/**
 * @name ute-ui
 * @version 0.7.13
 * @namespace ute-ui
 */


/*! PHP-JS | @link https://github.com/kvz/phpjs | @copyright Kevin van Zonneveld | @license MIT and GPL */
rewardCardController.$inject = ["$scope", "$rootScope", "$state", "resource", "wishlistService", "contentFetchService", "userLanguage", "localStorage", "settings", "apiRoutes"];
function count (mixed_var, mode) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +      input by: Waldo Malqui Silva
    // +   bugfixed by: Soren Hansen
    // +      input by: merabi
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +   bugfixed by: Olivier Louvignes (http://mg-crea.com/)
    // +   improved by: Obinwanne Hill on 22-03-2013 (https://about.me/obinwanne.hill)
    // +   dependencies: isArray() and isObject()
    // *     example 1: count([[0,0],[0,-4]], 'COUNT_RECURSIVE');
    // *     returns 1: 6
    // *     example 2: count({'one' : [1,2,3,4,5]}, 'COUNT_RECURSIVE');
    // *     returns 2: 6
    var key, nvld = false, cnt = 0;

    switch(true)
    {
        case (mixed_var === null || typeof mixed_var === 'undefined'):
            return 0;
            break;

        case (!isArray(mixed_var) && !isObject(mixed_var)):
            nvld = true;
            break;
    }

    switch(true)
    {
        case (mixed_var.hasOwnProperty('length')):
            return mixed_var.length;
            break;
    }

    //Return 1 if !isArray && !Object && does not have .length
    switch(true)
    {
        case (nvld):
            return 1;
            break;
    }

    switch(true)
    {
        case (mode === 'COUNT_RECURSIVE'):
            mode = 1;
            break;
    }

    switch(true)
    {
        case (mode != 1):
            mode = 0;
            break;
    }

    for (key in mixed_var) {
        switch(true)
        {
            case (mixed_var.hasOwnProperty(key)):
                cnt++;
                switch(true)
                {
                    case (mode == 1 && mixed_var[key] && (isArray(mixed_var[key]) || isObject(mixed_var[key]))):
                        cnt += this.count(mixed_var[key], 1);
                        break;
                }
                break;
        }
    }

    return cnt;
}

function in_array (needle, haystack, argStrict) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: vlado houba
    // +   input by: Billy
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // *     example 1: in_array('van', ['Kevin', 'van', 'Zonneveld']);
    // *     returns 1: true
    // *     example 2: in_array('vlado', {0: 'Kevin', vlado: 'van', 1: 'Zonneveld'});
    // *     returns 2: false
    // *     example 3: in_array(1, ['1', '2', '3']);
    // *     returns 3: true
    // *     example 3: in_array(1, ['1', '2', '3'], false);
    // *     returns 3: true
    // *     example 4: in_array(1, ['1', '2', '3'], true);
    // *     returns 4: false
    var key = '',
        strict = !! argStrict;

    if (strict) {
        for (key in haystack) {
            if (haystack[key] === needle) {
                return true;
            }
        }
    } else {
        for (key in haystack) {
            if (haystack[key] == needle) {
                return true;
            }
        }
    }

    return false;
}

function array_search (needle, haystack, argStrict) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +      input by: Brett Zamir (http://brett-zamir.me)
    // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // *     example 1: array_search('zonneveld', {firstname: 'kevin', middle: 'van', surname: 'zonneveld'});
    // *     returns 1: 'surname'
    // *     example 2: ini_set('phpjs.return_phpjs_arrays', 'on');
    // *     example 2: var ordered_arr = array({3:'value'}, {2:'value'}, {'a':'value'}, {'b':'value'});
    // *     example 2: var key = array_search(/val/g, ordered_arr); // or var key = ordered_arr.search(/val/g);
    // *     returns 2: '3'

    var strict = !!argStrict,
        key = '';

    if (haystack && typeof haystack === 'object' && haystack.change_key_case) { // Duck-type check for our own array()-created PHPJS_Array
        return haystack.search(needle, argStrict);
    }
    if (typeof needle === 'object' && needle.exec) { // Duck-type for RegExp
        if (!strict) { // Let's consider case sensitive searches as strict
            var flags = 'i' + (needle.global ? 'g' : '') +
                (needle.multiline ? 'm' : '') +
                (needle.sticky ? 'y' : ''); // sticky is FF only
            needle = new RegExp(needle.source, flags);
        }
        for (key in haystack) {
            if (needle.test(haystack[key])) {
                return key;
            }
        }
        return false;
    }

    for (key in haystack) {
        if ((strict && haystack[key] === needle) || (!strict && haystack[key] == needle)) {
            return key;
        }
    }

    return false;
}

function array_keys (input, search_value, argStrict) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +      input by: Brett Zamir (http://brett-zamir.me)
    // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: jd
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +   input by: P
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // *     example 1: array_keys( {firstname: 'Kevin', surname: 'van Zonneveld'} );
    // *     returns 1: {0: 'firstname', 1: 'surname'}

    var search = typeof search_value !== 'undefined',
        tmp_arr = [],
        strict = !!argStrict,
        include = true,
        key = '';

    if (input && typeof input === 'object' && input.change_key_case) { // Duck-type check for our own array()-created PHPJS_Array
        return input.keys(search_value, argStrict);
    }

    for (key in input) {
        if (input.hasOwnProperty(key)) {
            include = true;
            if (search) {
                if (strict && input[key] !== search_value) {
                    include = false;
                }
                else if (input[key] != search_value) {
                    include = false;
                }
            }

            if (include) {
                tmp_arr[tmp_arr.length] = key;
            }
        }
    }

    return tmp_arr;
}

function array_values (input) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +      improved by: Brett Zamir (http://brett-zamir.me)
    // *     example 1: array_values( {firstname: 'Kevin', surname: 'van Zonneveld'} );
    // *     returns 1: {0: 'Kevin', 1: 'van Zonneveld'}
    var tmp_arr = [],
        key = '';

    if (input && typeof input === 'object' && input.change_key_case) { // Duck-type check for our own array()-created PHPJS_Array
        return input.values();
    }

    for (key in input) {
        tmp_arr[tmp_arr.length] = input[key];
    }

    return tmp_arr;
}

function array_combine (keys, values) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // *     example 1: array_combine([0,1,2], ['kevin','van','zonneveld']);
    // *     returns 1: {0: 'kevin', 1: 'van', 2: 'zonneveld'}
    var new_array = {},
        keycount = keys && keys.length,
        i = 0;

    // input sanitation
    if (typeof keys !== 'object' || typeof values !== 'object' || // Only accept arrays or array-like objects
        typeof keycount !== 'number' || typeof values.length !== 'number' || !keycount) { // Require arrays to have a count
        return false;
    }

    // number of elements does not match
    if (keycount != values.length) {
        return false;
    }

    for (i = 0; i < keycount; i++) {
        new_array[keys[i]] = values[i];
    }

    return new_array;
}

function implode (glue, pieces) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   improved by: Waldo Malqui Silva
    // +   improved by: Itsacon (http://www.itsacon.net/)
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // +   improved by: Obinwanne Hill (http://about.me/obinwanne.hill)
    // *     example 1: implode(' ', ['Kevin', 'van', 'Zonneveld']);
    // *     returns 1: 'Kevin van Zonneveld'
    // *     example 2: implode(' ', {first:'Kevin', last: 'van Zonneveld'});
    // *     returns 2: 'Kevin van Zonneveld'
    var myArgs = Array.prototype.slice.call(arguments),
        use_count_for_loop_bool = myArgs[2],
        i = '',
        retVal = '',
        tGlue = '';
    if (arguments.length === 1) {
        pieces = glue;
        glue = '';
    }
    if (typeof(pieces) === 'object') {
        if(use_count_for_loop_bool)
        {
            for (i = 0; i < count(pieces); i++){
                retVal += tGlue + pieces[i];
                tGlue = glue;
            }
        }
        else
        {
            for (i in pieces) {
                retVal += tGlue + pieces[i];
                tGlue = glue;
            }
        }

        return retVal;
    }
    return pieces;
}

function explode (delimiter, string, limit) {

    if ( arguments.length < 2 || typeof delimiter == 'undefined' || typeof string == 'undefined' ) return null;
    if ( delimiter === '' || delimiter === false || delimiter === null) return false;
    if ( typeof delimiter == 'function' || typeof delimiter == 'object' || typeof string == 'function' || typeof string == 'object'){
        return { 0: '' };
    }
    if ( delimiter === true ) delimiter = '1';

    // Here we go...
    delimiter += '';
    string += '';

    var s = string.split( delimiter );


    if ( typeof limit === 'undefined' ) return s;

    // Support for limit
    if ( limit === 0 ) limit = 1;

    // Positive limit
    if ( limit > 0 ){
        if ( limit >= s.length ) return s;
        return s.slice( 0, limit - 1 ).concat( [ s.slice( limit - 1 ).join( delimiter ) ] );
    }

    // Negative limit
    if ( -limit >= s.length ) return [];

    s.splice( s.length + limit );
    return s;
}

function urlencode (str) {
    // http://kevin.vanzonneveld.net
    // + original by: Philip Peterson
    // + improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // + input by: AJ
    // + improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // + improved by: Brett Zamir (http://brett-zamir.me)
    // + bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // + input by: travc
    // + input by: Brett Zamir (http://brett-zamir.me)
    // + bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // + improved by: Lars Fischer
    // + input by: Ratheous
    // + reimplemented by: Brett Zamir (http://brett-zamir.me)
    // + bugfixed by: Joris
    // + reimplemented by: Brett Zamir (http://brett-zamir.me)
    // % note 1: This reflects PHP 5.3/6.0+ behavior
    // % note 2: Please be aware that this function expects to encode into UTF-8 encoded strings, as found on
    // % note 2: pages served as UTF-8
    // * example 1: urlencode('Kevin van Zonneveld!');
    // * returns 1: 'Kevin+van+Zonneveld%21'
    // * example 2: urlencode('http://kevin.vanzonneveld.net/');
    // * returns 2: 'http%3A%2F%2Fkevin.vanzonneveld.net%2F'
    // * example 3: urlencode('http://www.google.nl/search?q=php.js&ie=utf-8&oe=utf-8&aq=t&rls=com.ubuntu:en-US:unofficial&client=firefox-a');
    // * returns 3: 'http%3A%2F%2Fwww.google.nl%2Fsearch%3Fq%3Dphp.js%26ie%3Dutf-8%26oe%3Dutf-8%26aq%3Dt%26rls%3Dcom.ubuntu%3Aen-US%3Aunofficial%26client%3Dfirefox-a'
    str = (str + '').toString();

    // Tilde should be allowed unescaped in future versions of PHP (as reflected below), but if you want to reflect current
    // PHP behavior, you would need to add ".replace(/~/g, '%7E');" to the following.
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
        replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

function strrpos (haystack, needle, offset) {
    // http://kevin.vanzonneveld.net
    // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // +   bugfixed by: Onno Marsman
    // +   input by: saulius
    // +   bugfixed by: Brett Zamir (http://brett-zamir.me)
    // *     example 1: strrpos('Kevin van Zonneveld', 'e');
    // *     returns 1: 16
    // *     example 2: strrpos('somepage.com', '.', false);
    // *     returns 2: 8
    // *     example 3: strrpos('baa', 'a', 3);
    // *     returns 3: false
    // *     example 4: strrpos('baa', 'a', 2);
    // *     returns 4: 2
    var i = -1;
    if (offset) {
        i = (haystack + '').slice(offset).lastIndexOf(needle); // strrpos' offset indicates starting point of range till end,
        // while lastIndexOf's optional 2nd argument indicates ending point of range from the beginning
        if (i !== -1) {
            i += offset;
        }
    } else {
        i = (haystack + '').lastIndexOf(needle);
    }
    return i >= 0 ? i : false;
}

function uasort (inputArr, sorter) {
    // http://kevin.vanzonneveld.net
    // +   original by: Brett Zamir (http://brett-zamir.me)
    // +   improved by: Brett Zamir (http://brett-zamir.me)
    // +   improved by: Theriault
    // %        note 1: This function deviates from PHP in returning a copy of the array instead
    // %        note 1: of acting by reference and returning true; this was necessary because
    // %        note 1: IE does not allow deleting and re-adding of properties without caching
    // %        note 1: of property position; you can set the ini of "phpjs.strictForIn" to true to
    // %        note 1: get the PHP behavior, but use this only if you are in an environment
    // %        note 1: such as Firefox extensions where for-in iteration order is fixed and true
    // %        note 1: property deletion is supported. Note that we intend to implement the PHP
    // %        note 1: behavior by default if IE ever does allow it; only gives shallow copy since
    // %        note 1: is by reference in PHP anyways
    // *     example 1: fruits = {d: 'lemon', a: 'orange', b: 'banana', c: 'apple'};
    // *     example 1: fruits = uasort(fruits, function (a, b) { if (a > b) {return 1;}if (a < b) {return -1;} return 0;});
    // *     results 1: fruits == {c: 'apple', b: 'banana', d: 'lemon', a: 'orange'}
    var valArr = [],
        tempKeyVal, tempValue, ret, k = '',
        i = 0,
        strictForIn = false,
        populateArr = {};

    if (typeof sorter === 'string') {
        sorter = this[sorter];
    } else if (Object.prototype.toString.call(sorter) === '[object Array]') {
        sorter = this[sorter[0]][sorter[1]];
    }

    // BEGIN REDUNDANT
    this.php_js = this.php_js || {};
    this.php_js.ini = this.php_js.ini || {};
    // END REDUNDANT
    strictForIn = this.php_js.ini['phpjs.strictForIn'] && this.php_js.ini['phpjs.strictForIn'].local_value && this.php_js.ini['phpjs.strictForIn'].local_value !== 'off';
    populateArr = strictForIn ? inputArr : populateArr;


    for (k in inputArr) { // Get key and value arrays
        if (inputArr.hasOwnProperty(k)) {
            valArr.push([k, inputArr[k]]);
            if (strictForIn) {
                delete inputArr[k];
            }
        }
    }
    valArr.sort(function (a, b) {
        return sorter(a[1], b[1]);
    });

    for (i = 0; i < valArr.length; i++) { // Repopulate the old array
        populateArr[valArr[i][0]] = valArr[i][1];
    }

    return strictForIn || populateArr;
}

function microtime (get_as_float) {
    // http://kevin.vanzonneveld.net
    // +   original by: Paulo Freitas
    // *     example 1: timeStamp = microtime(true);
    // *     results 1: timeStamp > 1000000000 && timeStamp < 2000000000
    var now = new Date().getTime() / 1000;
    var s = parseInt(now, 10);

    return (get_as_float) ? now : (Math.round((now - s) * 1000) / 1000) + ' ' + s;
}

/*! md5.js - MD5 Message-Digest - v2.0.0 | @copyright 1999,2002 Masanao Izumo <iz@onicos.co.jp>  */
/* md5.js - MD5 Message-Digest
 * Copyright (C) 1999,2002 Masanao Izumo <iz@onicos.co.jp>
 * Version: 2.0.0
 * LastModified: May 13 2002
 *
 * This program is free software.  You can redistribute it and/or modify
 * it without any warranty.  This library calculates the MD5 based on RFC1321.
 * See RFC1321 for more information and algorithm.
 */

/* Interface:
 * md5_hexstr = md5(data);
 */

/* ChangeLog
 * 2013/07/20: Updated by Obinwanne Ugwuh
 * 2002/05/13: Version 2.0.0 released
 * NOTICE: API is changed.
 * 2002/04/15: Bug fix about MD5 length.
 */
(function() {
    var MD5_T = new Array(0x00000000, 0xd76aa478, 0xe8c7b756, 0x242070db, 0xc1bdceee, 0xf57c0faf, 0x4787c62a, 0xa8304613, 0xfd469501, 0x698098d8, 0x8b44f7af, 0xffff5bb1, 0x895cd7be, 0x6b901122, 0xfd987193, 0xa679438e, 0x49b40821, 0xf61e2562, 0xc040b340, 0x265e5a51, 0xe9b6c7aa, 0xd62f105d, 0x02441453, 0xd8a1e681, 0xe7d3fbc8, 0x21e1cde6, 0xc33707d6, 0xf4d50d87, 0x455a14ed, 0xa9e3e905, 0xfcefa3f8, 0x676f02d9, 0x8d2a4c8a, 0xfffa3942, 0x8771f681, 0x6d9d6122, 0xfde5380c, 0xa4beea44, 0x4bdecfa9, 0xf6bb4b60, 0xbebfbc70, 0x289b7ec6, 0xeaa127fa, 0xd4ef3085, 0x04881d05, 0xd9d4d039, 0xe6db99e5, 0x1fa27cf8, 0xc4ac5665, 0xf4292244, 0x432aff97, 0xab9423a7, 0xfc93a039, 0x655b59c3, 0x8f0ccc92, 0xffeff47d, 0x85845dd1, 0x6fa87e4f, 0xfe2ce6e0, 0xa3014314, 0x4e0811a1, 0xf7537e82, 0xbd3af235, 0x2ad7d2bb, 0xeb86d391);

    var MD5_round1 = new Array(new Array(0, 7, 1), new Array(1, 12, 2), new Array(2, 17, 3), new Array(3, 22, 4), new Array(4, 7, 5), new Array(5, 12, 6), new Array(6, 17, 7), new Array(7, 22, 8), new Array(8, 7, 9), new Array(9, 12, 10), new Array(10, 17, 11), new Array(11, 22, 12), new Array(12, 7, 13), new Array(13, 12, 14), new Array(14, 17, 15), new Array(15, 22, 16));

    var MD5_round2 = new Array(new Array(1, 5, 17), new Array(6, 9, 18), new Array(11, 14, 19), new Array(0, 20, 20), new Array(5, 5, 21), new Array(10, 9, 22), new Array(15, 14, 23), new Array(4, 20, 24), new Array(9, 5, 25), new Array(14, 9, 26), new Array(3, 14, 27), new Array(8, 20, 28), new Array(13, 5, 29), new Array(2, 9, 30), new Array(7, 14, 31), new Array(12, 20, 32));

    var MD5_round3 = new Array(new Array(5, 4, 33), new Array(8, 11, 34), new Array(11, 16, 35), new Array(14, 23, 36), new Array(1, 4, 37), new Array(4, 11, 38), new Array(7, 16, 39), new Array(10, 23, 40), new Array(13, 4, 41), new Array(0, 11, 42), new Array(3, 16, 43), new Array(6, 23, 44), new Array(9, 4, 45), new Array(12, 11, 46), new Array(15, 16, 47), new Array(2, 23, 48));

    var MD5_round4 = new Array(new Array(0, 6, 49), new Array(7, 10, 50), new Array(14, 15, 51), new Array(5, 21, 52), new Array(12, 6, 53), new Array(3, 10, 54), new Array(10, 15, 55), new Array(1, 21, 56), new Array(8, 6, 57), new Array(15, 10, 58), new Array(6, 15, 59), new Array(13, 21, 60), new Array(4, 6, 61), new Array(11, 10, 62), new Array(2, 15, 63), new Array(9, 21, 64));

    function MD5_F(x, y, z) {
        return (x & y) | (~x & z);
    }

    function MD5_G(x, y, z) {
        return (x & z) | (y & ~z);
    }

    function MD5_H(x, y, z) {
        return x ^ y ^ z;
    }

    function MD5_I(x, y, z) {
        return y ^ (x | ~z);
    }

    var MD5_round = new Array(new Array(MD5_F, MD5_round1), new Array(MD5_G, MD5_round2), new Array(MD5_H, MD5_round3), new Array(MD5_I, MD5_round4));

    function MD5_pack(n32) {
        return String.fromCharCode(n32 & 0xff) + String.fromCharCode((n32 >>> 8) & 0xff) + String.fromCharCode((n32 >>> 16) & 0xff) + String.fromCharCode((n32 >>> 24) & 0xff);
    }

    function MD5_unpack(s4) {
        return s4.charCodeAt(0) | (s4.charCodeAt(1) << 8) | (s4.charCodeAt(2) << 16) | (s4.charCodeAt(3) << 24);
    }

    function MD5_number(n) {
        while (n < 0)
            n += 4294967296;
        while (n > 4294967295)
            n -= 4294967296;
        return n;
    }

    function MD5_apply_round(x, s, f, abcd, r) {
        var a, b, c, d;
        var kk, ss, ii;
        var t, u;

        a = abcd[0];
        b = abcd[1];
        c = abcd[2];
        d = abcd[3];
        kk = r[0];
        ss = r[1];
        ii = r[2];

        u = f(s[b], s[c], s[d]);
        t = s[a] + u + x[kk] + MD5_T[ii];
        t = MD5_number(t);
        t = ((t << ss) | (t >>> (32 - ss)));
        t += s[b];
        s[a] = MD5_number(t);
    }

    function utf8_encode(s)
    {
        for(var c, i = -1, l = (s = s.split("")).length, o = String.fromCharCode; ++i < l;
            s[i] = (c = s[i].charCodeAt(0)) >= 127 ? o(0xc0 | (c >>> 6)) + o(0x80 | (c & 0x3f)) : s[i]
            );
        return s.join("");
    }

    function MD5_hash(data) {
        var abcd, x, state, s;
        var len, index, padLen, f, r;
        var i, j, k;
        var tmp;

        if (/[\x80-\xFF]/.test(data)) {
            data = utf8_encode(data);

        }

        state = new Array(0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476);
        len = data.length;
        index = len & 0x3f;
        padLen = (index < 56) ? (56 - index) : (120 - index);
        if (padLen > 0) {
            data += "\x80";
            for (i = 0; i < padLen - 1; i++)
                data += "\x00";
        }
        data += MD5_pack(len * 8);
        data += MD5_pack(0);
        len += padLen + 8;
        abcd = new Array(0, 1, 2, 3);
        x = new Array(16);
        s = new Array(4);

        for (k = 0; k < len; k += 64) {
            for (i = 0, j = k; i < 16; i++, j += 4) {
                x[i] = data.charCodeAt(j) | (data.charCodeAt(j + 1) << 8) | (data.charCodeAt(j + 2) << 16) | (data.charCodeAt(j + 3) << 24);
            }
            for (i = 0; i < 4; i++)
                s[i] = state[i];
            for (i = 0; i < 4; i++) {
                f = MD5_round[i][0];
                r = MD5_round[i][1];
                for (j = 0; j < 16; j++) {
                    MD5_apply_round(x, s, f, abcd, r[j]);
                    tmp = abcd[0];
                    abcd[0] = abcd[3];
                    abcd[3] = abcd[2];
                    abcd[2] = abcd[1];
                    abcd[1] = tmp;
                }
            }

            for (i = 0; i < 4; i++) {
                state[i] += s[i];
                state[i] = MD5_number(state[i]);
            }
        }

        return MD5_pack(state[0]) + MD5_pack(state[1]) + MD5_pack(state[2]) + MD5_pack(state[3]);
    }

    function MD5_hexhash(data) {
        var i, out, c;
        var bit128;

        bit128 = MD5_hash(data);
        out = "";
        for (i = 0; i < 16; i++) {
            c = bit128.charCodeAt(i);
            out += "0123456789abcdef".charAt((c >> 4) & 0xf);
            out += "0123456789abcdef".charAt(c & 0xf);
        }
        return out;
    }

    md5 = function (s) {
        return MD5_hexhash(s);
    }
})();

/*! json2.js | @link https://github.com/douglascrockford/JSON-js | @copyright Douglas Crockford <douglas@crockford.com> */

// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

if (typeof JSON !== 'object') {
    JSON = {};
}

(function () {
    'use strict';

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10 ? '0' + n : n;
    }

    if (typeof Date.prototype.toJSON !== 'function') {

        Date.prototype.toJSON = function () {

            return isFinite(this.valueOf())
                ? this.getUTCFullYear()     + '-' +
                f(this.getUTCMonth() + 1) + '-' +
                f(this.getUTCDate())      + 'T' +
                f(this.getUTCHours())     + ':' +
                f(this.getUTCMinutes())   + ':' +
                f(this.getUTCSeconds())   + 'Z'
                : null;
        };

        String.prototype.toJSON      =
            Number.prototype.toJSON  =
                Boolean.prototype.toJSON = function () {
                    return this.valueOf();
                };
    }

    var cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
        gap,
        indent,
        meta = {    // table of character substitutions
            '\b': '\\b',
            '\t': '\\t',
            '\n': '\\n',
            '\f': '\\f',
            '\r': '\\r',
            '"' : '\\"',
            '\\': '\\\\'
        },
        rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        escapable.lastIndex = 0;
        return escapable.test(string) ? '"' + string.replace(escapable, function (a) {
            var c = meta[a];
            return typeof c === 'string'
                ? c
                : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + string + '"';
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i,          // The loop counter.
            k,          // The member key.
            v,          // The member value.
            length,
            mind = gap,
            partial,
            value = holder[key];

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === 'object' &&
            typeof value.toJSON === 'function') {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === 'function') {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
            case 'string':
                return quote(value);

            case 'number':

// JSON numbers must be finite. Encode non-finite numbers as null.

                return isFinite(value) ? String(value) : 'null';

            case 'boolean':
            case 'null':

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce 'null'. The case is included here in
// the remote chance that this gets fixed someday.

                return String(value);

// If the type is 'object', we might be dealing with an object or an array or
// null.

            case 'object':

// Due to a specification blunder in ECMAScript, typeof null is 'object',
// so watch out for that case.

                if (!value) {
                    return 'null';
                }

// Make an array to hold the partial results of stringifying this object value.

                gap += indent;
                partial = [];

// Is the value an array?

                if (Object.prototype.toString.apply(value) === '[object Array]') {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                    length = value.length;
                    for (i = 0; i < length; i += 1) {
                        partial[i] = str(i, value) || 'null';
                    }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                    v = partial.length === 0
                        ? '[]'
                        : gap
                        ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']'
                        : '[' + partial.join(',') + ']';
                    gap = mind;
                    return v;
                }

// If the replacer is an array, use it to select the members to be stringified.

                if (rep && typeof rep === 'object') {
                    length = rep.length;
                    for (i = 0; i < length; i += 1) {
                        if (typeof rep[i] === 'string') {
                            k = rep[i];
                            v = str(k, value);
                            if (v) {
                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
                            }
                        }
                    }
                } else {

// Otherwise, iterate through all of the keys in the object.

                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = str(k, value);
                            if (v) {
                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
                            }
                        }
                    }
                }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

                v = partial.length === 0
                    ? '{}'
                    : gap
                    ? '{\n' + gap + partial.join(',\n' + gap) + '\n' + mind + '}'
                    : '{' + partial.join(',') + '}';
                gap = mind;
                return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== 'function') {
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = '';
            indent = '';

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === 'number') {
                for (i = 0; i < space; i += 1) {
                    indent += ' ';
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === 'string') {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== 'function' &&
                (typeof replacer !== 'object' ||
                    typeof replacer.length !== 'number')) {
                throw new Error('JSON.stringify');
            }

// Make a fake root object containing our value under the key of ''.
// Return the result of stringifying the value.

            return str('', {'': value});
        };
    }


// If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== 'function') {
        JSON.parse = function (text, reviver) {

// The parse method takes a text and an optional reviver function, and returns
// a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

// The walk method is used to recursively walk the resulting structure so
// that modifications can be made.

                var k, v, value = holder[key];
                if (value && typeof value === 'object') {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }


// Parsing happens in four stages. In the first stage, we replace certain
// Unicode characters with escape sequences. JavaScript handles many characters
// incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            cx.lastIndex = 0;
            if (cx.test(text)) {
                text = text.replace(cx, function (a) {
                    return '\\u' +
                        ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

// In the second stage, we run the text against regular expressions that look
// for non-JSON patterns. We are especially concerned with '()' and 'new'
// because they can cause invocation, and '=' because it can cause mutation.
// But just to be safe, we want to reject all unexpected forms.

// We split the second stage into 4 regexp operations in order to work around
// crippling inefficiencies in IE's and Safari's regexp engines. First we
// replace the JSON backslash pairs with '@' (a non-JSON character). Second, we
// replace all simple value tokens with ']' characters. Third, we delete all
// open brackets that follow a colon or comma or that begin the text. Finally,
// we look to see that the remaining characters are only whitespace or ']' or
// ',' or ':' or '{' or '}'. If that is so, then the text is safe for eval.

            if (/^[\],:{}\s]*$/
                .test(text.replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@')
                .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
                .replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {

// In the third stage we use the eval function to compile the text into a
// JavaScript structure. The '{' operator is subject to a syntactic ambiguity
// in JavaScript: it can begin a block or an object literal. We wrap the text
// in parens to eliminate the ambiguity.

                j = eval('(' + text + ')');

// In the optional fourth stage, we recursively walk the new structure, passing
// each name/value pair to a reviver function for possible transformation.

                return typeof reviver === 'function'
                    ? walk({'': j}, '')
                    : j;
            }

// If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError('JSON.parse');
        };
    }
}());

/*! AmplifyJS-Store - v1.1.0 | @link http://amplifyjs.com/api/store/ | @copyright 2012 AppendTo <http://appendto.com/contact> | @license MIT and GPL V2 */
(function( amplify, undefined ) {

    var store = amplify.store = function( key, value, options ) {
        var type = store.type;
        if ( options && options.type && options.type in store.types ) {
            type = options.type;
        }
        return store.types[ type ]( key, value, options || {} );
    };

    store.types = {};
    store.type = null;
    store.addType = function( type, storage ) {
        if ( !store.type ) {
            store.type = type;
        }

        store.types[ type ] = storage;
        store[ type ] = function( key, value, options ) {
            options = options || {};
            options.type = type;
            return store( key, value, options );
        };
    };
    store.error = function() {
        return "amplify.store quota exceeded";
    };

    var rprefix = /^__amplify__/;
    function createFromStorageInterface( storageType, storage ) {
        store.addType( storageType, function( key, value, options ) {
            var storedValue, parsed, i, remove,
                ret = value,
                now = (new Date()).getTime();

            if ( !key ) {
                ret = {};
                remove = [];
                i = 0;
                try {
                    // accessing the length property works around a localStorage bug
                    // in Firefox 4.0 where the keys don't update cross-page
                    // we assign to key just to avoid Closure Compiler from removing
                    // the access as "useless code"
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=662511
                    key = storage.length;

                    while ( key = storage.key( i++ ) ) {
                        if ( rprefix.test( key ) ) {
                            parsed = JSON.parse( storage.getItem( key ) );
                            if ( parsed.expires && parsed.expires <= now ) {
                                remove.push( key );
                            } else {
                                ret[ key.replace( rprefix, "" ) ] = parsed.data;
                            }
                        }
                    }
                    while ( key = remove.pop() ) {
                        storage.removeItem( key );
                    }
                } catch ( error ) {}
                return ret;
            }

            // protect against name collisions with direct storage
            key = "__amplify__" + key;

            if ( value === undefined ) {
                storedValue = storage.getItem( key );
                parsed = storedValue ? JSON.parse( storedValue ) : { expires: -1 };
                if ( parsed.expires && parsed.expires <= now ) {
                    storage.removeItem( key );
                } else {
                    return parsed.data;
                }
            } else {
                if ( value === null ) {
                    storage.removeItem( key );
                } else {
                    parsed = JSON.stringify({
                        data: value,
                        expires: options.expires ? now + options.expires : null
                    });
                    try {
                        storage.setItem( key, parsed );
                        // quota exceeded
                    } catch( error ) {
                        // expire old data and try again
                        store[ storageType ]();
                        try {
                            storage.setItem( key, parsed );
                        } catch( error ) {
                            throw store.error();
                        }
                    }
                }
            }

            return ret;
        });
    }

// localStorage + sessionStorage
// IE 8+, Firefox 3.5+, Safari 4+, Chrome 4+, Opera 10.5+, iPhone 2+, Android 2+
    for ( var webStorageType in { localStorage: 1, sessionStorage: 1 } ) {
        // try/catch for file protocol in Firefox and Private Browsing in Safari 5
        try {
            // Safari 5 in Private Browsing mode exposes localStorage
            // but doesn't allow storing data, so we attempt to store and remove an item.
            // This will unfortunately give us a false negative if we're at the limit.
            window[ webStorageType ].setItem( "__amplify__", "x" );
            window[ webStorageType ].removeItem( "__amplify__" );
            createFromStorageInterface( webStorageType, window[ webStorageType ] );
        } catch( e ) {}
    }

// globalStorage
// non-standard: Firefox 2+
// https://developer.mozilla.org/en/dom/storage#globalStorage
    if ( !store.types.localStorage && window.globalStorage ) {
        // try/catch for file protocol in Firefox
        try {
            createFromStorageInterface( "globalStorage",
                window.globalStorage[ window.location.hostname ] );
            // Firefox 2.0 and 3.0 have sessionStorage and globalStorage
            // make sure we default to globalStorage
            // but don't default to globalStorage in 3.5+ which also has localStorage
            if ( store.type === "sessionStorage" ) {
                store.type = "globalStorage";
            }
        } catch( e ) {}
    }

// userData
// non-standard: IE 5+
// http://msdn.microsoft.com/en-us/library/ms531424(v=vs.85).aspx
    (function() {
        // IE 9 has quirks in userData that are a huge pain
        // rather than finding a way to detect these quirks
        // we just don't register userData if we have localStorage
        if ( store.types.localStorage ) {
            return;
        }

        // append to html instead of body so we can do this from the head
        var div = document.createElement( "div" ),
            attrKey = "amplify";
        div.style.display = "none";
        document.getElementsByTagName( "head" )[ 0 ].appendChild( div );

        // we can't feature detect userData support
        // so just try and see if it fails
        // surprisingly, even just adding the behavior isn't enough for a failure
        // so we need to load the data as well
        try {
            div.addBehavior( "#default#userdata" );
            div.load( attrKey );
        } catch( e ) {
            div.parentNode.removeChild( div );
            return;
        }

        store.addType( "userData", function( key, value, options ) {
            div.load( attrKey );
            var attr, parsed, prevValue, i, remove,
                ret = value,
                now = (new Date()).getTime();

            if ( !key ) {
                ret = {};
                remove = [];
                i = 0;
                while ( attr = div.XMLDocument.documentElement.attributes[ i++ ] ) {
                    parsed = JSON.parse( attr.value );
                    if ( parsed.expires && parsed.expires <= now ) {
                        remove.push( attr.name );
                    } else {
                        ret[ attr.name ] = parsed.data;
                    }
                }
                while ( key = remove.pop() ) {
                    div.removeAttribute( key );
                }
                div.save( attrKey );
                return ret;
            }

            // convert invalid characters to dashes
            // http://www.w3.org/TR/REC-xml/#NT-Name
            // simplified to assume the starting character is valid
            // also removed colon as it is invalid in HTML attribute names
            key = key.replace( /[^\-._0-9A-Za-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c-\u200d\u203f\u2040\u2070-\u218f]/g, "-" );
            // adjust invalid starting character to deal with our simplified sanitization
            key = key.replace( /^-/, "_-" );

            if ( value === undefined ) {
                attr = div.getAttribute( key );
                parsed = attr ? JSON.parse( attr ) : { expires: -1 };
                if ( parsed.expires && parsed.expires <= now ) {
                    div.removeAttribute( key );
                } else {
                    return parsed.data;
                }
            } else {
                if ( value === null ) {
                    div.removeAttribute( key );
                } else {
                    // we need to get the previous value in case we need to rollback
                    prevValue = div.getAttribute( key );
                    parsed = JSON.stringify({
                        data: value,
                        expires: (options.expires ? (now + options.expires) : null)
                    });
                    div.setAttribute( key, parsed );
                }
            }

            try {
                div.save( attrKey );
                // quota exceeded
            } catch ( error ) {
                // roll the value back to the previous value
                if ( prevValue === null ) {
                    div.removeAttribute( key );
                } else {
                    div.setAttribute( key, prevValue );
                }

                // expire old data and try again
                store.userData();
                try {
                    div.setAttribute( key, parsed );
                    div.save( attrKey );
                } catch ( error ) {
                    // roll the value back to the previous value
                    if ( prevValue === null ) {
                        div.removeAttribute( key );
                    } else {
                        div.setAttribute( key, prevValue );
                    }
                    throw store.error();
                }
            }
            return ret;
        });
    }() );

// in-memory storage
// fallback for all browsers to enable the API even if we can't persist data
    (function() {
        var memory = {},
            timeout = {};

        function copy( obj ) {
            return obj === undefined ? undefined : JSON.parse( JSON.stringify( obj ) );
        }

        store.addType( "memory", function( key, value, options ) {
            if ( !key ) {
                return copy( memory );
            }

            if ( value === undefined ) {
                return copy( memory[ key ] );
            }

            if ( timeout[ key ] ) {
                clearTimeout( timeout[ key ] );
                delete timeout[ key ];
            }

            if ( value === null ) {
                delete memory[ key ];
                return null;
            }

            memory[ key ] = value;
            if ( options.expires ) {
                timeout[ key ] = setTimeout(function() {
                    delete memory[ key ];
                    delete timeout[ key ];
                }, options.expires );
            }

            return value;
        });
    }() );

}( this.amplify = this.amplify || {} ) );

/*! ios-orientationchange-fix.js | Script by @scottjehl rebound by @wilto, modified by Peter Wooster | @link https://github.com/scottjehl/iOS-Orientationchange-Fix | @copyright Scott Jehl <@scottjehl> | @license MIT / GPLV2 */
(function(w){

    // This fix addresses an Mobile Safari iOS bug, so return early if the UA claims it's something else.
    var ua = navigator.userAgent.toLowerCase();
    if( !( /iphone|ipad|ipod/.test( navigator.platform.toLowerCase() )
        && /os [1-5]_[0-9_]* like mac os x/i.test(ua)
        && ua.indexOf( "applewebkit" ) > -1
        && ua.indexOf( "crios") == -1  // chrome for iOS doesn't have the bug
        )){
        return;
    }

    var doc = w.document;

    if( !doc.querySelector ){ return; }
    var meta = doc.querySelector( "meta[name=viewport]" );
    if( !meta ){ return; }
    var initialContent = meta && meta.getAttribute( "content" );
    var disabledZoom = initialContent + ",maximum-scale=1";
    var enabledZoom = initialContent + ",maximum-scale=10";
    var enabled = true;
    var	x, y, z, aig;
    function restoreZoom(){
        meta.setAttribute( "content", enabledZoom );
        enabled = true;
    }

    function disableZoom(){
        meta.setAttribute( "content", disabledZoom );
        enabled = false;
    }

    function checkTilt( e ){
        var ori = w.orientation;
        // if it's landscape we're out of here
        if(90 == Math.abs(w.orientation)) {
            if(enabled)restoreZoom();
            return;
        }

        aig = e.accelerationIncludingGravity;
        x = Math.abs( aig.x );
        y = Math.abs( aig.y );

        // If in the danger zone where x is much greater than y turn off zoom
        if(y == 0 || (x/y) > 1.2){
            if(enabled)disableZoom();
        }else if( !enabled )restoreZoom();
    }

    w.addEventListener( "orientationchange", restoreZoom, false );
    w.addEventListener( "devicemotion", checkTilt, false );

})( this );


/*! jQuery resize event - v1.1 | @link http://benalman.com/projects/jquery-resize-plugin/ | Copyright (c) 2010 "Cowboy" Ben Alman | @license MIT/GPL */
// Script: jQuery resize event
//
// *Version: 1.1, Last updated: 3/14/2010*
//
// Project Home - http://benalman.com/projects/jquery-resize-plugin/
// GitHub       - http://github.com/cowboy/jquery-resize/
// Source       - http://github.com/cowboy/jquery-resize/raw/master/jquery.ba-resize.js
// (Minified)   - http://github.com/cowboy/jquery-resize/raw/master/jquery.ba-resize.min.js (1.0kb)
//
// About: License
//
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
//
// About: Examples
//
// This working example, complete with fully commented code, illustrates a few
// ways in which this plugin can be used.
//
// resize event - http://benalman.com/code/projects/jquery-resize/examples/resize/
//
// About: Support and Testing
//
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
//
// jQuery Versions - 1.3.2, 1.4.1, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-resize/unit/
//
// About: Release History
//
// 1.1 - (3/14/2010) Fixed a minor bug that was causing the event to trigger
//       immediately after bind in some circumstances. Also changed $.fn.data
//       to $.data to improve performance.
// 1.0 - (2/10/2010) Initial release

(function($,window,undefined){
    '$:nomunge'; // Used by YUI compressor.

    // A jQuery object containing all non-window elements to which the resize
    // event is bound.
    var elems = $([]),

    // Extend $.resize if it already exists, otherwise create it.
        jq_resize = $.resizecontainer = $.extend( $.resize, {} ),

        timeout_id,

    // Reused strings.
        str_setTimeout = 'setTimeout',
        str_resize = 'resizecontainer',
        str_data = str_resize + '-special-event',
        str_delay = 'delay',
        str_throttle = 'throttleWindow';

    // Property: jQuery.resize.delay
    //
    // The numeric interval (in milliseconds) at which the resize event polling
    // loop executes. Defaults to 250.

    jq_resize[ str_delay ] = 250;

    // Property: jQuery.resize.throttleWindow
    //
    // Throttle the native window object resize event to fire no more than once
    // every <jQuery.resize.delay> milliseconds. Defaults to true.
    //
    // Because the window object has its own resize event, it doesn't need to be
    // provided by this plugin, and its execution can be left entirely up to the
    // browser. However, since certain browsers fire the resize event continuously
    // while others do not, enabling this will throttle the window resize event,
    // making event behavior consistent across all elements in all browsers.
    //
    // While setting this property to false will disable window object resize
    // event throttling, please note that this property must be changed before any
    // window object resize event callbacks are bound.

    jq_resize[ str_throttle ] = true;

    // Event: resize event
    //
    // Fired when an element's width or height changes. Because browsers only
    // provide this event for the window element, for other elements a polling
    // loop is initialized, running every <jQuery.resize.delay> milliseconds
    // to see if elements' dimensions have changed. You may bind with either
    // .resize( fn ) or .bind( "resize", fn ), and unbind with .unbind( "resize" ).
    //
    // Usage:
    //
    // > jQuery('selector').bind( 'resize', function(e) {
    // >   // element's width or height has changed!
    // >   ...
    // > });
    //
    // Additional Notes:
    //
    // * The polling loop is not created until at least one callback is actually
    //   bound to the 'resize' event, and this single polling loop is shared
    //   across all elements.
    //
    // Double firing issue in jQuery 1.3.2:
    //
    // While this plugin works in jQuery 1.3.2, if an element's event callbacks
    // are manually triggered via .trigger( 'resize' ) or .resize() those
    // callbacks may double-fire, due to limitations in the jQuery 1.3.2 special
    // events system. This is not an issue when using jQuery 1.4+.
    //
    // > // While this works in jQuery 1.4+
    // > $(elem).css({ width: new_w, height: new_h }).resize();
    // >
    // > // In jQuery 1.3.2, you need to do this:
    // > var elem = $(elem);
    // > elem.css({ width: new_w, height: new_h });
    // > elem.data( 'resize-special-event', { width: elem.width(), height: elem.height() } );
    // > elem.resize();

    $.event.special[ str_resize ] = {

        // Called only when the first 'resize' event callback is bound per element.
        setup: function() {
            // Since window has its own native 'resize' event, return false so that
            // jQuery will bind the event using DOM methods. Since only 'window'
            // objects have a .setTimeout method, this should be a sufficient test.
            // Unless, of course, we're throttling the 'resize' event for window.
            if ( !jq_resize[ str_throttle ] && this[ str_setTimeout ] ) { return false; }

            var elem = $(this);

            // Add this element to the list of internal elements to monitor.
            elems = elems.add( elem );

            // Initialize data store on the element.
            $.data( this, str_data, { w: elem.width(), h: elem.height() } );

            // If this is the first element added, start the polling loop.
            if ( elems.length === 1 ) {
                loopy();
            }
        },

        // Called only when the last 'resize' event callback is unbound per element.
        teardown: function() {
            // Since window has its own native 'resize' event, return false so that
            // jQuery will unbind the event using DOM methods. Since only 'window'
            // objects have a .setTimeout method, this should be a sufficient test.
            // Unless, of course, we're throttling the 'resize' event for window.
            if ( !jq_resize[ str_throttle ] && this[ str_setTimeout ] ) { return false; }

            var elem = $(this);

            // Remove this element from the list of internal elements to monitor.
            elems = elems.not( elem );

            // Remove any data stored on the element.
            elem.removeData( str_data );

            // If this is the last element removed, stop the polling loop.
            if ( !elems.length ) {
                clearTimeout( timeout_id );
            }
        },

        // Called every time a 'resize' event callback is bound per element (new in
        // jQuery 1.4).
        add: function( handleObj ) {
            // Since window has its own native 'resize' event, return false so that
            // jQuery doesn't modify the event object. Unless, of course, we're
            // throttling the 'resize' event for window.
            if ( !jq_resize[ str_throttle ] && this[ str_setTimeout ] ) { return false; }

            var old_handler;

            // The new_handler function is executed every time the event is triggered.
            // This is used to update the internal element data store with the width
            // and height when the event is triggered manually, to avoid double-firing
            // of the event callback. See the "Double firing issue in jQuery 1.3.2"
            // comments above for more information.

            function new_handler( e, w, h ) {
                var elem = $(this),
                    data = $.data( this, str_data );

                // If called from the polling loop, w and h will be passed in as
                // arguments. If called manually, via .trigger( 'resize' ) or .resize(),
                // those values will need to be computed.
                data.w = w !== undefined ? w : elem.width();
                data.h = h !== undefined ? h : elem.height();

                old_handler.apply( this, arguments );
            }

            // This may seem a little complicated, but it normalizes the special event
            // .add method between jQuery 1.4/1.4.1 and 1.4.2+
            if ( $.isFunction( handleObj ) ) {
                // 1.4, 1.4.1
                old_handler = handleObj;
                return new_handler;
            } else {
                // 1.4.2+
                old_handler = handleObj.handler;
                handleObj.handler = new_handler;
            }
        }

    };

    function loopy() {

        // Start the polling loop, asynchronously.
        timeout_id = window[ str_setTimeout ](function(){

            // Iterate over all elements to which the 'resize' event is bound.
            elems.each(function(){
                var elem = $(this),
                    width = elem.width(),
                    height = elem.height(),
                    data = $.data( this, str_data );

                // If element size has changed since the last time, update the element
                // data store and trigger the 'resize' event.
                if ( width !== data.w || height !== data.h ) {
                    elem.trigger( str_resize, [ data.w = width, data.h = height ] );
                }

            });

            // Loop.
            loopy();

        }, jq_resize[ str_delay ] );

    }

})(jQuery, window);

/**
 * Count the number of substring occurrences
 * @param haystack {String} the string to search in
 * @param needle {String} the substring to search for
 * @return {Number}
 */
function substr_count(haystack, needle)
{
    var needle_esc = needle.replace(/(?=[\\^$*+?.\(\)|{\}[\]])/g, "\\");
    var pattern = new RegExp(""+needle_esc+"", "g");
    var count = haystack.match(pattern);
    return count ? count.length : 0;
}

/**
 * Checks if a variable is a String
 * @param str {*} The variable to test
 * @return {Boolean}
 */
function isString(str)
{
    return typeof str == "string";
}

/**
 * Checks if a variable is a Number
 * @param num {*} The variable to test
 * @return {Boolean}
 */
function isNumber(num)
{
    return (!isNaN(parseFloat(num)) && isFinite(num));
}

/**
 * Checks if a variable is a Boolean
 * @param bool {*} The variable to test
 * @return {Boolean}
 */
function isBool(bool)
{
    return (bool === true || bool === false);
}

/**
 * Checks if the variable is an array
 * @param arr {*} The variable to test
 * @return {Boolean}
 */
function isArray(arr) {
    return Object.prototype.toString.call(arr) === "[object Array]";
}

/**
 * Checks if a variable is an Object
 * @param obj {*} The variable to test
 * @return {Boolean}
 */
function isObject(obj)
{
    switch(true)
    {
        case (isArray(obj)):
            return false;
            break;
    }

    var is_empty_obj_bool;
    for ( var p in obj )
    {
        if (obj.hasOwnProperty(p))
        {
            is_empty_obj_bool = false;
            break;
        }
    }
    is_empty_obj_bool = (isBool(is_empty_obj_bool)) ? is_empty_obj_bool: true;

    switch(true)
    {
        case (typeof obj === "object" && is_empty_obj_bool === false):
            return true;
            break;
    }

    return false;
}

/**
 * Checks if a variable is a Function
 * @param obj {*} The variable to test
 * @return {Boolean}
 */
function isFunction(obj) {
    return !!(obj && obj.constructor && obj.call && obj.apply);
}

/**
 * Converts a string array to an integer array
 * It converts all the string values of an array into their integer equivalents
 * @param str_arr {Array} The array to convert
 * @return {Array}
 */
function arrayToInteger(str_arr)
{
    var int_arr_item_int,
        array_count_int,
        keys_arr = [],
        values_arr = [],
        values_int_arr = [],
        final_int_arr = [];

    keys_arr = array_keys(str_arr);
    values_arr = array_values(str_arr);

    array_count_int = count(str_arr);
    for(var i = 0; i < array_count_int; i++)
    {
        int_arr_item_int = parseInt(values_arr[i]);
        values_int_arr.push(int_arr_item_int);
    }

    final_int_arr = array_combine(keys_arr, values_int_arr);
    return final_int_arr;
}

/**
 * Checks to see if array has duplicate values
 * @param arr {Array} the array to check
 * @return {Boolean}
 */
function arrayHasDuplicates(arr) {
    var valuesSoFar = {},
        array_count_int = count(arr);

    for (var i = 0; i < array_count_int; ++i) {
        var value = arr[i];
        if (Object.prototype.hasOwnProperty.call(valuesSoFar, value)) {
            return true;
        }
        valuesSoFar[value] = true;
    }
    return false;
}

/**
 * Gets a value from an array derived after a tokenized string is exploded
 * @param str {String} the tokenized string that will be exploded to an array
 * @param delim {String} the delimiter
 * @param key {Integer} the position of the array to return
 * @return {String}
 */
function getValueAfterExplode(str, delim, key)
{
    var arr = explode(delim, str);
    return arr[key];
}

/**
 * Sorts an array in numerical order and returns an array containing the keys of the array in the new sorted order
 * @param values_arr {Array} The array to sort
 * @return {Array}
 */
function getSortedKeys(values_arr)
{
    var array_with_keys = [];
    for (var i = 0; i < values_arr.length; i++) {
        array_with_keys.push({ key: i, value: values_arr[i] });
    }

    array_with_keys.sort(function(a, b) {
        if (a.value < b.value) { return -1; }
        if (a.value > b.value) { return  1; }
        return 0;
    });

    var keys = [];
    for (var i = 0; i < array_with_keys.length; i++) {
        keys.push(array_with_keys[i].key);
    }

    return keys;
}

/**
 * Finds the nearest matching number in an array containing integers
 * It is recommended that you sort the array in order before using it with this function
 * @param haystack_arr {Array} The array containing the integer values
 * @param needle_int {Number} The reference integer which is used to find the match
 * @param return_key_only_bool {Boolean} If true, will return the key position of the nearest match. Default is false.
 * @param is_ceil_bool {Boolean} If true, will return the nearest highest number even if a lower number is technically 'closer'. Default value is true.
 * @param disable_ceil_offset_int {Number} Please see explanation below.
 * For example, let's say needle_int is 120 and the nearest matching numbers are 115 on the lower end and 140 on the higher end
 * Being the is_ceil_bool is true by default, 140 would ordinarily be the nearest number selected. However, if disable_ceil_offset is set to 5, this will set is_ceil_bool to false, and 115 will be returned as the nearest number selected because the difference between it (the true nearest matching number) and 120 (needle_int) is 5 or less, even though needle_int is higher and under normal circumstances 120 would have been returned instead
 * @return {Number}
 */
function getClosestNumberMatchArray(haystack_arr, needle_int)
{
    var myArgs = Array.prototype.slice.call(arguments),
        return_key_only_bool = (isBool(myArgs[2])) ? myArgs[2]: false,
        is_ceil_bool = (isBool(myArgs[3])) ? myArgs[3]: true,
        disable_ceil_offset_int = (isNumber(myArgs[4])) ? myArgs[4] : 0,
        value_diff_int,
        value_diff_keys_sort_arr = [],
        value_diff_values_arr = [],
        key_final_int,
        value_final_int,
        value_final_needle_diff_int
        ;

    haystack_arr = arrayToInteger(haystack_arr);
    needle_int = parseInt(needle_int);

    for(var i = 0; i < count(haystack_arr); i++)
    {
        value_diff_int = needle_int - haystack_arr[i];
        value_diff_int = Math.abs(value_diff_int);
        value_diff_values_arr.push(value_diff_int);
    }

    value_diff_keys_sort_arr = getSortedKeys(value_diff_values_arr);
    key_final_int = value_diff_keys_sort_arr[0];
    value_final_int = haystack_arr[key_final_int];

    value_final_needle_diff_int = value_final_int - needle_int;
    value_final_needle_diff_int = Math.abs(value_final_needle_diff_int);

    //Manage for when needle_int is higher than nearest matching number, and highest matching number is required
    switch(true)
    {
        case (value_final_int < needle_int):
            is_ceil_bool = (value_final_needle_diff_int <= disable_ceil_offset_int) ? false : is_ceil_bool;
            key_final_int = (is_ceil_bool) ? key_final_int + 1 : key_final_int;
            break;
    }

    //return value or key
    value_final_int = haystack_arr[key_final_int];
    return (return_key_only_bool) ? key_final_int: value_final_int;
}

/**
 * This function checks if a number is an integer decimal and if the integral part of the decimal is even
 * For example, 640.123 will be true, 641.123 will be false
 * @param number_int {Number} The Integer Decimal
 * @param allow_negative_bool {Boolean} This will allow negative numbers to be considered
 * @return {Boolean}
 */
function isEvenDecimal(number_int)
{
    var myArgs = Array.prototype.slice.call(arguments),
        allow_negative_bool = (isBool(myArgs[1])) ? myArgs[1]: false,
        number_temp_int,
        number_temp_mod_int;

    number_temp_int = (number_int < 0 && allow_negative_bool) ? number_int * -1 : number_int;
    number_temp_mod_int = number_temp_int % 1;

    //return false if Number is less than one or is not a decimal integer
    switch(true)
    {
        case (!isNumber(number_temp_int) || number_temp_int < 1 || number_temp_mod_int == 0):
            return false;
            break;
    }

    //Check if integral part is even number
    number_temp_int = Math.floor(number_temp_int);
    number_temp_mod_int = number_temp_int % 2;

    return !!((number_temp_mod_int == 0));
}

/**
 * Retrieves the current and full URL of the document
 * @param option_flag_str {String} If present, specifies a specific part of the URL to return
 * The two options flags availabel are:
 * 1. bp [basepath] - Will return 'http://restive.io/index.html' if current URL is 'http://restive.io/index.html?id=1234'
 * 2. bd [basedir] - Will return 'http://restive.io/test' if current URL is 'http://restive.io/test/index.html?id=4'
 * 3. q [query] - Will return 'id=1234' if current URL is 'http://restive.io/index.html?id=1234'
 * @param url_str {String} By default, this function uses document.URL to capture the URL. You may provide your own url using this parameter
 * @return {String}
 */
function getUrl()
{
    var myArgs = Array.prototype.slice.call(arguments),
        option_flag_str = (isString(myArgs[0]) && myArgs[0] != '') ? myArgs[0]: '',
        url_str = (isString(myArgs[1]) && myArgs[1] != '') ? myArgs[1] : document.URL,
        url_temp_str,
        url_temp_arr = [],
        is_url_has_q_bool = /\?+/.test(url_str),
        url_match_arr = url_str.match(/^([h|f]{1}[t]{0,1}tp[s]{0,1}\:\/\/)([^ ]+?)\?([^ ]*)/i);

    switch(true)
    {
        case (option_flag_str == 'basepath' || option_flag_str == 'bp'):
            return (is_url_has_q_bool) ? url_match_arr[1]+url_match_arr[2] : url_str;
            break;

        case (option_flag_str == 'basedir' || option_flag_str == 'bd'):
            url_temp_str = (is_url_has_q_bool) ? url_match_arr[1]+url_match_arr[2] : url_str;
            url_temp_arr = explode('/', url_temp_str);
            url_temp_arr.pop();

            return implode('/', url_temp_arr);
            break;

        case (option_flag_str == 'query' || option_flag_str == 'q'):
            return (is_url_has_q_bool) ? url_match_arr[3]: "";
            break;

        default:
            return url_str;
    }
}

(function($){

    /**
     * Determines if a given element is a child or descendant of another
     * @param {String} $elem_sel_parent_str The selector of the parent object
     * @param {String} $elem_sel_child_str The selector of the suspected child object
     * @return {Boolean}
     */
    window.elementIsChildOf = function($elem_sel_parent_str, $elem_sel_child_str){
        var result_bool = false,
            elem_parent = $(''+$elem_sel_parent_str+''),
            elem_child = $(''+$elem_sel_child_str+'');

        switch(true)
        {
            case ($(elem_child).parents().index(elem_parent) != -1):
                result_bool = true;
                break;
        }

        return result_bool;
    };

    /**
     * Retrieves the text value of a JQuery Selector
     * @param {Object} el the JQuery Object/Element
     * @return {String}
     */
    window.getSelector = function(el){
        var $el = $(el);

        var id = $el.attr("id");
        if (id) { //"should" only be one of these if theres an ID
            return "#"+ id;
        }

        var node = $el[0].nodeName.toLowerCase();
        if(node == 'html' || node == 'body'){
            return node;
        }

        var selector = $el.parents()
            .map(function() { return this.tagName; })
            .get().reverse().join(" ");

        if (selector) {
            selector += " "+ $el[0].nodeName;
        }

        var classNames = $el.attr("class");
        if (classNames) {
            selector += "." + $.trim(classNames).replace(/\s/gi, ".");
        }

        var name = $el.attr('name');
        if (name) {
            selector += "[name='" + name + "']";
        }
        if (!name){
            var index = $el.index();
            if (index) {
                index = index + 1;
                selector += ":nth-child(" + index + ")";
            }
        }
        return selector;
    };

})(jQuery);


/*! Restive.JS | @copyright 2013 Obinwanne Hill */
var Restive = (function(window, document, $) {

    //Check for Dependency
    switch(true)
    {
        case (typeof $ != 'function'):
            //exit gracefully if missing
            throw 'Restive.JS requires JQuery to run!';
            break;
    }

    //Define local vars
    var root = this,
        Restive,
        win = window,
        docElem = document.documentElement,
        $win = $(win),
        screen = win.screen,
        vSpan, vPitch, cSpan, cPitch, dSpan, dPitch, eSpan, ePitch,
        media  = win.matchMedia || win.msMatchMedia || Object
        ;

    //Create window storage
    window.rstv_store = {'main': {}};
    window.parent.rstv_store = {'main': {}};

    //Create window storage function
    window.rstv_store.storage = function(){
        var myArgs = Array.prototype.slice.call(arguments),
            key_str = myArgs[0],
            value_res = myArgs[1],
            is_value_valid_bool = !!((typeof value_res !== "undefined" && value_res !== null) && ((isString(value_res) && value_res != "") || isNumber(value_res) || (isArray(value_res) && count(value_res) > 0) || isBool(value_res) || isObject(value_res))),
            is_value_null_bool = !!((value_res === null))
            ;

        switch(true)
        {
            case (is_value_valid_bool):
                window.rstv_store.main[""+key_str+""] = value_res;
                return;
                break;

            case (is_value_null_bool):
                window.rstv_store.main[""+key_str+""] = null;
                return;
                break;

            default:
                return window.rstv_store.main[""+key_str+""];
        }
    };

    /**
     * Initialize and store some important default values.
     * Return false if initialization has already been performed in same session.
     * @return {Boolean}
     */
    var init = function () {
        //detect private browsing
        window.rstv_store.main["rstv_is_priv_browsing"] = !!((_detectPrivateBrowsing()));

        var is_init_bool = store("rstv_is_init"),
            retr;

        switch (true) {
            case (is_init_bool):
                store("rstv_timestamp_curr", microtime(true));

                store("rstv_url", getUrl('bp'));

                //load counter
                _loadCounter();

                /** FIX FOR LOCAL BROWSER-BASED EMULATORS **/
                _fixForLocalDev();

                //update the dimension and orientation info storage-wide
                _initDimensionVars();
                _updateDimensionStore();
                _updateOrientationStore();

                retr = false;
                break;

            default:
                //flag that defaults are set
                store("rstv_timestamp_curr", microtime(true));
                store("rstv_timestamp_init", store("rstv_timestamp_curr"));
                store("rstv_loaded_count", 0, '', {expires: 1500});

                store("rstv_is_init", true);

                store("rstv_url", getUrl('bp'));
                store("rstv_url_hash", md5(getUrl('bp')));

                _initDimensionVars();
                _updateDimensionStore();
                store("rstv_ort_init", getOrientation());
                store("rstv_ort_curr", getOrientation());

                //load counter
                _loadCounter();

                retr = true;
        }

        return retr;
    };

    /**
     * Reinitializes the Restive Class on Demand
     * It resets Dimension, Orientation, and Timestamp Info
     * The Restive Class is initialized as soon as Restive.JS is called via <script\> tag. In certain circumstances
     * this might bring out a slight change in Dimension and Orientation Data especially for PCs.
     * Re-initialization will usually correct any discrepancies
     * NOTE: It is advised that you use this function only once, within document.ready, and before any other Restive-related methods
     */
    function reInit()
    {
        //reset timestamps
        store("rstv_timestamp_curr", microtime(true));
        store("rstv_timestamp_init", store("rstv_timestamp_curr"));

        //update the dimension and orientation info storage-wide
        _initDimensionVars();
        _updateDimensionStore();
        store("rstv_ort_init", getOrientation());
        store("rstv_ort_curr", getOrientation());
    }

    /**
     * Initializes important dimension variables to Local storage
     * @private
     */
    function _initDimensionVars()
    {
        store("rstv_var_doc_client_w", docElem.clientWidth);
        store("rstv_var_doc_client_h", docElem.clientHeight);
        store("rstv_var_win_outer_w", window.outerWidth);
        store("rstv_var_win_outer_h", window.outerHeight);
        store("rstv_var_win_screen_w", screen.width);
        store("rstv_var_win_screen_h", screen.height);
    }

    /**
     * Keeps track of how many times Restive.JS is loaded in rapid succession in a single browser session
     * @private
     */
    function _loadCounter()
    {
        var load_count_int = parseInt(store("rstv_loaded_count"));
        switch(true)
        {
            case (!isNumber(load_count_int)):
                load_count_int = 0;
                break;
        }
        load_count_int++;
        store("rstv_loaded_count", load_count_int, '', {expires: 1500});
    }

    /**
     * This is a special function to deal with certain issues experienced when using Restive.JS in Chrome Ripple
     * and other Browser Based Mobile Device emulators that load scripts more than once in rapid succession
     * when they are being initialized
     * @private
     */
    function _fixForLocalDev()
    {
        var load_count_int = parseInt(store("rstv_loaded_count")),
            ffld_is_init_bool = store("rstv_ffld_is_init");

        switch(true)
        {
            case (load_count_int > 1):
                store("rstv_viewportW rstv_viewportW_dip rstv_viewportH rstv_viewportH_dip rstv_screenW rstv_screenH", null);
                store("rstv_is_ios rstv_is_android rstv_is_blackberry rstv_is_symbian rstv_is_windows rstv_is_windows_phone", null);
                store("rstv_is_android_1_ rstv_is_android_2_ rstv_is_android_3_", null);
                store("rstv_is_phone rstv_is_tablet rstv_is_tv rstv_is_pc", null);
                store("rstv_ort_curr rstv_timestamp_curr rstv_is_portrait rstv_is_landscape", null);
                store("rstv_multi_count rstv_multi_bpm_idx rstv_cache_bpm rstv_cache_bpm_lock rstv_cache_req rstv_cache_bpm_viewport_diff", null);
                store("rstv_user_agent", null);

                store("rstv_timestamp_curr", microtime(true));
                store("rstv_ort_curr", getOrientation());

                switch(true)
                {
                    case (!ffld_is_init_bool):

                        store("rstv_timestamp_init", store("rstv_timestamp_curr"));
                        store("rstv_ort_init", getOrientation());

                        //Mark that this function has been executed
                        store("rstv_ffld_is_init", true);
                        break;
                }

                break;
        }
    }

    /**
     * Detects whether private browsing is active or not
     * @return {Boolean}
     */
    function _detectPrivateBrowsing()
    {
        try {
            localStorage.setItem("__test", "data");
        }
        catch (e)
        {
            if (/QUOTA_?EXCEEDED/i.test(e.name)) {
                return true;
            }
        }
        return false;
    }

    /**
     * Stores a value in LocalStorage [or other storage type], or retrieves previously stored value
     * Leverages AmplifyJS Store
     * @param key_str The identifier for the value being stored
     * @param value_res The value to store [optional]
     * @param type_str The type of storage format to be used
     * @param options_res A set of key/value pairs that relate to settings for storing the value
     * @return {*}
     */
    function store()
    {
        var myArgs = Array.prototype.slice.call(arguments);
        var is_priv_browsing_bool = window.rstv_store.main["rstv_is_priv_browsing"],
            key_str = myArgs[0],
            value_res = myArgs[1],
            type_str = ((typeof myArgs[2] !== "undefined" && myArgs[2] !== null) && (isString(myArgs[2]) && myArgs[2] != "")) ? myArgs[2] : 'ss',
            options_res = myArgs[3],
            store_func_name,
            store_func,
            list_del_key_arr = [],
            is_getall_bool = (isString(key_str) && key_str != "") ? false: true,
            is_value_valid_bool = !!((typeof value_res !== "undefined" && value_res !== null) && ((isString(value_res) && value_res != "") || isNumber(value_res) || (isArray(value_res) && count(value_res) > 0) || isBool(value_res) || isObject(value_res))),
            is_value_null_bool = !!((value_res === null));

        try
        {
            switch(true)
            {
                case (is_priv_browsing_bool):
                    //Private Browsing Detected, Use Windows Store
                    store_func_name = 'storage';
                    store_func = window.rstv_store[store_func_name];
                    break;

                default:
                    //Use AmplifyJS Store
                    switch(true)
                    {
                        case (type_str == 'ls'):
                            store_func_name = 'localStorage';
                            break;

                        default:
                            store_func_name = 'sessionStorage';
                    }
                    store_func = amplify.store[store_func_name];

                    //if sessionStorage is not supported, default to amplifyJS
                    switch(true)
                    {
                        case (!window.sessionStorage || !window.localStorage):
                            store_func = amplify.store;
                            break;
                    }

                    //return all values if no key is provided
                    switch(true)
                    {
                        case (is_getall_bool):
                            return store_func();
                            break;
                    }
            }

            //return stored value if empty value argument and value is not null
            switch(true)
            {
                case (!is_value_valid_bool && !is_value_null_bool):
                    return store_func(key_str);
                    break;
            }

            //delete object if value is null
            switch(true)
            {
                case (is_value_null_bool):
                    //delete stored object(s)
                    list_del_key_arr = explode(" ", key_str);
                    for (var i = 0; i < count(list_del_key_arr); i++)
                    {
                        store_func(list_del_key_arr[i], null);
                    }
                    return null;
                    break;
            }

            //store value
            store_func(key_str, null);
            store_func(key_str, value_res, options_res);
        }
        catch(e){
            alert(e);

        }
    }

    /**
     * This function is used to track specific String values in a storage system
     * The two possible storage options are (1) Cookies, and (2) Local Storage
     * It will store individual values as a tokenized string.
     * For example, if you call this function on two strings 'trial' and 'error', the stored value will be 'trial|error'
     *
     * @param key_str {String} The identifier of the value being stored
     * @param value_str {String} The individual value to store and track
     * @param store_type_str {String} The storage type of the container that will hold the stored value. 'ck' represents 'Cookie', and 'ls' represents 'LocalStorage'
     * @param unique_bool {Boolean} The setting that determines if the individual values should be unique. If this is true, no two string values will be identical
     * @param expires_ck_int|expires_ls_int {Number} Expiry setting
     * @param reverse_order_bool {Boolean} This affects the order with which data is stored. If true, data will be stored in a LIFO (Last In - First Out) format. If false, data will be store in a FIFO (First In - First Out) format
     * @param delim_str {String} The character that will be used to delimit the stored string
     * @param data_count_int {Number} The number of individual
     * @return {Boolean}
     */
    function storeVarTracker(key_str, value_str)
    {
        /**
         * This function saves the current Restive.JS settings tracking code to history
         */
        var myArgs = Array.prototype.slice.call(arguments),
            store_type_str = (isString(myArgs[2]) && myArgs[2] != "") ? myArgs[2] : 'ck',
            unique_bool = (isBool(myArgs[3])) ? myArgs[3]: false,
            expires_ls_int = (isNumber(myArgs[4]) || isString(myArgs[4])) ? parseInt(myArgs[4]): '',
            expires_ck_int = (isNumber(myArgs[4]) || isString(myArgs[4])) ? parseInt(myArgs[4]): 30,
            reverse_order_bool = (isBool(myArgs[5])) ? myArgs[5]: true,
            delim_str = (isString(myArgs[6]) && myArgs[6] != "") ? myArgs[6]: '-!',
            data_count_int = (isNumber(myArgs[7]) || isString(myArgs[7])) ? parseInt(myArgs[7]): 60,
            history_tok_str,
            history_upd_tok_str,
            history_arr = [],
            history_upd_arr = []
            ;

        //check if this tracking code exists
        history_tok_str = (store_type_str == 'ls') ? store(key_str) : $.cookie(key_str);
        switch(true)
        {
            case (history_tok_str === null || typeof history_tok_str === "undefined"):
                (store_type_str == 'ls') ? store(key_str, value_str,
                    '', {expires: expires_ls_int}) : $.cookie(key_str, value_str, { expires: expires_ck_int, path: '/' });

                return true;
                break;

            case (typeof history_tok_str !== "undefined" && history_tok_str !== null && history_tok_str != ""):
                //get cookie info and check if tracking cookie exists
                history_arr = explode(delim_str, history_tok_str);
                switch(true)
                {
                    case (in_array(value_str, history_arr) && unique_bool):
                        return false;
                        break;

                    default:
                        //generate the current tracking code
                        switch(true)
                        {
                            case (reverse_order_bool):
                                history_arr.unshift(value_str);
                                history_upd_arr = history_arr.slice(0, data_count_int);

                                history_upd_tok_str = implode(delim_str, history_upd_arr);
                                break;

                            default:
                                history_arr.push(value_str);
                                history_upd_tok_str = implode(delim_str, history_arr);
                        }

                        //store the tracking code
                        (store_type_str == 'ls') ? store(key_str, history_upd_tok_str, '', {expires: expires_ls_int}) : $.cookie(key_str, history_upd_tok_str, { expires: expires_ck_int, path: '/' });

                        return true;
                }
                break;
        }
    }

    /**
     * This function is used to validate a string value against the tokenized string stored via storeVarTracker()
     * It checks to see if the string value is one of the tokenized item. If yes, it returns true; if no, it returns false
     * For example if needle = 'trial', and the var_key_str identifies a stored string with value = 'trial|error', then validation will be successful
     * @param value_needle_str {String} The string value that will be validated against the stored value
     * @param key_str {String} The identifier of the value that was stored via storeVarTracker()
     * @param store_type_str {String} The storage type of the container holding the stored value. 'ck' represents 'Cookie', and 'ls' represents 'LocalStorage'
     * @param delim_str {String} The character that will be used to delimit the stored string
     * @return {Boolean}
     */
    function storeVarValidator(value_needle_str, key_str)
    {
        var myArgs = Array.prototype.slice.call(arguments),
            store_type_str = (isString(myArgs[2]) && myArgs[2] != "") ? myArgs[2] : 'ck',
            delim_str = (isString(myArgs[3]) && myArgs[3] != "") ? myArgs[3] : '-!',
            value_str = (store_type_str == 'ls') ? store(key_str) : $.cookie(key_str);

        switch(true)
        {
            case (typeof value_str !== "undefined" && value_str !== null && value_str != ""):
                var value_arr = [];
                value_arr = explode(delim_str, value_str);

                switch(true)
                {
                    case (in_array(value_needle_str, value_arr)):
                        //tracking code is in history
                        return true;
                        break;

                    default:
                        return false;
                }
                break;

            default:
                return false;
        }
    }

    /**
     * Checks if a value stored in LocalStorage exists and contains a value
     * Also stores a value if provided if the value did not previously exist or was invalid
     * @param key_str {String} The identifier for the value that was stored
     * @param value_store_res {*} The value to store [optional]
     * @return {Boolean}
     */
    function isStorageValueSet(key_str)
    {
        var myArgs = Array.prototype.slice.call(arguments),
            value_store_res = myArgs[1],
            value_retr_res = store(''+key_str+''),
            is_value_valid_bool = !!((typeof value_store_res !== "undefined" && value_store_res !== null)),
            is_store_value_set_bool = false
            ;

        //Determine if store value exists and is valid
        switch(true)
        {
            case (isBool(value_retr_res) || (value_retr_res !== null && typeof value_retr_res !== "undefined" && value_retr_res != "")):
                is_store_value_set_bool = true;
                break;
        }

        //Return result of check immediately if no value is provided
        switch(true)
        {
            case (!is_value_valid_bool):
                return is_store_value_set_bool;
                break;
        }

        //Store value if it does not exist and/or is invalid.
        switch(true)
        {
            case (!is_store_value_set_bool):
                store(key_str, value_store_res);
                break;
        }
    }

    /**
     * Increment (or Decrement) a stored variable
     * @param key_str {String} The identifier of the value that was stored
     * @param increment_value_int {Number} The size of the increment operation. Default is 1
     * @param is_decrement_bool {Boolean} If set to true, will decrement instead of increment
     * @return {Number|Boolean}
     */
    function incrementStorageValue(key_str)
    {
        var myArgs = Array.prototype.slice.call(arguments),
            increment_value_int = (isNumber(myArgs[1])) ? myArgs[1]: 1,
            is_decrement_bool = (isBool(myArgs[2])) ? myArgs[2]: false,
            value_int;

        value_int = parseInt(store(key_str));
        switch(true)
        {
            case (!isNumber(value_int)):
                return false;
                break;
        }

        value_int = (is_decrement_bool) ? value_int - increment_value_int: value_int + increment_value_int;
        store(key_str, value_int);

        return value_int;
    }

    /**
     * Returns a list of standard resolution dimensions
     * @param class_str {String} the class of dimensions to return. It could be 'w' = widths, or 'h' = heights
     * @return {Array}
     * @private
     */
    function _getResolutionDimensionList(class_str)
    {
        var std_w_arr = [120, 128, 160, 200, 240, 272, 300, 320, 352, 360, 480, 540, 576, 600, 640, 720, 768, 800, 864, 900, 1024, 1050, 1080, 1152, 1200, 1440, 1536, 1600, 1800, 2048, 2160, 2400, 3072, 3200, 4096, 4320, 4800],
            std_h_arr = [160, 240, 260, 320, 400, 432, 480, 640, 720, 800, 854, 960, 1024, 1136, 1152, 1280, 1360, 1366, 1400, 1440, 1600, 1680, 1920, 2048, 2560, 2880, 3200, 3840, 4096, 5120, 6400, 7680]
            ;

        switch(true)
        {
            case (class_str == 'w'):
                return std_w_arr;
                break;

            case (class_str == 'h'):
                return std_h_arr;
                break;
        }
    }

    /**
     * Get the Viewport or Screen Dimensions of the Device
     * @param type_str {String} The type of operation to execute
     * vW = viewport width, vH = viewport height, sW = screen width, sH = screen height
     * @param adj_screen_size_bool {Boolean} This determines if the screen size result should be adjusted to return the nearest standard resolution. For example if actual screen height is 1184, 1280 will be returned as it is the nearest standard resolution height. Default is true
     * @return {*}
     * @private
     */
    function _getDimension(type_str)
    {
        var myArgs = Array.prototype.slice.call(arguments),
            adj_screen_size_bool = (isBool(myArgs[1])) ? myArgs[1]: true,
            dim_res,
            dim_res_adj,
            adj_dim_res_bool = false,
            is_pc_or_tv_bool = !!((isPC() || isTV())),
            pixel_ratio_device_int = getPixelRatio(),
            pixel_ratio_virtual_int,
            win_outer_w_int = store("rstv_var_win_outer_w"),
            win_outer_h_int = store("rstv_var_win_outer_h"),
            doc_client_w_int = store("rstv_var_doc_client_w"),
            doc_client_h_int = store("rstv_var_doc_client_h"),
            win_screen_w_int = store("rstv_var_win_screen_w"),
            win_screen_h_int = store("rstv_var_win_screen_h")
            ;

        /**
         * Return dimensions quickly if device is PC
         */
        switch(true)
        {
            case (is_pc_or_tv_bool):
                switch(true)
                {
                    case (type_str == 'vW'):
                        dim_res = doc_client_w_int;
                        break;

                    case (type_str == 'vH'):
                        dim_res = doc_client_h_int;
                        break;

                    case (type_str == 'sW'):
                        dim_res = win_screen_w_int;
                        break;

                    case (type_str == 'sH'):
                        dim_res = win_screen_h_int;
                        break;
                }

                switch(true)
                {
                    case (type_str == 'vW' || type_str == 'vH'):
                        dim_res = (pixel_ratio_device_int >= 1.5) ? dim_res * pixel_ratio_device_int : dim_res;
                        break;
                }

                dim_res = Math.floor(dim_res);
                return dim_res;

                break;
        }

        /**
         * If not PC, continue processing
         */

        var device_user_agent_str = getUserAgent(),
            is_opera_browser_bool = /opera.+(mini|mobi)/i.test(device_user_agent_str),
            is_ios_bool = !!((isIOS())),
            is_symbian_bool = !!((isSymbian())),
            is_windows_bool = !!((isWindows())),
            is_android_bool = !!((isAndroid())),
            is_android_1_bool = !!((isAndroid('1.'))),
            is_android_2_bool = !!((isAndroid('2.'))),
            is_special_needs_bool = !!(((is_android_1_bool || is_android_2_bool) || is_symbian_bool || is_windows_bool)),
            viewport_w_int,
            viewport_h_int,
            screen_w_int = win_screen_w_int,
            screen_h_int = win_screen_h_int,
            screen_w_fix_int = screen_w_int,
            ort_w_int,
            ort_h_int,
            viewport_w_to_screen_w_ratio_int,
            screen_w_to_viewport_w_diff_int,
            screen_w_to_h_ratio_int,
            fixed_screen_dim_bool,
            std_w_arr = _getResolutionDimensionList('w'),
            std_h_arr = _getResolutionDimensionList('h'),
            std_w_temp_arr = std_w_arr,
            std_h_temp_arr = std_h_arr,
            is_landscape_v_bool,                    //viewport
            is_landscape_s_bool,                    //screen
            is_landscape_v_extended_verify_bool
            ;

        /**
         * Get the viewport dimensions
         */
        switch(true)
        {
            case (is_special_needs_bool):
                viewport_w_int = (win_outer_w_int <= 0) ? doc_client_w_int : win_outer_w_int;
                viewport_h_int = (win_outer_h_int <= 0) ? doc_client_h_int : win_outer_h_int;
                ort_w_int = viewport_w_int;
                ort_h_int = viewport_h_int;
                break;

            default:
                viewport_w_int = doc_client_w_int;
                viewport_h_int = doc_client_h_int;
                ort_w_int = doc_client_w_int;
                ort_h_int = doc_client_h_int;
        }

        /**
         * Modify Screen Dimensions if Android 2 or Symbian Platform
         */
        switch(true)
        {
            case ((is_android_2_bool || is_symbian_bool) && !is_opera_browser_bool):
                screen_w_int = (win_outer_w_int <= 0) ? screen_w_int : win_outer_w_int;
                screen_h_int = (win_outer_h_int <= 0) ? screen_h_int : win_outer_h_int;
                break;
        }

        //Determine orientation
        screen_w_to_h_ratio_int = screen_w_int/screen_h_int;
        screen_w_to_viewport_w_diff_int = screen_w_int - viewport_w_int;
        screen_w_to_viewport_w_diff_int = Math.abs(screen_w_to_viewport_w_diff_int);

        is_landscape_v_extended_verify_bool = (is_opera_browser_bool && viewport_w_int < 260) ? ((screen_w_to_viewport_w_diff_int <= 4) && (screen_w_to_h_ratio_int >= 1) ? true : false) : true;
        is_landscape_v_bool = !!((ort_h_int <= ort_w_int) && is_landscape_v_extended_verify_bool);
        is_landscape_s_bool = !!((screen_h_int <= screen_w_int));

        /**
         * Reduce resolution dimension list size if iOS
         * This improves the accuracy for first-generation iOS devices
         */
        switch(true)
        {
            case (is_ios_bool):
                std_w_temp_arr = std_w_temp_arr.slice(7);
                std_h_temp_arr = std_h_temp_arr.slice(6);
                break;

            case (is_android_bool):
                std_w_temp_arr = std_w_temp_arr.slice(4);
                std_h_temp_arr = std_h_temp_arr.slice(3);
                break;

            case (is_symbian_bool):
                std_w_temp_arr = std_w_temp_arr.slice(4);
                break;
        }

        /**
         * Reverse resolution dimension list when orientation changes
         */
        switch(true)
        {
            case (is_landscape_v_bool):
                std_w_arr = std_h_temp_arr;
                std_h_arr = std_w_temp_arr;
                break;

            default:
                std_w_arr = std_w_temp_arr;
                std_h_arr = std_h_temp_arr;
        }

        /**
         * Get Dimensions
         */
        switch(true)
        {
            case (type_str == 'vW'):
                dim_res = viewport_w_int;
                break;

            case (type_str == 'vH'):
                dim_res = viewport_h_int;
                break;

            case (type_str == 'sW'):
                /**
                 * This aims to correct any screen dimension discrepancies that usually occur when the
                 * raw viewport dimensions say the orientation is in one mode, but the raw screen dimensions
                 * say it is in another mode. Certain devices e.g. iPad will not change screen dimensions as the
                 * orientation changes. When this happens, we reverse values for screen_w and screen_h to compensate
                 */
                fixed_screen_dim_bool = !!((is_landscape_v_bool === true && is_landscape_s_bool === false) || (is_landscape_v_bool === false && is_landscape_s_bool === true));

                dim_res = (fixed_screen_dim_bool) ? screen_h_int : screen_w_int ;

                //get the fixed screen width
                screen_w_fix_int = (fixed_screen_dim_bool) ? screen_h_int : screen_w_int ;

                dim_res_adj = dim_res * pixel_ratio_device_int;
                adj_dim_res_bool = adj_screen_size_bool ? ((in_array(dim_res, std_w_arr) || in_array(dim_res_adj, std_w_arr)) ? false: true) : false;
                break;

            case (type_str == 'sH'):
                /**
                 * This aims to correct any screen dimension discrepancies that usually occur when the
                 * raw viewport dimensions say the orientation is in one mode, but the raw screen dimensions
                 * say it is in another mode. Certain devices e.g. iPad will not change screen dimensions as the
                 * orientation changes. When this happens, we reverse values for screen_w and screen_h to compensate
                 */
                fixed_screen_dim_bool = !!((is_landscape_v_bool === true && is_landscape_s_bool === false) || (is_landscape_v_bool === false && is_landscape_s_bool === true));

                dim_res = (fixed_screen_dim_bool) ? screen_w_int : screen_h_int ;

                //get the fixed screen width
                screen_w_fix_int = (fixed_screen_dim_bool) ? screen_h_int : screen_w_int ;

                dim_res_adj = dim_res * pixel_ratio_device_int;
                adj_dim_res_bool = adj_screen_size_bool ? ((in_array(dim_res, std_h_arr) || in_array(dim_res_adj, std_h_arr)) ? false: true) : false;
                break;
        }

        /**
         * Get the virtual pixel ratio i.e. screen vs viewport dimensions
         */
        pixel_ratio_virtual_int = screen_w_fix_int/viewport_w_int;

        /**
         * Return if Device Pixel Ratio is 1 or less and Virtual Pixel Ratio is less than 1.1
         */
        switch(true)
        {
            case (pixel_ratio_device_int <= 1 && pixel_ratio_virtual_int <= 1.1):
                switch(true)
                {
                    case (type_str == 'sW' && adj_dim_res_bool):
                        dim_res = getClosestNumberMatchArray(std_w_arr, dim_res, '', '', 8);
                        break;

                    case (type_str == 'sH' && adj_dim_res_bool):
                        dim_res = getClosestNumberMatchArray(std_h_arr, dim_res, '', '', 8);
                        break;
                }
                return dim_res;
                break;
        }

        /**
         * Continue if Pixel Ratio is greater than 1
         */
        switch(true)
        {
            case (is_ios_bool):
                dim_res = dim_res * pixel_ratio_device_int;
                break;

            default:
                switch(true)
                {
                    case (!is_android_2_bool):
                        /**
                         * Case 1: Device Pixel Ratio is 1 or less, and Virtual Pixel Ratio is greater than 1.1
                         * Update Viewport Dimensions only. Do not update Screen Dimensions
                         * Case 2. Device Pixel Ratio is more than 1, and Virtual Pixel Ratio is less than or equal to 1.1
                         * Update both Viewport and Screen Dimensions
                         * Case 3. Device Pixel Ratio is more than 1, and Virtual Pixel Ratio is greater than 1.1
                         * Update Viewport Dimensions only. Do not update Screen Dimensions
                         */
                        switch(true)
                        {
                            //1
                            case (pixel_ratio_device_int <= 1 && pixel_ratio_virtual_int > 1.1):
                                dim_res = (in_array(type_str, ['vW', 'vH'])) ? dim_res * pixel_ratio_virtual_int : dim_res;
                                break;
                            //2
                            case (pixel_ratio_device_int > 1 && pixel_ratio_virtual_int <= 1.1):
                                switch(true)
                                {
                                    case (pixel_ratio_device_int <= 1.1):
                                        //Special Operation for some devices that report device pixel ratio slightly above one
                                        switch(true)
                                        {
                                            case (in_array(type_str, ['vW', 'vH'])):
                                                dim_res = dim_res * pixel_ratio_device_int;
                                                dim_res = (isEvenDecimal(dim_res)) ? Math.floor(dim_res) : dim_res;
                                                break;
                                        }
                                        break;

                                    default:
                                        dim_res = dim_res * pixel_ratio_device_int;
                                }
                                break;
                            //3
                            case (pixel_ratio_device_int > 1 && pixel_ratio_virtual_int > 1.1):
                                switch(true)
                                {
                                    case (in_array(type_str, ['vW', 'vH'])):
                                        dim_res = dim_res * pixel_ratio_device_int;
                                        dim_res = (isEvenDecimal(dim_res)) ? Math.floor(dim_res) : Math.ceil(dim_res);
                                        break;
                                }
                                break;
                        }
                        break;
                }

                /**
                 * Get the nearest standard screen widths or heights
                 */
                switch(true)
                {
                    case (type_str == 'sW' && adj_dim_res_bool):
                        dim_res = getClosestNumberMatchArray(std_w_arr, dim_res, '', '', 8);
                        break;

                    case (type_str == 'sH' && adj_dim_res_bool):
                        dim_res = getClosestNumberMatchArray(std_h_arr, dim_res, '', '', 8);
                        break;
                }
        }

        dim_res = Math.floor(dim_res);
        return dim_res;
    }

    /**
     * Get the Viewport dimensions in Device-Independent Pixels
     * @param type_str {String} The type of operation. Either 'w' for width, or 'h' for height
     * @return {Number}
     * @private
     */
    function _getViewportDimensionDIP(type_str)
    {
        var dim_res,
            is_width_bool = !!((type_str == 'w')),
            is_pc_or_tv_bool = !!((isPC() || isTV())),
            pixel_ratio_int = getPixelRatio()
            ;

        switch(true)
        {
            case (is_pc_or_tv_bool):
                //If pc or tv, moderate use of pixel ratio
                pixel_ratio_int = (pixel_ratio_int <= 1.5) ? 1 : pixel_ratio_int;
                break;
        }
        dim_res = (is_width_bool) ? viewportW()/pixel_ratio_int : viewportH()/pixel_ratio_int;
        return Math.round(dim_res);
    }

    /**
     * Get the dimension of a DOM Element.
     * It uses the JQuery dimension functions e.g. width(), innerHeight(), etc.
     * @param el_obj {String} The JQuery element object
     * @param type_str {String} The type of operation. w = width, h = height
     * @param format_str {String} The dimension retrieval method to use. There are three as follows
     * 1: d = default = el_obj.width() or el_obj.height()
     * 2: i = inner = el_obj.innerWidth() or el_obj.innerHeight()
     * 3: o = outer = el_obj.outerWidth() or el_obj.outerHeight()
     * @param force_dip_bool {Boolean} Determines whether to consider the element dimensions in device-independent pixel format or not. true = do not use DIP, false [default] = use DIP
     * @return {Number|Boolean}
     * @private
     */
    function _getElementDimension(el_obj, type_str)
    {
        var myArgs = Array.prototype.slice.call(arguments),
            format_str = (isString(myArgs[2]) && myArgs[2] != "") ? myArgs[2]: 'd',
            force_dip_bool = (isBool(myArgs[3])) ? myArgs[3]: false,
            dim_final_int
            ;
        type_str = type_str.toLowerCase();

        switch(true)
        {
            case (type_str == 'w'):
                switch(true)
                {
                    case (format_str == 'i'):
                        dim_final_int = el_obj.innerWidth();
                        break;

                    case (format_str == 'o'):
                        dim_final_int = el_obj.outerWidth();
                        break;

                    default:
                        dim_final_int = el_obj.width();
                }
                break;

            case (type_str == 'h'):
                switch(true)
                {
                    case (format_str == 'i'):
                        dim_final_int = el_obj.innerHeight();
                        break;

                    case (format_str == 'o'):
                        dim_final_int = el_obj.outerHeight();
                        break;

                    default:
                        dim_final_int = el_obj.height();
                }
                break;

            default:
                dim_final_int = false;
        }

        switch(true)
        {
            case (force_dip_bool === false):
                //Convert to Device Pixels
                dim_final_int = dim_final_int * getPixelRatio();
                break;
        }

        return dim_final_int;
    }

    /**
     * Get the width of a DOM element
     * @param el_obj {Object} The JQuery Element Object
     * @param dim_format_str {String} The dimension retrieval method to use.
     * @param force_dip_bool {Boolean} Flag for forced Device-Independent Pixel consideration
     * @return {Number|Boolean}
     * @private
     */
    function _elementW(el_obj){
        var myArgs = Array.prototype.slice.call(arguments),
            dim_format_str = myArgs[1],
            force_dip_bool = myArgs[2]
            ;
        return _getElementDimension(el_obj, 'w', dim_format_str, force_dip_bool);
    }

    /**
     * Get the height of a DOM element
     * @param el_obj {Object} The JQuery Element Object
     * @param dim_format_str {String} The dimension retrieval method to use.
     * @param force_dip_bool {Boolean} Flag for forced Device-Independent Pixel consideration
     * @return {Number|Boolean}
     * @private
     */
    function _elementH(el_obj){
        var myArgs = Array.prototype.slice.call(arguments),
            dim_format_str = myArgs[1],
            force_dip_bool = myArgs[2]
            ;
        return _getElementDimension(el_obj, 'h', dim_format_str, force_dip_bool);
    }

    /**
     * Get the width of the viewport
     * @return {*|Number}
     */
    function viewportW(){
        return (isStorageValueSet("rstv_viewportW")) ? store("rstv_viewportW"): _getDimension('vW', store("rstv_is_getdim_screen_adj"));
    }

    /**
     * Get the height of the viewport
     * @return {*|Number}
     */
    function viewportH(){
        return (isStorageValueSet("rstv_viewportH")) ? store("rstv_viewportH"): _getDimension('vH', store("rstv_is_getdim_screen_adj"));
    }

    /**
     * Get the width of the screen i.e. device width
     * @return {*|Number}
     */
    function screenW(){
        return (isStorageValueSet("rstv_screenW")) ? store("rstv_screenW"): _getDimension('sW', store("rstv_is_getdim_screen_adj"));
    }

    /**
     * Get the height of the screen i.e. device height
     * @return {*|Number}
     */
    function screenH(){
        return (isStorageValueSet("rstv_screenH")) ? store("rstv_screenH"): _getDimension('sH', store("rstv_is_getdim_screen_adj"));
    }

    /**
     * Get the Device-Independent Pixel width of the viewport
     */
    function pixelW()
    {
        return (isStorageValueSet("rstv_viewportW_dip")) ? store("rstv_viewportW_dip"): _getViewportDimensionDIP('w');
    }

    /**
     * Get the Device-Independent Pixel height of the viewport
     */
    function pixelH()
    {
        return (isStorageValueSet("rstv_viewportH_dip")) ? store("rstv_viewportH_dip"): _getViewportDimensionDIP('h');
    }

    /**
     * Resets/Updates the cached values (localStorage) of Viewport and Screen Dimension Info
     * @private
     */
    function _updateDimensionStore()
    {
        //reset
        store("rstv_viewportW rstv_viewportW_dip rstv_viewportH rstv_viewportH_dip rstv_screenW rstv_screenH", null);

        //reload
        store("rstv_viewportW", viewportW());
        store("rstv_viewportH", viewportH());
        store("rstv_screenW", screenW());
        store("rstv_screenH", screenH());
        store("rstv_viewportW_dip", pixelW());
        store("rstv_viewportH_dip", pixelH());
    }

    /**
     * Get the Device Pixel Ratio
     * @param decimal {Number} An optional number (integer or float) to check against actual pixel ratio
     * @return {Number|Boolean}
     */
    function getPixelRatio(decimal)
    {
        //check if pixel ratio check has already been done. If so, return stored value
        switch(true)
        {
            case (isStorageValueSet("rstv_pixel_ratio")):
                return store("rstv_pixel_ratio");
                break;
        }

        var device_user_agent_str = getUserAgent(),
            is_opera_browser_bool = /opera.+(mini|mobi)/i.test(device_user_agent_str),
            doc_client_w = store("rstv_var_doc_client_w"),
            win_outer_w = store("rstv_var_win_outer_w"),
            win_screen_w = store("rstv_var_win_screen_w"),
            is_symbian_bool = !!(isSymbian()),
            is_windows_bool = !!(isWindows()),
            is_android_1_bool = !!((isAndroid('1.'))),
            is_android_2_bool = !!((isAndroid('2.'))),
            is_special_needs_bool = !!(((is_android_1_bool || is_android_2_bool) || is_symbian_bool || is_windows_bool)),
            is_windows_or_symbian_bool = !!(is_windows_bool || is_symbian_bool),
            viewport_w = (is_special_needs_bool) ? ((win_outer_w <= 0) ? doc_client_w : win_outer_w) : doc_client_w,
            screen_w = ((is_android_2_bool || is_symbian_bool) && !is_opera_browser_bool) ? ((win_outer_w <= 0) ? win_screen_w : win_outer_w) : win_screen_w,
            dPR,
            dPR_temp,
            dPR_virtual,
            dPR_retr
            ;

        /**
         * Get the Pixel Ratio
         * Make Adjustments for when window.devicePixelRatio is 0
         */
        dPR_temp = win.devicePixelRatio;
        switch(true)
        {
            case (dPR_temp <= 0 || typeof dPR_temp === 'undefined' || dPR_temp === null):
                dPR_virtual = screen_w/viewport_w;
                dPR = dPR_virtual;
                switch(true)
                {
                    case (is_windows_or_symbian_bool):
                        switch(true)
                        {
                            case (dPR > 0.5 && dPR < 1.2):
                                dPR = 1;
                                break;

                            case (dPR >= 1.2 && dPR < 2):
                                dPR = 1.5;
                                break;

                            case (dPR >= 2 && dPR < 3):
                                dPR = 2;
                                break;

                            case (dPR >= 3):
                                dPR = 3;
                                break;

                            default:
                                dPR = 1;
                        }
                        break;
                }
                store("rstv_pixel_ratio_virtual", dPR_virtual);
                break;

            default:
                dPR = dPR_temp;
        }

        //Return Pixel Ratio variations
        switch(true)
        {
            case (!isNumber(decimal)):
                dPR_retr = dPR || (getPixelRatio(3) ? 3 : getPixelRatio(2) ? 2 : getPixelRatio(1.5) ? 1.5 : getPixelRatio(1) ? 1 : 0);
                store("rstv_pixel_ratio", dPR_retr);
                return dPR_retr;
                break;
        }

        //Return false if not finite
        switch(true)
        {
            case (!isFinite(decimal)):
                return false;
                break;
        }

        switch(true)
        {
            case (dPR && dPR > 0):
                return dPR >= decimal;
                break;
        }

        //Revert to .matchMedia/.msMatchMedia for Gecko (FF6+) support
        decimal = 'only all and (min--moz-device-pixel-ratio:' + decimal + ')';
        switch(true)
        {
            case (media(decimal).matches):
                return true;
                break;
        }

        return !!media(decimal.replace('-moz-', '')).matches;
    }

    /**
     * Checks if the device is a Retina-device i.e. it has a Pixel Ratio of 2 or greater
     * @return {Boolean}
     */
    function isRetina()
    {
        var pixel_ratio_int = getPixelRatio();
        switch(true)
        {
            case (pixel_ratio_int >= 2):
                return true;
                break;
        }

        return false;
    }

    /**
     * A comparison function for checking if a number is within a range of two other numbers
     * @param {Function} fn
     * @return {Function}
     */
    function rangeCompare(fn) {
        return function(min, max) {
            var myArgs = Array.prototype.slice.call(arguments),
                bool,
                el = myArgs[2],
                el_valid_bool = !!((isObject(el) && (typeof el !== "undefined" && el !== null))),
                wf = myArgs[3],
                f_dip = myArgs[4],
                curr = (el_valid_bool) ? fn(el, wf, f_dip) : fn()
                ;

            bool = curr >= (min || 0);
            return !max ? bool : bool && curr <= max;
        };
    }

    //Range Comparison Booleans for Viewport and Screen
    vSpan = rangeCompare(viewportW);
    vPitch = rangeCompare(viewportH);
    dSpan = rangeCompare(screenW);
    dPitch = rangeCompare(screenH);
    cSpan = rangeCompare(pixelW);
    cPitch = rangeCompare(pixelH);

    //Range Comparison Booleans for DOM Element Containers
    eSpan = rangeCompare(_elementW);
    ePitch = rangeCompare(_elementH);

    /**
     * Gets the user agent of the Device
     * This function makes provision for proxy-based browsers that employ X11 forwarding
     * @return {String}
     */
    function getUserAgent()
    {
        //check if user agent check has been done and is in storage. If so, return stored value
        switch(true)
        {
            case (isStorageValueSet("rstv_user_agent")):
                return store("rstv_user_agent");
                break;
        }

        var ua = navigator.userAgent.toLowerCase(),
            is_proxy_bool;

        //Check if device user agent is being updated by proxy-based browser
        is_proxy_bool = /mozilla.+x11/i.test(ua);

        switch(true)
        {
            case (is_proxy_bool):
                $.ajax({
                    type: "GET",
                    async: false,
                    crossDomain: true,
                    url: "http://www.restive.io/ping/ua.php",
                    headers: {
                        "Cache-Control":"no-cache",
                        "Pragma":"no-cache"
                    },
                    success: function(response) {
                        ua = response;
                    },
                    error: function(xhr, status, error_msg){
                        console.log('error');/*RemoveLogging:skip*/
                    }
                });
                break;
        }

        store("rstv_user_agent", ua);
        return ua;
    }

    /**
     * Gets the Operating System Platform of the Device
     * There are six possible platforms availabel
     * (1) ios, (2) android, (3) Symbian, (4) Blackberry, (5) Windows, (6) Other
     * @return {String}
     */
    function getPlatform()
    {
        switch(true)
        {
            case (_checkOS("ios")):
                return "ios";
                break;

            case (_checkOS("android")):
                return "android";
                break;

            case (_checkOS("symbian")):
                return "symbian";
                break;

            case (_checkOS("blackberry")):
                return "blackberry";
                break;

            case (_checkOS("windows")):
                return "windows";
                break;

            default:
                return "other";
        }
    }

    /**
     * Detects the Operating System [Platform] of the Device
     * @param os_str {String} The name of the OS
     * @param version_str An optional version number [Only valid for Android]
     * @return {Boolean}
     * @private
     */
    function _checkOS(os_str)
    {
        var myArgs = Array.prototype.slice.call(arguments),
            is_version_valid_bool = !!((isString(myArgs[1]) && myArgs[1] != "")),
            version_str = '',
            version_regex_suffix_str = '',
            version_store_suffix_str = ''
            ;

        //manage version string if provided
        switch(true)
        {
            case (is_version_valid_bool):
                version_str = myArgs[1];
                version_str = version_str.replace(/^\s+|\s+$/g, "");
                version_regex_suffix_str = ' '+version_str;
                version_store_suffix_str = '_'+version_str.replace(".", "_");
                break;
        }

        //Check if value is stored. Return if true
        switch(true)
        {
            case (isStorageValueSet("rstv_is_"+os_str+version_store_suffix_str)):
                return store("rstv_is_"+os_str+version_store_suffix_str);
                break;
        }

        var nav = getUserAgent(),
            is_os_bool = false;

        switch(true)
        {
            case (os_str == "ios"):
                is_os_bool = /\bipad|\biphone|\bipod/i.test(nav);
                break;

            case (os_str == "android"):
                var pattern = new RegExp("\\bandroid"+version_regex_suffix_str, "i");
                is_os_bool = pattern.test(nav);
                break;

            case (os_str == "symbian"):
                is_os_bool = /series(4|6)0|symbian|symbos|syb-[0-9]+|\bs60\b/i.test(nav);
                break;

            case (os_str == "blackberry"):
                is_os_bool = /bb[0-9]+|blackberry|playbook|rim +tablet/i.test(nav);
                break;

            case (os_str == "windows"):
                is_os_bool = /window mobile|windows +(ce|phone)|windows +nt.+arm|windows +nt.+touch|xblwp7|zunewp7/i.test(nav);
                break;

            case (os_str == "windows_phone"):
                is_os_bool = /windows +phone|xblwp7|zunewp7/i.test(nav);
                break;

            default:
                return false;
        }

        //persist to local storage and return
        store("rstv_is_"+os_str+version_store_suffix_str, is_os_bool);
        return !!((is_os_bool));
    }

    /**
     * Checks if the Device is based on Apple's iOS Platform
     * @return {Boolean}
     */
    function isIOS()
    {
        return _checkOS("ios");
    }

    /**
     * Checks if the Device is based on Apple's iOS Platform
     * @return {Boolean}
     */
    function isApple()
    {
        return _checkOS("ios");
    }

    /**
     * Checks if the Device is based on Android Platform
     * @return {Boolean}
     */
    function isAndroid()
    {
        var myArgs = Array.prototype.slice.call(arguments),
            version_str = myArgs[0];
        return _checkOS("android", version_str);
    }

    /**
     * Checks if the Device is based on Symbian Platform
     * @return {Boolean}
     */
    function isSymbian()
    {
        return _checkOS("symbian");
    }

    /**
     * Checks if the Device is based on Blackberry Platform
     * @return {Boolean}
     */
    function isBlackberry()
    {
        return _checkOS("blackberry");
    }

    /**
     * Checks if the Device is based on a Windows Platform
     * @return {Boolean}
     */
    function isWindows()
    {
        return _checkOS("windows");
    }

    /**
     * Checks if the Device is based on Windows Phone Platform
     * @return {Boolean}
     */
    function isWindowsPhone()
    {
        return _checkOS("windows_phone");
    }

    /**
     * Mobile Browser Detection Regex
     * @param ua {String} User Agent String
     * @return {Boolean}
     * @private
     */
    function _mobileDetect(ua)
    {
        return /android|android.+mobile|avantgo|bada\/|\bbb[0-9]+|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|\bip(hone|od|ad)|iris|kindle|lge |maemo|meego.+mobile|midp|mmp|motorola|mobile.+firefox|netfront|nokia|nintendo +3ds|opera m(ob|in)i|palm|palm( os)?|phone|p(ixi|re)\/|playbook|rim +tablet|playstation.+vita|plucker|pocket|psp|samsung|(gt\-|bgt\-|sgh\-|sph\-|sch\-)[a-z][0-9]+|series(4|6)0|symbian|symbos|\bs60\b|treo|up\.(browser|link)|vertu|vodafone|wap|windows (ce|phone)|windows +nt.+arm|windows +nt.+touch|xda|xiino|xblwp7|zunewp7/i.test(ua) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb|b\-[0-9]+)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(ua.substr(0, 4));
    }

    /**
     * Gets the Form Factor of the device
     * There are only three form factors availabel
     * (1) Phone, (2) Tablet, (3) TV, (4) PC
     * @return {String}
     */
    function getFormFactor()
    {
        var form_factor_str = "";

        switch(true)
        {
            case (isTablet()):
                form_factor_str = "tablet";
                break;

            case (isTV()):
                form_factor_str = "tv";
                break;

            default:
                switch(true)
                {
                    case (isPhone()):
                        form_factor_str = "phone";
                        break;

                    default:
                        form_factor_str = "pc";
                }
        }

        return form_factor_str;
    }

    /**
     * Check if the Device is a Phone
     * @return {Boolean}
     */
    function isPhone()
    {
        //check if phone check has already been done. If so, return stored value
        switch(true)
        {
            case (isStorageValueSet("rstv_is_phone")):
                return store("rstv_is_phone");
                break;
        }

        //Check if Device is a Tablet
        switch(true)
        {
            case (isTablet(true) || isTV()):
                //is not phone
                store("rstv_is_phone", false);
                return false;
                break;
        }

        //Check if it is a phone
        switch(true)
        {
            case (_mobileDetect(getUserAgent() || navigator.vendor.toLowerCase() || window.opera)):
                store("rstv_is_phone", true);
                return true;
                break;
        }

        store("rstv_is_phone", false);
        return false;
    }

    /**
     * Check if the Device is a Tablet
     * @param bypass_storage_bool {Boolean} Prevent this method from caching its result in local storage
     * @return {Boolean}
     */
    function isTablet()
    {
        var myArgs = Array.prototype.slice.call(arguments),
            bypass_storage_bool = isBool(myArgs[0]) ? myArgs[0] : false
            ;

        //check if tablet check has already been done. If so, return stored value
        switch(true)
        {
            case (isStorageValueSet("rstv_is_tablet")):
                return store("rstv_is_tablet");
                break;
        }

        var regex_raw_str,
            regex,
            is_tablet_bool,
            nav = getUserAgent(),
            pixel_w_int = parseInt(store("rstv_viewportW_dip")),
            pixel_h_int = parseInt(store("rstv_viewportH_dip")),
            pixel_dim_int = (store("rstv_is_portrait")) ? pixel_w_int : pixel_h_int
            ;

        //if iPad or Blackberry Playbook, return true
        regex = new RegExp("ipad|playbook|rim +tablet", "i");
        is_tablet_bool = regex.test(nav);
        switch(true)
        {
            case (is_tablet_bool):
                if(!bypass_storage_bool){ store("rstv_is_tablet", true); }
                return true;
                break;
        }

        //if Windows Surface, return true
        regex = new RegExp("windows +nt.+arm|windows +nt.+touch", "i");
        is_tablet_bool = regex.test(nav);
        switch(true)
        {
            case (is_tablet_bool):
                switch(true)
                {
                    case (isNumber(pixel_dim_int) && (pixel_dim_int <= 520)):
                        if(!bypass_storage_bool){
                            store("rstv_is_tablet", false);
                            if(store("rstv_is_phone") === false){ store("rstv_is_phone", true);}
                        }
                        return false;
                        break;

                    default:
                        if(!bypass_storage_bool){ store("rstv_is_tablet", true); }
                        return true;
                }
                break;
        }

        /**
         * Check Other Known Tablets
         *
         * 1. Amazon Kindle: android.+kindle|kindle +fire|android.+silk|silk.*accelerated
         * 2. Google Nexus Tablet: android.+nexus +(7|10)
         * 3. Samsung Tablet: samsung.*tablet|galaxy.*tab|sc-01c|gt-p1000|gt-p1003|gt-p1010|gt-p3105|gt-p6210|gt-p6800|gt-p6810|gt-p7100|gt-p7300|gt-p7310|gt-p7500|gt-p7510|sch-i800|sch-i815|sch-i905|sgh-i957|sgh-i987|sgh-t849|sgh-t859|sgh-t869|sph-p100|gt-p3100|gt-p3108|gt-p3110|gt-p5100|gt-p5110|gt-p6200|gt-p7320|gt-p7511|gt-n8000|gt-p8510|sgh-i497|sph-p500|sgh-t779|sch-i705|sch-i915|gt-n8013|gt-p3113|gt-p5113|gt-p8110|gt-n8010|gt-n8005|gt-n8020|gt-p1013|gt-p6201|gt-p7501|gt-n5100|gt-n5110|shv-e140k|shv-e140l|shv-e140s|shv-e150s|shv-e230k|shv-e230l|shv-e230s|shw-m180k|shw-m180l|shw-m180s|shw-m180w|shw-m300w|shw-m305w|shw-m380k|shw-m380s|shw-m380w|shw-m430w|shw-m480k|shw-m480s|shw-m480w|shw-m485w|shw-m486w|shw-m500w|gt-i9228|sch-p739|sch-i925|gt-i9200|gt-i9205|gt-p5200|gt-p5210|sm-t311|sm-t310|sm-t210|sm-t210r|sm-t211|sm-p600|sm-p601|sm-p605|sm-p900|sm-t217|sm-t217a|sm-t217s|sm-p6000|sm-t3100|sgh-i467|xe500
         * 4. HTC Tablet: htc flyer|htc jetstream|htc-p715a|htc evo view 4g|pg41200
         * 5. Motorola Tablet: xoom|sholest|mz615|mz605|mz505|mz601|mz602|mz603|mz604|mz606|mz607|mz608|mz609|mz615|mz616|mz617
         * 6. Asus Tablet: transformer|^.*padfone((?!mobile).)*$|tf101|tf201|tf300|tf700|tf701|tf810|me171|me301t|me302c|me371mg|me370t|me372mg|me172v|me173x|me400c|slider *sl101
         * 7. Nook Tablet: android.+nook|nookcolor|nook browser|bnrv200|bnrv200a|bntv250|bntv250a|bntv400|bntv600|logicpd zoom2
         * 8. Acer Tablet: android.*\b(a100|a101|a110|a200|a210|a211|a500|a501|a510|a511|a700|a701|w500|w500p|w501|w501p|w510|w511|w700|g100|g100w|b1-a71|b1-710|b1-711|a1-810)\b|w3-810
         * 9. Toshiba Tablet: android.*(at100|at105|at200|at205|at270|at275|at300|at305|at1s5|at500|at570|at700|at830)|toshiba.*folio
         * 10. LG Tablet: \bl-06c|lg-v900|lg-v905|lg-v909
         * 11. Yarvik Tablet: android.+(xenta.+tab|tab210|tab211|tab224|tab250|tab260|tab264|tab310|tab360|tab364|tab410|tab411|tab420|tab424|tab450|tab460|tab461|tab464|tab465|tab467|tab468|tab469)
         * 12. Medion Tablet: android.+\boyo\b|life.*(p9212|p9514|p9516|s9512)|lifetab
         * 13. Arnova Tablet: an10g2|an7bg3|an7fg3|an8g3|an8cg3|an7g3|an9g3|an7dg3|an7dg3st|an7dg3childpad|an10bg3|an10bg3dt
         * 14. Archos Tablet: android.+archos|\b(101g9|80g9|a101it)\b|qilive 97r|
         * 15. Ainol Tablet: novo7|novo7aurora|novo7basic|novo7paladin|novo8|novo9|novo10
         * 16. Sony Tablet: sony tablet|sony tablet s|sgpt12|sgpt121|sgpt122|sgpt123|sgpt111|sgpt112|sgpt113|sgpt211|sgpt213|ebrd1101|ebrd1102|ebrd1201|sgpt311|sgpt312|sonyso-03e
         * 17. Cube Tablet: android.*(k8gt|u9gt|u10gt|u16gt|u17gt|u18gt|u19gt|u20gt|u23gt|u30gt)|cube u8gt
         * 18. Coby Tablet: mid1042|mid1045|mid1125|mid1126|mid7012|mid7014|mid7034|mid7035|mid7036|mid7042|mid7048|mid7127|mid8042|mid8048|mid8127|mid9042|mid9740|mid9742|mid7022|mid7010
         * 19. SMiTTablet: android.*(\bmid\b|mid-560|mtv-t1200|mtv-pnd531|mtv-p1101|mtv-pnd530)
         * 20. RockchipTablet: android.*(rk2818|rk2808a|rk2918|rk3066)|rk2738|rk2808a
         * 21. TelstraTablet: t-hub2
         * 22. FlyTablet: iq310|fly vision
         * 23. bqTablet: bq.*(elcano|curie|edison|maxwell|kepler|pascal|tesla|hypatia|platon|newton|livingstone|cervantes|avant)
         * 24. HuaweiTablet: mediapad|ideos s7|s7-201c|s7-202u|s7-101|s7-103|s7-104|s7-105|s7-106|s7-201|s7-slim
         * 25. NecTablet: \bn-06d|\bn-08d
         * 26. Pantech: pantech.*p4100
         * 27. BronchoTablet: broncho.*(n701|n708|n802|a710)
         * 28. VersusTablet: touchpad.*[78910]|\btouchtab\b
         * 29. Zynctablet: z1000|z99 2g|z99|z930|z999|z990|z909|z919|z900
         * 30. Positivo: tb07sta|tb10sta|tb07fta|tb10fta
         * 31. NabiTablet: android.*\bnabi
         * 32. Playstation: playstation.*(portable|vita)
         * 33. Dell: dell.*streak
         * 34. Milagrow: milagrow +tab.*top
         * 35. Lenovo: android.+(ideapad|ideatab|lenovo +a1|s2110|s6000|k3011|a3000|a1000|a2107|a2109|a1107)
         * 37. UPad: android.+f8-sup
         * 38. Kobo: android.+(k080|arc|vox)
         * 39. MSI: android.*(msi.+enjoy|enjoy +7|enjoy +10)
         * 40. Agasio: dropad.+a8
         * 41. Acho: android.+c906
         * 42. Iberry: android.+iberry.+auxus
         * 43. Aigo: android.+aigopad
         * 44. Airpad: android.*(airpad|liquid metal)
         * 45. HCL: android.+hcl.+tablet|connect-3g-2.0|connect-2g-2.0|me tablet u1|me tablet u2|me tablet g1|me tablet x1|me tablet y2|me tablet sync
         * 46. Karbonn: android.*(a39|a37|a34|st8|st10|st7|smarttab|smart +tab)
         * 47. Micromax: android.*(micromax.+funbook|funbook|p250|p275|p300|p350|p362|p500|p600)|micromax.*(p250|p275|p350|p362|p500|p600)|funbook
         * 48. Penta: android.+penta
         * 49. Celkon: android.*(celkon.+ct|ct-[0-9])
         * 50. Intex: android.+i-buddy
         * 51. Viewsonic: android.*(viewbook|viewpad)
         * 52: ZTE: android.*(v9|zte.+v8110|light tab|light pro|beeline|base.*tab)
         * 53. Pegatron: chagall
         * 54. Advan: android.*(vandroid|t3i)
         * 55. Creative: android.*(ziio7|ziio10)
         * 56. OlivePad: android.*(v-t100|v-tw100|v-tr200|v-t300)
         * 57. Vizio: android.+vtab1008
         * 58. Bookeen: bookeen|cybook
         * 59. Medion: android.*lifetab_(s9512|p9514|p9516)
         * 60. IRU Tablet: m702pro
         * 61. IRULU: irulu-al101
         * 62. Prestigio: pmp3170b|pmp3270b|pmp3470b|pmp7170b|pmp3370b|pmp3570c|pmp5870c|pmp3670b|pmp5570c|pmp5770d|pmp3970b|pmp3870c|pmp5580c|pmp5880d|pmp5780d|pmp5588c|pmp7280c|pmp7280|pmp7880d|pmp5597d|pmp5597|pmp7100d|per3464|per3274|per3574|per3884|per5274|per5474|pmp5097cpro|pmp5097|pmp7380d|pmp5297c|pmp5297c_quad
         * 63. AllView: allview.*(viva|alldro|city|speed|all tv|frenzy|quasar|shine|tx1|ax1|ax2)
         * 64: Megafon: megafon v9
         * 65: Lava: android.+(z7c|z7h|z7s)
         * 66: iBall: android.+iball.+slide.+(3g *7271|3g *7334|3g *7307|3g *7316|i7119|i7011)|android.+iball.+i6012
         * 67. Tabulet: android.+(tabulet|troy +duos)
         * 68. Texet Tablet: navipad|tb-772a|tm-7045|tm-7055|tm-9750|tm-7016|tm-7024|tm-7026|tm-7041|tm-7043|tm-7047|tm-8041|tm-9741|tm-9747|tm-9748|tm-9751|tm-7022|tm-7021|tm-7020|tm-7011|tm-7010|tm-7023|tm-7025|tm-7037w|tm-7038w|tm-7027w|tm-9720|tm-9725|tm-9737w|tm-1020|tm-9738w|tm-9740|tm-9743w|tb-807a|tb-771a|tb-727a|tb-725a|tb-719a|tb-823a|tb-805a|tb-723a|tb-715a|tb-707a|tb-705a|tb-709a|tb-711a|tb-890hd|tb-880hd|tb-790hd|tb-780hd|tb-770hd|tb-721hd|tb-710hd|tb-434hd|tb-860hd|tb-840hd|tb-760hd|tb-750hd|tb-740hd|tb-730hd|tb-722hd|tb-720hd|tb-700hd|tb-500hd|tb-470hd|tb-431hd|tb-430hd|tb-506|tb-504|tb-446|tb-436|tb-416|tb-146se|tb-126se
         * 69. GalapadTablet: android.*\bg1\b
         * 70. GUTablet: tx-a1301|tx-m9002|q702
         * 71. GT-Pad: ly-f528
         * 72. Danew: android.+dslide.*\b(700|701r|702|703r|704|802|970|971|972|973|974|1010|1012)\b
         * 73. MIDTablet: m9701|m9000|m9100|m806|m1052|m806|t703|mid701|mid713|mid710|mid727|mid760|mid830|mid728|mid933|mid125|mid810|mid732|mid120|mid930|mid800|mid731|mid900|mid100|mid820|mid735|mid980|mid130|mid833|mid737|mid960|mid135|mid860|mid736|mid140|mid930|mid835|mid733
         * 74. Fujitsu: android.*\b(f-01d|f-05e|f-10d|m532|q572)\b
         * 75. GPad: android.+casiatab8
         * 76. Tesco Hudl: android.+hudl
         * 77. Polaroid: android.*(polaroid.*tablet|pmid1000|pmid10c|pmid800|pmid700|pmid4311|pmid701c|pmid701i|pmid705|pmid706|pmid70dc|pmid70c|pmid720|pmid80c|pmid901|ptab7200|ptab4300|ptab750|midc010|midc407|midc409|midc410|midc497|midc700|midc800|midc801|midc802|midc901)
         * 78. Eboda: e-boda.+(supreme|impresspeed|izzycomm|essential)
         * 79. HP Tablet: hp slate 7|hp elitepad 900|hp-tablet|elitebook.*touch
         * 80. AllFineTablet: fine7 genius|fine7 shine|fine7 air|fine8 style|fine9 more|fine10 joy|fine11 wide
         * 81. Sanei: android.*\b(n10|n10-4core|n78|n79|n83|n90 ii)\b
         * 82: ProScan Tablet: \b(pem63|plt1023g|plt1041|plt1044|plt1044g|plt1091|plt4311|plt4311pl|plt4315|plt7030|plt7033|plt7033d|plt7035|plt7035d|plt7044k|plt7045k|plt7045kb|plt7071kg|plt7072|plt7223g|plt7225g|plt7777g|plt7810k|plt7849g|plt7851g|plt7852g|plt8015|plt8031|plt8034|plt8036|plt8080k|plt8082|plt8088|plt8223g|plt8234g|plt8235g|plt8816k|plt9011|plt9045k|plt9233g|plt9735|plt9760g|plt9770g)\b
         * 83: YonesTablet : bq1078|bc1003|bc1077|rk9702|bc9730|bc9001|it9001|bc7008|bc7010|bc708|bc728|bc7012|bc7030|bc7027|bc7026
         * 84: ChangJiaTablet: tpc7102|tpc7103|tpc7105|tpc7106|tpc7107|tpc7201|tpc7203|tpc7205|tpc7210|tpc7708|tpc7709|tpc7712|tpc7110|tpc8101|tpc8103|tpc8105|tpc8106|tpc8203|tpc8205|tpc8503|tpc9106|tpc9701|tpc97101|tpc97103|tpc97105|tpc97106|tpc97111|tpc97113|tpc97203|tpc97603|tpc97809|tpc97205|tpc10101|tpc10103|tpc10106|tpc10111|tpc10203|tpc10205|tpc10503
         * 85: RoverPad: android.*(roverpad|rp3wg70)
         * 86. PointofView Tablet: tab-p506|tab-navi-7-3g-m|tab-p517|tab-p-527|tab-p701|tab-p703|tab-p721|tab-p731n|tab-p741|tab-p825|tab-p905|tab-p925|tab-pr945|tab-pl1015|tab-p1025|tab-pi1045|tab-p1325|tab-protab[0-9]+|tab-protab25|tab-protab26|tab-protab27|tab-protab26xl|tab-protab2-ips9|tab-protab30-ips9|tab-protab25xxl|tab-protab26-ips10|tab-protab30-ips10
         * 87: Overmax: android.*ov-(steelcore|newbase|basecore|baseone|exellen|quattor|edutab|solution|action|basictab|teddytab|magictab|stream|tb-08|tb-09)
         * 88: DPS Tablet: dps dream 9|dps dual 7
         * 89: Visture Tablet: v97 hd|i75 3g|visture v4( hd)?|visture v5( hd)?|visture v10
         * 90: Cresta Tablet: ctp(-)?810|ctp(-)?818|ctp(-)?828|ctp(-)?838|ctp(-)?888|ctp(-)?978|ctp(-)?980|ctp(-)?987|ctp(-)?988|ctp(-)?989
         * 200. Generic Tablet: android.*\b97d\b|tablet(?!.*pc)|viewpad7|lg-v909|mid7015|bntv250a|logicpd zoom2|\ba7eb\b|catnova8|a1_07|ct704|ct1002|\bm721\b|rk30sdk|\bevotab\b|smarttabii10|smarttab10
         */
        regex_raw_str = ""+
            "android.+kindle|kindle +fire|android.+silk|silk.*accelerated|"+
            "android.+nexus +(7|10)|"+
            "samsung.*tablet|galaxy.*tab|sc-01c|gt-p1000|gt-p1003|gt-p1010|gt-p3105|gt-p6210|gt-p6800|gt-p6810|gt-p7100|gt-p7300|gt-p7310|gt-p7500|gt-p7510|sch-i800|sch-i815|sch-i905|sgh-i957|sgh-i987|sgh-t849|sgh-t859|sgh-t869|sph-p100|gt-p3100|gt-p3108|gt-p3110|gt-p5100|gt-p5110|gt-p6200|gt-p7320|gt-p7511|gt-n8000|gt-p8510|sgh-i497|sph-p500|sgh-t779|sch-i705|sch-i915|gt-n8013|gt-p3113|gt-p5113|gt-p8110|gt-n8010|gt-n8005|gt-n8020|gt-p1013|gt-p6201|gt-p7501|gt-n5100|gt-n5110|shv-e140k|shv-e140l|shv-e140s|shv-e150s|shv-e230k|shv-e230l|shv-e230s|shw-m180k|shw-m180l|shw-m180s|shw-m180w|shw-m300w|shw-m305w|shw-m380k|shw-m380s|shw-m380w|shw-m430w|shw-m480k|shw-m480s|shw-m480w|shw-m485w|shw-m486w|shw-m500w|gt-i9228|sch-p739|sch-i925|gt-i9200|gt-i9205|gt-p5200|gt-p5210|sm-t311|sm-t310|sm-t210|sm-t210r|sm-t211|sm-p600|sm-p601|sm-p605|sm-p900|sm-t217|sm-t217a|sm-t217s|sm-p6000|sm-t3100|sgh-i467|xe500|"+
            "htc flyer|htc jetstream|htc-p715a|htc evo view 4g|pg41200|"+
            "xoom|sholest|mz615|mz605|mz505|mz601|mz602|mz603|mz604|mz606|mz607|mz608|mz609|mz615|mz616|mz617|"+
            "transformer|^.*padfone((?!mobile).)*$|tf101|tf201|tf300|tf700|tf701|tf810|me171|me301t|me302c|me371mg|me370t|me372mg|me172v|me173x|me400c|slider *sl101|"+
            "android.+nook|nookcolor|nook browser|bnrv200|bnrv200a|bntv250|bntv250a|bntv400|bntv600|logicpd zoom2|"+
            "android.*\\b(a100|a101|a110|a200|a210|a211|a500|a501|a510|a511|a700|a701|w500|w500p|w501|w501p|w510|w511|w700|g100|g100w|b1-a71|b1-710|b1-711|a1-810)\\b|w3-810|"+
            "android.*(at100|at105|at200|at205|at270|at275|at300|at305|at1s5|at500|at570|at700|at830)|toshiba.*folio|"+
            "\\bl-06c|lg-v900|lg-v905|lg-v909|"+
            "android.+(xenta.+tab|tab210|tab211|tab224|tab250|tab260|tab264|tab310|tab360|tab364|tab410|tab411|tab420|tab424|tab450|tab460|tab461|tab464|tab465|tab467|tab468|tab469)|"+
            "android.+\\boyo\\b|life.*(p9212|p9514|p9516|s9512)|lifetab|"+
            "an10g2|an7bg3|an7fg3|an8g3|an8cg3|an7g3|an9g3|an7dg3|an7dg3st|an7dg3childpad|an10bg3|an10bg3dt|"+
            "android.+archos|\\b(101g9|80g9|a101it)\\b|qilive 97r|"+
            "novo7|novo7aurora|novo7basic|novo7paladin|novo8|novo9|novo10|"+
            "sony tablet|sony tablet s|sgpt12|sgpt121|sgpt122|sgpt123|sgpt111|sgpt112|sgpt113|sgpt211|sgpt213|ebrd1101|ebrd1102|ebrd1201|sgpt311|sgpt312|sonyso-03e|"+
            "android.*(k8gt|u9gt|u10gt|u16gt|u17gt|u18gt|u19gt|u20gt|u23gt|u30gt)|cube u8gt|"+
            "mid1042|mid1045|mid1125|mid1126|mid7012|mid7014|mid7034|mid7035|mid7036|mid7042|mid7048|mid7127|mid8042|mid8048|mid8127|mid9042|mid9740|mid9742|mid7022|mid7010|"+
            "android.*(\\bmid\\b|mid-560|mtv-t1200|mtv-pnd531|mtv-p1101|mtv-pnd530)|"+
            "android.*(rk2818|rk2808a|rk2918|rk3066)|rk2738|rk2808a|"+
            "t-hub2|"+
            "iq310|fly vision|"+
            "bq.*(elcano|curie|edison|maxwell|kepler|pascal|tesla|hypatia|platon|newton|livingstone|cervantes|avant)|"+
            "mediapad|ideos s7|s7-201c|s7-202u|s7-101|s7-103|s7-104|s7-105|s7-106|s7-201|s7-slim|"+
            "\\bn-06d|\\bn-08d|"+
            "pantech.*p4100|"+
            "broncho.*(n701|n708|n802|a710)|"+
            "touchpad.*[78910]|\\btouchtab\\b|"+
            "z1000|z99 2g|z99|z930|z999|z990|z909|z919|z900|"+
            "tb07sta|tb10sta|tb07fta|tb10fta|"+
            "android.*\\bnabi|"+
            "playstation.*(portable|vita)|"+
            "dell.*streak|"+
            "milagrow +tab.*top|"+
            "android.+(ideapad|ideatab|lenovo +a1|s2110|s6000|k3011|a3000|a1000|a2107|a2109|a1107)|"+
            "android.+f8-sup|"+
            "android.*(k080|arc|vox)|"+
            "android.*(msi.+enjoy|enjoy +7|enjoy +10)|"+
            "dropad.+a8|"+
            "android.+c906|"+
            "android.+iberry.+auxus|"+
            "android.+aigopad|"+
            "android.*(airpad|liquid metal)|"+
            "android.+hcl.+tablet|connect-3g-2.0|connect-2g-2.0|me tablet u1|me tablet u2|me tablet g1|me tablet x1|me tablet y2|me tablet sync|"+
            "android.*(a39|a37|a34|st8|st10|st7|smarttab|smart +tab)|"+
            "android.*(micromax.+funbook|funbook|p250|p275|p300|p350|p362|p500|p600)|micromax.*(p250|p275|p350|p362|p500|p600)|funbook|"+
            "android.+penta|"+
            "android.*(celkon.+ct|ct-[0-9])|"+
            "android.+i-buddy|"+
            "android.*(viewbook|viewpad)|"+
            "android.*(v9|zte.+v8110|light tab|light pro|beeline|base.*tab)|"+
            "chagall|"+
            "android.*(vandroid|t3i)|"+
            "android.*(ziio7|ziio10)|"+
            "android.*(v-t100|v-tw100|v-tr200|v-t300)|"+
            "android.+vtab1008|"+
            "bookeen|cybook|"+
            "android.*lifetab_(s9512|p9514|p9516)|"+
            "m702pro|"+
            "irulu-al101|"+
            "pmp3170b|pmp3270b|pmp3470b|pmp7170b|pmp3370b|pmp3570c|pmp5870c|pmp3670b|pmp5570c|pmp5770d|pmp3970b|pmp3870c|pmp5580c|pmp5880d|pmp5780d|pmp5588c|pmp7280c|pmp7280|pmp7880d|pmp5597d|pmp5597|pmp7100d|per3464|per3274|per3574|per3884|per5274|per5474|pmp5097cpro|pmp5097|pmp7380d|pmp5297c|pmp5297c_quad|"+
            "allview.*(viva|alldro|city|speed|all tv|frenzy|quasar|shine|tx1|ax1|ax2)|"+
            "megafon +v9|"+
            "android.+(z7c|z7h|z7s)|"+
            "android.+iball.+slide.+(3g *7271|3g *7334|3g *7307|3g *7316|i7119|i7011)|android.+iball.+i6012|"+
            "navipad|tb-772a|tm-7045|tm-7055|tm-9750|tm-7016|tm-7024|tm-7026|tm-7041|tm-7043|tm-7047|tm-8041|tm-9741|tm-9747|tm-9748|tm-9751|tm-7022|tm-7021|tm-7020|tm-7011|tm-7010|tm-7023|tm-7025|tm-7037w|tm-7038w|tm-7027w|tm-9720|tm-9725|tm-9737w|tm-1020|tm-9738w|tm-9740|tm-9743w|tb-807a|tb-771a|tb-727a|tb-725a|tb-719a|tb-823a|tb-805a|tb-723a|tb-715a|tb-707a|tb-705a|tb-709a|tb-711a|tb-890hd|tb-880hd|tb-790hd|tb-780hd|tb-770hd|tb-721hd|tb-710hd|tb-434hd|tb-860hd|tb-840hd|tb-760hd|tb-750hd|tb-740hd|tb-730hd|tb-722hd|tb-720hd|tb-700hd|tb-500hd|tb-470hd|tb-431hd|tb-430hd|tb-506|tb-504|tb-446|tb-436|tb-416|tb-146se|tb-126se|"+
            "android.*\\bg1\\b|"+
            "tx-a1301|tx-m9002|q702|"+
            "ly-f528|"+
            "android.+dslide.*\\b(700|701r|702|703r|704|802|970|971|972|973|974|1010|1012)\\b|"+
            "m9701|m9000|m9100|m806|m1052|m806|t703|mid701|mid713|mid710|mid727|mid760|mid830|mid728|mid933|mid125|mid810|mid732|mid120|mid930|mid800|mid731|mid900|mid100|mid820|mid735|mid980|mid130|mid833|mid737|mid960|mid135|mid860|mid736|mid140|mid930|mid835|mid733|"+
            "android.*\\b(f-01d|f-05e|f-10d|m532|q572)\\b|"+
            "android.+casiatab8|"+
            "android.+hudl|"+
            "android.*(polaroid.*tablet|pmid1000|pmid10c|pmid800|pmid700|pmid4311|pmid701c|pmid701i|pmid705|pmid706|pmid70dc|pmid70c|pmid720|pmid80c|pmid901|ptab7200|ptab4300|ptab750|midc010|midc407|midc409|midc410|midc497|midc700|midc800|midc801|midc802|midc901)|"+
            "e-boda.+(supreme|impresspeed|izzycomm|essential)|"+
            "hp slate 7|hp elitepad 900|hp-tablet|elitebook.*touch|"+
            "fine7 genius|fine7 shine|fine7 air|fine8 style|fine9 more|fine10 joy|fine11 wide|"+
            "android.*\\b(n10|n10-4core|n78|n79|n83|n90 ii)\\b|"+
            "\\b(pem63|plt1023g|plt1041|plt1044|plt1044g|plt1091|plt4311|plt4311pl|plt4315|plt7030|plt7033|plt7033d|plt7035|plt7035d|plt7044k|plt7045k|plt7045kb|plt7071kg|plt7072|plt7223g|plt7225g|plt7777g|plt7810k|plt7849g|plt7851g|plt7852g|plt8015|plt8031|plt8034|plt8036|plt8080k|plt8082|plt8088|plt8223g|plt8234g|plt8235g|plt8816k|plt9011|plt9045k|plt9233g|plt9735|plt9760g|plt9770g)\\b|"+
            "bq1078|bc1003|bc1077|rk9702|bc9730|bc9001|it9001|bc7008|bc7010|bc708|bc728|bc7012|bc7030|bc7027|bc7026|"+
            "tpc7102|tpc7103|tpc7105|tpc7106|tpc7107|tpc7201|tpc7203|tpc7205|tpc7210|tpc7708|tpc7709|tpc7712|tpc7110|tpc8101|tpc8103|tpc8105|tpc8106|tpc8203|tpc8205|tpc8503|tpc9106|tpc9701|tpc97101|tpc97103|tpc97105|tpc97106|tpc97111|tpc97113|tpc97203|tpc97603|tpc97809|tpc97205|tpc10101|tpc10103|tpc10106|tpc10111|tpc10203|tpc10205|tpc10503|"+
            "android.*(roverpad|rp3wg70)|"+
            "tab-p506|tab-navi-7-3g-m|tab-p517|tab-p-527|tab-p701|tab-p703|tab-p721|tab-p731n|tab-p741|tab-p825|tab-p905|tab-p925|tab-pr945|tab-pl1015|tab-p1025|tab-pi1045|tab-p1325|tab-protab[0-9]+|tab-protab25|tab-protab26|tab-protab27|tab-protab26xl|tab-protab2-ips9|tab-protab30-ips9|tab-protab25xxl|tab-protab26-ips10|tab-protab30-ips10|"+
            "android.*ov-(steelcore|newbase|basecore|baseone|exellen|quattor|edutab|solution|action|basictab|teddytab|magictab|stream|tb-08|tb-09)|"+
            "dps dream 9|dps dual 7|"+
            "v97 hd|i75 3g|visture v4( hd)?|visture v5( hd)?|visture v10|"+
            "ctp(-)?810|ctp(-)?818|ctp(-)?828|ctp(-)?838|ctp(-)?888|ctp(-)?978|ctp(-)?980|ctp(-)?987|ctp(-)?988|ctp(-)?989|"+
            "android.*\\b97d\\b|tablet(?!.*pc)|viewpad7|lg-v909|mid7015|bntv250a|logicpd zoom2|\\ba7eb\\b|catnova8|a1_07|ct704|ct1002|\\bm721\\b|rk30sdk|\\bevotab\\b|smarttabii10|smarttab10"+
            "";

        //Check Main Tablet
        regex = new RegExp(regex_raw_str, "i");
        is_tablet_bool = regex.test(nav);
        switch(true)
        {
            case (is_tablet_bool):
                if(!bypass_storage_bool){ store("rstv_is_tablet", true); }
                return true;
                break;
        }

        //Check Android Tablet
        var regex_1_bool = /android/i.test(nav),
            regex_2_bool = !/mobile/i.test(nav)
            ;

        switch(true)
        {
            case (regex_1_bool):
                /**
                 * if tablet has either:
                 * 1. Device independent viewport width between 520px and 800px when in portrait
                 * 2. Device independent viewport height between 520px and 800px when in landscape
                 */
                switch(true)
                {
                    case (isNumber(pixel_dim_int) && (pixel_dim_int >= 520 && pixel_dim_int <= 810)):
                        if(!bypass_storage_bool){
                            store("rstv_is_tablet", true);
                            if(store("rstv_is_phone")){ store("rstv_is_phone", false);}
                        }
                        return true;
                        break;
                }

                //if user agent is Android but 'mobile' keyword is absent
                switch(true)
                {
                    case (regex_2_bool):
                        if(!bypass_storage_bool){ store("rstv_is_tablet", true); }
                        return true;
                        break;
                }

                break;
        }

        //Return false if otherwise
        if(!bypass_storage_bool){ store("rstv_is_tablet", false); }
        return false;
    }

    /**
     * Check if the device is a TV
     * @return {Boolean}
     */
    function isTV()
    {
        //check if TV check has already been done. If so, return stored value
        switch(true)
        {
            case (isStorageValueSet("rstv_is_tv")):
                return store("rstv_is_tv");
                break;
        }

        //get the user agent
        var nav = getUserAgent();

        /**
         * Check for known TVs
         */
        var is_tv_bool = /googletv|smart\-tv|smarttv|internet +tv|netcast|nettv|appletv|boxee|kylo|roku|vizio|dlnadoc|ce\-html|ouya|xbox|playstation *(3|4)|wii/i.test(nav);

        switch(true)
        {
            case (is_tv_bool):
                store("rstv_is_tv", true);
                return true;
                break;
        }

        store("rstv_is_tv", false);
        return false;
    }

    /**
     * Checks if the device is a Personal Computer
     * @return {Boolean}
     */
    function isPC()
    {
        //check if PC check has already been done. If so, return stored value
        switch(true)
        {
            case (isStorageValueSet("rstv_is_pc")):
                return store("rstv_is_pc");
                break;
        }

        switch(true)
        {
            case (isMobile() === false && isTV() === false):
                store("rstv_is_pc", true);
                return true;
                break;
        }

        store("rstv_is_pc", false);
        return false;
    }

    /**
     * Checks if the device is a mobile device
     * @return {Boolean}
     */
    function isMobile()
    {
        //check if device is phone or tablet
        switch(true)
        {
            case (isPhone() || isTablet(true)):
                return true;
                break;

            default:
                return false;
        }
    }

    /**
     * Checks if the device is a non-mobile device
     * @return {Boolean}
     */
    function isNonMobile()
    {
        //check if device is not phone or mobile
        switch(true)
        {
            case (!isMobile()):
                return true;
                break;

            default:
                return false;
        }
    }

    /**
     * Gets the orientation of the device
     * @param bypass_cache_bool {Boolean} Determines if the stored value for current orientation should be retrieved or not. True will ignore the value stored and will re-test the orientation
     * @return {String}
     */
    function getOrientation()
    {
        var myArgs = Array.prototype.slice.call(arguments),
            bypass_cache_bool = isBool(myArgs[0]) ? myArgs[0] : false,
            ort_final_str;

        //check if current orientation value is stored and bypass_cache_bool is false. If so, return stored value
        switch(true)
        {
            case (isStorageValueSet("rstv_ort_curr") && !bypass_cache_bool):
                return store("rstv_ort_curr");
                break;
        }

        //Reset Viewport Dimensions if bypass_cache_bool is true
        switch(true)
        {
            case (bypass_cache_bool):
                store("rstv_viewportW rstv_viewportW_dip rstv_viewportH rstv_viewportH_dip rstv_screenW rstv_screenH", null);
                break;
        }

        //Get the Viewport Dimensions
        var device_user_agent_str = getUserAgent(),
            is_opera_mini_bool = /opera.+(mini|mobi)/i.test(device_user_agent_str),
            viewport_w_int = viewportW(),
            viewport_h_int = viewportH(),
            screen_w_int = screenW(),
            screen_h_int = screenH(),
            screen_w_to_h_ratio_int = screen_w_int/screen_h_int,
            screen_w_to_viewport_w_diff_int = screen_w_int - viewport_w_int,
            is_landscape_extended_verify_bool,
            is_landscape_bool;

        screen_w_to_viewport_w_diff_int = Math.abs(screen_w_to_viewport_w_diff_int);
        is_landscape_extended_verify_bool = (is_opera_mini_bool && viewport_w_int < 260) ? ((screen_w_to_viewport_w_diff_int <= 4) && (screen_w_to_h_ratio_int >= 1) ? true : false) : true;
        is_landscape_bool = !!((viewport_h_int <= viewport_w_int) && is_landscape_extended_verify_bool);

        switch(true)
        {
            case (is_landscape_bool):
                //landscape
                ort_final_str = 'landscape';

                //do not alter cached orientation variables if bypass_cache_bool is true
                switch(true)
                {
                    case (!bypass_cache_bool):
                        store("rstv_is_portrait", false);
                        store("rstv_is_landscape", true);
                        break;
                }

                break;

            default:
                //portrait
                ort_final_str = 'portrait';

                //do not alter cached orientation variables if bypass_cache_bool is true
                switch(true)
                {
                    case (!bypass_cache_bool):
                        store("rstv_is_portrait", true);
                        store("rstv_is_landscape", false);
                        break;
                }
        }

        return ort_final_str;
    }

    /**
     * Resets/Updates the cached values (localStorage) of Orientation Info
     * @private
     */
    function _updateOrientationStore()
    {
        //reset
        store("rstv_ort_curr rstv_is_portrait rstv_is_landscape", null);

        //reload
        store("rstv_ort_curr", getOrientation());
    }

    /**
     * Checks if the device is currently in Portrait mode
     * @return {Boolean}
     */
    function isPortrait()
    {
        //check if portrait orientation value is stored. If so, return stored value
        switch(true)
        {
            case (isStorageValueSet("rstv_is_portrait")):
                return store("rstv_is_portrait");
                break;
        }
        return !!((getOrientation() == 'portrait'));
    }

    /**
     * Checks if the device is currently in Landscape mode
     * @return {Boolean}
     */
    function isLandscape()
    {
        //check if landscape orientation value is stored. If so, return stored value
        switch(true)
        {
            case (isStorageValueSet("rstv_is_landscape")):
                return store("rstv_is_landscape");
                break;
        }
        return !!((getOrientation() == 'landscape'));
    }

    /**
     * Gets the Standard Display Resolution of the given device
     * @return {String}
     */
    function getResolution()
    {
        var is_landscape_bool = isLandscape(),
            screen_w = screenW(),
            screen_h = screenH(),
            std_w_arr = (is_landscape_bool) ? _getResolutionDimensionList('h') :_getResolutionDimensionList('w'),
            std_h_arr = (is_landscape_bool) ? _getResolutionDimensionList('w'): _getResolutionDimensionList('h'),
            screen_w_std = getClosestNumberMatchArray(std_w_arr, screen_w),
            screen_h_std = getClosestNumberMatchArray(std_h_arr, screen_h),
            screen_res_str,
            screen_res_matrix_arr = _getResolutionMatrix(),
            screen_res_name_str
            ;

        switch(true)
        {
            case (screen_w_std >= screen_h_std):
                screen_res_str = screen_h_std+'_'+screen_w_std;
                break;

            default:
                screen_res_str = screen_w_std+'_'+screen_h_std;
        }

        screen_res_name_str = array_search(screen_res_str, screen_res_matrix_arr);

        return screen_res_name_str;
    }

    /**
     * Composes and Saves a List of Standard Graphic Resolutions
     * @return {Array}
     * @private
     */
    function _getResolutionList()
    {
        //Check if Resolution List is Stored
        switch(true)
        {
            case (isStorageValueSet("rstv_is_cache_res_list")):
                return store("rstv_cache_res_list");
                break;
        }

        var $res_arr = [
            'qqvga', 'qqvgax1', 'hqvga', 'hqvgax1', 'hqvgax2', 'hvgax1', 'qvga', 'wqvga', 'wqvga1', 'hvga',
            'hvga1', 'hvga2', 'hvga3', 'hvgax1', 'hvgax2', 'vga', 'wvga', 'wvgax1', 'fwvga', 'svga',
            'dvga', 'dvgax1', 'wsvga', 'wsvga1', 'xga', 'wxga', 'wxga1', 'wxga2', 'wxga3', 'wxga4', 'wxga5',
            'xga+', 'wxga+', 'sxga', 'sxga+', 'wsxga+', 'uxga', 'wuxga', 'qwxga', 'qxga', 'wqxga',
            'qsxga', 'wqsxga', 'quxga', 'wquxga', 'hxga', 'whxga', 'hsxga', 'whsxga', 'huxga', 'whuxga',
            'nhd', 'nhdx1', 'qhd', 'hd', '720p', 'fhd', '1080p', '1080i', 'wqhd', 'mbprhd', '4kuhd', '8kuhd'
        ];

        store("rstv_is_cache_res_list", true);
        store("rstv_cache_res_list", $res_arr);
        return $res_arr;
    }

    /**
     * Composes and Saves a Resolution Matrix (Resolution to Dimensions)
     * @return {Array|Object}
     * @private
     */
    function _getResolutionMatrix()
    {
        //Check if Resolution Matrix is Stored
        switch(true)
        {
            case (isStorageValueSet("rstv_is_cache_res_matrix")):
                return store("rstv_cache_res_matrix");
                break;
        }

        var $res_matrix_arr = {
            'qqvga': '120_160', 'qqvgax1': '128_160', 'hqvga': '160_240', 'hqvgax1': '240_240', 'hqvgax2': '240_260',
            'qvga': '240_320', 'wqvga': '240_400', 'wqvga1': '240_432', 'hvga': '320_480',
            'hvga1': '360_480', 'hvga2': '272_480', 'hvga3': '240_640', 'hvgax1': '200_640', 'hvgax2': '300_640',
            'hvgax3': '360_400',
            'vga': '480_640', 'wvga': '480_800', 'wvgax1': '352_800', 'fwvga': '480_854', 'svga': '600_800',
            'dvga': '640_960', 'dvgax1': '640_1136', 'wsvga': '576_1024', 'wsvga1': '600_1024', 'xga': '768_1024',
            'wxga': '768_1280', 'wxga1': '720_1280', 'wxga2': '800_1280', 'wxga3': '768_1360', 'wxga4': '768_1366',
            'wxga5': '720_720',
            'xga+': '864_1152', 'wxga+': '900_1440', 'sxga': '1024_1280', 'sxga+': '1050_1400', 'wsxga+': '1050_1680',
            'uxga': '1200_1600', 'wuxga': '1200_1920', 'qwxga': '1152_2048', 'qxga': '1536_2048', 'wqxga': '1600_2560',
            'wqxga+': '1800_3200',
            'qsxga': '2048_2560', 'wqsxga': '2048_3200', 'quxga': '2400_3200', 'wquxga': '2400_3840', 'hxga': '3072_4096',
            'whxga': '3200_5120', 'hsxga': '4096_5120', 'whsxga': '4096_6400', 'huxga': '4800_6400', 'whuxga': '4800_7680',
            'nhd': '360_640', 'nhdx1': '320_640', 'qhd': '540_960', 'hd': '720_1280', '720p': '720_1280', 'fhd': '1080_1920',
            '1080p': '1080_1920', '1080i': '1080_1920', 'wqhd': '1440_2560', 'mbprhd': '1800_2880', '4kuhd': '2160_3840',
            '8kuhd': '4320_7680'
        };

        store("rstv_is_cache_res_matrix", true);
        store("rstv_cache_res_matrix", $res_matrix_arr);
        return $res_matrix_arr;
    }

    /**
     * Converts various types of breakpoints into pixel breakpoints
     * It converts 'Device' and 'Resolution' breakpoints
     * @param bp_arr {Array} The breakpoints you define
     * @param bp_class_arr {Array} The names of CSS classes paired with breakpoints
     * @return {Array}
     * @private
     */
    function _toViewportBreakpoints(bp_arr, bp_class_arr)
    {
        try{
            //Create local variables
            var bp_attrib_arr = [],
                list_dev_arr,
                list_res_arr,
                matrix_dev_arr,
                matrix_res_arr,
                ort_marker_str = '',
                ort_marker_key_str = '',
                error_marker_str = '',
                bp_temp_w_arr = [],
                bp_item_w_temp_int = '',
                bp_temp_h_arr = [],
                bp_item_h_temp_int = '',
                bp_temp_type_arr = [],
                bp_ort_marker_temp_arr = [],
                bp_final_arr = [],
                bp_item_temp_str,
                bp_item_res_temp_str,
                bp_item_final_str,
                bp_item_v_temp_str,
                bp_item_v_temp_arr = [],
                is_class_def_bool = false,
                is_attrib_def_bool = false;

            //Create variables for counter functionality
            var counter_int = 0,
                counter_alpha_str = '',
                counter_alpha_arr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p',
                    'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'aa', 'ab', 'ac', 'ad', 'ae', 'af', 'ag', 'ah', 'ai',
                    'aj', 'ak', 'al', 'am', 'an', 'ao', 'ap', 'aq', 'ar', 'as', 'at', 'au', 'av', 'aw', 'ax'
                ],
                counter_alpha_pre_arr = [],
                counter_alpha_post_arr = [],
                bp_arr_count_int = count(bp_arr),
                bp_class_arr_count_int = count(bp_class_arr),
                bp_attrib_arr_count_int = count(bp_attrib_arr),
                bp_item_w_temp_final_int,
                bp_item_h_temp_final_int;

            //check that value in argument is array and is not empty
            switch(true)
            {
                case (!isArray(bp_arr)):
                    throw new Error ("The first argument must be an array!");
                    break;

                case (isArray(bp_arr) && bp_arr_count_int == 0):
                    throw new Error ("The first argument must not be empty!");
                    break;
            }

            //Check that only either classes or attributes are defined
            switch(true)
            {
                case ((bp_class_arr_count_int > 0) && (bp_attrib_arr_count_int > 0)):
                    throw new Error("You can only define either 'Classes' or 'Attributes' settings!");
                    break;
            }

            //If classes are defined, ensure they correspond with the number of breakpoints defined
            switch(true)
            {
                case (bp_class_arr_count_int > 0):
                    //classes are defined
                    is_class_def_bool = true;
                    switch(true)
                    {
                        case (bp_class_arr_count_int !== bp_arr_count_int):
                            throw new Error ("The number items for 'Breakpoints' and 'Classes' settings must match");
                            break;
                    }
                    break;
            }

            //If attributes are defined, ensure they correspond with the number of breakpoints defined
            switch(true)
            {
                case (bp_attrib_arr_count_int > 0):
                    //attributes are defined
                    is_attrib_def_bool = true;
                    switch(true)
                    {
                        case (bp_attrib_arr_count_int !== bp_arr_count_int):
                            throw new Error ("The number items for 'Breakpoints' and 'Attributes' settings must match");
                            break;
                    }
                    break;
            }

            //Get Breakpoint Reference Data
            list_res_arr = _getResolutionList();
            matrix_res_arr = _getResolutionMatrix();

            //iterate over the breakpoints provided
            for(var i = 0; i < bp_arr_count_int; i++)
            {
                bp_item_temp_str = bp_arr[i];

                counter_alpha_str = counter_alpha_arr[i];

                //ensure that the orientation markers are valid i.e. only -p and -l if any
                switch(true)
                {
                    case (/-+/i.test(bp_item_temp_str) && !/^[^-]*-[^-]*$/i.test(bp_item_temp_str)):
                        //error in the way orientation markers are defined
                        error_marker_str += '2';
                        break;
                }

                //find out if there are any resolution markers e.g. -l or -p
                ort_marker_str = '';
                ort_marker_key_str = '';
                switch(true)
                {
                    case (substr_count(bp_item_temp_str, '-p') > 0):
                        ort_marker_str = 'p';
                        ort_marker_key_str = '-p';

                        bp_ort_marker_temp_arr.push('p');
                        break;

                    case (substr_count(bp_item_temp_str, '-l') > 0):
                        ort_marker_str = 'l';
                        ort_marker_key_str = '-l';

                        bp_ort_marker_temp_arr.push('l');
                        break;

                    default:
                        bp_ort_marker_temp_arr.push('x');
                }

                //reset the breakpoint i.e. remove any resolution markers
                bp_item_final_str = bp_item_temp_str.replace(''+ort_marker_key_str+'', '');

                //find out which class of breakpoint i.e. viewport, device, or resolution
                switch(true)
                {
                    case (in_array(bp_item_final_str, list_res_arr)):
                        //is resolution breakpoint. Get viewport dimensions
                        bp_item_v_temp_str = matrix_res_arr[''+bp_item_final_str+''];

                        bp_item_v_temp_arr = arrayToInteger(explode('_', bp_item_v_temp_str));

                        bp_item_w_temp_int = parseInt(bp_item_v_temp_arr[0]);
                        bp_item_h_temp_int = parseInt(bp_item_v_temp_arr[1]);

                        //consider landscape orientation markers
                        bp_item_w_temp_final_int = bp_item_w_temp_int;
                        bp_item_h_temp_final_int = bp_item_h_temp_int;
                        switch(true)
                        {
                            case (ort_marker_str == 'l'):
                                bp_item_w_temp_final_int = bp_item_h_temp_int;
                                bp_item_h_temp_final_int = bp_item_w_temp_int;
                                break;
                        }

                        bp_temp_w_arr[counter_alpha_str] = bp_item_w_temp_final_int;
                        bp_temp_h_arr[counter_alpha_str] = bp_item_h_temp_final_int;

                        //set breakpoint type as resolution
                        bp_temp_type_arr.push('r');

                        break;

                    case (/[0-9]+/i.test(bp_item_final_str)):
                        //is viewport breakpoint
                        bp_temp_w_arr[counter_alpha_str] = parseInt(bp_item_final_str);
                        bp_temp_h_arr[counter_alpha_str] = parseInt(bp_item_final_str);

                        //set breakpoint type as viewport
                        bp_temp_type_arr.push('v');
                        break;

                    default:
                        //mark error
                        error_marker_str += '1';
                }

                counter_alpha_pre_arr.push(counter_alpha_str);

                counter_int++;
            }

            //check if there are any errors. If yes, throw error
            switch(true)
            {
                case (/[1]+/i.test(error_marker_str)):
                    throw new Error("There are errors in your 'Breakpoints' settings!");
                    break;

                case (/[2]+/i.test(error_marker_str)):
                    throw new Error("There are errors in your 'Breakpoints' settings with regard to the way you have defined orientation markers e.g. -p or -l!");
                    break;
            }

            //compose breakpoints
            var cmp = function ($a, $b) {
                if ($a == $b) {
                    return 0;
                }
                return ($a < $b) ? -1 : 1;
            };

            var bp_temp_w_sort_arr = [],
                bp_temp_h_sort_arr = [],
                bp_temp_w_sort_int,
                bp_temp_w_sort_juxta_key_int,
                bp_type_arr = [],
                bp_temp_ort_sort_arr = [],
                bp_temp_class_arr = [],
                bp_temp_pre_attrib_arr = [],
                bp_temp_attrib_arr = [];

            //reformat attribute array
            bp_temp_pre_attrib_arr = bp_attrib_arr;

            //sort viewport width breakpoints
            bp_temp_w_sort_arr = uasort(bp_temp_w_arr, cmp);

            //sort other arrays in an identical fashion to viewport width breakpoints
            counter_alpha_post_arr = array_keys(bp_temp_w_sort_arr);

            var bp_temp_w_sort_arr_size_int = count(bp_temp_w_sort_arr);
            for(var i = 0; i < bp_temp_w_sort_arr_size_int; i++)
            {
                bp_temp_w_sort_int = counter_alpha_post_arr[i];
                bp_temp_w_sort_juxta_key_int = array_search(bp_temp_w_sort_int, counter_alpha_pre_arr);

                //sort breakpoint heights array
                bp_temp_h_sort_arr[bp_temp_w_sort_int] = bp_temp_h_arr[bp_temp_w_sort_int];

                //sort breakpoint type array
                bp_type_arr[i] = bp_temp_type_arr[bp_temp_w_sort_juxta_key_int];

                //sort the orientation marker array
                bp_temp_ort_sort_arr[i] = bp_ort_marker_temp_arr[bp_temp_w_sort_juxta_key_int];

                //sort the classes array
                bp_temp_class_arr[i] = bp_class_arr[bp_temp_w_sort_juxta_key_int];

                //sort the attributes array
                bp_temp_attrib_arr[i] = bp_temp_pre_attrib_arr[bp_temp_w_sort_juxta_key_int];
            }

            //Save Primary Results Data to Array
            bp_final_arr["bp_w"] = implode('|', bp_temp_w_sort_arr);                //width
            bp_final_arr["bp_h"] = implode('|', bp_temp_h_sort_arr);                //height
            bp_final_arr["bp_o"] = implode('|', bp_temp_ort_sort_arr);              //orientation
            bp_final_arr["bp_t"] = implode('|', bp_type_arr);                       //type

            //add data for classes if defined
            switch(true)
            {
                case (is_class_def_bool):
                    var c_str = implode('|', bp_temp_class_arr);
                    bp_final_arr["bp_c"] = c_str;                   //classes
                    break;
            }

            //add data for attributes if defined
            switch(true)
            {
                case (is_attrib_def_bool):
                    var a_str = implode('|', bp_temp_attrib_arr);
                    bp_final_arr["bp_a"] = a_str;                   //attributes
                    break;
            }

            return bp_final_arr;
        }
        catch(e){
            var e_msg_str = "There was an error: "+ e.message;
            alert(e_msg_str);
        }
    }

    /**
     * Wrapper class for _toViewportBreakpoints
     * @param bp_arr {Array} The list of breakpoints
     * @param bp_class_arr {Array} The corresponding list of classes
     * @return {Array}
     */
    function getBreakpoints(bp_arr, bp_class_arr)
    {
        var data_arr = [];
        data_arr = _toViewportBreakpoints(bp_arr, bp_class_arr);

        return data_arr;
    }

    /**
     * Monitors the viewport for size and orientation changes
     */
    function viewportMonitor()
    {
        var myArgs = Array.prototype.slice.call(arguments),
            trigger_suffix_str = (isNumber(myArgs[0])) ? "_"+myArgs[0]: "";

        var viewport_monit_fn = function(){

            //get viewport info before they are reset in storage
            var viewport_w_prev_int = store("rstv_viewportW"),
                viewport_h_prev_int = store("rstv_viewportH");

            //re-initialize dimension variables
            _initDimensionVars();

            //get current and active and define local variables
            var is_mobile_bool = isMobile(),
                ort_active_str = getOrientation(true),
                ort_curr_str = store("rstv_ort_curr"),
                viewport_w_curr_int,
                viewport_h_curr_int,
                viewport_w_diff_int,
                viewport_w_diff_abs_int,
                viewport_w_diff_pc_int,
                viewport_h_diff_int,
                viewport_h_diff_abs_int,
                viewport_h_diff_pc_int,
                is_softkey_bool = false;

            //Update stored values for dimensions
            _updateDimensionStore();

            /**
             * Perform soft keyboard check
             * This manages for mobile devices that resize the viewport when the soft keyboard is initialized
             * This scenario will sometimes result in a pseudo-orientation change which is unwanted
             */
            switch(true)
            {
                case (is_mobile_bool):
                    viewport_w_curr_int = store("rstv_viewportW");
                    viewport_h_curr_int = store("rstv_viewportH");
                    viewport_w_diff_int = viewport_w_curr_int-viewport_w_prev_int;
                    viewport_h_diff_int = viewport_h_curr_int-viewport_h_prev_int;
                    viewport_w_diff_abs_int = Math.abs(viewport_w_diff_int);
                    viewport_h_diff_abs_int = Math.abs(viewport_h_diff_int);

                    //get the percentage changes in viewport width and height
                    viewport_w_diff_pc_int = (viewport_w_diff_abs_int/viewport_w_prev_int)*100;
                    viewport_h_diff_pc_int = (viewport_h_diff_abs_int/viewport_h_prev_int)*100;

                    switch(true)
                    {
                        case (viewport_w_diff_pc_int < 1):
                            switch(true)
                            {
                                case (viewport_h_diff_pc_int > 35 && viewport_h_diff_int < 0):
                                    //soft keyboard is opening
                                    is_softkey_bool = true;
                                    break;

                                case (viewport_h_diff_pc_int > 35 && viewport_h_diff_int > 0):
                                    //Soft keyboard closing - start
                                    is_softkey_bool = true;
                                    break;

                                case (viewport_h_diff_pc_int > 12 && viewport_h_diff_pc_int <= 35 && viewport_h_diff_int > 0):
                                    //Soft keyboard closing - end
                                    is_softkey_bool = true;
                                    break;

                                case (viewport_h_diff_pc_int == 0):
                                    //No movement - possible Soft keyboard action
                                    is_softkey_bool = true;
                                    break;
                            }
                            break;
                    }
                    break;
            }

            /**
             * Trigger events only if soft keyboard action is not detected
             */
            switch(true)
            {
                case (!is_softkey_bool):
                    switch(true)
                    {
                        case ((ort_curr_str !== ort_active_str)):
                            //orientation has changed. Update stored values for dimensions and orientation
                            _updateOrientationStore();

                            $(window).trigger("change_orientation"+trigger_suffix_str);
                            break;

                        default:
                            /**
                             * Fire resize only for devices that are non-mobile
                             * This eliminates resize callback functionality for mobile devices
                             */
                            switch(true)
                            {
                                case (!is_mobile_bool):
                                    $(window).trigger("resize_viewport"+trigger_suffix_str);
                                    break;
                            }
                    }
                    break;
            }
        };
        resize(viewport_monit_fn);
    }

    /**
     * Monitors a DOM element/container for size changes
     */
    function containerMonitor(elem)
    {
        var myArgs = Array.prototype.slice.call(arguments),
            trigger_suffix_str = (isNumber(myArgs[1])) ? "_"+myArgs[1]: ""
            ;

        var container_monit_fn = function(){
            $(window).trigger("resize_container"+trigger_suffix_str);
        };
        resizeContainer(elem, container_monit_fn);
    }

    /**
     * Attach an event handler for the resize event
     * @param {Function} fn The function to execute
     * @return object
     */
    function resize(fn)
    {
        $win.on('resize', fn);
        return Restive;
    }

    /**
     * Attach an event handler for the resizecontainer event
     * @param {Function} fn The function to execute
     * @return object
     */
    function resizeContainer(el, fn)
    {
        el.on('resizecontainer', fn);
        return Restive;
    }

    //Define Restive Object
    Restive = {
        init: init(),
        reInit: reInit,
        getUserAgent: getUserAgent,
        isStorageValueSet: isStorageValueSet,
        store: store,
        storeVarTracker: storeVarTracker,
        storeVarValidator: storeVarValidator,
        incrementStorageValue: incrementStorageValue,
        getBreakpoints: getBreakpoints,
        viewportW: viewportW,
        viewportH: viewportH,
        screenW: screenW,
        screenH: screenH,
        pixelW: pixelW,
        pixelH: pixelH,
        vSpan: vSpan,
        vPitch: vPitch,
        dSpan: dSpan,
        dPitch: dPitch,
        cSpan: cSpan,
        cPitch: cPitch,
        eSpan: eSpan,
        ePitch: ePitch,
        isRetina: isRetina,
        getPixelRatio: getPixelRatio,
        getPlatform: getPlatform,
        getFormFactor: getFormFactor,
        getOrientation: getOrientation,
        getResolution: getResolution,
        isPortrait: isPortrait,
        isLandscape: isLandscape,
        viewportMonitor: viewportMonitor,
        containerMonitor: containerMonitor,
        isMobile: isMobile,
        isNonMobile: isNonMobile,
        isPhone: isPhone,
        isTablet: isTablet,
        isPC: isPC,
        isTV: isTV,
        isIOS: isIOS,
        isApple: isApple,
        isAndroid: isAndroid,
        isSymbian: isSymbian,
        isBlackberry: isBlackberry,
        isWindows: isWindows,
        isWindowsPhone: isWindowsPhone,
        resize: resize,
        resizeContainer: resizeContainer
    };
    return Restive;

})(window, document, jQuery);

/*
 * Restive.JS Plugin v1.3.3
 * http://restivejs.com
 *
 * Copyright 2013 Obinwanne Hill <https://about.me/obinwanne.hill>
 * Released under MIT License
 */
(function (window, document, $, undefined) {
    //Gets the content of a function
    Function.prototype.getFuncBody = function()
    {
        // Get content between first { and last }
        var m = this.toString().match(/\{([\s\S]*)\}/m)[1];
        // Strip comments
        return m.replace(/^\s*\/\/.*$/mg,'');
    };

    var methods = {
		init : function(options){

			try{

                //Multiple Constructor Manager
                methods._multiConstructorCounter();
                methods._multiConstructorManager();

                //Create plugin variables
                var $options = options,
                    $valid_platform_arr = ['all', 'ios', 'android', 'symbian', 'blackberry', 'windows'],
                    $valid_formfactor_arr = ['all', 'pc', 'tv', 'tablet', 'phone'],
                    $platform_init_str = options.platform,
                    $formfactor_init_str = options.formfactor,
                    responsive_basis_str,
                    is_resp_basis_container_bool,
                    is_multi_start_bool = Restive.store("rstv_multi_start"),
                    rstv_store_multi_counter_int = Restive.store("rstv_multi_count"),
                    is_multi_abort_2_bool = Restive.store("rstv_multi_abort_2");

                //Ensure Platform Values are within range
				switch(true)
				{
					case(in_array($platform_init_str, $valid_platform_arr) === false):
						methods._error('rstv_error_001', '"'+$platform_init_str+'" is not a valid Platform option!');
                        return false;
					    break;
				}

                //Ensure Form Factor Values are within range
                switch(true)
                {
                    case(in_array($formfactor_init_str, $valid_formfactor_arr) === false):
                        methods._error('rstv_error_002', '"'+$formfactor_init_str+'" is not a valid Form Factor option!');
                        return false;
                        break;
                }

                //Abort if endMulti() is not called after startMulti() with multiple constructors
                switch(true)
                {
                    case (is_multi_abort_2_bool):
                        methods._error('rstv_error_003', 'If you are calling the Restive.JS Constructor more than once, you must call $.restive.endMulti() at the end!');
                        return false;
                        break;
                }

                //Get Initial Breakpoints
				var $breakpoints_arr = [],
                    $breakpoints_init_arr = [],
                    $classes_init_arr = [];

                $breakpoints_init_arr = options.breakpoints;
                $classes_init_arr = options.classes;

                $breakpoints_arr = methods.getBreakpoints($breakpoints_init_arr, $classes_init_arr);

                /**
                 * Generate Restive Core Information
                 */
                var $rstv_core_info_arr = [];

                //A1. Get the Device Platform e.g. iOS, Android, etc.
                $rstv_core_info_arr["platform"] = methods.getPlatform();

                //A2. Get the Device Form Factor
                $rstv_core_info_arr["formfactor"] = methods.getFormFactor();

                //A3. Check if Device is a mobile device
                $rstv_core_info_arr["is_mobile"] = methods.isMobile();

                //A4. Get the Device Pixel Ratio
                $rstv_core_info_arr["pixelratio"] = methods.getPixelRatio();

                //A5. Get the Orientation and Set Orientation Marker
                $rstv_core_info_arr["orientation"] = methods.getOrientation();

                //A6. Get the Selector of the Element
                $rstv_core_info_arr["selector"] = getSelector(this);

                //A7. Get the Tag Name of the Element
                $rstv_core_info_arr["tagname"] = this.prop("tagName").toLowerCase();

                //Get the Basis for Responsiveness
                responsive_basis_str = methods._responsiveBasis($options, $rstv_core_info_arr);
                is_resp_basis_container_bool = !!((responsive_basis_str == 'c'));

                //Add Responsive Basis Indicator to Device Core Info
                $rstv_core_info_arr["is_resp_basis_container"] = is_resp_basis_container_bool;

                //Set Event Handlers and Callbacks according to Responsive Basis
                switch(true)
                {
                    case (is_resp_basis_container_bool):
                        methods._containerMonitor($breakpoints_arr, this, $options, $rstv_core_info_arr);
                        break;

                    default:
                        switch(true)
                        {
                            case (!is_multi_start_bool):
                                methods._viewportMonitor($breakpoints_arr, this, $options, $rstv_core_info_arr);
                                methods._callbackManager($options, ['ready', 'init']);
                                break;

                            default:
                                //Store some variables required for later use
                                window.parent.rstv_store.main["rstv_breakpoints_"+rstv_store_multi_counter_int] = $breakpoints_arr;
                                window.parent.rstv_store.main["rstv_this_"+rstv_store_multi_counter_int] = this;
                                window.parent.rstv_store.main["rstv_options_"+rstv_store_multi_counter_int] = $options;
                                window.parent.rstv_store.main["rstv_core_info_"+rstv_store_multi_counter_int] = $rstv_core_info_arr;

                                window.rstv_store.main = window.parent.rstv_store.main;
                        }
                }

                //reset turbo_classes_reflow sessionStorage variable
                Restive.store("rstv_turbo_classes_reflow_status_in", null);

                /**
                 * Manage Breakpoints
                 */
                return this.each(function(){
					var $this = $(this);
                    methods.setBreakpoints($breakpoints_arr, $this, $options, $rstv_core_info_arr);
				});
			}
			catch(e){
				alert(e);
			    console.log(e)/*RemoveLogging:skip*/;
			}
		},
        _error: function(code, message){
            var error_msg_is_init_bool = !!((String(Restive.store(code+"_init")).toLowerCase() === "true"));
            switch(true)
            {
                case (!error_msg_is_init_bool):
                    Restive.store(code+"_init", true);
                    throw new Error(message);
                    break;
            }
        },
        _callbackManager: function(){

            var myArgs = Array.prototype.slice.call(arguments),
                options = myArgs[0],
                callback_type_arr = myArgs[1],
                $on_func,
                $on_func_body_count
                ;

            //Execute onReady
            switch(true)
            {
                case (in_array('ready', callback_type_arr)):
                    var $on_ready = options.onReady,
                        $on_ready_body_count = options.onReady.getFuncBody().length;
                    switch(true)
                    {
                        case ($.isFunction($on_ready) && ($on_ready_body_count > 0)):
                            //Execute Callback
                            $on_ready();
                            break;
                    }
                break;
            }

            //Resize Callbacks
            switch(true)
            {
                case (in_array('resize', callback_type_arr)):
                    var $on_resize = options.onResize,
                        $on_resize_body_count = options.onResize.getFuncBody().length;
                    switch(true)
                    {
                        case ($.isFunction($on_resize) && ($on_resize_body_count > 0)):
                            //Execute Callback
                            $on_resize();
                            break;
                    }
                    break;
            }

            //PC Force Reflow Callbacks
            switch(true)
            {
                case (in_array('turboclassesreflow', callback_type_arr)):
                    var $reflow_direction_str = callback_type_arr[1],
                        $on_reflow = options.onTurboClassReflow,
                        $on_reflow_body_count = options.onTurboClassReflow.getFuncBody().length;
                    switch(true)
                    {
                        case ($.isFunction($on_reflow) && ($on_reflow_body_count > 0)):
                            //Execute Callback
                            $on_reflow();
                            break;
                    }

                    var $on_reflow_in = options.onTurboClassReflowIn,
                        $on_reflow_in_body_count = options.onTurboClassReflowIn.getFuncBody().length;
                    switch(true)
                    {
                        case ($.isFunction($on_reflow_in) && ($on_reflow_in_body_count > 0)):
                            //Execute Callback
                            switch(true)
                            {
                                case ($reflow_direction_str == 'in'):
                                    $on_reflow_in();
                                    break;
                            }
                            break;
                    }

                    var $on_reflow_out = options.onTurboClassReflowOut,
                        $on_reflow_out_body_count = options.onTurboClassReflowOut.getFuncBody().length;
                    switch(true)
                    {
                        case ($.isFunction($on_reflow_out) && ($on_reflow_out_body_count > 0)):
                            //Execute Callback
                            switch(true)
                            {
                                case ($reflow_direction_str == 'out'):
                                    $on_reflow_out();
                                    break;
                            }
                            break;
                    }

                    break;
            }

            //Rotate/Orientation Callbacks
            switch(true)
            {
                case (in_array('rotate', callback_type_arr)):
                    var ort_curr_str = Restive.getOrientation(),
                        $on_rotate = options.onRotate,
                        $on_rotate_body_count = options.onRotate.getFuncBody().length;
                    switch(true)
                    {
                        case ($.isFunction($on_rotate) && ($on_rotate_body_count > 0)):
                            //Execute Callback
                            $on_rotate();
                            break;
                    }

                    //Execute onRotateToP
                    var $on_rotate_to_p = options.onRotateToP,
                        $on_rotate_to_p_body_count = options.onRotateToP.getFuncBody().length;
                    switch(true)
                    {
                        case ($.isFunction($on_rotate_to_p) && ($on_rotate_to_p_body_count > 0)):
                            //Execute Callback
                            switch(true)
                            {
                                case (ort_curr_str == 'portrait'):
                                    $on_rotate_to_p();
                                    break;
                            }
                            break;
                    }

                    //Execute onRotateToL
                    var $on_rotate_to_l = options.onRotateToL,
                        $on_rotate_to_l_body_count = options.onRotateToL.getFuncBody().length;
                    switch(true)
                    {
                        case ($.isFunction($on_rotate_to_l) && ($on_rotate_to_l_body_count > 0)):
                            //Execute Callback
                            switch(true)
                            {
                                case (ort_curr_str == 'landscape'):
                                    $on_rotate_to_l();
                                    break;
                            }
                            break;
                    }
                    break;
            }

            //Add/Remove Class Callbacks
            switch(true)
            {
                case (in_array('addclass', callback_type_arr) || in_array('removeclass', callback_type_arr)):
                    var $callback_type_str = callback_type_arr[0],
                        $callback_type_args = callback_type_arr[1],
                        $callback_data_arr = {'addclass': 'onAddClass', 'removeclass': 'onRemoveClass'}
                        ;
                    $on_func = options[$callback_data_arr[''+$callback_type_str+'']];
                    $on_func_body_count = $on_func.getFuncBody().length;

                    switch(true)
                    {
                        case ($.isFunction($on_func) && ($on_func_body_count > 0)):
                            //Execute Callback
                            $on_func($callback_type_args);
                            break;
                    }
                    break;
            }

            //Initialization Callbacks
            switch(true)
            {
                case (in_array('init', callback_type_arr)):
                    switch(true)
                    {
                        case (in_array('init', callback_type_arr)):
                            var callback_name_arr = [
                                'onPortrait', 'onLandscape', 'onRetina', 'onPhone', 'onTablet', 'onPC', 'onTV', 'onIOS', 'onAndroid', 'onSymbian', 'onBlackberry', 'onWindows', 'onWindowsPhone', 'onMobile', 'onNonMobile'
                            ],
                                func_name_arr = [
                                'isPortrait', 'isLandscape', 'isRetina', 'isPhone', 'isTablet', 'isPC', 'isTV', 'isIOS', 'isAndroid', 'isSymbian', 'isBlackberry', 'isWindows', 'isWindowsPhone', 'isMobile', 'isNonMobile'
                            ];

                            for(var i = 0; i < count(func_name_arr); i++)
                            {
                                $on_func = options[callback_name_arr[i]];
                                $on_func_body_count = $on_func.getFuncBody().length;

                                switch(true)
                                {
                                    case ($.isFunction($on_func) && ($on_func_body_count > 0)):
                                        var $on_func_res = methods[func_name_arr[i]],
                                            $on_func_bool = $on_func_res();
                                        switch(true)
                                        {
                                            case ($on_func_bool):
                                                $on_func();
                                                break;
                                        }
                                        break;
                                }
                            }
                            break;
                    }
                    break;
            }
        },
        _URLMonitor: function(){
            //monitor changes from URL to URL
            var $rstv_url_str = Restive.store("rstv_url"),
                $rstv_url_hash_prev_str = Restive.store("rstv_url_hash"),
                $rstv_url_hash_curr_str = md5($rstv_url_str);

            switch(true)
            {
                case ($rstv_url_hash_curr_str != $rstv_url_hash_prev_str):
                    //page has changed
                    Restive.store("rstv_multi_bpm_idx rstv_cache_bpm rstv_cache_bpm_lock rstv_cache_req rstv_cache_bpm_viewport_diff", null);

                    Restive.store("rstv_url_hash", $rstv_url_hash_curr_str);
                    break;
            }
        },
        _responsiveBasis: function($options, $rstv_core_info){
            /**
             * This determines the basis for responsive i.e. viewport or container
             * 1. If anchor option is 'element' and Restive.JS selector is under the body tag, basis is 'container' or 'c'
             * 2. If not 1, basis is 'viewport' or 'v'
             */
            var resp_basis_str,
                selector_name_str = $rstv_core_info["selector"],
                elem_is_id_selector_bool = /^#[^\s]+$/i.test(selector_name_str),
                elem_is_child_of_body_bool = elementIsChildOf('body', selector_name_str),
                anchor_str = $options.anchor
                ;

            try
            {
                switch(true)
                {
                    case (elem_is_child_of_body_bool && (anchor_str == 'element' || anchor_str == 'e')):
                        switch(true)
                        {
                            case (!elem_is_id_selector_bool):
                                throw new Error("You must use only the JQuery ID selector when the 'anchor' option is set to 'e' or 'element'!");
                                break;
                        }
                        resp_basis_str = 'c';
                        break;

                    default:
                        resp_basis_str = 'v';
                        /**
                         * This indicates that at least one Restive.JS constructor has a Responsive Basis of 'viewport'
                         * NOTE: It is ultimately used to prevent the viewport and callback manager from being activated if all Restive.JS constructors are determined to have a 'container' responsiveness basis
                         */
                        Restive.store("rstv_resp_basis_viewport_init", true);
                }

                return resp_basis_str;
            }
            catch(e){
                alert(e);
                console.log(e);/*RemoveLogging:skip*/
            }
        },
        _viewportMonitor: function($bp_arr, $this, $options, $rstv_core_info){
            //set event handler for resize
            var event_name_resize_str = "resize_viewport",
                event_name_ort_str = "change_orientation";

            //set event handler for viewport resize
            $(window).on(event_name_resize_str, function(){
                methods._onResizeViewport($bp_arr, $this, $options, $rstv_core_info);
            });

            //set event handler for orientation change
            $(window).on(event_name_ort_str, function(){
                methods._onChangeOrientation($bp_arr, $this, $options, $rstv_core_info);
            });

            //activate Viewport Monitor
            Restive.viewportMonitor();
        },
        _containerMonitor: function($bp_arr, $this, $options, $rstv_core_info){
            var event_name_resize_container_str = "resizecontainer"
                ;

            //set event handler for container resize
            $this.on(event_name_resize_container_str, function(){
                methods._onResizeContainer($bp_arr, $this, $options, $rstv_core_info);
            });
        },
        _onResizeViewport: function($bp_arr, $this, $options, $rstv_core_info){
            try{
                return $this.each(function(){
                    var $_this = $(this)
                        ;
                    methods.setBreakpoints($bp_arr, $_this, $options, $rstv_core_info, 'rv');

                    //call resize callbacks
                    methods._callbackManager($options, ['resize']);
                });
            }
            catch(e){
                alert(e);
                console.log(e);/*RemoveLogging:skip*/
            }
        },
        _onResizeContainer: function($bp_arr, $this, $options, $rstv_core_info){
            try{
                return $this.each(function(){
                    var $_this = $(this)
                        ;
                    methods.setBreakpoints($bp_arr, $_this, $options, $rstv_core_info, 'rc');
                });
            }
            catch(e){
                alert(e);
                console.log(e);/*RemoveLogging:skip*/
            }
        },
        _onChangeOrientation: function($bp_arr, $this, $options, $rstv_core_info){
            try{
                return $this.each(function(){
                    var $_this = $(this);
                    methods.setBreakpoints($bp_arr, $_this, $options, $rstv_core_info, 'co');

                    //call orientation callbacks
                    methods._callbackManager($options, ['rotate']);
                });
            }
            catch(e){
                alert(e);
                console.log(e);/*RemoveLogging:skip*/
            }
        },
        getBreakpoints: function(bp_arr, bp_class_arr){
            return Restive.getBreakpoints(bp_arr, bp_class_arr);
        },
        setBreakpoints: function(){

            var myArgs = Array.prototype.slice.call(arguments);
            var bp_arr = myArgs[0],
                elem = myArgs[1],
                rstv_options = myArgs[2],
                rstv_core_info = myArgs[3],
                rstv_event_info = myArgs[4],
                is_ort_change_bool = false,
                is_resize_viewport_bool = false,
                is_resize_container_bool = false,
                is_resp_basis_container_bool = rstv_core_info["is_resp_basis_container"],
                is_multi_abort_1_bool = Restive.store("rstv_multi_abort_1")
            ;

            //Capture orientation change
            switch(true)
            {
                case (rstv_event_info == 'co'):
                    //there has been a change in orientation. manage accordingly
                    is_ort_change_bool = true;
                    break;
            }

            //Capture resize
            switch(true)
            {
                case (rstv_event_info == 'rv'):
                    //the viewport has been resized. manage accordingly
                    is_resize_viewport_bool = true;
                    break;
            }

            //Capture resize container
            switch(true)
            {
                case (rstv_event_info == 'rc'):
                    //the selected container has been resized. manage accordingly
                    is_resize_container_bool = true;
                    break;
            }

            //Abort Restive.JS if multiple constructor anomalies occur
            switch(true)
            {
                case (is_multi_abort_1_bool):
                    methods._error('rstv_error_004', 'If you are calling the Restive.JS Constructor more than once, you must call $.restive.startMulti() before calling these constructors!');
                    return false;
                    break;
            }

            /**
             * When multiple Restive.JS Constructors are used, and a match is found, that match is saved
             * On successive attempts, the breakpoint conditions that previously failed are prevented from being executed further to improve overall performace
             * The following code manages this process
             * NOTE: If the Responsive Basis is 'container', this functionality is ignored
             */
            var rstv_store_is_multi_bool = Restive.store("rstv_multi_start"),
                rstv_store_multi_count_int = parseInt(Restive.store("rstv_multi_count")),
                rstv_store_bpm_idx_int = parseInt(Restive.store("rstv_multi_bpm_idx")),
                rstv_store_bpm_lock_bool = Restive.store("rstv_cache_bpm_lock")
                ;

            switch(true)
            {
                case (!is_resp_basis_container_bool):
                    /**
                     * Do only if Responsive Basis is Viewport
                     */
                    switch(true)
                    {
                        case (rstv_store_is_multi_bool && !is_ort_change_bool && rstv_store_bpm_lock_bool):
                            switch(true)
                            {
                                case (isNumber(rstv_store_multi_count_int) && isNumber(rstv_store_bpm_idx_int) && rstv_store_multi_count_int != rstv_store_bpm_idx_int):
                                    return false;
                                    break;
                            }
                            break;
                    }
                    break;
            }

            //get Device and Orientation Options and Information
            var restive_user_agent_str = Restive.getUserAgent(),
                options_platform_str = rstv_options.platform,
                options_formfactor_str = rstv_options.formfactor,
                options_force_dip_str = rstv_options.force_dip,
                restive_platform_str = rstv_core_info["platform"],
                restive_formfactor_str = rstv_core_info["formfactor"],
                restive_pixelratio_str = rstv_core_info["pixelratio"],
                restive_is_mobile_str = (rstv_core_info["is_mobile"] == true) ? "true": "false",
                ort_init_str = Restive.store("rstv_ort_init"),
                ort_curr_str = Restive.store("rstv_ort_curr"),
                is_portrait_bool = Restive.isPortrait(),
                is_landscape_bool = (is_portrait_bool === true) ? false : true;


            var dim_arr = [],
                viewport_w_int,
                viewport_h_int,
                screen_w_int,
                screen_h_int,
                pixel_w_int,
                pixel_h_int,
                viewport_w_active_int,
                bp_set_arr = [],
                bp_class_arr = [],
                is_class_def_bool = false,
                bp_width_tok_str = bp_arr["bp_w"],
                bp_height_tok_str = bp_arr["bp_h"],
                bp_ort_tok_str = bp_arr["bp_o"],
                bp_type_tok_str = bp_arr["bp_t"],
                bp_class_tok_str = bp_arr["bp_c"],
                bp_width_arr = [],
                bp_height_arr = [],
                bp_ort_arr = [],
                bp_type_arr = [];

            viewport_w_int = Restive.viewportW();
            viewport_w_active_int = viewport_w_int;
            viewport_h_int = Restive.viewportH();
            screen_w_int = Restive.screenW();
            screen_h_int = Restive.screenH();
            pixel_w_int = Restive.pixelW();
            pixel_h_int = Restive.pixelH();

            switch(true)
            {
                case (options_force_dip_str == true):
                    viewport_w_active_int = Restive.pixelW();
                    break;
            }

            //Extract Data to Array
            bp_width_arr = arrayToInteger(explode("|", bp_width_tok_str));
            bp_height_arr = arrayToInteger(explode("|", bp_height_tok_str));
            bp_ort_arr = explode("|", bp_ort_tok_str);
            bp_type_arr = explode("|", bp_type_tok_str);

            //Manage Classes Data
            switch(true)
            {
                case (typeof bp_class_tok_str !== "undefined" || bp_class_tok_str != null):
                    is_class_def_bool = true;
                    bp_class_arr = explode("|", bp_class_tok_str);
                    break;
            }

            var bp_width_arr_has_dupl_bool,
                bp_width_tok_no_dupl_str = '',
                bp_break_on_match_bool,
                bp_width_int,
                bp_width_prev_int,
                bp_width_prev_ort_marker_int,
                is_curr_bp_in_ort_range_bool = true,
                is_prev_bp_in_ort_range_bool = true,
                is_ort_marker_set_init_bool = false,        //this indicates whether orientation markers have been used at least once
                bp_width_start_int,
                bp_width_min_int,
                bp_width_max_int,
                bp_height_int,
                bp_width_diff_r_int,                        //the difference between current viewport width and bp_width_max_int
                bp_width_diff_r_abs_int,                    //the absolute difference between current viewport width and bp_width_max_int
                bp_width_diff_l_int,                        //the difference between current viewport width and bp_width_min_int
                bp_width_diff_r_comp_int,
                bp_type_str,
                bp_ort_str,
                bp_class_str,
                bp_class_last_sel_str,
                span_range_bool,
                ort_range_bool,
                is_breakpoint_match_bool = false,
                is_breakpoint_match_hit_bool = false,
                is_breakpoint_match_os_bool = true,
                is_breakpoint_match_ff_bool = true,
                ba_usage_log_status_str = '',
                ba_usage_log_status_code_str = '',
                elem_set_data_str
                ;

            var bp_width_arr_count_int = count(bp_width_arr);

            //check if there are duplicate width values
            bp_width_arr_has_dupl_bool = arrayHasDuplicates(bp_width_arr);
            bp_break_on_match_bool = (bp_width_arr_has_dupl_bool) ? false : true;

            /**
             * Iterate over individual breakpoints
             */
            for(var i = 0; i < bp_width_arr_count_int; i++)
            {
                /**
                 * Filter for:
                 * 1. platform
                 * 2. form factor
                 * If provided in the options
                 * Break out of for loop
                 */
                //1
                switch(true)
                {
                    case (rstv_options.platform != 'all' && rstv_options.platform != restive_platform_str):
                        is_breakpoint_match_os_bool = false;
                        break;
                }

                //2
                switch(true)
                {
                    case (rstv_options.formfactor != 'all' && rstv_options.formfactor != restive_formfactor_str):
                        is_breakpoint_match_ff_bool = false;
                        break;
                }

                //break out of for loop if match is not found
                if(!is_breakpoint_match_os_bool || !is_breakpoint_match_ff_bool) break;

                var i_prev = i - 1;
                bp_width_int = bp_width_arr[i];

                //manage previous breakpoint widths
                switch(true)
                {
                    case (i > 0):
                        bp_width_prev_int = bp_width_arr[i_prev];
                        break;

                    default:
                        bp_width_prev_int = 0;
                        bp_width_prev_ort_marker_int = 0;
                }

                bp_height_int = bp_height_arr[i];

                bp_type_str = bp_type_arr[i];
                bp_ort_str = bp_ort_arr[i];

                //Consider orientation markers
                is_prev_bp_in_ort_range_bool = is_curr_bp_in_ort_range_bool;
                switch(true)
                {
                    case (bp_ort_str == "p"):
                        ort_range_bool = (is_portrait_bool) ? true : false;
                        is_ort_marker_set_init_bool = true;

                        is_curr_bp_in_ort_range_bool = ort_range_bool;
                        bp_width_tok_no_dupl_str = (is_prev_bp_in_ort_range_bool === false) ? bp_width_prev_ort_marker_int: bp_width_tok_no_dupl_str;
                        break;

                    case (bp_ort_str == "l"):
                        ort_range_bool = (is_landscape_bool) ? true : false;
                        is_ort_marker_set_init_bool = true;

                        is_curr_bp_in_ort_range_bool = ort_range_bool;
                        bp_width_tok_no_dupl_str = (is_prev_bp_in_ort_range_bool === false) ? bp_width_prev_ort_marker_int: bp_width_tok_no_dupl_str;
                        break;

                    default:
                        /**
                         * If is_prev_bp_in_ort_range_bool is false, it means that the previous breakpoint
                         * had an orientation marker ('-p' or '-l') that did not match the current
                         * orientation of the viewport.
                         * And if is_ort_marker_set_init_bool is true, then there has been a transition from a
                         * breakpoint with an orientation marker to one without one.
                         */
                        bp_width_tok_no_dupl_str = (is_ort_marker_set_init_bool === true && is_prev_bp_in_ort_range_bool === false) ? bp_width_prev_ort_marker_int: bp_width_tok_no_dupl_str;

                        bp_width_prev_ort_marker_int = (i > 0) ? bp_width_int: 0;
                        ort_range_bool = true;
                        is_curr_bp_in_ort_range_bool = ort_range_bool;
                }

                //Manage duplicate entries
                switch(true)
                {
                    case (i == 0):
                        bp_width_start_int = 0;
                        bp_width_tok_no_dupl_str = bp_width_int;
                        break;

                    case (i >= 1):

                        switch(true)
                        {
                            case (bp_width_int !== bp_width_prev_int):
                                bp_width_tok_no_dupl_str = bp_width_int+'-!'+bp_width_tok_no_dupl_str;
                                break;
                        }

                        bp_width_start_int = parseInt(getValueAfterExplode(bp_width_tok_no_dupl_str, '-!', 1));

                        break;
                }

                //Define classes
                bp_class_str = bp_class_arr[i];

                //set ranges for widths
                switch(true)
                {
                    case (i == 0):
                        bp_width_min_int = bp_width_start_int;
                        bp_width_max_int = bp_width_int;

                        break;

                    default:
                        bp_width_min_int = (bp_width_start_int == 0) ? bp_width_start_int : bp_width_start_int + 1;
                        bp_width_max_int = bp_width_int;
                }

                /**
                 * Check for Matching Breakpoints
                 * 1. Do for Container Basis
                 * 2. Do for Viewport Basis. Make sure to consider force_dip option
                 */
                switch(true)
                {
                    case (is_resp_basis_container_bool):
                        //1
                        span_range_bool = Restive.eSpan(bp_width_min_int, bp_width_max_int, elem, rstv_options.anchor_e_df, rstv_options.force_dip);
                        break;

                    default:
                        //2
                        span_range_bool = (options_force_dip_str == true) ? Restive.cSpan(bp_width_min_int, bp_width_max_int): Restive.vSpan(bp_width_min_int, bp_width_max_int);
                }

                /**
                 * Set Breakpoints
                 * A. For Container Basis
                 *
                 * B. For Viewport Basis
                 * Status codes as follows:
                 * 1: Viewport matched breakpoint with clean hit on initialization i.e. viewport is virtually identical to breakpoint
                 * 2: Viewport matched breakpoint with clean hit after orientation change
                 * 3: Viewport matched breakpoint but not with a clean hit i.e. margin between viewport width and upper limit of matched breakpoint range is significant
                 * 4: Viewport matched breakpoint after orientation change but not with a clean hit i.e. margin between viewport width and upper limit of matched breakpoint range is significant
                 */
                switch(true)
                {
                    case (span_range_bool && ort_range_bool):

                        switch(true)
                        {
                            case (is_resp_basis_container_bool):
                                //A
                                is_breakpoint_match_bool = true;
                                break;

                            default:
                                //B
                                bp_width_diff_r_int = bp_width_max_int - viewport_w_active_int;
                                bp_width_diff_r_abs_int = Math.abs(bp_width_diff_r_int);
                                bp_width_diff_l_int = viewport_w_active_int - bp_width_min_int;

                                bp_width_diff_r_comp_int = bp_width_max_int*0.1;
                                bp_width_diff_r_comp_int = Math.round(bp_width_diff_r_comp_int);

                                switch(true)
                                {
                                    case (is_ort_change_bool):
                                        //capture some key metrics
                                        switch(true)
                                        {
                                            case (bp_width_diff_r_int > bp_width_diff_r_comp_int):
                                                ba_usage_log_status_code_str = "4";
                                                break;

                                            default:
                                                ba_usage_log_status_code_str = "2";
                                        }
                                        break;

                                    default:
                                        //capture some key metrics
                                        switch(true)
                                        {
                                            case (bp_width_diff_r_int > bp_width_diff_r_comp_int):
                                                ba_usage_log_status_code_str = "3";
                                                break;

                                            default:
                                                ba_usage_log_status_code_str = "1";
                                        }
                                }

                                is_breakpoint_match_bool = true;

                                //Capture class values of last hit
                                switch(true)
                                {
                                    case (is_breakpoint_match_bool):
                                        is_breakpoint_match_hit_bool = true;

                                        bp_class_last_sel_str = bp_class_str;

                                        switch(true)
                                        {
                                            case (bp_ort_str != "x"):
                                                bp_break_on_match_bool = true;
                                                break;
                                        }
                                        break;
                                }
                        }

                        break;

                    default:
                        is_breakpoint_match_bool = false;
                }

                //break out of for loop if match is found
                if(is_breakpoint_match_bool && bp_break_on_match_bool) break;
            }

            //Perform adjustment of breakpoint match value to compensate for if bp_break_on_match_bool is false
            switch(true)
            {
                case (is_breakpoint_match_hit_bool):
                    is_breakpoint_match_bool = true;
                    bp_class_str = bp_class_last_sel_str;
                    break;
            }

            //Some Breakpoint Advisory Information
            switch(true)
            {
                case (!is_breakpoint_match_bool):

                    //Do for Container Basis
                    switch(true)
                    {
                        case (is_resp_basis_container_bool):
                            methods.unsetElementDOM(elem, rstv_options);
                            return;
                            break;
                    }

                    //Do for Viewport Basis
                    bp_width_min_int = 0;
                    bp_width_max_int = 0;

                    switch(true)
                    {
                        case (!Restive.store("rstv_multi_start") || is_ort_change_bool):
                            methods.unsetElementDOM(elem, rstv_options);
                            break;
                    }

                    switch(true)
                    {
                        case (!is_breakpoint_match_os_bool && is_breakpoint_match_ff_bool):
                            ba_usage_log_status_code_str = "7";
                            break;

                        case (!is_breakpoint_match_ff_bool && is_breakpoint_match_os_bool):
                            ba_usage_log_status_code_str = "8";
                            break;

                        case (!is_breakpoint_match_ff_bool && !is_breakpoint_match_os_bool):
                            ba_usage_log_status_code_str = "9";
                            break;

                        default:
                            switch(true)
                            {
                                case (is_ort_change_bool):
                                    ba_usage_log_status_code_str = "6";
                                    break;

                                default:
                                    ba_usage_log_status_code_str = "5";
                            }
                    }

                    //Add Turbo Classes if any
                    elem_set_data_str = methods._addTurboClasses('', rstv_options.turbo_classes);

                    //This if for turbo_classes_reflow option
                    elem_set_data_str = methods._addTurboClassesReflow(elem_set_data_str, rstv_options);

                    switch(true)
                    {
                        case (!Restive.store("rstv_multi_start") || is_ort_change_bool):
                            methods.setElementDOM(elem, elem_set_data_str, rstv_options);
                            break;
                    }

                    //persist
                    Restive.store("rstv_breakpoint_match_curr", false);

                    break;

                case (is_breakpoint_match_bool):
                    elem_set_data_str = methods._addTurboClasses(bp_class_str, rstv_options.turbo_classes);

                    //This if for turbo_classes_reflow option
                    elem_set_data_str = methods._addTurboClassesReflow(elem_set_data_str, rstv_options);

                    /**
                     * Set class
                     */
                    //Do for Container Basis
                    switch(true)
                    {
                        case (is_resp_basis_container_bool):
                            methods.setElementDOM(elem, elem_set_data_str, rstv_options);
                            return;
                            break;
                    }

                    //Do for Viewport Basis
                    switch(true)
                    {
                        case (Restive.store("rstv_multi_start")):
                            var bpm_h_counter_int = parseInt(Restive.store("rstv_bpm_h_counter"));
                            switch(true)
                            {
                                case (is_ort_change_bool):
                                    //change in orientation
                                    methods.setElementDOM(elem, elem_set_data_str, rstv_options);
                                    break;

                                default:
                                    //initialization
                                    switch(true)
                                    {
                                        case (bpm_h_counter_int > 1):
                                            //check if the current viewport offers a better match
                                            var ss_bp_width_diff_r_abs_int = parseInt(Restive.store("rstv_cache_bpm_viewport_diff"));

                                            switch(true)
                                            {
                                                case (bp_width_diff_r_abs_int < ss_bp_width_diff_r_abs_int):
                                                    //this is a better viewport match
                                                    methods.setElementDOM(elem, elem_set_data_str, rstv_options);

                                                    switch(true)
                                                    {
                                                        case(!rstv_store_bpm_lock_bool):
                                                            Restive.store("rstv_multi_bpm_idx", rstv_store_multi_count_int);
                                                            break;
                                                    }

                                                    Restive.store("rstv_cache_bpm_viewport_diff", bp_width_diff_r_abs_int);
                                                    break;
                                            }

                                            break;

                                        default:
                                            methods.setElementDOM(elem, elem_set_data_str, rstv_options);
                                            switch(true)
                                            {
                                                case(!rstv_store_bpm_lock_bool):
                                                    Restive.store("rstv_multi_bpm_idx", rstv_store_multi_count_int);
                                                    break;
                                            }

                                            Restive.store("rstv_cache_bpm_viewport_diff", bp_width_diff_r_abs_int);
                                    }

                                    bpm_h_counter_int++;
                                    Restive.store("rstv_bpm_h_counter", bpm_h_counter_int, '', {expires: 1000});
                            }

                            break;

                        default:
                            //Set the element class immediately
                            methods.setElementDOM(elem, elem_set_data_str, rstv_options);
                    }

                    //persist
                    Restive.store("rstv_breakpoint_match_curr", true);
                    break;
            }

            /**
             * Track Breakpoint Hits and Misses in Storage
             * Do this incrementally when:
             * 1. Multi-Constructor Mode is active
             * 2. There has not been a change in orientation
             * 3. Breakpoint Match Cache Lock is not set
             * NOTE: For Multi-constructor Operations only
             */
            var rstv_cache_bpm_lock_bool = Restive.store("rstv_cache_bpm_lock");
            switch(true)
            {
                case (rstv_store_is_multi_bool && !is_ort_change_bool && !((isString(rstv_cache_bpm_lock_bool) && rstv_cache_bpm_lock_bool != "") || isBool(rstv_cache_bpm_lock_bool))):
                    (Restive.store("rstv_breakpoint_match_curr")) ? methods._extVarTracker("rstv_cache_bpm", "h", "ls", false, '', false): methods._extVarTracker("rstv_cache_bpm", "m", "ls", false, '', false);
                    break;
            }

            //Exit for Matched Breakpoint
            switch(true)
            {
                case (is_breakpoint_match_bool):
                    return true;
                    break;
            }

            return false;
		},
        _addTurboClassesReflow: function(class_data_str, options){
            switch(true)
            {
                case (methods.isPC()):
                    //only do for Personal Computer environments

                    switch(true)
                    {
                        case (options.turbo_classes_reflow && isString(options.turbo_classes) && options.turbo_classes != ''):
                            //only do if turbo_classes_reflow option is true and turbo_classes are populated

                            var opt_isset_is_mobile_bool,
                                fpr_span_range_tomobile_bool,
                                fpr_span_range_tophone_bool,
                                fpr_span_range_totablet_bool,
                                fpr_limits_tablet_int,
                                fpr_limits_phone_int,
                                fpr_limits_bp_btw_phone_and_tablet_int,
                                fpr_test_key_str,
                                fpr_test_value_str,
                                fpr_limits_arr = [],
                                turbo_classes_arr = [],
                                fpr_final_data_str = class_data_str,
                                is_turbo_classes_reflow_match_bool = false,
                                is_turbo_classes_reflow_status_bool = Restive.store('rstv_turbo_classes_reflow_status_in')
                                ;

                            //get the turbo_classes_reflow_limits values
                            fpr_limits_arr = explode(',', options.turbo_classes_reflow_limits);
                            fpr_limits_phone_int = parseInt(fpr_limits_arr[0]);
                            fpr_limits_tablet_int = parseInt(fpr_limits_arr[1]);

                            //ensure is_mobile turbo_classes parameter
                            opt_isset_is_mobile_bool = /is_mobile=/i.test(options.turbo_classes);
                            switch(true)
                            {
                                case (opt_isset_is_mobile_bool):
                                    //iterate over all provided turbo_classes
                                    turbo_classes_arr = explode(',', options.turbo_classes);
                                    for(var j = 0; j < count(turbo_classes_arr); j++)
                                    {
                                        fpr_test_key_str = getValueAfterExplode(turbo_classes_arr[j], "=", 0);
                                        fpr_test_value_str = getValueAfterExplode(turbo_classes_arr[j], "=", 1);

                                        switch(true)
                                        {
                                            case (fpr_test_key_str == 'is_mobile'):
                                                fpr_span_range_tomobile_bool = (options.force_dip == true) ? Restive.cSpan(0, fpr_limits_tablet_int): Restive.vSpan(0, fpr_limits_tablet_int);

                                                switch(true)
                                                {
                                                    case (fpr_span_range_tomobile_bool):

                                                        fpr_final_data_str += ' '+fpr_test_value_str;
                                                        is_turbo_classes_reflow_match_bool = true;
                                                        switch(true)
                                                        {
                                                            case (!is_turbo_classes_reflow_status_bool && is_turbo_classes_reflow_match_bool):
                                                                Restive.store('rstv_turbo_classes_reflow_status_in', true);

                                                                //add callback
                                                                methods._callbackManager(options, ['turboclassesreflow', 'in']);

                                                                break;
                                                        }

                                                        break;

                                                    default:
                                                        is_turbo_classes_reflow_match_bool = false;
                                                        switch(true)
                                                        {
                                                            case (is_turbo_classes_reflow_status_bool && !is_turbo_classes_reflow_match_bool):
                                                                Restive.store('rstv_turbo_classes_reflow_status_in', false);

                                                                //add callback
                                                                methods._callbackManager(options, ['turboclassesreflow', 'out']);

                                                                break;
                                                        }
                                                }

                                                break;
                                        }

                                        switch(true)
                                        {
                                            case (fpr_test_key_str == 'is_phone'):
                                                fpr_span_range_tophone_bool = (options.force_dip == true) ? Restive.cSpan(0, fpr_limits_phone_int): Restive.vSpan(0, fpr_limits_phone_int);

                                                fpr_final_data_str = (fpr_span_range_tophone_bool) ? fpr_final_data_str + ' ' + fpr_test_value_str: fpr_final_data_str;
                                                break;
                                        }

                                        switch(true)
                                        {
                                            case (fpr_test_key_str == 'is_tablet'):
                                                fpr_limits_bp_btw_phone_and_tablet_int = fpr_limits_phone_int + 1;
                                                fpr_span_range_totablet_bool = (options.force_dip == true) ? Restive.cSpan(fpr_limits_bp_btw_phone_and_tablet_int, fpr_limits_tablet_int): Restive.vSpan(fpr_limits_bp_btw_phone_and_tablet_int, fpr_limits_tablet_int);
                                                fpr_final_data_str = (fpr_span_range_totablet_bool) ? fpr_final_data_str + ' ' + fpr_test_value_str: fpr_final_data_str;

                                                break;
                                        }

                                    }

                                    return fpr_final_data_str;
                                    break;
                            }
                            break;
                    }
                    break;
            }

            //Restive.store('rstv_turbo_classes_reflow_status_in', false);
            return class_data_str;
        },
        _addTurboClasses: function(class_data_str, opt_turbo_classes){
            //return class name only if power classes info is invalid or empty
            switch(true)
            {
                case (!isString(opt_turbo_classes) || opt_turbo_classes == ''):
                    return class_data_str;
                    break;
            }

            //Define variables
            var opt_pc_arr = [],
                pc_key_str,
                pc_value_str,
                pc_temp_arr = [],
                pc_temp_str = '',
                pc_final_str = '',
                pc_func_arr = {'is_mobile': 'isMobile', 'is_non_mobile': 'isNonMobile', 'is_retina': 'isRetina', 'is_phone': 'isPhone', 'is_tablet': 'isTablet', 'is_tv': 'isTV', 'is_pc': 'isPC', 'is_portrait': 'isPortrait', 'is_landscape': 'isLandscape'},
                pc_func_name_str,
                pc_func_res
                ;

            opt_pc_arr = explode(',', opt_turbo_classes);
            for(var i = 0; i < count(opt_pc_arr); i++)
            {
                pc_key_str = getValueAfterExplode(opt_pc_arr[i], "=", 0);
                pc_value_str = getValueAfterExplode(opt_pc_arr[i], "=", 1);

                pc_func_name_str = pc_func_arr[pc_key_str];
                switch(true)
                {
                    case (isString(pc_func_name_str) && pc_func_name_str != ''):
                        pc_func_res = methods[pc_func_name_str];
                        switch(true)
                        {
                            case (pc_func_res()):
                                pc_temp_arr.push(pc_value_str);
                                break;
                        }
                        break;
                }
            }

            pc_temp_str = implode(' ', pc_temp_arr, true);
            pc_final_str = (pc_temp_str != '') ? pc_temp_str+' '+class_data_str : class_data_str;
            return pc_final_str;
        },
        setElementDOM: function(elem, elem_set_str, options){
            var data_key_str = md5(getSelector(elem)),
                ds_elem_set_class_name_str = "rstv_bpm_class_"+data_key_str,
                ds_elem_set_str;

            ds_elem_set_str = (isString(Restive.store(ds_elem_set_class_name_str)) && Restive.store(ds_elem_set_class_name_str) != '') ? Restive.store(ds_elem_set_class_name_str): '';
            switch(true)
            {
                case (ds_elem_set_str != ''):
                    elem.removeClass(ds_elem_set_str).addClass(elem_set_str);
                    switch(true)
                    {
                        case (ds_elem_set_str != elem_set_str):
                            methods._callbackManager(options, ['removeclass', ''+ds_elem_set_str+'']);
                            break;
                    }
                    break;

                default:
                    elem.addClass(elem_set_str);
            }
            Restive.store(ds_elem_set_class_name_str, elem_set_str);
            methods._callbackManager(options, ['addclass', ''+elem_set_str+'']);
        },
        unsetElementDOM: function(elem, options){
            var data_key_str = md5(getSelector(elem)),
                ds_elem_set_class_name_str = "rstv_bpm_class_"+data_key_str,
                ds_elem_set_str;

            ds_elem_set_str = (isString(Restive.store(ds_elem_set_class_name_str)) && Restive.store(ds_elem_set_class_name_str) != '') ? Restive.store(ds_elem_set_class_name_str): '';
            elem.removeClass(ds_elem_set_str);

            methods._callbackManager(options, ['removeclass', ''+ds_elem_set_str+'']);
        },
        _extVarTracker: function($track_name_str, $track_value_str)
        {
            var myArgs = Array.prototype.slice.call(arguments);
            var store_type_str = (isString(myArgs[2]) && myArgs[2] != "") ? myArgs[2] : 'ck';
            var unique_bool = (isBool(myArgs[3])) ? myArgs[3]: false;
            var expires = (isNumber(myArgs[4]) || isString(myArgs[4])) ? parseInt(myArgs[4]): '';
            var reverse_order_bool = (isBool(myArgs[5])) ? myArgs[5]: true;
            var delim_str = (isString(myArgs[6]) && myArgs[6] != "") ? myArgs[6]: '-!';
            var data_count_int = (isNumber(myArgs[7]) || isString(myArgs[7])) ? parseInt(myArgs[7]): 80;

            return Restive.storeVarTracker($track_name_str, $track_value_str, store_type_str, unique_bool, expires, reverse_order_bool, delim_str, data_count_int);
        },
        _multiConstructorSelectPos: function(){
            var bpm_val_str = Restive.store("rstv_cache_bpm"),
                bpm_val_arr = explode("-!", bpm_val_str),
                bpm_val_temp_str,
                bpm_idx_int = parseInt(Restive.store("rstv_multi_bpm_idx"))
                ;

            bpm_val_temp_str = implode("", bpm_val_arr);

            /**
             * 1. If only one hit is recorded, get it's position
             * 2. If all misses, get the last position i.e. length of string
             * 3. If more than one hit, get the value for the best match previously calculated
             */
            var sel_constructor_pos,
                sel_constructor_pos_1,
                pattern_1 = new RegExp("^[^h]*h[^h]*$", "gi"),
                pattern_2 = new RegExp("^m+$", "gi");

            switch(true)
            {
                case (pattern_1.test(bpm_val_temp_str)):
                    //1
                    sel_constructor_pos = strrpos(bpm_val_temp_str, 'h');
                    break;

                case (pattern_2.test(bpm_val_temp_str)):
                    //2
                    Restive.store("rstv_cache_bpm_all_miss", true, '', {expires: 2000});
                    sel_constructor_pos = strrpos(bpm_val_temp_str, 'm');
                    break;

                case(substr_count(bpm_val_temp_str, "h") > 1):
                    //3
                    sel_constructor_pos = bpm_idx_int - 1;
                    break;
            }
            sel_constructor_pos_1 = sel_constructor_pos + 1;
            Restive.store("rstv_multi_bpm_idx", sel_constructor_pos_1);

            return sel_constructor_pos;
        },
        _multiConstructorManageEvents: function(sel_constructor_pos){
            //Remove any events previously attached
            $(window).off('resize');

            //Manage Viewport Monitoring and Callbacks
            var $sel_pos_final_int = parseInt(sel_constructor_pos) + 1,
                $breakpoints_arr = window.parent.rstv_store.main["rstv_breakpoints_"+$sel_pos_final_int],
                $this = window.parent.rstv_store.main["rstv_this_"+$sel_pos_final_int],
                $options = window.parent.rstv_store.main["rstv_options_"+$sel_pos_final_int],
                $rstv_core_info_arr = window.parent.rstv_store.main["rstv_core_info_"+$sel_pos_final_int]
                ;

            switch(true)
            {
                case (Restive.store("rstv_resp_basis_viewport_init")):
                    methods._viewportMonitor($breakpoints_arr, $this, $options, $rstv_core_info_arr);
                    methods._callbackManager($options, ['ready', 'init']);
                    break;
            }
        },
        _multiConstructorFinalize: function(){

            var sel_constructor_pos = methods._multiConstructorSelectPos();

            //Redo event handlers
            methods._multiConstructorManageEvents(sel_constructor_pos);

            /**
             * Set Breakpoint Match Cache Lock
             * This marks that a Breakpoint Match has been determined (i.e. hit or miss) and as such this result should be stored and reused
             * NOTE: Only used in Multi-Constructor Operations
             */
            Restive.store("rstv_cache_bpm_lock", true);

            //Reset some local storage variables
            Restive.store("rstv_cache_req", null);
            Restive.store("rstv_multi_count", null);
        },
        _multiConstructorStart: function(){
            Restive.store("rstv_multi_count", 0);                 //counts the number of multi-constructor operations
            Restive.store("rstv_multi_start", true);
            Restive.store("rstv_multi_abort_1", false);
            Restive.store("rstv_multi_abort_2", false);

            //set some expiring counters
            Restive.store("rstv_bpm_h_counter", 1, '', {expires: 1000});
            Restive.store("rstv_bpm_m_counter", 1, '', {expires: 1000});

            //set some persistent counters
            switch(true)
            {
                case (!Restive.isStorageValueSet("rstv_multi_start_count")):
                    Restive.store("rstv_multi_start_count", 1);
                    Restive.store("rstv_multi_end", false);
                    break;

                default:
                    Restive.incrementStorageValue("rstv_multi_start_count");
            }
        },
        _multiConstructorManager: function(){
            var is_multi_start_bool = Restive.store("rstv_multi_start"),
                is_multi_end_bool = Restive.store("rstv_multi_end"),
                rstv_count_int = parseInt(Restive.store("rstv_multi_count")),
                rstv_multi_start_count_int = parseInt(Restive.store("rstv_multi_start_count"))
            ;

            /**
             * Check if Restive.JS Constructor has been called multiple times
             */
            switch(true)
            {
                case (rstv_count_int > 1):
                    //Signal abort if startMulti() method call not used
                    switch(true)
                    {
                        case (is_multi_start_bool === false):
                            Restive.store("rstv_multi_abort_1", true);
                            break;
                    }
                    break;
            }

            /**
             * Check if Restive.JS Constructor has been called multiple times and has not been finalized properly with endMulti() method
             */
            switch(true)
            {
                case (rstv_multi_start_count_int > 1 && is_multi_end_bool === false):
                    Restive.store("rstv_multi_abort_2", true);
                    break;
            }
            methods._URLMonitor();
        },
        _multiConstructorCounter: function(){
            Restive.incrementStorageValue("rstv_multi_count");
        },
        _multiConstructorEnd: function(){
            //reset stored variables
            Restive.store("rstv_multi_start_count", 0);
            Restive.store("rstv_multi_end", true);

            //finalize multi constructor operations
            methods._multiConstructorFinalize();
        },
        getUserAgent: function (){
            return Restive.getUserAgent();
        },
        getPlatform: function (){
            return Restive.getPlatform();
        },
        getFormFactor: function(){
            return Restive.getFormFactor();
        },
        getOrientation: function(){
            return Restive.getOrientation();
        },
        getResolution: function(){
            return Restive.getResolution();
        },
        getPixelRatio: function(pxl_ratio){
            return Restive.getPixelRatio(pxl_ratio);
        },
        getViewportW: function(){
            return Restive.viewportW();
        },
        getViewportH: function(){
            return Restive.viewportH();
        },
        getScreenW: function(){
            return Restive.screenW();
        },
        getScreenH: function(){
            return Restive.screenH();
        },
        getPixelW: function(){
            return Restive.pixelW();
        },
        getPixelH: function(){
            return Restive.pixelH();
        },
        isRetina: function(){
            return Restive.isRetina();
        },
        isMobile: function(){
            return Restive.isMobile();
        },
        isNonMobile: function(){
            return Restive.isNonMobile();
        },
        isPhone: function(){
            return Restive.isPhone();
        },
        isTablet: function(){
            return Restive.isTablet();
        },
        isTV: function(){
            return Restive.isTV();
        },
        isPC: function(){
            return Restive.isPC();
        },
        isIOS: function(){
            return Restive.isIOS();
        },
        isApple: function(){
            return Restive.isApple();
        },
        isAndroid: function(){
            return Restive.isAndroid();
        },
        isSymbian: function(){
            return Restive.isSymbian();
        },
        isBlackberry: function(){
            return Restive.isBlackberry();
        },
        isWindows: function(){
            return Restive.isWindows();
        },
        isWindowsPhone: function(){
            return Restive.isWindowsPhone();
        },
        isPortrait: function(){
            return Restive.isPortrait();
        },
        isLandscape: function(){
            return Restive.isLandscape();
        }
	};

    /**
     * Plugin Initialize
     */
    $.fn.restive = function(args){

		if ( methods[args] )
		{
			//execute JQuery Plugin Method
		   	return methods[ args ].apply( this, Array.prototype.slice.call( arguments, 1 ));
		}
		else if ( typeof args === 'object' || ! args )
		{
			//Process JQuery Plugin Options
			var opts = $.extend({}, $.fn.restive.defaults, args);
			var new_args = new Array(opts);
			return methods.init.apply( this, new_args );
		}
		else
		{
		   	$.error( 'Method ' +  args + ' does not exist on Restive.JS' );
		}
	};

	/**
	 * Plugin Defaults
	 */
	$.fn.restive.defaults = {
        breakpoints: [],                                //the breakpoints
		classes: [],                                    //the corresponding classes
        anchor: 'window',                               //the basis for responsiveness
        anchor_e_df: 'w',                               //the dimension format for element-value anchor operations
        platform: 'all',						        //all, ios, android, symbian, blackberry, windows
        formfactor: 'all',                              //all, pc, tv, tablet, phone
        turbo_classes: '',                              //special class-based functionality
        turbo_classes_reflow: false,                    //this will apply specific turbo_classes based on limit settings
        turbo_classes_reflow_limits: '480,960',         //defines thresholds for turbo_classes_reflow option
        force_dip: false,                               //force breakpoints to use device-independent pixels
        onReady: 		    function(){},
		onResize: 		    function(){},
		onRotate:		    function(){},
		onRotateToP:	    function(){},
		onRotateToL:	    function(){},
        onPortrait:         function(){},
        onLandscape:        function(){},
        onRetina:           function(){},
        onPhone:            function(){},
        onTablet:           function(){},
        onPC:               function(){},
        onTV:               function(){},
        onIOS:              function(){},
        onAndroid:          function(){},
        onSymbian:          function(){},
        onBlackberry:       function(){},
        onWindows:          function(){},
        onWindowsPhone:     function(){},
        onMobile:           function(){},
        onNonMobile:        function(){},
        onTurboClassReflow:         function(){},
        onTurboClassReflowIn:       function(){},
        onTurboClassReflowOut:      function(){},
        onAddClass:         function(){},
        onRemoveClass:      function(){}
	};

    /**
     * Plugin Methods
     */
    var D = $.restive = function(){};
    $.extend(D, {
        getUserAgent: function(){
            return methods.getUserAgent();
        },
        getPlatform: function(){
            return methods.getPlatform();
        },
        getFormFactor: function(){
            return methods.getFormFactor();
        },
        getOrientation: function(){
            return methods.getOrientation();
        },
        getResolution: function(){
            return methods.getResolution();
        },
        getPixelRatio: function(pxl_ratio){
            return methods.getPixelRatio(pxl_ratio);
        },
        getViewportW: function(){
            return methods.getViewportW();
        },
        getViewportH: function(){
            return methods.getViewportH();
        },
        getScreenW: function(){
            return methods.getScreenW();
        },
        getScreenH: function(){
            return methods.getScreenH();
        },
        getPixelW: function(){
            return methods.getPixelW();
        },
        getPixelH: function(){
            return methods.getPixelH();
        },
        isRetina: function(){
            return methods.isRetina();
        },
        isMobile: function(){
            return methods.isMobile();
        },
        isNonMobile: function(){
            return methods.isNonMobile();
        },
        isPhone: function(){
            return methods.isPhone();
        },
        isTablet: function(){
            return methods.isTablet();
        },
        isTV: function(){
            return methods.isTV();
        },
        isPC: function(){
            return methods.isPC();
        },
        isIOS: function(){
            return methods.isIOS();
        },
        isApple: function(){
            return methods.isIOS();
        },
        isAndroid: function(){
            return methods.isAndroid();
        },
        isSymbian: function(){
            return methods.isSymbian();
        },
        isBlackberry: function(){
            return methods.isBlackberry();
        },
        isWindows: function(){
            return methods.isWindows();
        },
        isWindowsPhone: function(){
            return methods.isWindowsPhone();
        },
        isPortrait: function(){
            return methods.isPortrait();
        },
        isLandscape: function(){
            return methods.isLandscape();
        },
        startMulti: function(){
            methods._multiConstructorStart();
        },
        endMulti: function(){
            methods._multiConstructorEnd();
        }
    });

}(window, document, jQuery));

////////////////////////////
// UTE-UI Angular extension
////////////////////////////
(function () {

  'use strict';

  angular.isUndefinedOrNull = angular.isUndefinedOrNull || function (val) {
    return angular.isUndefined(val) || val === null;
  };

  angular.stringContains = angular.stringContains || function (string, val) {
    return string.indexOf(val) !== -1;
  };

})();
////////////////////////////
////////////////////////////
////////////////////////////
////////////////////////////
// UTE-UI JQuery extension
////////////////////////////
(function () {

  'use strict';

  if (typeof $.prototype.hasAttr === 'undefined') {
    $.prototype.hasAttr = function (attrName) {
      return this.attr(attrName) !== null && this.attr(attrName) !== undefined;
    };
  }

})();
////////////////////////////
////////////////////////////
////////////////////////////
////////////////////////////
// UTE-UI JQuery extension
////////////////////////////
(function () {

  'use strict';

  String.prototype.toCamelCase = function () {
    return this.replace(/^([A-Z])|\s(\w)/g, function (match, p1, p2, offset) {
      if (p2) return p2.toUpperCase();
      return p1.toLowerCase();
    });
  };

})();
////////////////////////////
////////////////////////////
////////////////////////////
(function () {

  /**
   * @name ute-ui
   * @version 0.7.13
   * @namespace ute-ui
   */

  'use strict';

  angular.module('ute.ui.charts', ['ute.ui.core']);

  angular.module('ute.ui.content', ['ute.ui.core', 'ngTable', 'pascalprecht.translate', 'ngCookies']);

  angular.module('ute.ui.restive', []);

  angular.module('ute.ui.core', [
    'ute.ui.content',
    'ute.ui.restive',
    'ute.ui.charts',
    'tmh.dynamicLocale'
  ]).constant('moment', moment);

})();

(function () {

    'use strict';
  
    /**
     * @author Chester Rivas
     * @class ute-ui.charts
     * @memberOf ute-ui
     */
    angular.module('ute.ui.charts')
  
    /**
     * @class ute-ui.charts.uteChartist
     */
      .constant('uteBarOptions', {
        // Options for X-Axis
        axisX: {
          // The offset of the chart drawing area to the border of the container
          offset: 30,
          // Allows you to correct label positioning on this axis by positive or negative x and y offset.
          labelOffset: {
            x: 0,
            y: 0
          },
          // If labels should be shown or not
          showLabel: true,
          // If the axis grid should be drawn or not
          showGrid: true,
          // Interpolation function that allows you to intercept the value from the axis label
          labelInterpolationFnc: Chartist.noop,
          // This value specifies the minimum width in pixel of the scale steps
          scaleMinSpace: 40
        },
        // Options for Y-Axis
        axisY: {
          // The offset of the chart drawing area to the border of the container
          offset: 40,
          // Allows you to correct label positioning on this axis by positive or negative x and y offset.
          labelOffset: {
            x: 0,
            y: 0
          },
          // If labels should be shown or not
          showLabel: true,
          // If the axis grid should be drawn or not
          showGrid: true,
          // Interpolation function that allows you to intercept the value from the axis label
          labelInterpolationFnc: Chartist.noop,
          // This value specifies the minimum height in pixel of the scale steps
          scaleMinSpace: 20
        },
        // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
        width: undefined,
        // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
        height: undefined,
        // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
        high: undefined,
        // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
        low: undefined,
        // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
        chartPadding: 5,
        // Specify the distance in pixel of bars in a group
        seriesBarDistance: 15,
        // If set to true this property will cause the series bars to be stacked and form a total for each series point. This will also influence the y-axis and the overall bounds of the chart. In stacked mode the seriesBarDistance property will have no effect.
        stackBars: false,
        // Inverts the axes of the bar chart in order to draw a horizontal bar chart. Be aware that you also need to invert your axis settings as the Y Axis will now display the labels and the X Axis the values.
        horizontalBars: false,
        // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
        reverseData: false,
        // Override the class names that get used to generate the SVG structure of the chart
        classNames: {
          chart: 'ute-ct-chart-bar ct-chart-bar',
          label: 'ute-ct-label ct-label',
          labelGroup: 'ute-ct-labels ct-labels',
          series: 'ute-ct-series ct-series',
          bar: 'ute-ct-bar ct-bar',
          grid: 'ute-ct-grid ct-grid',
          gridGroup: 'ute-ct-grids ct-grids',
          vertical: 'ute-ct-vertical ct-vertical',
          horizontal: 'ute-ct-horizontal ct-horizontal'
        }
      });
  
  })();
  
  (function () {
  
    'use strict';
  
    /**
     * @author Chester Rivas
     * @class ute-ui.charts
     * @memberOf ute-ui
     */
    angular.module('ute.ui.charts')
  
    /**
     * @class ute-ui.charts.uteChartist
     */
      .constant('uteLineOptions', {
        // Options for X-Axis
        axisX: {
          // The offset of the labels to the chart area
          offset: 30,
          // Allows you to correct label positioning on this axis by positive or negative x and y offset.
          labelOffset: {
            x: 0,
            y: 0
          },
          // If labels should be shown or not
          showLabel: true,
          // If the axis grid should be drawn or not
          showGrid: true,
          // Interpolation function that allows you to intercept the value from the axis label
          labelInterpolationFnc: Chartist.noop
        },
        // Options for Y-Axis
        axisY: {
          // The offset of the labels to the chart area
          offset: 40,
          // Allows you to correct label positioning on this axis by positive or negative x and y offset.
          labelOffset: {
            x: 0,
            y: 0
          },
          // If labels should be shown or not
          showLabel: true,
          // If the axis grid should be drawn or not
          showGrid: true,
          // Interpolation function that allows you to intercept the value from the axis label
          labelInterpolationFnc: Chartist.noop,
          // This value specifies the minimum height in pixel of the scale steps
          scaleMinSpace: 20
        },
        // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
        width: undefined,
        // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
        height: undefined,
        // If the line should be drawn or not
        showLine: true,
        // If dots should be drawn or not
        showPoint: true,
        // If the line chart should draw an area
        showArea: false,
        // The base for the area chart that will be used to close the area shape (is normally 0)
        areaBase: 0,
        // If the line will stop drawing when the data ends rather than normalizing. This will not manipulate data with multiple length.
        allowVariableDataLengths: false,
        // Specify if the lines should be smoothed. This value can be true or false where true will result in smoothing using the default smoothing interpolation function Chartist.Interpolation.cardinal and false results in Chartist.Interpolation.none. You can also choose other smoothing / interpolation functions availabel in the Chartist.Interpolation module, or write your own interpolation function. Check the examples for a brief description.
        lineSmooth: true,
        // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
        low: undefined,
        // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
        high: undefined,
        // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
        chartPadding: 5,
        // When set to true, the last grid line on the x-axis is not drawn and the chart elements will expand to the full availabel width of the chart. For the last label to be drawn correctly you might need to add chart padding or offset the last label with a draw event handler.
        fullWidth: false,
        // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
        reverseData: false,
        // Override the class names that get used to generate the SVG structure of the chart
        classNames: {
          chart: 'ute-ct-chart-line ct-chart-line',
          label: 'ute-ct-label ct-label',
          labelGroup: 'ute-ct-labels ct-labels',
          series: 'ute-ct-series ct-series',
          line: 'ute-ct-line ct-line',
          point: 'ute-ct-point ct-point',
          area: 'ute-ct-area ct-area',
          grid: 'ute-ct-grid ct-grid',
          gridGroup: 'ute-ct-grids ct-grids',
          vertical: 'ute-ct-vertical ct-vertical',
          horizontal: 'ute-ct-horizontal ct-horizontal'
        }
      });
  
  })();
  
  (function () {
  
    'use strict';
  
    /**
     * @author Chester Rivas
     * @class ute-ui.charts
     * @memberOf ute-ui
     */
    angular.module('ute.ui.charts')
  
    /**
     * @class ute-ui.charts.uteChartist
     */
      .constant('utePieOptions', {
        // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
        width: undefined,
        // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
        height: undefined,
        // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
        chartPadding: 5,
        // Override the class names that get used to generate the SVG structure of the chart
        classNames: {
          chart: 'ute-ct-chart-pie',
          series: 'ute-ct-series ct-series',
          slice: 'ute-ct-slice ct-slice',
          donut: 'ute-ct-donut ct-donut',
          label: 'ute-ct-label ct-label'
        },
        // The start angle of the pie chart in degrees where 0 points north. A higher value offsets the start angle clockwise.
        startAngle: 0,
        // An optional total you can specify. By specifying a total value, the sum of the values in the series must be this total in order to draw a full pie. You can use this parameter to draw only parts of a pie or gauge charts.
        total: undefined,
        // If specified the donut CSS classes will be used and strokes will be drawn instead of pie slices.
        donut: false,
        // Specify the donut stroke width, currently done in javascript for convenience. May move to CSS styles in the future.
        donutWidth: 60,
        // If a label should be shown or not
        showLabel: true,
        // Label position offset from the standard position which is half distance of the radius. This value can be either positive or negative. Positive values will position the label away from the center.
        labelOffset: 0,
        // An interpolation function for the label value
        labelInterpolationFnc: Chartist.noop,
        // Label direction can be 'neutral', 'explode' or 'implode'. The labels anchor will be positioned based on those settings as well as the fact if the labels are on the right or left side of the center of the chart. Usually explode is useful when labels are positioned far away from the center.
        labelDirection: 'neutral',
        // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
        reverseData: false
      });
  
  })();

  (function () {

    'use strict';
  
    /**
     * @author Chester Rivas
     * @class ute-ui.charts
     * @memberOf ute-ui
     */
    angular.module('ute.ui.charts')
  
    /**
     * @class ute-ui.charts.uteChartBadge
     */
      .directive('uteChartBadge', function () {
  
        return {
          restrict: 'EA',
          replace: true,
          scope: {
            limitValue: '@'
          },
          template: '<div class="badge ute-ct-badge"><p><b>{{limitValue}} MB</b><br/> data limit</p></div>'
        };
  
      });
  
  })();
  
  (function () {
  
    'use strict';
  
    /**
     * @author Chester Rivas
     * @description wrapper directive for chartist
     * @class ute-ui.charts
     * @memberOf ute-ui
     */
    angular.module('ute.ui.charts')
  
    /**
     * @class ute-ui.charts.uteChartist
     */
      .directive('uteChartist', ["$compile", "uteLineOptions", "uteBarOptions", "utePieOptions", function ($compile, uteLineOptions, uteBarOptions, utePieOptions) {
  
        /**
         * @class ute-ui.chartist.uteChartist
         */
        return {
          restrict: 'EA',
          scope: {
            chartData: '=',
            chartOptions: '=',
            chartResponsiveOptions: '=',
            chartBreakLine: '=',
            chartShowLimitLine: '=',
            chartType: '@',
            onCreated: '&',
            onFinishedDrawing: '&',
            onDraw: '&'
          },
          replace: true,
          template: '<div class="ct-chart ute-chart"></div>',
          link: function ($scope, $element) {
  
            $scope.chart = null;
            $scope.chartData = angular.copy($scope.chartData);
            $scope.chartOptions = angular.copy($scope.chartOptions);
  
            var $target = $element[0],
              options;
  
            if ($scope.chartType === 'line') {
  
              // if chart data is defined and has more than 2 properties: labels and series
              if (angular.isDefined($scope.chartData) && angular.isDefined($scope.chartData.labels) && angular.isDefined($scope.chartData.series)) {
  
                var findLongestArray = function (listOfArrays) {
                    return _.reduce(listOfArrays, function (memo, num) {
                      var length = angular.isDefined(num.data) ? num.data.length : num.length;
                      return length > memo ? num.data : memo;
                    }, 0);
                  },
                  seriesArray;
  
                if ($scope.chartData.series === null || $scope.chartData.series === undefined) {
                  void 0;
                  return;
                }
  
                seriesArray = findLongestArray($scope.chartData.series);
  
                if ($scope.chartBreakLine && $scope.chartBreakLine.enabled) {
  
                  var breakLine,
                    limitIndex,
                    limitValue,
                    lastValue,
                    findMatchingLabel = function (index) {
                      if (typeof $scope.chartBreakLine.breakOn === 'number') {
                        return index < $scope.chartBreakLine.breakOn;
                      } else if (typeof $scope.chartBreakLine.breakOn === 'string') {
                        return $scope.chartBreakLine.breakOn !== $scope.chartData.labels[index].toLowerCase();
                      } else {
                        return false;
                      }
                    },
                    first = true;
  
                  if (angular.isDefined($scope.chartBreakLine.breakOn)) {
  
                    if (typeof $scope.chartBreakLine.breakOn !== 'number' && typeof $scope.chartBreakLine.breakOn !== 'string') {
                      throw new Error('uteChartist error: chartBreakLine.breakOn is not a number or a string, typeof value is: ' + typeof $scope.chartBreakLine.breakOn);
                    }
  
                    breakLine = [];
                    _.each(seriesArray, function (d, index, sourceArray) {
                      // if index value is less than breakOn value then push d to breakLine
                      var match = findMatchingLabel(index);
                      match && breakLine.push(d);
                      // if index is greater than or equal to breakOn then get the first next value and push one more data point
                      if (!match && first) {
                        limitIndex = index;
                        limitValue = seriesArray[index - 1];
                        lastValue = d;
                        first = false;
                        breakLine.push(d);
                        //sourceArray[index] = null; // TODO fix nullifying data
                      }
                    });
  
                    // create another graph line in the series
                    $scope.chartData.series.push({
                      data: breakLine,
                      limitData: {
                        lastValue: lastValue,
                        limitValue: limitValue,
                        index: limitIndex,
                        cap: $scope.chartBreakLine.limit
                      }
                    });
  
                  } else if (angular.isDefined($scope.chartBreakLine.limit)) {
  
                    if (typeof $scope.chartBreakLine.limit !== 'object' && typeof $scope.chartBreakLine.limit !== 'number') {
                      throw new Error('uteChartist error: chartBreakLine.limit is not a object or a string, typeof value is: ' + typeof $scope.chartBreakLine.limit);
                    }
  
                    if (Array.isArray($scope.chartBreakLine.limit)) {
  
                      // if limit is an array
                      _.each($scope.chartBreakLine.limit.reverse(), function (l) {
                        breakLine = [];
                        _.each(seriesArray, function (d, index, sourceArray) {
                          // if data value is less than current value in limit array then push data point to breakLine array
                          d < l && breakLine.push(d);
                          // if data value is greater than or equal to current value in limit array then get the first next value and push one more data point
                          if (d >= l && first) {
                            limitIndex = index;
                            limitValue = seriesArray[index - 1];
                            lastValue = d;
                            first = false;
                            breakLine.push(d);
                            //sourceArray[index] = null; // TODO fix nullifying data
                          }
                        });
  
                        // create another graph line in the series
                        $scope.chartData.series.push({
                          data: breakLine,
                          limitData: {
                            lastValue: lastValue,
                            limitValue: limitValue,
                            index: limitIndex,
                            cap: l
                          }
                        });
                      });
  
                    } else {
  
                      // if limit is a number
                      breakLine = [];
                      _.each(seriesArray, function (d, index, sourceArray) {
                        // if data value is less than limit value then push data point to breakLine array
                        if (d <= $scope.chartBreakLine.limit) {
                          breakLine.push(d);
                          limitValue = seriesArray[index];
                          //sourceArray[index] = null; // TODO fix nullifying data
                        }
                        // if data is greater than or equal to limit value then get the first next value and push one more data point
                        if (d >= $scope.chartBreakLine.limit && first) {
                          limitIndex = index;
                          lastValue = d;
                          first = false;
                          breakLine.push(d);
                        }
                      });
  
                      // create another graph line in the series
                      $scope.chartData.series.push({
                        data: breakLine,
                        limitData: {
                          lastValue: lastValue,
                          limitValue: limitValue,
                          index: limitIndex,
                          cap: $scope.chartBreakLine.limit
                        }
                      });
  
                    }
  
                  }
  
                }
  
                // if chartShowLimitLine is enabled
                if ($scope.chartShowLimitLine && $scope.chartShowLimitLine.enabled) {
  
                  var maxLine;
  
                  if (Array.isArray($scope.chartShowLimitLine.limit)) {
                    _.each($scope.chartShowLimitLine.limit, function (l, index) {
                      maxLine = [];
                      _.each(seriesArray, function () {
                        maxLine.push(l);
                      });
                      $scope.chartData.series.push({
                        data: maxLine,
                        className: 'ute-ct-limit-line ute-ct-limit-line-' + (index + 1)
                      });
                    });
                  } else {
                    maxLine = [];
                    _.each(seriesArray, function () {
                      maxLine.push($scope.chartShowLimitLine.limit);
                    });
                    $scope.chartData.series.push({
                      data: maxLine,
                      className: 'ute-ct-limit-line'
                    });
                  }
  
                }
  
                options = _.defaults({}, $scope.chartOptions, uteLineOptions);
                options.breakLine = $scope.chartBreakLine || {};
                options.showLimitLine = $scope.chartShowLimitLine || {};
  
                $scope.chart = Chartist.Line($target, $scope.chartData, options, $scope.chartResponsiveOptions);
  
              } else {
  
                if (!angular.isDefined($scope.chartData)) {
                  throw new Error('uteChartist error: $scope.chartData is undefined');
                } else {
                  throw new Error('uteChartist error: $scope.chartData is defined but does not have the correct properties: series and labels');
                }
  
              }
  
            } else if ($scope.chartType === 'bar') {
  
              options = _.defaults({}, $scope.chartOptions, uteBarOptions);
              $scope.chart = Chartist.Bar($target, $scope.chartData, options, $scope.chartResponsiveOptions);
  
            } else if ($scope.chartType === 'pie') {
  
              options = _.defaults({}, $scope.chartOptions, utePieOptions);
              $scope.chart = Chartist.Pie($target, $scope.chartData, options, $scope.chartResponsiveOptions);
  
            } else {
  
              throw new Error('uteChartist error: unknown chartType, must be \'line\', \'bar\' or \'pie\'');
  
            }
  
            // CREATED
            $scope.chart.on('created', function () {
  
              if ($scope.chartShowLimitLine && $scope.chartShowLimitLine.showLabel && $scope.chartShowLimitLine.showLabel.enabled) {
  
                var labelHTML = $scope.chartShowLimitLine.showLabel.template,
                  $limitLine = $('.ute-ct-limit-line'),
                  target = $limitLine.parent(),
                  $label,
                  $svgParent,
                  $svg,
                  linkFn = $compile(labelHTML),
                  labelDirective = $(linkFn($scope));
  
                labelDirective.addClass('ute-limit-line-badge');
  
                if ($($element).find('.badge.ute-ct-badge').length === 0) {
                  target.after(labelDirective);
                }
  
                $label = $($element).find('.badge.ute-ct-badge');
  
                $svg = $($element).find('svg');
                $svg.css({
                  top: 0,
                  left: 0
                });
  
                $svgParent = $svg.parent();
                $svgParent.css({
                  position: 'relative'
                });
  
                $label.css({
                  position: 'absolute',
                  left: 0 - $label.outerWidth() + 100,
                  top: $svgParent.position().top + ($label.height() / 2)
                });
  
              }
  
              // if $scope.onCreated is defined then fire method
              if (angular.isDefined($scope.onCreated)) {
                var expressionHandler = $scope.onCreated();
                if (typeof expressionHandler === 'function') {
                  expressionHandler($scope.chart);
                }
              }
  
              $scope.chart.eventEmitter.emit('finishedDrawing');
  
            });
  
            // DRAWING
            $scope.chart.on('draw', function (drawData) {
              // if $scope.onDraw is defined then fire method
              if (angular.isDefined($scope.onDraw)) {
                var expressionHandler = $scope.onDraw();
                if (typeof expressionHandler === 'function') {
                  expressionHandler(drawData);
                }
              }
            });
  
            // FINISHED DRAWING
            $scope.chart.on('finishedDrawing', function () {
              if (angular.isDefined($scope.onFinishedDrawing)) {
                var expressionHandler = $scope.onFinishedDrawing();
                if (typeof expressionHandler === 'function') {
                  expressionHandler();
                }
              }
            });
  
          }
  
        };
  
      }]);
  
  })();

(function () {

    'use strict';
  
    /**
     * @author Ronald Nicolls
     * @class ute.ui.content
     * @memberOf ute-ui
     */
    angular.module('ute.ui.content')
  
    /**
     * @class ute.ui.content.uteTable
     */
      .directive('uteTable', ["$http", "$filter", "ngTableParams", function ($http, $filter, ngTableParams) {
  
        return {
          restrict: 'EA',
          scope: {
            tableData: '=',
            footerData: '=',
            language: '@',
            itemsPerPage: '=',
            initialSort: '@',
            order: '@',
            tableTemplateFolder: '@'
          },
          transclude: true,
          templateUrl: function ($element, $attrs) {
            var templateFolder = $attrs.tableTemplateFolder || 'views/templates/table/';
            return templateFolder + $attrs.tableBodyTemplate + '.html';
          },
          link: function ($scope) {
  
            /**
             * @name updateTableData
             * @type {function}
             * @memberOf ute-ui.extras.uteTable
             * @description updates table with new data
             * @param tableData
             */
            var updateTableData = function (tableData) {
  
              if (angular.isDefined(tableData)) {
  
                $scope.tableParams = new ngTableParams({
                    page: 1,
                    count: $scope.itemsPerPage >= 0 ? $scope.itemsPerPage : 1000,
                    sorting: {}
                  },
                  {
                    counts: [],
                    total: tableData.length,
                    getData: function ($defer, params) {
                      var orderedData = params.sorting() ? $filter('orderBy')(tableData, params.orderBy()) : tableData;
                      $defer.resolve(orderedData.slice((params.page() - 1) * params.count(), params.page() * params.count()));
                    }
                  });
  
                /**
                 * Adds dynamic sorting param from attribute
                 */
                var orderDirection = $scope.order || 'desc';
                $scope.tableParams.$params.sorting[$scope.initialSort] = orderDirection;
  
                /**
                 * Adds dynamic table data update behaviour
                 */
                  //$scope.tableParams.count(tableData.length);
                $scope.tableParams.count($scope.itemsPerPage >= 0 ? $scope.itemsPerPage : 1000);
                $scope.tableParams.reload();
  
              }
  
            };
  
            $scope.$watch('tableData', updateTableData);
  
          }
  
        };
      }]);
  
  })();

(function () {

    'use strict';
  
    /**
     * @author Ronald Nicholls | Chester Rivas
     * @class ute-ui.restive
     * @memberOf ute-ui
     */
    angular.module('ute.ui.restive')
  
    /**
     * @class ute-ui.restive.uteRestive
     */
      .directive('uteRestive', ["restive", function (restive) {
  
        return {
          restrict: 'AE',
          scope: {
            bandwidthSource: '@',
            speed: '@'
          },
          replace: false,
          controller: ["$scope", "$element", function ($scope, $element) {
  
            var breakClass,
              deviceSize,
              selector = $($element),
              classes = ['xs', 'sm', 'md', 'lg', 'xl', '2k', '4k', '8k'],
              setAttributes = function () {
                _.each(classes, function (value) {
                  if (selector.attr('class').indexOf(value) > -1) {
                    deviceSize = value;
                  }
                });
  
                //var req = new XMLHttpRequest();
                //req.open('GET', $scope.bandwidthSource || 'http://www.fido.ca/' , false);
                //req.send(null);
                //var headers = req.getAllResponseHeaders().toLowerCase();
  
                // Find and retrieve "Bandwidth" value
                //var arrHeaders = headers.split('\r\n');
                //var bandwidth = arrHeaders[arrHeaders.indexOf("bandwidth: fast")].split(': ')[1];
  
                breakClass = restive.isPhone() === true ? 'xs' : deviceSize;
                selector.attr('ute-device-orientation', restive.getOrientation())
                  //.attr('ute-device-pixel-density', restive.getPixelRatio())
                  .attr('ute-device-platform', restive.getPlatform())
                  .attr('ute-device-formfactor', restive.getFormFactor())
                  .attr('ute-device-mobile', restive.isMobile())
                  .attr('ute-device-resolution', restive.getResolution())
                  .attr('ute-device-bandwidth', $scope.speed || 'fast')
                  .attr('ute-device-size', breakClass);
              };
  
            restive.startMulti();
  
            /*jshint camelcase: false */
            selector.restive({
              breakpoints: ['640', '720', '960', '1024', '1280', '1920', '3840', '7680'],
              classes: ['xs', 'sm', 'md', 'lg', 'xl', '2k', '4k', '8k'],
              force_dip: true,
              onRotate: function () {
                selector.attr('ute-device-orientation', restive.getOrientation());
              },
              onAddClass: function () {
                setAttributes();
              }
            });
  
            selector.restive({
              breakpoints: ['800'],
              classes: ['xs'],
              formfactor: 'phone',
              force_dip: true,
              onRotate: function () {
                selector.attr('ute-device-orientation', restive.getOrientation());
              },
              onAddClass: function () {
                setAttributes();
              }
            });
  
            restive.endMulti();
  
            setAttributes();
  
          }]
  
        };
  
      }]);
  
  })();

(function () {

  'use strict';

  /**
   * @author Ronald Nicholls | Chester Rivas
   * @class ute-ui.content
   * @memberOf ute-ui
   */
  angular.module('ute.ui.content')

  /**
   * @class ute-ui.content.uteContentInjector
   */
    .directive('uteContentInjector', ["$rootScope", "$templateCache", "uteContentLoader", "$cookies", "uteLocale", function ($rootScope, $templateCache, uteContentLoader, $cookies, uteLocale) {

      return {
        scope: {
          localContentId: '@',
          contentId: '@',
          compile: '=',
          province: '@',
          language: '@',
          ignoreProvince :'='
        },
        replace: true,
        restrict: 'EA',
        controller: ["$scope", "$element", function ($scope, $element) {

          /**
           * @description toggle for showing meta data for developer purposes
           * @name metaShown
           * @memberOf ute-ui.content.uteContentInjector
           */
          var metaShown = false;

          /**
           * @description toggle hidden dev divs and displays metadata after user clicks hidden cms-metadata-toggle div
           * @name displayMetadata
           * @memberOf ute-ui.content.uteContentInjector
           */
          var displayMetadata = function () {

            metaShown = !metaShown;
            var settings = {
              scope: $scope,
              element: $element,
              method: 'GET',
              dataType: 'json',
              fileType: '.json',
              contentId: $scope.contentId,
              compile: angular.isDefined($scope.compile) && $scope.compile || false,
              language: $scope.language || uteLocale.language(),
              province: $scope.province || uteLocale.province(),
              localContentId: $scope.localContentId
            };

            metaShown ? uteContentLoader.makeRequest(settings) : $element.children().children()[0].remove();

          };

          /**
           * @description add and removed active from cms-metadata div
           * @name metadataActive
           * @memberOf ute-ui.content.uteContentInjector
           */
          var metadataActive = function () {
            $(this).toggleClass('active');
          };

          /**
           * @description inits the directive
           * @name init
           * @memberOf ute-ui.content.uteContentInjector
           */
          var init = function () {

            $('ins').off().on('click', '.cms-metadata', metadataActive);

            $element.addClass('preloader loading');

            if (!$rootScope.ute) {
              $rootScope.ute = {
                language: 'en',
                province: 'on'
              };
            }

            makeRequest();

            //TODO - change .bind to .on method
            angular.element(document.getElementById('cms-metadata-toggle')).bind('click', displayMetadata);

          };

          /**
           * @description makes http request, also called by watcher
           * @name makeRequest
           * @memberOf ute-ui.content.uteContentInjector
           */
          var makeRequest = function () {

            var settings = {
              scope: $scope,
              element: $element,
              method: 'GET',
              dataType: 'html',
              fileType: '.html',
              contentId: $scope.contentId,
              compile: angular.isDefined($scope.compile) && $scope.compile || false,
              language: $scope.language || uteLocale.language(),
              province: $scope.province || uteLocale.province() || $cookies.get('province') || 'on',
              ignoreProvince: $scope.ignoreProvince,
              localContentId: $scope.localContentId
            };

            uteContentLoader.makeRequest(settings);

          };

          /**
           * @description checks to see if new values are different from the old values then makes an http request again
           * @name metaShown
           * @param oldValue
           * @param newValue
           * @memberOf ute-ui.content.uteContentInjector
           */
          var update = function (oldValue, newValue) {
            if ((angular.isUndefinedOrNull(newValue)) || oldValue !== newValue) {
              makeRequest();
            }
          };

          init();

          $scope.$watch('language', update);
          $scope.$watch('province', update);
          $scope.$watch('contentId', update);


        }]

      };

    }]);

})();

(function () {

  'use strict';

  /**
   * @author Ronald Nicolls | Chester Rivas
   * @class ute-ui.content
   * @memberOf ute-ui
   */
  angular.module('ute.ui.content')

  /**
   * @class ute-ui.content.uteContentLoader
   */
    .factory('uteContentLoader', ["$http", "uteEndpoint", "$compile", "moment", function ($http, uteEndpoint, $compile, moment) {

      /**
       * @name uteContentLoader
       * @type {object}
       * @memberOf ute-ui.content
       */
      var uteContentLoader = {};

      /**
       * @property uteContentLoader.contentObjects
       * @type {array}
       * @memberOf ute-ui.content.uteContentLoader
       * @description holds each instance of the directive that calls the makeRequest method, using to loop through and match after loading content
       */
      uteContentLoader.contentObjects = [];

      /**
       * @property uteContentLoader.localizedUrl
       * @type {function}
       * @memberOf ute-ui.content.uteContentLoader
       * @description returns a string with the language and province appended
       * @param config - object containing language and province
       * @returns {string}
       */
      uteContentLoader.localizedUrl = function (config) {
        var contentId = config.localContentId || config.contentId;
        var seperator = contentId.indexOf('intergration') === -1 ? '_' : '-';
        var provinceVal = config.ignoreProvince ? "" : seperator + config.province;
        return contentId + seperator + config.language + provinceVal;
      };

      /**
       * @property uteContentLoader.unescapeHTML
       * @type {function}
       * @memberOf ute-ui.content.uteContentLoader
       * @description converts ascii/html characters to < > characters, also replaces ampersands and a specific pattenr of double quotes
       * @param escapedHTML - string to convert
       * @returns {string}
       */
      uteContentLoader.unescapeHTML = function (escapedHTML) {
        return escapedHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/\\"/g, '"');
      };

      /**
       * @name onCMSLoadSuccess
       * @property uteContentLoader.onCMSLoadSuccess
       * @type {function}
       * @memberOf ute-ui.content.uteContentLoader
       * @description callback for CMS loading success
       * @param {object} currentContentObj - config object
       * @param {object} result - data containing html markup
       */
      uteContentLoader.onCMSLoadSuccess = function (currentContentObj, result) {

        var convertedHTML,
          matchedContent = null;

        // loop through contents object array and find the matching content and it's config object
        _.some(uteContentLoader.contentObjects, function (eachContent) {

          return currentContentObj.rid === eachContent.rid && currentContentObj.element === eachContent.element && (matchedContent = currentContentObj);

        });

        if (matchedContent === null) throw new Error('uteContentLoader error "matchedContent" was not defined');

        // if attribute option compile is set to true then compile the markup
        if (matchedContent.compile) {

          // convert the markup into valid HTML
          //convertedHTML = matchedContent.element.html(result.data).text();

          // populate that markup into the html
          matchedContent.element.html(result.data);

          // compile only the inner markup so there's no recursive loop
          //$compile($element.children().first())($scope.$parent);
          $compile(matchedContent.element.contents())(matchedContent.scope.$parent);

        } else if (matchedContent.fileType === '.json') {

          /*jshint camelcase: false */
          matchedContent.element.children().prepend('<div class="cms-metadata"><span class="content-url">' + uteContentLoader.path.replace('.json', '.html') +
            '</span><span class="edit-date">' + moment().format('MMMM Do YYYY, h:mm:ss a', result.data.editDate) + '</span><span class="version">' +
            result.data.version + '</span><span class="is-published">' + result.data.is_active + '</span><span class="content-edit-url"><a href="' +
            result.data.cmsContentURL + '" target="_blank">Edit</a></span></div>');

        } else {

          convertedHTML = uteContentLoader.unescapeHTML(result.data);
          matchedContent.element.html(convertedHTML);

        }

        matchedContent.element.removeClass('preloader loading');

      };

      /**
       * @property uteContentLoader.onCMSLoadError
       * @type function
       * @description callback for CMS loading error error
       * @memberOf ute-ui.content.uteContentLoader
       * @param {HTMLElement} currentContentObj - config object
       */
      uteContentLoader.onCMSLoadError = function (currentContentObj) {
        var placeholder = '<div class="col-xs-12 cms-content" style="background-color: #f5f5f5; text-align:center; margin-bottom:25px; margin-top:25px; border:1px dashed #ccc; padding:10px;"><span id="cms-header" style="text-align:center; color:#999;">' + uteContentLoader.localizedUrl(currentContentObj) + currentContentObj.fileType + '</span></div>';
        currentContentObj.element.removeClass('preloader loading');
        currentContentObj.element.html(placeholder);
      };

      /**
       * @property uteContentLoader.setOptions
       * @type {function}
       * @description sets all the default options before making the $http request
       * @memberOf ute-ui.content.uteContentLoader
       * @param {object} config - config object
       * @property {object} config.scope - scope of the directive
       * @property {string} config.contentId - the id/path to a CMS view from teamsite
       * @property {boolean} config.compile - to compile html string as angular binded markup
       * @property {string} config.language - language en or fr
       * @property {string} config.province - a province
       * @property {string} config.localContentId - the id/path to a local view, used for dev purposes
       */
      uteContentLoader.setOptions = function (config) {

        config.rid = Math.round(Math.random() * 1000);
        config.localContentId = angular.isDefined(config.localContentId) ? uteContentLoader.localizedUrl(config) + '.html' : undefined;

        // push processed object into array
        uteContentLoader.contentObjects.push(config);

        return config;

      };

      /**
       * @property uteContentLoader.makeRequest
       * @type {function}
       * @description make $http request to retrieve content of either html or json file
       * @memberOf ute-ui.content.uteContentLoader
       * @param {object} configObj - object which contains all the data associated with request
       */
      uteContentLoader.makeRequest = function (configObj) {

        // save current config object and push to array
        // returns object with rid defined
        var config = uteContentLoader.setOptions(configObj);

        config.fileType = config.contentId.indexOf('intergration') === -1 ? config.fileType : '.xml';

        //Take parts of configObj.contentId and remove trailing content id after final /
        var parts = config.contentId.split('/'),
          removedContentId = config.contentId.replace(parts[parts.length - 1], '');

        // Use full config.contentId if dateType is html, if dataType is json reform the $scope.contentId to have json subfolder added to it
        config.contentId = config.dataType === 'json' ? removedContentId + '/json/' + parts[parts.length - 1] : config.contentId;

        uteContentLoader.path = uteContentLoader.localizedUrl(config) + config.fileType;

        $http({
          method: config.method,
          dataType: config.dataType,
          url: config.localContentId || uteEndpoint(uteContentLoader.path, 'cms')
        }).then(uteContentLoader.onCMSLoadSuccess.bind(uteContentLoader, config), uteContentLoader.onCMSLoadError.bind(uteContentLoader, config));

      };

      return uteContentLoader;

    }]);

})();

/* jshint ignore:start */

(function () {

  /**
   *  Warning
   *  Don't use strict for this file as it's based on old code base and needs updated.
   * This file is copied and customized from the existing Rogers.com for encryption the credit card number purpose.
   * The third-party code used in this file was created in 2005 and doesn't pass the jshint,to keep the functionality working, this file has been excluded from the jshint.
   * Ideally, we should introduce an upgraded version of a Javascript encryption algorithm to replace this piece of code.
   */

  angular.module('ute.ui.core')

    .factory('uteEncryption', function () {

      // Augment the basic prototypes if they have not already been augmented.
      // These forms are obsolete. It is recommended that JSON.stringify and
      // JSON.parse be used instead.

      //}// prng4.js - uses Arcfour as a PRNG

      function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = [];
      }

      // Initialize arcfour context from key, an array of ints, each from [0..255]
      function ARC4init(key) {
        var i, j, t;
        for (i = 0; i < 256; ++i)
          this.S[i] = i;
        j = 0;
        for (i = 0; i < 256; ++i) {
          j = (j + this.S[i] + key[i % key.length]) & 255;
          t = this.S[i];
          this.S[i] = this.S[j];
          this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
      }

      function ARC4next() {
        var t;
        this.i = (this.i + 1) & 255;
        this.j = (this.j + this.S[this.i]) & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[(t + this.S[this.i]) & 255];
      }

      Arcfour.prototype.init = ARC4init;
      Arcfour.prototype.next = ARC4next;

      // Plug in your RNG constructor here
      function prng_newstate() {
        return new Arcfour();
      }

      // Pool size must be a multiple of 4 and greater than 32.
      // An array of bytes the size of the pool will be passed to init()
      var rng_psize = 256;
      // Random number generator - requires a PRNG backend, e.g. prng4.js

      // For best results, put code like
      // <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
      // in your main HTML document.

      var rng_state;
      var rng_pool;
      var rng_pptr;

      // Mix in a 32-bit integer into the pool
      function rng_seed_int(x) {
        rng_pool[rng_pptr++] ^= x & 255;
        rng_pool[rng_pptr++] ^= (x >> 8) & 255;
        rng_pool[rng_pptr++] ^= (x >> 16) & 255;
        rng_pool[rng_pptr++] ^= (x >> 24) & 255;
        if (rng_pptr >= rng_psize) rng_pptr -= rng_psize;
      }

      // Mix in the current time (w/milliseconds) into the pool
      function rng_seed_time() {
        rng_seed_int(new Date().getTime());
      }

      // Initialize the pool with junk if needed.
      if (rng_pool == null) {
        rng_pool = [];
        rng_pptr = 0;
        var t;
        if (navigator.appName == "Netscape" && navigator.appVersion < "5" && window.crypto) {
          // Extract entropy (256 bits) from NS4 RNG if availabel
          var z = window.crypto.random(32);
          for (t = 0; t < z.length; ++t)
            rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
        }
        while (rng_pptr < rng_psize) { // extract some randomness from Math.random()
          t = Math.floor(65536 * Math.random());
          rng_pool[rng_pptr++] = t >>> 8;
          rng_pool[rng_pptr++] = t & 255;
        }
        rng_pptr = 0;
        rng_seed_time();
        //rng_seed_int(window.screenX);
        //rng_seed_int(window.screenY);
      }

      function rng_get_byte() {
        if (rng_state == null) {
          rng_seed_time();
          rng_state = prng_newstate();
          rng_state.init(rng_pool);
          for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)
            rng_pool[rng_pptr] = 0;
          rng_pptr = 0;
          //rng_pool = null;
        }
        // TODO: allow reseeding after first request
        return rng_state.next();
      }

      function rng_get_bytes(ba) {
        var i;
        for (i = 0; i < ba.length; ++i) ba[i] = rng_get_byte();
      }

      function SecureRandom() {
      }

      SecureRandom.prototype.nextBytes = rng_get_bytes;
      // Depends on jsbn.js and rng.js

      // Version 1.1: support utf-8 encoding in pkcs1pad2

      // convert a (hex) string to a bignum object
      function parseBigInt(str, r) {
        return new BigInteger(str, r);
      }

      function linebrk(s, n) {
        var ret = "";
        var i = 0;
        while (i + n < s.length) {
          ret += s.substring(i, i + n) + "\n";
          i += n;
        }
        return ret + s.substring(i, s.length);
      }

      function byte2Hex(b) {
        if (b < 0x10)
          return "0" + b.toString(16);
        else
          return b.toString(16);
      }

      // PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
      function pkcs1pad2(s, n) {
        if (n < s.length + 11) { // TODO: fix for utf-8
          throw "encryption, Message too long for RSA";
          return null;
        }
        var ba = [];
        var i = s.length - 1;
        while (i >= 0 && n > 0) {
          var c = s.charCodeAt(i--);
          if (c < 128) { // encode using utf-8
            ba[--n] = c;
          } else if ((c > 127) && (c < 2048)) {
            ba[--n] = (c & 63) | 128;
            ba[--n] = (c >> 6) | 192;
          } else {
            ba[--n] = (c & 63) | 128;
            ba[--n] = ((c >> 6) & 63) | 128;
            ba[--n] = (c >> 12) | 224;
          }
        }
        ba[--n] = 0;
        var rng = new SecureRandom();
        var x = [];
        while (n > 2) { // random non-zero pad
          x[0] = 0;
          while (x[0] == 0) rng.nextBytes(x);
          ba[--n] = x[0];
        }
        ba[--n] = 2;
        ba[--n] = 0;
        return new BigInteger(ba);
      }

      // "empty" RSA key constructor
      function RSAKey() {
        this.n = null;
        this.e = 0;
        this.d = null;
        this.p = null;
        this.q = null;
        this.dmp1 = null;
        this.dmq1 = null;
        this.coeff = null;
      }

      // Set the public key fields N and e from hex strings
      function RSASetPublic(N, E) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
          this.n = parseBigInt(N, 16);
          this.e = parseInt(E, 16);
        } else
          throw "Invalid RSA public key";
      }

      // Perform raw public operation on "x": return x^e (mod n)
      function RSADoPublic(x) {
        return x.modPowInt(this.e, this.n);
      }

      // Return the PKCS#1 RSA encryption of "text" as an even-length hex string
      function RSAEncrypt(text) {
        var m = pkcs1pad2(text, (this.n.bitLength() + 7) >> 3);
        if (m == null) return null;
        var c = this.doPublic(m);
        if (c == null) return null;
        var h = c.toString(16);
        if ((h.length & 1) == 0) return h;
        else return "0" + h;
      }

      // Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
      //function RSAEncryptB64(text) {
      //  var h = this.encrypt(text);
      //  if(h) return hex2b64(h); else return null;
      //}

      // protected
      RSAKey.prototype.doPublic = RSADoPublic;

      // public
      RSAKey.prototype.setPublic = RSASetPublic;
      RSAKey.prototype.encrypt = RSAEncrypt;
      //RSAKey.prototype.encrypt_b64 = RSAEncryptB64;
      var b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var b64pad = "=";

      function hex2b64(h) {
        var i;
        var c;
        var ret = "";
        for (i = 0; i + 3 <= h.length; i += 3) {
          c = parseInt(h.substring(i, i + 3), 16);
          ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
        }
        if (i + 1 == h.length) {
          c = parseInt(h.substring(i, i + 1), 16);
          ret += b64map.charAt(c << 2);
        } else if (i + 2 == h.length) {
          c = parseInt(h.substring(i, i + 2), 16);
          ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
        }
        while ((ret.length & 3) > 0) ret += b64pad;
        return ret;
      }

      // convert a base64 string to hex
      function b64tohex(s) {
        var ret = "",
          v,
          i,
          k = 0, // b64 state, 0-3
          slop;
        for (i = 0; i < s.length; ++i) {
          if (s.charAt(i) == b64pad) break;
          v = b64map.indexOf(s.charAt(i));
          if (v < 0) continue;
          if (k == 0) {
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 1;
          } else if (k == 1) {
            ret += int2char((slop << 2) | (v >> 4));
            slop = v & 0xf;
            k = 2;
          } else if (k == 2) {
            ret += int2char(slop);
            ret += int2char(v >> 2);
            slop = v & 3;
            k = 3;
          } else {
            ret += int2char((slop << 2) | (v >> 4));
            ret += int2char(v & 0xf);
            k = 0;
          }
        }
        if (k == 1)
          ret += int2char(slop << 2);
        return ret;
      }

      // convert a base64 string to a byte/number array
      function b64toBA(s) {
        //piggyback on b64tohex for now, optimize later
        var h = b64tohex(s);
        var i;
        var a = [];
        for (i = 0; 2 * i < h.length; ++i) {
          a[i] = parseInt(h.substring(2 * i, 2 * i + 2), 16);
        }
        return a;
      }


      // Copyright (c) 2005  Tom Wu
      // All Rights Reserved.
      // See "LICENSE" for details.

      // Basic JavaScript BN library - subset useful for RSA encryption.

      // Bits per digit
      var dbits;

      // JavaScript engine analysis
      var canary = 0xdeadbeefcafe;
      var j_lm = ((canary & 0xffffff) == 0xefcafe);

      // (public) Constructor
      function BigInteger(a, b, c) {
        if (a != null)
        //if("number" == typeof a) this.fromNumber(a,b,c);
          if ("number" == typeof a) this.fromInt(a);
          else if (b == null && "string" != typeof a) this.fromString(a, 256);
          else this.fromString(a, b);
      }

      // return new, unset BigInteger
      function nbi() {
        return new BigInteger(null);
      }

      // am: Compute w_j += (x*this_i), propagate carries,
      // c is initial carry, returns final carry.
      // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
      // We need to select the fastest one that works in this environment.

      // am1: use a single mult and divide to get the high bits,
      // max digit bits should be 26 because
      // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
      function am1(i, x, w, j, c, n) {
        while (--n >= 0) {
          var v = x * this[i++] + w[j] + c;
          c = Math.floor(v / 0x4000000);
          w[j++] = v & 0x3ffffff;
        }
        return c;
      }

      // am2 avoids a big mult-and-extract completely.
      // Max digit bits should be <= 30 because we do bitwise ops
      // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
      function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff,
          xh = x >> 15;
        while (--n >= 0) {
          var l = this[i] & 0x7fff;
          var h = this[i++] >> 15;
          var m = xh * l + h * xl;
          l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
          c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
          w[j++] = l & 0x3fffffff;
        }
        return c;
      }

      // Alternately, set max digit bits to 28 since some
      // browsers slow down when dealing with 32-bit numbers.
      function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff,
          xh = x >> 14;
        while (--n >= 0) {
          var l = this[i] & 0x3fff;
          var h = this[i++] >> 14;
          var m = xh * l + h * xl;
          l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
          c = (l >> 28) + (m >> 14) + xh * h;
          w[j++] = l & 0xfffffff;
        }
        return c;
      }

      if (j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
        BigInteger.prototype.am = am2;
        dbits = 30;
      } else if (j_lm && (navigator.appName != "Netscape")) {
        BigInteger.prototype.am = am1;
        dbits = 26;
      } else { // Mozilla/Netscape seems to prefer am3
        BigInteger.prototype.am = am3;
        dbits = 28;
      }

      BigInteger.prototype.DB = dbits;
      BigInteger.prototype.DM = ((1 << dbits) - 1);
      BigInteger.prototype.DV = (1 << dbits);

      var BI_FP = 52;
      BigInteger.prototype.FV = Math.pow(2, BI_FP);
      BigInteger.prototype.F1 = BI_FP - dbits;
      BigInteger.prototype.F2 = 2 * dbits - BI_FP;

      // Digit conversions
      var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
      var BI_RC = [];
      var rr, vv;
      rr = "0".charCodeAt(0);
      for (vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;
      rr = "a".charCodeAt(0);
      for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
      rr = "A".charCodeAt(0);
      for (vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

      function int2char(n) {
        return BI_RM.charAt(n);
      }

      function intAt(s, i) {
        var c = BI_RC[s.charCodeAt(i)];
        return (c == null) ? -1 : c;
      }

      // (protected) copy this to r
      function bnpCopyTo(r) {
        for (var i = this.t - 1; i >= 0; --i) r[i] = this[i];
        r.t = this.t;
        r.s = this.s;
      }

      // (protected) set from integer value x, -DV <= x < DV
      function bnpFromInt(x) {
        this.t = 1;
        this.s = (x < 0) ? -1 : 0;
        if (x > 0) this[0] = x;
        else if (x < -1) this[0] = x + this.DV;
        else this.t = 0;
      }

      // return bigint initialized to value
      function nbv(i) {
        var r = nbi();
        r.fromInt(i);
        return r;
      }

      // (protected) set from string and radix
      function bnpFromString(s, b) {
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 256) k = 8; // byte array
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else {
          this.fromRadix(s, b);
          return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length,
          mi = false,
          sh = 0;
        while (--i >= 0) {
          var x = (k == 8) ? s[i] & 0xff : intAt(s, i);
          if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
          }
          mi = false;
          if (sh == 0)
            this[this.t++] = x;
          else if (sh + k > this.DB) {
            this[this.t - 1] |= (x & ((1 << (this.DB - sh)) - 1)) << sh;
            this[this.t++] = (x >> (this.DB - sh));
          } else
            this[this.t - 1] |= x << sh;
          sh += k;
          if (sh >= this.DB) sh -= this.DB;
        }
        if (k == 8 && (s[0] & 0x80) != 0) {
          this.s = -1;
          if (sh > 0) this[this.t - 1] |= ((1 << (this.DB - sh)) - 1) << sh;
        }
        this.clamp();
        if (mi) BigInteger.ZERO.subTo(this, this);
      }

      // (protected) clamp off excess high words
      function bnpClamp() {
        var c = this.s & this.DM;
        while (this.t > 0 && this[this.t - 1] == c) --this.t;
      }

      // (public) return string representation in given radix
      function bnToString(b) {
        if (this.s < 0) return "-" + this.negate().toString(b);
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else return this.toRadix(b);
        var km = (1 << k) - 1,
          d, m = false,
          r = "",
          i = this.t;
        var p = this.DB - (i * this.DB) % k;
        if (i-- > 0) {
          if (p < this.DB && (d = this[i] >> p) > 0) {
            m = true;
            r = int2char(d);
          }
          while (i >= 0) {
            if (p < k) {
              d = (this[i] & ((1 << p) - 1)) << (k - p);
              d |= this[--i] >> (p += this.DB - k);
            } else {
              d = (this[i] >> (p -= k)) & km;
              if (p <= 0) {
                p += this.DB;
                --i;
              }
            }
            if (d > 0) m = true;
            if (m) r += int2char(d);
          }
        }
        return m ? r : "0";
      }

      // (public) -this
      function bnNegate() {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
      }

      // (public) |this|
      function bnAbs() {
        return (this.s < 0) ? this.negate() : this;
      }

      // (public) return + if this > a, - if this < a, 0 if equal
      function bnCompareTo(a) {
        var r = this.s - a.s;
        if (r != 0) return r;
        var i = this.t;
        r = i - a.t;
        if (r != 0) return (this.s < 0) ? -r : r;
        while (--i >= 0)
          if ((r = this[i] - a[i]) != 0) return r;
        return 0;
      }

      // returns bit length of the integer x
      function nbits(x) {
        var r = 1,
          t;
        if ((t = x >>> 16) != 0) {
          x = t;
          r += 16;
        }
        if ((t = x >> 8) != 0) {
          x = t;
          r += 8;
        }
        if ((t = x >> 4) != 0) {
          x = t;
          r += 4;
        }
        if ((t = x >> 2) != 0) {
          x = t;
          r += 2;
        }
        if ((t = x >> 1) != 0) {
          x = t;
          r += 1;
        }
        return r;
      }

      // (public) return the number of bits in "this"
      function bnBitLength() {
        if (this.t <= 0) return 0;
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ (this.s & this.DM));
      }

      // (protected) r = this << n*DB
      function bnpDLShiftTo(n, r) {
        var i;
        for (i = this.t - 1; i >= 0; --i) r[i + n] = this[i];
        for (i = n - 1; i >= 0; --i) r[i] = 0;
        r.t = this.t + n;
        r.s = this.s;
      }

      // (protected) r = this >> n*DB
      function bnpDRShiftTo(n, r) {
        for (var i = n; i < this.t; ++i) r[i - n] = this[i];
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
      }

      // (protected) r = this << n
      function bnpLShiftTo(n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB),
          c = (this.s << bs) & this.DM,
          i;
        for (i = this.t - 1; i >= 0; --i) {
          r[i + ds + 1] = (this[i] >> cbs) | c;
          c = (this[i] & bm) << bs;
        }
        for (i = ds - 1; i >= 0; --i) r[i] = 0;
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
      }

      // (protected) r = this >> n
      function bnpRShiftTo(n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
          r.t = 0;
          return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for (var i = ds + 1; i < this.t; ++i) {
          r[i - ds - 1] |= (this[i] & bm) << cbs;
          r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
        r.t = this.t - ds;
        r.clamp();
      }

      // (protected) r = this - a
      function bnpSubTo(a, r) {
        var i = 0,
          c = 0,
          m = Math.min(a.t, this.t);
        while (i < m) {
          c += this[i] - a[i];
          r[i++] = c & this.DM;
          c >>= this.DB;
        }
        if (a.t < this.t) {
          c -= a.s;
          while (i < this.t) {
            c += this[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
          }
          c += this.s;
        } else {
          c += this.s;
          while (i < a.t) {
            c -= a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
          }
          c -= a.s;
        }
        r.s = (c < 0) ? -1 : 0;
        if (c < -1) r[i++] = this.DV + c;
        else if (c > 0) r[i++] = c;
        r.t = i;
        r.clamp();
      }

      // (protected) r = this * a, r != this,a (HAC 14.12)
      // "this" should be the larger one if appropriate.
      function bnpMultiplyTo(a, r) {
        var x = this.abs(),
          y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while (--i >= 0) r[i] = 0;
        for (i = 0; i < y.t; ++i) r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        r.s = 0;
        r.clamp();
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
      }

      // (protected) r = this^2, r != this (HAC 14.16)
      function bnpSquareTo(r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while (--i >= 0) r[i] = 0;
        for (i = 0; i < x.t - 1; ++i) {
          var c = x.am(i, x[i], r, 2 * i, 0, 1);
          if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
          }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        r.s = 0;
        r.clamp();
      }

      // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
      // r != q, this != m.  q or r may be null.
      function bnpDivRemTo(m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) return;
        var pt = this.abs();
        if (pt.t < pm.t) {
          if (q != null) q.fromInt(0);
          if (r != null) this.copyTo(r);
          return;
        }
        if (r == null) r = nbi();
        var y = nbi(),
          ts = this.s,
          ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
          pm.lShiftTo(nsh, y);
          pt.lShiftTo(nsh, r);
        } else {
          pm.copyTo(y);
          pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) return;
        var yt = y0 * (1 << this.F1) + ((ys > 1) ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt,
          d2 = (1 << this.F1) / yt,
          e = 1 << this.F2;
        var i = r.t,
          j = i - ys,
          t = (q == null) ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
          r[r.t++] = 1;
          r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while (y.t < ys) y[y.t++] = 0;
        while (--j >= 0) {
          // Estimate quotient digit
          var qd = (r[--i] == y0) ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
          if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) { // Try it out
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while (r[i] < --qd) r.subTo(t, r);
          }
        }
        if (q != null) {
          r.drShiftTo(ys, q);
          if (ts != ms) BigInteger.ZERO.subTo(q, q);
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r);
      }

      // (public) this mod a
      function bnMod(a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
        return r;
      }

      // Modular reduction using "classic" algorithm
      function Classic(m) {
        this.m = m;
      }

      function cConvert(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
      }

      function cRevert(x) {
        return x;
      }

      function cReduce(x) {
        x.divRemTo(this.m, null, x);
      }

      function cMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
      }

      function cSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
      }

      Classic.prototype.convert = cConvert;
      Classic.prototype.revert = cRevert;
      Classic.prototype.reduce = cReduce;
      Classic.prototype.mulTo = cMulTo;
      Classic.prototype.sqrTo = cSqrTo;

      // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
      // justification:
      //         xy == 1 (mod m)
      //         xy =  1+km
      //   xy(2-xy) = (1+km)(1-km)
      // x[y(2-xy)] = 1-k^2m^2
      // x[y(2-xy)] == 1 (mod m^2)
      // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
      // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
      // JS multiply "overflows" differently from C/C++, so care is needed here.
      function bnpInvDigit() {
        if (this.t < 1) return 0;
        var x = this[0];
        if ((x & 1) == 0) return 0;
        var y = x & 3; // y == 1/x mod 2^2
        y = (y * (2 - (x & 0xf) * y)) & 0xf; // y == 1/x mod 2^4
        y = (y * (2 - (x & 0xff) * y)) & 0xff; // y == 1/x mod 2^8
        y = (y * (2 - (((x & 0xffff) * y) & 0xffff))) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = (y * (2 - x * y % this.DV)) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return (y > 0) ? this.DV - y : -y;
      }

      // Montgomery reduction
      function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << (m.DB - 15)) - 1;
        this.mt2 = 2 * m.t;
      }

      // xR mod m
      function montConvert(x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
        return r;
      }

      // x/R mod m
      function montRevert(x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
      }

      // x = x/R mod m (HAC 14.32)
      function montReduce(x) {
        while (x.t <= this.mt2) // pad x so am has enough room later
          x[x.t++] = 0;
        for (var i = 0; i < this.m.t; ++i) {
          // faster way of calculating u0 = x[i]*mp mod DV
          var j = x[i] & 0x7fff;
          var u0 = (j * this.mpl + (((j * this.mph + (x[i] >> 15) * this.mpl) & this.um) << 15)) & x.DM;
          // use am to combine the multiply-shift-add into one call
          j = i + this.m.t;
          x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
          // propagate carry
          while (x[j] >= x.DV) {
            x[j] -= x.DV;
            x[++j]++;
          }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
      }

      // r = "x^2/R mod m"; x != r
      function montSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
      }

      // r = "xy/R mod m"; x,y != r
      function montMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
      }

      Montgomery.prototype.convert = montConvert;
      Montgomery.prototype.revert = montRevert;
      Montgomery.prototype.reduce = montReduce;
      Montgomery.prototype.mulTo = montMulTo;
      Montgomery.prototype.sqrTo = montSqrTo;

      // (protected) true iff this is even
      function bnpIsEven() {
        return ((this.t > 0) ? (this[0] & 1) : this.s) == 0;
      }

      // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
      function bnpExp(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE;
        var r = nbi(),
          r2 = nbi(),
          g = z.convert(this),
          i = nbits(e) - 1;
        g.copyTo(r);
        while (--i >= 0) {
          z.sqrTo(r, r2);
          if ((e & (1 << i)) > 0) z.mulTo(r2, g, r);
          else {
            var t = r;
            r = r2;
            r2 = t;
          }
        }
        return z.revert(r);
      }

      // (public) this^e % m, 0 <= e < 2^32
      function bnModPowInt(e, m) {
        var z;
        if (e < 256 || m.isEven()) z = new Classic(m);
        else z = new Montgomery(m);
        return this.exp(e, z);
      }

      // protected
      BigInteger.prototype.copyTo = bnpCopyTo;
      BigInteger.prototype.fromInt = bnpFromInt;
      BigInteger.prototype.fromString = bnpFromString;
      BigInteger.prototype.clamp = bnpClamp;
      BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
      BigInteger.prototype.drShiftTo = bnpDRShiftTo;
      BigInteger.prototype.lShiftTo = bnpLShiftTo;
      BigInteger.prototype.rShiftTo = bnpRShiftTo;
      BigInteger.prototype.subTo = bnpSubTo;
      BigInteger.prototype.multiplyTo = bnpMultiplyTo;
      BigInteger.prototype.squareTo = bnpSquareTo;
      BigInteger.prototype.divRemTo = bnpDivRemTo;
      BigInteger.prototype.invDigit = bnpInvDigit;
      BigInteger.prototype.isEven = bnpIsEven;
      BigInteger.prototype.exp = bnpExp;

      // public
      BigInteger.prototype.toString = bnToString;
      BigInteger.prototype.negate = bnNegate;
      BigInteger.prototype.abs = bnAbs;
      BigInteger.prototype.compareTo = bnCompareTo;
      BigInteger.prototype.bitLength = bnBitLength;
      BigInteger.prototype.mod = bnMod;
      BigInteger.prototype.modPowInt = bnModPowInt;

      // "constants"
      BigInteger.ZERO = nbv(0);
      BigInteger.ONE = nbv(1);

      //serivce return object
      function encrptCard(idNumber, modulus, exponent) {
        var rsa = new RSAKey();
        rsa.setPublic(modulus, exponent);
        var encryptCardNumber = rsa.encrypt(idNumber);
        return hex2b64(encryptCardNumber);
      }

      return encrptCard;
    })
})();

/* jshint ignore:end */
(function () {

  'use strict';

  /**
   * @author - Ronald Nicholls
   * @class ute-ui.core
   * @memberOf ute-ui
   */
  angular.module('ute.ui.core')

  /**
   * factory for unifying the logic for getting language and province based on $rootScope object rui or ute or cookies
   */
    .factory('uteLocale', ["$rootScope", "$cookies", function ($rootScope, $cookies) {

      var ute = {},
          language,
          province;

      ute.language = function () {

        if (typeof $rootScope.rui !== 'undefined' && typeof $rootScope.rui.language !== 'undefined') {
          language = $rootScope.rui.language;
        } else if (typeof $rootScope.ute !== 'undefined' && typeof $rootScope.ute.language !== 'undefined') {
          language = $rootScope.ute.language;
        }else if (typeof $cookies !== 'undefined' && typeof $cookies.get('language') !== 'undefined') {
          language = $cookies.get('language');
        }else{
          language = 'en';
        }

        return language;


      };

      ute.province = function () {
        if (typeof $rootScope.rui !== 'undefined' && typeof $rootScope.rui.province !== 'undefined') {
          province = $rootScope.rui.province;
        } else if (typeof $rootScope.ute !== 'undefined' && typeof $rootScope.ute.province !== 'undefined') {
          province = $rootScope.ute.province;
        }else if (typeof $cookies !== 'undefined' && typeof $cookies.get('province') !== 'undefined') {
          province = $cookies.get('province');
        }else{
          province = 'on';
        }

        return province;

      };

      return ute;


    }]);

})();

(function () {

  'use strict';

  /**
   * @class ute-ui.core
   * @memberOf ute-ui
   */


  /**
   * @memberof ute-ui.core
   * @description returns credit card type from card number
   * @param {String} credit card number
   * @example
   *   uteCyberSource.getCardType('4444444444444448'); // VISA
   * @returns {String} credit card type; VISA, MASTER, or AMEX
   */
  var getCardType = function (number) {
    if (number.match(/^4[0-9]{12}(?:[0-9]{3})?$/)) {
      return 'VISA';
    } else if (number.match(/^5[1-5][0-9]{14}$/)) {
      return 'MASTER';
    } else if (number.match(/^3[47][0-9]{13}$/)) {
      return 'AMEX';
    } else if (number) {
      return '';
    }
    return undefined;
  };

  /**
   * @memberof ute-ui.core
   * @description returns tokenized credit card number
   * @param {String} tokenized credit card number
   * @example
   *   uteCyberSource.getMaskedToken('9999999999991234'); // **** **** **** 1234
   * @returns {String} masked credit card number
   *   i.e., '**** **** **** 1234'
   */
  var getMaskedToken = function (token) {
    if (token.length == 15) {
      return '**** ****** *' + token.substr(11);
    } else {
      return '**** **** **** ' + token.substr(12);
    }
  };

  /**
   * @memberof ute-ui.core
   */
  var getCybersourceUrl = function (cardNumber, uteEncryption, config) {
    var rsaEncrypted = uteEncryption(cardNumber, config.modulus, config.publicExponent);

    var JSONData = {
      pan: rsaEncrypted,
      sig: config.signature,
      si: config.systemIndicator,
      ts: config.timestamp,
      type: getCardType(cardNumber).substr(0, 1),
      service: config.serviceVal
    };
    var jsonStr = JSON.stringify(JSONData);

    var url = config.url +
      '?merchantID=' + config.applicationId +
      '&jsonstring=' + encodeURIComponent(jsonStr) + '&callback=JSON_CALLBACK';
    return url;
  };

  /**
   * @class ute-ui.core.uteCyberSource
   * @name uteCyberSourceProvider
   * @description  uteCyberSource provider object
   */
  angular.module('ute.ui.core')

    .provider('uteCyberSource', function () {

      /**
       * @class ute-ui.core.uteCyberSource
       * @this uteCyberSourceProvider
       * @description  set signature url
       * @param {String} url
       * @example
       *   uteCyberSourceProvider.setSignatureUrl('http://my.backend.com/signagurePath');
       */
      this.setSignatureUrl = function (url) {
        this.signatureUrl = url;
      };

      /**
       * @class ute-ui.core.uteCyberSource
       * @this uteCyberSourceProvider
       * @description  set decryption url
       * @param {String} url
       * @example
       *   uteCyberSourceProvider.setDecryptionUrl('http://my.backend.com/decryptionPath');
       */
      this.setDecryptionUrl = function (url) {
        this.decryptionUrl = url;
      };

      this.$get = ["$http", "uteEncryption", "$q", function ($http, uteEncryption, $q) {
        var _this = this;
        return {
          getCardType: getCardType,
          getMaskedToken: getMaskedToken,

          /**
           * @class ute-ui.core.uteCyberSource
           * @description returns promise with encrypted token response
           * @param {String} credit card number
           * @example
           *   uteCyberSource.getEncryptedToken('4444444444444448').then(function(result) {
         *     console.log(result.data);
         *   });
           * @returns {HttpPromise} Future object
           */
          getEncryptedToken: function (cardNumber) {
            var deferred = $q.defer();
            $http.post(_this.signatureUrl).success(function (resp) {
              var url = getCybersourceUrl(cardNumber, uteEncryption, resp);
              deferred.resolve($http.jsonp(url));
            }).error(function (error) {
              deferred.reject('invalid cybersource environment, could not get uteEncryption signature');
            });
            return deferred.promise;
          },

          /**
           * @class ute-ui.core.uteCyberSource
           * @description returns promise with decrypted token response
           * @param {Object} response from #getEncryptedToken
           *     i.e. {token: 'xxxx', iin: 'xxxxx', rc: '100'}
           * @param {String} credit card type. i.e., 'V', 'M', or 'A'
           * @example
           *   uteCyberSource.getEncryptedToken(encrypted, 'M').then(function(result) {
         *     console.log(result.data);
         *   });
           * @returns {HttpPromise} Future object
           */
          getDecryptedToken: function (encrypted, cardType) {
            var url = _this.decryptionUrl +
              '?encryptedToken=' + encrypted.token +
              '&bin=' + encrypted.iin +
              '&result=' + encrypted.rc +
              '&creditCardType=' + cardType;
            return $http.post(url);
          }
        };
      }];
    });
})();
(function () {

  /**
   * @ngdoc service
   * @name uteEndpoint
   * @param key Endpoint key name to generate a complete url
   * @description
   *   Returns endpoint url for http(s) services
   *
   * Requirements;
   *
   *   Input/Configuration/Parameter;
   *
   *     . MUST be able to configure `baseUrl`
   *     . MUST be able to configure `basePath`
   *     . MUST be able to configure keys to override the default behaviour
   *
   *   Output
   *
   *     . MUST return complete url starting from http, https, or //
   *
   * @example
   * <script>
   *   app.config(function(uteEndpointProvider) {
 *     uteEndpointProvider.setBaseUrl("http://base.url.com");
 *     uteEndpointProvider.setBasePath("/base/path");
 *     uteEndpointProvider.setEndpoints({
 *       'custom1': "http://custom.com/foo",
 *       'custom2': "/foo/bar",
 *       'custom3': "bar",
 *     });
 *     uteEndpointProvider.set('custom4', "http://custom.com/bar");
 *   });
   *
   *  app.controller('MyCtrl', function($scope, uteEndpoint) {
 *    uteEndpoint("foo");     // http://base.url.com/base/path/foo
 *    uteEndpoint("bar");     // http://base.url.com/base/path/bar
 *    uteEndpoint("/foo");    // http://base.url.com/foo
 *    uteEndpoint("custom1"); // http://custom.com/foo
 *    uteEndpoint("custom2"); // http://base.url.com/foo/bar
 *    uteEndpoint("custom3"); // http://base.url.com/base/path/bar
 *    uteEndpoint("custom4"); // http://custom.com/bar
 *  });
   * </script>
   */

  'use strict';

  /**
   * @ngdoc provider
   * @name uteEndpointProvider
   * @description  uteEndpoint configuration object
   */
  angular.module('ute.ui.core')

    .provider('uteEndpoint', function () {
      this.baseUrl = '';
      this.basePath = '';
      this.cmsContentURL = '';
      this.endpoints = {};

      /**
       * set cms content url
       */
      this.setCMSContentURL = function (url) {
        this.cmsContentURL = url;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set all options
       * @param {Object} options
       * @example
       *   uteEndpointProvider.configure({baseUrl:"http://foo.com", basePath: "/bar"});
       */
      this.configure = function (options) {
        this.baseUrl = options.baseUrl;
        this.basePath = options.basePath;
        this.endpoints = options.endpoints;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set base url
       * @param {String} url
       * @example
       *   uteEndpointProvider.setBaseUrl("http://foo.com");
       */
      this.setBaseUrl = function (url) {
        this.baseUrl = url;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set base path
       * @param {String} path
       * @example
       *   uteEndpointProvider.setBasePath("/bar");
       */
      this.setBasePath = function (path) {
        this.basePath = path;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set all custom endpoints to override the default behaviour
       * @param {Object}  endpoints object with key/value
       * @example
       *   uteEndpointProvider.setEndpoints({foo:"/foo", bar: "https://foo.com/bar"});
       */
      this.setEndpoints = function (endpoints) {
        this.endpoints = endpoints;
      };

      // set cms content url
      this.setCMSContentURL = function (url) {
        this.cmsContentURL = url;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set a single custom endpoint to override the default behaviour
       * @param key key of endpoint, i.e. 'myurl"
       * @param url url, i.e. 'https://my.custom.com/url/endpoint"
       * @example
       *   uteEndpointProvider.set("foo", "https://foo.com/bar");
       */
      this.set = function (key, url) {
        this.endpoints[key] = url;
      };

      this.$get = function () {
        var _this = this;
        return function (key, typeOfEndpoint) {

          // if it's a cms call
          if (typeOfEndpoint && typeOfEndpoint === 'cms') {
            if (!_this.cmsContentURL) {
              _this.cmsContentURL = _this.baseUrl;
            }
            return _this.cmsContentURL + key;
          }

          // not a cms call
          if (_this.endpoints[key]) {
            var url = _this.endpoints[key];
            if (url.match(/^http/)) {
              return url;
            } else if (url.match(/^\//)) {
              return _this.baseUrl + url;
            } else {
              return _this.baseUrl + _this.basePath + '/' + url;
            }
          } else if (key.match(/^\//)) {
            return _this.baseUrl + key;
          } else {
            return _this.baseUrl + _this.basePath + '/' + key;
          }
        };
      };
    });
})();

(function() {
  'use strict';

/**
 * @ngdoc module
 * @name bssPayment
 * @description
 * # A module for bss payment including 3 directives
 *
 */

angular.module('bssPayment', [
				'makePayment',
				'changePaymentMethod',
				'paymentHistory',
				'ute.datalayer.common'
]);
})();

/**
 * Created by james.magpantay on 4/4/2016.
 */

(function () {
  'use strict';

  angular.module('changeSubscriberName',[
    'pascalprecht.translate',
    'ui.router',
    'ngCookies'


  ])




})();


'use strict';

/**
 * @ngdoc module
 * @name uteInternetUsage
 * @description
 * # The ute-internet-usage module depends on 4 other modules. Import these modules make some directives available.
 *
 */

//++++
angular.module('ute-internet-usage', ['ute-internet-usage-daily',
                                      'ute-internet-usage-monthly',
                                      'ute-internet-usage-notification',
                                      'ute-internet-usage-nav'
                                      ])
.run([function(){

}])

.controller('_scopeCtrl',['$scope', function($scope){}]);


//++++
angular.module('ute-internet-usage-daily', [])
.run([function(){

}]);

//++++
angular.module('ute-internet-usage-monthly', [])
.run([function(){

}]);

//++++
angular.module('ute-internet-usage-notification', [])
.run([function(){

}]);

//++++
angular.module('ute-internet-usage-nav', [])
.run([function(){

}]);



/* Translating filter */
angular.module('ute-internet-usage')
.filter('res', ['resource', function(resource){
	return function(input){
		return resource.get(input);
	};
}]);

(function() {
  'use strict';

  /**
   * @ngdoc module
   * @name changePaymentMethod
   */

  angular.module('changePaymentMethod', [

  ]);
})();

(function() {
  'use strict';

  /**
   * @ngdoc module
   * @name bssPayment
   * @description
   * # A module for bss payment including 3 directives
   *
   */

  angular.module('makePayment', [

  ]);
})();

(function() {
  'use strict';

  /**
   * @ngdoc module
   * @name bssPayment
   * @description
   * # A module for bss payment including 3 directives
   *
   */

  angular.module('paymentHistory', ['smoothScroll']);
})();

(function () {
  'use strict';
  angular.module('ute.payment.helper.view', ['ute.common.component.directives']);
})();

/**
 * Created by james.magpantay on 4/4/2016.
 */

(function () {
  'use strict';

  angular.module('ute.resetVoiceMailbox',[
    'pascalprecht.translate',
    'ui.router'
  ])




})();


(function () {
  'use strict';

  angular.module('ute.common.simcard.change.form', ['ngMessages', 'ute.common.simcard.change.service','ute.datalayer.common']);
})();

(function () {
  'use strict';

  angular.module('ute.common.simcard.change.confirmation', ['ngMessages', 'ute.common.simcard.change.service','ute.datalayer.common']);
})();

(function () {
  'use strict';

  angular.module('ute.common.simcard.change.success', []);
})();

'use strict';

/**
 * @ngdoc overview
 * @name totesApp
 * @description
 * # totesApp
 *
 * Main module of the application.
 */

angular
  .module('totesApp', [
    'pricePlanChanges', // Price Plan Changes - bruce.christie@mobilelive.ca & holt.mansfield@mobilelive.ca
    'selfServe',
    'ngCookies',
    'ngResource',
    'ngSanitize',
    'ngTouch',
    'ngMessages',
    'ngAnimate',
    'ui.bootstrap',
    'ui.router',
    'ute.ui.core',
    'myr.modules.commonUtilities',
    'myr.modules.notificationBanner',
    'myr.modules.rgcl',
    'myr.modules.viewBill',
    'myr.modules.briteBill',
    'myr.modules.paymentTopBar',
    'myr.modules.accountBalanceData',
    'mdo-angular-cryptography',
    'ute.common.suspend.ctn',
    'angularMoment',
    'timer',
    'duScroll',
    'bssPayment',
    'makePayment',
    'changePaymentMethod',
    'ngTinyScrollbar',
    'translations',
    'vcRecaptcha',
    'ute-internet-usage',
    'changeSubscriberName',
    'ute.resetVoiceMailbox',
    'ute.blocks.language.switcher',
    'ute.common.voicemail.resetPassword',
    'ute.common.suspend.ctn',
    'ute.common.reactivate.ctn',
    'ute.common.simcard.change',
    'ute.common.component.directives',
    'ute.rogers.setpassword',
    'ute.rogers.user.registration',
    'ute.datalayer.common',
    'ute.rogers.datalayer.integration.common',
    'ute.blocks.persistent.storage',
    'ute.fraud.logging'
  ]);

angular.module('rfrApp', ['schemaForm', 'infinite-scroll', 'ngCookies']);

angular.module('pricePlanChanges', ['ngDialog']);

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('selfServe', []);
})();

(function () {
  'use strict';

  angular.module('ute.common.component.directives', ['mdo-angular-cryptography', 'ng']);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.commonUtilities', []);

})();

(function() {
  'use strict';

  angular.module('myr.modules.accountBalanceData', []);
})();

(function () {
  'use strict';

  angular.module('myr.modules.briteBill', []);
})();

(function() {
  'use strict';

  angular.module('myr.modules.paymentTopBar', ['myr.modules.accountBalanceData']);
})();

(function() {
  'use strict';

  angular.module('myr.modules.viewBill', ['totesApp', 'ui.router']);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner', []);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.rgcl', []);
})();

/**
 * Created by james.magpantay on 4/4/2016.
 */

(function () {

  'use strict';

  angular
    .module('changeSubscriberName')
    .controller('changeSubscriberNameCtrl', changeSubscriberNameCtrl);

  changeSubscriberNameCtrl.$inject = ['$scope', '$rootScope','$state','$window','changeSubscriberNameService'];

  function changeSubscriberNameCtrl($scope, $rootScope,$state,$window,changeSubscriberNameService) {
    var vm = this;

    vm.init = init;
    vm.csns = changeSubscriberNameService;
    vm.submit = submit;
    vm.back = back;
    vm.showFull = showFull;
    vm.bannedWords = null;

    vm.init();

    function init() {
      vm.subscriberName = changeSubscriberNameService.getSubscriberName();
      vm.phoneNumber = changeSubscriberNameService.getPhoneNumber();
       changeSubscriberNameService.getBannedWords().then(
                        function (data) {
                          vm.bannedWords = data;
                        },
                        function (error) {

                        }
                      );
    }

    function submit(){
      var input = $scope.csnForm;
      if (input.firstName.$modelValue == undefined ){
        vm.nullFirstName = true;
        if (input.lastName.$modelValue == undefined ){
          vm.nullLastName = true;
          return;
        }
        return;
      }

      if (input.lastName.$modelValue == undefined ){
        vm.nullLastName = true;
        return;
      }

      var firstName = input.firstName.$modelValue.toLowerCase();
      var lastName = input.lastName.$modelValue.toLowerCase();

      function isNameExistsInBannedList(name){
         var isNameBanned = false;
         var trimmedName = name.replace(/[^a-z0-9]/ig, "");
                var formattedName = name.replace(/[^a-z]/ig, "");
            angular.forEach(vm.bannedWords.en, function(value, key) {
                    if( (name.indexOf(value.toLowerCase()) >=0) || (trimmedName.indexOf(value.toLowerCase()) >=0) || (name.indexOf("private") >= 0) || (name.indexOf("privé") >= 0) || (formattedName=="")){
                       if((trimmedName.indexOf("jo") >= 0 ||trimmedName.indexOf("jos") >= 0) ){
                         if (trimmedName =="jo" || trimmedName =="jos"){
                                isNameBanned = true;
                         }
                       }else{
                                isNameBanned = true;
                       }
                    }
                });
                angular.forEach(vm.bannedWords.fr, function(value, key) {
                    if( (name.indexOf(value.toLowerCase()) >=0) || (trimmedName.indexOf(value.toLowerCase()) >=0) || (name.indexOf("private") >= 0) || (name.indexOf("privé") >= 0) || (formattedName=="")){
                        if((trimmedName.indexOf("jo") >= 0 ||trimmedName.indexOf("jos") >= 0) ){
                           if (trimmedName =="jo" || trimmedName =="jos"){
                               isNameBanned = true;
                            }
                        }else{
                             isNameBanned = true;
                        }
                    }
               });

         return isNameBanned;
      }

      if (isNameExistsInBannedList(firstName)){
         vm.bannedFirstName = true;
            if(isNameExistsInBannedList(lastName)){
               vm.bannedLastName = true;
                  return;
               }
            return;
      }
      if(isNameExistsInBannedList(lastName)){
         vm.bannedLastName = true;
           return;
      }

        vm.loading = true;

      changeSubscriberNameService.changeSubscriberName(input).then(
        function(response){
          vm.submitted = true;
          if(response.status == 'success'){
            vm.success = true;
            vm.subscriberName = changeSubscriberNameService.getSubscriberName();
          }else{
            vm.success = false;
          }
            vm.loading = false;
        },function(error){
              vm.loading = false;
      }
      );
    }

    function back(){
      $state.go('wireless');
    }

    function showFull(){
    }
  }
})();

/**
 * Created by james.magpantay on 4/5/2016.
 */
(function () {
  'use strict';

  angular
    .module('changeSubscriberName')
    .filter('tel', function () {
      return function (tel) {
        if (!tel) { return ''; }

        var value = tel.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
          return tel;
        }

        var country, city, number;

        switch (value.length) {
          case 10: // +1PPP####### -> C (PPP) ###-####
            country = 1;
            city = value.slice(0, 3);
            number = value.slice(3);
            break;

          case 11: // +CPPP####### -> CCC (PP) ###-####
            country = value[0];
            city = value.slice(1, 4);
            number = value.slice(4);
            break;

          case 12: // +CCCPP####### -> CCC (PP) ###-####
            country = value.slice(0, 3);
            city = value.slice(3, 5);
            number = value.slice(5);
            break;

          default:
            return tel;
        }

        if (country == 1) {
          country = "";
        }

        number = number.slice(0, 3) + '-' + number.slice(3);

        return (country + " " + city + "-" + number).trim();
      };
    });

})();


/**
 * Created by james.magpantay on 4/4/2016.
 */
(function () {
  'use strict';


  angular
    .module('changeSubscriberName')
    .config(changeSubscriberName);

  changeSubscriberName.$inject = ['$translateProvider'];

  function changeSubscriberName($translateProvider){
    $translateProvider.translations('en', {
      csn : {
        header:"Change Subscriber Name for",
        subHeader: "Here you can change the name linked to this telephone number, and also what appears on your invoice and caller ID.",
        name: "Current name:",
        update:"Update your subscriber's name:",
        firstName: "First name",
        lastName: "Last name",
        cancel:"Cancel",
        saveChanges:"Save changes",
        success:"Success!",
        successSub:"Your subscriber's name has been updated. This change will be reflected on your next bill.",
        updatedDetails:"Updated Details",
        wireless:"Wireless number:",
        name2: "Name:",
        back: "< Go back",
        failure:"Currently System Unavailable.",
        failureSub:"Please try again.",
        firstNameError:"Please enter valid First Name",
        lastNameError:"Please enter valid Last Name",
        nullFirstName:"Please enter new First Name",
        nullLastName:"Please enter new Last Name",
        bannedFirstNameError:"Please enter valid First Name",
        bannedLastNameError:"Please enter valid Last Name"

      },
      wack:"dasdsadas"

    });
    $translateProvider.translations('fr', {
      csn : {
        header:"Modifier le nom de l’abonné",
        subHeader: "Ici, vous pouvez modifier le nom lié à ce numéro de téléphone, ce qui apparaît sur votre facture et sur l'affichage des appels.",
        name: "Nom actuel:",
        update:"Mettre à jour le nom de l’abonné:",
        firstName: "Prénom",
        lastName: "Nom de famille",
        cancel:"Annuler",
        saveChanges:"Enregistrer les modifications",
        success:"C’est fait!",
        successSub:"Votre nom d’abonné a été mis à jour. Ce changement figurera sur votre prochain relevé.",
        updatedDetails:"Détails mis à jour",
        wireless:"Numéro de sans-fil:",
        name2: "Nom:",
        back: "< Précédent",
        failure:"Désolés, nous éprouvons actuellement des difficultés techniques.",
        failureSub:"Veuillez réessayer plus tard. Merci de votre patience.",
        firstNameError:"Veuillez entrer un prénom valide",
        lastNameError:"Veuillez entrer un nom valide",
        nullFirstName:"Veuillez entrer un nouveau prénom",
        nullLastName:"Veuillez entrer un nouveau nom",
        bannedFirstNameError:"Veuillez entrer un prénom valide",
        bannedLastNameError:"Veuillez entrer un nom valide"
      }

    });


    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitize');
  }



})();

'use strict';

angular.module('changeSubscriberName').config(['$stateProvider', '$urlRouterProvider', '$httpProvider',
  function ($stateProvider, $urlRouterProvider, $httpProvider) {

    var allStates = [
      {
        name: 'changesubscribername',
        url: '/changesubscribername',
        controller: 'changeSubscriberNameCtrl',
        controllerAs: 'csn',
        templateUrl: 'module/changeSubscriberName/changeSubscriberName.html'
      }
    ];

    for (var i = 0; i < allStates.length; i++) {
      $stateProvider.state(allStates[i]);
    }


  }]);

/**
 * Created by james.magpantay on 4/4/2016.
 */

(function () {

  'use strict';

  angular
    .module('changeSubscriberName')
    .factory('changeSubscriberNameService', changeSubscriberNameService);

  changeSubscriberNameService.$inject = ['$http','$window'];

  function changeSubscriberNameService($http,$window) {

    var service = {
      changeSubscriberName : changeSubscriberName,
      getPhoneNumber: getPhoneNumber,
      getSubscriberName: getSubscriberName,
      getAccountNumber: getAccountNumber,
      getBannedWords : getBannedWords
    };

    return service;

    function getPhoneNumber(){
      return $window.localStorage.getItem('phoneNumber');
    }

    function getSubscriberName(){
      return $window.localStorage.getItem('subscriberName');
    }

    function getAccountNumber(){
      return $window.localStorage.getItem('accountNumber');
    }

    function getBannedWords() {
            var httpBannedWordRequest = $http({
               method : 'GET',
               url : '/cmsbusiness/json/bannedWords.json'
            });

            return httpBannedWordRequest.then(
               function (response) {
                  return response.data;
                  }, function (error) {
                    return error;
                    }
                  );
            }

    function changeSubscriberName(input){
      var accountNumber = service.getAccountNumber();
      var phoneNumber = service.getPhoneNumber();
      var fullName = input.firstName.$modelValue + ' ' + input.lastName.$modelValue;
      var oldFullName = service.getSubscriberName();
      var splitName = oldFullName.split(" ");
      var oldLastName = splitName[splitName.length-1]; //The last one
      var oldFirstName = "";
      for (var i=0; i < splitName.length-1; i++){
        oldFirstName += splitName[i] + " "
      }
      oldFirstName = oldFirstName.slice(0, -1);
      var request = {
        oldFirstName:oldFirstName,
        oldLastName:oldLastName,
        firstName: input.firstName.$modelValue,
        lastName: input.lastName.$modelValue,
        accountNumber: accountNumber,
        telephoneNumber: phoneNumber,
        medium:"Web",
        applicationId: "SMB"
      };

      var httpRequest = $http({
        method : 'POST',
        url : '/web/RogersServices.portal/smb/api/business/v1/wirelessDashBoard/changeSubscriberName',
        data : request
      });


      return httpRequest.then(
        function(response){
          var status = response.data.content.status;
          if(status == 'success'){
            $window.localStorage.setItem('subscriberName',fullName);
          }
          return response.data.content;
        },
        function(error){
          console.log('error');
          return error;
        }
      );

    }


  }
})();

/**
 * Created by james.magpantay on 12/29/2015.
 */
(function () {
    'use strict';

    angular.
    module('changeSubscriberName')
        .directive('inputValidator', inputValidator);

    function inputValidator() {
        return {
            restrict: 'EA',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                var maxlength = Number(attrs.inputValidator);
                ngModelCtrl.$parsers.push(function (text) {
                  var transformedInput = text.replace(/[^a-zA-Z0-9 àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ]/, '');
                    if (transformedInput != text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    if (text.length > maxlength) {
                        transformedInput = text.substring(0, maxlength);
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                });
            }
        };
    }

})();



/**
 * @ngdoc module
 * @name makePayment
 * @description
 * #
 *
 */

(function($){

	'use strict';

	angular.module('changePaymentMethod')
		.directive('changePaymentMethod', changePaymentMethodDirective)
		.factory('updatePaymentTypeService', updatePaymentTypeService)
		.controller('changePaymentMethodController', changePaymentMethodController)

	changePaymentMethodDirective.$inject = [];
	updatePaymentTypeService.$inject = ['$rootScope', 'backend', '$q'];
	changePaymentMethodController.$inject = ['$scope', '$rootScope', '$window','updatePaymentTypeService','userLanguage', 'resource'];


	//++++++++++
	function changePaymentMethodDirective(){
		return {
			restrict: 'AE',
			scope: {accountNo: '=',contactId:'=',methodOfPayment:'=',methodOfPaymentCode:'=',nickName:'=',lang:'=',lob:'=',isCable:'='},
			templateUrl: 'scripts/modules/changePayMethod/changePaymentMethod.html',
			link: function(scope, element, attrs){

			}
		}
	}

	//++++++++++
	function updatePaymentTypeService($rootScope, backend, $q){
		return {
			updatePaymentType: function(request){
				return backend.post('changePaymentMethod', request)
					.then(	function(data){
						return data;
					}, function(error){
						return $q.reject('updatePaymentMethod request Failed');
					}
				);
			},
			broadcast: function(){
				$rootScope.$broadcast('updatePaymentTypeService');
			}
		}
	}

	//++++++++++
	function changePaymentMethodController($scope, $rootScope,$window,updatePaymentTypeService,userLanguage, resource){
		$scope.paymentMethods=[
			{name:"Pre-Authorized Debit", isActive:false, class:"borderRedSecond", size:5,radio:"thirdRadio"},
			{name:"Credit Card", isActive:false, class:"borderRedFirst", size:5, radio:"fourthRadio"},
			{name:"Invoice", isActive:false, class:"borderRedSecond", size:2,radio:"fifthRadio"}
		];
		$scope.ACCOUNT={
			PAYMENTMETHOD: "Credit Card",
			ACCOUNTNO: $scope.accountNo
		};

		$scope.lang = userLanguage();

                resource.onChanged(function () {
                  $scope.lang = userLanguage();
                }, $scope);



		$scope.showFocusedPaymentMethod=function(name){
			for( var i=0;i<paymentMethodsLength;i++){
				if(name==paymentMethods[i].name){
					$scope.paymentMethods[i].isActive=true;
					$scope.paymentMethods[i].class="borderRedFirst";
				}else{
					$scope.paymentMethods[i].isActive=false;
					$scope.paymentMethods[i].class="borderRedSecond";
				}
			}
		}
		var accounts=$scope.ACCOUNT;
		var paymentMethods=$scope.paymentMethods;
		var paymentMethodsLength=$scope.paymentMethods.length;
		if($(window).width()>992){
			$scope.showFocusedPaymentMethod(accounts.PAYMENTMETHOD);
		}
		var chequing=$scope.paymentMethods[0].name;
		var preAuthorized=$scope.paymentMethods[1].name;
		var invoice=$scope.paymentMethods[2].name;
		$scope.bodyFrClass = $('body').hasClass('fr');
		$scope.showBankingSection=function(type){
			$scope.paymentMethods[0].isActive=false;
			$scope.paymentMethods[1].isActive=false;
			$scope.thirdRadio=false;
			$scope.fourthRadio=false;
			$scope.fifthRadio=false;
			$scope.paymentMethods[2].isActive=false;
			$scope.enableButton = true;
			if(type==chequing){
				$scope.paymentMethods[0].isActive=true;
				$scope.thirdRadio=true;
			}else if(type==preAuthorized){
				$scope.paymentMethods[1].isActive=true;
				$scope.fourthRadio=true;
			}else{
				$scope.paymentMethods[2].isActive=true;
				$scope.fifthRadio=true;
			}
		}



		$scope.showTab=function(name){
			$scope.showFocusedPaymentMethod(name);
		}

    $scope.months= [{name:'January',value:'01'},
      {name:'February',value:'02'},
      {name:'March',value:'03'},
      {name:'April',value:'04'},
      {name:'May',value:'05'},
      {name:'June',value:'06'},
      {name:'July',value:'07'},
      {name:'August',value:'08'},
      {name:'September',value:'09'},
      {name:'October',value:'10'},
      {name:'November',value:'11'},
      {name:'December',value:'12'}];
		$scope.years=[];
		var startYear = new Date().getFullYear();
		for(var i=0; i<=10; i++){
			$scope.years[i]= startYear++;
		}
		$scope.selectedMonth={name:"bss_month", value:""};
		$scope.selectedYear={name:"Year", value:""};

		//++++++++++
		$scope.changeMonth=function(month){
			$scope.selectedMonth=month;
			$scope.monthFlag=false;
			$scope.isValidMonth=$scope.monthFlag;
			if($scope.isClicked)
				$scope.changeButtonStateForCreditCard();
		}

		//+++++++++
		$scope.changeYear=function(year){
			$scope.selectedYear=year;
			$scope.yearFlag=false;
			$scope.isValidYear=$scope.yearFlag;
			if($scope.isClicked)
				$scope.changeButtonStateForCreditCard();
		}

    $scope.redirectToLegacyPayment = function () {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
      $window.location.href = '../../../business/ute/smb/transactions/uteBillingAndPayment';
    }
		//+++++++++
		$scope.showUpdatedPaymentMethod=function(updateType){
			$scope.showChangePaymentMethodSection=true;
			$scope.loadingIndicator=true;

      if(updateType == "C" && !$scope.isValidSecurityCode && ($scope.securityCode.length==3 || $scope.securityCode.length==4) &&  !$scope.isValidMonth &&  !$scope.isValidYear && !$scope.isValidCreditCardNumber && !$scope.isValidCreditCardScheme) {
        var request = {
          refresh: false,
          applicationId: 'Rogers.com',
          flowType: "paymentTypeChange",
          acctNo: $scope.accountNo,
          contactID: $scope.contactId,
          paymentMethod: "C",
          ccType: $('#cardScheme').val(),
          ccNumber: $('#token').val(),
          ccExpiryMonth: $scope.selectedMonth,
          ccExpiryYear: $scope.selectedYear,
          securityCode: $scope.securityCode,
          LOB:$scope.lob
        };
      }else if(updateType == "D" && !$scope.isValidTransitCode && !$scope.isValidBankCode &&  !$scope.isValidAccountNumber && !$scope.isValid) {
        var request = {
          refresh: false,
          applicationId: 'Rogers.com',
          flowType: "paymentTypeChange",
          acctNo: $scope.accountNo,
          contactID: $scope.contactId,
          paymentMethod: "D",
          bankCode: $scope.bankCode,
          bankBranchNo: $scope.transitCode,
          bankAcctNo: $scope.accountNumber,
          LOB: $scope.lob

        };
      } else if(updateType == "I") {
        var request = {
          refresh: false,
          applicationId: 'Rogers.com',
          flowType: "paymentTypeChange",
          acctNo: $scope.accountNo,
          contactID: $scope.contactId,
          paymentMethod: "CASH",
          LOB: $scope.lob

        };
      }

			updatePaymentTypeService.updatePaymentType(request)
				.then(function(data) {
					if(data.status.toLowerCase() =='success'){

						if (window._satellite) _satellite.track('actv-myrogersbus-chg method of payment-complete');
						console.log("actv-myrogersbus-chg method of payment-complete");
						$scope.content = data;
						$scope.showUpdatedPayment = true;
						window.scrollTo(0,0);
						for(var i=0;i<paymentMethodsLength;i++){
							if($scope.paymentMethods[i].isActive){
								if($scope.paymentMethods[i].name == 'Credit Card') {
									if ($('#cardScheme').val() == 'MASTERCARD') {
										$scope.cardUrl = 'images/masterCard.png';
									}else if($('#cardScheme').val() == 'VISA'){
										$scope.cardUrl = 'images/visa.png';
									}else if($('#cardScheme').val() == 'AMEX'){
										$scope.cardUrl = 'images/americanExpress.png';
									}
									$scope.updatedPaymentMethod = $scope.paymentMethods[i].name;
									$scope.cardNumber = $('#maskedCardNumber').val();
									$scope.showCardImage = true;
								}else{
									$scope.showCardImage = false;
									$scope.ACCOUNT.PAYMENTMETHOD=$scope.paymentMethods[i].name;

									$scope.updatedPaymentMethod = $scope.paymentMethods[i].name;

								}
							}
						}
						$scope.loadingIndicator=false;
						$scope.showChangePaymentMethodSection=true;
					}else{
						$scope.showChangePaymentMethodErrorSection=true;
						$scope.showChangePaymentMethodSection=true;
					}
				}, function(error){
					if (window._satellite) _satellite.track('actv-myrogersbus-chg method of payment-error');
					console.log("actv-myrogersbus-chg method of payment-error");
					$scope.loadingIndicator=false;
					$scope.content=error;
					$scope.showChangePaymentMethodErrorSection=true;
					$scope.showChangePaymentMethodSection=true;
				});

		}

		$scope.monthFlag=true;
		$scope.yearFlag=true;
		$scope.securityCode="";
		$scope.paymentAmount="";
		$scope.transitCode="";
		$scope.bankCode="";
		$scope.accountNumber="";
		$scope.enableButton = true;
		$scope.isClicked=false;

		//+++++++++++
		$scope.validateCreditCardForm=function(){

			$scope.isValidCreditCardNumber=true;
			$scope.isValidSecurityCode=$scope.creditCardForm.securityCode.$error.required;
			$scope.isValidMonth=$scope.monthFlag;
			$scope.isValidYear=$scope.yearFlag;
			$scope.isValidCreditCardScheme=false;
			$scope.isValidCreditCardNumber=false;
			if($('#token').val()=="" || $('#token').val()=="UNKNOWN"){
				$scope.isValidCreditCardNumber=true;
				$('#cardNumberErrorSection').show();
			}else if($('#cardScheme').val() != 'MASTERCARD' && $('#cardScheme').val() != 'VISA' && $('#cardScheme').val() != 'AMEX'){
				$scope.isValidCreditCardScheme=true;
				$('#cardSchemeErrorSection').show();
				$('#token').val("");
			}

      if($('#cardScheme').val() == 'AMEX'){
        if($scope.securityCode.length!=4)
          $scope.isValidSecurityCode=true;
      }else if($('#cardScheme').val() == 'MASTERCARD' || $('#cardScheme').val() == 'VISA'){
        if($scope.securityCode.length!=3)
          $scope.isValidSecurityCode=true;
      }

			$scope.enableButton = !$scope.isValidSecurityCode && ($scope.securityCode.length==3 || $scope.securityCode.length==4) &&  !$scope.isValidMonth &&  !$scope.isValidYear;
			if(!$scope.isValidSecurityCode && ($scope.securityCode.length==3 || $scope.securityCode.length==4) &&  !$scope.isValidMonth &&  !$scope.isValidYear && !$scope.isValidCreditCardNumber && !$scope.isValidCreditCardScheme){
				$scope.showUpdatedPaymentMethod("C");
			}else{
				$scope.isClicked=true;
			}
		}

		//+++++++++
		$scope.changeButtonStateForCreditCard=function(){
			if(!$scope.isValidSecurityCode && $scope.securityCode.length==3 &&  !$scope.isValidMonth &&  !$scope.isValidYear){
				$scope.enableButton = true;
			}else{
				$scope.enableButton = false;
			}
		}

		//++++++++++++++++
		$scope.validateSecurityCode=function(){
			var securityCodeLength=$scope.securityCode.length;
			if(securityCodeLength>0){
				$scope.isValidSecurityCode=false;
				if($scope.isClicked){
					$scope.changeButtonStateForChequing();
				}
			}
		}


		$scope.termsAndConditions=false;
		$scope.validateChequingForm=function(){
			$scope.isValidTransitCode=$scope.chequingForm.transitCode.$error.required;
			$scope.isValidBankCode=$scope.chequingForm.bankCode.$error.required;
			$scope.isValidAccountNumber=$scope.chequingForm.accountNumber.$error.required;
			$scope.isValid=!$scope.termsAndConditions;
			$scope.enableButton = !$scope.isValidTransitCode && !$scope.isValidBankCode &&  !$scope.isValidAccountNumber && !$scope.isValid;
			if(!$scope.isValidTransitCode && !$scope.isValidBankCode &&  !$scope.isValidAccountNumber && !$scope.isValid){
				$scope.showUpdatedPaymentMethod("D");
			}else{
				$scope.isClicked=true;
			}
		}

		$scope.validateTransitCode=function(){
			var transitCodeLength=$scope.transitCode.length;
			if(transitCodeLength>0){
				$scope.isValidTransitCode = false;
				if($scope.isClicked){
					$scope.changeButtonStateForChequing();
				}
			}
		}

		$scope.validateBankCode=function(){
			var bankCodeLength=$scope.bankCode.length;
			if(bankCodeLength>0){
				$scope.isValidBankCode = false;
				if($scope.isClicked){
					$scope.changeButtonStateForChequing();
				}
			}
		}

		$scope.validateAccountNumber=function(){
			var accountNumberLength=$scope.accountNumber.length;
			if(accountNumberLength>0){
				$scope.isValidAccountNumber = false;
				if($scope.isClicked){
					$scope.changeButtonStateForChequing();
				}
			}
		}

		$scope.validateTermsAndCondtions=function(){
			if($scope.isClicked){
				$scope.changeButtonStateForChequing();
			}
		}

		$scope.changeButtonStateForChequing=function(){
			if($scope.isValidTransitCode == false && $scope.isValidBankCode == false &&  $scope.isValidAccountNumber == false && $scope.isValid == false){
				$scope.enableButton = true;
			}else{
				$scope.enableButton = false;
			}
		}

		$scope.validateAndSubmitForm=function(){
            if (window._satellite) _satellite.track('actv-myrogersbus-chg method of payment-start');
            console.log("actv-myrogersbus-chg method of payment-start");
			if($scope.paymentMethods[0].isActive){
				$scope.validateChequingForm();
			}else if($scope.paymentMethods[1].isActive){
				$scope.validateCreditCardForm();
			}else if($scope.paymentMethods[2].isActive){
				$scope.showUpdatedPaymentMethod("I");
			}
		}

		$scope.date=new Date();
		$scope.requiredDate= $scope.date.getDate()+", "+$scope.date.getFullYear();
		$scope.requiredMonth=$scope.months[$scope.date.getMonth()].name;
    $scope.showCreditCardForStandAloneCable = function(){
      if($(window).width()<992 && $scope.isCable == true)
        $scope.paymentMethods[1].isActive = true
    }

    $scope.showCreditCardForStandAloneCable();

		var content = $(".contentDesktopView");
		content.popover({
			trigger:"manual",
			placement: "right",
			html:"true",
			title:"",
			content: function() {
				return  $(".popoverContentDesktop").html();
			}
		}).on("click", function () {
			var _this = this;
			$(this).popover("show");
			$(this).siblings(".popover").on("click", function () {
				$(_this).popover('hide');
			});
		}).on("mouseleave", function () {
			var _this = this;
			setTimeout(function () {
				if (!$(".popover:hover").length) {
					$(_this).popover("hide")
				}
			}, 100);
		});


		var contentSmallDevice = $(".contentSmallDevices");
		contentSmallDevice.popover({
			trigger:"manual",
			placement: "bottom",
			html:"true",
			content: function() {
				return  $(".popoverContentMobile").html();
			}
		}).on("click", function () {
			var _this = this;
			$(this).popover("show");
			$(this).siblings(".popover").on("click", function () {
				$(_this).popover('hide');
			});
		}).on("mouseleave", function () {
			var _this = this;
			setTimeout(function () {
				if (!$(".popover:hover").length) {
					$(_this).popover("hide")
				}
			}, 100);
		});
	}

})(jQuery);

/**
 * @ngdoc module
 * @name makePayment
 * @description
 * #
 *
 */

(function ($) {

    'use strict';

    angular.module('makePayment')
        .directive('makePayment', makePaymentDirective)
        .directive('numbersOnly', numbersOnlyDirective)
        .directive('errorMessage', errorMessageDirective)
        .directive('ngEnter', ngEnterDirective)
        .factory('makePaymentService', makePaymentService)
        .controller('makePaymentController', makePaymentController)

    //+++++++++++ Dependency injecting block
    makePaymentDirective.$inject = [];
    numbersOnlyDirective.$inject = [];
    errorMessageDirective.$inject = [];
    ngEnterDirective.$inject = [];
    makePaymentService.$inject = ['backend', '$q', '$rootScope'];
    makePaymentController.$inject = ['myrAccountOverviewService','sessionStorage','ajax','$scope', '$rootScope', '$window', 'makePaymentService', 'userLanguage', 'resource', 'ute.datalayer.common.service'];


    //+++++++++++++++ makePaymentDirective driving function
    function makePaymentDirective() {
        return {
            restrict: 'AE',
			scope: {accountNo:'=',brtSwitchvalue:'=',brtWhitelistvalue:'=',contactId:'=', lob:'=', dueDate:'=', accountBalance:'=',lng:'=',dollar:'=',cents:'=',name:'=',bankPaymentId:'='},
            templateUrl: 'scripts/modules/makePayment/makePayment.html',
			link: function(scope, element, attrs){
			}
        }
    }

    //+++++++++++++++
    function makePaymentService(backend, $q, $rootScope) {
        return {
            makePayment: function (request, callback) {
                return backend.post('makePayment', request).then(
                    function (data) {
                        return data;
                    },
                    function (error) {
                        if (error && error.data && error.data.data && error.data.data.reason) {
                            if (error.data.data.reason.indexOf("invalid") !== -1 || error.data.data.reason.indexOf("declined") !== -1)
                                return $q.reject("bss_makePayment_invalid_cc");
                            else {
                                return $q.reject("bss_makePayment_generic_error");
                            }
                        } else {
                            return $q.reject("bss_makePayment_generic_error");
                        }
                    }
                );
            },
            broadcast: function () {
                $rootScope.$broadcast('makePaymentService');
            }
        }
    }

    //+++++++++++++++
    function makePaymentController(accountOverviewService,sessionStorage,ajax,$scope, $rootScope, $window, makePaymentService, userLanguage, resource, dataLayerService) {
        $scope.loadingIndicator = false;
        var flag;
        var brtflag = false;
        ajax.getBrtSwitches().then(
            function (data) {
              angular.forEach(data, function (obj, key) {
                    if(obj.id == "BRT_BANK_PAYMENTID"){
                        $scope.brtSwitchvalue = brtflag;
                        if (obj.switchIsOn == false) {
                            brtflag = true
                            flag = obj.id;
                            ajax.getPermissions().then(
                              function (data) {
                                angular.forEach(data, function (obj, key) {
                                  angular.forEach(obj, function (x, key) {
                                    if (x.permission == flag) {
                                      $scope.brtSwitchvalue = brtflag;
                                    }
                                  });
                                });
                              });
                          }else{
                           var whitelistval = false;
                            var usernameDetails = JSON.parse(sessionStorage.getSessionStorageValue('accountInfo'));
                            var requestData ={
                              userId : usernameDetails.userName,
                              brtSwitch : obj.id
                            }
                            ajax.gethasPermissions(requestData).then(
                              function (data) {
                                if(data.hasBrtPermission == whitelistval){
                                    $scope.brtWhitelistvalue = false;
                                }else{
                                    $scope.brtWhitelistvalue = true;
                                }
                                
                              })
                          }
                     }
              });
            });
            if(accountOverviewService.getSelectedAccountDetail().accountBalance.bankPaymentId){
                $scope.bankPaymentId = accountOverviewService.getSelectedAccountDetail().accountBalance.bankPaymentId;
              }
		$scope.makePaymentBreadCrumb=[{name:"Enter Information", isActive:true, selection:"active"},
			{name:"Review", isActive:false, selection:"inactive"},
			{name:"Confirmation", isActive:false, selection:"inactive"}
		];
        $scope.monthFlag = true;
        $scope.yearFlag = true;
        $scope.securityCode = "";
        var centsCheck = $scope.cents;
        if (centsCheck == undefined) {
            $scope.cents = "00";
        }
        $scope.paymentAmount = $scope.dollar + "." + $scope.cents;
        $scope.showOnlineBanking = false;
        $scope.showCreditCardBanking = false;
        $scope.lng = userLanguage();
		$scope.bankDetails = [
              {name:"BMO",href:"http://www.bmo.com/home?redirect_uri=www.bmo.ca"},{name:"CIBC",href:"http://cibc.com/ca/personal.html"},
              {name:"laurentianBank",href:"https://www.laurentianbank.ca/en/personal_banking_services/index.html"},{name:"manulifeFinancial",href:"http://www.manulife.ca/canada/canada1.nsf/public/homepage"},
              {name:"nationalBank",href:"http://www.nbc.ca/"},{name:"RBC",href:"http://www.rbcroyalbank.com/personal.html"},
              {name:"scotiaBank",href:"http://www.scotiabank.com/ca/en/0,,2,00.html"},{name:"tdBank",href:"http://www.td.com/"}
         ];

        if ($(window).width() > 992) {
            $scope.showCreditCardBanking = true;
        }

        $scope.showBankingSection = function (type) {
            if (type == 'online' && $scope.showOnlineBanking == false) {
                $scope.showOnlineBanking = true;
                $scope.showCreditCardBanking = false;
            } else if (type == 'creditCard' && $scope.showCreditCardBanking == false) {
                $scope.showOnlineBanking = false;
                $scope.showCreditCardBanking = true;
            }
        }

        /*
         $scope.ACCOUNTS=[{
         ACCOUNT:$stateParams.accountNo,
         ACCOUNTBALANCE: $stateParams.accountBalance ,
         PAYMENTDUEDATE: $stateParams.dueDate
         }];
         */

        $scope.closePopOver = function () {
            angular.element('#cvvHelp').trigger('click');
        }
        $scope.redirectToLegacyPayment = function () {
            // Look into  non_angular_script/supportFunctions.js  for more information
            scrollPageToTop(); // jshint ignore:line
            $window.location.href = '../../../business/ute/smb/transactions/uteBillingAndPayment';
        }
        $scope.validatePaymentAmount = function (el) {
            var paymentAmountLength = $scope.paymentAmount.length;

            var ex = /^[0-9]+\.?[0-9]*$/;
            if (ex.test(el.value) == false) {
                el.value = el.value.substring(0, el.value.length - 1);
            }

            if (paymentAmountLength > 0) {
                $scope.isValidPaymentAmount = false;
            }
        }
        $scope.validateSecurityCode = function () {
            var securityCodeLength = $scope.securityCode.length;
            if (securityCodeLength > 0)
                $scope.isValidSecurityCode = false;
        }

		$scope.months= [
		    {name:'January',value:'01'},
			{name:'February',value:'02'},
			{name:'March',value:'03'},
			{name:'April',value:'04'},
			{name:'May',value:'05'},
			{name:'June',value:'06'},
			{name:'July',value:'07'},
			{name:'August',value:'08'},
			{name:'September',value:'09'},
			{name:'October',value:'10'},
			{name:'November',value:'11'},
			{name:'December',value:'12'}
        ];

		$scope.selectedMonth={name:"bss_month", value:""};
		$scope.selectedYear={name:"Year", value:""};
        $scope.years = [];
        var startYear = new Date().getFullYear();
        for (var i = 0; i <= 10; i++) {
            $scope.years[i] = startYear++;
        }
        $scope.editInfo = function () {
            $scope.makePaymentBreadCrumb[0].isActive = true;
            $scope.makePaymentBreadCrumb[0].selection = "active";
            $scope.makePaymentBreadCrumb[1].isActive = false;
            $scope.makePaymentBreadCrumb[1].selection = "inactive";
        }

        $scope.changeMonth = function (month) {
            $scope.selectedMonth = month;
            $scope.monthFlag = false;
            $scope.isValidMonth = $scope.monthFlag;
        }

        $scope.changeYear = function (year) {
            $scope.selectedYear = year;
            $scope.yearFlag = false;
            $scope.isValidYear = $scope.yearFlag;
        }

        $scope.showNext = function (next) {
            var breadCrumb = $scope.makePaymentBreadCrumb;
            var len = breadCrumb.length;
            var flag = false;
            var currentStep;
            window.scrollTo(0, 0);
            for (var i = 0; i < len; i++) {
                if (breadCrumb[i].name == next) {
                    currentStep = i;
                    $scope.makePaymentBreadCrumb[currentStep].isActive = true;
                    $scope.makePaymentBreadCrumb[currentStep].selection = "active";
                    $scope.url =
                        flag = true;
                    if ($('#cardScheme').val() == 'MASTERCARD') {
                        $scope.cardUrl = 'images/masterCard.png';
                        $scope.cardImg = resource.get('_img_mastercard');
                    } else if ($('#cardScheme').val() == 'VISA') {
                        $scope.cardUrl = 'images/visa.png';
                        $scope.cardImg = resource.get('_img_visa');
                    } else if ($('#cardScheme').val() == 'AMEX') {
                        $scope.cardUrl = 'images/americanExpress.png';
                        $scope.cardImg = resource.get('_img_amex');
                    }
                    $scope.creditCardNumber = $('#maskedCardNumber').val();
                    $scope.cardType = $('#cardScheme').val();
                    $scope.token = $('#token').val();
                } else {
                    $scope.makePaymentBreadCrumb[i].isActive = false;
                    $scope.makePaymentBreadCrumb[i].selection = "inactive";
                }
            }
        }

        $scope.submitPayment = function () {
            $scope.showMakePaymentSection = true;
            $scope.loadingIndicator = true;
            var paymentAmount = $scope.paymentAmount;
            var selectedMonth = $scope.selectedMonth;
            var selectedYear = $scope.selectedYear;
            var cardType = $scope.cardType;
            var token = $scope.token;
            if ($scope.paymentAmount.indexOf('.') == -1) {
                $scope.paymentAmount = $scope.paymentAmount + "." + "00"
            }

            var request = {
                refresh: false,
                applicationId: 'Rogers.com',
                flowType: "makePayment",
                acctNo: $scope.accountNo,
                contactID: $scope.contactId,
                LOB: $scope.lob,
                amount: $scope.paymentAmount,
                paymentMethod: "C",
                ccType: $('#cardScheme').val(),
                ccNumber: $scope.token,
                ccExpiryMonth: $scope.selectedMonth,
                ccExpiryYear: $scope.selectedYear,
                securityCode: $scope.securityCode

                //                    flowType:"paymentHistory",
                //                    acctNo:"614178549",
                //                    LOB:"WL"
            };
            makePaymentService.makePayment(request).then(function (data) {
                $scope.content = data;

                if (data.status.toUpperCase() == "success".toUpperCase()) {
                    if (window._satellite) _satellite.track('actv-myrogersbus-make a payment-complete');
                    console.log("actv-myrogersbus-make a payment-complete");
                    var payload = {
                        page: {
                            name: 'creditCardPaymentConfirmation',
                            hierarchy: ['selfserve', 'billing&payment', 'makeAPayment']
                        },
                        selfServe: {
                            type: 'transaction',
                            name: 'Make a payment',
                            paymentMethod: 'Credit - ' + request.ccType,
                            revenue: request.amount
                        },
                        events: {
                            selfServeComplete: true
                        }
                    };
                    dataLayerService.track(payload, false, [4, 0, 1, 2]);
                    $scope.loadingIndicator = false;
                    $scope.showMakePaymentSection = false;
                    $scope.showNext('Confirmation');
                } else {
                    var payload = {
                        page: {
                            name: 'creditCardPaymentConfirmation',
                            hierarchy: ['selfserve', 'billing&payment', 'makeAPayment']
                        },
                        errors: {
                            API: 'Make Payment',
                            Category: 'selfserve',
                            Code: 200,
                            Message: 'Currently system unavailable. Please try again - 200 - ' + data.status,
                            type: 'credit'
                        },
                        events: {
                            error: true
                        }
                    };
                    dataLayerService.track(payload, false, [4, 0, 1]);
                    $scope.content = "bss_makePayment_generic_error";
                    $scope.showMakePaymentErrorSection = true;
                    $scope.showMakePaymentSection = true;
                }
                //show error section code
            }, function (error) {
                if (window._satellite) _satellite.track('actv-myrogersbus-make a payment-error');
                console.log("actv-myrogersbus-make a payment-error");

                $scope.loadingIndicator = false;
                $scope.content = error;

                $scope.showMakePaymentErrorSection = true;
                $scope.showMakePaymentSection = true;

                //show error section code
            });
        }

        $scope.validateEnterInformationForm = function () {
            if (window._satellite) _satellite.track('actv-myrogersbus-make a payment-start');
            console.log("actv-myrogersbus-make a payment-start");
            $scope.validatedObject = {};
            $scope.isValidPaymentAmount = $scope.enterInformationForm.paymentAmount.$error.required;
            $scope.isValidPaymentAmt = $scope.enterInformationForm.paymentAmount.$error.pattern;
            $scope.isValidSecurityCode = $scope.enterInformationForm.securityCode.$error.required;

            $scope.isValidMonth = $scope.monthFlag;
            $scope.isValidYear = $scope.yearFlag;
            if (!$scope.isValidSecurityCode) {
                if ($scope.securityCode.length != 3 && $scope.securityCode.length != 4) {
                    $scope.isValidSecurityCode = true;
                }
            }
            $scope.isValidCreditCardScheme = false;
            $scope.isValidCreditCardNumber = false;

            if ($('#token').val() == "" || $('#token').val() == "UNKNOWN") {
                $scope.isValidCreditCardNumber = true;
                $('#cardNumberErrorSection').show();
                $('#token').val("");
            } else if ($('#cardScheme').val() != 'MASTERCARD' && $('#cardScheme').val() != 'VISA' && $('#cardScheme').val() != 'AMEX') {
                $scope.isValidCreditCardScheme = true;
                $('#cardSchemeErrorSection').show();
                $('#token').val("");
            }

            if ($('#cardScheme').val() == 'AMEX') {
                if ($scope.securityCode.length != 4)
                    $scope.isValidSecurityCode = true;
            } else if ($('#cardScheme').val() == 'MASTERCARD' || $('#cardScheme').val() == 'VISA') {
                if ($scope.securityCode.length != 3)
                    $scope.isValidSecurityCode = true;
            }

            if (!$scope.isValidPaymentAmount && !$scope.isValidPaymentAmt && !$scope.isValidSecurityCode && ($scope.securityCode.length == 3 || $scope.securityCode.length == 4) &&
                !$scope.isValidMonth && !$scope.isValidYear && !$scope.isValidCreditCardNumber && !$scope.isValidCreditCardScheme) {
                $scope.showNext('Review');
                var payload = {
                    page: {
                        name: 'reviewCreditCardPaymentInformation',
                        hierarchy: ['selfserve', 'billing&payment', 'makeAPayment']
                    }
                };
                dataLayerService.track(payload, false, [4, 0, 1, 2]);
            }
        }

        $scope.date = new Date();
        $scope.requiredDate = $scope.date.getDate() + ", " + $scope.date.getFullYear();
        $scope.requiredMonth = $scope.months[$scope.date.getMonth()].name;

        var content = $(".contentDesktopView");
        content.popover({
            trigger: "manual",
            placement: "right",
            html: "true",
            title: "",
            content: function () {
                return $(".popoverContentDesktop").html();
            }
        }).on("click", function () {
            var _this = this;
            $(this).popover("show");
            $(this).siblings(".popover").on("click", function () {
                $(_this).popover('hide');
            });
        }).on("mouseleave", function () {
            var _this = this;
            setTimeout(function () {
                if (!$(".popover:hover").length) {
                    $(_this).popover("hide")
                }
            }, 100);
        });
        var contentDesktopViewsbrt = $(".contentDesktopViewbrt");
        contentDesktopViewsbrt.popover({
            trigger: "manual",
            placement: "right",
            html: "true",
            title: "",
            content: function () {
                return $(".popoverContentDesktopbrt").html();
            }
        }).on("click", function () {
            var _this = this;
            $(this).popover("show");
            $(this).siblings(".popover").on("click", function () {
                $(_this).popover('hide');
            });
        }).on("mouseleave", function () {
            var _this = this;
            setTimeout(function () {
                if (!$(".popover:hover").length) {
                    $(_this).popover("hide")
                }
            }, 100);
        });

        var contentSmallDevice = $(".contentSmallDevices");
        contentSmallDevice.popover({
            trigger: "manual",
            placement: "bottom",
            html: "true",
            content: function () {
                return $(".popoverContentMobile").html();
            }
        }).on("click", function () {
            var _this = this;
            $(this).popover("show");
            $(this).siblings(".popover").on("click", function () {
                $(_this).popover('hide');
            });
        }).on("mouseleave", function () {
            var _this = this;
            setTimeout(function () {
                if (!$(".popover:hover").length) {
                    $(_this).popover("hide")
                }
            }, 100);
        });

        $scope.currentDate = new Date();

        resource.onChanged(function () {
            $scope.lng = userLanguage();
        }, $scope);
    }

    //++++++++++++++++
    function numbersOnlyDirective() {
        return {
            require: '?ngModel',
            link: function (scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                ngModelCtrl.$parsers.push(function (val) {
                    if (angular.isUndefined(val)) {
                        var val = '';
                    }
                    var clean = val.replace(/[^0-9\.]/g, '');
                    var decimalCheck = clean.split('.');

                    if (!angular.isUndefined(decimalCheck[1])) {
                        decimalCheck[1] = decimalCheck[1].slice(0, 2);
                        clean = decimalCheck[0] + '.' + decimalCheck[1];
                    }

                    if (val !== clean) {
                        ngModelCtrl.$setViewValue(clean);
                        ngModelCtrl.$render();
                    }
                    return clean;
                });

                element.bind('keypress', function (event) {
                    if (event.keyCode === 32) {
                        event.preventDefault();
                    }
                });
            }
        };
    };

    //+++++++++++++++
    function errorMessageDirective() {
        return {
            restrict: 'E',
            replace: true,

            scope: {
                message: '@message',
                image: '@image'
            },
            template: '<div><img src="{{image}}" width:28 height:22>&nbsp;{{message}}</div>',

            link: function (scope, element, attr) {}
        };
    };

    //++++++++++++++++
    function ngEnterDirective() {
        return function (scope, element, attrs) {
            element.bind('keydown keypress', function (event) {
                if (event.which == 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        };
    };

})(jQuery);

/**
 * @ngdoc module
 * @name paymentHistory
 * @description
 * # A simple wrapper to provide a directive module for paymentHistory - including its own controller, service and template
 *
 */

(function() {

  'use strict';

  angular.module('paymentHistory')
    .directive('paymentHistory', paymentHistoryDirective)
    .factory('paymentHistoryService',paymentHistoryService)
    .filter('startFrom', function() {
      return function(input, start) {
        start = +start; //parse to int
        return input.slice(start);
      }
    })
    .controller('paymentHistoryController',paymentHistoryController);

  paymentHistoryDirective.$inject = [];
  paymentHistoryService.$inject = ['$rootScope','backend','$q'];
  paymentHistoryController.$inject = ['$rootScope','$scope','$timeout','paymentHistoryService','smoothScroll','$window'];

  //+++++++++
  function paymentHistoryDirective(){
    return {
      restrict: 'AE',
      scope: {accountNo:'=', lob:'=', contactId:'=', accountNickName:'='},
      templateUrl: 'scripts/modules/payHistory/paymentHistory.html',
      link: function(scope,element, attrs){}
    };
  }

  //+++++++++
  function paymentHistoryService($rootScope, backend, $q) {

    var returnObj = {

      getPaymentHistory : function(request, callback){
        return backend.post('paymentHistory', request).then(
          function(data){
            return data;
          },
          function(error){
            return $q.reject('getPaymentHistory Failed');
          }
        );
      },
      broadcast: function () {
        $rootScope.$broadcast('paymentHistoryService');
      }
    };
    return returnObj;
  }

  //+++++++++++
  function paymentHistoryController($rootScope,$scope,$timeout,paymentHistoryService,smoothScroll,$window){

    $scope.loadingIndicator=false;
    $scope.showPaymentHistoryErrorSection=false;
    $scope.showPaymentHistorySection=false;
    $scope.showPaymentHistoryRecordsSection=false;
    $scope.reverse=true;
    $scope.showDetails=[];
    $scope.showDetailsColor=[];
    $scope.leftProperty=0;
    $scope.listLength=0;
    $scope.currentPage=1;
    $scope.ctrlArr=[];
    $scope.limiter = 10;
    $scope.sortLable="transDate";
    $scope.hideNext=false;
    $scope.showNextButton=true;
    $scope.showNextTenButton=false;
    $scope.showNextDisabledButton=false;
    $scope.hidePrev=true;
    $scope.activePageIndex=0;
    $scope.historyList = [];
    $scope.leftover = 10;
    $scope.unread = 0;
    $scope.pageTotal = 10;
    $scope.orderToggle = false;

    $scope.clicker = clicker;
    $scope.orderPayHistoryLabel = order;
    $scope.getPaymentHistory = getPaymentHistory;
    $scope.pagenumberScrollHolderatePage = pagenumberScrollHolderatePage;
    $scope.detailsShowHide = detailsShowHide;
    $scope.initHistoryController = initHistoryController;
    $scope.isActive = isActive;

    var recordsPerpage= 10;
    var originalList=[];

    $scope.redirectBack = function(){
      $window.history.back();
    };

    $scope.redirectToLegacyPayment = function () {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
      $window.location.href = '../../../business/ute/smb/transactions/uteBillingAndPayment';
    }
    function clicker(){
      $scope.pageList = $scope.historyList;
      $scope.unread = $scope.unread - 10;
      $scope.limiter =  $scope.limiter + 10;
      $scope.lastIndex= $scope.limiter -1;
      if ($scope.limiter >= $scope.listLength){
        $scope.limiter = $scope.listLength;
        $scope.lastIndex= $scope.limiter -1;
      }
      if ($scope.unread < $scope.leftover){

        $scope.leftover = $scope.unread;
      }
      if ($scope.leftover < 1){
        $scope.showNextButton = false;
      }

      var index = $scope.lastIndex;

      $timeout(function(){
        var element = document.getElementById('history' + index);

        if(element) {
          var options = {
            duration: 500,
            easing: 'easeInQuad',
            offset: 350,
          }
          smoothScroll(element, options);
        }
      }, 0);
    }

    function order(sortLable) {
      $scope.reverse = ($scope.sortLable === sortLable) ? !$scope.reverse : false;
      $scope.sortLable = sortLable;
      $scope.orderToggle = !$scope.orderToggle;
    }

    function getPaymentHistory(){
      var todayDate = new Date();
      var newDate = new  Date(todayDate);
      var startData = new Date(newDate.setDate(todayDate.getDate() - 730));
      var request = {
        refresh: false,
        applicationId: 'Rogers.com',
        flowType:"paymentHistory",
        endDate: moment(todayDate).format('YYYY-MM-DD'),
        startDate:moment(startData).format('YYYY-MM-DD'),
        acctNo:$scope.accountNo,
        LOB:$scope.lob
      };

      paymentHistoryService.getPaymentHistory(request)
        .then(function(data) {
          $scope.loadingIndicator=false;
          $scope.content = data;
          $scope.showPaymentHistorySection=true;
          $scope.showPaymentHistoryErrorSection=false;
          /*angular.forEach(data.historyList.historyList, function(value, key) {
            value.transDate=new Date(value.transDate);
          })*/
          originalList=$scope.content.historyList.historyList;
          $scope.historyList = originalList;
          $scope.listLength =originalList.length;
          $scope.unread = $scope.listLength-10;
          if(originalList){
            $scope.showPaymentHistoryRecordsSection=true;
            pagginationCtrl();
            pagginationListPreparator(0);
          }
          else{
            $scope.showPaymentHistoryRecordsSection=false;
          }
        },function (error){
          $scope.loadingIndicator=false;
          $scope.content=error;
          $scope.showPaymentHistoryErrorSection=true;
          $scope.showPaymentHistorySection=false;
        });
    }

    function pagginationListPreparator(currentPage){
      $scope.pageList=originalList;
      $scope.currentPage=currentPage+1;
      $scope.activePageIndex=parseInt(currentPage/recordsPerpage);
    }

    function pagginationCtrl(){
      var ctrlarr=[];
      var ittrLnt=0;
      if(originalList.length/recordsPerpage > 0){
        ittrLnt=parseInt(originalList.length/recordsPerpage);
      }
      if(originalList.length%recordsPerpage != 0){
        ittrLnt++;
      }
      for( var i=1;i<=ittrLnt;i++){
        ctrlarr.push(i);
      }
      $scope.ctrlArr=ctrlarr;
    }

    function detailsShowHide(index){
      $scope.showDetails[index] = !$scope.showDetails[index];
    }

    function pagenumberScrollHolderatePage(index,e){
      var nextButtonClick="";
      if(typeof index=="string"){
        if(index=="next"){
          index=parseInt($scope.currentPage/recordsPerpage)+1;
          nextButtonClick="true";
        }
        else{
          index=parseInt($scope.currentPage/recordsPerpage)-1;
          nextButtonClick="false";
        }
      }
      pagginationListPreparator((index==0)?index:index*recordsPerpage);
      if(index==0){
        $scope.hidePrev=true;
        $scope.hideNext=false;
        $scope.showNextTenButton=false;
        $scope.showNextDisabledButton=false;
      }else if(index==$scope.ctrlArr.length-2){
        $scope.showNextButton=false;
        $scope.showNextDisabledButton=false;
        $scope.showNextTenButton=true;
        $scope.hidePrev=false;
        $scope.hideNext=false;
      }else if(index==$scope.ctrlArr.length-1){
        $scope.showNextButton=false;
        $scope.showNextDisabledButton=true;
        $scope.showNextTenButton=false;
        $scope.hideNext=true;
        $scope.hidePrev=false;

      }else{
        $scope.showNextButton=true;
        $scope.showNextTenButton=false;
        $scope.showNextDisabledButton=false;
        $scope.hidePrev=false;
        $scope.hideNext=false;
      }
      if(nextButtonClick!="")
      {
        var widthFix=0;
        if(index%2==0 && index!=0 && nextButtonClick=="true"){
          $('#paymentHistory .pagenumberScroll a:gt('+(index-1)+')').filter(':lt(2)').each(function(){
            widthFix+=$(this).outerWidth(true);
          });
          $scope.leftProperty-=($(".pagenumberScroll").width());
          $(".pagenumberScroll").parent().width(widthFix);
        }else if(index%2==1&& index!=1&& nextButtonClick=="false"){
          $('#paymentHistory .pagenumberScroll a:lt('+(index+1)+')').filter(':gt('+(index-2)+')').each(function(){
            widthFix+=$(this).outerWidth(true);
          });
          $scope.leftProperty=-$(".pagenumberScroll a.activePage").position().left+widthFix;
          $(".pagenumberScroll").parent().width(widthFix);
        }else if(index<2){
          $scope.leftProperty=0;
          $(".pagenumberScroll").parent().width("24");
        }
        nextButtonClick="";
      }
    }

    function isActive(type){
      if ($scope.sortLable === type){
        return true;
      }
      else{
        return false;
      }
    }

    function initHistoryController() {
      $scope.loadingIndicator = true;
      $scope.getPaymentHistory();
      //initialize showdetails
      for( var i=1;i<=$scope.historyList.length;i++){
        showDetails[i]=false;
      }
    }
    $scope.initHistoryController();
  }

})();

(function () {
  'use strict';

  angular.module('ute.payment.helper.view')
      .controller('MyrPaymentHelperController', PaymentHelperController);

  PaymentHelperController.$inject = [];

  /* @ngInject */
  function PaymentHelperController() {
    var vm = this;
  }

})();

'use strict';
/*
 the payment helper:
 Need help with payment options?   Review Payment FAQs >    Talk to us now with LiveChat >
 */
angular.module('ute.payment.helper.view').directive('myrPaymentHelper', [function () {
  return {
    templateUrl: 'module/myrPaymentHelper/paymentHelper.view.html',
    replace: true,
    controller: 'MyrPaymentHelperController',
    controllerAs: 'ph',
    restrict: 'E',
    link: function (scope, element, attr) {
    }
  };
}]);

/**
 * Created by james.magpantay on 4/4/2016.
 */

(function () {

  'use strict';

  angular
    .module('ute.resetVoiceMailbox')
    .controller('resetVoiceMailboxCtrl', resetVoiceMailboxCtrl);

  resetVoiceMailboxCtrl.$inject = ['$scope', '$rootScope','$state','$stateParams','$window','resetVoiceMailboxService'];

  function resetVoiceMailboxCtrl($scope, $rootScope,$state,$stateParams,$window,resetVoiceMailboxService) {
    var vm = this;

    vm.init = init;
    vm.reset = reset;
    vm.back = back;

    vm.init();

    function init() {
      vm.phoneNumber = resetVoiceMailboxService.getPhoneNumber();
    }

    function reset(){
      vm.loading= true;
      resetVoiceMailboxService.resetVoiceMailbox().then(
        function(response){
          vm.submitted = true;
          if(response.status == 'success'){
            vm.success = true;
          }else{
            vm.success = false;
          }
          vm.loading=false;
        },function(error){
            vm.loading=false;

      }
      );
    }

    function back(){
      $state.go('wireless');
    }
  }
})();

/**
 * Created by james.magpantay on 4/5/2016.
 */
(function () {
  'use strict';

  angular
    .module('ute.resetVoiceMailbox')
    .filter('tel', function () {
      return function (tel) {
        if (!tel) { return ''; }

        var value = tel.toString().trim().replace(/^\+/, '');

        if (value.match(/[^0-9]/)) {
          return tel;
        }

        var country, city, number;

        switch (value.length) {
          case 10: // +1PPP####### -> C (PPP) ###-####
            country = 1;
            city = value.slice(0, 3);
            number = value.slice(3);
            break;

          case 11: // +CPPP####### -> CCC (PP) ###-####
            country = value[0];
            city = value.slice(1, 4);
            number = value.slice(4);
            break;

          case 12: // +CCCPP####### -> CCC (PP) ###-####
            country = value.slice(0, 3);
            city = value.slice(3, 5);
            number = value.slice(5);
            break;

          default:
            return tel;
        }

        if (country == 1) {
          country = "";
        }

        number = number.slice(0, 3) + '-' + number.slice(3);

        return (country + " " + city + "-" + number).trim();
      };
    });

})();




/**
 * Created by james.magpantay on 4/4/2016.
 */
(function () {
  'use strict';


  angular
    .module('ute.resetVoiceMailbox')
    .config(resetVoiceMailbox);

  resetVoiceMailbox.$inject = ['$translateProvider'];

  function resetVoiceMailbox($translateProvider){
    $translateProvider.translations('en', {
      rvm : {
        header:"Voice Mailbox and Password Reset for",
        subHeader: "Please note: if you reset your voice mailbox, you'll delete your current greeting and all new or saved voice messages.",
        msg2:"You'll receive a text message with instructions.",
        cancel:"Cancel",
        reset:"Reset voice mailbox",
        success:"Success!",
        successSub:"Your voice mailbox has been reset. You will receive a text message with instructions.",
        back: "< Go back",
        failure:"Currently System Unavailable.",
        failureSub:"Please try again."

      }
    });
    $translateProvider.translations('fr', {
      rvm : {
        header:"Réinitialiser la boîte vocale et le mot de passe",
        subHeader: "Veuillez noter que si vous réinitialisez votre boîte vocale, vous effacerez votre message d’accueil actuel ainsi que vos nouveaux messages et les messages sauvegardés.",
        msg2:"Vous recevrez un message texte avec des instructions.",
        cancel:"Annuler",
        reset:"Réinitialiser la boîte vocale",
        success:"C’est fait!",
        successSub:"Votre boîte vocale a été réinitialisée. Vous recevrez un message texte avec des instructions.",
        back: "< Retour",
        failure:"Désolés, nous éprouvons actuellement des difficultés techniques.",
        failureSub:"Veuillez réessayer plus tard. Merci de votre patience."
      }

    });

    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitize');
  }



})();

'use strict';

angular.module('ute.resetVoiceMailbox').config(['$stateProvider', '$urlRouterProvider', '$httpProvider',
  function ($stateProvider, $urlRouterProvider, $httpProvider) {

    var allStates = [
      {
        name: 'resetvoicemailbox',
        url: '/resetvoicemailbox',
        controller: 'resetVoiceMailboxCtrl',
        controllerAs: 'rvm',
        templateUrl: 'module/resetVoiceMailbox/resetVoiceMailbox.html',
        params: {accountNumber : null}
      }
    ];

    for (var i = 0; i < allStates.length; i++) {
      $stateProvider.state(allStates[i]);
    }


  }]);

/**
 * Created by james.magpantay on 4/4/2016.
 */

(function () {

  'use strict';

  angular
    .module('ute.resetVoiceMailbox')
    .factory('resetVoiceMailboxService', resetVoiceMailboxService);

  resetVoiceMailboxService.$inject = ['$http','$window'];

  function resetVoiceMailboxService($http,$window) {

    var service = {
      resetVoiceMailbox : resetVoiceMailbox,
      getPhoneNumber: getPhoneNumber,
      getAccountNumber: getAccountNumber
    };

    return service;

    function getPhoneNumber(){
      return $window.localStorage.getItem('phoneNumber');
    }

    function getAccountNumber(){
      return $window.localStorage.getItem('accountNumber');
    }

    function resetVoiceMailbox(){
      var accountNumber = service.getAccountNumber();
      var phoneNumber = service.getPhoneNumber();
      var request = {
        accountNumber: accountNumber,
        phoneNumber: phoneNumber,
        medium:'Web',
        applicationId: "SMB"
      };

      var httpRequest = $http({
        method : 'POST',
        url : '/web/RogersServices.portal/smb/api/business/v1/wirelessDashBoard/resetVoiceMailBox',
        data : request
      });

      return httpRequest.then(
        function(response){
          console.log(response);
          return response.data.content;
        },
        function(error){
          console.log('error');
          return error;
        }
      );

    }


  }
})();

(function () {

  'use strict';

  angular.module('ute-internet-usage')

    .controller('uteInternetUsageDailyCtrl', ['$scope', '$filter', 'backend','$rootScope', function($scope, $filter, backend,$rootScope) {

    	$scope.usageData = [];
    	$scope.slctMonth = 0;
    	var breakIndex = 0;

    	$scope.billingCycleChanged = function(){
    		//Invoke webAPI: ajax.getDailyUsage(accId, subId, month), and then parse the promised result (raw result)
        var request = {accountNumber: $scope.selectedAccNum, applicationId: "Rogers.com",monthIndicator:$scope.slctMonth};
        backend.post('getDailyUsage', request)
    		.then(function(data){
				  		processDailyUsage(data);
    				}, function(err){
				  		internetUsageErr(err);
				  	});
    	};




    	//+++++
    	function processDailyUsage(result){
    		var monthlyUsageLimit = 0;
    		$scope.usageData[$scope.slctMonth] = {
	    			sum: { upload: 0, download: 0 },
	    			dailyChartLineBreak: { enabled: false },
	    			cumulativeChartLineBreak: { enabled: false },
	    			cumulativeLimitOptions: {
	    				enabled: false,
	    				limit: 1000,
	    				showLabel: {
	    	                enabled: true,
	    	                template: '<ute-chart-badge limit-value="1000"></ute-chart-badge>'
	    				}
	    			}
    	        };

			// daily usage data for table
			// sort by date
			if (result && result.getUsageDetails && result.getUsageDetails.dailyUsageSummary && result.getUsageDetails.dailyUsageSummary.dailyUsage) {
				$scope.usageData[$scope.slctMonth].dailyUsage = _.sortBy(result.getUsageDetails.dailyUsageSummary.dailyUsage, function (dailyUsage) {
						return dailyUsage.date;
	            	});
			}

			if (result && result.getUsageDetails && result.getUsageDetails.dailyUsageSummary && result.getUsageDetails.dailyUsageSummary.totalDailyUsage) {
	            var dailyUsageSummaryMB = _.find(result.getUsageDetails.dailyUsageSummary.totalDailyUsage, function(dailyUsage) {
	            		return dailyUsage.unit === 'MB';
	            	});
	            if (dailyUsageSummaryMB){
	            	monthlyUsageLimit = Number(dailyUsageSummaryMB.planLimit);
	            }
			}

			var labels = [],
				cumulativeChartData = [],
				foundBreakIndex = false,
				dailyData = [];

			_.each($scope.usageData[$scope.slctMonth].dailyUsage, function (usage, index2){
	            usage.download = parseInt(usage.download.toFixed(0), 10);
	            usage.upload = parseInt(usage.upload.toFixed(0), 10);
	            //usage.total = usage.download + usage.upload;
	            usage.total = parseInt(usage.total.toFixed(0), 10);

	            labels.push($filter('date')(usage.date, 'MMM d'));
	            dailyData.push(usage.total);
	            $scope.usageData[$scope.slctMonth].sum.upload = $scope.usageData[$scope.slctMonth].sum.upload + usage.upload;
	            $scope.usageData[$scope.slctMonth].sum.download = $scope.usageData[$scope.slctMonth].sum.download + usage.download;

	            if (cumulativeChartData.length>0) {
	            	var d = cumulativeChartData[cumulativeChartData.length - 1] + usage.total;
	            	cumulativeChartData.push(d);
	            }else{
	            	cumulativeChartData.push(usage.total);
	            }

	            if (d > monthlyUsageLimit && !foundBreakIndex) {
	            	foundBreakIndex = true;
	            	breakIndex = index2;
	            	$scope.usageData[$scope.slctMonth].dailyChartLineBreak = {
    	                enabled: true,
    	                breakOn: breakIndex
	            	};
	            }

			});

			if (!foundBreakIndex && ($scope.usageData[$scope.slctMonth].dailyUsage || []).length > 0) {
	            foundBreakIndex = true;
	            breakIndex = $scope.usageData[$scope.slctMonth].dailyUsage.length - 1;
	            $scope.usageData[$scope.slctMonth].dailyChartLineBreak = {
	            	enabled: true,
	            	breakOn: breakIndex
	            };
			}

			$scope.usageData[$scope.slctMonth].cumulativeChartLineBreak = {
	            enabled: true,
	            limit: ((cumulativeChartData.length >0 && cumulativeChartData[cumulativeChartData.length - 1] > monthlyUsageLimit) ? monthlyUsageLimit : cumulativeChartData[cumulativeChartData.length - 1]),
	            smartAlign: true
			};

			$scope.usageData[$scope.slctMonth].cumulativeLimitOptions = {
	            enabled: (monthlyUsageLimit == 9999999 ? false : true),
	            limit: monthlyUsageLimit,
	            showLabel: {
	            	enabled: true,
	            	template: '<chart-badge limit-value="' + monthlyUsageLimit + '"></chart-badge>'
	            }
			};



			//=======> daily chart data
			$scope.usageData[$scope.slctMonth].lineDailyData = {
	            labels: labels,
	            series: [{ data: dailyData } ]
			};

			//======> umulative chart data
			$scope.usageData[$scope.slctMonth].lineCumulativeData = {
	            labels: labels,
	            series: [{ data: cumulativeChartData }]
			};

			//======> daily usage options
			$scope.lineDailyOptions = {
	            showPoint: false,
	            fullWidth: true,
              height: 240,
	            //lineSmooth: false,
	            lineSmooth: Chartist.Interpolation.simple(),		//TETS
	            low: 0,
	            // If the line will stop drawing when the data ends rather than normalizing. This will not manipulate data with multiple length.
	            allowVariableDataLengths: true,
	            chartPadding: { right: 10 },
	            axisY: {
	            	labelOffset: {  x: 0, y: 3 },
	            	labelInterpolationFnc: function (value, index, axis) {
    	                if ($rootScope.selectedLanguage == "en" && index === axis.length - 1) {
    	                  return "MB</br>" +  value;
    	                } else if($rootScope.selectedLanguage == "fr" && index === axis.length - 1){
                        return "Mo</br>" +  value;
                      } else {
    	                  return value;
    	                }
	            	}
	            },
	            axisX: {
	            	showGrid: false,
	            	labelInterpolationFnc: function (value, index, axis) {
    	                // only show the first and last label
    	                if (index === 0 || index === axis.length - 1) {
    	                  return value;
    	                } else if (index % 1 === 0) {
    	                  return ' ';
    	                } else {
    	                  return false;
    	                }
	            	}
	            }
			};


			//======> cumulative chart options
			$scope.lineCumulativeOptions = {
	            showPoint: false,
	            fullWidth: true,
	            height: 240,
	            low: 0,
	            //scaleMinSpace: 20,
	            lineSmooth: false,
	            // If the line will stop drawing when the data ends rather than normalizing. This will not manipulate data with multiple length.
	            allowVariableDataLengths: true,
	            axisY: {
	            	labelOffset: {x: 0, y: 3},
	            	labelInterpolationFnc: function (value, index, axis) {

                  if ($rootScope.selectedLanguage == "en" && index === axis.length - 1) {
                    return (Math.round(Number(value) / 1024)) + "GB";
                  } else if($rootScope.selectedLanguage == "fr" && index === axis.length - 1) {
                    return (Math.round(Number(value) / 1024)) + "Go";
                  }else {
    	                  return (index % 1 === 0) && (Math.round(Number(value) / 1024));
    	                }
	            	}
	            },
	            axisX: {
	            	showGrid: false,
	            	labelOffset: {x: 0, y: 0},
	            	labelInterpolationFnc: function (value, index) {
    	            	  // only show the first and last label
    	            	  if (index === 0 || index === labels.length - 1) {
    	            		  return value;
    	            	  } else if (index % 1 === 0) {
    	            		  return ' ';
    	            	  } else {
    	            		  return false;
    	            	  }
	            	}
	            }
    		};
    	};
    	//<<===================


    	function loopBillingCycle() {
    		$scope.usageData.push({
    				sum: { upload: 0, download: 0 },
    				dailyChartLineBreak: { enabled: false },
    				cumulativeChartLineBreak: { enabled: false },
    				cumulativeLimitOptions: {
    					enabled: false,
    					showLabel: {  enabled: false }
    				}
    		});
    	};

    	function usageSummaryLoaded(data) {
    		$scope.usageSummary = data.getDataHSIUsageSummary;
    		$scope.usageSummary.usageMeter = Math.round($scope.usageSummary.usageMeter);

    		if ($scope.usageSummary && $scope.usageSummary.usageMeter > 100) {
    			$scope.usageSummary.usageMeter = 100;
    		}

    		$scope.usageData = [];

    		_.each($scope.usageSummary.billingCycle, loopBillingCycle);

    		if ($scope.usageSummary && $scope.usageSummary.billingCycle && $scope.usageSummary.billingCycle.length) {
    			$scope.slctMonth = $scope.usageSummary.billingCycle[0].monthlyInd;
    			$scope.billingCycleChanged();
    		}
    	};

    	function init() {
	        $scope.usageSummary = {};
        $rootScope.$broadcast("dailyActive", {active: 'daily' });
	        //Load usageSummary for initialization
        var request = {accountNumber: $scope.selectedAccNum, applicationId: "Rogers.com"};
        //Load usageSummary for initialization
        backend.post('consolidatedInternetUsage', request)
	        .then(function(data){
	        		usageSummaryLoaded(data);
			  		},function(err){
				  		internetUsageErr(err);
				  	});
    	};

    	init();

	}]);

})();

'use strict';
angular.module('ute-internet-usage-monthly')
.controller('uteInternetUsageMonthlyCtrl', ['$scope', '$filter', 'backend','$rootScope', function($scope, $filter, backend,$rootScope){

	$scope.lineData = null;

	$scope.lineOptions = {
			showPoint: false,
			fullWidth: false,
			height: 200,
			low: 0,
			lineSmooth: false,
			allowVariableDataLengths: true,
			chartPadding: {right: 20},
			axisY: {
				labelOffset: { x: 0, y: 3 },
				labelInterpolationFnc: function (value, index, axis) {
					if(index === axis.length - 1) {
						return "GB</br>" +  value;
					}else{
						return value;
					}
				}
			},
			axisX: {
				labelInterpolationFnc: function(value, index, axis){
					return (index % 1 === 0) ? value : '';
				},
				showGrid: false
			}
	};

	$scope.averageUseData = { total: 0, included: 0, additional: 0, overageCharge: 0 };


	function init(){
    $rootScope.$broadcast("dailyActive", {active: 'monthly' });
    var request = {accountNumber: $scope.selectedAccNum, applicationId: "Rogers.com"};
    backend.post('consolidatedInternetUsage', request)
	    .then(function(data){
	    			$scope.usageSummary = data.getDataHSIUsageSummary;
	    			$scope.usageSummary.usageMeter = Math.round($scope.usageSummary.usageMeter);

	    			if($scope.usageSummary && $scope.usageSummary.usageMeter > 100){
	    				$scope.usageSummary.usageMeter = 100;
	    			}
	  		},function(err){
		  		internetUsageErr(err);
		  	});

    backend.post('getMonthlyUsage', request)
	    .then(function(result){
	    		$scope.monthlyUsage = [];

	    		if(result && result.getUsageDetails && result.getUsageDetails.monthlyUsageSummary && result.getUsageDetails.monthlyUsageSummary.monthlyUsage){
	    			$scope.monthlyUsage = _.sortBy(result.getUsageDetails.monthlyUsageSummary.monthlyUsage, function(monthlyUsage){
	    				return monthlyUsage.date;
	    			});
	    		};

	    		if(result && result.getUsageDetails && result.getUsageDetails.monthlyUsageSummary && result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage){
	    			$scope.averageUseData = {
	    				total: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.total,
	    				included: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.included,
	    				additional: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.additional,
	    				overageCharge: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.overageCharge,
	    				unit: result.getUsageDetails.monthlyUsageSummary.averageMonthlyUsage.unit
	    			};
	    		};

	    		$scope.maxUsage = 0;
	    		var labels = [],
	    		chartData = [];

	    		_.each($scope.monthlyUsage, function (usage){

	    			labels.push(usage.billingPeriod);
	    			chartData.push(usage.total);

	    			$scope.maxUsage += usage.total;
	    		});

	    		$scope.lineData = {
	    				labels: labels,
	    				series: [ {data: chartData} ]
	    		};
	    	}, function(){
	    		internetUsageErr(err);
	    	});


	};

	init();
}]);

/**
 *
 */

(function(){

	angular.module('ute-internet-usage-nav')
	.controller('uteInternetUsageNavCtrl', ['$scope', '$state','$rootScope', function($scope, $state,$rootScope){

		for(var i=0; i<$scope.tabConfig.length; i++){
			if($scope.tabConfig[i]['active']){
				$state.go($scope.tabConfig[i]['route']);
				break;
			}
		}
      $rootScope.$on("dailyActive", function (event, args) {
       if(args.active == 'daily'){
         $scope.tabConfig = [{heading:"ute_label_Daily", subHeading:"ute_label_UsageHistory", route:"internetUsage.daily", active: true},
           {heading:"ute_label_Monthly", subHeading:"ute_label_UsageHistory", route:"internetUsage.monthly", active: false},
           {heading:"ute_label_Usage", subHeading:"ute_label_NotificationHistory", route:"internetUsage.notification", active:false}
         ];
       } else if(args.active == 'monthly'){
         $scope.tabConfig = [{heading:"ute_label_Daily", subHeading:"ute_label_UsageHistory", route:"internetUsage.daily", active: false},
           {heading:"ute_label_Monthly", subHeading:"ute_label_UsageHistory", route:"internetUsage.monthly", active: true},
           {heading:"ute_label_Usage", subHeading:"ute_label_NotificationHistory", route:"internetUsage.notification", active:false}
         ];
       } else if(args.active == 'notification'){
         $scope.tabConfig = [{heading:"ute_label_Daily", subHeading:"ute_label_UsageHistory", route:"internetUsage.daily", active: false},
           {heading:"ute_label_Monthly", subHeading:"ute_label_UsageHistory", route:"internetUsage.monthly", active: false},
           {heading:"ute_label_Usage", subHeading:"ute_label_NotificationHistory", route:"internetUsage.notification", active:true}
         ];
       }
      });

      $scope.navigate = function(route){
			$state.go(route);
		}
	}]);

})();
(function() {
	'use strict';

	angular.module('ute-internet-usage-notification')
	.controller('uteInternetUsageNotificationCtrl', ['$scope', 'backend','$rootScope', function($scope,backend,$rootScope) {
      $rootScope.$broadcast("dailyActive", {active: 'notification' });
      var request = {accountNumber: $scope.selectedAccNum, applicationId: "Rogers.com"};
      backend.post('notification', request)
    	.then(function(data){
    			$scope.usageHistoryData = [];
    			$scope.usageHistoryData = data.getUsageNotifications.notification;
          if (data && data.getUsageNotifications && data.getUsageNotifications.notification) {
            $scope.usageHistoryData = _.sortBy(data.getUsageNotifications.notification , function (notification) {
              return notification.date;
            });
          }
	    	},function(){

	    	});

      backend.post('consolidatedInternetUsage', request)
    	.then(function(data){
    			$scope.usageSummary = data.getDataHSIUsageSummary;
	    	},function(){

	    	});
	}]);

})();

/**
 * @ngdoc directive
 * @name ute-internet-usage
 * @description
 * # Internet usage panel (3-tabs/views)
 * 
 * @Usage <ute-internet-usage account='account'></ute-internet-usage> OR <div ute-internet-usage account='account'></div>
 * @Note: In the touter, the route names for content of 3 tabs are fixed: "internetUsage.daily", "internetUsage.monthly", "internetUsage.notification"
 */

(function(){
	'use strict';
	angular.module('ute-internet-usage')
	.directive('uteInternetUsage',['$state', function($state){
		return {
			restrict: 'AE',
			scope: {account:'=', tabConfig:'='},
			templateUrl: 'views/uteInternetUsage/uteInternetUsage.html',
			controller: ["$scope", "$element", "$attrs", function($scope, $element, $attrs){
				for(var i=0; i<$scope.tabConfig.length; i++){
					if($scope.tabConfig[i]['active']){
						$state.go($scope.tabConfig[i]['route']);
						break;
					}
				}
				$scope.navigate = function(route){
					$state.go(route);
				}
			}]
		}
	}]);
})();

/**
 * @ngdoc module
 * @name makePayment
 * @description
 * #
 *
 */

(function(){
	'use strict';

	angular.module('makePayment')
    .directive('formCreditCard', ['rogerstosemafoneservice','semafoneService','$rootScope', 'resource',
        function (rogerstosemafoneservice, semafoneService, $rootScope, resource) {
            return {
                restrict: 'AE',
                templateUrl: 'scripts/modules/makePayment/formCreditCard.html',
                link: function ($scope, $element, attr) {

                    $scope.visa= resource.get('_alt_visa');
                    $scope.mastercard= resource.get('_alt_mastercard');
                    $scope.amex= resource.get('_alt_amex');
                    $scope.infoIcon= resource.get('_alt_infoIcon');


                    $rootScope.$watch('semafoneLang', function(){
                        if(semafoneService.getToken().length == 1){
                            semafoneService.setToken(" ");
                            semafoneService.setMaskedCardNumber(" ");
                            semafoneService.setCardScheme(" ");
                            semafoneService.setSemafoneValidationState(" ");
                            rogerstosemafoneservice.launchSemafoneCapturePage("semafoneCapturePage");
                        }
                    });
                },
                compile: function(){
                    semafoneService.setToken(" ");
                    semafoneService.setMaskedCardNumber(" ");
                    semafoneService.setCardScheme('');
                    semafoneService.setSemafoneValidationState(" ");
                    rogerstosemafoneservice.launchSemafoneCapturePage("semafoneCapturePage");
                    return this.link;
                }
            };

            // TODO this is unreachible code
            resource.onChanged(function () {

                $scope.tooltip = resource.get('paynow_card_tooltip');

            }, $scope);

        }]);

})();



/**
 * @ngdoc module
 * @name makePayment
 * @description
 * # 
 * 
 */

(function($){
	'use strict';

	angular.module('makePayment')
	.factory('rogerstosemafoneservice', ['settings', '$timeout', 'semafoneService', 'brtCheck', '$rootScope', function (settings, $timeout, semafoneService, brtCheck, $rootScope) {
		 
		return {
		      launchSemafoneCapturePage : launchSemafoneCapturePage
		};

		//+++++++++++
		function launchSemafoneCapturePage(semafoneCapturePageCompId){
		    var loc = window.location.toString();
            var properties = {};
		    brtCheck.tokenization().then(function(data){

                 if (!!_.find(data,{id:'TOKENIZATION_EVOLUTION',switchIsOn: true})) {
                  //console.log('old cred should load');
                     if ((loc.match('.dev')) || (loc.match('.DEV')) || (loc.match('.env')) || (loc.match('.ENV'))) {
                        properties = settings.legacyQaSemafoneParameters;
                     } else if ((loc.match('localhost')) || (loc.match('LOCALHOST'))) {
                        properties = settings.legacyDevSemafoneParameters;
                     } else if ((loc.match('.qa')) || (loc.match('.QA'))) {
                        properties = settings.legacyQaSemafoneParameters;
                     } else if ((loc.match('.pet')) || (loc.match('.PET'))) {
                        properties = settings.legacyPetSemafoneParameters;
                     } else {
                         properties = settings.legacyProdSemafoneParameters;
                     }
                 }else{
                    // console.log('new cred should load');
                     properties = defaultProperties(loc, properties);
                }
                temp(semafoneCapturePageCompId, loc, properties)
            }, function(){

                defaultProperties(loc, properties)
                temp(semafoneCapturePageCompId, loc, properties)
            });
		}

		function defaultProperties(loc, properties){
		    if((loc.match('.dev'))||(loc.match('.DEV')) || (loc.match('.env')) || (loc.match('.ENV'))){
                //properties = settings.devSemafoneParameters;
                properties = settings.qaSemafoneParameters;
            }else if((loc.match('localhost'))||(loc.match('LOCALHOST'))){
                properties = settings.devSemafoneParameters;
            }else if((loc.match('.qa'))||(loc.match('.QA'))){
                properties = settings.qaSemafoneParameters;
            }else if((loc.match('.pet'))||(loc.match('.PET'))){
                properties = settings.petSemafoneParameters;
            }else{
                properties = settings.prodSemafoneParameters;
            }
            return properties;
		}
		function temp(semafoneCapturePageCompId, loc, properties){

			var semafoneUrl           =   properties.semafoneUrl;
			var semafoneMode          =   properties.semafoneMode;
			var gatewayId             =   properties.gatewayId;
			//console.log(gatewayId);
			var methodId              =   properties.methodId;
			var ppUserId              =   properties.ppUserId;
			var ppPassword            =   properties.ppPassword;
			var tenantId              =   properties.tenantId;
			var clientId              =   properties.clientId;
			var accountId             =   properties.accountId;
			var principle             =   properties.principle;
			var licenseCode           =   properties.licenseCode;
			var transactionType       =   properties.transactionType;
			var responseType          =   properties.responseType;
			var responseURL           =   properties.responseURL;
			/* var lang = userLanguage();*/
			var isPanFocusedOnInitialise = false;
			var elementFontSize = '24';
			var elementWidth = '300';
			var elementMaxLength = '16';
			var maskedPan = settings.iframeParameters;
			var url = '';
		
			if($('#maskedCardNumber').length > 0 && $('#maskedCardNumber').val().length > 0) {
				maskedPan = $('#maskedCardNumber').val();
		    }
		
			if($('#isPanFocusedOnInitialise').length > 0 && $('#isPanFocusedOnInitialise').val().length > 0) {
				isPanFocusedOnInitialise = $('#isPanFocusedOnInitialise').val();
		    }
			var isPanResetOnInitialFocus = true;
			if($('#isPanResetOnInitialFocus').length > 0 && $('#isPanResetOnInitialFocus').val().length > 0) {
				isPanResetOnInitialFocus = $('#isPanResetOnInitialFocus').val();
		    }
		
			if(semafoneMode !== 'UNKNOWN' && methodId !== 'UNKNOWN') {
				if(methodId === 'TOKENISE'){
					if(semafoneMode === 'DISABLED') {
						url = semafoneUrl + '?semafoneMode=' + semafoneMode + '&gatewayId=' + gatewayId + '&methodId=' + methodId + '&ppUserId=' + ppUserId + '&ppPassword=' + encodeURIComponent(ppPassword) + '&tenantId=' + tenantId + '&clientId=' + clientId + '&accountId=' + accountId + '&principle=' + principle + '&licenseCode=' + licenseCode + '&responseType=' + responseType + '&transactionType=' + transactionType + '&maskedPan=' + maskedPan + '&isPanFocusedOnInitialise=' + isPanFocusedOnInitialise + '&isPanResetOnInitialFocus=' + isPanResetOnInitialFocus + '&elementFontSize=' + elementFontSize + '&elementWidth=' + elementWidth + '&elementMaxLength=' + elementMaxLength + '&responseURL=' + responseURL;
					}else{
						//Error condition: Invalid semafoneMode
					}
				}else{
					//Error condition: Invalid methodId
				}
			}else{
				//Error condition: methodId or semafoneMode not specified
			}
		
			initialiseIframe(url,semafoneCapturePageCompId);
		}
		
		//++++++++++++
		function initialiseIframe(iframeUrl,semafoneCapturePageCompId){
			loadIframe(iframeUrl, semafoneCapturePageCompId, function(semafoneState, semafoneValidationState, semafoneValidationErrorCode, semafoneValidationErrorDesc, cardScheme, currentCardNumberLength, expectedCardNumberLength, expectedSecurityCodeLength, token, maskedPan, processResultState, semafoneResponseCode, semafoneReasonCode, semafoneErrorCode, semafoneErrorName, semafoneErrorCause, semafoneErrorRemedy, semafoneWarningCode, semafoneWarningName, semafoneWarningCause, semafoneWarningRemedy, serviceReasonCode, serviceResponseCode, serviceMessage, serviceErrorCode, serviceErrorName, serviceErrorCause, serviceErrorRemedy) {
				if(semafoneState && semafoneState.length > 0) {
					$('#semafoneState').val(semafoneState);
				}
				if(semafoneValidationState && semafoneValidationState.length > 0) {
					$('#semafoneValidationState').val(semafoneValidationState);
				}
				if( semafoneValidationErrorCode && semafoneValidationErrorCode.length > 0) {
					if(semafoneValidationErrorCode === '100799' && semafoneState === 'ACTIVE'){
						$('#semafoneError').removeClass('ng-hide');
					}
		
					$('#semafoneValidationErrorCode').val(semafoneValidationErrorCode);
				}else{
					$('#semafoneValidationErrorCode').val('');
		       
				}
		
				if(semafoneValidationErrorDesc && semafoneValidationErrorDesc.length > 0){
					$('#semafoneValidationErrorDesc').val(semafoneValidationErrorDesc);
				}else{
					$('#semafoneValidationErrorDesc').val('');
				}
				if((semafoneState && semafoneState.length > 0 && semafoneState === 'ACTIVE' )){
				    //$('#cardNumberErrorSection').hide();
					$('#cardSchemeErrorSection').hide();
	                $('#token').val('');
	                semafoneService.setToken(' ');
	                $('#cardScheme').val('');
	                semafoneService.setCardScheme('');
	                $('#maskedCardNumber').val('');
	                semafoneService.setMaskedCardNumber('');
	                semafoneService.setSemafoneValidationState('Unknown');
	                $('#semafoneTokeniseReasonCode').val('');
	                $('#semafoneTokeniseResponseCode').val('');
	                $('#semafoneTokeniseErrorCode').val('');
	                $('#semafoneTokeniseErrorDesc').val('');
	                $('#cybersourceTokeniseResponseCode').val('');
	                $('#cybersourceTokeniseReasonCode').val('');
	                $('#cybersourceTokeniseMessage').val('');
	                $('#cybersourceTokeniseErrorCause').val('');
	                $('#semafoneError').addClass('ng-hide');
	           }
	           if(semafoneState && semafoneState.length > 0 && semafoneState !== 'COMPLETE') {
	                $('#semafoneState').val(semafoneState);
	           }
	           if(semafoneValidationState && semafoneValidationState.length > 0 && semafoneValidationState !== 'SUCCESS') {
	                $('#semafoneValidationState').val(semafoneValidationState);
	           }
	           if(semafoneValidationState && semafoneValidationState.length > 0 && semafoneValidationState === 'FAIL') {
	                 semafoneService.setToken(' ');
	                 semafoneService.setMaskedCardNumber(' ');
	                 semafoneService.setCardScheme(' ');
	                 semafoneService.setSemafoneValidationState('FAIL');
	                 $('#semafoneError').removeClass('ng-hide');
	           }
	           if(semafoneResponseCode && semafoneResponseCode.length > 0) {
	              $('#semafoneTokeniseResponseCode').val(semafoneResponseCode);
	              if(semafoneResponseCode !== 'SUCCESS' && (!serviceResponseCode || serviceResponseCode.length < 1)) {
	                    $('#isPanResetOnInitialFocus').val(true);
	                    launchSemafoneCapturePage('semafoneCapturePage');
	              }
	           }
	           if(semafoneErrorCode && semafoneErrorCode.length > 0) {

	                $('#semafoneTokeniseErrorCode').val(semafoneErrorCode);
	                if(semafoneErrorCode==='200101'){
	                				$('#semafoneError').addClass('ng-hide');
	                				$('#cyberSourceDown').removeClass('ng-hide');

	                				}
	           }
	           if(semafoneErrorCause && semafoneErrorCause.length > 0) {
	                 $('#semafoneTokeniseErrorDesc').val(semafoneErrorCause);
	           }
	           if( serviceResponseCode && serviceResponseCode.length > 0) {
	              $('#cybersourceTokeniseResponseCode').val(serviceResponseCode);
	              if(serviceResponseCode !== 100) {
	                    $('#isPanResetOnInitialFocus').val(true);
	                   launchSemafoneCapturePage('semafoneCapturePage');
	              }
	           }
	           if(serviceErrorCause && serviceErrorCause.length > 0) {
	                 $('#cybersourceTokeniseErrorCause').val(serviceErrorCause);
	           }
	           if( serviceReasonCode && serviceReasonCode.length > 0) {
	                $('#cybersourceTokeniseReasonCode').val(serviceReasonCode);
	           }
	           if(serviceMessage && serviceMessage.length > 0) {
	                $('#cybersourceTokeniseMessage').val(serviceMessage);
	           }

	           if(processResultState === 'SUCCESS'){
	               $('#semafoneError').addClass('ng-hide');
	               $('#cyberSourceDown').addClass('ng-hide');
	               if(cardScheme && cardScheme.length > 0) {
	                    $('#cardScheme').val(cardScheme);
	                    if(token && token.length > 0){
	                                $('#semafoneError').addClass('ng-hide');
	                               semafoneService.setCardScheme(cardScheme);

	                               switch (cardScheme)
	                               {
	                                   case 'VISA':
	                                       if($('.imgMc').hasClass('card_selected')){
	                                           $('.imgMc').removeClass('card_selected');
	                                           $('.imgMc').addClass('card_not_selected');
	                                       }
	                                       if($('.imgAmex').hasClass('card_selected')){
	                                           $('.imgAmex').removeClass('card_selected');
	                                           $('.imgAmex').addClass('card_not_selected');
	                                       }
	                                       $('.imgVisa').removeClass('card_not_selected');
	                                       $('.imgVisa').addClass('card_selected');
                                           $("#month").focus();
	                                       break;
	                                   case 'MASTERCARD':
	                                       if($('.imgVisa').hasClass('card_selected')){
	                                           $('.imgVisa').removeClass('card_selected');
	                                           $('.imgVisa').addClass('card_not_selected');
	                                       }
	                                       if($('.imgAmex').hasClass('card_selected')){
	                                           $('.imgAmex').removeClass('card_selected');
	                                           $('.imgAmex').addClass('card_not_selected');
	                                       }
	                                       $('.imgMc').removeClass('card_not_selected');
	                                       $('.imgMc').addClass('card_selected');
                                           $("#month").focus();
	                                       break;
	                                   case 'AMEX':
	                                       if($('.imgVisa').hasClass('card_selected')){
	                                           $('.imgVisa').removeClass('card_selected');
	                                           $('.imgVisa').addClass('card_not_selected');
	                                       }
	                                       if($('.imgMc').hasClass('card_selected')){
	                                           $('.imgMc').removeClass('card_selected');
	                                           $('.imgMc').addClass('card_not_selected');
	                                       }
	                                       $('.imgAmex').removeClass('card_not_selected');
	                                       $('.imgAmex').addClass('card_selected');
	                                       $(".imgAmex").attr("tabindex","0");
	                                       $("#month").focus();
	                                       break;
	                                  default:
	                               }
	                    }
	               }
	               if(token && token.length > 0) {
	                    //alert(token);
	                     $('#token').val(token);
	                     semafoneService.setToken(token);
	               }
	               if(maskedPan && maskedPan.length > 0) {
	                     $('#maskedCardNumber').val(maskedPan);
	                     semafoneService.setMaskedCardNumber(maskedPan);
	                     $('#isPanResetOnInitialFocus').val(true);
	                     launchSemafoneCapturePage('semafoneCapturePage');
	               }
	           }
	           if(cardScheme === 'Unknown'){
	            $('#semafoneError').removeClass('ng-hide');

	           }
			});
		}

		//+++++++++++++++++++++
		function loadIframe(url, iframe, fn){
	      //alert('in load iframe');
			var semafoneState ='',
				semafoneValidationState ='',
				semafoneValidationErrorCode ='',
				semafoneValidationErrorDesc ='',
				cardScheme ='',
				currentCardNumberLength ='',
				expectedCardNumberLength ='',
				expectedSecurityCodeLength ='',
				token ='',
				maskedPan ='',
				processResultState ='',
				semafoneResponseCode ='',
				semafoneReasonCode ='',
				semafoneErrorCode ='',
				semafoneErrorName ='',
				semafoneErrorCause ='',
				semafoneErrorRemedy ='',
				semafoneWarningCode ='',
				semafoneWarningName ='',
				semafoneWarningCause ='',
				semafoneWarningRemedy ='',
				serviceReasonCode ='',
				serviceResponseCode ='',
				serviceMessage ='',
				serviceErrorCode ='',
				serviceErrorName ='',
				serviceErrorCause ='',
				serviceErrorRemedy ='';
			
			var src = url + '#' + encodeURIComponent(document.location.href);
	      
			//The style values can be set as required - if elementFontSize or elementWidth have been changed then consider adjusting max-width and height
			$('#' + iframe).html($('<iframe src="' + src + '" style="display: inline;max-width:300" height="40", scrolling="no" transparency="true" offset="0" border="0" outline="0" frameBorder="0" frameborder="0" marginwidth="0" marginheight="0"><\/iframe>'));		// jshint ignore:line


			$.receiveMessage(function(event){
				var bar = event.data.split('&');
				for(var i = 0;i<bar.length;i++){
					var pair  = bar[i].split('=');
					var key   = pair[0];
					var value = pair[1];
					if (key === 'semafoneState'){
						semafoneState = value;
					}else if(key === 'semafoneValidationState'){
						semafoneValidationState = value;
					}else if(key === 'semafoneValidationErrorCode'){
						semafoneValidationErrorCode = value;
					}else if(key === 'semafoneValidationErrorDesc'){
						semafoneValidationErrorDesc = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'cardScheme') {
						cardScheme = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'currentCardNumberLength'){
						currentCardNumberLength = value;
					}else if(key === 'expectedCardNumberLength'){
						expectedCardNumberLength = value;
					}else if (key === 'expectedSecurityCodeLength'){
						expectedSecurityCodeLength = value;
					}else if(key === 'token'){
						token = decodeURIComponent(value);
						$('#token').val(token);
					}else if(key === 'maskedPan'){
						maskedPan = decodeURIComponent(decodeSpaces(value));
						$('#maskedCardNumber').val(maskedPan);
					}else if (key === 'processResultState'){
						processResultState = value;
					}else if (key === 'semafoneResponseCode'){
						semafoneResponseCode = decodeURIComponent(decodeSpaces(value));
					}else if (key === 'semafoneReasonCode'){
						semafoneReasonCode = decodeURIComponent(decodeSpaces(value));
					}else if (key === 'semafoneErrorCode'){
						semafoneErrorCode = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'semafoneErrorName'){
						semafoneErrorName = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'semafoneErrorCause'){
						semafoneErrorCause = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'semafoneErrorRemedy'){
						semafoneErrorRemedy = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'semafoneWarningCode'){
						semafoneWarningCode = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'semafoneWarningName'){
						semafoneWarningName = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'semafoneWarningCause'){
						semafoneWarningCause = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'semafoneWarningRemedy'){
						semafoneWarningRemedy = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'serviceReasonCode'){
						serviceReasonCode = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'serviceResponseCode'){
						serviceResponseCode = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'serviceMessage'){
						serviceMessage = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'serviceErrorCode'){
						serviceErrorCode = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'serviceErrorName'){
						serviceErrorName = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'serviceErrorCause'){
						serviceErrorCause = decodeURIComponent(decodeSpaces(value));
					}else if(key === 'serviceErrorRemedy'){
						serviceErrorRemedy = decodeURIComponent(decodeSpaces(value));
					}
				}

				fn(semafoneState, semafoneValidationState, semafoneValidationErrorCode, semafoneValidationErrorDesc, cardScheme, currentCardNumberLength, expectedCardNumberLength, expectedSecurityCodeLength, token, maskedPan, processResultState, semafoneResponseCode, semafoneReasonCode, semafoneErrorCode, semafoneErrorName, semafoneErrorCause, semafoneErrorRemedy, semafoneWarningCode, semafoneWarningName, semafoneWarningCause, semafoneWarningRemedy, serviceReasonCode, serviceResponseCode, serviceMessage, serviceErrorCode, serviceErrorName, serviceErrorCause, serviceErrorRemedy);
			});

			function decodeSpaces(s){
				s = s.replace (/\+/g, ' ');
				return s;
			}
		}

	  }]);
})(jQuery);

/**
 * @ngdoc module
 * @name makePayment
 * @description
 * # 
 * 
 */

(function(){

	'use strict';
	
	angular.module('makePayment')
	.factory('semafoneService', function(){
		var token = '',
		cardScheme = '',
		maskedCardNumber ='',
		semafoneValidationState ='';
		
		return {
				  setToken : setToken,
				  getToken : getToken,
				  setCardScheme : setCardScheme,
				  getCardScheme:getCardScheme,
				  setMaskedCardNumber:setMaskedCardNumber,
				  getMaskedCardNumber:getMaskedCardNumber,
				  setSemafoneValidationState:setSemafoneValidationState,
				  getSemafoneValidationState:getSemafoneValidationState
				};
		
		function setToken(semafoneToken){
			 //alert('tokenin set mehtod:'+semafoneToken);
			 token = semafoneToken;
		}
		function getToken(){
			//alert('tokeninsemafoneservice'+token);
			return token;
		}
		function setCardScheme(semafonecardScheme){
			cardScheme = semafonecardScheme;
		}
		function getCardScheme(){
			return cardScheme;
		}
		function setMaskedCardNumber(semafonemaksedCardNumber){
			maskedCardNumber = semafonemaksedCardNumber;
		}
		function getMaskedCardNumber(){
			return maskedCardNumber;
		}
		function setSemafoneValidationState(semafoneValidateState){
			semafoneValidationState = semafoneValidateState;
		}
		function getSemafoneValidationState(){
			return semafoneValidationState;
		}
	})
})();


angular.module('mdo-angular-cryptography', [])
    .provider('$crypto', function CryptoKeyProvider() {
        var cryptoKey;

        this.setCryptographyKey = function(value) {
            this.cryptoKey = value;
        }

        this.$get = [function(){
            return {
                cryptoKey: this.cryptoKey,

                encrypt: function(message, key) {

                    if (key === undefined) {
                        key = this.cryptoKey;
                    }

                    return CryptoJS.AES.encrypt(message, key ).toString();
                },

                decrypt: function(message, key) {

                    if (key === undefined) {
                        key = this.cryptoKey;
                    }

                    return CryptoJS.AES.decrypt(message, key).toString(CryptoJS.enc.Utf8)
                }
            }
        }];
    });

(function(){
'use strict';

  angular.module('totesApp')
    .config(['ute.datalayer.common.serviceProvider',
    function (dataLayerServiceProvider) {
      var signinPayload = {
        page: {
          name: 'signin',
          hierarchy: ['selfserve', 'signin']
        }
      };
      var runService = {
        page: {
          name: 'tvDashboard',
          hierarchy: ['selfserve','services','tvDashboard']
        }
      };

      var selectAccountModal = {
        page: {
          name: 'selectAccount',
          hierarchy: ['selfserve', 'accountOverview']
        }
      }

      var changeAccNumber = {
        page: {
          name: 'changeAccountNumber',
          hierarchy: ['selfserve', 'account']
        }
      }

      var isSubMenuEnabled = {
        page: {
          name: 'subMenuEnabled',
          hierarchy: ['selfserve', 'Overview', ]
        }
      }
      var isDisplayPopup = {
        page: {
          name: 'isDisplayPopup',
          hierarchy: ['selfserve', 'Profile']
        }
      }

      var runRogersProfile = {
        page: {
          name: 'accountOverview',
          hierarchy: ['selfserve', 'accountOverview']
        }
      }
      var upgradeDevice = {
        page: {
          name: 'wireless',
          hierarchy: ['selfserve', 'accountOverview', 'wireless']
        }
      }
      var addNewWirelessLine = {
        page: {
          name: 'wireless',
          hierarchy: ['selfserve', 'accountOverview', 'wireless']
        }
      }
      var forgotPasswordPayload = {
        page: {
          name: 'forgotPassword',
          hierarchy: ['selfserve', 'forgotPassword']
        }
      };
      var setPasswordPayload = {
        page: {
          name: 'setPassword',
          hierarchy: ['selfserve', 'setPassword']
        }
      };
      var resetPasswordPayload = {
        page: {
          name: 'resetPassword',
          hierarchy: ['selfserve', 'resetPassword']
        }
      };
      var registrationPayload = {
        page: {
          name: 'registration',
          hierarchy: ['selfserve', 'registration']
        },
        selfServe: {
          type: 'transaction',
          name: 'Register new BSS account'
        },
        events: {
          selfServeStart:true
        }
      };
      var linkAccountPayload = {
        page: {
          name: 'linkAccount',
          hierarchy: ['selfserve', 'linkAccount']
        }
      };
      var guestOverviewPayload = {
        page: {
          name: 'guestOverview',
          hierarchy: ['selfserve', 'guestOverview']
        }
      };
      var accountOverviewPayload = {
        page: {
          name: 'accountOverview',
          hierarchy: ['selfserve', 'accountOverview']
        }
      };
      var viewInvoicePayload = {
        page: {
          name: 'viewBill',
          hierarchy: ['selfserve','billing&payment','viewBill']
        }
      };
      var paymentHistoryPayload = {
        page: {
          name: 'paymentHistory',
          hierarchy: ['selfserve','billing&payment','paymentHistory']
        }
      };
      var makeAPaymentPayload = {
        page: {
          name: 'makeACreditCardPayment',
          hierarchy: ['selfserve','billing&payment','makeAPayment']
        }
      };
      var changePaymentMethodPayload = {
        page: {
          name: 'changePaymentMethod',
          hierarchy: ['selfserve','billing&payment','changePaymentMethod']
        }
      };
      var viewGroupsPayload = {
        page: {
          name: 'viewGroups',
          hierarchy: ['selfserve','billing&payment','viewGroups']
        }
      };
      var viewReportingPayload = {
        page: {
          name: 'viewReporting',
          hierarchy: ['selfserve','billing&payment','viewReporting']
        }
      };
      var wirelessDashboardPayload = {
        page: {
          name: 'physical sim setup',
          hierarchy: ["selfserve", "change my simcard"],
          wirelessPage: true
        }
      };
      var changeSubscriberNamePayload = {
        page: {
          name: 'changeSubscriberName',
          hierarchy: ['selfserve','services', 'wirelessDashboard', 'changeSubscriberName'],
          wirelessPage: true
        }
      };
      var simCardPayload = {
        page: {
          name: 'simCard',
          hierarchy: ['selfserve','services', 'wirelessDashboard', 'simCard'],
          wirelessPage: true
        }
      };
      var suspendCtnStartPayload = {
        page: {
          name: 'suspendCtnStart',
          hierarchy: ['selfserve','services', 'wirelessDashboard', 'suspendCtnStart'],
          wirelessPage: true
        }
      };
      var suspendCtnSuccessPayload = {
        page: {
          name: 'suspendCtnSuccess',
          hierarchy: ['selfserve','services', 'wirelessDashboard', 'suspendCtnSuccess'],
          wirelessPage: true
        }
      };
      var reactivateCtnPayload = {
        page: {
          name: 'reactivateCtn',
          hierarchy: ['selfserve','services', 'wirelessDashboard', 'reactivateCtn'],
          wirelessPage: true
        }
      };
      var resetVoiceMailboxPayload = {
        page: {
          name: 'resetVoiceMailbox',
          hierarchy: ['selfserve','services', 'wirelessDashboard', 'resetVoiceMailbox'],
          wirelessPage: true
        }
      };
      var shmDashboardPayload = {
        page: {
          name: 'shmDashboard',
          hierarchy: ['selfserve','services','shmDashboard']
        }
      };
      var tvDashboardPayload = {
        page: {
          name: 'tvDashboard',
          hierarchy: ['selfserve','services','tvDashboard']
        }
      };
      var businessPhoneDashboardPayload = {
        page: {
          name: 'businessPhoneDashboard',
          hierarchy: ['selfserve','services','businessPhoneDashboard']
        }
      };
      var internetDashboardPayload = {
        page: {
          name: 'internetDashboard',
          hierarchy: ['selfserve','services','internetDashboard']
        }
      };
      var easSuccessPayload = {
        page: {
          name: 'password-set-successful',
          hierarchy: ['recover-password']
        }
      };
      var easErrorPayload = {
        page: {
          name: 'easError',
          hierarchy: ['selfserve','easError']
        }
      };
      var underMaintenancePayload = {
        page: {
          name: 'underMaintenance',
          hierarchy: ['selfserve','underMaintenance']
        }
      };

      //All modals
      var accountSelectionModalPayload = {
        page: {
          name: 'accountSelectionModal',
          hierarchy: ['selfserve','accountOverview','accountSelectionModal']
        }
      };
      var switchBillTypeModalPayload = {
        page: {
          name: 'switchBillTypeModal',
          hierarchy: ['selfserve', 'accountOverview', 'switchBillTypeModal']
        }
      };
      var changeEsimcard ={
        page: {
        name: "change my simcard",
        hierarchy: ["selfserve", "change my simcard"]
        }
      };
      var shareEsimcard ={
        page: {
        name: "esim setup",
        hierarchy: ["selfserve", "change my simcard"]
        }
      };
      var shareEsimemail ={
        page: {
        name: "share esim",
        hierarchy: ["selfserve", "change my simcard"]
        }
      };
      var shareeSimsuccess ={
        page: {
        name: "share esim success",
        hierarchy: ["selfserve", "change my simcard"]
        }
      };
      var confirmSimsuccess ={
        page: {
        name: "esim setup success",
        hierarchy: ["selfserve", "change my simcard"]
        }
      };
      var PhysicalSimcard ={
        page: {
        name: "physical sim setup",
        hierarchy: ["selfserve", "change my simcard"]
        }
      };
      var physicalsimContinue = {
        page: {
          name: "confirmation",
          hierarchy: ["selfserve", "change my simcard"],
          }
      };
      var physicalsimConfirmation = {
        page: {
          name: "confirmation",
          hierarchy: ["selfserve", "change my simcard", "physical sim setup"]
          }
      };
      var physicalsimSuccess = {
        page: {
          name: "success",
          hierarchy: ["selfserve", "change my simcard", "physicalsim setup", "confirmation"],

          }

      };
      var PhysicalsimModalerror = {
        page: {
          name: 'modal-error message',
          "hierarchy": ["selfserve", "change my simcard", "physicalsim setup", "confirmation"],
          wirelessPage: true
        }
      };
      var TransferesimLink = {
        page: {
          name: 'esim setup',
          "hierarchy": ["selfserve", "change my simcard"],
        }
      };
      var TransferesimdeviceList = {
        page: {
          name: 'esim transfer',
          "hierarchy": ["selfserve", "change my simcard", "esimtransfer"],
        }
      };
      var TransferesimNodeviceList = {
        page: {
          name: 'no compatible devices',
          "hierarchy": ["selfserve", "change my simcard", "esimtransfer"],
        }
      };
      var TransferesimSuccess = {
        page: {
          name: 'success',
          "hierarchy": ["selfserve", "change my simcard", "esimtransfer"],
        }
      };
      var TransferesimError = {
        page: {
          name: 'error',
          "hierarchy": ["selfserve", "change my simcard", "esimtransfer"],
        }
      };
             //All Interactions


      var errorConfig = {
        errorCategory: {
          category: 'self serve'
        },
        errorPageNamePayload: {
          page: {
            name: 'error'
          }
        },
        defaultTranslateService: 'resource',
        defaultAPIErrorMessageKey: 'bb_error_message_system_issue',
        defaultAPIErrorMessageContent: 'We\’re working on fixing the problem. If you need help right away, please contact us.',
        errorTrackingAPIs: [
          {
            name: 'accountoverview',
            message: 'acc_overview_oops',
            errorsMap: {
              10403: 'error_population_accounts'
            }
          },
          {
            name: 'getWinAvailableInvoices',
            message: 'bb_error_message_header_system_issue_winonline'
          },
          {
            name: 'epost',
            message: 'bb_error_message_header_system_issue_epost'
          },
          {
            name: 'activatedUserSummary',
            message: 'bb_error_message_header_system_issue_britebill'
          },
          {
            name: 'bulkDownload',
            message: 'DT_technical_error_message'
          }
        ]
      };

      var config = {
        basic: {
          site: {
            name: 'R-BIZ'
          }
        },
        advance: {
          //---------------------------------------
          // About the 'configOptions' property:
          //
          // - Indicate whether you'd like to load the configuration from the file specified in 'pathToConfigFile'.
          // - If the configuration file is not specified, the locally defined configuration mapping will be used instead.
          //---------------------------------------
          configOptions: {
            rootHierarchy: ['selfserve'], // Default Page Hierarchy - one or multiple level(s) (See FSD v5.1 pg. 19)
            pathToConfigFile: 'resource/dataLayerConfig.json', // path to the configuration file
            loadFromFile: false, // 'true' to load configuration from a file, 'false' otherwise
            isAbsolutePath: false, // 'true' if pathToConfigFile is a full URL (i.e. a CMS http link), 'false' otherwise.
            globalTrackingOn: true, // flag to specify if global tracking should be enabled
            queryParamTrackingOn: false, // flag to specify if query parameters tracking should be enabled
            globalTrackingExclusive: true,
            suppressCTNForNonWireless: true
          },
          defaultTranslateService: errorConfig.defaultTranslateService,
          defaultAPIErrorMessageKey: errorConfig.defaultAPIErrorMessageKey,
          defaultAPIErrorMessageContent: errorConfig.defaultAPIErrorMessageContent,
          errorTrackingAPIs: errorConfig.errorTrackingAPIs,

          //---------------------------------------
          // The mapping keys can be defined here:
          //---------------------------------------
          mappingKey: {
            //---------------------------------------
            // Global variable Page Name & Hierarchy
            // (See FSD v5.1 Pg. 18)
            //---------------------------------------
            'formError': {
                type: 'form',
                category: 'selfserve'
            },
            'signin': {
              page: signinPayload.page
            },
            'runService': {
              page: runService.page
            },
            'selectAccountModal': {
              page: selectAccountModal.page
            },
            'changeAccNumber': {
              page: changeAccNumber.page
            },
            'isDisplayPopup': {
              page: isDisplayPopup.page
            },
            'runRogersProfile': {
              page: runRogersProfile.page
            },
            'upgradeDevice': {
              page: upgradeDevice.page
            },
            'addNewWirelessLine': {
              page: addNewWirelessLine.page
            },
            'isSubMenuEnabled': {
              page: isSubMenuEnabled.page
            },
            'sso/forgotPassword': {
              page: forgotPasswordPayload.page
            },
            'sso/setPassword': {
              page: setPasswordPayload.page
            },
            'sso/resetPassword': {
              page: resetPasswordPayload.page
            },
            'simCard.confirmation':{
              page: physicalsimConfirmation.page,
              "events": {
                "pageView": true
                },
            },
            'simCard.success':{
              page: physicalsimConfirmation.page,
              "events": {
                "pageView": true
                },
            },
            'sso/registration': {
              page: registrationPayload.page,
              selfServe: registrationPayload.selfServe,
              events: registrationPayload.events
            },
            'linkaccount': {
              page: linkAccountPayload.page
            },
            'guestOverview': {
              page: guestOverviewPayload.page
            },
            'accountOverview': {
              page: accountOverviewPayload.page
            },
            'viewInvoice': {
             page: viewInvoicePayload.page
            },
            'payHistory': {
              page: paymentHistoryPayload.page
            },
            'makeAPayment': {
              page: makeAPaymentPayload.page
            },
            'changePayMethod': {
              page: changePaymentMethodPayload.page
            },
            'viewGroups': {
              page: viewGroupsPayload.page
            },
            'viewReporting': {
              page: viewReportingPayload.page
            },
            'wireless': {
              page: wirelessDashboardPayload.page,
              "events": {
                "interaction": true
                },
                "interaction": {
                "name": "bss change to physical sim enter new sim card cancel button",
                "type": "click"
                },
            },
            'physicalsimModalerror':{
              page: PhysicalsimModalerror.page,
              "events": {
                "error": true,
                "pageView": true
                },
            },
            'changesubscribername': {
              page: changeSubscriberNamePayload.page
            },

            'simCard.confirmation':{
              page: physicalsimConfirmation.page,
            },
            'simCard.success':{
              page: physicalsimSuccess.page,
              "events": {
                "pageView": true
                },
            },
            'physicalsimContinue':{
              page: physicalsimContinue.page,
              "events": {
                "interaction": true
                },
                "interaction": {
                "name": "bss change to physical sim enter new sim card continue button",
                "type": "click"
                },
            },
            'suspendCtn.start': {
              page: suspendCtnStartPayload.page
            },
            'suspendCtn.success': {
              page: suspendCtnSuccessPayload.page
            },
            'reactivateCtn.success': {
              page: reactivateCtnPayload.page
            },
            'resetvoicemailbox': {
              page: resetVoiceMailboxPayload.page
            },
            'shmdashboard': {
              page: shmDashboardPayload.page
            },
            'tvdashboard': {
              page: tvDashboardPayload.page
            },
            'businessphonedashboard': {
              page: businessPhoneDashboardPayload.page
            },
            'internetdash': {
              page: internetDashboardPayload.page
            },
            'easSuccess': {
              page: easSuccessPayload.page
            },
            'easError': {
              page: easErrorPayload.page
            },
            'underMaintenance': {
              page: underMaintenancePayload.page
            },
            'validatelinkAccountStep1FormError': {
              API: 'validatelinkAccountInfo',
              code: '200',
              type: 'http',
              category: 'Selfserve'
            },
            'validatelinkAccountStep2FormError': {
              API: 'linkAccount',
              code: '200',
              type: 'http',
              category: 'Selfserve'
            },

            //All modals
            'accountSelectionModal': {
              page: accountSelectionModalPayload.page
            },
              //All Interactions
            'signingIn': {
              page: signinPayload.page,
              signin: {
                type: 'Login-BSS-S'
              },
              events: {
                signinAttempt: true
              },
              signin: {
                 type: 'Login-BSS-S'
                 },
            },
            'signInAttempt': {
                events: {
                SignInAttempt:true
                },
             Signin: {
                type: 'Login-BSS-S'
                   }
            },
            'signInSuccess': {
              page: signinPayload.page,
              signin: {
                type: 'Login-BSS-S'
              },
              events: {
                signinSuccess: true
              }
            },
            'signInError': {
             page: signinPayload.page,
             site: {
                name: 'R-BIZ'
             },
             errors: [{
                             API : "web/smb/api/business/v2/login",
                             category:"login",
                             code: 500,
                             message:"Sorry, we don't recognize the credentials you've entered. Please try again.",
                             name: "signInError",
                             type:"http"
                           }],
             events: {
               pageView: true,
               error: true
             }
            },
            'forgotPasswordLink': {
              page: signinPayload.page,
              selfServe: {
                type: 'transaction',
                name: 'Reset Password'
              },
              events: {
                selfServeStart: true
              }
            },
            'guestOverviewToLinkAccount': {
              page: guestOverviewPayload.page,
              selfServe: {
                type: 'transaction',
                name: 'Link Account'
              },
              events: {
                selfServeStart: true
              }
            },
            'accountOverviewTolinkAccount': {
              page: accountOverviewPayload.page,
              selfServe: {
                type: 'transaction',
                name: 'Link Account'
              },
              events: {
                selfServeStart: true
              }
            },
            'linkAccountStep1Validation': {
              page: linkAccountPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Link Account|Step 1 submit'
              },
              events: {
                interaction: true
              }
            },
            'linkAccountStep2Validation': {
              page: linkAccountPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Link Account|Step 2 submit'
              },
              events: {
                interaction: true
              }
            },
            'linkAccountSuccess': {
              page: linkAccountPayload.page,
              selfServe: {
                type: 'transaction',
                name: 'Link Account'
              },
              events: {
                selfServeComplete: true
              }
            },
            'linkAccountCancel': {
              page: linkAccountPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Link Account|Cancel'
              },
              events: {
                interaction: true
              }
            },
            'switchBillTypeSelection': {
              page: switchBillTypeModalPayload.page,
              selfServe : {
                type: 'transaction',
                name: 'Change Bill Type to Online'
              },
              events : {
                selfServeStart: true
              }
            },
            'switchBillConfirmation': {
              page: switchBillTypeModalPayload.page,
              selfServe : {
                type: 'transaction',
                name: 'Change Bill Type to Online'
              },
              events : {
                selfServeComplete: true
              }
            },
            'switchBillFailure': {
              page: switchBillTypeModalPayload.page,
              selfServe : {
                type: 'transaction',
                name: 'Change Bill Type to Online Failure'
              }
            },
            'switchBillCancel': {
              page: switchBillTypeModalPayload.page,
              interaction : {
                type: 'click',
                name: 'Cancel Online Billing'
              },
              events : {
                interaction: true
              }
            },
            'updateUsername': {
              page: switchBillTypeModalPayload.page,
              interaction : {
                type: 'click',
                name: 'Update Username'
              },
              events : {
                interaction: true
              }
            },
            'discoverWirelessPlanBanner': {
              page: accountOverviewPayload.page,
              link: {
                type: 'exit',
                URL: 'https://www.rogers.com/small-business/products-and-solutions/wireless/plans-and-pricing?icid=ba-bsssftcon-bsrbwrls-0101184'
              },
              events: {
                linkClick: true
              }
            },
            'rogersBusinessAppMarketBanner': {
              page: accountOverviewPayload.page,
              link: {
                type: 'exit',
                URL: 'https://businessmarket.rogers.com/home'
              },
              events: {
                linkClick: true
              }
            },
            'rogersCheckInBanner': {
              page: accountOverviewPayload.page,
              link: {
                type: 'exit',
                URL: 'http://am.rogers-esa.com/'
              },
              events: {
                linkClick: true
              }
            },
            'RogersUnisonBanner': {
              page: accountOverviewPayload.page,
              link: {
                type: 'exit',
                URL: 'https://www.rogers.com/small-business/products-and-solutions/wireless/plans-and-pricing?icid=ba-bsssftcon-bsrbwrls-0101184'
              },
              events: {
                linkClick: true
              }
            },
            //All Interactions
            'manageBAN': {
              page: accountOverviewPayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'Manage Different BAN'
              },
              events: {
                selfServeComplete: true
              }
            },
            'registerLink': {
              page: signinPayload.page,
              interaction: {
                type: 'click',
                name: 'Register new BSS account-Login Page'
              },
              events: {
                interaction: true
              }
            },
            'forgotPasswordVerificationPage': {
              page: {
                name: 'forgotPasswordVerificationSent',
                hierarchy: forgotPasswordPayload.page.hierarchy
              }
            },
            'viewBillAccOverview': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Account Overview|View Bill CTA'
              },
              events: {
                interaction: true
              }
            },
            'makePaymentAccOverview': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Account Overview|Make a Payment CTA'
              },
              events: {
                interaction: true
              }
            },
            'wirelessServiceBadges': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S – Services Badge – Wireless'
              },
              events: {
                interaction: true
              }
            },
            'tvServiceBadges': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S – Services Badge – TV'
              },
              events: {
                interaction: true
              }
            },
            'internetServiceBadges': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S – Services Badge – Internet'
              },
              events: {
                interaction: true
              }
            },
            'phoneServiceBadges': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S – Services Badge – Phone'
              },
              events: {
                interaction: true
              }
            },
            'billingAndPaymentTab': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav - Billing and Payment'
              },
              events: {
                interaction: true
              }
            },
            'invoiceBillingAndPayment': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav - Billing and Payment – Invoice'
              },
              events: {
                interaction: true
              }
            },
            'groupsBillingAndPayment': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav - Billing and Payment – Groups'
              },
              events: {
                interaction: true
              }
            },
            'reportsBillingAndPayment': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav - Billing and Payment – Reports'
              },
              events: {
                interaction: true
              }
            },
            'profileTab': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav – Profile'
              },
              events: {
                interaction: true
              }
            },
            'serviceTab': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav – Services'
              },
              events: {
                interaction: true
              }
            },
            'wirelessServiceTab': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav – Services – Wireless'
              },
              events: {
                interaction: true
              }
            },
            'tvServiceTab': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav – Services – TV'
              },
              events: {
                interaction: true
              }
            },
            'internetServiceTab': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav – Services – Internet'
              },
              events: {
                interaction: true
              }
            },
            'phoneServiceTab': {
              page: accountOverviewPayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Secondary Nav – Services – Phone'
              },
              events: {
                interaction: true
              }
            },
            'briteBill': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'View Invoice – BriteBill'
              },
              events: {
                selfServeComplete: true
              }
            },
            'downloadBills': {
              page: viewInvoicePayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Download Bills-Bulk|Button on View Bills page'
              },
              events: {
                interaction: true
              }
            },
            'cancelDownload': {
              page: viewInvoicePayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Download Bills-Bulk|Cancel'
              },
              events: {
                interaction: true
              }
            },
            'downloadBillConfirmation': {
              page: viewInvoicePayload.page,
              interaction: {
                type: 'click',
                name: 'BSS-S|Download Bills-Bulk|Confirm to download'
              },
              events: {
                interaction: true
              }
            },
            'downloadBillsSuccess': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'Download Bills-Bulk'
              },
              events: {
                selfServeComplete: true
              }
            },
            'briteBillNextBill': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'View Invoice – BriteBill'
              },
              events: {
                selfServeComplete: true,
                interaction: true
              },
              interaction: {
                type: 'click',
                name: 'See Next Bill'
              }
            },
            'briteBillPreviousBill': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'View Invoice – BriteBill'
              },
              events: {
                selfServeComplete: true,
                interaction: true
              },
             interaction: {
               type: 'click',
               name: 'See Previous Bill'
             }
            },
            'epostBill': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'View Invoice - ePost'
              },
              events: {
                selfServeComplete: true
              }
            },
            'epostBillNextBill': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'View Invoice - ePost'
              },
              events: {
                selfServeComplete: true,
                interaction: true
              },
              interaction: {
               type: 'click',
               name: 'See Next Bill'
              }
            },
            'epostBillPreviousBill': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'View Invoice - ePost'
              },
              events: {
                selfServeComplete: true,
                interaction: true
              },
              interaction: {
                type: 'click',
                name: 'See Previous Bill'
              }
            },
            'winOnline': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'View Invoice - WinOnline'
              },
              events: {
                selfServeComplete: true
              }
            },
            'pdfNotLoadingError': {
              page: viewInvoicePayload.page,
              errors: [{
                API : "bills/wol",
                category:"Selfserve",
                code: 200,
                message:"200 - OK - We couldn't load the PDF, right now. - 200 - Failed to load the PDF.",
                type:"http"
              }],
              selfServe: {
                type: 'inquiry',
                name: 'No Invoice Available'
              },
              events: {
                error: true
              }
            },
            'noInvoicesAvailable': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'No Invoice Available'
              },
              events: {
                selfServeComplete: true
              }
            },
             'noInvoiceReturned': {
              page: viewInvoicePayload.page,
              selfServe: {
                type: 'inquiry',
                name: 'No Invoice PDF returned by WinOnline'
              },
              events: {
                selfServeComplete: true
              }
            },
             'winPdfDownload': {
               page: viewInvoicePayload.page,
               selfServe: {
                 type: 'inquiry',
                 name: 'Download Invoice – WinOnline PDF'
               },
               events: {
                 selfServeComplete: true
               }
             },
             'makePaymentInitiate': {
               page: {
                 name: 'reviewCreditCardPaymentInformation',
                 hierarchy: ['selfserve','billing&payment','makeAPayment']
               },
               selfServe: {
                type: 'transaction',
                name: 'Make a payment'
               },
               events: {
                selfServeStart: true
               }
             },
             'accountOverBanner': { //RBIB-298
              events: {
                interaction: true
              },
               applicationName: "My Account Rogers",
               interaction: {
                 type: "click",
                 name: "Account Overview Banner - CTA"
               },
               "personalization": {},
                "site": {
                "name": "R-MBH"
                }
              },
             'fitEntryPoint1': {
               events: {
                 interaction: true
               },
               page: {
                  "name": "accountoverview",
                  "hierarchy": ["selfserve","accountoverview"]
                },
                interaction: {
                  type: "click",
                  name: "BSS-S|Account Overview|Link|Initiate transfer of responsibility"
                }
             },
             'fitEntryPoint2': {
              events: {
                interaction: true
              },
              page: {
                "name": "accountoverview",
                "hierarchy": ["selfserve","accountoverview"]
              },
              interaction: {
                type: "click",
                name: "BSS-S|Account Overview|Link|Submit a billing inquiry"
              }
            },
            'fitEntryPoint3': {
                events: {
                  interaction: true
                },
                page: {
                  "name": "accountoverview",
                  "hierarchy": ["selfserve","accountoverview"]
                },
                interaction: {
                  type: "click",
                  name: "BSS-S|Account Overview|Link|Submit an inquiry about this portal"
                }
            },
            'fitEntryPoint4': {
              events: {
                interaction: true
              },
              page: {
                 "name": "accountoverview",
                 "hierarchy": ["selfserve","accountoverview"]
               },
               interaction: {
                 type: "click",
                 name: "BSS-S|Account Overview|Link|View order status"
               }
              },
              'fitEntryPoint5': {
                events: {
                  interaction: true
                },
                page: {
                  "name": "accountoverview",
                  "hierarchy": ["selfserve","accountoverview"]
                },
                interaction: {
                  type: "click",
                  name: "BSS-S|Account Overview|Link|Create new user"
                }
              },
              'fitEntryPoint6': {
                events: {
                  interaction: true
                },
                page: {
                  "name": "accountoverview",
                  "hierarchy": ["selfserve","accountoverview"]
                },
                interaction: {
                  type: "click",
                  name: "BSS-S|Account Overview|Link|Transfer number"
                }
              },
              'fitInvoiceEntryPoint': {
                events: {
                  interaction: true
                },
                interaction: {
                  type: "click",
                  name: "BSS-S|Billing and Payment|Link|Submit a billing inquiry"
                },
                page: {
                  name: "viewBill",
                  hierarchy: ["selfserve","billing&payment","viewBill"]
                }
              },
              'changeEsimcard':{
                page: changeEsimcard.page,
                events: {
                  pageView: true,
                }
              },
              'esimSetupmodal':{
                page: shareEsimcard.page,
                events: {
                  pageView: true,
                }
              },
              'eSimqrcodecheckbox':{
                page: shareEsimcard.page,
                interaction: {
                  type: "click",
                  name: "bss esim setup i have successfully scanned the qr code with my device checkbox"
                },
                events: {
                  "interaction": true,
                }
              },
              'eSimsetupback':{
                page: shareEsimcard.page,
                interaction: {
                  type: "click",
                  name: "bss esim setup go back button"

                },
                events: {
                  "interaction": true,
                }
              },
              'eSimConfirmsetup':{
                page: shareEsimcard.page,
                interaction: {
                  type: "click",
                  name: "bss esim setup confirm and change sim"
                },
                events: {
                  "interaction": true,
                }
              },
              'PhysicalSimsetup':{
                page: PhysicalSimcard.page,
                events: {
                  "pageView": true,
                }
              },
              'shareEsimcode':{
                page: shareEsimcard.page,
                interaction: {
                  type: "click",
                  name: "bss esim setup share this esim with someone else external link"
                },
                events: {
                  "interaction": true,
                }
              },
              'shareEmailcode':{
                page: shareEsimemail.page,
                selfServe: {
                  name: "bss share esim with someone else",
                  type: "transaction",
                },
                events: {
                    "selfServeStart": true,
                    "pageView": true
                }
              },
              'shareEmailbutton':{
                page: shareEsimemail.page,
                "interaction": {
                  "name": "bss esim setup share esim with someone else share button",
                  "type": "click"
                  },
                events: {
                    "interaction": true
                }
              },
              'shareeSimsuccess':{
                page: shareeSimsuccess.page,
                events: {
                  "selfServeComplete": true
                },
                "selfServe": {
                  "name": "bss share esim with someone else",
                  "type": "transaction"
                  },
              },
              'confirmeSimsuccess':{
                page: confirmSimsuccess.page,
                events: {
                  "pageView": true
                }
              },
              'shareCancelbutton':{
                page: shareEsimemail.page,
                "interaction": {
                  "name": "bss esim setup share esim with someone else cancel button",
                  "type": "click"
                  },
                events: {
                    "interaction": true
                }
              },
              'esimOtpbackTodashboard':{
                page: shareeSimsuccess.page,
                "interaction": {
                  "name": "bss share esim with someone else success back to dashboard button",
                  "type": "click"
                  },
                events: {
                    "interaction": true
                }
              },
              'transferesimcode':{
                page: TransferesimLink.page,
                "interaction": {
                  "type": "click",
                  "name": "bss esim setup transfer esim link"
                  },
                events: {
                    "interaction": true
                }
              },
              'transferesimdevicelist':{
                page: TransferesimdeviceList.page,
                events: {
                    "interaction": true
                }
              },
              'transferesimNodevicelist':{
                page: TransferesimNodeviceList.page,
                  "events": {
                    "pageView": true
                    },
              },"events": {
                "error": true
                },

              'transferesimSuccess':{
                page: TransferesimSuccess.page,
                  "events": {
                    "pageView": true
                    },
              },
              'transferesim500Error':{
                page: TransferesimError.page,
                "events": {
                  "error": true
                  },
                  errors: [{
                    API : "mbh/v1/seamlessesim/reserveSeamlessESIM",
                    category:"self serve",
                    code: 500,
                    message:"Sorry, we’re unable to send the eSIM now. Please try again later.",
                    type:"http"
                  }],
              },
              'transferesim422Error':{
                page: TransferesimError.page,
                "events": {
                  "error": true
                  },
                  errors: [{
                    API : "mbh/v1/seamlessesim/reserveSeamlessESIM",
                    category:"self serve",
                    code: 422,
                    message:"Due to technical difficulty, we’re unable to send the eSIM to the selected mobile device. Please try sending eSIM via email.",
                    type:"http"
                  }],
              },
          }//mappingKey
        } //advance
      };

      dataLayerServiceProvider.configure(config);
    }]);
})();

'use strict';

angular.module('rfrApp')
  .factory('rfrAjax', [
    'backend',
    'apiRoutes',
    'rfrUtilService',
    '$http',
    '$location',
    'userLanguage',
    '$q',
    rfrAjax
  ])
  .constant('apiRoutes', {
    rfrAPI: {
      getAccountList: 'accountoverview',
      membershipList: 'rfr/membership/list',
      membershipDetail: 'rfr/membership/details',
      getRewardCategories: 'rfr/reward/categories',
      getRewardsList: 'rfr/reward/products',
      getTransactions: 'rfr/reward/transactions',
      getEarnCategories: 'rfr/promotion/categories',
      getEarnList: 'rfr/marketing/promotions',
      getProductImg: 'rfr/product/image',
      getWishList: 'rfr/wishList',
      updateWishList: 'rfr/updateWishList',
      enrollToRFR: 'rfr/enroll',
      redeemReward: 'rfr/redeem',
      optInSpecialOffer: 'rfr/optInToSpecialOffer',
      getCmsContent: 'teamsite/list',
      tracePage: 'rfr/tracePage',
      addressValidationRequest: 'address/validation'
    },
    localJSON: {
      getAccountList: 'accountoverview',
      membershipList: 'rfr/api/MembershipList.json',
      membershipDetail: 'rfr/membership/details',
      getRewardCategories: 'rfr/reward/categories',
      getRewardsList: 'rfr/reward/products',
      getTransactions: 'rfr/api/transactions.json',
      getEarnCategories: 'rfr/promotion/categories',
      getEarnList: 'rfr/api/promotions.json',
      getProductImg: 'rfr/product/image',
      getWishList: 'rfr/wishList',
      updateWishList: 'rfr/updateWishList',
      enrollToRFR: 'rfr/enroll',
      redeemReward: 'rfr/redeem',
      optInSpecialOffer: 'rfr/optInToSpecialOffer',
      getCmsContent: 'teamsite/list',
      tracePage: 'rfr/tracePage',
      addressValidationRequest: 'address/validation'
    }
  });

function rfrAjax(backend,
                 apiRoutes,
                 rfrUtilService,
                 $http,
                 $location,
                 userLanguage,
                 $q) {

  //if true, the requests are local, to /rfr/api/*.json files
  //there's also localOverride bit in each request, for convenience
  var USE_LOCAL_JSON = false,
    cmsContentErrors,
    locks = {
      wishListLock: false
    },

    getBaselineOptions = function () {
      return {
        channel: rfrUtilService.getChannel(),
        pageSource: rfrUtilService.getPageSource()
      };
    },

    errorDispatch = function (error) {
      var userFriendlyErrorMsg = '',
        errorString,
        errorDisplayStrings = {
          errorData: error && error.data && error.data.data ? error.data.data : error && error.data ? error.data : error ? error : 'ajax error',
          errorStatus: error.originalError || error
        };

      if (cmsContentErrors && cmsContentErrors.length) {
        cmsContentErrors.filter(function (e) {
          return e.id === 'rfr.error.' + errorDisplayStrings.errorData.errorCode;
        });
      }

      if (userFriendlyErrorMsg.length) {
        errorString = userLanguage() === 'en' ? userFriendlyErrorMsg[0].englishMessage : userFriendlyErrorMsg[0].frenchMessage;
        errorDisplayStrings.errorString = errorString;
      }
      return rfrUtilService.errorDisplay(errorDisplayStrings);
    },

    apiDispatchInterceptor = function (ops) {
      var headerOptions = rfrUtilService.getHeaderOptions() ? rfrUtilService.getHeaderOptions().headerData : null,
        options = $.extend(true, {}, ops, getBaselineOptions());

      if (USE_LOCAL_JSON || ops.localOverride) {
        console.log('WARNING! Call to local JSON file: ' + ops.opCode);
        return $http.get(apiRoutes.localJSON[ops.opCode])
          .then(
          function (data) {
            return data.data;
          },
          function (res) {
            apiDispatchInterceptor(ops);
            console.log(res, 'error');
          }
        );
      } else {
        return backend.post(apiRoutes.rfrAPI[ops.opCode],
          options, null, headerOptions);
      }
    };

  //rfrAjax API
  return {
    stateResolveError: errorDispatch,
    getAccountList: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'getAccountList',
        applicationId:'Rogers.com'
      }, ops))
        .catch(errorDispatch);
    },
    membershipList: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'membershipList'
      }, ops))
        .catch(errorDispatch);
    },
    membershipDetail: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'membershipDetail'
      }, ops))
        .catch(errorDispatch);
    },
    getTransactions: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'getTransactions'
      }, ops))
        .catch(errorDispatch);
    },
    getRewardCategories: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'getRewardCategories'
      }, ops))
        .catch(errorDispatch);
    },
    getRewardsList: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'getRewardsList'
      }, ops))
        .catch(errorDispatch);
    },
    getEarnCategories: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'getEarnCategories'
      }, ops))
        .catch(errorDispatch);
    },
    getEarnList: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'getEarnList'
      }, ops))
        .catch(errorDispatch);
    },
    getProductImg: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'getProductImg'
      }, ops))
        .catch(errorDispatch);
    },
    getWishList: function (ops) {
      if (!locks.wishListLock) {
        locks.wishListLock = true;
        return apiDispatchInterceptor($.extend(true, {}, {
          opCode: 'getWishList'
        }, ops))
          .then(function (data) {
            locks.wishListLock = false;
            return data;
          })
          .catch(function (err) {
            locks.wishListLock = false;
            return errorDispatch(err);
          });
      } else {
        return $q.when([]);
      }
    },
    updateWishList: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'updateWishList'
      }, ops))
        .catch(errorDispatch);
    },
    enrollToRFR: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'enrollToRFR'
      }, ops))
        .catch(errorDispatch);
    },
    redeemReward: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'redeemReward'
      }, ops))
        .catch(errorDispatch);
    },
    optInSpecialOffer: function (ops) {
      ops.channelName = rfrUtilService.getChannel();
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'optInSpecialOffer'
      }, ops))
        .catch(errorDispatch);
    },
    getCmsContent: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'getCmsContent'
      }, ops))
        .catch(errorDispatch);
    },
    tracePage: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'tracePage'
      }, ops))
        .catch(errorDispatch);
    },
    addressValidationRequest: function (ops) {
      return apiDispatchInterceptor($.extend(true, {}, {
        opCode: 'addressValidationRequest'
      }, ops));//we don't catch error here, let the requester deal with it
    }
  };
}

//Speed optimization
angular.module('rfrApp').config(["$httpProvider", function ($httpProvider) {
  $httpProvider.useApplyAsync(true);
}]);



'use strict';

angular.module('rfrApp')
  .config([
    '$compileProvider',
    'uteEndpointProvider',
    function ($compileProvider,
              uteEndpointProvider) {

      $compileProvider.debugInfoEnabled(true);
      if (window.location.hash.match('sidh')) {//if it comes from MyAccount
        uteEndpointProvider.setCMSContentURL('/');
      } else {
        uteEndpointProvider.setCMSContentURL('/web/totes/');
      }
    }])
  .run([
    '$rootScope',
    '$state',
    '$stateParams',
    'rfrAjax',
    'userLanguage',
    function ($rootScope,
              $state,
              $stateParams,
              rfrAjax,
              userLanguage) {

      //close the ruiDropdown menus
      angular.element(document).on('click', function (e) {
        $rootScope.$broadcast('documentClicked', angular.element(e.target));
      });
      $rootScope.errorCode = {};
      //reload the APIs on languageChange:
      $rootScope.rfrAPIlang = userLanguage();
      $rootScope.$on('resourceChanged', function (event) {
        if ($state.includes('rewards') && $rootScope.rfrAPIlang !== userLanguage()) {
          $rootScope.rfrAPIlang = userLanguage();
          $state.transitionTo($state.current, $stateParams, {reload: true, inherit: false, notify: true});
        }
      });

      $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
        if (!!toState && !!toState.name && !!toState.name.match(/rewards.*/)) {
          if (toParams.rewardId && toParams.rewardProductId) {
            rfrAjax.tracePage({ logObjectId: toParams.rewardProductId });
          } else if (toParams.earnId && toParams.marketingPromotionId) {
            rfrAjax.tracePage({ logObjectId: toParams.marketingPromotionId });
          } else if (toParams.rewardId && !toParams.rewardProductId) {
            // this is a direct link to a reward card scenario, tracePage() will run from controller
          } else if (toParams.earnId && !toParams.marketingPromotionId) {
            // this is a direct link to a earn item scenario, tracePage() will run from controller
          } else {
            rfrAjax.tracePage();
          }
        }
      });
      $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
        rfrAjax.stateResolveError(error);
      });

    }]);

'use strict';
/*jshint -W117 */
function rfrRoutesProvider() {
  var rfrRoutes = [
     {
      name: 'noaccount',
       url: '/noaccount',
     templateUrl: 'rfr/views/noaccount.html',
     controller: 'noaccountCtrl',
     resolve : noaccountCtrl.resolve
      },
     {
      name: 'rewards',
       url: '/rewards',
     templateUrl: 'rfr/views/rewards.html',
      controller: 'rewardsMain',
     resolve: rewardsMain.resolve
    },
    {
      name: 'rewards.enroll',
      url: '/enroll',
      sticky: false,
     views: {
        'enroll': {
         templateUrl: 'rfr/views/rewards.enroll.html',
          controller: 'enrollCtrl'
       }
      }
    },
    {
      name: 'rewards.membership',
      url: '/membership',
      sticky: false,
      views: {
        'membership': {
          templateUrl: 'rfr/views/rewards.membership.html',
          controller: 'membershipCtrl'
       }
      },
     resolve: membershipCtrl.resolve
    },
    {
      name: 'rewards.wishlist',
      url: '/wishlist',
      sticky: false,
      views: {
        'wishlist': {
          templateUrl: 'rfr/views/rewards.wishlist.html',
         controller: 'wishlistCtrl'
        }
      },
     resolve: wishlistCtrl.resolve
    },
   {
     name: 'rewards.transactions',
      url: '/transactions/:transactionId',
     sticky: false,
      views: {
       'transactions': {
          templateUrl: 'rfr/views/rewards.transactions.html',
         controller: 'transactionDetailsCtrl'
        }
     },
      resolve: transactionDetailsCtrl.resolve,
      params: {
       transactionId: {//This sets default value so it matches /transactions without trailing slash
          value: null,
          squash: true
       }
      }
    },
   {
      name: 'rewards.redeem',
      url: '/redeem/:rewardId/:stepId',
     sticky: false,
      views: {
       'redeem': {
         templateUrl: 'rfr/views/rewards.redeem.html',
         controller: 'redeemCtrl'
        }
      },
      resolve: redeemCtrl.resolve,
     params: {
        rewardId: {
         value: null,
        squash: true
        },
        stepId: {
        value: null,
         squash: true
       },
       rewardProductId: null,
       redemptionDetails: null
     }
    },
   {
      name: 'rewards.browse',
      url: '/browse/:catId',
     sticky:true,
      views: {
       'browse': {
         templateUrl: 'rfr/views/rewards.browse.html',
          controller: 'browseCtrl'
       }
      },
      resolve: browseCtrl.resolve,
     params: {
        catId: {
          value: null,
          squash: true
        }
      }
    },
    {
     name: 'rewards.earn',
      url: '/earn/:earnId/:stepId',
      sticky:true,
     views: {
        'earn': {
         templateUrl: 'rfr/views/rewards.earn.html',
         controller: earnCtrl
        }
      },
      params: {
       earnId: {
         value: null,
          squash: true
        },
       stepId: {
          value: null,
          squash: true
        },
       marketingPromotionId: null
      },
     resolve: earnCtrl.resolve
    },
   {
     name: 'rewards.howitworks',
      url: '/howitworks',
      sticky: false,
      views: {
        'howitworks': {
         templateUrl: 'rfr/views/rewards.howitworks.html',
          controller: 'howitworksCtrl'
        }
     },
      resolve: howitworksCtrl.resolve
    }
  ];

  /* jshint validthis: true */
  this.$get = function () {
    return rfrRoutes;
  };
}

angular.module('rfrApp').provider('rfrRoutes', rfrRoutesProvider);

(function () {
  'use strict';

  angular.module('totesApp').factory('janrainOidc', janrainOidc);

  janrainOidc.$inject = ['localStorage', '$http', 'settings', '$browser'];

  function janrainOidc(localStorage, $http, settings, $browser) {

    var config = {};

    var oidcObj = {
      signIn: signIn
    };

    function signIn() {
      $http.get("/web/smb/cms/selfserve/authorizeConfigData.json").then(
        function (response) {
          if (response.data) {
            var envName = settings.prodEnvName;
            if (settings.isDevMBH) {
              envName = settings.devEnvName;
            } else if (settings.isQaMBH) {
              envName = settings.qaEnvName;
            }
            var configData = response.data[envName];
            var UUIDState = uuidv4();
            var UUIDNonce = uuidv4();
            var lang = $browser.cookies().language;
            config.basePath = configData.basePath;
            localStorage.setLocalStorageValue('consentPath', configData.consentBasePath);
            config.clientId = configData.clientId;
            localStorage.setLocalStorageValue('easClientId', configData.clientId);
            config.responseType = 'code';
            config.scope = "openid offline_access";
            config.redirectUri = configData.redirectUri;
            config.state = UUIDState;
            config.nonce = UUIDNonce;
            localStorage.setLocalStorageValue('state', UUIDState);
            localStorage.setLocalStorageValue('nonce', UUIDNonce);
            var url = config.basePath +
              "?response_type=" +
              encodeURIComponent(config.responseType) +
              "&client_id=" +
              encodeURIComponent(config.clientId) +
              "&state=" +
              encodeURIComponent(config.state) +
              "&redirect_uri=" +
              encodeURIComponent(config.redirectUri) +
              "&scope=" +
              encodeURIComponent(config.scope) +
              "&nonce=" +
              encodeURIComponent(config.nonce) +
              "&ui_locales=" +
               encodeURIComponent(lang);
            window.location.replace(url);
          }
        },
        function (error) {});
    }

    function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    return oidcObj;
  }
})();

'use strict';

angular.module('totesApp').config(['$stateProvider', '$urlRouterProvider', '$httpProvider', 'settings','$provide',
  function ($stateProvider, $urlRouterProvider, $httpProvider, settings, $provide) {

    // Redirect all unmatched URLs to decommission page
    $urlRouterProvider.otherwise(function($injector, $location) {
      window.location.href = 'https://mybusinesshub.rogers.com/login';  // Replace with your decommission URL
    });

    // UCCPHASE2 temporary redirection
    $urlRouterProvider.when('/registration', '/sso/registration');
    $urlRouterProvider.when('/forgotPassword', '/sso/forgotPassword');
    $urlRouterProvider.when('/forgotpassword', '/sso/forgotPassword');

    var signInUrls = ['', '/', '/home'];
    $.each(signInUrls, function (k, v) {
      $urlRouterProvider.when(v, 'signin');
    });

    $httpProvider.defaults.withCredentials = true;
    $httpProvider.defaults.timeout = 30000;

    var allStates = [
      // Public pages
      {
        name: 'signin',
        url: '/signin',
        controller: 'MyrSigninController',
        templateUrl: 'scripts/modules/signin/signin.html',
        resolve: {
//          globalloaderHandler: function (globalloaderService) {
//            globalloaderService.show();
//          },
          deepLinkingHandler: function (deeplink) {
            return deeplink.signInCheck('/signin');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          },
          //signinPermission: function (permissionResolver) {
          //  return permissionResolver.getNoOfInvalidPasswordAttempts();
          //},
          resolveResource: function (resource) {
            return resource.resolveResource();
          },
          setCookieForForgotPasswordRedirect: ['$stateParams', '$location', 'myrForgetPasswordService', function ($stateParams, $location, forgetPasswordService) {
            if ($location.path() === '/tpsc') {
              forgetPasswordService.setCookie($stateParams);
              $location.path('/tempPassword');
            }
          }]
        },
        onEnter: ['appInterface', 'localStorage', 'myrAccountOverviewService', 'globalloaderService',
          function (appInterface, localStorage, accountOverviewService, globalloaderService) {
            appInterface.stateEnter('/signin');
            var storageArr = ['pInd','ttlDate','ListBasedTargets','visitCount','cta-clicked','disqualify', 'state', 'nonce', 'deeplinkStateName', 'consentPath', 'midmarkettemp'];
            localStorage.clearAllLocalStorageValuesExcept(storageArr);
           /* var prodInd = localStorage.getLocalStorageValue('pInd');
            var ttlDate = localStorage.getLocalStorageValue('ttlDate');
            var listBasedTargets = localStorage.getLocalStorageValue('ListBasedTargets');
            localStorage.clearAllLocalStorageValues();
            localStorage.setLocalStorageValue('pInd', prodInd);
            localStorage.setLocalStorageValue('ttlDate', ttlDate);
            localStorage.setLocalStorageValue('ListBasedTargets', listBasedTargets); */
            accountOverviewService.purgeAccountList();
            globalloaderService.hide();
          }
        ],
        onExit: ['appInterface', '$location', function (appInterface, $location) {
          $location.search({});
          appInterface.stateExit('/signin');
        }]
      },
      {
        name: 'frontline',
        url: '/frontline',
        controller: 'MyrSigninController',
        templateUrl: 'scripts/modules/signin/frontlineSignin.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            return deeplink.signInCheck('/frontline');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          },
          resolveResource: function (resource) {
            return resource.resolveResource();
          },
          setCookieForForgotPasswordRedirect: ['$stateParams', '$location', 'myrForgetPasswordService', function ($stateParams, $location, forgetPasswordService) {
            if ($location.path() === '/tpsc') {
              forgetPasswordService.setCookie($stateParams);
              $location.path('/tempPassword');
            }
          }]
        },
        onEnter: ['appInterface', 'localStorage', 'myrAccountOverviewService', 'globalloaderService', '$rootScope','$window',
          function (appInterface, localStorage, accountOverviewService, globalloaderService, $rootScope, $window) {
            $window.open($window.location.origin + '/web/smb/api/business/v1/getSAMLRequest','_self');
            $rootScope.$emit('frontLineUser');
            appInterface.stateEnter('/frontline');
            var storageArr = ['pInd','ttlDate','ListBasedTargets','visitCount','cta-clicked','disqualify', 'consentPath', 'midmarkettemp'];
            localStorage.clearAllLocalStorageValuesExcept(storageArr);
         /*   var prodInd = localStorage.getLocalStorageValue('pInd');
            var ttlDate = localStorage.getLocalStorageValue('ttlDate');
            var listBasedTargets = localStorage.getLocalStorageValue('ListBasedTargets');
            localStorage.clearAllLocalStorageValues();
            localStorage.setLocalStorageValue('pInd', prodInd);
            localStorage.setLocalStorageValue('ttlDate', ttlDate);
            localStorage.setLocalStorageValue('ListBasedTargets', listBasedTargets); */
            accountOverviewService.purgeAccountList();
            globalloaderService.hide();
          }
        ],
        onExit: ['appInterface', '$rootScope', function (appInterface, $rootScope) {
          $rootScope.$emit('exitFrontLine');
          appInterface.stateExit('/frontline');
        }]
      },
      {
        name: 'gotodatamanager',
        url: '/gotodatamanager',
        controller: 'goToMyBusinessHubController',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/gotodatamanager');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        }
      },
      {
        name: 'signoff',
        url: '/signoff',
        controller: 'MyrSigninController',
        templateUrl: 'scripts/modules/signin/signin.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/signoff');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/signoff');
        }
      },
      //{
      //  name: 'tpsc',
      //  url: '/tpsc?SMTOKEN&USERNAME&SMAUTHREASON&SMAGENTNAME&TARGET',
      //  resolve: {
      //    removeSMTRYNO: function ($cookieStore, $timeout, ajax) {
      //      $cookieStore.remove('SMTRYNO');
      //      ajax.notifyServerDiscardSMCookies();
      //    },
      //    setCookieForForgotPasswordRedirect: ['$stateParams', '$location', 'myrForgetPasswordService', function ($stateParams, $location, forgetPasswordService) {
      //      forgetPasswordService.setCookie($stateParams);
      //      $location.path('/tempPassword');
      //    }]
      //  },
      //  onEnter: function (appInterface, globalloaderService) {
      //    appInterface.stateEnter('/tpsc');
      //    globalloaderService.hide();
      //  },
      //  onExit: function (appInterface) {
      //    appInterface.stateExit('/tpsc');
      //  }
      //},
      {
        name: 'forgotUserName',
        url: '/forgotusername',
        controller: 'MyrForgotUserNameController',
        templateUrl: 'scripts/modules/forgotUserName/forgotUserName.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/forgotusername');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/forgotusername');
        }
      },
      {
        name: 'forgotPassword',
        url: '/forgotpassword',
        controller: 'MyrForgotPasswordController',
        templateUrl: 'scripts/modules/forgotPassword/forgotPassword.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/forgotpassword');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/forgotpassword');
        }
      },
      {
        name: 'tempPassword',
        url: '/tempPassword',
        controller: 'MyrTempPasswordController',
        templateUrl: 'scripts/modules/forgotPassword/tempPassword/tempPassword.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/tempPassword');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/tempPassword');
        }
      },
      {
        name: 'migrateUser',
        url: '/migrateuser',
        controller: 'MyrMigrateUserController',
        templateUrl: 'scripts/modules/migrateUser/migrateUser.html',
        resolve: {
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/migrateuser');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/migrateuser');
        }
      },
        {
              name: 'securityQuestionAnswer',
              url: '/securityQuestionAnswer',
              controller: 'MyrSecurityQuestionAnswerController',
              templateUrl: 'scripts/modules/registration/securityQuestionAnswer.html',
              resolve: {},
              onEnter: function (appInterface, globalloaderService) {
                appInterface.stateEnter('/securityQuestionAnswer');
                globalloaderService.hide();
              },
              onExit: function (appInterface) {
                appInterface.stateExit('/securityQuestionAnswer');
              }
            },
      {
        name: 'registration',
        url: '/registration',
        controller: 'MyrRegistrationController',
        templateUrl: 'scripts/modules/registration/registration.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/registration');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/registration');
        }
      },
      {
        name: 'completeProfile',
        url: '/completeProfile',
        controller: 'MyrCompleteProfileController',
        templateUrl: 'scripts/modules/completeProfile/completeProfile.html',
        resolve: {
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/completeProfile');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/completeProfile');
        }
      },
      {
        name: 'linkaccount',
        url: '/linkaccount',
        controller: 'BssLinkAccountController',
        templateUrl: 'scripts/modules/bssLinkAccount/linkAccount.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/linkaccount');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/linkaccount');
        }
      },
      {
        name: 'bsslinkaccount',
        url: '/bsslinkaccount',
        controller: 'BssLinkAccountController',
        templateUrl: 'scripts/modules/bssLinkAccount/linkAccount.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/bsslinkaccount');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/bsslinkaccount');
        }
      },
      {
        name: 'bssdelinkaccount',
        url: '/bssdelinkaccount',
        controller: 'BssDelinkAccountController',
        templateUrl: 'scripts/modules/bssDelinkAccount/deLinkAccount.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/bssdelinkaccount');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/bssdelinkaccount');
        }
      },
      {
        name: 'easSuccess',
        url: '/easSuccess',
        controller: 'MyrEasSuccessController',
        templateUrl: 'scripts/modules/eas/easSuccess.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/easSuccess');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/easSuccess');
        }
      },
      {
        name: 'easError',
        url: '/easError',
        controller: 'MyrEasErrorController',
        templateUrl: 'scripts/modules/eas/easError.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/easError');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/easError');
        }
      },
      {
        name: 'underMaintenance',
        url: '/underMaintenance',
        controller: 'MyrUnderMaintenanceController',
        templateUrl: 'scripts/modules/underMaintenance/underMaintenance.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/underMaintenance');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/underMaintenance');
        }
      },
      {
        name: 'guestOverview',
        url: '/guestoverview',
        controller: 'MyrGuestOverviewController',
        templateUrl: 'scripts/modules/guestOverview/guestOverview.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/guestoverview');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/guestoverview');
        }
      },
      {
        name: 'oneViewDashboard',
        url: '/oneViewDashboard',
        controller: 'MyrAccountOverviewController',
        controllerAs: 'ao',
        bindToController: true,
        templateUrl: 'views/oneView.html',
        data: {
          _preConditions: {
            accountNumber: 0
          }
        },
        resolve: {
          globalloaderHandler: function (globalloaderService) {
            globalloaderService.show();
          },
          deepLinkingHandler: function (deeplink) {
            return deeplink.redirectCheck(this.url.sourcePath);
          },
          resolveResource: function (resource) {
            return resource.resolveResource();
          },
          permissionData : function(permissionResolver) {
              return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter:['localStorage', 'appInterface', 'globalloaderService','myrAccountOverviewService',
          function (localStorage, appInterface, globalloaderService, accountOverviewService) {
            this.data._preConditions.accountNumber = localStorage.getLocalStorageValue('accountNumber');
            appInterface.stateEnter('/oneViewDashboard');
            globalloaderService.hide();
          }
        ],
        onExit: function (appInterface) {
          appInterface.stateExit('/oneViewDashboard');
        }
      },
      // Pages that require login
      {
        name: 'accountOverview',
        url: '/accountOverview?directLanding&ban&ctn',
        controller: 'MyrAccountOverviewController',
        controllerAs: 'ao',
        bindToController: true,
        templateUrl: 'scripts/modules/accountOverview/accountOverview.html',
        data: {
          _preConditions: {
            accountNumber: 0
          }
        },
        resolve: {
          globalloaderHandler: function (globalloaderService) {
            globalloaderService.show();
          },
          deepLinkingHandler: function (deeplink, $stateParams) {
            deeplink.storeDirectLandingData($stateParams);
            deeplink.settingWcocJwtTokenValue();
          	return deeplink.redirectCheck(this.url.sourcePath);
          },
          resolveResource: function (resource) {
            return resource.resolveResource();
          },
          permissionData : function(permissionResolver) {
              return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter:['localStorage', 'appInterface', 'globalloaderService',
          function (localStorage, appInterface, globalloaderService) {
            this.data._preConditions.accountNumber = localStorage.getLocalStorageValue('accountNumber');
            appInterface.stateEnter('/accountOverview');
            globalloaderService.hide();
          }
        ],
        onExit: function (appInterface) {
          appInterface.stateExit('/accountOverview');
        }
      },
      {
        name: 'shmdashboard',
        url: '/shmdashboard',
        controller: 'MyrShmDashboardController',
        templateUrl: 'scripts/modules/smartHomeMonitoring/shmDashboard.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/shmdashboard');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/shmdashboard');
        }
      },
      {
        name: 'tvdashboard',
        url: '/tvdashboard',
        controller: 'MyrTvDashboardController',
        templateUrl: 'scripts/modules/tvDashboard/tvdashboard.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/tvdashboard');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/tvdashboard');
        }
      },
      {
        name: 'igniteInternet',
        url: '/igniteinternet',
        controller: 'MyrIgniteInternetController',
        bindToController: true,
        templateUrl: 'scripts/modules/igniteInternet/igniteInternet.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal("/igniteinternet");
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/igniteinternet');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/igniteinternet');
        }
      },
      {
        name: 'ignitetv',
        url: '/ignitetv',
        controller: 'MyrIgniteTVController',
        bindToController: true,
        templateUrl: 'scripts/modules/igniteTv/igniteTv.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/ignitetv');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/ignitetv');
        }
      },
      {
        name: 'businessphonedashboard',
        url: '/businessphonedashboard',
        controller: 'BusinessPhoneDashboardController',
        templateUrl: 'scripts/modules/businessPhoneDashboard/businessPhoneDashboard.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/businessphonedashboard');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/businessphonedashboard');
        }
      },
      {
        name: 'internetdash',
        url: '/internetdash',
        controller: 'MyrInternetDashboardController',
        templateUrl: 'scripts/modules/internetDashboard/internetDashboard.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/internetdash');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/internetdash');
        }
      },
      {
        name: 'internetUsage',
        url: '/internetUsage',
        templateUrl: 'scripts/modules/uteInternetUsage/uteInternetUsage.html',
        params: {usageType : null},
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/internetUsage');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/internetUsage');
        }
      },
      {
        name: 'internetUsage.daily',
        url: '/daily',
        active: 'daily',
        templateUrl: 'views/uteInternetUsage/html/uteInternetUsageDaily.html'
      },
      {
        name: 'internetUsage.monthly',
        url: '/monthly',
        active: 'monthly',
        templateUrl: 'views/uteInternetUsage/html/uteInternetUsageMonthly.html'
      },
      {
        name: 'internetUsage.notification',
        url: '/notification',
        active: 'notification',
        templateUrl: 'views/uteInternetUsage/html/uteInternetUsageNotification.html'
      },
      {
        name: 'colony',
        url: '/colony',
        controller: 'InternetColonyPortal',
        templateUrl: 'scripts/modules/internetDashboard/internetColonyPortal.html'
      },
      {
        name: 'midmarket',
        url: '/midmarket',
        controller: 'MyrMidMarketPortal',
        templateUrl: 'scripts/modules/midmarket/midMarketPortal.html'
      },
      {
        name: 'viewGroups',
        url: '/viewGroups',
        controller: 'viewGroupsAndReportingController',
        templateUrl: 'scripts/modules/viewGroupsAndReporting/viewGroups.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/viewGroups');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/viewGroups');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/viewGroups');
        }
      },
      {
        name: 'viewReporting',
        url: '/viewReporting',
        controller: 'viewGroupsAndReportingController',
        templateUrl: 'scripts/modules/viewGroupsAndReporting/viewReporting.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/viewReporting');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/viewReporting');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/viewReporting');
        }
      },
      {
        name: 'wireless',
        url: '/wireless?directLanding&ban&ctn',
        controller: 'MyrWirelessDashboardController',
        templateUrl: 'scripts/modules/wirelessDashboard/wirelessDashboard.html',
        data: {
          _preConditions: {
            accountNumber: 0,
            phoneNumber: 0
          }
        },
        resolve: {
          deepLinkingHandler: function (deeplink, $stateParams) {
            deeplink.storeDirectLandingData($stateParams);
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (localStorage, appInterface, globalloaderService) {
          this.data._preConditions.phoneNumber = localStorage.getLocalStorageValue('phoneNumber');
          this.data._preConditions.accountNumber = localStorage.getLocalStorageValue('accountNumber');
          appInterface.stateEnter('/wireless');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/wireless');
        }
      },
      {
        name: 'wirelessPrepaid',
        url: '/wirelessPrepaid',
        controller: 'MyrWirelessPrepaidController',
        templateUrl: 'scripts/modules/wirelessPrepaid/wirelessPrepaid.html',
        data: {
          _preConditions: {
            accountNumber: 0,
            phoneNumber: 0
          }
        },
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (localStorage, appInterface, globalloaderService) {
          this.data._preConditions.phoneNumber = localStorage.getLocalStorageValue('phoneNumber');
          this.data._preConditions.accountNumber = localStorage.getLocalStorageValue('accountNumber');
          appInterface.stateEnter('/wirelessPrepaid');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/wirelessPrepaid');
        }
      },
      {
        name: 'pdWhiteList',
        url: '/white-list',
        controller: 'PdWhiteListCtrl',
        templateUrl: 'scripts/modules/pdWhiteList/pdWhiteList.html',
        controllerAs: 'vm'
      },
      {
        name: 'sohoIntercept',
        url: '/soho-migration',
        controller: 'sohoMigrationCtrl',
        templateUrl: 'scripts/modules/sohoMigration/sohoMigration.html',
        controllerAs: 'vm',
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/soho-migration');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/soho-migration');
        }
      },
      {
        name: 'paynow',
        url: '/paynow',
        controller: 'MyrPayNowController',
        templateUrl: 'scripts/modules/payNow/payNow.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/paynow');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/paynow');
        }
      },
      {
        name: 'paynowInterac',
        url: '/paynow/:submodule',
        controller: 'MyrPayNowController',
        templateUrl: 'scripts/modules/payNow/payNow.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/paynow');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/paynow');
        }
      },
      {
        name: 'payHistory',
        url: '/payHistory',
        controller: 'PayHistoryController',
        templateUrl: 'scripts/modules/payHistory/payHistory.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/payHistory');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/payHistory');
        }
      },
      {
        name: 'makeAPayment',
        url: '/makeAPayment?directLanding&ban&ctn',
        controller: 'MakePaymentController',
        templateUrl: 'scripts/modules/makePayment/payNow.html',
        params: {accountNo : null, LOB : null, contactId : null},
        resolve: {
          deepLinkingHandler: function (deeplink, $stateParams) {
            deeplink.storeDirectLandingData($stateParams);
            deeplink.internal('/makeAPayment');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/makeAPayment');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/makeAPayment');
        }
      },
      {
        name: 'changePayMethod',
        url: '/changePayMethod?directLanding&ban&ctn',
        controller: 'ChangePayMethodController',
        templateUrl: 'scripts/modules/changePayMethod/changePayMethod.html',
        resolve: {
          deepLinkingHandler: function (deeplink, $stateParams) {
            deeplink.storeDirectLandingData($stateParams);
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/changePayMethod');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/changePayMethod');
        }
      },
      {
        name: "accountInitialization",
        url: "/accountInitialization",
        controller:'AccountInitController'
      },
      {
        name: 'changeMethod',
        url: '/changemethod',
        controller: 'MyrChangePaymentMethodController',
        templateUrl: 'scripts/modules/changePaymentMethod/changePaymentMethod.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/changemethod');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/changemethod');
        }
      },
      {
        name: 'eSimcard',
        url: '/eSimcard',
        controller: 'myeSimcardController',
        templateUrl: 'scripts/modules/eSimCardChange/eSimCard.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/eSimcard');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/eSimcard');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/eSimcard');
        }
      },
      {
        name: 'eSimChange',
        url: '/eSimChange',
        controller: 'myeSimAndPhysicalSimChangeController',
        templateUrl: 'scripts/modules/eSIMCard_PhysicalSim/eSIMChange.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/eSimChange');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/eSimChange');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/eSimChange');
        }
      },
      {
        name: 'eSimEmail',
        url: '/eSimEmail',
        controller: 'myeSimemailmodalController',
        templateUrl: 'scripts/modules/eSimEmailModal/eSimemail.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/eSimEmail');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/eSimEmail');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/eSimcard');
        }
      },
      {
        name: 'eSimOtp',
        url: '/eSimOtp',
        controller: 'myeSimotpmodalController',
        templateUrl: 'scripts/modules/eSimOtpmodal/eSimOtp.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/eSimOtp');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/eSimOtp');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/eSimEmail');
        }
      },
      {
        name: 'eSimSuccess',
        url: '/eSimSuccess',
        controller: 'myeSimsuccessmodalController',
        templateUrl: 'scripts/modules/eSimSuccessmodal/eSimSuccess.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/eSimSuccess');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/eSimSuccess');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/wireless');
        }
      },
      {
        name: 'eSimtransfer',
        url: '/eSimtransfer',
        controller: 'myeSimtransaferController',
        templateUrl: 'scripts/modules/eSimtransfermodal/eSimtransfer.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/eSimtransfer');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/eSimtransfer');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/wireless');
        }
      },
      {
        name: 'eSimtransfersuccess',
        url: '/eSimtransfersuccess',
        controller: 'myeSimtransfersuccessController',
        templateUrl: 'scripts/modules/eSimtransfersuccess/eSimtransfersucces.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/eSimtransfersuccess');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/eSimtransfersuccess');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/wireless');
        }
      },
      {
        name: 'eSimtransfererror',
        url: '/eSimtransfererror',
        controller: 'myeSimtransfererrorController',
        templateUrl: 'scripts/modules/eSimtransfererror/eSimtransfererror.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal('/eSimtransfererror');
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/eSimtransfererror');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/wireless');
        }
      },
      {
        name: 'paymentHistory',
        url: '/paymenthistory',
        controller: 'MyrPaymentHistoryController',
        templateUrl: 'scripts/modules/paymentHistory/paymentHistory.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/paymenthistory');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/paymenthistory');
        }
      },
      // Not found and others
      {
        name: 'error404',
        url: '/error404',
        templateUrl: 'views/404.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/error404');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/error404');
        }
      },
      {
        name: 'oops',
        url: '/oops',
        templateUrl: 'views/oops.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/oops');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/oops');
        }
      },
      {
        name: 'suspended',
        url: '/suspended',
        templateUrl: 'views/suspended.html',
        resolve: {},
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/suspended');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/suspended');
        }
      },
      {
        name: 'oneViewInterface',
        url: '/oneViewInterface',
        controller: 'oneViewInterfaceCtrl',
        templateUrl: 'views/oneViewInterface.html',
        onEnter: function (appInterface) {
          appInterface.stateEnter('/oneViewInterface');
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/oneViewInterface');
        }
      },
      /*
       {
       name: 'home',
       url: '/home',
       templateUrl: 'views/home.html'
       }
       //*/
      {
        name: 'reservedevice',
        url: '/reservedevice',
        controller: 'MyrReserveDeviceCtrl',
        templateUrl: 'scripts/modules/reserveDevice/reservedevice.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/reservedevice');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/reservedevice');
        }
      }
    ];

    if (settings.enablePricePlanChanges) {
      allStates.push({
        name: 'ppc-singleline',
        url: '/ppc-singleline',
        onEnter: function ($window, $rootScope) {
          $rootScope.internalRedirect = true;
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.location.href = origin + '/web/smb/wireless-plan-change/#/choose-plan';
        }
      });
      allStates.push({
        name: 'ppc-resume-order',
        url: '/ppc-resume-order',
        onEnter: function ($window, $rootScope) {
          $rootScope.internalRedirect = true;
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.location.href = origin + '/web/smb/wireless-plan-change/#/resume';
        }
      });
      allStates.push({
        name: 'ppc-multiline-entry-2',
        url: '/ppc-multiline-entry-2',
        onEnter: function ($window, $rootScope) {
          $rootScope.internalRedirect = true;
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.location.href = origin + '/web/smb/wireless-plan-change/#/change-share-plan';
        }
      });
      allStates.push({
        name: 'ppc-multiline-step-1',
        url: '/ppc-multiline-step-1',
        onEnter: function ($window, $rootScope) {
          $rootScope.internalRedirect = true;
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.location.href = origin + '/web/smb/wireless-plan-change/#/choose-share-plan';
        }
      });
      allStates.push({
        name: 'ppc-multiline-step-2',
        url: '/ppc-multiline-step-2',
        onEnter: function ($window, $rootScope) {
          $rootScope.internalRedirect = true;
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.location.href = origin + '/web/smb/wireless-plan-change/#/additional-line-options?callingOptionsRoute=wireless';
        }
      });
      allStates.push({
        name: 'change-price-plan',
        url: '/change-price-plan?directLanding&ban&ctn',
        resolve: {
          deepLinkingHandler: function (deeplink, $stateParams) {
            deeplink.storeDirectLandingData($stateParams);
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function ($state) {
            $state.go("accountInitialization");
        }
      });
      allStates.push({
        name: 'wireless-plan-change',
        url: '/wireless-plan-change',
        controller: 'singleLinePpcCtrl as singleLinePPC',
        templateUrl: 'views/single-line-ppc.html',
        resolve: {
          deepLinkingHandler: function (deeplink) {
            deeplink.internal();
          },
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/wireless-plan-change');
          globalloaderService.hide();
        },
        onExit: function (appInterface) {
          appInterface.stateExit('/wireless-plan-change');
        }
      });

      allStates.push({
        name: 'review-order',
        url: '/review-order',
        controller: 'reviewOrderCtrl as reviewOrder',
        templateUrl: 'views/review-order.html',
        resolve: {
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        }
      });

      allStates.push({
        name: 'confirm-order',
        url: '/confirm-order',
        controller: 'confirmOrderCtrl as confirmOrder',
        templateUrl: 'views/confirm-order.html',
        resolve: {
          permissionData: function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }
        }
      });

      if (settings.enableSelfServe) {
        // a small tear falls from the side of the eye of the developer who programs by convention not configuration
        allStates.push({
          name: 'self-serve',
          url: '/profile',
          controller: 'selfServeCtrl as selfServe',
          templateUrl: 'views/selfServe/selfServe.html',
          resolve: {
            permissionData: function (permissionResolver) {
              return permissionResolver.getPermission(this.url.sourcePath);
            }
          }
        });
      }
    }



    $.each(allStates, function (k, v) {
      $stateProvider.state(v);
    });

$provide.decorator('ute.common.user.service',['$delegate','ute.blocks.persistent.storage.service','$http', uteUserDecorator]);

          function uteUserDecorator($delegate,storageService, $http) {
            $delegate.user_1 = ute.common.user;
            $delegate.storageService = storageService;
            $delegate.failSafeKey = '7RvnncDPUc535aBZftoarnFdYXM1zlfY';

                                       $delegate.getUserType = function () {
                                                      return $delegate.user_1.UserType[_.get($delegate.user, 'userType', $delegate.user_1.UserType.consumer)];
                                                   };


                                    $delegate._getEncryptionKey = function () {
                                        return $delegate.$http.get('/web/RogersServices.portal/smb/api/v1/myKey')
                                            .then($delegate.processEncryptionKeyResponse)
                                            .catch(_.curry($delegate.fail)('processEncryptionKeyResponse failed.'));
                                    };

                                    $delegate.getUserName = function () {
                                        return _.get($delegate.user, 'userName');
                                    };
//
                                    $delegate.getCacheName = function () {
                                        return 'EncryptionKeyCacheName';
                                    };
//
                                    $delegate.processEncryptionKeyResponse = function (response) {
                                        //console.log('ute.user.service.UserService.processEncryptionKeyResponse', _.get<string>(response, 'data.content.key', this.failSafeKey));
                                        return _.get(response, 'data.content.key', $delegate.failSafeKey);
                                    };

                                    //private fail: (reason: string, error: any) => ng.IPromise<any> = (reason: string, error: any) => {
                                    $delegate.fail = function (reason, error) {
                                        //var msg = _.get(error, 'data.description', error);
                                        //this.exceptionHandler.catcher(msg)(reason, 'ute.common.user.service');
                                        //return this.$q.reject(msg);
                                        //console.log('ute.user.service.UserService.fail', this.failSafeKey + this.getUserName());
                                        return $delegate.failSafeKey + $delegate.getUserName();
                                    };
                                    $delegate.user = $delegate.storageService.getFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER)
                                    $delegate.getEncryptionKey = _.memoize($delegate._getEncryptionKey, $delegate.getCacheName);
//                                    $delegate.registerSigninHandler($delegate.cleanCache, $delegate);



            return $delegate;
          }
  }]);

angular.module('totesApp').run(['$rootScope',function($rootScope) {

    // Intercept state changes - redirect specific states to external URLs and others to decommission page
    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
      
      // Map specific states to external URLs
      var externalRedirects = {
        'accountOverview': 'https://mybusinesshub.rogers.com/dashboard',
        'viewInvoice': 'https://mybusinesshub.rogers.com/dashboard/viewInvoice',
        'viewGroups': 'https://mybusinesshub.rogers.com/dashboard/groups',
        'viewReporting': 'https://mybusinesshub.rogers.com/dashboard/reports',
        'wireless': 'https://mybusinesshub.rogers.com/dashboard',
        'tvdashboard': 'https://mybusinesshub.rogers.com/dashboard',
        'internetdash': 'https://mybusinesshub.rogers.com/dashboard'
      };
      
      // Check if this state has a specific redirect rule
      if (externalRedirects[toState.name]) {
        event.preventDefault();
        window.location.href = externalRedirects[toState.name];
        return;
      }
      
      // Default: redirect all states except 'frontline' to decommission URL
      if (toState.name !== 'frontline') {
        event.preventDefault();
        window.location.href = 'https://mybusinesshub.rogers.com/login';  // Default decommission URL
      }
    });

$rootScope.$on('$stateChangeSuccess',function(event, toState, toParams, fromState, fromParams) {
//Run the Qualtrics code
if(typeof(window.QSI) !=='undefined') {
setTimeout(function() {
window.QSI.API.unload();
window.QSI.API.load();
window.QSI.API.run();
},500);
}
});

}
]);

'use strict';

var btnStatus = {
  visible: 0,
  hidden: 1,
  disabled: 2,
  names: {
    0: 'Visible',
    1: 'Hidden',
    2: 'Disabled'
  }
};

var subMenuItems = {
  overview: 0,
  billingAndPayment: 1,
  services: 2,
  profile: 3,
  guestoverview: 4,
  names: {
    0: 'Overview',
    1: 'Billing & Payment',
    2: 'Services',
    3: 'Profile'
  }
};

var maintenanceValues = {
  ACCOUNT_OVERVIEW_ON_MAINTENANCE: 0,
  HOME_PHONE_ON_MAINTENANCE: 1,
  INTERNET_ON_MAINTENANCE: 2,
  RSHM_ON_MAINTENANCE: 3,
  SITE_ON_MAINTENANCE: 4,
  TV_ON_MAINTENANCE: 5,
  WIRELESS_ON_MAINTENANCE: 6,
  WIRELESS_PREPAID_ON_MAINTENANCE: 7,
  names: {
    0: 'ACCOUNT_OVERVIEW_ON_MAINTENANCE',
    1: 'HOME_PHONE_ON_MAINTENANCE',
    2: 'INTERNET_ON_MAINTENANCE',
    3: 'RSHM_ON_MAINTENANCE',
    4: 'SITE_ON_MAINTENANCE',
    5: 'TV_ON_MAINTENANCE',
    6: 'WIRELESS_ON_MAINTENANCE',
    7: 'WIRELESS_PREPAID_ON_MAINTENANCE'
  }
};

var permissionValues = {
  CHANGE_FEATURES_ON_WIRELESS_DASHBOARD: 0,
  CHANGE_MY_PLAN_TV: 1,
  CHANGE_PAYMENT_METHOD: 2,
  CHANGE_PLAN_ON_WIRELESS_DASHBOARD: 3,
  REDEEM_LOYALTY_POINTS: 4,
  SHOW_ADD_ONS_TV: 5,
  UPDATE_MY_FAB_CONTACT_ON_WIRELESS_DASHBOARD: 6,
  VIEW_ACCOUNT_BALANCE: 7,
  VIEW_ACCOUNT_DETAILS: 8,
  VIEW_LOYALTY_POINTS: 9,
  names: {
    0: 'CHANGE_FEATURES_ON_WIRELESS_DASHBOARD',
    1: 'CHANGE_MY_PLAN_TV',
    2: 'CHANGE_PAYMENT_METHOD',
    3: 'CHANGE_PLAN_ON_WIRELESS_DASHBOARD',
    4: 'REDEEM_LOYALTY_POINTS',
    5: 'SHOW_ADD_ONS_TV',
    6: 'UPDATE_MY_FAB_CONTACT_ON_WIRELESS_DASHBOARD',
    7: 'VIEW_ACCOUNT_BALANCE',
    8: 'VIEW_ACCOUNT_DETAILS',
    9: 'VIEW_LOYALTY_POINTS'
  }
};

angular
  .module('totesApp')
  .config(['$logProvider', function ($logProvider) {
    // debug logs must be disabled in production
    $logProvider.debugEnabled(false);
  }])
  .constant('jQuery', $)
  .constant('settings', {
    supportedLanguages: {
      en: 'English',
      fr: 'Français'
    },
    defaultLanguage: 'en',
    isLocal: window.location.host.indexOf('localhost:') === 0, //change to false in production
    isDevBB: window.location.host.match('dev') || window.location.host.match('totes') || window.location.host.match('localhost.rogers.com'),
    isQaBB: window.location.host.match('qa'),
    isProdBB: window.location.host.match('www.rogers.com'),
    isDev: window.location.host.indexOf('dev'),
    isQa: window.location.host.indexOf('qa'),
    isProd: window.location.host.indexOf('www.rogers.com'),
    isDevQa: window.location.host.indexOf('dev') > -1 || window.location.host.indexOf('qa') > -1 ? true : false,
    isDevMBH: window.location.host.indexOf('env') > -1 || window.location.host.indexOf('dev') > -1 || window.location.host.indexOf('localhost') > -1 ? true : false,
    isQaMBH: window.location.host.indexOf('qa') > -1 ? true : false,
    isProdMBH: window.location.host.indexOf('www.rogers.com') > -1 ? true : false,
    devEnvName: window.location.host.indexOf('env') > -1 ?
      window.location.hostname.substr(window.location.hostname.indexOf("env"), window.location.hostname.indexOf(".rogers.com") - window.location.hostname.indexOf("env")) : window.location.hostname.substr(window.location.hostname.indexOf("dev"), window.location.hostname.indexOf(".rogers.com") - window.location.hostname.indexOf("dev")),
    qaEnvName: window.location.hostname.substr(window.location.hostname.indexOf("qa"), window.location.hostname.indexOf(".rogers.com") - window.location.hostname.indexOf("qa")),
    prodEnvName: 'prod',
    devMode: true,
    // omitPagesFromGlobalLoader:['/signin'],
    omitPagesFromGlobalLoader: [''],
    useLocalAPI: false,
    reviewLink: {
      en: 'https://www.rogers.com/web/support/supportbillingpayment',
      fr: 'https://www.rogers.com/web/support/supportbillingpayment/setLanguage=fr'
    },
    chatLink: {
      en: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=105',
      fr: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=155'
    },
    chatLinkChangeModem: {
      en: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=105',
      fr: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=155'
    },
    chatLinkChangePlan: {
      en: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=105 ',
      fr: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=155'
    },
    chatLinkModules: {
      payment: {
        en: 'http://www.rogershelp.com/customerserv/credops_landing.php?hm=n&s=203',
        fr: 'http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253'
      }
    },
    sbpInquiry: {
      qa: 'https://beta1.rogersdirect.ca/sbp/Authenticate/AuthenticateMBH?ref_id=',
      prod: 'https://secure2.rogersdirect.ca/SBP/AuthenticateBSSStandard?ref_id='
    },
    redeemLink: {
      en: '/web/totes/#/rewards/redeem',
      fr: '/web/totes/#/rewards/redeem',
      enroll: '/web/totes/#/rewards/enroll'
    },
    redeemLinkQA5: {
      en: 'http://sft5.rogersfirstrewards.rogers.com:8082/en/private/my_rogers/home/www_home_page',
      fr: 'http://sft5.rogersfirstrewards.rogers.com:8082/fr/private/my_rogers/home/www_home_page',
      enroll: 'http://sft5.rogersfirstrewards.rogers.com:8082/{lang}/private/my_rogers/home/www_home_page'
    },
    agentInfo: {
      heartbeatURL: 'shop/cfa/o/logout-keep-alive',
      signoutURL: 'shop/home',
      sspDashboardURL: 'shop/cfa/ssp-ute-interface',
      timeout: 15,
      sspHomeURL: 'shop/cfa/home'
    },
    saveOrderSearch: {
      qa: 'https://api-qa.rogers.com/qa14/mbh/v1/rd/saveOrderSearch',
      prod: 'https://api.rogers.com/mbh/v1/rd/saveOrderSearch'
    },
    britebill: {
      dev: 'https://qa7.invoiceportal.rogers.com/',
      qa: 'https://qa7.invoiceportal.rogers.com/',
      prod: 'https://wtip.rogers.com/'
    },
    invoiceWinUrl: {
      dev: 'https://qa3.bss.rogers.com:7526',
      qa: 'https://qa2.bss.rogers.com:8443',
      prod: 'https://bss.rogers.com'
    },
    salesForceUrl: {
      dev: 'https://uat.config.cs7.force.com/',
      qa: 'https://uat.config.cs7.force.com/',
      prod: 'https://rogersprod.secure.force.com/'
    },
    ESFUrl: {
      dev: 'https://esfidtapi.rogers.com/esfapi/ebu/user/samlAuth',
      qa: 'https://esfqaapi.rogers.com/esfapi/ebu/user/samlAuth',
      prod: 'https://esfidtapi.rogers.com/esfapi/ebu/user/samlAuth'
    },
    ColonyPortalUrl: {
      dev: 'http://rogers-dev.colonynetworks.com',
      qa: 'https://api-alpha.colonynetworks.com',
      prod: 'http://rogers-dev.colonynetworks.com'
    },

    myBusinessHUBUrl: {
      dev: {
        welcome: 'https://dev15.rogers.com/mbh/welcome/',
        dashboard: 'https://dev15.rogers.com/mbh/dashboard/',
        dataManager: 'https://dev15.rogers.com/mbh/datamanager',
        transferOfResponsibility: 'https://itdevstage-r4b.cs142.force.com/s/createcase?source=BSS-S&type=Service&product=Wireless&class=Manage WLS Services&reason=TOR&language=en&hideReason=true&category=Mobile Services&returnURL=https://www.env37.rogers.com/web/smb/bss/',
        billInquiry: 'https://itdevstage-r4b.cs142.force.com/s/createcase?source=BSS-S&type=Service&product=Wireless&class=Bill Inquiry&reason=Adjustment&language=fr&hideReason=true&category=Mobile Services&returnURL=https://www.env37.rogers.com/web/smb/bss/',
        portalInquiry: 'https://itdevstage-r4b.cs142.force.com/s/createcase?source=BSS-S&type=Service&product=Wireless&class=Online Portal&reason=Support&language=fr&hideReason=true&category=Mobile Services&returnURL=https://www.env37.rogers.com/web/smb/bss/',
        sbpInquiry: 'https://beta5.rogersdirect.ca/sbp/Authenticate/AuthenticateMBH?ref_id=',
        orderInquiry: 'https://beta5.rogersdirect.ca/wireless/Midmarket/authenticateBSSStandard',
        contactManagement: 'https://itdevstage-r4b.cs142.force.com/s/addbaucontact?language=en&returnURL=https://www.env37.rogers.com/web/smb/bss/',
        portIn: 'https://itdevstage-r4b.cs142.force.com/s/addbaucontact?language=en&returnURL=https://www.env37.rogers.com/web/smb/bss/'
      },
      qa: {
        welcome: 'https://qa12.rogers.com/mbh/welcome/',
        dashboard: 'https://qa12.rogers.com/mbh/dashboard/',
        dataManager: 'https://qa12.rogers.com/mbh/datamanager',
        transferOfResponsibility: 'https://itqatest-communities.cs142.force.com/s/createcase?source=BSS-S&type=Service&product=Wireless&class=Manage WLS Services&reason=TOR&language=en&hideReason=true&category=Mobile Services&returnURL=https://qa4-bss.rogers.com/web/smb/bss/',
        billInquiry: 'https://itqatest-communities.cs142.force.com/s/createcase?source=BSS-S&type=Service&product=Wireless&class=Bill Inquiry&reason=Adjustment&language=fr&hideReason=true&category=Mobile Services&returnURL=https://qa4-bss.rogers.com/web/smb/bss/',
        portalInquiry: 'https://itqatest-communities.cs142.force.com/s/createcase?source=BSS-S&type=Service&product=Wireless&class=Online Portal&reason=Support&language=fr&hideReason=true&category=Mobile Services&returnURL=https://qa4-bss.rogers.com/web/smb/bss/',
        sbpInquiry: 'https://beta5.rogersdirect.ca/sbp/Authenticate/AuthenticateMBH?ref_id=',
        orderInquiry: 'https://beta5.rogersdirect.ca/wireless/Midmarket/authenticateBSSStandard',
        contactManagement: 'https://itqatest-communities.cs142.force.com/s/addbaucontact?language=en&returnURL=https://qa4-bss.rogers.com/web/smb/bss/',
        portIn: 'https://itqatest-communities.cs142.force.com/s/addbaucontact?language=en&returnURL=https://qa4-bss.rogers.com/web/smb/bss/'
      },
      prod: {
        welcome: 'https://mybusinesshub.rogers.com/welcome/',
        dashboard: 'https://mybusinesshub.rogers.com/dashboard/',
        dataManager: 'https://mybusinesshub.rogers.com/datamanager',
        transferOfResponsibility: 'https://mybizhub.rogers.com/s/createcase?source=BSS-S&type=Service&product=Wireless&class=Manage WLS Services&reason=TOR&language=en&hideReason=true&category=Mobile Services&returnURL=https://rogers.com/bss',
        billInquiry: 'https://mybizhub.rogers.com/s/createcase?source=BSS-S&type=Service&product=Wireless&class=Bill Inquiry&reason=Adjustment&language=fr&hideReason=true&category=Mobile Services&returnURL=https://rogers.com/bss',
        portalInquiry: 'https://mybizhub.rogers.com/s/createcase?source=BSS-S&type=Service&product=Wireless&class=Online Portal&reason=Support&language=fr&hideReason=true&category=Mobile Services&returnURL=https://rogers.com/bss',
        sbpInquiry: 'https://rogersdirect.ca/sbp/Authenticate/AuthenticateMBH?ref_id=',
        orderInquiry: 'https://beta5.rogersdirect.ca/wireless/Midmarket/authenticateBSSStandard',
        contactManagement: 'https://mybizhub.rogers.com/s/addbaucontact?language=en&returnURL=https://rogers.com/bss',
        portIn: 'https://mybizhub.rogers.com/s/addbaucontact?language=en&returnURL=https://rogers.com/bss'
      }
    },

    revolutionExternalLinks: {
      spotify: {
        en: {
          qa: 'https://www.spotify.com/ca-en/download/',
          prod: 'https://www.spotify.com/ca-en/download/'
        },
        fr: {
          qa: 'https://www.spotify.com/ca-fr/download/',
          prod: 'https://www.spotify.com/ca-fr/download/'
        }
      },
      nextissue: {
        en: {
          qa: 'https://staging-secure.nextissue.ca/',
          prod: 'https://www.nextissue.ca/en/'
        },
        fr: {
          qa: 'https://staging-secure.nextissue.ca/',
          prod: 'https://www.nextissue.ca/fr/'
        }
      },
      shomi: {
        en: {
          qa: 'http://shomi-qa1.herokuapp.com/',
          prod: 'https://my.shomi.com/signin'
        },
        fr: {
          qa: 'http://shomi-qa1.herokuapp.com/',
          prod: 'https://my.shomi.com/signin'
        }
      }
    },

    revolutionLink: '/web/totes/plans/#/manage-your-experience',
    revolutionSegmentNumber: 6,
    revolutionPermissionName: 'VIEW_ACCOUNT_BALANCE',
    revolutionAddNhl: false,

    revolutionGetOffersPrefix: window.location.host.indexOf('localhost:') >= 0 ? 'http://10.14.11.52:9000' : '/web/RogersServices.portal/totes/api',
    revolutionGetOffers: '/v1/offer-status', //'http://10.10.94.138:9000/selfserve/v1/offer-status',

    redeemPoints: 400,
    usageLimit: 75,
    msInDay: 1000 * 60 * 60 * 24,
    //The maximum amount user can pay is the due amount + paymentMaximum.
    paymentMaximum: 1000,
    //payment history list: pagesPerSection is the number of pages each pagination section can display. itemsPerPage is the number of records per page.
    paymentHistory: {
      pagesPerSection: 5,
      itemsPerPage: 10
    },
    //creditCardField for semafone
    iframeParameters: 'xxxx xxxx xxxx',
    //semafone details for LEGACY
    //semafone details for DEV
    legacyDevSemafoneParameters: {
      semafoneUrl: 'https://htsdev05.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
      semafoneMode: 'DISABLED',
      gatewayId: 'CYBERSOURCE',
      methodId: 'TOKENISE',
      ppUserId: 'rogers.com',
      ppPassword: 'MIIBmjCCAQOgAwIBAgIEVNkSJTANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwMjA5MjAwMTQxWhcNMjUwMjA2MjAwMTQxWjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCar7YRV/nrR3MFB/GoAvwz4ocpnN0ViO9OWlPl9ZvFAVnMAuPNPcwK+xfIgwG3Zdw8WZ56Flc1GTfUFZNV1Mz4AQYagN+s59LyfTLtMVXwTFJSItnTqJ+S0R9Sm0EzmhIMlDha49+h/469kXzDSVpyKayxSB5uQ2OQcn4IB8YmgwIDAQABMA0GCSqGSIb3DQEBBQUAA4GBABGvmhfC5mhStql26Vmc4+fN2GsrRUu4+E/pqywzHCtvd+Ktsd6t1Eqc1wtY40CLWyOyP0eNk7yVPTWgQaU3ZQU88t69GxQjwwRfEy0VLqB7ez7UrLOYgLxv2SK2IqAYEOMRFYc12YW8yHIUQvWaVp2QjXsJLkzsTrMrq5/XHymM',
      tenantId: 'RCI',
      clientId: '9',
      accountId: '531',
      principle: 'rogersp',
      licenseCode: '2kBsYvAs3d',
      transactionType: 'GetTokenPan',
      responseType: 'web',
      responseURL: 'https://htsdev03.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
    },
    //semafone details for QA
    legacyQaSemafoneParameters: {
      semafoneUrl: 'https://htsqa02.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
      semafoneMode: 'DISABLED',
      gatewayId: 'CYBERSOURCE',
      methodId: 'TOKENISE',
      ppUserId: 'rogers.com',
      ppPassword: 'MIIBmjCCAQOgAwIBAgIEVNkTEjANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwMjA5MjAwNTM4WhcNMjUwMjA2MjAwNTM4WjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzqmdLamUOlCO2kpAZBVTuQN+6Iw6+kNb91EW055udpGNyX04o4xMl1zrLFEVJpuZ3JqyrtuAFKQb8ovEeBNzJWoZL8EhpYXYaCfwL5114lpTbVEi/AvbV0iVSvmADjenEzD1241/KTf8Y9ThhHV9SzJOHdCqdRT8OmUn1BHeCIQIDAQABMA0GCSqGSIb3DQEBBQUAA4GBAHAH048PRyvJA2lmamcN83LfiCr1G92ec8dE9CB0XOIWKsusBcYYPBWfJyTFvRg93nbT6laRMUWPcuFDxjYl1o5b0DMCQPmn01fzM9RSk2h9KdUQj5/ZPMrP+og3950DnsCn4rlAWJ/syWsnVS8j/20Vo+q1oBapJsX0gimwZHgG',
      tenantId: 'RCI',
      clientId: '9',
      accountId: '531',
      principle: 'rogersp',
      licenseCode: '2kBsYvAs3d',
      transactionType: 'GetTokenPan',
      responseType: 'web',
      responseURL: 'https://htsqa02.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
    },
    //semafone details for PET
    legacyPetSemafoneParameters: {
      semafoneUrl: 'https://htspet.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
      semafoneMode: 'DISABLED',
      gatewayId: 'CYBERSOURCE',
      methodId: 'TOKENISE',
      ppUserId: 'rogers.com',
      ppPassword: 'MIIBmjCCAQOgAwIBAgIEVNkTEjANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwMjA5MjAwNTM4WhcNMjUwMjA2MjAwNTM4WjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzqmdLamUOlCO2kpAZBVTuQN+6Iw6+kNb91EW055udpGNyX04o4xMl1zrLFEVJpuZ3JqyrtuAFKQb8ovEeBNzJWoZL8EhpYXYaCfwL5114lpTbVEi/AvbV0iVSvmADjenEzD1241/KTf8Y9ThhHV9SzJOHdCqdRT8OmUn1BHeCIQIDAQABMA0GCSqGSIb3DQEBBQUAA4GBAHAH048PRyvJA2lmamcN83LfiCr1G92ec8dE9CB0XOIWKsusBcYYPBWfJyTFvRg93nbT6laRMUWPcuFDxjYl1o5b0DMCQPmn01fzM9RSk2h9KdUQj5/ZPMrP+og3950DnsCn4rlAWJ/syWsnVS8j/20Vo+q1oBapJsX0gimwZHgG',
      tenantId: 'RCI',
      clientId: '9',
      accountId: '531',
      principle: 'rogersp',
      licenseCode: '2kBsYvAs3d',
      transactionType: 'GetTokenPan',
      responseType: 'web',
      responseURL: 'https://htspet.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
    },
    //semafone details for production
    legacyProdSemafoneParameters: {
      semafoneUrl: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
      semafoneMode: 'DISABLED',
      gatewayId: 'CYBERSOURCE',
      methodId: 'TOKENISE',
      ppUserId: 'rogers.com',
      ppPassword: 'MIIBmjCCAQOgAwIBAgIEVUzQzDANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwNTA4MTUwNTQ4WhcNMjUwNTA1MTUwNTQ4WjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDIiTVxBU6TCkukpWoLS28L1t/mTDPevgoKv+ETN1Wji0GYNIibphhEdz8VD2zJ0zCilENcDCLJMdL2RoQVwqetg7b4UwBfNkfAdiRn5P/HR8fvwlky8ETuofm9J0k13KEN3hDQEmvCNqIIF/nI/8GO+MD0IlP0w1+A7Z5bZZb/ewIDAQABMA0GCSqGSIb3DQEBBQUAA4GBAIIzYCkh8cy8WbwXjSDTVRqiorrgFs99Y+GNncZiIDlug25adp5FBjOVYIZkIAZVaJ1Tv/PfzmqmOQrvaKz2GpCEjhDAfoIc8MwQ43Q3+Iq9/U0z98jwA11OmsvZJHy/VsxQ0aMjDL15J48YclVS7nFPkwZb77Oz1z/nzmgwWZTO',
      tenantId: 'RCI',
      clientId: '9',
      accountId: '531',
      principle: 'rogersp',
      licenseCode: '7QucejpMeP',
      transactionType: 'GetTokenPan',
      responseType: 'web',
      responseURL: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
    },



    //semafone details for DEV
    devSemafoneParameters: {
      semafoneUrl: 'https://htsdev03.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
      semafoneMode: 'DISABLED',
      gatewayId: 'MONERIS',
      methodId: 'TOKENISE',
      ppUserId: 'vaas000153',
      ppPassword: 'o116tdUOVaqfmtsbSPUw',
      tenantId: 'RCI',
      clientId: '9',
      accountId: '531',
      principle: 'rogersp',
      licenseCode: '2kBsYvAs3d',
      transactionType: 'GetTokenPan',
      responseType: 'web',
      responseURL: 'https://htsdev03.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
    },
    //semafone details for QA
    qaSemafoneParameters: {
      semafoneUrl: 'https://htsqa02.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
      semafoneMode: 'DISABLED',
      gatewayId: 'MONERIS',
      methodId: 'TOKENISE',
      ppUserId: 'vaas000221',
      ppPassword: 'KiVDIoM0wPjcxBXXkKT3',
      tenantId: 'RCI',
      clientId: '9',
      accountId: '531',
      principle: 'rogersp',
      licenseCode: '2kBsYvAs3d',
      transactionType: 'GetTokenPan',
      responseType: 'web',
      responseURL: 'https://htsqa02.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
    },
    //semafone details for PET
    petSemafoneParameters: {
      semafoneUrl: 'https://htspet.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
      semafoneMode: 'DISABLED',
      gatewayId: 'MONERIS',
      methodId: 'TOKENISE',
      ppUserId: 'vaas000221',
      ppPassword: 'TcT2sUbtllPZC6TtOdLA',
      tenantId: 'RCI',
      clientId: '9',
      accountId: '531',
      principle: 'rogersp',
      licenseCode: '2kBsYvAs3d',
      transactionType: 'GetTokenPan',
      responseType: 'web',
      responseURL: 'https://htspet.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
    },
    //semafone details for production
    prodSemafoneParameters: {
      semafoneUrl: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
      semafoneMode: 'DISABLED',
      gatewayId: 'MONERIS',
      methodId: 'TOKENISE',
      ppUserId: 'vaas000221',
      ppPassword: 'TcT2sUbtllPZC6TtOdLA',
      tenantId: 'RCI',
      clientId: '9',
      accountId: '531',
      principle: 'rogersp',
      licenseCode: '7QucejpMeP',
      transactionType: 'GetTokenPan',
      responseType: 'web',
      responseURL: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
    },
    // useFakeData: window.location.host.indexOf('localhost') === 0, //true,
    useFakeData: true,
    // Show all failures in a overlay box message
    showErrorPopup: false,
    // secure vs. unsecure path calls
    formsURL: '', //'http://10.10.47.23:8033' : '',  // https://www.dev17.rogers.com if you are on localhost this will prepend to your URLs
    //formsURL: 'https://www.dev26.rogers.com',
    devServerURL: '', //'http://10.10.47.23:8033', // https://www.dev17.rogers.com if you are on localhost this will prepend to your URLs

    unProtectedUrlPrefix: '/web/smb/api/business/v1/', // secureCallDefault = false
    protectedUrlPrefix: '/web/RogersServices.portal/smb/api/business/v1/', // secureCallDefault = true
    unProtectedUrlPrefixGeneric: '/web/smb/api/v1/', // secureCallDefault = false
    protectedUrlPrefixGeneric: '/web/RogersServices.portal/smb/api/v1/', // secureCallDefault = true

    //userType constants
    userType: {
      dealer: 'dealer',
      care: 'careRep',
      consumer: 'business'
    },
    //oneView Error Code Constants
    oneViewErrorCodes: {
      sspSSOFailure: 'SSP_SSO_FAILURE',
      crmSSOFailure: 'CRM_SSO_FAILURE',
      sspAccessFailure: 'SSP_ACCESS_FAILURE',
      crmAccessFailure: 'CRM_ACCESS_FAILURE',
      sessionTimeout: 'SESSION_TIMEOUT'
    },
    //defaultForRetailandCare:"DefaultForRetailandCare",

    //TBD figure out how to find My5 add-on
    my5soc: 'MY5 Talk',
    myVM: 'VM',
    myRVM: 'RVM',
    //!!! secureCallDefault - By default all calls are treated as secure -> true, pages and calls listed will be resolved into unsecure -> false

    // Default value to decide if call should be to [unProtectedUrlPrefix] OR [protectedUrlPrefix]
    secureCallDefault: true,
    // Pages listed in this array will overide [secureCallDefault] to value of FALSE and will therefore use [unProtectedUrlPrefix]
    // array values are module name
    secureCallPages: [
      'home',
      'signin',
      'registration',
      'forgetPassword',
      'forgetusername',
      'invalidPath',
      'demo',
      'tempPassword',
      'permissionDenied',
      'tpsc',
      'rewards',
      'rewards/redeem',
      'rewards/browse',
      'rewards/earn'
    ],
    // Ajax call functions listed in this array will overide [secureCallDefault] to value of FALSE and will therefore use [unProtectedUrlPrefix]
    // array values are relative paths from the ajax.post call
    // secureCalls: ['wirelessDashBoard', 'profile/question'],		// Example
    secureCalls: [
      'testlogin',
      'signin',
      'profile',
      'discardAllSmCookies',
      'profile/question',
      'forgot/username',
      'forgot/password/resubmit',
      'forgot/password',
      'tempPassword',
      'rfr/reward/products',
      'rfr/reward/categories',
      'rfr/marketing/promotions'
    ],
    // Pages listed in this array will use URL provided as an overide to URLs provided by default (key/value type of arrangement)
    // key = module name
    moduleCallException: {
      // 'linkaccount': '/web/RogersServices.portal/api/v1/'		// Example
    },
    // Ajax call functions listed in this array will use overide value from this array. (key/value type of arrangement)
    // key = relative parh from the ajax.post call  (payment/decrypt IS VALID as array key)
    ajaxCallException: {
      'loggedIn': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/loggedIn' : '/web/RogersServices.portal/smb/api/v1/loggedIn',
      'signin': '/smbsiteminderagent/forms/login.fcc',
      'tempPassword': '/smbsiteminderagent/forms/smpwservices.fcc',
      'encryptBritebill': '/web/RogersServices.portal/smb/api/v1/encryptBritebill',
      'brtSwitches': '/web/RogersServices.portal/smb/api/v1/brtSwitches',
      'hasPermissions': window.location.host.indexOf('localhost:') === 0 ? '/web/RogersServices.portal/smb/api/v1/hasPermissions' : '/web/RogersServices.portal/smb/api/v1/hasPermissions',
      'accountoverview': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/accountoverview' : '/web/RogersServices.portal/smb/api/business/v1/accountoverview',
      'permissions': window.location.host.indexOf('localhost:') === 0 ? '/web/RogersServices.portal/smb/api/v1/permissions' : '/web/RogersServices.portal/smb/api/v1/permissions',
      'ppc/priceplans/eligibility': '/web/RogersServices.portal/smb/api/v1/ppc/priceplans/eligibility',
      'spa/state': '/web/RogersServices.portal/smb/api/v1/spa/state',
      'buy/cart/fetch': '/web/RogersServices.portal/smb/api/v1/buy/cart/fetch',
      'ppc/subscribers': '/web/RogersServices.portal/smb/api/v1/ppc/subscribers',
      'esimreversechange' : "https://mybusinesshub.rogers.com/api/support/reserveESIMDetails",
      'swapsimdetails' : "https://mybusinesshub.rogers.com/api/support/changeSim",
      'esimtokendetails': "https://mybusinesshub.rogers.com/api/support/getTokenDetails",
      'esimdevicedetails': "https://mybusinesshub.rogers.com/api/support/geteSIMDeviceDetails",
      'reservseamlesseSim': "https://mybusinesshub.rogers.com/api/support/reserveSeamlessESIM",
      'getDetails': 'https://mybusinesshub.rogers.com/api/support/decryptESIMDetails',
      //ucc calls
      'subscriberListForBan': window.location.host.indexOf('localhost:') === 0 ? '/web/RogersServices.portal/smb/api/business/v1/ucc/subscriberListForBan' : '/web/RogersServices.portal/smb/api/business/v1/ucc/subscriberListForBan',
      //RFR protected calls
      'rfr/membership/list': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/rfr/membership/list' : '/web/RogersServices.portal/totes/api/v1/rfr/membership/list',
      'rfr/membership/details': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/rfr/membership/details' : '/web/RogersServices.portal/totes/api/v1/rfr/membership/details',
      'rfr/reward/transactions': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/rfr/reward/transactions' : '/web/RogersServices.portal/totes/api/v1/rfr/reward/transactions',
      'rfr/wishList': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/rfr/wishList' : '/web/RogersServices.portal/totes/api/v1/rfr/wishList',
      'rfr/updateWishList': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/rfr/updateWishList' : '/web/RogersServices.portal/totes/api/v1/rfr/updateWishList',
      'rfr/redeem': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/rfr/redeem' : '/web/RogersServices.portal/totes/api/v1/rfr/redeem',
      'rfr/optInToSpecialOffer': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/rfr/optInToSpecialOffer' : '/web/RogersServices.portal/totes/api/v1/rfr/optInToSpecialOffer',
      'rfr/product/image': '/web/totes/api/v1/rfr/product/image',
      'profile/checkComplete': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/profile/checkComplete' : '/web/RogersServices.portal/smb/api/business/v1/profile/checkComplete',
      'usernameMigration/check': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/usernameMigration/check' : '/web/RogersServices.portal/smb/api/business/v1/usernameMigration/check',
      'wcoc/decryptjwttoken': window.location.host.indexOf('localhost:') === 0 ? '/web/totes/api/v1/wcoc/decryptjwttoken' : '/web/RogersServices.portal/smb/api/business/v1/wcoc/decryptjwttoken',
      'customerbasedtargeting': 0 === window.location.host.indexOf('localhost:') ? '/web/totes/api/v1/customerBasedTargeting' : '/web/RogersServices.portal/smb/api/business/v1/customerBasedTargeting'
    },
    // Page login - list pages that need to be login protected
    // THIS IS DIFFERENT from secure / unsecure calls above
    pageLoginRequired: {
      //false - means all users / public
      'home': false,
      'registration': false,
      'signin': false,
      'forgetPassword': false,
      'forgetusername': false,
      'invalidPath': false,
      'demo': false,
      'tempPassword': false,
      'permissionDenied': false,
      'easSuccess': false,
      'easError': false,
      'underMaintenance': false,
      'tpsc': false,
      'uaa': false,
      'rewards': false,
      'rewards.redeem': false,
      'rewards.browse': false,
      'rewards.earn': false,
      'rewards.howitworks': false,
      'soho-migration': false,
      'sohoIntercept': false,
      //true - means only for logged-in users
      'guestOverview': false,
      'guestoverview': false,
      'linkaccount': true,
      'accountSelector': true,
      'accountOverview': true,
      'paymentHistory': true,
      'makeAPayment': true,
      'paynow': true,
      'migrateuser': true,
      'changeMethod': true,
      'wireless': true,
      'tvdashboard': true,
      'internetdash': true,
      'shmdashboard': true,
      'viewbill': true,
      'viewInvoice': true,
      'wireless-plan-change': true,
      'change-price-plan': true,
      'review-order': true,
      'confirm-order': true,
      'rewards.enroll': true,
      'rewards.wishlist': true,
      'rewards.membership': true,
      'rewards.transactions': true,
      'completeProfile': true,
      'reservedevice': true,
      'profile': true,
      'changePayMethod': true,
      'gotodatamanager': true
    },
    btnSettings: [{
        accountStatus: 'Suspended',
        viewBill: btnStatus.visible,
        payNow: btnStatus.visible,
        redeemEarnPoints: btnStatus.disabled,
        getTheReward: btnStatus.disabled,
        dashboardLinks: btnStatus.disabled,
        otherAvailableServices: btnStatus.disabled,
        paymentHistory: btnStatus.visible,
        changePaymentMethod: btnStatus.visible,
        accountBalance: btnStatus.visible,
        paymentDueDate: btnStatus.hidden,
        totalPoints: btnStatus.visible,
        earnedPoints: btnStatus.visible,
        allSubscriptions: btnStatus.disabled,
        accOverviewEnroll: btnStatus.visible,
        internetPackageLinks: btnStatus.visible,
        //modemDescription:btnStatus.visible,
        internetModemLinks: btnStatus.visible,
        changeModemLink: btnStatus.visible,
        changeModemLinkMessage: btnStatus.hidden,
        changeTVPackageSection: btnStatus.visible,
        infoMessageBox: btnStatus.hidden
      },
      {
        accountStatus: 'Cancelled',
        viewBill: btnStatus.visible,
        payNow: btnStatus.visible,
        redeemEarnPoints: btnStatus.hidden,
        getTheReward: btnStatus.hidden,
        dashboardLinks: btnStatus.hidden,
        otherAvailableServices: btnStatus.hidden,
        paymentHistory: btnStatus.visible,
        changePaymentMethod: btnStatus.hidden,
        accountBalance: btnStatus.visible,
        paymentDueDate: btnStatus.visible,
        totalPoints: btnStatus.hidden,
        earnedPoints: btnStatus.hidden,
        allSubscriptions: btnStatus.hidden,
        accOverviewEnroll: btnStatus.visible,
        internetPackageLinks: btnStatus.visible,
        // modemDescription:btnStatus.visible,
        internetModemLinks: btnStatus.visible,
        changeModemLink: btnStatus.visible,
        changeModemLinkMessage: btnStatus.hidden,
        changeTVPackageSection: btnStatus.visible,
        infoMessageBox: btnStatus.hidden
      },
      {
        accountStatus: 'Deactive',
        viewBill: btnStatus.visible,
        payNow: btnStatus.visible,
        redeemEarnPoints: btnStatus.hidden,
        getTheReward: btnStatus.hidden,
        dashboardLinks: btnStatus.hidden,
        otherAvailableServices: btnStatus.hidden,
        paymentHistory: btnStatus.visible,
        changePaymentMethod: btnStatus.hidden,
        accountBalance: btnStatus.visible,
        paymentDueDate: btnStatus.visible,
        totalPoints: btnStatus.hidden,
        earnedPoints: btnStatus.hidden,
        allSubscriptions: btnStatus.hidden,
        accOverviewEnroll: btnStatus.visible,
        internetPackageLinks: btnStatus.visible,
        // modemDescription:btnStatus.visible,
        internetModemLinks: btnStatus.visible,
        changeModemLink: btnStatus.visible,
        changeModemLinkMessage: btnStatus.hidden,
        changeTVPackageSection: btnStatus.visible,
        infoMessageBox: btnStatus.hidden
      },
      {
        accountStatus: 'CLMExceeded',
        viewBill: btnStatus.visible,
        payNow: btnStatus.visible,
        redeemEarnPoints: btnStatus.disabled,
        getTheReward: btnStatus.disabled,
        dashboardLinks: btnStatus.disabled,
        otherAvailableServices: btnStatus.disabled,
        paymentHistory: btnStatus.visible,
        changePaymentMethod: btnStatus.visible,
        accountBalance: btnStatus.visible,
        paymentDueDate: btnStatus.visible,
        totalPoints: btnStatus.visible,
        earnedPoints: btnStatus.visible,
        allSubscriptions: btnStatus.disabled,
        accOverviewEnroll: btnStatus.visible,
        internetPackageLinks: btnStatus.visible,
        // modemDescription:btnStatus.visible,
        internetModemLinks: btnStatus.visible,
        changeModemLink: btnStatus.visible,
        changeModemLinkMessage: btnStatus.hidden,
        changeTVPackageSection: btnStatus.visible,
        infoMessageBox: btnStatus.hidden
      },
      {
        accountStatus: 'DefaultForRetailandCare',
        viewBill: btnStatus.visible,
        payNow: btnStatus.visible,
        redeemEarnPoints: btnStatus.hidden,
        getTheReward: btnStatus.hidden,
        dashboardLinks: btnStatus.hidden,
        otherAvailableServices: btnStatus.visible,
        paymentHistory: btnStatus.hidden,
        changePaymentMethod: btnStatus.visible,
        accountBalance: btnStatus.visible,
        paymentDueDate: btnStatus.hidden,
        totalPoints: btnStatus.hidden,
        earnedPoints: btnStatus.hidden,
        allSubscriptions: btnStatus.hidden,
        accOverviewEnroll: btnStatus.hidden,
        internetPackageLinks: btnStatus.hidden,
        // modemDescription: btnStatus.hidden,
        internetModemLinks: btnStatus.hidden,
        changeModemLink: btnStatus.hidden,
        changeModemLinkMessage: btnStatus.visible,
        changeTVPackageSection: btnStatus.hidden,
        infoMessageBox: btnStatus.visible
      },
      {
        accountStatus: 'Default',
        viewBill: btnStatus.visible,
        payNow: btnStatus.visible,
        redeemEarnPoints: btnStatus.visible,
        getTheReward: btnStatus.visible,
        dashboardLinks: btnStatus.visible,
        otherAvailableServices: btnStatus.visible,
        paymentHistory: btnStatus.visible,
        changePaymentMethod: btnStatus.visible,
        accountBalance: btnStatus.visible,
        paymentDueDate: btnStatus.visible,
        totalPoints: btnStatus.visible,
        earnedPoints: btnStatus.visible,
        allSubscriptions: btnStatus.visible,
        accOverviewEnroll: btnStatus.visible,
        internetPackageLinks: btnStatus.visible,
        // modemDescription:btnStatus.visible,
        internetModemLinks: btnStatus.visible,
        changeModemLink: btnStatus.visible,
        changeModemLinkMessage: btnStatus.hidden,
        changeTVPackageSection: btnStatus.visible,
        infoMessageBox: btnStatus.hidden
      }
    ],
    postSigninUrl: window.location.protocol + '//' + window.location.hostname + '/web/RogersServices.portal/smb/bss/#/accountOverview',
    postSigninUrlShort: '/web/smb/bss/#/accountoverview',
    postSignOutUrl: window.location.host.indexOf('localhost:') >= 0 ? '/#/signin' : '/web/smb/bss/#/signin',
    // exceptional behaviour
    siteminderUrl: '/smbsiteminderagent/forms/login.fcc', // Used in signin.js
    tempPasswordUrl: '/smbsiteminderagent/forms/smpwservices.fcc',
    enablePricePlanChanges: true,
    enableSelfServe: true,
    // page that are mandatory to complete and should have all sub menus disabled
    mandatoryPages: [
      'migrateUser',
      'completeProfile'
    ]

  })
  .run(['$rootScope', 'appState', 'userLanguage', 'userProvince', 'settings', 'localStorage', '$browser', 'ute.blocks.persistent.storage.service', 'ute.rogers.datalayer.integration.common.service', 'ute.datalayer.common.service', '$window', '$http', 'ajax', 'ute.common.user.service', '$injector', '$sce', '$interval', 'keepAliveService',
    function ($rootScope, appState, userLanguage, userProvince, settings, localStorage, $browser, utePersistentStorageService, dataLayerIntegrationService, dataLayerService, $window, $http, ajax, userService, $injector, $sce, $interval, keepAliveService) {

      // Pre-set global variables
      $('html').attr('lang', userLanguage());
      $rootScope.countValue = 1;

      $window.document.cookie = 'uteBillProfile=' + 'true' + ';domain=' + '.rogers.com' + ';path=' + '/';

      localStorage.setLocalStorageValue('BSS_OCP_UTE', true); //setting this value as true by default for handling ppc direct landing
      $rootScope.statusFlag = false;
      //EAS Change to skip refresh token and status call in every 1 mins
      /* $interval(function () {
        if ($browser.cookies()['bss-info'] || $browser.cookies().CONSENT_STATE) {
          keepAliveService.validateSession();
        }
      }, 60000); */

      window.addEventListener("message", function (event) {
        if (event.origin == "https://" + window.location.hostname) {
          if (event.data.sessionexpired) {
            $rootScope.internalRedirect = true;
            window.location.href = event.data.url;
          } else if (event.data.winpdfdownloaded) {
            dataLayerService.track({}, false, [4, 1, 0], {
              mappingKey: 'winPdfDownload'
            });
          } else if (event.data.pdfNotLoading) {
            $rootScope.$apply(function () {
              var uteBillService = $injector.get('uteBillService');
              uteBillService.pdfErrorCount++;
              $rootScope.pdfNotLoading = true;
              $rootScope.winInvoice = true;
              if (uteBillService.pdfErrorCount < 3) {
                if (uteBillService.invoiceDateSelected.issue_date) {
                  var _date = uteBillService.invoiceDateSelected.issue_date.split('-');
                  $rootScope.pdfNotLoading = false;
                  $rootScope.winIframeUrl = $sce.trustAsResourceUrl("/web/smb/cms/selfserve/pdf_js/web/viewer.html?file=" +
                    encodeURIComponent('/web/RogersServices.portal/smb/api/business/v2/bills/wol/' + $rootScope.ao.accountActive.accountNumber + '/' + _date[0] + '/' + _date[1] +
                      '?date=' + new Date().getTime()));
                }
              } else {
                uteBillService.pdfErrorCount = 0;
                dataLayerService.track({}, false, [4, 1, 0], {
                  mappingKey: 'pdfNotLoadingError'
                });
              }
            });
          } else if (event.data.noInvoiceReturned) {
            dataLayerService.track({}, false, [4, 1, 0], {
              mappingKey: 'noInvoiceReturned'
            });
          }
        }
      }, false);

      $rootScope.$on('resourceChanged', function () {
        utePersistentStorageService.putToSession("userLanguage", userLanguage());
        utePersistentStorageService.putToSession("userProvince", userProvince());
        analyticsUserAccountInfo();
        signedInUserInfo();
      });

      // Start - bsl-107 changes
      var exceptionCases = ['setPassword', 'resetPassword', 'tempPassword', '?'];
      var ttlForClientCache;
      var isExceptionCase = false;
      angular.forEach(exceptionCases, function (value) {
        if (window.location.href.indexOf(value) > 0) {
          isExceptionCase = true;
        }
      })

      if (isExceptionCase || ($browser.cookies().deepJSON)) {
        document.cookie = "timeToLive=true; path=/;";
      }
      if ($browser.cookies().timeToLive) {
        // Do nothing
      } else {
        if (!(utePersistentStorageService.getFromLocal('ttlDate')) || (utePersistentStorageService.getFromLocal('ttlDate') == null) || (utePersistentStorageService.getFromLocal('ttlDate') == undefined)) {
          var currentDate = new Date();
          utePersistentStorageService.putToLocal('ttlDate', currentDate.getTime());
          document.cookie = "timeToLive=true; path=/;";
        } else {
          ajax.getSelfserveConfig().then(
            function (response) {
              ttlForClientCache = response.ttlForClientCache;
              var today = new Date();
              var timeDiff = (today.getTime() - utePersistentStorageService.getFromLocal('ttlDate'));
              var cacheDaysInMilliSeconds = ttlForClientCache * 24 * 60 * 60 * 1000;
              var host = location.host.split(".");
              host.shift();
              var cookieDomain = '.' + host.join('.');
              var cookiePossibleDomains = ['www.rogers.com', '.rogers.com', cookieDomain, location.host];
              if (timeDiff > cacheDaysInMilliSeconds) {
                angular.forEach($browser.cookies(), function (value, key) {
                  document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC';
                  document.cookie = key + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
                  angular.forEach(cookiePossibleDomains, function (domain) {
                    document.cookie = key + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=' + domain;
                  })
                })
                var storageArr = ['pInd', 'ttlDate', 'ListBasedTargets', 'visitCount', 'cta-clicked', 'disqualify', 'consentPath', 'midmarkettemp'];
                localStorage.clearAllLocalStorageValuesExcept(storageArr);
                //localStorage.clearAllLocalStorageValues();
                sessionStorage.clearAllSessionStorageValues();
                $window.location.reload(true);
              } else {
                document.cookie = "timeToLive=true; path=/;";
              }
            },
            function (error) {}
          );
        }
      }

      // End - bsl-107 changes

      utePersistentStorageService.putToSession('userLanguage', userLanguage());
      utePersistentStorageService.putToSession("userProvince", userProvince());

      if (localStorage.getLocalStorageValue('phoneNumber')) {
        var accountInfo = {
          selectedCTN: localStorage.getLocalStorageValue('phoneNumber')
        };
        dataLayerIntegrationService.setSelectedSubscriberNumber(accountInfo);
      }

      function signedInUserInfo() {
        if (!(localStorage.getLocalStorageValue('ute.rogers.signin.user')) || (localStorage.getLocalStorageValue('ute.rogers.signin.user') == null) || (localStorage.getLocalStorageValue('ute.rogers.signin.user') == "")) {
          var signedInUser = {};
          signedInUser.userEmail = $browser.cookies().userName;
          signedInUser.userName = $browser.cookies().userName;
          localStorage.setLocalStorageValue('ute.rogers.signin.user', JSON.stringify(signedInUser));
          userService.signed(signedInUser);
        }
      }

      function analyticsUserAccountInfo() {
        var cookieStore = $browser.cookies();
        var userName;
        if (localStorage.getLocalStorageValue('ute.rogers.signin.user')) {
          var userDetail = JSON.parse(localStorage.getLocalStorageValue('ute.rogers.signin.user'));
          if (userDetail.userName) {
            userName = userDetail.userName;
          }
        }
        var accountNumber = getAccountInfo(utePersistentStorageService.getFromSession('accountNumber'), cookieStore.accountNumber, utePersistentStorageService.getFromLocal('accountNumber'));
        var userId = getAccountInfo(utePersistentStorageService.getFromSession('userName'), cookieStore.userName, userName);
        var accountInfo = {
          accountNumber: accountNumber,
          userName: userId,
          userType: 'BSS-Standard'
        };
        if ($rootScope.user.isAuthenticated) {
          dataLayerIntegrationService.setUserAccountInfo(accountInfo);
        }
        utePersistentStorageService.putToSession('flowType', 'Selfserve');
      }

      function getAccountInfo(sessionValue, cookieValue, localValue) {
        if (sessionValue && !(sessionValue === null && sessionValue === undefined)) {
          return sessionValue;
        } else if (cookieValue && !(decodeURIComponent(cookieValue) === null && decodeURIComponent(cookieValue) === 'undefined')) {
          return cookieValue;
        } else if (localValue && !(localValue === null && localValue === undefined)) {
          return localValue;
        }
      }

      //getting querystrings for making specific account call.
      $rootScope.isConsumer = true;
      $rootScope.isDealer = false;
      $rootScope.isCare = false;
      $rootScope.isOneViewInterface = false;
      var queryStrings = appState.getQueryStrings();
      if (queryStrings != '') {
        // this global variable is being used globally
        var userType = $browser.cookies().userType;
        if (userType) {
          if (userType === settings.userType.dealer) {
            $rootScope.isDealer = true;
            $rootScope.isConsumer = false;
          } else if (userType === settings.userType.care) {
            $rootScope.isCare = true;
            $rootScope.isConsumer = false;
          }
        }
      }
      // initiate Account overview appState
      appState.aoInitiate();

      // Modal instance holder
      $rootScope.modal = null;

      $rootScope.$on('$stateChangeStart', function () {
        if ($rootScope.modal !== null && $rootScope.modal !== undefined) {
          //	$rootScope.modal.close('url');
          $rootScope.modal.dismiss('cancel');
          $rootScope.modal = null;
        }
      });

      $rootScope.popUpOpened = false;
      $rootScope.$on('$stateChangeStart', function (event, next, current) {
        if ($rootScope.dialogPNSuccess) {
          $rootScope.dialogPNSuccess.close();
          $rootScope.dialogPNSuccess = undefined;
        }
        if ($rootScope.dialogPNFail) {
          $rootScope.dialogPNFail.close();
          $rootScope.dialogPNFail = undefined;
        }
        if ($rootScope.dialogPNCancel) {
          $rootScope.dialogPNCancel.close();
          $rootScope.dialogPNCancel = undefined;
        }
        if (next.url === '/oneViewInterface') {
          $rootScope.isOneViewInterface = true;
        }
      });

      $rootScope.errorMessagesMapping = [{
          'page': 'linkaccount',
          'field': 'accountNumber',
          'required': 'linked_err_acc_num',
          'pattern': 'linked_err_acc_num'
        },
        {
          'page': 'linkaccount',
          'field': 'postalCode',
          'required': 'linked_err_postal',
          'pattern': 'linked_acc_postalcode_invalid'
        },
        {
          'page': 'linkaccount',
          'field': 'phoneNumber',
          'required': 'linked_acc_phone_invalid',
          'pattern': 'linked_acc_phone_invalid'
        },
        {
          'page': 'linkaccount',
          'field': 'pinNumber',
          'required': 'linked_acc_prepaid_pin',
          'pattern': 'linked_acc_prepaid_pin'
        }
      ];

      $window.onbeforeunload = function () {
       // if (!$rootScope.internalRedirect && $rootScope.user.isAuthenticated && $http.pendingRequests.length !== 0) {
        //  for(var i=0;i<= $http.pendingRequests.length;i++){
          //  var httplogout = "https://rogers-stg.transmit.security/api/v2/login/direct/eas/logout?client_id=51c7aaf4-9bb8-423e-b3f4-aba8e51653f9";
           // if($http.pendingRequests[i].url == "/web/smb/api/business/v1/logout" || $http.pendingRequests[i].url == httplogout || $http.pendingRequests[i].url == "/web/RogersServices.portal/smb/api/v1/discardLoginSmCookies" ||  $http.pendingRequests[i].url == "/web/smb/cms/selfserve/authorizeConfigData.json"){
            // console.log("hlo");
            //}else{
              //  return "Are you sure want to close";
           // }
        //}
        //}
      };
      // $rootscope.currentTime = new Date().getHours();
      ajax.getSelfserveConfig().then(
        function (response) {
          $rootScope.maintenanceStart = response.maintenanceStartTime;
          $rootScope.maintenanceEnd = response.maintenanceEndTime;
          $rootScope.esfSessionListenerEnabled = response.esfSessionListenerEnabled;
        }
      )

      //      $rootScope.$watch('user.isAuthenticated', function (newVal, oldVal) {
      //        if (newVal) {
      //          $interval(function () {
      //            var url = '/business/v1/sso/status?' + Date.now();
      //            $http.get(url).then();
      //          }, 60 * 1000);
      //        }
      //      });
    }
  ]);


(function () {
  'use strict';

  angular
    .module('totesApp')
    .controller('ocpPopupCtrl', ocpPopupController);

  ocpPopupController.$inject = ['$scope','resource','userLanguage', '$interval', 'user', 'ocpService'];

  function ocpPopupController($scope, resource, userLanguage, $interval, user, ocpService) {
      $scope.userLanguage = userLanguage().toUpperCase();
      $scope.liveChatURL = resource.get("live_chat_url");
      var minutes = 2;
      var seconds = 0;
      var logout = true;


      if (minutes >= 0) {
          checkTime();
      }
      setTime(minutes, seconds);

      function checkTime() {
          var showTime = $interval(function() {
              if (minutes === 0 && seconds == 0 && logout) {
                  $interval.cancel(showTime);


                  MBHLauncher.trigger("sessionTimeout");




                  return;
              }

              if (seconds === 0) {
                  --minutes;
                  seconds = 59;
              } else
                  --seconds;

              setTime(minutes, seconds);
          }, 1000)
      }

      function setTime(minutes, seconds) {
          $scope.displaySeconds = (seconds < 10 ? "0" : "") + seconds;
          $scope.minutes = minutes;



      }

      $scope.SignOut = function() {
          logout = false;

          //MBHLauncher.signOut();
          //MBHLauncher.destroy();
          user.logout();
      };

      $scope.SignedIn = function() {
          logout = false;
          ocpService.showOcpPopup = true;
          MBHLauncher.keepAlive(true);
          $scope.closeThisDialog();
      };
  }
})();

'use strict';

/**
 * @ngdoc function
 * @name accountOverview
 * @description
 * # account overview service and controller
 * Controller of the totesApp
 */

angular
  .module('totesApp')
  .factory('oneViewService', ['$rootScope', '$location', 'ajax', 'resource', 'appState', 'localStorage', '$window', 'settings', 'userLanguage',
    function ($rootScope, $location, ajax, resource, appState, localStorage, $window, settings, userLanguage) {

    }])

  .controller('oneView', ['$scope', '$rootScope', '$cookieStore', '$browser', 'resource', 'appState', 'deeplink', 'myrAccountOverviewService', 'userLanguage', 'settings', '$modal', 'ajax', '$state', '$window', 'localStorage', 'btnSettings', '$stateParams', 'myrNotificationBannerService',
    function ($scope, $rootScope, $cookieStore, $browser, resource, appState, deeplink, accountOverviewService, userLanguage, settings, $modal, ajax, $state, $window, localStorage, btnSettings, $stateParams, notificationBannerService) {

      notificationBannerService.cleanBanner('linkedMessage');
      notificationBannerService.cleanBanner('successMessage');
      var linkedMessageId = null;
      var successMsgIdFromStorage = null;

      // Scope variables
      $scope.appState = appState;
      $scope.errorKey = null;
      $scope.errorMessage = null;
      /*$scope.linkedMessageId = null;
       $scope.linkedMessage = null;
       $scope.successMessage = null;*/
      $scope.clmMessage = null;

      // User profile
      $scope.userId = null;
      $scope.accountTypes = [];
      $scope.selectedAccount = null;
      $scope.isPrepaid = false;     //selected account is pre-paid or not
      $scope.isCLM = false;
      $scope.isCLMExceeded = false;    //exceeded credit limit
      $scope.accountDetails = null;
      $scope.popUpOpened = false;
      $scope.selAccountStatusError = '';
      $scope.accountStatusSimple = '';
      $scope.accountCancelled = false;
      $scope.mode = 'overview';
      $scope.adExpired = false;
      $scope.modalInstance = null;
      $scope.myServicesList = [];
      $scope.isbritebillAvailable = false;

      // Switch account flags
      $scope.loadingDataIndicator = false;
      $scope.isDetailsNotFound = false;
      $scope.isSwitching = false;
      //$scope.successMsgIdFromStorage = '';
      $scope.suspendedSubscriptionMessage = '';

      $scope.loadingBriteBill = true;
      $scope.loadingBalance = true;
      $scope.loadingRewards = true;
      $scope.bLoadingServices = true;
      $scope.disableBalance = true;

      var briteBillServerLogs = {
        'briteBillError': 'BriteBill error - '
      };

      //for Message box
      var messageBoxDom = function () {
        $scope.rhmMsg = '<div>' +
          resource.get('order_though_oasys') +
          '</div><div class=\'green-text\'><strong>' +
          resource.get('to_book_in_home_assessment') +
          '</strong></div><div>' +
          resource.get('login_to') +
          ' <strong>' +
          resource.get('sgi') +
          '</strong></div>';
      };
      messageBoxDom();
      resource.onChanged(function () {
        messageBoxDom();
      }, $scope);

      var errorMessages = {
        'accountList': null,
        'summary': null,
        'balanceDetails': null,
        'loyalty': null
      };

      function errorMessageCheck() {

        $scope.errorMessage = '';

        $.each(errorMessages, function (key, value) {
          if (value) {
            $scope.errorMessage = value;
          }
        });

      }

      $scope.getMaintenanceSettings = function () {
        if (!$rootScope.ao.accountActive) {
          //first time check signin language
          // Make call to server (Should not need to tho)
          var request = {
            refresh: false
          };

          var maintenanceSettingsResponse = function (_tmp) {

          };

          accountOverviewService.getMaintenanceSettings(request, maintenanceSettingsResponse);

        } else {
          // grab data from rootscope and have the function process that
          accountOverviewService.processMaintenanceSettings($rootScope.maintenance, true);
        }
        return null;
      };

      $scope.tagSelectedAccount = function () {
        var _details = accountOverviewService.getSelectedAccountDetail();
        if (!_details) {
          return;
        }
        $scope.isPrepaid = _details.isPrepaid;
        //get phone numbers
        var _phonesList = '';
        if (_details.phoneNumber) {
          for (var i = 0, l = _details.phoneNumber.length; i < l; i++) {
            _phonesList += _details.phoneNumber[i] + '|';
          }
        }
        _phonesList = _phonesList.substr(0, _phonesList.length - 1);
        appState.tagging(['_trackPageView',
          {pn: 'home:myrogers:overview'}, // Page Name
          {sACTT: _details.userType}, // Consumer, Business
          {sACSBTT: _details.userSubType}, // Prepaid, Regular
          {sBAN: _details.number}, //Account Number BAN, ex : '12345'
          {sCTN: _phonesList}, //Account Telephone Number CTN, ex: '4161234567|4161234568'
          {sACSS: _details.status} // Active, Suspended:
        ]);
      };

      $scope.runService = function (serviceName, value) {
        accountOverviewService.runService(serviceName, value);
      };

      $scope.processGetAccountList = function (_tmp) {
        // _tmp = $rootScope.ao.raw
        // _tmp = $rootScope.ao.raw
        if (_tmp.result === 'success') {
          for (var i = 0; i < _tmp.total; i++) {
            var tmp = {};
            tmp = _tmp.accountList[i];
            _tmp.accountList[i].accountStatusSimple = accountOverviewService.getAccountStatus(tmp).accountStatusSimple;
            _tmp.accountList[i].nickName = _tmp.accountList[i].nickname;
            _tmp.accountList[i].displayName = _tmp.accountList[i].nickName ? _tmp.accountList[i].nickName : _tmp.accountList[i].accountNumber;
            _tmp.accountList[i].accNo = _tmp.accountList[i].accountNumber;
          }

          // ????
          if (appState.usernameChanged && _tmp.accountList.length >= 1) {
            linkedMessageId = 'mu_msg_success';
            updateMessage();
            accountOverviewService.clearAccountDetails();
            appState.usernameChanged = false;
          }

          //display the linked success banner for the very first account
          $scope.accountTypes = _tmp.accountList;
          var reqIndex = 0;
          var accLocalSelected;

          if ($scope.accountTypes.length > 1 &&
            ($rootScope.ao.accountActiveIndex === null || $rootScope.ao.accountActiveIndex === undefined)) {

            // Check local storage if account was selected in past
            accLocalSelected = localStorage.getLocalStorageValue('accountNumber');
            if (accLocalSelected) {
              // Update selected index
              appState.aoUpdateActiveObjects(accLocalSelected);
              reqIndex = $rootScope.ao.accountActiveIndex;
            } else {
              if (deeplink.data.direction === 'out') {
                // DO NOT open the pop-up selector
              } else {
                // Show the popup / first time entry
                if (!$rootScope.firstLoad) {
                  appState.tagging(['_trackLink', {event35: ''}]);
                  $rootScope.firstLoad = 1;
                }
                $rootScope.popUpOpened = true;
                $scope.openSelectAccount('');
              }
            }
          }
          else if ($scope.accountTypes.length > 1) {
            accLocalSelected = localStorage.getLocalStorageValue('accountNumber');
            if (accLocalSelected) {
              appState.aoUpdateActiveObjects(accLocalSelected);
              reqIndex = $rootScope.ao.accountActiveIndex;
            } else {
              reqIndex = $rootScope.ao.accountActiveIndex;
            }
          }
          if ($scope.accountTypes.length === 1) {
            if (!$rootScope.firstLoad) {
              $rootScope.firstLoad = 1;
              appState.tagging(['_trackLink', {event35: ''}]);
            }
          }

          // Update selection and store it into a cookie
          $scope.selectedAccount = accountOverviewService.updateSelectedAccount(reqIndex);
          $rootScope.ao.accountActive = $scope.selectedAccount;

          //getBriteBillList();
          appState.tagging(['_trackLink', {eVar7: $scope.selectedAccount.accountNumber}, {event17: ''}]);
          appState.tagging(['_trackLink', {eVar17: $scope.selectedAccount.accountNumber}]);

          $scope.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
          $scope.btnStatus = $window.btnStatus;

          $rootScope.selectedAccount = $scope.selectedAccount.accountNumber;
          localStorage.setLocalStorageValue('accountNumber', $scope.selectedAccount.accountNumber);
          localStorage.setLocalStorageValue('accountTypeNumber', $scope.selectedAccount.accountTypeNumber);
          appState.aoUpdateIndexes($scope.selectedAccount.accountNumber);
          $scope.changeAccount();

          var modalSelected = localStorage.getLocalStorageValue('accountNumber');
          appState.aoUpdateActiveObjects(modalSelected);

          // From updated rootScope proceed to update of the page
          //$scope.selectedAccount = $rootScope.ao.accountActive; // accountActive is unprocessed, selectedAccount must come from accountTypes in order to be represented properly in accountoverview combo box
          $scope.selectedAccount = $scope.accountTypes[reqIndex];

          return $scope.accountTypes;

        } else {
          if (_tmp.result === 'redirect') {
            appState.noLinking = false;
            //appState.switchView('guestoverview');
            appState.switchView('/oneViewInterface');
          } else if (_tmp.result === 'fail') {
            $scope.errorMessage = 'Failed to load account list';

          } else if (_tmp.result === 'error') {
            $scope.errorMessage = _tmp.originalError;

          } else {
            // Unknown state ???
          }
        }
      };

      $scope.findIndex = function (activeNumber, objectArray) {
        // purpose of this is to find the index of the object in array using one of its proprties
        var retVal = -1;
        if (objectArray === null) {
          // no data? why bother?
        } else {
          for (var i = 0; i < objectArray.length; i++) {
            if (objectArray[i].accountNumber === activeNumber) {
              retVal = i;
            }
          }
        }
        return retVal;
      };

      $scope.preCleanCall = function () {
        // Notify server to prepare fresh data
        var postData = {};
        postData.accountNumber = $rootScope.ao.accountActive.accountNumber;
        ajax.notifyServerLOBchange(postData);

        return true;
      };

      $scope.getAccountList = function () {
        //hide the previous account details
        $scope.startLoadingData();
        errorMessages.accountList = null;

        var browserCookies = $browser.cookies();
        var signInLanguage = browserCookies.signInLang;
        var cacheFailSafe = true;

        if (signInLanguage) {
          userLanguage(signInLanguage);
          $cookieStore.remove('signInLang');
        }
        if (!$rootScope.ao.accountActive) {
          //first time check signin language

          // Make call to server (Should not need to tho)
          var request = {
            refresh: false,
            applicationId: 'Rogers.com'
          };

          var accountListResponse = function (_tmp) {
            if (_tmp) {

              if (_tmp.cachedResultInfo) {
                if (_tmp.cachedResultInfo.expired && cacheFailSafe) {
                  cacheFailSafe = false;
                  request.refresh = true;
                  if (_tmp.accountList.length > 0) {
                    var dataToProcess = JSON.parse(JSON.stringify(_tmp));
                    $scope.processGetAccountList(dataToProcess);
                    accountOverviewService.storedAccountList = JSON.parse(JSON.stringify(_tmp));
                  }

                  accountOverviewService.getAccountList(request, accountListResponse, accountListErrorSecondCall);
                }
              }
              /*

               if( !accountOverviewService.storedAccountList || (accountOverviewService.storedAccountList && (_tmp !== accountOverviewService.storedAccountList))){
               $scope.processGetAccountList(_tmp);
               accountOverviewService.storedAccountList = _tmp;
               accountOverviewService.getAccountList(request, accountListResponse, accountListError);
               }

               */

              if (accountOverviewService.storedAccountList) {
                accountOverviewService.storedAccountList.cachedResultInfo = {};
              }
              _tmp.cachedResultInfo = {};

              if (!accountOverviewService.storedAccountList || (accountOverviewService.storedAccountList && (!angular.equals(_tmp, accountOverviewService.storedAccountList)))) {
                $scope.processGetAccountList(_tmp);
              }

            }

          };

          var accountListError = function () {
            errorMessages.accountList = resource.get('acc_overview_oops');
          };

          var accountListErrorSecondCall = function () {
            $scope.loadingDataIndicator = false;
          };

          accountOverviewService.getAccountList(request, accountListResponse, accountListError);

        } else {
          // grab data from rootscope and have the function process that
          $scope.processGetAccountList($rootScope.ao.raw);
        }

        return null;
      };

      $scope.getAccountDetails = function (selectedAccount, language, isRefresh) {
        //hide the previous account details
        $scope.startLoadingData();
        $rootScope.$broadcast('startChangeAccount');
        $scope.loadingRewards = true;
        $scope.myOtherServicseListFinal = [];

        errorMessages.loyalty = null;
        errorMessages.summary = null;
        var cacheFailSafe = true;
        var request = {
          accountNumber: selectedAccount.accountNumber,
          accountTypeNumber: selectedAccount.accountTypeNumber,
          pinNumber: selectedAccount.pinNumber,
          phoneNumber: selectedAccount.phoneNumber,
          language: language,
          refresh: isRefresh || false,
          indx: selectedAccount.selectedAccountIndex,
          applicationId: 'SMB'
        };

        accountOverviewService.clearAccountDetails();
        $scope.myServicesList = [];

        //save the selected for future reference
        appState.selectedAccount = $scope.selectedAccount;

        var rewardsResponse = function (data) {
          errorMessages.loyalty = (data && data.result === 'fail') ? resource.get('acc_overview_loyalty_error') : null;
          $scope.loadingRewards = false;
        };

        var accountDetailsResponse = function (_tmp) {

          var processDetailsResponse = function () {
            $scope.isDetailsNotFound = false;
            $scope.accountDetails = _tmp.data;

            $rootScope.ao.accountDetails = null;
            $rootScope.ao.accountDetails = $scope.accountDetails;
            //Analytic tagging when select an account
            if ($scope.selectedAccount) {
              $scope.tagSelectedAccount();
            }

            if ($scope.accountDetails.cachedResultInfo !== undefined) {
              $scope.adExpired = $scope.accountDetails.cachedResultInfo.expired;
              //$scope.$broadcast('detailExpired');
            }

            var status = accountOverviewService.getAccountStatus(selectedAccount);
            $scope.selAccountStatusError = status.accountStatusError;
            $scope.accountStatusSimple = status.accountStatusSimple;
            $scope.accountCancelled = status.accountCancelled;
            switch (selectedAccount.accountStatus) {
              case 'Suspended':
                $scope.displayPayNowBtn = false;
                break;
              case 'Cancelled':
                $scope.displayPayNowBtn = false;
                break;
              case 'Deactive':
                $scope.displayPayNowBtn = false;
                break;
              default:
                $scope.displayPayNowBtn = true;
                break;
            }

            //check credit limit error
            //check if exceeding credit limit

            //var _isCLM = $scope.accountDetails.accountBalance.exceedCreditLimit;
            //$scope.isCLM = _isCLM ? true : false;

            //$scope.getSubscriptions($scope.accountDetails.subList);
            var subscriptions = accountOverviewService.getSubscriptions($scope.accountDetails.subList);
            $scope.myServicesList = subscriptions.myServices;
            $rootScope.myServicesList = subscriptions.myServices;
            //$scope.myOtherServicesListFinal = subscriptions.myOtherServices;
            //$scope.loadingDataIndicator = false;
          };

          if (_tmp.result === 'success') {

            if (_tmp.data.cachedResultInfo) {
              if (_tmp.data.cachedResultInfo.expired === true && cacheFailSafe) {
                cacheFailSafe = false;
                request.refresh = true;
                var dataToProcess = JSON.parse(JSON.stringify(_tmp));
                accountOverviewService.storedSummary = JSON.parse(JSON.stringify(_tmp));
                processDetailsResponse(dataToProcess.data);
                accountOverviewService.getAccountDetails(request, accountDetailsResponse, rewardsResponse);
              }
            }

            if (!_tmp.data.cachedResultInfo || (_tmp.data.cachedResultInfo && !_tmp.data.cachedResultInfo.expired)) {

              //Account details updated and show them
              $scope.endLoadingData();
            }
            processDetailsResponse(_tmp.data);
          }
          else {
            // Unknown state ???
            $scope.isDetailsNotFound = true;
            errorMessages.summary = resource.get('maintenance_info');
          }
        };
        accountOverviewService.getAccountDetails(request, accountDetailsResponse, rewardsResponse);
      };

      $scope.startLoadingData = function () {
        $scope.loadingDataIndicator = true;
        $scope.isSwitching = true;
        $rootScope.$broadcast('startChangeAccount');
        $('#accountType').prop('disabled', 'disabled');
      };

      $scope.endLoadingData = function () {
        //broadcast event ended
        $('#accountType').removeAttr('disabled');
        $scope.isSwitching = false;
        $rootScope.$broadcast('changedAccount');   // accountBalance.js - picks up on this call and initiates $scope.updateBalance ();
        $scope.loadingDataIndicator = false;
      };

      $scope.redirectToCarePage = function () {
        var _linkToCareUrl = settings.devServerURL.replace(/\/\/www/gi, '//internal') + '/web/InternalUse.portal';
        $window.location.href = _linkToCareUrl;
      };

      $scope.openSelectAccount = function (size) {
        // Modal handling function
        var pageUrl = $window.location.href;
        if (pageUrl.indexOf('underMaintenance') >= 0) {
          return;
        }

        var serverHack = '/web/smb/bss';
        if (settings.isLocal) {
          serverHack = '';
        }

      };

      $scope.selectAccount = function (val) {
        $scope.selectedAccount = val;
        if ($rootScope.ao.accountActive.accountNumber !== null && $rootScope.ao.accountActive.accountNumber !== $scope.selectedAccount.accountNumber) {
          $scope.changeAccount();
        }
      };

      //switch account
      $scope.changeAccount = function () {
        linkedMessageId = null;
        notificationBannerService.cleanBanner('linkedMessage');
        // Update indexes of active user account and permissions
        // appState.aoUpdateIndexes($scope.selectedAccount.accountNumber);
        appState.aoUpdateActiveObjects($scope.selectedAccount.accountNumber);

        // Update selection and store it into a cookie
        $rootScope.ao.accountActive = $scope.selectedAccount;
        $scope.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
        $scope.btnStatus = $window.btnStatus;

        $rootScope.selectedAccount = $scope.selectedAccount.accountNumber;
        localStorage.setLocalStorageValue('accountNumber', $scope.selectedAccount.accountNumber);
        localStorage.setLocalStorageValue('accountTypeNumber', $scope.selectedAccount.accountTypeNumber);
        appState.tagging(['_trackLink', {eVar7: $scope.selectedAccount.accountNumber}, {event17: ''}]);
        $scope.loadingDataIndicator = true;

        $scope.getAccountDetails($scope.selectedAccount, userLanguage(), false);
        if ($scope.selectedAccount.accountTypeNumber !== 9) {
          $scope.getBalanceDetails($scope.selectedAccount, userLanguage(), false);
        }
        getRewards($scope.selectedAccount);

        $state.current.data._preConditions.accountNumber = $scope.selectedAccount.accountNumber;

        /*getBriteBillList();*/

        // Look into  non_angular_script/supportFunctions.js  for more information
        scrollPageToTop();					// jshint ignore:line
      };

      $scope.postToRogersCancelled = function () {
        $('#formToRogers').attr('action', settings.formsURL + '/web/myrogers/viewBill' + '?setLanguage=' + userLanguage());
        $('#formToRogers').submit();
      };

      $scope.payBill = function () {
        //localStorage.setLocalStorageValue('accountTypeNumber', $scope.selectedAccount.accountTypeNumber);
        ////appState.switchView('paynow/' + $scope.selectedAccount.accountNumber + '/' + $scope.selectedAccount.accountTypeNumber);

        // Look into  non_angular_script/supportFunctions.js  for more information
        scrollPageToTop();     // jshint ignore:line
        appState.switchView('/paynow');
      };

      $scope.viewHistory = function () {
        localStorage.setLocalStorageValue('accountTypeNumber', $scope.selectedAccount.accountTypeNumber);
        ////appState.switchView('paynow/' + $scope.selectedAccount.accountNumber + '/' + $scope.selectedAccount.accountTypeNumber);
        appState.switchView('/paymenthistory');
      };

      $scope.runRogersProfile = function () {
        var linkTorogersl = settings.formsURL + '/web/RogersServices.portal?_nfpb=true&_pageLabel=ManageMyOnlineProfile_beta&setLanguage=' + userLanguage();
        $window.location.href = linkTorogersl;
      };

      $scope.getBalanceDetails = function (selectedAccount, language, isRefresh) {

        $scope.loadingBalance = true;
        $scope.disableBalance = true;

        var request = {
          accountNumber: selectedAccount.accountNumber,
          accountTypeNumber: selectedAccount.accountTypeNumber,
          pinNumber: selectedAccount.pinNumber,
          phoneNumber: selectedAccount.phoneNumber,
          language: language,
          refresh: isRefresh || false,
          indx: selectedAccount.selectedAccountIndex,
          applicationId: 'Rogers.com'
        };

        var balanceDetailsResponse = function (_tmp) {
          //errorMessages.balanceDetails = null;

          if (_tmp.result === 'success') {
            $scope.disableBalance = false;
            if (!$scope.accountDetails) {
              $scope.accountDetails = {accountBalance: {}};
            }

            $scope.accountDetails.accountBalance = _tmp.data;
            $rootScope.$broadcast('changedAccount');
            if (!$scope.$$phase) {
              $scope.$apply();
            }

            if ($scope.accountDetails.accountBalance !== undefined) {
              $scope.isCLM = (Number($scope.accountDetails.accountBalance.creditLimit) > 0);
              $scope.isCLMExceeded = $scope.accountDetails.accountBalance.exceedCreditLimit;
              selectedAccount.isCLM = $scope.isCLM;
              selectedAccount.isCLMExceeded = $scope.isCLMExceeded;
            }

          } else {
            //errorMessages.balanceDetails = resource.get('acc_overview_oops');

          }
          errorMessageCheck();
          $scope.loadingBalance = false;
          $scope.disableBalance = false;
        };

        accountOverviewService.getBalanceDetails(request, balanceDetailsResponse);

      };

      function convertDate(date) {
        //date = "2015-06-01";
        var _date = date.split('-');
        // _date[0] - year, _date[1] - month, _date[2] - day
        var _dateObj = new Date(_date[0], _date[1] - 1, _date[2]);
        var day = _dateObj.getDate();
        day++;
        var _months = resource.get('_months');
        var month = _months[_dateObj.getMonth()];
        if (userLanguage() === 'en') {
          date = month + ' ' + day + ', ' + _dateObj.getFullYear();
        } else {
          date = day + ' ' + month + ' ' + _dateObj.getFullYear();
        }
        return date;
      }

      function getBriteBillList() {

        $scope.loadingBriteBill = true;
        $rootScope.briteBillFailed = false;
        accountOverviewService.britebill = null;
        accountOverviewService.briteBillError = null;

        var currentAccNumber = '';
        if (!$rootScope.ao && !$rootScope.ao.accountActive && !$rootScope.ao.accountActive.accountNumber) {
          return;
        } else if ($rootScope.ao) {
          if ($rootScope.ao.accountActive === null) {
            return;
          }
        } else if ($rootScope.ao && $rootScope.ao.accountActive && !$rootScope.ao.accountActive.accountNumber) {
          return;
        }

        $rootScope.ao.britebill = null;
        $rootScope.bbpermission = false;

        currentAccNumber = $rootScope.ao.accountActive.accountNumber;
        var bbrequest = {
          'currentAccNumber': currentAccNumber,
          'applicationId': 'MyAccount'
        };
        accountOverviewService.getBrtSwitches(function (_temp) {

          if (_temp.result === 'success') {

            if (_temp.data.length > 0) {
              for (var i = 0; i < _temp.data.length; i++) {
                if (_temp.data[i].id === 'BRITEBILL_UTE') {
                  if (_temp.data[i].switchIsOn) {
                    $rootScope.bbpermission = true;
                  }
                }
              }
            }

            if ($rootScope.bbpermission) {
              accountOverviewService.getBriteBill(bbrequest, function (_tmp) {

                if (_tmp.result === 'success') {

                  if (_tmp.data.encryptedString) {
                    var headerData = {'EncryptedToken': _tmp.data.encryptedString};
                    var data = {
                      'appID': 'MyAccount'
                    };

                    accountOverviewService.getBriteBillListOfBills(data, headerData, function (_tmp2) {

                      if (_tmp2.result === 'success') {
                        if (_tmp2.data && _tmp2.data.bills && _tmp2.data.bills.length > 0) {
                          var bills = _tmp2.data.bills;
                          bills.sort(function (a, b) {
                            //Dates are iso std YYYY-MM-DD
                            var c = new Date(a.issue_date);// jshint ignore:line
                            var d = new Date(b.issue_date);// jshint ignore:line
                            return d - c;
                          });
                          $rootScope.briteBillInvoiceDates = '';
                          for (var i = 0; i < bills.length; i++) {
                            bills[i].name = convertDate(bills[i].issue_date); // jshint ignore:line
                            bills[i].id = bills[i].issue_date; // jshint ignore:line

                            if ($rootScope.briteBillInvoiceDates) {
                              $rootScope.briteBillInvoiceDates += "," + bills[i].issue_date; // jshint ignore:line
                            } else {
                              $rootScope.briteBillInvoiceDates += bills[i].issue_date;// jshint ignore:line
                            }
                          }
                          if (bills.length > 0) {
                            $scope.briteBillOldestDate = bills[bills.length - 1].name;
                            $rootScope.isbritebillAvailable = true;
                          }
                          $rootScope.ao.britebill = bills;
                          accountOverviewService.britebill = bills;
                          $scope.loadingBriteBill = false;
                        } else {
                          // no bills
                          $rootScope.ao.britebill = undefined;
                          $scope.loadingBriteBill = false;
                          if (typeof(_tmp2.data == 'string')) {
                            accountOverviewService.briteBillError = briteBillServerLogs.briteBillError + _tmp2.data;
                          } else {
                            accountOverviewService.briteBillError = briteBillServerLogs.briteBillError + 'no bills';
                          }
                        }
                      } else {
                        $scope.loadingBriteBill = false;
                        if (_tmp2.result === 'fail') {
                        } else if (_tmp2.result === 'error') {
                          $rootScope.briteBillFailed = true;

                        } else {
                          // Unknown state ???
                        }
                      }
                    });
                  } else {
                    $scope.loadingBriteBill = false;
                  }
                } else {
                  $scope.loadingBriteBill = false;
                  if (_tmp.result === 'fail') {

                  } else if (_tmp.result === 'error') {
                    $rootScope.briteBillFailed = true;
                  } else {
                    // Unknown state ???
                  }
                }
              });
            } else {
              $scope.loadingBriteBill = false;
            }
          } else {
            $scope.loadingBriteBill = false;
            if (_temp.result === 'fail') {

            } else if (_temp.result === 'error') {
              $rootScope.briteBillFailed = true;
            } else {
              // Unknown state ???
            }
          }
        });
      }

      function getRewards(selectedAccount) {
        $scope.loadingRewards = true;
        errorMessages.loyalty = null;

        var rewardsResponse = function (data) {

          errorMessages.loyalty = (data && data.result === 'fail') ? resource.get('acc_overview_loyalty_error') : null;

          $scope.loadingRewards = false;
        };

        accountOverviewService.getRewards(selectedAccount.accountNumber, selectedAccount.language, rewardsResponse);
      }

      //update the banner message when language changes
      function updateMessage() {
        if ($scope.myOtherServicesListFinal) {
          for (var xx = 0; xx < $scope.myOtherServicesListFinal.length; xx++) {
            var unit = $scope.myOtherServicesListFinal[xx];
            if (unit.updateRogersBank) {
              unit.link = ' https://www.rogersbank.com/' + userLanguage();
            }
          }
        }

        if (!!linkedMessageId) {
          notificationBannerService.sendMessageKey('linkedMessage', linkedMessageId);
        }
        if (!!$scope.errorKey) {
          $scope.errorMessage = resource.get($scope.errorKey);
        }
        $scope.suspendedSubscriptionMessage = resource.get('_suspended_service');
      }

      function updateSuccessMessage() {
        if (!successMsgIdFromStorage) {
          notificationBannerService.cleanBanner('successMessage');
        } else {
          notificationBannerService.sendMessageKey('successMessage', successMsgIdFromStorage);
        }
      }

      successMsgIdFromStorage = localStorage.getLocalStorageValue('successMessage');
      if (successMsgIdFromStorage) {
        localStorage.deleteLocalStorageValue('successMessage');
        if (!(!!linkedMessageId)) {
          updateSuccessMessage();
        }
      }

      resource.onChanged(function () {
        if ($scope.selectedAccount) {
          $scope.selAccountStatusError = accountOverviewService.getAccountStatus($scope.selectedAccount).accountStatusError;
        }

        updateMessage();
        updateSuccessMessage();
      }, $scope);

      //update details if receive the flag.
      $scope.$on('detailExpired', function (newVal, oldVal) {
        // make sure that the $rootScope.ao.accountDetails is not null (default / initial state)
        if ($scope.adExpired === true) {
          $scope.getAccountDetails($scope.selectedAccount, userLanguage(), true);
          if ($scope.selectedAccount.accountTypeNumber !== 9) {
            $scope.getBalanceDetails($scope.selectedAccount, userLanguage(), true);
          }
          getRewards($scope.selectedAccount);
        }
      }, true);

      $scope.$watch('accountTypes', function (newVal, oldVal) {
      }, true);

      // Link modal with the page through event broadcast.
      $rootScope.$on('updateAccountOverview', function (data) {
        if (!$rootScope.ao.accountActive) {
          return false;
        }
        var modalSelected = localStorage.getLocalStorageValue('accountNumber');
        if (!$scope.selectedAccount || (modalSelected !== $scope.selectedAccount.accountNumber)) {


          // Take data from localstorage and update few things
          //appState.aoUpdateIndexes(modalSelected );
          appState.aoUpdateActiveObjects(modalSelected);
          // From updated rootScope proceed to update of the page
          //$scope.selectedAccount = $rootScope.ao.accountActive; //Use $scope.accountTypes, not accountActive for selectedAccount (account list combobox dependency)
          $scope.selectedAccount = $.grep($scope.accountTypes, function (e) {
            return e.accNo === modalSelected;
          })[0];
          $scope.changeAccount();
          $rootScope.$$listeners.updateAccountOverview = [];
        }

      });

      if (appState.afterPaymentRefresh) {
        appState.afterPaymentRefresh = false;
        $window.location.reload(true);
      }

      $scope.getAccountList();
      //getBriteBillList();
      $scope.getMaintenanceSettings();

      // User needs to link account
      if (appState.isLinked) {
        linkedMessageId = 'linked_acc_success';
        updateMessage();
        accountOverviewService.clearAccountDetails();

        appState.isLinked = false;
      }
    }]);
'use strict';

/**
 * @ngdoc function
 * @name totesApp.controller:forgotPasswordCtrl
 * @description
 * # forgotPasswordCtrl
 * Controller of the totesApp
 */

angular.module('totesApp')
  .controller('oneViewInterfaceCtrl', ['$scope', 'ajax', 'resource', 'appState', 'errorHandler', '$element', '$rootScope', 'settings', '$window',
    function ($scope, ajax, resource, appState, errorHandler, $element, $rootScope, settings, $window) {
      var requestURI = $window.location.href;
      var keyValues = '';
      var queryString = requestURI.split('?');
      if (queryString.length > 1) {
        var params = queryString[1].split('=');
        if (params[1] === settings.oneViewErrorCodes.sspSSOFailure ||
          params[1] === settings.oneViewErrorCodes.crmSSOFailure ||
          params[1] === settings.oneViewErrorCodes.sspAccessFailure ||
          params[1] === settings.oneViewErrorCodes.crmAccessFailure) {

          $scope.isSSOFailure = true;
        } else if (params[1] === settings.oneViewErrorCodes.sessionTimeout) {
          $scope.isSessionTimeOut = true;
        } else {
          $scope.isGenericError = true;
        }
      } else {
        $scope.isGenericError = true;
      }

    }]);

'use strict';

angular.module('totesApp')
		.controller('permissionDeniedCtrl', ['$scope', 'settings',
			function ($scope, settings) {

			}]);


'use strict';

angular.module('totesApp')
		.run(["$rootScope", "appState", "agentSession", "localStorage", "settings", "$browser", "$window", function ($rootScope, appState, agentSession, localStorage, settings, $browser, $window) {
		  var cookies = $browser.cookies();
			var userType = cookies.userType;
    var foreseeLang = cookies.language;

    var foreseeLocale = foreseeLang + '_CA';
    var _domain = $window.location.hostname.replace('www', '');

    $window.document.cookie = 'locale=' + foreseeLocale + ';domain=' + _domain + ';path=' + '/';
			if(userType) {
        if(userType === settings.userType.dealer && ! $rootScope.userInfo) {
            agentSession.startAgentSession();
        } else if(userType === settings.userType.care){
            agentSession.renewCareSession();
        }
    }
    
  }]);


'use strict';

angular.module('totesApp')
  .config(["$provide", function ($provide) {

    $provide.decorator('$exceptionHandler',['$delegate', '$injector',   function ($delegate, $injector) {
      return function (exception) {
        /*
         EvalError: Raised when the eval() functions is used in an incorrect manner.
         RangeError: Raised when a numeric variable exceeds its allowed range.
         ReferenceError: Raised when an invalid reference is used.
         SyntaxError: Raised when a syntax error occurs while parsing JavaScript code.
         TypeError: Raised when the type of a variable is not as expected.
         URIError: Raised when the encodeURI() or decodeURI() functions are used in an incorrect manner.
         Example:
         switch (exception.name) {
         case 'ReferenceError':

         break;
         case 'TypeError':

         break;
         }
         */

/*
        // Manual error throwing - This Error handler can only receive a string. And therefore for more information to be passed in
        // objects have to converted into a string.
        // Example below.

        var testObj = {};
        testObj.message = 'User cannot continue to accountOverview';
        testObj.id = 42;
        var testJSON = angular.toJson(testObj);

        throw new Error(testJSON);
//*/

/*
        var user = $injector.get('user');
        if (!user.isLoggedIn) {
          user.logout();
        }
//*/

        /*
         var stack = exception.stack.split('\n');
         var moduleName = stack[1];
         */
        function getDateTime() {
          var now     = new Date();
          var year    = now.getFullYear();
          var month   = now.getMonth()+1;
          var day     = now.getDate();
          var hour    = now.getHours();
          var minute  = now.getMinutes();
          var second  = now.getSeconds();

          month = (month.toString().length === 1) ? '0'+month : month;
          day = (day.toString().length === 1) ? '0'+day : day;
          hour = (hour.toString().length === 1) ? '0'+hour : hour;
          minute = (minute.toString().length === 1) ? '0'+minute : minute;
          second = (second.toString().length === 1) ? '0'+second : second;

          var dateTime = year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second;
          return dateTime;
        }

        var appState = $injector.get('appState');
        var $rootScope = $injector.get('$rootScope');
        var $location = $injector.get('$location');

        $rootScope.errorsStack = $rootScope.errorsStack || [];


       // var stack = (exception.stack) ? exception.stack.split('\n') : {};
        var url = $location.absUrl();
        var dateTime = getDateTime();


        var accountInfo = {
          'accountNumber': ($rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountNumber : undefined,
          'accountTypeNumber': ($rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountTypeNumber : undefined,
          'accountStatus': ($rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountStatus : undefined,
          'accountStatusSimple': ($rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountStatusSimple : undefined
        };

        //angular.copy($rootScope.ao.accountActive, accountInfo);

        var systemInfo = {
          appCodeName: navigator.appCodeName,
          appName: navigator.appName,
          appVersion: navigator.appVersion,
          cookieEnabled: navigator.cookieEnabled,
          platform: navigator.platform,
          userAgent: navigator.userAgent
        };

        var exceptionObject = {
          'dateTime': dateTime,
          'url': url,
          //'account': accountInfo,
          'systemInfo': systemInfo
        };

        if ($location.path() !== '/oops') {
          $rootScope.errorsStack.push(exceptionObject);
        }

        //$delegate(exception);
      };

    }]);

  }]);

'use strict';
// Filter to change decimal point into comma for french numbers
angular.module('totesApp').
  filter('bilingualnumber', ['$filter', 'userLanguage', function($filter, userLanguage) {
    return function(input, scope) {
      var value     = $filter('number')(input,2),
          language  = userLanguage();
      if (value && language !== 'en'){
        value = value.replace('.',',');
      }
      return value;
    };
  }]);

'use strict';

angular.module('totesApp').
  filter('capitalize', function() {
    return function(input, scope) {
	    if (input  && input.length > 0) {
	    	input = input.toLowerCase();
	    	return input.substring(0,1).toUpperCase()+input.substring(1);
	    } else {
	    	return;
	    }
	  };
  });
 


'use strict';

angular
  .module('totesApp')
  .filter('centsWithDecimal', ["userLanguage", function (userLanguage) {
    return function (input, showDefault) {
      if (!input) {
        if(showDefault) {
          return '00';
        } else {
          return '';
        }
      }

      if(input === 0) {
        if(showDefault) {
          return '00';
        } else {
          return '';
        }
      }

      var inputRemainder = parseFloat(input) % 1;
      var costInCents = inputRemainder.toFixed(2).substring(1);

      return costInCents;
    };
  }]);

'use strict';

angular
  .module('totesApp')
  .filter('currencies', ["currenciesConfig", function (currenciesConfig) {
    return function (input, lang, prefixOverride, deci) {

      var default_input = 0;
      var default_deci = 2;
      var default_lang = 'en';

      input = (typeof input === 'undefined') ? default_input : input;
      deci = (typeof deci === 'undefined') ? default_deci : deci;
      lang = (typeof lang === 'undefined') ? default_lang : lang;

      var prefix = (lang === 'en' && prefixOverride) ? prefixOverride : null;

      if (isNaN(input*1)) {
        return currenciesConfig.format(lang, input, prefix);
      }else{

        var pow = Math.pow(10, deci);
        var amt = parseFloat(Math.round(input * pow) / pow).toFixed(deci);

        return currenciesConfig.format(lang, amt, prefix);
      }

    };
  }]);

'use strict';

angular.module('totesApp').
  filter('date2',['resource', 'userLanguage', function (resource) {
    return function (input, delimiter, separator, yearPrefix, aryOrder) {

      var monthsNames = resource.get('_months');
      var months = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
        Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
      };

      function formatMonthCheck(val){
        if(val === 0){
          return monthsNames[months[arrDate[val]]];
        }else{
          return arrDate[val];
        }
      }

      if (!input) {
        return '';
      }

      var arrDate = input.split(delimiter);

      return (formatMonthCheck(aryOrder[0]) +
      separator + formatMonthCheck(aryOrder[1]) +
      separator + yearPrefix + formatMonthCheck(aryOrder[2]));

    };
  }]);

'use strict';

angular.module('totesApp').
  filter('date3',[ function () {
    return function (input) {

      var nextbilldaysuntil = '';
      if (input) {
        var stringArray = input.split('-');

        var months = {
          'Jan': 0,
          'Feb': 1,
          'Mar': 2,
          'Apr': 3,
          'May': 4,
          'Jun': 5,
          'Jul': 6,
          'Aug': 7,
          'Sep': 8,
          'Oct': 9,
          'Nov': 10,
          'Dec': 11
        };

        var dueMonth = months[stringArray[0]];
        var dueDay = parseInt(stringArray[1]);
        var dueYear = parseInt(stringArray[2]) + 2000;

        var nextBillDate = new Date(dueYear, dueMonth, dueDay, 0, 0, 0, 0);

        var currectDate = new Date();
        nextbilldaysuntil = ' ' + Math.floor((nextBillDate - currectDate) / 86400000);
      } else {
        nextbilldaysuntil = 'N/A';
      }

      return nextbilldaysuntil;
    };
  }]);

'use strict';

angular
  .module('totesApp')
  .filter('decimals', ["$filter", "currenciesConfig", function ($filter,currenciesConfig) {
    return function (input,lang) {

      if(input){

        input = $filter('number')(input, 2);

        var langDec = currenciesConfig.getProperty(lang,'decimalDelimiter');
        var pos = input.toString().indexOf(langDec);

        if(pos > -1){
          return (langDec+input.toString().substr(pos+1,input.length)).toString();
        }else{
          return (langDec+'00').toString();
        }
      }


    };
  }]);

'use strict';

angular
  .module('totesApp')
  .filter('dollarsOnly', ["userLanguage", function (userLanguage) {
    return function (input, showDefault) {
      if (!input) {
        if(showDefault) {
          return '0';
        } else {
          return '';
        }
      }

      if(input === 0) {
        if(showDefault) {
          return '0';
        } else {
          return '';
        }
      }

      return parseInt(input);
    };
  }]);

'use strict';

angular.module('totesApp').
  filter('escapeHtml', function() {
  	return function(text) {
//	console.log('text:' + text);
	    if (text) {
//	console.log('text:' + text);
	    return text.
	        replace(/&/g, '&amp;').
	        replace(/</g, '&lt;').
	        replace(/>/g, '&gt;').
	        replace(/'/g, '&#8216;').
	        replace(/'/g, '&#8217;');
		  }
		  return '';
		};
  });
 


'use strict';

angular.module('totesApp')
  .filter('floor', function() {
    return function(n) {
      return Math.floor(n);
    };
  });

/*
 Converts kiloBytes to GB if over 1000MB
 Converts kiloBytes to MB if under 1000MB
 */

// <div>
// 	<span>1 gb: </span><span>{{ 1048576 | mbOrGB }}</span>
// </div>
// <div>
// 	<span>1 mb: </span><span>{{ 1024 | mbOrGB }}</span>
// </div>
// <div>
// 	<span>less than 1 gb: </span><span>{{ 1048575 | mbOrGB }}</span>
// </div>
// <div>
// 	<span>less than 1 mb: </span><span>{{ 1023 | mbOrGB }}</span>
// </div>
// <div>
// 	<span>half gb: </span><span>{{ 524288 | mbOrGB }}</span>
// </div>
// <div>
// 	<span>1.2 gb: </span><span>{{ 1258291.2 | mbOrGB }}</span>
// </div>

'use strict';

angular
        .module('pricePlanChanges')
        .filter('mbOrGbUnit', function () {
          return function (kiloBytes, language) {
            var mbUnit = language === 'en' ? 'MB' : 'MO';
            var gbUnit = language === 'en' ? 'GB' : 'GO';

            // Return empty string if kiloBytes is NaN
            if (isNaN(parseFloat(kiloBytes)) || !isFinite(kiloBytes)) {
              return '';
            }

            // Return megabytes if zero so we can display 0 MB, as mbOrGbValue will return a zero
            if (kiloBytes === 0) {
              return mbUnit;
            }

            if (kiloBytes / 1024 >= 1024) {
              return gbUnit;
            } else {
              return mbUnit;
            }
          };
        })
        .filter('mbOrGbValue', function () {
          return function (kiloBytes) {
            // Return empty string if kiloBytes is NaN
            if (isNaN(parseFloat(kiloBytes)) || !isFinite(kiloBytes)) {
              return '';
            }

            // Return zero if zero
            if (kiloBytes === 0) {
              return '0 ';
            }

            if (kiloBytes / 1024 >= 1024) {
              var gb = kiloBytes / 1048576;
              var gbRound = gb.toFixed(2);

              return gbRound + ' ';
            } else {
              var mb = kiloBytes / 1024;
              var mbRound = Math.floor(mb);

              return mbRound + ' ';
            }
          };
        })
        .filter('mbOrGbValueStr', ['userLanguage', 'resource',
          function (userLanguage, resource) {
            return function (value) {
              if (value) {
                var result = '';
                
                if (value !== 'Not Applicable') {
                  var language = userLanguage();
                  var mbUnit = language === 'en' ? 'MB' : 'MO';
                  var gbUnit = language === 'en' ? 'GB' : 'GO';
                  if (value.indexOf(mbUnit) > 0) {
                    value = value.replace(/\..+$/, '');
                    result = value + ' ' + mbUnit;
                  }
                  if (value.indexOf(gbUnit) > 0) {
                    value = value.replace(/\..+$/, '');
                    result = value + ' ' + gbUnit;
                  }
                } else {
                  result = resource.get('ppc_not_applicable');
                }
                return result;
              }
            };
          }]);

'use strict';

angular.module('totesApp').
	// split a phone number and add THREE dashes 416-555-5656
	filter('phone', function () {
		return function (input) {

			if (!input) {
				return '';
			}

			// int -> string + cleanup
			var inputStr = input.toString().trim().replace(/^\+/, '');

			// Split
			var area = inputStr.slice(0, 3);
			var trip = inputStr.slice(3, 6);
			var quad = inputStr.slice(6);

			// Pretty phone number
			var retVal = area +'-'+ trip +'-'+ quad;

			return (retVal);
		};
	}).
	// split a phone number and add TWO dashes 416 555-5656
  filter('phone2', function() {
    return function (input) {

      if (!input) {
        return '';
      }

      // int -> string + cleanup
      var inputStr = input.toString().trim().replace(/^\+/, '');

      // Split
      var area = inputStr.slice(0, 3);
      var trip = inputStr.slice(3, 6);
      var quad = inputStr.slice(6);

      // Pretty phone number
      var retVal =  area + ' ' + trip + '-' + quad;

      return (retVal);
    };
  }).
  // split a phone number and add TWO dashes (416)555-5656
  filter('phone3', function() {
    return function (input) {

      if (!input) {
        return '';
      }

      // int -> string + cleanup
      var inputStr = input.toString().trim().replace(/^\+/, '');

      // Split
      var area = inputStr.slice(0, 3);
      var trip = inputStr.slice(3, 6);
      var quad = inputStr.slice(6);

      // Pretty phone number
      var retVal =  '(' + area + ') ' + trip + '-' + quad;

      return (retVal);
    };
  });


'use strict';

angular.module('totesApp').
  filter('replace', function () {
    return function (input,_replace, _with) {
      if (!!input) {
        return input.replace(_replace, _with);
      } else {
        return;
      }
    };
  });

'use strict';

//try not used 'res' filter, because it cause slower performance, as angularjs 's dirty
//checking always evaluate filter, so that cause unnecessary computation
angular.module('totesApp')
    .filter('res', ['resource', function (resource) {
        return function (resourceKey) {
            return resource.get(resourceKey);
        };
    }]);

'use strict';

angular.module('totesApp').
	filter('trustHtml', ["$sce", function ($sce) {
		return function (input) {
      return $sce.trustAs('html', input);
		};
	}]);

'use strict';
var omnp = omnp || [];
window.addOmnp=function(options){
  try {
    omnp.push(options);
  } catch (e) {
    console.error("Error adding OMNP " + e );
  }
};

'use strict';

angular.module('totesApp').run(['$rootScope', function ($rootScope) {

    angular.extend($rootScope.constructor.prototype, {
        $extend: function (extension) {
            angular.extend(this, extension);
            return this;
        }
    });

}]);

/**
 * Created by OlgaN on 9/14/2015.
 */
/* UAParser.js
 * Lightweight JavaScript-based User-Agent String Parser */
// jshint ignore: start
'use strict';
 (function (window, undefined) {

  var LIBVERSION = '0.7.1', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv';
  var util = {
    extend: function (regexes, extensions) {
      for (var i in extensions) {
        if ('browser cpu device engine os'.indexOf(i) !== -1 && extensions[i].length % 2 === 0) {
          regexes[i] = extensions[i].concat(regexes[i])
        }
      }
      return regexes
    }, has: function (str1, str2) {
      if (typeof str1 === 'string') {
        return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1
      }
    }, lowerize: function (str) {
      return str.toLowerCase();
    }
  };
  var mapper = {
    rgx: function () {
      for (var result, i = 0, j, k, p, q, matches, match, args = arguments; i < args.length; i += 2) {
        var regex = args[i], props = args[i + 1];
        if (typeof result === UNDEF_TYPE) {
          result = {};
          for (p in props) {
            q = props[p];
            if (typeof q === OBJ_TYPE) {
              result[q[0]] = undefined
            } else {
              result[q] = undefined
            }
          }
        }
        for (j = k = 0; j < regex.length; j++) {
          matches = regex[j].exec(this.getUA());
          if (!!matches) {
            for (p = 0; p < props.length; p++) {
              match = matches[++k];
              q = props[p];
              if (typeof q === OBJ_TYPE && q.length > 0) {
                if (q.length == 2) {
                  if (typeof q[1] == FUNC_TYPE) {
                    result[q[0]] = q[1].call(this, match)
                  } else {
                    result[q[0]] = q[1]
                  }
                } else if (q.length == 3) {
                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                    result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined
                  } else {
                    result[q[0]] = match ? match.replace(q[1], q[2]) : undefined
                  }
                } else if (q.length == 4) {
                  result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined
                }
              } else {
                result[q] = match ? match : undefined
              }
            }
            break;
          }
        }
        if (!!matches)
          break;
      }
      return result
    }, str: function (str, map) {
      for (var i in map) {
        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
          for (var j = 0; j < map[i].length; j++) {
            if (util.has(map[i][j], str)) {
              return i === UNKNOWN ? undefined : i
            }
          }
        } else if (util.has(map[i], str)) {
          return i === UNKNOWN ? undefined : i
        }
      }
      return str
    }
  };
  var maps = {
    browser: {
      oldsafari: {
        major: {1: ['/8', '/1', '/3'], 2: '/4', '?': '/'},
        version: {
          '1.0': '/8',
          1.2: '/1',
          1.3: '/3',
          '2.0': '/412',
          '2.0.2': '/416',
          '2.0.3': '/417',
          '2.0.4': '/419',
          '?': '/'
        }
      }
    },
    device: {
      amazon: {model: {'Fire Phone': ['SD', 'KF']}},
      sprint: {model: {'Evo Shift 4G': '7373KT'}, vendor: {HTC: 'APA', Sprint: 'Sprint'}}
    },
    os: {
      windows: {
        version: {
          ME: '4.90',
          'NT 3.11': 'NT3.51',
          'NT 4.0': 'NT4.0',
          2000: 'NT 5.0',
          XP: ['NT 5.1', 'NT 5.2'],
          Vista: 'NT 6.0',
          7: 'NT 6.1',
          8: 'NT 6.2',
          8.1: 'NT 6.3',
          RT: 'ARM'
        }
      }
    }
  };
  var regexes = {
    browser: [[/(opera\smini)\/((\d+)?[\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/((\d+)?[\w\.-]+)/i, /(opera).+version\/((\d+)?[\w\.]+)/i, /(opera)[\/\s]+((\d+)?[\w\.]+)/i], [NAME, VERSION, MAJOR], [/\s(opr)\/((\d+)?[\w\.]+)/i], [[NAME, 'Opera'], VERSION, MAJOR], [/(kindle)\/((\d+)?[\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?((\d+)?[\w\.]+)*/i, /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?((\d+)?[\w\.]*)/i, /(?:ms|\()(ie)\s((\d+)?[\w\.]+)/i, /(rekonq)((?:\/)[\w\.]+)*/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron)\/((\d+)?[\w\.-]+)/i], [NAME, VERSION, MAJOR], [/(trident).+rv[:\s]((\d+)?[\w\.]+).+like\sgecko/i], [[NAME, 'IE'], VERSION, MAJOR], [/(yabrowser)\/((\d+)?[\w\.]+)/i], [[NAME, 'Yandex'], VERSION, MAJOR], [/(comodo_dragon)\/((\d+)?[\w\.]+)/i], [[NAME, /_/g, ' '], VERSION, MAJOR], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?((\d+)?[\w\.]+)/i, /(uc\s?browser|qqbrowser)[\/\s]?((\d+)?[\w\.]+)/i], [NAME, VERSION, MAJOR], [/(dolfin)\/((\d+)?[\w\.]+)/i], [[NAME, 'Dolphin'], VERSION, MAJOR], [/((?:android.+)crmo|crios)\/((\d+)?[\w\.]+)/i], [[NAME, 'Chrome'], VERSION, MAJOR], [/version\/((\d+)?[\w\.]+).+?mobile\/\w+\s(safari)/i], [VERSION, MAJOR, [NAME, 'Mobile Safari']], [/version\/((\d+)?[\w\.]+).+?(mobile\s?safari|safari)/i], [VERSION, MAJOR, NAME], [/webkit.+?(mobile\s?safari|safari)((\/[\w\.]+))/i], [NAME, [MAJOR, mapper.str, maps.browser.oldsafari.major], [VERSION, mapper.str, maps.browser.oldsafari.version]], [/(konqueror)\/((\d+)?[\w\.]+)/i, /(webkit|khtml)\/((\d+)?[\w\.]+)/i], [NAME, VERSION, MAJOR], [/(navigator|netscape)\/((\d+)?[\w\.-]+)/i], [[NAME, 'Netscape'], VERSION, MAJOR], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?((\d+)?[\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/((\d+)?[\w\.-]+)/i, /(mozilla)\/((\d+)?[\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf)[\/\s]?((\d+)?[\w\.]+)/i, /(links)\s\(((\d+)?[\w\.]+)/i, /(gobrowser)\/?((\d+)?[\w\.]+)*/i, /(ice\s?browser)\/v?((\d+)?[\w\._]+)/i, /(mosaic)[\/\s]((\d+)?[\w\.]+)/i], [NAME, VERSION, MAJOR]],
    cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[ARCHITECTURE, 'ia32']], [/windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [[ARCHITECTURE, /ower/, '', util.lowerize]], [/(sun4\w)[;\)]/i], [[ARCHITECTURE, 'sparc']], [/(ia64(?=;)|68k(?=\))|arm(?=v\d+;)|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [[ARCHITECTURE, util.lowerize]]],
    device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i], [MODEL, VENDOR, [TYPE, TABLET]], [/applecoremedia\/[\w\.]+ \((ipad)/], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [/(apple\s{0,1}tv)/i], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [/(hp).+(touchpad)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [MODEL, VENDOR, [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);/i], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/\((bb10);\s(\w+)/i], [[VENDOR, 'BlackBerry'], MODEL, [TYPE, MOBILE]], [/android.+((transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7))/i], [[VENDOR, 'Asus'], MODEL, [TYPE, TABLET]], [/(sony)\s(tablet\s[ps])/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(nintendo)\s([wids3u]+)/i], [VENDOR, MODEL, [TYPE, CONSOLE]], [/((playstation)\s[3portablevi]+)/i], [[VENDOR, 'Sony'], MODEL, [TYPE, CONSOLE]], [/(sprint\s(\w+))/i], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [/(Lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i], [[VENDOR, 'Lenovo'], MODEL, [TYPE, TABLET]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, /(zte)-(\w+)*/i, /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [/\s((milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?))[\w\s]+build\//i, /(mot)[\s-]?(\w+)*/i], [[VENDOR, 'Motorola'], MODEL, [TYPE, MOBILE]], [/android.+\s((mz60\d|xoom[\s2]{0,2}))\sbuild\//i], [[VENDOR, 'Motorola'], MODEL, [TYPE, TABLET]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n8000|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-n900))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i, /sec-((sgh\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [/(sie)-(\w+)*/i], [[VENDOR, 'Siemens'], MODEL, [TYPE, MOBILE]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]+)*/i], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [/android\s3\.[\s\w-;]{10}((a\d{3}))/i], [[VENDOR, 'Acer'], MODEL, [TYPE, TABLET]], [/android\s3\.[\s\w-;]{10}(lg?)-([06cv9]{3,4})/i], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [/(lg) netcast\.tv/i], [VENDOR, [TYPE, SMARTTV]], [/((nexus\s[45]))/i, /(lg)[e;\s\/-]+(\w+)*/i], [[VENDOR, 'LG'], MODEL, [TYPE, MOBILE]], [/android.+((ideatab[a-z0-9\-\s]+))/i], [[VENDOR, 'Lenovo'], MODEL, [TYPE, TABLET]], [/linux;.+((jolla));/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/(mobile|tablet);.+rv\:.+gecko\//i], [[TYPE, util.lowerize], VENDOR, MODEL]],
    engine: [[/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [NAME, VERSION], [/rv\:([\w\.]+).*(gecko)/i], [VERSION, NAME]],
    os: [[/microsoft\s(windows)\s(vista|xp)/i], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*|windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [/\((bb)(10);/i], [[NAME, 'BlackBerry'], VERSION], [/(blackberry)\w*\/?([\w\.]+)*/i, /(tizen)\/([\w\.]+)/i, /(android|webos|palm\os|qnx|bada|rim\stablet\sos|meego)[\/\s-]?([\w\.]+)*/i, /linux;.+(sailfish);/i], [NAME, VERSION], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i], [[NAME, 'Symbian'], VERSION], [/\((series40);/i], [NAME], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[NAME, 'Firefox OS'], VERSION], [/(nintendo|playstation)\s([wids3portablevu]+)/i, /(mint)[\/\s\(]?(\w+)*/i, /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk)[\/\s-]?([\w\.-]+)*/i, /(hurd|linux)\s?([\w\.]+)*/i, /(gnu)\s?([\w\.]+)*/i], [NAME, VERSION], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[NAME, 'Chromium OS'], VERSION], [/(sunos)\s?([\w\.]+\d)*/i], [[NAME, 'Solaris'], VERSION], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i], [NAME, VERSION], [/(ip[honead]+)(?:.*os\s*([\w]+)*\slike\smac|;\sopera)/i], [[NAME, 'iOS'], [VERSION, /_/g, '.']], [/(mac\sos\sx)\s?([\w\s\.]+\w)*/i], [NAME, [VERSION, /_/g, '.']], [/(haiku)\s(\w+)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i, /(macintosh|mac(?=_powerpc)|plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos)/i, /(unix)\s?([\w\.]+)*/i], [NAME, VERSION]]
  };
  var UAParser = function (uastring, extensions) {
    if (!(this instanceof UAParser)) {
      return new UAParser(uastring, extensions).getResult()
    }
    var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
    var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
    this.getBrowser = function () {
      return mapper.rgx.apply(this, rgxmap.browser)
    };
    this.getCPU = function () {
      return mapper.rgx.apply(this, rgxmap.cpu)
    };
    this.getDevice = function () {
      return mapper.rgx.apply(this, rgxmap.device)
    };
    this.getEngine = function () {
      return mapper.rgx.apply(this, rgxmap.engine)
    };
    this.getOS = function () {
      return mapper.rgx.apply(this, rgxmap.os)
    };
    this.getResult = function () {
      return {
        ua: this.getUA(),
        browser: this.getBrowser(),
        engine: this.getEngine(),
        os: this.getOS(),
        device: this.getDevice(),
        cpu: this.getCPU()
      }
    };
    this.getUA = function () {
      return ua
    };
    this.setUA = function (uastring) {
      ua = uastring;
      return this
    };
    this.setUA(ua)
  };
  UAParser.VERSION = LIBVERSION;
  UAParser.BROWSER = {NAME: NAME, MAJOR: MAJOR, VERSION: VERSION};
  UAParser.CPU = {ARCHITECTURE: ARCHITECTURE};
  UAParser.DEVICE = {
    MODEL: MODEL,
    VENDOR: VENDOR,
    TYPE: TYPE,
    CONSOLE: CONSOLE,
    MOBILE: MOBILE,
    SMARTTV: SMARTTV,
    TABLET: TABLET
  };
  UAParser.ENGINE = {NAME: NAME, VERSION: VERSION};
  UAParser.OS = {NAME: NAME, VERSION: VERSION};
  if (typeof exports !== UNDEF_TYPE) {
    if (typeof module !== UNDEF_TYPE && module.exports) {
      exports = module.exports = UAParser
    }
    exports.UAParser = UAParser;
  } else {
    window.UAParser = UAParser;
    if (typeof define === FUNC_TYPE && define.amd) {
      define(function () {
        return UAParser;
      })
    }
    var $ = window.jQuery || window.Zepto;
    if (typeof $ !== UNDEF_TYPE) {
      var parser = new UAParser;
      $.ua = parser.getResult();
      $.ua.get = function () {
        return parser.getUA()
      };
      $.ua.set = function (uastring) {
        parser.setUA(uastring);
        var result = parser.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop]
        }
      }
    }
  }
})(this);

var semafoneParameters = {
  en:'Credit Card Number',
  fr:'Num&#233;ro de carte de cr&#233;dit',
  semafoneUrl: '',
  semafoneMode: '',
  gatewayId:'',
  methodId:'',
  ppUserId:'',
  ppPassword:'',
  tenantId:'',
  clientId:'',
  accountId:'',
  principle:'',
  licenseCode:'',
  transactionType:'',
  responseType:'',
  responseURL:''
};
'use strict';

/*
$('.numbersOnly').keypress(function (e) {
    if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  }
);
//*/


function augment(prototype, extension) {
    for (var key in extension) {
        if (!prototype[key]) {
            prototype[key] = extension[key];
        }
    }
}

augment(Array.prototype, {

    contains: function (item) {
        return (this.indexOf(item) !== -1);
    },

    remove: function (item) {
        var position = this.indexOf(item);
        if (position !== -1) {
            this.splice(position, 1);
        }
        return this;
    },

    removeItems: function (items) {
        for (var i = 0; i < items.length; i++) {
            this.remove(items[i]);
        }
        return this;
    },

    removeAt: function (index) {
        this.splice(index, 1);
        return this;
    },

    pushUnique: function (item) {
        if (!this.contains(item)) {
            this.push(item);
        }
        return this;
    },

    merge: function (items) {
        if (items && items.length) {
            for (var i = 0; i < items.length; i++) {
                this.pushUnique(items[i]);
            }
        }
        return this;
    },

    //it can be sortObject()
    //sortObject(by)
    //asc is by default true
    sortObject: function (by, asc) {
        if (angular.isUndefined(asc)) {
            if (angular.isUndefined(by)) {
                asc = true;
                by = undefined;
            } else {
                if (angular.isString(by)) {
                    asc = true;
                } else {
                    asc = by;
                    by = undefined;
                }
            }
        }

        if (by) {
            this.sort(function (a, b) {
                var av = a[by];
                var bv = b[by];
                if (av === bv) {
                    return 0;
                }
                return  asc ? (av > bv) ? 1 : -1 :
                    (av > bv) ? -1 : 1;
            });
        } else {
            //Expected an assignment or function call and instead saw an expression.
            /*jshint -W030 */
            asc ? this.sort() : this.sort().reverse();
        }
        return this;
    },

    //this compare content of two array
    //[1, 2, 3].equalTo([3, 2, 1]) will be true
    equalTo: function (items) {
        if (this.length === items.length) {
            for (var i = 0; i < this.length; i++) {

                if (!items.contains(this[i])) {
                    return false;
                }
            }
            return true;

        } else {
            return false;
        }
    },

    //for example,
    //a = [1, 2, 3], b = [3, 4], c = [4, 5]
    //b.hasAnyInsideOf(a) ==> true
    //c.hasAnyInsideOf(a) ==> false
    hasAnyInsideOf: function (items) {
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (this.contains(item)) {
                return true;
            }
        }
        return false;
    }
});

var rSupplant = /\{([^\{\}]*)\}/g;

augment(String.prototype, {

    startsWith: function (text) {
        return this.indexOf(text) === 0;
    },

    endsWith: function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    },

    contains: function (text) {
        return this.indexOf(text) !== -1;
    },


    supplant: function (obj) {
        return this.replace(rSupplant,
            function (a, b) {
                var r = obj[b];
                return typeof r ? r : a;
            });
    },

    format: function () {
        var source = this;
        $.each(arguments, function (index, value) {
            source = source.replace(new RegExp('\\{' + index + '\\}', 'g'), value);
        });
        return source;
    },

    looseEqual: function (str) {
        return ( str && this.length ) ?
            this.toUpperCase() === str.toUpperCase() :
            this === str;
    }
});

'use strict';

function scrollPageToTop () {
	// plain jquey page scroll to top.  (Could be animated)

//	setTimeout(function () {			// Enable tiout ONLY if really really needed
		window.scrollTo(0, 0);			// jshint ignore:line
		$(window).scrollTop;			// jshint ignore:line
//	}, 100);
}

function nullOrEmpty(value) {
  return (value === null || value === '');
}

function replace(value, target, replacement) {
  if (nullOrEmpty(value)) {
    return value;
  }
  return value.replace(target, replacement);
}

function smUrlDecode(value) {

  // This URL decoding is specific to SiteMinder
  // Some details may be found here
  // https://communities.ca.com/thread/100358666
  // http://cookbooks.ca.com/casiteminder/?p=27

  value = replace(value, /%20/g, ' ');
  value = replace(value, /%26/g, '&');
  value = replace(value, /%2b/g, '+');
  value = replace(value, /%3f/g, '?');
  value = replace(value, /%3d/g, '=');
  value = replace(value, /%2f/g, '/');
  value = replace(value, /%2e/g, '.');
  value = replace(value, /--/g, '-');
  value = replace(value, /-SM-HTTPS/i, 'https');
  value = replace(value, /%3a/, ':');
  value = replace(value, /%24/g, '$');

  return value;
}

function scrollToAnchor(hash) {
    location.hash = '#' + hash;
}

'use strict';

angular.module('totesApp').factory('AppError', function () {

    //new AppError("50001"); //by default isPlainText is false
    //new AppError(true, "Unexpected error just happened"
    function AppError(isPlainText, resourceId) {
        this.name = 'AppError';

        if (angular.isString(isPlainText)) {
            resourceId = isPlainText;
            isPlainText = false;
        }
        this.message = resourceId;
        this.isPlainText = isPlainText;

    }

    AppError.prototype = Error.prototype;
    return AppError;
});
'use strict';

// document can be found at
// http://projects.rogersnpd.com:8090/display/TOT/API+Documentation

angular.module('totesApp')
  .factory('ajax', ['backend', '$browser', 'settings', '$http', '$log', '$q', 'localStorage',
    function(backend, $browser, settings, $http, $log, $q, localStorage) {
      // Initiate Object
      var ajax = {};
      var killSwitchTrigger = 10;

      ajax.discardAllSmCookiesKillSwitch = 0;
      ajax.notifyServerDiscardSMCookiesKillSwitch = 0;
      ajax.discardLoginSmCookiesKillSwitch = 0;

      return {
        resetKillSwitches : function() {
          ajax.discardAllSmCookiesKillSwitch = 0;
          ajax.notifyServerDiscardSMCookiesKillSwitch = 0;
          ajax.discardLoginSmCookiesKillSwitch = 0;
        },
        disassociateAccount : function(data) {
          return backend.post('SelfServeAutomation/disassociateAccount', data, true);
        },
        updatePinEmail : function(data) {
          // return
          // backend.post('SelfServeAutomation/updatePinEmail',
          // data, true);
          return backend.post('SelfServeAutomation/setAddrContLang', data, true);
        },
        updateBillingType : function(data) {
          return backend.post('SelfServeAutomation/updateBillingType', data, true);
        },
        updateUserInfo : function(data) {
          return backend.post('SelfServeAutomation/manageMyOnlineProfile', data, true);
        },
        updateContactInformation : function(data) {
          // return
          // backend.post('SelfServeAutomation/updateContactInformation',
          // {}, true);
          return backend.post('SelfServeAutomation/setAddrContLang', data, true);
        },
        updateServiceAddress : function() {
          return backend.post('SelfServeAutomation/updateServiceAddress', {}, true);
        },
        updateBillingAddress : function() {
          return backend.post('SelfServeAutomation/updateBillingAddress', {}, true);
        },
        updateMarketingPermissions : function(mktPermObj) {
          return backend.post('SelfServeAutomation/updateMarketingPermissions', mktPermObj, true);
        },
        updateCredentials : function() {
          return backend.post('SelfServeAutomation/updateCredentials', {}, true);
        },
        getUserInfo : function() {
          return backend.post( 'SelfServeAutomation/manageMyOnlineProfileQuery', false);
        },
        setAddressContLang : function(obj) {
          return backend.post('SelfServeAutomation/setAddrContLang', obj, true);
        },
        getMarketingPermissions : function(obj) {
          return backend.post('SelfServeAutomation/getMarketingPermissions', obj, true);
        },
        getProfilePageInfo : function() {
          return backend.post('check.html', {
            'ban' : '453532863',
            'ctn' : '6043511037',
            'accountNumber' : '453532863'
          }, true);
        },
        getErrorMessages : function() {
          return backend.get('/web/smb/cms/selfserve/errorMessages.json');
        },
      getUccLinks : function() {
        return backend.get('/web/smb/cms/ucc/links.json');
      },

        getAuthorizedLocally : function(userName, password) {
          return backend.post('testlogin', { email : userName, password : password});
        },
        register : function(regObj) {
          return backend.post('profile', regObj);
        },
        agentInfo : function() {
          return backend.post('agentInfo');
        },
        signin : function(userName, password) {
          // var requestObj = {
          //   USER : userName,
          //   password : password,
          //   SMAUTHREASON : '0',
          //   target : settings.postSigninUrl
          // };
          // return backend.postFormData('signin',requestObj);
          return $q.when({
            valid: true,
            statusCode: 200
          });
        },
        pagePermission : function(url) {
          return backend.post('', {pageURL : url});
        },
        getSecurityQuestionSetup  : function(){
          /*var request = {
           USERNAME : username,
           PASSWORD: password
           };*/
          return backend.post('getSecurityQuestion');
        },

        updateSecurityQuestionSetup : function(questionId, answer) {
          var requestObj = {
            securityQuestion : questionId,
            securityAnswer : answer
          };
          return backend.postFormData('updateSecurityQuestion', requestObj);
        },
        invokeEnterpriseTokenApi : function(activeWirelessAccountList, uniqueIDVal, xReqIdVal ){
            var profileInfo = {
                guid : $browser.cookies()['guid'],
                userId : $browser.cookies()['userToken'],
                email : $browser.cookies()['userToken'],
                lang : $browser.cookies()['language'],
                uniqueID : uniqueIDVal,
                cookieExpiry : 10080
            };
            var profileObj =  { profile : profileInfo };
            var requestObj = {
                content : profileObj,
                accounts : activeWirelessAccountList,
                accountsThreshold : 6
            };
            var headersList ={
                "x-request-id" : xReqIdVal ,
                "x-app-name" :"UTESMBOnline",
                "realm" :"ROGERS"
            }
            var options = { withCredentials : true, headers : headersList};
            console.log(angular.toJson(requestObj));
            $http.get("/web/smb/cms/selfserve/authorizeConfigData.json").then(
               function (response) {
                  if (response.data) {
                      var envName = settings.prodEnvName;
                      if (settings.isDevMBH) {
                         envName = settings.devEnvName;
                      } else if (settings.isQaMBH) {
                         envName = settings.qaEnvName;
                      }
                      var configData = response.data[envName];
                      var inaEnterpriseTokenApiUrl = configData.inaEnterpriseTokenApi;
            					//var inaEnterpriseTokenApiUrl ="https://qa1x-mservices.rogers.com/v1/user/oidcSession/enterprise/6402b93d-8c00-49f5-b7bc-96c75bc781ae";
                      $http.post(inaEnterpriseTokenApiUrl, requestObj,options ).then(
                         function (response) {
            									console.log("success");
                         },
                         function (error) {console.log("failure");}
                      );
                  }
               },
               function (error) {console.log("failure in json call"); });
        },
        tempPassword : function(username, password, newpassword, confirmation, smtoken, smauthreason, smagentname) {
          var requestObj = {
            PASSWORD : password,
            NEWPASSWORD : newpassword,
            CONFIRMATION : confirmation,
            SMTOKEN : smtoken,
            USERNAME : username,
            SMAUTHREASON : smauthreason,
            SMAGENTNAME : smagentname,
            TARGET : settings.postSigninUrl,
            SMQUERYDATA : '',
            POSTPRESERVATIONDATA : ''
          };
          return backend.postFormData('tempPassword', requestObj);
        },
        getMaintenanceSettings : function(postData) {
          return backend.post('maintenanceSettings', postData);
        },
        getBillingDetail : function(postData) {
          // accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          var data = backend.post('accountoverview/billingDetails', postData);
          return data;
        },
        getBalance : function(postData) {
          // accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          var data = backend.post('accountoverview/balance', postData);
          return data;
        },

        getUserDetails : function(postData) {
          var data = backend.post('profile/getUserDetails', postData);
          return data;
        },

        saveOrderSearch : function(postData, url) {

          var request = {
            guid: $browser.cookies().guid,
            ban: localStorage.getLocalStorageValue('accountNumber'),
            ctn: postData.ctn,
            firstName: localStorage.getLocalStorageValue('fName'),
            lastName: localStorage.getLocalStorageValue('lName'),
            email: $browser.cookies().userToken,
            language: $browser.cookies().language,
            portalId: "BSSS",
            refId: postData.refId,
            orderType: postData.orderType
          };

          return backend.postUsingAbsoluteUrl(url, request, false, {'Content-Type': 'application/json'});
        },

        getAccountList : function(postData, oldApi) {
          // accountoverview
          // return backend.post('accounts',
          // postData);
          // if (oldApi) {
          // return backend.post('accounts',
          // postData);
          // }
          return backend.post('accountoverview', postData);
        },
        checkReserveDevice : function() {
          var request = {
              province: $browser.cookies().province,
              activityTypeKey: "NAC",
              planCategory: "" ,
              dealerCode: "EGT01",
              applicationId: "SMB"
          };
          return backend.post('checkReserveDevice', request);
        },
        getAccountDetail : function(postData, oldApi) {
          // accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          // var data =
          // backend.post('accounts/detail',
          // postData);
          var data;
          // if (oldApi) {
          // data = backend.post('accounts/detail',
          // postData);
          // } else {
          data = backend.post('accountoverview/summary', postData);
          // }
          return data;
        },
        getAccountDetailPrepaid : function(postData) {
          // accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          // var data =
          // backend.post('accounts/detail',
          // postData);
          var data = backend.post('accounts/detail', postData);
          return data;
        },
        getSecureQuestion : function(email) {
          return backend.post('profile/question', {username : email});
        },
        getRegisteredUserName : function(email) {
          return backend.post('forgot/username', {email : email});
        },
        forgetPassword : function(selectedAnswer, fn,cToken, email, attemts) {
          if (attemts > 1) {
            return backend.post('forgot/password/resubmit', {username : email, answer : selectedAnswer});
          }

          return backend.post('forgot/password', {answer : selectedAnswer, fn : fn, cToken : cToken});
        },
        validatelinkAccountInfo : function(postData) {
          return backend.post('account/validatelinkAccountInfo', postData);
        },
        linkAccount : function(postData) {
          return backend.post('account/linkAccount', postData);
        },
        linkPostPaidAccount : function(postPaidAccount) {
          return backend.post('linkAccount/postpaid', postPaidAccount);
        },
        linkPrepaidAccount : function(prepaidAccount) {
          return backend.post('linkAccount/prepaid', prepaidAccount);
        },
        getRewards : function(accountNo, language) {
          var passJson = {
            accountNumber : accountNo, // accountNo,
            language : language
          };
          return backend.post('accounts/loyalty', passJson);
        },
        getSegmentationForRGCL : function(postData) {
          var data;
          data = backend.post('accountoverview/getSegmentationForRGCL',postData);
          return data;
        },
        usernameMigration : function() {
          return backend.post('usernameMigration/check', {});
        },
        getEmail : function() {
          return backend .post( 'usernameMigration/getEmail', { username : $browser.cookies().userName });
        },
        updateUsername : function(email) {
          return backend .post('usernameMigration/updateUsername', {username : $browser.cookies().userName, email : email});
        },
        getBillingType : function(accountNumber) {
          return backend.post('SelfServeAutomation/getBillType', {accountNumber : accountNumber});
        },
        // PPC Check Eligibility Calls
        singleLineIdentity : function(accountNumber, ctn) {
          return backend.post('wirelessPricePlanChange/SingleLineIdentity', {accountNumber : accountNumber, ctn : ctn});
        },

        hupEligibility : function(accountNumber, ctn, loyaltyStatus) {
          return backend.post('wirelessPricePlanChange/HupEligibility',
            {
              accountNumber : accountNumber,
              ctn : ctn,
              loyaltyStatus : loyaltyStatus
            });
        },

        // make a payment
        /* make a payment with a credit card */
        getSignature : function(accountNumber) {
          return backend.post('signature', {accountNumber : accountNumber});
          // return backend.post('signature', { });
        },
        getToken : function(paymentServerUrl) {
          return backend.jsonp(paymentServerUrl);
        },
        decryptToken : function(accountNumber, token, iin, rc, ccType) {
          var requestObj = {
            accountNumber : accountNumber,
            encryptedToken : token,
            bin : iin,
            result : rc,
            creditCardType : ccType
          };
          return backend.post('payment/decrypt',requestObj);
        },
        payNow : function(creditPaymentObj, accountNumber, accountTypeNumber, subNumber, isConsolidated) {
          $log.debug(creditPaymentObj);
          var passJson = {
            accountNumber : accountNumber, // accountNo,
            accountTypeNumber : accountTypeNumber,
            amount : creditPaymentObj.paymentAmount,
            paymentMethod : 'CreditCard',
            subNumber : subNumber,
            consolidated : isConsolidated,
            'creditCardInfo.ccNumber' : creditPaymentObj.creditCardNo,
            'creditCardInfo.ccType' : creditPaymentObj.creditCardType.name,
            'creditCardInfo.ccExpiryMonth' : creditPaymentObj.expireDate.month,
            'creditCardInfo.ccExpiryYear' : creditPaymentObj.expireDate.year,
            'creditCardInfo.securityCode' : creditPaymentObj.securityCode
          };

          return backend .post('makePayment', passJson);
        },
        /* make a payment with interac */
        interacConfirm : function(accountNumber) {
          var requestObj = {
            accountNumber : accountNumber
          };
          return backend.post('interac/confirmationData', requestObj);
        },
        /* make a payment with interac */
        getSHMlink : function(accountNumber, url) {
          var requestObj = {
            serviceNumber : accountNumber
          };
          return backend.post('redirectionUrl', requestObj);
        },
        // call this method with the response from
        // interacEligibility directly.
        interacMakePayment : function(requestObj) {
          return backend.post('interac', requestObj);
        },
        billHistory : function(accountNumber, accountTypeNumber, index, pageSize) {

          var passJson = {
            accountId : accountNumber, // accountNo,
            accountType : accountTypeNumber,
            index : index,
            pageSize : pageSize
          };

          return backend.post('payment/history', passJson);
        },
        /**
         * change payment method requestObj - required
         * to complete the payment operation
         */

        setPaymentMethod : function(requestObj) {
          /*
           * var requestObj= { accountNumber:
           * accountNumber, accountTypeNumber:
           * accountTypeNumber, mopType: methodType,
           * 'creditCardInfo.ccNumber':
           * creditPaymentObj.creditCardNo,
           * 'creditCardInfo.ccType':
           * creditPaymentObj.creditCardType.name,
           * 'creditCardInfo.ccExpiryMonth':
           * creditPaymentObj.expireDate.month,
           * 'creditCardInfo.ccExpiryYear':
           * creditPaymentObj.expireDate.year,
           * 'creditCardInfo.securityCode':
           * creditPaymentObj.securityCode,
           * 'chequingInfo.bankNumber':
           * debitPaymentObj.bankCode,
           * 'chequingInfo.transitNumber':
           * debitPaymentObj.transitNo,
           * 'chequingInfo.accountNumber':
           * debitPaymentObj.accountNo,
           * 'phoneNumber':cableAccount.phoneNumber,
           * 'oldMopType':cableAccount.oldPaymentMethod,
           * 'email':cableAccount.email };
           */
          return backend.post( 'payment/updatePaymentMethod', requestObj);
        },
        // Wireless Dashboard

        /*
         * required params ban Account Number
         * 716942875(Wireless) ctn Phone Number
         * 4162780218
         */
        wirelessDashBoard : function(postData) {
          // postData.ban = 716942875;
          // postData.ctn = 4162780218;
          return backend.post('wirelessDashBoard', postData);
        },
        /*
         * required params ban Account Number
         * 716936547(Wireless) ctn Phone Number
         * 4168145924
         */
        wirelessPostpaid : function(postData) {
          // postData.ban = 716936547;
          // postData.ctn = '4168145000';
          return backend.post('wirelessDashBoard/postPaidDetails', postData);
        },
        interacEligibility : function(accountNumber, accountType, amountDue, amount) {
          var requestObj = {
            language : 'EN',
            accountNumber : accountNumber,
            accountTypeNumber : accountType,
            amountDue : amountDue,
            amount : amount
          };
          return backend.post('interac/getEligibility', requestObj);
        },
        /*
         * required params ctn Phone Number 4162780218
         */
        wirelessPrepaid : function(postData) {
          // postData.ctn = 4162780218;
          return backend.post('wirelessDashBoard/prepaidDetails', postData);
        },
        wirelessTravelPackageStaticContent : function(postData) {
          // postData.ban
          // postData.ctn
          return backend.post('wirelessDashBoard/rlh/staticContent', postData);
        },
        /*
         * required params ctn Phone Number 4162780218
         */
        wirelessTravelPackage : function(postData) {
          // postData.ban
          // postData.ctn
          return backend.post('wirelessDashBoard/rlh/getDetails', postData);
        },
        wirelessTravelPackageAddOnSummary : function(postData) {
          // postData.ban
          return backend.post('wirelessDashBoard/planAddOnSummary', postData);
        },
        /*
         * required params ctn Phone Number 4162780218
         */
        setwirelessTravelPackage : function(postData) {
          // postData.ban
          // postData.ctn
          // updateOptInOutFlag
          return backend.post('wirelessDashBoard/rlh/setDetails', postData);
        },
        /*
         * required params ctn Phone Number 4162780218
         */
        internetDashboard : function(accountNumber, language, ban) {
          var passJson = {
            accountNumber : accountNumber, // accountNo,
            language : language,
            ban : ban
          };

          return backend.post('internetDashBoard', passJson, 'internetdash');
        },
        internetDashboardUsage : function(accountNumber) {
          var passJson = {
            accountNumber : accountNumber,
            applicationId : 'Rogers.com'
          };
          return backend.post(
            'internetDashBoard/usage',
            passJson, 'internetdash');
        },
        internetDashboardProduct : function(accountNumber, refresh, userLang) {
          accountNumber = (accountNumber === undefined) ? 0
            : accountNumber;
          refresh = (refresh === undefined) ? false
            : refresh;
          var passJson = {
            accountNumber : accountNumber,
            applicationId : 'Rogers.com',
            refresh : refresh,
            language: userLang
          };
          return backend.post('internetDashBoard/productDetails', passJson, 'internetdash');
        },
        getCPRequestData : function(){
          return backend.post('getCPRequestData');
        },
        getMidMarketSAMLData : function(postData){
          return backend.post('getMidMarketSAMLData', postData);
        },
        tvDashboard : function(accountNumber, language, ban, refresh) {
          var passJson = {
            accountNumber : accountNumber, // accountNo,
            language : language.toLowerCase(),
            ban : ban,
            refresh : refresh
          };

          return backend.post('tvLanding', passJson);
        },
        
        loadIgniteInternetDashboard: function(accountNumber, language, requestFreshData) {
          var passJson = {
            customerBillingProfileID : accountNumber, // accountNo,
            language : language.toUpperCase(),
            refresh : requestFreshData
          };
          return backend.post('igniteInternetLanding', passJson);
        },

        loadIgniteTvDashboard: function(accountNumber, language, requestFreshData) {
          var passJson = {
            customerBillingProfileID : accountNumber, // accountNo,
            language : language.toUpperCase(),
            refresh : requestFreshData
          };
          return backend.post('igniteTVLanding', passJson);
        },

        businessPhoneDashboard : function(accountNumber, language, ban, refresh) {
          var passJson = {
            accountNumber : ban , // accountNo,
            language : language.toLowerCase(),
            subscriberNumber : accountNumber,
            applicationId : 'Rogers.com',
            refresh : refresh
          };

          return backend.post('iblcDashboard', passJson);
        },

        getUCCSubscriberList : function(ban) {
          var postData = {
            accountNumber : ban
          };
          return backend.post('subscriberListForBan', postData);

        },

        getWcocJwtToken : function() {
          var postData = {
            applicationId: 'Rogers.com'
          };
          return backend.post('wcoc/createjwttoken', postData);

        },

        decryptWcocJwtToken : function(token) {
          var postData = {
            applicationId: 'Rogers.com',
            token: token
          };
          return backend.post('wcoc/decryptjwttoken', postData);
        },

        getEnterpriseID : function(ban) {
          var postData = {
            ban : ban
          };
          return backend.post('getAccountUCCEnterpriseDetails', postData);

        },

        tvFeed : function() {
          return backend.post('tv-feed/contents', {});
        },
        /*
         * Data Eviction Notificaton calls
         */
        notifyServerPreredeem : function(postData) {
          // postData.accountNumber = 4162780218;
          return backend.post('maestro/preredeem',
            postData);
        },
        notifyServerLOBchange : function(postData) {
          // postData.accountNumber = 4162780218;
          return backend.post('accounts/lobprechange', postData);
        },
        notifyServerDeviceStatuschange : function(
          postData) {
          return backend.post('wirelessDashBoard/deviceStatusChange', postData);
        },
        notifyServerLoggedIn : function() {
          var loggedInRequest = {
            applicationId : "SMB"
          };
          return backend.post('loggedIn', loggedInRequest);
        },
        notifyServerLogout : function() {
          // return;
          if (ajax.discardAllSmCookiesKillSwitch < killSwitchTrigger) {
            ajax.discardAllSmCookiesKillSwitch++;
            return backend.post('discardLoginSmCookies', {});
          }
        },
        // notifyLegacyLogout: function () {
        // //return;
        // return backend.post('web/totesSignOut', {},
        // 'legacySignout');
        // // Removed after consultation with Prasanth
        // },
        notifyServerDiscardSMCookies : function() {
          if (ajax.notifyServerDiscardSMCookiesKillSwitch < killSwitchTrigger) {
            ajax.notifyServerDiscardSMCookiesKillSwitch++;
            return backend.post('discardAllSmCookies', {});
          }
        },
        notifyServerDiscardLoginSMCookies : function() {
          if (ajax.discardLoginSmCookiesKillSwitch < killSwitchTrigger) {
            ajax.discardLoginSmCookiesKillSwitch++;
            return backend.post('discardLoginSmCookies', {});

          }
        },
        notifyServerDiscardRBSSSessionId : function() {
          var notifyServerDiscardRBSSSessionIdRequest = {
            applicationId : 'Rogers.com'
          };
          return backend.post('discardRBSSCookies',notifyServerDiscardRBSSSessionIdRequest);
        },
        /*
         * required params currentAccNumber 123456789
         */
        getBriteBill : function(postData) {
          // postData.currentAccNumber
          return backend.post('encryptBritebill',
            postData);
        },
        getBriteBillListOfBills : function(postData,headerData) {
          return backend.post('briteBillList', postData, null, headerData);
        },
        getWolDates : function(postData) {
          return backend.post('getWinAvailableInvoices', postData);
        },
        winRegister : function(postData) {
          return backend.post('winRegister', postData);
        },
        checkEpost : function(postData) {
          return backend.post('checkEpostAccount', postData);
        },
        getEpostBill : function(postData) {
//          return backend.post('bills/epost', postData);
            return $q.when({});
        },
        getBulkDownloadBills : function(postData) {
          return backend.post('invoices/bulkDownload', postData);
        },
        subscribers: function (postData) {
          return backend.post('ppc/subscribers', postData);
        },
        checkEligibility: function (postData) {
          return backend.post('ppc/priceplans/eligibility', postData);
        },
        setState: function (postData) {
          //return backend.post('spa/state', postData, null, {'Content-Type': 'application/x-www-form-urlencoded'});
          return backend.post('spa/state', postData);
        },
        fetchOrder: function () {
          var fetchOrderRequestObj = {
            applicationId : "SMB"
          };

          return backend.post('buy/cart/fetch',fetchOrderRequestObj);
        },
        getPermissions : function() {
          return backend.post('permissions');
        },
        gethasPermissions : function(postData) {
         return backend.post('hasPermissions',postData);
         },
        getBrtSwitches : function() {
          return backend.post('brtSwitches');
        },
        geteSimreversechange: function(postdata) {
          return backend.post('esimreversechange',postdata);
        },
        geteSwapsimchange: function(postdata) {
          return backend.post('swapsimdetails',postdata);
        },
        geteSimtokengeneration : function(postdata) {
          return backend.post('esimtokendetails',postdata);
        },
        geteSimdevicedetails : function(postdata) {
          return backend.post('esimdevicedetails',postdata);
        },
        getreservseamlesseSim:function(postdata) {
          return backend.post('reservseamlesseSim',postdata);
        },
        getDetails:function(postdata) {
          return backend.post('getDetails',postdata);
        },
        abort : function() {
          return backend.abort();
        },
        checkProfileComplete : function() {
          return backend.post('profile/checkComplete');
        },
        verifyAddress : function(data) {
          return backend.post('SelfServeAutomation/verifyAddress', data);
        },
        updateSecurityQuestion : function(questionId, answer) {
          var requestObj = {
            questionId : questionId,
            answer : answer
          };
          return backend.postFormData('profile/updateSecurityQuestion', requestObj);
        },
        serverLog : function(data) {
          data.logLevel = 'INFO';
          return backend.post('log', data);
        },
        backToSSP : function(postData) {
          return backend.post('backToSSP', postData);
        },
        getEncryptNRSData : function(postData) {
          return backend.post('nrs/getPayload',
            postData);
        },
        getUsageData : function() {
          return backend.post('wirelessPricePlanChange/getUsageData');
        },
        getWinOnlineFlag : function(postData)  {
          return backend.post('view/winBill',postData)
        },
        checkBillType : function(postData)  {
          return backend.post('billType',postData)
        },
        legacyUpdateAccountInfo : function(postData)  {
          return backend.get("/business/ute/smb/transactions/uteUpdateAccountInfo");
        },
        changeBillType : function(postData)  {
          return backend.get("/business/BSS.portal?_nfpb=true&_st=&_windowLabel=portletInstance_46&_urlType=resource&_portlet.renderResource=true&_resId=changeBillType&_resca=cacheLevelPage&_rrparams=&_pageLabel=smb_ute_transactions_update_account_info&accountNumber=" + postData.accountNumber + "&targetBillType=electronic&_="+Date.now(), postData);
        },
        getBSSUrls: function () {
            return backend.get("/web/smb/cms/selfserve/otherPortalUrls.json");
        },
        encryptDMData : function(postData) {
          return backend.post('getEncryptToken', postData);
        },

//--->--->--->--->--->---> Added for BSS-SelveServe, 2015/10/16
        getPaymentHistory: function(){
          /*TEST*/return backend.getNullPromise();
        },
//<---<---<---<---<---<---
        getSelfserveConfig: function(){
          return backend.get("/cmsbusiness/json/config.json");
        },
        getPdEligibility: function(postData) {
          return backend.post('getPdEligibility', postData);
        },
        updatePdEligibility: function(postData) {
          return backend.post('updatePdWhitelist', postData);
        },
        getAccountListForTargeting: function(postData){
          return backend.post("customerbasedtargeting", postData);
        },
        getWinOnlineToken : function(postData) {
          return backend.post("getWinOnlineEncryptToken",postData);
        },
        updateUserPreferenceInfo : function(postData) {
          return backend.post("updateUserPreference",postData);
        },
        changeLanguage : function(postData) {
          return backend.post("profileMgmt/changeLanguage",postData);
        },
        getMigrationEligibleFlag : function(postData) {
          return backend.post("getMigrationEligibleFlag",postData);
        }
      };
    }
  ]);

'use strict';


angular
		.module('totesApp')
		.factory('appInterface', ['$location', '$rootScope', '$state', 'userLanguage', 'userProvince',
			function ($location, $rootScope, $state, userLanguage, userProvince) {

				// Initiate Object
				var appInterface = {};

				// hook up variables
				appInterface.data = {};
				appInterface.selectedLanguage = userLanguage();
				appInterface.selectedProvince = userProvince();
				appInterface.currentURLPath = '';
				appInterface.feedbackTabType = 'regular';

				// Various test function that will trigger outside functionality
				appInterface.fn = {};

				// Feedback tab on side vs. Britebill feedback tab
				appInterface.fn.feedbackTab = function (userPath) {
					appInterface.currentURLPath = userPath;

					if (typeof (setFeedbackTabState) === 'function') {						// jshint ignore:line
						var tabType = 'regular';

						if (typeof (getFeedbackTabURL) === 'function') {					// jshint ignore:line
							tabType = getFeedbackTabURL(userPath);							// jshint ignore:line
						}

						appInterface.feedbackTabType = tabType;
						appInterface.selectedLanguage = userLanguage();
						appInterface.selectedProvince = userProvince();

						var language = appInterface.selectedLanguage;
						var province = appInterface.selectedProvince;
						var customerId = '';

						setFeedbackTabState(tabType, language, province, customerId);		// jshint ignore:line
					}
				};

				// language change notification
				appInterface.fn.languageChange = function (language) {
					if (typeof (setFeedbackTabLanguage) === 'function') {					// jshint ignore:line
						setFeedbackTabLanguage(language, appInterface.feedbackTabType);		// jshint ignore:line
					}
				};

				// province change notification
				appInterface.fn.provinceChange = function (province) {
					if (typeof (setFeedbackTabProvince) === 'function') {										// jshint ignore:line
						setFeedbackTabProvince(province, appInterface.feedbackTabType, userLanguage());			// jshint ignore:line
					}
				};

				// main interaction functions (routing, custom event triggeres)
				// routing.js  ->  onEnter
				appInterface.stateEnter = function (toStatePath) {
					var userPath = (toStatePath === undefined) ? $location.path() : toStatePath;

					// Check function calls
					appInterface.fn.feedbackTab(userPath);
				};
				// routing.js  ->  onExit
				appInterface.stateExit = function (toStatePath) {
				};

				return appInterface;
			}
		]);


angular
		.module('totesApp')
		.provider('appInterfaceHandler', function () {
			var data;

			return {
				$get: function () {
					return data;
				},
				$set: function (value) {
					data = value;
				}
			};
		});
'use strict';

angular.module('totesApp')
  .factory('appState', ['$rootScope', '$window', '$location', '$translate', 'settings', 'userLanguage', 'confirmationDialog', '$state', 'webanalytics', '$browser', '$injector', 'localStorage', 'userProvince', 'janrainOidc', '$cookies', '$http', 'sessionStorage', '$timeout', '$cookieStore',
    function ($rootScope, $window, $location, $translate, settings, userLanguage, confirmationDialog, $state, webanalytics, $browser, $injector, localStorage, userProvince, janrainOidc, $cookies, $http, sessionStorage, $timeout, $cookieStore) {
      // Initiate Object
      var appState = {};

      // hook up variables
      appState.module = null;
      appState.submodule = null;

      var stateName = $state.current.name;

      appState.route = stateName || undefined;

      appState.isMobile = false; //for now only set to mobile, need a detection
      appState.newRegistration = false;
      appState.noLinking = false;
      appState.isLinked = false;
      appState.language = 'en';
      appState.savedPassword = null;
      appState.usernameChanged = false;
      appState.selectedAccount = null;
      appState.selectedAccountIndex = null;
      appState.afterPaymentRefresh = false;
      appState.modalPayNowOpened = false;
      appState.permissionsLoaded = false;
      appState.viewPermissionResolved = false;

      // hook up functions
      appState.getPaymentMethodOfSelectedAccount = function () {
        if (!appState.selectedAccount) {
          return;
        }
        var _modObject;
        switch (appState.selectedAccount.accountDetail.accountType) {
          //post-paid
          case 1:
            break;
            //pre-paid
          case 9:
            break;
          default:
            break;
        }
        return _modObject;
      };
      //analytic tagging, to add a tagging object into the global tagging array.
      appState.tagging = function (options) {
        $window.addOmnp(options);
      };

      //analytic tagging, tag a form field validation error
      appState.tagFieldValidationErrors = function (pageName, fieldName, errorObj) {
        if (!pageName || !fieldName || !errorObj) {
          return;
        }
        //set error type
        var errType = '',
          errMessage = '';
        if (errorObj === 1 || errorObj === 2) {
          errType = errorObj;
        } else {
          if (errorObj.required) {
            errType = 1;
          } else if (errorObj.pattern) {
            errType = 2;
          } else {
            $.each(errorObj, function (index, value) {
              errType = 3;
              errMessage = value;
            });
          }
        }

        if (errType > 0) {
          var msg = webanalytics.formatErrorMessage(pageName, fieldName, errType, errMessage);
          appState.tagging(['_trackLink', {
              eVar49: msg
            },
            {
              event15: ''
            } // Generic Error
          ]);
        }

      };

      //analytic tagging, tag all form validation errors
      appState.tagFormValidationErrors = function (pageName, errorObj) {

        if (!pageName || !errorObj) {
          return;
        }

        // Form is NOT valid, tag the errors
        var msg = '';
        var numRequiredErrors = (errorObj.required && errorObj.required.length) || 0;
        var numPatternErrors = (errorObj.pattern && errorObj.pattern.length) || 0;

        for (var i = 0; i < numRequiredErrors; i++) {

          msg = webanalytics.formatErrorMessage(pageName, errorObj.required[i].$name, 1, null);
          appState.tagging(['_trackLink',
            {
              eVar49: msg
            },
            {
              event15: ''
            } // Generic Error
          ]);
        }

        for (var j = 0; j < numPatternErrors; j++) {

          msg = webanalytics.formatErrorMessage(pageName, errorObj.pattern[i].$name, 2, null);
          appState.tagging(['_trackLink',
            {
              eVar49: msg
            },
            {
              event15: ''
            } // Generic Error
          ]);
        }
      };

      appState.alert = function (info) {
        confirmationDialog.alert(info);
      };

      appState.setConfirmation = function (options) {
        confirmationDialog.open(options);
      };

      appState.switchView = function (viewName) {
        var _targetView = viewName.charAt(0) !== '/' ? '/' : '',
          _targetParam;
        _targetView += viewName;

        //remember the selected account number for page refresh
        //$state.go(viewName);
        $location.path(_targetView);
      };

      appState.validateJSON = function (data) {
        //if data is null or a html page which returned by siteminder, it means user not signed in, so redirect to signin.
      };

      appState.redirectToSignIn = function () {
        $window.location.href = settings.postSignOutUrl;
      };

      appState.kickOutExpired = function () {
        // Non-Angular cookie grab
        var name = (localStorage.getLocalStorageValue('BSS_OCP_UTE') == "true") ? 'bss-info=' : 'SMSESSION=';
        var logOffcookie = '';
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            logOffcookie = c.substring(name.length, c.length);
          }
        }

        // Angular cookie grab
        if (logOffcookie === 'LOGGEDOFF') {
          // Do the user logout here
          var user = $injector.get('user');
          user.logout();

        } else {
          // You shall pass!!! ...  This time.
        }
      };

      /* RootScope handling */

      // Account list and permissions
      // Initial state
      appState.aoInitiate = function () {
        // Account overview
        $rootScope.ao = {};
        $rootScope.ao.raw = null;

        // User accounts list
        $rootScope.ao.allAccounts = null;
        $rootScope.ao.accountActive = null;
        $rootScope.ao.accountActiveIndex = null;
        $rootScope.ao.accountDetails = null;

        // All account permissions
        $rootScope.permissions = {};
        $rootScope.permissions.allPermissions = null;
        $rootScope.permissions.permissionActive = null;
        $rootScope.permissions.permissionActiveIndex = null;

        // All account permissions
        $rootScope.maintenance = {};

        // All user data / flags
        $rootScope.user = {};
        $rootScope.user.isAuthenticated = false;

        // Is user logged in?
        appState.userInitiate();
      };

      // User Data
      // Initial state
      appState.userInitiate = function () {
        var cookies = $browser.cookies();
        var serverID = "";
        if ($browser.cookies()['bss-info']) {
          serverID = $browser.cookies()['bss-info']
        } else {
          serverID = $browser.cookies().SMSESSION
        }
        var localID = cookies.SM_GUID;
        var userType = cookies.userType;

        if (serverID === 'LOGGEDOFF') {
          $rootScope.user.isAuthenticated = false;
        } else if (serverID || localID) {
          $rootScope.user.isAuthenticated = true;
        } else {
          $rootScope.user.isAuthenticated = false;
        }
        if (userType) {
          if (userType === settings.userType.dealer) {
            if ($rootScope.userInfo && $rootScope.userInfo.cfaInfo) {
              $rootScope.user.isAuthenticated = true;
            }
          } else if (userType === settings.userType.care) {
            $rootScope.user.isAuthenticated = true;
          }
        } else if (userType === settings.userType.care) {
          console.log('inside userInitiate if care:', userType);
          $rootScope.user.isAuthenticated = true;
        }

        if ($rootScope.user.isAuthenticated) {
          if ($rootScope.isServerLoggedIn != true) {
            var ajax = $injector.get('ajax');
            var signinService = $injector.get('myrSigninService');
            ajax.notifyServerLoggedIn().then(
              function (data) {
                // timing issue solution
                if (data == "success:true") {
                  signinService.mbhUrlConfig().then(function (urlResponse) {
                    var MBH_Redesign = localStorage.getLocalStorageValue('MBH_Redesign');
                    console.log("MBH_Redesign", MBH_Redesign);
                    $rootScope.mbhUrl = MBH_Redesign? urlResponse.dashboardNew : urlResponse.dashboard;
                    localStorage.setLocalStorageValue('MBHUrl', $rootScope.mbhUrl);
                  });
                  signinService.brtCheck().then(function (result) {
                    localStorage.setLocalStorageValue('BRT_SWITCHES', 'CALLED');
                    $rootScope.isServerLoggedIn = true;
                    if ($rootScope.mbhAccounts == 'undefined' && localStorage.getLocalStorageValue('accountNumber')) {
                      $rootScope.mbhAccounts = {
                        "accountList": [{
                          "accountNumber": localStorage.getLocalStorageValue("accountNumber")
                        }]
                      };
                    }
                    $rootScope.$emit('initializeMbhLauncher', $rootScope.mbhAccounts);
                  });
                  //changes for viewbill
                  ajax.getSelfserveConfig().then(
                    function (response) {
                      $rootScope.errorMsgBB = response.errorMessage;
                      $rootScope.upfrontAdvantageSocs = response.upFrontAdvantageSOCs;
                      if (response) {
                        if (response.invoice) {
                          localStorage.setLocalStorageValue('smbInvoiceMode', response.invoice);
                          $window.document.cookie = 'smbInvoiceMode=' + response.invoice + ';domain=' + '.rogers.com' + ';path=' + '/';
                        }
                      }
                      //check for business on this
                    },
                    function (error) {
                      //check for business on this
                    }
                  );
                } else {
                  var user = $injector.get('user');
                  user.clearCookies();
                  appState.aoFlushScope();
                  appState.switchView('signin');
                }
              },
              function (error) {
                // timing issue solution
                var user = $injector.get('user');
                user.clearCookies();
                appState.aoFlushScope();
                appState.switchView('signin');
              }
            );
          }
        }
      };

      // Clear to defaults
      appState.aoFlushScope = function () {
        // Destroy everything
        $rootScope.ao = null;
        $rootScope.permissions = null;
        $rootScope.maintenance = null;
        $rootScope.user = null;
        appState.aoInitiate();
      };
      // Update scope
      appState.aoUpdate = function () {
        // update one or all values of the Account Overview (User) related section

        // Is user logged in?
        appState.userInitiate();
      };
      appState.aoUpdateIndexes = function (accNo) {
        // Update active account indexes using account number => accNo
        $rootScope.ao.accountActiveIndex = this.findIndex(accNo, $rootScope.ao.allAccounts);
        $rootScope.permissions.permissionActiveIndex = this.findIndex(accNo, $rootScope.permissions.allPermissions);
        if (!$rootScope.permissions.allPermissions) {
          return;
        }
        $rootScope.permissions.permissionActive = $rootScope.permissions.allPermissions[$rootScope.permissions.permissionActiveIndex];
      };
      appState.aoUpdateActiveObjects = function (accNo) {
        // Make sure indexes are up-to-date
        this.aoUpdateIndexes(accNo);
        // Update active account indexes AND active accounts using account number => accNo
        $rootScope.ao.accountActive = $rootScope.ao.allAccounts[$rootScope.ao.accountActiveIndex];
        $rootScope.permissions.permissionActive = $rootScope.permissions.allPermissions[$rootScope.permissions.permissionActiveIndex];

        return $rootScope.ao.accountActiveIndex;
      };
      // Reconstruct scope
      appState.aoReconstruct = function (accountNumber) {
        // Grab info and make all necesary calls
        this.aoUpdateActiveObjects(accountNumber);
      };

      // Permissions related function - Look up specific permission flag for active account
      appState.permissionTo = function (flag) {
        // Look it up in flag list
        var returnVal = false;
        var permArray = [];

        try {
          permArray = $rootScope.permissions.permissionActive.permissions;
        } catch (e) {
          permArray = [];
        }

        if (permArray.length > 0) {
          var permObj = null;
          for (var i in permArray) {
            permObj = permArray[i];
            if (permObj.name === flag) {
              returnVal = true;
              break;
            }
          }
        }

        return returnVal;
      };

      //display the maintenance page when account list is not available.
      appState.showMaintenance = function () {
        if (!$rootScope.noAccountList) {

          $rootScope.noAccountList = true;
          $location.path('/underMaintenance');
          //$window.location.href = $window.location.origin + '/#/underMaintenance';
          setTimeout(function () {
            $window.location.reload();
          }, 1000);

        }
        return;
      };

      appState.checkMaintenance = function (pageName) {
        var result = false;
        if ($rootScope.maintenance[pageName] && $rootScope.maintenance[pageName] === 'true') {
          result = true;
        }
        return result;
      };

      // Maintenance related function - Look up value of maintanance flag based on current URL
      appState.maintenanceRedirect = function (url) {
        // Look it up in flag list
        var returnVal = null;

        // prep the URL for processing
        var urlArray = url.split('/');
        var keyWord = urlArray[1];

        var maintenance = $rootScope.altMaintenance || {};

        if (keyWord === 'wireless') {
          returnVal = maintenance.WIRELESS_ON_MAINTENANCE;

        } else if (keyWord === 'wirelessPrepaid') {
          returnVal = maintenance.WIRELESS_PREPAID_ON_MAINTENANCE;

        } else if (keyWord === 'internetdash') {
          returnVal = maintenance.INTERNET_ON_MAINTENANCE;

        } else if (keyWord === 'tvdashboard') {
          returnVal = maintenance.TV_ON_MAINTENANCE;

        } else if (keyWord === 'shmdashboard') {
          returnVal = maintenance.RSHM_ON_MAINTENANCE;

        } else if (keyWord === 'rhpc') {
          returnVal = maintenance.HOME_PHONE_ON_MAINTENANCE;

        } else if (keyWord === 'homephone') {
          returnVal = maintenance.HOME_PHONE_ON_MAINTENANCE;
        } else if (keyWord === 'accountOverview') {
          returnVal = maintenance.ACCOUNT_OVERVIEW_ON_MAINTENANCE;

        } else {
          // keep default value
        }

        return returnVal;
      };

      // Support functions
      appState.findIndex = function (activeNumber, objectArray) {
        // purpose of this is to find the index of the object in array using one of its properties
        var retVal = -1;
        if (objectArray === null) {
          // no data? why bother?
        } else {
          for (var i = 0; i < objectArray.length; i++) {
            if (objectArray[i].accountNumber === activeNumber) {
              retVal = i;
            }
          }
        }
        return retVal;
      };

      // Event watchers / transmitters
      //$rootScope.$on('$routeChangeSuccess', function (/*event, currentRoute, previousRout*/) {
      //
      //	//appState.module = $routeParams.module;
      //	//appState.submodule = $routeParams.submodule
      //});

      //on language change
      $rootScope.$on('resourceChanged', function () {
        appState.language = userLanguage();
      });

      // App state change

      //start
      $rootScope.$on('$stateChangeStart', function (evt, toState, toParams, fromState, fromParams) {
        localStorage.setLocalStorageValue('toStateName', toState.name);
        if ("easSuccess" == toState.name || "easError" == toState.name) {
          $rootScope.showHeaderFooter = false;
        } else {
          $rootScope.showHeaderFooter = true;
        }
        var keepAliveService = $injector.get('keepAliveService');
        keepAliveService.validateSession();
        if (!("signin" === toState.name)) {
			      sessionStorage.setSessionStorageValue("toDeepStateName", $location.url());
		    }else{
		      //signin redirect from apache and check error code if any
		      sessionStorage.deleteSessionStorageValue("toDeepStateName");
		      if($browser.cookies()["EAS_ERROR"]){
              console.log("failure from EAS " + $browser.cookies()["EAS_ERROR"]);
              setTimeout(function() {
                 $location.path('/easError');
              }, 500);
           return;
          }
          //Change password flow - easCode and consent_state cookie will have different value
          var consentCookie = $browser.cookies().CONSENT_STATE;
          var splitCookie = consentCookie.split('&');
          var codeValue;
          var stateValue;
          if (splitCookie && splitCookie.length > 0) {
          		codeValue = splitCookie[0].split('=');
          		stateValue = splitCookie[1].split('=');
          }
          var easCode =$browser.cookies()["easCode"];
          if($browser.cookies()['bss-info'] && (easCode !== codeValue[1])){
          	console.log("code values are not matching.. change password flow...");
            $window.document.cookie = 'easCode=' + codeValue[1] + ';domain=' + '.rogers.com' + ';path=' + '/';
            setTimeout(function() {
               $location.path('/easSuccess');
            }, 500);
            return;
          }
        }  //Change password flow - change end
        $translate.use(userLanguage());
        if (toState.url.indexOf("sso") !== -1 || (toState.name === "underMaintenance") || (toState.name === "frontline") ||(toState.name === "sohoIntercept") || (toState.name === "easSuccess") || (toState.name === "easError")) {
          console.log(toState.name);
        } else {
          if (!($browser.cookies()['bss-info'])) {
            if (!($browser.cookies().CONSENT_STATE)) {
              if (!(toState.name === "signin"))  {
                  var user = $injector.get('user');
                  user.clearCookies();
                  appState.aoFlushScope();
                  appState.switchView('signin');
              }
            } else {
              console.log("no bss-info --> yes CONSENT_STATE ");
              var UUIDNonce = localStorage.getLocalStorageValue('nonce');
              var urlPrefix = "/web/smb/api";
              var tokenData = {
                code: codeValue && codeValue.length > 0 && codeValue[1],
                state: stateValue && stateValue.length > 0 && stateValue[1],
                nonce: UUIDNonce
              };
              $window.document.cookie = 'easCode=' + codeValue[1] + ';domain=' + '.rogers.com' + ';path=' + '/';
              var authState = localStorage.getLocalStorageValue("state");
              if (stateValue && stateValue.length > 0 && authState === stateValue[1]) {
                $http.post(urlPrefix + "/business/v1/token", tokenData).then(function (response) {
                  var ajax = $injector.get('ajax');
                  var signinService = $injector.get('myrSigninService');
                  if ("signin" === toState.name && $browser.cookies()['easFlowTypeForState'] == "password") {
                    $location.path('/easSuccess');
                    return;
                  } else if ("signin" === toState.name && $browser.cookies()['easFlowTypeForState'] == "create") {
                    signinService.mbhUrlConfig().then(function(urlResponse){
                       $window.location.href = urlResponse.register+"?portal=bsss&registrationCompleted=true";
                    });
                    return;
                  }
                  ajax.notifyServerDiscardRBSSSessionId().then(function (rbssCookieDiscardData) {
                    $window.document.cookie = 'RBSS_ADMIN=' + "UTE" + ';domain=' + '.rogers.com' + ';path=' + '/';
                    var deeplinkStateName = sessionStorage.getSessionStorageValue('toDeepStateName');
                    appState.aoFlushScope();
                    if (deeplinkStateName) {
                      if (deeplinkStateName.includes('gotodatamanager')) {
                        signinService.mbhUrlConfig().then(function (urlResponse) {
                          $timeout(function () {
                            $cookieStore.remove('deepJSON');
                            var MBH_Redesign = localStorage.getLocalStorageValue('MBH_Redesign');
                            $window.location.href = (MBH_Redesign? urlResponse.dataManagerNew : urlResponse.dataManager) + "?redirectFrom=Email";
                          }, 2000);
                        });
                      } else if (deeplinkStateName.includes("sso") || (deeplinkStateName.includes("underMaintenance")) || (deeplinkStateName.includes("frontline")) || (deeplinkStateName.includes("easSuccess")) || (deeplinkStateName.includes("easError"))) {
                        appState.switchView('accountOverview');
                      } else {
                        $location.url(deeplinkStateName);
                      }
                    } else {
                      appState.switchView('accountOverview');
                    }
                  });
                });
              } else {
                var user = $injector.get('user');
                user.clearCookies();
                localStorage.clearAllLocalStorageValues();
                $window.location.href = $window.location.pathname;
              }
            }
          } else {
            if ($rootScope.statusFlag == false) {
              console.log("status initial status flag", $rootScope.statusFlag);
             //EAS changes to ignore refresh token and status calls
             //  keepAliveService.validateSession();
              $rootScope.statusFlag = true;
            }
            switch (toState.name) {
              case 'accountOverview':
              case 'migrateUser':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.overview;
                break;
              case 'guestOverview':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.guestoverview;
                break;
              case 'paynow':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'britebill':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                $rootScope.briteBillIframeCount = 0;
                break;
              case 'paymenthistory':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'self-serve':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.profile;
                break;
              case 'viewbill':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'viewInvoice':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'viewGroups':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'viewReporting':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'britebill':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'makeAPayment':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'changePayMethod':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'payHistory':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
                break;
              case 'profile':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.profile;
                break;
              case 'linkaccount':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
              case 'wireless':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
              case 'wirelessPrepaid':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
              case 'prepaidWireless':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
              case 'internetdash':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
              case 'tvdashboard':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
              case 'ignitetv':
                  $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                  break;
              case 'igniteInternet':
                  $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                  break;
              case 'businessphonedashboard':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
              case 'shmdashboard':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
              case 'oneViewDashboard':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.overview;
                break;
              case 'changesubscribername':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
              case 'resetvoicemailbox':
                $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
                break;
            }
          }
        }
      });

      // Success
      $rootScope.$on('$stateChangeSuccess', function (evt, toState, toParams, from, fromParams) {
        appState.prevState = from;
        $window.scrollTo(0, 0);
        if (toState.name !== 'britebill') {
          window.onpopstate = function (e) {}; // popstate cancelled
          $rootScope.briteBillHistoryCount = 0;
        }
        $rootScope.currentPageName = $window.location.href;
        $rootScope.currentStateName = toState.name;
        var hideSubMenuStates = ['underMaintenance', 'linkaccount', 'signin', 'tempPassword', 'forgotUserName', 'forgotPassword', 'registration',
          'rewards',
          'rewards.enroll',
          'rewards.redeem',
          'rewards.earn',
          'rewards.membership',
          'rewards.wishlist',
          'rewards.transactions',
          'rewards.transactions',
          'rewards.howitworks',
          'rewards.terms',
          'rewards.browse', 'oneViewInterface',
          'easSuccess', 'easError'
        ];
        $rootScope.hideSubMenu = (hideSubMenuStates.indexOf(toState.name) !== -1) ? true : false;

        var noAccounts = false;
        var accN = localStorage.getLocalStorageValue('accountNumber');

        if (!$rootScope.myServicesList && $rootScope.ao.accountActive && (toState.name !== 'accountOverview')) {
          var myrMyServicesService = $injector.get('myrMyServicesService');
          var request = {};
          // plain
          request = {
            accountNumber: $rootScope.ao.accountActive.accountNumber,
            accountTypeNumber: $rootScope.ao.accountActive.accountTypeNumber,
            language: userLanguage(),
            refresh: false,
            applicationId: 'Rogers.com'
          };

          // with other items in the call
          try {
            request.pinNumber = $rootScope.ao.accountActive.pinNumber;
          } catch (e) {}
          try {
            request.phoneNumber = $rootScope.ao.accountActive.phoneNumber;
          } catch (e) {}
          try {
            request.indx = $rootScope.ao.accountActiveIndex;
          } catch (e) {}

          myrMyServicesService.getAccountDetails(request, function (data) {
            if (data.result !== 'error') {
              $rootScope.ao.accountDetails = data.data;
              var res = myrMyServicesService.getSubscriptions($rootScope.ao.accountDetails.subList);
              $rootScope.myServicesList = (res && res.myServices) ? res.myServices : undefined;
            }
          });
        }
      });

      // Error
      $rootScope.$on('$stateChangeError', function (evt, to, toP, from, fromP, err) {});

      // Not found
      $rootScope.$on('$stateNotFound', function (evt, unfoundState, fromState, fromParams) {});

      // Page load events - Page loader / loading animation
      // Page load start
      $rootScope.$on('$viewContentLoading', function (evt, viewConfig) {
        // Access to all the view config properties.
        // and one special property 'targetView'
        // viewConfig.targetView
      });
      // Page load done and rendering is finished
      $rootScope.$on('$viewContentLoaded', function (evt) {
        // code here
      });

      // Not found
      $rootScope.$on('$stateNotFound', function (evt, unfoundState, fromState, fromParams) {});

      // Page load events - Page loader / loading animation
      // Page load start
      $rootScope.$on('$viewContentLoading', function (evt, viewConfig) {
        // Access to all the view config properties.
        // and one special property 'targetView'
        // viewConfig.targetView
      });
      // Page load done and rendering is finished
      $rootScope.$on('$viewContentLoaded', function (evt) {
        // code here
      });
      appState.getQueryStrings = function () {
        var keyValues = '';
        var queryString = $window.location.href.split('?');
        // Query string is now implemented for dealer and care
        //----- /web/totes/#/oneViewDashboard?lang=en&userType=dealer&prov=ON
        if (queryString.length > 1) {
          var oneviewError = $location.search().error;
          if (oneviewError === settings.oneViewErrorCodes.sspSSOFailure ||
            oneviewError === settings.oneViewErrorCodes.crmSSOFailure ||
            oneviewError === settings.oneViewErrorCodes.sspAccessFailure ||
            oneviewError === settings.oneViewErrorCodes.crmAccessFailure ||
            oneviewError === settings.oneViewErrorCodes.sessionTimeout) {
            scrollPageToTop(); // jshint ignore:line
            appState.switchView('/oneViewInterface');
          } else {
            var language = $location.search().lang;
            var ut = $location.search().userType;
            var province = $location.search().prov;
            if (ut) {
              $browser.cookies('userType', ut);
            }
            if (language) {
              userLanguage(language);
              appState.language = language;
            }
            if (province) {
              userProvince(province);
            }
            if (ut === settings.userType.dealer ||
              ut === settings.userType.care) {
              console.log("For dealer and care remove account list and localstorage values");
              var storageArr = ['pInd', 'ttlDate', 'ListBasedTargets', 'visitCount', 'cta-clicked', 'disqualify', 'consentPath', 'midmarkettemp'];
              localStorage.clearAllLocalStorageValuesExcept(storageArr);
              /*var ttlDate = localStorage.getLocalStorageValue('ttlDate');
              localStorage.clearAllLocalStorageValues();
                    localStorage.setLocalStorageValue('ttlDate', ttlDate); */
              // var accountOverviewService = $injector.get('myrAccountOverviewService');
              //accountOverviewService.purgeAccountList();
              appState.aoFlushScope();
            }
            keyValues = [language, ut, province];
          }
        } else {
          var userType = $browser.cookies().userType;
          if (userType === settings.userType.dealer || userType === settings.userType.care) {
            if (userType === settings.userType.dealer) {
              $rootScope.isDealer = true;
              $rootScope.isConsumer = false;
            } else if (userType === settings.userType.care) {
              $rootScope.isCare = true;
              $rootScope.isConsumer = false;
            }
            appState.switchView('oneViewDashboard');
          } else {
            $browser.cookies('userType', settings.userType.consumer);
            keyValues = '';
          }
        }
        return keyValues;
      };

      return appState;
    }
  ]);

(function () {
  'use strict';

  angular.module('totesApp')
    .service('authInterceptor', authInterceptor)
    .config(['$httpProvider', function ($httpProvider) {
      $httpProvider.interceptors.push('authInterceptor');
    }]);

  authInterceptor.$inject = ['$q', '$injector', 'localStorage', 'sessionStorage', '$window', '$rootScope'];

  function authInterceptor($q, $injector, localStorage, sessionStorage, $window, $rootScope) {
    var service = this;

    service.responseError = function (rejection) {
      var locationUrl = $window.location.href;
      if (rejection.config.url.indexOf("genesis") !== -1) {
      } else if (rejection.config.url.indexOf("token") !== -1) {
        var user = $injector.get('user');
        user.clearCookies();
        localStorage.clearAllLocalStorageValues();
        sessionStorage.clearAllSessionStorageValues();
        var janrainOidc = $injector.get('janrainOidc');
        janrainOidc.signIn();
      } else if (
        locationUrl.indexOf("signin") !== -1 ||
        locationUrl.indexOf("sso") !== -1 ||
        locationUrl.indexOf("frontline") !== -1 ||
        locationUrl.indexOf("soho-migration") !== -1
      ) {} else {
        if (rejection.status === 401) {
          var user = $injector.get('user');
          user.clearCookies();
          $rootScope.user.isAuthenticated = false;
          localStorage.clearAllLocalStorageValues();
          sessionStorage.clearAllSessionStorageValues();
          $window.location.href = '/web/smb/bss/#/signin';
        }
      }
      return $q.reject(rejection);
    };
  }
})();

'use strict';

angular.module('totesApp')
    .factory('backend', ['settings', '$http', '$q', 'resource', 'userOptions', 'appState', 'localStorage', '$location', '$rootScope', '$browser', '$injector', 'ute.datalayer.common.service', 'ute.rogers.datalayer.integration.common.service',
	function (settings, $http, $q, resource, userOptions, appState, localStorage, $location, $rootScope, $browser, $injector, dataLayerService, dataLayerIntegrationService) {

            var protectedUrlPrefix = settings.protectedUrlPrefix;
            var unprotectedUrlPrefix = settings.unProtectedUrlPrefix;
            // $rootScope.abortList = [];

            function absUrl(relativeUrl, useProtectedPrefix) {
                if (useProtectedPrefix) {
                    return protectedUrlPrefix + relativeUrl;
                } else {
                    return unprotectedUrlPrefix + relativeUrl;
                }
            }

            /*
             * function removeCanceller(cancelObj) { for (var
             * i=0; i < $rootScope.abortList.length; i++) { if
             * (cancelObj === $rootScope.abortList[i]) { delete
             * $rootScope.abortList[i];
             * $rootScope.abortList.splice(i,1); } } } //
             */
            function addParameterToURL(url, param) {
                var _url = url;
                _url += (_url.split('?')[1] ? '&' : '?') + param;
                return _url;
            }

            function handleError(response, analyticsInfo) {
                // look for error code and pick action based on
                // that
                var statusCode = response.status;
                var statusText = response.statusText;
                var statusMessage = statusCode + ' - ' + statusText;
                var error = response.data;
                var latesturl = response.config.url;
                var urlvalue = latesturl.split('/');
                var lasturlindex = urlvalue.length - 1;
                var lasturlvalue = urlvalue[lasturlindex];
                try {
                  if(lasturlvalue == 'geteSIMDeviceDetails'|| lasturlvalue == 'reserveSeamlessESIM'){
                    console.log('');
                  }else{
                    if(!isNaN(statusCode) && statusCode !== -1) {
                      dataLayerIntegrationService.initiateErrorAnalyticsEvent(response, analyticsInfo);

                    }
                  }
                } catch (e) {
                    console.log('Selfserve Analytics Exception :: ' + e);
                }

                // Compile more informative error message
                var message = '';

                /*
                 * Error brackets
                 */

                // 0 - 199
                if (statusCode >= 0 && statusCode < 200) {
                    // error message and popup is allowed by
                    // settings
                    if (settings.showErrorPopup) {
                        userOptions.alert(statusMessage);
                    }
                    return $q.reject({
                        $handled: false,
                        originalError: statusMessage,
                        data: response
                    });

                } else
                // 300 - 399
                if (statusCode >= 300 && statusCode < 400) {
                    // error message and popup is allowed by
                    // settings
                    if (settings.showErrorPopup) {
                        userOptions.alert(statusMessage);
                    }
                    return $q.reject({
                        $handled: false,
                        originalError: statusMessage,
                        data: response
                    });

                } else
                // 400 - 499
                if (statusCode >= 400 && statusCode < 500) {
                    // Session expired or user is trying to
                    // access data without proper credentials
                    if (settings.showErrorPopup) {
                        userOptions.alert(statusMessage);
                    }

                    // Special treatment
                    if (statusCode === 401) {
                        // Analyze requester - if this comes
                        // from login page -> pass the response
                        // back to the controller
                        var sourceURL = response.config.url;
                        var sourceArray = sourceURL.split('/');
                        var sourceLength = sourceArray.length;
                        var action = sourceArray[(sourceLength - 1)];

                        if (action === 'testlogin' || action === 'signin') {
                            // Failed credentials
                            return $q.reject({
                                $handled: false,
                                originalError: statusMessage,
                                data: response,
                                action: 'invalidCredentials'
                            });

                        } else {
                            // Most likely session expired and
                            // server is returning 401s
                            return $q.reject({
                                $handled: true,
                                originalError: statusMessage,
                                data: response,
                                action: 'userLogout'
                            });
                        }
                    } else {
                        return $q.reject({
                            $handled: false,
                            originalError: statusMessage,
                            data: response
                        });
                    }

                } else
                // 500 - 554

                if (statusCode === 503) {
                    if (response.config.url.indexOf("rogers_rest/rogers/documents/activatedUserSummary") <= 0 && response.config.url.indexOf("invoices/bulkDownload") <= 0) {
                        localStorage.setLocalStorageValue('maintPage', 'siteMaint');
                        appState.switchView('/underMaintenance');
                    }
                }
                if (statusCode >= 500 && statusCode < 555) {
                    // error message and popup is allowed by
                    // settings
                    if (settings.showErrorPopup) {
                        // userOptions.alert(statusMessage);
                    }
                    return $q.reject({
                        $handled: false,
                        originalError: statusMessage,
                        data: response
                    });

                } else
                // 555 - Special case
                if (statusCode === 555) {

                    // This section HAS TO pass the error
                    // through to the controller fo further
                    // processing
                    // ALSO to have a way for caller functions
                    // to deal with the response.

                    var retObj = {};
                    var resourceId = null;

                    if (error === '') {
                        // empty / no message
                        // Additional logic goes here to treat
                        // the error locally

                    } else if (angular.isString(error) && error.search(/<html.*>/i) >= 0) {
                        // HTML response
                        // Additional logic goes here to treat
                        // the error locally

                    } else {
                        // likely JSON response

                        try {
                            if (error.errorCode >= 10000 && error.errorCode < 11000) {
                                // Event range (ususally in step
                                // of 100)
                                resourceId = error.errorCode;

                            } else if (error.errorCode >= 11000 && error.errorCode < 12000) {
                                // Event range (ususally in step
                                // of 100)
                                resourceId = error.errorCode;

                            } else if (error.errorCode >= 12000 && error.errorCode < 12100) {
                                // Loyalty special messages
                                if (error.errorMessage === 'A') {
                                    // active - do not trigger
                                    // error message

                                } else if (error.errorMessage === 'S') {
                                    // Suspended - trigger error
                                    // message but show widget
                                    resourceId = error.errorCode + '-' + error.errorMessage;

                                } else {
                                    // Do not show the widget
                                    // and do not show the error
                                    resourceId = error.errorCode + '-' + error.errorMessage;
                                }

                            } else if (error.errorCode >= 50000 && error.errorCode < 51000) {
                                // Server important
                                resourceId = error.errorCode;

                            } else {
                                resourceId = '50000';
                            }

                        } catch (err) {
                            resourceId = '50000';
                        }

                        // map 50000 unknown error message to
                        // generic maintainence message
                        if (resourceId === 50000) {
                            resourceId = 'maintenance_info';
                        }

                        // Pass the message
                        // message += '<small>For
                        // customers:</small><br/>';
                        message += resource.get('' + resourceId);
                    }

                    // message = response.statusText?
                    // response.statusText:
                    // resource.get('50000');
                    if (settings.showErrorPopup) {
                        // userOptions.alert(message);
                    }

                    // Reject the value back to caller - For
                    // local handling
                    retObj.errorCode = error.errorCode;
                    retObj.errorMessage = error.errorMessage;
                    retObj.message = message;
                    retObj.statusCode = 555;

                    return $q.reject({
                        $handled: false,
                        originalError: statusMessage,
                        data: response,
                        error: retObj
                    });

                } else {
                    // Every other status code and some that
                    // don't exist
                    if (settings.showErrorPopup) {
                        // userOptions.alert(statusMessage);
                    }
                    return $q.reject({
                        $handled: false,
                        originalError: statusMessage,
                        data: response
                    });
                }
            }

            return {
                postUsingAbsoluteUrl: function (absoluteUrl, data, isFormData, headerData, method) {
                    if (!data) { data = {}; }
                    var analyticsInfo = {
                        method: method,
                        url: absoluteUrl
                    };

                    var canceller = $q.defer();
                    var _method = 'POST';
                    if (method) {
                        _method = method;
                    }
                    // $rootScope.abortList.push(canceller);
                    var httpRequest;
                    var _url = absoluteUrl;
                    if (method === 'GET') {
                        for (var key in data) {
                            _url = addParameterToURL(_url, key + '=' + data[key]);
                        }
                    }
                    if (isFormData) {
                        httpRequest = $http
                            .post(
                                _url,
                                $.param(data), {
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded'
                                    }
                                });
                    } else {
                        if (method === 'GET') {
                            httpRequest = $http({
                                method: _method,
                                url: _url,
                                data: data,
                                headers: headerData,
                                transformResponse: undefined
                            });
                        } else if (absoluteUrl.indexOf('invoices/bulkDownload') > -1) {
                            httpRequest = $http({
                                method: _method,
                                url: _url,
                                data: data,
                                headers: headerData,
                                responseType: "blob"
                            });
                        } else {
                            httpRequest = $http({
                                method: _method,
                                url: _url,
                                data: data,
                                headers: headerData
                            });
                        }
                    }

                    // fix for discardAllSmCookies loop
                    var isLogoff = absoluteUrl.indexOf('discardAllSmCookies') >= 0;

                    var req = httpRequest.then(
                        // response is like
                        // {config:xx,data:{},
                        // headers: function () {},
                        // status:200, statusText }
                        // response.data is what
                        // server return to client
                        function (response) {
                            // If server session is
                            // expired sent user to
                            // sign in!!!
                            if (!isLogoff) {
                                appState
                                    .kickOutExpired();
                            }

                            if (response.status > 199 && response.status < 300) {
                                try {
                                    var pathArray = analyticsInfo.url.split('/');
                                    var apiName = pathArray[pathArray.length - 1];
                                    if (_.findIndex(dataLayerService.returnConfig().advance.errorTrackingAPIs, function (errorTrackingAPI) {
                                            return errorTrackingAPI.name == apiName;
                                        }) != -1) {
                                        console.log('Error Handling on success scenario');
                                        dataLayerIntegrationService.initiateErrorAnalyticsEvent(response, analyticsInfo, true);
                                    }
                                } catch (e) {
                                    console.log('Selfserve Analytics Exception :: ' + e);
                                }
                                // Something is
                                // right
                                var _json = null;
                                if (absoluteUrl.indexOf('invoices/bulkDownload') > -1) {
                                    _json = response;
                                } else {
                                    _json = response.data;
                                }

                                if (!_json || (angular
                                        .isString(_json) && _json
                                        .search(/<html.*>/i) >= 0)) {
                                    // Response is
                                    // HTML but it
                                    // is a pass
                                    // from server.
                                    // Strip out
                                    // HTML ->
                                    // return null
                                    // instead
                                    _json = null;
                                }
                                return _json;

                            } else {
                                // Something is
                                // wrong
                                return handleError(response, analyticsInfo);
                            }

                        },
                        function (errorData) {
                            // If server session is
                            // expired sent user to
                            // sign in!!!
                            if (!isLogoff) {
                                appState
                                    .kickOutExpired();
                            }

                            return handleError(errorData, analyticsInfo);
                        }
                    );
                    return req;
                },

                pathResolver: function (relativeUrl) {
                    var returnPath = '';

                    // 1) settings
                    var defaultLevel = settings.secureCallDefault;
                    // var currentModule =
                    // $route.current.params.module;

                    // Change for ui-router migration -
                    // Commented out on Feb 19th 2015 - due to
                    // timing issue comming from local storage
                    // var toStateName =
                    // localStorage.getLocalStorageValue('toStateName');
                    // var currentModule = (toStateName) ?
                    // toStateName : $state.current.name;
                    var currentModule = $location.path(); // $state.current.name
                    if (currentModule.charAt(0) === '/') {
                        currentModule = currentModule.substr(1);
                    }

                    // var currentModule2 = $location.path();

                    // 2) is page UNsecure call listed?
                    var moduleListed = settings.secureCallPages;
                    var pID = moduleListed
                        .indexOf(currentModule);
                    if (pID >= 0) {
                        defaultLevel = false; // item found in
                        // the array ->
                        // UNsecure call
                    } else {
                        // index = -1 -> not found, keep the
                        // level
                    }

                    // 3) is the call UNsecure listed
                    var callListed = settings.secureCalls;
                    var cID = callListed.indexOf(relativeUrl);
                    if (cID >= 0) {
                        defaultLevel = false; // item found in
                        // the array ->
                        // UNsecure call
                    } else {
                        // index = -1 -> not found, keep the
                        // level
                        if (relativeUrl == 'discardRBSSCookies')
                            defaultLevel = true;
                    }

                    // Localhost hack!!!! REMOVE AS SOON AS
                    // POSSIBLE!!!!!!!
                    if (settings.isLocal) {
                        defaultLevel = false; // All calls
                        // from
                        // localhost
                        // have to
                        // bypass
                        // siteminder ->
                        // UNsecure call
                    }
                    // End of hack

                    // Localhost hack!!!! FIX the real
                    // cause!!!!!!!

                    if (relativeUrl == 'teamsite/list' && !window.location.hash
                        .match('sidh')) {
                        defaultLevel = false;
                    }
                    if (window.location.hash.match('sidh')) {
                        settings.protectedUrlPrefix = '/v1/';
                        settings.unProtectedUrlPrefix = '/v1/';
                    }
                    // End of hack

                    // 4) switch from true/false for string ->
                    // secure / unsecure URL
                    if (defaultLevel) {
                        //Signout user if bss-info is not available
                        if ((localStorage.getLocalStorageValue('BSS_OCP_UTE') == "true") && $rootScope.user.isAuthenticated
                              && !$browser.cookies()['bss-info'] && !$browser.cookies().CONSENT_STATE) {
                            console.log("bss-info not present :: Triggering signout");
                            var user = $injector.get('user');
                            user.logout();
                        }
                        // Secure path
                        if (relativeUrl == 'discardLoginSmCookies' || relativeUrl == 'hasPermissions' || relativeUrl == 'logout' || relativeUrl == 'loggedIn' || relativeUrl == 'maintenanceSettings' || relativeUrl == 'checkReserveDevice')
                            returnPath = settings.protectedUrlPrefixGeneric + relativeUrl;
                        else
                            returnPath = settings.protectedUrlPrefix + relativeUrl;
                    } else {
                        // Unsecure path
                        if (relativeUrl == 'discardLoginSmCookies' || relativeUrl == 'hasPermissions' || relativeUrl == 'logout' || relativeUrl == 'loggedIn' || relativeUrl == 'maintenanceSettings' || relativeUrl === 'discardAllSmCookies' || relativeUrl == 'checkReserveDevice')
                            returnPath = settings.unProtectedUrlPrefixGeneric + relativeUrl;
                        else
                            returnPath = settings.unProtectedUrlPrefix + relativeUrl;
                    }

                    // EXCEPTIONS
                    // 5) Special URLs provided for specific
                    // modules - custom path overide
                    var pageExceptions = settings.moduleCallException;
                    if (pageExceptions[currentModule]) {
                        returnPath = pageExceptions[currentModule];
                    }

                    // 6) Special URLs provided for specific
                    // calls - custom path overide
                    var callExceptions = settings.ajaxCallException;
                    if (callExceptions[relativeUrl]) {
                        returnPath = callExceptions[relativeUrl];
                    }

                    // Localhost hack!!!! REMOVE AS SOON AS
                    // POSSIBLE!!!!!!!
                    // 7) Localhost hack - Prepend the final URL
                    // with full server path to conmplete the
                    // call
                    if (settings.isLocal) {
                        returnPath = settings.devServerURL + returnPath;
                    }
                    // End of hack
                    // The backend call should not append
                    // RogersServices.portal for dealer or care
                    // As the authentication is taken care in
                    // server side through SSO
                    if ($rootScope.isDealer || $rootScope.isCare) {
                        returnPath = settings.unProtectedUrlPrefix + relativeUrl;
                    }
                    return returnPath;
                },

                getFromLocal: function (relativeUrl) {
                    // $rootScope.abortList.push(canceller);
                    var httpRequest;

                    var absoluteUrl = (relativeUrl.indexOf('/') > -1) ? 'resource/' + relativeUrl.substr(relativeUrl
                        .lastIndexOf('/'),
                        relativeUrl.length) + '.json' : 'resource/' + relativeUrl + '.json';
                    var _method = 'GET';
                    var data = '';
                    var analyticsInfo = {
                        method: _method,
                        url: absoluteUrl
                    };
                    httpRequest = $http({
                        method: _method,
                        url: absoluteUrl,
                        data: data
                    });

                    // fix for discardAllSmCookies loop
                    var isLogoff = absoluteUrl
                        .indexOf('discardAllSmCookies') >= 0;

                    var req = httpRequest
                        .then(
                            // response is like
                            // {config:xx,data:{},
                            // headers: function () {},
                            // status:200, statusText }
                            // response.data is what
                            // server return to client
                            function (response) {
                                // If server session is
                                // expired sent user to
                                // sign in!!!
                                if (!isLogoff) {
                                    appState
                                        .kickOutExpired();
                                }

                                if (response.status > 199 && response.status < 300) {
                                    // Something is
                                    // right
                                    var _json = null;
                                    _json = response.data;

                                    if (!_json || (angular
                                            .isString(_json) && _json
                                            .search(/<html.*>/i) >= 0)) {
                                        // Response is
                                        // HTML but it
                                        // is a pass
                                        // from server.
                                        // Strip out
                                        // HTML ->
                                        // return null
                                        // instead
                                        _json = null;
                                    }
                                    return _json;

                                } else {
                                    // Something is
                                    // wrong

                                    return handleError(response, analyticsInfo);
                                }

                            },
                            function (errorData) {
                                // If server session is
                                // expired sent user to
                                // sign in!!!
                                if (!isLogoff) {
                                    appState
                                        .kickOutExpired();
                                }

                                return handleError(errorData, analyticsInfo);
                            });
                    return req;

                },

                post: function (relativeUrl, data, moduleName, headerData) {

                    if (settings.useLocalAPI) {
                        return this.getFromLocal(relativeUrl);
                    } else {

                        var method = '';
                        var fullPath = this
                            .pathResolver(relativeUrl);
                        // Ticket TOT-1201 hack
                        if (relativeUrl === 'wirelessDashBoard/rlh/staticContent') {
                            if (settings.isLocal) {
                                fullPath = 'http://10.10.147.133:9000/v1' + '/cms/page-specific/addons/content/travel/union-pricing.js';
                            } else {
                                fullPath = '/cms/page-specific/addons/content/travel/union-pricing.js';
                            }
                        } else if (relativeUrl === 'briteBillList') { // Ticket TOT-1128
                            if (settings.isLocal) {
                                fullPath = settings.britebill.local + 'rogers_rest/rogers/documents/activatedUserSummary';
                            } else {
                                fullPath = '/rogers_rest/rogers/documents/activatedUserSummary';
                            }
                            method = 'GET';
                        }

                        return this.postUsingAbsoluteUrl(
                            fullPath, data, false,
                            headerData, method);
                    }
                },

                get: function (absUrl) {
                    /*if (settings.useLocalAPI) {
                      return this.getFromLocal(absUrl);
                    }else{
                      var method = 'GET';
                    }*/
                    var analyticsInfo = {
                        method: 'GET',
                        url: absUrl
                    };
                    return $http.get(absUrl).then(
                        function (response) {
                            return response.data;

                        }, function (response) {
                            handleError(response, analyticsInfo);
                        });

                },

                postFormData: function (relativeUrl, data,
                    moduleName, headerData) {
                    var fullPath = this
                        .pathResolver(relativeUrl);

                    return this.postUsingAbsoluteUrl(fullPath,
                        data, true);
                },

                jsonp: function (absUrl) {
                    if (!absUrl) {
                        return false;
                    }
                    var analyticsInfo = {
                        method: 'GET',
                        url: absUrl
                    };
                    return $http.jsonp(absUrl).then(
                        function (response) {
                            return response.data;

                        }, function (response) {
                            handleError(response, analyticsInfo);
                        });
                },
                abort: function () {
                    /*
                     for (var i=0; i < $rootScope.abortList.length; i++) {
                     $rootScope.abortList[i].resolve();
                     }
                     return;
                     //*/
                },
                getOffers: function (request) {
                    var deferred = $q.defer();

                    $http({
                        //url:  'http://10.10.94.138:9000/selfserve/v1/getOffers',
                        url: settings.revolutionGetOffersPrefix + settings.revolutionGetOffers, //'http://10.10.94.138:9000/selfserve/v1/offer-status',
                        //url: 'http://10.10.91.58:9000/selfserve/v1/offer-status',
                        method: 'POST',
                        params: request,

                        cache: false
                    }).then(function (result) {
                        deferred.resolve(result);
                        return result;

                    }, function (error) {
                        deferred.reject(error);
                    });
                    return deferred.promise;
                },
                getRevPermissions: function (request) {
                    var deferred = $q.defer();

                    $http({
                        // url:  'http://10.10.94.138:9000/selfserve/v1/getOffers',
                        url: 'http://10.10.94.153:9000/v1/permissions',
                        //url: 'http://10.10.91.58:9000/selfserve/v1/offer-status',
                        method: 'POST',
                        params: request,
                        cache: false
                    }).then(function (result) {
                        deferred.resolve(result);
                        return result;
                    }, function (error) {
                        deferred.reject(error);
                    });
                    return deferred.promise;
                },

                //Add a null promise API
                getNullPromise: function () {
                    /*
                    var deferred = $q.defer();
                    var obj={};
                    deferred.resolve(obj);
                    return obj;
                    */
                    return $q.when({ttt:"TTT"})
                }

            };
			}
	]);

/**
 * Created by James.Magpantay on 4/13/2016.
 */

(function () {

  'use strict';


  angular
    .module('totesApp')
    .factory('brtCheck', brtCheck);

  brtCheck.$inject = ['$q', '$location', '$cookies', '$rootScope', '$state', '$window', 'settings', 'ajax'];

  function brtCheck($q, $location, $cookies, $rootScope, $state, $window, settings, ajax) {

    var service = {
      utePhaseII: utePhaseII,
      linkAccount: linkAccount,
      cam: cam,
      uccP1:uccP1,
      usermigrate:usermigrate,
      nac:nac,
      tokenization:tokenization,
      dataManagerMigration: dataManagerMigration,
      invoiceEvolution: invoiceEvolution,
      eSimSwitch: eSimSwitch,
      ColonyPortalSwitch: ColonyPortalSwitch,
      brtPermissionContributedData: brtPermissionContributedData
    };

    return service;
    var brtResponse = null;


    function uccP1() {

      var flag = false;
      var brtflag = false;
      ajax.getBrtSwitches().then(
        function (data) {
          angular.forEach(data, function (obj, key) {
            if (obj.id == 'BSS_UCC_P1_BRT') {
              brtflag = true;
              if (obj.switchIsOn == true) {
                ajax.getPermissions().then(
                  function (data) {
                    angular.forEach(data, function (obj, key) {
                      angular.forEach(obj, function (x, key) {
                        if (x.permission == 'BSS_UCC_P1_BRT') {
                          $rootScope.brtUccP1 = true;
                          flag = true;
                        }
                      });
                    });
                    if (!flag) {
                      // no permissions
                      $rootScope.brtUccP1 = false;
                    }
                  },
                  function (error) {
                  }
                );
              } else if (obj.switchIsOn == false) {
                $rootScope.brtUccP1 = true;
              }
            }
          });
          if (!brtflag) {
            $rootScope.brtUccP1 = false;
          }
        },
        function (error) {

        }
      );
    }




    function utePhaseII() {
      var flag = true;
      ajax.getBrtSwitches().then(
        function (data) {
          angular.forEach(data, function (obj, key) {
            if (obj.id == 'BSS_UTE_PH2') {
              if (obj.switchIsOn == true) {
                ajax.getPermissions().then(
                  function (data) {
                    angular.forEach(data, function (obj, key) {
                      angular.forEach(obj, function (x, key) {
                        if (x.permission == 'BSS_UTE_PH2') {
                          $rootScope.brtph2 = true;
                        }
                      });
                    });
                  },
                  function (error) {
                  }
                );

              } else if (obj.switchIsOn == false) {
                $rootScope.brtph2 = true;
              }
            }
            else if (obj.id == 'BSS_UTE_PH2_COMMON_REQ'){
              if(obj.switchIsOn == true){
                ajax.getPermissions().then(
                  function(data) {
                    angular.forEach(data, function(obj, key){
                      angular.forEach(obj, function(x, key){
                        if(x.permission == 'BSS_UTE_PH2_COMMON_REQ'){
                          $rootScope.brtph2common = true;
                        }
                      });
                    });
                  },
                  function(error) {

                  }
                );

              }else if(obj.switchIsOn == false){
                $rootScope.brtph2common = true;
              }

            }
          });
        },
        function (error) {

        }
      );

    }

    function linkAccount() {
      var flag = false;
      var brtflag = false;
      ajax.getBrtSwitches().then(
        function (data) {
          angular.forEach(data, function (obj, key) {
            if (obj.id == 'BSS_AA_BRT') {
              brtflag = true;
              if (obj.switchIsOn == true) {
                ajax.getPermissions().then(
                  function (data) {
                    angular.forEach(data, function (obj, key) {
                      angular.forEach(obj, function (x, key) {
                        if (x.permission == 'BSS_AA_BRT') {
                          $rootScope.brtLinkAccount = false;
                          flag = true;
                        }
                      });
                    });
                    if (!flag) {
                      // no permissions
                      $rootScope.brtLinkAccount = true;
                    }
                  },
                  function (error) {
                  }
                );
              } else if (obj.switchIsOn == false) {
                $rootScope.brtLinkAccount = false;
              }
            }
          });
          if (!brtflag) {
            $rootScope.brtLinkAccount = true;
          }
        },
        function (error) {

        }
      );
    }

    function cam() {
      var flag = false;
      var brtflag = false;
      ajax.getBrtSwitches().then(
        function (data) {
          angular.forEach(data, function (obj, key) {
            if (obj.id == 'BSS_CAM_BRT') {
              brtflag = true;
              if (obj.switchIsOn == true) {
                ajax.getPermissions().then(
                  function (data) {
                    angular.forEach(data, function (obj, key) {
                      angular.forEach(obj, function (x, key) {
                        if (x.permission == 'BSS_CAM_BRT') {
                          $rootScope.cambrt = true;
                          flag = true;
                        }
                      });
                    });
                    if (!flag) {
                      // no permissions
                      $rootScope.cambrt = false;
                    }
                  },
                  function (error) {
                  }
                );
              } else if (obj.switchIsOn == false) {
                $rootScope.cambrt = true;
              }
            }
          });
          if (!brtflag) {
            $rootScope.cambrt = false;
          }
        },
        function (error) {

        }
      );

    }
    function usermigrate() {
          var flag = false;
          var brtflag = false;
          var deferred = $q.defer();
          ajax.getBrtSwitches().then(
            function (data) {
              angular.forEach(data, function (obj, key) {
                if (obj.id == 'BSS_LEGACY_USERNAME_MIGRATION') {
                  brtflag = true;
                  if (obj.switchIsOn == true) {
                    ajax.getPermissions().then(
                      function (data) {
                        angular.forEach(data, function (obj, key) {
                          angular.forEach(obj, function (x, key) {
                            if (x.permission == 'BSS_LEGACY_USERNAME_MIGRATION') {
                              $rootScope.brtusermigrate = true;
                              flag = true;
                              deferred.resolve($rootScope.brtusermigrate);
                            }
                          });
                        });
                        if (!flag) {
                          // no permissions
                          $rootScope.brtusermigrate = false;
                          deferred.reject($rootScope.brtusermigrate);
                        }
                      },
                      function (error) {
                          deferred.reject($rootScope.brtusermigrate);
                      }
                    );
                  } else if (obj.switchIsOn == false) {
                    $rootScope.brtusermigrate= true;
                    deferred.resolve($rootScope.brtusermigrate);
                  }
                }
              });
              if (!brtflag) {
                $rootScope.brtusermigrate = false;
                deferred.reject($rootScope.brtusermigrate);
              }
            },
            function (error) {
                deferred.reject($rootScope.brtusermigrate);
            }
          );
          //deferred.resolve($rootScope.brtusermigrate);
          return deferred.promise;
        }

        function nac() {
          var flag = false;
          var brtflag = false;
          ajax.getBrtSwitches().then(
            function (data) {
              angular.forEach(data, function (obj, key) {
                if (obj.id == 'BSS_NAC_UTE') {
                  brtflag = true;
                  if (obj.switchIsOn == true) {
                    ajax.getPermissions().then(
                      function (data) {
                        angular.forEach(data, function (obj, key) {
                          angular.forEach(obj, function (x, key) {
                            if (x.permission == 'BSS_NAC_UTE') {
                              $rootScope.brtNac = true;
                              flag = true;
                            }
                          });
                        });
                        if (!flag) {
                          // no permissions
                          $rootScope.brtNac = false;
                        }
                      },
                      function (error) {
                      }
                    );
                  } else if (obj.switchIsOn == false) {
                    $rootScope.brtNac = true;
                  }
                }
              });
              if (!brtflag) {
                $rootScope.brtNac = false;
              }
            },
            function (error) {
            }
          );
        }

        function tokenization() {
        //    $rootScope.brtTokenization = false;
         var deferred = $q.defer();
            if(brtResponse == null){
              ajax.getBrtSwitches().then(function(data){
                brtResponse = data;
                deferred.resolve(brtResponse);
              },function(error){
                deferred.reject(error);
              });
            }else{
              deferred.resolve(brtResponse);
            }

             return deferred.promise;
        }

        function invoiceEvolution() {
             var invoiceFlag = false;
             $rootScope.brtInvoiceEvolution = false;
             var deferred = $q.defer();

             ajax.getBrtSwitches().then(
               function (data) {
                 angular.forEach(data, function (obj, key) {
                   if (obj.id == 'EBU_INVOICE_EVOLUTION') {
                     $rootScope.brtInvoiceEvolution = true;

                     if (obj.switchIsOn == true) {
                       ajax.getPermissions().then(
                         function (data) {
                           angular.forEach(data, function (obj, key) {
                             angular.forEach(obj, function (x, key) {
                               if (x.permission == 'EBU_INVOICE_EVOLUTION') {
                                 $rootScope.isBrtIEProfile = true;
                                 invoiceFlag = true;
                                 deferred.resolve($rootScope.isBrtIEProfile);
                               }
                             });
                           });
                           if (!invoiceFlag) {
                             // no permissions
                             $rootScope.isBrtIEProfile = false;
                             deferred.resolve($rootScope.isBrtIEProfile);
                           }
                         },
                         function (error) {
                             $rootScope.isBrtIEProfile = false;
                             deferred.resolve($rootScope.isBrtIEProfile);
                         }
                       );
                     }
                   }
                 });
                 if (!$rootScope.brtInvoiceEvolution) {
                   $rootScope.isBrtIEProfile = false;
                   deferred.resolve($rootScope.isBrtIEProfile);
                 }
               },
               function (error) {
                   $rootScope.isBrtIEProfile = false;
                   deferred.resolve($rootScope.isBrtIEProfile);
               }
             );
             //deferred.resolve($rootScope.isBrtIEProfile);
             return deferred.promise;
        }

        function dataManagerMigration() {
           var dmFlag = false;
           var brtModeDM = false;
           var deferred = $q.defer();

             ajax.getBrtSwitches().then(
               function (data) {
                 angular.forEach(data, function (obj, key) {
                   if (obj.id == 'BSS_DM_MIGRATION') {
                     brtModeDM = true;

                     if (obj.switchIsOn == true) {
                       ajax.getPermissions().then(
                         function (data) {
                           angular.forEach(data, function (obj, key) {
                             angular.forEach(obj, function (x, key) {
                               if (x.permission == 'BSS_DM_MIGRATION') {
                                 $rootScope.dmRedirect = true;
                                 dmFlag = true;
                                 deferred.resolve($rootScope.dmRedirect);
                               }
                             });
                           });
                           if (!dmFlag) {
                             // no permissions
                             $rootScope.dmRedirect = false;
                             deferred.resolve($rootScope.dmRedirect);
                           }
                         },
                         function (error) {
                             $rootScope.dmRedirect = false;
                             deferred.resolve($rootScope.dmRedirect);
                         }
                       );
                     } else {
                         $rootScope.dmRedirect = true;
                         deferred.resolve($rootScope.dmRedirect);
                     }
                   }
                 });
                 if (!brtModeDM) {
                   $rootScope.dmRedirect = true;
                   deferred.resolve($rootScope.dmRedirect);
                 }
               },
               function (error) {
                   $rootScope.dmRedirect = false;
                   deferred.resolve($rootScope.dmRedirect);
               }
             );
             //deferred.resolve($rootScope.dmRedirect);
             return deferred.promise;
        }

        function eSimSwitch() {
           var EsimFlag = false;
           var brtflag = false;
           var deferred = $q.defer();

             ajax.getBrtSwitches().then(
               function (data) {
                 angular.forEach(data, function (obj, key) {
                   if (obj.id == 'BSS_ESIM_UTE') {
                     brtflag = true;

                     if (obj.switchIsOn == true) {
                       ajax.getPermissions().then(
                         function (data) {
                           angular.forEach(data, function (obj, key) {
                             angular.forEach(obj, function (x, key) {
                               if (x.permission == 'BSS_ESIM_UTE') {
                                 $rootScope.brtEsimSwitch = true;
                                 EsimFlag = true;
                                 deferred.resolve($rootScope.brtEsimSwitch);
                               }
                             });
                           });
                           if (!EsimFlag) {
                             // no permissions
                             $rootScope.brtEsimSwitch = false;
                             deferred.resolve($rootScope.brtEsimSwitch);
                           }
                         },
                         function (error) {
                             $rootScope.brtEsimSwitch = false;
                             deferred.resolve($rootScope.brtEsimSwitch);
                         }
                       );
                     } else {
                         $rootScope.brtEsimSwitch = true;
                         deferred.resolve($rootScope.brtEsimSwitch);
                     }
                   }
                 });
                 if (!brtflag) {
                   $rootScope.brtEsimSwitch = true;
                   deferred.resolve($rootScope.brtEsimSwitch);
                 }
               },
               function (error) {
                   $rootScope.brtEsimSwitch = false;
                   deferred.resolve($rootScope.brtEsimSwitch);
               }
             );
             //deferred.resolve($rootScope.brtEsimSwitch);
             return deferred.promise;
        }

        function ColonyPortalSwitch() {
           var switchFlag = false;
           var brtModeSwitch = false;
           var deferred = $q.defer();

             ajax.getBrtSwitches().then(
               function (data) {
                 angular.forEach(data, function (obj, key) {
                   if (obj.id == 'BSS_COLONY_PORTAL_SWITCH') {
                     brtModeSwitch = true;

                     if (obj.switchIsOn == true) {
                       ajax.getPermissions().then(
                         function (data) {
                           angular.forEach(data, function (obj, key) {
                             angular.forEach(obj, function (x, key) {
                               if (x.permission == 'BSS_COLONY_PORTAL_SWITCH') {
                                 $rootScope.ColonyPortalSwitch = true;
                                 switchFlag = true;
                                 deferred.resolve($rootScope.ColonyPortalSwitch);
                               }
                             });
                           });
                           if (!switchFlag) {
                             // no permissions
                             $rootScope.ColonyPortalSwitch = false;
                             deferred.resolve($rootScope.ColonyPortalSwitch);
                           }
                         },
                         function (error) {
                             $rootScope.ColonyPortalSwitch = false;
                             deferred.resolve($rootScope.ColonyPortalSwitch);
                         }
                       );
                     } else {
                         $rootScope.ColonyPortalSwitch = true;
                         deferred.resolve($rootScope.ColonyPortalSwitch);
                     }
                   }
                 });
                 if (!brtModeSwitch) {
                   $rootScope.ColonyPortalSwitch = true;
                   deferred.resolve($rootScope.ColonyPortalSwitch);
                 }
               },
               function (error) {
                   $rootScope.ColonyPortalSwitch = false;
                   deferred.resolve($rootScope.ColonyPortalSwitch);
               }
             );
             //deferred.resolve($rootScope.ColonyPortalSwitch);
             return deferred.promise;
        }

        function brtPermissionContributedData () {
          var deferred = $q.defer();
          ajax.getBrtSwitches().then(
            function(data) {
              var switchValue = _.find(data, {id: 'SMB_PLAN_DATA'});
              if (switchValue && switchValue.switchIsOn && switchValue.switchIsOn) {
                ajax.getPermissions().then(
                  function(result) {
                    if (result && result.permissions && result.permissions.length &&
                        _.find(result.permissions, {permission: 'SMB_PLAN_DATA'})) {
                      deferred.resolve(true);
                    } else {
                      deferred.resolve(false);
                    }
                  },
                  function(error) {
                    deferred.reject();
                  }
                );
              } else {
                deferred.resolve(true);
              }
            },
            function(error) {
              deferred.reject();
            }
          );
          return deferred.promise;
        }
  }
})();



'use strict';

angular.module('totesApp')
  .factory('btnSettings', ['settings', function (settings) {
    return {
      getSettings: function(accountStatus) {
        var btnSettings = settings.btnSettings;
        var length = btnSettings.length;
        var res, defaultSettings;
        for (var i = 0; i < length; i++) {
          if (btnSettings[i].accountStatus === accountStatus) {
           res = btnSettings[i];
          }
          if (btnSettings[i].accountStatus === 'Default') {
            defaultSettings = btnSettings[i];
          }
        }
        return (res) ? res : defaultSettings;
      }
    };
  }]);


'use strict';


angular.module('totesApp')
    .factory('checkRoute', ['$timeout', function ($timeout) {


        //fnIsRouteValid is function like function (event, next, current) {}
        return function (scope, fnIsRouteValid, invalidCallback) {

            if (!scope.__routeCheckers) {
                scope.__routeCheckers = [];

                scope.$on('$stateChangeStart', function (event, next, current) {

                    var checkers = scope.__routeCheckers;

                    for (var i = 0; i < checkers.length; i++) {
                        var checker = checkers[i];

                        var fnIsRouteValid = checker.fnIsRouteValid;
                        var invalidCallback = checker.invalidCallback;

                        if (!fnIsRouteValid(event, next, current)) {
                            event.preventDefault();
                            if (invalidCallback) {
                                $timeout(invalidCallback);
                                break;
                            }
                        }
                    }

                });


            }

            scope.__routeCheckers.push({
                fnIsRouteValid: fnIsRouteValid,
                invalidCallback: invalidCallback
            });

        };
    }]);

'use strict';

angular
		.module('totesApp')
		.factory('currenciesConfig', function () {

			var currenciesConfig = {
				'currencies': [],
				'addCurrency': function (lang, pref, thou, dec, suf) {
					var obj = {
						'prefix': pref,
						'thousandsDelimiter': thou,
						'decimalDelimiter': dec,
						'suffix': suf
					};
					this.currencies[lang] = obj;
				},
				'getCurrency': function (lang) {
					return this.currencies[lang];
				},
				'getProperty': function (lang, prop) {
					return this.currencies[lang][prop];
				},
				'format': function (lang, val, prefixOverride) {
					var objCurr = this.currencies[lang];
					var prefix = prefixOverride || objCurr.prefix;

					// ????? Seriously! Does this look right to you? -- NO! we should be using localization and angular's built in
					return (prefix + val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').replace(',', objCurr.thousandsDelimiter).replace('.', objCurr.decimalDelimiter) + objCurr.suffix);
				}
			};

			//ADDS 2 DEFAULT CURRENCIES EN and FR to be used immediately by the currencies filter
			currenciesConfig.addCurrency('en', '$', ',', '.', '');
			currenciesConfig.addCurrency('fr', '', ' ', ',', ' $');

			return currenciesConfig;
		});

'use strict';


angular
        .module('totesApp')
        .factory('deeplink', ['$q', '$location', 'cookieStore', '$browser', 'settings', '$rootScope', 'localStorage', 'appState', 'myrAccountOverviewService', 'userLanguage', '$window', '$timeout', '$log', 'myrAccountListService', 'ajax', 'sessionStorage',
          function ($q, $location, cookieStore, $browser, settings, $rootScope, localStorage, appState, accountOverviewService, userLanguage, $window, $timeout, $log, myrAccountListService, ajax, sessionStorage) {

            // Initiate Object
            var deeplink = {
              isDeepLinkExists: isDeepLinkExists,
              data: {}
            };

            function isDeepLinkExists() {
              return angular.isDefined($browser.cookies().deepJSON);
            }

            // hook up variables
            deeplink.data.redirect = false;
            deeplink.data.state = '';
            deeplink.data.direction = '';

            deeplink.signInCheck = function () {
              // $log.info('deeplink.signInCheck');

              var sic = $q.defer();
              var deepStr = '';

              // /web/RogersServices.portal/totes/ is a SM protected - we can not get views, js and etc - current solution to go to the publicly accessible /web/totes/
              if($window.location.href.indexOf('/web/RogersServices.portal/totes/#/signin') > 0) {
                $window.location.href = '/web/totes/#/signin';
                return;
              }

              var myCurrentPath = $location.absUrl();
              var lockSearch = $browser.cookies().SMLOCK;
              var signSearch = myCurrentPath.indexOf('signin');
              var colonyPortalSearch = myCurrentPath.indexOf('v1%252fcolonyPortal');
              // $log.info('deeplink.signInCheck - myCurrentPath', myCurrentPath);

              if (lockSearch > 0 && signSearch > 0 || colonyPortalSearch > 0) {
                // You are in locked up sign-in page -> do nothing
              } else {
                deepStr = deeplink.deepLink(myCurrentPath);

                if (deepStr !== '') {
                  // Most definitely external link
                  deeplink.storeData(myCurrentPath);
                }
              }

              sic.resolve(true);				// proceed
              // sic.resolve(false);			// proceed NOT
              return sic.promise;
            };

            deeplink.internal = function (toStatePath) {
              // $log.info('deeplink.internal');

              // User and Location info
              var spliPath = $location.absUrl();
              var splitPathArray = spliPath.split("?");
              var userAuth = $rootScope.user.isAuthenticated;
              var userPath = (toStatePath) ? toStatePath : $location.path();

              // $log.info('deeplink.internal - userPath', userPath);

              // Split string based on this pattern /:module/:submodule
              var pathArr = userPath.split('/');
              var module = pathArr[1];


              // Login required - grab data from settings
              var pageLogin = settings.pageLoginRequired[module];
               myrAccountListService.isOcp = splitPathArray[1];
               if(pathArr[1] !== "accountInitialization" && myrAccountListService.isOcp != "directLanding" )
                 myrAccountListService.acctInitStateUrl = pathArr[1];
               myrAccountListService.isOcpCheck = splitPathArray[1];
               myrAccountListService.acctInitStateUrl = pathArr[1];
              var userState = '';
              if (module === 'signin') {		// Sign page
                // User is already logged in -> sent them back to Account Overview
                if (userAuth === true) {
                  userState = 'signin-page-kickback';
                } else {
                  userState = 'signin-page-fall-through';
                }

              } else {
                if (userAuth === false && pageLogin === false) {
                  // All clear - no need to log in
                  userState = 'public-page';
                } else if (userAuth === false && pageLogin === true) {
                  // All bad - you NEED to log in
                  userState = 'need-login';

                } else if (userAuth === true && pageLogin === false) {
                  // All clear - no need to log in - SignIn page exception handled above
                  userState = 'loggedin-in-public';

                } else if (userAuth === true && pageLogin === true) {
                  // All clear - no need to log in
                  userState = 'no-need-login';

                } else {
                  // Unknown state
                }
              }

              if (userState === 'need-login') {
                var deepStr = '';

                var myCurrentPath = $location.absUrl();
                var lockSearch = myCurrentPath.indexOf('lock');
                var signSearch = myCurrentPath.indexOf('signin');

                deeplink.clearData();		// Cleanup - just in case
                if (lockSearch > 0 && signSearch > 0) {
                  // You are in locked up sign-in page -> do nothing
                } else {
                  // check existing
                  deeplink.storeData(myCurrentPath);
                }
              }
            };

            deeplink.redirectCheck = function (toStatePath) {
              // $log.info('deeplink.redirectCheck');


              var spliPath = $location.absUrl();
              var splitPathArray = spliPath.split("?");
              var userPath = toStatePath ? toStatePath : $location.path();
              var  pathArr = userPath.split("/");
              myrAccountListService.isOcp = splitPathArray[1];
              myrAccountListService.isOcpCheck = splitPathArray[1];
              myrAccountListService.acctInitStateUrl = pathArr[1];
              if(myrAccountListService.isWireless=="true"){
                 myrAccountListService.isWireless= " ";
                 myrAccountListService.acctInitStateUrl = "wireless";
              }

              // Pull data from cookie
              var deepStr = deeplink.restoreData();

              try {
                if (deepStr) {
                  deeplink.deepLinkDirection(deepStr);
                } else {
                  // Leave it as is -> do nothing
                }
              } catch (err) {
                // Leave it as is -> do nothing
              }
            };

            deeplink.permissionResolverHook = function (data) {
              // $log.info('deeplink.permissionResolverHook');

              var prh = $q.defer();

              var localStorageAccountNumber = null;
              var defaultAccNumber = null;

              try {
                defaultAccNumber = data.accountList[0].accountNumber;
                localStorage.setLocalStorageValue('accountNumber', defaultAccNumber);
              } catch (e) {
                // well, well, well ... now we have three holes in the ground
              }

              localStorageAccountNumber = localStorage.getLocalStorageValue('accountNumber');
              if (localStorageAccountNumber) {
                // Last selected account cookie exists --->>> Commence reconstruction
                appState.aoReconstruct(localStorageAccountNumber);

                var selectedAccount = $rootScope.ao.accountActive;
                var request = {
                  applicationId: 'Rogers.com',
                  accountNumber: selectedAccount.accountNumber,
                  accountTypeNumber: selectedAccount.accountTypeNumber,
                  pinNumber: selectedAccount.pinNumber,
                  phoneNumber: selectedAccount.phoneNumber,
                  language: userLanguage(),
                  refresh: false,
                  indx: selectedAccount.selectedAccountIndex
                };

                accountOverviewService.clearAccountDetails();
                accountOverviewService.getAccountDetails(request, function (_tmp) {
                  if (_tmp.result === 'success') {
                    var sublist = _tmp.data.subList;
                    var foundIT = false;

                    for (var sl in sublist) {
                      var item = sublist[sl];
                      if (typeof item === 'object') {

                        if (deeplink.data.state === 'wireless' && item.subType === 'CTN' && item.subStatus === 'Active') {
                          localStorage.setLocalStorageValue('phoneNumber', item.subAccountId);
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'wirelessPrepaid' && item.subType === 'CTN' && item.subStatus === 'Active') {
                          localStorage.setLocalStorageValue('phoneNumber', item.subAccountId);
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'shmdashboard' && item.subType === 'Rogers Smart Home Monitoring' && item.subStatus === 'Active') {
                          localStorage.setLocalStorageValue('shmAccountNumber', item.subAccountId);
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'internetdash' && item.subType === 'Hi-Speed Internet' && item.subStatus === 'Active') {
                          localStorage.setLocalStorageValue('internetAccountNumber', item.subAccountId);
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'tvdashboard' && item.subType === 'Digital TV' && item.subStatus === 'Active') {
                          localStorage.setLocalStorageValue('tvAccountNumber', item.subAccountId);
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'suspended' && item.subStatus === 'Suspended') {
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'homephone' && item.subType === 'RHPc' && item.subStatus === 'Active') {
                          foundIT = true;
                          break;
                        }
                      }
                    }

                    if (foundIT === true) {
                      // Internal deeplinking process - go to the destination URL
                      if (appState.maintenanceRedirect(deeplink.data.state)) {
                        $location.path('/underMaintenance');
                      }else{
                        appState.switchView(deeplink.data.state);
                      }

                      prh.resolve(true);       // proceed
                    } else {
                      // Do nothing
                      // appState.switchView('accountOverview');
                      prh.resolve(false);			// proceed NOT
                    }
                  } else {
                    // fail ??? !!  Something
                  }
                });
              }

              // prh.resolve(true);       // proceed
              // prh.resolve(false);			// proceed NOT
              // prh.deffer();            // FAIL!!
              return prh.promise;
            };


            // deep linking cruncher - parse / process URLs and behave upon provided conditions
            deeplink.deepLinkIN = function (tempUrlStr) {
              // $log.info('deeplink.deepLinkIN');
              // $log.info('deeplink.deepLinkIN - tempUrlStr', tempUrlStr);

              // Split string based on this pattern /:module/:submodule
              var module = '';
              var mainSection = '';
              var pathArr = tempUrlStr.split('/#/');

              if (pathArr.length > 1) {
                module = pathArr[1];
                var moduleArr = module.split('/');
                if (moduleArr) {
                  mainSection = moduleArr[0];
                }
              }

              try {
                // Login required - grab data from settings
                var pageLogin = settings.pageLoginRequired[mainSection];
                if (pageLogin) {
                  deeplink.data.redirect = true;
                  deeplink.data.direction = 'in';
                  deeplink.data.state = mainSection;

                  $location.path('/'+ pathArr[1]);
                }
              } catch (err) {
                // failed to confirm page - do nothing and let the regular pocess follow through
              }
            };

            deeplink.deepLinkOUT = function (tempUrlStr) {
              // $log.info('deeplink.deepLinkOUT');
              // $log.info('deeplink.deepLinkOUT - tempUrlStr', tempUrlStr);

              // Button click like behavior
              deeplink.data.direction = 'out';
              tempUrlStr = tempUrlStr.replace('#/signin', '');        // Clean out the sign-in bit

              if (tempUrlStr.search('wcoc')) {
                $rootScope.internalRedirect = true;
                cookieStore.remove('deepJSON');
                $window.location.href = tempUrlStr + '?entryId=D';
              } else {
                $timeout(function () {
                   $rootScope.internalRedirect = true;
                   $window.location.href = tempUrlStr;
                },1100);
              }
            };

            deeplink.deepLinkDirection = function (urlStr) {
              // $log.info('deeplink.deepLinkDirection');

              // rinse out -SM- From the URL
              var tempUrlStr = urlStr;
              var firstPass = deeplink.deepLink(urlStr);

              if (firstPass === '') {
                // Posibly internal link
                deeplink.deepLinkIN(tempUrlStr);

              } else {
                // Most definitely external link
                deeplink.deepLinkOUT(firstPass);
              }
            };

            deeplink.deepLink = function (url) {
              // $log.info('deeplink.deepLink');

              url = (url === undefined) ? '' : url;
              var decode = '';
              var splitUrlArr = url.split('?');
              var parametersSetStr = splitUrlArr[1];
              var tragetString = '';
              var sourceString = '';
              var jwtString = '';

              if ((parametersSetStr !== undefined) && !(url.contains('colonyPortal'))){
                var parametersSetArr = parametersSetStr.split('&');

                if (parametersSetArr.length > 0) {
                  for (var op in parametersSetArr) {
                    var opNum = parseInt(op);

                    if (typeof opNum === 'number' && opNum >= 0) {
                      var tempStr = parametersSetArr[opNum];

                      var targetSearch = tempStr.indexOf('TARGET');
                      var refSearch = tempStr.indexOf('referer');
                      var sourceSearch = tempStr.indexOf('sourceid');

                      if (sourceSearch === 0) {
                        sourceString = tempStr;
                        sourceString = sourceString.replace('sourceid=', '');
                      }
                      if (targetSearch === 0 || refSearch === 0) {
                        tragetString = tempStr;
                        //break;
                      }
                    }
                  }
                }
              }

              if ((tragetString !== '') && !(url.contains('colonyPortal'))) {
                var ts = tragetString.indexOf('TARGET');
                var rs = tragetString.indexOf('referer');

                // make sure that only the first word is removed
                if (ts === 0) {
                  tragetString = tragetString.replace('TARGET=', '');
                  tragetString = decodeURIComponent(tragetString);			// Once only
                }
                if (rs === 0) {
                  tragetString = tragetString.replace('referer=', '');
                  tragetString = decodeURIComponent(tragetString);			// Once
                  tragetString = decodeURIComponent(tragetString);			// TWICE encoded!!!  WOWsies!!!
                }
                decode = smUrlDecode(tragetString);								// jshint ignore:line

              }
              // $log.info('deeplink.deepLink - decode', decode);

              // Objectify this to match the rest of the script
              return decode;
            };

            deeplink.settingWcocJwtTokenValue = function () {
               try{
                var wcocDeepJSON = $window.location.href;
                   if(wcocDeepJSON.indexOf('sourceid=wcoc') >= 0){
                       var deepSTR = this.deepLink(wcocDeepJSON);
                       sessionStorage.setSessionStorageValue('wcocDeepSTR', deepSTR);
                       sessionStorage.setSessionStorageValue('wcocJwtToken', localStorage.getLocalStorageValue('wcocToken'));
                   }
                }
                catch (err){
                    //handle error
                }
             };

             deeplink.storeDirectLandingData = function (params) {
                if (params.ban) {
                  localStorage.setLocalStorageValue('accountNumber', params.ban);
                  localStorage.setLocalStorageValue("banFreshInStorage", "Y");
                }
                if (params.ctn) {
                  localStorage.setLocalStorageValue('phoneNumber', params.ctn);
                }
                if (params.directLanding === "true") {
                  if (params.ban) {
                    $location.url($location.path() + "?directLanding");
                  } else if (!localStorage.getLocalStorageValue("banFreshInStorage")) {
                    localStorage.setLocalStorageValue("banNotFound", "Y");
                  } else {
                    $window.localStorage.removeItem('banFreshInStorage');
                  }
                }
             }

            deeplink.storeData = function (deepStr) {
              // $log.info('deeplink.storeData');

              // Cookie way
              $browser.cookies('deepJSON', deepStr);
            };

            deeplink.restoreData = function () {
              // $log.info('deeplink.restoreData');

              var deepJSON = '';

              try {
                deepJSON = $browser.cookies().deepJSON;
                cookieStore.remove('deepJSON');

                if (deepJSON === undefined || deepJSON === null || deepJSON === 'undefined') {
                  deepJSON = '';
                }
              } catch (err) {
                // And that's how the cookie crumble.
              }
              return deepJSON;
            };

            deeplink.clearData = function () {
              // $log.info('deeplink.clearData');

              // Cookie GO away!!
              try {
                cookieStore.remove('deepJSON');
              } catch (monster) {
                // "Me no have cooookie??" - Cookie monster
              }
            };

            return deeplink;
          }
        ]);


angular
        .module('totesApp')
        .provider('deepLinkingHandler', function () {
          var data;

          return {
            $get: function () {
              return data;
            },
            $set: function (value) {
              data = value;
            }
          };
        });

'use strict';

angular
        .module('totesApp')
        .factory('email_ppc', ['$filter', 'resource', 'userLanguage', 'pricePlanChangesCart',
          function ($filter, resource, userLanguage, pricePlanChangesCart) {

            var globHtml = /(<([^>]+)>)/ig;
            var nl = '\n';
            var dollarSign = function dollarSign(value, locale) {
              return (locale === 'en') ? '$' + value : value + ' $';
            };


            return {
              getemail: function () {
                //cached if already called before
                //if(uri)
                //return uri;
                var lang = userLanguage().toLowerCase();
                var uri = '';
                var mailto = [];
                // cart
                var cart = pricePlanChangesCart;

                // Your order
                mailto.push(resource.get('checkout_confirm_order_your_order') + nl + nl);

                // billing
                mailto.push(resource.get('checkout_review_order_billing_address') + nl + nl);
                mailto.push(cart.billingStreetAddress + nl);
                mailto.push(cart.billingCity + ', ' + cart.billingProvince + nl);
                mailto.push(cart.billingPostalCode + nl + nl);

                mailto.push(resource.get('checkout_review_order_billing_preferences') + nl + nl);
                mailto.push(resource.get('checkout_review_order_pay') + ' ');
                mailto.push(resource.get('checkout_review_order_pay_invoice') + nl);

                // invoice type
                mailto.push(resource.get('checkout_review_order_receive_bill_via') + ' ');
                if (cart.billingType == 'INVOICE') {
                  mailto.push(resource.get('online_bill_title') + nl);
                }
                else {
                  mailto.push(resource.get('_paper_bill') + nl);
                }
                mailto.push(resource.get('checkout_review_order_send_bill_to') + ' ');
                mailto.push(cart.email + nl + nl);

                // contact details
                mailto.push(resource.get('checkout_confirm_order_contact_details') + nl + nl);
                mailto.push($filter('phone3')(cart.contactPhoneNumber) + nl);
                mailto.push(cart.email + nl + nl);
                // plan details
                mailto.push(resource.get('ppc_shop_cart_plan_details') + ' ' + $filter('phone3')(cart.ctn) + nl + nl);
                mailto.push((lang == 'en' ? cart.newPlan.cmsData_En.planTitle : cart.newPlan.cmsData_Fr.planTitle) + nl);     // jshint ignore:line
                mailto.push(cart.newPlan.planInfo.includedDataMax + ' ');
                if (cart.newPlan.planInfo.includedDataMax !== 'Not Applicable') {
                  mailto.push(resource.get('ppc_overage_rate') + ' ' + cart.newPlan.planInfo.overageRate + nl);
                }
                mailto.push(cart.newPlan['cmsData_' + (lang == 'en' ? 'En' : 'Fr')].includedMessages[0].replace(globHtml, '') + nl);
                mailto.push(cart.newPlan['cmsData_' + (lang == 'en' ? 'En' : 'Fr')].includedMinutes[0].replace(globHtml, '') + nl);
                cart.newPlan['cmsData_' + (lang == 'en' ? 'En' : 'Fr')].planFeatures.forEach(function (feature) {
                  mailto.push(feature + nl);
                });
                mailto.push(nl);
                // monthly fee
                mailto.push(resource.get('checkout_confirm_order_monthly_fees') + nl + nl);
                mailto.push(dollarSign(cart.newPlan.planInfo.planPrice, lang) + nl + nl);

                // add-ons
                mailto.push(resource.get('_add_ons') + nl + nl);

                cart.addOns.forEach(function (addOn) {
                  mailto.push(addOn['cmsData_' + (lang === 'en' ? 'En' : 'Fr')].title + ': ' + dollarSign($filter('number')(addOn.addonInfo.addOnPrice, 2), lang) + nl);
                });
                mailto.push(nl);

                // extras
                mailto.push(resource.get('wireless_extras') + nl + nl);
                if (cart.newPlan.cmsData_En.categoryName_En.indexOf('Share') > -1) {                                        // jshint ignore:line
                  if (lang === 'en') {
                    mailto.push(cart.newPlan.cmsData_En.categoryName_En + nl);                                              // jshint ignore:line
                  } else {
                    mailto.push(cart.newPlan.cmsData_Fr.categoryName_Fr + nl);                                              // jshint ignore:line
                  }
                  mailto.push(resource.get('myaccoverview_get_nhl').replace(globHtml, '') + nl);
                  mailto.push(resource.get('wireless_roaming') + nl + nl);
                }

                // summary / total
                mailto.push(resource.get('checkout_confirm_order_monthly_fees') + nl + nl);
                mailto.push(resource.get('ppc_shop_cart_summary_new_monthly_cost') + ': ' + dollarSign($filter('number')(cart.totalCost, 2), lang) + nl);
                angular.forEach(
                        cart.taxes.taxes,
                        function (value, key) {
                          mailto.push(key + ': ' + dollarSign($filter('number')(value, 2), lang) + nl);	//cart.taxes.taxes[key]
                        }
                );
                mailto.push(resource.get('checkout_confirm_new_monthly_total_fees') + ' ' + dollarSign($filter('number')(cart.grandTotal, 2), lang) + nl + nl);

                mailto.push(resource.get('checkout_confirm_partial_prepaid') + nl + nl);

                // MERGE
                uri = 'mailto:' + cart.email + '?subject=' + encodeURIComponent(resource.get('ppc_shop_cart_plan_details')) + '&body=' + encodeURIComponent(mailto.join(''));
                return uri;
              }
            };
          }
        ]);

'use strict';

angular
        .module('totesApp')
        .factory('email_ppc', ['$filter', 'resource', 'userLanguage', 'pricePlanChangesCart',
          function ($filter, resource, userLanguage, pricePlanChangesCart) {
            //var mailto = [];
            var nl = '<br>';
            var lang = userLanguage().toLowerCase();
            var html = {
              start: '<html><body>',
              end: '</body></html>'
            };

            return {
              getemail: function () {

                //cached if already called before
                //if(mailto.length)
                //		return mailto;
                var mailto = [];

                // cart
                var cart = pricePlanChangesCart;
                return cart.email;		        // jshint ignore:line
//*** DISABLED ***   ^^^    // WHAT IS THIS NONSENCE??????
/*
                // contact
                mailto.push(cart.email);		//'mailto:' +
                mailto.push('?subject=' + resource.get('ppc_shop_cart_plan_details'));
                mailto.push('&body=' + html.start + resource.get('ppc_shop_cart_plan_details') + nl + nl);

                // billing
                mailto.push(resource.get('checkout_confirm_order_contact_details') + nl);
                mailto.push(resource.get('checkout_review_order_billing_address') + nl);
                mailto.push(cart.billingStreetAddress + nl);
                mailto.push(cart.billingCity + nl);
                mailto.push(cart.billingPostalCode + nl + nl);

                // invoice type
                if (cart.billingType == 'INVOICE') {
                  mailto.push(resource.get('_online_bill') + nl);
                }
                else {
                  mailto.push(resource.get('_paper_bill') + nl);
                }
                mailto.push(nl + nl);

                // contact details
                mailto.push(resource.get('checkout_confirm_order_contact_details') + nl);
                mailto.push($filter('phone3')(cart.contactPhoneNumber) + nl);
                mailto.push(cart.email + nl + nl);

                // plan details
                mailto.push(resource.get('ppc_shop_cart_plan_details') + $filter('phone3')(cart.ctn) + nl);
                mailto.push((lang == 'en' ? cart.newPlan.cmsData_En.planTitle : cart.newPlan.cmsData_Fr.planTitle) + nl);     // jshint ignore:line
                mailto.push('<ul>');
                angular.forEach(
                        (lang == 'en') ? cart.newPlan.cmsData_En.planFeatures : cart.newPlan.cmsData_Fr.planFeatures,         // jshint ignore:line
                        function (key, value) {
                          mailto.push('<li>' + value + '</li>');
                        });
                mailto.push('</ul>' + nl + nl);

                // monthly fee
                mailto.push(resource.get('checkout_confirm_order_monthly_fees') + nl);
                if (lang == 'en')
                  mailto.push('$' + cart.newPlan.planInfo.planPrice + nl);
                else
                  mailto.push(cart.newPlan.planInfo.planPrice + '$' + nl);
//*/
                // add-ons
                /*if (cart.addOns.length && lang == 'en') {
                 angular.forEach(
                 cart.addOns,
                 function(key, value){
                 //mailto.push( '$' + cart.addOns[key].cmsData_En.title + ': ' + $filter('number')(cart.addOns[key].addonInfo.addOnPrice, 2) + nl );
                 }
                 );
                 }
                 else if (card.addOns.length) {
                 angular.forEach(
                 cart.addOns,
                 function(key, value){
                 //mailto.push( cart.addOns[key].cmsData_Fr.title + ' : '  + '$' + $filter('number')(cart.addOns[key].addonInfo.addOnPrice, 2) + nl );
                 }
                 );
                 }
                 
                 // extras
                 if(cart.newPlan.cmsData_En.categoryName_En.indexOf('Share') > -1){
                 if(lang == 'en'){
                 mailto.push( cart.newPlan.cmsData_En.categoryName_En + nl );
                 }
                 else {
                 mailto.push( cart.newPlan.cmsData_Fr.categoryName_Fr + nl );
                 }
                 mailto.push( resource.get('myaccoverview_get_nhl') + nl );
                 mailto.push( resource.get('wireless_roaming') + nl + nl );
                 }
                 
                 // summary / total
                 mailto.push( resource.get('checkout_confirm_order_monthly_fees') + nl );
                 mailto.push( resource.get('ppc_shop_cart_summary_new_monthly_cost') + ': ' + $filter('number')(cart.totalCost, 2) + nl );
                 angular.forEach(
                 cart.taxes.taxes,
                 function(key, value){
                 mailto.push( key + ': ' + value + nl );	//cart.taxes.taxes[key]
                 }
                 );
                 mailto.push( resource.get('checkout_confirm_new_monthly_total_fees') + $filter('number')(cart.grandTotal, 2) + nl );*/

                // MERGE
//                return mailto.join('') + html.end;
              }
            };
          }
        ]);

/*
 *  Warning
 *  Don't use strict for this file as it's based on old code base and needs updated.
 * This file is copied and customized from the existing Rogers.com for encryption the credit card number purpose.
  * The third-party code used in this file was created in 2005 and doesn't pass the jshint,to keep the functionality working, this file has been excluded from the jshint.
  * Ideally, we should introduce an upgraded version of a Javascript encryption algorithm to replace this piece of code.
   * */
angular.module('totesApp')
    .factory('encryption', function () {

// Augment the basic prototypes if they have not already been augmented.
// These forms are obsolete. It is recommended that JSON.stringify and
// JSON.parse be used instead.

//}// prng4.js - uses Arcfour as a PRNG

        function Arcfour() {
            this.i = 0;
            this.j = 0;
            this.S = new Array();
        }

// Initialize arcfour context from key, an array of ints, each from [0..255]
        function ARC4init(key) {
            var i, j, t;
            for(i = 0; i < 256; ++i)
                this.S[i] = i;
            j = 0;
            for(i = 0; i < 256; ++i) {
                j = (j + this.S[i] + key[i % key.length]) & 255;
                t = this.S[i];
                this.S[i] = this.S[j];
                this.S[j] = t;
            }
            this.i = 0;
            this.j = 0;
        }

        function ARC4next() {
            var t;
            this.i = (this.i + 1) & 255;
            this.j = (this.j + this.S[this.i]) & 255;
            t = this.S[this.i];
            this.S[this.i] = this.S[this.j];
            this.S[this.j] = t;
            return this.S[(t + this.S[this.i]) & 255];
        }

        Arcfour.prototype.init = ARC4init;
        Arcfour.prototype.next = ARC4next;

// Plug in your RNG constructor here
        function prng_newstate() {
            return new Arcfour();
        }

// Pool size must be a multiple of 4 and greater than 32.
// An array of bytes the size of the pool will be passed to init()
        var rng_psize = 256;
// Random number generator - requires a PRNG backend, e.g. prng4.js

// For best results, put code like
// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
// in your main HTML document.

        var rng_state;
        var rng_pool;
        var rng_pptr;

// Mix in a 32-bit integer into the pool
        function rng_seed_int(x) {
            rng_pool[rng_pptr++] ^= x & 255;
            rng_pool[rng_pptr++] ^= (x >> 8) & 255;
            rng_pool[rng_pptr++] ^= (x >> 16) & 255;
            rng_pool[rng_pptr++] ^= (x >> 24) & 255;
            if(rng_pptr >= rng_psize) rng_pptr -= rng_psize;
        }

// Mix in the current time (w/milliseconds) into the pool
        function rng_seed_time() {
            rng_seed_int(new Date().getTime());
        }

// Initialize the pool with junk if needed.
        if(rng_pool == null) {
            rng_pool = new Array();
            rng_pptr = 0;
            var t;
            if(navigator.appName == "Netscape" && navigator.appVersion < "5" && window.crypto) {
                // Extract entropy (256 bits) from NS4 RNG if available
                var z = window.crypto.random(32);
                for(t = 0; t < z.length; ++t)
                    rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
            }
            while(rng_pptr < rng_psize) {  // extract some randomness from Math.random()
                t = Math.floor(65536 * Math.random());
                rng_pool[rng_pptr++] = t >>> 8;
                rng_pool[rng_pptr++] = t & 255;
            }
            rng_pptr = 0;
            rng_seed_time();
            //rng_seed_int(window.screenX);
            //rng_seed_int(window.screenY);
        }

        function rng_get_byte() {
            if(rng_state == null) {
                rng_seed_time();
                rng_state = prng_newstate();
                rng_state.init(rng_pool);
                for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)
                    rng_pool[rng_pptr] = 0;
                rng_pptr = 0;
                //rng_pool = null;
            }
            // TODO: allow reseeding after first request
            return rng_state.next();
        }

        function rng_get_bytes(ba) {
            var i;
            for(i = 0; i < ba.length; ++i) ba[i] = rng_get_byte();
        }

        function SecureRandom() {}

        SecureRandom.prototype.nextBytes = rng_get_bytes;
// Depends on jsbn.js and rng.js

// Version 1.1: support utf-8 encoding in pkcs1pad2

// convert a (hex) string to a bignum object
        function parseBigInt(str,r) {
            return new BigInteger(str,r);
        }

        function linebrk(s,n) {
            var ret = "";
            var i = 0;
            while(i + n < s.length) {
                ret += s.substring(i,i+n) + "\n";
                i += n;
            }
            return ret + s.substring(i,s.length);
        }

        function byte2Hex(b) {
            if(b < 0x10)
                return "0" + b.toString(16);
            else
                return b.toString(16);
        }

// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
        function pkcs1pad2(s,n) {
            if(n < s.length + 11) { // TODO: fix for utf-8
                alert("Message too long for RSA");
                return null;
            }
            var ba = new Array();
            var i = s.length - 1;
            while(i >= 0 && n > 0) {
                var c = s.charCodeAt(i--);
                if(c < 128) { // encode using utf-8
                    ba[--n] = c;
                }
                else if((c > 127) && (c < 2048)) {
                    ba[--n] = (c & 63) | 128;
                    ba[--n] = (c >> 6) | 192;
                }
                else {
                    ba[--n] = (c & 63) | 128;
                    ba[--n] = ((c >> 6) & 63) | 128;
                    ba[--n] = (c >> 12) | 224;
                }
            }
            ba[--n] = 0;
            var rng = new SecureRandom();
            var x = new Array();
            while(n > 2) { // random non-zero pad
                x[0] = 0;
                while(x[0] == 0) rng.nextBytes(x);
                ba[--n] = x[0];
            }
            ba[--n] = 2;
            ba[--n] = 0;
            return new BigInteger(ba);
        }

// "empty" RSA key constructor
        function RSAKey() {
            this.n = null;
            this.e = 0;
            this.d = null;
            this.p = null;
            this.q = null;
            this.dmp1 = null;
            this.dmq1 = null;
            this.coeff = null;
        }

// Set the public key fields N and e from hex strings
        function RSASetPublic(N,E) {
            if(N != null && E != null && N.length > 0 && E.length > 0) {
                this.n = parseBigInt(N,16);
                this.e = parseInt(E,16);
            }
            else
                alert("Invalid RSA public key");
        }

// Perform raw public operation on "x": return x^e (mod n)
        function RSADoPublic(x) {
            return x.modPowInt(this.e, this.n);
        }

// Return the PKCS#1 RSA encryption of "text" as an even-length hex string
        function RSAEncrypt(text) {
            var m = pkcs1pad2(text,(this.n.bitLength()+7)>>3);
            if(m == null) return null;
            var c = this.doPublic(m);
            if(c == null) return null;
            var h = c.toString(16);
            if((h.length & 1) == 0) return h; else return "0" + h;
        }

// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
//function RSAEncryptB64(text) {
//  var h = this.encrypt(text);
//  if(h) return hex2b64(h); else return null;
//}

// protected
        RSAKey.prototype.doPublic = RSADoPublic;

// public
        RSAKey.prototype.setPublic = RSASetPublic;
        RSAKey.prototype.encrypt = RSAEncrypt;
//RSAKey.prototype.encrypt_b64 = RSAEncryptB64;
        var b64map="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var b64pad="=";

        function hex2b64(h) {
            var i;
            var c;
            var ret = "";
            for(i = 0; i+3 <= h.length; i+=3) {
                c = parseInt(h.substring(i,i+3),16);
                ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
            }
            if(i+1 == h.length) {
                c = parseInt(h.substring(i,i+1),16);
                ret += b64map.charAt(c << 2);
            }
            else if(i+2 == h.length) {
                c = parseInt(h.substring(i,i+2),16);
                ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
            }
            while((ret.length & 3) > 0) ret += b64pad;
            return ret;
        }

// convert a base64 string to hex
        function b64tohex(s) {
            var ret = ""
            var i;
            var k = 0; // b64 state, 0-3
            var slop;
            for(i = 0; i < s.length; ++i) {
                if(s.charAt(i) == b64pad) break;
                v = b64map.indexOf(s.charAt(i));
                if(v < 0) continue;
                if(k == 0) {
                    ret += int2char(v >> 2);
                    slop = v & 3;
                    k = 1;
                }
                else if(k == 1) {
                    ret += int2char((slop << 2) | (v >> 4));
                    slop = v & 0xf;
                    k = 2;
                }
                else if(k == 2) {
                    ret += int2char(slop);
                    ret += int2char(v >> 2);
                    slop = v & 3;
                    k = 3;
                }
                else {
                    ret += int2char((slop << 2) | (v >> 4));
                    ret += int2char(v & 0xf);
                    k = 0;
                }
            }
            if(k == 1)
                ret += int2char(slop << 2);
            return ret;
        }

// convert a base64 string to a byte/number array
        function b64toBA(s) {
            //piggyback on b64tohex for now, optimize later
            var h = b64tohex(s);
            var i;
            var a = new Array();
            for(i = 0; 2*i < h.length; ++i) {
                a[i] = parseInt(h.substring(2*i,2*i+2),16);
            }
            return a;
        }



// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.

// Basic JavaScript BN library - subset useful for RSA encryption.

// Bits per digit
        var dbits;

// JavaScript engine analysis
        var canary = 0xdeadbeefcafe;
        var j_lm = ((canary&0xffffff)==0xefcafe);

// (public) Constructor
        function BigInteger(a,b,c) {
            if(a != null)
                //if("number" == typeof a) this.fromNumber(a,b,c);
                if("number" == typeof a) this.fromInt(a);
                else if(b == null && "string" != typeof a) this.fromString(a,256);
                else this.fromString(a,b);
        }

// return new, unset BigInteger
        function nbi() { return new BigInteger(null); }

// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.

// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
        function am1(i,x,w,j,c,n) {
            while(--n >= 0) {
                var v = x*this[i++]+w[j]+c;
                c = Math.floor(v/0x4000000);
                w[j++] = v&0x3ffffff;
            }
            return c;
        }
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
        function am2(i,x,w,j,c,n) {
            var xl = x&0x7fff, xh = x>>15;
            while(--n >= 0) {
                var l = this[i]&0x7fff;
                var h = this[i++]>>15;
                var m = xh*l+h*xl;
                l = xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);
                c = (l>>>30)+(m>>>15)+xh*h+(c>>>30);
                w[j++] = l&0x3fffffff;
            }
            return c;
        }
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
        function am3(i,x,w,j,c,n) {
            var xl = x&0x3fff, xh = x>>14;
            while(--n >= 0) {
                var l = this[i]&0x3fff;
                var h = this[i++]>>14;
                var m = xh*l+h*xl;
                l = xl*l+((m&0x3fff)<<14)+w[j]+c;
                c = (l>>28)+(m>>14)+xh*h;
                w[j++] = l&0xfffffff;
            }
            return c;
        }
        if(j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
            BigInteger.prototype.am = am2;
            dbits = 30;
        }
        else if(j_lm && (navigator.appName != "Netscape")) {
            BigInteger.prototype.am = am1;
            dbits = 26;
        }
        else { // Mozilla/Netscape seems to prefer am3
            BigInteger.prototype.am = am3;
            dbits = 28;
        }

        BigInteger.prototype.DB = dbits;
        BigInteger.prototype.DM = ((1<<dbits)-1);
        BigInteger.prototype.DV = (1<<dbits);

        var BI_FP = 52;
        BigInteger.prototype.FV = Math.pow(2,BI_FP);
        BigInteger.prototype.F1 = BI_FP-dbits;
        BigInteger.prototype.F2 = 2*dbits-BI_FP;

// Digit conversions
        var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
        var BI_RC = new Array();
        var rr,vv;
        rr = "0".charCodeAt(0);
        for(vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;
        rr = "a".charCodeAt(0);
        for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
        rr = "A".charCodeAt(0);
        for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

        function int2char(n) { return BI_RM.charAt(n); }
        function intAt(s,i) {
            var c = BI_RC[s.charCodeAt(i)];
            return (c==null)?-1:c;
        }

// (protected) copy this to r
        function bnpCopyTo(r) {
            for(var i = this.t-1; i >= 0; --i) r[i] = this[i];
            r.t = this.t;
            r.s = this.s;
        }

// (protected) set from integer value x, -DV <= x < DV
        function bnpFromInt(x) {
            this.t = 1;
            this.s = (x<0)?-1:0;
            if(x > 0) this[0] = x;
            else if(x < -1) this[0] = x+this.DV;
            else this.t = 0;
        }

// return bigint initialized to value
        function nbv(i) { var r = nbi(); r.fromInt(i); return r; }

// (protected) set from string and radix
        function bnpFromString(s,b) {
            var k;
            if(b == 16) k = 4;
            else if(b == 8) k = 3;
            else if(b == 256) k = 8; // byte array
            else if(b == 2) k = 1;
            else if(b == 32) k = 5;
            else if(b == 4) k = 2;
            else { this.fromRadix(s,b); return; }
            this.t = 0;
            this.s = 0;
            var i = s.length, mi = false, sh = 0;
            while(--i >= 0) {
                var x = (k==8)?s[i]&0xff:intAt(s,i);
                if(x < 0) {
                    if(s.charAt(i) == "-") mi = true;
                    continue;
                }
                mi = false;
                if(sh == 0)
                    this[this.t++] = x;
                else if(sh+k > this.DB) {
                    this[this.t-1] |= (x&((1<<(this.DB-sh))-1))<<sh;
                    this[this.t++] = (x>>(this.DB-sh));
                }
                else
                    this[this.t-1] |= x<<sh;
                sh += k;
                if(sh >= this.DB) sh -= this.DB;
            }
            if(k == 8 && (s[0]&0x80) != 0) {
                this.s = -1;
                if(sh > 0) this[this.t-1] |= ((1<<(this.DB-sh))-1)<<sh;
            }
            this.clamp();
            if(mi) BigInteger.ZERO.subTo(this,this);
        }

// (protected) clamp off excess high words
        function bnpClamp() {
            var c = this.s&this.DM;
            while(this.t > 0 && this[this.t-1] == c) --this.t;
        }

// (public) return string representation in given radix
        function bnToString(b) {
            if(this.s < 0) return "-"+this.negate().toString(b);
            var k;
            if(b == 16) k = 4;
            else if(b == 8) k = 3;
            else if(b == 2) k = 1;
            else if(b == 32) k = 5;
            else if(b == 4) k = 2;
            else return this.toRadix(b);
            var km = (1<<k)-1, d, m = false, r = "", i = this.t;
            var p = this.DB-(i*this.DB)%k;
            if(i-- > 0) {
                if(p < this.DB && (d = this[i]>>p) > 0) { m = true; r = int2char(d); }
                while(i >= 0) {
                    if(p < k) {
                        d = (this[i]&((1<<p)-1))<<(k-p);
                        d |= this[--i]>>(p+=this.DB-k);
                    }
                    else {
                        d = (this[i]>>(p-=k))&km;
                        if(p <= 0) { p += this.DB; --i; }
                    }
                    if(d > 0) m = true;
                    if(m) r += int2char(d);
                }
            }
            return m?r:"0";
        }

// (public) -this
        function bnNegate() { var r = nbi(); BigInteger.ZERO.subTo(this,r); return r; }

// (public) |this|
        function bnAbs() { return (this.s<0)?this.negate():this; }

// (public) return + if this > a, - if this < a, 0 if equal
        function bnCompareTo(a) {
            var r = this.s-a.s;
            if(r != 0) return r;
            var i = this.t;
            r = i-a.t;
            if(r != 0) return (this.s<0)?-r:r;
            while(--i >= 0) if((r=this[i]-a[i]) != 0) return r;
            return 0;
        }

// returns bit length of the integer x
        function nbits(x) {
            var r = 1, t;
            if((t=x>>>16) != 0) { x = t; r += 16; }
            if((t=x>>8) != 0) { x = t; r += 8; }
            if((t=x>>4) != 0) { x = t; r += 4; }
            if((t=x>>2) != 0) { x = t; r += 2; }
            if((t=x>>1) != 0) { x = t; r += 1; }
            return r;
        }

// (public) return the number of bits in "this"
        function bnBitLength() {
            if(this.t <= 0) return 0;
            return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM));
        }

// (protected) r = this << n*DB
        function bnpDLShiftTo(n,r) {
            var i;
            for(i = this.t-1; i >= 0; --i) r[i+n] = this[i];
            for(i = n-1; i >= 0; --i) r[i] = 0;
            r.t = this.t+n;
            r.s = this.s;
        }

// (protected) r = this >> n*DB
        function bnpDRShiftTo(n,r) {
            for(var i = n; i < this.t; ++i) r[i-n] = this[i];
            r.t = Math.max(this.t-n,0);
            r.s = this.s;
        }

// (protected) r = this << n
        function bnpLShiftTo(n,r) {
            var bs = n%this.DB;
            var cbs = this.DB-bs;
            var bm = (1<<cbs)-1;
            var ds = Math.floor(n/this.DB), c = (this.s<<bs)&this.DM, i;
            for(i = this.t-1; i >= 0; --i) {
                r[i+ds+1] = (this[i]>>cbs)|c;
                c = (this[i]&bm)<<bs;
            }
            for(i = ds-1; i >= 0; --i) r[i] = 0;
            r[ds] = c;
            r.t = this.t+ds+1;
            r.s = this.s;
            r.clamp();
        }

// (protected) r = this >> n
        function bnpRShiftTo(n,r) {
            r.s = this.s;
            var ds = Math.floor(n/this.DB);
            if(ds >= this.t) { r.t = 0; return; }
            var bs = n%this.DB;
            var cbs = this.DB-bs;
            var bm = (1<<bs)-1;
            r[0] = this[ds]>>bs;
            for(var i = ds+1; i < this.t; ++i) {
                r[i-ds-1] |= (this[i]&bm)<<cbs;
                r[i-ds] = this[i]>>bs;
            }
            if(bs > 0) r[this.t-ds-1] |= (this.s&bm)<<cbs;
            r.t = this.t-ds;
            r.clamp();
        }

// (protected) r = this - a
        function bnpSubTo(a,r) {
            var i = 0, c = 0, m = Math.min(a.t,this.t);
            while(i < m) {
                c += this[i]-a[i];
                r[i++] = c&this.DM;
                c >>= this.DB;
            }
            if(a.t < this.t) {
                c -= a.s;
                while(i < this.t) {
                    c += this[i];
                    r[i++] = c&this.DM;
                    c >>= this.DB;
                }
                c += this.s;
            }
            else {
                c += this.s;
                while(i < a.t) {
                    c -= a[i];
                    r[i++] = c&this.DM;
                    c >>= this.DB;
                }
                c -= a.s;
            }
            r.s = (c<0)?-1:0;
            if(c < -1) r[i++] = this.DV+c;
            else if(c > 0) r[i++] = c;
            r.t = i;
            r.clamp();
        }

// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
        function bnpMultiplyTo(a,r) {
            var x = this.abs(), y = a.abs();
            var i = x.t;
            r.t = i+y.t;
            while(--i >= 0) r[i] = 0;
            for(i = 0; i < y.t; ++i) r[i+x.t] = x.am(0,y[i],r,i,0,x.t);
            r.s = 0;
            r.clamp();
            if(this.s != a.s) BigInteger.ZERO.subTo(r,r);
        }

// (protected) r = this^2, r != this (HAC 14.16)
        function bnpSquareTo(r) {
            var x = this.abs();
            var i = r.t = 2*x.t;
            while(--i >= 0) r[i] = 0;
            for(i = 0; i < x.t-1; ++i) {
                var c = x.am(i,x[i],r,2*i,0,1);
                if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1)) >= x.DV) {
                    r[i+x.t] -= x.DV;
                    r[i+x.t+1] = 1;
                }
            }
            if(r.t > 0) r[r.t-1] += x.am(i,x[i],r,2*i,0,1);
            r.s = 0;
            r.clamp();
        }

// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
        function bnpDivRemTo(m,q,r) {
            var pm = m.abs();
            if(pm.t <= 0) return;
            var pt = this.abs();
            if(pt.t < pm.t) {
                if(q != null) q.fromInt(0);
                if(r != null) this.copyTo(r);
                return;
            }
            if(r == null) r = nbi();
            var y = nbi(), ts = this.s, ms = m.s;
            var nsh = this.DB-nbits(pm[pm.t-1]);	// normalize modulus
            if(nsh > 0) { pm.lShiftTo(nsh,y); pt.lShiftTo(nsh,r); }
            else { pm.copyTo(y); pt.copyTo(r); }
            var ys = y.t;
            var y0 = y[ys-1];
            if(y0 == 0) return;
            var yt = y0*(1<<this.F1)+((ys>1)?y[ys-2]>>this.F2:0);
            var d1 = this.FV/yt, d2 = (1<<this.F1)/yt, e = 1<<this.F2;
            var i = r.t, j = i-ys, t = (q==null)?nbi():q;
            y.dlShiftTo(j,t);
            if(r.compareTo(t) >= 0) {
                r[r.t++] = 1;
                r.subTo(t,r);
            }
            BigInteger.ONE.dlShiftTo(ys,t);
            t.subTo(y,y);	// "negative" y so we can replace sub with am later
            while(y.t < ys) y[y.t++] = 0;
            while(--j >= 0) {
                // Estimate quotient digit
                var qd = (r[--i]==y0)?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);
                if((r[i]+=y.am(0,qd,r,j,0,ys)) < qd) {	// Try it out
                    y.dlShiftTo(j,t);
                    r.subTo(t,r);
                    while(r[i] < --qd) r.subTo(t,r);
                }
            }
            if(q != null) {
                r.drShiftTo(ys,q);
                if(ts != ms) BigInteger.ZERO.subTo(q,q);
            }
            r.t = ys;
            r.clamp();
            if(nsh > 0) r.rShiftTo(nsh,r);	// Denormalize remainder
            if(ts < 0) BigInteger.ZERO.subTo(r,r);
        }

// (public) this mod a
        function bnMod(a) {
            var r = nbi();
            this.abs().divRemTo(a,null,r);
            if(this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r,r);
            return r;
        }

// Modular reduction using "classic" algorithm
        function Classic(m) { this.m = m; }
        function cConvert(x) {
            if(x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
            else return x;
        }
        function cRevert(x) { return x; }
        function cReduce(x) { x.divRemTo(this.m,null,x); }
        function cMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }
        function cSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

        Classic.prototype.convert = cConvert;
        Classic.prototype.revert = cRevert;
        Classic.prototype.reduce = cReduce;
        Classic.prototype.mulTo = cMulTo;
        Classic.prototype.sqrTo = cSqrTo;

// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
        function bnpInvDigit() {
            if(this.t < 1) return 0;
            var x = this[0];
            if((x&1) == 0) return 0;
            var y = x&3;		// y == 1/x mod 2^2
            y = (y*(2-(x&0xf)*y))&0xf;	// y == 1/x mod 2^4
            y = (y*(2-(x&0xff)*y))&0xff;	// y == 1/x mod 2^8
            y = (y*(2-(((x&0xffff)*y)&0xffff)))&0xffff;	// y == 1/x mod 2^16
            // last step - calculate inverse mod DV directly;
            // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
            y = (y*(2-x*y%this.DV))%this.DV;		// y == 1/x mod 2^dbits
            // we really want the negative inverse, and -DV < y < DV
            return (y>0)?this.DV-y:-y;
        }

// Montgomery reduction
        function Montgomery(m) {
            this.m = m;
            this.mp = m.invDigit();
            this.mpl = this.mp&0x7fff;
            this.mph = this.mp>>15;
            this.um = (1<<(m.DB-15))-1;
            this.mt2 = 2*m.t;
        }

// xR mod m
        function montConvert(x) {
            var r = nbi();
            x.abs().dlShiftTo(this.m.t,r);
            r.divRemTo(this.m,null,r);
            if(x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r,r);
            return r;
        }

// x/R mod m
        function montRevert(x) {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }

// x = x/R mod m (HAC 14.32)
        function montReduce(x) {
            while(x.t <= this.mt2)	// pad x so am has enough room later
                x[x.t++] = 0;
            for(var i = 0; i < this.m.t; ++i) {
                // faster way of calculating u0 = x[i]*mp mod DV
                var j = x[i]&0x7fff;
                var u0 = (j*this.mpl+(((j*this.mph+(x[i]>>15)*this.mpl)&this.um)<<15))&x.DM;
                // use am to combine the multiply-shift-add into one call
                j = i+this.m.t;
                x[j] += this.m.am(0,u0,x,i,0,this.m.t);
                // propagate carry
                while(x[j] >= x.DV) { x[j] -= x.DV; x[++j]++; }
            }
            x.clamp();
            x.drShiftTo(this.m.t,x);
            if(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
        }

// r = "x^2/R mod m"; x != r
        function montSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

// r = "xy/R mod m"; x,y != r
        function montMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }

        Montgomery.prototype.convert = montConvert;
        Montgomery.prototype.revert = montRevert;
        Montgomery.prototype.reduce = montReduce;
        Montgomery.prototype.mulTo = montMulTo;
        Montgomery.prototype.sqrTo = montSqrTo;

// (protected) true iff this is even
        function bnpIsEven() { return ((this.t>0)?(this[0]&1):this.s) == 0; }

// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
        function bnpExp(e,z) {
            if(e > 0xffffffff || e < 1) return BigInteger.ONE;
            var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e)-1;
            g.copyTo(r);
            while(--i >= 0) {
                z.sqrTo(r,r2);
                if((e&(1<<i)) > 0) z.mulTo(r2,g,r);
                else { var t = r; r = r2; r2 = t; }
            }
            return z.revert(r);
        }

// (public) this^e % m, 0 <= e < 2^32
        function bnModPowInt(e,m) {
            var z;
            if(e < 256 || m.isEven()) z = new Classic(m); else z = new Montgomery(m);
            return this.exp(e,z);
        }

// protected
        BigInteger.prototype.copyTo = bnpCopyTo;
        BigInteger.prototype.fromInt = bnpFromInt;
        BigInteger.prototype.fromString = bnpFromString;
        BigInteger.prototype.clamp = bnpClamp;
        BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
        BigInteger.prototype.drShiftTo = bnpDRShiftTo;
        BigInteger.prototype.lShiftTo = bnpLShiftTo;
        BigInteger.prototype.rShiftTo = bnpRShiftTo;
        BigInteger.prototype.subTo = bnpSubTo;
        BigInteger.prototype.multiplyTo = bnpMultiplyTo;
        BigInteger.prototype.squareTo = bnpSquareTo;
        BigInteger.prototype.divRemTo = bnpDivRemTo;
        BigInteger.prototype.invDigit = bnpInvDigit;
        BigInteger.prototype.isEven = bnpIsEven;
        BigInteger.prototype.exp = bnpExp;

// public
        BigInteger.prototype.toString = bnToString;
        BigInteger.prototype.negate = bnNegate;
        BigInteger.prototype.abs = bnAbs;
        BigInteger.prototype.compareTo = bnCompareTo;
        BigInteger.prototype.bitLength = bnBitLength;
        BigInteger.prototype.mod = bnMod;
        BigInteger.prototype.modPowInt = bnModPowInt;

// "constants"
        BigInteger.ZERO = nbv(0);
        BigInteger.ONE = nbv(1);

        //serivce return object
        function encrptCard(idNumber, modulus, exponent) {
            var rsa = new RSAKey();
            rsa.setPublic(modulus, exponent);
            var encryptCardNumber = rsa.encrypt(idNumber);
            //hex2b64(encriptCardNumber);

            //alert(encryptCardNumber);
            return hex2b64(encryptCardNumber);
        }

        return  encrptCard;
    })


'use strict';
/**
 * Created by Derek Gu on March 2, 2015
 */

angular.module('totesApp')
	.factory('errorHandler', ['resource',
	function (resource) {
		return {
			/**
			 * This is a helper function that extract the error description that can be 
			 * displayed to end-user from the error object returned from backend.js.
			 * Note this function will return a generic maintenance message for non-555 
			 * errors, for specific treatment controller should implement additional logic 
			 * case-by-case.
			 */
			getErrorDescription: function(error) {
				if (!!error.data.status && error.data.status === 555 && !!error.error.message) {
					return error.error.message;
				}
				return resource.get('maintenance_info');
			}
		};

}]);

'use strict';
//angular.module('totesApp')
//  .factory('$exceptionHandler', function ($injector) {
//    return function(exception, cause) {
//      var $rootScope = $injector.get('$rootScope');
//      $rootScope.errors = $rootScope || [];
//      $rootScope.errors.push[exception.message];
//    }
//  });

'use strict';

//document can be found at
// http://projects.rogersnpd.com:8090/display/TOT/API+Documentation

//read this first
//1. to complete disable fake data go to settings.js change useFakeData to false
//2. to disable one ajax method, add a prefix '_', so that real ajax method will be used
//   otherwise, this fake ajax method will be used
angular.module('totesApp').config(['$provide', 'settings', function ($provide, settings) {

	if (!settings.useFakeData) {
		return;
	}

	$provide.decorator('ajax', ['$delegate', 'fakePromise', '$browser',
		function ($delegate, fakePromise, $browser) {

			angular.extend($delegate, {
				_payNow: function (requestObj) {
					return fakePromise(
							{
								success: true
							});
				},
				_getSignature: function () {
					return fakePromise(
							{
								'modulus': '9885751e4505a97dcb7ed8bde723a47aeabca0560563b33dbfdf49c8c0ae029fc893fde57d9af861c171695413849d7fdf356b8323a4bdf05659a398df096ad867159573a21b7b0b8637bd023ade7a37bcdc24550f62844d739dfb0ad7bfc78dcdf2873814a36bfbd607800fd8c409cf00db878b5b5e19a73f33ab191a75ef33',
								'publicExponent': '10001',
								'applicationId': 'rogers.com',
								'timestamp': '1417116040528',
								'signature': 'XB7GZArBYZBS3M5qpVg+FqWDE0U=',
								'serviceVal': 'T',
								'systemIndicatorPrepaid': 'mg-otcc-prepaid',
								'systemIndicator': '',
								'url': 'https://www.qa5.cybs.rogers.com/rogerspop/servlet/POPServlet'
							});
				},
				_billHistory: function (requestObj) {
					return fakePromise(
							{
								'end': true,
								'more': false,
								'total': 4,
								'records': [
									{
										'tranDate': '1417539158163',
										'paidBy': 'credit card',
										'amount': '200',
										'refNum': '12345678'
									},
									{
										'tranDate': '1417539158163',
										'paidBy': 'credit card',
										'amount': '3400',
										'refNum': '4556575'
									},
									{
										'tranDate': '1417539158163',
										'paidBy': 'credit card',
										'amount': '300',
										'refNum': '1233546'
									},
									{
										'tranDate': '1417539158163',
										'paidBy': 'credit card',
										'amount': '200',
										'refNum': '12345678'
									}
								]
							}
					);
				},
				_register: function (regObj) {
					return fakePromise(true);
				},
				_signin: function (userName, password) {
					// $cookies.SMTRYNO = 5;
					$browser.cookies('SMTRYNO', 5);
					return fakePromise('');
				},
				/*
				 signinPermission: function () {
				 return fakePromise({
				 signinWidget: true
				 });
				 },
				 //*/
				_getAccountList: function (user) {
					// test-accounts    http://projects.rogersnpd.com:8090/display/TOT/Test+Accounts
					return fakePromise(
							{
								'accountList': [
									{
										'accountName': {
											'firstName': 'DOIN',
											'lastName': 'AGAIN'
										},
										'accountDetails': {
											'present': true
										},
										'accountNumber': '230314384201',
										'nickname': 'nickname',
										'accountTypeNumber': 6,
										'accountStatus': 'Open'//'Suspended', 'Active'
									},
									{
										'accountName': {
											'firstName': 'TWO',
											'lastName': 'OLGA'
										},
										'accountDetails': {
											'present': true
										},
										'accountTypeNumber': '9',
										'accountNumber': '712203827',
										'nickname': 'nickname2',
										'accountStatus': 'Suspended',
										'pinNumber': '1211'
									},
									{
										'accountName': {
											'firstName': 'THREE',
											'lastName': 'OLGA'
										},
										'accountDetails': {
											'present': true
										},
										'accountTypeNumber': '9',
										'accountNumber': '712203868',
										'accountStatus': 'Cancelled',
										'pinNumber': '1211'
									},
									{
										'accountStatus': 'Open',
										'accountName': {
											'firstName': 'XA',
											'lastName': 'XA'
										},
										'accountDetails': {
											'present': true
										},
										'nickname': 'nickname',
										'accountTypeNumber': 1,
										'accountNumber': '716942875'
									}
								]
							}
					);
				},
				_getAccountDetail: function (accountNumber, language) {

					return fakePromise(
//                    {
//                        'accBalanceLastUpdt': 0,
//                        'accFidoRewardsLastUpdt': 0,
//                        'accHupDeliveryLastUpdt': 0,
//                        'accHupEligibilityLastUpdt': 0,
//                        'accLoyaltyLastUpdt': 0,
//                        'accProfileLastUpdt': 0,
//                        'accountBalance': {
//                            'balanceAmount': '86.35',
//                            'billDueDate': 'Oct-30-14',
//                            'consolidated': false,
//                            'creditAvailable': '123.0',
//                            'creditLimit': '500.0',
//                            'franchise': 'W',
//                            'lastPaymentAmount': '0.0',
//                            'methodOfPayment': {
//                                'mopType': 'R'
//                            },
//                            'nextBillDate': 'Nov-04-14'
//                        },
//                        'accountTypeNumber' : 'WIRELESS',
//                        'accountInfo': {
//                            'accSubType': 'Regular',
//                            'accType': 'Consumer',
//                            'code': 0,
//                            'franchise': 'W',
//                            'status': 'Open'
//                        },
//                        'accountName': {
//                            'firstName': 'POSTPAID',
//                            'lastName': 'TOTES'
//                        },
//                        'accountNumber': '716929443',
//
//                        'internetUsageLastUpdt': 0,
//                        'isAccountHolder': true,
//                        'lob': 'WL',
//                        'accountStatus': 'Cancelled',
//                        'subList': [
//                            {
//                                'isAccountHolder': true,
//                                'subAccountId': '712137454',
//                                'subDataDTO': {
//                                    'activeSubscriptionLastUpdt': 0,
//                                    'buddyInfoLastUpdt': 0,
//                                    'maxBuddyLastUpdt': 0,
//                                    'subNumber': '6473000009',
//                                    'usageMap': {  }
//                                },
//                                'subNumber': '6473000009',
//                                'subType': 'CTN'
//                            },
//                            {
//                                'isAccountHolder': true,
//                                'subAccountId': '210423604',
//                                'subDataDTO': { 'activeSubscriptionLastUpdt': 0,
//                                    'buddyInfoLastUpdt': 0,
//                                    'maxBuddyLastUpdt': 0,
//                                    'subNumber': '9C972683EFDF',
//                                    'usageMap': {  }
//                                },
//                                'subNumber': '9C972683EFDF',
//                                'subType': 'Rogers Smart Home Monitoring'
//                            },
//                            {
//                                'isAccountHolder': true,
//                                'subAccountId': '21045735',
//                                'subDataDTO': { 'activeSubscriptionLastUpdt': 0,
//                                    'buddyInfoLastUpdt': 0,
//                                    'maxBuddyLastUpdt': 0,
//                                    'subNumber': 'TR456322',
//                                    'usageMap': {  }
//                                },
//                                'subNumber': 'TR456322',
//                                'subType': 'Digital TV'
//                            }
//                        ]
//                    }

							{
								'lob': 'WL',
								'isAccountHolder': true,
								'accountNumber': '716942875',
								'accountBalance': {
									'franchise': 'W',
									'lastPaymentAmount': '0.0',
									'creditLimit': '0.0',
									'creditAvailable': '296.35',
									'consolidated': false,
									'nextBillDate': 'Dec-04-14',
									'billDueDate': 'Jul-07-14',
									'methodOfPayment': {
										'mopType': 'R'
									},
									'balanceAmount': '103.65'
								},
								'accountName': {
									'firstName': 'XA',
									'lastName': 'XA'
								},
								'accountInfo': {
									'accType': 'Consumer',
									'accSubType': 'Regular',
									'franchise': 'W',
									'code': 0,
									'status': 'Open'
								},
								'subList': [
									{
										'subNumber': '4162780218',
										'isAccountHolder': true,
										'subType': 'CTN',
										'subAccountId': '716942982',
										'subDataDTO': {
											'buddyInfoLastUpdt': 0,
											'activeSubscriptionLastUpdt': 0,
											'maxBuddyLastUpdt': 0,
											'usageMap': {},
											'subNumber': '4162780218'
										}
									}
								]
							}
					);
				},
				/*
				 _getAccountDetail_new : function(accountNumber, language){
				 return fakePromise(
				 {
				 'accountBalance' : { 'balanceAmount' : '0.0',
				 'bonusBalanceAmount' : '0.0',
				 'realBalanceAmount' : '0.0'
				 },
				 'accountInfo' : { 'expiryDate' : 'Jul 5, 2015 12:00:00 AM',
				 'pricePlan' : { 'category' : 'REGULAR',
				 'descirption' : 'By the Minute - Talk Anytime plan',
				 'name' : 'PPDMM0401',
				 'serviceProvider' : 'ROGERS'
				 },
				 'status' : 'Deactive'
				 },
				 'accountName' : { 'firstName' : 'PREPAID',
				 'lastName' : 'TOTES'
				 },
				 'accountNumber' : '712137546',
				 'ctnNumber' : '6473000010',
				 'isAccountHolder' : false,
				 'pinNumber' : '0110'
				 }

				 );
				 },
				 //*/
				_getSecureQuestion: function () {
					return fakePromise({
						'fn': 'IRS234NT-R24SITNI',
						'cToken': '2389429ne234nin',
						'question': '1'
					});
				},
				_getRegisteredUserName: function () {
					return fakePromise({
						'fn': 'IRS234NT-R24SITNI',
						'cToken': '2389429ne234nin',
						'username': 'somebody'
					});
				},
				_forgetPassword: function () {
					return fakePromise({
						'success': '1'
					});
				},
				_getEmail: function () {
					return fakePromise({
						email: 'olga.v2.nosova@gmail.com'
					});
				},
				_updateUsername: function (email) {
					return fakePromise({
						'success': '1'
					});
				},
				_linkPostPaidAccount: function () {
					return fakePromise({
						'success': true
					});
				},
				_linkPrepaidAccount: function () {
					return fakePromise({
						'success': true
					});
				},
				_getRewards: function (accountNo, language) {
					var returnJson =
							{
								'lastSearchOrder': 'NOT_SORTED',
								'allPromotionsSortOrder': 'NOT_SORTED',
								'popularPromotionsSortOrder': 'NOT_SORTED',
								'newPromotionsSortOrder': 'NOT_SORTED',
								'promotionsSortOrder': 'NOT_SORTED',
								'rewardsNewSortOrder': 'NOT_SORTED',
								'rewardsPopularSortOrder': 'NOT_SORTED',
								'rewardsAllSortOrder': 'NOT_SORTED',
								'membershipID': '22396612',
								'ecid': '436262890',
								'membershipProgram': 'O',
								'membershipStatus': 'ACTIVE',
								'currentBalance': 2033,
								'pendingBalance': 185,
								'numberOfRedemptions': 0,
								'gracePeriodRemaining': -1,
								'targeted': true,
								'membershipEligible': true,
								'accountsData': {
									'712136837': {
										'eligible': true,
										'sourceSystem': 'V',
										'number': '712136837',
										'name': 'HOMEPHONE TOTES',
										'shipmentAddress': {
											'city': 'TORONTO',
											'province': 'ON',
											'postalCode': 'M5A4S9',
											'contactPhone': '4168146541',
											'firstName': 'HOMEPHONE',
											'lastName': 'TOTES',
											'streetName': 'ADELAIDE ST E',
											'apartmentNumber': '3',
											'houseNumber': '330'

										},
										'subscriptions': [
											{
												'typeCode': 'B',
												'typeName': 'BSN',
												'subscriberNumber': '3031461643',
												'visible': false
											},
											{
												'typeCode': 'D',
												'typeName': 'Home Phone',
												'subscriberNumber': '4165190062',
												'visible': false
											}
										]
									},
									'230314616403': {
										'eligible': true,
										'sourceSystem': 'S',
										'number': '230314616403',
										'name': 'HOMEPHONE TOTES',
										'shipmentAddress': {
											'city': 'TORONTO',
											'province': 'ON',
											'postalCode': 'M5A4S9',
											'contactPhone': '4168146541',
											'firstName': 'HOMEPHONE',
											'lastName': 'TOTES',
											'streetName': 'ADELAIDE ST E',
											'apartmentNumber': '3',
											'houseNumber': '330'
										},
										'subscriptions': [
											{
												'typeCode': '2',
												'typeName': 'Digital TV',
												'visible': true
											},
											{
												'typeCode': '9',
												'typeName': 'Home Phone',
												'subscriberNumber': '4165190062',
												'visible': true
											},
											{
												'typeCode': '1',
												'typeName': 'Cable TV',
												'visible': true
											},
											{
												'typeCode': '11',
												'typeName': 'Long Distance',
												'visible': false
											}
										]
									}
								}
							};

//                return fakePromise({
//                    'StatusName': 'Enrolled',  //Not-Enrolled
//                    'PointsBalance': returnJson.currentBalance, //'2436',
//                    'PendingPointsBalance': '110'
//                });
					return fakePromise(returnJson);
				},
				// make a payment with interac
				_interacEligibility: function (accountNumber, accountType, amountDue, amount) {
					var requestObj = {
						language: 'EN',
						accountNumber: accountNumber,
						accountTypeNumber: accountType,
						amountDue: amountDue,
						amount: amount
					};
					return {};
				},
				//call this method with the response from interacEligibility directly.
				_interacMakePayment: function (requestObj) {
					return {};
				},
				_internetDashboard: function (accountNumber, language) {
					var passJson = {
						accountNumber: accountNumber, //accountNo,
						language: language
					};


					return fakePromise(
							{
								'serviceName': 'Hi-Speed Internet',
								'deviceName': '',
								'planName': '',
								'serviceType': 'High Speed Internet',
								'internetUsageToolVO': {
									'dayToDayVO': [{
											'billPeriodEndDate': '01/19/2015',
											'billPeriodStartDate': '12/20/2014',
											'billDate': 'Sat Dec 20 00:00:00 EST 2014 - Mon Jan 19 00:00:00 EST 2015',
											'dailyBillTotalUsageMB': 37888,
											'dailyBillTotalUsageGB': 37.00,
											'roundedUploadExtraUsage': 12.00,
											'usageAllowance': 25600,
											'periodUploadChargeAmount': 48.00,
											'usageAllowanceDailyGB': 25.00,
											'usageAllowanceDailyTB': 0.0244140625,
											'dailyUsageList': [
												{
													'downLoadUsage': 0,
													'upLoadUsage': 0,
													'totalDailyUsage': 0,
													'usageDate': '12/20/2015'
												},
												{
													'downLoadUsage': 0,
													'upLoadUsage': 0,
													'totalDailyUsage': 0,
													'usageDate': '12/21/2015'
												},
												{
													'downLoadUsage': 0,
													'upLoadUsage': 0,
													'totalDailyUsage': 0,
													'usageDate': '12/22/2015'
												},
												{
													'downLoadUsage': 15360,
													'upLoadUsage': 22528,
													'totalDailyUsage': 37888,
													'usageDate': '01/05/2015'
												},
												{
													'downLoadUsage': 0,
													'upLoadUsage': 0,
													'totalDailyUsage': 0,
													'usageDate': '01/06/2015'
												}

											],
											'usageAvailable': 'Y'
										}],
									'prevMonthlyHistoryVO': [{
											'billPeriodEndDate': 'Jul 12, 2015 12:00:00 AM',
											'billPeriodStartDate': 'Jan 11, 2016 12:00:00 AM',
											'totalUsage': 37.00,
											'totalExtraCharge': 48.00,
											'additionalUsage': 12.00,
											'usageAllowance': 25.00,
											'usageAllowanceTB': 0.0244140625
										}],
									'errorCodeCurrentUsageAvailable': 'NoUsage'
								},
								'internetUsageTotal': 25.0,
								'internetUsageUsed': 37.0,
								'internetUsageRemaining': 0.0,
								'internetUsageOverage': 0.0,
								'internetUnlimitedCapLimit': 0.0,
								'displaySpeedBoostLink': true,
								'displayUpgradeLink': false,
								'displayChangeTierLink': false,
								'displayChangePlanLink': true,
								'displayUpsellLink': false,
								'displayShopLink': false,
								'displayHiSpeedLink': true,
								'displayMoveServicesLink': true,
								'displayWirelessInternetChangePlanLink': false,
								'displayTestMyServicesLink': true,
								'displayHiSpeedUpsellLinks': false,
								'displayPortableUpsellLinks': false,
								'displayMobileInternetUsageMeter': true,
								'displayWriteReviewLink': false,
								'displayRssLink': false,
								'displayYahooMailButton': true,
								'isUnlimitedUsage': false,
								'displayAppointmentLink': true,
								'usageUnavailableFlag': false,
								'displayMobileInternetChangeSIMLink': false
							}
					);
				},
				_tvDashboard: function (accountNumber, language) {
					var passJson = {
						accountNumber: accountNumber, //accountNo,
						language: language
					};
					return fakePromise(
							{
								'cableTvDetails': {
									'packageDescription': 'VIP Digital Movies Plus',
									'myExtras': [
										{
											'name': 'Sports VIP Pack',
											'label': 'c'
										},
										{
											'name': 'Extra Channels',
											'label': 'c'
										}
									],
									'channelsList': [
										'Digital Services Fee ',
										'Digital Services Fee ',
										'Super Sports Pak ',
										'The Movie Network ',
										'TMN Encore ',
										'Superstation Pack ',
										'The Biography Channel ',
										'FYI ',
										'The independent Film Channel ',
										'Mystery ',
										'G4techTV ',
										'National Geographic ',
										'BBC Canada ',
										'Action ',
										'BBC Kids ',
										'Sundance Channel ',
										'Investigation Discovery ',
										'Nickelodeon ',
										'DUSK ',
										'Comedy Gold ',
										'Fox Sportsworld Canada ',
										'Discovery Science ',
										'Animal Planet ',
										'MSNBC ',
										'Lifetime ',
										'DejaView ',
										'Gameshow Network ',
										'NFL Network ',
										'DIY Network '
									],
									'hardwareList': [
										'Digital Terminal Rental ',
										'NextBox 3.0 HDPVR Rental ',
										'NextBox HDPVR Purchase '
									]
								}
							}
					);
				},
				_shmDashboard: function (accountNumber, language) {
					var passJson = {
						accountNumber: accountNumber, //accountNo,
						language: language
					};
					return fakePromise(
							{
								'cableTvDetails': {
									'packageDescription': 'VIP Digital Movies Plus',
									'myExtras': [
										{
											'name': 'Sports VIP Pack',
											'label': 'c'
										},
										{
											'name': 'Extra Channels',
											'label': 'c'
										}
									],
									'channelsList': [
										'Digital Services Fee ',
										'Digital Services Fee ',
										'Super Sports Pak ',
										'The Movie Network ',
										'TMN Encore ',
										'Superstation Pack ',
										'The Biography Channel ',
										'FYI ',
										'The independent Film Channel ',
										'Mystery ',
										'G4techTV ',
										'National Geographic ',
										'BBC Canada ',
										'Action ',
										'BBC Kids ',
										'Sundance Channel ',
										'Investigation Discovery ',
										'Nickelodeon ',
										'DUSK ',
										'Comedy Gold ',
										'Fox Sportsworld Canada ',
										'Discovery Science ',
										'Animal Planet ',
										'MSNBC ',
										'Lifetime ',
										'DejaView ',
										'Gameshow Network ',
										'NFL Network ',
										'DIY Network '
									],
									'hardwareList': [
										'Digital Terminal Rental ',
										'NextBox 3.0 HDPVR Rental ',
										'NextBox HDPVR Purchase '
									]
								}
							}
					);
				},
				_closingBS: function (requestObj) {
					return {};
				},
        _checkProfileComplete: function (requestObj) {
          return fakePromise(
            {
              'modulus': '9885751e4505a97dcb7ed8bde723a47aeabca0560563b33dbfdf49c8c0ae029fc893fde57d9af861c171695413849d7fdf356b8323a4bdf05659a398df096ad867159573a21b7b0b8637bd023ade7a37bcdc24550f62844d739dfb0ad7bfc78dcdf2873814a36bfbd607800fd8c409cf00db878b5b5e19a73f33ab191a75ef33',
              'publicExponent': '10001',
              'applicationId': 'rogers.com',
              'timestamp': '1417116040528',
              'signature': 'XB7GZArBYZBS3M5qpVg+FqWDE0U=',
              'serviceVal': 'T',
              'systemIndicatorPrepaid': 'mg-otcc-prepaid',
              'systemIndicator': '',
              'url': 'https://www.qa5.cybs.rogers.com/rogerspop/servlet/POPServlet'
            });
        }
			});

			return $delegate;
		}]);
}]);



'use strict';

angular.module('totesApp')
    .factory('fakePromise', ['$q', function ($q) {
        return  function (fakeValue) {
            var deferred = $q.defer();
            deferred.resolve(fakeValue);
            return deferred.promise;
        };
    }]);

(function () {
  'use strict';

  angular.module('totesApp').service('keepAliveService', keepAliveService);

  keepAliveService.$inject = ['$http', 'user', 'ajax','settings', 'localStorage', 'sessionStorage', '$window', '$rootScope' , '$injector', '$browser'];

  function keepAliveService($http, user, ajax,settings, localStorage, sessionStorage, $window, $rootScope,$injector, $browser) {

    var service = {
      validateSession: validateSession
    };

    function validateSession() {
             $http.get("/web/smb/cms/selfserve/authorizeConfigData.json").then(
                  function (response) {
                      if (response.data) {
                         var envName = settings.prodEnvName;
                         if (settings.isDevMBH) {
                             envName = settings.devEnvName;
                         } else if (settings.isQaMBH) {
                             envName = settings.qaEnvName;
                         }
                         var configData = response.data[envName];
                         var statusUrl = configData.statusUrl;
                         $http.get(statusUrl).then(
                               function (response) {
                                  if (response.data['activeSessionFound'] == true || response.data['activeSessionFound'] == "true") {
                                      var janrainOidc = $injector.get('janrainOidc');
                                      if (!($browser.cookies()['bss-info']) && !($browser.cookies()['CONSENT_STATE'])) {
                                          janrainOidc.signIn();
                                      } else if ($browser.cookies()['bss-info']) {
                                          $http.post('/web/smb/api/business/v1/sso/session/status').then(function () {},
                                              function (error) {
                                                user.logout();
                                              });
                                      }
                                  } else if ($browser.cookies()['bss-info']) {
                                     // user.logout();
                                    $http.post('/web/smb/api/business/v1/sso/session/status').then(function () {},
                                             function (error) {
                                               user.logout();
                                             });
                                  }
                               },
                               function (error) {
                              // user.logout();
                              $http.post('/web/smb/api/business/v1/sso/session/status').then(function () {},
                                      function (error) {
                                        user.logout();
                                      });
                               }
                          );
                     }
                  },
                 function (error) {}
              );
    }
    return service;
  }
})();

(function () {
  'use strict';

  angular.module('totesApp').factory('landing', landingService);

  landingService.$inject = ['profileService', 'migrateUserService', 'appState', '$browser', '$cookieStore', 'localStorage', '$window', '$state','$log','$rootScope', 'ajax', 'brtCheck'];

  /* @ngInject */
  function landingService(profileService, migrateuserService, appState, $browser, $cookieStore, localStorage, $window, $state, $log, $rootScope, ajax, brtCheck) {
    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var landingServiceObj = {
      landingRedirect: landingRedirect,
      localPostSignin: localPostSignin
    };

    return landingServiceObj;

    ///////////////////////////////////////////////////////////////
    // Public

    function landingRedirect() {
        // order of redirects
        // 1 - check if need to complete security question (auto-registration)
        // 2 - check if need to username migration

        //profileService.checkProfileComplete().then(function (isComplete) {
        // After successfully completed the profile, the backend cannot tell until user sign-in again.
        // to allow user to continue to account overview, we use cached result from localstorage.
        /*var profileCompletedBefore = localStorage.getLocalStorageValue('profileComplete');
        if (!profileCompletedBefore && !isComplete) {
          appState.switchView('completeProfile');
        } else {
          localStorage.setLocalStorageValue('profileComplete', true);
          }*/

        // 2 - check username migration

//        brtCheck.usermigrate().then(
//            function(data) {
//              console.log("User migrate" + data);
//                if ($rootScope.brtusermigrate) {
//                    migrateuserService.migrateCheck().then(function(needMigrate) {
//
//                        if (needMigrate) {
//                            appState.switchView('migrateuser');
//                        } else {
//                            localStorage.setLocalStorageValue('usernameMigrationComplete', true);
//                            localPostSignin();
//                        }
//
//                    });
//                } else {
//                    localPostSignin();
//                }
//            },
//            function(error) {
//                console.log("Error from BRT imple" + error);
//                localPostSignin();
//            });
        //});

        if ($rootScope.brtusermigrate) {
            migrateuserService.migrateCheck().then(function(needMigrate) {
                if (needMigrate) {
                    appState.switchView('migrateuser');
                } else {
                    localStorage.setLocalStorageValue('usernameMigrationComplete', true);
                    localPostSignin();
                }
            });
        } else {
            localPostSignin();
        }
    }

    ///////////////////////////////////////////////////////////////
    // Private

    function localPostSignin() {
      // Force secure login
      // Already in secure - proceed with regular redirect

      // Read the overide cookie from other projects
      var linkIn = '';

      try {
        linkIn = $browser.cookies().linkIn;
        $cookieStore.remove('linkIn');

        if (linkIn === undefined || linkIn === null || linkIn === 'undefined') {
          linkIn = '';
        }
      } catch (err) {
        // And that's how the cookie crumble.
      }

      // next destination override from other projects
      if (linkIn === '') {
        // Proceed to default page
        var currentStateName = $state.current.name;
        if (currentStateName === 'registration') {                     // MYR-780 fix attempt
          // Exceptional behavior - do nothing in this case
          // SigninService call from registration state
        } else {
          appState.switchView('accountOverview');
          // Proceed to Account overview
               /* ajax.getSecurityQuestionSetup().then(function (data) {
                    // After successfully completed the profile, the backend cannot tell until user sign-in again.
                    // to allow user to continue to account overview, we use cached result from localstorage.
                    var profileCompletedBefore = localStorage.getLocalStorageValue('securityQuestionAnswer');
                    var status;
                    if (data) {
                        var dataObj = angular.fromJson(data);
                        status = dataObj.status;
                        if(!profileCompletedBefore && status){
                        appState.switchView('securityQuestionAnswer');
                        }else{
                            localStorage.setLocalStorageValue('securityQuestionAnswer', true);
                            appState.switchView('accountOverview');
                        }
                    }

                }, function(error){
                     appState.switchView('accountOverview');
                });        */
        }
      } else {
        // Sent the user to the location int cookie (This assumes that the string is valid URL!!)
        var pathArray = linkIn.split('/');
        var deepLinkPath = pathArray[pathArray.length - 1];
        if(deepLinkPath === "choose-plan"){
          $browser.cookies('deepLinkFlow', 'PPC');
          $state.go("accountInitialization");
        }
        else{
          $rootScope.internalRedirect = true;
          $window.location.href = linkIn;
        }
      }
    }
  }

})();


'use strict';

angular
		.module('totesApp')
		.factory('localStorage', ['$window',
			function ($window) {
				var localStorage = {};
				var tokenvalue;
				// Read
				localStorage.getLocalStorageValue = function (key) {
					return $window.localStorage.getItem(key);
				};
				localStorage.getLocalStorageObject = function (key) {
					var valueString = $window.localStorage.getItem(key);
					var valueObject = angular.fromJson(valueString);
					return valueObject;
				};

				// Write
				localStorage.setLocalStorageValue = function (key, val) {
					$window.localStorage.setItem(key, val);
				};
				localStorage.setLocalStorageObject = function (key, val) {
					var valueString = angular.toJson(val);
					$window.localStorage.setItem(key, valueString);
				};

				// Delete
				localStorage.deleteLocalStorageValue = function (key) {
					$window.localStorage.removeItem(key);
				};
				localStorage.deleteLocalStorageObject = function (key) {
					this.deleteLocalStorageValue(key);
				};
                //brt value
				localStorage.getTransferswitch = function (val) {
					transferSwitch = val;
					};
					localStorage.getTransferswitchval = function () {
					return transferSwitch;
					};

				// Clear all
				localStorage.clearAllLocalStorageValues = function () {
				  console.log('inside clearalllocalstorage');
				  var chatKey;
				  var chatValue
          while ($window.localStorage.length > 0) {
					  var key=$window.localStorage.key(0);
					  if(key.includes(":actmu")){
					   chatKey =  key;
					   chatValue = $window.localStorage.getItem(key);
					 }
						$window.localStorage.removeItem($window.localStorage.key(0));
         }
          if(chatKey){
            $window.localStorage.setItem(chatKey,chatValue);
          }
				};
				// Clear all except those mentioned in the array
				localStorage.clearAllLocalStorageValuesExcept = function (theseArr) {
				  for (var i = 0; i < $window.localStorage.length; i++) {
				  var key = $window.localStorage.key(i);
						var keyIndex = theseArr.indexOf($window.localStorage.key(i).split(";|")[0]);
						if (keyIndex >= 0 || key.includes(':actmu')){
							// found it -> skipping this one
						} else {
							$window.localStorage.removeItem($window.localStorage.key(i));
						}
					}
				};
				localStorage.getTokenid = function (val) {
					tokenvalue = val;
				  };
				  localStorage.getTokenidval = function () {
					return tokenvalue;
				  };
				return localStorage;
			}
		]);

(function () {
  'use strict';

  angular.module('totesApp').factory('ocpService', ocpService);

  ocpService.$inject = ['ajax'];

  /* @ngInject */
  function ocpService (ajax) {


    var service = {



	  setLanguage:setLanguage,
	  userLang: "",
    showOcpPopup:true,
    launcherInitialized:false
    };



    return service;



  function setLanguage(language) {

  }

}

})();

'use strict';

angular
		.module('totesApp')
		.factory('permissionResolver', ['$q', '$location', 'settings', 'ajax', '$rootScope', '$browser', 'myrAccountListService', 'appState', 'user', 'userOptions', 'resource', 'localStorage', '$window', 'deeplink', 'landing', 'globalloaderService',
			function ($q, $location, settings, ajax, $rootScope, $browser, myrAccountListService, appState, user, userOptions, resource, localStorage, $window, deeplink, landing, globalloaderService) {
				// Initiate Object
				var pr = {};

				// hook up variables
				pr.data = {};

				// hook up functions
				pr.getPermission = function (toStatePath) {
				  appState.viewPermissionResolved = false;
					var d = $q.defer();

					// Killswitch limit reset every new page visit
					ajax.resetKillSwitches();

					// If server session is expired sent user to sign in!!!
					appState.kickOutExpired();

					// Reject user access alltogether
					var dummyTestPass = true;
					if (dummyTestPass) {
						// Sufficient login level - proceed
					} else {
						$location.path('/permissionDenied');	// Access denied
					}

					// User and Location info
					var userAuth = $rootScope.user.isAuthenticated;
					var userPath = (toStatePath) ? toStatePath : $location.path();

					// Split string based on this pattern /:module/:submodule
					var pathArr = userPath.split('/');
					var module = pathArr[1];

          //rfr specific handling:
          if(module === 'rewards'){
            module = module + '.' + pathArr[2];//i.e. rewards.enroll as found in settings.js pageLoginRequired map
          }

					// Login required - grab data from settings
					var pageLogin = settings.pageLoginRequired[module];
					if (module === 'signnoff') {		// Sign page
						// User is already logged in -> sent them back to Account Overview
						if (userAuth === true) {
							$location.path('/signin');
						} else {
						  appState.viewPermissionResolved = true;
							d.resolve(true);		// show the page
						}
					} else if (module === 'signin') {		// Sign page
            if (userAuth === true) {
              landing.localPostSignin();
              // TODO: this is a temporary fix, need to figure out why hitting the back button causing routing
              // not going through onEnter logic anymore, hence not turning off the spinner.
              globalloaderService.hide();
            } else {
              appState.viewPermissionResolved = true;
              d.resolve(true);		// show the signin page
            }

          } else if (module === 'completeProfile') {
            if (userAuth === false) {
              $location.path('/signin');
            } else {
              var profileComplete = localStorage.getLocalStorageValue('profileComplete');
              if (profileComplete) {
                appState.switchView('accountOverview');
              } else {
                appState.viewPermissionResolved = true;
                // show profile page
                d.resolve(true);
              }
            }
          } else if (module === 'migrateuser') {  // username migration page
            if (userAuth === false) {
              $location.path('/signin');
            } else {
              var usernameMigrationComplete = localStorage.getLocalStorageValue('usernameMigrationComplete');
              if (usernameMigrationComplete) {
                appState.switchView('accountOverview');
              } else {
                appState.viewPermissionResolved = true;
                // show username migration page
                d.resolve(true);
              }
            }
					} else {

            if (userAuth === false && pageLogin === false) {
              appState.viewPermissionResolved = true;
							// All clear - no need to log in
							d.resolve(true);		// show the page

						} else if (userAuth === false && pageLogin === true) {
							// Send user to sign-in page
							$location.path('/signin');
						} else if (userAuth === true && pageLogin === false) {
						  appState.viewPermissionResolved = true;
							// All clear - no need to log in - SignIn page exception handled above
							d.resolve(true);		// show the page

						} else if (userAuth === true && pageLogin === true) {
							// All clear - no need to log in

							// Check if data are alredy present
							if ($rootScope.ao.raw === null) {
								// Show loader bit
//								$rootScope.$broadcast('showGlobalLoader');

                $rootScope.reserveDeviceAvbl = false;
                ajax.getSelfserveConfig().then(
                function (response) {
                    $rootScope.reserveDeviceAvbl = response.reserveDeviceAvbl;
                  }
                );
                /*ajax.checkReserveDevice().then(
                  function(data){
                    if (data.isReserved) {
                      $rootScope.reserveDeviceAvbl = true;
                    }
                  }
                ); */

								// Collect Account list info + permissions info
								var request = {
									refresh: false,
									applicationId: 'Rogers.com'
								};

								// Always get fresh data from server
								ajax.getAccountList(request).then(
										function (data) {
										  var accounts=[];
										  if((data.accountList) && (data.accountList.length >=1)) {
                        for (var i = 0; i < data.accountList.length; i++) {
                          accounts.push(data.accountList[i].accountNumber);
                        }
                      }
										  localStorage.setLocalStorageValue('accounts', accounts);
										  var usrPdt = data.userProduct;
                      if(usrPdt === 'NP')
                        localStorage.setLocalStorageValue('pInd', 'N');
                      else if (usrPdt === 'WL')
                        localStorage.setLocalStorageValue('pInd', 'W');
                      else if (usrPdt === 'C')
                        localStorage.setLocalStorageValue('pInd', 'C');
                      else if (usrPdt === 'WL_C')
                        localStorage.setLocalStorageValue('pInd', 'B');

											// Process through account overview services
											$rootScope.$emit('initializeMbhLauncher', data);
											$rootScope.accountListLength = "";
											$rootScope.mbhAccounts = data;

											data = myrAccountListService.processAccountList(data);
                      $rootScope.accountListLength = data.accountList.length;
                      if (data.accountList.length == 1) {
                          $rootScope.accountListOcp = data.accountList;

                      }
                      $rootScope.isAccountListCacheExpired = false;
                      if(undefined != data.cachedResultInfo && data.cachedResultInfo.expired){
                        $rootScope.isAccountListCacheExpired = true;
                      }
											// Check if user pressed refresh button on browser
                      var localStorageAccountNumber = localStorage.getLocalStorageValue('accountNumber');

											if ($rootScope.ao.accountDetails === null) {
												if (localStorageAccountNumber) {
													// Last selected account cookie exists --->>> Commence reconstruction
													appState.aoReconstruct(localStorageAccountNumber);
												}
											}

											// Hide loader bit
//											$rootScope.$broadcast('hideGlobalLoader');

											// Maintenance redirect
											// Send all traffic to maintenance page with attached request URL and let the maintenance controler cedide which page to show
											if (appState.maintenanceRedirect(userPath)) {
												$location.path('/underMaintenance');
											}

											// Internal deeplinking process verification and state change
											if (deeplink.data.redirect) {
											  appState.viewPermissionResolved = true;
												d.resolve( deeplink.permissionResolverHook(data) );           // Promise within a promise
											} else {
											  appState.viewPermissionResolved = true;
												// Resolve this matter and let the page move on
												if (data.result === 'success') {
													d.resolve(data);
												} else if (data.result === 'redirect') {
													d.resolve(false);
												} else if (data.result === 'fail') {
													d.resolve(false);
												} else {
													// this should not happen
												}
											}

										},
										function (error) {
											//redirect to the maintenance if account list call fails.

											// VERY special treatment for business redirect
											if (error.data.status === 555 && error.error.errorCode === 10490) {
												// DON'T FREAK OUT!!! WE NEED TO PUT THE REDIRECT SOMEWHERE
												$window.location.href = '/business/ss/smb/redesign/dashboard/overview';
												throw new Error('redirected');
											}


											appState.showMaintenance();

											var message = '';
											var errorObj = {};
											var errorJSON = '';

											// Error handling - 555 exception
											if (error.data.status === 555) {
												// Server error that needs further processing
												// additional information for 555 error


												// error.error.errorCode		// 10k - 12.1k & 50k - 51k
												// error.error.errorMessage		// Message as delivered from server
												// error.error.message 			// Message as found in resource file
												// error.error.statusCode		// error status code - 555 in this case

												// Stop the app from going further

												if (error.error.errorCode === 10403) {
													// "errorMessage":"Get postpaid account details failed"
													message += resource.get('error_population_accounts');
													userOptions.alert(message);

													// Stop the process
													errorObj = {};
													errorObj.message = 'User cannot continue to accountOverview due to error on server and accounts are missing.';
													errorObj.res = 'error_population_accounts';

													errorJSON = angular.toJson(errorObj);
													throw new Error(errorJSON);
												}

											} else {
												// anything but status code 555
												if (error.data.status === 302) {
													// redirect to location in the
													$window.location.href = '/business/ss/smb/redesign/dashboard/overview';
												}
												if (error.data.status === 401) {
													// Unauthorized
													message += resource.get('error_population_accounts');
													userOptions.alert(message);

													// Stop the process
													errorObj = {};
													errorObj.message = 'User cannot continue to accountOverview due to error on server and accounts are missing.';
													errorObj.res = 'error_population_accounts';

													errorJSON = angular.toJson(errorObj);
													throw new Error(errorJSON);
												}
												if (error.data.status >= 500 && error.data.status < 555) {
													// Server Error
													message += resource.get('error_population_accounts');
													userOptions.alert(message);

													// Stop the process
													errorObj = {};
													errorObj.message = 'User cannot continue to accountOverview due to error on server and accounts are missing.';
													errorObj.res = 'error_population_accounts';

													errorJSON = angular.toJson(errorObj);
													throw new Error(errorJSON);
												}
											}

											appState.aoFlushScope();
											error.total = -1;
											error.result = 'error';
                      appState.viewPermissionResolved = true;
											d.resolve(false);
										});

							} else {
								// Maintenance redirect
								// Send all traffic to maintenance page with attached request URL and let the maintenance controler cedide which page to show
								if (appState.maintenanceRedirect(userPath)) {
									localStorage.setLocalStorageValue('maintPage', userPath);
									$location.path('/underMaintenance');
								}

								// Check if user pressed refresh button on browser
								var localStorageAccountNumber = null;
								localStorageAccountNumber = localStorage.getLocalStorageValue('accountNumber');

								if (localStorageAccountNumber) {
									// Last selected account cookie exists --->>> Commence reconstruction
									appState.aoReconstruct(localStorageAccountNumber);
								}
                appState.viewPermissionResolved = true;
								// Take all data from storage
								var _storage = $rootScope.ao.raw;
								d.resolve(_storage);
							}

						} else {
						  appState.viewPermissionResolved = true;
							// Unknown state - reboot The Matrix
							d.resolve('Mr. Anderson');
						}
					}

					return d.promise;
				};

				//pr.getNoOfInvalidPasswordAttempts = function () {
				//	var defer = $q.defer();
				//	var data = this.data;
				//	var cookies = $browser.cookies();
				//	data.invalidAttempts = cookies.SMTRYNO;
				//	defer.resolve(data);
				//	return defer.promise;
				//};

				return pr;
			}]);


angular
		.module('totesApp')
		.provider('permissionData', function () {
			var data;

			return {
				$get: function () {
					return data;
				},
				$set: function (value) {
					data = value;
				}
			};
		});

'use strict';

angular.module('totesApp')
	.service('permissionService',['$rootScope','appState', function ($rootScope, appState) {

		// Use for this one? Anybody?

	}]);
'use strict';

angular.module('totesApp')
	.factory('persistentAccessor', ['$browser', function ($browser) {
		return function (key, initialValue) {
			// var _val = $cookies.key;
			var _val = $browser.cookies()[key];

			if (angular.isUndefined(_val)) {
				// $cookies[key] = initialValue;
				$browser.cookies(key, initialValue);
				_val = initialValue;
			} else {
				if (angular.isUndefined(initialValue)) {
					// $cookies[key] = initialValue;
					$browser.cookies(key, initialValue);
				}
			}

			return function (value) {
				if (angular.isUndefined(value)) {
					return _val;
				} else {
					_val = value;
					// $cookies[key] = initialValue;
					$browser.cookies(key, initialValue);
				}
			};
		};
	}]);

'use strict';

angular.module('totesApp')
    .factory('profileService', ['ajax', '$q', '$log', 'resource', function(ajax, $q, $log, resource) {
        var service = {};
        service.checkProfileComplete = function () {
            var mic = $q.defer();
            $log.debug('profileService.checkProfileComplete');

            ajax.checkProfileComplete().then(
                function (data) {
                    $log.debug('checkProfileComplete: ajax=' + data);
                    var isComplete;
                    if (data) {
                        var dataObj = angular.fromJson(data);
                        isComplete = dataObj.complete;
                        mic.resolve(isComplete);
                    }else{
                      mic.reject();
                    }

                },
                function (error) {
                    $log.error('Calling /checkProfileComplete failed');
                    mic.reject();
                }
            );

            return mic.promise;
        };

        return service;
    }]);


'use strict';

angular
        .module('totesApp')
        .factory('resource', ['$http', '$q', '$rootScope', 'userLanguage', 'util',
          function ($http, $q, $rootScope, userLanguage, util) {

            var resourceCache;
            var resourceURL = '/cmsbusiness/BFA/SelfServe/json/';

            $rootScope.$watch(function () {
              return userLanguage();
            }, function (lang) {
              resourceCache = $http.get(resourceURL + lang + '.json').then(function (response) {
                resourceCache = response.data;
                $rootScope.$broadcast(rtn.changedEvent);
                return resourceCache;
              });
            });

            var changedEvent = 'resourceChanged';
            var rtn = {
              changedEvent: changedEvent,
              resolveResource: function () {
                var deferred = $q.defer();
                var lang = userLanguage();

                $http.get(resourceURL + lang + '.json')
                        .then(function (response) {
                          resourceCache = response.data;
                          $rootScope.$broadcast(changedEvent);
                          deferred.resolve(true);
                        }, function (error) {
                          //deferred.reject( error );
                          throw error;
                        }
                        );
                return deferred.promise;
              },
              get: function (resourceId, substituions) {
                if (!resourceCache || util.isPromise(resourceCache)) {
                  return '';
                } else {
                  var text = resourceCache[resourceId];
                  if (substituions && text) {
                    text = text.supplant(substituions);
                  }
                  if (angular.isUndefined(text)) {
                    //silent fail
                    text = '';
                    //throw new Error('resource for {0} does not exists'.format(resourceId));
                  }
                  return text;
                }
              },
              //evaluateImmediately is optional by default is true
              onChanged: function (evaluateImmediately, fn, scope) {
                if (angular.isFunction(evaluateImmediately)) {
                  scope = fn;
                  fn = evaluateImmediately;
                  evaluateImmediately = true;
                }
                if (evaluateImmediately) {
                  fn();
                }
                scope.$on(rtn.changedEvent, fn);
              }
            };

            return rtn;
          }]);

'use strict';

angular
		.module('totesApp')
		.factory('sessionStorage', ['$window',
			function ($window) {
				var sessionStorage = {};

				// Read
				sessionStorage.getSessionStorageValue = function (key) {
					return $window.sessionStorage.getItem(key);
				};
				sessionStorage.getSessionStorageObject = function (key) {
					var valueString = $window.sessionStorage.getItem(key);
					var valueObject = angular.fromJson(valueString);
					return valueObject;
				};

				// Write
				sessionStorage.setSessionStorageValue = function (key, val) {
					$window.sessionStorage.setItem(key, val);
				};
				sessionStorage.setSessionStorageObject = function (key, val) {
					var valueString = angular.toJson(val);
					$window.sessionStorage.setItem(key, valueString);
				};

				// Delete
				sessionStorage.deleteSessionStorageValue = function (key) {
					$window.sessionStorage.removeItem(key);
				};
				sessionStorage.deleteSessionStorageObject = function (key) {
					this.deleteSessionStorageValue(key);
				};

				// Clear all
				sessionStorage.clearAllSessionStorageValues = function () {
				  // console.log('inside clearalllocalstorage');
					while ($window.sessionStorage.length > 0) {
						$window.sessionStorage.removeItem($window.sessionStorage.key(0));
					}
				};

				// Clear all except those mentioned in the array
				sessionStorage.clearAllSessionStorageValuesExcept = function (theseArr) {
					while ($window.sessionStorage.length > 0) {
						var keyIndex = theseArr.indexOf($window.sessionStorage.key(0));
						if (keyIndex >= 0){
							// found it -> skipping this one
						} else {
							$window.sessionStorage.removeItem($window.sessionStorage.key(0));
						}
					}
				};

				return sessionStorage;
			}
		]);


'use strict';


angular.module('totesApp')
    .factory('sync', ['$rootScope', function ($rootScope) {
        //synchronize the property value between two objects a and b

        // let login.userName follow the change of person.name
        //sync(person, "name", login, "userName");

        // let login.userName follow the change of person.name and person.name follow the change of login.userName
        //sync(person, "name", login, "userName", true);
        return function (srcObj, srcProp, targetObj, targetProp, twoWay) {

            targetProp = targetProp || srcProp;

            var scope = targetObj.$apply ? targetObj : $rootScope;

            //when object a change, then copy the value to object b
            scope.$watch(function () {
                return srcObj[srcProp];
            }, function (value) {
                targetObj[targetProp] = value;
            });

            if (twoWay) {
                //when object b change, then copy the value to object b
                scope.$watch(function () {
                    return targetObj[targetProp];
                }, function (value) {
                    srcObj[srcProp] = value;
                });
            }
        };
    }]);

'use strict';


angular.module('totesApp')
    .factory('syncOnce',['$rootScope', function ($rootScope) {

        return function (srcObj, srcProp, targetObj, targetProp) {

            targetProp = targetProp || srcProp;

            var scope = targetObj.$apply ? targetObj : $rootScope;


            var unwatch = scope.$watch(function () {

                return srcObj[srcProp];

            }, function (value) {
                if (angular.isDefined(value)) {
                    targetObj[targetProp] = value;
                    unwatch();
                }
            });
        };
    }]);



/**
 * Created by james.magpantay on 2/10/2016.
 */

(function () {

  'use strict';


  angular
    .module('totesApp')
    .factory('uccBanner', uccBanner);

  uccBanner.$inject = ['$q', '$location', '$cookies', '$rootScope', '$state', '$window', 'settings', 'ajax'];

  function uccBanner($q, $location, $cookies, $rootScope, $state, $window, settings, ajax) {

    var service = {
      getUccLinks: getUccLinks
    };

    return service;


    function getUccLinks(){
      return ajax.getUccLinks().then(
        function (data) {

          return data;
        }, function (error) {

          return error;

        }
      );
    }
  }
})();



/**
 * Created by OlgaN on 9/14/2015.
 */
// jshint ignore: start
'use strict';

angular
  .module('totesApp')
  .constant( 'offerUrl',
  {
    default: {
      'en': {
        'spotifyComplementary': 'http://www.rogers.com/web/support/wireless/share-everything-plus/2194',
        'spotifyRegistration': 'https://accounts.spotify.com/en/authorize?client_id=',
        'spotifyLogout': 'https://accounts.spotify.com/en/logout?continue=',
        'spotifyCancellation': 'https://www.spotify.com/account/cancel/confirm/partner/',
        'rogersChat': 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?source=707',
        'upgradePlanUrl': 'http://www.rogers.com/consumer/wireless/share-everything?setLanguage=en'
      },
      'fr': {
        'spotifyComplementary': 'http://www.rogers.com/web/support/wireless/share-everything-plus/2194',
        'spotifyRegistration': 'https://accounts.spotify.com/fr-ca/authorize?client_id=',
        'spotifyLogout': 'https://accounts.spotify.com/fr/logout?continue=',
        'spotifyCancellation': 'https://www.spotify.com/ca-fr/account/cancel/confirm/partner/',
        'rogersChat': 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?source=757',
        'upgradePlanUrl': 'http://www.rogers.com/consumer/wireless/share-everything?setLanguage=fr'
      }
    },
    offers: {
      spotify: {
        default: {
          'en': 'https://www.spotify.com/ca-en/download/',
          'fr': 'https://www.spotify.com/ca-fr/login/'
        },
        defaultOthers: {
          'en': 'https://www.spotify.com/ca-en/download/',
          'fr': 'https://www.spotify.com/ca-fr/login/'
        },
        iOS: {
          version: '6.0',
          mobile: {
            'en': 'https://itunes.apple.com/ca/app/spotify-music/id324684580',
            'fr': 'https://itunes.apple.com/ca/app/spotify-music/id324684580?l=fr'
          },
          tablet: {
            'en': 'https://itunes.apple.com/ca/app/spotify-music/id324684580',
            'fr': 'https://itunes.apple.com/ca/app/spotify-music/id324684580?l=fr'
          }
        },
        Android: {
          version: '4.4',
          mobile: {
            'en': 'https://play.google.com/store/apps/details?id=com.spotify.music',
            'fr': 'https://play.google.com/store/apps/details?id=com.spotify.music&hl=fr'
          },
          tablet: {
            'en': 'https://play.google.com/store/apps/details?id=com.spotify.music',
            'fr': 'https://play.google.com/store/apps/details?id=com.spotify.music&hl=fr'
          }
        },
        'Windows Phone': {
          version: '8.0',
          'en': 'https://www.microsoft.com/en-ca/store/apps/spotify/9wzdncrfj4wk',
          'fr': 'https://www.microsoft.com/fr-ca/store/apps/spotify/9wzdncrfj4wk'
        },
        Blackberry: {
          version: '10.0',
          'en': 'http://www.amazon.ca/Spotify-Music/dp/B00KLBR6IC',
          'fr': 'http://www.amazon.ca/gp/switch-language/product/B00KLBR6IC/ref=cs_switchlang?ie=UTF8&language=fr_CA'
        }
      },
      nextissue: {
        default: {
          'en': 'https://www.nextissue.ca/appdownload',
          'fr': 'https://www.nextissue.ca/telecharger'
        },
        defaultOthers: {
          'en': 'https://www.nextissue.ca/appdownload',
          'fr': 'https://www.nextissue.ca/telecharger'
        },
        iOS: {
          version: '5.0',
          mobile: {
            'en': 'https://itunes.apple.com/ca/app/rogers-next-issue/id649174756',
            'fr': 'https://itunes.apple.com/ca/app/rogers-next-issue/id649174756?l=fr'
          },
          tablet: {
            'en': 'https://itunes.apple.com/ca/app/rogers-next-issue/id649174756',
            'fr': 'https://itunes.apple.com/ca/app/rogers-next-issue/id649174756?l=fr'
          }
        },
        Android: {
          version: '3.1',
          mobile: {
            'en': 'https://play.google.com/store/apps/details?id=com.nim.rogers',
            'fr': 'https://play.google.com/store/apps/details?id=com.nim.rogers&hl=fr'
          },
          tablet: {
            'en': 'https://play.google.com/store/apps/details?id=com.nim.rogers',
            'fr': 'https://play.google.com/store/apps/details?id=com.nim.rogers&hl=fr'
          }
        },
        'Windows Phone': {
          version: '8.0',
          'en': 'https://www.nextissue.ca/en/device-windows/',
          'fr': 'https://www.nextissue.ca/fr/device-windows-fr/'
        },
        Blackberry: {
          version: '10.0',
          'en': 'https://www.nextissue.ca/appdownload',
          'fr': 'https://www.nextissue.ca/telecharger'
        }
      },
      shomi: {
        default: {
          'en': 'https://my.shomi.com/signin',
          'fr': 'https://my.shomi.com/signin?lang=fr'
        },
        defaultOthers: {
          'en': 'http://discover.shomi.com/devices',
          'fr': 'http://discover.shomi.com/devices?lang=fr'
        },
        iOS: {
          version: '7.0',
          mobile: {
            'en': 'https://itunes.apple.com/ca/app/shomi-for-iphone/id925867624',
            'fr': 'https://itunes.apple.com/ca/app/shomi-for-iphone/id925867624?l=fr'
          },
          tablet: {
            'en': 'https://itunes.apple.com/ca/app/shomi/id925878292',
            'fr': 'https://itunes.apple.com/ca/app/shomi/id925878292?l=fr'
          }
        },
        Android: {
          version: '4.0',
          mobile: {
            'en': 'https://play.google.com/store/apps/details?id=com.shomi.phone',
            'fr': 'https://play.google.com/store/apps/details?id=com.shomi.phone&hl=fr'
          },
          tablet: {
            'en': 'https://play.google.com/store/apps/details?id=com.shomi.tablet',
            'fr': 'https://play.google.com/store/apps/details?id=com.shomi.tablet&hl=fr'
          }
        },
        'Windows Phone': {
          version: '8.0',
          'en': 'http://discover.shomi.com/devices',
          'fr': 'http://discover.shomi.com/devices?lang=fr'
        },
        Blackberry: {
          version: '10.0',
          'en': 'http://discover.shomi.com/devices',
          'fr': 'http://discover.shomi.com/devices?lang=fr'
        }
      }
    }

  }
);
angular
  .module('totesApp')
  .factory( 'urlDevice', ["offerUrl", function( offerUrl ) {

    var urlDevice = {

      // this function is used in my account  in procedural way -  device-check.js
      checkPhone: function() {

        var isSmart = true,
          device = '',
          obj;

        try {
          var clientWidth = document.documentElement && document.documentElement.clientWidth;

          if (clientWidth == undefined || (+clientWidth) > 240) {
            isSmart = true;
          } else {
            isSmart = false;
          }

          var parser = new UAParser(),              // instance of UA-check third party library ->  http://faisalman.github.io/ua-parser-js/
            result = parser.getResult(),
            deviceType = result.device.type,		     // mobile, tablet, undefined
            osName = result.os.name,				         // Android, iOS, BlackBerry, Windows Phone, Symbian
            osVersion = result.os.version,			     // '4.1', '7.0', '10', '8.0', '2.3.5' ... etc
            osVersionFloat = parseFloat( osVersion );  // Crunch the OS version number string into a float value

          // Device Name.
          device = osName;

          if (osName === 'iOS' && osVersionFloat < 6) {
            isSmart = false;
          } else if (osName === 'Android' && osVersionFloat < 4) {
            isSmart = false;
          } else if (osName === 'BlackBerry') {
            if (osVersionFloat >= 10) {
              isSmart = true;
              device = osName + '10+';
            } else {
              isSmart = false;
            }
          } else if (osName === 'Windows Phone' && osVersionFloat < 8) {
            isSmart = false;
          } else {
            // Leave it at the default value
          }
        } catch (e) {
          // An error has occurred so we will default to smart layout.
          isSmart = false;
        }

        obj = {
          'isSmart': isSmart,
          'device': device,
          'osName': osName,
          'deviceType': deviceType,
          'osVersion': osVersion,
          'version': osVersionFloat
        };

        return obj;

      },
      findUrl: function() {
        var urls = {},
          obj = offerUrl.offers,
          getDeviceInfo = urlDevice.checkPhone();

        for (var key in obj) {
          if (obj.hasOwnProperty( key )) {
            if (getDeviceInfo.device === 'iOS' && (parseFloat( getDeviceInfo.osVersion ).toFixed( 1 ) >= parseFloat( obj[key][getDeviceInfo.device].version ) )) {
              if (getDeviceInfo.deviceType === 'tablet') {
                urls[key] = obj[key][getDeviceInfo.device].tablet;
              }
              else {
                urls[key] = obj[key][getDeviceInfo.device].mobile;
              }
            }
            else if (getDeviceInfo.device === 'Android' && (parseFloat( getDeviceInfo.osVersion ).toFixed( 1 ) >= parseFloat( obj[key][getDeviceInfo.device].version ) )) {
              if (getDeviceInfo.deviceType === 'tablet') {
                urls[key] = obj[key][getDeviceInfo.device].tablet;
              }
              else {
                urls[key] = obj[key][getDeviceInfo.device].mobile;
              }
            }
            else if (getDeviceInfo.osName === 'BlackBerry') {
              if (getDeviceInfo.device === 'BlackBerry10+' && parseFloat( getDeviceInfo.osVersion ).toFixed( 1 ) >= parseFloat( obj[key][getDeviceInfo.device].version ) ) {
                urls[key] = obj[key][getDeviceInfo.device];
              }
              else {
                urls[key] = obj[key].defaultOthers;
              }
            }
            else if (getDeviceInfo.deviceType === 'mobile' || getDeviceInfo.deviceType === 'tablet') {
              if (getDeviceInfo.device === 'Windows Phone' && (parseFloat( getDeviceInfo.osVersion ).toFixed( 1 ) >= parseFloat( obj[key][getDeviceInfo.device].version ) )) {
                urls[key] = obj[key][getDeviceInfo.device];
              }
              else {
                urls[key] = obj[key].defaultOthers;
              }
            } else {
              urls[key] = obj[key].default;
            }
          }
        }
        return urls;
      }
    };

    return urlDevice;
}] );

'use strict';

angular.module('totesApp')
  .factory('user', ['$rootScope', 'persistentAccessor', 'settings', 'ajax', '$location', '$cookieStore', 'appState', '$window', '$browser', 'localStorage', 'globalloaderService', 'agentSession', 'myrForgetPasswordService', 'ute.common.user.service', 'ute.rogers.datalayer.integration.common.service', 'janrainOidc', '$http', '$q',
    function ($rootScope, persistentAccessor, settings, ajax, $location, $cookieStore, appState, $window, $browser, localStorage, globalloaderService, agentSession, forgetPasswordService, userService, dataLayerIntegrationService, janrainOidc, $http, $q) {

      var lastDigestRun = new Date();
      $rootScope.$on('$stateChangeStart', function ( /*event, currentRoute, previousRout*/ ) {
        var now = new Date();
        if (now - lastDigestRun > 1000 * 60 * 14) {
          //DBG
          //user.logout();
        }
        lastDigestRun = now;
      });

      var user = {



        isAuthenticated: function () {
          return $rootScope.user.isAuthenticated;
        },

        token: persistentAccessor('userToken', null),
        isLoggedIn: function () {
          var session = (localStorage.getLocalStorageValue('BSS_OCP_UTE') == "true") ? $browser.cookies()['bss-info'] : $browser.cookies().SMSESSION;
          if (settings.isLocal) {

            // if (!$cookies.SM_GUID) {
            if (!$browser.cookies().SM_GUID) {
              return false;
            }
          } else {
            //if ($cookies.SMSESSION  && $cookies.SMSESSION === 'LOGGEDOFF') {
            if (!session && session === 'LOGGEDOFF') {
              return false;
            } else if ($browser.cookies().CONSENT_STATE || $browser.cookies()['bss-info']) {
              return true;
            } else {
              return false;
            }
          }
        },
        login: function (userName, password) {
          var returnObj = {};

          // Localhost hack!!!! REMOVE AS SOON AS POSSIBLE!!!!!!!
          if (settings.isLocal) {
            //set local dev mode

            return ajax.getAuthorizedLocally(userName, password).then(
              // success???
              function (response) {
                try {
                  persistentAccessor('SM_GUID', response.guid);
                  persistentAccessor('SM_USER', response.user);

                  returnObj.valid = true;
                  returnObj.statusCode = 200;
                  return returnObj;

                } catch (err) {
                  returnObj.valid = false;
                  returnObj.statusCode = 200;
                  return returnObj;
                }

              },
              function (error) {
                // Error handling - 555 exception
                if (error.data.status === 555) {
                  // Server error that needs further processing
                  // additional information for 555 error

                  // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                  // error.error.errorMessage		// Message as delivered from server
                  // error.error.message 			// Message as found in resource file
                  // error.error.statusCode		// error status code - 555 in this case

                } else {
                  // anything but status code 555

                  if (error.data.status === 401) {
                    // User(ajax.signin) - wrong credentials.
                    returnObj.action = error.action;
                    returnObj.data = error.data;
                  } else if (error.data.status === 503) {
                    // User(ajax.signin) - Server unresponsive.
                  } else {
                    // User(ajax.signin)
                  }
                }

                returnObj.valid = false;
                returnObj.statusCode = error.data.status;
                return returnObj;
              }
            );

          } else {
            // Localhost hack!!!! REMOVE AS SOON AS POSSIBLE!!!!!!!

            //production mode
            // do cookie checking here
            return ajax.signin(userName, password).then(
              // success
              function (response) {
                returnObj = {};

                $rootScope.$broadcast('accountLockAvailable');
                var browserCookies = $browser.cookies();

                if (browserCookies.SM_QUERY_STRING) {
                  var params = browserCookies.SM_QUERY_STRING.split('&').map(function (n) {
                    return n = n.split('='), this[n[0]] = n[1], this;
                  }.bind({}))[0];

                  removeCookie('SMTRYNO');
                  removeCookie('R1IDSMTRYNO');
                  removeCookie('SM_QUERY_STRING');
                  if (params.SMAUTHREASON == 20 && params.SMTOKEN) {
                    params.SMTOKEN = params.SMTOKEN + '=';

                    forgetPasswordService.setCookie(params);
                    $location.path('/tempPassword');
                    return null;
                  }
                }

                var smsession = "";
                if ($browser.cookies()['bss-info']) {
                  smsession = $browser.cookies()['bss-info']
                } else {
                  smsession = $browser.cookies().SMSESSION
                }
                if (!!smsession) {
                  removeCookie('R1IDSMTRYNO');
                  removeCookie('SMTRYNO');
                  returnObj.valid = true;
                  returnObj.statusCode = 200;
                } else {
                  returnObj.valid = true;
                  returnObj.statusCode = 200;
                }
                return returnObj;

              },
              function (error) {
                returnObj = {};
                // Error handling - 555 exception
                if (error.data.status === 555) {
                  // Server error that needs further processing
                  // additional information for 555 error

                  // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                  // error.error.errorMessage		// Message as delivered from server
                  // error.error.message 			// Message as found in resource file
                  // error.error.statusCode		// error status code - 555 in this case

                } else {
                  // anything but status code 555

                  if (error.data.status === 401) {} else if (error.data.status === 502) {
                    // console.log('User(ajax.signin) - Bad gateway.');
                  } else if (error.data.status === 503) {
                    // console.log('User(ajax.signin) - Server unresponsive.');
                  } else {
                    // console.log('User(ajax.signin) - error.data.status:', error.data.status);
                  }
                }

                returnObj.valid = false;
                returnObj.statusCode = error.data.status;
                return returnObj;
              }
            );
            // Localhost hack!!!! REMOVE AS SOON AS POSSIBLE!!!!!!!
          }
          // End of hack
        },
        tempPassword: function (username, password, newpassword, confirmation, smtoken, smauthreason, smagentname) {
          function resetPassword() {
            return ajax.tempPassword(username, password, newpassword, confirmation, smtoken, smauthreason, smagentname).then(
              function (response) {
                if (settings.isLocal) {
                  return true;
                }
                var smsession = "";
                if ($browser.cookies()['bss-info']) {
                  smsession = $browser.cookies()['bss-info']
                } else {
                  smsession = $browser.cookies().SMSESSION
                }
                //var smsession = (localStorage.getLocalStorageValue('BSS_OCP_UTE')=="true") ? $browser.cookies()['bss-info'] : $browser.cookies().SMSESSION;
                return (!!smsession && smsession !== 'LOGGEDOFF');

              },
              function (error) {
                // even with error, reset password might have been successful
                // so must check session cookie
                //var smsession = (localStorage.getLocalStorageValue('BSS_OCP_UTE')=="true") ? $browser.cookies()['bss-info'] : $browser.cookies().SMSESSION;
                var smsession = "";
                if ($browser.cookies()['bss-info']) {
                  smsession = $browser.cookies()['bss-info']
                } else {
                  smsession = $browser.cookies().SMSESSION
                }
                return (!!smsession && smsession !== 'LOGGEDOFF');
              }
            );
          }

          // if (!!$cookies.SMSESSION || !!$cookies.SMTRYNO) {
          //var sessionbrt = (localStorage.getLocalStorageValue('BSS_OCP_UTE')=="true") ? $browser.cookies()['bss-info'] : $browser.cookies().SMSESSION;
          var sessionbrt = "";
          if ($browser.cookies()['bss-info']) {
            sessionbrt = $browser.cookies()['bss-info']
          } else {
            sessionbrt = $browser.cookies().SMSESSION
          }

          var smtryno = "";
          if ($browser.cookies().R1IDSMTRYNO) {
            smtryno = $browser.cookies().R1IDSMTRYNO
          } else {
            smtryno = $browser.cookies().SMTRYNO
          }
          //var smtryNo = (localStorage.getLocalStorageValue('BSS_OCP_UTE')=="true") ? $browser.cookies().R1IDSMTRYNO : $browser.cookies().SMTRYNO;
          if (!!sessionbrt || !!smtryno) {

            // This code is not working

            //var smtrynoName = (localStorage.getLocalStorageValue('BSS_OCP_UTE')=="true") ? 'R1IDSMTRYNO' : 'SMTRYNO';
            $cookieStore.remove('R1IDSMTRYNO');
            $cookieStore.remove('SMTRYNO');
            //var sessionName = (localStorage.getLocalStorageValue('BSS_OCP_UTE')=="true") ? 'R1IDSMSESSION' : 'SMSESSION';
            $cookieStore.remove('bss-info');
            $cookieStore.remove('SMSESSION');

            return ajax.notifyServerDiscardSMCookies().then(
              function (response) {
                return resetPassword();
              },
              function (error) {
                return false;
              }
            );
          } else {
            return resetPassword();
          }
        },
        clearCookies: function () {
          // Kill the cookies
          // The SMSESSION cookie should not be removed for dealer
          if ($browser.cookies().userType != settings.userType.dealer) {
            var sessionName = (localStorage.getLocalStorageValue('BSS_OCP_UTE') == "true") ? 'bss-info' : 'SMSESSION';
            removeCookie(sessionName);
          }
          removeCookie('SM_USERAUTHENTICATED');
          removeCookie('SMLOCK');
          removeCookie('SM_GUID');
          removeCookie('SM_USER');
          removeCookie('userToken');
          removeCookie('selectedAccount');
          removeCookie('accountNumber');
          removeCookie('userType');
          removeCookie('cbid'); //bold chat
          removeCookie('bss-info');
          removeCookie('CONSENT_STATE');
          removeCookie('guid');
          removeCookie('easCode');
          removeCookie('easFlowTypeForState');
          //Story MBH-4560 changes
          removeCookie("loggedInB");
          removeCookie("authZB");
          removeCookie("authNB");
          removeCookie("tokenSetB");

        },

        logout: function () {
          var promises = [];
          var urlPrefix = "/web/smb/api/";
          promises.push($http.post(urlPrefix + "business/v1/logout"));    // clear entry from cassandra
          promises.push(ajax.notifyServerLogout());  // clear browser cookies
          console.log('bss-info from cookie:', $browser.cookies()['bss-info']);
          console.log('CONSENT_STATE from cookie:', $browser.cookies().CONSENT_STATE);
          if ($browser.cookies()['bss-info'] || $browser.cookies().CONSENT_STATE) {
              $http.get("/web/smb/cms/selfserve/authorizeConfigData.json").then(
                 function (response) {
                    if (response.data) {
                       var envName = settings.prodEnvName;
                       if (settings.isDevMBH) {
                          envName = settings.devEnvName;
                       } else if (settings.isQaMBH) {
                          envName = settings.qaEnvName;
                       }
                        var configData = response.data[envName];
                       // config.logoutUrl = configData.logoutUrl;
                        promises.push($http.get(configData.logoutUrl)/*.then(
                        function(response){
                            var urlPrefix = "/web/smb/api/";
                            promises.push($http.get(urlPrefix + "business/v1/logout"));
                        },function (error){
                          console.log("EAS Logout API Call failure");
                        })*/);
                    }
                 },
                 function (error) {}
              );

          }
          $q.all(promises).then(function (response) {
            user.token(null);
            // reset rootscope
            appState.aoFlushScope();
            var storageArr = ['_{deploymentId}:gcmcopn', '_act', '_<deploymentId>:gcmc','_<deploymentId>:gcm', '_actvc' , '_actts', '_actms', '_actmu', '_actmr', '_actec',  '_actsc', '_{deploymentId}:gcmcsessionActive', '_{deploymentId):gcmksid',  '_{deploymentId}:gcmcopn','pInd', 'ttlDate', 'ListBasedTargets', 'visitCount', 'cta-clicked', 'disqualify', 'consentPath', 'midmarkettemp'];
            localStorage.clearAllLocalStorageValuesExcept(storageArr);
            /* var prodInd = localStorage.getLocalStorageValue('pInd');
                 var ttlDate = localStorage.getLocalStorageValue('ttlDate');
                 var listBasedTargets = localStorage.getLocalStorageValue('ListBasedTargets');
                 localStorage.clearAllLocalStorageValues();
                 localStorage.setLocalStorageValue('pInd', prodInd);
                 localStorage.setLocalStorageValue('ttlDate', ttlDate);
             localStorage.setLocalStorageValue('ListBasedTargets', listBasedTargets); */

            dataLayerIntegrationService.resetSessionStorage();
            user.clearCookies();
            if (localStorage.getLocalStorageValue('BSS_OCP_UTE') == "true") {
              MBHLauncher.signOut();
              MBHLauncher.destroy();
            }
            // TODO temporary solution instead of $rootScope = {};
            if (userType != settings.userType.dealer) {
              location.reload(true);
              //$rootScope = $rootScope.$new(true);
            }
            if (userType && userType === settings.userType.dealer && sspPath) {
              $cookieStore.remove('userType');
              $window.location.href = sspPath;
            } else if (userType && userType === settings.userType.care) {
              $cookieStore.remove('userType');
              agentSession.endCareSession();
            } else {
              appState.switchView('signin');
            }
          }, function (error) {
            user.token(null); // reset rootscope
            appState.aoFlushScope();
            var storageArr = ['_{deploymentId}:gcmcopn', '_act', '_<deploymentId>:gcmc','_<deploymentId>:gcm', '_actvc' , '_actts', '_actms', '_actmu', '_actmr', '_actec',  '_actsc', '_{deploymentId}:gcmcsessionActive', '_{deploymentId):gcmksid',  '_{deploymentId}:gcmcopn', 'pInd', 'ttlDate', 'ListBasedTargets', 'visitCount', 'cta-clicked', 'disqualify', 'consentPath', 'midmarkettemp'];
            localStorage.clearAllLocalStorageValuesExcept(storageArr);
            /* var prodInd = localStorage.getLocalStorageValue('pInd');
                 var ttlDate = localStorage.getLocalStorageValue('ttlDate');
                 localStorage.clearAllLocalStorageValues();
                 localStorage.setLocalStorageValue('pInd', prodInd);
             localStorage.setLocalStorageValue('ttlDate', ttlDate); */
            dataLayerIntegrationService.resetSessionStorage();
            user.clearCookies();
            if (localStorage.getLocalStorageValue('BSS_OCP_UTE') == "true") {
              MBHLauncher.signOut();
              MBHLauncher.destroy();
            }
            // TODO temporary solution instead of $rootScope = {};
            if (userType != settings.userType.dealer) {
              location.reload(true);
              //$rootScope = $rootScope.$new(true);
            }
            if (userType && userType === settings.userType.dealer && sspPath) {
              $cookieStore.remove('userType');
              $window.location.href = sspPath;
            } else if (userType && userType === settings.userType.care) {
              $cookieStore.remove('userType');
              agentSession.endCareSession();
            } else {
              appState.switchView('signin');
            }
          });
          var userType;
          userService.unsigned();
          console.log('userType from cookie:', $browser.cookies().userType);
          if ($browser.cookies().userType) {
            userType = $browser.cookies().userType;
          }
          var sspPath;
          if (userType && userType === settings.userType.dealer && $rootScope.userInfo.cfaInfo) {
            sspPath = $rootScope.userInfo.cfaInfo.sourceURL ? $rootScope.userInfo.cfaInfo.sourceURL + settings.agentInfo.signoutURL : false;
          }
          console.log('ssppath:', sspPath);
          ajax.resetKillSwitches();
          // Kill the local data
          try {
            if ($rootScope.ao.accountActive !== null) {
              $rootScope.ao.accountActive = null;
            }
          } catch (err) {
            // nonexistent accountActive
          }
          $rootScope.popUpOpened = false;
          if (userType && userType === settings.userType.care) {
            $rootScope.user.isAuthenticated = false;
          }
          //$rootScope = {};
          //$rootScope.ao = {};

          // notify server - logout
          $rootScope.toggleMainPlusMinus = false;
          $rootScope.toggleServicesPlusMinus = false;

        },
        securePostSignin: function () {
          ///// WARNING /////  landing.js -> landing     function:  localPostSignin   IS TAKING OVER this bit of code - start
          //						if ($location.protocol() === 'http') {
          //							// Switch to secure AFTER signing in
          //							var newURL = '';
          //							newURL += 'https://';
          //							newURL += $location.host();
          //							newURL += settings.postSigninUrl;
          //							$window.location.href = newURL;
          //						} else {
          //							// Already in secure - proceed with regular redirect
          //              appState.switchView('accountOverview');
          //						}
          ///// WARNING /////  landing.js -> landing     function:  localPostSignin   IS TAKING OVER this bit of code - end
        },
        isEmail: function (email) {
          var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return regex.test(email);
        },
        allAccounts: [],
        currentAccountId: '',
        currentAccount: {}
      };

      function removeCookie(name) {
        document.cookie = name + '=; domain=.rogers.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC';
      }

      return user;
    }
  ]);

'use strict';

//
angular.module('totesApp').factory('userOptions',['$rootScope', function ($rootScope) {

    var optionsQueue = [];
    var currentOptions = null;

    function dequeuUserNextOptions() {

        currentOptions = optionsQueue.shift();

        if (currentOptions) {
            $rootScope.$broadcast('options_sent', currentOptions);
        }

    }

    var userOptions = {

        __optionsQueue: optionsQueue,

        alert: function (message, title, callback) {

            if (angular.isFunction(message) || angular.isUndefined(title)) {
                callback = title;
                title = 'Rogers';
            }

            this.push({
                title: title,
                message: message,
                options: [
                    {
                        id: 'Ok',
                        text:'',
                        action: callback
                    }
                ]
            });
        },

        //eventType is used together with listen
        push: function (options) {

            optionsQueue.push(options);

            if (!currentOptions) {
                dequeuUserNextOptions();
            }
        },

        subscribe: function (scope, optionType, callback) {

            if (angular.isFunction(optionType)) {
                callback = optionType;
                optionType = undefined;
            }

            scope.$on('options_sent', function (e, userOptions) {
                if (userOptions.type === optionType) {
                    /*jshint expr:true */
                    callback && callback(userOptions);
                }
            });
        },

        //the done can be trigger asynchronously
        done: function (optionId) {

            var option = optionId && currentOptions && currentOptions.options && currentOptions.options[optionId];

            /*jshint expr:true */
            option && option.action && option.action();
            currentOptions = null;
            dequeuUserNextOptions();
        }
    };

    return userOptions;


}]);

'use strict';

angular.module('totesApp').factory('userLanguage', ['ute.blocks.language.switcher', function (languageSwitcher) {

  return function (value) {
    if (angular.isUndefined(value)) {
      var currentLanguage = languageSwitcher.getCurrentLanguage();
      return !!currentLanguage && currentLanguage !== 'null' ? currentLanguage : 'en';
    } else {
      languageSwitcher.changeLanguage(value);
    }
  };
}
]);

'use strict';

angular.module('totesApp')
		.factory('userProvince', ['$window', '$browser',
			function ($window, $browser) {

				var _province = $browser.cookies().province;
				var _domain = $window.location.hostname.replace('www', '');

				function setProvinceCookie(value) {
					$window.document.cookie = 'province=' + value + ';domain=' + _domain + ';path=/';
					$window.document.cookie = 'province=' + value + ';domain=' + $window.location.hostname + ';path=/';
					$window.document.cookie = 'province=' + value + ';domain=' + '.rogers.com' + ';path=/';
				}

				return function (value) {
					if (angular.isUndefined(value)) {
						if (angular.isUndefined(_province) || _province == 'null') {
							_province = 'ON';
							setProvinceCookie(_province);
						}
						return _province;
					} else {
						_province = value;
						setProvinceCookie(value);
						return value;
					}
				};
			}
		]);

'use strict';

angular.module('totesApp')
  .factory('util', ['$window', function ($window) {


    return {
        isPromise: function (obj) {
            return !!obj && angular.isFunction(obj.then);
        },
        updateCTNFormat: function (ctn) {
          var ctnRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

		      var formattedCTN = ctn;
          if (ctnRegex.test(ctn)) {
            formattedCTN = ctn.replace(ctnRegex, '($1) $2-$3');
          }
          return formattedCTN;
        },
        getLocalStorageValue: function(key) {
          return $window.localStorage.getItem(key);
        }
    };
  }]);


'use strict';

/**
 * @ngdoc service
 * @name totesApp.webanalytics
 * @description
 * # webanalytics
 * Service in the totesApp.
 */
angular.module('totesApp')
  .service('webanalytics', function () {
    // AngularJS will instantiate a singleton by calling "new" on this function
    //tag objects of all modules.
/*    var _pageTags={
      'signin': 'home:signin',
      'registration': 'home:registration:contact-information',
      'forgetPassword': 'home:signin',
      'forgetusername': 'home:signin',
      'invalidPath': 'home:signin',
      'tempPassword': 'home:signin',
      'permissionDenied': 'home:signin',
      'tpsc': 'home:signin'
    };*/

    return {

      formatErrorMessage: function (page, controlName, errorType, errorMessage) {
        var message = '';

        if(errorType === 1){
          message = controlName + ' is empty;';
        }

        if(errorType === 2){
          message = controlName + ' pattern is invalid;';
        }

        if( errorType === 3){
          message = controlName + ' is ' + errorMessage;
        }
        return 'Validation Error---'+ 'Page: ' + page + ':' + message ;
      },
      getPageTagObj: function (module) {
        var _pageName = 'home:signin';// the tagging page name of the

        return ['_trackPageView',
          {pn: _pageName}
        ];
      }

    };

  });

'use strict';
/*
The directive for the <body> tag.
By checking the environment, this directive will insert class into the body for global css treatment.
 */
angular.module('totesApp')
    .directive('bodyClasses', ['userLanguage',function (userLanguage) {
        return function(scope, element, attr){

            function update(){
                var newValue= userLanguage();
                if(!newValue ) {
                    return false;
                }
                element.removeClass();
                var _ret='ute-dca ';
                _ret +=newValue;
                element.addClass(_ret);
            }
            //update(userLanguage());
            scope.$on('resourceChanged', update);
        };

    }]);

(function (angular, _, $) {

  'use strict';

  angular
    .module('totesApp')
    .directive('breakPoint', function() {
      return {
        restrict: 'E',
        scope: {

        },
        template: '<div class="breakpoint"><p class="xs"></p><p class="sm"></p><p class="md"></p><p class="lg"></p></div>',
        controller: ["$scope", "$rootScope", function ($scope, $rootScope) {
          $scope.breakpoints = {
            xs: '',
            sm: '',
            md: '',
            lg: ''
          };
          $scope.currentBreakPoint = '';

          $scope.setBreakPoint = function (size, val) {
            if ($scope.breakpoints.hasOwnProperty(size)) {
              $scope.breakpoints[size] = val;
            }
          };

          $rootScope.$on('breakpoint', function (event, breakpoint) {
            // console.log('breakpoint changed: ' + breakpoint);
          });

          $scope.fireBreakPointEvent = function (breakpoint) {
              $rootScope.$broadcast('breakpoint', breakpoint);
          };

          $scope.setCurrentBreakPoint = function (width) {
            var bp = '';
            if (width <= $scope.breakpoints.xs) {
              bp = 'xs';
            } else if (width > $scope.breakpoints.xs && width <= $scope.breakpoints.sm) {
              bp = 'sm';
            } else if (width > $scope.breakpoints.sm && width <= $scope.breakpoints.md) {
              bp = 'md';
            } else if (width > $scope.breakpoints.md) {
              bp = 'lg';
            }
            $scope.currentBreakPoint = bp;
            $rootScope.breakpoint = bp; // we also set the breakpoint on rootscope for access

            return $scope.currentBreakPoint;
          };
        }],
        link: function(scope, elem) {
          // get all the breakpoints from sass
          var xs = elem.find('.breakpoint > .xs').width(), // from sass variable
            sm = elem.find('.breakpoint > .sm').width(), // from sass variable
            md = elem.find('.breakpoint > .md').width(), // from sass variable
            lg = elem.find('.breakpoint > .lg').width(), // from sass variable
            currentWidth = elem.find('.breakpoint').width(), // from the media query
            currentBreakPoint;

          // populate the controllers scope with the breakpoints
          scope.setBreakPoint('xs', xs);
          scope.setBreakPoint('sm', sm);
          scope.setBreakPoint('md', md);
          scope.setBreakPoint('lg', lg);

          // set current size only when all breakpoints are set as
          // there is logic that depends on it
          currentBreakPoint = scope.setCurrentBreakPoint(currentWidth);

          // fire the breakpoint event on rootscope (this is the one that is on page load and not on resize)
          scope.fireBreakPointEvent(currentBreakPoint);

          // fire the breakpoint event on resize
          $(window).resize(_.debounce(function () {
            currentWidth = elem.find('.breakpoint').width();
            var prevBreakPoint = scope.currentBreakPoint;
            var currentBreakpoint = scope.setCurrentBreakPoint(currentWidth);
            if (prevBreakPoint !== currentBreakpoint) {
              scope.fireBreakPointEvent(currentBreakpoint);
            }
          }, 600));
        }
      };
    });
}(angular, _, $));



/**
 * Define a date input basing on datepicker of angular-bootstrap and [text] input.
 * So it depends on 'ui-bootsttrap' module
 * Basically the width/height are defined by outside container - 100% scale, and do does font-size.
 *
 * Usage: <div class='col-xs-5' data-picking model='obj.date' style='line-height:32px; font-size:14px'></div>
 * The container must be float:left, col- is good.
 */

(function(angular){
	"use strict";

	angular.module('totesApp')
	.directive('datePicking', [function(){
		return {
			restrict: 'AE',
			scope: {model:"=", ngRequired:"@", name:"@", required:"@", placeholder:"@"   },
			template: 	"<div class='datepicker-open' ng-click='_op=true' " +
									"style='position:absolute; display:inline-block; right:15px; cursor:pointer; vertical-align:middle'>" +
							"<i class='glyphicon glyphicon-calendar'></i>" +
						"</div>" + "<label for='lastInvoice' class='sr-only' res='_enter_invoice_date'></label>" +
						"<input type='text' name='{{name}}' id='lastInvoice' class='form-control' ng-model='model' is-open='_op' ng-focus='_op=true' placeholder='{{placeholder}}' " +
								"uib-datepicker-popup='yyyy-MM-dd' show-weeks=false show-button-bar=false ng-required='{{ngRequired}}' required='{{required}}' " +
										"style='background-color:white; vertical-align:middle; width:100%'>" +

						"<style>ul.dropdown-menu[uib-datepicker-popup-wrap] tr{line-height:normal}" +
								"ul.dropdown-menu[uib-datepicker-popup-wrap]{padding:7px; background-color:#f4f4f4}" +
									".datepicker-open:hover{color:#00a0c0}ul.dropdown-menu[uib-datepicker-popup-wrap] *:focus{outline:0}</style>"
		}
	}])
    .directive('bindHtmlCompile', ['$compile', function ($compile) {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          scope.$watch(function () {
            return scope.$eval(attrs.bindHtmlCompile);
          }, function (value) {
            // Incase value is a TrustedValueHolderType, sometimes it
            // needs to be explicitly called into a string in order to
            // get the HTML string.
            element.html(value && value.toString());
            // If scope is provided use it, otherwise use parent scope
            var compileScope = scope;
            if (attrs.bindHtmlScope) {
              compileScope = scope.$eval(attrs.bindHtmlScope);
            }
            $compile(element.contents())(compileScope);
          });
        }
      };
    }])

	.directive('validMoney', function(){

		return {
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, elme, attr, ctrl){		//Here ctrl is the ngModel controller

				 ctrl.$validators.validMoney = function (modelValue, viewValue){
					if(ctrl.$isEmpty(modelValue)) { return true; }		// consider empty models to be valid

					if(isNaN(viewValue)){ return false; }	//is a number

				        // it is valid
				        return true;
				};
			}
		}

	})
	.directive('rgsValidAcc', function(){

		return {
			restrict: 'EA',
			require: 'ngModel',
			link: function(scope, elme, attr, ctrl){		//Here ctrl is the ngModel controller

				 ctrl.$validators.rgsValidAcc = function (modelValue, viewValue){
					 var _vv = viewValue.replace(/\s+/g, "");	//remove all white spaces

					 if(ctrl.$isEmpty(modelValue)) { return true; }		// consider empty models to be valid

					 if(_vv.length!=9 && _vv.length!=12){ return false; }		// not 9, neither 12, false

					 if(isNaN(_vv)){ return false; }	//not-number, false

				     // it is valid
				     return true;
				};

        ctrl.$parsers.push(function (text) {
          var transformedInput = text.replace(/[-]/, '');
          if (transformedInput != text) {
            ctrl.$setViewValue(transformedInput);
            ctrl.$render();
          }
          return transformedInput;
        });

			}
		}

	})
	.directive('validPostal', function(){
		return{
			restrict: 'A',
			require: 'ngModel',
			link: function(scope, elme, attr, ctrl){		//Here ctrl is the ngModel controller
				 ctrl.$validators.validPostal = function (modelValue, viewValue){

					 var _vv = viewValue.replace(/\s+/g, "");	//remove all white spaces
           var regexp = /^(\d{5}(-\d{4})?|[A-Z]\d[A-Z] *\d[A-Z]\d)$/i; //regex changed for BSL-64
					 if(ctrl.$isEmpty(modelValue)) { return true; }		// consider empty models to be valid
					 if (_vv) {
             return regexp.test(_vv);
           }

				     // it is valid
				     return true;
				};
			}
		}
	})

    .directive('rgsInset', ["$window", "$rootScope", function($window,$rootScope){
      return {
        restrict: "EA",
        transclude: true,
        scope: true,
        templateUrl: 'scripts/modules/bssLinkAccount/rgsInset.html',
        link: function(scope, el, attrs){
          el.find('ng-transclude').on('click', function(event){
            event.stopPropagation();
            scope.$apply(function(){
              scope._insetOpen=!scope._insetOpen;
              if(attrs.popup == 'account'){
                scope._account = true;
              }else if(attrs.popup == 'date'){
                scope._date = true;
              }

            });
          });


          el.find('ng-transclude').on('touchstart', function(event){
            event.stopPropagation();
            scope.$apply(function(){
              scope._insetOpen=!scope._insetOpen;
              if(attrs.popup == 'account'){
                scope._account = true;
              }else if(attrs.popup == 'date'){
                scope._date = true;
              }

            });
            return false;
          });

          $window.onclick = function() {
            $rootScope.$broadcast('outsideClick');

          };

          scope.$on('outsideClick', function(){
            if(scope._insetOpen){
              scope.$apply(function(){
                scope._insetOpen=false;
              });
            }
          })

        }
      };
    }]);

})(window.angular);

'use strict';
/*
This directive is placed on elements that have a class of 'cloaked' on them.
The cloaked class is intended to hide 'template flashing' in IE where the contents of the template are briefly
displayed before the content is loaded.
This directive removes the class when it loads (which is later than the flashing occurs)
 */
angular.module('totesApp')
    .directive('cloaker', [function () {
        return {
            restrict: 'A',
            link: function(scope, elem, attr){
                elem.removeClass('cloaked');
            }
        };

    }]);
'use strict';

angular.module('totesApp').directive('digitMask', function () {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, element, attr, ctrl) {
        function inputValue(val) {
          if (val) {
            var digits = val.replace(/[^0-9.,]/g, '');

            if (digits !== val) {
              ctrl.$setViewValue(digits);
              ctrl.$render();
            }
            var result = parseFloat(digits);
            return result;
          }
          return undefined;
        }
        ctrl.$parsers.push(inputValue);
      }
    };
 });

'use strict';

angular
        .module('totesApp')
        .directive('disableWhiteout', function () {
          return {
            restrict: 'AEC',
            controller: ["$scope", "$rootScope", function ($scope, $rootScope) {
              $scope.fireCloseEvent = function () {
                $rootScope.$broadcast('closeonresize');
              };
            }],
            link: function (scope, element, attrs) {
              var runOnce = false;
              // var element = element;      // WHY??? - Commenting this line out
              // var scope = scope;          // WHY??? - Commenting this line out
              
              $(window).resize(function () {
                if (runOnce === false) {
                  scope.fireCloseEvent();
                  runOnce = true; // only execute once;
                }
              });
            }
          };
        });

'use strict';
/*
 The directive for the <form> tag.
 Watching any changes in the form
 */
angular.module('totesApp')
  .directive('formChangeWatch', function() {

    return function (scope, el, attrs, ctrl) {
// console.log(el);
      el.$watch(el.$valid, function (newVal, oldVal) {
// console.log('newVal: ', newVal);
      }, true);

    };

});


'use strict';

angular
        .module('totesApp')
        .directive('formLocator', function () {
          return {
            link: function (scope) {
              scope.$emit('formLocator');
            }
          };
        });

'use strict';

// More info on nested directives
// https://thinkster.io/egghead/directive-to-directive-communication/


angular
        .module('totesApp')
        .provider('globalloaderHandler', function () {
          var data;

          return {
            $get: function () {
              return data;
            },
            $set: function (value) {
              data = value;
            }
          };
        })
        .factory('globalloaderService', ['$rootScope', 'deeplink', '$log','$location','settings',
          function ($rootScope, deeplink, $log,$location,settings) {

            var globalloaderService = {};
            var aryOmittedPages = settings.omitPagesFromGlobalLoader;

            globalloaderService.omitFromPage = function(stPage){
              aryOmittedPages.push(stPage);
            };

            globalloaderService.getOmittedPages = function(){
              return aryOmittedPages;
            };

            globalloaderService.isCurrentPageOmitted = function(){

              var aryNonLoaderPages = globalloaderService.getOmittedPages();
              var stCurrentURL = $location.url();
              return (aryNonLoaderPages.indexOf(stCurrentURL) > -1);
            };

            globalloaderService.show = function () {
              if(!globalloaderService.isCurrentPageOmitted()) {
                $rootScope.$broadcast('showGlobalLoader');
              }
            };

            globalloaderService.hide = function () {
              if(!globalloaderService.isCurrentPageOmitted()) {
                if (deeplink.data.direction === 'out') {
                  // DO NOT shut down the loader image
                } else {
                  $rootScope.$broadcast('hideGlobalLoader');
                }
              }
            };

            return globalloaderService;
          }
        ])
        .directive('globalloader', function () {
          return {
            restrict: 'A',
            scope: {},
            link: function (scope, element, attrs) {
            },
            controller: ['$scope', '$rootScope', '$element', '$attrs', 'userLanguage',
              function ($scope, $rootScope, $element, $attrs) {

                // Show hide functions
                $scope.initialLoader = function () {
                  // show loader section
                  $element.show();
                };

                // Show hide functions
                $scope.showLoader = function (type) {
                  if (type === 'loader') {
                    // show loader section
                    $element.show();
                  } else {
                    $element.hide();
                  }
                };

                $scope.hideLoader = function (type) {
                  if (type === 'loader') {
                    $element.hide();
                  } else {
                    $element.show();
                  }
                };

                // Show hide triggeres
                $rootScope.$on('showGlobalLoader', function () {                  // <<<<<<<<<<<<<<<<<<< CLEAN this from the rest of the code
                  $scope.showLoader($attrs.globalloader);
                });
                $rootScope.$on('hideGlobalLoader', function () {                  // <<<<<<<<<<<<<<<<<<< CLEAN this from the rest of the code
                  $scope.hideLoader($attrs.globalloader);
                });

                // decide which loader to show -> EN / FR
                $scope.initialLoader();
                // hide by default
                $scope.hideLoader($attrs.globalloader);
              }]

          };
        });

'use strict';

angular.module('totesApp')
	.directive('languageSelector',['settings', 'userLanguage', '$browser',
	function (settings, userLanguage, $browser) {
		return {
			// scope: {},
			replace: true,
			templateUrl: 'views/languageSelector.html',
			restrict: 'E',
			link: function (scope, element, attrs) {
				scope.languages = settings.supportedLanguages;
				scope.selectedLanguage = userLanguage();

        scope.changeLanguage = function () {
					userLanguage(scope.selectedLanguage);
					// $cookies.language = scope.selectedLanguage;
					//$browser.cookies('language', scope.selectedLanguage);
				};
			}
		};
	}]);

'use strict';

// More info on nested directives
// https://thinkster.io/egghead/directive-to-directive-communication/
// <div livecontent="header" language="en" province="on"></div>

angular.module('totesApp')
    .directive('liveheader', function () {
        return {
            restrict: 'EA',
            // scope: {},
            controller: ['$scope', '$rootScope', '$element', '$translate', 'settings', 'user', 'userLanguage', 'userProvince', '$browser', 'appInterface', 'resource', 'localStorage', 'ngDialog', 'ocpService', 'ajax', '$window', '$compile', '$cookieStore', '$location',
        function ($scope, $rootScope, $element, $translate, settings, user, userLanguage, userProvince, $browser, appInterface, resource, localStorage, ngDialog, ocpService, ajax, $window, $compile, $cookieStore, $location) {

                    // global variables
                    $scope.languages = settings.supportedLanguages;
                    $scope.selectedLanguage = userLanguage();
                    $scope.selectedProvince = userProvince();
                    $scope.languageChanged = false;
                    $rootScope.showNavPlus = true;
                    $scope.isFrontLineUser = false;
                    var _keepAliveInit = false;
                    // Update functions
                    $scope.reloadHeaderDOM = function (forceRedraw) {
                        var LCtype = 'header';
                        var LClanguage = $scope.selectedLanguage;
                        var LCprovinceALLCAPS = $scope.selectedProvince;
                        var LCprovince = LCprovinceALLCAPS.toLowerCase();
                        var ocpLauncherTitle = "Quick links";
                        var LCfilename = LCtype + '-' + LClanguage + '-' + LCprovince + '.xml';

                        var LCurlPrefix = '';
                        var LCurl = '';
                        // ----------------- localhost hack -------------------------------------- start
                        if (settings.isLocal) {
                            LCurlPrefix = settings.devServerURL;
                        }
                        // ----------------- localhost hack -------------------------------------- end

                        // Compile the file path
                        LCurl = LCurlPrefix + '/web/smb/cms/rogers-smb/integration/' + LCfilename;

                        // Example: https://www.rogers.com/cms/rogers/integration/header-en-on.xml

                        // Prouction URL load
                        // https://www.rogers.com/consumer/integration/header.page?setLanguage=fr&setProvince=on
                        // LCurl = 'https://www.rogers.com/consumer/integration/'+ LCtype +'.page?setLanguage='+ LClanguage +'&setProvince='+ LCprovince;

                        $element.load(LCurl, function () {
                            // login / logout links
                            var newURL = '';
                            var newID = '';
                            var newText = '';
                            var userID = '';
                            var userCookie = '';
                            var userType = $browser.cookies().userType;
                            var language = $browser.cookies().language;
                            var province = $browser.cookies().province;
                            var mbhUrl = localStorage.getLocalStorageValue('MBHUrl');
                            if ($scope.selectedLanguage == "fr") {
                                ocpLauncherTitle = "Liens rapides";
                            }
                            var ocpElement = "ul.quickLinksDropDownList";
                            /*$(ocpElement).after($('<li class="ocp"><div class="dropdown"><a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">'+ocpLauncherTitle+'<span class="caret"></span></a>'+
                            '<div class="dropdown-menu ocpContent">'+'<div class="ocpHeader">'+'<div class="ocpIcon"></div>'+'<div class="fa fa-chevron-right"></div>'+'<div class="ocptitle">'+'</div></div>'+'<div class="ocpSubModule">'+'<ul class="ocpLinkList">'+'</ul>'+'</div> </div> </div>'+'</li>'));*/
                            var ocpElementContent = "<mbh-links></mbh-links>";
                            $(ocpElement).html($compile(ocpElementContent)($scope));

                            var $mblquicklinksdropdown = $(".mobile-menu.signin").clone();
                            $mblquicklinksdropdown.removeClass("signin").addClass("quicklinks");
                            $mblquicklinksdropdown.find(".signInDropdownList").removeClass("signInDropdownList").addClass("quicklinksDropdownList");
                            $mblquicklinksdropdown.find(".closeSignin").removeClass("closeSignin").addClass("closeQuicklinks");
                            $mblquicklinksdropdown.find("ul.quicklinksDropdownList li").not(".closeQuicklinks").remove();
                            $mblquicklinksdropdown.insertAfter($(".mobile-menu.signin"));
                            $mblquicklinksdropdown.find(".closeQuicklinks a > span").text($(".mobile-menu.default .quickLinks .innerMainNavCopy").text());

                            var mobileOcpElement = ".mobile-menu.quicklinks li.closeQuicklinks";
                            var mobileOcpElementContent = "<mobile-mbh-links></mobile-mbh-links>"
                            $(mobileOcpElement).after($compile(mobileOcpElementContent)($scope));

                            var ocpShow = "#dca-secondary-nav .nav-section ul.nav-link-set li.ocp";
                            var ocpPopupShow = "#ocpPopup";
                            $(ocpShow).hide();
                            $(ocpPopupShow).hide();

                            if ($rootScope.isDealer || $rootScope.isCare) {
                                $element.find('#header').find('#nav-main').find('#main-nav-item-3').attr({
                                    href: '/web/totes/#/oneViewDashboard?lang=' + language + '&userType=' + userType + '&prov=' + province
                                });
                                $element.find('#header').find('#nav-main').find('#main-nav-item-5').attr({href: ''});
                                $element.find('#header').find('#nav-main').find('#main-nav-item-4').attr({href: ''});
                                $element.find('#header').find('#nav-main').find('#main-nav-item-4').parent().find('.dropdown-menu').remove();
                                $element.find('#header').find('#nav-main').find('#main-nav-item-7').attr({href: ''});
                            }

                            // Language link
                            $element.find(".languageDropdown li a").attr({
                                id: 'languageFrench'
                            });
                            $element.find(".languageDropdown li:first-child a").attr({
                                id: 'languageEnglish'
                            });
                            $element.find(".languageDropdown li a").attr({
                                href: 'javascript: void(0)'
                            });

                            if ($rootScope.user.isAuthenticated) {
                                $element.find('.signInDropdown').hide();

                                $element.find('.quickLinksDropDown').removeClass("d-none").attr('style','display: block !important');
                                $element.find('.signOut').removeClass("d-none").attr('style','display: block !important');
                                $element.find('.welcomeMsg').removeClass("d-none").attr('style','display: block !important');

                                // User is logged in
                                newURL = '#';
                                newID = 'logoutAction';
                                var ocpShow = "#dca-secondary-nav .nav-section ul.nav-link-set li.ocp";
                                var lowerLanguage = "";
                                var ocpPopupShow = "#ocpPopup";
                                if (window.localStorage.getItem('BSS_OCP_UTE') == "true") {
                                    $(ocpShow).show();
                                }
                                $(ocpPopupShow).show();
                                if (ocpService.userLang == "") {
                                    var userDetails = JSON.parse(window.localStorage.getItem('ute.rogers.signin.user'));
                                    var userId = "";
                                    if ($browser.cookies().userName == undefined || $browser.cookies().userName == null) {
                                        userId = userDetails.userEmail;
                                    } else {
                                        var encodedUserId = $browser.cookies().userName;
                                        userId = decodeURIComponent(encodedUserId);
                                    }

                                    var userReq = {
                                        userName: userId
                                    };

                                    ajax.getUserDetails(userReq).then(function(data) {
                                        /* MBHLauncher.initialize({
                                                     launcherLanguage: $scope.selectedLanguage,
                                                     launcherURL: '/mbh-launcher/v-1/mbh-launcher.html',
                                                     inactivityTime: 1000 * 2 * 60,
                                                     heartBeatInterval: 1000 * 1 * 60,
                                                     portalId: 'BSSS',
                                                     token: ''
                                                   },true);
                                                   if(data.language != undefined || data.language != null){
                                                   lowerLanguage = data.language.toLowerCase();
                                                   }else{
                                                   lowerLanguage =  $scope.selectedLanguage;
                                                   }
                                                   MBHLauncher.setLanguage(lowerLanguage);
                                                   $window.document.cookie = 'guid=' + data.guid + ';domain=' +'.rogers.com' + ';path=' + '/';
                                                   MBHLauncher.setPortalId('BSSS');
                                                   ocpService.userLang = lowerLanguage;
                                                   MBHLauncher.setCookie($browser.cookies().R1IDSMSESSION);
                                                   MBHLauncher.subscribe('sessionKeptAlive', function() {
                                                       if (!_keepAliveInit) {
                                                         _keepAliveInit = true;
                                                         MBHLauncher.getJSON();

                                                       }
                                                   });*/
                                        $window.document.cookie = 'guid=' + data.content.guid + ';domain=' + '.rogers.com' + ';path=' + '/';
                                        lowerLanguage = $scope.selectedLanguage;
                                        if (localStorage.getLocalStorageValue('accountNumber') && localStorage.getLocalStorageValue("BSS_OCP_UTE") == "true") {
                                            var mbhAccounts = {
                                                "accountList": [{
                                                    "accountNumber": localStorage.getLocalStorageValue("accountNumber")
                                                }]
                                            };
                                            $rootScope.$emit('initializeMbhLauncher', mbhAccounts);
                                        }
                                        ocpService.userLang = lowerLanguage;

                                        (ocpService.userLang == "fr") ? $scope.languageToFrench(false) : ((ocpService.userLang == "en") ? $scope.languageToEnglish(false) : "");
                                    }, function(error) {
                                        /*MBHLauncher.initialize({
                                  launcherLanguage: $scope.selectedLanguage,
                                  launcherURL: '/mbh-launcher/v-1/mbh-launcher.html',
                                  inactivityTime: 1000 * 2 * 60,
                                  heartBeatInterval: 1000 * 1 * 60,
                                  portalId: 'BSSS',
                                  token: ''
                                },true);
                               MBHLauncher.setLanguage($scope.selectedLanguage);
                               MBHLauncher.setPortalId('BSSS');
                               MBHLauncher.setCookie($browser.cookies().R1IDSMSESSION);
                               ocpService.userLang = $scope.selectedLanguage;
                                MBHLauncher.subscribe('sessionKeptAlive', function() {
                                  if (!_keepAliveInit) {
                                    _keepAliveInit = true;
                                    MBHLauncher.getJSON();

                                  }
                                });*/
                                        if (localStorage.getLocalStorageValue('accountNumber') && localStorage.getLocalStorageValue("BSS_OCP_UTE") == "true") {
                                            var mbhAccounts = {
                                                "accountList": [{
                                                    "accountNumber": localStorage.getLocalStorageValue("accountNumber")
                                                }]
                                            };
                                            $rootScope.$emit('initializeMbhLauncher', mbhAccounts);
                                        }
                                    });
                                } else {
                                    $scope.languageChanged = false;
                                    //MBHLauncher.getJSON();
                                }

                                /* MBHLauncher.subscribe('launcherDataRecieved', function(e,json) {
                           var signedElement2 = "#dca-secondary-nav .nav-section ul.nav-link-set li.ocp .dropdown .ocpContent .ocpHeader .ocptitle";
                           var signedElement12 = "#dca-secondary-nav .nav-section ul.nav-link-set li.ocp .dropdown .ocpContent .ocpHeader .ocptitle a";
                           $(signedElement12).empty();
                           $(signedElement2).prepend($('<a target="_blank" href="' + mbhUrl +'">' + json.content[0].header1 + '</a>'));

                           //var signedElement3 = "#dca-secondary-nav .nav-section ul.nav-link-set li.ocp .dropdown .ocpContent .ocpHeader .ocptitle .ocpSubtitle";
                           //$(signedElement3).empty();
                           //$(signedElement3).append($("<span>" + json.content[0].header2 + "</span>"));
                           //var signedElement4 = "#dca-secondary-nav .nav-section ul.nav-link-set li.ocp .dropdown .ocpContent .ocpSubModule";
                           //var signedElement14 = "#dca-secondary-nav .nav-section ul.nav-link-set li.ocp .dropdown .ocpContent .ocpSubModule span";
                           //$(signedElement14).empty();
                           //$(signedElement4).prepend($("<span>" + json.content[0].content1 + "</span>"));
                           var signedElement5 = "#dca-secondary-nav .nav-section ul.nav-link-set li.ocp .dropdown .ocpContent .ocpSubModule .ocpLinkList";
                           $(signedElement5).empty();
                           json.content[0].links.forEach(function(link) {
                               $(signedElement5).append($('<li><a target="_blank" href="' + link.url + '">' + link.text + " "+ ">" + "</a></li>"))
                           })
                        });*/

                                var userIDa = $browser.cookies().pageUserName.contains("@") ? $browser.cookies().pageUserName : $browser.cookies().userName;
                                var userIDb = $browser.cookies().SM_USER;
                                var userName = $browser.cookies().userName;

                                if (userIDa && userIDa !== '') {
                                    userCookie = decodeURIComponent(userIDa);
                                }// Fix for CQUSR01270699
                                else if (userName && userName !== '') {
                                    userCookie = decodeURIComponent(userName);
                                } else if (userIDb && userIDb !== '') {
                                    userCookie = decodeURIComponent(userIDb);
                                    // localhost development
                                } else if (userType === settings.userType.dealer) {
                                    userCookie = '';
                                } else if (userType === settings.userType.care) {
                                    userCookie = '';
                                } else {
                                    userCookie = '';
                                }

                                var userNameOnHeader = $element.find('li.welcomeMsg span.navLabel').text() + ' ' + userCookie;
                                $element.find('li.welcomeMsg span.navLabel').text(userNameOnHeader);

                                $element.find('a.signOutLink').attr({
                                  href: newURL
                                });

                                var accountDetails = "#dca-secondary-nav .nav-section ul.nav-link-set li.dropdown-header-menu ul";
                                $(accountDetails).hide();
                                $("#dca-secondary-nav .nav-section ul.nav-link-set li.dropdown-header-menu a").attr("href", "/business/signin");
                                $("#dca-secondary-nav .nav-section ul.nav-link-set li.dropdown-header-menu button").hide();
                                $("#dca-primary-nav .nav-section  li.dropdown-header-menu  ul").hide();

                                var signedOutMobile = "#dca-primary-nav .nav-section li.dropdown-header-menu";
                                $(signedOutMobile).hide();
                                $(signedOutMobile).after($('<a href="#" id="logoutAction">' + newText + "</a>"));
                                var signinContent = "#dca-secondary-nav .nav-section ul.nav-link-set li.dropdown-header-menu";
                                $(signinContent).attr("style", "margin-left: 15% !important; float: left !important; margin-right: 0px !important");

                            } else{
                                // User needs to sign in
                                //$(signedInElement).remove();
                                newURL = '#/signin';
                                newID = 'loginAction';

                                $element.find('#username').find('a:first').attr({
                                    href: newURL,
                                    id: newID
                                });
                                $element.find('#username').find('a:last').attr({
                                    href: '#/sso/registration',
                                    id: newID
                                });


                                $('.welcomeMsg').hide();
                                $('.quickLinksDropDown').hide();
                                $('.signOut').hide();
                                $('.signInDropdown').show();
                            }





                            if (forceRedraw) {
                                // Force - re-draw
                                $scope.$apply();
                            }

                            // Re-initiate header/footer functions
                            if (typeof (init_page) === 'function') { // jshint ignore:line
                                init_page(); // jshint ignore:line
                            }
                            if (typeof (disableTypeaheadOnTotes) === 'function') { // jshint ignore:line
                                disableTypeaheadOnTotes(); // jshint ignore:line
                            }

                            if (typeof (init_HTML) === 'function') { // jshint ignore:line
                                init_HTML(); // jshint ignore:line
                            }

                            if (typeof (init_header) === 'function') { // jshint ignore:line
                                init_header(); // jshint ignore:line
                            }

                            if (typeof (init_footer) === 'function') { // jshint ignore:line
                                init_footer(); // jshint ignore:line
                            }

                            if (typeof (init_components) === 'function') { // jshint ignore:line
                                init_components(); // jshint ignore:line
                            }

                            if  (typeof  (globalHeaderSearch) ===  'function') {    // jshint ignore:line
                                globalHeaderSearch();                     // jshint ignore:line
                            }

                            // DEAD!!!  Was taken out of rui.js
                            if (typeof (disableTypeaheadOnTotes) === 'function') { // jshint ignore:line
                                disableTypeaheadOnTotes(); // jshint ignore:line
                            }
                            // DEAD END!!!
                            if (typeof (init_affix) === 'function') { // jshint ignore:line
                                init_affix(); // jshint ignore:line
                            }
                            // typeahead integration START
                            if (LClanguage === 'en') {
                                var searchPlaceholder = 'Search';
                            } else {
                                var searchPlaceholder = 'Recherche';
                            }

                            $('div.search-section').children().remove();
                            $('div.search-section').append('<ute-sse-typeahead placeholder="' + searchPlaceholder + '" language="' + LClanguage + '" province="' + LCprovinceALLCAPS + '" site="smallbusiness"></ute-sse-typeahead>');
                            $('div.search-section button').css("top", "-4px");
                            // typeahead integration END
                            if($scope.isFrontLineUser) {
                              var frontLineHide = "#dca-secondary-nav .nav-section ul.nav-link-set li:not(:last-child), .mobile-container .nav-link-set";
                              $(frontLineHide).hide();
                            }
                        });
                    };

                    //getUserDetails($browser.cookies().userName);


                    function showSomethingWentWrongErrorPopup() {
                        return ngDialog.open({
                            template: 'views/ocp-popup.html',
                            className: 'ngdialog-theme-default ngdialog-ocp-theme',
                            controller: 'ocpPopupCtrl',
                            showClose: true,
                            appendTo: 'div[ui-view]',
                            closeByDocument: false
                        }).closePromise;
                    }

                    MBHLauncher.subscribe('sessionTimeoutAlert', function (e, d) {
                        $scope.showOcpPopup();
                    });

                    $scope.showOcpPopup = function () {
                        if (ocpService.showOcpPopup) {
                            ocpService.showOcpPopup = false;
                            showSomethingWentWrongErrorPopup();
                        }
                    }

                    $rootScope.$on('reloadHeader', function (evt, args) {
                        $scope.reloadHeaderDOM(false);
                    });

                    $rootScope.$on('frontLineUser', function (evt, args) {
                        $scope.isFrontLineUser = true;
                        var frontLineHide = "#dca-secondary-nav .nav-section ul.nav-link-set li:not(:last-child), .mobile-container .nav-link-set, #footer, #footer-bar ul.footer-bar-links, #copyright";
                        $(frontLineHide).hide();
                        $("#footer-bar .province-language").addClass("col-md-push-2");
                    });
                    $rootScope.$on('exitFrontLine', function (evt, args) {
                        $scope.isFrontLineUser = false;
                        $scope.reloadHeaderDOM(true);
                        $scope.reloadFooterDOM(true);
                    });
                    function menuTextDom() {

                    }

                    $scope.executeLogOut = function () {
                        user.logout();
                    };

                    $scope.updatePreferredLanguage = function (updatePreferredLanguage) { };

                    $scope.languageToFrench = function (updatePreferredLanguage) {
                        // Set language

                        _keepAliveInit = false;
                        $scope.languageChanged = true;
                        $scope.selectedLanguage = 'fr';
                        var _domain = $window.location.hostname.replace('www', '');
                        if (_domain !== '.rogers.com') {
                            $window.document.cookie = 'language=' + $scope.selectedLanguage + ';domain=' + _domain + ';path=/';
                        }
                        $window.document.cookie = 'language=' + $scope.selectedLanguage + ';domain=.rogers.com;path=/';
                        $window.document.cookie = 'language=' + $scope.selectedLanguage + ';path=/';
                        if (window.localStorage.getItem('BSS_OCP_UTE') == "true") {
                            MBHLauncher.setLanguage($scope.selectedLanguage);
                            ocpService.setLanguage($scope.selectedLanguage);
                            MBHLauncher.getJSON();
                        }
                        userLanguage($scope.selectedLanguage);
                        $translate.use($scope.selectedLanguage);

                        // external functionality notification
                        appInterface.fn.languageChange($scope.selectedLanguage);
                        $scope.switchTabWrap();

                        $rootScope.$broadcast('languageChanged');

                        // load the files
                        $scope.reloadHeaderDOM(false);
                        $scope.reloadFooterDOM(true);
                    };
                    $scope.languageToEnglish = function (updatePreferredLanguage) {
                        // Set language

                        _keepAliveInit = false;
                        $scope.languageChanged = true;
                        $scope.selectedLanguage = 'en';
                        var _domain = $window.location.hostname.replace('www', '');
                        if (_domain !== '.rogers.com') {
                            $window.document.cookie = 'language=' + $scope.selectedLanguage + ';domain=' + _domain + ';path=/';
                        }
                        $window.document.cookie = 'language=' + $scope.selectedLanguage + ';domain=.rogers.com;path=/';
                        $window.document.cookie = 'language=' + $scope.selectedLanguage + ';path=/';
                        if (window.localStorage.getItem('BSS_OCP_UTE') == "true") {
                            MBHLauncher.setLanguage($scope.selectedLanguage);
                            ocpService.setLanguage($scope.selectedLanguage);
                            MBHLauncher.getJSON();
                        }
                        userLanguage($scope.selectedLanguage);
                        $translate.use($scope.selectedLanguage);

                        // external functionality notification
                        appInterface.fn.languageChange($scope.selectedLanguage);
                        $scope.switchTabWrap();

                        // Broadcast language change event
                        $rootScope.$broadcast('languageChanged');
                        // load the files
                        $scope.reloadHeaderDOM(false);
                        $scope.reloadFooterDOM(true);
                    };
                    $scope.changeProvince = function (prov) {
                        // Set province
                        $scope.selectedProvince = prov;
                        userProvince(prov);

                        // external functionality notification
                        appInterface.fn.provinceChange($scope.selectedProvince);
                        $scope.switchTabWrap();

                        // Broadcast province change event
                        $rootScope.$broadcast('provinceChanged');
                        // load the files
                        $scope.reloadHeaderDOM(false);
                        $scope.reloadFooterDOM(true);
                    };

                    $scope.switchTabWrap = function () {
                        // Right side feedback tab
                        var domHolder = $element.find('#feedback-tab').find('a');
                        var tabType = appInterface.feedbackTabType;
                        var language = $scope.selectedLanguage;
                        if (typeof (switchTab) === 'function') { // jshint ignore:line
                            switchTab(domHolder, tabType, language); // jshint ignore:line
                        }
                    };

                    // Execute the update
                    $scope.reloadHeaderDOM(false);

                    // Watch for changes
                    $rootScope.$watch('user.isAuthenticated', function () {
                        $scope.reloadHeaderDOM(true);
                    });

                    $scope.$on('pageUserNameChanged', function () {
                        $scope.reloadHeaderDOM(true);
                    });
        }],
            link: function (scope, element, attrs) {}
        };
    })
    .directive('livefooter', function () {
        return {
            restrict: 'E',
            // scope: {},
            controller: ['$scope', '$element', 'settings', 'userLanguage', 'userProvince', 'appInterface', 'resource', '$rootScope', 'ajax', 'localStorage', '$location',
        function ($scope, $element, settings, userLanguage, userProvince, appInterface, resource, $rootScope, ajax, localStorage, $location) {
                    // global variables
                    $scope.languages = settings.supportedLanguages;
                    $scope.selectedLanguage = userLanguage();
                    $scope.selectedProvince = userProvince();

                    // Update functions
                    $scope.reloadFooterDOM = function (forceRedraw) {
                        var LCtype = 'footer';
                        var LClanguage = $scope.selectedLanguage;
                        var LCprovinceALLCAPS = $scope.selectedProvince;
                        var LCprovince = LCprovinceALLCAPS.toLowerCase();

                        var LCfilename = LCtype + '-' + LClanguage + '-' + LCprovince + '.xml';

                        var LCurlPrefix = '';
                        var LCurl = '';
                        // ----------------- localhost hack -------------------------------------- start
                        if (settings.isLocal) {
                            LCurlPrefix = settings.devServerURL;
                        }
                        // ----------------- localhost hack -------------------------------------- end

                        // Compile the file path
                        LCurl = LCurlPrefix + '/web/smb/cms/rogers-smb/integration/' + LCfilename;

                        // Prouction URL load
                        // https://www.rogers.com/consumer/integration/footer.page?setLanguage=fr&setProvince=on
                        // LCurl = 'https://www.rogers.com/consumer/integration/'+ LCtype +'.page?setLanguage='+ LClanguage +'&setProvince='+ LCprovince;

                        $element.load(LCurl, function () {
                            // post-load action

                            // Right side feedback tab
                            var domHolder = $element.find('#feedback-tab').find('a');
                            var tabType = appInterface.feedbackTabType;
                            var language = userLanguage();

                            $("#footer-bar #province select option[name='" + LCprovinceALLCAPS + "']").prop('selected', true);
                            $('body').on('change', '#footer-bar #province select', function (e) {
                                window.location = "?setProvince=" + $(this).find(':selected').text();
                            });
                            // Language link
                            var languageSelect = '';
                            if (LClanguage === 'en') {
                                languageSelect += 'languageFrench';
                            } else if (LClanguage === 'fr') {
                                languageSelect += 'languageEnglish';
                            } else {
                                // nothing
                            }
                            $element.find("#footer-bar .lang-toggle a").attr({
                                id: languageSelect
                            });

                            $element.find("#province .dropdown-toggle").html(LCprovinceALLCAPS + ' <span class="caret"></span>');
                            if (typeof (switchTab) === 'function') { // jshint ignore:line
                                switchTab(domHolder, tabType, language); // jshint ignore:line
                            }

                            if (forceRedraw) {
                                // Force - re-draw
                                $scope.$apply();
                            }
                            if ($rootScope.isDealer || $rootScope.isCare || $rootScope.isOneViewInterface) {
                                $element.find('#feedback-tab').hide();
                                $element.find('#footer a[onclick=\'javascript:FSR.popFeedback()\']').hide();
                            }
                            if ($scope.isFrontLineUser) {
                                var frontLineHide = "#footer, #footer-bar ul.footer-bar-links, #copyright";
                                $(frontLineHide).hide();
                                $("#footer-bar .province-language").addClass("col-md-push-2");
                            }

                        });
                    };

                    // Execute the update
                    $scope.reloadFooterDOM(false);
        }],
            link: function (scope, element, attrs) {}
        };
    });

// jQuery action binding
$("body").on("mouseover", "#ocpPopup", function (event) {
    event.preventDefault();
    event.stopPropagation();
    angular.element(document.getElementById("ocpPopup")).scope().showOcpPopup();
});
/*if(MBHLauncher){
MBHLauncher.subscribe('sessionTimeoutAlert',function(e,d) {
    angular.element(document.getElementById("ocpPopup")).scope().showOcpPopup();

  });
}*/
$('body').on('click', '.signOutLink', function (event) {
    event.preventDefault(); // Default action
    event.stopPropagation(); // Bubling

    angular.element(document.querySelector('.signOutLink')).scope().executeLogOut();
});

$('body').on('click', '#languageFrench', function (event) {
    event.preventDefault(); // Default action
    event.stopPropagation(); // Bubling
    window.postMessage({message: 'UCX-CHNG-LANGUAGE', messageData: { language: 'fr' },},'*');
    $('html').attr('lang', 'fr');
    angular.element(document.getElementById('languageFrench')).scope().languageToFrench(true);
    if(MBHLauncher && MBHLauncher.setLanguage) {
      MBHLauncher.setLanguage('fr');
    }
    //	var body = angular.element(document.body);
    //	var $rootScope = body.scope().$root;
    //	$rootScope.$apply(function(){
    //	  $rootScope.semafoneLang = 'fr';
    //	});
});

$('body').on('click', '#languageEnglish', function (event) {
    event.preventDefault(); // Default action
    event.stopPropagation(); // Bubling
    window.postMessage({message: 'UCX-CHNG-LANGUAGE', messageData: { language: 'en' },},'*');
    $('html').attr('lang', 'en');
    angular.element(document.getElementById('languageEnglish')).scope().languageToEnglish(true);
    if(MBHLauncher && MBHLauncher.setLanguage) {
      MBHLauncher.setLanguage('en');
    }

    //	var body = angular.element(document.body);
    //  	var $rootScope = body.scope().$root;
    //  	$rootScope.$apply(function(){
    //  	  $rootScope.semafoneLang = 'en';
    //  	});
});

$('body').on('click', '#province .dropdown-menu li a', function (event) {
    event.preventDefault(); // Default action
    event.stopPropagation(); // Bubling

    var linkID = $(this).attr('id');
    if (linkID) {
        angular.element(document.getElementById('province-alt')).scope().changeProvince(linkID);
    }
});

$('body').on('click', '#navToggleHeader', function (event) {
    var $body = angular.element(document.body);
    var $rootScope = $body.scope().$root;
    $rootScope.$apply(function () {
        $rootScope.showNavPlus = !$rootScope.showNavPlus;
    });
});

$('body').on('change', '#province-alt', function (event) {
    event.preventDefault(); // Default action
    event.stopPropagation(); // Bubling

    var linkID = $(this).val();
    console.log("linkID " + linkID);
    if (linkID) {
        angular.element(document.getElementById('province')).scope().changeProvince(linkID);
    }
});

'use strict';

angular.module('totesApp')
	.directive('logoutButton', ['user', function (user) {
		return function (scope, $elem) {
			$elem.click(function () {
				scope.$apply(function () {
					user.logout();
				});
			});
		};
	}]);
'use strict';
var secretDetail = "=";
angular.module('totesApp')
  .directive('matchEmail', ['appState', function (appState) {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        scope.$watch('[regObj.email, confirmEmail]', function (newVal) {
          if (!!newVal[0] && !!newVal[1]) {
            var currentValue = newVal[0] === newVal[1];
            ctrl.$setValidity('mismatchEmail', currentValue);
          }
        });
      }
    };
  }])

  .directive('matchEmailMu', ['appState', function (appState) {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        scope.$watch('[regObj.email, confirmEmail]', function (newVal) {
          if (!!newVal[0] && !!newVal[1]) {
            var currentValue = newVal[0] === newVal[1];
            ctrl.$setValidity('mismatchEmail', currentValue);
            appState.tagging(['_trackLink', {eVar49: 'MyRogers-username_mig_emails_donotmatch'}, {event15: ''}]);
          }
        });
      }
    };
  }])
  .directive('matchPassword', ["$interpolate", function ($interpolate) {
    return {
      require: 'ngModel',
      scope: {
        password: secretDetail,
        confirmpassword: secretDetail
      },
      link: function (scope, elem, attrs, ctrl) {
        if (scope.hasOwnProperty('password') && scope.hasOwnProperty('confirmpassword')) {
          scope.$watch('[password, confirmpassword]', function (newVal) {
            if (!!newVal[0] && !!newVal[1]) {
              var currentValue = newVal[0] === newVal[1];
              // console.log(currentValue);
              ctrl.$setValidity('mismatchPassword', currentValue);
            }
          });
        }
        scope.$watch('[regObj.password, regObj.confirmPassword]', function (newVal) {
          if (!!newVal[0] && !!newVal[1]) {
            var currentValue = newVal[0] === newVal[1];
            ctrl.$setValidity('mismatchPassword', currentValue);
          }
        });
      }
    };
  }])
  .directive('compareTo', function () {
    return {
      require: 'ngModel',
      scope: {
        otherModelValue: '=compareTo'
      },
      link: function (scope, element, attributes, ngModel) {

        ngModel.$validators.compareTo = function (modelValue) {
          if (!modelValue && ngModel.$name === 'confirmEmail') {
            ngModel.$setValidity('mismatchPassword', true);
            return;
          }

          if (modelValue !== scope.otherModelValue && scope.otherModelValue) {
            ngModel.$setValidity('mismatchPassword', false);
            return false;
          } else if (modelValue === scope.otherModelValue) {
            ngModel.$setValidity('mismatchPassword', true);
            return true;
          }
        };

        scope.$watch('otherModelValue', function () {
          ngModel.$validate();
        });
      }
    };
  })

  .directive('match', ["$parse", function match($parse) {
    return {
      require: '?ngModel',
      restrict: 'A',
      link: function (scope, elem, attrs, ctrl) {
        if (!ctrl) {
          if (console && console.warn) {
            console.warn('Match validation requires ngModel to be on the element');
          }
          return;
        }

        var matchGetter = $parse(attrs.match);
        var caselessGetter = $parse(attrs.matchCaseless);
        var unMatch = $parse(attrs.unMatch);
        scope.$watch(getMatchValue, function () {
          ctrl.$$parseAndValidate();
        });

        ctrl.$validators.match = function () {
          var match = getMatchValue();
          if (caselessGetter(scope) && angular.isString(match) && angular.isString(ctrl.$viewValue)) {
            return ctrl.$viewValue.toLowerCase() === match.toLowerCase();
          }
          if (unMatch(scope) && angular.isString(match) && angular.isString(ctrl.$viewValue)) {
            return ctrl.$viewValue === '' || ctrl.$viewValue !== match;
          }
          return ctrl.$viewValue === match;
        };

        function getMatchValue() {
          var match = matchGetter(scope);
          if (angular.isObject(match) && match.hasOwnProperty('$viewValue')) {
            match = match.$viewValue;
          }
          return match;
        }
      }
    };
  }])
  .directive('truthTest', function match() {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, elem, attrs, ctrl) {
        var truthTest = attrs.truthTest == 'true';
        ctrl.$validators.invalidEmail = function (modelValue, viewValue) {
          return modelValue != 'E_BILL' || truthTest;
        };
      }
    };
  });


'use strict';

//the this directive is to solve insufficiency of original directive ngForm/form and
//ngModel, add a $setAllDirty method to put 'ng-dirty' to input element
//and set ngModel of that element to $dirty(true)

//var formDirectiveBuilder = function (isNgForm) {
//    return function () {
//        return {
//            restrict: isNgForm ? 'EAC' : 'E',
//            require: 'form',
//            link: function postLink(scope, element, attrs, ngForm) {
//
//                ngForm.$setAllDirty = function () {
//                    this.$setDirty();
//                    for (var key in this) {
//                        var model = this[key];
//                        if (model && model.$name) {
//                            model.$dirty = true;
//                        }
//                    }
//                    element.find('[ng-model], [data-ng-model]').removeClass('ng-pristine').addClass('ng-dirty');
//                };
//            }
//        };
//    };
//};
//
//angular.module('totesApp')
//    .directive('form', formDirectiveBuilder())
//    .directive('ngForm', formDirectiveBuilder(true));
//
//formDirectiveBuilder = null;

//angular.module('totesApp')
//    .directive('ngModel', function () {
//        return function (scope, $elem, attrs) {
//
//            $elem.keyup(function (e) {
//
//                if (e.which == 13) {
//                    e.preventDefault();
//                    e.stopImmediatePropagation();
//                    return false;
//                }
//            });
//
//        };
//    });
'use strict';

// More info on nested directives
// https://thinkster.io/egghead/directive-to-directive-communication/


angular.module('totesApp')
	.directive('permission', function () {
		return {
			restrict: 'A',
			controller: ['$scope', '$rootScope', 'appState', '$element', '$attrs', function ($scope, $rootScope, appState, $element, $attrs) {
				$scope.myFlag = $attrs.permission;
				$scope.shomi = false;

				$scope.runner = function () {
					$scope.shomi = false;			// reset
					
					// Find if listed
					if ($scope.myFlag !== '') {
						$scope.shomi = appState.permissionTo($scope.myFlag);
					}

					// Remove from DOM
					if ($scope.shomi) {
						// Show
						$element.show();
					} else {
						// Hide
						$element.hide();
					}
				};
				$scope.runner();
				

				// Test functions for two way communication - See accountBalance.js to see how to set that up
				this.checkFlags = function () {
// console.log ('Yo... permission directive here!!!');
				};
				this.passFlags = function (pass) {
// console.log ('passFlags', pass);
				};


				$rootScope.$watch('ao.accountDetails', function(newVal, oldVal){
					$scope.runner();
				}, true);
				
				$rootScope.$watch('permissions.permissionActive', function(newVal, oldVal){
					$scope.runner();
				}, true);
			}],
			link: function (scope, element, attrs) {}
		};
	});

'use strict';

angular.module('totesApp')
    .directive('res', ['resource', function (resource) {
        var resParamAttribute = /^res-param-(.*)/;				// TODO - USE attrs.resParam NOT regex!!!

        return function (scope, element, attrs) {

            var substitutions;

            //search for attributes like res-param-xxx, such as
            //for <span res="greeting" res-param-fullname="{{fullname}}"></span>
            //to create a substitution object like { fullname: value_of_fullname }
            //if greeting is "My name is {fullname}" and fullname is "Fred"
            //then output will name "My name is Fred
            angular.forEach(attrs.$attr, function (attr, normalizedAttr) {

                //if attribute name is data-xxx (but it can not be data-ng-xxx), extract it
                //and create an object like { fullname: 'fred yang' }
                var match = resParamAttribute.exec(attr);
                if (match) {
                    substitutions = substitutions || {};
                    var paraName = match[1];
                    attrs.$observe(normalizedAttr, function (newVal, oldVal) {
                        if ((newVal && newVal !== oldVal) || !(substitutions && substitutions[paraName])) {
                            substitutions[paraName] = attrs[normalizedAttr];
                            update();
                        }
                    });
                }
            });

            function update() {
                element.html(resource.get(attrs.res, substitutions));
            }

            resource.onChanged(!substitutions, update, scope);
        };
    }])
    .directive('resappend',['resource', function (resource) {
        var resParamAttribute = /^resappend(.*)/;

        return function (scope, element, attrs) {

            var substitutions;

            //search for attributes like res-param-xxx, such as
            //for <span res="greeting" res-param-fullname="{{fullname}}"></span>
            //to create a substitution object like { fullname: value_of_fullname }
            //if greeting is "My name is {fullname}" and fullname is "Fred"
            //then output will name "My name is Fred
            angular.forEach(attrs.$attr, function (attr, normalizedAttr) {

                //if attribute name is data-xxx (but it can not be data-ng-xxx), extract it
                //and create an object like { fullname: 'fred yang' }
                var match = resParamAttribute.exec(attr);
                if (match) {
                    substitutions = substitutions || {};
                    var paraName = match[1];
                    attrs.$observe(normalizedAttr, function (newVal, oldVal) {
                        if ((newVal && newVal !== oldVal) || !(substitutions && substitutions[paraName])) {
                            substitutions[paraName] = attrs[normalizedAttr];
                            update();
                        }
                    });
                }
            });

            function update() {
                element.append(resource.get(attrs.resappend, substitutions));
            }

            resource.onChanged(!substitutions, update, scope);
        };
    }]);

'use strict';

angular.module('totesApp')
    .directive('resAttr', ['resource', function (resource) {
        return function (scope, element, attrs) {
            var resKeyValuePairs = scope.$eval(attrs.resAttr);

            resource.onChanged(
                function () {
                    for (var attrName in resKeyValuePairs) {
                        var resourceKey = resKeyValuePairs[attrName];
                        var resourceValue = resource.get(resourceKey);
                        element.attr(attrName, resourceValue);
                    }
                }, scope);
        };
    }]);

'use strict';

angular.module('totesApp')
	.directive('showOnLogin', ['user', function (user) {
		return function (scope, $elem) {
			scope.$watch(function () {
				return user.isAuthenticated();
			}, function (data) {
				$elem[ data ? 'show' : 'hide']();
			});
		};
	}])
	.directive('hideOnLogin', ['user', function (user) {
		return function (scope, $elem) {
			scope.$watch(function () {
				return user.isAuthenticated();
			}, function (data) {
				$elem[ data ? 'hide' : 'show']();
			});
		};
	}]);
'use strict';

//<a tab-link="model|news|selected">
//<a tab-link="model|news">
angular.module('totesApp')
    .directive('tabLink', ['$parse', function ($parse) {
        return function (scope, $elem, attrs) {

            var parts = attrs.tabLink.split('|');
            var modelExpression = parts[0];
            var tabId = parts[1];
            var selectedClass = parts[2] || 'selected';

            $elem.click(function () {
                scope.$apply(function () {
                    $parse(modelExpression).assign(scope, tabId);
                });
            });

            scope.$watch(modelExpression, function (value) {
                if (value === tabId) {
                    $elem.addClass(selectedClass);
                } else {
                    $elem.removeClass(selectedClass);
                }
            });
        };
    }]);

'use strict';

//<div tab-view="appState.module|dashboard|active">
angular.module('totesApp')
    .directive('tabView', function () {
        return function (scope, $elem, attrs) {

            var parts = attrs.tabView.split('|');
            var modelExpression = parts[0];
            var tabId = parts[1];
            var selectedClass = parts[2] || 'selected';

            scope.$watch(modelExpression, function (value) {
                if (value === tabId) {
                    $elem.addClass(selectedClass);
                } else {
                    $elem.removeClass(selectedClass);
                }
            });
        };
    });

'use strict';

angular
        .module('totesApp')
        .directive('toggleClass', function () {
          return {
            restrict: 'A',
            link: function (scope, element, attrs) {
              element.bind('click', function () {
                element.toggleClass(attrs.toggleClass);
              });
            }
          };
        });

'use strict';
/*
The directive to toggle 'touched' class of the element upon mouse clicking.
 */
angular.module('totesApp')
    .directive('touched', function () {
        return function($scope, $element, attr){

/*            function addClass(){
              $element.toggleClass('touched');
            }*/
/*            function removeClass(){
              $element.toggleClass('touched');
            }*/
/*          var $body = $('body');
          $element.bind( 'click', addClass);
          $body.bind( 'click', addClass);*/

          /*if (!('ontouchstart' in document.documentElement)) {
            document.documentElement.className += ' no-touch';
            $element.addClass('touch');
          }else{
            $element.addClass('no-touch');
          }*/
          $element.bind('touchstart',function(e){
            e.stopPropagation();
            $element.addClass('touch');
           // $body.insert
          });
          var $body = $('body');
          $body.bind('touchstart',function(){
            $element.removeClass('touch');
          });
        };

    });

'use strict';
/*
The directive to tag the validation error of a form field.
use as:
 <input type="text" validation-tag tag-form-name="form" tag-page-name="Registration" name="email" id="email" />
 once the inline validation error occurs, the error object will be tagged through appState service.
 */
angular.module('totesApp')
    .directive('validationTag', ['appState', function (appState) {
        return function($scope, $element, attrs){
          var _formName = attrs.tagFormName;
          var _pageName = attrs.tagPageName || 'unknown_page';
          var _fieldName = attrs.name || attrs.id || 'unknown_field';
          if( !_formName ){
            return;
          }
          var _form = $scope[attrs.tagFormName];
          function getValidity(){
            //return $element.$error;
            return _form[attrs.name].$error;
          }
          //check the form field error type and tag it.
          $scope.$watch( getValidity, function(newVal, oldVal) {
            if( !newVal || $( newVal).length <=0){
              return;
            }

            appState.tagFieldValidationErrors ( _pageName, _fieldName,  newVal  );

          }, true);

        };

    }]);

'use strict';
angular.module('rfrApp').controller('addressFormCtrl', [
  '$scope',
  'resource',
  'addressValidationService',
  '$modal',
  addressFormCtrl
]);

function addressFormCtrl(
  $scope,
  resource,
  addressValidationService,
  $modal
) {
  $scope.model = {
    'province': {
      name: resource.get('_select_province'),
      value: '?'
    }
  };
  $scope.options = {
    formDefaults: {
      feedback: '{"inline-checker": true,"icon-checked": hasSuccess(), "icon-error": hasError()}',
      ngModelOptions: { updateOn: 'submit' }
    }
  };

  var createFormDefs = function(){
    $scope.form = createForm();
    $scope.schema = createSchema();
  };

  var createForm = function(){
    return [
      {
        'type': 'section',
        'htmlClass': 'row',
        'items': [
          {
            'type': 'section',
            'htmlClass': 'col-xs-12 col-sm-4',
            'items': [
              {
                'key': 'firstName',
                'title': resource.get('_first_name'),
                'placeholder': resource.get('_enter_first_name'),
                'validationMessage':' '
              },
              {
                'key': 'lastName',
                'title': resource.get('_last_name'),
                'placeholder': resource.get('_enter_last_name'),
                'validationMessage':' '
              },
              {
                'key': 'addressLine1',
                'title': resource.get('_address'),
                'placeholder': resource.get('_enter_address'),
                'validationMessage':' '
              },
              {
                'key': 'addressLine2',
                'notitle': true,
                'placeholder': resource.get('address_line_2'),
                'validationMessage':' '
              }
            ]
          },
          {
            'type': 'section',
            'htmlClass': 'col-xs-12 col-sm-4',
            items: [
              {
                'key': 'city',
                'title': resource.get('_city'),
                'placeholder': resource.get('_enter_city'),
                'validationMessage':' '
              },
              {
                'key': 'province',
                'type': 'template',
                'template': '<div rui-dropdown class="form-group rui-dropdown" list=form.provinceList selected="$$value$$" property="name" ng-model="$$value$$"></div>',
                ngModel: function(ngModel) {
                  ngModel.$validators.provinceSelect = function(province) {
                    return province.value !== '?';
                  };
                },
                validationMessage: {
                  'provinceSelect': ' '
                },
                'provinceList': createProvinceTitleMap(),
                'title': resource.get('_province')
              },
              {
                'key': 'postalCode',
                'title': resource.get('_postal_code'),
                'placeholder': resource.get('_enter_postal_code'),
                'validationMessage':' '
              },
              {
                'key': 'phone',
                'title': resource.get('_phone_number'),
                'placeholder': resource.get('_enter_phone_number'),
                'validationMessage':' '
              }
            ]
          },
          {
            'type': 'section',
            'htmlClass': 'col-xs-12 col-sm-4',
            'items': [
              {
                'key': 'comment',
                'type': 'textarea',
                'placeholder': resource.get('comment_placeholder')
              }
            ]
          }
        ]
      },
      {
        'type': 'submit',
        'style': 'cta-round primary pull-right address-form-submit',
        'title': resource.get('_save')
      }
    ];
  };

  var createSchema = function(){
    return  {
      'type': 'object',
      'title': 'Comment',
      'properties': {
        'firstName': {
          'type': 'string'
        },
        'lastName': {
          'type': 'string'
        },
        'addressLine1': {
          'type': 'string'
        },
        'addressLine2': {
          'type': 'string'
        },
        'city': {
          'type': 'string'
        },
        'province': {
          'type': 'string',
          'enum': ['AB', 'BC', 'MB', 'NB', 'NL', 'NT', 'NS', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT']
        },
        'postalCode': {
          'type': 'string'//,
          //'pattern': '^\\S+@\\S+$'
        },
        'phone': {
          'type': 'string',
          //'pattern': '^\\S+@\\S+$'
        },
        'comment': {
          'title': resource.get('comment_title'),
          'type': 'string',
          'maxLength': 150,
          'validationMessage': 'Keep the message short!'
        }
      },
      'required': [
        'firstName',
        'lastName',
        'addressLine1',
        'city',
        'phone',
        'postalCode'
      ]
    };
  };

  $scope.$on('resourceChanged', createFormDefs);

  var createProvinceTitleMap = function () {
    return [
      {
        name: resource.get('_select_province'),
        value: '?'
      },
      {
        name: resource.get('_province_AB'),
        value: 'AB'
      },
      {
        name: resource.get('_province_BC'),
        value: 'BC'
      },
      {
        name: resource.get('_province_MB'),
        value: 'MB'
      },
      {
        name: resource.get('_province_NB'),
        value: 'NB'
      },
      {
        name: resource.get('_province_NL'),
        value: 'NL'
      },
      {
        name: resource.get('_province_NT'),
        value: 'NT'
      },
      {
        name: resource.get('_province_NS'),
        value: 'NS'
      },
      {
        name: resource.get('_province_NU'),
        value: 'NU'
      },
      {
        name: resource.get('_province_ON'),
        value: 'ON'
      },
      {
        name: resource.get('_province_PE'),
        value: 'PE'
      },
      {
        name: resource.get('_province_QC'),
        value: 'QC'
      },
      {
        name: resource.get('_province_SK'),
        value: 'SK'
      },
      {
        name: resource.get('_province_YT'),
        value: 'YT'
      }
    ];
  };

  $scope.onSubmit = function(form) {
    // First we broadcast an event so all fields validate themselves
    $scope.$broadcast('schemaFormValidate');

    // Then we check if the form is valid
    if (form.$valid && $scope.model.province.value !== '?') {
      addressValidationService.addressValidationRequest({
        address1: form.addressLine1.$modelValue,
        address2: form.addressLine2.$modelValue,
        city: form.city.$modelValue,
        phone: form.phone.$modelValue,
        province: $scope.model.province.value,
        postalCode: form.postalCode.$modelValue
      }).then(function(result){
        if (form.phone && form.phone.$modelValue) {
          result.phone = form.phone.$modelValue;
        }
        $scope.openModal(form, result);
      },function(error){
        if(error.data){
          $scope.handleSuggestionError(error, form);
        }
      });
    }
  };

  $scope.handleSuggestionError = function(error, form){
    switch(error.data.data.errorMessage){
      case 'STREET ERR: RCIS_ERR':
            form.addressLine1.$setValidity('parse', false);
            break;
      case 'POSTAL CODE ERR: RCIS_ERR':
            form.postalCode.$setValidity('parse', false);
            break;
      case 'CIVIC NO: RCIS_ERR':
            form.addressLine1.$setValidity('parse', false);
            break;
      case 'UNSPECIFIED: RCIS_ERR':
            form.addressLine1.$setValidity('parse', false);
            break;
      default:
            form.addressLine1.$setValidity('parse', false);
            break;
    }
  };

  $scope.openModal = function (form, result) {
    var modalInstance = $modal.open({
      animation: false,
      templateUrl: 'rfr/js/directives/addressFormModal/addressFormModal.html',
      controller: 'addressFormModalCtrl',
      resolve: {
        entry: function(){
          return {
            firstName: form.firstName.$modelValue,
            lastName: form.lastName.$modelValue,
            addressLine1: form.addressLine1.$modelValue,
            addressLine2: form.addressLine2.$modelValue,
            city: form.city.$modelValue,
            province: $scope.model.province.value,
            postalCode: form.postalCode.$modelValue,
            contactPhone: form.phone.$modelValue
          };
        } ,
        suggestion: function(){
          return {
            firstName: form.firstName.$modelValue,
            lastName: form.lastName.$modelValue,
            addressLine1: result.address1,
            addressLine2: result.address2,
            city: result.city,
            province: result.province,
            postalCode: result.postalCode,
            contactPhone: form.phone.$modelValue
          };
        }
      }
    });

    modalInstance.result.then(function (addressValues) {
      $scope.$emit('confirmShipAddress', addressValues);
    });
  };

  createFormDefs();
}

angular.module('rfrApp').controller('addressFormModalCtrl', ["$scope", "$modalInstance", "entry", "suggestion", function ($scope, $modalInstance, entry, suggestion) {
  $scope.entry = entry;
  $scope.suggestion = suggestion;
  $scope.ok = function (params) {
    $modalInstance.close(params);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };

  $scope.useSuggestion = function() {
    $scope.ok(suggestion);
  };

  $scope.useMine = function () {
    $scope.ok(entry);
  };

  $scope.modify = function () {
    $scope.cancel();
  };


}]);

'use strict';

angular.module('rfrApp').controller('browseCtrl', [
  '$scope',
  'rfrUtilService',
  '$state',
  '$anchorScroll',
  '$filter',
  '$browser',
  'user',
  'resource',
  'membershipDetail',
  '$stateParams',
  'rewardsList',
  'contentFetchService',
  'userLanguage',
  'localStorage',
  'settings',
  'apiRoutes',
  '$rootScope',
  'rewardsListService',
  browseCtrl])
  .filter('rewardsCategoryFilter',[rewardsCategoryFilter])
  .filter('rewardsCategoryRefineFilter',[rewardsCategoryRefineFilter])
  .filter('rewardsSortFilter',[rewardsSortFilter])
  .filter('rewardsBrowseSearch',[rewardsBrowseSearch])
  .filter('orderCats',[orderCats]);

function browseCtrl(
  $scope,
  rfrUtilService,
  $state,
  $anchorScroll,
  $filter,
  $browser,
  user,
  resource,
  membershipDetail,
  $stateParams,
  rewardsList,
  contentFetchService,
  userLanguage,
  localStorage,
  settings,
  apiRoutes,
  $rootScope,
  rewardsListService
) {
  $scope.categories = $scope.$parent.categoriesList || {};

  $scope.catIconsShown = false;

  $scope.imageUrl = settings.formsURL + settings.unProtectedUrlPrefix +  apiRoutes.rfrAPI.getProductImg;

  $scope.searchBrowseReward = '';

  $scope.lang = userLanguage();

  $scope.goToCategory = function(stateToGo) {
    $scope.userNavigationLoaderShow = true;

    if (stateToGo.catId === $state.params.catId || /iPad|iPhone|iPod/.test(navigator.platform)) {
      $state.go('rewards.browse', stateToGo, { reload: true });
      return;
    }

    setTimeout(function(){ $state.go('rewards.browse', stateToGo) }, 50);
  };

  $scope.accountDetails = $scope.accountDetails || (membershipDetail) ? {
    points: membershipDetail.pointsBalance
  } : {};

  $scope.rewardNameRes = resource.get('rewardName')
  $scope.sort_by_allRes = resource.get('sort_by_allRes')
  $scope.sort_by_availableRangeRes = resource.get('sort_by_availableRangeRes')
  $scope.sort_by_lowhighRes = resource.get('sort_by_lowhighRes')
  $scope.sort_by_highlowRes = resource.get('sort_by_highlowRes')
  $scope.sort_by_1_2499Res = resource.get('sort_by_1_2499Res')
  $scope.sort_by_2500_4999Res = resource.get('sort_by_2500_4999Res')
  $scope.sort_by_5000_7499Res = resource.get('sort_by_5000_7499Res')
  $scope.sort_by_7500_9999Res = resource.get('sort_by_7500_9999Res')
  $scope.sort_by_10000Res = resource.get('sort_by_10000Res')

  //Sorting options
  $scope.sortingCategories = [
    {'id':'all','name': $scope.sort_by_allRes},
    {'id':'ascending','name':$scope.sort_by_lowhighRes },
    {'id':'descending','name':$scope.sort_by_highlowRes },
    {'id':'under2500','name':$scope.sort_by_1_2499Res },
    {'id':'2500-4999','name':$scope.sort_by_2500_4999Res },
    {'id':'5000-7499','name':$scope.sort_by_5000_7499Res },
    {'id':'7500-9999','name':$scope.sort_by_7500_9999Res },
    {'id':'over10000','name':$scope.sort_by_10000Res }
  ];

  //Add mypoints option if user is logged in
  //temp fix please search for the real cause
  if (rfrUtilService.isRfrAuthenticated()){
     if (rfrUtilService.isRfrEnrolled()) {
    var removed = $scope.sortingCategories.splice(1, 0,
      {'id':'mypoints','name': $scope.sort_by_availableRangeRes,'value':$scope.accountDetails.points});
    }
  }

  $scope.currentCategorySortOption = '';

  $scope.$on('resourceChanged', function () {
    $scope.catIconsShown = false;
    $scope.userNavigationLoaderShow = true;
    $scope.rewardNameRes = resource.get('rewardName');
    $scope.sort_by_allRes = resource.get('sort_by_allRes');
    $scope.sort_by_availableRangeRes = resource.get('sort_by_availableRangeRes');
    $scope.sort_by_lowhighRes = resource.get('sort_by_lowhighRes');
    $scope.sort_by_highlowRes = resource.get('sort_by_highlowRes');
    $scope.sort_by_1_2499Res = resource.get('sort_by_1_2499Res');
    $scope.sort_by_2500_4999Res = resource.get('sort_by_2500_4999Res');
    $scope.sort_by_5000_7499Res = resource.get('sort_by_5000_7499Res');
    $scope.sort_by_7500_9999Res = resource.get('sort_by_7500_9999Res');
    $scope.sort_by_10000Res = resource.get('sort_by_10000Res')
  });



  //List of rewards & categoryies
  $scope.refinedRewardsList = $scope.rewards;


  //This one is a list of the main top categories
  $scope.slideFlagCategories = {};

  //Category Code to Name mapping & vice-versa
  $scope.catCodeNameMapping = {};
  $scope.catNameCodeMapping = {};

  //This is a list of all the categories
  $scope.allCategories = {};

  //Loop through the categories and pick
  // the once to be shown at the top of the browse section
  var sliderCatCounter = 0; //This counter makes sure
  // not more than 6 sliders show on selected categories
    var categoriesFn = function(){
    if(rfrUtilService.isRfrAuthenticated() && membershipDetail){
      if(membershipDetail.statusCode === 'A' || membershipDetail.statusCode === 'S'){
        rewardsListService.getRewardCategories({membershipId: membershipDetail.membershipId}).then(
            function(data) {
              $scope.categories = data;
              $scope.$parent.categoriesList = data;
              init();
            },
            function(data) {
              console.log(data);
            });
      }else{
        rewardsListService.getRewardCategories().then(
          function(data) {
            $scope.categories = data;
            $scope.$parent.categoriesList = data;
            init();
          },
          function(data) {
            console.log(data);
          });
      }
    } else {
      rewardsListService.getRewardCategories().then(
        function(data) {
          $scope.categories = data;
          $scope.$parent.categoriesList = data;
          init();
        },
        function(data) {
          console.log(data);
        });
    }
  };

  var init = function(){
    //console.log('Init Starts');
    for (var i=0;i < $scope.categories.length; i++) {
      var currentCat = $scope.categories[i];
      var currentCatCode = currentCat.name.replace(/ /g,'').toLowerCase();

      currentCat.url = currentCatCode;
      currentCat.catFilter = { };
      currentCat.catFilter[currentCat.code] = 1;

      $scope.catCodeNameMapping[currentCat.code] = currentCat.name;
      $scope.catNameCodeMapping[currentCatCode] = currentCat.code;

      if (currentCat.sliderFlag) {
        sliderCatCounter++;
        //Mapping the browse Cat name to the current category page
        if (currentCat.browseRewards) {
        //Flush out the Category stored rewards so they get updated from new rewards pulled form server
          delete currentCat.browseRewards;
        }
        $scope.slideFlagCategories[currentCatCode] = currentCat;
        $scope.slideFlagCategories[currentCatCode]['ordering'] = sliderCatCounter.toString();

        //For each category we need to get the category icons, so we have to
        //call the getProductImg and passing the image id
        //Also we have to wrap it in a closure function to pass the catCode
        //so that we can assign the image patch back to the slideFlagCategories object
        if(!localStorage.getLocalStorageObject(currentCatCode)){
          if(currentCat.imageId){
            contentFetchService.getProductImg({
              imageId: currentCat.imageId
            }).then(function(catCode) {
              return function (imgData) {
                if (imgData && imgData.imageData) {
                  $scope.slideFlagCategories[catCode].imageBg = {
                    'imgData': 'data:image/jpg;base64,' + imgData.imageData
                  };
                  localStorage.setLocalStorageObject(catCode, {
                    'imgData': 'data:image/jpg;base64,' + imgData.imageData,
                    timestamp: moment()
                  });
                }
              };
            }(currentCatCode));
          }

        } else {
          $scope.slideFlagCategories[currentCatCode].imageBg = {
            imgData: localStorage.getLocalStorageObject(currentCatCode).imgData
          };
        }

      } else {
        $scope.allCategories[currentCatCode] = currentCat;
      }
    }

  $scope.categoryOrder = 'ordering';

  //............
  $scope.sortRewardId = '';

  $scope.categoryOrderPredicate = function(cat) {
    return cat.ordering;
  };

  if ($scope.catNameCodeMapping[$stateParams.catId] || ! $stateParams.catId) {
    $scope.catId = $stateParams.catId;
    $rootScope.categoryCode = $scope.catNameCodeMapping[$stateParams.catId];
    $scope.catName = $scope.catCodeNameMapping[$rootScope.categoryCode];
  } else if ($stateParams.catId && $rootScope.categoryCode) {
    $rootScope.currentSelectedCategoryName = $scope.catCodeNameMapping[$rootScope.categoryCode];
    $rootScope.updateMenuLinks();
    $scope.catId = $scope.catCodeNameMapping[$rootScope.categoryCode].replace(/ /g,'').toLowerCase();
  }

  //refineCatCode is used by the refine by category filter
  $scope.refineCatCode = $scope.catNameCodeMapping[$stateParams.catId];

  //The current selected categories
  if ($scope.catId) {
    $scope.catCode = {};
    if ($scope.slideFlagCategories[$scope.catId]) {
      $scope.catCode[$scope.slideFlagCategories[$scope.catId].code] = 1;
    } else {
      $scope.catCode[$scope.allCategories[$scope.catId].code] = 1;
    }
  } else {
    $scope.catCode = null;
  }
  $scope.currentCategory = '';

  $scope.catIconsShown = true;

  //In the Refine dropdown we only want to show categories that are in the existing rewards list
  //and not all categories
  $scope.updateRewardCategories = function() {
    var availableRewardCats = {};
    var catRewards = rewardsCategoryFilter()($scope.rewards,$scope.catCode,false);
    catRewards = (!$scope.searchBrowseReward) ? catRewards : rewardsBrowseSearch()(catRewards,$scope.searchBrowseReward)


    for (var i = 0;i < catRewards.length && ($scope.catId || $scope.searchBrowseReward);i++) {
      for (var j=0;j < catRewards[i].categoryCodes.length;j++) {
        availableRewardCats[catRewards[i].categoryCodes[j]] = 1;
      }
    }
    return availableRewardCats;
  };

  $scope.applyAllFilters = function(forceCat, forceSearch) {
    $scope.refinedRewardsList = $scope.rewards;

    if ($scope.refineCatCode || forceCat) {
      $scope.refinedRewardsList = $filter('rewardsCategoryRefineFilter')($scope.refinedRewardsList,$scope.refineCatCode);

      var currentCatCode = $scope.catNameCodeMapping[$scope.catId];
      if (currentCatCode && currentCatCode != $scope.refineCatCode) {
        $scope.refinedRewardsList = $filter('rewardsCategoryRefineFilter')($scope.refinedRewardsList,currentCatCode);
      }
    }

    if ($scope.searchBrowseReward || forceSearch) {
      $scope.refinedRewardsList = $filter('rewardsBrowseSearch')($scope.refinedRewardsList,$scope.searchBrowseReward);
    }

    if ($scope.currentCategorySortOption) {
      $scope.refinedRewardsList = $filter('rewardsSortFilter')($scope.refinedRewardsList,$scope.currentCategorySortOption);
    }

  };

  $scope.$watch('searchBrowseReward', function(newValue, oldValue) {
    if ($scope.rewards && newValue != oldValue && ( (newValue) || (oldValue && !newValue) ) ) {
      $scope.applyAllFilters(false,true);
    }
  });

  $scope.$watch('refineCatCode', function(newValue, oldValue) {
    //if ( newValue != oldValue && ( (newValue) || (oldValue && !newValue) ) ) {
    if ($scope.rewards) {
      $scope.applyAllFilters(true,true);
    }
  });

  $scope.$watch('currentCategorySortOption', function(newValue, oldValue) {
    if ($scope.rewards && newValue && newValue != oldValue) {
      $scope.applyAllFilters(false,false);
    }
  });

  $scope.$watch('$parent.rewardsList' , function(newValue , oldValue){
    $scope.rewards = newValue;
    $scope.refinedRewardsList = newValue;
    var wishListCounter = 0

    //Loop through all the rewards and add 3 rewards to each main category so that it shows up
    //On the main browse page
    if ($scope.rewards.length) {
      for (var i= 0; i < $scope.rewards.length; i++) {
        var currentReward = $scope.rewards[i];

        //Wishlist counter
        if(newValue[i].inWhishList == true){
          wishListCounter = wishListCounter + 1;
        }

        for (var j = 0; j < currentReward.categoryCodes.length; j++) {
          var currentCatCode = currentReward.categoryCodes[j];
          var catName = $scope.catCodeNameMapping[currentCatCode].replace(/ /g,'').toLowerCase();

          // If this category is apart of the slider cats
          // and if this is the first reward to be added tot he browse Rewards
          if ($scope.slideFlagCategories[catName]) {
            var currentCategory = $scope.slideFlagCategories[catName];
            if (! currentCategory.browseRewards) {
              //Create array and add first reward
              currentCategory.browseRewards = [currentReward];
            } else if (currentCategory.browseRewards.length < 3) {
              //Append to the array
              currentCategory.browseRewards.push(currentReward);
            }
          }
        }

      }

      if ($scope.refineCatCode) {
        $scope.refinedRewardsList = $filter('rewardsCategoryRefineFilter')($scope.rewards,$scope.refineCatCode);
      }

    }

    $rootScope.wishlistCounter = wishListCounter
    $scope.availableRewardCategories = $scope.updateRewardCategories();
      $scope.refinedCategories = (! $scope.catId) ? $scope.categories : $scope.categories.filter(function(cat) {
          return ($scope.availableRewardCategories[cat.code] && cat.refineFlag);
      });
  })

  $scope.$on('$stateChangeSuccess',
    function(event, toState, toParams, fromState, fromParams){
    if (toState.name == "rewards.browse" && fromState.name != "rewards.browse" && fromState.name){
      //console.log('Going to call RewardsList FN');
      $scope.$parent.rewardsListFn()
    }
  });

  $scope.lazyLoadLimit = ($scope.catId || $scope.searchBrowseReward) ? 8 : 0;
  $anchorScroll();
  $scope.loadMore = function() {
    if ($scope.catId || $scope.searchBrowseReward)
      $scope.lazyLoadLimit = ($scope.lazyLoadLimit >= $scope.rewards.length ? $scope.rewards.length : $scope.lazyLoadLimit += 6);
  };

  $scope.$watch('searchBrowseReward',function(value) {
    if(!$.isEmptyObject($scope.categories)){
      $scope.lazyLoadLimit = ($scope.catId || value) ? 8 : 0;
      $scope.availableRewardCategories = $scope.updateRewardCategories();
      $scope.refinedCategories = $scope.categories.filter(function(cat) {
        return ($scope.availableRewardCategories[cat.code] && cat.refineFlag);
      });
    }
  });

  $scope.sortRewardBy = function(item) {
    $scope.sortRewardId = item.id;
  };

  $scope.refineCategoryBy = function(item) {
      $scope.refineCatCode = item.code;
  };

  $scope.getResourceString = function(ref){
    return resource.get(ref);
  };

  $scope.loggedInOnly = rfrUtilService.isRfrAuthenticated();

  //Get the CatNameCodeMapping into the rootScope so we can use it in the subMenu breadcrumbs
  $rootScope.currentSelectedCategoryName = ($scope.catId && $scope.slideFlagCategories[$scope.catId]) ?
    $scope.slideFlagCategories[$scope.catId].name : '';
    //console.log('Init Ends');
  };

  $scope.$watch('rewards', function(newValue, oldValue) {
    //console.log('rewards Changed');
    init();
  });

  if(!$scope.$parent.categoriesList.length) {
    categoriesFn()
  }else{
    init();
  }
  $scope.userNavigationLoaderShow = false;

}



/////////////////////////////resolve/////////////////////////////////////////


browseCtrl.resolve = {
  permissionData: ['$browser','permissionResolver' , 'rfrUtilService', function ($browser,permissionResolver, rfrUtilService) {
    //Update the linkIn cookie for url redirect
    if(!rfrUtilService.isRfrAuthenticated()){
      $browser.cookies('linkIn',document.location.href);
    }
    return permissionResolver.getPermission(this.url.sourcePath);
  }]
};


///////////////////////////////filters///////////////////////////////////////
function rewardsSortFilter() {
  return function(rewards, sortType) {
    var filtered = [];

    if (sortType == '' || sortType.id == 'all') {
      filtered = rewards;
    } else if (sortType.id == 'ascending') {
      filtered = rewards;
      filtered.sort(function (a, b) {
        var aArray = (a.pricePlanList && a.pricePlanList[0]) ? a.pricePlanList[0] : undefined;
        var bArray = (b.pricePlanList && b.pricePlanList[0]) ? b.pricePlanList[0] : undefined;
        var aVal = (aArray && aArray['points']) ? aArray['points'] : 0;
        var bVal = (bArray && bArray['points']) ? bArray['points'] : 0;
        return aVal - bVal;
      });
    } else if (sortType.id == 'descending') {
      filtered = rewards;
      filtered.sort(function (a, b) {
        var aArray = (a.pricePlanList && a.pricePlanList[0]) ? a.pricePlanList[0] : undefined;
        var bArray = (b.pricePlanList && b.pricePlanList[0]) ? b.pricePlanList[0] : undefined;
        var aVal = (aArray && aArray['points']) ? aArray['points'] : 0;
        var bVal = (bArray && bArray['points']) ? bArray['points'] : 0;
        return bVal - aVal;
      });
    } else if (sortType.id == 'mypoints' && sortType.value) {
      angular.forEach(rewards, function(reward) {
        if (reward.points <= sortType.value)
          filtered.push(reward);
      });
    } else if (sortType.id == 'under2500') {
      angular.forEach(rewards, function(reward) {
        if (reward.points < 2500)
          filtered.push(reward);
      });
    } else if (sortType.id == '2500-4999') {
      angular.forEach(rewards, function(reward) {
        if (reward.points > 2499 && reward.points < 5000)
          filtered.push(reward);
      });
    } else if (sortType.id == '5000-7499') {
      angular.forEach(rewards, function(reward) {
        if (reward.points > 4999 && reward.points < 7500)
          filtered.push(reward);
      });
    } else if (sortType.id == '7500-9999') {
      angular.forEach(rewards, function(reward) {
        if (reward.points > 7499 && reward.points < 10000)
          filtered.push(reward);
      });
    } else if (sortType.id == 'over10000') {
      angular.forEach(rewards, function(reward) {
        if (reward.points > 9999)
          filtered.push(reward);
      });
    }

    //console.log('Sort Filter ' + filtered.length);
    //if(reverse) filtered.reverse();
    return filtered;
  };
}

function rewardsCategoryFilter() {
  return function (rewards, catIds, isExcluded) {
    if (catIds && rewards && rewards.length) {

      return rewards.filter(function (reward) {
        for (var i=0;i < reward.categoryCodes.length;i++) {
          if (catIds && catIds[reward.categoryCodes[i]]) {
            return (isExcluded) ? null : reward;
          }
        }
      });
    } else {
      //console.log('CAT Filter:::' + rewards.length);
      return rewards;
    }
  };
}

function rewardsCategoryRefineFilter() {
  return function (rewards, catCode) {
    if(rewards && rewards.length){

      return rewards.filter(function (reward) {
        for (var i=0;i < reward.categoryCodes.length;i++) {
          if (catCode === reward.categoryCodes[i] || ! catCode) {
            //console.log('REFINE filter:::');
            return reward;
          }
        }
      });
    }

  };
}

function rewardsBrowseSearch() {
  return function (rewards, searchTerm) {
    if (searchTerm) {

      return rewards.filter(function (reward) {
        if (reward.rewardName.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1) {
          //console.log('SEARCH Filter:::');
          return reward;
        }
      });
    } else {
      return rewards;
    }

  };
}

function orderCats() {
  return function (cats) {
    var filtered = [];
    angular.forEach(cats, function(item) {
      filtered.push(item);
    });
    filtered.sort(function(a,b) {
      var paddedOrderA = ("000"+a.ordering).slice(-4);
      var paddedOrderB = ("000"+b.ordering).slice(-4);
      return (paddedOrderA > paddedOrderB);
    });

    return filtered;
  };
}

'use strict';

angular.module('rfrApp').controller('earnCtrl', [
  '$scope',
  '$rootScope',
  '$state',
  '$stateParams',
  'user',
  'earnList',
  'rfrUtilService',
  'resource',
  'userLanguage',
  '$browser',
  '$anchorScroll',
  'contentFetchService',
  'earnListService',
  'membershipDetail',
  'settings',
  'apiRoutes',
  '$sce',
  'rfrAjax',
  earnCtrl]);

function earnCtrl($scope,
                  $rootScope,
                  $state,
                  $stateParams,
                  earnList,
                  user,
                  rfrUtilService,
                  resource,
                  userLanguage,
                  $browser,
                  $anchorScroll,
                  contentFetchService,
                  earnListService,
                  membershipDetail,
                  settings,
                  apiRoutes,
                  $sce,
                  rfrAjax
) {
  $anchorScroll();
  $rootScope.apiError = '';
  $scope.imageUrl = settings.formsURL + settings.unProtectedUrlPrefix +  apiRoutes.rfrAPI.getProductImg;

  var getEarnItem = function (earnId) {
    return earnList.filter(function (earnItem) {
      if (earnItem.id.toString() === decodeURIComponent(earnId)) {
        return earnItem;
      }
    })[0];
  };

  resource.onChanged(function () {
    $scope.lang = userLanguage();
    $scope.province = ($browser.cookies().province) ? $browser.cookies().province.toLowerCase() : 'on';
    $rootScope.rui = {
      language: $scope.lang,
      province: $scope.province
    };
  }, $scope);

  $scope.getHtmlString = function(string){
    return $sce.trustAsHtml(string);
  };

  $scope.imgSrc = {};

  $scope.$extend({
      currentBalance: $rootScope.currentRewardsBalance,
      showSignIn: !rfrUtilService.isRfrAuthenticated(),
      earnList: earnList,
      earnId: $stateParams.earnId,
      stepId: $stateParams.stepId,
      earnItem: $stateParams.earnId ? getEarnItem($stateParams.earnId) : null,
      limit: 5,
      loadMore: function () {
        $scope.limit = ($scope.limit >= $scope.earnList.length ? $scope.earnList.length : $scope.limit += 2);
      },
      rejectTerms: function () {
        $state.transitionTo('rewards.earn', {
            earnId: $scope.earnItem.earnId
          },
          {
            inherit: false, reload: true
          });
      },
      acceptTerms: function () {
        earnListService.optInSpecialOffer({
          membershipId: membershipDetail.membershipId,
          promotionId: $scope.earnItem.id,
          logObjectId: $scope.earnItem.marketingPromotionId
        }).then(function (data) {
          $state.go('.', {stepId: 'success'});
          $anchorScroll();
        });
      },
      printEarnSuccessSummary: function(){
        window.print();
      },
      getEarnUrl: function (id, marketingPromotionId) {
        return 'rewards.earn({earnId: "' + encodeURIComponent(id) + '", marketingPromotionId: "'+ marketingPromotionId +'"})';
      },
      getImageSrc: function (item) {
        if (item.image && item.image.imageId) {
          contentFetchService.getProductImg({
            imageId: item.image.imageId
          }).then(function(imgId) {
            return function(imgData) {
              if (imgData && imgData.imageData) {
                $scope.imgSrc[imgId] = 'data:image/jpg;base64,' + imgData.imageData;
              }
            };
          }(item.image.imageId));
        }
        return $scope.imgSrc;
      },
      hideOptIn: function() {
        if (!$rootScope.isEnrolled) {
          return !$rootScope.isEnrolled;
        } else if ($scope.earnItem && !$scope.earnItem.optInRequired) {
          return true;
        } else if($scope.earnItem){
          return $scope.earnItem.optedInStatus && $scope.earnItem.optInRequired;
        }
      },
      showEnrollLink: function () {
        if ($scope.user.isAuthenticated) {
          return $state.is('rewards.earn') &&
                  $scope.membershipDetail.eligible &&
                  $scope.membershipDetail.statusCode !== 'A';
        }
        return true;
      }
    }
  );

  if ($scope.earnItem && !$stateParams.marketingPromotionId) {
    rfrAjax.tracePage({ logObjectId: $scope.earnItem.marketingPromotionId });
  }

  $scope.imgPath = null;
  if($scope.earnItem){
    if($scope.earnItem.image.imageId){
      $scope.imgPath = settings.formsURL + settings.unProtectedUrlPrefix + apiRoutes.rfrAPI.getProductImg + '/' + $scope.earnItem.image.imageId;
    }
  }
  $scope.smallImgSrc = null;
  if($scope.earnItem){
    contentFetchService.getProductImg({
      imageId:$scope.earnItem.smallImageIdentifier.imageId
    }).then(function (imgData) {
      if (imgData && imgData.imageData) {
        $scope.smallImgSrc = 'data:image/jpg;base64,' + imgData.imageData;
      }
    });
  }
}

earnCtrl.resolve = {
  permissionData: ['$browser','permissionResolver' , 'rfrUtilService', function ($browser,permissionResolver, rfrUtilService) {
    //Update the linkIn cookie for url redirect
    if(!rfrUtilService.isRfrAuthenticated()){
      $browser.cookies('linkIn',document.location.href);
    }
    return permissionResolver.getPermission(this.url.sourcePath);
  }],
  earnList: ['earnListService', 'membershipDetail', function (earnListService, membershipDetail) {
    if(membershipDetail.statusCode === 'A'){
      return earnListService.getEarnList({membershipId: membershipDetail.membershipId});
    }else{
      return earnListService.getEarnList();
    }

  }]
};


'use strict';

angular.module('rfrApp')
  .controller('enrollCtrl', [
    '$scope',
    '$rootScope',
    '$window',
    '$state',
    'enrollmentService',
    'membershipDetail',
    'resource',
    'userLanguage',
    '$browser',
    'rfrUtilService',
    enrollCtrl]);

function enrollCtrl($scope,
                    $rootScope,
                    $window,
                    $state,
                    enrollmentService,
                    membershipDetail,
                    resource,
                    userLanguage,
                    $browser,
                    rfrUtilService) {

  if (!rfrUtilService.isRfrAuthenticated()) {
    $state.go('signin');
  }

  $rootScope.apiError = '';
  $scope.rejectTerms = function () {
    $window.history.back();
  };
  $scope.acceptTerms = function () {
    enrollmentService.enrollToRFR({
      membershipId: membershipDetail.membershipId
    }).then(function (result) {
      $state.go('rewards', {}, {notify: true, reload: true});
    });
  };

  resource.onChanged(function () {
    $scope.lang = userLanguage();
    $scope.province = ($browser.cookies().province) ? $browser.cookies().province.toLowerCase() : 'on';
    $rootScope.rui = {
      language: $scope.lang,
      province: $scope.province
    };
  }, $scope);

  $scope.sendToPrinter = function (contentToPrint) {
    var printContents = document.getElementById("main").innerHTML;
    var originalContents = document.body.innerHTML;
    if (contentToPrint == "printWholePage") {
      window.print();
    } else {
      var myWindow = window.open("", "MsgWindow", "width=500, height=300");
      myWindow.document.write(printContents);
      myWindow.print();
    }
  };


}


'use strict';

angular.module('rfrApp')
  .controller('howitworksCtrl',[
    '$scope',
    '$rootScope',
    'cmsContent',
    'userLanguage',
    'resource',
    '$browser',
    '$state',
    howitworksCtrl]);

function howitworksCtrl($scope,$rootScope,cmsContent,userLanguage,resource,$browser,$state) {

  $scope.cmsContent = cmsContent;
  $scope.lang = userLanguage();

  $scope.howtoStepImages = {
    "11": ($scope.cmsContent['rfr.image.howto.step1']) ? {
      'en': $scope.cmsContent['rfr.image.howto.step1']['englishMessage'],
      'fr': $scope.cmsContent['rfr.image.howto.step1']['frenchMessage']
    } : {},
    "12": ($scope.cmsContent['rfr.image.howto.step2']) ? {
      'en': $scope.cmsContent['rfr.image.howto.step2']['englishMessage'],
      'fr': $scope.cmsContent['rfr.image.howto.step2']['frenchMessage']
    } : {},
    "13": ($scope.cmsContent['rfr.image.howto.step3']) ? {
      'en': $scope.cmsContent['rfr.image.howto.step3']['englishMessage'],
      'fr': $scope.cmsContent['rfr.image.howto.step3']['frenchMessage']
    } : {},
    "14": ($scope.cmsContent['rfr.image.howto.step4']) ? {
      'en': $scope.cmsContent['rfr.image.howto.step4']['englishMessage'],
      'fr': $scope.cmsContent['rfr.image.howto.step4']['frenchMessage']
    } : {},
    "21": ($scope.cmsContent['rfr.image.enroll.step1']) ? {
      'en': $scope.cmsContent['rfr.image.enroll.step1']['englishMessage'],
      'fr': $scope.cmsContent['rfr.image.enroll.step1']['frenchMessage']
    } : {},
    "22": ($scope.cmsContent['rfr.image.collect.step2']) ? {
      'en': $scope.cmsContent['rfr.image.collect.step2']['englishMessage'],
      'fr': $scope.cmsContent['rfr.image.collect.step2']['frenchMessage']
    } : {},
    "23": ($scope.cmsContent['rfr.image.redeem.step3']) ? {
      'en': $scope.cmsContent['rfr.image.redeem.step3']['englishMessage'],
      'fr': $scope.cmsContent['rfr.image.redeem.step3']['frenchMessage']
    } : {},
    "31": ($scope.cmsContent['rfr.image.collect.step1']) ? {
      'en': $scope.cmsContent['rfr.image.collect.step1']['englishMessage'],
      'fr': $scope.cmsContent['rfr.image.collect.step1']['frenchMessage']
    } : {},
    "32": ($scope.cmsContent['rfr.image.redeem.step2']) ? {
      'en': $scope.cmsContent['rfr.image.redeem.step2']['englishMessage'],
      'fr': $scope.cmsContent['rfr.image.redeem.step2']['frenchMessage']
    } : {}
  };

  $scope.totalsteps = (! $scope.user.isAuthenticated ) ? '4' : ( ($rootScope.isEnrolled) ? '2' : '3' );

  $scope.stepImage = function(stepNum) {
    if(window.location.hash.match('sidh')){
      return $scope.howtoStepImages[stepNum][$scope.lang].replace(/\/web\/totes/gi, '');
    } else {
      return $scope.howtoStepImages[stepNum][$scope.lang];

    }
  };

  resource.onChanged(function () {
    $scope.lang = userLanguage();
    $scope.province = ($browser.cookies().province) ? $browser.cookies().province.toLowerCase() : 'on';
    $rootScope.rui = {
      language: $scope.lang,
      province: $scope.province
    };
  }, $scope);

}

howitworksCtrl.resolve = {
  permissionData: ['$browser','permissionResolver' , 'rfrUtilService', function ($browser,permissionResolver, rfrUtilService) {
    //Update the linkIn cookie for url redirect
    if(!rfrUtilService.isRfrAuthenticated()){
      $browser.cookies('linkIn',document.location.href);
    }
    return permissionResolver.getPermission(this.url.sourcePath);
  }]
};

'use strict';

angular.module('rfrApp')
  .constant('accountToIconMap', {
    '1': {
      icon: 'rui-icon-tv'
    },
    '2': {
      icon: 'rui-icon-tv'
    },
    '3': {
      icon: 'rui-icon-tv'
    },
    '4': {
      icon: 'rui-icon-internet'
    },
    '5': {
      icon: 'rui-icon-internet'
    },
    '6': {
      icon: 'rui-icon-internet'
    },
    '7': {
      icon: 'rui-icon-internet'
    },
    '8': {
      icon: 'rui-icon-internet'
    },
    '9': {
      icon: 'rui-icon-home-phone'
    },
    '10': {
      icon: 'rui-icon-home-phone'
    },
    '11': {
      icon: 'rui-icon-home-phone'
    },
    '12': {
      icon: 'rui-icon-home-phone'
    },
    '13': {
      icon: 'rui-icon-menu'
    },
    '14': {
      icon: 'rui-icon-home-phone'
    },
    'D': {
      icon: 'rui-icon-home-phone'
    },
    'C': {
      icon: 'rui-icon-wireless'
    },
    'B': {
      icon: 'rui-icon-bundles'
    },
    '15': {
      icon: 'rui-icon-home-security'
    },
    'RS': {
      icon: 'rui-icon-home-security'
    },
    'CR': {
      icon: 'rui-icon-credit-card'
    }
  })
  .controller('membershipCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    '$window',
    'appState',
    'settings',
    'membershipList',
    'membershipDetail',
    'membershipDetailsList',
    'rfrUtilService',
    'accountToIconMap',
    'userLanguage',
    'cmsContent',
    'resource',
    'membershipService', '$q',
    membershipCtrl]);

function membershipCtrl($scope,
                        $rootScope,
                        $state,
                        $window,
                        appState,
                        settings,
                        membershipList,
                        membershipDetail,
                        membershipDetailsList,
                        rfrUtilService,
                        accountToIconMap,
                        userLanguage,
                        cmsContent,
                        resource,
                        membershipService, $q) {

  if(membershipDetail.statusCode =='N'){
    $state.go('rewards.enroll');
  }else{
    $scope.loadingTransactions = true;
    membershipService.getTransactions(membershipDetail.membershipId).then(
      function(data){
        $scope.transactions = data;
        $scope.loadingTransactions = false;
        if($rootScope.errorCode.errInTransactionLoading){
          $rootScope.errorCode.errInTransactionLoading = false;
        }
      },
      function(data){
        console.log(data);
        $rootScope.errorCode.errInTransactionLoading = true;
      }
    );
  }

  var membershipIndex;
  $scope.popupContentLeft = resource.get('membership_popup_content_left');
  $scope.popupContentRight = resource.get('membership_popup_content_right');

  $scope.getAccountTypeIcon = function (iconType) {
    return accountToIconMap[iconType] ?
    accountToIconMap[iconType].icon + ' icon' :
      'rui-icon-bundles icon';//default
  };

  $scope.needsFix = function (iconType) {
    return iconType === 'C' ||
      iconType === '11' ||
      iconType === '9' ||
      iconType === 'K';
  };

  $scope.updatemembershipList = function(membershipDetailsListObj){
    //populate the drop downlist
    $scope.membershipList = membershipList.filter(function(obj){
        var eligible = _.indexBy(membershipDetailsListObj, 'membershipId')[obj.membershipId].eligible;

        (obj.statusCode == 'N' && eligible) ? obj.showNotEnrolled = ' - Not Enrolled' : '';
        (obj.statusCode == 'S' && eligible) ? obj.showNotEnrolled = ' - Suspended' : '';
        (obj.statusCode == 'P') ? obj.showNotEnrolled = ' - Deactivating' : '';
        return obj.statusCode === 'A' || obj.statusCode === 'P' ||
          _.indexBy(membershipDetailsListObj, 'membershipId')[obj.membershipId].eligible;
      });

      // lookup the local stroage for accountNumber to identify the index number of membership in the membership list
      var LocalStorageAccountNumber =  localStorage.getItem('accountNumber');
      //match the accountNumber with the membership detail
      if(LocalStorageAccountNumber){
        var filteredList = membershipDetailsList.filter(function(detail){
          return detail.eligible || detail.statusCode === 'P';
        });
        for (var i = filteredList.length - 1; i >= 0; i--) {
          for (var x = filteredList[i].accounts.length - 1; x >= 0; x--) {
            if(filteredList[i].accounts[x].number === localStorage.getItem('accountNumber') ){
              membershipIndex = i;
            }
          }
        }
      }
  };

  //set the value from what we have from rewards.main controller
  $scope.updatemembershipList(membershipDetailsList);

  //refresh the membership list (getTheLatestMemberShipinfo)... because we want the latest
  var getTheLatestMemberShipinfo = function() {
    if (rfrUtilService.isRfrAuthenticated()) {
     var promises = [];
     membershipList.forEach(function (membership) {
       promises.push(membershipService.getMembershipDetail(membership.membershipId));
     });
     $q.all(promises).then(
      function (detailsList) {
        $scope.membershipList = detailsList;
        membershipDetailsList = detailsList;
        //console.log('-from membership, refreshed-', detailsList)
        $scope.updatemembershipList(membershipDetailsList);
        if($rootScope.errorCode.errInMembershipLoading){
          $rootScope.errorCode.errInMembershipLoading = false;
        }
      },
      function (res) {
        console.log(res);
        $rootScope.errorCode.errInMembershipLoading = true;
        //console.log('error');
      }
     );
    }
  };

  $scope.$on('$stateChangeSuccess',
    function(event, toState, toParams, fromState, fromParams){
    if (toState.name === 'rewards.membership' && fromState.name && fromState.name.match('rewards')){
      getTheLatestMemberShipinfo();
    }
  });


  $scope.account = $scope.membershipList[membershipIndex];
  $rootScope.currentRewardsBalance = membershipDetail.pointsBalance;

  $scope.processMembershipTier = function(){
    $scope.dateFormatPlaceholder = resource.get('date_format_placeholder');

    $scope.membershipTeirBadge = '';
      if ($scope.accountDetails.tier === 'SILVER') {
        $scope.membershipTierLabel = resource.get('rewards_silver');
        if($scope.cmsContent['rfr.image.membership.tier.silver']){
          $scope.membershipTeirBadge = ($scope.lang == 'en') ? $scope.cmsContent['rfr.image.membership.tier.silver']['englishMessage'] :
          $scope.cmsContent['rfr.image.membership.tier.silver']['frenchMessage'];
        }
      } else if ($scope.accountDetails.tier === 'GOLD') {
        $scope.membershipTierLabel = resource.get('rewards_gold');
        if($scope.cmsContent['rfr.image.membership.tier.gold']){
          $scope.membershipTeirBadge = ($scope.lang == 'en') ? $scope.cmsContent['rfr.image.membership.tier.gold']['englishMessage'] :
          $scope.cmsContent['rfr.image.membership.tier.gold']['frenchMessage'];
        }
      } else if ($scope.accountDetails.tier === 'PLATINUM') {
        $scope.membershipTierLabel = resource.get('rewards_platinum');
        if($scope.cmsContent['rfr.image.membership.tier.platinum']){
          $scope.membershipTeirBadge = ($scope.lang == 'en') ? $scope.cmsContent['rfr.image.membership.tier.platinum']['englishMessage'] :
          $scope.cmsContent['rfr.image.membership.tier.platinum']['frenchMessage'];
        }
      }
  };

  $scope.setTierLabel = function (tier) {
    var tierLabel = '';
    if (tier === 'GOLD') {
      tierLabel = resource.get('rewards_gold');
    } else if (tier === 'PLATINUM') {
      tierLabel = resource.get('rewards_platinum');
    } else if (tier === 'SILVER') {
      tierLabel = resource.get('rewards_silver');
    }
    return tierLabel;
  };

  $scope.processAccountsInfo = function() {
    //ACCOUNT LIST COMBO  BOX MODEL ADJUSTMENTS
    for (var acct = 0; acct < $scope.accountsList.length; acct++) {

      var account = $scope.accountsList[acct];
      var listVal = account.number;

      if (account.sourceSystem === 'B'){
        for (var sub = 0; sub < account.subscriptions.length; sub++) {
          if (account.subscriptions[sub].visible)
            listVal = account.subscriptions[0].typeName;//SECONDARYVAL NEEDS TO ACCOUNT.SUBTYPE WHEN AVAILABLE
        }
      }

      try {
        account.streetAddress = $scope.accountsList[acct].shipmentAddress.houseNumber + ' '
          + $scope.accountsList[acct].shipmentAddress.streetName + ', '
          + $scope.accountsList[acct].shipmentAddress.city + ' '
          + $scope.accountsList[acct].shipmentAddress.province + ' '
          + $scope.accountsList[acct].shipmentAddress.postalCode;
      }
      catch(err) {
        account.streetAddress = '-';
      }

      account.listValue = listVal;
    }
    ////////////////////////////////////


    //HIDDEN FLAG FOR LINKED ROGERS ACCOUNT LIST
    for (var acct = 0; acct < $scope.accountsList.length; acct++) {

      var account = $scope.accountsList[acct];
      var bHidden = true;

      for (var sub = 0; sub < account.subscriptions.length; sub++) {
        if (account.eligible && account.subscriptions[sub].visible)
          bHidden = false;
      }

      account.hidden = bHidden;
    }
    /////////////////////////////////////////////
  };

  $scope.$on('resourceChanged', function () {
    $scope.loadingTransactions = true;
    $scope.accountDetails.enrolledOn = rfrUtilService.constructDateString(membershipDetail.enrollmentDate, 'LL');
  });

  $scope.selectedAccount = 0;

  $scope.$watchGroup(['account', 'membershipList'], function changeRewardAccount(newValue, OldValue) {
    localStorage.setItem('accountNumber' , $scope.account.accounts[0]);

    var membershipDetail = membershipDetailsList.filter(function(detail){return detail.membershipId === $scope.account.membershipId;})[0];
    $scope.accountDetails = {
      membershipId: membershipDetail.membershipId,
      enrolledOn: rfrUtilService.constructDateString(membershipDetail.enrollmentDate, 'LL'),
      points: membershipDetail.pointsBalance,
      pendingPoints: membershipDetail.pendingPointsBalance,
      tier: membershipDetail.tierCode
    };

    $rootScope.currentRewardsBalance = membershipDetail.pointsBalance;
    $scope.accountsList = membershipDetail.accounts;
    $scope.processAccountsInfo();
    $scope.processMembershipTier();

    if(newValue[0].membershipId != OldValue[0].membershipId){
      if(newValue[0].statusCode == 'N'){
        $scope.loadingTransactions = true;
        $state.go('rewards.enroll', {}, {notify: true, reload: true});
      }else{
        $scope.loadingTransactions = true;
        $state.go('rewards.membership', {}, {notify: true, reload: true});
      }
    }
  });


  $scope.sendToPrinter = function( contentToPrint ) {
    var printContents = document.getElementById( 'main' ).innerHTML;
    var originalContents = document.body.innerHTML;
    if (contentToPrint == 'printWholePage') {
      window.print();
    } else {
      var myWindow = window.open( '', 'MsgWindow', 'width=500, height=300' );
      myWindow.document.write( printContents );
      myWindow.print();
    }
  };
};

membershipCtrl.resolve = {
    loginAuth: function($q, $state, rfrUtilService, $timeout) {
        if(!rfrUtilService.isRfrAuthenticated()){
          $timeout(function() {
            $state.go('signin');
          },0);
          return $q.reject({ originalError: "auth fail" });
        }
    }
};

'use strict';

angular.module('rfrApp')
  .controller('noaccountCtrl', ['$scope' ,'cmsContent', noaccountCtrl]);

function noaccountCtrl($scope, cmsContent) {
  $scope.cmsContent = cmsContent;
}

noaccountCtrl.resolve = {
  permissionData: function (permissionResolver) {
    return permissionResolver.getPermission(this.url.sourcePath);
  },
  cmsContent: ['contentFetchService', function (contentFetchService) {
    return contentFetchService.getCmsContent();
  }]
};

'use strict';


angular.module('rfrApp').controller('redeemCtrl', [
  '$scope',
  '$rootScope',
  '$state',
  '$browser',
  '$location',
  'resource',
  'userLanguage',
  '$stateParams',
  'rewardsList',
  'membershipDetail',
  '$anchorScroll',
  'categories',
  'redeemService',
  'rfrUtilService',
  'contentFetchService',
  '$sce',
  'wishlistService',
  'deviceActivationDateService',
  'rfrAjax',
  redeemCtrl]);

function redeemCtrl($scope,
                    $rootScope,
                    $state,
                    $browser,
                    $location,
                    resource,
                    userLanguage,
                    $stateParams,
                    rewardsList,
                    membershipDetail,
                    $anchorScroll,
                    categories,
                    redeemService,
                    rfrUtilService,
                    contentFetchService,
                    $sce,
                    wishlistService,
                    deviceActivationDateService,
                    rfrAjax) {

  $anchorScroll();

  $scope.redemptionDetails = null;
  if($stateParams.redemptionDetails){
    $scope.redemptionDetails = $stateParams.redemptionDetails;
    if(userLanguage() === 'en'){
      $scope.redemptionDetails.activationDate = moment(new Date($stateParams.redemptionDetails.activationDate)).format('DD/MM/YYYY');
    } else {
      $scope.redemptionDetails.activationDate = moment(new Date($stateParams.redemptionDetails.activationDate)).format('MM/DD/YYYY');
    }
  }
  $scope.viewLoader = false;
  $rootScope.apiError = '';
  if (!$stateParams.rewardId) {
    $state.go('rewards.browse');
  }

  if ($stateParams.rewardId && $stateParams.stepId && !rfrUtilService.isRfrAuthenticated()) {
    $state.transitionTo('rewards.redeem', {rewardId: $stateParams.rewardId}, {
      reload: true,
      inherit: false,
      notify: true
    });
  }

  $scope.$watch('rewardsList', function (newValue, oldValue) {
    $scope.rewards = newValue;
    init();

  });

var init = function(){

  $scope.rewardId = $stateParams.rewardId;
  $scope.reward = $scope.rewards.filter(function (reward) {
    if (reward.rewardId === decodeURIComponent($scope.rewardId)) {
      return reward;
    }
  })[0];

  if (!$stateParams.rewardProductId) {
    rfrAjax.tracePage({ logObjectId: $scope.reward.rewardProductId });
  }

  $scope.stepId = $stateParams.stepId;
  $scope.categories = categories;

  $scope.accountsList = (membershipDetail &&
  membershipDetail.accounts &&
  membershipDetail.accounts) ? membershipDetail.accounts : '';

  $scope.addressList = {};
  $scope.deviceNumberList = [];

  $scope.lang = userLanguage();

  angular.forEach($scope.accountsList, function (account) {
    angular.forEach(account.subscriptions, function (subscription) {
      if (subscription.typeCode === 'C' || subscription.typeCode === 'D' || subscription.typeCode === 'RS') {
        $scope.deviceNumberList.push({
          name: account.name,
          number: subscription.subscriberNumber,
          associatedAccountNumber: account.number
        });
      }
    });
    if (account.eligible) {
      $scope.addressList[account.number] = account.shipmentAddress;
    }
  });

  if(!$rootScope.selectedAccountNumber){
    $rootScope.selectedAccountNumber = Object.keys($scope.addressList)[0];
  }
  if(!$rootScope.selectedSubscriptionNumber){
    $rootScope.selectedSubscriptionNumber = $scope.redemptionAccountChoices ? $scope.redemptionAccountChoices[0] : null;
  }

  $scope.$watch('reward.inWhishList', function (newValue, oldValue) {
    $scope.inWishList = newValue;
    $scope.wishlistCtaMsg = ($scope.reward && $scope.inWishList ? resource.get('remove_from_wishlist') : resource.get('add_to_wishlist'));

  });

  $scope.$extend({
    loggedInOnly: rfrUtilService.isRfrAuthenticated(),
    currentBalance: (membershipDetail && membershipDetail.pointsBalance) ? membershipDetail.pointsBalance : 0,
    acceptTerms: function () {
      var getShippingAddress = function () {
        var shippingAddress;
        if ($scope.shipAddress && $rootScope.selectedAccountNumber === 'differentAddress') {
          shippingAddress = $scope.shipAddress;
          shippingAddress.streetName = $scope.shipAddress.addressLine1.substr($scope.shipAddress.addressLine1.indexOf(' ')+1);
          shippingAddress.houseNumber = $scope.shipAddress.addressLine1.substr(0,$scope.shipAddress.addressLine1.indexOf(' '));
          //$scope.addressList[$scope.selectedAccountNumber].address = shippingAddress; //Using 0 for the custom address account number as default
        } else {
          shippingAddress = $scope.addressList[$rootScope.selectedAccountNumber];
        }
        return shippingAddress;
      };

      var getAdditionalOps = function () {
        var additionalOps = {};
        switch ($scope.reward.rewardType) {
          case 'BATCH':
            additionalOps.quantity = 1;
            break;
          case 'VOUCHER_CODE':
            additionalOps.quantity = 1;
            break;
          default:
            break;
        }

        if ($scope.reward.futureActivationAllowed) {
          additionalOps.startDate = deviceActivationDateService.getActivationDate();
        }
        if ($rootScope.selectedSubscriptionNumber) {
          if ($scope.reward.redemptionSubscriptions && $scope.reward.redemptionSubscriptions.length) {
            additionalOps.subscriptionSerialNumber = $scope.reward.redemptionSubscriptions.filter(function(sub){
              return sub.subscriberNumber === $rootScope.selectedSubscriptionNumber;
            })[0].subscriptionSerialNumber;
            additionalOps.accountNumber = $scope.deviceNumberList.filter(function(obj){
              return obj.number === $rootScope.selectedSubscriptionNumber;})[0].associatedAccountNumber;
          } else if ($scope.reward.redemptionAccounts && $scope.reward.redemptionAccounts.length) {
            additionalOps.accountNumber = ($scope.reward.rewardType === 'BATCH')? $rootScope.selectedAccountNumber : $rootScope.selectedSubscriptionNumber;
          }
        }

        return additionalOps;
      };

      var getPricePlan = function () {
        return $scope.reward.pricePlanList[0].code;
      };

      var getBaselineOps = function(){
        return {
          membershipId: membershipDetail.membershipId,
          rewardId: $scope.reward.rewardId,
          pricePlan: getPricePlan(),
          shippingAddress: getShippingAddress(),
          accountNumber: $rootScope.selectedAccountNumber || '',
          logObjectId: $scope.reward.rewardProductId
        };
      };

      var getAccountNumber = function() {
        if($rootScope.selectedAccountNumber === 'differentAddress'){
          return {
            accountNumber: $scope.accountsList[0].number
          };
        } else {
          return {};
        }
      };

      redeemService.redeemRewards($.extend({}, getBaselineOps(), getAdditionalOps(), getAccountNumber()))
        .then(function (data) {
        $state.go('rewards.redeem', {stepId: 'success', redemptionDetails: data.redemptionDetails}, {notify: true});
        $rootScope.currentRewardsBalance = data.currentBalance;
      })
        .then(
      function(){$anchorScroll();}, function(){$anchorScroll();});
    },
    showSubscriptionSelection: function (subscriptionNumber) {
      return $rootScope.selectedSubscriptionNumber === subscriptionNumber || $stateParams.stepId === 'confirm';
    },
    redemptionAccountChoices: [],
    getRedemptionAccountChoices: function () {
      if ($scope.reward.redemptionAccounts && $scope.reward.redemptionAccounts.length) {
        $scope.redemptionAccountChoices = $scope.reward.redemptionAccounts;
        if(!$rootScope.selectedSubscriptionNumber){
          $rootScope.selectedSubscriptionNumber = $scope.redemptionAccountChoices[0];
        }
        return true;
      } else if ($scope.reward.redemptionSubscriptions && $scope.reward.redemptionSubscriptions.length) {
        $scope.redemptionAccountChoices = _.pluck($scope.reward.redemptionSubscriptions, 'subscriberNumber');
        if(!$rootScope.selectedSubscriptionNumber){
          $rootScope.selectedSubscriptionNumber = $scope.redemptionAccountChoices[0];
        }
        return true;
      } else {
        return false;
      }
    },
    showSelectAddress: function (accountNumber) {
      return _.contains($scope.redemptionAccountChoices, accountNumber) && ($scope.stepId === 'confirm' ||
        ($rootScope.selectedAccountNumber === accountNumber &&
        !($rootScope.shippingInfo && $rootScope.shippingInfo.shipAddress)));
    },
    showDifferentAddress: function(){
      return ($rootScope.shippingInfo && $rootScope.shippingInfo.shipAddress) || $scope.stepId === 'confirm';
    },
    rejectTerms: function () {
      $state.transitionTo('rewards.redeem', {
          rewardId: $scope.reward.rewardId
        },
        {
          inherit: false, reload: true
        });
    },
    printRedeemSuccessSummary: function () {
      window.print();
    },
    lazyLoadLimit: 9,
    loadMore: function () {
      $scope.lazyLoadLimit = ($scope.lazyLoadLimit >= $scope.rewards.length ?
        $scope.rewards.length :
        $scope.lazyLoadLimit += 6);
    },
    getScenarioTemplate: function () {
      if ($scope.reward) {
        switch ($scope.reward.rewardType) {
          case 'WIRELESS':
          case 'DATAPASS':
          case 'CABLE':
          case 'INTERNET':
          case 'PPV':
          case 'VOD':
          case 'RHP':
          case 'BILL_CREDIT':
          case 'SLC':
          case 'SHM':
            return 'rfr/js/directives/rewardFullfilment/tvAccountScenario.html';
          case 'BATCH':
            return 'rfr/js/directives/rewardFullfilment/shipAddressScenario.html';
          default:
            return '';
        }
      }
    },
    showAddressForm: false,
    toggleShipAddressForm: function () {
      $scope.showAddressForm = !$scope.showAddressForm;
    },
    shipToAddressConfirmed: false,
    hideAddressForm: function () {
      $scope.showAddressForm = false;
    },
    getPointPercentMessage: function () {
      if ($scope.reward) {
        if ($scope.currentBalance / $scope.reward.points >= 1) {
          return resource.get('rfr_get_it_now');
        } else {
          return ($scope.reward.points - $scope.currentBalance) + resource.get('rfr_points_needed');
        }
      }
    },
    canRedeem: function () {
      if ($scope.reward && $scope.reward.quantityRemaining !== void 0) {
        return ($scope.reward.points <= $scope.currentBalance) &&
          rfrUtilService.isRfrEnrolled() &&
          $scope.reward.canRedeem &&
          $scope.reward.quantityRemaining !== 0;
      } else if ($scope.reward) {
        return ($scope.reward.points <= $scope.currentBalance) &&
          rfrUtilService.isRfrEnrolled() &&
          $scope.reward.canRedeem;
      }
    },
    inWishList: ($scope.reward && $scope.reward.inWhishList),
    wishlistCtaMsgRender: true,
    toggleInWishList: function () {
      $scope.viewLoader = true;
      if ($scope.reward) {
        if ($scope.reward.inWhishList) {
          wishlistService.updateWishList({
            membershipId: $rootScope.membershipDetail.membershipId,
            rewardId: $scope.reward.rewardId,
            notifyPointReached: false,
            logObjectId: $scope.reward.rewardProductId
          }).then(function (result) {
            $scope.viewLoader = false;
            $rootScope.wishlistCounter = $rootScope.wishlistCounter - 1;
            $scope.reward.inWhishList = false;
            $scope.wishlistCtaMsgRender = false;
            $scope.wishlistCtaMsg = resource.get('add_to_wishlist');
            $scope.wishlistCtaMsgRender = true;

            $rootScope.wishListObj = _.without($rootScope.wishListObj, _.findWhere($rootScope.wishListObj, {rewardId: $scope.reward.rewardId}));
          });
        } else {
          wishlistService.updateWishList({
            membershipId: $rootScope.membershipDetail.membershipId,
            rewardId: $scope.reward.rewardId,
            notifyPointReached: true,
            logObjectId: $scope.reward.rewardProductId
          }).then(function (result) {
            $scope.viewLoader = false;
            $rootScope.wishlistCounter = $rootScope.wishlistCounter + 1;
            $scope.reward.inWhishList = true;
            $scope.wishlistCtaMsgRender = false;
            $scope.wishlistCtaMsg = resource.get('remove_from_wishlist');
            $scope.wishlistCtaMsgRender = true;
            $rootScope.wishListObj.push($scope.reward);
          });
        }
      }
    },
    getCategoryName: function (categoryCode) {
      var catName = $scope.categories.filter(function (category) {
        return category.code === categoryCode;
      });
      return catName.length ? catName[0].name : null;
    },
    getCategoryUrl: function (categoryCode) {
      var categoryNameUrl = ($scope.getCategoryName(categoryCode)) ?
        $scope.getCategoryName(categoryCode).replace(' ', '').toLowerCase() : '';
      return (categoryNameUrl) ? 'rewards.browse({catId: "' + categoryNameUrl + '"})' : 'rewards.browse';
    },
    isValid: function () {
      return $scope.redemptionform.$valid;
    }
  });
  $scope.activationMessage = null;
  $scope.activationTypeMsg = null;

  $scope.imgSrc = null;
  if ($scope.reward) {
    if($scope.reward.redemptionSubscriptions && $scope.reward.redemptionSubscriptions.length){
      $scope.activationMessage = ' a device ';
      $scope.activationTypeMsg = resource.get('subscription_num');
    } else if ($scope.reward.redemptionAccounts && $scope.reward.redemptionAccounts.length) {
      $scope.activationMessage = ' an account ';
      $scope.activationTypeMsg = resource.get('account_num');
    }

    $scope.getRedemptionAccountChoices();

    contentFetchService.getProductImg({
      imageId: $scope.reward.largeImageIdentifier.imageId
    }).then(function (imgData) {
      if (imgData && imgData.imageData) {
        $scope.imgSrc = 'data:image/jpg;base64,' + imgData.imageData;
      }
    });
  }

  $scope.date = {
    deviceActivationDate: null
  };


  $scope.pointPercentMessage = $scope.getPointPercentMessage();

  $scope.$on('resourceChanged', function () {
    $scope.lang = userLanguage();
    $scope.wishlistCtaMsg = ($scope.reward && $scope.reward.inWhishList ?
      resource.get('remove_from_wishlist') :
      resource.get('add_to_wishlist'));
    $scope.pointPercentMessage = $scope.getPointPercentMessage();
  });

  $scope.getHtmlString = function (string) {
    return $sce.trustAsHtml(string);
  };


  $scope.$on('confirmShipAddress', function (event, shipAddress) {
    $rootScope.shippingInfo = {
      shipAddress: shipAddress
    };
    $scope.shipAddress = shipAddress;
    //$rootScope.selectedAccountNumber = $scope.accountsList[0].number;
    $rootScope.selectedAccountNumber = 'differentAddress';

    $scope.shipToAddressConfirmed = true;
    $scope.hideAddressForm();
    $location.hash('differentAddress');
    $anchorScroll.yOffset = 150;
    $anchorScroll();
  });
  };
}

redeemCtrl.resolve = {
  permissionData: ['$browser','permissionResolver' , 'rfrUtilService', function ($browser,permissionResolver, rfrUtilService) {
    //Update the linkIn cookie for url redirect
    if(!rfrUtilService.isRfrAuthenticated()){
      $browser.cookies('linkIn',document.location.href);
    }
    return permissionResolver.getPermission(this.url.sourcePath);
  }],
  categories: ['rewardsListService','rfrUtilService','membershipDetail',
    function (rewardsListService,rfrUtilService,membershipDetail) {
    if(rfrUtilService.isRfrAuthenticated() && membershipDetail){
      return rewardsListService.getRewardCategories({
        membershipId: membershipDetail.membershipId
      });
    } else {
      return rewardsListService.getRewardCategories();
    }
  }]
};

'use strict';

angular.module('rfrApp').controller('rewardCardController', [
  '$scope',
  '$rootScope',
  '$state',
  'resource',
  'wishlistService',
  'contentFetchService',
  'userLanguage',
  'localStorage',
  'settings',
  'apiRoutes',
  rewardCardController]);

function rewardCardController($scope,
                              $rootScope,
                              $state,
                              resource,
                              wishlistService,
                              contentFetchService,
                              userLanguage,
                              localStorage,
                              settings,
                              apiRoutes) {


  var imgId;

  $scope.$watch('reward', function (newValue, oldValue) {
    // if($scope.reward != undefined){
      $scope.init();
    //}
  });

  // $scope.stateGo = function(state, toParams) {
  //   $state.go(state , toParams )
  // }

  $scope.init = function(){
    if ($scope.reward) {
      try {
        $scope.reward.points = $scope.reward.pricePlanList[0].points;
      } catch(anExcption) {
      }

      imgId = $state.includes('rewards.redeem') ? $scope.reward.largeImageIdentifier.imageId : $scope.reward.smallImageIdentifier.imageId;
    }

    $scope.imgPath = null;
    $scope.viewLoader = false;

    if ($scope.reward ) {

          var i = new Image();
          i.onload = function () {
            $scope.$apply(function () {

              $scope.imgPath = {
                'background-image': 'url("'+settings.formsURL + settings.unProtectedUrlPrefix +  apiRoutes.rfrAPI.getProductImg+"/" + imgId + '")',
                'background-color': 'lightgray'
              };

              if (i.width > 200) {
                if(matchMedia('(max-width: 768px)').matches || (matchMedia('(max-width: 991px) and (orientation:landscape)').matches)){
                  $scope.imgPath['background-size'] = 'cover';
                } else {
                  $scope.imgPath['background-size'] = 'contain';
                }
                $scope.imgPath['background-position-y'] = '0px';
              } else {
                $scope.imgPath['background-position'] = 'center 40%';
                $scope.smallImage = true;
              }

            });
          };

        i.src = settings.formsURL + settings.unProtectedUrlPrefix + apiRoutes.rfrAPI.getProductImg+'/'+ imgId;
      $scope.$parent.pageLoaded = true;
    }

    $scope.toggleInWishList = function () {
        $scope.viewLoader = true;
        $scope.$parent.viewLoader = true;
        if ($scope.reward) {
          if ($scope.inWishList) {
            wishlistService.updateWishList({
              membershipId: $rootScope.membershipDetail.membershipId,
              rewardId: $scope.reward.rewardId,
              notifyPointReached: false,
              logObjectId: $scope.reward.rewardProductId
            }).then(

            function (result) {
              $scope.viewLoader = false;
              $scope.$parent.viewLoader = false;
              $rootScope.wishlistCounter = $rootScope.wishlistCounter - 1;
              $scope.inWishList = false;
              $scope.reward.inWhishList = false;

              $rootScope.wishListObj = _.without($rootScope.wishListObj, _.findWhere($rootScope.wishListObj, {rewardId: $scope.reward.rewardId}));
              $scope.$parent.rewardsList.filter(function(reward){
                return reward.rewardId === $scope.reward.rewardId;})[0].inWhishList = false;
              //if ($scope.inWishListView) {
              //  $scope.$parent.removeFromWishList=true;
              //  //$state.go('rewards.wishlist', {}, {reload: true});
              //}
            },
            function(){$scope.viewLoader = false;}
            );
          } else {
            wishlistService.updateWishList({
              membershipId: $rootScope.membershipDetail.membershipId,
              rewardId: $scope.reward.rewardId,
              notifyPointReached: true,
              logObjectId: $scope.reward.rewardProductId
            }).then(

            function (result) {
              $scope.viewLoader = false;
              $scope.$parent.viewLoader = false;
              $rootScope.wishlistCounter = $rootScope.wishlistCounter + 1;
              $scope.inWishList = true;
              $scope.reward.inWhishList = true;

              $rootScope.wishListObj.push($scope.reward);
              $scope.$parent.rewardsList.filter(function(reward){
                return reward.rewardId === $scope.reward.rewardId;})[0].inWhishList = true;
            },
            function(){$scope.viewLoader = false;}
            );
          }
        }
      }

    $scope.daysLeft = ($scope.reward && $scope.reward.rewardEndDate && moment($scope.reward.rewardEndDate).diff(moment(), 'days') <= 10 ? moment($scope.reward.rewardEndDate).diff(moment(), 'days') : null),
    $scope.showGetItNow = $scope.getItNow();
    $scope.badgeText = resource.get('rfr_expiry_warning').replace(/\{days}/gi, $scope.daysLeft);
    $scope.pointPercentMessage = $scope.getPointPercentMessage();
    $scope.$on('resourceChanged', function () {
      $scope.badgeText = resource.get('rfr_expiry_warning').replace(/\{days}/gi, $scope.daysLeft);
      $scope.pointPercentMessage = $scope.getPointPercentMessage();
    });
  };

  $scope.$watch(function(){
    return $scope.reward;
  }, function(oldValue, newValue){
    if(newValue){
      $scope.inWishList = newValue.inWhishList;
    }
  });

    $scope.$extend({
      currentBalance: $rootScope.currentRewardsBalance,
      inWishListView: $state.is('rewards.wishlist'),
      getPointPercentMessage: function () {
        if ($scope.reward) {
          if ($scope.currentBalance / $scope.reward.points >= 1) {
            return '';
          } else {
            if (userLanguage() === 'en') {
              return ($scope.reward.points - $scope.currentBalance) + ' ' + resource.get('rfr_points_needed');
            } else {
              return resource.get('rfr_points_needed') + ' ' + ($scope.reward.points - $scope.currentBalance);
            }
          }
        }
      },
      getRedeemUrl: function () {
        if ($scope.reward) {
          return 'rewards.redeem({rewardId: "' + encodeURIComponent($scope.reward.rewardId) + '", rewardProductId: "'+ $scope.reward.rewardProductId +'"})';
        }
      },
      showRedeemDetailsExpiryMessage: function () {
        return $state.includes('rewards.redeem');
      },
      getItNow: function () {
        if ($scope.reward && $scope.reward.quantityRemaining !== void 0) {
          return !!($scope.currentBalance / $scope.reward.points >= 1 && $scope.reward.quantityRemaining !== 0);
        } else if ($scope.reward) {
          return ($scope.currentBalance / $scope.reward.points >= 1);
        }
      }
    });


}

'use strict';

angular.module('rfrApp')
  .controller('rewardsMain', [
    '$scope',
    '$rootScope',
    '$state',
    'membershipDetail',
    'cmsContent',
    'mobileAppRequest',
    'rfrUtilService',
    'userLanguage',
    'resource',
    '$browser',
    '$cookies',
    'rewardsListService',
    'rewardsList',
    'wishList',
    'wishlistService',
    rewardsMain]);

function rewardsMain($scope,
                     $rootScope,
                     $state,
                     membershipDetail,
                     cmsContent,
                     mobileAppRequest,
                     rfrUtilService,
                     userLanguage,
                     resource,
                     $browser,
                     $cookies,
                     rewardsListService,
                     rewardsList,
                     wishList,
                     wishlistService) {
  $scope.categoriesList = {};
  if (mobileAppRequest) {
    $rootScope.mobileAppR = true;
    rfrUtilService.renderMobile();
  }

  $rootScope.wishListObj = [];
  $scope.rewardsList = [];

  //Update the linkIn cookie for url redirect
  //$browser.cookies('linkIn',document.location.href);
  //console.log('adding linkIn cookie: ' + document.location.href );

  var wishListFn =   function() {
      if (rfrUtilService.isRfrAuthenticated() &&
        membershipDetail &&
        (membershipDetail.statusCode === 'A' || membershipDetail.statusCode === 'S')) {
        wishlistService.getWishList({
          membershipId: membershipDetail.membershipId
        }).then(function(data){
          $scope.wishListObj = data;
          wishList = data;
          $rootScope.wishlistCounter = wishList.length || 0;
          if($rootScope.errorCode.errInWishlistLoading){
            $rootScope.errorCode.errInWishlistLoading = false;
          }
          },
          function (res) {
            console.log(res);
            console.log('error');
            $rootScope.errorCode.errInWishlistLoading = true;
            //wishListFn();
          });
      } else {
      }
  };

  $rootScope.$on('$stateChangeSuccess',
    function(event, toState, toParams){
      if(toState.name.match('rewards') && !rfrUtilService.isRfrAuthenticated()){
        $browser.cookies('linkIn',$state.href(toState));//deeplink feature
      } else {
        if(!toState.name.match('signin')){
          delete $cookies['linkIn'];
          document.cookie = 'linkIn=false; expires=Fri, 31 Dec 1970 23:59:59 GMT; path=/';
        }
      }

      if (!$scope.rewardsList.length){
      $scope.rewardsListFn();
    }
  });

  $scope.rewardsListFn = function(){
    if($state.current.name !== 'rewards.membership' &&  $state.current.name !== 'rewards.wishlist'){
      if(rfrUtilService.isRfrAuthenticated() &&
          membershipDetail &&
          (membershipDetail.statusCode === 'A' || membershipDetail.statusCode === 'S')
        ){
          rewardsListService.getRewardsList({
            membershipId: membershipDetail.membershipId,
            refreshCacheFlag: true
          }).then(
            function(result){
              rewardsList = result;
              //as per Sahil, we should show all the products not only the canRedeem ones
              //to revert back make rewardsList = result.filter(function(reward){ return reward.canRedeem;});
              if($rootScope.errorCode.errInRewardLoading){
              $rootScope.errorCode.errInRewardLoading = false;
              }
              $scope.rewardsList = rewardsList;
              $scope.recommendedRewards = (rewardsList) ? rewardsList.filter(function (reward) {
                return (reward.recommended);
              }) : [];
            },
            function (res) {
              console.log(res);
              console.log('error');
              $rootScope.errorCode.errInRewardLoading = true;

              //rewardsListFn()
            }
          );
        } else {
          rewardsListService.getRewardsList().then(
            function(data) {
              rewardsList = data;
              $scope.rewardsList = rewardsList;
              if($rootScope.errorCode.errInRewardLoading){
              $rootScope.errorCode.errInRewardLoading = false;
              }
              $scope.recommendedRewards = (rewardsList) ? rewardsList.filter(function (reward) {
                return (reward.recommended);
              }) : [];
            },
            function(data){
              $rootScope.errorCode.errInRewardLoading = true;
            }
          );
        }
    }
  };

  var init = function(mobileAppRequest){
    wishListFn();
    if(rfrUtilService.getPageSource()!='#/rewards/earn') {
      $scope.rewardsListFn();
    }
    $scope.membershipDetail = $scope.accountDetails || membershipDetail;
    $rootScope.membershipDetail = membershipDetail;
    $scope.$state = $state;
    $scope.$index = 3;

    $scope.cmsContent = cmsContent;
    $scope.isEnrolled = $rootScope.isEnrolled = (rfrUtilService.isRfrAuthenticated() && membershipDetail && (membershipDetail.statusCode === 'A' || membershipDetail.statusCode === 'S' || membershipDetail.statusCode === 'P' ) ) ? true : false;
    $scope.lang = userLanguage();

    moment.locale($scope.lang);
    $scope.province = ($browser.cookies().province) ? $browser.cookies().province.toLowerCase() : 'on';
    $rootScope.rui = {
      language: $scope.lang,
      province: $scope.province
    };
    if (moment) {
      rfrUtilService.localizeMoment();
    }

    if ($scope.rewardsList && $rootScope.wishListObj) {
      angular.forEach($scope.rewardsList, function (reward) {
        angular.forEach($rootScope.wishListObj, function (wish) {
          if (reward.rewardId === wish.rewardId) {
            reward.inWhishList = true;
          }
        });
      });
    }

    var mobileUrlReplace = function(string){
      return string.replace(/\/web\/totes/, '');
    };


    if ($scope.cmsContent['rfr.image.home.banner']) {
      $scope.homeBanner = ($scope.lang == 'en') ? $scope.cmsContent['rfr.image.home.banner'].englishMessage :
        $scope.cmsContent['rfr.image.home.banner'].frenchMessage;
      $scope.homeBanner = $scope.homeBanner.replace(/\"/g, '');
      if(mobileAppRequest){
        $scope.homeBanner = {
          'background-image': "url('" + mobileUrlReplace($scope.homeBanner) + "')"
        };
      } else {
        $scope.homeBanner = {
          'background-image': "url('" + $scope.homeBanner + "')"
        };
      }
    } else {
      $scope.homeBanner = {};
    }

    if ($scope.cmsContent['rfr.image.home.earnmore']) {
      var earnMoreContent = $scope.cmsContent['rfr.image.home.earnmore'];
      if(mobileAppRequest){
        $scope.homeEarnMore = ($scope.lang == 'en') ? mobileUrlReplace(earnMoreContent.englishMessage) :
          mobileUrlReplace(earnMoreContent.frenchMessage);
      } else {
        $scope.homeEarnMore = ($scope.lang == 'en') ? earnMoreContent.englishMessage :
          earnMoreContent.frenchMessage;
      }
    } else {
      $scope.homeEarnMore = ' ';
    }

    (function () {
      var omnp = omnp || [];
      if(membershipDetail){omnp.push(['_trackPageView ', {eVar27: membershipDetail.statusCode}, {event17: ''}]);
      }
    })();

    $rootScope.currentRewardsBalance = (membershipDetail) ? membershipDetail.pointsBalance : 0;
    //$rootScope.currentRewardsBalance = 10000;

    resource.onChanged(function () {
      $scope.lang = userLanguage();
      moment.locale($scope.lang);
      $scope.province = ($browser.cookies().province) ? $browser.cookies().province.toLowerCase() : 'on';
      $rootScope.rui = {
        language: $scope.lang,
        province: $scope.province
      };

      if ($scope.cmsContent['rfr.image.home.banner']) {
        $scope.homeBanner = ($scope.lang == 'en') ? $scope.cmsContent['rfr.image.home.banner'].englishMessage :
          $scope.cmsContent['rfr.image.home.banner'].frenchMessage;
        $scope.homeBanner = $scope.homeBanner.replace(/\"/g, '');
        if(mobileAppRequest){
          $scope.homeBanner = {
            'background-image': "url('" + mobileUrlReplace($scope.homeBanner) + "')"
          };
        } else {
          $scope.homeBanner = {
            'background-image': "url('" + $scope.homeBanner + "')"
          };
        }
      }
      if ($scope.cmsContent['rfr.image.home.earnmore']) {
        var earnMoreContent = $scope.cmsContent['rfr.image.home.earnmore'];
        if(mobileAppRequest){
          $scope.homeEarnMore = ($scope.lang == 'en') ? mobileUrlReplace(earnMoreContent.englishMessage) :
            mobileUrlReplace(earnMoreContent.frenchMessage);
        } else {
          $scope.homeEarnMore = ($scope.lang == 'en') ? earnMoreContent.englishMessage :
            earnMoreContent.frenchMessage;
        }
      }

    }, $scope);


  };

  init(mobileAppRequest);
}

rewardsMain.resolve = {
  permissionData: ['$browser','permissionResolver' , 'rfrUtilService', function ($browser,permissionResolver, rfrUtilService) {
    //Update the linkIn cookie for url redirect
    if(!rfrUtilService.isRfrAuthenticated()){
      $browser.cookies('linkIn',document.location.href);
    }
    return permissionResolver.getPermission(this.url.sourcePath);
  }],
  cmsContent: ['contentFetchService', function (contentFetchService) {
    return contentFetchService.getCmsContent();
  }],
  mobileAppRequest: [
    '$rootScope',
    '$browser',
    'rfrUtilService',
    '$location',
    function ($rootScope,
              $browser,
              rfrUtilService,
              $location) {
      if ($location.search().sidh) {
        rfrUtilService.setRfrAuthenticated(true);
        rfrUtilService.setMobileSettings();
        rfrUtilService.setHeaderOptions({
          headerData: {
            sidh: $location.search().sidh,
            userId: $location.search().userid
          }
        });
        rfrUtilService.setMobileAppLang($location.search().userlang);
        return true;
      } else {
        return false;
      }
    }],
  membershipList: [
    'membershipService',
    '$rootScope',
    '$q',
    'rfrUtilService',
    'mobileAppRequest',
    '$state',
    function (membershipService,
              $rootScope,
              $q,
              rfrUtilService,
              mobileAppRequest, $state) {

      var getAccountListPromise = function () {
        return membershipService.getAccountList().then(
          function (data) {
            if (data && data.accountList.length != 0) {
              var accounts = data.accountList.map(function (account) {
                return account.accountNumber;
              });
              if(!localStorage.getItem('accountNumber')){
                localStorage.setItem('accountNumber', data.accountList[0].accountNumber);
              }
              return membershipService.getMembershipList(accounts.join());
            } else {
              return $state.go('noaccount');
            }
          },
          function (res) {
            console.log(res);
            console.log('error');
            //retry if the request have failed
            //return getAccountListPromise()
          }
        );
      };

      if (rfrUtilService.isRfrAuthenticated()) {
        //if you come straight to /rewards from deep link, or refresh /rewards, or from mobile app
        if (!($rootScope.ao && $rootScope.ao.allAccounts)) {
          return getAccountListPromise();
        } else {
          var accounts = $rootScope.ao.allAccounts ?
            $rootScope.ao.allAccounts.map(function (account) {
              return account.accountNumber;
            }) : null;
          return membershipService.getMembershipList(accounts.join());
        }
      } else {
        return {};
      }
    }],
  membershipDetailsList: [
    'membershipService',
    'membershipList',
    '$q',
    'rfrUtilService',
    function (membershipService,
              membershipList,
              $q,
              rfrUtilService) {
                var getMembershipList = function() {
                  if (rfrUtilService.isRfrAuthenticated()) {
                    var promises = [];
                    membershipList.forEach(function (membership) {
                      promises.push(membershipService.getMembershipDetail(membership.membershipId));
                    });
                    return $q.all(promises).then(
                      function (detailsList) {
                        //console.log('-from main-', detailsList)
                        return detailsList;
                      },
                      function (res) {
                        console.log(res);
                        console.log('error');
                        //retry if the request have failed
                        //return getMembershipList()
                      }
                    );
                  } else {
                    return {};
                  }
                };
      return getMembershipList();

      if (rfrUtilService.isRfrAuthenticated()) {
        var promises = [];
        membershipList.forEach(function (membership) {
          promises.push(membershipService.getMembershipDetail(membership.membershipId));
        });
        return $q.all(promises).then(function (detailsList) {
          // console.log('-')
          return detailsList;
        });
      } else {
        return {};
      }
    }],
  membershipDetail: [
    'membershipService',
    'membershipDetailsList',
    'rfrUtilService',
    '$location',
    function (membershipService,
              membershipDetailsList,
              rfrUtilService,
              $location) {

      var principalMemberDetails = function (detailsList) {
          var mobileUrlAccountNumber;
          var mobileUrlReqArr ;
          var LocalStorageAccountNumber;
          var principalMemberDetailsObj;

          if($location.search().sidh){
            mobileUrlReqArr = ($location.$$url.split('?'))[1].split('&');
            for (var i = mobileUrlReqArr.length - 1; i >= 0; i--) {
              if( (mobileUrlReqArr[i].split('=')[0]) === 'accountNumber' ){
                console.log(mobileUrlReqArr[i].split('=')[1]);
                mobileUrlAccountNumber = mobileUrlReqArr[i].split('=')[1];
              }
            }
          }else{
            LocalStorageAccountNumber =  localStorage.getItem('accountNumber');
          }

        //match the accountNumber with the membership detail
        if(LocalStorageAccountNumber || mobileUrlAccountNumber){
          for (var i = membershipDetailsList.length - 1; i >= 0; i--) {
            for (var x = membershipDetailsList[i].accounts.length - 1; x >= 0; x--) {
              if(membershipDetailsList[i].accounts[x].number === LocalStorageAccountNumber || membershipDetailsList[i].accounts[x].number === mobileUrlAccountNumber ){
                principalMemberDetailsObj = membershipDetailsList[i];
                if(LocalStorageAccountNumber){
                  localStorage.setItem('accountNumber' , LocalStorageAccountNumber);
                } else if (mobileUrlAccountNumber){
                  localStorage.setItem('accountNumber', mobileUrlAccountNumber);
                }
              }
            }
          }
          return principalMemberDetailsObj;
        }
      };

      if (rfrUtilService.isRfrAuthenticated()) {
        return principalMemberDetails(membershipDetailsList);
      } else {
        return {};
      }
    }]
};

'use strict';

angular.module('rfrApp').controller('transactionDetailsCtrl',[
  '$scope',
  '$filter',
  '$browser',
  '$stateParams',
  'transactions',
  'membershipDetail',
  '$anchorScroll',
  'rfrUtilService',
  transactionDetailsCtrl]);

function transactionDetailsCtrl(
  $scope,
  $filter,
  $browser,
  $stateParams,
  transactions,
  membershipDetail,
  $anchorScroll,
  rfrUtilService
){
  $anchorScroll();
  $scope.transaction = transactions.filter(function(transaction){
    return (transaction.transactionNo.toString() === $stateParams.transactionId);
  })[0];

  $scope.membershipDetail = membershipDetail;

  $scope.getPointsClass = function(){
    return Number($scope.transaction.points) > 0 ? 'positive' : 'negative';
  };

  $scope.transactionDate = function(){
    return rfrUtilService.constructDateString($scope.transaction.date, 'LL');
  };

  $scope.showTransactionType = function(transactionType){
    return $scope.transaction.typeCode === transactionType;
  };

  $scope.getValidityPeriod = function() {
    if ($scope.transaction.activationDate && $scope.transaction.serviceEndDate) {
      return (rfrUtilService.constructDateString($scope.transaction.activationDate)).substring(0, 10) +
        ' - ' +
        (rfrUtilService.constructDateString($scope.transaction.serviceEndDate)).substring(0, 10);
    } else {
      return (rfrUtilService.constructDateString($scope.transaction.date)).substring(0, 10);
    }

  };

  //TODO find out where this is actually coming from // this is just a place holder we don't know where we should get the DevicesList
  $scope.getTransactionDevicesList = function() {
    return $scope.transaction.subscriberNumber;
  };

  //TODO find out where this is actually coming from
  $scope.getTransactionAccountsList = function() {
    if ($scope.transaction.accountNumber) {
      return '#' + $scope.transaction.accountNumber;
    }
  };
}

transactionDetailsCtrl.resolve = {
  permissionData: ['$browser','permissionResolver' , 'rfrUtilService', function ($browser,permissionResolver, rfrUtilService) {
    //Update the linkIn cookie for url redirect
    if(!rfrUtilService.isRfrAuthenticated()){
      $browser.cookies('linkIn',document.location.href);
    }
    return permissionResolver.getPermission(this.url.sourcePath);
  }],
  transactions: ['membershipService', 'membershipDetail', function (membershipService, membershipDetail) {
    return membershipService.getTransactions(membershipDetail.membershipId);
  }]
};


'use strict';
angular.module('rfrApp')
  .constant('filterOptions',[
    {
      name: 'filter_transaction_by_allRes',
      type: 'ALL'
    },
    {
      name: 'rfr_transaction_type_earn',
      type: 'I'
    },
    {
      name: 'rfr_transaction_type_point_adjust',
      type: ['D', 'M']
    },
    {
      name: 'rfr_transaction_type_point_deduct',
      type: 'L'
    },
    {
      name: 'rfr_transaction_type_point_redeem',
      type: 'R'
    },
    {
      name: 'rfr_transaction_type_redeem_adjust',
      type: 'D'
    },
    {
      name: 'rfr_transaction_type_reversal',
      type: 'U'
    },
    {
      name: 'rfr_transaction_type_transfer',
      type: 'T'
    }
  ])
  .controller('transactionsGridCtrl', [
    '$scope',
    'resource',
    'rfrUtilService',
    '$filter',
    'filterOptions',
    '$anchorScroll',
    '$location',
    transactionsGridCtrl
  ])
  .filter('transactionsDateFilter', ['rfrUtilService',transactionsDateFilter])
  .filter('transactionsTypeFilter', [transactionsTypeFilter]);

function transactionsGridCtrl(
  $scope,
  resource,
  rfrUtilService,
  $filter,
  filterOptions,
  $anchorScroll,
  $location
) {
  $scope.filterOptions = filterOptions;
  $scope.filterOption = '';
  $scope.filterOptionObj = {};

  $scope.$watch('transactions', function(newValue, oldValue) {
    if (!oldValue && newValue) {
      $scope.allTransactionsCount = angular.copy(newValue, []).length;
    }
  });

  $scope.changeTransactionType = function(item){
    $scope.filterOptionObj = item;
  };

  $scope.transactionsGridLimit = 10;
  $scope.loadMoreTransactions = function () {
    if($scope.transactionsGridLimit === $scope.transactions.length){
      $location.hash('transactions');
      $anchorScroll.yOffset = 100;
      $anchorScroll();
    } else {
      if($scope.transactionsGridLimit + 10 < $scope.transactions.length){
        $scope.transactionsGridLimit +=10;
      } else {
        $scope.transactionsGridLimit = $scope.transactions.length;
      }
    }
  };

  $scope.datePredicate = function(transaction) {
    return (new Date(transaction.date)).getTime();
  };

  $scope.getResourceString = function(ref){
    return resource.get(ref);
  };

  $scope.getPointsClass = function(transaction){
    return Number(transaction.points) > 0 ? 'positive' : 'negative';
  };

  $scope.transactionDate = function(transaction){
    return rfrUtilService.constructDateString(transaction.date, 'LL');
  };

  $scope.getTransactionTitle = function(transaction){
    if(transaction.typeCode === 'R'){
      return transaction.rewardName;
    } else {
      return transaction.typeName;
    }
  };
}

function transactionsDateFilter(rfrUtilService) {
  return function (items, fromDate, toDate) {
    var endDate = toDate || moment();
    if(items && items.length){
      return items.filter(function (item) {
        var transactionDate = moment(rfrUtilService.constructDateString(item.date));
        if (transactionDate.isBetween(fromDate, endDate, 'days') ||
          transactionDate.isSame(fromDate, 'days') ||
          transactionDate.isSame(endDate, 'days') ||
          !fromDate) {
          return item;
        }
      });
    }
  };
}

function transactionsTypeFilter() {
  return function (items, filterOption) {
    var passesFilter = false;
    if(items && items.length){
      return items.filter(function (item) {
        if($.isEmptyObject(filterOption) || filterOption.type === 'ALL'){
          return item;
        } else if ((typeof filterOption.type === "object") && (filterOption.type.length > 1) ) {
          filterOption.type.forEach(function(f) {
            if (item.typeCode === f) {
              passesFilter = true;
              return false; /* if even one filter matches, item passes and so exit loop */
            } else {
              passesFilter = false;
            }
          });
          return passesFilter;
        } else {
          return item.typeCode === filterOption.type;
        }
      });
    }
  };
}

'use strict';

angular.module('rfrApp')
  .controller('wishlistCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    'rfrUtilService',
    'wishlistService',
    '$anchorScroll',
    wishlistCtrl]);

function wishlistCtrl($scope,
                      $rootScope,
                      $state,
                      rfrUtilService,
                      wishlistService,
                      $anchorScroll) {
  $anchorScroll();

  wishlistService.getWishList({
    membershipId: $rootScope.membershipDetail.membershipId
  }).then(function (data) {
      $rootScope.wishListObj = data;
      $scope.wishlist = $rootScope.wishListObj;
      $rootScope.wishlistCounter = $scope.wishlist.length || 0;
    }
  );

  $scope.$watch(function () {
    return $rootScope.wishListObj;
  }, function (newValue, oldValue) {
    init();
  }, true);
  var init = function () {
    if (rfrUtilService.isRfrAuthenticated() && rfrUtilService.isRfrEnrolled()) {
      $rootScope.apiError = '';
      $scope.wishlist = $rootScope.wishListObj;
      $scope.lazyLoadLimit = 9;
      $scope.loadMore = function () {
        $scope.lazyLoadLimit = ($scope.lazyLoadLimit >= $scope.wishlist.length) ? $scope.wishlist.length : $scope.lazyLoadLimit += 6;
      };
    } else {
      $rootScope.unauthorizedRedirect = true;
      $state.go('rewards.enroll');
    }
  };
}

wishlistCtrl.resolve = {
    loginAuth: function($q, $state, rfrUtilService, $timeout) {
        if(!rfrUtilService.isRfrAuthenticated()){
          $timeout(function() {
            $state.go('signin');
          },0);
          return $q.reject({ originalError: "auth fail" });
        }
    }
};

'use strict';

angular.module('rfrApp').service('addressValidationService', ['rfrAjax', addressValidationService]);

function addressValidationService(rfrAjax){
  return {
    addressValidationRequest: function(ops){
      return rfrAjax.addressValidationRequest(ops);
    }
  };
}

'use strict';

function contentFetchService(rfrAjax, $q) {
  return {
    getProductImg: function (ops) {
      if(ops.imageId && ops.imageId !== ''){
        return rfrAjax.getProductImg({
          imageId: ops.imageId
        });
      } else {
        return $q.reject('imgId not provided');
      }
    },
    getCmsContent: function () {
      return rfrAjax.getCmsContent().then(function(data) {
        var finalCms = {};
        for (var i=0;data && i < data.length;i++) {
          finalCms[data[i].id] = data[i];
        }
        return finalCms;
      });
    }
  };
}

angular.module('rfrApp').service('contentFetchService', ['rfrAjax', '$q', contentFetchService]);

'use strict';

function deviceActivationDateService(){
  var activationDate;
  return {
    getActivationDate: function(){
      return moment(activationDate).format('YYYY-MM-DD');
    },
    setActivationDate: function (date) {
      if(date instanceof Date){
        activationDate = date;

      } else {
        activationDate = moment(date, 'MM/DD/YYYY');
      }
    }
  };
}

angular.module('rfrApp').service('deviceActivationDateService', [deviceActivationDateService]);

'use strict';

function earnListService(rfrAjax){
  return {
    getEarnList: function(ops){
      return rfrAjax.getEarnList(ops);
    },
    optInSpecialOffer: function (ops) {
      return rfrAjax.optInSpecialOffer(ops);
    }
  };
}

angular.module('rfrApp').service('earnListService', ['rfrAjax', earnListService]);

'use strict';

function enrollmentService(rfrAjax) {
  return {
    enrollToRFR: function (ops) {
      return rfrAjax.enrollToRFR(ops);
    }
  };
}

angular.module('rfrApp').service('enrollmentService', ['rfrAjax', enrollmentService]);

'use strict';

function membershipService(rfrAjax, rfrUtilService) {
  return {
    getAccountList: function (){
      if(rfrUtilService.isRfrAuthenticated()) {
        return rfrAjax.getAccountList();
      }
    },
    getMembershipList: function (accounts) {
      if (rfrUtilService.isRfrAuthenticated()) {
        return rfrAjax.membershipList({
          accounts: accounts
        });
      }
    },
    getMembershipDetail: function (membershipId) {
      if (rfrUtilService.isRfrAuthenticated()) {
        return rfrAjax.membershipDetail({
          membershipId: membershipId
        });
      }
    },
    getTransactions: function (membershipId) {
      if (rfrUtilService.isRfrAuthenticated()) {
        return rfrAjax.getTransactions({
          membershipId: membershipId
        });
      }
    }
  };
}

angular.module('rfrApp').service('membershipService', ['rfrAjax', 'rfrUtilService', membershipService]);

'use strict';

function redeemService(rfrAjax){
  return {
    redeemRewards: function(ops){
      return rfrAjax.redeemReward(ops);
    }
  };
}

angular.module('rfrApp').service('redeemService', ['rfrAjax', redeemService]);

'use strict';

function rewardsListService(rfrAjax) {
  return {
    getRewardsList: function (ops) {
      return rfrAjax.getRewardsList(ops);
    },
    getRewardCategories: function (ops) {
      return rfrAjax.getRewardCategories(ops);
    }
  };
}

angular.module('rfrApp').service('rewardsListService', ['rfrAjax', rewardsListService]);

'use strict';
  //var membershipList = {};
  // var membershipDetailsList = {};
  // var membershipDetail = {};
  // var rewardsList = {};
  // var wishList= {};

// angular.module('rfrApp').factory('membershipList', function membershipListFn() {
//   return {};
// });

// angular.module('rfrApp').factory('membershipDetailsList', function membershipDetailsListFn() {
//   return  {};
// });

// angular.module('rfrApp').factory('membershipDetail', function membershipDetailFn() {
//   return {};
// });

angular.module('rfrApp').factory('rewardsList', function rewardsListFn() {
  return {};
});

angular.module('rfrApp').factory('wishList', function wishListFn() {
  var wishList = {} || wishList
  return wishList;
});


'use strict';
angular.module('rfrApp').service('rfrUtilService', [
  'userLanguage',
  '$rootScope',
  '$state',
  'settings',
  'resource',
  rfrUtilService]);

function rfrUtilService(userLanguage,
                        $rootScope,
                        $state,
                        settings,
                        resource) {
  var headerOptions = null;
  return {
    getHeaderOptions: function () {
      return headerOptions;
    },
    setHeaderOptions: function (ops) {
      headerOptions = ops;
    },
    setMobileSettings: function () {
      settings.unProtectedUrlPrefix = '/v1/';
      settings.protectedUrlPrefix = '/v1/';
      settings.ajaxCallException.accountoverview = '/v1/accountoverview';
      settings.ajaxCallException['rfr/membership/list'] = '/v1/rfr/membership/list';
      settings.ajaxCallException['rfr/membership/details'] = '/v1/rfr/membership/details';
      settings.ajaxCallException['rfr/reward/transactions'] = '/v1/rfr/reward/transactions';
      settings.ajaxCallException['rfr/product/image'] = '/v1/rfr/product/image';
      settings.ajaxCallException['rfr/wishList'] = '/v1/rfr/wishList';
      settings.ajaxCallException['rfr/updateWishList'] = '/v1/rfr/updateWishList';
      settings.ajaxCallException['rfr/redeem'] = '/v1/rfr/redeem';
      settings.ajaxCallException['rfr/optInToSpecialOffer'] = '/v1/rfr/optInToSpecialOffer';

      //this sets requests so they point directly to the dev NGNINX if coming from mobile, and when running locally
      settings.devServerURL = 'http://10.16.91.19:8084';
    },
    setMobileAppLang: function(lang){
      userLanguage(lang);
    },
    renderMobile: function () {
      var backText = resource.get('rfr_back');
      $('#header').remove();
      $('#footer').remove();
      $('.team-site-footer').remove();
      $('body').css({
        'padding-top': '0'
      });
      $('<div>' +
        '<span id="back-btn-mobile"></span>' +
          '<span style="position: absolute;left:30px;top:7px;font-weight: 700;">'+ backText +'</span>' +
        '</div>')
        .prependTo('body')
        .css({
          'height': '45px',
          'background-color': '#97999c'
        })
        .find('#back-btn-mobile').on('click', function () {
          closeSecondaryWebView(device);
        })
        .css({
          'display': 'block',
          'background-image': 'url(images/arrowLeftReferrer.png)',
          'background-size': '15px 25px',
          'background-repeat': 'no-repeat',
          'height': '25px',
          'position': 'relative',
          'top': '4px',
          'margin-left': '5px',
          'margin-right': '10px'
        });

      var doCheck = checkPhone(),
        device = doCheck.device;

      mobileInterface(device, '');
    },
    getChannel: function () {
      var mobapp = this.getHeaderOptions() ? 'MOBAPP' : false;
      var mobile = window.matchMedia('only screen and (max-width: 767px)').matches ? 'MOBIL' : false;
      var tablet = window.matchMedia('only screen and (min-width: 768px) and (max-width: 991px)').matches ? 'TABLET' : false;
      var desktop = window.matchMedia('only screen and (min-width: 992px)').matches ? 'DSKTOP' : false;

      return mobapp || mobile || tablet || desktop;
    },
    getPageSource: function () {
      if (window.location.hash.indexOf('?') === 0) {
        return window.location.hash.slice(0, window.location.hash.indexOf('?'));
      } else {
        return window.location.hash;
      }
    },
    localizeMoment: function () {
      /* We add french. This is only done once during the init */
      moment.locale('fr', {
        months : "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
        monthsShort : "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
        weekdays : "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
        weekdaysShort : "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
        weekdaysMin : "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
        longDateFormat : {
          LT : "HH:mm",
          LTS : "HH:mm:ss",
          L : "DD/MM/YYYY",
          LL : "D MMMM YYYY",
          LLL : "D MMMM YYYY LT",
          LLLL : "dddd D MMMM YYYY LT"
        },
        calendar : {
          sameDay: "[Aujourd'hui à] LT",
          nextDay: '[Demain à] LT',
          nextWeek: 'dddd [à] LT',
          lastDay: '[Hier à] LT',
          lastWeek: 'dddd [dernier à] LT',
          sameElse: 'L'
        },
        relativeTime : {
          future : "dans %s",
          past : "il y a %s",
          s : "quelques secondes",
          m : "une minute",
          mm : "%d minutes",
          h : "une heure",
          hh : "%d heures",
          d : "un jour",
          dd : "%d jours",
          M : "un mois",
          MM : "%d mois",
          y : "une année",
          yy : "%d années"
        },
        ordinalParse : /\d{1,2}(er|ème)/,
        ordinal : function (number) {
          return number + (number === 1 ? 'er' : 'ème');
        },
        meridiemParse: /PD|MD/,
        isPM: function (input) {
          return input.charAt(0) === 'M';
        },
        // in case the meridiem units are not separated around 12, then implement
        // this function (look at locale/id.js for an example)
        // meridiemHour : function (hour, meridiem) {
        //     return /* 0-23 hour, given meridiem token and hour 1-12 */
        // },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        week : {
          dow : 1, // Monday is the first day of the week.
          doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
      });
    },
    constructDateString: function (date, format) {
      return format ? moment(date).format(format) : moment(date).format();
    },
    errorDisplay: function (ops) {
      //$rootScope.apiError = ops.errorStatus;
      if(ops.errorString){
        $rootScope.apiError = ops.errorString;
      } else if (ops && ops.errorData && ops.errorData.errorMessage) {
        $rootScope.apiError = ops.errorData.errorMessage;
      } else {
        $rootScope.apiError = 'Error contacting server.';
      }
      throw ops;
      //$state.go('underMaintenance');
    },
    isRfrAuthenticated: function () {
      return $rootScope.user && $rootScope.user.isAuthenticated;
    },
    isRfrEnrolled: function () {
      return $rootScope.isEnrolled;
    },
    setRfrAuthenticated: function (boolean) {
      $rootScope.user.isAuthenticated = !!boolean;
    }
  };
}

'use strict';
angular.module('rfrApp').service('wishlistService', [
  'rfrAjax',
  wishlistService
]);

function wishlistService(
  rfrAjax
) {
  return {
    getWishList: function (ops) {
      return rfrAjax.getWishList({
        membershipId: ops.membershipId
      });
    },
    updateWishList: function (ops) {
      console.log(ops);
      return rfrAjax.updateWishList({
        rewardId: ops.rewardId,
        membershipId: ops.membershipId,
        notifyPointReached: ops.notifyPointReached,
        logObjectId: ops.logObjectId
      });
    }
  };
}

/* UAParser.js
 * Lightweight JavaScript-based User-Agent String Parser */
(function(window,undefined){"use strict";var LIBVERSION="0.7.1",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv";var util={extend:function(regexes,extensions){for(var i in extensions){if("browser cpu device engine os".indexOf(i)!==-1&&extensions[i].length%2===0){regexes[i]=extensions[i].concat(regexes[i])}}return regexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}},lowerize:function(str){return str.toLowerCase()}};var mapper={rgx:function(){for(var result,i=0,j,k,p,q,matches,match,args=arguments;i<args.length;i+=2){var regex=args[i],props=args[i+1];if(typeof result===UNDEF_TYPE){result={};for(p in props){q=props[p];if(typeof q===OBJ_TYPE){result[q[0]]=undefined}else{result[q]=undefined}}}for(j=k=0;j<regex.length;j++){matches=regex[j].exec(this.getUA());if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){result[q[0]]=q[1].call(this,match)}else{result[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){result[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{result[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){result[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{result[q]=match?match:undefined}}break}}if(!!matches)break}return result},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{major:{1:["/8","/1","/3"],2:"/4","?":"/"},version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/((\d+)?[\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/((\d+)?[\w\.-]+)/i,/(opera).+version\/((\d+)?[\w\.]+)/i,/(opera)[\/\s]+((\d+)?[\w\.]+)/i],[NAME,VERSION,MAJOR],[/\s(opr)\/((\d+)?[\w\.]+)/i],[[NAME,"Opera"],VERSION,MAJOR],[/(kindle)\/((\d+)?[\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?((\d+)?[\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?((\d+)?[\w\.]*)/i,/(?:ms|\()(ie)\s((\d+)?[\w\.]+)/i,/(rekonq)((?:\/)[\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron)\/((\d+)?[\w\.-]+)/i],[NAME,VERSION,MAJOR],[/(trident).+rv[:\s]((\d+)?[\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION,MAJOR],[/(yabrowser)\/((\d+)?[\w\.]+)/i],[[NAME,"Yandex"],VERSION,MAJOR],[/(comodo_dragon)\/((\d+)?[\w\.]+)/i],[[NAME,/_/g," "],VERSION,MAJOR],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?((\d+)?[\w\.]+)/i,/(uc\s?browser|qqbrowser)[\/\s]?((\d+)?[\w\.]+)/i],[NAME,VERSION,MAJOR],[/(dolfin)\/((\d+)?[\w\.]+)/i],[[NAME,"Dolphin"],VERSION,MAJOR],[/((?:android.+)crmo|crios)\/((\d+)?[\w\.]+)/i],[[NAME,"Chrome"],VERSION,MAJOR],[/version\/((\d+)?[\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,MAJOR,[NAME,"Mobile Safari"]],[/version\/((\d+)?[\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,MAJOR,NAME],[/webkit.+?(mobile\s?safari|safari)((\/[\w\.]+))/i],[NAME,[MAJOR,mapper.str,maps.browser.oldsafari.major],[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/((\d+)?[\w\.]+)/i,/(webkit|khtml)\/((\d+)?[\w\.]+)/i],[NAME,VERSION,MAJOR],[/(navigator|netscape)\/((\d+)?[\w\.-]+)/i],[[NAME,"Netscape"],VERSION,MAJOR],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?((\d+)?[\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/((\d+)?[\w\.-]+)/i,/(mozilla)\/((\d+)?[\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf)[\/\s]?((\d+)?[\w\.]+)/i,/(links)\s\(((\d+)?[\w\.]+)/i,/(gobrowser)\/?((\d+)?[\w\.]+)*/i,/(ice\s?browser)\/v?((\d+)?[\w\._]+)/i,/(mosaic)[\/\s]((\d+)?[\w\.]+)/i],[NAME,VERSION,MAJOR]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/(ia64(?=;)|68k(?=\))|arm(?=v\d+;)|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(hp).+(touchpad)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\((bb10);\s(\w+)/i],[[VENDOR,"BlackBerry"],MODEL,[TYPE,MOBILE]],[/android.+((transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7))/i],[[VENDOR,"Asus"],MODEL,[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/((playstation)\s[3portablevi]+)/i],[[VENDOR,"Sony"],MODEL,[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(Lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[[VENDOR,"Lenovo"],MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w+)*/i,/(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/\s((milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?))[\w\s]+build\//i,/(mot)[\s-]?(\w+)*/i],[[VENDOR,"Motorola"],MODEL,[TYPE,MOBILE]],[/android.+\s((mz60\d|xoom[\s2]{0,2}))\sbuild\//i],[[VENDOR,"Motorola"],MODEL,[TYPE,TABLET]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n8000|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-n900))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/(sie)-(\w+)*/i],[[VENDOR,"Siemens"],MODEL,[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]+)*/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w-;]{10}((a\d{3}))/i],[[VENDOR,"Acer"],MODEL,[TYPE,TABLET]],[/android\s3\.[\s\w-;]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,[TYPE,SMARTTV]],[/((nexus\s[45]))/i,/(lg)[e;\s\/-]+(\w+)*/i],[[VENDOR,"LG"],MODEL,[TYPE,MOBILE]],[/android.+((ideatab[a-z0-9\-\s]+))/i],[[VENDOR,"Lenovo"],MODEL,[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/(mobile|tablet);.+rv\:.+gecko\//i],[[TYPE,util.lowerize],VENDOR,MODEL]],engine:[[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]+).*(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*|windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)\/([\w\.]+)/i,/(android|webos|palm\os|qnx|bada|rim\stablet\sos|meego)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids3portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk)[\/\s-]?([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.]+\d)*/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[NAME,VERSION],[/(ip[honead]+)(?:.*os\s*([\w]+)*\slike\smac|;\sopera)/i],[[NAME,"iOS"],[VERSION,/_/g,"."]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i],[NAME,[VERSION,/_/g,"."]],[/(haiku)\s(\w+)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(macintosh|mac(?=_powerpc)|plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos)/i,/(unix)\s?([\w\.]+)*/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){return mapper.rgx.apply(this,rgxmap.browser)};this.getCPU=function(){return mapper.rgx.apply(this,rgxmap.cpu)};this.getDevice=function(){return mapper.rgx.apply(this,rgxmap.device)};this.getEngine=function(){return mapper.rgx.apply(this,rgxmap.engine)};this.getOS=function(){return mapper.rgx.apply(this,rgxmap.os)};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};this.setUA(ua)};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{window.UAParser=UAParser;if(typeof define===FUNC_TYPE&&define.amd){define(function(){return UAParser})}var $=window.jQuery||window.Zepto;if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}}})(this);

function checkPhone() {
	// Default state
	var isSmart = true,
		device = '';
	
	try {
		var clientWidth = document.documentElement && document.documentElement.clientWidth

		if (clientWidth == undefined || (+clientWidth) > 240) {
			isSmart = true;
		} else {
			isSmart = false;
		}

		// instance of UA-check third party library ->  http://faisalman.github.io/ua-parser-js/
		var parser = new UAParser();
		var result = parser.getResult();
		
		var deviceType = result.device.type;		// mobile, tablet, undefined
		var osName = result.os.name;				// Android, iOS, BlackBerry, Windows Phone, Symbian
		var osVersion = result.os.version;			// "4.1", "7.0", "10", "8.0", "2.3.5" ... etc
		
		// Crunch the OS version number string into a float value
		var osVersionFloat = parseFloat(osVersion);

		// Device Name.
		device = osName;

		// These if conditions could be in one line, I left it in multiple for readability
		if (osName === "iOS" && osVersionFloat < 6) {
			isSmart = false;
		} else if (osName === "Android" && osVersionFloat < 4) {
			isSmart = false;
		} else if (osName === "BlackBerry") {
			if (osVersionFloat >= 10) {
				isSmart = true;
				device = osName + "10+";
			} else {
				isSmart = false;
			}
		} else if (osName === "Windows Phone" && osVersionFloat < 8) {
			isSmart = false;
//		} else if (osName === "Symbian") {
//			isSmart = false;
		} else {
			// Leave it at the default value
		}
	} catch(e) {
		// An error has occurred so we will default to smart layout.
		isSmart = false;
	}

	return {"isSmart" : isSmart, "device" : device, "version" : osVersionFloat};
}
var NativeMobileClient = null;
function mobileInterface(device, title) {
	if (device.toLowerCase() == 'ios') {
		// use an iframe to load a constructed URI with a special protocol that the app can intercept
		// in shouldStartLoadWithRequest
		(function () {
			'use strict';
			var iOSscheme = 'myacc://',
			    FUNCTIONS = {
					SET_TITLE: 'setTitle',
					SET_SUPERMENU: 'setSupermenu',
					CLOSE_SECONDARY_WEB_VIEW: 'closeSecondaryWebView'
				};

			function createIFrame(src) {
			    var newFrameElement = document.createElement('iframe');
			    newFrameElement.setAttribute('src', src);
			    document.documentElement.appendChild(newFrameElement);
			    return newFrameElement;
			}	// createIFrame()

			function handleRequest(fcn, data) {
	            var url, iFrame;

	            if (data == undefined) {
		            url = iOSscheme + FUNCTIONS[fcn];
	            } else {
		            url = iOSscheme + FUNCTIONS[fcn] + '^' + data;
	            }

        		iFrame = createIFrame(url);
	            iFrame.parentNode.removeChild(iFrame);
			}

			function createIOSClientInterface() {
			    return {
			    	type: 'ios',
			        setTitle: function (title) {
			        	handleRequest('SET_TITLE', title);
			        },
			        setSupermenu: function (smJson) {
			        	handleRequest('SET_SUPERMENU', smJson);
			        },
			        closeSecondaryWebView: function () {
			        	handleRequest('CLOSE_SECONDARY_WEB_VIEW');
			        }
			    };
			}	// createIOSClientInterface()

			NativeMobileClient = createIOSClientInterface();
		}());
	}	// iOS

	if (device.toLowerCase() == 'linux' || device.toLowerCase() == 'android') {
		(function () {
			'use strict';
			if (window.android) {
				NativeMobileClient = window.android;
			}
		}());
	}	// Android

	if (device.toLowerCase() == 'ios' || device.toLowerCase() == 'linux' || device.toLowerCase() == 'android') {
		if (typeof NativeMobileClient !== 'undefined') {
			try {
				if (headerTitle != null) {
					NativeMobileClient.setTitle(title);
				}
			} catch(e) {
				// An error has occurred. Title of mobile app could not be set. We put this catch here so app doesn't crash.
			}
		}
	}
}

function closeSecondaryWebView(device) {
	console.log('device= ' + device);
	if (device.toLowerCase() == 'ios' || device.toLowerCase() == 'linux' || device.toLowerCase() == 'android') {
		if (typeof NativeMobileClient !== 'undefined') {
			try {
				NativeMobileClient.closeSecondaryWebView();
			} catch(e) {
				// Error handling.
			}
		}
	}
}

'use strict';

angular
  .module('pricePlanChanges')
  .controller('confirmOrderCtrl', ["$rootScope", "userLanguage", "pricePlanChangesCart", "pricePlanTranslate", "$scope", "$state", "email_ppc", "pricePlanChanges", function($rootScope, userLanguage, pricePlanChangesCart, pricePlanTranslate, $scope, $state, email_ppc, pricePlanChanges) {

  	//REDIRECT ON REFRESH
  	if(!pricePlanChangesCart.totalCost){ $state.go('wireless-plan-change'); }

    var ctrl = this; // this controller uses the 'controller as' pattern //
    $scope.showExistingAddOns = true;
    ctrl.cart = pricePlanChangesCart;
    ctrl.userSelections = pricePlanChanges.userSelections;

    ctrl.isSharePlus = (ctrl.cart.newPlan.cmsData_En.hasOwnProperty('isSharePlus') && ctrl.cart.newPlan.cmsData_En.isSharePlus.toLowerCase() == "yes") ? true : false;
    ctrl.isShareable = (ctrl.cart.newPlan.cmsData_En.hasOwnProperty('shareType') && ctrl.cart.newPlan.cmsData_En.shareType.toLowerCase() == "share") ? true : false;



    $scope.showIncludes = ctrl.cart.newPlan ? ctrl.cart.newPlan.cmsData_En.categoryName_En.indexOf('Share') > -1 : false;
    $scope.$state = $state;		//button

    //email
    ctrl.email = function(){
				return email_ppc.getemail();
    };

    //OVERAGE

    ctrl.overageFr = pricePlanTranslate.overageFr;

    $scope.lang  = userLanguage();
    $rootScope.$on('resourceChanged', function(){
      $scope.lang  = userLanguage();
    });

    window.scrollTo(0, 0);
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .controller('reviewOrderCtrl', ["$rootScope", "$scope", "$location", "userLanguage", "pricePlanChangesCart", "pricePlanChangesErrors", "pricePlanTranslate", "resource", "$state", "email_ppc", "pricePlanChanges", function($rootScope, $scope, $location, userLanguage, pricePlanChangesCart, pricePlanChangesErrors, pricePlanTranslate, resource, $state, email_ppc, pricePlanChanges) {

  	//REDIRECT ON REFRESH
  	if(!pricePlanChangesCart.totalCost){ $state.go('wireless-plan-change'); }

    var ctrl = this; // this controller uses the 'controller as' pattern //
    $scope.showExistingAddOns = true;
    ctrl.showAgreementError = false;
    ctrl.$location = $location;
    ctrl.cart = pricePlanChangesCart;
    ctrl.userSelections = pricePlanChanges.userSelections;
    $scope.showIncludes = ctrl.cart.newPlan ? ctrl.cart.newPlan.cmsData_En.categoryName_En.indexOf('Share') > -1 : false;

    $scope.isSharePlus = (ctrl.cart.newPlan.cmsData_En.hasOwnProperty('isSharePlus') && ctrl.cart.newPlan.cmsData_En.isSharePlus.toLowerCase() == "yes") ? true : false;
    $scope.isShareable = (ctrl.cart.newPlan.cmsData_En.hasOwnProperty('shareType') && ctrl.cart.newPlan.cmsData_En.shareType.toLowerCase() == "share") ? true : false;


    $scope.agreementDate = Date.now();
    ctrl.cart.taxes = pricePlanChangesCart.getTaxesObject();
    ctrl.cart.grandTotal = pricePlanChangesCart.getGrandTotal();

    $rootScope.$watch('submittingOrder', function(newVal) {
      ctrl.submittionOrder = newVal;
    });

    ctrl.scrollTo = function(targetID) {
      var targetElement = $('#' +targetID);

      // scrollTo is a jQuery plugin
      $('#tac').scrollTo(targetElement);
    }

    ctrl.checkout = function() {
      if ($scope.tac_checkbox) {
        var message = '';
        if ($scope.showIncludes) {
          message = resource.get('ppc_change_plan_confirm_share_text');
        } else {
          message = resource.get('ppc_change_plan_confirm_not_share_text');
        }
        var modal = pricePlanChangesErrors.showError(resource.get('ppc_change_plan_confirm_title'), message, ['Cancel', 'Confirm']);
        modal.then(function(data) {
          if (data) {
            pricePlanChangesCart.checkout();
          }
        });
      } else {
        ctrl.showAgreementError = true;
        //pricePlanChangesErrors.showError(resource.get('_review_order'), resource.get('ppc_agrrement_error_message'), ['OK']);
      }
    }

    //email
    ctrl.email = function(){
    	return email_ppc.getemail();
    };

    //CANCEL/EDIT
    var RELOAD = true;
    ctrl.edit = function(){
    	pricePlanChangesErrors.showError(
    		resource.get('_confirm_leave'),
    		resource.get('_confirm_leave_details'),
    		['Cancel', 'Continue'],
    		{goForward: 'wireless-plan-change'},
    		null,
    		RELOAD);		//bug on reload
    };

    ctrl.checkTacValue = function(){
      if ($scope.tac_checkbox) {
        ctrl.showAgreementError = false;
      }else{
        ctrl.showAgreementError = true;
      }
    };

    //OVERAGE
    ctrl.overageFr = pricePlanTranslate.overageFr;

    $scope.lang  = userLanguage();
    $rootScope.$on('resourceChanged', function(){
      $scope.lang  = userLanguage();
    });

    window.scrollTo(0, 0);
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .controller('singleLinePpcCtrl', ['pricePlanChanges', 'pricePlansPaging', 'popUpBubbles', 'pricePlanChangesErrors',
    'pricePlanChangesCart', 'pricePlanAlignRows', '$rootScope', 'localStorage', 'userLanguage',
    'ajax', '$q', 'pricePlanChangesState', 'resource', '$timeout', '$scope', 'myrMyServicesService','$window', function (pricePlanChanges, pricePlansPaging, popUpBubbles, pricePlanChangesErrors, pricePlanChangesCart, pricePlanAlignRows,
                                                                                       $rootScope, localStorage, userLanguage, ajax, $q, pricePlanChangesState, resource, $timeout, $scope
                                                                                         , myrMyServicesService,$window) {

      $scope.isMobile = false;

      $scope.$watch(function(){
        return $window.innerWidth;
      }, function(value) {
        $scope.isMobile = (value<=991);
      });

      var ctrl = this; // this controller uses the 'controller as' pattern //
      console.log("myrMyServicesService.accountDetails", myrMyServicesService.accountDetails);
      var accountDetailsResponse = {};
      var checkEligibility = function () {
        var deferred = $q.defer();
        var accountNumber = localStorage.getLocalStorageValue('accountNumber');
        var accountTypeNumber = localStorage.getLocalStorageValue('accountTypeNumber');
        var ctn = localStorage.getLocalStorageValue('phoneNumber');
        var membershipStatus = '';
        $rootScope.selectedPlanCount = 0;
        function process() {
          ajax.hupEligibility(accountNumber, ctn, membershipStatus).then(
            function (response) {
              if (!response.isAllowAccess) {
                pricePlanChangesErrors.showError(resource.get('ppc_hup_eligibility_check_message_title'), resource.get('ppc_hup_eligibility_check_message_text'), ['GO_BACK'], {goBack: 'accountOverview'});
              }
            },
            function (response) {
              //pricePlanChangesErrors.showError('HUP Eligibility Check', response.originalMessage, ['OK'], 'wireless');
              //deferred.reject(response);
            });


            var request = {
              accountNumber: accountNumber,
              accountTypeNumber: accountTypeNumber,
              language: userLanguage(),
              applicationId: 'Rogers.com',
              refresh: false
            };
      console.log("filter.accountDetails.subList", _.filter(myrMyServicesService.accountDetails.subList, function(item) {return item.subType == 'CTN';}));

            var subListFromService = _.filter(myrMyServicesService.accountDetails.subList, function(item) {
              return item.subType == 'CTN';
            });
			ctrl.ctnList = _.pluck(subListFromService, 'subNumber');
      console.log("subListFromService", subListFromService);
            ajax.getAccountDetail(request).then(function (data) {
              accountDetailsResponse = data;
              /*var subList = _.filter(data.subList, function(item) {
                return item.subType == 'CTN';
              });
              ctrl.ctnList = _.pluck(subList, 'subNumber');*/

              ajax.getBillingDetail(request).then(function (billingDetails) {
                ctrl.details = myrMyServicesService.accountDetails;
                ctrl.details.accountBalance = billingDetails;
                pricePlanChangesCart.setAccountInfoFromBillingDetails(billingDetails);
                var _length = myrMyServicesService.accountDetails.subList.length;
                var ctnObj = {};
                for (var i = 0; i < _length; i++) {
                  if (myrMyServicesService.accountDetails.subList[i].subNumber === ctn) {
                    ctnObj = myrMyServicesService.accountDetails.subList[i];
                  }
                }
                if (ctnObj.subStatus === 'Suspended') {
                  pricePlanChangesErrors.showSuspendedError(
                    resource.get('ppc_account_suspended_message_title'),
                    resource.get('ppc_account_suspended_message_text'),
                    [],
                    {goBack: 'accountOverview'},
                    true,
                    false,
                    true // isSuspended
                  );
                  deferred.reject(false);
                } else {
                  deferred.resolve(true);
                }
              });
            });


        }//process
        //deferred.resolve(true);

        if (!$rootScope.objRedeem) {

          ajax.getRewards(accountNumber, userLanguage()).then(function (data) {
            membershipStatus = (data.membershipStatus === 'ENROLLED') ? 'ACTIVE' : (data.membershipStatus === 'NOT_ENROLLED') ? 'INACTIVE' : data.membershipStatus;
            process();
          });
        } else {
          membershipStatus = ($rootScope.objRedeem.membershipStatus === 'ENROLLED') ? 'ACTIVE' : ($rootScope.objRedeem.membershipStatus === 'NOT_ENROLLED') ? 'INACTIVE' : $rootScope.objRedeem.membershipStatus;
          if (!membershipStatus || membershipStatus === '') {
            ajax.getRewards(accountNumber, userLanguage()).then(function (data) {
              membershipStatus = (data.membershipStatus === 'ENROLLED') ? 'ACTIVE' : (data.membershipStatus === 'NOT_ENROLLED') ? 'INACTIVE' : data.membershipStatus;
              process();
            });
          } else {
            process();
          }
        }
		//process();
        return deferred.promise;
      };
      var initializeData = function() {
        //Scroll Top
        pricePlanAlignRows.scrollToTop();

        var deferred = $q.defer();
        var ctn = localStorage.getLocalStorageValue('phoneNumber');
        var accountNumber = localStorage.getLocalStorageValue('accountNumber');
        if (ctn) {
          deferred.resolve(ctn);
        } else {
          pricePlanChanges.getWireLessAccounts(accountNumber)
            .then(function (accounts) {
              if (angular.isArray(accounts) && accounts.length > 0 && accounts[0].hasOwnProperty('subNumbers') && angular.isArray(accounts[0].subNumbers)) {
                var account = accounts[0];
                ctn = account.subNumbers[0];
                localStorage.setLocalStorageValue('phoneNumber', ctn);
                localStorage.setLocalStorageValue('accountTypeNumber', account.accountTypeNumber);
                deferred.resolve(accounts);
              } else {
                deferred.reject('getWireLessAccounts failed');
              }

            })
            .then(null, function (error) {
              deferred.reject(error);
            });
        }
        return deferred.promise;
      };
      var initializeController = function () {
        //row align
        $rootScope.alignRows = false;

        //this creates a bindable reference all the way up into the service, and down into directives
        pricePlanChangesCart.init();
        pricePlanChanges.userSelections = pricePlanChangesState.resetUserSelections();
        $rootScope.plansLoading = true;
        checkEligibility().then(
          function () {
            ctrl.userSelections = pricePlanChanges.userSelections;

            pricePlanChanges.getCtnList()
              .then(function (data) {
                //ctrl.ctnList = data;
                var ctn = localStorage.getLocalStorageValue('phoneNumber');
                if (!ctn && angular.isArray(ctrl.ctnList) && ctrl.ctnList.length > 0) {
                  ctn = ctrl.ctnList[0];
//                  ctn = data[0];
                }
                getAvailablePlans(ctn);
                pricePlanChangesCart.ctn = ctn; // we default to the first CTN, this is the equivalent of a user selection
              })
              .then(null, function (errorMessage) {
                alert(errorMessage);
              });
          },
          function (error) {
            if (error.data.status === 555) {
              pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
            }
          }
        ).finally(function () {

          });

        if (!$rootScope.alignRows) {
          //Re-init plan row alignment, if countPlan (= available plans loaded)
          //@see available-plan.js
          if ($rootScope.countPlan == 0) {
            setTimeout(function (newValue, oldValue) {
              pricePlanAlignRows.alignDataRows();
            }, 250);   //$timeout*/
          }
          //Scroll Top
          //pricePlanAlignRows.scrollToTop();
        }
      };

      var getAvailablePlans = function (ctn, dontUpdatePlans) {
        var deferred = $q.defer();

        function getAvailablePlansLocal(ctn, planCode, currentCategory, planPrice, billing_postalCode) {
        //function getAvailablePlansLocal() {
          pricePlanChanges.getAvailablePlans(ctn, planCode, currentCategory, planPrice, billing_postalCode)
          //pricePlanChanges.getAvailablePlans()
            .then(function (data) {

              //****
              //data = data.data;
              //****
              /*if (data.hasOwnProperty('isAllowAccess') && !data.isAllowAccess) {
                pricePlanChangesErrors.showError(resource.get('ppc_hup_eligibility_check_message_title'), resource.get('ppc_hup_eligibility_check_message_text'), ['GO_BACK'], {goBack: 'accountOverview'});
              }*/
              if(data.hasOwnProperty('accessAllowed') && data.accessAllowed == false){
                pricePlanChangesErrors.showError(resource.get('ppc_need_help_message_title'), resource.get('ppc_multiline_error_message'), ['OK'], {goBack: 'accountOverview'}, true);
              }
              else if (data.hasOwnProperty('result') && data.result === 'success') {
                // Read in Data
                // Sort For Featured Plans
                if (data.availablePLans.length > 0) {
                  if (!dontUpdatePlans) {
                    var allPlans = [],
                      pageLength = 0;
                    ctrl.userSelections.availablePlans = [];
                    ctrl.userSelections.availablePlansRawLength = 0;
                    ctrl.userSelections.esisSessionId = data.esisSessionId;
                    pricePlanChangesCart.captureAccountData(data);

                    // delay sort and load
                    //pricePlanChanges.sortRecommendedExclusive(data.availablePLans).then(function (plans) {
                      ctrl.userSelections.availablePlansRaw = data.availablePLans;//plans;
                      allPlans = pricePlansPaging.paginate(ctrl.userSelections.availablePlansRaw, 3);
                      pageLength = allPlans.length;
                      var delayLoadIndex = 0;
                      var delayLoadPlans = function () {
                        if (pageLength > delayLoadIndex) {
                          ctrl.userSelections.availablePlansRawLength += allPlans[delayLoadIndex].length;
                          ctrl.userSelections.availablePlans.push(allPlans[delayLoadIndex]);
                          delayLoadIndex++;
                          $scope.onDelayLoadPlans = $timeout(function () {
                            delayLoadPlans();
                            $scope.$apply();
                          }, 50);
                        }
                      };
                      delayLoadPlans();
                      $rootScope.plansLoading = false;

                    //});

                    // normal sort and load
                    /*ctrl.userSelections.availablePlansRaw = pricePlanChanges.sortRecommendedExclusive(data.availablePLans);
                     ctrl.userSelections.availablePlansRawLength =  ctrl.userSelections.availablePlansRaw.length;
                     ctrl.userSelections.availablePlans = pricePlansPaging.paginate(data.availablePLans, 3);*/

                    //ctrl.userSelections.esisSessionId = data.esisSessionId;
                    //ctrl.status = data.accountInfo.accountInfo.status;


                    // Capture data in cart
                    //if (ctrl.status !== 'Active') {
                    //  pricePlanChangesErrors.showGenericError();
                    //}
                  }
                  deferred.resolve(true);
                } else {
                  deferred.reject(false);
                  pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
                }

              } else if (data.hasOwnProperty('errorCode') && data.errorCode == '204') {
                deferred.reject(false);
                pricePlanChangesErrors.showError(resource.get('204_title'), resource.get('204_text'), ['OK'], {goBack: 'accountOverview'});
              } else {
                deferred.reject(false);
                pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
              }
            })
            .then(null, function (error) {
              // console.log(error);
              pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
            });
        }

        //if (!$rootScope.ao.accountDetails) {
        if (1 === 1) {
          var request = {
            ctn: ctn,
            ban: localStorage.getLocalStorageValue('accountNumber'),
            language: userLanguage()
          };

          ajax.wirelessPostpaid(request).then( function (data) {
              if (data) {
                var planCode = (data.postPaidPhoneDetails.planCode) ? data.postPaidPhoneDetails.planCode : null;
                var currentCategory = (data.planDetails[planCode]['EN'] && data.planDetails[planCode]['EN'].dbPlanrealPPCatergory) ? data.planDetails[planCode]['EN'].dbPlanrealPPCatergory : null;
                currentCategory = (currentCategory) ? currentCategory.trim() : null;
                var planPrice = (data.postPaidPhoneDetails.planMSF) ? data.postPaidPhoneDetails.planMSF : null;
                var accountTypeNumber = localStorage.getLocalStorageValue('accountTypeNumber');
                /*var request = {
                  accountNumber: localStorage.getLocalStorageValue('accountNumber'),
                  accountTypeNumber: accountTypeNumber,
                  language: userLanguage(),
                  applicationId: 'Rogers.com',
                  refresh: false
                };*/
                //ajax.getAccountDetail(request).then(function (data) {
                  var billingPostalCode = accountDetailsResponse.billingAddress.postalCode;
                  pricePlanChangesCart.setAccountInfoFromDetails(accountDetailsResponse);
                  getAvailablePlansLocal(ctn, planCode, currentCategory, planPrice, billingPostalCode);

                  //according to the new changes in backend, no param is required for availablePlan / asked by Shiv, Yihua
                  //getAvailablePlansLocal();
                //});

              }
            }, function () {
              deferred.reject(false);
              pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
            }
          );
        } else {
          getAvailablePlansLocal(ctn);
        }
        return deferred.promise;
      };

      ctrl.selectCtn = function (ctn) {
        pricePlanChanges.userSelections.availablePlanDetailsExpanded = false;
        localStorage.setLocalStorageValue('phoneNumber', ctn);
        $rootScope.plansLoading = true;
        checkEligibility().then(function () {
            pricePlanChanges.selectCtn(ctn)
              .then(function () {
                // Service retains new plan, directives bound to ctrl.userSelections automatically updated
                getAvailablePlans(ctn);
                pricePlanChangesCart.ctn = ctn;
              })
              .then(null, function (errorMessage) {
                alert(errorMessage);
              });
          },
          function (error) {
            // console.log(error);
            //pricePlanChangesErrors.showError(resource.get('ppc_hup_eligibility_check_message_title'), resource.get('ppc_hup_eligibility_check_message_text'), ['OK'], {goBack: 'accountOverview'});
          }
        );
      };

      ctrl.showAvailablePlanDetails = function (slideIndex, planCode) {
        pricePlanChanges.expandPlan(planCode); // pop the right plan onto the scope
        ctrl.userSelections.availablePlanDetailsExpanded = true; // capture expanded state
        ctrl.userSelections.availablePlanDetailsSlideIndex = slideIndex; // let details panel know which wedige to display
      };

      ctrl.hideAvailablePlanDetails = function () {
        ctrl.userSelections.availablePlanDetailsExpanded = false;
      };

      ctrl.showExistingAddOnDetails = function (slideIndex, addOnCode) {
        pricePlanChanges.expandExistingAddOn(addOnCode); // pop the right plan onto the scope
        ctrl.userSelections.existingAddOnDetailsExpanded = true; // capture expanded state
        ctrl.userSelections.existingAddOnDetailsSlideIndex = slideIndex; // let details panel know which wedige to display
      };

      ctrl.hideExistingAddOnDetails = function () {
        ctrl.userSelections.existingAddOnDetailsExpanded = false;
      };

      ctrl.showAvailableLDAddOnDetails = function (slideIndex, addOnCode) {
        pricePlanChanges.expandAvailableLDAddOn(addOnCode); // pop the right plan onto the scope
        ctrl.userSelections.availableLDAddOnDetailsExpanded = true; // capture expanded state
        ctrl.userSelections.availableLDAddOnDetailsSlideIndex = slideIndex; // let details panel know which wedige to display
      };

      ctrl.hideAvailableLDAddOnDetails = function () {
        ctrl.userSelections.availableLDAddOnDetailsExpanded = false;
      };

      ctrl.showAvailableCFAddOnDetails = function (slideIndex, addOnCode) {
        pricePlanChanges.expandAvailableCFAddOn(addOnCode); // pop the right plan onto the scope
        ctrl.userSelections.availableCFAddOnDetailsExpanded = true; // capture expanded state
        ctrl.userSelections.availableCFAddOnDetailsSlideIndex = slideIndex; // let details panel know which wedige to display
      };

      ctrl.hideAvailableCFAddOnDetails = function () {
        ctrl.userSelections.availableCFAddOnDetailsExpanded = false;
      };


      ctrl.showAvailableVPAddOnDetails = function (slideIndex, addOnCode) {
        pricePlanChanges.expandAvailableVPAddOn(addOnCode); // pop the right plan onto the scope
        ctrl.userSelections.availableVPAddOnDetailsExpanded = true; // capture expanded state
        ctrl.userSelections.availableVPAddOnDetailsSlideIndex = slideIndex; // let details panel know which wedige to display
      };

      ctrl.hideAvailableVPAddOnDetails = function () {
        ctrl.userSelections.availableVPAddOnDetailsExpanded = false;
      };

      ctrl.selectPlan = function (planCode) {
        $rootScope.selectedPlanCount++;
        //we do not need to call availablePlans again after clicking on 2nd/3rd/... plan - asked by Shiv
        pricePlanChanges.selectPlan(planCode);

        /*if ($rootScope.selectedPlanCount > 1) {
          getAvailablePlans(localStorage.getLocalStorageValue('phoneNumber'), true).then(function (response) {
            if (response) {
              pricePlanChanges.selectPlan(planCode);
            }
          });

        } else {
          pricePlanChanges.selectPlan(planCode);
        }*/
      };

      ctrl.removePlan = function () {
        pricePlanChanges.removePlan();
      };

      // pass down functions from service
      ctrl.addOnsUpdated = pricePlanChanges.addOnsUpdated;
      ctrl.filterAddOns = pricePlanChanges.filterAddOns;

      // pass down entire service
      ctrl.popUpBubbles = popUpBubbles;


      //@todo - service
      //redundant, same as ctrl.userSelections.availableAddOns.length
      //added to use in Angular watch 'ng-show'
      ctrl.filterAddonsWatch = function (type, sizeOnly) {
        sizeOnly = sizeOnly || false;
        if (!ctrl.userSelections || !ctrl.userSelections.availableAddOns) {
          return 0;
        }

        var addOns = ctrl.userSelections.availableAddOns;

        //temp. @todo
        //type = (type != 'LongDistance') ? 'Calling Features' : 'Long Distance';
        if(type == 'LongDistance'){
          type = 'Long Distance';
        }else if(type == 'CallingFeatures'){
          type= 'Calling Features';
        }else if(type == 'ValuePacks'){
          type= 'Value Packs';
        }

        var filteredAddOns = _.filter(addOns, function (addOn) {
          return addOn.addonInfo.categoryName_En === type;
        });

        if (sizeOnly)
          return filteredAddOns.length;

        return filteredAddOns;
      };

      //INITIALIZATION
      initializeData().then(function() {
        initializeController();
      });
    }]);

(function () {
'use strict';

angular
  .module('selfServe')
  .controller('selfServeCtrl', ["selfServeSvc", "$scope", "$rootScope", "userLanguage", "$q", "$modal", "localStorage", "$cookies", "appState", "profileEditService", "$window", "$state", "myrAccountListService", function(selfServeSvc, $scope, $rootScope, userLanguage, $q, $modal, localStorage, $cookies, appState, profileEditService, $window, $state,myrAccountListService) {
    var userInfoDefer = $q.defer();
    var accountsDefer = $q.defer();
    var accountTypeNumber = localStorage.getLocalStorageValue('accountTypeNumber');

    appState.tagging(['_trackPageView',
      {pn:'home:myrogers:profile'},
      {eVar14:'MyRogers_view_profile_page'},
      {event5:''}// Generic Error
    ]);

    var userInfo = selfServeSvc.getUserProfile(userInfoDefer);
    var accounts = selfServeSvc.getAccountList(accountsDefer);
    $scope.isEditOpen = function() {
      return profileEditService.getEditPanelStatus();
    };

    $scope.cableCustomer = false;
    if (accountTypeNumber == 6) {
      $scope.cableCustomer = true;
    }
    $scope.CredentialsHeading = '';
    $scope.ServiceAddressHeading = '';
    $scope.ContactInformationHeading = '';
    $scope.BillingAddressHeading = '';
    $scope.MarketingPermissionsHeading = 'Marketing Permissions';
    $scope.selectedAccount = {};
    $scope.selectedAccountName = '';
    $scope.showRemovalConfirmation = false;
    $scope.userLanguage = userLanguage();
    $scope.loadedpromise = $q.defer();
    $scope.disassociateAccount = function (account) {

      appState.tagging(['_trackPageView',{pn:'home:MyRogers: remove_account'},{eVar13:' MyRogers__remove_account'},{event5:''}]);
      var originalScope = $scope;
      var modalInstance = $modal.open({
        templateUrl: 'views/modals/account-removal-confirmation.html',
        controller: ["$scope", function ($scope) {

          $scope.accountName = account.name;
          $scope.accountNumber = account.accountNumber;

          $scope.close = function (isRemoval) {
            if (isRemoval) {
              modalInstance.close();
              $state.go($state.current, {}, {reload: true});
              //$route.reload();
              //$window.location.reload();
            }
            modalInstance.close();
          };

          $scope.removeAccount = function () {
            appState.tagging(['_trackLink',{eVar13: 'MyRogers_remove_account'},{event6:''}]);
            $scope.loading = true;
            selfServeSvc.disassociateAccount({
              disassociateAccountNumber: account.accountNumber, // remove this hardcode
              rogersUserID: $cookies.userToken // part of the scope
            }).then(function (result) {
              $scope.loading = false;
              //$scope.close();
              // remove this account from the account list
              selfServeSvc.removeAccountFromList(account);
              originalScope.selectedAccount = originalScope.accounts[0];

              myrAccountListService.removeAccount(account.accountNumber);
              // show the removal confirmation
              originalScope.showRemovalConfirmation = true;

              $scope.showRemovalConfirmation = true;

              $scope.$on('modal.closing', function () {
                if ($scope.showRemovalConfirmation && originalScope.selectedAccount) {
                  $state.go($state.current, {}, {reload: true});
                }
              });

              if (!originalScope.selectedAccount) {
                $state.go('linkaccount', {}, { reload: true });
                return;
              }

            }, function (error) {
              $scope.loading = false;
              $scope.close();
              var modalInstance = $modal.open({
                templateUrl: "views/modals/disassociateModalFail.html",
                windowClass: "verify-address-modal",
                controller: ["$scope", "userLanguage", function ($scope, userLanguage) {
                  $scope.language = userLanguage();
                  $scope.close = function() {
                    modalInstance.close();
                  };
                }]
              });
            });
          };
        }],
        windowClass: "verify-address-modal"
      });
    };

    userInfoDefer.promise.then(function () {
      $scope.userInfo = selfServeSvc.getUserInfo();
      $scope.userInfo.defer = $q.defer();
      $scope.userInfo.defer.resolve();
    }, function () {
      $scope.userInfo = {};
      $scope.userInfo.failure = $q.defer();
      $scope.userInfo.failure.resolve(); //
    });

    $scope.loading = true;
    $scope.accountsFailed = false;

    accountsDefer.promise.then(function () {
      $scope.accounts = selfServeSvc.getAccounts();
      $scope.loading = false;
      var alreadySelectedAccount = localStorage.getLocalStorageValue("accountNumber");

      if (alreadySelectedAccount !== "") {
        var selectedAccount = selfServeSvc.getAccountByAccountNumber(alreadySelectedAccount);
        $scope.selectedAccount = selectedAccount;
      } else {
        $scope.selectedAccount = $scope.accounts[0];
      }
    }, function () {
      $scope.accountsFailed = true;
    });

    var alreadySelectedAccount = localStorage.getLocalStorageValue("accountNumber");
    $scope.hideMarketingPermissionsSection = true;
    selfServeSvc.getMarketingPermissions(alreadySelectedAccount).then(function(marketingPermissions) {
      $scope.hideMarketingPermissionsSection = false;
      if (marketingPermissions) {
        $scope.MarketingPermissions = selfServeSvc.transformMarketingPermissions(marketingPermissions);
      }
    });

    $rootScope.$broadcast("marketingPermissionsStopLoading");

    $scope.selectedAccountChanged = function (account) {
      $scope.selectedAccount = account;
    };

    $scope.accountChanged = function (account) {
      if (account && account.accountNumber) {
        var billingTypeDefer = $q.defer();
        selfServeSvc.getBillingType(account.accountNumber, billingTypeDefer);
        //updating localStorage as requested by Shiv
        localStorage.setLocalStorageValue('accountNumber', account.accountNumber);
        localStorage.setLocalStorageValue('accountTypeNumber', account.accountTypeNumber);

        var detailPromise = $q.defer();
        selfServeSvc.getAccountDetails(account, detailPromise);
        selfServeSvc.setCurrentAccount(account);
        //$scope.selectedAccount = account;
        $rootScope.$broadcast("startLoading");

        $scope.loading = true;

        $scope.hideMarketingPermissionsSection = true;
        selfServeSvc.getMarketingPermissions(account.accountNumber).then(function(marketingPermissions) {
          $scope.hideMarketingPermissionsSection = false;
          if (marketingPermissions) {
            $scope.MarketingPermissions = selfServeSvc.transformMarketingPermissions(marketingPermissions);
          }
        });

        detailPromise.promise.then(function (account) {
          $scope.BillingAddress = account.billingAddress; //selfServeSvc.getBillingAddressForAccount(account); // old reference
          userInfoDefer.promise.then(function () {
            $scope.userInfo.defer.promise.then(function() {
              $scope.BillingAddress.validEmail = !!$scope.userInfo.email;
            });
          });

          $scope.ContactInformation = account.contactInformation; //selfServeSvc.getContactInformationForAccount(account);

          (function fnWrapper(currentAccountNumber) {
            billingTypeDefer.promise.then(function (data) {
              if (currentAccountNumber == $scope.selectedAccount.accountNumber) {
                if (data.billingtype === 'INVOICE') {
                  $scope.BillingAddress.paper = true;
                  $scope.BillingAddress.ebill = false;
                } else if (data.billingtype === 'E_BILL') {
                  $scope.BillingAddress.ebill = false;
                  $scope.BillingAddress.ebill = true;
                }
                $scope.BillingAddress.billingType = data.billingtype;
              }
            }, function(error) {
              //
            });
          }) (account.accountNumber);

          $rootScope.$broadcast("stopLoading");
          $scope.loading = false;
        }, function (response) {
          // this is an error
          $rootScope.$broadcast("stopLoading");
          $scope.loading = false;
          if (response && response.data && response.data.config && response.data.config.data && response.data.config.data.accountTypeNumber && response.data.config.data.accountTypeNumber == "9" ) {
            $scope.prepaidAccount = true;
          } else {
            $scope.generalError = true;
            $scope.accountsFailed = true;
          }
        });
      }
    };
    $scope.addAccount = function() {
      //appState.switchView('linkaccount');
       signinService.mbhUrlConfig().then(function(urlResponse){
         $window.location.href = urlResponse.dashboard+"?openLinkAcctModal=true";
      });
    };

    $scope.$watch('selectedAccount', function (account) {
      $scope.accountChanged(account);
    });
    $scope.notifyServer = function () {
        selfServeSvc.updateMarketingPermissions();
    };

    $scope.updateAccountInfo = selfServeSvc.updateAccountInfo;
    $scope.updateServiceAddress = selfServeSvc.updateServiceAddress;
    $scope.updateContactInformation = selfServeSvc.updateContactInformation;
    $scope.updateBillingAddress = selfServeSvc.updateBillingAddress;
    $scope.updateMarketingPermissions = selfServeSvc.updateMarketingPermissions;
    $scope.assosciatedAccountsExist = true; //
    $scope.updateBillingType = selfServeSvc.updateBillingType;
    $scope.updatePinEmailAddress = selfServeSvc.updatePinEmailAddress;
    $scope.updateEmailAddress = selfServeSvc.updateEmailAddress;

    $scope.contactInformationCtrl = function (scope) {
      scope.$watch('editableData.english', function () {
        if (scope.editableData.english) {
          scope.editableData.french = false;
        }
      });

      scope.$watch('editableData.french', function () {
        if (scope.editableData.french) {
          scope.editableData.english = false;
        }
      });
    };

    $scope.addRemoveAccTag = function(){
      appState.tagging(['_trackPageView',{pn:'home:MyRogers: Add_Remove_account'},{eVar14:' MyRogers_View_add_remove_account '},{event5:''}]);
    };
}])
  .factory('profileEditService', [function() {
    var _editPanelStatus = false;
    var getEditPanelStatus = function getEditPanelStatus() {
      return _editPanelStatus;
    };
    var setEditPanelStatus = function setEditPanelStatus(status) {
      _editPanelStatus = status;
    };
    return {
      getEditPanelStatus: getEditPanelStatus,
      setEditPanelStatus: setEditPanelStatus
    };
  }]);
})();

'use strict';

angular.module('pricePlanChanges').
  filter('decimalCommaValueFltr',['resource', 'userLanguage', function (resource, userLanguage) {
    return function (input) {

      if(!isNaN(input)) {
        input = String(input);

        //issue with decimal-comma-value directive, which works only on broadcast
        //@todo - this temp. fix to load proper ./, when language selected in another view
        var PUNCTUATION = {PERIOD: '.', COMMA: ','};
        var pointChar = userLanguage() === 'en' ? PUNCTUATION.PERIOD : PUNCTUATION.COMMA;
        var previousPointChar = userLanguage() === 'fr' ? PUNCTUATION.PERIOD : PUNCTUATION.COMMA;

        return input.replace(previousPointChar, pointChar);
      }

    };
  }]);

(function () {
  'use strict';

  angular.module('totesApp').controller('MyrAccountBalanceController', accountBalanceController);

  accountBalanceController.$inject = ['$scope','$rootScope', '$location', '$browser', 'appState', 'resource', 'userLanguage', 'myrAccountOverviewService', 'myrAccountBalanceService','myrAccountListService','myrMyServicesService', 'settings', 'btnSettings', '$window', 'localStorage', 'ajax','$modal','myrBriteBillService','myrAccountBalanceDataFactory','$state', 'invoiceService'];

  /* @ngInject */
  function accountBalanceController($scope, $rootScope, $location, $browser, appState, resource, userLanguage, myrAccountOverviewService, myrAccountBalanceService,myrAccountListService, myrMyServicesService,settings, btnSettings, $window, localStorage, ajax,$modal,myrBriteBillService,myrAccountBalanceDataFactory,$state,invoiceService) {

    var vm = this;

    // Public API
    vm.lng = userLanguage();
    vm.rs = $rootScope;

    //cls
    vm.isShowPanel = false;

    vm.payBill = payBill;
    vm.postToRogers = postToRogers;
    vm.postToRogersTop = postToRogersTop;

    vm.ao = myrAccountOverviewService;
    vm.abs = myrAccountBalanceService;
    vm.mss = myrMyServicesService;
    vm.bb = myrBriteBillService;

    vm.als = myrAccountListService;
    vm.abdf = myrAccountBalanceDataFactory;
    $scope.$watch('ab.als.selectedAccount.accountNumber',function(accountNumber){
      if(accountNumber && myrAccountListService.selectedAccount.accountTypeNumber !== 9){
        getBalanceDetails();
      }
    });

  $scope.currentTime=new Date().getHours();


    var isWireless = function(){
    var selectedAccount = vm.mss.selectedAccountDetail;
    var status = selectedAccount.status.toLowerCase();
    if((selectedAccount.hasWireless && selectedAccount.isConsolidated  && status === 'suspended') || !selectedAccount.hasWireless)
           return false;
     else if ((selectedAccount.hasWireless && !selectedAccount.isConsolidated) || (selectedAccount.hasWireless && selectedAccount.isConsolidated && status === 'active'))
         return true;
    }


   var invokeFloatingChat = function (){
         angular.element('.bcFloat').remove();
         var buttonId;
             if (userLanguage() === 'en') {
              buttonId = getBDId('F_BSS_Overview');
              floatingLiveChatButtonUTE(buttonId);
             }
             else{
              if(isWireless()){
                //console.log("account number");
                buttonId = getBDId('F_BSS_Overview_Fr');
                floatingLiveChatButtonUTE(buttonId);
              }
              }
              }

               $scope.$on('$stateChangeStart', function() {
               angular.element('.bcFloat').remove();
               });

               $rootScope.$on('languageChanged', function() {
              // if($location.path()=='/accountOverview') { //Commented for RBIB-2322
               angular.element('.bcFloat').remove();
               invokeFloatingChat();
              // }
               });

         $scope.$watch('ab.mss.selectedAccountDetail.number',function(){
         invokeFloatingChat();

              });
             // invokeFloatingChat();



    $rootScope.$watch('ao.accountActive', function () {
      if ($rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatus) {
        vm.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
        vm.btnStatus = $window.btnStatus;
      }
    });

    function payBill() {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
      appState.tagging(['_trackPageView', {pn:'overview_paynow_Paynow'} ]);
      appState.switchView('/makeAPayment');
    }

    var postToRogersUrls = [
      {url: '/web/myrogers/viewInvoice'},
      {url: '/web/myrogers/prepaidTopUp'}
    ];

    function postToRogers() {
      appState.switchView('viewInvoice');
    }

    function postToRogersTop() {
      // For oneview dealer and care display modal for prepaid top-up
      if($rootScope.isDealer || $rootScope.isCare){
        $scope.openModalPopup();
      }else{
        $('#formToRogersTop').attr('action', settings.formsURL + postToRogersUrls[1].url);
        $('#formToRogersTop').submit();
      }
    }

    $scope.openModalPopup = function (size) {
      var serverHack = '/web/smb/bss';
      if (settings.isLocal) {
        serverHack = '';
      }
      $rootScope.modal = $modal.open({
        templateUrl: serverHack + '/views/modals/prepaidModal.html',
        controller: 'MyrWirelessPrepaidModalController',
        size: size,
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });

      $rootScope.modal.result.then(function () {
        // on OK behaviour
      }, function () {
        // on Cancel behaviour
      });
    };

    function getBalanceDetails() {

      vm.loadingBalance = true;
      vm.disableBalance = true;
      var acctDetails = myrAccountListService.selectedAccount;

      var request = {
        accountNumber: acctDetails.accountNumber,
        accountTypeNumber: acctDetails.accountTypeNumber,
        pinNumber: acctDetails.pinNumber,
        phoneNumber: acctDetails.phoneNumber,
        language: vm.lng,
        refresh: true,
        indx: acctDetails.selectedAccountIndex,
        applicationId: 'Rogers.com'
      };

      if($state.current.name === 'viewInvoice'){
        var request = {
          accountNumber: localStorage.getLocalStorageValue('accountNumber'),
          accountTypeNumber: acctDetails.accountTypeNumber,
          pinNumber: acctDetails.pinNumber,
          phoneNumber: acctDetails.phoneNumber,
          language: vm.lng,
          refresh: true,
          indx: acctDetails.selectedAccountIndex,
          applicationId: 'Rogers.com'
        };
      }

      var balanceDetailsResponse = function (_tmp) {
        // Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal

        $rootScope.$watch('isbritebillAvailable', function () {
          if(($rootScope.isDealer || $rootScope.isCare)
            && ($rootScope.isbritebillAvailable && !vm.mss.selectedAccountDetail.isPrepaid)) {
            vm.mss.selectedAccountDetail.isViewBillDisplay=true;
          }
        });


        if (_tmp.result === 'success') {
          vm.abs.accountBalance = _tmp.data;
          vm.abdf.accountBalance = _tmp.data;

        }else{
          vm.abs.accountBalance = {};
          vm.abdf.accountBalance = {};
        }

        vm.loadingBalance = false;
        vm.disableBalance = false;
      };

      myrAccountBalanceService.getBalanceDetails(request, balanceDetailsResponse);
      //vm.abdf.getBalanceDetails(request, balanceDetailsResponse);

    }


    resource.onChanged(function () {
      vm.lng = userLanguage();
    }, $scope);

  }
})();

(function () {
  'use strict';

  angular.module('totesApp').directive('myrAccountBalance', accountBalance);

  accountBalance.$inject = [];

  /* @ngInject */
  function accountBalance($log) {
    return {
      scope: {loadingBriteBill: '='},
      templateUrl: function(elem,attrs) { if(attrs.viewHtml){return 'scripts/modules/accountBalance/'+attrs.viewHtml} },
      restrict: 'EA',
      controller: 'MyrAccountBalanceController',
      controllerAs: 'ab',
      bindToController: true
    };

  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:myrAccountBalanceService
   * @description
   * # myrAccountBalanceService
   */
  angular.module('totesApp').factory('myrAccountBalanceService', accountBalanceService);

  accountBalanceService.$inject = ['$rootScope', 'ajax','localStorage', 'resource'];

  function accountBalanceService($rootScope, ajax, localStorage, resource) {

    var service = {
      accountBalance:{},
      loadingData:false,
      errorLoading:null,
      isWinOnline : isWinOnline,
      getBalanceDetails: getBalanceDetails,
      getAccountBalance:getAccountBalance
    };

    return service;

    ///////////////////////////////////////////////////////////////
    function getAccountBalance(){
      return service.accountBalance;
    }

    function isWinOnline(isWinOnlineRequest,callback){
      ajax.getWinOnlineFlag(isWinOnlineRequest).then(
        function (data) {

          return callback(data);


        }, function (error) {

          return callback(error);
        }
      );
    }

    function getBalanceDetails(request, callback, billingOverride) {

      service.accountBalance = {};

      // load JSON
      var _return = {};
      var _this = this;

      var wirelessAccountTypeNumber = 1;
      var call = (!billingOverride && (request.accountTypeNumber === wirelessAccountTypeNumber)) ? ajax.getBalance : ajax.getBillingDetail;

      service.loadingData = true;
      service.errorLoading = null;
      // Always load new data
      call(request).then(
        function (data) {

          var lastSetAccount = localStorage.getLocalStorageValue('accountNumber');

          if (request.accountNumber === lastSetAccount) {

            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {

              localStorage.deleteLocalStorageValue('refreshDetails');

              if ($rootScope.ao.accountDetails) {
                $rootScope.ao.accountDetails.accountBalance = data;
              }

              data.isCLM = (Number(data.creditLimit) > 0);
              data.isCLMExceeded = data.exceedCreditLimit;

              _return.result = 'success';
              _return.data = service.accountBalance = data;
              service.loadingData = false;
              return callback(_return);

            } else {
              service.loadingData = false;
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          }
        }, function (error) {
          service.loadingData = false;
          service.errorLoading = resource.get('acc_overview_oops');

          // Error handling - 555 exception
          if (error.data.status === 555) {
            // Server error that needs further processing
            // additional information for 555 error

            // error.error.errorCode		// 10k - 12.1k & 50k - 51k
            // error.error.errorMessage		// Message as delivered from server
            // error.error.message 			// Message as found in resource file
            // error.error.statusCode		// error status code - 555 in this case

          } else {
            // anything but status code 555
          }

          _return.result = 'error';
          _return.data = error;
          return callback(_return);
        }
      );

    }
  }

}());

(function () {
  'use strict';

  angular.module('totesApp').controller('AccountInitController', AccountInitController);

  AccountInitController.$inject = ['$state', '$stateParams', 'myrAccountListService', 'myrMyServicesService', 'myrAccountBalanceService', '$rootScope', 'userLanguage', 'localStorage', 'bfappcWirelessDashboardService'];

  /* @ngInject */
  function AccountInitController($state, $stateParams, myrAccountListService, myrMyServicesService, myrAccountBalanceService, $rootScope, userLanguage, localStorage, bfappcWirelessDashboardService) {

    function init() {
       var request = {};
       if ($rootScope.ao.accountActive == null && $rootScope.accountListLength == 1) {
           localStorage.setLocalStorageValue('accountNumber', $rootScope.accountListOcp[0].accountNumber);
           request = {
               accountNumber: $rootScope.accountListOcp[0].accountNumber,
               accountTypeNumber: $rootScope.accountListOcp[0].accountTypeNumber,
               language: userLanguage(),
               refresh: !1,
               applicationId: "Rogers.com"
           }

       } else {
           request = {
               accountNumber: $rootScope.ao.accountActive.accountNumber,
               accountTypeNumber: $rootScope.ao.accountActive.accountTypeNumber,
               language: userLanguage(),
               refresh: !1,
               applicationId: "Rogers.com"
           }

       };
        myrMyServicesService.getAccountDetails(request, function(data) {
            if (data.result !== 'error') {
                $rootScope.ao.accountDetails = data.data;
                var res = myrMyServicesService.getSubscriptions($rootScope.ao.accountDetails.subList);
                $rootScope.myServicesList = (res && res.myServices) ? res.myServices : undefined;
                var acctDetails = myrAccountListService.selectedAccount;
                var sublistLength = $rootScope.ao.accountDetails.subList.length;
                var req = {};
                var req = {
                    accountNumber: acctDetails.accountNumber,
                    accountTypeNumber: acctDetails.accountTypeNumber,
                    pinNumber: acctDetails.pinNumber,
                    phoneNumber: acctDetails.phoneNumber,
                    language: userLanguage(),
                    refresh: true,
                    indx: acctDetails.selectedAccountIndex,
                    applicationId: 'Rogers.com'
                };

                myrAccountBalanceService.getBalanceDetails(req, function(data) {
                    if (data.result !== 'error') {
                        myrMyServicesService.getSelectedAccountDetail();

                        var accountDetails = $rootScope.ao.accountActive;
                        if(myrAccountListService.isOcpCheck == "directLanding"){
                            myrAccountListService.isOcpCheck= " ";
                            if ((myrAccountListService.acctInitStateUrl == "wireless" && acctDetails.accountTypeNumber != 21) || ((myrAccountListService.acctInitStateUrl == "changePayMethod" || myrAccountListService.acctInitStateUrl == "wireless" ) && (acctDetails.accountStatus =="Suspended"|| acctDetails.accountStatus =="Cancelled"))) {
                                $state.go("accountOverview");
                            } else {
                                //view bill changes
                                if(myrAccountListService.acctInitStateUrl == "viewbill"){
                                  myrAccountListService.acctInitStateUrl = "viewInvoice";
                                } else if(myrAccountListService.acctInitStateUrl == "change-price-plan"){
                                    return bfappcWirelessDashboardService.hasMultipleSubscribers().then(
                                      function (hasMultipleSubscribers) {
                                        if (!hasMultipleSubscribers) {
                                          $state.go("ppc-singleline");
                                        } else {
                                          $state.go('ppc-multiline-entry-2');
                                        }
                                      }
                                    );
                                }
                                $state.go(myrAccountListService.acctInitStateUrl);
                                if (typeof(window.QSI) !== 'undefined') {
                                    setTimeout(function() {
                                        window.QSI.API.unload();
                                        window.QSI.API.load();
                                        window.QSI.API.run();
                                    }, 1500);
                                }
                            }
                        }else{
                            if(['wireless', 'tvdashboard', 'internetdash', 'businessphonedashboard'].indexOf(myrAccountListService.acctInitStateUrl) >= 0) {
                                if(accountDetails && (accountDetails.accountStatus == "Suspended" || accountDetails.accountStatus == "Cancelled")) {
                                   $state.go("accountOverview");
                                } else {
                                  var lob =  $rootScope.ao.accountDetails.lob;
                                  if(lob == 'WL' || lob == 'C'){
                                    var subType = $rootScope.ao.accountDetails.subList[0].subType;
                                    if(subType == 'CTN'){
                                      $state.go("wireless");
                                    } else if(subType == 'Digital TV'){
                                      $state.go("tvdashboard");
                                    } else if(subType == 'Hi-Speed Internet'){
                                      localStorage.setLocalStorageValue('internetAccountNumber', accountDetails.accountNumber);
                                      $state.go("internetdash");
                                    } else if(subType == 'DPN'){
                                      $state.go("businessphonedashboard");
                                    } else if(subType == 'Rogers Smart Home Monitoring'){
                                      $state.go("shmdashboard");
                                    }
                                  }
                                }
                            } else if (['viewGroups', 'viewReporting'].indexOf(myrAccountListService.acctInitStateUrl) >= 0){
                                if(accountDetails.accountNumber.length == 9)
                                  $state.go(myrAccountListService.acctInitStateUrl);
                                else
                                  $state.go("accountOverview");
                            } else if (['changesubscribername', 'simCard', 'resetvoicemailbox'].indexOf(myrAccountListService.acctInitStateUrl) >= 0){
                                $state.go("accountOverview");
                            } else {
                                $state.go(myrAccountListService.acctInitStateUrl);
                            }
                        }
                    } else {
                      $state.go("accountOverview");
                    }
                });
            }
        });
    }

    init();
  }
})();

(function () {
  'use strict';

  angular.module('totesApp').controller('MyrAccountListController', accountListController);

  accountListController.$inject = ['$scope','$rootScope','$modal','userLanguage','myrAccountListService','$browser','$cookieStore','localStorage','deeplink','$window','myrNotificationBannerService','btnSettings','$state','appState','settings','resource','$location','brtCheck','invoiceService','$q','myrSigninService', 'ute.datalayer.common.service'];

  /* @ngInject */
  function accountListController($scope,$rootScope,$modal,userLanguage,myrAccountListService,$browser,$cookieStore,localStorage,deeplink,$window,myrNotificationBannerService,btnSettings,$state,appState,settings,resource,$location,brtCheck,invoiceService,$q,signinService, dataLayerService) {

    var vm = this;
    var notificationBannerService = myrNotificationBannerService;

    // Public API
    vm.lng = userLanguage();

    vm.loadingDataIndicator = false;
    vm.als = myrAccountListService;
    vm.selectAccount = selectAccount;
    vm.changeAccNumber = changeAccNumber;
    /**
    * Introducing flag to redirect to accountOverview only in case of change account from menu dropdown.
    **/
    vm.accountNumberChangedManually = false;
    $scope.migrationEligibleKey = null;
    $scope.faqURL = resource.get('soho_migration_faq_url');
    vm.accounts =[];


    function changeAccNumber(selectedAccNumber){
      dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "changeAccNumber"});
      if(vm.als.selectedAccount.accountNumber != selectedAccNumber){
        var accountType = _.find(vm.als.accountTypes, {'accountNumber': selectedAccNumber});
        if(!!accountType){
          vm.als.selectedAccount = accountType;
          vm.accountNumberChangedManually = true;
        }
        openSohoMigrationPopup();
      }
    }

   $scope.linkAccount = function() {
       signinService.mbhUrlConfig().then(function(urlResponse) {
         $window.location.href = urlResponse.dashboard + "?openLinkAcctModal=true";
               })
           }

    function changeAccount() {

      notificationBannerService.cleanBanner('linkedMessage');

      // Update indexes of active user account and permissionsbrtLinkAccount
      appState.aoUpdateActiveObjects(vm.als.selectedAccount.accountNumber);

      // Update selection and store it into a cookie
      localStorage.setLocalStorageValue('accountNumber', vm.als.selectedAccount.accountNumber);
      localStorage.setLocalStorageValue('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
      if(vm.als.selectedAccount.accountName) {
        if(vm.als.selectedAccount.accountName.firstName)
          localStorage.setLocalStorageValue('fName', vm.als.selectedAccount.accountName.firstName);
        if(vm.als.selectedAccount.accountName.lastName)
          localStorage.setLocalStorageValue('lName', vm.als.selectedAccount.accountName.lastName);
      }
      appState.tagging(['_trackLink', {eVar7: vm.als.selectedAccount.accountNumber}, {event17: ''}]);

      //console.log('getDetails call 1');
      try{
        $state.current.data._preConditions.accountNumber = vm.als.selectedAccount.accountNumber;
      }catch(e){}

      if(vm.accountNumberChangedManually){
        vm.accountNumberChangedManually = false;
        $state.go("accountInitialization");
      }

      vm.als.analyticsUserAccountInfo();

      $rootScope.$emit('accountChanged', vm.als.selectedAccount.accountNumber);
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
    }

    var getAccountList = function () {

      //hide the previous account details

      var browserCookies = $browser.cookies();
      var signInLanguage = browserCookies.signInLang;
      var userlang = userLanguage();
      var cacheFailSafe = true;

      var accountListError = function () {
        vm.loadingDataIndicator = false;
      };

      if (signInLanguage) {
        if(userlang == '' || userlang == signInLanguage){
          userLanguage(signInLanguage);
          $cookieStore.remove('signInLang');
        }
      }
      // As for dealer and care the accountActive becomes null when coming back from wireless
      // Need to reinitialize from selectedAccount
      if(($rootScope.isDealer || $rootScope.isCare) && !$rootScope.ao.accountActive) {
        if(appState.selectedAccount) {
          $rootScope.ao.accountActive = appState.selectedAccount;
        }
      }
      //if ($rootScope.ao.raw === null) {
      if (!$rootScope.ao.accountActive) {
        //first time check signin language

        // Make call to server (Should not need to tho)
        var request = {
          refresh: false,
          applicationId: 'Rogers.com'
        };

        var accountListResponse = function (_tmp) {

          vm.loadingDataIndicator = false;

          if (_tmp) {
            if (_tmp.cachedResultInfo) {
              if ((_tmp.cachedResultInfo.expired || $rootScope.isAccountListCacheExpired ) && cacheFailSafe) {
                $rootScope.isAccountListCacheExpired = false;
                cacheFailSafe = false;
                request.refresh = true;
                //console.log('process account list 0');
                if (_tmp.accountList.length > 0) {
                  var dataToProcess = JSON.parse(JSON.stringify(_tmp));
                  processGetAccountList(dataToProcess);
                  vm.als.accountListRaw = JSON.parse(JSON.stringify(_tmp));
                }
                vm.loadingDataIndicator = true;
                $rootScope.ao.raw.cachedResultInfo.expired = true;
                vm.als.getAccountList(request, accountListResponse,accountListError);
              }
            }

            if (vm.als.accountListRaw) {
              vm.als.accountListRaw.cachedResultInfo = {};
            }
            _tmp.cachedResultInfo = {};

            if (!vm.als.accountListRaw || (vm.als.accountListRaw && (!angular.equals(_tmp, vm.als.accountListRaw)))) {

              //console.log('process account list 1');
              processGetAccountList(_tmp);
            }

          }

        };

        vm.loadingDataIndicator = true;

        vm.als.getAccountList(request, accountListResponse,accountListError);

        vm.accounts = localStorage.getLocalStorageValue('accounts').split(',');
        if(vm.accounts.length == 1) {
          openSohoMigrationPopup();
        }

      } else {

        processGetAccountList($rootScope.ao.raw);

        vm.accounts = localStorage.getLocalStorageValue('accounts').split(',');
        if(vm.accounts.length == 1) {
          openSohoMigrationPopup();
        }

        //console.log('process account list 2');
        // grab data from rootscope and have the function process that
      }

      return null;
    };

    var processGetAccountList = function (_tmp) {
      // _tmp = $rootScope.ao.raw
      // _tmp = $rootScope.ao.raw

      if (_tmp.result === 'success') {
        var ban = {};
        for (var i = 0; i < _tmp.accountList.length; i++) {
          var tmp = {};
          tmp = _tmp.accountList[i];
          _tmp.accountList[i].accountStatusSimple = vm.als.getAccountStatus(tmp).accountStatusSimple;
          _tmp.accountList[i].nickName = _tmp.accountList[i].nickname;
          _tmp.accountList[i].displayName = _tmp.accountList[i].nickName ? _tmp.accountList[i].nickName : _tmp.accountList[i].accountNumber;
          _tmp.accountList[i].comboDisplay = (_tmp.accountList[i].nickName || _tmp.accountList[i].nickName) ? (_tmp.accountList[i].nickName || _tmp.accountList[i].nickName) + ' - ' + _tmp.accountList[i].accountNumber : _tmp.accountList[i].accountNumber;
          _tmp.accountList[i].accNo = _tmp.accountList[i].accountNumber;
          ban[i] = _tmp.accountList[i].accountNumber;
        }
        //display the linked success banner for the very first account
        vm.als.accountTypes = _tmp.accountList;
        vm.als.accountNumberList = ban;

        var reqIndex = 0;
        var accLocalSelected;

        if (vm.als.accountTypes.length > 1 && ($rootScope.ao.accountActiveIndex === null || $rootScope.ao.accountActiveIndex === undefined)) {
          // Check local storage if account was selected in past
          accLocalSelected = localStorage.getLocalStorageValue('accountNumber');
          if (!accLocalSelected) {
            // Update selected index
            appState.aoUpdateActiveObjects(accLocalSelected);
            reqIndex = $rootScope.ao.accountActiveIndex;

            if (deeplink.data.direction === 'out') {
              // DO NOT open the pop-up selector
            } else {

              // Show the popup / first time entry
              if (!$rootScope.firstLoad) {
                appState.tagging(['_trackLink', {event35: ''}]);
                $rootScope.firstLoad = 1;
                $rootScope.popUpOpened = true;

                openSelectAccount('');

              }
            }
          }
          else{
            // Update selected index
            appState.aoUpdateActiveObjects(accLocalSelected);
            reqIndex = $rootScope.ao.accountActiveIndex;

          }
        } else if (vm.als.accountTypes.length > 1) {

          accLocalSelected = localStorage.getLocalStorageValue('accountNumber');

          if (accLocalSelected) {
            var actIndex = appState.aoUpdateActiveObjects(accLocalSelected);
            vm.als.updateSelectedAccount(actIndex);
            reqIndex = vm.als.selectedIndex;
          } else {
            //reqIndex = $rootScope.ao.accountActiveIndex;
            reqIndex = vm.als.selectedIndex;
          }

        }

        if (vm.als.accountTypes.length === 1) {
          if (!$rootScope.firstLoad) {
            $rootScope.firstLoad = 1;
            appState.tagging(['_trackLink', {event35: ''}]);
          }
          if ($browser.cookies().deepLinkFlow == 'PPC'){
            $state.go('ppc-singleline');
            $window.document.cookie = "deepLinkFlow" + "=" + null + "; expires=Thu, 01 Jan 1970 00:00:00 UTC";
          }
        }

        // Update selection and store it into a cookie
        vm.als.selectedAccount = vm.als.updateSelectedAccount(reqIndex);
        $rootScope.ao.accountActive = vm.als.selectedAccount;

        appState.tagging(['_trackLink', {eVar7: vm.als.selectedAccount.accountNumber}, {event17: ''}]);
        appState.tagging(['_trackLink', {eVar17: vm.als.selectedAccount.accountNumber}]);

        vm.als.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
        vm.als.btnStatus = $window.btnStatus;

        localStorage.setLocalStorageValue('accountNumber', vm.als.selectedAccount.accountNumber);
        localStorage.setLocalStorageValue('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
        appState.aoUpdateIndexes(vm.als.selectedAccount.accountNumber);

        // load default profile

        var modalSelected = localStorage.getLocalStorageValue('accountNumber');

        appState.aoUpdateActiveObjects(modalSelected);

        // From updated rootScope proceed to update of the page
        vm.als.selectedAccount = vm.als.accountTypes[reqIndex];

        return vm.als.accountTypes;

      } else {
        if (_tmp.result === 'redirect') {
          appState.noLinking = false;
          if($rootScope.isConsumer){
            appState.switchView('guestoverview');
          } else {
            appState.switchView('/oneViewInterface');
          }
          //appState.switchView('guestoverview');
        } else {
          // Unknown state ???
        }
      }
    };

    function selectAccount(val) {

      vm.als.selectedAccount = $rootScope.ao.accountActive = val;

    }

    var openSelectAccount = function (size) {
      // Modal handling function

      var pageUrl = $window.location.href;
      if (pageUrl.indexOf('underMaintenance') >= 0) {
        return;
      }

      var serverHack = '/web/smb/bss';
      if (settings.isLocal) {
        serverHack = '';
      }

      $rootScope.modal = $modal.open({
        templateUrl:'views/modals/accountOverviewLinkModal.html',
        controller: 'MyrAccountListLinkModalController',
        scope: $scope,
        size: size,
        backdrop: 'static',
        keyboard: false,
        backdropClass: 'bkg-modal',
        resolve: {}
      });

      $rootScope.modal.result.then(function (_data) {
        if (typeof _data === 'object') {
          // Button in modal window pressed and passed object information
          selectAccount(_data);
        } else {
          if (_data === 'ok') {
            // accountOverview.openSelectAccount - Close - OK
          } else if (_data === 'url') {
            // accountOverview.openSelectAccount - Close - URL change
          } else {
            // Some other undefined operation happened to close the modal
            // accountOverview.openSelectAccount - Close
            throw new Error('accountListController.openSelectAccount - Undefined modal close event');
          }
        }
        openSohoMigrationPopup();
      }, function (_data) {
        if (_data === 'cancel') {
          // accountOverview.openSelectAccount - Dismiss - Cancel
        } else {
          // Some other undefined operation happened to dismiss the modal
          // accountOverview.openSelectAccount - Dismiss
          throw new Error('accountListController.openSelectAccount - Undefined modal dismiss event');
        }
      });

    };

    // Link modal with the page through event broadcast.
    $rootScope.$on('updateAccountList', function (data) {

      var modalSelected = localStorage.getLocalStorageValue('accountNumber');

      if (!vm.als.selectedAccount || (modalSelected !== vm.als.selectedAccount.accountNumber)) {

        // Take data from localstorage and update few things
        appState.aoUpdateActiveObjects(modalSelected);

        // From updated rootScope proceed to update of the page
        vm.als.selectedAccount = $.grep(vm.als.accountTypes, function (e) {return e.accNo === modalSelected;})[0];

        $rootScope.$$listeners.updateAccountOverview = [];
      }

    });

    resource.onChanged(function () {
      if (vm.als.selectedAccount) {
        vm.als.getAccountStatus(vm.als.selectedAccount);
      }
      $scope.faqURL = resource.get('soho_migration_faq_url');
    },$scope);

    $scope.$watch('al.als.selectedAccount.accountNumber',function(acct){
      if(acct && vm.viewPermissionResolved){
        changeAccount();
      }
    });

    $scope.as = appState;
    $scope.$watch('as.viewPermissionResolved',function(viewPermissionResolved){
      if(viewPermissionResolved){
         vm.viewPermissionResolved = true;
         getAccountList();
         if($rootScope.ao.allAccounts.length == 1)
          changeAccount();
      }
    });

    function openSohoMigrationPopup() {
      var deferred = $q.defer();
      vm.als.sohoMigrationBrtCheck().then(function(){
          var accNum = localStorage.getLocalStorageValue('accountNumber');
          vm.als.migrationEligibleFlagCheck(accNum).then(function(){
          var currentState = $state.current.name;
          $scope.migrationEligibleKey = vm.als.migrationEligible;
           if(vm.als.sohoMigrationSwitch && $scope.migrationEligibleKey && $scope.migrationEligibleKey != null) {
            $scope.sohoMigrationPopup = $modal.open({
               templateUrl:'views/modals/sohoMigrationPopup.html',
               scope: $scope,
               keyboard: false,
               backdrop: 'static',
               windowClass : 'soho-migration'
             });
             $scope.sohoMigrationPopup.result.then(function () {
                deferred.resolve();
               }, function () {
                 deferred.resolve();
               });
           } else {
              deferred.resolve();
           }
        },
         function(error){
           deferred.resolve();
         });
        },
        function(error){
          deferred.resolve();
        }
      );
      return deferred.promise;
    };
    $scope.soho = {
      isChecked : false
    };
    $scope.closeSohoMigrationPopup = function() {
      if($scope.soho.isChecked) {
        $scope.doNotShowMigrationPopup();
      }
      $scope.sohoMigrationPopup.close();
    }
    $scope.doNotShowMigrationPopup = function () {
      if($scope.soho.isChecked) {
        vm.als.updateUserPreference();
      }
    }
    //Commenting the code as the account dropdown is not loading
    //getAccountList();

  }
})();

(function () {
  'use strict';

  angular.module('totesApp').directive('myrAccountList', accountList);

  accountList.$inject = [];

  /* @ngInject */
  function accountList($log) {
    return {
      scope: {loadingBriteBill: '='},
      templateUrl: 'scripts/modules/accountList/accountList.html',
      restrict: 'EA',
      controller: 'MyrAccountListController',
      controllerAs: 'al',
      bindToController: true
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrAccountListLinkModalController', AccountListLinkModalController);

  AccountListLinkModalController.$inject = ['$scope', '$rootScope', '$browser', '$uibModalInstance', 'localStorage', '$state', '$stateParams', 'myrAccountListService', '$window', 'ute.datalayer.common.service'];

  /* @ngInject */
  function AccountListLinkModalController($scope, $rootScope, $browser, $modalInstance, localStorage, $state, $stateParams, myrAccountListService, $window, dataLayerService) {
    // Function invoked after click in the template
    $scope.selectAccountModal = function (val) {
      dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "selectAccountModal"});
      $rootScope.alsModal = true;
      if ($browser.cookies().deepLinkFlow == 'PPC'){
        $state.go('ppc-singleline');
        $window.document.cookie = "deepLinkFlow" + "=" + null + "; expires=Thu, 01 Jan 1970 00:00:00 UTC";
      }
      localStorage.setLocalStorageValue('accountNumber', val.accountNumber);

      // Broadcast the event
      $rootScope.$broadcast('updateAccountList', val.accountNumber);

      if(myrAccountListService.isOcp == "directLanding"){
      		   myrAccountListService.isOcp = " ";
      		   $state.go("accountInitialization");
      }
       //Run the Qualtrics code
            if(typeof(window.QSI) !=='undefined') {
            setTimeout(function() {
            window.QSI.API.unload();
            window.QSI.API.load();
            window.QSI.API.run();
            },500);
            }

      // close modal
      $modalInstance.close('ok');
      $rootScope.modal = null;
    };

    // OK / Cancel buttons
    $scope.ok = function () {
      $modalInstance.close('ok');
      $rootScope.modal = null;
    };
    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };
  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:myrAccountListService
   * @description
   * # myrAccountListService
   */
  angular.module('totesApp').factory('myrAccountListService', accountListService);

  accountListService.$inject = ['$rootScope','appState','ajax','resource', '$q', '$browser', 'localStorage', 'ute.blocks.persistent.storage.service', 'ute.rogers.datalayer.integration.common.service', '$window'];

  function accountListService($rootScope,appState,ajax,resource, $q, $browser, localStorage, utePersistentStorageService, dataLayerIntegrationService, $window) {

    var service = {
      accountListRaw:null,
      accountTypes:[],
      selectedIndex:0,
      selectedAccount:null,
      errorLoading:null,
      acctInitStateUrl:null,
      isOcp:null,
      isOcpCheck:null,
      processAccountList: processAccountList,
      getAccountList: getAccountList,
      getSelectedAccount: getSelectedAccount,
      updateSelectedAccount: updateSelectedAccount,
      getAccountStatus: getAccountStatus,
      removeAccount:removeAccount,
      updateSelectedAccountByAccountNumber:updateSelectedAccountByAccountNumber,
      checkBillType: checkBillType,
      billTypeFlag: {},
      analyticsUserAccountInfo: analyticsUserAccountInfo,
      getAccountInfo: getAccountInfo,
      migrationEligible : null,
      sohoMigrationBrtCheck : sohoMigrationBrtCheck,
      sohoMigrationSwitch : false,
      sohoPostMigrationSwitch : false,
      updateUserPreference : updateUserPreference,
      migrationEligibleFlagCheck : migrationEligibleFlagCheck,
      hasActiveWirelessAccount: false,
      activeWirelessAccountListForIna : []
    };

    return service;

    ///////////////////////////////////////////////////////////////
    function processAccountList (raw) {
      try {
        raw.total = raw.accountList.length;
        service.hasActiveWirelessAccount = false;

        if (raw.total <= 0) {			// WARNING - Should raw.total be used at all???
          //if no account, redirect to the account linking page
          appState.aoFlushScope();
          raw.total = 0;
          raw.result = 'redirect';
          $rootScope.ao.raw = raw;

        } else if (raw.total > 0) {
          // successful data catch
          var wirelessAccountListForINA =[]; // this is for INA service - find the list of active wireless accounts to pass request as INA service
          for (var i = 0, l = raw.total; i < l; i++) {		// custom data manipulation
            var _tmp = {};
            _tmp = raw.accountList[i];
            _tmp.accountOwner = raw.accountList[i].accountName.firstName + ' ' + raw.accountList[i].accountName.lastName;
            raw.accountList[i] = _tmp;
            _tmp.payNow = false;
            if(_tmp.accountStatus !== 'Suspended' && (_tmp.accountStatus !== 'Cancelled') && (_tmp.accountStatus !== 'Deactive')){
              _tmp.payNow = true;
            }
            if (_tmp.accountStatus === 'Active' && (_tmp.accPdtType === 'WL' || _tmp.accPdtType === 'WL_C')) {
              service.hasActiveWirelessAccount = true;
              wirelessAccountListForINA.push({"accountNumber": ''+ raw.accountList[i].accountNumber + ''});
            }
          }
          service.activeWirelessAccountListForIna = wirelessAccountListForINA;
          //console.log("final activeWirelessAccountListForIna length :" + service.activeWirelessAccountListForIna.length);
          if(service.activeWirelessAccountListForIna.length > 0){
            console.log("invokeEnterpriseTokenApi !tokenSetB" + !$browser.cookies()["loggedInB"] );
            if(!$browser.cookies()["loggedInB"]){
              ajax.invokeEnterpriseTokenApi(service.activeWirelessAccountListForIna, uuidv4(), uuidv4());
              }
          }
          // store for later and split up the raw data into user and permissions
          appState.aoFlushScope();
          raw.result = 'success';
          $rootScope.ao.raw = raw;
          $rootScope.ao.allAccounts = raw.accountList;
          raw.data = raw.accountList;									// TODO review all functions that deal with list and fix that to allAccounts

          $rootScope.permissions.allPermissions = raw.permissions;
          $rootScope.permissions.permissionActiveIndex = $rootScope.permissions.permissionActiveIndex ? $rootScope.permissions.permissionActiveIndex : 0;
          $rootScope.permissions.permissionActive = $rootScope.permissions.permissionActive ? $rootScope.permissions.permissionActive : $rootScope.permissions.allPermissions[0];

          if (localStorage.getLocalStorageValue('banNotFound') == 'Y') {
            localStorage.setLocalStorageValue('accountNumber', raw.accountList[0].accountNumber);
            $window.localStorage.removeItem('banNotFound');
          }

          //TODO: dashboards require an account, account overview requires a process account.. we shouldn't be swapping them around
          if(!service.selectedAccount){
            service.selectedAccount = raw.accountList[0];
          }
        } else {
          appState.aoFlushScope();
          raw.total = -1;
          raw.result = 'fail';
          $rootScope.ao.raw = raw;
        }
      } catch (err) {
        appState.aoFlushScope();

        if (!raw) {
          raw = {};
        }
        raw.total = -1;
        raw.result = 'fail';
        $rootScope.ao.raw = raw;
      }
      return raw;
    }
    function uuidv4() {
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
              v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          })}
    function getAccountStatus(_tmp) {

      _tmp.accountStatusSimple = 'Active';
      _tmp.accountStatusError = '';
      _tmp.accountCancelled = false;

      if (_tmp.accountStatus === 'Suspended') {
        _tmp.accountStatusSimple = 'Error';
        _tmp.accountStatusModalMessage = 'acc_overview_account_suspended_2';

        if (_tmp.accountTypeNumber === '9' || _tmp.accountTypeNumber === 9) {
          _tmp.accountStatusError = resource.get('acc_overview_pay_as_you_go_suspended');
        } else {
          if ($rootScope.isDealer || $rootScope.isCare) {
            _tmp.accountStatusError = resource.get('acc_overview_account_overdue_one_view');
          }
          else {
            _tmp.accountStatusError = resource.get('acc_overview_account_overdue');
          }

        }

      } else {
        if (!!_tmp.postpaidAccountBalance && !_tmp.isCLM && !_tmp.isCLMExceeded) {
          _tmp.isCLM = (Number(_tmp.postpaidAccountBalance.creditLimit) > 0);
          _tmp.isCLMExceeded = _tmp.postpaidAccountBalance.exceedCreditLimit;
        }

        if (_tmp.isCLM && _tmp.isCLMExceeded) {
          _tmp.accountStatusSimple = 'Warning';
          _tmp.accountStatusError = resource.get('acc_selection_clm');
          _tmp.accountStatusModalMessage = 'acc_overview_account_exceeded';
          _tmp.accountStatus = 'CLMExceeded';

        } else {
          if (_tmp.accountStatus === 'Cancelled' || _tmp.accountStatus === 'Closed' || _tmp.accountStatus === 'Inactive' || _tmp.accountStatus === 'Expired' || _tmp.accountStatus === 'Deactive') {
            _tmp.accountStatusModalMessage = 'acc_overview_account_cancelled';
            switch (_tmp.accountTypeNumber) {
              case 9:
                _tmp.accountStatusSimple = 'Warning';
                _tmp.accountStatusError = resource.get('acc_overview_pay_as_you_go_cancelled');
                break;
              default:
                _tmp.accountStatusSimple = 'Warning';
                _tmp.accountStatusError = resource.get('acc_overview_account_limited');
                _tmp.accountCancelled = true;
                break;
            }
          }
        }
      }

      return _tmp;
    }
    function getAccountList(request, callback, errorCallBack) {
      // Always make ajax call to get fresh data

      function processList(data) {
        // Process data
        data = service.processAccountList(data);
        if (data.result === 'success' || data.result === 'redirect' || data.result === 'fail') {
          if (data.result === 'fail') {
            service.errorLoading = 'Failed to load account list';
          }
          return callback(data);
        }
      }

      function callForAccountList() {
        service.errorLoading = null;

        ajax.getAccountList(request).then(
          function (data) {
            var accounts=[];
            if((data.accountList) && (data.accountList.length >=1)) {
              for (var i = 0; i < data.accountList.length; i++) {
                accounts.push(data.accountList[i].accountNumber);
              }
            }
            localStorage.setLocalStorageValue('accounts', accounts);
            var usrPdt = data.userProduct;
            if(usrPdt === 'NP')
              localStorage.setLocalStorageValue('pInd', 'N');
            else if (usrPdt === 'WL')
              localStorage.setLocalStorageValue('pInd', 'W');
            else if (usrPdt === 'C')
              localStorage.setLocalStorageValue('pInd', 'C');
            else if (usrPdt === 'WL_C')
              localStorage.setLocalStorageValue('pInd', 'B');

            $rootScope.$emit('initializeMbhLauncher', data);
            processList(data);
//            if(data.migrationEligible) {
//              service.migrationEligible = data.migrationEligible;
//            }
          },
          function (error) {
              if (errorCallBack) {
          		  errorCallBack();
          		}
            //redirect users to the maintenance page
            //ajax.abort();
            if(error && error.data && error.data.status !== 401) {
              if (request.refresh === false) {
                appState.showMaintenance();
              } else {
                service.errorLoading = resource.get('acc_overview_oops');
                if (errorCallBack) {
                  errorCallBack();
                }
              }
            }
          });

        $rootScope.reserveDeviceAvbl = false;
        ajax.getSelfserveConfig().then(
        function (response) {
            $rootScope.reserveDeviceAvbl = response.reserveDeviceAvbl;
           }
        );
        /*ajax.checkReserveDevice().then(
          function(data){
            if (data.isReserved) {
              $rootScope.reserveDeviceAvbl = true;
            }
          }
        );*/
      }

      if ($rootScope.ao.raw && $rootScope.ao.raw.cachedResultInfo && !$rootScope.ao.raw.cachedResultInfo.expired) {
        processList($rootScope.ao.raw);
      } else {
        callForAccountList();
      }
    }

    function removeAccount(accountNum){

      service.accountTypes = service.accountTypes.filter(function( obj ) {
        return obj.accountNumber !== accountNum;
      });
      $rootScope.ao.raw.accountList = $rootScope.ao.raw.accountList.filter(function(obj){
        return obj.accountNumber !== accountNum;
      });
      $rootScope.ao.allAccounts = service.accountTypes;

      if(accountNum == service.selectedAccount.accountNumber){
        service.selectedAccount = service.updateSelectedAccount(0);
        service.selectedIndex = 0;
        $rootScope.ao.accountActiveIndex = 0;
      }

    }
    function getSelectedAccount() {
      // active account
      if (service.accountTypes === null) {
        //return false;										// TODO - make call getAccountList
      } else {
        return (service.selectedAccount);
      }
    }

    function updateSelectedAccountByAccountNumber(accountNumber){
      for(var i = 0 ; i < service.accountTypes.length ; i ++){
        if(service.accountTypes[i].accountNumber == accountNumber){
          updateSelectedAccount(i);
        }
      }
    }

    function updateSelectedAccount(index) {

      if (service.accountTypes === null) {
        // Check rootscope storage
        if ($rootScope.ao.allAccounts !== null) {

          service.selectedIndex = index;
          this.accountTypes = $rootScope.ao.allAccounts;
          this.selectedAccount = this.accountTypes[index];		// update private data
          return (this.selectedAccount);
        } else {
          return false;									// TODO - make call getAccountList
        }

      } else {
        service.selectedAccount = service.accountTypes[index];			// update private data
        service.selectedIndex = index;
        return (service.selectedAccount);
      }
    }

    function checkBillType(accountNumber){
        var deferred = $q.defer();
        var request = {
          'accountNumber': accountNumber,
          'applicationId': 'SMB'
        }

        if(service.billTypeFlag && service.billTypeFlag[accountNumber] != undefined) {
          deferred.resolve(service.billTypeFlag[accountNumber]);
        } else {
            ajax.checkBillType(request).then(function(data) {
                $rootScope.billTypeValue = data.billType;
                service.billTypeFlag[accountNumber] = data;
                deferred.resolve(service.billTypeFlag[accountNumber]);
            }, function(error) {
               $rootScope.billTypeValue = 'E_BILL';
               deferred.resolve('E_BILL'); //if calls fails, not sure whether its paper or ebill, so we are taking as ebill and will hide OLB
            });
        }
       return deferred.promise;
    }

    function analyticsUserAccountInfo(){
      var cookieStore = $browser.cookies();
      var userName;
      if (localStorage.getLocalStorageValue('ute.rogers.signin.user')) {
        var userDetail = JSON.parse(localStorage.getLocalStorageValue('ute.rogers.signin.user'));
        if(userDetail.userName){
          userName = userDetail.userName;
        }
      }
      var accountNumber = service.getAccountInfo(utePersistentStorageService.getFromSession('accountNumber'), cookieStore.accountNumber, utePersistentStorageService.getFromLocal('accountNumber'));
      var userId = service.getAccountInfo(utePersistentStorageService.getFromSession('userName'), cookieStore.userName, userName);
      var accountInfo = {
        accountNumber: accountNumber,
        userName: userId,
        userType: 'BSS-Standard'
      };
      if($rootScope.user.isAuthenticated){
        dataLayerIntegrationService.setUserAccountInfo(accountInfo);
      }
      utePersistentStorageService.putToSession('flowType', 'Selfserve');
    }

    function getAccountInfo(sessionValue, cookieValue, localValue) {
     if (sessionValue && !(sessionValue === null && sessionValue === undefined)) {
       return sessionValue;
     } else if (cookieValue && !(decodeURIComponent(cookieValue) === null && decodeURIComponent(cookieValue) === 'undefined')) {
       return cookieValue;
     } else if (localValue && !(localValue === null && localValue === undefined)) {
       return localValue;
     }
    }

    function updateUserPreference(){
     var guid = $browser.cookies()['guid'];
     var userName = $browser.cookies()['userName'];
     var accNum = localStorage.getLocalStorageValue('accountNumber');
     var request = {
        userPreference : 'Y',
        guid : guid,
        userName : userName,
        accountNumber : accNum
      }
      ajax.updateUserPreferenceInfo(request);
    }

     function sohoMigrationBrtCheck(){
      return ajax.getBrtSwitches().then(
      function(data) {
        angular.forEach(data, function(obj, key) {
            if (obj.id == 'BSS_TO_CSS_MIGRATION') {
               service.sohoMigrationSwitch = obj.switchIsOn ? true : false;
            }
            if(obj.id == 'BSS_TO_CSS_POST_MIGRATION'){
                service.sohoPostMigrationSwitch = obj.switchIsOn ? false : true;
            }
        });
      },function(error){});
     }

     function migrationEligibleFlagCheck(acctnumber){
        var deferred = $q.defer();
        var selectedAccnum = acctnumber;
        var guid = $browser.cookies()['guid'];
        var userName = $browser.cookies()['userName'];
        var request = {
            accountNumber : selectedAccnum,
            email : userName,
            guid : guid
          };
      ajax.getMigrationEligibleFlag(request).then(function(response) {
        service.migrationEligible = response.migrationFlag;
        deferred.resolve();
       },function(error){
        deferred.reject();
       });
       return deferred.promise;
     }
  }

}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name accountOverview
   * @description
   * # account overview service and controller
   * Controller of the totesApp
   */

  angular.module('totesApp').controller('MyrAccountOverviewController', AccountOverviewController);

  AccountOverviewController.$inject = ['$scope', '$rootScope','$browser','btnSettings','appState', 'myrAccountOverviewService', 'userLanguage', 'settings', '$modal',
    'ajax', '$window', 'localStorage', 'myrNotificationBannerService','myrMyServicesService','myrAccountListService','myrAccountBalanceService','myrRgclService','myrBriteBillService', 'resource','uccBanner','brtCheck', 'uteBillService','$location', '$state', '$timeout', 'myrSigninService', 'ute.datalayer.common.service', 'sessionStorage', '$cookieStore'];

  /* @ngInject */
  function AccountOverviewController($scope, $rootScope,$browser,btnSettings, appState, accountOverviewService, userLanguage, settings, $modal,
                                     ajax, $window, localStorage, notificationBannerService,myrMyServicesService,myrAccountListService,myrAccountBalanceService,rgclService,myrBriteBillService,resource,uccBanner,brtCheck, uteBillService,$location, $state, $timeout, signinService, dataLayerService, sessionStorage, $cookieStore) {
    var vm = this;

    notificationBannerService.cleanBanner('linkedMessage');
    notificationBannerService.cleanBanner('successMessage');

    // Scope variables
    vm.appState = appState;
    vm.btnSettings = btnSettings;
    vm.btnStatus =  $window.btnStatus;

    vm.mss = myrMyServicesService;
    vm.als = myrAccountListService;
    vm.mab = myrAccountBalanceService;
    //vm.mrs = myrRewardsService;
    vm.bb = myrBriteBillService;

    vm.rgcl = rgclService;

    vm.loadingDataIndicator = false;
    vm.hasWcocBrt = false;

    vm.preCleanCall = preCleanCall;
    vm.postToRogersCancelled = postToRogersCancelled;
    vm.payBill = payBill;
    vm.viewHistory = viewHistory;
    vm.runRogersProfile = runRogersProfile;
    vm.redirectToMidMarket = redirectToMidMarket;
    vm.redirectToFitUrl = redirectToFitUrl;
    vm.triggerTrackData = triggerTrackData;

    vm.initBrt = initBrt;

    vm.mbhUrls = {};
    vm.hasCommunitiesAccess = false;

    $rootScope.updatedUserEmail = $browser.cookies().userEmailUpdated;
    $rootScope.launcherPortalUserSeg = $browser.cookies().LAUNCHER_PORTAL_USER_SEGMENTS;

    $window.document.cookie = 'updateEmail=' + '' + ';domain=' + '.rogers.com' + ';path=' + '/' + ';expires=Thu, 01 Jan 1970 00:00:00 GMT';
    $window.document.cookie = 'userEmailUpdated=' + '' + ';domain=' + '.rogers.com' + ';path=' + '/' + ';expires=Thu, 01 Jan 1970 00:00:00 GMT';

    vm.errorMessage = null;

    var errorMessages = {
      'accountList': null,
      'summary': null,
      'balanceDetails': null,
      'loyalty': null
    };

    $scope.language = userLanguage();
    $scope.portalUserSeg = $browser.cookies().LAUNCHER_PORTAL_USER_SEGMENTS;
    $scope.boldChat = {
        suspendAcct: {
          en: {
            cbid: 'S_BSS_Login',
            dynamicDivId: 'S_BSS_Account_Suspended_div',
            chatButtonClass:'chatButtonAccountSuspendedEn'
          }
        }
    };

    //RBIB-298

    var AnalyticsDataLayer = {
      "account": {
        "userName": $browser.cookies().userName,
        "BAN": localStorage.getLocalStorageValue('accountNumber'),
        "CTN": sessionStorage.getSessionStorageValue('selectedSubscriberNumber'),
        "userType": "consumer",
        "type": "<[account type]|[account sub type]|[IDV or SOHO identifier]|[product type]>",
        "products": {"lob": "", "quantity": ""}
      },
      "page": {
        "name": "accountOverviewBanner",
        "hierarchy": ["selfserve","accountoverview"],
        "language": $scope.language,
        "province": sessionStorage.getSessionStorageValue('userProvince')
      }
     }

    $(document).ready(function() {

      $("body").on('DOMSubtreeModified', ".owl-wrapper", function() {

        $(this).children('.item').unbind().click(function(){
          var imagePath = $(this).find('img').attr('src');
          AnalyticsDataLayer.page.name = imagePath.split('/').slice(-1)[0].split('.').slice(-2)[0].split('_').join(' ');
          dataLayerService.configure({advance: {mappingKey: {'accountOverBanner':AnalyticsDataLayer}}})
          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "accountOverBanner"});
        });

      });

    });

    //RBIB-298

    vm.isDevQa = settings.isDevQa;

    $rootScope.$on('languageChanged', function (){
          $scope.language = userLanguage();
    });


	if($rootScope.isDealer || $rootScope.isCare){
      //for Message box
      var messageBoxDom = function () {
        $scope.rhmMsg='<div>'
          +resource.get("order_though_oasys")
          +"</div><div class='green-text'><strong>"+resource.get("to_book_in_home_assessment")
          +'</strong></div><div>'+resource.get("login_to")
          +' <strong>'
          +resource.get("sgi")+'</strong></div>';
      }
      messageBoxDom();
      resource.onChanged(function () {
        messageBoxDom();
      }, $scope);
    }
    function errorMessageCheck() {

      errorMessages.accountList = myrAccountListService.errorLoading;
      errorMessages.summary = myrMyServicesService.errorLoading;
      errorMessages.balanceDetails = myrAccountBalanceService.errorLoading;
      // errorMessages.loyalty = myrRewardsService.errorLoading;

      vm.errorMessage = '';

      $.each(errorMessages, function (key, value) {
        if (value) {
          vm.errorMessage = value;
        }
      });

    }
    function loadingCheck(){
      if(!vm.mss.loadingData && !vm.mab.loadingData){

        vm.loadingDataIndicator = false;

        errorMessageCheck();

      }
        getWcocPermissions();
    }


    /* var dataObj = angular.fromJson(data);*/
     $scope.isSafariBrowser = function(){
       var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');
       return (isSafari);
     }

    function initBrt(){
      if(localStorage.getLocalStorageValue('accountNumber') != null){
        $location.search('directLanding', null);
        myrAccountListService.isOcp="";
        myrAccountListService.isOcpCheck="";
      }
      brtCheck.uccP1();
      brtCheck.cam();
      brtCheck.eSimSwitch();
      brtCheck.ColonyPortalSwitch();

      uccBanner.getUccLinks().then(
        function (data) {
          $scope.uccLinks = data;
        },
        function (error) {

        }
      );
    }

    function getWcocPermissions(){
        ajax.getPermissions().then(
            function (response) {
                if (response && response.permissions && Array.isArray(response.permissions)) {
                    vm.hasWcocBrt = response.permissions.some(function (elem) {
                        if (elem.permission === 'WCOC_BRT') {
                              var flag = false;
                              var wcocAccountDetails = vm.mss.wcocAccountOverviewDetails;
                              if (wcocAccountDetails.accountInfo != undefined &&  wcocAccountDetails.accountInfo.status.toLowerCase() != 'cancelled' && wcocAccountDetails.accountType === 21) {
                                    angular.forEach(wcocAccountDetails.subList, function (value, index) {
                                    if(value.subStatus.toLowerCase() != 'cancelled' && value.subType === 'CTN'){
                                     flag = true;
                                    }
                                 });
                              }
                              return flag;
                        }
                    });
                }
            },
            function () {
            vm.hasWcocBrt = false;
            }
        );
    }


    $scope.getAccountUCCDetails = function() {

      var account = vm.als.selectedAccount.accountNumber;
      var userName = $browser.cookies().userName;

      $window.document.cookie = 'userName=' + userName + ';domain=' +'.rogers.com' + ';path=' + '/';

      ajax.getUCCSubscriberList(account).then(
        function(data) {
          if(data){
            if (data.isFMCCTNFound == true){
              //PCR-245 Modify the logic to redirect the customers to UCC portal
              //if(data.ctnList.length > 0){
                $window.document.cookie = 'enterpriseID=' + data.enterpriseID + ';domain=' +'.rogers.com' + ';path=' + '/';
                if(settings.isDevQa){
                  $window.location.href = $scope.uccLinks.qa;
                }else{
                  $window.location.href = $scope.uccLinks.prod;
                }
              /*}else{
                marketingRedirect();
              }*/
            }else{
              marketingRedirect();
            }
          }else{
            marketingRedirect();
          }
        },
        function(error) {
          marketingRedirect();
        }
      );

      function marketingRedirect(){
        if(userLanguage() == 'en'){
          $window.location.href = $scope.uccLinks.marketen;
        }else if(userLanguage() == 'fr'){
          $window.location.href = $scope.uccLinks.marketfr;
        }
      }
    };

    $scope.getJwtToken = function(redirectLabel) {

      var sessionlanguage = sessionStorage.getSessionStorageValue('userLanguage');
      var cookielanguage = getCookie('language');
      if(!cookielanguage || cookielanguage == 'null' || cookielanguage == 'undefined'){
        setCookieLanguage('language',sessionlanguage);
      }
      var redirectionUri = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
      if(redirectionUri.contains("-bss")){
        redirectionUri = redirectionUri.replace("-bss","");
      }
      redirectionUri = redirectionUri +"/wcoc/bss/manage-users";
      $window.open(redirectionUri, "_self");

      function setCookieLanguage(cookieName, cookieValue) {
        var _domain = window.location.hostname.replace('www', '');
        if (_domain !== '.rogers.com') {
          document.cookie = cookieName + '=' + cookieValue + ';domain=' + _domain + ';path=/';
        }
        document.cookie = cookieName + '=' + cookieValue + ';domain=.rogers.com;path=/';
        document.cookie = cookieName + '=' + cookieValue + ';path=/';
      }

      function getCookie(cookieName) {
           const cDecoded = decodeURIComponent(document.cookie);
            const cokkieArray = cDecoded.split(";, ");
            var result = null;
            cokkieArray.forEach(function(element, key) {
                if(element.indexOf(cookieName) == 0){
                  result = element.substring(cookieName.length + 1);
                }
            });
            return result;
      }
    /*ajax.getWcocJwtToken().then(
        function(data) {
        localStorage.setLocalStorageValue('wcocToken', data);
        var redirectionUri = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
        if(redirectionUri.contains("-bss")){
            redirectionUri = redirectionUri.replace("-bss","");
        }
        redirectionUri = redirectionUri +"/wcoc/bss/manage-users";
         if(redirectLabel === "restore"){
            //redirectionUri = redirectionUri + '/web/wcoc/#/restore-data/'+userLanguage().toUpperCase()+'/BS?entryId=D';
            $window.open(redirectionUri, "_self");
          }
          else if(redirectLabel === "addManage"){
            //redirectionUri = redirectionUri + '/web/wcoc/#/manage-users/'+userLanguage().toUpperCase()+'/BS?entryId=D';
            $window.open(redirectionUri, "_self");
          }
        },
        function(error) {
               console.log(error);
                }
        ); */
    };



    /*var rgclCheck = function(){
     if(!vm.rgcl.loadingData && !vm.mss.loadingData){
     if(vm.mss.myOtherServicesListFinal){
     $.grep(vm.mss.myOtherServicesListFinal, function (e) {return e.title === "myaccoverview_get_nhl";})[0].isVisible = !rgclService.rgclEligible;
     }
     }

     };*/
    /*

     var getMaintenanceSettings = function () {
     //if ($rootScope.ao.raw === null) {
     if ($rootScope.maintenance.ACCOUNT_OVERVIEW_ON_MAINTENANCE === undefined) {
     //first time check signin language

     // Make call to server (Should not need to tho)
     var request = {
     refresh: false
     };

     var maintenanceSettingsResponse = function (_tmp) {
     accountOverviewService.processMaintenanceSettings(_tmp, true);
     };

     accountOverviewService.getMaintenanceSettings(request, maintenanceSettingsResponse);

     } else {
     // grab data from rootscope and have the function process that
     accountOverviewService.processMaintenanceSettings($rootScope.maintenance, true);
     }

     };

     */

    var getMaintenanceSettings = function () {
      var request = {
        refresh: false
      };

      var maintenanceSettingsResponse = function (_tmp) {
        accountOverviewService.processMaintenanceSettings(_tmp, true);
      };

      accountOverviewService.getMaintenanceSettings(request, maintenanceSettingsResponse);

      return null;
    };

    //RBIB-28504
    var getMBHUrls = function () {
      $scope.$watch(function () {
        return $rootScope.portalIds;
      }, function (newVal) {
        if (newVal && newVal.length > 0) {
          vm.hasCommunitiesAccess = false;
          for (var i = 0; i < newVal.length; i++) {
            if (newVal[i] === 'SFDC') {
              vm.hasCommunitiesAccess = true;
            }
          }
          signinService.mbhUrlConfig().then(function (urlResponse) {
            vm.mbhUrls = urlResponse;
          });
        }
      });
    };


    $scope.$watch('ao.mss.loadingData',function(){
      loadingCheck();
      //rgclCheck();
    });

    $scope.$watch('ao.mab.loadingData',function(){
      loadingCheck();
    });

    $scope.$watch('ao.mrs.loadingData',function(){
      loadingCheck();
    });

    /*$scope.$watch('ao.rgcl.loadingData',function(){
     rgclCheck();
     });*/

    try {
      $scope.$watch('ao.als.selectedAccount.accountNumber', function (val) {

        vm.loadingDataIndicator = true;

          //vm.bb.getBriteBillList(val);

        // vm.rgcl.callGetSegmentationForRGCL(val);

        if (vm.als.selectedAccount.accountStatus === 'Suspended' || vm.als.selectedAccount.accountStatus === 'Cancelled') {
          vm.rgcl.setIsAccountCanceledOrSuspended(true);
        } else {
          vm.rgcl.setIsAccountCanceledOrSuspended(false);
        }

        //For Displaying Groups and Reporting tab
        $rootScope.displayGroupsReporting = true;
        var accountNumber = val;
        if(accountNumber.length == 12){
          $rootScope.displayGroupsReporting = false;
        } else {
          uteBillService.brtCheckEpost(accountNumber).then(function(ePostStatus) {
            if(ePostStatus == 'true'){
                $rootScope.displayGroupsReporting = false;
            }else{
                $rootScope.displayGroupsReporting = true;
            }
          });
        }

        /*if (_tmp.result === 'redirect') {
         appState.noLinking = false;
         if($rootScope.isConsumer){
         appState.switchView('guestoverview');
         } else {
         appState.switchView('/oneViewInterface');
         }
         } else if (_tmp.result === 'fail') {
         if (vm.als.selectedAccount.accountStatus === 'Suspended' || vm.als.selectedAccount.accountStatus === 'Cancelled') {
         vm.rgcl.setIsAccountCanceledOrSuspended(true);
         } else {
         vm.rgcl.setIsAccountCanceledOrSuspended(false);
         }
         }*/
      });
    } catch(e) {
    }

    function preCleanCall() {
      // Notify server to prepare fresh data
      var postData = {};
      postData.accountNumber = $rootScope.ao.accountActive.accountNumber;
      ajax.notifyServerLOBchange(postData);

      return true;
    }


    // As for dealer and care the accountActive becomes null when coming back from wireless
    // Need to reinitialize from selectedAccount
    /*if(($rootScope.isDealer || $rootScope.isCare) && !$rootScope.ao.accountActive) {

     if(appState.selectedAccount) {
     $rootScope.ao.accountActive = appState.selectedAccount;
     }
     }*/
    function postToRogersCancelled() {
      if($rootScope.isDealer || $rootScope.isCare){
        // For dealer and care the viewbill is displayed only if it is brite bill, so no need to redirect to legacy
        $window.location.href = '../../../business/ute/smb/transactions/uteBillingAndPayment';
      } else {
        $window.location.href = '../../../business/ute/smb/transactions/uteBillingAndPayment';
      }
    }

    //RBIB-28504
    var addInternet = function () {
      $scope.$watch(function () {
        return $rootScope.portalIds;
      }, function (newVal) {
        if (newVal && newVal.length > 0) {
          $scope.isCommunityUser = false;
          for (var i = 0; i < newVal.length; i++) {
            if (newVal[i] === "SFDC") {
              $scope.isCommunityUser = true;
              break;
            }
          }
        }
      });
    }

    function payBill() {
      //localStorage.setLocalStorageValue('accountTypeNumber', $scope.selectedAccount.accountTypeNumber);
      ////appState.switchView('paynow/' + $scope.selectedAccount.accountNumber + '/' + $scope.selectedAccount.accountTypeNumber);

      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
      appState.switchView('/makeAPayment');
    }

    function viewHistory() {
      localStorage.setLocalStorageValue('accountTypeNumber', myrAccountListService.selectedAccount.accountTypeNumber);
      ////appState.switchView('paynow/' + $scope.selectedAccount.accountNumber + '/' + $scope.selectedAccount.accountTypeNumber);
      appState.switchView('/payHistory');
    }

    function runRogersProfile() {
      $window.location.href = '../../../business/ute/smb/transactions/uteMyRogersProfile?setLanguage=' + userLanguage();
    }



  $scope.brtWhitelistvalue = false;
  ajax.getBrtSwitches().then(
      function (data) {
        angular.forEach(data, function (obj, key) {
              if(obj.id == "BRT_NON_MSD"){
                var usernameDetails = JSON.parse(sessionStorage.getSessionStorageValue('accountInfo'));
                var requestData ={
                  userId : usernameDetails.userName,
                  brtSwitch : obj.id
                }
                ajax.gethasPermissions(requestData).then(
                  function (data) {
                    $scope.brtWhitelistvalue = data.hasBrtPermission;
                  })
               }
        });
      });

  function redirectToMidMarket() {

    var orderSearchRefId;
    orderSearchRefId = (sessionStorage.getSessionStorageValue("orderSearchRefId") != null)?sessionStorage.getSessionStorageValue("orderSearchRefId"):"";

    ajax.saveOrderSearch({"refId": orderSearchRefId, "ctn": "", "orderType": "ORDERSEARCH"}, vm.mbhUrls.saveOrderSearch).then(function(response){
      sessionStorage.setSessionStorageValue("orderSearchRefId", response.refId);
      orderSearchRefId = response.refId;
      if($scope.brtWhitelistvalue) {
        //SBP URL
        $window.open(vm.mbhUrls.sbpInquiry + orderSearchRefId, "_blank");
      } else {
        //Midmarket URL
        $window.open(vm.mbhUrls.orderInquiry + orderSearchRefId, "_blank");
      }
    });

    triggerTrackData(4);

    /*var BRTUrl;
    if($scope.brtWhitelistvalue) {
      //SBP URL
      BRTUrl = vm.mbhUrls.sbpInquiry;
    } else {
      //Midmarket URL
      BRTUrl = vm.mbhUrls.orderInquiry;
    }
    $window.open(BRTUrl + orderSearchRefId, "_blank");*/
  }

  function replaceLanguageParam(url) {
    var lang = userLanguage();
    if(lang == "en") {
      lang = "en_US";
    }

    if(url.includes('en_US') && lang == 'en_US') {
      return url;
    }

    var returnVal = url.replace("language=en", "language=" + lang);
    return returnVal.replace("language=fr", "language=" + lang);
  }

  function redirectToFitUrl(index, fitUrl) {
    triggerTrackData(index);
    $window.open(replaceLanguageParam(fitUrl), "_blank");
  }

    function triggerTrackData(index) {
      dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "fitEntryPoint" + index});
    }

    if (appState.afterPaymentRefresh) {
      appState.afterPaymentRefresh = false;
      $window.location.reload(true);
    }

    brtCheck.dataManagerMigration();
    brtCheck.eSimSwitch();

    vm.als.analyticsUserAccountInfo();

    getMaintenanceSettings();

    vm.initBrt();

    getMBHUrls();


     /*  <<<<<<<<<<<<<<<<<<  same bit of code on Guest overview page - Start
     // Setup Thank you / Community links modal
     var thanksModal = function () {
     // localhost exception
     var serverHack = '/web/totes';
     if (settings.isLocal) {
     serverHack = '';
     }

     $rootScope.modal = $modal.open({
     templateUrl: serverHack + '/views/modals/thankYouModalCtrl.html',
     controller: 'MyrThankYouModalController',
     size: 'thankYouDesign',
     backdrop: 'static',
     backdropClass: 'bkg-modal',
     resolve: {}
     });


     $rootScope.modal.result.then(function () {
     // on OK behaviour
     $window.location.href = 'http://communityforums.rogers.com/t5/community/categorypage/category-id/EnglishCommunity?profile.language='+ userLanguage();
     }, function () {
     // on Cancel behaviour
     });
     };
     // Show modal windows in right order
     setTimeout(function(){
     // Open Thank you / Community links modal
     if (appState.newRegistration) {
     appState.newRegistration = false;
     thanksModal();        // 200ms delay
     }
     }, 150);
     ////  <<<<<<<<<<<<<<<<<<  same bit of code on Guest overview page - End
     //*/
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrAccountOverviewService', accountOverviewService);

  accountOverviewService.$inject = ['$rootScope', 'ajax', 'resource', 'appState', 'myrMyServicesService','myrAccountBalanceService','myrAccountListService','myrBriteBillService'];

  /* @ngInject */
  function accountOverviewService($rootScope, ajax, resource, appState,myrMyServicesService,myrAccountBalanceService,myrAccountListService,myrBriteBillService) {

    return {
      // listing

      briteBillError: null,
      storedAccountList: null,
      storedSummary: null,

      accountBalance: myrAccountBalanceService.accountBalance,
      getSelectedAccount:myrAccountListService.getSelectedAccount,
      getAccountBalance:myrAccountBalanceService.getAccountBalance,
      getBalanceDetails:myrAccountBalanceService.getBalanceDetails,
      getAccountList:myrAccountListService.getAccountList,
      clearAccountDetails:myrMyServicesService.clearAccountDetails,
      getAccountDetails:myrMyServicesService.getAccountDetails,
      getSelectedAccountDetail:myrMyServicesService.getSelectedAccountDetail,
      getSubscriptions:myrMyServicesService.getSubscriptions,
      runService:myrMyServicesService.runService,
      getServicePath:myrMyServicesService.getServicePath,
      resetCallingAccountDetails:myrMyServicesService.resetCallingAccountDetails,
      updateMessage:myrMyServicesService.updateMessage,
      updateSuccessMessage:myrMyServicesService.updateSuccessMessage,
      getBriteBill:myrBriteBillService.getBriteBill,
      getBriteBillListOfBills:myrBriteBillService.getBriteBillListOfBills,
      getBrtSwitches:myrBriteBillService.getBrtSwitches,
      britebill:myrBriteBillService.britebill,

      purgeAccountList: function () {
        // Kill rootscope
        appState.aoFlushScope();
        // Kill locals
        /*_accountTypes = null;
        _selectedAccount = null;
        _accountDetails = null;*/
      },

      processMaintenanceSettings: function (raw) {

        // Clean up maintenance object into key > value array
        var TMPmaintenance = [];
        for (var a = 0, b = raw.length; a < b; a++) {		// custom data manipulation
          var _tmpObj = {};
          _tmpObj = raw[a];
          TMPmaintenance[_tmpObj.name] = _tmpObj.ruleValid;
        }

        $rootScope.maintenance = TMPmaintenance;
        $rootScope.altMaintenance = TMPmaintenance;

        // return only the index 4 (SITE_ON_MAINTENANCE) to the caller
        return raw[4];

      },
      getMaintenanceSettings: function (request, callback) {
        // Always make ajax call to get fresh data
        var _this = this;
        ajax.getMaintenanceSettings(request).then(
          function (data) {
            // Process data

            //data[4].ruleValid = false;

            data = _this.processMaintenanceSettings(data);
/*
            $rootScope.altMaintenance.TV_ON_MAINTENANCE = true;
            $rootScope.altMaintenance.INTERNET_ON_MAINTENANCE = true;
*/

            if (data.name && data.name === 'SITE_ON_MAINTENANCE')/// site on maintenance nothing is available
            {
              $rootScope.maintenance.SITE_ON_MAINTENANCE = data.ruleValid;
              if ($rootScope.maintenance.SITE_ON_MAINTENANCE === true) {
                appState.switchView('underMaintenance');
              }
            }

            if ($rootScope.maintenance.SITE_ON_MAINTENANCE !== undefined) {

              return callback(data);

            } else {
              // this should not happen
            }

          }, function (error) {

            //redirect users to the maintenance page
            //ajax.abort();
            appState.showMaintenance();

          }
        );
      }
    };
  }
})();

angular.module('mdo-angular-cryptography', [])
    .provider('$crypto', function CryptoKeyProvider() {
        var cryptoKey;

        this.setCryptographyKey = function(value) {
            this.cryptoKey = value;
        }

        this.$get = [function(){
            return {
                cryptoKey: this.cryptoKey,

                encrypt: function(message, key) {

                    if (key === undefined) {
                        key = this.cryptoKey;
                    }

                    return CryptoJS.AES.encrypt(message, key ).toString();
                },

                decrypt: function(message, key) {

                    if (key === undefined) {
                        key = this.cryptoKey;
                    }

                    return CryptoJS.AES.decrypt(message, key).toString(CryptoJS.enc.Utf8)
                }
            }
        }];
    });

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:BssLinkAccountController
   * @description
   * # MyrLinkAccountController
   * Controller of the BSS Link Account page
   */
  angular.module('totesApp').controller('BssDelinkAccountController', BssDelinkAccountController);

  BssDelinkAccountController.$inject = ['$scope', 'ajax', 'resource', 'appState', '$rootScope', 'localStorage', 'userLanguage'];

  /* @ngInject */
  function BssDelinkAccountController($scope, ajax, resource, appState, $rootScope, localStorage, userLanguage) {

    $scope.submit = function () {
      $scope.asynWaiting = true;

      var input = $scope.linkAccForm;
      var acountNumber = input.account.$modelValue;


        bssDeLinkAccountService.accountPreCheck(input).then(
          function (data) {


          }, function (error) {

          }
        )

    }


  }


})();

/**
 * Created by james.magpantay on 1/7/2016.
 */
(function () {

  'use strict';


  angular
    .module('totesApp')
    .factory('bssDelinkAccountService',bssDelinkAccountService);

  bssDelinkAccountService.$inject = ['ajax'];

  function bssDelinkAccountService(ajax) {

    var service = {
      delinkAccount : delinkAccount
    };

    return service;



    function delinkAccount(input) {

      if(input){

        var postalCode = input.postal.$modelValue;
        postalCode = postalCode.replace(' ','');
        var request = {
          "accountNumber": input.account.$modelValue,
          "postalCode": postalCode
        };

      }

      return ajax.validatelinkAccountInfo(request).then(
        function (data) {
         if(data.status == 'success'){
            service.isCableCheck(request.accountNumber);
          }
          return data;
        }, function (error) {

          return error;

        }
      );

    }





  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:BssLinkAccountController
   * @description
   * # MyrLinkAccountController
   * Controller of the BSS Link Account page
   */
  angular.module('totesApp').controller('BssLinkAccountController', LinkAccountController);

  LinkAccountController.$inject = ['$scope', '$browser', '$interpolate','$cookies', '$window', 'settings', 'ajax', 'resource', 'appState', '$rootScope', 'localStorage', 'userLanguage', 'bssLinkAccountService', 'brtCheck', '$timeout', 'ute.datalayer.common.service'];

  /* @ngInject */
  function LinkAccountController($scope, $browser, $interpolate,$cookies, $window, settings, ajax, resource, appState, $rootScope, localStorage, userLanguage, bssLinkAccountService, brtCheck, $timeout, dataLayerService) {
    bssLinkAccountService.getErrorMessages().then(
      function (data) {
        $scope.errorMsgs = data;
      },
      function (error) {

      }
    );


    $scope.skip = function () {
      if(appState.prevState.url.indexOf('accountOverview?directLanding&ban&ctn') > 0)
        appState.switchView('accountOverview');
      else
        appState.switchView(appState.prevState.url);
    };

    $scope.previous = function () {
      $scope.linkAccForm.$setPristine();
      $scope.servererror = false;
      $scope.dataerror = false;

    };


    $scope.submit = function () {
      $scope.asynWaiting = true;

      var input = $scope.linkAccForm;
      var accountNumber = input.account.$modelValue;
      var  validatelinkAccountapiFaliure = {
        page: {
          name: 'linkAccount',
          hierarchy: ['selfserve', 'linkAccount']
        },
        errors: [{
          API : "validateLinkAccount",
          category:"Selfserve",
          code: "",
          message:"Currently System Unavailable.",
          type:"http"
        }],
        events: {
          error: true
        }
      }; 
      var  linkAccountapiFaliure = {
        page: {
          name: 'linkAccount',
          hierarchy: ['selfserve', 'linkAccount']
        },
        errors: [{
          API : "linkAccount",
          category:"Selfserve",
          code: "",
          message:"Currently System Unavailable.",
          type:"http"
        }],
        events: {
          error: true
        }
      }; 

      if (!$scope.continue) {
        bssLinkAccountService.accountPreCheck(input).then(
          function (data) {
            if (data) {
              if (data.status == "success") {
                dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "linkAccountStep1Validation"});
                $scope.showCTN = data.showCTN;
                $scope.showCableBillType = data.showCableBillType;
                $scope.showInvoiceAndPayment = data.showLastInvoice;
                $scope.isCable = bssLinkAccountService.isCable;
                $scope.linkAccForm.$setPristine();
                $scope.continue = true;
                $timeout(function () {
                  $('#firstName').focus();
                }, 500);
              }
              else if (data.errorCode) {
                $scope.errorCode = data.errorCode;
                $scope.errorValues = data.errorValues;
                handleError();
              }
              else {
                dataLayerService.track(validatelinkAccountapiFaliure, false, [4, 1, 0]);
                $scope.servererror = true;
              }
            } else {
              dataLayerService.track(validatelinkAccountapiFaliure, false, [4, 1, 0]);
              $scope.servererror = true;
            }
            $scope.asynWaiting = false;
          }, function (error) {
            dataLayerService.track(validatelinkAccountapiFaliure, false, [4, 1, 0]);
            $scope.servererror = true;
            $scope.asynWaiting = false;
          }
        );
      } else {
        bssLinkAccountService.accountFullCheck(input).then(
          function (data) {
            var  payloadForBillType = {
              page: {
                name: 'linkAccount',
                hierarchy: ['selfserve', 'linkAccount']
              },
              miscellaneous: {
                type: 'linkbillpreference',
                name:  input.billType.$modelValue === "online" ? "Online" : "Paper"
              },
              events: {
                miscellaneous: true
              }
            }; 
            dataLayerService.track(payloadForBillType, false, [4, 1, 0]);
            if (data.status == "success") {
              dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "linkAccountSuccess"});
              appState.aoFlushScope();
              appState.switchView('accountOverview');
            }
            else if (data.errorCode) {
              $scope.errorCode = data.errorCode;
              $scope.errorValues = data.errorValues;
              handleError();
            }
            else {
              dataLayerService.track(linkAccountapiFaliure, false, [4, 1, 0]);
              $scope.servererror = true;
            }
            $scope.asynWaiting = false;
          }, function (error) {
            var  payloadForBillType = {
              page: {
                name: 'linkAccount',
                hierarchy: ['selfserve', 'linkAccount']
              },
              miscellaneous: {
                type: 'linkbillpreference',
                name:  input.billType.$modelValue === "online" ? "Online" : "Paper"
              },
              events: {
                miscellaneous: true
              }
            }; 
            dataLayerService.track(payloadForBillType, false, [4, 1, 0]);
            dataLayerService.track(linkAccountapiFaliure, false, [4, 1, 0]);
            $scope.servererror = true;
            $scope.asynWaiting = false;
          }
        );
      }
    };


    function handleError() {
      if ($scope.errorMsgs) {
        angular.forEach($scope.errorMsgs, function (obj, key) {
          if ($scope.errorCode == obj.errorCode) {
            $scope.errorMsgFr =  $interpolate(obj.errorMsg.fr)($scope);
            $scope.errorMsgEn = $interpolate(obj.errorMsg.en)($scope);
            $scope.dataerror = true;
          }
        });
        if ($scope.dataerror == true) {
          $scope.servererror = false;
        } else {
          if(!$scope.continue) {
            dataLayerService.track(validatelinkAccountapiFaliure, false, [4, 1, 0]);
          } else {
            dataLayerService.track(linkAccountapiFaliure, false, [4, 1, 0]);
          }
          $scope.servererror = true;
        }
      }
    }

    $rootScope.$watch(function () {
      return userLanguage();
    }, function (lang) {
      $scope.lang = lang;


    });


  }


})();

/**
 * Created by james.magpantay on 1/7/2016.
 */
(function () {

  'use strict';


  angular
    .module('totesApp')
    .factory('bssLinkAccountService',bssLinkAccountService);

  bssLinkAccountService.$inject = ['ajax'];

  function bssLinkAccountService(ajax) {

    var service = {
      isCableCheck : isCableCheck,
      accountPreCheck: accountPreCheck,
      accountFullCheck: accountFullCheck,
      getErrorMessages:getErrorMessages,
      isCable: '',
      showCableBillType: ''
    };

    return service;


    function isCableCheck(accountNumber,showCableBillType){
      service.showCableBillType = showCableBillType;
      if(accountNumber.toString().length == 12 ){
        service.isCable = true;
      }else{
        service.isCable = false;
      }
    }


    function accountPreCheck(input) {
      if(input){

        var postalCode = input.postal.$modelValue;
        postalCode = postalCode.replace(' ','');
        postalCode = postalCode.toUpperCase();
        var request = {
          "accountNumber": input.account.$modelValue,
          "postalCode": postalCode
        };

      }

      return ajax.validatelinkAccountInfo(request).then(
        function (data) {
         if(data.status == 'success'){
            service.isCableCheck(request.accountNumber,data.showCableBillType);
          }
          return data;
        }, function (error) {

          return error;

        }
      );

    }

    function accountFullCheck(input) {

      if(input){
        var postalCode = input.postal.$modelValue;
        postalCode = postalCode.replace(' ','');
        postalCode = postalCode.toUpperCase();
        var request = {
          "accountNumber": input.account.$modelValue,
          "billType": input.billType.$modelValue,
          "firstName": input.firstName.$modelValue,
          "lastName": input.lastName.$modelValue,
          "postalCode": postalCode
        };

        if(service.showCableBillType == false){
          delete request.billType;
        }

        if (input.lastPay) {
          var lastPaymentAmount = input.lastPay.$modelValue;
          lastPaymentAmount = parseFloat(lastPaymentAmount).toFixed(2);
          request.lastPaymentAmount = lastPaymentAmount;
        }

        if (input.lastInvoice){
          request.lastInvoiceDate = input.lastInvoice.$viewValue;
        }

        if (input.telephoneNumber){
          var telephoneNumber = input.telephoneNumber.$modelValue;
          telephoneNumber = telephoneNumber.replace(/\D+/g, "");
          request.telephoneNumber = telephoneNumber;
        }

      }

      return ajax.linkAccount(request).then(
        function (data) {

          return data;
        }, function (error) {

          return error;

        }
      );

    }

    function getErrorMessages() {
      return ajax.getErrorMessages().then(
        function (data) {

          return data;
        }, function (error) {

          return error;

        }
      );

    }



  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:BusinessPhoneDashboardController
   * @description
   * # TvdashboardCtrl
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('BusinessPhoneDashboardController', BusinessPhoneDashboardController);

  BusinessPhoneDashboardController.$inject = ['$scope', '$rootScope', '$browser', 'appState', 'resource', 'userLanguage', 'settings', 'ajax', '$timeout', 'localStorage', 'businessPhoneDashboardService','myrAccountOverviewService','myrAccountListService','myrAccountBalanceService', 'myrSigninService'];

  /* @ngInject */
  function BusinessPhoneDashboardController($scope, $rootScope, $browser, appState, resource, userLanguage, settings, ajax, $timeout, localStorage, businessPhoneDashboardService,myrAccountOverviewService,myrAccountListService,myrAccountBalanceService, signinService) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line


    $scope.selectedBusinessPhoneAccNum = localStorage.getLocalStorageValue('businessPhoneAccNum');



    //Start - Bold chat changes to display floating chat in Wireless Dashboard
    $scope.invokeFloatingChat = function () {
      var buttonId;
      setTimeout(function() {
        if(userLanguage() === 'en'){
          buttonId = getBDId('F_BSS_WlessDbrd-3484832265096496923');
          floatingLiveChatButtonUTE(buttonId);
        } else {
          buttonId = getBDId('F_BSS_WlessDbrd_Fr-7188242006291476406');
          floatingLiveChatButtonUTE(buttonId);
        }
      }, 5000);
    };

    $scope.$on('$stateChangeStart', function() {
      angular.element('.bcFloat').remove();
    });


    $rootScope.$on('languageChanged', function (){
      angular.element('.bcFloat').remove();
      $scope.invokeFloatingChat();
    });

    $scope.invokeFloatingChat();
    //End - Bold chat changes to display floating chat in Wireless Dashboard


    $scope.$extend({
      province: $browser.cookies().province || 'ON',
      postToRogersUrls: [],
      isCollapsed: true,
      lang: userLanguage() + '-CA',
      langUpper: userLanguage().toUpperCase(),
      lng: userLanguage(),
      limitLow: settings.usageLimit,
      loadingDataIndicatorBusinessPhoneDashboard: true,
      finalDataReceived: false,
      businessPhoneResponse: {},
      wirelessAccountsPhones : [],
      threadsOpen : 0,
      businessPhoneObj: {
        myBusinessPhonePackageName : '',
        myBusinessPhonePackageFeatures : [],
        myBusinessPhoneAddons : []
      },
      pageVariablesInit: function (firstTime) {
        $scope.lng = userLanguage();
      },
      errorCode: '',
      errorMessage: '',
      hasExtras: false,
      hasThemes: false,
      themesOpen: false,
      extraOpen: false,
      globalNotice: '',
      securityKey: '',
      securityToken: '',
      hasTvBox: true,
      showHardwareDD: true,
      getAccountList: function () {
        var request = {refresh: 'false', applicationId: 'Rogers.com'};
        var holder = null;
        $scope.wirelessAccounts = [];
        /*appState.tagging(['_trackPageView', {pn:'home:myrogers:wireless'} ]);*/
        appState.tagging(['_trackLink', {eVar11: $scope.ctn}, {event17: ''}]);


        myrAccountListService.getAccountList(request, function (_tmp) {
          if (_tmp.result === 'success' && _tmp.data.length > 0) {
            // Loop through the results and find only wireless accounts
            var tmpObj = {};
            var accountNumber = localStorage.getLocalStorageValue('accountNumber');


            // TODO - $rootScope.ao.accountActive.accountNumber  Make SURE this is not null / happens when refresh is pressed
            var _length = _tmp.data.length;

            //for (var i in _tmp.data) {
            for (var i = 0; i < _length; i++) {
              tmpObj = _tmp.data[i];
              // if ((tmpObj.accountTypeNumber === 1 || tmpObj.accountTypeNumber === 9) && tmpObj.accountNumber === $rootScope.ao.accountActive.accountNumber) {
              // if ((tmpObj.accountTypeNumber === 1 || tmpObj.accountTypeNumber === 9) && tmpObj.accountNumber === accountNumber) {
              if (tmpObj.accountNumber === accountNumber) {
                // Wireless accounts only -> tmpObj.accountTypeNumber == 1
                $scope.wirelessAccounts.push(tmpObj);
              }
            }


            for (var i = 0; i < _tmp.total; i++) {
              var tmp = {};
              tmp = _tmp.accountList[i];
              _tmp.accountList[i].accountStatusSimple = myrAccountListService.getAccountStatus(tmp).accountStatusSimple;
              _tmp.accountList[i].nickName = _tmp.accountList[i].nickname;
              _tmp.accountList[i].displayName = _tmp.accountList[i].nickName ? _tmp.accountList[i].nickName : _tmp.accountList[i].accountNumber;
              _tmp.accountList[i].comboDisplay = (_tmp.accountList[i].nickName || _tmp.accountList[i].nickName) ? (_tmp.accountList[i].nickName || _tmp.accountList[i].nickName) + ' - ' + _tmp.accountList[i].accountNumber : _tmp.accountList[i].accountNumber;
              _tmp.accountList[i].accNo = _tmp.accountList[i].accountNumber;
            }

            //display the linked success banner for the very first account
            myrAccountListService.accountTypes = _tmp.accountList;

            myrAccountListService.updateSelectedAccountByAccountNumber(accountNumber);

            if ($scope.wirelessAccounts.length > 0) {
              $scope.selectedAccount = $scope.wirelessAccounts[0];

              // Proceed with loading of all details for the subaccounts
              $scope.getAccountListDetails($scope.wirelessAccounts, userLanguage());
              if(!myrAccountBalanceService.accountBalance.nextBillDate){

                getBalanceDetails();

              }
            } else {
              // Redirect to link accounts?
              //appState.switchView('linkaccount');
              signinService.mbhUrlConfig().then(function(urlResponse){
                  $window.location.href = urlResponse.dashboard+"?openLinkAcctModal=true";
                });

              // console.log ('wireless.getAccountList -> No Wireless account linked!!!');
              // throw new Error('wireless.getAccountList -> No Wireless account linked!!!');
            }

          } else if (_tmp.result === 'redirect') {
            appState.switchView('guestoverview');

          } else if (_tmp.result === 'fail') {
            //holder = _tmp.data;
            $scope.loadingDataIndicator = false;
            scrollPageToTop();					// jshint ignore:line

            //$scope.errorMessage = 'Failed to load account list';
            $scope.errorMessageKey = 'error_wireless_usage';
            $scope.errorMessage = resource.get('error_wireless_usage');

          } else if (_tmp.result === 'error') {
            // holder = _tmp.data;
            $scope.loadingDataIndicator = false;
            scrollPageToTop();					// jshint ignore:line

            //$scope.errorMessage = _tmp.message;
            $scope.errorMessageKey = 'error_wireless_usage';
            $scope.errorMessage = resource.get('error_wireless_usage');

          } else {
            // Unknown state ???
            $scope.loadingDataIndicator = false;
            scrollPageToTop();					// jshint ignore:line
          }

        });
      },
      getAccountListDetails: function (accArray, language) {
        //	shotgun load all subaccounts and keep track of it
        var request;
        var tmpObj;

        for (var i in accArray) {
          tmpObj = accArray[i];
          if (typeof tmpObj === 'object') {
            request = {};
            request.accountNumber = tmpObj.accountNumber;
            request.accountTypeNumber = tmpObj.accountTypeNumber;
            request.language = language;
            request.applicationId = 'Rogers.com';

            // with other items in the call
            try {
              request.pinNumber = tmpObj.pinNumber;
            } catch (e) {
            }
            try {
              request.phoneNumber = tmpObj.phoneNumber;
            } catch (e) {
            }

            $scope.threadsOpen++;												// Event counter
            myrAccountOverviewService.resetCallingAccountDetails();
            myrAccountOverviewService.getAccountDetails(request, $scope.getAccountListPairing);
          }
        }
      },
      getAccountListPairing: function (_tmp) {
        var holder;

        if (_tmp.result === 'success') {
          // push result object to raw data object
          $scope.wirelessAccountsPhones.push(_tmp.data);

          $scope.threadsOpen--;
          if ($scope.threadsOpen === 0) {
            // Done with all shotgun loads - proceed to array simplification
            $scope.getAccountListSimple($scope.wirelessAccountsPhones);
          }
          /*

           // keep next billing date handy
           var stringSplit = myrAccountBalanceService.accountBalance ? myrAccountBalanceService.accountBalance.nextBillDate : '';		//"Feb-01-15"

           // to use it in the proration dialog
           localStorage.setLocalStorageValue('nextBillDate', stringSplit);

           if (stringSplit) {
           var stringArray = stringSplit.split('-');

           var months = {
           'Jan': 0,
           'Feb': 1,
           'Mar': 2,
           'Apr': 3,
           'May': 4,
           'Jun': 5,
           'Jul': 6,
           'Aug': 7,
           'Sep': 8,
           'Oct': 9,
           'Nov': 10,
           'Dec': 11
           };

           var dueMonth = months[stringArray[0]];
           var dueDay = parseInt(stringArray[1]);
           var dueYear = parseInt(stringArray[2]) + 2000;

           $scope.nextBillDate = new Date(dueYear, dueMonth, dueDay, 0, 0, 0, 0);

           var currectDate = new Date();
           $scope.nextbilldaysuntil = ' ' + Math.floor(($scope.nextBillDate - currectDate) / 86400000);
           } else {
           $scope.nextBillDate = 'N/A';
           $scope.nextbilldaysuntil = 'N/A';
           }
           */

        } else if (_tmp.result === 'fail') {
          var holderDetailsFail = _tmp.data;
          holder = _tmp.data;
          //$scope.errorMessage = 'Failed to load account detail';
          $scope.errorMessageKey = 'error_wireless_usage';
          $scope.errorMessage = resource.get('error_wireless_usage');

        } else if (_tmp.result === 'error') {
          // This error comes from account overview - IT IS NOT SAME format as local error messages
          holder = _tmp.data;
          //$scope.errorMessage = holder.originalError;
          $scope.errorMessageKey = 'error_wireless_usage';
          $scope.errorMessage = resource.get('error_wireless_usage');

        } else {
          // Unknown state ???
        }
      },
      getAccountListSimple: function (_full) {
        var tmpObj, tmpObjA, tmpObjB;
        var tmpArray = [];
        var ban = null;
        var ctn = null;
        var _length = _full.length;
        $scope.wirelessDashData = [];

        //for (var i in _full) {
        for (var i = 0; i < _length; i++) {
          tmpObj = _full[i];
          if (typeof tmpObj === 'object') {
            // Sift through the raw objects and look for phone numbers
            ban = tmpObj.accountNumber;
            tmpArray = tmpObj.subList;

            for (var j in tmpArray) {
              tmpObjA = tmpArray[j];
              if (typeof tmpObjA === 'object' && tmpObjA.subType === 'DPN' && tmpObjA.subStatus !== 'Suspended') {
                ctn = tmpObjA.subNumber;

                tmpObjB = {};
                tmpObjB.ban = ban;
                //tmpObjB.ctn = util.updateCTNFormat(ctn);
                tmpObjB.ctn = ctn;

                $scope.wirelessDashData.push(tmpObjB);
              }
            }
          }
        }

        // Make a call to load the wireless dashboard with real data
        for (var n = 0; n < $scope.wirelessDashData.length; n++) {
          //ui-router migration
          var phoneNumber = localStorage.getLocalStorageValue('businessPhoneNumber');

          //if ($scope.wirelessDashData[n].ctn === $routeParams.submodule) {
          if ($scope.wirelessDashData[n].ctn === phoneNumber) {
            $scope.wirelessDashActive = $scope.wirelessDashData[n];
          }
        }
        $scope.loadBusinessPhoneDashboard($scope.wirelessDashActive);
      }
    });

    $scope.processResponse = function (response) {
      if (response === undefined || response === null || !response.packages) {
        $scope.displayContentPhoneDashboard = false;
        $scope.loadingDataIndicatorBusinessPhoneDashboard = false;
        $scope.finalDataReceived = true;
        $scope.errorCode = 50000;
        $scope.errorMessage = resource.get($scope.errorCode);

      } else {  //TBD
        $scope.businessPhoneResponse = response;
        $scope.displayContentPhoneDashboard = true;
        //set business phone package details

        $scope.businessPhoneObj.myBusinessPhonePackageName = response.packages.description;
        //console.log($scope.lng);
        angular.forEach(response.productDetails,function(productDetail){
          if(response.packages.code == productDetail["product-id"] && $scope.lng === 'en')
            $scope.businessPhoneObj.myBusinessPhonePackageName = productDetail["english"]["short-description"];
          else if(response.packages.code == productDetail["product-id"] && $scope.lng === 'fr')
            $scope.businessPhoneObj.myBusinessPhonePackageName = productDetail["french"]["short-description"];
        });
        $scope.businessPhoneObj.myBusinessPhonePackageFeatures =[];
        angular.forEach(response.packages.features,function(packageFeature){
          var pkgFeature = '';
          angular.forEach(response.productDetails,function(productDetailFeature){
            if(packageFeature.code == productDetailFeature["product-id"] && $scope.lng === 'en')
              pkgFeature = productDetailFeature["english"]["short-description"];
            else if(packageFeature.code == productDetailFeature["product-id"] && $scope.lng === 'fr')
              pkgFeature = productDetailFeature["french"]["short-description"];
          });

          if(pkgFeature == '' && packageFeature.description != null)
            pkgFeature = packageFeature.description;

          if(pkgFeature != null && pkgFeature != '')
          $scope.businessPhoneObj.myBusinessPhonePackageFeatures.push(pkgFeature);

        });

        $scope.businessPhoneObj.myBusinessPhoneAddons = [];
        angular.forEach(response.addons,function(packageAddon){
          var addOn = '';
          angular.forEach(response.productDetails,function(addonDetail){
            if(packageAddon.addonCode == addonDetail["product-id"] && $scope.lng === 'en')
              addOn = addonDetail["english"]["short-description"];
            else if(packageAddon.addonCode == addonDetail["product-id"] && $scope.lng === 'fr')
              addOn = addonDetail["french"]["short-description"];
          });

          if(addOn == '' && packageAddon.addonDescription != null)
            addOn = packageAddon.addonDescription;

          if(addOn != null && addOn != '')
            $scope.businessPhoneObj.myBusinessPhoneAddons.push(addOn);

        });
      if(null != $scope.businessPhoneObj &&  $scope.businessPhoneObj.myBusinessPhonePackageName != ''){
        $scope.finalDataReceived = true;
      }
        //console.log( $scope.businessPhoneObj);
      }
    };

    function getBalanceDetails() {

      var acctDetails = myrAccountListService.selectedAccount;

      var request = {
        accountNumber: acctDetails.accountNumber,
        accountTypeNumber: acctDetails.accountTypeNumber,
        pinNumber: acctDetails.pinNumber,
        phoneNumber: acctDetails.phoneNumber,
        language: userLanguage(),
        refresh: false,
        indx: acctDetails.selectedAccountIndex,
        applicationId: 'Rogers.com'
      };

      myrAccountBalanceService.getBalanceDetails(request,function(_tmp){
      });

    }

    $scope.loadBusinessPhoneDashboard = function (tmp) {
      $scope.loadingDataIndicatorBusinessPhoneDashboard = true;
      $scope.displayContentPhoneDashboard = false;
      $scope.finalDataReceived = false;
      if (!$scope.selectedAccount.accountNumber) {
        return;
      }
      businessPhoneDashboardService.businessPhoneDashboard(tmp.ctn, $scope.langUpper, $scope.selectedBusinessPhoneAccNum, false).then(
        function (response) {
          $scope.processResponse(response);
         /* if (response.cachedResultInfo) {
            if (response.cachedResultInfo.expired) {
              businessPhoneDashboardService.businessPhoneDashboard($scope.selectedAccount.accountNumber, $scope.langUpper, $scope.selectedAccount.ban, true).then(
                function (response) {
                  $scope.finalDataReceived = true;
                  $scope.processResponse(response);
                },
                function (error) {
                  $scope.displayContentPhoneDashboard = false;
                  $scope.loadingDataIndicatorBusinessPhoneDashboard = false;

                  // Error handling - 555 exception
                  if (error.data.status === 555) {
                    $scope.errorCode = error.error.errorCode;
                    $scope.errorMessage = error.error.message;
                  } else {
                    $scope.errorMessage = resource.get('error_tv_feeder');
                  }
                });
            } else {
              $scope.finalDataReceived = true;
            }
          }*/
        },
        function (error) {
          $scope.displayContentPhoneDashboard = false;
          $scope.loadingDataIndicatorBusinessPhoneDashboard = false;

          // Error handling - 555 exception
          if (error.data.status === 555) {
            $scope.errorCode = error.error.errorCode;
            $scope.errorMessage = error.error.message;
          } else {
            $scope.errorMessage = resource.get('error_tv_feeder');
          }
        });
    };

    $scope.changeAccount = function () {
      $scope.wirelessDashData = [];
      $scope.wirelessAccountsPhones = [];
      localStorage.setLocalStorageValue('businessPhoneNumber', $scope.wirelessDashActive.ctn);
      $scope.getAccountList();

      //$scope.getTravelPackage({ban: $scope.wirelessDashActive.ban, ctn: $scope.wirelessDashActive.ctn});

      scrollPageToTop();					// jshint ignore:line
    };
    $scope.pageVariablesInit(true);
    resource.onChanged(function () {

      var oldLang = $scope.lng;

      $scope.lng = userLanguage();
      $scope.lang = userLanguage() + '-CA';
      $scope.langUpper = userLanguage().toUpperCase();

      if (oldLang !== $scope.lng) {
        $scope.wirelessDashData = [];
        $scope.wirelessAccountsPhones = [];
        localStorage.setLocalStorageValue('businessPhoneNumber', $scope.wirelessDashActive.ctn);
        $scope.getAccountList();
      }

      $scope.dollarSignB = userLanguage() === 'en' ? '$' : '';
      $scope.dollarSignA = userLanguage() === 'fr' ? '$' : '';

      var stateName = localStorage.getLocalStorageValue('toStateName');
      if(stateName === 'businessphonedashboard' && oldLang === $scope.lng ){
        $scope.getAccountList();
      }

    }, $scope);
  }
})();
/**
 * Created by varun.ramakanth on 11/14/2015.
 */

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('businessPhoneDashboardService', businessPhoneDashboardService);

  businessPhoneDashboardService.$inject = ['ajax', '$q'];

  /* @ngInject */
  function businessPhoneDashboardService(ajax, $q) {

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      businessPhoneDashboard: businessPhoneDashboard
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function businessPhoneDashboard(accountNumber, language, ban, requestFreshData) {

      var deferred = $q.defer();

      // process the first time result
      function processResult(data) {
        deferred.resolve(data);
      }

      // call tvLanding api to get data
      ajax.businessPhoneDashboard(accountNumber, language, ban, requestFreshData).then(
        function (response) {
          if (response) {
            processResult(response);
          }
        }, function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }
  }
})();

/**
 * Created by varun.ramakanth on 11/3/2015.
 */

(function () {
  'use strict';

  angular.module('totesApp').controller('ChangePayMethodController', ChangePayMethodController);

  ChangePayMethodController.$inject = ['$scope', '$state', 'ajax', 'resource', '$rootScope', 'appState', 'myrPayNowService', 'userLanguage', 'myrAccountOverviewService', 'myrChangePaymentMethodService', '$stateParams', 'settings', '$modal', '$timeout', 'localStorage', 'semafoneService', '$document', 'myrMyServicesService', 'myrAccountBalanceService', 'myrAccountListService'];

  /* @ngInject */
  function ChangePayMethodController($scope, $state, ajax, resource, $rootScope, appState, myrPayNowService, userLanguage, accountOverviewService, paymentMethodService, $stateParams, settings, $modal, $timeout, localStorage, semafoneService, $document, myrMyServicesService, myrAccountBalanceService, myrAccountListService) {

    function init() {
      var isDetailsAvailable = false;
      /*if(myrAccountListService.isOcp == "directLanding" && localStorage.getLocalStorageValue('accountNumber') != null){
                  		   myrAccountListService.isOcp = " ";
                  		   $state.go("accountInitialization");
       }*/
      if(accountOverviewService.getSelectedAccountDetail()) {
        $scope.selectedAccNum = accountOverviewService.getSelectedAccountDetail().billableAccountNumber;
        $scope.selectedAccContactId = accountOverviewService.getSelectedAccountDetail().contactId;
        $scope.selectedAccLOB = accountOverviewService.getSelectedAccountDetail().lob;
        $scope.lang = userLanguage();
        $scope.name = accountOverviewService.getSelectedAccountDetail().nickName;

        if (accountOverviewService.getSelectedAccountDetail().accountBalance.methodOfPayment) {
          $scope.mopCode = accountOverviewService.getSelectedAccountDetail().accountBalance.methodOfPayment.mopType;
          if ($scope.mopCode == "C")
            $scope.mop = userLanguage() == 'en' ? 'Credit Card' : 'Carte de cr\u00E9dit';
          else if ($scope.mopCode == "D")
            $scope.mop = userLanguage() == 'en' ? 'Pre-authorized Debit' : 'Paiement pr\u00E9autoris\u00E9 par pr\u00E9l\u00E8vement automatique';
          else
            $scope.mop = userLanguage() == 'en' ? 'Month-by-Month' : 'Au mois';
        }
        isDetailsAvailable = true;
      }
      else if((undefined != localStorage.getLocalStorageValue('accountNo')) && ("" != localStorage.getLocalStorageValue('accountNo'))){
        $scope.selectedAccNum = localStorage.getLocalStorageValue('accountNo');
        $scope.selectedAccContactId = localStorage.getLocalStorageValue('contactId');
        $scope.selectedAccLOB = localStorage.getLocalStorageValue('LOB');
        $scope.mop = localStorage.getLocalStorageValue('currentPaymentMethod');
        if($scope.mop.toLowerCase() == 'invoice' || $scope.mop.toLowerCase() == 'facture' ){
          $scope.mopCode = 'R';
        } else if($scope.mop.toLowerCase() == 'Pre-authorized credit card' || $scope.mop.toLowerCase() == 'Carte de crédit' ){
          $scope.mopCode = 'C';
        }else if($scope.mop.toLowerCase() == 'Chequing Account' || $scope.mop.toLowerCase() == 'Compte chèques' ){
          $scope.mopCode = 'D';
        }

        if ($scope.mopCode == "C")
          $scope.mop = userLanguage() == 'en' ? 'Credit Card' : 'Carte de cr\u00E9dit';
        else if ($scope.mopCode == "D")
          $scope.mop = userLanguage() == 'en' ? 'Pre-authorized Debit' : 'Paiement pr\u00E9autoris\u00E9 par pr\u00E9l\u00E8vement automatique';
        else
          $scope.mop = userLanguage() == 'en' ? 'Month-by-Month' : 'Au mois';

        $scope.lang = userLanguage();
        isDetailsAvailable = true;
      }
      $scope.isCable = false;
      // Removing as part of RBIB-20046
      // if(undefined != $scope.selectedAccNum && $scope.selectedAccNum.length == 12)
      //   $scope.isCable = true;

      if (!isDetailsAvailable) {
        //appState.switchView('accountOverview');
      }
      if(myrAccountListService.isOcp == "directLanding" && (localStorage.getLocalStorageValue('accountNumber') != null || $rootScope.accountListLength == 1)){
          myrAccountListService.isOcp = " ";
          $state.go("accountInitialization");
      }
    }

    init();
  }

})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrChangePaymentMethodController', ChangePaymentMethodController);

  ChangePaymentMethodController.$inject = ['$scope', '$state', '$rootScope', 'ajax', 'settings', 'resource', 'userLanguage', 'appState', 'myrAccountOverviewService', 'myrChangePaymentMethodService', '$stateParams', '$window', 'semafoneService', '$modal', 'myrAccountListService'];

  /* @ngInject */
  function ChangePaymentMethodController($scope, $state, $rootScope, ajax, settings, resource, userLanguage, appState, accountOverviewService, paymentMethodService, $stateParams, $window, semafoneService, $modal, myrAccountListService) {
    var requestObj = null;
    var map = {'VISA': 'VI', 'MASTERCARD': 'MC', 'AMEX': 'AM'};
    $scope.state = $state.current.name;

    var params = $stateParams;
    $rootScope.showCreditCardForm = false;
    $rootScope.showDebitForm = false;
    function changeCardType(key) {
      return map[key];
    }

    //handle language switch
    //update the resource keys when language switches
    function setMethodNames() {
      $scope.serverMessage = null;
      $scope.paymentMethods[0].resKey = resource.get('invoice');
      $scope.paymentMethods[1].resKey = resource.get('change_method_credit');
      $scope.paymentMethods[2].resKey = resource.get('change_method_debit');
      $scope.chatLink = getChatLink();
    }

    function setMethod() {
      if (!requestObj) {
        return;
      }
      $scope.isChanging = true;
      ajax.setPaymentMethod(requestObj).then(
        function (response) {
          $scope.isChanging = false;
          if (response === undefined) {
            handleError(null);
          } else {
            handleSuccess();
          }
        },
        function (error) {
          $scope.isChanging = false;
          // Error handling - 555 exception
          if (error.data.status === 555) {
            // Server error that needs further processing
            // additional information for 555 error

            // error.error.errorCode        // 10k - 12.1k & 50k - 51k
            // error.error.errorMessage     // Message as delivered from server
            // error.error.message          // Message as found in resource file
            // error.error.statusCode       // error status code - 555 in this case

            $scope.errorMessage = error.error.errorCode + ' - ' + error.error.errorMessage;

          } else {
            // anything but status code 555
            $scope.errorMessage = error.data.status + ' - ' + error.data.statusText;
          }

          handleError(error);
        }
      );
    }

    function setConfirmationDialog() {
      var _options = {
        title: resource.get('change_method_confirm_title'),
        message: resource.get('change_method_confirm_details'),
        onClose: cancel,
        icon: 'success',
        buttons: [
          {label: '_cancel', type: 'secondary', action: cancel},
          {label: '_continue', type: 'primary', action: callServer}
        ]
      };
      appState.setConfirmation(_options);
    }

    function callServer() {
      //prepare the server call
      //$scope.getCableAccountDetails();
      $scope.storeScope();
      $scope.isChanging = true;
      var _detail = accountOverviewService.getSelectedAccountDetail();

      myrAccountListService.selectedAccount.accountNumber = _detail.billableAccountNumber ? _detail.billableAccountNumber : _detail.number;
      myrAccountListService.selectedAccount.subNumber = _detail.number;
      myrAccountListService.selectedAccount.accountType = _detail.type;

      // var biilAccNumber  = _details.billableAccountNumber ? _details.billableAccountNumber : _details.number;
      if ($scope.selectedMethod === 1) {
        //set credit card
        var card = changeCardType(semafoneService.getCardScheme());
        //$scope.creditPaymentObj.creditCardNo = token;
        requestObj = {
          accountNumber: myrAccountListService.selectedAccount.accountNumber,
          accountTypeNumber: myrAccountListService.selectedAccount.accountType,
          mopType: $scope.selectedMethodObj.type,
          consolidated: _detail.isConsolidated,
          subNumber: myrAccountListService.selectedAccount.subNumber,
          'creditCardInfo.ccNumber': semafoneService.getToken(), // $scope.creditPaymentObj.creditCardNo,
          'creditCardInfo.ccType': card,
          'creditCardInfo.ccExpiryMonth': $scope.creditPaymentObj.expireDate.month,
          'creditCardInfo.ccExpiryYear': $scope.creditPaymentObj.expireDate.year,
          'creditCardInfo.securityCode': $scope.creditPaymentObj.securityCode,
          'detail.oldMopType': _detail.paymentMethod,
          'detail.contactId': _detail.contactId
        };
        setMethod();

      } else if ($scope.selectedMethod === 2) {
        //set cheque account
        requestObj = {
          accountNumber: myrAccountListService.selectedAccount.accountNumber,
          accountTypeNumber: myrAccountListService.selectedAccount.accountType,
          mopType: $scope.selectedMethodObj.type,
          consolidated: _detail.isConsolidated,
          subNumber: myrAccountListService.selectedAccount.subNumber,
          'chequingInfo.bankNumber': $scope.chequingObj.bankCode,
          'chequingInfo.transitNumber': $scope.chequingObj.transitNo,
          'chequingInfo.accountNumber': $scope.chequingObj.accountNo,
          'chequingInfo.termsChecked': true,
          'detail.oldMopType': _detail.paymentMethod,
          'detail.contactId': _detail.contactId
        };
        setMethod();
      }
    }

    function cancel() {
    }

    function afterChangeMethod() {
      //   appState.afterPaymentRefresh = true;
      //appState.switchView('accountOverview');
      $window.location.reload();
    }

    function afterErrorMethod() {
      //   appState.afterPaymentRefresh = true;
      appState.switchView('changemethod');
    }

    function handleSuccess() {
      tagChangeMethodSuccess();

      //Add due date into confirmation message
      var _message = resource.get('change_method_thankyou_details');
      _message = _message.replace(/\{dueDate\}/i, $scope.accountDetail.dueDate);
      if (myrAccountListService.selectedAccount.accountType === 6 && $scope.selectedMethod === 2 && !accountOverviewService.getSelectedAccountDetail().isConsolidated) {
        _message += '<br/><br/>' + resource.get('change_method_note');
      }
      //change_method_note

      //appState.afterPaymentRefresh = true;
      var _options = {
        title: resource.get('change_method_thankyou_title'),
        message: _message,
        onClose: afterChangeMethod,
        icon: 'success',
        buttons: [
          {label: 'paynow_go_to_overview', type: 'secondary', action: afterChangeMethod}
        ]
      };
      appState.setConfirmation(_options);
    }

    function handleError(errorCode) {
      $scope.recoverScope();

      //$scope.serverMessage =resource.get( errorCode );
      var _options = {
        title: '',
        message: resource.get('change_method_error'),
        onClose: cancel,
        iconBody: 'alert',
        buttons: [
          {label: 'paynow_go_to_overview', type: 'secondary', action: afterChangeMethod}
        ]
      };
      /*            if( errorCode){
       _options.message = resource.get('10001');
       }else {
       _options.message = resource.get('10001');
       }*/
      appState.setConfirmation(_options);
    }

    function getChatLink() {
      var lang = userLanguage();
      if (!lang) {
        return settings.chatLinkModules.payment.en;
      }
      return settings.chatLinkModules.payment[lang];
    }

    function tagChangeMethodSuccess() {
      appState.tagging(['_trackPageView',
        {eVar13: 'MyRogers - Change method of payment'},
        {event6: ''}]);
    }

    function tagChangePaymentMethod() {
      appState.tagging(['_trackPageView',
        {pn: 'home:MyRogers:payment-method'},
        {eVar13: 'MyRogers - Change method of payment'},
        {event5: ''}
      ]);
    }

    function tagInvoice() {
      appState.tagging(['_trackPageView',
        {pn: 'home:MyRogers:payment-method:invoice'},
        {eVar38: 'Invoice'}
      ]);
    }

    function tagPreCheque() {
      appState.tagging(['_trackPageView',
        {pn: 'home:MyRogers:payment-method:pre-authorized-chequing'},
        {eVar38: 'Pre-authorized Chequing'}
      ]);
    }

    function tagPreCredit() {
      appState.tagging(['_trackPageView',
        {pn: 'home:MyRogers:payment-method:pre-authorized-chequing'},
        {eVar38: 'Pre-authorized Chequing'}
      ]);
    }

    $scope.$extend({
      currentMethodId: null,
      changeInvoiceMethod: false,
      showCreditCardForm: false,
      showDebitForm: false,
      serverMessage: null,
      paymentMethods: [
        {
          id: 0, //invoice
          type: 'R',
          resKey: null
        },
        {
          id: 1, //credit card
          type: 'C',
          resKey: null
        },
        {
          id: 2, //cheque account
          type: 'D',
          resKey: null
        }
      ],
      selectedMethodObj: null,
      selectedMethod: 0,
      chatLink: null,
      isPreAuthorized: paymentMethodService.isActiveAccountMethodInvoice() || false,
      //isUnavailable: paymentMethodService.isMethodUnavailable(),
      isChanging: false,
      //isAccepted: false,

      resetForm: function () {
        $scope.changeInvoiceMethod = false;

        if ($scope.form) {
          $scope.form.$setPristine();
        }

      },
      /**
       * Display the selected payment method form.
       */
      changeMethod: function (method) {
        //check if change from other methods to invoice
        $scope.resetForm();
        if ($scope.currentMethodId !== 0 && method.id === 0) {
          $scope.changeInvoiceMethod = true;
        }
        $scope.selectedMethod = method.id;

        //set flags for the form to be shown
        if ($scope.selectedMethod === 0) {

          tagInvoice();

          $scope.showCreditCardForm = false;
          $scope.showDebitForm = false;

        } else if ($scope.selectedMethod === 1) {
          tagPreCredit();

          $scope.showCreditCardForm = true;
          $scope.showDebitForm = false;
          $rootScope.showDebitForm = false;
          $rootScope.showCreditCardForm = true;

        }
        if ($scope.selectedMethod === 2) {
          tagPreCheque();

          $scope.showCreditCardForm = false;
          $rootScope.showCreditCardForm = false;
          $scope.showDebitForm = true;
          $rootScope.showDebitForm = true;
        }
      },
      selectedAccount: accountOverviewService.getSelectedAccount(),
      accountBalance: accountOverviewService.getAccountBalance(),
      accountDetail: {
        dueDate: '',
        mopType: ''
      },
      //submit selected method to the server.
      submit: function () {
        if ($scope.selectedMethod === 1) {
          $scope.setCCType();
        }

        if (!$scope.selectedMethod || !$scope.form.$valid) {
          return false;
        } else {
          if ($rootScope.isDealer || $rootScope.isCare) {
            $scope.open();
          }
          else {
            callServer();
          }
        }
      },
      processBalance: function () {
        $scope.accountDetail.dueDate = $scope.accountBalance.nextBillDate;
        $scope.accountDetail.mopType = 'R';
        if ($scope.accountBalance.methodOfPayment && $scope.accountBalance.methodOfPayment.mopType) {
          $scope.accountDetail.mopType = $scope.accountBalance.methodOfPayment.mopType;
        }
        var _method = $scope.accountDetail.mopType;
        if (_method && (_method = _method.toLowerCase())) {
          $scope.selectedMethodObj = $($scope.paymentMethods).map(function (k, v) {
            if (v.type.toLowerCase() === _method) {
              return v;
            }
          }).get()[0];
          if ($scope.selectedMethodObj) {
            $scope.currentMethodId = $scope.selectedMethodObj.id;
            $scope.changeMethod($scope.selectedMethodObj);
          }
        }
        //initialize the method names and update when switch languages.
        setMethodNames();
        $scope.resetForm();
      },
      cancel: function () {
        if($rootScope.isDealer || $rootScope.isCare){
          appState.switchView('oneViewDashboard');
        } else {
          appState.switchView('accountOverview');
        }
      }
    });

    $scope.storeScope = function () {
      $scope.origObj = angular.copy($scope.creditPaymentObj);

    };
    $scope.recoverScope = function () {
      $.extend($scope.creditPaymentObj, $scope.origObj);

    };
    //check rootScope
    if (!$rootScope.ao.accountDetails) {
      appState.switchView('accountOverview');
    }
    //set the current payment method.
    //set bill due date
    else {
      tagChangePaymentMethod();
      $scope.processBalance();
    }

    // resource.onChanged(setMethodNames, $scope);
    resource.onChanged(function () {
      $scope.tooltip = resource.get('paynow_card_tooltip');
      setMethodNames();
    }, $scope);

    //local test
    //handleError('10001');
    //handleSuccess();

    // Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal
    $scope.open = function (size) {

      var serverHack = '/web/smb/bss';
      if (settings.isLocal) {
        serverHack = '';
      }

      $rootScope.modal = $modal.open({
        templateUrl: serverHack + '/scripts/modules/payNow/payNowContinueModal.html',
        controller: 'MyrPayNowContinueModalController',
        size: size,
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });

      $rootScope.modal.result.then(function () {
        // on OK behaviour
      }, function () {
        // on Cancel behaviour
      });
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * change the payment method of selected account.
   * this has a service for the changePaymentMethodController
   */
  angular.module('totesApp').service('myrChangePaymentMethodService', changePaymentMethodService);

  changePaymentMethodService.$inject = ['$rootScope'];

  /* @ngInject */
  function changePaymentMethodService($rootScope) {

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      isActiveAccountMethodInvoice: isActiveAccountMethodInvoice,
      isMethodUnavailable: isMethodUnavailable
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function isActiveAccountMethodInvoice() {
      if (!$rootScope.ao.accountDetails) {
        return null;
      } else {
        var isInvoice = true;
        if ($rootScope.ao.accountDetails.accountBalance && $rootScope.ao.accountDetails.accountBalance.methodOfPayment && $rootScope.ao.accountDetails.accountBalance.methodOfPayment.mopType) {
          isInvoice = $rootScope.ao.accountDetails.accountBalance.methodOfPayment.mopType === 'R';
        }
        return isInvoice;
      }
    }

    function isMethodUnavailable() {
      if (!$rootScope.ao.accountDetails) {
        return null;
      } else {
        return !($rootScope.ao.accountDetails.accountBalance.methodOfPayment && $rootScope.ao.accountDetails.accountBalance.methodOfPayment.mopType);
      }
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.commonUtilities').factory('commonUtilityService', commonUtilityServices);

  commonUtilityServices.$inject = ['$log'];

  /* @ngInject */
  function commonUtilityServices($log) {

    // Public API
    var service = {
      dateTime: {
        parse: parse,
        getDateFromStringYYYYMMDD: getDateFromStringYYYYMMDD
      },browser:{
        isSafari: isSafari,
        isSafariOnIos: isSafariOnIos
      }
    };

    return service;

    ///////////////////////////////////////////////////////////////

    /**
     * This function is use to convert a string in 'YYYY-MM-DD' format into a datetime object
     * @param dateTimeInString should be in YYYY-MM-DD format
     */
    function getDateFromStringYYYYMMDD(dateTimeInString) {
      try {
        // Basic validation
        var dateTimeSplit = dateTimeInString.split('-');

        if(dateTimeSplit.length !== 3){
          return undefined;
        }
        var yearInt = parseInt(dateTimeSplit[0]);
        var monthInt = parseInt(dateTimeSplit[1]);
        var dayInt = parseInt(dateTimeSplit[2]);

        if(isNaN(yearInt) || isNaN(yearInt) || isNaN(yearInt)){
          return undefined;
        }

        // Fix the month before set Date
        monthInt = monthInt-1;

        var returnDateTime = new Date(yearInt, monthInt, dayInt);
        return returnDateTime;

      } catch (e) {
        $log.error('Exception catch during getDateFromStringYYYYMMDD:', e.message);
      }
      return undefined;
    }

    /**
     * This function is use to convert a string in 'YYYY-MM-DD' format into a datetime object
     * @param dateTimeInString '2016-02-04', 'Feb 04, 2016'
     * @param expectedFormat 'YYYY-MM-DD', 'MMM DD, YYYY'
     */
    function parse(dateTimeInString, expectedFormat) {
      try {

        if(/yyyy-mm-dd/i.test(expectedFormat)){
          return getDateFromStringYYYYMMDD(dateTimeInString);
        }

      } catch (e) {
        $log.error('Exception catch during parse:', e.message);
      }
      return new Date();
    }

    /**
     * This function is use to check if the current browser is safari running on IOS 
     */
    function isSafariOnIos() {
      try {
        return (
          /ipad|iphone/i.test(window.navigator.platform)
          && isSafari()
        );
      } catch (e) {
        $log.error('Exception catch during isSafariOnIos:', e.message);
      }
    }

    /**
     * This function is use to check if the current browser is Safari
     */
    function isSafari() {
      try {
        return (
          /safari/i.test(window.navigator.appVersion)
          && !(/chrome|crios/i.test(window.navigator.appVersion))
        );
      } catch (e) {
        $log.error('Exception catch during isSafari:', e.message);
      }
    }

  }
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrCompleteProfileController', CompleteProfileController);

  CompleteProfileController.$inject = ['$scope', 'ajax', 'resource', 'appState', 'landing', 'localStorage'];

  /* @ngInject */
  function CompleteProfileController($scope, ajax, resource, appState, landing, localStorage) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    $scope.$extend({
      tagPageName: 'Security Question',
      questionId: '',
      answer: '',
      questions: null, //to be populated as below
      form: $scope.form,
      isValid: null,
      loadingDataIndicator: false,
      submit: function () {
        if ($scope.form.$valid) {
          $scope.isValid = true;
          $scope.isError = false;
          $scope.errorDescription = null;
          $scope.loadingDataIndicator = true;
          ajax.updateSecurityQuestion($scope.questionId, $scope.answer).then(function () {
            // success
            localStorage.setLocalStorageValue('profileComplete', true);
            // remove success message from previous step (password reset page)
            localStorage.deleteLocalStorageValue('successMessage');
            landing.landingRedirect();
          }, function (error) {
            $scope.isError = true;
            $scope.loadingDataIndicator = false;
            $scope.tagErrorAnsweringUsage();
            if (error.data.status === 555) {
              if (error.error.errorCode) {
                $scope.errorDescription = resource.get(error.error.errorCode);
              }
            }
            if (!($scope.errorDescription)) {
              $scope.errorDescription = resource.get('maintenance_info');
            }
          }).then(function () {
            if ($scope.isError) {
              return;
            }
          });
        } else {
          $scope.isValid = false;
          appState.tagFormValidationErrors($scope.tagPageName, $scope.form.$error);
          $scope.loadingDataIndicator = false;
        }
      }
    });

    // TODO: omniture tagging
//            function tagSecurityQuestion() {
//                appState.tagging(['_trackPageView',
//                    {pn: 'home:registration:contact-information'}, // Page Name
//                    {eVar13: 'MyRogers - Security Question'},
//                    {event5: ''},
//                    {event7: ''}
//                ]);
//            }

    $scope.tagSecurityQuestionUsage= function () {
      /*appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:Auto_Regis_Secretques'}, // Page Name
      ]);*/
    };

    $scope.tagErrorAnsweringUsage= function () {
      appState.tagging(['_trackLink',
        {eVar49:'<ErrorMessages>'},// Error Message example: Please Enter a correct Answer'
        {event15:''}// Generic Error
      ]);
    };

    resource.onChanged(function () {
      $scope.questions = resource.get('login_security_questions');
//                $scope.errorDescription = resource.get($scope.errorCode);
    }, $scope);

    //init tagging
    // TODO: omniture tagging
//            tagSecurityQuestion();
  }
})();

(function () {
    'use strict';
    angular.module('totesApp').controller('myeSimAndPhysicalSimChangeController', eSimAndPhysicalSimChangeController);

    eSimAndPhysicalSimChangeController.$inject = ['$scope', '$rootScope', '$sce', 'settings', '$browser', 'localStorage', 'user', 'uteBillService', 'ajax','myrAccountListService','ute.common.simcard.change.service','appState','ute.datalayer.common.service','sessionStorage'];
   
    function eSimAndPhysicalSimChangeController($scope, $rootScope, $sce, settings, $browser, localStorage, user, uteBillService, ajax,myrAccountListService,simcardChangeService,appState,dataLayerService,sessionStorage) {
      var simcardetails;
      $scope.ctnNumber = localStorage.getLocalStorageValue('ctnNumber');
      $scope.changeEsimpage = function(){
        var flag;
        var transferlinkSwitch = "";
          ajax.getBrtSwitches().then(
              function (data) {
                angular.forEach(data, function (obj, key) {
                  if(obj.id == "BRT_SEAMLESS_eSIM"){
                    if (obj.switchIsOn == false) {
                        flag = obj.id;
                        ajax.getPermissions().then(
                          function (data) {
                            angular.forEach(data, function (obj, key) {
                              angular.forEach(obj, function (x, key) {
                                if (x.permission == flag) {
                                  transferlinkSwitch = true;
                                  localStorage.setLocalStorageValue('transfereSimbrtswitch',transferlinkSwitch);
                                }
                              });
                            });
                          });
                      }else{
                       var whitelistvalfal = false;
                        var usernameDetails = JSON.parse(sessionStorage.getSessionStorageValue('accountInfo'));
                        var requestData ={
                          userId : usernameDetails.userName,
                          brtSwitch : obj.id
                        }
                        ajax.gethasPermissions(requestData).then(
                          function (data) {
                            if(data.hasBrtPermission == whitelistvalfal){
                              transferlinkSwitch = false;
                              localStorage.setLocalStorageValue('transfereSimbrtswitch',transferlinkSwitch);
                            }else{
                              transferlinkSwitch = true;
                              localStorage.setLocalStorageValue('transfereSimbrtswitch',transferlinkSwitch);
                            }
                          });
                      }
                  }else{
                    transferlinkSwitch = true;
                    localStorage.setLocalStorageValue('transfereSimbrtswitch',transferlinkSwitch); 
                  }
                });
              });
        var requestData ={
            accountNumber: localStorage.getLocalStorageValue('accountNumber'),
            franchise: "Rogers",
              sku: "",
            companyCode: "",
            usedIndicator: "N"
           
         }
         ajax.geteSimreversechange(requestData).then(function(data) {
          var requestDataForGetDetails = {
            number: atob(data.simNumber),
            code : atob(data.simActivationCode)
          };
          ajax.getDetails(requestDataForGetDetails).then(function(data1) {
            var response = data1;
            if (dataLayerService.track({}, !1, [4, 1, 0], {
              mappingKey: "esimSetupmodal"
          }),
          appState.switchView("eSimcard"),
          simcardetails = data,
          simcardetails && (localStorage.setLocalStorageValue("newSimNumber", response.number),
          localStorage.setLocalStorageValue("simActivationCode", response.code)),
          simcardetails.simActivationCode) {
              var usernameDetails = JSON.parse(sessionStorage.getSessionStorageValue("accountInfo"))
                , minm = 1e5
                , maxm = 999999
                , rendomvalue = Math.floor(Math.random() * (maxm - minm + 1)) + minm
                , randomvaluesstring = rendomvalue.toString()
                , requestData = {
                  simActivationCode: response.code,
                  oneTimePassword: randomvaluesstring,
                  flowType: "SIM_SWAP",
                  newSimNumber: response.number,
                  oldSimNumber: localStorage.getLocalStorageValue("oldSimNumber"),
                  account: localStorage.getLocalStorageValue("accountNumber"),
                  subscriber: $scope.ctnNumber,
                  language: sessionStorage.getSessionStorageValue("userLanguage"),
                  email: usernameDetails.userName
              };
              ajax.geteSimtokengeneration(requestData).then(function(data) {
                  var simcardetails = data;
                  simcardetails.tokenId && localStorage.getTokenid(simcardetails.tokenId)
              })
          }
          })
            
        })
    }
        $scope.postToRogersSim = function() {
            if ($rootScope.brtph2common) {
              myrAccountListService.acctInitStateUrl = "simCard";
              var  acctNumber= localStorage.getLocalStorageValue('accountNumber');
              var accountEmail = _.has($scope.ao, 'accountDetails.contactInfo.emailAddress') ? $scope.ao.accountDetails.contactInfo.emailAddress : '';
              simcardChangeService.goToEntryState({phoneNumber: $scope.ctnNumber, accountNumber: acctNumber, accountEmail: accountEmail});
              dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "PhysicalSimsetup"});
            } else {
              $('#formToRogersSim').attr('action', settings.formsURL + '/business/ute/smb/transactions/uteChangeSim');
              $('#formToRogersSim').submit();
            }
          };

    }
})();
(function () {
    'use strict';
    angular.module('totesApp').controller('myeSimcardController', eSimcardController);

    eSimcardController.$inject = ['$scope', '$rootScope', '$sce', 'settings','sessionStorage', '$browser', 'localStorage', 'user', 'ajax','appState','userLanguage','resource','ute.datalayer.common.service'];
   
    function eSimcardController($scope, $rootScope, $sce, settings,sessionStorage, $browser, localStorage, user, ajax,appState,userLanguage,resource,dataLayerService) {
        $scope.ctnNumber = localStorage.getLocalStorageValue('ctnNumber');
        var esim_link_hide = localStorage.getLocalStorageValue('esimcodestatus');
        $scope.transferLinkhide = "";
        if(esim_link_hide == 'transferesimlinkhide'){
          $scope.transferLinkhide = false;
        }else if(esim_link_hide == 'transferesimlinkshow'){
          $scope.transferLinkhide = true;
        }
        $scope.lang = userLanguage();
        $scope.brt_transfer_link = localStorage.getLocalStorageValue('transfereSimbrtswitch');
        $scope.getbackWireless = function(){
          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "eSimsetupback"});
            appState.switchView('/wireless');
        }
        $scope.shareEsimvalue = function(){
          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "shareEsimcode"});
          appState.switchView('/eSimEmail');
          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "shareEmailcode"});
        }
        $scope.transferEsim = function(){
          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "transferesimcode"});
            appState.switchView('/eSimtransfer');
        }
        $scope.getBackToWireless = function(){
            appState.switchView('/wireless');
        }
        $scope.successfullcheckbox = false;
        $scope.showcheckboxError =true;
        $scope.validatesuccessfullcheckbox = function(){
          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "eSimqrcodecheckbox"});
          $scope.isVslidbutton = false;
          $scope.successfullcheckbox ? $scope.isVslidbutton : true;
        }
        $scope.changeSwapsimpage = function(){
          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "eSimConfirmsetup"});
          var tokenidval = localStorage.getTokenidval();
            if($scope.successfullcheckbox == true){
                $scope.showcheckboxError = true;
            var requestData ={
                tokenId : tokenidval,
                equipmentIDType: "SIM",
                lob    : "WL",
                status    : "New"
             }
             ajax.geteSwapsimchange(requestData).then(
               function (data) {
                 if( data.status = "Success"){
                    appState.switchView('/eSimSuccess');
                    dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "confirmeSimsuccess"});
                 }
               });
            }else{
                $scope.showcheckboxError = false;
              }
            }
            resource.onChanged(function () {
                $scope.lang = userLanguage();
            }, $scope);
            var simActivationCode = localStorage.getLocalStorageValue('simActivationCode');
            var qrcode = new QRCode(document.getElementById("qrcode"), {
                width: 180,
                height: 180
              });
              qrcode.makeCode(simActivationCode);
              var qrcodemob = new QRCode(document.getElementById("qrcodemobile"), {
                width: 180,
                height: 180
              });
              qrcodemob.makeCode(simActivationCode);
    }
})();
(function () {
    'use strict';
    angular.module('totesApp').controller('myeSimemailmodalController', eSimemailmodalController);

    eSimemailmodalController.$inject = ['$scope', '$rootScope', '$sce', 'settings', '$browser', 'localStorage', 'user', 'appState','sessionStorage','ajax','userLanguage','resource','ute.datalayer.common.service'];
   
    function eSimemailmodalController($scope, $rootScope, $sce, settings, $browser, localStorage, user, appState,sessionStorage,ajax,userLanguage,resource,dataLayerService) {
      $scope.ctnNumber = localStorage.getLocalStorageValue('ctnNumber'),
      $scope.lang = userLanguage();
        $scope.geteSimotpdetails = function() {
          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "shareEmailbutton"});
            var minm = 100000;
            var maxm = 999999;
            var rendomvalue = Math.floor(Math
            .random() * (maxm - minm + 1)) + minm;
            var randomvaluesstring = rendomvalue.toString();
            localStorage.setLocalStorageValue('esimEmailotp',randomvaluesstring);
            var randomvaluespace =  randomvaluesstring.split('').join(' ');
            localStorage.setLocalStorageValue('eSimemail',$scope.email);
            localStorage.setLocalStorageValue('randomEmailotp',randomvaluespace);
            var requestData ={
                simActivationCode: localStorage.getLocalStorageValue('simActivationCode'),
                oneTimePassword: localStorage.getLocalStorageValue('esimEmailotp'),
                flowType: "SIM_SWAP",
                newSimNumber: localStorage.getLocalStorageValue('newSimNumber'),
                oldSimNumber: localStorage.getLocalStorageValue('oldSimNumber'),
                account: localStorage.getLocalStorageValue('accountNumber'),
                subscriber: $scope.ctnNumber,
                language: sessionStorage.getSessionStorageValue('userLanguage'),
                email: $scope.email
             }
             ajax.geteSimtokengeneration(requestData).then(
                function (data) {
                 var simcardetails = data;
                 if(simcardetails.tokenId){
                    appState.switchView('eSimOtp');
                    dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "shareeSimsuccess"});
                 } 
                });
          };
        $scope.getbackwirelesspage = function() {
            appState.switchView('/wireless');
            dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "shareCancelbutton"});
          };
          resource.onChanged(function () {
            $scope.lang = userLanguage();
            if($scope.lang == "en"){
              $scope.email_placeholder="Enter email address";
            }else{
              $scope.email_placeholder="Entrer votre adresse courriel";
            }
        }, $scope);

    }
})();
(function () {
    'use strict';
    angular.module('totesApp').controller('myeSimotpmodalController', eSimotpmodalController);

    eSimotpmodalController.$inject = ['$scope', '$rootScope', '$sce', 'settings', '$browser', 'localStorage', 'user', 'appState','ute.datalayer.common.service'];
   
    function eSimotpmodalController($scope, $rootScope, $sce, settings, $browser, localStorage, user, appState,dataLayerService) {
      $scope.ctnNumber = localStorage.getLocalStorageValue('ctnNumber');
      $scope.randomOtp = localStorage.getLocalStorageValue('randomEmailotp');
      $scope.eSimemail = localStorage.getLocalStorageValue('eSimemail');
        $scope.getbackwirelessdashboard = function() {
            appState.switchView('/wireless');
            dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "esimOtpbackTodashboard"});
          };

    }
})();
(function () {
    'use strict';
    angular.module('totesApp').controller('myeSimsuccessmodalController', eSimsuccessmodalController);

    eSimsuccessmodalController.$inject = ['$scope', '$rootScope', '$sce', 'settings', '$browser', 'localStorage', 'user', 'appState'];
   
    function eSimsuccessmodalController($scope, $rootScope, $sce, settings, $browser, localStorage, user, appState) {
      $scope.ctnNumber = localStorage.getLocalStorageValue('ctnNumber');
      $scope.randomOtp = localStorage.getLocalStorageValue('randomEmailotp');
      $scope.eSimemail = localStorage.getLocalStorageValue('eSimemail');
        $scope.getbackwirelessdashboard = function() {
            appState.switchView('/wireless');
          };

    }
})();
(function () {
    'use strict';
    angular.module('totesApp').controller('myeSimtransfererrorController', eSimtransfererrorController);

    eSimtransfererrorController.$inject = ['$scope', '$rootScope', '$sce', 'settings', '$browser', 'localStorage', 'user', 'appState','userLanguage','resource'];
   
    function eSimtransfererrorController($scope, $rootScope, $sce, settings, $browser, localStorage, user, appState,userLanguage,resource) {
      $scope.ctnNumber = localStorage.getLocalStorageValue('ctnNumber');
      $scope.randomOtp = localStorage.getLocalStorageValue('randomEmailotp');
      $scope.eSimemail = localStorage.getLocalStorageValue('eSimemail');
      $scope.eSimerrorcode = localStorage.getLocalStorageValue('esimerrorcode');
          if($scope.eSimerrorcode == 'No eSIM compatible device'){
            if($scope.lang == "en"){
              $scope.transferesimerror_details = resource.get('transferesim_errordetails');
              $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetails');
            }else{
              $scope.transferesimerror_details = resource.get('transferesim_errordetails');
              $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetails');
            }
            resource.onChanged(function () {
              $scope.lang = userLanguage();
              if($scope.lang == "en"){
                $scope.transferesimerror_details = resource.get('transferesim_errordetails');
                $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetails');
              }else{
                $scope.transferesimerror_details = resource.get('transferesim_errordetails');
                $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetails');
              }
          }, $scope);
          }
          else if($scope.eSimerrorcode == 'BIZERROR'){
            if($scope.lang == "en"){
              $scope.transferesimerror_details = resource.get('transferesim_errordetailsone');
              $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetailsone');
            }else{
              $scope.transferesimerror_details = resource.get('transferesim_errordetailsone');
              $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetailsone');
            }
            resource.onChanged(function () {
              $scope.lang = userLanguage();
              if($scope.lang == "en"){
                $scope.transferesimerror_details = resource.get('transferesim_errordetailsone');
                $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetailsone');
              }else{
                $scope.transferesimerror_details = resource.get('transferesim_errordetailsone');
                $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetailsone');
              }
          }, $scope);
          }else if($scope.eSimerrorcode == 'TECHERROR'){
            if($scope.lang == "en"){
              $scope.transferesimerror_details = resource.get('transferesim_errordetailstwo');
              $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetailstwo');
            }else{
              $scope.transferesimerror_details = resource.get('transferesim_errordetailstwo');
              $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetailstwo');
            }
            resource.onChanged(function () {
              $scope.lang = userLanguage();
              if($scope.lang == "en"){
                $scope.transferesimerror_details = resource.get('transferesim_errordetailstwo');
                $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetailstwo');
              }else{
                $scope.transferesimerror_details = resource.get('transferesim_errordetailstwo');
                $scope.transferesimerrorbody_details = resource.get('transferesim_errorbodydetailstwo');
              }
          }, $scope);
          }
        $scope.getbackwirelessdashboard = function() {
          if($scope.eSimerrorcode == 'No eSIM compatible device'){
            localStorage.setLocalStorageValue('esimcodestatus',"transferesimlinkhide");
            localStorage.deleteLocalStorageValue('transfereSimbrtswitch');
            appState.switchView('/eSimcard');
          }else if($scope.eSimerrorcode == 'TECHERROR'){
            localStorage.setLocalStorageValue('esimcodestatus',"transferesimlinkshow");
            localStorage.deleteLocalStorageValue('transfereSimbrtswitch');
            appState.switchView('/eSimcard');
          }else if($scope.eSimerrorcode == 'BIZERROR'){
            localStorage.setLocalStorageValue('esimcodestatus',"transferesimlinkhide");
            localStorage.deleteLocalStorageValue('transfereSimbrtswitch');
            appState.switchView('/eSimcard');
          }
          };

    }
})();
(function () {
    'use strict';
    angular.module('totesApp').controller('myeSimtransaferController', eSimtransferController);

    eSimtransferController.$inject = ['$scope', '$rootScope', '$sce', 'settings', '$browser', 'localStorage', 'user', 'appState','sessionStorage','ajax','userLanguage','resource','ute.datalayer.common.service'];
   
    function eSimtransferController($scope, $rootScope, $sce, settings, $browser, localStorage, user, appState,sessionStorage,ajax,userLanguage,resource,dataLayerService) {
      $scope.ctnNumber = localStorage.getLocalStorageValue('ctnNumber'),
      $scope.lang = userLanguage();
      $scope.devicevalueid= "";
        $scope.geteSimdevicedetail = function() {
          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "esimtransfer"});
            var requestData ={
                account: localStorage.getLocalStorageValue('accountNumber'),
                subscriber: $scope.ctnNumber,
             }
             ajax.geteSimdevicedetails(requestData).then(
                function (data) {
                 var simcardetails = data;
                 if(simcardetails){
                  $scope.transferdata = simcardetails.deviceDetailsList;
                 }else{
                  localStorage.setLocalStorageValue('esimerrorcode','No eSIM compatible device');
                  appState.switchView('/eSimtransfererror');
                 }
                },function(error) {
                  if(error.data.data.status == "NOCONTENT"){
                    localStorage.setLocalStorageValue('esimerrorcode','No eSIM compatible device');
                    appState.switchView('/eSimtransfererror');
                    dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "transferesimNodevicelist"});
                  }else if(error.data.data.status == "TECHERROR"){
                    localStorage.setLocalStorageValue('esimerrorcode','TECHERROR');
                    appState.switchView('/eSimtransfererror');
                  }else if(error.data.data.status == "BIZERROR"){
                    localStorage.setLocalStorageValue('esimerrorcode','BIZERROR');
                    appState.switchView('/eSimtransfererror');
                  }
                });
          };
          $scope.geteSimdevicedetail();
          $scope.deviceValuechange = function(value) {
            if(value){
              var devicedetails = JSON.parse(value);
            }
           if(devicedetails){
            dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "transferesimdevicelist"});
            $scope.devicefieldvalue =true;
            $scope.eidNumber = devicedetails.eidNumber;
            $scope.imeiNumber = devicedetails.imei;
           }else{
            $scope.devicefieldvalue =false;
           }
          
           }

          
          $scope.deviceValue = function(){
            // dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "eSimqrcodecheckbox"});
            $scope.isVslidbutton = false;
            $scope.successfullcheckbox ? $scope.isVslidbutton : true;
          }
        $scope.transfereSimpage = function() {
             var requestData ={
                	accountNumber: localStorage.getLocalStorageValue('accountNumber'), 
		            franchise : "Rogers",
	             	sku: "",
	            	companyCode: "",
	           	usedIndicator: "N",
		            imeiNumber:  $scope.imeiNumber,
		          eidNumber : $scope.eidNumber,
		          subscriberNumber: $scope.ctnNumber,
	            	simType: "D",
	            	oldNumber: localStorage.getLocalStorageValue('oldSimNumber'),
             }
             ajax.getreservseamlesseSim(requestData).then(
                function (data) {
                 var simcardetails = data;
                 if(simcardetails.status == 'Success'){
                    appState.switchView('eSimtransfersuccess');
                    dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "transferesimSuccess"});
                 }
                },
               function(error) {
                if(error.data.data.status == "TECHERROR"){
                  localStorage.setLocalStorageValue('esimerrorcode','TECHERROR');
                  dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "transferesim500Error"});
                  appState.switchView('/eSimtransfererror');
                }else if(error.data.data.status == "BIZERROR"){
                  localStorage.setLocalStorageValue('esimerrorcode','BIZERROR');
                  dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "transferesim422Error"});
                  appState.switchView('/eSimtransfererror');
                }
              });
            // dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "shareCancelbutton"});
          };
          resource.onChanged(function () {
            $scope.lang = userLanguage();
            if($scope.lang == "en"){
              $scope.transfer_placeholder= resource.get('transfer_dropdownlabel');
            }else{
              $scope.transfer_placeholder= resource.get('transfer_dropdownlabel');
            }
        }, $scope);

    }
})();
(function () {
    'use strict';
    angular.module('totesApp').controller('myeSimtransfersuccessController', eSimtransfersuccessController);

    eSimtransfersuccessController.$inject = ['$scope', '$rootScope', '$sce', 'settings', '$browser', 'localStorage', 'user', 'appState'];
   
    function eSimtransfersuccessController($scope, $rootScope, $sce, settings, $browser, localStorage, user, appState) {
      $scope.ctnNumber = localStorage.getLocalStorageValue('ctnNumber');
      $scope.randomOtp = localStorage.getLocalStorageValue('randomEmailotp');
      $scope.eSimemail = localStorage.getLocalStorageValue('eSimemail');
        $scope.getbackwirelessdashboard = function() {
            appState.switchView('/wireless');
          };

    }
})();
( function () {
  'use strict';

   angular.module('totesApp').controller('MyrEasErrorController', MyrEasErrorController);

   MyrEasErrorController.$inject = ['$browser', '$location', '$window', '$scope', 'localStorage', 'janrainOidc', 'userLanguage', 'ute.datalayer.common.service'];
   function MyrEasErrorController($browser, $location, $window, $scope, localStorage, janrainOidc, userLanguage, dataLayerService) {

      $scope.langLinkId = "languageFrench";
      $scope.errorTitle = "_eas_error_title_";
      $scope.errorMessage = "_eas_error_message_";
      $scope.closeBtn = "_eas_error_close";
      $scope.errorCode = "ue04";

      var accountSuspendedPayload = {
        errors: [
           {
              category: "login",
              type: "business logic",
              API: "login",
              message: "Access to this Rogers Business account has been suspended. Please contact us for more details."
           }
        ],
        events: {
          error: true
        },
        page: {
          name: "account-suspended",
          hierarchy: ["login"]
        },
        site: {
          name: "R-Biz"
        }
      };
      var sessionExpiredPayload = {
        errors: [
           {
              category: "login",
              type: "user",
              API: "login",
              message: "Your privacy is essential and to ensure your personal details are safe, we ended the previous session due to inactivity."
           }
        ],
        events: {
          error: true
        },
        page: {
          name: "session-timeout",
          hierarchy: ["login"]
        },
        site: {
          name: "R-Biz"
        }
      }

      function init() {
        if (userLanguage() == "fr" || userLanguage() == "FR") {
          $scope.langLinkId = "languageFrench";
        } else {
          $scope.langLinkId = "languageEnglish";
        }

        var errCode = $browser.cookies()["EAS_ERROR"];
        if (errCode) {
          var urlParams = new URLSearchParams(errCode);
          $scope.errorCode = urlParams.get('error_code');
          if (!$scope.errorCode) {
            $scope.errorCode = urlParams.get('error');
          }
          if ($scope.errorCode) {
            $scope.errorCode = $scope.errorCode.toLowerCase();
          } else {
            $location.path("/signin");
          }

          if ($scope.errorCode == "cancel_password") {
            document.cookie = 'EAS_ERROR=; domain=.rogers.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
            $window.location.href = '../../../business/ute/smb/transactions/uteMyRogersProfile';
          } else if ($scope.errorCode == "se01") {
            var errorCountStr = localStorage.getLocalStorageValue("easErrorCount");
            var prevErrorCount = errorCountStr ? parseInt(errorCountStr) : 0;
            localStorage.setLocalStorageValue("easErrorCount", (prevErrorCount + 1) + "");
            if (prevErrorCount < 3) {
              $scope.errorMessage = "_eas_error_se01_retry_message";
              $scope.errorTitle = "_eas_error_se01_retry_title";
              $scope.closeBtn = "_eas_error_tryagain";
            } else {
              $window.localStorage.removeItem("easErrorCount");
              $scope.errorTitle += $scope.errorCode;
              $scope.errorMessage += $scope.errorCode;
            }
          }
        }
        if ($scope.errorCode != "se01") {
          $scope.errorTitle += $scope.errorCode;
          $scope.errorMessage += $scope.errorCode;
        }

        triggerTrackData();
      };

      function triggerTrackData() {
        if ($scope.errorCode == "bl02") {
          dataLayerService.track(accountSuspendedPayload, false, [4, 1, 0]);
        } else if ($scope.errorCode == "ue02") {
          dataLayerService.track(sessionExpiredPayload, false, [4, 1, 0]);
        }
      }

      $scope.closeMessage = function() {
        document.cookie = 'EAS_ERROR=; domain=.rogers.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
        if ($scope.errorCode == "bl02") {
          $location.path("/signin");
        } else if ($scope.errorCode == "ue02") {
          $location.path("/signin");
        } else if ($scope.errorCode == "ue04") {
          $location.path("/signin");
        } else if ($scope.errorCode == "ue06") {
          $location.path("/signin");
        } else if ($scope.errorCode == "ue07") {
          $location.path("/signin");
        } else if ($scope.errorCode == "ue08") {
          $location.path("/signin");
        } else if ($scope.errorCode == "se01") {
          var errorCountStr = localStorage.getLocalStorageValue("easErrorCount");
          var errorCount = errorCountStr ? parseInt(errorCountStr) : 0;
          if (errorCount < 4) {
            janrainOidc.signIn();
            return;
          }
          $location.path("/signin");
        } else if ($scope.errorCode == "cancel_password") {
          $window.location.href = '../../../business/ute/smb/transactions/uteMyRogersProfile';
        } else {
          $location.path("/signin");
        }
      };

      $scope.toggleLang = function() {

        if ($scope.langLinkId == "languageEnglish") {
          $scope.langLinkId = "languageFrench";
          userLanguage("en");
        } else {
          $scope.langLinkId = "languageEnglish";
          userLanguage("fr");
        }
      };

      init();
   }
})();

( function () {
  'use strict';

   angular.module('totesApp').controller('MyrEasSuccessController', MyrEasSuccessController);

   MyrEasSuccessController.$inject = ['$location', '$window', '$scope', '$browser', '$http', 'userLanguage', 'localStorage', 'appState'];
   function MyrEasSuccessController($location, $window, $scope, $browser, $http, userLanguage, localStorage, appState) {
      $scope.langLinkId = "languageFrench";

      function init(){
        if (userLanguage() == "fr" || userLanguage() == "FR") {
          $scope.langLinkId = "languageFrench";
        } else {
          $scope.langLinkId = "languageEnglish";
        }
        if ($browser.cookies()['easFlowTypeForState'] != "password") {
          var consentCookie = $browser.cookies().CONSENT_STATE;
          var splitCookie = consentCookie.split('&');
          var codeValue;
          var stateValue;
          if (splitCookie && splitCookie.length > 0) {
              codeValue = splitCookie[0].split('=');
              stateValue = splitCookie[1].split('=');
          }
          var UUIDNonce = localStorage.getLocalStorageValue('nonce');
          var urlPrefix = "/web/smb/api";
          var tokenData = {
                 code: codeValue && codeValue.length > 0 && codeValue[1],
                 state: stateValue && stateValue.length > 0 && stateValue[1],
                 nonce: UUIDNonce
          };
          $http.post(urlPrefix + "/business/v1/token", tokenData).then(function (response) { });
        }
      };

      $scope.closeMessage = function() {
        if ($browser.cookies()['easFlowTypeForState'] != "password") {
          $window.location.href = '../../../business/ute/smb/transactions/uteMyRogersProfile';
        } else {
          appState.switchView('accountOverview');
        }
      };

      $scope.toggleLang = function() {
        if ($scope.langLinkId == "languageEnglish") {
          $scope.langLinkId = "languageFrench";
          userLanguage("fr");
        } else {
          $scope.langLinkId = "languageEnglish";
          userLanguage("en");
        }
      };

     init();
   }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrForgetPasswordService', forgetPasswordService);

  forgetPasswordService.$inject = ['$q', '$timeout'];

  /* @ngInject */
  function forgetPasswordService($q, $timeout) {

    // Public API
    var service = {
      setCookie: setCookie,
      getSmtoken: getSmtoken,
      getUsername: getUsername,
      getSmauthreason: getSmauthreason,
      getSmagentname: getSmagentname,
      getTarget: getTarget
    };

    // private
    var data = {
      smtoken: undefined,
      username: undefined,
      smauthreason: undefined,
      smagentname: undefined,
      target: undefined
    };

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    // TODO where is cookie here?
    /**
     *
     * @param params
     * @returns {*}
     */
    function setCookie(params) {
      var defer = $q.defer();
      // $cookie gets updated every 100 ms
      // use timeout to let data have time to be ready
      $timeout(function () {
        data.smtoken = params.SMTOKEN;
        data.username = params.USERNAME;
        data.smauthreason = params.SMAUTHREASON;
        data.smagentname = params.SMAGENTNAME;
        data.target = params.TARGET;
        defer.resolve(data);
      }, 125);

      return defer.promise;
    }

    function getSmtoken() {
      return data.smtoken;
    }

    function getUsername() {
      return data.username;
    }

    function getSmauthreason() {
      return data.smauthreason;
    }

    function getSmagentname() {
      return data.smagentname;
    }

    function getTarget() {
      return data.target;
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:ForgotPasswordController
   * @description
   * # ForgotPasswordController
   * Controller of the totesApp
   */

  angular.module('totesApp').controller('MyrForgotPasswordController', ForgotPasswordController);

  ForgotPasswordController.$inject = ['$scope', 'ajax','$rootScope', 'resource', 'userLanguage', 'appState', 'errorHandler', 'myrNotificationBannerService'];

  /* @ngInject */
  function ForgotPasswordController($scope, ajax, $rootScope, resource, userLanguage, appState, errorHandler, notificationBannerService) {
    $scope.questionId = 1;
    $scope.questions = null;
    $scope.numAttempts = 0;
    $scope.loadingDataIndicator = false;

    notificationBannerService.cleanBanner('successMessage');

    var errorCode = null;

    /* Added for BoldChat changes*/
    $scope.setStaticChatButtonId = function () {
      if(userLanguage() == 'en'){
        $scope.boldChatButtonId = 'S_BSS_PassRest';
        $scope.boldChatButtonDiv = 'S_BSS_PassRest_div';
        $scope.boldChatButton = 'chatButtonForgotPasswordEn';
      } else {
        $scope.boldChatButtonId = 'S_BSS_PassRest_Fr';
        $scope.boldChatButtonDiv = 'S_BSS_PassRest_Fr_div';
        $scope.boldChatButton = 'chatButtonForgotPasswordFr';
      }
    };

    $scope.setStaticChatButtonId();

    $rootScope.$on('languageChanged', function (){
      $scope.setStaticChatButtonId();
    });

    $scope.$extend({
      email: '',
      //subModule: function () {
      //    return appState.submodule;
      //},

      //second form
      success: false,
      isError: false,
      errorDescription: '',
      errorCode: '',
      emailRequiredMessage: null,
      emailInvalidMessage: null,
      failedMessage: '',
      fn: '',
      cToken: '',
      isAnswerValid: true,
      partNo: '1',
      submit: function () {

        var form = $scope.form1;

        if (form.$valid) {
          $scope.loadingDataIndicator = true;
          ajax.getSecureQuestion($scope.email).then(
            function (data) {
              if (data === undefined) {
                $scope.isError = true;
                return false;
              } else {
                $scope.isError = false;
                $scope.fn = data.fn;
                $scope.cToken = data.cToken;
                $scope.questionId = data.question;
                //redirect to secure question screen
                //appState.switchView('forgetPassword/part2');

                $scope.partNo = '2';
                //tag the second page
                tagSecurityQuestion();
                $scope.loadingDataIndicator = false;
              }
            },
            function (error) {
              $scope.errorCode = error.data.data.errorCode;
              $scope.isError = true;
              $scope.errorDescription = errorHandler.getErrorDescription(error);
              $scope.loadingDataIndicator = false;
            }
          );
        }
      },
      submitFinal: function () {
        var form = $scope.form2;

        if (form.$valid) {
          $scope.numAttempts++;
          $scope.loadingDataIndicator = true;
          ajax.forgetPassword($scope.selectedAnswer, $scope.fn, $scope.cToken, $scope.email, $scope.numAttempts).then(function (data) {
            if (data === undefined) {
              $scope.isError = true;
              $scope.failedMessage = resource.get('login_invalid_email_sent_desc');
              $scope.failedMessage = $scope.failedMessage.format($scope.email);

              return false;
            } else {
              $scope.isError = false;
              $scope.isAnswerValid = true;
              $scope.success = true;
              $scope.loadingDataIndicator = false;

            }
            //tag success email sent
            tagEmailSent();

          }, function (error) {
//								console.log(error);
            $scope.errorCode = error.data.data.errorCode;
            $scope.isError = true;
            $scope.errorDescription = errorHandler.getErrorDescription(error);
            $scope.loadingDataIndicator = false;
          });
        }
      }
    });

    resource.onChanged(function () {
      $scope.questions = resource.get('login_security_questions');
    }, $scope);

    resource.onChanged(function () {
      $scope.errorMessAnswer = resource.get('login_invalid_answer_required');
    }, $scope);

    resource.onChanged(function () {
      $scope.emailRequiredMessage = resource.get('login_forget_pwd_required');
    }, $scope);

    resource.onChanged(function () {
      $scope.emailInvalidMessage = resource.get('login_forget_pwd_email_invalid');
    }, $scope);

    $scope.question = function () {
      return $scope.questions[$scope.questionId];
    };
    resource.onChanged(function () {
      notificationBannerService.sendMessageKey('successMessage', 'login_reset_pwd_success');
    }, $scope);

    resource.onChanged(function () {
      // console.log($scope.errorCode);
      $scope.errorDescription = resource.get($scope.errorCode);

    }, $scope);

    function tagForgetPassword() {
      appState.tagging(['_trackPageView',
        {pn: 'home:reset-password:enter-email'},
        {eVar13: 'MyRogers - Forgot Password'},
        {event5: ''}
      ]);
    }

    function tagSecurityQuestion() {
      appState.tagging(['_trackPageView',
        {pn: 'home:reset-password:security-question'}
      ]);
    }

    function tagEmailSent() {
      appState.tagging(['_trackPageView',
        {pn: 'home:reset-password:check-your-email'}
      ]);
    }

    tagForgetPassword();

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrForgotUserNameController
   * @description
   * # MyrForgotUserNameController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrForgotUserNameController', ForgotUserNameController);

  ForgotUserNameController.$inject = ['$scope', '$rootScope', 'userLanguage', 'ajax', 'resource', 'appState', 'errorHandler', 'myrNotificationBannerService'];

  /* @ngInject */
  function ForgotUserNameController($scope, $rootScope, userLanguage, ajax, resource, appState, errorHandler, notificationBannerService) {

    notificationBannerService.cleanBanner('successMessage');

    var errorCode = null;
    console.log("forgotUsername-start");
    /* Added for BoldChat changes */
    $scope.setStaticChatButtonValues = function () {
      if(userLanguage() == 'en'){
        $scope.boldChatButtonId = 'S_BSS_UsrNameRest';
        $scope.boldChatButtonDiv = 'S_BSS_UsrNameRest_div';
        $scope.boldChatButton = 'chatButtonForgotUserNameEn';
      } else {
        $scope.boldChatButtonId = 'S_BSS_UsrNameRest_Fr';
        $scope.boldChatButtonDiv = 'S_BSS_UsrNameRest_Fr_div';
        $scope.boldChatButton = 'chatButtonForgotUserNameFr';
      }
    };

    $scope.setStaticChatButtonValues();

    $rootScope.$on('languageChanged', function (){
      $scope.setStaticChatButtonValues();
    });

    $scope.$extend({
      email: '',
      subModule: function () {
        return appState.submodule;
      },
      //second form
      success: false,
      isError: false,

      failedMessage: '',
      errorDescription: '',
      fn: '',
      cToken: '',
      emailRequiredMessage: null,
      emailInvalidMessage: null,
      isEmailValid: true,
      errorCode: '',
      loadingDataIndicator: false,
      submit: function () {
        var form = $scope.form1;

        if (form.$valid) {
          $scope.loadingDataIndicator = true;
          ajax.getRegisteredUserName($scope.email).then(
            function (data) {
              if (data === undefined) {
                $scope.isError = true;
              } else {
                console.log("forgotUsername-complete");
                $scope.success = true;
              }
              $scope.loadingDataIndicator = false;
            },
            function (error) {
              console.log("forgotUsername-error");
              $scope.isError = true;
              errorCode = error.data.data.errorCode;
              $scope.errorDescription = errorHandler.getErrorDescription(error);
              tagError($scope.errorDescription);
              $scope.loadingDataIndicator = false;
            }
          );
        }
      }
    });

    resource.onChanged(function () {

      notificationBannerService.sendMessageKey('successMessage', 'login_forget_username_success');
    }, $scope);

    resource.onChanged(function () {
      $scope.failedMessage = resource.get('login_invalid_email_sent_desc');
    }, $scope);

    resource.onChanged(function () {
      $scope.emailRequiredMessage = resource.get('login_forget_pwd_required');
    }, $scope);

    resource.onChanged(function () {
      $scope.emailInvalidMessage = resource.get('login_forget_pwd_email_invalid');
    }, $scope);

    $scope.failedMessageX = function () {
     return $scope.failedMessage.format($scope.email);
    };

    resource.onChanged(function () {
      $scope.errorDescription = resource.get(errorCode);
    }, $scope);

    function tagForgetUserName() {
      appState.tagging(['_trackPageView',
        {pn: 'home:reset-password:enter-email'},
        {eVar13: 'MyRogers - Forgot Password'},
        {event5: ''}
      ]);
    }

    function tagError(message) {
      appState.tagging([
        '_trackLink',
        {eVar49: message},
        {event15: ''}
      ]);
    }

    tagForgetUserName();
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
/**
   * @ngdoc function
   * @name totesApp.controller:goToDatamartController
   * @description
   * # goToDatamartController
   * Controller of the totesApp
   */

  angular.module('totesApp').controller('goToMyBusinessHubController', GoToMyBusinessHubController);

  GoToMyBusinessHubController.$inject = ['$scope', '$rootScope','myrSigninService','$window','ocpService','$timeout'];

  /* @ngInject */
  function GoToMyBusinessHubController($scope, $rootScope, signinService, $window, ocpService, $timeout) {
    // redirect to mybusinesshub page
    signinService.mbhUrlConfig().then(function(urlResponse){
        MBHLauncher.initialize({
          launcherLanguage: ocpService.userLang,
          launcherURL: '/launcher/v-3/mbh-launcher.html',
          inactivityTime: 1000 * 2 * 60,
          heartBeatInterval: 1000 * 1 * 60,
          portalId: 'BSSS',
          token: '',
          logoutRedirect: window.location.origin + '/web/smb/bss/#/signin',
          enableCheckInactive: false
        },true);
        MBHLauncher.setLanguage(ocpService.userLang);
        MBHLauncher.setPortalId('BSSS');
        // MBHLauncher.setCookie($browser.cookies().R1IDSMSESSION);
        ocpService.launcherInitialized = true;
        $scope.launcherEnabled = true;
        $scope.mbhUrl = localStorage.getLocalStorageValue('MBHUrl');
        $timeout(function(){
          $rootScope.mbhUrl = urlResponse.dataManager;
          //console.log('$rootScope.mbhUrl', $rootScope.mbhUrl);
          $window.location.href = $rootScope.mbhUrl+"?redirectFrom=Email";
        },2000);

      }
    )}
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrGuestOverviewController
   * @description
   * # MyrGuestOverviewController
   * Controller of the totesApp
   */

  angular.module('totesApp').controller('MyrGuestOverviewController', GuestOverviewController);

  GuestOverviewController.$inject = ['$scope', 'appState', '$modal', '$rootScope', 'settings', '$window', 'userLanguage','brtCheck', '$location', 'myrAccountListService', 'myrSigninService'];

  /* @ngInject */
  function GuestOverviewController($scope, appState, $modal, $rootScope, settings, $window, userLanguage,brtCheck, $location, myrAccountListService, signinService) {

 $scope.linkAccount = function () {
              console.log("Test Link ACct1 ");
               signinService.mbhUrlConfig().then(function(urlResponse){
                                $window.location.href = urlResponse.dashboard+"?openLinkAcctModal=true";
                             });
              }
    $scope.$extend({
      myServicesList: [
        {
          icon: 'rui-icon-wireless',
          serviceType: 'service_wireless',
          serviceDetail: null,
          linkText: '_add',
          linkURL: 'https://www.rogers.com/web/content/wireless_plan_landing'
        },
        {
          icon: 'rui-icon-internet',
          serviceType: 'service_internet',
          serviceDetail: null,
          linkText: '_add',
          linkURL: 'https://www.rogers.com/web/link/hispeedBrowseFlowDefaultPlans'
        },
        {
          icon: 'rui-icon-tv',
          serviceType: 'service_tv',
          serviceDetail: null,
          linkText: '_add',
          linkURL: 'https://www.rogers.com/web/link/tv/build-your-tv-package?flowType=dbchangepkg'
        },
        {
          icon: 'rui-icon-home-phone',
          serviceType: 'service_phone',
          serviceDetail: null,
          linkText: '_add',
          linkURL: 'https://www.rogers.com/web/link/hpValuePlanFlow'
        },
        {
          icon: 'rui-icon-home-monitoring',
          serviceType: 'service_monitoring',
          serviceDetail: null,
          linkText: '_add',
          linkURL: 'https://www.rogers.com/web/content/smart-home-monitoring-solutions-new'
        }
      ]
    });

    $scope.lang = userLanguage();

    $rootScope.$on('languageChanged', function (){
      $scope.lang = userLanguage();
    });

 /*   brtCheck.linkAccount();*/

    // Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal

    // Setup link account modal
    $scope.open = function (size) {

      brtCheck.linkAccount();
      $location.search('directLanding', null);
      myrAccountListService.isOcp="";
      myrAccountListService.isOcpCheck="";
      brtCheck.cam();
      // localhost exception
      var serverHack = '/web/smb/bss';
      if (settings.isLocal) {
        serverHack = '';
      }

      $rootScope.modal = $modal.open({
        templateUrl: 'views/modals/linkAccountModalCtrl.html',
        controller: 'MyrLinkAccountModalController',
        size: size,
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {
          thanksModal: function () {
            // Open Thank you / Community links modal
            if (appState.newRegistration) {
              appState.newRegistration = false;
              //$scope.thanksModal();
            }
            return true;
          }
        }
      });

      $rootScope.modal.result.then(function () {
        // on OK behaviour
        if($rootScope.brtLinkAccount == true){
          $window.location.href = '../../../business/ute/smb/transactions/uteAccountAssociation';
        }else if ($rootScope.brtLinkAccount == false){
          //appState.switchView('linkaccount');
          signinService.mbhUrlConfig().then(function(urlResponse){
             $window.location.href = urlResponse.dashboard+"?openLinkAcctModal=true";
           });
        }
      }, function () {
        // on Cancel behaviour
      });
    };

     $scope.isSafariBrowser = function(){
           var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');
           return (isSafari);
     }

    /*  <<<<<<<<<<<<<<<<<<  same bit of code on Account overview page - Start
    // Setup Thank you / Community links modal
    $scope.thanksModal = function () {
      // localhost exception
      var serverHack = '/web/totes';
      if (settings.isLocal) {
        serverHack = '';
      }

      $rootScope.modal = $modal.open({
        templateUrl: serverHack + '/views/modals/thankYouModalCtrl.html',
        controller: 'MyrThankYouModalController',
        size: 'thankYouDesign',
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });

      $rootScope.modal.result.then(function () {
        // on OK behaviour
        $window.location.href = 'http://communityforums.rogers.com/t5/community/categorypage/category-id/EnglishCommunity?profile.language='+ userLanguage();
      }, function () {
        // on Cancel behaviour
      });
    };
    /////  <<<<<<<<<<<<<<<<<<  same bit of code on Account overview page - End
    //*/


    // Show modal windows in right order
    // Open link account modal
    if (!appState.noLinking) {
      $scope.open();
    } else {
 //     // Open Thank you / Community links modal
 //     if (appState.newRegistration) {
 //       appState.newRegistration = false;
 //       $scope.thanksModal();
 //     }
    }

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrLinkAccountModalController', LinkAccountModalController);

  LinkAccountModalController.$inject = ['$scope', '$modalInstance', '$rootScope', '$window', 'myrSigninService'];

  /* @ngInject */
  function LinkAccountModalController($scope, $modalInstance, $rootScope, $window, signinService) {

    $scope.ok = function () {
      signinService.mbhUrlConfig().then(function(urlResponse){
        $window.location.href = urlResponse.dashboard+"?openLinkAcctModal=true";
        $modalInstance.close('ok');
        $rootScope.modal = null;
      });
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrThankYouModalController', thankYouModalController);

  thankYouModalController.$inject = ['$scope', '$modalInstance', '$rootScope'];

  /* @ngInject */
  function thankYouModalController($scope, $modalInstance, $rootScope) {

    $scope.ok = function () {
      $modalInstance.close('ok');
      $rootScope.modal = null;
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:IgniteInternetCtrl
   * @description
   * # IgniteInternetCtrl
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrIgniteInternetController', IgniteInternetController);

  IgniteInternetController.$inject = ['$scope','resource', 'userLanguage', 'localStorage', '$rootScope', 'myrIgniteInternetDashboardService', '$timeout'];

  /* @ngInject */
  function IgniteInternetController($scope, resource, userLanguage, localStorage, $rootScope, igniteInternetDashboardService, $timeout) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    $scope.selectedAccount = {};
    $scope.selectedAccount.accountName = {};
    $scope.selectedAccount.accountNumber = localStorage.getLocalStorageValue('igniteInternetAccountNumber');
    $scope.selectedAccount.ban = localStorage.getLocalStorageValue('accountNumber');
    $scope.finalDataReceived = false;
    $scope.showPrdDetails = false,
    $scope.offerCaption = '',
    $scope.modemList = [];

    //Start - Bold chat changes to display floating chat in Wireless Dashboard
    $scope.invokeFloatingChat = function () {
      var buttonId;
      setTimeout(function() {  //timeout for not loading tv dashboard incident
      if(userLanguage() === 'en'){
        buttonId = getBDId('F_BSS_TVDbrd');
        floatingLiveChatButtonUTE(buttonId);
      }
      }, 5000);
    };

    $scope.$on('$stateChangeStart', function() {
      removeChatButtons('bcFloat');
    });


    $rootScope.$on('languageChanged', function (){
      angular.element('.bcFloat').remove();
      $scope.invokeFloatingChat();
    });

    $scope.invokeFloatingChat();

    // resource.onChanged(function () {
    //   messageBoxDom();
    // }, $scope);

    $scope.processResponse = function(res) {
      const productDetails = res.igniteInternetProductDetails ? res.igniteInternetProductDetails : null;
      if (productDetails !== null) {
        const internetpackage = productDetails.filter(function (item)  {
          return item.productName === 'HSI' && item.lob === 'Internet';
        })

        const modemList = productDetails.filter(function (item) {
          return item.productName === 'Modem' && item.lob === 'Internet';
        })
        $scope.offerCaption = internetpackage.length > 0 ? internetpackage[0].offerCaption :  [];
        $scope.modemList = modemList.length > 0 ? modemList :  [];
        $scope.showPrdDetails = true;
      }else {
        $scope.showPrdDetails = false;
        $scope.offerCaption = '';
        $scope.modemList = []
      }

    }

    $scope.loadIgniteInterntDashboard = function () {
      $scope.loadingProdDetails = true;
      $scope.displayContentTvDashboard = false;
      var customerBillingProfileID = localStorage.getLocalStorageValue('customerBillingProfileID');

      if (!$scope.selectedAccount.accountNumber) {
        return;
      }
      igniteInternetDashboardService.loadIgniteInternetDashboard(customerBillingProfileID, userLanguage(), false).then(
        function (response) {
          $scope.processResponse(response);
          if (response.cachedResultInfo) {
            if (response.cachedResultInfo.expired) {
              igniteInternetDashboardService.loadIgniteInternetDashboard(customerBillingProfileID, userLanguage(), true).then(
                function (response) {
                  $scope.finalDataReceived = true;
                  $scope.processResponse(response);
                },
                function (error) {
                  $scope.displayContentTvDashboard = false;
                  $scope.loadingProdDetails = false;

                  // Error handling - 555 exception
                  if (error.data.status === 555) {
                    $scope.errorCode = error.error.errorCode;
                    $scope.errorMessage = error.error.message;
                  } else {
                    $scope.errorMessage = resource.get('error_tv_feeder');
                  }
                });
            } else {
              $scope.finalDataReceived = true;
            }
          }
        },
        function (error) {
          $scope.displayContentTvDashboard = false;
          $scope.loadingProdDetails = false;

          // Error handling - 555 exception
          if (error.data.status === 555) {
            $scope.errorCode = error.error.errorCode;
            $scope.errorMessage = error.error.message;
          } else {
            $scope.errorMessage = resource.get('error_tv_feeder');
          }
        });
    };

    // $scope.onOmnitureClickTv = function (option) {
    //   appState.tagging(option);
    // };

    //$scope.loadTvFeed();

    $scope.loadIgniteInterntDashboard();

    resource.onChanged(function () {

      var oldLang = $scope.lng;

      $scope.lng = userLanguage();
      $scope.lang = userLanguage() + '-CA';
      $scope.langUpper = userLanguage().toUpperCase();

      if (oldLang !== $scope.lng) {
        $scope.loadIgniteInterntDashboard();
      }

      $scope.dollarSignB = userLanguage() === 'en' ? '$' : '';
      $scope.dollarSignA = userLanguage() === 'fr' ? '$' : '';

      // $scope.postToRogersUrls = [
      //   {url: '/web/myrogers/torcom/link/tv/build-your-tv-package' + '?setLanguage=' + $scope.lng, flowId: 'dbchangechnlortp'},
      //   {url: '/web/myrogers/torcom/link/tv/build-your-tv-package' + '?setLanguage=' + $scope.lng, flowId: 'dbchangepkg'},
      //   {url: '/web/myrogers/torcom/link/tv/build-your-tv-package' + '?setLanguage=' + $scope.lng, flowId: 'dbchangedigitalbox'},
      //   {url: '/web/myrogers/resetDigitalBox' + '?setLanguage=' + $scope.lng, flowId: ''},
      //   {url: '/web/myrogers/resetDigitalPin' + '?setLanguage=' + $scope.lng, flowId: ''}
      // ];
    }, $scope);
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrIgniteInternetDashboardService', igniteInternetDashboardService);

  igniteInternetDashboardService.$inject = ['ajax', '$q'];

  /* @ngInject */
  function igniteInternetDashboardService(ajax, $q) {

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      loadIgniteInternetDashboard: loadIgniteInternetDashboard
    };


    function loadIgniteInternetDashboard(accountNumber, language, requestFreshData) {

      var deferred = $q.defer();

      // process the first time result
      function processResult(data) {
        deferred.resolve(data);
      }

      // call tvLanding api to get data
      ajax.loadIgniteInternetDashboard(accountNumber, language, requestFreshData).then(
        function (response) {
          if (response) {
            processResult(response);
          }
        }, function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }




    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:IgniteTvCtrl
   * @description
   * # IgniteTvCtrl
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrIgniteTVController', IgniteTvController);

  IgniteTvController.$inject = ['$scope', 'resource', 'userLanguage', 'localStorage', 'myrIgniteTvDashboardService', '$rootScope'];

  /* @ngInject */
  function IgniteTvController($scope, resource, userLanguage, localStorage, igniteTvDashboardService, $rootScope) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    $scope.selectedAccount = {};
    $scope.selectedAccount.accountName = {};
    $scope.selectedAccount.accountNumber = localStorage.getLocalStorageValue('igniteTvAccountNumber');
    $scope.selectedAccount.ban = localStorage.getLocalStorageValue('accountNumber');
    $scope.finalDataReceived = false;
    $scope.showPrdDetails = false;
    $scope.offerCaption = '';
    $scope.tvBoxList = [];

    //Start - Bold chat changes to display floating chat in Wireless Dashboard
    $scope.invokeFloatingChat = function () {
      var buttonId;
      setTimeout(function() {  //timeout for not loading tv dashboard incident
      if(userLanguage() === 'en'){
        buttonId = getBDId('F_BSS_TVDbrd');
        floatingLiveChatButtonUTE(buttonId);
      }
      }, 5000);
    };

    $scope.$on('$stateChangeStart', function() {
      removeChatButtons('bcFloat');
    });


    $rootScope.$on('languageChanged', function (){
      angular.element('.bcFloat').remove();
      $scope.invokeFloatingChat();
    });

    $scope.invokeFloatingChat();

    // resource.onChanged(function () {
    //   messageBoxDom();
    // }, $scope);

    $scope.processResponse = function(res) {
      const productDetails = res.igniteTVProductDetails ? res.igniteTVProductDetails : null;
      if (productDetails !== null) {
        const tvPackage = productDetails.find(function(item)   {
          return item.offerCaption;
        })

        const tvBoxList = productDetails.filter(function(item) {
          return item.productName === 'IPTV' && item.lob === 'IPTV';
        })
        $scope.offerCaption = tvPackage && tvPackage.offerCaption ? tvPackage.offerCaption : null;
        $scope.tvBoxList = tvBoxList.length > 0 ? tvBoxList :  [];
        $scope.showPrdDetails = true;
      }else {
        $scope.showPrdDetails = false;
        $scope.offerCaption = '';
        $scope.tvBoxList = [];
      }

    }

    $scope.loadIgniteTvDashboard = function () {
      $scope.loadingProdDetails = true;
      $scope.displayContentTvDashboard = false;
      var customerBillingProfileID = localStorage.getLocalStorageValue('customerBillingProfileID');

      if (!$scope.selectedAccount.accountNumber) {
        return;
      }
      igniteTvDashboardService.loadIgniteTvDashboard(customerBillingProfileID, userLanguage(), false).then(
        function (response) {
          $scope.processResponse(response);
          if (response.cachedResultInfo) {
            if (response.cachedResultInfo.expired) {
              igniteTvDashboardService.loadIgniteTvDashboard(customerBillingProfileID, userLanguage(), true).then(
                function (response) {
                  $scope.finalDataReceived = true;
                  $scope.processResponse(response);
                },
                function (error) {
                  $scope.displayContentTvDashboard = false;
                  $scope.loadingProdDetails = false;

                  // Error handling - 555 exception
                  if (error.data.status === 555) {
                    $scope.errorCode = error.error.errorCode;
                    $scope.errorMessage = error.error.message;
                  } else {
                    $scope.errorMessage = resource.get('error_tv_feeder');
                  }
                });
            } else {
              $scope.finalDataReceived = true;
            }
          }
        },
        function (error) {
          $scope.displayContentTvDashboard = false;
          $scope.loadingProdDetails = false;

          // Error handling - 555 exception
          if (error.data.status === 555) {
            $scope.errorCode = error.error.errorCode;
            $scope.errorMessage = error.error.message;
          } else {
            $scope.errorMessage = resource.get('error_tv_feeder');
          }
        });
    };

    // $scope.onOmnitureClickTv = function (option) {
    //   appState.tagging(option);
    // };

    //$scope.loadTvFeed();

    $scope.loadIgniteTvDashboard();

    // resource.onChanged(function () {

    //   var oldLang = $scope.lng;

    //   $scope.lng = userLanguage();
    //   $scope.lang = userLanguage() + '-CA';
    //   $scope.langUpper = userLanguage().toUpperCase();

    //   if (oldLang !== $scope.lng) {
    //     $scope.loadIgniteTvDashboard();
    //   }

    //   $scope.dollarSignB = userLanguage() === 'en' ? '$' : '';
    //   $scope.dollarSignA = userLanguage() === 'fr' ? '$' : '';

    //   $scope.postToRogersUrls = [
    //     {url: '/web/myrogers/torcom/link/tv/build-your-tv-package' + '?setLanguage=' + $scope.lng, flowId: 'dbchangechnlortp'},
    //     {url: '/web/myrogers/torcom/link/tv/build-your-tv-package' + '?setLanguage=' + $scope.lng, flowId: 'dbchangepkg'},
    //     {url: '/web/myrogers/torcom/link/tv/build-your-tv-package' + '?setLanguage=' + $scope.lng, flowId: 'dbchangedigitalbox'},
    //     {url: '/web/myrogers/resetDigitalBox' + '?setLanguage=' + $scope.lng, flowId: ''},
    //     {url: '/web/myrogers/resetDigitalPin' + '?setLanguage=' + $scope.lng, flowId: ''}
    //   ];
    // }, $scope);
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrIgniteTvDashboardService', igniteTvDashboardService);

  igniteTvDashboardService.$inject = ['ajax', '$q'];

  /* @ngInject */
  function igniteTvDashboardService(ajax, $q) {

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      loadIgniteTvDashboard: loadIgniteTvDashboard
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function loadIgniteTvDashboard(accountNumber, language, requestFreshData) {

      var deferred = $q.defer();

      // process the first time result
      function processResult(data) {
        deferred.resolve(data);
      }

      // call tvLanding api to get data
      ajax.loadIgniteTvDashboard(accountNumber, language, requestFreshData).then(
        function (response) {
          if (response) {
            processResult(response);
          }
        }, function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrInternetColonyPortal
   * @description
   * # MyrInternetColonyPortal
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('InternetColonyPortal', InternetColonyPortal);

  InternetColonyPortal.$inject = ['$scope', '$browser', '$http', 'ajax', 'userLanguage', 'pricePlanChangesErrors','settings','myrSigninService'];

  /* @ngInject */
  function InternetColonyPortal($scope, $browser, $http, ajax, userLanguage, pricePlanChangesErrors, settings, signinService) {
    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    function init() {
        ajax.getCPRequestData().then(function(data){
             if(data && data.status && data.status.toLowerCase() == "success") {
                document.getElementById("SAMLResponse").value = data.samlresponse;
                document.getElementById("RelayState").value = data.relayState;
                document.getElementById("SAMLResponseForm").action = data.acsurl;
                document.getElementById("SAMLResponseForm").submit();
                /*$scope.SAMLResponse = data.SAMLResponse;
                $scope.RelayState = data.RelayState;
                $scope.ACSUrl = data.ACSURL;
                $('#SAMLResponseForm').submit();*/
             } else {
              pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'internetdash'}, true);
             }
        }, function(error){
           pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'internetdash'}, true);
        });
    }
    init();

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrInternetChartService', internetChartService);

  internetChartService.$inject = ['resource'];

  /* @ngInject */
  function internetChartService(resource) {

    // Initiate Object
    var internetChart = {};

    // hook up variables
    internetChart._usages = [];
    internetChart._startDate = new Date();
    internetChart._endDate = new Date();
    internetChart._leftDays = null;
    internetChart.usageLimit = 0;
    internetChart.currentTotal = 0;

    internetChart.graph = {};
    internetChart.xPadding = 25;
    internetChart.yPadding = 25;

    internetChart.axisColor = '#cccccc';
    internetChart.successColor = '#00aec7';
    internetChart.warnColor = '#ffbe3e';
    internetChart.gbColor = 'black';
    internetChart.scaleFont = '5pt Calibri';
    internetChart.firstTimeShift = 0;
    internetChart.axisYstep = 1; //MB
    internetChart.axisYFont = '10pt Calibri';

    internetChart.data = {};
    internetChart.isGB = true;

    internetChart.drawChartInner = function () {
      internetChart.axisYstep = 1;
      internetChart.currentTotal = 0;
      internetChart.isGB = true;

      internetChart.getGraph();
      var c = internetChart.graph.getContext('2d');

      internetChart.data.values = [];
      for (var x = 0; x < internetChart._usages.length; x++) {
        internetChart.data.values.push({X: x, Y: internetChart._usages[x].totalDailyUsage});
      }

      var absMax = internetChart.getAbsMax();
      internetChart.isGB = absMax >= 1000;
      //adjust for MB
      if (!internetChart.isGB) {
        var tmp1 = 0;
        for (var xx = 0; xx < internetChart.data.values.length; xx++) {
          tmp1 = internetChart.data.values[xx].Y;
          tmp1 = tmp1 * 1000;
          internetChart.data.values[xx].Y = tmp1;
        }

        absMax = internetChart.getAbsMax();
        internetChart.usageLimit = internetChart.usageLimit * 1000;
      }
      internetChart.drawGB(c);

      var ln = String(absMax).length;
      for (var ox = 1; ox < ln; ox++) {
        internetChart.axisYstep = internetChart.axisYstep * 10;
      }

      var multiply = internetChart.axisYstep / 1000;
      var axisYheight = internetChart.getMaxY();

      c.lineWidth = 2;
      c.strokeStyle = internetChart.axisColor;
      c.font = 'italic 8pt sans-serif';
      c.textAlign = 'center';

      // Draw the axises ===========================================================================================
      internetChart.drawAxises(c, internetChart.graph);
      c.lineWidth = 1;

      // Draw the X value texts ==================================================================================
      c.fillStyle = internetChart.axisColor;
      c.font = internetChart.scaleFont;

      var tt = ((internetChart.graph.width - internetChart.xPadding) / internetChart.data.values.length) / 2;  // shift to make day in the middle
      var shiftCoor = internetChart.data.values.length >= 30 ? tt : 0;
      for (var i = 0; i < internetChart.data.values.length; i++) {
        c.fillText('|', internetChart.getXPixel(i) - shiftCoor, internetChart.graph.height - internetChart.yPadding + internetChart.firstTimeShift);
      }

      // Draw the Y value texts===================================================================================
      c.font = internetChart.axisYFont;
      for (var y = 0; y < axisYheight; y += internetChart.axisYstep) {
        c.textAlign = 'right';
        c.textBaseline = 'Alphabetic';
        c.fillStyle = internetChart.gbColor;
        var gb = Math.round(y / internetChart.axisYstep * multiply);
        c.fillText(String(gb), internetChart.xPadding, internetChart.getYPixel(y));
      }
      //draw dashed lines==========================================================================================
      for (var yz = internetChart.axisYstep; yz < axisYheight; yz += internetChart.axisYstep) {
        c.setLineDash([1, 1]);

        c.moveTo(internetChart.xPadding, internetChart.getYPixel(yz));
        c.lineTo(internetChart.graph.width, internetChart.getYPixel(yz));
        c.stroke();
      }

      c.setLineDash([10, 0]);

      //GB at the top================================================================================================
      // NOT needed at present.... uncomment to show capping line text
      //internetChart.drawGB(c);

      //draw dates at the left and right============================================================================
      internetChart.drawDates(c);

      //draw top line================================================================================================
      // NOT needed at present.... uncomment to show capping line
      // internetChart.drawTopLine(c);

      // Draw the line graph=========================================================================================
      c.strokeStyle = internetChart.successColor;
      c.lineWidth = 3;
      c.beginPath();
      c.moveTo(internetChart.getXPixel(0), internetChart.getYPixel(internetChart.data.values[0].Y));
      internetChart.currentTotal += internetChart.data.values[0].Y;

      // var minusCorrect = internetChart._leftDays <= 0 ? internetChart._leftDays + 1 : internetChart._leftDays - 1;
      // Always add 1 to internetChart._leftDays because we don't want to include today...
      var minusCorrect = internetChart._leftDays <= 0 ? internetChart._leftDays + 1 : internetChart._leftDays + 2;
      if (internetChart.displayLastRecord) {
        minusCorrect -= 1;
      }
      for (var j = 1; j < internetChart.data.values.length - minusCorrect; j++) {
        if (internetChart.currentTotal > internetChart.usageLimit * 1024) {
          c.strokeStyle = internetChart.warnColor;
        }
        c.lineTo(internetChart.getXPixel(j), internetChart.getYPixel(internetChart.data.values[j].Y));
        internetChart.currentTotal += internetChart.data.values[j].Y;
        c.stroke();
        c.beginPath();
        c.moveTo(internetChart.getXPixel(j), internetChart.getYPixel(internetChart.data.values[j].Y));
      }
    };

    internetChart.drawGB = function (ctx) {
      //GB at the top================================================================================================
      ctx.fillStyle = 'black';
      ctx.textAlign = 'right';
      ctx.fontWeight = '300';

      ctx.textBaseline = 'top';
      var gbLabel = internetChart.isGB ? resource.get('internet_GB') : resource.get('internet_MB');
      ctx.fillText(gbLabel, internetChart.xPadding, 0);
    };

    internetChart.drawDates = function (ctx) {
      ctx.font = '400 12px sans-serif';
      ctx.textBaseline = 'top';
      ctx.textAlign = 'left';
      ctx.fillText(internetChart._startDate, 0, internetChart.graph.height - internetChart.yPadding / 2);
      ctx.textAlign = 'right';
      ctx.fillText(internetChart._endDate, internetChart.graph.width, internetChart.graph.height - internetChart.yPadding / 2);
    };

    internetChart.drawTopLine = function (ctx) {
      ctx.setLineDash([1, 1]);

      ctx.moveTo(internetChart.xPadding, 10);
      ctx.lineTo(internetChart.graph.width, 10);
      ctx.stroke();
      ctx.setLineDash([10, 0]);
    };

    internetChart.drawAxises = function (ctx, graph1) {
      ctx.lineWidth = 2;
      ctx.strokeStyle = internetChart.axisColor;
      ctx.beginPath();

      ctx.moveTo(0, graph1.height - internetChart.yPadding);
      ctx.lineTo(graph1.width, graph1.height - internetChart.yPadding);
      ctx.stroke();
    };

    internetChart.drawAxeY = function (ctx, graph1) {
      ctx.lineWidth = 2;
      ctx.strokeStyle = internetChart.axisColor;

      ctx.beginPath();
      ctx.moveTo(internetChart.xPadding, internetChart.yPadding / 2);  //beginning
      ctx.lineTo(internetChart.xPadding, internetChart.graph.height - internetChart.yPadding);

      ctx.stroke();
    };

    internetChart.getGraph = function () {
      var graphs = $('.chart-position');
      internetChart.graph = graphs[0];
      if (internetChart.graph.clientWidth === 0) {
        internetChart.graph = graphs[1];
      }

      var tmp = internetChart.graph.getContext('2d');
      tmp.clearRect(0, 0, internetChart.graph.width, internetChart.graph.height);
    };

    internetChart.drawChartEmpty = function () {
      internetChart.getGraph();
      var c = internetChart.graph.getContext('2d');

      internetChart.drawGB(c);
      internetChart.drawAxeY(c, internetChart.graph);

      internetChart.drawAxises(c, internetChart.graph);
      internetChart.drawDates(c);

      c.fillStyle = internetChart.axisColor;
      c.font = internetChart.scaleFont;

      for (var i = 0; i < 30; i++) {
        var x2 = ((internetChart.graph.width - internetChart.xPadding) / 30) * i + (internetChart.xPadding * 1.5);
        c.fillText('|', x2, internetChart.graph.height - internetChart.yPadding);
      }
    };

    // Return the x pixel for a graph point================================================================================
    internetChart.getXPixel = function (val) {
      return ((internetChart.graph.width - internetChart.xPadding) / internetChart.data.values.length) * val + (internetChart.xPadding * 1.5);
    };

    // Return the y pixel for a graph point
    internetChart.getYPixel = function (val) {
      return internetChart.graph.height - (((internetChart.graph.height - internetChart.yPadding) / internetChart.getMaxY()) * val) - internetChart.yPadding;
    };

    internetChart.getMaxY = function () {
      var max = 0;

      for (var i = 0; i < internetChart.data.values.length; i++) {
        if (internetChart.data.values[i].Y > max) {
          max = internetChart.data.values[i].Y;
        }
      }
      max += internetChart.axisYstep - max % internetChart.axisYstep;
      // Show axis labelling to be above maximum value
      max += internetChart.axisYstep;
      return max;
    };

    internetChart.getAbsMax = function () {
      var max = 0;

      for (var i = 0; i < internetChart.data.values.length; i++) {
        if (internetChart.data.values[i].Y > max) {
          max = internetChart.data.values[i].Y;
        }
      }

      return max;
    };

    internetChart.drawChart = function (dataObj, limit, startDate, endDate, leftDays, firstTime, displayLastRecord) {
      startDate = (startDate === undefined || startDate === null) ? new Date() : startDate;
      endDate = (endDate === undefined || endDate === null) ? new Date() : endDate;

      internetChart._startDate = startDate;
      internetChart._endDate = endDate;
      internetChart._leftDays = leftDays;
      internetChart._leftDays = internetChart._leftDays < 0 ? 0 : internetChart._leftDays;
      internetChart.firstTimeShift = firstTime ? 5 : 0;
      internetChart.displayLastRecord = displayLastRecord;

      if (!dataObj || dataObj.internetUsageToolVO.dayToDayVO === undefined || dataObj.internetUsageToolVO.dayToDayVO.length === 0) {
        internetChart.drawChartEmpty();
        return false;
      }

      internetChart.usageLimit = limit;
      internetChart._usages = dataObj.internetUsageToolVO.dayToDayVO[0].dailyUsageList; //dataObj.internetUsageToolVO.dayToDayVO;

      internetChart.drawChartInner();

      return true;
    };

    // This one is called from outside functions
    internetChart.drawChartSync = function (graphData, firstTime) {
      var dtStartdate = graphData.dtStartDate;
      var monthsNames = resource.get('_months');

      graphData.startDate = monthsNames[dtStartdate.getMonth()];
      graphData.startDate = graphData.startDate.substring(0, 3);
      graphData.startDate += ' ' + dtStartdate.getDate();

      var dtEndDate = graphData.dtEndDate;

      graphData.endDate = monthsNames[dtEndDate.getMonth()];
      graphData.endDate = graphData.endDate.substring(0, 3);
      graphData.endDate += ' ' + dtEndDate.getDate();

      var currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      var displayLastRecord = (((currentDate - dtEndDate) / 86400000) > 0);

      internetChart.drawChart(graphData.data, graphData.total, graphData.startDate, graphData.endDate, graphData.days, firstTime, displayLastRecord);
    };

    return internetChart;
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrInternetDashboardController
   * @description
   * # MyrInternetDashboardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrInternetDashboardController', InternetDashboardController);

  InternetDashboardController.$inject = ['$scope', 'localStorage', '$rootScope', 'appState', 'userLanguage'];

  /* @ngInject */
  function InternetDashboardController($scope, localStorage, $rootScope, appState, userLanguage) {
    $scope.selectedAccountNumber = localStorage.getLocalStorageValue('accountNumber');
    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line


    //Start - Bold chat changes to display floating chat in Wireless Dashboard
    $scope.invokeFloatingChat = function () {
      var buttonId;
      if(userLanguage() === 'en'){
        buttonId = getBDId('F_BSS_IntDbrd');
        floatingLiveChatButtonUTE(buttonId);
      } else {
        buttonId = getBDId('F_BSS_IntDbrd_Fr');
        floatingLiveChatButtonUTE(buttonId);
      }
    };

    $scope.$on('$stateChangeStart', function() {
      angular.element('.bcFloat').remove();
    });


    $rootScope.$on('languageChanged', function (){
      angular.element('.bcFloat').remove();
      $scope.invokeFloatingChat();
    });

    setTimeout(function () {
      $scope.invokeFloatingChat();
    }, 0);
    //End - Bold chat changes to display floating chat in Wireless Dashboard


  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrInternetService', internetService);

  internetService.$inject = ['ajax','$rootScope','brtCheck'];

  /* @ngInject */
  function internetService(ajax, $rootScope, brtCheck) {
    // Initiate Object
    var internetService = {};

    internetService.internetPackageObj = {};
    internetService.internetPackageObj.inProgress = false;
    internetService.internetPackageObj.callBack = null;
    internetService.internetPackageObj.callFail = null;

    internetService.internetModemObj = {};
    internetService.internetModemObj.inProgress = false;
    internetService.internetModemObj.callBack = null;
    internetService.internetModemObj.callFail = null;
    brtCheck.ColonyPortalSwitch();
    $rootScope.displayEligibility = false;
    // Get data from server
    // Old call that collected all data in one large JSON
    internetService.requestUsage = function (dataObj, callBack, callFail) {
      ajax.internetDashboard(dataObj.accBan, dataObj.accLang, dataObj.accNo).then(
        function (data) {
          callBack(data);
        },
        function (error) {
          callFail(error);
        }
      );
    };

    // New call to collect only specific data
    internetService.internetUsage = function (dataObj, callBack, callFail) {
      ajax.internetDashboardUsage(dataObj.accountNumber).then(
        function (data) {
          callBack(data);
        },
        function (error) {
          callFail(error);
        }
      );
    };

    // To reduce the amount of calls these two data-handling calls are coupled into one
    internetService.internetPackage = function (dataObj, callBack, callFail) {
      internetService.internetPackageObj.inProgress = true;

      // Check the other call progress
      if (internetService.internetModemObj.inProgress) {
        // The other call is in progress
        internetService.internetPackageObj.callBack = callBack;
        internetService.internetPackageObj.callFail = callFail;
        internetService.internetPackageObj.inProgress = false;
      } else {
        ajax.internetDashboardProduct(dataObj.accountNumber, dataObj.refresh, dataObj.lang).then(
          function (data) {

            if(data && data.switchEligible && data.switchEligible == true){
              $rootScope.displayEligibility = true;
            } else {
              $rootScope.displayEligibility = false;
            }
            callBack(data);
            internetService.supportTheOther(internetService.internetModemObj, data, 'success');
          },
          function (error) {
            internetService.internetPackageObj.inProgress = false;

            callFail(error);
            internetService.supportTheOther(internetService.internetModemObj, error, 'fail');
          }
        );
      }
    };

    internetService.internetModem = function (dataObj, callBack, callFail) {
      internetService.internetModemObj.inProgress = true;

      // Check the other call progress
      if (internetService.internetPackageObj.inProgress) {
        // The other call is in progress
        internetService.internetModemObj.callBack = callBack;
        internetService.internetModemObj.callFail = callFail;
        internetService.internetModemObj.inProgress = false;
      } else {
        ajax.internetDashboardProduct(dataObj.accountNumber, dataObj.refresh, dataObj.lang).then(
          function (data) {

            if(data && data.switchEligible && data.switchEligible == true){
              internetService.displayEligibility = true;
            } else {
              internetService.displayEligibility = false;
            }
            callBack(data);
            internetService.supportTheOther(internetService.internetPackageObj, data, 'success');
          },
          function (error) {
            internetService.internetModemObj.inProgress = false;

            callFail(error);
            internetService.supportTheOther(internetService.internetPackageObj, error, 'fail');
          }
        );
      }
    };

    // Deliver the data to the other call as if the call happened for real
    internetService.supportTheOther = function (respObj, blob, status) {
      if (status === 'success' && respObj.callBack !== null) {
        respObj.callBack(blob);
      }
      if (status === 'fail' && respObj.callFail !== null) {
        respObj.callFail(blob);
      }

      // Cleanup in isle 9
      respObj.inProgress = false;
      respObj.callBack = null;
      respObj.callFail = null;
    };

    return internetService;
  }
})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('epostService', epostService);

  epostService.$inject = ['ajax', 'resource', '$rootScope', '$q', '$window', 'settings', 'userLanguage', 'backend', 'appState', 'myrAccountListService', 'localStorage', '$location'];

  /* @ngInject */
  function epostService(ajax, resource, $rootScope, $q, $window, settings, userLanguage, backend, appState, myrAccountListService, localStorage, $location) {
      var service = {
        checkEpost: checkEpost
      };

      return service;

      function checkEpost(invoiceRequest){
         return ajax.checkEpost(invoiceRequest);
      }

  }
})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('invoiceService', invoiceService);

  invoiceService.$inject = ['ajax','$q', '$rootScope', 'localStorage', 'resource', 'userLanguage', '$window', 'brtCheck', 'myrAccountListService' , '$state' ];

  /* @ngInject */
  function invoiceService(ajax, $q, $rootScope, localStorage, resource, userLanguage, $window, brtCheck, myrAccountListService, $state ) {
      var briteBillInvoices = {};

    var isDuplicateWinDate = "false";

      var briteBillServerLogs = {
        'briteBillError': 'BriteBill error - '
      };

      var service = {
        //getAllBriteBillInvoices: getAllBriteBillInvoices,
        getBriteBillInvoice: getBriteBillInvoice,
        getWinOnlineInvoice: getWinOnlineInvoice,
        processInvoices: processInvoices,
        checkEpost: checkEpost,
        convertDate: convertDate,
        filterAndMergeDates: filterAndMergeDates,
        isDuplicateDate: isDuplicateDate,

        briteBillInvoiceDates: null,
        briteBillOldestDate: null,
        britebill: null,
        loadingBriteBill: false,
        invoiceDateArray: null,
        invoiceDateSelected: null,
        showInvoiceDates: false,
        defaultLink: null,
        briteBillError: null,
        isBriteBillErrorOccured: isBriteBillErrorOccured,
        isBriteBill: isBriteBill,
        isNoBillsAvailable: isNoBillsAvailable,
        isInvoiceProcessing : true,
        getbbErrorMsg: getbbErrorMsg
      };

      return service;

//      function getAllBriteBillInvoices() {
//        var deferred = $q.defer();
//        if (_.isEmpty(briteBillInvoices)) {
//          return fetchAllBriteBillInvoices().then(function(data){
//            deferred.resolve(data);
//          });
//        } else {
//            deferred.resolve(briteBillInvoices);
//        }
//        return deferred.promise;
//      }

      function getBriteBillInvoice(accountNumber){
        var deferred = $q.defer();
        if (!_.isEmpty(briteBillInvoices) && briteBillInvoices[accountNumber]) {
          deferred.resolve(briteBillInvoices[accountNumber]);
        } else {
          fetchBriteBillInvoice(accountNumber).then(function(data) {
            briteBillInvoices[accountNumber] = data;
            deferred.resolve(briteBillInvoices[accountNumber]);
          }, function(error) {
            briteBillInvoices[accountNumber] = 'ERROR';
            deferred.resolve(briteBillInvoices[accountNumber]);
          });
        }
        return deferred.promise;
      }

      function getWinOnlineInvoice(accountNumber) {
        var deferred = $q.defer();
        var invoiceRequest = {
          'accountNumber': accountNumber
        };

        fetchWinOnlineToGetBill(invoiceRequest).then(function(data) {
          deferred.resolve(data);
        }, function(error){
          deferred.resolve(error);
        });

        return deferred.promise;
      }

      function checkEpost(accountNumber){
        var deferred = $q.defer();
        var invoiceRequest = {
           'accountNumber': accountNumber
        };

        invokeEpost(invoiceRequest).then(function (data) {
          deferred.resolve(data);
        }, function(error){
          deferred.resolve(error);
        });

        return deferred.promise;
      }

//      function fetchAllBriteBillInvoices() {
//        var deferred = $q.defer();
//        var promises = {};
//
//        var accountList = $rootScope.ao.allAccounts;
//        if (accountList && accountList.length > 0) {
//          for (var index = 0; index < accountList.length; index++) {
//            promises[accountList[index].accountNumber] = fetchBriteBillInvoice(accountList[index].accountNumber);
//          }
//        }
//
//        angular.forEach(promises, function(promise, accountNumb) {
//          promise.then(function(data) {
//            briteBillInvoices[accountNumb] = data;
//          }, function(error) {
//            briteBillInvoices[accountNumb] = error;
//          })
//        });
//
//        $q.all(promises).then(function(){
//          deferred.resolve(briteBillInvoices);
//        });
//
//        return deferred.promise;
//      }

      function fetchBriteBillInvoice(accountNumber) {
        var deferred = $q.defer();
        var bbrequest = {
          'currentAccNumber': accountNumber,
          'applicationId': 'MyAccount'
        };
        ajax.getBriteBill(bbrequest).then(function(data) {
          if (data && data.encryptedString) {
            var headerData = {'EncryptedToken': data.encryptedString, 'If-Modified-Since': 0};
            var data = {
              'appID': 'MyAccount',
              'uuid': new Date().getTime()
            };
            invokeBriteBillToGetBill(data, headerData).then(function(data){
                deferred.resolve(data);
            }, function(error){
                deferred.reject('ERRORENCRYPT');
            });
          } else {
              deferred.reject('ERRORENCRYPT');
          }
        }, function (error) {
          deferred.reject('ERRORENCRYPT');
        });
        return deferred.promise;
      }

      function fetchWinOnlineToGetBill(invoiceRequest) {
        var deferred = $q.defer();
        ajax.getWolDates(invoiceRequest).then(function(data) {
          // check for error messages from server / Auth exipre / other troubles that do return valid JSON
          if (data.status == 'success') {
            var winDates= [];
            var onlyBB = true;
            angular.forEach(data.invoices, function (invoice) {
               if (invoice.locationInd == 'WIN') {
                  onlyBB = false;
                  winDates.push({
                   "accountbalance":"",
                   "amount": "",
                   "batch": "",
                   "content_id": "",
                   "duedate": "",
                   "from": "",
                   "issue_date": invoice.cycleDate,
                   "link": "WIN",
                   "payment_status": "",
                   "received_date": "",
                   "location_ind": invoice.locationInd
                   });
               }
            });
            if(onlyBB)
              deferred.resolve('onlyBB');
            else
              deferred.resolve(winDates);
          } else if (data.errorMessage == "No invoice available" || data.errorCode == 35001){
            deferred.resolve(35001);
          } else if(data.errorMessage == "Account does not exist" || data.errorCode == 35000) {
            deferred.resolve(35000);
          }
        }, function (error) {
           deferred.reject('ERROR');
        });
        return deferred.promise;
      }


      function invokeBriteBillToGetBill(data, headerData) {
        var deferred = $q.defer();
        ajax.getBriteBillListOfBills(data, headerData).then(function(tempData) {
          // check for error messages from server / Auth exipre / other troubles that do return valid JSON

          if(_.includes($rootScope.errorMsgBB, tempData)){
            $rootScope.isBBErrorOccured = true;
            deferred.reject('ERROR');
          } else {
              try{
                  tempData = tempData.bills ? tempData : JSON.parse(tempData);
                  if (tempData.bills && tempData.bills.length > 0) {
                    deferred.resolve(tempData.bills);
                  } else {
                    deferred.resolve('NO_BILLS_FOUND');
                  }
              } catch (e) {
                  deferred.resolve('NO_BILLS_FOUND');
              }
          }
        }, function (error) {
           if (error.data.status === 400 || error.data.status === 403 || error.data.status === 404) {
              deferred.resolve('NO_BILLS_FOUND');
           } else {
             $rootScope.isBBErrorOccured = true;
             deferred.reject('ERROR');
           }
        });
        return deferred.promise;
      }

      function invokeEpost(invoiceRequest){
         var deferred = $q.defer();
         ajax.checkEpost(invoiceRequest).then(function(data) {
           // check for error messages from server / Auth exipre / other troubles that do return valid JSON
           if(data == true || data == "true"){
             deferred.resolve('true');
           }else{
             deferred.reject('false');
           }
         }, function (error) {
            deferred.reject('ERROR');
         });

         return deferred.promise;
      }

      function processInvoices(bbInvoices, winDates, ePostStatus) {
        $rootScope.isNoBillsAvbl = false;
        $rootScope.isBBErrorOccured = false;
        if (bbInvoices && (bbInvoices == 'ERROR' || bbInvoices == 'NO_BILLS_FOUND' || bbInvoices.length > 0)) {

          var bills = _.clone(bbInvoices, true);

          if (bbInvoices == 'ERROR' || bbInvoices == 'NO_BILLS_FOUND') {
            bills = [];
          }

          if (bills && bills.length < 18) {
            if ((!_.isEmpty(winDates) && winDates != 35000 && winDates != 35001 && winDates != 'ERROR') || (ePostStatus && ePostStatus == 'true')) {
              bills.push({
                id: "legacy",
                link:"EPOST",
                issue_date: "9999-01-01",
                name: resource.get('acc_balance_view_older_bill')
              });
            }

          }
          sortInvoices(bills, bbInvoices);

        } else {
          service.loadingBriteBill = false;
          if (bbInvoices === 'fail') {

          } else if (bbInvoices === 'ERROR') {
            $rootScope.briteBillFailed = true;
          } else {
            // Unknown state ???
          }
        }
        service.isInvoiceProcessing = false;

      }
    function sortInvoices (bills , bbInvoices){
        if (bills.length > 0) {


            bills.sort(function (a, b) {
              //Dates are iso std YYYY-MM-DD
              var c = new Date(a.issue_date);// jshint ignore:line
              var d = new Date(b.issue_date);// jshint ignore:line
              return d - c;
            });

            $rootScope.briteBillInvoiceDates = '';
            for (var i = 0; i < bills.length; i++) {
              bills[i].name = bills[i].issue_date ? convertDate(bills[i].issue_date) : bills[i].name; // jshint ignore:line
              bills[i].id = bills[i].issue_date; // jshint ignore:line

              if ($rootScope.briteBillInvoiceDates) {
                $rootScope.briteBillInvoiceDates += "," + bills[i].issue_date; // jshint ignore:line
              } else {
                $rootScope.briteBillInvoiceDates += bills[i].issue_date;// jshint ignore:line
              }
            }
            service.briteBillInvoiceDates = $rootScope.briteBillInvoiceDates;

            /*if (bills.length > 0) {
              service.briteBillOldestDate = bills[bills.length - 1].name;
            }*/
            $rootScope.ao.britebill = bills;
            service.britebill = bills;
            $rootScope.isbritebillAvailable = true;
            /*if (bills.length > 0) {
              $rootScope.isbritebillAvailable = true;
            }*/
            service.loadingBriteBill = false;

            service.invoiceDateArray = bills;



            if(null == localStorage.getLocalStorageValue('invoiceDateSelected') || undefined == localStorage.getLocalStorageValue('invoiceDateSelected')  || localStorage.getLocalStorageValue('invoiceDateSelected') == "")
            {
                    service.invoiceDateSelected = bills[0].issue_date;
                    service.showInvoiceDates = true;
                    service.defaultLink = bills[0].link;
                    $rootScope.$emit('invoiceDateChange', {link: bills[0].link, issue_date: bills[0].issue_date });
            }

            else{
                service.invoiceDateSelected = localStorage.getLocalStorageValue('invoiceDateSelected');
                service.showInvoiceDates = true;
                service.defaultLink =   localStorage.getLocalStorageValue('defaultLink');
                $rootScope.$emit('invoiceDateChange', {link: localStorage.getLocalStorageValue('defaultLink'), issue_date: localStorage.getLocalStorageValue('invoiceDateSelected')});
                localStorage.deleteLocalStorageValue('invoiceDateSelected');
                localStorage.deleteLocalStorageValue('defaultLink');
            }
        }
        else {
            // no bills

            $rootScope.ao.britebill = undefined;
            $rootScope.briteBillInvoiceDates = '';
            service.loadingBriteBill = false;
            if (bbInvoices == 'NO_BILLS_FOUND') {
              $rootScope.isNoBillsAvbl = true;
              service.briteBillError = briteBillServerLogs.briteBillError + 'no bills';
            } else {
              $rootScope.isBBErrorOccured = true;
              service.briteBillError = briteBillServerLogs.briteBillError + bbInvoices;
            }
          }
    }

    function filterAndMergeDates(bbInvoiceList, winOnlineInvoiceList) {

      var mergedInvoiceDates = [];
      mergedInvoiceDates = bbInvoiceList;


      angular.forEach(winOnlineInvoiceList, function(winOnlineInvoice) {
        isDuplicateDate(winOnlineInvoice.issue_date, bbInvoiceList);
        if(isDuplicateWinDate == "false") {
          mergedInvoiceDates.push(winOnlineInvoice);
        }
      });

      return mergedInvoiceDates;
    }

    function isDuplicateDate(wolDate, bbInvoiceList) {
      isDuplicateWinDate = "false";
      angular.forEach(bbInvoiceList, function(bbInvoice){
        if(wolDate == bbInvoice.issue_date){
          isDuplicateWinDate = "true";
        }
      })
    }
      function convertDate(date) {
        if(date === "9999-01-01") return resource.get('acc_past_Invoices');
        //date = "2015-06-01";
        var _date = date.split('-');
        // _date[0] - year, _date[1] - month, _date[2] - day
        var _dateObj = new Date(_date[0], _date[1] - 1, _date[2]);

        var day = _dateObj.getDate();
        //Commenting out the date increment as we should use the date that is returned by the britebill server - was causing MYR-1041
        //day++;
        var _months = resource.get('_months');
        var month = _months[_dateObj.getMonth()];
        if (userLanguage() === 'en') {
          date = month + ' ' + day + ', ' + _dateObj.getFullYear();
        } else {
          date = day + ' ' + month + ' ' + _dateObj.getFullYear();
        }


        return date;
      }

      function isBriteBillErrorOccured() {
        return $rootScope.isBBErrorOccured;
      }

      function isNoBillsAvailable() {
        return $rootScope.isNoBillsAvbl;
      }

      function getbbErrorMsg(){
         return ajax.getSelfserveConfig().then(
            function (response) {
               $rootScope.errorMsgBB = response.errorMessage;
             }, function (error) {
               //check for business on this
             }
         );
      }


      function isBriteBill(){
        if (myrAccountListService.isOcp == "directLanding" && (localStorage.getLocalStorageValue('accountNumber') != null || $rootScope.accountListLength == 1)) {
            myrAccountListService.isOcp = " ";
            $state.go("accountInitialization");
        }
        service.getbbErrorMsg();
        $window.document.cookie = 'hasBriteBillInvoice=' + 'false' + ';domain=' +'.rogers.com' + ';path=' + '/';
        var accountNumber = ($rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountNumber : ($rootScope.ao.accountDetails ? $rootScope.ao.accountDetails.accountNumber : (myrAccountListService.selectedAccount ? myrAccountListService.selectedAccount.accountNumber : undefined));
        var deferred = $q.defer();
        getBriteBillInvoice(accountNumber).then(function(data){
          service.isInvoiceProcessing = false;
          $rootScope.isBBErrorOccured = false;
          if(data && data != 'NO_BILLS_FOUND' && data.length > 0){
            $window.document.cookie = 'hasBriteBillInvoice=' + 'true' + ';domain=' +'.rogers.com' + ';path=' + '/';
          }
          deferred.resolve(true);
        },function(){
          service.isInvoiceProcessing = false;
          $rootScope.isBBErrorOccured = true;
          deferred.resolve(true);
        });
        return deferred.promise;
      }

  }
})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('winOnlineService', winOnlineService);

  winOnlineService.$inject = ['ajax', 'resource', '$rootScope', '$q', '$window', 'settings', 'userLanguage', 'backend', 'appState', 'myrAccountListService', 'localStorage', '$location'];

  /* @ngInject */
  function winOnlineService(ajax, resource, $rootScope, $q, $window, settings, userLanguage, backend, appState, myrAccountListService, localStorage, $location) {
      var service = {
        getWinOnlineInvoices: getWinOnlineInvoices
      };

      return service;

      function getWinOnlineInvoices(invoiceRequest){
         return ajax.getWolDates(invoiceRequest);
      }

  }
})();

/**
 * Created by varun.ramakanth on 11/3/2015.
 */

(function () {
  'use strict';

  angular.module('totesApp').controller('MakePaymentController', MakePaymentController);

  MakePaymentController.$inject = ['$scope', '$state','$rootScope', 'appState', 'myrPayNowService', 'userLanguage', 'myrAccountOverviewService', 'myrChangePaymentMethodService', '$stateParams', 'settings', '$modal', '$location', 'localStorage', 'semafoneService', '$document', 'myrMyServicesService', 'myrAccountBalanceService', 'myrAccountListService', 'resource'];

  /* @ngInject */
  function MakePaymentController($scope, $state, $rootScope, appState, myrPayNowService, userLanguage, accountOverviewService, paymentMethodService, $stateParams, settings, $modal, $location, localStorage, semafoneService, $document, myrMyServicesService, myrAccountBalanceService, myrAccountListService, resource) {

    function init() {
      var isDetailsAvailable = false;
      /*if(myrAccountListService.isOcp == "directLanding" && localStorage.getLocalStorageValue('accountNumber') != null){
            		   myrAccountListService.isOcp = " ";
            		   $state.go("accountInitialization");
      }*/
      if(accountOverviewService.getSelectedAccountDetail()){
        $scope.selectedAccNum = accountOverviewService.getSelectedAccountDetail().billableAccountNumber;
        $scope.selectedAccContactId = accountOverviewService.getSelectedAccountDetail().contactId;
        $scope.selectedAccLOB = accountOverviewService.getSelectedAccountDetail().lob;
        $scope.isConsolidated = accountOverviewService.getSelectedAccountDetail().isConsolidated;
        $scope.lang = userLanguage();
        isDetailsAvailable = true;
        if(accountOverviewService.getSelectedAccountDetail().accountBalance.bankPaymentId){
          $scope.bankPaymentId = accountOverviewService.getSelectedAccountDetail().accountBalance.bankPaymentId;
        }
        if (accountOverviewService.getSelectedAccountDetail().accountBalance.balanceAmount) {
          var balance = accountOverviewService.getSelectedAccountDetail().accountBalance.balanceAmount.split('.');
          $scope.dollar = balance[0];
          $scope.cents = balance[1];
        }
        else {
          $scope.dollar = "0";
          $scope.cents = "00";
        }
        $scope.name = accountOverviewService.getSelectedAccountDetail().nickName;

      }
      else if((undefined != localStorage.getLocalStorageValue('accountNo')) && ("" != localStorage.getLocalStorageValue('accountNo'))){
        $scope.selectedAccNum = localStorage.getLocalStorageValue('accountNo');
        $scope.selectedAccContactId = localStorage.getLocalStorageValue('contactId');
        $scope.selectedAccLOB = localStorage.getLocalStorageValue('LOB');
        $scope.lang = userLanguage();
        if(accountOverviewService.getSelectedAccountDetail().accountBalance.bankPaymentId){
          $scope.bankPaymentId = accountOverviewService.getSelectedAccountDetail().accountBalance.bankPaymentId;
        }
        if (localStorage.getLocalStorageValue('accountBalance')) {
          var balance = localStorage.getLocalStorageValue('accountBalance').split('.');
          $scope.dollar = balance[0];
          $scope.cents = balance[1];
        }
        else {
          $scope.dollar = "0";
          $scope.cents = "00";
        }
        isDetailsAvailable = true;
      }
      if(myrAccountListService.isOcp == "directLanding" && (localStorage.getLocalStorageValue('accountNumber') != null || $rootScope.accountListLength == 1)){
          myrAccountListService.isOcp = " ";
          $state.go("accountInitialization");
      }
      if (!isDetailsAvailable) {
       // appState.switchView('accountOverview');
      }
    }

    init();
  }

})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
   'use strict';

   /**
    * @ngdoc function
    * @name totesApp.controller:MyrMidMarketPortal
    * @description
    * # MyrMidMarketPortal
    * Controller of the totesApp
    */
   angular.module('totesApp').controller('MyrMidMarketPortal', MyrMidMarketPortal);

   MyrMidMarketPortal.$inject = ['$scope', '$browser', '$http', '$location', 'ajax', 'userLanguage', 'pricePlanChangesErrors', 'settings', 'myrSigninService', 'localStorage', '$window'];

   /* @ngInject */
   function MyrMidMarketPortal($scope, $browser, $http, $location, ajax, userLanguage, pricePlanChangesErrors, settings, signinService, localStorage, $window) {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line

      function init() {
         var cacheId = $location.search()['cacheId'];
         var accountNumber = localStorage.getLocalStorageValue('accountNumber');
         var firstName = localStorage.getLocalStorageValue('fName');
         var lastName = localStorage.getLocalStorageValue('lName');

         var midmarkettemp = localStorage.getLocalStorageValue('midmarkettemp');
         if (!!midmarkettemp) {
            var midmarketdata = JSON.parse(midmarkettemp);
            accountNumber = midmarketdata['accountNumber'];
            firstName = midmarketdata['fName'];
            lastName = midmarketdata['lName'];
            cacheId = midmarketdata['cacheId'];
            localStorage.setLocalStorageValue('accountNumber', accountNumber);
            localStorage.setLocalStorageValue('fName', firstName);
            localStorage.setLocalStorageValue('lName', lastName);
            localStorage.deleteLocalStorageValue('midmarkettemp');
         }
         if ($browser.cookies().accountNumberTemp) {
            accountNumber = $browser.cookies().accountNumberTemp;
            firstName = $browser.cookies().fNameTemp;
            lastName = $browser.cookies().lNameTemp;

            localStorage.setLocalStorageValue('midmarkettemp', '{"accountNumber": "' + accountNumber + '", "fName": "' + firstName + '", "lName": "' + lastName + '", "cacheId": "' + cacheId + '"}');
            localStorage.setLocalStorageValue('accountNumber', accountNumber);
         }

         $window.document.cookie = 'accountNumberTemp=' + '' + ';domain=' + '.rogers.com' + ';path=' + '/' + ';expires=Thu, 01 Jan 1970 00:00:00 GMT';
         $window.document.cookie = 'fNameTemp=' + '' + ';domain=' + '.rogers.com' + ';path=' + '/' + ';expires=Thu, 01 Jan 1970 00:00:00 GMT';
         $window.document.cookie = 'lNameTemp=' + '' + ';domain=' + '.rogers.com' + ';path=' + '/' + ';expires=Thu, 01 Jan 1970 00:00:00 GMT';

         if (cacheId && !!accountNumber) {
            var postData = {
               cacheId: cacheId,
               ban: accountNumber,
               first_name: firstName,
               last_name: lastName
            }
            ajax.getMidMarketSAMLData(postData).then(function (data) {
               if (data && data.status && data.status.toLowerCase() == "success") {
                  document.getElementById("MidMarketSAMLResponse").value = data.samlresponse;
                  document.getElementById("MidMarketSAMLResponseForm").action = data.relayState;
                  document.getElementById("MidMarketSAMLResponseForm").submit();
               } else {
                  pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], { goBack: 'accountOverview' }, true);
               }
            }, function (error) {
               pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], { goBack: 'accountOverview' }, true);
            });
         } else {
            pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], { goBack: 'accountOverview' }, true);
         }
      }
      init();

   }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrMigrateUserController
   * @description
   * # MyrMigrateUserController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrMigrateUserController', MigrateUserController);

  MigrateUserController.$inject = ['$scope', '$rootScope', 'settings', '$browser', 'resource', 'ajax', 'appState', 'userLanguage', 'localStorage', 'landing'];

  /* @ngInject */
  function MigrateUserController($scope, $rootScope, settings, $browser, resource, ajax, appState, userLanguage, localStorage, landing) {

    $scope.regObj = {
      email: null
    };
    $scope.loadingDataIndicator = false;
    $scope.confirmEmail = '';
    $scope.errorCode = '';
    $scope.errorDescription = '';
    $scope.isSuccess = null;
    $scope.isDisabled = false;
    $scope.chatHref = userLanguage() === 'en' ? settings.chatLink.en : settings.chatLink.fr; /// 'cuscare_ECare_landing.php?hm=n&s=701',
    localStorage.setLocalStorageValue('userMigrateGeneralError', false);
    $scope.submit = function () {
      var form = $scope.form;
      if (form.$valid) {
        $scope.updateUsername();
      }
    };

    $scope.showGeneralError = function () {
      $scope.errorCode = 'general';
      $scope.onClickEmailAlreadyRegisteredUsage();
      $scope.errorDescription = resource.get('maintenance_info_migrateUser');
      console.log($rootScope.maintenance);
      localStorage.setLocalStorageValue('userMigrateGeneralError', true);
    };

    $scope.onClickUserNameMigrationPageLoadUsage= function () {

      appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:username_migration_start'}, // Page Name
        {eVar14: 'MyRogers_username_migration'}, {event5: ''}]);
    };

    $scope.onClickNotAValidEmailAddressUsage= function () {

      appState.tagging(['_trackLink',
        {eVar49: 'MyRogers-username_mig_not_a_valid_email'}, {event15: ''}]);
    };

    $scope.onClickEmailsDoNotMatchUsage=function () {

      appState.tagging(['_trackLink', {eVar49: 'MyRogers-username_mig_emails_donotmatch'}, {event15: ''}]);
    };

    $scope.onClickEmailAlreadyRegisteredUsage=function () {

      appState.tagging(['_trackLink', {eVar49: 'MyRogers-username_mig_email_already_registered'}, {event15: ''}]);
    };

    $scope.onClickThankYouPageOfUserNameMigrationLoadsUsage= function () {

      appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:username_migration_thankyou'}, // Page Name
        {eVar14: 'MyRogers_username_migration'}, {event6: ''}]);
    };

    $scope.updateUsername = function () {
      $scope.loadingDataIndicator = true;
      ajax.updateUsername($scope.regObj.email).then(
        function (response) {
          if (response === undefined) {
            $scope.loadingDataIndicator = false;
            $scope.showGeneralError();
          } else {
            $scope.loadingDataIndicator = false;
            $scope.isSuccess = true;
            $scope.onClickThankYouPageOfUserNameMigrationLoadsUsage();
            localStorage.setLocalStorageValue('successMessage', 'mu_msg_success');
            localStorage.setLocalStorageValue('usernameMigrationComplete', true);
            $browser.cookies('userToken', $scope.email);
            $scope.$emit('pageUserNameChanged');
            landing.landingRedirect();
          }
        },
        function (error) {
          $scope.loadingDataIndicator = false;
          if (error.data.status === 555) {
            if (error.error.errorCode === 10802) {
              $scope.onClickNotAValidEmailAddressUsage();
              $scope.errorCode = error.error.errorCode.toString();
            } else {
              $scope.showGeneralError();
            }
          } else {
            $scope.showGeneralError();
          }
        });
    };

    $scope.getEmail = function () {
      ajax.getEmail().then(
        function (response) {
          if (response === undefined) {
            $scope.onClickNotAValidEmailAddressUsage();
            // do nothing
          } else {
            $scope.regObj.email = response.email;
            $rootScope.migratedEmail = response.email;
          }
        },
        function (error) {
          // no need to inform user if failed to retrieve suggestion email
        }
      );
    };

    $scope.getEmail();

    resource.onChanged(function () {
      $scope.chatHref = userLanguage() === 'en' ? settings.chatLink.en : settings.chatLink.fr;
    }, $scope);
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  // TODO where it used ?

  angular.module('totesApp').provider('myrMigrateUserHandler', function () {
    var data;

    return {
      $get: function () {
        return data;
      },
      $set: function (value) {
        data = value;
      }
    };
  });
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('migrateUserService', migrateUserService);

  migrateUserService.$inject = ['$q', 'ajax', 'resource', 'user', '$browser'];

  /* @ngInject */
  function migrateUserService($q, ajax, resource, user, $browser) {

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      migrateCheck: migrateCheck
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function migrateCheck() {
      var mic = $q.defer();

      var username = $browser.cookies().userName;
      if (!username || user.isEmail(username)) {
        mic.resolve(false);
      }

      ajax.usernameMigration().then(
        function (data) {
          if (data === '') {
            mic.resolve(false);

          } else {
            var dataObj = angular.fromJson(data);
            if (dataObj.migration) {
              mic.resolve(true);
            } else {
              mic.resolve(false);
            }
          }
        },
        function (error) {
          var _return = {};

          if (error.data.status === 555) {
            _return.result = 'error';
            _return.data = error;
            _return.message = resource.get(error.error.errorCode);		// Pull message from resource file
            mic.resolve(false);

          } else {
            _return.result = 'error';
            _return.data = error;
            _return.message = resource.get('maintenance_info');		// Pull message from resource file 401 or 5xx situlation
            mic.resolve(false);
          }
        }
      );

      return mic.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('totesApp').controller('MyrMyServicesController', myServicesController);

  myServicesController.$inject = ['$scope','$rootScope','$window','myrMyServicesService','myrAccountListService','appState','userLanguage','resource','btnSettings','myrNotificationBannerService','localStorage','$modal', '$timeout'];

  /* @ngInject */
  function myServicesController($scope,$rootScope,$window,myrMyServicesService,myrAccountListService,appState,userLanguage,resource,btnSettings,notificationBannerService,localStorage,$modal,$timeout) {

    var vm = this;

    $scope.acctListService = myrAccountListService;
    vm.maintenanceTime =false;
    var currentTime = new Date().getHours();
    if((currentTime>=$rootScope.maintenanceStart)&&(currentTime<$rootScope.maintenanceEnd)){
      vm.maintenanceTime =true;
    }

    $scope.$watch('acctListService.selectedAccount.accountNumber',function(accountNumber){
      if(accountNumber){

        if (appState.usernameChanged) {
          myrMyServicesService.linkedMessageId = 'mu_msg_success';
          myrMyServicesService.updateMessage();
          myrMyServicesService.clearAccountDetails();
          appState.usernameChanged = false;
        }

        getAccountDetails();

      }
    });

    var runService = function (serviceName, value,subscriberName) {
      console.log("service name", serviceName);
      console.log("service details", value);
      console.log("subscriber name", subscriberName)
      var userPath = myrMyServicesService.getServicePath(serviceName,value,subscriberName);

      if (appState.maintenanceRedirect(userPath)) {
        $location.path('/underMaintenance');
      }else{
        myrMyServicesService.runService(serviceName, value,subscriberName);
      }
    };

    vm.mss = myrMyServicesService;
    vm.isDealer = $rootScope.isDealer;
    vm.isCare = $rootScope.isCare;
    vm.runService = runService;
    vm.isNameLong = isNameLong;
    vm.btnSettings = null;
    vm.btnStatus = null;
    vm.suspended = 'Suspended';

    vm.redirectToDMDashboard = function() {
      vm.mss.encryptDMPayload().then(function(token) {
        $scope.icid = 'bu-otmbcinq-dmlrbwrls-0227195';
        $scope.token = token;
        $timeout(function () {
          $("#dmFormData").submit();
        });
      }, function(error) {
        $scope.modalInstance = $modal.open({
          templateUrl: 'views/modals/dmFailureMessage.html',
          controller: 'MyrMyServicesController',
          backdrop: false,
          scope: $scope,
          resolve: {}
        });
      });
    };

    $scope.closeDmAlertMsg = function() {
      $scope.modalInstance.close();
    }

    function isNameLong(name){
      if(name.length > 13){
        return true;
      }else{
        return false;
      }

    }

    function tagSelectedAccount() {

      var _details = vm.mss.getSelectedAccountDetail();

      if (!_details) {
        return;
      }

      //get phone numbers
      var _phonesList = '';
      if (_details.phoneNumber) {
        for (var i = 0, l = _details.phoneNumber.length; i < l; i++) {
          _phonesList += _details.phoneNumber[i] + '|';
        }
      }
      _phonesList = _phonesList.substr(0, _phonesList.length - 1);
     /* appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:overview'}, // Page Name
        {sACTT: _details.userType}, // Consumer, Business
        {sACSBTT: _details.userSubType}, // Prepaid, Regular
        {sBAN: _details.number}, //Account Number BAN, ex : '12345'
        {sCTN: _phonesList}, //Account Telephone Number CTN, ex: '4161234567|4161234568'
        {sACSS: _details.status} // Active, Suspended:
      ]);*/
    }

    function endLoadingData() {
      //broadcast event ended
      $('#accountType').removeAttr('disabled');
      $scope.isSwitching = false;
      $rootScope.$broadcast('changedAccount');			// accountBalance.js - picks up on this call and initiates $scope.updateBalance ();
      $scope.loadingDataIndicator = false;
    }

    function startLoadingData() {
      $rootScope.$broadcast('startChangeAccount');
      $('#accountType').prop('disabled', 'disabled');
    }

    function getAccountDetails () {

      var selectedAccount = myrAccountListService.selectedAccount;
      var language = userLanguage();

      //hide the previous account details
      startLoadingData();
      $rootScope.$broadcast('startChangeAccount');
      $scope.myOtherServicesListFinal = [];

      var cacheFailSafe = true;

      //selectedAccount.accountTypeNumber = null;//local test detail failing

      var request = {
        accountNumber: selectedAccount.accountNumber,
        accountTypeNumber: selectedAccount.accountTypeNumber,
        pinNumber: selectedAccount.pinNumber,
        phoneNumber: selectedAccount.phoneNumber,
        language: language,
        refresh: false,
        indx: selectedAccount.selectedAccountIndex,
        applicationId: 'SMB'
      };

      vm.mss.clearAccountDetails();
      vm.mss.myServicesList = [];

      //save the selected for future reference
      appState.selectedAccount = selectedAccount;


      var accountDetailsResponse = function (_tmp) {

        var processDetailsResponse = function () {

          vm.mss.isDetailsNotFound = false;
          vm.mss.accountDetails = _tmp.data;
          $rootScope.ao.accountDetails = null;
          $rootScope.ao.accountDetails = vm.mss.accountDetails;

          //Analytic tagging when select an account
          if (vm.mss.selectedAccount) { 
            tagSelectedAccount();
          }
          console.log("account details of the user", vm.mss.accountDetails)
          console.log('account infor', vm.mss.accountDetails.accountInfo)
          console.log('account converted indicator', vm.mss.accountDetails.accountConvertedIndicator)
          console.log('account converted indicator', vm.mss.accountDetails.customerBillingProfileID)
          $scope.accountStatus = vm.mss.accountDetails && vm.mss.accountDetails.accountInfo && vm.mss.accountDetails.accountInfo.status ? vm.mss.accountDetails.accountInfo.status : '';
          var customerBillingProfileID = vm.mss.accountDetails && vm.mss.accountDetails.customerBillingProfileID ? vm.mss.accountDetails.customerBillingProfileID : null ;
          localStorage.setLocalStorageValue('customerBillingProfileID', customerBillingProfileID);
          const accountConvertedIndicator =  vm.mss.accountDetails && vm.mss.accountDetails.accountConvertedIndicator ?  vm.mss.accountDetails.accountConvertedIndicator : null;
          var subscriptions = vm.mss.getSubscriptions(vm.mss.accountDetails.subList, accountConvertedIndicator);
          $rootScope.myServicesList = vm.mss.myServicesList = subscriptions.myServices;
          console.log("servcie list at controller",vm.mss.myServicesList)
          //$scope.myOtherServicesListFinal = subscriptions.myOtherServices;

        };
        var accoutType = $rootScope.ao.accountDetails.acctPdtType;
        var pdtflag = false;
        if(accoutType == "IPTV"){
          pdtflag = true;
          $scope.accpdtFlag = pdtflag;
        }
        if (_tmp.result === 'success') {

          if (_tmp.data.cachedResultInfo) {
            if (_tmp.data.cachedResultInfo.expired === true && cacheFailSafe) {

              cacheFailSafe = false;
              request.refresh = true;

              var dataToProcess = JSON.parse(JSON.stringify(_tmp));
              vm.mss.storedSummary = JSON.parse(JSON.stringify(_tmp));

              processDetailsResponse(dataToProcess.data);
              vm.mss.getAccountDetails(request, accountDetailsResponse);
            }
          }

          if (!_tmp.data.cachedResultInfo || (_tmp.data.cachedResultInfo && !_tmp.data.cachedResultInfo.expired)) {

            //Account details updated and show them
            endLoadingData();
          }

          processDetailsResponse(_tmp.data);

        } else {
          // Unknown state ???
          $scope.isDetailsNotFound = true;
        }
      };

      vm.mss.getAccountDetails(request, accountDetailsResponse);

    }

    $rootScope.$watch('ao.accountActive', function() {
      if($rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatus) {
        vm.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
        vm.btnStatus = $window.btnStatus;
      }
      messageBoxDom();
    });

    var messageBoxDom = function () {
      vm.loginMessage= "<strong>"+resource.get("login_to")+" "+resource.get("sgi")+"</strong>";
    };

    myrMyServicesService.successMsgIdFromStorage = localStorage.getLocalStorageValue('successMessage');

    if (myrMyServicesService.successMsgIdFromStorage) {
      localStorage.deleteLocalStorageValue('successMessage');
      if (!(!!myrMyServicesService.linkedMessageId)) {
        myrMyServicesService.updateSuccessMessage();
      }
    }

    resource.onChanged(function () {

      myrMyServicesService.updateMessage();
      myrMyServicesService.updateSuccessMessage();

    }, $scope);

    resource.onChanged(function () {
      messageBoxDom();
    }, $scope);

    // User needs to link account
    if (appState.isLinked) {
      myrMyServicesService.linkedMessageId = 'linked_acc_success';
      myrMyServicesService.updateMessage();
      vm.mss.clearAccountDetails();

      appState.isLinked = false;
    }
  }

})();
(function () {
  'use strict';

  angular.module('totesApp').directive('myrMyServices', myServices);

  myServices.$inject = [];

  /* @ngInject */
  function myServices($log) {
    return {
      templateUrl: 'scripts/modules/myServices/myServices.html',
      restrict: 'EA',
      controller: 'MyrMyServicesController',
      controllerAs: 'ms',
      bindToController: true
    };

  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:myrAccountListService
   * @description
   * # myrAccountListService
   */
  angular.module('totesApp').factory('myrMyServicesService', myrMyServicesService);

  myrMyServicesService.$inject = ['$rootScope','$window','userProvince','userLanguage','localStorage','$location','ajax','settings','appState','myrAccountBalanceService','resource','myrNotificationBannerService','myrAccountListService', '$cookieStore', '$browser', 'ute.fraud.logging.service', 'ute.fraud.logging.TransactionProp', '$modal', '$q', '$state'];

  function myrMyServicesService($rootScope,$window,userProvince,userLanguage,localStorage,$location,ajax,settings,appState,myrAccountBalanceService,resource,notificationBannerService,myrAccountListService, $cookieStore, $browser, fraudLoggingService, transactionProp, $modal, $q, $state) {

    var primaryDeviceNumbers = [];

    var service = {

      myServicesList:null,
      myCompanionList:null,
      myOtherServicesListFinal:null,
      accountDetails:null,
      selectedAccountDetail:null,
      callingAccountDetails:false,
      isDetailsNotFound:true,
      storedSummary:null,
      loadingData:false,
      errorLoading:null,
      linkedMessageId:null,
      successMsgIdFromStorage:null,
      suspendedSubscriptionMessage:null,
      wcocAccountOverviewDetails:null,

      clearAccountDetails:clearAccountDetails,
      getAccountDetails:getAccountDetails,
      getSelectedAccountDetail:getSelectedAccountDetail,
      getSubscriptions:getSubscriptions,
      runService:runService,
      getServicePath:getServicePath,
      resetCallingAccountDetails:resetCallingAccountDetails,
      updateMessage:updateMessage,
      updateSuccessMessage:updateSuccessMessage,
      dmInfo: {},
      encryptDMPayload:encryptDMPayload,
      isPrimaryDevice: isPrimaryDevice
    };

    return service;

    function isPrimaryDevice(ctn) {
      return primaryDeviceNumbers.indexOf(ctn) > -1;
    }


    ///////////////////////////////////////////////////////////////
    function resetCallingAccountDetails() {
      service.callingAccountDetails = false;
    }

    function encryptDMPayload() {
      var userDetail = JSON.parse(localStorage.getLocalStorageValue('ute.rogers.signin.user'));
      var request = {
        "ban": localStorage.getLocalStorageValue('accountNumber'),
        "action": "DataManager",
        "GoBackAction": $state.current.name
      }

      var deferred = $q.defer();
      ajax.encryptDMData(request).then(function(data) {
        deferred.resolve(data.token);
      }, function (error) {
          deferred.reject('ERROR WHILE ENCRYPTING');
      });
      return deferred.promise;
    }

    function runService(serviceName, value, subscriberName) {
      var path = '';
      switch (serviceName) {
        case 'wireless':
          //if ($location.path() === '/wireless') {
          //  path = '';
          //  $rootScope.submenuWirelessNumber = value;
          //} else {
          //  path = '/wireless';
          //}
          path = '/wireless';
          appState.tagging(['_trackPageView', {pn:'overview_wireless_wireless'} ]);
          localStorage.setLocalStorageValue('phoneNumber', value);
          localStorage.setLocalStorageValue('subscriberName', subscriberName);
          break;
        case 'wirelessPrepaid':
          path = '/wirelessPrepaid';
          localStorage.setLocalStorageValue('phoneNumber', value);
          break;
        case 'shmdashboard':
          path = '/shmdashboard';
          localStorage.setLocalStorageValue('shmAccountNumber', value);
          break;
        case 'internetdash':
          path = '/internetdash';
          appState.tagging(['_trackPageView', {pn:'overview_internet_internet',c34:'overview_internet_internet'} ]);
          localStorage.setLocalStorageValue('internetAccountNumber', value);
          break;
        case 'tvdashboard':
          path = '/tvdashboard';
          appState.tagging(['_trackPageView', {pn:'overview_tv_tv'} ]);
          localStorage.setLocalStorageValue('tvAccountNumber', value);
          break;
        case 'ignitetv':
          path = '/ignitetv';
          localStorage.setLocalStorageValue('igniteTvAccountNumber', value);
          break;
        case 'igniteinternet':
          path = '/igniteinternet';
          localStorage.setLocalStorageValue('igniteInternetAccountNumber', value);
          break;
        case 'suspended':
          path = '/suspended';
          break;
        case 'businessphonedashboard':
          path = '/businessphonedashboard';
          appState.tagging(['_trackPageView', {pn:'overview_businessphone_businessphone'} ]);
          localStorage.setLocalStorageValue('businessPhoneNumber', value);
          break;
      }
      if (path !== undefined) {
        $location.path(path);
      }
    }
    function getServicePath (serviceName, value) {
      var path = '';
      switch (serviceName) {
        case 'wireless':
          path = '/wireless';
          break;
        case 'wirelessPrepaid':
          path = '/wirelessPrepaid';
          break;
        case 'shmdashboard':
          path = '/shmdashboard';
          break;
        case 'internetdash':
          path = '/internetdash';
          break;
        case 'ignitetv':
          path = '/ignitetv';
          break;
        case 'igniteinternet':
          path = '/igniteinternet';
          break;
        case 'tvdashboard':
          path = '/tvdashboard';
          break;
        case 'suspended':
          path = '/suspended';
          break;
        case 'businessphonedashboard':
          path = '/businessphonedashboard';
          break;

      }
      if (path !== undefined) {
        return(path);
      }
    }
    function clearAccountDetails () {
      // Purge any data
      this.accountDetails = null;
      return true;
    }

    function getSelectedAccountDetail() {
      //wrap account details for selected account, handle account variety.
      if (service.selectedAccountDetail) {

        if (service.selectedAccountDetail.accountBalance != {}) {
          service.selectedAccountDetail.accountBalance = myrAccountBalanceService.accountBalance;
        }

        return service.selectedAccountDetail;
      }
      if (!$rootScope.ao.accountDetails) {
        return;
      }

      var _rtn;
      var _selectedAccount = $rootScope.ao.accountDetails;

      if (_selectedAccount) {
        var _detail = _selectedAccount;
        var _info = _detail.accountInfo;
        var _subList = _detail.subList;

        _rtn = {
          number: _detail.accountNumber,
          billableAccountNumber: _detail.billableAccountNumber,
          type: _detail.accountType,
          status: _info.status,
          nickName: myrAccountListService.selectedAccount.nickname, //to be removed
          name: _detail.accountName.firstName,
          accountBalance: myrAccountBalanceService.accountBalance,
          isPrepaid: _detail.accountType === 9,
          isWireless: _detail.accountType === 1,
          isMastro: _detail.accountType === 30,
          isCable: _detail.accountType === 6,
          isConsolidated: _detail.isConsolidated,
          lob: _detail.lob,
          contactId: _detail.contactInfo.contactId,
          isViewBillDisplay: (($rootScope.isDealer || $rootScope.isCare) && ($rootScope.isbritebillAvailable && (_detail.accountType != 9))),

          //optional data
          balance: '',
          dueDate: '',
          dateDelimiter:'',
          due:'',
          dateOrder:[],
          dateYearPrefix:'',
          paymentMethod: '',
          userType: '',
          userSubType: '',
          phoneNumber: '',
          hasWireless: '',
          nextBillingDate: _detail.nextBillingDate
        };

        if (myrAccountBalanceService.accountBalance) {
          _rtn.balance = myrAccountBalanceService.accountBalance.balanceAmount || '';
          _rtn.dueDate = myrAccountBalanceService.accountBalance.billDueDate || '';
        }

        if(_rtn.isPrepaid){
          _rtn.due = $rootScope.ao.accountDetails.accountInfo.expiryDate;
          _rtn.dateDelimiter = ' ';
          _rtn.dateOrder = [0,1,2];
          _rtn.dateYearPrefix = '';
        }else{
          _rtn.due = myrAccountBalanceService.accountBalance ? myrAccountBalanceService.accountBalance.billDueDate : '';
          _rtn.dateDelimiter = '-';
          _rtn.dateOrder = [1,0,2];
          _rtn.dateYearPrefix = '20';
        }

        //get phone numbers
        var _list = $(_subList).map(function (k, v) {
          // if (v.subAccountId === _rtn.number) {
          //console.log(v);
          if (v.subContactList && v.subContactList[0]) {
            _rtn.contactId = v.subContactList[0].contactId;
          }
          // }

          if (v.subType === 'CTN') {
            _rtn.hasWireless = true;
            return v.subNumber;
          }
        }).get();

        _rtn.phoneNumber = _list[0];

        //Wireless account
        if (_rtn.isWireless) {
          _rtn.userType = _info.accType;
          _rtn.userSubType = _info.accSubType;
        }

        //post-paid account get payment method
        if (!_rtn.isPrepaid && myrAccountBalanceService.accountBalance !== undefined && myrAccountBalanceService.accountBalance) {
          //post-paid account
          _rtn.paymentMethod = myrAccountBalanceService.accountBalance.methodOfPayment ? myrAccountBalanceService.accountBalance.methodOfPayment.mopType : 'R';
        }
      }

      service.selectedAccountDetail = _rtn;

      return service.selectedAccountDetail;
    }

    function getSubscriptions (subList, accountConvertedIndicator) {
      accountConvertedIndicator = $rootScope.ao.accountDetails.accountConvertedIndicator;
      console.log("accountConvertedIndicator passed to service for getSubscriptions method", accountConvertedIndicator)
      // TODO : Remove the accountConvertedIndicator hardcode value right below this line
      // Removable code starts here
      // accountConvertedIndicator = accountConvertedIndicator ? accountConvertedIndicator : 'YES'
      // Removable code ends here

      if (!subList) {
        return;
      }

      //build the subscribed service list
      var myServicesList = [];

      /*var myOtherServicesListMaster = getMyOtherServicesList();*/

      var myOtherServicesList = [];

      var _details = service.getSelectedAccountDetail();

      var isPrepaid = (_details && _details.isPrepaid) ? _details.isPrepaid : false;


      for (var i = 0, l = subList.length; i < l; i++) {
        var _tmp = subList[i], _sub = {};
        _sub.serviceDetail = _tmp.subNumber;
        _sub.accountNumber = localStorage.getLocalStorageValue('accountNumber');
        _sub.showPhone = _tmp.subType.toLowerCase() === 'ctn' || _tmp.subType.toLowerCase() === 'dpn';//show phone number for wireless/home phone
        _sub.businessAccNo = '';
        _sub.dmServiceGrp = _tmp.dmServiceGrp;
        if (_tmp.subType === 'CTN') {
          _sub.subType = 'CTN';
          _sub.serviceType = isPrepaid ? 'service_wireless_prepaid' : 'service_wireless';
          _sub.icon = 'rui-icon-wireless';
          _sub.linkText = '_manage';

          _sub.linkURL = isPrepaid ? 'wirelessPrepaid' : 'wireless';
          _sub.paramName = 'phoneNumber';
          _sub.serviceName = isPrepaid ? 'wirelessPrepaid' : 'wireless';
          _sub.subscriberName = _tmp.subscriberName;
          _sub.atmType = "overview_wireless_wireless";
          _sub.firstName = _tmp.firstName;
          _sub.serviceBadgeMappingKey = 'wirelessServiceBadges';
          _sub.servicetabMapping = 'wirelessServiceTab';
        }
        if (_tmp.subType === 'Hi-Speed Internet') {
          _sub.subType = 'Hi-Speed Internet';
          _sub.isCompanion = false;
          _sub.serviceType = 'service_internet';
          _sub.icon = 'rui-icon-internet';
          _sub.linkText = '_manage';
          _sub.linkURL = 'internetdash';
          _sub.serviceDetail = _tmp.subAccountId;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'internetdash';
          _sub.atmType = "overview_internet_internet";
          _sub.serviceBadgeMappingKey = 'internetServiceBadges';
          _sub.servicetabMapping = 'internetServiceTab';

        }
        if (_tmp.subType === 'Digital TV') {
          _sub.subType = 'Digital TV';
          _sub.serviceType = 'service_tv';
          _sub.isCompanion = false;
          _sub.icon = 'rui-icon-tv';
          _sub.linkText = '_manage';
          _sub.linkURL = 'tvdashboard';
          _sub.serviceDetail = _tmp.subAccountId;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'tvdashboard';
          _sub.atmType = "overview_tv_tv";
          _sub.serviceBadgeMappingKey = 'tvServiceBadges';
          _sub.servicetabMapping = 'tvServiceTab';
        }
        if (_tmp.subType === 'Rogers Smart Home Monitoring') {
          // _sub.serviceDetail = resource.get('myaccoverview_home_monotoring');
          _sub.subType = 'Rogers Smart Home Monitoring';
          _sub.isCompanion = false;
          _sub.serviceType = 'myaccoverview_business_monotoring';
          _sub.icon = 'rui-icon-home-monitoring';
          _sub.linkText = '_manage';
          _sub.linkURL = 'shmdashboard';
          //_sub.serviceDetail = _tmp.subAccountId;
          _sub.serviceDetail = _tmp.serviceNumber;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'shmdashboard';
           _sub.atmType = "overview_sbm_sbm";
        }
        if (_tmp.subType === 'DPN') {
          _sub.subType = 'DPN';
          _sub.isCompanion = false;
          _sub.serviceType = 'service_phone';
          _sub.icon = 'rui-icon-home-phone';
          _sub.linkText = '_manage';
          localStorage.setLocalStorageValue('businessPhoneAccNum', _tmp.subAccountId);
          _sub.linkURL = 'businessphonedashboard';
          //_sub.linkURL = settings.devServerURL + '/web/myrogers/data/homePhonePackages/redesignHomePhone';
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'businessphonedashboard';
          _sub.atmType = "overview_businessphone_businessphone";
          _sub.serviceBadgeMappingKey = 'phoneServiceBadges';
          _sub.servicetabMapping = 'phoneServiceTab';
        }

        if (accountConvertedIndicator === 'YES') {
          if (_tmp.subType === 'IPTV') {
            _sub.subType = 'igniteTv';
            _sub.isCompanion = false;
            _sub.serviceType = 'ignite_tv';
            _sub.icon = 'rui-icon-tv';
            _sub.linkText = '_manage';
            _sub.linkURL = 'ignitetv'; 
            _sub.serviceName = 'ignitetv'
            _sub.serviceDetail = _tmp.subAccountId;
            localStorage.setLocalStorageValue('igniteTvAccountNumber', _tmp.subAccountId);
            _sub.paramName = 'accountNumber';
          }
          if (_tmp.subType === 'HSI') {
            if(_tmp.subType === 'Gateway'){
              _sub.subType = 'igniteInternet';
              _sub.isCompanion = false;
              _sub.icon = 'rui-icon-internet';
              _sub.linkText = '_manage';
              _sub.linkURL = 'igniteinternet';
              _sub.serviceName = 'igniteinternet'
              _sub.serviceType = 'Ignite_Internet';
              _sub.serviceDetail = _tmp.subAccountId;
              localStorage.setLocalStorageValue('igniteInternetAccountNumber', _tmp.subAccountId);
              _sub.paramName = 'accountNumber';
            }
            else if ((!_tmp.subscriptionSubType || _tmp.subscriptionSubType.toUpperCase() !== 'S')) {
              _sub.subType = 'igniteInternet';
              _sub.isCompanion = false;
              _sub.icon = 'rui-icon-internet';
              _sub.linkText = '_manage';
              _sub.linkURL = 'igniteinternet';
              _sub.serviceName = 'igniteinternet'
              _sub.serviceType = 'Ignite_Internet';
              _sub.serviceDetail = _tmp.subAccountId;
              localStorage.setLocalStorageValue('igniteInternetAccountNumber', _tmp.subAccountId);
              _sub.paramName = 'accountNumber';
            } else {
              continue;
            }
            
          } 
        }

        if (_sub.subStatus === 'Suspended') {
          _sub.serviceName = 'suspended';
        }

        if(_tmp.subType.toLowerCase() !== 'rhpc') {
          myServicesList.push(_sub);
        }
        if (myOtherServicesList.indexOf(_sub.subType) < 0) {
          myOtherServicesList.push(_sub.subType);
        }
      }

      ///$rootScope.myServicesList = myServicesList;

      /*var myOtherServicesListFinal = [];

      for (var y = 0; y < myOtherServicesListMaster.length; y++) {
        if (myOtherServicesList.indexOf(myOtherServicesListMaster[y].id) < 0) {
          myOtherServicesListMaster[y].isVisible = true;
          myOtherServicesListFinal.push(myOtherServicesListMaster[y]);
        }
      }*/
    if(service.myCompanionList.length >= 1){
      var companion = service.myCompanionList;
      service.myServicesList = myServicesList.concat(companion);
    }
    else{
      service.myServicesList = myServicesList;
    }

      //this.myOtherServicesListFinal = myOtherServicesListFinal;
    console.log(service.myServicesList)
      return {
        myServices: service.myServicesList
      };
    }

    function getMyOtherServicesList() {
      var sl = [
        {
          id: 'Technical FAQs',
          title: 'myaccoverview_need_help_faq1',
          //link: 'https://www.rogers.com/web/content/wireless_plan_landing',
          link:'../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/support/faqs/technicalfaqs/',
          addLang: false,
          langParameterName: '',
          langFirstParam: false
        },
        {
          id: 'Wireless FAQs',
          title: 'myaccoverview_need_help_faq2',
          //link: 'https://www.rogers.com/web/link/hispeedBrowseFlowDefaultPlans',
          link: '../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/support/faqs/wirelessfaqs/',
          addLang: false,
          langParameterName: '',
          langFirstParam: false
        },
        {
          id: 'Internet FAQs',
          title: 'myaccoverview_need_help_faq3',
          //link: 'https://www.rogers.com/web/link/tv/build-your-tv-package?flowType=dbchangepkg',
          link: '../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/support/faqs/businessinternetfaqs/',
          addLang: false,
          langParameterName: '',
          langFirstParam: false
        },
        {
          id: 'TV FAQs',
          title: 'myaccoverview_need_help_faq4',
          link: '../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/support/faqs/businesstvfaqs/',
          addLang: false,
          langParameterName: '',
          langFirstParam: false
        },
        {
          id: 'Business Phone FAQs',
          title: 'myaccoverview_need_help_faq5',
          //link: 'https://www.rogers.com/web/content/smart-home-monitoring-solutions-new',
          link: '../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/support/faqs/businessphonefaqs/',
          addLang: false,
          langParameterName: '',
          langFirstParam: false
        }
      ];
      return sl;
    }

    function updateMessage() {
      if (service.myOtherServicesListFinal) {
        for (var xx = 0; xx < service.myOtherServicesListFinal.length; xx++) {
          var unit = service.myOtherServicesListFinal[xx];
          if (unit.updateRogersBank) {
            unit.link = ' https://www.rogersbank.com/' + userLanguage();
          }
        }
      }

      if (!!service.linkedMessageId) {
        notificationBannerService.sendMessageKey('linkedMessage', service.linkedMessageId);
      }

      service.suspendedSubscriptionMessage = resource.get('_suspended_service');
    }

    function updateSuccessMessage() {
      if (!service.successMsgIdFromStorage) {
        notificationBannerService.cleanBanner('successMessage');
      } else {
        notificationBannerService.sendMessageKey('successMessage', service.successMsgIdFromStorage);
      }
    }

    function getAccountDetails(request, callback) {

      //reset account over view
      //$rootScope.$broadcast('resetAccountOverview');
      //empty cache

      // load JSON
      var _return = {};
      /*

       var isRefresh = localStorage.getLocalStorageValue('refreshDetails');

       request.refresh = isRefresh ? true : false;
       */

      function processDetails(data) {

        service.selectedAccountDetail = null;

        $rootScope.ao.accountDetails = data;
        service.wcocAccountOverviewDetails = data;
        $rootScope.ao.accountDetails.accountBalance = data.accountBalance;

       function processSubscriberName(data){
          $rootScope.dmEligibility = false;
          $rootScope.dmSharedSubLength = 0;
           var myServicesList = [];
          if(data.getSubscriberInfoResp){
            var k = data.getSubscriberInfoResp.subscriberInfo;
            for (var i = 0, l = data.getSubscriberInfoResp.subscriberInfo.length; i < l; i++) {
              var _sub = {};
              if(k[i] !== null && !_.isEmpty(k[i].userName)) {
                var firstName = _.isEmpty(k[i].userName.firstName) ? '' : k[i].userName.firstName;
                var lastName = _.isEmpty(k[i].userName.lastName) ? '' : k[i].userName.lastName;
                for (var j = 0; j < $rootScope.ao.accountDetails.subList.length; j++) {
                  if ($rootScope.ao.accountDetails.subList[j].subNumber == k[i].subscriberNumber) {
                    $rootScope.ao.accountDetails.subList[j].firstName = firstName;
                    $rootScope.ao.accountDetails.subList[j].subscriberName = firstName +' ' +lastName;
                    if(k[i].familyShareStatus === 'Main' || k[i].familyShareStatus === 'Additional'){
                      $rootScope.ao.accountDetails.subList[j].dmServiceGrp = 1;
                      if(k[i].dmEligibilityInd == 'YES') {
                        $rootScope.dmEligibility = true;
                        $rootScope.dmSharedSubLength++;
                      }
                    }
                    if ($rootScope.ao.accountDetails.subList[j].subType === 'CTN' && k[i].familyShareStatus == null) {
                      $rootScope.ao.accountDetails.subList[j].dmServiceGrp = 2;
                    }
                  }
                }
              }
              if(data.getSubscriberInfoResp.subscriberInfo[i].subType === "R" && $rootScope.brtEsimSwitch){
                _sub.serviceName = 'wireless';
                _sub.serviceType = 'service_wireless';
                if(data.getSubscriberInfoResp.subscriberInfo[i].userName.firstName && data.getSubscriberInfoResp.subscriberInfo[i].userName.lastName){
                 _sub.subscriberName = data.getSubscriberInfoResp.subscriberInfo[i].userName.firstName + ' ' + data.getSubscriberInfoResp.subscriberInfo[i].userName.lastName;
                }
                _sub.serviceDetail = data.getSubscriberInfoResp.subscriberInfo[i].subscriberNumber ? data.getSubscriberInfoResp.subscriberInfo[i].subscriberNumber : " ";
                _sub.subType = 'R';
                _sub.serviceBadgeMappingKey = 'wirelessServiceBadges';
                _sub.servicetabMapping = 'wirelessServiceTab';
                _sub.icon = 'rui-icon-os-apple';
                _sub.isCompanion = true;
                _sub.linkURL = 'wireless';
                _sub.isPrimaryDeviceNumber = data.getSubscriberInfoResp.subscriberInfo[i].primaryDeviceNumber ? true : false;
                _sub.dmServiceGrp = data.getSubscriberInfoResp.subscriberInfo[i].familyShareStatus ?(data.getSubscriberInfoResp.subscriberInfo[i].familyShareStatus.toLowerCase() === 'main' || data.getSubscriberInfoResp.subscriberInfo[i].familyShareStatus.toLowerCase() === 'additional' ? 1 : 2) : 2;
                _sub.primaryDeviceNumber = data.getSubscriberInfoResp.subscriberInfo[i].primaryDeviceNumber ? data.getSubscriberInfoResp.subscriberInfo[i].primaryDeviceNumber : " ";
                if (primaryDeviceNumbers.indexOf(data.getSubscriberInfoResp.subscriberInfo[i].primaryDeviceNumber) < 0) {
                 primaryDeviceNumbers.push(data.getSubscriberInfoResp.subscriberInfo[i].primaryDeviceNumber);
                }

                myServicesList.push(_sub);
              }
            }
          }
          for (var i = 0, l = $rootScope.ao.accountDetails.subList.length; i < l; i++) {
            if(['Hi-Speed Internet', 'Digital TV', 'Rogers Smart Home Monitoring', 'DPN', 'IPTV', 'HSI'].indexOf($rootScope.ao.accountDetails.subList[i].subType) >= 0) {
              $rootScope.ao.accountDetails.subList[i].dmServiceGrp = 3;
            }
          }
          service.myCompanionList = myServicesList;
        }

        processSubscriberName(data);


        var res = service.getSubscriptions($rootScope.ao.accountDetails.subList);
        $rootScope.myServicesList = (res && res.myServices) ? res.myServices : undefined;

        // check for error messages from server / Auth exipre / other troubles that do return valid JSON
        if (data.accountNumber) {
          // check for legacy accounts
          if (data.accountType === 30) {
            // legacy accounts are missing accountBalance data
            /*
             data.accountBalance = {};
             data.accountBalance.balanceAmount = '';
             data.accountBalance.billDueDate = '';
             data.accountBalance.consolidated = null;
             data.accountBalance.creditAvailable = '';
             data.accountBalance.creditLimit = '';
             data.accountBalance.exceedCreditLimit = null;
             data.accountBalance.franchise = '';
             data.accountBalance.lastPaymentAmount = '';
             data.accountBalance.lastPaymentDate = '';
             data.accountBalance.methodOfPayment = {};
             data.accountBalance.methodOfPayment.mopType = '';
             data.accountBalance.nextBillDate = '';
             //*/
          }else if(data.accountType == 9){
            myrAccountBalanceService.accountBalance = data.accountBalance;
          }

          localStorage.deleteLocalStorageValue('refreshDetails');
            //Bold chat to set encrypted email in cookie
          var browserCookies = $browser.cookies();
          var contactEmail = browserCookies.cbid;
          if(contactEmail){
              $cookieStore.remove('cbid');
          }
          if(data.contactInfo && data.contactInfo.emailAddress){
              var _domain = $window.location.hostname.replace('www', '');
              var cbid = data.contactInfo.emailAddress ;
              var encrypted = CryptoJS.AES ? CryptoJS.AES.encrypt(cbid, "BoldChatSecret") : undefined;
                if(encrypted !== undefined) {
                    $window.document.cookie = 'cbid=' + encrypted.toString() + ';domain=' + _domain + ';path=/';
               	}
          }
           //Bold chat to set email in cookie
          service.accountDetails = data;
          _return.result = 'success';
          _return.data = service.accountDetails;

          //save the selected in global appState object for other controllers to update account info.
          appState.selectedAccount = service.accountDetails;
          appState.selectedAccountIndex = request.indx;

          if($rootScope.alsModal) {
            var fraudTransactionPayload = {
              sourceChannel: transactionProp.sourceChannel.bss,
              transactionType: transactionProp.transactionType.accountOverview,
              action: transactionProp.action.accountSelection,
              userType: transactionProp.userType.consumer,
              franchise: transactionProp.franchise.rogers,
              userEmail: JSON.parse(window.localStorage.getItem('ute.rogers.signin.user')).userEmail,
              loginId: JSON.parse(window.localStorage.getItem('ute.rogers.signin.user')).userName,
              accountStatus: data.accountInfo.originalStatus,
              customerFirstName: data.accountName.firstName,
              customerLastName: data.accountName.lastName,
              transactionStatus: transactionProp.transactionStatus.success
            };
            if (data.accountNumber.length === 12) {
              fraudTransactionPayload.can = data.accountNumber;
            }
            else if (data.accountNumber.length === 9) {
              fraudTransactionPayload.ban = data.accountNumber;
              fraudTransactionPayload.banSubType = data.accountInfo.accSubType;
              fraudTransactionPayload.banType = data.accountInfo.accType;
            }
            if(data.billingAddress) {
              fraudTransactionPayload.billingAddress = data.billingAddress.streetNumber + ',' +
                data.billingAddress.streetName + ',' +
                data.billingAddress.city + ',' +
                data.billingAddress.province + ',' +
                data.billingAddress.postalCode;
            }
            if(data.contactInfo && data.contactInfo.businessPhone) {
              fraudTransactionPayload.businessNumber = data.contactInfo.businessPhone;
            }
            if(data.contactInfo && data.contactInfo.emailAddress) {
              fraudTransactionPayload.customerContactEmail = data.contactInfo.emailAddress;
            }
            fraudLoggingService.captureTransaction(fraudTransactionPayload);
            $rootScope.alsModal = false;
          }

          return callback(_return);

        } else {
          // Fail and display error message
          // {'errorCode':10402,'errorMessage':'failed to get account details'}
          service.accountDetails = null;
          _return.result = 'fail';
          _return.data = data;
          return callback(_return);
        }
      }

      if ($rootScope.ao.accountDetails && $rootScope.ao.accountDetails.accountNumber === request.accountNumber && !request.refresh) {
        processDetails($rootScope.ao.accountDetails);
        /*--if (_rewardsData) {
          rewardsCallback(_rewardsData);
        }*/

      } else {
        // load new data
        //if (!callingAccountDetails) {
        this.callingAccountDetails = true;
        var call = ajax.getAccountDetail;

        if (request.accountTypeNumber === 9) {
          call = ajax.getAccountDetailPrepaid;
        }
        //prepaid hardcode -- remove ASAP
        /*
         var data = {"isAccountHolder":false,"accountNumber":"725289839","billableAccountNumber":"725289839","accountType":9,"ctnNumber":"4162588372","pinNumber":"1234","accountBalance":{"realBalanceAmount":"3.5","bonusBalanceAmount":"0.0","autoPaymentMethod":{"autoExLB":{"status":false},"autoMSF":{"status":false}},"balanceAmount":"3.5"},"accountName":{"firstName":"SIMONA","lastName":"THUR"},"accountInfo":{"expiryDate":"Jun 2, 2016 12:00:00 AM","pricePlan":{"name":"PPDMM440C","descirption":"By the Month - Talk \u0026 Text 30","category":"REGULAR","serviceProvider":"ROGERS"},"status":"Active"},"subList":[{"subNumber":"4162588372","isAccountHolder":true,"subType":"CTN","subStatus":"Active","realSubStatus":"Active"}],"cachedResultInfo":{"cachedDate":"Jun 29, 2015 11:41:38 AM","cacheExpiryDate":"Jul 2, 2015 11:41:38 AM","expired":false}};
         callingAccountDetails = false;
         processDetails(data);
         */
        /////////////////////////////////
        this.loadingData = true;
        this.errorLoading = null;
        this.linkedMessageId = null;

        call(request).then(function (data) {
            service.callingAccountDetails = false;
            service.loadingData = false;
            var lastSetAccount = localStorage.getLocalStorageValue('accountNumber');

            if (data.accountNumber === lastSetAccount) {

              processDetails(data);

            }

          },
          function (error) {
            service.loadingData = false;
            service.errorLoading = resource.get('maintenance_info');
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

            } else {
              // anything but status code 555
            }
            service.callingAccountDetails = false;
            _return.result = 'error';
            _return.data = error;
            return callback(_return);
          }
        );
        //}
      }
    }
  }

}());

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:myrAccountBalanceDataFactory
   * @description
   * # myrAccountBalanceDataFactory
   */
  angular.module('myr.modules.accountBalanceData').factory('myrAccountBalanceDataFactory', accountBalanceFactory);

  accountBalanceFactory.$inject = ['$rootScope', 'ajax','localStorage', 'resource', 'sessionStorage', '$log', 'commonUtilityService'];

  function accountBalanceFactory($rootScope, ajax,localStorage,resource, sessionStorage, $log, commonUtilityService) {

    var service = {
      accountBalance:{},
      billingDetails:{},
      loadingData:false,
      errorLoading: undefined,
      getAccountBalance:getAccountBalance,
      getBalanceDetails:getBalanceDetails
    };

    return service;

    ///////////////////////////////////////////////////////////////

    function getAccountBalance(){
      return service.accountBalance;
    }

    // TODO why we are using 2 different calls for different purpose in one method?
    function getBalanceDetails(request, callback, billingOverride) {

      service.accountBalance = {};

      // load JSON
      var _return = {};
      var _this = this;

      var wirelessAccountTypeNumber = 1;
      var call = (!billingOverride && (request.accountTypeNumber === wirelessAccountTypeNumber)) ? ajax.getBalance : ajax.getBillingDetail;

      var bBillingDetails = (call == ajax.getBillingDetail);

      if (bBillingDetails) {
        service.billingDetails = {};
      }

      service.loadingData = true;
      service.errorLoading = undefined;
      // Always load new data
      call(request).then(
        function (data) {

          var lastSetAccount = localStorage.getLocalStorageValue('accountNumber');

          if ($rootScope.isCare) {
            lastSetAccount = sessionStorage.getSessionStorageValue('accountNumber');
          }

          if (request.accountNumber === lastSetAccount) {

            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {

              localStorage.deleteLocalStorageValue('refreshDetails');

              if ($rootScope.ao.accountDetails) {
                $rootScope.ao.accountDetails.accountBalance = data;
              }

              data.isCLM = (Number(data.creditLimit) > 0);
              if(data.isCLM){
                data.exceedCreditLimit = ((Number(data.creditLimit) - Number(data.balanceAmount)) < 0);
              }
              data.isCLMExceeded = data.exceedCreditLimit;

              _return.result = 'success';
              _return.data = service.accountBalance = data;

              // Add Expiry date to accountBalance object
              if(service.accountBalance.nextBillingDetail){

                try {
                  var currentExpiryDate = commonUtilityService.dateTime.parse(service.accountBalance.nextBillingDetail, 'YYYY-MM-DD');
                  if(currentExpiryDate === undefined){
                    service.accountBalance.currentExpiryDate = '';
                  }else{
                    currentExpiryDate.setDate(currentExpiryDate.getDate()-1)
                    service.accountBalance.currentExpiryDate = currentExpiryDate;
                  }
                } catch (e) {
                  $log.error('Exception catch during add currentExpiryDate to accountBalance object in myrAccountBalanceDataFactory:', e.message);
                }
              }

              if (bBillingDetails) {
                service.billingDetails = data;
              } else if (data.balanceAmount && service.billingDetails.balanceAmount == undefined) {
                service.billingDetails = data;
                service.errorLoading = null;
              }

              service.loadingData = false;
              return callback(_return);

            } else {
              service.loadingData = false;
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          }
        }, function (error) {
          service.loadingData = false;
          if (angular.isUndefined(service.errorLoading)) {
            service.errorLoading = resource.get('acc_overview_oops');
          }

          // Error handling - 555 exception
          if (error.data.status === 555) {
            // Server error that needs further processing
            // additional information for 555 error

            // error.error.errorCode		// 10k - 12.1k & 50k - 51k
            // error.error.errorMessage		// Message as delivered from server
            // error.error.message 			// Message as found in resource file
            // error.error.statusCode		// error status code - 555 in this case

          } else {
            // anything but status code 555
          }

          _return.result = 'error';
          _return.data = error;
          return callback(_return);
        }
      );

    }

  }

}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.briteBill').controller('MyrBriteBillController', BriteBillController);

  BriteBillController.$inject = ['$scope', '$rootScope', 'myrBriteBillService', '$timeout', '$sce', 'invoiceService', '$browser', 'uteBillService'];

  /* @ngInject */
  function BriteBillController($scope, $rootScope, myrBriteBillService, $timeout, $sce, invoiceService, $browser, uteBillService) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    var vm = this;
    vm.bbService = ($browser.cookies().uteBillProfile == 'false') ? myrBriteBillService : uteBillService;
    vm.invoiceService = invoiceService;

    /*
     $('#bb_iframe_container').on('scroll', function(){
     resizeIframe();
     });

     function resizeIframe(){
     var height = bbIframe.contentDocument.body.scrollHeight;
     bbIframe.height(height);
     }
     */
    vm.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    };
    vm.trustSrc = function(src) {
      return $sce.trustAsResourceUrl(src);
    };

    function showBritebill() {
      getBriteBill(vm.bbService.defaultLink ? vm.bbService.defaultLink : vm.invoiceService.defaultLink);
      $rootScope.bbloadingDataIndicator = false;
    }

    function getBriteBill(link) {
      if ($rootScope.briteBillFailed) {

        $scope.briteBillFailed = true;

      } else {

        $scope.briteBillFailed = false;


        $scope.loadingDataIndicator = true;
        vm.bbService.changeBriteBillSrc(link);

        /*
         var _iframe_pre = '<iframe id="bb_iframe" class="bb_iframe" style="display:none;" scrolling="no" src="about:blank"></iframe>'; // jshint ignore:line
         var _iframe_actual = '<iframe id="bb_iframe" class="bb_iframe" style="display:none;" scrolling="no" src=""></iframe>'; // jshint ignore:line
         var target = angular.element('.iframe-ctn');
         target.html(_iframe_pre); // jshint ignore:line
         target.html(_iframe_actual); // jshint ignore:line
         */

        //$timeout(resizeIframe, 1000);
        $rootScope.bbloadingDataIndicator = true;

      }

    }

    $timeout(showBritebill, 1000);
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
  /*
   BriteBill
   */
  angular.module('myr.modules.briteBill').directive('myrBriteBill', briteBill);

  briteBill.$inject = ['$log', '$timeout', '$interval'];

  /* @ngInject */
  function briteBill($log, $timeout, $interval) {
    return {
      restrict: "EA",
      templateUrl: "scripts/modules/myrBriteBill/briteBillView.html",
      link: linkFunc,
      replace: true,
      controller: 'MyrBriteBillController',
      controllerAs: 'bb',
      bindToController: true
    };

    function linkFunc(scope, element, attrs, ctrl) {

      function resizeIframe() {

        var bbIframe = element[0];
        if (bbIframe.contentDocument) {
          var height = bbIframe.contentDocument.body.scrollHeight;

          bbIframe.style.height = height + 'px';

        }

      }

      $(document).on('scroll', function (evt) {
        resizeIframe();
      });

      scope.$on('$stateChangeStart', function () {
        $(document).off('scroll', function (evt) {
          resizeIframe();
        });
      });

      //$timeout(resizeIframe, 5000);

      var stopTime = $interval(resizeIframe, 1000);

      element.on('$destroy', function() {
        $interval.cancel(stopTime);
      });

    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.briteBill').factory('myrBriteBillService', briteBillService);

  briteBillService.$inject = ['ajax', 'resource', '$rootScope', '$q', '$window', 'settings', 'userLanguage', 'backend', 'appState', 'myrAccountListService', 'localStorage', '$location', '$browser', 'invoiceService', '$state'];

  /* @ngInject */
  function briteBillService(ajax, resource, $rootScope, $q, $window, settings, userLanguage, backend, appState, myrAccountListService, localStorage, $location, $browser, invoiceService, $state) {

    var briteBillServerLogs = {
      'briteBillError': 'BriteBill error - '
    };

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      src: 'about:blank',
      defaultLink: '',
      loadingBriteBill: false,
      britebill: null,
      briteBillError: null,
      briteBillOldestDate: null,
      invoiceDateSelected: null,
      invoiceDateArray: null,
      briteBillInvoiceDates: null,
      showInvoiceDates: false,
      getBriteBill: getBriteBill,
      getBriteBillList: getBriteBillList,
      getBriteBillListOfBills: getBriteBillListOfBills,
      getBrtSwitches: getBrtSwitches,
      isBriteBill: isBriteBill,
      convertDate: convertDate,
      changeBriteBillSrc: changeBriteBillSrc,
      validateBriteBillSwitch: validateBriteBillSwitch,
      redirectUserToLegacyEpost: redirectUserToLegacyEpost,
      redirectUserToLegacy: redirectUserToLegacy,
      isLegacyRedirection : false
    };

    resource.onChanged(function () {
      if (service.invoiceDateArray) {
        service.invoiceDateArray[service.invoiceDateArray.length - 1].name = resource.get('acc_balance_view_older_bill');
      }
    }, $rootScope);

    $rootScope.$on('invoiceDateChange', function (evt, args) {
      changeBriteBillSrc(args.link, args.issue_date);
    });

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function redirectUserToLegacyEpost(acctNumberLegacy) {

      var accountNumberEpost = localStorage.getLocalStorageValue('accountNumber');

      if(acctNumberLegacy != '' && acctNumberLegacy != undefined)
        accountNumberEpost = acctNumberLegacy;

      $window.location.href = '../../../business/ute/smb/transactions/uteEpostinvoice?acct='+accountNumberEpost;
    }

    function redirectUserToLegacy() {
      localStorage.setLocalStorageValue('toStateName','legacyviewbill');
      $window.location.href = '../../../business/ute/smb/transactions/uteBillingAndPayment';
    }




    function changeBriteBillSrc(link,issue_date) {
      if(true) {
        var accountNumber = localStorage.getLocalStorageValue('accountNumber');
        var bbErrorMessage = resource.get('bb_error_message');
        //var hasBBInvoice = $browser.cookies().hasBriteBillInvoice;
        if(link == "WIN"){
          //if (hasBBInvoice == "true") {  **** Uncomment this line and comment below 'if', if pdf and redirection should not occur together ****
          if (issue_date) {
            var _date = issue_date.split('-');
            //$window.location.href  = 'https://bss.rogers.com/bizonline/ecom/disp.do?dest=PDFinvoice&lang='+$browser.cookies().locale+'&ban='+$rootScope.ao.accountActive.accountNumber+'&month='+_date[1]+'&year'+_date[0];
            var currentDomain = '';
            var winPDFUrl = '';
            if (settings.isQaBB) {
              currentDomain = settings.invoiceWinUrl.qa;
            } else if (settings.isProdBB) {
              currentDomain = settings.invoiceWinUrl.prod;
            } else {
              currentDomain = settings.invoiceWinUrl.prod;
            }
            winPDFUrl = currentDomain + "/bizonline/ecom/disp.do?dest=PDFinvoice&lang=";
            window.open(winPDFUrl+userLanguage()+'_CA&ban='+$rootScope.ao.accountActive.accountNumber+'&month='+_date[1]+'&year='+_date[0]);
          } else {
            service.isLegacyRedirection = true;
            $window.location.href = '../../../business/ute/smb/transactions/uteBillingAndPayment';
          }
        }
        else if(link == "EPOST"){
          service.isLegacyRedirection = true;
          $window.location.href = '../../../business/ute/smb/transactions/utePastInvoices';
        }
        else if (!_.isEmpty(link)) {
          service.src = '/web/smb/bss/BriteBill.html?accountNumber=' + accountNumber +
              '&link=' + link +
              '&bbErrorMessage=' + bbErrorMessage;
        }
      }
    }

    function getBriteBill(request, callback) {
      var _return = {};
      if (request.currentAccNumber && request.currentAccNumber != '') {
        ajax.getBriteBill(request).then(
            function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.result = 'success';
                _return.data = data;
                return callback(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                //_dashboardTravelPackageData = null;
                _return.result = 'fail';
                _return.data = data;
                return callback(_return);
              }
            }, function (error) {
              // Error handling - 555 exception
              if (error.data.status === 555) {
                // Server error that needs further processing
                // additional information for 555 error

                // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                // error.error.errorMessage		// Message as delivered from server
                // error.error.message 			// Message as found in resource file
                // error.error.statusCode		// error status code - 555 in this case

                _return.result = 'error';
                _return.data = error;
                _return.message = resource.get(error.error.errorCode);		// Pull message from resource file
                return callback(_return);

              } else {
                // anything but status code 555
                _return.result = 'error';
                _return.data = error;
                _return.message = resource.get('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
                return callback(_return);
              }
            }
        );
      }
    }

    //Method to check whether the brite bill switch is ON and redirect to legacy if OFF
    function validateBriteBillSwitch(_temp) {

      localStorage['brtSwitches'] = JSON.stringify(_temp);
      var currentPage = localStorage.getLocalStorageValue('toStateName');

      var loadingFromLegacy = false;

      var queryParams = $location.search();

      var keys = Object.keys(queryParams);
      var len = keys.length;

      var acctNumberLegacy = '';

      if(len > 0){
        if(queryParams.source !== undefined && queryParams.source == "legacy")
          loadingFromLegacy = true;
        if(queryParams.legacy_cable_acct !== undefined)
          acctNumberLegacy = queryParams.legacy_cable_acct;
      }

      if (_temp.result === 'success') {
        if (_temp.data.length > 0) {
          $rootScope.ao.brtSwitches = _temp.data;

          var result = $.grep(_temp.data, function (e) {
            return e.id == 'BRITEBILL_UTE_BSS';
          });
          if (result) {
            $rootScope.bbpermission = result[0].switchIsOn;
          }

        }

        if ($rootScope.bbpermission) {
          //service.getBriteBill(bbrequest, processBriteBillEncryptionKey);
        } else {
          if(currentPage != null && currentPage != undefined) {
              if (currentPage == 'accountOverview' || loadingFromLegacy)
              redirectUserToLegacyEpost(acctNumberLegacy);
            else if (currentPage == 'viewbill')
              redirectUserToLegacy();
          }
        }
      } else {
        if(currentPage != null && currentPage != undefined) {
          if (currentPage == 'accountOverview' || loadingFromLegacy)
            redirectUserToLegacyEpost(acctNumberLegacy);
          else if (currentPage == 'viewbill')
            redirectUserToLegacy();
        }
          service.loadingBriteBill = false;
        if (_temp.result === 'fail') {

        } else if (_temp.result === 'error') {
          $rootScope.briteBillFailed = true;

        } else {
          // Unknown state ???
        }
      }
    }




    function isBriteBill() {
      invoiceService.getbbErrorMsg();
      $rootScope.briteBillInvoiceDates = '';
      service.defaultLink = '';
      $rootScope.ao.britebill = null;
      service.britebill = null;
      if (myrAccountListService.isOcp == "directLanding" && (localStorage.getLocalStorageValue('accountNumber') != null || $rootScope.accountListLength == 1)) {
          myrAccountListService.isOcp = " ";
          $state.go("accountInitialization");
      }
      var d = $q.defer();

      service.getBrtSwitches(validateBriteBillSwitch);

      var loadingFromLegacy = false;

      var queryParams = $location.search();

      var keys = Object.keys(queryParams);
      var len = keys.length;

      var acctNumberLegacy = '';

      if(len > 0){
        if(queryParams.source !== undefined && queryParams.source == "legacy")
          loadingFromLegacy = true;
        if(queryParams.legacy_cable_acct !== undefined)
          acctNumberLegacy = queryParams.legacy_cable_acct;
      }

      var currentPage = localStorage.getLocalStorageValue('toStateName');



      //$location.url($location.path());

      //if (service && angular.isUndefinedOrNull(service.britebill)) {
      //  $window.location.replace(settings.formsURL + '/web/myrogers/viewBill');
      //  d.resolve(false);
      //} else {
      //  d.resolve(true);
      //}
      //return d.promise;

      var currentAccNumber = $rootScope.ao.accountActive.accountNumber;
      if(acctNumberLegacy != '') {
        currentAccNumber = acctNumberLegacy;
        appState.aoUpdateActiveObjects(acctNumberLegacy);
        localStorage.setLocalStorageValue('accountNumber', acctNumberLegacy);
      }
      var bbrequest = {
        'currentAccNumber': currentAccNumber,
        'applicationId': 'MyAccount'
      };

      service.getBriteBill(bbrequest, function (_tmp) {

        if (_tmp.result === 'success') {

          if (_tmp.data.encryptedString) {
            var headerData = {'EncryptedToken': _tmp.data.encryptedString,'If-Modified-Since': 0};
            var data = {
              'appID': 'MyAccount',
              'uuid': new Date().getTime()
            };

            service.getBriteBillListOfBills(data, headerData, function (_tmp2) {
              if (_tmp2.result === 'success' && _tmp2.data && _tmp2.data.bills && _tmp2.data.bills.length > 0) {
                d.resolve(true);
              } else {
                  if(currentPage != null && currentPage != undefined) {
                    if (currentPage == 'accountOverview' || loadingFromLegacy)
                      redirectUserToLegacyEpost(acctNumberLegacy);
                    else if (currentPage == 'viewbill')
                      redirectUserToLegacy();
                  }
              }
            });
          }
        } else {
          d.resolve(false);
          // d.reject();
        }
      });
      return d.promise;
    }



    function getBrtSwitches(callback) {
      var _return = {};
      var _this = this;
      ajax.getBrtSwitches().then(
          function (data) {
            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {

              _this.brtSwitches = data;
              _return.result = 'success';
              _return.data = data;

              return callback(_return);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              //_dashboardTravelPackageData = null;
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          }, function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get(error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get('error_get_permissions');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          }
      );
    }

    function getBriteBillListOfBills(request, headerData, callback) {
      var _return = {};
      ajax.getBriteBillListOfBills(request, headerData).then(
          function (data) {
            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {
              _return.result = 'success';

              try {
                _return.data = JSON.parse(data);
              } catch (e) {
                _return.data = {bills: undefined};
              }
              return callback(_return);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              //_dashboardTravelPackageData = null;
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          }, function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get(error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get('error_brite_bill_get_bill_list');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          }
      );
    }

    //CONVERT DATE IS PART OF BRITEBILL FUNCTIONALITY -- WE NEED TO TURN THIS INTO A FILTER
    function convertDate(date) {
      //console.log("date:" +date);
      //date = "2015-06-01";
      var _date = date.split('-');
      // _date[0] - year, _date[1] - month, _date[2] - day
      var _dateObj = new Date(_date[0], _date[1] - 1, _date[2]);
      //console.log(_dateObj);
      var day = _dateObj.getDate();
      //Commenting out the date increment as we should use the date that is returned by the britebill server - was causing MYR-1041
      //day++;
      var _months = resource.get('_months');
      var month = _months[_dateObj.getMonth()];
      if (userLanguage() === 'en') {
        date = month + ' ' + day + ', ' + _dateObj.getFullYear();
      } else {
        date = day + ' ' + month + ' ' + _dateObj.getFullYear();
      }

      //console.log(userLanguage() + ":" + date);
      return date;
    }

    function getBriteBillList(currentAccNumber) {

      service.loadingBriteBill = true;
      $rootScope.briteBillFailed = false;
      $rootScope.isbritebillAvailable = false;

      service.britebill = null;
      service.briteBillError = null;
      /*
       var currentAccNumber = '';
       if (!$rootScope.ao && !$rootScope.ao.accountActive && !$rootScope.ao.accountActive.accountNumber) {
       return;
       } else if ($rootScope.ao) {
       if ($rootScope.ao.accountActive === null) {
       return;
       }
       } else if ($rootScope.ao && $rootScope.ao.accountActive && !$rootScope.ao.accountActive.accountNumber) {
       return;
       }*/

      $rootScope.ao.britebill = null;
      $rootScope.bbpermission = false;

      var bbrequest = {
        'currentAccNumber': currentAccNumber,
        'applicationId': 'MyAccount'
      };

      function processBriteBill(_tmp2) {

        if (_tmp2.result === 'success') {
          if (_tmp2.data && _tmp2.data.bills && _tmp2.data.bills.length > 0) {
            var bills = _tmp2.data.bills;

            bills.sort(function (a, b) {
              //Dates are iso std YYYY-MM-DD
              var c = new Date(a.issue_date);// jshint ignore:line
              var d = new Date(b.issue_date);// jshint ignore:line
              return d - c;
            });
            $rootScope.briteBillInvoiceDates = '';
            for (var i = 0; i < bills.length; i++) {

              bills[i].name = bills[i].issue_date ? convertDate(bills[i].issue_date) : bills[i].name; // jshint ignore:line
              bills[i].id = bills[i].issue_date; // jshint ignore:line

              if ($rootScope.briteBillInvoiceDates) {
                $rootScope.briteBillInvoiceDates += "," + bills[i].issue_date; // jshint ignore:line
              } else {
                $rootScope.briteBillInvoiceDates += bills[i].issue_date;// jshint ignore:line
              }
            }
            service.briteBillInvoiceDates = $rootScope.briteBillInvoiceDates;
            if (bills.length > 0) {
              service.briteBillOldestDate = bills[bills.length - 1].name;
            }
            $rootScope.ao.britebill = bills;
            service.britebill = bills;
            if (bills.length > 0) {
              $rootScope.isbritebillAvailable = true;
            }
            service.loadingBriteBill = false;
            invoiceService.isInvoiceProcessing = false;

            service.invoiceDateArray = bills;
            if ($rootScope.isConsumer) {
              service.invoiceDateArray.push({
                id: "legacy",
                name: resource.get('acc_balance_view_older_bill')//+ ' ' +service.briteBillOldestDate
              });
            }
            if(null == localStorage.getLocalStorageValue('invoiceDateSelected') || undefined == localStorage.getLocalStorageValue('invoiceDateSelected')  || localStorage.getLocalStorageValue('invoiceDateSelected') == ""){
                  service.invoiceDateSelected = bills[0].issue_date;
                  service.showInvoiceDates = true;
                  service.defaultLink = bills[0].link;
                  $rootScope.$emit('invoiceDateChange', {link: bills[0].link});
            }
            else{
                service.invoiceDateSelected = localStorage.getLocalStorageValue('invoiceDateSelected');
                service.showInvoiceDates = true;
                service.defaultLink =   localStorage.getLocalStorageValue('defaultLink');
                $rootScope.$emit('invoiceDateChange', {link: localStorage.getLocalStorageValue('defaultLink'), issue_date: localStorage.getLocalStorageValue('invoiceDateSelected')});
                localStorage.deleteLocalStorageValue('invoiceDateSelected');
                localStorage.deleteLocalStorageValue('defaultLink');
            }

          } else {
            // no bills
            $rootScope.ao.britebill = undefined;
            service.loadingBriteBill = false;
            if (typeof(_tmp2.data == 'string')) {
              service.briteBillError = briteBillServerLogs.briteBillError + _tmp2.data;
            } else {
              service.briteBillError = briteBillServerLogs.briteBillError + 'no bills';
            }
          }
        } else {
          service.loadingBriteBill = false;
          if (_tmp2.result === 'fail') {

          } else if (_tmp2.result === 'error') {
            $rootScope.briteBillFailed = true;

          } else {
            // Unknown state ???
          }
        }

      }

      function processBriteBillEncryptionKey(_tmp) {

        if (_tmp.result === 'success') {

          if (_tmp.data.encryptedString) {
            var headerData = {'EncryptedToken': _tmp.data.encryptedString,'If-Modified-Since': 0};
            var data = {
              'appID': 'MyAccount',
              'uuid': new Date().getTime()
            };

            service.getBriteBillListOfBills(data, headerData, processBriteBill);
          } else {
            service.loadingBriteBill = false;
            service.briteBillError = briteBillServerLogs.briteBillError + 'brtSwitch is off';
          }

        } else {
          service.loadingBriteBill = false;
          if (_tmp.result === 'fail') {

          } else if (_tmp.result === 'error') {
            $rootScope.briteBillFailed = true;
          } else {
            // Unknown state ???
          }
        }
      }

      function processSwitches(_temp) {

        localStorage['brtSwitches'] = JSON.stringify(_temp);
        var currentPage = localStorage.getLocalStorageValue('toStateName');

        if (_temp.result === 'success') {
          if (_temp.data.length > 0) {
            $rootScope.ao.brtSwitches = _temp.data;

            var result = $.grep(_temp.data, function (e) {
              return e.id == 'BRITEBILL_UTE_BSS';
            });
            if (result) {
              $rootScope.bbpermission = result[0].switchIsOn;
              localStorage.setLocalStorageValue('BSS_BB_UTE', $rootScope.bbpermission);
            }

          }

          if ($rootScope.bbpermission) {
            service.getBriteBill(bbrequest, processBriteBillEncryptionKey);
          } else {
            if(currentPage != null && currentPage != undefined) {
              if (currentPage == 'viewbill')
                redirectUserToLegacy();
              else if (currentPage == 'legacyviewbill')
                redirectUserToLegacyEpost();
                }
          }
        } else {
          if(currentPage != null && currentPage != undefined) {
            if (currentPage == 'viewbill')
              redirectUserToLegacy();
            else if (currentPage == 'legacyviewbill')
              redirectUserToLegacyEpost();
          }
          service.loadingBriteBill = false;
          if (_temp.result === 'fail') {

          } else if (_temp.result === 'error') {
            $rootScope.briteBillFailed = true;

          } else {
            // Unknown state ???
          }
        }
      }



      //service.getBriteBill(bbrequest, processBriteBillEncryptionKey);
      if (!localStorage['brtSwitches'] || (localStorage['brtSwitches'] && JSON.parse(localStorage['brtSwitches']).data.length == 0)) {
        service.getBrtSwitches(processSwitches);
      } else {
        processSwitches(JSON.parse(localStorage['brtSwitches']));
      }

    }

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrPaymentTopBarController
   * @description
   * # MyrPaymentTopBarController
   * Controller of the totesApp
   */
  angular.module('myr.modules.paymentTopBar').controller('MyrPaymentTopBarController', PaymentTopBarController);

  PaymentTopBarController.$inject = ['appState'];

  /* @ngInject */
  function PaymentTopBarController(appState) {

    var vm = this;

    vm.init = function(){
      appState.switchView('/viewInvoice');
    }

    vm.init();

  }
})();

(function () {
  'use strict';

  angular.module('myr.modules.paymentTopBar').directive('myrPaymentTopBar', paymentTopBar);

  paymentTopBar.$inject = ['localStorage'];

  /* @ngInject */
  function paymentTopBar() {
    return {
      templateUrl: 'scripts/modules/myrPaymentTopBar/paymentTopBarView.html',
      restrict: 'EA',
      controller: '@',
      name: 'controllerName',
      controllerAs: 'ptb',
      bindToController: true
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.paymentTopBar').factory('myrPaymentTopBarService', paymentTopBarService);

  paymentTopBarService.$inject = ['$rootScope','myrAccountBalanceDataFactory', 'userLanguage'];

  /* @ngInject */
  function paymentTopBarService( $rootScope,myrAccountBalanceDataFactory, userLanguage) {

    var abdf = myrAccountBalanceDataFactory;

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      paymentMethod:null,
      ccType:null,
      refreshBalanceDetails:refreshBalanceDetails
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function refreshBalanceDetails(){

      var request = {
        accountNumber: $rootScope.ao.accountActive.accountNumber,
        accountTypeNumber: $rootScope.ao.accountActive.accountTypeNumber,
        language: userLanguage(),
        refresh: false,
        applicationId: 'Rogers.com'
      };

      // with other items in the call
      try {
        request.pinNumber = vm.als.selectedAccount.pinNumber;
      } catch (e) {
      }
      try {
        request.phoneNumber = $rootScope.ao.accountActive.phoneNumber;
      } catch (e) {
      }
      try {
        request.indx = $rootScope.ao.accountActiveIndex;
      } catch (e) {
      }

      abdf.getBalanceDetails(request, function () {

        service.paymentMethod= abdf.accountBalance.methodOfPayment ? abdf.accountBalance.methodOfPayment.mopType : 'U';

        try {
          service.ccType = abdf.billingDetails.methodOfPayment.creditCardDetails.ccType;
        } catch (e) {
          service.ccType = null;
        }

      }, true);

    }

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
 'use strict';

 /**
  * @ngdoc function
  * @name totesApp.controller:utePaymentTopBarController
  * @description
  * # utePaymentTopBarController
  * Controller of the totesApp
  */
 angular.module('myr.modules.paymentTopBar').controller('utePaymentTopBarController', utePaymentTopBarController);

 utePaymentTopBarController.$inject = ['appState'];

 /* @ngInject */
 function utePaymentTopBarController(appState) {

    var vm = this;
    vm.init = function(){
        appState.switchView('/viewInvoice');
    }

    vm.init();
 }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.viewBill').controller('MyrViewBillController', ViewBillController);

  ViewBillController.$inject = ['$scope', '$rootScope', '$state', 'myrBriteBillService', 'myrAccountOverviewService', 'resource', 'userLanguage', 'localStorage', '$timeout', 'permissionData', 'invoiceService'];

  /* @ngInject */
  function ViewBillController($scope, $rootScope, $state, myrBriteBillService, accountOverviewService, resource, userLanguage, localStorage, $timeout, permissionData, invoiceService) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    var vm = this;

    $scope.lang = userLanguage();
    vm.briteBillFailed = false;
    vm.loadingDataIndicator = false;
    vm.state = $state.current.name;
    vm.isCable = (localStorage.getLocalStorageValue('smbInvoiceMode') == 'LEGACY' || localStorage.getLocalStorageValue('accountNumber').length == 12);

    vm.isBriteBillErrorOccurred = function(){
      return invoiceService.isBriteBillErrorOccured();
    }

    vm.isNoBillsAvailable = function(){
      return invoiceService.isNoBillsAvailable();
    }

    vm.isInvoiceProcessing = function(){
      return invoiceService.isInvoiceProcessing;
    }

    vm.isLegacyRedirection = function(){
      return myrBriteBillService.isLegacyRedirection;
    }

    $scope.boldChat = {
        viewBillError: {
          en: {
            cbid: 'S_BSS_Device_Details',
            dynamicDivId: 'Wireless_Bill_Error_div',
            chatButtonClass:'chatButtonWirelessBillErrorEn'
          },

          fr: {
            cbid: 'S_BSS_Device_Details_Fr',
            dynamicDivId: 'Wireless_BB_Error_Fr_div',
            chatButtonClass:'chatButtonWirelessBillErrorFr'
          }
        }
    };

  }
})();

(function() {
  'use strict';

  angular.module('myr.modules.viewBill').config(billRoutesConfig);
  billRoutesConfig.$inject = ['$stateProvider'];

  function billRoutesConfig($stateProvider) {
    var allStates = [{
        name: 'viewInvoice',
        url: '/viewInvoice?directLanding&ban&ctn',
        controller: 'uteBillController',
        controllerAs: 'ub',
        templateUrl: 'scripts/modules/uteBill/uteBill.html',
        resolve: {
          deepLinkingHandler: function (deeplink, $stateParams) {
            deeplink.storeDirectLandingData($stateParams);
            deeplink.internal('/viewInvoice');
          },
          permissionData: function (permissionResolver, uteBillService) {
            return permissionResolver.getPermission(this.url.sourcePath).then(function(){
                return uteBillService.isUteBill();
            });
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/viewInvoice');
          globalloaderService.hide();
        },
        onExit: function (appInterface, $location) {
          //Code to clear the query string and reflect it in url
          $location.search('source', null);
          $location.search('legacy_cable_acct', null);
          appInterface.stateExit('/viewInvoice');
        }
      },
      {
        name: 'viewbill',
        url: '/viewbill?directLanding&ban&ctn',
        controller: 'MyrViewBillController',
        controllerAs: 'vb',
        templateUrl: 'scripts/modules/myrViewBill/viewBill.html',
        resolve: {
          deepLinkingHandler: function (deeplink, $stateParams) {
            deeplink.storeDirectLandingData($stateParams);
            deeplink.internal('/viewInvoice');
          },
          permissionData: function (permissionResolver, myrBriteBillService, $browser, invoiceService, localStorage) {
            return permissionResolver.getPermission(this.url.sourcePath).then(function(){
              var accountNumber = localStorage.getLocalStorageValue('accountNumber');
              var smbInvoiceSwitch = $browser.cookies().smbInvoiceMode;
              if(accountNumber.length == 12 || smbInvoiceSwitch == null || smbInvoiceSwitch == 'undefined' || smbInvoiceSwitch == '' || smbInvoiceSwitch == undefined || smbInvoiceSwitch == 'LEGACY'){
                return myrBriteBillService.isBriteBill();
               }
              else {
                return invoiceService.isBriteBill();
              }
            });
          }
        },
        onEnter: function (appInterface, globalloaderService) {
          appInterface.stateEnter('/viewInvoice');
          globalloaderService.hide();
        },
        onExit: function (appInterface, $location) {
          //Code to clear the query string and reflect it in url
          $location.search('source', null);
          $location.search('legacy_cable_acct', null);
          appInterface.stateExit('/viewInvoice');
        }
      }
    ];

    $.each(allStates, function (k, v) {
      $stateProvider.state(v);
    });
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner').config(configure);

  configure.$inject = ['$logProvider'];

  /* @ngInject */
  function configure($logProvider) {
    if ($logProvider.debugEnabled) {
      $logProvider.debugEnabled(false);
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner').constant('lodash', _);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner').controller('MyrNotificationBannerController', NotificationBannerController);

  NotificationBannerController.$inject = ['myrNotificationBannerService', '$log'];

  /* @ngInject */
  function NotificationBannerController(notificationBannerService, $log) {
    var vm = this;

    // Public API
    vm.registerBanner = registerBanner;
    vm.getMessage = getMessage;
    vm.isVisible = isVisible;

    ///////////////////////////////////////////////////////////////

    // private
    var _bannerId;

    /**
     *
     * @param bannerId
     */
    function registerBanner(bannerId) {
      _bannerId = bannerId;
      return notificationBannerService.registerBanner(bannerId);
    }

    /**
     * get message for banner
     */
    function getMessage() {
      return notificationBannerService.getMessage(_bannerId);
    }

    /**
     * is banner visible
     */
    function isVisible() {
      return angular.isDefined(notificationBannerService.getMessage(_bannerId)) && !!notificationBannerService.getMessage(_bannerId);
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
  /*
   Global banner widget. When included, it will display a banner with the Rogers icon and
   available types:
   --success
   --warning
   --error
   --info
   Example:
   <notificationBanner type="success" message="resource-key"></notificationBanner>
   */
  angular.module('myr.modules.notificationBanner').directive('myrNotificationBanner', notificationBanner);

  notificationBanner.$inject = ['$log'];

  /* @ngInject */
  function notificationBanner($log) {
    return {
      restrict: "EA",
      templateUrl: "scripts/modules/notificationBanner/notificationBanner.html",
      scope: {
        type: '='
      },
      link: linkFunc,
      replace: true,
      controller: 'MyrNotificationBannerController',
      controllerAs: 'nb',
      bindToController: true
    };

    function linkFunc(scope, element, attrs, ctrl) {
      ctrl.registerBanner(attrs.bannerId);
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner').factory('myrNotificationBannerService', notificationBannerService);

  notificationBannerService.$inject = ['$log', '$rootScope', '$injector', '$timeout'];

  /* @ngInject */
  function notificationBannerService($log, $rootScope, $injector, $timeout) {
    // TODO fix dependency
    var resource = $injector.get('resource');

    // Public API
    var service = {
      registerBanner: registerBanner,
      sendMessageKey: sendMessageKey,
      sendMessage: sendMessage,
      getMessage: getMessage,
      cleanBanner: cleanBanner
    };

    var data = {
      banners: {}
    };

    // TODO move to utit tests
    /*
     sendMessageKey('linkedMessage', 'linked_acc_success');
     sendMessage('successMessage', 'test message');

     $timeout(function () {
     cleanBanner('linkedMessage');
     }, 5000);

     $timeout(function () {
     cleanBanner('successMessage');
     }, 10000);
     */
    return service;

    ///////////////////////////////////////////////////////////////

    /**
     *
     * @param bannerId
     */
    function registerBanner(bannerId) {
      // TODO
      return true;
    }

    /**
     * get message for bannerId
     *
     * @param bannerId
     * @returns {*}
     */
    function getMessage(bannerId) {
      return data.banners[bannerId];
    }

    /**
     * Sent message to the banner with bannerId
     *
     * @param bannerId
     * @param message
     * @returns {boolean}
     */
    function sendMessage(bannerId, message) {
      data.banners[bannerId] = message;
      return true;
    }

    /**
     * Sent a message by resource key to the banner with bannerId
     *
     * @param bannerId
     * @param messageKey
     * @returns {boolean}
     */
    function sendMessageKey(bannerId, messageKey) {
      if (!!messageKey && !!bannerId) {
        if(messageKey === 'mu_msg_success'){
          data.banners[bannerId] = resource.get('mu_msg_success') + $rootScope.migratedEmail + '<br>' + resource.get('mu_msg_success_1');
          return true;
        } else {
          data.banners[bannerId] = resource.get(messageKey);
          return true;
        }
      } else {
        return false;
      }
    }

    /**
     * Clean a banner with bannerId
     *
     * @param bannerId
     * @returns {boolean}
     */
    function cleanBanner(bannerId) {
      if (!!bannerId) {
        data.banners[bannerId] = null;
        return true;
      } else {
        return false;
      }
    }
  }
}());

(function () {
  'use strict';

  angular.module('totesApp').controller('PayHistoryController', PayHistoryController);

  PayHistoryController.$inject = ['$scope', '$state', 'ajax', 'resource', '$rootScope', 'appState', 'myrPayNowService', 'userLanguage', 'myrAccountOverviewService', 'myrChangePaymentMethodService', '$stateParams', 'settings', '$modal', '$timeout', 'localStorage', 'semafoneService', '$document', 'myrMyServicesService', 'myrAccountBalanceService'];

  /* @ngInject */
  function PayHistoryController($scope, $state, ajax, resource, $rootScope, appState, myrPayNowService, userLanguage, accountOverviewService, paymentMethodService, $stateParams, settings, $modal, $timeout, localStorage, semafoneService, $document, myrMyServicesService, myrAccountBalanceService) {

    function init() {
      var isDetailsAvailable = false;
      if(accountOverviewService.getSelectedAccountDetail()) {
        $scope.selectedAccNum = accountOverviewService.getSelectedAccountDetail().billableAccountNumber;
        $scope.selectedAccContactId = accountOverviewService.getSelectedAccountDetail().contactId;
        $scope.selectedAccLOB = accountOverviewService.getSelectedAccountDetail().lob;
        $scope.selectedAccName = accountOverviewService.getSelectedAccountDetail().nickName;
        isDetailsAvailable = true;
      }
      else if((undefined != localStorage.getLocalStorageValue('accountNo')) && ("" != localStorage.getLocalStorageValue('accountNo'))){
        $scope.selectedAccNum = localStorage.getLocalStorageValue('accountNo');
        $scope.selectedAccContactId = localStorage.getLocalStorageValue('contactId');
        $scope.selectedAccLOB = localStorage.getLocalStorageValue('LOB');
        $scope.lang = userLanguage();
        isDetailsAvailable = true;
      }
      if (!isDetailsAvailable) {
        appState.switchView('accountOverview');
      }
    }

    init();
  }

})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  // TODO not used
  angular.module('totesApp').directive('myrCreditCardNumber', creditCardNumber);

  function creditCardNumber() {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function ($scope, elm, attrs, ctrl) {
        ctrl.$validators.creditCardNumber = function (modelValue, viewValue) {
          return false;
        };
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  // TODO not used
  angular.module('totesApp').controller('MyrDialogCancelPaymentController', DialogCancelPaymentController);

  DialogCancelPaymentController.$inject = ['$scope', 'appState'];

  /* @ngInject */
  function DialogCancelPaymentController($scope, appState) {
    $scope.next = function () {

      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line

      appState.switchView('accountOverview');
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrPayNowContinueModalController', PayNowContinueModalController);

  PayNowContinueModalController.$inject = ['$scope', '$modalInstance', '$rootScope', 'userLanguage', 'settings'];

  /* @ngInject */
  function PayNowContinueModalController($scope, $modalInstance, $rootScope, userLanguage, settings) {

    $scope.showCreditCardForm = $rootScope.showCreditCardForm;
    $scope.showDebitForm = $rootScope.showDebitForm;
    $scope.isLanguageFr = false;
    $scope.isPaynow = false;
    var lang = userLanguage();
    if (settings.defaultLanguage != lang) {
      $scope.isLanguageFr = true;
    }

    $scope.close = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };
    if ($scope.showCreditCardForm || $scope.showDebitForm) {
      $scope.isPaynow = false;
    } else {
      $scope.isPaynow = true;
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrPayNowController', PayNowController);

  PayNowController.$inject = ['$scope', '$state', 'ajax', 'resource', '$rootScope', 'appState', 'myrPayNowService', 'userLanguage', 'myrAccountOverviewService', 'myrChangePaymentMethodService', '$stateParams', 'settings', '$modal', '$timeout', 'localStorage', 'semafoneService', '$document', 'myrMyServicesService', 'myrAccountBalanceService'];

  /* @ngInject */
  function PayNowController($scope, $state, ajax, resource, $rootScope, appState, myrPayNowService, userLanguage, accountOverviewService, paymentMethodService, $stateParams, settings, $modal, $timeout, localStorage, semafoneService, $document, myrMyServicesService, myrAccountBalanceService) {
    $scope.lang = appState.language;
    $scope.selectedAccount = {};
    $scope.state = $state.current.name;

    $scope.mss = myrMyServicesService;
    $scope.abs = myrAccountBalanceService;

    var params = $stateParams;

    $scope.wtf = '123';

    try {
      $scope.$extend({
        //fake hard-coded data
        mode: 'paynow',
        paymentMethods: {
          creditcard: {
            id: 2,
            name: resource.get('paynow_cc'),
            label: '',
            image: 'images/cc.png'
          },
          interac: {
            id: 1,
            name: resource.get('paynow_interac'),
            label: resource.get('paynow_interac_2'),
            image: 'images/interac.png'
          }
        },
        isValidCard: true,
        cards: {
          visa: {
            id: 0,
            name: 'VI',
            image: 'images/visa.png'
          },
          mc: {
            id: 1,
            name: 'MC',
            image: 'images/mc.png'
          },
          amex: {
            id: 2,
            name: 'AM',
            image: 'images/am.png'
          }
        },
        showCreditCardForm: true, //Set flag to be true for credit card directive

        errorMessage: '',
        isError: false,
        selectedCreditCard: false,
        isConfirmPanel: false,
        currentDate: new Date(),
        maskedCC: '',
        monthsNames: resource.get('_months'),
        dtPaid: '',
        isEnglish: true,
        isPreAuthorized: paymentMethodService.isActiveAccountMethodInvoice() || false,
        isAmountValid: true,
        isOverPaid: false,
        isExpDateValid: true,
        isCodeValid: true,
        isTooltipClicked: false,
        isPaymentFinished: false,
        loadingDataIndicatorPayment: false,
        dueAmount: 0,
        //urlInteracFailure : 'https//' +  window.location.hostname +'/web/myrogers/postpaidselfserve/debittopupnotfunded', //window.location.href.replace('#/paynow', '#/accountOverview'), //window.location.hostname + '/#/accountOverview',
        urlInteracFailure: 'https://www.rogers.com/web/RogersServices.portal/api/v1/interac/notfunded', //window.location.href.replace('#/paynow', '#/accountOverview'), //window.location.hostname + '/#/accountOverview',

        //urlInteracSuccess : 'https//' +  window.location.hostname +'/web/myrogers/postpaidselfserve/debittopupfunded',
        urlInteracSuccess: 'https://www.rogers.com/web/RogersServices.portal/api/v1/interac/debitfunded',
        //form data
        paymentAmount: $scope.dueAmount,
        months: myrPayNowService.months,
        years: myrPayNowService.expireYears(),
        //payment form data
        selectedMethodId: 0,
        inputCreditCardNo: null,
        merchantNumber: '',
        interacResult: '',
        thankYouMessage: '',
        sorryMessage: '',
        interacRefNumber: null,
        creditPaymentObj: {
          isCreditCard: null,
          creditCardType: null,
          creditCardNo: null, //'4234567890987654', //null,
          expireDate: {
            month: null,
            year: null
          },
          securityCode: null,
          NameOnCard: null
        },
        interactPaymentObj: {
          isInterac: null
        },
        emptyCreditCardObj: null,
        form: $scope.form,
        //payment status from the server
        paymentStatus: null,
        errorSummary: null,
        clearCasheDetails: false,
        serverHack: '/web/smb/bss',
        validateAmount: function () {
          $scope.isAmountValid = false;
          $scope.isOverPaid = false;
          $scope.form.$setValidity('paymentAmount', null);
          //$scope.form.paymentAmount.$viewValue = Number($scope.form.paymentAmount.$viewValue).toFixed(2);
          var _amountViewValue = $scope.form.paymentAmount.$viewValue;
          if (userLanguage() === 'fr') {
            _amountViewValue = _amountViewValue.replace(',', '.');
          }
          var _inputValue = Number(_amountViewValue);
          if (!_inputValue || _inputValue <= 0) {
            $scope.form.$setValidity('paymentAmount', false);
            return false;
          }
          if (_inputValue >= settings.paymentMaximum + Number($scope.dueAmount)) {
            $scope.isAmountValid = false;
            $scope.isOverPaid = true;
          } else if (_inputValue > $scope.dueAmount) {
            $scope.isAmountValid = true;
            $scope.isOverPaid = true;
          } else if (_inputValue > 0) {
            $scope.isAmountValid = true;
            $scope.isOverPaid = false;
          } else {
            $scope.isAmountValid = false;
            $scope.isOverPaid = false;
          }

          var pa = $scope.paymentAmount;

          if (!$scope.isAmountValid) {
            $scope.form.$setValidity('paymentAmount', false);
          }
        },
        handleSuccess: function (response) {
          //update account overview
          $scope.loadingDataIndicatorPayment = false;

          if (!params) {
            accountOverviewService.purgeAccountList();
          }

          $scope.isPaymentFinished = true;
          if ($scope.form) {
            $scope.form.$setPristine();
          }
          appState.afterPaymentRefresh = true;
          if ($scope.clearCasheDetails) {

            localStorage.setLocalStorageValue('refreshDetails', '1');
          }

          if (settings.isLocal) {
            $scope.serverHack = '';
          }

          $rootScope.modalP = $modal.open({
            templateUrl: $scope.serverHack + '/views/modals/paynowSuccess.html',
            controller: 'MyrPayNowController',
            size: 'lg',
            backdrop: 'static',
            backdropClass: 'bkg-modal',
            resolve: {}
          });

          $rootScope.modalP.result.then(function () {
            // $scope.creditPaymentObj.isCreditCard = true;
          }, function () {
            // on Cancel behaviour
          });

        },
        handleError: function (errorCode) {
          $scope.loadingDataIndicatorPayment = false;
          var msg = !errorCode ? 'server error' : 'payment was not accepted, error code: ' + errorCode;
          appState.tagging(['_trackLink', {eVar49: msg},
            {event15: ''}// Generic Error
          ]);

          if (settings.isLocal) {
            $scope.serverHack = '';
          }

          $rootScope.modalP = $modal.open({
            templateUrl: $scope.serverHack + '/views/modals/paynowFailure.html',
            controller: 'MyrPayNowController',
            size: 'md',
            backdrop: 'static',
            backdropClass: 'bkg-modal',
            resolve: {}
          });

          $rootScope.modalP.result.then(function () {

          }, function () {
            // on Cancel behaviour
            $scope.creditPaymentObj.isCreditCard = null;
            $scope.selectedCreditCard = false;
            $scope.isConfirmPanel = false;
          });

        },
        showCancel: function () {
          if (settings.isLocal) {
            $scope.serverHack = '';
          }

          $rootScope.modalP = $modal.open({
            templateUrl: $scope.serverHack + '/views/modals/paynowCancel.html',
            controller: 'MyrPayNowController',
            size: 'md',
            backdrop: 'static',
            backdropClass: 'bkg-modal',
            resolve: {}
          });

        },
        cancelOk: function () {
          $rootScope.modalP.dismiss('cancel');
          $rootScope.modalP = null;

        },
        cancelCancel: function () {
          $rootScope.modalP.dismiss('cancel');
          $rootScope.modalP = null;

          // Look into  non_angular_script/supportFunctions.js  for more information
          scrollPageToTop();					// jshint ignore:line
          appState.switchView('accountOverview');
        },
        showBegin: function () {


          $rootScope.modalP.dismiss('cancel');
          $rootScope.modalP = null;

          //$window.location.reload();

        },
        submit: function () {

          $scope.validateAmount();
          $scope.setCCType();
          $scope.validateSecurityCode();
          $scope.validateExpireDate();

          //form validation error occurs
          if ($scope.form.$invalid) {
            appState.tagFormValidationErrors('PayNow', $scope.form.$error);
          }

          if ($scope.form.$valid && $scope.isValidCard && $scope.isExpDateValid && $scope.isCodeValid && $scope.isAmountValid) {

            if ($rootScope.isDealer || $rootScope.isCare) {
              $scope.openMesgModal();
            }
            else {
              if ($scope.isConfirmPanel === false) {
                //show confirm page
                appState.tagging(['_trackPageView',
                  {pn: 'home:myrogers:make-a-payment:review'}
                ]);
                $scope.isConfirmPanel = true;
                var maskedCardNumber = semafoneService.getMaskedCardNumber().replace(/\*/g, 'x');
                $scope.maskedCC = maskedCardNumber;
                $scope.totalLimitF = Number($scope.paymentAmount).toFixed(2).replace('.', ',');
                $scope.dtPaid = $scope.monthsNames[new Date().getMonth()] + ' ' + new Date().getDate() + ', ' + new Date().getFullYear();

                // Look into  non_angular_script/supportFunctions.js  for more information
                scrollPageToTop();					// jshint ignore:line
                return false;
              } else {
                //submit form
                // Show loader bit
                $scope.loadingDataIndicatorPayment = true;

                if ($scope.creditPaymentObj.isCreditCard === true) {
                  //store a local copy
                  $scope.storeScope();
                  $scope.creditPaymentObj.creditCardNo = semafoneService.getToken();
                  var _paymentAmount = $scope.paymentAmount;
                  if (userLanguage() === 'fr') {
                    _paymentAmount = _paymentAmount.replace(',', '.');
                    _paymentAmount = Number(_paymentAmount).toFixed(2);
                  }
                  $scope.creditPaymentObj.paymentAmount = Number(_paymentAmount).toFixed(2);

                  ajax.payNow($scope.creditPaymentObj, $scope.selectedAccount.accountNumber, $scope.selectedAccount.accountType,
                    $scope.selectedAccount.subNumber, $scope.selectedAccount.isConsolidated).then(
                    function (response) {
                      // Hide loader bit
                      //$rootScope.$broadcast('hideGlobalLoader');

                      if (response === undefined) {
                        $scope.handleError(null);
                      } else {
                        appState.tagging(['_trackLink',
                          {eVar13: 'MyRogers - Make a Payment'},
                          {prop13: 'D=v13'}, {event6: ''},
                          {event40: ''}]);

                        $scope.handleSuccess(response);
                      }
                    },
                    function (error) {
                      // Hide loader bit
                      // $rootScope.$broadcast('hideGlobalLoader');
                      $scope.recoverScope();

                      // Error handling - 555 exception
                      if (error.data.status === 555) {

                      } else {
                        // anything but status code 555
                      }

                      $scope.handleError(error.errorCode);
                    });
                }
//									if ($scope.creditPaymentObj.isCreditCard === false) { /* ??? */ }
              }
            }
          }
        },
        /**
         select credit card payment method.
         */
        makeCCPayment: function () {
          $scope.interactPaymentObj.isInterac = false;
          $scope.creditPaymentObj.isCreditCard = true;
          $scope.selectedCreditCard = true;

          $timeout(function () {
            $document.duScrollToElement(angular.element(document.getElementById('sema')), 200);
          });

          appState.tagging(['_trackPageView',
            {pn: 'home:myrogers:make-a-payment:credit-card'},
            {eVar13: 'MyRogers - Make a Payment - credit card'},
            {event5: ''}
          ]);
        },
        //make interact payment
        makeInteracPayment: function () {
					if($rootScope.isConsumer) {
            var userValue = $scope.paymentAmount;
            userValue = userValue.replace(',', '.');

            var pAmount = Number(userValue);
            if ($scope.form.paymentAmount.$invalid || pAmount <= 0) {
              return;
            }

            $scope.interactPaymentObj.isInterac = true;
            $scope.creditPaymentObj.isCreditCard = false;
            $scope.selectedCreditCard = false;

            if ($scope.interactPaymentObj.isInterac && $scope.selectedAccount) {
              appState.tagging(['_trackPageView',
                {eVar13: 'MyRogers - Make a Payment - Interac'},
                {event5: ''}
              ]);

              var _paymentAmount = $scope.paymentAmount;
              if (userLanguage() === 'fr') {
                _paymentAmount = _paymentAmount.replace(',', '.');
              }

              _paymentAmount = Number(_paymentAmount).toFixed(2);
              var _dueAmountToSend = Number($scope.dueAmount).toFixed(2);

              ajax.interacEligibility($scope.selectedAccount.accountNumber, $scope.selectedAccount.accountType, _dueAmountToSend, _paymentAmount).then(
                function (response) {
                  // Hide loader bit
                  //$rootScope.$broadcast('hideGlobalLoader');
                  $scope.loadingDataIndicatorPayment = false;
                  if (response === undefined) {
                    $scope.handleError(null);
                  } else {
                    appState.tagging(['_trackLink',
                      {eVar13: 'MyRogers - Make a Payment'},
                      {prop13: 'D=v13'}, {event6: ''},
                      {event40: ''}]);

                    $scope.merchantNumber = response.IDEBIT_MERCHNUM;
                    $scope.IDEBIT_MERCHDATA = response.IDEBIT_MERCHDATA;
                    $scope.IDEBIT_INVOICE = response.IDEBIT_INVOICE;
                    $scope.IDEBIT_TERMID = response.IDEBIT_TERMID;
                    $scope.urlInteracFailure = response.IDEBIT_NOTFUNDEDURL;
                    $scope.urlInteracSuccess = response.IDEBIT_FUNDEDURL;
                    $scope.IDEBIT_AMOUNT = response.IDEBIT_AMOUNT;
                    $scope.IDEBIT_MERCHLANG = response.IDEBIT_MERCHLANG;

                    //'https://gateway.interaconline.com/merchant_processor.do'

                    //$('#formToRogers123').attr('action', 'https://merchant-test.interacidebit.ca/gateway/merchant_test_processor.do');
                    $('#formToRogers123').attr('action', response.interac_URL);  // jshint ignore:line

                    // $('#formToRogers123').attr('target','_blank');
                    $scope.paymentAmount = Number($scope.paymentAmount).toFixed(2);

                    $timeout(function () {
                      $('#formToRogers123').submit();
                    });

                  }

                },
                function (error) {
                  // Hide loader bit
                  // $rootScope.$broadcast('hideGlobalLoader');
                  $scope.loadingDataIndicatorPayment = false;
                  $scope.recoverScope();

                  // Error handling - 555 exception
                  if (error.data.status === 555) {

                  } else {
                    // anything but status code 555
                  }

                  $scope.handleError(error.errorCode);
                });
            }

          }

        },
        getCCLastDigits: function () {
          if ($scope.creditPaymentObj.creditCardNo && $scope.creditPaymentObj.creditCardNo.toString().length > 1) {
            var cNo = $scope.creditPaymentObj.creditCardNo.toString();
            var l = cNo.length - 4;
            return cNo.substring(l, cNo.length);
          }
        },
        showEdit: function () {
          $scope.isConfirmPanel = false;
        },
        getAccount: function () {
        },
        cancelPayNow: function () {
          // Look into  non_angular_script/supportFunctions.js  for more information
          //scrollPageToTop();					// jshint ignore:line
          if($rootScope.isDealer || $rootScope.isCare){
              appState.switchView('oneViewDashboard');
          } else{
              appState.switchView('accountOverview');
          }
        },
        goToOverview: function () {
          $rootScope.modalP.close('ok');
          $rootScope.modalP = null;
          //$window.location.reload(true);			/// ?????? WHY
          if($rootScope.isDealer || $rootScope.isCare){
             appState.switchView('oneViewDashboard');
          } else{
             appState.switchView('accountOverview');
          }
        }
      });
    } catch (e) {
      $scope.errorMessage = resource.get('maintenance_info');
      $scope.isError = true;
    }

    $scope.storeScope = function () {
      $scope.origObj = angular.copy($scope.creditPaymentObj);
    };
    $scope.recoverScope = function () {
      $.extend($scope.creditPaymentObj, $scope.origObj);
    };

    $scope.openUnderConstr = function (size) {

      if (settings.isLocal) {
        $scope.serverHack = '';
      }

      $rootScope.modal = $modal.open({
        templateUrl: $scope.serverHack + '/views/modals/underConstruction.html',
        controller: 'MyrUnderConstructionController',
        size: size,
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });

      $rootScope.modal.result.then(function () {
        // $scope.creditPaymentObj.isCreditCard = true;
      }, function () {
        // on Cancel behaviour
      });
    };

    $scope.getInteracReference = function () {
      ajax.interacConfirm($scope.selectedAccount.accountNumber).then(
        function (response) {
          if (response === undefined) {
            $scope.handleError(null);
          } else {
            $scope.interacRefNumber = response.referenceNumber;
            $scope.handleSuccess();
          }
        },
        function (error) {
          // Hide loader bit
          // $rootScope.$broadcast('hideGlobalLoader');
        });
    };

    function showBeginI() {
      console.log('wtf');
      $scope.wtf= '4567';
      appState.switchView('paynow');
    }

    function afterChangeMethod() {
      appState.switchView('accountOverview');
    }

    resource.onChanged(function () {
      try {
        $scope.paymentMethods.interac.name = resource.get('paynow_interac');
        $scope.paymentMethods.creditcard.name = resource.get('paynow_cc');
        $scope.paymentMethods.interac.label = resource.get('paynow_interac_2');
        $scope.tooltip = resource.get('paynow_card_tooltip');
        $scope.monthsNames = resource.get('_months');
        $scope.thankYouMessage = resource.get('paynow_thanks');
        $scope.sorryMessage = resource.get('paynow_sorry');
        $scope.errorMessage = resource.get('maintenance_info');

        $scope.lang = userLanguage();
        if ($scope.paymentAmount) {
          if ($scope.lang === 'en') {
            $scope.paymentAmount = $scope.paymentAmount.replace(',', '.');
          } else if ($scope.lang === 'fr') {
            $scope.paymentAmount = $scope.paymentAmount.replace('.', ',');
          }
          $scope.totalLimitF = $scope.paymentAmount.replace('.', ',');
        }

        // $scope.totalLimitF = $scope.creditPaymentObj.paymentAmount.replace('.', ',');
        $scope.dtPaid = $scope.monthsNames[new Date().getMonth()] + ' ' + new Date().getDate() + ', ' + new Date().getFullYear();
      } catch (e) {
        $scope.errorMessage = resource.get('maintenance_info');
        $scope.isError = true;
      }
    }, $scope);

    function init() {
      //save a reference
      $scope.emptyCreditCardObj = angular.copy($scope.creditPaymentObj);
      var _details = accountOverviewService.getSelectedAccountDetail();
      var _balance = accountOverviewService.getAccountBalance();

      $scope.dueAmount = _balance && _balance.balanceAmount && Number(_balance.balanceAmount) ? Number(_balance.balanceAmount) : 0;
      if (userLanguage() === 'en') {
        $scope.paymentAmount = $scope.dueAmount > 0 ? $scope.dueAmount.toFixed(2).replace(',', '.') : 0;
      } else if (userLanguage() === 'fr') {
        $scope.paymentAmount = $scope.dueAmount > 0 ? $scope.dueAmount.toFixed(2).replace('.', ',') : 0;
      }
      //	$scope.selectedAccount.accountNumber = _details.number;

      var proceed = true;

      $scope.selectedAccount.isConsolidated = false;
      try {
        $scope.selectedAccount.isConsolidated = _details.isConsolidated;
        proceed = true;
      } catch (error) {
        // Oh boy.. BIG problem
      }

      if (proceed) {
        $scope.paymentMethod = _details.paymentMethod;
        $scope.selectedAccount.subNumber = _details.number;  //ban number
        $scope.selectedAccount.accountNumber = _details.billableAccountNumber ? _details.billableAccountNumber : _details.number;
        $scope.selectedAccount.accountType = _details.type;
        $scope.isPreAuthorized = paymentMethodService.isActiveAccountMethodInvoice();

        if (_details.billableAccountNumber && _details.billableAccountNumber !== _details.number) {
          $scope.clearCasheDetails = true;
        }

        //came from Interac
        if ($stateParams.submodule && !appState.modalPayNowOpened) {
          appState.modalPayNowOpened = true;  //prevent looping
          $scope.interacResult = $stateParams.submodule;
          if ($scope.interacResult === 'funded') {
            $scope.handleSuccess();
          }

          if ($scope.interacResult === 'notfunded') {
            var _message = resource.get('paynow_sorry_i2');
            var _options = {
              title: resource.get('paynow_sorry_i1'),
              message: _message,
              onClose: showBeginI,
              icon: 'alert',
              buttons: [{
                label: 'paynow_select_another',
                type: 'primary',
                action: showBeginI
              }]
            };
            appState.setConfirmation(_options);
          }
        }
      }

      appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:make-a-payment'},
        {eVar13: 'MyRogers - Make a Payment'},
        {event5: ''}
      ]);
      $scope.storeScope();
    }

    if ($rootScope.ao.accountDetails) {
      $scope.selectedAccount = $rootScope.ao.accountActive;
      init();
    } else {
      var request = {
        accountNumber: $rootScope.ao.accountActive.accountNumber,
        accountTypeNumber: $rootScope.ao.accountActive.accountTypeNumber,
        language: userLanguage(),
        refresh: false,
        applicationId: 'Rogers.com'
      };

      // with other items in the call
      try {
        request.pinNumber = $rootScope.ao.accountActive.pinNumber;
      } catch (e) {
      }
      try {
        request.phoneNumber = $rootScope.ao.accountActive.phoneNumber;
      } catch (e) {
      }
      try {
        request.indx = $rootScope.ao.accountActiveIndex;
      } catch (e) {
      }

      accountOverviewService.resetCallingAccountDetails();
      accountOverviewService.getAccountDetails(request, function (data) {
        if (data) {
          $rootScope.ao.accountDetails = data.data;
          //init();
        } else {
          $scope.isError = true;
          $scope.errorMessage = resource.get('maintenance_info');
        }
      });
    }

    $scope.$watch('mss.selectedAccountDetail', function () {
      processInit();
    }, true);

    $scope.$watch('abs.accountBalance', function () {
      processInit();
    }, true);

    function processInit() {

      if (myrMyServicesService.selectedAccountDetail !== null && myrAccountBalanceService.accountBalance !== {}) {

        init();

      }
    }

    // Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal
    $scope.openMesgModal = function (size) {

      var serverHack = '/web/smb/bss';
      if (settings.isLocal) {
        serverHack = '';
      }

      $rootScope.modal = $modal.open({
        templateUrl: serverHack + '/scripts/modules/payNow/payNowContinueModal.html',
        controller: 'MyrPayNowContinueModalController',
        size: size,
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });

      $rootScope.modal.result.then(function () {
        // on OK behaviour
      }, function () {
        // on Cancel behaviour
      });
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').service('myrPayNowService', payNowService);

  payNowService.$inject = ['$q', '$window', 'ajax', 'encryption'];

  /* @ngInject */
  function payNowService($q, $window, ajax, encryption) {
    var _expireYears = [];

    return {
      postExpireYearsNum: 10,
      months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
      ccType: ['V', 'M', 'A'], //credit card types: visa, master and amex
      expireYears: function () {
        //return already calculated data
        if (_expireYears.length > 0) {
          return _expireYears;
        }
        var _currentYear = new Date().getFullYear();
        _expireYears.push(_currentYear);
        //get current year and add up to 10 years
        for (var i = 1; i <= 10; i++) {
          _expireYears.push(_currentYear + i);
        }
        return _expireYears;
      },
      //Tokenization flow of the input credit card:
      // 1. Encrypt the credit card number and request token from cybersource.
      // 2. Send the token to our server side for decrypted credit card number.
      // 3. User the decryped credit card number starting from "9****XXX" where XXX is the last three digits of the to the UI to make a credit card payment.
      tokenization: function (accountNUmber, cardNumber, cardType) {
        /*if( !cardNumber || this.ccType.contains(cardType) ){
         return;
         }*/
        var _ccType = this.ccType[cardType], _ccNum = cardNumber;
        var deferred = $q.defer();
        var _modulus, _exponent;

        //define angular call back for JSONP call.
        var c = $window.angular.callbacks.counter.toString(36);
        $window['angularcallbacks_' + c] = function (data) {
          $window.angular.callbacks['_' + c](data);
          delete $window['angularcallbacks_' + c];
        };
        //get signature
        ajax.getSignature(accountNUmber).then(
          function (response) {
            //ensure the credit care number is a string.
            _ccNum = _ccNum.toString();
            var _encriptCardNumber = encryption(_ccNum, response.modulus, response.publicExponent);
            var JSONData = {
              'pan': _encriptCardNumber,
              'sig': response.signature,
              'si': response.systemIndicator,
              'type': _ccType,
              'ts': response.timestamp,
              'service': response.serviceVal
            };
            var _jsonString = JSON.stringify(JSONData);
            /*below is a working encryption token given the credit card number '4444424473621504';
             response={'modulus':'9885751e4505a97dcb7ed8bde723a47aeabca0560563b33dbfdf49c8c0ae029fc893fde57d9af861c171695413849d7fdf356b8323a4bdf05659a398df096ad867159573a21b7b0b8637bd023ade7a37bcdc24550f62844d739dfb0ad7bfc78dcdf2873814a36bfbd607800fd8c409cf00db878b5b5e19a73f33ab191a75ef33','publicExponent':'10001','applicationId':'rogers.com','timestamp':'1425999435942','signature':'X8QfCX5ltQg4TMLIWwvtM6R9Jmo\u003d','serviceVal':'T','systemIndicatorPrepaid':'mg-otcc-prepaid','systemIndicator':'','url':'https://www.qa5.cybs.rogers.com/rogerspop/servlet/POPServlet'};
             _jsonString =  {%22pan%22:%22Ci1Qq3KEuXNqgx4aIBelISBT/VHgPIdxeaYxRHv10rPCh+GvXdnsg7q7Rm4AjBjxT0hLQtoaL+G/Zjc6vyMzFMupyyOlOvtLAZeHNBXWk+GFjzI/ivvaM3/6dDAMv46utI3SJKn59PU35R0SzqTVA+VRaupBLBfz2wnqhgvFzdM=%22,%22sig%22:%22X8QfCX5ltQg4TMLIWwvtM6R9Jmo=%22,%22si%22:%22%22,%22type%22:%22V%22,%22ts%22:%221425999435942%22,%22service%22:%22T%22}
             */

            ajax.getToken(response.url + '?merchantID=' + response.applicationId + '&jsonstring=' + _jsonString + '&callback=JSON_CALLBACK')
              .then(
              function (response) {
                //decrypt token for payment API
                /*                var _request = {
                 accountNUmber: accountNUmber,
                 encryptedToken: response.token,
                 bin: response.iin,
                 result: response.rc,
                 creditCardType: _ccType

                 };*/
                ajax.decryptToken(accountNUmber, response.token, response.iin, response.rc, _ccType)
                  .then(
                  function (response) {
                    deferred.resolve(response.decrypt);
                  },
                  function (error) {

                    // Error handling - 555 exception
                    if (error.data.status === 555) {

                    } else {
                      // anything but status code 555
                    }

                    deferred.reject(error);
                  }
                );
              },
              function (error) {
                // Error handling - 555 exception
                if (error.data.status === 555) {

                } else {
                  // anything but status code 555
                }
                deferred.reject(error);
              }
            );
          },
          function (error) {

            // Error handling - 555 exception
            if (error.data.status === 555) {

            } else {
              // anything but status code 555
            }

            deferred.reject(error);
          }
        );
        return deferred.promise;
      },
      validateInteracPayment: function (accountNumber, accountType, amountDue, amount) {
        var deferred = $q.defer();
        ajax.interacEligibility(accountNumber, accountType, amountDue, amount)
          .then(
          function (response) {
            deferred.resolve(response);
          },
          function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {

            } else {
              // anything but status code 555
            }
            deferred.reject(error);
          }
        );
        return deferred.promise;
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  // TODO not used
  angular.module('totesApp').controller('MyrPayNowSuccessController', PayNowSuccessController);

  PayNowSuccessController.$inject = ['$scope', '$modalInstance', 'appState'];

  /* @ngInject */
  function PayNowSuccessController($scope, $modalInstance, appState) {
    $scope.ok = function () {
      $modalInstance.close('ok');

      appState.switchView('accountOverview');

    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  // TODO rename
  angular.module('totesApp').controller('MyrUnderConstructionController', UnderConstructionController);

  UnderConstructionController.$inject = ['$scope', '$modalInstance'];

  /* @ngInject */
  function UnderConstructionController($scope, $modalInstance) {
    $scope.ok = function () {
      $modalInstance.close('ok');
    };
    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  }
})();

(function() {
  'use strict';

  angular.module('totesApp').controller('PdWhiteListCtrl', PdWhiteListCtrl);

  PdWhiteListCtrl.$inject = ['ajax', '$state','$scope', '$rootScope', 'localStorage', 'userLanguage'];

  function PdWhiteListCtrl(ajax, $state, $scope, $rootScope, localStorage, userLanguage) {

    $scope.lang = userLanguage();

    var vm = this;
    vm.showTermsAndConditions = false;
    vm.acceptAgreement = false;
    vm.waitingWhiteList= false;
    vm.isPdEligible = false;
    vm.updateEligiblityFailed = false;
    vm.confirmationPage = false;
    vm.updatePdEligibility = updatePdEligibility;
    vm.checkWhiteListStatus = checkWhiteListStatus;
    var whiteListValue = localStorage.getLocalStorageValue('whiteListStatus');

    $rootScope.$on('languageChanged', function (){
      $scope.lang = userLanguage();
    });

    if(whiteListValue === "whitelisted"){
      vm.whiteListStatus = true;
      vm.whiteListed = true;
    } else{
      vm.whiteListStatus = false;
      vm.whiteListed = false;
    }


    function checkWhiteListStatus() {
      if(!vm.isPdEligible) {
        if(vm.whiteListed != vm.whiteListStatus){
          vm.showTermsAndConditions = true;
          vm.acceptAgreement = false;
        } else {
          vm.showTermsAndConditions = false;
        }
      } else {
        vm.showTermsAndConditions = false;
      }
    }
    function updatePdEligibility() {
      vm.waitingWhiteList= true;
      var postData = {
         applicationId: "SMB",
         accountNumber: localStorage.getLocalStorageValue('accountNumber'),
         mode: vm.whiteListed? "I" : "D" ,
         tAndCVersionId : "1.0",
         primaryDeviceNumber:localStorage.getLocalStorageValue('phoneNumber'),
         userLoginId: JSON.parse(localStorage.getLocalStorageValue('ute.rogers.signin.user')).userEmail
      };
      ajax.updatePdEligibility(postData).then(function(response) {
        vm.confirmationPage = true;
        if (response.success) {
          vm.showTermsAndConditions = false;
          vm.isPdEligible = true;
          if(vm.whiteListed){
            vm.whiteListStatus = true;
            localStorage.setLocalStorageValue('whiteListStatus', "whitelisted");
          } else {
            vm.whiteListStatus = false;
            localStorage.setLocalStorageValue('whiteListStatus', "unWhiteListed");
          }
        } else{
          vm.updateEligiblityFailed = true;
          vm.showTermsAndConditions = false;
        }
        vm.waitingWhiteList= false;
      }, function(error) {
        // TODO - error handling
        vm.confirmationPage = true;
        vm.updateEligiblityFailed = true;
        vm.showTermsAndConditions = false;
        vm.waitingWhiteList= false;
      });
    }
  }

})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrRegistrationController', RegistrationController);

  RegistrationController.$inject = ['$scope', '$rootScope', 'ajax', 'settings', 'resource', 'userLanguage', 'appState', 'user', '$sce', '$browser', '$http', 'myrSigninService'];

  /* @ngInject */
  function RegistrationController($scope, $rootScope,ajax, settings, resource, userLanguage, appState, user, $sce, $browser, $http, signinService) {
    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    // Scope variables
    $scope.tagPageName = 'Registration';
    $scope.regObj = {
      lang: userLanguage(),
      email: '',
      password: '',
      question: '',
      answer: ''
    };
    $scope.registrationDone = false;
    $scope.confirmEmail = '';
    $scope.confirmPassword = '';
    $scope.languages = settings.supportedLanguages;
    $scope.questions = null; //to be populated as below

    $scope.tooltip = $sce.trustAsHtml(resource.get('registration_tooltip'));
    $scope.errorMessage = null;
    $scope.errorSummary = null;
    // $scope.form = $scope.form;
    $scope.isValid = null;
    $scope.loadingDataIndicator = false;


    /* Added for BoldChat changes */

    $scope.errorMessageBoldChat = "";
    $scope.lang = userLanguage();
    $scope.setStaticChatButtonId = function () {
      if(userLanguage() == 'en'){
        $scope.boldChatButtonId = 'S_BSS_Login';
        $scope.boldChatButtonDiv = 'S_BSS_Registration_Page_div';
        $scope.boldChatButton = 'chatButtonRegistrationEn';
      } else {
        $scope.boldChatButtonId = 'S_BSS_Login_Fr';
        $scope.boldChatButtonDiv = 'S_BSS_Registration_Page_Fr_div';
        $scope.boldChatButton = 'chatButtonRegistrationFr';
      }
    };

    $scope.setStaticChatButtonId();

    $rootScope.$on('languageChanged', function (){
      $scope.setStaticChatButtonId();
      $scope.lang = userLanguage();
    });

    $scope.setErrorMessage = function () {
        if($scope.isError) {
          $scope.errorMessageBoldChat = resource.get('10501');
        }
    };


    $scope.submit = function () {
      if ($scope.form.$valid) {
        $scope.isValid = true;
        $scope.errorSummary = null;
        $scope.isError = false;
        $scope.errorCode = null;
        $scope.errorDescription = null;
        $scope.loadingDataIndicator = true;

        // New registration
        appState.newRegistration = true;

        ajax.register($scope.regObj).then(function () {
          //successfully registered
          $scope.errorSummary = null;
          user.token($scope.regObj.email);

        }, function (error) {
          handleError(error);

        }).then(function () {

          if ($scope.isError) {
            return;
          }

          user.login($scope.regObj.email, $scope.regObj.password).then(
                  function (data) {
                    if (data.valid) {
                      $browser.cookies('userToken', $scope.email);
                      $browser.cookies('signInLang', userLanguage());

                      signinService.postSignin(data, $scope);

                      // notify server - log in
                      /*ajax.notifyServerLoggedIn().then(
                              function (notifydata) {
                                // timing issue solution
                                $scope.reloadHeaderDOM(false);
                              }, function (notifyerror) {
                        // timing issue solution
                        $scope.reloadHeaderDOM(false);
                      });

                      // Make call to rogers site to populate SSO cookies
                      var ssoCookiePull = '/web/RogersServices.portal?_nfpb=true&_pageLabel=beta';
                      var responsePromise = $http.get(ssoCookiePull);

                      responsePromise.success(function (data, status, headers, config) { });
                      responsePromise.error(function (data, status, headers, config) { });*/

                      // Update user rootscope
                      appState.userInitiate();
                      appState.savedPassword = $scope.password;

                      // Look into  non_angular_script/supportFunctions.js  for more information
                      scrollPageToTop();					// jshint ignore:line

                      appState.switchView('accountOverview');
                      //$window.location.href = '/business/ss/smb/redesign/dashboard/overview';
                      $scope.loadingDataIndicator = false;

                    } else {
                      // this shouldn't happen but happens, will investigate
                      $scope.isError = true;
                      $scope.errorCode = data.statusCode;
                      $scope.errorDescription = resource.get('10000_register');
                      $scope.loadingDataIndicator = false;
                    }
                  }
          );
        });
      } else {
        $scope.isValid = false;
        appState.tagFormValidationErrors($scope.tagPageName, $scope.form.$error);
        $scope.loadingDataIndicator = false;
      }

      $scope.setErrorMessage();
    };


    function updateMessage() {
      if (!$scope.errorSummary) {
        $scope.errorMessage = '';
        return;
      }
      $scope.errorMessage = resource.get($scope.errorSummary);
    }

    function handleError(error) {
      //DBG
      $scope.isError = true;
      if (error.data && error.data.data && error.data.data.errorCode !== undefined) {
        $scope.errorDescription = resource.get(error.data.data.errorCode);
        $scope.errorCode = error.data.data.errorCode;
        $scope.loadingDataIndicator = false;
      } else {
        $scope.errorDescription = error.originalError;
        $scope.loadingDataIndicator = false;

        // ????
        if (error.$handled === undefined || error.$handled === false) {
          // console.log('MyrRegistrationController.handleError', error);
          // throw new Error('MyrRegistrationController.handleError - Page Error not handled');
        }
      }
      $scope.setErrorMessage();
    }

    function tagRegistration() {
      appState.tagging(['_trackPageView',
        {pn: 'home:registration:contact-information'}, // Page Name
        {eVar13: 'MyRogers - Profile Registration'},
        {event5: ''},
        {event7: ''}
      ]);
    }

    $scope.$watch($scope.errorSummary, function () {
      if (!$scope.errorSummary) {
        return false;
      }
      $scope.errorMessage = resource.get($scope.errorSummary);
    });

    resource.onChanged(function () {
      $scope.questions = resource.get('login_security_questions');
      $scope.tooltip = resource.get('registration_tooltip');
      $scope.errorDescription = resource.get($scope.errorCode);
      updateMessage();
    }, $scope);

    //init tagging
    tagRegistration();
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrSecurityQuestionAnswerController', SecurityQuestionAnswerController);

  SecurityQuestionAnswerController.$inject = ['$scope', 'ajax', 'resource', 'appState', 'landing', 'localStorage'];

  /* @ngInject */
  function SecurityQuestionAnswerController($scope, ajax, resource, appState, landing, localStorage) {
      
          // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    $scope.$extend({
      tagPageName: 'Security Question',
      questionId: '',
      answer: '',
      questions: null, //to be populated as below
      form: $scope.form,
      isValid: null,
      loadingDataIndicator: false,
      submit: function () {
        if ($scope.form.$valid) {
          $scope.isValid = true;
          $scope.isError = false;
          $scope.errorDescription = null;
          $scope.loadingDataIndicator = true;
          ajax.updateSecurityQuestionSetup($scope.questionId, $scope.answer).then(function () {
            // success
            localStorage.setLocalStorageValue('profileComplete', true);
            // remove success message from previous step (password reset page)
            localStorage.deleteLocalStorageValue('successMessage');
            landing.localPostSignin();
          }, function (error) {
            $scope.isError = true;
            $scope.loadingDataIndicator = false;
            $scope.tagErrorAnsweringUsage();
            if (error.data.status === 555) {
              if (error.error.errorCode) {
                $scope.errorDescription = resource.get(error.error.errorCode);
              }
            }
            if (!($scope.errorDescription)) {
              $scope.errorDescription = resource.get('maintenance_info');
            }
          }).then(function () {
            if ($scope.isError) {
              return;
            }
          });
        } else {
          $scope.isValid = false;
          appState.tagFormValidationErrors($scope.tagPageName, $scope.form.$error);
          $scope.loadingDataIndicator = false;
        }
      }
    });

    // TODO: omniture tagging
//            function tagSecurityQuestion() {
//                appState.tagging(['_trackPageView',
//                    {pn: 'home:registration:contact-information'}, // Page Name
//                    {eVar13: 'MyRogers - Security Question'},
//                    {event5: ''},
//                    {event7: ''}
//                ]);
//            }

    $scope.tagSecurityQuestionUsage= function () {
      /*appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:Auto_Regis_Secretques'}, // Page Name
      ]);*/
    };

    $scope.tagErrorAnsweringUsage= function () {
      appState.tagging(['_trackLink',
        {eVar49:'<ErrorMessages>'},// Error Message example: Please Enter a correct Answer'
        {event15:''}// Generic Error
      ]);
    };

    resource.onChanged(function () {
      $scope.questions = resource.get('login_security_questions');
//                $scope.errorDescription = resource.get($scope.errorCode);
    }, $scope);

    //init tagging
    // TODO: omniture tagging
//            tagSecurityQuestion();
    
  }
})();

/**
 * @ngdoc controller
 * @name reserveDevice
 *
 * @description
 * _Please update the description and dependencies._
 *
 * @requires $scope
 * */

(function () {
  'use strict';
  angular
    .module('totesApp')
    .controller('MyrReserveDeviceCtrl', _controller);

  _controller.$inject = ['$scope', '$rootScope', '$state', 'myrReserveDeviceService', '$timeout'];

  /* @ngInject */
  function _controller($scope, $rootScope, $state, myrReserveDeviceService, $timeout) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line
    var iframeHeightResizeCount = 0;
    var iframeTimeout;
    $scope.state = $state.current.name;

    function resizeIframe() {
      if ($state.current.name !== 'reservedevice') {
        return;
      }
      var height = $('#sf_iframe').contents().height();

      var width = $('.iframe-rd').width();
      if (iframeHeightResizeCount < 16) {
        var timer = 1000;
        if (iframeHeightResizeCount > 1) {
          timer = 2000;
        } else if (iframeHeightResizeCount > 10) {
          timer = 30000;
        }
        $('#sf_iframe').height(height);
        $('#sf_iframe').width(width + 1);
        $('#sf_iframe').width(width - 1);
        iframeTimeout = $timeout(resizeIframe, timer);
      } else {
        $('#sf_iframe').width(width + 1);
        $('#sf_iframe').width(width - 1);
        iframeTimeout = $timeout(resizeIframe, 50);
      }
      $('#sf_iframe').hide();
      $('#sf_iframe').show();
      iframeHeightResizeCount++;
    }


    $scope.$extend({
      loadSalesForeFrame: function (link) {
        if ($rootScope.salesForceFailed) {
          $scope.salesForceFailed = true;
        } else {
          $scope.salesForceFailed = false;

          //var sfErrorMessage = resource.get('sf_error_message');
          $scope.loadingDataIndicator = true;
          /*var current_location = window.location;
           var myHistory = $window.history.state;
           console.log(myHistory);
           $window.history.pushState(myHistory, "View Bill", current_location);*/

          $timeout(postToSalesForce, 1000);
          //iframeHeightResizeCount = 0;
          //iframeTimeout = $timeout(resizeIframe, 1000); //TODO to be check if need
          $rootScope.bbloadingDataIndicator = true;       //TODO need a busy loading indicator
          $timeout(showSalesForceFrame, 1000);

        }
      }
    });

    $scope.$on('loadSalesForceFrame', function (event, args) {
      $scope.loadSalesForeFrame();
    });

    function showSalesForceFrame() {
      $('#sf_iframe').show();
      $rootScope.bbloadingDataIndicator = false;
    }

    function postToSalesForce() {
      $('#formToSalesForce').attr('action', myrReserveDeviceService.loadSalesForceUrl());
      $('#formToSalesForce').submit();
    }
  }

})();

/**
 * @ngdoc directive
 * @name reserveDevice
 *
 * @description
 *  reserve device salesForce iFrame and post Form template directive
 *
 * @restrict A
 * */
(function () {
  'use strict';
  angular
    .module('totesApp')
    .directive('myrReserveDevice', _reserveDevice);

  function _reserveDevice() {
    var directive = {
      restrict: 'EA',
      scope: true,
      templateUrl: 'scripts/modules/reserveDevice/nrsform.html',
      replace: true,
      controller: 'MyrReserveDeviceNRSFormCtrl',
      controllerAs: 'rd',
      bindToController: true
    };
    return directive;
  }
})();

/**
 * @ngdoc service
 * @name reserveDeviceTokenService
 * @description
 * get NRS Encrypt Data for post to SalesForce iFrame
 *
 * */


(function () {
  'use strict';

  angular
    .module('totesApp')
    .factory('myrReserveDeviceNRSDataService', _service);

  _service.$inject = ['ajax', 'resource'];

  /* @ngInject */
  function _service(ajax, resource) {

    var Service = {
      getEncryptNRSData: getEncryptNRSData
    };

    return Service;

    function getEncryptNRSData(request, callback) {
      var _result = {};
      ajax.getEncryptNRSData(request).then(
        function (data) {

          if (data) {
            _result.result = 'success';
            _result.data = data;
            return callback(_result);
          } else {
            _result.result = 'fail';
            _result.data = data;
            return callback(_result);
          }
        }, function (error) {
          // Error handling - 555 exception
          if (error.data.status === 555) {
            _result.result = 'error';
            _result.data = error;
            _result.message = resource.get(error.error.errorCode);
            return callback(_result);

          } else {
            // anything but status code 555
            _result.result = 'error';
            _result.data = error;
            _result.message = resource.get('maintenance_info');//TODO need error message define here
            return callback(_result);
          }
        }
      );
    }
  }

})();

/**
 * @ngdoc controller
 * @name reserveDevice
 *
 * @description
 * _Please update the description and dependencies._
 *
 * @requires $scope
 * */

(function () {
  'use strict';
  angular
    .module('totesApp')
    .controller('MyrReserveDeviceNRSFormCtrl', _controller);

  _controller.$inject = ['$scope', '$rootScope', '$location', 'localStorage', 'userLanguage', 'myrAccountOverviewService', 'myrReserveDeviceNRSDataService', 'settings'];

  /* @ngInject */
  function _controller($scope, $rootScope, $location, localStorage, userLanguage, myrAccountOverviewService, myrReserveDeviceNRSDataService, settings) {

    var vm = this; 	// jshint ignore:line

    vm.salesForceIframeUrl = '';
    vm.encryptedString = '';
    vm.encryptedSignature = '';

    activate();

    function activate() {
      $rootScope.salesForceFailed = false;
      myrAccountOverviewService.getBrtSwitches(function (_temp) {
        if (_temp.result === 'success') {
          if (_temp.data.length > 0) {
            for (var i = 0; i < _temp.data.length; i++) {
              if (_temp.data[i].id === 'NRS') {
                if (_temp.data[i].switchIsOn) {
                  $rootScope.sfnrs = true;
                }
              }
            }
          }
          //$rootScope.sfnrs = true; //debug
          if ($rootScope.sfnrs) {
            var _ctn = localStorage.getLocalStorageValue('phoneNumber') ? localStorage.getLocalStorageValue('phoneNumber') : '';
            var _ban = localStorage.getLocalStorageValue('accountNumber') ? localStorage.getLocalStorageValue('accountNumber') : '';
            var _cancelUrl = $location.absUrl().replace($location.path(),'/accountOverview');

            var _req = {
              applicationId: 'Rogers.com',
              ctn: _ctn,
              ban: _ban,
              language: userLanguage(),
              cancel: _cancelUrl
            };
            myrReserveDeviceNRSDataService.getEncryptNRSData(_req, function (_data) {
              if (_data.result === 'success') {
                if (_data.data.userCustomerBANInfo) {
                  vm.encryptedString = _.unescape(_data.data.userCustomerBANInfo);
                }
                if (_data.data.userCustomerBANInfoSignature) {
                  vm.encryptedSignature = _data.data.userCustomerBANInfoSignature;
                }
                $scope.$emit('loadSalesForceFrame', null);
              } else if (_data.result === 'fail') {
                $rootScope.salesForceFailed = true;
              } else if (_data.result === 'error') {
                $rootScope.salesForceFailed = true;
                //$rootScope.salesForceFailed = false; //debug
                //vm.encryptedString = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><ns2:RogersNRSInfo xmlns:ns2="http://wireless.rogers.com/schemas/ReserveDevice/NRS"><UserInfo><userId>c0014fd1-1658-44f9-85be-cec93e86adff</userId><userEmail>postpaid@715.com</userEmail></UserInfo><BanInfo><BanDetails><CTNs><CTNInfo><ctn>4162623678</ctn><selectedCTN>true</selectedCTN></CTNInfo><CTNInfo><ctn>4162622984</ctn><selectedCTN>false</selectedCTN></CTNInfo></CTNs><Customer><Name><firstName>DONTUSE</firstName><lastName>TOTESDQAQG</lastName><initial></initial><additionalTitle></additionalTitle><title></title><suffix></suffix></Name><BillingAddress><primaryLine>***,</primaryLine><secondaryLine></secondaryLine><additionalLine></additionalLine><aptNumber></aptNumber><aptDesignator></aptDesignator><city></city><province>**</province><country></country><postCode></postCode><attention></attention></BillingAddress><ContactInformation><workTelExtNo></workTelExtNo><workTelNo>4162222222</workTelNo><homeTelNo>4161111111</homeTelNo><emailAddressV21></emailAddressV21><contactPhoneNumber></contactPhoneNumber><faxNumber></faxNumber></ContactInformation></Customer><selectedBAN>true</selectedBAN><ban>728189904</ban></BanDetails><BanDetails><CTNs><CTNInfo><ctn>4162580098</ctn><selectedCTN>false</selectedCTN></CTNInfo></CTNs><Customer><Name><firstName>JOHN</firstName><lastName>CASTOR</lastName><initial></initial><additionalTitle></additionalTitle><title></title><suffix></suffix></Name><BillingAddress><primaryLine>***,</primaryLine><secondaryLine></secondaryLine><additionalLine></additionalLine><aptNumber></aptNumber><aptDesignator></aptDesignator><city></city><province>**</province><country></country><postCode></postCode><attention></attention></BillingAddress><ContactInformation><workTelExtNo></workTelExtNo><workTelNo></workTelNo><homeTelNo>4168169457</homeTelNo><emailAddressV21></emailAddressV21><contactPhoneNumber></contactPhoneNumber><faxNumber></faxNumber></ContactInformation></Customer><selectedBAN>false</selectedBAN><ban>728194695</ban></BanDetails></BanInfo><RogersIntInfo/><locale>en</locale></ns2:RogersNRSInfo>';
                //vm.encryptedSignature = 'C1czPCVVV8PlN3ptegFiKjVfBIvZDg0TZmzA6xhnx80=';
                //$scope.$emit('loadSalesForceFrame', null);
              }
            });
          } else {
            $('#formToRogersReserveDevice').attr('action', settings.formsURL + '/web/RogersServices.portal?_nfpb=true&_pageLabel=ReserveDevice' + '&setLanguage=' + $scope.lng);
            $('#formToRogersReserveDevice').submit();
          }
        } else {
          $rootScope.salesForceFailed = true;
        }
      });
    }
  }

})();

/**
 * @ngdoc service
 * @name myrReserveDeviceService
 * @description
 * get SalesForce iFrame URL
 *
 * */

(function () {
  'use strict';
  angular
    .module('totesApp')
    .factory('myrReserveDeviceService', _service);

  _service.$inject = ['settings'];

  /* @ngInject */
  function _service(settings) {

    var service = {
      loadSalesForceUrl: loadSalesForceUrl
    };
    return service;


    function loadSalesForceUrl() {
      var iFrameUrl = '';
      if (settings.isLocal) {
        iFrameUrl = settings.salesForceUrl.dev;
      } else if (settings.isDevBB) {
        iFrameUrl = settings.salesForceUrl.dev;
      } else if (settings.isQaBB) {
        iFrameUrl = settings.salesForceUrl.qa;
      } else if (settings.isProdBB) {
        iFrameUrl = settings.salesForceUrl.prod;
      } else {
        iFrameUrl = settings.salesForceUrl.prod;
      }
      return iFrameUrl;
    }
  }
})();


(function () {
  'use strict';

  angular.module('totesApp').controller('MyrRewardsController', rewardsController);

  rewardsController.$inject = ['$scope', '$log', '$rootScope', 'ajax', 'appState', 'resource', 'userLanguage', 'settings', 'btnSettings', '$window', 'myrAccountOverviewService','myrAccountListService','myrRewardsService'];

  /* @ngInject */
  function rewardsController($scope, $log, $rootScope, ajax, appState, resource, userLanguage, settings, btnSettings, $window, myrAccountOverviewService,myrAccountListService,myrRewardsService) {
    var vm = this;

    // Public API
    vm.btnSettings = btnSettings;
    vm.btnStatus = btnStatus;
    vm.lang = userLanguage();
    vm.isError = false;
    vm.errorDescription = '';
    vm.objRedeem = {};
    vm.gift = '';
    vm.accountOwner = '';
    vm.accountNo = 0;
    vm.accountNoLast = 0;
    vm.isQA5 = (window.location.hostname.indexOf('qa05') >= 0);
    vm.isDealer = $rootScope.isDealer;
    vm.isCare = $rootScope.isCare;

    vm.statuses = {
      'NOT_ENROLLED': false,
      'ACTIVE': true,
      'SUSPENDED': true,
      'PENDING': false,
      'PENDING_BCB_MIGRATION': false,
      'PENDING_DEACTIVATION': false,
      'DEACTIVATED': false,
      'BLOCKED': true,
      'FRAUD': false,
      'CLOSED': false
    };

    vm.goToRedeemPoints = goToRedeemPoints;
    vm.pullRewards = pullRewards;
    vm.updateGiftMessage = updateGiftMessage;

    vm.als = myrAccountListService;
    vm.ao = myrAccountOverviewService;
    vm.mrs = myrRewardsService;

    ///////////////////////////////////////////////////////////////


    $scope.$watch('re.als.selectedAccount.accountNumber',function(accountNumber){
      if(accountNumber){
        pullRewards();
      }
    });

    $scope.$watch(function(){
      return settings.redeemLink;
    }, function(newValue, oldValue){
      vm.rfrLinks = {
        redeemLink: settings.redeemLink[vm.lang],
        enrollLink: settings.redeemLink.enroll
      };
    });
/*

    $scope.$watch('re.ao.brtSwitches', function (data) {

      if (data && data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].id === 'RFR') {
            if (data[i].switchIsOn) {
              settings.redeemLink = {
                en: '/web/totes/#/rewards/redeem',
                fr: '/web/totes/#/rewards/redeem',
                enroll: '/web/totes/#/rewards/enroll'
              }
            }
          }
        }
      }
    });
*/

    $rootScope.$watch('ao.accountActive', function () {
      if ($rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatus) {
        vm.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
        vm.btnStatus = $window.btnStatus;
      }
    });

    //$rootScope.$watch('ao.accountDetails', function (newVal, oldVal) {
    //	// make sure that the $rootScope.ao.accountDetails is not null (default / initial state)
    //	if ($rootScope.ao.accountDetails !== null && $rootScope.ao.accountActive) {
    //		// Grab the data
    //		$scope.accountNo = $rootScope.ao.accountActive.accountNumber;
    //		// Avoid multiple calls from one acocunt number
    //		//if ($scope.accountNo !== $scope.accountNoLast && $rootScope.ao.accountActive.accountTypeNumber !== 9) {
    //		if (!$rootScope.objRedeem || $rootScope.objRedeem.accountNumber !== newVal.accountNumber && $rootScope.ao.accountActive.accountTypeNumber !== 9) {
    //			$scope.accountNoLast = $scope.accountNo;
    //if (!$rootScope.rewardsRequestSent) {
    // $scope.pullRewards();
    //}
    //
    //		}
    //	}
    //}, true);

    $rootScope.$watch('objRedeem', function (newVal) {
      if (newVal) {
        vm.objRedeem = newVal;
        vm.objRedeem.redeemLink = vm.isQA5 ? settings.redeemLinkQA5[vm.lang] : settings.redeemLink[vm.lang];
        vm.objRedeem.enrollLink = vm.isQA5 ? settings.redeemLinkQA5[vm.lang] : settings.redeemLink.enroll.replace('{lang}', vm.lang);
        vm.updateGiftMessage();
      }
    });

    function goToRedeemPoints() {
      // Notify server to prepare fresh data
      var postData = {};
      postData.accountNumber = $rootScope.ao.accountActive.accountNumber;
      ajax.notifyServerPreredeem(postData);

      appState.switchView('redeem');
    }

    function pullRewards() {
      vm.objRedeem = {
        accountNumber: 0,
        isMember: false, // 'NOT_ENROLLED' ? false : true,
        isFraudClosed: false,
        totalPoints: '0',
        monthPoints: '0',
        gift: '',
        redeemLink: vm.isQA5 ? settings.redeemLinkQA5[vm.lang] : settings.redeemLink[vm.lang],
        enrollLink: vm.isQA5 ? settings.redeemLinkQA5[vm.lang] : settings.redeemLink.enroll.replace('{lang}', vm.lang)
      };
// console.log($scope.objRedeem);

      $rootScope.objRedeem = ($rootScope.objRedeem) ? $rootScope.objRedeem : vm.objRedeem;

      // Make sure you have permission to make the call
      // if ( appState.permissionTo('VIEW_LOYALTY_POINTS')) {
      if ($rootScope.objRedeem.accountNumber !== myrAccountListService.selectedAccount.accountNumber) {
        // Call execution

        ajax.getRewards(myrAccountListService.selectedAccount.accountNumber, vm.lang).then(
          function (data) {
            vm.objRedeem.accountNumber = myrAccountListService.selectedAccount.accountNumber;
            vm.objRedeem.isMember = vm.statuses[data.membershipStatus] !== undefined ? vm.statuses[data.membershipStatus] : false;	 // 'NOT_ENROLLED' ? false : true;
            vm.objRedeem.isFraudClosed = data.membershipStatus === 'FRAUD';
            vm.objRedeem.totalPoints = data.currentBalance;
            vm.objRedeem.totalPointsDisplay = data.currentBalance.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            vm.objRedeem.monthPoints = data.pendingBalance;
            vm.updateGiftMessage();

            $rootScope.objRedeem = vm.objRedeem;
          }, function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing

            } else {


              // Pull message from resource file 401 or 5xx situlation
              vm.errorMessage = resource.get('error_rfr_details');
              vm.errorDescription = resource.get('error_rfr_details');
            }
          }
        );
      } else {
        // Rewards are not allowed to be even called

      }
    }

    function updateGiftMessage() {
      vm.objRedeem.gift = vm.objRedeem.totalPoints >= settings.redeemPoints ? resource.get('rewards_promo_500') : '';
    }

    try {
      resource.onChanged(function () {

        vm.lang = userLanguage();

        if (vm.errorMessage) {
          vm.errorMessage = resource.get('error_rfr_details');
        }

        if (vm.objRedeem.totalPoints) {
          vm.updateGiftMessage();
        }

        vm.objRedeem.redeemLink = vm.isQA5 ? settings.redeemLinkQA5[vm.lang] : settings.redeemLink[vm.lang];
        vm.objRedeem.enrollLink = vm.isQA5 ? settings.redeemLinkQA5[vm.lang] : settings.redeemLink.enroll.replace('{lang}', vm.lang);

      }, $scope);
    } catch (msg) {
      $log.error(msg);
    }

  }
})();

(function () {
  'use strict';

  angular.module('totesApp').directive('myrRewards', rewards);

  rewards.$inject = [];

  /* @ngInject */
  function rewards($log) {
    return {
      templateUrl: 'scripts/modules/rewards/rewards.html',
      restrict: 'EA',
      controller: 'MyrRewardsController',
      controllerAs: 're',
      bindToController: true
    };

  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:rewards
   * @description
   * # rewards
   */
  angular.module('totesApp').factory('myrRewardsService', rewardsService);

  rewardsService.$inject = ['$rootScope', 'ajax','resource'];

  function rewardsService($rootScope,ajax,resource) {

    var service = {
      loadingData:false,
      errorLoading:null,
      getRewards: getRewards
    };

    return service;

    ///////////////////////////////////////////////////////////////
    function getRewards(accountNumber, lang, callback) {

      var _this = this;

      var statuses = {
        'NOT_ENROLLED': false,
        'ACTIVE': true,
        'SUSPENDED': true,
        'PENDING': false,
        'PENDING_BCB_MIGRATION': false,
        'PENDING_DEACTIVATION': false,
        'DEACTIVATED': false,
        'BLOCKED': true,
        'FRAUD': false,
        'CLOSED': false
      };

      this.loadingData = true;
      this.errorLoading = null;

      ajax.getRewards(accountNumber, lang).then(
        function (data) {

          _this.loadingData = false;

          // TODO remove localStorage dependence as data model
          var lastSetAccount = localStorage.getLocalStorageValue('accountNumber');

          if (accountNumber === lastSetAccount) {

            var _return = {};
            var objRedeem = {
              accountNumber: accountNumber,
              isMember: statuses[data.membershipStatus] !== undefined ? statuses[data.membershipStatus] : false, // 'NOT_ENROLLED' ? false : true;
              isFraudClosed: data.membershipStatus === 'FRAUD',
              totalPoints: data.currentBalance,
              //TODO totalPointsDisplay should be removed. Use totalPoints in the view with a number filter
              totalPointsDisplay: data.currentBalance ? data.currentBalance.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : 0,
              monthPoints: data.pendingBalance
            };

            // TODO remove rootscope.objRedeem dependence
            $rootScope.objRedeem = objRedeem;

            _return.data = objRedeem;
            _return.result = 'success';

            if (callback) {
              return callback(_return);
            }
          }
        }, function (error) {

          _this.loadingData = false;
          _this.errorLoading = resource.get('acc_overview_loyalty_error');


          // TODO remove localStorage dependence as data model
          var lastSetAccount = localStorage.getLocalStorageValue('accountNumber');

          if (accountNumber === lastSetAccount) {

            var _return = {};
            _return.result = 'fail';
            _return.data = error;
            if (callback) {
              return callback(_return);
            }
          }
        }
      );
    }
  }

}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.rgcl').controller('MyrRgclController', RgclController);

  RgclController.$inject = ['$rootScope', '$scope', 'myrRgclService', 'userLanguage'];

  /* @ngInject */
  function RgclController($rootScope, $scope, rgclService, userLanguage) {
    var vm = this;

    // Public API
    vm.isVisibleWithinAccountOverview = isVisibleWithinAccountOverview;
    vm.wirelessTitle = "revo_with_wireless";
    vm.lang = userLanguage();

    ///////////////////////////////////////////////////////////////

    function isVisibleWithinAccountOverview(){
      return rgclService.getShowWithinAccountOverview();
    }

    $rootScope.$watch(function () {
      return userLanguage();
    }, function (lang) {
      if ($scope.lang !== userLanguage()) {
        $scope.lang = userLanguage();
      }
    });

    // private

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
  /*
   Global banner widget. When included, it will display a banner with the Rogers icon and
   available types:
   --success
   --warning
   --error
   --info
   Example:
   <notificationBanner type="success" message="resource-key"></notificationBanner>
   */
  angular.module('myr.modules.rgcl').directive('myrRgcl', rgcl);

  rgcl.$inject = ['$log'];

  /* @ngInject */
  function rgcl($log) {
    return {
      restrict: "EA",
      templateUrl: "scripts/modules/rgcl/rgcl.html",
      scope: {
        type: '='
      },
      link: linkFunc,
      replace: true,
      controller: 'MyrRgclController',
      controllerAs: 'rgcl',
      bindToController: true
    };

    function linkFunc(scope, element, attrs, ctrl) {
      //ctrl.registerBanner(attrs.bannerId);
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.rgcl').factory('myrRgclService', rgclService);

  rgclService.$inject = ['$log', '$injector', '$timeout', 'ajax', 'userLanguage'];

  /* @ngInject */
  function rgclService($log, $injector, $timeout, ajax, userLanguage) {
    // TODO fix dependency
    var resource = $injector.get('resource');

    // Public API
    var service = {
      loadingData:false,
      rgclEligible:false,
      callGetSegmentationForRGCL: callGetSegmentationForRGCL,
      getRgclEligibile: getRgclEligibile,
      getShowWithinAccountOverview: getShowWithinAccountOverview,
      getShowWithinRevolution: getShowWithinRevolution,
      setShowWithinRevolution: setShowWithinRevolution,
      getIsAccountCanceledOrSuspended: getIsAccountCanceledOrSuspended,
      setIsAccountCanceledOrSuspended: setIsAccountCanceledOrSuspended
    };

    var data = {
      rgclEligibile: false,
      showWithinRevolution: false,
      isAccountCanceledOrSuspended: false
    };

    return service;

    ///////////////////////////////////////////////////////////////

    /**
     *
     * @param accountNumber
     */

    function callGetSegmentationForRGCL(accountNumber) {

      service.loadingData = true;

      return ajax.getSegmentationForRGCL({accountNumber:accountNumber,language:userLanguage().toUpperCase(),applicationId:'Rogers.com'}).then(function (responseData) {
          service.rgclEligible = data.rgclEligibile = responseData.rgclEligibile;
          service.loadingData = false;
          return data;
        },
        function (error) {
          service.rgclEligible = false;
          data.rgclEligibile = false;
          service.loadingData = false;
          return data;
        }
      );
      //return true;
    }


    function getRgclEligibile() {
      return data.rgclEligibile;
    }

    function getShowWithinAccountOverview() {
      return data.rgclEligibile && !data.showWithinRevolution && !data.isAccountCanceledOrSuspended;
    }

    function getShowWithinRevolution() {
      return data.showWithinRevolution && !data.isAccountCanceledOrSuspended;
    }

    function setShowWithinRevolution(newValue) {
      data.showWithinRevolution = newValue;
    }

    function getIsAccountCanceledOrSuspended() {
      return data.isAccountCanceledOrSuspended;
    }

    function setIsAccountCanceledOrSuspended(newValue) {
      data.isAccountCanceledOrSuspended = newValue;
    }

  }
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:SetNewPasswordController
   * @description
   * # SetNewPasswordController
   * Controller of page /setNewPassword
   */

  angular.module('totesApp').controller('MyrSetNewPasswordController', SetNewPasswordController);

  SetNewPasswordController.$inject = ['$scope','$modal', 'ajax','$rootScope', 'localStorage','resource', 'userLanguage', 'appState', 'errorHandler', 'myrNotificationBannerService','myrSetNewPasswordService'];

  /* @ngInject */
  function SetNewPasswordController($scope,$modal, ajax, $rootScope,localStorage, resource, userLanguage, appState, errorHandler, notificationBannerService,myrSetNewPasswordService) {
    var vm = this;
    var snps = myrSetNewPasswordService;

    vm.confirm = confirm;
    vm.submit = submit;
    vm.username = localStorage.getLocalStorageValue('tempusername');


    function confirm() {
      var form = $scope.form1;
      return form.password.$viewValue == form.confirmPass.$viewValue;
    }

    function submit() {
      var form = $scope.form1;
      if(form.$valid && vm.confirm()){
        vm.loadingDataIndicator = true;
        snps.setNewPassword(form.password.$viewValue).then(
          function (data) {
            if (data) {
              if (data.status == "success") {
                vm.loadingDataIndicator = false;
                vm.snpModal = $modal.open({
                  templateUrl: 'scripts/modules/setNewPassword/setNewPasswordSuccess/setNewPasswordSuccess.html',
                  controller: 'MyrLinkAccountModalController',
                  backdrop: 'static',
                  backdropClass: 'bkg-modal'

                });
                vm.snpModal.result.then(function () {
                    appState.switchView('signin');
                }, function () {
                  // on Cancel behaviour
                });

              }
              else {
                vm.servererror = true;
              }
            } else {
              vm.servererror = true;
            }
            vm.loadingDataIndicator = false;
          }, function (error) {
            vm.servererror = true;
            vm.loadingDataIndicator = false;
          }
        );
      }
    }

    $scope.questionId = 1;
    $scope.questions = null;
    $scope.numAttempts = 0;

    notificationBannerService.cleanBanner('successMessage');

    var errorCode = null;

    /* Added for BoldChat changes*/
    $scope.setStaticChatButtonId = function () {
      if(userLanguage() == 'en'){
        $scope.boldChatButtonId = 'S_BSS_PassRest';
        $scope.boldChatButtonDiv = 'S_BSS_PassRest_div';
        $scope.boldChatButton = 'chatButtonForgotPasswordEn';
      } else {
        $scope.boldChatButtonId = 'S_BSS_PassRest_Fr';
        $scope.boldChatButtonDiv = 'S_BSS_PassRest_Fr_div';
        $scope.boldChatButton = 'chatButtonForgotPasswordFr';
      }
    };

    $scope.setStaticChatButtonId();

    $rootScope.$on('languageChanged', function (){
      $scope.setStaticChatButtonId();
    });





  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrSetNewPasswordService', SetNewPasswordService);

  SetNewPasswordService.$inject = ['$q', '$timeout','ajax'];

  /* @ngInject */
  function SetNewPasswordService($q, $timeout,ajax) {

    // Public API
    var service = {
      setCookie: setCookie,
      getSmtoken: getSmtoken,
      getUsername: getUsername,
      getSmauthreason: getSmauthreason,
      getSmagentname: getSmagentname,
      getTarget: getTarget,
      setNewPassword: setNewPassword
    };

    // private
    var data = {
      smtoken: undefined,
      username: undefined,
      smauthreason: undefined,
      smagentname: undefined,
      target: undefined
    };

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    // TODO where is cookie here?
    /**
     *
     * @param params
     * @returns {*}
     */
    function setCookie(params) {
      var defer = $q.defer();
      // $cookie gets updated every 100 ms
      // use timeout to let data have time to be ready
      $timeout(function () {
        data.smtoken = params.SMTOKEN;
        data.username = params.USERNAME;
        data.smauthreason = params.SMAUTHREASON;
        data.smagentname = params.SMAGENTNAME;
        data.target = params.TARGET;
        defer.resolve(data);
      }, 125);

      return defer.promise;
    }

    function setNewPassword(input){
      if (input){
        var request = {
          "password": input
        };

        return ajax.setNewPassword(request).then(
          function (data) {
            console.log(data);
            return data;
          }, function (error) {

            return error;

          }
        );
      }
      console.log(input);
    }

    function getSmtoken() {
      return data.smtoken;
    }

    function getUsername() {
      return data.username;
    }

    function getSmauthreason() {
      return data.smauthreason;
    }

    function getSmagentname() {
      return data.smagentname;
    }

    function getTarget() {
      return data.target;
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrSigninController
   * @description
   * # MyrSigninController
   * Controller of the totesApp
   */

  angular.module('totesApp').controller('MyrSigninController', SigninController);

  SigninController.$inject = ['$scope', '$rootScope', '$cookieStore', 'appState', 'user', '$browser', 'permissionResolver', 'ajax', 'webanalytics', 'userLanguage', 'localStorage', '$location', 'myrSigninService', '$log', '$window', 'resource', 'ute.common.user.service', 'ute.fraud.logging.service', 'ute.fraud.logging.TransactionProp', '$state', 'ute.blocks.persistent.storage.service', 'ocpService', '$timeout', 'myrAccountListService', '$http', 'ute.rogers.datalayer.integration.common.service', '$q', 'settings', '$injector'];

  /* @ngInject */
  function SigninController($scope, $rootScope, $cookieStore, appState, user, $browser, permissionResolver, ajax, webanalytics, userLanguage, localStorage, $location, signinService, $log, $window, resource, userService, fraudLoggingService, transactionProp, $state, utePersistentStorageService, ocpService, $timeout, myrAccountListService, $http, dataLayerIntegrationService,$q, settings, $injector) {
    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop(); // jshint ignore:line
    var vm = this;
    vm.als = myrAccountListService;
    //$scope.isLocked = Boolean($location.search().lock) || false; //required
    $scope.pasted = false;
    $scope.email = '';
    $scope.password = '';
    $scope.submitted = '';
    $scope.attempts = 0;
    $scope.maxAttempts = 5;
    $scope.lang = userLanguage();
    $scope.myRogersPermission = true; //permissionResolver.data.showWidget,
    $scope.isDisabled = false;
    $scope.isWaiting = false; // Show loader while resolving user credentials
    $scope.isWaitingClass = ''; // Additional style that would be added to login button
    $scope.ocpEnabled = false;
    $rootScope.loginWaiting = false;
    $scope.errorAttempts = 0;
    $scope.lockFlag = false;
    $scope.somethingWentWrong = false;
    console.log("signin-start");
    var widgetId;
    $scope.showLoader = false;

    retrieveSelfserveConfig();

    function retrieveSelfserveConfig() {

      return ajax.getSelfserveConfig().then(
        function (response) {
          $rootScope.errorMsgBB = response.errorMessage;
          $rootScope.upfrontAdvantageSocs = response.upFrontAdvantageSOCs;
          if (response) {
            if (response.invoice) {
              localStorage.setLocalStorageValue('smbInvoiceMode', response.invoice);
              $window.document.cookie = 'smbInvoiceMode=' + response.invoice + ';domain=' + '.rogers.com' + ';path=' + '/';
            }
            if (response.ocpEnabled) {
              $scope.ocpEnabled = response.ocpEnabled;
            }
          }
          //check for business on this
        },
        function (error) {
          //check for business on this
        }
      );

    }

    /* Added for BoldChat changes */

    var usernameFieldAvailable = '';
    var passwordFieldAvailable = '';
    $scope.errorMessageBoldChat = "";

    //    $scope.setStaticChatButtonId = function () {
    //      if (userLanguage() == 'en') {
    //        $scope.boldChatButtonId = 'S_BSS_Login';
    //        $scope.boldChatButtonDiv = 'S_BSS_Login_Page_div';
    //        $scope.boldChatButton = 'chatButtonLoginEn';
    //      } else {
    //        $scope.boldChatButtonId = 'S_BSS_Login_Fr';
    //        $scope.boldChatButtonDiv = 'S_BSS_Login_Page_Fr_div';
    //        $scope.boldChatButton = 'chatButtonLoginFr';
    //      }
    //    };

    $scope.setErrorMessage = function () {
     /* if ($scope.form !== undefined) {
        console.log("error");
        usernameFieldAvailable = (Object.keys($scope.form.USER.$error).length == 0);
        passwordFieldAvailable = (Object.keys($scope.form.password.$error).length == 0);
      }

      if (($scope.isLocked || $scope.attempts >= 3) && !$scope.errorSummary && (usernameFieldAvailable && passwordFieldAvailable)) {
        console.log("error");
        $scope.errorMessageBoldChat = resource.get('sign_maximum_attempts_line_1') + resource.get('sign_maximum_attempts_line_2');
      } else if (($scope.attempts > 0 && $scope.attempts <= 1) && !$scope.errorSummary && (usernameFieldAvailable && passwordFieldAvailable) && !$scope.isLocked) {
        console.log("error");
        $scope.errorMessageBoldChat = resource.get('sign_warning_msg_line_1') + resource.get('sign_warning_msg_line_2');
      } else if (($scope.attempts > 1 && $scope.attempts <= 2) && !$scope.errorSummary && (usernameFieldAvailable && passwordFieldAvailable) && !$scope.isLocked) {
        console.log("error");
        $scope.errorMessageBoldChat = resource.get('sign_third_attempts_msg_line_1') + resource.get('sign_third_attempts_msg_line_2');
      } else if (!usernameFieldAvailable || !passwordFieldAvailable) {
        console.log("error");
        $scope.errorMessageBoldChat = resource.get('_require_username_password');
      } */
    };

    //$scope.setStaticChatButtonId();

    $scope.boldChat = {
      attempts1: {
        en: {
          cbid: 'S_BSS_PassRest',
          dynamicDivId: 'Login_Attempts_Error_1_En_div',
          chatButtonClass: 'chatButtonLoginAttemptsError1En'
        },
        fr: {
          cbid: 'S_BSS_PassRest_Fr',
          dynamicDivId: 'Login_Attempts_Error_1_Fr_div',
          chatButtonClass: 'chatButtonLoginAttemptsError1Fr'
        }
      },

      attempts2: {
        en: {
          cbid: 'S_BSS_PassRest',
          dynamicDivId: 'Login_Attempts_Error_2_En_div',
          chatButtonClass: 'chatButtonLoginAttemptsError2En'
        },

        fr: {
          cbid: 'S_BSS_PassRest_Fr',
          dynamicDivId: 'Login_Attempts_Error_2_Fr_div',
          chatButtonClass: 'chatButtonLoginAttemptsError2Fr'
        }
      },

      attempts3: {
        en: {
          cbid: 'S_BSS_PassRest',
          dynamicDivId: 'Login_Attempts_Error_3_En_div',
          chatButtonClass: 'chatButtonLoginAttemptsError3En'
        },

        fr: {
          cbid: 'S_BSS_PassRest_Fr',
          dynamicDivId: 'Login_Attempts_Error_3_Fr_div',
          chatButtonClass: 'chatButtonLoginAttemptsError3Fr'
        }
      }
    };


    $rootScope.$on('languageChanged', function () {
      //$scope.setStaticChatButtonId();
      $scope.setErrorMessage();
      $scope.lang = userLanguage();
    });

    $scope.getDynamicDiv = function (resourceName) {
      return resource.get(resourceName);
    };

    $scope.$on("accountLockAvailable", function () {
      console.log("SM_AUTHREASON IS : " + $location.search().SM_AUTHREASON);
      $scope.isLocked = signinService.isAccountLocked() || false; //required
    });

    $scope.error = {
      wrongCredential: null,
      thirdAttemps: null,
      maxAttempts: null
    };

    $scope.isEmail = function (email) {
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    };

    // $scope.setWidget = function (id) {
    //   widgetId = id;
    // };

  $scope.submit = function () {
        var janrainOidc = $injector.get('janrainOidc');
        console.log("SigninController -  $browser.cookies().CONSENT_STATE "  +  $browser.cookies().CONSENT_STATE);
        /*if(!$browser.cookies().CONSENT_STATE)
        			janrainOidc.signIn();
        else {
        			console.log("$browser.cookies().CONSENT_STATE present");
        }*/
        janrainOidc.signIn();
    };

    $scope.langChange = function () {
      return userLanguage();
    }


    $scope.register = function () {
      signinService.mbhUrlConfig().then(function(urlResponse){
         $window.location.href = urlResponse.register+"?portal=bsss";
      });
    };

    $scope.hasError = function () {};

    function tagSignIn() {
      appState.tagging(['_trackPageView',
        {
          pn: 'home:signin'
        }
      ]);
    }

    $scope.signOut = function () {
      var session = $browser.cookies()['bss-info'];
      var tmpSession = $browser.cookies().CONSENT_STATE;
      if ($browser.cookies().SM_USER || session || tmpSession) {
        user.logout();
      }
    };
    function openSohoIntercept() {
      var deferred = $q.defer();
      var showSohoIntercept = false;
      vm.als.sohoMigrationBrtCheck().then(function(){
    	  if(vm.als.sohoPostMigrationSwitch ) {
    		  showSohoIntercept = true;
    		  deferred.resolve(showSohoIntercept);
    	 } else {
    		deferred.resolve(showSohoIntercept);
    	 }
    	},
    	function(error){
    	  deferred.resolve(showSohoIntercept);
    	});
      return deferred.promise;
    };

    function insertScript(){
      if (!($browser.cookies()['bss-info'])) {
        if (!($browser.cookies().CONSENT_STATE)) {
          var studioTag =document.createElement("script");
          studioTag.type="text/javascript";
          studioTag.innerHTML="(function(o,n,e){var l='link',s='script',c='createElement',i='insertBefore',f=o.getElementsByTagName(s)[0],p=f.parentNode,x=o[c](l),y=o[c](l),z=o[c](s);x.rel='preconnect';x.href=n;y.rel='preload';y.href=e;y.as=s;z.id='thxTag';z.src=e;p[i](x,f);p[i](y,f);p[i](z,f);})(document,'https://na5.thunderhead.com','https://na5.cdn.thunderhead.com/one/rt/js/one-tag.js?siteKey=ONE-GXOQ2DLBIT-1681');";
          $("head").append(studioTag);
        }
      }
      if(settings.isDevQa){
        var isTag = document.createElement("script");
        isTag.type="text/javascript";
        isTag.src = '//cdn.evgnet.com/beacon/rogerscanada/development/scripts/evergage.min.js';
        isTag.async = true;
        $("head").append(isTag);
      } else{
        var isTag = document.createElement("script");
        isTag.type="text/javascript";
        isTag.src = '//cdn.evgnet.com/beacon/rogerscanada/engage/scripts/evergage.min.js';
        isTag.async = true;
        $("head").append(isTag);
      }
    }
    //RCRT-5997 start
    $scope.showpopup = function () {
      var popup = document.getElementById("myPopup");
      popup.classList.toggle("show");
    }
    //RCRT-5997 End

    function init() {
      if (!!$browser.cookies().CONSENT_STATE) {
    		$scope.showLoader = true;
    	} else {
    		$scope.showLoader = false;
    	}
      insertScript();
      var params = $location.search();
    }

    init();
    try {
      tagSignIn();
    } catch (e) {
      $log.error('Exception during signOut, message is', e.message);
    }
  }
})();

(function () {
  'use strict';

  // TODO this is very dirty temporary service

  angular.module('totesApp').factory('myrSigninService', signinService);

  signinService.$inject = ['$log', 'ajax', 'settings', '$http', 'appState', 'user', '$browser', 'resource', 'deeplink', 'landing', '$rootScope', '$q', 'localStorage', '$location', '$window', 'sessionStorage', 'ute.datalayer.common.service', '$sce', 'userLanguage'];

  /* @ngInject */
  function signinService($log, ajax, settings, $http, appState, user, $browser, resource, deeplink, landing, $rootScope, $q, localStorage, $location, $window, sessionStorage, dataLayerService, $sce, userLanguage) {
    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var sohoInterceptResponse;
    var service = {
      postSignin: postSignin,
      isAccountLocked: isAccountLocked,
      brtCheck: brtCheck,
      mbhUrlConfig: mbhUrlConfig,
      getListForTargeting: getListForTargeting,
      setSohoInterceptResponse: setSohoInterceptResponse,
      getSohoInterceptResponse: getSohoInterceptResponse,
      getAutoRegistrationStatus : getAutoRegistrationStatus,
      disableResendBtn : false
    };

    return service;

    ///////////////////////////////////////////////////////////////

    function isAccountLocked() {
      return $browser.cookies().SMLOCK > 0;
    }

    function replaceLanguageParam(url) {
      var lang = userLanguage();
      if(lang == "en") {
        lang = "en_US";
      }
      var returnVal = url.replace("language=en", "language=" + lang);
      return returnVal.replace("language=fr", "language=" + lang);
    }

    function mbhUrlConfig() {
        var url = {};
        var deferred = $q.defer();
        ajax.getBSSUrls().then(
            function(data) {
                var envName = settings.prodEnvName;
                if (settings.isDevMBH) {
                    envName = settings.devEnvName;
                } else if (settings.isQaMBH) {
                    envName = settings.qaEnvName;
                }
                url.welcome = data[envName].welcome;
                url.dashboard = data[envName].dashboard;
                url.dashboardNew = data[envName].dashboardNew,
                url.dataManager = data[envName].dataManager,
                url.dataManagerNew = data[envName].dataManagerNew,
                url.ESFUrl = data[envName].ESFUrl;
                url.ColonyPortalUrl = data[envName].ColonyPortalUrl;
                url.register = data[envName].register;
                $rootScope.dmUrl = $sce.trustAsResourceUrl(url.dataManager);
                url.transferOfResponsibility = replaceLanguageParam(data[envName].transferOfResponsibility);
                url.billInquiry = replaceLanguageParam(data[envName].billInquiry);
                url.portalInquiry = replaceLanguageParam(data[envName].portalInquiry);
                url.sbpInquiry = replaceLanguageParam(data[envName].sbpInquiry);
                url.orderInquiry = replaceLanguageParam(data[envName].orderInquiry);
                url.contactManagement = replaceLanguageParam(data[envName].contactManagement);
                url.portIn = replaceLanguageParam(data[envName].portIn);
                url.saveOrderSearch = replaceLanguageParam(data[envName].saveOrderSearch);
                deferred.resolve(url);
            },
            function(error){
                var envName = 'prod';
                if (settings.isDevMBH) {
                    envName = 'dev';
                } else if (settings.isQaMBH) {
                    envName = 'qa';
                }
                url.welcome = settings.myBusinessHUBUrl[envName].welcome;
                url.dashboard = settings.myBusinessHUBUrl[envName].dashboard;
                url.dataManager = settings.myBusinessHUBUrl[envName].dataManager;
                url.ESFUrl = settings.ESFUrl[envName];
                url.ColonyPortalUrl = settings.ColonyPortalUrl[envName];
                url.register = settings.myBusinessHUBUrl[envName].register;
                $rootScope.dmUrl = $sce.trustAsResourceUrl(url.dataManager);
                url.transferOfResponsibility = replaceLanguageParam(settings.myBusinessHUBUrl[envName].transferOfResponsibility);
                url.billInquiry = replaceLanguageParam(settings.myBusinessHUBUrl[envName].billInquiry);
                url.portalInquiry = replaceLanguageParam(settings.myBusinessHUBUrl[envName].portalInquiry);
                url.sbpInquiry = replaceLanguageParam(settings.myBusinessHUBUrl[envName].sbpInquiry);
                url.orderInquiry = replaceLanguageParam(settings.myBusinessHUBUrl[envName].orderInquiry);
                url.contactManagement = replaceLanguageParam(settings.myBusinessHUBUrl[envName].contactManagement);
                url.portIn = replaceLanguageParam(settings.myBusinessHUBUrl[envName].portIn);
                url.saveOrderSearch = replaceLanguageParam(settings.saveOrderSearch[envName]);
                deferred.resolve(url);
            }
        );
        return deferred.promise;
    }

    function brtCheck() {
        var mbhSwitch = false;
        var mbhSwitchPresent = false;
        var mbhPermission = false;
        var userMigrateSwitch = false;
        var userMigrateSwitchPresent = false;
        var userMigratePermission = false;
        $rootScope.brtusermigrate = false;
        $rootScope.ocpEnabled = false;
        $rootScope.bbpermission = false;
        localStorage.setLocalStorageValue('BSS_OCP_UTE', $rootScope.ocpEnabled);
        localStorage.setLocalStorageValue('MBH_Redesign', false);
        var deferred = $q.defer();
        ajax.getBrtSwitches().then(
            function(data) {
                $rootScope.isServerLoggedIn = true;
                angular.forEach(data, function(obj, key) {
                    if (obj.id == 'BSS_LEGACY_USERNAME_MIGRATION') {
                        userMigrateSwitchPresent = true;
                        if (obj.switchIsOn == true) {
                            userMigrateSwitch = true;
                        }
                    }
                });
                angular.forEach(data, function(obj, key) {
                    if (obj.id == 'BSS_OCP_UTE') {
                        mbhSwitchPresent = true;
                        if (obj.switchIsOn == true) {
                            mbhSwitch = true;
                        }
                    }
                });
                angular.forEach(data, function(obj, key) {
                  if (obj.id == 'MBH_Redesign') {
                    if (obj.switchIsOn == true) {
                      localStorage.setLocalStorageValue('MBH_Redesign', true);
                    }
                  }
              });


                ajax.getPermissions().then(
                    function(result) {
                        if (result.permissions && result.permissions.length && _.find(result.permissions, function(obj) {
                                return obj.permission === 'BSS_LEGACY_USERNAME_MIGRATION';
                            })) {
                            userMigratePermission = true;
                        }
                        if (result.permissions && result.permissions.length && _.find(result.permissions, function(obj) {
                                return obj.permission === 'BSS_OCP_UTE';
                            })) {
                            mbhPermission = true;
                        }
                        if ((mbhSwitchPresent && mbhSwitch == false) || (mbhSwitch && mbhPermission)) {
                            $rootScope.ocpEnabled = true;
                            localStorage.setLocalStorageValue('BSS_OCP_UTE', $rootScope.ocpEnabled);
                        }
                        if ((userMigrateSwitchPresent && userMigrateSwitch == false) || (userMigrateSwitch && userMigratePermission)) {
                            $rootScope.brtusermigrate = true;

                        }
                        deferred.resolve();
                    },
                    function(error) {
                        $rootScope.brtusermigrate = false;
                        $rootScope.ocpEnabled = false;
                        if (mbhSwitchPresent && mbhSwitch == false){
                              $rootScope.ocpEnabled = true;
                        }
                        if (userMigrateSwitchPresent && userMigrateSwitch == false){
                              $rootScope.brtusermigrate = true;
                        }
                        localStorage.setLocalStorageValue('BSS_OCP_UTE', $rootScope.ocpEnabled);
                        deferred.resolve();
                    }
                );

            },
            function(error) {
                $rootScope.brtusermigrate = false;
                $rootScope.ocpEnabled = false;
                deferred.resolve();
            }
        );
        return deferred.promise;
    }

    function postSignin(data, $scope) {
      if (data.statusCode === 200) {
        // pass

        if (data.valid) {
          service.brtCheck().then(function(result) {
          // notify server - log in
          ajax.notifyServerLoggedIn().then(
            function (data) {
            dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "signInSuccess"});
            var wcocDeepStr = sessionStorage.getSessionStorageValue('wcocDeepSTR');
            var wcocJwtToken = sessionStorage.getSessionStorageValue('wcocJwtToken');
              if (null != wcocDeepStr && wcocDeepStr != undefined && wcocDeepStr.indexOf('wcoc') >= 0
                                 && null != wcocJwtToken && wcocJwtToken != undefined && wcocJwtToken != '') {
                ajax.decryptWcocJwtToken(wcocJwtToken).then(
                  function(data) {
                    localStorage.setLocalStorageValue('wcocToken', data);
                    deeplink.redirectCheck();
                  },
                  function(error) {
                    deeplink.redirectCheck();
                  }
                );
              } else {
                // timing issue solution
                console.log("success");
                $scope.reloadHeaderDOM(false);
                $rootScope.loginWaiting = false;
                landing.landingRedirect();
                }
              },
              function (error) {
                // timing issue solution
                dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "signInError"});
                console.log("error");
                $scope.reloadHeaderDOM(false);
                $rootScope.loginWaiting = false;
                landing.localPostSignin();
              });

            if (settings.isLocal) {
              // do not pull SSO cookies
            } else {
              // Make call to rogers site to populate SSO cookies
            /*  var ssoCookiePull = '/web/RogersServices.portal?_nfpb=true&_pageLabel=beta';
              var responsePromise = $http.get(ssoCookiePull);
              responsePromise.success(function (data, status, headers, config) {
                deeplink.redirectCheck();
              });
              responsePromise.error(function (data, status, headers, config) {
              });*/
            }

            // Update user rootscope
            appState.userInitiate();
            appState.savedPassword = $scope.password;

            //landing.localPostSignin();
          });
        } else {
          $rootScope.loginWaiting = false;
          var smtryno = "";
          if($browser.cookies().R1IDSMTRYNO){
           smtryno = $browser.cookies().R1IDSMTRYNO
          }else{
           smtryno = $browser.cookies().SMTRYNO
          }
          $scope.attempts = smtryno;
          if (!$scope.isLocked && $scope.attempts >= 3) {
              if($browser.cookies().R1IDSMTRYNO){
                document.cookie = 'R1IDSMTRYNO' + '=; domain=.rogers.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
              }
              else{
                document.cookie = 'SMTRYNO' + '=; domain=.rogers.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
              }
          }
          else {
            $scope.attempts = smtryno;
          }

          var  payload = {
            page: {
              name: 'signin',
              hierarchy: ['selfserve', 'signin']
            },
            errors: {
              type: 'http',
              category: 'login',
              message: (($scope.isLocked || $scope.attempts >= 3) ? (resource.get("sign_maximum_attempts_line_1") + resource.get("sign_maximum_attempts_line_2")+ resource.get("sign_maximum_attempts_line_3")) : (($scope.attempts > 0 && $scope.attempts <= 1) ? (resource.get("sign_warning_msg_line_1") + resource.get("sign_warning_msg_line_2")): (($scope.attempts > 1 && $scope.attempts <= 2) ? (resource.get("sign_third_attempts_msg_line_1") + resource.get("sign_third_attempts_msg_line_2")+ resource.get("sign_third_attempts_msg_line_3")) : ""))),
              code: data.statusCode
            },
            events: {
              error: true
            }
          }; 
          dataLayerService.track(payload, false, [4, 1, 0], {mappingKey: "signInError"} );

          //not signed in, error occurs
          user.clearCookies();
          ajax.notifyServerDiscardLoginSMCookies();
          user.token(null);

          //$('#signinForm').attr('method', 'post');
          //$('#signinForm').attr('action', settings.siteminderUrl);
          //$('#target').attr('value', settings.postSigninUrl);
          //$('#signinForm').submit();
          //location.reload(true);
        }
      } else {

        // this block of code is related to the localhost authentication
        $scope.isWaitingClass = '';
        $rootScope.loginWaiting = false;
        if (data.statusCode === 401) {
          // status: 401
          // statusText: "Unauthorized"
          setErrorMessage($scope);
          tagError($scope.errorSummary);

        } else {
          // Server error or bad fail
          $scope.errorSummary = resource.get('10000_sign_in');
          tagError($scope.errorSummary);
        }
      }
    }

     function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1);
          if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
        }
        return "";
     }

    function setErrorMessage($scope) {
      if ($scope.attempts > 0) {
        $scope.errorSummary = resource.get('_attempt') + ' ' + $scope.attempts + ' ' + resource.get('_of') + ' ' + $scope.maxAttempts;
      } else {
        $scope.errorSummary = resource.get('10000_sign_in');	// TEST PURPOSE
      }
    }

    function tagError(errorMessage) {
      if (errorMessage) {
        appState.tagging([
          '_trackLink',
          {eVar49: errorMessage}, // Error Message
          {event15: ''}, // Generic Error
          {event36: ''}// Residential Sign-in error
        ]);
      }
    }

    function getListForTargeting(targetstr){
      console.log('service called');
      var response = {};
      var deferred = $q.defer();
      var postData = {"banList" : targetstr};

      ajax.getAccountListForTargeting(postData).then(
          function(data) {
              response = data;
              deferred.resolve(response);
          }
      );

      //return
      return deferred.promise;
    }
    function setSohoInterceptResponse(data){
     sohoInterceptResponse = data;
    }
    function getSohoInterceptResponse(data){
     return sohoInterceptResponse;
    }
    function getAutoRegistrationStatus() {
      var deferred = $q.defer();
      var email = localStorage.getLocalStorageValue('email');
      var req = {
        username : email
      };
      var urlPrefix = '/web/smb/api/';
      $http.post(urlPrefix + 'business/v1/getAutoRegistrationStatus', req).then( function(response) {
        if(response.data.autoRegFlag && response.data.autoRegFlag === true) {
          service.disableResendBtn = true;
          deferred.resolve();
        } else {
          deferred.resolve();
        }
      },function(error) {
        deferred.resolve();
      });
      return deferred.promise;
    }
  }
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrShmDashboardController
   * @description
   * # MyrShmDashboardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrShmDashboardController', ShmDashboardController);

  ShmDashboardController.$inject = ['$scope', 'appState', 'resource', 'userLanguage','userProvince', 'ajax', 'localStorage'];

  /* @ngInject */
  function ShmDashboardController($scope, appState, resource, userLanguage,userProvince, ajax, localStorage) {

    $scope.selectedAccount = {};
    $scope.selectedAccount.accountName = {};
    $scope.selectedAccount.accountNumber = localStorage.getLocalStorageValue('shmAccountNumber');
    $scope.shmLink = '';

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    var status = '';
    var accType = '';
    if ($scope.selectedAccount.accountInfo) {
      status = $scope.selectedAccount.accountInfo.status;
      accType = $scope.selectedAccount.accountInfo.accType;
    }
    /*appState.tagging(['_trackPageView',
      {pn: 'home:myrogers:rshm'},
      {sACTT: status}, // Consumer, Business
      {sBAN: $scope.selectedAccount.accountNumber}, //Account Number BAN, ex : '12345'
      {sCTN: $scope.selectedAccount.accountNumber}, //Account Telephone Number CTN, ex: '4161234567|4161234568'
      {sACSS: accType}
    ]);*/

    $scope.setLinks = function () {
      switch (userLanguage()) {
        case 'en':
          $scope.quickStartGuideLink = '/pdf/en/Quick-Start-Guide.pdf';
          $scope.serviceAgreementLink = '/en/SHM-Service-Agreement.pdf';
          $scope.municipalPermitsInformationLink = 'setLanguage=en';
          break;
        case 'fr':
          $scope.quickStartGuideLink = '/support/pdfs/SHM/FRE_Quick_Start_Guide%20Oct%202014_FR.pdf';
          $scope.serviceAgreementLink = '/fr/SHM-Service-Agreement-f.pdf';
          $scope.municipalPermitsInformationLink = 'setLanguage=fr';
          break;
      }
    };

    $scope.$extend({
      isCollapsed: true,
      lng: userLanguage(),
      lang: userLanguage() + '-CA',
      langUpper: userLanguage().toUpperCase(),
      loadingUsage: true,
      errorCode: '',
      errorMessage: '',
      url: window.location.host,
      learnMoreUrl: '../../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/shop/security/bundles/',
      loadData: function () {
        ajax.getSHMlink($scope.selectedAccount.accountNumber, $scope.url).then(
          function (response) {
            if (response === undefined || response === null) {
              $scope.errorCode = 50000;
              $scope.errorMessage = resource.get($scope.errorCode);
            } else {
              $scope.shmLink = response.accessWebURl;
            }
          },
          function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              $scope.errorCode = error.error.errorCode;
              $scope.errorMessage = error.error.message;
            } else {
              $scope.errorMessage = resource.get('50000');
            }
          });
      }
    });

    resource.onChanged(function () {
      $scope.setLinks();
    }, $scope);

    $scope.loadData();
    $scope.setLinks();
  }
})();

( function () {
  'use strict';

   angular.module('totesApp').controller('sohoMigrationCtrl', sohoMigrationCtrl);

   sohoMigrationCtrl.$inject = ['$scope', '$rootScope','$q', '$modal', 'myrAccountListService', 'myrSigninService', 'resource', 'ajax', '$http','$window','localStorage'];
   function sohoMigrationCtrl($scope, $rootScope, $q, $modal, myrAccountListService, myrSigninService, resource, ajax, $http, $window, localStorage){

      var vm = this;
      vm.als = myrAccountListService;
      //$scope.autoRegEmailNotSent = false;
      var urlPrefix = '/web/smb/api/';
      $scope.userMigratedEmailResponse ;
      $scope.autoRegfail = false;
      $scope.apiCount = null;
      $scope.disableResendBtn = myrSigninService.disableResendBtn;

      function init(){
        $scope.userMigratedEmailResponse = myrSigninService.getSohoInterceptResponse();
        // var localResponse=localStorage.getLocalStorageValue('migratedUser');
        // if($scope.userMigratedEmailResponse){
        //   localStorage.setLocalStorageValue('migratedUser',$scope.userMigratedEmailResponse);
        // }else{
        //   $scope.userMigratedEmailResponse=localResponse;
        // }
        //For MBH navigation
        if ($scope.userMigratedEmailResponse === undefined){

          var email = $window.location.href.split('=')[1];
          if(email !== undefined){
            localStorage.setLocalStorageValue('email',email);
            var href = $window.location.href;
            var url = href.substring(0, href.indexOf('?'));
            $window.history.replaceState({}, '', url);
          }
          else{
            email=localStorage.getLocalStorageValue('email');
          }
          var req={
            "username":email
          }
          $http.post(urlPrefix + 'business/v1/cssUserMigratedList', req).then(
            function(response){
              $scope.userMigratedEmailResponse =response.data;
              //localStorage.setLocalStorageValue('migratedUser',response);
            },
            function(error){
              console.log("business/v1/cssUserMigratedList error");
              $scope.userMigratedEmailResponse ='';
            }
          );

          $http.post(urlPrefix + 'business/v1/getAutoRegistrationStatus', req).then( function(response) {
            if(response.data.autoRegFlag && response.data.autoRegFlag === true) {
              $scope.disableResendBtn = true;
            }
          });
        }
      };

     $scope.autoRegEmail = function(account){
        $scope.selectedEmailForAutoReg = account.migratedEmail;
        var request = {
          APIKey : '',
          accountNumber : account.acctNbr,
          email : account.migratedEmail,
          language : account.language,
          realm : 'ROGERS',
          consolidatedAccNumber : '',
          billType : '1'
        };
        var today = new Date();
        var emailDate = new Date(account.autoreg_email_date);
        var timeDiff = today.getTime() - emailDate.getTime();
        var daysDiff = Math.round(timeDiff / (1000 * 3600 * 24));
//        if (daysDiff > 3) {
          $http.post(urlPrefix + 'business/v1/consumer/autoRegister', request).then(
           function (response) {
             if (response.data.status === 'SUCCESS') {
               $scope.autoRegSuccess = true;
               $scope.apiCount = response.data.apiCount;
               openConfirmationPopup();
             }
           },
           function (error) {
             if(error.data.errorCode == 403) {
              $scope.autoRegfail = true;
             } else {
              $scope.autoRegSuccess = false;
                openConfirmationPopup();
             }
           });
//        }
//        else {
//         $scope.autoRegEmailNotSent = true;
//         openConfirmationPopup();
//        }
     }
     function openConfirmationPopup(){
        var deferred = $q.defer();
        var wclass = $scope.autoRegSuccess === true ? 'soho-migration': ''
        $scope.sohoEmailConfirmationPopup = $modal.open({
         templateUrl:'views/modals/sohoEmailConfirmationPopup.html',
         scope: $scope,
         keyboard: false,
         backdrop: 'static',
         windowClass : wclass
       });
       $scope.sohoEmailConfirmationPopup.result.then(function () {
          deferred.resolve();
        }, function () {
          deferred.resolve();
       });

     };
     $scope.closeConfirmationPopup = function() {
       $scope.sohoEmailConfirmationPopup.close();
     }
     init();
   }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:TvdashboardCtrl
   * @description
   * # TvdashboardCtrl
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrTvDashboardController', TvDashboardController);

  TvDashboardController.$inject = ['$scope', '$browser', 'appState', 'resource', 'userLanguage', 'settings', 'ajax', '$timeout', 'localStorage', 'myrTvDashboardService', '$rootScope'];

  /* @ngInject */
  function TvDashboardController($scope, $browser, appState, resource, userLanguage, settings, ajax, $timeout, localStorage, tvDashService, $rootScope) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    $scope.selectedAccount = {};
    $scope.selectedAccount.accountName = {};
    $scope.selectedAccount.accountNumber = localStorage.getLocalStorageValue('tvAccountNumber');
    $scope.selectedAccount.ban = localStorage.getLocalStorageValue('accountNumber');


    //Start - Bold chat changes to display floating chat in Wireless Dashboard
    $scope.invokeFloatingChat = function () {
      var buttonId;
      setTimeout(function() {  //timeout for not loading tv dashboard incident
      if(userLanguage() === 'en'){
        buttonId = getBDId('F_BSS_TVDbrd');
        floatingLiveChatButtonUTE(buttonId);
      }
      }, 5000);
    };

    $scope.$on('$stateChangeStart', function() {
      removeChatButtons('bcFloat');
    });


    $rootScope.$on('languageChanged', function (){
      angular.element('.bcFloat').remove();
      $scope.invokeFloatingChat();
    });

    $scope.invokeFloatingChat();
    //End - Bold chat changes to display floating chat in Wireless Dashboard


    //displaying message for retailer/dealer.
    var messageBoxDom = function () {

      $scope.lng = userLanguage();
      var loginDom;
      // to chnage the login link text based on the laguage
      if ($scope.lng === 'en') {
        loginDom = '<div class="login-text"><div>' + resource.get("login") + "</div>"
          + "<div><strong> " + resource.get("to") + " " + resource.get("sgi") + '</strong></div>'
          + '</div>';
      }
      else {
        loginDom = '<div class="login-text"><div>' + resource.get("login_to") + "</div>"
          + "<div><strong> " + resource.get("sgi") + '</strong></div>'
          + '</div>';
      }

      $scope.changeTVPackageMessage = '<div class="info-box-header">'
        + "<span class='header-tab'><strong>" + resource.get("to_manage")
        + ":</strong></span>"
        + "</div>"
        + '<div class="info-box-body">'
        + '<div class="info-box-col">'
        + '<div><strong>' + resource.get("package") + '</strong></div>'
        + '<div><strong>' + resource.get("theme_packs") + '</strong></div>'
        + '<div><strong>' + resource.get("channels") + '</strong></div>'
        + "</div>"
        + '<div class="info-box-col"><img src="images/message-arrow.png"/></div>'
          //+'<div class="login-text float-left"><div>'+resource.get("login")+"</div>"
          //+"<div>"+resource.get("login_to")+" <strong>"+resource.get("sgi")+'</strong></div>'
        + loginDom
        + '</div>';

      $scope.tvServicesMessage = '<div class="info-box-header">'
        + "<span class='header-tab'><strong>" + resource.get("to_manage")
        + ":</strong></span><span><strong>" + resource.get("to_reset") + ":</strong></span>"
        + "</div>"
        + '<div class="info-box-body">'
        + '<div class="info-box-col info-box-border">'
        + '<div><strong>' + resource.get("digital_box") + '</strong></div>'
        + '<div><strong>' + resource.get("outlets") + '</strong></div>'
        + "</div>"
        + '<div class="info-box-col">'
        + '<div><strong>' + resource.get("digital_box") + '</strong></div>'
        + '<div><strong>' + resource.get("digital_pin") + '</strong></div>'
        + "</div>"
        + '<div class="info-box-col"><img src="images/message-arrow.png"/></div>'
          //+'<div class="info-box-col login-text"><div>'+resource.get("login")+"</div>"
          // +"<div>"+resource.get("login_to")+" <strong>"+resource.get("sgi")+'</strong></div>'
        + loginDom
        + '</div>';
    }
    messageBoxDom();
    resource.onChanged(function () {
      messageBoxDom();
    }, $scope);

    $scope.$extend({
      province: $browser.cookies().province || 'ON',
      postToRogersUrls: [],
      isCollapsed: true,
      lang: userLanguage() + '-CA',
      langUpper: userLanguage().toUpperCase(),
      lng: userLanguage(),
      limitLow: settings.usageLimit,
      loadingDataIndicatorTvFeed: true,
      loadingDataIndicatorTvDashboard: true,
      finalDataReceived: false,
      tvResponse: {},
      tvObj: {
        globalColor: '',
        unlimitedClass: 'normal',
        myPlan: {},
        myExtras: [],
        myModem: {
          name: '',
          image: '',
          imageSm: ''
        },
        hardwareList: [],
        extraChannelList: [],
        selectedHardwareId: null,
        selectedHardwareName: '',
        rtoIndicator: false // RTO change
      },
      errorCode: '',
      errorMessage: '',
      hasExtras: false,
      hasThemes: false,
      themesOpen: false,
      extraOpen: false,
      globalNotice: '',
      securityKey: '',
      securityToken: '',
      hasTvBox: true,
      showHardwareDD: true,
      rentThis: function () {
      },
      record: function () {
      },
      changeRemove: function (val) {
      },
      addChannels: function () {
      },
      changeExtraChannels: function () {
      },
      getDeviceImage: function (imgFile) {
        if (!imgFile || imgFile === '') {
          $scope.tvObj.myModem.image = 'images/tv_icon_2.png';
        } else {
          $scope.tvObj.myModem.image = settings.formsURL + imgFile;
        }
      },
      selectedFlow: '',
      postToRogers: function (actionId) {
        $('#formToRogers').attr('action', settings.formsURL + $scope.postToRogersUrls[actionId].url);

        $scope.selectedFlow = $scope.postToRogersUrls[actionId].flowId;
        $timeout(function () {
          $('#formToRogers').submit();
        });
      },
      processDevice: function () {
        for (var x1 = 0; x1 < $scope.tvResponse.cableTvDetails.hardwareMap.length; x1++) {
          var productId = $scope.tvResponse.cableTvDetails.hardwareMap[x1].productId;
          var objChild = $scope.tvResponse.cableTvDetails.deviceDetails[productId];

          if (objChild) {
            $scope.tvObj.myModem.image = objChild.digitalBoxImage;
            $scope.tvObj.selectedHardwareId = $scope.tvResponse.cableTvDetails.hardwareMap[x1].productName;
            $scope.tvObj.rtoIndicator = $scope.tvResponse.cableTvDetails.hardwareMap[x1].rtoIndicator; // RTO change
            break; // show first
          } else if ($scope.tvResponse.cableTvDetails.hardwareMap && $scope.tvResponse.cableTvDetails.hardwareMap.length > 0) {
            $scope.tvObj.selectedHardwareId = $scope.tvResponse.cableTvDetails.hardwareMap[0].productName;
            $scope.tvObj.rtoIndicator = $scope.tvResponse.cableTvDetails.hardwareMap[0].rtoIndicator; // RTO change
          }
        }
      },
      changeDeviceImage: function () {
        var selOption = $scope.tvObj.selectedHardwareId;
        var imageFile = null;

        for (var x1 = 0; x1 < $scope.tvResponse.cableTvDetails.hardwareMap.length; x1++) {
          var productName = $scope.tvResponse.cableTvDetails.hardwareMap[x1].productName;
          if (selOption === productName) {
            $scope.tvObj.rtoIndicator = $scope.tvResponse.cableTvDetails.hardwareMap[x1].rtoIndicator; // RTO change
            var productId = $scope.tvResponse.cableTvDetails.hardwareMap[x1].productId;
            var objChild = $scope.tvResponse.cableTvDetails.deviceDetails[productId];

            if (objChild) {
              imageFile = objChild.digitalBoxImage;
              break; // show first
            }
          }
        }

        $scope.getDeviceImage(imageFile);
      },
      postToRogersBottom: function (actionId) {
        $('#formToRogersBottom').attr('action', settings.formsURL + $scope.postToRogersUrls[actionId].url);
        $('#formToRogersBottom').submit();
      },
      loadTvFeed: function () {
        var status = '';
        var accType = '';
        if ($scope.selectedAccount.accountInfo) {
          status = $scope.selectedAccount.accountInfo.status;
          accType = $scope.selectedAccount.accountInfo.accType;
        }
        /*appState.tagging(['_trackPageView',
          {pn: 'home:myrogers:tv'},
          {sACTT: status}, // Consumer, Business
          {sBAN: $scope.selectedAccount.accountNumber}, //Account Number BAN, ex : '12345'
          {sCTN: $scope.selectedAccount.accountNumber}, //Account Telephone Number CTN, ex: '4161234567|4161234568'
          {sACSS: accType}
        ]);*/

        ajax.tvFeed().then(
          function (response) {
            if (response === undefined || response === null) {
              $scope.errorCode = 50000;
              $scope.errorMessageTvFeed = resource.get($scope.errorCode);

              $scope.displayContentTvFeed = false;
              $scope.loadingDataIndicatorTvFeed = false;
            } else {  //TBD
              $scope.displayContentTvFeed = true;
              $scope.loadingDataIndicatorTvFeed = false;
              /*for (var i=0; i<response.length; i++) {
               response[i].title = $sanitize(response[i].title);
               }*/
              $scope.tvFeed = response;
            }
          },
          function (error) {
            $scope.displayContentTvFeed = false;
            $scope.loadingDataIndicatorTvFeed = false;

            if (error.data.status === 555) {
              $scope.errorCode = error.error.errorCode;
              $scope.errorMessageTvFeed = error.error.message;
            } else {
              // anything but status code 555
              // Pull message from resource file 401 or 5xx situlation
              $scope.errorMessageTvFeed = resource.get('error_tv_feeder');
            }
          });
      }
    });

    $scope.processResponse = function (response) {
      if (response === undefined || response === null || !response.cableTvDetails) {
        $scope.displayContentTvDashboard = false;
        $scope.loadingDataIndicatorTvDashboard = false;

        $scope.errorCode = 50000;
        $scope.errorMessage = resource.get($scope.errorCode);

      } else {  //TBD
        $scope.tvResponse = response;
        $scope.displayContentTvDashboard = true;
        //$scope.loadingDataIndicatorTvDashboard = response.cachedResultInfo.expired;
        //console.log(response.cableTvDetails);
        var tvPackageNameCMS = ''
        angular.forEach(response.cableProductCMSDetails,function(cableProductCMSDetail){
          if(response.cableTvDetails.packageName == cableProductCMSDetail["product-id"]){
            if($scope.lng == 'en')
              tvPackageNameCMS = cableProductCMSDetail["english"]["short-description"];
            else
              tvPackageNameCMS = cableProductCMSDetail["french"]["short-description"];
          }

        });
        $scope.tvObj.myPlan.packageDescription = tvPackageNameCMS === '' ? response.cableTvDetails.packageDescription : tvPackageNameCMS;
        $scope.tvObj.myPlan.numChannels = response.cableTvDetails.channelsList.length;
        $scope.tvObj.hardwareList = response.cableTvDetails.hardwareList;

        if ($scope.tvObj.hardwareList.length < 2) {
          $scope.showHardwareDD = false;
          $scope.tvObj.selectedHardwareName = $scope.tvObj.hardwareList[0];
        }

        $scope.tvObj.hardwareList = {};
        for (var i = 0; i < response.cableTvDetails.hardwareList.length; i++) {
          var box = response.cableTvDetails.hardwareList[i];
          if(box) {
            if ($scope.tvObj.hardwareList.hasOwnProperty(box)) {
              $scope.tvObj.hardwareList[box]++;
            } else {
              $scope.tvObj.hardwareList[box] = 1;
            }
          }
        }
        $scope.securityKey = response.cableTvDetails.rogersKey;
        $scope.securityToken = response.cableTvDetails.rogersToken;
        $scope.processDevice();
        $scope.getDeviceImage($scope.tvObj.myModem.image);
        $scope.tvObj.extraChannelList = [];

        //if (response.cableTvDetails.themePackList !== undefined) {
          angular.forEach(response.cableTvDetails.themepackVOList, function(themepackVO) {
            var themePackTitle = '';
            angular.forEach(response.cableProductCMSDetails, function (themepackProductCMSDetail) {
              if (themepackVO.id == themepackProductCMSDetail["product-id"]) {
                if ($scope.lng == 'en') {
                  themePackTitle = themepackProductCMSDetail["english"]["short-description"] == '' ? themepackVO.cmsTitle : themepackProductCMSDetail["english"]["short-description"];
                } else if ($scope.lng == 'fr') {
                  themePackTitle = themepackProductCMSDetail["french"]["short-description"] == '' ? themepackVO.cmsTitle : themepackProductCMSDetail["french"]["short-description"];
                }
              }
            });
            if(themePackTitle == '')
              themePackTitle = themepackVO.cmsTitle;

            $scope.tvObj.myExtras.push(themePackTitle);
          } );
          $scope.hasThemes = $scope.tvObj.myExtras.length > 0;
       // }

        angular.forEach(response.cableTvDetails.channelVOList, function(channelVO) {
          var packageTitle = '';
          angular.forEach(response.cableProductCMSDetails, function (cblProductCMSDetail) {
            if (channelVO.id == cblProductCMSDetail["product-id"]) {
              if ($scope.lng == 'en') {
                packageTitle = cblProductCMSDetail["english"]["short-description"] == '' ? channelVO.cmsTitle : cblProductCMSDetail["english"]["short-description"];
              } else if ($scope.lng == 'fr') {
                packageTitle = cblProductCMSDetail["french"]["short-description"] == '' ? channelVO.cmsTitle : cblProductCMSDetail["french"]["short-description"];
              }
            }
          });
          if(packageTitle == '')
            packageTitle = channelVO.cmsTitle;

          $scope.tvObj.extraChannelList.push(packageTitle);
        } );
        $scope.hasExtras = $scope.tvObj.extraChannelList.length > 0;
      }
    };

    $scope.loadTvDashboard = function () {
      $scope.loadingDataIndicatorTvDashboard = true;
      $scope.displayContentTvDashboard = false;

      if (!$scope.selectedAccount.accountNumber) {
        return;
      }
      tvDashService.tvDashboard($scope.selectedAccount.accountNumber, $scope.langUpper, $scope.selectedAccount.ban, false).then(
        function (response) {
          $scope.processResponse(response);
          if (response.cachedResultInfo) {
            if (response.cachedResultInfo.expired) {
              tvDashService.tvDashboard($scope.selectedAccount.accountNumber, $scope.langUpper, $scope.selectedAccount.ban, true).then(
                function (response) {
                  $scope.finalDataReceived = true;
                  $scope.processResponse(response);
                },
                function (error) {
                  $scope.displayContentTvDashboard = false;
                  $scope.loadingDataIndicatorTvDashboard = false;

                  // Error handling - 555 exception
                  if (error.data.status === 555) {
                    $scope.errorCode = error.error.errorCode;
                    $scope.errorMessage = error.error.message;
                  } else {
                    $scope.errorMessage = resource.get('error_tv_feeder');
                  }
                });
            } else {
              $scope.finalDataReceived = true;
            }
          }
        },
        function (error) {
          $scope.displayContentTvDashboard = false;
          $scope.loadingDataIndicatorTvDashboard = false;

          // Error handling - 555 exception
          if (error.data.status === 555) {
            $scope.errorCode = error.error.errorCode;
            $scope.errorMessage = error.error.message;
          } else {
            $scope.errorMessage = resource.get('error_tv_feeder');
          }
        });
    };

    $scope.onOmnitureClickTv = function (option) {
      appState.tagging(option);
    };

    //$scope.loadTvFeed();

    $scope.loadTvDashboard();

    resource.onChanged(function () {

      var oldLang = $scope.lng;

      $scope.lng = userLanguage();
      $scope.lang = userLanguage() + '-CA';
      $scope.langUpper = userLanguage().toUpperCase();

      if (oldLang !== $scope.lng) {
        $scope.loadTvDashboard();
      }

      $scope.dollarSignB = userLanguage() === 'en' ? '$' : '';
      $scope.dollarSignA = userLanguage() === 'fr' ? '$' : '';

      $scope.postToRogersUrls = [
        {url: '/web/myrogers/torcom/link/tv/build-your-tv-package' + '?setLanguage=' + $scope.lng, flowId: 'dbchangechnlortp'},
        {url: '/web/myrogers/torcom/link/tv/build-your-tv-package' + '?setLanguage=' + $scope.lng, flowId: 'dbchangepkg'},
        {url: '/web/myrogers/torcom/link/tv/build-your-tv-package' + '?setLanguage=' + $scope.lng, flowId: 'dbchangedigitalbox'},
        {url: '/web/myrogers/resetDigitalBox' + '?setLanguage=' + $scope.lng, flowId: ''},
        {url: '/web/myrogers/resetDigitalPin' + '?setLanguage=' + $scope.lng, flowId: ''}
      ];
    }, $scope);
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrTvDashboardService', tvDashboardService);

  tvDashboardService.$inject = ['ajax', '$q'];

  /* @ngInject */
  function tvDashboardService(ajax, $q) {

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      tvDashboard: tvDashboard
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function tvDashboard(accountNumber, language, ban, requestFreshData) {

      var deferred = $q.defer();

      // process the first time result
      function processResult(data) {
        deferred.resolve(data);
      }

      // call tvLanding api to get data
      ajax.tvDashboard(accountNumber, language, ban, requestFreshData).then(
        function (response) {
          if (response) {
            processResult(response);
          }
        }, function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrUnderMaintenanceController', UnderMaintenanceController);

  UnderMaintenanceController.$inject = ['$scope', '$rootScope', '$location', 'resource', 'myrAccountOverviewService', 'localStorage'];

  /* @ngInject */
  function UnderMaintenanceController($scope, $rootScope, $location, resource, accountOverviewService, localStorage) {

    // One of the most amazing codes will be here
    var maintenance = null;

    $scope.$extend({
      accountTypes: null,
      mAccountOverview: false,
      mWireless: false,
      mResidential: false,
      messageId: 'maintenance_info',
      maintenanceInfo: resource.get($scope.messageId)
    });
     var migrateUserError = localStorage.getLocalStorageValue('userMigrateGeneralError');
    $scope.initMT = function () {

      var request = {
        refresh: false
      };

      if ($rootScope.maintenance && $rootScope.maintenance.ACCOUNT_OVERVIEW_ON_MAINTENANCE) {

        accountOverviewService.getAccountList(request, function (_tmp) {
          $scope.accountTypes = _tmp.accountList;

        });

      }

      getMaintenance($rootScope.maintenance);
    };

    function getMaintenance(value) {
      if (value.WIRELESS_ON_MAINTENANCE === true || value.WIRELESS_PREPAID_ON_MAINTENANCE === true) {
        $scope.messageId = 'maintenance_info_wireless';
      }
      else if (value.SITE_ON_MAINTENANCE === true) {
               $scope.messageId = 'acc_overview_daily_maintenance';
             }
      else if(migrateUserError){

      $scope.messageId = 'maintenance_info_migrateUser';
      migrateUserError = localStorage.setLocalStorageValue('userMigrateGeneralError', false);
      }

    }

    if (!$rootScope.noAccountList) {
      $scope.initMT();
    }

    resource.onChanged(function () {

      if (!$scope.messageId) {
        return;
      }

      $scope.maintenanceInfo = resource.get($scope.messageId);

    }, $scope);

  }
})();

'use strict';

  angular.module('totesApp')
  .directive('bulkInvoiceDownload', bulkInvoiceDownload);

  bulkInvoiceDownload.$inject = [];

  /* @ngInject */
  function bulkInvoiceDownload() {
    return {
      templateUrl: 'scripts/modules/uteBill/bulkInvoiceDownload.html',
      restrict: 'EA',
      scope: {},
      controller: ['$scope', '$rootScope', 'uteBillService', 'ajax', 'ute.datalayer.common.service', 'resource',
                    function ($scope, $rootScope, uteBillService, ajax, dataLayerService, resource) {
                      $scope.showDownloadsTab = false;
                      $scope.downloadingSelectedBills = false;
                      $scope.downloadSuccess= false;
                      $scope.technicalError = false;
                      $scope.timeoutError = false;
                      $scope.displayDownloadStatus = false;
                      $scope.uteBillService = uteBillService;
                      $scope.$watch('uteBillService.downloadBill', function () {
                        if(!$rootScope.disableDownloadSelectedButton && uteBillService.downloadBill) {
                          $scope.showDownloadsTab = false;
                        }
                      });

                      $rootScope.$watch('changeInDownloadBillRequest', function () {
                        if ($rootScope.changeInDownloadBillRequest && uteBillService.downloadSelectedInvoiceRequest && uteBillService.downloadSelectedInvoiceRequest && (uteBillService.downloadSelectedInvoiceRequest.downloadDetailsList.length > 0)) {
                          $scope.lastRetryAttempt = false;
                          $scope.downloadSuccess = false;
                          $scope.technicalError = false;
                          $scope.showDownloadsTab = true;
                          $scope.displayDownloadStatus = true;
                          $scope._tempArray = uteBillService.downloadSelectedInvoiceRequest;
                          $scope.downloadingSelectedBills = true;
                          bulkDownloadBills($scope._tempArray, 'timeoutError');
                          $rootScope.changeInDownloadBillRequest = false;
                        }
                      });
                      bulkDownloadBills = function (JSONRequest, retryAttempt) {
                        ajax.getBulkDownloadBills(JSON.stringify(JSONRequest)).then(function(response) {
                          var a = document.createElement('a');
                          var contentDisposition = response.headers('Content-disposition');
                          var filename = 'Unknown.zip';
                          if (contentDisposition) {
                            var splitValue = contentDisposition.split('filename=');
                            filename = splitValue.length > 1 ? splitValue[1] : 'Unknown.zip';
                          }
                          var contentType = response.headers('Content-Type');
                          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                            var blob = new Blob([response.data], {type: contentType});
                            window.navigator.msSaveOrOpenBlob(blob, filename);
                          } else {
                            var blob = typeof File === 'function'
                                ? new File([response.data], filename, {type: contentType})
                                : new Blob([response.data], {type: contentType});
                            var url = URL.createObjectURL(blob);
                            a.href = url;
                            a.download = filename;
                            a.target = '_blank';
                            document.body.appendChild(a);
                           setTimeout(function(){
                              a.click();
                            }, 2000);
                            setTimeout(function(){
                                document.body.removeChild(a);
                                window.URL.revokeObjectURL(url);
                            }, 5000);
                          }
                          dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "downloadBillsSuccess"});
                          $scope.downloadingSelectedBills = false;
                          $scope.downloadSuccess = true;
                          $rootScope.disableDownloadSelectedButton = false;
                          $scope.displayDownloadStatus = true;
                        }, function (error) {
                          if (error.data.status === 503 || error.data.status === 504) {
                            $scope.downloadingSelectedBills = false;
                            $scope.displayDownloadStatus = true;
                            switch (retryAttempt) {
                              case 'timeoutError':
                                $scope.timeoutError = true;
                                break;
                              case 'firstRetryAttempt':
                                $scope.firstRetryAttempt = true;
                                break;
                              case 'secondRetryAttempt':
                                $scope.secondRetryAttempt = true;
                                break;
                              case 'lastRetryAttempt':
                                $scope.lastRetryAttempt = true;
                                $rootScope.disableDownloadSelectedButton = false;
                                break;
                              default:
                                $scope.timeoutError = true;
                            }
                            var  payload = {
                              page: {
                                name: 'viewBill',
                                hierarchy: ['selfserve','billing&payment','viewBill']
                              },
                              errors: [{
                                API: '/bulkDownload',
                                type: 'http',
                                category: 'selfServe',
                                message: (($scope.timeoutError && !($scope.firstRetryAttempt || $scope.secondRetryAttempt || $scope.lastRetryAttempt)) ? resource.get('DT_timeout_error_message') :($scope.firstRetryAttempt ? resource.get('DT_first_timeout_error_message') : ($scope.secondRetryAttempt ? resource.get('DT_second_timeout_error_message') : ($scope.lastRetryAttempt ? resource.get('DT_technical_error_message') : resource.get('DT_technical_error_message'))))),
                                code: error.statusCode
                              }],
                              events: {
                                error: true
                              }
                            }; 
                            dataLayerService.track(payload, false, [4, 1, 0]);
                          }
                          else {
                            $scope.downloadingSelectedBills = false;
                            $scope.displayDownloadStatus = true;
                            $scope.technicalError = true;
                            $rootScope.disableDownloadSelectedButton = false;
                          }
                        });
                      }
                      $scope.bulkDownloadStatus = function () {
                        $scope.displayDownloadStatus = !$scope.displayDownloadStatus;
                      }

                      $scope.close = function () {
                        if($scope.downloadSuccess || $scope.technicalError || $scope.lastRetryAttempt) {
                          $scope.showDownloadsTab = false;
                          $scope.lastRetryAttempt = false;
                        }
                        else {
                          $scope.displayDownloadStatus = false;
                        }
                      }

                      $scope.dismiss = function() {
                        $scope.showDownloadsTab = false;
                        $scope.lastRetryAttempt = false;
                        $scope.downloadSuccess = false;
                        $scope.technicalError = false;
                      }

                      $scope.retry = function(retryAttempt) {
                        if (retryAttempt == 'firstRetryAttempt') {
                          $scope.timeoutError = false;
                          $scope.downloadingSelectedBills = true;
                          bulkDownloadBills($scope._tempArray, retryAttempt);
                        }
                        else if (retryAttempt == 'secondRetryAttempt') {
                          $scope.firstRetryAttempt = false;
                          $scope.downloadingSelectedBills = true;
                          bulkDownloadBills($scope._tempArray, retryAttempt);
                        }
                         else if (retryAttempt == 'lastRetryAttempt') {
                          $scope.secondRetryAttempt = false;
                          $scope.downloadingSelectedBills = true;
                          bulkDownloadBills($scope._tempArray, retryAttempt);
                        }

                      }

                    }]

                };
              }



// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.viewBill').controller('uteBillController', uteBillController);

  uteBillController.$inject = ['$scope', '$rootScope', '$timeout', 'btnSettings', '$window', 'userLanguage', 'myrPaymentTopBarService', 'myrAccountBalanceDataFactory', '$state', 'resource', 'myrBriteBillService', 'appState', 'myrAccountBalanceService', '$browser', '$modal', 'uteBillService', 'ute.datalayer.common.service', 'ajax', 'myrAccountListService', 'myrSigninService'];

  /* @ngInject */
  function uteBillController($scope, $rootScope, $timeout, btnSettings, $window, userLanguage, myrPaymentTopBarService, myrAccountBalanceDataFactory, $state, resource, myrBriteBillService, appState, myrAccountBalanceService, $browser, $modal, uteBillService, dataLayerService, ajax, myrAccountListService, signinService) {
    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    var vm = this;

    vm.abdf = myrAccountBalanceDataFactory;
    vm.abs = myrAccountBalanceService;
    vm.bb = uteBillService;
    vm.lang = userLanguage();
    vm.btnSettings = btnSettings;
    vm.ptbs = myrPaymentTopBarService;
    vm.getCreditCardImage = getCreditCardImage;
    vm.getCreditCardText=getCreditCardText;
    vm.getBankAccountNumber=getBankAccountNumber;
    vm.als = myrAccountListService;
    vm.hasCommunitiesAccess = false;
    vm.mbhUrls = {};

    vm.uteBillFailed = false;
    vm.loadingDataIndicator = false;
    vm.state = $state.current.name;

    $scope.billLimit = 6;

    $rootScope.$watch('ao.accountActive', function () {
      if ($rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatus) {
        vm.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
        vm.btnStatus = $window.btnStatus;
        vm.init();
      }
    });

    $rootScope.$watch('bbloadingDataIndicator', function () {
      vm.bbloadingDataIndicator = $rootScope.bbloadingDataIndicator;
    });

    function getCreditCardImage(){
      return resource.get(vm.abdf.billingDetails.methodOfPayment.creditCardDetails.ccType+"_img");
    }

    function getCreditCardText(){
      return resource.get(vm.abdf.billingDetails.methodOfPayment.creditCardDetails.ccType);
    }

    function getBankAccountNumber () {
       var accountNumber=vm.abdf.billingDetails.methodOfPayment.chequingDetails.accountNumber.substring(0 ,1) + "XXX XXXX XXXX X" + vm.abdf.billingDetails.methodOfPayment.chequingDetails.accountNumber.substring(1 ,4);
       return  accountNumber;
    }

    vm.bbloadingDataIndicator = true;
    vm.abdf.accountBalance.balanceAmount = "--.--";

    resource.onChanged(function () {
      vm.lang = userLanguage();

      if ($rootScope.briteBillInvoiceDates) {
        if ($rootScope.ao.britebill) {
          for (var i = 0; i < $rootScope.ao.britebill.length; i++) {
            $rootScope.ao.britebill[i].name = $rootScope.ao.britebill[i].issue_date ? vm.bb.convertDate($rootScope.ao.britebill[i].issue_date) : $rootScope.ao.britebill[i].name;// jshint ignore:line
            //TODO Remove rootscope.ao.britebill
            vm.bb.britebill[i].name = $rootScope.ao.britebill[i].issue_date ? vm.bb.convertDate($rootScope.ao.britebill[i].issue_date) : $rootScope.ao.britebill[i].name;// jshint ignore:line
          }
          vm.bb.briteBillOldestDate = $rootScope.ao.britebill[$rootScope.ao.britebill.length - 1].name;
        }
      }
    }, $scope);

    vm.showInvoiceDates = ($state.current.name === 'viewInvoice');

    vm.payBill = function () {
      scrollPageToTop();
      appState.switchView('/makeAPayment');
    };

    vm.triggerTrackData = function(fitUrl) {
      dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "fitInvoiceEntryPoint"});
      $window.open(fitUrl, "_blank");
    };

    //start of DSO-12417
    var bulkDownloadBillRequest = {};

    vm.downloadBill = function () {
      if(!$rootScope.disableDownloadSelectedButton) {
        uteBillService.downloadBill = true;
      }
      vm.checkAll = false;
      if (bulkDownloadBillRequest && (bulkDownloadBillRequest.downloadDetailsList.length)) {
        bulkDownloadBillRequest.downloadDetailsList = [];
      }
      angular.forEach(vm.bb.invoiceDateArray, function(date){
        date.selected = false;
      })
      $scope.modalInstance = $modal.open({
        templateUrl:'scripts/modules/uteBill/downloadBill.html',
        windowClass: "downloadBills",
        scope: $scope,
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });
    };
    vm.readMore= function(){
      document.getElementById("read-more").style.display ="none";
    	document.getElementById("print-notification").style.whiteSpace="normal";
    };
    vm.cancel = function() {
      $scope.modalInstance.close();
    };

    function formDownloadBillRequest(selectedDate) {
      var link, system, billDate = selectedDate.issue_date.split('-'), month = billDate[1], year = billDate[0], invDate = billDate[2];
      if (selectedDate.link === "EPOST"){
        link = selectedDate.url;
        system = selectedDate.link.toLowerCase();
      }
      else if (selectedDate.link === "WIN"){
        link = "";
        system = selectedDate.link.toLowerCase();
      }
      else {
        link = selectedDate.link;
        system = "britebill";
      }
      bulkDownloadBillRequest.downloadDetailsList.push({
        "system": system,
        "month": month,
        "year": year,
        "date": invDate,
        "link": link
      })
    }

    //RBIB-28504
vm.getMBHUrls = function () {
  $scope.$watch(function () {
    return $rootScope.portalIds;
  }, function (newVal) {
    if (newVal && newVal.length > 0) {
      vm.hasCommunitiesAccess = false; 
      for (var i = 0; i < newVal.length; i++) {
        if (newVal[i] === 'SFDC') {
          vm.hasCommunitiesAccess = true;
        }
      }
      signinService.mbhUrlConfig().then(function (urlResponse) {
        vm.mbhUrls = urlResponse;
      });
    }
  });
}

    vm.selectAll = function(){
      bulkDownloadBillRequest.downloadDetailsList = [];
      if (!vm.checkAll) {
        angular.forEach(vm.bb.invoiceDateArray, function(date){
          date.selected = false;
        })
      }
    }

    vm.isDateSelected = function(flag) {
      if(flag == true) {vm.dateSelected = true}
      else vm.dateSelected = false;
    }

    vm.downloadSelectedBills = function() {
      bulkDownloadBillRequest.downloadDetailsList = [];
      angular.forEach(vm.bb.invoiceDateArray, function(date) {
        if (vm.checkAll) {
          formDownloadBillRequest(date);
        }
        else if(date.selected) {
          formDownloadBillRequest(date);
        }
      })
      if (bulkDownloadBillRequest && bulkDownloadBillRequest.downloadDetailsList && (bulkDownloadBillRequest.downloadDetailsList.length > 0)) {
        $rootScope.changeInDownloadBillRequest = true;
        uteBillService.downloadSelectedInvoiceRequest = bulkDownloadBillRequest;
        vm.cancel();
        $rootScope.disableDownloadSelectedButton = true;
        uteBillService.downloadBill = false;
      }
    }
    //end of DSO-12417

    vm.isInvoiceProcessing = function(){
      return uteBillService.isInvoiceProcessing;
    }

    vm.isBillError = function(){
      return uteBillService.isInvErrorOccured();
    }

    vm.isNoBillsAvailable = function(){
      return uteBillService.isNoBillsAvailable();
    }

    vm.billingCycleEndDate = function(){
      var billingEndDateObj = vm.abs.accountBalance.currentBillCycleEndDate.split('-');
      var billingEndDate = new Date(billingEndDateObj[2], billingEndDateObj[0]-1, billingEndDateObj[1]);
      return billingEndDate;
    }

    $scope.boldChat = {
        uteBillError: {
          en: {
            cbid: 'S_BSS_Device_Details',
            dynamicDivId: 'Wireless_Bill_Error_div',
            chatButtonClass:'chatButtonWirelessBillErrorEn'
          },

          fr: {
            cbid: 'S_BSS_Device_Details_Fr',
            dynamicDivId: 'Wireless_BB_Error_Fr_div',
            chatButtonClass:'chatButtonWirelessBillErrorFr'
          }
        }
    };

    vm.openInvoice = function(bill){
      vm.bb.invoiceDateSelected = bill;
      uteBillService.downloadBill = true;
      $scope.modalInstance = $modal.open({
         templateUrl:'scripts/modules/uteBill/viewAllBills.html',
         windowClass: "uteBills",
         controller: 'viewAllBillsController',
         controllerAs: 'vab',
         scope: $scope,
         backdrop: 'static',
         keyboard: false,
         backdropClass: 'bkg-modal',
         resolve: {}
      });
      $scope.modalInstance.rendered.then(function() {
          $scope.$emit('billDateChange', {bill: bill});
      });
    }

    $scope.$on('billDateChange', function (evt, args) {
      $scope.dateChangeTitle = args.bill.name;
      vm.bb.getBillSrc(args.bill.link, args.bill.issue_date, args.bill.url);
      if ($rootScope.britebillInvoice) {
          $(".uteBills .modal-dialog").addClass("bbInvoices");
          $scope.analyticsMappingKey = 'briteBill';
      } else {
        $(".uteBills .modal-dialog").removeClass("bbInvoices");
        if ($rootScope.epostInvoice)
          $scope.analyticsMappingKey = 'epostBill';
        else
          $scope.analyticsMappingKey = 'winOnline';
      }

      var billType = $rootScope.billTypeValue === 'E_BILL' ? 'online' : 'paper';
      var invoiceType = $rootScope.britebillInvoice ? 'briteBill' : $rootScope.epostInvoice ? 'epostBill' : 'winOnline';
      var isEpostBill = $rootScope.displayGroupsReporting ? "epostN" : "epostY";
      var invoiceDate = args.bill.id.replace(/-/g, '');
      var billView = (args.eventSource === 'NextBill') ? 'See Next Bill' : (args.eventSource === 'PreviousBill') ? 'See Previous Bill' : 'BSS-ViewBill';
      var payload = {
        page: {
          name: 'viewBill',
          hierarchy: ['selfserve','billing&payment','viewBill']
        },
        events: {
          interaction: true,
          selfServeComplete: true
        },
        interaction: {
          type: 'click',
          name: billView + '|v21' + billType + '|' + invoiceType + '|' + isEpostBill + '|' + invoiceDate
        }
      };

      var invType = $rootScope.britebillInvoice ? 'BriteBill' : $rootScope.epostInvoice ? 'ePost' : 'WinOnline';
      if(args.eventSource) {
        payload.selfServe = {
          type: 'inquiry',
          name: 'View Invoice – ' + invType
        };
      }
      dataLayerService.track(payload, false, [4, 1, 0]);

      if(!args.eventSource) {
        $rootScope.$emit('$modal.opened', $scope.analyticsMappingKey);
      }
    });

    vm.showMoreDates = function() {
      $scope.billLimit = $scope.billLimit + 6;
    }

    vm.getUteBills = function() {
     if($state.current.name === 'viewInvoice') {
       var currentAccNumber = $rootScope.ao.accountActive.accountNumber;
       vm.bb.isInvoiceProcessing = true;
       if(currentAccNumber != '' || currentAccNumber != null || currentAccNumber != undefined){
         if ($browser.cookies().smbInvoiceMode == 'LEGACY' || $browser.cookies().smbInvoiceMode == ''){
           vm.bb.getEpostInvoice(currentAccNumber).then(function(epostDates) {
             if(epostDates != 'ERROR' && $rootScope.ao.accountActive.accountStatus != "Cancelled"){
               vm.bb.getWinOnlineInvoice(currentAccNumber).then(function(winInvoices) {
               vm.bb.processInvoices({}, epostDates, winInvoices);
               });
             } else {
                 vm.bb.processInvoices({}, epostDates, {});
             }
           });
         } else {
           vm.bb.getBriteBillInvoice(currentAccNumber).then(function(bbInvoices) {
              if (currentAccNumber.length != 12 && $browser.cookies().smbInvoiceMode != 'BRITEBILL' && bbInvoices != "ERROR" && (bbInvoices == 'NO_BILLS_FOUND' ||  bbInvoices.length < 18)) {
                vm.bb.getEpostInvoice(currentAccNumber).then(function(epostDates) {
                  if(epostDates != 'ERROR'){
                  if($rootScope.ao.accountActive.accountStatus != "Cancelled") {
                    vm.bb.getWinOnlineInvoice(currentAccNumber).then(function(winInvoices) {
                      vm.bb.processInvoices(bbInvoices, epostDates, winInvoices);
                    });
                    } else {
                      vm.bb.processInvoices(bbInvoices, epostDates, {});
                    }
                  } else {
                      vm.bb.processInvoices(bbInvoices, epostDates, {});
                  }
               });
              } else {
                vm.bb.processInvoices(bbInvoices, {}, {});
              }
          });
         }
       }
     }
    };
    vm.init = function() {
    			if ($rootScope.ao && $rootScope.ao.accountActive) {
            vm.getMBHUrls();
            bulkDownloadBillRequest= {
              "ban": $rootScope.ao.accountActive.accountNumber,
              "downloadDetailsList": []
            };
    				vm.ptbs.refreshBalanceDetails(),
    				vm.bb.registerToWIN(),
    				vm.getUteBills()
    			}
    };
    vm.init();
  }
})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('uteBillService', uteBillService);

  uteBillService.$inject = ['ajax','$q', '$rootScope', 'localStorage', 'resource', 'userLanguage', '$window', 'brtCheck', 'settings', '$sce', 'ute.datalayer.common.service', 'myrAccountListService', '$state', '$browser'];

  /* @ngInject */
  function uteBillService(ajax, $q, $rootScope, localStorage, resource, userLanguage, $window, brtCheck, settings, $sce, dataLayerService, myrAccountListService, $state, $browser) {
      var briteBillInvoices = {};

      var briteBillServerLogs = {
        'briteBillError': 'BriteBill error - '
      };

      var service = {
        getBriteBillInvoice: getBriteBillInvoice,
        getWinOnlineInvoice: getWinOnlineInvoice,
        processInvoices: processInvoices,
        getEpostInvoice: getEpostInvoice,
        convertDate: convertDate,
        filterAndMergeDates: filterAndMergeDates,
        isDuplicateDate: isDuplicateDate,

        briteBillInvoiceDates: null,
        briteBillOldestDate: null,
        britebill: null,
        loadingBriteBill: false,
        invoiceDateArray: null,
        invoiceDateSelected: null,
        showInvoiceDates: false,
        defaultLink: null,
        briteBillError: null,
        isInvErrorOccured: isInvErrorOccured,
        isBriteBill: isBriteBill,
        isNoBillsAvailable: isNoBillsAvailable,
        isInvoiceProcessing : true,
        getbbErrorMsg: getbbErrorMsg,
        isUteBill: isUteBill,
        getBillSrc: getBillSrc,
        downloadSelectedInvoiceRequest: null,
        downloadBill: false,
        pdfErrorCount: 0,
        brtCheckEpost: brtCheckEpost,
        epostAccountFlag: {},
        registerToWIN: registerToWIN
      };

      return service;

      function getBillSrc(link, issue_date, url) {
        var accountNumber = localStorage.getLocalStorageValue('accountNumber');
        var bbErrorMessage = resource.get('bb_error_message');
        $rootScope.pdfNotLoading = false;
        $rootScope.winInvoice = false;
        $rootScope.epostInvoice = false;
        $rootScope.britebillInvoice = false;

        if(link == "WIN"){
          $rootScope.pdfNotLoading = false;
          $rootScope.winInvoice = true;
          if (issue_date) {
            var _date = issue_date.split('-');
            service.pdfErrorCount = 0;
            $rootScope.winIframeUrl = $sce.trustAsResourceUrl("/web/smb/cms/selfserve/pdf_js/web/viewer.html?file=" +
                                      encodeURIComponent('/web/RogersServices.portal/smb/api/business/v2/bills/wol/'+$rootScope.ao.accountActive.accountNumber+'/'+_date[0]+'/'+_date[1] +
                                      '?date=' + new Date().getTime()));
          }
        }
        else if(link == "EPOST"){
          $rootScope.pdfNotLoading = false;
          $rootScope.epostInvoice = true;
          $rootScope.epostURL = $sce.trustAsResourceUrl(url);
        }
        else if (!_.isEmpty(link)) {
          $rootScope.pdfNotLoading = false;
          $rootScope.britebillInvoice = true;
          service.src = '/web/smb/bss/BriteBill.html?accountNumber=' + accountNumber + '&link=' + link + '&bbErrorMessage=' + bbErrorMessage;
        }
      }

      function getBriteBillInvoice(accountNumber){
        var deferred = $q.defer();
        if (!_.isEmpty(briteBillInvoices) && briteBillInvoices[accountNumber]) {
          deferred.resolve(briteBillInvoices[accountNumber]);
        } else {
          fetchBriteBillInvoice(accountNumber).then(function(data) {
            briteBillInvoices[accountNumber] = data;
            deferred.resolve(briteBillInvoices[accountNumber]);
          }, function(error) {
            briteBillInvoices[accountNumber] = 'ERROR';
            deferred.resolve(briteBillInvoices[accountNumber]);
          });
        }
        return deferred.promise;
      }

      function fetchBriteBillInvoice(accountNumber) {
        var deferred = $q.defer();
        var bbrequest = {
          'currentAccNumber': accountNumber,
          'applicationId': 'MyAccount'
        };
        ajax.getBriteBill(bbrequest).then(function(data) {
          if (data && data.encryptedString) {
            var headerData = {'EncryptedToken': data.encryptedString, 'If-Modified-Since': 0};
            var data = {
              'appID': 'MyAccount',
              'uuid': new Date().getTime()
            };
            invokeBriteBillToGetBill(data, headerData).then(function(data){
                deferred.resolve(data);
            }, function(error){
                deferred.reject('ERRORENCRYPT');
            });
          } else {
              deferred.reject('ERRORENCRYPT');
          }
        }, function (error) {
          deferred.reject('ERRORENCRYPT');
        });
        return deferred.promise;
      }

      function invokeBriteBillToGetBill(data, headerData) {
        var deferred = $q.defer();

        ajax.getBriteBillListOfBills(data, headerData).then(function(tempData) {
          // check for error messages from server / Auth exipre / other troubles that do return valid JSON

          if(_.includes($rootScope.errorMsgBB, tempData)){
            $rootScope.isBillErrorOccured = true;
            deferred.reject('ERROR');
          } else {
              try{
                  tempData = tempData.bills ? tempData : JSON.parse(tempData);
                  if (tempData.bills && tempData.bills.length > 0) {
                    deferred.resolve(tempData.bills);
                  } else {
                    deferred.resolve('NO_BILLS_FOUND');
                  }
              } catch (e) {
                  deferred.resolve('NO_BILLS_FOUND');
              }
          }
        }, function (error) {
           if (error.data.status === 400 || error.data.status === 403 || error.data.status === 404) {
              deferred.resolve('NO_BILLS_FOUND');
           } else {
             $rootScope.isBillErrorOccured = true;
             deferred.reject('ERROR');
           }
        });
        return deferred.promise;
      }

      function getWinOnlineInvoice(accountNumber) {
        var deferred = $q.defer();
        var invoiceRequest = {
          'accountNumber': accountNumber
        };

        fetchWinOnlineToGetBill(invoiceRequest).then(function(data) {
          deferred.resolve(data);
        }, function(error){
          deferred.resolve(error);
        });

        return deferred.promise;
      }

      function fetchWinOnlineToGetBill(invoiceRequest) {
        var deferred = $q.defer();
        ajax.getWolDates(invoiceRequest).then(function(data) {
          // check for error messages from server / Auth exipre / other troubles that do return valid JSON
          if (data.status == 'success') {
            var winDates= [];
            $rootScope.latestWinBillURL = undefined;
            angular.forEach(data.invoices, function (invoice) {
               if (invoice.locationInd == 'WIN') {
                  winDates.push({
                   "accountbalance":"",
                   "amount": "",
                   "batch": "",
                   "content_id": "",
                   "duedate": "",
                   "from": "",
                   "issue_date": invoice.cycleDate,
                   "link": "WIN",
                   "payment_status": "",
                   "received_date": "",
                   "location_ind": invoice.locationInd
                   });
               }
            });
            deferred.resolve(winDates);
          } else if (data.errorMessage == "No invoice available" || data.errorCode == 35001){
            deferred.resolve(35001);
          } else if(data.errorMessage == "Account does not exist" || data.errorCode == 35000) {
            deferred.resolve(35000);
          } else if (!data.isWinRegistered) {
            deferred.resolve('notWinRegistered');
          } else {
            deferred.resolve(35001);
          }
        }, function (error) {
           deferred.reject('ERROR');
        });
        return deferred.promise;
      }

      function getEpostInvoice(accountNumber){
        var deferred = $q.defer();
        var invoiceRequest = {
           'accountNumber': accountNumber
        };

        invokeEpost(invoiceRequest).then(function (data) {
          deferred.resolve(data);
        }, function(error){
          deferred.resolve(error);
        });
        return deferred.promise;
      }

      function invokeEpost(invoiceRequest){
         var deferred = $q.defer();
         ajax.getEpostBill(invoiceRequest).then(function(data) {
          if (data.length > 0) {
            var epostDates= [];
            angular.forEach(data, function (epostInvoice) {
              epostDates.push({
               "accountbalance":"",
               "amount": "",
               "batch": "",
               "content_id": "",
               "duedate": "",
               "from": "",
               "issue_date": epostInvoice.date,
               "link": "EPOST",
               "payment_status": "",
               "received_date": "",
               "url": epostInvoice.url
               });
            });
            deferred.resolve(epostDates);
          } else {
            deferred.resolve(5001);
          }
         }, function (error) {
            deferred.reject('ERROR');
         });

         return deferred.promise;
      }

      function processInvoices(bbInvoices, epostDates, winDates) {
        $rootScope.isNoBillsAvbl = false;
        $rootScope.isBillErrorOccured = false;
        if (bbInvoices && (bbInvoices == 'ERROR' || bbInvoices == 'NO_BILLS_FOUND' || bbInvoices.length > 0 || $browser.cookies().smbInvoiceMode == 'LEGACY')) {
          var bills = _.clone(bbInvoices, true);
          if (bbInvoices == 'ERROR' || bbInvoices == 'NO_BILLS_FOUND' || $browser.cookies().smbInvoiceMode == 'LEGACY') {
            bills = [];
          }
          if(!_.isEmpty(epostDates) && epostDates != 'ERROR'){
            bills = filterAndMergeDates(bills, epostDates);
          }
          if (!_.isEmpty(winDates) && winDates != 35000 && winDates != 35001 && winDates != 'notWinRegistered' && winDates != 'ERROR') {
            bills = filterAndMergeDates(bills, winDates);
          }
          sortInvoices(bills, bbInvoices, epostDates, winDates);
        } else {
          service.loadingBriteBill = false;
          if (bbInvoices === 'fail') {

          } else if (bbInvoices === 'ERROR') {
            $rootScope.briteBillFailed = true;
          } else {
            // Unknown state ???
          }
        }
        service.isInvoiceProcessing = false;
      }

      function sortInvoices (bills , bbInvoices, epostDates, winDates){
        if(bbInvoices == 'ERROR' || epostDates == 'ERROR' || winDates == 'ERROR' || winDates == 'notWinRegistered'){
          $rootScope.ao.britebill = undefined;
          $rootScope.briteBillInvoiceDates = '';
          service.loadingBriteBill = false;
          $rootScope.isBillErrorOccured = true;
        } else if (bills.length > 0) {
          bills.sort(function (a, b) {
            //Dates are iso std YYYY-MM-DD
            var c = new Date(a.issue_date);// jshint ignore:line
            var d = new Date(b.issue_date);// jshint ignore:line
            return d - c;
          });

          bills.splice(18, bills.length - 18); //For removing bills more than 18

          $rootScope.briteBillInvoiceDates = '';
          for (var i = 0; i < bills.length; i++) {
            bills[i].name = bills[i].issue_date ? convertDate(bills[i].issue_date) : bills[i].name; // jshint ignore:line
            bills[i].id = bills[i].issue_date; // jshint ignore:line

            if ($rootScope.briteBillInvoiceDates) {
              $rootScope.briteBillInvoiceDates += "," + bills[i].issue_date; // jshint ignore:line
            } else {
              $rootScope.briteBillInvoiceDates += bills[i].issue_date;// jshint ignore:line
            }
          }
          service.briteBillInvoiceDates = $rootScope.briteBillInvoiceDates;

          $rootScope.ao.britebill = bills;
          service.britebill = bills;
          $rootScope.isbritebillAvailable = true;
          service.loadingBriteBill = false;
          service.invoiceDateArray = bills;

          if(null == localStorage.getLocalStorageValue('invoiceDateSelected') || undefined == localStorage.getLocalStorageValue('invoiceDateSelected')  || localStorage.getLocalStorageValue('invoiceDateSelected') == "") {
            service.invoiceDateSelected = bills[0].issue_date;
            service.showInvoiceDates = true;
            service.defaultLink = bills[0].link;
            //$rootScope.$emit('invoiceDateChange', {link: bills[0].link, issue_date: bills[0].issue_date });
          } else {
              service.invoiceDateSelected = localStorage.getLocalStorageValue('invoiceDateSelected');
              service.showInvoiceDates = true;
              service.defaultLink =   localStorage.getLocalStorageValue('defaultLink');
              //$rootScope.$emit('invoiceDateChange', {link: localStorage.getLocalStorageValue('defaultLink'), issue_date: localStorage.getLocalStorageValue('invoiceDateSelected')});
              localStorage.deleteLocalStorageValue('invoiceDateSelected');
              localStorage.deleteLocalStorageValue('defaultLink');
          }
        } else {
          // no bills
          $rootScope.ao.britebill = undefined;
          $rootScope.briteBillInvoiceDates = '';
          service.loadingBriteBill = false;
          $rootScope.isNoBillsAvbl = true;
          var mappingKey = { mappingKey: "noInvoicesAvailable" };
          dataLayerService.trackGlobal(mappingKey);
        }
      }

      function filterAndMergeDates(mergedInvoiceList, invoiceList) {
        var mergedInvoiceDates = [];
        mergedInvoiceDates = mergedInvoiceList;

        angular.forEach(invoiceList, function(invoice) {
          var isDuplicateInvoiceDate = isDuplicateDate(invoice.issue_date, mergedInvoiceList);
          if(isDuplicateInvoiceDate == "false") {
            mergedInvoiceDates.push(invoice);
          }
        });
        return mergedInvoiceDates;
      }

      function isDuplicateDate(invoiceDate, mergedInvoiceList) {
        var isDuplicateInvoiceDate = "false";
        angular.forEach(mergedInvoiceList, function(mergedInvoice){
          if(invoiceDate == mergedInvoice.issue_date){
            isDuplicateInvoiceDate = "true";
            return isDuplicateInvoiceDate;
          }
        })
        return isDuplicateInvoiceDate;
      }

      function convertDate(date) {
        //date = "2015-06-01";
        var _date = date.split('-');
        // _date[0] - year, _date[1] - month, _date[2] - day
        var _dateObj = new Date(_date[0], _date[1] - 1, _date[2]);

        var day = _dateObj.getDate();
        //Commenting out the date increment as we should use the date that is returned by the britebill server - was causing MYR-1041
        //day++;
        var _months = resource.get('_months');
        var month = _months[_dateObj.getMonth()];
        if (userLanguage() === 'en') {
          date = month + ' ' + day + ', ' + _dateObj.getFullYear();
        } else {
          date = day + ' ' + month + ' ' + _dateObj.getFullYear();
        }
        return date;
      }

      function isInvErrorOccured() {
        return $rootScope.isBillErrorOccured;
      }

      function isNoBillsAvailable() {
        return $rootScope.isNoBillsAvbl;
      }

      function getbbErrorMsg(){
         return ajax.getSelfserveConfig().then(
            function (response) {
               $rootScope.errorMsgBB = response.errorMessage;
             }, function (error) {
               //check for business on this
             }
         );
      }

      function brtCheckEpost(accountNumber){
        var deferred = $q.defer();
        if(service.epostAccountFlag && service.epostAccountFlag[accountNumber] != undefined)
          deferred.resolve(service.epostAccountFlag[accountNumber]);
        else {
          ajax.checkEpost(accountNumber).then(function(data){
            service.epostAccountFlag[accountNumber] = data;
            deferred.resolve(service.epostAccountFlag[accountNumber]);
          }, function(error){
            deferred.resolve('false');
          });
        }
        return deferred.promise;
      }

      function isBriteBill(){
        if (myrAccountListService.isOcp == "directLanding" && (localStorage.getLocalStorageValue('accountNumber') != null || $rootScope.accountListLength == 1)) {
            myrAccountListService.isOcp = " ";
            $state.go("accountInitialization");
        }
        service.getbbErrorMsg();
        $window.document.cookie = 'hasBriteBillInvoice=' + 'false' + ';domain=' +'.rogers.com' + ';path=' + '/';
        var accountNumber = ($rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountNumber : ($rootScope.ao.accountDetails ? $rootScope.ao.accountDetails.accountNumber : undefined);
        var deferred = $q.defer();
        getBriteBillInvoice(accountNumber).then(function(data){
          $rootScope.isBillErrorOccured = false;
          if(data && data != 'NO_BILLS_FOUND' && data.length > 0){
            $window.document.cookie = 'hasBriteBillInvoice=' + 'true' + ';domain=' +'.rogers.com' + ';path=' + '/';
          }
          deferred.resolve(true);
        },function(){
          $rootScope.isBillErrorOccured = true;
          deferred.resolve(true);
        });
        return deferred.promise;
      }

      function isUteBill(){
        service.isBriteBill();
      }

      function registerToWIN() {
        if((localStorage.getLocalStorageValue('winRegistered') == null || localStorage.getLocalStorageValue('winRegistered') == undefined) &&
            ($rootScope.ao.raw.userProduct === 'WL' || $rootScope.ao.raw.userProduct === 'WL_C')) {

          var postData = {};
          postData.banList = [];
          postData.firstName = myrAccountListService.selectedAccount.accountName.firstName;
          postData.lastName = myrAccountListService.selectedAccount.accountName.lastName;
          for(var i=0; i< $rootScope.ao.allAccounts.length; i++){
            if($rootScope.ao.allAccounts[i].accPdtType === 'WL' || $rootScope.ao.allAccounts[i].accPdtType === 'WL_C'){
              postData.banList.push($rootScope.ao.allAccounts[i].accountNumber);
            }
          }

          ajax.winRegister(postData).then(function(data) {
            localStorage.setLocalStorageValue('winRegistered', true);
          }, function (error) {
            //DoNothing
          });

        }
      };
  }
})();



(function () {
  'use strict';

  angular.module('myr.modules.viewBill').controller('viewAllBillsController', viewAllBillsController);

  viewAllBillsController.$inject = ['$uibModalInstance', 'uteBillService', '$scope'];

  function viewAllBillsController($modalInstance, uteBillService, $scope) {
    var vm = this;
    var currentDate = 0;

    vm.bb = uteBillService;
    vm.cancel = function(){
      $modalInstance.dismiss('cancel');
    };

    vm.index = _.findIndex(vm.bb.invoiceDateArray, function(invoice) {
                return invoice.issue_date === vm.bb.invoiceDateSelected.issue_date;
              });

    vm.nextBill = function() {
        vm.index = vm.index+1;
        if (vm.index >= vm.bb.invoiceDateArray.length) {
          vm.index = vm.bb.invoiceDateArray.length - 1;
        }
        vm.bb.invoiceDateSelected = vm.bb.invoiceDateArray[vm.index];
        $scope.nextBillDate = vm.bb.invoiceDateSelected.name;
        $scope.$emit('billDateChange', {bill: vm.bb.invoiceDateSelected, eventSource: 'NextBill'});
    };

    vm.prevBill = function() {
        vm.index = vm.index-1;
        if (vm.index < 0) {
          vm.index = 0;
        }
        vm.bb.invoiceDateSelected = vm.bb.invoiceDateArray[vm.index];
        $scope.prevBillDate = vm.bb.invoiceDateSelected.name;
        $scope.$emit('billDateChange', {bill: vm.bb.invoiceDateSelected, eventSource: 'PreviousBill'});
    };

    vm.nextBillDate = function() {
        if (vm.index >= vm.bb.invoiceDateArray.length - 1) {
          return;
        }
        return vm.bb.invoiceDateArray[vm.index + 1].name;
    };

    vm.prevBillDate = function() {
        if (vm.index <= 0) {
          return;
        }
        return vm.bb.invoiceDateArray[vm.index - 1].name;
    };
  }
})();

/**
 * Created by varun.ramakanth on 11/9/2015.
 */
(function () {
  'use strict';

  angular.module('totesApp').controller('InternetUsageController', InternetUsageController);

  InternetUsageController.$inject = ['$scope', '$state', 'ajax', 'resource', '$rootScope', 'appState', 'myrPayNowService', 'userLanguage', 'myrAccountOverviewService', 'myrChangePaymentMethodService', '$stateParams', 'settings', '$modal', '$timeout', 'localStorage', 'semafoneService', '$document', 'myrMyServicesService', 'myrAccountBalanceService'];

  /* @ngInject */
  function InternetUsageController($scope, $state, ajax, resource, $rootScope, appState, myrPayNowService, userLanguage, accountOverviewService, paymentMethodService, $stateParams, settings, $modal, $timeout, localStorage, semafoneService, $document, myrMyServicesService, myrAccountBalanceService) {


    function init() {


      var isRouteAvailable = false;
      var isAccNumAvailable = false;
      if(undefined != accountOverviewService.getSelectedAccountDetail()){

        if(accountOverviewService.getSelectedAccountDetail().isConsolidated)
        $scope.selectedAccNum = localStorage.getLocalStorageValue('internetAccountNumber');
         else
        $scope.selectedAccNum = accountOverviewService.getSelectedAccountDetail().billableAccountNumber;

        isAccNumAvailable = true;
      }
      if($stateParams.usageType == 'daily'){
        isRouteAvailable = true;
        $scope.tabConfig = [{heading:"ute_label_Daily", subHeading:"ute_label_UsageHistory", route:"internetUsage.daily", active: true},
          {heading:"ute_label_Monthly", subHeading:"ute_label_UsageHistory", route:"internetUsage.monthly", active: false},
          {heading:"ute_label_Usage", subHeading:"ute_label_NotificationHistory", route:"internetUsage.notification", active:false}
        ];
      }
      else if($stateParams.usageType == 'monthly'){
        isRouteAvailable = true;
        $scope.tabConfig = [{heading:"ute_label_Daily", subHeading:"ute_label_UsageHistory", route:"internetUsage.daily", active: false},
          {heading:"ute_label_Monthly", subHeading:"ute_label_UsageHistory", route:"internetUsage.monthly", active: true},
          {heading:"ute_label_Usage", subHeading:"ute_label_NotificationHistory", route:"internetUsage.notification", active:false}
        ];
      }
      else if($stateParams.usageType == 'notification'){
        isRouteAvailable = true;
        $scope.tabConfig = [{heading:"ute_label_Daily", subHeading:"ute_label_UsageHistory", route:"internetUsage.daily", active: false},
          {heading:"ute_label_Monthly", subHeading:"ute_label_UsageHistory", route:"internetUsage.monthly", active: false},
          {heading:"ute_label_Usage", subHeading:"ute_label_NotificationHistory", route:"internetUsage.notification", active:true}
        ];
      }
      if(!isAccNumAvailable || !isRouteAvailable){
        appState.switchView('internetdash');
      }
    }

    $scope.internetUsageErr = function(){

    };

    init();
  }

})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('viewGroupsAndReportingController', viewGroupsAndReportingController);

  viewGroupsAndReportingController.$inject = ['$scope', '$rootScope', '$sce', 'settings', '$browser', 'localStorage', 'user', 'uteBillService', 'ajax'];

  /* @ngInject */
  function viewGroupsAndReportingController($scope, $rootScope, $sce, settings, $browser, localStorage, user, uteBillService, ajax) {

      $scope.locale = $browser.cookies().language+'_CA';

      function loadInvoiceWinUrl() {
        if((localStorage.getLocalStorageValue('BSS_OCP_UTE')=="true") && user.isAuthenticated()
              && !$browser.cookies()['bss-info'] && !$browser.cookies().CONSENT_STATE) {
           console.log("bss-info not present :: Triggering signout from Groups & Reporting pages");
           user.logout();
        }
        if(localStorage.getLocalStorageValue('BSS_OCP_UTE')=="true" && localStorage.getLocalStorageValue('accountNumber')){
            var mbhAccounts ={"accountList" :[{"accountNumber":localStorage.getLocalStorageValue("accountNumber")}]};
            $rootScope.$emit('initializeMbhLauncher', mbhAccounts);
        }
        var iFrameUrl = '';
        if (settings.isLocal) {
          iFrameUrl = settings.invoiceWinUrl.dev;
        } else if (settings.isDevBB) {
          iFrameUrl = settings.invoiceWinUrl.dev;
        } else if (settings.isQaBB) {
          iFrameUrl = settings.invoiceWinUrl.qa;
        } else if (settings.isProdBB) {
          iFrameUrl = settings.invoiceWinUrl.prod;
        } else {
          iFrameUrl = settings.invoiceWinUrl.prod;
        }
        ajax.getWinOnlineToken({'user': true}).then(
          function(data){
            if (data.token) {
              $scope.iFrameSrcGroups = $sce.trustAsResourceUrl(iFrameUrl + "/bizonline/ecom/disp.do?dest=bizgroups&lang=" + $scope.locale + "&tok=" + data.token + "&output=embed");
              $scope.iFrameSrcReporting = $sce.trustAsResourceUrl(iFrameUrl + "/bizonline/ecom/disp.do?dest=reports&lang=" + $scope.locale + "&tok=" + data.token + "&output=embed");
            }else {
              $scope.iFrameSrcGroups = $sce.trustAsResourceUrl(iFrameUrl + "/bizonline/ecom/disp.do?dest=bizgroups&lang=" + $scope.locale + "&output=embed");
              $scope.iFrameSrcReporting = $sce.trustAsResourceUrl(iFrameUrl + "/bizonline/ecom/disp.do?dest=reports&lang=" + $scope.locale + "&output=embed");
            }
          },function(error){
            $scope.iFrameSrcGroups = $sce.trustAsResourceUrl(iFrameUrl + "/bizonline/ecom/disp.do?dest=bizgroups&lang=" + $scope.locale + "&output=embed" );
            $scope.iFrameSrcReporting = $sce.trustAsResourceUrl(iFrameUrl + "/bizonline/ecom/disp.do?dest=reports&lang=" + $scope.locale + "&output=embed");
          });
        return;
      }

      uteBillService.registerToWIN();
      loadInvoiceWinUrl();
    }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrWirelessDashboardController', WirelessDashboardController);

  WirelessDashboardController.$inject = ['$scope', '$rootScope', 'appState', 'myrWirelessDashboardService', 'myrAccountOverviewService','myrAccountListService','myrAccountBalanceService', 'resource', 'userLanguage', 'localStorage','userProvince','$window', '$state', '$location', 'ute.rogers.datalayer.integration.common.service', 'brtCheck', '$modal', 'myrMyServicesService', '$timeout', 'myrSigninService'];

  /* @ngInject */
  function WirelessDashboardController($scope, $rootScope, appState, myrWirelessDashboardService, myrAccountOverviewService,myrAccountListService,myrAccountBalanceService, resource, userLanguage, localStorage, userProvince, $window, $state, $location, dataLayerIntegrationService, brtCheck, $modal, myrMyServicesService, $timeout, signinService) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line
    brtCheck.eSimSwitch();
    $scope.ab = myrAccountBalanceService;
    $scope.maintenanceTime =false;
    var currentTime = new Date().getHours();
    if((currentTime>=$rootScope.maintenanceStart)&&(currentTime<$rootScope.maintenanceEnd)){
      $scope.maintenanceTime =true;
    }

    $scope.redirectToDMDashboard = function() {
      myrMyServicesService.encryptDMPayload().then(function(token) {
        $scope.icid = 'bu-otmbcinq-dmlrbwrls-0227196';
        $scope.token = token;
        $timeout(function () {
          $("#dmFormData").submit();
        });
      }, function(error) {
        $scope.modalInstance = $modal.open({
          templateUrl: 'views/modals/dmFailureMessage.html',
          controller: 'MyrMyServicesController',
          backdrop: false,
          scope: $scope,
          resolve: {}
        });
      });
    }

    $scope.ctn = localStorage.getLocalStorageValue('phoneNumber');
    $scope.ban = localStorage.getLocalStorageValue('accountNumber');
    $scope.WirelessService = myrWirelessDashboardService;

    $scope.redirectToWirelessPlans = '../../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/shop/wireless/plans/';
    /*function () {
     $window.open('../../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/shop/wireless/plans/', '_blank');
     };*/


    //Start - Bold chat changes to display floating chat in Wireless Dashboard
    $scope.invokeFloatingChat = function () {
      var buttonId;
      if(userLanguage() === 'en'){
        buttonId = getBDId('F_BSS_BldSln_SB');
        floatingLiveChatButtonUTE(buttonId);
      } else {
        buttonId = getBDId('F_BSS_WlessDbrd_Fr');
        floatingLiveChatButtonUTE(buttonId);
      }
    };

    $scope.$on('$stateChangeStart', function() {
      angular.element('.bcFloat').remove();
    });


    $rootScope.$on('languageChanged', function (){
      angular.element('.bcFloat').remove();
      $scope.invokeFloatingChat();
    });

    setTimeout(function () {
      $scope.invokeFloatingChat();
    }, 0);

    // $scope.invokeFloatingChat(); // added for RBIB-2322
    //End - Bold chat changes to display floating chat in Wireless Dashboard

    var request = {
      applicationId: 'SMB',
      ctn: $scope.ctn,
      ban: $scope.ban,
      language: userLanguage()
    };

    $scope.$watch(function(){return myrAccountBalanceService.accountBalance.nextBillDate},function(val){
      localStorage.setLocalStorageValue('nextBillDate', val);
    });

    $scope.$watch('wirelessDashActive', function (newValue, oldValue) {
      if (newValue !== oldValue || (newValue === oldValue && !$rootScope.wirelessPackagePostPaidProcessed)) {
        if (newValue.ctn) {
          $scope.ctn = request.ctn = $scope.wirelessDashActive.ctn;
          request.refresh = false;
          $scope.WirelessService.getWirelessPostpaid(request);
        }
      }
    });

    $scope.$extend({
      postToRogersUrls: [
        '/web/torcom/prepaidPricePlanChange',
        '/web/torcom/prepaidUpdateWirelessEssential',
        '/web/torcom/prepaidTopUp',
        '/web/torcom/prepaidTelephoneNumberChange',
        '/web/torcom/prepaidPassCodeReset'
      ],
      //	State reset / variables erase
      pageVariablesInit: function (firstTime) {
        $scope.lng = userLanguage();
        $scope.displayContent = false;
        $scope.loadingDataIndicator = true;
        $scope.loadingDataIndicatorTravelPackage = true;

        $scope.appState = appState;
        $scope.errorMessage = '';
        $scope.errorMessageKey = '';
        $scope.threadsOpen = 0;

        $scope.wirelessAccounts = [];
        $scope.wirelessAccountsPhones = [];
        $scope.wirelessDashData = [];
        $scope.wirelessDashActive = [];
        $scope.wd = [];
        $scope.wdEmpty = false;
        $scope.wdMidCycle = false;
        $scope.wdMCPPCrerating = false;

        // Show / hide sections
        $scope.showData = false;
        $scope.showRoaming = false;
        $scope.showRoamingComingSoon = false;
        $scope.showSms = false;
        $scope.showTalk = false;

        // Mobile view collapsed
        $scope.dataIsCollapsed = true;
        $scope.talkIsCollapsed = true;
        $scope.smsIsCollapsed = true;
        $scope.roamingIsCollapsed = true;

        // Travel packages
        $scope.hideWirelessTravelPackage = true;

        // Trigger collapse event
        $('.colDataWrap').collapse('hide');

        // Page refresh is different from selector update.
        if (firstTime) {
          // First time load
          $('.colDataWrap').removeClass('in');

        } else {
          // Selector refresh
        }

        // next billing date
        $scope.nextBillDate = null;
        $scope.nextbilldaysuntil = null;

        $scope.selectedAccount = {};
      },
      /*
       * Data loading
       */
      getAccountList: function () {
        var request = {refresh: 'false', applicationId: 'Rogers.com'};
        var holder = null;
        myrAccountListService.acctInitStateUrl = "wireless";
        $scope.wirelessAccounts = [];
        // appState.tagging(['_trackPageView', {pn:'home:myrogers:wireless'} ]);
        appState.tagging(['_trackLink', {eVar11: $scope.ctn}, {event17: ''}]);


        myrAccountListService.getAccountList(request, function (_tmp) {
          if (_tmp.result === 'success' && _tmp.data.length > 0) {
            // Loop through the results and find only wireless accounts
            var tmpObj = {};
            var accountNumber = localStorage.getLocalStorageValue('accountNumber');


            // TODO - $rootScope.ao.accountActive.accountNumber  Make SURE this is not null / happens when refresh is pressed
            var _length = _tmp.data.length;

            //for (var i in _tmp.data) {
            for (var i = 0; i < _length; i++) {
              tmpObj = _tmp.data[i];
              // if ((tmpObj.accountTypeNumber === 1 || tmpObj.accountTypeNumber === 9) && tmpObj.accountNumber === $rootScope.ao.accountActive.accountNumber) {
              // if ((tmpObj.accountTypeNumber === 1 || tmpObj.accountTypeNumber === 9) && tmpObj.accountNumber === accountNumber) {
              if (tmpObj.accountNumber === accountNumber) {
                // Wireless accounts only -> tmpObj.accountTypeNumber == 1
                if(myrAccountListService.isOcp == "directLanding" && (tmpObj.accountStatus == "Suspended" || tmpObj.accountTypeNumber !=21 )){
                  myrAccountListService.isOcp="";
                  myrAccountListService.isOcpCheck = "";
                  appState.switchView("accountOverview");
                }
                $scope.wirelessAccounts.push(tmpObj);
              }
            }


            for (var i = 0; i < _tmp.total; i++) {
              var tmp = {};
              tmp = _tmp.accountList[i];
              _tmp.accountList[i].accountStatusSimple = myrAccountListService.getAccountStatus(tmp).accountStatusSimple;
              _tmp.accountList[i].nickName = _tmp.accountList[i].nickname;
              _tmp.accountList[i].displayName = _tmp.accountList[i].nickName ? _tmp.accountList[i].nickName : _tmp.accountList[i].accountNumber;
              _tmp.accountList[i].comboDisplay = (_tmp.accountList[i].nickName || _tmp.accountList[i].nickName) ? (_tmp.accountList[i].nickName || _tmp.accountList[i].nickName) + ' - ' + _tmp.accountList[i].accountNumber : _tmp.accountList[i].accountNumber;
              _tmp.accountList[i].accNo = _tmp.accountList[i].accountNumber;
            }

            //display the linked success banner for the very first account
            myrAccountListService.accountTypes = _tmp.accountList;

            myrAccountListService.updateSelectedAccountByAccountNumber(accountNumber);

            if ($scope.wirelessAccounts.length > 0) {
              $scope.selectedAccount = $scope.wirelessAccounts[0];

              // Proceed with loading of all details for the subaccounts
              $scope.getAccountListDetails($scope.wirelessAccounts, userLanguage());
              if(myrAccountListService.isOcp == "directLanding"){
                $location.search('directLanding', null);
                if ($rootScope.accountListLength == 1) {
                  $state.go("accountInitialization");
                }else{
                  myrAccountListService.isOcp="";
                  myrAccountListService.isOcpCheck = "";

                }
              }
              if(!myrAccountBalanceService.accountBalance.nextBillDate){

                getBalanceDetails();

              }
            } else {
              // Redirect to link accounts?
              if(myrAccountListService.isOcp == "directLanding"){
              			  myrAccountListService.isWireless = "true";
              				if ($rootScope.accountListLength == 1) {
                          $state.go("accountInitialization");
                      } else {
                          myrAccountListService.isWireless = "true";
                      }
              }else{
              			   //appState.switchView('linkaccount');
              			   signinService.mbhUrlConfig().then(function(urlResponse){
                           $window.location.href = urlResponse.dashboard+"?openLinkAcctModal=true";
                     });
              }

              // console.log ('wireless.getAccountList -> No Wireless account linked!!!');
              // throw new Error('wireless.getAccountList -> No Wireless account linked!!!');
            }

          } else if (_tmp.result === 'redirect') {
            appState.switchView('guestoverview');

          } else if (_tmp.result === 'fail') {
            //holder = _tmp.data;
            $scope.loadingDataIndicator = false;
            scrollPageToTop();					// jshint ignore:line

            //$scope.errorMessage = 'Failed to load account list';
            $scope.errorMessageKey = 'error_wireless_usage';
            $scope.errorMessage = resource.get('error_wireless_usage');

          } else if (_tmp.result === 'error') {
            // holder = _tmp.data;
            $scope.loadingDataIndicator = false;
            scrollPageToTop();					// jshint ignore:line

            //$scope.errorMessage = _tmp.message;
            $scope.errorMessageKey = 'error_wireless_usage';
            $scope.errorMessage = resource.get('error_wireless_usage');

          } else {
            // Unknown state ???
            $scope.loadingDataIndicator = false;
            scrollPageToTop();					// jshint ignore:line
          }

        });
      },
      getAccountListDetails: function (accArray, language) {
        //	shotgun load all subaccounts and keep track of it
        var request;
        var tmpObj;

        for (var i in accArray) {
          tmpObj = accArray[i];
          if (typeof tmpObj === 'object') {
            request = {};
            request.accountNumber = tmpObj.accountNumber;
            request.accountTypeNumber = tmpObj.accountTypeNumber;
            request.language = language;
            request.applicationId = 'SMB';

            // with other items in the call
            try {
              request.pinNumber = tmpObj.pinNumber;
            } catch (e) {
            }
            try {
              request.phoneNumber = tmpObj.phoneNumber;
            } catch (e) {
            }

            $scope.threadsOpen++;												// Event counter
            myrAccountOverviewService.resetCallingAccountDetails();
            myrAccountOverviewService.getAccountDetails(request, $scope.getAccountListPairing);
          }
        }
      },
      getAccountListPairing: function (_tmp) {
        var holder;

        if (_tmp.result === 'success') {
          // push result object to raw data object
          $scope.wirelessAccountsPhones.push(_tmp.data);

          $scope.threadsOpen--;
          if ($scope.threadsOpen === 0) {
            // Done with all shotgun loads - proceed to array simplification
            $scope.getAccountListSimple($scope.wirelessAccountsPhones);
          }
          /*

           // keep next billing date handy
           var stringSplit = myrAccountBalanceService.accountBalance ? myrAccountBalanceService.accountBalance.nextBillDate : '';		//"Feb-01-15"

           // to use it in the proration dialog
           localStorage.setLocalStorageValue('nextBillDate', stringSplit);

           if (stringSplit) {
           var stringArray = stringSplit.split('-');

           var months = {
           'Jan': 0,
           'Feb': 1,
           'Mar': 2,
           'Apr': 3,
           'May': 4,
           'Jun': 5,
           'Jul': 6,
           'Aug': 7,
           'Sep': 8,
           'Oct': 9,
           'Nov': 10,
           'Dec': 11
           };

           var dueMonth = months[stringArray[0]];
           var dueDay = parseInt(stringArray[1]);
           var dueYear = parseInt(stringArray[2]) + 2000;

           $scope.nextBillDate = new Date(dueYear, dueMonth, dueDay, 0, 0, 0, 0);

           var currectDate = new Date();
           $scope.nextbilldaysuntil = ' ' + Math.floor(($scope.nextBillDate - currectDate) / 86400000);
           } else {
           $scope.nextBillDate = 'N/A';
           $scope.nextbilldaysuntil = 'N/A';
           }
           */

        } else if (_tmp.result === 'fail') {
          var holderDetailsFail = _tmp.data;
          holder = _tmp.data;
          //$scope.errorMessage = 'Failed to load account detail';
          $scope.errorMessageKey = 'error_wireless_usage';
          $scope.errorMessage = resource.get('error_wireless_usage');

        } else if (_tmp.result === 'error') {
          // This error comes from account overview - IT IS NOT SAME format as local error messages
          holder = _tmp.data;
          //$scope.errorMessage = holder.originalError;
          $scope.errorMessageKey = 'error_wireless_usage';
          $scope.errorMessage = resource.get('error_wireless_usage');

        } else {
          // Unknown state ???
        }
      },
      getAccountListSimple: function (_full) {
        var tmpObj, tmpObjA, tmpObjB;
        var tmpArray = [], tmpCompanionArray =[];
        var ban = null;
        var ctn = null;
        var subscriberName = null;
        var _length = _full.length;
        $scope.wirelessDashData = [];
          var mismatchPhoneNumber = true;

        //for (var i in _full) {
        for (var i = 0; i < _length; i++) {
          tmpObj = _full[i];
          if (typeof tmpObj === 'object') {
            // Sift through the raw objects and look for phone numbers
            ban = tmpObj.accountNumber;
            for(var k=0; k < tmpObj.getSubscriberInfoResp.subscriberInfo.length; k++){
              if(tmpObj.getSubscriberInfoResp.subscriberInfo[k].subType === "R"){
                tmpCompanionArray.push(tmpObj.getSubscriberInfoResp.subscriberInfo[k]);
              }
            }
            tmpArray = tmpObj.subList;
            if(tmpCompanionArray.length > 0){
              tmpArray = tmpArray.concat(tmpCompanionArray);
            }
            console.log(tmpArray);

            for (var j in tmpArray) {
              tmpObjA = tmpArray[j];
              if (typeof tmpObjA === 'object' && tmpObjA.subType === 'CTN' && tmpObjA.subStatus !== 'Suspended') {
                ctn = tmpObjA.subNumber;
                subscriberName = tmpObjA.subscriberName;

                tmpObjB = {};
                tmpObjB.ban = ban;
                //tmpObjB.ctn = util.updateCTNFormat(ctn);
                tmpObjB.ctn = ctn;
                tmpObjB.subscriberName = subscriberName;

                $scope.wirelessDashData.push(tmpObjB);
              }
              else if (typeof tmpObjA === 'object' && tmpObjA.subType === 'R' && tmpObjA.status !== 'Suspended' && $rootScope.brtEsimSwitch) {
                ctn = tmpObjA.subscriberNumber;
                subscriberName = tmpObjA.userName.firstName + ' ' + tmpObjA.userName.lastName;

                tmpObjB = {};
                tmpObjB.ban = ban;
                //tmpObjB.ctn = util.updateCTNFormat(ctn);
                tmpObjB.ctn = ctn;
                tmpObjB.subType = 'R';
                tmpObjB.subscriberName = subscriberName;
                $scope.wirelessDashData.push(tmpObjB);
              }
              else{
               //DoNothing
              }
            }
          }
        }

        // Make a call to load the wireless dashboard with real data

        var phoneNumber = localStorage.getLocalStorageValue('phoneNumber');
          for (var n = 0; n < $scope.wirelessDashData.length; n++) {
            //ui-router migration


            if (phoneNumber == null || phoneNumber=="")
             {
               localStorage.setLocalStorageValue('phoneNumber', $scope.wirelessDashData[0].ctn);
               var accountInfo = {
                  selectedCTN: localStorage.getLocalStorageValue('phoneNumber')
               };
               dataLayerIntegrationService.setSelectedSubscriberNumber(accountInfo);
               phoneNumber = localStorage.getLocalStorageValue('phoneNumber');
               localStorage.setLocalStorageValue('subscriberName', $scope.wirelessDashData[0].subscriberName);
             }
                  //if ($scope.wirelessDashData[n].ctn === $routeParams.submodule) {
             if ($scope.wirelessDashData[n].ctn === phoneNumber) {

               mismatchPhoneNumber = false;
               localStorage.setLocalStorageValue('phoneNumber', $scope.wirelessDashData[n].ctn);
               var accountInfo = {
                  selectedCTN: localStorage.getLocalStorageValue('phoneNumber')
               };
               dataLayerIntegrationService.setSelectedSubscriberNumber(accountInfo);
               localStorage.setLocalStorageValue('subscriberName', $scope.wirelessDashData[n].subscriberName);
               $scope.wirelessDashActive = $scope.wirelessDashData[n];


             }
            if(mismatchPhoneNumber)
            {

              localStorage.setLocalStorageValue('phoneNumber', $scope.wirelessDashData[0].ctn);
              var accountInfo = {
                 selectedCTN: localStorage.getLocalStorageValue('phoneNumber')
              };
              dataLayerIntegrationService.setSelectedSubscriberNumber(accountInfo);
              localStorage.setLocalStorageValue('subscriberName', $scope.wirelessDashData[0].subscriberName);
              $scope.wirelessDashActive = $scope.wirelessDashData[0];

            }
        }
          $scope.getWirelessDashBoard($scope.wirelessDashActive);
        //Save wirelessDashData to service to be used in wirelessPackage directive
        myrWirelessDashboardService.setWirelessDashData($scope.wirelessDashData);
      },
      getWirelessDashBoard: function (rdata) {
        var holder;
        var request = {};
        request.ban = rdata.ban;
        request.ctn = rdata.ctn;
        if(rdata.subType && rdata.subType === 'R'){
          $scope.companion = true;
        } else {
          $scope.companion = false;
        }
        myrWirelessDashboardService.getWirelessDashBoard(request, function (_tmp) {
          $scope.loadingDataIndicator = false;
          scrollPageToTop();					// jshint ignore:line
					//$scope.billCycleEndDate = uteBillService.convertDate((cycleEndDate.getFullYear()+"-"+(cycleEndDate.getMonth()+1)+"-"+cycleEndDate.getDate()));
          if (_tmp.result === 'success') {

            // Proceed to display
            $scope.wd = _tmp.data;
            $scope.wdEmpty = _tmp.empty;
            $scope.wdMidCycle = _tmp.midCycle;
            $scope.wdMCPPCrerating = _tmp.MCPPCrerating;
            $scope.dataEmpty = false;
            $scope.textEmpty = false;
            $scope.talkEmpty = false;
            if(_tmp.data.dataArr.length < 1){
              $scope.dataEmpty = true;
            }
            if(_tmp.data.smsArr.length < 1){
              $scope.textEmpty = true;
            }
            if(_tmp.data.talkArr.length < 1){
              $scope.talkEmpty = true;
            }
            $scope.displayWirelessDashBoardDelay(_tmp.data, _tmp.empty, _tmp.midCycle, _tmp.MCPPCrerating);		// If any more variables need to come through -> make params into an object

          } else if (_tmp.result === 'fail') {
            holder = _tmp.data;

            $scope.errorMessageKey = 'error_wireless_package_device';
            $scope.errorMessage = resource.get('error_wireless_package_device');

          } else if (_tmp.result === 'error') {
            // holder = _tmp.data;
            if (_tmp.data && _tmp.data.error && _tmp.data.error.errorCode && (_tmp.data.error.errorCode == 10013)) {
              var getCurrentBillCycleEndDate;
              if (myrAccountBalanceService.accountBalance && myrAccountBalanceService.accountBalance.currentBillCycleEndDate) {
                getCurrentBillCycleEndDate = myrAccountBalanceService.accountBalance.currentBillCycleEndDate.split('-');
                // getCurrentBillCycleEndDate[2] - year, getCurrentBillCycleEndDate[0] - month, getCurrentBillCycleEndDate[1] - day
                var currentBillCycleEndDateObj = new Date(getCurrentBillCycleEndDate[2], getCurrentBillCycleEndDate[0]-1, getCurrentBillCycleEndDate[1]);
                var _months = resource.get('_months');
                var month = _months[currentBillCycleEndDateObj.getMonth()];
                var capitalizeMonth = month.charAt(0).toUpperCase() + month.slice(1);
                if (userLanguage() === 'en') {
                  $scope.currentBillCycleEndDate = (capitalizeMonth + ' ' + currentBillCycleEndDateObj.getDate() + ', ' + currentBillCycleEndDateObj.getFullYear());
                } else {
                  $scope.currentBillCycleEndDate = (currentBillCycleEndDateObj.getDate() + ' ' + capitalizeMonth + ' ' + currentBillCycleEndDateObj.getFullYear());
                }
              }
              $scope.errorMessageKey = ('MCPPC_Proration_error' + ' ' + $scope.currentBillCycleEndDate);
              $scope.errorMessage = (resource.get('MCPPC_Proration_error') + ' ' + $scope.currentBillCycleEndDate);
            } else {
              $scope.errorMessageKey = 'error_wireless_package_device';
              $scope.errorMessage = resource.get('error_wireless_package_device');
            }
          } else {
            // Unknown state ???
          }
          $scope.invokeFloatingChat();
        });
      },
      defineLabels: function () {
        //115
        $scope.remainingLbl = resource.get('wireless_remaining');
        $scope.textsLbl = resource.get('wireless_texts');
      },
      /*
       * Data process and display
       */

      displayWirelessDashBoardDelay: function (allData, allEmpty, allMidCycle, allMCPPCrerating) {
        setTimeout(function () {
          $scope.displayWirelessDashBoard(allData, allEmpty, allMidCycle, allMCPPCrerating);
        }, 100);
        //  $scope.displayWirelessDashBoard(allData);
      },
      displayWirelessDashBoard: function (allData, allEmpty, allMidCycle, allMCPPCrerating) {
        // Display main blocks
        // Need to show a different word when usage is plural in Fr (restant vs restants)
        var isGlobalDataDisplayRemainPlural = function (value) {
          var amountThatIsMoreThanOneGB = 1053818,
            amountThatIsConsideredOneGB = 1048576,
            amountThatIsConsideredOneMB = 1535;
          if (value > amountThatIsMoreThanOneGB ||
            value < amountThatIsConsideredOneGB &&
            value > amountThatIsConsideredOneMB) {
            return true;
          }
          return false;
        };
        // Need to show a different word when minutes are plural in Fr (restant vs restants)
        var isGlobalTalkDisplayRemainPlural = function (value) {
          return value > 1 ? true : false;
        };
        $scope.wd = allData;

        $scope.wdEmpty = allEmpty;
        $scope.wdMidCycle = allMidCycle;
        $scope.wdMCPPCrerating = allMCPPCrerating;

        // Process the highest percentage and select proper color as result decide to show in template (show =  true / false)
        var showData = myrWirelessDashboardService.globalDataSets(allData.data, 'data');
        $scope.showData = showData;

        var showRoaming = myrWirelessDashboardService.globalDataSets(allData.roaming, 'roaming');
        //$scope.showRoaming = showRoaming;
        $scope.showRoaming = false;				// Section shutdown on 2015-04-14 11:48am
        $scope.showRoamingComingSoon = showRoaming;
        $scope.showRoamingComingSoonUrl = resource.get('wireless_roaming_details_coming_soon_chat_with_us_url');

        var showSms = myrWirelessDashboardService.globalDataSets(allData.sms, 'sms');
        $scope.showSms = showSms;

        var showTalk = myrWirelessDashboardService.globalDataSets(allData.talk, 'talk');
        $scope.showTalk = showTalk;

        // Show collapsed
        $('.colDataWrap').removeClass('in');

        // Hide loading icon
        $scope.displayContent = true;
        $scope.loadingDataIndicator = false;
        scrollPageToTop();					// jshint ignore:line
        $scope.globalDataDisplayRemainPlural = isGlobalDataDisplayRemainPlural($scope.wd.data.globalDisplayRemain);
        $scope.globalTalkDisplayRemainPlural = isGlobalTalkDisplayRemainPlural($scope.wd.talk.globalDisplayRemain);
        // refresh the scope DOM
        $scope.$apply();
      },
      onClickViewMyWirelessTalkUsage: function () {
        appState.tagging(['_trackPageView', {pn: 'wireless_viewtalk_viewtalk'}]);
      },
      onClickViewMyWirelessDataUsage: function () {
        appState.tagging(['_trackPageView', {pn: 'wireless_viewdata_viewdata'}]);
      },
      onClickViewMyWirelessTextUsage: function () {
        /*appState.tagging(['_trackPageView',
         {pn: 'home:myrogers:wireless:manage-my-plan:text'}, // Page Name
         {eVar14: 'MyRogers - view my messaging usage'},
         {event10: ''}]
         );*/
      }
    });

    $scope.changeAccount = function () {

      //$scope.wirelessDashActive = account;

      // Load JSON with account overview details
      myrWirelessDashboardService.clearWirelessDashBoard();					// Clean old set

      // notify wirelessPackage.js directive that loader icons need to show up
      $scope.wpkg_loadingDataIndicatorPackage = true; // jshint ignore:line
      $scope.wpkg_loadingDataIndicatorDevice = true; // jshint ignore:line

      $scope.wpkg_displayContentPackage = false;  // jshint ignore:line
      $scope.wpkg_displayContentDevice = false; // jshint ignore:line

      // Update local storage
      localStorage.setLocalStorageValue('phoneNumber', $scope.wirelessDashActive.ctn);
      localStorage.setLocalStorageValue('subscriberName', $scope.wirelessDashActive.subscriberName);
      localStorage.setLocalStorageValue('ban', $scope.wirelessDashActive.ban);

      // reset all initial variables
      $scope.pageVariablesInit(false);

      // re-render tha page
      // $scope.getWirelessDashBoard($scope.wirelessDashActive);
      $scope.getAccountList();
      //$scope.getTravelPackage({ban: $scope.wirelessDashActive.ban, ctn: $scope.wirelessDashActive.ctn});

      scrollPageToTop();					// jshint ignore:line
    };

    $scope.openTalkTextPopup = function () {
        $rootScope.modalInstance = $modal.open({
        templateUrl: "scripts/modules/wirelessDashboard/talkAndTextPopup.html",
        controller: "MyrWirelessDashboardController",
        windowClass: "talk-text-popup"
      });
    };

    $scope.close = function () {
      $rootScope.modalInstance.close();
    };

   //$rootScope.$watch('submenuWirelessNumber', function() {
    //  if ($rootScope.submenuWirelessNumber) {
    //    var obj = {
    //      ctn: $rootScope.submenuWirelessNumber,
    //      ban: localStorage.getLocalStorageValue('accountNumber')
    //    }
    //    $scope.wirelessDashActive = obj;
    //    //$scope.changeAccount();
    //  }
    //});

    /*
     Data load
     1) get account list
     2) get account details data - Load details for each wireless account to obtain phone number
     3) get wireless dashboard dagetta based on account number and acocunt details
     4) load manage my phone data

     Load chain:  getAccountList  >  getAccountListDetails  >  getAccountListPairing  >  getAccountListSimple  >  getWirelessDashBoard
     Data processing and display functions: displayWirelessDashBoard
     //*/

    //$scope.postToRogers(0);

    // Run it
    $scope.pageVariablesInit(true);			// THIS HAS TO RUN AT THE BEGINNING!!! default state of all that happens in this page
    //$scope.getAccountList();


    function getBalanceDetails() {

      var acctDetails = myrAccountListService.selectedAccount;

      var request = {
        accountNumber: acctDetails.accountNumber,
        accountTypeNumber: acctDetails.accountTypeNumber,
        pinNumber: acctDetails.pinNumber,
        phoneNumber: acctDetails.phoneNumber,
        language: userLanguage(),
        refresh: false,
        indx: acctDetails.selectedAccountIndex,
        applicationId: 'Rogers.com'
      };

      myrAccountBalanceService.getBalanceDetails(request,function(_tmp){
      });

    }

    brtCheck.dataManagerMigration();

    resource.onChanged(function () {
      $scope.lng = userLanguage();
      $scope.errorMessage = resource.get($scope.errorMessageKey);
      $scope.showRoamingComingSoonUrl = resource.get('wireless_roaming_details_coming_soon_chat_with_us_url');

      $scope.defineLabels();

      var stateName = localStorage.getLocalStorageValue('toStateName');
      if (stateName === 'wireless') {
        // Re-load the data
        $scope.pageVariablesInit(false);
        $scope.getAccountList();
        //$scope.getTravelPackage({ban: $scope.ban, ctn: $scope.ctn});
      }
    }, $scope);

    brtCheck.brtPermissionContributedData().then(
      function (response) {
        if (response) {
          myrWirelessDashboardService.getContributedData([$scope.ban],$scope.ctn).then(function (contributedData) {
            $scope.contributedData = contributedData;
          });
        }
      },
      function (errorResponse) {}
    );

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').service('myrWirelessDashboardService', wirelessDashboardService);

  wirelessDashboardService.$inject = ['ajax', 'resource', 'userLanguage', 'localStorage', '$rootScope', '$window', '$q', '$http'];

  /* @ngInject */
  function wirelessDashboardService(ajax, resource, userLanguage, localStorage, $rootScope, $window, $q, $http) {

    // Private data
    var _dashboardDataRaw = null;
    var _dashboardData = null;

    // Post-paid
    var _dashboardPostpaidData = null;

    // Pre-paid
    var _dashboardPrepaidData = null;

    // Travel Package data
    var _dashboardTravelPackageData = null;

    var limitLow = 100; // 75
    var limitHigh = 10000; // 100
    //MCPPC
    var isMCPPCrerating = false;
    var wirelessDashData = null;
    // Check for objects
    function wirelessServiceObjectPush(master, tmpObj, groupType) {
      var myCount = 0;

      if (typeof tmpObj === 'object') {
        // Look through the data and pluck specific data from usageSummary array.
        if (tmpObj.usageSummary.length > 0) {
          for (var u = (tmpObj.usageSummary.length - 1); u >= 0; u--) {
            if (typeof tmpObj.usageSummary[u] === 'object') {
              // this usage set IS and EXTRA and there is no usage meaning that user has ZERO use
              if (tmpObj.usageSummary[u].total === 0 && tmpObj.usageSummary[u].othersUsage === 0 && tmpObj.usageSummary[u].subscriberUsage === 0 && tmpObj.usageSummary[u].used === 0) {
                // extra  ->  total = 0, othersUsage = 0, subscriberUsage = 0, used = 0
                tmpObj.usageSummary.splice(u, 1);
              }
            }
          }
        }

        // Push usages into next set that assesses the data and further decorates them.
        if (tmpObj.usageSummary.length > 0) {
          tmpObj = wirelessServiceAddData(tmpObj, groupType);
          master.push(tmpObj);

        }

        // handle - status code 127 (now 10013) exception - MCPPC
        if (parseInt(tmpObj.statusCode) === 10013) {
          myCount = -1000;
          isMCPPCrerating = true;
        } else if (parseInt(tmpObj.statusCode) === 10012) {
          myCount = -1000;
        } else {
          myCount = tmpObj.usageSummary.length; // pass this back for proper plan counter
        }
      }

      return myCount;
    }

    // Process and andd some data into the object
    function wirelessServiceAddData(tmpObj, groupType) {
      var locSet = tmpObj.usageSummary;
      var highestPercentage = 0;
      var highestColor = '';
      var displayTotal = 0;
      var displayUsed = 0;
      var displayRemain = 0;
      var onlyExtras = true;
      var haveExtras = false;
      var overExtras = false;

      var collect = true;
      var collectType = '';
      var collectIndex = -1;

      for (var i in locSet) {
        var subSet = locSet[i];

        if (typeof subSet === 'object') {

          // unlimited / pay-per-use / limited Definitions
          var locTotal = parseFloat(subSet.total);
          var locUNLflag = subSet.isUsageUnlimited;

          // Tag all sets with parent data sumary type
          subSet.usageSummaryType = tmpObj.usageSummaryType;

          if (locTotal < 0 || (locTotal > 90000 && groupType !== 'data') || (locTotal > 90000000000 && groupType === 'data') || locUNLflag) {
            //		unlimited -> subSet.total < 0
            subSet.usageType = 'unlimited';
            subSet.total = 0;
            subSet.percentage = 0;
            subSet.overExtra = false;
            subSet.usageColor = 'usageNormal';

            // no plan but extras only
            onlyExtras = false;

            // Collect data for dial/meter
            if ((collectType === '' || collectType === 'pay-per-use') && collect) {
              collectType = subSet.usageType;
              collectIndex = i;
            }

          } else if (locTotal === 0) {
            //		pay-per-use -> subSet.total = 0
            subSet.usageType = 'pay-per-use';
            subSet.total = 0;
            subSet.percentage = 100;
            subSet.overExtra = false;
            subSet.usageColor = 'usageWarning'; // 'usageOver'

            // Show dial/meter flag
            haveExtras = true;

            // Collect data for dial/meter
            if (collectType === '') {
              collectType = subSet.usageType;
              collectIndex = i;
            }

          } else if (locTotal > 0) {
            //			limited -> subSet.total > 0
            subSet.usageType = 'limited';

            // no plan but extras only
            onlyExtras = false;

            // Calculate percentages and if usage is
            var percentageTemp = (parseFloat(subSet.used) / parseFloat(subSet.total)) * 100;
            subSet.percentage = Math.ceil(percentageTemp);

            // Color definition
            if (subSet.percentage <= limitLow) {
              subSet.overExtra = false;
              subSet.usageColor = 'usageNormal';
            } else if ((subSet.percentage > limitLow && subSet.percentage <= limitHigh) || (subSet.percentage > limitLow)) {
              //  limits were pushed from 75/100 to 100/1000 and this logic was simply not working properly.
              //									subSet.overExtra = false;
              //									subSet.usageColor = 'usageWarning';
              //								} else if (subSet.percentage > limitLow) {
              //									// subSet.usageColor = 'usageOver';
              subSet.overExtra = true;
              overExtras = true;
              subSet.usageColor = 'usageWarning';
              subSet.percentage = 100;
            }

            // Collect data for dial/meter
            if ((collectType === '' || collectType === 'pay-per-use') && collect) {
              collect = false;
              collectType = subSet.usageType;
              collectIndex = i;
            }

          } else {
            // This should not happen!!! EVER!!!
            throw new Error('wireless.wirelessServiceAddData - Critical fail!!');
          }

          if (parseFloat(subSet.remaining) <= 0) {
            subSet.remaining = 0;
          }

          // Push it back
          locSet[i] = subSet;
        }
      }

      // Logic overide from colective decision on plan structure to pick the first one and use that as dial / tongue
      // collectIndex = 0;		// pick the first item on the list to match dial/tongue with first item on the list

      // data set has ONLY extras or it is mix of Extras and plans
      if (onlyExtras) {
        // Display orange tongue with extras sign
        displayTotal = 0;
        displayUsed = 0;
        displayRemain = 0;
        highestColor = 'usageWarning';
        highestPercentage = 0;

        collectIndex = 0; // pick the first item on the list to match dial/tongue with first item on the list
      } else {
        // Decide what color and numbers go to the dial at the top
        if (collectIndex >= 0) {
          // limited or pay-per-use
          displayTotal = locSet[collectIndex].total;
          displayUsed = locSet[collectIndex].used;
          displayRemain = locSet[collectIndex].remaining;
          highestColor = locSet[collectIndex].usageColor;
          highestPercentage = locSet[collectIndex].percentage;

        } else {
          // unlimited
          displayTotal = 0;
          displayUsed = 0;
          displayRemain = 0;
          highestColor = 'usageNormal';
          highestPercentage = 0;

          collectIndex = 0; // pick the first item on the list to match dial/tongue with first item on the list
        }
      }

      // Safety measure to make sure that collectIndex is never negative after this point.
      // Since unable to verify this issue on multiple servers this needs to be tested very carefuly
      if (collectIndex < 0) {
        collectIndex = 0;
      }

      // Hand-off to level up object
      tmpObj.displayTotal = displayTotal;
      tmpObj.displayUsed = displayUsed;
      tmpObj.displayRemain = displayRemain;
      tmpObj.highestPercentage = highestPercentage;
      tmpObj.highestColor = highestColor;
      tmpObj.usageSummary = locSet;

      tmpObj.onlyExtras = onlyExtras;
      tmpObj.haveExtras = haveExtras;
      tmpObj.overExtras = overExtras;

      // Default display type ( normal = round dial at the top / unlimited = no dial, only name and open link )
      tmpObj.unlimitedShow = false;
      tmpObj.unlimitedClass = 'normal';

      // Only if all plans within are unlimited -> switch display type to unlimited
      if (groupType === 'roaming' || onlyExtras) {
        tmpObj.unlimitedShow = true;
        tmpObj.unlimitedClass = 'unlimited';

      } else {
        if (locSet[collectIndex].usageType === 'unlimited') {
          tmpObj.unlimitedShow = true;
          tmpObj.unlimitedClass = 'unlimited';
        }
      }

      return tmpObj;
    }

    // Add more data into the large data objects - Total usage, color codes, calculate leftovers
    function wirelessServiceGlobalDataSets(masterSet, groupType) {
      var globalDisplayTotal = 0;
      var globalDisplayUsed = 0;
      var globalDisplayRemain = 0;
      var globalPercentage = 0;
      var globalColor = '';

      var globalOnlyExtras = true;
      var globalHaveExtras = false;
      var globalOverExtras = false;

      var globalUnlimitedShow = false;
      var globalUnlimitedClass = 'normal';
      //					var globalNotice = '';

      var returnValue = false;
      if (masterSet.length > 0) {
        // Display yes
        returnValue = true;
      } else {
        // Display no
        returnValue = false;
      }

      // Process data
      if (returnValue) {
        // Look through all sets and collect flags that span across entire set
        var sumHaveExtras = false;
        var sumOnlyExtras = true;
        var sumOverExtras = false;

        for (var i = 0; i < masterSet.length; i++) {
          var subSet = masterSet[i];

          if (subSet.haveExtras === true) {
            sumHaveExtras = true;
          }
          if (subSet.onlyExtras === false) {
            sumOnlyExtras = false;
          }
          if (subSet.overExtras === true) {
            sumOverExtras = true;
          }
        }

        // Decide which to select - pick the first set of data - as it is assumed that it has the highest priority
        var largeSet = null;
        if (sumOnlyExtras === true) {
          // Pick the first one
          largeSet = masterSet[0];
        } else {
          if (sumHaveExtras === true) {
            // Find first index that is not pay-per-use
            var outIndex = 0;

            for (var j = 0; j < masterSet.length; j++) {
              var tempSet = masterSet[j];

              if (tempSet.onlyExtras === false) {
                outIndex = j;
                break;
              }
            }

            largeSet = masterSet[outIndex];
          } else {
            // no extras -> pick the first one
            largeSet = masterSet[0];
          }
        }

        // Show the extras badge if there one or more plans has over-usage
        if (sumOverExtras === true) {
          // do something with this information
          sumHaveExtras = true; // should user have over usage - it will show as extra badge
        }

        if (typeof largeSet === 'object') {

          // This would be a great place to add more logic if required
          globalDisplayTotal = largeSet.displayTotal;
          globalDisplayUsed = largeSet.displayUsed;
          globalDisplayRemain = largeSet.displayRemain;
          globalPercentage = largeSet.highestPercentage;
          globalColor = largeSet.highestColor;

          globalOnlyExtras = sumOnlyExtras;
          globalHaveExtras = sumHaveExtras;
          globalOverExtras = sumOverExtras;

          globalUnlimitedShow = largeSet.unlimitedShow;
          globalUnlimitedClass = largeSet.unlimitedClass;

          // Color definition
          //							if (globalPercentage < limitLow) {
          //								globalNotice = 'Looking good';
          //							} else if (globalPercentage >= limitLow && globalPercentage < limitHigh) {
          //								globalNotice = 'Check it out';
          //							} else if (globalPercentage >= limitHigh) {
          //								globalNotice = 'Extra Usage';
          //							}
        }

        // Add data to master set
        masterSet.globalDisplayTotal = globalDisplayTotal;
        masterSet.globalDisplayUsed = globalDisplayUsed;
        masterSet.globalDisplayRemain = globalDisplayRemain;
        masterSet.globalPercentage = globalPercentage;
        masterSet.globalColor = globalColor;

        masterSet.globalOnlyExtras = globalOnlyExtras;
        masterSet.globalHaveExtras = globalHaveExtras;
        masterSet.globalOverExtras = globalOverExtras;

        masterSet.unlimitedShow = globalUnlimitedShow;
        masterSet.unlimitedClass = globalUnlimitedClass;
        //						masterSet.globalNotice = globalNotice;
      }

      return returnValue;
    }

    function wirelessServiceSeparateUsage(masterSet, groupType, countChk) {
      var newMasterSet = {};
      newMasterSet.plans = [];
      newMasterSet.sumary = {};
      newMasterSet.extras = [];
      var newMasterArray = [];

      // split data by type plan (regular/unlimited) and extras
      for (var j in masterSet) {
        var tmpObj = masterSet[j];

        for (var u in tmpObj.usageSummary) {
          var tmpItem = tmpObj.usageSummary[u];

          if (typeof tmpItem === 'object') {
            if (tmpItem.usageType === 'pay-per-use') {
              newMasterSet.extras.push(tmpItem);
            } else {
              newMasterSet.plans.push(tmpItem);
            }
          }
        }
      }

      // collect all extras headlines and total values
      if (newMasterSet.extras.length > 0) {
        newMasterSet.sumary.usageType = 'extras_summary';
        newMasterSet.sumary.usageSets = [];

        for (var b = 0; b < newMasterSet.extras.length; b++) {
          var tmpArr = newMasterSet.extras[b];

          // header replace "/" with " / " for better breaking purposes
          var sourceHead = tmpArr.periodGroup;
          var cleanHeadline = sourceHead.replace('/', ' / ');

          var stuffObj = {};
          stuffObj.othersUsage = tmpArr.othersUsage;
          stuffObj.overage = tmpArr.overage;
          stuffObj.periodGroup = cleanHeadline;
          stuffObj.remaining = tmpArr.remaining;
          stuffObj.subscriberUsage = tmpArr.subscriberUsage;
          stuffObj.total = tmpArr.total;
          stuffObj.used = tmpArr.used;
          stuffObj.usageSummaryType = tmpArr.usageSummaryType;

          newMasterSet.sumary.usageSets.push(stuffObj);
        }
      }

      // re-assable the data into new array in this order - Plans > extras summary > extras
      if (newMasterSet.plans.length > 0) {
        for (var t = 0; t < newMasterSet.plans.length; t++) {
          var aaArr = newMasterSet.plans[t];
          newMasterArray.push(aaArr);
        }
      }
      if (newMasterSet.extras.length > 0) {
        // sumary
        newMasterArray.push(newMasterSet.sumary);

        // extras
        for (var e = 0; e < newMasterSet.extras.length; e++) {
          var ccArr = newMasterSet.extras[e];

          if (groupType === 'roaming') {
            // roamig data are always cinsidered an extras
            newMasterArray.push(ccArr);
          } else {
            // extras for all other plans after collecting sumary is pointless -> don't push to display pipe
            // newMasterArray.push(ccArr);
          }
        }

        // roaming data also need to be separated into type buckets - data voice text

      }

      return newMasterArray;
    }

    function constructMServicesUrl(url) {
      var requestUrl = '';
      if (url.indexOf('http') === 0) {
        requestUrl = url;
      } else {
        requestUrl = '/web/smb' + url;
      }
      return requestUrl;
    }

    function fetchAccountRef(tokenData) {
      var deferred = $q.defer();
      $http.get('/web/smb/web/genesis/api/usage/v3/customer/accounts', {
        headers: {
          'x-info-token': tokenData.jwtToken,
          'brand': 'rogers',
          'x-app-id': 'UTESMBOnline'

        }
      }).then(
        function (response) {
          var accountRef = _.result(_.find(response.data, function (account) {
            return account.accountNumber === tokenData.ban;
          }), 'links');
          var linkRef = _.result(_.find(accountRef, function (link) {
            return link.rel.toLowerCase() === 'self';
          }), 'href');
          if (linkRef) {
            deferred.resolve({
              linkReference: linkRef,
              jwtToken: tokenData.jwtToken,
              ctn: tokenData.ctn
            });
          } else {
            deferred.reject();
          }
        },
        function () {
          deferred.reject();
        }
      )
      return deferred.promise;
    }

    function fetchServiceRef(fetchAccountResponse) {
      var deferred = $q.defer();
      var requestUrl = constructMServicesUrl(fetchAccountResponse.linkReference);

      $http.get(requestUrl, {
        headers: {
          'x-info-token': fetchAccountResponse.jwtToken,
          'brand': 'rogers',
          'x-app-id': 'UTESMBOnline'
        }
      }).then(
        function (response) {
          var servicesRef = _.result(_.find(response.data.services, function (services) {
            return services.category.toLowerCase() === 'wireless' && (services.type.toLowerCase() === 'share everything' || services.type.toLowerCase() === 'non-shared');
          }), 'links');

          var linkRef1 = _.result(_.find(servicesRef, function (link) {
            return link.rel.toLowerCase() === 'self';
          }), 'href');
          if (linkRef1) {
            deferred.resolve({
              linkReference: linkRef1,
              jwtToken: fetchAccountResponse.jwtToken,
              ctn: fetchAccountResponse.ctn
            });
          } else {
            deferred.reject();
          }
        },
        function () {
          deferred.reject();
        }
      )
      return deferred.promise;
    }

    function fetchLineRef(fetchServiceResponse) {
      var deferred = $q.defer();
      var requestUrl = constructMServicesUrl(fetchServiceResponse.linkReference);

      $http.get(requestUrl, {
        headers: {
          'x-info-token': fetchServiceResponse.jwtToken,
          'brand': 'rogers',
          'x-app-id': 'UTESMBOnline'
        }
      }).then(
        function (response) {
          var linkRef = null;
          if (response.data.mainLine.number === fetchServiceResponse.ctn) {
            linkRef = response.data.mainLine.plan.href;
          } else {
            linkRef = _.result(_.find(response.data.lines, function (value) {
              return value.number === fetchServiceResponse.ctn;
            }), 'plan.href');
          }

          if (linkRef) {
            deferred.resolve({
              linkReference: linkRef,
              jwtToken: fetchServiceResponse.jwtToken
            });
          } else {
            deferred.reject();
          }
        },
        function () {
          deferred.reject();
        }
      )
      return deferred.promise;
    }

    function uuidv4() {
              return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0,
                  v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
              })}

    function fetchDataRef(fetchLineResponse) {
      var deferred = $q.defer();
      var requestUrl = constructMServicesUrl(fetchLineResponse.linkReference);
     // var clientId = localStorage.getLocalStorageValue('easClientId');
      var corId = uuidv4();
      $http.get(requestUrl, {
        headers: {
          //'Authorization': 'Bearer ' + fetchLineResponse.jwtToken,
          'client_id': "UTESMBOnline",
          'correlation_id' : corId
        }
      }).then(
        function (response) {
          var dataRef = _.result(_.find(response.data.allowances, function (value) {
            return value.type === "data";
          }), 'size');
          if (dataRef) {
            deferred.resolve(dataRef);
          } else {
            deferred.reject();
          }
        },
        function () {
          deferred.reject();
        }
      )
      return deferred.promise;
    }

    return {
      postpaidDetails: null,
      // Usage data handling
      getWirelessDashBoard: function (request, callback) {
        request.language = userLanguage().toUpperCase();

        // ALWAYS load fresh JSON
        var _return = {};
        _dashboardDataRaw = null;

        ajax.wirelessDashBoard(request).then(
          function (data) {
            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {
              _dashboardDataRaw = data;

              // preset defaults
              _dashboardData = {};
              _dashboardData.data = [];
              _dashboardData.dataArr = [];
              _dashboardData.roaming = [];
              _dashboardData.roamingArr = [];
              _dashboardData.sms = [];
              _dashboardData.smsArr = [];
              _dashboardData.talk = [];
              _dashboardData.talkArr = [];

              var dataCounter = {};
              dataCounter.data = 0;
              dataCounter.roaming = 0;
              dataCounter.sms = 0;
              dataCounter.talk = 0;

              // Filter out objects that have no usage information
              var tmpObj = {};
              var i, j, k, l;
              var setCounter = 0;

              if (_dashboardDataRaw.data) {
                // Data
                for (i in _dashboardDataRaw.data) {
                  tmpObj = _dashboardDataRaw.data[i];
                  var dadat = wirelessServiceObjectPush(_dashboardData.data, tmpObj, 'data');
                  dataCounter.data += dadat;
                  setCounter += dadat;
                }
                if (dataCounter.data > 0) {
                  _dashboardData.dataArr = wirelessServiceSeparateUsage(_dashboardData.data, 'data', dataCounter.data);
                }
              }

              if (_dashboardDataRaw.roaming) {
                // Roamiong
                for (j in _dashboardDataRaw.roaming) {
                  tmpObj = _dashboardDataRaw.roaming[j];
                  var darom = wirelessServiceObjectPush(_dashboardData.roaming, tmpObj, 'roaming');
                  dataCounter.roaming += darom;
                  setCounter += darom;
                }
                if (dataCounter.roaming > 0) {
                  _dashboardData.roamingArr = wirelessServiceSeparateUsage(_dashboardData.roaming, 'roaming', dataCounter.roaming);
                }
              }

              if (_dashboardDataRaw.sms) {
                // SMS
                for (k in _dashboardDataRaw.sms) {
                  tmpObj = _dashboardDataRaw.sms[k];
                  var dasms = wirelessServiceObjectPush(_dashboardData.sms, tmpObj, 'sms');
                  dataCounter.sms += dasms;
                  setCounter += dasms;
                }
                if (dataCounter.sms > 0) {
                  _dashboardData.smsArr = wirelessServiceSeparateUsage(_dashboardData.sms, 'sms', dataCounter.sms);
                }
              }

              if (_dashboardDataRaw.talk) {
                // Talk
                for (l in _dashboardDataRaw.talk) {
                  tmpObj = _dashboardDataRaw.talk[l];
                  var datal = wirelessServiceObjectPush(_dashboardData.talk, tmpObj, 'talk');
                  dataCounter.talk += datal;
                  setCounter += datal;
                }
                if (dataCounter.talk > 0) {
                  _dashboardData.talkArr = wirelessServiceSeparateUsage(_dashboardData.talk, 'talk', dataCounter.talk);
                }
              }

              if (setCounter < 0 && isMCPPCrerating) {
                // statusCode: "127" exeption - MCPPC
                _return.MCPPCrerating = true;
                _return.midCycle = false;
                _return.empty = false;
              } else if (setCounter < 0) {
                // statusCode: "103" exeption
                _return.MCPPCrerating = false;
                _return.midCycle = true;
                _return.empty = false;

              } else if (setCounter === 0) {
                _return.MCPPCrerating = false;
                _return.midCycle = false;
                _return.empty = true;
              } else {
                _return.MCPPCrerating = false;
                _return.midCycle = false;
                _return.empty = false;
              }
              // To be removed soon
              // TOT-2631 HACK BEGIN
              for (var ia = 0; ia < data.talk.length; ia++) {
                if (data.talk[ia].statusCode && data.talk[ia].statusCode === '10012') {
                  _return.MCPPCrerating = false;
                  _return.midCycle = true;
                  _return.empty = false;
                }
              }
              // TOT-2631 HACK END
              // To be removed soon
              _return.result = 'success';
              _return.data = _dashboardData;
              return callback(_return);

            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              _dashboardData = null;
              _return.result = 'fail';
              _return.data = data;
              _return.empty = true;
              _return.midCycle = false;
              _return.MCPPCrerating = false;
              return callback(_return);
            }
          },
          function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get(error.error.errorCode); // Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get('error_wireless_usage'); // Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          }
        );
      },
      getUsageData: function () {
        return ajax.getUsageData();
      },
      activeWirelessDashBoard: function () {
        if (_dashboardData === null) {
          return false;
        } else {
          return _dashboardData;
        }
      },
      clearWirelessDashBoard: function () {
        // Purge any data
        _dashboardData = null;
        return true;
      },
      globalDataSets: function (masterSet, groupType) {
        var returnCatch = false;
        returnCatch = wirelessServiceGlobalDataSets(masterSet, groupType);
        return returnCatch;
      },
      getWirelessTravelPackage: function (request, callback) {
        var _return = {};
        ajax.wirelessTravelPackage(request).then(
          function (data) {
            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {
              _return.result = 'success';
              _return.data = data;
              return callback(_return);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              //_dashboardTravelPackageData = null;
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          },
          function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get(error.error.errorCode); // Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get('error_wireless_usage'); // Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          }
        );
      },
      getWirelessTravelPackageStaticContent: function (request, callback) {
        var _return = {};
        ajax.wirelessTravelPackageStaticContent(request).then(
          function (data) {
            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {
              _return.result = 'success';
              _return.data = data;
              return callback(_return);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              _dashboardTravelPackageData = null;
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          },
          function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get(error.error.errorCode); // Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get('error_wireless_usage'); // Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          }
        );
      },
      getWirelessTravelPackageAddOnSummary: function (request, callback) {
        var _return = {};
        ajax.wirelessTravelPackageAddOnSummary(request).then(
          function (data) {
            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {
              _return.result = 'success';
              _return.data = data;
              return callback(_return);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              // _dashboardTravelPackageAddOnSummaryData = null;
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          },
          function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get(error.error.errorCode); // Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get('error_wireless_usage'); // Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          }
        );
      },
      setWirelessTravelPackage: function (request, callback) {
        var _return = {};
        ajax.setwirelessTravelPackage(request).then(function (data) {
          // check for error messages from server / Auth exipre / other troubles that do return valid JSON
          if (data) {
            _return.result = 'success';
            _return.data = data;
            return callback(_return);
          } else {
            // Fail and display error message
            // {'errorCode':10402,'errorMessage':'failed to get account details'}
            // _dashboardTravelPackageAddOnSummaryData = null;
            _return.result = 'fail';
            _return.data = data;
            return callback(_return);
          }
        }, function (error) {
          // Error handling - 555 exception
          if (error.data.status === 555) {
            // Server error that needs further processing
            // additional information for 555 error

            // error.error.errorCode		// 10k - 12.1k & 50k - 51k
            // error.error.errorMessage		// Message as delivered from server
            // error.error.message 			// Message as found in resource file
            // error.error.statusCode		// error status code - 555 in this case

            _return.result = 'error';
            _return.data = error;
            _return.message = resource.get(error.error.errorCode); // Pull message from resource file
            return callback(_return);

          } else {
            // anything but status code 555
            _return.result = 'error';
            _return.data = error;
            _return.message = resource.get('error_wireless_usage'); // Pull message from resource file 401 or 5xx situlation
            return callback(_return);
          }
        });
      },
      // Plugin / widget data handling

      // Postpaid data for widgets
      getWirelessPostpaid: function (request) {

        var _this = this;
        var _cacheFailSafe = true;
        var upfrontAdvantageSocs = $rootScope.upfrontAdvantageSocs;

        var wirelessPostpaidCall = function () {

          // ALWAYS load fresh JSON
          var _return = {};
          _this.postpaidData = null;

          ajax.wirelessPostpaid(request).then(
            function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.stale = false;
                if (data.cachedResultInfo && data.cachedResultInfo.expired && _cacheFailSafe) {
                  request.refresh = true;
                  _cacheFailSafe = false;
                  _return.stale = true;
                  wirelessPostpaidCall();

                }
                _return.result = 'success';
                _return.data = data;

                $window.localStorage.removeItem('upfrontAdvantageEligible');
                if (upfrontAdvantageSocs != undefined && data.postPaidPhoneDetails.addonsSocsList != undefined) {
                  for (var i = 0; i < upfrontAdvantageSocs.length; i++) {
                    for (var j = 0; j < data.postPaidPhoneDetails.addonsSocsList.length; j++) {
                      if (upfrontAdvantageSocs[i] == data.postPaidPhoneDetails.addonsSocsList[j]) {
                        localStorage.setLocalStorageValue('upfrontAdvantageEligible', true);
                        break;
                      }
                    }
                  }
                }
                _this.postpaidData = _return;
                //return callback(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                _dashboardPostpaidData = null;
                _return.result = 'fail';
                _return.data = data;
                _this.postpaidData = _return;
                //return callback(_return);
              }
            },
            function (error) {
              // Error handling - 555 exception
              if (error.data.status === 555) {
                // Server error that needs further processing
                // additional information for 555 error

                // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                // error.error.errorMessage		// Message as delivered from server
                // error.error.message 			// Message as found in resource file
                // error.error.statusCode		// error status code - 555 in this case

                _return.result = 'error';
                _return.data = error;
                _return.message = resource.get(error.error.errorCode); // Pull message from resource file
                //return callback(_return);
                _this.postpaidData = _return;
              } else {
                // anything but status code 555
                _return.result = 'error';
                _return.data = error;
                _return.message = resource.get('error_wireless_usage'); // Pull message from resource file 401 or 5xx situlation
                //return callback(_return);
                _this.postpaidData = _return;
              }
            }
          );
        };

        wirelessPostpaidCall();
      },
      setWirelessDashData: function (data) {
        wirelessDashData = data;
      },
      getWirelessDashData: function () {
        return wirelessDashData;
      },
      getConfigData: function () {
        return ajax.getSelfserveConfig();
      },
      getContributedData: function (ban, ctn) {
        var deferred = $q.defer();
        $http.post('/web/RogersServices.portal/smb/api/business/v1/wirelessDashBoard/getJWTToken', {
            "accountNumbers": ban
          })
          .then(function (response) {
            var deferred = $q.defer();
            if (response && response.data && response.data.token) {
              deferred.resolve({
                jwtToken: response.data.token,
                ban: ban[0],
                ctn: ctn
              });
            } else {
              deferred.reject();
            }
            return deferred.promise;
          })
          .then(fetchAccountRef)
          .then(fetchServiceRef)
          .then(fetchLineRef)
          .then(fetchDataRef)
          .then(function (contributedData) {
            deferred.resolve(contributedData);
          });
        return deferred.promise;
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrWirelessPrepaidController', WirelessPrepaidController);

  WirelessPrepaidController.$inject = ['appState'];

  /* @ngInject */
  function WirelessPrepaidController(appState) {
    appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:payasyougo'}, // Page Name
        {eVar16: 'prepaid'} // Prepaid, Regular
      ]
    );
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrWirelessPrepaidModalController', WirelessPrepaidModalController);

  WirelessPrepaidModalController.$inject = ['$scope', '$modalInstance', '$rootScope'];

  /* @ngInject */
  function WirelessPrepaidModalController($scope, $modalInstance, $rootScope) {
    $scope.close = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').service('myrWirelessPrepaidService', wirelessPrepaidService);

  wirelessPrepaidService.$inject = ['ajax', 'resource'];

  /* @ngInject */
  function wirelessPrepaidService(ajax, resource) {
    return {
      // Postpaid data for widgets
      getWirelessPrepaid: function (request, callback) {
        // ALWAYS load fresh JSON
        var _return = {};

        ajax.wirelessPrepaid(request).then(
          function (data) {
            // check for error messages from server / Auth expire / other troubles that do return valid JSON
            if (data) {
              _return.result = 'success';
              _return.data = data;
              return callback(_return);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              //_dashboardPrepaidData = null;
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          }, function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get(error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = resource.get('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          }
        );
      }
    };
  }
})();

'use strict';

angular
  .module('pricePlanChanges')
  .factory('existingPlanTransformer', function() {
    var service = {};

    function arrayHasElement(array) {
      if(array) {
        if(array.length > 0) {
          return true;
        }
      }

      return false;
    }

    function getTalk(wirelessPostpaid) {
      if(wirelessPostpaid.postPaidPhoneDetails &&
         wirelessPostpaid.postPaidPhoneDetails.additionalInfo &&
         arrayHasElement(wirelessPostpaid.postPaidPhoneDetails.additionalInfo.includedMinutes)){
        return wirelessPostpaid.postPaidPhoneDetails.additionalInfo.includedMinutes;
      }

      return null;
    }

    function getFeatures(wirelessPostpaid) {
      if(wirelessPostpaid.postPaidPhoneDetails &&
         wirelessPostpaid.postPaidPhoneDetails.additionalInfo &&
         arrayHasElement(wirelessPostpaid.postPaidPhoneDetails.additionalInfo.includedServices)){
        return wirelessPostpaid.postPaidPhoneDetails.additionalInfo.includedServices;
      }

      return null;
    }

    function getData(wirelessDashboard) {
      if(wirelessDashboard &&
         arrayHasElement(wirelessDashboard.dataArr)){
        return wirelessDashboard.dataArr[0].total;
      }

      return null;
    }

    function getSms(wirelessDashboard) {
      var sms = null;

      if(wirelessDashboard &&
         arrayHasElement(wirelessDashboard.smsArr)){
           sms = {};
           sms.usageType = wirelessDashboard.smsArr[0].usageType;
           sms.total = wirelessDashboard.smsArr[0].total;
      }

      return sms;
    }

    function getAddOnsTotal(wirelessPostpaid) {
      var total = 0;

      if(wirelessPostpaid.postPaidPhoneDetails.postPaidAddons) {
        _.each(wirelessPostpaid.postPaidPhoneDetails.postPaidAddons, function(addOn) {
          total += parseFloat(addOn.addonMSF);
        });
      }

      return total;
    }

    function getCosts(wirelessPostpaid) {
      var costs = {};

      if(wirelessPostpaid && wirelessPostpaid.postPaidPhoneDetails) {
        costs.planMSF = wirelessPostpaid.postPaidPhoneDetails.planMSF;
        costs.addOnsTotal = getAddOnsTotal(wirelessPostpaid);
      }

      return costs;
    }

    service.transform = function(wirelessPostpaid, wirelessDashboard) {
      // Validate Incoming Data
      var dataIncluded = (wirelessDashboard && arrayHasElement(wirelessDashboard.dataArr)) ? wirelessDashboard.dataArr[0].total : '';

      var cleanPlanData = {
        data: getData(wirelessDashboard),
        talk: getTalk(wirelessPostpaid),
        features: getFeatures(wirelessPostpaid),
        text: getSms(wirelessDashboard),
        costs: getCosts(wirelessPostpaid),
      };

      return cleanPlanData;
    };

    function getCostInDollars(cost) {
      return Math.floor(cost);
    }

    function getCostInCents(cost) {
      var costRemainder = cost % 1;

      if(costRemainder == 0) {
        return '.00';
      } else {
        return costRemainder.toFixed(2).substring(1);
      }
    }

    function mapAddOns(wirelessPostpaid) {
      if(wirelessPostpaid && wirelessPostpaid.postPaidPhoneDetails && arrayHasElement(wirelessPostpaid.postPaidPhoneDetails.postPaidAddons)) {
        return _.map(wirelessPostpaid.postPaidPhoneDetails.postPaidAddons, function(addOn) {
          var mappedAddOn = {};

          mappedAddOn.hideDetailsButton = true; // we don't have details for existing addOns, hide the button
          mappedAddOn.selected = true;          // default to selected for existing addOns

          mappedAddOn.cmsData_En = {
            title: addOn.socDesc,
          };

          mappedAddOn.cmsData_Fr = {
            title: addOn.socDescFr,
          };

          mappedAddOn.addonInfo = {
            addOnCode: addOn.soc,
            addOnPrice: addOn.addonMSF,
          };

          return mappedAddOn;
        });
      }

      return [];
    }

    service.transformAddOns = function(wirelessPostpaid) {
      return mapAddOns(wirelessPostpaid);
    };

    return service;
  });

'use strict';

angular
  .module('pricePlanChanges')
  .factory('popUpBubbles', function() {
    var service = {};
    service.isExclusive = false;
    service.isRecommended = false;

    service.planPopUpVisible = false;
    service.planIndex = 0;

    service.showPlanPopUp = function(index, targetPlan) {
    	service.isExclusive = false;
      service.planPopUpVisible = true;
      service.planIndex = index;

      //Is Exclusive? Then show ...exclusive class also for bubble
      if(targetPlan && targetPlan == 2)
      	service.isExclusive = true;
      else if(targetPlan && targetPlan == 1)
        service.isRecommended = true;
    }

    service.hidePlanPopUp = function() {
      service.planPopUpVisible = false;
    }

    return service;
  });

/**
 * Created on 29/05/2015.
 */
'use strict';

angular
  .module('pricePlanChanges')
  .factory('pricePlanAlignRows', ["$rootScope", "$state", function($rootScope, $state) {

    return {
      alignDataRows: function(){
        //align data-plan-align-row's
        for(var i = 0; i < 6; ++i){
          //jQuaary
          var divs = $('div[data-plan-align-row="' + (i+1) + '"]');
          var height = 0;

          //FIXED height for data align row 1
          if(i > 0) {
            divs.each(function(idx, val) {
             if ($(this).outerHeight() > height)
                height = $(this).outerHeight();
             });
          } else {
            height = 120;
          }
          divs.each(function(idx, val){
            $(this).height(height);
          });
        }

        //===
        //align container heights
        var height_ap = $('available-plan').find(':first-child').outerHeight();
        $('#plan-container').height( height_ap );

        //.plan-header, #plan-price-container
        var height_ph = $('#plan-container .plan-header').outerHeight();
        var height_pc = $('#plan-price-container').outerHeight();

        //#existing-plan-grey-body
        var tweak = -37;  //margin-top added to #existing-plan-grey-body
        $('#existing-plan-grey-body').height( height_ap - ( height_ph + height_pc ) + tweak );
        //===

        $rootScope.countPlan = 0;

        //Reload desktop from mobile
        this.reloadDesktopOnResize();
      },

      scrollToTop: function(){
	      //Force Top of Page
	      var doScroll = true;		//alert(52);
	      if(doScroll){
	      	//jQuery
	      	setTimeout(
						function() {
	    				$('html, body').animate({scrollTop: 0}, 750);
	    			},
	    			1000
	      	);
	      }
      },

      reloadDesktopOnResize: function(){
        //jQuery
        var reload   = false;
        var bp       = 992;
        var jQwindow = $(window);
        var lastSize = jQwindow.width();

        jQwindow.on('resize', function () {
          var windowSize = $(this).width();
          reload = windowSize < bp ? false : true;

          //LOAD ON CROSSING OF BREAKPOINT
          if(reload && $state.current.name == 'wireless-plan-change' && lastSize < bp && windowSize >= bp) {
            reload = false;
            //$state.go($state.current.name, {reload: true});
            setTimeout(
              //FF issue, use this
              function(){
                window.location.reload();
              }, 100);
          }
          lastSize = windowSize;
        });
      }
    };

  }]);


'use strict';

/************************************

  need to consider how we might store the cart data
  we are supposed to have a popup when the user navigates away, could store then

***************************************/

angular
  .module('pricePlanChanges')
  .factory('pricePlanChangesCart', ['$browser', '$q', '$rootScope', 'backend', 'pricePlanChangesErrors', 'localStorage',
    '$location', 'userProvince', 'userLanguage', 'pricePlanAlignRows', 'resource',
    function($browser, $q, $rootScope, backend, pricePlanChangesErrors, localStorage, $location, userProvince, userLanguage,
             pricePlanAlignRows, resource) {

    var service = {};
    service.init = function() {
      //Align rows set for init in singleLinePPC
      $rootScope.alignRows = true;

      //Scroll Top
      pricePlanAlignRows.scrollToTop();


      // CART DATA
      service.newPlan = null;
      service.addOns = [];
      service.selectedAvailableAddOns = [];
      service.addOnsToRemove = [];
      service.isProrated = false;
      service.totalCost = null;

      // USER DATA
      service.email = $browser.cookies().userName || $browser.cookies().SM_USER;
      service.firstName = '';
      service.lastName = '';
      service.ctn = '';
      service.sessionId = '';

      service.billingAddress = null;
      service.billingType = '';// INVOICE | online ?

      service.billingCity = '';
      service.billingPostalCode = '';
      service.billingProvince = '';
      service.billingStreetAddress = '';
      service.contactPhoneNumber = '';
      service.contactEmail = '';
      service.billingCycleDay = 0;

      service.taxRates = {
        AB: {
          GST: 5
        },
        BC: {
          GST: 5,
          PST: 7
        },
        MB: {
          GST: 5,
          PST: 8
        },
        NB: {
          HST: 13
        },
        NL: {
          HST: 13
        },
        NS: {
          HST: 15
        },
        NT: {
          GST: 5
        },
        ON: {
          HST: 13
        },
        PE: {
          HST: 14
        },
        QC: {
          GST: 5,
          QST: 9.975
        },
        SK: {
          GST: 5,
          PST: 5
        },
        YT: {
          GST: 5
        },
        NU: {
          GST: 5
        }
      };
    }

    var getAddOnCost = function() {
      var addOnCost = 0.0;

      _.each(service.addOns, function(addOn) {
        addOnCost += addOn.addonInfo.addOnPrice;
      });

      return addOnCost;
    };

    var calculateTax = function () {
      var province = userProvince();
      var provinceTax = service.taxRates[province];
      var provinceTaxResult = {
        taxes: {},
        taxTotal: 0,
        taxTotalStr: ''
      };
      var taxTotal = 0;
      var currentTaxValue = 0;
      if (!service.totalCost) {
        service.totalCost = service.getTotalCost();
      }
      for (var key in provinceTax) {
        currentTaxValue = (service.totalCost * (provinceTax[key] / 100));
        var vObj = {
          value: currentTaxValue,
          writable: true,
          enumerable: true,
          configurable: true
        };
        Object.defineProperty(provinceTaxResult.taxes, key, vObj);
        taxTotal += currentTaxValue;
      }
      provinceTaxResult.taxTotal = taxTotal;
      provinceTaxResult.taxTotalStr = taxTotal.toFixed(2);
      return provinceTaxResult;
    };

    service.getTotalCost = function() {
      var planCost = service.newPlan.planInfo.planPrice;
      var addOnCost = getAddOnCost();
      return planCost + addOnCost;
    };

    service.getGrandTotal = function() {
      if (!service.totalCost) {
        service.totalCost = service.getTotalCost();
      }
      var total = service.totalCost;
      var effectiveTax = calculateTax();
      return Number(total) + Number(effectiveTax.taxTotal);
    };

    service.getTaxesObject = function() {
      var taxes = calculateTax();
      return taxes;
    }

    var getSocCodesFromAddOns = function(addOns) {
      var addOnCodes = [];

      _.each(addOns, function(addOn) {
        addOnCodes.push(addOn.addonInfo.addOnCode);
      });

      // Still not sure if the backend prefers an empty array or null //
      if(addOnCodes.length > 0) {
        return addOnCodes;
      } else {
        return null;
      }
    };
    var trimObject = function(obj) {
      for (var prop in obj) {
        if (typeof obj[prop] === 'string') {
          var _tmpStr = obj[prop];
          obj[prop] = (_tmpStr) ? _tmpStr.trim() : _tmpStr;
        }//if
      }//for
      return obj;
    }

    // get the add ons the user wants to have with their new plan, this can be new and existing addOns
    var getDesiredAddOns = function() {
      //return getSocCodesFromAddOns(service.addOns);
      return getSocCodesFromAddOns(service.selectedAvailableAddOns);
    };

    // get any addons the user is removing from their plan
    var getDeletedAddOns = function() {
      return getSocCodesFromAddOns(service.addOnsToRemove);
    };



    var modifyAddons = function () {
      $rootScope.submittingOrder = true;
      var deferred = $q.defer();

      var socsForAddition = getDesiredAddOns();
      var socsForDeletion = getDeletedAddOns();

      var request = {
        sessionId: service.sessionId,
        planCode: service.newPlan.planInfo.planCode,
        ban: localStorage.getLocalStorageValue('accountNumber'),
        accountNumber: localStorage.getLocalStorageValue('accountNumber'),
        ctn: service.ctn,
        language: userLanguage().toUpperCase()
        //socsForAddition: getDesiredAddOns(),
        //socsForDeletion: getDeletedAddOns()
      };

      var sendModify = (socsForAddition || socsForDeletion);


      if (sendModify) {
        if (socsForAddition) {
          request.socsForAddition = socsForAddition;
        }
        if (socsForDeletion) {
          request.socsForDeletion = socsForDeletion;
        }

        request = trimObject(request);


        backend.postFormData('wirelessPricePlanChange/modifyAddons', request)
          .then(function (response) {
            if (response.result === 'success') {
              $rootScope.submittingOrder = false;
              deferred.resolve('true');
            } else {
              pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
              deferred.reject(response);
            }

          })
          .then(null, function (response) {
            $rootScope.submittingOrder = false;
            pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
            deferred.reject();
          });
      } else {
        deferred.resolve(true);
      }
      return deferred.promise;
    };

    var submitOrder = function () {
      $rootScope.submittingOrder = true;
      var deferred = $q.defer();

      var request = {
        sessionId: service.sessionId,
        ban: localStorage.getLocalStorageValue('accountNumber'),
        accountNumber: localStorage.getLocalStorageValue('accountNumber'),
        ctn: service.ctn
      };

      backend.postFormData('wirelessPricePlanChange/submitOrder', request)
        .then(function(response) {
          $rootScope.submittingOrder = false;
          if(response.result === 'success') {
            deferred.resolve('true');
          } else {
            pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
            deferred.reject(response);
          }
        })
        .then(null, function(response) {
          pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
          $rootScope.submittingOrder = false;
          deferred.reject();
        });

      return deferred.promise;
    };

    service.checkout = function () {
/*
    modifyAddons & submitOrder do their own error handling,
    we only get notified on success
*/
      $rootScope.reviewLoader = true;
      modifyAddons()
        .then(function() {
          submitOrder()
            .then(function() {
              $location.path('/confirm-order');
              $rootScope.reviewLoader = false;
            });
        });
    };

    service.setAccountInfoFromBillingDetails = function(data) {
      if (data && data.billingCycleDay) {
        service.billingCycleDay = data.billingCycleDay;
        //service.billCycleEndDate = data.billCycleEndDate;
      }
    };


    service.setAccountInfoFromDetails = function(data) {
      if (data.billingAddress) {
        service.billingType = data.billingAddress.billingType;
        service.billingCity = data.billingAddress.city;
        service.billingPostalCode = data.billingAddress.postalCode;
        service.billingProvince = data.billingAddress.province;
        service.billingStreetAddress = data.billingAddress.streetNumber + ' ' + data.billingAddress.streetName + ' ' + data.billingAddress.streetType;
        service.contactPhoneNumber = data.contactInfo.homePhone;
      }
    };

    service.captureAccountData = function(getAvailablePlansResponse) {
      //var accountInfo = getAvailablePlansResponse.accountInfo;

      service.sessionId = getAvailablePlansResponse.esisSessionId;
      //service.billingType = accountInfo.billingType;
      //
      //service.billingCity = accountInfo.billing_city;
      //service.billingPostalCode = accountInfo.billing_postalCode;
      //service.billingProvince = accountInfo.billing_province;
      //service.billingStreetAddress = accountInfo.billing_streetAddress;
    };
    service.init();
    return service;
  }]);


'use strict';

angular
  .module('pricePlanChanges')
  .factory('pricePlanChangesData', ['$rootScope','$q', 'localStorage', 'userLanguage', 'backend', 'myrAccountOverviewService', 'myrWirelessDashboardService',
    'existingPlanTransformer', 'pricePlanChangesState', 'pricePlanChangesCart', 'pricePlanChangesErrors', '$http', 'ajax', '$state', 'resource',
    function($rootScope, $q, localStorage, userLanguage, backend, accountOverviewService, wirelessService,
             existingPlanTransformer, pricePlanChangesState, pricePlanChangesCart, pricePlanChangesErrors, $http, ajax, $state, resource) {
    var service = {};

    service.getWireLessAccounts = function(accountNumber) {
      var deferred = $q.defer();
      var wirelessAccounts = [];
      var request = {
        refresh: false,
        applicationId: 'Rogers.com'
      };

      // taken from app/scripts/controllers/wireless.js
      accountOverviewService.getAccountList(request, function(_tmp) {
        if (_tmp.result === 'success' && _tmp.data.length > 0) {
          wirelessAccounts = _.filter(_tmp.data, function(account) {
            return (account.accountTypeNumber === 1 || account.accountTypeNumber === 9) && account.accountNumber === accountNumber && account.accountStatus == 'Active' && account.accountNumber && typeof account.accountNumber == 'string' && account.accountNumber.length < 12;
          });
        } else {
          // ERROR //
          pricePlanChangesErrors.showError('Accounts List Error', _tmp.errorCode, ['OK'],  {goBack: 'accountOverview'});
          deferred.reject(null);
        }
        if (wirelessAccounts.length == 0) {
          $state.go('accountOverview');
        }
        pricePlanChangesCart.firstName = wirelessAccounts[0].accountName.firstName;
        pricePlanChangesCart.lastName  = wirelessAccounts[0].accountName.lastName;

        deferred.resolve(wirelessAccounts);
      });

      return deferred.promise;
    };

    service.cleanFeatures = function(features) {
      var _length = features.length;
      for (var i =  _length -1; i > 0; i--) {
        if (features[i].desc === '') {
          features.splice(i, 1);
        }
      }
      return features;
    }

    service.getPlan = function(ctn) {
//      var wirelessPostpaid = null;
      var deferred = $q.defer();
      var requestBody = {
        ctn: ctn,
        ban: localStorage.getLocalStorageValue('accountNumber'),
        applicationId: 'SMB',
        language: userLanguage()
      };

      ajax.wirelessPostpaid(requestBody).then(
        function (wirelessPostpaidResponse) {
          if (wirelessPostpaidResponse) {
            if(wirelessPostpaidResponse.postPaidPhoneDetails.HasFuturePricePlan){
              // Q2PPC-76
              pricePlanChangesErrors.showError(resource.get('ppc_pending_error_title'), resource.get('ppc_pending_error_text'), ['OK'], {goBack: 'accountOverview'});
            }else if(wirelessPostpaidResponse.postPaidPhoneDetails.isPendingCancellation ){
              //Q2PPC-77
              pricePlanChangesErrors.showError(resource.get('ppc_cancellation_pending_error_title'), resource.get('ppc_cancellation_pending_error_text'), ['OK'], {goBack: 'accountOverview'}, true);

            }else if(wirelessPostpaidResponse.postPaidPhoneDetails.isSuspendedCtn){
              pricePlanChangesErrors.showError(resource.get('ppc_account_suspended_message_title'), resource.get('ppc_account_suspended_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
            }else {
              // the first call has completed make the second call (using the same request)
              wirelessService.getWirelessDashBoard(requestBody, function (wirelessDashboardResponse) {
                if (wirelessDashboardResponse.result === 'success') {
                  var cleanPlan = existingPlanTransformer.transform(wirelessPostpaidResponse, wirelessDashboardResponse.data);
                  cleanPlan.features = service.cleanFeatures(cleanPlan.features);
                  var cleanAddOns = existingPlanTransformer.transformAddOns(wirelessPostpaidResponse);

                  deferred.resolve({
                    plan: cleanPlan,
                    addOns: cleanAddOns
                  });
                } else {
                  deferred.reject(wirelessDashboardResponse.message);
                }
              });
            }
          } else {
            deferred.reject(wirelessDashboardResponse.message);
          }
        }, function() {
          deferred.reject(false);
          pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'});
        });

      return deferred.promise;
    };

    service.getAvailableAddOns = function getAvailableAddOns(planCode, esisSessionId, ctn, selectedMisoCode) {
      var request = {
        sessionId: esisSessionId,
        planCode: planCode,
        ban: localStorage.getLocalStorageValue('accountNumber'),
        accountNumber: localStorage.getLocalStorageValue('accountNumber'),
        ctn: ctn,
        selectedDataMiso: selectedMisoCode
      };

      /*if ($rootScope.selectedPlanCount > 1) {
        request = {
          sessionId: esisSessionId
        };
      }*/

      return backend.postFormData('wirelessPricePlanChange/availableAddons', request);
      //return $http.get('mocks/availableAddons.json');
    };

    service.getAvailablePlans = function(ctn, planCode, currentCategory, planPrice, billing_postalCode) {
    //service.getAvailablePlans = function() {
      var request = {
        // are accNum & BAN the same??????????????????????????????????????
        //according new changes in BE, Yihua asked to send a request without params
        ban: localStorage.getLocalStorageValue('accountNumber'),
        //accountNumber: localStorage.getLocalStorageValue('accountNumber'),
        ctn: ctn,
        planCode: planCode,
        currentCategory: currentCategory,
        pricePlan: planPrice,
        postalCode: billing_postalCode
      };
      return backend.postFormData('wirelessPricePlanChange/availablePlans', request);
      //return $http.get('mocks/availablePlans.json');
    }
    return service;
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .factory('pricePlanChangesErrors', ["resource", "$modal", "$state", "userLanguage", function(resource, $modal, $state, userLanguage) {
    var service = {};

    function showModal(errorMessage) {
      $('#error-modal-body').html(errorMessage);
      $('#error-modal').modal('show');
    };

    function showErrorModal(title, message, buttons, redirect, showLiveChat, reload, isSuspended) {
    	reload = reload || false;

      var $modalInstance = $modal.open({
        //templateUrl: 'scripts/directives/pricePlanChanges/timeline/timelineIndex.html',
        templateUrl: 'views/modals/ppc-modal-template.html',
        windowClass: 'prorated-modal',
        controller: ["$scope", function($scope) {
          $scope.title = title;
          $scope.showLiveChat = showLiveChat;
          $scope.message = message;
          $scope.showCancelBtn = false;
          $scope.showOKBtn = false;
          $scope.showConfirmBtn = false;
          $scope.showContinueBtn = false;
          $scope.showRemoveAddOnBtn = false;
          $scope.showGoBackBtn = false;
          $scope.isSuspendedAccount = isSuspended;
          $scope.lang = userLanguage();
          var _length = buttons.length;
          for (var i = 0; i < _length; i++) {
            switch (buttons[i]) {
              case 'OK':
                $scope.showOKBtn = true;
                break;
              case 'Cancel':
                $scope.showCancelBtn = true;
                break;
              case 'Confirm':
                $scope.showConfirmBtn = true;
                break;
              case 'ConfirmPlanChange':
                $scope.showConfirmPlanChangeBtn = true;
                break;
              case 'Continue':
                $scope.showContinueBtn = true;
                break;
              case 'RemoveAddOn':
                $scope.showRemoveAddOnBtn = true;
                break;
              case 'GO_BACK':
                $scope.showGoBackBtn = true;
                break;
            }
          }

          $scope.boldChat = {
              wlssPpc: {
                en: {
                  cbid: 'S_BSS_PS_Wlss_PPC',
                  dynamicDivId: 'S_BSS_PS_Wlss_PPC_div',
                  chatButtonClass:'chatButtonPPCEn'
                },

                fr: {
                  cbid: 'S_BSS_PS_Wlss_PPC_fr',
                  dynamicDivId: 'S_BSS_PS_Wlss_PPC_fr_div',
                  chatButtonClass:'chatButtonPPCFr'
                }
              }
          };

          $scope.ok = function () {
            $modalInstance.close();
            if (redirect && redirect.goBack) {
              $state.go(redirect.goBack);
            }
          };
          $scope.goBack = function () {
            $modalInstance.close();
            if (redirect && redirect.goBack) {
              $state.go(redirect.goBack);
            }
          };
          $scope.removeAddOn = function () {
            $modalInstance.close(true);
          };

          $scope.cancel = function () {
            $modalInstance.close(false);
            if (redirect && redirect.goBack) {
              $state.go(redirect.goBack);
            }
          };

          $scope.continue = function () {
            $modalInstance.close(true);
            if (redirect && redirect.goForward) {
              $state.go(redirect.goForward, {}, { reload: reload });
            }
          };

          $scope.confirm = function () {
            $modalInstance.close(true);
            if (redirect && redirect.goForward) {
              $state.go(redirect.goForward);
            }
            else if (redirect && typeof redirect.sendCallback === 'function' ) {
              redirect.sendCallback();
            }
          };
          if (!$scope.isSuspendedAccount) {
            switch (userLanguage()) {
              case 'en':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=10&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en';
                break;
              case 'fr':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=60&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr';
                break;
            }
          } else {
            switch (userLanguage()) {
              case 'en':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=204&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en';
                break;
              case 'fr':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=254&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr';
                break;
            }
          }

        }],
        //scope: $scope,
        size: 'md',
        backdrop: 'static'
        //keyboard: false,
        //backdropClass: 'bkg-modal',
        //resolve: {}
      });

      return $modalInstance.result;
    }

    // Display provided errorMessage in Modal
    // missing the RELOAD button
    service.showError = function(title, message, buttons, redirect, showLiveChat, isSuspended) {
      return showErrorModal(title, message, buttons, redirect, showLiveChat, isSuspended);
    };

    service.showSuspendedError = function(title, message, buttons, redirect, showLiveChat, reload, isSuspended) {
      return showErrorModal(title, message, buttons, redirect, showLiveChat, reload, isSuspended);
    };

    // Look up error message for this errorCode and then display in modal
    service.handleError = function(errorCode) {
      var errorMessage = resource.get(errorCode);
      showModal(errorMessage);
    };

    // Look up generic error message and display in modal
    service.showGenericError = function() {
      var errorMessage = resource.get('_something_went_wrong');
      showModal(errorMessage);
    };

    return service;
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .factory('pricePlanChangesState', function() {
    var service = {};

    service.resetUserSelections = function() {
      return {
        ctn: '',
                                 // selected phone number defautls to first CTN on page load
        availablePlanDetailsExpanded: false,   // below the plans carousel is a panel to show/hide plan details
        availablePlanDetailsSlideIndex: -1 ,    // we need to know which of the three plans in the carousel was clicked on
        expandedPlan: null,                    // the plan the user wants to view details for

        existingAddOnDetailsExpanded: false,   // below the list of existing add-ons is a panel to show/hide add-on details
        existingAddOnDetailsSlideIndex: -1,    // we need to know which of the three add-ons in the list was clicked on
        expandedExistingAddOn: null,           // the add-on the user wants to view details for

        availableLDAddOnDetailsExpanded: false,   // below the list of available Long Distance add-ons is a panel to show/hide add-on details
        availableLDAddOnDetailsSlideIndex: -1,    // we need to know which of the three add-ons in the list was clicked on
        expandedAvailableLDAddOn: null,           // the add-on the user wants to view details for

        availableCFAddOnDetailsExpanded: false,   // below the list of available Calling Features add-ons is a panel to show/hide add-on details
        availableCFAddOnDetailsSlideIndex: -1,    // we need to know which of the three add-ons in the list was clicked on
        expandedAvailableCFAddOn: null,           // the add-on the user wants to view details for

        availablePlans: [],                    // this is a paged array of plans (an array of an array)
        availablePlansRaw: [],                 // this is a straight array of plans from the server
        availableAddOns: [],                   // this is 'per plan' and gets loaded when a plan is selected
        duplicateAddons: [],                   // the add ons made superflous by their newly chosen plan
        droppedAddons: [],                     // WTFBBQ?!?!?!?
        selectedPlan: null,                    // the plan the user wants to switch to

        removedAddOns: [],                     // existing add-ons they chose to remove

        isProrated: false,                     // are they changing their plan mid-month
        totalCost: null,                       // plan + addOns - discount
        rewardsPoints: 0,                      // rewards points earned for this purchase?

        plan: null,                            // existing plan comes from server when user selects a CTN
        existingAddOns: null,                  // existing add ons come from server with the plan
        esisSessionId: null                // this is returned when we get available plans
      };
    };

    return service;
  });

'use strict';

angular
  .module('pricePlanChanges')
  .factory('pricePlanChanges', ['$rootScope', 'pricePlanChangesData', 'pricePlanChangesState', '$q', 'localStorage',
    'pricePlanChangesCart', 'pricePlanChangesErrors', '$modal', 'resource', 'userLanguage', 'settings', '$timeout',
    function($rootScope, pricePlanChangesData, pricePlanChangesState, $q, localStorage,
             pricePlanChangesCart, pricePlanChangesErrors, $modal, resource, userLanguage, settings, $timeout) {
    var service = {};

    service.userSelections = pricePlanChangesState.resetUserSelections();

    $rootScope.$on('available-plan-details-expanded', function(event, args) {
      //*** The subscribing details button emits this event ***//
      // capture plan we want to show details from
      service.userSelections.expandedPlan = fetchPlanFromArray(args.buttonId);
    });

    var fetchPlanFromArray = function (planCode) {
      var plan =  _.find(service.userSelections.availablePlansRaw, function(plan) {
          return plan.planInfo.planCode === planCode;
      });

      return plan;
    };

    var fetchAvailableAddOnFromArray = function(addOnCode) {
      return _.find(service.userSelections.availableAddOns , function(addOn) {
        return addOn.addonInfo.addOnCode === addOnCode;
      });
    };

    var setVisibilityOfExistingAddOns = function() {
      // if the existing Add-On is present in array of dupes, don't display it
      _.each(service.userSelections.existingAddons, function(addOn) {
        var isDuplicate = _.any(service.userSelections.duplicateAddons, function(dupe) {
          return dupe.addonInfo.addOnCode === addOn.addonInfo.addOnCode;
        });

        if(isDuplicate) {
          addOn.invisble = isDuplicate;
          addOn.selected = false;
        }
      });
    };

    var reconcileAddOns = function() {
      setVisibilityOfExistingAddOns();
    };

    var calculateTotal = function() {
      //var addOnTotal = _.chain(service.userSelections.existingAddOns)
      //                  .filter(function(addOn) {
      //                      return addOn.selected;
      //                    })
      //                  .sum(function(addOn) {
      //                      return addOn.addonInfo.addOnPrice;
      //                    }).value();
      //
      //addOnTotal += _.chain(service.userSelections.availableAddOns)
      //               .filter(function(addOn) {
      //                   return addOn.selected;
      //                 })
      //               .sum(function(addOn) {
      //                   return addOn.addonInfo.addOnPrice;
      //                 }).value();
      var addOnTotal = 0;
      var _length = (service.userSelections.existingAddOns) ? service.userSelections.existingAddOns.length : 0;
      for (var i = 0; i < _length; i++) {
        if (service.userSelections.existingAddOns[i].selected) {
          addOnTotal += parseFloat(service.userSelections.existingAddOns[i].addonInfo.addOnPrice);
        }
      }

      _length = service.userSelections.availableAddOns.length;
      for (var i = 0; i < _length; i++) {
        if (service.userSelections.availableAddOns[i].selected) {
          addOnTotal += parseFloat(service.userSelections.availableAddOns[i].addonInfo.addOnPrice);
        }
      }

      var planPrice = service.userSelections.selectedPlan ? service.userSelections.selectedPlan.planInfo.planPrice : 0;
      var total = addOnTotal + planPrice;

      return total.toFixed(2);
    };

    var updateCart = function() {
      // this appears redundant but in the future the 'cart' will encompass more than PricePlanChanges
      pricePlanChangesCart.newPlan = service.userSelections.selectedPlan;
      pricePlanChangesCart.addOns = getSelectedAddOns();
      pricePlanChangesCart.selectedAvailableAddOns = getSelectedAvailableAddOns();
      pricePlanChangesCart.addOnsToRemove = getRemovedAddOns();
      pricePlanChangesCart.isProrated = service.userSelections.isProrated;

      var newCost = calculateTotal();
      pricePlanChangesCart.totalCost = newCost;
      service.userSelections.totalCost = newCost;
      service.userSelections.rewardsPoints = Math.round(newCost);

      //notify loading image
      $rootScope.longDistanceLoader = $rootScope.longDistanceLoadMobile = false;
    };

    var getSelectedAddOns = function() {
      var existing = _.filter(service.userSelections.existingAddOns, function(addOn) {
                       return addOn.selected;
                     });

      var available = _.filter(service.userSelections.availableAddOns, function(addOn) {
                       return addOn.selected;
                     });

      return existing.concat(available);
      //return available;
    };

    var getSelectedAvailableAddOns = function() {
      var available = _.filter(service.userSelections.availableAddOns, function(addOn) {
        return addOn.selected;
      });
      return available;
    }

    var getRemovedAddOns = function() {
      var removed = _.filter(service.userSelections.existingAddOns, function(addOn) {
        return addOn.selected === false;
      });
      return removed;
    };

    service.getWireLessAccounts = function(accountNumber) {
      return pricePlanChangesData.getWireLessAccounts(accountNumber);
    };

    service.getPlan = function(ctn) {
      return pricePlanChangesData.getPlan(ctn);
    };

    service.getCtnList = function() {
      var deferred = $q.defer();

      service.getWireLessAccounts(localStorage.getLocalStorageValue('accountNumber'))
        .then(function(data) {
          var ctn = localStorage.getLocalStorageValue('phoneNumber');
          if (!ctn) {
            ctn = data[0].subNumbers[0];
          }
          service.getPlan(ctn)
            .then(function(planData) {
              service.userSelections.plan = planData.plan;
              service.userSelections.existingAddOns = planData.addOns;

              //############################### moved form bottom part to inside the THEN, so the promise will be solved only after getting response from getPlan.
              // capture the current number
              service.userSelections.ctn = ctn;

              // resolve with array of phone numbers
              deferred.resolve(data[0].subNumbers);
              //###############################
            }, function() {
              pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'});
            });

          // capture the current number
          //service.userSelections.ctn = ctn;

          // resolve with array of phone numbers
          //deferred.resolve(data[0].subNumbers);
        })
        .then(null, function(data) {
          deferred.reject(data.message);
        });

      return deferred.promise;
    };

    service.selectCtn = function(ctn) {
      var deferred = $q.defer();

      service.getPlan(ctn)
        .then(function(planData) {
          pricePlanChangesCart.ctn = ctn;
          service.userSelections.ctn = ctn;
          service.userSelections.plan = planData.plan;
          service.userSelections.existingAddOns = planData.addOns;

          deferred.resolve(service.userSelections.plan);
        })
        .then(null, function(errorMessage){
          deferred.reject(errorMessage);
        });

      return deferred.promise;
    };

    service.getAvailablePlans = function(ctn, planCode, currentCategory, planPrice, billingPostalCode) {
    //service.getAvailablePlans = function() {
      return pricePlanChangesData.getAvailablePlans(ctn, planCode, currentCategory, planPrice, billingPostalCode);
      //return pricePlanChangesData.getAvailablePlans();
    };

    service.expandPlan = function(planCode) {
      // capture expanded to show details
      service.userSelections.expandedPlan = fetchPlanFromArray(planCode);
    };

    service.getExpandedPlan = function(planCode) {
      // capture expanded to show details
      return fetchPlanFromArray(planCode);
    };

    service.expandExistingAddOn = function(addOnCode) {
      // capture expanded to show details
      service.userSelections.expandedExistingAddOn = fetchPlanFromArray(addOnCode);
    };

    service.expandAvailableLDAddOn = function(addOnCode) {
      // capture expanded to show details
      service.userSelections.expandedAvailableLDAddOn = fetchAvailableAddOnFromArray(addOnCode);
    };

    service.expandAvailableCFAddOn = function(addOnCode) {
      // capture expanded to show details
      service.userSelections.expandedAvailableCFAddOn = fetchAvailableAddOnFromArray(addOnCode);
    };

    service.expandAvailableVPAddOn = function(addOnCode) {
      // capture expanded to show details
      service.userSelections.expandedAvailableVPAddOn = fetchAvailableAddOnFromArray(addOnCode);
    };

    service.selectPlan = function(planCode) {
      // capture selected plan
      service.userSelections.selectedPlan = fetchPlanFromArray(planCode);
      // get the available add-ons for this plan
        var misoCode = (service.userSelections.selectedPlan.planInfo.dataMisoList &&  service.userSelections.selectedPlan.planInfo.dataMisoList[0])
          ? service.userSelections.selectedPlan.planInfo.dataMisoList[0].misoCode : null;
        pricePlanChangesData.getAvailableAddOns(planCode, service.userSelections.esisSessionId, service.userSelections.ctn, misoCode)
          .then(function(data) {
            //***** mock data
            //data = data.data;
            //***** mock data
            if (data) {
              service.userSelections.availableAddOns = data.availableAddons;
              //service.userSelections.duplicateAddons = service.filterAddOnsByType(service.userSelections.availableAddOns, 'Duplicated');
              //service.userSelections.droppedAddons = service.filterAddOnsByType(service.userSelections.availableAddOns, 'dropped');
              //service.userSelections.availableAddOns = data.availableAddons;
              service.userSelections.duplicateAddons = data.duplicateAddons;
              service.userSelections.droppedAddons = data.droppedAddons;
              reconcileAddOns();
              updateCart();
            } else {
              if (data.result) {
                pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'});
              } else {
                updateCart();
              }
            }
          })
          .then(null, function(data){
            pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'});
          }
        );
    };

    service.removePlan = function() {
      // clear selected plan
      service.userSelections.selectedPlan = null;
      service.userSelections.availableAddOns = [];
      updateCart();
    };

    service.addOnsUpdated = function() {
      updateCart();
    };

    service.filterAddOns = function(addOns, type) {
      var filteredAddOns = _.filter(addOns, function(addOn) {
        return addOn.addonInfo.categoryName_En === type;
      });
      return filteredAddOns;
    };

    service.filterAddOnsByType = function(addOns, type) {
      var filteredAddOns = _.filter(addOns, function(addOn) {
        return addOn.addonType === type;
      });
      return filteredAddOns;
    };

    service.showProrationDetails = function() {
      //if (!pricePlanChangesCart.billingCycleDay) { return; }

      if (!localStorage.getLocalStorageValue('nextBillDate')) { return; }
      $rootScope.modal = $modal.open({
        //templateUrl: 'scripts/directives/pricePlanChanges/timeline/timelineIndex.html',
        templateUrl: 'views/modals/proratedchangesexplanation.html',
        windowClass: 'prorated-modal',
        controller: ["$scope", function($scope) {
          //$scope.billingCycleDay =  pricePlanChangesCart.billingCycleDay; //new Date(pricePlanChangesCart.billCycleEndDate).getDate();
          $scope.billingCycleDay =  new Date(localStorage.getLocalStorageValue('nextBillDate')).getDate();
          $scope.currentDate = new Date();

          var day   = $scope.currentDate.getDate();
          var year  = $scope.currentDate.getFullYear();
          var month = $scope.currentDate.getMonth();

          //Greater Than or Equal Comparison
          var currentDayGreaterBillingCycleDay =  Boolean(day >= $scope.billingCycleDay ? 1 : 0);
          var lastBill = new Date(year, currentDayGreaterBillingCycleDay ? month : month - 1, ($scope.billingCycleDay+1));
          var thisBill = new Date(year, month, $scope.billingCycleDay);
          var today = new Date(year, month, day);
          var nextBill = new Date(year, currentDayGreaterBillingCycleDay ? month + 1 : month, $scope.billingCycleDay);

          $scope.lastBillDate = lastBill.getTime();
          $scope.thisBillDate = thisBill.getTime();
          $scope.todaysDate = today.getTime();
          $scope.nextBillDate = nextBill.getTime();

          $scope.percentPassed = Math.round(($scope.todaysDate - $scope.lastBillDate) / ($scope.nextBillDate - $scope.lastBillDate) * 100);

          var nextBillDateDay = nextBill.getDate();
          var nextBillDateMonth = nextBill.getMonth();

          var lang = userLanguage();
          var months = resource.get('_months');
          switch (lang) {
            case 'en':
              $scope.changePlanDate = (months[month]).substring(0, 3) + ' ' + day;
              $scope.nextBillFormattedDate = (months[nextBillDateMonth]).substring(0, 3) + ' ' + nextBillDateDay;
              break;
            case 'fr':
              $scope.changePlanDate = day + ' ' + months[month];
              $scope.nextBillFormattedDate = nextBillDateDay + ' ' + months[nextBillDateMonth];
              break;
          }
          var timeDiff        = Math.abs($scope.nextBillDate - $scope.currentDate.getTime());
          $scope.diffBillDate = Math.ceil(timeDiff / (1000 * 3600 * 24));

          $scope.cancel = function () {
            $rootScope.modal.dismiss('cancel');
            $rootScope.modal = null;
          };
        }],
        //scope: $scope,
        size: 'md',
        backdrop: 'static'
        //keyboard: false,
        //backdropClass: 'bkg-modal',
        //resolve: {}
      });
    };


      //IMPLEMENT SORTING MECHANISM FOR RECOMMENDED, EXCLUSIVE PLANS
      //@see  - ng-repeat in available-plan.html
      //@todo - make service
      service.sortRecommendedExclusive = function (plans) {
        var delaySort, onDelaySort;
        var deferred = $q.defer();
        var TARGET = {
          RECOMMENDED: 1,
          EXCLUSIVE: 2,
          DEFAULT: 3	//blank
        };
        if (plans && plans.length) {
          delaySort = function() {
            plans.sort(function (a, b) {
              var result;
              a.planInfo.targetedPlanInd = a.targetPlanInd ? a.targetPlanInd : TARGET.DEFAULT;
              b.planInfo.targetedPlanInd = b.targetPlanInd ? b.targetPlanInd : TARGET.DEFAULT;
              result = a.planInfo.targetedPlanInd - b.planInfo.targetedPlanInd;
              if (result === 0){
                result = a.planInfo.planPrice - b.planInfo.planPrice;
              }
              return result;
            });
            deferred.resolve(plans);
          };
          onDelaySort = $timeout(function(){
            delaySort();
          },0);
        } else {
          deferred.resolve(plans);
        }
        return deferred.promise;
      };

    return service;
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .factory('pricePlanChanges', ["$rootScope", "pricePlanChangesData", "pricePlanChangesState", "$q", "localStorage", "pricePlanChangesCart", "pricePlanChangesErrors", "$modal", "resource", "userLanguage", "settings", function($rootScope, pricePlanChangesData, pricePlanChangesState, $q, localStorage,
                                        pricePlanChangesCart, pricePlanChangesErrors, $modal, resource, userLanguage, settings) {
    var service = {};

    service.userSelections = pricePlanChangesState.resetUserSelections();

    $rootScope.$on('available-plan-details-expanded', function(event, args) {
      //*** The subscribing details button emits this event ***//
      // capture plan we want to show details from
      service.userSelections.expandedPlan = fetchPlanFromArray(args.buttonId);
    });

    var fetchPlanFromArray = function (planCode) {
      var plan =  _.find(service.userSelections.availablePlansRaw, function(plan) {
          return plan.planInfo.planCode === planCode;
      });

      return plan;
    };

    var fetchAvailableAddOnFromArray = function(addOnCode) {
      return _.find(service.userSelections.availableAddOns , function(addOn) {
        return addOn.addonInfo.addOnCode === addOnCode;
      });
    };

    var setVisibilityOfExistingAddOns = function() {
      // if the existing Add-On is present in array of dupes, don't display it
      _.each(service.userSelections.existingAddons, function(addOn) {
        var isDuplicate = _.any(service.userSelections.duplicateAddons, function(dupe) {
          return dupe.addonInfo.addOnCode === addOn.addonInfo.addOnCode;
        });

        if(isDuplicate) {
          addOn.invisble = isDuplicate;
          addOn.selected = false;
        }
      });
    };

    var reconcileAddOns = function() {
      setVisibilityOfExistingAddOns();
    };

    var calculateTotal = function() {
      var addOnTotal = _.chain(service.userSelections.existingAddOns)
                        .filter(function(addOn) {
                            return addOn.selected;
                          })
                        .sum(function(addOn) {
                            return addOn.addonInfo.addOnPrice;
                          }).value();

      addOnTotal += _.chain(service.userSelections.availableAddOns)
                     .filter(function(addOn) {
                         return addOn.selected;
                       })
                     .sum(function(addOn) {
                         return addOn.addonInfo.addOnPrice;
                       }).value();

      var planPrice = service.userSelections.selectedPlan ? service.userSelections.selectedPlan.planInfo.planPrice : 0;
      var total = addOnTotal + planPrice;

      return total.toFixed(2);
    };

    var updateCart = function() {
      // this appears redundant but in the future the 'cart' will encompass more than PricePlanChanges
      pricePlanChangesCart.newPlan = service.userSelections.selectedPlan;
      pricePlanChangesCart.addOns = getSelectedAddOns();
      pricePlanChangesCart.isProrated = service.userSelections.isProrated;

      var newCost = calculateTotal();
      pricePlanChangesCart.totalCost = newCost;
      service.userSelections.totalCost = newCost;
      service.userSelections.rewardsPoints = Math.round(newCost);
    };

    var getSelectedAddOns = function() {
      var existing = _.filter(service.userSelections.existingAddOns, function(addOn) {
                       return addOn.selected;
                     });

      var available = _.filter(service.userSelections.availableAddOns, function(addOn) {
                       return addOn.selected;
                     });

      //return existing.concat(available);
      return available;
    };

    service.getWireLessAccounts = function(accountNumber) {
      return pricePlanChangesData.getWireLessAccounts(accountNumber);
    };

    service.getPlan = function(ctn) {
      return pricePlanChangesData.getPlan(ctn);
    };

    service.getCtnList = function() {
      var deferred = $q.defer();

      service.getWireLessAccounts(localStorage.getLocalStorageValue('accountNumber'))
        .then(function(data) {
          // we default to the first CTN, go ahead and retrieve their plan
          service.getPlan(data[0].subNumbers[0])
            .then(function(planData) {
              service.userSelections.plan = planData.plan;
              service.userSelections.existingAddOns = planData.addOns;
            });

          // capture the first number
          service.userSelections.ctn = data[0].subNumbers[0];

          // resolve with array of phone numbers
          deferred.resolve(data[0].subNumbers);
        })
        .then(null, function(data) {
          deferred.reject(data.message);
        });

      return deferred.promise;
    };

    service.selectCtn = function(ctn) {
      var deferred = $q.defer();

      service.getPlan(ctn)
        .then(function(planData) {
          pricePlanChangesCart.ctn = ctn;
          service.userSelections.ctn = ctn;
          service.userSelections.plan = planData.plan;
          service.userSelections.existingAddOns = planData.addOns;

          deferred.resolve(service.userSelections.plan);
        })
        .then(null, function(errorMessage){
          deferred.reject(errorMessage);
        });

      return deferred.promise;
    };

    service.getAvailablePlans = function(ctn, planCode, currentCategory, planPrice, billing_postalCode) {
      return pricePlanChangesData.getAvailablePlans(ctn, planCode, currentCategory, planPrice, billing_postalCode);
    };

    service.expandPlan = function(planCode) {
      // capture expanded to show details
      service.userSelections.expandedPlan = fetchPlanFromArray(planCode);
    };

    service.getExpandedPlan = function(planCode) {
      // capture expanded to show details
      return fetchPlanFromArray(planCode);
    };

    service.expandExistingAddOn = function(addOnCode) {
      // capture expanded to show details
      service.userSelections.expandedExistingAddOn = fetchPlanFromArray(addOnCode);
    };

    service.expandAvailableLDAddOn = function(addOnCode) {
      // capture expanded to show details
      service.userSelections.expandedAvailableLDAddOn = fetchAvailableAddOnFromArray(addOnCode);
    };

    service.expandAvailableCFAddOn = function(addOnCode) {
      // capture expanded to show details
      service.userSelections.expandedAvailableCFAddOn = fetchAvailableAddOnFromArray(addOnCode);
    };

    service.selectPlan = function(planCode) {
      // capture selected plan
      service.userSelections.selectedPlan = fetchPlanFromArray(planCode);
      // get the available add-ons for this plan
      pricePlanChangesData.getAvailableAddOns(planCode, service.userSelections.esisSessionId, service.userSelections.ctn)
        .then(function(data) {
          //**** mock data
          //data = data.data;
          //**** mock data
          if (data) {
            service.userSelections.availableAddOns = data.availableAddons;
            service.userSelections.duplicateAddons = service.filterAddOnsByType(service.userSelections.availableAddOns, 'Duplicated');
            service.userSelections.droppedAddons = service.filterAddOnsByType(service.userSelections.availableAddOns, 'dropped');
            //service.userSelections.availableAddOns = data.availableAddons;
            //service.userSelections.duplicateAddons = data.duplicateAddons;
            //service.userSelections.droppedAddons = data.droppedAddons;
            reconcileAddOns();
            updateCart();
          } else {
            if (data.result) {
              pricePlanChangesErrors.showError('Select Plan', data.result, ['OK'], {}, false);
            } else {
              updateCart();
            }
          }
        })
        .then(null, function(data){
          pricePlanChangesErrors.showError('Select Plan', data.result, ['OK'], {}, false);
        }
      );
    };

    service.removePlan = function() {
      // clear selected plan
      service.userSelections.selectedPlan = null;
      service.userSelections.availableAddOns = [];
      updateCart();
    };

    service.addOnsUpdated = function() {
      updateCart();
    };

    service.filterAddOns = function(addOns, type) {
      var filteredAddOns = _.filter(addOns, function(addOn) {
        return addOn.addonInfo.categoryName_En === type;
      });
      return filteredAddOns;
    };

    service.filterAddOnsByType = function(addOns, type) {
      var filteredAddOns = _.filter(addOns, function(addOn) {
        return addOn.addonType === type;
      });
      return filteredAddOns;
    };

    service.showProrationDetails = function() {
      if (!pricePlanChangesCart.billingCycleDay) { return; }
      $rootScope.modal = $modal.open({
        //templateUrl: 'scripts/directives/pricePlanChanges/timeline/timelineIndex.html',
        templateUrl: 'views/modals/proratedchangesexplanation.html',
        windowClass: 'prorated-modal',
        controller: ["$scope", function($scope) {
          $scope.billingCycleDay = pricePlanChangesCart.billingCycleDay;

          $scope.currentDate = new Date();

          var day = $scope.currentDate.getDate();
          var year = $scope.currentDate.getFullYear();
          var month = $scope.currentDate.getMonth();
          var lang = userLanguage();
          var months = resource.get('_months');
          switch (lang) {
            case 'en':
              $scope.changePlanDate = (months[month]).substring(0, 3) + ' ' + day;
              break;
            case 'fr':
              $scope.changePlanDate = day + ' ' + months[month];
              break;
          }

          $scope.lastBillDate = new Date(year, month - 1, $scope.billingCycleDay).getTime();
          $scope.thisBillDate = new Date(year, month, $scope.billingCycleDay).getTime();
          $scope.nextBillDate = new Date(year, month + 1, $scope.billingCycleDay).getTime();
          $scope.cancel = function () {
            $rootScope.modal.dismiss('cancel');
            $rootScope.modal = null;
          };
        }],
        //scope: $scope,
        size: 'md',
        backdrop: 'static'
        //keyboard: false,
        //backdropClass: 'bkg-modal',
        //resolve: {}
      });
    };


    	//IMPLEMENT SORTING MECHANISM FOR RECOMMENDED, EXCLUSIVE PLANS
    	//@see  - ng-repeat in available-plan.html
    	//@todo - make service
    	service.sortRecommendedExclusive = function (plans) {
    		if(plans.length){
    			//TEST DATA MECHANISM WHEN NO R/E DATA
	    		var TEST = false;//true;

	    		var TARGET = {
	    			RECOMMENDED: 1,
	    			EXCLUSIVE:	 2,
	    			DEFAULT: 	   3	//blank
	    		};

	    		//20150622		BACKEND now sending targetedPlanInd at same JSON level as planInfo
    			//20150622		targetedPlanInd now being sent as: 1 (RECOMMENDED), 2 (EXCLUSIVE) or 3 (NONE/DEFAULT).

	    		angular.forEach(plans, function(value, key) {
	    			//PLANS
	    			//@todo - modify directives to remove now duplicate property .planInfo.targetedPlanInd
	    			var targeted = plans[key];
	    			targeted.targetPlanInd = targeted.targetPlanInd || TARGET.DEFAULT;
	    			targeted.planInfo.targetedPlanInd = targeted.targetPlanInd;

            //TEST / DEMO
            if (TEST && settings.isLocal) {
              var TEST_R = [3,4];
              var TEST_E = [5,6];

              if (TEST_R.indexOf(key) > -1) {
                targeted.planInfo.targetedPlanInd = targeted.targetPlanInd = TARGET.RECOMMENDED;
              }

              if (TEST_E.indexOf(key) > -1) {
                targeted.planInfo.targetedPlanInd = targeted.targetPlanInd = TARGET.EXCLUSIVE;
              }
            }
	    		});

	  			//SORT
	  			plans.sort(function(a, b) {
	  					//return a.targetPlanInd - b.targetPlanInd;
					    return a.planInfo.targetedPlanInd - b.planInfo.targetedPlanInd;
					});

					//TEST, LOG
					/*if(TEST && settings.isLocal) {
						angular.forEach(plans, function(value, key) {
		   					console.log(plans[key], plans[key].targetedPlanInd, plans[key].planInfo.targetedPlanInd);
		   			});
		   		}*/
	    	}

    		return plans;
    	}

    return service;
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .factory('pricePlanTranslate', ["userLanguage", function(userLanguage) {
    var service = {};

    service.overageFr = function(input){
      if(userLanguage() == 'fr' && input)
        return input.replace('$','').replace('/','$ pour ').replace(/GB/i, ' Go').replace(/MB/i, ' Mo');

      return input || false;
    };

    return service;
  }]);

'use strict';

/**
 * @ngdoc service
 * @name webanalytics
 * @description
 * # webanalytics
 * Service in the totesApp.
 */
angular.module('selfServe')
  .service('omni', ["$window", function ($window) {
    // AngularJS will instantiate a singleton by calling "new" on this function
    //tag objects of all modules.
    /*    var _pageTags={
     'signin': 'home:signin',
     'registration': 'home:registration:contact-information',
     'forgetPassword': 'home:signin',
     'forgetusername': 'home:signin',
     'invalidPath': 'home:signin',
     'tempPassword': 'home:signin',
     'permissionDenied': 'home:signin',
     'tpsc': 'home:signin'
     };*/

    return {
      tagging: function (options) {
        $window.addOmnp(options);
      },
      tagPage: function( pageName, options){
        var _tagObj=[
          '_trackPageView',
          {pn: pageName}
        ];
        angular.forEach( options, function( value){
            _tagObj.push( value);
        });
        return this.tagging( _tagObj);
      },

      tagLink: function( options){
        var _tagObj=[
          '_trackLink'
        ];
        angular.forEach( options, function( value){
          _tagObj.push( value);
        });
        this.tagging( _tagObj );
      },
      tagFormValidationErrors : function (pageName, errorObj) {

        if (!pageName || !errorObj) {
          return;
        }

        // Form is NOT valid, tag the errors
        var msg = '';
        var numRequiredErrors = (errorObj.required && errorObj.required.length) || 0;
        var numPatternErrors = (errorObj.pattern && errorObj.pattern.length) || 0;

        for (var i = 0; i < numRequiredErrors; i++) {

          msg = webanalytics.formatErrorMessage(pageName, errorObj.required[i].$name, 1, null);
          appState.tagging(['_trackLink',
            {eVar49: msg},
            {event15: ''}// Generic Error
          ]);
        }

        for (var j = 0; j < numPatternErrors; j++) {

          msg = webanalytics.formatErrorMessage(pageName, errorObj.pattern[i].$name, 2, null);
          appState.tagging(['_trackLink',
            {eVar49: msg},
            {event15: ''}// Generic Error
          ]);
        }
      },

      formatErrorMessage: function (page, controlName, errorType, errorMessage) {
        var message = '';

        if (errorType === 1) {
          message = controlName + ' is empty;';
        }

        if (errorType === 2) {
          message = controlName + ' pattern is invalid;';
        }

        if (errorType === 3) {
          message = controlName + ' is ' + errorMessage;
        }
        return 'Validation Error---' + 'Page: ' + page + ':' + message;
      },
      getPageTagObj: function (module) {
        var _pageName = 'home:signin';// the tagging page name of the

        return ['_trackPageView',
          {pn: _pageName}
        ];
      }

    };

  }]);

(function (_, $) {
  'use strict';
  angular
    .module('selfServe')
    .factory('selfServeSvc', ['ajax', '$http', 'settings', '$modal', '$q', 'resource', 'omni', '$rootScope','myrAccountListService', function (ajax, $http, settings, $modal, $q, resource, omni, $rootScope,myrAccountListService) {
      var userProfile,
        accounts,
        currentAccount,
        marketingPermissions = {
          "mks": [
            {"MktgChannel": "TEXT_MESSAGING", "PlClassCD": "WIRELESS", "PermissionGrantedInd": "YES"},
            {"MktgChannel": "TEXT_MESSAGING", "PlClassCD": "CABLE", "PermissionGrantedInd": "YES"},
            {"MktgChannel": "TEXT_MESSAGING", "PlClassCD": "INTERNET", "PermissionGrantedInd": "YES"},
            {"MktgChannel": "TEXT_MESSAGING", "PlClassCD": "HOME_PHONE", "PermissionGrantedInd": "YES"},
            {"MktgChannel": "DIRECT_MAIL", "PlClassCD": "WIRELESS", "PermissionGrantedInd": "YES"},
            {"MktgChannel": "DIRECT_MAIL", "PlClassCD": "CABLE", "PermissionGrantedInd": "YES"},
            {"MktgChannel": "DIRECT_MAIL", "PlClassCD": "INTERNET", "PermissionGrantedInd": "YES"},
            {"MktgChannel": "DIRECT_MAIL", "PlClassCD": "HOME_PHONE", "PermissionGrantedInd": "YES"},
            {"MktgChannel": "EMAIL", "PlClassCD": "HOME_PHONE", "PermissionGrantedInd": "YES"},
            {"MktgChannel": "TELEMARKETING", "PlClassCD": "HOME_PHONE", "PermissionGrantedInd": "YES"}
          ]
        },
        provinces = [
          {label: "Alberta", value: "AB"},
          {label: "Britsh Columbia", value: "BC"},
          {label: "Manitoba", value: "MB"},
          {label: "New Brunswick", value: "NB"},
          {label: "Newfoundland", value: "NL"},
          {label: "Nova Scotia", value: "NS"},
          {label: "Northwest Territories", value: "NT"},
          {label: "Nunavut", value: "NU"},
          {label: "Ontario", value: "ON"},
          {label: "Prince Edward Island", value: "PE"},
          {label: "Québec", value: "QC"},
          {label: "Saskatchewan", value: "SK"},
          {label: "Yukon Territory", value: "YT"}
        ];

      var findProfileByAccountName = function (accountName) {
        var profile = _.find(profilePage.accounts, function (obj) {
          return obj.accountName === accountName;
        });

        return profile;
      };
      var loginSecurityQuestions = [];
      function buildAddressLineForSubmit(updates) {
        var validStreet = updates.Street_name && updates.Street_type && updates.Street_number;
        var streetPortion = "";
        var address = "";

        if (validStreet) {
          return updates.Street_number + " " + updates.Street_name + " " + updates.Street_type;
        }

      }

      function buildAddressLineForUI(updates) {
        var addressAsEntered = "";
        var streetPortion = "";
        var apartmentPortion = "";
        var cityAndProvince = "";

        var validStreet = updates.Street_name && updates.Street_type && updates.Street_number;
        var validAptType = updates.AptType && updates.AptNo;
        var validCountry = updates.postalCode && updates.province && updates.country;

        if (validStreet) {
          streetPortion = updates.Street_number + " " + updates.Street_name + " " + updates.Street_type + " ";
        }

        if (validAptType) {
          apartmentPortion = updates.AptType + " " + updates.AptNo + ", ";
        }

        if (validCountry) {
          cityAndProvince = updates.city + ", " + updates.postalCode + ", " + updates.province + ", " + updates.country;
        }

        if (validStreet) {
          addressAsEntered = streetPortion;
          if (validAptType) {
            addressAsEntered += apartmentPortion;
          }
          if (validCountry) {
            addressAsEntered += cityAndProvince;
          }
        }

        return addressAsEntered;
      }

      function isLanguageChanged(language) {
        return (currentAccount.contactInformation.language !== language);
      }

      function isContactAddressChanged(updates) {
        return !angular.equals(updates, currentAccount.contactInformation);
      }

      function isEmailChanged(updates) {
        return !angular.equals(updates.email, currentAccount.contactInformation.email);
      }

      function update(updates, type, onSuccess, onError) {
        var updateObj = {};
        var selectedAccount = currentAccount;

        updateObj.accountType = selectedAccount.accountTypeNumber;
        updateObj.update_accountNumber = selectedAccount.accountNumber;
        updateObj.addresskey = selectedAccount.addresskey;
        updateObj.consolidated = selectedAccount.consolidated;

        if (selectedAccount.consolidated === true && selectedAccount.accountNumber.length === '12') {
          if (selectedAccount.subNumbers) {
            updateObj.accountNumber = selectedAccount.subNumbers[0];
          }
        }

        // initializing the flags
        updateObj.AddressChanged = false;
        updateObj.ContactChanged = false;
        updateObj.LanguageChanged = false;
        updateObj.EmailChanged = false;

        // updating LANG implies contact information object is received
        if (type === "lang" || type === "contactlang") {
          updateObj.LanguageChanged = true;
          updateObj.contactLanguage = updates.language;
        }

        if (type === "address") {
          updateObj.province = updates.selectedProvince ? updates.selectedProvince.value : updates.province;
          updateObj.primaryline = updates.billing_streetAddress;
          updateObj.postalcode = updates.billing_postalCode || updates.postalCode;
          updateObj.country = updates.country || "CAN";
          updateObj.city = updates.billing_city || updates.city;
          updateObj.aptNumber = updates.AptNo || "";
          updateObj.aptType = updates.AptType || "";

          if (updateObj.aptNumber === "") {
            updateObj.aptType = "";
          }

          updateObj.AddressChanged = true;
        }

        if (type === "contact" || type === "contactlang") {
          updateObj.contactLanguage = updates.language;
//        updateObj.emailAddress = updates.email; //
          if (!updates.contactNumber2) {
            updateObj.businessPhone = "9999999999";
          } else {
            updateObj.businessPhone = updates.contactNumber2;
          }

          if(!updates.contactNumber1) {
            updateObj.homePhone = "9999999999";
          } else {
            updateObj.homePhone = updates.contactNumber1;
          }

          if (!updates.extension) {
            updateObj.ext = "00";
          } else {
            updateObj.ext = updates.extension; // verify this
          }

          updateObj.ContactChanged = true;
          updateObj.LanguageChanged = isLanguageChanged(updateObj.contactLanguage);
          updateObj.EmailChanged = isEmailChanged(updates);
        }
        if (type === "email") {
          updateObj.emailAddress = updates.email; //
          updateObj.EmailChanged = true;
        }

        if (type === "address" && updates.billingType && updates.billingTypeModified) {
          var arrayPromise = [];
          var onErrorHandler = onError;

          if (updates.billingTypeModified) {
            var updateBillingTypePromise = ajax.updateBillingType({
              accountNumber: updateObj.update_accountNumber,
              billingType: updates.billingType
            }).then(function () {
              onSuccess();
            }, function (data) {
              onErrorHandler(data);
            });
          } else {
            var setAddress = ajax.setAddressContLang(updateObj).then(function (success) {
              var updateBillingTypePromise = ajax.updateBillingType({
                accountNumber: updateObj.update_accountNumber,
                billingType: updates.billingType
              }).then(function () {
                onSuccess();
              }, function (data) {
                onErrorHandler(data);
              });
            }, function (data) {
              onError(data);
            });
          }

          return;
        }

        return ajax.setAddressContLang(updateObj).then(
          function (result) {
            onSuccess();
          },
          function (data) {
            onError(data);
          });
      }

      return {
        getAccountByAccountNumber: function (accountNumber) {
          for (var i = 0; i < accounts.length; i++) {
            if (accounts[i].accountNumber === accountNumber) {
              return accounts[i];
            }
          }
        },
        getStates: function () {
          return states;
        },
        removeAccountFromList: function (account) {
          // find account using identifier
          var identifier = account.identifier;

          for (var i = 0; i < accounts.length; i++) {
            if (accounts[i].identifier === identifier) {

              if (identifier === currentAccount.identifier) {
                currentAccount = accounts[0]; //
              }

              accounts.splice(i, 1);
              break;
            }
          }
        },
        disassociateAccount: function (obj) {
          return ajax.disassociateAccount(obj);
        },
        transformtoUnfriendlyMarketingPermissions: function (obj) {
          var obj = this.transformtoFriendlyMarketingPermissions().objArray;

          var permObj,
            i = 0;

          var objArray = [];

          while (permObj = obj[i]) {
            for (var permission in permObj.Permissions) {
              var k = {};
              k.MktgChannel = permObj.MarketingChannel;
              if (permission === "wireless") {
                k.PlClassCD = "WIRELESS";
                k.PermissionGrantedInd = permObj.Permissions[k] === true ? 'YES' : 'NO';
              }
              if (permission === "cable") {
                k.PlClassCD = "CABLE";
                k.PermissionGrantedInd = permObj.Permissions[k] === true ? 'YES' : 'NO';
              }
              if (permission === "internet") {
                k.PlClassCD = "INTERNET";
                k.PermissionGrantedInd = permObj.Permissions[k] === true ? 'YES' : 'NO';
              }
              if (permission === "homephone") {
                k.PlClassCD = "HOME_PHONE";
                k.PermissionGrantedInd = permObj.Permissions[k] === true ? 'YES' : 'NO';
              }
              objArray.push(k);
            }
            i++;
          }

          return {"mks": objArray}
        },
        transformtoFriendlyMarketingPermissions: function (marketingPermissionsServer) {
          var self = this;
          var channelPermissions = function () {
            this.MarketingChannel = "",
              this.Permissions = {
                wireless: false,
                cable: false,
                internet: false,
                homephone: false,
                homemonitoring: false
              };

            this.setPermission = function (label, value) {
              if (label === "WIRELESS") {
                if (value === "YES") {
                  this.Permissions.wireless = true;
                }
              }

              if (label === "INTERNET") {
                if (value === "YES") {
                  this.Permissions.internet = true;
                }
              }

              if (label === "CABLE") {
                if (value === "YES") {
                  this.Permissions.cable = true;
                }
              }

              if (label === "HOME_PHONE") {
                if (value === "YES") {
                  this.Permissions.homephone = true;
                }
              }

              if (label === "SMART_HOME_MONITORING") {
                if (value === "YES") {
                  this.Permissions.homemonitoring = true;
                }
              }
            };

            this.toArray = function () {
              return {
                MarketingChannel: this.MarketingChannel,
                Permissions: {
                  wireless: this.Permissions.wireless,
                  cable: this.Permissions.cable,
                  internet: this.Permissions.internet,
                  homephone: this.Permissions.homephone,
                  homemonitoring: this.Permissions.homemonitoring
                }
              }
            }
          };

          var permissionsArray = [];

          var marketingPermissionsServer = marketingPermissions.mks;

          for (var i = 0; i < marketingPermissionsServer.length; i++) {
            var mkp = marketingPermissionsServer[i];
            var channel = mkp.MktgChannel;

            // find the channel in existing array
            var obj = _.find(permissionsArray, {MarketingChannel: channel});

            if (obj) {
              var label = mkp.PlClassCD;
              var value = mkp.PermissionGrantedInd;
              obj.setPermission(label, value);
            } else {
              var cp = new channelPermissions();
              var label = mkp.PlClassCD;
              var value = mkp.PermissionGrantedInd;

              cp.MarketingChannel = mkp.MktgChannel;
              cp.setPermission(label, value);
              permissionsArray.push(cp);
            }
          }

          var permissionsArrayObject = [];
          for (var i = 0; i < permissionsArray.length; i++) {
            var o = permissionsArray[i];
            permissionsArrayObject.push(o.toArray());
          }

          var literalObj = {};
          for (var j = 0; j < permissionsArrayObject.length; j++) {
            literalObj[permissionsArrayObject[j].MarketingChannel] = permissionsArrayObject[j];
          }
          return {
            literal: literalObj,
            objArray: permissionsArrayObject
          };
        },
        transformMarketingPermissions: function(serverResponse) {
          var productCategories = _.uniq(serverResponse.map(function(marketingPermission) {
            return marketingPermission.plClassType;
          }));
          var transformedPermissions = {};
          productCategories.forEach(function(productCategory) {
            transformedPermissions[productCategory] = {};
            var matchingChannels = serverResponse.filter(function(marketingPermission) {
              return marketingPermission.plClassType == productCategory;
            });
            matchingChannels.forEach(function(matchingChannel) {
              transformedPermissions[productCategory][matchingChannel.marketingChannel] = matchingChannel.permissionGranted;
            });
          });
          return transformedPermissions;
        },
        generateUUID: function generateUUID() {
          var d = new Date().getTime();
          var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
          });
          return uuid;
        },
        getProvinces: function () {
          return provinces;
        },
        getBillingAddressForAccount: function (account) {
          for (var i = 0; i < accounts.length; i++) {
            if (account.identifier = accounts[i].identifier) {
              return accounts[i].billingAddress;
            }
          }
        },
        buildBillingAddress: function (obj) {
          obj = obj.billingAddress;
          if (!obj) {
            return {noBillingAddress: true};
          }

          var billingAddress = {};
          billingAddress = obj;
          if (obj.billingType === 'INVOICE') {
            billingAddress.paper = true;
          } else if (obj.billingType === 'eBill') {
            billingAddress.ebill = true;
          }
          billingAddress.billingType = obj.billingType;
          billingAddress.billing_city = obj.city;
          billingAddress.billing_postalCode = obj.postalCode;
          billingAddress.billing_province = obj.province;
          billingAddress.billing_streetAddress = '';
          billingAddress.Street_number = obj.Street_number || obj.streetNumber;
          billingAddress.Street_type = obj.Street_type || obj.streetType;
          billingAddress.Street_name = obj.Street_name || obj.streetName;
          billingAddress.AptNo = obj.AptNo || obj.unit;
          billingAddress.AptType = obj.AptType || 'APT';

          if (obj.AptNo) {
            billingAddress.billing_streetAddress = "#" + obj.AptNo + " ";
          }
          billingAddress.billing_streetAddress += obj.Street_number + " " +
            obj.Street_name + " " + obj.Street_type + ", " + obj.city + ", " + obj.province + ", " + obj.postalCode;
          billingAddress.provinces = provinces; // this should break part of the closure
          billingAddress.country = 'CA';
          billingAddress.selectedProvince = _.find(provinces, { value: billingAddress.billing_province });
          if (!billingAddress.selectedProvince && billingAddress.billing_province !== '') {
            billingAddress.country = 'US';
          }

          // for (var i = 0; i < billingAddress.provinces.length; i++) {
          //   var province = billingAddress.provinces[i];
          //   if (province.value === billingAddress.billing_province) {
          //     billingAddress.selectedProvince = province;
          //     break;
          //   }
          // }

          return billingAddress;
        },
        buildContactInformation: function (account, obj) {
          var contactInfo = {};
          var contactObj = obj.contactInfo;

          contactInfo.language = contactObj.language || "";

          if (contactObj.homePhone === "0000000000" || contactObj.homePhone ==="9999999999") {
            contactInfo.contactNumber1 = "";
          } else {
            contactInfo.contactNumber1 = contactObj.homePhone || "";
          }

          if (contactObj.businessPhone === "0000000000" || contactObj.businessPhone === "9999999999") {
            contactInfo.contactNumber2 = "";
          } else {
            contactInfo.contactNumber2 = contactObj.businessPhone || "";
          }

          contactInfo.email = contactObj.emailAddress || "";

          if (contactObj.extension === "0" || contactObj.extension === "00" || contactObj.extension === "000"
            || contactObj.extension === "0000" || contactObj.extension === "00000" || contactObj.contactNumber2 === ""
          ) {
            contactInfo.extension = "";
          } else {
            contactInfo.extension = contactObj.extension || "";
          }

          return contactInfo;
        },
        buildSubAccounts: function (account, data) {
          var arr = [];
          var subList = data.subList;
          for (var i = 0; i < subList.length; i++) {
            var subListObj = subList[i];
            var obj = {};
            obj.name = subListObj.name ? subListObj.name : 'Jane Smith';
            obj.accountNumber = subListObj.subAccountId;

            arr.push(obj);
          }

          return arr;
        },
        getAccountDetails: function (account, defer) {
          var self = this;

          function handleSuccessResponse(data) {

            account.details = data;
            account.billingAddress = self.buildBillingAddress(data);
            account.billingAddress.accountId = account.billingAddress && account.identifier;
            account.contactInformation = self.buildContactInformation(account, data);
            account.subAccounts = self.buildSubAccounts(account, data);
            account.addresskey = data.addresskey;

            defer.resolve(account);
          };

          function handleFailureResponse(data) {
            defer.reject(data);
          };
          return ajax.getAccountDetail({
            accountNumber: account.accountNumber,
            accountTypeNumber: account.accountTypeNumber,
            applicationId: 'Rogers.com',
            refresh: false
          }, true).then(function (data) {
            if (data.cachedResultInfo && data.cachedResultInfo.expired) {
              return ajax.getAccountDetail({
                accountNumber: account.accountNumber,
                accountTypeNumber: account.accountTypeNumber,
                applicationId: 'Rogers.com',
                refresh: true
              }).then(function (data) {
                handleSuccessResponse(data);
              }, function (data) {
                handleFailureResponse(data);
              });
            }
            handleSuccessResponse(data);
          }, function (data) {
            handleFailureResponse(data);
          });
        },
        getAccounts: function () {
          for (var i = 0; i < accounts.length; i++) {
            // get name
            var account = accounts[i];
            var accountName = account.accountName;
            if (account && accountName)
              var name = accountName.firstName + " " + accountName.lastName;
            account.name = name || "";
            account.accountLabel = account.accountType ? account.accountType : '' + ' #' + account.accountNumber;
            account.identifier = this.generateUUID();
            account.consolidated = account.postpaidAccountBalance ? account.postpaidAccountBalance.consolidated : false;
          }
          currentAccount = accounts[0];
          return accounts;
        },
        getAccountList: function (defer) {

          function handleSuccessResponse(data) {
            defer.resolve(data);
          };

          function handleFailureResponse(data) {
            defer.reject(data);
          };

          return ajax.getAccountList({applicationId: 'Rogers.com', refresh: false}, true).then(function (data) {
            accounts = data.accountList || [];
            $rootScope.$emit('initializeMbhLauncher', data);
            if (data.cachedResultInfo && data.cachedResultInfo.expired) {
              return ajax.getAccountList(
                { applicationId: 'Rogers.com', refresh: true }, true
              ).then(function (data) {
                $rootScope.$emit('initializeMbhLauncher', data);
                myrAccountListService.processAccountList(data);
                handleSuccessResponse(data);
              }, function (data) {
                handleFailureResponse(data);
              });
            }

            if (accounts.length === 0) {
              defer.reject();
              return;
            }
            handleSuccessResponse(data);

          }, function (data) {
            handleFailureResponse(data);
          });
        },
        getSecretQuestionList: function () {
          return secretQuestions;
        },
        getLoginSecurityQuestions: function () {
          loginSecurityQuestions = [];
          for (var i = 1; i <=8; i++) {
            loginSecurityQuestions.push({value: i.toString(), label: resource.get('login_security_questions_' + i)});
          }
          return loginSecurityQuestions;
        },
        getUserInfo: function () {
          var questionIndex = parseInt(userProfile.questionNo || 0, 10);

          var matchedQuestions = loginSecurityQuestions.filter(function(q){
            return q.value == questionIndex;
          });
          userProfile.secretQuestion = matchedQuestions && angular.isArray(matchedQuestions) && matchedQuestions.length > 0 && matchedQuestions[0].hasOwnProperty('label') ? matchedQuestions[0].label : '';
          userProfile.secretQuestions = loginSecurityQuestions;
          userProfile.questionNo = questionIndex;
          userProfile.oldPassword = "";
          userProfile.confirmPassword = "";
          userProfile.newPassword = "";

          return userProfile;
        },
        getContactInformation: function (accountName) {
          var profile = findProfileByAccountName(accountName);
          // augment object with two properties
          profile.contactInformation.english = false;
          profile.contactInformation.french = false;

          if (profile.contactInformation.language.toLowerCase() === 'french') {
            profile.contactInformation.french = true;
          } else {
            profile.contactInformation.english = true;
          }

          return profile.contactInformation;
        },
        getContactInformationForAccount: function (account) {
          for (var i = 0; i < accounts.length; i++) {
            if (account.identifier = accounts[i].identifier) {
              return accounts[i].contactInformation;
            }
          }
        },
        getMarketingPermissions: function (accountNumber) {
          return ajax.getMarketingPermissions({
            accountNumber: accountNumber
          });
        },
        getUserProfile: function (defer) {
          return ajax.getUserInfo().then(function (data) {
            if (data.errorMessage) {
              defer.reject();
              return;
            }
            userProfile = data;

            defer.resolve();
          }, function () {
            defer.reject();
          });
        },
        _update: function (updates, type, onsuccess, onError) {
          return update(updates, type, onsuccess, onError);
        },
        updateBillingType: function (updates, defer) {
          var billingType = updates.billingType;
          var accountNumber = currentAccount.accountNumber;

          $rootScope.updateBillingType = false;
          return ajax.updateBillingType({
            accountNumber: accountNumber,
            billingType: billingType
          }).then(function (data) {
            if (updates.billingType === 'INVOICE') {
              currentAccount.billingAddress.billingType = 'INVOICE';
              currentAccount.billingAddress.paper = true;
              currentAccount.billingAddress.ebill = false;
            } else if (updates.billingType === 'E_BILL') {
              currentAccount.billingAddress.billingType = 'E_BILL';
              currentAccount.billingAddress.ebill = true;
              currentAccount.billingAddress.paper = false;
            }
            defer.resolve();
            $rootScope.updateBillingType = true;
            var modalData = {
              billingType: billingType
            };
            var modalInstance = $modal.open({
              templateUrl: "views/modals/update-billing-type.html",
              windowClass: "verify-address-modal",
              controller: ["$scope", "selfServeSvc", function ($scope, selfServeSvc) {
                $scope.data = modalData;
                $scope.close = function () {
                  modalInstance.close();
                  defer.notify();
                };
              }]
            });
          }, function (data) {
            defer.reject();
          });
        },
        updateBillingAddress: function (updates, defer, form) {
          //update billing type
          if (currentAccount.billingAddress.billingType !== updates.billingType) {
            return this.updateBillingType(updates, defer, form);
          }

          var addressAsEntered = buildAddressLineForUI(updates);
          var verifyAddressObj = {};

          form.$setSubmitted(); //
          verifyAddressObj.city = updates.city;
          verifyAddressObj.province = updates.province; // this is probably missing
          verifyAddressObj.postalcode = updates.postalCode;
          verifyAddressObj.address = buildAddressLineForSubmit(updates);
          verifyAddressObj.aptNumber = updates.AptNo;
          if (updates.AptNo) {
            verifyAddressObj.aptType = updates.AptType ? updates.AptType : 'Apt';
          }
          verifyAddressObj.country = updates.country;

          var promiseArray = [];

          var verifyAddressReq = ajax.verifyAddress(verifyAddressObj).then(
            function (result) {
              var canadaPostAddress = "";

              if (result.addressVerificationResponse) {
                var address = result.addressVerificationResponse.address;
                canadaPostAddress = address.primaryLine + ", " + address.city + ", "
                  + address.postCode + ", " + address.province + ", " + address.country;
                var modalData = {
                  address: addressAsEntered,
                  canadaPostAddress: canadaPostAddress || ''
                };

                //console.log("CANADA POST RESPONSE");
                //console.log(address);
                //console.log(updates);

                var addressInfo = {
                  streetNumber: address.streetNo,
                  streetName: address.streetName,
                  streetType: address.streetSuffix
                };
                var canadaPostResponseForSubmit = {
                  province: address.province,
                  billing_streetAddress: address.primaryLine, // this might have to be constructed ?
                  billing_postalCode: address.postCode,
                  country: address.country,
                  billing_city: address.city,
                  AptNo: updates.AptNo, //address.aptNumber || '', // canada post not returning apt number
                  AptType: updates.AptType
                };

                var oldBillingType = currentAccount.billingAddress.billingType;
                var newBillingType = updates.billingType;
                var isWirelessAccount = currentAccount.accountNumber.length < 12;

                if (oldBillingType !== newBillingType && isWirelessAccount) {
                  canadaPostResponseForSubmit.billingType = newBillingType;
                  canadaPostResponseForSubmit.billingTypeModified = true;
                }

                var modalInstance = $modal.open({
                  templateUrl: "views/modals/verify-billing-address.html",
                  windowClass: "verify-address-modal",
                  controller: ["$scope", "selfServeSvc", function ($scope, selfServeSvc) {
                    $scope.data = modalData;
                    $scope.close = function () {
                      modalInstance.close();
                      defer.notify();
                    };
                    $scope.submitCanadaPostAddress = function () {
                      selfServeSvc._update(canadaPostResponseForSubmit, "address", onsuccess, onError);

                      function onsuccess() {
                        _.merge(currentAccount.billingAddress, canadaPostResponseForSubmit);
//                        _.merge(currentAccount.billingAddress, addressInfo);
//console.dir(addressInfo);
                        currentAccount.billingAddress.billing_streetAddress = canadaPostAddress;
                        currentAccount.billingAddress.Street_name = addressInfo.streetName;
                        currentAccount.billingAddress.Street_number = addressInfo.streetNumber;
                        currentAccount.billingAddress.Street_type = addressInfo.streetType;
                        modalInstance.close();
                        defer.resolve();
                      }

                      function onError(data) {
                        modalInstance.close();
                        defer.reject();
                      }

                    };
                    $scope.submit = function () {
                      selfServeSvc.saveAddressAsEntered(updates, modalInstance, defer, form);
                    };
                  }]
                });
              } else {
                $rootScope.verifyAddressFailed = true;
              }
            },
            function (data) {
              // data .. failure verify address failed
              // console.log(data);
              $rootScope.verifyAddressFailed = true;
              defer.reject();
            }
          );
        },
        updatePinEmailAddress: function (updates, defer, form) {
          //return ajax.updatePinEmail({
          //  accountType: currentAccount.a,
          //  update_accountNumber: currentAccount.accountNumber,
          //  email: updates.email
          //});
        },
        updateEmailAddress: function (updates, defer, form) {
          function onSuccess() {
            _.merge(currentAccount.contactInformation, updates);
            defer.resolve();
          }

          function onError(data) {
            defer.reject();
          }

          return update(updates, 'email', onSuccess, onError);
        },
        updateContactInformation: function (updates, defer, form) {
          // console.log("UPDATING CONTACT INFORMATION!!");

          var languageChanged = isLanguageChanged(),
            contactAddressChanged = isContactAddressChanged(updates);

          var updateType = "";

          if (languageChanged && !contactAddressChanged) {
            updateType = "lang";
          } else if (!languageChanged && contactAddressChanged) {
            updateType = "contact";
          } else if (languageChanged && contactAddressChanged) {
            updateType = "contactlang";
          }

          function onSuccess() {
            _.merge(currentAccount.contactInformation, updates);
            defer.resolve();
          }

          function onError(data) {
            defer.reject();
          }

          if (updateType !== '') {
            return update(updates, updateType, onSuccess, onError);
          }
        },
        setCurrentAccount: function (account) {
          currentAccount = account;
        },
        getCurrentAccount: function () {
          if (currentAccount) {
            return currentAccount;
          }
        },
        buildAddressLineForSubmit: function (updates) {
          var validStreet = updates.Street_name && updates.Street_type && updates.Street_number;
          var validAptType = updates.AptType && updates.AptNo;
          var streetPortion = "";
          var apartmentPortion = "";
          var address = "";

          if (validStreet) {
            streetPortion = updates.Street_number + " " + updates.Street_name + " " + updates.Street_type + " ";
          }

          if (validAptType) {
            apartmentPortion = updates.AptType + " " + updates.AptNo;
          }

          if (validStreet) {
            address = streetPortion;
            if (validAptType) {
              address += apartmentPortion;
            }
          }

          return address;
        },

        saveAddressAsEntered: function (updates, modalInstance, defer, form) {
          var verifyAddressObj = {};
          var addressAsEntered = buildAddressLineForSubmit(updates);
          var addressForUI = buildAddressLineForUI(updates);

          verifyAddressObj.Street_number = updates.Street_number;
          verifyAddressObj.Street_name = updates.Street_name;
          verifyAddressObj.Street_type = updates.Street_type;
          verifyAddressObj.AptType = updates.AptType;
          verifyAddressObj.AptNo = updates.AptNo;
          verifyAddressObj.billing_postalCode = updates.postalCode;
          verifyAddressObj.province = updates.province;
          verifyAddressObj.billing_city = updates.city;
          verifyAddressObj.billing_streetAddress = addressAsEntered;
          verifyAddressObj.postalCode = updates.postalCode;
          verifyAddressObj.city = updates.city;

          function onSuccess() {
            var accountIdentifier = updates.accountId;
            if (accountIdentifier) {
              var account = _.find(accounts, {identifier: accountIdentifier}, 'identifier');
              _.merge(account.billingAddress, verifyAddressObj);
              currentAccount.billingAddress.billing_streetAddress = addressForUI;

              defer.resolve();
            }
            modalInstance.close();
          }

          function onError(data) {
            modalInstance.close();
            defer.reject();
          }

          return update(verifyAddressObj, "address", onSuccess, onError);
        },
        updateAccountInfo: function (updates, defer, form) {
          var updatesToSend = {
            userName: updates.userName,
            userId: updates.userName
          };

          form.$submitted = true;

          // password changed
          if (updates.newPassword !== "") {
            updatesToSend.oldPassword = updates.oldPassword;
            updatesToSend.newPassword = updates.newPassword;
            updatesToSend.confirmPassword = updates.confirmPassword;
            userProfile.questionNo = updates.questionNo;
            updatesToSend.questionNo = updates.questionNo || userProfile.questionNo;

            if (updates.answer === userProfile.answer) {
              updatesToSend.answer = userProfile.answer;
            } else {
              updatesToSend.answer = updates.answer;
            }
          }
          // secret question changed
          if (updates.questionNo !== "" || updates.answer != "") {
            userProfile.questionNo = updates.questionNo;
            updatesToSend.questionNo = updates.questionNo;
            updatesToSend.answer = updates.answer;
          }

          return ajax.updateUserInfo(updatesToSend)
            .then(
            function (data) {
              _.merge(userProfile, updates);
              var matchedQuestions = loginSecurityQuestions.filter(function(q){
                return q.value == updatesToSend.questionNo;
              });
              userProfile.secretQuestion = matchedQuestions && angular.isArray(matchedQuestions) && matchedQuestions.length > 0 && matchedQuestions[0].hasOwnProperty('label') ? matchedQuestions[0].label : '';
              defer.resolve(data);
            },
            function (data) {
              form.$valid = false; // an error should pop up now
              var errorObj = data.data;
              form.errorMsg = errorObj.errorMessage;

              if (errorObj.status = 500) {
                form.generalError = true;
              }
              defer.reject(data);
            }
          );
        },
        updateMarketingPermissions: function () {
          var requestData = {};

          $http.post(settings.testDevServerURL + 'SelfServeAutomation/updateMarketingPermissions', requestData)
            .then(function () {
            });
        },
        getBillingType: function (obj, defer) {
          return ajax.getBillingType(obj).then(function (data) {
            defer.resolve(data);
          }, function (error) {
            defer.reject(error);
          });
        }
      }
    }])
}(_, $));

'use strict';


angular.module('totesApp')
		.directive('accountBalanceHorizon', function () {
			return {
				restrict: 'E',
				templateUrl: 'scripts/directives/accountBalance/accountBalanceHorizon.html'
			};
		})
		.controller('accountBalanceCtrl', ['$scope', '$rootScope', 'appState', 'resource', 'userLanguage', 'myrAccountOverviewService', 'settings', 'btnSettings', '$window', 'localStorage', '$modal', 'ajax',
			function ($scope, $rootScope, appState, resource, userLanguage, accountOverviewService, settings, btnSettings, $window, localStorage, $modal, ajax) {

				$scope.acctOverviewService = accountOverviewService;
				$rootScope.$watch('ao.accountActive', function () {
					if ($rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatus) {
						$scope.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
						$scope.btnStatus = $window.btnStatus;
					}

				});
				$scope.isPaynowPage = localStorage.getLocalStorageValue('toStateName') === 'paynow';

				$scope.viewBill = function () {
					appState.switchView('paymentHistory');
				};
				$scope.payBill = function () {
					// Look into  non_angular_script/supportFunctions.js  for more information
					scrollPageToTop();					// jshint ignore:line
					appState.switchView('/paynow');
				};

				$scope.isOverview = ($scope.mode !== 'paynow');
				$scope.monthsNames = resource.get('_months');
				$scope.due = '';
				$scope.dtEn = '';
				$scope.dtFr = '';
				$scope.lng = userLanguage();
				$scope.dtShow = '';
				$scope.isConsumer = $rootScope.isConsumer;
				$scope.months = {
					Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
					Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
				};


				//cls
				$scope.isShowCls = false;
				$scope.isShowPanel = false;
				$scope.totalLimit = 0;
				$scope.outstandingBalance = 0;
				$scope.remainingBalance = 0;

				$scope.loading = true;
				$scope.selectedAccount = {};
				$scope.hasBalance = false;
				$scope.isPreAuth = false;

				var formatDates = function () {
					$scope.hasBalance = false;

					if (!$scope.due || !$rootScope.ao.accountDetails || !$rootScope.ao.accountDetails.accountBalance || $rootScope.ao.accountDetails.accountBalance.balanceAmount <= 0) {
						return;
					}

					$scope.hasBalance = true;
					var arrDate = $scope.due.split('-');
					var mNum = $scope.months[arrDate[0]];

					$scope.dtEn = arrDate[1] + '-' + arrDate[0] + '-20' + arrDate[2];
					$scope.dtFr = arrDate[1] + ' ' + $scope.monthsNames[mNum] + ' 20' + arrDate[2];

				};

				var formatDatesPrepaid = function () {
					$scope.hasBalance = false;

					if (!$scope.due || !$rootScope.ao.accountDetails) {
						return;
					}

					$scope.hasBalance = true;
					var arrDate = $scope.due.split(' ');
					var mNum = $scope.months[arrDate[0]];

					$scope.dtEn = arrDate[0] + ' ' + arrDate[1] + ' ' + arrDate[2];
					$scope.dtFr = $scope.monthsNames[mNum] + ' ' + arrDate[1] + ' ' + arrDate[2];
				};

				var reset = function () {
					$scope.loading = true;
					$scope.due = '';
					$scope.dtEn = '';
					$scope.dtFr = '';
					$scope.dtShow = '';

					$scope.isShowCls = false;
					$scope.isShowPanel = false;
					$scope.totalLimit = 0;
					$scope.outstandingBalance = 0;
					$scope.remainingBalance = 0;

					$scope.selectedAccount = {};
					$scope.hasBalance = false;
				};

				var updateBalance = function ( ) {
					$scope.loading = true;
					$scope.hideAccountBalance = false;
					reset();
					// make sure that the $rootScope.ao.accountDetails is not null (default / initial state)

					if ($scope.acctOverviewService.accountBalance !== null) {
						$scope.selectedAccount = $rootScope.ao.accountDetails;

						var _accountBalance = $scope.acctOverviewService.getAccountBalance();
						var _detail = $scope.acctOverviewService.getSelectedAccountDetail();
						if (!_detail) {
							return;
						}

						$scope.accountNumber = _detail.number;
						$scope.accountType = _detail.type;

						$scope.isPrepaid = _detail.isPrepaid;
						$scope.paymentMethod = _detail.paymentMethod;

						if (!$scope.isPrepaid) {
							$scope.due = _accountBalance.billDueDate;//$rootScope.ao.accountDetails.accountBalance.billDueDate;

							formatDates();
							$scope.totalLimit = _accountBalance.creditLimit;

							$scope.remainingBalance = _accountBalance.creditAvailable;
							$scope.outstandingBalance = $scope.totalLimit - $scope.remainingBalance;

							if (_accountBalance.creditLimit !== undefined) {
								$scope.isShowCls = Number(_accountBalance.creditLimit) > 0 && $scope.isOverview;
							} else {
								$scope.isShowCls = false;

							}
						} else {
							if (_detail.accountBalance.autoPaymentMethod) {
							$scope.due = $rootScope.ao.accountDetails.accountInfo.expiryDate;
								$scope.isPreAuth = false;// _detail.accountBalance.autoPaymentMethod.autoMSF.status === true;

								formatDatesPrepaid();
							} else {
								// console.log(_detail);
						  }
						}
					}

					$scope.loading = false;
				};

				var postToRogersUrls = [
					{url: '/web/myrogers/viewInvoice'},
					{url: '/web/myrogers/prepaidTopUp'}
				];

				$scope.postToRogers = function () {
					$scope.briteBillInvoiceDates = $rootScope.briteBillInvoiceDates;
					if($rootScope.ao.britebill && $scope.acctOverviewService.britebill === null){
						$scope.acctOverviewService.britebill = $rootScope.ao.britebill;
					}
					if ($scope.acctOverviewService.britebill && $scope.acctOverviewService.britebill.length > 0 && !$scope.showOlderBills) {
						appState.switchView('viewInvoice');

					} else if ( $rootScope.briteBillFailed ) {
					 appState.switchView('viewInvoice');
          } else {

            if(accountOverviewService.briteBillError){
              var dataLog = {'logLevel':'INFO','message':'Sending user to ePost: '+accountOverviewService.briteBillError};
              ajax.serverLog(dataLog);
            }

						$('#formToRogers').attr('action', settings.formsURL + postToRogersUrls[0].url);
						$('#formToRogers').submit();
					}
				};

				$scope.postToRogersTop = function () {

          // For oneview dealer and care display modal for prepaid top-up
          if($rootScope.isDealer || $rootScope.isCare){
              $scope.openModalPopup();
          }else{
            $('#formToRogersTop').attr('action', settings.formsURL + postToRogersUrls[1].url);
            $('#formToRogersTop').submit();
          }

				};
				// Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal
        $scope.openModalPopup = function (size) {
          var serverHack = '/web/smb/bss';
          if (settings.isLocal) {
            serverHack = '';
          }
          $rootScope.modal = $modal.open({
            templateUrl: serverHack + '/views/modals/prepaidModal.html',
            controller: 'MyrWirelessPrepaidModalController',
            size: size,
            backdrop: 'static',
            backdropClass: 'bkg-modal',
            resolve: {}
          });

          $rootScope.modal.result.then(function () {
            // on OK behaviour
          }, function () {
            // on Cancel behaviour
          });
        };

				$scope.$watch('acctOverviewService.accountBalance', function (newVal, oldVal) {
         $scope.isViewBillDisplay=false;
         if(($rootScope.isDealer || $rootScope.isCare)
                && ($rootScope.isbritebillAvailable && !$scope.isPrepaid)) {
            $scope.isViewBillDisplay=true;
          }
					updateBalance();
				}, true);

				$scope.$watch('acctOverviewService.selectedAccountDetail', function (newVal, oldVal) {
					updateBalance();
				}, true);

				$scope.$on('changedAccount', function () {
					updateBalance();
				});


				resource.onChanged(function () {
					$scope.lng = userLanguage();
					$scope.monthsNames = resource.get('_months');

					if (!$scope.isPrepaid) {
						formatDates();
					} else {
						formatDatesPrepaid();
					}
				}, $scope);

			}]);

'use strict';

angular.module('totesApp')
  .directive('accountSelector', ['settings', function ( settings ) {
    return {

      replace: true,

      templateUrl: 'scripts/directives/accountSelector/accountSelector.html',

      restrict: 'E',

      link: function ($scope, $elem, attr) {
        //console.log($scope);
        $scope.postToRogersUrls = [
          {url: '/web/myrogers/viewInvoice'},

          {url: '/web/myrogers/prepaidTopUp'}

        ];
        $scope.postToRogers = function() {

          // console.log( this);
          var selectedAccount=this.value;
          $('#formToRogers').attr('accountNumber', selectedAccount.accountNumber);
          /*$('#formToRogers').attr('ctn', selectedAccount.ctnNumber);
          $('#formToRogers').attr('passCode', selectedAccount.pinNumber);*/
          $('#formToRogers').attr('action', settings.formsURL + $scope.postToRogersUrls[0].url);

          $('#formToRogers').submit();


        };
      }
    };

  }]);

'use strict';

angular.module('totesApp').directive('attemptsErrorBox', function () {

	return {
 		templateUrl: "scripts/directives/attemptsErrorBox/attemptsErrorBox.html",
		replace: true,
		restrict: "E"
	};
});


'use strict';
angular.module('totesApp').directive('bannerArea', function () {
    return {
        templateUrl: "scripts/directives/bannerArea/bannerArea.html",
        replace: true,
        restrict: "E"
    };
});

/* jshint -W117 */

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * Example: <bold-chat-static-button data-cbid="{{'ute.rogers.myrPaymentHelper.boldChatButtonId' | translate}}"
   data-dynamic-div="{{'ute.rogers.myrPaymentHelper.boldChatButtonDiv' | translate}}"
   data-chat-button="{{'ute.rogers.myrPaymentHelper.boldChatButton' | translate}}"></bold-chat-static-button>
   */
  angular.module('ute.common.component.directives').directive('boldChatStaticButton', BoldChatStaticButton);

  BoldChatStaticButton.$inject = ['$interpolate'];

  function BoldChatStaticButton($interpolate) {

    return {
      templateUrl: 'scripts/directives/boldChat/boldChatStaticButton.html',
      replace: true,
      restrict: 'EA',
      scope: {
        //cbid: '=',
        //boldChatDiv: '=dynamicDiv',
        //chatButton: '=',
        //errorMessage: '=errorMessage'
      },
      link: function (scope, element, attrs) {
        scope.isChatReady = false;

        if (attrs.cbid) {
          scope.cbid = scope.$eval($interpolate(attrs.cbid));
        }
        if (attrs.dynamicDiv) {
          scope.boldChatDiv = scope.$eval($interpolate(attrs.dynamicDiv));
        }
        if (attrs.chatButton) {
          scope.chatButton = scope.$eval($interpolate(attrs.chatButton));
        }
        if (attrs.errorMessage) {
          scope.errorMessage = scope.$eval($interpolate(attrs.errorMessage));
        }

        var watcher = scope.$watch(function () {
            return document.getElementById(scope.boldChatDiv);
          }, function (newValue, oldValue) {
            if (null != newValue) {
              var chatButtonOld = null;
              try {
                var bdid = getBDId(scope.cbid);
                staticLiveChatButtonUTE(bdid, scope.boldChatDiv, scope.chatButton, chatButtonOld, scope.errorMessage);
              } catch (e) {
              }
            }
            watcher();
          }
        );

        attrs.$observe('cbid', function (value) {
          /**
           * Run the following code only when the chat markup is ready
           */
          if (scope.isChatReady) {
            staticLiveChatButtonUTE(getBDId(value), scope.boldChatDiv, scope.boldChatDiv, scope.chatButton, scope.errorMessage);
          }
        });

        scope.$watch('chatButton', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            staticLiveChatButtonUTE(getBDId(scope.cbid), scope.boldChatDiv, scope.chatButton, oldValue, scope.errorMessage);
          }
          scope.isChatReady = true;
        }, true);
      }
    };
  }
})();

'use strict';

angular.module('totesApp')
  .factory('confirmationDialog',['$rootScope', 'resource', function ($rootScope, resource) {

    var confirmationDialog = {

      dialogObj: {
        show: false,//switch to open the dialog
        title: null,//dialog title resource key
        message: null,//dialog content resource key
        icon: null,
        iconBody: null,
        onClose: null, //action upon closing the dialog
        buttons: null
        /*
         //buttons is the collection of the buttons on the bottom of the confirmation dialog
         //example:
         buttons:[
         {label: '_cancel', //text on the button
         type:'label', //Totes button type: primary, secondary, tertiary  or label
         action: cancel // the call back of this button, defined the caller scope
         },
         {label: '_continue',
         type:'primary',
         action: callServer}
         ]
         */
      },
      alert: function (info, showIcon) {
        var _info = resource.get(info);

        confirmationDialog.open({
          title: '',
          message: _info,
          onClose: null,
          icon: 'alert',
          buttons: [
            {label: 'wireless_close', type: 'primary', action: function(){
              //confirmationDialog.open(null);
            }}
          ]
        });
      },

      close: function () {
        /*      if (confirmationDialog.dialogObj.show) {
         confirmationDialog.open(null);
         } else {
         confirmationDialog.open(null);
         }*/
        confirmationDialog.open(null);
      },

      open: function (options) {
        //reset the dialog object if null
        //else set the buttons
        if (!options) {
          confirmationDialog.dialogObj.title = null;
          confirmationDialog.dialogObj.icon = null;
          confirmationDialog.dialogObj.iconBody= null;
          confirmationDialog.dialogObj.message = null;
          confirmationDialog.dialogObj.buttons = null;
          confirmationDialog.dialogObj.show = false;
          if (confirmationDialog.dialogObj.onClose) {
            confirmationDialog.dialogObj.onClose();
          }
          confirmationDialog.dialogObj.onClose = null;
          return;
        }
        confirmationDialog.dialogObj.show = true;
        confirmationDialog.dialogObj.onClose = options.onClose;
        confirmationDialog.dialogObj.title = options.title;
        confirmationDialog.dialogObj.icon = options.icon;
        confirmationDialog.dialogObj.iconBody = options.iconBody;
        confirmationDialog.dialogObj.message = options.message;
        confirmationDialog.dialogObj.buttons = [];
        for (var i = 0, l = options.buttons.length; i < l; i++) {
          confirmationDialog.dialogObj.buttons.push({
            label: options.buttons[i].label,
            type: options.buttons[i].type,
            action: options.buttons[i].action
          });
        }
      }
    };

    $rootScope.$on('$stateChangeStart', function () {
      //clear any dialog upon route changes
      confirmationDialog.close();
    });

    return confirmationDialog;
  }])
  .directive('confirmDialog', ['confirmationDialog', function (confirmationDialog) {
    return {
      scope: {},

      replace: true,

      templateUrl: 'scripts/directives/confirmDialog/confirmDialog.html',

      restrict: 'E',

      link: function (scope, $elem, attr) {

        scope.dialog= confirmationDialog.dialogObj;

        function closeDialog() {
          confirmationDialog.open(null);
          scope.$apply();
        }


        $elem.delegate(".close-dialog ", "click", closeDialog);
        //$elem.find('.close-dialog').bind('click', closeDialog);
      }
    };

  }]);

'use strict';


angular.module('totesApp')
	.directive('demoWidget', function () {
		return {
			restrict: "E",
			scope: {},
			templateUrl: "scripts/directives/demoWidget/demoWidget.html",
			link: function (scope, element, attrs) {
				// DOM or direct jQuery calls
			}
		};
	})
	.controller('demoWidgetCtrl',['$scope', '$rootScope', function ($scope, $rootScope) {
		// Local variables
		// $scope.name = "Bingo!!";
		// $scope.greeting = "hello";

		// All options of the module (ng-show) and default state
		$scope.p = {};
		$scope.p.visible = true;
		$scope.p.lvl1 = true;
		$scope.p.lvl2 = true;
		$scope.p.lvl3 = true;
		$scope.p.lvl4 = true;
		$scope.p.lvl5 = true;
		
/* DEAD CODE
		$rootScope.$watch('permissions', function(newVal, oldVal){
			// Watch for Permissions and initiate any functionality that needs to happen

			if ($rootScope.permissions.modules.demoWidgetCtrl) {
				var modulePermission = $rootScope.permissions.modules.demoWidgetCtrl;
				var moduleVisibility = modulePermission.permission.visible;
				
				var permissionMap = {};
				if ($rootScope.permissions.userRole === "pass") {
					if (modulePermission[modulePermission.permission.role]){
						permissionMap = modulePermission[modulePermission.permission.role];
					}
				} else {
					if (modulePermission[$rootScope.permissions.userRole]) {
						permissionMap = modulePermission[$rootScope.permissions.userRole];
					}
				}
				
				permissionMap.visible = moduleVisibility;		// Specific flags after object was pushed
				
				// Apply permission map to the scope
				$scope.p = {};
				$scope.p = permissionMap;				// Map object first
				
			} else {
// console.log ("demoWidgetCtrl permission - no data");
			}
			
		}, true);
//*/
		
	}]);

(function (_) {
  'use strict';
  angular
    .module('selfServe')
    .controller('editableContentController', ["$scope", "$rootScope", "$modal", "resource", "userLanguage", "localStorage", "omni", "selfServeSvc", function ($scope, $rootScope, $modal, resource, userLanguage, localStorage, omni, selfServeSvc) {
      $scope.currentPanelOpen = false;
      $scope.nonEditableData = $scope.formdata;
      $scope.editableData = $.extend(true, {}, $scope.formdata);
      if ($scope.loadLoginSecurityQuestions) {
        $scope.loginSecurityQuestions = selfServeSvc.getLoginSecurityQuestions();
      }
      var accountTypeNumber = localStorage.getLocalStorageValue('accountTypeNumber');
      $scope.cableCustomer = false;

      if (accountTypeNumber == 6) {
        $scope.cableCustomer = true;
      }

      $scope.language = userLanguage();

      $rootScope.$on("startLoading", function () {
        $scope.loading = true;
      });

      $rootScope.$on("stopLoading", function () {
       $scope.loading = false;
      });
      $scope.productCategories = [
        {id: 'WIRELESS', resource: 'wireless'},
        {id: 'CABLE', resource: 'tv'},
        {id: 'INTERNET', resource: '_internet'},
        {id: 'HOME PHONE', resource: 'rogers_home_phone'}];
      $scope.marketingChannels = [
        {id: 'EMAIL', resource: '_email'},
        {id: 'DIRECT MAIL', resource: 'direct_mail'},
        {id: 'TELE-MARKETING', resource: 'telemarketing'},
        {id: 'TEXT MESSAGING', resource: 'text_message'}];
      $scope.getResource = function(key) {
        return resource.get(key);
      };
      $scope.getYesNo = function(boolean) {
        if (boolean == void 0) return '';
        return resource.get(boolean ? 'yes' : 'no');
      };
      $scope.$watch('formdata', function (newValue) {
        $scope.nonEditableData = newValue;
        $scope.editableData = $.extend(true, {}, newValue);
        if ($scope.formdata && $scope.formdata.defer) {
          $scope.formdata.defer.promise.then(function () {
            $scope.loading = false;
            // reset password fields
            $scope.editableData.confirmPassword = '';
            $scope.editableData.newPassword = '';
            $scope.editableData.oldPassword = '';

          });
        }

        if ($scope.formdata && $scope.formdata.failure) {
          $scope.formdata.failure.promise.then(function () {
            $scope.generalError = true;
            $scope.loading = false; // we don't want to show the loading sign
          });
        }

        //omniture taggings
        var _pageName='', _options=[];
        switch( $scope.formdata){
          case 'userInfo':
            _pageName='home:MyRogers:change-password';
            _options.push({eVar13:'MyRogers - change password'});
            _options.push({event5:''});
            break;
          case 'BillingAddress':
            _pageName='home:MyRogers:change-billing address';
            _options.push({eVar13:'MyRogers - change billing address'});
            _options.push({event5:''});
            break;
          case 'ContactInformation':
            _pageName='home:MyRogers:change-contact information';
            _options.push({eVar13:'MyRogers - change contact information'});
            _options.push({event5:''});
            break;
          case 'MarketingPermissions':
            _pageName='home:MyRogers:Change-Marketing Permission Information';
            _options.push({eVar13:'MyRogers - change marketing permission information'});
            _options.push({event5:''});
            break;
          default:
            break;
        }
        omni.tagPage( _pageName, _options);

      }, true);

      resource.resolveResource().then(function () {
        $scope.heading = resource.get($scope.formheading);
      });

      $rootScope.$on('languageChanged', function () {
        resource.resolveResource().then(function () {
          $scope.heading = resource.get($scope.formheading);
          if ($scope.loadLoginSecurityQuestions) {
            $scope.loginSecurityQuestions = selfServeSvc.getLoginSecurityQuestions();
            var translatedCurrentSelectedQuestion = $scope.loginSecurityQuestions.filter(function(q){return q.value == $scope.editableData.questionNo})[0];
            $scope.$root.$broadcast('loginSecurityQuestionsChanged', translatedCurrentSelectedQuestion);
          }
        });
      });

      $scope.openPaperBillingModal = function (ab) {
        $modal.open({
          templateUrl: 'views/modals/paper-billing-modal.html',
          windowClass: 'verify-address-modal',
          controller: ["$scope", function($scope) {
            $scope.closeModal = function () {
              this.$close();
            }
          }]
        });
      };

      $scope.clearFieldInObject = function (field, obj) {
        for (var i in obj) {
          if (obj[i].Permissions) {
            obj[i].Permissions[field] = false;
          }
        }
      };

      $scope.copySelections = function (selection) {};

      $scope.clearSelections = function (section) {
        if (section === 'wireless') {
          $scope.clearFieldInObject('wireless', $scope.editableData);
        } else if (section === 'cable') {
          $scope.clearFieldInObject('cable', $scope.editableData);
        } else if (section === 'internet') {
          $scope.clearFieldInObject('internet', $scope.editableData);
        } else if (section === 'homephone') {
          $scope.clearFieldInObject('homephone', $scope.editableData);
        } else if (section === 'homemonitoring') {
          $scope.clearFieldInObject('homemonitoring', $scope.editableData);
        }
      };
      $scope.$watch('editableData', function(newValue){
        $scope.maybeSelectedSecurityQuestion(newValue);
      });
      $scope.maybeSelectedSecurityQuestion = function(editableData){
        if(!$.isEmptyObject(editableData) && editableData.questionNo && $scope.loginSecurityQuestions.length){
          $scope.selectedSecurityQuestion = $scope.selectedSecurityQuestion || $scope.loginSecurityQuestions.filter(function(q){return q.value == $scope.editableData.questionNo})[0];
          //console.log('assign selectedSecQuestion');
        }
      };
      $scope.selectSecurityQuestion = function(question){
        $scope.editableData.answer = '';
        $scope.editableData.questionNo = question.value;
        $scope.editableData.secretQuestion = question.label;
        $scope.selectedSecurityQuestion = question;
      };

 /*      $scope.$on('formLocator', function(event) {
        $scope.myDeeplyNestedForm = event.targetScope.form;
      }); */

      if($scope.closeonresize === 'true') {
        $rootScope.$on("closeonresize", function () {
          $scope.cancel(true);
        });
      }
    }])
    .directive('editableContent', ["$q", "$compile", "$modal", "$location", "$state", "omni", "profileEditService", "appState", function($q, $compile, $modal, $location, $state, omni, profileEditService, appState) {
      return {
        restrict: 'E',
        controller: 'editableContentController',
        transclude: true,
        scope: {
          marketingpermissions: '@',
          editabletemplateurl: '@',
          formtemplate: '@',
          formdata: '=',
          formheading: '@',
          onSubmit: '&',
          onBillingtypeupdate: '&',
          onEmailupdate: '&',
          controller: '&',
          skin: '@',
          whiteout: '@',
          closeonresize: '@',
          billingupdate: '@',
          loadLoginSecurityQuestions: '@',
          emailupdate: '@'
        },
        templateUrl: 'views/editable-content-template.html',
        link: function (scope, element, attrs) {
          // keep the element in closure so other functions can access it
          // as angular loses the element attribute when scope methods are hit
          // from the template. This is probably a bug in angular.
          var _element = element;
          scope.isEditOpen = function() {
            return profileEditService.getEditPanelStatus();
          };

          scope.whiteoutEnabled = scope.whiteout === "true";

          // if assigned a controller instantiate instantiate it with the view
          scope.controller({scope: scope});

          // initially show the NON EDITABLE TEMPLATE
          scope.loading = true;
          if (scope.loading === false && scope.generalError === false) {
            scope.contentUrl = attrs.editabletemplateurl;
          }

          scope.$watch('loading', function (newValue) {
            if (newValue === false) {
              if (!scope.contentUrl && !scope.generalError) {
                scope.contentUrl = attrs.editabletemplateurl;
              }
            }
          });

          //
          // This function switches the view by setting the content url
          // with a given template url. This template is passed through the attributes
          //
          scope.swapView = function (viewName) {
            scope.contentUrl = viewName;
            scope.tagViewLoading(viewName);
          };

          scope.tagViewLoading = function(viewName){
            var tagOpts;
            switch (viewName) {
              case (viewName.match(/usernameandpasswordform/) || {}).input:
                tagOpts = ['_trackPageView',{pn:'home:MyRogers:change-password'},{eVar13:'MyRogers_change password'},{event5:''}];
                break;
              case (viewName.match(/billinginformationform/) || {}).input:
                tagOpts = ['_trackPageView',{pn:'home:MyRogers:change-billing'},{eVar14:'MyRogers_view_change_billing'},{event5:''}];
                break;
              case (viewName.match(/contactinformationform/) || {}).input:
                tagOpts = ['_trackPageView',{pn:'home:MyRogers:change-contact information'},{eVar14:'MyRogers_View_change_contactinformation'},{event5:''}];
                break;
              case (viewName.match(/marketinginformationform/) || {}).input:
                tagOpts = ['_trackPageView',{pn:'home:MyRogers:change-marketing permissions'},{eVar14:'MyRogers_Profile_Account_change_marketingperm’'},{event5:''}];
                break;
              default:
                console.log('Didn\'t match');
                break;
            }

            appState.tagging(tagOpts);
          };

          //
          // This function sets up the directive to be in the editable mode.
          // The view is swapped to the form and the state is set to isEditOpen = true
          //
          scope.edit = function () {
            // only open if no other directives are open
            // horrible hack for marketing permissions that needs to be changed
//            scope.myDeeplyNestedForm.horribleHackToHideError = true;
            scope.maybeSelectedSecurityQuestion(scope.editableData);
            var domain = $location.protocol() + "://" + $location.host() + ":" + $location.port();
            var url = domain + '/web/RogersServices.portal?_nfpb=true&_pageLabel=Marketing_Permissions';

            if (attrs.marketingpermissions === "true") {
              window.location = url;
              return;
            }

            //if (isMarketingPermissions) {
            //  $location.redirect("<Domain>/web/RogersServices.portal?_nfpb=true&_pageLabel=Marketing_Permissions");
            //}

            scope.swapView(attrs.formtemplate);
            scope.currentPanelOpen = true;
            profileEditService.setEditPanelStatus(true);
            scope.loading = false;
            if (scope.whiteoutEnabled) {
              //$(element).siblings().toggleClass("white-out");
              $('.totes-project').find('.self-serve').children().find('.big-half-header').toggleClass('white-out');
              $('.totes-project').find('.self-serve').children().find('.editable-content').each(function (k, v) {
                if (!$(v).parent().is($(element))) {
                  $(v).toggleClass('white-out');
                }
              });

              $('.totes-project').find('.account-select').toggleClass('white-out');

              //$(element).toggleClass("white-out");
              //$(element).siblings().children().toggleClass("white-out");
            }
          };

          scope.scrollToTop = function (element) {
            setTimeout(function () {
              var scrollby = $(element).offset().top - 200;

              $('html, body').animate({
                scrollTop: scrollby
              }, 400);
            }, 300);
          };

          //
          // This function restores the directive to the non editable state.
          // It also discards changes made to the form
          //
          scope.cancel = function (force) {
            // we switch back to the non editable form
            scope.swapView(attrs.editabletemplateurl);
            scope.currentPanelOpen = false;
            profileEditService.setEditPanelStatus(false);
            if(scope.whiteoutEnabled) {
              $('.totes-project').find('.self-serve').children().find('.big-half-header').toggleClass('white-out');
              $('.totes-project').find('.self-serve').children().find('.editable-content').each(function (k, v) {
                if (!$(v).parent().is($(element))) {
                  $(v).toggleClass('white-out');
                }
              });

              $('.totes-project').find('.account-select').toggleClass('white-out');
            }
            // discard changes
            scope.editableData = $.extend(true, {}, scope.formdata);

/*            if (scope.myDeeplyNestedForm) {
              scope.myDeeplyNestedForm.$submitted = false;
            }*/

            scope.scrollToTop(element);

            // look at the next digest cycle
            if(force) {
              $(element).click(); // causes a refresh
            }
          };

          scope.onSuccess = function () {
            scope.updatingBillingType = false;

            scope.swapView(attrs.editabletemplateurl);

            scope.currentPanelOpen = false;
            profileEditService.setEditPanelStatus(false);

            if (scope.whiteoutEnabled) {
              //$(element).siblings().toggleClass("white-out");
              $('.totes-project').find('.self-serve').children().find('.big-half-header').toggleClass('white-out');
              $('.totes-project').find('.self-serve').children().find('.editable-content').each(function (k, v) {
                if (!$(v).parent().is($(element))) {
                  $(v).toggleClass('white-out');
                }
              });

              $('.totes-project').find('.account-select').toggleClass('white-out');
            }

            scope.scrollToTop(element);

            //omniture taggings
            var  _options=[];
            switch( attrs.formdata){
              case 'userInfo':
                _options.push({eVar13:'MyRogers - change password'});
                _options.push({event6:''});
                break;
              case 'BillingAddress':
                _options.push({eVar13:'MyRogers - change Billing Address'});
                _options.push({event6:''});
                break;
              case 'ContactInformation':
                _options.push({eVar13:'MyRogers - change contact information'});
                _options.push({event6:''});
                break;
              case 'MarketingPermissions':
                _options.push({eVar13:'MyRogers - change marketing permission information'});
                _options.push({event6:''});
                break;
              default:
                break;
            }
            omni.tagLink( _options);
            scope.loading = false;
          };

          scope.openModal = function() {
            var modal = $modal.open({
              templateUrl: 'views/modals/marketingPermissionsInfo.html',
              windowClass: 'verify-address-modal',
              controller: ["$scope", function ($scope) {
                $scope.closeModal = function () {
                  this.$close();
                }
              }]
            });
          };

          scope.onError = function () {
            scope.loading = false;
            // if billing type
            if (scope.onBillingtypeupdate) {
              scope.updatingBillingType = false;
            }

            var modalInstance = $modal.open({
              templateUrl: 'views/modals/generalErrorDialog.html',
              windowClass: "verify-address-modal",
              controller: ["$scope", "userLanguage", "$rootScope", function ($scope, userLanguage, $rootScope) {
                $scope.verifyAddressFailed = $rootScope.verifyAddressFailed;
                $scope.language = userLanguage();
                $scope.close = function () {
                  modalInstance.close();
                  if ($state) {
                    profileEditService.setEditPanelStatus(false);
                    $state.go($state.current, {}, {reload: true});
                  } else {
                    location.reload();
                  }
                };

                $scope.$on('modal.closing', function () {
                  if ($state) {
                    $state.go($state.current, {}, {reload: true});
                  } else {
                    location.reload();
                  }
                });
              }]
            });
          };

          scope.onNotify = function () {
/*            if (scope.myDeeplyNestedForm) {
              scope.myDeeplyNestedForm.$submitted = false;
            }*/
            scope.loading = false;
          };

          scope.updateEmail = function (form) {
            appState.tagging(['_trackLink',{eVar13:'MyRogers-change_contactinformation_email'},{event6:''}]);
            var defer = $q.defer();
            //var doneSavingPromise = defer.promise;
            var emailFields = {email: scope.editableData.email, emailconfirmation: scope.editableData.emailconfirmation};
            scope.loading = true;

            angular.extend ( scope.editableData, { EmailChanged: true });

            scope.onEmailupdate({ updates: emailFields, defer: defer, form: form });
            defer.promise.then(
              function (successful) {
                scope.onSuccess();
                scope.currentPanelOpen = false;
                profileEditService.setEditPanelStatus(false);

                form.$valid = false;
              },
              function (rejected) {
                scope.onError();
              },
              // on notify we close the loading
              function () {
                scope.onNotify();
              }
            );
          };

          scope.tagOnSaveBillingChanges = function(){
            var tagBillVar = 'MyRogers-change_Billingtype_';
            if(scope.editableData.billingType === 'E_BILL'){
              tagBillVar += 'online';
            } else if ( scope.editableData.billingType === 'INVOICE') {
              tagBillVar += 'paper';
            }
            appState.tagging(['_trackLink',{eVar13:tagBillVar},{event6:''}]);
          };

          scope.saveBillingChanges = function (form) {
            scope.tagOnSaveBillingChanges();

            //if (!form.$invalid) {
            // should check if something is checked or not instead
              var defer = $q.defer(),
                doneSavingPromise = defer.promise;

              scope.loading = true;
              form.$submitted = false;

              var onBillingUpdateDefer = $q.defer();
              onBillingUpdateDefer.promise;

              scope.updatingBillingType = true;

              scope.onBillingtypeupdate({
                updates: {billingType: scope.editableData.billingType},
                defer: onBillingUpdateDefer
              });

              onBillingUpdateDefer.promise.then(function () {
                scope.onSuccess();
              }, function () {
                scope.onError();
              });

              return;
          };

          scope.tagOnSaveBillingAddress = function () {
            appState.tagging(['_trackLink',{eVar13:'MyRogers-change_Billingaddress '},{event6:''}]);
          };

          scope.tagOnSaveContactInfo = function () {
            appState.tagging(['_trackLink',{eVar13:'MyRogers-change_contactinformation_contactnumber'},{event6:''}]);
          }

          scope.saveChanges = function (form) {

            if(attrs.formdata === 'BillingAddress'){
              scope.tagOnSaveBillingAddress();
            } else if ( attrs.formdata === 'ContactInformation'){
              scope.tagOnSaveContactInfo();
            }
            var defer = $q.defer(),
              doneSavingPromise = defer.promise;

            //if (form.confirmEmail.$valid === false && form.Email.$touched === false) {
            //  form.confirmEmail.$valid = true;
            //  form.confirmEmail.$invalid = false;
            //  form.$valid = true;
            //  form.$invalid = false;
            //}
            //
            // Execute onSubmit callback passed to the directive
            // with a promise and the delta of the changes
            // The promise must be resolved by the onSubmit function such
            // that the directive can switch back to the non editable view.
            //

            scope.loading = true;

            //add a flag to indicate email or phone number change
//            var emailChanged = !!form.Email;
//            angular.extend ( scope.editableData, { EmailChanged: emailChanged });
            scope.formdata.answer = scope.editableData.answer;
            scope.onSubmit({ updates: scope.editableData, defer: defer, form: form });
            var self = this;
            doneSavingPromise.then(
              function (successful) {
                scope.onSuccess();
                scope.currentPanelOpen = false;
                profileEditService.setEditPanelStatus(false);

                form.$valid = false;
              },
              function (rejected) {
                if (rejected && rejected.data && rejected.data.data && rejected.data.data.errorCode && rejected.data.data.errorCode === 10510) {
                  form.oldpasswordwrong = true;
                  form.oldpassworderrormsg = rejected.data.data.errorMessage;
                  scope.loading = false;
                  form.generalError = false;
                  form.$setValidity('oldPassword', false, form);
                  //form.oldPassword.$valid = false;
                  form.oldPassword.$touched = false;
                } else {
                  scope.onError();
                }
              },
              // on notify we close the loading
              function () {
                scope.onNotify();
              }
            );
          };
        }
      };
    }]);
}(_));

'use strict';

/**
 * Cheque form widget:
 * output object, the parent scope will have this object ready for use,
 * just refer to the object if need to retrieve the value, for example to call server with the cheque information:
 * chequingObj:{
        transitNo:null,
        bankCode: null,
        accountNo:null
    }
 */
angular.module('totesApp')
	.directive('formChequing', ['resource', function (resource) {
		return {
			restrict: 'E',
			templateUrl: 'scripts/directives/formChequing/formChequing.html',
			link: function ($scope, element, attr) {

                $scope.$extend ({
                    accountFocused: false,
                    bankFocused: false,
                    transitFocused: false,
                    chequingObj:{
                        transitNo:null,
                        bankCode: null,
                        accountNo:null
                    },
                    isAccepted: false,
                    setHintImg: function ( imgSrc){
                        $(element).find('.img-cheque #overlay').attr( 'src', imgSrc);
                    }
                });
			}
		};
	}]);

(function(){
'use strict';

angular.module('totesApp')
		.directive('goPaperless', function () {
			return {
				restrict: "EA",
        templateUrl: "scripts/directives/goPaperless/goPaperless.html",
        controller: "goPaperlessCtrl"
			};
		}).controller('goPaperlessCtrl', ['$scope', 'ajax', '$rootScope', '$browser', 'userLanguage', '$modal', '$window', 'localStorage', 'myrAccountListService',  'ute.rogers.datalayer.integration.common.service', 'ute.datalayer.common.service', 'userProvince',
        function ($scope, ajax, $rootScope, $browser, userLanguage, $modal, $window, localStorage, myrAccountListService, dataLayerIntegrationService, dataLayerService, userProvince) {

           $scope.language = userLanguage();
           $scope.province = userProvince().toLowerCase();

           $rootScope.$on("accountChanged", function(event, accountNumber){
              $scope.olbBillType(accountNumber);

              if($rootScope.ao.accountDetails && $rootScope.ao.accountDetails.contactInfo){
                 localStorage.setLocalStorageValue('contactEmail', $rootScope.ao.accountDetails.contactInfo.emailAddress);
              }
           });

          $rootScope.$on("provinceChanged", function(event, accountNumber){
            $scope.province = userProvince().toLowerCase();
          });

           $scope.olbBillType = function(accountNumber){
              myrAccountListService.checkBillType(accountNumber).then(function(olbStatus) {
                 if(olbStatus.billType == 'E_BILL'){
                     $scope.billType = 'E_BILL';
                 }else{
                     $scope.billType = 'PAPER';
                 }
              });
           }

           $scope.switchBillTypeModal = function (isEmailUpdated) {
             $scope.ban = localStorage.getLocalStorageValue('accountNumber');
             $rootScope.switchBillLoader = false;

              if (isEmailUpdated) {
                $scope.cableEmail = $browser.cookies().pageUserName.contains("@") ? $browser.cookies().pageUserName : $browser.cookies().userName;
              } else if($rootScope.ao.accountDetails && $rootScope.ao.accountDetails.contactInfo){
                $scope.cableEmail = $rootScope.ao.accountDetails.contactInfo.emailAddress;
              } else {
                $scope.cableEmail = localStorage.getLocalStorageValue('contactEmail');
              }

             $scope.modalInstance = $modal.open({
               templateUrl:'views/modals/switchBillType.html',
               controller: 'switchBillTypeController',
               scope: $scope,
               backdrop: 'static',
               keyboard: false,
               backdropClass: 'bkg-modal',
               resolve: {}
             });
           };

         $scope.switchBillType = function () {
             dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "switchBillTypeSelection"});
             $rootScope.switchBillLoader = true;
             var request = {
               'accountNumber': $scope.ban,
               'targetBillType ': 'electronic'
             }

             ajax.legacyUpdateAccountInfo().then(function(){
               ajax.changeBillType(request).then(
                   function(data){
                     if(data.success){
                      $scope.modalInstance.close();
                      $scope.billType = 'E_BILL';
                      myrAccountListService.billTypeFlag[accountNumber] = 'E_BILL';
                      $scope.modalInstance = $modal.open({
                         templateUrl:'views/modals/switchBTSuccess.html',
                         controller: 'switchBillTypeController',
                         scope: $scope,
                         backdrop: 'static',
                         keyboard: false,
                         backdropClass: 'bkg-modal',
                         resolve: {}
                       });
                      $scope.modalInstance.opened.then(function() {
                        $rootScope.$emit('$modal.opened', 'switchBillConfirmation');
                      });
                       $rootScope.switchBillLoader = false;
                     } else {
                       $scope.switchBTFailure();
                     }
                 }, function(error){
                       $scope.switchBTFailure();
                 });
               }, function(error) {
                     $scope.switchBTFailure();
               });
           };

           $scope.switchBTFailure = function () {
            $scope.modalInstance.close();
            $scope.modalInstance = $modal.open({
               templateUrl:'views/modals/switchBTFailure.html',
               controller: 'switchBillTypeController',
               scope: $scope,
               backdrop: 'static',
               keyboard: false,
               backdropClass: 'bkg-modal',
               resolve: {}
             });
            $scope.modalInstance.opened.then(function() {
              $rootScope.$emit('$modal.opened', 'switchBillFailure');
            });
            $rootScope.switchBillLoader = false;
           };

           if($rootScope.updatedUserEmail) {
             $window.document.cookie = 'updateEmail=' + '' + ';domain=' + '.rogers.com' + ';path=' + '/' + ';expires=Thu, 01 Jan 1970 00:00:00 GMT';
             $scope.switchBillTypeModal(true);
             $rootScope.updatedUserEmail = false;
           }

           $scope.olbBillType(myrAccountListService.selectedAccount.accountNumber);
        }
    ]);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('switchBillTypeController', switchBillTypeController);

  switchBillTypeController.$inject = ['$scope', '$rootScope', 'localStorage', 'ajax', '$window', 'userLanguage', '$modalInstance', '$browser'];

  /* @ngInject */
  function switchBillTypeController($scope, $rootScope, localStorage, ajax, $window, userLanguage, $modalInstance, $browser) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    $scope.lang = userLanguage();

    $scope.profileData = $browser.cookies().pageUserName.contains("@") ? $browser.cookies().pageUserName : $browser.cookies().userName;

    // OK / Cancel buttons
    $scope.ok = function () {
      $modalInstance.close('ok');
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.updateUserEmail = function () {
     $window.document.cookie = 'updateEmail=' + 'true' + ';domain=' + '.rogers.com' + ';path=' + '/';
     $window.location.href = '/business/ute/smb/transactions/uteUpdateProfile';
    };

    $scope.boldChat = {
      olbLiveChat: {
        en: {
          cbid: 'S_BSS_Device_Details',
          dynamicDivId: 'S_BSS_BillType_Error_div',
          chatButtonClass:'chatButtonBTSwitchErrorEn'
        },

        fr: {
          cbid: 'S_BSS_Device_Details_Fr',
          dynamicDivId: 'S_BSS_BillType_Error_fr_div',
          chatButtonClass:'chatButtonBTSwitchErrorFr'
        }
      }
    };
  }
})();

'use strict';

angular
		.module('totesApp')
		.directive('internetMyModem', function () {
			return {
				restrict: 'AE',
				replace: 'true',
				scope: {},
				templateUrl: 'scripts/directives/internetMyModem/internetMyModem.html',
				link: function (scope, element, attrs) {
					// DOM or direct jQuery calls
				},
				controller: ['$scope', 'settings', 'myrInternetService', 'resource', 'userLanguage', 'localStorage','appState','$rootScope',
					function ($scope, settings, internetService, resource, userLanguage, localStorage, appState, $rootScope) {

						// Required by template - Variables set
						$scope.internetObj = {
							days: 0,
							usedGb: 0,
							globalColor: '',
							globalPercentage: 0,
							unlimitedClass: 'normal',
							extraUsage: 0,
							chargeAmount: 0,
							myPlan: {
								totalGB: '',
								total: '',
								package: '',
								downloadSpeed: '',
								uploadSpeed: ''
							},
							myExtras: [],
							myModem: {
								name: '',
								image: '',
								imagePath: ''
							}
						};
						//$scope.userTypeDealer = $rootScope.isDealer;
						$scope.isDealer = $rootScope.isDealer;
						$scope.isCare = $rootScope.isCare;

            if ($rootScope.isDealer || $rootScope.isCare) {
              var messageBoxDom = function () {
                $scope.changeModemMessage='<div class="info-box-header">'
                                        +"<span class='header-tab'><strong>"+resource.get("to_change")
                                        +":</strong>"+"</div>"
                                        +'<div class="info-box-body">'
                                        +'<div class="info-box-col">'
                                        +'<div><strong>'+resource.get("modem")+'</strong></div>'
                                        +"</div>"
                                        +'<div class="info-box-col"><img src="images/message-arrow.png" class="width-50"/></div>'
                                        +'<div class="info-box-col login-text">'
                                        +resource.get("login_to")+" "+resource.get("sgi")+"</div>"
                                        +'</div>';
              };
              messageBoxDom();
              resource.onChanged(function () {
                    messageBoxDom();
                     }, $scope);
            }

						$scope.lang = userLanguage() + '-CA';
						$scope.lng = userLanguage();
						$scope.chatHref = userLanguage() === 'en' ? settings.chatLinkChangeModem.en : settings.chatLinkChangeModem.fr;

						$scope.displayContent = false;
						$scope.loadingDataIndicator = true;
						$scope.errorMessage = '';



						// From old controller
						$scope.loadData = function (refreshCall) {
							refreshCall = (refreshCall === undefined) ? false : refreshCall;

							// collect the data that you need to run this directive
							$scope.passParams = {};
							$scope.passParams.accountNumber = localStorage.getLocalStorageValue('internetAccountNumber');
							$scope.passParams.refresh = refreshCall;
              $scope.passParams.lang = $scope.lng;
							// new way
						internetService.internetModem($scope.passParams, $scope.processResponse, $scope.processError);
						};

						// Process data response
						$scope.processResponse = function (response) {
							if (response) {
								if (response === undefined || response === null) {
									$scope.displayContent = false;
									$scope.loadingDataIndicator = false;

									$scope.errorCode = '50000';
									$scope.errorMessage = resource.get($scope.errorCode);
								} else {
									// Hide loading usage
									$scope.currentModemId = response.deviceId;
									$scope.currentPackageId = response.internetPlan;

									// Show page
									$scope.displayContent = true;
									$scope.loadingDataIndicator = false;
                  internetService.internetModemObj.inProgress = false;
									// Make the call
                  var deviceNameCMS = '';
                  var planNameCMS = '';
                  angular.forEach(response.internetProductDetails,function(internetProductValue){
                    if(internetProductValue["product-id"] == response.deviceId) {
                      if($scope.lng == "en")
                        deviceNameCMS = internetProductValue["english"]["short-description"];
                      else if($scope.lng == "fr")
                        deviceNameCMS = internetProductValue["french"]["short-description"];
                    }

                    if(internetProductValue["product-id"] == response.internetPlan) {
                      if($scope.lng == "en")
                        planNameCMS = internetProductValue["english"]["short-description"];
                      else if($scope.lng == "fr")
                        planNameCMS = internetProductValue["french"]["short-description"];
                    }

                  });
									$scope.internetObj.myModem.name = deviceNameCMS === ''? response.deviceName : deviceNameCMS;
                  $scope.internetObj.myPlan.package = planNameCMS === '' ? response.serviceName : planNameCMS; //'Ultimate Package';
									var deviceId = response.deviceId;
									if (response.deviceDetails[deviceId]) {
										$scope.internetObj.myModem.image = response.deviceDetails[deviceId].modemImagePath;
									}
									$scope.getDeviceImage();
									$scope.displaySpeedBoostLink = response.displaySpeedBoostLink;
									$scope.displayYahooMailButton = response.displayYahooMailButton;

									// Keep loading untill no stale data come back
									try {
										if (response.cachedResultInfo.expired === true) {

											setTimeout(function(){
												$scope.loadData(true);					// Ask for fresh data
												$scope.displayContent = true;
												$scope.loadingDataIndicator = true;
											}, 50);

										}
									} catch (e) {
										// Do nothing with this. Use data as is.
									}
								}
							}
						};

						// Process Error response
						$scope.processError = function (error) {
							// Hide loading usage
							$scope.displayContent = false;
							$scope.loadingDataIndicator = false;
							$scope.errorCode = error.errorCode === undefined ? '50000' : error.errorCode;
							$scope.errorMessage = resource.get($scope.errorCode);

							// Error handling - 555 exception
							if (error.data.status === 555) {
								$scope.errorCode = error.error.errorCode;
								$scope.errorMessage = error.error.message;
							} else {
								$scope.errorCode = 'error_usage_internet_modem';
								$scope.errorMessage = resource.get('error_usage_internet_modem');
							}
						};

						$scope.getDeviceImage = function () {
							if (!$scope.internetObj.myModem.image || $scope.internetObj.myModem.image === '') {
								$scope.internetObj.myModem.image = 'images/Internet-HD.png';
							} else {
								if (settings.isLocal) {
									$scope.internetObj.myModem.image = settings.formsURL + $scope.internetObj.myModem.image;
								}
							}
						};

						$scope.onOmnitureClickInternetMyModem = function (option) {
				      appState.tagging(option);
				    };


						// run it
						$scope.loadData(false);

						resource.onChanged(function () {
							var oldLang = $scope.lng;

							$scope.lang = userLanguage() + '-CA';
							$scope.lng = userLanguage();
							$scope.langUpper = userLanguage().toUpperCase();

							$scope.errorMessage = resource.get($scope.errorCode);
							$scope.planName = resource.get('internet_unlimited');

							if (oldLang !== $scope.lng) {
								$scope.loadData(false);
							}

							$scope.chatHref = userLanguage() === 'en' ? settings.chatLinkChangeModem.en : settings.chatLinkChangeModem.fr;
						}, $scope);

					}
				]
			};
		});

'use strict';

angular
		.module('totesApp')
		.directive('internetMyPackage', function () {
			return {
				restrict: 'AE',
				replace: 'true',
				scope: {},
				templateUrl: 'scripts/directives/internetMyPackage/internetMyPackage.html',
				link: function (scope, element, attrs) {
					// DOM or direct jQuery calls
				},
				controller: ['$rootScope', '$scope', 'myrInternetService', 'localStorage', 'userLanguage', 'resource', 'settings', 'appState',
					function ($rootScope, $scope, internetService, localStorage, userLanguage, resource, settings, appState) {

						// Required by template - Variables set
						$scope.internetObj = {
							days: 0,
							usedGb: 0,
							globalColor: '',
							globalPercentage: 0,
							unlimitedClass: 'normal',
							extraUsage: 0,
							chargeAmount: 0,
							myPlan: {
								totalGB: '',
								total: '',
								package: '',
								downloadSpeed: '',
								uploadSpeed: ''
							},
							myExtras: [],
							myModem: {
								name: '',
								image: '',
								imagePath: ''
							}
						};

						var messageBoxDom = function () {
              $scope.myPackageMessage='<div class="info-box-header">'
                                     +"<span class='header-tab'><strong>"+resource.get("to_manage")
                                     +":</strong>"+"</div>"
                                     +'<div class="info-box-body">'
                                     +'<div class="info-box-col">'
                                     +'<div><strong>'+resource.get("package")+'</strong></div>'
                                     +'<div><strong>'+resource.get("extras")+'</strong></div>'
                                     +"</div>"
                                     +'<div class="info-box-col"><img src="images/message-arrow.png"/></div>'
                                     +'<div class="login-text">'
                                     +resource.get("login_to")+" "+resource.get("sgi")+"</div>"
                                     +'</div>';
             }
						$scope.isDealer = $rootScope.isDealer;
            $scope.isCare = $rootScope.isCare;
                messageBoxDom();
                resource.onChanged(function () {
                      messageBoxDom();
                       }, $scope);

						$scope.lang = userLanguage() + '-CA';
						$scope.lng = userLanguage();

						$scope.postToRogersUrls = [
							{url: '/web/myrogers/torcom/internetUsage/ViewUsageHistory' + '?setLanguage=' + $scope.lng},
							{url: '/web/myrogers/torcom/internetUsage/ViewUsageAlerts' + '?setLanguage=' + $scope.lng},
							{url: '/web/myrogers/torcom/internetUsage/DailyUsage' + '?setLanguage=' + $scope.lng},
							{url: '/web/myrogers/torcom/internetUsage/MonthlyUsage' + '?setLanguage=' + $scope.lng},
							{url: 'http://www.dev44.rogers.com/web/myrogers/torcom/internetChangePackage' + '?setLanguage=' + $scope.lng}
						];

						$scope.displayContent = false;
						$scope.loadingDataIndicator = true;
						$scope.internetUsageEmpty = false;
						$scope.errorMessage = '';
						$scope.hasExtras = false;

						$scope.dollarSignA = userLanguage() === 'fr' ? '$' : '';
						$scope.dollarSignB = userLanguage() === 'en' ? '$' : '';
						$scope.selectedAccount = $rootScope.ao.accountDetails;

						// Support functions
						$scope.postToRogers = function (actionId) {
							if (actionId === 4) {
								$('<input>').attr({
									type: 'text',
									name: 'currentPackageId',
									value: $scope.currentPackageId
								}).appendTo('#formToRogers');
								$('<input>').attr({
									type: 'text',
									name: 'currentModemId',
									value: $scope.currentModemId
								}).appendTo('#formToRogers');
							}

							$('#formToRogers').attr('action', settings.formsURL + $scope.postToRogersUrls[actionId].url);
							$('#formToRogers').submit();
						};


						// From old controller
						$scope.loadData = function (refreshCall) {
							refreshCall = (refreshCall === undefined) ? false : refreshCall;

							// collect the data that you need to run this directive
							$scope.passParams = {};
							$scope.passParams.accountNumber = localStorage.getLocalStorageValue('internetAccountNumber');
							$scope.passParams.refresh = refreshCall;
              $scope.passParams.lang = $scope.lng.toUpperCase();
							// new way
							internetService.internetPackage($scope.passParams, $scope.processResponse, $scope.processError);
						};

						// Process data response
						$scope.processResponse = function (response) {
							if (response) {
								if (response === undefined || response === null) {
									$scope.displayContent = false;
									$scope.loadingDataIndicator = false;

									$scope.errorCode = '50000';
									$scope.errorMessage = resource.get($scope.errorCode);
								} else {
									// Hide loading usage
									$scope.currentModemId = response.deviceId;
									$scope.currentPackageId = response.internetPlan;

									// Show page
									$scope.displayContent = true;
									$scope.loadingDataIndicator = false;
                  internetService.internetPackageObj.inProgress = false;
                  var deviceNameCMS = '';
                  var planNameCMS = '';

                  angular.forEach(response.internetProductDetails,function(internetProductValue){
                       if(internetProductValue["product-id"] == response.deviceId) {
                         if($scope.lng == "en")
                         deviceNameCMS = internetProductValue["english"]["short-description"];
                         else if($scope.lng == "fr")
                           deviceNameCMS = internetProductValue["french"]["short-description"];
                       }

                    if(internetProductValue["product-id"] == response.internetPlan) {
                      if($scope.lng == "en")
                        planNameCMS = internetProductValue["english"]["short-description"];
                      else if($scope.lng == "fr")
                        planNameCMS = internetProductValue["french"]["short-description"];
                    }

                  });
									$scope.internetObj.myModem.name = deviceNameCMS === '' ? response.deviceName : deviceNameCMS;
									$scope.internetObj.myPlan.package = planNameCMS === '' ? response.serviceName : planNameCMS; //'Ultimate Package';
                  var deviceId = response.deviceId;
                  if (undefined != response.internetProductDetails[deviceId]) {
                    $scope.internetObj.myModem.image = response.deviceDetails[deviceId].modemImagePath;
                  }
                  $scope.getDeviceImage();
									// Keep loading untill no stale data come back
									try {
										if (response.cachedResultInfo.expired === true) {

											setTimeout(function(){
												$scope.loadData(true);					// Ask for fresh data
												$scope.displayContent = true;
												$scope.loadingDataIndicator = true;
											}, 50);

										}
									} catch (e) {
										// Do nothing with this. Use data as is.
									}
								}
							}
						};

						// Process Error response
						$scope.processError = function (error) {
							// Hide loading usage
							$scope.displayContent = false;
							$scope.loadingDataIndicator = false;
							$scope.errorCode = error.errorCode === undefined ? '50000' : error.errorCode;
							$scope.errorMessage = resource.get($scope.errorCode);

							// Error handling - 555 exception
							if (error.data.status === 555) {
								$scope.errorCode = error.error.errorCode;
								$scope.errorMessage = error.error.message;
							} else {
								$scope.errorCode = 'error_usage_internet_modem';
								$scope.errorMessage = resource.get('error_usage_internet_modem');
							}
						};


            $scope.getDeviceImage = function () {
              if (!$scope.internetObj.myModem.image || $scope.internetObj.myModem.image === '') {
                $scope.internetObj.myModem.image = 'images/Internet-HD.png';
              } else {
                if (settings.isLocal) {
                  $scope.internetObj.myModem.image = settings.formsURL + $scope.internetObj.myModem.image;
                }
              }
            };

						$scope.onOmnitureClickInternet = function (option) {
				      appState.tagging(option);
				    };




						// run it
						$scope.loadData(false);

						resource.onChanged(function () {
							var oldLang = $scope.lng;

							$scope.lang = userLanguage() + '-CA';
							$scope.lng = userLanguage();
							$scope.dollarSignA = userLanguage() === 'fr' ? '$' : '';
							$scope.dollarSignB = userLanguage() === 'en' ? '$' : '';
							$scope.errorMessage = resource.get($scope.errorCode);

							if (oldLang !== $scope.lng) {
								$scope.loadData(false);
							}

							$scope.postToRogersUrls = [
								{url: '/web/myrogers/torcom/internetUsage/ViewUsageHistory' + '?setLanguage=' + $scope.lng},
								{url: '/web/myrogers/torcom/internetUsage/ViewUsageAlerts' + '?setLanguage=' + $scope.lng},
								{url: '/web/myrogers/torcom/internetUsage/DailyUsage' + '?setLanguage=' + $scope.lng},
								{url: '/web/myrogers/torcom/internetUsage/MonthlyUsage' + '?setLanguage=' + $scope.lng},
								{url: '/web/myrogers/torcom/internetChangePackage' + '?setLanguage=' + $scope.lng}
							];
						}, $scope);

					}
				]
			};
		});

'use strict';

angular
		.module('totesApp')
		.directive('internetMyUsage', function () {
			return {
				restrict: 'AE',
				replace: 'true',
				scope: {},			// closed scope
				templateUrl: 'scripts/directives/internetMyUsage/internetMyUsage.html',
				link: function (scope, element, attrs) {
					// DOM or direct jQuery calls
				},
				controller: ['$scope' , '$http','$browser','settings', 'myrInternetService', 'myrInternetChartService', 'localStorage', 'userLanguage', 'appState', 'resource', '$timeout', '$filter', '$rootScope','$state', 'ajax','myrSigninService', '$window',
					function ($scope, $http, $browser, settings, internetService, internetChart, localStorage, userLanguage, appState, resource, $timeout, $filter, $rootScope, $state, ajax, signinService, $window) {

						// Verify user is logged in with proper access
						$scope.selectedAccount = {};

						// $scope.selectedAccount.accountName = {};			// ??????



						var lsAcc = localStorage.getLocalStorageValue('internetAccountNumber');

						if (lsAcc === null) {
							// Send user back to Account overview????
							appState.switchView('accountOverview');
						} else {
							$scope.selectedAccount.accountNumber = lsAcc;
							$scope.selectedAccount.ban = localStorage.getLocalStorageValue('accountNumber');
						}

             $scope.isDealer = $rootScope.isDealer;
             $scope.isCare = $rootScope.isCare;


						// Required by template - Variables set
						$scope.graphData = {};
						$scope.internetObj = {
							days: 0,
							usedGb: 0,
							globalColor: '',
							globalPercentage: 0,
							unlimitedClass: 'normal',
							extraUsage: 0,
							chargeAmount: 0,
							myPlan: {
								totalGB: 0,
								total: 0,
								package: '',
								downloadSpeed: '',
								uploadSpeed: ''
							},
							myExtras: [],
							myModem: {
								name: '',
								image: '',
								imagePath: ''
							}
						};

						$scope.lang = userLanguage() + '-CA';
						$scope.lng = userLanguage();
						$scope.langUpper = userLanguage().toUpperCase();

						$scope.postToRogersUrls = [
							{url: '/web/myrogers/torcom/internetUsage/ViewUsageHistory' + '?setLanguage=' + $scope.lng},
							{url: '/web/myrogers/torcom/internetUsage/ViewUsageAlerts' + '?setLanguage=' + $scope.lng},
							{url: '/web/myrogers/torcom/internetUsage/DailyUsage' + '?setLanguage=' + $scope.lng},
							{url: '/web/myrogers/torcom/internetUsage/MonthlyUsage' + '?setLanguage=' + $scope.lng},
							{url: '/web/myrogers/torcom/internetChangePackage' + '?setLanguage=' + $scope.lng}
						];

						$scope.loadingDataIndicator = true;
						$scope.displayContent = false;
						$scope.internetUsageEmpty = '';
						$scope.errorMessage = '';
						$scope.unlimitedShow = false;
						$scope.isOverage = false;

						$scope.planName = '';
						$scope.lbGB = '';
						$scope.lbRemaining = '';
						$scope.lbDown = 0;
						$scope.lbUpload = 0;
						$scope.lblOvrUsedMonth = '';
						$scope.lblOvrUsed = '';


						// Support functions
						$scope.postToRogers = function (actionId) {
							if (actionId === 4) {
								// Exception - what ever you do. Do not let 4 through. (Don't know why tho.)
							} else {
								$('#formToRogers').attr('action', settings.formsURL + $scope.postToRogersUrls[actionId].url);
								$('#formToRogers').submit();
							}
						};

            $scope.showUsage = function (usageType) {
              if(usageType === 'daily') {
                appState.tagging(['_trackPageView', {pn: 'internet_viewdailyusage_viewdailyusage'}]);
                $state.go("internetUsage.daily", {usageType: usageType});
              }
              else if(usageType === 'monthly'){
                appState.tagging(['_trackPageView', {pn: 'internet_viewmonthlyusage_viewmonthlyusage'}]);
                $state.go("internetUsage.monthly",{ usageType : usageType});
              }
              else if(usageType === 'notification'){
                appState.tagging(['_trackPageView', {pn: 'internet_viewusagealerts_viewusagealerts'}]);
                $state.go("internetUsage.notification",{ usageType : usageType});
              }
            };

            $scope.redirectToColonyPortal = function () {
               signinService.mbhUrlConfig().then(function(urlResponse){
                    $window.location.href = urlResponse.ColonyPortalUrl;
                });
            };
						// From old controller
						$scope.loadData = function () {
							var status = '';
							var accType = '';

							$scope.loadingDataIndicator = true;
							$scope.displayContent = false;

							if ($scope.selectedAccount.accountInfo) {
								status = $scope.selectedAccount.accountInfo.status;
								accType = $scope.selectedAccount.accountInfo.accType;
							}

							// Oniture tagging
							/*appState.tagging(['_trackPageView',
								{pn: 'home:myrogers:internet'},
								{sACTT: status}, // Consumer, Business
								{sBAN: $scope.selectedAccount.accountNumber}, //Account Number BAN, ex : '12345'
								{sCTN: $scope.selectedAccount.accountNumber}, //Account Telephone Number CTN, ex: '4161234567|4161234568'
								{sACSS: accType}
							]);*/

							// collect the data that you need to run this directive
							$scope.passParams = {};
							$scope.passParams.accountNumber = localStorage.getLocalStorageValue('internetAccountNumber');

							// Optimized backend calls
							internetService.internetUsage($scope.passParams, $scope.processResponse, $scope.processError);
						};

						// Process data response
						$scope.processResponse = function (response) {

							// Hide loading usage
							$scope.internetUsageEmpty = (response.internetUsageToolVO.errorCodeCurrentUsageAvailable === 'NoUsage');

							if (response) {
								if (response === undefined || response === null) {
									$scope.displayContent = false;
									$scope.loadingDataIndicator = false;

									$scope.errorCode = '50000';
									$scope.errorMessage = resource.get($scope.errorCode);
								} else {
									// Show page
									$scope.displayContent = true;
									$scope.loadingDataIndicator = false;

									// Reset graph
									$scope.graphData = {};
									$scope.internetObj.days = 0;

									// Is ths unlimited plan?
									if (response.internetUsageTotal > 99999 && response.internetUsageRemaining > 99999) {
										$scope.unlimitedShow = true;
									} else {
										$scope.unlimitedShow = response.isInternetUsageUnlimited;
									}

									if ($scope.unlimitedShow) {
										$scope.planName = resource.get('internet_unlimited');
									} else {
										$scope.planName = response.serviceName;
									}

									$scope.lblOvrUsedMonth = '';
									$scope.lblOvrUsed = '';

									$scope.isOverage = response.internetUsageToolVO.currentUsageSummaryVO.currentTotalExtraUsage > 0 ? true : false;
									$scope.internetObj.extraUsage = response.internetUsageToolVO.currentUsageSummaryVO.currentTotalExtraUsage;
									$scope.internetObj.chargeAmount = response.internetUsageToolVO.currentUsageSummaryVO.currentTotalChargeAmount;

									// Percentages
									var total = response.internetUsageTotal === undefined ? response.internetUsageToolVO.currentUsageSummaryVO.usageCapacity : response.internetUsageTotal;
									total = Math.round(total * 10) / 10;
									$scope.internetObj.myPlan.total = total;

									var used = 0;
									used = response.internetUsageToolVO.currentUsageSummaryVO.totalUsage;

									var remaining = (total - used);
									$scope.internetObj.myPlan.totalGB = $scope.unlimitedShow === true ? resource.get('internet_unlimited') : total;
									$scope.internetObj.usedGb = used;
									$scope.internetObj.remainingGb = remaining.toFixed(2);

									var divider = total;
									if (divider === 0) {
										divider = 1;
									}
									$scope.internetObj.globalPercentage = Math.ceil((used / divider) * 100);

									$scope.internetObj.downloaded = 0;
									$scope.internetObj.uploaded = 0;

									var startDate = '';
									var endDate = '';
									var downTotal = 0;
									var upTotal = 0;

									if (response.internetUsageToolVO.dayToDayVO[0]) {
										startDate = response.internetUsageToolVO.dayToDayVO[0].billPeriodStartDate;
										endDate = response.internetUsageToolVO.dayToDayVO[0].billPeriodEndDate;

										for (var ix = 0; ix < response.internetUsageToolVO.dayToDayVO[0].dailyUsageList.length; ix++) {
											downTotal += response.internetUsageToolVO.dayToDayVO[0].dailyUsageList[ix].downLoadUsage;
											upTotal += response.internetUsageToolVO.dayToDayVO[0].dailyUsageList[ix].upLoadUsage;
										}

										$scope.internetObj.downloaded = response.internetUsageToolVO.currentUsageSummaryVO.currentDownloadTotalUsage;
										$scope.internetObj.uploaded = response.internetUsageToolVO.currentUsageSummaryVO.currentUploadTotalUsage;

									} else { //no usage
										var defaultVO = response.internetUsageToolVO.currentUsageSummaryVO;
										startDate = defaultVO.currentBillPeriodStartDate;
										endDate = defaultVO.currentBillPeriodEndDate;
									}

									$scope.defineLabels();
									$scope.getRoundClass();

									var dtStartdate = new Date(startDate);
									var dtEndDate = new Date(endDate);
									var dtToday = new Date();

									$scope.internetObj.days = Math.round((dtEndDate.getTime() - dtToday.getTime()) / (settings.msInDay)); //+ 1;
									if ($scope.internetObj.days < 0) {
										$scope.internetObj.days = 0;
									}

									$scope.graphData.data = response;
									$scope.graphData.total = total;
									$scope.graphData.startDate = startDate;
									$scope.graphData.endDate = endDate;
									$scope.graphData.dtStartDate = dtStartdate;
									$scope.graphData.dtEndDate = dtEndDate;
									$scope.graphData.days = $scope.internetObj.days;
								}
							}

							$timeout(function () {
								internetChart.drawChartSync ($scope.graphData, true);
							});
						};
						// Process Error response
						$scope.processError = function (error) {
							// Hide loading usage
							$scope.displayContent = false;
							$scope.loadingDataIndicator = false;
							$scope.errorCode = error.errorCode === undefined ? '50000' : error.errorCode;
							$scope.errorMessage = resource.get($scope.errorCode);

							// Error handling - 555 exception
							if (error.data.status === 555) {
								$scope.errorCode = error.error.errorCode;
								$scope.errorMessage = error.error.message;
							} else {
								$scope.errorCode = 'error_usage_internet_modem';
								$scope.errorMessage = resource.get('error_usage_internet_modem');
							}
						};



						$scope.defineLabels = function () {
							var remainingAmount = $scope.internetObj.myPlan.total > 1 ? 'wireless_remaining_plural' : 'wireless_remaining';
							$scope.lbGB = $filter('bilingualnumber')($scope.internetObj.remainingGb, 2);

							$scope.lbRemaining = resource.get(remainingAmount) + ' / ' + $filter('bilingualnumber')($scope.internetObj.myPlan.total, 2) + ' ' + resource.get('internet_GB');
							$scope.lbDown = resource.get('internet_downloaded') + ' ' + $filter('bilingualnumber')($scope.internetObj.downloaded, 2) + ' ' + resource.get('internet_GB');
							$scope.lbUpload = resource.get('internet_uploaded') + ' ' + $filter('bilingualnumber')($scope.internetObj.uploaded, 2) + ' ' + resource.get('internet_GB');
							$scope.internetObj.myPlan.totalGB = $scope.unlimitedShow === true ? resource.get('internet_unlimited') : $filter('bilingualnumber')($scope.internetObj.myPlan.total, 2) + ' ' + resource.get('internet_GB');

							$scope.lblOvrUsedMonth = $filter('bilingualnumber')($scope.internetObj.myPlan.total, 2) + ' ' + resource.get('internet_GB') + ' ' + resource.get('internet_per_month');
							$scope.lblOvrUsed = $filter('bilingualnumber')($scope.internetObj.usedGb, 2) + ' ' + resource.get('internet_GB') + ' ' + resource.get('internet_used');
						};

						$scope.getRoundClass = function () {
							if ($scope.internetObj.globalPercentage <= 100) {
								$scope.internetObj.globalColor = 'usageNormal';
								$scope.internetObj.globalNotice = 'Looking good';
							} else if ($scope.internetObj.globalPercentage > 100) {
								$scope.internetObj.globalColor = 'usageWarning';
								$scope.internetObj.globalNotice = 'Check it out';
							}

							if ($scope.internetObj.globalPercentage > 100) {
								$scope.internetObj.globalPercentage = 100;
							}
						};


						// run it
						$scope.loadData();

						resource.onChanged(function () {
							var oldLang = $scope.lng;

							$scope.lang = userLanguage() + '-CA';
							$scope.lng = userLanguage();
							$scope.langUpper = userLanguage().toUpperCase();

							$scope.errorMessage = resource.get($scope.errorCode);
							$scope.planName = resource.get('internet_unlimited');

							if (oldLang !== $scope.lng) {
								$scope.loadData();
							}

							$scope.postToRogersUrls = [
								{url: '/web/myrogers/torcom/internetUsage/ViewUsageHistory' + '?setLanguage=' + $scope.lng},
								{url: '/web/myrogers/torcom/internetUsage/ViewUsageAlerts' + '?setLanguage=' + $scope.lng},
								{url: '/web/myrogers/torcom/internetUsage/DailyUsage' + '?setLanguage=' + $scope.lng},
								{url: '/web/myrogers/torcom/internetUsage/MonthlyUsage' + '?setLanguage=' + $scope.lng},
								{url: '/web/myrogers/torcom/internetChangePackage' + '?setLanguage=' + $scope.lng}
							];

							$scope.defineLabels();

							if ($scope.loadingDataIndicator === false) {
								internetChart.drawChartSync($scope.graphData, false);
							}
						}, $scope);

					}
				]
			};
		});

'use strict';

angular.module('totesApp').directive('liveChat', function () {

    return {
        templateUrl: "scripts/directives/liveChat/liveChat.html",
        replace: true,
        restrict: "E"

    };

});

'use strict';

angular.module('totesApp')
.directive('mbhLinks', function () {
			return {
				restrict: 'E',
				scope: {},
        templateUrl: 'scripts/directives/mbhLinks/mbhLinks.html'
      }
})
.controller('mbhLinksCtrl', ['$scope', '$rootScope', 'ocpService', '$browser', 'resource', 'localStorage', 'user', 'userLanguage',
			function ($scope, $rootScope, ocpService, $browser, resource, localStorage, user, userLanguage) {


          var _keepAliveInit = false;
          $scope.lang = (userLanguage() == 'en')?'en_US':userLanguage();
          $scope.ocpHeader1 = "";
          $scope.links =[];
          $scope.launcherEnabled = ocpService.launcherInitialized;
          $scope.showContent = false;
          $rootScope.$on('initializeMbhLauncher', function(evt, data) {
              if(ocpService.launcherInitialized == false && data && data.accountList && data.accountList.length > 0 && localStorage.getLocalStorageValue('BSS_OCP_UTE')	== "true"){
                  MBHLauncher.initialize({
                    launcherLanguage: ocpService.userLang,
                    launcherURL: '/launcher/v-3/mbh-launcher.html',
                    inactivityTime: 1000 * 2 * 60,
                    heartBeatInterval: 1000 * 1 * 60,
                    portalId: 'BSSS',
                    token: '',
                    logoutRedirect: window.location.origin + '/web/smb/bss/#/signin',
                    enableCheckInactive: false
                  },true);
                  MBHLauncher.setLanguage(ocpService.userLang);
                  MBHLauncher.setPortalId('BSSS');
                  // MBHLauncher.setCookie($browser.cookies().R1IDSMSESSION);
                  ocpService.launcherInitialized = true;
                  $scope.launcherEnabled = true;
                  $scope.mbhUrl = localStorage.getLocalStorageValue('MBHUrl');
              }
          });

          MBHLauncher.subscribe('sessionKeptAlive', function() {
             if (!_keepAliveInit) {
               _keepAliveInit = true;
               MBHLauncher.getJSON();

             }
          });
      //EAS Change - fix to avoid triggering signout after A/Oview loading
          /*  if ($rootScope.esfSessionListenerEnabled) {
            MBHLauncher.subscribe('sessionTimeout', function(e, d) {
              // MBHLauncher.signOut();
              // MBHLauncher.destroy();
              user.logout();
           });
          }*/

          $scope.launcherEnabled = function() {
              if(ocpService.launcherInitialized){
          		   return true
          		}else{
          			  return false
          		}
          }

          $scope.mbhOpen = function () {
          		$scope.showContent = !$scope.showContent
          }

          MBHLauncher.subscribe('launcherDataRecieved', function(e,json) {
              $scope.ocpHeader1 = json.content[0].header1;
              $scope.links = json.content[0].links;
              $scope.mbhUrl = localStorage.getLocalStorageValue('MBHUrl');
              //RBIB-28504
              $rootScope.portalIds = [];
              for (var i = 0; i < $scope.links.length; i++) {
                 $rootScope.portalIds.push($scope.links[i].id);
             }
          });


}]);

'use strict';

angular.module('totesApp')
.directive('mobileMbhLinks', function () {
			return {
				restrict: 'E',
				scope: {},
        templateUrl: 'scripts/directives/mbhLinks/mobileMbhLinks.html'
      }
});

'use strict';

angular
	.module('totesApp')
	.directive('messageInfoBox', ['resource',
		function (resource) {
			return {
				scope: {
				infoMessage: '='
				},
				templateUrl: "scripts/directives/messageInfoBox/messageInfoBox.html",
				replace: true,
				restrict: "E",
				link: function (scope, element, attrs, $sce) {

				}
			};
		}]);


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  // TODO please finished refactoring according to https://github.com/johnpapa/angular-styleguide

  angular.module('totesApp').directive('myOffers', myOffers);

  // TODO all dependencies moved to controller - please cleanup
  myOffers.$inject = ['$rootScope', '$modal', 'resource', 'userLanguage', 'settings', '$window', 'ajax', '$filter', 'localStorage', '$timeout', 'appState'];

  /* @ngInject */
  function myOffers($rootScope, $modal, resource, userLanguage, settings, $window, ajax, $filter, localStorage, $timeout, appState) {
    return {
      templateUrl: 'scripts/directives/myOffers/myOffers.html',
      restrict: 'E',
      //link: function postLink($scope, element, attrs) {
      //},
      controller: ['$scope', 'settings', 'localStorage', 'appState', 'ajax', '$timeout', '$rootScope', '$filter',
        function ($scope, settings, localStorage, appState, ajax, $timeout, $rootScope, $filter) {
          $scope.revolutionLink = /*'https://' + $window.location.hostname +*/ settings.revolutionLink;

          $scope.hasTPSApermission = false;
          $scope.revPermissionLoaded = false;

          // Used in ute-injected content - do not remove
          $scope.openModal = function (size) {

            var serverHack = '/web/smb/bss';
            if (settings.isLocal) {
              serverHack = '';
            }

            $rootScope.modal = $modal.open({
              templateUrl: serverHack + '/views/modals/briteBillPromo.html',
              controller: 'briteBillPromoModalCtrl',
              size: size,
              backdrop: false,
              //backdropClass: 'bkg-modal',
              resolve: {}
            });

            $rootScope.modal.result.then(function () {

            }, function () {
              // on Cancel behaviour
            });
          };

          function getPermissions() {

            $scope.hasTPSApermission = false;
            $scope.revPermissionLoaded = false;

            var hasRevPermission = localStorage.getLocalStorageValue('RevPermission');
            if (hasRevPermission) {

              if (hasRevPermission === '1') {
                $scope.hasTPSApermission = true;
                $scope.revPermissionLoaded = true;
                return;
              }
              if (hasRevPermission === '0') {
                $scope.hasTPSApermission = false;
                $scope.revPermissionLoaded = true;
                return;
              }

            }
            //to avoid second call because widget is displayed twice on the page
            if (appState.permissionsLoaded) {
              return;
            }
            appState.permissionsLoaded = true;

            ajax.getPermissions().then(function (result) {
              // var permissionsData =  backend.getRevPermissions().then(function (result) {
              var permissionRev = ($filter('filter')(result.permissions, {permission: 'TPSA_PAGE_VIEW'}));

              if (permissionRev && permissionRev.length > 0 || settings.isLocal) {
                $scope.hasTPSApermission = true;
                $scope.revPermissionLoaded = true;
                localStorage.setLocalStorageValue('RevPermission', '1');
                $timeout(function () {
                  $rootScope.$broadcast('gotPermissions');
                }, 500);
              } else {
                localStorage.setLocalStorageValue('RevPermission', '0');
                $scope.hasTPSApermission = false;
                $scope.revPermissionLoaded = true;
              }
            }, function (error) {
              localStorage.setLocalStorageValue('RevPermission', 'error');
              $scope.hasTPSApermission = false;
              $scope.revPermissionLoaded = true;
              appState.permissionsLoaded = false;
            });
          }

          getPermissions();

        }]

    };
  }

  // TODO please finished refactoring according to https://github.com/johnpapa/angular-styleguide
  angular.module('totesApp').controller('briteBillPromoModalCtrl', ['$scope', '$rootScope', '$modalInstance', '$sce', 'userLanguage',
    function ($scope, $rootScope, $modalInstance, $sce, userLanguage) {

      $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
      };

      $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
      };

      function watchVideo() {
        $scope.lang = userLanguage();
        if ($scope.lang === 'en') {
          $scope.videoLink = $scope.trustSrc('https://www.youtube.com/embed/yQhrPek1KJw?autoplay=1&showinfo=0&rel=0&controls=0');
        } else if ($scope.lang === 'fr') {
          $scope.videoLink = $scope.trustSrc('https://www.youtube.com/embed/sQi8PxSD-sA?autoplay=1&showinfo=0&rel=0&controls=0');
        }
      }

      watchVideo();

    }])
})();

'use strict';

/**
 * @ngdoc directive
 * @name totesApp.directive:myservices
 * @description
 * # myservices
 */

/*var dummyArray = [
  {
    icon:'rui-icon-internet',
    serviceType:'Internet',
    serviceDetail:null,
    linkText:'Manage',
    linkURL:'#'
  },
  {
    icon:'rui-icon-tv',
    serviceType:'TV',
    serviceDetail:null,
    linkText:'Manage',
    linkURL:'#'
  },
  {
    icon:'rui-icon-wireless',
    serviceType:'Wireless',
    serviceDetail:'416-123-4567',
    linkText:'Manage',
    linkURL:'#wireless'
  }
];*/


angular.module('totesApp')
  .directive('myservices', ['$rootScope','btnSettings', '$window', 'resource', function ($rootScope, btnSettings, $window, resource) {
    return {
      templateUrl: 'scripts/directives/myservices/myservices.html',
      //scope: {
      //    myServicesList:"=list",
      //    mode:"=mode"
      //},
      restrict: 'E',
      link: function postLink($scope) {
          //scope.myServicesList = dummyArray;
          //scope.mode;

        $scope.isDealer = $rootScope.isDealer;
        $scope.isCare = $rootScope.isCare;
        $rootScope.$watch('ao.accountActive', function() {
          if($rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatus) {
            $scope.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
            $scope.btnStatus = $window.btnStatus;
          }
          messageBoxDom();
        });
        var messageBoxDom = function () {
          $scope.loginMessage= "<strong>"+resource.get("login_to")+" "+resource.get("sgi")+"</strong>";
        }

        resource.onChanged(function () {
              messageBoxDom();
       }, $scope);
      }
    };
  }]);

'use strict';

angular.module('totesApp').directive('needHelp', function() {

  return {
    templateUrl: "scripts/directives/needHelp/needHelp.html",
    replace: true,
    restrict: "EA",
    scope: { cbid:'=', boldChatDiv: '=dynamicDiv', chatButton: '='},
    link: function(scope, element, attrs)
    {

      var watcher = scope.$watch(function (){
          var id = document.getElementById(scope.boldChatDiv);
          return id;
        }, function (newValue, oldValue) {
          if(null != newValue){
            var bdid = getBDId(scope.cbid);
            staticLiveChatButtonUTE(bdid, scope.boldChatDiv, scope.chatButton);
          }
          watcher();
        }
      );

      scope.$watch('chatButton', function(newValue, oldValue) {
        if (newValue !== oldValue) {
          var bdid = getBDId(scope.cbid);
          var chatButtonOld = oldValue;
          staticLiveChatButtonUTE(bdid, scope.boldChatDiv, scope.chatButton, chatButtonOld);
        }
      }, true);

    }
  };
});

'use strict';

angular.module('totesApp')
  .service('agentSession', ['$http', '$q', '$rootScope', 'ajax', 'settings', '$window', 'localStorage', 'appState', '$state', '$location', '$cookieStore', function ($http, $q, $rootScope, ajax, settings, $window, localStorage, appState, $state, $location, $cookieStore) {
      return {
        startAgentSession: function(){
          var deferred = $q.defer();
          var $this = this;
          ajax.agentInfo().then(
            function (data) {
                  if(!data || !data.cfaInfo){
                    deferred.reject('No cfaInfo');
                  }
                  $rootScope.userInfo = {
                    cfaInfo: data,
                    type: 'cfa'
                  };
                 $this.renewAgentSession();
            }, function (error) {
                deferred.reject(error);
            });
        },

        renewAgentSession: function(){
            if($rootScope.userInfo && $rootScope.userInfo.cfaInfo){
                $rootScope.$broadcast('timer-clear');
                var d1 = new Date ();
                var d2 = new Date ( d1 );
                d2.setMinutes ( d1.getMinutes() + settings.agentInfo.timeout);
                $rootScope.agentExpiry = d2;
                $rootScope.$broadcast('timer-start');
                $http.post($rootScope.userInfo.cfaInfo.sourceURL + settings.agentInfo.heartbeatURL + ';jsessionid=' + $rootScope.userInfo.cfaInfo.jsessionId);
            }
        },
        renewCareSession: function(){
           $rootScope.$broadcast('timer-clear');
           var d1 = new Date ();
           var d2 = new Date ( d1 );
           d2.setMinutes ( d1.getMinutes() + settings.agentInfo.timeout);
           $rootScope.agentExpiry = d2;
           $rootScope.$broadcast('timer-start');

        },
        endAgentSession: function(){
          $cookieStore.remove('userType');
          var path;
          if($rootScope.userInfo && $rootScope.userInfo.cfaInfo)
          path = $rootScope.userInfo.cfaInfo.sourceURL ? $rootScope.userInfo.cfaInfo.sourceURL
                      + settings.agentInfo.sspHomeURL : false;
          $rootScope.$broadcast('timer-stop');
          $rootScope.userInfo = {};
          if (!path){
            $state.go('home');
          } else {
            $window.location = path;
          }
        },
        endCareSession: function(isReload){
          $cookieStore.remove('userType');
          $window.location.href ='/web/totes/#/oneViewInterface?error='+settings.oneViewErrorCodes.sessionTimeout;
          $window.location.reload(true);
        }
      };
  }]);

'use strict';

angular.module('totesApp').directive('body', ['agentSession', 'localStorage', 'settings', '$browser', function (agentSession, localStorage, settings, $browser) {
    return {
      restrict: 'E',
      scope: false,
      controller: ["$scope", "$element", "$rootScope", "util", function ($scope, $element, $rootScope, util) {
      var userType = $browser.cookies().userType;

        $($element[0]).on('click', function(e){
          if(userType) {
              if(userType === settings.userType.dealer) {
                  agentSession.renewAgentSession();
              } else if(userType === settings.userType.care){
                  agentSession.renewCareSession();
              }
          }
        });

         $scope.$on('timer-stopped', function (event, data){
            if(userType) {
               if(userType === settings.userType.dealer) {
                    agentSession.endAgentSession();
               } else if(userType === settings.userType.care){
                    agentSession.endCareSession(true);
               }

            }
        });
      }]
    };
  }]);

'use strict';

angular.module('totesApp')
    .directive('optionsDialog',['userOptions', function (userOptions) {
        return {

            scope: {},

            replace: true,

            templateUrl: 'scripts/directives/optionsDialog/optionsDialog.html',

            restrict: 'E',

            link: function (scope, $elem) {

                var $body = $("body");

                //scope, optionType, callback
                userOptions.subscribe(scope, function /*callback function when userOptions is broadcast*/(param) {

                    scope.$extend(param);

                    scope.action = function (actionId) {
                        closeDialog();
                        userOptions.done(actionId);
                    };


                    setTimeout(function () {
                        $body.css("overflow", "hidden");
                        $elem.show();
                    }, 20);

                    function closeDialog() {
                        $body.css("overflow", "");
                        $elem.hide();
                    }

                    $elem.delegate(".close", "click", closeDialog);

                });
            }
        };
    }]);


/*optionDialog.listen( function( currentOptions ) {

 $.extend( scope, currentOptions );
 scope.ignoreCurrentOptions = optionDialog.ignoreCurrentOptions;

 scope.action = function( actionNumber ) {
 optionDialog.done( actionNumber );
 };

 setTimeout( function() {
 //$body.addClass("overflowHidden");
 $body.css( "overflow", "hidden" );
 //$elem.show();
 $overlay.show();
 }, 20 );
 } );

 $elem.delegate( ".close", "click", function() {
 //$body.removeClass("overflowHidden");
 $body.css( "overflow", "" );
 //$elem.hide();
 $overlay.hide();
 } );
 */
'use strict';

/**
 * @ngdoc directive
 * @name totesApp.directive:otherservices/otherservices
 * @description
 * # otherservices/otherservices
 */
angular.module('totesApp')
  .directive('otherservices', [function () {
    return {
      templateUrl: 'scripts/directives/otherservices/otherservices.html',
      scope: {
        myOtherServicesListFinal:"=list"
      },
      restrict: 'E',
      link: function postLink(scope, element, attrs) {

      }
    };
  }]);

'use strict';

angular.module('totesApp')
	.directive('pageHeadline', function () {
		return {
			restrict: 'EA',
			templateUrl: 'scripts/directives/pageHeadline/pageHeadline.html',
			link: function postLink(scope, element, attrs) {},
			controller: ["$scope", "$attrs", "resource", function ($scope, $attrs, resource) {
				$scope.pageHeadline = {};

				var title = '';
				if (resource.get($attrs.text)) {
					title = resource.get($attrs.text);
				} else {
					title = '{missing resource}';
				}

				$scope.pageHeadline.text = title;

        resource.onChanged(function () {

          if (resource.get($attrs.text)) {
            title = resource.get($attrs.text);
          } else {
            title = '{missing resource}';
          }

          $scope.pageHeadline.text = title;
        }, $scope);
			}]


		};
	});

'use strict';
/*
the payment helper:
    Need help with payment options?   Review Payment FAQs >    Talk to us now with LiveChat >
 */
angular.module('totesApp').directive('paymentHelper', ['settings','userLanguage', 'resource',function (settings, userLanguage, resource) {

    return {
        scope: {
        },

        templateUrl: "scripts/directives/paymentHelper/paymentHelper.html",

        replace: true,

        restrict: "E",

        link: function (scope, element, attr) {

          resource.onChanged(function () {
            scope.lang = userLanguage();
          }, scope);

          function update() {
            var newValue = userLanguage();
            if (!newValue) {
              return false;
            }
            scope.reviewLink = settings.reviewLink.en + '/setLanguage=' + userLanguage();
            scope.chatLink = settings.chatLink[newValue];
          }

          function getChatLink() {
            var lang = userLanguage();
            if (!lang) {
              return settings.chatLinkModules.payment['en'];
            }
            return settings.chatLinkModules.payment[lang];
          }

          scope.reviewLink = settings.reviewLink.en + '?setLanguage=' + userLanguage();
          scope.chatLink = getChatLink();

          scope.$on('resourceChanged', update);
        }



    };




}]);

'use strict';
angular.module('totesApp').directive('registrationArea', function () {
    return {
        templateUrl: "scripts/directives/registrationArea/registrationArea.html",
        replace: true,
        restrict: "E"
    };
});

/**
 * Created by OlgaN on 4/29/2015.
 */
'use strict';

angular.module('totesApp')
  .directive('revolution', ['$rootScope', '$window', 'resource', 'ajax', 'appState', 'userLanguage',
    'settings', '$http', 'localStorage', '$filter', '$timeout', 'backend', 'user', 'urlDevice', 'myrRgclService',
    function ($rootScope, $window, resource, ajax, appState, userLanguage,
              settings, $http, localStorage, $filter, $timeout, backend, user, urlDevice, rgclService) {
      return {
        templateUrl: 'scripts/directives/revolution/revolution.html',

        restrict: 'E',

        controller: ["$scope", function ($scope) {

          $scope.ban = null;
          $scope.oldBan = null;
          $scope.ctn = null;

          $scope.lang = userLanguage();
          $scope.loadingDataIndicatorRev = false;
          $scope.errorMessageR = null;
          $scope.tabs = false;
          $scope.loadingPage = true;
          $scope.hasBrtSwitch = false;

          $scope.hasRevSwitch = false; // localStorage.getLocalStorageValue('revpermission');

          $scope.shiftBigCols = 0;
          $scope.numberInnerCols = 4;
          $scope.numberRightCols = 4;
          $scope.shiftSmColsOut = 6;
          $scope.shiftSmColsInL = 6;
          $scope.shiftSmColsInR = 6;
          $scope.showMargin = false;

          $scope.globalOffers = {};
          $scope.globalOffersData = {};
          $scope.allOffers = [];
          $scope.ineligibleUser = false;
          $scope.showRightLabel = false;
          $scope.isPageWireless = $window.location.href.indexOf('wireless') > 0;
          $scope.revolutionLink = 'https://' + $window.location.hostname + settings.revolutionLink;

          $scope.months = {
            Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
            Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
          };

          $scope.leftHtmlTemplate = 'scripts/directives/revolution/revyouhave.html';
          $scope.isQA = $window.location.href.indexOf('www.qa') >= 0;

          $scope.isDealer = $rootScope.isDealer;
          $scope.isCare = $rootScope.isCare;


          $scope.processOffers = function () {

            if (!$scope.globalOffers.value || !$scope.globalOffersData.value) {
              return;
            }


            if ($scope.isPageWireless) {
              $scope.ctn = localStorage.getLocalStorageValue('phoneNumber');
            }

            $scope.allOffers = $scope.globalOffers.value[$scope.lang];

            $scope.isPageWireless = $window.location.href.indexOf('wireless') > 0;

            $scope.mapOffers();

            $scope.activeOffers = [];
            $scope.inactiveOffers = [];

            $scope.activeOffers = $filter('filter')($scope.allOffers, {active: true, inView: true});
            $scope.inactiveOffers = $filter('filter')($scope.allOffers, {active: false, inView: true});

            /**
             * Create a new var for rgcl
             *
             * Add 1 to the active offer list count for rgcl
             */
             var activeOffersCount = $scope.activeOffers.length + 1;

            if (activeOffersCount > 2 && $scope.allOffers.length < 6) {
              $scope.showMargin = true;
            }

            if (activeOffersCount > 3) {
              $scope.shiftBigCols = 2;
              $scope.numberInnerCols = 3;
              $scope.numberRightCols = 5;
            }
            if ($scope.inactiveOffers.length > 3) {
              $scope.shiftBigCols = -2;
              $scope.numberInnerCols = 5;
              $scope.numberRightCols = 3;
            }

            //shiftSmCols
            switch (activeOffersCount) {
              case 4:
                $scope.shiftSmColsOut = 12; //0 -left column not shown
                $scope.shiftSmColsInL = 3; //0
                $scope.shiftSmColsInR = 0;
                break;
              case 3:
                $scope.shiftSmColsOut = 9; // 3
                $scope.shiftSmColsInL = 4; // 12
                $scope.shiftSmColsInR = 12;
                break;
              case 2:
                $scope.shiftSmColsOut = 6; //6
                $scope.shiftSmColsInL = 6; //6
                $scope.shiftSmColsInR = 6;
                break;
              case 1:
                $scope.shiftSmColsOut = 3; //9
                $scope.shiftSmColsInL = 12; //4
                $scope.shiftSmColsInR = 4;
                break;
              case 0:
                $scope.shiftSmColsOut = 0; //12 - right column not shown
                $scope.shiftSmColsInL = 12; //3
                $scope.shiftSmColsInR = 3;
                break;
              default:
                $scope.shiftSmColsOut = 6;
                $scope.shiftSmColsInL = 6;
            }


            if (activeOffersCount === 3) { ///fix for long spotify description
              $scope.numberRightCols = 5;
            }
            $scope.showRightLabel = $scope.inactiveOffers.length >= 3;

          };

          $scope.mapOffers = function () {
            for (var yy = 0; yy < $scope.allOffers.length; yy++) {
              var current = $scope.allOffers[yy];
              current.inView = true;


              var found = $filter('filter')($scope.globalOffersData.value.valueAddedOffers, {id: current.id})[0];
              if (!found) {
                current.inView = false;
                continue;
              }

              current.active = !found.canAvailAsOffer;
              current.isFree = (found.isFree && found.opted) || found.optedAsAnotherPromo;
              current.opted = found.opted;
              current.swappable = found.swappable;

              if (found.onAccount && current.isFree) {
                current.isFreeLabel = $scope.mapFreeLabel(found.onAccount);
              }

              if (found.swappable && found.swappableDate) {
                current.swappableDate = '(' + resource.get('revo_by') + ' ' + $scope.formatDate(found.swappableDate) + ')';
              }


              if (current.id === 'spotify' && current.active && !$scope.isPageWireless) {
                current.offerDetails[0].messageMap.buttonLabel = resource.get('revo_manage');
              }
              else if (current.id === 'spotify' && current.active && $scope.isPageWireless) {
                current.offerDetails[0].messageMap.buttonLabel = $scope.mapSpotifyButton(current, found);
              }

              if (current.active === false) {
                current.offerDetails[0].messageMap.buttonLabel = resource.get('revo_get_this');
              }


            }
          };

          $scope.mapSpotifyButton = function (currentObj, foundObj) {
            var result = currentObj.offerDetails[0].messageMap.buttonLabel;

            //v
            if ($scope.isPageWireless){
              result = resource.get('revo_listen');
              currentObj.revSpUrl = true;
            }
            if (foundObj.ctns.length === 0) {
              return result;
            }
            var maxAll = foundObj.numberOfCtnsAllowed;
            var registered = [];
            //DBG
            //var ctnN = '9999999999';
            var ctnN = $scope.ctn;
            registered = $filter('filter')(foundObj.ctns, {registered: true});
            var registeredSelf = $filter('filter')(foundObj.ctns, {registered: true, ctn: ctnN})[0];
            var foundSelf = $filter('filter')(foundObj.ctns, {ctn: ctnN})[0];

            if (!registeredSelf) {  // not registered number
              if (registered.length >= maxAll || !foundSelf) { //hide widgit
                currentObj.inView = false;
              }
              else {
                result = resource.get('register_now');
                currentObj.revSpUrl = null;
              }
            }
            return result;
          };

          $scope.mapFreeLabel = function (onaccount) {
            onaccount = onaccount.toLowerCase();

            var result = resource.get('revo_with_internet');
            if (onaccount === 'wireless') {
              result = resource.get('revo_with_wireless');
            }
            if (onaccount === 'cable') {
              result = resource.get('revo_with_cable');
            }
            return result;
          };

          $scope.formatDate = function (swappableDate) {
            var result = '';

            if (!swappableDate) {
              return result;
            }

            var dateString = swappableDate.substring(0, 10);
            var arrDate = dateString.split('-');

            if (!arrDate || arrDate.length < 3) {
              return result;
            }
            var mName = $scope.monthsNames[Number(arrDate[1]) - 1];

            if ($scope.lang == 'fr') {
              result = Number(arrDate[2]) + ' ' + $scope.monthsNames[Number(arrDate[1]) - 1] + ' ' + arrDate[0];
            }
            else {
              result = mName + ' ' + Number(arrDate[2]) + ', ' + arrDate[0];
            }
            return result;
          };

          $scope.loadOffers = function () {
            //var resourceCache = $http.get('resource/00.json').then(function (mappings) {

            var resourceCache = $http.get('resource/revolutionLabels.json').then(function (mappings) {
              resourceCache = mappings.data;
              $scope.globalOffers = resourceCache;
            });

          };

          $scope.loadOffersData = function () {
            $scope.loadingDataIndicatorRev = true;

            $scope.ban = localStorage.getLocalStorageValue('accountNumber'); //$rootScope.ao.accountActive.accountNumber;



            var request = {ban: $scope.ban, 'includeNhl': settings.revolutionAddNhl};
            //var offersData =  ajax.getOffers(request).then(function (mappings) {

            //var offersData = $http.get('resource/01.json').then(function (mappings) {
            var offersData = backend.getOffers(request).then(function (mappings) {
              offersData = mappings.data;
              $scope.loadingDataIndicatorRev = false;

              if (offersData.status.errorCode === '11020') {
                rgclService.setShowWithinRevolution(false);
                return;
              }
              if (offersData.status.errorCode > 0) {
                $scope.errorMessageR = offersData.status.reason;
                rgclService.setShowWithinRevolution(false);
                return;
              }
              $scope.globalOffersData = offersData;
              $scope.processOffers();

            }, function (error) {

              $scope.loadingDataIndicatorRev = false;
              $scope.errorMessageR = resource.get('50000');
              rgclService.setShowWithinRevolution(false);
              return;
            });

          };

          $scope.startOffer = function (offer, revSpUrl) {

            if (!user.isLoggedIn) {
              appState.switchView('signin');
              return;
            }

            if (offer === 'spotify' && !revSpUrl) {
              $window.location.href = $scope.revolutionLink;
              return;
            }

            var url = $scope.getExternalLink(offer);

            window.open(
              url,
              '_blank' // <- This is what makes it open in a new window.
            );

          };

          $scope.getOffer = function (offer) {

            if (!user.isLoggedIn) {
              appState.switchView('signin');
              return;
            }
            var obj = offer;

            $window.location.href = $scope.revolutionLink;
          };


          $scope.goToDetails = function (offer) {

            if (!user.isLoggedIn) {
              appState.switchView('signin');
              return;
            }
            var obj = offer;

            $window.location.href = $scope.revolutionLink;

          };

          $scope.checkLogin = function () {
            if (user.isLoggedIn) {

            }
          };

          $scope.changeSelection = function (offer) {

            $window.location.href = $scope.revolutionLink;
          };

          $scope.clearData = function () {

            $scope.activeOffers = [];
            $scope.inactiveOffers = [];

            $scope.globalOffersData = {};

            $scope.loadingDataIndicatorRev = false;
            $scope.errorMessageR = null;
            $scope.ineligibleUser = false;
            $rootScope.hasTPSApermission = false;

          };

          $scope.loadFullData = function () {

            var newBan = localStorage.getLocalStorageValue('accountNumber');

            var hasRevPermission  = localStorage.getLocalStorageValue('RevPermission');
            if(!hasRevPermission || hasRevPermission !== '1'){
              rgclService.setShowWithinRevolution(false);
              return;
            }

            if ($scope.isPageWireless) {
              rgclService.setShowWithinRevolution(false);
            }else{
              rgclService.setShowWithinRevolution(true);
            }

            var banType  = localStorage.getLocalStorageValue('accountTypeNumber');

            var found = $filter('filter')($rootScope.ao.allAccounts, {accountNumber: newBan})[0];

            if (!found || found.accountStatus !== 'Active'  || banType !== '1') {
              rgclService.setShowWithinRevolution(false);
              if(found.accountStatus === 'Suspended' || found.accountStatus === 'Cancelled'){
                $scope.clearData();
              }
              return;
            }

            //if (($rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatusSimple !== 'Active') || banType !== '1') {
            //  return;
            //}

            $scope.loadOffers();

            $scope.clearData();

            $scope.loadOffersData();




            //$timeout(function () {
            //  $scope.hasBrtSwitch = $rootScope.revpermission;
            //  $scope.loadingDataIndicatorRev = true;
            //  var request = {};
            //  var permissionsData = ajax.getPermissions().then(function (result) {
            //    // var permissionsData =  backend.getRevPermissions().then(function (result) {
            //
            //    var permissionRev = ($filter('filter')(result.permissions, {permission: 'TPSA_PAGE_VIEW'}));
            //    $scope.loadingDataIndicatorRev = false;
            //    //DBG
            //    if (permissionRev && permissionRev.length > 0 || settings.isLocal) {
            //      $rootScope.hasTPSApermission = true;
            //      $scope.loadOffersData();
            //      return;
            //    }
            //    $rootScope.hasTPSApermission = false;
            //  }, function (error) {
            //    $rootScope.hasTPSApermission = false;
            //    $scope.loadingDataIndicatorRev = false;
            //    $scope.errorMessageR = resource.get('50000');
            //    //DBG
            //    if (settings.isLocal) {
            //      $scope.loadOffersData();
            //    }
            //
            //    return;
            //  });
            //
            //});

          }

          $scope.getExternalLink = function (id) {

            var output = '';

           var  doCheck =  urlDevice.checkPhone();

           var friendlyUrl = urlDevice.findUrl();

            output = friendlyUrl[id][$scope.lang];


            //if (id === 'spotify') {
            //  output = $scope.isQA ? settings.revolutionExternalLinks.spotify[$scope.lang].qa : settings.revolutionExternalLinks.spotify[$scope.lang].prod;
            //}
            //if (id === 'nextissue') {
            //  output = $scope.isQA ? settings.revolutionExternalLinks.nextissue[$scope.lang].qa : settings.revolutionExternalLinks.nextissue[$scope.lang].prod;
            //}
            //if (id === 'shomi') {
            //  output = $scope.isQA ? settings.revolutionExternalLinks.shomi[$scope.lang].qa : settings.revolutionExternalLinks.shomi[$scope.lang].prod;
            //}

            return output;
          }

          //$scope.loadFullData();

          // if ($scope.isPageWireless) {
          $scope.loadFullData();
          //}


          resource.onChanged(function () {
            $scope.monthsNames = resource.get('_months');

            if ($scope.lang !== userLanguage()) {
              $scope.lang = userLanguage();
              $scope.processOffers();
            }

          }, $scope);

          $scope.$watch('wirelessDashActive', function (newValue, oldValue) {

            if (newValue && oldValue && newValue.ctn && newValue !== oldValue) {

              $scope.processOffers();
            }
          });

          $scope.$on('startChangeAccount', function (event, obj) {


           // $scope.clearData();
          });

          $scope.$on('gotPermissions', function (event, obj) {

            $scope.loadFullData();
          });

          $scope.$on('changedAccount', function (event, obj) {

            var newBan = localStorage.getLocalStorageValue('accountNumber');
            if (!newBan || newBan === $scope.ban) {
              return;
            }
            $scope.ban = newBan;
            $scope.loadFullData();
          });

          $scope.isRgclVisible = function () {
            return rgclService.getRgclEligibile() && rgclService.getShowWithinRevolution();
          }

          //
          //$rootScope.$watch('revpermission', function(event, obj){
          //
          //  $scope.hasBrtSwitch = $rootScope.revpermission;
          //
          //  $scope.loadingDataIndicatorRev = false;
          //  if($rootScope.revpermission){
          //    $scope.loadingDataIndicatorRev = true;
          //    $scope.loadFullData();
          //
          //  }
          //
          //
          //});

        }]

      };
    }]);

/**
 * Created by OlgaN on 5/13/2015.
 */
angular.module('totesApp')
  .directive('revyouhave', ['$rootScope','btnSettings', '$window', function ($rootScope, btnSettings, $window) {
    return {
      templateUrl: 'scripts/directives/revolution/revyouhave.html',

      restrict: 'E'

    };
  }]);

'use strict';

/**
 * @ngdoc directive
 * @name totesApp.directive:rewards
 * @description
 * # rewards
 */
angular.module('totesApp')
	.directive('rewardsBanner', function () {
		return {
			templateUrl: 'scripts/directives/rewards/rewardsBanner.html',
			scope: {
				mode: '@'
			},
			restrict: 'E',
			link: function postLink(scope, element, attrs) {


			}

				};
	})
  .controller('rewardsBannerCtrl', ['$scope', '$rootScope', 'btnSettings', '$window', 'resource',
    function ($scope, $rootScope,  btnSettings, $window, resource) {
    //$scope.gift =  resource.get('rewards_promo_500');

    $rootScope.$watch('ao.accountActive', function() {
      if($rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatus){
        $scope.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
        $scope.btnStatus = $window.btnStatus;
      }

    });

    $rootScope.$watch('objRedeem', function(newVal, oldVal){
      $scope.objRedeem = {};


      if($rootScope.objRedeem != null){
        $scope.objRedeem = $rootScope.objRedeem;
        // Grab the data
        //$scope.gift = $scope.objRedeem.totalPoints > settings.redeemPoints ? resource.get('rewards_promo_500') : resource.get('rewards_promo_100');

      }
    }, true);

      resource.onChanged(function () {



      }, $scope);

  }]);

'use strict';

angular
        .module('totesApp')
        .directive('subMenu', ["ajax", "localStorage", function (ajax,localStorage) {
          return {
            restrict: 'EA',
            replace: 'false',
            templateUrl: 'scripts/directives/subMenu/subMenu.html',
            link: function (scope, element, attrs) {
              scope.$root.$watch('myServicesList', function () {
                scope.subMenuMyServicesList = scope.$root.myServicesList;
                scope.updateServicesList();
              });

              scope.$root.$watch('permissions.permissionActive', function (newVal, oldVal) {
                scope.showCareLink = false;
                if (newVal) {
                  if (scope.hasOwnProperty('ssaPermission')) {
//                    console.log("ssaPermission already defined on scope: " + scope.ssaPermission);
                  } else {
                   /* ajax.getPermissions().then(function (permissions) {
                      var ssaPermission = permissions.permissions.filter(function (permission) {
                        return permission.permission && permission.permission === 'SSA_PAGE_VIEW';
                      });
                      scope.ssaPermission = ssaPermission.length > 0;
                    }, function(error) {
                      console.error("Unexpected error getting ssaPermission: " + error);
                    });*/
                  }
                  var parmissions = newVal.permissions;
                  for (var xx = 0; xx < parmissions.length; xx++) {
                    var current = parmissions[xx];
                    if (current.name === 'INTERNAL_USER') { //TODO INTERNAL_USER
                      scope.showCareLink = true;
                      break;
                    }
                  }
                }
              }, true);


              scope.$root.$watch('currentStateName', function (newVal) {
                scope.isWireless = (newVal === 'wireless' || newVal === 'prepaidWireless');
                scope.isBusinessPhone = (newVal === 'businessphonedashboard');
                scope.updateServicesList();
                scope.subscriberName = localStorage.getLocalStorageValue('subscriberName');
//                scope.undefinedFlag = true;
//                  if(scope.subscriberName == undefined){
//                      scope.undefinedFlag = false;
//                  }
              });

              scope.$root.$watch('ao.accountActive', function () {
                scope.activeAccountType = (!!scope.$root.ao.accountActive) ? scope.$root.ao.accountActive.accountTypeNumber : 0;
                if (scope.$root.ao.accountActive) {
                  scope.updateBtnSettings(scope.$root.ao.accountActive.accountStatus);
                }
              });
            },
//            compile: function compile(tElement, tAttrs, transclude) {
//              return {
//
//                pre: function preLink(scope, iElement, iAttrs, controller) {
//                  // Nothing here
//                },
//                post: function postLink(scope, iElement, iAttrs, controller) {
//                  // Nor here
//                }
//              };
//            },
            controller: ['$scope', '$rootScope', '$state', '$location', 'myrAccountOverviewService', 'btnSettings', '$window', 'settings', 'ajax', 'myrSigninService', 'appState', 'user', 'deeplink', 'userLanguage', 'sessionStorage', 'localStorage', '$modal', 'invoiceService', '$browser', 'brtCheck', 'resource', 'ute.datalayer.common.service',
              function ($scope, $rootScope, $state, $location, accountOverviewService, btnSettings, $window, settings, ajax, signinService, appState, user, deeplink, userLanguage, sessionStorage, localStorage, $modal, invoiceService, $browser, brtCheck, resource, dataLayerService) {
                // if one usertype retail/care hide the homephone and link account links from services menu.
                //  $scope.userTypeDealer = $rootScope.isDealer;
                $scope.isDealer = $rootScope.isDealer;
                $scope.isCare = $rootScope.isCare;
                $scope.isConsumer = $rootScope.isConsumer;
                brtCheck.eSimSwitch();
                //TODO:This needs to be removed asap when we complete the maintenanceSettings service. All instances throughout the application
                $rootScope.altMaintenance = {};
                // Self hiding logic
                $scope.selfDestruct = function (stateString) {
                  var hideSubMenuStates = [
                    'linkaccount',
                    'bsslinkaccount',
                    'bssdelinkaccount',
                    'signin',
                    'frontline',
                    'tempPassword',
                    'setNewPassword',
                    'forgotUserName',
                    'forgotPassword',
                    'registration',
                    'completeProfile',
                    'rewards',
                    'rewards.enroll',
                    'rewards.redeem',
                    'rewards.earn',
                    'rewards.membership',
                    'rewards.wishlist',
                    'rewards.transactions',
                    'rewards.transactions',
                    'rewards.howitworks',
                    'rewards.terms',
                    'rewards.browse',
                    'oneViewInterface',
                    'migrateUser',
                    'sso/setPassword',
                    'sso/forgotPassword',
                    'sso/resetPassword',
                    'sso/registration',
                    'sso/registrationConfirmation',
                    'sso/emailResendConfirmation'
                  ];

                  if($rootScope.altMaintenance.SITE_ON_MAINTENANCE){
                    hideSubMenuStates.push('underMaintenance');
                  }

                  // Get location and masage the result a little bit
                  var toState = $location.path();

                  // Remove first slash and replace other slashes with dots
                  toState = toState.substring(1);
                  toState = toState.replace(/\//gi, '.');

                  toState = (stateString === '' || stateString === undefined) ? toState : stateString;

                  // array lookup
                  var toStateResult = true;
                  if (user.isLoggedIn && toState && ($browser.cookies()['bss-info'] || $browser.cookies().CONSENT_STATE)) {
                    // maybe will show it
                    toStateResult = (hideSubMenuStates.indexOf(toState) === -1) ? false : true;
                  } else {
                    // definitely will NOT show it
                    toStateResult = true;
                  }
                  return toStateResult;
                };
                $scope.selfDestructFlag = $scope.selfDestruct();

              var aalRefId;
              $scope.hasBrtPermission = false;
              aalRefId = (sessionStorage.getSessionStorageValue("aalRefId") != null)?sessionStorage.getSessionStorageValue("aalRefId"):"";

              signinService.mbhUrlConfig().then(function(urlResponse){
                $scope.mbhUrls = urlResponse;
              });
              var requestData;

              $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
                ajax.getBrtSwitches().then(
                  function (data) {

                    angular.forEach(data, function (obj, key) {
                          if(obj.id == "BRT_NON_MSD"){
                            var usernameDetails = JSON.parse(sessionStorage.getSessionStorageValue('accountInfo'));
                            requestData ={
                              userId : usernameDetails.userName,
                              brtSwitch : obj.id
                            }
                            $scope.brtNonMsd = true;
                            ajax.gethasPermissions(requestData).then(
                              function (data) {
                                $scope.hasBrtPermission = data.hasBrtPermission;
                              });
                          }
                    });

                  });
              });

                $scope.addNewWirelessLine = function() {
                  var interactionObject = {
                    applicationName: 'Rogers Business|rogers.git/cmsredesign',
                    buyflow: {
                        name: 'AAL'
                      },
                    ecommerce: {
                      products: [
                        {
                          ID: "[]",
                          name: "[]",
                          manufacturer: "[]",
                          color: "[]",
                          capacity: "[]",
                          category: "rbiz-wireless",
                          subCategory: "BSS-S-Services",
                          findingMethod: "[]",
                          price: "[]",
                          quantity: "[]",
                          upfrontEdgeAmount: "[]"
                        }
                      ]
                    },
                    events: {
                      pageView: true,
                      productView: true,
                      buyFlowStart: true
                    },
                  };
                  dataLayerService.track(interactionObject, false, [4, 1, 0], {mappingKey: "addNewWirelessLine"});

                  ajax.saveOrderSearch({"refId": aalRefId, "ctn": "", "orderType": "AAL"}, $scope.mbhUrls.saveOrderSearch).then(function(response){
                    sessionStorage.setSessionStorageValue("aalRefId", response.refId);
                    aalRefId = response.refId;

                    $window.open($scope.mbhUrls.sbpInquiry + aalRefId, "_blank");

                  });


                     /*if($scope.brtNonMsd) {
                        if($scope.hasBrtPermission) {
                          //SBP URL
                          $window.open($scope.mbhUrls.sbpInquiry + aalRefId, "_blank");
                        } else {
                          //Midmarket URL
                          $window.open($scope.mbhUrls.orderInquiry + aalRefId, "_blank");
                        }
                      }*/
                  }

                // Listen to the state change broadcast
                $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
                    if (deeplink.data.direction === 'out') {
                      // DO NOT show the submenu
                      $scope.selfDestructFlag = true;
                    } else {
                      $scope.selfDestructFlag = $scope.selfDestruct(toState.name);
                    }
                });


                $scope.subMenuItems = $window.subMenuItems;
                $scope.isOverview = false;
                $scope.isPayment = false;
                $scope.isService = false;
                $scope.isWireless = false;
                $scope.isBusinessPhone = false;
                $scope.toggleMainPlusMinus = $rootScope.toggleMainPlusMinus;
                $scope.toggleServicesPlusMinus = $rootScope.toggleServicesPlusMinus;
                $scope.isDealer = $rootScope.isDealer;
                $scope.isCare = $rootScope.isCare;
                $scope.isConsumer = $rootScope.isConsumer;

                // $scope.subUser = $rootScope.user;
                $scope.selSubMenuItem = $rootScope.selectedSubMenuItem;
                $scope.$watch(function() {
                  return $rootScope.selectedSubMenuItem;
                }, function() {
                  $scope.selSubMenuItem = $rootScope.selectedSubMenuItem;
                }, true);

                $scope.runService = function (serviceName, value,subscriberName) {
                  dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "runService"});
                  function runMaintenanceCheck(){
                    var userPath = accountOverviewService.getServicePath(serviceName,value,subscriberName);

                    if (appState.maintenanceRedirect(userPath)) {
                      $location.path('/underMaintenance');
                    }else{
                      accountOverviewService.runService(serviceName, value,subscriberName);
                    }
                  }

                  if($rootScope.altMaintenance.SITE_ON_MAINTENANCE == undefined){

                    var maintenanceSettingsResponse = function (_tmp) {
                      runMaintenanceCheck();
                    };

                    var request = {
                      refresh: false
                    };

                    accountOverviewService.getMaintenanceSettings(request, maintenanceSettingsResponse);

                  }else{
                    runMaintenanceCheck();
                  }



                };

                $scope.runCustomerCare = function () {

                  var _linkToCareUrl = settings.devServerURL.replace(/\/\/www/gi, '//internal') + '/web/InternalUse.portal';
                  $window.location.href = _linkToCareUrl;
                };

                //Redirection to Legacy if Switch is OFF
                $scope.isBriteBillON = function ($event) {

                  var bbSwitch = localStorage.getLocalStorageValue('BSS_BB_UTE');
                  if(bbSwitch != null && bbSwitch != undefined && bbSwitch === "false")
                      $window.location.href = '../../../business/ute/smb/transactions/uteBillingAndPayment';
                  else
                      return true;

                }

                $scope.runRogersProfile = function ($event) {
                  dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "runRogersProfile"});
                  if ($scope.ssaPermission) {
                    $event.preventDefault();
                    if($rootScope.isDealer || $rootScope.isCare ){
                      $scope.open();
                    } else if($scope.isSubMenuEnabled('profile')){
                      $state.go('self-serve');
                    }
                  } else {
                    //$event.currentTarget.href = $event.currentTarget.href.replace(/ProfileAccountNumber=[\d]*/, 'ProfileAccountNumber=' + $rootScope.selectedAccount);
                    // TODO Please add you logic here
                    var smbInvoiceSwitch = $browser.cookies().smbInvoiceMode;
                    if(smbInvoiceSwitch == null || smbInvoiceSwitch == 'undefined' || smbInvoiceSwitch == '' || smbInvoiceSwitch == undefined || smbInvoiceSwitch == 'LEGACY'){
                      $window.location.href = '../../../business/ute/smb/transactions/uteMyRogersProfile?setLanguage=' + userLanguage();
                     }
                    else{
                      invoiceService.isBriteBill().then(function(success){
                        $window.location.href = '../../../business/ute/smb/transactions/uteMyRogersProfile?setLanguage=' + userLanguage();
                      }, function(error){
                        $window.location.href = '../../../business/ute/smb/transactions/uteMyRogersProfile?setLanguage=' + userLanguage();
                      });
                    }
                  }
                };

                $scope.accountOverview = function ($event) {
                  $event.preventDefault();
                  if($scope.isSubMenuEnabled('accountOverview')){
                    scrollPageToTop();
                    if($rootScope.isDealer || $rootScope.isCare) {
                      appState.switchView('oneViewDashboard');
                    } else {
                      appState.switchView('accountOverview');
                    }
                  }
                };


                $scope.rogersORpaybill = function () {
                  var rogersORpaybillType = 0;
                  try {
                    rogersORpaybillType = $rootScope.ao.accountActive.accountTypeNumber;
                  } catch (e) {
                  }

                  var isConsumer = !$scope.isDealer && !$scope.isCare;
                  if(isConsumer) {
                    if (rogersORpaybillType === 9 || rogersORpaybillType === '9') {
                      $scope.postToRogersTop();
                    } else {
                      $scope.payBill();
                    }
                  } else {
                    // The accountActive is becoming null, so need to get the accountTypeNumber from local storage
                    if(rogersORpaybillType === 0){
                      rogersORpaybillType = localStorage.getLocalStorageValue('accountTypeNumber');
                    }
                    if (rogersORpaybillType === 9 || rogersORpaybillType === '9') {
                      // Disable bills & payments in prepaid for dealer and care
                    } else {
                      $scope.payBill();
                    }
                  }
                };

                $scope.postToRogersUrls = [
                  {url: '/web/myrogers/viewInvoice'},
                  {url: '/web/RogersServices.portal?_nfpb=true&_pageLabel=BillsPayments'},
                  {url: '/web/myrogers/prepaidTopUp'}
                ];
                $scope.postToRogersTop = function () {
//							$('#formToRogersTop').attr('action', $scope.postToRogersUrls[1].url);
//							$('#formToRogersTop').submit();
                  var redirectURL = $scope.postToRogersUrls[1].url;
                  $window.location.href = redirectURL;
                };
                $scope.payBill = function () {
                  // Look into  non_angular_script/supportFunctions.js  for more information
                  scrollPageToTop();					// jshint ignore:line
                  appState.switchView('viewInvoice');
                };


                $scope.closeMenu = function () {
                  $scope.toggleMainPlusMinus = false;
                  $scope.toggleServicesPlusMinus = false;
                  $rootScope.menuOpenSafari = false;
                };
                $scope.navMainMenuClick = function ($event) {
                  if ($scope.toggleMainPlusMinus) {
                    $scope.toggleMainPlusMinus = false;
                    $scope.toggleServicesPlusMinus = false;
                  } else {
                    $scope.toggleMainPlusMinus = true;
                  }
                  $rootScope.menuOpenSafari = !$rootScope.menuOpenSafari;
                };

                $scope.navSubMenuClick = function () {
                  if ($scope.toggleServicesPlusMinus) {
                    $scope.toggleServicesPlusMinus = false;
                  } else {
                    $scope.toggleServicesPlusMinus = true;
                  }
                };

                $scope.updateServicesList = function () {
                  if ($scope.subMenuMyServicesList) {
                    var _length = $scope.subMenuMyServicesList.length;
                    var serviceName;
                    for (var i = 0; i < _length; i++) {
                      serviceName = $scope.subMenuMyServicesList[i].serviceName;
                      $scope.subMenuMyServicesList[i].hide = ($scope.isWireless || $scope.isBusinessPhone) && (serviceName === 'wireless' || serviceName === 'wirelessPrepaid' || serviceName == 'businessphonedashboard');
                    }
                  }
                };

                $scope.updateBtnSettings = function (accountStatus) {
                  if ($rootScope && $rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatus) {
                    $scope.btnSettings = btnSettings.getSettings(accountStatus);
                    $scope.btnStatus = $window.btnStatus;
                  }
                };

                $scope.isDropDownEnabled = function () {
                  return (settings.mandatoryPages.indexOf($state.current.name) < 0);
                };

                $scope.isSubMenuEnabled = function (subMenuName) {
                  var result = false;
                  // if current page is mandatory, disable all subMenus
                  if (settings.mandatoryPages.indexOf($state.current.name) >= 0)
                    return false;

                  switch (subMenuName) {
                    case 'accountOverview':
                    case 'billingAndPayment':
                      result = $rootScope.selectedSubMenuItem !== $scope.subMenuItems.guestoverview;
                      break;
                    case 'services' :
                    case 'profile' :
                      result = $rootScope.selectedSubMenuItem !== $scope.subMenuItems.guestoverview;
                      break;
                    default :
                      break;
                  }
                  return result;
                };

                $scope.subMenuMyServicesList = $rootScope.myServicesList;
                $rootScope.$on('$stateChangeStart', function () {
                  $scope.closeMenu();
                });

                // Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal
                $scope.open = function (size) {
                  var serverHack = '/web/smb/bss';
                  if (settings.isLocal) {
                    serverHack = '';
                  }

                  $rootScope.modal = $modal.open({
                    templateUrl: serverHack + '/views/modals/profileModalCtrl.html',
                    controller: 'profileModalCtrl',
                    size: size,
                    backdrop: 'static',
                    backdropClass: 'bkg-modal',
                    resolve: {}
                  });

                  $rootScope.modal.result.then(function () {
                    // on OK behaviour
                  }, function () {
                    // on Cancel behaviour
                  });
                };
                 $scope.isDisplayPopup = function () {
                  dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "isDisplayPopup"});
                    var result = false;
                    if($rootScope.isConsumer){
                      result = true;
                    } else {
                      result = false;
                      $scope.open();
                    }
                    return result;
                 }

                 $rootScope.isWirelessAccount = function(){
                   return localStorage.getLocalStorageValue("accountTypeNumber") == 21;
                 }
                 $scope.isCableAccount = function(){
                   return localStorage.getLocalStorageValue("accountTypeNumber") == 22;
                 }
                 $rootScope.isMaestroAccount = function(){
                   return localStorage.getLocalStorageValue("accountTypeNumber") == 23;
                 }
                 $rootScope.hasWirelessAccount = function() {
                    //console.log('hasWirelessAccount', $scope.ao.raw.userProduct, 'WL' == $scope.ao.raw.userProduct || 'WL_C' == $scope.ao.raw.userProduct);
                    return 'WL' == $scope.ao.raw.userProduct || 'WL_C' == $scope.ao.raw.userProduct;
                 }

                 $rootScope.hasSelectedWirelessAccount = function() {
                  //console.log('hasWirelessAccount', $scope.ao.raw.userProduct, 'WL' == $scope.ao.raw.userProduct || 'WL_C' == $scope.ao.raw.userProduct);
                  return 'WL' == $scope.ao.accountActive.accPdtType || 'WL_C' == $scope.ao.accountActive.accPdtType;
               }

                 $rootScope.isBtvPhaseTwoAccount = function() {
                  return 'IGNITE_TV' == $scope.ao.raw.userProduct || 'IGNITE_BUNDLE' == $scope.ao.raw.userProduct;
                 }

                 $rootScope.hasAccountStatus = function() {
                  return 'Cancelled' != $scope.ao.accountActive.accountStatus && 'Suspended' != $scope.ao.accountActive.accountStatus;
                 }
                 $rootScope.hasCableOnlyAccount = function() {
                     //console.log('hasCableOnly Account', $scope.ao.raw.userProduct, 'C' == $scope.ao.raw.userProduct);
                     return 'C' == $scope.ao.raw.userProduct;
                 }

                $rootScope.hasIptvOnlyAccount = function() {
                  //console.log('hasCableOnly Account', $scope.ao.raw.userProduct, 'C' == $scope.ao.raw.userProduct);
                  return  'IPTV' == $scope.ao.accountDetails.acctPdtType || 'IGNITE_BUNDLE' == $scope.ao.accountDetails.acctPdtType || 'IGNITE_TV' == $scope.ao.accountDetails.acctPdtType || 'IGNITE_TV + INTERNET' == $scope.ao.accountDetails.acctPdtType || 'IGNITE_INTERNET' == $scope.ao.accountDetails.acctPdtType;
                }
                 $scope.isLegacy = function(){
                   return localStorage.getLocalStorageValue('smbInvoiceMode') == "LEGACY";
                 }
                 $scope.legacyRedirect = function(menuItem){
                    switch (menuItem) {
                        case 'invoice':
                          $window.location.href = '../../../business/ute/smb/transactions/uteBillingAndPayment';
                          break;
                        case 'groups':
                          $window.location.href = '../../../business/ute/smb/transactions/uteReportinggroups';
                          break;
                        case 'reporting':
                          $window.location.href = '../../../business/ute/smb/transactions/uteReporting';
                          break;
                        default :
                          break;
                      }
                 }

              }]};
        }])
        // for displaying modal box when usertpe retail.
        .controller('profileModalCtrl', ['$scope', '$modalInstance', '$rootScope',
          function ($scope, $modalInstance, $rootScope) {
            $scope.close = function () {
              $modalInstance.dismiss('cancel');
              $rootScope.modal = null;
          };
    }]);

'use strict';


angular.module('totesApp')
	.directive('termsConditions', ['resource', function (resource) {
		return {
			restrict: 'E',
			templateUrl: 'scripts/directives/termsConditions/termsConditions.html',
			link: function ( $scope/*, element, attrs*/) {
                $scope.$extend ({
                    isAccepted: false
                });
			}
		};
	}]);

(function () {

  'use strict';
  angular.module('ute.ui.content')

    /**
     * @class ute-ui.content.uteContentInjectorNoCache
     */
  .directive('uteContentInjectorNoCache', ["$rootScope", "$templateCache", "uteContentLoader", "$cookies", "uteLocale", function ($rootScope, $templateCache, uteContentLoader, $cookies, uteLocale) {
        return {
          scope: {
            localContentId: '@',
            contentId: '@',
            compile: '=',
            province: '@',
            language: '@'
          },
          replace: true,
          restrict: 'EA',
          controller: ["$scope", "$element", function ($scope, $element) {
            /**
             * @description toggle for showing meta data for developer purposes
             * @name metaShown
             * @memberOf ute-ui.content.uteContentInjector
             */
            var metaShown = false;

            /**
             * @description toggle hidden dev divs and displays metadata after user clicks hidden cms-metadata-toggle div
             * @name displayMetadata
             * @memberOf ute-ui.content.uteContentInjector
             */
            var displayMetadata = function () {
              metaShown = !metaShown;
              var settings = {
                scope: $scope,
                element: $element,
                method: 'GET',
                dataType: 'json',
                fileType: '.json',
                contentId: $scope.contentId,
                compile: angular.isDefined($scope.compile) && $scope.compile || false,
                language: $scope.language || uteLocale.language(),
                province: $scope.province || uteLocale.province(),
                localContentId: $scope.localContentId
              };

              metaShown ? uteContentLoader.makeRequest(settings) : $element.children().children()[0].remove();
            };

            /**
             * @description add and removed active from cms-metadata div
             * @name metadataActive
             * @memberOf ute-ui.content.uteContentInjector
             */
            var metadataActive = function () {
              $(this).toggleClass('active');
            };

            /**
             * @description inits the directive
             * @name init
             * @memberOf ute-ui.content.uteContentInjector
             */
            var init = function () {
              $('ins').off().on('click', '.cms-metadata', metadataActive);
              $element.addClass('preloader loading');

              if (!$rootScope.ute) {
                $rootScope.ute = {
                  language: 'en',
                  province: 'on'
                };
              }

              makeRequest();

              //TODO - change .bind to .on method
              angular.element(document.getElementById('cms-metadata-toggle')).bind('click', displayMetadata);
            };

            /**
             * @description makes http request, also called by watcher
             * @name makeRequest
             * @memberOf ute-ui.content.uteContentInjector
             */
            var makeRequest = function () {
              var settings = {
                scope: $scope,
                element: $element,
                method: 'GET',
                dataType: 'html',
                fileType: '.html?v='+new Date().getTime(),
                contentId: $scope.contentId,
                compile: angular.isDefined($scope.compile) && $scope.compile || false,
                language: $scope.language || uteLocale.language() || $cookies.get('language') || 'en',
                province: $scope.province || uteLocale.province() || $cookies.get('province') || 'on',
                localContentId: $scope.localContentId
              };

              uteContentLoader.makeRequest(settings);
            };

            /**
             * @description checks to see if new values are different from the old values then makes an http request again
             * @name metaShown
             * @param oldValue
             * @param newValue
             * @memberOf ute-ui.content.uteContentInjector
             */
            var update = function (oldValue, newValue) {
              if (oldValue !== newValue) {
                makeRequest();
              }
            };

            init();

            $scope.$watch('language', update);
            $scope.$watch('province', update);
            $scope.$watch('contentId', update);
          }]
        };
      }]);
})();

'use strict';

angular
	.module('totesApp')
	.directive('validationErrorBox', ['resource',
		function (resource) {
			return {
				scope: {
					errorMessage: '='
				},
				templateUrl: "scripts/directives/validationErrorBox/validationErrorBox.html",
				replace: true,
				restrict: "E",
				link: function (scope, element, attrs, $sce) {}
			};
		}]);

(function () {
  'use strict';

  angular.module('totesApp').directive('wirelessMyDevice', function () {
    return {
      restrict: 'EA',
      replace: 'true',
      scope: {
        mode: '='			// 1 = postpaid / 2 = prepaid
      },
      templateUrl: 'scripts/directives/wirelessMyDevice/wirelessMyDevice.html',
      link: function (scope, element, attrs) {
        // DOM or direct jQuery calls
      },
      controller: ['$scope', 'myrWirelessDashboardService', function ($scope, wirelessService) {
        // console.log('hit');
        /*
         // Mode processing
         if ($scope.mode === 1) {
         //			console.log ('wirelessMyDeviceCtrl - post-paid');

         } else if ($scope.mode === 2) {
         //			console.log ('wirelessMyDeviceCtrl - pre-paid');

         } else {
         // Wrong parameter !!!!!  > do nothing
         }
         //*/
        // $scope variables / data holders
        $scope.wd = null;
        $scope.client = null;
        $scope.device = null;
        $scope.loadingDevice = true;

        var holder = null;
        //var request = {applicationId:'Rogers.com'};
        //request.ctn = '4162680198';
        //request.ban = '716936547';

        $scope.WirelessService = wirelessService;
        // console.log($scope.WirelessService);
        $scope.$watch('WirelessService.postpaidData', function (_tmp) {
          // console.log('hit');
          if (_tmp.result === 'success') {
            // Proceed to display
            $scope.wd = _tmp.data;

            // console.log(_tmp);
            $scope.wpkg_loadingDataIndicatorDevice = _tmp.stale;
            $scope.wpkg_displayContentDevice = true;

            $scope.processData($scope.wd);

            // Hide loading
            $scope.loadingDevice = false;

          } else if (_tmp.result === 'fail') {
            holder = _tmp.data;
            $scope.errorMessage = 'Failed to load Wireless account data';

          } else if (_tmp.result === 'error') {
            holder = _tmp.data;
            $scope.errorMessage = holder.originalError;

          } else {
            // Unknown state ???
          }
        });
        /*
         wirelessService.getWirelessPostpaid(request, function(_tmp) {
         if (_tmp.result === 'success') {
         // Proceed to display
         $scope.wd = _tmp.data;
         $scope.processData ($scope.wd);

         // Hide loading
         $scope.loadingDevice = false;

         } else if  (_tmp.result === 'fail') {
         holder = _tmp.data;
         $scope.errorMessage = 'Failed to load Wireless account data';

         } else if  (_tmp.result === 'error') {
         holder = _tmp.data;
         $scope.errorMessage = holder.originalError;

         } else {
         // Unknown state ???
         }
         });
         */
        // Support functions
        $scope.processData = function (data) {
          //console.log('My Device Data', data);
          $scope.client = data.postPaidPhoneDetails;							// Client Data
          $scope.device = data.deviceDetails[$scope.client.phoneProductId];	// Device data

          // Phone image
          var altImage = $scope.client.phoneAltImage;
          var mainImage = $scope.client.phoneImage;
          var useThis = '';

          if (mainImage === "noimage") {
            if (altImage === "" || altImage === "noimage") {
              // No image...
            } else {
              useThis = altImage;
            }
          } else {
            useThis = mainImage;
          }
          $scope.client.phoneImageProcessed = useThis;
        };
      }]
    };
  });
})();

'use strict';

angular.module('totesApp')
	.directive('wirelessNeedHelp', function () {
		return {
			restrict: 'E',
			replace: 'true',
			templateUrl: 'scripts/directives/wirelessNeedHelp/wirelessNeedHelp.html',
			link: function (scope, element, attrs) {
				// DOM or direct jQuery calls
			}
		};
	})
	.controller('wirelessNeedHelpCtrl', ['$scope', function($scope) {

		$scope.loadingHelp = true;

	}]);

'use strict';


angular.module('totesApp')
  .directive('wirelessPackage', ['$log', 'appState', function ($log, appState) {
    return {
      restrict: 'E',
      replace: 'true',
      // scope: {},
      templateUrl: 'scripts/directives/wirelessPackage/wirelessPackage.html',
      link: function (scope, element, attrs) {
        // DOM or direct jQuery calls
        scope.$watch('wirelessDashActive' ,function (newValue, oldValue) {
          //$log.info(newValue !== oldValue, scope.$root.wirelessPackagePostPaidProcessed);
          if (newValue !== oldValue || (newValue === oldValue && !scope.$root.wirelessPackagePostPaidProcessed)) {
            scope.refresh();
          }
        });
      },

      controller: ['$scope', '$rootScope', 'myrWirelessDashboardService', 'settings', '$timeout', '$modal', 'sessionStorage', 'localStorage', 'userLanguage', 'resource','$location', '$sce', 'ajax', 'myrSigninService', '$q', '$browser', 'myrAccountOverviewService','$window','userProvince','brtCheck','ute.common.suspend.ctn.service', 'ute.common.reactivate.ctn.service', 'ute.common.simcard.change.service','bfappcWirelessDashboardService', '$state', 'myrAccountListService', 'ute.rogers.datalayer.integration.common.service', 'myrMyServicesService', 'pricePlanChangesErrors','ute.datalayer.common.service',
      function($scope, $rootScope, wirelessService, settings, $timeout, $modal, sessionStorage, localStorage, userLanguage, resource, $location, $sce, ajax, signinService, $q, $browser, myrAccountOverviewService,$window,userProvince,brtCheck,suspendCtnService,reactivateCtnService,simcardChangeService, bfappcWirelessDashboardService, $state, myrAccountListService, dataLayerIntegrationService, myrMyServicesService, pricePlanChangesErrors,dataLayerService) {
          var self = this;
          // $scope variables / data holders
          activate();
          function activate() {
            $rootScope.salesForceFailed = false;
            /*myrAccountOverviewService.getBrtSwitches(function (_temp) {
             if (_temp.result === 'success') {
             if (_temp.data.length > 0) {
             for (var i = 0; i < _temp.data.length; i++) {
             if (_temp.data[i].id === 'NRS') {
             if (_temp.data[i].switchIsOn) {
             $rootScope.sfnrs = true;
             }
             }
             }
             }
             }
             });*/
          }
          $scope.showTooltip = 0;
          $scope.wpkg_wd = null;
          $scope.wpkg_client = null;
          $scope.wpkg_device = null;
          $scope.wpkg_rawData = null;
          $scope.wpkg_isCollapsed = true;
          $scope.wpkg_loadingDataIndicatorPackage = true;
          $scope.wpkg_loadingDataIndicatorDevice = true;
          $scope.wpkg_errorMessageWirelessPackage = undefined;
          $scope.wpkg_isShowPanel = false;
          $scope.wpkg_my5 = {};
          $scope.maintenanceTime =false;
           $scope.wpkg_hupRefId = null;
          var currentTime = new Date().getHours();
          if((currentTime>=$rootScope.maintenanceStart)&&(currentTime<$rootScope.maintenanceEnd)){
            $scope.maintenanceTime =true;
          }

          brtCheck.utePhaseII();
          brtCheck.nac();

          $scope.changeBtnLoading = bfappcWirelessDashboardService.changeBtnLoading;
          $scope.SOCIsNotSuppressed = function(item){
            if(item.socDesc!=='TAGSRA01B'){return true;}
            return false;
          }
          $scope.wpkg_clientBkp = {};

          $scope.lng = userLanguage();

          if(localStorage.getLocalStorageValue('phoneNumber')){
              var accountInfo = {
                 selectedCTN: localStorage.getLocalStorageValue('phoneNumber')
              };
              dataLayerIntegrationService.setSelectedSubscriberNumber(accountInfo);
          }

          //RBIB-6688
          $(document).ready(function() {
            var counter = 0;
            $("body").on('DOMSubtreeModified', ".chat-en .chatButtonWirelessUnlock", function() {
                counter++;
                if(counter == 1) {
                  $('.chat_unlock_device_label').remove();
                  $('.chatButtonWirelessUnlock > a').removeAttr('href');
                  counter = 0;
                }
            });
            var counterFr = 0;
            $("body").on('DOMSubtreeModified', ".chat-fr .chatButtonWirelessUnlockFr", function() {
              counterFr++;
                if(counterFr == 1) {
                  $('.chat_unlock_device_label').remove();
                  $('.chatButtonWirelessUnlockFr > a').removeAttr('href');
                  counterFr = 0;
                }
          });

          });
          //RBIB-6688

          $scope.boldChat = {
              unlockDevice: {
                en: {
                  cbid: 'S_BSS_PS_UnlkPh',
                  dynamicDivId: 'Wireless_Unlock_div',
                  chatButtonClass:'chatButtonWirelessUnlock'
                },

                fr: {
                  cbid: 'S_BSS_PS_UnlkPh_Fr',
                  dynamicDivId: 'Wireless_Unlock_Fr_div',
                  chatButtonClass:'chatButtonWirelessUnlockFr'
                }
              },
              wlssPpc: {
                en: {
                  cbid: 'S_BSS_PS_Wlss_PPC',
                  dynamicDivId: 'S_BSS_PS_Wlss_PPC_div',
                  chatButtonClass:'chatButtonPPCEn'
                },

                fr: {
                  cbid: 'S_BSS_PS_Wlss_PPC_fr',
                  dynamicDivId: 'S_BSS_PS_Wlss_PPC_fr_div',
                  chatButtonClass:'chatButtonPPCFr'
                }
              }
          };

          $scope.accLink =  'https://' + window.location.hostname  +  '/web/myrogers/torcom/shopAccessories' + '?setLanguage=' + $scope.lng;
          if(settings.isLocal){
            $scope.accLink = settings.formsURL +  '/web/myrogers/torcom/shopAccessories' + '?setLanguage=' + $scope.lng;
          }
          //$scope.userTypeRetail = $rootScope.isDealer;
          $scope.isDealer = $rootScope.isDealer;
          $scope.isCare = $rootScope.isCare;
          $scope.isConsumer = $rootScope.isConsumer;

          var holder = null;
          var request = {};

          //request.ctn = '4163190303';  //my5
          //request.ban = '706422417';
          $scope.$watchGroup(['isFetchOrderCompleted()', 'permissionsObj', 'wirelessDashActive.ctn'], function (newValue, oldValue) {
            $scope.isHupFlowProcessSaved = !!(newValue !== oldValue && !_.isEmpty($scope.permissionsObj) &&
            newValue[0] && !checkHuPPermission() && !_.isUndefined(bfappcWirelessDashboardService.getFetchOrderFullResponse().hup) &&
            bfappcWirelessDashboardService.getFetchOrderFullResponse().hup.length > 0 && isCtnHasSavedCart());
          });
          // the following obj will be saved in backend and will be fetched in PPC SPA again
          $scope.appStateForPPC = {
            ban: '',
            ctn: '',
            accountTypeNumber: '',
            flow: 'PPC',
            eligibilityChecked: 'false',
            availableCreditAmount: 0,
            ctnList: []
          };
          bfappcWirelessDashboardService.clean();
          bfappcWirelessDashboardService.fetchOrder();

          $scope.WirelessService = wirelessService;

          $scope.$watch('WirelessService.postpaidData', function (_tmp) {
            if (_tmp) {
              if (_tmp.result === 'success') {
                //$log.info('success');
                $rootScope.wirelessPackagePostPaidProcessed = true;
                $rootScope.wirelessPackageLastRequestCtn = angular.copy(request.ctn);
                // Proceed to display
                $scope.wpkg_wd = _tmp.data;
                $scope.processWirelessPackage($scope.wpkg_wd);
                $scope.processDataWirelessMyDevice($scope.wpkg_wd);
                $scope.processLanguageLabels();

                // Hide loading
                $scope.wpkg_displayContentPackage = true;
                $scope.wpkg_loadingDataIndicatorPackage = _tmp.stale;

                $scope.wpkg_displayContentDevice = true;
                $scope.wpkg_loadingDataIndicatorDevice = _tmp.stale;

                // remove error messages
                // $scope.errorMessage = false;
                if ($scope.wpkg_errorMessageWirelessPackage !== undefined) {
                  $scope.wpkg_errorMessageWirelessPackage = undefined;
                }
                $scope.setDataForReactivateCtn();
//$scope.refresh();
              } else {
                $scope.wpkg_displayContentPackage = false;
                $scope.wpkg_displayContentDevice = false;
                $scope.wpkg_loadingDataIndicatorPackage = false;
                $scope.wpkg_loadingDataIndicatorDevice = false;

                if (_tmp.result === 'fail') {
                  holder = _tmp.data;
                  //$scope.wpkg_errorMessageWirelessPackage = 'Failed to load Wireless account data';
                  $scope.wpkg_errorMessageWirelessPackage = resource.get('error_wireless_package_device');

                } else if (_tmp.result === 'error') {
                  holder = _tmp.data;
                  //$scope.wpkg_errorMessageWirelessPackage = holder.originalError;
                  $scope.wpkg_errorMessageWirelessPackage = resource.get('error_wireless_package_device');

                } else {
                  // Unknown state ???
                }
              }

            } else {

            }

          });
          
          //RBIB-28504
        var getMBHUrls = function () {
          var hasCommunitiesAccess;
          $scope.$watch(function () {
            return $rootScope.portalIds;
          }, function (newVal) {
            if (newVal && newVal.length > 0) {
              for (var i = 0; i < newVal.length; i++) {
                if (newVal[i] === 'SFDC') {
                  hasCommunitiesAccess = true;
                }
              }
              signinService.mbhUrlConfig().then(function (urlResponse) {
                $scope.mbhUrls = urlResponse;
              });
            }
          });
        }
        getMBHUrls();

          var hupRefId;

          ajax.getBrtSwitches().then(
              function (data) {
                angular.forEach(data, function (obj, key) {
                      if(obj.id == "BRT_NON_MSD"){
                        var usernameDetails = JSON.parse(sessionStorage.getSessionStorageValue('accountInfo'));
                        var requestData ={
                          userId : usernameDetails.userName,
                          brtSwitch : obj.id
                        }
                        ajax.gethasPermissions(requestData).then(
                          function (data) {
                            $scope.hasBrtPermission = data.hasBrtPermission;
                          })
                       }
                });
              });

          var messageBoxDom = function () {
            var loginDom;
            var deviceBalanceDom;
            var loginDirection;
            if($rootScope.isDealer){
              loginDirection=resource.get("ssp");
            }else if($rootScope.isCare){
              loginDirection=resource.get("v21");
            }
            // to chnage the login link text based on the laguage
            if ($scope.lng === 'en') {
              loginDom = '<div class="info-box-col login-text"><div>'+resource.get("login")+"</div>"
                +"<div><strong> "+resource.get("to")+" "+loginDirection+'</strong></div>'
                +'</div>';
              deviceBalanceDom = "<div><strong>"+resource.get("device")+'</strong></div>'
                +"<div><strong>"+resource.get("balance")+'</strong></div>';
            }
            else {
              loginDom = '<div class="info-box-col login-text"><div>'+resource.get("login_to")+"</div>"
                +"<div><strong> "+loginDirection+'</strong></div>'
                +'</div>';
              deviceBalanceDom = "<div><strong>"+resource.get("device_balance")+'</strong></div>';

            }


            // for info box message

            if($rootScope.isDealer){
              $scope.wireLessPackageMessage='<div class="info-box-header">'
                +"<strong><span class='header-tab'>"+resource.get("to_manage")
                +":</span><span>"+resource.get("to_change")
                +":</span></strong>"
                +"</div>"
                +'<div class="info-box-body">'
                +'<div class="info-box-col info-box-border">'
                +"<div><strong>"+resource.get("plan")+'</strong></div>'
                +"<div><strong>"+resource.get("add_ons")+'</strong></div></div>'
                +'<div class="info-box-col">'
                +"<div><strong>"+resource.get("phone_number")+'</strong></div>'
                +"<div><strong>"+resource.get("sim_card")+'</strong></div></div>'
                +'<div class="info-box-col"><img src="images/message-arrow.png"/></div>'
                +loginDom+"</div>";
              $scope.loginMsg=resource.get("login_to")+" "
                +"<strong>"+resource.get("ssp")+"</strong>";
            }
            else if($rootScope.isCare){
              $scope.wireLessPackageMessage='<div class="info-box-header">'
                +"<strong><span class='header-tab'>"+resource.get("to_manage")
                +":</span><span>"+resource.get("to_change")
                +":</span></strong>"
                +"</div>"
                +'<div class="info-box-body">'
                +'<div class="info-box-col info-box-border">'
                +"<div><strong>"+resource.get("add_ons")+'</strong></div></div>'
                +'<div class="info-box-col">'
                +"<div><strong>"+resource.get("phone_number")+'</strong></div>'
                +"<div><strong>"+resource.get("sim_card")+'</strong></div></div>'
                +'<div class="info-box-col"><img src="images/message-arrow.png"/></div>'
                +loginDom+"</div>";
              $scope.wireLessPackagePricePlanMessage='<div class="info-box-header">'
                +"<strong><span class='header-tab'>"+resource.get("to_manage")
                +":</span></strong>"
                +"</div>"
                +'<div class="info-box-body">'
                +'<div class="info-box-col">'
                +"<div><strong>"+resource.get("price_plan")+'</strong></div></div>'
                +'<div class="info-box-col"><img src="images/message-arrow.png"/></div>'
                +resource.get("log_in_to_telli")+"</div>"
                +"</div>";
              $scope.careUpgradeMessage='<div class="info-box-header">'
                +"<strong><span class='header-tab'>"+resource.get("to_upgrade")
                +":</span></strong>"
                +"</div>"
                +'<div class="info-box-body">'
                +'<div class="info-box-col">'
                +"<div><strong>"+resource.get("device")+'</strong></div></div>'
                +'<div class="info-box-col"><img src="images/message-arrow.png"/></div>'
                +'<div class="info-box-col login-text">'
                +resource.get("login_to")+" "
                +"<strong>"+resource.get("v21")+"</strong></div>";
              +"</div>";
              $scope.careCheckMessage='<div class="info-box-header">'
                +"<strong><span class='header-tab'>"+resource.get("to_check")
                +":</span></strong>"
                +"</div>"
                +'<div class="info-box-body">'
                +'<div class="info-box-col">'
                +"<div><strong>"+resource.get("device_balance")+'</strong></div></div>'
                +'<div class="info-box-col"><img src="images/message-arrow.png"/></div>'
                +'<div class="info-box-col login-text">'
                +resource.get("log_in_to_telli")+"</div>"
                +"</div>";
              $scope.loginMsg=resource.get("login_to")+" "
                +"<strong>"+resource.get("v21")+"</strong>";
            }
            $scope.upgradeMessage='<div class="info-box-header">'
              +"<span class='header-tab'><strong>"+resource.get("to_upgrade")
              +":</strong></span><span><strong>"+resource.get("to_check")+":</strong></span>"
              +"</div>"
              +'<div class="info-box-body">'
              +'<div class="info-box-col info-box-border"><strong>'
              +resource.get("device")+'</strong></div>'
              +'<div class="info-box-col">'
              +deviceBalanceDom+'</div>'
              +'<div class="info-box-col"><img src="images/message-arrow.png"/></div>'
              +loginDom+"</div>";


            $scope.reserveDeviceMsg="<span class='green-text'>"+resource.get("to_reserve_device")
              +"</span> "+resource.get("login_to_v21");

            $scope.loginSSPMsg=resource.get("login_to")+" "
              +"<strong>"+resource.get("ssp")+"</strong>";
            $scope.loginV21Msg=resource.get("login_to")+" "
              +"<strong>"+resource.get("v21")+"</strong>";


          };
          messageBoxDom();
          resource.onChanged(function () {
            messageBoxDom();
          }, $scope);
          $scope.refresh = function() {
            //$log.info('refresh');
            request.ctn = localStorage.getLocalStorageValue('phoneNumber');
            request.ban = localStorage.getLocalStorageValue('accountNumber');
            $scope.ban = localStorage.getLocalStorageValue('accountNumber');
            request.subscriberName = localStorage.getLocalStorageValue('subscriberName');

            request.language = userLanguage();
            request.applicationId = 'Rogers.com';

            //if (!!$rootScope.wirelessPackagePostPaidProcessed) {
            //  if ($rootScope.wirelessPackageLastRequestCtn === request.ctn) {
            //    return;
            //  }
            //}
            $scope.loadingDataIndicatorTravelPackage = false;

            /*
             wirelessService.getWirelessPostpaid(request, function(_tmp) {

             if (_tmp.result === 'success') {
             //$log.info('success');
             $rootScope.wirelessPackagePostPaidProcessed = true;
             $rootScope.wirelessPackageLastRequestCtn = angular.copy(request.ctn);
             // Proceed to display
             $scope.wpkg_wd = _tmp.data;
             $scope.processWirelessPackage ($scope.wpkg_wd);
             $scope.processDataWirelessMyDevice ($scope.wpkg_wd);
             $scope.processLanguageLabels();

             // Hide loading
             $scope.wpkg_displayContentPackage = true;
             $scope.wpkg_displayContentDevice = true;

             $scope.wpkg_loadingDataIndicatorPackage = false;
             $scope.wpkg_loadingDataIndicatorDevice = false;

             // remove error messages
             // $scope.errorMessage = false;
             if ($scope.wpkg_errorMessageWirelessPackage !== undefined) {
             $scope.wpkg_errorMessageWirelessPackage = undefined;
             }

             } else {
             $scope.wpkg_displayContentPackage = false;
             $scope.wpkg_displayContentDevice = false;
             $scope.wpkg_loadingDataIndicatorPackage = false;
             $scope.wpkg_loadingDataIndicatorDevice = false;

             if (_tmp.result === 'fail') {
             holder = _tmp.data;
             //$scope.wpkg_errorMessageWirelessPackage = 'Failed to load Wireless account data';
             $scope.wpkg_errorMessageWirelessPackage = resource.get('error_wireless_package_device');

             } else if (_tmp.result === 'error') {
             holder = _tmp.data;
             //$scope.wpkg_errorMessageWirelessPackage = holder.originalError;
             $scope.wpkg_errorMessageWirelessPackage = resource.get('error_wireless_package_device');

             } else {
             // Unknown state ???
             }
             }

             });*/
            /* UNION STATIC HARD CODED
             $scope.travelPackageData = {};
             $scope.travelPackageData.us = {
             "en":{
             "name"			:"U.S",
             "price"			:"5.00",
             "per"			:{
             "value"		:"/day",
             "legal"		: [
             {
             "label"		:"1",
             "content"	:"Taxes extra. Roam Like Home daily fee is a Pay-Per-Use rate and subject to change without notice. Fee is charged per line (added to your Share Everything plan monthly service fee) and applies for 24 hours from first use while in the U.S. See rogers.com/terms for full terms and conditions."
             }
             ]
             },
             "info1"			:"(You pay for up to XX days max at no extra charge for trips YY days or longer.)"
             },
             "fr":{
             "name"			:"Aux &Eacute;tats-Unis",
             "price"			:"5",
             "per"			:{
             "value"		:"par jour",
             "legal"		: [
             {
             "label"		:"1",
             "content"	:"*Taxes en sus. Le tarif quotidien de PARTOUT CHEZ VOUS est factur&eacute; &agrave; l&rsquo;utilisation et peut &ecirc;tre modifi&eacute; en tout temps sans pr&eacute;avis. Les frais sont factur&eacute;s par ligne (ajout&eacute;s aux frais de service mensuels de votre forfait Partagez tout) et s&rsquo;appliquent d&egrave;s la premi&egrave;re utilisation aux &Eacute;tats-Unis pendant une p&eacute;riode de 24 heures. Consultez rogers.com/modalites pour conna&icirc;tre toutes les modalit&eacute;s."
             }
             ]
             },
             "info1"			:"(Vous payez pour un maximum de 10 jours â€” aucuns frais additionnels pour les voyages de plus de 11 jours.)"
             }
             };

             $scope.travelPackageData.europe = {
             "en":{
             "name"			:"Over 35 countries in Europe",
             "price"			:"XX",
             "per"			:{
             "value"		:"/day when roaming within an eligible country",
             "legal"		: [
             {
             "label"		:"2",
             "content"	:"Taxes extra. The fee is a Pay-Per-Use rate and subject to change without notice. Fee is charged per line (in addition to your Share Everything plan monthly fee) and applies for 24 hours from first use while in an eligible European country. Roaming charges apply when outside the eligible country. Data: Usage exceeding your plan allotment charged in increments rounded up to the next MB or GB (as applicable based on your plan). Texts: Includes texts sent to a local wireless number while in an eligible country or to a Canadian wireless number. Sent/received premium texts, sent international texts to countries other than the eligible countries charged at applicable rates. Calls: While in an eligible country, includes unlimited calls to local numbers or Canadian numbers. International long distance rates apply to calls made to other countries while in an eligible country. See rogers.com/terms for full terms and conditions and list of eligible countries."
             }
             ]
             },
             "info1"			:"(You pay for up to XX days max at no extra charge for trips YY days or longer.)"
             },
             "fr":{
             "name"			:"Dans plus de 35 pays en Europe",
             "price"			:"XX",
             "per"			:{
             "value"		:"par jour lorsque vous utilisez votre appareil en itin&eacute;rance dans un pays admissible",
             "legal"		: [
             {
             "label"		:"2",
             "content"	:"* Taxes en sus. Le tarif est imput&eacute; &agrave; l&rsquo;utilisation et peut &ecirc;tre modifi&eacute; en tout temps sans pr&eacute;avis. Ce service est factur&eacute; par ligne (les frais s&apos;ajoutent aux frais de service mensuels de votre forfait Partagez tout) et s&rsquo;applique pendant 24 heures d&egrave;s votre premi&egrave;re utilisation de celui-ci dans un pays d&rsquo;Europe admissible. Des frais d&rsquo;itin&eacute;rance s&rsquo;appliquent lorsque vous &ecirc;tes &agrave; l&rsquo;ext&eacute;rieur des pays admissibles. Donn&eacute;es : L&rsquo;utilisation de donn&eacute;es sup&eacute;rieure au volume de donn&eacute;es compris dans votre forfait est factur&eacute;e par tranches et arrondie au Mo ou au Go suivant (selon les modalit&eacute;s de votre forfait). Messages texte : Comprend les messages texte envoy&eacute;s &agrave; un num&eacute;ro de sans-fil local dans un pays admissible ou &agrave; un num&eacute;ro de sans-fil au Canada. Les messages texte entrants et sortants &agrave; tarification additionnelle et les messages envoy&eacute;s &agrave; l&rsquo;&eacute;tranger, except&eacute; dans les pays admissibles, sont factur&eacute;s aux tarifs en vigueur. Appels : Comprend un nombre illimit&eacute; d&apos;appels &agrave; des num&eacute;ros locaux ou &agrave; des num&eacute;ros au Canada lorsque vous &ecirc;tes dans un pays admissible. Des tarifs interurbains internationaux s&rsquo;appliquent aux appels effectu&eacute;s dans d&rsquo;autres pays pendant que vous &ecirc;tes dans un pays admissible. Consultez rogers.com/modalites pour conna&icirc;tre les modalit&eacute;s et la liste des pays admissibles."
             }
             ]
             },
             "info1"			:"(Vous payez pour un maximum de XX jours &mdash; aucuns frais additionnels pour les voyages de plus de XX jours.)"
             }
             }; UNION STATIC HARD CODED */
            //var request = {};
            //request.ban = _data.ban;
            //request.ctn = _data.ctn;
            $scope.travelPackageDataHasPlan = false;

            /*wirelessService.getWirelessTravelPackage(request, function (_tmp) {
             if (_tmp.result === 'success') {
             if (_tmp.data.evolutionEligibleFlag) {
             $scope.hideWirelessTravelPackage = false;

             if (_tmp.data.evolutionOptInOutFlag) {
             $scope.travelPackageDataHasPlan = true;
             }
             wirelessService.getWirelessTravelPackageStaticContent(request, function (_tmp1) {
             if (_tmp1.result === 'success') {
             $scope.travelPackageData = {};
             $scope.travelPackageData.us = _tmp1.data.usa[0];
             $scope.travelPackageData.europe = _tmp1.data.europe[0];
             $scope.travelPackageData.common = _tmp1.data.common[0];
             $scope.loadingDataIndicatorTravelPackage = false;
             } else if (_tmp1.result === 'fail') {
             $scope.hideWirelessTravelPackage = true;
             } else if (_tmp1.result === 'error') {
             $scope.hideWirelessTravelPackage = true;
             } else {
             $scope.hideWirelessTravelPackage = true;
             }
             });
             request.language = userLanguage();
             wirelessService.getWirelessTravelPackageAddOnSummary(request, function (_tmp2) {
             //$scope.loadingDataIndicatorTravelPackage = false;
             if (_tmp2.result === 'success') {
             $scope.travelPackageAddOnSummaryData = {};
             $scope.travelPackageAddOnSummaryData.planAddOnDetails = _tmp2.data.postPaidAddons;

             } else if (_tmp2.result === 'fail') {

             } else if (_tmp2.result === 'error') {

             } else {
             // Unknown state ???
             }
             });
             } else {
             $scope.hideWirelessTravelPackage = true;
             }
             } else if (_tmp.result === 'fail') {
             $scope.hideWirelessTravelPackage = true;
             } else if (_tmp.result === 'error') {
             $scope.hideWirelessTravelPackage = true;
             } else {
             // Unknown state ???
             $scope.hideWirelessTravelPackage = true;
             }
             });*/
          };
          //$scope.refresh();

          // Support functions
          $scope.processWirelessPackage = function( data ){
            $scope.wpkg_rawData = data;												// All of the data
            $scope.wpkg_client = data.postPaidPhoneDetails;							// Client Data
            $scope.simtypedetails = data.postPaidPhoneDetails.simType;
            $scope.pType_toggle = false;
            $scope.eType_toggle = false;
            $scope.uType_toggle = false;
            if($scope.simtypedetails === 'P'){
              $scope.pType_toggle = true;
              $scope.simtype_label = resource.get('simtype_label');
              $scope.physical_label = resource.get('physical_label');
            }else if($scope.simtypedetails === 'D'|| $scope.simtypedetails === 'V' || $scope.simtypedetails === 'O'){
                $scope.eType_toggle = true;
                $scope.simtype_label = resource.get('simtype_label');
                $scope.esim_label = resource.get('esim_label');
            }else{
                $scope.uType_toggle = true;
                $scope.simtype_label = resource.get('simtype_label');
                $scope.unknown_label = resource.get('unknown_label');
            }
            angular.copy($scope.wpkg_client, $scope.wpkg_clientBkp);
            localStorage.setLocalStorageValue('oldSimNumber',data.postPaidPhoneDetails.simNumber);
            localStorage.setLocalStorageValue('ctnNumber',data.postPaidPhoneDetails.ctn);
            $scope.wpkg_client.subscriberName = localStorage.getLocalStorageValue('subscriberName');

            $scope.wpkg_device = data.bizDeviceDetails[$scope.wpkg_client.phoneProductId];	// Device data

            var subSet = null;
            var moreDetails = null;

            // Combine short plan details and long plan details, based on their SOC number
            $scope.wpkg_client.hasMyFive = data.postPaidPhoneDetails.hasMyFive;
            $scope.wpkg_client.hasVoiceMail = false;
            $scope.wpkg_client.hasRVoiceMail = false;
            $scope.wpkg_client.planSuspended = data.postPaidPhoneDetails.isSuspendedCtn;

            $scope.wpkg_client.features = [];
            $scope.wpkg_clientBkp.features = [];
            $scope.wpkg_clientBkp.featuresFr = [];

            $scope.wpkg_client.minutes = [];
            $scope.wpkg_clientBkp.minutes = [];
            $scope.wpkg_clientBkp.minutesFr = [];
            $scope.wpkg_unisonSOCs = [];

            function itemIsNot(item, text){
              if (item.desc) {
                if(item.desc.search(text) !== -1){
                  return false;
                }
              }

              return true;
            }

            hupRefId = (sessionStorage.getSessionStorageValue("hupRefId") != null)?sessionStorage.getSessionStorageValue("hupRefId"):"";

            ajax.saveOrderSearch({"refId": hupRefId, "ctn": $scope.wpkg_client.ctn, "orderType": "HUP"}, $scope.mbhUrls.saveOrderSearch).then(function(response){
              sessionStorage.setSessionStorageValue("hupRefId", response.refId);
              $scope.wpkg_hupRefId = response.refId;

            });

            wirelessService.getConfigData().then(
              function (response) {
                 $scope.wpkg_unisonSOCs = (typeof(response.unisonSOCs) !== 'undefined') ? response.unisonSOCs : [];
                 //console.log('unison data function2', $scope.wpkg_unisonSOCs, $scope.wpkg_unisonSOCs.indexOf("APLSRA222"));
               }, function (error) {
                 //check for business on this
                 $scope.wpkg_unisonSOCs = [];
               }
            );
            for (var ix = 0; ix <  data.postPaidPhoneDetails.additionalInfo.includedServices.length; ix++){
              var item = data.postPaidPhoneDetails.additionalInfo.includedServices[ix];

              if (item.hasOwnProperty('desc') && item.desc !== '' && itemIsNot(item, 'GPRS')) {
                $scope.wpkg_client.features.push(item.desc);
                $scope.wpkg_clientBkp.features.push(item.desc);
                $scope.wpkg_clientBkp.featuresFr.push(item.descFr);
              }

              if(item.socSubType && item.socSubType === settings.myVM){
                $scope.wpkg_client.vmsoc = item.soc;
                $scope.wpkg_client.hasVoiceMail = true;
              } else if(item.socSubType && item.socSubType === settings.myRVM){
                $scope.wpkg_client.hasRVoiceMail = true;
              }
            }
            if (data.postPaidPhoneDetails.additionalInfo.includedMinutes) {
              for (var yx = 0; yx <  data.postPaidPhoneDetails.additionalInfo.includedMinutes.length; yx++){
                $scope.wpkg_client.minutes.push(data.postPaidPhoneDetails.additionalInfo.includedMinutes[yx].desc);
                $scope.wpkg_clientBkp.minutes.push(data.postPaidPhoneDetails.additionalInfo.includedMinutes[yx].desc);
                $scope.wpkg_clientBkp.minutesFr.push(data.postPaidPhoneDetails.additionalInfo.includedMinutes[yx].descFr);
              }

            }

            //remove extra MY5 item U
            //comment out for showing my5 under the My Wireless Package
            /*    var _length = $scope.wpkg_client.postPaidAddons.length;
             for (var i = _length -1; i >= 0; i--) {
             if ($scope.wpkg_client.postPaidAddons[i].socDesc === settings.my5soc) {
             if (!$scope.wpkg_client.postPaidAddons[i].socSubType || $scope.wpkg_client.postPaidAddons[i].socSubType !== settings.my5soc) {
             $scope.wpkg_client.postPaidAddons.splice(i,1);
             }
             }
             } */

            // change format of json file.
            if ($scope.wpkg_client.hasMyFive) {
              $scope.wpkg_my5.soc = $scope.wpkg_client.soc;
              $scope.wpkg_my5.socDesc = $scope.wpkg_client.socDesc;
              $scope.wpkg_my5.MAX = $scope.wpkg_client.buddyListCount;
              $scope.wpkg_my5.TYPE = $scope.wpkg_client.buddyListType ; //subSet.socType;
            }

            //loop throght the postPaidAddons
            for (var i in $scope.wpkg_client.postPaidAddons) {
              subSet = $scope.wpkg_client.postPaidAddons[i];
              moreDetails = null;

              if (typeof subSet === 'object') {
                // Percentages for the ring chart
                var mySOCK = subSet.soc;

                if($scope.wpkg_client.hasMyFive) {
                  $scope.wpkg_my5.soc = mySOCK;
                  $scope.wpkg_my5.socDesc = subSet.socDesc;
                  $scope.wpkg_my5.MAX = $scope.wpkg_client.buddyListCount;
                  $scope.wpkg_my5.TYPE = $scope.wpkg_client.buddyListType ; //subSet.socType;
                }

                if(subSet.socSubType && subSet.socSubType === settings.myVM){
                  $scope.wpkg_client.vmsoc = subSet.soc;
                  $scope.wpkg_client.hasVoiceMail = true;
                } else if(subSet.socSubType && subSet.socSubType === settings.myRVM){
                  $scope.wpkg_client.hasRVoiceMail = true;
                }

                // Find that SOC id in planDetails and add that to the postPaidAddons array
                if ($scope.wpkg_rawData.planDetails[mySOCK]) {
                  moreDetails = $scope.wpkg_rawData.planDetails[mySOCK];
                  $scope.wpkg_client.postPaidAddons[i].additionalDetails = moreDetails;
                } else {
                  moreDetails = null;
                }
              }
            }

            var socDesc = $scope.lng === 'fr' ? data.postPaidPhoneDetails.planDescriptionFr : data.postPaidPhoneDetails.planDescription;
            var myPlanAddOn = {'soc': 'MyPlan', 'addonMSF': data.postPaidPhoneDetails.planMSF, 'socDesc': socDesc};
            var myPlanAddOnBkp = { 'soc' : 'MyPlan', 'addonMSF' :  data.postPaidPhoneDetails.planMSF , 'socDesc' : data.postPaidPhoneDetails.planDescription, 'socDescFr' :  data.postPaidPhoneDetails.planDescriptionFr};
            $scope.wpkg_client.postPaidAddons.unshift(myPlanAddOn);
            $scope.wpkg_clientBkp.postPaidAddons.unshift(myPlanAddOnBkp);
            angular.copy($scope.wpkg_client.postPaidAddons, $scope.wpkg_clientBkp.postPaidAddons);
          };

          $scope.processLanguageLabels = function(){

            if(!$scope.wpkg_client){
              return;
            }

            var isFrench = $scope.lng === 'fr';

            for (var i = 0; i< $scope.wpkg_client.postPaidAddons.length; i++) {
              var addon = $scope.wpkg_client.postPaidAddons[i];
              if(addon.soc == "MyPlan")
                addon.socDesc = $scope.wpkg_clientBkp.postPaidAddons[i].socDesc;
              else
                addon.socDesc = $scope.lng === 'fr' ? $scope.wpkg_clientBkp.postPaidAddons[i].socDescFr : $scope.wpkg_clientBkp.postPaidAddons[i].socDesc;
            }

            for (var ix = 0; ix <  $scope.wpkg_client.features.length; ix++){
              $scope.wpkg_client.features[ix] = isFrench ?  $scope.wpkg_clientBkp.featuresFr[ix] : $scope.wpkg_clientBkp.features[ix];
            }

            for (var yx = 0; yx <  $scope.wpkg_client.minutes.length; yx++){
              $scope.wpkg_client.minutes[yx] = isFrench ?  $scope.wpkg_clientBkp.minutesFr[yx] : $scope.wpkg_clientBkp.minutes[yx];
            }


          };

          $scope.processDataWirelessMyDevice = function( data ){
            $scope.wpkg_client = data.postPaidPhoneDetails;							// Client Data
            if(undefined != $scope.wpkg_client.phoneProductId &&
                undefined != data.bizDeviceDetails[$scope.wpkg_client.phoneProductId] && undefined != data.bizDeviceDetails[$scope.wpkg_client.phoneProductId].EN) {
              $scope.wpkg_device = data.bizDeviceDetails[$scope.wpkg_client.phoneProductId].EN;	// Device data

              // Phone image
              var mainImage = '';
              var deviceName = '';
              var deviceNameFr = '';

              var deviceInfo = $scope.wpkg_client.phoneProductId;
              var deviceObject = data.bizDeviceDetails[deviceInfo].EN;
              var deviceObjectFr = data.bizDeviceDetails[deviceInfo].FR;

              try {
                if (deviceObject.phoneImagePaths.length > 0) {
                  mainImage = deviceObject.phoneImagePaths[0];
                }

              } catch (err) {
                mainImage = 'noimage';
              }

              try {
                deviceName = deviceObject.english['product-info']['product-title'];
                deviceNameFr = deviceObjectFr.french['product-info']['product-title'];
                var deviceObjectImg = data.bizDeviceDetails[deviceInfo].EN.english;
                if (deviceObjectImg != null && deviceObjectImg != undefined) {
                  angular.forEach(deviceObjectImg, function(value, key) {
                    if(key=="product-images"){
                      angular.forEach(value, function(value1, key1) {
                        if(key1=="ute-image-medium"){
                          mainImage = self.setSmbImageurl(value1.url);
                        }
                      });
                    }
                  });
                }

              } catch (err) {
                deviceName = '';
                deviceNameFr = '';
              }


              var altImage = $scope.wpkg_client.phoneAltImage;
              var useThis = '';

              useThis = mainImage;
              if (mainImage === 'noimage' || mainImage === '') {
                useThis = 'images/Wireless-SD.png';

              } else {
                if (settings.isLocal) {
                  useThis = settings.formsURL + useThis;
                }
              }

              $scope.wpkg_client.phoneImageProcessed = useThis;
              console.log(useThis);
              $scope.wpkg_client.deviceName = deviceName;
              $scope.wpkg_client.deviceNameFr = deviceNameFr;
            }
            else{
              $scope.wpkg_client.phoneImageProcessed = 'images/Wireless-SD.png';
              $scope.wpkg_client.deviceName = '';
              $scope.wpkg_client.deviceNameFr = '';
            }
          };

         self.setSmbImageurl = function(imgUrl){

           var replaceString = "";
           if(imgUrl.contains("/cms/ute/rogers/consumer/BFA/images/wireless/")){
              replaceString = "/cms/ute/rogers/consumer/BFA/images/wireless/";
           }
           if(imgUrl.contains("/cms/ute/fido/images/wireless/")){
              replaceString = "/cms/ute/fido/images/wireless/";
           }
           if(replaceString != "") {
            imgUrl = imgUrl.replace(replaceString,"/cms/rogers/smb/");
           }
           return "/web/smb"+imgUrl;
         };

          self.getQ2PPCPermission = function (permissionStorage, permissionName) {
            var deferred = $q.defer();
            var q2PPCPermission = localStorage.getLocalStorageValue(permissionStorage);
            if (!q2PPCPermission || q2PPCPermission === 'false') {
              ajax.getPermissions().then(function (result) {
                if (result.permissions && result.permissions.length && _.find(result.permissions, function(obj){
                    return obj.permission === permissionName;
                  })) {
                  localStorage.setLocalStorageValue(permissionStorage, true);
                  deferred.resolve();
                } else {
                  localStorage.setLocalStorageValue(permissionStorage, false);
                  deferred.reject();
                }
              }, function () {
                localStorage.setLocalStorageValue(permissionStorage, false);
                deferred.reject()
              });
            } else {
              deferred.resolve();
            }
            return deferred.promise;
          };

          $scope.isFetchOrderCompleted = bfappcWirelessDashboardService.isFetchOrderCompleted;

          $scope.hasPPCOrder = function () {
            return bfappcWirelessDashboardService.hasOrder($scope.wirelessDashActive.ctn);
          };

          $scope.openPPC = function (resumeOrder) {
            ppcBrt().then(function (allowPPC) {
              if (allowPPC) {
                if ($scope.isDealer) {
                  $rootScope.targetFlow = settings.deepLinkStatusCodes.changePricePlan;
                  $scope.deepLinkingModal();
                } else {
                  $scope.changeBtnLoading(true);
                  bfappcWirelessDashboardService.gotoBFAPPC($scope, resumeOrder).then(
                    function () {
                      $scope.changeBtnLoading(false);
                    },
                    function (q2ppcBrtSwitch) {
                      // BFA-PPC BRT switch is off
                      if (q2ppcBrtSwitch) {
                        //if q2PPC itself is on BRT we should only display a msg
                        $scope.openChangePlanModal();
                      } else {
                        $state.go('wireless-plan-change');
                      }
                      $scope.changeBtnLoading(false);
                    }
                  );
                }
              } else {
                $window.location.href = '/small-business/products-and-solutions/wireless/plans-and-pricing';
              }
            }, function () {
              // TODO: Error Handling
            });
          };

          $scope.openChangePlanModal = function (size) {
            $modal.open({
              templateUrl: 'views/modals/wirelessRemovePlan.html',
              controller: 'wirelessRemoveModalCtrl',
              size: size,
              backdrop: false,
              resolve: {}
            });
          };

          function ppcBrt() {
            var deferred = $q.defer();
            bfappcWirelessDashboardService.isBRT('ppcRateCard').then(
              function (hasSwitch) {
                if (hasSwitch) {
                  bfappcWirelessDashboardService.hasPermission('ppcRateCard').then(
                    function (hasPermission) {
                      if (!hasPermission) {
                        deferred.resolve(false);
                      } else {
                        deferred.resolve(true);
                      }
                    }
                  );
                } else {
                  deferred.resolve(true);
                }
              }, function () {
                deferred.reject();
              });
            return deferred.promise;
          }

          $scope.goToSingleLinePlanPage = function () {
            if (settings.enablePricePlanChanges) {
              self.getQ2PPCPermission('q2PPCPermission', 'PPC_PAGE_VIEW').then(function () {
                $location.url('/wireless-plan-change');
              }, function () {
                $scope.openModal();
              });
            }
          };

          $scope.openModal = function (size) {

            var serverHack = '/web/smb/bss';
            if( settings.isLocal ) {
              serverHack = '';
            }

            $rootScope.modal = $modal.open({
              templateUrl: serverHack+'/views/modals/wirelessRemovePlan.html',
              controller: 'wirelessRemoveModalCtrl',
              size: size,
              backdrop: false,
              //backdropClass: 'bkg-modal',
              resolve: {}
            });

            $rootScope.modal.result.then(function () {

            }, function () {
              // on Cancel behaviour
            });
          };

          // Links
          $scope.postToRogersUrls = [
            {url: '/web/RogersServices.portal?_nfpb=true&_pageLabel=ChangeSimCard' + '&setLanguage=' + $scope.lng},
            {url: '/web/myrogers/torcom/postPaidAppsAddons' + '?setLanguage=' + $scope.lng},
            {url: '/web/myrogers/updateBuddyList' + '?setLanguage=' + $scope.lng},
            {url: '/web/myrogers/torcom/shopAccessories' + '?setLanguage=' + $scope.lng}
          ];

          $scope.postToRogersBusinessAddOn = function() {
            $('#formToRogersAddOn').attr('action', settings.formsURL + '/business/ute/smb/transactions/uteModifyAddons');
            $('#formToRogersAddOn').submit();
          };


          $scope.postToRogersBusinessAddLine = function() {
                      $('#formToRogersAddLine').attr('action', settings.formsURL + '/web/smb/new-wireless-activation/#/choose-phone?deeplink');
                      $('#formToRogersAddLine').submit();
                    };


          $scope.changeSubscriberName = function() {
            myrAccountListService.acctInitStateUrl = "changesubscribername";
            appState.switchView('changesubscribername');
          };

          $scope.resetVoiceMailbox = function() {
            myrAccountListService.acctInitStateUrl = "resetvoicemailbox";
            appState.switchView('resetvoicemailbox');
          };

          $scope.isPrimaryDevice = function() {
            return myrMyServicesService.isPrimaryDevice($scope.ctn);
          };

          $scope.getPdEligibility = function() {
            var postData = {
                 applicationId: "SMB",
                 accountNumber: localStorage.getLocalStorageValue('accountNumber'),
                 primaryDeviceNumber: $scope.ctn
            };
            ajax.getPdEligibility(postData).then(function(data) {

              if(data && data.pdEligFlag && data.pdEligFlag === "E" || data.pdEligFlag === "Y" ){

                if(data.pdEligFlag === "E"){
                  localStorage.setLocalStorageValue('whiteListStatus', "unWhiteListed");
                } else {
                  localStorage.setLocalStorageValue('whiteListStatus', "whitelisted");
                }
                $state.go('pdWhiteList');

              } else if(data && data.pdEligFlag && data.pdEligFlag === "N") {

                var pdEligibilityModal = $modal.open({
                  templateUrl: 'views/modals/pdEligibility.html',
                  controller: 'pdEligiblityModalCtrl',
                  controllerAs: 'vm',
                  resolve: {
                    isErrorDescEn: function() {
                      var genDes = [];
                      if(data.errorDescriptionList.length > 0){
                        for (var i = 0; i < data.errorDescriptionList.length ; i++)
                        {
                          genDes.push(data.errorDescriptionList[i].genDesc);
                        }
                        return genDes;
                      }

                      else{
                        return null;
                      }
                    },
                    isErrorDescFr: function() {
                      var genDescFr = [];
                      if(data.errorDescriptionList.length > 0){
                        for (var i = 0; i < data.errorDescriptionList.length ; i++)
                        {
                          genDescFr.push(data.errorDescriptionList[i].genDescFr);
                        }
                        return genDescFr;
                      }

                      else{
                        return null;
                      }
                  }
                  }
                });
              } else {
                pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);
              }
            }, function(error) {
              // TODO - error handling
               pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], {goBack: 'accountOverview'}, true);

            });
          };

          $scope.changeTelephoneNumber = function() {
            $('#formToRogersCTN').attr('action', settings.formsURL + '/business/ute/smb/transactions/uteChangeCTN');
            $('#formToRogersCTN').submit();
          };

          $scope.postToRogersAddOnChange = function(subSet) {
            if(subSet && subSet.socDesc && subSet.socDesc === settings.my5soc){
              $scope.updateMy5();
            }
            if(subSet && subSet.socSubType && subSet.socSubType === settings.myVM){
              $scope.changePassword();
            }
          };

          $scope.updateMy5 =  function(){
            $('#formToRogersMy5').attr('action', settings.formsURL + '/web/myrogers/updateBuddyList'+ '?setLanguage=' + $scope.lng);
            $('#formToRogersMy5').submit();
          };

          if($scope.boldChat == undefined) {
            $scope.boldChat = {};
          } else if($scope.boldChat.olbLiveChat == undefined){
            $scope.boldChat.manageMy5 = {
              en: {
                cbid: 'Rogers_Default',
                dynamicDivId: 'Rogers_Default_div',
                chatButtonClass:'chatButtonRogersDefaultEn'
              },

              fr: {
                cbid: 'Rogers_Default_Fr',
                dynamicDivId: 'Rogers_Default_Fr_div',
                chatButtonClass:'chatButtonRogersDefaultFr'
              }
            };
          }

          $scope.getFirstNameFromCtn = function (ctn) {
            var ctnRecord = _.find($scope.myServicesList, {'subType': 'CTN', 'serviceDetail': $scope.ctn});
            if (ctnRecord) {
              return ctnRecord.firstName;
            }
            return '';
          };

          $scope.getDmServiceGrp = function () {
            var ctnRecord = _.find($scope.myServicesList, {'subType': 'CTN', 'serviceDetail': $scope.ctn});
            if (ctnRecord) {
              return ctnRecord.dmServiceGrp;
            }
            return 0;
          };

          $scope.setDataForReactivateCtn = function () {
            $scope.dataModelForReactivateCtn = {
              phoneNumber: $scope.ctn,
              accountNumber: $scope.ban,
              deviceNameEn: $scope.wpkg_client.deviceName,
              deviceNameFr: $scope.wpkg_client.deviceNameFr,
              firstName: $scope.getFirstNameFromCtn($scope.ctn)
            };
            reactivateCtnService.setModel($scope.dataModelForReactivateCtn);
          };

          $scope.postToeSimpage = function(){
            var flag;
            ajax.getBrtSwitches().then(
              function (data) {
                angular.forEach(data, function (obj, key) {
                  if(obj.id == "BRT_eSIM_BSS"){
                    if (obj.switchIsOn == false) {
                        flag = obj.id;
                        ajax.getPermissions().then(
                          function (data) {
                            angular.forEach(data, function (obj, key) {
                              angular.forEach(obj, function (x, key) {
                                if (x.permission == flag) {
                                  dataLayerService.track({}, false, [4, 1, 0], {mappingKey: "changeEsimcard"});
                                  appState.switchView('eSimChange');
                                }
                              });
                            });
                          });
                      }else{
                       var whitelistvalfal = false;
                        var usernameDetails = JSON.parse(sessionStorage.getSessionStorageValue('accountInfo'));
                        var requestData ={
                          userId : usernameDetails.userName,
                          brtSwitch : obj.id
                        }
                        ajax.gethasPermissions(requestData).then(
                          function (data) {
                            if(data.hasBrtPermission == whitelistvalfal){
                              if ($rootScope.brtph2common) {
                                myrAccountListService.acctInitStateUrl = "simCard";
                                var  acctNumber= localStorage.getLocalStorageValue('accountNumber');
                                var accountEmail = _.has($scope.ao, 'accountDetails.contactInfo.emailAddress') ? $scope.ao.accountDetails.contactInfo.emailAddress : '';
                                simcardChangeService.goToEntryState({phoneNumber: $scope.ctn, accountNumber: acctNumber, accountEmail: accountEmail});
                              } else {
                                $('#formToRogersSim').attr('action', settings.formsURL + '/business/ute/smb/transactions/uteChangeSim');
                                $('#formToRogersSim').submit();
                              }
                            }else{
                              appState.switchView('eSimChange');
                            }
                          });
                      }
                  }
                });
              });
          };

          $scope.suspendPhone = function(){
            if ($rootScope.brtph2common) {
              var  acctNumber= localStorage.getLocalStorageValue('accountNumber');
              var accountEmail = _.has($scope.ao, 'accountDetails.contactInfo.emailAddress') ? $scope.ao.accountDetails.contactInfo.emailAddress : '';
              suspendCtnService.goToEntryState({
                phoneNumber: $scope.ctn,
                accountNumber: acctNumber,
                accountEmail: accountEmail,
                deviceNameEn: $scope.wpkg_client.deviceName,
                deviceNameFr: $scope.wpkg_client.deviceNameFr,
                firstName:$scope.getFirstNameFromCtn($scope.ctn)
              });
            }
            else{
              $('#formToRogersBusinessSuspend').attr('action', settings.formsURL + '/business/ute/smb/transactions/uteSuspendReactivate');
              $('#formToRogersBusinessSuspend').submit();
            }
          };

          $scope.isReactivateCtnCallInProgress = function () {
            return reactivateCtnService.isReactivateCtnCallInProgress();
          };

          $scope.reactivatePhone = function($event){
            if ($rootScope.brtph2common) {
              $event.preventDefault();
              reactivateCtnService.setAccountNumber($scope.ban);
              reactivateCtnService.setPhoneNumber($scope.ctn);
              reactivateCtnService.processReactivateCtn();
            }
            else{
              $('#formToRogersBusinessReactivate').attr('action', settings.formsURL + '/business/ute/smb/transactions/uteSuspendReactivate');
              $('#formToRogersBusinessReactivate').submit();
            }
          };

          $scope.changePassword = function() {
            $('#formToRogersVoicemail').attr('action', settings.formsURL + '/business/ute/smb/transactions/uteResetVoicemailPassword');
            $('#formToRogersVoicemail').submit();
          };

          $scope.shopAccesuars = function() {
            var urlA =  settings.formsURL + '/web/myrogers/torcom/shopAccessories' + '?setLanguage=' + $scope.lng;
            $location.href = urlA;
          };

          $scope.showHidePanels = function(panelNumber) {
            if (panelNumber === 1) {
              $scope.wpkg_isCollapsed = !$scope.wpkg_isCollapsed;
              if($scope.wpkg_isShowPanel === true){
                $scope.wpkg_isShowPanel = false;
              }
            }
            if (panelNumber === 2) {
              $scope.wpkg_isShowPanel = !$scope.wpkg_isShowPanel;
              if($scope.wpkg_isCollapsed === false){
                $scope.wpkg_isCollapsed = true;
              }
            }
          };

          $scope.linkToHandsetProtectionGuarantee =function(){
            $window.location.href = '../../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/rogers/handsetprotection/';
          };

          $scope.linkToWirelessPlans =function(){
            $window.location.href = '../../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/shop/wireless/plans/';
          };

          $scope.linkToWirelessNetworkCoverage =function(){
            $window.location.href = '../../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/shop/wireless/networkcoverage/';
          };

          $scope.linkToWirelessAddonTravel =function(){
            $window.location.href = '../../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/shop/wireless/addons/travel/';
          };

          $scope.linkToWifiCalling =function(){
            $window.location.href = '../../../business/'+userProvince().toLowerCase()+'/'+userLanguage()+'/smallbusiness/shop/wireless/wifi/';
          };

          $scope.linkToReserveDevice = function(){
            //$window.location.href = 'https://secure2.rogersdirect.ca/reserve2/';
            $window.open('https://secure2.rogersdirect.ca/reserve2/', '_blank');
          };


          $scope.postToRogersAddOn = function() {
            $('#formToRogersAddOn').attr('action', settings.formsURL + '/business/ute/smb/transactions/uteModifyAddons');
            $('#formToRogersAddOn').submit();
          };

          $scope.upgradeDevice = function() {
            $('#formToRogersUpgrade').attr('action', settings.formsURL + '/web/myrogers/device-upgrade' + '?setLanguage=' + $scope.lng);
            $('#formToRogersUpgrade').submit();
          };

          $scope.upgradeMyDevice = function() {
            var interactionObject = {
              applicationName: 'Rogers Business|rogers.git/cmsredesign',
              buyflow: {
                  name: 'upgrade device'
                },
              ecommerce: {
                products: [
                  {
                    ID: "[]",
                    name: "[]",
                    manufacturer: "[]",
                    color: "[]",
                    capacity: "[]",
                    category: "rbiz-wireless",
                    subCategory: "BSS-S-device-details",
                    findingMethod: "[]",
                    price: "[]",
                    quantity: "[]",
                    upfrontEdgeAmount: "[]"
                  }
                ]
              },
              events: {
                pageView: true,
                productView: true,
                buyFlowStart: true
              },
            };
            dataLayerService.track(interactionObject, false, [4, 1, 0], {mappingKey: "upgradeDevice"});
            if($scope.hasBrtPermission) {
              //SBP URL
              $window.open($scope.mbhUrls.sbpInquiry + hupRefId, "_blank");
            } else {
              //Midmarket URL
              $window.open($scope.mbhUrls.orderInquiry + hupRefId, "_blank");
            }

          }

          //
          $scope.checkBalance = function() {
            $('#formToRogersUpgrade').attr('action', settings.formsURL + '/business/ute/smb/transactions/uteCheckDeviceBalance');
            $('#formToRogersUpgrade').submit();
          };

          //reserveDevice
          $scope.reserveDevice = function() {

            //TODO two line below here may cause by code merge
            //$('#formToRogersReserveDevice').attr('action',settings.formsURL+'/web/RogersServices.portal?_nfpb=true&_pageLabel=ReserveDevice'+'&setLanguage='+$scope.lng);
            //$('#formToRogersReserveDevice').submit();
            function goToReserveDevice(){
              //$rootScope.sfnrs=true;//debug
              if($rootScope.sfnrs){
                appState.switchView('reservedevice');
              }else{
                $('#formToRogersReserveDevice').attr('action',settings.formsURL+'/web/RogersServices.portal?_nfpb=true&_pageLabel=ReserveDevice'+'&setLanguage='+$scope.lng);
                $('#formToRogersReserveDevice').submit();
              }
            }

            if($scope.wpkg_client.creditLimitAmount == 0){
              goToReserveDevice();
            }else{
              var serverHack = '/web/smb/bss';
              if (settings.isLocal) {
                serverHack = '';
              }
              $rootScope.modal = $modal.open({
                templateUrl: serverHack + '/views/modals/reserveDevice.html',
                controller: 'wirelessModalCtrl',
                backdrop: false,
                scope: $scope,
                resolve: {}
              });

              $rootScope.modal.result.then(function (e) {
                goToReserveDevice();
              }, function (e) {
                // on Cancel behaviour
              });

            }

          }

          $scope.openWirelessTravelPackageLegalContentModal = function($event, size) {
            var serverHack = '/web/smb/bss';
            if (settings.isLocal) {
              serverHack = '';
            }
            $scope.wirelessTravelPackageLegalContent = $sce.trustAsHtml(angular.element($event.target).next().html());

            $rootScope.modal = $modal.open({
              templateUrl: serverHack + '/views/modals/wirelessTravelPackageLegal.html',
              controller: 'wirelessTravelPackageLegalModalCtrl',
              size: size,
              backdrop: false,
              scope: $scope,
              resolve: {}
            });

            $rootScope.modal.result.then(function () {

            }, function () {
              // on Cancel behaviour
            });
          }
          $scope.renderHTML = function(html_code)
          {
            var decoded = angular.element('<textarea />').html(html_code).text();
            return $sce.trustAsHtml(decoded);
          }
          $scope.openWirelesePackageModal = function (size) {
            if($rootScope.isDealer || $rootScope.isCare){
              var serverHack = '/web/smb/bss';
              if (settings.isLocal) {
                serverHack = '';
              }
              $rootScope.modal = $modal.open({
                templateUrl: serverHack + '/views/modals/roamEnrollModal.html',
                controller: 'roamEnrollModalCtrl',
                size: size,
                scope: $scope,
                backdrop: false,
                resolve: {}
              });
              $rootScope.modal.result.then(function () {

              }, function () {
                // on Cancel behaviour
              });

            }else {
              var serverHack = '/web/smb/bss';
              if (settings.isLocal) {
                serverHack = '';
              }
              $rootScope.modal = $modal.open({
                templateUrl: serverHack + '/views/modals/wirelessTravelPackage.html',
                controller: 'wirelessTravelPackageModalCtrl',
                size: size,
                scope: $scope,
                backdrop: false,
                resolve: {}
              });
              $rootScope.modal.result.then(function () {

              }, function () {
                // on Cancel behaviour
              });
            }

          };

          $scope.onClickWirelessChangeWirelessNumber = function () {
            appState.tagging(['_trackPageView',{eVar13:'MyRogers change wireless number'},{event5:''}]);
          };

          $scope.onClickWirelessChangeMyPlan = function () {
            appState.tagging(['_trackPageView',{eVar13:'MyRogers – change my plan'},{event5:''}]);
          };

          $scope.onClickWirelessDeviceReservation = function () {
            appState.tagging(['_trackPageView',{eVar13:'MyRogers device reservation'},{event5:''}]);
          };

          $rootScope.$on('setTravelPackageDataHasPlan', function (data) {
            $scope.travelPackageDataHasPlan = true;
          });

          resource.onChanged(function () {
            $scope.lng =	userLanguage();

            if(localStorage.getLocalStorageValue('phoneNumber')){
                var accountInfo = {
                   selectedCTN: localStorage.getLocalStorageValue('phoneNumber')
                };
                dataLayerIntegrationService.setSelectedSubscriberNumber(accountInfo);
            }

            $scope.processLanguageLabels();

            if ($scope.wpkg_errorMessageWirelessPackage) {
              $scope.wpkg_errorMessageWirelessPackage = resource.get('error_wireless_package_device');
            } else {
              $scope.wpkg_errorMessageWirelessPackage = undefined;
            }
          }, $scope);

          $scope.showReactivateCtn = function () {
            return (
              $scope.wpkg_client &&
              $scope.wpkg_client.planSuspended &&
              $rootScope.brtph2common && !_.isUndefined($scope.dataModelForReactivateCtn)
            );
          };

        }]};
  }])

  .controller('wirelessRemoveModalCtrl', ["$scope", "$rootScope", "$modalInstance", "userLanguage", "settings", "resource", function ($scope, $rootScope, $modalInstance, userLanguage, settings, resource) {
    $scope.chatHref = userLanguage() === 'en' ? settings.chatLinkChangePlan.en : settings.chatLinkChangePlan.fr,  /// 'cuscare_ECare_landing.php?hm=n&s=701',


      $scope.ok = function () {
        $modalInstance.close('ok');
        $rootScope.modal = null;
      };
    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };

    resource.onChanged(function () {
      $scope.lng =	userLanguage();
      $scope.viewAllPlanslink = settings.formsURL + '/small-business/wireless/plans?setLanguage=' + $scope.lng;

    }, $scope);


  }])
  .controller('wirelessTravelPackageModalCtrl', ['$scope', '$rootScope', '$modalInstance', 'myrWirelessDashboardService',
    function ($scope, $rootScope, $modalInstance, wirelessService) {
      $scope.errorMessage = false;
      $scope.getPlan = function () {

        var request = {};
        request.ban = $scope.ban;
        request.ctn = $scope.ctn;
        request.evolutionOptInOutFlag = true;
        request.evolutionEligibleFlag = true;
        wirelessService.setWirelessTravelPackage(request, function (_tmp1) {
          if (_tmp1.result === 'success') {
            if  (_tmp1.data.successFlag === true) {
              $rootScope.$broadcast('setTravelPackageDataHasPlan');
              $modalInstance.close('ok');
            } else {
              $scope.errorMessage=true;
            }
          } else if (_tmp1.result === 'fail') {
            $scope.errorMessage=true;
          } else if (_tmp1.result === 'error') {
            $scope.errorMessage=true;
          } else {
            $scope.errorMessage=true;
          }


        });

        $rootScope.modal = null;
      };

      $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
      };
    }])
  .controller('wirelessTravelPackageLegalModalCtrl', ['$scope', '$rootScope', '$modalInstance', '$sce',
    function ($scope, $rootScope, $modalInstance, $sce) {
      $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
      };
    }])
  .controller('wirelessModalCtrl', ['$scope', '$rootScope', '$modalInstance', '$sce',
    function ($scope, $rootScope, $modalInstance, $sce) {
      $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
      };
      $scope.ok = function(){
        $modalInstance.close('ok');
        $rootScope.modal = null;
      }
    }])
  .controller('roamEnrollModalCtrl', ['$scope', '$rootScope', '$modalInstance', '$sce',
    function ($scope, $rootScope, $modalInstance, $sce) {
      $scope.close = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
      };
    }])
  .controller('notEligibleModalCtrl', ["$scope", "$modalInstance", "userLanguage", "resource", "settings", "eligibilityResponse", function ($scope, $modalInstance, userLanguage, resource, settings, eligibilityResponse) {
    var self = this;
    self.init = function () {
      $scope.chatHref = userLanguage() === 'en' ? settings.chatLinkChangePlan.en : settings.chatLinkChangePlan.fr;
      $scope.model = {
        desc: resource.get('ppccode_500')
      };
    };
    self.init();
    $scope.onContinue = function () {
      $modalInstance.close('ok');
    };
  }])
  .controller('pdEligiblityModalCtrl', ['$modalInstance', 'userLanguage', 'isErrorDescEn', 'isErrorDescFr', function($modalInstance, userLanguage, isErrorDescEn, isErrorDescFr) {
    var vm = this;
    var genDescEn = [];
    var genDescFr = [];
    for (var i = 0 ; i< isErrorDescEn.length ; i++){
      genDescEn.push(isErrorDescEn[i]);
    }
    vm.isErrorDescEn = genDescEn;
    for (var i = 0 ; i< isErrorDescFr.length ; i++){
      genDescFr.push(isErrorDescFr[i]);
    }
    vm.isErrorDescFr = genDescFr;
    vm.language = userLanguage().toLowerCase();
    vm.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
    vm.ok = function() {
      $modalInstance.close('ok');
    };
  }]);

'use strict';

angular.module('totesApp')
		.directive('wirelessPlan', function () {
			return {
				restrict: 'E',
				replace: 'true',
				scope: {
					mode: '='			// 1 = postpaid / 2 = prepaid
				},
				templateUrl: 'scripts/directives/wirelessPlan/wirelessPlan.html',
				link: function (scope, element, attrs) {
					// DOM or direct jQuery calls
				}
			};
		})
		.controller('wirelessPlanCtrl', ['$scope', 'settings', '$timeout', 'resource', 'userLanguage', 'localStorage', 'myrWirelessPrepaidService', '$rootScope', '$modal',
			function ($scope, settings, $timeout, resource, userLanguage, localStorage, wirelessPrepaidService, $rootScope, $modal ) {

				$scope.lng = userLanguage();
				$scope.lang = userLanguage();
				$scope.showWpAddOns = false;
        $scope.dtEn = null;
        $scope.showDefaultExpireDate=false;

				$scope.vpd = {};
				$scope.isDeveloper = settings.isLocal;

				$scope.wd = null;
				$scope.loadingDataIndicator = true;

				var holder = null;
				var request = {};

				request.ctn = localStorage.getLocalStorageValue('phoneNumber'); //'4163880217';
				request.language = userLanguage();

				$scope.ctn = localStorage.getLocalStorageValue('phoneNumber');
				$scope.postObj = {};
				$scope.ctn = localStorage.getLocalStorageValue('phoneNumber');

				$scope.months = {
					Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
				};

				$scope.monthsNames = resource.get('_months');
				$scope.addOns = [];
				$scope.postToRogersUrls = [];
				$scope.selectedFlow = '';
				$scope.isDealer = $rootScope.isDealer;
				$scope.isCare= $rootScope.isCare;
				$scope.isConsumer= $rootScope.isConsumer;

				$scope.postToRogers = function (actionId) {
				  if($rootScope.isDealer || $rootScope.isCare){
				    $scope.open();
            if(actionId!=2){
              $rootScope.actionOtherThanTopUp=true;
            }else{
              $rootScope.actionOtherThanTopUp=false;
            }

				  }else{
				    $('#formToRogers').attr('action', settings.formsURL + $scope.postToRogersUrls[actionId].url);
            $scope.selectedFlow = $scope.postToRogersUrls[actionId].flowId;
            $timeout(function () {
              $('#formToRogers').submit();
            });
				  }

				};

				// Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal
        $scope.open = function (size) {
          var serverHack = '/web/smb/bss';
          if (settings.isLocal) {
            serverHack = '';
          }
          $rootScope.modal = $modal.open({
            templateUrl: serverHack + '/views/modals/prepaidModal.html',
            controller: 'MyrWirelessPrepaidModalController',
            size: size,
            backdrop: 'static',
            backdropClass: 'bkg-modal',
            resolve: {}
          });

          $rootScope.modal.result.then(function () {
            // on OK behaviour
          }, function () {
            // on Cancel behaviour
          });
        };

				$scope.formatDates = function () {
					if (!$scope.vpd.phoneSelected.expireDate) {
            $scope.showDefaultExpireDate = true;
						return;
					}

					var arrDate = $scope.vpd.phoneSelected.expireDate.split('-');
					//var mNum = $scope.months[arrDate[0]];
                    //
					//$scope.dtEn = arrDate[1] + '-' + arrDate[0] + '-20' + arrDate[2];
					//$scope.dtFr = arrDate[1] + ' ' + $scope.monthsNames[mNum] + ' 20' + arrDate[2];

          var mNum1 = Number(arrDate[1]);


          $scope.dtEn = $scope.monthsNames[mNum1-1] + ' ' + arrDate[2] + ', ' + arrDate[0];
          $scope.dtFr = $scope.dtEn;
				};

				$scope.getWirelessPrepaid = function () {
					$scope.loadingDataIndicator = true;
					$scope.displayContent = false;

					$scope.postObj.ctn = request.ctn;
					$scope.postObj.language = $scope.lang;

					wirelessPrepaidService.getWirelessPrepaid($scope.postObj, function (_tmp) {
						if (_tmp.result === 'success') {
							// Hide loading
							$scope.loadingDataIndicator = false;
							$scope.displayContent = true;

							// Proceed to display
							$scope.vpd = _tmp.data;


							// Split the plan name into two lines
							// Split the plan name into two lines
							for (var i in $scope.vpd.phoneServices) {
								var subSet = $scope.vpd.phoneServices[i];
								//DBG
								//$scope.vpd.phoneServices[i].prePaidAddons = [];

								var addOns = $scope.vpd.phoneServices[i].prePaidAddons;
								subSet.addOns = addOns;

								//subSet.addOns.push({'addonTitle':'test1 - desc1'});
								//subSet.addOns.push({'addonTitle':'test1 - desc1'});

								subSet.expireDate = $scope.vpd.phoneServices[i].expiryDate;  //$scope.vpd.nextBillingDate;
								subSet.pin = $scope.vpd.phoneServices[i].pin;
								subSet.accountNumber = $scope.vpd.phoneServices[i].ban;

								if (typeof subSet === 'object') {
									var origName = subSet.planDesc;
									var origNameArr = origName.split('-');

									if (origNameArr.length === 2) {
										subSet.planDescHTML = '<h5 >' + origNameArr[0] + '</h5><div class=\"title_28 mtss\">' + origNameArr[1] + '</div>';
									} else {
										subSet.planDescHTML = '<h5>' + origName + '</h5>';
									}
								}

								$scope.vpd.phoneServices[i] = subSet;
							}

							// !!!!!!!!!!!!!!!!   THIS WILL REFLECT ON USER SELECTION !!!!!!!!!!!!!!!!!!!!!!
							$scope.vpd.phoneSelected = $scope.vpd.phoneServices[0];

							//for (var xx = 0; xx < $scope.vpd.phoneSelected.addOns.length; xx++){
							//	var aoT = $scope.vpd.phoneSelected.addOns[xx].addonTitle;
							//	var aoArr = aoT.split(' - ');
							//	$scope.vpd.phoneSelected.addOns[xx].addonTitle = aoArr[1] +' - '+ aoArr[2];
							//}

							$scope.formatDates();
						} else {
							$scope.loadingDataIndicator = false;
							$scope.displayContent = false;

							if (_tmp.result === 'fail') {
								holder = _tmp.data;
								$scope.errorMessage = 'Failed to load Wireless account data';

							} else if (_tmp.result === 'error') {
								// holder = _tmp.data;
								$scope.errorMessage = _tmp.message;

							} else {
								// Unknown state ???
							}
						}
					});
				};

				resource.onChanged(function () {
					$scope.lng = userLanguage() + '-CA';
					$scope.lang = userLanguage();
					$scope.monthsNames = resource.get('_months');
					$scope.getWirelessPrepaid();
					$scope.postToRogersUrls = [
						{url: '/web/myrogers/prepaidPricePlanChange', flowId: 'PPC'},
						{url: '/web/myrogers/prepaidUpdateWirelessEssential', flowId: 'UWE'},
						{url: '/web/myrogers/prepaidTopUp', flowId: 'TOP'},
						{url: '/web/myrogers/prepaidChangeWirelessNumber', flowId: 'TNC'},
						{url: '/web/myrogers/prepaidResetPasscode', flowId: 'PCR'}
					];
				}, $scope);
			}]);

'use strict';

function acceptDirective(){
  return {
    restrict: 'EA',
    templateUrl: 'rfr/js/directives/accept/accept.html',
    scope: {
      cancelAction: '&onCancel',
      acceptAction: '&onAccept'
    },
    link: {
      pre: function(scope, elem, attrs){
        scope.checkboxState = false;
        scope.checkBoxLabelText = attrs.checkboxTextRes;
        scope.acceptText = attrs.acceptTextRes;
        scope.cancelText = attrs.cancelTextRes;
        scope.isDisabled = (attrs.isDisabled == "true") ? true : false;
      }
    }
  };
}

angular.module('rfrApp').directive('accept',[acceptDirective]);

'use strict';

angular.module('rfrApp').directive('addressFormModal',[addressFormModalDirective]);

function addressFormModalDirective() {
  return {
    templateUrl: 'rfr/js/directives/addressFormModal/addressFormModal.html',
    restrict: 'EA',
    link: function postLink(scope, elem, attrs) {
      scope.closed = true;
      scope.close = function(){
        scope.closed = true;
      };
      scope.open = function() {
        scope.closed = false;
      };
    }
  };
}


'use strict';

angular.module('rfrApp').config(["$provide", function($provide) {
  $provide.decorator('daypickerDirective', ["$delegate", function($delegate) {
    var directive = $delegate[0];

    var compile = directive.compile;

    directive.compile = function(tElement, tAttrs) {
      var link = compile.apply(this, arguments);

      tElement
        .find('small')
        .html('{{label.abbr.slice(0,1)}}');

      tElement
        .find('thead>tr:nth-of-type(1)')
        .find('th:nth-of-type(1)')
        .attr('colspan', '2')
        .find('i')
        .removeClass('glyphicon glyphicon-chevron-left')
        .addClass('fa fa-caret-left datepicker-caret-scale-x');

      tElement
        .find('thead>tr:nth-of-type(1)')
        .find('th:nth-of-type(2)')
        .attr('colspan', '3');

      tElement
        .find('thead>tr:nth-of-type(1)')
        .find('th:nth-of-type(3)')
        .attr('colspan', '2')
        .find('i')
        .removeClass('glyphicon glyphicon-chevron-left')
        .addClass('fa fa-caret-right datepicker-caret-scale-x');


      return function(scope, elem, attrs) {
        link.apply(this, arguments);
        // We can extend the link function here
      };
    };

    return $delegate;
  }]);
}]);

'use strict';

function membershipInfoDirective(){
  return {
    templateUrl: 'rfr/js/directives/membershipInfo/membershipInfo.html'
  };
}

angular.module('rfrApp')
  .directive('membershipInfo',[membershipInfoDirective]);

'use strict';

function multiDatepickerDirective() {
  return {
    templateUrl: 'rfr/js/directives/multiDatepicker/multiDatepicker.html',
    link: function postLink(scope, element) {
      scope.mobileDisplay = matchMedia('(max-width: 767px)').matches;

      scope.datepickers = {
        fromDate: null,
        toDate: null
      };

      scope.formData = {
        requestFromDate: null,
        requestToDate: null,
        maxFromDate: null,
        minToDate: null
      };

      scope.formats = ['dd-MMMM-yyyy', 'MM/dd/yyyy', 'shortDate', 'MM/DD/YYYY'];
      scope.format = scope.formats[1];

      scope.$watch('formData.fromDate', function (v) {
        if (scope.mobileDisplay && v) {
          var minTo = new Date(v).toISOString().substr(0,10);
          element.find("[name='toDate']").prop("min", minTo);
        } else if (scope.mobileDisplay && !v) {
          element.find("[name='toDate']").removeAttr("min");
        } else {
         scope.formData.minToDate = v;
        }
      });

      scope.$watch('formData.toDate', function (v) {
        if (scope.mobileDisplay && v) {
          var maxFrom = new Date(v).toISOString().substr(0,10);
          element.find("[name='fromDate']").prop("max", maxFrom);
        } else if (scope.mobileDisplay && !v) {
          element.find("[name='fromDate']").removeAttr("max");
        } else {
          scope.formData.maxFromDate = v;
        }
      });

      scope.clear = function () {
        scope.formData.fromDate = null;
        scope.formData.toDate = null;
        scope.changeTransactionType({});
        scope.filterOption = "";
        scope.requestDateRange();
      };

      scope.open = function ($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        scope.datepickers[which] = true;
      };

      scope.requestDateRange = function () {
        this.formData.requestFromDate = this.formData.fromDate;
        this.formData.requestToDate = this.formData.toDate;
      };
    }
  };
}

angular.module('rfrApp').directive('multiDatepicker', [multiDatepickerDirective]);

'use strict';

angular.module('rfrApp').directive('myPoints', [
  '$state',
  'rfrUtilService',
  '$rootScope',
  '$window',
  myPointsDirective]);

function myPointsDirective($state,
                           rfrUtilService,
                           $rootScope,
                           $window) {
  return {
    templateUrl: 'rfr/js/directives/myPoints/myPoints.html',
    restrict: 'E',
    link: function (scope, elem, attrs) {
      //mobile safari fix for 'fixed'
      if(window.navigator.userAgent.match('iPhone') && window.location.hash.match('sidh')){
        elem.css('bottom', '64px');
      }
      var markup = '';
      scope.$watch(function () {
        return $rootScope.currentRewardsBalance;
      }, function () {
        var score = String($rootScope.currentRewardsBalance);
        markup = '';
        elem.find('.points').find('span').remove();
        angular.forEach(score, function (o, i) {
          markup += '<span>' + o + '</span>';
        });
        elem.find('.points').append(markup);
      });

      scope.goToWishlist = function () {
        $state.go('rewards.wishlist');
      };
      scope.goToMembership = function () {
        $state.go('rewards.membership');
      };
      scope.showMyPoints = function () {
        return rfrUtilService.isRfrAuthenticated() && rfrUtilService.isRfrEnrolled();
      };
    }
  };
}

'use strict';

function pointDialDirective() {
  return {
    templateUrl: 'rfr/js/directives/pointDial/pointDial.html',
    link: function ($scope, element, attrs) {
      $scope.getDialClass = function () {
        if ($scope.reward) {
          var percentageClass = 'red-percent';
          var percentage = ($scope.currentBalance / $scope.reward.points) * 100;
          if (percentage >= 100) {
            percentageClass = 'green-percent';

          } else if (percentage > 50) {
            percentageClass = 'yellow-percent';
          }
          return percentageClass;
        }
      };
      $scope.getProgressPercentage = function () {
        if ($scope.reward) {
          var ratio = Math.round(($scope.currentBalance / $scope.reward.points) * 100);
          var result = 0;
          if(ratio > 100){
            result = 100;
          } else if(ratio > 90 && ratio < 100) {
            result = 97;
          } else {
            result = Math.round(ratio / 10) * 10 || 3;//if 0 adjust to 3 so the dial displays properly
          }
          //if 0 or 1 or 2 adjust to 3 so the dial displays properly
          return (result === 0 || result === 1 || result === 2)? 3 : result;
        }
      };
    }
  };
}

angular.module('rfrApp')
  .directive('pointDial', pointDialDirective);


'use strict';

function rewardCardDirective() {
    return {
      scope: {
        reward: '=rewardCard',
        'bundleId':'@'
      },
        templateUrl: 'rfr/js/directives/rewardCard/rewardCard.html',
        controller: rewardCardController,
        restrict: 'EA'
    };
}

angular.module('rfrApp').directive('rewardCard', rewardCardDirective);


'use strict';

function rewardCardInfoBoxDirective(rfrUtilService, $state) {
  return {
    templateUrl: 'rfr/js/directives/rewardCardInfoBox/rewardCardInfoBox.html',
    restrict: 'EA',
    link: function postLink(scope, elem, attrs) {
      scope.largeDial = $state.includes('rewards.redeem');
      scope.loggedInOnly = rfrUtilService.isRfrAuthenticated();
      scope.enrolled = rfrUtilService.isRfrEnrolled();
      scope.displayOutOfStockMessage = function(){
        return scope.reward && (scope.reward.quantityRemaining === 0);
      };
    }
  };
}

angular.module('rfrApp').directive('rewardCardInfoBox',['rfrUtilService', '$state', rewardCardInfoBoxDirective]);

'use strict';

/**
 * @ngdoc directive
 * @name totesApp.directive:rewardsFooter
 * @description
 * # rewardsFooter
 */
angular.module('rfrApp')
  .directive('rewardsFooter', ["$window", "$rootScope", "resource", function ($window, $rootScope, resource) {
    return {
      scope: {'splitView':'@', 'earnBanner':'=', 'lang':'='},
      templateUrl: 'rfr/js/directives/rewardsFooter/rewardsFooter.html',
      restrict: 'E',
      link: function postLink(scope, element, attrs) {

        var popupWidth = 1200,
          popupHeight=600,popupTop=800,popupLeft=650;

        scope.openChatPopup = function() {
          $window.open('http://www.rogershelp.com/customerserv/livechatsupport/index.php?source=30',
            'new_window', 'width=' + popupWidth + ',height=' + popupHeight + ',top=' + popupTop + ',left=' + popupLeft);
        };
      }
    };
  }]);

'use strict';

angular.module('rfrApp')
  .directive('rewardsSubMenu', [
    'resource',
    '$state',
    '$rootScope',
    rewardsSubMenuDirective]);

function rewardsSubMenuDirective(resource, $state, $rootScope) {
  return {
    templateUrl: 'rfr/js/directives/rewardsSubMenu/rewardsSubMenu.html',
    restrict: 'E',
    replace: true,
    link: function postLink(scope, element, attrs) {

      scope.hideBreadCrumbsMenu = false;

      scope.closeMenu = function () {
        scope.toggleMainPlusMinus = false;
      };
      scope.navMainMenuClick = function ($event) {
        scope.toggleMainPlusMinus = !scope.toggleMainPlusMinus;
      };

      scope.state = $state;

      $rootScope.updateMenuLinks = function () {

        //scope.currentMenu = menuLinks[scope.$state.current.name];
        var currentMenuBreadcrumbs = location.hash.split('/');
        //ignring first two parts of the hash # and rewards
        scope.currentMenu = {};
        scope.hideBreadCrumbsMenu = false;

        if (currentMenuBreadcrumbs[2] === 'membership' || currentMenuBreadcrumbs[2] === 'membership#transactions') {
          scope.currentMenu.primary = resource.get('rewards_redeem');
          scope.currentMenu.primaryUrl =  '#/rewards/browse';
          //scope.currentMenu.secondary = resource.get('submenu_earn');
          //scope.currentMenu.secondaryUrl = '#/rewards/earn';
        } else if (currentMenuBreadcrumbs[2] === 'transactions') {
          scope.currentMenu.primary = resource.get('transactions');
          scope.currentMenu.primaryUrl = '#/rewards/membership#transactions';
          scope.currentMenu.secondary = null;
        } else if (currentMenuBreadcrumbs[2] === 'browse') {
          scope.currentMenu.primary = (currentMenuBreadcrumbs[2]) ? resource.get(currentMenuBreadcrumbs[2]) : null;
          scope.currentMenu.primaryUrl = (scope.currentMenu.primary) ? '#/rewards/' + currentMenuBreadcrumbs[2] : '';
          scope.currentMenu.secondary = (currentMenuBreadcrumbs[3] && $rootScope.currentSelectedCategoryName) ? $rootScope.currentSelectedCategoryName : null;
        } else if (currentMenuBreadcrumbs[2] === 'redeem' || currentMenuBreadcrumbs[2] === 'wishlist') {
          scope.currentMenu.primary = resource.get('browse');
          scope.currentMenu.primaryUrl = '#/rewards/browse';
          scope.currentMenu.secondary = resource.get(currentMenuBreadcrumbs[2]);
        } else {
          scope.currentMenu.primary = (currentMenuBreadcrumbs[2]) ? resource.get(currentMenuBreadcrumbs[2]) : null;
          scope.currentMenu.primaryUrl = (scope.currentMenu.primary) ? '#/rewards/' + currentMenuBreadcrumbs[2] : '';
          scope.currentMenu.secondary = (currentMenuBreadcrumbs[3] && currentMenuBreadcrumbs[2] != 'redeem') ? resource.get(currentMenuBreadcrumbs[3]) : null;
        }
      };

      $rootScope.updateMenuLinks();

      scope.$on('$locationChangeSuccess', function () {
        $rootScope.updateMenuLinks();
      });

      scope.$on('resourceChanged', function () {
        $rootScope.updateMenuLinks();
      });

      scope.showEnrollLink = function () {
        return $state.is('rewards.earn') && $rootScope.membershipDetail.eligible && $rootScope.membershipDetail.statusCode !== 'A';
      };

      scope.navHandle = function(state) {
        $state.go(state);
        scope.toggleMainPlusMinus = !scope.toggleMainPlusMinus;
      };

    }
  };
}

'use strict';

angular.module('rfrApp')
  .directive('rfrModal', ["resource", "$state", "$rootScope", "$location", "userLanguage", function (resource,
                                   $state,
                                   $rootScope,
                                   $location,
                                   userLanguage) {
    return {
      templateUrl: 'rfr/js/directives/rfrModal/rfrModal.html',
      restrict: 'E',
      replace: true,
      link: function postLink(scope, element, attrs) {

        scope.modalInstance = $(element);
        scope.user = $rootScope.user;
        scope.rfrModalTitle = "-";
        scope.rfrModalContentGn = "-";

        var closeView = function(){
          var doCheck = checkPhone();
          mobileInterface(doCheck.device, '');
          closeSecondaryWebView(doCheck.device);
        };

        scope.okModal = function () {
          if(window.location.hash.match('sidh')){
            closeView();
          } else {
          location.href = "/consumer/home";
          //this.modalInstance.hide();
          }
        };
        scope.cancelModal = function () {
          if(window.location.hash.match('sidh')){
            closeView();
          } else {
            location.href = "/consumer/home";
            //this.modalInstance.hide();
          }
        };

        var checkModalPopup = function () {
          //Check if we need to show any modals
          if(scope.user.isAuthenticated &&
            scope.membershipDetail &&
            scope.membershipDetail.statusCode === 'N' &&
              scope.membershipDetail.eligible &&
            !scope.membershipDetail.targeted ){
            if(userLanguage() == 'fr'){
              scope.rfrModalContentGn = (scope.cmsContent['rfr.error.nontargeted']) ?
                scope.cmsContent['rfr.error.nontargeted']['frenchMessage'] : '-';
            } else {
              scope.rfrModalContentGn = (scope.cmsContent['rfr.error.nontargeted']) ?
                scope.cmsContent['rfr.error.nontargeted']['englishMessage'] : '-';
            }
            scope.modalInstance.show();
          }
          else if (scope.user.isAuthenticated && scope.membershipDetail &&
            (!scope.membershipDetail.eligible && scope.membershipDetail.statusCode != 'P')) {
            if (userLanguage() == 'fr') {
              scope.rfrModalContentGn = (scope.cmsContent['rfr.error.notEligilbleToEnroll']) ?
                scope.cmsContent['rfr.error.notEligilbleToEnroll']['frenchMessage'] : '-';
            } else {
              scope.rfrModalContentGn = (scope.cmsContent['rfr.error.notEligilbleToEnroll']) ?
                scope.cmsContent['rfr.error.notEligilbleToEnroll']['englishMessage'] : '-';
            }
            scope.modalInstance.show();
          }

          else if (scope.user.isAuthenticated && scope.membershipDetail && ( (scope.membershipDetail.statusCode == 'B' ||
            scope.membershipDetail.statusCode == 'F') ||
            ( !scope.membershipDetail.eligible && scope.membershipDetail.statusCode == 'N') )
          ) {


            scope.rfrModalTitle = '';//resource.get('link_account_title');

            if (scope.membershipDetail.statusCode == 'F') {
              if (userLanguage() == 'fr') {
                scope.rfrModalContentGn = (scope.cmsContent['rfr.error.fraud']) ?
                  scope.cmsContent['rfr.error.fraud']['frenchMessage'] : '-';
              }
              if (userLanguage() == 'en') {
                scope.rfrModalContentGn = (scope.cmsContent['rfr.error.fraud']) ?
                  scope.cmsContent['rfr.error.fraud']['englishMessage'] : '-';
              }
            } else if (scope.membershipDetail.statusCode == 'B') {
              if (userLanguage() == 'fr') {
                scope.rfrModalContentGn = (scope.cmsContent['rfr.error.blocked']) ?
                  scope.cmsContent['rfr.error.blocked']['frenchMessage'] : '-';
              }
              if (userLanguage() == 'en') {
                scope.rfrModalContentGn = (scope.cmsContent['rfr.error.blocked']) ?
                  scope.cmsContent['rfr.error.blocked']['englishMessage'] : '-';
              }
            } else if (!scope.membershipDetail.eligible && scope.membershipDetail.statusCode == 'N') {
              if (userLanguage() == 'fr') {
                scope.rfrModalContentGn = (scope.cmsContent['rfr.error.notEligilbleToEnroll']) ?
                  scope.cmsContent['rfr.error.notEligilbleToEnroll']['frenchMessage'] : '-';
              }
              if (userLanguage() == 'en') {
                scope.rfrModalContentGn = (scope.cmsContent['rfr.error.notEligilbleToEnroll']) ?
                  scope.cmsContent['rfr.error.notEligilbleToEnroll']['englishMessage'] : '-';
              }
            } else {
              if (userLanguage() == 'fr') {
                scope.rfrModalContentGn = (scope.cmsContent['rfr.error.Generic']) ?
                  scope.cmsContent['rfr.error.Generic']['frenchMessage'] : '-';
              }
              if (userLanguage() == 'en') {
                scope.rfrModalContentGn = (scope.cmsContent['rfr.error.Generic']) ?
                  scope.cmsContent['rfr.error.Generic']['englishMessage'] : '-';
              }
            }

            scope.modalInstance.show();
          } else if ($state.current.name == 'noaccount') {
            if (userLanguage() == 'fr') {
              scope.rfrModalContentGn = (scope.cmsContent['rfr.error.noAccounts']) ?
                scope.cmsContent['rfr.error.noAccounts']['frenchMessage'] : '-';
            }
            if (userLanguage() == 'en') {
              scope.rfrModalContentGn = (scope.cmsContent['rfr.error.noAccounts']) ?
                scope.cmsContent['rfr.error.noAccounts']['englishMessage'] : '-';
            }
            scope.modalInstance.show();
          }
        };

        checkModalPopup();

        scope.$on('$routeChangeSuccess', function () {
          checkModalPopup();
        });

      }
    };
  }]);

'use strict';
angular.module('rfrApp')
  .directive('rfrPopover', function () {
    return {
      templateUrl: 'rfr/js/directives/rfrPopover/rfrPopover.html',
      restrict: 'A',
      scope: {
        content: '@rfrPopover'
      },
      transclude: true,
      link: function postLink(scope, element, attrs) {
        scope.popoverVisible = false;
        element.on('click', function(){
          scope.popoverVisible = !scope.popoverVisible;
        });
      }
    }
  });

'use strict';
angular.module('rfrApp').directive('ruiDropdown', [
  '$rootScope',
  'resource',
  '$filter',
  ruiDropdownDirective]);

function ruiDropdownDirective(
  $rootScope, resource,$filter){
  return {
    restrict: 'EA',
    require: '?ngModel',
    templateUrl: 'rfr/js/directives/ruiDropdown/ruiDropdown.html',
    scope: {
      placeholder: '@',
      list: '=',
      selected: '=',
      selectAction: '&',
      property: '@',
      additional: '@',
      prefix: '@',
      useres: '@',
      filter: '@',
      listenForLanguageChange: '@'
    },
    link: function(scope, element, attrs, ngModel) {
      scope.listVisible = false;
      scope.isPlaceholder = true;
      scope.element = element;

      scope.select = function(item) {
        scope.isPlaceholder = false;
        if(scope.useres === 'true'){
          scope.selected = resource.get(item.name);
        } else {
          scope.selected = item;
        }
        scope.selectAction({item:item});
        scope.hide();
      };

      scope.isSelected = function(item) {
        if(scope.useres && scope.selected){
          return resource.get(item[scope.property]) === scope.selected;
        } else if(scope.selected) {
          return item[scope.property] === scope.selected[scope.property];
        } else {
          return false;
        }
      };

      scope.toggle = function() {
          scope.listVisible = !scope.listVisible;
        scope.$root.$broadcast('closeDropdown', scope.$id);
      };

      scope.hide = function() {
        scope.listVisible = false;
      };

      $rootScope.$on('documentClicked', function(inner, target) {
        if (!$(target[0]).is('.dropdown-display.clicked-add') && !$(target[0]).parents('.dropdown-display.clicked-add').length > 0) {
          scope.listVisible = false;
        }
      });

      $rootScope.$on('loginSecurityQuestionsChanged', function (event, question) {
        if (scope.listenForLanguageChange == "true") scope.display = question.label;
      });

      scope.$on('closeDropdown', function(event,id){
        if(scope.$id !== id){
          scope.hide();
        }
      });

      scope.$on('schemaFormValidate', function(){
        scope.validateDropdown();
      });

      scope.validateDropdown = function(){
        if(scope.selected.value === '?'){
          scope.element.addClass('ng-invalid-province-select ng-invalid ng-dirty').removeClass('ng-valid-province-select ng-valid');
        } else {
          scope.element.addClass('ng-valid-province-select ng-valid ng-dirty').removeClass('ng-invalid-province-select ng-invalid');
        }
      };

      scope.getValue = function(item,property){
        return (property !== undefined ? item[property] : item);
      };

      scope.useFilter = function(name,value){
        return $filter(name)(value);
      };

      scope.$watch('selected', function(value) {
        scope.isPlaceholder = scope.selected === '' && scope.selected[scope.property] === undefined;

        if(!$.isEmptyObject(value)){
          if (ngModel) {
            if(scope.element.hasClass('ng-dirty')){
              scope.validateDropdown();
            }
          }

          if(scope.useres === 'true'){
            scope.display = scope.selected;
          } else {
            scope.display = (scope.prefix ? scope.prefix: '') +
              scope.selected[scope.property] +
              (scope.additional && !!scope.selected[scope.additional] ? scope.selected[scope.additional]: '');
          }
        }
      });
    }
  };
}

'use strict';

function sectionHeaderDirective(){
  return {
    scope: true,
    templateUrl:'rfr/js/directives/sectionHeader/sectionHeader.html',
    priority: 101,
    link: {
      pre: function postLink(scope, elem, attrs){
        scope.headerCopy = attrs.headerCopy;
        scope.loaderEnabled = attrs.loaderEnabled;
        scope.loaderHide = attrs.loaderHide;
        scope.getHeaderStyle = function(){
          if(elem.find('.big-header-ctn').height() > 100){
            elem.find('h1.big-header').addClass('double');
          }
        };
      }
    }
  };
}

angular.module('rfrApp').directive('sectionHeader',[sectionHeaderDirective]);

'use strict';

function signInOrRegisterDirective(){
  return {
    templateUrl: 'rfr/js/directives/signInOrRegister/signInOrRegister.html'
  };
}

angular.module('rfrApp').directive('signInOrRegister', [signInOrRegisterDirective]);

'use strict';

function singleDatepickerDirective(deviceActivationDateService) {
  return {
    templateUrl: 'rfr/js/directives/singleDatepicker/singleDatepicker.html',
    link: function postLink(scope, element) {
      scope.mobileDisplay = matchMedia('(max-width: 767px)').matches;

      scope.$watch('date.deviceActivationDate', function () {
        deviceActivationDateService.setActivationDate(scope.date.deviceActivationDate);
      });

      scope.isOpen = {
        open: false
      };
      scope.minDate = moment();

      scope.formData = {
        requestDate: moment()
      };

      scope.formats = ['dd-MMMM-yyyy', 'MM/dd/yyyy', 'shortDate', 'MM/DD/YYYY'];
      scope.format = scope.formats[1];

      scope.today = function () {
        if (scope.mobileDisplay) {
          scope.date.deviceActivationDate = new Date();
        } else {
          scope.date.deviceActivationDate = moment().format(scope.formats[3]);
        }
      };
      scope.today();

      scope.showWeeks = true;
      scope.toggleWeeks = function () {
        scope.showWeeks = !scope.showWeeks;
      };

      scope.clear = function () {
        scope.fromDate = null;
        scope.date.deviceActivationDate = null;
      };

      // Disable weekend selection
      scope.disabled = function (date, mode) {
        return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
      };

      scope.open = function ($event) {
        if (!scope.mobileDisplay) {
          $event.preventDefault();
          $event.stopPropagation();
          scope.isOpen.open = true;
        }
      };
    }
  };
}

angular.module('rfrApp').directive('singleDatepicker', ['deviceActivationDateService', singleDatepickerDirective]);

'use strict';

function transactionsGridDirective(){
  return {
    templateUrl: 'rfr/js/directives/transactionsGrid/transactionsGrid.html',
    controller: transactionsGridCtrl
  };
}

angular.module('rfrApp').directive('transactionsGrid', [transactionsGridDirective]);

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrTempPasswordController', TempPasswordController);

  TempPasswordController.$inject = ['$rootScope', '$scope', 'resource', 'userLanguage', 'user', 'appState', '$sce', 'myrForgetPasswordService', '$browser', 'localStorage', 'errorHandler', 'ajax', 'landing', '$window'];

  /* @ngInject */
  function TempPasswordController($rootScope, $scope, resource, userLanguage, user, appState, $sce, forgetPasswordService, $browser, localStorage, errorHandler, ajax, landing, $window) {
    $scope.$extend({
      regObj: {
        lang: userLanguage(),
        tempPassword: '',
        password: '',
        confirmPassword: ''
      },
      tooltipTempPassword: $sce.trustAsHtml(resource.get('temp_password_temp_pass_field_tooltip')),
      tooltipPassword: $sce.trustAsHtml(resource.get('registration_tooltip')),
      form: $scope.form,

      submit: function () {
        $scope.form.tempPassword.$setValidity('invalidPassword', true);
        if ($scope.form.$valid) {
//          $rootScope.$broadcast('showGlobalLoader');

          $scope.errorSummary = null;
          updateMessage();

          user.tempPassword(forgetPasswordService.getUsername(),
            $scope.regObj.tempPassword,
            $scope.regObj.password,
            $scope.regObj.confirmPassword,
            forgetPasswordService.getSmtoken(),
            forgetPasswordService.getSmauthreason(),
            forgetPasswordService.getSmagentname()).then(
            function (isLoggedIn) {
              if (isLoggedIn) {
              ajax.notifyServerDiscardRBSSSessionId().then(
               function (rbssCookieDiscardData) {
                 if (rbssCookieDiscardData == 'RBSS_ADMIN') {
                     $window.document.cookie = 'RBSS_ADMIN=' + "RBSS_ADMIN" + ';domain=' +'.rogers.com' + ';path=' + '/';
                     $window.location.href = '../../../business/ss/loginSuccess';
                 } else {
                    // notify server - log in
                    $window.document.cookie = 'RBSS_ADMIN=' + "UTE" + ';domain=' +'.rogers.com' + ';path=' + '/';
                    ajax.notifyServerLoggedIn().then(
                      function () {
                        $browser.cookies('userToken', forgetPasswordService.getUsername());
                        localStorage.setLocalStorageValue('successMessage', 'login_reset_success');
                        tagResetPassword();
                        appState.noLinking = false;
                        $rootScope.user.isAuthenticated = true;
    //                    $rootScope.$broadcast('hideGlobalLoader');
                        landing.localPostSignin();
                      }
                    );
                 }
              });
              } else {
                var browserCookies = $browser.cookies();
                var smtryno = "";
                if($browser.cookies().R1IDSMTRYNO){
                 smtryno = $browser.cookies().R1IDSMTRYNO
                }else{
                 smtryno = $browser.cookies().SMTRYNO
                }
                var smusernotfound = browserCookies.SM_USERNOTFOUND;

                if (!!smtryno || !!smusernotfound) {
                  $scope.errorSummary = '_check_form_errors';
                  updateMessage();
                  $scope.form.tempPassword.$setValidity('invalidPassword', false);
                  tagError($scope.errorSummary);
                } else {
                  $scope.errorSummary = 'maintenance_info';
                  updateMessage();
                  tagError($scope.errorSummary);
                }
//                $rootScope.$broadcast('hideGlobalLoader');
              }
            }, function (error) {
              // $cookies.userToken = undefined;
              $browser.cookies('userToken', undefined);			//!!!!! This will DELETE the cookie
              $scope.errorSummary = errorHandler.getErrorDescription(error);
              tagError($scope.errorSummary);
//              $rootScope.$broadcast('hideGlobalLoader');
            }
          );
        } else {
          $scope.errorSummary = '_check_form_errors';
          updateMessage();
        }
      },
      cancel: function () {
      },
      errorMessage: null,
      errorSummary: null
    });

    function updateMessage() {
      if (!$scope.errorSummary) {
        $scope.errorMessage = '';
        return;
      }
      $scope.errorMessage = resource.get($scope.errorSummary);
    }

    $scope.$watch($scope.errorSummary, function () {
      if (!$scope.errorSummary) {
        return;
      }
      $scope.errorMessage = resource.get($scope.errorSummary);
    });

    $scope.$watch('form.$valid', function (newVal) {
      $scope.errorSummary = (newVal) ? null : $scope.errorSummary;
    });

    resource.onChanged(function () {
      $scope.questions = resource.get('login_security_questions');
      $scope.tooltipTempPassword = resource.get('temp_password_temp_pass_field_tooltip');
      $scope.tooltipPassword = resource.get('registration_tooltip');
      updateMessage();
    }, $scope);

    function tagTempPassword() {
      appState.tagging([
        '_trackPageView',
        {pn: 'home:reset-password:new-password'}
      ]);
    }

    function tagResetPassword() {
      appState.tagging([
        '_trackLink',
        {prop13: 'D=v13'},
        {eVar13: 'MyRogers - Forgot Password'},
        {event6: ''}
      ]);
    }

    function tagError(message) {
      appState.tagging([
        '_trackLink',
        {eVar49: message},
        {event15: ''}
      ]);
    }

    tagTempPassword();
  }

  angular.module('totesApp').directive('customTrim', function(){

    return {
      restrict:'A',
      require:'ngModel',
      link: function(scope, element, attrs, ngModelCtrl) {
        element.on('blur', function() {
          element.val($.trim(element.val()));
          ngModelCtrl.$setViewValue(element.val());
          scope.regObj.tempPassword = element.val();
          scope.form.tempPassword.$setValidity('invalidPassword', true);
        })

      }

    }
  })

})();

//https://github.com/fraywing/textAngular/issues/503
// The checkbox and radio buttons does not work properly when we use both angular-touch and bootstrap modal in mobile devices (iOS), so the following directive was added to prevent touch event in modals
angular.module('totesApp').directive('bfaStopEvent', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      element.on(attr.bfaStopEvent, function (e) {
        e.stopPropagation();
        console.log('bfaStopEvent' ,attr);
      });
    }
  };
});

(function () {
    'use strict';

    angular.module('totesApp').service('bfappcWirelessDashboardService', bfappcWirelessDashboardService);

    bfappcWirelessDashboardService.$inject = ['$q', '$state', '$modal', 'ajax', 'resource', 'localStorage', 'pricePlanChangesErrors', 'myrWirelessDashboardService', 'sessionStorage', '$rootScope'];

    function bfappcWirelessDashboardService($q, $state, $modal, ajax, resource, localStorage, pricePlanChangesErrors, myrWirelessDashboardService, sessionStorage, $rootScope) {
        var self = {
            scope: {},
            fetchOrderCompleted: false,
            bfappcOrders: [],
            brtSwitch: {
                ppc: null,
                mppc: null,
                q2ppc: null,
                ppcRateCard: null
            },
            permission: {
                ppc: null,
                mppc: null,
                ppcRateCard: null
            },
            subscribers: null,
            selectedAdditionalSubscribers: [],
            selectedPrimary: '',
            changeBtnLoadingStatus: false
        };

        self.hasOrder = function (ctn) {
            return self.bfappcOrders.length > 0 && self.getSwitchToOrder(ctn);
        };

        self.getCurrentOrder = function (ctn) {
            return _.find(self.bfappcOrders, function (order) {
                return order.currentOrder === true && _.indexOf(order.assemblyIds, ctn) >= 0;
            });
        };

        self.getSwitchToOrder = function (ctn) {
            return _.find(self.bfappcOrders, function (order) {
                return _.find(order.assemblyIds, function (assemblyId) {
                    return assemblyId == ctn;
                });
            });
        };

        self.isFetchOrderCompleted = function () {
            return self.fetchOrderCompleted;
        };

        self.fetchOrder = function () {
            //console.info('fetchOrder');
            ajax.fetchOrder().then(
                function (response) {
                    self.fetchOrderCompleted = true;
                    if (response && response.success) {
                        self.fetchOrderFullResponse = response;
                        if (response.ppc && response.ppc.length) {
                            self.bfappcOrders = response.ppc;
                        }
                    } else {
                        // PPC TODO: error message on fetch error
                    }
                }
            ).catch(
                function () {
                    self.fetchOrderCompleted = true;
                    // PPC TODO: error message on fetch error
                }
            );
        };

        self.gotoBFAPPC = function ($scope, resumeOrder) {
            var deferred = $q.defer();
            self.scope = $scope;
            self.isBRT('ppc').then(function (brtSwitch) {
                if (!brtSwitch) {
                    self.processAllowedPpcBrt(deferred, resumeOrder);
                } else {
                    self.hasPermission('ppc').then(function (permission) {
                        if (!permission) {
                            // goto q2ppc
                            self.isBRT('q2ppc').then(
                                function (q2PpcBrtSwitch) {
                                    deferred.reject(q2PpcBrtSwitch);
                                }
                            );
                        } else {
                            self.processAllowedPpcBrt(deferred, resumeOrder);
                        }
                    });
                }
            });
            return deferred.promise;
        };

        self.processAllowedPpcBrt = function (deferred, resumeOrder) {
            self.hasMultipleSubscribers().then(
                function (hasMultipleSubscribers) {
                    if (!hasMultipleSubscribers) {
                        deferred.resolve();
                        self.checkEligibilityAndSaveState('single', 'all').then(function () {
                            $state.go('ppc-singleline');
                        });
                    } else {
                        self.isBRT('mppc').then(function (brtSwitch) {
                            if (!brtSwitch) {
                                //go to multi line entries
                                self.redirectToPpc(resumeOrder);
                            } else {
                                self.hasPermission('mppc').then(function (permission) {
                                    deferred.resolve();
                                    if (!permission) {
                                        //TODO: display a generic message, will be provided by Andreea
                                        self.isMultiline().then(
                                            function (isMultiline) {
                                                if (isMultiline) {
                                                    pricePlanChangesErrors.showError('', resource.get('mppc_on_brt_no_permission_text'), ['OK'], null, true);
                                                    self.changeBtnLoading(false);
                                                    deferred.resolve();
                                                } else {
                                                    self.hasMainSubscriber().then(function (hasMain) {
                                                        if (hasMain) {
                                                            self.checkEligibilityAndSaveState('single', 'individual').then(function () {
                                                                $state.go('ppc-singleline');
                                                            });
                                                        } else {
                                                            self.checkEligibilityAndSaveState('single', 'all').then(function () {
                                                                $state.go('ppc-singleline');
                                                            });
                                                        }
                                                    });

                                                }
                                            }
                                        );
                                    } else {
                                        //go to multi line entries
                                        self.redirectToPpc(resumeOrder);
                                    }
                                });
                            }
                        });
                    }
                }
            );
        };

        self.isMultiline = function () {
            var deferred = $q.defer();
            // Abdellatif said, if there is an additional subscriber, it is multiline, no matter what the current ctn is
            self.getSubscribers().then(
                function (subscribers) {
                    var isMultiline = _.filter(subscribers, function (subscriber) {
                        return subscriber.familyShareStatus === 'Additional';
                    }).length > 0;
                    deferred.resolve(isMultiline);
                },
                function () {
                    deferred.reject();
                }
            );
            return deferred.promise;
        };

        self.hasMainSubscriber = function () {
            var deferred = $q.defer();
            self.getSubscribers().then(
                function (subscribers) {
                    var hasMain = _.filter(subscribers, function (subscriber) {
                        return subscriber.familyShareStatus === 'Main';
                    }).length > 0;
                    deferred.resolve(hasMain);
                },
                function () {
                    deferred.reject();
                }
            );
            return deferred.promise;
        };

        self.hasMultipleSubscribers = function () {
            var deferred = $q.defer();
            self.getSubscribers().then(
                function (subscribers) {
                    deferred.resolve(subscribers.length > 1);
                },
                function () {
                    deferred.reject();
                }
            );
            return deferred.promise;
        };

        self.isBRT = function (type) {
            var deferred = $q.defer();
            if (self.brtSwitch[type] !== null) {
                deferred.resolve(self.brtSwitch[type]);
            } else {
                ajax.getBrtSwitches().then(
                    function (response) {
                        // keep the value for PPC_UTE switch, if true means q2PPC(old PPC) is on the BRT mode.
                        self.brtSwitch.q2ppc = Boolean(_.result(_.find(response, function (obj) {
                            return obj.id === 'BSS_PPC_UTE';
                        }), 'switchIsOn'));

                        self.brtSwitch.ppc = Boolean(_.result(_.find(response, function (obj) {
                            return obj.id === 'BSS_NPPC_UTE';
                        }), 'switchIsOn'));

                        self.brtSwitch.mppc = Boolean(_.result(_.find(response, function (obj) {
                            return obj.id === 'BSS_MULTI_NPPC_UTE';
                        }), 'switchIsOn'));

                        self.brtSwitch.ppcRateCard = Boolean(_.result(_.find(response, function (obj) {
                            return obj.id === 'SMB_PPC_REDESIGN';
                        }), 'switchIsOn'));

                        deferred.resolve(self.brtSwitch[type]);
                    },
                    function () {
                        pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], null, true);
                        self.changeBtnLoading(false);
                        deferred.reject();
                    }
                );
            }
            return deferred.promise;
        };

        self.hasPermission = function (type) {
            var deferred = $q.defer();
            if (self.permission[type] !== null) {
                deferred.resolve(self.permission[type]);
            } else {
                ajax.getPermissions().then(
                    function (response) {
                        self.permission.ppc = false;
                        self.permission.mppc = false;

                        if (response && response.permissions && Array.isArray(response.permissions)) {
                            self.permission.ppc = response.permissions.some(function (elem) {
                                return elem.permission === 'BSS_NPPC_UTE_PAGE_VIEW';
                            });

                            self.permission.mppc = response.permissions.some(function (elem) {
                                return elem.permission === 'BSS_MULTI_NPPC_UTE_PAGE_VIEW';
                            });

                            self.permission.ppcRateCard = response.permissions.some(function (elem) {
                                return elem.permission === 'SMB_PPC_REDESIGN';
                            });
                        }
                        deferred.resolve(self.permission[type]);
                    },
                    function () {
                        pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], null, true);
                        self.changeBtnLoading(false);
                        deferred.reject();
                    }
                );
            }

            return deferred.promise;
        };



        self.isEligible = function (flowType) {
            var deferred = $q.defer();
            var postData = {
                accountNumber: ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber'),
                accountTypeNumber: ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('accountTypeNumber') : localStorage.getLocalStorageValue('accountTypeNumber'),
                subscriberNumber: ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber'),
                consolidatedInd: 'NO',
                flowType: flowType,
                applicationId: 'SMB'
            };
            if (self.selectedPrimary != '' && self.selectedPrimary != null) {
                postData.subscriberNumber = self.selectedPrimary;
            }
            self.changeBtnLoading(true);
            ajax.checkEligibility(postData).then(
                function (response) {
                    self.scope.appStateForPPC.eligibilityChecked = response.eligible;
                    self.scope.appStateForPPC.availableCreditAmount = response.availableCreditAmount;

                    if (response.eligible) {
                        self.changeBtnLoading(false);
                        deferred.resolve();
                    } else {
                        pricePlanChangesErrors.showError(resource.get('ppc_not_eligible_title'), resource.get('ppccode_sub_pending_ppc_order'), ['Continue'], null, true);
                        self.changeBtnLoading(false);
                        deferred.reject();
                    }
                },
                function (response) {
                    if (response && response.eligibilityCode) {
                        pricePlanChangesErrors.showError(resource.get('ppc_not_eligible_title'), resource.get('ppccode_500'), ['Continue'], null, true);

                    } else {
                        pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], null, true);
                        //Temporary fix
                        //deferred.resolve();
                    }
                    self.changeBtnLoading(false);
                    deferred.reject();
                }
            ).finally(
                function () {
                    self.selectedPrimary = null;
                }
            );
            return deferred.promise;
        };



        self.saveState = function (filterOption) {
            filterOption = filterOption || 'all';
            self.scope.appStateForPPC.ban = ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber');
            self.scope.appStateForPPC.ctnWirelessDashboard = ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber');
            if (self.selectedPrimary != '' && self.selectedPrimary != null) {
                self.scope.appStateForPPC.ctn = self.selectedPrimary;
            } else {
                self.scope.appStateForPPC.ctn = self.scope.appStateForPPC.ctnWirelessDashboard;
            }
            self.scope.appStateForPPC.accountTypeNumber = ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('accountTypeNumber') : localStorage.getLocalStorageValue('accountTypeNumber');
            self.scope.appStateForPPC.selectedAdditionalSubscribers = self.selectedAdditionalSubscribers.join(',');

            self.scope.appStateForPPC.ctnList = _.pluck(myrWirelessDashboardService.getWirelessDashData(), 'ctn');
            self.scope.appStateForPPC.filterOption = filterOption;
            return ajax.setState(self.scope.appStateForPPC);
        };

        self.getSubscribers = function () {
            var deferred = $q.defer();
            var postData = {
                accountNumber: ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber'),
                applicationId: 'SMB'
            };
            if (self.subscribers !== null) {
                deferred.resolve(self.subscribers);
            } else {
                ajax.subscribers(postData).then(
                    function (response) {
                        self.subscribers = response.subscribers;
                        deferred.resolve(response.subscribers);
                    },
                    function () {
                        pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], null, true);
                        self.changeBtnLoading(false);
                        deferred.reject();
                    }
                );
            }
            return deferred.promise;
        };

        self.redirectToPpc = function (resumeOrder) {
            if (resumeOrder) {
                self.scope.appStateForPPC.eligibilityChecked = false;
                self.saveState().then(
                    function () {
                        $state.go('ppc-resume-order');
                    }
                );
                return;
            }

            //if mainSubscriber is undefined it means there is no shared group
            var mainSubscriber = _.find(self.subscribers, function (subscriber) {
                return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Main';
            });

            var currentCtnShareStatus = _.result(_.find(self.subscribers, function (subscriber) {
                return subscriber.subscriberNumber === (($rootScope.isCare) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber'));
            }), 'familyShareStatus');

            var numberOfAdditionalSubscribers = 0;
            var numberOfIndividualSubscribers = 0;
            angular.forEach(self.subscribers, function (subscriber) {
              if (subscriber.status === 'Active' && subscriber.familyShareStatus === 'Additional') {
                numberOfAdditionalSubscribers++;
              }
              if (subscriber.status === 'Active' && subscriber.familyShareStatus === 'Individual') {
                numberOfIndividualSubscribers++;
              }
            });

            if (mainSubscriber != undefined) {
              // below cases are defined in BFA-1911

              if (numberOfAdditionalSubscribers == 0 && currentCtnShareStatus == 'Main') {
                // if there is only 1 subscriber and it is 'main', user must be directed to single line NOT multi line
                self.checkEligibilityAndSaveState('single', 'all').then(function () {
                  $state.go('ppc-singleline');
                });
              } else if (currentCtnShareStatus == 'Additional') {
                self.isEligible('multi').then(function () {
                  self.selectedPrimary = mainSubscriber.subscriberNumber;
                  self.checkEligibilityAndSaveState('multi', 'main').then(function () {
                    $state.go('ppc-multiline-entry-2');
                  });
                });
              } else if (currentCtnShareStatus == 'Main') {
                //customer already has a shared group and selected an additional/main CTN
                // bfa-4584: check main ctn eligibility before going into ML flow
                // previous logic: covers 4, 5, 7 - As Abdellatif said, for entry point 2, we should do eligibility check in the entry point itself only for main and we should do eligibility check for additional lines in the calling options page
                self.selectedPrimary = mainSubscriber.subscriberNumber;
                self.checkEligibilityAndSaveState('multi', 'main').then(function () {
                  $state.go('ppc-multiline-entry-2');
                });
              } else if (currentCtnShareStatus == 'Individual') {
                //customer already has a shared group and selected an individual CTN
                //covers 6
                self.showThirdMultiLineEntry();
              }

            } else if (currentCtnShareStatus == 'Individual') {
              //covers cases 1, 2, 3
              if (numberOfIndividualSubscribers == 1) {
                self.checkEligibilityAndSaveState('single', 'all').then(function () {
                  $state.go('ppc-singleline');
                });
              } else {
                self.showFirstMultiLineEntry();
              }

            }
        };

        self.showThirdMultiLineEntry = function () {
            var entry3ModalInstance = $modal.open({
                templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry3Modal.html',
                controller: 'mppcEntry3Ctrl'
            });

            entry3ModalInstance.result.then(
                function (response) {
                    if (response === 'changeCurrentPlan') {
                        self.checkEligibilityAndSaveState('single', 'individual').then(function () {
                            $state.go('ppc-singleline');
                        });
                    } else if (response === 'addToSharedGroup') {
                        self.selectedAdditionalSubscribers = _.pluck(_.filter(self.subscribers, function (subscriber) {
                            return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Additional';
                        }), 'subscriberNumber');
                        self.selectedAdditionalSubscribers.push(($rootScope.isCare) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber'));

                        self.selectedPrimary = _.find(self.subscribers, function (subscriber) {
                            return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Main';
                        }).subscriberNumber;
                        self.askAddAdditionalData();
                    }
                },
                function () {
                    self.changeBtnLoading(false);
                });
        };

        self.askAddAdditionalData = function () {
            var addAdditionalDataModalInstance = $modal.open({
                templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcAddAditionalDataModal.html',
                controller: 'mppcAddAdditionalDataModalCtrl'
            });

            addAdditionalDataModalInstance.result.then(
                function (response) {
                    self.checkEligibilityAndSaveState('multi', 'main').then(function () {
                        if (response) {
                            $state.go('ppc-multiline-step-1');
                        } else {
                            localStorage.setLocalStorageValue('individualToSharedCTN', localStorage.getLocalStorageValue('phoneNumber'));
                            $state.go('ppc-multiline-step-1');
                        }
                    });
                },
                function () {
                    self.changeBtnLoading(false);
                });
        };

        self.showFirstMultiLineEntry = function () {
            var entry1ModalInstance = $modal.open({
                templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry1Modal.html',
                controller: 'mppcEntry1Ctrl'
            });

            entry1ModalInstance.result.then(
                function (response) {
                    if (response === 'changeCurrentPlan') {
                        self.checkEligibilityAndSaveState('single', 'all').then(function () {
                            $state.go('ppc-singleline');
                        });
                    } else if (response === 'createSharedGroup') {
                        self.createSharedGroup();
                    }
                },
                function () {
                    self.changeBtnLoading(false);
                });
        };

        self.createSharedGroup = function () {
            var shareGroupIndividualModalInstance = $modal.open({
                templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupIndividualModal.html',
                controller: 'mppcSharedGroupIndividualModalCtrl',
                resolve: {
                    subscribers: function () {
                        return self.subscribers;
                    },
                    currentCtn: function () {
                        return ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber');
                    }
                }
            });

            shareGroupIndividualModalInstance.result.then(
                function (selectedAdditionalSubscribers) {
                    // we need to group the current CTN with these selected subscribers
                    console.log('selectedAdditionalSubscribers: ', selectedAdditionalSubscribers);
                    var currentCtn = ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber');
                    if (selectedAdditionalSubscribers.length > 0) {
                        self.selectedAdditionalSubscribers = selectedAdditionalSubscribers;
                        var shareGroupPrimaryModalInstance = $modal.open({
                            templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupPrimaryModal.html',
                            controller: 'mppcSharedGroupPrimaryModalCtrl',
                            resolve: {
                                selectedAdditionalSubscribers: function () {
                                    return selectedAdditionalSubscribers;
                                },
                                currentCtn: function () {
                                    return currentCtn;
                                }
                            }
                        });

                        shareGroupPrimaryModalInstance.result.then(
                            function (selectedPrimary) {
                                console.log('selectedPrimary', selectedPrimary);
                                if (selectedPrimary) {
                                    if (selectedPrimary != currentCtn) {
                                        //if user changed the primary subscriber, so old primary one should be an additional now!
                                        self.selectedAdditionalSubscribers.push([currentCtn]);
                                        //the new selectedPrimary ctn must ne remove from selectedAdditionalSubscribers, because it is a primary now!
                                        _.remove(selectedAdditionalSubscribers, function (item) {
                                            return item === selectedPrimary;
                                        });
                                    }
                                    self.selectedPrimary = selectedPrimary;
                                    self.checkEligibilityAndSaveState('multi', 'main').then(function () {
                                        $state.go('ppc-multiline-step-1');
                                    });

                                }
                            },
                            function () {
                                self.changeBtnLoading(false);
                            }
                        );

                    }
                },
                function () {
                    self.changeBtnLoading(false);
                });
        };

        self.checkEligibilityAndSaveState = function (flowType, filterOption) {
            var deferred = $q.defer();
            self.isEligible(flowType).then(function () {
                    self.saveState(filterOption).then(
                        function () {
                            deferred.resolve();
                        },
                        function (saveStateError) {
                            pricePlanChangesErrors.showError(resource.get('ppc_something_went_wrong_message_title'), resource.get('ppc_something_went_wrong_message_text'), ['OK'], null, true);
                            self.changeBtnLoading(false);
                            deferred.reject();
                        });
                },
                function () {
                    // already displayed eligibility error in isEligible()
                    deferred.reject();
                });
            return deferred.promise;
        };

        self.clean = function () {
            self.scope = {};
            self.fetchOrderCompleted = false;
            self.bfappcOrders.length = 0;
            self.brtSwitch = {
                ppc: null,
                mppc: null,
                q2ppc: null,
                ppcRateCard: null
            };
            self.permission = {
                ppc: null,
                mppc: null,
                ppcRateCard: null
            };
            self.subscribers = null;
            self.fetchOrderFullResponse = {};
            self.changeBtnLoadingStatus = false;
        };

        self.getFetchOrderFullResponse = function () {
            return self.fetchOrderFullResponse;
        };

        self.changeBtnLoading = function (status) {
            if (!arguments.length) {
                return self.changeBtnLoadingStatus;
            }
            self.changeBtnLoadingStatus = status;
        };

        return {
            'isFetchOrderCompleted': self.isFetchOrderCompleted,
            'hasOrder': self.hasOrder,
            'fetchOrder': self.fetchOrder,
            'gotoBFAPPC': self.gotoBFAPPC,
            'clean': self.clean,
            'changeBtnLoading': self.changeBtnLoading,
            'getFetchOrderFullResponse': self.getFetchOrderFullResponse,
            'checkEligibilityAndSaveState' : self.checkEligibilityAndSaveState,
            'hasMultipleSubscribers' : self.hasMultipleSubscribers,
            'isBRT' : self.isBRT,
            'hasPermission': self.hasPermission
        };
    }
})
();

(function () {
  'use strict';

  angular.module('totesApp').controller('mppcAddAdditionalDataModalCtrl', mppcAddAdditionalDataModalCtrl);
  mppcAddAdditionalDataModalCtrl.$inject = ['$scope', '$modalInstance'];
  function mppcAddAdditionalDataModalCtrl($scope, $modalInstance) {
    var self = {};
    $scope.model = {};

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.yes = function () {
      $modalInstance.close(true);
    };

    $scope.no = function () {
      $modalInstance.close(false);
    };
  }

})();


(function () {
  'use strict';

  angular.module('totesApp').controller('mppcEntry1Ctrl', mppcEntry1Ctrl);
  mppcEntry1Ctrl.$inject = ['$scope', '$modalInstance'];
  function mppcEntry1Ctrl($scope, $modalInstance) {
    var self = {};
    $scope.model = {};

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.createSharedGroup = function () {
      $modalInstance.close('createSharedGroup');
    };

    $scope.changeCurrentPlan = function () {
      $modalInstance.close('changeCurrentPlan');
    };
  }

})();


(function () {
  'use strict';

  angular.module('totesApp').controller('mppcEntry3Ctrl', mppcEntry3Ctrl);
  mppcEntry3Ctrl.$inject = ['$scope', '$modalInstance'];
  function mppcEntry3Ctrl($scope, $modalInstance) {
    var self = {};
    $scope.model = {};

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.addToSharedGroup = function () {
      $modalInstance.close('addToSharedGroup');
    };

    $scope.changeCurrentPlan = function () {
      $modalInstance.close('changeCurrentPlan');
    };
  }

})();


(function () {
  'use strict';

  angular.module('totesApp').controller('mppcSharedGroupIndividualModalCtrl', mppcSharedGroupIndividualModalCtrl);
  mppcSharedGroupIndividualModalCtrl.$inject = ['$scope', '$modalInstance', 'subscribers', 'currentCtn','$state', 'bfappcWirelessDashboardService'];
  function mppcSharedGroupIndividualModalCtrl($scope, $modalInstance, subscribers, currentCtn, $state, bfappcWirelessDashboardService) {
    var self = {};

    $scope.model = {
      subscribers: subscribers,
      currentCtn: currentCtn,
      selectedSubscribersCheckBox:{},
      showBenefits: false,
      isCTNSelected: false
    };

    $scope.toggleBenefits = function () {
      $scope.model.showBenefits = ($scope.model.showBenefits) ? false : true;
    };

    $scope.filterSubscribers = function (item) {
      return item.familyShareStatus === 'Individual' && item.status === 'Active' && item.subscriberNumber != currentCtn;
    };

    $scope.continue = function () {
      if(self.getSelectedSubscribers().length > 0){
        $scope.model.isCTNSelected = false;
        $modalInstance.close(self.getSelectedSubscribers());
      } else{
        $scope.model.isCTNSelected = true;
      }

    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.skipStep = function () {
      bfappcWirelessDashboardService.checkEligibilityAndSaveState('single', 'main').then(function () {
              $state.go('ppc-singleline');
              });
    };

    self.getSelectedSubscribers = function(){
      return _.keys(_.pick($scope.model.selectedSubscribersCheckBox , function(value, key) {
        return value;
      }));
    };
  }

})();

(function () {
  'use strict';

  angular.module('totesApp').controller('mppcSharedGroupPrimaryModalCtrl', mppcSharedGroupPrimaryModalCtrl);
  mppcSharedGroupPrimaryModalCtrl.$inject = ['$scope', '$modalInstance', 'selectedAdditionalSubscribers', 'currentCtn'];
  function mppcSharedGroupPrimaryModalCtrl($scope, $modalInstance, selectedAdditionalSubscribers, currentCtn) {
    var self = {};

    $scope.model = {
      selectedAdditionalSubscribers: selectedAdditionalSubscribers,
      selectedPrimaryCtn: currentCtn, // the selected ctn should be preselected in the list
      currentCtn: currentCtn,
    };

    $scope.continue = function () {
      $modalInstance.close($scope.model.selectedPrimaryCtn);
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  }

})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:sspDashBoardController
   * @description
   * # sspDashBoardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyRepFeedbackController', repFeedbackController);

  repFeedbackController.$inject = ['$scope', '$rootScope', '$q','localStorage', 'ajax', '$element', 'settings', '$browser', '$cookies', 'userLanguage'];

  /* @ngInject */
  function repFeedbackController($scope, $rootScope, $q, localStorage, ajax, $element, settings, $browser, $cookies, userLanguage) {
    $scope.$extend({
    });

    $scope.userTypeDealer = $rootScope.isDealer;
    $scope.userTypeCare =  $rootScope.isCare;
    if($rootScope.isDealer || $rootScope.isCare){
        $element.find('#feedback-tab').hide();
        $element.find("#footer a[onclick='javascript:FSR.popFeedback()']").hide();
    }
    $scope.openSurveyLink = function () {
      $scope.lang = userLanguage();
      var browserName = $scope.getBrowserName();
      var browserVer = $.browser.version;
      var os = $scope.getOs();
      var sessionId ='';
      var site = "rogers.com";
      var ban = localStorage.getLocalStorageValue('accountNumber');
      var userId = '';
      var deferred = $q.defer();
      ajax.agentInfo().then(
      function (data) {
        if(!data ){
          deferred.reject('No cfaInfo');
        }
        if($scope.userTypeDealer){
          userId = data.cfaInfo.userId;
          if(data.playSessionId){
            sessionId = data.playSessionId.split('-');
          }
        } else if($scope.userTypeCare){
          userId = data.repInfo.loginId;
          if(data.playSessionId){
            sessionId = data.playSessionId.split('-');
          }
        }
        var surveyUrl = "https://www.surveymonkey.com/r/3K87P7G?userid="+userId+
                  "&"+"browser="+browserName+"&"+"browserversion="+browserVer+
                  "&"+"os="+os+"&"+"sessionid="+sessionId[0]+"&"+"site="+site+"&"+"currentban="+ban;
        if($scope.lang === 'fr'){
            surveyUrl = "https://fr.surveymonkey.com/r/XQLJHDT?userid="+userId+
                  "&"+"browser="+browserName+"&"+"browserversion="+browserVer+
                  "&"+"os="+os+"&"+"sessionid="+sessionId[0]+"&"+"site="+site+"&"+"currentban="+ban;
        }
        window.open(surveyUrl,'_blank');
      }, function (error) {
        deferred.reject(error);
      });
    };

    $scope.getOs = function (){
      var nAgt = navigator.userAgent;
      var os = '';
        var clientStrings = [
          {s:'Windows 10', r:/(Windows 10.0|Windows NT 10.0)/},
          {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
          {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
          {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
          {s:'Windows Vista', r:/Windows NT 6.0/},
          {s:'Windows Server 2003', r:/Windows NT 5.2/},
          {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
          {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
          {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
          {s:'Windows 98', r:/(Windows 98|Win98)/},
          {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
          {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
          {s:'Windows CE', r:/Windows CE/},
          {s:'Windows 3.11', r:/Win16/},
          {s:'Android', r:/Android/},
          {s:'Open BSD', r:/OpenBSD/},
          {s:'Sun OS', r:/SunOS/},
          {s:'Linux', r:/(Linux|X11)/},
          {s:'iOS', r:/(iPhone|iPad|iPod)/},
          {s:'Mac OS X', r:/Mac OS X/},
          {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
          {s:'QNX', r:/QNX/},
          {s:'UNIX', r:/UNIX/},
          {s:'BeOS', r:/BeOS/},
          {s:'OS/2', r:/OS\/2/},
          {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
        ];
        for (var id in clientStrings) {
          var cs = clientStrings[id];
          if (cs.r.test(nAgt)) {
              os = cs.s;
              break;
          }
        }
      return os;
    };

    $scope.getBrowserName = function (){
      var nAgt = navigator.userAgent;
      var browser = navigator.appName;
      var version = '' + parseFloat(navigator.appVersion);
      var nameOffset, verOffset, ix;

      // Opera
      if ((verOffset = nAgt.indexOf('Opera')) != -1) {
          browser = 'Opera';
          version = nAgt.substring(verOffset + 6);
          if ((verOffset = nAgt.indexOf('Version')) != -1) {
              version = nAgt.substring(verOffset + 8);
          }
      }
      // Opera Next
      if ((verOffset = nAgt.indexOf('OPR')) != -1) {
          browser = 'Opera';
          version = nAgt.substring(verOffset + 4);
      }
      // MSIE
      else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
          browser = 'Microsoft Internet Explorer';
          version = nAgt.substring(verOffset + 5);
      }
      // Chrome
      else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
          browser = 'Chrome';
          version = nAgt.substring(verOffset + 7);
      }
      // Safari
      else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
          browser = 'Safari';
          version = nAgt.substring(verOffset + 7);
          if ((verOffset = nAgt.indexOf('Version')) != -1) {
              version = nAgt.substring(verOffset + 8);
          }
      }
      // Firefox
      else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
          browser = 'Firefox';
          version = nAgt.substring(verOffset + 8);
      }
      // MSIE 11+
      else if (nAgt.indexOf('Trident/') != -1) {
          browser = 'Microsoft Internet Explorer';
          version = nAgt.substring(nAgt.indexOf('rv:') + 3);
      }
      // Other browsers
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
          browser = nAgt.substring(nameOffset, verOffset);
          version = nAgt.substring(verOffset + 1);
          if (browser.toLowerCase() == browser.toUpperCase()) {
              browser = navigator.appName;
          }
      }
    	return browser;
    };
  }
})();





(function () {
  'use strict';

  angular.module('totesApp').directive('repFeedback', repFeedback);

  repFeedback.$inject = [];

  /* @ngInject */
  function repFeedback($log) {
    return {
      templateUrl: 'scripts/directives/oneview/repFeedback/repFeedback.html',
      scope: {},
      restrict: 'EA',
      controller: 'MyRepFeedbackController',
      controllerAs: 'ssp',
      bindToController: true
    };

  }
})();


'use strict';

angular.module('totesApp')
.directive('sspDashboard', function () {
			return {
				restrict: 'E',
				 scope: {},
         templateUrl: 'scripts/directives/oneview/sspDashboard/sspDashboard.html'
      }
})
.controller('sspDashboardCtrl', ['$scope', '$rootScope',  'resource', 'userLanguage', 'localStorage', 'ajax', '$element', 'settings', '$browser',
			function ($scope, $rootScope, resource, userLanguage, localStorage, ajax, $element, settings, $browser) {
        $scope.userTypeDealer = $rootScope.isDealer;
        if($rootScope.isDealer || $rootScope.isCare){
            $element.find('#feedback-tab').hide();
            $element.find("#footer a[onclick='javascript:FSR.popFeedback()']").hide();
        }
        $scope.backToSSPdashBoard = function () {
          var cookies = $browser.cookies();
          var language = cookies.language;
          var province = cookies.province;
         // alert("language:"+language+" province:"+province);
          var postData;
          if(localStorage.getLocalStorageValue('toStateName')==="wireless") {
                postData = {
                   ctn: localStorage.getLocalStorageValue('phoneNumber'),
                   accountNumber: localStorage.getLocalStorageValue('accountNumber'),
                   lang: language,
                   prov: province
                };
          }
          else {
            postData = {
               ctn: "",
               accountNumber: localStorage.getLocalStorageValue('accountNumber'),
               lang: language,
               prov: province
            };
          }
          ajax.backToSSP(postData).then(
              function (data) {
                if(data.isCableOnly) {
                  $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
                  $('#formToSSP').submit();
                } else {
                  $('#formToSSP').find("#sharedKey").val(data.sharedKey);
                  $('#formToSSP').find("#signature").val(data.signature);
                  $('#formToSSP').find("#content").val(data.content);
                  $('#formToSSP').attr('action', data.envPath +  settings.agentInfo.sspDashboardURL);
                  $('#formToSSP').submit();
                }
              },
              function (error) {
                $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
                $('#formToSSP').submit();
              }
          );
        };
}]);

'use strict';

angular
  .module('pricePlanChanges')
  .directive('addOnDetails', function() {
    return {
      restrict: 'E',
      scope: {
        details: '=',
        slideIndex: '=',   // which of the three plans above was clicked on
        expanded:   '=',   // flag value from parent controller
      },
      templateUrl: 'scripts/directives/pricePlanChanges/add-on/add-on-details.html',
      controller: ["$scope", "$rootScope", function($scope, $rootScope) {
        $rootScope.$on('available-add-on-details-expanded', function(event, args) {
          //if(args.addOnCode !== $scope.details.addOnCode) {
            // our neighbour just opened up, show this panel as 'collapsed'
            $scope.expanded = false;
          //}
        });
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('addOn', ["pricePlanChangesErrors", "resource", function(pricePlanChangesErrors, resource) {
    return {
      restrict: 'E',
      scope: {
        addOn: '=',        // The actual add-on that is either existing or available
        showDetails: '=',  // the function we call when the user clicks on the '+' details-button
        hideDetails: '=',  // the function we call when the user clicks on the '-' details-button
        slideIndex: '@',   // which add-on above was clicked on
        group: '@',        // existing is a group and the available add-ons are grouped as Long-Distance and Calling-Features
        addOnsUpdated: '=',// function called when an add on is selected or removed
        showDescription: '='//show Addon Description
      },
      templateUrl: 'scripts/directives/pricePlanChanges/add-on/add-on.html',
      controller: ["$scope", function ($scope) {
        $scope.select = function () {
          if ($scope.addOn.selected) {
            var modal = pricePlanChangesErrors.showError(resource.get('ppc_confirm_addon_remove'), resource.get('ppc_confirm_addon_remove_content'),
              ['Cancel', 'RemoveAddOn'],{},false);
            modal.then(function(data) {
              if (data) {
                $scope.addOn.selected = false;
                $scope.addOnsUpdated();
              }
            });
          } else {
            $scope.addOn.selected = true;
            $scope.addOnsUpdated();
          }
        };
      }]
    };
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .directive('availableAddOnAdaptive', function() {
    return {
      restrict: 'E',
      scope: {
        addOn: '=',
        addOnsUpdated: '=',// function called when an add on is selected or removed
        detailsExpanded: '=',
        showDetails: '=',
        hideDetails: '=',
        position: '@'
      },
      templateUrl: 'scripts/directives/pricePlanChanges/add-on/available-add-on-adaptive.html',
      controller: ["$scope", function ($scope) {
        $scope.select = function () {
          if ($scope.addOn.selected) {
            $scope.addOn.selected = false;
          } else {
            $scope.addOn.selected = true;
          }
          $scope.addOnsUpdated();
        };
        
        $scope.clicked = function(pos){
        		alert(pos);
        }
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('availableAddOnsListAdaptive', function() {
    return {
      restrict: 'E',
      scope: {
        addOns: '=',  // array of add ons
        addOnsUpdated: '=',// function called when an add on is selected or removed
        detailsExpanded: '=', // a flag for tracking expand/collapse state of details panel
        showDetails: '=',
        hideDetails: '=',
        type: '@'
      },
      templateUrl: 'scripts/directives/pricePlanChanges/add-on/available-add-ons-list-adaptive.html',
      controller: ["$scope", function($scope){
        $scope.filterAddons = function(addOns, type){
          //temp. @todo
          //type = (type != 'LongDistance') ? 'Calling Features' : 'Long Distance';
          if(type == 'LongDistance'){
            type = 'Long Distance';
          }else if(type == 'CallingFeatures'){
            type= 'Calling Features';
          }else if(type == 'ValuePacks'){
            type= 'Value Packs';
          }
        	var filteredAddOns = _.filter(addOns, function(addOn) {
		        return addOn.addonInfo.categoryName_En === type;
		      });
		      return filteredAddOns;
        };

        /*$scope.filteredAddonsLength = function(addOns, type){
          var addOns = $scope.filteredAddOns(addOns, type);
          return addOns.length || 0;
        };*/
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('duplicateAddOns', function() {
    return {
      restrict: 'E',
      scope: {
        duplicates: '=',
        dropped: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/add-on/duplicate-add-ons.html',
      controller: function() {

      }
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('yourAddOnsAdaptive', function() {
    return {
      restrict: 'E',
      scope: {
        addOn: '=',
        addOnsUpdated: '=',
        duplicates: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/add-on/your-add-ons-adaptive.html',
      controller: ["$scope", function($scope) {
          $scope.yourAddOnsExpanded = true;

          var a = $scope.addOn;
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('yourAddOnsDuplicatesAdaptive', function() {
    return {
      restrict: 'E',
      scope: {
        duplicates: '=',
        dropped: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/add-on/your-add-ons-duplicates-adaptive.html',
      controller: ["$scope", function($scope) {
          $scope.yourAddOnsExpanded = true;
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('availablePlanAdaptive', ["$rootScope", "pricePlanChangesErrors", "pricePlanTranslate", "resource", function($rootScope, pricePlanChangesErrors, pricePlanTranslate, resource) {
    return {
      restrict: 'E',
      scope: {
        plan: '=',
        selectPlan: '=', // passed down from price-plans-carousel-adaptive
        removePlan: '=', // passed down from price-plans-carousel-adaptive
      },
      templateUrl: 'scripts/directives/pricePlanChanges/available-plan/available-plan-adaptive.html',
      controller: ["$scope", function($scope) {
					$scope.showIncludes = $scope.plan.cmsData_En.categoryName_En.indexOf('Share') > -1;

          /*Q2PPC-27*/
        $scope.isSharePlus = ($scope.plan.cmsData_En.hasOwnProperty('isSharePlus') && $scope.plan.cmsData_En.isSharePlus.toLowerCase() == "yes") ? true : false;
        $scope.isShareable = ($scope.plan.cmsData_En.hasOwnProperty('shareType') && $scope.plan.cmsData_En.shareType.toLowerCase() == "share") ? true : false;

					$scope.closeDetails = function(){
						 if ($scope.showExpanded == true)
						 		$scope.showExpanded = false;
					};
					$scope.doSelect = function(){
						 $rootScope.longDistanceLoadMobile = true;
					};

					$scope.confirmUndo = function(){
        		var _scope = $scope;
        		var _rootScope = $rootScope;
        		var callback = function(){
        			_rootScope.$broadcast('price-plan-undo-select', {planCode: _scope.plan.planInfo.planCode});
        		};
						pricePlanChangesErrors.showError(
						resource.get('ppc_confirm_addon_remove'),
						resource.get('ppc_confirm_addon_remove_content'),
							['Cancel', 'Confirm'],
							{sendCallback: callback}
						);
	        };

	        $scope.$on('price-plan-undo-select', function(event, args) {
	        	if($scope.plan.planInfo.planCode == args.planCode) {
		        	$scope.removePlan();
	        		$scope.plan.isSelected = !$scope.plan.isSelected;
		      	}
	        });

          $scope.overageFr = pricePlanTranslate.overageFr;
      }],
      link: function(scope, element, attrs){
      	//called from various directives
      	//@todo can move to controller
        var self = {};
        self.onCloseButton = $rootScope.$on('close-expanded-button-mobile', function(){
      		if (scope.showExpanded == true)
      			scope.showExpanded = false;
      	});

        scope.$on('$destroy', function(){
          self.onCloseButton();
        });
      }
    };
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .directive('availablePlanDetails', ["pricePlanChanges", "userLanguage", function(pricePlanChanges, userLanguage) {
    return {
      restrict: 'E',
      scope: {
        expanded: '=',     // visibility toggle
        slideIndex: '=',   // which of the three plans above was clicked on
        expandedPlan: '=' // the actual selected plan we are displaying details for
      },
      templateUrl: 'scripts/directives/pricePlanChanges/available-plan/available-plan-details.html',
      controller: ["$scope", "$rootScope", function($scope, $rootScope) {
        //$scope.$on('available-plan-details-expanded', function(event, args) {
        //  console.log(args);
        //  var plan = pricePlanChanges.getExpandedPlan(args.buttonId);
        //  console.log(plan);
        //});


        $scope.$watch('expandedPlan', function(plan) {
          $scope.showIncludes = (plan && plan.cmsData_En) ? plan.cmsData_En.categoryName_En.indexOf('Share') > -1 : false;

          var _index = 0;


          if (plan && plan.cmsData_En) {

            /*Q2PPC-27*/
            $scope.isSharePlus = (plan.cmsData_En.hasOwnProperty('isSharePlus') && plan.cmsData_En.isSharePlus.toLowerCase() == "yes") ? true : false;
            $scope.isShareable = (plan.cmsData_En.hasOwnProperty('shareType') && plan.cmsData_En.shareType.toLowerCase() == "share") ? true : false;

            var _length = plan.cmsData_En.includedMinutes.length;
            for (var i = 0; i < _length; i++) {
              if (plan.cmsData_En.includedMinutes[i].indexOf('Unlimited') !== -1) {
                _index = i;
                break;
              }
            }
            var _lang = userLanguage();
            var _str = '';
            switch (_lang) {
              case 'en':
                _str = plan.cmsData_En.includedMinutes[_index];
                break;
              case 'fr':
                _str = plan.cmsData_Fr.includedMinutes[_index];
                break;
            }
            $scope.unlimitedWideCanadaText = _str.replace(/<(?:.|\n)*?>/gm, '');
            $scope.unlimitedWideCanadaText += '<sup>2</sup>';
          }
        });

        $scope.closeDetails = function(expandedPlan){
          $rootScope.$broadcast('close-expanded-button');
        }
      }]
    };
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .directive('availablePlan', ["pricePlanChangesErrors", "pricePlanTranslate", "resource", "$rootScope", function(pricePlanChangesErrors, pricePlanTranslate, resource, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        plan: '=',
        plansLength: '=',
        showDetails: '=', // passed down to available-plan-details
        hideDetails: '=', // passed down to available-plan-details
        selectPlan:  '=', // this is the equivalent of 'add to cart'
        removePlan:  '=', // this is the equivalent of 'remove from cart'
        slideIndex:  '@' // the sequence of the three plans left to right
      },
      templateUrl: 'scripts/directives/pricePlanChanges/available-plan/available-plan.html',
      controller: ["$scope", "$rootScope", "popUpBubbles", "pricePlanAlignRows", "$timeout", function($scope, $rootScope, popUpBubbles, pricePlanAlignRows, $timeout) {
        $rootScope.countPlan = $rootScope.countPlan || 0;

        $scope.showIncludes = $scope.plan.cmsData_En.categoryName_En.indexOf('Share') > -1;

        /*Q2PPC-27*/
        $scope.isSharePlus = ($scope.plan.cmsData_En.hasOwnProperty('isSharePlus') && $scope.plan.cmsData_En.isSharePlus.toLowerCase() == "yes") ? true : false;
        $scope.isShareable = ($scope.plan.cmsData_En.hasOwnProperty('shareType') && $scope.plan.cmsData_En.shareType.toLowerCase() == "share") ? true : false;

        $scope.plan.isSelected = false; // select/remove state toggle
        $scope.popUpBubbles = popUpBubbles;

        function deselectOtherPlans(planCode) {
          $rootScope.$broadcast('price-plan-selected', { planCode: planCode });
        }

        $rootScope.$on('price-plan-selected', function(event, args) {
          if($scope.plan.planCode !== args.planCode) {
            $scope.plan.isSelected = false;
          }
        });

        $scope.doSelect = function(isSelected, planCode) {
          if(isSelected) {
            deselectOtherPlans(planCode);
          }

          // capture new state
          $scope.plan.isSelected = isSelected;

          //close
          $timeout(function() {
            $rootScope.$broadcast('close-expanded-button');
          });

          //notify loading image
          $rootScope.longDistanceLoader = true;
        };

        $scope.$watch('$scope.slideIndex', function(){
          //ALIGN ROWS AFTER SLIGHT DELAY
          ++$rootScope.countPlan;
          if($rootScope.countPlan == $scope.plansLength){
            //$timeout(function() {	//slow with $apply
            setTimeout(function() {
              pricePlanAlignRows.alignDataRows();
            }, 500);
          }
        });

        $scope.overageFr = pricePlanTranslate.overageFr;

        $scope.toggleHeaderInfo = function (plan) {
          if (!plan.hasOwnProperty('displayHeaderInfo')) {
            plan.displayHeaderInfo = false;
          }
          plan.displayHeaderInfo = !plan.displayHeaderInfo;
        };
      }]
    };
  }]);

(function () {
  'use strict';

  angular
    .module('pricePlanChanges')
    .directive('pricePlansCarouselAdaptive', ["$rootScope", function ($rootScope) {
      return {
        restrict: 'E',
        scope: {
          plans: '=',
          selectPlan: '=', // passed down to available-plan-directive
          removePlan: '=' // passed down to available-plan-directive
        },
        templateUrl: 'scripts/directives/pricePlanChanges/carousel/price-plans-carousel-adaptive.html',
        link: function (scope, element, attrs) {
          var self = {};
          self.activeSlide = function () {
            return document.querySelector('.carousel-inner .active');
          };

          self.watchActiveSlide = scope.$watch(self.activeSlide, function () {
            $rootScope.$emit('close-expanded-button-mobile');
          });

          scope.showArrow = function () {
            return scope.plans && scope.plans.length > 1;
          };

          scope.$on('$destroy', function () {
            self.watchActiveSlide();
          });
        }
      };
    }]);
})();

'use strict';

angular
  .module('pricePlanChanges')
  .directive('pricePlansCarouselDots', function() {
    return {
      restrict: 'E',
      templateUrl: 'scripts/directives/pricePlanChanges/carousel/price-plans-carousel-dots.html',
      controller: ["$scope", function($scope) {
      }],
      scope: {
        type: '='
      },
      link: function ($scope, $elem, attr) {
        var filterAddons = function (addons, type, sizeOnlny) {
          var addOns = addons || [];

          //temp. @todo
          type = (type != 'LongDistance') ? 'Calling Features' : 'Long Distance';
          var filteredAddOns = _.filter(addOns, function(addOn) {
            return addOn.addonInfo.categoryName_En === type;
          });

          return filteredAddOns;
        };
        var _myScope = $scope;
        var addons;
        var length = 0;
        $scope.$parent.$parent.singleLinePPC.addOnsPromise.promise.then(function (addons) {
          // console.log("PROMISE RESOLVED!");
          // console.log(addons);
          // console.log(_myScope.type);
          addons = filterAddons(addons, _myScope.type);
          $scope.dotCount = addons.length;
          // console.log("GOING TO ADD " + $scope.dotCount + " dots");
        });
      }
      //compile: function(element, attrs) {
      //	var sub    = '@@';	//see template
      //	var placer = angular.element(element).find('.carousel-dots-container');
      //
      //	//trick to leave repeat element in template
      //	var dot = placer.html();
      //  /*placer.html('');*/
      //
      //	for (var i = 0; i < attrs.repeat; ++i){
      //	  var dotter = dot.clone().replace(sub, i + 1)
      //		placer.append(dotter);
      //	}
      //
      //	/*var linkFunction = function(scope, element, attrs){
      //		//state, which dot
      //		var dot  = 1;
      //		var ways = ['up', 'down'];
      //
      //		scope.$on('redDotChange', function(type, way){
      //			if(type != attrs.type || ways.indexOf(way) == -1){ return; }
      //
      //			angular.element('.carousel-dots-dot').each(function() {
      //				angular.element(this).removeClass('rogers-red-font');
      //			});
      //
      //			var status = (way == 'up') ? ++dot : --dot;
      //
      //			//broadcasts excess
      //			if(dot <= 0) {
      //				dot = 1;
      //			}
      //			else if (dot > attrs.dots) {
      //				dot = attrs.dots;
      //			}
      //
      //			//change class
      //			//CSS: rogers-red-font, rogers-red-font-remove
      //			if(dot > 0 && dot <= attrs.dots){
      //				angular.element('i[data-dot="' + dot + '"]').addClass('rogers-red-font');
      //			}
      //
      //			//console.log(type, way, status);
      //		});*/
      //
      //		angular.element('i[data-dot="1"]').addClass('rogers-red-font').removeClass('mlm');
      //
      //		//\app\scripts\directives\pricePlanChanges\add-on\available-add-ons-list-adaptive.html
      //		/*$scope.updateCarousel = function(type, way){
      //			$scope.broadcast('redDotChange', {type: type, way: way});
      //		}
      //
      //    return linkFunction;*/
      //	}
      }
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('pricePlansCarouselPageIndicator', function() {
    return {
      restrict: 'E',
      scope: {
        currentPage: '=',
        plans: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/carousel/price-plans-carousel-page-indicator.html',
      controller: ["$scope", function($scope) {
        $scope.setPage = function(newPageNumber) {
          $scope.currentPage = newPageNumber;
        };

        $scope.isCurrentPage = function(pageNumber) {
          return pageNumber === $scope.currentPage;
        };
      }]
    };
  });

(function () {
  'use strict';

  angular
    .module('pricePlanChanges')
    .directive('pricePlansCarousel', ["$rootScope", function ($rootScope) {
      return {
        restrict: 'E',
        transclude: false,
        templateUrl: 'scripts/directives/pricePlanChanges/carousel/price-plans-carousel.html',
        scope: {
          plans: '=',       // PAGED array of plans
          plansLength: '=', // length of RAW plans
          showDetails: '=', // passed down to available-plan and then down to available-plan-details
          hideDetails: '=', // passed down to available-plan and then down to available-plan-details
          selectPlan: '=', // this is the equivalent of 'add to cart'
          removePlan: '=' // this is the equivalent of 'remove from cart'
        },
        controller: ["$scope", function ($scope) {
          $scope.closeDetails = function () {
            $rootScope.$emit('close-expanded-button');
          };

          $scope.showArrow = function () {
            return $scope.plans && $scope.plans.length > 1;
          };
        }]
      };
    }]);
})();

'use strict';

angular
  .module('pricePlanChanges')
  .factory('pricePlansPaging', function () {
    var service = {};

    // Take a flat array and return an array of arrays by pageSize //
    service.paginate = function(plans, pageSize) {
      var pagedArray = _.map(plans, function(item, index){
        return index % pageSize === 0 ? plans.slice(index, index + pageSize) : null;
      })
      .filter(function(item){
        return item;
      });

      return pagedArray;
    };

    return service;
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('addOnsListAdaptive', function() {
    return {
      restrict: 'E',
      scope: {
        addOns: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/cart-summary/add-ons-list-adaptive.html',
      controller: function() {
      },
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('addOnsList', function() {
    return {
      restrict: 'E',
      scope: {
        addOns: '=',
        editBtn: '=',
        onEditClick: '&'
      },
      templateUrl: 'scripts/directives/pricePlanChanges/cart-summary/add-ons-list.html'
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('cartSummaryAdaptive', function() {
    return {
      restrict: 'E',
      scope: {
        details:'=',
        plan: '=',
        totalCost: '=',
        ctn: '=',
        existingAddOns: '=',
        availableAddOns: '=',
        isProrated: '=',
        rewardsPoints: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/cart-summary/cart-summary-adaptive.html',
      controller: ["$scope", "pricePlanChanges", "$state", "pricePlanChangesErrors", "resource", function($scope, pricePlanChanges, $state, pricePlanChangesErrors, resource) {
      	$scope.showProration = function() {
          pricePlanChanges.showProrationDetails();
        }

        $scope.checkout = function(){
          if (!pricePlanChanges.userSelections.selectedPlan) {
            pricePlanChangesErrors.showError('Price Plan Change', 'Please select plan', ['OK'], {}, false);
            return;
          }

          var creditAvailableInt = parseInt($scope.details.accountBalance.availableCreditAmount, 10);
          var totalCostInt = parseInt($scope.totalCost, 10);

          if (creditAvailableInt === 0 || totalCostInt <= creditAvailableInt) {
            $state.go('review-order');
          } else if (totalCostInt > creditAvailableInt) {
            var title = resource.get("price_plan_change_error");
            var message = resource.get("price_plan_change_error_msg");
            pricePlanChangesErrors.showError(title, message, ['OK']);
          }
        };

        $scope.hasAddOns = function() {
          var selectedExisting = _.filter($scope.existingAddOns, function(addOn) {
            return addOn.selected;
          });

          var selectedAvailable = _.filter($scope.availableAddOns, function(addOn) {
            return addOn.selected;
          });

          var numberOfAddOns = selectedExisting.length + selectedAvailable.length;

          // there are two types of add-ons, if none are selected value returned is false
          return numberOfAddOns > 0;
        };
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('cartSummary', function() {
    return {
      restrict: 'E',
      scope: {
        details: '=',
        plan: '=',
        totalCost: '=',
        ctn: '=',
        existingAddOns: '=',
        availableAddOns: '=',
        isProrated: '=',
        rewardsPoints: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/cart-summary/cart-summary.html',
      controller: ["$scope", "$state", "pricePlanChanges", "pricePlanChangesErrors", "resource", function($scope, $state, pricePlanChanges, pricePlanChangesErrors, resource) {
        $scope.showProration = function() {
          pricePlanChanges.showProrationDetails();
        }
        $scope.$state = $state;

        $scope.checkout = function() {

          if (!pricePlanChanges.userSelections.selectedPlan) {
            pricePlanChangesErrors.showError('Price Plan Change', 'Please select plan', ['OK'], {}, false);
            return;
          }

            var creditAvailableInt = parseInt($scope.details.accountBalance.availableCreditAmount, 10);
            var totalCostInt = parseInt($scope.totalCost, 10);

            if (creditAvailableInt === 0 || totalCostInt <= creditAvailableInt) {
              $state.go('review-order');
            } else if (totalCostInt > creditAvailableInt) {
              var title = resource.get("price_plan_change_error");
              var message = resource.get("price_plan_change_error_msg");
              pricePlanChangesErrors.showError(title, message, ['OK']);
            }
        };

        $scope.hasAddOns = function() {
          var selectedExisting = _.filter($scope.existingAddOns, function(addOn) {
            return addOn.selected;
          });

          var selectedAvailable = _.filter($scope.availableAddOns, function(addOn) {
            return addOn.selected;
          });

          var numberOfAddOns = selectedExisting.length + selectedAvailable.length;

          // there are two types of add-ons, if none are selected value returned is false
          return numberOfAddOns > 0;
        };
      }],
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('confirmReviewOrderShared', function() {
    return {
      restrict: 'E',
      scope: {
        addOns: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/cart-summary/confirm-review-order-shared.html',
      controller: ["$scope", "$location", "$state", "resource", "pricePlanChangesCart", "pricePlanChangesErrors", "pricePlanTranslate", "email_ppc", function($scope, $location, $state, resource, pricePlanChangesCart, pricePlanChangesErrors, pricePlanTranslate, email_ppc) {
      	$scope.$state = $state;

        $scope.paths = {
          'REVIEW':  '/review-order',
          'CONFIRM': '/confirm-order'
        };

        $scope.path = $location.path();
        $scope.cart = pricePlanChangesCart;		//checkout
        $scope.showAgreementError = false;


        $scope.showIncludes = $scope.cart.newPlan ? $scope.cart.newPlan.cmsData_En.categoryName_En.indexOf('Share') > -1 : false;

        $scope.isSharePlus = ($scope.cart.newPlan.cmsData_En.hasOwnProperty('isSharePlus') && $scope.cart.newPlan.cmsData_En.isSharePlus.toLowerCase() == "yes") ? true : false;
        $scope.isShareable = ($scope.cart.newPlan.cmsData_En.hasOwnProperty('shareType') && $scope.cart.newPlan.cmsData_En.shareType.toLowerCase() == "share") ? true : false;


        $scope.scrollTo = function(targetID) {
		      var targetElement = '#' +targetID;

		      // scrollTo is a jQuery plugin
		      $('.scroll-copy-box').scrollTo(targetElement);
		    }

		    var RELOAD = true;
		    $scope.edit = function(){

		    	pricePlanChangesErrors.showError(
		    		resource.get('_confirm_leave'),
		    		resource.get('_confirm_leave_details'),
		    		['Cancel', 'Continue'],
		    		{goForward: 'wireless-plan-change'},
		    		null,
		    		RELOAD);		//bug on reload
		    };

        $scope.overageFr = pricePlanTranslate.overageFr;

        $scope.email = function(){
            return email_ppc.getemail();
        };

        $scope.agreementDate = Date.now();

        $scope.checkout = function() {
          if ($scope.tac_checkbox) {
            $scope.reviewLoader = true;
            var message = '';
            if ($scope.showIncludes) {
              message = resource.get('ppc_change_plan_confirm_share_text');
            } else {
              message = resource.get('ppc_change_plan_confirm_not_share_text');
            }
            var modal = pricePlanChangesErrors.showError(resource.get('ppc_change_plan_confirm_title'), message, ['Cancel', 'Confirm']);
            modal.then(function(data) {
              if (data) {
                pricePlanChangesCart.checkout();
                $scope.reviewLoader = false;
              }
            });
          } else {
            $scope.showAgreementError = true;
            //pricePlanChangesErrors.showError(resource.get('_review_order'), resource.get('ppc_agrrement_error_message'), ['OK']);
          }
        };

        $scope.checkTacValue = function(){
          if ($scope.tac_checkbox) {
            $scope.showAgreementError = false;
          }else{
            $scope.showAgreementError = true;
          }
        };


      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('ctnSelect', ["pricePlanChangesErrors", "resource", function(pricePlanChangesErrors, resource) {
    return {
      restrict: 'E',
      scope: {
        userSelections: '=', // this is an object passed down from parent view and originating in price-plan-changes service
        ctnList: '=',
        selectCtn: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/ctn-select/ctn-select.html',
      controller: ["$scope", function($scope) {
        //prompt warn lose changes
        $scope.clickCTN = function(clickedCTN, $event){
          //same number, close dropdown
          if(clickedCTN == $scope.userSelections.ctn) {
            $event.stopPropagation();
            $('#ctn-container .ctn-dropdown-button').click();   //jQ
          }
          else {
            var modal = pricePlanChangesErrors.showError(
              resource.get('ppc_ctn_confirm_leave_page_title'),
                resource.get('ppc_ctn_confirm_leave_page_text'),
                  ['Cancel', 'Continue'], {}, false  //true - show icons
            );

            modal.then(function(data){
              if(data == true) {
                /* singleLinePPC -> selectCtn(ctn) */
                $scope.userSelections.ctn = clickedCTN;
                $scope.selectCtn($scope.userSelections.ctn);
              }
            }, function(){
              //do nothing
            });
          }
        };
      }],
      link: function(element, scope, attrs) {
        //see ng-click
      }
    };
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .directive('existingPlanAdaptive', function() {
    return {
      restrict: 'E',
      scope: {
        plan: '=',
        existingAddons: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/existing-plan/existing-plan-adaptive.html',
      controller: ["$scope", function($scope) {
        $scope.combineFeatures = function(first, second){
            if(first && second && first.length && second.length)
        		  return first.concat(second);
        };
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('existingPlan', function() {
    return {
      restrict: 'E',
      scope: {
        plan: '=',
        planDetails: '=',
        existingAddons: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/existing-plan/existing-plan.html',
      controller: ["$scope", function($scope) {
        $scope.$watch('plan', function(newVal) {
          if (newVal) {
            var _length = newVal.features ? newVal.features.length : 0;
            for (var i = 0; i < _length; i++) {
              var str = newVal.features[i].desc || '';
              var strFr = newVal.features[i].descFr || '';
              newVal.features[i].desc = str.replace(/Unlimited/i, '<span class="rogers-red-font">Unlimited</span>');
              newVal.features[i].descFr = strFr.replace(/illimités/i, '<span class="rogers-red-font">illimités</span>');
            }
            var _length = newVal.talk ? newVal.talk.length : 0;
            for (var i = 0; i < _length; i++) {
              var str = newVal.talk[i].desc || '';
              var strFr = newVal.talk[i].descFr || '';
              newVal.talk[i].desc = str.replace(/Unlimited/i, '<span class="rogers-red-font">Unlimited</span>');
              newVal.talk[i].descFr = strFr.replace(/illimités/i, '<span class="rogers-red-font">illimités</span>');
            }
            var _length = newVal.text ? newVal.text.length : 0;
            for (var i = 0; i < _length; i++) {
              var str = newVal.text[i].desc || '';
              var strFr = newVal.text[i].descFr || '';
              newVal.text[i].desc = str.replace(/Unlimited/i, '<span class="rogers-red-font">Unlimited</span>');
              newVal.text[i].descFr = strFr.replace(/illimités/i, '<span class="rogers-red-font">illimités</span>');
            }
          }
        });
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('timeLine', function() {
    return {
      restrict: "E",
      scope: {
        percentPassed: '@'
      },
      templateUrl: 'scripts/directives/pricePlanChanges/timeline/timeline.html',
      link: function (scope, element, attrs) {
      }
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('fullDetails', ["$rootScope", "$modal", "userLanguage", function($rootScope, $modal, userLanguage) {
    return {
      restrict: 'E',
      templateUrl: 'scripts/directives/pricePlanChanges/widgets/full-details.html',
      controller: ["$scope", function($scope) {
        $scope.showFullDetails = function(){

          $rootScope.modal = $modal.open({
            templateUrl: 'views/modals/ppc-full-details-' + userLanguage().toLowerCase() + '.html',
            controller: ["$scope", function($scope) {
              /* DUE TO LENGTH OF CONTENT, NOTICE WE PUT COPY IN HTML */

              $scope.cancel = function () {
                $rootScope.modal.dismiss('cancel');
                $rootScope.modal = null;
              };
            }],
            size: 'md'
          });

        };
      }]
    };
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .directive('bigHalfHeader', function() {
    return {
      restrict: 'E',
      scope: {
        resKey: '@'
      },
      templateUrl: 'scripts/directives/pricePlanChanges/widgets/big-half-header/big-half-header.html',
      controller: function() {

      }
    };
  });

/*
  A button that displays either a plus or a minus sign
*/

'use strict';

angular
  .module('pricePlanChanges')
  .directive('detailsButton', function() {
    return {
      restrict: 'E',
      scope: {
        showDetails: '=',  // called when PLUS clicked
        hideDetails: '=',  // called when MINUS clicked
        expanded: '=',
        buttonId: '@' // the ID for this button (derived from source element)
      },
      templateUrl: 'scripts/directives/pricePlanChanges/widgets/details-button/details-button.html',
      controller: ["$scope", function($scope) {
        $scope.handleClick = function() {
          if($scope.expanded) {
            $scope.hideDetails();
          } else {
            $scope.showDetails(null, $scope.addOnCode);
          }
        };
      }]
    };
  });

/*
  A button that displays either a plus or a minus sign
*/

'use strict';

angular
  .module('pricePlanChanges')
  .directive('detailsButtonMobile', function() {
    return {
      restrict: 'E',
      templateUrl: 'scripts/directives/pricePlanChanges/widgets/details-button/details-button-mobile.html',
      controller: ["$scope", function($scope) {
      	
      }]
    };
  });

/*
 A button that displays either a plus or a minus sign
 Publishes an 'expanded' event
 Subscribes to 'expanded' event and will close and display the minus sign if it's neighbour opens up

 Source elements referred to below are available-plans, existing add-ons and available add-ons
 */

'use strict';

angular
  .module('pricePlanChanges')
  .directive('subscribingDetailsButton', function () {
    return {
      restrict: 'E',
      scope: {
        showDetails: '=',  // called when PLUS clicked
        hideDetails: '=',  // called when MINUS clicked
        slideIndex: '=',  // the position of source element that was clicked
        buttonId: '@', // the ID for this button (derived from source element)
        eventName: '@' // the logical grouping of details-buttons based on source element
      },
      templateUrl: 'scripts/directives/pricePlanChanges/widgets/details-button/details-button.html',
      controller: ["$scope", "$rootScope", function ($scope, $rootScope) {
        var self = this;
        $scope.expanded = false;

        function emitExpandedEvent(buttonId) {
          // let the other details-button directives know that it's neighbour just opened
          $rootScope.$broadcast($scope.eventName, {buttonId: buttonId});
        }

        if ($scope.eventName) {
          $rootScope.$on($scope.eventName, function (event, args) {
            if (args.buttonId !== $scope.buttonId) {
              // our neighbour just opened up, show this button as 'collapsed'
              $scope.expanded = false;
            }
          });
        }

        $scope.handleClick = function () {
          if ($scope.expanded) {
            $scope.hideDetails();
          } else {
            $scope.showDetails($scope.slideIndex, $scope.buttonId);

            if ($scope.eventName) {
              emitExpandedEvent($scope.buttonId);
            }
          }
        };

        $scope.$on('close-expanded-button', function (event, args) {
          $scope.expanded = false;
          $scope.hideDetails();
        });

        self.onCloseButton = $rootScope.$on('close-expanded-button', function () {
          $scope.expanded = false;
          $scope.hideDetails();
        });

        $scope.$on('$destroy', function () {
          self.onCloseButton();
        });
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('decimalCommaValue', function() {
    return {
      restrict: 'A',
      controller: ["$scope", "$element", "$rootScope", "userLanguage", "resource", function($scope, $element, $rootScope, userLanguage, resource) {
        //$rootScope.$on('resourceChanged', function() {
        resource.onChanged(function() {
          //@todo - see also decimalCommaValueFltr filter
          //if(isNaN($element[0])){ return; }

          var pointChar =  userLanguage() === 'en' ? '.' : ',';
          var previousPointChar = userLanguage() === 'fr' ? '.' : ',';
          var previousValue = $element[0].innerHTML;

          //if(previousValue.indexOf('.') != -1) {
          //  var segments = previousValue.split('.');
          //  previousValue = segments[1];
          //}

          var newValue = previousValue.replace(previousPointChar, pointChar);
          $element[0].innerHTML = newValue;
        }, $scope);
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('showWhen', ["userLanguage", function(userLanguage) {
    return {
      restrict: 'A',
      controller: ["$scope", "$element", "$attrs", "userLanguage", "$rootScope", function($scope, $element, $attrs, userLanguage, $rootScope) {
        function showHide() {
          var shouldBeHidden = userLanguage() !== $attrs.showWhen;

          if(shouldBeHidden) {
            $element.hide();
          } else {
            $element.show();
          }
        }

        $rootScope.$on('resourceChanged', function() {
          // call when user switches languages
          showHide();
        });

        showHide(); // call this for page load
      }]
    };
  }]);

'use strict';

angular
  .module('pricePlanChanges')
  .directive('moreInformation', function() {
    return {
      restrict: 'E',
      scope: {

      },
      templateUrl: 'scripts/directives/pricePlanChanges/widgets/more-information/more-information.html',
      controller: ["$scope", "$modal", "omni", function ($scope, $modal, omni) {
        var modal;
        $scope.openModal = function () {
          modal = $modal.open({
            templateUrl: 'views/modals/passwordRequirement.html',
            windowClass: 'verify-address-modal',
            controller: ["$scope", function ($scope) {
              $scope.closeModal = function () {
                this.$close();
              }
            }]
          });
          omni.tagLink( [{eVar49:'MyRogers – password must contain 8-16 characters etc'}, {event15:''}]);
        };
      }],
      link: function (element, attribute, scope) {
      }
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('rewardsBox', function() {
    return {
      restrict: 'E',
      scope: {
        pointValue: '='
      },
      templateUrl: 'scripts/directives/pricePlanChanges/widgets/rewards/rewards-box.html',
      controller: ["$scope", function($scope) {
        $scope.firstDigit = 0;
        $scope.secondDigit = 0;
        $scope.thirdDigit = 0;
        $scope.fourthDigit = 0;

        function getFillerString() {
          var numberOfRealDigits = ($scope.pointValue) ? $scope.pointValue.toString().length : 0;
          var numberOfFillerDigits = 4 - numberOfRealDigits;
          var fillerString = '';

          for(var i = 0; i < numberOfFillerDigits; i++) {
            fillerString +='0';
          }

          return fillerString;
        }

        function updateDisplay() {
          var displayString = getFillerString() +$scope.pointValue;

          $scope.firstDigit  = displayString.substring(0, 1);
          $scope.secondDigit = displayString.substring(1, 2);
          $scope.thirdDigit  = displayString.substring(2, 3);
          $scope.fourthDigit = displayString.substring(3, 4);
        }

        $scope.$watch('pointValue', function () {
          updateDisplay();
        });
      }]
    };
  });

'use strict';

angular
  .module('pricePlanChanges')
  .directive('rowHr', function() {
    return {
      restrict: 'E',
      scope: {
        resKey: '@',
      },
      templateUrl: 'scripts/directives/pricePlanChanges/widgets/row-hr/row-hr.html',
      controller: function() {

      },
    };
  });

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            angular.module('ute.dtm.service', []);
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                angular.module('ute.rogers.user.registration', [
                    'ute.blocks.router',
                    'pascalprecht.translate',
                    'duScroll',
                    'ngMessages',
                    'ute.dtm.service',
                    'ute.common.encryption',
                    'pascalprecht.translate'
                ]);
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            'use strict';
            angular.module('ute.common.user', [
                'ute.blocks.persistent.storage',
                'ute.blocks.exception',
                'ute.common.utils',
                'ute.blocks.messages.bus',
                // ute.common.utils.UtilsStatic.getCookieModule()
                angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'
            ]);
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            angular.module('ute.common.core', [
                angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies',
                'ute.common.core.brtswitch',
                'ute.common.core.caching',
                'ute.common.core.subpub'
            ]);
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var decorator;
        (function (decorator) {
            var directives;
            (function (directives) {
                'use strict';
                angular.module('ute.common.decorator.directives', ['ng']);
            })(directives = decorator.directives || (decorator.directives = {}));
        })(decorator = common.decorator || (common.decorator = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter', ['ng', 'pascalprecht.translate']);
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            'use strict';
            angular.module('ute.common.utils', []);
        })(utils = common.utils || (common.utils = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                angular.module('ute.datalayer.common', []);
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var deeplink;
        (function (deeplink) {
            var service;
            (function (service) {
                'use strict';
                angular.module('ute.rogers.deeplink', [
                    'ute.common.user',
                    'ute.blocks.router',
                    'ute.blocks.logger',
                    'ute.blocks.messages.bus',
                    'ute.common.security',
                    'ute.blocks.persistent.storage'
                ]);
            })(service = deeplink.service || (deeplink.service = {}));
        })(deeplink = rogers.deeplink || (rogers.deeplink = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                angular.module('ute.blocks.language.switcher', [angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies', 'pascalprecht.translate', 'tmh.dynamicLocale']);
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
            angular.module('ute.common.encryption', [
                'ute.blocks.logger',
                'mdo-angular-cryptography',
                'ute.common.user',
                'ute.blocks.router'
            ]);
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var fraud;
    (function (fraud) {
        var logging;
        (function (logging) {
            'use strict';
            angular.module('ute.fraud.logging', []);
        })(logging = fraud.logging || (fraud.logging = {}));
    })(fraud = ute.fraud || (ute.fraud = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var messages;
        (function (messages) {
            var bus;
            (function (bus) {
                'use strict';
                angular.module('ute.blocks.messages.bus', ['ute.blocks.logger']);
            })(bus = messages.bus || (messages.bus = {}));
        })(messages = blocks.messages || (blocks.messages = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var permissions;
        (function (permissions) {
            var service;
            (function (service) {
                'use strict';
                angular.module('ute.common.permissions', [
                    'ute.blocks.exception',
                    'ute.common.user',
                    'ute.common.security'
                ]);
            })(service = permissions.service || (permissions.service = {}));
        })(permissions = common.permissions || (common.permissions = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                angular.module('ute.blocks.persistent.storage', [
                    'ngStorage'
                ]);
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                angular.module('ute.common.reactivate.ctn', [
                    'ute.blocks.router',
                    'ute.common.component.directives',
                    'ute.common.runtime.translate',
                    'ute.common.filter',
                    'ute.rogers.deeplink',
                    'ute.common.security'
                ]);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                angular.module('ute.common.voicemail.resetPassword', [
                    'ui.bootstrap',
                    'ngMessages',
                    'pascalprecht.translate',
                    'duScroll',
                    'ute.common.encryption',
                    'ute.common.filter',
                    'ute.common.decorator.directives',
                    'ute.common.security'
                ]);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var datalayer;
        (function (datalayer) {
            var integration;
            (function (integration) {
                var common;
                (function (common) {
                    var service;
                    (function (service) {
                        'use strict';
                        angular.module('ute.rogers.datalayer.integration.common', ['ute.datalayer.common', 'ute.blocks.persistent.storage', 'ui.router', 'ct.ui.router.extras']);
                    })(service = common.service || (common.service = {}));
                })(common = integration.common || (integration.common = {}));
            })(integration = datalayer.integration || (datalayer.integration = {}));
        })(datalayer = rogers.datalayer || (rogers.datalayer = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var interceptors;
        (function (interceptors) {
            var auth;
            (function (auth) {
                'use strict';
                angular.module('ute.rogers.interceptors.auth', ['ute.blocks.messages.bus']);
            })(auth = interceptors.auth || (interceptors.auth = {}));
        })(interceptors = rogers.interceptors || (rogers.interceptors = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
                angular.module('ute.rogers.siteminder.signin', [
                    'ute.blocks.exception',
                    'ute.blocks.environment',
                    'ute.blocks.router',
                    'ute.common.core',
                    'ute.common.user',
                    'ute.blocks.messages.bus',
                    angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'
                ]);
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var runtime;
        (function (runtime) {
            var translate;
            (function (translate) {
                'use strict';
                angular.module('ute.common.runtime.translate', ['pascalprecht.translate']);
            })(translate = runtime.translate || (runtime.translate = {}));
        })(runtime = common.runtime || (common.runtime = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var security;
        (function (security) {
            'use strict';
            angular.module('ute.common.security', [
                'ute.blocks.logger',
                'ute.common.user'
            ]);
        })(security = common.security || (common.security = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change', [
                        'ute.common.simcard.change.form',
                        'ute.common.simcard.change.confirmation',
                        'ute.common.simcard.change.success',
                        'ute.common.simcard.change.service',
                        'ute.blocks.router',
                        'ute.common.decorator.directives',
                        'ui.bootstrap',
                        'ngMessages',
                        'pascalprecht.translate',
                        'duScroll',
                        'ute.common.encryption',
                        'ute.payment.helper.view',
                        'ute.common.filter',
                        'ute.common.permissions',
                        'ute.rogers.deeplink',
                        'ute.datalayer.common'
                    ]);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            angular.module('ute.rogers.setpassword', [
                'ute.blocks.router',
                'pascalprecht.translate',
                'ute.janrain.verification',
                'duScroll',
                'ngMessages',
                'ute.common.utils',
                'ui.bootstrap',
                'ute.rogers.siteminder.signin',
                'ute.datalayer.common',
                'ute.blocks.persistent.storage'
            ]);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            'use strict';
            angular.module('ute.janrain.verification', [
                'ute.common.core',
                'ute.blocks.environment',
                'ute.blocks.persistent.storage',
                'ui.bootstrap',
                'ute.common.utils',
                'ute.common.encryption'
            ]);
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                angular.module('ute.common.suspend.ctn', [
                    'ute.blocks.router',
                    'ui.bootstrap',
                    'ngMessages',
                    'pascalprecht.translate',
                    'ute.common.runtime.translate',
                    'duScroll',
                    'ute.common.encryption',
                    'ute.common.filter',
                    'ute.rogers.deeplink',
                    'ute.common.security'
                ]);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var subpub;
            (function (subpub) {
                'use strict';
                angular.module('ute.common.core.subpub', []);
            })(subpub = core.subpub || (core.subpub = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                angular.module('ute.common.core.brtswitch', ['ute.blocks.exception']);
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
                angular.module('ute.common.core.caching', [
                    'ute.common.core.subpub'
                ]);
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var environment;
        (function (environment) {
            'use strict';
            angular.module('ute.blocks.environment', ['ute.blocks.exception', 'config']);
        })(environment = blocks.environment || (blocks.environment = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var exception;
        (function (exception) {
            'use strict';
            angular.module('ute.blocks.exception', ['ute.blocks.logger']);
        })(exception = blocks.exception || (blocks.exception = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var logger;
        (function (logger) {
            'use strict';
            angular.module('ute.blocks.logger', []);
        })(logger = blocks.logger || (blocks.logger = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.service', [
                        'ute.common.encryption',
                        'ute.common.user',
                        'ute.common.security'
                    ]);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
            angular.module('ute.common.encryption', [
                'ute.blocks.logger',
                'mdo-angular-cryptography',
                'ute.common.user',
                'ute.blocks.router'
            ]);
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            angular.module('ute.blocks.router', [
                'ui.router',
                'ute.blocks.logger',
                'pascalprecht.translate'
            ]);
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

/// <reference path="../.tmp/typings/tsd.d.ts" />

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user_1) {
            var service;
            (function (service) {
                'use strict';
            })(service = user_1.service || (user_1.service = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                var log;
                (function (log) {
                    'use strict';
                    (function (LogLevel) {
                        LogLevel[LogLevel["OFF"] = 0] = "OFF";
                        LogLevel[LogLevel["FATAL"] = 1] = "FATAL";
                        LogLevel[LogLevel["ERROR"] = 2] = "ERROR";
                        LogLevel[LogLevel["WARN"] = 3] = "WARN";
                        LogLevel[LogLevel["INFO"] = 4] = "INFO";
                        LogLevel[LogLevel["DEBUG"] = 5] = "DEBUG";
                        LogLevel[LogLevel["TRACE"] = 6] = "TRACE";
                        LogLevel[LogLevel["ALL"] = 7] = "ALL";
                    })(log.LogLevel || (log.LogLevel = {}));
                    var LogLevel = log.LogLevel;
                })(log = api.log || (api.log = {}));
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                'use strict';
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                var types;
                (function (types) {
                    'use strict';
                })(types = api.types || (api.types = {}));
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                service.formErrorDefaultFieldName = '<not specified>';
                (function (ErrorType) {
                    ErrorType[ErrorType["FORM"] = 0] = "FORM";
                    ErrorType[ErrorType["SELF_SERVE"] = 1] = "SELF_SERVE";
                    ErrorType[ErrorType["HTTP"] = 2] = "HTTP";
                    ErrorType[ErrorType["SIGNIN"] = 3] = "SIGNIN";
                    ErrorType[ErrorType["LOCATION"] = 4] = "LOCATION";
                    ErrorType[ErrorType["CREDIT"] = 5] = "CREDIT";
                    ErrorType[ErrorType["USER"] = 6] = "USER";
                    ErrorType[ErrorType["BUSINESS_LOGIC"] = 7] = "BUSINESS_LOGIC";
                })(service.ErrorType || (service.ErrorType = {}));
                var ErrorType = service.ErrorType;
                (function (DataLayerPredefinedSection) {
                    DataLayerPredefinedSection[DataLayerPredefinedSection["ACCOUNT"] = 0] = "ACCOUNT";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["PAGE"] = 1] = "PAGE";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["PAGE_VIEW_EVENT"] = 2] = "PAGE_VIEW_EVENT";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["SIGNIN"] = 3] = "SIGNIN";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["SITE"] = 4] = "SITE";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["GLOBAL"] = 5] = "GLOBAL";
                })(service.DataLayerPredefinedSection || (service.DataLayerPredefinedSection = {}));
                var DataLayerPredefinedSection = service.DataLayerPredefinedSection;
                (function (ErrorCategory) {
                    ErrorCategory[ErrorCategory["BUYFLOW"] = 0] = "BUYFLOW";
                    ErrorCategory[ErrorCategory["SELF_SERVE"] = 1] = "SELF_SERVE";
                    ErrorCategory[ErrorCategory["LOGIN"] = 2] = "LOGIN";
                    ErrorCategory[ErrorCategory["VAS"] = 3] = "VAS";
                })(service.ErrorCategory || (service.ErrorCategory = {}));
                var ErrorCategory = service.ErrorCategory;
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var deeplink;
        (function (deeplink) {
            var service;
            (function (service) {
                'use strict';
            })(service = deeplink.service || (deeplink.service = {}));
        })(deeplink = rogers.deeplink || (rogers.deeplink = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            var DtmServiceAction = (function () {
                function DtmServiceAction() {
                }
                DtmServiceAction.START = 'started';
                DtmServiceAction.COMPLETE = 'completed';
                DtmServiceAction.EXCEPTION = 'error';
                return DtmServiceAction;
            }());
            service.DtmServiceAction = DtmServiceAction;
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var fraud;
    (function (fraud) {
        var logging;
        (function (logging) {
            'use strict';
        })(logging = fraud.logging || (fraud.logging = {}));
    })(fraud = ute.fraud || (ute.fraud = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var permissions;
        (function (permissions) {
            var service;
            (function (service) {
                'use strict';
                /**
                 * List of all available user permissions
                 */
                (function (UserPermissions) {
                    UserPermissions[UserPermissions["SSA"] = 0] = "SSA";
                    UserPermissions[UserPermissions["USERNAME_MIGRATION"] = 1] = "USERNAME_MIGRATION";
                    UserPermissions[UserPermissions["PPC_PAGE_VIEW"] = 2] = "PPC_PAGE_VIEW";
                    UserPermissions[UserPermissions["RESET_VOICE_MAIL_PASSWORD"] = 3] = "RESET_VOICE_MAIL_PASSWORD";
                    UserPermissions[UserPermissions["SSA_PAGE_VIEW"] = 4] = "SSA_PAGE_VIEW";
                    UserPermissions[UserPermissions["REVOLUTION"] = 5] = "REVOLUTION";
                    UserPermissions[UserPermissions["PPC_UTE"] = 6] = "PPC_UTE";
                    UserPermissions[UserPermissions["TPSA_PAGE_VIEW"] = 7] = "TPSA_PAGE_VIEW";
                    UserPermissions[UserPermissions["RFR"] = 8] = "RFR";
                    UserPermissions[UserPermissions["CHANGE_SIM_CARD"] = 9] = "CHANGE_SIM_CARD";
                    UserPermissions[UserPermissions["SUSPEND_CTN"] = 10] = "SUSPEND_CTN";
                    UserPermissions[UserPermissions["REACTIVATE_CTN"] = 11] = "REACTIVATE_CTN";
                    UserPermissions[UserPermissions["ONEVIEW_CHANGE_SIM_CARD_DEALER"] = 12] = "ONEVIEW_CHANGE_SIM_CARD_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_RESET_VOICE_MAIL_PASSWORD_DEALER"] = 13] = "ONEVIEW_RESET_VOICE_MAIL_PASSWORD_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_CHANGE_SIM_CARD_CARE"] = 14] = "ONEVIEW_CHANGE_SIM_CARD_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_RESET_VOICE_MAIL_PASSWORD_CARE"] = 15] = "ONEVIEW_RESET_VOICE_MAIL_PASSWORD_CARE";
                    UserPermissions[UserPermissions["RAM"] = 16] = "RAM";
                    UserPermissions[UserPermissions["ONEVIEW_REVOLUTION_CARE"] = 17] = "ONEVIEW_REVOLUTION_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_PAY_NOW_DEALER"] = 18] = "ONEVIEW_PAY_NOW_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_PAY_NOW_CARE"] = 19] = "ONEVIEW_PAY_NOW_CARE";
                    UserPermissions[UserPermissions["RFR_TWILIGHT_VIEW"] = 20] = "RFR_TWILIGHT_VIEW";
                    UserPermissions[UserPermissions["ONEVIEW_UPDATE_PAYMENT_METHOD_CARE"] = 21] = "ONEVIEW_UPDATE_PAYMENT_METHOD_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_UPDATE_PAYMENT_METHOD_DEALER"] = 22] = "ONEVIEW_UPDATE_PAYMENT_METHOD_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_PROFILE_UNLOCK_CARE"] = 23] = "ONEVIEW_PROFILE_UNLOCK_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_PROFILE_UNLOCK_DEALER"] = 24] = "ONEVIEW_PROFILE_UNLOCK_DEALER";
                    UserPermissions[UserPermissions["DATA_MANAGER_CONSUMER"] = 25] = "DATA_MANAGER_CONSUMER";
                    UserPermissions[UserPermissions["DISCOVERY_PAGE"] = 26] = "DISCOVERY_PAGE";
                    UserPermissions[UserPermissions["ONEVIEW_SUSPEND_CTN_CARE"] = 27] = "ONEVIEW_SUSPEND_CTN_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_SUSPEND_CTN_DEALER"] = 28] = "ONEVIEW_SUSPEND_CTN_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_REACTIVATE_CTN_CARE"] = 29] = "ONEVIEW_REACTIVATE_CTN_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_REACTIVATE_CTN_DEALER"] = 30] = "ONEVIEW_REACTIVATE_CTN_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_INTERACTION_NOTES_DEALER"] = 31] = "ONEVIEW_INTERACTION_NOTES_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_INTERACTION_NOTES_CARE"] = 32] = "ONEVIEW_INTERACTION_NOTES_CARE";
                    UserPermissions[UserPermissions["TAZO_UTE_PAGE_VIEW"] = 33] = "TAZO_UTE_PAGE_VIEW";
                    UserPermissions[UserPermissions["ONEVIEW_PROFILE_DEALER"] = 34] = "ONEVIEW_PROFILE_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_PROFILE_CARE"] = 35] = "ONEVIEW_PROFILE_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_REVOLUTION_DEALER"] = 36] = "ONEVIEW_REVOLUTION_DEALER";
                    UserPermissions[UserPermissions["PROFILE_EDIT_USERNAME"] = 37] = "PROFILE_EDIT_USERNAME";
                    UserPermissions[UserPermissions["ENHANCED_SAVE_BILL"] = 38] = "ENHANCED_SAVE_BILL";
                    UserPermissions[UserPermissions["ONEVIEW_RETENTION_PLANS_DEALER"] = 39] = "ONEVIEW_RETENTION_PLANS_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_RETENTION_PLANS_CARE"] = 40] = "ONEVIEW_RETENTION_PLANS_CARE";
                    UserPermissions[UserPermissions["CHANGE_SUBSCRIBER_NAME"] = 41] = "CHANGE_SUBSCRIBER_NAME";
                    UserPermissions[UserPermissions["CHANGE_SUBSCRIBER_NAME_ONEVIEW"] = 42] = "CHANGE_SUBSCRIBER_NAME_ONEVIEW";
                })(service.UserPermissions || (service.UserPermissions = {}));
                var UserPermissions = service.UserPermissions;
                /**
                 * List of all available resource codes for RAM permissions
                 * Used string type declaration to accept '.' inside the enum
                 */
                (function (RamResourceCodes) {
                    RamResourceCodes[RamResourceCodes["OneView"] = 'OneView'] = "OneView";
                    RamResourceCodes[RamResourceCodes["Rogers"] = 'Rogers'] = "Rogers";
                    RamResourceCodes[RamResourceCodes["InteractionHistory"] = 'InteractionHistory'] = "InteractionHistory";
                    RamResourceCodes[RamResourceCodes["CustomerProfile"] = 'CustomerProfile'] = "CustomerProfile";
                    RamResourceCodes[RamResourceCodes["MakePayment"] = 'MakePayment'] = "MakePayment";
                    RamResourceCodes[RamResourceCodes["SingleLinePPCBuyFlow"] = 'SingleLinePPCBuyFlow'] = "SingleLinePPCBuyFlow";
                    RamResourceCodes[RamResourceCodes["OfferSale"] = 'Offer.Sale'] = "OfferSale";
                    RamResourceCodes[RamResourceCodes["RoamLikeHome"] = 'RoamLikeHome'] = "RoamLikeHome";
                    RamResourceCodes[RamResourceCodes["PromiseToPay"] = 'PromiseToPay'] = "PromiseToPay";
                    RamResourceCodes[RamResourceCodes["TransferOfResponsibility"] = 'TransferOfResponsibility'] = "TransferOfResponsibility";
                    RamResourceCodes[RamResourceCodes["CreditManagement"] = 'CreditManagement'] = "CreditManagement";
                    RamResourceCodes[RamResourceCodes["RepFooter"] = 'RepFooter'] = "RepFooter";
                    RamResourceCodes[RamResourceCodes["ProfileContactInfo"] = 'ProfileContactInfo'] = "ProfileContactInfo";
                    RamResourceCodes[RamResourceCodes["ProfileBillingDetails"] = 'ProfileBillingDetails'] = "ProfileBillingDetails";
                    RamResourceCodes[RamResourceCodes["HUPBuyFlow"] = 'HUPBuyFlow'] = "HUPBuyFlow";
                    RamResourceCodes[RamResourceCodes["RetentionOfferBuyFlow"] = 'RetentionOfferBuyFlow'] = "RetentionOfferBuyFlow";
                    RamResourceCodes[RamResourceCodes["PointsToMentionBuyFlow"] = 'PointsToMentionBuyFlow'] = "PointsToMentionBuyFlow";
                    RamResourceCodes[RamResourceCodes["FutureDatePPCBuyFlow"] = 'FutureDatePPCBuyFlow'] = "FutureDatePPCBuyFlow";
                    RamResourceCodes[RamResourceCodes["DealerCode"] = 'DealerCode'] = "DealerCode";
                    RamResourceCodes[RamResourceCodes["PPCBuyFlow"] = 'PPCBuyFlow'] = "PPCBuyFlow";
                    RamResourceCodes[RamResourceCodes["CreditCardCapture"] = 'CreditCardCapture'] = "CreditCardCapture";
                    RamResourceCodes[RamResourceCodes["OneviewFooter"] = 'OneviewFooter'] = "OneviewFooter";
                })(service.RamResourceCodes || (service.RamResourceCodes = {}));
                var RamResourceCodes = service.RamResourceCodes;
                /**
                 * List of all available action codes for RAM permissions
                 */
                (function (RamActionCodes) {
                    RamActionCodes[RamActionCodes["read"] = 0] = "read";
                    RamActionCodes[RamActionCodes["update"] = 1] = "update";
                    RamActionCodes[RamActionCodes["start"] = 2] = "start";
                    RamActionCodes[RamActionCodes["remove"] = 3] = "remove";
                    RamActionCodes[RamActionCodes["make"] = 4] = "make";
                    RamActionCodes[RamActionCodes["add"] = 5] = "add";
                    RamActionCodes[RamActionCodes["grant"] = 6] = "grant";
                    RamActionCodes[RamActionCodes["inprogress"] = 7] = "inprogress";
                    RamActionCodes[RamActionCodes["enable"] = 8] = "enable";
                    RamActionCodes[RamActionCodes["mandatory"] = 9] = "mandatory";
                    RamActionCodes[RamActionCodes["manual"] = 10] = "manual";
                    RamActionCodes[RamActionCodes["reader"] = 11] = "reader";
                })(service.RamActionCodes || (service.RamActionCodes = {}));
                var RamActionCodes = service.RamActionCodes;
            })(service = permissions.service || (permissions.service = {}));
        })(permissions = common.permissions || (common.permissions = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                var RogersStoreKeys = (function () {
                    function RogersStoreKeys() {
                    }
                    RogersStoreKeys.IS_LOGIN = 'ute.rogers.signin.service.isLogin';
                    RogersStoreKeys.ROGERS_SIGNIN_USER = 'ute.rogers.signin.user';
                    RogersStoreKeys.ROGERS_DEEP_LINK_STATE = 'ute.rogers.deep.link.state';
                    RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER = 'phoneNumber';
                    RogersStoreKeys.ROGERS_SELECTED_HOME_PHONE_NUMBER = 'homePhoneNumber';
                    RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER = 'tvAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_SHM_ACCOUNT_NUMBER = 'shmAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_IPTV_ACCOUNT_NUMBER = 'iptvAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER = 'internetAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER = 'accountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_BRITEBILL_ID = 'ute.rogers.selected.britebill.id';
                    RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER = 'accountTypeNumber';
                    RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION = 'ssoCodeVerification';
                    RogersStoreKeys.ROGERS_SESSION_TOKEN = 'ute.rogers.signin.sessionToken';
                    RogersStoreKeys.ROGERS_REMEMBER_ME = 'ute.rogers.signin.rememberMe';
                    RogersStoreKeys.ROGERS_ONEVIEW_REPVIEW = 'isRepView';
                    RogersStoreKeys.ROGERS_X_SESSION_TOKEN = 'x_session_token';
                    return RogersStoreKeys;
                }());
                storage.RogersStoreKeys = RogersStoreKeys;
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var datalayer;
        (function (datalayer) {
            var integration;
            (function (integration) {
                var common;
                (function (common) {
                    var service;
                    (function (service) {
                        'use strict';
                    })(service = common.service || (common.service = {}));
                })(common = integration.common || (integration.common = {}));
            })(integration = datalayer.integration || (datalayer.integration = {}));
        })(datalayer = rogers.datalayer || (rogers.datalayer = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var runtime;
        (function (runtime) {
            var translate;
            (function (translate) {
                'use strict';
            })(translate = runtime.translate || (runtime.translate = {}));
        })(runtime = common.runtime || (common.runtime = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var security;
        (function (security) {
            'use strict';
        })(security = common.security || (common.security = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                /**
                 * List of all available BRT switches
                 */
                (function (BrtSwitches) {
                    BrtSwitches[BrtSwitches["PPC_UTE"] = 0] = "PPC_UTE";
                    BrtSwitches[BrtSwitches["NPPC_UTE"] = 1] = "NPPC_UTE";
                    BrtSwitches[BrtSwitches["ONEVIEW_RLH"] = 2] = "ONEVIEW_RLH";
                    BrtSwitches[BrtSwitches["REGISTRATION"] = 3] = "REGISTRATION";
                    BrtSwitches[BrtSwitches["USERNAME_MIGRATION"] = 4] = "USERNAME_MIGRATION";
                    BrtSwitches[BrtSwitches["ONEVIEW_HUP"] = 5] = "ONEVIEW_HUP";
                    BrtSwitches[BrtSwitches["BRITEBILL_UTE"] = 6] = "BRITEBILL_UTE";
                    BrtSwitches[BrtSwitches["HUP_UTE"] = 7] = "HUP_UTE";
                    BrtSwitches[BrtSwitches["HUP_RESP_MIGRATION"] = 8] = "HUP_RESP_MIGRATION";
                    BrtSwitches[BrtSwitches["NRS"] = 9] = "NRS";
                    BrtSwitches[BrtSwitches["SSA"] = 10] = "SSA";
                    BrtSwitches[BrtSwitches["REVOLUTION"] = 11] = "REVOLUTION";
                    BrtSwitches[BrtSwitches["RFR"] = 12] = "RFR";
                    BrtSwitches[BrtSwitches["MULTI_NPPC_UTE"] = 13] = "MULTI_NPPC_UTE";
                    BrtSwitches[BrtSwitches["CHANGE_SIM_CARD"] = 14] = "CHANGE_SIM_CARD";
                    BrtSwitches[BrtSwitches["JANRAIN_REGISTRATION"] = 15] = "JANRAIN_REGISTRATION";
                })(brtswitch.BrtSwitches || (brtswitch.BrtSwitches = {}));
                var BrtSwitches = brtswitch.BrtSwitches;
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                    (function (FrontEndErrorCode) {
                        FrontEndErrorCode[FrontEndErrorCode["UPDATED_OK"] = 0] = "UPDATED_OK";
                        FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                    })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                    var FrontEndErrorCode = service.FrontEndErrorCode;
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    (function (FrontEndErrorCode) {
                        FrontEndErrorCode[FrontEndErrorCode["UPDATED_OK"] = 0] = "UPDATED_OK";
                        FrontEndErrorCode[FrontEndErrorCode["CURRENT_SIM_CARD_NOT_VALID_ERROR"] = 1] = "CURRENT_SIM_CARD_NOT_VALID_ERROR";
                        FrontEndErrorCode[FrontEndErrorCode["NEW_SIM_CARD_NOT_VALID_ERROR"] = 2] = "NEW_SIM_CARD_NOT_VALID_ERROR";
                        FrontEndErrorCode[FrontEndErrorCode["NEW_SIM_CARD_IN_USE_ERROR"] = 3] = "NEW_SIM_CARD_IN_USE_ERROR";
                        FrontEndErrorCode[FrontEndErrorCode["NEW_SIM_HAS_BEEN_USED_BEFORE"] = 4] = "NEW_SIM_HAS_BEEN_USED_BEFORE";
                        FrontEndErrorCode[FrontEndErrorCode["NEW_SIM_HAS_INVALID_SIM_PREFIX"] = 5] = "NEW_SIM_HAS_INVALID_SIM_PREFIX";
                        FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 6] = "GENERIC_ERROR";
                    })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                    var FrontEndErrorCode = service.FrontEndErrorCode;
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var resend;
            (function (resend) {
                var email;
                (function (email) {
                    'use strict';
                })(email = resend.email || (resend.email = {}));
            })(resend = verification.resend || (verification.resend = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                    (function (FrontEndErrorCode) {
                        FrontEndErrorCode[FrontEndErrorCode["UPDATED_OK"] = 0] = "UPDATED_OK";
                        FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                    })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                    var FrontEndErrorCode = service.FrontEndErrorCode;
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            var StateHandlerPriority = (function () {
                function StateHandlerPriority() {
                }
                StateHandlerPriority.LOW = 0;
                StateHandlerPriority.MEDIUM_LOW = 2500;
                StateHandlerPriority.MEDIUM = 5000;
                StateHandlerPriority.MEDIUM_HIGH = 7500;
                StateHandlerPriority.HIGH = 10000;
                return StateHandlerPriority;
            }());
            router.StateHandlerPriority = StateHandlerPriority;
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var TestAbstract = (function () {
                    function TestAbstract() {
                        this.restrict = 'E';
                        this.transclude = true;
                        this.template = '<div data-ng-if="test.test()"><ng-transclude></ng-transclude></div>';
                        this.scope = {};
                        this.controllerAs = 'test';
                        this.bindToController = true;
                    }
                    return TestAbstract;
                }());
                directives.TestAbstract = TestAbstract;
                var ControllerAbstract = (function () {
                    function ControllerAbstract(routerHelper) {
                        this.routerHelper = routerHelper;
                        this.test = function () { return false; };
                        this.statesArray = this.states ? this.states.split(',').map(function (s) { return s.trim(); }) : [];
                    }
                    return ControllerAbstract;
                }());
                directives.ControllerAbstract = ControllerAbstract;
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTestAbstract = (function () {
                    function UserTestAbstract() {
                        this.restrict = 'E';
                        this.transclude = true;
                        this.template = '<div data-ng-if="user.test()"><ng-transclude></ng-transclude></div>';
                        this.scope = {};
                        this.controllerAs = 'user';
                    }
                    return UserTestAbstract;
                }());
                directives.UserTestAbstract = UserTestAbstract;
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var subpub;
            (function (subpub) {
                'use strict';
                var SubPubGeneric = (function () {
                    function SubPubGeneric(logPrefix) {
                        var _this = this;
                        this.logPrefix = logPrefix;
                        this.onDataChangeSubs = [];
                        /**
                         * @param callback
                         * @param id
                         * @returns {boolean}
                         */
                        this.registerOnDataChangeHandler = function (callback, id) {
                            if (callback && id) {
                                var found = _.find(_this.onDataChangeSubs, function (val) { return val.id === id; });
                                if (found) {
                                    found.callback = callback;
                                }
                                else {
                                    _this.onDataChangeSubs.push({ callback: callback, id: id });
                                }
                                // console.log(this.logPrefix + '->registerOnDataChangeHandler: Subs size=', this.onDataChangeSubs.length, 'id=', id, 'subs=', this.onDataChangeSubs);
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        this.unregisterOnDataChangeHandler = function (id) {
                            _this.onDataChangeSubs = _this.onDataChangeSubs.filter(function (o, index, array) { return o.id !== id; });
                            // if (this.subPubConfig.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                            // console.log(this.logPrefix + '->unregisterOnDataChangeHandler: onDataChangeSubs size=', this.onDataChangeSubs.length, 'id=', id, 'subs=', this.onDataChangeSubs);
                            // }
                            return true; // TODO
                        };
                        this.getSubsSize = function () { return _this.onDataChangeSubs.length; };
                        this.notifySubs = function () {
                            _this.onDataChangeSubs.forEach(function (handler) {
                                try {
                                    // console.log(this.logPrefix + '->notifySubs: handlerId=', handler.id, this.getChangableData());
                                    // noinspection TypeScriptValidateTypes
                                    handler.callback(_this.getChangableData());
                                }
                                catch (e) {
                                    console.log(_this.logPrefix + '->notifySubs->handler.callback->catch:', e, handler.id, _this.getChangableData());
                                }
                            });
                        };
                    }
                    return SubPubGeneric;
                }());
                subpub.SubPubGeneric = SubPubGeneric;
                angular.module('ute.common.core.subpub').constant('SubPubGeneric', SubPubGeneric);
            })(subpub = core.subpub || (core.subpub = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
                var CacheableDataGeneric = (function (_super) {
                    __extends(CacheableDataGeneric, _super);
                    function CacheableDataGeneric(data, config, securityService, $http, $q, $timeout, userService, request) {
                        var _this = this;
                        _super.call(this, config.basic.logPrefix);
                        this.data = data;
                        this.config = config;
                        this.securityService = securityService;
                        this.$http = $http;
                        this.$q = $q;
                        this.$timeout = $timeout;
                        this.userService = userService;
                        this.request = request;
                        /**
                         * @returns {IPromise<T>}
                         */
                        this.getData = function () {
                            if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                console.log(_this.config.basic.logPrefix + '->getData: onDataChangeHandlers.size=', _this.getSubsSize(), 'cachedResultInfo=', _.get(_this.cacheableData, 'cachedResultInfo'), 'isCallInProgress=', _this.isCallInProgress(), 'logLevel=', _this.config.basic.logLevel, ute.common.typescript.api.log.LogLevel.DEBUG);
                            }
                            if (_this.isDataLocallyCached()) {
                                if (!_this.callInProgress) {
                                    if (_this.config.basic.isCachableOnBackend && !_this.isBackendDataUpToDate()) {
                                        // returned locally cached data but schedule call to MW and notify all subs when data arrived
                                        _this.getDataRefresh(true, true);
                                    }
                                    else if (!_this.isLocalDataUpToDate()) {
                                        // returned locally cached data but schedule call to Play!/Cassandra and notify all subs when data arrived
                                        _this.getDataRefresh(false, true);
                                    }
                                }
                                // return this.$q.when<IAccountOverview>(angular.copy(this.accountOverviewData.data)); // old style
                                return new _this.$q(function (resolve) { return resolve(_.cloneDeep(_this.cacheableData.data)); });
                            }
                            else if (_this.callInProgress) {
                                // other call with the same request data
                                return _this.callInProgress;
                            }
                            else {
                                // Fastest way to get it from Play!/Cassandra
                                return _this.getDataRefresh(false);
                            }
                        };
                        /**
                         *
                         * @param refresh - true | false | undefined
                         * @param async - true - call has been instantiated internally and result will be processed by subpub
                         * @returns {IPromise<T>}
                         */
                        this.getDataRefresh = function (refresh, async) {
                            if (async === void 0) { async = false; }
                            var base = {
                                applicationId: _this.config.basic.applicationId,
                            };
                            if (_this.config.basic.isCachableOnBackend && !_.isUndefined(refresh)) {
                                base.refresh = refresh;
                            }
                            var config = angular.isObject(_this.$http.defaults) ? {
                                transformRequest: (_.get(_this.config, 'basic.$http.transformRequest') ? [].concat(_this.$http.defaults.transformRequest, _this.config.basic.$http.transformRequest) : _this.$http.defaults.transformRequest),
                                transformResponse: (_.get(_this.config, 'basic.$http.transformResponse') ? [].concat(_this.$http.defaults.transformResponse, _this.config.basic.$http.transformResponse) : _this.$http.defaults.transformResponse)
                            } : {};
                            config = angular.extend(config, async ? { extraInfo: { async: async } } : {});
                            // const config: IRequestShortcutConfig & any = async ? {extraInfo: {async: async}} : undefined;
                            var request = _.assign(base, _this.request);
                            _this.callInProgress = _this.$http.post(_this.securityService.getBackendUrl(_this.config.basic.partialApiUrl), request, config)
                                .then(_this.processOk)
                                .catch(_this.processError);
                            return _this.callInProgress;
                        };
                        /**
                         * @param response
                         * @returns {T}
                         */
                        this.processOk = function (response) {
                            _this.callInProgress = null;
                            if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                console.log(_this.config.basic.logPrefix + '->processOk:', 'response.config.data=', response.config.data, 'cachedResultInfo=', response.data.cachedResultInfo, 'onDataChangeHandlers.size=', _this.getSubsSize());
                            }
                            var cachedResponse = false;
                            // Cachable or Not Cachable response
                            if (_.has(response.data, 'cachedResultInfo.cachedDate')) {
                                cachedResponse = true;
                                // incomming data just a string
                                response.data.cachedResultInfo.cachedDate = new Date(response.data.cachedResultInfo.cachedDate.toString());
                            }
                            // If No Local Cache or backend(Play!/Cassandra) cache has been updated
                            if (!_this.isDataLocallyCached() || !cachedResponse || _this.isBackendCacheHasBeenUpdated(response.data.cachedResultInfo.cachedDate)) {
                                var rawData = angular.extend({}, response.data);
                                if (cachedResponse) {
                                    var cachedResultInfo = {
                                        cachedDate: response.data.cachedResultInfo.cachedDate,
                                        cacheExpiryDate: new Date(response.data.cachedResultInfo.cacheExpiryDate.toString()),
                                        expired: Boolean(response.data.cachedResultInfo.expired)
                                    };
                                    delete response.data.cachedResultInfo; // Do not expose cachedResultInfo to the public
                                    // local cache
                                    _this.cacheableData = {
                                        cachedResultInfo: cachedResultInfo,
                                        localCachedDate: new Date(),
                                        data: _this.normalizeData(angular.extend(_this.data, response.data), rawData)
                                    };
                                }
                                else {
                                    delete response.data.cachedResultInfo; // Do not expose cachedResultInfo to the public
                                    // local cache
                                    _this.cacheableData = {
                                        localCachedDate: new Date(),
                                        data: _this.normalizeData(angular.extend(_this.data, response.data), rawData)
                                    };
                                }
                                if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                    console.log(_this.config.basic.logPrefix + '->LocalCache:', 'cacheableData:', _this.cacheableData);
                                }
                                if (_this.config.basic.isCachableOnBackend && !_this.isRefreshRequested(response.config.data) && !_this.isBackendDataUpToDate()) {
                                    _this.getDataRefresh(true, true);
                                }
                                // only if it's background call //TODO clear distinct between original call with promise returned to the caller and background async call
                                if (_.get(response.config, 'extraInfo.async')) {
                                    // if (this.isRefreshRequested(response.config.data)) {
                                    _this._notifySubs();
                                }
                            }
                            else {
                                _this.cacheableData.localCachedDate = new Date();
                            }
                            // if (this.isBackendDataUpToDate()) {
                            //   this.refreshCount = 1;
                            // } else {
                            // if backend return already expired data on refreshed request - schedule it
                            // If No scheduled and we tried already
                            /*
                             if (!this.scheduledRefresh && this.isRefreshRequested(response.config.data)) {
                             if (this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                             console.log(this.config.basic.logPrefix + '->scheduledRefresh: scheduled full refresh from MW in ' + 10 * this.refreshCount + ' sec');
                             }
                             this.scheduledRefresh = this.$timeout(() => {
                             this.getDataRefresh(true, true); // TODO if refreshable
                             }, 10000 * this.refreshCount); // 10 sec * n
                             this.refreshCount++;
                      
                             this.scheduledRefresh.finally(() => this.scheduledRefresh = null);
                             }
                             */
                            // }
                            // return immutable copy
                            return _.cloneDeep(_this.cacheableData.data);
                        };
                        /**
                         * normalizer backend datatypes
                         * default implementation - do nothing
                         * @param input
                         * @returns {T}
                         */
                        this.normalizeData = function (input, rawData) {
                            return input;
                        };
                        /**
                         * @param requestData
                         * @returns {boolean}
                         */
                        this.isRefreshRequested = function (requestData) {
                            return requestData.refresh === true;
                        };
                        /**
                         * @param error
                         * @returns {T}
                         */
                        this.processError = function (error) {
                            _this.callInProgress = null;
                            return new _this.$q(function (resolve, reject) { return reject(error); });
                        };
                        this.resetData = function () {
                            try {
                                _this.cleanup();
                            }
                            catch (e) {
                            }
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isCallInProgress = function () {
                            // return this.isCallInProgress;
                            return !!_this.callInProgress;
                        };
                        this._notifySubs = function () {
                            if (_this.isDataLocallyCached()) {
                                _this.notifySubs();
                            }
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isBackendCacheHasBeenUpdated = function (cachedDate) {
                            return angular.isDate(_.get(_this.cacheableData, 'cachedResultInfo.cachedDate')) && _this.cacheableData.cachedResultInfo.cachedDate.getTime() !== cachedDate.getTime();
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isDataLocallyCached = function () {
                            return _.isObject(_this.cacheableData);
                        };
                        /**
                         * Check if backend/Play!/Cassandra data up to date
                         * @returns {boolean}
                         */
                        this.isBackendDataUpToDate = function () {
                            var retval = _this.isDataLocallyCached() && (!_.get(_this.cacheableData, 'cachedResultInfo.expired', false) || _.get(_this.cacheableData, 'cachedResultInfo.expired', true) === false &&
                                _this.cacheableData.cachedResultInfo.cacheExpiryDate > new Date());
                            if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG && _this.isDataLocallyCached() && _.has(_this.cacheableData, 'cachedResultInfo.cacheExpiryDate')) {
                                console.log(_this.config.basic.logPrefix + '->isBackendDataUpToDate:', retval, 'diffTimestamp=', _this.cacheableData.cachedResultInfo.cacheExpiryDate.getTime() - new Date().getTime(), 'backend cacheExpiryDate=', _this.cacheableData.cachedResultInfo.cacheExpiryDate);
                            }
                            return retval;
                        };
                        this.cleanup = function () {
                            _this.cacheableData = null;
                            if (_this.scheduledRefresh) {
                                _this.$timeout.cancel(_this.scheduledRefresh);
                            }
                        };
                        /**
                         * Check if local data up to date - 60 sec for now
                         * @returns {boolean}
                         */
                        this.isLocalDataUpToDate = function () {
                            // TODO 60000
                            var retval = _this.isDataLocallyCached() /*&& this.isBackendDataUpToDate()*/ && new Date().getTime() - _this.cacheableData.localCachedDate.getTime() <= 60000;
                            if (_this.isDataLocallyCached() && _this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                console.log(_this.config.basic.logPrefix + '->isLocalDataUpToDate:', retval, 'diff=', new Date().getTime() - _this.cacheableData.localCachedDate.getTime(), 'localCachedDate=', _this.cacheableData.localCachedDate);
                            }
                            return retval;
                        };
                        this.config.basic.isCachableOnBackend = _.isUndefined(this.config.basic.isCachableOnBackend) ? true : this.config.basic.isCachableOnBackend;
                        this.config.basic.logLevel = this.config.basic.logLevel || ute.common.typescript.api.log.LogLevel.OFF;
                        this.userService.registerSigninHandler(this.cleanup, this);
                    }
                    ;
                    /**
                     * @override
                     * @returns {T}
                     */
                    CacheableDataGeneric.prototype.getChangableData = function () {
                        return _.get(this.cacheableData, 'data');
                    };
                    return CacheableDataGeneric;
                }(ute.common.core.subpub.SubPubGeneric));
                caching.CacheableDataGeneric = CacheableDataGeneric;
                angular.module('ute.common.core.caching').constant('CacheableDataGeneric', CacheableDataGeneric);
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            var ProviderBase = (function () {
                function ProviderBase() {
                    var _this = this;
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    /**
                     * @returns {C}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                }
                return ProviderBase;
            }());
            core.ProviderBase = ProviderBase;
            angular.module('ute.common.core').constant('ProviderBase', ProviderBase);
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var service;
            (function (service) {
                'use strict';
                var ResponseErrorHandlerGeneric = (function () {
                    function ResponseErrorHandlerGeneric(defaultFrontEndErrorCode, defaultBackEndErrorCode, logPrefix, $injector) {
                        var _this = this;
                        this.defaultFrontEndErrorCode = defaultFrontEndErrorCode;
                        this.defaultBackEndErrorCode = defaultBackEndErrorCode;
                        this.logPrefix = logPrefix;
                        this.errorCodesMap = {};
                        this.isCallInProgress = false;
                        this.openModalPopup = function (codeEntry) { return null; };
                        /**
                         * @param code
                         * @returns {boolean}
                         */
                        this.addCode = function (code) {
                            _this.errorCodesMap[code.frontendCode] = code;
                        };
                        /**
                         * @param backendCode
                         * @returns {<CE>}
                         */
                        this.findCodeEntry = function (backendCode) { return (_.find(_this.errorCodesMap, function (ce) {
                            return ce.backendCode === backendCode;
                        }) || _this.errorCodesMap[_this.defaultFrontEndErrorCode]); };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processOk = function (response) {
                            var backendCode = _.get(response, 'data.status.code', _this.defaultBackEndErrorCode);
                            var retval = _this.findCodeEntry(backendCode);
                            console.log(_this.logPrefix + '->processOk:', 'response:', response, 'backendCode:', backendCode, 'retval:', retval);
                            return retval;
                        };
                        /**
                         * @param error
                         * @return {any}
                         */
                        this.processError = function (error) {
                            var backendCode = _.get(error, 'data.status.code', _this.defaultBackEndErrorCode);
                            var retval = _this.findCodeEntry(backendCode);
                            console.log(_this.logPrefix + '->processError:', 'error:', error, 'backendCode:', backendCode);
                            if (retval.windowTemplateUrl) {
                                return _this.openModalPopup(retval);
                            }
                            else {
                                return new _this.$q(function (resolve, reject) { return reject(retval); });
                            }
                        };
                        this.finaliseCall = function () {
                            _this.isCallInProgress = false;
                        };
                        this.$q = $injector.get('$q');
                    }
                    ;
                    return ResponseErrorHandlerGeneric;
                }());
                service.ResponseErrorHandlerGeneric = ResponseErrorHandlerGeneric;
                angular.module('ute.common.core').constant('ResponseErrorHandlerGeneric', ResponseErrorHandlerGeneric);
            })(service = core.service || (core.service = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var TestAbstract = (function () {
                        function TestAbstract() {
                            this.restrict = 'E';
                            this.transclude = true;
                            this.template = '<span data-ng-if="$ctrl.test"><ng-transclude></ng-transclude></span>';
                            this.scope = {};
                            this.controllerAs = '$ctrl';
                        }
                        return TestAbstract;
                    }());
                    directives.TestAbstract = TestAbstract;
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                angular.module('ute.rogers.user.registration').run(setPasswordRoutesConfig);
                setPasswordRoutesConfig.$inject = ['ute.blocks.router',
                    'ute.rogers.user.registration.service'
                ];
                function setPasswordRoutesConfig(routerHelper, userRegistrationService) {
                    var config = userRegistrationService.getConfig();
                    routerHelper.configureStates([
                        {
                            name: config.advanced.registration.stateName,
                            url: '/' + config.advanced.registration.stateName,
                            // url: '/' + config.advanced.setPassword.stateName,
                            controller: config.advanced.registration.controllerName,
                            controllerAs: 'registration',
                            templateUrl: config.advanced.registration.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['public'] }
                            }
                        },
                        {
                            name: config.advanced.confirmation.stateName,
                            url: '/' + config.advanced.confirmation.stateName + '/:id',
                            // url: '/' + config.advanced.setPassword.stateName,
                            controller: config.advanced.confirmation.controllerName,
                            controllerAs: 'registration',
                            templateUrl: config.advanced.confirmation.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['public'] }
                            }
                        }
                    ]);
                    routerHelper.registerToStateHandler(config.advanced.confirmation.stateName, userRegistrationService, ute.blocks.router.StateHandlerPriority.LOW);
                }
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user_1) {
            var service;
            (function (service) {
                'use strict';
                var UserService = (function () {
                    /* @ngInject */
                    function UserService($injector, config) {
                        var _this = this;
                        this.$injector = $injector;
                        this.config = config;
                        //private failSafeKey: string = this.utilsService.randomString();
                        this.failSafeKey = '7RvnncDPUc535aBZftoarnFdYXM1zlfY';
                        this.signinHandlers = [];
                        this.signoutHandlers = [];
                        this.isSigned = function () {
                            //console.log('isSigned', !!this.user);
                            return !!_this.user;
                        };
                        this.signed = function (user) {
                            // because this called from pure JavaScript
                            if (angular.isString(user.userType)) {
                                //noinspection TypeScriptUnresolvedFunction
                                user.userType = user_1.UserType[user.userType.toString()];
                            }
                            //console.log('ute.user.service.UserService.signed: user=', user, ' cache=', (<any>this.getEncryptionKey).cache);
                            var userWithoutPassword = _.cloneDeep(user);
                            delete userWithoutPassword.userPassword;
                            _this.user = userWithoutPassword;
                            _this.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER, userWithoutPassword);
                            _this.callSigninHandlers();
                            _this.messagesService.publish(ute.blocks.messages.bus.Messages.uteRogersSigninSuccessful, _this.user);
                        };
                        /**
                         * !!! do not use this method in real application !!!
                         */
                        this.signout = function () {
                            // TODO still not real signout, real signout provider must be called here
                            // this is temporary
                            // const options: any = {path: '/', domain: '.rogers.com'};
                            // this.$cookies.remove('SMSESSION', options);
                            // this.$cookies.remove('SM_USERAUTHENTICATED', options);
                            _this.config.advanced.signoutCallback(_this.$injector);
                            // this.unsigned();
                        };
                        this.unsigned = function () {
                            _this.callSignoutHandlers();
                            //console.log('ute.user.service.UserService.unsigned: user=', this.user, ' cache=', (<any>this.getEncryptionKey).cache);
                            _this.user = null;
                            _this.storageService.removeFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER);
                            _this.messagesService.publish(ute.blocks.messages.bus.Messages.uteRogersSignoutSuccessful);
                            //this.storageService.remove('ute.rogers.signin.user');
                        };
                        /**
                         * @returns {ute.common.user.IUser}
                         */
                        this.getUser = function () {
                            return angular.copy(_this.user);
                        };
                        this.setUsername = function (newUsername) {
                            _this.updateUsername(newUsername);
                        };
                        /**
                         * @returns {string}
                         */
                        this.getUserType = function () {
                            if (angular.isDefined(_this.user)) {
                                var ut = _.get(_this.user, 'userType');
                                return angular.isUndefined(ut) ? undefined : user_1.UserType[ut];
                            }
                            else {
                                return undefined;
                            }
                        };
                        this.setUserView = function (isRepView) {
                            _this.storageService.putToSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_ONEVIEW_REPVIEW, isRepView);
                        };
                        this.getUserView = function () {
                            return _this.storageService.getFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_ONEVIEW_REPVIEW);
                        };
                        /**
                         * @param partialUrl
                         * @returns {string}
                         */
                        this.getBackendUrl = function (partialUrl) {
                            // console.log('ute.common.security.service->getBackendUrl', (this.config.roleToUrlBase[this.userService.getUserType()]) + partialUrl);
                            return (_.get(_this.config, 'roleToUrlBase.' + _this.getUserType() + '.baseUrl') || UserProvider.protectedUrlPrefix) + partialUrl;
                        };
                        this.getPersistentService = function () {
                            return _.get(_this.config, 'roleToUrlBase.' + _this.getUserType() + '.persistentService') || _this.$injector.get('ute.blocks.persistent.storage.service').getLocalStoreService();
                        };
                        this.isAnyRoleGranted = function (userRoles) {
                            var rolesArray = userRoles ? userRoles.split(',').map(function (s) { return s.trim(); }) : [];
                            return _.include(rolesArray, _this.getUserType());
                        };
                        /**
                         * @param callBack
                         * @param thisArg
                         * @param argArray
                         */
                        this.registerSigninHandler = function (callBack, thisArg, argArray) {
                            if (callBack && thisArg) {
                                _this.signinHandlers.push({ callBack: callBack, thisArg: thisArg, argArray: argArray });
                            }
                        };
                        /**
                         * @param callBack
                         * @param thisArg
                         * @param argArray
                         */
                        this.registerSignoutHandler = function (callBack, thisArg, argArray) {
                            if (callBack && thisArg) {
                                _this.signoutHandlers.push({ callBack: callBack, thisArg: thisArg, argArray: argArray });
                            }
                        };
                        /**
                         * @returns {any}
                         * @private
                         */
                        this._getEncryptionKey = function () {
                            if (_this.isSigned()) {
                                return _this.$http.get(_this.getBackendUrl('v1/myKey'))
                                    .then(_this.processEncryptionKeyResponse)
                                    .catch(_.curry(_this.fail)('processEncryptionKeyResponse failed.'));
                            }
                            else {
                                return new _this.$q(function (resolve) { return resolve(_this.failSafeKey); });
                            }
                        };
                        /**
                         * @returns {any}
                         */
                        this.getUserName = function () {
                            return _.get(_this.user, 'userName');
                        };
                        this.updateUsername = function (newUsername) {
                            _this.user.userEmail = newUsername;
                            _this.user.userName = newUsername;
                            _this.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER, _this.user);
                        };
                        this.callSigninHandlers = function () {
                            _this.callHandlers(_this.signinHandlers);
                        };
                        this.callSignoutHandlers = function () {
                            _this.callHandlers(_this.signoutHandlers);
                        };
                        /**
                         * @param handlers
                         */
                        this.callHandlers = function (handlers) {
                            handlers.forEach(function (handler) {
                                try {
                                    // TODO async
                                    handler.callBack.apply(handler.thisArg, handler.argArray);
                                }
                                catch (e) {
                                }
                            });
                        };
                        this.getCacheName = function () {
                            return 'EncryptionKeyCacheName';
                        };
                        this.cleanCache = function () {
                            //console.log('ute.user.service.UserService.cleanCache: cache=', (<any>this.getEncryptionKey).cache);
                            _this.getEncryptionKey.cache.delete(_this.getCacheName());
                        };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processEncryptionKeyResponse = function (response) {
                            //console.log('ute.user.service.UserService.processEncryptionKeyResponse', _.get<string>(response, 'data.content.key', this.failSafeKey));
                            return _.get(response, 'data.content.key', _this.failSafeKey);
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {string}
                         */
                        //private fail: (reason: string, error: any) => ng.IPromise<any> = (reason: string, error: any) => {
                        this.fail = function (reason, error) {
                            //var msg = _.get(error, 'data.description', error);
                            //this.exceptionHandler.catcher(msg)(reason, 'ute.common.user.service');
                            //return this.$q.reject(msg);
                            //console.log('ute.user.service.UserService.fail', this.failSafeKey + this.getUserName());
                            return _this.failSafeKey + _this.getUserName();
                        };
                        this.storageService = $injector.get('ute.blocks.persistent.storage.service');
                        this.messagesService = $injector.get('ute.blocks.messages.bus.service');
                        this.$q = $injector.get('$q');
                        this.$http = $injector.get('$http');
                        // ute.common.utils.UtilsStatic.getCookieService(),
                        this.$cookies = $injector.get(angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies');
                        // we don't know who the user is at this point, so we try form both: local and session
                        this.user = this.storageService.getFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER) ||
                            this.storageService.getFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER);
                        this.getEncryptionKey = _.memoize(this._getEncryptionKey, this.getCacheName);
                        this.registerSigninHandler(this.cleanCache, this);
                        this.getUserRole = this.getUserType;
                    }
                    UserService.prototype.setProfileId = function (profileId) {
                        this.user.profileId = profileId;
                    };
                    ;
                    UserService.prototype.getProfileId = function () {
                        return _.get(this.user, 'profileId');
                    };
                    ;
                    UserService.prototype.setAccountId = function (accountId) {
                        this.user.accountId = accountId;
                    };
                    ;
                    UserService.prototype.getAccountId = function () {
                        return _.get(this.user, 'accountId');
                    };
                    ;
                    UserService.prototype.isConsumer = function () {
                        return this.user.userType === user_1.UserType.consumer;
                    };
                    UserService.prototype.isDealer = function () {
                        return this.user.userType === user_1.UserType.dealer;
                    };
                    UserService.prototype.isCare = function () {
                        return this.user.userType === user_1.UserType.care;
                    };
                    UserService.prototype.isRepView = function () {
                        return this.storageService.getFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_ONEVIEW_REPVIEW) === true;
                    };
                    UserService.$inject = [
                        '$injector'
                    ];
                    return UserService;
                }());
                var UserProvider = (function () {
                    /* @ngInject */
                    function UserProvider() {
                        var _this = this;
                        this.config = {
                            // roles: [UserType.care, UserType.dealer, UserType.consumer],
                            roleToUrlBase: {}
                        };
                        /* @ngInject */
                        this.$get = ["$injector", function ($injector) {
                            _this.$injector = $injector;
                            var storeService = $injector.get('ute.blocks.persistent.storage.service');
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.care]].persistentService = storeService.getSessionStoreService();
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.careRep]].persistentService = storeService.getSessionStoreService();
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.dealer]].persistentService = storeService.getLocalStoreService();
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.consumer]].persistentService = storeService.getLocalStoreService();
                            return new UserService($injector, _this.config);
                        }];
                        this.$get.$inject = [
                            '$injector'
                        ];
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.care]] = { baseUrl: UserProvider.publicUrlPrefix };
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.careRep]] = { baseUrl: UserProvider.publicUrlPrefix };
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.dealer]] = { baseUrl: UserProvider.publicUrlPrefix };
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.consumer]] = { baseUrl: UserProvider.protectedUrlPrefix };
                    }
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    UserProvider.prototype.configure = function (config) {
                        this.config = _.merge(this.config, config);
                        return true;
                    };
                    UserProvider.protectedUrlPrefix = '/web/RogersServices.portal/totes/api/';
                    UserProvider.publicUrlPrefix = '/web/totes/api/';
                    UserProvider.$inject = [];
                    return UserProvider;
                }());
                angular.module('ute.common.user').provider('ute.common.user.service', UserProvider);
            })(service = user_1.service || (user_1.service = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            'use strict';
            (function (UserType) {
                UserType[UserType["dealer"] = 0] = "dealer";
                UserType[UserType["care"] = 1] = "care";
                UserType[UserType["consumer"] = 2] = "consumer";
                UserType[UserType["careRep"] = 3] = "careRep";
            })(user.UserType || (user.UserType = {}));
            var UserType = user.UserType;
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var Test = (function (_super) {
                    __extends(Test, _super);
                    function Test() {
                        _super.call(this);
                        this.scope = {
                            states: '@'
                        };
                        this.controller = Controller;
                    }
                    Test.factory = function () {
                        return function () { return new Test(); };
                    };
                    return Test;
                }(directives.TestAbstract));
                var Controller = (function (_super) {
                    __extends(Controller, _super);
                    /* @ngInject */
                    function Controller(routerHelper) {
                        var _this = this;
                        _super.call(this, routerHelper);
                        this.test = function () { return _.include(_this.statesArray, _.get(_this.routerHelper.getCurrentState(), 'name')); };
                    }
                    Controller.$inject = ['ute.blocks.router'];
                    return Controller;
                }(directives.ControllerAbstract));
                /**
                 * <ute-if-in-any-routing-state states='state1,state2'> directive
                 */
                angular.module('ute.common.component.directives').directive('uteIfInAnyRoutingState', Test.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var Test = (function (_super) {
                    __extends(Test, _super);
                    function Test() {
                        _super.call(this);
                        this.scope = {
                            states: '@'
                        };
                        this.controller = Controller;
                    }
                    Test.factory = function () {
                        return function () { return new Test(); };
                    };
                    return Test;
                }(directives.TestAbstract));
                var Controller = (function (_super) {
                    __extends(Controller, _super);
                    /* @ngInject */
                    function Controller(routerHelper) {
                        var _this = this;
                        _super.call(this, routerHelper);
                        this.test = function () { return !_.include(_this.statesArray, _.get(_this.routerHelper.getCurrentState(), 'name')); };
                    }
                    Controller.$inject = ['ute.blocks.router'];
                    return Controller;
                }(directives.ControllerAbstract));
                /**
                 * <ute-if-not-in-any-routing-state states='state1,state2'> directive
                 */
                angular.module('ute.common.component.directives').directive('uteIfNotInAnyRoutingState', Test.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            var RogersCookies = (function () {
                function RogersCookies() {
                }
                RogersCookies.SM_USERNOTFOUND = 'SM_USERNOTFOUND';
                //static SM_USERAUTHENTICATED = 'SM_USERAUTHENTICATED';
                RogersCookies.SMTRYNO = 'SMTRYNO';
                RogersCookies.SM_USER = 'SM_USER';
                RogersCookies.SMLOCK = 'SMLOCK';
                //static SMSESSION = 'SMSESSION';
                RogersCookies.SM_QUERY_STRING = 'SM_QUERY_STRING';
                RogersCookies.LANGUAGE = 'language';
                RogersCookies.ROGERS_LEGACY_DEEP_LINK = 'deepJSON';
                return RogersCookies;
            }());
            core.RogersCookies = RogersCookies;
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var decorator;
        (function (decorator) {
            var directives;
            (function (directives) {
                'use strict';
                var ModalInputFocusOnClick = (function () {
                    ///* @ngInject */
                    function ModalInputFocusOnClick() {
                        this.restrict = 'A';
                        this.link = this.linkFn;
                    }
                    ModalInputFocusOnClick.factory = function () {
                        var directive = function () { return new ModalInputFocusOnClick(); };
                        return directive;
                    };
                    ModalInputFocusOnClick.prototype.linkFn = function (scope, instanceElement, instanceAttributes, controller, transclude) {
                        instanceElement.bind('click', function (evt) {
                            console.log('setFocus to click event', evt);
                            evt.preventDefault();
                            evt.stopPropagation();
                            evt.target.focus();
                        });
                    };
                    return ModalInputFocusOnClick;
                }());
                angular.module('ute.common.decorator.directives').directive('uteModalInputFocusOnClick', ModalInputFocusOnClick.factory());
            })(directives = decorator.directives || (decorator.directives = {}));
        })(decorator = common.decorator || (common.decorator = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var decorator;
        (function (decorator) {
            var directives;
            (function (directives) {
                'use strict';
                var NumbersOnlyInput = (function () {
                    /* @ngInject */
                    function NumbersOnlyInput() {
                        this.require = 'ngModel';
                        this.link = this.linkFn;
                        //console.log('NumbersOnlyInput->constructor', $translate);
                    }
                    NumbersOnlyInput.factory = function () {
                        var directive = function () { return new NumbersOnlyInput(); };
                        //directive.$inject = ['$translate'];
                        return directive;
                    };
                    NumbersOnlyInput.prototype.linkFn = function (scope, instanceElement, instanceAttributes, controller, transclude) {
                        function inputFromUser(text) {
                            if (text) {
                                var transformedInput = text.replace(/[^0-9]/g, '');
                                if (transformedInput !== text) {
                                    controller.$setViewValue(transformedInput);
                                    controller.$render();
                                }
                                return transformedInput;
                            }
                            return undefined;
                        }
                        controller.$parsers.push(inputFromUser);
                    };
                    return NumbersOnlyInput;
                }());
                angular.module('ute.common.decorator.directives').directive('uteNumbersOnlyInput', NumbersOnlyInput.factory());
            })(directives = decorator.directives || (decorator.directives = {}));
        })(decorator = common.decorator || (common.decorator = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter').filter('ute_common_filter_data_conversion', dataConversion); // split a phone number and format it like this (416) 555-5656
            /**
             *
             * @returns {function(number, string, number, boolean): string}
             */
            dataConversion.$inject = ['$filter'];
            function dataConversion($filter) {
                return function (input, format, base, decimals, showUnit, showUnitOnly) {
                    var units = ['kb', 'mb', 'gb', 'tb'], index = units.indexOf(format), data = input, finalUnit = units[index], decimalFactor = Math.pow(10, decimals);
                    for (index; index < units.length; index++) {
                        if (data >= base) {
                            data = data / base;
                        }
                        else {
                            finalUnit = units[index];
                            break;
                        }
                    }
                    var outputAmount = $filter('number')(Math.round(data * (decimalFactor)) / decimalFactor, decimals);
                    var outputUnit = (showUnit ? ($filter('translate')('ute.commonFilters.dataConversion.' + finalUnit)) : '');
                    var output = '';
                    if (showUnitOnly) {
                        output = outputUnit;
                    }
                    else {
                        output = outputAmount + outputUnit;
                    }
                    return output;
                };
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter').filter('ute_common_filter_phone', phone).
                filter('ute_common_filter_phone2', phone2).
                filter('ute_common_filter_phone3', phone3); // split a phone number and format it like this (416) 555-5656
            /**
             * Format phone# as '416-123-4567'
             * @returns {function(string): string}
             */
            function phone() {
                return function (input, format) {
                    return formatPhone(input, format || '$1-$2-$3');
                };
            }
            /**
             * Format phone# as '416 123-4567'
             * @returns {function(string): string}
             */
            function phone2() {
                return function (input, format) {
                    return formatPhone(input, format || '$1 $2-$3');
                };
            }
            /**
             * Format phone# as '(416) 123-4567'
             * @returns {function(string): string}
             */
            function phone3() {
                return function (input, format) {
                    return formatPhone(input, format || '($1) $2-$3');
                };
            }
            /**
             * Format phone# as @param format
             * @param input
             * @param format
             * @returns {string}
             */
            function formatPhone(input, format) {
                if (input && format) {
                    return input.toString().trim().replace(/^\+/, '').replace(/(\d{3})(\d{3})(\d{4})/, format);
                }
                // else will be undefined
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter')
                .filter('ute_common_filter_string_limit_to', limitTo);
            /**
             * Limit a string to input number
             * @returns {function(string): string}
             *
             * Business Requirements
             * |----------------------|----------------------|----------------------|----------------------|
             * |        input         |     characterLimit   |      isEllipsis      |   Expected Result    |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 12345678901234567890 |            12        |         true         | 123456789...         |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 12345678901234567890 |            10        |         true         | 1234567...           |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 12345678901234567890 |            10        |         false        | 1234567890           |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 123456789            |            10        |         false        | 123456789            |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 1234567890           |            10        |         true         | 1234567890           |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 123456789            |            10        |         true         | 123456789            |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 12345678             |            10        |         true         | 12345678             |
             * |----------------------|----------------------|----------------------|----------------------|
             */
            function limitTo() {
                return function (input, characterLimit, isEllipsis) {
                    if (angular.isUndefined(input) || _.isNull(input)) {
                        return '';
                    }
                    isEllipsis = angular.isUndefined(isEllipsis) || _.isNull(isEllipsis) ? true : !!isEllipsis;
                    var hellipLength = 3;
                    if (input.length > characterLimit && isEllipsis === true) {
                        return input.substring(0, (characterLimit - hellipLength)) + '...';
                    }
                    else if (input.length > characterLimit && isEllipsis === false) {
                        return input.substring(0, (characterLimit));
                    }
                    else {
                        return input;
                    }
                };
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                var mixin;
                (function (mixin) {
                    'use strict';
                    var MixinHelper = (function () {
                        function MixinHelper() {
                        }
                        /**
                         * apply Mixins pattern to the derivedCtor class
                         * example:
                         * class SmartObject implements Disposable, Activatable {
                         *   ...
                         * }
                         * applyMixins(SmartObject, [Disposable, Activatable]);
                         *
                         * @param derivedCtor
                         * @param baseCtors
                         */
                        MixinHelper.applyMixins = function (derivedCtor, baseCtors) {
                            baseCtors.forEach(function (baseCtor) {
                                Object.getOwnPropertyNames(baseCtor.prototype).forEach(function (name) {
                                    derivedCtor.prototype[name] = baseCtor.prototype[name];
                                });
                            });
                        };
                        return MixinHelper;
                    }());
                    mixin.MixinHelper = MixinHelper;
                })(mixin = api.mixin || (api.mixin = {}));
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            'use strict';
        })(utils = common.utils || (common.utils = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            'use strict';
            var UtilsStatic = (function () {
                function UtilsStatic() {
                }
                UtilsStatic.memoizeResolver = function (o) {
                    // console.log(UtilsProvider.serviceName + '->memoizeResolver->input:', o);
                    // console.log(UtilsProvider.serviceName + '->memoizeResolver->output:', _.chain(o).filter(e => angular.isDefined(e)).values().value().sort().join('_'));
                    return _.chain(o).filter(function (e) { return angular.isDefined(e); }).values().value().sort().join('_');
                };
                UtilsStatic.getCookieModule = function () { return angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'; };
                UtilsStatic.getCookieService = function () { return angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies'; };
                return UtilsStatic;
            }());
            utils.UtilsStatic = UtilsStatic;
            var UtilsProvider = (function () {
                /* @ngInject */
                function UtilsProvider() {
                    var _this = this;
                    this.config = {}; // defaults
                    /* @ngInject */
                    this.$get = function ($injector) {
                        _this.$window = $injector.get('$window');
                        return {
                            randomString: _this.randomString,
                            parseTimer: _this.parseTimer,
                            formatPhoneNumber: _this.formatPhoneNumber,
                            objectToArray: _this.objectToArray,
                            arrayToObject: _this.arrayToObject,
                            getQuerystringParameter: _this.getQuerystringParameter,
                            calculateAge: _this.calculateAge,
                            isNullOrEmptyObject: _this.isNullOrEmptyObject,
                            isAlphabetOnly: _this.isAlphabetOnly,
                            isAlphanumeric: _this.isAlphanumeric,
                            isNumericOnly: _this.isNumericOnly,
                            stringContains: _this.stringContains,
                            detectBrowser: _this.detectBrowser,
                            getQueryParameters: _this.getQueryParameters,
                            getHomePage: _this.getHomePage
                        };
                    };
                    /**
                     * TODO validation + defaults
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    this.randomString = function (length, chars) {
                        if (length && chars) {
                            var result = '';
                            for (var i = length; i > 0; --i) {
                                result += chars[Math.floor(Math.random() * chars.length)];
                            }
                            return result;
                        }
                        else {
                            return _this.randomString(32, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
                        }
                    };
                    this.parseTimer = function (t) {
                        var days, hours, minutes, seconds;
                        days = Math.floor(t / 86400);
                        t -= days * 86400;
                        hours = Math.floor(t / 3600) % 24;
                        t -= hours * 3600;
                        minutes = Math.floor(t / 60) % 60;
                        t -= minutes * 60;
                        seconds = t % 60;
                        if (minutes < 10) {
                            minutes = '0' + minutes;
                        }
                        if (seconds < 10) {
                            seconds = '0' + seconds;
                        }
                        return minutes + ":" + seconds;
                    };
                    this.formatPhoneNumber = function (n, regex) {
                        if (n == null) {
                            return n;
                        }
                        if (regex == null) {
                            regex = /[\-\s\.]/g;
                        }
                        return n.replace(regex, '');
                    };
                    this.objectToArray = function (obj) {
                        var arr = [];
                        for (var prop in obj) {
                            if (obj.hasOwnProperty(prop)) {
                                //console.log('o.' + prop + ' = ' + obj[prop]);
                                arr.push(obj[prop]);
                            }
                        }
                        return arr;
                    };
                    this.arrayToObject = function (arr) {
                        var obj = {};
                        arr.forEach(function (el, index) {
                            obj[index] = el;
                        });
                        return obj;
                    };
                    this.getQuerystringParameter = function (name) {
                        var nm = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                        var regex = new RegExp('[\\?&]' + nm + '=([^&#]*)');
                        var results = regex.exec(location.href.replace('&amp;', '&'));
                        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
                    };
                    this.calculateAge = function (birthDate, currentDate) {
                        var bd = new Date(birthDate);
                        if (currentDate == null) {
                            currentDate = new Date();
                        }
                        var years = (currentDate.getFullYear() - bd.getFullYear());
                        if (currentDate.getMonth() < bd.getMonth() ||
                            currentDate.getMonth() === bd.getMonth() &&
                                currentDate.getDay() < bd.getDay()) {
                            years--;
                        }
                        return years;
                    };
                    // former isUndefinedOrNull
                    this.isNullOrEmptyObject = function (val) {
                        if (angular.isUndefined(val) || val === null) {
                            return true;
                        }
                        var jsonStr;
                        try {
                            jsonStr = angular.toJson(val);
                        }
                        catch (e) {
                            return false;
                        }
                        return jsonStr === '{}';
                    };
                    this.stringContains = function (s, val) {
                        return s.indexOf(val) !== -1;
                    };
                    this.detectBrowser = function () {
                        var ua = navigator.userAgent;
                        var tem;
                        var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                        if (/trident/i.test(M[1])) {
                            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                            return {
                                type: 'ie',
                                version: (tem[1] || '')
                            };
                        }
                        if (M[1] === 'Chrome') {
                            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                            if (tem != null) {
                                return {
                                    type: tem.slice(1).join(' ').replace('OPR', 'Opera'),
                                    version: M[1]
                                };
                            }
                        }
                        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                            M.splice(1, 1, tem[1]);
                        }
                        return {
                            type: M[0].toLowerCase(),
                            version: M[1]
                        };
                    };
                    this.isNumericOnly = function (test) {
                        return (/^[0-9]+$/g).test(test);
                    };
                    this.isAlphabetOnly = function (test) {
                        return (/^[a-zA-Z]+$/g).test(test);
                    };
                    this.isAlphanumeric = function (test) {
                        return (/^[a-zA-Z0-9]+$/g).test(test);
                    };
                    /**
                     * Parse location query params and return hashmap
                     *
                     * @example http://example.com/test?lunch=sandwich&dinner=stirfry will return { "lunch": "sandwich", "dinner": "stirfry" }
                     *
                     * @param str
                     * @returns {*}
                     */
                    this.getQueryParameters = function (str) {
                        return _.chain((str || _this.$window.location.search).replace(/(^\?)/, '').split('&')).map(function (params) {
                            var p = params.split('=');
                            return [p[0], angular.isUndefined(p[1]) ? true : p[1]];
                        }).object().value();
                    };
                    this.getHomePage = function () {
                        var wl = _this.$window.location;
                        if (!wl.origin) {
                            // polyfill for IE
                            wl.origin = wl.protocol + '//' + wl.hostname + (wl.port ? ':' + wl.port : '');
                        }
                        return wl.origin;
                    };
                    this.$get.$inject = [
                        '$injector'
                    ];
                }
                UtilsProvider.$inject = [];
                UtilsProvider.serviceName = 'ute.common.utils.service';
                return UtilsProvider;
            }());
            angular.module('ute.common.utils').provider(UtilsProvider.serviceName, UtilsProvider);
        })(utils = common.utils || (common.utils = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var UteDataLayerFormFieldError = (function () {
                    function UteDataLayerFormFieldError(dataLayerService, $parse, $q, $state) {
                        var _this = this;
                        this.dataLayerService = dataLayerService;
                        this.$parse = $parse;
                        this.$q = $q;
                        this.$state = $state;
                        this.restrict = 'A';
                        this.linkFn = function ($scope, element, attrs) {
                            var fireDataLayer = _this.$parse(attrs.fireDataLayer)($scope);
                            var mappingKey, isModalPopup, mapping;
                            var selectedSections = [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE];
                            if (!(fireDataLayer === false) && _this.dataLayerService.isStateDefined(_this.$state.current.name)) {
                                $scope.$applyAsync(function () {
                                    try {
                                        isModalPopup = _this.$parse(attrs.isModalPopup)($scope) || false;
                                        // if mappingKey is not bound to parent scope or controller variable, then tries to get mappingKey from attrs object
                                        try {
                                            mappingKey = _this.$parse(attrs.mappingKey)($scope);
                                        }
                                        catch (e) {
                                        }
                                        if (!mappingKey) {
                                            mappingKey = attrs.mappingKey;
                                        }
                                        if (mappingKey) {
                                            mapping = {
                                                mappingKey: mappingKey
                                            };
                                        }
                                        if (attrs.pageView === 'true') {
                                            selectedSections.push(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                        }
                                        _this.getErrorPayload($scope, attrs).then(function (payload) {
                                            _this.dataLayerService.trackFormError(payload, element.text().trim(), attrs.formFieldName || '', isModalPopup, selectedSections, mapping);
                                        });
                                    }
                                    catch (err) {
                                        console.warn('Exception in dataLayer form error directive', err);
                                    }
                                });
                            }
                        };
                        this.link = this.linkFn;
                    }
                    UteDataLayerFormFieldError.factory = function () {
                        var directive = function (dataLayerService, $parse, $q, $state) { return new UteDataLayerFormFieldError(dataLayerService, $parse, $q, $state); };
                        directive.$inject = ['ute.datalayer.common.service', '$parse', '$q', '$state'];
                        return directive;
                    };
                    ;
                    UteDataLayerFormFieldError.prototype.getErrorPayload = function (scope, attrs) {
                        var errorPayload_cb, errorPayload_promise, payload;
                        errorPayload_cb = this.dataLayerService.getCallbackByKey('errorPayload');
                        if (errorPayload_cb) {
                            errorPayload_promise = errorPayload_cb.callback(attrs.errorData);
                        }
                        // try parse json object . In case when payload specified as a json object.
                        try {
                            payload = JSON.parse(attrs.errorPayload);
                        }
                        catch (e) {
                        }
                        // try parse bound variable ( scope or controller(as syntax)) when json parsing failed.
                        if (!payload) {
                            try {
                                payload = this.$parse(attrs.errorPayload)(scope);
                            }
                            catch (e) {
                            }
                        }
                        return this.$q.when(errorPayload_promise)
                            .then(function (callBackpayload) {
                            if (payload && callBackpayload) {
                                _.merge(payload, callBackpayload);
                            }
                            else if (callBackpayload) {
                                payload = callBackpayload;
                            }
                            return payload;
                        })
                            .catch(function (error) {
                            console.warn('Error in handling errorPayload callback.');
                            return payload;
                        });
                    };
                    return UteDataLayerFormFieldError;
                }());
                angular.module('ute.datalayer.common').directive('uteDataLayerFormFieldError', UteDataLayerFormFieldError.factory());
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var UteDataLayerEvent = (function () {
                    function UteDataLayerEvent(dataLayerService, $parse, $q, $state) {
                        var _this = this;
                        this.dataLayerService = dataLayerService;
                        this.$parse = $parse;
                        this.$q = $q;
                        this.$state = $state;
                        this.restrict = 'A';
                        this.linkFn = function ($scope, element, attrs) {
                            var mappingKey, isModalPopup, mapping;
                            var self = _this;
                            var selectedSections;
                            function setTrackParams(parse) {
                                selectedSections = [
                                    service.DataLayerPredefinedSection.ACCOUNT,
                                    service.DataLayerPredefinedSection.PAGE,
                                    service.DataLayerPredefinedSection.SITE];
                                if (attrs.pageView === 'true') {
                                    selectedSections.push(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                }
                                isModalPopup = (attrs.isModalPopup === 'true');
                                try {
                                    mappingKey = parse(attrs.mappingKey)($scope);
                                }
                                catch (e) {
                                }
                                if (!mappingKey) {
                                    mappingKey = attrs.mappingKey;
                                }
                                if (mappingKey) {
                                    mapping = {
                                        mappingKey: mappingKey
                                    };
                                }
                            }
                            function track($parse) {
                                try {
                                    setTrackParams($parse);
                                    self.getEventPayload($scope, attrs).then(function (payload) {
                                        self.dataLayerService.track(payload, isModalPopup, selectedSections, mapping);
                                    });
                                }
                                catch (err) {
                                    console.warn('Exception in adl form event tracking directive', err);
                                }
                            }
                            $scope.$applyAsync(function () {
                                if (_this.dataLayerService.isStateDefined(_this.$state.current.name)) {
                                    if (attrs.eventName) {
                                        element.on(attrs.eventName, function (event) {
                                            track(_this.$parse);
                                        });
                                    }
                                    else {
                                        track(_this.$parse);
                                    }
                                }
                            });
                            $scope.$on('$destroy', function () {
                                if (attrs.eventName) {
                                    element.off(attrs.eventName);
                                }
                            });
                        };
                        this.getEventPayload = function ($scope, attrs) {
                            var eventPayload_cb, eventPayload_promise, payload;
                            eventPayload_cb = _this.dataLayerService.getCallbackByKey('eventPayload');
                            if (eventPayload_cb) {
                                eventPayload_promise = eventPayload_cb.callback(attrs.eventData);
                            }
                            try {
                                payload = JSON.parse(attrs.eventPayload);
                            }
                            catch (e) {
                            }
                            // try parse bound variable ( scope or controller(as syntax)) when json parsing failed.
                            if (!payload) {
                                try {
                                    payload = _this.$parse(attrs.eventPayload)($scope);
                                }
                                catch (e) {
                                }
                            }
                            return _this.$q.when(eventPayload_promise)
                                .then(function (callBackpayload) {
                                if (payload && callBackpayload) {
                                    _.merge(payload, callBackpayload);
                                }
                                else if (callBackpayload) {
                                    payload = callBackpayload;
                                }
                                return payload;
                            })
                                .catch(function (error) {
                                console.warn('Error in handling eventPayload callback.');
                                return payload;
                            });
                        };
                        this.link = this.linkFn;
                    }
                    UteDataLayerEvent.factory = function () {
                        var directive = function (dataLayerService, $parse, $q, $state) { return new UteDataLayerEvent(dataLayerService, $parse, $q, $state); };
                        directive.$inject = ['ute.datalayer.common.service', '$parse', '$q', '$state'];
                        return directive;
                    };
                    ;
                    return UteDataLayerEvent;
                }());
                angular.module('ute.datalayer.common').directive('uteDataLayerEvent', UteDataLayerEvent.factory());
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var DataLayerServiceProvider = (function () {
                    function DataLayerServiceProvider() {
                        var _this = this;
                        this.config = {};
                        this.is_trackDataFunctionExist = (typeof (_trackData) === 'function');
                        this.configLoaded = false;
                        this.registeredCallbacks = [];
                        this.referrer = '';
                        this.$get = ["$q", "$window", "$rootScope", "$injector", function ($q, $window, $rootScope, $injector) {
                            _this.$q = $q;
                            _this.$window = $window;
                            _this.$rootScope = $rootScope;
                            _this.$injector = $injector;
                            _this.getConfig()
                                .then(function () {
                                if (_.get(_this.config, 'advance.configOptions.globalTrackingOn', false)) {
                                    $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
                                        var exclusive = _.get(_this.config, 'advance.configOptions.globalTrackingExclusive', false);
                                        if (!exclusive || exclusive && _.has(_this.config.advance.mappingKey, toState.name)) {
                                            var delegatedMappingKey_1 = toState.name;
                                            var getQueryStringFn_1 = _this.getQueryString;
                                            var config = _this.config;
                                            if (_.get(config, 'advance.configOptions.queryParamTrackingOn', false) && _.get(config, ['advance', 'configOptions', 'queryParamsMapping', toState.name], false)) {
                                                _.forEach(_.get(config, ['advance', 'configOptions', 'queryParamsMapping', toState.name], null), function (queryParamKey) {
                                                    if (getQueryStringFn_1(queryParamKey)) {
                                                        delegatedMappingKey_1 = getQueryStringFn_1(queryParamKey);
                                                        return false;
                                                    }
                                                });
                                            }
                                            _this.trackGlobalAsync({
                                                mappingKey: delegatedMappingKey_1,
                                                stateURL: toState.url
                                            });
                                        }
                                    });
                                }
                            });
                            return {
                                returnConfig: _this.returnConfig,
                                configure: _this.configure,
                                track: _this.trackAsync,
                                trackGlobal: _this.trackGlobalAsync,
                                getMappingPayload: _this.getMappingPayload,
                                getPageHierarchy: _this.getPageHierarchy,
                                getConfigByMappingKey: _this.getConfigByMappingKey,
                                registerCallbacks: _this.registerCallbacks,
                                getQueryString: _this.getQueryString,
                                getCallbackByKey: _this.getCallbackByKey,
                                trackError: _this.trackError,
                                trackFormError: _this.trackFormErrorAsync,
                                trackErrors: _this.trackErrors,
                                trackAPIError: _this.trackAPIErrorAsync,
                                isStateDefined: _this.isStateDefined,
                                trackHttpRequest: _this.trackHttpRequest,
                                trackHttpResponse: _this.trackHttpResponseAsync,
                                trackHttpResponseError: _this.trackHttpResponseErrorAsync,
                                trackUteModal: _this.trackUteModalAsync,
                                getLastPayload: _this.getLastPayload,
                                resetLastModalPayload: _this.resetLastModalPayload
                            };
                        }];
                        /**
                         * @description To merge the passed in configuration with the local configuration
                         * @param config: IDataLayerServiceConfig
                         * @returns boolean
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        /**
                         * @description TBD
                         * @param field:
                         * @param url:
                         * @returns TBD
                         */
                        this.getQueryString = function (field, url) {
                            var href = url ? url : window.location.href;
                            var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
                            var queryString = reg.exec(href);
                            return queryString ? queryString[1] : null;
                        };
                        this.getLastPayload = function () { return _this.lastModalPayload || _this.lastPayload; };
                        this.resetLastModalPayload = function () {
                            _this.lastModalPayload = null;
                        };
                        /**
                         * @description To obtain a flag if state name is defined in config object.
                         * @param stateName: string
                         * @returns boolean
                         */
                        this.isStateDefined = function (stateName) { return _.has(_this.config.advance.mappingKey, stateName); };
                        /**
                         * @description To retrieve callback object by callback key
                         * @param callbackKey: string
                         * @returns IDataLayerCallback
                         */
                        this.getCallbackByKey = function (callbackKey) {
                            return _.find(_this.registeredCallbacks, { 'callbackKey': callbackKey });
                        };
                        /**
                         * @description To register callbacks in common datalayer to obtain data that require app specific implementation
                         * @param callBacks: Array<IDataLayerCallback>
                         */
                        this.registerCallbacks = function (callBacks) {
                            _this.registeredCallbacks = [];
                            for (var i = 0; i < callBacks.length; i++) {
                                _this.registeredCallbacks.push(callBacks[i]);
                            }
                        };
                        /**
                         * @description To get configuration from  external source or from local object.
                         * If property advance.configOptions.loadFromFile is defined in config and its value is true then it performs http.get call
                         * to obtain configuration using path that defined in property advance.configOptions.pathToConfigFile. Otherwise resolves the promise.
                         * @returns Promise for configuration data.
                         */
                        this.getConfig = function () {
                            if (_this.configLoaded) {
                                return _this.$q.when(true);
                            }
                            else {
                                if (_.has(_this.config, 'advance.configOptions.loadFromFile')) {
                                    if (_this.config.advance.configOptions.loadFromFile) {
                                        var pathName = _this.config.advance.configOptions.pathToConfigFile;
                                        if (!_this.config.advance.configOptions.isAbsolutePath) {
                                            pathName = location.origin + location.pathname + pathName;
                                        }
                                        var $http = _this.$injector.get('$http');
                                        return $http.get(_this.config.advance.configOptions.pathToConfigFile)
                                            .then(function (response) {
                                            _this.configure(response.data);
                                            _this.configLoaded = true;
                                            return true;
                                        }).catch(function (error) {
                                            console.warn('Initializing data layer config from file failed', error);
                                            return true;
                                        });
                                    }
                                    else {
                                        return _this.$q.when(true);
                                    }
                                }
                                else {
                                    return _this.$q.when(true);
                                }
                            }
                        };
                        this.getGlobalSections = function () {
                            return [
                                service.DataLayerPredefinedSection.ACCOUNT,
                                service.DataLayerPredefinedSection.PAGE,
                                service.DataLayerPredefinedSection.PAGE_VIEW_EVENT,
                                service.DataLayerPredefinedSection.SITE
                            ];
                        };
                        /**
                         * @description To pass all the required parameters to the track function in common service
                         * @param mapping?: IDataLayerMapping
                         * @param resetSessionEvent?: boolean
                         */
                        this.trackGlobalAsync = function (mapping, resetSessionEvent) {
                            setTimeout(function () {
                                try {
                                    /* To make sure the tracking library has loaded and _trackData function exists */
                                    if (!_this.is_trackDataFunctionExist) {
                                        return;
                                    }
                                    var datalayerTrackParams_1 = {}, currentPayload_cb = _this.getCallbackByKey('payload'), currentPayload_promise = void 0, stateName = void 0;
                                    if (mapping) {
                                        stateName = mapping.mappingKey;
                                        datalayerTrackParams_1.mapping = mapping;
                                    }
                                    currentPayload_promise = (currentPayload_cb) ? currentPayload_cb.callback(stateName) : {};
                                    _this.$q.when(currentPayload_promise)
                                        .then(function (payLoadData) {
                                        if (!(payLoadData.suppressTracking)) {
                                            _this.mergeSelectedInformation(payLoadData || {}, false, [service.DataLayerPredefinedSection.GLOBAL])
                                                .then(function (payload) {
                                                _this.lastPayload = payload;
                                                _this.lastModalPayload = null;
                                                datalayerTrackParams_1.payload = payload;
                                                if (_.isBoolean(resetSessionEvent) && resetSessionEvent) {
                                                    _this.$rootScope.$emit('resetSessionEvent', true);
                                                }
                                                _this._track(datalayerTrackParams_1);
                                            })
                                                .catch(function (error) {
                                                console.warn('trackGlobalAsync -> mergeSelectedInformation: Error in merging payload data', error);
                                            });
                                        }
                                    })
                                        .catch(function (error) {
                                        console.warn('Error in resolving payload promise.');
                                    });
                                }
                                catch (error) {
                                    console.warn('trackGlobalAsync -> Data layer global track', error);
                                }
                            });
                        };
                        /**
                         * @description To return the complete / partial configuration at any point of time.
                         * @param key: if key is specified, only the corresponding config associated with the key will be returned.
                         * @returns IDataLayerServiceConfig
                         */
                        this.returnConfig = function (key) {
                            try {
                                if (_this.config) {
                                    return _.get(_this.config, key, !key && _this.config);
                                }
                            }
                            catch (error) {
                                console.warn('Error in returnConfig function', error);
                            }
                        };
                        /**
                         * @description To construct the payload object based on the passed in parameters.
                         * @param payload: IDataLayerTrackParams
                         * @param isModalPopup: Boolean, true if it's a modal popup
                         * @param selectedSections: DataLayerPredefinedSection[], predefined section
                         * @param mapping: IDataLayerMapping
                         */
                        this.trackAsync = function (payload, isModalPopup, selectedSections, mapping) {
                            if (isModalPopup === void 0) { isModalPopup = false; }
                            payload = payload || {};
                            var datalayerTrackParams = {
                                payload: payload,
                                mapping: mapping
                            }, payload_cb, payload_promise;
                            setTimeout(function () {
                                try {
                                    payload_cb = _this.getCallbackByKey('trackPayload');
                                    /* To make sure the tracking library has loaded and _trackData function exists */
                                    if (!_this.is_trackDataFunctionExist) {
                                        return;
                                    }
                                    payload_promise = (payload_cb) ? payload_cb.callback() : {};
                                    _this.$q.when(payload_promise)
                                        .then(function (payLoadData) {
                                        if (payLoadData) {
                                            _.merge(payload, payLoadData);
                                        }
                                        if (selectedSections && selectedSections.length > 0) {
                                            _this.mergeSelectedInformation(payload, isModalPopup, selectedSections)
                                                .then(function (payload) {
                                                if (!_.get(payload, 'liveChat')) {
                                                    _this.lastModalPayload = isModalPopup && payload || _this.lastModalPayload;
                                                    _this.lastPayload = !isModalPopup && payload || _this.lastPayload;
                                                }
                                                datalayerTrackParams.payload = payload;
                                                _this._track(datalayerTrackParams);
                                            })
                                                .catch(function (error) {
                                                console.warn('track -> mergeSelectedInformation: Error in merging payload data', error);
                                            });
                                        }
                                        else {
                                            if (!_.get(payload, 'liveChat')) {
                                                _this.lastModalPayload = isModalPopup && payload || _this.lastModalPayload;
                                                _this.lastPayload = !isModalPopup && payload || _this.lastPayload;
                                            }
                                            _this._track(datalayerTrackParams);
                                        }
                                    })
                                        .catch(function (error) {
                                        console.warn('Error in resolving payload promise.');
                                    });
                                }
                                catch (error) {
                                    console.warn('Error in track function', error);
                                }
                            });
                        };
                        /**
                         * @description 1. To construct the payload object based on the passed in parameters.
                         *              2. To obtain partial payload based on params.mapping and merge into final payload.
                         *              3. To perform call to _trackData function with final payload object
                         * @param params: Contains 2 properties => mapping and payload
                         */
                        this._track = function (params) {
                            var mappingPayLoad;
                            //To make sure the tracking library has loaded and _trackData is a function
                            if (!_this.is_trackDataFunctionExist) {
                                return;
                            }
                            _this.getConfig()
                                .then(function () {
                                if (params) {
                                    if (params.mapping) {
                                        mappingPayLoad = _this.getMappingPayload(params.mapping);
                                        if (mappingPayLoad) {
                                            _.merge(params.payload, mappingPayLoad);
                                        }
                                    }
                                    _trackData(params.payload);
                                    _this.trackGTM(params.payload);
                                }
                            });
                        };
                        /**
                         * @description To send the payload object with errors to the dataLayerTrack function from the data layer common service.
                         * @param payload: ITrackDataPayload,
                         * @param trackingErrors: IADLError[],
                         * @param isModalPopup?: boolean, (default = false)
                         * @param selectedSections?: DataLayerPredefinedSection[],
                         */
                        this.trackErrors = function (payload, trackingErrors, isModalPopup, selectedSections) {
                            if (isModalPopup === void 0) { isModalPopup = false; }
                            try {
                                /* To make sure the tracking library has loaded and _trackData function exists */
                                if (!_this.is_trackDataFunctionExist) {
                                    return;
                                }
                                var errors = trackingErrors;
                                var event_1 = { error: true };
                                /* To set Error Type to lowercase and Decode HTML entity for message */
                                errors.map(function (err) {
                                    err.type = err.type.replace('_', ' ').toLocaleLowerCase();
                                    err.message = angular.element('<textarea />').html(err.message).text();
                                    err.category = err.category.replace('_', ' ').toLocaleLowerCase();
                                });
                                var _payload = {
                                    errors: errors,
                                    events: event_1
                                };
                                if (angular.isObject(payload)) {
                                    _.merge(payload, _payload);
                                }
                                _this.trackAsync(payload, isModalPopup, selectedSections);
                            }
                            catch (error) {
                                console.warn('Data layer tracking errors', error);
                            }
                        };
                        /**
                         * @description
                         * @param payload: ITrackDataPayload,
                         * @param errorType: ErrorType,
                         * @param errorCode: string,
                         * @param errorMessage: string,
                         * @param errorCategory: ErrorType,
                         * @param errorField: string,
                         * @param errorAPI: string,
                         * @param isModalPopup?: boolean, (default = false)
                         * @param selectedSections?: DataLayerPredefinedSection[],
                         * @param mapping?: IDataLayerMapping
                         */
                        this.trackError = function (payload, errorType, errorCode, errorMessage, errorCategory, errorField, errorAPI, isModalPopup, selectedSections, mapping) {
                            if (errorField === void 0) { errorField = service.formErrorDefaultFieldName; }
                            if (isModalPopup === void 0) { isModalPopup = false; }
                            setTimeout(function () {
                                try {
                                    /* To make sure the tracking library has loaded and _trackData function exists */
                                    if (!_this.is_trackDataFunctionExist) {
                                        return;
                                    }
                                    payload = payload || {};
                                    var errors = [{
                                            type: service.ErrorType[errorType],
                                            code: errorCode,
                                            message: errorMessage,
                                            category: service.ErrorCategory[errorCategory],
                                            field: errorField,
                                            API: errorAPI
                                        }];
                                    if (mapping && mapping.mappingKey) {
                                        _.merge(payload, _this.getMappingPayload(mapping));
                                    }
                                    _this.trackErrors(payload, errors, isModalPopup, selectedSections);
                                }
                                catch (error) {
                                    console.warn('trackError method: ', error);
                                }
                            });
                        };
                        /**
                         * @description To track error on form field
                         * @param payload: ITrackDataPayload, // if payload param is undefined then tryies to get payload from configuration
                         * @param errorMessage: string,
                         * @param errorField: string,
                         * @param isModalPopup?: boolean, (default = false)
                         * @param selectedSections?: DataLayerPredefinedSection[], if not specified then used all 4 sections
                         * @param mapping?: IDataLayerMapping
                         */
                        this.trackFormErrorAsync = function (payload, errorMessage, errorField, isModalPopup, selectedSections, mapping) {
                            setTimeout(function () {
                                var error, errors = [];
                                payload = payload || {};
                                try {
                                    /* To make sure the tracking library has loaded and _trackData function exists */
                                    if (!_this.is_trackDataFunctionExist) {
                                        return;
                                    }
                                    if (mapping && mapping.mappingKey) {
                                        var mappingKeys = mapping.mappingKey.split(',');
                                        //set error mapping keys
                                        var errorMappingKeysArr = _.filter(mappingKeys, function (keyItem) {
                                            return keyItem.indexOf('errors:') > -1;
                                        });
                                        error = _this.getErrorData('', errorMessage, errorField, errorMappingKeysArr);
                                        // Merge value "FORM" to property "type" in error object. This value will always be used in tracking error
                                        // on form validation.
                                        if (error) {
                                            _.merge(error, { type: service.ErrorType[service.ErrorType.FORM] });
                                            errors.push(error);
                                        }
                                        //remove error mapping keys prefixed by 'errors:' from mapping object
                                        mapping.mappingKey = _.difference(mappingKeys, errorMappingKeysArr).join(',');
                                        _.merge(payload, _this.getMappingPayload(mapping));
                                    }
                                    _this.trackErrors(payload, errors, isModalPopup, selectedSections);
                                }
                                catch (error) {
                                    console.warn('trackFormError method: ', error);
                                }
                            });
                        };
                        /**
                         * @description To track error on api failure
                         * @param errorCode: string,
                         * @param errorMessage: string,
                         * @param isModalPopup?: boolean, (default = false)
                         * @param selectedSections?: DataLayerPredefinedSection[], if not specified then used all 4 sections
                         * @param mapping?: IDataLayerMapping
                         */
                        this.trackAPIErrorAsync = function (errorCode, errorMessage, isModalPopup, selectedSections, mapping) {
                            setTimeout(function () {
                                var payload = {}, error, errors = [];
                                try {
                                    if (mapping && mapping.mappingKey) {
                                        var mappingKeys = mapping.mappingKey.split(',');
                                        var errorMappingKeysArr = _.filter(mappingKeys, function (keyItem) {
                                            return keyItem.indexOf('errors:') > -1;
                                        });
                                        error = _this.getErrorData(errorCode, errorMessage, '', errorMappingKeysArr);
                                        //remove error mapping keys prefixed by 'errors:' from mapping object
                                        mapping.mappingKey = _.difference(mappingKeys, errorMappingKeysArr).join(',');
                                        payload = _this.getMappingPayload(mapping);
                                        errors.push(error);
                                        _this.trackErrors(payload, errors, isModalPopup, selectedSections);
                                    }
                                }
                                catch (error) {
                                    console.warn('trackAPIError method: ', error);
                                }
                            });
                        };
                        /**
                         * @description 1. To track modal popup triggered by UteModal
                         *              2. This function will be called when uteModal.defaultConfigObject.opened function is invoked.
                         *              3. either trackAsync or trackFormErrorAsync (when data.isError === true) will be called.
                         * @param config: uteModal.config object
                         */
                        this.trackUteModalAsync = function (config) {
                            setTimeout(function () {
                                try {
                                    var $state = _this.$injector.get('$state');
                                    var mapping = _this.getMappingPayload({ mappingKey: $state.current.name });
                                    if (mapping && Object.keys(mapping).length > 0) {
                                        var key = _this.getConfigByMappingKey({ 'mappingKey': 'modal' });
                                        var template = _.get(key, config.templateUrl, {});
                                        var func = _.get(template, 'response', '');
                                        if (func) {
                                            var data = func(config, $state.current.name);
                                            if (data && Object.keys(data).length > 0) {
                                                var payload = _.get(data, 'payload', {});
                                                if (data.isError) {
                                                    _this.trackError(payload, data.errorType || service.ErrorType.FORM, data.errorCode, data.errorMessage, data.errorCategory, data.errorField, data.errorAPI, true, [service.DataLayerPredefinedSection.GLOBAL]);
                                                }
                                                else {
                                                    _this.trackAsync(payload, true, [service.DataLayerPredefinedSection.GLOBAL]);
                                                }
                                            }
                                        }
                                    }
                                }
                                catch (error) {
                                    console.warn('trackUteModal method: ', error);
                                }
                            });
                        };
                        /**
                         * @description To track on httpInterceptor request.
                         * @param config: config object from http interceptor
                         */
                        this.trackHttpRequest = function (config) {
                            try {
                                var key = _this.getConfigByMappingKey({ 'mappingKey': 'api' }) || {};
                                var path_1 = _this.URI(config.url).path;
                                var keys = Object.keys(key);
                                var api = keys[_.findIndex(keys, function (k) { return path_1.match(k); })] || '';
                                var func = _.get(key, api + '.request', '');
                                if (func) {
                                    var $state = _this.$injector.get('$state');
                                    var respData = func(config, api, $state.current.name, _this.$injector);
                                    _this.$q.when(respData).then(function (data) {
                                        var payload = _.get(data, 'payload', {});
                                        if (data && Object.keys(data).length > 0) {
                                            var selectedSections = (data.pageView === false) ? [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE] : [service.DataLayerPredefinedSection.GLOBAL];
                                            _this.trackAsync(payload, data.isModalPopup, selectedSections);
                                        }
                                    });
                                    config.track = true;
                                    config.api = api;
                                }
                                else if (_.get(key, api + '.response') || _.get(key, api + '.responseError')) {
                                    config.track = true;
                                    config.api = api;
                                }
                            }
                            catch (error) {
                                console.warn('Error in trackHttpRequest function', error);
                            }
                        };
                        /**
                         * @description To track on httpInterceptor response.
                         * @param response: response object from http interceptor
                         */
                        this.trackHttpResponseAsync = function (response) {
                            setTimeout(function () {
                                try {
                                    var api = response.config.api;
                                    var key = _this.getConfigByMappingKey({ 'mappingKey': 'api.' + api });
                                    var func = _.get(key, 'response', '');
                                    if (func) {
                                        var $state = _this.$injector.get('$state');
                                        var respData = func(response, api, $state.current.name, _this.$injector);
                                        _this.$q.when(respData).then(function (data) {
                                            var payload = _.get(data, 'payload', {});
                                            if (data && Object.keys(data).length > 0) {
                                                var selectedSections = (data.pageView === false) ? [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE] : [service.DataLayerPredefinedSection.GLOBAL];
                                                if (data.isError) {
                                                    _this.trackError(payload, data.errorType, data.errorCode, data.errorMessage, data.errorCategory, '', data.errorAPI, data.isModalPopup, [service.DataLayerPredefinedSection.GLOBAL]);
                                                }
                                                else {
                                                    _this.trackAsync(payload, data.isModalPopup, selectedSections);
                                                }
                                            }
                                        });
                                    }
                                }
                                catch (error) {
                                    console.warn('Error in trackHttpResponseAsync function', error);
                                }
                            });
                        };
                        /**
                         * @description To track on httpInterceptor responseError.
                         * @param rejection: rejection object from http interceptor
                         */
                        this.trackHttpResponseErrorAsync = function (rejection) {
                            setTimeout(function () {
                                try {
                                    var key = _this.getConfigByMappingKey({ 'mappingKey': 'api' });
                                    var api = rejection.config.api;
                                    var func = _.get(key, api + '.responseError', _.get(key, 'default.responseError'));
                                    if (func) {
                                        var $state = _this.$injector.get('$state');
                                        var respData = func(rejection, api, $state.current.name, _this.$injector);
                                        _this.$q.when(respData).then(function (data) {
                                            if (data && Object.keys(data).length > 0) {
                                                var payload = _.get(data, 'payload', {});
                                                _this.trackError(payload, data.errorType, data.errorCode, data.errorMessage, data.errorCategory, '', data.errorAPI, data.isModalPopup, [service.DataLayerPredefinedSection.GLOBAL]);
                                            }
                                        });
                                    }
                                }
                                catch (error) {
                                    console.warn('Error in trackHttpResponseErrorAsync function', error);
                                }
                            });
                        };
                        /**
                         * @description To return a error object by:
                         *  1. Retrieving mapping values by mapping keys for category, type and API properties.
                         *  2. Setting properties code, message, field using passed in params
                         * @param errorCode: string
                         * @param errorMessage: string
                         * @param fieldName: string
                         * @param keysArr: string[]; can contain one or more mapping key items in the following structure:
                         *                           ['errors:key1:key2',errors:key3']
                         * @returns error: IADLError
                         */
                        this.getErrorData = function (errorCode, errorMessage, fieldName, keysArr) {
                            var self = _this;
                            var errorData = {
                                code: errorCode,
                                message: errorMessage,
                                field: fieldName,
                                type: '',
                                category: '',
                                API: ''
                            };
                            var mappingKeys = [], errorMappingKeysStr;
                            _.forEach(keysArr, function (keyItem) {
                                keyItem = _.trim(keyItem);
                                //trim errors keyword in keyItem string from index 7 till end of the string: errors:key1:key2 => key1:key2
                                errorMappingKeysStr = keyItem.substr(7);
                                //concat mappingKeys array and errorMappingKeysStr.split(':')
                                mappingKeys = mappingKeys.concat(errorMappingKeysStr.split(':'));
                            });
                            _.forEach(mappingKeys, function (mappingKey) {
                                if (_.has(self.config.advance.mappingKey, mappingKey)) {
                                    _.merge(errorData, _.cloneDeep(_.get(self.config.advance.mappingKey, mappingKey)));
                                }
                                else {
                                    console.warn('getErrorData => errorMappingKey: ' + mappingKey + ' is not defined in advance.mappingKey configuration property');
                                }
                            });
                            return errorData;
                        };
                        /**
                         * @description To return a page payload object by:
                         *  1. Retrieving mapping value by mapping key from config object.
                         *  2. Setting the page name and hierarchy by parsing the hash value if a mapping doesn't exist.
                         * @param mapping: IDataLayerMapping
                         * @returns payload: ITrackDataPayload
                         */
                        this.getMappingPayload = function (mapping) {
                            var payload = {}, _location = location.hash, _stateURL = (mapping.stateURL) ? mapping.stateURL : '';
                            if (mapping.mappingKey) {
                                var mappingKeys = mapping.mappingKey.split(',');
                                _.forEach(mappingKeys, function (mappingKey) {
                                    mappingKey = _.trim(mappingKey);
                                    if (_.has(_this.config.advance.mappingKey, mappingKey)) {
                                        _.merge(payload, _.cloneDeep(_.get(_this.config.advance.mappingKey, mappingKey)));
                                    }
                                    else {
                                        console.warn('getMappingPayload => mappingKey: ' + mappingKey + ' is not defined in advance.mappingKey configuration property');
                                    }
                                });
                            }
                            else if (mapping.mappingKey !== '') {
                                //Setting the page name and hierarchy by parsing the hash value if a mappingKey is not provided.
                                //In case mappingKey is empty string, this functionality will be skipped.
                                if (Object.keys(payload).length === 0) {
                                    /* to handle cases when a parameter exists in an URL */
                                    if (_stateURL.indexOf('/:') > -1) {
                                        var key = _stateURL.split('/:')[0];
                                        _location = _location.substring(0, _location.indexOf(key) + key.length);
                                    }
                                    payload = {
                                        page: _this.parseHashValue(_location)
                                    };
                                }
                            }
                            return payload;
                        };
                        /**
                         * @description To return page hierarchy and page name by:
                         *  1. Parsing the hash value (i.e. location.hash)
                         * @returns page: IADLPage
                         */
                        this.getPageHierarchy = function () {
                            var _location = location.hash;
                            return _this.parseHashValue(_location);
                        };
                        /**
                         * @description To return config object by:
                         *  1. Retrieving mapping value by mapping key from config object.
                         * @param mapping: IDataLayerMapping
                         * @returns mappedObject: any
                         */
                        this.getConfigByMappingKey = function (mapping) {
                            var mappedObject;
                            if (_.has(_this.config, mapping.mappingKey)) {
                                mappedObject = _.cloneDeep(_.get(_this.config, mapping.mappingKey));
                            }
                            return mappedObject;
                        };
                        /**
                         * @description To configure page payload object
                         *
                         */
                        this.getAccountPayloadData = function () {
                            var accountPayload, accountData, wirelessData;
                            var currentAccount_cb = _this.getCallbackByKey('account');
                            var currentUser_cb = _this.getCallbackByKey('user');
                            var currentDevice_cb = _this.getCallbackByKey('device');
                            var currentPlanInfo_cb = _this.getCallbackByKey('plan');
                            var currentAccount_promise, currentUser_promise, currentDevice_promise, currentPlanInfo_promise;
                            if (currentAccount_cb) {
                                currentAccount_promise = currentAccount_cb.callback();
                            }
                            if (currentUser_cb) {
                                currentUser_promise = currentUser_cb.callback();
                            }
                            if (currentDevice_cb) {
                                currentDevice_promise = currentDevice_cb.callback();
                            }
                            if (currentPlanInfo_cb) {
                                currentPlanInfo_promise = currentPlanInfo_cb.callback();
                            }
                            return _this.$q.all([currentAccount_promise, currentUser_promise, currentDevice_promise, currentPlanInfo_promise])
                                .then(function (values) {
                                var accountObj = values[0], userObj = values[1], deviceObj = values[2], planObj = values[3];
                                if ((accountObj && !_.isEmpty(accountObj)) || (userObj && !_.isEmpty(userObj))) {
                                    accountData = {};
                                    if (accountObj && !_.isEmpty(accountObj)) {
                                        if (accountObj.accountType) {
                                            accountData.type = accountObj.accountType.toLowerCase();
                                        }
                                        if (accountObj.accountNumber) {
                                            accountData.BAN = accountObj.accountNumber.toString();
                                        }
                                        if (accountObj.phoneNumber) {
                                            accountData.CTN = accountObj.phoneNumber.toString();
                                        }
                                    }
                                    if (userObj && !_.isEmpty(userObj)) {
                                        accountData.userType = userObj.userType;
                                        accountData.userName = userObj.userName;
                                        if (userObj.dealerCode) {
                                            accountData.dealerCode = userObj.dealerCode;
                                        }
                                        if (userObj.dealerType) {
                                            accountData.dealerType = userObj.dealerType;
                                        }
                                    }
                                    if ((deviceObj && !_.isEmpty(deviceObj)) || (planObj && !_.isEmpty(planObj))) {
                                        wirelessData = {};
                                        if (deviceObj && !_.isEmpty(deviceObj)) {
                                            wirelessData.device = deviceObj.device;
                                        }
                                        if (planObj && !_.isEmpty(planObj)) {
                                            wirelessData.plan = planObj.plan;
                                            wirelessData.balance = {
                                                amount: planObj.amount,
                                                payoffDate: planObj.payoffDate
                                            };
                                        }
                                        if (wirelessData && !_.isEmpty(wirelessData)) {
                                            accountData.wireless = wirelessData;
                                        }
                                    }
                                    if (accountData && !_.isEmpty(accountData)) {
                                        accountPayload = { account: accountData };
                                    }
                                }
                                return accountPayload;
                            })
                                .catch(function (error) {
                                console.warn('Error in configuring account section. Failed to load account/user details.');
                                return accountPayload;
                            });
                        };
                        /**
                         * @description To configure page payload object
                         *
                         */
                        this.getPagePayloadData = function (isModalPopup) {
                            var pagePayload;
                            var pageData;
                            var currentLanguage_cb = _this.getCallbackByKey('language');
                            var currentProvince_cb = _this.getCallbackByKey('province');
                            var currentLanguage_promise;
                            var currentProvince_promise;
                            if (currentLanguage_cb) {
                                currentLanguage_promise = currentLanguage_cb.callback();
                            }
                            if (currentProvince_cb) {
                                currentProvince_promise = currentProvince_cb.callback();
                            }
                            return _this.$q.all([currentLanguage_promise, currentProvince_promise])
                                .then(function (values) {
                                var languageResponse = values[0];
                                var provinceResponse = values[1];
                                pageData = {
                                    url: isModalPopup ? 'modal popup' : location.href,
                                    referrer: isModalPopup ? location.href : _this.referrer || location.href,
                                    ICMTimestamp: moment().format('dddd|MM/DD/YYYY HH:mm'),
                                    responsiveVersion: _this.isMobile() ? 'mobile' : 'desktop'
                                };
                                if (languageResponse) {
                                    pageData.language = languageResponse.language;
                                }
                                if (provinceResponse) {
                                    pageData.province = provinceResponse.province.toLowerCase();
                                }
                                _this.referrer = location.href;
                                return pagePayload = { page: pageData };
                            })
                                .catch(function (error) {
                                console.warn('Error in configuring page section. Failed to load language/province details.');
                                return pagePayload;
                            });
                        };
                        /**
                         * @description To merge all the selected information to the payload object.
                         * @param payload: ITrackDataPayload,
                         * @param selectedSections: DataLayerPredefinedSection[]
                         */
                        this.mergeSelectedInformationSync = function (payload, selectedSections) {
                            try {
                                //DA-45 - Remove pageView event for all errors tracking
                                var pageViewIndex = selectedSections.indexOf(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                if (_.get(payload, 'events.error') === true && pageViewIndex >= 0) {
                                    selectedSections.splice(pageViewIndex, 1);
                                }
                                /* Populate selected payload information */
                                selectedSections.forEach(function (section) {
                                    switch (section) {
                                        case service.DataLayerPredefinedSection.PAGE_VIEW_EVENT:
                                            _.merge(payload, { events: _this.getPageViewEventObject() });
                                            break;
                                        case service.DataLayerPredefinedSection.SIGNIN:
                                            _.merge(payload, { signin: _this.getSigninObject() });
                                            break;
                                        case service.DataLayerPredefinedSection.SITE:
                                            _.merge(payload, { site: _this.getSiteObject() });
                                            break;
                                        default:
                                    }
                                });
                                return payload;
                            }
                            catch (error) {
                                console.warn('Merge selected tracking data', error);
                            }
                        };
                        /**
                         * @description To merge all the selected information to the payload object.
                         * @param payload: ITrackDataPayload,
                         * @param isModalPopup: boolean,
                         * @param selectedSections: DataLayerPredefinedSection[]
                         */
                        this.mergeSelectedInformation = function (payload, isModalPopup, selectedSections) {
                            var promises = [];
                            if (_.indexOf(selectedSections, service.DataLayerPredefinedSection.GLOBAL) >= 0) {
                                selectedSections = _this.getGlobalSections();
                            }
                            if (_.indexOf(selectedSections, service.DataLayerPredefinedSection.ACCOUNT) >= 0) {
                                promises.push(_this.getAccountPayloadData());
                            }
                            if (_.indexOf(selectedSections, service.DataLayerPredefinedSection.PAGE) >= 0) {
                                promises.push(_this.getPagePayloadData(isModalPopup));
                            }
                            if (promises.length > 0) {
                                return _this.$q.all(promises)
                                    .then(function (payLoadData) {
                                    payLoadData.forEach(function (_payLoadItem) {
                                        if (_payLoadItem) {
                                            _.merge(payload, _payLoadItem);
                                        }
                                    });
                                    _.merge(payload, _this.mergeSelectedInformationSync(payload, selectedSections));
                                    return payload;
                                }).catch(function (error) {
                                    console.warn('Error in merging selected tracking data', error);
                                    return _this.$q.reject(error);
                                });
                            }
                            else {
                                _.merge(payload, _this.mergeSelectedInformationSync(payload, selectedSections));
                                return _this.$q.when(payload);
                            }
                        };
                        /**
                         * @description To get the data layer site object.
                         */
                        this.getSiteObject = function () {
                            return {
                                name: _this.config.basic.site.name
                            };
                        };
                        /**
                         * @description To get the data layer signin object
                         */
                        this.getSigninObject = function () {
                            return {
                                type: _this.config.basic.signin.type
                            };
                        };
                        /**
                         * @description To get the data layer event object
                         */
                        this.getPageViewEventObject = function () {
                            return {
                                pageView: true
                            };
                        };
                        this.isMobile = function () {
                            return (_this.isAndroid() || _this.isBlackBerry() || _this.isIOS() || _this.isWindowsMobile());
                        };
                        this.isWindowsMobile = function () {
                            return /IEMobile/i.test(_this.$window.navigator.userAgent);
                        };
                        this.isAndroid = function () {
                            return /Android/i.test(_this.$window.navigator.userAgent);
                        };
                        this.isBlackBerry = function () {
                            return /BlackBerry/i.test(_this.$window.navigator.userAgent);
                        };
                        this.isIOS = function () {
                            return /iPhone|iPad|iPod/i.test(_this.$window.navigator.userAgent);
                        };
                        this.URI = function (str) {
                            // Based on the regex in RFC2396 Appendix B.
                            var parser = /^(?:([^:\/?\#]+):)?(?:\/\/([^\/?\#]*))?([^?\#]*)(?:\?([^\#]*))?(?:\#(.*))?/;
                            var result = str.match(parser);
                            return {
                                scheme: result[1] || null,
                                authority: result[2] || null,
                                path: result[3] || null,
                                query: result[4] || null,
                                fragment: result[5] || null
                            };
                        };
                        this.$get.$inject = ['$q', '$window', '$rootScope', '$injector'];
                    }
                    DataLayerServiceProvider.prototype.trackGTM = function (payload) {
                        try {
                            if (payload && payload.events) {
                                var gtmPayload = _.cloneDeep(payload);
                                gtmPayload.event = Object.keys(gtmPayload.events)
                                    .reduce(function (prev, current, index) { return (index > 0) ? prev + ' // ' + current : prev + current; }, 'LEGACY /// ');
                                window.analyticsLayer = window.analyticsLayer || [];
                                window.analyticsLayer.push(gtmPayload);
                            }
                        }
                        catch (error) {
                            console.warn('Error in trackGTM function', error);
                        }
                    };
                    /**
                     * @description To return an object with page name and hierarchy by parsing the hash value (i.e. location.hash)
                     * @param hash: string
                     * @returns pageObj: { name: string, hierarchy: string }
                     */
                    DataLayerServiceProvider.prototype.parseHashValue = function (hash) {
                        var hashValue, pageName, hashValueParts, hashValueArr, rootHierarchy, pageObj = {};
                        if (_.has(this.config, 'advance.configOptions.rootHierarchy')) {
                            rootHierarchy = this.config.advance.configOptions.rootHierarchy;
                        }
                        // Removing query parameters from the URI
                        if (hash.indexOf('?') > 0) {
                            hash = hash.split('?')[0];
                        }
                        hashValueArr = hash.split('#/');
                        if (hashValueArr.length > 1) {
                            hashValue = hashValueArr[1]; // hashValueArr[0] will be empty string
                            hashValueParts = hashValue.split('/').join('|').toLowerCase().split('|');
                            pageName = hashValueParts[hashValueParts.length - 1];
                            if (rootHierarchy && rootHierarchy.length > 0) {
                                hashValueParts = rootHierarchy.concat(hashValueParts);
                            }
                            pageObj = {
                                name: pageName,
                                hierarchy: hashValueParts
                            };
                        }
                        return pageObj;
                    };
                    return DataLayerServiceProvider;
                }());
                angular.module('ute.datalayer.common').provider('ute.datalayer.common.service', DataLayerServiceProvider);
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var UteDataLayerErrorTrack = (function () {
                    function UteDataLayerErrorTrack(dataLayerService, $q, $state) {
                        var _this = this;
                        this.dataLayerService = dataLayerService;
                        this.$q = $q;
                        this.$state = $state;
                        this.restrict = 'A';
                        this.linkFn = function ($scope, element, attrs) {
                            var parsedErrorAttributes;
                            var mapping, errorCode = '', errorApi = '';
                            var selectedSections = [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE];
                            var field;
                            var category;
                            if (_this.dataLayerService.isStateDefined(_this.$state.current.name)) {
                                $scope.$applyAsync(function () {
                                    try {
                                        parsedErrorAttributes = JSON.parse(attrs.adlErrorTrack);
                                        if (parsedErrorAttributes.mappingKey) {
                                            mapping = {
                                                mappingKey: parsedErrorAttributes.mappingKey
                                            };
                                        }
                                        if (parsedErrorAttributes.pageView) {
                                            selectedSections.push(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                        }
                                        field = _this.dataLayerService.returnConfig('advance.mappingKey.' + parsedErrorAttributes.field) || parsedErrorAttributes.field;
                                        category = service.ErrorCategory[_.get(parsedErrorAttributes, 'category', 'self_serve').toLocaleUpperCase()];
                                        if (typeof category === 'undefined') {
                                            category = service.ErrorCategory.SELF_SERVE;
                                        }
                                        _this.getErrorPayload($scope, parsedErrorAttributes.callBackParam).then(function (payload) {
                                            _this.dataLayerService.trackError(payload, service.ErrorType.FORM, errorCode, element.text().trim(), category, field, errorApi, parsedErrorAttributes.isModalPopup, selectedSections, mapping);
                                        });
                                    }
                                    catch (err) {
                                        console.warn('Exception in dataLayer form error directive', err);
                                    }
                                });
                            }
                        };
                        this.link = this.linkFn;
                    }
                    UteDataLayerErrorTrack.factory = function () {
                        var directive = function (dataLayerService, $q, $state) { return new UteDataLayerErrorTrack(dataLayerService, $q, $state); };
                        directive.$inject = ['ute.datalayer.common.service', '$q', '$state'];
                        return directive;
                    };
                    ;
                    UteDataLayerErrorTrack.prototype.getErrorPayload = function (scope, callbackParam) {
                        var errorPayload_cb, errorPayload_promise;
                        errorPayload_cb = this.dataLayerService.getCallbackByKey('errorPayload');
                        if (errorPayload_cb && callbackParam) {
                            errorPayload_promise = errorPayload_cb.callback(callbackParam);
                            return this.$q.when(errorPayload_promise)
                                .catch(function (error) {
                                console.warn('Error in handling errorPayload callback.');
                                return;
                            });
                        }
                        return this.$q.when({});
                    };
                    return UteDataLayerErrorTrack;
                }());
                angular.module('ute.datalayer.common').directive('adlErrorTrack', UteDataLayerErrorTrack.factory());
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var UteDataLayerEventTrack = (function () {
                    function UteDataLayerEventTrack(dataLayerService, $q, $state) {
                        var _this = this;
                        this.dataLayerService = dataLayerService;
                        this.$q = $q;
                        this.$state = $state;
                        this.restrict = 'A';
                        this.linkFn = function ($scope, element, attrs) {
                            var mapping;
                            var parsedEventAttributes;
                            var self = _this;
                            var selectedSections;
                            try {
                                if (_this.dataLayerService.isStateDefined(_this.$state.current.name)) {
                                    parsedEventAttributes = JSON.parse(attrs.adlEventTrack);
                                    if (parsedEventAttributes.action) {
                                        element.on(parsedEventAttributes.action, function (event) {
                                            if (parsedEventAttributes.oneTimeAction) {
                                                element.off(parsedEventAttributes.action);
                                                parsedEventAttributes.oneTimeAction = false;
                                            }
                                            track();
                                        });
                                    }
                                    else {
                                        track();
                                    }
                                }
                            }
                            catch (err) {
                                console.warn('Exception in dataLayer form event tracking directive', err);
                            }
                            $scope.$on('$destroy', function () {
                                if (parsedEventAttributes && parsedEventAttributes.action) {
                                    element.off(parsedEventAttributes.action);
                                }
                            });
                            function track() {
                                $scope.$applyAsync(function () {
                                    try {
                                        selectedSections = [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE];
                                        // Have to parse second time at the moment when event occurs to obtain updated evaluated expression
                                        parsedEventAttributes = JSON.parse(attrs.adlEventTrack);
                                        if (!(parsedEventAttributes.suppressTracking === true)) {
                                            if (parsedEventAttributes.pageView) {
                                                selectedSections.push(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                            }
                                            if (parsedEventAttributes.mappingKey) {
                                                mapping = {
                                                    mappingKey: parsedEventAttributes.mappingKey
                                                };
                                            }
                                            self.getEventPayload($scope, parsedEventAttributes.callBackParam)
                                                .then(function (payload) {
                                                self.dataLayerService.track(payload, parsedEventAttributes.isModalPopup, selectedSections, mapping);
                                            });
                                        }
                                    }
                                    catch (err) {
                                        console.warn('Exception in dataLayer form event tracking directive', err);
                                    }
                                });
                            }
                        };
                        this.getEventPayload = function ($scope, callbackParam) {
                            var eventPayload_cb, eventPayload_promise;
                            eventPayload_cb = _this.dataLayerService.getCallbackByKey('eventPayload');
                            if (eventPayload_cb && callbackParam) {
                                eventPayload_promise = eventPayload_cb.callback(callbackParam);
                                return _this.$q.when(eventPayload_promise)
                                    .catch(function (error) {
                                    console.warn('Error in handling eventPayload callback.');
                                    return;
                                });
                            }
                            return _this.$q.when({});
                        };
                        this.link = this.linkFn;
                    }
                    UteDataLayerEventTrack.factory = function () {
                        var directive = function (dataLayerService, $q, $state) { return new UteDataLayerEventTrack(dataLayerService, $q, $state); };
                        directive.$inject = ['ute.datalayer.common.service', '$q', '$state'];
                        return directive;
                    };
                    ;
                    return UteDataLayerEventTrack;
                }());
                angular.module('ute.datalayer.common').directive('adlEventTrack', UteDataLayerEventTrack.factory());
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var deeplink;
        (function (deeplink) {
            var service;
            (function (service) {
                'use strict';
                angular.module('ute.rogers.deeplink').run(addStateHandler);
                addStateHandler.$inject = ['ute.blocks.router', 'ute.rogers.deeplink.service'];
                /* @ngInject */
                function addStateHandler(routerHelper, deeplinkService) {
                    routerHelper.registerGlobalToStateHandler(deeplinkService, ute.blocks.router.StateHandlerPriority.HIGH);
                }
            })(service = deeplink.service || (deeplink.service = {}));
        })(deeplink = rogers.deeplink || (rogers.deeplink = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var deeplink;
        (function (deeplink) {
            var service;
            (function (service) {
                'use strict';
                var DeeplinkProvider = (function () {
                    /* @ngInject */
                    function DeeplinkProvider() {
                        var _this = this;
                        this.config = {
                            signinState: 'signin',
                            signoutState: 'signout',
                            referer: 'referer'
                        }; // defaults
                        /* @ngInject */
                        this.$get = ["$state", "$injector", "$location", "$window", "$timeout", function ($state, $injector, $location, $window, $timeout) {
                            _this.$state = $state;
                            _this.storageService = $injector.get('ute.blocks.persistent.storage.service');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.securityService = $injector.get('ute.common.security.service');
                            _this.$location = $location;
                            _this.$window = $window;
                            _this.$timeout = $timeout;
                            var messagesService = $injector.get('ute.blocks.messages.bus.service');
                            //messagesService.register(ute.blocks.messages.bus.Messages.uteRogersSigninSuccessful, this.signinSuccessfulHandler);
                            //messagesService.register(Messages.uteUserUnauthorized, (event: ng.IAngularEvent, ...args: any[]) => {
                            //  console.log('SigninService got a message:', event.name);
                            //  $state.go(this.environmentService.getProperty('apiUrls.signoutState'));
                            //});
                            messagesService.register(ute.blocks.messages.bus.Messages.uteUserUnauthorized, function (event) {
                                var args = [];
                                for (var _i = 1; _i < arguments.length; _i++) {
                                    args[_i - 1] = arguments[_i];
                                }
                                // console.log('DeeplinkService got a message:', event.name, /*args[0].toState.name*/ $state.current.name, $state.params);
                                _this.userService.unsigned();
                                _this.navigateToSignin($state.current, $state.params);
                                // $state.go(this.config.signoutState).then((data: any) => {
                                //   //console.log('signin.service->$state.go->then', data);
                                // }).catch((error: any) => {
                                //   //console.log('signin.service->$state.go->catch', error);
                                //   //this.$state.go();
                                // }).finally(() => {
                                //   //console.log('signin.service->$state.go->finally');
                                // });
                            });
                            _this.savedState = _this.storageService.get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_STATE);
                            // if (_.get<string>(this.savedState, 'params.id')) {  // TODO all params
                            //   this.savedState.params.id = encodeURIComponent(this.savedState.params.id).replace(/%/g, '~');
                            // }
                            // console.log('DeeplinkService->restore from storage: savedState=', this.savedState);
                            return {
                                stateTransitionHandler: _this.stateTransitionHandler.bind(_this),
                                getDeeplinkState: _this.getDeeplinkState,
                                signinAndNavigate: _this.signinAndNavigate
                            };
                        }];
                        /**
                         * TODO validation + defaults
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        /**
                         * @param toState - optional, if specified url will be ignored
                         * @param toParams - optional
                         * @param url - optional, full url, if not specified 'window.location.href' will be used
                         * @returns {boolean} - true if navigation Ok
                         */
                        this.navigateToSignin = function (toState, toParams, url) {
                            if (_this.config.signinUri || !angular.isDefined(toState)) {
                                _this.saveDeeplinkState({ name: url || _this.$window.location.href });
                                _this.$window.location.href = _this.config.signinUri;
                                return true;
                            }
                            else if (_this.config.signinState && angular.isDefined(toState)) {
                                _this.saveDeeplinkState({ name: toState.name, params: toParams });
                                _this.$state.go(_this.config.signinState);
                                return true;
                            }
                            return false;
                        };
                        this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                            //           console.log(`DeeplinkService->stateTransitionHandler: event.name=${event.name} toState=${toState.name} \
                            // isStateProtected=${this.securityService.isStateProtected(<ute.common.security.IState>toState)} fromState=${fromState.name} \
                            // isUserSigned=${this.userService.isSigned()} referer=${this.$location.search()[this.config.referer]} \
                            // toParams=`, toParams, ` toState.abstract=${toState.abstract} fromState.abstract=${fromState.abstract}`
                            //           );
                            // console.log('aaaaaaaaaa', !this.userService.isSigned(), !this.checkAndSaveReferer(), this.securityService.isStateProtected(<ute.common.security.IState>toState),
                            //     toState.name, _.get(this, 'savedState.name'));
                            //https://localhost.rogers.com:3000/web/totes/#/signin?lithium_forum=true&referer=http%253A%252F%252Fcommunityforums.rogers.com%252Ft5%252Fcommunity%252Fcategorypage%252Fcategory-id%252FEnglishCommunity%253Fprofile.language%253Den%2526lang%253Den
                            if (toState.name !== _.get(_this.savedState, 'name')) {
                                // console.log('00000000000000000', !this.userService.isSigned(), !this.checkAndSaveReferer(), this.securityService.isStateProtected(<ute.common.security.IState>toState));
                                if (!_this.userService.isSigned() && !_this.checkAndSaveReferer() && _this.securityService.isStateProtected(toState)) {
                                    event.preventDefault();
                                    return !_this.navigateToSignin(toState, toParams);
                                }
                                else if (_this.isDeepLinkable() && fromState.name && fromState.name !== _.get(_this.savedState, 'name') && !_.includes([_this.config.signinState, _this.config.signoutState], toState.name) && _this.userService.isSigned()) {
                                    // console.log('2222222222222222222', fromState.name, toState.name, this.config.signinState, this.isDeepLinkable(this.savedState), this.savedState);
                                    event.preventDefault();
                                    _this.transitToSavedState();
                                    return false;
                                }
                                else if (toState.name === _this.config.signinState && _this.userService.isSigned() && _this.isExternal(_this.$location.search()[_this.config.referer])) {
                                    // console.log('33333333333333333333333333');
                                    event.preventDefault();
                                    _this.$window.location.href = decodeURIComponent(_this.$location.search()[_this.config.referer]);
                                    return false;
                                }
                            }
                            return true;
                        };
                        this.getDeeplinkState = function () {
                            return _this.savedState;
                        };
                        /**
                         * If url is specified, navigate to it after signin, if not provided navigate to the current url
                         * @param url
                         */
                        this.signinAndNavigate = function (url) {
                            return _this.navigateToSignin(undefined, undefined, url);
                        };
                        /**
                         * Check if current windows.location has a 'referer' key, if yes save it for future use
                         * @returns {boolean} if current windows.location has a 'referer' key
                         */
                        this.checkAndSaveReferer = function () {
                            //console.log('DeeplinkService->checkAndSaveReferer: $state.current.name=', this.$state.current.name);
                            var referer = _this.$location.search()[_this.config.referer];
                            if (referer) {
                                return _this.saveDeeplinkState({ name: decodeURIComponent(referer) });
                            }
                            return false;
                        };
                        /**
                         * save valid provided routing state in memory and in persistent storage
                         * @param toState
                         * @returns {boolean} return true if state has been saved
                         */
                        this.saveDeeplinkState = function (toState) {
                            if (_this.isStateValid(toState.name) && (_this.isExternal(toState.name) || _this.securityService.isStateProtected(_this.$state.get(toState.name)))) {
                                // console.log('saveDeeplinkState:', toState);
                                _this.savedState = toState;
                                _this.storageService.put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_STATE, toState);
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        //private signinSuccessfulHandler: (event: ng.IAngularEvent, ...args: any[]) => void = (event: ng.IAngularEvent, ...args: any[]) => {
                        //  console.log('DeeplinkService got a message', event);
                        //  if (this.transitToSavedState()) {
                        //    event.preventDefault();
                        //  }
                        //};
                        this.isStateValid = function (name) {
                            return _this.isExternal(name) || !!_this.$state.get(name);
                        };
                        this.isExternal = function (name) {
                            //console.log('isExternal:', 'name=', name);
                            return name && name.toLowerCase().indexOf('http') === 0;
                        };
                        this.isDeepLinkable = function () {
                            return !!_this.savedState;
                        };
                        this.transitToSavedState = function () {
                            var savedState = _this.savedState;
                            _this.savedState = undefined;
                            // console.log('transitToSavedState:', savedState);
                            _this.storageService.remove(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_STATE);
                            _this.storageService.remove('toStateName'); // TODO
                            if (_this.isExternal(savedState.name)) {
                                // this.savedState = undefined;
                                _this.$window.location.href = savedState.name;
                            }
                            else {
                                // this.$timeout(() => {
                                // console.log('transitToSavedState->$state.go->before', savedState.name, savedState.params, this.$state.current);
                                _this.$state.go(savedState.name, savedState.params /*, {notify: false}*/).then(function (data) {
                                    // console.log('transitToSavedState->$state.go->then', data);
                                }).catch(function (error) {
                                    // console.log('transitToSavedState->$state.go->catch1', error);
                                    // myRogers cancel me because has it own deeplink
                                    _this.$state.go(savedState.name, savedState.params).catch(function (error) {
                                        // console.log('transitToSavedState->$state.go->catch2', error);
                                    });
                                }) /*.finally(() => {
                                 this.savedState = undefined;
                                 //console.log('transitToSavedState->$state.go->finally');
                                 })*/;
                            }
                        };
                        this.$get.$inject = [
                            '$state',
                            '$injector',
                            '$location',
                            '$window',
                            '$timeout'
                        ];
                    }
                    DeeplinkProvider.$inject = [];
                    return DeeplinkProvider;
                }());
                angular.module('ute.rogers.deeplink').provider('ute.rogers.deeplink.service', DeeplinkProvider);
            })(service = deeplink.service || (deeplink.service = {}));
        })(deeplink = rogers.deeplink || (rogers.deeplink = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            var DtmServiceProvider = (function () {
                /* @ngInject */
                function DtmServiceProvider() {
                    var _this = this;
                    this.config = {
                        basic: {
                            project: 'myrogers',
                            category: 'actv',
                            isDebug: true
                        }
                    };
                    /* @ngInject */
                    this.$get = ["$injector", "$timeout", "$window", function ($injector, $timeout, $window) {
                        _this.$injector = $injector;
                        /*The _satellite argument is coming from application so this is an requirement meanwhile to have this dependency on a calling application */
                        _this.$dtm = $window._satellite;
                        _this.$timeout = $timeout;
                        return {
                            getConfig: _this.getConfig,
                            getVar: _this.getVar,
                            setVar: _this.setVar,
                            start: _this.start,
                            complete: _this.complete,
                            exception: _this.exception,
                            direct: _this.direct,
                            exceptionFormField: _this.exceptionFormField,
                            noAction: _this.noAction,
                            track: _this.track
                        };
                    }];
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        if (_.isEmpty(_this.config.basic.project)) {
                            console.error('project:', 'Config Provider should override project with valid Project name');
                            return false;
                        }
                        if (_.isEmpty(_this.config.basic.category)) {
                            console.error('category:', 'Config Provider should override category with valid Category name');
                            return false;
                        }
                        return true;
                    };
                    /**
                     * @returns {IDtmServiceConfig}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    /**
                     * @function
                     * @description Alias to _satellite.getVar()
                     * @param {String} key - Key to get
                     * @return {String} Value of Key
                     * @memberof Factories.dtmService
                     */
                    this.getVar = function (key) {
                        return _this.$dtm.getVar(key);
                    };
                    /**
                     * @function
                     * @description Alias to _satellite.setVar()
                     * @param {String} key - Key to set to
                     * @param {String} value - Value to set
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.setVar = function (key, value) {
                        _this.$dtm.setVar(key, value);
                    };
                    /**
                     * @function
                     * @description Track a "start" action
                     * @param {String} transaction - Transaction name to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.start = function (transaction, cat) {
                        _this.track(transaction, cat || _this.config.basic.category, service.DtmServiceAction.START);
                    };
                    /**
                     * @function
                     * @description Track a "complete" action
                     * @param {String} transaction - Transaction name to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.complete = function (transaction, cat) {
                        _this.track(transaction, cat || _this.config.basic.category, service.DtmServiceAction.COMPLETE);
                    };
                    /**
                     * @function
                     * @description Track an "error" action
                     * @param {String} transaction - Transaction name to use
                     * @param {String} message - Error message to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.exception = function (transaction, message, cat) {
                        if (_.isEmpty(message) && _this.config.basic.isDebug) {
                            console.log(message);
                        }
                        _this.setVar(service.DtmServiceAction.EXCEPTION, message);
                        _this.track(transaction, cat || _this.config.basic.category, service.DtmServiceAction.EXCEPTION);
                    };
                    /**
                     * @function
                     * @description Track an action
                     * @param {String} method - Method name to use
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.direct = function (method) {
                        _this.$dtm.track(method);
                        if (_this.config.basic.isDebug) {
                            console.log(method);
                        }
                        return _this;
                    };
                    /**
                     * @function
                     * @description Track a Form Field Validation "error" action
                     * @param {String} transaction - Transaction name to use
                     * @param {Object} $element - jQuery $element to get the message form
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.exceptionFormField = function (transaction, element, cat) {
                        _this.$timeout(function () {
                            var message = element.parent().text().trim();
                            this.exception(transaction, message, cat || this.config.basic.category);
                        }, 500);
                        return _this;
                    };
                    /**
                     * @function
                     * @description Track a "no action"
                     * @param {String} transaction - Transaction name to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.noAction = function (transaction, cat) {
                        _this.track(transaction, cat || _this.config.basic.category, null);
                    };
                    /**
                     * @function
                     * @description Track an action
                     * @param {String} transaction - Transaction name to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @param {String} action - Action name to use
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.track = function (transaction, cat, action) {
                        var value = [
                            cat || _this.config.basic.category,
                            _this.config.basic.project,
                            transaction
                        ];
                        if (angular.isDefined(action)) {
                            value.push(action);
                        }
                        var stringValue = value.map(function (o) { return o.valueOf(); }).join('-');
                        if (_this.config.basic.isDebug) {
                            console.log(stringValue);
                        }
                        _this.$dtm.track(stringValue);
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$timeout',
                        '$window'
                    ];
                }
                DtmServiceProvider.$inject = [];
                return DtmServiceProvider;
            }());
            angular.module('ute.dtm.service').provider('ute.dtm.service', DtmServiceProvider);
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                // TODO where it used?
                var locales = {
                    'locales': {
                        'fr_CA': 'Français',
                        'en_CA': 'English'
                    },
                    'preferredLocale': 'en_CA'
                };
                angular.module('ute.blocks.language.switcher').config(configure).constant('LOCALES', locales);
                configure.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];
                /* @ngInject */
                function configure($translateProvider, tmhDynamicLocaleProvider) {
                    // TODO 'en' move to config
                    $translateProvider
                        .preferredLanguage('en')
                        .useStorage('ute.blocks.language.switcher.customLocaleStorage')
                        .useSanitizeValueStrategy(null);
                    tmhDynamicLocaleProvider.localeLocationPattern('scripts/angular-i18n/angular-locale_{{locale}}.js');
                }
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var CustomLocaleStorage = (function () {
                    /* @ngInject */
                    function CustomLocaleStorage($cookies) {
                        var _this = this;
                        this.$cookies = $cookies;
                        // TODO provider and configure
                        this.path = '/';
                        this.domain = '.rogers.com';
                        this.LANG_KEY = 'NG_TRANSLATE_LANG_KEY';
                        this.put = function (name, value) {
                            //console.log('CustomLocaleStorage->put: name=', name, ' value=', value);
                            if (name === _this.LANG_KEY) {
                                _this.$cookies.put(ute.common.core.RogersCookies.LANGUAGE, value, { path: _this.path, domain: _this.domain });
                                _this.$cookies.put(ute.common.core.RogersCookies.LANGUAGE, value, { path: _this.path }); // to support ute.ui
                            }
                        };
                        this.get = function (name) {
                            //console.log('CustomLocaleStorage->get: name=', name);
                            if (name === _this.LANG_KEY) {
                                return _this.getCurrentLanguage();
                            }
                        };
                        this.getCurrentLanguage = function () {
                            // TODO use default lang from angular-translate
                            return _this.$cookies.get(ute.common.core.RogersCookies.LANGUAGE) || 'en';
                        };
                    }
                    CustomLocaleStorage.$inject = [angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies'];
                    return CustomLocaleStorage;
                }());
                angular.module('ute.blocks.language.switcher').service('ute.blocks.language.switcher.customLocaleStorage', CustomLocaleStorage);
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var LanguageSwitchController = (function () {
                    /* @ngInject */
                    function LanguageSwitchController($translate, tmhDynamicLocale, languageSwitcher) {
                        var _this = this;
                        this.$translate = $translate;
                        this.tmhDynamicLocale = tmhDynamicLocale;
                        this.languageSwitcher = languageSwitcher;
                        this.changeLanguage = function () {
                            if (angular.isDefined($)) {
                                $('html').attr('lang', _this.$translate.instant('ute.blocks.language.switcher.to'));
                            }
                            return _this.languageSwitcher.changeLanguage(_this.$translate.instant('ute.blocks.language.switcher.to'));
                        };
                    }
                    LanguageSwitchController.$inject = ['$translate', 'tmhDynamicLocale', 'ute.blocks.language.switcher'];
                    return LanguageSwitchController;
                }());
                switcher.LanguageSwitchController = LanguageSwitchController;
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var LanguageSwitch = (function () {
                    function LanguageSwitch() {
                        this.bindToController = true;
                        //controller: string = 'ute.common.core.LanguageSwitchController';
                        this.controller = switcher.LanguageSwitchController;
                        this.controllerAs = 'languageSwitch';
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = 'module/language.switcher/languageSwitch.html';
                    }
                    //constructor(private $translate: ng.translate.ITranslateService) {
                    //}
                    LanguageSwitch.factory = function () {
                        var directive = function () { return new LanguageSwitch(); };
                        //directive.$inject = ['$translate'];
                        return directive;
                    };
                    return LanguageSwitch;
                }());
                angular.module('ute.blocks.language.switcher').directive('uteLanguageSwitch', LanguageSwitch.factory());
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var SubPubGeneric = ute.common.core.subpub.SubPubGeneric;
                var LanguageSwitcher = (function (_super) {
                    __extends(LanguageSwitcher, _super);
                    /* @ngInject */
                    function LanguageSwitcher($translate, tmhDynamicLocale, localeStorage, routerHelper, $location) {
                        var _this = this;
                        _super.call(this, 'LanguageSwitcher');
                        this.$translate = $translate;
                        this.tmhDynamicLocale = tmhDynamicLocale;
                        this.$location = $location;
                        this.lang2locale = {
                            fr: 'fr-ca',
                            en: 'en-ca'
                        };
                        this.getCurrentLanguage = function () { return _this.currentLanguage; };
                        /**
                         * @param switchToLang
                         * @returns {boolean}
                         */
                        this.changeLanguage = function (switchToLang) {
                            if (!_.include(LanguageSwitcher.supportedLanguages, switchToLang)) {
                                return false;
                            }
                            var search = _this.$location.search();
                            if (_.has(search, 'lang')) {
                                _this.$location.search(_.assign(search, { lang: switchToLang }));
                            }
                            _this.currentLanguage = switchToLang;
                            // console.log('changeLanguage: switchToLang=' + switchToLang,
                            //     'tmhDynamicLocale.get()=', this.tmhDynamicLocale.get(),
                            //     'currentLanguage=', this.currentLanguage);
                            _this.$translate.use(switchToLang);
                            _this.tmhDynamicLocale.set(_this.lang2locale[switchToLang]);
                            _this.notifySubs();
                            return true;
                        };
                        this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                            var search = _this.$location.search();
                            if (_.has(search, 'lang')) {
                                _this.changeLanguage(search.lang);
                            }
                            return true;
                        };
                        this.currentLanguage = localeStorage.getCurrentLanguage();
                        LanguageSwitcher.supportedLanguages.forEach(function (lang) { return _this.tmhDynamicLocale.set(_this.lang2locale[lang]); });
                        this.tmhDynamicLocale.set(this.lang2locale[this.currentLanguage]);
                        routerHelper.registerGlobalFromStateHandler(this, ute.blocks.router.StateHandlerPriority.HIGH);
                    }
                    LanguageSwitcher.prototype.getChangableData = function () {
                        return this.currentLanguage;
                    };
                    LanguageSwitcher.$inject = [
                        '$translate',
                        'tmhDynamicLocale',
                        'ute.blocks.language.switcher.customLocaleStorage',
                        'ute.blocks.router',
                        '$location'];
                    LanguageSwitcher.supportedLanguages = ['en', 'fr'];
                    return LanguageSwitcher;
                }(SubPubGeneric));
                angular.module('ute.blocks.language.switcher').service('ute.blocks.language.switcher', LanguageSwitcher);
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
            angular.module('ute.common.encryption').config(configure).run(addStateHandler);
            configure.$inject = ['$cryptoProvider'];
            /* @ngInject */
            function configure($cryptoProvider) {
                $cryptoProvider.setCryptographyKey('ABCD123');
            }
            addStateHandler.$inject = ['ute.blocks.router', 'ute.common.encryption.service'];
            /* @ngInject */
            function addStateHandler(routerHelper, encryptionService) {
                routerHelper.registerGlobalToStateHandler(encryptionService);
            }
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
            // !!!! Do not remove or rename existing members only add new at the end
            var Params;
            (function (Params) {
                Params[Params["phoneNumber"] = 1] = "phoneNumber";
                Params[Params["accountNumber"] = 2] = "accountNumber";
                Params[Params["currentSimCardNumber"] = 3] = "currentSimCardNumber";
                Params[Params["newSimCardNumber"] = 4] = "newSimCardNumber";
                Params[Params["accountEmail"] = 5] = "accountEmail";
                Params[Params["deviceNameEn"] = 6] = "deviceNameEn";
                Params[Params["deviceNameFr"] = 7] = "deviceNameFr";
                Params[Params["firstName"] = 8] = "firstName";
                Params[Params["email"] = 9] = "email";
            })(Params || (Params = {}));
            var EncryptionService = (function () {
                /* @ngInject */
                function EncryptionService(logger, $crypto, userService, utilsService, $state) {
                    var _this = this;
                    this.logger = logger;
                    this.$crypto = $crypto;
                    this.userService = userService;
                    this.utilsService = utilsService;
                    this.$state = $state;
                    this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                        var params = _.intersection(_.keys(toParams), _.get(toState, 'data.encryption.params'));
                        if (params) {
                            params.forEach(function (param) {
                                _this.decrypt(toParams[param]).then(function () {
                                    //
                                }).catch(function (error) {
                                    event.preventDefault();
                                    _this.$state.go(_.get(toState, 'data.encryption.failbackState'));
                                });
                            });
                        }
                        else {
                            event.preventDefault();
                            _this.$state.go(_.get(toState, 'data.encryption.failbackState'));
                        }
                        return true;
                    };
                    this._encrypt = function (obj) {
                        return _this.userService.getEncryptionKey().then(_.curry(_this.encryptWithKey)(obj));
                    };
                    /**
                     * @param obj
                     * @returns {string}
                     */
                    this.resolver = function (obj) {
                        if (_this.userService.getUser()) {
                            var userName = _this.userService.getUser().userName;
                            var objStr = _.isString(obj) ? obj : angular.toJson(obj);
                            //console.log('EncryptionService->resolver:', objStr + userName);
                            return objStr + userName;
                        }
                        else {
                            _this.utilsService.randomString();
                        }
                    };
                    /**
                     * @param obj
                     * @param key
                     * @returns {ng.IPromise<string>|*|any}
                     */
                    this.encryptWithKey = function (obj, key) {
                        //console.log('EncryptionService->encrypt:', key);
                        //console.log('EncryptionService->encrypt:', key, obj, (_.reduce<{}, _.Dictionary<{}>>(
                        //    obj,
                        //    (result: _.Dictionary<{}>, value: {}, key: string): _.Dictionary<{}> => {
                        //      result[_.find([Params[key], key], angular.isDefined)] = value;
                        //      return result;
                        //    }, {})));
                        return _this.$crypto.encrypt(angular.toJson(_.reduce(obj, function (result, value, key) {
                            result[_.find([Params[key], key], angular.isDefined)] = value;
                            return result;
                        }, {})), key);
                    };
                    /**
                     * @param str
                     * @returns {any}
                     * @private
                     */
                    this._decrypt = function (str) {
                        return _this.userService.getEncryptionKey().then(_.curry(_this.decryptWithKey)(str));
                    };
                    /**
                     * @param str
                     * @param key
                     * @returns {any}
                     */
                    this.decryptWithKey = function (str, key) {
                        try {
                            //console.log('EncryptionService->decrypt:', str, key, angular.fromJson(this.$crypto.decrypt(str, key)));
                            return _.reduce(angular.fromJson(_this.$crypto.decrypt(str, key)), function (result, value, key) {
                                result[_.find([Params[key], key], angular.isDefined)] = value;
                                return result;
                            }, {});
                        }
                        catch (e) {
                            throw new Error('EncryptionService->decryptWithKey error: ' + e.toString());
                        }
                    };
                    this.encrypt = _.memoize(this._encrypt, this.resolver);
                    this.decrypt = _.memoize(this._decrypt, this.resolver);
                }
                EncryptionService.$inject = [
                    'ute.blocks.loggerService',
                    '$crypto',
                    'ute.common.user.service',
                    'ute.common.utils.service',
                    '$state'
                ];
                return EncryptionService;
            }());
            angular.module('ute.common.encryption').service('ute.common.encryption.service', EncryptionService);
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var fraud;
    (function (fraud) {
        var logging;
        (function (logging) {
            'use strict';
            var TransactionProp = {
                requestUrl: {
                    rogers: '/web/totes/api/v1/captureTransactionInfo',
                    fido: '/bfa-api/v1/captureTransactionInfo',
                    bss: '/web/smb/api/v1/captureTransactionInfo'
                },
                sourceChannel: {
                    rogers: 'UTE-ROGERS-ONLINE',
                    fido: 'UTE-FIDO-ONLINE',
                    bss: 'UTE-ROGERS-BSS',
                    oneview: 'ONEVIEW-CARE'
                },
                transactionType: {
                    login: 'Login',
                    createProfile: 'Create Profile',
                    accountOverview: 'Account Overview',
                    profile: 'Profile',
                    billing: 'Billing'
                },
                action: {
                    login: 'login',
                    createProfile: 'create profile',
                    accountSelection: 'account selection',
                    setRecoveryNumber: 'set recovery number',
                    changeRecoveryNumber: 'change recovery number',
                    forgotUsername: 'forgot username',
                    forgotPassword: 'forgot password',
                    viewBill: 'view bill',
                    changePassword: 'change password'
                },
                userType: {
                    consumer: 'Customer',
                    employee: 'Employee'
                },
                transactionStatus: {
                    success: 'Success',
                    failure: 'Failure'
                },
                franchise: {
                    rogers: 'Rogers',
                    fido: 'Fido'
                }
            };
            angular.module('ute.fraud.logging').constant('ute.fraud.logging.TransactionProp', TransactionProp);
        })(logging = fraud.logging || (fraud.logging = {}));
    })(fraud = ute.fraud || (ute.fraud = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var fraud;
    (function (fraud) {
        var logging;
        (function (logging) {
            'use strict';
            /**
             * @description Class for capturing transaction info
             * @class FraudLoggingService
             * @implements {IFraudLoggingService}
             */
            var FraudLoggingService = (function () {
                function FraudLoggingService($http, $q, transactionProp) {
                    this.$http = $http;
                    this.$q = $q;
                    this.transactionProp = transactionProp;
                    this.useMockData = false;
                }
                /**
                 * @description Function to call v1/captureTransactionInfo POST API
                 * @param payload
                 * @return HTTP promise
                 */
                FraudLoggingService.prototype.captureTransaction = function (payload) {
                    var deferred = this.$q.defer();
                    var captureTransactionRequest = '';
                    if (payload.sourceChannel === this.transactionProp.sourceChannel.rogers) {
                        captureTransactionRequest = this.transactionProp.requestUrl.rogers;
                    }
                    else if (payload.sourceChannel === this.transactionProp.sourceChannel.fido) {
                        captureTransactionRequest = this.transactionProp.requestUrl.fido;
                    }
                    else if (payload.sourceChannel === this.transactionProp.sourceChannel.bss) {
                        captureTransactionRequest = this.transactionProp.requestUrl.bss;
                    }
                    if (this.useMockData) {
                        this.$http.get('ute-fraud-logging/assets/mocks/captureTransactionInfo-auth-failure.json')
                            .then(function (resp) { return deferred.resolve(resp); }, function (err) { return deferred.reject(err); });
                    }
                    else {
                        this.$http.post(captureTransactionRequest, payload)
                            .then(function (resp) { return deferred.resolve(resp); }, function (err) { return deferred.reject(err); });
                    }
                    return deferred.promise;
                };
                FraudLoggingService.$inject = ['$http', '$q', 'ute.fraud.logging.TransactionProp'];
                return FraudLoggingService;
            }());
            angular.module('ute.fraud.logging').service('ute.fraud.logging.service', FraudLoggingService);
        })(logging = fraud.logging || (fraud.logging = {}));
    })(fraud = ute.fraud || (ute.fraud = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var messages;
        (function (messages) {
            var bus;
            (function (bus) {
                'use strict';
                var Messages = (function () {
                    function Messages() {
                    }
                    Messages.uteRogersInterceptorsAuthSigninRequired = 'ute.rogers.interceptors.auth.signin.required';
                    Messages.uteRogersInterceptorsAuthSignoutRequired = 'ute.rogers.interceptors.auth.signout.required';
                    Messages.uteUserResourceAccessPermissionDenied = 'ute.user.resource.access.permission.denied';
                    Messages.uteUserUnauthorized = 'ute.user.unauthorized';
                    Messages.uteRogersSigninSuccessful = 'ute.rogers.signin.successful';
                    Messages.uteRogersSignoutSuccessful = 'ute.rogers.signout.successful';
                    Messages.uteRogersAccountChanged = 'ute.rogers.account.has.been.changed';
                    return Messages;
                }());
                bus.Messages = Messages;
                var MessagesService = (function () {
                    /* @ngInject */
                    function MessagesService(logger, $rootScope) {
                        var _this = this;
                        this.logger = logger;
                        this.$rootScope = $rootScope;
                        /**
                         * Simple wrap
                         * @param event
                         * @param data
                         * @return IAngularEvent
                         */
                        this.publish = function (event, data) {
                            return _this.$rootScope.$broadcast(event, data);
                        };
                        this.register = function (name, listener) {
                            return _this.$rootScope.$on(name, listener);
                        };
                        this.subscribe = this.register;
                    }
                    MessagesService.$inject = ['ute.blocks.loggerService', '$rootScope'];
                    return MessagesService;
                }());
                angular.module('ute.blocks.messages.bus').service('ute.blocks.messages.bus.service', MessagesService);
            })(bus = messages.bus || (messages.bus = {}));
        })(messages = blocks.messages || (blocks.messages = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var permissions;
        (function (permissions) {
            var service;
            (function (service) {
                'use strict';
                var PermissionsProvider = (function () {
                    /* @ngInject */
                    function PermissionsProvider() {
                        var _this = this;
                        // private isProtectedCall: boolean;
                        //private logger: ute.blocks.logger.ILogger;
                        this.config = {
                            partialApiUrl: 'v1/permissions',
                            ramPartialApiUrl: 'v1/ram/permissions/all'
                        };
                        /* @ngInject */
                        this.$get = ["$injector", "$http", function ($injector, $http) {
                            _this.exceptionHandler = $injector.get('ute.blocks.exceptionService');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.securityService = $injector.get('ute.common.security.service');
                            //this.logger = $injector.get('ute.blocks.loggerService');
                            _this.$http = $http;
                            _this.getUserPermissions = _.memoize(_this._getUserPermissions, _this.getCacheName);
                            /**
                             * @param getRamPermissions
                             */
                            _this.getRamPermissions = _.memoize(_this._getRamPermissions, _this.getRamCacheName);
                            _this.userService.registerSigninHandler(_this.cleanCache, _this);
                            return {
                                getUserPermission: _this.getUserPermission,
                                getUserPermissions: _this.getUserPermissions,
                                getRamPermission: _this.getRamPermission
                            };
                        }];
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.getCacheName = function () {
                            return 'PermissionsCacheName';
                        };
                        /**
                         * @return RamPermissions CacheName
                         */
                        this.getRamCacheName = function () {
                            return 'RamPermissionsCacheName';
                        };
                        this.cleanCache = function () {
                            //console.log('ute.user.service.UserService.cleanCache: cache=', (<any>this.getEncryptionKey).cache);
                            //console.log('ute.permission.service.cleanRamCache: cache=', (<any>this.getRamPermissions).cache);
                            _this.getUserPermissions.cache.delete(_this.getCacheName());
                            _this.getRamPermissions.cache.delete(_this.getRamCacheName());
                        };
                        /**
                         * @param key
                         * @returns {IPromise<boolean>}
                         */
                        this.getUserPermission = function (key) {
                            return _this.getUserPermissions().then(function (val) {
                                //console.log('PermissionsProvider->getUserPermission', key, !!_.find<IPermissionEntry, IPermissionEntry>(val.permissions, <IPermissionEntry>{permission: _.isNumber(key) ? UserPermissions[key] : key}));
                                return !!_.find(val.permissions, { permission: _.isNumber(key) ? service.UserPermissions[key] : key });
                            });
                        };
                        /**
                         * @param ramCode ramAction
                         * @returns {IPromise<boolean>}
                         */
                        this.getRamPermission = function (ramCode, ramAction) {
                            return _this.getRamPermissions().then(function (val) {
                                //console.log('ramPermissions', _.find<IRamPermissionEntry, IRamPermissionEntry>(val.content, <IRamPermissionEntry>{resourceCode: _.isNumber(ramCode) ? RamResourceCodes[ramCode] : ramCode ,actionCode: _.isNumber(ramAction) ? RamActionCodes[ramAction] : ramAction}));
                                return !!_.find(val.content, {
                                    resourceCode: _.isNumber(ramCode) ? service.RamResourceCodes[ramCode] : ramCode,
                                    actionCode: _.isNumber(ramAction) ? service.RamActionCodes[ramAction] : ramAction
                                });
                            });
                        };
                        /**
                         * @returns {IPromise<IPermissions>}
                         * @private
                         */
                        this._getUserPermissions = function () {
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.config.partialApiUrl), {})
                                .then(_this.processUserPermissionsResponse)
                                .catch(_.curry(_this.fail)('processUserPermissionsResponse failed.'));
                        };
                        /**
                         * @getRamPermissions
                         * @returns {IPromise<IRamPermissions>}
                         * @private
                         */
                        this._getRamPermissions = function () {
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.config.ramPartialApiUrl), {})
                                .then(_this.processRamPermissionsResponse)
                                .catch(_.curry(_this.ramFail)('processRamPermissionsResponse failed.'));
                        };
                        /**
                         * @param response
                         * @returns {IPermissions}
                         */
                        this.processUserPermissionsResponse = function (response) {
                            //console.log('BrtSwitchService->processBrtSwitchesResponse', response.data);
                            return _.get(response, 'data', { permissions: [] });
                        };
                        /**
                         * @param response
                         * @returns {IRamPermissions}
                         */
                        this.processRamPermissionsResponse = function (response) {
                            //console.log('RamPermissions->ramPermissionsReponse', response.data);
                            return _.get(response, 'data', { content: [] });
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {IPermissions}
                         */
                        this.fail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            _this.exceptionHandler.catcher(msg)(reason, 'ute.common.permissions.service fail');
                            return { permissions: [] };
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {IRamPermissions}
                         */
                        this.ramFail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            _this.exceptionHandler.catcher(msg)(reason, 'ute.common.permissions.service ramFail');
                            return { content: [] };
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http'
                        ];
                    }
                    PermissionsProvider.$inject = [];
                    return PermissionsProvider;
                }());
                angular.module('ute.common.permissions').provider('ute.common.permissions.service', PermissionsProvider);
            })(service = permissions.service || (permissions.service = {}));
        })(permissions = common.permissions || (common.permissions = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                angular.module('ute.blocks.persistent.storage').config(configure);
                configure.$inject = ['$sessionStorageProvider', '$localStorageProvider'];
                /* @ngInject */
                function configure($sessionStorageProvider, $localStorageProvider) {
                    $sessionStorageProvider.setKeyPrefix('');
                    $localStorageProvider.setKeyPrefix('');
                    $sessionStorageProvider.setDeserializer(function (value) {
                        try {
                            return angular.fromJson(value);
                        }
                        catch (e) {
                            return value;
                        }
                    });
                    $localStorageProvider.setDeserializer(function (value) {
                        try {
                            return angular.fromJson(value);
                        }
                        catch (e) {
                            return value;
                        }
                    });
                }
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                var RogersStoreService = (function () {
                    /* @ngInject */
                    function RogersStoreService($window) {
                        var _this = this;
                        this.$window = $window;
                        this.put = function (key, value) {
                            _this.$window.sessionStorage.setItem(key, angular.isObject(value) || angular.isArray(value) ? angular.toJson(value) : value);
                            return true;
                        };
                        this.get = function (key) {
                            var value = _this.$window.sessionStorage.getItem(key);
                            try {
                                return angular.fromJson(value);
                            }
                            catch (e) {
                                return value;
                            }
                        };
                        this.remove = function (key) {
                            _this.$window.sessionStorage.removeItem(key);
                            return true;
                        };
                        this.putToLocal = function (key, value) {
                            _this.$window.localStorage.setItem(key, angular.isObject(value) || angular.isArray(value) ? angular.toJson(value) : value);
                            return true;
                        };
                        this.getFromLocal = function (key) {
                            var value = _this.$window.localStorage.getItem(key);
                            try {
                                return angular.fromJson(value);
                            }
                            catch (e) {
                                return value;
                            }
                        };
                        this.removeFromLocal = function (key) {
                            _this.$window.localStorage.removeItem(key);
                            return true;
                        };
                        this.getLocalStoreService = function () { return ({
                            put: _this.putToLocal,
                            get: _this.getFromLocal,
                            remove: _this.removeFromLocal
                        }); };
                        this.getSessionStoreService = function () { return ({
                            put: _this.putToSession,
                            get: _this.getFromSession,
                            remove: _this.removeFromSession
                        }); };
                        this.putToSession = this.put;
                        this.getFromSession = this.get;
                        this.removeFromSession = this.remove;
                    }
                    RogersStoreService.$inject = ['$window'];
                    return RogersStoreService;
                }());
                angular.module('ute.blocks.persistent.storage').service('ute.blocks.persistent.storage.service', RogersStoreService);
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                angular.module('ute.common.reactivate.ctn').run(reactivateCtnRoutesConfig);
                reactivateCtnRoutesConfig.$inject = ['ute.blocks.router', 'ute.common.reactivate.ctn.service'];
                /* @ngInject */
                function reactivateCtnRoutesConfig(routerHelper, reactivateCtnService) {
                    routerHelper.configureStates(getStates(reactivateCtnService));
                }
                function getStates(reactivateCtnService) {
                    var reactivateCtnRootState = reactivateCtnService.getConfig().basic.reactivateCtnRootState;
                    return [
                        {
                            name: reactivateCtnRootState,
                            abstract: true,
                            url: '/' + reactivateCtnRootState,
                            controller: reactivateCtnService.getConfig().basic.mainControllerName,
                            templateUrl: reactivateCtnService.getConfig().basic.mainTemplateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] }
                            },
                            resolve: reactivateCtnService.getConfig().advanced.resolve
                        },
                        {
                            name: reactivateCtnRootState + '.' + reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.subState,
                            url: '/' + reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.subState + '/:id',
                            controller: reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.controllerName,
                            controllerAs: 'successSuspendDevice',
                            templateUrl: reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] }
                            }
                        }
                    ];
                }
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    var ReactivateCtnController = (function () {
                        /* @ngInject */
                        function ReactivateCtnController($document, reactivateCtnService) {
                            this.$document = $document;
                            this.reactivateCtnService = reactivateCtnService;
                            reactivateCtnService.restoreState();
                            $document.scrollTop(0);
                        }
                        ReactivateCtnController.$inject = ['$document', 'ute.common.reactivate.ctn.service'];
                        return ReactivateCtnController;
                    }());
                    service.ReactivateCtnController = ReactivateCtnController;
                    angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.main.controller', ReactivateCtnController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                var ResetVoicemailPasswordController = (function () {
                    /* @ngInject */
                    function ResetVoicemailPasswordController($modal, resetVoicemailPasswordService, userService) {
                        this.$modal = $modal;
                        this.resetVoicemailPasswordService = resetVoicemailPasswordService;
                        this.userService = userService;
                        this.model = this.resetVoicemailPasswordService.getModel();
                        this.moduleConfig = this.resetVoicemailPasswordService.getConfig();
                        this.userType = this.userService.getUserType();
                    }
                    /**
                     * @param simCardForm
                     * @returns {boolean}
                     */
                    ResetVoicemailPasswordController.isFormValid = function (simCardForm) {
                        simCardForm.$submitted = true;
                        return simCardForm.$valid;
                    };
                    /**
                     * @param simCardForm
                     * @param $event
                     */
                    ResetVoicemailPasswordController.prototype.submit = function (simCardForm, $event) {
                        $event.preventDefault();
                        if (ute.common.voicemail.resetPassword.ResetVoicemailPasswordController.isFormValid(simCardForm)) {
                            this.resetVoicemailPasswordService.setNewVoicemailPassword(this.model.newVoicemailPassword);
                            return this.resetVoicemailPasswordService.cancelResetVoicemailPassword();
                        }
                    };
                    /**
                     * @param $event
                     */
                    ResetVoicemailPasswordController.prototype.cancel = function ($event) {
                        $event.preventDefault();
                        return this.resetVoicemailPasswordService.cancelResetVoicemailPassword();
                    };
                    /**
                     * @param size
                     * @param view
                     */
                    ResetVoicemailPasswordController.prototype.openModalPopup = function (size, view) {
                        var _this = this;
                        // TODO config
                        this.$modal.open({
                            windowTemplateUrl: this.moduleConfig.advanced.voicemailResetPasswordModalDirective.windowTemplateUrl,
                            templateUrl: this.moduleConfig.advanced.voicemailResetPasswordModalDirective.templateUrl,
                            controller: this.moduleConfig.advanced.voicemailResetPasswordModalDirective.controllerName,
                            controllerAs: 'resetPasswordModal',
                            size: size,
                            backdrop: 'static',
                            backdropClass: 'bkg-modal',
                            resolve: {}
                        }).result.then(function (result) {
                            // Result selection behaviour
                            switch (result) {
                                case 'yes':
                                    break;
                                case 'no':
                                    _this.resetVoicemailPasswordService.cancelResetVoicemailPassword();
                                    break;
                            }
                        }).catch(function () {
                            // Dismiss behaviour
                            // Do nothing/close
                        });
                    };
                    ResetVoicemailPasswordController.$inject = ['$modal', 'ute.common.voicemail.resetPassword.service', 'ute.common.user.service'];
                    return ResetVoicemailPasswordController;
                }());
                resetPassword.ResetVoicemailPasswordController = ResetVoicemailPasswordController;
                angular.module('ute.common.voicemail.resetPassword').controller('ute.common.voicemail.resetPassword.directive.controller', ResetVoicemailPasswordController);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                var ResetVoicemailPassword = (function () {
                    /* @ngInject */
                    ResetVoicemailPassword.$inject = ["resetVoicemailPasswordService"];
                    function ResetVoicemailPassword(resetVoicemailPasswordService) {
                        var _this = this;
                        this.resetVoicemailPasswordService = resetVoicemailPasswordService;
                        this.restrict = 'E';
                        this.scope = {
                            accountNumber: '@',
                            ctn: '@'
                        };
                        this.templateUrl = this.resetVoicemailPasswordService.getConfig().advanced.voicemailResetPasswordDirective.templateUrl;
                        this.controller = this.resetVoicemailPasswordService.getConfig().advanced.voicemailResetPasswordDirective.controllerName;
                        this.controllerAs = 'voicemailResetPassword';
                        /**
                         * @param scope
                         */
                        this.linkFn = function (scope) {
                            // Set account number and phone number to the service model
                            _this.resetVoicemailPasswordService.setAccountNumber(scope.accountNumber);
                            _this.resetVoicemailPasswordService.setPhoneNumber(scope.ctn);
                        };
                        this.link = this.linkFn;
                    }
                    /**
                     * @returns {function(ute.common.voicemail.resetPassword.IResetVoicemailPasswordService): ute.common.voicemail.resetPassword.ResetVoicemailPassword}
                     */
                    ResetVoicemailPassword.factory = function () {
                        var directive = function (resetVoicemailPasswordService) { return new ResetVoicemailPassword(resetVoicemailPasswordService); };
                        directive.$inject = ['ute.common.voicemail.resetPassword.service'];
                        return directive;
                    };
                    return ResetVoicemailPassword;
                }());
                angular.module('ute.common.voicemail.resetPassword').directive('uteVoicemailResetPassword', ResetVoicemailPassword.factory());
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                var ResetVoicemailPasswordModalController = (function () {
                    /* @ngInject */
                    function ResetVoicemailPasswordModalController($scope, $modalInstance, resetVoicemailPasswordModalService) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$modalInstance = $modalInstance;
                        this.resetVoicemailPasswordModalService = resetVoicemailPasswordModalService;
                        //public errorMessagePath: string = '';
                        this.updateSuccessful = false;
                        this.isCallInProgress = function () {
                            return _this.resetVoicemailPasswordModalService.isCallInProgress();
                        };
                        this.errorMessagePath = function () {
                            return _this.resetVoicemailPasswordModalService.getErrorMessagePath();
                        };
                        this.showChatOption = function () {
                            return _this.resetVoicemailPasswordModalService.getShowChatOption();
                        };
                    }
                    ResetVoicemailPasswordModalController.prototype.noSelection = function () {
                        this.resetVoicemailPasswordModalService.resetErrorMessage();
                        this.$modalInstance.dismiss('cancel');
                    };
                    /**
                     * This onClick function will prevent ng-touch to do the blur() from onClick(event)
                     * Tried to move this function to directive 'ute-modal-input-focus-on-click',
                     * but it is still not working in mobile view.
                     * The same directive is working on desktop view.
                     * Will check it in the future.
                     */
                    ResetVoicemailPasswordModalController.prototype.inputOnClick = function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        event.target.focus();
                    };
                    ResetVoicemailPasswordModalController.prototype.cancel = function () {
                        this.resetVoicemailPasswordModalService.resetErrorMessage();
                        this.$modalInstance.close('no');
                    };
                    ResetVoicemailPasswordModalController.prototype.submit = function (resetVoicemailPasswordForm) {
                        var _this = this;
                        if (this.resetVoicemailPasswordModalService.formValidation(resetVoicemailPasswordForm)) {
                            this.resetVoicemailPasswordModalService.setFormData(resetVoicemailPasswordForm);
                            this.resetVoicemailPasswordModalService.updateVoicemailPassword()
                                .then(function (result) {
                                // console.log('resetVoicemailPasswordModalService response', result);
                                _this.updateSuccessful = result.result;
                                //this.errorMessagePath = result.errorKey;
                            })
                                .catch(function (error) {
                                // console.log('resetVoicemailPasswordModalService has error');
                                _this.updateSuccessful = error.result;
                                //this.errorMessagePath = error.errorKey;
                            });
                        }
                    };
                    ResetVoicemailPasswordModalController.$inject = ['$scope', '$modalInstance', 'ute.common.voicemail.resetPassword.modal.service'];
                    return ResetVoicemailPasswordModalController;
                }());
                resetPassword.ResetVoicemailPasswordModalController = ResetVoicemailPasswordModalController;
                angular.module('ute.common.voicemail.resetPassword').controller('ute.common.voicemail.resetPassword.modal.controller', ResetVoicemailPasswordModalController);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                var ResetVoicemailPasswordModalService = (function () {
                    /* @ngInject */
                    function ResetVoicemailPasswordModalService($http, resetVoicemailPasswordService, securityService) {
                        var _this = this;
                        this.$http = $http;
                        this.resetVoicemailPasswordService = resetVoicemailPasswordService;
                        this.securityService = securityService;
                        this.callInProgress = false;
                        /**
                         * @param resetVoicemailPasswordForm
                         * @returns {boolean}
                         */
                        this.formValidation = function (resetVoicemailPasswordForm) {
                            // Set default value to the error message
                            _this.errorMessagePath = '';
                            _this.showChatOption = false;
                            // First check both new voicemail password and confirm voicemail password are valid
                            //resetVoicemailPasswordForm.newVoicemailPassword.$invalid
                            if (angular.isUndefined(resetVoicemailPasswordForm.newVoicemailPassword.$viewValue) ||
                                angular.isUndefined(resetVoicemailPasswordForm.confirmVoicemailPassword.$viewValue) ||
                                resetVoicemailPasswordForm.newVoicemailPassword.$viewValue.length <= 0 ||
                                resetVoicemailPasswordForm.confirmVoicemailPassword.$viewValue.length <= 0) {
                                _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.notEnterBothFields';
                                return false;
                            }
                            else if (resetVoicemailPasswordForm.newVoicemailPassword.$invalid ||
                                resetVoicemailPasswordForm.confirmVoicemailPassword.$invalid) {
                                _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.notFourToFiveDigits';
                                return false;
                            }
                            else if (resetVoicemailPasswordForm.newVoicemailPassword.$modelValue !== resetVoicemailPasswordForm.confirmVoicemailPassword.$modelValue) {
                                _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.passwordNotMatch';
                                return false;
                            }
                            return true;
                        };
                        /**
                         * @param resetVoicemailPasswordForm
                         */
                        this.setFormData = function (resetVoicemailPasswordForm) {
                            _this.resetVoicemailPasswordService.setNewVoicemailPassword(resetVoicemailPasswordForm.newVoicemailPassword.$viewValue);
                        };
                        /**
                         * @returns {IPromise<ISubmitResult>}
                         */
                        this.updateVoicemailPassword = function () {
                            var model = _this.resetVoicemailPasswordService.getModel();
                            var request = {
                                applicationId: _this.resetVoicemailPasswordService.getConfig().basic.applicationId,
                                accountNumber: localStorage.getItem('accountNumber'),
                                phoneNumber: localStorage.getItem('phoneNumber'),
                                password: model.newVoicemailPassword,
                                medium: _this.resetVoicemailPasswordService.getConfig().basic.medium
                            };
                            _this.callInProgress = true;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.resetVoicemailPasswordService.getConfig().basic.partialApiUrl), request)
                                .then(_this.processResponseOk)
                                .catch(_this.processResponseError)
                                .finally(_this.processResponseFinal);
                        };
                        this.isCallInProgress = function () {
                            return _this.callInProgress;
                        };
                        this.getErrorMessagePath = function () {
                            return _this.errorMessagePath;
                        };
                        this.getShowChatOption = function () {
                            return _this.showChatOption;
                        };
                        this.resetErrorMessage = function () {
                            _this.errorMessagePath = '';
                            _this.showChatOption = false;
                        };
                        /**
                         * @param response
                         * @returns {boolean}
                         */
                        this.processResponseOk = function (response) {
                            //console.log('response.data', response.data);
                            //response.data = { 'status': { 'code': 0, 'requestId': '484ae78d-2900-455f-a71f-5636f4c6b3fa' }, 'content': { 'status': true } };
                            //response.data = {"status":{"code":15650,"codeName":"FAILED_IN_RESET","requestId":"2dc27924-7119-48b8-b1b4-b4adc3d53760","description":"Failed to reset voicemail password116417199"}};
                            _this.showChatOption = false;
                            if (_.has(response.data, 'content.status') && response.data.content.status === true) {
                                _this.errorMessagePath = '';
                                return { result: true, errorKey: '' };
                            }
                            else {
                                _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.failure';
                                return { result: false, errorKey: 'ute.voicemail.resetPassword.responseMessage.failure' };
                            }
                        };
                        this.processResponseError = function (reason) {
                            //console.log('processResponseError->response', reason);
                            _this.showChatOption = true;
                            _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.failure';
                            return { result: false, errorKey: 'ute.voicemail.resetPassword.responseMessage.failure' };
                        };
                        this.processResponseFinal = function () {
                            _this.callInProgress = false;
                            //console.log('processResponseFinal', this.callInProgress);
                            return true;
                        };
                        this.errorMessagePath = '';
                        this.showChatOption = false;
                    }
                    ResetVoicemailPasswordModalService.$inject = [
                        '$http',
                        'ute.common.voicemail.resetPassword.service',
                        'ute.common.security.service'
                    ];
                    return ResetVoicemailPasswordModalService;
                }());
                angular.module('ute.common.voicemail.resetPassword').service('ute.common.voicemail.resetPassword.modal.service', ResetVoicemailPasswordModalService);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                /**
                 * Private interface
                 */
                var ResetVoicemailPasswordProvider = (function () {
                    /* @ngInject */
                    function ResetVoicemailPasswordProvider() {
                        var _this = this;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                medium: 'WEB',
                                partialApiUrl: 'v1/wirelessDashBoard/resetvoicemailPassword'
                            },
                            advanced: {
                                voicemailResetPasswordDirective: {
                                    templateUrl: 'module/resetVoicemailPasswordDirective/resetVoicemailPassword.directive.view.html',
                                    controllerName: 'ute.common.voicemail.resetPassword.directive.controller'
                                },
                                voicemailResetPasswordModalDirective: {
                                    windowTemplateUrl: 'module/resetVoicemailPasswordDirective/resetVoicemailPasswordWindow.modal.view.html',
                                    templateUrl: 'module/resetVoicemailPasswordDirective/resetVoicemailPassword.modal.view.html',
                                    controllerName: 'ute.common.voicemail.resetPassword.modal.controller'
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function () {
                            return {
                                getConfig: _this.getConfig,
                                getModel: _this.getModel,
                                setAccountNumber: _this.setAccountNumber,
                                getAccountNumber: _this.getAccountNumber,
                                setPhoneNumber: _this.setPhoneNumber,
                                getPhoneNumber: _this.getPhoneNumber,
                                setNewVoicemailPassword: _this.setNewVoicemailPassword,
                                cancelResetVoicemailPassword: _this.cancelResetVoicemailPassword
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            if (_this.config.basic.medium.length === 0) {
                                console.error('medium:', 'Config Provider should override medium with vaid Medium');
                                return false;
                            }
                            return true;
                        };
                        /**
                         * Get Phone number from the model
                         * @returns {number}
                         */
                        this.getPhoneNumber = function () {
                            return _this.model.phoneNumber;
                        };
                        /**
                         * Get Account number from the model
                         * @returns {number}
                         */
                        this.getAccountNumber = function () {
                            return _this.model.accountNumber;
                        };
                        /**
                         * get the config setting
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        /**
                         * Return immutable IResetVoicemailPasswordModel object
                         * @returns {IResetVoicemailPasswordModel}
                         */
                        this.getModel = function () {
                            return angular.copy(_this.model);
                        };
                        /**
                         * @param accountNumber - set account number
                         */
                        this.setAccountNumber = function (accountNumber) {
                            _this.model.accountNumber = accountNumber;
                        };
                        /**
                         * @param ctn - set phone number
                         */
                        this.setPhoneNumber = function (ctn) {
                            _this.model.phoneNumber = ctn;
                        };
                        /**
                         * @param newPassword - New voicemail password
                         */
                        this.setNewVoicemailPassword = function (newPassword) {
                            _this.model.newVoicemailPassword = newPassword;
                        };
                        /**
                         * cancel Sim Card Change Wizard and naviagte to the 'start' state
                         * @returns {angular.IPromise<any>}
                         */
                        this.cancelResetVoicemailPassword = function () {
                            // close modal
                        };
                        /**
                         * Reset model to initial state
                         */
                        this.resetModel = function () {
                            _this.model = {
                                accountNumber: null,
                                phoneNumber: null,
                                newVoicemailPassword: null,
                                confirmVoicemailPassword: null
                            };
                        };
                        this.$get.$inject = [];
                        this.resetModel();
                    }
                    ResetVoicemailPasswordProvider.$inject = [];
                    return ResetVoicemailPasswordProvider;
                }());
                angular.module('ute.common.voicemail.resetPassword').provider('ute.common.voicemail.resetPassword.service', ResetVoicemailPasswordProvider);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var datalayer;
        (function (datalayer) {
            var integration;
            (function (integration) {
                var common;
                (function (common) {
                    var service;
                    (function (service) {
                        'use strict';
                        var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
                        var UteDataLayerIntegrationFormViewEvent = (function () {
                            function UteDataLayerIntegrationFormViewEvent(dataLayerService, $parse, $q) {
                                var _this = this;
                                this.dataLayerService = dataLayerService;
                                this.$parse = $parse;
                                this.$q = $q;
                                this.restrict = 'A';
                                this.scope = {
                                    eventTriggerFlag: '=?'
                                };
                                this.linkFn = function ($scope, element, attrs) {
                                    var mapping, mappingKey;
                                    var selectedSections = [
                                        DataLayerPredefinedSection.ACCOUNT,
                                        DataLayerPredefinedSection.PAGE,
                                        DataLayerPredefinedSection.SITE
                                    ];
                                    $scope.$applyAsync(function () {
                                        try {
                                            element.on(attrs.eventName, function (event) {
                                                if ($scope.eventTriggerFlag.triggered === 'NO') {
                                                    $scope.eventTriggerFlag.triggered = 'YES';
                                                    if (!mappingKey) {
                                                        mappingKey = attrs.mappingKey;
                                                    }
                                                    if (mappingKey) {
                                                        mapping = {
                                                            mappingKey: mappingKey
                                                        };
                                                    }
                                                    if (attrs.pageView === 'true') {
                                                        selectedSections.push(DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                                    }
                                                    _this.getEventPayload($scope, attrs).then(function (payload) {
                                                        _this.dataLayerService.track(payload, false, selectedSections, mapping);
                                                    });
                                                }
                                            });
                                        }
                                        catch (err) {
                                            console.warn('Exception in dataLayer form event tracking directive', err);
                                        }
                                    });
                                };
                                this.link = this.linkFn;
                            }
                            UteDataLayerIntegrationFormViewEvent.factory = function () {
                                var directive = function (dataLayerService, $parse, $q) { return new UteDataLayerIntegrationFormViewEvent(dataLayerService, $parse, $q); };
                                directive.$inject = ['ute.datalayer.common.service', '$parse', '$q'];
                                return directive;
                            };
                            ;
                            UteDataLayerIntegrationFormViewEvent.prototype.getEventPayload = function ($scope, attrs) {
                                var currentPayload_cb, currentPayload_promise, payload = {};
                                currentPayload_cb = this.dataLayerService.getCallbackByKey('payload');
                                currentPayload_promise = (currentPayload_cb) ? currentPayload_cb.callback(attrs.stateName) : {};
                                try {
                                    return this.$q.when(currentPayload_promise)
                                        .then(function (callbackPayLoad) {
                                        if (callbackPayLoad) {
                                            _.merge(payload, callbackPayLoad);
                                        }
                                        return payload;
                                    })
                                        .catch(function (error) {
                                        console.warn('Error in resolving payload promise.');
                                        return payload;
                                    });
                                }
                                catch (e) {
                                    console.warn('Silent :: Error in resolving payload promise.');
                                }
                            };
                            return UteDataLayerIntegrationFormViewEvent;
                        }());
                        angular.module('ute.rogers.datalayer.integration.common').directive('uteDataLayerIntegrationFormViewEvent', UteDataLayerIntegrationFormViewEvent.factory());
                    })(service = common.service || (common.service = {}));
                })(common = integration.common || (integration.common = {}));
            })(integration = datalayer.integration || (datalayer.integration = {}));
        })(datalayer = rogers.datalayer || (rogers.datalayer = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var datalayer;
        (function (datalayer) {
            var integration;
            (function (integration) {
                var common;
                (function (common) {
                    var service;
                    (function (service) {
                        'use strict';
                        angular.module('ute.rogers.datalayer.integration.common').filter('uteDataIntegrationLayerHTMLToText', function () {
                            return function (text) {
                                return String(text).replace(/<[^>]+>/gm, '');
                            };
                        });
                    })(service = common.service || (common.service = {}));
                })(common = integration.common || (integration.common = {}));
            })(integration = datalayer.integration || (datalayer.integration = {}));
        })(datalayer = rogers.datalayer || (rogers.datalayer = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var datalayer;
        (function (datalayer) {
            var integration;
            (function (integration) {
                var common;
                (function (common) {
                    var service;
                    (function (service) {
                        'use strict';
                        var __$q;
                        var __$state;
                        var __dataLayerService;
                        var __utePersistentStorageService;
                        var __datalayerIntegrationService;
                        //var __accountDetails;
                        var __cookies;
                        angular.module('ute.rogers.datalayer.integration.common').run(UTERogersDataLayerIntegrationRun);
                        UTERogersDataLayerIntegrationRun.$inject = ['$q', '$rootScope', '$injector', '$state', 'ute.datalayer.common.service', 'ute.blocks.persistent.storage.service', 'ute.rogers.datalayer.integration.common.service'];
                        /**
                         * @description To register call back functions.
                         */
                        function UTERogersDataLayerIntegrationRun($q, $rootScope, $injector, $state, dataLayerService, utePersistentStorageService, datalayerIntegrationService) {
                            var callbacks = [
                                {
                                    callbackKey: 'account',
                                    callback: getCurrentAccount
                                },
                                {
                                    callbackKey: 'user',
                                    callback: getCurrentUser
                                },
                                {
                                    callbackKey: 'province',
                                    callback: getCurrentProvince
                                },
                                {
                                    callbackKey: 'language',
                                    callback: getCurrentLanguage
                                },
                                {
                                    callbackKey: 'device',
                                    callback: getCurrentDevice
                                },
                                {
                                    callbackKey: 'plan',
                                    callback: getCurrentPlan
                                },
                                {
                                    callbackKey: 'payload',
                                    callback: getCurrentPayload
                                },
                                {
                                    callbackKey: 'eventPayload',
                                    callback: getEventPayload
                                },
                                {
                                    callbackKey: 'errorPayload',
                                    callback: getFormErrorPayload
                                }
                            ];
                            __$q = $q;
                            __$state = $state;
                            __dataLayerService = dataLayerService;
                            __utePersistentStorageService = utePersistentStorageService;
                            __datalayerIntegrationService = datalayerIntegrationService;
                            __dataLayerService.registerCallbacks(callbacks);
                            __cookies = $injector.get(angular.version.major <= 1 && angular.version.minor <= 3 ? 'cookieStore' : '$cookies');
                            try {
                            }
                            catch (e) {
                                console.log('exception accountdetails run block' + e);
                            }
                            var currentStateUrl;
                            if (__$state && __$state.current && __$state.current.name) {
                                currentStateUrl = __$state.current.url;
                            }
                            else if (window && window.location) {
                                currentStateUrl = window.location.hash;
                            }
                            console.log('currentStateUrl :: ' + currentStateUrl);
                            if (currentStateUrl && (currentStateUrl.match('choose-phone') || currentStateUrl.match('choose-plan') || currentStateUrl.match('build-plan') || currentStateUrl.match('change-share-plan') || currentStateUrl.match('resume') || currentStateUrl.match('review'))) {
                                __datalayerIntegrationService.resetSessionStorage().then(function (successFlag) {
                                    console.log('Clearing Session Storage :: ' + successFlag);
                                    if (__utePersistentStorageService.getFromSession('uniqueID') === undefined || __utePersistentStorageService.getFromSession('uniqueID') === null) {
                                        var uniqueValue = new Date().valueOf() + Math.random();
                                        var uniqueID = uniqueValue.toString();
                                        if (uniqueID.length > 19) {
                                            uniqueID = uniqueID.substring(0, 19);
                                        }
                                        __utePersistentStorageService.putToSession('uniqueID', uniqueID);
                                    }
                                });
                            }
                            $rootScope.$on('ngDialog.opened', function (e, $dialog) {
                                var $dialogOptions = angular.element($dialog.dialog).data('$ngDialogOptions');
                                if ($dialogOptions && $dialogOptions.trackingEnabled) {
                                    __datalayerIntegrationService.initiateModalAnalyticsEvent($dialog.name).then(function (successFlag) {
                                        console.log('ngDialog modal :: ' + successFlag);
                                    });
                                }
                            });
                            $rootScope.$on('$modal.opened', function (event, modalName) {
                                __datalayerIntegrationService.initiateModalAnalyticsEvent(modalName).then(function (successFlag) {
                                    console.log('$modal modal :: ' + successFlag);
                                });
                                if (event.stopPropagation) {
                                    event.stopPropagation();
                                }
                            });
                            $rootScope.$on('resetSessionEvent', function (event, reset) {
                                if (reset) {
                                    __datalayerIntegrationService.resetSessionStorage();
                                }
                            });
                        }
                        ;
                        /**
                         * @description To get the current Payload object.
                         */
                        function getCurrentPayload(stateName, removeCartEvent) {
                            var payload = {};
                            try {
                                return getPayload(stateName, removeCartEvent).then(function (payloadObj) {
                                    return payloadObj;
                                });
                            }
                            catch (error) {
                                console.error('ADL error in getCurrentPayload method: ', error);
                            }
                            return __$q.when(payload);
                        }
                        ;
                        /**
                         * @description To get the Payload object.
                         */
                        function getPayload(stateName, removeCartEvent) {
                            var completePayload = {};
                            try {
                                if (__utePersistentStorageService.getFromSession('uniqueID') === undefined || __utePersistentStorageService.getFromSession('uniqueID') === null) {
                                    var uniqueValue = new Date().valueOf() + Math.random();
                                    var uniqueID = uniqueValue.toString();
                                    if (uniqueID.length > 19) {
                                        uniqueID = uniqueID.substring(0, 19);
                                    }
                                    __utePersistentStorageService.putToSession('uniqueID', uniqueID);
                                }
                                var config = __dataLayerService.returnConfig();
                                var delegatedService = __datalayerIntegrationService;
                                if (_.get(config, 'advance.configOptions.deepLinkTrackingOn', false) && _.get(config, ['advance', 'configOptions', 'deepLinkMapping', stateName], false)) {
                                    for (var _i = 0, _a = _.get(config, ['advance', 'configOptions', 'deepLinkMapping', stateName], null); _i < _a.length; _i++) {
                                        var deepLinkParamKey = _a[_i];
                                        console.log('deepLinkParamKey :: ' + deepLinkParamKey);
                                        if (getQueryString(deepLinkParamKey)) {
                                            var deepLinkParamValue = getQueryString(deepLinkParamKey);
                                            return delegatedService.setDeviceProductObject(null, deepLinkParamValue, true, null, null, null, null, null).then(function (successFlag) {
                                                return constructPayload(stateName, removeCartEvent).then(function (payloadObj) {
                                                    return payloadObj;
                                                });
                                            });
                                        }
                                        else {
                                            return constructPayload(stateName, removeCartEvent).then(function (payloadObj) {
                                                return payloadObj;
                                            });
                                        }
                                    }
                                }
                                else {
                                    return constructPayload(stateName, removeCartEvent).then(function (payloadObj) {
                                        return payloadObj;
                                    });
                                }
                            }
                            catch (error) {
                                console.error('ADL error in getPayload method: ', error);
                            }
                            return __$q.when(completePayload);
                        }
                        ;
                        /**
                         * @description To construct the Payload object.
                         */
                        function constructPayload(stateName, removeCartEvent) {
                            var products = [];
                            var completePayload = {};
                            try {
                                var ecommObject_promise = __datalayerIntegrationService.getEcommerceObject(stateName, removeCartEvent);
                                var checkoutDetails_promise = __datalayerIntegrationService.getCheckoutDetailsObject(stateName);
                                var serial_promise = __datalayerIntegrationService.getSerialNumber();
                                var flowType_promise = __datalayerIntegrationService.getFlowType();
                                var isMultiLineFlow_promise = __datalayerIntegrationService.getIsMultiLineFlow();
                                var isAALFlow_promise = __datalayerIntegrationService.getIsAALFlow();
                                var keepPlan_promise = __datalayerIntegrationService.getKeepExistingPlan();
                                return __$q.all([ecommObject_promise, checkoutDetails_promise, serial_promise, flowType_promise, isMultiLineFlow_promise, isAALFlow_promise, keepPlan_promise])
                                    .then(function (values) {
                                    var ecommObject = values[0], checkoutDetails = values[1], serial = values[2];
                                    var flowType = values[3];
                                    var isMultiLineFlow = values[4];
                                    var isAALFlow = values[5];
                                    var keepPlan = values[6];
                                    //Adding device, plan and addon products to the products array
                                    return addProduct(ecommObject, stateName, products, flowType).then(function (products) {
                                        //Constructing the payload object
                                        return constructProductsPayload({}, products).then(function (payload) {
                                            return constructBuyflowOrSitePayload(payload, serial).then(function (payload) {
                                                return constructPagePayload(payload, stateName).then(function (payload) {
                                                    return constructEventPayload(payload, keepPlan, stateName, flowType, removeCartEvent, isMultiLineFlow, isAALFlow).then(function (payload) {
                                                        //Constructing the remaining objects for the at the 'confirm' state & mapping key is 'orderComplete'
                                                        if (stateName === 'orderComplete') {
                                                            return constructEcommercePayload(payload, checkoutDetails, flowType).then(function (payload) {
                                                                return payload;
                                                            });
                                                        }
                                                        else {
                                                            return payload;
                                                        }
                                                    });
                                                });
                                            });
                                        });
                                    });
                                }).catch(function (error) {
                                    console.warn('Error in constructing the payload.');
                                });
                            }
                            catch (error) {
                                console.error('ADL error in getPayload method: ', error);
                            }
                            return __$q.when(completePayload);
                        }
                        ;
                        /**
                         * @description To merge the passed in configuration with the local configuration.
                         */
                        function getQueryString(field, url) {
                            var href = url ? url : window.location.href;
                            var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
                            var queryString = reg.exec(href);
                            return queryString ? queryString[1] : null;
                        }
                        ;
                        /**
                         * @description To construct the product(device, plan, addons) objects.
                         */
                        function addProduct(obj, stateName, products, flowType) {
                            if (obj && obj.length > 0) {
                                obj.forEach(function (selectedProduct) {
                                    var product;
                                    product = {
                                        name: selectedProduct.name,
                                        ID: selectedProduct.ID,
                                        category: selectedProduct.category,
                                        subCategory: selectedProduct.subCategory,
                                        findingMethod: selectedProduct.findingMethod
                                    };
                                    if (product.subCategory === 'device') {
                                        product.manufacturer = selectedProduct.manufacturer;
                                        product.model = selectedProduct.model;
                                    }
                                    if (stateName === 'orderComplete') {
                                        if (selectedProduct.quantity) {
                                            product.quantity = selectedProduct.quantity;
                                        }
                                        if (product.subCategory === 'plan' && (flowType === 'PPC' || flowType === 'HUP') && _.has(selectedProduct, 'previousRevenue')) {
                                            product.previousRevenue = selectedProduct.previousRevenue;
                                        }
                                        if (product.subCategory !== 'device') {
                                            if (flowType === 'PPC' || flowType === 'HUP') {
                                                product.MSF = __datalayerIntegrationService.getPlanAddonsMSFById(selectedProduct.subCategory, selectedProduct.CTN, selectedProduct.ID);
                                            }
                                            else {
                                                product.MSF = selectedProduct.MSF;
                                            }
                                        }
                                        else {
                                            product.unsubprice = __datalayerIntegrationService.getNoTermPrice(selectedProduct.ID);
                                            product.price = __datalayerIntegrationService.getDeviceChargePriceByDeviceId(selectedProduct.ID, selectedProduct.basketSeqNo);
                                        }
                                    }
                                    if (product) {
                                        products.push(product);
                                    }
                                });
                            }
                            return __$q.when(products);
                        }
                        ;
                        /**
                         * @description To wrap the products Payload.
                         */
                        function constructProductsPayload(payload, products) {
                            var completePayload = {};
                            var eCommercePayloadObject = {};
                            if (products.length > 0) {
                                eCommercePayloadObject = {
                                    ecommerce: {
                                        products: products
                                    }
                                };
                            }
                            completePayload = _.merge(payload, eCommercePayloadObject);
                            return __$q.when(completePayload);
                        }
                        ;
                        /**
                         * @description To construct the buyflow/Site Payload.
                         */
                        function constructBuyflowOrSitePayload(payload, serial) {
                            var completePayload = {};
                            var buyFlowOrSitePayloadObj = {};
                            if (serial) {
                                var flowType = __utePersistentStorageService.getFromSession('flowType');
                                if (flowType === 'Selfserve') {
                                    buyFlowOrSitePayloadObj = {
                                        site: {
                                            sessionID: serial
                                        }
                                    };
                                }
                                else {
                                    buyFlowOrSitePayloadObj = {
                                        buyflow: {
                                            serial: serial
                                        }
                                    };
                                }
                            }
                            completePayload = _.merge(payload, buyFlowOrSitePayloadObj);
                            return __$q.when(completePayload);
                        }
                        ;
                        /**
                         * @description To construct the page payload.
                         */
                        function constructPagePayload(payload, stateName) {
                            var completePayload = {};
                            var pagePayload = {};
                            if (stateName) {
                                if (stateName === 'creditCheckFailOrSecDeposit') {
                                    var creditDepositAmount = 0;
                                    if (__utePersistentStorageService.getFromSession('CREDIT_CHECK_DEPOSIT_AMOUNT')) {
                                        creditDepositAmount = __utePersistentStorageService.getFromSession('CREDIT_CHECK_DEPOSIT_AMOUNT');
                                    }
                                    var pageName = 'credit-check-acceptance-risk-' + creditDepositAmount;
                                    pagePayload = {
                                        page: {
                                            name: pageName
                                        }
                                    };
                                }
                            }
                            completePayload = _.merge(payload, pagePayload);
                            return __$q.when(completePayload);
                        }
                        ;
                        /**
                         * @description To construct the event Payload.
                         */
                        function constructEventPayload(payload, keepPlan, stateName, flowType, removeCartEvent, isMultiLineFlow, isAALFlow) {
                            var completePayload = {};
                            var eventObj = {};
                            var events = {};
                            var form = {};
                            var buyFlow = {};
                            var flowName;
                            if (__utePersistentStorageService.getFromSession('flowName')) {
                                flowName = __utePersistentStorageService.getFromSession('flowName');
                            }
                            if (!removeCartEvent) {
                                if (stateName === 'orderComplete') {
                                    events.purchase = true;
                                    events.buyFlowComplete = true;
                                }
                                if (_.has(__dataLayerService.returnConfig(), 'advance.checkoutStates')) {
                                    __dataLayerService.returnConfig().advance.checkoutStates.forEach(function (checkoutState) {
                                        if (stateName === checkoutState || stateName === 'orderComplete') {
                                            if (flowType === 'PPC' || flowType === 'HUP') {
                                                if (__utePersistentStorageService.getFromSession('isTAZOFlow')) {
                                                    buyFlow.useCase = 'T';
                                                }
                                                else {
                                                    if (flowName === 'multiline') {
                                                        buyFlow.useCase = 'ML';
                                                    }
                                                    if (flowName === 'singleline') {
                                                        buyFlow.useCase = 'SL';
                                                    }
                                                }
                                            }
                                            if (flowType === 'NAC') {
                                                if (stateName !== 'reviewBuildPlan') {
                                                    if (isAALFlow) {
                                                        if (isMultiLineFlow) {
                                                            buyFlow.useCase = 'MLAAL';
                                                        }
                                                        if (!isMultiLineFlow) {
                                                            buyFlow.useCase = 'SLAAL';
                                                        }
                                                    }
                                                    if (!isAALFlow) {
                                                        if (isMultiLineFlow) {
                                                            buyFlow.useCase = 'ML';
                                                        }
                                                        if (!isMultiLineFlow) {
                                                            buyFlow.useCase = 'SL';
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                                if (flowType === 'NAC') {
                                    if (stateName === 'choose-add-ons' && !__utePersistentStorageService.getFromSession('ADD_TO_CART_TRIGGERED')) {
                                        events.addToCart = true;
                                        __utePersistentStorageService.putToSession('ADD_TO_CART_TRIGGERED', true);
                                    }
                                    if (stateName === 'add-ons' && !__utePersistentStorageService.getFromSession('ADD_TO_CART_TRIGGERED')) {
                                        events.addToCart = true;
                                        __utePersistentStorageService.putToSession('ADD_TO_CART_TRIGGERED', true);
                                    }
                                    if ((stateName === 'add-ons') && (__utePersistentStorageService.getFromSession('BYOP'))) {
                                        events.buyFlowStart = true;
                                        __utePersistentStorageService.removeFromSession('BYOP');
                                    }
                                    if (stateName === 'shipping' && isAALFlow) {
                                        events.checkout = true;
                                    }
                                    if (stateName === 'createProfile' && !__utePersistentStorageService.getFromSession('CHECKOUT_EVENTS') && !isAALFlow) {
                                        events.checkout = true;
                                        __utePersistentStorageService.putToSession('CHECKOUT_EVENTS', true);
                                    }
                                    if (stateName === 'creditCheck' && !(__utePersistentStorageService.getFromSession('CREATE_PROFILE_FORM_COMPLETE'))) {
                                        events.formComplete = true;
                                        form.name = 'create profile';
                                        __utePersistentStorageService.putToSession('CREATE_PROFILE_FORM_COMPLETE', true);
                                    }
                                    if (!isAALFlow) {
                                        if ((stateName === 'ctnSelection' || stateName === 'seeChooseNumber') && !(__utePersistentStorageService.getFromSession('CREDIT_CHECK_FORM_COMPLETE'))) {
                                            events.formComplete = true;
                                            form.name = 'credit check';
                                        }
                                        if (stateName === 'creditCheckFailOrSecDeposit' && !(__utePersistentStorageService.getFromSession('CREDIT_CHECK_FORM_COMPLETE'))) {
                                            events.formComplete = true;
                                            form.name = 'credit check';
                                            __utePersistentStorageService.putToSession('CREDIT_CHECK_FORM_COMPLETE', true);
                                        }
                                        if (stateName === 'creditCheckOptions') {
                                            events.formComplete = true;
                                            form.name = 'credit check';
                                            __utePersistentStorageService.putToSession('CREDIT_CHECK_FORM_COMPLETE', true);
                                        }
                                    }
                                    if (stateName === 'nacPayment') {
                                        events.formComplete = true;
                                        form.name = 'choose number';
                                    }
                                    if (stateName === 'review' && isAALFlow) {
                                        events.formComplete = true;
                                        form.name = 'choose number';
                                    }
                                }
                                else if (flowType === 'HUP') {
                                    if (stateName === 'orderComplete') {
                                        events.keepPlan = keepPlan;
                                    }
                                    if (stateName === 'review' && __utePersistentStorageService.getFromSession('SHIPPING_ADDRESS_CHANGED')) {
                                        events.formComplete = true;
                                        form.name = 'shipping address';
                                    }
                                    if (stateName === 'add-ons' && !__utePersistentStorageService.getFromSession('ADD_TO_CART_TRIGGERED')) {
                                        events.addToCart = true;
                                        __utePersistentStorageService.putToSession('ADD_TO_CART_TRIGGERED', true);
                                    }
                                    if (stateName === 'choose-add-ons' && !__utePersistentStorageService.getFromSession('ADD_TO_CART_TRIGGERED')) {
                                        events.addToCart = true;
                                        __utePersistentStorageService.putToSession('ADD_TO_CART_TRIGGERED', true);
                                    }
                                }
                                else if (flowType === 'PPC') {
                                    if (stateName === 'app.mppc.step4' && !__utePersistentStorageService.getFromSession('ADD_TO_CART_TRIGGERED')) {
                                        events.addToCart = true;
                                        __utePersistentStorageService.putToSession('ADD_TO_CART_TRIGGERED', true);
                                    }
                                    if (stateName === 'app.mppc.step1') {
                                        __utePersistentStorageService.putToSession('BUY_FLOW_START_TRIGGERED', true);
                                    }
                                    if (stateName === 'app.mppc.entry' && __utePersistentStorageService.getFromSession('BUY_FLOW_START_TRIGGERED')) {
                                        __utePersistentStorageService.removeFromSession('BUY_FLOW_START_TRIGGERED');
                                    }
                                    if (stateName === 'app.mppc.step2' && !__utePersistentStorageService.getFromSession('BUY_FLOW_START_TRIGGERED')) {
                                        events.buyFlowStart = true;
                                    }
                                    if (stateName === '' || stateName === '') {
                                        events.checkout = true;
                                        __utePersistentStorageService.putToSession('CHECKOUT_EVENTS', true);
                                    }
                                    if (stateName === 'createProfile' && !__utePersistentStorageService.getFromSession('CHECKOUT_EVENTS')) {
                                        events.checkout = true;
                                    }
                                }
                                else {
                                }
                                if (Object.keys(events).length > 0) {
                                    eventObj.events = events;
                                }
                                if (Object.keys(form).length > 0) {
                                    eventObj.form = form;
                                }
                                if (Object.keys(buyFlow).length > 0) {
                                    eventObj.buyflow = buyFlow;
                                }
                            }
                            completePayload = _.merge(payload, eventObj);
                            return __$q.when(completePayload);
                        }
                        ;
                        /**
                         * @description To construct the ecommerce Payload.
                         */
                        function constructEcommercePayload(payload, details, flowType) {
                            var completePayload = {};
                            if (details && Object.keys(details).length > 0) {
                                var fulfillment_promise = __datalayerIntegrationService.getFulfillmentMethod();
                                var creditCardType_promise = __datalayerIntegrationService.getCreditCardType();
                                return __$q.all([fulfillment_promise, creditCardType_promise]).then(function (values) {
                                    var fulfillmentMethod = values[0];
                                    var creditCardTypes = [];
                                    creditCardTypes.push(values[1]);
                                    var obj = {};
                                    var ecommerce = {
                                        transactionID: details.transactionID,
                                        currency: 'CAD',
                                        tax: details.tax,
                                        province: details.province.toLowerCase(),
                                        postal: details.postalCode,
                                        paymentMethods: creditCardTypes,
                                        fees: details.fees
                                    };
                                    if (flowType === 'NAC' || flowType === 'HUP') {
                                        ecommerce.fullfillmentMethod = fulfillmentMethod;
                                    }
                                    obj.ecommerce = ecommerce;
                                    completePayload = _.merge(payload, obj);
                                    return completePayload;
                                });
                            }
                            return __$q.when(payload);
                        }
                        ;
                        /**
                         * @description To construct payload for data layer form event.
                         */
                        function getEventPayload(eventData) {
                            var payload = {};
                            return __datalayerIntegrationService.getSerialNumber().then(function (serialId) {
                                try {
                                    if (serialId) {
                                        var flowType = __utePersistentStorageService.getFromSession('flowType');
                                        if (flowType === 'Selfserve') {
                                            payload.site = {};
                                            payload.site.sessionID = serialId;
                                        }
                                        else {
                                            payload.buyflow = {};
                                            payload.buyflow.serial = serialId;
                                        }
                                    }
                                    if (_.has(__dataLayerService.returnConfig(), 'advance.configOptions.appName') && payload.buyflow) {
                                        payload.buyflow.name = __dataLayerService.returnConfig().advance.configOptions.appName;
                                    }
                                    if (eventData) {
                                        var parsedEventData = JSON.parse(eventData);
                                        payload = _.merge(parsedEventData, payload);
                                    }
                                }
                                catch (error) {
                                    console.error('ADL error in getEventPayload method: ', error);
                                }
                                return payload;
                            });
                        }
                        ;
                        /**
                         * @description To get the form error Payload.
                         */
                        function getFormErrorPayload(errorData) {
                            var payload = {};
                            return __datalayerIntegrationService.getSerialNumber().then(function (serialId) {
                                try {
                                    if (serialId) {
                                        var flowType = __utePersistentStorageService.getFromSession('flowType');
                                        if (flowType === 'Selfserve') {
                                            payload.site = {};
                                            payload.site.sessionID = serialId;
                                        }
                                        else {
                                            payload.buyflow = {};
                                            payload.buyflow.serial = serialId;
                                        }
                                    }
                                    if (_.has(__dataLayerService.returnConfig(), 'advance.configOptions.appName') && payload.buyflow) {
                                        payload.buyflow.name = __dataLayerService.returnConfig().advance.configOptions.appName;
                                    }
                                }
                                catch (error) {
                                    console.error('ADL error in getEventPayload method: ', error);
                                }
                                return payload;
                            });
                        }
                        ;
                        /**
                         * @description To get the current account number.
                         */
                        function getCurrentAccount() {
                            var returnObject = {};
                            var subscriberNumber;
                            var accountNumber;
                            var type;
                            return __datalayerIntegrationService.getUserAccountInfo().then(function (accountInfo) {
                                return __datalayerIntegrationService.getSelectedSubscriberNumber().then(function (subscriberObject) {
                                    var config = __dataLayerService.returnConfig();
                                    if (_.get(config, 'advance.configOptions.suppressCTNForNonWireless', false)) {
                                        var currentStateName = 'Unknown';
                                        if (__$state && __$state.current && __$state.current.name) {
                                            currentStateName = __$state.current.name;
                                        }
                                        var mappingKey = __dataLayerService.getConfigByMappingKey({ 'mappingKey': 'advance.mappingKey.' + currentStateName });
                                        if (_.get(mappingKey, 'page.wirelessPage', false)) {
                                            if (subscriberObject && subscriberObject.CTN) {
                                                subscriberNumber = subscriberObject.CTN;
                                            }
                                            else if (accountInfo && accountInfo.subscriberNumber) {
                                                subscriberNumber = accountInfo.subscriberNumber;
                                            }
                                        }
                                    }
                                    else {
                                        if (subscriberObject && subscriberObject.CTN) {
                                            subscriberNumber = subscriberObject.CTN;
                                        }
                                        else if (accountInfo && accountInfo.subscriberNumber) {
                                            subscriberNumber = accountInfo.subscriberNumber;
                                        }
                                    }
                                    if (accountInfo && accountInfo.accountNumber) {
                                        accountNumber = accountInfo.accountNumber;
                                    }
                                    else if (__utePersistentStorageService.getFromSession('tentativeAccountNumber')) {
                                        accountNumber = __utePersistentStorageService.getFromSession('tentativeAccountNumber');
                                    }
                                    if (accountInfo && accountInfo.type) {
                                        type = accountInfo.type;
                                    }
                                    try {
                                        if (accountNumber || subscriberNumber || type) {
                                            returnObject = {
                                                accountNumber: accountNumber,
                                                phoneNumber: subscriberNumber,
                                                accountType: type
                                            };
                                            return returnObject;
                                        }
                                        else {
                                            return __$q.defer().resolve(undefined);
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error in getCurrentAccount method: ', error);
                                    }
                                    return __$q.when(returnObject);
                                });
                            });
                        }
                        ;
                        /**
                         * @description To get the current device.
                         */
                        function getCurrentDevice() {
                            var returnObject = {};
                            return __datalayerIntegrationService.getCurrentDeviceObj().then(function (deviceObject) {
                                if (deviceObject && Object.keys(deviceObject).length > 0 && deviceObject.device) {
                                    returnObject = {
                                        device: deviceObject.device
                                    };
                                }
                                else {
                                    return __$q.defer().resolve(undefined);
                                }
                                return __$q.when(returnObject);
                            });
                        }
                        ;
                        /**
                         * @description To get the current plan details.
                         */
                        function getCurrentPlan() {
                            var returnObject = {};
                            var payOffDate;
                            var planSOC;
                            var planAmount;
                            return __datalayerIntegrationService.getCurrentPlanObj().then(function (planObject) {
                                if (planObject && Object.keys(planObject).length > 0) {
                                    if (planObject.payoffDate) {
                                        payOffDate = planObject.payoffDate;
                                    }
                                    if (planObject.plan) {
                                        planSOC = planObject.plan;
                                    }
                                    if (planObject.amount) {
                                        planAmount = planObject.amount;
                                    }
                                    returnObject = {
                                        plan: planSOC,
                                        amount: planAmount,
                                        payoffDate: payOffDate
                                    };
                                }
                                else {
                                    return __$q.defer().resolve(undefined);
                                }
                                return __$q.when(returnObject);
                            });
                        }
                        ;
                        /**
                         * @description To get the current usertype and username.
                         */
                        function getCurrentUser() {
                            var returnObject = {};
                            var userID;
                            var userType;
                            var dealerCode;
                            var dealerType;
                            return __datalayerIntegrationService.getUserAccountInfo().then(function (accountInfo) {
                                return __datalayerIntegrationService.getDealerInfo().then(function (dealerInfo) {
                                    if (accountInfo && accountInfo.userType) {
                                        userType = accountInfo.userType;
                                    }
                                    if (userType && (userType === 'consumer' || userType === 'BSS-Standard')) {
                                        if (accountInfo && accountInfo.userName) {
                                            userID = accountInfo.userName;
                                        }
                                        else if (__utePersistentStorageService.getFromSession('profileInfo')) {
                                            var tempID = __utePersistentStorageService.getFromSession('profileInfo');
                                            userID = tempID.emailAddress;
                                        }
                                    }
                                    else if (dealerInfo && dealerInfo.userId) {
                                        userID = dealerInfo.userId;
                                    }
                                    if (dealerInfo && dealerInfo.dealerCode) {
                                        dealerCode = dealerInfo.dealerCode;
                                    }
                                    else if (__utePersistentStorageService.getFromSession('dealerCode')) {
                                        dealerCode = __utePersistentStorageService.getFromSession('dealerCode');
                                    }
                                    if (dealerInfo && dealerInfo.dealerType) {
                                        dealerType = dealerInfo.dealerType;
                                    }
                                    try {
                                        if (userID || userType || dealerCode || dealerType) {
                                            returnObject = {
                                                userType: userType,
                                                userName: userID,
                                                dealerCode: dealerCode,
                                                dealerType: dealerType
                                            };
                                        }
                                        else {
                                            return __$q.defer().resolve(undefined);
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error in getCurrentUser method: ', error);
                                    }
                                    return __$q.when(returnObject);
                                });
                            });
                        }
                        ;
                        /**
                         * @description To get the current province.
                         */
                        function getCurrentProvince() {
                            var returnObject = {};
                            try {
                                returnObject = {
                                    province: __utePersistentStorageService.getFromSession('userProvince')
                                };
                            }
                            catch (error) {
                                console.error('ADL error in getCurrentProvince method: ', error);
                            }
                            return __$q.when(returnObject);
                        }
                        ;
                        /**
                         * @description To get the current language.
                         */
                        function getCurrentLanguage() {
                            var returnObject = {};
                            try {
                                returnObject = {
                                    language: __utePersistentStorageService.getFromSession('userLanguage')
                                };
                            }
                            catch (error) {
                                console.error('ADL error in getCurrentLanguage method: ', error);
                            }
                            return __$q.when(returnObject);
                        }
                        ;
                    })(service = common.service || (common.service = {}));
                })(common = integration.common || (integration.common = {}));
            })(integration = datalayer.integration || (datalayer.integration = {}));
        })(datalayer = rogers.datalayer || (rogers.datalayer = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var datalayer;
        (function (datalayer) {
            var integration;
            (function (integration) {
                var common;
                (function (common) {
                    var service;
                    (function (service) {
                        'use strict';
                        var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
                        var DataLayerIntegrationService = (function () {
                            /* @ngInject */
                            function DataLayerIntegrationService($http, $rootScope, $q, $filter, $translate, $window, $injector, $state, $stateParams, $previousState, dataLayerService, utePersistentStorageService) {
                                var _this = this;
                                this.$http = $http;
                                this.$rootScope = $rootScope;
                                this.$q = $q;
                                this.$filter = $filter;
                                this.$translate = $translate;
                                this.$window = $window;
                                this.$injector = $injector;
                                this.$state = $state;
                                this.$stateParams = $stateParams;
                                this.$previousState = $previousState;
                                this.dataLayerService = dataLayerService;
                                this.utePersistentStorageService = utePersistentStorageService;
                                this.config = {};
                                this.runtimeConfigure = function (config) {
                                    _this.config = _.merge(_this.config, config);
                                    return true;
                                };
                                this.getConfig = function () { return angular.copy(_this.config); };
                                /**
                                 * @description To track the API errors events.
                                 * @param response: any,
                                 * analyticsInfo: IAnalyticsInfo,
                                 * successFlag: boolean,
                                 */
                                this.initiateErrorAnalyticsEvent = function (response, analyticsInfo, successFlag) {
                                    try {
                                        // asynchronous function, which calls
                                        _this.payload = {
                                            buyflow: {},
                                            site: {}
                                        };
                                        var isExceptionFound_1 = false;
                                        var uteRequestId_1 = response.headers('Ute-Request-Id') ? response.headers('Ute-Request-Id') : 'Unknown';
                                        var statusCode_1 = response.status;
                                        var statusText_1 = response.statusText;
                                        var translateKey_1 = 'checkout_server_error_title';
                                        var translateService = void 0;
                                        var translateServiceProvided_1 = false;
                                        if (_this.dataLayerService.returnConfig().advance.defaultAPIErrorMessageKey) {
                                            translateKey_1 = _this.dataLayerService.returnConfig().advance.defaultAPIErrorMessageKey;
                                        }
                                        if (_this.dataLayerService.returnConfig().advance.defaultTranslateService) {
                                            translateService = _this.dataLayerService.returnConfig().advance.defaultTranslateService;
                                            _this.customTranslateService = _this.$injector.get(translateService);
                                            translateServiceProvided_1 = true;
                                        }
                                        if (_this.utePersistentStorageService.getFromSession('uniqueID') === undefined || _this.utePersistentStorageService.getFromSession('uniqueID') === null) {
                                            var uniqueValue = new Date().valueOf() + Math.random();
                                            var uniqueID = uniqueValue.toString();
                                            if (uniqueID.length > 19) {
                                                uniqueID = uniqueID.substring(0, 19);
                                            }
                                            _this.utePersistentStorageService.putToSession('uniqueID', uniqueID);
                                        }
                                        var statusMessage_1;
                                        var appName = void 0;
                                        var userType = void 0;
                                        var pathArray = analyticsInfo.url.split('/');
                                        var apiName_1 = pathArray[pathArray.length - 1];
                                        if (/^logout-keep-alive/.test(apiName_1)) {
                                            apiName_1 = 'logout-keep-alive';
                                        }
                                        var errorTrackingAPI = _.find(_this.dataLayerService.returnConfig().advance.errorTrackingAPIs, function (errorTrackingAPI) {
                                            return errorTrackingAPI.name === apiName_1;
                                        });
                                        var currentStateName_1 = 'Unknown';
                                        if (_this.$state && _this.$state.current && _this.$state.current.name) {
                                            currentStateName_1 = _this.$state.current.name;
                                        }
                                        var isCheckoutState = _.find(_this.dataLayerService.returnConfig().advance.checkoutStates, function (state) {
                                            return state === currentStateName_1;
                                        });
                                        var isAALFlow = _this.utePersistentStorageService.getFromSession('isAALFlow');
                                        var accountInfo = _this.utePersistentStorageService.getFromSession('accountInfo');
                                        if (accountInfo) {
                                            userType = accountInfo.userType;
                                        }
                                        if (errorTrackingAPI && errorTrackingAPI.message) {
                                            translateKey_1 = errorTrackingAPI.message;
                                        }
                                        if (errorTrackingAPI && errorTrackingAPI.applicableInCheckoutModule && isCheckoutState) {
                                            translateKey_1 = errorTrackingAPI.checkoutConfig.message;
                                            if (errorTrackingAPI.checkoutConfig.errorsMapExist && errorTrackingAPI.checkoutConfig.errorsMap) {
                                                errorTrackingAPI.errorsMap = errorTrackingAPI.checkoutConfig.errorsMap;
                                            }
                                        }
                                        if (_.has(_this.dataLayerService.returnConfig(), 'advance.configOptions.appName')) {
                                            _this.payload.buyflow.name = _this.dataLayerService.returnConfig().advance.configOptions.appName;
                                            appName = _this.dataLayerService.returnConfig().advance.configOptions.appName;
                                        }
                                        if (errorTrackingAPI && (errorTrackingAPI.checkoutModule || errorTrackingAPI.applicableInCheckoutModule) && isCheckoutState) {
                                            _this.customTranslateService = _this.$injector.get('checkoutResource');
                                            translateServiceProvided_1 = true;
                                        }
                                        if (successFlag) {
                                            if (response && (!response.data || response.data === undefined || response.data === null || (response.data && (response.data.errorCode || response.data.errorMessage || response.data.error)))) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'activatedUserSummary') {
                                                if (!appName) {
                                                    if (_.includes(_this.$rootScope.errorMsgBB, response.data)) {
                                                        isExceptionFound_1 = true;
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'subscribers') {
                                                if (!response.data.subscribers) {
                                                    isExceptionFound_1 = true;
                                                }
                                                else if (response.data.subscribers && (response.data.subscribers.length === 0)) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'checkCreditLimit' && response.data.overLimit) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'getState' && response && response.data) {
                                                if (appName === 'NAC') {
                                                    if (!response.data.success) {
                                                        isExceptionFound_1 = true;
                                                    }
                                                    else if (!isCheckoutState && currentStateName_1 !== 'deviceCatalog') {
                                                        if (response.data.key === 'NEW_MULTI_WRLS_INFO' && !(response.data.nacSessionList && response.data.nacSessionList.length)) {
                                                            isExceptionFound_1 = true;
                                                        }
                                                        if (response.data.key === 'NEW_WRLS_INFO') {
                                                            if ((response.data.phone && !response.data.phone.deviceSku)) {
                                                                isExceptionFound_1 = true;
                                                            }
                                                            if ((response.data.plan && !response.data.plan.valid) || (response.data.addons && !response.data.addons.valid)) {
                                                                translateKey_1 = 'invalid_hup_order_error';
                                                                isExceptionFound_1 = true;
                                                            }
                                                        }
                                                    }
                                                    else if (currentStateName_1 === 'createProfile' && response.data.key === 'NEW_MULTI_WRLS_INFO' && !(response.data.nacSessionList && response.data.nacSessionList.length)) {
                                                        //existing user. on create profile page.
                                                        isExceptionFound_1 = true;
                                                    }
                                                    if (isAALFlow) {
                                                        if (currentStateName_1 === 'shipping' && response.config.data.analytics && !(response.data.customerDetails && !_.isEmpty(response.data.customerDetails))) {
                                                            isExceptionFound_1 = true;
                                                        }
                                                    }
                                                }
                                                if (appName === 'HUP') {
                                                    if (response.data.success && (response.data.errorMessage || (response.data.context && !response.data.context.ctn) || (response.data.phone && !response.data.phone.valid) || (response.data.plan && !response.data.plan.valid) || (response.data.addons && !response.data.addons.valid))) {
                                                        translateKey_1 = 'invalid_hup_order_error';
                                                        isExceptionFound_1 = true;
                                                    }
                                                    else if (!response.data.success) {
                                                        isExceptionFound_1 = true;
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'getSkuHupOffers' && !response.data.skuHupOffersMap) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'getSkuOffers') {
                                                if (response.data && !(response.data.skuOffersMap && response.data.success)) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if ((apiName_1 === 'getAllHupDevices' || apiName_1 === 'getAllDevices' || apiName_1 === 'getSubsidizedSkuPrices' || apiName_1 === 'getSubsidyCategoryOffers') && response && response.data) {
                                                if (!response.data.devicesMap) {
                                                    isExceptionFound_1 = true;
                                                }
                                                if (response.data.error || response.data.errorMessage) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'add' && !response.data.success) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'clearAllAndAddToCart' && !response.data.success) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'validateSIM') {
                                                if (response && response.data && !response.data.simFound) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'flow-type' && !response.data.success) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'eligibility') {
                                                if (response.data && !response.data.eligible) {
                                                    isExceptionFound_1 = true;
                                                }
                                                if ((!response || !response.data) && appName !== 'HUP') {
                                                    translateKey_1 = 'ppccode_500';
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'order-email') {
                                                if (response.data.emailType && response.data.emailType !== 'review') {
                                                    translateKey_1 = 'checkout_sendemail_error';
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'autoRegister' && response.data.status && !(response.data.status.toLowerCase() === 'success')) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'fetchCart' && !response.data.success) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'reserveTelephoneNumber' && response.data.status && response.data.status.toLowerCase() !== 'success') {
                                                isExceptionFound_1 = true;
                                                if (response.data.errorCode) {
                                                    _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                        if (Number(key) === Number(response.data.errorCode)) {
                                                            translateKey_1 = value;
                                                            return false;
                                                        }
                                                    });
                                                }
                                            }
                                            if (apiName_1 === 'createCustomerAccount' && !response.data.tentativeAccountNumber) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'checkNfdb') {
                                                if (response.data.isNFDBExistInd) {
                                                    isExceptionFound_1 = true;
                                                    if (currentStateName_1 === 'shipping') {
                                                        translateKey_1 = 'checkout_shipping_nfdb_error';
                                                    }
                                                }
                                                else if (appName === 'HUP' && response && response && (!response.data || response.data === undefined || response.data === null) && isCheckoutState) {
                                                    translateKey_1 = 'checkout_server_error_title';
                                                }
                                            }
                                            if (apiName_1 === 'verifyJanrainCustomer') {
                                                if (response.data.janrainCustomer && response.data.janrainCustomer === true) {
                                                    isExceptionFound_1 = true;
                                                }
                                                else if (response.data.janrainCustomer === false) {
                                                    isExceptionFound_1 = false;
                                                }
                                            }
                                            if (apiName_1 === 'validate-order') {
                                                if (response.data && !response.data.success) {
                                                    isExceptionFound_1 = true;
                                                    if (appName === 'HUP' && response.data.errorCode) {
                                                        _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                            if (key === response.data.errorCode.toUpperCase()) {
                                                                translateKey_1 = value;
                                                                return false;
                                                            }
                                                        });
                                                    }
                                                }
                                                //PPC
                                                if (response.data && response.data.wirelessOrderResponseHeader && response.data.wirelessOrderResponseHeader.orderStatus.toLowerCase() !== 'success') {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'review-order' && !response.data.success) {
                                                isExceptionFound_1 = true;
                                                if (response.data.errorCode) {
                                                    _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                        if (key === response.data.errorCode.toUpperCase()) {
                                                            translateKey_1 = value;
                                                            return false;
                                                        }
                                                    });
                                                }
                                            }
                                            if (apiName_1 === 'activationPaymentOptions') {
                                                if (response.data && (!response.data.nacPaymentOptionsRogers || !(response.data.nacPaymentOptionsRogers.length > 0))) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'checkPortInEligibility' && response.data && (!response.data.portInEligible || response.data.portInEligible !== 'YES')) {
                                                translateKey_1 = 'checkout_number_not_eligible_transfer_1';
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'availableTelephoneNumbers' && !response.data.ctnList) {
                                                translateKey_1 = 'checkout_ctn_warnmsg';
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'searchCustomer') {
                                                if (response.data.errorCode === '30106') {
                                                    isExceptionFound_1 = false;
                                                }
                                                else if (response.data.customerExistsInd && response.data.customerExistsInd === true) {
                                                    if (userType === 'dealer' || userType === 'care') {
                                                        translateKey_1 = 'existingCustomer_error1';
                                                        isExceptionFound_1 = true;
                                                    }
                                                    else {
                                                        translateKey_1 = 'checkout_duplicate_account_error_msg_section_1';
                                                        isExceptionFound_1 = true;
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'checkCreditAssessment') {
                                                if (response.data.fraudInd && response.data.fraudInd === true) {
                                                    translateKey_1 = 'checkout_appears_problem_with_information_entered_please_call_number_below';
                                                    isExceptionFound_1 = true;
                                                }
                                                else if ((response.data.alertInd && response.data.alertInd === true) || (response.data.riskClassCategory && response.data.riskClassCategory === 'DECL')) {
                                                    translateKey_1 = 'checkout_creditcheck_common_fail';
                                                    isExceptionFound_1 = true;
                                                }
                                                else if (response.data.errorCode) {
                                                    _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                        if (Number(key) === Number(response.data.errorCode)) {
                                                            translateKey_1 = value;
                                                            return false;
                                                        }
                                                    });
                                                }
                                            }
                                            if (apiName_1 === 'preAuth' && !response.data.success) {
                                                isExceptionFound_1 = true;
                                                if (response.data.errorCode) {
                                                    if ((userType === 'care' || userType === 'dealer') && response.data.errorCode === 9999) {
                                                        translateKey_1 = 'checkout_preauth_failed_max_attempts_care';
                                                    }
                                                    else {
                                                        _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                            if (Number(key) === Number(response.data.errorCode)) {
                                                                translateKey_1 = value;
                                                                return false;
                                                            }
                                                        });
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'submit-order') {
                                                var errorCode_1 = -1;
                                                if (response.data && !response.data.success) {
                                                    isExceptionFound_1 = true;
                                                    if (_this.$stateParams && _this.$stateParams.creditCardPaymentObj) {
                                                        errorCode_1 = 1666;
                                                    }
                                                    else {
                                                        errorCode_1 = 1777;
                                                    }
                                                }
                                                if (response.data && response.data.errorCode) {
                                                    isExceptionFound_1 = true;
                                                    errorCode_1 = response.data.errorCode;
                                                }
                                                if (isExceptionFound_1 && errorCode_1 && errorCode_1 !== -1) {
                                                    _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                        if (Number(key) === Number(errorCode_1)) {
                                                            translateKey_1 = value;
                                                            return false;
                                                        }
                                                    });
                                                }
                                            }
                                            if (apiName_1 === 'updateAccount') {
                                                if (response.data && response.data.status && response.data.status.toLowerCase() !== 'success') {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'removeItem' && !response.data.success && isCheckoutState) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'apply-discount') {
                                                var discountErrorCode_1;
                                                if ((response.data.validateStatus && response.data.validateStatus.toUpperCase() !== 'SUCCESS') || (response.data.applyStatus && response.data.applyStatus.toUpperCase() !== 'SUCCESS') || (response.data.status && response.data.status.toUpperCase() !== 'SUCCESS')) {
                                                    isExceptionFound_1 = true;
                                                    discountErrorCode_1 = 'VP007';
                                                    if (response.data.validateErrorCode) {
                                                        discountErrorCode_1 = response.data.validateErrorCode;
                                                    }
                                                    if (response.data.applyErrorCode) {
                                                        discountErrorCode_1 = response.data.applyErrorCode;
                                                    }
                                                    if (response.data.errorCode) {
                                                        discountErrorCode_1 = response.data.errorCode;
                                                    }
                                                    if (discountErrorCode_1 && isExceptionFound_1) {
                                                        _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                            if (key === discountErrorCode_1.toUpperCase()) {
                                                                translateKey_1 = value;
                                                                return false;
                                                            }
                                                        });
                                                    }
                                                }
                                            }
                                            //PPC calls
                                            if (apiName_1 === 'accountoverview' && appName === 'PPC') {
                                                if (!(response.data.accountList && response.data.accountList.length)) {
                                                    isExceptionFound_1 = true;
                                                }
                                                var WIRELESS_ACCOUNT_TYPE_1 = [1, 9];
                                                var account = _.find(response.data.accountList, function (account) {
                                                    return account.accountNumber && WIRELESS_ACCOUNT_TYPE_1.indexOf(account.accountTypeNumber) >= 0 && account.isWlsSubTypeExists;
                                                });
                                                if (!(account && account.subNumbers.length)) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'summary' && appName === 'PPC') {
                                                if (!(response.data.subList && response.data.subList.length)) {
                                                    isExceptionFound_1 = true;
                                                }
                                                var requestedAccountNumber_1;
                                                if (response && response.config && response.config.data && response.config.data.accountNumber) {
                                                    requestedAccountNumber_1 = response.config.data.accountNumber;
                                                }
                                                var subNumbers = _.reduce(response.data.subList, function (numbers, obj) {
                                                    if (obj.subNumber.length === 10 && obj.isAccountHolder && obj.subType === 'CTN' && obj.subStatus.toLowerCase() === 'active' && obj.subAccountId === requestedAccountNumber_1) {
                                                        numbers = _.union(numbers, [obj.subNumber]);
                                                    }
                                                    return numbers;
                                                }, []);
                                                if (!subNumbers.length) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'state' && (!response.data.ban || !response.data.accountTypeNumber || !response.data.ctn)) {
                                                isExceptionFound_1 = true;
                                                if (typeof (response.data) === 'string' && response.data.toLowerCase() === 'succeeded') {
                                                    isExceptionFound_1 = false;
                                                }
                                            }
                                            if (apiName_1 === 'province' && !response.data.provinceCode && appName === 'PPC') {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'downgradeFee') {
                                                if (response.data && response.data.earlyCancellationDetail && response.data.earlyCancellationDetail.penaltyAmount) {
                                                    isExceptionFound_1 = true;
                                                    if (appName === 'HUP') {
                                                        if (userType === 'care' || userType === 'dealer') {
                                                            translateKey_1 = 'downgrade_fee';
                                                        }
                                                        else {
                                                            isExceptionFound_1 = false;
                                                        }
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'overCLMLimit') {
                                                if (response.data.overLimit) {
                                                    translateKey_1 = 'ppc_plan_change_error';
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'add-all' && response.data) {
                                                Object.keys(response.data).forEach(function (key, idx) {
                                                    if ((!response.data[key].success) || (response.data[key].errorCode) || (response.data[key].errorMessage)) {
                                                        isExceptionFound_1 = true;
                                                    }
                                                });
                                            }
                                            if (apiName_1 === 'payment-options') {
                                                if (response.data && response.data.displayPaymentScreen) {
                                                    if (response.data.msfExceedsCLMLimit) {
                                                        translateKey_1 = 'checkout_order_review_msg';
                                                        isExceptionFound_1 = true;
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'fetch') {
                                                if (response.data && !response.data.success) {
                                                    isExceptionFound_1 = true;
                                                }
                                                if (response.data && response.data.success && !(response.data.ppc && response.data.ppc.length)) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'fetch-validated-cart') {
                                                if (response.data && !response.data.success) {
                                                    isExceptionFound_1 = true;
                                                }
                                                if (response.data && !(response.data.ppc && response.data.ppc.length)) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'compatible') {
                                                var addonFlag = false;
                                                if (analyticsInfo.url && /addons/.test(analyticsInfo.url)) {
                                                    addonFlag = true;
                                                }
                                                if (!addonFlag) {
                                                    if (response.data && !(response.data.planList && response.data.planList.length)) {
                                                        isExceptionFound_1 = true;
                                                        if (currentStateName_1 === 'app.mppc.step2') {
                                                            translateKey_1 = 'mppc.common.on_brt_no_permission_text';
                                                        }
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'callingOptions' && (userType === 'care' || userType === 'dealer')) {
                                                if (!(response.data.pricePlansCallingOptionsMap && !_.isEmpty(response.data.pricePlansCallingOptionsMap))) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'checkSharedIntegrity' && response.data.conflicts) {
                                                if (appName === 'HUP') {
                                                    isExceptionFound_1 = true;
                                                    translateKey_1 = 'hup_conflicts_error_message';
                                                }
                                            }
                                            if (apiName_1 === 'discount' && appName === 'PPC' && !response.data.discounts) {
                                                isExceptionFound_1 = true;
                                            }
                                            if (apiName_1 === 'billingDetails') {
                                                if ((userType === 'dealer' || userType === 'care') && !response.data.nextBillCycleStartDate) {
                                                    isExceptionFound_1 = true;
                                                }
                                                else if (!response.data.currentBillCycleStartDate || !response.data.currentBillCycleEndDate) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'getProratedCharges' && (userType === 'care' || userType === 'dealer')) {
                                                Object.keys(response.data).forEach(function (key, idx) {
                                                    if (response.data[key].status && response.data[key].status.toLowerCase() !== 'success') {
                                                        isExceptionFound_1 = true;
                                                    }
                                                });
                                            }
                                            if (apiName_1 === 'updateOrderInfo') {
                                                if (!response.data.success) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            if (apiName_1 === 'deviceBalance') {
                                                var errorCode_2 = '';
                                                if (appName === 'HUP') {
                                                    if (!response.data.getHupEligibilityResult) {
                                                        isExceptionFound_1 = true;
                                                    }
                                                    if (response.data.errorCode && response.data.errorCode.toUpperCase() === 'HNA') {
                                                        isExceptionFound_1 = true;
                                                        errorCode_2 = response.data.errorCode;
                                                    }
                                                    if (response.data.getHupEligibilityResult && response.data.getHupEligibilityResult.isHupEligibilityError) {
                                                        isExceptionFound_1 = true;
                                                        if (response.data.getHupEligibilityResult.hupErrorCode) {
                                                            errorCode_2 = response.data.getHupEligibilityResult.hupErrorCode;
                                                        }
                                                    }
                                                    if (userType === 'care' && errorCode_2 && isExceptionFound_1) {
                                                        translateKey_1 = errorCode_2.toLowerCase() + '_care';
                                                    }
                                                    else if (userType === 'dealer' && errorCode_2 && isExceptionFound_1) {
                                                        translateKey_1 = errorCode_2.toLowerCase() + '_retail';
                                                    }
                                                    else if (isExceptionFound_1 && errorCode_2 && errorCode_2 !== '') {
                                                        _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                            if (key === errorCode_2.toUpperCase()) {
                                                                translateKey_1 = value;
                                                                return false;
                                                            }
                                                        });
                                                    }
                                                }
                                                if (appName === 'PPC') {
                                                    if (typeof (response.data.getCurrentSubsidyResponseVO) === 'undefined' || !response.data.getCurrentSubsidyResponseVO || response.data.getCurrentSubsidyResponseVO.status.toLowerCase() !== 'success') {
                                                        isExceptionFound_1 = true;
                                                    }
                                                }
                                            }
                                            //care
                                            if (apiName_1 === 'save-order') {
                                                if (!response.data.success) {
                                                    isExceptionFound_1 = true;
                                                }
                                            }
                                            //Selfserve
                                            if (apiName_1 === 'getWinAvailableInvoices') {
                                                if (!appName) {
                                                    if (response.data.status !== 'success') {
                                                        if (response.data.errorCode === '35001' || response.data.errorCode === '35000' || response.data.errorMessage === 'No invoice available' || response.data.errorMessage === 'Account does not exist') {
                                                            isExceptionFound_1 = false;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            if (response && response.data && response.data.status && (response.data.status.code || response.data.status.codeName)) {
                                                if (apiName_1 === 'create' && response.data.status.code) {
                                                    _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                        if (Number(key) === Number(response.data.status.code)) {
                                                            translateKey_1 = value;
                                                            return false;
                                                        }
                                                    });
                                                }
                                            }
                                            if (apiName_1 === 'searchCustomer') {
                                                if (response && response.data) {
                                                    if (response.data.customerExistsInd && response.data.customerExistsInd === true) {
                                                        if (userType === 'dealer' || userType === 'care') {
                                                            translateKey_1 = 'existingCustomer_error';
                                                        }
                                                        else {
                                                            translateKey_1 = 'checkout_duplicate_account_error_msg_section_1';
                                                        }
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'checkCreditAssessment') {
                                                if (response && response.data) {
                                                    if (response.data.fraudInd && response.data.fraudInd === true) {
                                                        translateKey_1 = 'checkout_appears_problem_with_information_entered_please_call_number_below';
                                                        isExceptionFound_1 = true;
                                                    }
                                                    else if ((response.data.alertInd && response.data.alertInd === true) || (response.data.riskClassCategory && response.data.riskClassCategory === 'DECL')) {
                                                        translateKey_1 = 'checkout_creditcheck_common_fail';
                                                        isExceptionFound_1 = true;
                                                    }
                                                    else if (response.data.errorCode) {
                                                        _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                            if (Number(key) === Number(response.data.errorCode)) {
                                                                translateKey_1 = value;
                                                                return false;
                                                            }
                                                        });
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'brtSwitches') {
                                                if (response.data && response.data.errorCode) {
                                                    if (statusCode_1 === 555) {
                                                        translateKey_1 = response.data.errorCode;
                                                    }
                                                    else {
                                                        translateKey_1 = 'error_get_permissions';
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'check') {
                                                if (response.data && response.data.errorCode) {
                                                    if (statusCode_1 === 555) {
                                                        translateKey_1 = response.data.errorCode;
                                                    }
                                                    else {
                                                        translateKey_1 = 'maintenance_info';
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'submit-order') {
                                                var errorCode_3 = -1;
                                                if (response.data && response.data.errorCode === 1555) {
                                                    errorCode_3 = response.data.errorCode;
                                                }
                                                else {
                                                    if (_this.$stateParams && _this.$stateParams.creditCardPaymentObj) {
                                                        errorCode_3 = 1666;
                                                    }
                                                    else {
                                                        errorCode_3 = 1777;
                                                    }
                                                }
                                                if (errorCode_3 && errorCode_3 !== -1) {
                                                    _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                        if (Number(key) === Number(errorCode_3)) {
                                                            translateKey_1 = value;
                                                            return false;
                                                        }
                                                    });
                                                }
                                            }
                                            if (apiName_1 === 'checkNfdb') {
                                                translateKey_1 = 'checkout_server_error_title';
                                            }
                                            //PPC calls
                                            if (apiName_1 === 'eligibility') {
                                                if (!response || !response.data) {
                                                    if (appName === 'PPC') {
                                                        translateKey_1 = 'ppc_something_went_wrong_message_title';
                                                    }
                                                }
                                                if (appName === 'HUP') {
                                                    translateKey_1 = 'hup_generic_error_message';
                                                }
                                            }
                                            if (apiName_1 === 'downgradeFee' && appName !== 'HUP') {
                                                translateKey_1 = 'ppc_something_went_wrong_message_title';
                                            }
                                            if (apiName_1 === 'checkCreditLimit') {
                                                if (!response || !response.data) {
                                                    translateKey_1 = 'ppc_something_went_wrong_message_title';
                                                }
                                            }
                                            if (apiName_1 === 'deviceBalance' && appName === 'HUP') {
                                                if (response && response.data && response.data.errorCode) {
                                                    _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                        if (key === response.data.errorCode.toUpperCase()) {
                                                            translateKey_1 = value;
                                                            return false;
                                                        }
                                                    });
                                                }
                                            }
                                            //Selfserve
                                            if (apiName_1 === 'accountoverview') {
                                                if (!appName) {
                                                    _.forOwn(errorTrackingAPI.errorsMap, function (value, key) {
                                                        if (key === response.data.errorCode.toUpperCase()) {
                                                            translateKey_1 = value;
                                                            return false;
                                                        }
                                                    });
                                                    if (response.refresh && response.refresh === true) {
                                                        isExceptionFound_1 = true;
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'activatedUserSummary') {
                                                if (!appName) {
                                                    if (response.status === 400 || response.status === 403 || response.status === 404) {
                                                        //to restrict the tracking of the call
                                                        successFlag = true;
                                                        isExceptionFound_1 = false;
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'epost') {
                                                if (!appName) {
                                                    if (!response || !response.data) {
                                                        isExceptionFound_1 = true;
                                                    }
                                                }
                                            }
                                            if (apiName_1 === 'getWinAvailableInvoices') {
                                                if (!appName) {
                                                    if (!response || !response.data) {
                                                        isExceptionFound_1 = true;
                                                    }
                                                }
                                            }
                                        }
                                        return _this.initiateAnalyticsAccountDetails().then(function (initiateAccountInfo) {
                                            if (initiateAccountInfo) {
                                                return _this.getAccountInfo().then(function (accountInfo) {
                                                    if (accountInfo.userName) {
                                                        _this.payload.account = accountInfo;
                                                    }
                                                    return _this.getSerialNumber().then(function (serialID) {
                                                        var flowType = _this.utePersistentStorageService.getFromSession('flowType');
                                                        if (flowType === 'Selfserve') {
                                                            _this.payload.site.sessionID = serialID;
                                                            _this.payload.buyflow = undefined;
                                                        }
                                                        else {
                                                            _this.payload.buyflow.serial = serialID;
                                                        }
                                                        if (_.has(_this.dataLayerService.returnConfig(), 'advance.configOptions.appName') && _this.payload.buyflow) {
                                                            _this.payload.buyflow.name = _this.dataLayerService.returnConfig().advance.configOptions.appName;
                                                        }
                                                        return _this.initiateAnalyticsSelectedSections(false).then(function (selectedSections) {
                                                            if (selectedSections) {
                                                                var filter_1 = _this.$filter;
                                                                var initiateAnalyticsTrackingFn_1 = _this.initiateAnalyticsTracking;
                                                                var delegatedPayload_1 = _this.payload;
                                                                if (translateServiceProvided_1) {
                                                                    var translatedContent = _this.customTranslateService.get(translateKey_1);
                                                                    if (translatedContent === '' || !translatedContent) {
                                                                        if (_this.dataLayerService.returnConfig().advance.defaultAPIErrorMessageContent) {
                                                                            translatedContent = _this.dataLayerService.returnConfig().advance.defaultAPIErrorMessageContent;
                                                                        }
                                                                    }
                                                                    return initiateAnalyticsTrackingFn_1(uteRequestId_1, delegatedPayload_1, response, isExceptionFound_1, statusMessage_1, statusCode_1, statusText_1, filter_1('uteDataIntegrationLayerHTMLToText')(translatedContent), accountInfo, apiName_1, selectedSections, successFlag).then(function (response) {
                                                                        return response;
                                                                    });
                                                                }
                                                                else {
                                                                    return _this.$translate(translateKey_1).then(function (translation) {
                                                                        return initiateAnalyticsTrackingFn_1(uteRequestId_1, delegatedPayload_1, response, isExceptionFound_1, statusMessage_1, statusCode_1, statusText_1, filter_1('uteDataIntegrationLayerHTMLToText')(translation), accountInfo, apiName_1, selectedSections, successFlag).then(function (response) {
                                                                            return response;
                                                                        });
                                                                    }, function (translationKey) {
                                                                        return initiateAnalyticsTrackingFn_1(uteRequestId_1, delegatedPayload_1, response, isExceptionFound_1, statusMessage_1, statusCode_1, statusText_1, filter_1('uteDataIntegrationLayerHTMLToText')(translationKey), accountInfo, apiName_1, selectedSections, successFlag).then(function (response) {
                                                                            return response;
                                                                        });
                                                                    });
                                                                }
                                                            }
                                                        });
                                                    });
                                                });
                                            }
                                        });
                                    }
                                    catch (e) {
                                        console.error('API :: completely success response' + e);
                                    }
                                };
                                /**
                                 * @description To track the search events.
                                 * @param searchKeyword: string,
                                 * resultCount: number,
                                 * filterName: string,
                                 */
                                this.initiateSearchAnalytics = function (searchKeyword, resultCount, filterName, searchType) {
                                    _this.payload = {};
                                    var search = {};
                                    var events = {};
                                    var filters = [];
                                    var filter = {};
                                    var page = {};
                                    if (searchKeyword) {
                                        search.keyword = searchKeyword.toLowerCase();
                                        search.type = searchType;
                                        search.resultCount = resultCount;
                                        _this.payload.search = search;
                                        if (!filterName) {
                                            events.search = true;
                                        }
                                    }
                                    if (filterName) {
                                        filter.name = filterName.toLowerCase();
                                        filter.type = 'dropdown';
                                        filters.push(filter);
                                        _this.payload.search.filters = filters;
                                        _this.payload.search.type = searchType;
                                        events.searchFilterAdd = true;
                                    }
                                    _this.payload.events = events;
                                    page = _this.dataLayerService.getPageHierarchy();
                                    if (page) {
                                        _this.payload.page = page;
                                    }
                                    return _this.getSerialNumber().then(function (serialID) {
                                        var flowType = _this.utePersistentStorageService.getFromSession('flowType');
                                        if (flowType === 'Selfserve') {
                                            _this.payload.site = {};
                                            _this.payload.site.sessionID = serialID;
                                        }
                                        else {
                                            _this.payload.buyflow = {};
                                            _this.payload.buyflow.serial = serialID;
                                        }
                                        if (_.has(_this.dataLayerService.returnConfig(), 'advance.configOptions.appName') && _this.payload.buyflow) {
                                            _this.payload.buyflow.name = _this.dataLayerService.returnConfig().advance.configOptions.appName;
                                        }
                                        return _this.initiateAnalyticsAccountDetails().then(function (response) {
                                            if (response) {
                                                return _this.getAccountInfo().then(function (accountInfo) {
                                                    if (accountInfo.userName) {
                                                        _this.payload.account = accountInfo;
                                                    }
                                                    return _this.initiateAnalyticsSelectedSections(false).then(function (selectedSections) {
                                                        _this.dataLayerService.track(_this.payload, false, selectedSections);
                                                        return true;
                                                    });
                                                });
                                            }
                                        });
                                    });
                                };
                                /**
                                 * @description To track the site interaction events.
                                 * @param type: string,
                                 * name: string,
                                 */
                                this.initiateSiteInteractionAnalytics = function (type, name) {
                                    var page = {};
                                    _this.payload = {
                                        interaction: {
                                            type: type,
                                            name: name
                                        },
                                        events: {
                                            interaction: true
                                        }
                                    };
                                    page = _this.dataLayerService.getPageHierarchy();
                                    if (page) {
                                        _this.payload.page = page;
                                    }
                                    return _this.getSerialNumber().then(function (serialID) {
                                        var flowType = _this.utePersistentStorageService.getFromSession('flowType');
                                        if (flowType === 'Selfserve') {
                                            _this.payload.site = {};
                                            _this.payload.site.sessionID = serialID;
                                        }
                                        else {
                                            _this.payload.buyflow = {};
                                            _this.payload.buyflow.serial = serialID;
                                        }
                                        if (_.has(_this.dataLayerService.returnConfig(), 'advance.configOptions.appName') && _this.payload.buyflow) {
                                            _this.payload.buyflow.name = _this.dataLayerService.returnConfig().advance.configOptions.appName;
                                        }
                                        return _this.initiateAnalyticsAccountDetails().then(function (response) {
                                            if (response) {
                                                return _this.getAccountInfo().then(function (accountInfo) {
                                                    if (accountInfo.userName) {
                                                        _this.payload.account = accountInfo;
                                                    }
                                                    return _this.initiateAnalyticsSelectedSections(false).then(function (selectedSections) {
                                                        _this.dataLayerService.track(_this.payload, false, selectedSections);
                                                        return true;
                                                    });
                                                });
                                            }
                                        });
                                    });
                                };
                                /**
                                 * @description To track the remove/edit events.
                                 * @param mappingKey: any,
                                 * toStateName: string,
                                 * removeCartEvent: boolean,
                                 */
                                this.initiateRemoveAnalyticsEvent = function (mappingKey, toStateName, removeCartEvent, index) {
                                    var editPayload = {
                                        events: {
                                            removeFromCart: true
                                        }
                                    };
                                    var currentTabsObject;
                                    var payloadData;
                                    var payload_cb = _this.dataLayerService.getCallbackByKey('payload');
                                    if (payload_cb) {
                                        var payloadObj_1;
                                        return payload_cb.callback(toStateName, removeCartEvent).then(function (response) {
                                            currentTabsObject = _this.utePersistentStorageService.getFromSession('currentTabsObj');
                                            payloadObj_1 = response;
                                            if (index >= 0 && typeof (index) !== 'undefined') {
                                                payloadObj_1.ecommerce.products = [];
                                                angular.forEach(currentTabsObject[index], function (tabObject) {
                                                    if (!Array.isArray(tabObject)) {
                                                        var obj = {};
                                                        obj.name = tabObject.name;
                                                        obj.ID = tabObject.ID;
                                                        obj.subCategory = tabObject.subCategory;
                                                        obj.category = 'wireless';
                                                        obj.findingMethod = tabObject.findingMethod;
                                                        if (tabObject.subCategory === 'device') {
                                                            obj.manufacturer = tabObject.manufacturer;
                                                            obj.model = tabObject.model;
                                                        }
                                                        payloadObj_1.ecommerce.products.push(obj);
                                                    }
                                                    else if (Array.isArray(tabObject) && tabObject.length !== 0) {
                                                        angular.forEach(tabObject, function (addons) {
                                                            payloadObj_1.ecommerce.products.push(addons);
                                                        });
                                                    }
                                                });
                                            }
                                            payloadData = _.merge(editPayload, payloadObj_1);
                                            return _this.initiateAnalyticsAccountDetails().then(function (response) {
                                                if (response) {
                                                    return _this.getAccountInfo().then(function (accountInfo) {
                                                        if (accountInfo.userName) {
                                                            _this.payload.account = accountInfo;
                                                        }
                                                        return _this.initiateAnalyticsSelectedSections(false).then(function (selectedSections) {
                                                            _this.dataLayerService.track(payloadData, false, selectedSections, mappingKey);
                                                            return _this.$q.when(true);
                                                        });
                                                    });
                                                }
                                            });
                                        });
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To track the modal popups events.
                                 * @param modalName: string,
                                 */
                                this.initiateModalAnalyticsEvent = function (modalName) {
                                    try {
                                        _this.payload = {};
                                        var mappingKey_1 = {
                                            'mappingKey': modalName
                                        };
                                        return _this.getSerialNumber().then(function (serialID) {
                                            var flowType = _this.utePersistentStorageService.getFromSession('flowType');
                                            if (flowType === 'Selfserve') {
                                                _this.payload.site = {};
                                                _this.payload.site.sessionID = serialID;
                                            }
                                            else {
                                                _this.payload.buyflow = {};
                                                _this.payload.buyflow.serial = serialID;
                                            }
                                            if (_.has(_this.dataLayerService.returnConfig(), 'advance.configOptions.appName') && _this.payload.buyflow) {
                                                _this.payload.buyflow.name = _this.dataLayerService.returnConfig().advance.configOptions.appName;
                                            }
                                            return _this.initiateAnalyticsAccountDetails().then(function (response) {
                                                if (response) {
                                                    return _this.getAccountInfo().then(function (accountInfo) {
                                                        if (accountInfo.userName) {
                                                            _this.payload.account = accountInfo;
                                                        }
                                                        return _this.initiateAnalyticsSelectedSections(true).then(function (selectedSections) {
                                                            _this.dataLayerService.track(_this.payload, true, selectedSections, mappingKey_1);
                                                            return _this.$q.when(true);
                                                        });
                                                    });
                                                }
                                            });
                                        });
                                    }
                                    catch (error) {
                                        console.error('ADL error while triggering modal tracking : ', error);
                                    }
                                    return _this.$q.when(false);
                                };
                                /**
                                 * @description To track the form events.
                                 * @param formName: string,
                                 * isFormView: boolean,
                                 * mappingKey: any,
                                 */
                                this.initiateFormAnalytics = function (formName, isFormView, mappingKey, stateName) {
                                    var mapping;
                                    var selectedSections = [
                                        DataLayerPredefinedSection.ACCOUNT,
                                        DataLayerPredefinedSection.PAGE,
                                        DataLayerPredefinedSection.SITE
                                    ];
                                    _this.payload = {
                                        buyflow: {},
                                        form: {
                                            name: formName
                                        },
                                        events: {}
                                    };
                                    var events = {};
                                    if (isFormView) {
                                        events.formView = true;
                                        _this.payload.events = events;
                                    }
                                    if (mappingKey) {
                                        mapping = {
                                            mappingKey: mappingKey
                                        };
                                    }
                                    return _this.getEventPayload(_this.payload, stateName).then(function (payload) {
                                        _this.dataLayerService.track(payload, false, selectedSections, mapping);
                                        return true;
                                    });
                                };
                                /**
                                 * @description To track the form field error events.
                                 * @param formFieldName: string,
                                 * formFieldErrorMessage: string,
                                 * isModalPopup: boolean,
                                 * mappingKey: string,
                                 */
                                this.initiateFormFieldErrorAnalytics = function (formFieldName, formFieldErrorMessage, isModalPopup, mappingKey) {
                                    if (formFieldName && formFieldErrorMessage) {
                                        var errorPayload_1 = {};
                                        var mapping_1 = {
                                            'mappingKey': mappingKey
                                        };
                                        return _this.getSerialNumber().then(function (serialID) {
                                            var flowType = _this.utePersistentStorageService.getFromSession('flowType');
                                            if (flowType === 'Selfserve') {
                                                errorPayload_1.site = {};
                                                errorPayload_1.site.sessionID = serialID;
                                            }
                                            else {
                                                errorPayload_1.buyflow = {};
                                                errorPayload_1.buyflow.serial = serialID;
                                            }
                                            if (_.has(_this.dataLayerService.returnConfig(), 'advance.configOptions.appName') && errorPayload_1.buyflow) {
                                                errorPayload_1.buyflow.name = _this.dataLayerService.returnConfig().advance.configOptions.appName;
                                            }
                                            return _this.initiateAnalyticsSelectedSections(false).then(function (selectedSections) {
                                                _this.dataLayerService.trackFormError(errorPayload_1 || {}, formFieldErrorMessage, formFieldName || '', isModalPopup, selectedSections, mapping_1);
                                                return true;
                                            });
                                        });
                                    }
                                };
                                /**
                                 * @description To populate the account details.
                                 */
                                this.initiateAnalyticsAccountDetails = function () {
                                    var defer = _this.$q.defer();
                                    _this.account = {};
                                    defer.resolve(true);
                                    return defer.promise;
                                };
                                /**
                                 * @description To populate the selected section details.
                                 * @param isModalPopup: boolean,
                                 */
                                this.initiateAnalyticsSelectedSections = function (isModalPopup) {
                                    var defer = _this.$q.defer();
                                    var parentSelectedSections = DataLayerPredefinedSection;
                                    var selectedSections;
                                    if (isModalPopup === true) {
                                        selectedSections = [parentSelectedSections.SITE, parentSelectedSections.PAGE, parentSelectedSections.ACCOUNT, parentSelectedSections.PAGE_VIEW_EVENT];
                                    }
                                    else {
                                        selectedSections = [parentSelectedSections.SITE, parentSelectedSections.PAGE, parentSelectedSections.ACCOUNT];
                                    }
                                    defer.resolve(selectedSections);
                                    return defer.promise;
                                };
                                /**
                                 * @description Util method to track the API errors events.
                                 * @param delegatedPayload?: IPayload,
                                 * response?: any,
                                 * isExceptionFound?: boolean,
                                 * statusMessage?: string,
                                 * statusCode?: string,
                                 * statusText?: string,
                                 * translation?: string,
                                 * accountInfo?: any, apiName?: string,
                                 * selectedSections?: any,
                                 * successFlag?: boolean,
                                 */
                                this.initiateAnalyticsTracking = function (uteRequestId, delegatedPayload, response, isExceptionFound, statusMessage, statusCode, statusText, translation, accountInfo, apiName, selectedSections, successFlag) {
                                    var defer = _this.$q.defer();
                                    var page = {};
                                    statusMessage = (statusCode ? statusCode : 'Unknown') + ' - ' + (statusText ? statusText : 'Unknown') + ' - ' + translation;
                                    if (response && response.data && (response.data.errorCode || response.data.errorMessage)) {
                                        statusMessage = statusMessage + ' - ' + (response.data.errorCode ? response.data.errorCode : 'Unknown') + ' - ' + (response.data.errorMessage ? response.data.errorMessage : 'Unknown');
                                    }
                                    if (response && response.data && response.data.status && response.data.status.code) {
                                        statusMessage = statusMessage + ' - ' + (response.data.status.code ? response.data.status.code : 'Unknown') + ' - ' + (response.data.status.codeName ? response.data.status.codeName : 'Unknown');
                                    }
                                    if (response && response.data && response.data.error) {
                                        statusMessage = statusMessage + ' - ' + (response.data.error.errorCode ? response.data.error.errorCode : 'Unknown') + ' - ' + (response.data.error.errorMessageEn ? response.data.error.errorMessageEn : 'Unknown');
                                    }
                                    if (apiName === 'add-all' && response.data) {
                                        Object.keys(response.data).forEach(function (key, idx) {
                                            if ((response.data[key].errorCode) || (response.data[key].errorMessage)) {
                                                statusMessage = statusMessage + ' - ' + (response.data[key].errorCode ? response.data[key].errorCode : 'Unknown') + ' - ' + (response.data[key].errorMessage ? response.data[key].errorMessage : 'Unknown');
                                            }
                                        });
                                    }
                                    if (statusCode === '-1') {
                                        statusCode = 'Unknown';
                                        statusMessage = 'Unknown';
                                    }
                                    _this.payload = {
                                        errors: [
                                            {
                                                requestID: uteRequestId,
                                                type: 'http',
                                                category: _this.utePersistentStorageService.getFromSession('flowType') === 'Selfserve' ? 'Selfserve' : 'buyflow',
                                                message: statusMessage,
                                                code: statusCode,
                                                API: apiName
                                            }
                                        ],
                                        events: {
                                            error: true
                                        }
                                    };
                                    if (delegatedPayload) {
                                        _this.payload = _.merge(_this.payload, delegatedPayload);
                                    }
                                    page = _this.dataLayerService.getPageHierarchy();
                                    if (page) {
                                        _this.payload.page = page;
                                    }
                                    if (accountInfo.userName) {
                                        _this.payload.account = accountInfo;
                                    }
                                    if (!successFlag) {
                                        _this.dataLayerService.track(_this.payload, false, selectedSections);
                                    }
                                    else if (isExceptionFound) {
                                        _this.dataLayerService.track(_this.payload, false, selectedSections);
                                    }
                                    else {
                                        console.log(apiName + ':: completely success response');
                                    }
                                    defer.resolve(true);
                                    return defer.promise;
                                };
                                /**
                                 * @description To get the account information.
                                 */
                                this.getAccountInfo = function () {
                                    var defer = _this.$q.defer();
                                    defer.resolve(_this.account);
                                    return defer.promise;
                                };
                                /**
                                 * @description To set the device product object.
                                 */
                                this.setDeviceProductObject = function (deviceProduct, deviceSku, isPhoneObject, phoneObject, modelName, manufacturer, findingMethod, CTN) {
                                    var deviceProductObject = {};
                                    try {
                                        deviceProductObject.category = 'wireless';
                                        deviceProductObject.subCategory = 'device';
                                        deviceProductObject.quantity = 1;
                                        deviceProductObject.findingMethod = findingMethod ? findingMethod : _this.getFindingMethod();
                                        deviceProductObject.ID = deviceSku;
                                        if (manufacturer) {
                                            deviceProductObject.manufacturer = manufacturer;
                                        }
                                        if (modelName && modelName[_this.lang_upper]) {
                                            deviceProductObject.model = modelName[_this.lang_upper];
                                        }
                                        if (deviceProduct && !isPhoneObject) {
                                            var skus = deviceProduct.skusByMemory;
                                            _.forEach(skus, function (sku) {
                                                var phone = sku.wirelessSKUMap.find(function (i) {
                                                    return i.externalId === deviceSku;
                                                });
                                                if (phone) {
                                                    deviceProductObject.name = phone.displayName[_this.lang_upper];
                                                }
                                            });
                                        }
                                        else if (isPhoneObject && phoneObject) {
                                            deviceProductObject.name = phoneObject.displayName[_this.lang_upper];
                                        }
                                        // for HUP flow
                                        deviceProductObject.CTN = CTN ? CTN : null;
                                        _this.utePersistentStorageService.putToSession('phoneProduct', deviceProductObject);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Phone Product : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                this.getEcommerceObject = function (state, removeCartEvent) {
                                    var returnObject = [];
                                    var flowName = _this.utePersistentStorageService.getFromSession('flowName');
                                    var flowType = _this.utePersistentStorageService.getFromSession('flowType');
                                    if (flowName === 'multiline') {
                                        return _this.getCurrentTabsObj(state, removeCartEvent).then(function (multiLineProducts) {
                                            if (multiLineProducts && multiLineProducts.length > 0) {
                                                _.forEach(multiLineProducts, function (multiLineProduct) {
                                                    if (multiLineProduct) {
                                                        if (multiLineProduct.device) {
                                                            if (flowType === 'HUP' && ((removeCartEvent && (state === 'choose-phone' || state === 'compare-devices')) || (!removeCartEvent && state !== 'choose-phone' && state !== 'compare-devices'))) {
                                                                returnObject.push(multiLineProduct.device);
                                                            }
                                                            else if (flowType === 'NAC') {
                                                                returnObject.push(multiLineProduct.device);
                                                            }
                                                        }
                                                        if (multiLineProduct.plan) {
                                                            if (flowType === 'HUP' && ((removeCartEvent && (state === 'choose-phone' || state === 'compare-devices' || state === 'build-plan')) || (!removeCartEvent && state !== 'choose-phone' && state !== 'compare-devices' && state !== 'build-plan'))) {
                                                                returnObject.push(multiLineProduct.plan);
                                                            }
                                                            else if (flowType === 'NAC' || flowType === 'PPC') {
                                                                returnObject.push(multiLineProduct.plan);
                                                            }
                                                        }
                                                        if (multiLineProduct.addons) {
                                                            if (flowType === 'HUP' && ((removeCartEvent && (state === 'choose-phone' || state === 'compare-devices' || state === 'build-plan' || state === 'additional-line-options' || state === 'manage-add-ons' || state === 'choose-add-ons')) || (!removeCartEvent && state !== 'choose-phone' && state !== 'compare-devices' && state !== 'build-plan' && state !== 'additional-line-options' && state !== 'manage-add-ons' && state !== 'choose-add-ons'))) {
                                                                returnObject = returnObject.concat(multiLineProduct.addons);
                                                            }
                                                            else if (flowType === 'NAC') {
                                                                returnObject = returnObject.concat(multiLineProduct.addons);
                                                            }
                                                            else if (flowType === 'PPC' && ((removeCartEvent && (state === 'app.mppc.edit-plan' || state === 'app.mppc.edit')) || (!removeCartEvent && state !== 'app.mppc.step1' && state !== 'app.mppc.step2' && state !== 'app.mppc.step3' && state !== 'app.mppc.step4'))) {
                                                                returnObject = returnObject.concat(multiLineProduct.addons);
                                                            }
                                                        }
                                                    }
                                                });
                                                return returnObject;
                                            }
                                        });
                                    }
                                    else {
                                        var deviceProduct_promise = _this.getDeviceProductObject(state, removeCartEvent);
                                        var planProduct_promise = _this.getPlanProductObject(state, removeCartEvent);
                                        var addonsProduct_promise = _this.getAddonProductArray(state, removeCartEvent);
                                        return _this.$q.all([deviceProduct_promise, planProduct_promise, addonsProduct_promise]).then(function (resolvedValues) {
                                            var device = resolvedValues[0];
                                            var plan = resolvedValues[1];
                                            var addons = resolvedValues[2];
                                            if (device) {
                                                returnObject.push(device);
                                            }
                                            if (plan) {
                                                returnObject.push(plan);
                                            }
                                            if (addons && addons.length > 0) {
                                                returnObject = returnObject.concat(addons);
                                            }
                                            return returnObject;
                                        });
                                    }
                                };
                                /**
                                 * @description To get the device product object.
                                 */
                                this.getDeviceProductObject = function (state, removeCartEvent) {
                                    var returnObject;
                                    try {
                                        if ((removeCartEvent && (state === 'choose-phone' || state === 'deviceCatalog' || state === 'compare-devices')) || (!removeCartEvent && state !== 'deviceCatalog' && state !== 'choose-phone' && state !== 'compare-devices')) {
                                            returnObject = _this.utePersistentStorageService.getFromSession('phoneProduct');
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Phone Product : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the plan product object.
                                 */
                                this.setPlanProductObject = function (id, name, msf, keepPlan, previousRevenue, findingMethod, CTN) {
                                    try {
                                        var planProductObject = {};
                                        var planName = null;
                                        planProductObject.category = 'wireless';
                                        planProductObject.subCategory = 'plan';
                                        planProductObject.quantity = 1;
                                        planProductObject.findingMethod = findingMethod ? findingMethod : _this.getFindingMethod();
                                        planProductObject.ID = id;
                                        if (name) {
                                            if (_.has(name, _this.lang_upper)) {
                                                planName = name[_this.lang_upper];
                                            }
                                            else if (_.has(name, _this.lang_lower)) {
                                                planName = name[_this.lang_lower];
                                            }
                                        }
                                        planProductObject.name = planName;
                                        planProductObject.MSF = msf;
                                        planProductObject.keepPlan = keepPlan;
                                        if (previousRevenue) {
                                            // For PPC flow
                                            planProductObject.previousRevenue = previousRevenue;
                                        }
                                        // for PPC, HUP flow
                                        planProductObject.CTN = CTN ? CTN : null;
                                        _this.utePersistentStorageService.putToSession('planProduct', planProductObject);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Plan Product : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the plan product object.
                                 */
                                this.getPlanProductObject = function (state, removeCartEvent) {
                                    var returnObject;
                                    try {
                                        if ((removeCartEvent && (state === 'choose-phone' || state === 'build-plan' || state === 'deviceCatalog' || state === 'deviceConfigure' || state === 'app.mppc.edit-plan' || state === 'compare-devices' || state === 'app.ppc' || state === 'app.mppc.edit-add-ons')) || (!removeCartEvent && state !== 'deviceCatalog' && state !== 'deviceConfigure' && state !== 'choose-phone' && state !== 'build-plan' && state !== 'app.mppc.edit-plan' && state !== 'app.ppc' && state !== 'app.mppc.edit-add-ons' && state !== 'compare-devices')) {
                                            returnObject = _this.utePersistentStorageService.getFromSession('planProduct');
                                        }
                                        else if (_this.$previousState && _this.$previousState.get() && _this.$previousState.get().state && _this.$previousState.get().state.name && _this.$previousState.get().state.name === 'planCatalog') {
                                            returnObject = _this.utePersistentStorageService.getFromSession('planProduct');
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Plan Product : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the addon products object.
                                 */
                                this.setAddonProductArray = function (compatibleAddons, carryOverAddons, findingMethod, CTN) {
                                    try {
                                        var addonProductArray_1 = [];
                                        var selectedCompatibleAddons = angular.copy(compatibleAddons);
                                        var selectedCarryOverAddons = angular.copy(carryOverAddons);
                                        var addons = _.union(selectedCompatibleAddons, selectedCarryOverAddons);
                                        var language_lower_1 = _this.lang_lower;
                                        angular.forEach(addons, function (addon) {
                                            var addonProductObject = {};
                                            addonProductObject.category = 'wireless';
                                            addonProductObject.subCategory = 'addon';
                                            addonProductObject.quantity = 1;
                                            addonProductObject.findingMethod = findingMethod ? findingMethod : _this.getFindingMethod();
                                            addonProductObject.ID = addon.socNumber ? addon.socNumber : addon.addonSku;
                                            addonProductObject.name = addon[language_lower_1];
                                            addonProductObject.MSF = addon.addonCost;
                                            // for PPC, HUP flow
                                            addonProductObject.CTN = CTN ? CTN : null;
                                            addonProductArray_1.push(addonProductObject);
                                        });
                                        _this.utePersistentStorageService.putToSession('addonProductArray', addonProductArray_1);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Addon Product Array : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the addon products object.
                                 */
                                this.getAddonProductArray = function (state, removeCartEvent) {
                                    var returnObject = {};
                                    try {
                                        if ((removeCartEvent && (state === 'choose-phone' || state === 'build-plan' || state === 'add-ons' || state === 'choose-add-ons' || state === 'deviceCatalog' || state === 'deviceConfigure' || state === 'app.mppc.edit-plan' || state === 'compare-devices' || state === 'app.ppc' || state === 'app.mppc.edit-add-ons')) || (!removeCartEvent && state !== 'deviceCatalog' && state !== 'deviceConfigure' && state !== 'choose-add-ons' && state !== 'add-ons' && state !== 'choose-phone' && state !== 'build-plan' && state !== 'add-ons' && state !== 'app.mppc.edit-plan' && state !== 'app.ppc' && state !== 'app.mppc.edit-add-ons' && state !== 'compare-devices')) {
                                            returnObject = _this.utePersistentStorageService.getFromSession('addonProductArray');
                                        }
                                        else {
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Addon Product Array : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the checkout details object.
                                 */
                                this.setCheckoutDetailsObject = function (checkoutParameters) {
                                    try {
                                        var fees_1 = [];
                                        var checkoutDetailsObject = {};
                                        var monthlyTax = checkoutParameters.orderTotalPrice.orderTotalMonthlyTax;
                                        var onetimeTax = checkoutParameters.orderTotalPrice.orderTotalOnetimeTax;
                                        checkoutDetailsObject.tax = (monthlyTax.gstTaxAmount + monthlyTax.hstTaxAmount + monthlyTax.pstTaxAmount + monthlyTax.qstTaxAmount + monthlyTax.taxableAmount +
                                            onetimeTax.gstTaxAmount + onetimeTax.hstTaxAmount + onetimeTax.pstTaxAmount + onetimeTax.qstTaxAmount + onetimeTax.taxableAmount);
                                        if (checkoutDetailsObject.tax) {
                                            checkoutDetailsObject.tax = Number(checkoutDetailsObject.tax.toFixed(2));
                                        }
                                        checkoutDetailsObject.province = checkoutParameters.billingAddress.province.toLowerCase();
                                        checkoutDetailsObject.postalCode = checkoutParameters.billingAddress.postalCode;
                                        if (checkoutParameters.additionalFeeDetail) {
                                            _.forEach(checkoutParameters.additionalFeeDetail, function (n) {
                                                if (n.additionalFeeType && n.price) {
                                                    fees_1.push({
                                                        type: n.additionalFeeType,
                                                        amount: n.price.priceAmount
                                                    });
                                                }
                                            });
                                        }
                                        checkoutDetailsObject.fees = fees_1;
                                        checkoutDetailsObject.transactionID = checkoutParameters.wirelessOrderResponseHeader.transactionId;
                                        _this.utePersistentStorageService.putToSession('checkoutDetails', checkoutDetailsObject);
                                        _this.setReviewOrderPrices(checkoutParameters);
                                        // for TAZO flow
                                        if (_.isEmpty(_this.$previousState.get())) {
                                            _this.utePersistentStorageService.putToSession('isTAZOFlow', true);
                                            _this.setECommerceProductsForTAZO(checkoutParameters);
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Checkout Details : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the checkout details object.
                                 */
                                this.getCheckoutDetailsObject = function (state) {
                                    var returnObject = {};
                                    try {
                                        if (state === 'orderComplete') {
                                            returnObject = _this.utePersistentStorageService.getFromSession('checkoutDetails');
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Checkout Details : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the credit card type object.
                                 */
                                this.setCreditCardType = function (type) {
                                    try {
                                        var creditCardType = void 0;
                                        switch (type) {
                                            case 0:
                                                creditCardType = 'visa';
                                                break;
                                            case 1:
                                                creditCardType = 'mastercard';
                                                break;
                                            case 2:
                                                creditCardType = 'amex';
                                                break;
                                            default:
                                                creditCardType = 'invoice';
                                        }
                                        _this.utePersistentStorageService.putToSession('creditCardType', creditCardType);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the CreditCard Type : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the credit card type object.
                                 */
                                this.getCreditCardType = function () {
                                    var returnObject;
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('creditCardType');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the CreditCard Type : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the fulfillment method object.
                                 */
                                this.setFulfillmentMethod = function (method) {
                                    try {
                                        _this.utePersistentStorageService.putToSession('fulfillmentMethod', method);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Fulfillment Method : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the fulfillment method object.
                                 */
                                this.getFulfillmentMethod = function () {
                                    var returnObject;
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('fulfillmentMethod');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Fulfillment Method : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the serial number object.
                                 */
                                this.setSerialNumber = function (serialNo) {
                                    try {
                                        _this.utePersistentStorageService.putToSession('uniqueID', serialNo);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Serial Number : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the serial number object.
                                 */
                                this.getSerialNumber = function () {
                                    var returnObject;
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('uniqueID');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Serial Number : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the device charge price object.
                                 */
                                this.setDeviceChargePrice = function (devicePrice) {
                                    try {
                                        var deviceChargePrice = (devicePrice !== undefined) ? devicePrice : 0;
                                        _this.utePersistentStorageService.putToSession('wirelessDevicePrice', deviceChargePrice);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Device Price Object : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the device charge price object.
                                 */
                                this.getDeviceChargePrice = function () {
                                    var returnObject;
                                    try {
                                        returnObject = Number(_this.utePersistentStorageService.getFromSession('wirelessDevicePrice'));
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Device Price Object : ', error);
                                    }
                                    return returnObject;
                                };
                                /**
                                 * @description To set the selected subscriber number object.
                                 */
                                this.setSelectedSubscriberNumber = function (subscriberObj) {
                                    var currentSubscriberObj = {};
                                    try {
                                        currentSubscriberObj.CTN = subscriberObj.selectedCTN;
                                        _this.utePersistentStorageService.putToSession('selectedSubscriberNumber', currentSubscriberObj);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Current Subscriber Object : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the selected subscriber number object.
                                 */
                                this.getSelectedSubscriberNumber = function () {
                                    var returnObject = {};
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('selectedSubscriberNumber');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Current Subscriber Object : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the dealer info object.
                                 */
                                this.setDealerInfo = function (dealerInfoObj) {
                                    var currentDealerInfoObj = {};
                                    try {
                                        currentDealerInfoObj.dealerCode = dealerInfoObj.dealerCode;
                                        currentDealerInfoObj.dealerType = dealerInfoObj.dealerType;
                                        currentDealerInfoObj.userId = dealerInfoObj.userId;
                                        _this.utePersistentStorageService.putToSession('dealerInfo', currentDealerInfoObj);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Current dealer code Object : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the dealer info object.
                                 */
                                this.getDealerInfo = function () {
                                    var returnObject = {};
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('dealerInfo');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Current dealer code Object : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the compatible addons object.
                                 */
                                this.setCompatibleAddOns = function (compatibleAddOns) {
                                    var addOnsObject = {};
                                    try {
                                        addOnsObject = compatibleAddOns;
                                        _this.utePersistentStorageService.putToSession('compatibleAddons', addOnsObject);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the AddOns Object : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the compatible addons object.
                                 */
                                this.getCompatibleAddOns = function () {
                                    var returnObject = {};
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('compatibleAddons');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the AddOns Object : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the account information object.
                                 */
                                this.setUserAccountInfo = function (accountInfo) {
                                    var account = {};
                                    try {
                                        account.accountNumber = accountInfo.accountNumber;
                                        account.subscriberNumber = accountInfo.subscriberNumber;
                                        account.userName = accountInfo.userName;
                                        account.userType = accountInfo.userType;
                                        account.type = accountInfo.type;
                                        _this.utePersistentStorageService.putToSession('accountInfo', account);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Account Object : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the selected subscriber number object.
                                 */
                                this.getUserAccountInfo = function () {
                                    var returnObject = {};
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('accountInfo');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Account Object : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the current device object.
                                 */
                                this.setCurrentDeviceObj = function (deviceObj) {
                                    var currentDeviceObj = {};
                                    try {
                                        currentDeviceObj.device = deviceObj.phoneProductId;
                                        _this.utePersistentStorageService.putToSession('currentDevice', currentDeviceObj);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Current Device Object : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the current device object.
                                 */
                                this.getCurrentDeviceObj = function () {
                                    var returnObject = {};
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('currentDevice');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Current Device Object : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the current plan object.
                                 */
                                this.setCurrentPlanObj = function (planObj) {
                                    var currentPlanObj = {};
                                    try {
                                        currentPlanObj.plan = planObj.currentPlan;
                                        currentPlanObj.amount = planObj.currentPlanAmount;
                                        currentPlanObj.payoffDate = planObj.currentPlanPayoffDate;
                                        _this.utePersistentStorageService.putToSession('currentPlan', currentPlanObj);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Current Plan Object : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To create the tab feasible device object.
                                 */
                                this.getCurrentPlanObj = function () {
                                    var returnObject = {};
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('currentPlan');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Current Plan Object : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To create the tab feasible device object.
                                 */
                                this.createDeviceTabObject = function (deviceObject) {
                                    var returnObject = {};
                                    var flowType = _this.utePersistentStorageService.getFromSession('flowType');
                                    try {
                                        returnObject.device = deviceObject;
                                        returnObject.device.selectedModel = {
                                            displayName: {
                                                EN: deviceObject.name
                                            }
                                        };
                                        returnObject.device.displayName = {
                                            EN: deviceObject.model
                                        };
                                        if ('HUP' === flowType) {
                                            returnObject.device.hupDeviceObj = {
                                                selectedHupPhoneSku: deviceObject.ID
                                            };
                                            returnObject.BasketSeqNo = 0; // Hardcoded as HUP will always have the one line
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while creating the device tab object : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To create the tab feasible plan object.
                                 */
                                this.createPlanTabObject = function (planObject) {
                                    var returnObject = {};
                                    try {
                                        returnObject.plan = planObject;
                                        returnObject.plan.displayName = {
                                            EN: planObject.name
                                        };
                                        returnObject.plan.externalId = planObject.ID;
                                        returnObject.plan.isAdditional = false; // As this method will be executed only for primary line
                                        returnObject.plan.price = planObject.MSF;
                                        if (returnObject.previousRevenue) {
                                            returnObject.plan.previousRevenue = String(returnObject.previousRevenue);
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while creating the plan tab object : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                this.setCurrentTabsObj = function (tabsObj, findingMethod) {
                                    var selectedMultiLineProducts = [];
                                    try {
                                        _this.getCompatibleAddOns().then(function (compatibleAddons) {
                                            if (tabsObj && tabsObj.length > 0) {
                                                angular.forEach(tabsObj, function (tab) {
                                                    if (!tab.isExisting) {
                                                        var selectedMultiLineProduct = {};
                                                        var addons_1 = [];
                                                        if (tab.device) {
                                                            var deviceProductObject = {};
                                                            var displayName = tab.device.selectedModel.displayName;
                                                            var name_1;
                                                            if (_.has(displayName, _this.lang_upper)) {
                                                                name_1 = displayName[_this.lang_upper];
                                                            }
                                                            else if (_.has(displayName, _this.lang_lower)) {
                                                                name_1 = displayName[_this.lang_lower];
                                                            }
                                                            deviceProductObject.category = 'wireless';
                                                            deviceProductObject.subCategory = 'device';
                                                            deviceProductObject.name = name_1;
                                                            if (tab.device.nacDeviceObj && tab.device.nacDeviceObj.selectedNacPhoneSku) {
                                                                deviceProductObject.ID = tab.device.nacDeviceObj.selectedNacPhoneSku;
                                                            }
                                                            else if (tab.device.hupDeviceObj && tab.device.hupDeviceObj.selectedHupPhoneSku) {
                                                                deviceProductObject.ID = tab.device.hupDeviceObj.selectedHupPhoneSku;
                                                            }
                                                            deviceProductObject.findingMethod = findingMethod ? findingMethod : tab.device.findingMethod;
                                                            deviceProductObject.manufacturer = tab.device.manufacturer;
                                                            if (tab.device.displayName) {
                                                                deviceProductObject.model = tab.device.displayName[_this.lang_upper];
                                                            }
                                                            deviceProductObject.quantity = 1;
                                                            deviceProductObject.basketSeqNo = tab.BasketSeqNo;
                                                            // for HUP flow
                                                            deviceProductObject.CTN = tab.ctn ? tab.ctn : null;
                                                            selectedMultiLineProduct.device = deviceProductObject;
                                                        }
                                                        if (tab.plan) {
                                                            var devicePlanObject = {};
                                                            var displayName = tab.plan.displayName;
                                                            var name_2;
                                                            if (_.has(displayName, _this.lang_upper)) {
                                                                name_2 = displayName[_this.lang_upper];
                                                            }
                                                            else if (_.has(displayName, _this.lang_lower)) {
                                                                name_2 = displayName[_this.lang_lower];
                                                            }
                                                            devicePlanObject.category = 'wireless';
                                                            devicePlanObject.subCategory = 'plan';
                                                            devicePlanObject.name = (name_2 !== null && typeof (name_2) !== 'undefined') ? name_2 : 'Unknown';
                                                            devicePlanObject.ID = tab.plan.externalId;
                                                            devicePlanObject.findingMethod = findingMethod ? findingMethod : _this.getMultiLineFindingMethod('plan', tab.plan.isAdditional, null);
                                                            devicePlanObject.quantity = 1;
                                                            devicePlanObject.MSF = String(tab.plan.price);
                                                            if (tab.plan.previousRevenue >= 0) {
                                                                devicePlanObject.previousRevenue = String(tab.plan.previousRevenue);
                                                            }
                                                            // for PPC, HUP flow
                                                            devicePlanObject.CTN = tab.ctn ? tab.ctn : null;
                                                            selectedMultiLineProduct.plan = devicePlanObject;
                                                        }
                                                        if (tab.addon) {
                                                            angular.forEach(tab.addon, function (value) {
                                                                var addOnObject = {};
                                                                var lang = _this.lang_lower;
                                                                addOnObject.category = 'wireless';
                                                                addOnObject.subCategory = 'addon';
                                                                addOnObject.name = value[lang];
                                                                addOnObject.ID = value.socNumber ? value.socNumber : value.addonSku;
                                                                addOnObject.findingMethod = findingMethod ? findingMethod : _this.getMultiLineFindingMethod('addon', null, value.isCarryOver);
                                                                addOnObject.quantity = 1;
                                                                addOnObject.MSF = value.addonCost;
                                                                // for PPC, HUP flow
                                                                addOnObject.CTN = tab.ctn ? tab.ctn : null;
                                                                addons_1.push(addOnObject);
                                                            });
                                                        }
                                                        if (compatibleAddons && compatibleAddons[tab.BasketSeqNo] !== null) {
                                                            angular.forEach(compatibleAddons[tab.BasketSeqNo], function (value) {
                                                                var deviceAddOnObject = {};
                                                                deviceAddOnObject.category = 'wireless';
                                                                deviceAddOnObject.subCategory = 'addon';
                                                                deviceAddOnObject.name = value.en;
                                                                deviceAddOnObject.ID = value.socNumber ? value.socNumber : value.addonSku;
                                                                deviceAddOnObject.findingMethod = findingMethod ? findingMethod : _this.getMultiLineFindingMethod('addon', null, null);
                                                                deviceAddOnObject.quantity = 1;
                                                                deviceAddOnObject.MSF = value.addonCost;
                                                                addons_1.push(deviceAddOnObject);
                                                            });
                                                        }
                                                        selectedMultiLineProduct.addons = addons_1;
                                                        selectedMultiLineProducts.push(selectedMultiLineProduct);
                                                    }
                                                });
                                                _this.utePersistentStorageService.putToSession('currentTabsObj', selectedMultiLineProducts);
                                            }
                                        });
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the selected-product/tab objects in multi line flow: ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                this.getCurrentTabsObj = function (state, removeCartEvent) {
                                    var multiLineProducts = {};
                                    var flowType = _this.utePersistentStorageService.getFromSession('flowType');
                                    try {
                                        if ('NAC' === flowType || 'HUP' === flowType || (('PPC' === flowType) && ((removeCartEvent && (state === 'app.mppc.edit-plan' || state === 'app.mppc.edit')) || (!removeCartEvent && state !== 'app.mppc.step1' && state !== 'app.mppc.edit-plan' && state !== 'app.mppc.entry' && state !== 'app.mppc.edit')))) {
                                            multiLineProducts = _this.utePersistentStorageService.getFromSession('currentTabsObj');
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the selected-product/tab objects in multi line flow: ', error);
                                    }
                                    return _this.$q.when(multiLineProducts);
                                };
                                /**
                                 * @description To set the isSubmitOrderSuccess flag.
                                 */
                                this.setIsSubmitOrderSuccess = function (isSuccess) {
                                    try {
                                        _this.utePersistentStorageService.putToSession('isSubmitOrderSuccess', isSuccess);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Submit Order status: ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the isSubmitOrderSuccess flag.
                                 */
                                this.getIsSubmitOrderSuccess = function () {
                                    var returnObject;
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('isSubmitOrderSuccess');
                                        if (null === returnObject || undefined === returnObject) {
                                            returnObject = false;
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Submit Order status : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the isReviewServiceSuccess flag.
                                 */
                                this.setIsReviewServiceSuccess = function (isSuccess) {
                                    try {
                                        _this.utePersistentStorageService.putToSession('isReviewServiceSuccess', isSuccess);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Submit Order status: ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the isReviewServiceSuccess flag.
                                 */
                                this.getIsReviewServiceSuccess = function () {
                                    var returnObject;
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('isReviewServiceSuccess');
                                        if (null === returnObject || undefined === returnObject) {
                                            returnObject = false;
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Submit Order status : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the isMultiLineFlow flag.
                                 */
                                this.setIsMultiLineFlow = function (isMultiLine) {
                                    try {
                                        _this.utePersistentStorageService.putToSession('isMultiLineFlow', isMultiLine);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the MultiLine status: ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the isMultiLineFlow flag.
                                 */
                                this.getIsMultiLineFlow = function () {
                                    var returnObject;
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('isMultiLineFlow');
                                        if (null === returnObject || undefined === returnObject) {
                                            returnObject = false;
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the MultiLine status : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the isAALFlow flag.
                                 */
                                this.setIsAALFlow = function (isAAL) {
                                    try {
                                        _this.utePersistentStorageService.putToSession('isAALFlow', isAAL);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the AAL  status: ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the isAALFlow flag.
                                 */
                                this.getIsAALFlow = function () {
                                    var returnObject;
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('isAALFlow');
                                        if (null === returnObject || undefined === returnObject) {
                                            returnObject = false;
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the AAL status : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the flow type flag.
                                 */
                                this.setFlowType = function (flowType) {
                                    try {
                                        _this.utePersistentStorageService.putToSession('flowType', flowType);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the Flow Type: ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the flow type flag.
                                 */
                                this.getFlowType = function () {
                                    var returnObject;
                                    try {
                                        returnObject = _this.utePersistentStorageService.getFromSession('flowType');
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the Flow Type : ', error);
                                    }
                                    return _this.$q.when(returnObject);
                                };
                                /**
                                 * @description To set the keepExistingMainPlan flag for HUP flow.
                                 */
                                this.setKeepExistingPlan = function (keepExistingMainPlan) {
                                    try {
                                        if (_.isBoolean(keepExistingMainPlan)) {
                                            _this.utePersistentStorageService.putToSession('keepExistingMainPlan', keepExistingMainPlan);
                                        }
                                        else {
                                            _this.utePersistentStorageService.putToSession('keepExistingMainPlan', false);
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the keepExistingMainPlan: ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To get the keepExistingMainPlan flag for HUP flow.
                                 */
                                this.getKeepExistingPlan = function () {
                                    var keepExistingMainPlan;
                                    try {
                                        keepExistingMainPlan = _this.utePersistentStorageService.getFromSession('keepExistingMainPlan');
                                        if (!_.isBoolean(keepExistingMainPlan)) {
                                            keepExistingMainPlan = false;
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the keepExistingMainPlan : ', error);
                                    }
                                    return _this.$q.when(keepExistingMainPlan);
                                };
                                /**
                                 * @description To get the finding method from url
                                 */
                                this.getFindingMethod = function () {
                                    var currentStateURL;
                                    var findingMethod = null;
                                    currentStateURL = _this.$window.location.href;
                                    if (null != currentStateURL && undefined !== currentStateURL) {
                                        var lastIndexOfSlash = currentStateURL.lastIndexOf('/');
                                        var indexOfFirstParam = currentStateURL.indexOf('?');
                                        if (indexOfFirstParam > 0 && lastIndexOfSlash < indexOfFirstParam) {
                                            findingMethod = currentStateURL.substring(lastIndexOfSlash + 1, indexOfFirstParam);
                                        }
                                        else {
                                            findingMethod = currentStateURL.substring(lastIndexOfSlash + 1);
                                        }
                                    }
                                    return findingMethod;
                                };
                                /**
                                 * @description To get findingMethod for a product w.r.t flow type
                                 */
                                this.getMultiLineFindingMethod = function (subCategory, isAdditional, isCarryOver) {
                                    var findingMethod;
                                    var flowType = _this.utePersistentStorageService.getFromSession('flowType');
                                    if (flowType && subCategory) {
                                        if (flowType === 'NAC') {
                                            // for NAC ML flow
                                            if (subCategory === 'plan') {
                                                findingMethod = 'build-plan';
                                            }
                                            else if (subCategory === 'addon') {
                                                findingMethod = 'choose-add-ons';
                                            }
                                        }
                                        else if (flowType === 'PPC') {
                                            // for PPC ML flow
                                            if (subCategory === 'plan' && _.isBoolean(isAdditional)) {
                                                findingMethod = isAdditional ? 'additional-line-options' : 'choose-share-plan';
                                            }
                                            else if (subCategory === 'addon' && _.isBoolean(isCarryOver)) {
                                                findingMethod = isCarryOver ? 'manage-add-ons' : 'choose-add-ons';
                                            }
                                        }
                                        else if (flowType === 'HUP') {
                                            // for HUP ML flow
                                            if (subCategory === 'plan' && _.isBoolean(isAdditional)) {
                                                findingMethod = isAdditional ? 'additional-line-options' : 'build-plan';
                                            }
                                            else if (subCategory === 'addon' && _.isBoolean(isCarryOver)) {
                                                findingMethod = isCarryOver ? 'manage-add-ons' : 'choose-add-ons';
                                            }
                                        }
                                    }
                                    return findingMethod;
                                };
                                /**
                                 * @description To find device charge price for given deviceId
                                 */
                                this.getDeviceChargePriceByDeviceId = function (deviceId, lineNo) {
                                    var price;
                                    try {
                                        var reviewOrderPrices = _this.utePersistentStorageService.getFromSession('reviewOrderPrices');
                                        var flowType_1 = _this.utePersistentStorageService.getFromSession('flowType');
                                        var flowName_1 = _this.utePersistentStorageService.getFromSession('flowName');
                                        if (deviceId && Array.isArray(reviewOrderPrices) && reviewOrderPrices.length > 0) {
                                            reviewOrderPrices.forEach(function (reviewOrderPrice) {
                                                if (reviewOrderPrice && reviewOrderPrice.devicePrice && reviewOrderPrice.devicePrice.deviceExternalId === deviceId) {
                                                    if ('NAC' === flowType_1 || 'HUP' === flowType_1) {
                                                        if ('singleline' === flowName_1) {
                                                            price = reviewOrderPrice.devicePrice.price;
                                                        }
                                                        else if ('multiline' === flowName_1 && reviewOrderPrice.basketSequenceNumber === lineNo) {
                                                            price = reviewOrderPrice.devicePrice.price;
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the device charge price : ', error);
                                        return null;
                                    }
                                    return price;
                                };
                                /**
                                 * @description To get no term price for given deviceId
                                 */
                                this.getNoTermPrice = function (deviceId) {
                                    var reviewOrderPrices = _this.utePersistentStorageService.getFromSession('reviewOrderPrices');
                                    var noTermPrice;
                                    try {
                                        if (deviceId && Array.isArray(reviewOrderPrices) && reviewOrderPrices.length > 0) {
                                            reviewOrderPrices.forEach(function (reviewOrderPrice) {
                                                if (reviewOrderPrice && reviewOrderPrice.devicePrice && reviewOrderPrice.devicePrice.deviceExternalId === deviceId) {
                                                    noTermPrice = reviewOrderPrice.devicePrice.noTermPrice;
                                                }
                                            });
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting the no term price : ', error);
                                        return null;
                                    }
                                    return noTermPrice;
                                };
                                /**
                                 * @description To get plan/addons MSF for given id
                                 */
                                this.getPlanAddonsMSFById = function (productSubCategory, CTN, id) {
                                    var reviewOrderPrices = _this.utePersistentStorageService.getFromSession('reviewOrderPrices');
                                    var MSF;
                                    try {
                                        if (productSubCategory && CTN && id && Array.isArray(reviewOrderPrices) && reviewOrderPrices.length > 0) {
                                            reviewOrderPrices.forEach(function (reviewOrderPrice) {
                                                if (!_.isEmpty(reviewOrderPrice) && reviewOrderPrice.CTN && (CTN === reviewOrderPrice.CTN)) {
                                                    if (productSubCategory === 'plan' && !_.isEmpty(reviewOrderPrice.planMSF) && reviewOrderPrice.planMSF.externalId && id === reviewOrderPrice.planMSF.externalId) {
                                                        MSF = reviewOrderPrice.planMSF.MSF;
                                                    }
                                                    else if (productSubCategory === 'addon' && Array.isArray(reviewOrderPrice.addonsMSF) && reviewOrderPrice.addonsMSF.length > 0) {
                                                        var addon = _.find(reviewOrderPrice.addonsMSF, { 'externalId': id });
                                                        if (_.isEmpty(addon)) {
                                                            addon = _.find(reviewOrderPrice.addonsMSF, { 'skuId': id });
                                                        }
                                                        if (!_.isEmpty(addon)) {
                                                            MSF = addon.MSF;
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while getting MSF : ', error);
                                        return null;
                                    }
                                    return MSF;
                                };
                                this.trackSaveOrder = function (mappingKey, stateName) {
                                    var currentPayload_cb, currentPayload_promise;
                                    var payloadData;
                                    var order = _this.utePersistentStorageService.getFromSession('order');
                                    var accountInfo = _this.utePersistentStorageService.getFromSession('accountInfo');
                                    var createQuotePayload = {
                                        events: {
                                            createQuote: true
                                        }
                                    };
                                    var submitQuotePayload = {
                                        events: {
                                            submitQuote: true
                                        }
                                    };
                                    currentPayload_cb = _this.dataLayerService.getCallbackByKey('payload');
                                    currentPayload_promise = (currentPayload_cb) ? currentPayload_cb.callback(stateName) : {};
                                    _this.$q.when(currentPayload_promise).then(function (callbackPayLoad) {
                                        if (callbackPayLoad && stateName === 'app.review' && accountInfo.userType === 'care' && order.quotation) {
                                            payloadData = _.merge(createQuotePayload, callbackPayLoad);
                                        }
                                        if (callbackPayLoad && stateName === 'confirm' && order.quotation) {
                                            payloadData = _.merge(submitQuotePayload, callbackPayLoad);
                                        }
                                        if (accountInfo.userType === 'consumer' && order.orderSavedByAgent) {
                                            payloadData.buyflow.originPoint = 'Care';
                                        }
                                        if ((accountInfo.userType !== 'consumer' && !order.orderSavedByAgent)) {
                                            payloadData.buyflow.originPoint = 'Consumer';
                                        }
                                        _this.initiateAnalyticsAccountDetails().then(function (response) {
                                            if (response) {
                                                return _this.getAccountInfo().then(function (accountInfo) {
                                                    if (accountInfo.userName) {
                                                        payloadData.account = accountInfo;
                                                    }
                                                    return _this.initiateAnalyticsSelectedSections(false).then(function (selectedSections) {
                                                        _this.dataLayerService.track(payloadData, false, selectedSections, mappingKey);
                                                        return _this.$q.when(true);
                                                    });
                                                });
                                            }
                                        });
                                    });
                                    return _this.$q.when(true);
                                };
                                this.trackDealerSubmit = function (mappingKey, stateName) {
                                    var currentPayload_cb, currentPayload_promise;
                                    var payloadData;
                                    var dealerSubmitPayload = {
                                        events: {
                                            dealerSubmit: true
                                        }
                                    };
                                    currentPayload_cb = _this.dataLayerService.getCallbackByKey('payload');
                                    currentPayload_promise = (currentPayload_cb) ? currentPayload_cb.callback(stateName) : {};
                                    _this.$q.when(currentPayload_promise).then(function (callbackPayLoad) {
                                        if (callbackPayLoad) {
                                            payloadData = _.merge(dealerSubmitPayload, callbackPayLoad);
                                        }
                                        _this.initiateAnalyticsAccountDetails().then(function (response) {
                                            if (response) {
                                                return _this.getAccountInfo().then(function (accountInfo) {
                                                    if (accountInfo.userName) {
                                                        payloadData.account = accountInfo;
                                                    }
                                                    return _this.initiateAnalyticsSelectedSections(false).then(function (selectedSections) {
                                                        _this.dataLayerService.track(payloadData, false, selectedSections, mappingKey);
                                                        return _this.$q.when(true);
                                                    });
                                                });
                                            }
                                        });
                                    });
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To populate single line ecommerce products for TAZO flow
                                 */
                                this.populateEComProductForTAZOSingleLine = function (orderDetails) {
                                    var devices = orderDetails[0].devices;
                                    var plans = orderDetails[0].plans;
                                    var addons = orderDetails[0].addons;
                                    try {
                                        // device ecom population
                                        if (Array.isArray(devices) && devices.length === 1) {
                                            var device = devices[0];
                                            if (device && device.itemDetail && device.itemDetail.externalId && device.itemDetail.newManufacturer) {
                                                var deviceDisplayName = {};
                                                deviceDisplayName.EN = device.itemDetail.itemNameEN;
                                                var deviceObject = {
                                                    displayName: deviceDisplayName
                                                };
                                                _this.setDeviceProductObject(null, device.itemDetail.externalId, true, deviceObject, null, device.itemDetail.newManufacturer, 'review', orderDetails[0].ctn);
                                            }
                                        }
                                        // plan ecom population
                                        if (Array.isArray(plans) && plans.length === 1) {
                                            var plan = plans[0];
                                            if (plan && plan.itemDetail && plan.itemDetail.itemNameEN && plan.itemDetail.externalId && plan.price && plan.price.priceAmount) {
                                                var planDisplayName = {};
                                                planDisplayName.EN = plan.itemDetail.itemNameEN;
                                                var MSF = plan.price.priceAmount ? String(plan.price.priceAmount) : null;
                                                _this.setPlanProductObject(plan.itemDetail.externalId, planDisplayName, MSF, null, null, 'review', orderDetails[0].ctn);
                                            }
                                        }
                                        // addons ecom population
                                        if (Array.isArray(addons) && addons.length > 0) {
                                            var addonProductArray_2 = [];
                                            addons.forEach(function (addon) {
                                                if (addon && addon.itemDetail && addon.itemDetail.externalId && addon.itemDetail.itemNameEN && addon.price && addon.price.priceAmount) {
                                                    var addonProductObject = {};
                                                    addonProductObject.socNumber = addon.itemDetail.externalId;
                                                    addonProductObject.en = addon.itemDetail.itemNameEN;
                                                    addonProductObject.addonCost = addon.price.priceAmount;
                                                    addonProductArray_2.push(addonProductObject);
                                                }
                                            });
                                            if (!_.isEmpty(addonProductArray_2)) {
                                                _this.setAddonProductArray(addonProductArray_2, null, 'review', orderDetails[0].ctn);
                                            }
                                        }
                                    }
                                    catch (error) {
                                        console.error('ADL error while populating single line ecommerce products : ', error);
                                        return _this.$q.when(false);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To populate multi line ecommerce products for TAZO flow
                                 */
                                this.populateEComProductForTAZOMultiLine = function (orderDetails) {
                                    var multilineProducts = [];
                                    if (Array.isArray(orderDetails) && orderDetails.length > 1) {
                                        try {
                                            orderDetails.forEach(function (orderDetail) {
                                                if (!orderDetail.isExisting) {
                                                    var multilineProduct = {};
                                                    multilineProduct.ctn = orderDetail.ctn;
                                                    var orderDetailDevices = orderDetail.devices;
                                                    var orderDetailPlans = orderDetail.plans;
                                                    var orderDetailAddons = orderDetail.addons;
                                                    var device = {};
                                                    var plan = {};
                                                    var addons_2 = [];
                                                    // device ecom population
                                                    if (Array.isArray(orderDetailDevices) && orderDetailDevices.length === 1) {
                                                        var orderDetailDevice = orderDetailDevices[0];
                                                        if (orderDetailDevice && orderDetailDevice.itemDetail && orderDetailDevice.itemDetail.itemNameEN && orderDetailDevice.itemDetail.newManufacturer && orderDetailDevice.itemDetail.externalId) {
                                                            device.selectedModel = {
                                                                displayName: {
                                                                    EN: orderDetailDevice.itemDetail.itemNameEN
                                                                }
                                                            };
                                                            device.manufacturer = orderDetailDevice.itemDetail.newManufacturer;
                                                            device.hupDeviceObj = {
                                                                selectedHupPhoneSku: orderDetailDevice.itemDetail.externalId
                                                            };
                                                            multilineProduct.BasketSeqNo = 0;
                                                        }
                                                        multilineProduct.device = _.isEmpty(device) ? null : device;
                                                    }
                                                    // plan ecom population
                                                    if (Array.isArray(orderDetailPlans) && orderDetailPlans.length === 1) {
                                                        var orderDetailPlan = orderDetailPlans[0];
                                                        if (orderDetailPlan && orderDetailPlan.itemDetail && orderDetailPlan.itemDetail.itemNameEN && orderDetailPlan.itemDetail.externalId && orderDetailPlan.price && orderDetailPlan.price.priceAmount) {
                                                            plan.displayName = {
                                                                EN: orderDetailPlan.itemDetail.itemNameEN
                                                            };
                                                            plan.externalId = orderDetailPlan.itemDetail.externalId;
                                                            plan.price = orderDetailPlan.price.priceAmount;
                                                        }
                                                        multilineProduct.plan = _.isEmpty(plan) ? null : plan;
                                                    }
                                                    // addons ecom population
                                                    if (Array.isArray(orderDetailAddons) && orderDetailAddons.length > 0) {
                                                        orderDetailAddons.forEach(function (orderDetailAddon) {
                                                            var addon = {};
                                                            if (orderDetailAddon && orderDetailAddon.itemDetail && orderDetailAddon.itemDetail.externalId && orderDetailAddon.itemDetail.itemNameEN && orderDetailAddon.price && orderDetailAddon.price.priceAmount) {
                                                                addon.socNumber = orderDetailAddon.itemDetail.externalId;
                                                                addon.addonCost = orderDetailAddon.price.priceAmount;
                                                                addon.en = orderDetailAddon.itemDetail.itemNameEN;
                                                            }
                                                            if (!_.isEmpty(addon)) {
                                                                addons_2.push(addon);
                                                            }
                                                        });
                                                        if (Array.isArray(addons_2) && addons_2.length > 0) {
                                                            multilineProduct.addon = addons_2;
                                                        }
                                                        else {
                                                            multilineProduct.addon = null;
                                                        }
                                                    }
                                                    if (multilineProduct.device || multilineProduct.plan) {
                                                        multilineProducts.push(multilineProduct);
                                                    }
                                                }
                                            });
                                            if (!_.isEmpty(multilineProducts)) {
                                                _this.setCurrentTabsObj(multilineProducts, 'review');
                                                return _this.$q.when(false);
                                            }
                                        }
                                        catch (error) {
                                            console.error('ADL error while populating multi line ecommerce products : ', error);
                                            return _this.$q.when(false);
                                        }
                                    }
                                    else {
                                        return _this.$q.when(false);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To construct ecommerce products for TAZO flow from review-order response
                                 */
                                this.setECommerceProductsForTAZO = function (checkoutParameters) {
                                    if (checkoutParameters && Array.isArray(checkoutParameters.orderDetail) && checkoutParameters.orderDetail.length > 0) {
                                        var orderDetails = checkoutParameters.orderDetail;
                                        if (Array.isArray(orderDetails) && orderDetails.length === 1) {
                                            // ecom population for single line flow
                                            _this.utePersistentStorageService.putToSession('flowName', 'singleline');
                                            _this.populateEComProductForTAZOSingleLine(orderDetails);
                                        }
                                        else if (Array.isArray(orderDetails) && orderDetails.length > 1) {
                                            // ecom population for multiline flow
                                            _this.utePersistentStorageService.putToSession('flowName', 'multiline');
                                            _this.populateEComProductForTAZOMultiLine(orderDetails);
                                        }
                                    }
                                    else {
                                        return _this.$q.when(false);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To extract products price from review-order response
                                 */
                                this.setReviewOrderPrices = function (checkoutParameters) {
                                    var reviewOrderPrices = [];
                                    var subscriberSequence = checkoutParameters.subscriberSequence;
                                    var orderDetails = checkoutParameters.orderDetail;
                                    try {
                                        if (orderDetails && orderDetails.length > 0) {
                                            orderDetails.forEach(function (orderDetail) {
                                                if (!orderDetail.isExisting) {
                                                    var reviewOrderPrice = {};
                                                    var devicePrice = {};
                                                    var planMSF = {};
                                                    var addonsMSF_1 = [];
                                                    var ctn_1 = orderDetail.ctn;
                                                    reviewOrderPrice.CTN = ctn_1;
                                                    // setting device price
                                                    if (Array.isArray(orderDetail.devices) && orderDetail.devices.length === 1) {
                                                        var device = orderDetail.devices[0];
                                                        var basketSequenceNumber_1 = 0;
                                                        if (subscriberSequence) {
                                                            _.forEach(subscriberSequence, function (value, basketSeqNo) {
                                                                if (value && basketSeqNo && value === ctn_1) {
                                                                    basketSequenceNumber_1 = Number(basketSeqNo);
                                                                }
                                                            });
                                                        }
                                                        if (device && _.has(device, 'itemDetail') && _.has(device.itemDetail, 'eiData') && _.has(device.itemDetail.eiData, 'noTermDevicePrice') && _.has(device.itemDetail, 'externalId') && _.has(device, 'price') && _.has(device.price, 'priceAmount')) {
                                                            devicePrice.deviceExternalId = device.itemDetail.externalId;
                                                            devicePrice.price = device.price.priceAmount;
                                                            devicePrice.noTermPrice = device.itemDetail.eiData.noTermDevicePrice;
                                                        }
                                                        reviewOrderPrice.basketSequenceNumber = basketSequenceNumber_1;
                                                        reviewOrderPrice.devicePrice = _.isEmpty(devicePrice) ? null : devicePrice;
                                                    }
                                                    // setting plan MSF
                                                    if (Array.isArray(orderDetail.plans) && orderDetail.plans.length === 1) {
                                                        var orderDetailPlan = orderDetail.plans[0];
                                                        if (!_.isEmpty(orderDetailPlan) && orderDetailPlan.itemDetail && orderDetailPlan.itemDetail.externalId && orderDetailPlan.itemDetail.id && orderDetailPlan.price && orderDetailPlan.price.priceAmount) {
                                                            planMSF.externalId = orderDetailPlan.itemDetail.externalId;
                                                            planMSF.MSF = String(orderDetailPlan.price.priceAmount);
                                                            planMSF.skuId = orderDetailPlan.itemDetail.id;
                                                        }
                                                        reviewOrderPrice.planMSF = _.isEmpty(planMSF) ? null : planMSF;
                                                    }
                                                    // setting addons MSF
                                                    if (Array.isArray(orderDetail.addons) && orderDetail.addons.length > 0) {
                                                        orderDetail.addons.forEach(function (orderDetailAddon) {
                                                            var addonMSF = {};
                                                            if (orderDetailAddon && orderDetailAddon.itemDetail && orderDetailAddon.itemDetail.externalId && orderDetailAddon.itemDetail.id && orderDetailAddon.price && orderDetailAddon.price.priceAmount) {
                                                                addonMSF.externalId = orderDetailAddon.itemDetail.externalId;
                                                                addonMSF.MSF = String(orderDetailAddon.price.priceAmount);
                                                                addonMSF.skuId = orderDetailAddon.itemDetail.id;
                                                            }
                                                            if (!_.isEmpty(addonMSF)) {
                                                                addonsMSF_1.push(addonMSF);
                                                            }
                                                        });
                                                        if (Array.isArray(addonsMSF_1) && addonsMSF_1.length > 0) {
                                                            reviewOrderPrice.addonsMSF = addonsMSF_1;
                                                        }
                                                        else {
                                                            reviewOrderPrice.addonsMSF = null;
                                                        }
                                                    }
                                                    if (!_.isEmpty(reviewOrderPrice.devicePrice) || (!_.isEmpty(reviewOrderPrice.planMSF))) {
                                                        reviewOrderPrices.push(reviewOrderPrice);
                                                    }
                                                }
                                            });
                                        }
                                        _this.utePersistentStorageService.putToSession('reviewOrderPrices', reviewOrderPrices);
                                    }
                                    catch (error) {
                                        console.error('ADL error while setting the device charge prices : ', error);
                                        return _this.$q.when(false);
                                    }
                                    return _this.$q.when(true);
                                };
                                /**
                                 * @description To reset the session storage.
                                 */
                                this.resetSessionStorage = function () {
                                    try {
                                        // Place holder - Offshore has to update the keys
                                        _this.utePersistentStorageService.removeFromSession('uniqueID');
                                        _this.utePersistentStorageService.removeFromSession('CREDIT_CHECK_FORM_COMPLETE');
                                        _this.utePersistentStorageService.removeFromSession('CREATE_PROFILE_FORM_COMPLETE');
                                        _this.utePersistentStorageService.removeFromSession('BYOP');
                                        _this.utePersistentStorageService.removeFromSession('SHIPPING_ADDRESS_CHANGED');
                                        _this.utePersistentStorageService.removeFromSession('ADD_TO_CART_TRIGGERED');
                                        _this.utePersistentStorageService.removeFromSession('CHECKOUT_EVENTS');
                                        _this.utePersistentStorageService.removeFromSession('CREDIT_CHECK_DEPOSIT_AMOUNT');
                                        _this.utePersistentStorageService.removeFromSession('addonProductArray');
                                        _this.utePersistentStorageService.removeFromSession('phoneProduct');
                                        _this.utePersistentStorageService.removeFromSession('planProduct');
                                        _this.utePersistentStorageService.removeFromSession('checkoutDetails');
                                        _this.utePersistentStorageService.removeFromSession('creditCardType');
                                        _this.utePersistentStorageService.removeFromSession('fulfillmentMethod');
                                        _this.utePersistentStorageService.removeFromSession('wirelessDevicePrice');
                                        _this.utePersistentStorageService.removeFromSession('isSubmitOrderSuccess');
                                        _this.utePersistentStorageService.removeFromSession('isReviewServiceSuccess');
                                        _this.utePersistentStorageService.removeFromSession('flowType');
                                        _this.utePersistentStorageService.removeFromSession('accountInfo');
                                        _this.utePersistentStorageService.removeFromSession('compatibleAddons');
                                        _this.utePersistentStorageService.removeFromSession('profileInfo');
                                        _this.utePersistentStorageService.removeFromSession('tentativeAccountNumber');
                                        _this.utePersistentStorageService.removeFromSession('isAALFlow');
                                        _this.utePersistentStorageService.removeFromSession('isMultiLineFlow');
                                        _this.utePersistentStorageService.removeFromSession('flowName');
                                        _this.utePersistentStorageService.removeFromSession('BUY_FLOW_START_TRIGGERED');
                                        _this.utePersistentStorageService.removeFromSession('selectedSubscriberNumber');
                                        _this.utePersistentStorageService.removeFromSession('dealerInfo');
                                        _this.utePersistentStorageService.removeFromSession('currentDevice');
                                        _this.utePersistentStorageService.removeFromSession('currentPlan');
                                        _this.utePersistentStorageService.removeFromSession('currentTabsObj');
                                        _this.utePersistentStorageService.removeFromSession('isTAZOFlow');
                                        _this.utePersistentStorageService.removeFromSession('reviewOrderPrices');
                                        _this.utePersistentStorageService.removeFromSession('keepExistingMainPlan');
                                    }
                                    catch (error) {
                                        console.error('ADL error while resetting the sessionStorage : ', error);
                                    }
                                    return _this.$q.when(true);
                                };
                                this.lang_upper = 'EN';
                                this.lang_lower = 'en';
                            }
                            /**
                             * @description To get the eventPayload
                             */
                            DataLayerIntegrationService.prototype.getEventPayload = function (payload, stateName) {
                                var currentPayload_cb, currentPayload_promise;
                                currentPayload_cb = this.dataLayerService.getCallbackByKey('payload');
                                currentPayload_promise = (currentPayload_cb) ? currentPayload_cb.callback(stateName) : {};
                                try {
                                    return this.$q.when(currentPayload_promise)
                                        .then(function (callbackPayLoad) {
                                        if (callbackPayLoad) {
                                            _.merge(payload, callbackPayLoad);
                                        }
                                        return payload;
                                    })
                                        .catch(function (error) {
                                        console.warn('Error in resolving payload promise.');
                                        return payload;
                                    });
                                }
                                catch (e) {
                                    console.warn('Silent :: Error in resolving payload promise.');
                                }
                            };
                            DataLayerIntegrationService.$inject = [
                                '$http',
                                '$rootScope',
                                '$q',
                                '$filter',
                                '$translate',
                                '$window',
                                '$injector',
                                '$state',
                                '$stateParams',
                                '$previousState',
                                'ute.datalayer.common.service',
                                'ute.blocks.persistent.storage.service'
                            ];
                            DataLayerIntegrationService.serviceName = 'ute.rogers.datalayer.integration.common.service';
                            return DataLayerIntegrationService;
                        }());
                        angular.module('ute.rogers.datalayer.integration.common').service(DataLayerIntegrationService.serviceName, DataLayerIntegrationService);
                    })(service = common.service || (common.service = {}));
                })(common = integration.common || (integration.common = {}));
            })(integration = datalayer.integration || (datalayer.integration = {}));
        })(datalayer = rogers.datalayer || (rogers.datalayer = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var interceptors;
        (function (interceptors) {
            var auth;
            (function (auth) {
                'use strict';
                angular.module('ute.rogers.interceptors.auth').config(configure);
                configure.$inject = ['$httpProvider', 'ute.rogers.interceptors.auth.serviceProvider'];
                /* @ngInject */
                function configure($httpProvider, authHttpResponseInterceptorProvider) {
                    //authHttpResponseInterceptorProvider.configure({
                    //  httpCodes: [401],
                    //  notifyEvents: [ute.blocks.messages.bus.Messages.uteUserUnauthorized]
                    //});
                    $httpProvider.interceptors.push(authHttpResponseInterceptorProvider.$get);
                }
            })(auth = interceptors.auth || (interceptors.auth = {}));
        })(interceptors = rogers.interceptors || (rogers.interceptors = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var interceptors;
        (function (interceptors) {
            var auth;
            (function (auth) {
                'use strict';
                var AuthHttpResponseInterceptorProvider = (function () {
                    /* @ngInject */
                    function AuthHttpResponseInterceptorProvider() {
                        var _this = this;
                        this.config = {
                            httpCodes: [401],
                            notifyEvents: [ute.blocks.messages.bus.Messages.uteUserUnauthorized]
                        };
                        /* @ngInject */
                        this.$get = ["$q", "$injector", function ($q, $injector) {
                            _this.$q = $q;
                            _this.messagesService = $injector.get('ute.blocks.messages.bus.service');
                            return {
                                response: _this.response,
                                responseError: _this.responseError
                            };
                        }];
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.response = function (response) {
                            // TODO search text
                            if (_.includes(_this.config.httpCodes, response.status) || (angular.isString(response.data) && response.data.search(/<html.*>.*You will be forwarded to continue the authorization process/i) >= 0)) {
                                _this.notify();
                                return _this.$q.reject(response);
                            }
                            else {
                                return _this.$q.when(response);
                            }
                        };
                        this.responseError = function (rejection) {
                            if (_.includes(_this.config.httpCodes, rejection.status)) {
                                _this.notify();
                            }
                            return _this.$q.reject(rejection);
                        };
                        this.notify = function () {
                            _.forEach(_this.config.notifyEvents, function (value) {
                                _this.messagesService.publish(value);
                            });
                        };
                        this.$get.$inject = ['$q', '$injector'];
                    }
                    AuthHttpResponseInterceptorProvider.$inject = [];
                    return AuthHttpResponseInterceptorProvider;
                }());
                angular.module('ute.rogers.interceptors.auth').provider('ute.rogers.interceptors.auth.service', AuthHttpResponseInterceptorProvider);
            })(auth = interceptors.auth || (interceptors.auth = {}));
        })(interceptors = rogers.interceptors || (rogers.interceptors = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
                var RogersCookies = ute.common.core.RogersCookies;
                var UserType = ute.common.user.UserType;
                var SigninService = (function () {
                    // static $inject: Array<string> = [];
                    // /* @ngInject */
                    SigninService.$inject = ["config", "$http", "$q", "$injector", "$window", "$state", "$cookies"];
                    function SigninService(config, $http, $q, $injector, $window, $state, $cookies) {
                        var _this = this;
                        this.config = config;
                        this.$http = $http;
                        this.$q = $q;
                        this.$injector = $injector;
                        this.$window = $window;
                        this.$state = $state;
                        this.$cookies = $cookies;
                        this.signinUser = function (user) {
                            console.log(SigninService.serviceName + '->signinUser->user:', user);
                            _this.resetModel(user);
                            return _this.discardLoginSmCookies() // server side call
                                .then(_this.signinFn) // siteMinder call
                                .then(function (isSigninOk) { return _this.$q.all({
                                isUserFound: _this.isUserFoundFunc(isSigninOk),
                                isUserNotLocked: _this.isUserNotLocked(isSigninOk),
                                isUserAuthenticated: _this.isUserAuthenticatedFunc(isSigninOk),
                                isNotTemporaryPassword: _this.isNotTemporaryPassword(isSigninOk)
                            }); })
                                .then(_this.postSignin)
                                .catch(_.curry(_this.fail)('signin failed.'));
                        };
                        this.getRetryNumber = function () { return _this.model.smTryNumber; };
                        this.discardLoginSmCookies = function () {
                            return _this.$http.post(_this.environmentService.getProperty('apiUrls.discardLoginSmCookies'), {})
                                .then(_this.discardSuccess)
                                .catch(_.curry(_this.fail)('discardLoginSmCookies failed.'));
                        };
                        this.loggedIn = function () {
                            return _this.$http.post(_this.environmentService.getProperty('apiUrls.loggedIn'), {}).then(_this.loggedInSuccess).catch(_.curry(_this.fail)('loggedIn failed.'));
                        };
                        this.processPostSignin = function () {
                            return _this.$http.get(_this.environmentService.getProperty('apiUrls.postSigninRequest')).then(_this.processPostSigninSuccess).catch(_.curry(_this.fail)('processPostSignin failed.'));
                        };
                        this.signin = function (user) {
                            // TODO interface
                            var postData = {
                                USER: user.userName,
                                password: user.userPassword,
                                SMAUTHREASON: '0',
                                target: _this.postSigninUrl()
                            };
                            return _this.$http.post(_this.environmentService.getProperty('siteminder.signinActionUrl'), $.param(postData), {
                                headers: {
                                    'Accept': 'text/plain, */*',
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            })
                                .then(_this.signinSuccess)
                                .catch(_.curry(_this.fail)('signin failed'));
                        };
                        this.isUserFound = function () { return (_this.$q.when(_this.$cookies.get(RogersCookies.SM_USERNOTFOUND) !== '1')); };
                        this.isSignin = function () { return _this.userService.isSigned(); };
                        this.signout = function () {
                            //this.$cookies.remove(RogersCookies.SM_USERAUTHENTICATED, {domain: this.environmentService.getProperty('cookies.defaultDomain')});
                            //this.$cookies.remove(RogersCookies.SMSESSION, {domain: this.environmentService.getProperty('cookies.defaultDomain')});
                            if (_this.userService.isSigned()) {
                                return _this.discardAllSmCookies().finally(function () {
                                    // regardless of Ok or not Ok notify user service and transit to signin state
                                    _this.userService.unsigned();
                                    return _this.$state.go(_this.config.signinState);
                                });
                            }
                            else {
                                return _this.$state.go(_this.config.signinState);
                            }
                        };
                        this.signinCheck = function () {
                            //this.logger.info('signinCheck: ' + this.environmentService.getProperty('apiUrls.defaultLandingState'));
                            if (_this.isSignin()) {
                                //console.log('signinCheck', this.config.landingState);
                                return _this.$state.go(_this.config.landingState);
                            }
                            return _this.$q.when(true);
                        };
                        this.isUserLocked = function () { return (_this.$q.when(_this.$cookies.get(RogersCookies.SMLOCK) === '1')); };
                        this.isTemporaryPassword = function () {
                            var retval = false;
                            var smQueryCookie = _this.$cookies.get(RogersCookies.SM_QUERY_STRING);
                            //var smQueryCookie='SMENC=UTF-8&SMTOKEN={RC2}tHHbCU9XYKDFOIkbQhVUCNEYWPkhyg1f1JTa+VKqp6wkOAUHrmDWcKCSzNeWURmNqBGCtyyT/omvSeWYGHF7DOn3/ymf2IROKGf7JF+xvl5tLlnee2N0/R9TfB5RB3zjt0W+UBi7LPeKqvAiRKLI11M5l4SgSewS/utExahyYQpgJcGBhC2eHraF8fTeq3SUwKONjiraiUQ=&USERNAME=spidermonca@yahoo.ca&SMAUTHREASON=20&SMAGENTNAME=zKoliFagzIafTRmv55EAwldWZCnBmFSsGdnDIWiwclBez3MZgA58Eu5EhbBDxIO8&TARGET=-SM-https%3a%2f%2fwww%2edev42%2erogers%2ecom%2fweb%2fRogersServices%2eportal%2ftotes%2f';
                            if (smQueryCookie) {
                                var params = (_.chain(smQueryCookie.split('&')).map(function (params) {
                                    var p = params.split('=');
                                    return [p[0], decodeURIComponent(p[1])];
                                }).object().value());
                                _this.$cookies.remove(RogersCookies.SM_QUERY_STRING);
                                if (params.SMAUTHREASON === '20' && params.SMTOKEN) {
                                    params.SMTOKEN = params.SMTOKEN + '=';
                                    retval = true;
                                }
                            }
                            return _this.$q.when(retval);
                        };
                        this.isUserAuthenticated = function () {
                            return _this.$q.when(!(Number(_this.$cookies.get(RogersCookies.SMTRYNO)) >= 1));
                        };
                        this.postSignin = function (results) {
                            //console.log('postSignin:', results);
                            if (angular.isUndefined(_.find(results, function (val) { return !val; }))) {
                                return _this.$q.all([_this.loggedIn(), _this.processPostSignin()]).then(_this.finaliseSignin);
                            }
                            else {
                                return _this.$q.reject('User is not loggedin');
                            }
                        };
                        this.discardAllSmCookies = function () {
                            return _this.$http.post(_this.environmentService.getProperty('apiUrls.discardAllSmCookies'), {}).then(_this.discardSuccess).catch(_.curry(_this.fail)('discardAllSmCookies failed.'));
                        };
                        this.finaliseSignin = function (results) {
                            if (angular.isUndefined(_.find(results, function (val) { return !val; }))) {
                                // All calls successful
                                _this.userService.signed(_this.model.user);
                                _this.messagesService.publish(ute.blocks.messages.bus.Messages.uteRogersSigninSuccessful, { email: _this.model.user.userEmail });
                                //console.log('finaliseSignin', this.config.landingState);
                                return _this.$state.go(_this.config.landingState);
                            }
                            else {
                                return _this.$q.reject('User PostSignin not Ok');
                            }
                        };
                        // TODO move to the common service
                        this.postSigninUrl = function () { return (_this.$window.location.protocol + '//' + _this.$window.location.hostname +
                            ((_this.$window.location.protocol === 'http' && _this.$window.location.port === '80') || (_this.$window.location.protocol === 'https' && _this.$window.location.port === '443') ?
                                '' : ':' + _this.$window.location.port) + _this.environmentService.getProperty('apiUrls.defaultLandingPage')); };
                        this.loggedInSuccess = function (response) {
                            var retval = response.data === 'success:true';
                            if (!retval) {
                                _this.userService.unsigned();
                            }
                            return retval;
                        };
                        this.discardSuccess = function (response) { return (response.data === 'success:true'); };
                        this.processPostSigninSuccess = function (response) { return true; };
                        this.signinSuccess = function (response) {
                            _this.model.smTryNumber = Number(_this.$cookies.get(RogersCookies.SMTRYNO));
                            /*
                             if (this.smTryNumber >= 1) {
                             throw {message: 'Signin not Ok', data: {description: 'smTryNumber=' + this.smTryNumber}};
                             }
                             return true;
                             */
                            //return !(this.smTryNumber >= 1);
                            return true;
                        };
                        this.signinFn = function (isDiscardOk) {
                            if (isDiscardOk) {
                                return _this.signin(_this.model.user).then(function (data) {
                                    _this.logger.info('smTryNumber=' + _this.getRetryNumber());
                                    return data;
                                });
                            }
                            else {
                                _this.$q.reject('discardLoginSmCookies not Ok');
                            }
                        };
                        this.isUserFoundFunc = function (isSigninOk) {
                            if (isSigninOk) {
                                return _this.isUserFound().then(function (result) {
                                    _this.model.isUserFound = result;
                                    _this.logger.info('isUserFound=' + result);
                                    return result;
                                });
                            }
                            else {
                                return _this.$q.reject('Signin not Ok');
                            }
                        };
                        this.isUserNotLocked = function (isSigninOk) {
                            if (isSigninOk) {
                                return _this.isUserLocked().then(function (result) {
                                    _this.model.isUserLocked = result;
                                    _this.logger.info('isUserLocked=' + result);
                                    return !result;
                                });
                            }
                            else {
                                return _this.$q.reject('Signin User failed');
                            }
                        };
                        this.isUserAuthenticatedFunc = function (isSigninOk) {
                            if (isSigninOk) {
                                return _this.isUserAuthenticated().then(function (result) {
                                    _this.model.isUserAuthenticated = result;
                                    _this.logger.info('isUserAuthenticated=' + result);
                                    return result;
                                });
                            }
                            else {
                                return _this.$q.reject('Signin not Ok');
                            }
                        };
                        this.isNotTemporaryPassword = function (isSigninOk) {
                            if (isSigninOk) {
                                return _this.isTemporaryPassword().then(function (result) {
                                    _this.logger.info('isTemporaryPassword=' + result);
                                    if (result) {
                                        _this.$state.go(_this.environmentService.getProperty('apiUrls.changeTemporaryPasswordState'));
                                    }
                                    return !result;
                                });
                            }
                            else {
                                return _this.$q.reject('Signin not Ok');
                            }
                        };
                        this.resetModel = function (userIn) {
                            var user = _.assign({}, userIn);
                            user.userType = UserType.consumer; // TODO factory from userService
                            _this.model = {
                                user: user,
                                isUserFound: undefined,
                                isUserLocked: undefined,
                                isUserAuthenticated: undefined,
                                smTryNumber: 0
                            };
                        };
                        this.fail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            //this.exception.catcher(msg)(reason, 'signin.data.service.ts');
                            return _this.$q.reject(msg);
                        };
                        this.environmentService = $injector.get('ute.blocks.environment');
                        this.messagesService = $injector.get('ute.blocks.messages.bus.service');
                        this.userService = $injector.get('ute.common.user.service');
                        this.logger = $injector.get('ute.blocks.loggerService');
                    }
                    SigninService.serviceName = 'ute.rogers.siteminder.signin.service';
                    return SigninService;
                }());
                var SigninProvider = (function () {
                    /* @ngInject */
                    function SigninProvider() {
                        var _this = this;
                        this.config = signin.DefaultConfigFactory();
                        /* @ngInject */
                        this.$get = function ($http, $q, $injector, $window, $state, $cookies) {
                            return new SigninService(_this.config, $http, $q, $injector, $window, $state, $cookies);
                        };
                        /**
                         * TODO validation
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.$get.$inject = [
                            '$http',
                            '$q',
                            '$injector',
                            '$window',
                            '$state',
                            angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies'
                        ];
                    }
                    SigninProvider.$inject = [];
                    return SigninProvider;
                }());
                angular.module('ute.rogers.siteminder.signin').provider(SigninService.serviceName, SigninProvider);
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
                function DefaultConfigFactory() {
                    return {
                        landingState: 'accountOverview',
                        signinState: 'signin',
                        signoutState: 'signout'
                    };
                }
                signin.DefaultConfigFactory = DefaultConfigFactory;
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                var UserRegistrationController = (function () {
                    /* @ngInject */
                    function UserRegistrationController($document, userRegistrationService, dtmService) {
                        $document.scrollTop(0);
                        this.emailAddress = userRegistrationService.getModel().email;
                        dtmService.complete(userRegistrationService.getConfig().basic.dtmName);
                    }
                    UserRegistrationController.$inject = ['$document',
                        'ute.rogers.user.registration.service',
                        'ute.dtm.service'
                    ];
                    UserRegistrationController.controlerName = 'ute.rogers.user.registration.confirmation.controller';
                    return UserRegistrationController;
                }());
                angular.module('ute.rogers.user.registration').controller(UserRegistrationController.controlerName, UserRegistrationController);
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                var UserRegistrationController = (function () {
                    /* @ngInject */
                    function UserRegistrationController($document, userRegistrationService, dtmService, $window, $scope) {
                        var _this = this;
                        this.userRegistrationService = userRegistrationService;
                        this.dtmService = dtmService;
                        this.$window = $window;
                        this.$scope = $scope;
                        this.modelOptions = { updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 }, allowInvalid: true };
                        this.isUserRegistrationCallInProgress = this.userRegistrationService.isUserRegistrationCallInProgress;
                        this.isSubmitButtonEnabled = function () {
                            // console.log(UserRegistrationController.controlerName + '->isSubmitButtonEnabled', this.form.$valid, !this.userRegistrationService.isUserRegistrationCallInProgress());
                            return !_this.isUserRegistrationCallInProgress();
                            // return this.form.$valid && !this.userRegistrationService.isUserRegistrationCallInProgress();
                        };
                        this.getCancelStateName = function () { return _this.config.advanced.registration.cancelState; };
                        /**
                         * @returns {IPromise<any>}
                         */
                        this.submit = function () {
                            // console.log(UserRegistrationController.controlerName + '->submit: form.$valid=', this.form.$valid,
                            //     'form.email=', this.form.email,
                            //     'form.confirmEmail=', this.form.confirmEmail,
                            //     'form=', this.form
                            // );
                            if (_this.form.$valid) {
                                _this.errorCode = null;
                                // console.log(UserRegistrationController.controlerName + '->submit->model:', this.model);
                                return _this.userRegistrationService.registerUser(_this.model)
                                    .then(_this.processOk)
                                    .catch(_this.processError);
                            }
                            else {
                                return null;
                            }
                        };
                        this.verifyReCaptchaCallback = function (response) {
                            _this.$scope.$apply(function () {
                                _this.model.reCaptchaResponse = response;
                            });
                        };
                        this.processOk = function (codeEntry) {
                            // console.log(UserRegistrationController.controlerName + '->processOk: codeEntry=', codeEntry);
                            return _this.userRegistrationService.goToConfirmation();
                        };
                        this.processError = function (codeEntry) {
                            // console.log(UserRegistrationController.controlerName + '->processError: codeEntry=', codeEntry);
                            _this.errorCode = codeEntry;
                            _this.model.reCaptchaResponse = undefined;
                            _this.$window.grecaptcha.reset();
                        };
                        $document.scrollTop(0);
                        this.model = this.userRegistrationService.getModel();
                        this.config = this.userRegistrationService.getConfig();
                        this.languages = this.config.advanced.supportedLanguages;
                        this.recaptchaSiteKey = this.config.basic.recaptchaSiteKey;
                        this.dtmService.start(this.config.basic.dtmName);
                    }
                    UserRegistrationController.$inject = ['$document',
                        'ute.rogers.user.registration.service',
                        'ute.dtm.service',
                        '$window',
                        '$scope'
                    ];
                    UserRegistrationController.controlerName = 'ute.rogers.user.registration.controller';
                    return UserRegistrationController;
                }());
                angular.module('ute.rogers.user.registration').controller(UserRegistrationController.controlerName, UserRegistrationController);
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                var ProviderBase = ute.common.core.ProviderBase;
                var ResponseErrorHandlerGeneric = ute.common.core.service.ResponseErrorHandlerGeneric;
                /**
                 * Private
                 */
                var BackEndErrorCode = (function () {
                    function BackEndErrorCode() {
                    }
                    BackEndErrorCode.SAVE_OK = 0;
                    BackEndErrorCode.GENERIC_ERROR = 17082;
                    BackEndErrorCode.CREATE_PROFILE_PROFILE_ALREADY_EXIST = 17083;
                    return BackEndErrorCode;
                }());
                (function (FrontEndErrorCode) {
                    FrontEndErrorCode[FrontEndErrorCode["SAVE_OK"] = 0] = "SAVE_OK";
                    FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                    FrontEndErrorCode[FrontEndErrorCode["CREATE_PROFILE_PROFILE_ALREADY_EXIST"] = 2] = "CREATE_PROFILE_PROFILE_ALREADY_EXIST";
                })(registration.FrontEndErrorCode || (registration.FrontEndErrorCode = {}));
                var FrontEndErrorCode = registration.FrontEndErrorCode;
                var UserRegistrationService = (function (_super) {
                    __extends(UserRegistrationService, _super);
                    function UserRegistrationService(config, $injector, $http, $timeout, $state, encryptionService) {
                        var _this = this;
                        _super.call(this, FrontEndErrorCode.GENERIC_ERROR, BackEndErrorCode.GENERIC_ERROR, UserRegistrationService.serviceName, $injector);
                        this.config = config;
                        this.$injector = $injector;
                        this.$http = $http;
                        this.$timeout = $timeout;
                        this.$state = $state;
                        this.encryptionService = encryptionService;
                        this.getConfig = function () { return angular.copy(_this.config); };
                        this.isUserRegistrationCallInProgress = function () { return _this.isCallInProgress; };
                        /**
                         * Return immutable IUserRegistrationModel object
                         * @returns {IUserRegistrationModel}
                         */
                        this.getModel = function () {
                            // console.log(UserRegistrationService.serviceName + '->getModel->model', this.model);
                            return angular.copy(_this.model);
                        };
                        /**
                         * @returns {IPromise<ICodeEntry>}
                         */
                        this.registerUser = function (model) {
                            // this.model = _.assign({}, this.model, model);
                            var self = _this;
                            var deferred = _this.$q.defer();
                            grecaptcha.execute('6LcPtLoUAAAAADsi2E1nlo8deAULkCWNVSgsoEB7', {
                                action: 'login'
                            }).then(function (token) {
                                self.model = (_.assign({}, self.model, model));
                                // this.model = model;
                                var request = {
                                    email: self.model.email,
                                    lang: self.model.lang,
                                    // reCaptchaResponse: this.model.reCaptchaResponse
                                    recaptcha: token
                                };
                                self.isCallInProgress = true;
                                self.$http.post(self.config.basic.apiUrl, request)
                                    .then(function (data) { return deferred.resolve(self.processOk(data)); })
                                    .catch(function (error) {
                                    var processedErrorPromise = self.processError(error);
                                    if (processedErrorPromise) {
                                        processedErrorPromise.then(function (data) { return console.log(data); }, function (errorResp) { return deferred.reject(errorResp); });
                                    }
                                })
                                    .finally(self.finaliseCall);
                            });
                            return deferred.promise;
                        };
                        this.goToConfirmation = function () {
                            // console.log(UserRegistrationService.serviceName + '->goToConfirmation->', this.model);
                            return _this.$state.go(_this.config.advanced.confirmation.stateName);
                        };
                        /**
                         * implementation of ute.blocks.router.IStateHandler
                         * @param event
                         * @param toState
                         * @param toParams
                         * @param fromState
                         * @param fromParams
                         * @returns {boolean}
                         */
                        this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                            _this.restoreFromInput(toParams).then(function (result) {
                                // console.log(UserRegistrationService.serviceName + '->stateTransitionHandler->then', result);
                                if (!result) {
                                    event.preventDefault();
                                }
                            });
                            return true;
                        };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processOk = function (response) {
                            var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                            // console.log(UserRegistrationService.serviceName + '->processOk:', 'response:', response, 'backendCode:', backendCode, this.findCodeEntry(backendCode));
                            return _this.findCodeEntry(backendCode);
                        };
                        this.finaliseCall = function () {
                            _this.isCallInProgress = false;
                            _this.model.reCaptchaResponse = undefined;
                        };
                        /**
                         * @param $stateParams
                         * @returns {IPromise<boolean>}
                         */
                        this.restoreFromInput = function ($stateParams) {
                            if ($stateParams.id) {
                                return _this.encryptionService.decrypt($stateParams.id).then(function (obj) {
                                    // console.log(UserRegistrationService.serviceName + '->restoreFromInput->then', obj);
                                    if (obj.email) {
                                        _this.model.email = obj.email;
                                        return true;
                                    }
                                    else {
                                        // this.$state.go(this.config.advanced.registration.stateName);
                                        return false;
                                    }
                                }).catch(function (error) {
                                    // console.log(UserRegistrationService.serviceName + '->restoreFromInput->catch', error);
                                    // this.$state.go(this.config.advanced.registration.stateName);
                                    return false;
                                });
                            }
                            else {
                                // this.$state.go(this.config.advanced.registration.stateName);
                                return new _this.$q(function (resolve) { return resolve(false); });
                            }
                        };
                        /**
                         * Reset model to initial state
                         */
                        this.resetModel = function () {
                            _this.model = {
                                email: undefined,
                                confirmEmail: undefined,
                                lang: 'en',
                                reCaptchaResponse: undefined
                            };
                        };
                        this.addCodes = function () {
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.SAVE_OK,
                                backendCode: BackEndErrorCode.SAVE_OK
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.GENERIC_ERROR,
                                frontendMessageKey: 'ute.rogers.user.registration.system.error.message',
                                backendCode: BackEndErrorCode.GENERIC_ERROR /*,
                                 boldChat: {
                                 cbid: 'ute.rogers.myrSimCard.boldChat.cbid',
                                 dynamicDivId: 'ute.rogers.myrSimCard.boldChat.dynamicDivId',
                                 chatButtonClass: 'ute.rogers.myrSimCard.boldChat.chatButtonClass'
                                 }*/
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.CREATE_PROFILE_PROFILE_ALREADY_EXIST,
                                frontendMessageKey: 'ute.rogers.user.registration.account.already.associated',
                                backendCode: BackEndErrorCode.CREATE_PROFILE_PROFILE_ALREADY_EXIST,
                                boldChat: {
                                    cbid: 'ute.rogers.user.registration.boldChat.cbid',
                                    dynamicDivId: 'ute.rogers.user.registration.boldChat.dynamicDivId',
                                    chatButtonClass: 'ute.rogers.user.registration.boldChat.chatButtonClass'
                                }
                            });
                        };
                        this.addCodes();
                        this.resetModel();
                    }
                    ;
                    UserRegistrationService.serviceName = 'ute.rogers.user.registration.service';
                    return UserRegistrationService;
                }(ResponseErrorHandlerGeneric));
                var UserRegistrationProvider = (function (_super) {
                    __extends(UserRegistrationProvider, _super);
                    /* @ngInject */
                    function UserRegistrationProvider() {
                        var _this = this;
                        _super.call(this);
                        /* @ngInject */
                        this.$get = function ($injector, $http, $timeout, $state) {
                            return new UserRegistrationService(_this.config, $injector, $http, $timeout, $state, $injector.get('ute.common.encryption.service'));
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http',
                            '$timeout',
                            '$state'
                        ];
                        this.config = registration.DefaultConfigFactory();
                    }
                    UserRegistrationProvider.$inject = [];
                    return UserRegistrationProvider;
                }(ProviderBase));
                angular.module('ute.rogers.user.registration').provider(UserRegistrationService.serviceName, UserRegistrationProvider);
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                function DefaultConfigFactory() {
                    return {
                        basic: {
                            apiUrl: 'api/v2/profile/create',
                            dtmName: 'account registration',
                            logPrefix: 'UserRegistration',
                            logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                            recaptchaSiteKey: '6LfmNCYTAAAAALEqhfoLZeelZ5jWm3vsW_xUeYpf'
                        },
                        advanced: {
                            registration: {
                                stateName: 'sso/registration',
                                cancelState: 'wireless',
                                controllerName: 'ute.rogers.user.registration.controller',
                                templateUrl: 'module/registrationStart/userRegistration.html',
                            },
                            confirmation: {
                                stateName: 'sso/registrationConfirmation',
                                controllerName: 'ute.rogers.user.registration.confirmation.controller',
                                templateUrl: 'module/registrationConfirmation/registrationConfirmation.html',
                            },
                            supportedLanguages: {
                                en: 'English',
                                fr: 'Français'
                            }
                        }
                    };
                }
                registration.DefaultConfigFactory = DefaultConfigFactory;
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var runtime;
        (function (runtime) {
            var translate;
            (function (translate) {
                'use strict';
                var RuntimeTranslateProvider = (function () {
                    /* @ngInject */
                    function RuntimeTranslateProvider($translateProvider) {
                        var _this = this;
                        this.$translateProvider = $translateProvider;
                        /* @ngInject */
                        this.$get = ["$injector", "$translate", function ($injector, $translate) {
                            _this.$translate = $translate;
                            return {
                                addTranslations: _this.addTranslations,
                                addTranslation: _this.addTranslation,
                                hasTranslation: _this.hasTranslation
                            };
                        }];
                        /**
                         * @param langKey
                         * @param translationTable
                         * @returns {ute.common.runtime.translate.RuntimeTranslateProvider}
                         */
                        this.addTranslations = function (langKey, translationTable) {
                            if (langKey && translationTable) {
                                _this.$translateProvider.translations(langKey, translationTable);
                            }
                            return _this;
                        };
                        /**
                         * @param langKey
                         * @param trKey
                         * @param trVal
                         * @returns {ute.common.runtime.translate.RuntimeTranslateProvider}
                         */
                        this.addTranslation = function (langKey, trKey, trVal) {
                            if (langKey && trKey) {
                                var translationTable = {};
                                translationTable[trKey] = trVal;
                                _this.$translateProvider.translations(langKey, translationTable);
                            }
                            return _this;
                        };
                        /**
                         * @param key
                         * @returns {boolean}
                         */
                        this.hasTranslation = function (key) {
                            try {
                                return !_.isEmpty(_this.$translate.instant(key));
                            }
                            catch (e) {
                                console.log('aaaaaaaaaa', e.message, e.name);
                                return false;
                            }
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$translate'
                        ];
                    }
                    RuntimeTranslateProvider.$inject = ['$translateProvider'];
                    return RuntimeTranslateProvider;
                }());
                angular.module('ute.common.runtime.translate').provider('ute.common.runtime.translate.service', RuntimeTranslateProvider);
            })(translate = runtime.translate || (runtime.translate = {}));
        })(runtime = common.runtime || (common.runtime = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var security;
        (function (security) {
            'use strict';
            // import UserType = ute.common.user.UserType;
            var SecurityProvider = (function () {
                /* @ngInject */
                function SecurityProvider(userProvider) {
                    var _this = this;
                    this.userProvider = userProvider;
                    // private protectedUrlPrefix: string = '/web/RogersServices.portal/totes/api/';
                    // private publicUrlPrefix: string = '/web/totes/api/';
                    /* @ngInject */
                    this.$get = ["$injector", "$state", function ($injector, $state) {
                        _this.$state = $state;
                        _this.userService = $injector.get('ute.common.user.service');
                        return {
                            isStateProtected: _this.isStateProtected,
                            getBackendUrl: _this.userService.getBackendUrl
                        };
                    }];
                    /**
                     * @param state
                     * @returns {boolean}
                     */
                    this.isStateProtected = function (state) {
                        var roles = _.get(_.isString(state) ? _this.$state.get(state) : state, 'data.security.roles');
                        // if not exists = public
                        return !(angular.isUndefined(roles) || _.contains(roles, 'public'));
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$state'
                    ];
                    // this.config.roleToUrlBase[UserType[UserType.care]] = this.publicUrlPrefix;
                    // this.config.roleToUrlBase[UserType[UserType.careRep]] = this.publicUrlPrefix;
                    // this.config.roleToUrlBase[UserType[UserType.dealer]] = this.publicUrlPrefix;
                    // this.config.roleToUrlBase[UserType[UserType.consumer]] = this.protectedUrlPrefix;
                }
                /**
                 * @param config
                 * @returns {boolean}
                 */
                SecurityProvider.prototype.configure = function (config) {
                    // this.config = <ISecurityConfig>_.merge(this.config, config);
                    // this.userProvider.configure({roleToUrlBase: config.roleToUrlBase});
                    return true;
                };
                SecurityProvider.$inject = ['ute.common.user.serviceProvider'];
                return SecurityProvider;
            }());
            angular.module('ute.common.security').provider('ute.common.security.service', SecurityProvider);
        })(security = common.security || (common.security = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    var SimCardController = (function () {
                        /* @ngInject */
                        function SimCardController($document, simCardService) {
                            this.$document = $document;
                            this.simCardService = simCardService;
                            this.howToFindNumberPartialPath = simCardService.getConfig().advanced.secondaryColumnPartialPath;
                            this.simCardHeaderPartialPath = simCardService.getConfig().advanced.simCardHeaderPartialPath;
                            this.simCardDefaultPartialPath = simCardService.getConfig().advanced.simCardDefaultPartialPath;
                            this.getCtn = simCardService.getPhoneNumber;
                            this.getBan = simCardService.getAccountNumber;
                            this.getEmail = simCardService.getAccountEmail;
                            simCardService.restoreFromInput();
                            $document.scrollTop(0);
                        }
                        SimCardController.$inject = ['$document', 'ute.common.simcard.change.service'];
                        return SimCardController;
                    }());
                    service.SimCardController = SimCardController;
                    angular.module('ute.common.simcard.change').controller('ute.common.simcard.change.main.controller', SimCardController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.service').run(simCardRoutesConfig);
                    simCardRoutesConfig.$inject = ['ute.blocks.router', 'ute.common.simcard.change.service'];
                    /* @ngInject */
                    function simCardRoutesConfig(routerHelper, simCardService) {
                        routerHelper.configureStates(getStates(simCardService));
                    }
                    function getStates(simCardService) {
                        var simCardRootState = simCardService.getConfig().basic.simCardRootState;
                        return [
                            {
                                name: simCardRootState,
                                abstract: true,
                                url: '/' + simCardRootState,
                                controller: simCardService.getConfig().basic.mainControllerName,
                                controllerAs: 'sc',
                                templateUrl: simCardService.getConfig().basic.mainTemplateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] }
                                },
                                resolve: simCardService.getConfig().advanced.resolve
                            },
                            {
                                name: simCardService.getEntryState(),
                                url: '/' + simCardService.getConfig().advanced.enterSimCard.subState + '/:id',
                                controller: simCardService.getConfig().advanced.enterSimCard.controllerName,
                                controllerAs: 'sc',
                                templateUrl: simCardService.getConfig().advanced.enterSimCard.templateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] },
                                    encryption: { params: ['id'], failbackState: simCardService.getConfig().advanced.enterSimCard.cancelState }
                                }
                            },
                            {
                                name: simCardRootState + '.' + simCardService.getConfig().advanced.confirmation.subState,
                                url: '/' + simCardService.getConfig().advanced.confirmation.subState + '/:id',
                                controller: simCardService.getConfig().advanced.confirmation.controllerName,
                                controllerAs: 'sc',
                                templateUrl: simCardService.getConfig().advanced.confirmation.templateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] },
                                    encryption: { params: ['id'], failbackState: simCardService.getConfig().advanced.enterSimCard.cancelState }
                                }
                            },
                            {
                                name: simCardRootState + '.' + simCardService.getConfig().advanced.success.subState,
                                url: '/' + simCardService.getConfig().advanced.success.subState + '/:id',
                                controller: simCardService.getConfig().advanced.success.controllerName,
                                controllerAs: 'sc',
                                templateUrl: simCardService.getConfig().advanced.success.templateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] },
                                    encryption: { params: ['id'], failbackState: simCardService.getConfig().advanced.enterSimCard.cancelState }
                                }
                            }];
                    }
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
            var ForgotPasswordController = (function () {
                /* @ngInject */
                function ForgotPasswordController($document, setPasswordService, $modal, datalayerService, $scope, $modalInstance, $http) {
                    var _this = this;
                    this.$document = $document;
                    this.setPasswordService = setPasswordService;
                    this.$modal = $modal;
                    this.datalayerService = datalayerService;
                    this.$scope = $scope;
                    this.$modalInstance = $modalInstance;
                    this.$http = $http;
                    this.showMigrationContent = false;
                    this.autoRegSuccess = false;
                    this.autoRegFail = false;
                    this.autoRegEmailNotSent = false;
                    this.disableResendBtn = false;
                    this.isRogersForgotPasswordCallInProgress = this.setPasswordService.isRogersForgotPasswordCallInProgress;
                    /**
                     * @returns {IPromise<any>}
                     */
                    this.submit = function () {
                        // console.log(ForgotPasswordController.controlerName + '->submit continue');
                        if (_this.form.$valid) {
                            _this.errorMessageKey = null;
                            return _this.setPasswordService.forgotPassword(_this.model)
                                .then(_this.processOk)
                                .catch(_this.processError);
                        }
                        else {
                            return null;
                        }
                    };
                    /**
                     * @returns boolean
                     */
                    this.isLegacyUser = function () {
                        var emailaddress = _this.model.email, pattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
                        return pattern.test(emailaddress);
                    };
                    /**
                     * @returns {IPromise<any>}
                     */
                    this.cancel = function () {
                        // console.log(ForgotPasswordController.controlerName + '->submit has been called');
                        _this.setPasswordService.goToState(_this.config.advanced.forgotPassword.cancelState);
                    };
                    this.isSubmitButtonEnable = function () {
                        return _this.form.$valid && !_this.isRogersForgotPasswordCallInProgress();
                    };
                    this.processOk = function (codeEntry) {
                        // console.log(ForgotPasswordController.controlerName + '->processOk: codeEntry=', codeEntry);
                        // return this.userRegistrationService.goToConfirmation();
                        // return codeEntry;
                        var selectedSections = [
                            DataLayerPredefinedSection.ACCOUNT,
                            DataLayerPredefinedSection.PAGE,
                            DataLayerPredefinedSection.PAGE_VIEW_EVENT,
                            DataLayerPredefinedSection.SITE
                        ];
                        var payload = {};
                        payload = {
                            page: {
                                name: 'forgotPasswordVerificationSent',
                                hierarchy: ['selfserve', 'forgotPassword']
                            },
                            selfServe: {
                                type: 'transaction',
                                name: 'Reset Password'
                            },
                            events: {
                                selfServeComplete: true
                            }
                        };
                        _this.brtCheck().then(function () {
                            if (!_this.showMigrationContent) {
                                _this.datalayerService.track(payload, false, selectedSections);
                            }
                        });
                        return null; // TODO
                    };
                    this.brtCheck = function () {
                        _this.userMigratedResponse = _this.setPasswordService.getUserMigratedEmailResponse();
                        var req = {
                            username: _this.model.email
                        };
                        _this.setPasswordService.autoRegistrationStatus(req).then(function (response) {
                            if (response.data.autoRegFlag && response.data.autoRegFlag === true) {
                                _this.disableResendBtn = true;
                            }
                        });
                        return _this.setPasswordService.brtSwitches().then(function (migrationSwitch) {
                            if (migrationSwitch && !(_this.userMigratedResponse === null)) {
                                _this.showMigrationContent = true;
                            }
                        }, function (error) { _this.showMigrationContent = false; });
                    };
                    /**
                     * @param codeEntry
                     */
                    this.processError = function (codeEntry) {
                        // console.log(ForgotPasswordController.controlerName + '->processError: codeEntry=', codeEntry);
                        _this.errorMessageKey = codeEntry.frontendMessageKey;
                        // this.userRegistrationService.goToConfirmation();
                        _this.openModalPopup(codeEntry);
                    };
                    this.closeConfirmationPopup = function () {
                        _this.confirmationModal.close();
                    };
                    $document.scrollTop(0);
                    this.setPasswordService.resetForgotPasswordModel();
                    this.model = this.setPasswordService.getForgotPasswordModel();
                    this.config = this.setPasswordService.getConfig();
                }
                ForgotPasswordController.prototype.openModalPopup = function (errorHandler) {
                    this.$modal.open({
                        windowTemplateUrl: _.isEmpty(errorHandler.windowTemplateUrl) ? this.config.advanced.genericErrorModal.windowTemplateUrl : errorHandler.windowTemplateUrl,
                        templateUrl: errorHandler.templateUrl,
                        controller: _.isEmpty(errorHandler.controller) ? this.config.advanced.genericErrorModal.controllerName : errorHandler.controller,
                        controllerAs: 'errorModal',
                        size: errorHandler.modalSize,
                        backdrop: 'static',
                        resolve: {
                            'ute.rogers.setpassword.errorHandler': errorHandler,
                            'ute.janrain.verification.errorHandler': errorHandler
                        }
                    }).result.then(function (result) {
                        // Result selection behaviour
                        switch (result) {
                            case 'yes':
                                // this.simCardService.cancelSimCardChange();
                                break;
                            case 'no':
                                // this.simCardService.goToSubModule(this.simCardService.getConfig().advanced.enterSimCard.subState);
                                break;
                        }
                    }, function () {
                        // Dismiss behaviour
                        // Do nothing/close
                    });
                };
                ForgotPasswordController.prototype.autoRegEmail = function (bizMigratedEmailResponsesList) {
                    var _this = this;
                    this.selectedEmailForAutoReg = bizMigratedEmailResponsesList.migratedEmail;
                    var request = {
                        APIKey: '',
                        accountNumber: bizMigratedEmailResponsesList.acctNbr,
                        email: bizMigratedEmailResponsesList.migratedEmail,
                        language: bizMigratedEmailResponsesList.language,
                        realm: 'ROGERS',
                        consolidatedAccNumber: '',
                        billType: '1'
                    };
                    var today = new Date();
                    var emailDate = new Date(bizMigratedEmailResponsesList.autoreg_email_date);
                    var timeDiff = today.getTime() - emailDate.getTime();
                    var daysDiff = Math.round(timeDiff / (1000 * 3600 * 24));
                    this.setPasswordService.autoRegistrationCall(request).then(function (response) {
                        if (response.data.status === 'SUCCESS') {
                            _this.autoRegSuccess = true;
                            _this.apiCount = response.data.apiCount;
                            _this.openConfirmationPopup();
                        }
                    }, function (error) {
                        if (error.data.errorCode == 403) {
                            _this.autoRegFail = true;
                        }
                        else {
                            _this.autoRegSuccess = false;
                            _this.openModalPopup(error);
                        }
                    });
                    //this.autoRegEmailNotSent = true;
                    //this.openConfirmationPopup();
                };
                ;
                ForgotPasswordController.prototype.openConfirmationPopup = function () {
                    this.confirmationModal = this.$modal.open({
                        templateUrl: 'module/forgotPassword/emailRetriggerConfirmationPopup.html',
                        scope: this.$scope,
                        backdrop: 'static',
                        windowClass: 'soho-migration'
                    });
                    this.confirmationModal.result.then(function (result) {
                        // Result selection behaviour
                        switch (result) {
                            case 'yes':
                                // this.simCardService.cancelSimCardChange();
                                break;
                            case 'no':
                                // this.simCardService.goToSubModule(this.simCardService.getConfig().advanced.enterSimCard.subState);
                                break;
                        }
                    }, function () {
                        // Dismiss behaviour
                        // Do nothing/close
                    });
                };
                ForgotPasswordController.$inject = ['$document',
                    'ute.rogers.setpassword.service',
                    '$modal',
                    'ute.datalayer.common.service',
                    '$scope'
                ];
                ForgotPasswordController.controlerName = 'ute.rogers.forgotpassword.controller';
                return ForgotPasswordController;
            }());
            angular.module('ute.rogers.setpassword').controller(ForgotPasswordController.controlerName, ForgotPasswordController);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
            var SetPasswordController = (function () {
                /* @ngInject */
                function SetPasswordController($document, $injector, setPasswordService, utilsService, janrainVerificationService, $modal, datalayerService, $q) {
                    var _this = this;
                    this.$document = $document;
                    this.setPasswordService = setPasswordService;
                    this.utilsService = utilsService;
                    this.janrainVerificationService = janrainVerificationService;
                    this.$modal = $modal;
                    this.datalayerService = datalayerService;
                    this.$q = $q;
                    this.getVerificationCode = this.janrainVerificationService.getVerificationCode;
                    this.getUuid = this.janrainVerificationService.getUuid;
                    this.getEmail = this.janrainVerificationService.getEmail;
                    this.isCodeValid = this.janrainVerificationService.isCodeValid;
                    // isExpired: () => boolean = this.janrainVerificationService.isCodeExpired;
                    this.isResetPassword = this.setPasswordService.isResetPassword;
                    this.isAlphabetOnly = this.utilsService.isAlphabetOnly;
                    this.isAlphanumeric = this.utilsService.isAlphanumeric;
                    this.isNumericOnly = this.utilsService.isNumericOnly;
                    this.isJanrainVerificationCallInProgress = this.janrainVerificationService.isJanrainVerificationCallInProgress;
                    this.isRogersSetPasswordCallInProgress = this.setPasswordService.isRogersSetPasswordCallInProgress;
                    // verifyJanrainCode: ($event?: IAngularEvent) => ng.IPromise<ICodeEntry> = ($event?: IAngularEvent) => {
                    //   if ($event) {
                    //     $event.preventDefault();
                    //   }
                    //   //   return this.janrainVerificationService.verifyJanrainCode().then((code: ICodeEntry) => {
                    //   //     // console.log(JanrainVerificationController.controlerName + '->verifyJanrainCode: code=', code);
                    //   //     return code;
                    //   //   });
                    //   return null;
                    // };
                    this.init = function () {
                        var selectedSections = [
                            DataLayerPredefinedSection.ACCOUNT,
                            DataLayerPredefinedSection.PAGE,
                            DataLayerPredefinedSection.PAGE_VIEW_EVENT,
                            DataLayerPredefinedSection.SITE
                        ];
                        var payload = {};
                        if (_this.isResetPassword()) {
                            payload = {
                                page: {
                                    name: 'setPassword',
                                    hierarchy: ['selfserve', 'setPassword']
                                },
                                selfServe: {
                                    type: 'transaction',
                                    name: 'Set New Password (Reset)'
                                },
                                events: {
                                    selfServeStart: true
                                }
                            };
                        }
                        else {
                            payload = {
                                page: {
                                    name: 'setNewPassword',
                                    hierarchy: ['selfserve', 'setPassword']
                                },
                                selfServe: {
                                    type: 'transaction',
                                    name: 'Set New Password (New Registration)'
                                },
                                events: {
                                    selfServeStart: true
                                }
                            };
                        }
                        _this.datalayerService.track(payload, false, selectedSections);
                        return null;
                    };
                    /**
                     * @returns {IPromise<any>}
                     */
                    this.submit = function () {
                        // console.log(SetPasswordController.controlerName + '->submit has been called');
                        if (_this.form.$valid) {
                            _this.errorMessageKey = null;
                            return _this.setPasswordService.savePassword(_this.model)
                                .then(_this.processOk)
                                .catch(_this.processError);
                        }
                        else {
                            return null;
                        }
                    };
                    this.isPasswordsMatched = function () {
                        return _this.model.newPassword === _this.model.confirmPassword;
                    };
                    this.isSubmitButtonEnable = function () {
                        return _.get(_this.form, '$valid', false) && _this.isPasswordsMatched() && !_this.isRogersSetPasswordCallInProgress();
                    };
                    this.processOk = function (codeEntry) {
                        // console.log(SetPasswordController.controlerName + '->processOk: codeEntry=', codeEntry);
                        return _this.setPasswordService.onSuccessSetPassword();
                    };
                    /**
                     * @param codeEntry
                     */
                    this.processError = function (codeEntry) {
                        // console.log(SetPasswordController.controlerName + '->processError: codeEntry=', codeEntry);
                        _this.errorMessageKey = codeEntry.frontendMessageKey;
                        // this.userRegistrationService.goToConfirmation();
                        _this.openModalPopup(codeEntry);
                    };
                    $document.scrollTop(0);
                    this.datalayerService = $injector.get('ute.datalayer.common.service');
                    this.model = this.setPasswordService.getModel();
                    this.config = this.setPasswordService.getConfig();
                    this.init();
                }
                SetPasswordController.prototype.openModalPopup = function (errorHandler) {
                    this.$modal.open({
                        windowTemplateUrl: this.config.advanced.genericErrorModal.windowTemplateUrl,
                        templateUrl: errorHandler.templateUrl,
                        controller: this.config.advanced.genericErrorModal.controllerName,
                        controllerAs: 'errorModal',
                        size: errorHandler.modalSize,
                        backdrop: 'static',
                        resolve: {
                            'ute.rogers.setpassword.errorHandler': errorHandler
                        }
                    }).result.then(function (result) {
                        // Result selection behaviour
                        switch (result) {
                            case 'yes':
                                // this.simCardService.cancelSimCardChange();
                                break;
                            case 'no':
                                // this.simCardService.goToSubModule(this.simCardService.getConfig().advanced.enterSimCard.subState);
                                break;
                        }
                    }, function () {
                        // Dismiss behaviour
                        // Do nothing/close
                    });
                };
                SetPasswordController.$inject = ['$document',
                    '$injector',
                    'ute.rogers.setpassword.service',
                    'ute.common.utils.service',
                    'ute.janrain.verification.service',
                    '$modal',
                    'ute.datalayer.common.service',
                    '$q'
                ];
                SetPasswordController.controlerName = 'ute.rogers.setpassword.controller';
                return SetPasswordController;
            }());
            angular.module('ute.rogers.setpassword').controller(SetPasswordController.controlerName, SetPasswordController);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            angular.module('ute.rogers.setpassword').run(setPasswordRoutesConfig);
            setPasswordRoutesConfig.$inject = ['ute.blocks.router',
                'ute.rogers.setpassword.service',
                'ute.janrain.verification.service'
            ];
            function setPasswordRoutesConfig(routerHelper, setPasswordService, janrainVerificationService) {
                var config = setPasswordService.getConfig();
                routerHelper.configureStates([
                    {
                        name: config.advanced.setPassword.stateName,
                        url: '/' + config.advanced.setPassword.stateName + '/:id',
                        // url: '/' + config.advanced.setPassword.stateName,
                        controller: config.advanced.setPassword.controllerName,
                        controllerAs: 'setPasswordCtrl',
                        templateUrl: config.advanced.setPassword.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['public'] },
                            settings: {
                                codeVerificationApiUrl: config.advanced.setPassword.codeVerificationApiUrl,
                                needAutoRegCheck: config.advanced.setPassword.needAutoRegCheck
                            }
                        }
                    },
                    {
                        name: config.advanced.resetPassword.stateName,
                        url: '/' + config.advanced.resetPassword.stateName + '/:id',
                        // url: '/' + config.advanced.resetPassword.stateName,
                        controller: config.advanced.resetPassword.controllerName,
                        controllerAs: 'setPasswordCtrl',
                        templateUrl: config.advanced.resetPassword.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['public'] },
                            settings: {
                                codeVerificationApiUrl: config.advanced.resetPassword.codeVerificationApiUrl,
                                needAutoRegCheck: config.advanced.resetPassword.needAutoRegCheck
                            }
                        }
                    },
                    {
                        name: config.advanced.forgotPassword.stateName,
                        url: '/' + config.advanced.forgotPassword.stateName,
                        controller: config.advanced.forgotPassword.controllerName,
                        controllerAs: 'forgotPasswordCtrl',
                        templateUrl: config.advanced.forgotPassword.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['public'] }
                        }
                    }
                ]);
                routerHelper.registerToStateHandler(config.advanced.setPassword.stateName, janrainVerificationService, ute.blocks.router.StateHandlerPriority.LOW);
                routerHelper.registerToStateHandler(config.advanced.resetPassword.stateName, janrainVerificationService, ute.blocks.router.StateHandlerPriority.LOW);
                routerHelper.registerFromStateHandler(config.advanced.setPassword.stateName, janrainVerificationService, ute.blocks.router.StateHandlerPriority.LOW);
                routerHelper.registerFromStateHandler(config.advanced.resetPassword.stateName, janrainVerificationService, ute.blocks.router.StateHandlerPriority.LOW);
            }
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            /* @ngInject */
            var ErrorController = (function () {
                /* @ngInject */
                function ErrorController($modalInstance, setPasswordService, errorHandler) {
                    // console.log(ErrorController.controlerName + '->constructor: errorHandler:', errorHandler);
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.setPasswordService = setPasswordService;
                    this.errorHandler = errorHandler;
                    // getUserEmailAddress(): string {
                    //   // return this.simCardService.getUser().userEmail;
                    //   return this.simCardService.getAccountEmail();
                    // }
                    //
                    // finishedRoute(): angular.IPromise<any> {
                    //   return this.simCardService.finishedRoute();
                    // }
                    this.noSelection = function () {
                        _this.$modalInstance.dismiss('cancel');
                    };
                }
                ErrorController.$inject = [
                    '$modalInstance',
                    'ute.rogers.setpassword.service',
                    'ute.rogers.setpassword.errorHandler'];
                ErrorController.controlerName = 'ute.rogers.setpassword.error.controller';
                return ErrorController;
            }());
            angular.module('ute.rogers.setpassword').controller(ErrorController.controlerName, ErrorController);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            'use strict';
            angular.module('ute.janrain.verification').run(setPasswordRoutesConfig);
            setPasswordRoutesConfig.$inject = ['ute.blocks.router',
                'ute.janrain.verification.service'
            ];
            function setPasswordRoutesConfig(routerHelper, janrainVerificationService) {
                var config = janrainVerificationService.getConfig();
                routerHelper.configureStates([
                    {
                        name: config.advanced.emailResendConfirmation.stateName,
                        url: '/' + config.advanced.emailResendConfirmation.stateName,
                        // url: '/' + config.advanced.setPassword.stateName,
                        controller: config.advanced.emailResendConfirmation.controllerName,
                        controllerAs: 'resendEmail',
                        templateUrl: config.advanced.emailResendConfirmation.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['public'] }
                        }
                    }
                ]);
                routerHelper.registerToStateHandler(config.advanced.emailResendConfirmation.stateName, janrainVerificationService, ute.blocks.router.StateHandlerPriority.LOW);
            }
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                angular.module('ute.common.suspend.ctn').run(suspendCtnRoutesConfig);
                suspendCtnRoutesConfig.$inject = ['ute.blocks.router', 'ute.common.suspend.ctn.service'];
                /* @ngInject */
                function suspendCtnRoutesConfig(routerHelper, suspendCtnService) {
                    routerHelper.configureStates(getStates(suspendCtnService));
                }
                function getStates(suspendCtnService) {
                    var suspendCtnRootState = suspendCtnService.getConfig().basic.suspendCtnRootState;
                    return [
                        {
                            name: suspendCtnRootState,
                            abstract: true,
                            url: '/' + suspendCtnRootState,
                            controller: suspendCtnService.getConfig().basic.mainControllerName,
                            controllerAs: 'mainSuspendDevice',
                            templateUrl: suspendCtnService.getConfig().basic.mainTemplateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] }
                            },
                            resolve: suspendCtnService.getConfig().advanced.resolve
                        },
                        {
                            name: suspendCtnService.getEntryState(),
                            url: '/' + suspendCtnService.getConfig().advanced.confirmSuspendDevice.subState + '/:id',
                            controller: suspendCtnService.getConfig().advanced.confirmSuspendDevice.controllerName,
                            controllerAs: 'confirmSuspendDevice',
                            templateUrl: suspendCtnService.getConfig().advanced.confirmSuspendDevice.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] },
                                encryption: { params: ['id'], failbackState: suspendCtnService.getConfig().basic.cancelState }
                            }
                        },
                        {
                            name: suspendCtnRootState + '.' + suspendCtnService.getConfig().advanced.suspendCtnSuccess.subState,
                            url: '/' + suspendCtnService.getConfig().advanced.suspendCtnSuccess.subState + '/:id',
                            controller: suspendCtnService.getConfig().advanced.suspendCtnSuccess.controllerName,
                            controllerAs: 'successSuspendDevice',
                            templateUrl: suspendCtnService.getConfig().advanced.suspendCtnSuccess.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] },
                                encryption: { params: ['id'], failbackState: suspendCtnService.getConfig().basic.cancelState }
                            }
                        }
                    ];
                }
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnMainController = (function () {
                    /* @ngInject */
                    function SuspendCtnMainController($document, suspendCtnService) {
                        this.$document = $document;
                        this.suspendCtnService = suspendCtnService;
                        suspendCtnService.restoreState();
                        $document.scrollTop(0);
                    }
                    SuspendCtnMainController.$inject = [
                        '$document',
                        'ute.common.suspend.ctn.service'
                    ];
                    return SuspendCtnMainController;
                }());
                ctn.SuspendCtnMainController = SuspendCtnMainController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.main.controller', SuspendCtnMainController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function () {
                    /* @ngInject */
                    UserTest.$inject = ["userService", "$animate"];
                    function UserTest(userService, $animate) {
                        var _this = this;
                        this.userService = userService;
                        this.$animate = $animate;
                        this.scope = {
                            uteUserHideIfAnyGranted: '@'
                        };
                        this.restrict = 'A';
                        this.multiElement = true;
                        this.test = function () {
                            return _this.userService.isSigned() && _.include(_this.rolesArray, _this.userService.getUserType());
                        };
                        this.linkFn = function (scope, instanceElement) {
                            _this.rolesArray = scope.uteUserHideIfAnyGranted ? scope.uteUserHideIfAnyGranted.split(',').map(function (s) { return s.trim(); }) : [];
                            scope.$watch(_this.test, function (value) {
                                _this.$animate[value ? 'addClass' : 'removeClass'](instanceElement, UserTest.NG_HIDE_CLASS, {
                                    tempClasses: UserTest.NG_HIDE_IN_PROGRESS_CLASS
                                });
                            });
                        };
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        var directive = function (userService, $animate) { return new UserTest(userService, $animate); };
                        directive.$inject = ['ute.common.user.service', '$animate'];
                        return directive;
                    };
                    UserTest.NG_HIDE_CLASS = 'ng-hide';
                    UserTest.NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
                    return UserTest;
                }());
                /**
                 * <div ute-user-hide-if-any-granted='role1,role2'> directive
                 */
                angular.module('ute.common.user').directive('uteUserHideIfAnyGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function () {
                    /* @ngInject */
                    UserTest.$inject = ["userService", "$animate"];
                    function UserTest(userService, $animate) {
                        var _this = this;
                        this.userService = userService;
                        this.$animate = $animate;
                        this.scope = {
                            uteUserShowIfAnyGranted: '@'
                        };
                        this.restrict = 'A';
                        this.multiElement = true;
                        this.test = function () {
                            return _this.userService.isSigned() && _.include(_this.rolesArray, _this.userService.getUserType());
                        };
                        this.linkFn = function (scope, instanceElement) {
                            _this.rolesArray = scope.uteUserShowIfAnyGranted ? scope.uteUserShowIfAnyGranted.split(',').map(function (s) { return s.trim(); }) : [];
                            scope.$watch(_this.test, function (value) {
                                // console.log('wwwwwwwwwwwwwwwwww', this.rolesArray, value, scope);
                                _this.$animate[value ? 'removeClass' : 'addClass'](instanceElement, UserTest.NG_HIDE_CLASS, {
                                    tempClasses: UserTest.NG_HIDE_IN_PROGRESS_CLASS
                                });
                            });
                        };
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        var directive = function (userService, $animate) { return new UserTest(userService, $animate); };
                        directive.$inject = ['ute.common.user.service', '$animate'];
                        return directive;
                    };
                    UserTest.NG_HIDE_CLASS = 'ng-hide';
                    UserTest.NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
                    return UserTest;
                }());
                /**
                 * <div ute-user-show-if-any-granted='role1,role2'> directive
                 */
                angular.module('ute.common.user').directive('uteUserShowIfAnyGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.scope = {
                            roles: '@'
                        };
                        this.linkFn = function (scope) {
                            scope.rolesArray = scope.roles ? scope.roles.split(',').map(function (s) { return s.trim(); }) : [];
                        };
                        this.controller = Controller;
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.test = function () {
                            return _this.userService.isSigned() && _.include(_this.$scope.rolesArray, _this.userService.getUserType());
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-any-granted roles='consumer,dealer'> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfAnyGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.controller = Controller;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService) {
                        this.userService = userService;
                        this.test = this.userService.isSigned;
                    }
                    Controller.$inject = ['ute.common.user.service'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-logged-in> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfLoggedIn', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.scope = {
                            roles: '@'
                        };
                        this.linkFn = function (scope) {
                            scope.rolesArray = scope.roles ? scope.roles.split(',').map(function (s) { return s.trim(); }) : [];
                        };
                        this.controller = Controller;
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.test = function () {
                            return _this.userService.isSigned() && !_.include(_this.$scope.rolesArray, _this.userService.getUserType());
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-not-granted roles='consumer,dealer'> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfNotGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.controller = Controller;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService) {
                        var _this = this;
                        this.userService = userService;
                        this.test = function () { return !_this.userService.isSigned(); };
                    }
                    Controller.$inject = ['ute.common.user.service'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-not-logged-in> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfNotLoggedIn', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserInfo = (function () {
                    function UserInfo() {
                        this.restrict = 'E';
                        this.controllerAs = 'user';
                        this.scope = {
                            field: '@'
                        };
                        this.template = '{{user.getUserInfo()}}';
                        this.controller = Controller;
                    }
                    UserInfo.factory = function () {
                        return function () { return new UserInfo(); };
                    };
                    return UserInfo;
                }());
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.getUserInfo = function () {
                            try {
                                return _.get(_this.userService.getUser(), _this.$scope.field) || _this.userService['get' + _this.capitalize(_this.$scope.field)]();
                            }
                            catch (e) {
                            }
                        };
                        /**
                         * TODO 1. move it to ute common utils
                         * TODO 2. migrate to lodash 4.x and use _.upperFirst
                         * @param s
                         * @returns {string}
                         */
                        this.capitalize = function (s) {
                            return s && s[0].toUpperCase() + s.slice(1);
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-logged-in-user-info field='userEmail'> directive
                 * <ute-user-logged-in-user-info field='userRole'> directive
                 */
                angular.module('ute.common.user').directive('uteUserLoggedInUserInfo', UserInfo.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserSignout = (function () {
                    function UserSignout() {
                        this.restrict = 'E';
                        this.controllerAs = 'user';
                        this.scope = {
                            field: '@'
                        };
                        this.transclude = true;
                        this.template = '<div data-ng-click="user.userSignout()"><ng-transclude></ng-transclude></div>';
                        this.controller = Controller;
                    }
                    UserSignout.factory = function () {
                        return function () { return new UserSignout(); };
                    };
                    return UserSignout;
                }());
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.userSignout = function () {
                            try {
                                return _this.userService.signout();
                            }
                            catch (e) {
                            }
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-signout> directive
                 */
                angular.module('ute.common.user').directive('uteUserSignout', UserSignout.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                // TODO provider
                var BrtSwitchService = (function () {
                    /* @ngInject */
                    function BrtSwitchService($http, $timeout, exceptionHandler) {
                        var _this = this;
                        this.$http = $http;
                        this.$timeout = $timeout;
                        this.exceptionHandler = exceptionHandler;
                        /**
                         * @param key
                         * @returns {IPromise<boolean>}
                         */
                        this.getValue = function (key) {
                            return _this.getBrtSwitches().then(function (val) {
                                return _.get(_.find(val, { 'id': _.isNumber(key) ? brtswitch.BrtSwitches[key] : key }), 'switchIsOn');
                            });
                        };
                        /**
                         * @param keys
                         * @returns {IPromise<boolean>}
                         */
                        this.isSome = function (keys) {
                            return _this.getBrtSwitches().then(function (vals) {
                                return _.isEmpty(keys) ? false : _.intersection(_.chain(vals)
                                    .filter({ switchIsOn: true })
                                    .map(function (e) { return e.id; })
                                    .value(), _this.getKeys(keys)).length > 0;
                            });
                        };
                        /**
                         * @param keys
                         */
                        this.getKeys = function (keys) {
                            return _.isEmpty(keys) ? [] : _.isNumber(keys[0]) ? keys.map(function (key) { return brtswitch.BrtSwitches[key]; }) : keys;
                        };
                        /**
                         * @returns {IPromise<IBrtSwitches>}
                         * @private
                         */
                        this._getBrtSwitches = function () {
                            return _this.$http.post('/web/totes/api/v1/brtSwitches', {})
                                .then(_this.processBrtSwitchesResponse)
                                .catch(_.curry(_this.fail)('processBrtSwitchesResponse failed.'));
                        };
                        /**
                         * @param response
                         * @returns {IBrtSwitches}
                         */
                        this.processBrtSwitchesResponse = function (response) {
                            // console.log(BrtSwitchService.serviceName + '->processBrtSwitchesResponse', response.data);
                            return _.get(response, 'data', []);
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {IBrtSwitches}
                         */
                        this.fail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            _this.exceptionHandler.catcher(msg)(reason, 'ute.common.core.brtswitch fail');
                            _this.$timeout(_this.cleanCache);
                            return [];
                        };
                        this.cleanCache = function () {
                            _this.getBrtSwitches.cache.clear();
                        };
                        (_.memoize).Cache = window.Map; // required https://www.npmjs.com/package/es6-shim
                        this.getBrtSwitches = _.memoize(this._getBrtSwitches);
                    }
                    BrtSwitchService.$inject = [
                        '$http',
                        '$timeout',
                        'ute.blocks.exceptionService'
                    ];
                    BrtSwitchService.serviceName = 'ute.common.core.brtswitch.service';
                    return BrtSwitchService;
                }());
                angular.module('ute.common.core.brtswitch').service(BrtSwitchService.serviceName, BrtSwitchService);
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var environment;
        (function (environment) {
            'use strict';
            (function (EnvironmentType) {
                EnvironmentType[EnvironmentType["PROD"] = 0] = "PROD";
                EnvironmentType[EnvironmentType["QA"] = 1] = "QA";
                EnvironmentType[EnvironmentType["SIT"] = 2] = "SIT";
                EnvironmentType[EnvironmentType["DEV"] = 3] = "DEV";
                EnvironmentType[EnvironmentType["LOCAL"] = 4] = "LOCAL";
            })(environment.EnvironmentType || (environment.EnvironmentType = {}));
            var EnvironmentType = environment.EnvironmentType;
            var EnvironmentStatic = (function () {
                function EnvironmentStatic() {
                }
                /**
                 *
                 * @returns {ute.blocks.environment.EnvironmentType}
                 */
                EnvironmentStatic.getEnvType = function () {
                    if (location.hostname.indexOf('www.rogers.com') === 0) {
                        return ute.blocks.environment.EnvironmentType.PROD;
                    }
                    else if (location.hostname.indexOf('www.dev') === 0) {
                        return ute.blocks.environment.EnvironmentType.DEV;
                    }
                    else if (location.hostname.indexOf('www.qa') === 0) {
                        return ute.blocks.environment.EnvironmentType.QA;
                    }
                    else {
                        return ute.blocks.environment.EnvironmentType.LOCAL;
                    }
                };
                /**
                 * @returns {string}
                 */
                EnvironmentStatic.getEnvConfigPath = function () {
                    return 'environments/' + EnvironmentType[EnvironmentStatic.getEnvType()].toLowerCase() + '.js';
                };
                /**
                 *
                 * @param success
                 * @returns {JQueryXHR}
                 */
                EnvironmentStatic.getEnvConfig = function (success) {
                    return $.getScript(EnvironmentStatic.getEnvConfigPath(), success);
                };
                return EnvironmentStatic;
            }());
            environment.EnvironmentStatic = EnvironmentStatic;
            var EnvironmentHelperProvider = (function () {
                /* @ngInject */
                function EnvironmentHelperProvider(CONFIG) {
                    var _this = this;
                    this.config = {
                        url: '/environment.json'
                    };
                    /* @ngInject */
                    this.$get = function () {
                        return {
                            getProperty: _this.getProperty
                        };
                    };
                    this.configure = function (config) {
                        angular.extend(_this.config, config);
                        return true;
                    };
                    this.configureByHostName = function () {
                        _this.config.url = _this.buildEnvUrl(location.hostname);
                    };
                    this.configureByEnvType = function (envDetector) {
                        _this.config.url = _this.buildEnvUrl(EnvironmentType[envDetector ? envDetector.getEnvType() : EnvironmentStatic.getEnvType()].toLowerCase());
                    };
                    this.getProperty = function (name) {
                        return _.get(_this.envJson, name, name);
                    };
                    this.buildEnvUrl = function (name) { return '/environments/' + name + '.json'; };
                    this.$get.$inject = [];
                    this.envJson = CONFIG;
                }
                EnvironmentHelperProvider.$inject = ['CONFIG'];
                return EnvironmentHelperProvider;
            }());
            angular.module('ute.blocks.environment').provider('ute.blocks.environment', EnvironmentHelperProvider);
        })(environment = blocks.environment || (blocks.environment = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

// Include in index.html so that app level exceptions are handled.
// Exclude from testRunner.html which should run exactly what it wants to run
var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var exception;
        (function (exception_1) {
            'use strict';
            var ExceptionHandlerProvider = (function () {
                /* @ngInject */
                function ExceptionHandlerProvider() {
                    var _this = this;
                    this.config = {
                        appErrorPrefix: undefined
                    };
                    /* @ngInject */
                    this.$get = function () {
                        return { config: _this.config };
                    };
                    this.$get.$inject = [];
                }
                ExceptionHandlerProvider.prototype.configure = function (appErrorPrefix) {
                    this.config.appErrorPrefix = appErrorPrefix;
                };
                ExceptionHandlerProvider.$inject = [];
                return ExceptionHandlerProvider;
            }());
            config.$inject = ['$provide'];
            /* @ngInject */
            function config($provide) {
                $provide.decorator('$exceptionHandler', extendExceptionHandler);
            }
            extendExceptionHandler.$inject = ['$delegate', 'exceptionHandler', 'ute.blocks.loggerService'];
            /**
             * Extend the $exceptionHandler service to also display a toast.
             * @param  {Object} $delegate
             * @param  {Object} exceptionHandler
             * @param  {Object} logger
             * @return {Function} the decorated $exceptionHandler service
             */
            /* @ngInject */
            function extendExceptionHandler($delegate, exceptionHandler, logger) {
                return function (exception, cause) {
                    //            var appErrorPrefix = '[Error] ';
                    var appErrorPrefix = exceptionHandler.config.appErrorPrefix || '';
                    var errorData = { exception: exception, cause: cause };
                    exception.message = appErrorPrefix + exception.message;
                    $delegate(exception, cause);
                    /**
                     * Could add the error to a service's collection,
                     * add errors to $rootScope, log errors to remote web server,
                     * or log locally. Or throw hard. It is entirely up to you.
                     * throw exception;
                     * @example
                     *     throw { message: 'error message we added' };
                     */
                    logger.error(exception.message, errorData);
                };
            }
            angular.module('ute.blocks.exception').provider('exceptionHandler', ExceptionHandlerProvider).config(config);
        })(exception = blocks.exception || (blocks.exception = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var exception;
        (function (exception) {
            'use strict';
            var Exception = (function () {
                /* @ngInject */
                function Exception(logger) {
                    var _this = this;
                    this.logger = logger;
                    this.catcher = function (message) { return function (reason, title) { return _this.logger.error(message, reason, title); }; };
                }
                Exception.$inject = ['ute.blocks.loggerService'];
                return Exception;
            }());
            angular.module('ute.blocks.exception').service('ute.blocks.exceptionService', Exception);
        })(exception = blocks.exception || (blocks.exception = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var logger;
        (function (logger) {
            'use strict';
            var Logger = (function () {
                /* @ngInject */
                function Logger($log /*, private toastr: Toastr*/) {
                    this.$log = $log;
                }
                // straight to console; bypass toastr
                Logger.prototype.log = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i - 0] = arguments[_i];
                    }
                    this.$log.log(args);
                };
                Logger.prototype.error = function (message, data, title) {
                    //this.toastr.error(message, title);
                    this.$log.error('Error: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.prototype.info = function (message, data, title) {
                    //this.toastr.info(message, title);
                    this.$log.info('Info: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.prototype.success = function (message, data, title) {
                    //this.toastr.success(message, title);
                    this.$log.info('Success: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.prototype.warning = function (message, data, title) {
                    //this.toastr.warning(message, title);
                    this.$log.warn('Warning: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.$inject = ['$log' /*, 'toastr'*/];
                return Logger;
            }());
            angular.module('ute.blocks.logger').service('ute.blocks.loggerService', Logger);
        })(logger = blocks.logger || (blocks.logger = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnErrorController = (function () {
                    /* @ngInject */
                    function ReactivateCtnErrorController($modalInstance, reactivateCtnService, errorCode) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.reactivateCtnService = reactivateCtnService;
                        this.errorCode = errorCode;
                        this.backToDevicePage = function () {
                            _this.$modalInstance.dismiss('cancel');
                            _this.reactivateCtnService.backToDevice();
                        };
                        if (errorCode) {
                            this.errorMessage = errorCode.frontendMessageKey;
                            this.modalIcon = errorCode.modalIcon;
                        }
                    }
                    ReactivateCtnErrorController.prototype.cancel = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    ReactivateCtnErrorController.$inject = [
                        '$modalInstance',
                        'ute.common.reactivate.ctn.service',
                        'ute.common.reactivate.ctn.service.errorHandler'
                    ];
                    return ReactivateCtnErrorController;
                }());
                ctn.ReactivateCtnErrorController = ReactivateCtnErrorController;
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.error.controller', ReactivateCtnErrorController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnDeviceController = (function () {
                    /* @ngInject */
                    function ReactivateCtnDeviceController(reactivateCtnService) {
                        var _this = this;
                        this.reactivateCtnService = reactivateCtnService;
                        this.hasDeviceName = function () {
                            return _this.reactivateCtnService.hasDeviceName();
                        };
                    }
                    ReactivateCtnDeviceController.$inject = ['ute.common.reactivate.ctn.service'];
                    return ReactivateCtnDeviceController;
                }());
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.device.controller', ReactivateCtnDeviceController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnDevice = (function () {
                    /* @ngInject */
                    ReactivateCtnDevice.$inject = ["reactivateCtnService"];
                    function ReactivateCtnDevice(reactivateCtnService) {
                        this.reactivateCtnService = reactivateCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.reactivateCtnService.getConfig().advanced.reactivateCtnDevice.templateUrl;
                        this.controller = this.reactivateCtnService.getConfig().advanced.reactivateCtnDevice.controllerName;
                        this.controllerAs = 'reactivateCtnDevice';
                    }
                    ReactivateCtnDevice.factory = function () {
                        var directive = function (reactivateCtnService) { return new ReactivateCtnDevice(reactivateCtnService); };
                        directive.$inject = ['ute.common.reactivate.ctn.service'];
                        return directive;
                    };
                    return ReactivateCtnDevice;
                }());
                angular.module('ute.common.reactivate.ctn').directive('uteReactivateCtnDevice', ReactivateCtnDevice.factory());
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnMessageBoxController = (function () {
                    /* @ngInject */
                    function ReactivateCtnMessageBoxController($modal, reactivateCtnService) {
                        var _this = this;
                        this.$modal = $modal;
                        this.reactivateCtnService = reactivateCtnService;
                        this.reactivateDevice = function ($event) {
                            $event.preventDefault();
                            _this.reactivateCtnService.processReactivateCtn();
                            // this.reactivateCtnService.reactivateCtn().then<ICodeEntry>(
                            //     (result: ICodeEntry): ICodeEntry => {
                            //       switch (result.frontendCode) {
                            //         case ute.common.reactivate.ctn.service.FrontEndErrorCode.UPDATED_OK:
                            //           this.reactivateCtnService.goToState(this.reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.subState);
                            //           break;
                            //         default:
                            //           // this.reactivateCtnService.goToState(this.reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.subState); // TODO remove
                            //           this.openModalPopup(result);
                            //           break;
                            //       }
                            //       return result;
                            //     }).catch<ICodeEntry>((error: ICodeEntry): ICodeEntry => {
                            //   this.openModalPopup(error);
                            //   return error;
                            // });
                        };
                        this.isReactivateCtnCallInProgress = reactivateCtnService.isReactivateCtnCallInProgress;
                    }
                    ReactivateCtnMessageBoxController.prototype.openModalPopup = function (errorHandler) {
                        this.$modal.open({
                            templateUrl: errorHandler.templateUrl,
                            controller: this.reactivateCtnService.getConfig().advanced.reactivateCtnError.controllerName,
                            controllerAs: 'reactivateCtnErrorModal',
                            size: errorHandler.modalSize,
                            backdrop: 'static',
                            backdropClass: 'bkg-modal',
                            resolve: {
                                'ute.common.reactivate.ctn.service.errorHandler': errorHandler
                            }
                        });
                    };
                    ReactivateCtnMessageBoxController.$inject = ['$modal', 'ute.common.reactivate.ctn.service'];
                    return ReactivateCtnMessageBoxController;
                }());
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.messageBox.controller', ReactivateCtnMessageBoxController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnMessageBox = (function () {
                    /* @ngInject */
                    ReactivateCtnMessageBox.$inject = ["reactivateCtnService"];
                    function ReactivateCtnMessageBox(reactivateCtnService) {
                        var _this = this;
                        this.reactivateCtnService = reactivateCtnService;
                        this.restrict = 'E';
                        this.scope = {
                            inputModel: '='
                        };
                        this.templateUrl = this.reactivateCtnService.getConfig().advanced.reactivateCtnMessageBox.templateUrl;
                        this.controller = this.reactivateCtnService.getConfig().advanced.reactivateCtnMessageBox.controllerName;
                        this.controllerAs = 'reactivateCtnMessageBox';
                        /**
                         * @param scope
                         */
                        this.linkFn = function (scope) {
                            // Set account number and phone number to the service model
                            _this.reactivateCtnService.setModel(scope.inputModel);
                        };
                        this.link = this.linkFn;
                    }
                    ReactivateCtnMessageBox.factory = function () {
                        var directive = function (reactivateCtnService) { return new ReactivateCtnMessageBox(reactivateCtnService); };
                        directive.$inject = ['ute.common.reactivate.ctn.service'];
                        return directive;
                    };
                    return ReactivateCtnMessageBox;
                }());
                angular.module('ute.common.reactivate.ctn').directive('uteReactivateCtnMessageBox', ReactivateCtnMessageBox.factory());
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnWirelessNumberController = (function () {
                    /* @ngInject */
                    function ReactivateCtnWirelessNumberController(reactivateCtnService) {
                        var _this = this;
                        this.reactivateCtnService = reactivateCtnService;
                        this.getPhoneNumber = function () {
                            return _this.reactivateCtnService.getPhoneNumber();
                        };
                        this.getFirstName = function () {
                            return _this.reactivateCtnService.getFirstName();
                        };
                        this.backToDevicePage = function () {
                            _this.reactivateCtnService.backToDevice();
                        };
                    }
                    ReactivateCtnWirelessNumberController.$inject = ['ute.common.reactivate.ctn.service'];
                    return ReactivateCtnWirelessNumberController;
                }());
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.wirelessNumber.controller', ReactivateCtnWirelessNumberController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnWirelessNumber = (function () {
                    /* @ngInject */
                    SuspendCtnWirelessNumber.$inject = ["reactivateCtnService"];
                    function SuspendCtnWirelessNumber(reactivateCtnService) {
                        this.reactivateCtnService = reactivateCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.reactivateCtnService.getConfig().advanced.reactivateCtnWirelessNumber.templateUrl;
                        this.controller = this.reactivateCtnService.getConfig().advanced.reactivateCtnWirelessNumber.controllerName;
                        this.controllerAs = 'reactivateCtnWirelessNumber';
                    }
                    SuspendCtnWirelessNumber.factory = function () {
                        var directive = function (reactivateCtnService) { return new SuspendCtnWirelessNumber(reactivateCtnService); };
                        directive.$inject = ['ute.common.reactivate.ctn.service'];
                        return directive;
                    };
                    return SuspendCtnWirelessNumber;
                }());
                angular.module('ute.common.reactivate.ctn').directive('uteReactivateCtnWirelessNumber', SuspendCtnWirelessNumber.factory());
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn_1) {
                var service;
                (function (service) {
                    'use strict';
                    /**
                     * Private
                     */
                    var BackEndErrorCode = (function () {
                        function BackEndErrorCode() {
                        }
                        BackEndErrorCode.UPDATED_OK = 0;
                        BackEndErrorCode.GENERIC_ERROR = 15700;
                        return BackEndErrorCode;
                    }());
                    var ReactivateCtnProvider = (function () {
                        /* @ngInject */
                        function ReactivateCtnProvider() {
                            var _this = this;
                            this.errorCodesMap = {};
                            this.isReactivateCtnCallInProgress = false;
                            // TODO move it to separate config
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    medium: 'WEB',
                                    partialApiUrl: 'v1/wirelessService/reactivate',
                                    reactivateCtnRootState: 'reactivateCtn',
                                    cancelState: 'wireless',
                                    mainControllerName: 'ute.common.reactivate.ctn.main.controller',
                                    mainTemplateUrl: 'module/reactivateCtn/reactivateCtnMain.view.html'
                                },
                                advanced: {
                                    reactivateCtnMessageBox: {
                                        controllerName: 'ute.common.reactivate.ctn.messageBox.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnDirective/reactivateCtn.messageBox.directive.view.html'
                                    },
                                    reactivateCtnSuccess: {
                                        subState: 'success',
                                        backToState: 'wireless',
                                        controllerName: 'ute.common.reactivate.ctn.success.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnSuccess/reactivateCtnSuccess.view.html'
                                    },
                                    reactivateCtnError: {
                                        controllerName: 'ute.common.reactivate.ctn.error.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnError/reactivateCtn.error.view.html'
                                    },
                                    reactivateCtnWirelessNumber: {
                                        controllerName: 'ute.common.reactivate.ctn.wirelessNumber.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnDirective/reactivateCtn.wirelessNumber.directive.view.html'
                                    },
                                    reactivateCtnDevice: {
                                        controllerName: 'ute.common.reactivate.ctn.device.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnDirective/reactivateCtn.device.directive.view.html'
                                    }
                                }
                            };
                            /* @ngInject */
                            this.$get = ["$injector", "$state", "$http", "$modal", "$stateParams", function ($injector, $state, $http, $modal, $stateParams) {
                                _this.encryptionService = $injector.get('ute.common.encryption.service');
                                _this.runtimeTranslateService = $injector.get('ute.common.runtime.translate.service');
                                _this.userService = $injector.get('ute.common.user.service');
                                _this.securityService = $injector.get('ute.common.security.service');
                                _this.$state = $state;
                                _this.$http = $http;
                                _this.$modal = $modal;
                                _this.$stateParams = $stateParams;
                                _this.$injector = $injector;
                                return {
                                    getConfig: _this.getConfig,
                                    getAccountNumber: _this.getAccountNumber,
                                    setAccountNumber: _this.setAccountNumber,
                                    getPhoneNumber: _this.getPhoneNumber,
                                    setPhoneNumber: _this.setPhoneNumber,
                                    setModel: _this.setModel,
                                    getFirstName: _this.getFirstName,
                                    hasDeviceName: _this.hasDeviceName,
                                    processReactivateCtn: _this.processReactivateCtn,
                                    reactivateCtn: _this.reactivateCtn,
                                    isReactivateCtnCallInProgress: _this.isReactivateCtnCallInProgressFn,
                                    goToState: _this.goToState,
                                    backToDevice: _this.backToDevice,
                                    restoreState: _this.restoreState,
                                    $injector: _this.$injector
                                };
                            }];
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                return true;
                            };
                            this.addCode = function (code) {
                                _this.errorCodesMap[code.frontendCode] = code;
                            };
                            this.restoreState = function () {
                                // console.log('SuspendCtn->restoreState $stateParams=', this.$stateParams);
                                if (_this.$stateParams.id) {
                                    _this.encryptionService.decrypt(_this.$stateParams.id).then(function (obj) {
                                        console.log('ReactivateCtnProvider->restoreState', obj);
                                        if (obj.accountNumber && obj.phoneNumber) {
                                            _this.model.accountNumber = obj.accountNumber;
                                            _this.model.phoneNumber = obj.phoneNumber;
                                            _this.model.deviceNameEn = obj.deviceNameEn;
                                            _this.model.deviceNameFr = obj.deviceNameFr || obj.deviceNameEn;
                                            _this.model.firstName = obj.firstName;
                                            // this.model.accountEmail = obj.accountEmail;
                                            _this.runtimeTranslateService.addTranslation('en', ReactivateCtnProvider.deviceNameTranslateKey, _this.model.deviceNameEn);
                                            _this.runtimeTranslateService.addTranslation('fr', ReactivateCtnProvider.deviceNameTranslateKey, _this.model.deviceNameFr);
                                        }
                                        else {
                                            _this.$state.go(_this.config.basic.cancelState);
                                        }
                                    }) /*.catch((error: any): void => {
                                     this.$state.go(this.config.basic.cancelState);
                                     })*/;
                                }
                                else {
                                    // TODO route where ? or maybe restore from localstore - refresh on confirm
                                    _this.$state.go(_this.config.basic.cancelState);
                                }
                            };
                            this.addCodes = function () {
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.UPDATED_OK,
                                    templateUrl: _this.getConfig().advanced.reactivateCtnSuccess.templateUrl,
                                    modalIcon: '',
                                    modalSize: '',
                                    backendCode: BackEndErrorCode.UPDATED_OK
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.GENERIC_ERROR,
                                    frontendMessageKey: 'ute.common.reactivate.ctn.fail.message',
                                    templateUrl: _this.getConfig().advanced.reactivateCtnError.templateUrl,
                                    modalIcon: 'ute.common.reactivate.ctn.images.errorWarning',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.GENERIC_ERROR
                                });
                            };
                            /**
                             * Get Account number from the model
                             * @returns {number}
                             */
                            this.getAccountNumber = function () {
                                return _this.model.accountNumber;
                            };
                            /**
                             * @param accountNumber - set account number
                             */
                            this.setAccountNumber = function (accountNumber) {
                                _this.model.accountNumber = accountNumber;
                            };
                            /**
                             * Get Phone number from the model
                             * @returns {number}
                             */
                            this.getPhoneNumber = function () {
                                return _this.model.phoneNumber;
                            };
                            /**
                             * @param ctn - set phone number
                             */
                            this.setPhoneNumber = function (ctn) {
                                _this.model.phoneNumber = ctn;
                            };
                            this.setModel = function (inputModel) {
                                _this.model = inputModel;
                                _this.runtimeTranslateService.addTranslation('en', ReactivateCtnProvider.deviceNameTranslateKey, _this.model.deviceNameEn);
                                _this.runtimeTranslateService.addTranslation('fr', ReactivateCtnProvider.deviceNameTranslateKey, _this.model.deviceNameFr);
                            };
                            this.hasDeviceName = function () {
                                return _this.runtimeTranslateService.hasTranslation(ReactivateCtnProvider.deviceNameTranslateKey);
                            };
                            this.getFirstName = function () {
                                return _this.model.firstName;
                            };
                            this.goToState = function (state) {
                                return _this.encryptionService.encrypt(_this.model).then(function (id) {
                                    return _this.$state.go(_this.config.basic.reactivateCtnRootState + '.' + state, {
                                        id: id
                                    });
                                });
                            };
                            this.getConfig = function () {
                                return angular.copy(_this.config);
                            };
                            this.resetModel = function () {
                                _this.model = {
                                    phoneNumber: null,
                                    accountNumber: null // may be from local store?
                                };
                            };
                            this.processReactivateCtn = function () {
                                _this.reactivateCtn().then(function (result) {
                                    switch (result.frontendCode) {
                                        case ute.common.reactivate.ctn.service.FrontEndErrorCode.UPDATED_OK:
                                            _this.goToState(_this.getConfig().advanced.reactivateCtnSuccess.subState);
                                            break;
                                        default:
                                            // this.goToState(this.getConfig().advanced.reactivateCtnSuccess.subState); // TODO remove
                                            _this.openModalPopup(result);
                                            break;
                                    }
                                    return result;
                                }).catch(function (error) {
                                    _this.openModalPopup(error);
                                    return error;
                                });
                            };
                            this.reactivateCtn = function () {
                                var request = {
                                    accountNumber: _this.model.accountNumber,
                                    phoneNumber: _this.model.phoneNumber,
                                    applicationId: _this.config.basic.applicationId,
                                    medium: _this.config.basic.medium
                                };
                                _this.isReactivateCtnCallInProgress = true;
                                return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.partialApiUrl), request)
                                    .then(_this.processReactivateCtnSuccess)
                                    .catch(_this.processReactivateCtnError)
                                    .finally(_this.finaliseReactivateCtnCallCall);
                            };
                            this.processReactivateCtnSuccess = function (response) {
                                var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                //console.log('processSuspendCtn:', 'response:', response, 'backendCode:', backendCode);
                                if (backendCode === BackEndErrorCode.UPDATED_OK) {
                                    return _this.errorCodesMap[service.FrontEndErrorCode.UPDATED_OK];
                                }
                                else {
                                    return _this.findCodeEntry(backendCode);
                                }
                            };
                            this.findCodeEntry = function (backendCode) {
                                return _.find(_this.errorCodesMap, function (ce) {
                                    return ce.backendCode === backendCode;
                                }) || _this.errorCodesMap[service.FrontEndErrorCode.GENERIC_ERROR];
                            };
                            this.processReactivateCtnError = function (error) {
                                var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                return _this.findCodeEntry(backendCode);
                            };
                            this.finaliseReactivateCtnCallCall = function () {
                                _this.isReactivateCtnCallInProgress = false;
                            };
                            this.isReactivateCtnCallInProgressFn = function () {
                                return _this.isReactivateCtnCallInProgress;
                            };
                            this.backToDevice = function () {
                                _this.$state.go(_this.config.basic.cancelState);
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$state',
                                '$http',
                                '$modal',
                                '$stateParams'
                            ];
                            this.resetModel();
                            this.addCodes();
                        }
                        ;
                        ReactivateCtnProvider.prototype.openModalPopup = function (errorHandler) {
                            this.$modal.open({
                                templateUrl: errorHandler.templateUrl,
                                controller: this.getConfig().advanced.reactivateCtnError.controllerName,
                                controllerAs: 'reactivateCtnErrorModal',
                                size: errorHandler.modalSize,
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                resolve: {
                                    'ute.common.reactivate.ctn.service.errorHandler': errorHandler
                                }
                            });
                        };
                        ReactivateCtnProvider.$inject = [];
                        ReactivateCtnProvider.deviceNameTranslateKey = 'ute.common.reactivate.ctn.deviceName';
                        return ReactivateCtnProvider;
                    }());
                    angular.module('ute.common.reactivate.ctn').provider('ute.common.reactivate.ctn.service', ReactivateCtnProvider);
                })(service = ctn_1.service || (ctn_1.service = {}));
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnSuccessController = (function () {
                    /* @ngInject */
                    function ReactivateCtnSuccessController($document, reactivateCtnService) {
                        this.$document = $document;
                        this.reactivateCtnService = reactivateCtnService;
                    }
                    ReactivateCtnSuccessController.$inject = [
                        '$document',
                        'ute.common.reactivate.ctn.service'
                    ];
                    return ReactivateCtnSuccessController;
                }());
                ctn.ReactivateCtnSuccessController = ReactivateCtnSuccessController;
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.success.controller', ReactivateCtnSuccessController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    // - import IsdatalayerService = ute.common.simcard.change.success.
                    var SimCardChangeController = (function () {
                        /* @ngInject */
                        function SimCardChangeController($state, simCardService, datalayerService) {
                            this.$state = $state;
                            this.simCardService = simCardService;
                            this.datalayerService = datalayerService;
                            this.model = this.simCardService.getModel();
                            this.datalayerService = datalayerService;
                        }
                        SimCardChangeController.prototype.isFormValid = function (simCardForm) {
                            simCardForm.$submitted = true;
                            return simCardForm.$valid;
                        };
                        SimCardChangeController.prototype.submit = function (simCardForm, $event) {
                            $event.preventDefault();
                            this.datalayerService.track({}, false, [4, 1, 0], { mappingKey: "physicalsimContinue" });
                            if (this.isFormValid(simCardForm)) {
                                this.simCardService.setCurrentSimCardNumber(this.model.currentSimCardNumber);
                                this.simCardService.setNewSimCardNumber(this.model.newSimCardNumber);
                                return this.simCardService.goToSubModule(this.simCardService.getConfig().advanced.confirmation.subState);
                            }
                        };
                        SimCardChangeController.prototype.cancel = function ($event) {
                            $event.preventDefault();
                            this.simCardService.resetModel();
                            return this.$state.go(this.simCardService.getConfig().advanced.enterSimCard.cancelState);
                        };
                        SimCardChangeController.$inject = ['$state', 'ute.common.simcard.change.service', 'ute.datalayer.common.service'];
                        return SimCardChangeController;
                    }());
                    service.SimCardChangeController = SimCardChangeController;
                    angular.module('ute.common.simcard.change.form').controller('ute.common.simcard.change.directive.controller', SimCardChangeController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.form').directive('myrSimCardChange', myrSimCardChange);
                    myrSimCardChange.$inject = ['ute.common.simcard.change.service'];
                    /* @ngInject */
                    function myrSimCardChange(simCardService) {
                        return {
                            restrict: 'E',
                            templateUrl: simCardService.getConfig().advanced.simCardChangeDirective.templateUrl,
                            controller: simCardService.getConfig().advanced.simCardChangeDirective.controllerName,
                            controllerAs: 'simCardChange'
                        };
                    }
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    var SimCardConfirmationController = (function () {
                        /* @ngInject */
                        function SimCardConfirmationController($modal, simCardService, datalayerservice) {
                            var _this = this;
                            this.$modal = $modal;
                            this.simCardService = simCardService;
                            this.datalayerservice = datalayerservice;
                            //protected backToUpdateSimCard(): void {
                            //  this.openModalPopup({modalSize: 'lg', templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmationModal.view.html'});
                            //}
                            this.backToUpdateSimCard = function () {
                                return _this.simCardService.goToSubModule(_this.simCardService.getConfig().advanced.enterSimCard.subState);
                            };
                            this.isChangeSimCallInProgress = simCardService.isChangeSimCallInProgress;
                            //this.model = this.simCardService.getModel();
                        }
                        /**
                         * mutable model
                         */
                        //private model: ISimCardModel;
                        SimCardConfirmationController.prototype.getNewSimCardNumber = function () {
                            return this.simCardService.getModel().newSimCardNumber;
                        };
                        SimCardConfirmationController.prototype.submitConfirmation = function () {
                            var _this = this;
                            this.simCardService.changeSim().then(function (result) {
                                //console.log('submitConfirmation', errorHandler, FrontEndErrorCode[errorHandler.frontendCode]);
                                //switch (_.get(response, 'frontendCode')) {
                                switch (result.frontendCode) {
                                    case service.FrontEndErrorCode.UPDATED_OK:
                                        _this.simCardService.goToSubModule(_this.simCardService.getConfig().advanced.success.subState);
                                        break;
                                    default:
                                        // error mapper
                                        _this.datalayerservice.track({}, false, [4, 1, 0], { mappingKey: "physicalsimModalerror" });
                                        _this.openModalPopup(result);
                                        break;
                                }
                                return result;
                            }).catch(function (error) {
                                //system error
                                //Sorry! It seems something went wrong on our end. Please contact us on Live Chat to get this sorted out.
                                //console.log('submitConfirmation->catch', error);
                                _this.openModalPopup(error);
                                _this.datalayerservice.track({}, false, [4, 1, 0], { mappingKey: "physicalsimModalerror" });
                                return error;
                            });
                        };
                        SimCardConfirmationController.prototype.cancelConfirmation = function () {
                            // TODO configurable
                            this.openModalPopup({ modalSize: 'lg', templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmationModal.view.html' });
                        };
                        SimCardConfirmationController.prototype.openModalPopup = function (errorHandler) {
                            var _this = this;
                            this.$modal.open({
                                windowTemplateUrl: this.simCardService.getConfig().advanced.simCardConfirmationModal.windowTemplateUrl,
                                templateUrl: errorHandler.templateUrl,
                                controller: this.simCardService.getConfig().advanced.simCardConfirmationModal.controllerName,
                                controllerAs: 'simCardConfirmationModal',
                                size: errorHandler.modalSize,
                                backdrop: 'static',
                                resolve: {
                                    'ute.common.simcard.change.service.errorHandler': errorHandler
                                }
                            }).result.then(function (result) {
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        _this.simCardService.cancelSimCardChange();
                                        break;
                                    case 'no':
                                        // Send the user back to SIM card enter page and close modal
                                        _this.simCardService.goToSubModule(_this.simCardService.getConfig().advanced.enterSimCard.subState);
                                        break;
                                }
                            }, function () {
                                // Dismiss behaviour
                                // Do nothing/close
                            });
                        };
                        SimCardConfirmationController.$inject = ['$modal', 'ute.common.simcard.change.service', 'ute.datalayer.common.service'];
                        return SimCardConfirmationController;
                    }());
                    service.SimCardConfirmationController = SimCardConfirmationController;
                    angular.module('ute.common.simcard.change.confirmation').controller('ute.common.simcard.change.confirmation.controller', SimCardConfirmationController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.confirmation').directive('myrSimCardConfirmation', simCardConfirmation);
                    simCardConfirmation.$inject = ['ute.common.simcard.change.service'];
                    /* @ngInject */
                    function simCardConfirmation(simCardService) {
                        return {
                            restrict: 'E',
                            templateUrl: simCardService.getConfig().advanced.simCardConfirmationDirective.templateUrl,
                            controller: simCardService.getConfig().advanced.simCardConfirmationDirective.controllerName,
                            controllerAs: 'simCardConfirmation'
                        };
                    }
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    var SimCardConfirmationModalController = (function () {
                        /* @ngInject */
                        function SimCardConfirmationModalController($scope, $modalInstance, simCardService, errorCode) {
                            this.$scope = $scope;
                            this.$modalInstance = $modalInstance;
                            this.simCardService = simCardService;
                            this.errorCode = errorCode;
                            if (errorCode) {
                                this.errorMessage = errorCode.frontendMessageKey;
                                if (_.has(errorCode, 'frontendMessageP2Key')) {
                                    this.errorMessage_p2 = errorCode.frontendMessageP2Key;
                                }
                                if (_.has(errorCode, 'boldChat')) {
                                    this.boldChat = errorCode.boldChat;
                                }
                                this.modalIcon = errorCode.modalIcon;
                            }
                        }
                        SimCardConfirmationModalController.prototype.noSelection = function () {
                            if (this.simCardService.isGenericError(this.errorCode.backendCode)) {
                                this.$modalInstance.dismiss('cancel');
                            }
                            else {
                                this.$modalInstance.close('no');
                            }
                        };
                        SimCardConfirmationModalController.prototype.cancel = function () {
                            this.$modalInstance.close('no');
                        };
                        SimCardConfirmationModalController.prototype.continue = function () {
                            this.$modalInstance.close('yes');
                        };
                        SimCardConfirmationModalController.$inject = ['$scope', '$modalInstance', 'ute.common.simcard.change.service', 'ute.common.simcard.change.service.errorHandler'];
                        return SimCardConfirmationModalController;
                    }());
                    service.SimCardConfirmationModalController = SimCardConfirmationModalController;
                    angular.module('ute.common.simcard.change.confirmation').controller('ute.common.simcard.change.confirmation.modal.controller', SimCardConfirmationModalController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

// TODO move to the different module
var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.service').directive('myrErrorMessage', errorMessage);
                    errorMessage.$inject = ['ute.common.simcard.change.service'];
                    /* @ngInject */
                    function errorMessage(simCardService) {
                        return {
                            restrict: 'E',
                            transclude: true,
                            templateUrl: simCardService.getConfig().advanced.simCardErrorDirective.templateUrl
                        };
                    }
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    /**
                     * Private
                     */
                    var BackEndErrorCode = (function () {
                        function BackEndErrorCode() {
                        }
                        BackEndErrorCode.UPDATED_OK = 0;
                        BackEndErrorCode.GENERIC_ERROR = 15600;
                        BackEndErrorCode.CURRENT_SIM_IS_NOT_VALID = 15601;
                        BackEndErrorCode.NEW_SIM_IS_NOT_VALID = 15602;
                        BackEndErrorCode.NEW_SIM_IS_ALREADY_IN_USE = 15603;
                        BackEndErrorCode.NEW_SIM_HAS_BEEN_USED_BEFORE = 15604;
                        BackEndErrorCode.NEW_SIM_HAS_INVALID_SIM_PREFIX = 15605;
                        return BackEndErrorCode;
                    }());
                    var SimCardChangeProvider = (function () {
                        /* @ngInject */
                        function SimCardChangeProvider() {
                            var _this = this;
                            this.errorCodesMap = {};
                            this.isChangeSimCallInProgress = false;
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    medium: 'WEB',
                                    partialApiUrl: 'v1/wirelessDashBoard/changeSimCardNumber',
                                    simCardRootState: 'simCard',
                                    defaultSimNumber: 89302,
                                    mainControllerName: 'ute.common.simcard.change.main.controller',
                                    mainTemplateUrl: 'module/simCard/simCardMain.view.html'
                                },
                                advanced: {
                                    enterSimCard: {
                                        subState: 'start',
                                        cancelState: 'wireless',
                                        controllerName: 'ute.common.simcard.change.main.controller',
                                        templateUrl: 'module/simCard/simCardEnterSimCard/simCardEnterSimCard.view.html'
                                    },
                                    confirmation: {
                                        subState: 'confirmation',
                                        controllerName: 'ute.common.simcard.change.main.controller',
                                        templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmation.html'
                                    },
                                    success: {
                                        subState: 'success',
                                        backToState: 'accountOverview',
                                        controllerName: 'ute.common.simcard.change.main.controller',
                                        templateUrl: 'module/simCard/simCardSuccess/simCardSuccess.html'
                                    },
                                    simCardChangeDirective: {
                                        controllerName: 'ute.common.simcard.change.directive.controller',
                                        templateUrl: 'module/simCard/simCardChange/simCardChangeNumberForm.partial.html'
                                    },
                                    simCardErrorDirective: {
                                        templateUrl: 'module/simCard/simCardErrorMessage/simCardErrorMessage.template.html'
                                    },
                                    simCardConfirmationDirective: {
                                        controllerName: 'ute.common.simcard.change.confirmation.controller',
                                        templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmation.view.html'
                                    },
                                    simCardSuccess: {
                                        controllerName: 'ute.common.simcard.change.success.controller',
                                        templateUrl: 'module/simCard/simCardSuccess/simCardSuccess.view.html'
                                    },
                                    simCardConfirmationModal: {
                                        controllerName: 'ute.common.simcard.change.confirmation.modal.controller',
                                        templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmationErrorModal.view.html',
                                        windowTemplateUrl: 'module/simCard/simCardErrorMessage/simCardErrorMessageWindow.view.html'
                                    },
                                    simCardConfirmationGenericModal: {
                                        controllerName: 'ute.common.simcard.change.success.controller',
                                        templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmationGenericModal.view.html'
                                    },
                                    secondaryColumnPartialPath: 'module/simCard/simCardEnterSimCard/simCardHowToFindNumber.partial.html',
                                    simCardHeaderPartialPath: 'module/simCard/simCardHeader.partial.html',
                                    simCardDefaultPartialPath: 'module/simCard/simCardDefault.view.html'
                                }
                            };
                            /* @ngInject */
                            this.$get = ["$injector", "$state", "$http", "$stateParams", function ($injector, $state, $http, $stateParams) {
                                _this.encryptionService = $injector.get('ute.common.encryption.service');
                                _this.userService = $injector.get('ute.common.user.service');
                                _this.securityService = $injector.get('ute.common.security.service');
                                _this.$state = $state;
                                _this.$http = $http;
                                _this.$stateParams = $stateParams;
                                return {
                                    getConfig: _this.getConfig,
                                    goToEntryState: _this.goToEntryState,
                                    getEntryState: _this.getEntryState,
                                    changeSim: _this.changeSim,
                                    restoreFromInput: _this.restoreFromInput,
                                    getPhoneNumber: _this.getPhoneNumber,
                                    getAccountNumber: _this.getAccountNumber,
                                    getAccountEmail: _this.getAccountEmail,
                                    isChangeSimCallInProgress: _this.isChangeSimCallInProgressFn,
                                    getUser: _this.userService.getUser,
                                    goToSubModule: _this.goToSubModule,
                                    cancelSimCardChange: _this.cancelSimCardChange,
                                    resetModel: _this.resetModel,
                                    getModel: _this.getModel,
                                    setCurrentSimCardNumber: _this.setCurrentSimCardNumber,
                                    setNewSimCardNumber: _this.setNewSimCardNumber,
                                    finishedRoute: _this.finishedRoute,
                                    isGenericError: _this.isGenericError
                                };
                            }];
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                if (_.isEmpty(_this.config.basic.medium)) {
                                    console.error('medium:', 'Config Provider should override medium with vaid Medium');
                                    return false;
                                }
                                _this.config.advanced.confirmation.cancelSubState = _.get(config, 'advanced.confirmation.cancelSubState') ||
                                    _.get(config, 'advanced.enterSimCard.subState') ||
                                    _this.config.advanced.enterSimCard.subState;
                                return true;
                            };
                            /**
                             * @param code
                             * @returns {boolean}
                             */
                            this.addCode = function (code) {
                                _this.errorCodesMap[code.frontendCode] = code;
                            };
                            this.addCodes = function () {
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.UPDATED_OK,
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/green-checkbox.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.UPDATED_OK
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.GENERIC_ERROR,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.system_error_message',
                                    frontendMessageP2Key: 'ute.rogers.myrSimCard.simCardConfirmation.system_error_message_p2',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationGenericModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.GENERIC_ERROR,
                                    boldChat: {
                                        cbid: 'ute.rogers.myrSimCard.boldChat.cbid',
                                        dynamicDivId: 'ute.rogers.myrSimCard.boldChat.dynamicDivId',
                                        chatButtonClass: 'ute.rogers.myrSimCard.boldChat.chatButtonClass'
                                    }
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.CURRENT_SIM_CARD_NOT_VALID_ERROR,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.error_current_sim_invalid',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.CURRENT_SIM_IS_NOT_VALID
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.NEW_SIM_CARD_NOT_VALID_ERROR,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.error_new_sim_invalid',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.NEW_SIM_IS_NOT_VALID
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.NEW_SIM_CARD_IN_USE_ERROR,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.error_new_sim_in_use',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.NEW_SIM_IS_ALREADY_IN_USE
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.NEW_SIM_HAS_BEEN_USED_BEFORE,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.new.sim.has.been.used.before',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.NEW_SIM_HAS_BEEN_USED_BEFORE
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.NEW_SIM_HAS_INVALID_SIM_PREFIX,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.new.sim.has.invalid.sim.prefix',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.NEW_SIM_HAS_INVALID_SIM_PREFIX
                                });
                            };
                            /**
                             * @returns {ng.IPromise<ICodeEntry>}
                             */
                            this.changeSim = function () {
                                var request = {
                                    accountNumber: _this.model.accountNumber,
                                    phoneNumber: _this.model.phoneNumber,
                                    oldSimNumber: _this.model.currentSimCardNumber,
                                    newSimNumber: _this.model.newSimCardNumber,
                                    applicationId: _this.config.basic.applicationId,
                                    medium: _this.config.basic.medium
                                };
                                _this.isChangeSimCallInProgress = true;
                                return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.partialApiUrl), request)
                                    .then(_this.processChangeSimOk)
                                    .catch(_this.processChangeSimError)
                                    .finally(_this.finaliseChangeSimCardCall);
                            };
                            /**
                             * @param response
                             * @returns {any}
                             */
                            this.processChangeSimOk = function (response) {
                                var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                console.log('processChangeSimOk:', 'response:', response, 'backendCode:', backendCode);
                                // TODO
                                if (backendCode === BackEndErrorCode.UPDATED_OK) {
                                    return _this.errorCodesMap[service.FrontEndErrorCode.UPDATED_OK];
                                }
                                else {
                                    return _this.findCodeEntry(backendCode);
                                }
                            };
                            /**
                             * @param backendCode
                             * @returns {ICodeEntry|any}
                             */
                            this.findCodeEntry = function (backendCode) {
                                return _.find(_this.errorCodesMap, function (ce) {
                                    return ce.backendCode === backendCode;
                                }) || _this.errorCodesMap[service.FrontEndErrorCode.GENERIC_ERROR];
                            };
                            /**
                             * @param error
                             * @returns {ICodeEntry}
                             */
                            this.processChangeSimError = function (error) {
                                var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                //console.log('ute.common.simcard.change.service->processChangeSimError:', 'error:', error, 'backendCode:', backendCode);
                                return _this.findCodeEntry(backendCode);
                            };
                            this.finaliseChangeSimCardCall = function () {
                                _this.isChangeSimCallInProgress = false;
                                //console.log('ute.common.simcard.change.service->finaliseChangeSimError:', this.isChangeSimCallInProgress);
                            };
                            /**
                             * @returns {number}
                             */
                            this.getPhoneNumber = function () {
                                return _this.model.phoneNumber;
                            };
                            this.isChangeSimCallInProgressFn = function () {
                                return _this.isChangeSimCallInProgress;
                            };
                            /**
                             * @returns {number}
                             */
                            this.getAccountNumber = function () {
                                return _this.model.accountNumber;
                            };
                            /**
                             * @returns {string}
                             */
                            this.getAccountEmail = function () {
                                return _this.model.accountEmail;
                            };
                            /**
                             * TODO to make it automaticaly
                             */
                            this.restoreFromInput = function () {
                                if (_this.$stateParams.id) {
                                    _this.encryptionService.decrypt(_this.$stateParams.id).then(function (obj) {
                                        // console.log('SimCard->restoreFromInput', obj);
                                        if (obj.accountNumber && obj.phoneNumber) {
                                            _this.model.accountNumber = obj.accountNumber;
                                            _this.model.phoneNumber = obj.phoneNumber;
                                            _this.model.accountEmail = obj.accountEmail;
                                        }
                                        else {
                                            _this.$state.go(_this.config.advanced.enterSimCard.cancelState);
                                        }
                                        if (obj.currentSimCardNumber) {
                                            _this.model.currentSimCardNumber = obj.currentSimCardNumber;
                                        }
                                        if (obj.currentSimCardNumber && obj.newSimCardNumber) {
                                            _this.model.currentSimCardNumber = obj.currentSimCardNumber;
                                            _this.model.newSimCardNumber = obj.newSimCardNumber;
                                        }
                                        else {
                                            _this.goToEntryState(_this.model);
                                        }
                                    });
                                }
                                else {
                                    // TODO route where ? or maybe restore from localstore - refresh on confirm
                                    _this.$state.go(_this.config.advanced.enterSimCard.cancelState);
                                }
                            };
                            //function setOnStateChangeStartHandler() {
                            //  $rootScope.$on('$stateChangeStart',
                            //      function (event, toState, toParams, fromState, fromParams) {
                            //        if (_.startsWith(toState.name, myrSimCardService.getSimCardState())) {
                            //          restoreSimAndBan();
                            //        }
                            //      });
                            //}
                            /**
                             * @returns {any}
                             */
                            this.getConfig = function () {
                                return angular.copy(_this.config);
                            };
                            /**
                             * @returns {string}
                             */
                            this.getEntryState = function () {
                                return _this.config.basic.simCardRootState + '.' + _this.config.advanced.enterSimCard.subState;
                            };
                            /**
                             * @param input
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToEntryState = function (input) {
                                return _this.encryptionService.encrypt(input).then(function (id) {
                                    return _this.$state.go(_this.getEntryState(), { id: id });
                                });
                            };
                            /**
                             * @param module
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToSubModule = function (module) {
                                return _this.encryptionService.encrypt(_this.model).then(function (id) {
                                    return _this.$state.go(_this.config.basic.simCardRootState + '.' + module, {
                                        id: id
                                    });
                                });
                            };
                            /**
                             * Return immutable ISimCardModel object
                             * @returns {ISimCardModel}
                             */
                            this.getModel = function () {
                                return angular.copy(_this.model);
                            };
                            /**
                             * @param sim - current SimCard Number
                             */
                            this.setCurrentSimCardNumber = function (sim) {
                                _this.model.currentSimCardNumber = sim;
                            };
                            /**
                             * @param sim - New SimCard Number
                             */
                            this.setNewSimCardNumber = function (sim) {
                                _this.model.newSimCardNumber = sim;
                            };
                            /**
                             * cancel Sim Card Change Wizard and naviagte to the 'start' state
                             * @returns {angular.IPromise<any>}
                             */
                            this.cancelSimCardChange = function () {
                                _this.model.currentSimCardNumber = _this.config.basic.defaultSimNumber;
                                _this.model.newSimCardNumber = _this.config.basic.defaultSimNumber;
                                return _this.goToSubModule(_this.getConfig().advanced.confirmation.cancelSubState);
                            };
                            /**
                             * Reset model to initial state
                             */
                            this.resetModel = function () {
                                _this.model = {
                                    phoneNumber: null,
                                    accountNumber: null,
                                    currentSimCardNumber: _this.config.basic.defaultSimNumber,
                                    newSimCardNumber: _this.config.basic.defaultSimNumber,
                                    accountEmail: null
                                };
                            };
                            /**
                             * @returns {IPromise<TResult>}
                             */
                            this.finishedRoute = function () {
                                return _this.$state.go(_this.getConfig().advanced.success.backToState).then(function (data) {
                                    _this.resetModel();
                                }).catch(function (error) {
                                    // TODO
                                }).finally(function () {
                                    //TODO
                                });
                            };
                            /**
                             * @returns {boolean}
                             */
                            this.isGenericError = function (backendErrorCode) {
                                return (backendErrorCode === BackEndErrorCode.GENERIC_ERROR);
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$state',
                                '$http',
                                '$stateParams'
                            ];
                            this.resetModel();
                            this.addCodes();
                        }
                        ;
                        SimCardChangeProvider.$inject = [];
                        return SimCardChangeProvider;
                    }());
                    angular.module('ute.common.simcard.change.service').provider('ute.common.simcard.change.service', SimCardChangeProvider);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var success;
                (function (success) {
                    'use strict';
                    /* @ngInject */
                    var SimCardSuccessController = (function () {
                        /* @ngInject */
                        function SimCardSuccessController(simCardService) {
                            this.simCardService = simCardService;
                        }
                        SimCardSuccessController.prototype.getUserEmailAddress = function () {
                            // return this.simCardService.getUser().userEmail;
                            return this.simCardService.getAccountEmail();
                        };
                        SimCardSuccessController.prototype.finishedRoute = function () {
                            return this.simCardService.finishedRoute();
                        };
                        SimCardSuccessController.$inject = [
                            'ute.common.simcard.change.service'];
                        return SimCardSuccessController;
                    }());
                    success.SimCardSuccessController = SimCardSuccessController;
                    angular.module('ute.common.simcard.change.success').controller('ute.common.simcard.change.success.controller', SimCardSuccessController);
                })(success = change.success || (change.success = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var success;
                (function (success) {
                    'use strict';
                    angular.module('ute.common.simcard.change.success').directive('myrSimCardSuccess', MyrSimCardSuccess);
                    MyrSimCardSuccess.$inject = ['ute.common.simcard.change.service'];
                    /* @ngInject */
                    function MyrSimCardSuccess(simCardService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: simCardService.getConfig().advanced.simCardSuccess.templateUrl,
                            controller: simCardService.getConfig().advanced.simCardSuccess.controllerName,
                            controllerAs: 'simCardSuccess'
                        };
                    }
                })(success = change.success || (change.success = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            var ProviderBase = ute.common.core.ProviderBase;
            var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
            /**
             * Private
             */
            var BackEndErrorCode = (function () {
                function BackEndErrorCode() {
                }
                BackEndErrorCode.SET_NEW_PASSWORD_OK = 0;
                BackEndErrorCode.GENERIC_ERROR = 17052;
                BackEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST = 17095;
                BackEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_REGISTRATION_INCOMPLETE = 17008;
                BackEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_LOCKED_BY_AGENT = 17009;
                return BackEndErrorCode;
            }());
            (function (FrontEndErrorCode) {
                FrontEndErrorCode[FrontEndErrorCode["SET_NEW_PASSWORD_OK"] = 0] = "SET_NEW_PASSWORD_OK";
                FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                FrontEndErrorCode[FrontEndErrorCode["REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST"] = 2] = "REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST";
                FrontEndErrorCode[FrontEndErrorCode["REQUEST_FORGOT_PASSWORD_PROFILE_REGISTRATION_INCOMPLETE"] = 3] = "REQUEST_FORGOT_PASSWORD_PROFILE_REGISTRATION_INCOMPLETE";
                FrontEndErrorCode[FrontEndErrorCode["REQUEST_FORGOT_PASSWORD_PROFILE_LOCKED_BY_AGENT"] = 4] = "REQUEST_FORGOT_PASSWORD_PROFILE_LOCKED_BY_AGENT";
            })(setpassword.FrontEndErrorCode || (setpassword.FrontEndErrorCode = {}));
            var FrontEndErrorCode = setpassword.FrontEndErrorCode;
            var RogersSetPasswordService = (function () {
                function RogersSetPasswordService(config, $injector, $http, $q, $timeout, $state, $cookiesTemp, $window, datalayerService) {
                    var _this = this;
                    this.config = config;
                    this.$http = $http;
                    this.$q = $q;
                    this.$timeout = $timeout;
                    this.$state = $state;
                    this.$window = $window;
                    this.datalayerService = datalayerService;
                    this.errorCodesMap = {};
                    this.isCallInProgress = false;
                    this.isForgotPasswordCallInProgress = false;
                    this.userMigratedEmailResponseModel = {
                        isMigEmailPresent: false,
                        bizMigratedEmailResponsesList: null
                    };
                    this.getConfig = function () { return angular.copy(_this.config); };
                    this.isRogersSetPasswordCallInProgress = function () { return _this.isCallInProgress; };
                    this.isRogersForgotPasswordCallInProgress = function () { return _this.isForgotPasswordCallInProgress; };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.savePassword = function (model) {
                        if (_this.isResetPassword()) {
                            return _this.resetPassword(model);
                        }
                        else {
                            return _this.setPassword(model);
                        }
                    };
                    /*private getCookie = function(cname){
                        var name = cname + "=";
                      var decodedCookie = document.cookie;
                      var ca = decodedCookie.split(';');
                      for (var i = 0; i < ca.length; i++) {
                          var c = ca[i];
                          while (c.charAt(0) == ' ') {
                              c = c.substring(1);
                          }
                          if (c.indexOf(name) == 0) {
                              return c.substring(name.length, c.length);
                          }
                      }
                      return "";
                    };*/
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.forgotPassword = function (model) {
                        _this.forgotPasswordModel = model;
                        _this.forgotPasswordModel.isServiceCallSuccess = false;
                        var request = {
                            email: _this.forgotPasswordModel.email
                        };
                        _this.$window.localStorage.setItem('profileValidateEmail', _this.forgotPasswordModel.email);
                        _this.isForgotPasswordCallInProgress = true;
                        return _this.$http.post(_this.config.advanced.forgotPassword.apiUrl, request)
                            .then(_this.processForgotPasswordOk)
                            .catch(_this.processForgotPasswordError)
                            .finally(_this.finaliseForgotPasswordCall);
                    };
                    this.onSuccessSetPassword = function () {
                        var selectedSections = [
                            DataLayerPredefinedSection.ACCOUNT,
                            DataLayerPredefinedSection.PAGE,
                            DataLayerPredefinedSection.SITE
                        ];
                        var payload = {};
                        if (_this.isResetPassword()) {
                            payload = {
                                page: {
                                    name: 'setPassword',
                                    hierarchy: ['selfserve', 'setPassword']
                                },
                                selfServe: {
                                    type: 'transaction',
                                    name: 'Set New Password (Reset)'
                                },
                                events: {
                                    selfServeComplete: true
                                }
                            };
                            _this.datalayerService.track(payload, false, selectedSections);
                        }
                        else {
                            payload = {
                                page: {
                                    name: 'setNewPassword',
                                    hierarchy: ['selfserve', 'setPassword']
                                },
                                selfServe: {
                                    type: 'transaction',
                                    name: 'Set New Password (New Registration)'
                                },
                                events: {
                                    selfServeComplete: true
                                }
                            };
                            _this.datalayerService.track(payload, false, selectedSections);
                        }
                        _this.isCallInProgress = true;
                        // return this.$timeout(() => this.signinService.signinUser({
                        //   userName: this.janrainVerificationService.getEmail(),
                        //   userEmail: this.janrainVerificationService.getEmail(),
                        //   userPassword: this.model.newPassword,
                        //   userType: ute.common.user.UserType.consumer,
                        //   encryptionKey: undefined
                        // }).finally(() => {
                        //   this.isCallInProgress = false;
                        //   return this.goToState(this.config.advanced.setPassword.onSuccessState);
                        // }), 3000); // To make sure Janrain propagate changes to ESF
                        _this.signinService.signout();
                        _this.goToState('signin');
                        return _this.$q.when();
                    };
                    this.goToState = function (state) {
                        return _this.$state.go(state);
                    };
                    /**
                     * Return immutable IRogersSetPasswordModel object
                     * @returns {IPasswordModel}
                     */
                    this.getModel = function () {
                        return angular.copy(_this.model);
                    };
                    /**
                     * Return immutable IRogersSetPasswordModel object
                     * @returns {IForgotPasswordModel}
                     */
                    this.getForgotPasswordModel = function () {
                        return angular.copy(_this.forgotPasswordModel);
                    };
                    this.resetForgotPasswordModel = function () {
                        _this._resetForgotPasswordModel();
                    };
                    this.isResetPassword = function () { return _this.$state.current.name === _this.config.advanced.resetPassword.stateName; };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.getUserMigratedEmailResponse = function () {
                        return angular.copy(_this.userMigratedEmailResponseModel);
                    };
                    this.resetPassword = function (model) {
                        // this.model = _.merge({}, model);
                        _this.model = model;
                        var resetPasswordToken = _this.janrainVerificationService.getToken();
                        if (resetPasswordToken === 'forgotPasswordValidate') {
                            resetPasswordToken = _this.janrainVerificationService.getVerificationCode();
                        }
                        var request = {
                            // email: this.$window.localStorage.getItem('profileValidateEmail'),
                            email: _this.janrainVerificationService.getEmail(),
                            token: resetPasswordToken,
                            newPassword: _this.model.newPassword,
                            confirmPassword: _this.model.confirmPassword,
                            isForgotPassword: "true"
                        };
                        _this.isCallInProgress = true;
                        return _this.$http.post(_this.config.advanced.resetPassword.apiUrl, request)
                            .then(_this.processOk)
                            .catch(_this.processError)
                            .finally(_this.finaliseCall);
                    };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.setPassword = function (model) {
                        // this.model = _.merge({}, model);
                        _this.model = model;
                        var request = {
                            uuid: _this.janrainVerificationService.getUuid(),
                            email: _this.janrainVerificationService.getEmail(),
                            newPassword: _this.model.newPassword,
                            confirmPassword: _this.model.confirmPassword,
                            token: _this.janrainVerificationService.getVerificationCode(),
                        };
                        _this.isCallInProgress = true;
                        return _this.$http.post(_this.config.advanced.setPassword.apiUrl, request)
                            .then(_this.processOk)
                            .catch(_this.processError)
                            .finally(_this.finaliseCall);
                    };
                    /**
                     * Reset model to initial state
                     */
                    this.resetModel = function () {
                        _this.model = {
                            newPassword: null,
                            confirmPassword: null
                        };
                    };
                    this._resetForgotPasswordModel = function () {
                        _this.forgotPasswordModel = {
                            email: null,
                            isServiceCallSuccess: false
                        };
                    };
                    /**
                     * @param code
                     * @returns {boolean}
                     */
                    this.addCode = function (code) {
                        _this.errorCodesMap[code.frontendCode] = code;
                    };
                    this.addCodes = function () {
                        _this.addCode({
                            frontendCode: FrontEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST,
                            frontendMessageKey: 'ute.rogers.forgotPassword.email.not.found',
                            frontendMessageP2Key: '',
                            templateUrl: _this.config.advanced.genericErrorModal.templateUrl,
                            modalIcon: 'ute-common-assets/assets/error_warning.png',
                            modalSize: 'md',
                            backendCode: BackEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST
                        });
                        _this.addCode({
                            frontendCode: FrontEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_LOCKED_BY_AGENT,
                            frontendMessageKey: 'ute.rogers.forgotPassword.profile.lockedBy.agent',
                            frontendMessageP2Key: '',
                            templateUrl: _this.config.advanced.genericErrorModal.templateUrl,
                            modalIcon: 'ute-common-assets/assets/error_warning.png',
                            modalSize: 'md',
                            backendCode: BackEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_LOCKED_BY_AGENT
                        });
                        _this.addCode({
                            frontendCode: FrontEndErrorCode.GENERIC_ERROR,
                            frontendMessageKey: 'ute.common.error.general',
                            frontendMessageP2Key: '',
                            templateUrl: _this.config.advanced.genericErrorModal.templateUrl,
                            modalIcon: 'ute-common-assets/assets/error_warning.png',
                            modalSize: 'md',
                            backendCode: BackEndErrorCode.GENERIC_ERROR,
                            boldChat: {
                                cbid: '',
                                dynamicDivId: '',
                                chatButtonClass: ''
                            }
                        });
                        _this.addCode({
                            frontendCode: FrontEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_REGISTRATION_INCOMPLETE,
                            frontendMessageKey: 'ute.janrain.verification.invalid.error.message',
                            frontendMessageP2Key: '',
                            templateUrl: _this.janrainVerificationService.getConfig().advanced.askEmail.templateUrl,
                            modalIcon: 'ute-common-assets/assets/error_warning.png',
                            modalSize: 'lg',
                            backendCode: BackEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_REGISTRATION_INCOMPLETE,
                            controller: _this.janrainVerificationService.getConfig().advanced.askEmail.controllerName,
                            windowTemplateUrl: _this.janrainVerificationService.getConfig().advanced.askEmail.windowTemplateUrl,
                            errorTitleMessageKey: 'ute.janrain.verification.modalPopup.invalidProfile.title',
                            errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.invalidProfile.subTitle',
                            isForgotPassword: 'true'
                        });
                    };
                    /**
                     * @param response
                     * @returns {any}
                     */
                    this.processOk = function (response) {
                        var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                        // console.log(RogersSetPasswordService.serviceName + '->processOk:', 'response:', response, 'backendCode:', backendCode, this.findCodeEntry(backendCode));
                        return _this.findCodeEntry(backendCode);
                    };
                    /**
                     * @param backendCode
                     * @returns {ICodeEntry|any}
                     */
                    this.findCodeEntry = function (backendCode) { return (_.find(_this.errorCodesMap, function (ce) {
                        return ce.backendCode === backendCode;
                    }) || _this.errorCodesMap[FrontEndErrorCode.GENERIC_ERROR]); };
                    /**
                     * @param error
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.processError = function (error) {
                        var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                        // console.log(RogersSetPasswordService.serviceName + '->processError:', 'error:', error, 'backendCode:', backendCode);
                        var payload = {};
                        var uteRequestId = error.headers('Ute-Request-Id') ? error.headers('Ute-Request-Id') : 'Unknown';
                        var selectedSections = [
                            DataLayerPredefinedSection.ACCOUNT,
                            DataLayerPredefinedSection.PAGE,
                            DataLayerPredefinedSection.SITE
                        ];
                        payload = {
                            errors: {
                                uteRequestId: uteRequestId,
                                type: 'http',
                                category: 'login',
                                message: 'Sorry, something went wrong. We’re working on fixing it as quickly as we can. Please check back in a few minutes',
                                code: error.status,
                                API: (_this.config.advanced.resetPassword.stateName === 'sso/resetPassword') ? 'profile/resetPassword' : 'profile/setPassword'
                            },
                            events: {
                                error: true
                            }
                        };
                        _this.datalayerService.track(payload, false, selectedSections);
                        return new _this.$q(function (resolve, reject) { return reject(_this.findCodeEntry(backendCode)); });
                    };
                    this.finaliseCall = function () { return _this.isCallInProgress = false; };
                    /**
                     * @param response
                     * @returns {any}
                     */
                    this.processForgotPasswordOk = function (response) {
                        var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                        // console.log(RogersSetPasswordService.serviceName + '->processForgotPasswordOk:', 'response:', response, 'backendCode:', backendCode, this.findCodeEntry(backendCode));
                        if (response.data.content.bizMigratedEmailResponsesList) {
                            _this.forgotPasswordModel.isServiceCallSuccess = false;
                            _this.userMigratedEmailResponseModel.isMigEmailPresent = response.data.content.isMigEmailPresent;
                            _this.userMigratedEmailResponseModel.bizMigratedEmailResponsesList = response.data.content.bizMigratedEmailResponsesList;
                        }
                        else {
                            _this.userMigratedEmailResponseModel = null;
                            _this.forgotPasswordModel.isServiceCallSuccess = true;
                        }
                        return _this.findCodeEntry(backendCode);
                    };
                    /**
                     * @param error
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.processForgotPasswordError = function (error) {
                        var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                        var payload = {};
                        var uteRequestId = error.headers('Ute-Request-Id') ? error.headers('Ute-Request-Id') : 'Unknown';
                        var selectedSections = [
                            DataLayerPredefinedSection.ACCOUNT,
                            DataLayerPredefinedSection.PAGE,
                            DataLayerPredefinedSection.SITE
                        ];
                        payload = {
                            errors: {
                                uteRequestId: uteRequestId,
                                type: 'http',
                                category: 'login',
                                message: 'Sorry we were unable to find the email address you’ve entered. Please make sure you’ve entered the correct one and try again.',
                                code: error.status,
                                API: 'profile/forgotPassword'
                            },
                            events: {
                                error: true
                            }
                        };
                        _this.datalayerService.track(payload, false, selectedSections);
                        // console.log(RogersSetPasswordService.serviceName + '->processError:', 'error:', error, 'backendCode:', backendCode);
                        _this.forgotPasswordModel.isServiceCallSuccess = false;
                        _this.janrainVerificationService.setLocale(_this.$cookies.language);
                        //console.log(this.getCookie('language'));
                        return new _this.$q(function (resolve, reject) { return reject(_this.findCodeEntry(backendCode)); });
                    };
                    this.finaliseForgotPasswordCall = function () {
                        _this.isForgotPasswordCallInProgress = false;
                    };
                    this.brtSwitches = function () {
                        var deferred = _this.$q.defer();
                        _this.$http.post(_this.config.advanced.brtSwitches.apiUrl, {}).then(function (response) {
                            var migrationSwitch = false;
                            angular.forEach(response.data, function (obj, key) {
                                if (obj && obj.id === 'BSS_TO_CSS_POST_MIGRATION') {
                                    migrationSwitch = obj.switchIsOn ? false : true;
                                }
                            });
                            deferred.resolve(migrationSwitch);
                        }, function () { return deferred.reject(); });
                        return deferred.promise;
                    };
                    this.autoRegistrationCall = function (request) {
                        var deferred = _this.$q.defer();
                        _this.$http.post(_this.config.advanced.autoRegEmail.apiUrl, request).then(function (response) {
                            deferred.resolve(response);
                        }, function (error) {
                            if (error.data.errorCode == 403) {
                                deferred.reject(error);
                            }
                            else {
                                new _this.$q(function (resolve, reject) { return deferred.reject(_this.findCodeEntry(17052)); });
                            }
                        });
                        return deferred.promise;
                    };
                    this.autoRegistrationStatus = function (request) {
                        var deferred = _this.$q.defer();
                        _this.$http.post(_this.config.advanced.getBSSAutoRegistrationStatus.apiUrl, request).then(function (response) {
                            deferred.resolve(response);
                        }, function () { return deferred.reject(); });
                        return deferred.promise;
                    };
                    this.$cookies = $cookiesTemp;
                    this.janrainVerificationService = $injector.get('ute.janrain.verification.service');
                    this.signinService = $injector.get('ute.rogers.siteminder.signin.service');
                    this.datalayerService = $injector.get('ute.datalayer.common.service');
                    this.addCodes();
                    this.resetModel();
                    this._resetForgotPasswordModel();
                }
                ;
                RogersSetPasswordService.serviceName = 'ute.rogers.setpassword.service';
                return RogersSetPasswordService;
            }());
            var RogersSetPasswordProvider = (function (_super) {
                __extends(RogersSetPasswordProvider, _super);
                /* @ngInject */
                function RogersSetPasswordProvider() {
                    var _this = this;
                    _super.call(this);
                    /* @ngInject */
                    this.$get = function ($injector, $http, $q, $timeout, $state, $cookies, $window, datalayerService) {
                        return new RogersSetPasswordService(_this.config, $injector, $http, $q, $timeout, $state, $cookies, $window, datalayerService);
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$http',
                        '$q',
                        '$timeout',
                        '$state',
                        '$cookies',
                        '$window',
                        'ute.datalayer.common.service'
                    ];
                    this.config = setpassword.DefaultConfigFactory();
                }
                RogersSetPasswordProvider.$inject = [];
                return RogersSetPasswordProvider;
            }(ProviderBase));
            angular.module('ute.rogers.setpassword').provider(RogersSetPasswordService.serviceName, RogersSetPasswordProvider);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            function DefaultConfigFactory() {
                return {
                    basic: {
                        logPrefix: 'RogersSetPassword',
                        logLevel: ute.common.typescript.api.log.LogLevel.OFF
                    },
                    advanced: {
                        setPassword: {
                            apiUrl: 'api/v1/profile/setPassword',
                            stateName: 'sso/setPassword',
                            controllerName: 'ute.rogers.setpassword.controller',
                            templateUrl: 'module/setPassword/setPassword.html',
                            codeVerificationApiUrl: 'api/v1/profile/activate',
                            onSuccessState: 'accountOverview',
                            needAutoRegCheck: true
                        },
                        resetPassword: {
                            apiUrl: 'api/v1/profile/resetPassword',
                            stateName: 'sso/resetPassword',
                            controllerName: 'ute.rogers.setpassword.controller',
                            templateUrl: 'module/setPassword/setPassword.html',
                            codeVerificationApiUrl: 'api/v1/profile/forgotPasswordValidation',
                            needAutoRegCheck: false
                        },
                        forgotPassword: {
                            apiUrl: 'api/v1/profile/forgotPassword',
                            stateName: 'sso/forgotPassword',
                            cancelState: 'signin',
                            controllerName: 'ute.rogers.forgotpassword.controller',
                            templateUrl: 'module/forgotPassword/forgotPassword.html'
                        },
                        changeUsernameSuccess: {
                            stateName: 'sso/changeUsernameSuccess',
                            controllerName: 'ute.rogers.changeUsernameSuccess.controller',
                            templateUrl: 'module/changeUsernameSuccess/changeUsernameSuccess.html'
                        },
                        genericErrorModal: {
                            windowTemplateUrl: 'module/setPassword/setPasswordErrorMessageWindow.view.html',
                            controllerName: 'ute.rogers.setpassword.error.controller',
                            templateUrl: 'module/setPassword/setPasswordGenericErrorModal.view.html'
                        },
                        brtSwitches: {
                            apiUrl: '/web/RogersServices.portal/smb/api/v1/brtSwitches',
                            stateName: 'sso/forgotPassword'
                        },
                        autoRegEmail: {
                            apiUrl: '/web/smb/api/business/v1/consumer/autoRegister',
                            stateName: 'sso/forgotPassword'
                        },
                        getBSSAutoRegistrationStatus: {
                            apiUrl: '/web/smb/api/business/v1/getAutoRegistrationStatus',
                            stateName: 'sso/forgotPassword'
                        }
                    }
                };
            }
            setpassword.DefaultConfigFactory = DefaultConfigFactory;
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
            angular.module('ute.common.encryption').config(configure).run(addStateHandler);
            configure.$inject = ['$cryptoProvider'];
            /* @ngInject */
            function configure($cryptoProvider) {
                $cryptoProvider.setCryptographyKey('ABCD123');
            }
            addStateHandler.$inject = ['ute.blocks.router', 'ute.common.encryption.service'];
            /* @ngInject */
            function addStateHandler(routerHelper, encryptionService) {
                routerHelper.registerGlobalToStateHandler(encryptionService);
            }
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
            // !!!! Do not remove or rename existing members only add new at the end
            var Params;
            (function (Params) {
                Params[Params["phoneNumber"] = 1] = "phoneNumber";
                Params[Params["accountNumber"] = 2] = "accountNumber";
                Params[Params["currentSimCardNumber"] = 3] = "currentSimCardNumber";
                Params[Params["newSimCardNumber"] = 4] = "newSimCardNumber";
                Params[Params["accountEmail"] = 5] = "accountEmail";
                Params[Params["deviceNameEn"] = 6] = "deviceNameEn";
                Params[Params["deviceNameFr"] = 7] = "deviceNameFr";
                Params[Params["firstName"] = 8] = "firstName";
                Params[Params["email"] = 9] = "email";
            })(Params || (Params = {}));
            var EncryptionService = (function () {
                /* @ngInject */
                function EncryptionService(logger, $crypto, userService, utilsService, $state) {
                    var _this = this;
                    this.logger = logger;
                    this.$crypto = $crypto;
                    this.userService = userService;
                    this.utilsService = utilsService;
                    this.$state = $state;
                    this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                        var params = _.intersection(_.keys(toParams), _.get(toState, 'data.encryption.params'));
                        if (params) {
                            params.forEach(function (param) {
                                _this.decrypt(toParams[param]).then(function () {
                                    //
                                }).catch(function (error) {
                                    event.preventDefault();
                                    _this.$state.go(_.get(toState, 'data.encryption.failbackState'));
                                });
                            });
                        }
                        else {
                            event.preventDefault();
                            _this.$state.go(_.get(toState, 'data.encryption.failbackState'));
                        }
                        return true;
                    };
                    this._encrypt = function (obj) {
                        return _this.userService.getEncryptionKey().then(_.curry(_this.encryptWithKey)(obj));
                    };
                    /**
                     * @param obj
                     * @returns {string}
                     */
                    this.resolver = function (obj) {
                        if (_this.userService.getUser()) {
                            var userName = _this.userService.getUser().userName;
                            var objStr = _.isString(obj) ? obj : angular.toJson(obj);
                            //console.log('EncryptionService->resolver:', objStr + userName);
                            return objStr + userName;
                        }
                        else {
                            _this.utilsService.randomString();
                        }
                    };
                    /**
                     * @param obj
                     * @param key
                     * @returns {ng.IPromise<string>|*|any}
                     */
                    this.encryptWithKey = function (obj, key) {
                        //console.log('EncryptionService->encrypt:', key);
                        //console.log('EncryptionService->encrypt:', key, obj, (_.reduce<{}, _.Dictionary<{}>>(
                        //    obj,
                        //    (result: _.Dictionary<{}>, value: {}, key: string): _.Dictionary<{}> => {
                        //      result[_.find([Params[key], key], angular.isDefined)] = value;
                        //      return result;
                        //    }, {})));
                        return _this.$crypto.encrypt(angular.toJson(_.reduce(obj, function (result, value, key) {
                            result[_.find([Params[key], key], angular.isDefined)] = value;
                            return result;
                        }, {})), key);
                    };
                    /**
                     * @param str
                     * @returns {any}
                     * @private
                     */
                    this._decrypt = function (str) {
                        return _this.userService.getEncryptionKey().then(_.curry(_this.decryptWithKey)(str));
                    };
                    /**
                     * @param str
                     * @param key
                     * @returns {any}
                     */
                    this.decryptWithKey = function (str, key) {
                        try {
                            //console.log('EncryptionService->decrypt:', str, key, angular.fromJson(this.$crypto.decrypt(str, key)));
                            return _.reduce(angular.fromJson(_this.$crypto.decrypt(str, key)), function (result, value, key) {
                                result[_.find([Params[key], key], angular.isDefined)] = value;
                                return result;
                            }, {});
                        }
                        catch (e) {
                            throw new Error('EncryptionService->decryptWithKey error: ' + e.toString());
                        }
                    };
                    this.encrypt = _.memoize(this._encrypt, this.resolver);
                    this.decrypt = _.memoize(this._decrypt, this.resolver);
                }
                EncryptionService.$inject = [
                    'ute.blocks.loggerService',
                    '$crypto',
                    'ute.common.user.service',
                    'ute.common.utils.service',
                    '$state'
                ];
                return EncryptionService;
            }());
            angular.module('ute.common.encryption').service('ute.common.encryption.service', EncryptionService);
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            'use strict';
            var ErrorModalController = (function () {
                /* @ngInject */
                function ErrorModalController($modalInstance, errorCode, janrainVerificationService) {
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.errorCode = errorCode;
                    this.janrainVerificationService = janrainVerificationService;
                    this.getModalIcon = function () { return _this.errorCode.modalIcon; };
                    this.getFrontendMessageKey = function () { return _this.errorCode.frontendMessageKey; };
                    this.getFrontendMessageP2Key = function () { return _this.errorCode.frontendMessageP2Key; };
                    this.getBoldChat = function () { return _this.errorCode.boldChat; };
                    this.noSelection = function () {
                        _this.$modalInstance.dismiss('cancel');
                        return _this.janrainVerificationService.goToRescueState();
                    };
                    this.cancel = function () { return _this.$modalInstance.close('no'); };
                    this.continue = function () { return _this.$modalInstance.close('yes'); };
                }
                ErrorModalController.controlerName = 'ute.janrain.verification.error.modal.controller';
                ErrorModalController.$inject = ['$modalInstance',
                    'ute.janrain.verification.errorHandler',
                    'ute.janrain.verification.service'];
                return ErrorModalController;
            }());
            verification.ErrorModalController = ErrorModalController;
            angular.module('ute.janrain.verification').controller(ErrorModalController.controlerName, ErrorModalController);
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            'use strict';
            var InvalidForgotPasswordModalController = (function () {
                /* @ngInject */
                function InvalidForgotPasswordModalController($modalInstance, errorCode, janrainVerificationService, $state) {
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.errorCode = errorCode;
                    this.janrainVerificationService = janrainVerificationService;
                    this.$state = $state;
                    this.getModalIcon = function () { return _this.errorCode.modalIcon; };
                    this.getFrontendMessageKey = function () { return _this.errorCode.frontendMessageKey; };
                    this.getFrontendMessageP2Key = function () { return _this.errorCode.frontendMessageP2Key; };
                    this.getBoldChat = function () { return _this.errorCode.boldChat; };
                    this.noSelection = function () {
                        _this.$modalInstance.dismiss('cancel');
                        return _this.janrainVerificationService.goToRescueState();
                    };
                    this.cancel = function () {
                        _this.$modalInstance.dismiss('cancel');
                        return _this.janrainVerificationService.goToRescueState();
                    };
                    this.tryAgain = function () {
                        _this.$modalInstance.close();
                        return _this.$state.go('sso/forgotPassword');
                    };
                }
                InvalidForgotPasswordModalController.controlerName = 'ute.janrain.verification.invalidate.forgot.password.controller';
                InvalidForgotPasswordModalController.$inject = ['$modalInstance',
                    'ute.janrain.verification.errorHandler',
                    'ute.janrain.verification.service',
                    '$state'];
                return InvalidForgotPasswordModalController;
            }());
            verification.InvalidForgotPasswordModalController = InvalidForgotPasswordModalController;
            angular.module('ute.janrain.verification').controller(InvalidForgotPasswordModalController.controlerName, InvalidForgotPasswordModalController);
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var resend;
            (function (resend) {
                var email;
                (function (email) {
                    'use strict';
                    var ResponseErrorHandlerGeneric = ute.common.core.service.ResponseErrorHandlerGeneric;
                    /**
                     * Private
                     */
                    var BackEndErrorCode = (function () {
                        function BackEndErrorCode() {
                        }
                        BackEndErrorCode.CODE_OK = 0;
                        BackEndErrorCode.GENERIC_ERROR = 17000;
                        BackEndErrorCode.EMAIL_ALREADY_VARIFIED = 17003;
                        BackEndErrorCode.EMAIL_NOT_FOUND = 17004;
                        return BackEndErrorCode;
                    }());
                    var FrontEndErrorCode;
                    (function (FrontEndErrorCode) {
                        FrontEndErrorCode[FrontEndErrorCode["CODE_OK"] = 0] = "CODE_OK";
                        FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                        FrontEndErrorCode[FrontEndErrorCode["EMAIL_ALREADY_VARIFIED"] = 2] = "EMAIL_ALREADY_VARIFIED";
                        FrontEndErrorCode[FrontEndErrorCode["EMAIL_NOT_FOUND"] = 3] = "EMAIL_NOT_FOUND";
                    })(FrontEndErrorCode || (FrontEndErrorCode = {}));
                    var ResendEmailService = (function (_super) {
                        __extends(ResendEmailService, _super);
                        /* @ngInject */
                        function ResendEmailService($injector, $state, $http, $modal, janrainVerificationService, encryptionService, $window, $cookiesTemp) {
                            var _this = this;
                            _super.call(this, FrontEndErrorCode.GENERIC_ERROR, BackEndErrorCode.GENERIC_ERROR, ResendEmailService.serviceName, $injector);
                            this.$state = $state;
                            this.$http = $http;
                            this.$modal = $modal;
                            this.janrainVerificationService = janrainVerificationService;
                            this.encryptionService = encryptionService;
                            this.$window = $window;
                            this.model = { email: undefined, locale: undefined };
                            this.processOkSuper = this.processOk; // super.processOk
                            /**
                             * implementation of ute.blocks.router.IStateHandler
                             * @param event
                             * @param toState
                             * @param toParams
                             * @param fromState
                             * @param fromParams
                             * @returns {boolean}
                             */
                            this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                                _this.restoreFromInput(toParams).then(function (result) {
                                    // console.log(UserRegistrationService.serviceName + '->stateTransitionHandler->then', result);
                                    if (!result) {
                                        event.preventDefault();
                                    }
                                });
                                return true;
                            };
                            this.getEmail = function () { return _this.model.email; };
                            // isCallInProgress: () => boolean = () => this.isCallInProgress;
                            /**
                             * @returns {IPromise<ICodeEntry>}
                             */
                            this.resendEmail = function (model) {
                                var request = {
                                    email: model.email,
                                    lang: model.locale !== '' ? model.locale : _this.$cookies.language,
                                    isForgotPassword: location.href.indexOf("resetPassword") != -1 ? "true" : ""
                                };
                                if (model.isForgotPassword) {
                                    var request = {
                                        email: _this.$window.localStorage.getItem('profileValidateEmail'),
                                        lang: model.locale
                                    };
                                }
                                _this.model.email = model.email;
                                _this.isCallInProgress = true;
                                return _this.$http.post(_this.config.basic.resendEmailApiUrl, request)
                                    .then(_this.processOk)
                                    .catch(_this.processError)
                                    .finally(_this.finaliseCall);
                            };
                            /**
                             * @override
                             * @param response
                             * @return {ICodeEntry}
                             */
                            this.processOk = function (response) {
                                var retval = _this.processOkSuper(response);
                                _this.model.email = response.config.data.email;
                                _this.goToResendEmailConfirmation();
                                return retval;
                            };
                            this.openModalPopup = function (codeEntry) {
                                return _this.$modal.open({
                                    windowTemplateUrl: codeEntry.windowTemplateUrl,
                                    templateUrl: codeEntry.templateUrl,
                                    controller: codeEntry.controller,
                                    controllerAs: 'errorModal',
                                    size: codeEntry.modalSize,
                                    backdrop: 'static',
                                    resolve: {
                                        'ute.janrain.verification.errorHandler': codeEntry
                                    }
                                }).result.then(function (result) {
                                    // console.log(ResendEmailService.serviceName + '->openModalPopup->then:', 'result:', result);
                                    // Result selection behaviour
                                    switch (result) {
                                        case 'yes':
                                            return true;
                                        case 'no':
                                            return false;
                                        default:
                                            return false;
                                    }
                                }).catch(function (reason) {
                                    // console.log(ResendEmailService.serviceName + '->openModalPopup->catch:', 'reason:', reason);
                                    return false;
                                });
                            };
                            this.addCodes = function () {
                                _this.addCode({
                                    frontendCode: FrontEndErrorCode.CODE_OK,
                                    // templateUrl: this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/green-checkbox.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.CODE_OK
                                });
                                _this.addCode({
                                    frontendCode: FrontEndErrorCode.GENERIC_ERROR,
                                    errorTitleMessageKey: 'ute.janrain.verification.modalPopup.expired.title',
                                    errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.expired.subTitle',
                                    frontendMessageKey: 'ute.common.label.system.error.message',
                                    frontendMessageP2Key: 'ute.common.label.system.error.message.p2',
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    // modalSize: 'md',
                                    backendCode: BackEndErrorCode.GENERIC_ERROR,
                                    boldChat: {
                                        cbid: 'ute.rogers.myrSimCard.boldChat.cbid',
                                        dynamicDivId: 'ute.rogers.myrSimCard.boldChat.dynamicDivId',
                                        chatButtonClass: 'ute.rogers.myrSimCard.boldChat.chatButtonClass'
                                    }
                                });
                                _this.addCode({
                                    frontendCode: FrontEndErrorCode.EMAIL_ALREADY_VARIFIED,
                                    errorTitleMessageKey: 'ute.janrain.verification.modalPopup.email.already.verified.title',
                                    errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.email.already.verified.subTitle',
                                    frontendMessageKey: 'ute.janrain.verification.email.already.verified.error.message',
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'lg',
                                    backendCode: BackEndErrorCode.EMAIL_ALREADY_VARIFIED
                                });
                                _this.addCode({
                                    frontendCode: FrontEndErrorCode.EMAIL_NOT_FOUND,
                                    errorTitleMessageKey: 'ute.janrain.verification.modalPopup.email.not.found.title',
                                    errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.email.not.found.subTitle',
                                    frontendMessageKey: 'ute.janrain.verification.email.not.found.error.message',
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'lg',
                                    backendCode: BackEndErrorCode.EMAIL_NOT_FOUND
                                });
                            };
                            /**
                             * @param $stateParams
                             * @returns {IPromise<boolean>}
                             */
                            this.restoreFromInput = function ($stateParams) {
                                if ($stateParams.id) {
                                    return _this.encryptionService.decrypt($stateParams.id).then(function (obj) {
                                        // console.log(UserRegistrationService.serviceName + '->restoreFromInput->then', obj);
                                        if (obj.email) {
                                            _this.model.email = obj.email;
                                            return true;
                                        }
                                        else {
                                            // this.$state.go(this.config.advanced.registration.stateName);
                                            return false;
                                        }
                                    }).catch(function (error) {
                                        // console.log(UserRegistrationService.serviceName + '->restoreFromInput->catch', error);
                                        // this.$state.go(this.config.advanced.registration.stateName);
                                        return false;
                                    });
                                }
                                else {
                                    // this.$state.go(this.config.advanced.registration.stateName);
                                    return new _this.$q(function (resolve) { return resolve(false); });
                                }
                            };
                            this.goToResendEmailConfirmation = function () {
                                return _this.$state.go(_this.config.advanced.emailResendConfirmation.stateName);
                            };
                            this.$cookies = $cookiesTemp;
                            this.config = this.janrainVerificationService.getConfig();
                            this.addCodes();
                        }
                        ;
                        ResendEmailService.serviceName = 'ute.janrain.verification.resend.email.service';
                        ResendEmailService.$inject = [
                            '$injector',
                            '$state',
                            '$http',
                            '$modal',
                            'ute.janrain.verification.service',
                            'ute.common.encryption.service',
                            '$window',
                            '$cookies'
                        ];
                        return ResendEmailService;
                    }(ResponseErrorHandlerGeneric));
                    angular.module('ute.janrain.verification').service(ResendEmailService.serviceName, ResendEmailService);
                })(email = resend.email || (resend.email = {}));
            })(resend = verification.resend || (verification.resend = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
                var ProviderBase = ute.common.core.ProviderBase;
                var ResponseErrorHandlerGeneric = ute.common.core.service.ResponseErrorHandlerGeneric;
                /**
                 * Private
                 */
                var BackEndErrorCode = (function () {
                    function BackEndErrorCode() {
                    }
                    BackEndErrorCode.CODE_OK = 0;
                    BackEndErrorCode.GENERIC_FAILURE = 17010;
                    BackEndErrorCode.CODE_EXPIRED = 17001;
                    BackEndErrorCode.INVALID_CODE = 17028;
                    BackEndErrorCode.FORGOT_PASSWORD_MIDDLEWARE_FAILURE = 17056;
                    BackEndErrorCode.FORGOT_PASSWORD_VALIDATION_FAILED_CODE = 17092;
                    BackEndErrorCode.LOCKED_BY_AGENT = 17009;
                    return BackEndErrorCode;
                }());
                (function (FrontEndErrorCode) {
                    FrontEndErrorCode[FrontEndErrorCode["CODE_OK"] = 0] = "CODE_OK";
                    FrontEndErrorCode[FrontEndErrorCode["GENERIC_FAILURE"] = 1] = "GENERIC_FAILURE";
                    FrontEndErrorCode[FrontEndErrorCode["CODE_EXPIRED"] = 2] = "CODE_EXPIRED";
                    FrontEndErrorCode[FrontEndErrorCode["INVALID_CODE"] = 3] = "INVALID_CODE";
                    FrontEndErrorCode[FrontEndErrorCode["FORGOT_PASSWORD_MIDDLEWARE_FAILURE"] = 4] = "FORGOT_PASSWORD_MIDDLEWARE_FAILURE";
                    FrontEndErrorCode[FrontEndErrorCode["FORGOT_PASSWORD_VALIDATION_FAILED_CODE"] = 5] = "FORGOT_PASSWORD_VALIDATION_FAILED_CODE";
                    FrontEndErrorCode[FrontEndErrorCode["LOCKED_BY_AGENT"] = 6] = "LOCKED_BY_AGENT";
                })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                var FrontEndErrorCode = service.FrontEndErrorCode;
                var JanrainVerificationService = (function (_super) {
                    __extends(JanrainVerificationService, _super);
                    function JanrainVerificationService(config, $injector) {
                        var _this = this;
                        _super.call(this, FrontEndErrorCode.GENERIC_FAILURE, BackEndErrorCode.GENERIC_FAILURE, JanrainVerificationService.serviceName, $injector);
                        this.config = config;
                        /**
                         * implementation of ute.blocks.router.IStateHandler
                         * @param event
                         * @param toState
                         * @param toParams
                         * @param fromState
                         * @param fromParams
                         * @returns {boolean}
                         */
                        this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                            if (angular.isUndefined(_.get(toState, 'data.settings.codeVerificationApiUrl'))) {
                                _this.storageService.removeFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION);
                            }
                            else {
                                var isOcp = _this.extractCode('flow');
                                var ocpBrt = 'false';
                                if (isOcp === 'ocpbrt') {
                                    ocpBrt = 'true';
                                }
                                _this.model = {
                                    verificationCode: toParams.id || _this.extractCode('code') || _this.extractCode('verification_code'),
                                    email: undefined,
                                    uuid: undefined,
                                    token: undefined,
                                    isOcpBrtEnabled: ocpBrt,
                                    locale: _this.extractCode('lang') || '',
                                    needAutoRegCheck: toState.data.settings.needAutoRegCheck
                                };
                                _this.verifyJanrainCode(toState.data.settings.codeVerificationApiUrl);
                            }
                            return true;
                        };
                        this.getConfig = function () { return angular.copy(_this.config); };
                        this.getVerificationCode = function () { return _this.model.verificationCode; };
                        this.getIsOcpBrtEnabled = function () { return _this.model.isOcpBrtEnabled; };
                        this.getUuid = function () { return _this.model.uuid; };
                        this.getEmail = function () { return _this.model.email; };
                        this.getToken = function () { return _this.model.token; };
                        this.getLocale = function () { return _this.model.locale; };
                        this.setLocale = function (tempLocale) {
                            if (_.isEmpty(_this.model)) {
                                _this.model = {
                                    verificationCode: '',
                                    locale: tempLocale
                                };
                            }
                            else {
                                _this.model.locale = tempLocale;
                            }
                            return _this.model;
                        };
                        // isCodeExpired: () => boolean = () => !angular.isDefined(this.model.uuid); // TODO
                        this.isCodeValid = function () { return (angular.isDefined(_this.model.uuid) || angular.isDefined(_this.model.token)) && angular.isDefined(_this.model.verificationCode); };
                        this.isJanrainVerificationCallInProgress = function () { return _this.isCallInProgress; };
                        this.goToRescueState = function () { return _this.$state.go(_this.config.basic.rescueState); };
                        /**
                         * @returns {IPromise<ICodeEntry>}
                         */
                        this.verifyJanrainCode = function (codeVerificationApiUrl) {
                            var request = {
                                code: _this.model.verificationCode,
                                isOcpBrtEnabled: _this.model.isOcpBrtEnabled
                            };
                            _this.isCallInProgress = true;
                            _this.model.uuid = undefined;
                            _this.model.email = undefined;
                            _this.model.token = undefined;
                            _this.openVerificationModalPopup();
                            return _this.$http.post(codeVerificationApiUrl || _this.config.basic.codeVerificationApiUrl, request)
                                .then(_this.processOk)
                                .catch(_this.processError)
                                .finally(_this.finaliseCall);
                        };
                        /**
                         * @param errorHandler
                         * @returns {IPromise<boolean>}
                         */
                        this.openModalPopup = function (errorHandler) {
                            return _this.$modal.open({
                                windowTemplateUrl: errorHandler.windowTemplateUrl,
                                templateUrl: errorHandler.templateUrl,
                                controller: errorHandler.controller,
                                controllerAs: 'errorModal',
                                size: errorHandler.modalSize,
                                backdrop: 'static',
                                resolve: {
                                    'ute.janrain.verification.errorHandler': errorHandler
                                }
                            }).result.then(function (result) {
                                // console.log(JanrainVerificationService.serviceName + '->openModalPopup->then:', 'result:', result);
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        return true;
                                    case 'no':
                                        return false;
                                    default:
                                        return false;
                                }
                            }).catch(function (reason) {
                                // console.log(JanrainVerificationService.serviceName + '->openModalPopup->catch:', 'reason:', reason);
                                return false;
                            });
                        };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processOk = function (response) {
                            var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_FAILURE);
                            var retval = _this.findCodeEntry(backendCode);
                            // console.log(JanrainVerificationService.serviceName + '->processOk:', 'response:', response, 'backendCode:', backendCode, 'retval:', retval);
                            _this.$modalInstance.close();
                            if (angular.isObject(response.data)) {
                                // same code can be used only once - but we have to support refresh (F5)
                                var model = _this.storageService.getFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION);
                                if (_.get(model, 'verificationCode') !== response.config.data.code) {
                                    _this.model.uuid = _.get(response.data, 'content.attributes.uuid');
                                    var email = _.get(response.data, 'content.attributes.email');
                                    if (!email) {
                                        email = _.get(response.data, 'content.email');
                                    }
                                    if (!_this.model.uuid) {
                                        _this.model.uuid = _.get(response.data, 'content.uuid');
                                    }
                                    //  let newUserID = _.get<string>(response.data,'content.attributes.newUserID');
                                    //  this.model.email = email ? email : newUserID;
                                    _this.model.email = email;
                                    _this.model.token = response.data.content.token;
                                    // TODO when it will be removed
                                    // console.log('xxxxxxxxxxxxxxxxxx', this.model);
                                    _this.storageService.putToLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION, _this.model);
                                }
                                else {
                                    _this.model = model;
                                }
                                if (_this.isCodeValid()) {
                                    _this.openVerifySuccessModalPopup();
                                    /**
                                     * Add autoreg check logic:
                                     * when autoreg is true means New Registration then stay in set password page
                                     * when autoreg is false means change username then redirect user to resue state
                                     */
                                    if (_this.model.needAutoRegCheck && !_.get(response.data, 'content.attributes.autoreg')) {
                                        _this.goToRescueState();
                                    }
                                    if (_this.model.needAutoRegCheck && !_.get(response.data, 'content.autoreg')) {
                                        _this.goToRescueState();
                                    }
                                }
                                else {
                                    if (retval.windowTemplateUrl) {
                                        _this.openModalPopup(retval);
                                    }
                                }
                            }
                            return retval;
                        };
                        /**
                         * @param error
                         * @returns {any}
                         */
                        this.processError = function (error) {
                            var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_FAILURE);
                            // console.log(JanrainVerificationService.serviceName + '->processError:', 'error:', error, 'backendCode:', backendCode);
                            /**
                             * Close verification modal
                             */
                            _this.$modalInstance.close();
                            /**
                             * Because the validation token will expire within 1 hour
                             * therefore the system cannot let the user the set the new password
                             * when the code validation has failed
                             */
                            // if (angular.isObject(error.config)) {
                            //   // same code can be used only once
                            //   const model: IJanrainVerificationModel = this.storageService.getFromLocal<IJanrainVerificationModel>(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION);
                            //   if (_.get(model, 'verificationCode') === _.get(error.config, 'data.code')) {
                            //     this.model = model;
                            //     backendCode = BackEndErrorCode.CODE_OK;
                            //     this.openVerifySuccessModalPopup();
                            //   }
                            // }
                            var retval = _this.findCodeEntry(backendCode);
                            if (retval.windowTemplateUrl) {
                                return _this.openModalPopup(retval);
                            }
                            else {
                                return retval;
                            }
                        };
                        /**
                         * Extract code from http query
                         * @param paramName
                         * @return {string}
                         */
                        this.extractCode = function (paramName) {
                            return _this.$location.search()[paramName] || _.get(_this.utilsService.getQueryParameters(), paramName);
                        };
                        this.addCodes = function () {
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.CODE_OK,
                                // templateUrl: this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                modalIcon: 'ute-common-assets/assets/green-checkbox.png',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.CODE_OK
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.GENERIC_FAILURE,
                                frontendMessageKey: 'ute.common.label.system.error.message',
                                frontendMessageP2Key: 'ute.common.label.system.error.message.p2',
                                templateUrl: _this.config.advanced.genericErrorModal.templateUrl,
                                controller: _this.config.advanced.genericErrorModal.controllerName,
                                windowTemplateUrl: _this.config.advanced.genericErrorModal.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.GENERIC_FAILURE,
                                boldChat: {
                                    cbid: 'ute.rogers.myrSimCard.boldChat.cbid',
                                    dynamicDivId: 'ute.rogers.myrSimCard.boldChat.dynamicDivId',
                                    chatButtonClass: 'ute.rogers.myrSimCard.boldChat.chatButtonClass' // TODO
                                }
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.CODE_EXPIRED,
                                errorTitleMessageKey: 'ute.janrain.verification.modalPopup.expired.title',
                                errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.expired.subTitle',
                                frontendMessageKey: 'ute.janrain.verification.expired.error.message',
                                // frontendMessageP2Key: 'ute.janrain.verification.system.error.message.p2',
                                templateUrl: _this.config.advanced.askEmail.templateUrl,
                                controller: _this.config.advanced.askEmail.controllerName,
                                windowTemplateUrl: _this.config.advanced.askEmail.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'lg',
                                backendCode: BackEndErrorCode.CODE_EXPIRED
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.INVALID_CODE,
                                errorTitleMessageKey: 'ute.janrain.verification.modalPopup.invalid.title',
                                errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.invalid.subTitle',
                                frontendMessageKey: 'ute.janrain.verification.invalid.error.message',
                                // frontendMessageP2Key: 'ute.janrain.verification.system.error.message.p2',
                                templateUrl: _this.config.advanced.askEmail.templateUrl,
                                controller: _this.config.advanced.askEmail.controllerName,
                                windowTemplateUrl: _this.config.advanced.askEmail.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'lg',
                                backendCode: BackEndErrorCode.INVALID_CODE
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.FORGOT_PASSWORD_VALIDATION_FAILED_CODE,
                                errorTitleMessageKey: 'ute.janrain.verification.modalPopup.invalid.title',
                                errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.invalid.subTitle',
                                frontendMessageKey: 'ute.janrain.verification.invalid.error.message',
                                templateUrl: _this.config.advanced.invalidForgotPasswordModal.templateUrl,
                                controller: _this.config.advanced.invalidForgotPasswordModal.controllerName,
                                windowTemplateUrl: _this.config.advanced.invalidForgotPasswordModal.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'lg',
                                backendCode: BackEndErrorCode.FORGOT_PASSWORD_VALIDATION_FAILED_CODE
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.FORGOT_PASSWORD_MIDDLEWARE_FAILURE,
                                errorTitleMessageKey: 'ute.janrain.verification.modalPopup.middleware.failure.title',
                                errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.middleware.failure.subTitle',
                                frontendMessageKey: 'ute.janrain.verification.invalid.error.message',
                                // frontendMessageP2Key: 'ute.janrain.verification.system.error.message.p2',
                                templateUrl: _this.config.advanced.askEmail.templateUrl,
                                controller: _this.config.advanced.askEmail.controllerName,
                                windowTemplateUrl: _this.config.advanced.askEmail.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'lg',
                                backendCode: BackEndErrorCode.FORGOT_PASSWORD_MIDDLEWARE_FAILURE
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.LOCKED_BY_AGENT,
                                frontendMessageKey: 'ute.janrain.verification.modalPopup.lockeByAgent',
                                // frontendMessageP2Key: 'ute.janrain.verification.system.error.message.p2',
                                templateUrl: _this.config.advanced.genericErrorModal.templateUrl,
                                controller: _this.config.advanced.genericErrorModal.controllerName,
                                windowTemplateUrl: _this.config.advanced.genericErrorModal.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.LOCKED_BY_AGENT
                            });
                        };
                        this.$location = $injector.get('$location');
                        this.storageService = $injector.get('ute.blocks.persistent.storage.service');
                        this.$modal = $injector.get('$modal');
                        this.$http = $injector.get('$http');
                        this.$timeout = $injector.get('$timeout');
                        this.$state = $injector.get('$state');
                        this.utilsService = $injector.get('ute.common.utils.service');
                        this.encryptionService = $injector.get('ute.common.encryption.service');
                        this.addCodes();
                    }
                    ;
                    /**
                     * @returns {IPromise<boolean>}
                     */
                    JanrainVerificationService.prototype.openVerificationModalPopup = function () {
                        this.$modalInstance = this.$modal.open({
                            windowTemplateUrl: this.config.advanced.verificationModal.windowTemplateUrl,
                            templateUrl: this.config.advanced.verificationModal.templateUrl,
                            controller: this.config.advanced.verificationModal.controllerName,
                            controllerAs: 'verificationModal',
                            size: 'md',
                            backdrop: 'static',
                            keyboard: false
                        });
                    };
                    JanrainVerificationService.prototype.openVerifySuccessModalPopup = function () {
                        /**
                         * open success modal and wait for 5 seconds then close the modal
                         */
                        var $modalInstance = this.$modal.open({
                            windowTemplateUrl: 'module/janrainVerification/verificationModal/janrainVerification.modal.success.view.html',
                            templateUrl: this.config.advanced.verificationModal.templateUrl,
                            controller: this.config.advanced.verificationModal.controllerName,
                            controllerAs: 'verificationModal',
                            size: 'md',
                            backdrop: 'static',
                            keyboard: false
                        });
                        this.$timeout(function () {
                            $modalInstance.close();
                        }, 5000);
                    };
                    JanrainVerificationService.serviceName = 'ute.janrain.verification.service';
                    return JanrainVerificationService;
                }(ResponseErrorHandlerGeneric));
                var JanrainVerificationProvider = (function (_super) {
                    __extends(JanrainVerificationProvider, _super);
                    /* @ngInject */
                    function JanrainVerificationProvider() {
                        var _this = this;
                        _super.call(this);
                        /* @ngInject */
                        this.$get = function ($injector) {
                            return new JanrainVerificationService(_this.config, $injector);
                        };
                        this.$get.$inject = ['$injector'];
                        this.config = service.DefaultConfigFactory();
                    }
                    JanrainVerificationProvider.$inject = [];
                    return JanrainVerificationProvider;
                }(ProviderBase));
                angular.module('ute.janrain.verification').provider(JanrainVerificationService.serviceName, JanrainVerificationProvider);
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
                function DefaultConfigFactory() {
                    return {
                        basic: {
                            applicationId: 'ute-application-id',
                            codeVerificationApiUrl: 'api/v1/profile/activate',
                            resendEmailApiUrl: 'api/v1/profile/reactivate',
                            logPrefix: 'JanrainVerification',
                            logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                            rescueState: 'signin'
                        },
                        advanced: {
                            genericErrorModal: {
                                controllerName: 'ute.janrain.verification.error.modal.controller',
                                windowTemplateUrl: 'module/janrainVerification/genericError/errorWindow.view.html',
                                templateUrl: 'module/janrainVerification/genericError/errorModal.view.html'
                            },
                            askEmail: {
                                controllerName: 'ute.janrain.verification.resend.email.ask.controller',
                                windowTemplateUrl: 'module/janrainVerification/resendEmail/askEmail/window.view.html',
                                templateUrl: 'module/janrainVerification/resendEmail/askEmail/modal.view.html'
                            },
                            invalidForgotPasswordModal: {
                                controllerName: verification.InvalidForgotPasswordModalController.controlerName,
                                windowTemplateUrl: 'module/janrainVerification/invalidForgotPassword/invalidForgotPasswordWindow.view.html',
                                templateUrl: 'module/janrainVerification/invalidForgotPassword/invalidForgotPasswordModal.view.html'
                            },
                            verificationModal: {
                                controllerName: service.VerificationModalController.controlerName,
                                windowTemplateUrl: 'module/janrainVerification/verificationModal/janrainVerification.modal.window.view.html',
                                templateUrl: 'module/janrainVerification/verificationModal/janrainVerification.modal.window.view.html'
                            },
                            emailResendConfirmation: {
                                stateName: 'sso/emailResendConfirmation',
                                controllerName: 'ute.janrain.verification.resend.email.confirmation.controller',
                                templateUrl: 'module/janrainVerification/resendEmail/confirmation/view.html'
                            }
                        }
                    };
                }
                service.DefaultConfigFactory = DefaultConfigFactory;
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
                /* @ngInject */
                var VerificationModalController = (function () {
                    /* @ngInject */
                    function VerificationModalController($modalInstance) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.noSelection = function () {
                            _this.$modalInstance.dismiss('cancel');
                        };
                        // console.log('ute.janrain.verification.service:', $modalInstance, contentId);
                    }
                    VerificationModalController.$inject = ['$modalInstance'];
                    VerificationModalController.controlerName = 'ute.rogers.verification.modal.controller';
                    return VerificationModalController;
                }());
                service.VerificationModalController = VerificationModalController;
                angular.module('ute.janrain.verification').controller(VerificationModalController.controlerName, VerificationModalController);
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnConfirmController = (function () {
                    /* @ngInject */
                    function SuspendCtnConfirmController($modal, suspendCtnService, $state) {
                        this.$modal = $modal;
                        this.suspendCtnService = suspendCtnService;
                        this.$state = $state;
                        this.isSuspendCtnCallInProgress = suspendCtnService.isSuspendCtnCallInProgress;
                    }
                    /**
                     * Switch Off Service
                     */
                    SuspendCtnConfirmController.prototype.switchOffService = function ($event) {
                        var _this = this;
                        $event.preventDefault();
                        return this.suspendCtnService.suspendCtn().then(function (result) {
                            //console.log('submitConfirmation', errorHandler, FrontEndErrorCode[errorHandler.frontendCode]);
                            switch (result.frontendCode) {
                                case ute.common.suspend.ctn.service.FrontEndErrorCode.UPDATED_OK:
                                    _this.suspendCtnService.goToState(_this.suspendCtnService.getConfig().advanced.suspendCtnSuccess.subState);
                                    break;
                                default:
                                    // this.suspendCtnService.goToState(this.suspendCtnService.getConfig().advanced.suspendCtnSuccess.subState); // TODO remove
                                    _this.openModalPopup(result);
                                    break;
                            }
                            return result;
                        }).catch(function (error) {
                            _this.openModalPopup(error);
                            return error;
                        });
                    };
                    SuspendCtnConfirmController.prototype.backToDevice = function ($event) {
                        $event.preventDefault();
                        return this.$state.go(this.suspendCtnService.getConfig().basic.cancelState);
                    };
                    /**
                     * Get First Name
                     */
                    SuspendCtnConfirmController.prototype.getFirstName = function () {
                        return this.suspendCtnService.getFirstName();
                    };
                    /**
                     * Get Account Email
                     */
                    SuspendCtnConfirmController.prototype.getAccountEmail = function () {
                        return this.suspendCtnService.getAccountEmail();
                    };
                    /**
                     * Get
                     */
                    SuspendCtnConfirmController.prototype.getUpdateProfileState = function () {
                        return this.suspendCtnService.getConfig().basic.updateProfileState;
                    };
                    SuspendCtnConfirmController.prototype.openModalPopup = function (errorHandler) {
                        this.$modal.open({
                            templateUrl: errorHandler.templateUrl,
                            controller: this.suspendCtnService.getConfig().advanced.suspendCtnError.controllerName,
                            controllerAs: 'simCardErrorModal',
                            size: errorHandler.modalSize,
                            backdrop: 'static',
                            backdropClass: 'bkg-modal',
                            resolve: {
                                'ute.common.simcard.change.service.errorHandler': errorHandler
                            }
                        });
                    };
                    SuspendCtnConfirmController.$inject = [
                        '$modal',
                        'ute.common.suspend.ctn.service',
                        '$state'
                    ];
                    return SuspendCtnConfirmController;
                }());
                ctn.SuspendCtnConfirmController = SuspendCtnConfirmController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.confirm.controller', SuspendCtnConfirmController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnDeviceController = (function () {
                    /* @ngInject */
                    function SuspendCtnDeviceController(suspendCtnService) {
                        var _this = this;
                        this.suspendCtnService = suspendCtnService;
                        this.hasDeviceName = function () {
                            return _this.suspendCtnService.hasDeviceName();
                        };
                    }
                    SuspendCtnDeviceController.$inject = ['ute.common.suspend.ctn.service'];
                    return SuspendCtnDeviceController;
                }());
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.device.controller', SuspendCtnDeviceController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnDevice = (function () {
                    /* @ngInject */
                    SuspendCtnDevice.$inject = ["suspendCtnService"];
                    function SuspendCtnDevice(suspendCtnService) {
                        this.suspendCtnService = suspendCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.suspendCtnService.getConfig().advanced.suspendCtnDevice.templateUrl;
                        this.controller = this.suspendCtnService.getConfig().advanced.suspendCtnDevice.controllerName;
                        this.controllerAs = 'suspendCtnDevice';
                    }
                    SuspendCtnDevice.factory = function () {
                        var directive = function (suspendCtnService) { return new SuspendCtnDevice(suspendCtnService); };
                        directive.$inject = ['ute.common.suspend.ctn.service'];
                        return directive;
                    };
                    return SuspendCtnDevice;
                }());
                angular.module('ute.common.suspend.ctn').directive('uteSuspendCtnDevice', SuspendCtnDevice.factory());
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnFaqController = (function () {
                    function SuspendCtnFaqController() {
                    }
                    SuspendCtnFaqController.$inject = [];
                    return SuspendCtnFaqController;
                }());
                ctn.SuspendCtnFaqController = SuspendCtnFaqController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.faq.controller', SuspendCtnFaqController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnFaq = (function () {
                    /* @ngInject */
                    SuspendCtnFaq.$inject = ["suspendCtnService"];
                    function SuspendCtnFaq(suspendCtnService) {
                        this.suspendCtnService = suspendCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.suspendCtnService.getConfig().advanced.suspendCtnFaq.templateUrl;
                        this.controller = this.suspendCtnService.getConfig().advanced.suspendCtnFaq.controllerName;
                        this.controllerAs = 'suspendCtnFaq';
                    }
                    SuspendCtnFaq.factory = function () {
                        var directive = function (suspendCtnService) { return new SuspendCtnFaq(suspendCtnService); };
                        directive.$inject = ['ute.common.suspend.ctn.service'];
                        return directive;
                    };
                    return SuspendCtnFaq;
                }());
                angular.module('ute.common.suspend.ctn').directive('uteSuspendCtnFaq', SuspendCtnFaq.factory());
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnWirelessNumberController = (function () {
                    /* @ngInject */
                    function SuspendCtnWirelessNumberController(suspendCtnService) {
                        var _this = this;
                        this.suspendCtnService = suspendCtnService;
                        this.getPhoneNumber = function () {
                            return _this.suspendCtnService.getPhoneNumber();
                        };
                        this.getFirstName = function () {
                            return _this.suspendCtnService.getFirstName();
                        };
                        this.backToDevicePage = function () {
                            _this.suspendCtnService.backToDevice();
                        };
                    }
                    SuspendCtnWirelessNumberController.$inject = ['ute.common.suspend.ctn.service'];
                    return SuspendCtnWirelessNumberController;
                }());
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.wirelessNumber.controller', SuspendCtnWirelessNumberController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnWirelessNumber = (function () {
                    /* @ngInject */
                    SuspendCtnWirelessNumber.$inject = ["suspendCtnService"];
                    function SuspendCtnWirelessNumber(suspendCtnService) {
                        this.suspendCtnService = suspendCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.suspendCtnService.getConfig().advanced.suspendCtnWirelessNumber.templateUrl;
                        this.controller = this.suspendCtnService.getConfig().advanced.suspendCtnWirelessNumber.controllerName;
                        this.controllerAs = 'suspendCtnWirelessNumber';
                    }
                    SuspendCtnWirelessNumber.factory = function () {
                        var directive = function (suspendCtnService) { return new SuspendCtnWirelessNumber(suspendCtnService); };
                        directive.$inject = ['ute.common.suspend.ctn.service'];
                        return directive;
                    };
                    return SuspendCtnWirelessNumber;
                }());
                angular.module('ute.common.suspend.ctn').directive('uteSuspendCtnWirelessNumber', SuspendCtnWirelessNumber.factory());
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnErrorController = (function () {
                    /* @ngInject */
                    function SuspendCtnErrorController($modalInstance, suspendCtnService) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.suspendCtnService = suspendCtnService;
                        this.backToDevicePage = function () {
                            _this.$modalInstance.dismiss('cancel');
                            _this.suspendCtnService.backToDevice();
                        };
                    }
                    SuspendCtnErrorController.prototype.cancel = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    SuspendCtnErrorController.$inject = ['$modalInstance', 'ute.common.suspend.ctn.service'];
                    return SuspendCtnErrorController;
                }());
                ctn.SuspendCtnErrorController = SuspendCtnErrorController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.error.controller', SuspendCtnErrorController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                    /**
                     * Private
                     */
                    var BackEndErrorCode = (function () {
                        function BackEndErrorCode() {
                        }
                        BackEndErrorCode.UPDATED_OK = 0;
                        BackEndErrorCode.GENERIC_ERROR = 15700;
                        return BackEndErrorCode;
                    }());
                    var SuspendCtnProvider = (function () {
                        /* @ngInject */
                        function SuspendCtnProvider() {
                            var _this = this;
                            this.errorCodesMap = {};
                            this.isSuspendCtnCallInProgress = false;
                            // TODO move it to separate config
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    medium: 'WEB',
                                    partialApiUrl: 'v1/wirelessService/suspend',
                                    suspendCtnRootState: 'suspendCtn',
                                    cancelState: 'wireless',
                                    updateProfileState: 'self-serve',
                                    mainControllerName: 'ute.common.suspend.ctn.main.controller',
                                    mainTemplateUrl: 'module/suspendCtn/suspendCtnMain.view.html'
                                },
                                advanced: {
                                    suspendCtnFaq: {
                                        controllerName: 'ute.common.suspend.ctn.faq.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnDirective/suspendCtn.faq.directive.html'
                                    },
                                    suspendCtnWirelessNumber: {
                                        controllerName: 'ute.common.suspend.ctn.wirelessNumber.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnDirective/suspendCtn.wirelessNumber.directive.html'
                                    },
                                    suspendCtnDevice: {
                                        controllerName: 'ute.common.suspend.ctn.device.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnDirective/suspendCtn.device.directive.html'
                                    },
                                    confirmSuspendDevice: {
                                        subState: 'start',
                                        backToState: 'wireless',
                                        controllerName: 'ute.common.suspend.ctn.confirm.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnConfirm/suspendCtnConfirm.view.html'
                                    },
                                    suspendCtnSuccess: {
                                        subState: 'success',
                                        backToState: 'wireless',
                                        controllerName: 'ute.common.suspend.ctn.success.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnSuccess/suspendCtnSuccess.view.html'
                                    },
                                    suspendCtnError: {
                                        controllerName: 'ute.common.suspend.ctn.error.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnError/suspendCtnError.view.html'
                                    }
                                }
                            };
                            /* @ngInject */
                            this.$get = ["$injector", "$state", "$http", "$stateParams", function ($injector, $state, $http, $stateParams) {
                                _this.encryptionService = $injector.get('ute.common.encryption.service');
                                _this.userService = $injector.get('ute.common.user.service');
                                _this.securityService = $injector.get('ute.common.security.service');
                                _this.$state = $state;
                                _this.$http = $http;
                                _this.$stateParams = $stateParams;
                                _this.runtimeTranslateService = $injector.get('ute.common.runtime.translate.service');
                                return {
                                    getConfig: _this.getConfig,
                                    goToEntryState: _this.goToEntryState,
                                    getEntryState: _this.getEntryState,
                                    getPhoneNumber: _this.getPhoneNumber,
                                    getAccountNumber: _this.getAccountNumber,
                                    getFirstName: _this.getFirstName,
                                    getAccountEmail: _this.getAccountEmail,
                                    getUser: _this.userService.getUser,
                                    goToState: _this.goToState,
                                    getModel: _this.getModel,
                                    suspendCtn: _this.suspendCtn,
                                    isSuspendCtnCallInProgress: _this.isSuspendCtnCallInProgressFn,
                                    hasDeviceName: _this.hasDeviceName,
                                    backToDevice: _this.backToDevice,
                                    restoreState: _this.restoreState
                                };
                            }];
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                if (_.isEmpty(_this.config.basic.medium)) {
                                    console.error('medium:', 'Config Provider should override medium with vaid Medium');
                                    return false;
                                }
                                return true;
                            };
                            /**
                             * @param code
                             * @returns {boolean}
                             */
                            this.addCode = function (code) {
                                _this.errorCodesMap[code.frontendCode] = code;
                            };
                            this.addCodes = function () {
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.UPDATED_OK,
                                    templateUrl: _this.getConfig().advanced.suspendCtnSuccess.templateUrl,
                                    modalIcon: '',
                                    modalSize: '',
                                    backendCode: BackEndErrorCode.UPDATED_OK
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.GENERIC_ERROR,
                                    frontendMessageKey: 'ute.rogers.suspendCtn.system_error_message',
                                    templateUrl: _this.getConfig().advanced.suspendCtnError.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.GENERIC_ERROR
                                });
                            };
                            /**
                             * TODO to make it automaticaly
                             */
                            this.restoreState = function () {
                                // console.log('SuspendCtn->restoreState $stateParams=', this.$stateParams);
                                if (_this.$stateParams.id) {
                                    _this.encryptionService.decrypt(_this.$stateParams.id).then(function (obj) {
                                        // console.log('SuspendCtn->restoreState', obj);
                                        if (obj.accountNumber && obj.phoneNumber) {
                                            _this.model.accountNumber = obj.accountNumber;
                                            _this.model.phoneNumber = obj.phoneNumber;
                                            _this.model.deviceNameEn = obj.deviceNameEn;
                                            _this.model.deviceNameFr = obj.deviceNameFr || obj.deviceNameEn;
                                            _this.model.firstName = obj.firstName;
                                            _this.model.accountEmail = obj.accountEmail;
                                            _this.runtimeTranslateService.addTranslation('en', SuspendCtnProvider.deviceNameTranslateKey, _this.model.deviceNameEn);
                                            _this.runtimeTranslateService.addTranslation('fr', SuspendCtnProvider.deviceNameTranslateKey, _this.model.deviceNameFr);
                                        }
                                        else {
                                            _this.$state.go(_this.config.basic.cancelState);
                                        }
                                    }) /*.catch((error: any): void => {
                                     this.$state.go(this.config.basic.cancelState);
                                     })*/;
                                }
                                else {
                                    // TODO route where ? or maybe restore from localstore - refresh on confirm
                                    _this.$state.go(_this.config.basic.cancelState);
                                }
                            };
                            /**
                             * @returns {ng.IPromise<ICodeEntry>}
                             */
                            this.suspendCtn = function () {
                                var request = {
                                    accountNumber: _this.model.accountNumber,
                                    phoneNumber: _this.model.phoneNumber,
                                    applicationId: _this.config.basic.applicationId,
                                    medium: _this.config.basic.medium
                                };
                                _this.isSuspendCtnCallInProgress = true;
                                return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.partialApiUrl), request)
                                    .then(_this.processSuspendCtn)
                                    .catch(_this.processSuspendCtnError)
                                    .finally(_this.finaliseSuspendCtnCallCall);
                            };
                            /**
                             * @param response
                             * @returns {any}
                             */
                            this.processSuspendCtn = function (response) {
                                var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                //console.log('processSuspendCtn:', 'response:', response, 'backendCode:', backendCode);
                                if (backendCode === BackEndErrorCode.UPDATED_OK) {
                                    return _this.errorCodesMap[service.FrontEndErrorCode.UPDATED_OK];
                                }
                                else {
                                    return _this.findCodeEntry(backendCode);
                                }
                            };
                            /**
                             * @param backendCode
                             * @returns {ICodeEntry|any}
                             */
                            this.findCodeEntry = function (backendCode) {
                                return _.find(_this.errorCodesMap, function (ce) {
                                    return ce.backendCode === backendCode;
                                }) || _this.errorCodesMap[service.FrontEndErrorCode.GENERIC_ERROR];
                            };
                            /**
                             * @param error
                             * @returns {ICodeEntry}
                             */
                            this.processSuspendCtnError = function (error) {
                                var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                return _this.findCodeEntry(backendCode);
                            };
                            this.finaliseSuspendCtnCallCall = function () {
                                _this.isSuspendCtnCallInProgress = false;
                            };
                            this.backToDevice = function () {
                                _this.$state.go(_this.config.basic.cancelState);
                            };
                            this.isSuspendCtnCallInProgressFn = function () {
                                return _this.isSuspendCtnCallInProgress;
                            };
                            /**
                             * @returns {number}
                             */
                            this.getPhoneNumber = function () {
                                return _this.model.phoneNumber;
                            };
                            this.getAccountEmail = function () {
                                return _this.model.accountEmail;
                            };
                            /**
                             * @returns {string}
                             */
                            this.getFirstName = function () {
                                return _this.model.firstName;
                            };
                            /**
                             * @returns {number}
                             */
                            this.getAccountNumber = function () {
                                return _this.model.accountNumber;
                            };
                            this.hasDeviceName = function () {
                                //return (!_.isEmpty(this.model.deviceNameEn) || !_.isEmpty(this.model.deviceNameFr));
                                return _this.runtimeTranslateService.hasTranslation(SuspendCtnProvider.deviceNameTranslateKey);
                            };
                            /**
                             * @returns {any}
                             */
                            this.getConfig = function () {
                                return angular.copy(_this.config);
                            };
                            /**
                             * @returns {string}
                             */
                            this.getEntryState = function () {
                                return _this.config.basic.suspendCtnRootState + '.' + _this.config.advanced.confirmSuspendDevice.subState;
                            };
                            /**
                             * @param input
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToEntryState = function (input) {
                                console.log('goToEntryState', input);
                                _this.model = input;
                                return _this.encryptionService.encrypt(input).then(function (id) {
                                    return _this.$state.go(_this.getEntryState(), { id: id });
                                });
                            };
                            /**
                             * @param state
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToState = function (state) {
                                return _this.encryptionService.encrypt(_this.model).then(function (id) {
                                    return _this.$state.go(_this.config.basic.suspendCtnRootState + '.' + state, {
                                        id: id
                                    });
                                });
                            };
                            /**
                             * Return immutable ISimCardModel object
                             * @returns {ISimCardModel}
                             */
                            this.getModel = function () {
                                return angular.copy(_this.model);
                            };
                            /**
                             * Reset model to initial state
                             */
                            this.resetModel = function () {
                                _this.model = {
                                    phoneNumber: null,
                                    accountNumber: null // may be from local store?
                                };
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$state',
                                '$http',
                                '$stateParams'
                            ];
                            this.resetModel();
                            this.addCodes();
                        }
                        ;
                        SuspendCtnProvider.$inject = [];
                        SuspendCtnProvider.deviceNameTranslateKey = 'ute.common.suspend.ctn.success.header.deviceName';
                        return SuspendCtnProvider;
                    }());
                    angular.module('ute.common.suspend.ctn').provider('ute.common.suspend.ctn.service', SuspendCtnProvider);
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnSucessController = (function () {
                    /* @ngInject */
                    function SuspendCtnSucessController($document, $state, $translate, suspendCtnService) {
                        this.$document = $document;
                        this.$state = $state;
                        this.$translate = $translate;
                        this.suspendCtnService = suspendCtnService;
                        this.phoneNumber = this.suspendCtnService.getPhoneNumber();
                    }
                    SuspendCtnSucessController.$inject = ['$document', '$state', '$translate', 'ute.common.suspend.ctn.service'];
                    return SuspendCtnSucessController;
                }());
                ctn.SuspendCtnSucessController = SuspendCtnSucessController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.success.controller', SuspendCtnSucessController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            var DataService = (function () {
                /* @ngInject */
                function DataService($q, exception, logger) {
                    var _this = this;
                    this.$q = $q;
                    this.exception = exception;
                    this.logger = logger;
                    this.ready = function (promises) {
                        return _this.readyForAny(promises);
                    };
                    this.readyForAny = function (promises) {
                        return _this.getReady().then(function () {
                            return promises ? _this.$q.all(promises) : _this.readyPromise;
                        }).catch(_this.exception.catcher('"ready" function failed'));
                    };
                    this.getReady = function () {
                        if (!_this.readyPromise) {
                            // Apps often pre-fetch session data ("prime the app")
                            // before showing the first view.
                            // This app doesn't need priming but we add a
                            // no-op implementation to show how it would work.
                            _this.logger.info('Primed the app data');
                            _this.readyPromise = _this.$q.when(_this);
                        }
                        return _this.readyPromise;
                    };
                }
                DataService.$inject = ['$q', 'ute.blocks.exceptionService', 'ute.blocks.loggerService'];
                return DataService;
            }());
            angular.module('ute.blocks.router').service('ute.blocks.router.dataservice', DataService);
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            var RouterHelperProvider = (function () {
                /* @ngInject */
                function RouterHelperProvider($stateProvider, $urlRouterProvider) {
                    var _this = this;
                    this.$stateProvider = $stateProvider;
                    this.$urlRouterProvider = $urlRouterProvider;
                    this.config = {
                        docTitle: undefined
                    };
                    this.hasOtherwise = false;
                    this.handlingStateChangeError = false;
                    this.stateCounts = { errors: 0, changes: 0 };
                    this.resolveAlways = [];
                    this.globalTransitionHandlers = { from: [], to: [] };
                    /* @ngInject */
                    this.$get = ["$location", "$rootScope", "$state", "$injector", "$translate", function ($location, $rootScope, $state, $injector, $translate) {
                        _this.$location = $location;
                        _this.$rootScope = $rootScope;
                        _this.$translate = $translate;
                        _this.$state = $state;
                        _this.logger = $injector.get('ute.blocks.loggerService');
                        _this.handleRoutingErrors();
                        _this.handleStateChanges();
                        _this.handleLangChanges();
                        _this.handleStateChangeStart();
                        return {
                            configureStates: _this.configureStates.bind(_this),
                            registerFromStateHandler: _this.registerFromStateHandler.bind(_this),
                            registerToStateHandler: _this.registerToStateHandler.bind(_this),
                            registerGlobalFromStateHandler: _this.registerGlobalFromStateHandler.bind(_this),
                            registerGlobalToStateHandler: _this.registerGlobalToStateHandler.bind(_this),
                            getCountFromStateHandlers: _this.getCountFromStateHandlers.bind(_this),
                            getCountToStateHandlers: _this.getCountToStateHandlers.bind(_this),
                            when: _this.when.bind(_this),
                            getState: function (state) { return _this.$state.get(state); },
                            getCurrentState: function () { return _this.currentState; },
                            getStates: function () { return _this.$state.get(); }
                        };
                    }];
                    this.when = function (whenPath, toPath) {
                        return _this.$urlRouterProvider.when(whenPath, toPath);
                    };
                    this.configure = function (config) {
                        angular.extend(_this.config, config);
                        if (!_this.config.resolveAlways) {
                            // TODO this is not working
                            _this.config.resolveAlways = {
                                /* @ngInject */
                                ready: ['ute.blocks.router.dataservice', function (dataservice) {
                                        var tmp = {};
                                        this.resolveAlways.forEach(function (e) {
                                            tmp = _.merge(tmp, e());
                                        });
                                        return dataservice.ready(tmp);
                                    }]
                            };
                        }
                        return true;
                    };
                    this.addToResolveAlways = function (resolveCallback) {
                        _this.resolveAlways.push(resolveCallback);
                    };
                    //$locationProvider.html5Mode(true);
                    this.configureStates = function (states, otherwisePath) {
                        states.forEach(function (state) {
                            if (!state.abstract) {
                                state.resolve = angular.extend(state.resolve || {}, _this.config.resolveAlways || {});
                                // TODO define 'ready' in constants
                                _.forEach(state.resolve, function (val, key) {
                                    if (key !== 'ready' && angular.isObject(_this.config.resolveAlways) && _.isArray(val)) {
                                        val.splice(val.length - 1, 0, 'ready');
                                    }
                                });
                            }
                            _this.$stateProvider.state(state);
                        });
                        if (otherwisePath && !_this.hasOtherwise) {
                            _this.hasOtherwise = true;
                            _this.$urlRouterProvider.otherwise(otherwisePath);
                        }
                    };
                    this.registerStateHandler = function (fromTo, stateName, si) {
                        var state = _this.$state.get(stateName);
                        if (state) {
                            state.data = (state.data || {});
                            var transitionHandlers = state.data.$transitionHandlers = (state.data.$transitionHandlers || {
                                from: [],
                                to: []
                            });
                            transitionHandlers[fromTo].push(si);
                            // TODO upgrade to lodash 4.x
                            // state.data.$transitionHandlers[fromTo] = _.orderBy/*<IStateHandler>*/(transitionHandlers[fromTo], ['priority'], ['desc']);
                            state.data.$transitionHandlers[fromTo] = _.sortBy(transitionHandlers[fromTo], 'priority').reverse();
                        }
                        else {
                            _this.logger.info('not able to find state "' + stateName + '"');
                        }
                        //this.logger.info('state "' + stateName + '" has ' + transitionHandlers[fromTo].length + ' "' + fromTo + '" transition handlers');
                    };
                    this.registerGlobalStateHandler = function (fromTo, stateHandler) {
                        _this.globalTransitionHandlers[fromTo].push(stateHandler);
                        // this.globalTransitionHandlers[fromTo] = _.chain<IStateHandler>(this.globalTransitionHandlers[fromTo]).sortBy(['priority']).value().reverse();
                        _this.globalTransitionHandlers[fromTo] = _.sortBy(_this.globalTransitionHandlers[fromTo], 'priority').reverse();
                        //this.logger.info('global has ' + this.globalTransitionHandlers[fromTo].length + ' "' + fromTo + '" transition handlers');
                    };
                    this.registerFromStateHandler = function (stateName, stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerStateHandler('from', stateName, stateHandler);
                        }
                    };
                    this.registerToStateHandler = function (stateName, stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerStateHandler('to', stateName, stateHandler);
                        }
                    };
                    this.registerGlobalFromStateHandler = function (stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerGlobalStateHandler('from', stateHandler);
                        }
                    };
                    this.registerGlobalToStateHandler = function (stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerGlobalStateHandler('to', stateHandler);
                        }
                    };
                    this.getCountFromStateHandlers = function (stateName) {
                        var state = _this.$state.get(stateName);
                        return state ? state.data.$transitionHandlers.from.length : 0;
                    };
                    this.getCountToStateHandlers = function (stateName) {
                        var state = _this.$state.get(stateName);
                        return state ? state.data.$transitionHandlers.to.length : 0;
                    };
                    this.handleRoutingErrors = function () {
                        //TODO: must inject $state so we can kick off routing
                        // Route cancellation:
                        // On routing error, go to the dashboard.
                        // Provide an exit clause if it tries to do it twice.
                        _this.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                            if (_this.handlingStateChangeError) {
                                return;
                            }
                            _this.stateCounts.errors++;
                            _this.handlingStateChangeError = true;
                            var destination = (toState &&
                                (toState.name || toState.loadedTemplateUrl)) ||
                                'unknown target';
                            var msg = 'Error routing to ' + destination + '. ' +
                                (_.get(error, 'data') || '') + '. <br/>' + (error.statusText || '') +
                                ': ' + (error.status || '');
                            _this.logger.warning(msg, toState);
                            // TODO from settings
                            //this.$location.path('/');
                        });
                    };
                    this.handleStateChangeStart = function () {
                        _this.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                            // var promise = funcs[0](input);
                            // for (var i = 1; i < funcs.length; i++)
                            //   promise = promise.then(funcs[i]);
                            // funcs.reduce(function(prev, cur) {
                            //   return prev.then(cur);
                            // }, starting_promise);
                            (_this.globalTransitionHandlers.from).every(function (handler) {
                                try {
                                    return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                }
                                catch (e) {
                                    _this.logger.error('Exception catch during call stateTransitionHandler on globalTransitionHandlers.from:', e.message);
                                    return true;
                                }
                            });
                            (_this.globalTransitionHandlers.to).every(function (handler) {
                                try {
                                    return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                }
                                catch (e) {
                                    _this.logger.error('Exception catch during call stateTransitionHandler on globalTransitionHandlers.to:', e.message);
                                    return true;
                                }
                            });
                            if (_.get(fromState, 'data.$transitionHandlers.from')) {
                                (fromState.data.$transitionHandlers.from).every(function (handler) {
                                    try {
                                        return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                    }
                                    catch (e) {
                                        _this.logger.error('Exception catch during call stateTransitionHandler on $transitionHandlers.from:', e.message);
                                        return true;
                                    }
                                });
                            }
                            if (_.get(toState, 'data.$transitionHandlers.to')) {
                                (toState.data.$transitionHandlers.to).every(function (handler) {
                                    try {
                                        return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                    }
                                    catch (e) {
                                        _this.logger.error('Exception catch during call stateTransitionHandler on $transitionHandlers.to:', e.message);
                                        return true;
                                    }
                                });
                            }
                        });
                    };
                    this.handleStateChanges = function () {
                        _this.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                            _this.stateCounts.changes++;
                            _this.handlingStateChangeError = false;
                            _this.currentState = toState;
                            if (toState.data && toState.data.title) {
                                _this.$rootScope.title = _this.config.docTitle + ' ' + (_this.$translate.instant(toState.data.title) || '');
                            } // data bind to <title>
                        });
                    };
                    this.handleLangChanges = function () {
                        _this.$rootScope.$on('$translateChangeSuccess', function () {
                            _this.$rootScope.title = _this.config.docTitle + ' ' + (_this.$translate.instant((_.get(_this.$state, 'current.data.title'))) || ''); // data bind to <title>
                        });
                    };
                    this.$get.$inject = [
                        '$location',
                        '$rootScope',
                        '$state',
                        '$injector',
                        '$translate'
                    ];
                }
                RouterHelperProvider.$inject = ['$stateProvider', '$urlRouterProvider'];
                return RouterHelperProvider;
            }());
            angular.module('ute.blocks.router').provider('ute.blocks.router', RouterHelperProvider);
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var Test = (function (_super) {
                        __extends(Test, _super);
                        function Test() {
                            _super.call(this);
                            this.scope = {
                                keys: '@'
                            };
                            this.controller = Controller;
                        }
                        Test.factory = function () {
                            return function () { return new Test(); };
                        };
                        return Test;
                    }(directives.TestAbstract));
                    var Controller = (function () {
                        /* @ngInject */
                        function Controller(service, $scope) {
                            var _this = this;
                            this.service = service;
                            this.$scope = $scope;
                            this.init = function () {
                                var keysArray = angular.isDefined(_this.$scope.keys) ? _this.$scope.keys.split(',').map(function (s) { return s.trim(); }) : [];
                                return _this.service.isSome(keysArray).then(function (result) { return _this.test = result; });
                            };
                            this.init();
                        }
                        Controller.$inject = ['ute.common.core.brtswitch.service', '$scope'];
                        return Controller;
                    }());
                    /**
                     * <ute-if-any-brt keys='RAM, REGISTRATION'> directive
                     */
                    angular.module('ute.common.core.brtswitch').directive('uteIfAnyBrt', Test.factory());
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var Test = (function (_super) {
                        __extends(Test, _super);
                        function Test() {
                            _super.call(this);
                            this.scope = {
                                key: '@'
                            };
                            this.controller = Controller;
                        }
                        Test.factory = function () {
                            return function () { return new Test(); };
                        };
                        return Test;
                    }(directives.TestAbstract));
                    var Controller = (function () {
                        /* @ngInject */
                        function Controller(service, $scope) {
                            var _this = this;
                            this.$scope = $scope;
                            service.getValue(this.$scope.key).then(function (result) { return _this.test = result; });
                        }
                        Controller.$inject = ['ute.common.core.brtswitch.service', '$scope'];
                        return Controller;
                    }());
                    /**
                     * <ute-if-brt key='BSS_UCC_P1_BRT'> directive
                     */
                    angular.module('ute.common.core.brtswitch').directive('uteIfBrt', Test.factory());
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var TestNot = (function (_super) {
                        __extends(TestNot, _super);
                        function TestNot() {
                            _super.call(this);
                            this.scope = {
                                key: '@'
                            };
                            this.template = '<span data-ng-if="!$ctrl.test"><ng-transclude></ng-transclude></span>';
                            this.controller = Controller;
                        }
                        TestNot.factory = function () {
                            return function () { return new TestNot(); };
                        };
                        return TestNot;
                    }(directives.TestAbstract));
                    var Controller = (function () {
                        /* @ngInject */
                        function Controller(service, $scope) {
                            var _this = this;
                            this.$scope = $scope;
                            this.test = true;
                            service.getValue(this.$scope.key).then(function (result) { return _this.test = result; });
                        }
                        Controller.$inject = ['ute.common.core.brtswitch.service', '$scope'];
                        return Controller;
                    }());
                    /**
                     * <ute-if-not-brt key='BSS_UCC_P1_BRT'> directive
                     */
                    angular.module('ute.common.core.brtswitch').directive('uteIfNotBrt', TestNot.factory());
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            'use strict';
            var Controller = (function () {
                /* @ngInject */
                function Controller($modalInstance, errorCode, resendEmailService, janrainVerificationService) {
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.errorCode = errorCode;
                    this.resendEmailService = resendEmailService;
                    this.janrainVerificationService = janrainVerificationService;
                    // protected getModalIcon: () => string = () => this.errorCode.modalIcon;
                    // protected getErrorTitleMessageKey: () => string = () => this.errorCode.errorTitleMessageKey;
                    // protected getErrorSubTitleMessageKey: () => string = () => this.errorCode.errorSubTitleMessageKey;
                    // protected getFrontendMessageKey: () => string = () => this.errorCode.frontendMessageKey;
                    // protected getFrontendMessageP2Key: () => string = () => this.errorCode.frontendMessageP2Key;
                    // protected getBoldChat: () => IBoldChat = () => this.errorCode.boldChat;
                    this.noSelection = function () {
                        _this.$modalInstance.dismiss('cancel');
                        return _this.janrainVerificationService.goToRescueState();
                    };
                    this.cancel = function () {
                        _this.$modalInstance.dismiss('cancel');
                        //return this.janrainVerificationService.goToRescueState();
                    };
                    this.continue = function () { return _this.$modalInstance.close('yes'); };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.submit = function () {
                        // console.log(Controller.controlerName + '->submit: form.$valid=', this.form.$valid,
                        //     'form.email=', this.form.email,
                        //     'form=', this.form,
                        //     'model=', this.model
                        // );
                        if (_this.form.$valid) {
                            _this.errorMessageKey = null;
                            return _this.resendEmailService.resendEmail(_this.model)
                                .then(_this.processOk)
                                .catch(_this.processError);
                        }
                        else {
                            return null;
                        }
                    };
                    this.processOk = function (codeEntry) {
                        // console.log(Controller.controlerName + '->processOk: codeEntry=', codeEntry);
                        // return this.userRegistrationService.goToConfirmation();
                        _this.$modalInstance.close();
                        _this.janrainVerificationService.goToRescueState();
                        return null;
                    };
                    this.processError = function (codeEntry) {
                        // console.log(Controller.controlerName + '->processError: codeEntry=', codeEntry);
                        _this.errorMessageKey = codeEntry.frontendMessageKey;
                        return null;
                    };
                    this.model = {
                        email: this.resendEmailService.getEmail(),
                        locale: this.janrainVerificationService.getLocale(),
                        isForgotPassword: errorCode.isForgotPassword
                    };
                }
                Controller.controlerName = 'ute.janrain.verification.resend.email.ask.controller';
                Controller.$inject = ['$modalInstance',
                    'ute.janrain.verification.errorHandler',
                    'ute.janrain.verification.resend.email.service',
                    'ute.janrain.verification.service'];
                return Controller;
            }());
            angular.module('ute.janrain.verification').controller(Controller.controlerName, Controller);
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var resend;
            (function (resend) {
                var email;
                (function (email) {
                    var confirmation;
                    (function (confirmation) {
                        'use strict';
                        var Controller = (function () {
                            /* @ngInject */
                            function Controller($document, resendEmailService, janrainVerificationService /*,
                                 dtmService: ute.dtm.service.IDtmService*/) {
                                this.resendEmailService = resendEmailService;
                                this.janrainVerificationService = janrainVerificationService;
                                this.getEmail = this.resendEmailService.getEmail;
                                $document.scrollTop(0);
                                // dtmService.complete(userRegistrationService.getConfig().basic.dtmName);
                            }
                            Controller.$inject = ['$document',
                                'ute.janrain.verification.resend.email.service' /*,
                                 'ute.dtm.service'*/
                            ];
                            Controller.controlerName = 'ute.janrain.verification.resend.email.confirmation.controller';
                            return Controller;
                        }());
                        angular.module('ute.rogers.user.registration').controller(Controller.controlerName, Controller);
                    })(confirmation = email.confirmation || (email.confirmation = {}));
                })(email = resend.email || (resend.email = {}));
            })(resend = verification.resend || (verification.resend = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var app;
(function (app) {
    var boot;
    (function (boot) {
        'use strict';
        (function () {
            /**
             * example of custom implementation of environment type detector
             */
            //ute.blocks.environment.EnvironmentStatic.getEnvType = () => {
            //  if (location.hostname.indexOf('www.rogers.com') === 0) {
            //    return ute.blocks.environment.EnvironmentType.PROD;
            //  } else if (location.hostname.indexOf('www.dev') === 0) {
            //    return ute.blocks.environment.EnvironmentType.DEV;
            //  } else if (location.hostname.indexOf('www.qa') === 0) {
            //    return ute.blocks.environment.EnvironmentType.QA;
            //  } else {
            //    return ute.blocks.environment.EnvironmentType.LOCAL;
            //  }
            //};
            /**
             * or example of custom implementation of environment path detector
             */
            //ute.blocks.environment.EnvironmentStatic.getEnvConfigPath = () => {
            //  return 'environments/local.js';
            //};
            /**
             * bootstrap angular app after get environment config
             */
            ute.blocks.environment.EnvironmentStatic.getEnvConfig(function () {
                angular.element(document).ready(function () {
                    angular.bootstrap(document, ['totesApp'], {
                        // strictDi: true
                        strictDi: false
                    });
                });
            });
        })();
    })(boot = app.boot || (app.boot = {}));
})(app || (app = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                // TODO provider
                var BrtSwitchService = (function () {
                    /* @ngInject */
                    function BrtSwitchService($http, $timeout, exceptionHandler) {
                        var _this = this;
                        this.$http = $http;
                        this.$timeout = $timeout;
                        this.exceptionHandler = exceptionHandler;
                        /**
                         * @param key
                         * @returns {IPromise<boolean>}
                         */
                        this.getValue = function (key) {
                            return _this.getBrtSwitches().then(function (val) {
                                return _.get(_.find(val, { 'id': _.isNumber(key) ? brtswitch.BrtSwitches[key] : key }), 'switchIsOn');
                            });
                        };
                        /**
                         * @param keys
                         * @returns {IPromise<boolean>}
                         */
                        this.isSome = function (keys) {
                            return _this.getBrtSwitches().then(function (vals) {
                                return _.isEmpty(keys) ? false : _.intersection(_.chain(vals)
                                    .filter({ switchIsOn: true })
                                    .map(function (e) { return e.id; })
                                    .value(), _this.getKeys(keys)).length > 0;
                            });
                        };
                        /**
                         * @param keys
                         */
                        this.getKeys = function (keys) {
                            return _.isEmpty(keys) ? [] : _.isNumber(keys[0]) ? keys.map(function (key) { return brtswitch.BrtSwitches[key]; }) : keys;
                        };
                        /**
                         * @returns {IPromise<IBrtSwitches>}
                         * @private
                         */
                        this._getBrtSwitches = function () {
                            return _this.$http.post('/web/smb/api/v1/brtSwitches', {})
                                .then(_this.processBrtSwitchesResponse)
                                .catch(_.curry(_this.fail)('processBrtSwitchesResponse failed.'));
                        };
                        /**
                         * @param response
                         * @returns {IBrtSwitches}
                         */
                        this.processBrtSwitchesResponse = function (response) {
                            // console.log(BrtSwitchService.serviceName + '->processBrtSwitchesResponse', response.data);
                            return _.get(response, 'data', []);
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {IBrtSwitches}
                         */
                        this.fail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            _this.exceptionHandler.catcher(msg)(reason, 'ute.common.core.brtswitch fail');
                            _this.$timeout(_this.cleanCache);
                            return [];
                        };
                        this.cleanCache = function () {
                            _this.getBrtSwitches.cache.clear();
                        };
                        (_.memoize).Cache = window.Map; // required https://www.npmjs.com/package/es6-shim
                        this.getBrtSwitches = _.memoize(this._getBrtSwitches);
                    }
                    BrtSwitchService.$inject = [
                        '$http',
                        '$timeout',
                        'ute.blocks.exceptionService'
                    ];
                    BrtSwitchService.serviceName = 'ute.common.core.brtswitch.service';
                    return BrtSwitchService;
                }());
                angular.module('ute.common.core.brtswitch').service(BrtSwitchService.serviceName, BrtSwitchService);
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var janrainverification;
        (function (janrainverification) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureJanrainVerification);
                configureJanrainVerification.$inject = ['ute.janrain.verification.serviceProvider'];
                /* @ngInject */
                function configureJanrainVerification(JanrainVerificationProvider) {
                    JanrainVerificationProvider.configure({
                        basic: {
                            applicationId: 'ute-application-id',
                            codeVerificationApiUrl: '/web/smb/api/business/v2/createProfileValidate',
                            resendEmailApiUrl: '/web/smb/api/business/v1/profileReActivate',
                            logPrefix: 'JanrainVerification',
                            logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                            rescueState: 'sso/emailResendConfirmation'
                        }
                    });
                }
            })(integration = janrainverification.integration || (janrainverification.integration = {}));
        })(janrainverification = rogers.janrainverification || (rogers.janrainverification = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var reactivateCtn;
        (function (reactivateCtn) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureReactivateCtn);
                configureReactivateCtn.$inject = ['ute.common.reactivate.ctn.serviceProvider'];
                /* @ngInject */
                function configureReactivateCtn(reactivateServiceProvider) {
                    reactivateServiceProvider.configure({
                        basic: {
                            applicationId: 'SMB',
                            medium: 'WEB'
                        },
                        advanced: {
                            // TODO review after accountoverview refactoring
                            resolve: {
                                /* @ngInject */
                                permissionData: ['permissionResolver', function (permissionResolver) {
                                        return permissionResolver.getPermission('reactivateCtn'); // This is a state name, not a path
                                    }]
                            }
                        }
                    });
                }
            })(integration = reactivateCtn.integration || (reactivateCtn.integration = {}));
        })(reactivateCtn = rogers.reactivateCtn || (rogers.reactivateCtn = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var resetVoicemailPassword;
        (function (resetVoicemailPassword) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureResetVoicemailPassword);
                configureResetVoicemailPassword.$inject = ['ute.common.voicemail.resetPassword.serviceProvider'];
                /* @ngInject */
                function configureResetVoicemailPassword(resetVoicemailPasswordServiceProvider) {
                    resetVoicemailPasswordServiceProvider.configure({
                        basic: {
                            applicationId: 'SMB',
                            medium: 'WEB'
                        }
                    });
                }
            })(integration = resetVoicemailPassword.integration || (resetVoicemailPassword.integration = {}));
        })(resetVoicemailPassword = rogers.resetVoicemailPassword || (rogers.resetVoicemailPassword = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureSetPassword);
                configureSetPassword.$inject = ['ute.rogers.setpassword.serviceProvider'];
                /* @ngInject */
                function configureSetPassword(setPasswordProvider) {
                    setPasswordProvider.configure({
                        basic: {},
                        advanced: {
                            setPassword: {
                                apiUrl: '/web/smb/api/business/v2/password',
                                codeVerificationApiUrl: '/web/smb/api/business/v2/createProfileValidate',
                                onSuccessState: 'accountOverview',
                                needAutoRegCheck: false
                            },
                            resetPassword: {
                                apiUrl: '/web/smb/api/business/v1/profile/resetPassword',
                                stateName: 'sso/resetPassword',
                                controllerName: 'ute.rogers.setpassword.controller',
                                templateUrl: 'module/setPassword/setPassword.html',
                                codeVerificationApiUrl: '/web/smb/api/business/v1/profile/forgotPasswordValidation',
                                needAutoRegCheck: false
                            },
                            forgotPassword: {
                                apiUrl: '/web/smb/api/business/v1/profile/forgotPassword',
                                stateName: 'sso/forgotPassword',
                                cancelState: 'signin',
                                controllerName: 'ute.rogers.forgotpassword.controller',
                                templateUrl: 'module/forgotPassword/forgotPassword.html'
                            },
                        }
                    });
                }
            })(integration = setpassword.integration || (setpassword.integration = {}));
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureSimCard);
                    configureSimCard.$inject = ['ute.common.simcard.change.serviceProvider'];
                    /* @ngInject */
                    function configureSimCard(simCardServiceProvider) {
                        simCardServiceProvider.configure({
                            basic: {
                                applicationId: 'SMB',
                                medium: 'WEB',
                                mainTemplateUrl: 'scripts/modules/simCardChangeIntegration/simCardMain.view.html'
                            },
                            advanced: {
                                // TODO review after accountoverview refactoring
                                resolve: {
                                    /* @ngInject */
                                    permissionData: ['permissionResolver', function (permissionResolver) {
                                            return permissionResolver.getPermission('simCard'); // This is a state name, not a path
                                        }]
                                },
                                simCardChangeDirective: {
                                    templateUrl: 'scripts/modules/simCardChangeIntegration/simCardChangeNumberForm.partial.html' // custom
                                },
                                secondaryColumnPartialPath: 'scripts/modules/simCardChangeIntegration/simCardHowToFindNumber.partial.html',
                            }
                        });
                    }
                })(integration = change.integration || (change.integration = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = rogers.simcard || (rogers.simcard = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

/**
 * Created by james.magpantay on 5/26/2016.
 */
var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureSuspendCtn);
                    configureSuspendCtn.$inject = ['ute.common.suspend.ctn.serviceProvider'];
                    /* @ngInject */
                    function configureSuspendCtn(suspendctnProvider) {
                        suspendctnProvider.configure({
                            basic: {
                                applicationId: 'SMB',
                                medium: 'WEB'
                            },
                            advanced: {
                                // TODO review after accountoverview refactoring
                                resolve: {
                                    /* @ngInject */
                                    permissionData: ['permissionResolver', function (permissionResolver) {
                                            return permissionResolver.getPermission('suspendCtn'); // This is a state name, not a path
                                        }]
                                },
                                confirmSuspendDevice: {
                                    templateUrl: 'scripts/modules/suspendCtnIntegration/suspendCtnConfirm.view.html'
                                }
                            }
                        });
                    }
                })(integration = ctn.integration || (ctn.integration = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = rogers.suspend || (rogers.suspend = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var userregistration;
        (function (userregistration) {
            var start;
            (function (start) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureUserRegistration);
                    configureUserRegistration.$inject = ['ute.rogers.user.registration.serviceProvider'];
                    /* @ngInject */
                    function configureUserRegistration(UserRegistrationProvider) {
                        UserRegistrationProvider.configure({
                            basic: {
                                apiUrl: '/web/smb/api/business/v2/createProfile'
                            },
                            advanced: {
                                registration: {
                                    templateUrl: 'scripts/modules/userRegistrationIntegration/userRegistration.html'
                                }
                            }
                        });
                    }
                })(integration = start.integration || (start.integration = {}));
            })(start = userregistration.start || (userregistration.start = {}));
        })(userregistration = rogers.userregistration || (rogers.userregistration = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));



/**
 * Created by james.magpantay on 5/26/2016.
 */
var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var service;
            (function (service) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureUserService);
                    configureUserService.$inject = ['ute.common.user.serviceProvider'];
                    /* @ngInject */
                    function configureUserService(userServiceProvider) {
                        userServiceProvider.configure({
                            roleToUrlBase: {
                                consumer: {
                                    baseUrl: '/web/RogersServices.portal/smb/api/'
                                }
                            }
                        });
                    }
                })(integration = service.integration || (service.integration = {}));
            })(service = user.service || (user.service = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

//# sourceMappingURL=data:application/json;base64,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

angular.module("totesApp").run(["$templateCache", function($templateCache) {$templateCache.put("404.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><title>Page Not Found :(</title><style>\n      ::-moz-selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      ::selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      html {\n        padding: 30px 10px;\n        font-size: 20px;\n        line-height: 1.4;\n        color: #737373;\n        background: #f0f0f0;\n        -webkit-text-size-adjust: 100%;\n        -ms-text-size-adjust: 100%;\n      }\n\n      html,\n      input {\n        font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n      }\n\n      body {\n        max-width: 500px;\n        _width: 500px;\n        padding: 30px 20px 50px;\n        border: 1px solid #b3b3b3;\n        border-radius: 4px;\n        margin: 0 auto;\n        box-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;\n        background: #fcfcfc;\n      }\n\n      h1 {\n        margin: 0 10px;\n        font-size: 50px;\n        text-align: center;\n      }\n\n      h1 span {\n        color: #bbb;\n      }\n\n      h3 {\n        margin: 1.5em 0 0.5em;\n      }\n\n      p {\n        margin: 1em 0;\n      }\n\n      ul {\n        padding: 0 0 0 40px;\n        margin: 1em 0;\n      }\n\n      .container {\n        max-width: 380px;\n        _width: 380px;\n        margin: 0 auto;\n      }\n\n      /* google search */\n\n      #goog-fixurl ul {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n      }\n\n      #goog-fixurl form {\n        margin: 0;\n      }\n\n      #goog-wm-qt,\n      #goog-wm-sb {\n        border: 1px solid #bbb;\n        font-size: 16px;\n        line-height: normal;\n        vertical-align: top;\n        color: #444;\n        border-radius: 2px;\n      }\n\n      #goog-wm-qt {\n        width: 220px;\n        height: 20px;\n        padding: 5px;\n        margin: 5px 10px 0 0;\n        box-shadow: inset 0 1px 1px #ccc;\n      }\n\n      #goog-wm-sb {\n        display: inline-block;\n        height: 32px;\n        padding: 0 10px;\n        margin: 5px 0 0;\n        white-space: nowrap;\n        cursor: pointer;\n        background-color: #f5f5f5;\n        background-image: -webkit-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -moz-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -ms-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -o-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        *overflow: visible;\n        *display: inline;\n        *zoom: 1;\n      }\n\n      #goog-wm-sb:hover,\n      #goog-wm-sb:focus {\n        border-color: #aaa;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n        background-color: #f8f8f8;\n      }\n\n      #goog-wm-qt:hover,\n      #goog-wm-qt:focus {\n        border-color: #105cb6;\n        outline: 0;\n        color: #222;\n      }\n\n      input::-moz-focus-inner {\n        padding: 0;\n        border: 0;\n      }\n    </style></head><body><div class=\"container\"><h1>Not found <span>:(</span></h1><p>Sorry, but the page you were trying to view does not exist.</p><p>It looks like this was the result of either:</p><ul><li>a mistyped address</li><li>an out-of-date link</li></ul><script>\n        var GOOG_FIXURL_LANG = (navigator.language || \'\').slice(0,2),GOOG_FIXURL_SITE = location.host;\n      </script><script src=\"//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js\"></script></div></body></html>");
$templateCache.put("views/404.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-12\"><h2>404</h2><p>Page not found.</p></div></div></div>");
$templateCache.put("views/confirm-order.html","<div class=\"review-order confirm-order hidden-sm hidden-xs\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"checkout_confirm_order_order_confirmation\">checkout_confirm_order_order_confirmation</span></h1></div></div></div></div><div class=\"container\"><div id=\"top-image-row\" class=\"row\"><div id=\"top-image\"><div class=\"col-lg-7 col-md-7 thank-you\"><div id=\"phone-image\" class=\"col-lg-3 col-md-3\"><img src=\"images/lg-g3-BLK.png\"></div><div class=\"col-lg-7 col-md-7\" style1=\"background-color: green;\"><div id=\"thank-you-line-1\" class=\"huge-thank-you visible-lg\" res=\"checkout_confirm_thank_you\">res</div><div id=\"thank-you-line-1\" class=\"huge-thank-you huge-thank-you-md visible-md\" res=\"checkout_confirm_thank_you\">res</div><div id=\"thank-you-line-2\" class=\"huge-thank-you\"><span class=\"huge-thank-you\" res=\"checkout_confirm_for_your_order\">res</span>!</div><div id=\"processing\"></div><span class=\"visible-md\"></span></div></div><div id=\"confirmation-left-column\" class=\"col-lg-5 col-md-5 confirmation-left-column\"><div class=\"font-sz-22 pts\"><strong><span res=\"checkout_confirm_congrats\">res</span></strong> <span res=\"checkout_confirm_on_your_new_plan\">res</span>!</div><div class=\"mtm\" res=\"checkout_confirm_email_confirm\">res</div></div></div></div><div class=\"row\" ng-show=\"isSharePlus\"><div class=\"col-sm-12\"><span res=\"ppc-confirm-share-plus_message\"></span><div><a href=\"https://www.rogers.com/web/totes/plans/#/manage-your-experience\"><span res=\"ppc-confirm-share-plus_link_text\"></span></a></div></div></div><div class=\"row\"><div class=\"pull-left\"><h1 class=\"big-header rogers-red-font\" res=\"checkout_confirm_order_order_summary\">res</h1></div></div><div class=\"red-line clear-float mbn\"></div><div class=\"row padded-container pln\"><div class=\"your-order-column sub-heading-font\" res=\"checkout_confirm_order_contact_details\">res</div><div class=\"your-order-column confirm-line-small copy-font\">{{ confirmOrder.cart.firstName +\' \' +confirmOrder.cart.lastName }}</div><div class=\"your-order-column confirm-line-small copy-font\">{{ confirmOrder.cart.email }}</div><div class=\"your-order-column confirm-line-small copy-font\">{{ confirmOrder.cart.ctn }}</div><div class=\"your-order-column confirm-line-small copy-font mtl\">{{ confirmOrder.cart.billingStreetAddress }}</div><div class=\"your-order-column confirm-line-small copy-font\">{{ confirmOrder.cart.billingCity }}</div><div class=\"your-order-column confirm-line-small copy-font mbl\">{{ confirmOrder.cart.billingPostalCode }}</div></div><div class=\"row\"><div class=\"pull-left col-sm-10\"><h1 class=\"big-header rogers-red-font\" res=\"checkout_confirm_order_your_order\">res</h1></div><div id=\"print-button-container-X\" class=\"clickable pull-right col-sm-2 _np\"><a href=\"{{ confirmOrder.cart.email }}\"><img src=\"images/email-icon.png\" class=\"mrm\"></a> <a href=\"javascript:window.print()\"><img src=\"images/print-icon.png\"></a></div><div class=\"red-line clear-float\"></div></div><div class=\"row confirm-line-large\"><div class=\"col-lg-8 col-md-8\"><div class=\"confirm-line-large clickable\"><div class=\"rogers-red-font heading-font\"><span res=\"ppc_shop_cart_plan_details\">res</span></div><div class=\"your-order-column sub-heading-font float-left\"><span show-when=\"en\">{{ confirmOrder.cart.newPlan.cmsData_En.planTitle }}</span> <span show-when=\"fr\">{{ confirmOrder.cart.newPlan.cmsData_Fr.planTitle }}</span></div><div class=\"clear legal-fine-print\"><span class=\"font-sz-15 bold\" res=\"checkout_confirm_partial_prepaid\">res</span><br><br><span class=\"font-sz-15 bold\" res=\"checkout_confirm_term_service\">res</span></div><div class=\"clear-float order-items order-items-mln\"><ul><li>{{ confirmOrder.cart.newPlan.planInfo.includedDataMax | mbOrGbValue }} {{ confirmOrder.cart.newPlan.planInfo.includedDataMax | mbOrGbValueStr }} <span ng-show=\"confirmOrder.cart.newPlan.planInfo.includedDataMax !== \'Not Applicable\'\"><span res=\"ppc_overage_rate\">res</span> <span show-when=\"en\">{{ confirmOrder.cart.newPlan.planInfo.overageRate }}</span> <span show-when=\"fr\">{{ confirmOrder.overageFr(confirmOrder.cart.newPlan.planInfo.overageRate) }}</span></span></li><li><span show-when=\"en\" data-ng-bind-html=\"confirmOrder.cart.newPlan.cmsData_En.includedMessages[0]\"></span> <span show-when=\"fr\" data-ng-bind-html=\"confirmOrder.cart.newPlan.cmsData_Fr.includedMessages[0]\"></span></li><li><span show-when=\"en\" data-ng-bind-html=\"confirmOrder.cart.newPlan.cmsData_En.includedMinutes[0]\"></span> <span show-when=\"fr\" data-ng-bind-html=\"confirmOrder.cart.newPlan.cmsData_Fr.includedMinutes[0]\"></span></li></ul></div><div class=\"clear-float order-items order-items-mln\"><ul show-when=\"en\"><li ng-repeat=\"featureItem in confirmOrder.cart.newPlan.cmsData_En.planFeatures\" data-ng-bind-html=\"featureItem\"></li></ul><ul show-when=\"fr\"><li ng-repeat=\"featureItem in confirmOrder.cart.newPlan.cmsData_Fr.planFeatures\" data-ng-bind-html=\"featureItem\"></li></ul></div></div></div><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12\"></div><div class=\"confirm-line-large col-lg-2 col-md-2 col-sm-12 col-xs-12\"><div class=\"rogers-red-font sub-heading-font\" res=\"checkout_confirm_order_monthly_fees\">res</div><div class=\"your-order-column sub-heading-font\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ confirmOrder.cart.newPlan.planInfo.planPrice | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div></div></div><row-hr></row-hr><div id=\"add-ons-row\" class=\"row\"><div><h1 class=\"big-header rogers-red-font\" res=\"_add_ons\">res</h1></div></div><add-ons-list add-ons=\"confirmOrder.cart.addOns\" edit-btn=\"false\"></add-ons-list><row-hr ng-show=\"showIncludes\"></row-hr><div id=\"extras-heading\" class=\"row\" ng-show=\"isShareable\"><div class=\"pull-left\"><h1 class=\"big-header rogers-red-font mtn\" res=\"ppc_extras\">res</h1></div></div><div class=\"row\" ng-show=\"isShareable\"><div><img show-when=\"en\" ng-src=\"images/RoamON-EN-HD.png\" width=\"135\"> <img show-when=\"fr\" ng-src=\"images/RoamON-FR-HD.png\" width=\"185\"> <img show-when=\"en\" src=\"images/RGCL-logo-EN_lg.png\" class=\"mll\"> <img show-when=\"fr\" src=\"images/RGCL-logo-FR_lg.png\" class=\"mll\"></div><div ng-show=\"isSharePlus\" style=\"margin-top:30px;\" class=\"share-plus-logos\"><div res=\"ppc_one_following\" style=\"margin-bottom: 12px;\"></div><img src=\"images/value-added-offers/mb-spotify-logo.png\" width=\"100\"> <img src=\"images/value-added-offers/mb-shomi-logo.png\" width=\"90\"> <img src=\"images/value-added-offers/next_issue_2line.png\" width=\"110\"></div></div><div id=\"order-summary-total-heading\" class=\"row\"><div class=\"pull-left\"><h1 class=\"big-header rogers-red-font\" res=\"ppc_new_monthly_fees\">res</h1></div><div class=\"red-line clear-float\"></div></div><div class=\"row margin-bottom-md\"><div class=\"col-lg-4 col-lg-offset-6 col-md-4 col-md-offset-6\"><div class=\"your-order-column sub-heading-font confirm-line\" res=\"checkout_confirm_order_monthly_fees\">res</div><div class=\"your-order-column sub-heading-font confirm-line\" ng-repeat=\"(key, value) in confirmOrder.cart.taxes.taxes\">{{key}}</div></div><div class=\"col-lg-2 col-md-2 your-order-column-container-pad\"><div class=\"your-order-column sub-heading-font confirm-line txtR\"><span show-when=\"en\">$</span>{{confirmOrder.cart.totalCost | decimalCommaValueFltr}}<span show-when=\"fr\">$</span></div><div class=\"your-order-column sub-heading-font confirm-line txtR\" ng-repeat=\"(key, value) in confirmOrder.cart.taxes.taxes\"><span show-when=\"en\">$</span> {{value | number: 2 | decimalCommaValueFltr}} <span show-when=\"fr\">$</span></div></div></div><div id=\"grand-total-container\" class=\"row margin-bottom-md\"><div class=\"col-lg-5 col-md-5\"></div><div class=\"col-lg-7 col-md-7\"><div id=\"confirm-grand-total-box\" ng-class=\"{\'confirm-grand-total-box-fr\': lang == \'fr\'}\"><div><div class=\"pull-left\" res=\"checkout_confirm_new_monthly_total_fees\">res</div><div class=\"pull-right rogers-red-font\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ confirmOrder.cart.grandTotal | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div></div><div class=\"clear\"></div><div class=\"pull-left legal-fine-print\"><span res=\"ppc_taxes_disclaimer\">res</span></div></div></div></div><div id=\"cancel-checkout\" class=\"row\"><div class=\"col-lg-12 col-md-12 prl\"><div class=\"your-order-column pull-right\"><button class=\"cta-round large\" ng-click=\"$state.go(\'accountOverview\');\"><span class=\"white text-uppercase\" res=\"acc_overview_my_acc_overview\">res</span></button></div></div></div></div></div><div class=\"container-full confirm-order hidden-lg hidden-md\"><div class=\"red-header\"><div class=\"pull-left red-header-bubble\"></div><div id=\"page-title-container\" class=\"pull-left\"><div id=\"page-title\" res=\"checkout_confirm_order_order_confirmation\">res</div></div></div><div style=\"display: none;\" id=\"grey-box\"><div id=\"yellow-orange-bubble\"></div><div id=\"copy-container\"><div id=\"thank-you\">Thank you for your order!</div><div id=\"processing-line\">We are processing your request.</div></div><div id=\"grey-copy-container\"><div>Your order # is: <strong>203940239</strong>.</div><div>You will also receieve an email confirmation shortly.</div><div><div class=\"pull-left\"><strong><span res=\"checkout_confirm_order_continue_shopping\">res</span></strong></div><div id=\"triangle\" class=\"details-triangle pull-left\"></div></div></div></div><confirm-review-order-shared></confirm-review-order-shared></div>");
$templateCache.put("views/demo.html","<form action=\"https://www.dev21.rogers.com/web/myrogers/prepaidPricePlanChange\" method=\"post\" target=\"_blank\">BAN: <input type=\"text\" value=\"716938071\" name=\"ban\"><br>CTN: <input type=\"text\" value=\"4162680261\" name=\"ctn\"><br>PIN: <input type=\"text\" value=\"1234\" name=\"passCode\"><br>PIN: <input type=\"text\" value=\"PPC\" name=\"flowId\"><br><input type=\"submit\" content=\"Plan Change\"></form>");
$templateCache.put("views/editable-content-template.html","<div class=\"editable-content row {{skin}}\"><div class=\"heading-container\"><h1 ng-show=\"!generalError\">{{heading}}</h1><img ng-show=\"loading\" class=\"widget-loader\" src=\"images/widget-loader.gif\"> <span ng-if=\"!currentPanelOpen && !loading && !generalError\"><span class=\"editButton\" ng-class=\"{\'edit-button-enabled\': !isEditOpen()}\" ng-click=\"!isEditOpen() && edit()\"></span> <span class=\"edit-label\" ng-class=\"{\'edit-label-enabled\': !isEditOpen()}\" res=\"_editlabel\" ng-click=\"!isEditOpen() && edit()\">Edit</span></span></div><div class=\"row info-banner error mts mbm\" style=\"margin-left: 0px;\" data-ng-show=\"generalError\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 general-error\" style=\"float:left\"><span res=\"general_error\"></span></div></div><div ng-include=\"contentUrl\" class=\"template-container\" ng-class=\"{isEditOpen: isEditOpen()}\"></div></div>");
$templateCache.put("views/greeting.html","<h2>hello!!!!!!!!!</h2>");
$templateCache.put("views/home.html","<div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">^^^^ use the menu</div></div></div>");
$templateCache.put("views/invalidPath.html","<h1>invalid path</h1>");
$templateCache.put("views/languageSelector.html","<div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><select class=\"form-control\" data-ng-model=\"selectedLanguage\" data-ng-change=\"changeLanguage()\" ng-options=\"key as value for (key, value) in languages\"></select></div></div>");
$templateCache.put("views/ocp-popup.html","<div class=\"modal-container\"><div class=\"modal-header\"><h3><span class=\"message-banner-icon icon-alert\">&nbsp;</span><b res=\"ocp_popup-title\"></b> <b>&nbsp;{{minutes}}:{{displaySeconds}} !</b></h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"modal-body-message\"><p res=\"ocp_warning\"></p><b res=\"ocp_signin\"></b></div></div></div><div class=\"row\"><div class=\"col-xs-12 copy\" style=\"margin-top:15px;\"><div class=\"col-xs-5 col-sm-12 col-md-6 col-lg-3\"><button type=\"button\" class=\"button-default signout-button\" ng-click=\"SignOut()\"><span res=\"ocp_signout\"></span></button></div><div class=\"col-xs-7 col-sm-12 col-md-6 col-lg-4\"><button type=\"button\" class=\"button-default pull-right\" ng-click=\"SignedIn()\"><span res=\"ocp_continue\"></span></button></div></div></div></div></div>");
$templateCache.put("views/oneView.html","<section class=\"page-account-overview\"><div><div class=\"container\"><div><myr-notification-banner data-banner-id=\"linkedMessage\" type=\"success\"></myr-notification-banner></div><div><myr-notification-banner data-banner-id=\"successMessage\" type=\"success\"></myr-notification-banner></div></div><div class=\"top-bar-ctn\"><div class=\"container\"><div class=\"row pts top-bar\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><myr-account-list loading-brite-bill=\"ao.bb.loadingBriteBill\"></myr-account-list><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 row info-banner one-view-info-banner\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'error\' : \'warning-border\'\" data-ng-show=\"ao.als.selectedAccount.accountStatusError && !ao.loadingDataIndicator\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><span class=\"message-banner-icon error-sign-big\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'icon-error\' : \'icon-alert\'\"></span></div><div ng-show=\"!ao.als.selectedAccount.accountCancelled\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span class=\"v-base-line\" ng-bind-html=\"ao.als.selectedAccount.accountStatusError\" style=\"font-weight:normal\"></span></div><div ng-show=\"ao.als.selectedAccount.accountCancelled\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span class=\"v-base-line mbs\" res=\"acc_overview_account_limited\" style=\"font-weight:normal\"></span><br><span class=\"mtl\"><a ng-show=\"isbritebillAvailable\" class=\"pointer\" ng-click=\"ao.postToRogersCancelled()\">- <span res=\"acc_overview_view_bill\"></span></a><br><a ng-click=\"ao.viewHistory()\" class=\"pointer\">- <span res=\"acc_overview_view_bill_history\"></span></a><br><a ng-hide=\"isDealer || isCare\" ng-click=\"ao.runRogersProfile()\" class=\"pointer\">- <span res=\"acc_overview_manage_profile\"></span></a></span></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"acc_overview_my_acc_overview\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\"><div class=\"row\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div><div ng-if=\"!ao.mss.selectedAccountDetail.isPrepaid\"><div class=\"row ptm\"><div data-ng-hide=\"ao.btnSettings.accountBalance === ao.btnStatus.hidden\" class=\"col-xs-12 col-sm-12 col-md-5 col-lg-4\" permission=\"VIEW_ACCOUNT_BALANCE\"><myr-account-balance view-html=\"accountBalance.html\" loading-brite-bill=\"ao.bb.loadingBriteBill\"></myr-account-balance></div><div data-ng-hide=\"ao.btnSettings.earnedPoints === ao.btnStatus.hidden\" class=\"col-xs-12 col-sm-12 col-md-5 col-lg-4\"><myr-rewards></myr-rewards></div></div><div class=\"row my-services-list-ctn\"><div data-ng-hide=\"ao.btnSettings.allSubscriptions === ao.btnStatus.hidden\"><myr-my-services></myr-my-services></div></div></div><div ng-if=\"(ao.mss.selectedAccountDetail.isPrepaid || isPrepaid)\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div ng-show=\"!loadingDataIndicator && !isDetailsNotFound\"><myr-account-balance permission=\"VIEW_ACCOUNT_BALANCE\" view-html=\"accountBalance.html\" loading-brite-bill=\"ao.bb.loadingBriteBill\"></myr-account-balance></div></div><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-1\"></div><div data-ng-hide=\"loadingDataIndicator || ao.mss.isDetailsNotFound\" nclass=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><h1 class=\"primary-color mbl\"></h1><div><myr-my-services mode=\"\'mobile\'\"></myr-my-services></div></div></div></div><div class=\"container\"><div class=\"row redHeadline mbm ptm\" ng-show=\"!ao.mss.isDetailsNotFound\"><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"title-h2\"><span class=\"account-other-services-heading primary-color\" res=\"acc_overview_other_services\"></span> <span class=\"widget-loader-inline account-other-services\" ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></div></div></div></div></div><div class=\"row ptm other-services-list-ctn\" ng-show=\"(!ao.mss.loadingData && !ao.mss.isDetailsNotFound)\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\" ng-repeat=\"msl in ao.mss.myOtherServicesListFinal | filter:{isVisible:true}\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"msl.id===\'Rogers Bank\' || msl.id===\'NHL (GCL)\' || msl.id===\'Shomi\'\"><div class=\"other-service-title\" data-ng-class=\"btnSettings.otherAvailableServices === btnStatus.disabled ? \'not-active\' : \'\'\" name=\"preCleanCall\"><h5 class=\"get-services-link\"><span res=\"{{msl.title}}\"></span></h5></div><div ng-show=\"msl.id===\'Rogers Smart Home Monitoring\'\"><span ng-bind-html=\"rhmMsg\"></span></div><div ng-show=\"msl.id===\'CTN\'\"><span res=\"log_in_to_oasys_or_ssp\"></span></div><div ng-show=\"(msl.id!=\'Rogers Smart Home Monitoring\')&& (msl.id===\'Hi-Speed Internet\' || msl.id===\'Digital TV\' || msl.id===\'RHPc\')\"><span res=\"log_in_to_sgi\"></span></div></div></div></div></div></div></div></div></section>");
$templateCache.put("views/oneViewInterface.html","<div class=\"sso-error-page\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"sso-error-container\" ng-show=\"isSSOFailure\"><div class=\"sso-error-heading\"><strong res=\"unable_to_sign_on\"></strong></div><div class=\"sso-error-description\"><span res=\"sso_failure_description\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isSessionTimeOut\"><div class=\"sso-error-heading\"><strong res=\"session_timeout_error_title\"></strong></div><div class=\"sso-error-description\"><span res=\"session_timeout_error_message\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isGenericError\"><div class=\"sso-error-heading\"><strong res=\"generic_error_title\"></strong></div><div class=\"sso-error-description\"><span res=\"generic_error_message\"></span></div></div></div></div></div></div>");
$templateCache.put("views/oops.html","<div class=\"page-registration\"><div class=\"container\"><h1 res=\"_something_went_wrong\"></h1><ul ng-repeat=\"error in $parent.errorsStack track by $index\"><li><strong>{{error.dateTime}} : {{error.message}}</strong></li><li><strong>Account:</strong><ul><li>Account Number: {{error.account.accountNumber}}</li><li>Account Type: {{error.account.accountTypeNumber}}</li><li>Account Status: {{error.account.accountStatus}}</li><li>Account Status Simple: {{error.account.accountStatusSimple}}</li></ul></li><li><strong>System Information:</strong><ul><li>Browser CodeName: {{error.systemInfo.appCodeName}}</li><li>Browser Name: {{error.systemInfo.appName}}</li><li>Browser Version: {{error.systemInfo.appVersion}}</li><li>Cookies Enabled: {{error.systemInfo.cookieEnabled}}</li><li>Platform: {{error.systemInfo.platform}}</li><li>User-agent header: {{error.systemInfo.userAgent}}</li></ul></li><li><strong style=\"color:#FF0000\">URL:</strong>{{error.url}}</li><li><strong>Call stack:</strong><ul ng-repeat=\"call in error.stack track by $index\"><li>{{call}}</li></ul></li></ul></div></div>");
$templateCache.put("views/page.html","<timer end-time=\"agentExpiry\" ng-if=\"agentExpiry\" class=\"ng-hide\" data-ng-cloak=\"\">{{minutes}}:{{seconds}}</timer><section globalloader=\"content\" style=\"margin-botton:90px;\"><div ui-view=\"\"></div><ssp-dashboard></ssp-dashboard><rep-feedback></rep-feedback></section>");
$templateCache.put("views/permissionDenied.html","<div data-ng-controller=\"permissionDeniedCtrl\"><center><h1>Permission Denied</h1><h5>- Detail message here -</h5></center></div>");
$templateCache.put("views/pre-registration.html","<div data-ng-controller=\"preRegistrationCtrl\"><form name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-12\"><label><span res=\"_first_name\"></span>: <input type=\"text\" name=\"firstName\" data-ng-model=\"firstName\" required=\"\"></label></div></div><div class=\"row\"><div class=\"col-lg-12\"><label><span res=\"_last_name\"></span>: <input type=\"text\" name=\"lastName\" data-ng-model=\"lastName\" required=\"\"></label></div></div><div class=\"row\"><div class=\"col-lg-12\"><label><span res=\"_email\"></span>: <input type=\"text\" name=\"email\" data-ng-model=\"email\" required=\"\"></label></div></div><div class=\"row\"><div class=\"col-lg-12\"><label><span res=\"_lang\"></span>:<select name=\"language\" data-ng-model=\"language\" required=\"\" ng-options=\"key as value for (key, value) in languages\"><option></option></select></label></div></div><div class=\"row\"><div class=\"col-lg-12\"><button data-ng-click=\"submit()\"><span res=\"_submit\"></span></button></div></div></form></div>");
$templateCache.put("views/review-order.html","<div class=\"confirm-order review-order hidden-sm hidden-xs\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"checkout_review_order\">checkout_review_order</span></h1></div></div></div></div><div class=\"container\"><div class=\"row mbl\"><div class=\"col-md-7\"><div class=\"your-order-column sub-heading-font\" res=\"checkout_review_order_billing_address\">res</div><div class=\"your-order-column confirm-line-large copy-font\">{{ reviewOrder.cart.billingStreetAddress }}</div><div class=\"your-order-column confirm-line-small copy-font\">{{ reviewOrder.cart.billingCity +\', \' +reviewOrder.cart.billingProvince }}</div><div class=\"your-order-column confirm-line-small copy-font\">{{ reviewOrder.cart.billingPostalCode }}</div><div class=\"your-order-column sub-heading-font mtl\" res=\"checkout_review_order_billing_preferences\">res</div><div class=\"your-order-column confirm-line-large\"><span class=\"bold-label\" res=\"checkout_review_order_pay\">res<span>:</span></span> <span class=\"copy-font\" res=\"checkout_review_order_pay_invoice\">res</span></div><div class=\"your-order-column confirm-line-small\"><span class=\"bold-label\" res=\"checkout_review_order_receive_bill_via\"></span> <span ng-show=\"reviewOrder.cart.billingType === \'INVOICE\'\" class=\"copy-font\" res=\"_online_bill\">res</span> <span ng-show=\"reviewOrder.cart.billingType != \'INVOICE\'\" class=\"copy-font\" res=\"_paper_bill\">res</span></div></div><div class=\"col-md-5\"><div class=\"your-order-column sub-heading-font\" res=\"checkout_confirm_order_contact_details\">res</div><div class=\"your-order-column confirm-line-large copy-font\">{{ reviewOrder.cart.firstName }} {{ reviewOrder.cart.lastName }}</div><div class=\"your-order-column confirm-line-small copy-font\">{{ reviewOrder.cart.contactPhoneNumber | phone2 }}</div><div class=\"your-order-column confirm-line-small copy-font\">{{ reviewOrder.cart.email }}</div><div class=\"your-order-column sub-heading-font mtl\" res=\"ppc_date_of_agreement\">res</div><div class=\"your-order-column confirm-line-large copy-font\">{{ agreementDate | date:\'yyyy-MM-dd\'}}</div></div></div><div class=\"row padded-bottom-container mbl\"></div><div class=\"row\"><div class=\"pull-left col-sm-10\"><h1 class=\"big-header rogers-red-font\" res=\"checkout_confirm_order_your_order\">res</h1></div><div id=\"print-button-container-X\" class=\"clickable pull-right col-sm-2 _np\"><a href=\"{{ reviewOrder.email() }}\"><img src=\"images/email-icon.png\" class=\"mrm\"></a> <a href=\"javascript:window.print()\"><img src=\"images/print-icon.png\"></a></div><div class=\"red-line clear-float\"></div></div><div class=\"row padded-container ptl\"><div class=\"col-lg-8 col-md-8\"><div class=\"clickable\"><div class=\"rogers-red-font heading-font\"><span res=\"ppc_shop_cart_plan_details\">res</span><span show-when=\"fr\"></span></div><div class=\"your-order-column\"><div class=\"pull-left sub-heading-font mtm\"><span show-when=\"en\">{{ reviewOrder.cart.newPlan.cmsData_En.planTitle }}</span> <span show-when=\"fr\">{{ reviewOrder.cart.newPlan.cmsData_Fr.planTitle }}</span></div><div class=\"pull-left mtm edit-button-ctn\" ng-click=\"reviewOrder.edit()\"><div class=\"float-left edit-button-caption font-sz-15\" res=\"paynow_edit\">res</div><div class=\"details-triangle details-triangle-edit-plan-fix float-left\"></div></div><div class=\"clear legal-fine-print\"><span class=\"font-sz-15 bold\" res=\"checkout_confirm_term_service\">res</span></div></div><div class=\"clear-float order-items order-items-mln\"><ul><li>{{ reviewOrder.cart.newPlan.planInfo.includedDataMax | mbOrGbValue }} {{ reviewOrder.cart.newPlan.planInfo.includedDataMax | mbOrGbValueStr }} <span ng-show=\"reviewOrder.cart.newPlan.planInfo.includedDataMax !== \'Not Applicable\'\"><span res=\"ppc_overage_rate\">res</span> <span show-when=\"en\">{{ reviewOrder.cart.newPlan.planInfo.overageRate }}</span> <span show-when=\"fr\">{{ reviewOrder.overageFr(reviewOrder.cart.newPlan.planInfo.overageRate) }}</span></span></li><li><span show-when=\"en\" data-ng-bind-html=\"reviewOrder.cart.newPlan.cmsData_En.includedMessages[0]\"></span> <span show-when=\"fr\" data-ng-bind-html=\"reviewOrder.cart.newPlan.cmsData_Fr.includedMessages[0]\"></span></li><li><span show-when=\"en\" data-ng-bind-html=\"reviewOrder.cart.newPlan.cmsData_En.includedMinutes[0]\"></span> <span show-when=\"fr\" data-ng-bind-html=\"reviewOrder.cart.newPlan.cmsData_Fr.includedMinutes[0]\"></span></li></ul></div><div class=\"clear-float order-items order-items-mln\"><ul show-when=\"en\"><li ng-repeat=\"featureItem in reviewOrder.cart.newPlan.cmsData_En.planFeatures\" data-ng-bind-html=\"featureItem\"></li></ul><ul show-when=\"fr\"><li ng-repeat=\"featureItem in reviewOrder.cart.newPlan.cmsData_Fr.planFeatures\" data-ng-bind-html=\"featureItem\"></li></ul></div></div></div><div class=\"col-lg-2 col-md-2\"></div><div class=\"col-lg-2 col-md-2\"><div class=\"rogers-red-font heading-font\" res=\"checkout_confirm_order_monthly_fees\">res</div><div class=\"your-order-column sub-heading-font confirm-line-large\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ reviewOrder.cart.newPlan.planInfo.planPrice | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div></div></div><row-hr></row-hr><div id=\"add-ons-row\" class=\"row\" ng-show=\"reviewOrder.cart.addOns.length > 0\"><div><h1 class=\"big-header rogers-red-font\" res=\"_add_ons\">res</h1></div></div><add-ons-list add-ons=\"reviewOrder.cart.addOns\" edit-btn=\"true\" on-edit-click=\"reviewOrder.edit()\"></add-ons-list><row-hr class=\"mtl\" ng-show=\"showIncudes\"></row-hr><div id=\"extras-heading\" class=\"row\" ng-show=\"isShareable\"><div class=\"pull-left\"><h1 class=\"big-header rogers-red-font mtn\" res=\"ppc_extras\">res</h1></div></div><div class=\"row\" ng-show=\"isShareable\"><div><img show-when=\"en\" ng-src=\"images/RoamON-EN-HD.png\" width=\"130\"> <img show-when=\"fr\" ng-src=\"images/RoamON-FR-HD.png\" width=\"185\"> <img show-when=\"en\" src=\"images/RGCL-logo-EN_lg.png\" class=\"mll\"> <img show-when=\"fr\" src=\"images/RGCL-logo-FR_lg.png\" class=\"mll\"></div><div ng-show=\"isSharePlus\" style=\"margin-top:30px;\" class=\"share-plus-logos\"><div res=\"ppc_one_following\" style=\"margin-bottom: 12px;\"></div><img src=\"images/value-added-offers/mb-spotify-logo.png\" width=\"100\"> <img src=\"images/value-added-offers/mb-shomi-logo.png\" width=\"90\"> <img src=\"images/value-added-offers/next_issue_2line.png\" width=\"110\"></div></div><div id=\"order-summary-total-heading\" class=\"row\"><div class=\"pull-left\"><h1 class=\"big-header rogers-red-font\" res=\"ppc_new_monthly_fees\">res</h1></div><div class=\"red-line clear-float\"></div></div><div class=\"row margin-bottom-md\"><div class=\"col-lg-4 col-lg-offset-5 col-md-4 col-md-offset-5\"><div class=\"your-order-column sub-heading-font confirm-line\" res=\"checkout_confirm_order_monthly_fees\">res</div><div class=\"your-order-column sub-heading-font confirm-line\" ng-repeat=\"(key, value) in reviewOrder.cart.taxes.taxes\">{{key}}</div></div><div class=\"col-lg-2 col-md-2\"><div class=\"float-right your-order-column-container\"><div class=\"your-order-column sub-heading-font confirm-line txtR\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ reviewOrder.cart.totalCost | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div><div class=\"your-order-column sub-heading-font confirm-line txtR\" ng-repeat=\"(key, value) in reviewOrder.cart.taxes.taxes\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{value | number: 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div></div></div></div><div id=\"grand-total-container\" class=\"row margin-bottom-md\"><div class=\"col-lg-4 col-md-4\"></div><div class=\"col-lg-8 col-md-8\"><div id=\"grand-total-box\" ng-class=\"{\'grand-total-box-fr\': lang == \'fr\'}\"><div><div class=\"pull-left\" res=\"checkout_confirm_new_monthly_total_fees\">res</div><div class=\"pull-right rogers-red-font\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ reviewOrder.cart.grandTotal | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div></div><div class=\"clear\"></div><div class=\"pull-left legal-fine-print\"><span res=\"ppc_taxes_disclaimer\">res</span></div></div></div></div><div id=\"legal-copy-container\" class=\"row margin-bottom-md\"><div class=\"legal-fine-print\" res=\"checkout_confirm_partial_prepaid\">res</div><div class=\"legal-fine-print\" res=\"checkout_confirm_fine_print\">res</div></div><row-hr></row-hr><div id=\"tac-row\" class=\"row mtm\"><div><div id=\"tac-title\" class=\"your-order-column heading-font\" res=\"checkout_review_additional_agreement_details\">res</div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"reviewOrder.showAgreementError\"><div res=\"ppc_agrrement_error_message\">res</div></div></div><div class=\"col-lg-9 col-md-10\"><div id=\"tac\"><div class=\"paragraph-link\" ng-click=\"reviewOrder.scrollTo(\'checkout_review_account_maint_agree\')\"><span res=\"checkout_review_account_maint_agree\">res</span></div><div class=\"paragraph-link\" ng-click=\"reviewOrder.scrollTo(\'checkout_review_rogers_tos\')\"><span res=\"checkout_review_rogers_tos\">res</span></div><div class=\"paragraph-link\" ng-click=\"reviewOrder.scrollTo(\'acceptable-use-policy\')\"><span res=\"checkout_acceptable_use_policy\">res</span></div><div class=\"paragraph-link\" ng-click=\"reviewOrder.scrollTo(\'privacy-policy\')\"><span res=\"checkout_privacy_policy\">res</span></div><div class=\"paragraph\" id=\"checkout_review_account_maint_agree\"><div show-when=\"en\" ng-include=\"\'views/localization/account-maintenance-agreement.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/account-maintenance-agreement-fr.html\'\"></div></div><div class=\"paragraph\" id=\"checkout_review_rogers_tos\"><div show-when=\"en\" ng-include=\"\'views/localization/rogers-terms-of-service.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/rogers-terms-of-service-fr.html\'\"></div></div><div class=\"paragraph\" id=\"acceptable-use-policy\"><div show-when=\"en\" ng-include=\"\'views/localization/acceptable-use-policy.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/acceptable-use-policy-fr.html\'\"></div></div><div class=\"paragraph\" id=\"privacy-policy\"><div show-when=\"en\" ng-include=\"\'views/localization/privacy-policy.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/privacy-policy-fr.html\'\"></div></div></div></div></div><div class=\"row mtm tac-checkbox-ctn\"><div class=\"col-lg-1 col-md-1\"><input id=\"tac-checkbox\" type=\"checkbox\" data-ng-model=\"tac_checkbox\" ng-click=\"reviewOrder.checkTacValue()\"></div><div class=\"col-lg-8 col-md-10 legal-print\"><div id=\"tac-label\" res=\"checkout_review_checkbox_copy\" class=\"ng-style: reviewOrder.showAgreementError && {color:\'red\'};\">res</div></div></div><div id=\"cancel-checkout\" class=\"row\"><div class=\"col-lg-9 col-md-11\"><span class=\"widget-loader-ppc-submit-order\" ng-show=\"reviewOrder.submittingOrder\" width=\"30px\"><img src=\"images/widget-loader.gif\" alt=\"\"></span><div class=\"your-order-column pull-right\"><div><span class=\"widget-loader mls\" ng-show=\"reviewLoader === true\"><img src=\"images/widget-loader.gif\" alt=\"\" width=\"30\"></span></div><button id=\"submit-button\" ng-click=\"reviewOrder.checkout()\" class=\"cta-round large\"><span class=\"white text-uppercase\" res=\"checkout_review_checkout\">res</span></button></div><div id=\"cancel-button\" class=\"your-order-column pull-right bold\"><a ng-click=\"reviewOrder.edit()\" res=\"_cancel\">res</a></div></div></div></div></div><div class=\"container-full confirm-order hidden-lg hidden-md\"><div class=\"row header-row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"checkout_review_order\">checkout_review_order</span></h1></div></div></div></div><div class=\"page-container\"><div class=\"section\" id=\"billing-address\"><div class=\"sub-title black-font-override\"><strong res=\"checkout_review_order_billing_address\">res</strong></div><div class=\"your-order-column confirm-line-small copy-font\">{{ reviewOrder.cart.billingStreetAddress }}</div><div class=\"your-order-column confirm-line-small copy-font\">{{ reviewOrder.cart.billingCity +\',\' +reviewOrder.cart.billingProvince }}</div><div class=\"your-order-column confirm-line-small copy-font pbs\">{{ reviewOrder.cart.billingPostalCode }}</div><div class=\"sub-title your-order-column sub-heading-font mtl\"><strong res=\"checkout_review_order_billing_preferences\">res</strong></div><div class=\"your-order-column confirm-line-small\"><span class=\"bold-label\" res=\"checkout_review_order_pay\">res<span>:</span></span> <span class=\"copy-font\" res=\"checkout_review_order_pay_invoice\">res</span></div><div class=\"your-order-column confirm-line-small\"><span class=\"bold-label\" res=\"checkout_review_order_receive_bill_via\">res<span>:</span></span> <span ng-show=\"reviewOrder.cart.billingType === \'INVOICE\'\" class=\"copy-font\" res=\"_online_bill\">res</span> <span ng-show=\"reviewOrder.cart.billingType != \'INVOICE\'\" class=\"copy-font\" res=\"_paper_bill\">res</span></div></div></div><confirm-review-order-shared></confirm-review-order-shared></div>");
$templateCache.put("views/single-line-ppc.html","<div id=\"mobile-view\" class=\"container-full single-line-ppc hidden-lg hidden-md\" ng-class=\"{\'mbl\': $parent.plansLoading}\"><div class=\"row header-row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"ppc_shop_change_plan_header\">ppc_shop_change_plan_header</span> <span class=\"widget-loader-inline\" ng-show=\"$parent.plansLoading\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div></div><div class=\"row mtm\"><div id=\"ctn-container mln\" class=\"narrow-margins\"><ctn-select user-selections=\"singleLinePPC.userSelections\" ctn-list=\"singleLinePPC.ctnList\" select-ctn=\"singleLinePPC.selectCtn\"></ctn-select></div></div><div ng-hide=\"$parent.plansLoading\"><div id=\"your-plan-adaptive\" class=\"row\"><existing-plan-adaptive plan=\"singleLinePPC.userSelections.plan\" existing-addons=\"singleLinePPC.userSelections.existingAddOns\"></existing-plan-adaptive></div><div id=\"available-plan-adaptive-title\" class=\"row\"><div class=\"col-sm-1 col-xs-1\"></div><div class=\"col-sm-10 col-xs-10\"><img src=\"images/cell-phone.png\" class=\"float-left mrm\" width=\"20\"><div id=\"text\" class=\"available-plans-adaptive-title float-left\" res=\"ppc_plan_change\">res</div></div><div class=\"col-sm-1 col-xs-1\"></div></div><div id=\"available-plan-adaptive-carousel\" class=\"row\"><div id=\"carousel-directive-container-adaptive\" ng-if=\"isMobile\"><price-plans-carousel-adaptive plans=\"singleLinePPC.userSelections.availablePlansRaw\" select-plan=\"singleLinePPC.selectPlan\" remove-plan=\"singleLinePPC.removePlan\"></price-plans-carousel-adaptive></div></div><div class=\"_cf\"></div><div style=\"\" class=\"widget-loader widget-loader-mobile mbl\" ng-show=\"longDistanceLoadMobile == true\"><img src=\"images/widget-loader.gif\" alt=\"\" width=\"30\"></div><div class=\"row\" ng-hide=\"(singleLinePPC.userSelections.droppedAddons.length === 0) && (singleLinePPC.userSelections.existingAddOns.length === 0 || singleLinePPC.userSelections.plan.costs.addOnsTotal === 0 || singleLinePPC.userSelections.availableAddOns.length === 0 || $parent.plansLoading)\"><div id=\"existing-add-ons-container\" class=\"your-add-ons-adaptive existing-plan-adaptive\"><div class=\"charcoal-bar yellow-orange-font\"><span class=\"your-plan-caption heading-font\" res=\"ppc_your_add_ons\">res</span></div><div class=\"light-grey-background ptm\"><div ng-repeat=\"addon in singleLinePPC.userSelections.existingAddOns\"><your-add-ons-adaptive add-on=\"addon\" add-ons-updated=\"singleLinePPC.addOnsUpdated\" duplicates=\"singleLinePPC.userSelections.duplicateAddons\"></your-add-ons-adaptive></div><div class=\"your-add-ons-duplicates-adaptive\" ng-show=\"singleLinePPC.userSelections.duplicateAddons.length || singleLinePPC.userSelections.droppedAddons.length\"><your-add-ons-duplicates-adaptive duplicates=\"singleLinePPC.userSelections.duplicateAddons\" dropped=\"singleLinePPC.userSelections.droppedAddons\"></your-add-ons-duplicates-adaptive></div></div></div></div><div ng-show=\"true\"><div id=\"available-add-ons-adaptive\" class=\"row\" ng-hide=\"singleLinePPC.userSelections.availableAddOns.length === 0 || singleLinePPC.userSelections.selectedPlan === null\"><div id=\"choose-new-add-ons\" class=\"available-plans-adaptive-title margin-left\"><span res=\"ppc_shop_choose_add_ons\">res</span></div><div ng-show=\"singleLinePPC.filterAddonsWatch(\'ValuePacks\', true)\"><div class=\"add-on-category-button\" ng-click=\"valuePacksAddOnsExpanded = !valuePacksAddOnsExpanded\"><div class=\"pull-left\"><span res=\"value_packs\">res</span></div><div class=\"pull-right wedge\" ng-class=\"{ \'wedge-closed\': !valuePacksAddOnsExpanded, \'wedge-opended\': valuePacksAddOnsExpanded }\"></div></div><div ng-show=\"valuePacksAddOnsExpanded\"><available-add-ons-list-adaptive add-ons=\"singleLinePPC.userSelections.availableAddOns\" add-ons-updated=\"singleLinePPC.addOnsUpdated\" type=\"ValuePacks\" details-expanded=\"singleLinePPC.userSelections.availableLDAddOnDetailsExpanded\" show-details=\"singleLinePPC.showAvailableLDAddOnDetails\" hide-details=\"singleLinePPC.hideAvailableLDAddOnDetails\"></available-add-ons-list-adaptive></div></div></div><div ng-show=\"singleLinePPC.filterAddonsWatch(\'LongDistance\', true)\" class=\"row\"><div class=\"add-on-category-button\" ng-click=\"longDistanceAddOnsExpanded = !longDistanceAddOnsExpanded\"><div class=\"pull-left\"><span res=\"long_distance\">res</span></div><div class=\"pull-right wedge\" ng-class=\"{ \'wedge-closed\': !longDistanceAddOnsExpanded, \'wedge-opended\': longDistanceAddOnsExpanded }\"></div></div><div ng-show=\"longDistanceAddOnsExpanded\"><available-add-ons-list-adaptive add-ons=\"singleLinePPC.userSelections.availableAddOns\" add-ons-updated=\"singleLinePPC.addOnsUpdated\" type=\"LongDistance\" details-expanded=\"singleLinePPC.userSelections.availableLDAddOnDetailsExpanded\" show-details=\"singleLinePPC.showAvailableLDAddOnDetails\" hide-details=\"singleLinePPC.hideAvailableLDAddOnDetails\"></available-add-ons-list-adaptive></div></div></div><div class=\"row\" ng-show=\"singleLinePPC.filterAddonsWatch(\'CallingFeatures\', true)\"><div class=\"add-on-category-button\" ng-init=\"callingFeatureAddOnsExpanded = false;\" ng-click=\"callingFeatureAddOnsExpanded = !callingFeatureAddOnsExpanded\"><div class=\"pull-left\"><span res=\"calling_features\">res</span></div><div class=\"pull-right wedge\" ng-class=\"{ \'wedge-closed\': !callingFeatureAddOnsExpanded, \'wedge-opended\': callingFeatureAddOnsExpanded }\"></div></div><div ng-show=\"callingFeatureAddOnsExpanded\"><available-add-ons-list-adaptive add-ons=\"singleLinePPC.userSelections.availableAddOns\" type=\"CallingFeatures\" details-expanded=\"singleLinePPC.userSelections.availableCFAddOnDetailsExpanded\" show-details=\"singleLinePPC.showAvailableCFAddOnDetails\" hide-details=\"singleLinePPC.hideAvailableCFAddOnDetails\"></available-add-ons-list-adaptive></div></div><div class=\"row\" ng-hide=\"singleLinePPC.userSelections.selectedPlan == null || $parent.plansLoading || longDistanceLoadMobile\"><cart-summary-adaptive details=\"singleLinePPC.details\" plan=\"singleLinePPC.userSelections.selectedPlan\" ctn=\"singleLinePPC.userSelections.ctn\" total-cost=\"singleLinePPC.userSelections.totalCost\" existing-add-ons=\"singleLinePPC.userSelections.existingAddOns\" available-add-ons=\"singleLinePPC.userSelections.availableAddOns\" is-prorated=\"singleLinePPC.userSelections.isProrated\" rewards-points=\"singleLinePPC.userSelections.rewardsPoints\"></cart-summary-adaptive></div></div></div><div id=\"desktop-tablet-view\" class=\"single-line-ppc hidden-sm hidden-xs\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"ppc_shop_change_plan_header\">ppc_shop_change_plan_header</span></h1></div></div></div></div><div class=\"container\"><div id=\"ctn-row\" class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-4 col-xs-12\"><div class=\"rogers-red-font\"><h1 res=\"ppc_shop_choose_new_plan\">res</h1></div></div><div id=\"ctn-container\" class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12\"><ctn-select class=\"_dib\" user-selections=\"singleLinePPC.userSelections\" ctn-list=\"singleLinePPC.ctnList\" select-ctn=\"singleLinePPC.selectCtn\"></ctn-select>&nbsp; <span class=\"widget-loader widget-loader-ppc\" ng-show=\"$parent.plansLoading\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></div></div><div id=\"plans-row\" class=\"row\" ng-hide=\"$parent.plansLoading\"><div class=\"col-lg-3 col-md-3\" ng-mouseenter=\"singleLinePPC.popUpBubbles.hidePlanPopUp()\"><existing-plan plan=\"singleLinePPC.userSelections.plan\" plan-details=\"singleLinePPC.userSelections.planDetails\" existing-addons=\"singleLinePPC.userSelections.existingAddOns\"></existing-plan></div><div class=\"col-lg-9 col-md-9\" ng-mouseleave=\"singleLinePPC.popUpBubbles.hidePlanPopUp()\"><div class=\"available-plan-pop-up-bubble\" ng-show=\"singleLinePPC.popUpBubbles.planPopUpVisible\" ng-mouseleave=\"singleLinePPC.popUpBubbles.hidePlanPopUp()\" ng-class=\"{ \'pop-index-0\': singleLinePPC.popUpBubbles.planIndex === \'0\', \'pop-index-1\': singleLinePPC.popUpBubbles.planIndex === \'1\', \'pop-index-2\': singleLinePPC.popUpBubbles.planIndex === \'2\', \'available-plan-pop-up-bubble-exclusive\': singleLinePPC.popUpBubbles.isExclusive }\"><span res=\"ppc_exclusive_plan_pop_up\" ng-show=\"singleLinePPC.popUpBubbles.isExclusive\" show-when=\"en\">res</span> <span res=\"ppc_recommended_plan_pop_up\" ng-show=\"singleLinePPC.popUpBubbles.isRecommended\" show-when=\"en\">res</span> <span class=\"font-sz-11\" res=\"ppc_exclusive_plan_pop_up\" ng-show=\"singleLinePPC.popUpBubbles.isExclusive\" show-when=\"fr\">res</span> <span class=\"font-sz-11\" res=\"ppc_recommended_plan_pop_up\" ng-show=\"singleLinePPC.popUpBubbles.isRecommended\" show-when=\"fr\">res</span></div><div ng-if=\"!isMobile\"><price-plans-carousel plans=\"singleLinePPC.userSelections.availablePlans\" plans-length=\"singleLinePPC.userSelections.availablePlansRawLength\" show-details=\"singleLinePPC.showAvailablePlanDetails\" hide-details=\"singleLinePPC.hideAvailablePlanDetails\" select-plan=\"singleLinePPC.selectPlan\" remove-plan=\"singleLinePPC.removePlan\"></price-plans-carousel></div></div></div><div class=\"row\"><available-plan-details expanded=\"singleLinePPC.userSelections.availablePlanDetailsExpanded\" slide-index=\"singleLinePPC.userSelections.availablePlanDetailsSlideIndex\" expanded-plan=\"singleLinePPC.userSelections.expandedPlan\"></available-plan-details></div><h1 ng-hide=\"$parent.plansLoading\" ng-style-x=\"$parent.plansLoading && {\'visibility\' : \'hidden\'}\" class=\"rogers-red-font\"><span res=\"ppc_shop_add_ons_and_extras\">res</span><span class=\"widget-loader mls\" ng-show=\"longDistanceLoader === true && singleLinePPC.userSelections.selectedPlan != null\"><img src=\"images/widget-loader.gif\" alt=\"\" width=\"30\"></span></h1><div class=\"row label-row\" ng-hide=\"(singleLinePPC.userSelections.droppedAddons.length === 0) && (singleLinePPC.userSelections.existingAddOns.length === 0 || (singleLinePPC.userSelections.plan.costs.addOnsTotal === 0 || singleLinePPC.userSelections.availableAddOns.length === 0) || $parent.plansLoading || longDistanceLoader)\"><h4 ng-show=\"singleLinePPC.userSelections.existingAddOns.length || singleLinePPC.userSelections.plan.costs.addOnsTotal > 0\" class=\"sub-heading\" res=\"ppc_shop_existing_add_ons\">res</h4><div><add-on ng-repeat=\"addon in singleLinePPC.userSelections.existingAddOns\" add-on=\"addon\" show-details=\"singleLinePPC.showExistingAddOnDetails\" hide-details=\"singleLinePPC.hideExistingAddOnDetails\" slide-index=\"{{ $index }}\" group=\"existing\" add-ons-updated=\"singleLinePPC.addOnsUpdated\" show-description=\"false\"></add-on><duplicate-add-ons duplicates=\"singleLinePPC.userSelections.duplicateAddons\" dropped=\"singleLinePPC.userSelections.droppedAddons\"></duplicate-add-ons></div><add-on-details details=\"singleLinePPC.userSelections.expandedExistingAddOn\" slide-index=\"singleLinePPC.userSelections.existingAddOnDetailsSlideIndex\" expanded=\"singleLinePPC.userSelections.existingAddOnDetailsExpanded\"></add-on-details></div><h4 class=\"sub-heading\" res=\"ppc_shop_choose_add_ons\" ng-hide=\"singleLinePPC.userSelections.availableAddOns.length === 0 || (singleLinePPC.filterAddOns(singleLinePPC.userSelections.availableAddOns, \'Value Packs\').length === 0 && singleLinePPC.filterAddOns(singleLinePPC.userSelections.availableAddOns, \'Long Distance\').length === 0 && singleLinePPC.filterAddOns(singleLinePPC.userSelections.availableAddOns, \'Calling Features\').length === 0) || singleLinePPC.userSelections.selectedPlan === null || $parent.plansLoading || longDistanceLoader\">res</h4><div class=\"row\" ng-hide=\"singleLinePPC.userSelections.availableAddOns.length === 0 || singleLinePPC.filterAddOns(singleLinePPC.userSelections.availableAddOns, \'Value Packs\').length === 0 || singleLinePPC.userSelections.selectedPlan === null || $parent.plansLoading || longDistanceLoader\"><h4 class=\"sub-sub-heading rogers-red-font\" res=\"value_packs\">res</h4><div class=\"addons-long-distance\"><add-on ng-repeat=\"addon in singleLinePPC.filterAddOns(singleLinePPC.userSelections.availableAddOns, \'Value Packs\')\" add-on=\"addon\" show-details=\"singleLinePPC.showAvailableVPAddOnDetails\" hide-details=\"singleLinePPC.hideAvailableVPAddOnDetails\" slide-index=\"{{ $index }}\" group=\"available-long-distance\" add-ons-updated=\"singleLinePPC.addOnsUpdated\" show-description=\"true\"></add-on><add-on-details details=\"singleLinePPC.userSelections.expandedAvailableVPAddOn\" slide-index=\"singleLinePPC.userSelections.availableVPAddOnDetailsSlideIndex\" expanded=\"singleLinePPC.userSelections.availableVPAddOnDetailsExpanded\"></add-on-details></div></div><div class=\"row\" ng-hide=\"singleLinePPC.userSelections.availableAddOns.length === 0 || singleLinePPC.filterAddOns(singleLinePPC.userSelections.availableAddOns, \'Long Distance\').length === 0 || singleLinePPC.userSelections.selectedPlan === null || $parent.plansLoading || longDistanceLoader\"><h4 class=\"sub-sub-heading rogers-red-font\" res=\"long_distance\">res</h4><div class=\"addons-long-distance\"><add-on ng-repeat=\"addon in singleLinePPC.filterAddOns(singleLinePPC.userSelections.availableAddOns, \'Long Distance\')\" add-on=\"addon\" show-details=\"singleLinePPC.showAvailableLDAddOnDetails\" hide-details=\"singleLinePPC.hideAvailableLDAddOnDetails\" slide-index=\"{{ $index }}\" group=\"available-long-distance\" add-ons-updated=\"singleLinePPC.addOnsUpdated\" show-description=\"true\"></add-on><add-on-details details=\"singleLinePPC.userSelections.expandedAvailableLDAddOn\" slide-index=\"singleLinePPC.userSelections.availableLDAddOnDetailsSlideIndex\" expanded=\"singleLinePPC.userSelections.availableLDAddOnDetailsExpanded\"></add-on-details></div></div><div class=\"row\" ng-hide=\"singleLinePPC.userSelections.availableAddOns.length === 0 || singleLinePPC.filterAddOns(singleLinePPC.userSelections.availableAddOns, \'Calling Features\').length === 0 || singleLinePPC.userSelections.selectedPlan === null\"><h4 class=\"sub-sub-heading rogers-red-font\" res=\"calling_features\">res</h4><div><add-on ng-repeat=\"addon in singleLinePPC.filterAddOns(singleLinePPC.userSelections.availableAddOns, \'Calling Features\')\" add-on=\"addon\" show-details=\"singleLinePPC.showAvailableCFAddOnDetails\" hide-details=\"singleLinePPC.hideAvailableCFAddOnDetails\" slide-index=\"{{ $index }}\" group=\"available-calling-features\" add-ons-updated=\"singleLinePPC.addOnsUpdated\"></add-on><add-on-details details=\"singleLinePPC.userSelections.expandedAvailableCFAddOn\" slide-index=\"singleLinePPC.userSelections.availableCFAddOnDetailsSlideIndex\" expanded=\"singleLinePPC.userSelections.availableCFAddOnDetailsExpanded\"></add-on-details></div></div></div></div><div class=\"container-full hidden-sm hidden-xs\"><div class=\"row\" ng-hide=\"singleLinePPC.userSelections.selectedPlan === null || $parent.plansLoading || longDistanceLoader\"><cart-summary details=\"singleLinePPC.details\" plan=\"singleLinePPC.userSelections.selectedPlan\" ctn=\"singleLinePPC.userSelections.ctn\" total-cost=\"singleLinePPC.userSelections.totalCost\" existing-add-ons=\"singleLinePPC.userSelections.existingAddOns\" available-add-ons=\"singleLinePPC.userSelections.availableAddOns\" is-prorated=\"singleLinePPC.userSelections.isProrated\" rewards-points=\"singleLinePPC.userSelections.rewardsPoints\"></cart-summary></div></div><full-details ng-show=\"singleLinePPC.userSelections.availablePlans.length\"></full-details>");
$templateCache.put("views/suspended.html","<div class=\"page-wireless page-registration\" ng-controller=\"MyrAccountOverviewController\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"suspendedSubscriptionMessage\"></validation-error-box></div></div></div></div></div>");
$templateCache.put("rfr/views/noaccount.html","<rfr-modal></rfr-modal>");
$templateCache.put("rfr/views/rewards.browse.html","<section class=\"container rewards-section rewards-browse\"><h1 class=\"primary-color\" res=\"submenu_browse\" ng-class=\"{\'visible-xs\': !catId,\'hidden\': catId}\"></h1><h1 class=\"catTitle primary-color\" ng-class=\"{\'visible-xs\': catId,\'hidden\': !catId}\">{{ catName }}</h1><a name=\"/rewards/browse/\" class=\"named-anchor\"></a> <a name=\"/rewards/browse/{{catId}}\" class=\"named-anchor\"></a><div class=\"rewards-browse-catalogue\"><div class=\"row search\"><div class=\"col-xs-12 col-sm-6 col-sm-offset-6\"><form class=\"form-inline\"><div class=\"search-keyword hidden-xs\" ng-class=\"{\'text-right\': lang == \'en\', \'text-center\': lang == \'fr\' }\"><label res=\"search\"></label></div><div class=\"search-wrapper\"><input type=\"text\" ng-model=\"searchBrowseReward\" placeholder=\"{{rewardNameRes}}\" class=\"input-large\"> <button class=\"\"><i class=\"rui-icon-search\"></i></button></div></form></div></div><div class=\"row menu text-center\"><div class=\"wrapper\"><img ng-hide=\"catIconsShown\" class=\"loading mtl ptl\" src=\"images/widget-loader.gif\" alt=\"\"><ul ng-show=\"catIconsShown\" class=\"cat-icons\"><li class=\"col-xs-4 col-sm-2 cat-icon\" ng-repeat=\"aCategory in slideFlagCategories | orderCats | limitTo:6\" ng-class=\"{ active: catId == aCategory.url }\"><div class=\"category-icon\"><a ng-click=\"goToCategory({catId: aCategory.url});\"><img class=\"img-responsive\" ng-src=\"{{imageUrl}}/{{aCategory.imageId}}\"></a></div><h5><a ng-class=\"{ \'rfr-ellipsis\': (aCategory.name.length > 14) }\" ng-click=\"goToCategory({catId: aCategory.url});\">{{ aCategory.name | limitTo: 11 }}</a></h5></li></ul></div></div></div><div ng-show=\"errorCode.errInRewardLoading\" class=\"mvm info-banner error reverse-margin\"><div class=\"row\"><div class=\"sigin-error-icon-ctn col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding\"><span class=\"fa fa-exclamation-circle fa-2x txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\"><span class=\"v-base-line\">Sorry, server returned an error.</span></div></div></div><div class=\"rewards-browse-catalogue\" ng-repeat=\"aCategory in slideFlagCategories | orderCats | limitTo: 6\" ng-hide=\"catId || searchBrowseReward || userNavigationLoaderShow\"><div class=\"row category\" ng-hide=\"aCategory.browseRewards.length == 0\"><div class=\"visible-xs category-header\"><div class=\"col-xs-6\"><h3>{{aCategory.name}}</h3></div><div class=\"col-xs-6 text-right\"><h4><a res=\"view_all\" ui-sref=\"{catId: aCategory.url}\"></a> <i class=\"fa fa-caret-right\"></i></h4></div></div><div class=\"hidden-xs col-sm-offset-3 back\" ng-class=\"{ \'col-sm-3\': (aCategory.browseRewards.length === 1), \'col-sm-6\': (aCategory.browseRewards.length === 2), \'col-sm-9\': (aCategory.browseRewards.length > 2) }\"><div class=\"category-curve-detail\"></div></div><div class=\"hidden-xs col-sm-3 tabs\"><div class=\"category_title\"><div class=\"category_title_text\">{{aCategory.name}}&nbsp;&nbsp;</div><img ng-hide=\"aCategory.browseRewards.length\" class=\"loading\" src=\"images/widget-loader.gif\" alt=\"\"></div><div class=\"view-all\"><a res=\"view_all\" ui-sref=\"{catId: aCategory.url}\"></a> <i class=\"fa fa-caret-right\"></i></div></div><div class=\"col-xs-12 col-sm-3 col-md-3\" ng-repeat=\"reward in aCategory.browseRewards track by $index\"><div bundle-id=\"section-1-bundle-{{$index}}\" reward-card=\"reward\" class=\"reward-card carousel-card\"></div></div></div></div><div class=\"rewards-browse-catalogue-category\" ng-show=\"catId || searchBrowseReward\"><div class=\"row filter\"><div class=\"rui-dropdown-frame col-xs-12 col-sm-3 mbl\" style=\"z-index:501;\"><div rui-dropdown=\"\" class=\"rui-dropdown\" list=\"refinedCategories\" selected=\"currentCategory\" select-action=\"refineCategoryBy(item)\" property=\"name\" placeholder=\"{{getResourceString(\'refine_by\')}}\"></div></div><div class=\"rui-dropdown-frame col-xs-12 col-sm-3 mbl\"><div rui-dropdown=\"\" class=\"rui-dropdown\" list=\"sortingCategories\" selected=\"currentCategorySortOption\" select-action=\"sortRewardBy(item)\" property=\"name\" placeholder=\"{{getResourceString(\'sort_by\')}}\"></div></div><img ng-show=\"userNavigationLoaderShow || (!refinedRewardsList.length && refinedRewardsList.length != 0)\" class=\"loading\" width=\"29\" src=\"images/widget-loader.gif\" alt=\"\"></div></div><div infinite-scroll=\"loadMore()\"><div class=\"row filtered-view\"><div class=\"col-xs-12 col-sm-3 col-md-3\" ng-hide=\"!refinedRewardsList.length || userNavigationLoaderShow\" ng-repeat=\"reward in refinedRewardsList | limitTo: lazyLoadLimit track by reward.rewardId\"><div bundle-id=\"section-1-bundle-{{$index}}\" reward-card=\"reward\" class=\"reward-card carousel-card\"></div></div></div></div></section>");
$templateCache.put("rfr/views/rewards.earn.html","<section class=\"container rewards-section rewards-earn\"><a name=\"/rewards/earn/{{earnId}}/\" class=\"named-anchor\"></a> <a name=\"/rewards/redeem/{{earnId}}/confirm\" class=\"named-anchor\"></a><h1 class=\"visible-xs primary-color\" res=\"submenu_earn\"></h1><span class=\"earn-enroll-link\" ng-show=\"showEnrollLink()\"><a ui-sref=\"rewards.enroll\" res=\"rfr_enroll_in_first_rewards_now\"></a> <i class=\"fa fa-caret-right\"></i></span><div ng-hide=\"earnId\"><div infinite-scroll=\"loadMore()\"><div class=\"row rewards-earn-item\" ng-repeat=\"item in earnList | limitTo: limit\"><div class=\"rewards-earn-img col-xs-12 col-sm-5\"><img ng-if=\"item.image.imageId\" class=\"img-responsive\" ng-src=\"{{imageUrl}}/{{item.image.imageId}}\"> <img ng-if=\"!item.image.imageId && lang == \'en\'\" class=\"img-responsive\" ng-init=\"getImageSrc(item)\" src=\"images/nophoto.jpg\"> <img ng-if=\"!item.image.imageId && lang == \'fr\'\" class=\"img-responsive\" ng-init=\"getImageSrc(item)\" src=\"images/nophoto_fr.jpg\"></div><div class=\"rewards-earn-description col-xs-12 col-sm-7\"><div class=\"rewards-earn-item-title\" ng-bind=\"::item.name\"></div><div ng-if=\"item.PointsPossibleToEarn\" class=\"rewards-earn-points-display\"><span res=\"submenu_earn\"></span>&nbsp;<span ng-bind=\"::item.PointsPossibleToEarn | number:0\"></span>&nbsp;pts</div><div class=\"rewards-earn-description\" ng-bind-html=\"::getHtmlString(item.marketingPromotionsDescHtml)\"></div><button class=\"btn primary rfr-main-cta\" res=\"rfr_learn_more_btn\" ui-sref=\"{{::getEarnUrl(item.id, item.marketingPromotionId)}}\"></button></div></div></div></div><div class=\"rewards-earn-item-details-individual-wrapper\"><div class=\"row rewards-earn-item-details-individual\" ng-show=\"earnId && !stepId\"><div class=\"rewards-earn-item-title\" ng-bind=\"::earnItem.name\"></div><div class=\"rewards-earn-item-details-img col-xs-12 col-sm-7\"><img ng-if=\"imgPath\" class=\"img-responsive item-img\" ng-src=\"{{ imgPath }}\"> <img ng-if=\"!imgPath && lang == \'en\'\" class=\"img-responsive item-img\" src=\"images/nophoto.jpg\"> <img ng-if=\"!imgPath && lang == \'fr\'\" class=\"img-responsive item-img\" src=\"images/nophoto_fr.jpg\"><div class=\"earn-points-amount\"><span res=\"earn\"></span> <span ng-bind=\"::earnItem.PointsPossibleToEarn | number:0\"></span> &nbsp;pts</div></div><div class=\"rewards-earn-item-details col-xs-12 col-sm-5\"><div ng-show=\"!showSignIn\"><button ng-hide=\"hideOptIn()\" class=\"rfr-main-cta btn primary\" res=\"rfr_opt_in\" ui-sref=\"rewards.earn({stepId:\'confirm\', marketingPromotionId: earnItem.marketingPromotionId })\"></button><div ng-show=\"earnItem.optedInStatus\"><span class=\"promotion_opted_in_msg\" res=\"rfr_already_opted_in\"></span></div></div><div ng-show=\"showSignIn\" sign-in-or-register=\"\"></div><h4 class=\"col-xs-12 details-header\" res=\"_details\"></h4><p class=\"col-xs-12 details-copy\"><span ng-bind-html=\"::getHtmlString(earnItem.marketingPromotionsShortDescHtml)\"></span> <a class=\"rfr-details-link\" res=\"rfr_more_link\" ng-show=\"toggleLongDescription\" ng-click=\"toggleLongDescription = !toggleLongDescription\"></a></p></div><div class=\"details-copy-long-description col-xs-12\" ng-init=\"toggleLongDescription = true\" collapse=\"toggleLongDescription\" ng-bind-html=\"::getHtmlString(earnItem.marketingPromotionsDescHtml)\"></div></div><a class=\"rfr-details-link rfr-show-less\" res=\"rfr_less_link\" ng-hide=\"toggleLongDescription\" ng-click=\"toggleLongDescription = !toggleLongDescription\"></a></div><div class=\"row rewards-earn-confirm-container\" ng-show=\"earnId && stepId\"><div section-header=\"\" header-copy=\"rfr_promotion_summary\" ng-show=\"stepId ===\'confirm\'\"></div><div section-header=\"\" header-copy=\"rfr_promotion_confirmation\" ng-show=\"stepId ===\'success\'\"></div><div class=\"row rewards-earn-success-container\" ng-show=\"earnId && stepId && stepId===\'success\'\"><div class=\"rewards-earn-success col-xs-12 col-sm-8\"><i class=\"rfr-icon rfr-icon-checkmark\"></i><div class=\"rewards-earn-success-summary\"><span res=\"rfr_earn_success_copy\"></span><div ng-click=\"printEarnSuccessSummary()\"><i class=\"rfr-icon rfr-icon-print\"></i><span res=\"_print\"></span></div></div></div></div><div class=\"rewards-redeem-error-container col-xs-12 info-banner error\" ng-show=\"apiError\"><span class=\"message-banner-icon icon-error\"></span><div class=\"api-error-display\" ng-bind-html=\"apiError\"></div></div><div class=\"earn-details\"><div class=\"earn-details-img col-xs-12 col-sm-3\"><img class=\"img-responsive\" ng-src=\"{{smallImgSrc}}\"></div><div class=\"earn-details-text col-xs-12 col-sm-6\"><div class=\"details-header\" res=\"rfr_promotion_to_be_redeemed\" ng-show=\"stepId === \'confirm\'\"></div><div class=\"details-header\" res=\"rfr_promotion_redeemed\" ng-show=\"stepId === \'success\'\"></div><span class=\"earn-details-reward-title\" ng-bind=\"::earnItem.name\"></span><br><span class=\"earn-details-reward-pts\"><span ng-bind=\"::earnItem.PointsPossibleToEarn | number:0\"></span>&nbsp;<span>pts</span></span><div class=\"details-header your-points\" res=\"your_points\"></div><div><span class=\"details-label\" res=\"points_available\"></span> <span class=\"pull-right points-display\">&nbsp;pts</span> <span class=\"pull-right points-display\" ng-bind=\"::currentBalance | number:0\"></span><br><span class=\"details-label\" res=\"rfr_points_about_to_earn\" ng-show=\"stepId===\'confirm\'\"></span> <span class=\"details-label\" res=\"rfr_points_earned\" ng-show=\"stepId===\'success\'\"></span> <span class=\"pull-right about-to-earn points-display\">&nbsp;pts</span> <span class=\"pull-right about-to-earn points-display\" ng-bind=\"::\'+ \' + (earnItem.PointsPossibleToEarn | number:0)\"></span><br><hr><span class=\"details-label balance-after\" res=\"points_balance_after\"></span> <span class=\"pull-right points-display\">&nbsp;pts</span> <span class=\"pull-right points-display\" ng-bind=\"::(currentBalance + earnItem.PointsPossibleToEarn) | number:0\"></span></div></div></div><div ng-show=\"stepId ===\'confirm\'\"><h4 res=\"_terms_conditions\" class=\"rfr-terms-header\"></h4><div class=\"rfr-terms-conditions-box\"><div class=\"rfr-terms-conditions-text\"><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/earn-tc-txt/earn-tc-txt\"></ins></div></div><div accept=\"\" data-on-cancel=\"rejectTerms()\" data-on-accept=\"acceptTerms()\" data-checkbox-text-res=\"linked_acc_discl_accept\" data-accept-text-res=\"_submit\" data-cancel-text-res=\"_cancel\"></div></div></div><div class=\"row rewards-earn-success-container\" ng-show=\"earnId && stepId && stepId===\'success\'\"><div class=\"rewards-earn-success-details\"><div class=\"details-header\" res=\"_details\"></div><div ng-bind-html=\"::getHtmlString(earnItem.marketingPromotionsOptinConfMsgHtml)\"></div></div><div class=\"rewards-earn-success-description\"><div class=\"details-header\">Description</div><div ng-bind-html=\"::getHtmlString(earnItem.marketingPromotionsDescHtml)\"></div></div></div></section>");
$templateCache.put("rfr/views/rewards.enroll.html","<section class=\"container rewards-section rewards-enroll\"><h1 class=\"visible-xs primary-color\" res=\"enroll\"></h1><div class=\"row rewards-enroll-marketing-copy\"><div section-header=\"\" header-copy=\"rfr_enrollment_header\"></div><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/alert-message-enroll/alert-message-enroll\"></ins><div class=\"rewards-redeem-error-container col-xs-12 info-banner error\" ng-show=\"apiError && !unauthorizedRedirect\"><span class=\"message-banner-icon icon-error\"></span><div class=\"api-error-display\" ng-bind-html=\"apiError\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/enroll-banner-txt/enroll-banner-txt\"></ins></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><a class=\"pull-right ptl\" ng-click=\"sendToPrinter(\'\')\"><i class=\"font-xxl rfr-icon rfr-icon-print\"></i></a><h4 res=\"_terms_conditions\" class=\"rfr-terms-header\"></h4><div class=\"rfr-terms-conditions-box\"><div id=\"main\" class=\"rfr-terms-conditions-text\"><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/enroll-tc-txt/enroll-tc-txt\"></ins></div></div><p res=\"rfr_accept_confirmation\"></p><div accept=\"\" data-on-cancel=\"rejectTerms()\" data-on-accept=\"acceptTerms()\" data-checkbox-text-res=\"linked_acc_discl_accept\" data-accept-text-res=\"rfr_home_signed2_button\" data-cancel-text-res=\"_cancel\"></div></div></div></section>");
$templateCache.put("rfr/views/rewards.howitworks.html","<section class=\"container rewards-section rewards-howitworks\"><h1 class=\"visible-xs primary-color\" res=\"howitworks\"></h1><a name=\"/rewards/howitworks\" class=\"named-anchor\"></a><div class=\"row rewards-howitworks-redeem-copy\"><div class=\"col-xs-12 col-sm-3 ptm center-button\"><div ng-bind-html=\"stepImage(31)\"></div></div><div class=\"col-xs-12 col-sm-9 ptm center-button\"><ins class=\"hidden-xs\" ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/howto-step3-txt/howto-step3-txt\"></ins><div class=\"visible-xs\"><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/howto-step3-1-txt/howto-step3-1-txt\"></ins></div></div></div><hr><div class=\"row rewards-howitworks-redeem-using-phone-copy\"><div class=\"col-xs-12 col-sm-3 ptm center-button\"><div ng-bind-html=\"stepImage(32)\"></div></div><div class=\"col-xs-12 col-sm-9 ptm center-button\"><ins class=\"hidden-xs\" ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/howto-step4-txt/howto-step4-txt\"></ins><div class=\"visible-xs\"><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/howto-step3-2-txt/howto-step3-2-txt\"></ins></div><div class=\"howTo-step-4-content\"><button class=\"cta-round primary large\" ng-click=\"$state.go(\'rewards.browse\'); viewLoader = true;\"><span class=\"white\" res=\"find_something_you_love\"></span></button></div><img ng-show=\"viewLoader\" class=\"loading mts mhm\" width=\"29\" src=\"images/widget-loader.gif\" alt=\"\"></div></div><hr></section>");
$templateCache.put("rfr/views/rewards.html","<section class=\"rewards-section rewards-container\"><div class=\"hidden-xs my-points-wrapper-desktop\"><div class=\"container rel\"><div class=\"pin-r\"><my-points class=\"my-points-container\"></my-points></div></div></div><my-points class=\"visible-xs container my-points-container\"></my-points><div class=\"row\" ng-class=\"{\'hidden-sm hidden-md hidden-lg\': $state.is(\'rewards\')}\"><rewards-sub-menu></rewards-sub-menu></div><rfr-modal></rfr-modal><div ui-view=\"enroll\"></div><div ui-view=\"membership\" ng-show=\"$state.is(\'rewards.membership\')\"></div><div ui-view=\"wishlist\" ng-if=\"$state.is(\'rewards.wishlist\')\"></div><div ui-view=\"transactions\" ng-if=\"$state.is(\'rewards.transactions\')\"></div><div ui-view=\"redeem\" ng-if=\"$state.is(\'rewards.redeem\')\"></div><div ui-view=\"browse\" ng-show=\"$state.is(\'rewards.browse\')\"></div><div ui-view=\"earn\" ng-if=\"$state.is(\'rewards.earn\')\"></div><div ui-view=\"howitworks\" ng-if=\"$state.is(\'rewards.howitworks\')\"></div><div ui-view=\"terms\" ng-if=\"$state.is(\'rewards.terms\')\"></div><div id=\"rewards-main\" ng-if=\"$state.is(\'rewards\')\"><div class=\"container-fluid\"><div id=\"rewards-main-top-banner\" class=\"row\" ng-style=\"homeBanner\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"rfr-home-banner-title\"><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/home-banner-txt/home-banner-txt\"></ins><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/home-banner-browse-button-lbl/home-banner-browse-button-lbl\"></ins></div></div><div class=\"gap hidden-xs inline-block\"></div><div class=\"inside-container cnt-table col-sm-12 hidden-xs\" ng-class=\"{ \'rfr-single-button\': !user.isAuthenticated }\"><div class=\"wrapper pbl rew-auth-cta\" ng-class=\"{enroll: user.isAuthenticated }\" ng-hide=\"isEnrolled\"><div class=\"cnt-table-col login col-sm-12 text-center\" ng-hide=\"user.isAuthenticated\"><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/home-banner-signin-txt/home-banner-signin-txt\"></ins><a res=\"rfr_home_signin_button\" class=\"btn red\" ui-sref=\"signin\"></a></div><div class=\"login col-sm-6 text-center\" ng-show=\"!isEnrolled && user.isAuthenticated\"><p res=\"rfr_home_signed1_title\" class=\"home-signed-title\"></p><p class=\"title-detail\" res=\"rfr_home_signed1_line1\"></p></div><div class=\"register col-sm-6 text-center\" ng-show=\"!isEnrolled && user.isAuthenticated\"><p res=\"rfr_home_signed2_title\" class=\"home-signed-title\"></p><p class=\"title-detail\" res=\"rfr_home_signed2_line1\"></p></div></div><div class=\"enroll-btn\" ng-show=\"!isEnrolled && user.isAuthenticated\"><a res=\"rfr_home_signed2_button\" class=\"btn red\" ui-sref=\"rewards.enroll\"></a></div></div></div></div></div></div><div class=\"visible-xs\"><div ng-hide=\"user.isAuthenticated\" class=\"container mobile-view-signin-container\"><div class=\"row\"><div class=\"inside-container cnt-table col-sm-12\"><br><br><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/home-banner-signin-txt/home-banner-signin-txt\"></ins><br><a res=\"rfr_home_signin_button\" class=\"btn red\" ui-sref=\"signin\"></a><br><br><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/home-banner-register-txt/home-banner-register-txt\"></ins></div></div></div><div ng-show=\"! isEnrolled && user.isAuthenticated\" class=\"container inside-container mobile-view-signin-container\"><div class=\"row\"><p res=\"rfr_home_signed1_title\" class=\"home-signed-title\"></p><p res=\"rfr_home_signed1_line1\"></p><p res=\"rfr_home_signed2_title\" class=\"home-signed-title\"></p><p res=\"rfr_home_signed2_line1\"></p><div class=\"enroll-btn\"><a res=\"rfr_home_signed2_button\" class=\"btn red\" ui-sref=\"rewards.enroll\"></a></div></div></div></div><ins ng-if=\"user.isAuthenticated && !isEnrolled\" ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/alert-message-enroll/alert-message-enroll\"></ins><ins ng-if=\"user.isAuthenticated && isEnrolled\" ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/alert-message-postsignin/alert-message-postsignin\"></ins><ins ng-if=\"!user.isAuthenticated\" ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/alert-message-presignin/alert-message-presignin\"></ins><div class=\"container rewards-main-cards-container\"><div class=\"row top-picks-header\"><div class=\"col-xs-12 col-sm-8 col-md-6\"><h1 res=\"rfr_home_top_picks\" class=\"rfr-main-heading mrn primary-color pull-left\"></h1>&nbsp;<img ng-hide=\"recommendedRewards.length\" class=\"loading mtl mhm\" width=\"29\" src=\"images/widget-loader.gif\" alt=\"\"><div class=\"learn-more visible-xs pull-right\"><a res=\"rfr_home_see_all_rewards\" class=\"bold\" href=\"#/rewards/browse/\"></a> <i class=\"fa fa-caret-right\"></i></div></div><div class=\"col-sm-4 col-md-6 hidden-xs\"><div class=\"mtl curved-btn-table curved-btn-arrow rewards-see-all\" ng-click=\"$state.go(\'rewards.browse\');\"><div class=\"curved-btn-table-cell pts pbs text-uppercase\"><span res=\"rfr_home_see_all_rewards\"></span></div><div class=\"curved-btn-table-cell pts pbs\"><i class=\"fa fa-caret-right curved-btn-fa pull-right\"></i></div></div></div></div><div ng-show=\"errorCode.errInRewardLoading\" class=\"mvm info-banner error reverse-margin\"><div class=\"row\"><div class=\"sigin-error-icon-ctn col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding\"><span class=\"fa fa-exclamation-circle fa-2x txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\"><span class=\"v-base-line\">Sorry, server returned an error.</span></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 slide-repeater\" ng-repeat=\"reward in recommendedRewards | limitTo:4\"><div bundle-id=\"section-1-bundle-{{$index}}\" reward-card=\"reward\" class=\"reward-card carousel-card\"></div></div></div><div class=\"row how-it-works-header\"><div class=\"col-xs-12\"><div class=\"pull-left\"><h1 res=\"rfr_home_how_it_works\" class=\"rfr-main-heading mrn primary-color\"></h1><a res=\"rfr_home_learn_more\" class=\"bold pll hidden-xs\" ui-sref=\"rewards.howitworks\"></a> <i class=\"fa fa-caret-right hidden-xs\"></i></div><div class=\"learn-more visible-xs pull-right\"><a res=\"rfr_home_learn_more\" class=\"bold\" ui-sref=\"rewards.howitworks\"></a> <i class=\"fa fa-caret-right\"></i></div></div></div><div class=\"row how-it-works\"><div ng-class=\"{\'col-xs-12 col-sm-6 col-lg-3\': !user.isAuthenticated && !isEnrolled,\'col-xs-12 col-sm-4\': user.isAuthenticated && !isEnrolled, \'col-xs-12 col-sm-6\': isEnrolled}\" class=\"step step-3\"><div class=\"num-wrapper\"><div class=\"num\"><div>1</div></div><div class=\"num-text\"><a res=\"rfr_home_how_it_works_3_1\" ng-hide=\"isEnrolled\" ui-sref=\"rewards.howitworks\"></a> <a res=\"rfr_home_how_it_works_3_2\" ng-show=\"isEnrolled\" ui-sref=\"rewards.howitworks\"></a> <i class=\"visible-xs fa fa-caret-right curved-btn-fa\"></i></div></div></div><div ng-class=\"{\'col-xs-12 col-sm-6 col-lg-3\': !user.isAuthenticated && !isEnrolled,\'col-xs-12 col-sm-4\': user.isAuthenticated && !isEnrolled, \'col-xs-12 col-sm-6\': isEnrolled}\" class=\"step step-4\"><div class=\"num-wrapper\"><div class=\"num\"><div>2</div></div><div class=\"num-text\"><a res=\"rfr_home_how_it_works_4_1\" ng-hide=\"isEnrolled\" ui-sref=\"rewards.howitworks\"></a> <a res=\"rfr_home_how_it_works_4_2\" ng-show=\"isEnrolled\" ui-sref=\"rewards.howitworks\"></a> <i class=\"visible-xs fa fa-caret-right curved-btn-fa\"></i></div></div></div></div></div></div><rewards-footer earn-banner=\"homeEarnMore\" lang=\"lang\" split-view=\"{{false}}\"></rewards-footer><div class=\"container-fluid\" ng-if=\"!mobileAppR\"><div class=\"row\"><div class=\"col-xs-12 team-site-footer\" ng-hide=\"user.isAuthenticated\"><div class=\"container\"><ins ute-content-injector=\"\" content-id=\"cms/content/rfr/views/teals-pre-sign-txt/teals-pre-sign-txt\"></ins></div></div><div class=\"col-xs-12 team-site-footer\" ng-show=\"user.isAuthenticated\"><div class=\"container\"><ins ute-content-injector=\"\" content-id=\"cms/content/rfr/views/teals-post-sign-txt/teals-post-sign-txt\"></ins></div></div></div></div></section>");
$templateCache.put("rfr/views/rewards.membership.html","<section class=\"container rewards-section rewards-membership\"><div membership-info=\"\"></div><h3 class=\"rewards-section-heading\" res=\"rewards_my_transactions\"></h3><div transactions-grid=\"\"></div></section>");
$templateCache.put("rfr/views/rewards.redeem.html","<section class=\"container rewards-section rewards-redeem\" ng-show=\"rewardId\"><h1 class=\"visible-xs primary-color\" res=\"redeem\"></h1><a name=\"/rewards/redeem/{{rewardId}}/\" class=\"named-anchor\"></a> <a name=\"/rewards/redeem/{{rewardId}}/confirm\" class=\"named-anchor\"></a><div class=\"row rewards-redeem-details-container\" ng-show=\"rewardId && !stepId\"><span class=\"reward-name col-xs-12\" ng-bind=\"::reward.rewardName\"></span><br><div class=\"reward-tags col-xs-12\"><span ng-show=\"pageLoaded\" res=\"rfr_tags\" class=\"tags-label\"></span> <span class=\"tags-values\" ng-repeat=\"aTag in reward.categoryCodes track by $index\"><a ui-sref=\"{{::getCategoryUrl(aTag)}}\"><span ng-bind=\"::getCategoryName(aTag)\"></span></a> <span>{{$last ? \"\" : \",\"}}</span></span></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-7 reward-card-wrapper\"><img ng-hide=\"pageLoaded\" class=\"loading center-loading\" width=\"29\" src=\"images/widget-loader.gif\" alt=\"\"><div ng-show=\"pageLoaded\" bundle-id=\"redeem-reward-{{$index}}\" reward-card=\"reward\" ng-class=\"{\'redeem-details-card\':$state.includes(\'rewards.redeem\')}\" class=\"reward-card carousel-card\"></div></div><div class=\"col-xs-12 col-sm-5\"><div class=\"rewards-redeem-actions\"><div ng-show=\"pageLoaded\"><div ng-hide=\"loggedInOnly\" sign-in-or-register=\"\"></div></div><div ng-show=\"loggedInOnly\" class=\"col-xs-12 col-sm-8 rewards-redeem-actions-buttons\"><a ng-show=\"canRedeem()\" class=\"cta-round primary medium full rewards-redeem-cta\" res=\"submenu_redeem\" ui-sref=\"rewards.redeem({stepId:\'confirm\', rewardProductId: reward.rewardProductId})\"></a><br><button ng-disabled=\"viewLoader\" ng-show=\"isEnrolled\" ng-click=\"toggleInWishList()\" class=\"cta-round primary full rewards-redeem-wishlist-cta\"><i class=\"rfr-icon rfr-icon-heart-o\" ng-hide=\"reward.inWhishList\"></i> <span res=\"wishlist_cta\" res-param-msg=\"{{wishlistCtaMsg}}\"></span></button> <img ng-show=\"viewLoader\" width=\"29\" src=\"images/widget-loader.gif\" alt=\"\"></div><h4 class=\"col-xs-12 details-header\" res=\"_details\"></h4></div><p class=\"col-xs-12 details-copy\"><span ng-bind-html=\"::getHtmlString(reward.rewardsShortHtml)\"></span> <a class=\"rfr-details-link\" res=\"rfr_more_link\" ng-show=\"toggleLongDescription\" ng-click=\"toggleLongDescription = !toggleLongDescription\"></a></p></div><div class=\"details-copy-long-description col-xs-12\" ng-init=\"toggleLongDescription = true\" collapse=\"toggleLongDescription\" ng-bind-html=\"::getHtmlString(reward.rewardsDescHtml)\"></div></div><a class=\"rfr-details-link\" res=\"rfr_less_link\" ng-hide=\"toggleLongDescription\" ng-click=\"toggleLongDescription = !toggleLongDescription\"></a></div><div class=\"row rewards-redeem-confirm-container\" ng-show=\"rewardId && stepId\"><div section-header=\"\" header-copy=\"redemption_summary\" ng-show=\"stepId ===\'confirm\'\"></div><div section-header=\"\" header-copy=\"redemption_confirm\" ng-show=\"stepId ===\'success\'\"></div><div class=\"row rewards-redeem-success-container\" ng-show=\"rewardId && stepId && stepId===\'success\'\"><div class=\"rewards-redeem-success col-xs-12 col-md-9\"><i class=\"rfr-icon rfr-icon-checkmark\"></i><div class=\"rewards-redeem-success-summary\"><span res=\"rfr_success_copy\"></span><div class=\"hidden-xs\" ng-click=\"printRedeemSuccessSummary()\"><i class=\"rfr-icon rfr-icon-print\"></i><span res=\"_print\"></span></div></div></div></div><div class=\"row rewards-redeem-success-container\" ng-show=\"stepId===\'success\'\"><div class=\"rfr-redeem-next-steps\"><h4 class=\"details-header rfr-redeem-next-steps-title\" res=\"rfr_next_steps\"></h4><div ng-bind-html=\"::reward.confirmationMessage\"></div></div></div><div class=\"rewards-redeem-error-container col-xs-12 info-banner error\" ng-show=\"apiError\"><span class=\"message-banner-icon icon-error\"></span><div class=\"api-error-display\" ng-bind-html=\"apiError\"></div></div><div class=\"redeem-details\"><div class=\"redeem-details-img col-xs-12 col-sm-3\"><img class=\"img-responsive\" ng-src=\"{{imgSrc}}\"></div><div class=\"redeem-details-text col-xs-12 col-sm-6\"><div class=\"details-header\" res=\"rewards_to_be_redeemed\" ng-show=\"stepId === \'confirm\'\"></div><h5 class=\"details-header\" res=\"rewards_redeemed\" ng-show=\"stepId === \'success\'\"></h5><a class=\"text-decoration-no\" href=\"#/rewards/redeem/{{$state.params.rewardId}}\"><h2 class=\"redeem-details-reward-title rfr-flush\" ng-bind=\"::reward.rewardName\"></h2></a><br><div class=\"redeem-details-reward-pts\"><span ng-bind=\"::reward.points | number:0\"></span>&nbsp;<span>pts</span></div><h4 class=\"details-header your-points\" res=\"your_points\"></h4><div><span class=\"details-label\" res=\"points_available\" ng-if=\"stepId !== \'confirm\' && stepId !== \'success\'\"></span> <span class=\"details-label\" res=\"points_available_confirm\" ng-if=\"stepId === \'confirm\' || stepId === \'success\'\"></span> <span class=\"pull-right points-display\">&nbsp;pts</span> <span class=\"pull-right points-display\" ng-bind=\"::currentBalance | number:0\"></span><br><span class=\"details-label\" res=\"points_about_to_redeem\" ng-show=\"stepId===\'confirm\'\"></span> <span class=\"details-label\" res=\"points_redeemed\" ng-show=\"stepId===\'success\'\"></span> <span class=\"pull-right about-to-redeem points-display\">&nbsp;pts</span> <span class=\"pull-right about-to-redeem points-display\" ng-bind=\"\'- \' + (reward.points | number:0)\"></span><br><hr class=\"redeem-balance-line\"><span class=\"details-label balance-after\" res=\"points_balance_after\"></span><span class=\"pull-right points-display\">&nbsp;pts</span><span class=\"pull-right points-display\" ng-bind=\"(currentBalance - reward.points) | number:0\"></span></div></div></div><div ng-include=\"getScenarioTemplate()\"></div><hr class=\"visible-xs\"><div class=\"mvl row\"></div><br><h4 res=\"_terms_conditions\" ng-show=\"stepId ===\'confirm\'\" class=\"rfr-terms-header\"></h4><form name=\"redemptionform\" ng-show=\"stepId ===\'confirm\'\"><div class=\"redeem-terms-conditions\"><div class=\"rfr-terms-conditions-box\"><div class=\"rfr-terms-conditions-text\"><ins ute-content-injector=\"\" language=\"{{lang}}\" content-id=\"cms/content/rfr/views/redeem-tc-txt/redeem-tc-txt\"></ins></div></div><div accept=\"\" ng-show=\"(stepId ===\'confirm\') && isValid()\" data-on-cancel=\"rejectTerms()\" data-on-accept=\"acceptTerms()\" data-is-disabled=\"false\" data-checkbox-text-res=\"linked_acc_discl_accept\" data-accept-text-res=\"rewards_redeem_now\" data-cancel-text-res=\"_cancel\"></div></div><div accept=\"\" ng-show=\"(stepId ===\'confirm\') && !isValid()\" data-on-cancel=\"rejectTerms()\" data-on-accept=\"acceptTerms()\" data-is-disabled=\"true\" data-checkbox-text-res=\"linked_acc_discl_accept\" data-accept-text-res=\"rewards_redeem_now\" data-cancel-text-res=\"_cancel\"></div></form></div></section>");
$templateCache.put("rfr/views/rewards.transactions.html","<a id=\"/rewards/transactions/{{transaction.transactionNo}}/\" style=\"position:absolute;top:-1px;\"></a><section class=\"container rewards-section rewards-transactions\"><h1 class=\"visible-xs primary-color\" res=\"membership_my_transactions\"></h1><div ng-hide=\"transaction\">Missing Transaction Id</div><div class=\"row\" ng-show=\"transaction\"><h3 res=\"rfr_transaction_details\"></h3><span res=\"rfr_transaction_id\"></span>: {{::transaction.transactionNo}}<div class=\"transaction-details-date\" ng-bind=\"transactionDate()\"></div><div class=\"row transaction-details-container\"><div class=\"transaction-details redeem-transaction\" ng-show=\"::showTransactionType(\'R\')\"><div class=\"transaction-reward-name\" ng-bind=\"::transaction.rewardName\"></div><div class=\"transaction-points-display\" ng-class=\"::getPointsClass()\"><span res=\"rfr_redeemed\"></span>&nbsp; <span ng-bind=\"::transaction.points\"></span>&nbsp; <span res=\"rfr_pts\"></span></div><div class=\"transaction-order-details col-xs-12 col-sm-7\"><div class=\"transaction-order-status\" ng-if=\"transaction.rewardOrderStatusName\"><span res=\"rfr_order_status\"></span> <span ng-bind=\"::transaction.rewardOrderStatusName\"></span></div><div class=\"transaction-order-tracking-number\" ng-if=\"transaction.rewardOrderTrackingNumber\"><span res=\"rfr_tracking_number\"></span> <span ng-bind=\"::transaction.rewardOrderTrackingNumber\"></span></div><div class=\"transaction-order-carrier-name\" ng-if=\"transaction.rewardOrderCarrier\"><span res=\"rfr_carrier_name\"></span> <span ng-bind=\"::transaction.rewardOrderCarrier\"></span></div><div class=\"transaction-validity\"><div class=\"transaction-sub-header\" res=\"rfr_transaction_valid\"></div><div ng-bind=\"::getValidityPeriod()\"></div></div><div ng-if=\"transaction.subscriberNumber\" class=\"transaction-devices-list\"><div class=\"transaction-sub-header\" res=\"rfr_transaction_devices_reward_applied_to\"></div><div ng-bind=\"::getTransactionDevicesList()\"></div></div><div ng-if=\"getTransactionAccountsList()\" class=\"transaction-accounts-list\"><div class=\"transaction-sub-header\" res=\"rfr_transaction_account_reward_applied_to\"></div><div ng-bind=\"::getTransactionAccountsList()\"></div></div><div class=\"transaction-details-display\"><div class=\"transaction-sub-header\" res=\"_details\"></div><div ng-bind=\"::transaction.rewardShortDescription\"></div></div></div></div><div class=\"transaction-details points-adjust-transaction col-xs-12 col-sm-6\" ng-show=\"::showTransactionType(\'D\')\"><div class=\"transaction-type-name\" ng-bind=\"::transaction.typeName\"></div><table><tr><th res=\"points_refunded\"></th><th res=\"apply_reward_to\"></th></tr><tr><td ng-bind=\"::transaction.points\"></td><td ng-bind=\"::transaction.accountNumber\"></td></tr></table></div><div class=\"transaction-details earn-transaction col-xs-12 col-sm-6\" ng-show=\"::showTransactionType(\'I\')\"><div class=\"transaction-reward-name\" ng-bind=\"::transaction.rewardName\"></div><table><tr><th res=\"_account_number\"></th><th res=\"membership_points\"></th><th res=\"membership_pending_points\"></th></tr><tr><td ng-bind=\"::transaction.accountNumber\"></td><td ng-bind=\"::transaction.points\"></td><td ng-bind=\"::transaction.pendingPoints\"></td></tr></table><table><tr><th res=\"rfr_transaction_earn_event_name\"></th><th res=\"rfr_transaction_earn_points_type\"></th><th res=\"rfr_transaction_earn_issued_points\"></th></tr><tr ng-repeat=\"businessRule in transaction.businessRules track by $index\" ng-if=\"businessRule.resultingEvent[0].typeCode == \'P\'\"><td ng-bind=\"::businessRule.resultingEvent[0].name\"></td><td ng-bind=\"::businessRule.resultingEvent[0].pointsTypeName\"></td><td ng-bind=\"::businessRule.resultingEvent[0].points\"></td></tr></table></div><div class=\"transaction-details points-transfer-transaction col-xs-12 col-sm-9\" ng-show=\"::showTransactionType(\'T\')\"><div class=\"transaction-type-name\" ng-bind=\"::transaction.typeName\"></div><table><tr><th res=\"rfr_reason\"></th><th res=\"rfr_reason_description\"></th><th res=\"membership_points\"></th><th res=\"rfr_source_membership_id\"></th><th res=\"rfr_target_membership_id\"></th></tr><tr><td ng-bind=\"::transaction.reasonName\"></td><td ng-bind=\"::transaction.reasonDescription\"></td><td ng-bind=\"::transaction.points\"></td><td ng-bind=\"::transaction.sourceMembershipId\"></td><td ng-bind=\"::transaction.targetMembershipId\"></td></tr></table></div><div class=\"transaction-details points-deduction-transaction\" ng-show=\"::showTransactionType(\'L\')\"><div class=\"transaction-type-name\" ng-bind=\"::transaction.typeName\"></div><table><tr><th res=\"deducted_subtype\"></th><th res=\"membership_points\"></th></tr><tr><td ng-bind=\"::transaction.subtypeName\"></td><td ng-bind=\"::transaction.points\"></td></tr></table></div><div class=\"transaction-details refund-transaction\" ng-show=\"::showTransactionType(\'U\')\"><div class=\"transaction-type-name\" ng-bind=\"::transaction.typeName\"></div><table><tr><th res=\"rfr_reason\"></th><th res=\"rfr_reason_description\"></th><th res=\"membership_points\"></th></tr><tr><td ng-bind=\"::transaction.reasonName\"></td><td ng-bind=\"::transaction.reasonDescription\"></td><td ng-bind=\"::transaction.points\"></td></tr></table></div><div class=\"transaction-details manual-adjust-transaction col-xs-12 col-sm-6\" ng-show=\"::showTransactionType(\'M\')\"><div class=\"transaction-type-name\" ng-bind=\"::transaction.typeName\"></div><table><tr><th res=\"rfr_reason\"></th><th res=\"rfr_reason_description\"></th><th res=\"membership_points\"></th></tr><tr><td ng-bind=\"::transaction.reasonName\"></td><td ng-bind=\"::transaction.reasonDescription\"></td><td ng-bind=\"::transaction.points\"></td></tr></table></div></div></div></section>");
$templateCache.put("rfr/views/rewards.wishlist.html","<section class=\"container rewards-section rewards-wishlist\"><a name=\"/rewards/wishlist\" class=\"named-anchor\"></a><h1 class=\"visible-xs primary-color\" res=\"wishlist\"></h1><div class=\"rewards-redeem-error-container col-xs-12 info-banner error\" ng-show=\"apiError\"><span class=\"message-banner-icon icon-error\"></span><div class=\"api-error-display\" ng-bind-html=\"apiError\"></div></div><div infinite-scroll=\"loadMore()\"><div class=\"row\"><img ng-hide=\"wishlist.length >= 0\" class=\"loading\" width=\"29\" src=\"images/widget-loader.gif\" alt=\"\"><div ng-show=\"errorCode.errInWishlistLoading\" class=\"mvm info-banner error reverse-margin\"><div class=\"row\"><div class=\"sigin-error-icon-ctn col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding\"><span class=\"fa fa-exclamation-circle fa-2x txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\"><span class=\"v-base-line\">Sorry, server returned an error.</span></div></div></div><div ng-hide=\"removeFromWishList\" class=\"wishlist-card col-xs-12 col-sm-6 col-md-3 col-lg-3\" ng-repeat=\"reward in wishlist track by reward.rewardProductId | limitTo: lazyLoadLimit | orderBy: \'rewardId\'\"><div bundle-id=\"section-1-bundle-{{$index}}\" reward-card=\"reward\" class=\"reward-card img-responsive\"></div></div></div></div></section>");
$templateCache.put("views/localization/acceptable-use-policy-fr.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><p class=\"tc-heading\">POLITIQUE D\'UTILISATION ACCEPTABLE</p><p>Veuillez présenter toute question ou tout commentaire concernant la présente Politique d\'utilisation acceptable (« <strong>PUA</strong> »), ainsi que vos plaintes pour manquements à la présente Politique d\'utilisation acceptable par des abonnés, à l\'adresse abuse@rogers.com. À moins de mention contraire, « <strong>vous</strong> » et « <strong>votre</strong> » font référence à vous et à toute personne qui utilise le Service par l\'entremise de votre compte.</p><p class=\"tc-headline1\">Introduction</p><p>Lors de l\'utilisation de nos services, de l\'Équipement qui s\'y rattache, de nos installations, de nos réseaux ou de tout produit, contenu, application ou service utilisé en conjonction avec les Services ou l\'Équipement, vous devez respecter toutes les lois en vigueur ainsi que nos politiques, nos règles et nos limites, notamment la présente PUA. La présente Politique d\'utilisation acceptable fait partie intégrante des Modalités de service de Rogers (les « <strong>Modalités</strong> ») qui accompagnent la Politique d’utilisation acceptable. Elle est également disponible sur le site <a href=\"http://www.rogers.com/modalites\">http://www.rogers.com/modalites</a>. À moins de mention contraire définie dans la présente PUA, les termes définis ont la signification qui leur a été donnée dans les Modalités.</p><p><strong>SI VOUS N\'ACCEPTEZ PAS D\'ÊTRE LIÉ PAR LES PRÉSENTES MODALITÉS ET PAR LA PRÉSENTE PUA, TELLES QUE MODIFIÉES DE TEMPS À AUTRE, VOUS DEVREZ IMMÉDIATEMENT CESSER D\'UTILISER LES SERVICES ET AVISER ROGERS QUE VOUS RÉSILIEZ LES SERVICES.</strong></p><p class=\"tc-headline1\">Activités interdites</p><p>Sans limiter la généralité de ce qui précède, vous ne pouvez utiliser (ou permettre à quiconque d\'utiliser) nos Services pour :</p><ol type=\"i\"><li>utiliser, posséder, afficher, télécharger, transmettre, distribuer ou rendre disponible de quelque façon du contenu illégal ou violant des droits d\'auteur ou des droits de propriété intellectuelle d\'autres personnes (tel que décrit plus en détail ci-dessous);</li><li>participer à des activités de sollicitation ou de jeux illégaux;</li><li>tenter d\'utiliser les Services de façon à éviter l\'application des frais d\'utilisation;</li><li>participer à des activités frauduleuses, notamment en se faisant passer pour une autre personne ou entité ou en forgeant la signature numérique ou manuelle d\'une autre personne. C\'est vous qui assumez tous les risques associés à la détermination de l\'appartenance ou non au domaine public de tout matériel;</li><li>accéder à Internet par le biais des Services en utilisant une adresse autre que l\'adresse IP (protocole Internet) que nous vous avons attribuée;</li><li>violer la vie privée d\'une autre personne; recueillir ou enregistrer des données personnelles au sujet des autres utilisateurs; menacer ou harceler une autre personne ou une autre entité;</li><li>accéder à un ordinateur, des logiciels, des données ou tout autre matériel confidentiel, protégé par droit d\'auteur ou par brevet de toute autre personne, sans la connaissance et le consentement d\'une telle personne, ou encore utiliser un outil conçu pour faciliter un tel accès, comme des « <strong>espions de paquets</strong>»;</li><li>télécharger, diffuser, publier, altérer, modifier, transmettre, reproduire ou distribuer de quelque façon que ce soit de l\'information, des logiciels ou d\'autres éléments protégés par droit d\'auteur ou en vertu de droits de propriété ou contractuels (comme une entente de non-divulgation), ou tous travaux dérivés connexes, sans avoir obtenu au préalable la permission du titulaire des droits d\'auteur ou des droits de propriété;</li><li>utiliser, reproduire, distribuer, vendre, revendre ou exploiter les Services ou le contenu que nous offrons ou que vous obtenez en vertu des Services à des fins commerciales;</li><li>copier, distribuer, offrir en sous-licence ou rendre disponible de quelque autre façon un logiciel ou du contenu que nous vous fournissons ou rendu disponible par les Services, à moins d\'avoir obtenu notre autorisation;</li><li>altérer, reproduire ou modifier les Services ou quelque fonction, composante ou élément d\'identification de votre Équipement, comme le numéro de série électronique (NSÉ) ou le code d\'identification d\'équipement sans fil international (IMEI) n\'étant pas destiné à être altéré, reproduit ou modifié;</li><li>restreindre, entraver ou perturber la capacité de quiconque à accéder à Internet, aux Services ou à l\'Équipement utilisés, à les utiliser ou à en profiter pour se raccorder aux Services, ou créer un fardeau inhabituel sur nos réseaux, y compris, sans toutefois s\'y limiter, en diffusant, téléchargeant, transmettant ou rendant disponible de quelque façon que ce soit de l\'information ou des logiciels contenant un virus, un verrou, une clé, une bombe, un ver, un cheval de Troie ou une autre fonction nuisible, contraignante, destructrice ou débilitante; distribuer des courriels de masse non sollicités (« <strong>pourriel</strong> ») ou autres messages; ou générer de quelque autre façon que ce soit un volume de trafic suffisant pour nuire à la capacité des autres à transmettre ou à recevoir de l\'information; ou encore utiliser les Services de façon abusive en liaison avec des forfaits, des options ou des promotions permettant une utilisation illimitée;</li><li>perturber un réseau de dorsale ou un service de réseau, ou restreindre, bloquer, perturber ou entraver de quelque autre façon que ce soit nos transmissions, nos données ou notre capacité à surveiller ou à offrir les Services;</li><li>nuire à un réseau informatique ou à un service de télécommunications d\'un autre utilisateur sur Internet, d\'un système hôte, d\'un fournisseur de service ou d\'un réseau, incluant, sans toutefois s\'y limiter, les attaques par saturation, la surcharge d\'un service, l\'appropriation ou l\'abus des privilèges d\'opérateur (« <strong>piratage</strong>»), ou toute tentative de « <strong>blocage</strong> » d\'un système hôte;</li><li>utiliser les Services à quelque fin autre que des fins personnelles (comme pour la revente des Services, la fourniture d\'un accès Internet ou d\'autres caractéristiques des Services à une tierce personne) ou encore partager ou transférer vos Services à moins d\'avoir obtenu notre consentement explicite à cet effet;</li><li>exploiter un serveur en liaison avec les Services, incluant, sans toutefois s\'y limiter, les serveurs de courriel, de nouvelles, de fichiers, Gopher, Telnet, de clavardage, Web ou autre configuration d\'hôte, la diffusion multimédia continue ou les forums interactifs multiutilisateurs;</li><li>usurper l\'identité d\'une personne ou d\'une entité, y compris celle d’un représentant de Rogers, d’un animateur de forum, d’un guide ou d’un hôte, ou faire des déclarations trompeuses sur les liens qui vous unissent à une personne ou à une entité;</li><li>contrefaire des en-têtes ou manipuler de quelque autre façon que ce soit des éléments d\'identification afin de masquer l\'origine d\'un élément de contenu transmis par le biais des Services; ou</li><li>balayer les ports de l\'ordinateur ou le sans-fil d\'une personne sans le consentement de cette personne, ou utiliser des outils conçus pour favoriser de telles opérations de balayage.</li></ol><p class=\"tc-headline1\">Contenu illégal ou non approprié</p><p>Toute Partie de Rogers se réserve le droit de déplacer, de retirer et de refuser d\'afficher tout élément de contenu, en tout ou en partie, si elle juge, à sa seule discrétion, que ceux-ci sont inacceptables, indésirables ou en contravention avec les Modalités ou la présente PUA. Cela comprend, sans toutefois s’y limiter :</p><ol type=\"i\"><li>le contenu obscène, injurieux ou pornographique;</li><li>les déclarations diffamatoires, frauduleuses ou trompeuses;</li><li>les menaces, l\'intimidation, le langage abusif ou le harcèlement;</li><li>le contenu violant les droits à la vie privée ou les droits de propriété intellectuelle d\'autres personnes;</li><li>le contenu incitant à la haine ou qui en fait la promotion de façon illégale;</li><li>le contenu jugé offensant ou non pertinent de quelque autre façon; ou</li><li>toute transmission représentant ou encourageant une conduite pouvant constituer une infraction criminelle, qui pourrait donner lieu à une poursuite au civil ou qui viole de quelque autre façon une loi, un décret ou un règlement municipal, provincial, fédéral ou international.</li></ol><p>Pour les fins de la présente PUA, « <strong>contenu</strong> » réfère à toutes les formes de communication incluant, sans toutefois s\'y limiter, le texte, les graphiques (y compris les photographies, les illustrations, les images, les dessins, les logos), les programmes exécutables, les enregistrements audiovisuels et les enregistrements audio.</p><p class=\"tc-headline1\">Sécurité</p><p>Tel que stipulé ci-dessus, vous êtes seul responsable de toute mauvaise utilisation des Services, par vous ou par une autre personne ayant accès aux Services au moyen de votre Équipement ou de votre compte. Par conséquent, vous devez prendre des mesures pour vous assurer que personne ne peut avoir un accès non autorisé aux Services par le biais de quelque moyen que ce soit, incluant, sans toutefois s\'y limiter, les réseaux sans fil et les réseaux à fil. Les Services ne peuvent être utilisés pour contourner les mesures de sécurité des autres utilisateurs ou tenter d\'accéder à l\'équipement, aux logiciels ou aux données d\'une autre personne, sans la connaissance et le consentement d\'une telle personne. En outre, les Services ne peuvent être utilisés de quelque façon que ce soit pour se soustraire aux mesures d\'authentification ou de sécurité d\'un système hôte, d\'un réseau ou d\'un compte, y compris, sans toutefois s\'y limiter, pour accéder à des données qui ne vous sont pas destinées, pour faire une ouverture de session sur un serveur ou pour utiliser un serveur ou un compte pour lequel vous n\'avez pas d\'accès expressément autorisé, ou encore pour sonder la vulnérabilité des autres réseaux. L\'utilisation ou la distribution d\'outils pour compromettre la sécurité, comme des programmes de recherche de mots de passe, des outils d\'intrusion, des espions de paquets ou des outils de sondage de réseau, est interdite. Vous ne pouvez pas perturber les Services. Les Services ne peuvent être utilisés non plus pour nuire à un réseau informatique ou à des services de télécommunications offerts à un autre utilisateur, à un serveur ou à un réseau, y compris, sans toutefois s\'y limiter, les attaques de refus de service, l\'engorgement d\'un réseau, la surcharge d\'un service, l\'appropriation ou l\'abus des privilèges d\'opérateur, ou toute tentative de « <strong>blocage</strong> » d\'un système hôte. La transmission ou la dissémination de renseignements ou de logiciels contenant un virus ou une autre fonction nocive est également interdite. Vous êtes seul responsable de la sécurité des dispositifs que vous choisissez de raccorder aux Services, y compris les données qui y sont enregistrées. En particulier, Rogers vous recommande de ne pas activer le partage de fichiers ou d\'imprimante de quelque façon que ce soit. Rogers recommande que tous les fichiers ou les services que vous choisissez de rendre disponibles pour l\'accès à distance soient protégés par un bon mot de passe ou une autre méthode appropriée. Vous acceptez de traiter de façon confidentielle tous les codes d’accès, numéros d’identification personnels et (ou) autres mots de passe que nous vous fournissons pour vous permettre d’utiliser les Services.</p><p class=\"tc-headline1\">Communications non sollicitées</p><p>Comme il est stipulé ci-dessus, les Services ne peuvent être utilisés pour faire parvenir des messages non sollicités, des messages en lots ou des messages commerciaux ou pour transmettre toute autre communication non sollicitée. Ceci comprend, sans toutefois s’y limiter, l’utilisation de dispositifs de composition et d\'annonce automatique (ADAD) pour effectuer des appels téléphoniques et télécopies à des fins de sollicitation, d’envois en lots non sollicités de publicité commerciale, d’annonces d\'information, de demandes de dons de charité, de pétitions et de messages politiques ou religieux. De telles communications peuvent être envoyées uniquement à des personnes qui en ont fait la demande explicite. Les Services ne peuvent être utilisés pour envoyer des messages à toute personne ayant indiqué qu\'elle ne désirait pas recevoir de messages de votre part. Les Services ne peuvent être utilisés pour recueillir des réponses à des courriels non sollicités envoyés à partir de comptes provenant d\'autres serveurs sur Internet ou d\'autres services de courriel qui ne respectent pas la présente Politique d\'utilisation acceptable ou la politique d\'utilisation acceptable d\'un autre fournisseur de service Internet. En outre, les courriels non sollicités ne doivent pas inviter les destinataires à consulter un site Web ou une autre ressource utilisant les Services. La contrefaçon, la modification et le retrait des en-têtes de courriel sont interdits. Vous ne pouvez pas faire référence à un réseau de Rogers (par exemple, en incluant la mention « Organisation : Rogers » dans l\'en-tête de vos messages ou en indiquant une adresse IP appartenant a un réseau de Rogers) dans tout courriel non sollicité, même si ce courriel n\'est pas envoyé par le biais d’un réseau de Rogers. Le « <strong>bombardement de courriel</strong> » est interdit. C\'est-à-dire que vous ne pouvez pas envoyer plusieurs copies d\'un même message ou de messages similaires, ni envoyer de très gros messages ou de très gros fichiers à un destinataire dans le but de perturber un serveur ou un compte. La propagation de chaînes de lettres est également interdite, que le destinataire désire ou non recevoir de tels envois. Rogers n’est pas responsable du réacheminement des courriels envoyés à un compte suspendu ou résilié. De tels courriels seront retournés à l\'expéditeur, ignorés, supprimés ou alors enregistrés temporairement, à la seule discrétion de Rogers.</p><p class=\"tc-headline1\">Services de contenu généré par l\'utilisateur</p><p>Les « <strong>Services de contenu généré par l’utilisateur</strong> » font référence à tout Service qui permet à un utilisateur d’afficher, de télécharger ou de générer du contenu en ligne dans le but de le partager avec un nombre limité ou illimité de destinataires et peut comprendre, sans toutefois s’y limiter, les groupes de discussion, forums en ligne, babillards électroniques, programmes de clavardage, articles wiki, Services de partage de photos, forums de consommateurs, Services de partage de vidéos, carnets et l’hébergement Web.</p><p>Tout accès aux Services de contenu généré par l’utilisateur par l’entremise des Services doit respecter les points suivants :</p><ol type=\"i\"><li>vous devez respecter la charte écrite qui régit les Services de contenu généré par l’utilisateur, les politiques et la liste des questions fréquentes;</li><li>vous pouvez afficher des messages de publicité, de sollicitation ou autres messages commerciaux dans le cadre des Services de contenu généré par l’utilisateur seulement si la charte, les politiques ou la liste des questions fréquentes qui régissent ces services le permettent de façon explicite;</li><li>vous êtes responsable de connaître les politiques relatives aux Services de contenu généré par l’utilisateur avant de les utiliser;</li><li>vous devez vous conformer aux restrictions en matière de volume quotidien, de taille des fichiers et de format de tous les Services de contenu généré par l’utilisateur;</li><li>à moins de mention contraire dans la charte, les politiques ou la liste des questions fréquentes relatives aux Services de contenu généré par l’utilisateur, vous ne pouvez pas contrefaire, modifier ou supprimer quelque information que ce soit d’un Service de contenu généré par l’utilisateur;</li><li>les Parties de Rogers n’ont aucune obligation que ce soit de surveiller le contenu des Services de contenu généré par l’utilisateur et les Parties de Rogers ne peuvent pas être tenues responsables en cas de réclamation, perte, action en justice, procédure, poursuite, responsabilité, dommages, règlements, pénalités, amendes, coûts et dépenses associés de quelque façon que ce soit au contenu de tels Services;</li><li>vous ne pouvez pas utiliser les Services de contenu généré par l’utilisateur pour les « <strong>engorger</strong>», c\'est-à-dire, utiliser l\'application de mesures délibérées et répétitives en succession rapide pour remplir les écrans des autres utilisateurs d\'Internet avec du texte ou autre contenu;</li><li>tout ordinateur ou appareil raccordé par les Services ne peut maintenir plus de deux connexions de clavardage simultanées, et couvre, sans toutefois s’y limiter, l\'utilisation de programmes automatisés, comme des « <strong>robots</strong>» ou des « <strong>clones</strong> ». les programmes automatisés ne peuvent être utilisés lorsque le titulaire du compte n\'est pas présent physiquement à proximité de l\'appareil;</li><li>vous ne pouvez pas utiliser les Services pour envoyer des messages perturbant l\'équipement d\'un autre utilisateur d\'Internet, notamment ses logiciels, son matériel et ses affichages; et</li><li>vous ne pouvez pas contrefaire, modifier ou dissimuler votre identité (autrement que par l\'utilisation d\'un pseudonyme) lors de votre participation aux Services de contenu généré par l’utilisateur.</li></ol><p class=\"tc-headline1\">Bande passante, enregistrement des données et autres limites</p><p>Vous devez respecter les normes de bande passante, d\'enregistrement des données et les autres limites en vigueur pour les Services concernés. Vous devez également vous assurer que vos activités n\'entraînent aucune restriction, limitation ou dégradation indue de l\'utilisation des Services par les autres abonnés, et ne représentent pas (à la seule discrétion de Rogers) un fardeau excessif sur nos réseaux. En outre, vous devez vous assurer que vos activités n\'entraînent pas de restriction, de limitation, de perturbation, de dégradation ou d\'entrave indue à la capacité de Rogers à livrer et à surveiller les Services, et à faire enquête sur les Services, le réseau de base, les nœuds de réseau et (ou) les autres services ou composantes du réseau. Vous ne pouvez pas revendre, partager ou distribuer de quelque autre façon que ce soit les Services ou toute portion de ceux-ci à une tierce partie, à moins d\'avoir obtenu le consentement écrit de Rogers. Par exemple, vous ne pouvez pas offrir un accès Internet à d\'autres au moyen d\'une connexion téléphonique, héberger des comptes regroupés sur Internet, fournir des services de courriel ou des services de nouvelles, ou encore transmettre des fils de presse. Les Services sont des produits destinés au grand public, conçus pour offrir un accès et une utilisation personnels du réseau Internet. Par exemple, les Services n\'offrent pas le type de sécurité, de rendement en amont et de capacité de débit total en aval généralement associés à une utilisation commerciale. Vous ne pouvez pas exploiter un serveur en liaison avec les Services. Vous ne pouvez pas offrir de services de réseau à d\'autres utilisateurs par le biais des Services. En outre, il est interdit d\'exploiter des serveurs de courriel, http, ftp, irc et dhcp, ou encore des forums interactifs multiutilisateurs.</p><p>L’utilisation de vos Services peut être assortie d\'une limite d\'utilisation, telle que définie dans votre Entente de service. Si vous dépassez la limite définie par votre forfait, des frais d\'utilisation supplémentaire pourront être exigés. Consultez <a href=\"http://www.rogers.com/limiteutilisation\">http://www.rogers.com/limiteutilisation</a> pour connaître la limite d’utilisation actuelle de vos Services.</p><p class=\"tc-headline1\">Gestion du réseau</p><p>Nous nous réservons le droit de gérer nos réseaux dans le but d’optimiser leur efficacité au profit de nos abonnés, en prenant notamment des dispositions concernant ce qui suit, sans s’y limiter : limite de débit (vitesse), rejet ou suppression des pourriels ou de tout autre courriel non sollicité, processus antivirus et filtrage des protocoles. Nous pourrons aussi prendre toute autre mesure selon ce que nous jugeons approprié pour assurer à tous les abonnés une expérience sans faille sur notre réseau.<strong></strong>Pour obtenir de plus amples renseignements au sujet de nos pratiques de gestion de réseau, consultez <a href=\"http://www.rogers.com/politiquereseau\">http://www.rogers.com/politiquereseau</a>.</p><p class=\"tc-headline1\">Manquements à la présente Politique d\'utilisation acceptable</p><p>Tel que stipulé dans les Modalités, nous avons le droit, mais non l\'obligation, de surveiller tous les éléments de contenu transmis à l\'aide des Services (à l’exception des Services de transmission de la voix) ou de l\'Équipement, et de faire enquête sur ceux-ci; et d\'accéder au contenu ou à l’information et de les conserver conformément aux Modalités. Nous préférons aviser les abonnés de tout comportement inapproprié pour leur permettre d\'appliquer les mesures correctrices nécessaires. Toutefois, si les Services sont utilisés d\'une façon qui, selon nous et à notre seule discrétion, représente un manquement à la présente Politique d\'utilisation acceptable, toute Partie de Rogers peut prendre des mesures de réaction qu\'elle jugera appropriées. De telles mesures peuvent comprendre, sans toutefois s\'y limiter, le retrait temporaire ou permanent du contenu, l\'annulation des éléments publiés dans les groupes de discussion, le filtrage des transmissions Internet et (ou) la suspension ou la résiliation immédiate de la totalité ou d\'une portion des Services ou de votre compte. Les Parties de Rogers n\'auront aucune responsabilité relativement à de telles mesures de réaction. Les mesures décrites ci-dessus ne sont pas les seuls recours possibles, et les Parties de Rogers peuvent utiliser d\'autres recours légaux ou mesures techniques jugés appropriés. Sur résiliation d\'un compte, toute Partie de Rogers est autorisée à supprimer les fichiers, les programmes, les données et les messages électroniques associés à un tel compte. Notre défaut à faire appliquer la présente Politique d\'utilisation acceptable, pour quelque raison que ce soit, ne doit pas être considéré comme une renonciation de quelque droit que ce soit à le faire par la suite en tout temps. Si une portion de la présente Politique d\'utilisation acceptable s\'avère invalide ou inapplicable, cette portion sera modifiée de façon à être conforme aux lois applicables, de façon aussi fidèle que possible, et les autres portions conserveront leur pleine force et demeureront en vigueur. La présente PUA doit être établie et régie conformément aux dispositions de la loi en vigueur stipulées dans les Modalités.</p><p class=\"tc-headline1\">Plaintes</p><p>Veuillez présenter toute plainte concernant un manquement à la présente Politique d\'utilisation acceptable à l\'adresse abuse@rogers.com ou encore au 1-888-ROGERS1. Les questions ou les plaintes concernant le contenu d\'une tierce partie doivent être adressées au fournisseur de contenu en question.</p><p>MD Rogers Communications inc. © 2007-2015.</p><p>06/10</p>");
$templateCache.put("views/localization/acceptable-use-policy.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><p class=\"tc-heading\">ACCEPTABLE USE POLICY</p><p>Please direct any questions or comments regarding this Acceptable Use Policy (<strong>“AUP”</strong>) and complaints of violations of this AUP by subscribers to <strong>abuse@rogers.com.</strong>Except where otherwise indicated, <strong>“you”</strong>and <strong>“your”</strong>means you and every person who uses the Services through your account.</p><p class=\"tc-headline1\"><strong>Introduction</strong></p><p>When using our services, the Equipment, our facilities or networks and any products, content, applications or services in conjunction with the Services or Equipment, you must comply with all applicable laws, and our policies, rules and limits including this AUP. This AUP supplements and is incorporated into the Rogers Terms of Service (the “<strong>Terms</strong>”), which accompanies this AUP. It is also available at <strong>http://www.rogers.com/terms.</strong>Unless otherwise defined in this AUP, defined terms have the meanings given to them in the Terms. <strong>IF YOU DO NOT AGREE TO BE BOUND BY THE TERMS AND THIS AUP, AS AMENDED FROM TIME TO TIME, YOU SHOULD IMMEDIATELY STOP USING THE SERVICES AND NOTIFY ROGERS THAT YOU ARE TERMINATING THE SERVICES.</strong></p><p class=\"tc-headline1\"><strong>Prohibited Activities</strong></p><p>Without limitation, you may not use (or allow anyone else to use) our Services to:</p><ol type=\"i\"><li>use, possess, post, upload, transmit, disseminate or otherwise make available content that is unlawful or violates the copyright or other intellectual property rights of others (as described in more detail below);</li><li>participate in any illegal soliciting or gaming schemes;</li><li>attempt to use the Services in such a manner so as to avoid incurring charges for usage;</li><li>participate in any fraudulent activities, including impersonating any person or entity or forging anyone else’s digital or manual signature. You assume all risks regarding the determination of whether material is in the public domain;</li><li>access the Internet via the Services using Internet Protocol (IP) addresses other than the IP address(es) assigned to you by us;</li><li>invade another person’s privacy, collect or store personal data about other users, or stalk or harass another person or entity;</li><li>access any computer, software, data or any confidential, copyright-protected or patent-protected material of any other person, without the knowledge and consent of that person, or use any tools designed to facilitate access, such as <strong>“packet sniffers”</strong>;</li><li>upload, post, publish, deface, modify, transmit, reproduce, distribute in any way or otherwise make available information, software or other material protected by copyright or other proprietary or contractual right (such as a non-disclosure agreement) or related derivative works, without obtaining permission of the copyright owner or rightholder;</li><li>use, reproduce, distribute, sell, resell or otherwise exploit the Services or content we provide or which you obtain through the Services for any commercial purposes;</li><li>copy, distribute, sub-license or otherwise make available any software or content we provide or make available to you or which you obtain through the Services, except as authorized by us;</li><li>alter, reproduce, or tamper with the Services or any function, component or identifier of your Equipment, such as the Electronic Serial Number (ESN) or the International Mobile Equipment Identity (IMEI) that is not meant to be altered, reproduced or tampered with;</li><li>restrict, inhibit or interfere with the ability of any person to access, use or enjoy the Internet, the Services or any Equipment used to connect to the Services, or create an unusually large burden on our networks, including, without limitation, posting, uploading, transmitting or otherwise making available information or software containing a virus, lock, key, bomb, worm, Trojan horse or other harmful, limiting, destructive or debilitating feature, distributing mass or unsolicited e-mail (<strong>“spam”</strong>) or other messages, or otherwise generating levels of traffic sufficient to impede others’ ability to send or retrieve information, or to use the Services in an abusive manner in connection with any unlimited packages, options or promotions;</li><li>disrupt any backbone network nodes or network service, or otherwise restrict, inhibit, disrupt or impede our ability to monitor or deliver the Services, any transmissions or data;</li><li>interfere with computer networking or telecommunications service to or from any Internet user, host, provider or network, including, without limitation, denying service attacks, overloading a service, improperly seizing or abusing operator privileges (<strong>“hacking”</strong>), or attempting to <strong>“crash”</strong>a host;</li><li>use the Services for anything other than your own personal purposes (such as reselling the Services, providing Internet access or any other feature of the Services to any third party) or share or transfer your Services without our express consent;</li><li>operate a server in connection with the Services, including, without limitation, mail, news, file, gopher, telnet, chat, Web, or host configuration servers, multimedia streamers or multi-user interactive forums;</li><li>impersonate any person or entity, including, without limitation, a Rogers official, forum leader, guide or host, or falsely state or otherwise misrepresent your affiliation with a person or entity;</li><li>forge headers or otherwise manipulate identifiers in order to disguise the origin of any content transmitted through the Services; or</li><li>port scan a person’s computer or wireless device without that person’s consent, or use any tools designed to facilitate these scans.</li></ol><p class=\"tc-headline1\"><strong>Unlawful or Inappropriate Content</strong></p><p>Any Rogers Party reserves the right to move, remove or refuse to post any content, in whole or in part, that it, in its sole discretion, decide are unacceptable, undesirable or in violation of the Terms or this AUP. This includes, without limitation:</p><ul><li>obscene, profane, pornographic content;</li><li>defamatory, fraudulent or deceptive statements;</li><li>threatening, intimidating, abusive or harassing statements;</li><li>content that violates the privacy rights or intellectual property rights of others;</li><li>content that unlawfully promotes or incites hatred;</li><li>content that is otherwise offensive or objectionable; or</li><li>any transmissions constituting or encouraging conduct that would constitute a criminal offence, give rise to civil liability or otherwise violate any municipal, provincial, federal or international law, order or regulation.</li></ul><p>For purposes of this AUP, <strong>“content”</strong>refers to all forms of communications including, without limitation, text, graphics (including photographs, illustrations, images, drawings, logos), executable programs, audiovisual recordings, and audio recordings.</p><p class=\"tc-headline1\"><strong>Security</strong></p><p>As set out above, you are responsible for any misuse of the Services, by you or by any other person with access to the Services through your Equipment or your account. Therefore, you must take steps to ensure that others do not gain unauthorized access to the Services through any means, including, without limitation, wireless networking and wired networking. The Services may not be used to breach the security of another user or to attempt to gain access to any other person’s equipment, software or data, without the knowledge and consent of such person. Additionally, the Services may not be used in any attempt to circumvent the user authentication or security of any host, network, or account, including, without limitation, accessing data not intended for you, logging into or making use of a server or account you are not expressly authorized to access, or probing the security of other networks. Use or distribution of tools designed for compromising security, such as password guessing programs, cracking tools, packet sniffers or network probing tools, is prohibited. You may not disrupt the Services. The Services also may not be used to interfere with computer networking or telecommunications services to any user, host or network, including, without limitation, denial of service attacks, flooding of a network, overloading a service, improper seizing and abuse of operator privileges and attempts to <strong>“crash”</strong>a host. The transmission or dissemination of any information or software that contains a virus or other harmful feature is also prohibited. You are solely responsible for the security of any device you choose to connect to the Services, including any data stored on that device. In particular, Rogers recommends against enabling file or printer sharing of any sort. Rogers recommends that any files or services you do choose to make available for remote access be protected with a strong password or as otherwise appropriate. You agree to treat as confidential all access codes, personal identification numbers and/or other passwords that we may provide to you for use with the Services.</p><p class=\"tc-headline1\"><strong>Unsolicited Communications</strong></p><p>As set out above, the Services may not be used to send unsolicited, bulk or commercial messages or for any other unsolicited communications. This includes, without limitation, using automatic dialing and announcing devices to or otherwise make unsolicited voice or facsimile calls and bulk mailing of commercial advertising,</p><p>informational announcements, charity requests, petitions for signatures and political or religious messages. Such communications may only be directed to those who have explicitly requested it.</p><p>The Services may not be used to send messages to any individual who has indicated that he/she does not wish to receive messages from you. The Services may not be used to collect responses from unsolicited e-mail messages sent from accounts on other Internet hosts or e-mail services that violate this AUP or the acceptable use policy of any other Internet service provider. Moreover, unsolicited e-mail messages may not direct the recipient to any web site or other resource that uses the Services.</p><p>Forging, altering or removing e-mail headers is prohibited. You may not reference any Rogers network (for example, by including “Organization: Rogers” in the header or by listing an IP address that belongs to a Rogers network) in any unsolicited e-mail even if that e-mail is not sent through a Rogers network. <strong>“Mail bombing”</strong>is prohibited. That is, you may not send numerous copies of the same or substantially similar messages, nor may you send very large messages or files to a recipient with the intent to disrupt a server or account. The propagation of chain letters is similarly prohibited, whether or not the recipient wishes to receive such mailings. Rogers is not responsible for the forwarding of e-mail sent to any account that has been suspended or terminated. Such e-mail will be returned to sender, ignored, deleted, or stored temporarily, at Rogers’ sole discretion.</p><p class=\"tc-headline1\"><strong>User-Generated Content Services</strong></p><p><strong>“User-Generated Content Services”</strong>or <strong>“UGC Services”</strong>refers to any services that allow an end user to post, upload or generate content online to be shared with a limited or unlimited number of recipients and may include, without limitation: newsgroups, online forums, message boards, chat programs, wiki’s, photo sharing services, customer review sites, video sharing services, blogs and web hosting. Any User-Generated Content Services accessed through the Services must be used in accordance with the following:</p><ol type=\"i\"><li>you must comply with the UGC Service’s written charter, policies or FAQs;</li><li>you may only post advertisements, solicitations, or other commercial messages in the UGC Service if that service’s charter, policies or FAQs explicitly permit them;</li><li>you are responsible for determining the policies of the UGC Service before using it;</li><li>you must adhere to daily volume, file size and format restrictions of any UGC Service;</li><li>unless otherwise specified in the UGC Service’s charter, policies or FAQs, you must not forge, alter or remove any information from the UGC Service;</li><li>the Rogers Parties have no obligation to monitor the content of any UGC Service and the Rogers Parties are not liable for any claims, losses, actions, proceedings, suits, liabilities, damages, settlements, penalties, fines, costs and expenses arising out of or relating to the content of any such service;</li><li>you must not use the UGC Service to perform <strong>“flooding”</strong>, which refers to deliberately repeating actions in quick succession in order to fill the screens of other Internet users with text or other content;</li><li>any computer or other device connected through the Services may not maintain more than two simultaneous chat connections including, without limitation, the use of automated programs, such as <strong>“bots”</strong>or <strong>“clones”</strong>. Automated programs may not be used when the account holder is not physically present at the device;</li><li>you must not use the Services to send messages that disrupt another Internet user’s equipment, software, hardware or user display; and</li><li>you must not forge, alter or obscure your identity (other than using a nickname) while participating in the UGC Service.</li></ol><p class=\"tc-headline1\"><strong>Bandwidth, Data Storage and Other Limitations</strong></p><p>You must comply with the then current bandwidth, data storage and other limitations on your applicable Services. You must also ensure that your activity does not improperly restrict, inhibit, or degrade any other subscriber’s use of the Services, nor represent (in the sole judgment of Rogers) an unusually large burden on our networks. In addition, you must ensure that your activity does not improperly restrict, inhibit, disrupt, degrade or impede Rogers’ ability to deliver the Services, and monitor and investigate the Services, backbone, network nodes, and/or other network services or components. You may not resell, share, or otherwise distribute the Services or any portion thereof to any third party without the written consent of Rogers. For example, you cannot provide Internet access to others through a dial up connection, host shell accounts over the Internet, provide e-mail or news service, or send a news feed. The Services are consumer products designed for personal access to and use of the Internet. For example, the Services do not provide the type of security, upstream performance and total downstream throughput capability typically associated with commercial use. You may not run a server in connection with the Services. You may not provide network services to others via the Services. In addition, you are prohibited from running servers for mail, http, ftp, irc, and dhcp, and multi-user interactive forums.</p><p>Your use of the Services may be subject to a usage limit, as set out in your Service Agreement. If you exceed that limit, you may be subject to additional usage charges. See <a href=\"http://www.rogers.com/uselimits\"><strong>http://www.rogers.com/uselimits</strong></a> for the current usage allowance for your Services.</p><p class=\"tc-headline1\"><strong>Network Management</strong></p><p>We reserve the right to manage our networks in order to optimize their efficiency for the benefit of our subscribers, including, without limitation, by way of the following: rate limiting (speed), rejection or removal of spam or otherwise unsolicited bulk e-mail, anti-virus mechanisms, and protocol filtering. We may take any other action we deem appropriate in order to help ensure the integrity of the network experience for all subscribers. For details on our network management practices, visit <a href=\"http://www.rogers.com/networkpolicy\"><strong>http://www.rogers.com/networkpolicy</strong></a>.</p><p class=\"tc-headline1\"><strong>Violation of this Acceptable Use Policy</strong></p><p>As set out in the Terms, we have the right, but not the obligation, to monitor or investigate any content that is transmitted using the Services (other than voice Services) or the Equipment; and to access or preserve content or information in accordance with the Terms. We prefer to advise subscribers of inappropriate behavior and any necessary corrective action. However, if the Services are used in a way that we, in our sole discretion, believe violates this AUP, any of the Rogers Parties may take any responsive actions they deem appropriate. Such actions may include, without limitation, temporary or permanent removal of content, cancellation of newsgroup posts, filtering of Internet transmissions, and/or the immediate suspension or termination of all or any portion of the Services or your account. The Rogers Parties will have no liability for any such responsive actions. The above described actions are not exclusive remedies and the Rogers Parties may take any other legal or technical action deemed appropriate. Upon termination of an account, any of the Rogers Parties are authorized to delete any files, programs, data and e-mail messages associated with such account. The failure to enforce this AUP, for whatever reason, shall not be construed as a waiver of any right to do so at any time. If any portion of this AUP is held invalid or unenforceable, that portion will be construed consistent with applicable law as nearly as possible, and the remaining portions will remain in full force and effect. This AUP shall be exclusively governed by, and construed in accordance with the governing law provision set out in the Terms.</p><p class=\"tc-headline1\"><strong>Complaints</strong></p><p>Please direct any complaints of violations of this AUP to <a href=\"mailto:abuse@rogers.com\"><strong>abuse@rogers.com</strong></a> or contact us at 1-888-ROGERS1. Questions or complaints, concerning third party content should be addressed to the applicable content provider.</p><p>™Rogers Communications Inc. © 2007-2015.</p><p>06/10</p>");
$templateCache.put("views/localization/account-charges-billing-info-fr.html","<div class=\"bold paragraph\">Compte, frais et facturation</div><div class=\"paragraph\"><p>a. Comment Rogers me facture-t-elle mes Services?</p><p>Les frais relatifs aux Services commencent &agrave; vous &ecirc;tre factur&eacute;s &agrave; la Date de mise en service et sont factur&eacute;s &agrave; l&rsquo;avance. &Agrave; moins que Rogers et vous conveniez d&rsquo;un autre arrangement, votre p&eacute;riode de facturation est d&rsquo;une dur&eacute;e d&rsquo;un mois, et se termine &agrave; la date de facturation indiqu&eacute;e au haut de votre facture. Le d&eacute;but de votre p&eacute;riode de facturation ne co&iuml;ncidera pas toujours avec la Date de mise en service initiale. Dans un tel cas, vos frais de Services et votre quota d&rsquo;utilisation seront calcul&eacute;s proportionnellement pour la p&eacute;riode comprise entre votre Date de mise en service et votre date de facturation. Les frais d&rsquo;utilisation, comme les frais d&rsquo;utilisation de donn&eacute;es additionnelles, les frais de temps d&rsquo;antenne, les frais d&rsquo;interurbain, les achats de films ou d&rsquo;&eacute;v&eacute;nements et les frais d&rsquo;itin&eacute;rance, sont factur&eacute;s apr&egrave;s votre utilisation de ces services. Nous pourrons porter des frais &agrave; votre compte jusqu&rsquo;&agrave; <strong>6</strong> mois suivant la date o&ugrave; les frais ont &eacute;t&eacute; engag&eacute;s.</p><p>b. &Agrave; quelle date dois-je payer ma facture? Les frais port&eacute;s &agrave; votre compte sont payables en entier &agrave; la date de votre facture. Si vous payez par la poste ou par l&rsquo;entremise d&rsquo;une institution financi&egrave;re, veuillez pr&eacute;voir des d&eacute;lais suffisants pour que le paiement nous parvienne avant la date d&rsquo;exigibilit&eacute; du paiement. Il vous incombe d&rsquo;acquitter tous les frais imput&eacute;s &agrave; votre compte.</p><p>c. Qu&rsquo;arrive-t-il si je ne paie pas ma facture &agrave; temps?</p><p>Si nous ne recevons pas le montant d&rsquo;une somme due sur votre compte au plus tard &agrave; la date d&rsquo;exigibilit&eacute; pr&eacute;cis&eacute;e, le montant sera soumis &agrave; des frais de paiement en retard de <strong>2 %</strong> par mois, calcul&eacute;s et compos&eacute;s mensuellement sur le montant en souffrance (<strong>26,82 %</strong> par ann&eacute;e) &agrave; compter de la date de la premi&egrave;re facture sur laquelle le montant en souffrance appara&icirc;t, jusqu&rsquo;&agrave; la date de r&eacute;ception d&rsquo;un tel montant au complet. Vous convenez que nous pouvons facturer les montants non pay&eacute;s et en souffrance, y compris les frais de paiement en retard, selon tout mode de paiement pr&eacute;autoris&eacute; li&eacute; &agrave; votre compte (par exemple, en le portant &agrave; votre carte de cr&eacute;dit ou en proc&eacute;dant par retrait direct de votre compte bancaire).</p><p>d. Des frais d&rsquo;administration peuvent-ils m&rsquo;&ecirc;tre factur&eacute;s?</p><p>Nous pourrions imputer des frais d&rsquo;administration &agrave; votre compte, notamment en raison de ce qui suit :</p><p>i. un changement de forfait;<br>ii. un changement de num&eacute;ro de t&eacute;l&eacute;phone (ou de tout autre identifiant);<br>iii.une demande de r&eacute;impression de facture;</p><p><strong>Non applicable aux R&eacute;sidents du Qu&eacute;bec** :</strong></p><p>iv. des efforts de recouvrement &agrave; la suite d&rsquo;un non-paiement;<br>v. des paiements retourn&eacute;s ou refus&eacute;s; et (ou)<br>vi. le r&eacute;tablissement du Service.<br>Vous pouvez obtenir une liste de ces frais sur demande, ou la consulter &agrave; l&rsquo;adresse <a href=\"http://rogers.com/frais\">rogers.com/frais</a>. Cette liste fait partie int&eacute;grante des pr&eacute;sentes Modalit&eacute;s.</p><p>e. Que puis-je faire si je ne comprends pas ou que je veux contester des frais figurant sur ma facture?</p><p>Toute question ou erreur pr&eacute;sum&eacute;e concernant les frais doit nous &ecirc;tre signal&eacute;e dans les <strong>90</strong> jours suivant la date de la facture en question, sans quoi vous &ecirc;tes pr&eacute;sum&eacute; avoir accept&eacute; les frais. Si l&rsquo;imputation des frais &agrave; votre compte &eacute;tait effectivement non autoris&eacute;e ou erron&eacute;e, nous annulerons alors ces frais dans les <strong>30</strong> jours suivant la r&eacute;ception de votre avis signalant l&rsquo;erreur.</p><p>f. Comment s&rsquo;appliquent les rabais et les promotions?</p><p>Nous appliquerons tout rabais, toute promotion ou tout avantage &agrave; votre compte tant que vous y demeurez admissible. Nous pouvons v&eacute;rifier votre admissibilit&eacute; &agrave; ce rabais, &agrave; cette promotion ou &agrave; cet avantage de temps &agrave; autre, et si vous cessez d&rsquo;y &ecirc;tre admissible pour quelque raison que ce soit, nous pouvons l&rsquo;annuler et (ou) faire passer votre Service &agrave; un forfait comparable.</p><p>g. Comment les frais de temps d&rsquo;antenne sans fil local et interurbain sont-ils factur&eacute;s?</p><p>Les frais de temps d&rsquo;antenne local et interurbain sont arrondis &agrave; la minute compl&egrave;te suivante. Des frais minimums d&rsquo;une minute s&rsquo;appliquent &agrave; chaque appel achemin&eacute; (entrant ou sortant). Le temps d&rsquo;antenne pour toute la dur&eacute;e de l&rsquo;appel est factur&eacute; au tarif applicable au d&eacute;but de l&rsquo;appel. Les frais de temps d&rsquo;antenne (plus les frais d&rsquo;interurbain, s&rsquo;il y a lieu) s&rsquo;appliquent aux appels achemin&eacute;s &agrave; partir du moment o&ugrave; vous appuyez sur ENVOYER, jusqu&rsquo;&agrave; ce que vous appuyiez sur FIN, et comprennent le temps de sonnerie. Les frais pour les appels internationaux ou en itin&eacute;rance peuvent vous &ecirc;tre factur&eacute;s, que vous ayez r&eacute;ussi ou non l&rsquo;appel.</p><p>h. Comment Rogers d&eacute;termine-t-elle si j&rsquo;effectue un appel interurbain sans fil?</p><p>Une zone d&rsquo;appels sans fil locaux est une zone o&ugrave; vous pouvez faire et recevoir des appels locaux sans frais d&rsquo;interurbain. Les appels peuvent &ecirc;tre soit locaux, soit interurbains, selon les zones d&rsquo;appels locaux. L&rsquo;endroit o&ugrave; vous vous trouvez au moment de l&rsquo;appel, votre num&eacute;ro de sans-fil et le num&eacute;ro de t&eacute;l&eacute;phone que vous composez sont des &eacute;l&eacute;ments importants pour d&eacute;terminer les zones d&rsquo;appels locaux et le traitement des appels interurbains. Votre &laquo; zone d&rsquo;appels locaux entrants &raquo; est d&eacute;termin&eacute;e par l&rsquo;emplacement g&eacute;ographique associ&eacute; &agrave; votre num&eacute;ro de sans-fil. Tous les appels re&ccedil;us lorsque vous vous trouvez &agrave; l&rsquo;int&eacute;rieur de votre zone d&rsquo;appels locaux entrants sont consid&eacute;r&eacute;s comme des appels locaux. Tous les appels re&ccedil;us lorsque vous vous trouvez &agrave; l&rsquo;ext&eacute;rieur de votre zone d&rsquo;appels locaux entrants sont consid&eacute;r&eacute;s comme des appels interurbains. Votre zone d&rsquo;appels locaux sortants est d&eacute;termin&eacute;e par votre emplacement physique. Si vous composez un num&eacute;ro local lorsque vous vous trouvez dans la zone de ce num&eacute;ro, il s&rsquo;agit d&rsquo;un appel local. Si vous composez un num&eacute;ro &agrave; l&rsquo;ext&eacute;rieur de la zone o&ugrave; vous vous trouvez, il s&rsquo;agit d&rsquo;un appel interurbain. Lorsque vous utilisez le service Renvoi d&rsquo;appel, des frais d&rsquo;interurbain s&rsquo;appliquent lorsque le num&eacute;ro vers lequel vous transf&eacute;rez l&rsquo;appel se trouve &agrave; l&rsquo;ext&eacute;rieur de l&rsquo;emplacement g&eacute;ographique associ&eacute; &agrave; votre num&eacute;ro de sans-fil, et ce, peu importe o&ugrave; vous vous trouvez. Consultez rogers.com/interurbain pour conna&icirc;tre les tarifs interurbains en vigueur.</p><p>i. Comment sont factur&eacute;s les frais d&rsquo;interurbain &agrave; partir de mon num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel, et comment Rogers d&eacute;termine-t-elle si j&rsquo;effectue un appel interurbain &agrave; partir de mon num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel?</p><p>Les frais d&rsquo;interurbain sont arrondis &agrave; la minute compl&egrave;te suivante. Des frais minimums d&rsquo;une minute s&rsquo;appliquent &agrave; chaque appel interurbain que vous effectuez. Pour les appels internationaux, des frais d&rsquo;interurbain peuvent &ecirc;tre factur&eacute;s que l&rsquo;appel soit achemin&eacute; ou non. Pour les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle, les appels peuvent &ecirc;tre soit locaux, soit interurbains, selon les zones d&rsquo;appels locaux, et votre zone d&rsquo;appels locaux d&eacute;pend de votre num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel. Si vous composez un num&eacute;ro qui est un interurbain &agrave; partir de votre num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel, il s&rsquo;agit d&rsquo;un appel interurbain. Lorsque vous utilisez le Renvoi d&rsquo;appel, des frais d&rsquo;interurbain s&rsquo;appliquent lorsque le num&eacute;ro vers lequel vous transf&eacute;rez l&rsquo;appel se trouve &agrave; l&rsquo;ext&eacute;rieur de votre zone d&rsquo;appels locaux.</p></div>");
$templateCache.put("views/localization/account-charges-billing-info.html","<div class=\"bold paragraph\">ACCOUNT, CHARGES AND BILLING INFORMATION</div><div class=\"paragraph\"><p>a. How does Rogers bill me for Services?</p><p>Service charges will start on the Activation Date and are billed in advance. Unless we both agree to a different arrangement, your billing period runs for one month, and ends on the bill date noted on the top of your bill. Your Activation Date and billing period won&rsquo;t always start on the same day. When this happens, your Service charges and allotted usage are pro-rated for the period between your Activation Date and your bill date. Usage charges, such as additional data, airtime, long distance, movie or event purchases and roaming are billed after you use them. We may bill you for a charge up to <strong>6</strong> months from the date the charge was incurred.</p><p>b. When is my bill payment due?</p><p>Charges on your account are due and payable in full from the date of your bill. If you are paying by mail or through a financial institution, please allow adequate time for your payment to reach us before the required payment date. You are responsible for all charges on your account.</p><p>c. What if I don&rsquo;t pay my bill on time?</p><p>If we do not receive payment of an amount due on your account by the specified required payment date, it will be subject to a late payment charge of <strong>2%</strong> per month, calculated and compounded monthly on the outstanding amount (<strong>26.82%</strong> per year) from the date of the first bill on which it appears until the date we receive that amount in full. You agree that we can charge any unpaid and outstanding amount, including any late payment charges, on any pre-authorized payment method on your account (e.g., a credit card or bank account withdrawal).</p><p>d. Will I be subject to any administrative charges?</p><p>We may apply administrative charges in connection with your account, including as a result of the following:</p><p>i. price plan change;<br>ii. phone number (or other identifier) change;<br>iii.bill reprint requests;</p><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong></p><p>iv. collection efforts due to non-payment;<br>v. returned or rejected payments; and/or<br>vi. the restoral of Service.<br>A list of these charges is available on request, or at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/charges\">rogers.com/charges</a>, and forms part of these Terms.</p><p>e. What if I do not understand or disagree with a charge on my bill?</p><p>Any questions or discrepancies regarding charges must be reported to us within <strong>90</strong> days of the date of the applicable bill. Failure to notify us within this time period means that you have accepted those charges. If any of those discrepancies resulted in unauthorized or incorrect charges on your account, then we will reverse those charges within <strong>30</strong> days of receiving notice from you.</p><p>f. How do discounts and promotions work?</p><p>We will apply a discount, promotion or benefit to your account as long as you remain eligible for it. We may check your eligibility from time to time, and if you become ineligible to receive that discount, promotion or benefit for any reason, we may remove it, and/or transfer your Service to a comparable Service plan.</p><p>g. How is wireless local and long distance airtime charged?</p><p>Local and long distance airtime charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed call (made or received). The airtime for the entire call is charged based on the applicable rate at the beginning of the call. Airtime charges (plus long distance, if applicable) apply to completed or answered calls from the moment you press SEND until you press END and includes the ring time. For international calls or while roaming, you may be charged regardless of whether the call is completed.</p><p>h. How does Rogers determine if I&rsquo;m on a long distance wireless call?</p><p>Wireless local calling areas are the areas in which you can make or receive calls without incurring long distance charges. Wireless calls are defined as local or long distance based on local calling areas. Your location at the time of the call, your wireless phone number and the phone number called are all important factors in determining local calling areas and wireless long distance. Your &ldquo;Incoming Local Calling Area&rdquo; is based on the geographical location associated with your wireless number. All calls that you receive while you are in your Incoming Local Calling Area are local. All calls that you receive while you are outside your Incoming Local Calling Area are long distance. Your &ldquo;Outgoing Local Calling Area&rdquo; is determined by your physical location. If you dial a number that is local to your physical location, then it is a local call. If you dial a number that is long distance to your physical location, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside the geographical location associated with your wireless number, regardless of your physical location. Visit rogers.com/longdistance for current long distance rates.</p><p>i. How is home phone long distance calling charged and how does Rogers determine if I&rsquo;m on a long distance home phone call? Long distance charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed long distance call you make. For international calls, you may be charged regardless of whether the call is completed. For home phone Services, calls are defined as local or long distance based on local calling areas, and your local calling area depends on your home phone number. If you dial a number that is long distance to your home phone number, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside your local calling area.</p></div>");
$templateCache.put("views/localization/account-maintenance-agreement-fr.html","<div class=\"bold paragraph\">RENSEIGNEMENTS IMPORTANTS AU SUJET DE VOTRE SERVICE SANS-FIL</div><div class=\"paragraph\">La pr&eacute;sente information s&rsquo;ajoute &agrave; nos Ententes de service avec vous et en fait partie int&eacute;grante. Elle doit &ecirc;tre lue conjointement avec les Modalit&eacute;s de service, la Politique d&rsquo;utilisation acceptable et la Politique de protection de la vie priv&eacute;e de Rogers en vigueur qui vous ont &eacute;t&eacute; fournies et qui sont accessibles sur le site rogers.com (et qui remplacent les Modalit&eacute;s de service, la Politique d&rsquo;utilisation acceptable et la Politique de protection de la vie priv&eacute;e de Rogers qui vous ont &eacute;t&eacute; transmises ant&eacute;rieurement), avec les brochures ou le mat&eacute;riel en ligne de Rogers en vigueur d&eacute;crivant les forfaits, les fonctions, les services ou les produits que vous avez choisis, ainsi qu&rsquo;avec le Guide de l&rsquo;utilisateur de Rogers en vigueur. Tous les nouveaux changements apport&eacute;s &agrave; vos Ententes de service sont indiqu&eacute;s aux pr&eacute;sentes. Tous les autres aspects de vos Ententes de service demeurent les m&ecirc;mes. Vous reconnaissez que tout Service annul&eacute; &agrave; votre demande ne sera peut-&ecirc;tre plus disponible.</div><div class=\"paragraph\"><ol><li>Description des frais<ol><li>Des frais mensuels exig&eacute;s par le gouvernement pour le service d&rsquo;urgence 9-1-1 peuvent s&rsquo;appliquer : 0,62 $ en Saskatchewan, 0,40 $ au Qu&eacute;bec, 0,43 $ en Nouvelle-&Eacute;cosse, 0,53 $ au Nouveau-Brunswick, 0,70 $ &agrave; l&rsquo;&Icirc;le-du-Prince-&Eacute;douard, 0,44 $ en Alberta, et 0,75 $ &agrave; Terre-Neuve-et-Labrador. Toutefois, il n&rsquo;y a aucuns frais de temps d&rsquo;antenne pour les appels au 9-1-1 &agrave; partir d&rsquo;un appareil sans fil de Rogers.</li><li>Lorsqu&rsquo;ils sont exigibles, des frais de r&eacute;cup&eacute;ration des co&ucirc;ts gouvernementaux et r&eacute;glementaires servent &agrave; r&eacute;cup&eacute;rer les frais d&eacute;bours&eacute;s et &agrave; d&eacute;frayer les co&ucirc;ts de la conformit&eacute; aux exigences, aux mandats et aux programmes f&eacute;d&eacute;raux, provinciaux et (ou) municipaux. Ces frais ne sont pas une taxe ou des frais que Rogers doit percevoir de ses clients pour le gouvernement.</li><li>Les frais de temps d\'antenne additionnel, les frais de transmission de donn&eacute;es, les frais d\'interurbain, les frais d\'itin&eacute;rance, les frais &agrave; l\'utilisation et les taxes sont en sus et factur&eacute;s mensuellement, le cas &eacute;ch&eacute;ant. Pour obtenir de plus amples renseignements sur les Services auxquels vous &ecirc;tes abonn&eacute;, veuillez consulter la brochure de Rogers d&eacute;crivant votre forfait ou vos options ou encore le site rogers.com.</li></ol></li><li>Cat&eacute;gories de Services/Ententes de service. Il est entendu que les Services mentionn&eacute;s aux pr&eacute;sentes sont class&eacute;s selon les cat&eacute;gories suivantes :<ol><li>Services &agrave; dur&eacute;e d&eacute;termin&eacute;e. Les Services &agrave; dur&eacute;e d&eacute;termin&eacute;e correspondent aux Services auxquels vous vous abonnez qui comportent une P&eacute;riode d&rsquo;engagement (indiqu&eacute;e ci-dessus), laquelle est associ&eacute;e &agrave; la dur&eacute;e d&rsquo;une Entente de service ou celle d&rsquo;une P&eacute;riode d&rsquo;abonnement au service de transmission de donn&eacute;es. Chaque Service &agrave; dur&eacute;e d&eacute;termin&eacute;e auquel vous vous abonnez constitue une Entente de service distincte avec nous. Nous n&rsquo;augmenterons pas les frais de service mensuels ou le tarif &agrave; la minute pour le temps d&rsquo;antenne local ni ne r&eacute;duirons le nombre de minutes ou le volume de donn&eacute;es compris dans un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e au cours de sa P&eacute;riode d&rsquo;engagement.</li><li>Services mensuels. Les Services mensuels correspondent aux Services auxquels vous vous abonnez de fa&ccedil;on continue, mais qui ne comportent pas de P&eacute;riode d\'engagement. Les Services mensuels sont indiqu&eacute;s ci-dessus comme n&rsquo;&eacute;tant pas associ&eacute;s &agrave; une Entente de service ou &agrave; une P&eacute;riode d&rsquo;abonnement au service de transmission de donn&eacute;es. Chaque Service mensuel auquel vous vous abonnez constitue une Entente de service distincte avec nous. Pour obtenir de plus amples renseignements sur les Services mensuels, notamment les tarifs des services optionnels, veuillez consulter les brochures Rogers &agrave; jour ou encore le site rogers.com. Nous pouvons modifier les Services mensuels conform&eacute;ment aux Modalit&eacute;s de service de Rogers.</li><li>Services factur&eacute;s &agrave; l&rsquo;utilisation. Les Services factur&eacute;s &agrave; l\'utilisation correspondent aux Services que vous obtenez de Rogers et qui sont factur&eacute;s &agrave; l\'utilisation (qu\'ils soient utilis&eacute;s une seule fois ou pendant une p&eacute;riode donn&eacute;e, comme un jour ou une semaine), mais qui ne sont pas utilis&eacute;s de fa&ccedil;on continue. Les Services factur&eacute;s &agrave; l&rsquo;utilisation offerts comprennent notamment les suivants. Pour obtenir de plus amples renseignements sur les Services factur&eacute;s &agrave; l\'utilisation, notamment les tarifs, veuillez consulter les brochures Rogers &agrave; jour ou encore le site rogers.com. Nous pouvons modifier les Services factur&eacute;s &agrave; l\'utilisation conform&eacute;ment aux Modalit&eacute;s de service Rogers.<ol><li>Service en itin&eacute;rance. Des frais d&rsquo;itin&eacute;rance substantiels peuvent vous &ecirc;tre factur&eacute;s si vous utilisez votre appareil &agrave; l&rsquo;ext&eacute;rieur du r&eacute;seau Rogers, m&ecirc;me si l&rsquo;utilisation n&rsquo;est pas intentionnelle. Quand vous utilisez votre sans-fil hors du r&eacute;seau de Rogers, l&rsquo;utilisation est prise en charge par le r&eacute;seau sans-fil d&rsquo;un autre fournisseur. Des frais d\'itin&eacute;rance s\'appliquent pour toute utilisation faite en dehors du r&eacute;seau de Rogers. Une telle utilisation comprend notamment : les appels, les messages texte, photo et vid&eacute;o ainsi que la transmission de donn&eacute;es (notamment l&rsquo;utilisation d&rsquo;applications, du courriel, de la messagerie instantan&eacute;e, de la messagerie vocale visuelle et de la navigation sur Internet). Consultez rogers.com/itinerance pour conna&icirc;tre les tarifs &agrave; l&rsquo;utilisation en itin&eacute;rance en fonction des options et des destinations.</li><li>Service de messagerie texte, photo et vid&eacute;o factur&eacute; &agrave; l&rsquo;utilisation. Le service de messagerie texte, photo et vid&eacute;o sera activ&eacute; sur les appareils compatibles. Des frais &agrave; l&rsquo;utilisation seront factur&eacute;s pour chaque message sortant ou entrant (sauf dans le cas d\'un abonnement &agrave; une option, une offre group&eacute;e, une trousse ou un forfait comprenant le service de messagerie vis&eacute;).Les messages &agrave; tarification additionnelle entrants et sortants (alertes, messages li&eacute;s &agrave; du contenu et &agrave; des promotions) sont factur&eacute;s aux tarifs en vigueur. Des frais d&rsquo;itin&eacute;rance s\'appliquent pour le service en itin&eacute;rance.</li><li>Service de transmission de donn&eacute;es factur&eacute; &agrave; l&rsquo;utilisation. Le service de transmission de donn&eacute;es sera activ&eacute; sur les appareils compatibles. Des frais quotidiens &agrave; l\'utilisation s\'appliqueront (ne s\'appliquent pas dans le cas d\'un abonnement &agrave; un forfait ou &agrave; une option de transmission de donn&eacute;es).Des frais d&rsquo;itin&eacute;rance s\'appliquent pour le service en itin&eacute;rance.</li><li>Service Appel vid&eacute;o factur&eacute; &agrave; l\'utilisation. Le service Appel vid&eacute;o sera activ&eacute; sur les appareils compatibles. Des frais &agrave; l\'utilisation s\'appliqueront pour chaque minute d&rsquo;Appel vid&eacute;o effectu&eacute; et re&ccedil;u. Le temps d&rsquo;antenne et les frais d&rsquo;interurbain ne sont pas inclus. Des frais d&rsquo;itin&eacute;rance s\'appliquent pour le service en itin&eacute;rance.</li><li>Appel en attente et Appel de groupe. Des frais de temps d&rsquo;antenne s&rsquo;appliquent selon votre forfait (plus des frais d&rsquo;interurbain ou d&rsquo;itin&eacute;rance, s&rsquo;il y a lieu).</li><li>Renvoi d&rsquo;appel. Le Renvoi d&rsquo;appel peut &ecirc;tre ajout&eacute; &agrave; votre forfait (si ce service n&rsquo;est pas d&eacute;j&agrave; compris).Le service Renvoi d&rsquo;appel vous permet de transf&eacute;rer votre appel vers un autre num&eacute;ro et comprend 2 500 minutes locales de Renvoi d&rsquo;appel par mois. Les minutes de Renvoi d&rsquo;appel additionnelles sont factur&eacute;es au tarif mentionn&eacute; dans votre forfait ou option (plus des frais d\'interurbain ou d\'itin&eacute;rance, s&rsquo;il y a lieu).</li><li>Messagerie vocale. Des frais de temps d&rsquo;antenne, ou des frais de transmission de donn&eacute;es pour la messagerie vocale visuelle, s&rsquo;appliquent selon votre forfait (plus des frais d&rsquo;interurbain ou d&rsquo;itin&eacute;rance, s&rsquo;il y a lieu).</li><li>Assistance-annuaire 4 1 1. Des frais de service et de temps d&rsquo;antenne s&rsquo;appliquent (plus des frais d&rsquo;interurbain ou d&rsquo;itin&eacute;rance, s\'il y a lieu), et ce, m&ecirc;me si le num&eacute;ro que vous avez demand&eacute; n&rsquo;est pas inscrit dans l&rsquo;annuaire.</li></ol></li></ol></li><li>Calcul de vos frais de d&eacute;classement (applicables uniquement aux Services &agrave; dur&eacute;e d&eacute;termin&eacute;e). Si, pour quelque raison que ce soit, vous changez de forfait pour un forfait de cat&eacute;gorie inf&eacute;rieure pendant votre P&eacute;riode d&rsquo;abonnement, vous pourriez devoir acquitter des frais de d&eacute;classement de forfait. Les frais de d&eacute;classement correspondent &agrave; la diff&eacute;rence entre le B&eacute;n&eacute;fice &eacute;conomique que vous avez re&ccedil;u et le b&eacute;n&eacute;fice &eacute;conomique offert aux termes du forfait de cat&eacute;gorie inf&eacute;rieure que vous choisissez, multipli&eacute;e par le nombre de mois restant &agrave; la dur&eacute;e de votre Entente de service au moment du d&eacute;classement (taxes exigibles en sus). S&rsquo;il y a lieu, le montant des frais de d&eacute;classement indiqu&eacute; &agrave; la rubrique &laquo; D&eacute;classement de forfait &raquo; de votre entente servira &agrave; calculer tous frais de d&eacute;classement applicables. Si nous lan&ccedil;ons de nouvelles cat&eacute;gories de forfaits, ou modifions nos cat&eacute;gories de forfaits existantes, le b&eacute;n&eacute;fice &eacute;conomique offert aux termes de ces nouvelles cat&eacute;gories de forfaits servira &agrave; calculer tous frais de d&eacute;classement applicables. Si vous payez des frais de d&eacute;classement, le B&eacute;n&eacute;fice &eacute;conomique indiqu&eacute; dans votre plus r&eacute;cente entente sera r&eacute;duit d&rsquo;un montant correspondant aux frais de d&eacute;classement pour le calcul de tous Frais de r&eacute;cup&eacute;ration des &eacute;conomies r&eacute;alis&eacute;es sur l&rsquo;appareil.</li><li>R&eacute;siliation et modification<ol><li>G&eacute;n&eacute;ralit&eacute;s. Vous pouvez r&eacute;silier votre Service en tout temps (conform&eacute;ment aux Modalit&eacute;s de service de Rogers), y compris &agrave; la fin de votre P&eacute;riode d\'engagement, ou y apporter des modifications en communiquant avec nous au 1 888 ROGERS1 (1 888 764 3771). Si vous changez d&rsquo;appareil ou modifiez un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, vous pourriez devoir renouveler votre P&eacute;riode d&rsquo;engagement ou conclure avec nous une nouvelle Entente de service pour une nouvelle P&eacute;riode d&rsquo;engagement.</li><li>Prolongation automatique. &Agrave; la fin de votre P&eacute;riode d&rsquo;engagement, votre forfait passera automatiquement &agrave; un abonnement mensuel. Rogers peut communiquer avec vous en tout temps pour vous proposer de renouveler votre forfait. Si vous ne souhaitez pas renouveler votre forfait au moment o&ugrave; Rogers communique avec vous, vous conserverez votre forfait ainsi que votre entente actuels, inchang&eacute;s, jusqu\'&agrave; ce qu\'un changement y soit apport&eacute; ou que l\'abonnement soit r&eacute;sili&eacute; conform&eacute;ment aux modalit&eacute;s de l\'Entente de service r&eacute;gissant ce forfait.</li><li><p>Frais de r&eacute;cup&eacute;ration des &eacute;conomies r&eacute;alis&eacute;es sur l\'appareil (applicables uniquement aux Services &agrave; dur&eacute;e d&eacute;termin&eacute;e pour tout nouvel abonnement souscrit &agrave; partir du 22 janvier 2012). Des Frais de r&eacute;cup&eacute;ration des &eacute;conomies r&eacute;alis&eacute;es sur l\'appareil (FR&Eacute;A) s&rsquo;appliquent si vous avez obtenu un b&eacute;n&eacute;fice &eacute;conomique en acceptant le nouvel abonnement &agrave; dur&eacute;e d&eacute;termin&eacute;e et que, pour quelque raison que ce soit, votre service sans-fil ou votre nouvel abonnement &agrave; dur&eacute;e d&eacute;termin&eacute;e est annul&eacute; avant la fin de votre Entente de service (P&eacute;riode d&rsquo;abonnement). Les FR&Eacute;A correspondent au b&eacute;n&eacute;fice &eacute;conomique multipli&eacute; par le nombre de mois restant &agrave; votre P&eacute;riode d&rsquo;abonnement, divis&eacute; par le nombre total de mois de la P&eacute;riode d&rsquo;abonnement (taxes exigibles en sus). En d&rsquo;autres mots : FR&Eacute;A = B&eacute;n&eacute;fice &eacute;conomique x nombre de mois restant &agrave; votre P&eacute;riode d\'abonnement &divide; nombre total de mois de votre P&eacute;riode d&rsquo;abonnement + taxes exigibles.</p><p>Des Frais de r&eacute;cup&eacute;ration des &eacute;conomies additionnelles r&eacute;alis&eacute;es sur l\'appareil (FR&Eacute;AA) s\'appliquent &eacute;galement si, pour quelque raison que ce soit, votre service de transmission de donn&eacute;es sans-fil ou votre abonnement au service de transmission de donn&eacute;es (P&eacute;riode d\'abonnement au service de transmission de donn&eacute;es) est annul&eacute; avant la fin de votre P&eacute;riode d\'abonnement au service de transmission de donn&eacute;es. Les FR&Eacute;AA sont fond&eacute;s sur le b&eacute;n&eacute;fice &eacute;conomique additionnel que vous avez re&ccedil;u en vous abonnant au service de transmission de donn&eacute;es. Ils sont calcul&eacute;s &agrave; l&rsquo;aide de la formule qui permet de calculer les FR&Eacute;A (en rempla&ccedil;ant le B&eacute;n&eacute;fice &eacute;conomique par le B&eacute;n&eacute;fice &eacute;conomique additionnel et la P&eacute;riode d&rsquo;abonnement par la P&eacute;riode d&rsquo;abonnement au service de transmission de donn&eacute;es) et ils s&rsquo;ajoutent aux FR&Eacute;A payables &agrave; la r&eacute;siliation de votre Entente de service. Si vous &ecirc;tes abonn&eacute; &agrave; un forfait combinant des services voix et donn&eacute;es, les FR&Eacute;A et les FR&Eacute;AA s\'appliquent tous deux.</p></li><li>Frais d&rsquo;annulation de service (applicable uniquement aux Service &agrave; dur&eacute;e d&eacute;termin&eacute;e pour tout nouvel abonnement souscrit entre le 22 janvier 2012 et le 1er d&eacute;cembre 2013). Ne s&rsquo;applique pas aux r&eacute;sidants du Manitoba, aux r&eacute;sidants de Terre-Neuve ayant souscrit un nouvel abonnement &agrave; partir du 27 septembre 2012, aux r&eacute;sidants de la Nouvelle-&Eacute;cosse ayant souscrit un nouvel abonnement &agrave; partir du 1er mai 2013, ni aux r&eacute;sidants du Qu&eacute;bec : Des frais d&rsquo;annulation de service de 12,50 $ par ligne (taxes exigibles en sus) s&rsquo;appliquent si, pour quelque raison que ce soit, votre service sans-fil est annul&eacute; avant l&rsquo;&eacute;ch&eacute;ance de votre P&eacute;riode d&rsquo;abonnement. Ces frais s\'ajoutent aux FR&Eacute;A ou aux FR&Eacute;A et FR&Eacute;AA.</li><li>P&eacute;riode d&rsquo;essai. Rogers peut permettre la r&eacute;siliation de votre Service sans appliquer de FR&Eacute;A dans les conditions suivantes : 1) l&rsquo;appareil est remis avec toutes ses composantes et en son &eacute;tat d&rsquo;origine tel qu&rsquo;il est indiqu&eacute; dans le document Comment retourner votre sans-fil Rogers, inclus avec votre appareil, 2) l\'annulation est demand&eacute;e dans les 15 jours suivant la date de mise en service et 3) votre compte pr&eacute;sente moins de 30 minutes d\'utilisation de temps d\'antenne. Tous les frais engag&eacute;s jusqu\'au moment de l\'annulation du service vous seront factur&eacute;s.</li></ol></li><li>Renseignements sur l&rsquo;appareil<ol><li>Appareils neufs ou remis &agrave; neuf. Sauf indication contraire, votre appareil est neuf.</li><li>Verrouillage de l&rsquo;appareil. Votre appareil est verrouill&eacute; et ne peut &ecirc;tre utilis&eacute; que sur le r&eacute;seau de Rogers ou encore sur ceux exploit&eacute;s par les fournisseurs avec lesquels nous avons conclu une entente d&rsquo;itin&eacute;rance. Si vous tentez de d&eacute;verrouiller votre appareil, celui-ci pourrait devenir inutilisable de mani&egrave;re permanente et vous pourriez, ce faisant, contrevenir &agrave; la licence d&rsquo;utilisation du logiciel de votre appareil. Si vous souhaitez d&eacute;verrouiller votre appareil, les Frais de d&eacute;verrouillage mentionn&eacute;s pr&eacute;c&eacute;demment s&rsquo;appliquent. Si vous avez obtenu un B&eacute;n&eacute;fice &eacute;conomique, nous ne d&eacute;verrouillerons pas votre appareil pendant les 90 premiers jours de votre P&eacute;riode d&rsquo;abonnement.</li><li>Garantie. Veuillez consulter les documents remis avec votre appareil pour obtenir des renseignements d&eacute;taill&eacute;s sur la garantie dont il est assorti, notamment l&rsquo;objet de la garantie, la dur&eacute;e de celle-ci et les modalit&eacute;s de r&eacute;clamation.</li><li>Rabais sur les articles. Tout appareil qui vous est offert &agrave; 0 $ est offert &agrave; titre d&rsquo;article vendu au rabais et non d&rsquo;article gratuit.</li></ol></li><li><ol>D&eacute;p&ocirc;t de garantie<li>Conditions du d&eacute;p&ocirc;t de garantie. Nous pouvons exiger un d&eacute;p&ocirc;t de garantie ou imposer d&rsquo;autres exigences de paiement ou de cr&eacute;dit (par exemple, paiements provisoires, pr&eacute;l&egrave;vements automatiques obligatoires, cartes pr&eacute;autoris&eacute;es ou paiements bancaires) &agrave; tout moment et selon des modalit&eacute;s &eacute;tablies &agrave; notre seule discr&eacute;tion. Tout d&eacute;p&ocirc;t de garantie que vous nous fournissez sera conserv&eacute; pendant au moins 12 mois, sauf si vous mettez fin &agrave; vos Services avant la fin de cette p&eacute;riode. Apr&egrave;s 12 mois, nous pouvons lib&eacute;rer le d&eacute;p&ocirc;t de garantie et l&rsquo;appliquer au solde de votre compte si nous jugeons, &agrave; notre gr&eacute;, que votre historique de paiement est satisfaisant ou que vous r&eacute;pondez aux crit&egrave;res financiers pour le remboursement de votre d&eacute;p&ocirc;t de garantie.</li><li>Int&eacute;r&ecirc;ts sur le d&eacute;p&ocirc;t de garantie. Tout d&eacute;p&ocirc;t de garantie que nous d&eacute;tenons portera int&eacute;r&ecirc;t au taux de financement &agrave; un jour de la Banque du Canada en vigueur &agrave; ce moment major&eacute; d&rsquo;un pour cent, selon le nombre r&eacute;el de jours dans l&rsquo;ann&eacute;e, calcul&eacute; chaque mois. Les int&eacute;r&ecirc;ts seront cumul&eacute;s &agrave; partir de la date &agrave; laquelle nous recevons votre d&eacute;p&ocirc;t de garantie (mais pas avant le moment prescrit par la l&eacute;gislation ou la r&eacute;glementation en vigueur) jusqu&rsquo;&agrave; la date &agrave; laquelle nous vous le remettons.</li><li>Utilisation et remboursement du d&eacute;p&ocirc;t de garantie. Nous pouvons appliquer votre d&eacute;p&ocirc;t de garantie en entier &agrave; votre solde si nous n&rsquo;avons pas re&ccedil;u un paiement d&ucirc; aux termes de votre compte &agrave; la date pr&eacute;vue du paiement. Nous pouvons vous demander de r&eacute;approvisionner le d&eacute;p&ocirc;t de garantie apr&egrave;s une telle utilisation. Nous vous aviserons de toute utilisation d&rsquo;une partie ou de la totalit&eacute; du d&eacute;p&ocirc;t de garantie. Nous vous rembourserons le d&eacute;p&ocirc;t de garantie avec les int&eacute;r&ecirc;ts cumul&eacute;s dans les 30 jours suivant la r&eacute;siliation de vos Services ou lorsque nous jugeons que les conditions du remboursement du d&eacute;p&ocirc;t de garantie sont remplies.</li></ol></li><li>Forfaits Partage. Vous consentez &agrave; ce que, si la ligne principale de votre forfait Partage (selon le cas) est annul&eacute;e et que les autres lignes sont maintenues, l\'une de ces lignes soit automatiquement d&eacute;sign&eacute;e comme la ligne principale et qu\'elle soit factur&eacute;e dans le cadre du m&ecirc;me forfait ou d\'un forfait d&rsquo;une valeur &eacute;quivalente au forfait de la ligne de l&rsquo;abonnement initial. Vous consentez en outre &agrave; ce que, si le nombre de lignes mises en service dans le cadre de votre forfait tombe sous le minimum requis, Rogers effectue le transfert de votre ligne ou de vos lignes restantes vers un forfait ayant une valeur semblable &agrave; celle de votre forfait actuel.</li><li>Facturation du temps d&rsquo;antenne et des appels interurbains<ol><li>Frais de temps d\'antenne. Les frais de temps d\'antenne local et interurbain sont arrondis &agrave; la minute compl&egrave;te suivante. Des frais minimums d&rsquo;une minute s&rsquo;appliquent &agrave; chaque appel achemin&eacute; (entrant ou sortant).Le temps d\'antenne pour toute la dur&eacute;e de l\'appel est factur&eacute; au tarif applicable au d&eacute;but de l\'appel. Les frais de temps d&rsquo;antenne (plus les frais d&rsquo;interurbain, s&rsquo;il y a lieu) s&rsquo;appliquent aux appels achemin&eacute;s &agrave; partir du moment o&ugrave; vous appuyez sur ENVOYER, jusqu&rsquo;&agrave; ce que vous appuyiez sur FIN. Les frais pour les appels internationaux ou en itin&eacute;rance peuvent &ecirc;tre factur&eacute;s &agrave; partir du moment o&ugrave; vous appuyez sur ENVOYER, jusqu\'&agrave; ce que vous appuyez sur FIN, que vous ayez termin&eacute; ou non l\'appel. Les frais de temps d&rsquo;antenne (plus les frais d&rsquo;interurbain, s&rsquo;il y a lieu) s&rsquo;appliquent aux appels entrants re&ccedil;us sur l&rsquo;appareil sans fil jusqu&rsquo;&agrave; ce que vous appuyiez sur FIN. Les frais de temps d\'antenne sont factur&eacute;s d&egrave;s que l\'on appuie sur ENVOYER pour effectuer un appel et comprennent le temps de sonnerie.</li><li>Zone d&rsquo;appels locaux et interurbains. Une zone d&rsquo;appels locaux est une zone o&ugrave; vous pouvez faire et recevoir des appels locaux sans frais d&rsquo;interurbain. Les appels peuvent &ecirc;tre soit locaux, soit interurbains, selon les zones d\'appels locaux. L&rsquo;endroit o&ugrave; vous vous trouvez au moment de l&rsquo;appel, votre num&eacute;ro de sans-fil et le num&eacute;ro de t&eacute;l&eacute;phone que vous composez sont des &eacute;l&eacute;ments importants pour d&eacute;terminer les zones d&rsquo;appels locaux et le traitement des appels interurbains. Votre zone d&rsquo;appels locaux entrants est d&eacute;termin&eacute;e par l\'emplacement g&eacute;ographique associ&eacute; &agrave; votre num&eacute;ro de sans-fil. Tous les appels re&ccedil;us lorsque vous vous trouvez &agrave; l&rsquo;int&eacute;rieur de votre zone d&rsquo;appels locaux entrants sont consid&eacute;r&eacute;s comme des appels locaux. Tous les appels re&ccedil;us lorsque vous vous trouvez &agrave; l&rsquo;ext&eacute;rieur de votre zone d&rsquo;appels locaux entrants sont consid&eacute;r&eacute;s comme des appels interurbains. Votre zone d\'appels locaux sortants est d&eacute;termin&eacute;e par votre emplacement physique. Si vous composez un num&eacute;ro local lorsque vous vous trouvez dans la zone de ce num&eacute;ro, il s&rsquo;agit d&rsquo;un appel local. Si vous composez un num&eacute;ro &agrave; l&rsquo;ext&eacute;rieur de la zone o&ugrave; vous vous trouvez, il s&rsquo;agit d&rsquo;un appel interurbain. Lorsque vous utilisez le service Renvoi d&rsquo;appel, des frais d&rsquo;interurbain s&rsquo;appliquent lorsque le num&eacute;ro vers lequel vous transf&eacute;rez l&rsquo;appel se trouve &agrave; l&rsquo;ext&eacute;rieur de l\'emplacement g&eacute;ographique associ&eacute; &agrave; votre num&eacute;ro de sans-fil, et ce, peu importe o&ugrave; vous vous trouvez. Consultez rogers.com/interurbain pour conna&icirc;tre les tarifs interurbains en vigueur.</li></ol></li><li>Couverture &eacute;tendue (ne s&rsquo;applique pas au service pr&eacute;pay&eacute;). Si vous avez acc&egrave;s &agrave; une couverture &eacute;tendue, cette couverture ne devrait servir qu&rsquo;&agrave; une utilisation limit&eacute;e et occasionnelle, et l&rsquo;essentiel de votre utilisation mensuelle doit s&rsquo;effectuer sur le r&eacute;seau de Rogers. Nous pouvons restreindre ou limiter votre acc&egrave;s &agrave; la couverture &eacute;tendue si l&rsquo;essentiel de votre utilisation mensuelle est effectu&eacute;e dans les zones de la couverture &eacute;tendue, et ce de fa&ccedil;on continue. Lorsque vous utilisez la couverture &eacute;tendue, certains services ou certaines fonctionnalit&eacute;s ne sont pas disponibles ou ne fonctionnent pas pleinement. Pour plus de renseignements sur la disponibilit&eacute; limit&eacute;e de certains services ou de certaines fonctionnalit&eacute;s lorsque vous utilisez la couverture &eacute;tendue, consultez le rogers.com/couverture.</li><li>Documents et ressources suppl&eacute;mentaires<ol><li>Documents connexes. En plus d&rsquo;&ecirc;tre r&eacute;gie par vos Ententes de service, votre utilisation des Services est &eacute;galement r&eacute;gie par les documents connexes suivants, dont vous pouvez obtenir un exemplaire au rogers.com :<ul><li>Modalit&eacute;s de service : Nos Modalit&eacute;s de service r&eacute;gissent votre utilisation de tous les Services de Rogers et expliquent certains de nos droits et obligations l&eacute;gaux respectifs. Les Modalit&eacute;s de service comprennent des renseignements sur la fa&ccedil;on dont nous pouvons apporter des changements &agrave; vos Services et Ententes de service, la facturation des Services, la suspension ou la r&eacute;siliation de vos Services et des d&eacute;tails juridiques sur la limitation de la responsabilit&eacute;, les garanties et l&rsquo;indemnisation.</li><li>Politique d\'utilisation acceptable : Notre Politique d\'utilisation acceptable d&eacute;crit les r&egrave;gles, les politiques et les restrictions que vous devez respecter lorsque vous utilisez les Services. La Politique d\'utilisation acceptable pr&eacute;voit des exemples d&rsquo;activit&eacute;s interdites et de contenu ill&eacute;gal ou inappropri&eacute; et nous donne le droit de retirer du contenu et de suspendre vos Services ou d&rsquo;y mettre fin si vous contrevenez &agrave; la Politique d&rsquo;utilisation acceptable.</li><li>Politique de protection de la vie priv&eacute;e : Notre Politique de protection de la vie priv&eacute;e d&eacute;crit nos politiques relativement &agrave; la cueillette, &agrave; l&rsquo;utilisation et &agrave; la divulgation de vos renseignements personnels. Notre Politique de protection de la vie priv&eacute;e vous informe des raisons pour lesquelles nous recueillons de l&rsquo;information sur nos clients, de la fa&ccedil;on dont nous utilisons et partageons cette information et de la fa&ccedil;on de communiquer avec nous si vous souhaitez obtenir plus de d&eacute;tails sur nos pratiques de traitement des renseignements personnels.</li><li>Guide de l&rsquo;utilisateur : Notre Guide de l&rsquo;utilisateur vous explique la configuration de votre appareil, le fonctionnement de la facturation, la facturation des services voix et donn&eacute;es sans fil, la facturation des services en itin&eacute;rance et des appels interurbains, le fonctionnement du service d&rsquo;assistance 9-1-1 et la gestion de votre compte.</li></ul></li><li>Gestion de votre facture. Pour conna&icirc;tre les outils qui vous aident &agrave; g&eacute;rer votre facture, notamment les notifications sur l&rsquo;utilisation des donn&eacute;es et l&rsquo;itin&eacute;rance, les plafonds de donn&eacute;es et les outils de surveillance de l&rsquo;utilisation, veuillez visiter le rogers.com ou ouvrir une session dans votre compte Mon Rogers pour obtenir des d&eacute;tails sur votre utilisation r&eacute;elle.</li><li>Zone et cartes de couverture de service. Pour en savoir davantage sur notre zone de couverture de service, y compris nos cartes de couverture de service compl&egrave;tes, visitez le rogers.com/couverture.</li><li>Code sur les services sans fil. Pour consulter le Code sur les services sans fil du Conseil de la radiodiffusion et des t&eacute;l&eacute;communications canadiennes (le &laquo; CRTC &raquo;), visitez le site Web du CRTC au http://crtc.gc.ca/fra/info_sht/t13.htm.</li></ol></li></ol></div><div class=\"paragraph\">En concluant la pr&eacute;sente Entente de service ou les pr&eacute;sentes Ententes de service, vous :<ul><li>autorisez Rogers &agrave; recueillir et &agrave; utiliser vos donn&eacute;es de localisation personnelles courantes et historiques associ&eacute;es &agrave; tout appareil que vous utilisez aux termes de la pr&eacute;sente Entente de service ou des pr&eacute;sentes Ententes de service pour vous fournir des services de g&eacute;olocalisation, &eacute;tant entendu que vous pouvez vous d&eacute;sabonner de ces services en tout temps;</li><li>acceptez de recevoir les documents que nous vous fournissons en format &eacute;lectronique.</li></ul></div><div class=\"paragraph\">AMA 1/15</div>");
$templateCache.put("views/localization/account-maintenance-agreement.html","<div class=\"bold paragraph\">IMPORTANT INFORMATION ABOUT YOUR WIRELESS SERVICE</div><div class=\"paragraph\">This information is in addition to and forms part of our Service Agreement(s) with you and must be read in conjunction with the current Rogers Terms of Service, Acceptable Use Policy and Privacy Policy provided to you and posted on rogers.com (and which replace the Rogers Terms of Service, Acceptable Use Policy and Privacy Policy previously provided to you), and any other Rogers brochure or online material describing the plans, features, services and/or products you have selected and the Starting Up Guide that are currently in effect. Any new changes to your Service Agreement(s) are set out herein. All other aspects of your Service Agreement(s) remain the same. You acknowledge that any Services you have removed may no longer be available.</div><div class=\"paragraph\"><ol><li>Fee Descriptions<ol><li>Where applicable, the following monthly government 9-1-1 fees apply: 62&cent; in Saskatchewan, 40&cent; in Qu&eacute;bec, 43&cent; in Nova Scotia, 53&cent; in New Brunswick, 70&cent; in Prince Edward Island, 44&cent; in Alberta, and 75&cent; in Newfoundland and Labrador. However, there is no airtime charge for calls made to 9-1-1 from your Rogers wireless device.</li><li>Where applicable, the Government Regulatory Recovery Fee will be charged to help fund fees, costs and other amounts related to federal, provincial and/or municipal mandates, programs and requirements. This fee is not a tax or charge the government requires Rogers to collect.</li><li>Where applicable, additional airtime, data, long distance, roaming, pay-per-use charges and taxes are extra and billed monthly. For more information on the Services you have subscribed to, please refer to the Rogers brochure describing your plan or add-on, or visit rogers.com.</li></ol></li><li>Categories of Services/Service Agreements. For greater certainty, the Services referenced herein are categorized as follows:<ol><li>Term Services. Term Services means any Services that you subscribe to for a Commitment Period as identified above with a corresponding Service Agreement Term or Data Term. Every Term Service that you subscribe to constitutes a separate Service Agreement with us. We will not increase the monthly service fee or local per-minute airtime rate for, or decrease the amount of minutes or data included with, a Term Service during its Commitment Period.</li><li>Month-to-Month Services. Month-to-Month Services means any Services that you subscribe to on an ongoing basis, but not with a Commitment Period. Month-to-Month Services are identified above without a corresponding Service Agreement Term or Data Term, and every Month-to-Month Service that you subscribe to constitutes a separate Service Agreement with us. For more information on Month-to-Month Services, including rates for such optional services, please refer to the current Rogers brochures or visit rogers.com. We may change Month-to-Month Services in accordance with the Rogers Terms of Service.</li><li>Pay-Per-Use Services. Pay-Per-Use Services means any Services that you receive from Rogers on a per-usage basis (which may be a one-time usage, or usage for a set period of time, such as one day or one week), but not on an ongoing basis. Pay-Per-Use Services available to you include the following. For more information on Pay-Per-Use Services, including rates, please refer to the current Rogers brochures or visit rogers.com. We may change Pay-Per-Use Services in accordance with the Rogers Terms of Service.<ol><li>Roaming. Please note that substantial roaming charges may be incurred if your device is taken outside the Rogers network even if no services are intentionally used. Whenever you travel outside the Rogers network, your usage is routed through the wireless network of another carrier. Usage outside the Rogers network will result in roaming charges. Such usage includes (but is not limited to): calling; text, picture and video messaging; and data usage (including, but not limited to, apps usage, email, instant messaging, visual voicemail and web browsing). Visit rogers.com/roaming for roaming pay-per-use rates, options and destinations.</li><li>Text, Picture and Video Messaging Pay-Per-Use Service. Text, Picture and Video messaging service will be enabled on compatible devices. A pay-per-use fee will apply for each message sent or received (not applicable if you subscribe to an add-on, bundle, pack or plan that includes the relevant messaging). Sent/received premium messages (alerts, messages related to content and promotions) are charged at applicable rates. Roaming charges apply while roaming.</li><li>Pay-Per-Use Data. Data service will be enabled on compatible devices. A daily usage fee will apply (not applicable if you subscribe to a data plan or add-on). Roaming charges apply while roaming.</li><li>Video Calling Pay-Per-Use Service. Video Calling service will be enabled on compatible devices. A pay-per-use fee will apply for each minute of Video Calling placed and received. Airtime and long distance charges are not included. Roaming charges apply while roaming.</li><li>Call Waiting and Group Calling. Airtime charges apply as per your price plan (plus long distance or roaming, if applicable).</li><li>Call Forwarding. Call Forwarding can be added to your plan (if not already included). Call Forwarding allows your call to be forwarded to another number and includes 2,500 local Call Forwarding minutes per month. Additional Call Forwarding minutes are charged at the rate described in your price plan or add-on (plus long distance or roaming, if applicable).</li><li>Voicemail. Airtime charges, or data charges for visual voicemail, apply as per your price plan (plus long distance or roaming, if applicable).</li><li>411 Directory Assistance. A service fee and airtime charges apply (plus long distance or roaming, if applicable), even if the number you have requested is unlisted.</li></ol></li></ol></li><li>Calculating Your Downgrade Fee (applicable to Term Services only). If, for any reason, you downgrade to a lower tier plan category during your Term, you may be charged a price plan downgrade fee. The downgrade fee is calculated as the difference between the Economic Inducement you received and the economic inducement available in the lower tier plan category you are downgrading to, multiplied by the number of months remaining in your Service Agreement Term at the time you downgrade (plus applicable taxes). If applicable, the downgrade amount set out in the “Downgrading Your Plan” section of your agreement will be used to calculate any applicable downgrade fee. If we introduce new plan categories or change our existing plan categories, the economic inducement available in these new plan categories will be used to calculate any applicable downgrade fee. If you pay a downgrade fee, the Economic Inducement set out on your most recent agreement will be reduced by the downgrade fee amount for the purpose of calculating any Device Savings Recovery Fee.</li><li>Termination and Amendment<ol><li>General. You may terminate your Service at any time (in accordance with the Rogers Terms of Service), including at the expiry of any Commitment Period, or make changes to your Service, by contacting us at 1 888 ROGERS1 (764-3771). If you upgrade your device or change a Term Service, you may be required to renew your Commitment Period and/or enter into a new Service Agreement with us for a new Commitment Period.</li><li>Automatic Extension. At the end of your Commitment Period, your plan will automatically default to a month-to-month term. Rogers may contact you at any time to propose a renewal of your plan. If you do not wish to renew your plan when contacted, you will retain your existing plan and your existing agreement with us, unchanged, until those are changed or terminated in accordance with the terms of the Service Agreement governing that plan.</li><li><p>Device Savings Recovery Fee (applicable to Term Services only for any new term entered into on or after January 22, 2012). A Device Savings Recovery Fee (DSRF) applies if you were given an economic inducement when you agreed to your new term, and if, for any reason, your wireless service or your new term is terminated prior to the end of the term of your Service Agreement (Service Agreement Term). The DSRF is equal to the economic inducement multiplied by the number of months remaining in your Service Agreement Term divided by the total number of months of your Service Agreement Term (plus applicable taxes). In other words, DSRF = Economic Inducement x # months left in your Service Agreement Term &divide; Total # months in your Service Agreement Term + applicable taxes.</p><p>An Additional Device Savings Recovery Fee (ADSRF) also applies if, for any reason, your wireless data service, or your data plan\'s commitment term (Data Term), is terminated prior to the end of your Data Term. The ADSRF is based on the additional economic inducement you received for subscribing to your wireless data service, is calculated using the same formula used to calculate the DSRF (but substituting Economic Inducement with Additional Economic Inducement and Service Agreement Term with Data Term), and applies in addition to the DSRF for termination of your Service Agreement. If you subscribe to a plan combining both voice and data services, both the DSRF and the ADSRF apply.</p></li><li>Service Deactivation Fee (applicable to Term Services only for any new term entered into between January 22, 2012 and December 1, 2013). Not applicable to Residents of Manitoba, Residents of Newfoundland for any new term entered into on or after September 27, 2012, Residents of Nova Scotia for any new term entered into on or after May 1, 2013, or Residents of Qu&eacute;bec: A Service Deactivation Fee of $12.50 per line (plus applicable taxes) applies if, for any reason, your wireless service is deactivated prior to the end of your Service Agreement Term. This fee is in addition to any applicable DSRF or DSRF and ADSRF.</li><li>Trial Period. Rogers may allow for the cancellation of your Service without any DSRF with the following conditions: 1) the device is returned in complete and original condition as specified in the document entitled How to Return Your Rogers Wireless Purchase, enclosed with your device and 2) cancellation is requested within 15 days from date of activation and 3) your account has incurred less than 30 minutes of airtime usage. You will be billed for all charges incurred up to the point of deactivation.</li></ol></li><li>Device Information<ol><li>New or Refurbished Devices. Your device is new, unless otherwise indicated.</li><li>Device Locking. Your device is locked and restricted to be used only on the Rogers network, but may also be used on the networks operated by any of the carriers with which we have roaming agreements. If you attempt to unlock your device it may become permanently unusable and may violate the software licence agreement for your device. If you would like to unlock your device, the Device Unlock Fee set out above will apply. If you were given an Economic Inducement, we will not unlock your device within the first 90 days of your Service Agreement Term.</li><li>Warranty. Please see the materials accompanying your device for warranty information and details, including coverage, duration and how you may make a claim under any applicable warranty.</li><li>Rebated Goods. Any device provided to you for $0 is provided as a rebated good and not a free good.</li></ol></li><li><ol>Security Deposit<li>Security Deposit Conditions. We may require you to provide us with a security deposit or impose other payment or credit requirements (e.g., interim payments; mandatory pre-payments; pre-approved card or bank payments) at any time and on such terms as determined in our sole discretion. Any security deposit you provide to us will be kept for a minimum of 12 months, unless your Services are terminated sooner. After 12 months, we may release and apply the security deposit against your account balance if we, in our sole discretion, determine that your payment history has been satisfactory or that you have otherwise met our financial criteria for the return of the security deposit.</li><li>Interest on Security Deposit. You will earn interest on any security deposit held by us, using the Bank of Canada\'s overnight rate in effect at the time, plus one percent, on the basis of the actual number of days in a year, accruing on a monthly basis. Interest is earned starting from the date we collect a security deposit from you (but no earlier than required under applicable legislation or regulation) until the date we return it to you.</li><li>Use and Return of Security Deposit. We may apply your entire security deposit toward your account if payment of an amount due on your account is not received by us by the required payment date specified by us and we may require you to replenish the security deposit after such use. We will notify you upon applying all or part of any security deposit. We will return to you any security deposit with applicable interest within 30 days of termination of your Services or once we have determined that the conditions for returning the security deposit have been met.</li></ol></li><li>Share Plans. You agree that if the main line under your share plan (as applicable) is cancelled leaving additional lines, one of the additional lines will be automatically assigned as the main line and continue on the same plan as, or a plan similar in value to, the plan that the original main line was subscribed to. You further agree that if the number of lines activated under your plan falls below the required minimum, Rogers may migrate your remaining line(s) to another plan similar in value to your current plan.</li><li>How Airtime and Long Distance Calling Are Charged<ol><li>Airtime Charges. Local and long distance airtime charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed call (made or received). The airtime for the entire call is charged based on the applicable rate at the beginning of the call. Airtime charges (plus long distance, if applicable) apply to completed calls from the time you press SEND until you press END. For international calls or while roaming, you may be charged from the time you press SEND until you press END regardless of whether the call is completed. Airtime charges (plus long distance, if applicable) apply to every call you answer on your wireless phone until you press END. Charges will start at the moment the calling party initiates the call by pressing SEND and includes the ring time.</li><li>Local and Long Distance Calling Areas. Local calling areas are the areas in which you can make or receive calls without incurring long distance charges. Calls are defined as local or long distance based on local calling areas. Your location at the time of the call, your wireless phone number and the phone number called are all important factors in determining local calling areas and wireless long distance. Your Incoming Local Calling Area is based on the geographical location associated with your wireless number. All calls that you receive while you are in your Incoming Local Calling Area are local. All calls that you receive while you are outside your Incoming Local Calling Area are long distance. Your Outgoing Local Calling Area is determined by your physical location. If you dial a number that is local to your physical location, then it is a local call. If you dial a number that is long distance to your physical location, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside the geographical location associated with your wireless number, regardless of your physical location. Visit rogers.com/longdistance for current long distance rates.</li></ol></li><li>Extended Coverage (not applicable to prepaid service). If you have access to extended coverage, it is meant for limited and occasional use and the majority of your monthly usage must occur within the Rogers network. We may restrict or limit your access to extended coverage if the majority of your monthly usage occurs within extended coverage areas, on an ongoing basis. While using extended coverage, certain services or features are not available or have limited functionality. For details on limited services or features while using extended coverage, please visit rogers.com/coverage.</li><li>Additional Documents and Resources<ol><li>Related Documents. In addition to your Service Agreement(s), your use of the Services is governed by the following related documents, current copies of which can be accessed at rogers.com:<ul><li>Terms of Service: Our Terms of Service govern your use of all of your Rogers Services and explain some of our respective legal rights and obligations. The Terms of Service include details on how we can make changes to your Services and Service Agreement(s), how you will be charged for Services, how your Services can be suspended or terminated, and legal details on limitation of liability, warranties and indemnification.</li><li>Acceptable Use Policy: Our Acceptable Use Policy sets out the rules, policies and limits you must abide by when using the Services. The Acceptable Use Policy lists examples of prohibited activities and unlawful or inappropriate content and gives us the right to remove content and/or suspend or terminate your Services if you violate the Acceptable Use Policy.</li><li>Privacy Policy: Our Privacy Policy sets out our policies in relation to the collection, use and disclosure of your personal information. Our Privacy Policy provides information on why we collect customer information, how we use and share this information and specifies how to contact us if you would like more information on our personal information handling practices.</li><li>Starting Up Guide: Our Starting Up Guide provides you with information on how to set up your device, how billing works, how wireless voice and data services are charged, how roaming and long distance is charged, how 9-1-1 emergency assistance works and how to manage your account.</li></ul></li><li>Managing Your Bill. For information on tools to help you manage you bill, including notifications on data usage and roaming, data caps and usage monitoring tools, please visit rogers.com or log into your MyRogers account to view details on your actual usage.</li><li>Service Coverage Area and Maps. For information on our service coverage area, including our complete service coverage maps, please visit rogers.com/coverage.</li><li>Wireless Code. For information on the Canadian Radio-television and Telecommunications Commission (CRTC)\'s Wireless Code, please visit the CRTC website at http://crtc.gc.ca/eng/info_sht/t13.htm.</li></ol></li></ol></div><div class=\"paragraph\">By entering into this/these Service Agreement(s), you:<ul><li>authorize Rogers to collect and use your current and historical personal location information associated with any device you use under this/these Service Agreement(s) in order to provide geo-location services to you, with the ability to opt-out of these services at any time.</li><li>agree to receive any Materials we provide to you in electronic format.</li></ul></div><div class=\"paragraph\">AMA 1/15</div>");
$templateCache.put("views/localization/deposit-credit-requirements-fr.html","<div class=\"bold paragraph\">Exigences en mati&egrave;re de d&eacute;p&ocirc;t et de cr&eacute;dit</div><div class=\"paragraph\"><p>Tout d&eacute;p&ocirc;t de garantie que vous nous fournissez sera conserv&eacute; pendant au moins <strong>12</strong> mois, sauf si vous mettez fin &agrave; vos Services avant la fin de cette p&eacute;riode. Apr&egrave;s <strong>12</strong> mois, nous pouvons lib&eacute;rer le d&eacute;p&ocirc;t de garantie et l&rsquo;appliquer au solde de votre compte si nous jugeons que votre historique de paiement est satisfaisant ou que vous r&eacute;pondez aux crit&egrave;res financiers pour le remboursement de votre d&eacute;p&ocirc;t de garantie. Nous pouvons appliquer votre d&eacute;p&ocirc;t de garantie &agrave; votre solde si vous n&rsquo;acquittez pas votre facture, et nous pouvons vous demander de r&eacute;approvisionner le d&eacute;p&ocirc;t de garantie apr&egrave;s une telle utilisation. Nous vous aviserons de toute utilisation d&rsquo;une partie ou de la totalit&eacute; du d&eacute;p&ocirc;t de garantie. Nous vous rembourserons le d&eacute;p&ocirc;t de garantie avec les int&eacute;r&ecirc;ts cumul&eacute;s dans les <strong>30</strong> jours suivant la r&eacute;siliation de vos Services ou lorsque nous jugeons que les conditions du remboursement du d&eacute;p&ocirc;t de garantie sont remplies.</p><p>c. Mon d&eacute;p&ocirc;t de garantie porte-t-il int&eacute;r&ecirc;t?</p><p>Oui, tout d&eacute;p&ocirc;t de garantie que nous d&eacute;tenons portera int&eacute;r&ecirc;t au taux de financement &agrave; un jour de la Banque du Canada en vigueur &agrave; ce moment major&eacute; de <strong>1</strong> pour cent, selon le nombre r&eacute;el de jours dans l&rsquo;ann&eacute;e, calcul&eacute; chaque mois. Les int&eacute;r&ecirc;ts seront cumul&eacute;s &agrave; partir de la date &agrave; laquelle nous recevons votre d&eacute;p&ocirc;t de garantie (mais pas avant le moment prescrit par la l&eacute;gislation ou la r&eacute;glementation en vigueur) jusqu&rsquo;&agrave; la date &agrave; laquelle nous vous le remettons.</p><p>d. Rogers imposera-t-elle une limite de cr&eacute;dit &agrave; mon compte?</p><p>En vous donnant un avis &agrave; cet effet, nous pouvons attribuer ou modifier une limite de cr&eacute;dit &agrave; votre compte, en tout temps. Le Service pourra &ecirc;tre suspendu en tout temps, pour n&rsquo;importe lequel de vos comptes, si votre solde, y compris l&rsquo;utilisation non factur&eacute;e et les frais, les montants et les redressements en attente, d&eacute;passe cette limite. Les frais de service r&eacute;currents continueront de s&rsquo;appliquer pendant toute suspension des Services.</p></div>");
$templateCache.put("views/localization/deposit-credit-requirements.html","<div class=\"bold paragraph\">DEPOSIT AND CREDIT REQUIREMENTS</div><div class=\"paragraph\"><p>a. Does Rogers require security deposits or other payment or credit requirements?</p><p>Yes, we may require a security deposit or impose other payment or credit requirements such as interim payments, mandatory pre-payments, or pre-authorized payments.</p><p>b. How are security deposits used?</p><p>Any security deposit you provide to us will be kept for at least <strong>12</strong> months, unless your Services are cancelled sooner. After <strong>12</strong> months, we may release and apply the security deposit against your account balance if we determine that your payment history has been satisfactory or that you have otherwise met our financial criteria for the return of the security deposit. We may apply your security deposit toward your account if you do not pay your bill and we may require you to replenish the security deposit after use. We will notify you when we apply all or part of any security deposit. We will return to you any security deposit with applicable interest within <strong>30</strong> days of cancellation of your Services or once we have determined that the conditions for returning the security deposit have been met.</p><p>c. Will I earn any interest on security deposits?</p><p>Yes, you will earn interest on your security deposit with us, using the Bank of Canada&rsquo;s overnight rate in effect at the time, plus <strong>1</strong> percent, on the basis of the actual number of days in a year, accruing on a monthly basis. Interest is earned starting from the date we collect a security deposit from you (but no earlier than required under applicable legislation or regulation) until the date we return it to you.</p><p>d. Will Rogers impose a credit limit on my account?</p><p>Upon notice to you, we may assign or change a credit limit on your account at any time. Service may be suspended at any time to any and all of your accounts if your balance, including unbilled usage and pending charges, fees and adjustments, exceeds this limit. Recurring service charges continue to apply during any suspension of Services.</p></div>");
$templateCache.put("views/localization/equipment-fr.html","<div class=\"bold paragraph\">&Eacute;quipement</div><div class=\"paragraph\"><p>a. L&rsquo;&Eacute;quipement est-il neuf ou remis &agrave; neuf?</p><p>Sauf indication contraire, l&rsquo;&Eacute;quipement que vous achetez de nous est neuf. Sauf indication contraire, l&rsquo;&Eacute;quipement que vous louez aupr&egrave;s de nous est remis &agrave; neuf et il est fourni selon la disponibilit&eacute;. Si vous avez achet&eacute; de l&rsquo;&Eacute;quipement aupr&egrave;s de nous et que vous avez obtenu une subvention sur cet &Eacute;quipement qui a fait en sorte que vous avez pay&eacute; <strong>0 $</strong> pour cet &Eacute;quipement, veuillez noter que cet &Eacute;quipement vous est fourni &agrave; rabais et non en tant qu&rsquo;&Eacute;quipement gratuit.</p><p>b. Puis-je rehausser mon &Eacute;quipement?</p><p>Vous pouvez rehausser votre &Eacute;quipement &agrave; tout moment en communiquant avec nous de l&rsquo;une ou l&rsquo;autre des fa&ccedil;ons indiqu&eacute;es au paragraphe 10e) ci-apr&egrave;s. Vous pourriez devoir payer des frais d&rsquo;administration conform&eacute;ment au paragraphe 3d) ci-dessus. Si, aux termes de votre rehaussement d&rsquo;&Eacute;quipement, vous concluez une nouvelle P&eacute;riode d&rsquo;abonnement et r&eacute;siliez de fa&ccedil;on anticip&eacute;e une P&eacute;riode d&rsquo;abonnement existante, vous devrez payer des Frais de r&eacute;siliation anticip&eacute;e. Veuillez noter que si vous souhaitez rehausser votre &Eacute;quipement, vous pourriez &eacute;galement devoir passer &agrave; un Service qui est offert &agrave; ce moment-l&agrave;, et que tout Service ou &Eacute;quipement annul&eacute; &agrave; votre demande pourrait ne plus &ecirc;tre disponible.</p><p>c. Mon &Eacute;quipement est-il verrouill&eacute; ou limit&eacute; aux Services ou au r&eacute;seau de Rogers?</p><p><strong>Pour les Services sans fil :</strong><br>Votre appareil sans fil est verrouill&eacute; et ne peut &ecirc;tre utilis&eacute; que sur le r&eacute;seau de Rogers ou encore sur ceux exploit&eacute;s par les fournisseurs avec lesquels nous avons conclu une entente d&rsquo;itin&eacute;rance. Si vous tentez de d&eacute;verrouiller votre appareil, celui-ci pourrait devenir inutilisable de mani&egrave;re permanente et vous pourriez, ce faisant, contrevenir &agrave; la licence d&rsquo;utilisation du logiciel de votre appareil. Si vous souhaitez d&eacute;verrouiller votre appareil sans fil, les Frais de d&eacute;verrouillage mentionn&eacute;s dans votre entente de service sans fil s&rsquo;appliquent. Si vous avez obtenu une subvention sur votre appareil, nous ne d&eacute;verrouillerons votre appareil qu&rsquo;apr&egrave;s les <strong>90</strong> premiers jours de votre P&eacute;riode d&rsquo;abonnement. Veuillez prendre note que durant les <strong>90</strong> premiers jours suivant la Date de mise en service, si vous &ecirc;tes en itin&eacute;rance &agrave; l&rsquo;ext&eacute;rieur du r&eacute;seau Rogers, votre Service sera restreint et vous ne pourrez pas effectuer d&rsquo;appels sortants vers des destinations autres que celles qui ont un indicatif r&eacute;gional d&rsquo;Am&eacute;rique du Nord (incluant le Canada et les &Eacute;tats-Unis) et &agrave; l&rsquo;endroit o&ugrave; vous vous trouvez lorsque vous effectuez l&rsquo;appel (ne s&rsquo;applique pas au service pr&eacute;pay&eacute;).</p><p><strong>Pour les Services r&eacute;sidentiels :</strong><br>L&rsquo;&Eacute;quipement achet&eacute; ou lou&eacute; ne peut &ecirc;tre utilis&eacute; que dans le cadre des Services de Rogers, &agrave; l&rsquo;adresse de service indiqu&eacute;e dans votre compte. Si vous tentez de modifier l&rsquo;&Eacute;quipement, celui-ci pourrait devenir inutilisable de mani&egrave;re permanente et vous pourriez, ce faisant, contrevenir &agrave; la licence d&rsquo;utilisation du logiciel de l&rsquo;&Eacute;quipement.</p><p>d. Rogers devra-t-elle &eacute;ventuellement avoir acc&egrave;s &agrave; ma propri&eacute;t&eacute;?</p><p>Pour les Services r&eacute;sidentiels, vous nous autorisez, nous et nos repr&eacute;sentants, &agrave; acc&eacute;der &agrave; vos locaux ou &agrave; entrer dans vos locaux, au besoin, &agrave; un moment mutuellement convenu pour l&rsquo;installation, l&rsquo;entretien, l&rsquo;inspection, la r&eacute;paration, le retrait, le remplacement, l&rsquo;examen, la protection, la modification, la mise &agrave; niveau ou l&rsquo;am&eacute;lioration de l&rsquo;exploitation de nos services, de l&rsquo;&Eacute;quipement, de nos installations ou de nos r&eacute;seaux. Si vous r&eacute;siliez un ou plusieurs de vos Services ou comptes, vous nous autorisez, nous et nos repr&eacute;sentants, &agrave; acc&eacute;der &agrave; vos locaux ou &agrave; entrer dans vos locaux pour d&eacute;brancher les Services et retirer l&rsquo;&Eacute;quipement, le cas &eacute;ch&eacute;ant.</p><p>e. Qui est responsable de s&rsquo;assurer que mon &Eacute;quipement est &agrave; jour?</p><p>Il est possible que l&rsquo;&Eacute;quipement et les logiciels qui s&rsquo;y rattachent doivent respecter certaines exigences minimales et &ecirc;tre entretenus d&rsquo;une certaine fa&ccedil;on et &agrave; certains endroits afin d&rsquo;acc&eacute;der aux Services ou pour assurer le bon fonctionnement des Services (par exemple, services 9 1 1). Ces exigences peuvent changer de temps &agrave; autre, et vous &ecirc;tes responsable de la mise &agrave; jour ou de l&rsquo;entretien n&eacute;cessaires de votre &Eacute;quipement et des logiciels pour respecter de telles exigences. Nous pouvons fournir des mises &agrave; jour de logiciels pour l&rsquo;&Eacute;quipement pour les besoins du fonctionnement continu des Services ou de l&rsquo;&Eacute;quipement. De m&ecirc;me, nous pourrions devoir modifier ou d&eacute;sinstaller d&rsquo;anciennes fonctionnalit&eacute;s logicielles afin de fournir de nouvelles fonctionnalit&eacute;s et veiller &agrave; ce que l&rsquo;&Eacute;quipement demeure compatible avec les avanc&eacute;es technologiques. Si votre &Eacute;quipement ou vos logiciels ne sont pas &agrave; jour, nous pourrions ne pas &ecirc;tre en mesure de vous fournir le soutien technique voulu.</p><p>f. Quelles sont mes responsabilit&eacute;s relatives &agrave; l&rsquo;&Eacute;quipement?</p><p>Vous &ecirc;tes le seul responsable :<br>i. de tout acc&egrave;s &agrave; l&rsquo;&Eacute;quipement;<br>ii. de fournir toute connexion suppl&eacute;mentaire, ainsi que le filage interne et l&rsquo;&eacute;quipement du terminal de t&eacute;l&eacute;phonie r&eacute;sidentielle, qui ne sont pas fournis par nous;<br>iii.de la remise en service de votre &eacute;quipement et de vos installations dans la mesure n&eacute;cessaire apr&egrave;s la r&eacute;siliation de vos Services;<br>iv. du maintien de la s&eacute;curit&eacute; et de la confidentialit&eacute; de vos biens et de vos transmissions par l&rsquo;entremise des Services, de l&rsquo;&Eacute;quipement, de nos installations ou de nos r&eacute;seaux;<br>v. de la protection contre les manquements &agrave; la s&eacute;curit&eacute; ou &agrave; la confidentialit&eacute; ou contre les autres risques associ&eacute;s &agrave; l&rsquo;installation, &agrave; l&rsquo;utilisation, au maintien ou au changement des Services ou de l&rsquo;&Eacute;quipement;<br>vi. de vous assurer qu&rsquo;il n&rsquo;existe aucun branchement non autoris&eacute; &agrave; l&rsquo;&Eacute;quipement ou &agrave; notre c&acirc;ble (par exemple, pour l&rsquo;&Eacute;quipement de t&eacute;l&eacute;vision, une (1) seule t&eacute;l&eacute;vision peut &ecirc;tre raccord&eacute;e &agrave; une prise).<br></p><p>Sauf en ce qui concerne l&rsquo;&Eacute;quipement que vous avez pay&eacute; en entier, tout l&rsquo;&Eacute;quipement que nous installons ou que nous vous fournissons demeure notre propri&eacute;t&eacute;. En ce qui concerne tout l&rsquo;&Eacute;quipement dont nous sommes propri&eacute;taires, vous devez :</p><p>i. en prendre un soin raisonnable;<br>ii. ne pas le vendre, le louer, l&rsquo;hypoth&eacute;quer, le transf&eacute;rer, le c&eacute;der ou le grever de quelque fa&ccedil;on que ce soit;<br>iii.ne pas le d&eacute;m&eacute;nager sans notre connaissance et notre permission;<br>iv. nous le retourner &agrave; vos propres frais advenant la r&eacute;siliation des Services auxquels l&rsquo;&Eacute;quipement est rattach&eacute;.</p><p>Si notre &Eacute;quipement est perdu, endommag&eacute;, vol&eacute;, vendu, lou&eacute;, hypoth&eacute;qu&eacute;, transf&eacute;r&eacute;, c&eacute;d&eacute; ou grev&eacute;, ou qu&rsquo;il ne nous est pas retourn&eacute;, vous devez nous en avertir imm&eacute;diatement. Vous convenez de nous payer la valeur au d&eacute;tail non escompt&eacute;e d&rsquo;un tel &Eacute;quipement, ainsi que tous les frais encourus par nous pour reprendre possession d&rsquo;un tel &Eacute;quipement.</p></div>");
$templateCache.put("views/localization/equipment.html","<div class=\"bold paragraph\">EQUIPMENT</div><div class=\"paragraph\"><p>a. Is Equipment new or refurbished?</p><p>Equipment that you purchase from us is new, unless otherwise indicated. Equipment that you rent from us is refurbished, unless otherwise indicated, and is based on availability. If you have purchased Equipment from us and have received a subsidy on that Equipment resulting in a charge of <strong>$0</strong>, please note that that Equipment has been provided to you as a subsidized good and not a free good.</p><p>b. May I upgrade my Equipment?</p><p>You may upgrade your Equipment at any time by contacting us in any of the ways set out in Section 10(e) below. You may be subject to an administrative charge in accordance with Section 3(d) above. If, in connection with your Equipment upgrade, you are subscribing to a new Term and cancelling a previous Term early, you will be charged an Early Cancellation Fee. Please note that if you wish to upgrade your Equipment, you may also be required to change to a Service that is currently available in market. Also please note that any Service or Equipment you remove may no longer be available.</p><p>c. Is my Equipment locked or restricted to the Rogers network or Services?</p><p><strong>For wireless Services:</strong><br>Your wireless device is locked and restricted to be used only on the Rogers network, but may also be used on the networks operated by any of the carriers with which we have roaming agreements. If you attempt to unlock your device it may become permanently unusable and may violate the software licence agreement for your device. If you would like to unlock your wireless device, the Device Unlock Fee set out in your wireless service agreement will apply. If you were given a device subsidy, we will only unlock your device after the first <strong>90</strong> days of your Term. Please also note that for the first <strong>90</strong> days following the Activation Date, if you are roaming off the Rogers network, your Service will be restricted from placing outgoing calls to destinations other than those that have a North American area code (including Canada and the USA) and the destination at which are located while placing the call (not applicable to prepaid service).</p><p><strong>For residential Services:</strong><br>Purchased and rental Equipment are to be used only with Rogers Services at the service address identified on your account. If you attempt to tamper with any Equipment, it may become permanently unusable and may violate the software licence agreement for that Equipment.</p><p>d. Will Rogers ever need access to my property?</p><p>For residential Services, you authorize us and our representatives to enter or have access to your premises as necessary at mutually agreed upon times to install, maintain, inspect, repair, remove, replace, investigate, protect, modify, upgrade or improve the operation of our services, the Equipment or our facilities or networks. If any of your Services or accounts have been cancelled, then you authorize us and our representatives to enter or have access to your premises to disconnect the Services and remove our Equipment, as applicable.</p><p>e. Who is responsible for ensuring that my Equipment is up to date?</p><p>Equipment and related software may have to meet certain minimum requirements and be maintained in certain ways and in certain locations in order to access the Services or for the proper operation of the Services (e.g., 9-1-1 services). Those requirements may change from time to time and you are responsible for updating or maintaining your Equipment and software as necessary to meet those requirements. We may provide software updates for the Equipment for the continued operation of the Services or the Equipment. Likewise, from time to time we may have to modify or remove previous software features in order to introduce new features to ensure that the Equipment remains compatible with technological advancements. If your Equipment or software is not up to date, we may not be able to provide you with applicable customer support.</p><p>f. What are my responsibilities relating to the Equipment?</p><p>You are solely responsible for:</p><p>i. any access to the Equipment;<br>ii. providing any additional connections, as well as inside wiring and home phone terminal equipment, that are not provided by us;<br>iii.reconnecting any of your equipment and facilities as necessary after cancellation of your Services;<br>iv. maintaining the security and privacy of your property and your transmissions using the Services, the Equipment or our facilities or networks;<br>v. protecting against any breaches of security or privacy or other risks involved in installing, using, maintaining or changing the Services or the Equipment; and<br>vi. ensuring that there are no unauthorized attachments to the Equipment or our cable ( e.g., for television Equipment, only <strong>1</strong> television may be attached to any outlet).</p><p>Except for Equipment that you have fully paid for, all Equipment we install or provide to you remains our property. For all Equipment we own, you must:</p><p>i. take reasonable care of it;<br>ii. not sell, lease, mortgage, transfer, assign or encumber it;<br>iii.not re-locate it without our knowledge and permission; and<br>iv. return it to us at your own expense upon cancellation of the Services to which the Equipment is related.<br>If our Equipment is lost, damaged, stolen, sold, leased, mortgaged, transferred, assigned, encumbered or not returned, you must immediately notify us. You agree to pay us the undiscounted retail value of that Equipment, together with any costs we incur in seeking possession of it.</p></div>");
$templateCache.put("views/localization/general-fr.html","<div class=\"bold paragraph\">Dispositions g&eacute;n&eacute;rales</div><div class=\"paragraph\"><p>a. Comment puis-je r&eacute;soudre une plainte ou un diff&eacute;rend avec Rogers?</p><p>Si vous avez une plainte ou une pr&eacute;occupation non r&eacute;solue, nous vous invitons &agrave; remplir et &agrave; soumettre un formulaire Signaler un probl&egrave;me (que vous trouverez &agrave; l&rsquo;adresse <a href=\"http://www.rogers.com/contacteznous\">rogers.com/contacteznous</a>). Nous vous r&eacute;pondrons le jour ouvrable suivant. Si vous n&rsquo;&ecirc;tes pas satisfait de la fa&ccedil;on dont un membre de notre direction a r&eacute;solu votre plainte, vous avez &eacute;galement la possibilit&eacute; de vous adresser au Bureau du President ou directement au bureau de l&rsquo;Ombudsman.</p><p><strong>Non applicable aux R&eacute;sidents du Qu&eacute;bec** : Dans les limites maximales permises par la loi applicable</strong>, &agrave; moins d&rsquo;un accord de notre part, toute r&eacute;clamation ou tout diff&eacute;rend, de nature contractuelle ou d&eacute;lictuelle, en vertu de la loi ou d&rsquo;un r&egrave;glement, ou toute autre r&eacute;clamation ou tout autre diff&eacute;rend, de nature pr&eacute;existante, pr&eacute;sente ou future, d&eacute;coulant de quelque fa&ccedil;on des &eacute;l&eacute;ments suivants ou s&rsquo;y rapportant, sera r&eacute;gl&eacute; par arbitrage final et liant les parties, &agrave; l&rsquo;exclusion des tribunaux :</p><p>i. une Entente;<br>ii. les Services ou l&rsquo;&Eacute;quipement;<br>iii.les d&eacute;clarations verbales ou &eacute;crites, la publicit&eacute; ou les promotions associ&eacute;es &agrave; une Entente, aux Services ou &agrave; l&rsquo;&Eacute;quipement; ou<br>iv. la relation d&eacute;coulant d&rsquo;une Entente.</p><p><strong>Le cas &eacute;ch&eacute;ant</strong>, l&rsquo;arbitrage sera men&eacute; dans la province o&ugrave; vous habitez et sera simplifi&eacute; et men&eacute; de fa&ccedil;on exp&eacute;ditive par <strong>UN</strong> arbitre conform&eacute;ment aux lois et r&egrave;glements en vigueur ayant trait &agrave; l&rsquo;arbitrage commercial dans la province ou dans l&rsquo;administration o&ugrave; vous habitez &agrave; la date de l&rsquo;avis. Rogers paiera tous les frais raisonnables associ&eacute;s &agrave; cet arbitrage. Tout arbitrage sera men&eacute; conform&eacute;ment &agrave; notre Protocole d&rsquo;arbitrage, lequel est disponible &agrave; l&rsquo;adresse <a href=\"\">rogers.com/modalites</a>.</p><p>b. Qu&rsquo;arrive-t-il si une partie d&rsquo;une Entente devient inex&eacute;cutoire ou cesse de s&rsquo;appliquer?</p><p>Si une portion d&rsquo;une Entente est inex&eacute;cutoire, ses autres dispositions demeurent pleinement en vigueur. Notre d&eacute;faut &agrave; faire appliquer de fa&ccedil;on stricte une des dispositions d&rsquo;une Entente ne constitue pas une renonciation &agrave; quelque disposition ou &agrave; quelque droit que ce soit &agrave; l&rsquo;&eacute;gard de la pr&eacute;sente Entente. Ni le cours des affaires entre nous ni les pratiques commerciales ne pourront &ecirc;tre invoqu&eacute;s pour modifier quelque disposition que ce soit d&rsquo;une Entente.</p><p>c. Comment puis-je obtenir une version en anglais des pr&eacute;sentes Modalit&eacute;s?</p><p>Si vous souhaitez obtenir une version en anglais des pr&eacute;sentes Modalit&eacute;s, consultez le site Web &agrave; l&rsquo;adresse <a href=\"http://rogers.com/terms\">rogers.com/terms</a> ou demandez-en une copie en magasin.</p><p>d. Quelles lois s&rsquo;appliquent aux pr&eacute;sentes Modalit&eacute;s et aux autres parties de mon Entente?</p><p>Chaque Entente est r&eacute;gie exclusivement par les lois de la province o&ugrave; se situe votre adresse de facturation, et vous reconnaissez et acceptez la comp&eacute;tence exclusive des tribunaux de cette province. Toutefois, si votre adresse de facturation est situ&eacute;e &agrave; l&rsquo;ext&eacute;rieur du Canada, cette Entente sera r&eacute;gie exclusivement par les lois de la province d&rsquo;Ontario, et vous reconnaissez et acceptez la comp&eacute;tence des tribunaux de l&rsquo;Ontario. <strong>Veuillez noter que vos droits et recours peuvent varier selon chaque province</strong>.</p><p>e. Comment puis-je communiquer avec Rogers?</p><p>Pour communiquer avec nous :</p><p>i. rendez-vous dans un magasin Rogers;<br>ii. composez le 1 888 ROGERS-1 (1-888-764-3771) ou, &agrave; partir de votre sans-fil Rogers, composez *611 (cet appel est sans frais);<br>iii.visitez le <a href=\"http://rogers.com/contacteznous\">rogers.com/contacteznous</a> pour clavarder en direct;<br>iv. envoyer une t&eacute;l&eacute;copie au num&eacute;ro 1-800-219-6473; ou<br>v. &eacute;crivez au Service &agrave; la client&egrave;le de Rogers, &agrave; l&rsquo;adresse au 100, rue Westmorland, Moncton (Nouveau-Brunswick) E1C 0G1.</p><p>Tout avis de r&eacute;clamation doit &ecirc;tre transmis au Service juridique de Rogers, 333, rue Bloor Est, Toronto (ON) M4W 1G9, et cet avis sera r&eacute;put&eacute; avoir &eacute;t&eacute; donn&eacute; &agrave; la date &agrave; laquelle il est envoy&eacute; par l&rsquo;exp&eacute;diteur.</p><p>* <strong>&laquo; R&eacute;sidents de Terre-Neuve-et-Labrador &raquo;</strong> d&eacute;signe les r&eacute;sidents de Terre-Neuve-et-Labrador qui concluent une Entente &agrave; laquelle s&rsquo;applique la loi intitul&eacute;e <i>Consumer Protection and Business Practices Act</i> (Terre-Neuve-et-Labrador);<br>** <strong>&laquo; R&eacute;sidents du Qu&eacute;bec &raquo;</strong> d&eacute;signe les r&eacute;sidents du Qu&eacute;bec qui concluent une Entente &agrave; laquelle s&rsquo;applique la <i>Loi sur la protection du consommateur</i> (Qu&eacute;bec).</p><p>&copy;2015 06/15</p></div>");
$templateCache.put("views/localization/general.html","<div class=\"bold paragraph\">GENERAL</div><div class=\"paragraph\"><p>a. How can I resolve a complaint or dispute with Rogers?</p><p>If you have a concern that was not resolved, then we invite you to submit a Share a Concern form (located at <a href=\"http://www.rogers.com/contactus\">rogers.com/contactus</a>) and we\'ll respond within <strong>1</strong> business day. If you\'re not satisfied with the resolution by one of our management team members, then you also have the option to speak to our Office of the President or even directly with the Ombudsman office.</p><p><strong>Not applicable to Residents of Qu&eacute;bec**: To the extent permitted by applicable law</strong>, unless we agree otherwise, any claim or dispute, whether in contract or tort, under statute or regulation, or otherwise, and whether pre-existing, present or future, arising out of or relating to the following items will be determined by final and binding arbitration to the exclusion of the courts:</p><p>i. an Agreement;<br>ii. the Services or Equipment;<br>iii.oral or written statements, advertisements or promotions relating to an Agreement, the Services or Equipment; or<br>iv. the relationships that result from an Agreement.</p><p><strong>Where applicable</strong>, arbitration will be conducted in the province in which you reside, on a simplified and expedited basis by <strong>1</strong> arbitrator under the current laws and rules relating to commercial arbitration in the province or jurisdiction in which you reside on the date of the notice. Rogers will pay all reasonable costs associated with that arbitration. Any arbitration will be conducted in accordance with our Arbitration Protocol, which is available at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/terms\">rogers.com/terms</a>.</p><p>b. What happens if part of an Agreement becomes unenforceable or doesn\'t apply?</p><p>If any portion of an Agreement is unenforceable, the remaining provisions continue in full force. Our failure to enforce strict performance of any provision of an Agreement does not mean we have waived any provision or right. Neither the course of conduct between us nor trade practice modifies any provision of an Agreement.</p><p>c. What if I would prefer to have a copy of these Terms in French?</p><p>These Terms have been drawn up in the English language at the express request of the parties. Les pr&eacute;sentes modalit&eacute;s ont &eacute;t&eacute; r&eacute;dig&eacute;es en anglais &agrave; la demande expresse des parties. If you would like a copy of these Terms in French, please visit <a href=\"http://www.rogers.com/modalites\">rogers.com/modalit&eacute;s</a>, or request a copy in store.</p><p>d. What laws apply to these Terms and the rest of my Agreement?</p><p>Each Agreement is governed exclusively by the laws of the province in which your billing address is located and you submit to the exclusive jurisdiction of the courts of that province. However, if your billing address is outside of Canada, that Agreement is governed exclusively by the laws of the province of Ontario and you submit to the jurisdiction of the courts of Ontario. <strong>Please note that your rights and remedies may vary by province</strong>.</p><p>e. How can I contact Rogers?</p><p>To contact us:</p><p>i. visit a Rogers store;<br>ii. call 1-888-ROGERS1 (1-888-764-3771) or, from your Rogers wireless phone, call *611 (it\'s a free call);<br>iii.go online at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/contactus\">rogers.com/contactus</a> to use our live chat;<br>iv. send a fax to 1-800-219-6473; or<br>v. write to Rogers Customer Care, 100 Westmorland Street, Moncton, NB E1C 0G1.</p><p>Any notice of a claim must be given to the Rogers Legal Department, 333 Bloor Street East, Toronto, ON M4W 1G9 and will be deemed to have been given on the date on which it was sent by the party giving the notice.</p><p>* <strong>\"Residents of Newfoundland\"</strong> means residents of Newfoundland and Labrador who enter into an Agreement to which the <i>Consumer Protection and Business Practices Act</i> (Newfoundland and Labrador) applies.<br>** <strong>\"Residents of Qu&eacute;bec\"</strong> means residents of Qu&eacute;bec who enter into an Agreement to which the <i>Consumer Protection Act</i> (Qu&eacute;bec) applies.</p><p>&copy;2015 06/15</p></div>");
$templateCache.put("views/localization/intro-fr.html","<div class=\"bold paragraph\">INTRODUCTION</div><div class=\"paragraph\"><p>a. Comment les Modalit&eacute;s de service Rogers s&rsquo;appliquent-elles &agrave; moi?</p><p>Les pr&eacute;sentes Modalit&eacute;s de service Rogers (les &laquo; Modalit&eacute;s &raquo;) r&eacute;gissent votre utilisation :</p><p>i. des services de Rogers auxquels vous vous abonnez ou que vous achetez aux termes d&rsquo;une entente de service, ou que vous recevez de Rogers ou par son interm&eacute;diaire, y compris les services sans fil et les services r&eacute;sidentiels (les &laquo; Services &raquo;);<br>ii. de tout appareil ou &eacute;quipement dont vous vous servez pour acc&eacute;der aux Services ou que vous utilisez avec les Services (l&rsquo;&laquo; &Eacute;quipement &raquo;).<br>Dans les pr&eacute;sentes Modalit&eacute;s, les expressions &laquo; Rogers &raquo;, &laquo; nous &raquo;, &laquo; nos &raquo; et &laquo; notre &raquo; renvoient &agrave; l&rsquo;entit&eacute; de Rogers dont le nom figure dans l&rsquo;entente de service r&eacute;gissant le Service en particulier auquel vous vous abonnez. Les pr&eacute;sentes Modalit&eacute;s ne s&rsquo;appliquent pas aux services offerts par Rogers M&eacute;dia Inc. ou ses filiales.<br></p><p>b. Comment les Modalit&eacute;s de service Rogers r&eacute;gissent-elles mon entente de service et les autres documents qui me sont fournis?</p><p>Les pr&eacute;sentes Modalit&eacute;s s&rsquo;appliquent conjointement avec les documents suivants pour former ensemble votre entente compl&egrave;te (l&rsquo;&laquo; Entente &raquo;) avec nous, et contiennent des renseignements importants dont vous avez besoin pour bien comprendre vos Services :</p><p>i. Votre entente de service r&eacute;gissant le Service en particulier auquel vous vous abonnez (comme une entente de service sans fil ou une entente de service r&eacute;sidentiel).<br>ii. Notre Politique d&rsquo;utilisation acceptable, qui d&eacute;crit les r&egrave;gles, les politiques et les restrictions que vous devez respecter lorsque vous utilisez les Services. Notre Politique d&rsquo;utilisation acceptable pr&eacute;voit des exemples d&rsquo;activit&eacute;s interdites et de contenu ill&eacute;gal ou inappropri&eacute; et nous donne le droit de retirer du contenu et de suspendre vos Services ou d&rsquo;y mettre fin si vous contrevenez &agrave; la Politique.<br>iii. Notre Politique de protection de la vie priv&eacute;e, qui d&eacute;crit nos politiques relativement &agrave; la cueillette, &agrave; l&rsquo;utilisation et &agrave; la divulgation de vos renseignements personnels. Notre Politique de protection de la vie priv&eacute;e vous informe des raisons pour lesquelles nous recueillons de l&rsquo;information sur nos clients, de la fa&ccedil;on dont nous utilisons et partageons cette information et de la fa&ccedil;on de communiquer avec nous si vous souhaitez obtenir plus de d&eacute;tails sur nos pratiques de traitement des renseignements personnels.<br>iv. toutes modalit&eacute;s et conditions suppl&eacute;mentaires pouvant s&rsquo;appliquer &agrave; un Service pr&eacute;cis auquel vous &ecirc;tes abonn&eacute; ou que vous utilisez;<br>v. tout mat&eacute;riel ou brochure de Rogers d&eacute;crivant vos Services ou les produits que vous achetez.<br></p><p>Votre Entente, avec toute modification qui peut y &ecirc;tre apport&eacute;e, constitue l&rsquo;entente int&eacute;grale conclue entre vous et Rogers au sujet des Services pertinents. Chaque Service auquel vous vous abonnez constitue une Entente distincte avec nous. En cas d&rsquo;incoh&eacute;rence entre les documents indiqu&eacute;s ci-dessus et les pr&eacute;sentes Modalit&eacute;s, les pr&eacute;sentes Modalit&eacute;s auront pr&eacute;s&eacute;ance.</p><p>c. Qui est responsable de se conformer &agrave; l&rsquo;Entente?</p><p>En tant que titulaire de compte, vous avez la responsabilit&eacute; de respecter l&rsquo;Entente. Vous &ecirc;tes responsable notamment :</p><p>i. de payer tous les frais imput&eacute;s &agrave; votre compte;<br>ii. de vous assurer que toute personne qui utilise les Services par l&rsquo;entremise de votre compte ou avec votre autorisation le fait en conformit&eacute; avec l&rsquo;Entente;<br>iii. de vous assurer que personne n&rsquo;a acc&egrave;s &agrave; votre compte ou &agrave; vos Services sans votre autorisation, notamment en veillant &agrave; la confidentialit&eacute; de tout nom d&rsquo;utilisateur et mot de passe propre &agrave; votre compte;<br>iv. de vous assurer que tout renseignement que vous nous fournissez est &agrave; jour et exact, et de nous informer de tout changement &agrave; vos renseignements.<br></p><p>d. Puis-je transf&eacute;rer mon Entente &agrave; autrui?</p><p>Vous devez obtenir notre consentement pr&eacute;alable si vous souhaitez c&eacute;der ou transf&eacute;rer une Entente. Nous pouvons c&eacute;der ou transf&eacute;rer une Entente ou l&rsquo;un ou l&rsquo;autre de nos droits et responsabilit&eacute;s qui s&rsquo;y rattachent sans votre consentement.</p></div>");
$templateCache.put("views/localization/intro.html","<div class=\"bold paragraph\">INTRODUCTORY INFORMATION</div><div class=\"paragraph\"><p>a. How do the Rogers Terms of Service apply to me?</p><p>These Rogers Terms of Service (&quot;Terms&quot;) govern your use of:</p><p>i. the Rogers services that you subscribe to or purchase under a service agreement or receive from or through Rogers, including wireless and residential services (&quot;Services&quot;); and<br>ii. any device or equipment used to access the Services or used with the Services (&quot;Equipment&quot;).<br>In these Terms, &quot;Rogers&quot;, &quot;us&quot;, &quot;we&quot; and &quot;our&quot; means the Rogers entity named in the service agreement for the specific Service you subscribe to. These Terms do not apply to services offered by Rogers Media Inc. or its subsidiaries.<br></p><p>b. How do the Rogers Terms of Service work with my service agreement and other materials made available to me?</p><p>These Terms work together with the following materials to form your complete agreement (&quot;Agreement&quot;) with us, and provide you with the important information you need to help you fully understand your Services:</p><p>i. Your service agreement for the specific Service you subscribe to (such as a wireless service agreement or residential service agreement).<br>ii. Our Acceptable Use Policy, which sets out the rules, policies and limits you must abide by when using the Services. Our Acceptable Use Policy lists examples of prohibited activities and unlawful or inappropriate content and gives us the right to remove content and/or suspend or terminate your Services if you violate the policy.<br>iii. Our Privacy Policy, which sets out our policies in relation to the collection, use and disclosure of your personal information. Our Privacy Policy details why we collect customer information, how we use it and how we share it, and specifies how to contact us if you would like more information on our personal information handling practices.<br>iv. Any additional terms and conditions that may apply to a specific Service that you subscribe to or use.<br>v. Any Rogers brochure or material describing your Services or products you purchase.<br></p><p>Your Agreement, with any amendments, is the entire agreement between you and Rogers for the applicable Services. Each Service that you subscribe to is a separate Agreement with us. If there is any inconsistency between the materials listed above and these Terms, these Terms will prevail.</p><p>c. Who is responsible for complying with the Agreement?</p><p>You, as account holder, are responsible to comply with the Agreement. Among other things, you are responsible for:</p><p>i. all charges on your account;<br>ii. ensuring that anyone who uses Services under your account or with your authorization complies with the Agreement;<br>iii. ensuring that others do not gain unauthorized access to your account and your Services, including by protecting the security of any user names or passwords relating to your account;<br>iv. ensuring that any information you have provided to us is up-to-date and accurate, and to let us know if it changes.<br></p><p>d. May I transfer my Agreement to someone else?</p><p>You will need our prior permission if you want to assign or transfer an Agreement. We may assign or transfer an Agreement or any of our rights or responsibilities under an Agreement without your permission.</p></div>");
$templateCache.put("views/localization/prepaid-wireless-service-fr.html","<div class=\"bold paragraph\">Service sans fil pr&eacute;pay&eacute;</div><div class=\"paragraph\"><p>a. En tant que client du service sans fil pr&eacute;pay&eacute; de Rogers, comment puis-je v&eacute;rifier le solde d&rsquo;utilisation de mon service sans fil pr&eacute;pay&eacute;?</p><p>Vous pouvez v&eacute;rifier votre solde d&rsquo;utilisation &agrave; partir de votre appareil sans fil pr&eacute;pay&eacute; en composant *6 1 1 (sans frais).</p><p>b. Si j&rsquo;ajoute des fonds au solde de mon service sans fil pr&eacute;pay&eacute; et que je change d&rsquo;id&eacute;e, puis-je obtenir un remboursement?</p><p>Non, les d&eacute;p&ocirc;ts port&eacute;s &agrave; votre compte pour les services sans fil pr&eacute;pay&eacute;s ne sont pas remboursables.</p><p></p><p>c. Qu&rsquo;arrive-t-il si je n&rsquo;utilise pas r&eacute;guli&egrave;rement mon Service sans fil pr&eacute;pay&eacute;?</p><p>Si votre compte sans fil pr&eacute;pay&eacute; affiche un solde &agrave; <strong>0 $</strong> pendant <strong>6</strong> mois cons&eacute;cutifs ou si les paiements exigibles relatifs &agrave; votre compte ne sont pas effectu&eacute;s ou sont refus&eacute;s, pour une raison quelconque, votre identifiant du service sans fil pr&eacute;pay&eacute; (par exemple, num&eacute;ro de t&eacute;l&eacute;phone ou NIP) sera d&eacute;sactiv&eacute;. Veuillez noter &eacute;galement que tout solde de votre service sans fil pr&eacute;pay&eacute; peut comporter une date d&rsquo;expiration tel qu&rsquo;indiqu&eacute;.</p><p>d. Outre les frais d&rsquo;utilisation, d&rsquo;autres frais sont-ils associ&eacute;s au Service sans fil pr&eacute;pay&eacute;?</p><p>Une fois par mois, nous d&eacute;duirons de votre compte de service sans fil pr&eacute;pay&eacute; les frais d&rsquo;acc&egrave;s au service d&rsquo;urgence 9 1 1 (frais non gouvernementaux) pour l&rsquo;acc&egrave;s au service d&rsquo;urgence 9 1 1 et les frais gouvernementaux applicables au service 9 1 1 selon la province (aucuns frais de temps d&rsquo;antenne ne s&rsquo;appliquent pour les appels effectu&eacute;s au 9 1 1 &agrave; partir de votre appareil sans fil). Pour de plus amples renseignements, visitez le <a href=\"http://www.rogers.com/web/Rogers.portal?_nfpb=true&amp;_pageLabel=NEW_GCT&amp;_nfls=true&amp;setLanguage=fr&amp;template=wireless-911&amp;content10=wireless-911&amp;asc_refid=911\">rogers.com/911.</a></p></div>");
$templateCache.put("views/localization/prepaid-wireless-service.html","<div class=\"bold paragraph\">PREPAID WIRELESS SERVICE</div><div class=\"paragraph\"><p>a. If I am a Rogers prepaid wireless customer, how can I check my prepaid wireless usage balance?</p><p>You can check your usage balance from your prepaid wireless device by calling *611 (it&rsquo;s a free call).</p><p>b. If I change my mind about adding to my prepaid wireless balance, can I get a refund?</p><p>No. Deposits into your account for prepaid wireless Services are non-refundable.</p><p>c. What if I don&rsquo;t use my prepaid wireless Service on a regular basis?</p><p>If your prepaid wireless account balance remains at <strong>$0</strong> for <strong>6</strong> consecutive months or if required payments towards your account are not made or are returned, for any reason, your prepaid wireless identifier (e.g., phone number or PIN number) will be deactivated. Please also note any prepaid wireless balance may have an expiry date as indicated.</p><p>d. Other than usage charges, are there any additional fees associated with prepaid wireless Service?</p><p>We will deduct a 9-1-1 Emergency Access Fee (non-government fee) for the provision of access to 9-1-1 service and any applicable 9-1-1 provincial government fee, once per month from your prepaid wireless account (there is no airtime charge for calls made from your wireless device to 9-1-1). For more information, please visit <a href=\"http://www.rogers.com/911\">rogers.com/911</a>.</p></div>");
$templateCache.put("views/localization/privacy-policy-fr.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><h2 class=\"tc-heading\">POLITIQUE DE CONFIDENTIALITÉ</h2><h3 class=\"tc-subheading\">Politique du Groupe de sociétés Rogers (Rogers) en matière de protection de la vie privée</h3><ol class=\"tc-list-spacing\"><li>Cette politique s’applique à Rogers Communications, à Rogers Câble, à Rogers Sans-fil et à Rogers Média, regroupées dans la présente sous le nom de « Rogers ». Pour le Groupe de sociétés Rogers, la sécurité et l’intégrité des renseignements personnels de ses clients sont importantes. De plus, toutes les mesures nécessaires sont prises afin d’assurer la protection de la vie privée de ses clients tout en leur assurant le niveau de qualité élevée auxquels ils s’attendent pour leurs services de communications.</li><li>Les pratiques de Rogers en matière de protection de la vie privée sont conformes aux lois et règlements fédéraux et provinciaux. Rogers est en conformité avec la Loi sur la protection des renseignements personnels et les documents électroniques (LPRPDE), ainsi qu’avec les règles établies par le Conseil de la radiodiffusion et des télécommunications canadiennes (CRTC), lorsqu’elles s’appliquent.</li><li>Rogers a mis en place des procédures en matière de sécurité et de protection de la vie privée afin de protéger les renseignements personnels de ses clients. Ces procédures sont revues et mises à jour régulièrement. De plus, les employés de Rogers suivent une formation sur la protection de la vie privée et, comme condition d’emploi, s’engagent à respecter les pratiques adoptées par Rogers en matière de protection de la vie privée.</li><li>Les renseignements personnels recueillis par Rogers concernent toujours un individu identifiable et peuvent comprendre le nom, l’adresse électronique, le numéro de téléphone, la date de naissance ainsi que les renseignements financiers du client et, s’il y a lieu, les plaintes inscrites à son dossier.</li><li>Rogers recueille des renseignements pour une ou plusieurs des raisons suivantes :<ul class=\"tc-sublist\"><li>offrir une expérience positive au client, assurer la prestation et la facturation des produits et services ainsi que la collecte du paiement pour les produits et services offerts;</li><li>comprendre les exigences du client et donner accès à l’information sur les produits et services offerts par Rogers, ses représentants, ses concessionnaires et ses sociétés affiliées;</li><li>gérer les activités de Rogers et assurer leur expansion;</li><li>satisfaire aux exigences relatives aux lois et réglementations; et</li><li>obtenir des renseignements sur le crédit et les communiquer à d’autres parties.</li></ul></li><li>Rogers n’utilise ni ne dévoile les renseignements personnels pour des raisons autres que celles pour lesquelles ils ont été recueillis, sauf avec le consentement de la personne concernée ou tel qu’exigé par la loi. Rogers conserve ces renseignements aussi longtemps qu’ils lui sont nécessaires.</li><li>Rogers informe ses clients, lorsqu’ils en font la demande, de l’existence, de l’utilisation et de la diffusion de leurs renseignements personnels et leur donne accès à leurs renseignements.</li><li>Rogers s’assure que les renseignements personnels fournis sont exacts, complets et à jour. Les clients peuvent vérifier l’exactitude et l’exhaustivité des renseignements et demander les modifications nécessaires, au besoin.</li><li>Les membres du Groupe de sociétés Rogers échangent des renseignements personnels avec d’autres sociétés Rogers, des représentants et des concessionnaires autorisés, afin d’offrir à leurs clients des produits et services susceptibles de les intéresser. Des avis sur le partage de renseignements personnels paraissent sur tous les formulaires de demande, les factures et les sites Web. Les clients qui ne souhaitent pas être sollicités au sujet de ces produits et services peuvent communiquer avec Rogers (voir les coordonnées ci-dessous).</li><li>Pour consulter les questions fréquentes sur l’engagement de Rogers en matière de protection de la vie privée, veuillez vous référer à <strong>rogers.com/web/contenu/FAQ-sur-engagement-de-Rogers-aux-politiques</strong></li><li>Un agent de protection de la vie privée a été désigné chez Rogers. Celui-ci est responsable de tous les renseignements personnels recueillis par Rogers. Vous pouvez communiquer avec lui à l’adresse ci-dessous :<br>Par la poste : Agent de protection de la vie privée<br>Groupe de sociétés Rogers<br>333, rue Bloor Est Toronto (Ontario) M4W 1G9</li><li>Les clients qui désirent : obtenir de plus amples renseignements sur cette politique en matière de protection de la vie privée; accéder à leurs renseignements personnels ou obtenir de l’information sur les renseignements dont dispose Rogers; ou formuler une plainte liée à la protection de la vie privée peuvent communiquer avec un représentant du Service à la clientèle qui, au besoin, les mettra en contact avec l’agent de protection de la vie privée de Rogers.</li><li>Le Commissariat à la protection de la vie privée du Canada supervise le traitement de vos renseignements personnels par Rogers. Si vos préoccupations quant à la protection de la vie privée ne sont pas satisfaites par Rogers, vous pouvez communiquer avec le Commissariat à la protection de la vie privée du Canada pour obtenir de plus amples renseignements :<p>Par courriel : <a href=\"mailto:info@privcom.gc.ca\"><strong>info@privcom.gc.ca</strong></a></p><p>Site Web : <a href=\"http://www.privcom.gc.ca/\"><strong>www.privcom.gc.ca</strong></a></p></li></ol>");
$templateCache.put("views/localization/privacy-policy.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><h2 class=\"tc-heading\">PRIVACY POLICY</h2><h3 class=\"tc-subheading\">The Rogers Group of Companies (Rogers) Commitment to Privacy</h3><ol class=\"tc-list-spacing\"><li>This policy applies to Rogers Communications, Rogers Cable, Rogers Wireless and Rogers Media which are referred to here collectively as Rogers. At Rogers, the security and integrity of our customers’ personal information is important to us. We take every reasonable measure necessary to protect the privacy of our customers while providing the high level communication services they expect.</li><li>Rogers’ privacy practices are in accordance with all federal and provincial laws and regulations. We are compliant with the Personal Information Protection and Electronic Documents Act (PIPEDA) and where applicable with the privacy rules established by the Canadian Radio-television and Telecommunications Commission (CRTC).</li><li>Rogers has in place privacy and security practices to safeguard our customers’ personal information. These practices are reviewed, and if necessary revised, on a regular basis. Additionally, Rogers’ employees receive privacy training and must comply with Rogers’ privacy practices as a condition of employment.</li><li>Personal information collected by Rogers is information about an identifiable individual that may include such information as your name, e-mail address, mailing address, phone number, financial information, birth date and any recorded complaints.</li><li>At Rogers, we collect customer information for one or more of the following purposes:<ul class=\"tc-sublist\"><li>To provide a positive customer experience, and deliver, bill for, and collect payment for products and services;</li><li>To understand customer requirements and make information available regarding products and services offered by Rogers and its agents, dealers and related companies;</li><li>To manage and develop Rogers business and operations;</li><li>To meet legal and regulatory requirements; and</li><li>To obtain credit information or provide it to others.</li></ul></li><li>Rogers does not use or disclose personal information for purposes other than those for which it was collected, except with the consent of the individual or as required by law. Rogers retains personal information only as long as necessary for the fulfillment of those purposes.</li><li>Rogers informs customers of the existence, use and disclosure of their personal information upon request and gives them access to their information.</li><li>Rogers ensures that customer information is accurate, complete and up-to-date. Customers can challenge the accuracy and completeness of the information and request amendments as appropriate.</li><li>Rogers companies share information with other Rogers companies or their agents and authorized dealers, in order to offer customers products and services that they may find attractive. Notices on sharing information are contained in each company’s application forms, invoices and web sites. If customers do not want to be marketed with these products and services, they can contact Rogers (see How To Contact Rogers below).</li><li>For FAQs about Rogers Commitment to Privacy, please visit rogers.com/web/content/FAQs-About-Rogers-Commitment-to-Policy.</li><li>A senior company officer has been appointed as the Privacy Officer at Rogers. The Privacy Officer is accountable for all personal information at Rogers. You may contact the Privacy Officer at:<p>By Mail: Chief Privacy Officer<br>Rogers Group of Companies<br>333 Bloor Street East<br>Toronto, Ontario<br>M4W 1G9</p></li><li>Customers that wish to: obtain more information about Rogers Commitment to Privacy; access, or obtain more information about, their personal information held by Rogers; or make a privacy-related complaint; may contact a Rogers customer service representative who, if necessary, will refer the customer to the Rogers Privacy Officer.</li><li>The Office of the Privacy Commissioner of Canada oversees Rogers’ personal information handling practices. If your privacy concerns are not addressed to your satisfaction by Rogers you may contact the Office of the Privacy Commissioner of Canada for further guidance:<p>By E-mail: <a href=\"mailto:info@privcom.gc.ca\">info@privcom.gc.ca</a></p><p>Website: <a href=\"http://www.privcom.gc.ca/\">www.privcom.gc.ca</a></p></li></ol>");
$templateCache.put("views/localization/rogers-terms-of-service-fr.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><p class=\"tc-heading\">MODALITÉS DE SERVICE ROGERS</p><ol class=\"tc-ol-headline\"><li class=\"tc-headline2\"><strong>Introduction</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Comment les Modalités de service Rogers s’appliquent-elles à moi?</strong></li></ol><p>Les présentes Modalités de service Rogers (les « <strong>Modalités</strong> ») régissent votre utilisation :</p><ol type=\"i\"><li>des services de Rogers auxquels vous vous abonnez ou que vous achetez aux termes d’une entente de service, ou que vous recevez de Rogers ou par son intermédiaire, y compris les services sans fil et les services résidentiels (les « <strong>Services</strong>»);</li><li>de tout appareil ou équipement dont vous vous servez pour accéder aux Services ou que vous utilisez avec les Services (l’« <strong>Équipement</strong>»).</li></ol><p>Dans les présentes Modalités, les expressions « <strong>Rogers</strong> », « <strong>nous</strong> », « <strong>nos</strong> » et « <strong>notre</strong> » renvoient à l’entité de Rogers dont le nom figure dans l’entente de service régissant le Service en particulier auquel vous vous abonnez. Les présentes Modalités ne s’appliquent pas aux services offerts par Rogers Média Inc. ou ses filiales.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Comment les Modalités de service Rogers régissent-elles mon entente de service et les autres documents qui me sont fournis?</strong></li></ol><p>Les présentes Modalités s’appliquent conjointement avec les documents suivants pour former ensemble votre entente complète (l’« <strong>Entente</strong> ») avec nous, et contiennent des renseignements importants dont vous avez besoin pour bien comprendre vos Services :</p><ol type=\"i\"><li>Votre <strong>entente de service</strong> régissant le Service en particulier auquel vous vous abonnez (comme une entente de service sans fil ou une entente de service résidentiel).</li><li>Notre <strong>Politique d’utilisation acceptable</strong>, qui décrit les règles, les politiques et les restrictions que vous devez respecter lorsque vous utilisez les Services. Notre Politique d’utilisation acceptable prévoit des exemples d’activités interdites et de contenu illégal ou inapproprié et nous donne le droit de retirer du contenu et de suspendre vos Services ou d’y mettre fin si vous contrevenez à la Politique.</li><li>Notre <strong>Politique de protection de la vie privée</strong>, qui décrit nos politiques relativement à la cueillette, à l’utilisation et à la divulgation de vos renseignements personnels. Notre Politique de protection de la vie privée vous informe des raisons pour lesquelles nous recueillons de l’information sur nos clients, de la façon dont nous utilisons et partageons cette information et de la façon de communiquer avec nous si vous souhaitez obtenir plus de détails sur nos pratiques de traitement des renseignements personnels.</li><li>toutes <strong>modalités et conditions supplémentaires</strong> pouvant s’appliquer à un Service précis auquel vous êtes abonné ou que vous utilisez;</li><li>tout <strong>matériel ou brochure de Rogers décrivant vos Services ou les produits que vous achetez</strong>.</li></ol><p>Votre Entente, avec toute modification qui peut y être apportée, constitue l’entente intégrale conclue entre vous et Rogers au sujet des Services pertinents. Chaque Service auquel vous vous abonnez constitue une Entente distincte avec nous. En cas d’incohérence entre les documents indiqués ci-dessus et les présentes Modalités, les présentes Modalités auront préséance.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Qui est responsable de se conformer à l’Entente?</strong></li></ol><p>En tant que titulaire de compte, vous avez la responsabilité de respecter l’Entente. Vous êtes responsable notamment :</p><ol type=\"i\"><li>de payer tous les frais imputés à votre compte;</li><li>de vous assurer que toute personne qui utilise les Services par l’entremise de votre compte ou avec votre autorisation le fait en conformité avec l’Entente;</li><li>de vous assurer que personne n’a accès à votre compte ou à vos Services sans votre autorisation, notamment en veillant à la confidentialité de tout nom d’utilisateur et mot de passe propre à votre compte;</li><li>de vous assurer que tout renseignement que vous nous fournissez est à jour et exact, et de nous informer de tout changement à vos renseignements.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Puis-je transférer mon Entente à autrui?</strong></li></ol><p>Vous devez obtenir notre consentement préalable si vous souhaitez céder ou transférer une Entente. Nous pouvons céder ou transférer une Entente ou l’un ou l’autre de nos droits et responsabilités qui s’y rattachent sans votre consentement.</p><ol class=\"tc-ol-headline\" start=\"2\"><li class=\"tc-headline2\"><strong>Période d’abonnement, modifications et résiliation</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Quelles sont les catégories de Services visées par mon Entente?</strong></li></ol><p>Les Services sont classés selon les catégories suivantes :</p><ol type=\"i\"><li>Les « <strong>Services à durée déterminée</strong>» s’entendent de Services auxquels vous vous abonnez et qui comportent une période d’abonnement prédéterminée, tel qu’il est indiqué dans votre entente de service applicable (la « <strong>Période d’abonnement</strong> »);</li><li>Les « <strong>Services mensuels</strong>» s’entendent de Services auxquels vous vous abonnez de façon continue, mais qui ne comportent pas de Période d’abonnement;</li><li>Les « <strong>Services facturés à l’utilisation</strong>» s’entendent de Services que vous utilisez et qui sont facturés à l’utilisation (qu’ils soient utilisés une seule fois ou pendant une période donnée, comme un jour ou une semaine), mais qui ne sont pas utilisés de façon continue.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Quelle est la durée de mon Entente?</strong></li></ol><p>La durée de chaque Entente débute à la date de mise en service initiale des Services ou de l’Équipement, selon la première date à survenir (la « <strong>Date de mise en service</strong> »). À la fin de la Période d’abonnement d’un Service à durée déterminée, ce Service à durée déterminée deviendra automatiquement un Service mensuel, et votre Entente et votre Service existants auprès de Rogers demeureront inchangés jusqu’à ce qu’ils soient modifiés ou résiliés conformément aux présentes Modalités.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Rogers peut-elle modifier mes Services ou mon Entente?</strong></li></ol><p>Oui, Rogers peut apporter des changements à vos Services et à votre Entente, conformément à ce qui suit.</p><p><strong>Pour les Services sans fil :</strong></p><p>Nous pouvons modifier tout aspect d’un Service mensuel et de l’Entente qui y est associée, à condition de vous en aviser par écrit au moins <strong>30</strong> jours à l’avance. Nous pouvons également modifier des aspects d’un Service à durée déterminée et de l’Entente qui y est associée, autres que les principales modalités selon ce qui est prévu au Code sur les services sans fil du Conseil de la radiodiffusion et des télécommunications canadiennes (CRTC), en vous en avisant par écrit au moins <strong>30</strong> jours à l’avance. Dans un cas comme dans l’autre, nous vous enverrons l’avis écrit par message apparaissant sur votre facture, par message texte, par lettre ou par courriel, et cet avis comprendra des explications sur la modification ainsi que sa date d’entrée en vigueur.</p><p><strong>Pour les Services résidentiels :</strong></p><p><strong>Non applicable aux Résidents de Terre-Neuve-et-Labrador* ou aux Résidents du Québec** :</strong> Nous pouvons modifier tout aspect d’un Service mensuel ou d’un Service à durée déterminée, ainsi que toute disposition ou modalité d’une Entente, en vous faisant parvenir un préavis écrit par message apparaissant sur votre facture, par message texte, par courrier ou par courriel. Si vous n’acceptez pas ce changement, votre recours consiste à résilier les Services ou l’Entente visés en nous faisant parvenir un avis de résiliation conformément au paragraphe 2e) ci-après dans les <strong>30</strong><strong></strong>jours suivant la réception de notre avis de modification (à moins que nous y indiquions une autre période d’avis ou un autre recours).</p><p><strong>Applicable uniquement aux Résidents de Terre-Neuve-et-Labrador* et aux Résidents du Québec** :</strong>Nous pouvons modifier tout aspect d’un Service mensuel et de l’Entente qui y est associée, à condition de vous en aviser par écrit au moins <strong>30</strong>jours à l’avance. Nous pouvons également modifier un Service à durée déterminée et l’Entente qui y est associée en vous en avisant par écrit au moins <strong>30</strong>jours à l’avance, mais nous ne modifierons pas le prix, la durée, la nature ou tout autre aspect essentiel de ce Service à durée déterminée ou de l’Entente. Dans un cas comme dans l’autre, nous vous enverrons l’avis écrit par message apparaissant sur votre facture, par message texte, par lettre ou par courriel, et cet avis contiendra la nouvelle modalité ou disposition, la modalité ou disposition modifiée, l’ancienne version de cette modalité ou disposition (le cas échéant), la date à laquelle la modification entrera en vigueur et un énoncé de vos droits. Si le changement à un Service mensuel ou à un Service à durée déterminée entraîne une augmentation de vos obligations ou une réduction de nos obligations et que vous n’acceptez pas ce changement, votre recours consiste à résilier les Services ou l’Entente visés sans Frais de résiliation anticipée (tels que définis ci-après) en nous faisant parvenir un avis de résiliation conformément au paragraphe 2e) ci-après au plus tard <strong>30</strong> jours suivant l’entrée en vigueur de la modification.</p><p><strong>Pour les Services facturés à l’utilisation :</strong> Les Services facturés à l’utilisation sont offerts sous réserve de leur disponibilité, et Rogers peut les modifier ou les résilier en tout temps sans vous en aviser au préalable.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Puis-je modifier mes Services?</strong></li></ol><p>Vous pouvez modifier vos Services à tout moment en communiquant avec nous de l’une ou l’autre des façons indiquées au paragraphe 10e) ci-après. Vous pourriez devoir payer des frais d’administration conformément au paragraphe 3d) ci-après. Vous pourriez également devoir payer des frais pour changer un Service si de tels frais sont indiqués dans votre entente de service applicable à ce Service. Veuillez noter que, si vous souhaitez changer un Service, vous pourriez seulement pouvoir le remplacer par un Service qui est offert à ce moment-là, et que tout Service annulé à votre demande pourrait ne plus être disponible.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Comment puis-je résilier mes Services et à quel moment la résiliation entre-t-elle en vigueur?</strong></li></ol><p>À moins que les lois applicables ne permettent autre chose, vous pouvez résilier la totalité ou une partie de vos Services et toute Entente qui y est associée à tout moment en communiquant avec nous de l’une ou l’autre des façons indiquées au paragraphe 10e) ci-après. La résiliation entre en vigueur à la date à laquelle Rogers reçoit l’avis de résiliation ou à une date ultérieure qui est indiquée dans l’avis (le cas échéant), selon la date la plus éloignée. Les frais exigibles continueront de s’appliquer jusqu’à cette date. Cependant, si vous annulez uniquement une option du Service de télévision ou du Service d’accès Internet, les frais applicables pour cette option continueront de s’appliquer jusqu’à votre prochaine date de facturation.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Devrai-je payer des frais de résiliation anticipée si j’annule l’un ou l’autre de mes Services?</strong></li></ol><p>Si vous vous abonnez à un Service à durée déterminée que vous résiliez avant la fin de sa Période d’abonnement, vous devrez payer des frais de résiliation anticipée tel qu’il est décrit dans l’entente de service applicable à ce Service à durée déterminée (les « <strong>Frais de résiliation anticipée</strong> »).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"7\"><li><strong>Que se passe-t-il si je transfère mes Services à un autre fournisseur de service?</strong></li></ol><p>Le transfert de votre ou de vos Services à un autre fournisseur de service constitue une résiliation du ou des Services en question, et des Frais de résiliation anticipée pourront s’appliquer si le transfert entraîne la résiliation d’un Service à durée déterminée avant la fin de sa Période d’abonnement.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"8\"><li><strong>Rogers peut-elle résilier mes Services et, le cas échéant, à quel moment cette résiliation entre-t-elle en vigueur?</strong></li></ol><p><strong>Non applicable aux Résidents de Terre-Neuve-et-Labrador</strong><strong>* et aux Résidents du Québec** :</strong> À moins que les lois applicables ne permettent autre chose, Rogers peut résilier une partie ou la totalité de vos Services ou de vos comptes, ainsi que toute Entente qui y est associée, à condition de vous en aviser par écrit au moins <strong>30</strong> jours à l’avance. Les frais exigibles continuent de s’appliquer jusqu’à la date de résiliation.</p><p><strong>Applicable uniquement aux Résidents de Terre-Neuve-et-Labrador* et aux</strong><strong>Résidents du Québec** :</strong> À moins que les lois applicables ne permettent autre chose, Rogers peut résilier une partie ou la totalité de vos Services ou de vos comptes, ainsi que toute Entente qui y est associée, à condition de vous en aviser par écrit au moins <strong>60</strong>jours à l’avance. Si vous vous êtes abonné à un Service à durée déterminée, nous ne pouvons résilier ce Service : (i) (<strong>applicable uniquement aux Résidents de Terre-Neuve-et-Labrador*</strong>) que si n’avons plus la capacité technique de fournir ce Service à durée déterminée, ou (ii) (<strong>applicable uniquement aux Résidents du Québec**</strong>) qu’en vertu des articles 1604, 2126 et 2129 du <em>Code civil du Québec</em>. Les frais exigibles continuent de s’appliquer jusqu’à la date de résiliation. <strong>Applicable uniquement aux Résidents de Terre-Neuve-et-Labrador* :</strong>Si votre compte a un solde créditeur dépassant <strong>10 $</strong> sur votre facture finale, nous vous rembourserons ce solde dans les <strong>60</strong> jours suivant la date de cette facture. Les crédits discrétionnaires ne seront pas remboursés.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"9\"><li><strong>Rogers peut-elle suspendre ou résilier mes Services sans préavis?</strong></li></ol><p>Nous pouvons limiter, suspendre, bloquer, débrancher ou résilier l’un ou l’autre ou l’ensemble de vos Services, comptes ou identifiants de quelque façon que ce soit, y compris le service 9‑1‑1, sans avis ni responsabilité envers vous, si :</p><ol type=\"i\"><li>vous contrevenez aux modalités d’une Entente, notamment en omettant d’acquitter vos frais;</li><li>vous dépassez votre limite de crédit;</li><li>vous omettez de fournir ou de maintenir un dépôt de garantie raisonnable ou de vous conformer à une autre exigence de crédit lorsque nous vous demandons de le faire;</li><li>vous convenez avec nous d’un arrangement de paiement différé et vous omettez d’en respecter les modalités;</li><li>vous dépassez la limite d’utilisation raisonnable;</li><li>vous donnez de l’information fausse, trompeuse ou périmée;</li><li>nous avons des doutes raisonnables ou nous avons établi qu’un de vos comptes, identifiants, Services ou Équipement est associé à une fraude, une utilisation illégale ou inappropriée, ou est utilisé d’une façon nuisant à notre exploitation ou à l’utilisation de nos services, de nos installations ou de nos réseaux par d’autres;</li><li>vous harcelez, menacez ou faites preuve d’abus envers nous, nos employés ou nos agents;</li><li>vous tentez par des manœuvres frauduleuses ou malhonnêtes de ne pas nous payer;</li><li>nous devons installer, entretenir, inspecter, tester, réparer, retirer, remplacer, enquêter, protéger, modifier, mettre à jour ou améliorer l’exploitation des Services, de l’Équipement, de nos installations ou de nos réseaux;</li><li>un compte ou un service duquel vos Services dépendent est annulé pour quelque raison; ou</li><li>nous croyons raisonnablement qu’une urgence ou des circonstances particulières justifient une telle mesure.</li></ol><p>Si nous limitons, suspendons, bloquons, débranchons ou résilions vos Services ou vos comptes :</p><ol type=\"i\"><li>vous devez nous payer tous les montants que vous nous devez;</li><li>nous pouvons également, sans avis ni responsabilité, limiter, suspendre, bloquer, débrancher ou résilier vos Services aux termes d’une autre entente ou d’un autre compte que vous avez auprès de nous ou d’une société du même groupe que Rogers (incluant les comptes qui pourraient être en règle);</li><li>les frais encourus par nous ou une société du même groupe que Rogers relativement à votre manquement aux présentes Modalités pourraient vous être facturés, incluant, sans toutefois s’y limiter, les frais encourus pour vous obliger à les respecter;</li><li>votre accès aux services d’urgence ou aux services spéciaux (par exemple, le 9‑1‑1) peut également être restreint, suspendu, bloqué, désactivé ou annulé;</li><li>vos tarifs pour les services auprès des sociétés du même groupe que Rogers peuvent changer en fonction des modalités de ces services.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"10\"><li><strong>Les présentes Modalités s’appliqueront-elles toujours après la résiliation de mes Services?</strong></li></ol><p>Certaines dispositions des présentes Modalités peuvent continuer à s’appliquer puisqu’elles peuvent demeurer pertinentes même après la résiliation de tous vos Services. Plus particulièrement, les paragraphes 1b)-d), 2e)-j), 4b)-c), 5c), 6d), 8b)-d), 8f), 9, 10b)-d) et les dispositions en matière d’arbitrage du paragraphe 10a) continueront de s’appliquer à vous malgré la résiliation de votre Entente.</p><ol class=\"tc-ol-headline\" start=\"3\"><li class=\"tc-headline2\"><strong>Compte, frais et facturation</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Comment Rogers me facture-t-elle mes Services?</strong></li></ol><p>Les frais relatifs aux Services commencent à vous être facturés à la Date de mise en service et sont facturés à l’avance. À moins que Rogers et vous conveniez d’un autre arrangement, votre période de facturation est d’une durée d’un mois, et se termine à la date de facturation indiquée au haut de votre facture. Le début de votre période de facturation ne coïncidera pas toujours avec la Date de mise en service initiale. Dans un tel cas, vos frais de Services et votre quota d’utilisation seront calculés proportionnellement pour la période comprise entre votre Date de mise en service et votre date de facturation. Les frais d’utilisation, comme les frais d’utilisation de données additionnelles, les frais de temps d’antenne, les frais d’interurbain, les achats de films ou d’événements et les frais d’itinérance, sont facturés après votre utilisation de ces services. Nous pourrons porter des frais à votre compte jusqu’à <strong>6</strong> mois suivant la date où les frais ont été engagés.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>À quelle date dois-je payer ma facture?</strong></li></ol><p>Les frais portés à votre compte sont payables en entier à la date de votre facture. Si vous payez par la poste ou par l’entremise d’une institution financière, veuillez prévoir des délais suffisants pour que le paiement nous parvienne avant la date d’exigibilité du paiement. Il vous incombe d’acquitter tous les frais imputés à votre compte.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Qu’arrive-t-il si je ne paie pas ma facture à temps?</strong></li></ol><p>Si nous ne recevons pas le montant d’une somme due sur votre compte au plus tard à la date d’exigibilité précisée, le montant sera soumis à des frais de paiement en retard de <strong>2 %</strong> par mois, calculés et composés mensuellement sur le montant en souffrance (<strong>26,82 %</strong> par année) à compter de la date de la première facture sur laquelle le montant en souffrance apparaît, jusqu’à la date de réception d’un tel montant au complet. Vous convenez que nous pouvons facturer les montants non payés et en souffrance, y compris les frais de paiement en retard, selon tout mode de paiement préautorisé lié à votre compte (par exemple, en le portant à votre carte de crédit ou en procédant par retrait direct de votre compte bancaire).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Des frais d’administration peuvent-ils m’être facturés?</strong></li></ol><p>Nous pourrions imputer des frais d’administration à votre compte, notamment en raison de ce qui suit :</p><ol type=\"i\"><li>un changement de forfait;</li><li>un changement de numéro de téléphone (ou de tout autre identifiant);</li><li>une demande de réimpression de facture;</li></ol><p><strong>Non applicable aux Résidents du Québec** :</strong></p><ol type=\"i\" start=\"4\"><li>des efforts de recouvrement à la suite d’un non-paiement;</li><li>des paiements retournés ou refusés; et (ou)</li><li>le rétablissement du Service.</li></ol><p>Vous pouvez obtenir une liste de ces frais sur demande, ou la consulter à l’adresse <strong>rogers.com/frais</strong>. Cette liste fait partie intégrante des présentes Modalités.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Que puis-je faire si je ne comprends pas ou que je veux contester des frais figurant sur ma facture?</strong></li></ol><p>Toute question ou erreur présumée concernant les frais doit nous être signalée dans les <strong>90</strong> jours suivant la date de la facture en question, sans quoi vous êtes présumé avoir accepté les frais. Si l’imputation des frais à votre compte était effectivement non autorisée ou erronée, nous annulerons alors ces frais dans les <strong>30</strong> jours suivant la réception de votre avis signalant l’erreur.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Comment s’appliquent les rabais et les promotions?</strong></li></ol><p>Nous appliquerons tout rabais, toute promotion ou tout avantage à votre compte tant que vous y demeurez admissible. Nous pouvons vérifier votre admissibilité à ce rabais, à cette promotion ou à cet avantage de temps à autre, et si vous cessez d’y être admissible pour quelque raison que ce soit, nous pouvons l’annuler et (ou) faire passer votre Service à un forfait comparable.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"7\"><li><strong>Comment les frais de temps d’antenne sans fil local et interurbain sont-ils facturés?</strong></li></ol><p>Les frais de temps d’antenne local et interurbain sont arrondis à la minute complète suivante. Des frais minimums d’une minute s’appliquent à chaque appel acheminé (entrant ou sortant). Le temps d’antenne pour toute la durée de l’appel est facturé au tarif applicable au début de l’appel. Les frais de temps d’antenne (plus les frais d’interurbain, s’il y a lieu) s’appliquent aux appels acheminés à partir du moment où vous appuyez sur ENVOYER, jusqu’à ce que vous appuyiez sur FIN, et comprennent le temps de sonnerie. Les frais pour les appels internationaux ou en itinérance peuvent vous être facturés, que vous ayez réussi ou non l’appel.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"8\"><li><strong>Comment Rogers détermine-t-elle si j’effectue un appel interurbain sans fil?</strong></li></ol><p>Une zone d’appels sans fil locaux est une zone où vous pouvez faire et recevoir des appels locaux sans frais d’interurbain. Les appels peuvent être soit locaux, soit interurbains, selon les zones d’appels locaux. L’endroit où vous vous trouvez au moment de l’appel, votre numéro de sans-fil et le numéro de téléphone que vous composez sont des éléments importants pour déterminer les zones d’appels locaux et le traitement des appels interurbains. Votre « zone d’appels locaux entrants » est déterminée par l’emplacement géographique associé à votre numéro de sans-fil. Tous les appels reçus lorsque vous vous trouvez à l’intérieur de votre zone d’appels locaux entrants sont considérés comme des appels locaux. Tous les appels reçus lorsque vous vous trouvez à l’extérieur de votre zone d’appels locaux entrants sont considérés comme des appels interurbains. Votre zone d’appels locaux sortants est déterminée par votre emplacement physique. Si vous composez un numéro local lorsque vous vous trouvez dans la zone de ce numéro, il s’agit d’un appel local. Si vous composez un numéro à l’extérieur de la zone où vous vous trouvez, il s’agit d’un appel interurbain. Lorsque vous utilisez le service Renvoi d’appel, des frais d’interurbain s’appliquent lorsque le numéro vers lequel vous transférez l’appel se trouve à l’extérieur de l’emplacement géographique associé à votre numéro de sans-fil, et ce, peu importe où vous vous trouvez. Consultez rogers.com/interurbain pour connaître les tarifs interurbains en vigueur.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"9\"><li><strong>Comment sont facturés les frais d’interurbain à partir de mon numéro de téléphone résidentiel, et comment Rogers détermine-t-elle si j’effectue un appel interurbain à partir de mon numéro de téléphone résidentiel?</strong></li></ol><p>Les frais d’interurbain sont arrondis à la minute complète suivante. Des frais minimums d’une minute s’appliquent à chaque appel interurbain que vous effectuez. Pour les appels internationaux, des frais d’interurbain peuvent être facturés que l’appel soit acheminé ou non. Pour les Services de téléphonie résidentielle, les appels peuvent être soit locaux, soit interurbains, selon les zones d’appels locaux, et votre zone d’appels locaux dépend de votre numéro de téléphone résidentiel. Si vous composez un numéro qui est un interurbain à partir de votre numéro de téléphone résidentiel, il s’agit d’un appel interurbain. Lorsque vous utilisez le Renvoi d’appel, des frais d’interurbain s’appliquent lorsque le numéro vers lequel vous transférez l’appel se trouve à l’extérieur de votre zone d’appels locaux.</p><ol class=\"tc-ol-headline\" start=\"4\"><li class=\"tc-headline2\"><strong>Exigences en matière de dépôt et de crédit</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Rogers exige-t-elle un dépôt de garantie ou applique-t-elle d’autres exigences en matière de paiement ou de crédit?</strong></li></ol><p>Oui, nous pouvons exiger un dépôt de garantie ou imposer d’autres exigences de paiement ou de crédit, comme des paiements intérimaires, des prélèvements automatiques obligatoires ou des paiements préautorisés.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Comment sont utilisés les dépôts de garantie?</strong></li></ol><p>Tout dépôt de garantie que vous nous fournissez sera conservé pendant au moins <strong>12</strong> mois, sauf si vous mettez fin à vos Services avant la fin de cette période. Après <strong>12</strong> mois, nous pouvons libérer le dépôt de garantie et l’appliquer au solde de votre compte si nous jugeons que votre historique de paiement est satisfaisant ou que vous répondez aux critères financiers pour le remboursement de votre dépôt de garantie. Nous pouvons appliquer votre dépôt de garantie à votre solde si vous n’acquittez pas votre facture, et nous pouvons vous demander de réapprovisionner le dépôt de garantie après une telle utilisation. Nous vous aviserons de toute utilisation d’une partie ou de la totalité du dépôt de garantie. Nous vous rembourserons le dépôt de garantie avec les intérêts cumulés dans les <strong>30</strong> jours suivant la résiliation de vos Services ou lorsque nous jugeons que les conditions du remboursement du dépôt de garantie sont remplies.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Mon dépôt de garantie porte-t-il intérêt?</strong></li></ol><p>Oui, tout dépôt de garantie que nous détenons portera intérêt au taux de financement à un jour de la Banque du Canada en vigueur à ce moment majoré de <strong>1</strong> pour cent, selon le nombre réel de jours dans l’année, calculé chaque mois. Les intérêts seront cumulés à partir de la date à laquelle nous recevons votre dépôt de garantie (mais pas avant le moment prescrit par la législation ou la réglementation en vigueur) jusqu’à la date à laquelle nous vous le remettons.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Rogers imposera-t-elle une limite de crédit à mon compte?</strong></li></ol><p>En vous donnant un avis à cet effet, nous pouvons attribuer ou modifier une limite de crédit à votre compte, en tout temps. Le Service pourra être suspendu en tout temps, pour n’importe lequel de vos comptes, si votre solde, y compris l’utilisation non facturée et les frais, les montants et les redressements en attente, dépasse cette limite. Les frais de service récurrents continueront de s’appliquer pendant toute suspension des Services.</p><ol class=\"tc-ol-headline\" start=\"5\"><li class=\"tc-headline2\"><strong>Votre utilisation des Services</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Suis-je propriétaire de mon numéro de téléphone?</strong></li></ol><p>Vous n’êtes pas propriétaire de tout numéro de téléphone, adresse courriel ou autre identifiant qui vous est attribué. Nous pouvons changer ou supprimer un identifiant à tout moment.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Rogers surveille-t-elle le contenu que je transmets lorsque j’utilise les Services?</strong></li></ol><p>Nous avons le droit, mais non l’obligation, de surveiller tout élément de contenu transmis au moyen des Services (autres que les Services de transmission de la voix) ou de l’Équipement, et de faire enquête sur ceux-ci. Nous pouvons également consulter ou conserver du contenu ou de l’information afin de nous conformer au processus judiciaire en vigueur au Canada et dans des territoires étrangers, d’exploiter les Services, de veiller au respect d’une Entente, ou encore de nous protéger nous-mêmes et de protéger nos clients et le public.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Quelles sont mes responsabilités à l’égard des logiciels ou du contenu de Rogers ou de tierces parties?</strong></li></ol><p>Toutes les marques de commerce et tous les droits d’auteur, concepts de marque, noms, logos et dessins que nous utilisons sont des actifs de propriété intellectuelle, déposés ou autre, de Rogers Communications Inc. ou d’une société membre de son groupe, ou encore sont utilisés en vertu d’une licence de Rogers Communications Inc. ou d’une société membre de son groupe. Tous ces éléments sont reconnus comme des actifs de valeur de leurs propriétaires respectifs, et vous ne pouvez pas les afficher, les copier ni les utiliser de quelque façon que ce soit à des fins commerciales ni pour quelque autre fin que ce soit.</p><p>Tout logiciel ou contenu que vous recevez ou achetez par l’intermédiaire de Rogers ou d’une de nos boutiques tierces ne peut servir qu’à une utilisation personnelle non commerciale. Un tel logiciel ou contenu demeure notre propriété ou celle de nos concédants de licence ou de nos fournisseurs de contenu, le cas échéant. Vous ne pouvez pas :</p><ol type=\"i\"><li>copier, distribuer, transférer ou vendre un tel logiciel ou contenu;</li><li>modifier, changer ou falsifier un tel logiciel ou contenu;</li><li>désosser, décompiler ou désassembler une partie du logiciel;</li><li>tenter de déjouer, éviter, contourner, retirer ou désactiver les mécanismes de protection d’un tel logiciel.</li></ol><p>Vous devez également prendre toutes les mesures raisonnables pour protéger les logiciels ou le contenu contre le vol, la perte et les dommages. Veuillez noter que de tels logiciels ou contenus peuvent, de temps à autre et sans que vous en soyez avisé, faire en sorte que votre Équipement accède à Internet de façon automatique, entraînant des frais de transmission de données et (ou) des frais d’utilisation excédentaire.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Que dois-je savoir à propos des Services Yahoo! qui me sont offerts?</strong></li></ol><p>Yahoo! Inc. et les sociétés membres de son groupe peuvent offrir aux clients du Service d’accès Internet de Rogers l’accès à une gamme de ressources, incluant divers outils de communication et du contenu varié (les « <strong>Services Yahoo!</strong> »). Lorsque vous utilisez les Services Yahoo!, les modalités de service, les lignes directrices et les règlements de Yahoo! (les « <strong>Modalités Yahoo!</strong> ») qui s’appliquent à ces services et qui sont affichés sur les pages où vous accédez à ces services régissent votre utilisation des Services Yahoo! En utilisant les Services Yahoo!, vous acceptez d’être lié par les Modalités Yahoo! intégrées par renvoi à une Entente. En ce qui concerne le Service d’accès Internet de Rogers et les Services Yahoo!, les obligations respectives de Rogers et de Yahoo! sont distinctes et non conjointes. Pour communiquer avec Yahoo! Inc. au sujet des Services Yahoo! seulement, veuillez écrire au Service à la clientèle, 701, First Avenue, Sunnyvale, CA, 94089, États-Unis. Pour obtenir de plus amples renseignements au sujet du traitement de vos renseignements personnels lorsque vous utilisez le Service d’accès Internet de Rogers et les Services Yahoo!, consultez <a href=\"http://www.rogers.yahoo.com/privacy\"><strong>rogers.yahoo.com/privacy</strong></a>.</p><ol class=\"tc-ol-headline\" start=\"6\"><li class=\"tc-headline2\"><strong>Équipement</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>L’Équipement est-il neuf ou remis à neuf?</strong></li></ol><p>Sauf indication contraire, l’Équipement que vous achetez de nous est neuf. Sauf indication contraire, l’Équipement que vous louez auprès de nous est remis à neuf et il est fourni selon la disponibilité. Si vous avez acheté de l’Équipement auprès de nous et que vous avez obtenu une subvention sur cet Équipement qui a fait en sorte que vous avez payé <strong>0</strong> <strong>$</strong> pour cet Équipement, veuillez noter que cet Équipement vous est fourni à rabais et non en tant qu’Équipement gratuit.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Puis-je rehausser mon Équipement?</strong></li></ol><p>Vous pouvez rehausser votre Équipement à tout moment en communiquant avec nous de l’une ou l’autre des façons indiquées au paragraphe 10e) ci-après. Vous pourriez devoir payer des frais d’administration conformément au paragraphe 3d) ci-dessus. Si, aux termes de votre rehaussement d’Équipement, vous concluez une nouvelle Période d’abonnement et résiliez de façon anticipée une Période d’abonnement existante, vous devrez payer des Frais de résiliation anticipée. Veuillez noter que si vous souhaitez rehausser votre Équipement, vous pourriez également devoir passer à un Service qui est offert à ce moment-là, et que tout Service ou Équipement annulé à votre demande pourrait ne plus être disponible.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Mon Équipement est-il verrouillé ou limité aux Services ou au réseau de Rogers?</strong></li></ol><p><strong>Pour les Services sans fil :</strong></p><p>Votre appareil sans fil est verrouillé et ne peut être utilisé que sur le réseau de Rogers ou encore sur ceux exploités par les fournisseurs avec lesquels nous avons conclu une entente d’itinérance. Si vous tentez de déverrouiller votre appareil, celui-ci pourrait devenir inutilisable de manière permanente et vous pourriez, ce faisant, contrevenir à la licence d’utilisation du logiciel de votre appareil. Si vous souhaitez déverrouiller votre appareil sans fil, les Frais de déverrouillage mentionnés dans votre entente de service sans fil s’appliquent. Si vous avez obtenu une subvention sur votre appareil, nous ne déverrouillerons votre appareil qu’après les <strong>90</strong> premiers jours de votre Période d’abonnement. Veuillez prendre note que durant les <strong>90</strong> premiers jours suivant la Date de mise en service, si vous êtes en itinérance à l’extérieur du réseau Rogers, votre Service sera restreint et vous ne pourrez pas effectuer d’appels sortants vers des destinations autres que celles qui ont un indicatif régional d’Amérique du Nord (incluant le Canada et les États-Unis) et à l’endroit où vous vous trouvez lorsque vous effectuez l’appel (ne s’applique pas au service prépayé).</p><p><strong>Pour les Services résidentiels :</strong></p><p>L’Équipement acheté ou loué ne peut être utilisé que dans le cadre des Services de Rogers, à l’adresse de service indiquée dans votre compte. Si vous tentez de modifier l’Équipement, celui-ci pourrait devenir inutilisable de manière permanente et vous pourriez, ce faisant, contrevenir à la licence d’utilisation du logiciel de l’Équipement.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Rogers devra-t-elle éventuellement avoir accès à ma propriété?</strong></li></ol><p>Pour les Services résidentiels, vous nous autorisez, nous et nos représentants, à accéder à vos locaux ou à entrer dans vos locaux, au besoin, à un moment mutuellement convenu pour l’installation, l’entretien, l’inspection, la réparation, le retrait, le remplacement, l’examen, la protection, la modification, la mise à niveau ou l’amélioration de l’exploitation de nos services, de l’Équipement, de nos installations ou de nos réseaux. Si vous résiliez un ou plusieurs de vos Services ou comptes, vous nous autorisez, nous et nos représentants, à accéder à vos locaux ou à entrer dans vos locaux pour débrancher les Services et retirer l’Équipement, le cas échéant.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Qui est responsable de s’assurer que mon Équipement est à jour?</strong></li></ol><p>Il est possible que l’Équipement et les logiciels qui s’y rattachent doivent respecter certaines exigences minimales et être entretenus d’une certaine façon et à certains endroits afin d’accéder aux Services ou pour assurer le bon fonctionnement des Services (par exemple, services 9‑1‑1). Ces exigences peuvent changer de temps à autre, et vous êtes responsable de la mise à jour ou de l’entretien nécessaires de votre Équipement et des logiciels pour respecter de telles exigences. Nous pouvons fournir des mises à jour de logiciels pour l’Équipement pour les besoins du fonctionnement continu des Services ou de l’Équipement. De même, nous pourrions devoir modifier ou désinstaller d’anciennes fonctionnalités logicielles afin de fournir de nouvelles fonctionnalités et veiller à ce que l’Équipement demeure compatible avec les avancées technologiques. Si votre Équipement ou vos logiciels ne sont pas à jour, nous pourrions ne pas être en mesure de vous fournir le soutien technique voulu.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Quelles sont mes responsabilités relatives à l’Équipement?</strong></li></ol><p>Vous êtes le seul responsable :</p><ol type=\"i\"><li>de tout accès à l’Équipement;</li><li>de fournir toute connexion supplémentaire, ainsi que le filage interne et l’équipement du terminal de téléphonie résidentielle, qui ne sont pas fournis par nous;</li><li>de la remise en service de votre équipement et de vos installations dans la mesure nécessaire après la résiliation de vos Services;</li><li>du maintien de la sécurité et de la confidentialité de vos biens et de vos transmissions par l’entremise des Services, de l’Équipement, de nos installations ou de nos réseaux;</li><li>de la protection contre les manquements à la sécurité ou à la confidentialité ou contre les autres risques associés à l’installation, à l’utilisation, au maintien ou au changement des Services ou de l’Équipement;</li><li>de vous assurer qu’il n’existe aucun branchement non autorisé à l’Équipement ou à notre câble (par exemple, pour l’Équipement de télévision, une (<strong>1</strong>) seule télévision peut être raccordée à une prise).</li></ol><p>Sauf en ce qui concerne l’Équipement que vous avez payé en entier, tout l’Équipement que nous installons ou que nous vous fournissons demeure notre propriété. En ce qui concerne tout l’Équipement dont nous sommes propriétaires, vous devez :</p><ol type=\"i\"><li>en prendre un soin raisonnable;</li><li>ne pas le vendre, le louer, l’hypothéquer, le transférer, le céder ou le grever de quelque façon que ce soit;</li><li>ne pas le déménager sans notre connaissance et notre permission;</li><li>nous le retourner à vos propres frais advenant la résiliation des Services auxquels l’Équipement est rattaché.</li></ol><p>Si notre Équipement est perdu, endommagé, volé, vendu, loué, hypothéqué, transféré, cédé ou grevé, ou qu’il ne nous est pas retourné, vous devez nous en avertir immédiatement. Vous convenez de nous payer la valeur au détail non escomptée d’un tel Équipement, ainsi que tous les frais encourus par nous pour reprendre possession d’un tel Équipement.</p><ol class=\"tc-ol-headline\" start=\"7\"><li class=\"tc-headline2\"><strong>Service sans fil prépayé</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>En tant que client du service sans fil prépayé de Rogers, comment puis-je vérifier le solde d’utilisation de mon service sans fil prépayé?</strong></li></ol><p>Vous pouvez vérifier votre solde d’utilisation à partir de votre appareil sans fil prépayé en composant *6‑1‑1 (sans frais).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Si j’ajoute des fonds au solde de mon service sans fil prépayé et que je change d’idée, puis-je obtenir un remboursement?</strong></li></ol><p>Non, les dépôts portés à votre compte pour les services sans fil prépayés ne sont pas remboursables.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Qu’arrive-t-il si je n’utilise pas régulièrement mon Service sans fil prépayé?</strong></li></ol><p>Si votre compte sans fil prépayé affiche un solde à <strong>0 $</strong> pendant <strong>6</strong> mois consécutifs ou si les paiements exigibles relatifs à votre compte ne sont pas effectués ou sont refusés, pour une raison quelconque, votre identifiant du service sans fil prépayé (par exemple, numéro de téléphone ou NIP) sera désactivé. Veuillez noter également que tout solde de votre service sans fil prépayé peut comporter une date d’expiration tel qu’indiqué.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Outre les frais d’utilisation, d’autres frais sont-ils associés au Service sans fil prépayé?</strong></li></ol><p>Une fois par mois, nous déduirons de votre compte de service sans fil prépayé les frais d’accès au service d’urgence 9‑1‑1 (frais non gouvernementaux) pour l’accès au service d’urgence 9‑1‑1 et les frais gouvernementaux applicables au service 9‑1‑1 selon la province (aucuns frais de temps d’antenne ne s’appliquent pour les appels effectués au 9‑1‑1 à partir de votre appareil sans fil). Pour de plus amples renseignements, visitez le <a href=\"http://www.rogers.com/web/Rogers.portal?_nfpb=true&amp;_pageLabel=NEW_GCT&amp;_nfls=true&amp;setLanguage=fr&amp;template=wireless-911&amp;content10=wireless-911&amp;asc_refid=911\"><strong>rogers.com/911</strong></a>.</p><ol class=\"tc-ol-headline\" start=\"8\"><li class=\"tc-headline2\"><strong>Protection de votre vie privée</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Que peut faire Rogers avec les renseignements sur mon compte et mes renseignements personnels?</strong></li></ol><p>En concluant une Entente, vous :</p><ol type=\"i\"><li>autorisez expressément Rogers à recueillir et à utiliser vos données de localisation personnelles courantes et historiques associées à tout appareil que vous utilisez aux termes de votre ou vos Ententes de service pour vous fournir des services de géolocalisation, étant entendu que vous pouvez vous désabonner de ces services en tout temps.</li><li>convenez expressément que les renseignements relatifs à votre compte peuvent être divulgués à d’autres membres de l’organisation de Rogers Communications Inc. et à ses agents, concessionnaires autorisés et distributeurs, afin de gérer votre compte, de répondre à vos questions, de faire le télémarketing (y compris au moyen de composeurs messagers automatiques) et de vous proposer d’autres produits et services offerts par les membres de l’organisation de Rogers Communications Inc. Si vous ne souhaitez pas recevoir de telles offres ou information, veuillez communiquer avec nous de l’une ou l’autre des façons indiquées au paragraphe 10e) ci-après.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Où seront stockés mes renseignements personnels?</strong></li></ol><p>Les renseignements personnels recueillis dans le cadre de la prestation des Services peuvent être enregistrés et traités au Canada ou à l’étranger et être soumis aux lois en vigueur dans d’autres territoires.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Rogers divulguera-t-elle mes renseignements personnels à des tierces parties?</strong></li></ol><p>À moins que vous ne fournissiez votre consentement explicite, ou que cette divulgation soit requise aux termes d’une obligation légale, toute l’information vous concernant que nous détenons, sauf votre nom, votre adresse et votre numéro de téléphone inscrit dans l’annuaire, est confidentielle et ne pourra être divulguée par nous à quiconque autre que :</p><ol type=\"i\"><li>vous;</li><li>une personne qui, selon notre jugement raisonnable, agit comme votre mandataire pour obtenir de l’information;</li><li>une autre compagnie de téléphone, dans la mesure où les renseignements sont requis pour offrir un service de téléphonie résidentielle efficace et rentable, que la divulgation se fait sur une base confidentielle et que l’information est utilisée uniquement à cette fin;</li><li>un fournisseur vous assurant des services reliés aux fonctions de téléphonie ou d’annuaire téléphonique, dans la mesure où une telle divulgation se fait sur une base confidentielle et que l’information est divulguée et utilisée uniquement à cette fin;</li><li>un agent mandaté par nous pour le recouvrement de vos créances ou pour toute autre fonction administrative, dans la mesure où l’information est divulguée et utilisée uniquement à ces fins;</li><li>un agent mandaté par nous pour évaluer votre solvabilité, dans la mesure où l’information est divulguée et utilisée uniquement à cette fin;</li><li>un corps policier lorsque nous avons des motifs raisonnables de croire que vous nous avez sciemment fourni des renseignements faux ou trompeurs ou que vous êtes engagé de quelque autre façon dans des activités illégales;</li><li>une autorité publique ou le mandataire d’une autorité publique si, selon notre jugement raisonnable, nous croyons que la divulgation de vos renseignements pourrait éviter ou atténuer un danger de mort ou de dommage matériel imminent;</li><li>une autorité publique ou le mandataire d’une autorité publique, aux fins des alertes publiques d’urgence, si l’autorité publique a conclu être en présence d’un danger imminent ou sur le point de se produire mettant en danger la vie, la santé ou la sécurité de tout individu et que le danger pourrait être évité ou minimisé par la divulgation de l’information.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>De quelle façon Rogers obtient-elle mon consentement à la divulgation de mes renseignements personnels?</strong></li></ol><p>Le consentement explicite à la divulgation peut être obtenu comme suit :</p><ol type=\"i\"><li>un consentement écrit;</li><li>une confirmation orale vérifiée par une tierce partie indépendante;</li><li>une confirmation électronique par l’utilisation d’un numéro sans frais;</li><li>une confirmation électronique par Internet;</li><li>un consentement oral pour lequel nous avons conservé un enregistrement audio; ou</li><li>un consentement donné par une autre méthode, dans la mesure où il existe un enregistrement documenté objectif de votre consentement créé par vous ou par un tiers indépendant.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Puis-je demander d’avoir un numéro de téléphone résidentiel non inscrit dans l’annuaire?</strong></li></ol><p>Vous pouvez choisir de payer pour avoir un numéro de téléphone résidentiel non inscrit dans l’annuaire; cependant, veuillez noter que les fournisseurs d’annuaires et de services de téléphoniste peuvent obtenir votre numéro de téléphone et votre adresse d’une source autre que nous. Par ailleurs, votre nom, votre adresse et votre numéro de téléphone seront accessibles par les fournisseurs de service 9-1-1, même si vous payez pour avoir un numéro de téléphone non inscrit.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Comment puis-je obtenir de l’information sur la protection de mes renseignements personnels chez Rogers?</strong></li></ol><p>Nos Politiques de protection de la vie privée d’entreprise et en ligne se trouvent à <strong>rogers.com/privee</strong>. Pour communiquer avec notre Agent de protection de la vie privée afin d’accéder à vos renseignements personnels conservés par Rogers, d’obtenir plus d’information à ce sujet, de formuler une plainte au sujet de la protection de la vie privée, ou d’obtenir un exemplaire de nos Politiques de protection de la vie privée, envoyez un courriel à l’adresse <a href=\"mailto:privacy@rci.rogers.com\"><strong>privacy@rci.rogers.com</strong></a> ou écrivez à notre Agent de protection de la vie privée, Groupe de sociétés Rogers, 333, rue Bloor Est, Toronto (ON) M4W 1G9.</p><ol class=\"tc-ol-headline\" start=\"9\"><li class=\"tc-headline2\"><strong>Garanties et limite de responsabilité</strong></li></ol><p>Veuillez noter que l’expression « <strong>Parties de Rogers</strong> » comprend Rogers et les sociétés membres de son groupe, ses partenaires, ses concédants de licence, ses concessionnaires, ses représentants, ses fournisseurs et ses mandataires (de même que leurs employés, dirigeants, administrateurs, actionnaires et représentants respectifs).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>L’Équipement est-il garanti?</strong></li></ol><p>L’Équipement peut être couvert par une garantie du fabricant ou une autre garantie. Veuillez consulter les documents remis avec votre Équipement pour obtenir des renseignements détaillés sur la garantie dont il est assorti, notamment l’objet de la garantie, la durée de celle-ci et les modalités de réclamation. L’Équipement peut également comporter d’autres programmes de protection facultatifs qui vous sont offerts à l’occasion.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Les Services sont-ils garantis?</strong></li></ol><p>Les Services fournis par Rogers peuvent être touchés par des facteurs indépendants du contrôle raisonnable de Rogers. Pour cette raison, vous reconnaissez et convenez que les Services ou l’accès aux Services, y compris le service d’urgence 9‑1‑1, les alertes publiques ou les services spéciaux, peuvent ne pas fonctionner correctement, ou même ne pas fonctionner du tout, dans les cas suivants :</p><ol type=\"i\"><li>si votre Équipement fait défaut, s’il n’est pas bien configuré, ou s’il ne respecte pas les exigences de Rogers;</li><li>si vous avez installé certaines applications de tiers sur votre Équipement;</li><li>en cas de panne du réseau ou de panne d’électricité prolongée;</li><li>si vous modifiez ou, dans certains cas, si vous déplacez l’Équipement;</li><li>après la suspension ou la résiliation de vos Services ou de votre compte.</li></ol><p>Dans les limites permises par la loi en vigueur :</p><ol type=\"i\"><li>les Parties de Rogers ne donnent aucune garantie ou assurance à l’égard du rendement, de la disponibilité, de la couverture, de l’utilisation sans interruption, de la sécurité, du prix ou du fonctionnement des Services, de l’Équipement <strong>(sauf en faveur des Résidents du Québec** conformément aux garanties légales)</strong> ou de tout produit, contenu, application, logiciel, service, installation, connexion ou réseau utilisé ou fourni par nous ou par des tierces parties (collectivement désignés l’« <strong>Offre</strong> »);</li><li>Rogers peut limiter toute Offre que vous pouvez acheter;</li><li>vous assumez la totalité des risques associés à l’utilisation, à l’accès, à la transmission, à la disponibilité, à la fiabilité, aux délais, à la qualité, à la sécurité et au rendement de l’Offre;</li><li>les Parties de Rogers n’offrent aucune représentation, garantie ni condition expresse ou implicite, y compris des garanties de propriété ou d’absence de contrefaçon et des garanties implicites de qualité marchande ou d’adéquation à un usage particulier, à l’égard de l’Offre.</li></ol><p><strong>Non applicable aux Résidents du Québec** :</strong></p><ol type=\"i\" start=\"5\"><li>toutes les représentations, garanties et conditions de quelque type que ce soit, expresses ou implicites, sont exclues;</li><li>aucun conseil ou renseignement, qu’il soit fait verbalement ou par écrit, que vous obtenez de la part de toute Partie de Rogers n’aura pour effet de créer une modalité, une condition, une représentation ou une garantie qui n’est pas expressément énoncée dans une Entente.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>De quelle façon Rogers limite-t-elle sa responsabilité?</strong></li></ol><p>À moins de mention contraire stipulée spécifiquement dans une Entente, dans les limites maximales permises par les lois applicables, <strong>et sauf à l’égard des Résidents du Québec** pour des dommages résultant du fait personnel d’une Partie de Rogers</strong>, les Parties de Rogers ne pourront être tenues responsables envers vous ou une tierce partie pour les éléments suivants :</p><ol type=\"i\"><li><strong>Non applicable aux Résidents du Québec** :</strong>tout dommage direct, indirect, spécial, consécutif, accessoire, économique ou punitif (y compris la perte de profits ou de revenus; les pertes financières; les pertes d’occasions d’affaires; la perte, la destruction ou l’altération de données, de fichiers ou de logiciels; le manquement à la confidentialité ou à la sécurité; les dommages matériels; les blessures corporelles; les décès ou toute autre perte prévisible ou imprévisible, quelle qu’en soit la cause) associés directement ou indirectement à l’Offre ou à la publicité, la promotion ou les déclarations relatives à un des éléments précités, même si nous avons été négligents ou si nous avions été avisés de la possibilité de tels dommages;</li><li><strong>Applicable uniquement aux Résidents du Québec** :</strong> tout dommage (y compris la perte de profits ou de revenus; les pertes financières; les pertes d’occasions d’affaires; la perte, la destruction ou l’altération de données, de fichiers ou de logiciels; le manquement à la confidentialité ou à la sécurité; les dommages matériels) associé directement ou indirectement à l’Offre;</li><li>toute Offre qui vous est fournie ou à laquelle vous avez accès par l’intermédiaire des Services, tous frais engagés relativement à une telle Offre, ou toute action qui est ou qui peut être prise au moyen de cette Offre, même si cette Offre vous a été facturée;</li><li>le rendement, la disponibilité, la fiabilité, les délais, la qualité, la couverture, l’utilisation sans interruption, la sécurité, le prix ou le fonctionnement de l’Offre;</li><li>toute erreur, inclusion ou omission en ce qui a trait aux annuaires ou aux répertoires téléphoniques;</li><li>le refus, la restriction, le blocage, l’interruption ou l’inaccessibilité des Services, y compris le 9-1-1, les alertes publiques ou les services spéciaux, l’Équipement ou les identifiants (y compris les numéros de téléphone);</li><li>la perte, le vol, l’endommagement ou l’expiration de l’Équipement, des identifiants, des mots de passe, des codes, des avantages, des rabais, des remises ou des crédits;</li><li>toute erreur ou omission ou tout délai en rapport avec le transfert des numéros de téléphone à un autre fournisseur de services de télécommunications ou en provenance d’un tel autre fournisseur de services de télécommunications, de même que toute restriction attribuable au transfert ou au fournisseur de services de télécommunications;</li><li>tout acte ou toute omission d’un fournisseur de services de télécommunications dont les installations sont utilisées pour établir une liaison avec des points à l’extérieur de notre zone de desserte; ou</li><li>toute réclamation ou tout dommage attribuable directement ou indirectement à des affirmations selon lesquelles l’utilisation, l’utilisation prévue ou une combinaison de l’Offre ou tout document transmis par l’entremise des Services contreviennent aux droits de propriété intellectuelle, industrielle ou contractuelle, ou au droit à la vie privée ou à quelque autre droit d’une tierce partie.</li></ol><p><strong>Non applicable aux Résidents du Québec** :</strong>Ces limites s’ajoutent à toutes les autres limites à la responsabilité des Parties de Rogers qui sont indiquées dans une Entente et qui s’appliquent à tout acte ou toute omission des Parties de Rogers, peu importe que ces actes ou ces omissions puissent donner lieu à un recours en vertu d’un contrat, d’un délit civil ou de quelque loi ou autre doctrine juridique.</p><p><strong></strong></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>D’autres limites de responsabilité s’appliquent-elles aux services d’urgence 9‑1‑1?</strong></li></ol><p><strong>Pour les Services sans fil :</strong></p><p>Nous ne sommes pas responsables de ce qui suit :</p><ol type=\"i\"><li>diffamation ou atteinte aux droits d’auteur inhérents au matériel ou aux messages transmis par l’intermédiaire de notre réseau à partir de votre propriété ou de vos locaux ou enregistrés à partir de votre équipement ou du nôtre;</li><li>dommages causés par vos actes, par défaut, par négligence ou par omission de votre part dans l’utilisation ou la manipulation de l’équipement que nous fournissons;</li><li>dommages causés par toute transmission illégale, de quelque façon que ce soit, de matériel ou de messages par l’intermédiaire de notre réseau en votre nom; ou</li><li>tout acte, toute omission ou toute négligence de la part d’autres entreprises ou systèmes de télécommunications lorsque leurs installations sont utilisées aux fins d’établir une connexion à partir ou en direction de vos installations et de votre équipement. À l’exception des cas de négligence de notre part entraînant des blessures, la mort ou des dommages à votre propriété ou à vos locaux, notre responsabilité pour cause de négligence relative à la prestation obligatoire de services d’urgence 9-1-1 se limite à un montant de <strong>20 $</strong> ou à <strong>3</strong> fois le montant, s’il y a lieu, auquel vous auriez autrement droit à titre de remboursement pour la prestation de Services défectueux en vertu d’une Entente, selon le montant le plus élevé. Toutefois, notre responsabilité n’est pas limitée par le présent article en cas de faute délibérée, de négligence grave ou de conduite anticoncurrentielle de notre part ou en cas de bris de contrat résultant d’une négligence grossière de notre part.</li></ol><p><strong>Pour les Services de téléphonie résidentielle :</strong></p><p>Pour que les services d’urgence 9‑1‑1 puissent fonctionner convenablement avec les Services de téléphonie résidentielle, vous devez utiliser l’adaptateur qui fait partie de l’Équipement que nous vous avons fourni (l’« <strong>Adaptateur</strong> ») et les autres éléments d’Équipement à votre adresse de service. Nous ne pourrons être tenus responsables envers vous ou une tierce partie pour tout manquement à cette exigence. Les Services de téléphonie résidentielle pourraient ne pas fonctionner normalement, ou ne pas fonctionner du tout, dans les cas suivants :</p><ol type=\"i\"><li>si votre Adaptateur ou les autres éléments de l’Équipement font défaut ou ne sont pas configurés correctement;</li><li>en cas de panne du réseau de câble ou d’une panne d’électricité prolongée;</li><li>si vous modifiez ou déplacez votre Adaptateur ou un autre élément de l’Équipement à un endroit autre que votre adresse de service; ou</li><li>après la suspension ou la résiliation de vos Services ou de votre compte.</li></ol><p>Nous ne pourrons être tenus responsables envers vous ou une tierce partie en cas d’incapacité à utiliser les Services de téléphonie résidentielle ou d’obtenir l’accès aux services d’urgence 9‑1‑1 en raison des limites décrites au présent article.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Existe-t-il des circonstances dans lesquelles je devrai indemniser Rogers?</strong></li></ol><p>Vous indemniserez et tiendrez à couvert les Parties de Rogers de quelque réclamation, perte, dommages, coûts et dépenses que ce soit (y compris, sans limitation, les frais juridiques raisonnables et autres frais de règlement de litiges), encourus par les Parties de Rogers liés à la violation, à la violation présumée ou au détournement par vous du droit de propriété intellectuelle, industrielle ou contractuelle, ou toute atteinte au droit à la vie privée ou à quelque autre droit d’une tierce partie, ou à tout présumé libelle ou à toute présumée diffamation qui serait intenté ou allégué contre vous par une tierce partie.</p><ol class=\"tc-ol-headline\" start=\"10\"><li class=\"tc-headline2\"><strong>Dispositions générales</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Comment puis-je résoudre une plainte ou un différend avec Rogers?</strong></li></ol><p>Si vous avez une plainte ou une préoccupation non résolue, nous vous invitons à remplir et à soumettre un formulaire Signaler un problème (que vous trouverez à l’adresse <a href=\"http://www.rogers.com/contacteznous\"><strong>rogers.com/contacteznous</strong></a>). Nous vous répondrons le jour ouvrable suivant. Si vous n’êtes pas satisfait de la façon dont un membre de notre direction a résolu votre plainte, vous avez également la possibilité de vous adresser au Bureau du President ou directement au bureau de l’Ombudsman.</p><p><strong>Non applicable aux Résidents du Québec** : Dans les limites maximales permises par la loi applicable,</strong>à moins d’un accord de notre part, toute réclamation ou tout différend, de nature contractuelle ou délictuelle, en vertu de la loi ou d’un règlement, ou toute autre réclamation ou tout autre différend, de nature préexistante, présente ou future, découlant de quelque façon des éléments suivants ou s’y rapportant, sera réglé par arbitrage final et liant les parties, à l’exclusion des tribunaux :</p><ol type=\"i\"><li>une Entente;</li><li>les Services ou l’Équipement;</li><li>les déclarations verbales ou écrites, la publicité ou les promotions associées à une Entente, aux Services ou à l’Équipement; ou</li><li>la relation découlant d’une Entente.</li></ol><p><strong>Le cas échéant,</strong>l’arbitrage sera mené dans la province où vous habitez et sera simplifié et mené de façon expéditive par <strong>UN</strong> arbitre conformément aux lois et règlements en vigueur ayant trait à l’arbitrage commercial dans la province ou dans l’administration où vous habitez à la date de l’avis. Rogers paiera tous les frais raisonnables associés à cet arbitrage. Tout arbitrage sera mené conformément à notre Protocole d’arbitrage, lequel est disponible à l’adresse <strong>rogers.com/modalites</strong>.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Qu’arrive-t-il si une partie d’une Entente devient inexécutoire ou cesse de s’appliquer?</strong></li></ol><p>Si une portion d’une Entente est inexécutoire, ses autres dispositions demeurent pleinement en vigueur. Notre défaut à faire appliquer de façon stricte une des dispositions d’une Entente ne constitue pas une renonciation à quelque disposition ou à quelque droit que ce soit à l’égard de la présente Entente. Ni le cours des affaires entre nous ni les pratiques commerciales ne pourront être invoqués pour modifier quelque disposition que ce soit d’une Entente.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Comment puis-je obtenir une version en anglais des présentes Modalités?</strong></li></ol><p>Si vous souhaitez obtenir une version en anglais des présentes Modalités, consultez le site Web à l’adresse <strong>rogers.com/terms</strong> ou demandez-en une copie en magasin.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Quelles lois s’appliquent aux présentes Modalités et aux autres parties de mon Entente?</strong></li></ol><p>Chaque Entente est régie exclusivement par les lois de la province où se situe votre adresse de facturation, et vous reconnaissez et acceptez la compétence exclusive des tribunaux de cette province. Toutefois, si votre adresse de facturation est située à l’extérieur du Canada, cette Entente sera régie exclusivement par les lois de la province d’Ontario, et vous reconnaissez et acceptez la compétence des tribunaux de l’Ontario. <strong>Veuillez noter que vos droits et recours peuvent varier selon chaque province.</strong><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Comment puis-je communiquer avec Rogers?</strong></li></ol></p><p>Pour communiquer avec nous :</p><ol type=\"i\"><li>rendez-vous dans un magasin Rogers;</li><li>composez le 1‑888‑ROGERS-1 (1-888-764-3771) ou, à partir de votre sans-fil Rogers, composez *611 (cet appel est sans frais);</li><li>visitez le <strong>rogers.com/contacteznous</strong> pour clavarder en direct;</li><li>envoyer une télécopie au numéro 1-800-219-6473; ou</li><li>écrivez au Service à la clientèle de Rogers, à l’adresse au 100, rue Westmorland, Moncton (Nouveau-Brunswick) E1C 0G1.</li></ol><p>Tout avis de réclamation doit être transmis au Service juridique de Rogers, 333, rue Bloor Est, Toronto (ON) M4W 1G9, et cet avis sera réputé avoir été donné à la date à laquelle il est envoyé par l’expéditeur.</p><p><strong>*</strong>« <strong>Résidents de Terre-Neuve-et-Labrador</strong> » désigne les résidents de Terre-Neuve-et-Labrador qui concluent une Entente à laquelle s’applique la loi intitulée <em>Consumer Protection and Business Practices Act</em> (Terre-Neuve-et-Labrador);</p><p>** « <strong>Résidents du Québec</strong> » désigne les résidents du Québec qui concluent une Entente à laquelle s’applique la <em>Loi sur la protection du consommateur</em> (Québec).</p><p>©2015</p><p>06/15</p>");
$templateCache.put("views/localization/rogers-terms-of-service.html","<p class=\"tc-heading\">ROGERS TERMS OF SERVICE</p><ol class=\"tc-ol-headline\"><li class=\"tc-headline2\"><strong>Introductory Information</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>How do the Rogers Terms of Service apply to me?</strong></li></ol><p>These Rogers Terms of Service (&ldquo;<strong>Terms</strong>&rdquo;) govern your use of:</p><ol type=\"i\"><li>the Rogers services that you subscribe to or purchase under a service agreement or receive from or through Rogers, including wireless and residential services (&ldquo;<strong>Services</strong>&rdquo;); and</li><li>any device or equipment used to access the Services or used with the Services (&ldquo;<strong>Equipment</strong>&rdquo;).</li></ol><p>In these Terms, &ldquo;<strong>Rogers</strong>&rdquo;, &ldquo;<strong>us</strong>&rdquo;, &ldquo;<strong>we</strong>&rdquo; and &ldquo;<strong>our</strong>&rdquo; means the Rogers entity named in the service agreement for the specific Service you subscribe to. These Terms do not apply to services offered by Rogers Media Inc. or its subsidiaries.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>How do the Rogers Terms of Service work with my service agreement and other materials made available to me?</strong></li></ol><p>These Terms work together with the following materials to form your complete agreement (&ldquo;<strong>Agreement</strong>&rdquo;) with us, and provide you with the important information you need to help you fully understand your Services:</p><ol type=\"i\"><li>Your <strong>service agreement</strong> for the specific Service you subscribe to (such as a wireless service agreement or residential service agreement).</li><li>Our <strong>Acceptable Use Policy</strong>, which sets out the rules, policies and limits you must abide by when using the Services. Our Acceptable Use Policy lists examples of prohibited activities and unlawful or inappropriate content and gives us the right to remove content and/or suspend or terminate your Services if you violate the policy.</li><li>Our <strong>Privacy Policy</strong>, which sets out our policies in relation to the collection, use and disclosure of your personal information. Our Privacy Policy details why we collect customer information, how we use it and how we share it, and specifies how to contact us if you would like more information on our personal information handling practices.</li><li>Any <strong>additional terms and conditions</strong> that may apply to a specific Service that you subscribe to or use.</li><li>Any <strong>Rogers brochure or material describing your Services or products you purchase</strong>.</li></ol><p>Your Agreement, with any amendments, is the entire agreement between you and Rogers for the applicable Services. Each Service that you subscribe to is a separate Agreement with us. If there is any inconsistency between the materials listed above and these Terms, these Terms will prevail.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Who is responsible for complying with the Agreement?</strong></li></ol><p>You, as account holder, are responsible to comply with the Agreement. Among other things, you are responsible for:</p><ol type=\"i\"><li>all charges on your account;</li><li>ensuring that anyone who uses Services under your account or with your authorization complies with the Agreement;</li><li>ensuring that others do not gain unauthorized access to your account and your Services, including by protecting the security of any user names or passwords relating to your account;</li><li>ensuring that any information you have provided to us is up-to-date and accurate, and to let us know if it changes.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>May I transfer my Agreement to someone else?</strong></li></ol><p>You will need our prior permission if you want to assign or transfer an Agreement. We may assign or transfer an Agreement or any of our rights or responsibilities under an Agreement without your permission.</p><p></p><p></p><ol class=\"tc-ol-headline\" start=\"2\"><li class=\"tc-headline2\"><strong>Service Term, Changes and Cancellation</strong></li></ol><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>What are the categories of Services covered by my Agreement?</strong></li></ol><p>The Services are categorized as follows:</p><ol type=\"i\"><li>&ldquo;<strong>Term Services</strong>&rdquo; are Services that you subscribe to for a committed period of time as indicated on your applicable service agreement (&ldquo;<strong>Term</strong>&rdquo;);</li><li>&ldquo;<strong>Month-to-Month Services</strong>&rdquo; are Services that you subscribe to on an ongoing basis, but not with a Term; and</li><li>&ldquo;<strong>Pay-Per-Use Services</strong>&rdquo; are Services that you use on a per-usage basis (which may be a one-time usage, or usage for a set period of time, such as one day or one week), but not on an ongoing basis.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>What is the term of my Agreement?</strong></li></ol><p>The term of each Agreement starts on the initial activation date of the Services or the Equipment, whichever is earlier (&ldquo;<strong>Activation Date</strong>&rdquo;). At the end of the Term for a Term Service, the Service will automatically become a Month-to-Month Service and you will keep your existing Service and Agreement with us, unchanged, until they are changed or cancelled in accordance with these Terms.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Can Rogers change my Services or my Agreement?</strong></li></ol><p>Yes, Rogers may change your Services or Agreement as described below.</p><p><strong>For wireless Services:</strong></p><p>We may change any aspect of a Month-to-Month Service and the corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. We may also change aspects of a Term Service and the corresponding Agreement, other than a key term as defined in the Canadian Radio-television and Telecommunications Commission (CRTC)&rsquo;s Wireless Code, upon at least <strong>30</strong> days&rsquo; prior written notice to you. In either case, we will send you the written notice by bill message, text message, letter or e-mail and will explain the change and when it will take effect.</p><p><strong>For residential Services:</strong></p><p><strong>Not applicable to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong>We may change any aspect of a Month-to-Month Service or Term Service as well as any term or provision of an Agreement, upon prior written notice to you by bill message, text message, letter or e-mail. If you do not accept the change, your remedy will be to cancel the affected Services or Agreement by providing us with notice of cancellation under Section 2(e) below within <strong>30</strong> days of receiving our notice of change (unless we specify a different notice period or different remedy).</p><p><strong>Applicable only to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong>We may change any aspect of a Month-to-Month Service and the corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. We may also change a Term Service and the corresponding Agreement upon at least <strong>30</strong> days&rsquo; prior written notice, but will not change the price, term, nature or any other essential elements of that Term Service or that Agreement. In either case, we will send you the written notice by bill message, text message, letter or e-mail and it will contain the new or amended term or provision, the former version of that term or provision (if applicable), the date that the amendment will come into force, and your rights. If a change to a Month-to-Month Service or a Term Service entails an increase in your obligations or a decrease in our obligations and if you do not accept that change, your remedy will be to cancel the affected Services or Agreement without an Early Cancellation Fee (defined below) by providing us with notice of cancellation under Section 2(e) below no later than <strong>30</strong> days after the amendment takes effect.</p><p><strong>For Pay-Per-Use Services:</strong> Pay-Per-Use Services are subject to availability and may be changed or cancelled by Rogers at any time without prior notice to you.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>May I change my Services?</strong></li></ol><p>You may change your Services at any time by contacting us in any of the ways set out in Section 10(e) below. You may be subject to an administrative charge in accordance with Section 3(d) below. You may also be charged a fee to change your Service if one is specified in your service agreement for that Service. Please note that if you wish to change a Service, you may only be able to change to a Service that is currently available in market. Also please note that any Service you remove may no longer be available.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>How can I cancel my Services and when does cancellation take effect?</strong></li></ol><p>Unless otherwise permitted by applicable law, you may cancel any or all of your Services and any corresponding Agreement at any time by contacting us in any of the ways set out in Section 10(e) below. Cancellation takes effect on the day that Rogers receives notice of the cancellation, or a future date specified in that notice (if applicable), whichever is later. Applicable charges continue until that date. However, if you only cancel a television Service add-on or an internet Service add-on, applicable charges continue to apply until your next billing date for that add-on.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Will I be charged an early cancellation fee if I cancel my Service(s)?</strong></li></ol><p>If you subscribe to a Term Service that you cancel before the end of its Term, you will be charged an early cancellation fee as described in the service agreement for that Term Service (&ldquo;<strong>Early Cancellation Fee</strong>&rdquo;).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"7\"><li><strong>What happens if I transfer my Service(s) to another service provider?</strong></li></ol><p>Transferring your Service(s) to another service provider is a cancellation of the applicable Service(s) and an Early Cancellation Fee may apply if the transfer results in the cancellation of a Term Service before the end of its Term.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"8\"><li><strong>Can Rogers cancel my Services and when does cancellation take effect?</strong></li></ol><p><strong>Not applicable</strong><strong>to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> Unless otherwise permitted by applicable law, Rogers may cancel any or all of your Services or accounts and any corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. Applicable charges continue until the cancellation date.</p><p><strong>Applicable only to Residents of Newfoundland* or</strong><strong>Residents of Qu&eacute;bec**:</strong> Unless otherwise permitted by applicable law, Rogers may cancel any or all of your Services or accounts and any corresponding Agreement, as long as we give you at least <strong>60</strong> days&rsquo; prior written notice. If you have subscribed to a Term Service, then we may cancel that Service: (i) (<strong>applicable only to Residents of Newfoundland*</strong>) only if we no longer have the technical ability to provide that Term Service, or (ii) (<strong>applicable only to Residents of Qu&eacute;bec**</strong>) only pursuant to Sections 1604, 2126 and 2129 of the <em>Civil Code of Qu&eacute;bec</em>. Applicable charges continue until the cancellation date. <strong>Applicable only to Residents of Newfoundland*:</strong>If your account has a credit balance over <strong>$10</strong> on your final bill, then we will refund that balance to you within <strong>60</strong> days of the date of that bill. Discretionary credits will not be refunded.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"9\"><li><strong>Can Rogers suspend or cancel my Services without notice?</strong></li></ol><p>We may restrict, suspend, block, disconnect or cancel any or all of your Services, accounts or identifiers in any way, including 9-1-1 service, without notice or liability to you, if:</p><ol type=\"i\"><li>you are in breach of an Agreement, including for non-payment;</li><li>you exceed your credit limit;</li><li>you fail to provide or maintain a reasonable security deposit or other credit requirement when we ask you to;</li><li>you agree to a deferred payment arrangement with us and fail to comply with its terms;</li><li>you exceed our reasonable usage limits;</li><li>you have given us false, misleading or outdated information;</li><li>we reasonably suspect or determine that any of your account, identifiers, Services or Equipment is the subject of fraudulent, unlawful or improper usage or usage that adversely affects our operations or the use of our services, facilities or networks by others;</li><li>you harass, threaten or abuse us or our employees or agents;</li><li>you fraudulently or improperly seek to avoid payment to us;</li><li>we need to install, maintain, inspect, test, repair, remove, replace, investigate, protect, modify, upgrade or improve the operation of the Services, the Equipment or our facilities or networks;</li><li>any account or service on which your Services depend is cancelled for any reason; or</li><li>we reasonably believe that there is an emergency or extreme circumstance that would warrant that action.</li></ol><p>If we restrict, suspend, block, disconnect or cancel your Services or accounts:</p><ol type=\"i\"><li>you must pay any amounts owing;</li><li>we may also restrict, suspend, block, disconnect or cancel, without notice or liability, your Services under any other agreement or account that you may have with us or a related Rogers entity (including accounts that may be in good standing);</li><li>you may be charged for any costs incurred by us or any related Rogers entity in connection with your breach of these Terms, including costs incurred to enforce your compliance;</li><li>your access to emergency or special needs services (e.g., 9-1-1) may also be restricted, suspended, blocked, disconnected or cancelled; and</li><li>your rates for services with related Rogers entities may change in accordance with the terms of those services.</li></ol><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"10\"><li><strong>Will these Terms still apply once my Services are cancelled?</strong></li></ol><p>Certain provisions of these Terms may still apply as they may still be relevant even after cancellation of all your Services. Specifically, Sections 1(b)-(d), 2(e)-(j), 4(b)-(c), 5(c), 6(d), 8(b)-(d), 8(f), 9, 10(b)-(d) and the arbitration provisions of Section 10(a) will continue to apply to you after cancellation of your Agreement.</p><p></p><ol start=\"3\" class=\"tc-ol-headline\"><li class=\"tc-headline2\"><strong>Account, Charges and Billing Information</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>How does Rogers bill me for Services?</strong></li></ol><p>Service charges will start on the Activation Date and are billed in advance. Unless we both agree to a different arrangement, your billing period runs for one month, and ends on the bill date noted on the top of your bill. Your Activation Date and billing period won&rsquo;t always start on the same day. When this happens, your Service charges and allotted usage are pro-rated for the period between your Activation Date and your bill date. Usage charges, such as additional data, airtime, long distance, movie or event purchases and roaming are billed after you use them. We may bill you for a charge up to <strong>6</strong>months from the date the charge was incurred.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>When is my bill payment due?</strong></li></ol><p>Charges on your account are due and payable in full from the date of your bill. If you are paying by mail or through a financial institution, please allow adequate time for your payment to reach us before the required payment date. You are responsible for all charges on your account.&nbsp;</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>What if I don&rsquo;t pay my bill on time?</strong></li></ol><p>If we do not receive payment of an amount due on your account by the specified required payment date, it will be subject to a late payment charge of <strong>2</strong><strong>%</strong>per month, calculated and compounded monthly on the outstanding amount (<strong>26.82</strong><strong>%</strong>per year) from the date of the first bill on which it appears until the date we receive that amount in full. You agree that we can charge any unpaid and outstanding amount, including any late payment charges, on any pre-authorized payment method on your account (e.g., a credit card or bank account withdrawal).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Will I be subject to any administrative charges?</strong></li></ol><p>We may apply administrative charges in connection with your account, including as a result of the following:</p><ol type=\"i\"><li>price plan change;</li><li>phone number (or other identifier) change;</li><li>bill reprint requests;</li></ol><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong></p><ol type=\"i\" start=\"4\"><li>collection efforts due to non-payment;</li><li>returned or rejected payments; and/or</li><li>the restoral of Service.</li></ol><p>A list of these charges is available on request, or at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/charges\"><strong>rogers.com/charges</strong></a>, and forms part of these Terms.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>What if I do not understand or disagree with a charge on my bill?</strong></li></ol><p>Any questions or discrepancies regarding charges must be reported to us within <strong>90</strong>days of the date of the applicable bill. Failure to notify us within this time period means that you have accepted those charges. If any of those discrepancies resulted in unauthorized or incorrect charges on your account, then we will reverse those charges within <strong>30</strong> days of receiving notice from you.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>How do discounts and promotions work?</strong></li></ol><p>We will apply a discount, promotion or benefit to your account as long as you remain eligible for it. We may check your eligibility from time to time, and if you become ineligible to receive that discount, promotion or benefit for any reason, we may remove it, and/or transfer your Service to a comparable Service plan.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"7\"><li><strong>How is wireless local and long distance airtime charged?</strong></li></ol><p>Local and long distance airtime charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed call (made or received). The airtime for the entire call is charged based on the applicable rate at the beginning of the call. Airtime charges (plus long distance, if applicable) apply to completed or answered calls from the moment you press SEND until you press END and includes the ring time. For international calls or while roaming, you may be charged regardless of whether the call is completed.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"8\"><li><strong>How does Rogers determine if I&rsquo;m on a long distance wireless call?</strong></li></ol><p>Wireless local calling areas are the areas in which you can make or receive calls without incurring long distance charges. Wireless calls are defined as local or long distance based on local calling areas. Your location at the time of the call, your wireless phone number and the phone number called are all important factors in determining local calling areas and wireless long distance. Your &ldquo;Incoming Local Calling Area&rdquo; is based on the geographical location associated with your wireless number. All calls that you receive while you are in your Incoming Local Calling Area are local. All calls that you receive while you are outside your Incoming Local Calling Area are long distance. Your &ldquo;Outgoing Local Calling Area&rdquo; is determined by your physical location. If you dial a number that is local to your physical location, then it is a local call. If you dial a number that is long distance to your physical location, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside the geographical location associated with your wireless number, regardless of your physical location. Visit rogers.com/longdistance for current long distance rates.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"9\"><li><strong>How is home phone long distance calling charged and how does Rogers determine if I&rsquo;m on a long distance home phone call?</strong></li></ol><p>Long distance charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed long distance call you make. For international calls, you may be charged regardless of whether the call is completed. For home phone Services, calls are defined as local or long distance based on local calling areas, and your local calling area depends on your home phone number. If you dial a number that is long distance to your home phone number, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside your local calling area.</p><ol class=\"tc-ol-headline\" start=\"4\"><li class=\"tc-headline2\"><strong>Deposit and Credit Requirements</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Does Rogers require security deposits or other payment or credit requirements?</strong></li></ol><p>Yes, we may require a security deposit or impose other payment or credit requirements such as interim payments, mandatory pre-payments, or pre-authorized payments.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>How are security deposits used?</strong></li></ol><p>Any security deposit you provide to us will be kept for at least <strong>12</strong> months, unless your Services are cancelled sooner. After <strong>12</strong> months, we may release and apply the security deposit against your account balance if we determine that your payment history has been satisfactory or that you have otherwise met our financial criteria for the return of the security deposit. We may apply your security deposit toward your account if you do not pay your bill and we may require you to replenish the security deposit after use. We will notify you when we apply all or part of any security deposit. We will return to you any security deposit with applicable interest within <strong>30</strong> days of cancellation of your Services or once we have determined that the conditions for returning the security deposit have been met.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Will I earn any interest on security deposits?</strong></li></ol><p>Yes, you will earn interest on your security deposit with us, using the Bank of Canada&rsquo;s overnight rate in effect at the time, plus <strong>1</strong> percent, on the basis of the actual number of days in a year, accruing on a monthly basis. Interest is earned starting from the date we collect a security deposit from you (but no earlier than required under applicable legislation or regulation) until the date we return it to you.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Will Rogers impose a credit limit on my account?</strong></li></ol><p>Upon notice to you, we may assign or change a credit limit on your account at any time. Service may be suspended at any time to any and all of your accounts if your balance, including unbilled usage and pending charges, fees and adjustments, exceeds this limit. Recurring service charges continue to apply during any suspension of Services.</p><ol class=\"tc-ol-headline\" start=\"5\"><li class=\"tc-headline2\"><strong>Your Use of the Services</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Do I own my phone number?</strong></li></ol><p>You do not own any phone number, e-mail address or other identifier assigned to you. We may change or remove an identifier at any time.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Does Rogers monitor the content that I transmit when I use the Services?</strong></li></ol><p>We have the right, but not the obligation, to monitor or investigate any content that is transmitted using the Services (other than voice Services) or the Equipment. We may also access or preserve content or information to comply with legal process in Canada or foreign jurisdictions, operate the Services, ensure compliance with an Agreement, or protect ourselves, our customers or the public.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>What are my responsibilities relating to Rogers or third party software or content?</strong></li></ol><p>All trademarks, copyright, brand concepts, names, logos and designs that we use are intellectual property assets, registered or otherwise, of or used under license by Rogers Communications Inc. or of one of its affiliates. All are recognized as valuable assets of their respective owners, and you may not display, copy or use them in any manner for commercial or any other purpose.</p><p>Any software or content that you receive or purchase through Rogers or our third party storefronts is for your own personal, non-commercial use. This software or content remains our property or that of our licensors or content providers, as applicable. You may not:</p><ol type=\"i\"><li>copy, distribute, transfer or sell any of this software or content;</li><li>modify, alter or tamper with any of this software or content;</li><li>reverse engineer, decompile or disassemble any of this software;</li><li>attempt to defeat, avoid, by-pass, remove, deactivate or otherwise circumvent any software protection mechanisms.</li></ol><p>You must also take reasonable steps to protect this software or content from theft, loss or damage. Please be aware that software or content may from time to time automatically and, without notice to you, cause your Equipment to access the internet incurring data usage and/or overage charges.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>What do I need to know about the Yahoo! Services available to me?</strong></li></ol><p>Yahoo! Inc. and its affiliates may provide Rogers internet Service customers with access to a collection of resources, including various communications tools and content (the &ldquo;<strong>Yahoo! Services</strong>&rdquo;). When you use the Yahoo! Services, the Yahoo! terms of service, guidelines and rules (&ldquo;<strong>Yahoo! Terms</strong>&rdquo;) applicable to such services that are posted on the pages where you access these services govern your use of the Yahoo! Services. By using the Yahoo! Services you agree to be bound by the Yahoo! Terms which are incorporated by reference into an Agreement. With respect to Rogers internet Services and the Yahoo! Services, the obligations of Rogers and Yahoo! are several and not joint. To contact Yahoo! Inc. regarding the Yahoo! Services only: write to Customer Care, 701 First Avenue, Sunnyvale, CA, 94089, USA. Information about how your personal information is treated when using the Rogers internet Services andYahoo! Services is available at <a href=\"http://www.rogers.yahoo.com/privacy\"><strong>rogers.yahoo.com/privacy</strong></a>.</p><p></p><ol class=\"tc-ol-headline\" start=\"6\"><li class=\"tc-headline2\"><strong>Equipment</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Is Equipment new or refurbished?</strong></li></ol><p>Equipment that you purchase from us is new, unless otherwise indicated. Equipment that you rent from us is refurbished, unless otherwise indicated, and is based on availability. If you have purchased Equipment from us and have received a subsidy on that Equipment resulting in a charge of <strong>$0</strong>, please note that that Equipment has been provided to you as a subsidized good and not a free good.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>May I upgrade my Equipment?</strong></li></ol><p>You may upgrade your Equipment at any time by contacting us in any of the ways set out in Section 10(e) below. You may be subject to an administrative charge in accordance with Section 3(d) above. If, in connection with your Equipment upgrade, you are subscribing to a new Term and cancelling a previous Term early, you will be charged an Early Cancellation Fee. Please note that if you wish to upgrade your Equipment, you may also be required to change to a Service that is currently available in market. Also please note that any Service or Equipment you remove may no longer be available.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Is my Equipment locked or restricted to the Rogers network or Services?</strong></li></ol><p><strong>For wireless Services:</strong></p><p>Your wireless device is locked and restricted to be used only on the Rogers network, but may also be used on the networks operated by any of the carriers with which we have roaming agreements. If you attempt to unlock your device it may become permanently unusable and may violate the software licence agreement for your device. If you would like to unlock your wireless device, the Device Unlock Fee set out in your wireless service agreement will apply. If you were given a device subsidy, we will only unlock your device after the first <strong>90</strong> days of your Term. Please also note that for the first <strong>90</strong> days following the Activation Date, if you are roaming off the Rogers network, your Service will be restricted from placing outgoing calls to destinations other than those that have a North American area code (including Canada and the USA) and the destination at which are located while placing the call (not applicable to prepaid service).</p><p><strong>For residential Services:</strong></p><p>Purchased and rental Equipment are to be used only with Rogers Services at the service address identified on your account. If you attempt to tamper with any Equipment, it may become permanently unusable and may violate the software licence agreement for that Equipment.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Will Rogers ever need access to my property?</strong></li></ol><p>For residential Services, you authorize us and our representatives to enter or have access to your premises as necessary at mutually agreed upon times to install, maintain, inspect, repair, remove, replace, investigate, protect, modify, upgrade or improve the operation of our services, the Equipment or our facilities or networks. If any of your Services or accounts have been cancelled, then you authorize us and our representatives to enter or have access to your premises to disconnect the Services and remove our Equipment, as applicable.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Who is responsible for ensuring that my Equipment is up to date?</strong></li></ol><p>Equipment and related software may have to meet certain minimum requirements and be maintained in certain ways and in certain locations in order to access the Services or for the proper operation of the Services (e.g., 9-1-1 services). Those requirements may change from time to time and you are responsible for updating or maintaining your Equipment and software as necessary to meet those requirements. We may provide software updates for the Equipment for the continued operation of the Services or the Equipment. Likewise, from time to time we may have to modify or remove previous software features in order to introduce new features to ensure that the Equipment remains compatible with technological advancements. If your Equipment or software is not up to date, we may not be able to provide you with applicable customer support.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>What are my responsibilities relating to the Equipment?</strong></li></ol><p>You are solely responsible for:</p><ol type=\"i\"><li>any access to the Equipment;</li><li>providing any additional connections, as well as inside wiring and home phone terminal equipment, that are not provided by us;</li><li>reconnecting any of your equipment and facilities as necessary after cancellation of your Services;</li><li>maintaining the security and privacy of your property and your transmissions using the Services, the Equipment or our facilities or networks;</li><li>protecting against any breaches of security or privacy or other risks involved in installing, using, maintaining or changing the Services or the Equipment; and</li><li>ensuring that there are no unauthorized attachments to the Equipment or our cable ( e.g., for television Equipment, only <strong>1</strong> television may be attached to any outlet).</li></ol><p>Except for Equipment that you have fully paid for, all Equipment we install or provide to you remains our property. For all Equipment we own, you must:</p><ol type=\"i\"><li>take reasonable care of it;</li><li>not sell, lease, mortgage, transfer, assign or encumber it;</li><li>not re-locate it without our knowledge and permission; and</li><li>return it to us at your own expense upon cancellation of the Services to which the Equipment is related.</li></ol><p>If our Equipment is lost, damaged, stolen, sold, leased, mortgaged, transferred, assigned, encumbered or not returned, you must immediately notify us. You agree to pay us the undiscounted retail value of that Equipment, together with any costs we incur in seeking possession of it.</p><ol class=\"tc-ol-headline\" start=\"7\"><li class=\"tc-headline2\"><strong>Prepaid Wireless Service</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>If I am a Rogers prepaid wireless customer, how can I check my prepaid wireless usage balance?</strong></li></ol><p>You can check your usage balance from your prepaid wireless device by calling *611 (it&rsquo;s a free call).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>If I change my mind about adding to my prepaid wireless balance, can I get a refund?</strong></li></ol><p>No. Deposits into your account for prepaid wireless Services are non-refundable.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>What if I don&rsquo;t use my prepaid wireless Service on a regular basis?</strong></li></ol><p>If your prepaid wireless account balance remains at <strong>$0</strong> for <strong>6</strong>consecutive months or if required payments towards your account are not made or are returned, for any reason, your prepaid wireless identifier (e.g., phone number or PIN number) will be deactivated. Please also note any prepaid wireless balance may have an expiry date as indicated.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Other than usage charges, are there any additional fees associated with prepaid wireless Service?</strong></li></ol><p>We will deduct a 9-1-1 Emergency Access Fee (non-government fee) for the provision of access to 9-1-1 service and any applicable 9-1-1 provincial government fee, once per month from your prepaid wireless account (there is no airtime charge for calls made from your wireless device to 9-1-1). For more information, please visit <a href=\"http://www.rogers.com/911\"><strong>rogers.com/911</strong></a>.</p><ol class=\"tc-ol-headline\" start=\"8\"><li class=\"tc-headline2\"><strong>Your Privacy</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>What can Rogers do with my account information and personal information?</strong></li></ol><p>By entering into an Agreement, you expressly:</p><ol type=\"i\"><li>authorize Rogers to collect and use your current and historical personal location information associated with any device you use under your Agreement(s) in order to provide geo-location services to you, with the ability to opt-out of these services at any time.</li><li>agree that your account information may be disclosed to other members of the Rogers Communications Inc. organization, and to our agents, authorized dealers and distributors to service your account, respond to your questions, telemarket (including by way of automatic dialing and announcing devices), and promote additional products and services offered by members of the Rogers Communications Inc. organization. If you do not wish to receive these offers or information, please contact us in any of the ways set out in Section 10(e) below.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Where will my personal information be stored?</strong></li></ol><p>Personal information collected in connection with the provision of the Services may be stored and processed in or outside Canada and may be subject to the laws of other jurisdictions.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Will Rogers disclose my personal information to any outside parties?</strong></li></ol><p>Unless you provide express consent or disclosure is required pursuant to a legal power, all information regarding you kept by us, other than your name, address and listed phone number, is confidential and may not be disclosed by us to anyone other than:</p><ol type=\"i\"><li>you;</li><li>a person who, in our reasonable judgment, is seeking the information as your agent;</li><li>another telephone company, provided the information is required for the efficient and cost-effective provision of home phone service and disclosure is made on a confidential basis, with the information to be used only for that purpose;</li><li>a company involved in supplying phone or phone directory-related services, provided the information is required for that purpose and disclosure is made on a confidential basis, with the information to be used only for that purpose;</li><li>an agent retained by us in the collection of your account or to perform other administrative functions for us, provided the information is required for and used only for that purpose;</li><li>an agent retained by us to evaluate your creditworthiness, provided the information is required for and is to be used only for that purpose;</li><li>a law enforcement agency whenever we have reasonable grounds to believe that you have knowingly supplied us with false or misleading information or are otherwise involved in unlawful activities;</li><li>a public authority or agent of a public authority if, in our reasonable judgment, it appears that there is imminent danger to life or property which could be avoided or minimized by disclosure of the information; or</li><li>a public authority or agent of a public authority, for emergency public alerting purposes, if a public authority has determined that there is an imminent or unfolding danger that threatens the life, health or security of an individual and that the danger could be avoided or minimized by disclosure of the information.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>How does Rogers obtain consent from me to disclose my personal information?</strong></li></ol><p>Express consent to disclosure may be obtained by:</p><ol type=\"i\"><li>written consent;</li><li>oral confirmation verified by an independent third party;</li><li>electronic confirmation through the use of a toll-free number;</li><li>electronic confirmation via the internet;</li><li>oral consent, where an audio recording of the consent is retained by us; or</li><li>consent through other methods, as long as an objective documented record of your consent is created by you or by an independent third party.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Can I have an unlisted home phone number?</strong></li></ol><p>You may opt to pay for an unlisted home phone number; however, please note that directories or providers of operator services may obtain your phone numbers and address from a source other than us. In addition, your name, address and phone numbers will be accessible by 9-1-1 service providers even if you pay for an unlisted phone number.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>How can I get more information about the protection of my personal information at Rogers?</strong></li></ol><p>Our corporate and online Privacy Policies are available at <a href=\"http://www.rogers.com/privacy\"><strong>rogers.com/privacy</strong></a>. To contact our Privacy Officer in order to access, obtain more information about your personal information held by Rogers, make a privacy-related complaint, or obtain a copy of our Privacy Policies: e-mail us at <a href=\"mailto:privacy@rci.rogers.com\"><strong>privacy@rci.rogers.com</strong></a>; or write to Chief Privacy Officer, Rogers Group of Companies, 333 Bloor Street East, Toronto, ON M4W 1G9.</p><p></p><ol class=\"tc-ol-headline\" start=\"9\"><li class=\"tc-headline2\"><strong>Warranties and Limitation of Liability</strong></li></ol><p>Please note that the term &ldquo;<strong>Rogers Parties</strong>&rdquo; includes Rogers and its affiliates, partners, licensors, dealers, representatives, suppliers and agents (and their respective employees, officers, directors, shareholders and representatives).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Are there any warranties on the Equipment?</strong></li></ol><p>The Equipment may be covered by a manufacturer&rsquo;s or other warranty. Please see the materials accompanying your Equipment for warranty information and details, including coverage, duration and how you may make a claim under the warranty. There may also be optional Equipment protection programs made available to you from time to time.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Are there any warranties on the Services?</strong></li></ol><p>The Services that Rogers provides may be impacted by factors beyond Rogers&rsquo; reasonable control. For this reason, you acknowledge and understand that the Services or access to the Services, including 9-1-1, public alerts or special needs services, may not function correctly or at all in the following circumstances:</p><ol type=\"i\"><li>if your Equipment fails, is not configured correctly or does not meet Rogers&rsquo; requirements;</li><li>if you install certain third party applications on your Equipment;</li><li>in the event of a network outage or extended power failure;</li><li>if you tamper with or, in some cases, move the Equipment; or</li><li>following suspension or cancellation of your Services or account.</li></ol><p>To the maximum extent permitted by applicable law:</p><ol type=\"i\"><li>the Rogers Parties do not guarantee or warrant the performance, availability, coverage, uninterrupted use, security, pricing or operation of the Services, the Equipment <strong>(except towards residents of Qu&eacute;bec** in accordance with statutory warranties)</strong> or any products, content, applications, software, services, facilities, connections or networks used or provided by us or third parties (collectively, the &ldquo;<strong>Offering</strong>&rdquo;);</li><li>Rogers may limit the amount of an Offering that you may purchase;</li><li>you bear the entire risk as to the use, access, transmission, availability, reliability, timeliness, quality, security and performance of the Offering;</li><li>the Rogers Parties do not make any express or implied representations, warranties or conditions, including warranties of title or non-infringement, or implied warranties of merchantable quality or fitness for a particular purpose, with regard to the Offering.</li></ol><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong></p><ol type=\"i\" start=\"5\"><li>all representations, warranties and conditions of any kind, express or implied, are excluded;</li><li>no advice or information, whether oral or written, that you obtain from the Rogers Parties creates any term, condition, representation or warranty not expressly stated in an Agreement.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>How does Rogers limit its liability?</strong></li></ol><p>Unless otherwise specifically set out in an Agreement, to the maximum extent permitted by applicable law, and <strong>except towards Residents of Qu&eacute;bec** for damages resulting from a Rogers Party&rsquo;s own act</strong>, the Rogers Parties will not be liable to you or to any third party for:</p><ol type=\"i\"><li><strong>Not applicable to Residents of Qu&eacute;bec**:</strong>any direct, indirect, special, consequential, incidental, economic or punitive damages (including loss of profit or revenue; financial loss; loss of business opportunities; loss, destruction or alteration of data, files or software; breach of privacy or security; property damage; personal injury; death; or any other foreseeable or unforeseeable loss, however caused) resulting or relating directly or indirectly from or relating to the Offering or any advertisements, promotions or statements relating to any of the foregoing, even if we were negligent or were advised of the possibility of such damages;</li><li><strong>Applicable only to Residents of Qu&eacute;bec**:</strong> any damages (including loss of profit or revenue; financial loss; loss of business opportunities; loss, destruction or alteration of data, files or software; breach of privacy or security; or property damage) resulting or relating directly or indirectly from or relating to the Offering;</li><li>any Offering provided to you or accessible by you through the Services, any charges incurred in connection with such Offering or anything that is or can be done with such Offering even if you are billed for such Offering;</li><li>the performance, availability, reliability, timeliness, quality, coverage, uninterrupted use, security, pricing or operation of the Offering;</li><li>any error, inclusion or omission relating to any telephone listings or directories;</li><li>the denial, restriction, blocking, disruption or inaccessibility of any Services, including 9-1-1, public alerts or special needs services, Equipment or identifiers (including phone numbers);</li><li>any lost, stolen, damaged or expired Equipment, identifiers, passwords, codes, benefits, discounts, rebates or credits;</li><li>any error, omission or delay in connection with the transfer of phone numbers to or from another telecommunications service provider, or any limitation connected to that transfer or that telecommunications service provider;</li><li>any acts or omissions of a telecommunications carrier whose facilities are used to establish connections to points that we do not serve; or</li><li>any claims or damages resulting directly or indirectly from any claim that the use, intended use or combination of the Offering or any material transmitted through the Services infringes the intellectual property, industrial, contractual, privacy or other rights of a third party.</li></ol><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong>These limits are in addition to any other limits on the Rogers Parties&rsquo; liability set out elsewhere in an Agreement and apply to any act or omission of the Rogers Parties, whether or not the act or omission would otherwise be a cause of action in contract, tort or pursuant to any statute or other doctrine of law.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Are there any additional limitations of liability that apply to 9-1-1 emergency services?</strong></li></ol><p><strong>For wireless Services:</strong></p><p>We are not liable for:</p><ol type=\"i\"><li>libel, slander, defamation or the infringement of copyright arising from material or messages transmitted over our network from your property or premises or recorded by your equipment or our equipment;</li><li>damages arising out of your act, default, neglect or omission in the use or operation of equipment that we provide;</li><li>damages arising out of the transmission of material or messages over our network on your behalf, which is in any way unlawful; or</li><li>any act, omission or negligence of other companies or telecommunications systems when their facilities are used in establishing connections to or from your facilities and equipment. Except in cases where negligence on our part results in physical injury, death or damage to your property or premises, our liability for negligence related to the provision of 9-1-1 emergency services on a mandatory basis is limited to the greater of <strong>$20</strong> and <strong>3</strong> times the amount, if any, you would otherwise be entitled to receive as a refund for the provision of defective Service under an Agreement. However, our liability is not limited by this Section in cases of deliberate fault, gross negligence or anticompetitive conduct on our part or in cases of breach of contract where the breach results from our gross negligence.</li></ol><p><strong>For home phone Services:</strong></p><p>In order for 9-1-1 emergency services to function properly with home phone Services, you must use the adapter which forms part of the Equipment we have provided you (&ldquo;<strong>Adaptor</strong>&rdquo;) and other Equipment at your service address. We will not be liable to you or to any third party for your failure to comply with this requirement. The home phone Services may not function correctly, or at all, in the following circumstances:</p><ol type=\"i\"><li>if your Adaptor or other Equipment fails or is not configured correctly;</li><li>in the event of a cable network outage or extended power failure;</li><li>if you tamper with or move your Adaptor or other Equipment to a location other than your service address; or</li><li>following suspension or cancellation of your Services or account.</li></ol><p>We will not be liable to you or to any third party for any inability to use the home phone Services or to obtain access to 9-1-1 emergency services as a result of the limitations described in this Section.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Are there any circumstances under which I would have to compensate Rogers?</strong></li></ol><p>You will indemnify and hold harmless the Rogers Parties from and against any claims, losses, damages, costs and expenses (including, without limitation, reasonable legal fees and other litigation expenses) incurred by the Rogers Parties relating to your violation, alleged violation or misappropriation of any intellectual property, industrial, contractual, privacy or other rights of a third party or any alleged libel or slander by a third party against you.</p><ol class=\"tc-ol-headline\" start=\"10\"><li class=\"tc-headline2\"><strong>General</strong></li></ol><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>How can I resolve a complaint or dispute with Rogers?</strong></li></ol><p>If you have a concern that was not resolved, then we invite you to submit a Share a Concern form (located at <a href=\"http://www.rogers.com/contactus\"><strong>rogers.com/contactus</strong></a>) and we&rsquo;ll respond within <strong>1</strong> business day. If you&rsquo;re not satisfied with the resolution by one of our management team members, then you also have the option to speak to our Office of the President or even directly with the Ombudsman office.</p><p><strong>Not applicable to Residents of Qu&eacute;bec**: To the extent permitted by applicable law,</strong>unless we agree otherwise, any claim or dispute, whether in contract or tort, under statute or regulation, or otherwise, and whether pre-existing, present or future, arising out of or relating to the following items will be determined by final and binding arbitration to the exclusion of the courts:</p><ol type=\"i\"><li>an Agreement;</li><li>the Services or Equipment;</li><li>oral or written statements, advertisements or promotions relating to an Agreement, the Services or Equipment; or</li><li>the relationships that result from an Agreement.</li></ol><p><strong>Where applicable,</strong>arbitration will be conducted in the province in which you reside, on a simplified and expedited basis by <strong>1</strong> arbitrator under the current laws and rules relating to commercial arbitration in the province or jurisdiction in which you reside on the date of the notice. Rogers will pay all reasonable costs associated with that arbitration. Any arbitration will be conducted in accordance with our Arbitration Protocol, which is available at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/terms\"><strong>rogers.com/terms</strong></a>.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>What happens if part of an Agreement becomes unenforceable or doesn&rsquo;t apply?</strong></li></ol><p>If any portion of an Agreement is unenforceable, the remaining provisions continue in full force. Our failure to enforce strict performance of any provision of an Agreement does not mean we have waived any provision or right. Neither the course of conduct between us nor trade practice modifies any provision of an Agreement.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>What if I would prefer to have a copy of these Terms in French?</strong></li></ol><p>These Terms have been drawn up in the English language at the express request of the parties. Les pr&eacute;sentes modalit&eacute;s ont &eacute;t&eacute; r&eacute;dig&eacute;es en anglais &agrave; la demande expresse des parties. If you would like a copy of these Terms in French, please visit <a href=\"http://www.rogers.com/modalites\"><strong>rogers.com/modalit&eacute;s</strong></a>, or request a copy in store.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>What laws apply to these Terms and the rest of my Agreement?</strong></li></ol><p>Each Agreement is governed exclusively by the laws of the province in which your billing address is located and you submit to the exclusive jurisdiction of the courts of that province. However, if your billing address is outside of Canada, that Agreement is governed exclusively by the laws of the province of Ontario and you submit to the jurisdiction of the courts of Ontario. <strong>Please note that your rights and remedies may vary by province.</strong></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>How can I contact Rogers?</strong></li></ol><p>To contact us:</p><ol type=\"i\"><li>visit a Rogers store;</li><li>call 1-888-ROGERS1 (1-888-764-3771) or, from your Rogers wireless phone, call *611 (it&rsquo;s a free call);</li><li>go online at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/contactus\"><strong>rogers.com/contactus</strong></a> to use our live chat;</li><li>send a fax to 1-800-219-6473; or</li><li>write to Rogers Customer Care, 100 Westmorland Street, Moncton, NB&nbsp;E1C 0G1.</li></ol><p>Any notice of a claim must be given to the Rogers Legal Department, 333 Bloor Street East, Toronto, ON M4W 1G9 and will be deemed to have been given on the date on which it was sent by the party giving the notice.</p><p></p><p><strong>*</strong>&ldquo;<strong>Residents of Newfoundland</strong>&rdquo; means residents of Newfoundland and Labrador who enter into an Agreement to which the <em>Consumer Protection and Business Practices Act</em>(Newfoundland and Labrador) applies.</p><p>** &ldquo;<strong>Residents of Qu&eacute;bec</strong>&rdquo; means residents of Qu&eacute;bec who enter into an Agreement to which the <em>Consumer Protection Act</em> (Qu&eacute;bec) applies.</p><p>&copy;2015</p><p>06/15</p>");
$templateCache.put("views/localization/service-term-changes-cancellations-fr.html","<div class=\"bold paragraph\">P&eacute;riode d&rsquo;abonnement, modifications et r&eacute;siliation</div><div class=\"paragraph\"><p>a. Quelles sont les cat&eacute;gories de Services vis&eacute;es par mon Entente?</p><p>Les Services sont class&eacute;s selon les cat&eacute;gories suivantes:</p><p>i. Les <strong>&laquo; Services &agrave; dur&eacute;e d&eacute;termin&eacute;e &raquo;</strong> s&rsquo;entendent de Services auxquels vous vous abonnez et qui comportent une p&eacute;riode d&rsquo;abonnement pr&eacute;d&eacute;termin&eacute;e, tel qu&rsquo;il est indiqu&eacute; dans votre entente de service applicable (la <strong>&laquo; P&eacute;riode d&rsquo;abonnement &raquo;</strong>);<br>ii. Les <strong>&laquo; Services mensuels &raquo;</strong> s&rsquo;entendent de Services auxquels vous vous abonnez de fa&ccedil;on continue, mais qui ne comportent pas de P&eacute;riode d&rsquo;abonnement;<br>iii.Les <strong>&laquo; Services factur&eacute;s &agrave; l&rsquo;utilisation &raquo;</strong> s&rsquo;entendent de Services que vous utilisez et qui sont factur&eacute;s &agrave; l&rsquo;utilisation (qu&rsquo;ils soient utilis&eacute;s une seule fois ou pendant une p&eacute;riode donn&eacute;e, comme un jour ou une semaine), mais qui ne sont pas utilis&eacute;s de fa&ccedil;on continue.<br></p><p>b. Quelle est la dur&eacute;e de mon Entente?</p><p>La dur&eacute;e de chaque Entente d&eacute;bute &agrave; la date de mise en service initiale des Services ou de l&rsquo;&Eacute;quipement, selon la premi&egrave;re date &agrave; survenir (la <strong>&laquo; Date de mise en service &raquo;</strong>). &Agrave; la fin de la P&eacute;riode d&rsquo;abonnement d&rsquo;un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, ce Service &agrave; dur&eacute;e d&eacute;termin&eacute;e deviendra automatiquement un Service mensuel, et votre Entente et votre Service existants aupr&egrave;s de Rogers demeureront inchang&eacute;s jusqu&rsquo;&agrave; ce qu&rsquo;ils soient modifi&eacute;s ou r&eacute;sili&eacute;s conform&eacute;ment aux pr&eacute;sentes Modalit&eacute;s.</p><p>c. Rogers peut-elle modifier mes Services ou mon Entente?</p><p>Oui, Rogers peut apporter des changements &agrave; vos Services et &agrave; votre Entente, conform&eacute;ment &agrave; ce qui suit.</p><p><strong>Pour les Services sans fil:</strong><br>Nous pouvons modifier tout aspect d&rsquo;un Service mensuel et de l&rsquo;Entente qui y est associ&eacute;e, &agrave; condition de vous en aviser par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance. Nous pouvons &eacute;galement modifier des aspects d&rsquo;un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e et de l&rsquo;Entente qui y est associ&eacute;e, autres que les principales modalit&eacute;s selon ce qui est pr&eacute;vu au Code sur les services sans fil du Conseil de la radiodiffusion et des t&eacute;l&eacute;communications canadiennes (CRTC), en vous en avisant par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance. Dans un cas comme dans l&rsquo;autre, nous vous enverrons l&rsquo;avis &eacute;crit par message apparaissant sur votre facture, par message texte, par lettre ou par courriel, et cet avis comprendra des explications sur la modification ainsi que sa date d&rsquo;entr&eacute;e en vigueur.</p><p><strong>Pour les Services r&eacute;sidentiels:</strong><br><strong>Non applicable aux R&eacute;sidents de Terre-Neuve-et-Labrador* ou aux R&eacute;sidents du Qu&eacute;bec** :</strong> Nous pouvons modifier tout aspect d&rsquo;un Service mensuel ou d&rsquo;un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, ainsi que toute disposition ou modalit&eacute; d&rsquo;une Entente, en vous faisant parvenir un pr&eacute;avis &eacute;crit par message apparaissant sur votre facture, par message texte, par courrier ou par courriel. Si vous n&rsquo;acceptez pas ce changement, votre recours consiste &agrave; r&eacute;silier les Services ou l&rsquo;Entente vis&eacute;s en nous faisant parvenir un avis de r&eacute;siliation conform&eacute;ment au paragraphe 2e) ci-apr&egrave;s dans les <strong>30</strong> jours suivant la r&eacute;ception de notre avis de modification (&agrave; moins que nous y indiquions une autre p&eacute;riode d&rsquo;avis ou un autre recours). <strong>Applicable uniquement aux R&eacute;sidents de Terre-Neuve-et-Labrador* et aux R&eacute;sidents du Qu&eacute;bec** :</strong> Nous pouvons modifier tout aspect d&rsquo;un Service mensuel et de l&rsquo;Entente qui y est associ&eacute;e, &agrave; condition de vous en aviser par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance. Nous pouvons &eacute;galement modifier un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e et l&rsquo;Entente qui y est associ&eacute;e en vous en avisant par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance, mais nous ne modifierons pas le prix, la dur&eacute;e, la nature ou tout autre aspect essentiel de ce Service &agrave; dur&eacute;e d&eacute;termin&eacute;e ou de l&rsquo;Entente. Dans un cas comme dans l&rsquo;autre, nous vous enverrons l&rsquo;avis &eacute;crit par message apparaissant sur votre facture, par message texte, par lettre ou par courriel, et cet avis contiendra la nouvelle modalit&eacute; ou disposition, la modalit&eacute; ou disposition modifi&eacute;e, l&rsquo;ancienne version de cette modalit&eacute; ou disposition (le cas &eacute;ch&eacute;ant), la date &agrave; laquelle la modification entrera en vigueur et un &eacute;nonc&eacute; de vos droits. Si le changement &agrave; un Service mensuel ou &agrave; un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e entra&icirc;ne une augmentation de vos obligations ou une r&eacute;duction de nos obligations et que vous n&rsquo;acceptez pas ce changement, votre recours consiste &agrave; r&eacute;silier les Services ou l&rsquo;Entente vis&eacute;s sans Frais de r&eacute;siliation anticip&eacute;e (tels que d&eacute;finis ci-apr&egrave;s) en nous faisant parvenir un avis de r&eacute;siliation conform&eacute;ment au paragraphe 2e) ci-apr&egrave;s au plus tard <strong>30</strong> jours suivant l&rsquo;entr&eacute;e en vigueur de la modification.</p><p><strong>Pour les Services factur&eacute;s &agrave; l&rsquo;utilisation :</strong> Les Services factur&eacute;s &agrave; l&rsquo;utilisation sont offerts sous r&eacute;serve de leur disponibilit&eacute;, et Rogers peut les modifier ou les r&eacute;silier en tout temps sans vous en aviser au pr&eacute;alable.</p><p>d. Puis-je modifier mes Services?</p><p>Vous pouvez modifier vos Services &agrave; tout moment en communiquant avec nous de l&rsquo;une ou l&rsquo;autre des fa&ccedil;ons indiqu&eacute;es au paragraphe 10e) ci-apr&egrave;s. Vous pourriez devoir payer des frais d&rsquo;administration conform&eacute;ment au paragraphe 3d) ci-apr&egrave;s. Vous pourriez &eacute;galement devoir payer des frais pour changer un Service si de tels frais sont indiqu&eacute;s dans votre entente de service applicable &agrave; ce Service. Veuillez noter que, si vous souhaitez changer un Service, vous pourriez seulement pouvoir le remplacer par un Service qui est offert &agrave; ce moment-l&agrave;, et que tout Service annul&eacute; &agrave; votre demande pourrait ne plus &ecirc;tre disponible.</p><p>e. Comment puis-je r&eacute;silier mes Services et &agrave; quel moment la r&eacute;siliation entre-t-elle en vigueur?</p><p>&Agrave; moins que les lois applicables ne permettent autre chose, vous pouvez r&eacute;silier la totalit&eacute; ou une partie de vos Services et toute Entente qui y est associ&eacute;e &agrave; tout moment en communiquant avec nous de l&rsquo;une ou l&rsquo;autre des fa&ccedil;ons indiqu&eacute;es au paragraphe 10e) ci-apr&egrave;s. La r&eacute;siliation entre en vigueur &agrave; la date &agrave; laquelle Rogers re&ccedil;oit l&rsquo;avis de r&eacute;siliation ou &agrave; une date ult&eacute;rieure qui est indiqu&eacute;e dans l&rsquo;avis (le cas &eacute;ch&eacute;ant), selon la date la plus &eacute;loign&eacute;e. Les frais exigibles continueront de s&rsquo;appliquer jusqu&rsquo;&agrave; cette date. Cependant, si vous annulez uniquement une option du Service de t&eacute;l&eacute;vision ou du Service d&rsquo;acc&egrave;s Internet, les frais applicables pour cette option continueront de s&rsquo;appliquer jusqu&rsquo;&agrave; votre prochaine date de facturation.</p><p>f. Devrai-je payer des frais de r&eacute;siliation anticip&eacute;e si j&rsquo;annule l&rsquo;un ou l&rsquo;autre de mes Services?</p><p>Si vous vous abonnez &agrave; un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e que vous r&eacute;siliez avant la fin de sa P&eacute;riode d&rsquo;abonnement, vous devrez payer des frais de r&eacute;siliation anticip&eacute;e tel qu&rsquo;il est d&eacute;crit dans l&rsquo;entente de service applicable &agrave; ce Service &agrave; dur&eacute;e d&eacute;termin&eacute;e (les <strong>&laquo; Frais de r&eacute;siliation anticip&eacute;e &raquo;</strong>).</p><p>g. Que se passe-t-il si je transf&egrave;re mes Services &agrave; un autre fournisseur de service?</p><p>Le transfert de votre ou de vos Services &agrave; un autre fournisseur de service constitue une r&eacute;siliation du ou des Services en question, et des Frais de r&eacute;siliation anticip&eacute;e pourront s&rsquo;appliquer si le transfert entra&icirc;ne la r&eacute;siliation d&rsquo;un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e avant la fin de sa P&eacute;riode d&rsquo;abonnement.</p><p>h. Rogers peut-elle r&eacute;silier mes Services et, le cas &eacute;ch&eacute;ant, &agrave; quel moment cette r&eacute;siliation entre-t-elle en vigueur?</p><p><strong>Non applicable aux R&eacute;sidents de Terre-Neuve-et-Labrador* et aux R&eacute;sidents du Qu&eacute;bec** :</strong> &Agrave; moins que les lois applicables ne permettent autre chose, Rogers peut r&eacute;silier une partie ou la totalit&eacute; de vos Services ou de vos comptes, ainsi que toute Entente qui y est associ&eacute;e, &agrave; condition de vous en aviser par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance. Les frais exigibles continuent de s&rsquo;appliquer jusqu&rsquo;&agrave; la date de r&eacute;siliation.<br><strong>Applicable uniquement aux R&eacute;sidents de Terre-Neuve-et-Labrador* et aux R&eacute;sidents du Qu&eacute;bec** :</strong> &Agrave; moins que les lois applicables ne permettent autre chose, Rogers peut r&eacute;silier une partie ou la totalit&eacute; de vos Services ou de vos comptes, ainsi que toute Entente qui y est associ&eacute;e, &agrave; condition de vous en aviser par &eacute;crit au moins <strong>60</strong> jours &agrave; l&rsquo;avance. Si vous vous &ecirc;tes abonn&eacute; &agrave; un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, nous ne pouvons r&eacute;silier ce Service : (i) <strong>(applicable uniquement aux R&eacute;sidents de Terre-Neuve-et-Labrador*)</strong> que si n&rsquo;avons plus la capacit&eacute; technique de fournir ce Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, ou (ii) <strong>(applicable uniquement aux R&eacute;sidents du Qu&eacute;bec**)</strong> qu&rsquo;en vertu des articles 1604, 2126 et 2129 du Code civil du Qu&eacute;bec. Les frais exigibles continuent de s&rsquo;appliquer jusqu&rsquo;&agrave; la date de r&eacute;siliation. <strong>Applicable uniquement aux R&eacute;sidents de Terre-Neuve-et-Labrador* :</strong> Si votre compte a un solde cr&eacute;diteur d&eacute;passant <strong>10 $</strong> sur votre facture finale, nous vous rembourserons ce solde dans les <strong>60</strong> jours suivant la date de cette facture. Les cr&eacute;dits discr&eacute;tionnaires ne seront pas rembours&eacute;s.</p><p>i. Rogers peut-elle suspendre ou r&eacute;silier mes Services sans pr&eacute;avis?</p><p>Nous pouvons limiter, suspendre, bloquer, d&eacute;brancher ou r&eacute;silier l&rsquo;un ou l&rsquo;autre ou l&rsquo;ensemble de vos Services, comptes ou identifiants de quelque fa&ccedil;on que ce soit, y compris le service 9 1 1, sans avis ni responsabilit&eacute; envers vous, si :</p><p>i. vous contrevenez aux modalit&eacute;s d&rsquo;une Entente, notamment en omettant d&rsquo;acquitter vos frais; ii. vous d&eacute;passez votre limite de cr&eacute;dit; iii. vous omettez de fournir ou de maintenir un d&eacute;p&ocirc;t de garantie raisonnable ou de vous conformer &agrave; une autre exigence de cr&eacute;dit lorsque nous vous demandons de le faire; iv. vous convenez avec nous d&rsquo;un arrangement de paiement diff&eacute;r&eacute; et vous omettez d&rsquo;en respecter les modalit&eacute;s; v. vous d&eacute;passez la limite d&rsquo;utilisation raisonnable; vi. vous donnez de l&rsquo;information fausse, trompeuse ou p&eacute;rim&eacute;e; vii. nous avons des doutes raisonnables ou nous avons &eacute;tabli qu&rsquo;un de vos comptes, identifiants, Services ou &Eacute;quipement est associ&eacute; &agrave; une fraude, une utilisation ill&eacute;gale ou inappropri&eacute;e, ou est utilis&eacute; d&rsquo;une fa&ccedil;on nuisant &agrave; notre exploitation ou &agrave; l&rsquo;utilisation de nos services, de nos installations ou de nos r&eacute;seaux par d&rsquo;autres; viii. vous harcelez, menacez ou faites preuve d&rsquo;abus envers nous, nos employ&eacute;s ou nos agents; ix. vous tentez par des man&#339;uvres frauduleuses ou malhonn&ecirc;tes de ne pas nous payer; x. nous devons installer, entretenir, inspecter, tester, r&eacute;parer, retirer, remplacer, enqu&ecirc;ter, prot&eacute;ger, modifier, mettre &agrave; jour ou am&eacute;liorer l&rsquo;exploitation des Services, de l&rsquo;&Eacute;quipement, de nos installations ou de nos r&eacute;seaux; xi. un compte ou un service duquel vos Services d&eacute;pendent est annul&eacute; pour quelque raison; ou xii. nous croyons raisonnablement qu&rsquo;une urgence ou des circonstances particuli&egrave;res justifient une telle mesure. Si nous limitons, suspendons, bloquons, d&eacute;branchons ou r&eacute;silions vos Services ou vos comptes : i. vous devez nous payer tous les montants que vous nous devez; ii. nous pouvons &eacute;galement, sans avis ni responsabilit&eacute;, limiter, suspendre, bloquer, d&eacute;brancher ou r&eacute;silier vos Services aux termes d&rsquo;une autre entente ou d&rsquo;un autre compte que vous avez aupr&egrave;s de nous ou d&rsquo;une soci&eacute;t&eacute; du m&ecirc;me groupe que Rogers (incluant les comptes qui pourraient &ecirc;tre en r&egrave;gle); iii. les frais encourus par nous ou une soci&eacute;t&eacute; du m&ecirc;me groupe que Rogers relativement &agrave; votre manquement aux pr&eacute;sentes Modalit&eacute;s pourraient vous &ecirc;tre factur&eacute;s, incluant, sans toutefois s&rsquo;y limiter, les frais encourus pour vous obliger &agrave; les respecter; iv. votre acc&egrave;s aux services d&rsquo;urgence ou aux services sp&eacute;ciaux (par exemple, le 9 1 1) peut &eacute;galement &ecirc;tre restreint, suspendu, bloqu&eacute;, d&eacute;sactiv&eacute; ou annul&eacute;; v. vos tarifs pour les services aupr&egrave;s des soci&eacute;t&eacute;s du m&ecirc;me groupe que Rogers peuvent changer en fonction des modalit&eacute;s de ces services.</p><p>j. Les pr&eacute;sentes Modalit&eacute;s s&rsquo;appliqueront-elles toujours apr&egrave;s la r&eacute;siliation de mes Services?</p><p>Certaines dispositions des pr&eacute;sentes Modalit&eacute;s peuvent continuer &agrave; s&rsquo;appliquer puisqu&rsquo;elles peuvent demeurer pertinentes m&ecirc;me apr&egrave;s la r&eacute;siliation de tous vos Services. Plus particuli&egrave;rement, les paragraphes 1b)-d), 2e)-j), 4b)-c), 5c), 6d), 8b)-d), 8f), 9, 10b)-d) et les dispositions en mati&egrave;re d&rsquo;arbitrage du paragraphe 10a) continueront de s&rsquo;appliquer &agrave; vous malgr&eacute; la r&eacute;siliation de votre Entente.</p></div>");
$templateCache.put("views/localization/service-term-changes-cancellations.html","<div class=\"bold paragraph\">SERVICE TERM, CHANGES AND CANCELLATION</div><div class=\"paragraph\"><p>a. What are the categories of Services covered by my Agreement?</p><p>The Services are categorized as follows:</p><p>i. <strong>&quot;Term Services&quot;</strong> are Services that you subscribe to for a committed period of time as indicated on your applicable service agreement (<strong>&quot;Term&quot;</strong>);<br>ii. <strong>&quot;Month-to-Month Services&quot;</strong> are Services that you subscribe to on an ongoing basis, but not with a Term; and<br>iii. <strong>&quot;Pay-Per-Use Services&quot;</strong> are Services that you use on a per-usage basis (which may be a one-time usage, or usage for a set period of time, such as one day or one week), but not on an ongoing basis.<br></p><p>b. What is the term of my Agreement?</p><p>The term of each Agreement starts on the initial activation date of the Services or the Equipment, whichever is earlier <strong>(&quot;Activation Date&quot;)</strong>. At the end of the Term for a Term Service, the Service will automatically become a Month-to-Month Service and you will keep your existing Service and Agreement with us, unchanged, until they are changed or cancelled in accordance with these Terms.</p><p>c. Can Rogers change my Services or my Agreement?</p><p>Yes, Rogers may change your Services or Agreement as described below.</p><p><strong>For wireless Services:</strong><br>We may change any aspect of a Month-to-Month Service and the corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. We may also change aspects of a Term Service and the corresponding Agreement, other than a key term as defined in the Canadian Radio-television and Telecommunications Commission (CRTC)&rsquo;s Wireless Code, upon at least <strong>30</strong> days&rsquo; prior written notice to you. In either case, we will send you the written notice by bill message, text message, letter or e-mail and will explain the change and when it will take effect.</p><p><strong>For residential Services:</strong><br><strong>Not applicable to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> We may change any aspect of a Month-to-Month Service or Term Service as well as any term or provision of an Agreement, upon prior written notice to you by bill message, text message, letter or e-mail. If you do not accept the change, your remedy will be to cancel the affected Services or Agreement by providing us with notice of cancellation under Section 2(e) below within <strong>30</strong> days of receiving our notice of change (unless we specify a different notice period or different remedy). <strong>Applicable only to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> We may change any aspect of a Month-to-Month Service and the corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. We may also change a Term Service and the corresponding Agreement upon at least <strong>30</strong> days&rsquo; prior written notice, but will not change the price, term, nature or any other essential elements of that Term Service or that Agreement. In either case, we will send you the written notice by bill message, text message, letter or e-mail and it will contain the new or amended term or provision, the former version of that term or provision (if applicable), the date that the amendment will come into force, and your rights. If a change to a Month-to-Month Service or a Term Service entails an increase in your obligations or a decrease in our obligations and if you do not accept that change, your remedy will be to cancel the affected Services or Agreement without an Early Cancellation Fee (defined below) by providing us with notice of cancellation under Section 2(e) below no later than <strong>30</strong> days after the amendment takes effect.</p><p><strong>For Pay-Per-Use Services:</strong> Pay-Per-Use Services are subject to availability and may be changed or cancelled by Rogers at any time without prior notice to you.</p><p>d. May I change my Services?</p><p>You may change your Services at any time by contacting us in any of the ways set out in Section 10(e) below. You may be subject to an administrative charge in accordance with Section 3(d) below. You may also be charged a fee to change your Service if one is specified in your service agreement for that Service. Please note that if you wish to change a Service, you may only be able to change to a Service that is currently available in market. Also please note that any Service you remove may no longer be available.</p><p>e. How can I cancel my Services and when does cancellation take effect?</p><p>Unless otherwise permitted by applicable law, you may cancel any or all of your Services and any corresponding Agreement at any time by contacting us in any of the ways set out in Section 10(e) below. Cancellation takes effect on the day that Rogers receives notice of the cancellation, or a future date specified in that notice (if applicable), whichever is later. Applicable charges continue until that date. However, if you only cancel a television Service add-on or an internet Service add-on, applicable charges continue to apply until your next billing date for that add-on.</p><p>f. Will I be charged an early cancellation fee if I cancel my Service(s)?</p><p>If you subscribe to a Term Service that you cancel before the end of its Term, you will be charged an early cancellation fee as described in the service agreement for that Term Service <strong>(&quot;Early Cancellation Fee&quot;)</strong>.</p><p>g. What happens if I transfer my Service(s) to another service provider?</p><p>Transferring your Service(s) to another service provider is a cancellation of the applicable Service(s) and an Early Cancellation Fee may apply if the transfer results in the cancellation of a Term Service before the end of its Term.</p><p>h. Can Rogers cancel my Services and when does cancellation take effect?</p><p><strong>Not applicable to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> Unless otherwise permitted by applicable law, Rogers may cancel any or all of your Services or accounts and any corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. Applicable charges continue until the cancellation date.<br><strong>Applicable only to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> Unless otherwise permitted by applicable law, Rogers may cancel any or all of your Services or accounts and any corresponding Agreement, as long as we give you at least <strong>60</strong> days&rsquo; prior written notice. If you have subscribed to a Term Service, then we may cancel that Service: (i) <strong>(applicable only to Residents of Newfoundland*)</strong> only if we no longer have the technical ability to provide that Term Service, or (ii) <strong>(applicable only to Residents of Qu&eacute;bec**)</strong> only pursuant to Sections 1604, 2126 and 2129 of the Civil Code of Qu&eacute;bec. Applicable charges continue until the cancellation date. <strong>Applicable only to Residents of Newfoundland*:</strong> If your account has a credit balance over <strong>$10</strong> on your final bill, then we will refund that balance to you within <strong>60</strong> days of the date of that bill. Discretionary credits will not be refunded.</p><p>i. Can Rogers suspend or cancel my Services without notice?</p><p>We may restrict, suspend, block, disconnect or cancel any or all of your Services, accounts or identifiers in any way, including 9-1-1 service, without notice or liability to you, if:</p><p>i. you are in breach of an Agreement, including for non-payment;<br>ii. you exceed your credit limit;<br>iii. you fail to provide or maintain a reasonable security deposit or other credit requirement when we ask you to;<br>iv. you agree to a deferred payment arrangement with us and fail to comply with its terms;<br>v. you exceed our reasonable usage limits;<br>vi. you have given us false, misleading or outdated information;<br>vii. we reasonably suspect or determine that any of your account, identifiers, Services or Equipment is the subject of fraudulent, unlawful or improper usage or usage that adversely affects our operations or the use of our services, facilities or networks by others;<br>viii. you harass, threaten or abuse us or our employees or agents;<br>ix. you fraudulently or improperly seek to avoid payment to us;<br>x. we need to install, maintain, inspect, test, repair, remove, replace, investigate, protect, modify, upgrade or improve the operation of the Services, the Equipment or our facilities or networks;<br>xi. any account or service on which your Services depend is cancelled for any reason; or<br>xii. we reasonably believe that there is an emergency or extreme circumstance that would warrant that action.<br></p><p>If we restrict, suspend, block, disconnect or cancel your Services or accounts:</p><p>i. you must pay any amounts owing;<br>ii. we may also restrict, suspend, block, disconnect or cancel, without notice or liability, your Services under any other agreement or account that you may have with us or a related Rogers entity (including accounts that may be in good standing);<br>iii. you may be charged for any costs incurred by us or any related Rogers entity in connection with your breach of these Terms, including costs incurred to enforce your compliance;<br>iv. your access to emergency or special needs services (e.g., 9-1-1) may also be restricted, suspended, blocked, disconnected or cancelled; and<br>v. your rates for services with related Rogers entities may change in accordance with the terms of those services.<br></p><p>j. Will these Terms still apply once my Services are cancelled?</p><p>Certain provisions of these Terms may still apply as they may still be relevant even after cancellation of all your Services. Specifically, Sections 1(b)-(d), 2(e)-(j), 4(b)-(c), 5(c), 6(d), 8(b)-(d), 8(f), 9, 10(b)-(d) and the arbitration provisions of Section 10(a) will continue to apply to you after cancellation of your Agreement.</p></div>");
$templateCache.put("views/localization/tac-fr.html","<div class=\"bold paragraph\">RENSEIGNEMENTS IMPORTANTS AU SUJET DE VOTRE SERVICE SANS-FIL</div><div class=\"paragraph\">Cette information s’ajoute à notre (nos) Entente(s) de service avec vous et elle en fait partie. Elle doit être lue conjointement avec les Modalités de service de Rogers, la Politique d’utilisation acceptable et la Politique de confidentialité qui vous sont fournies et sont accessibles sur le site rogers.com (et qui remplacent les Modalités de service de Rogers, la Politique d’utilisation acceptable et la Politique de confidentialité que vous avez reçues antérieurement), avec les brochures ou le matériel en ligne de Rogers en vigueur décrivant les forfaits, les caractéristiques, les services et (ou) les produits que vous avez choisis, ainsi qu’avec le Guide de démarrage en vigueur. Tout nouveau changement apporté à votre (vos) Entente(s) de service est énoncé aux présentes. Tous les autres aspects de votre (vos) Entente(s) de service demeurent les mêmes. Vous reconnaissez que tout Service annulé à votre demande ne sera peut-être plus disponible.</div>");
$templateCache.put("views/localization/tac.html","<div class=\"bold paragraph\">IMPORTANT INFORMATION ABOUT YOUR WIRELESS SERVICE</div><div class=\"paragraph\">This information is in addition to and forms part of our Service Agreement(s) with you and must be read in conjunction with the current Rogers Terms of Service, Acceptable Use Policy and Privacy Policy provided to you and posted on rogers.com (and which replace the Rogers Terms of Service, Acceptable Use Policy and Privacy Policy previously provided to you), and any other Rogers brochure or online material describing the plans, features, services and/or products you have selected and the Starting Up Guide that are currently in effect. Any new changes to your Service Agreement(s) are set out herein. All other aspects of your Service Agreement(s) remain the same. You acknowledge that any Services you have removed may no longer be available.</div>");
$templateCache.put("views/localization/warranties-limitation-liability-fr.html","<div class=\"bold paragraph\">Garanties et limite de responsabilit&eacute;</div><div class=\"paragraph\"><p>Veuillez noter que l&rsquo;expression <strong>&laquo; Parties de Rogers &raquo;</strong> comprend Rogers et les soci&eacute;t&eacute;s membres de son groupe, ses partenaires, ses conc&eacute;dants de licence, ses concessionnaires, ses repr&eacute;sentants, ses fournisseurs et ses mandataires (de m&ecirc;me que leurs employ&eacute;s, dirigeants, administrateurs, actionnaires et repr&eacute;sentants respectifs).</p><p>a. L&rsquo;&Eacute;quipement est-il garanti?</p><p>L&rsquo;&Eacute;quipement peut &ecirc;tre couvert par une garantie du fabricant ou une autre garantie. Veuillez consulter les documents remis avec votre &Eacute;quipement pour obtenir des renseignements d&eacute;taill&eacute;s sur la garantie dont il est assorti, notamment l&rsquo;objet de la garantie, la dur&eacute;e de celle-ci et les modalit&eacute;s de r&eacute;clamation. L&rsquo;&Eacute;quipement peut &eacute;galement comporter d&rsquo;autres programmes de protection facultatifs qui vous sont offerts &agrave; l&rsquo;occasion.</p><p></p><p>b. Les Services sont-ils garantis?</p><p>Les Services fournis par Rogers peuvent &ecirc;tre touch&eacute;s par des facteurs ind&eacute;pendants du contr&ocirc;le raisonnable de Rogers. Pour cette raison, vous reconnaissez et convenez que les Services ou l&rsquo;acc&egrave;s aux Services, y compris le service d&rsquo;urgence 9 1 1, les alertes publiques ou les services sp&eacute;ciaux, peuvent ne pas fonctionner correctement, ou m&ecirc;me ne pas fonctionner du tout, dans les cas suivants :</p><p>i. si votre &Eacute;quipement fait d&eacute;faut, s&rsquo;il n&rsquo;est pas bien configur&eacute;, ou s&rsquo;il ne respecte pas les exigences de Rogers;<br>ii. si vous avez install&eacute; certaines applications de tiers sur votre &Eacute;quipement;<br>iii. en cas de panne du r&eacute;seau ou de panne d&rsquo;&eacute;lectricit&eacute; prolong&eacute;e;<br>iv. si vous modifiez ou, dans certains cas, si vous d&eacute;placez l&rsquo;&Eacute;quipement;<br>v. apr&egrave;s la suspension ou la r&eacute;siliation de vos Services ou de votre compte.</p><p>Dans les limites permises par la loi en vigueur :<br>i. les Parties de Rogers ne donnent aucune garantie ou assurance &agrave; l&rsquo;&eacute;gard du rendement, de la disponibilit&eacute;, de la couverture, de l&rsquo;utilisation sans interruption, de la s&eacute;curit&eacute;, du prix ou du fonctionnement des Services, de l&rsquo;&Eacute;quipement <strong>(sauf en faveur des R&eacute;sidents du Qu&eacute;bec** conform&eacute;ment aux garanties l&eacute;gales)</strong> ou de tout produit, contenu, application, logiciel, service, installation, connexion ou r&eacute;seau utilis&eacute; ou fourni par nous ou par des tierces parties (collectivement d&eacute;sign&eacute;s <strong>l&rsquo;&laquo; Offre &raquo;</strong>);<br>ii. Rogers peut limiter toute Offre que vous pouvez acheter;<br>iii.vous assumez la totalit&eacute; des risques associ&eacute;s &agrave; l&rsquo;utilisation, &agrave; l&rsquo;acc&egrave;s, &agrave; la transmission, &agrave; la disponibilit&eacute;, &agrave; la fiabilit&eacute;, aux d&eacute;lais, &agrave; la qualit&eacute;, &agrave; la s&eacute;curit&eacute; et au rendement de l&rsquo;Offre;<br>iv. les Parties de Rogers n&rsquo;offrent aucune repr&eacute;sentation, garantie ni condition expresse ou implicite, y compris des garanties de propri&eacute;t&eacute; ou d&rsquo;absence de contrefa&ccedil;on et des garanties implicites de qualit&eacute; marchande ou d&rsquo;ad&eacute;quation &agrave; un usage particulier, &agrave; l&rsquo;&eacute;gard de l&rsquo;Offre.</p><p><strong>Non applicable aux R&eacute;sidents du Qu&eacute;bec** :</strong><br>v. toutes les repr&eacute;sentations, garanties et conditions de quelque type que ce soit, expresses ou implicites, sont exclues;<br>vi. aucun conseil ou renseignement, qu&rsquo;il soit fait verbalement ou par &eacute;crit, que vous obtenez de la part de toute Partie de Rogers n&rsquo;aura pour effet de cr&eacute;er une modalit&eacute;, une condition, une repr&eacute;sentation ou une garantie qui n&rsquo;est pas express&eacute;ment &eacute;nonc&eacute;e dans une Entente.</p><p>c. De quelle fa&ccedil;on Rogers limite-t-elle sa responsabilit&eacute;?</p><p>&Agrave; moins de mention contraire stipul&eacute;e sp&eacute;cifiquement dans une Entente, dans les limites maximales permises par les lois applicables, <strong>et sauf &agrave; l&rsquo;&eacute;gard des R&eacute;sidents du Qu&eacute;bec** pour des dommages r&eacute;sultant du fait personnel d&rsquo;une Partie de Rogers</strong>, les Parties de Rogers ne pourront &ecirc;tre tenues responsables envers vous ou une tierce partie pour les &eacute;l&eacute;ments suivants :</p><p>i. <strong>Non applicable aux R&eacute;sidents du Qu&eacute;bec** :</strong> tout dommage direct, indirect, sp&eacute;cial, cons&eacute;cutif, accessoire, &eacute;conomique ou punitif (y compris la perte de profits ou de revenus; les pertes financi&egrave;res; les pertes d&rsquo;occasions d&rsquo;affaires; la perte, la destruction ou l&rsquo;alt&eacute;ration de donn&eacute;es, de fichiers ou de logiciels; le manquement &agrave; la confidentialit&eacute; ou &agrave; la s&eacute;curit&eacute;; les dommages mat&eacute;riels; les blessures corporelles; les d&eacute;c&egrave;s ou toute autre perte pr&eacute;visible ou impr&eacute;visible, quelle qu&rsquo;en soit la cause) associ&eacute;s directement ou indirectement &agrave; l&rsquo;Offre ou &agrave; la publicit&eacute;, la promotion ou les d&eacute;clarations relatives &agrave; un des &eacute;l&eacute;ments pr&eacute;cit&eacute;s, m&ecirc;me si nous avons &eacute;t&eacute; n&eacute;gligents ou si nous avions &eacute;t&eacute; avis&eacute;s de la possibilit&eacute; de tels dommages;<br>ii. <strong>Applicable uniquement aux R&eacute;sidents du Qu&eacute;bec** :</strong> tout dommage (y compris la perte de profits ou de revenus; les pertes financi&egrave;res; les pertes d&rsquo;occasions d&rsquo;affaires; la perte, la destruction ou l&rsquo;alt&eacute;ration de donn&eacute;es, de fichiers ou de logiciels; le manquement &agrave; la confidentialit&eacute; ou &agrave; la s&eacute;curit&eacute;; les dommages mat&eacute;riels) associ&eacute; directement ou indirectement &agrave; l&rsquo;Offre;<br>iii.toute Offre qui vous est fournie ou &agrave; laquelle vous avez acc&egrave;s par l&rsquo;interm&eacute;diaire des Services, tous frais engag&eacute;s relativement &agrave; une telle Offre, ou toute action qui est ou qui peut &ecirc;tre prise au moyen de cette Offre, m&ecirc;me si cette Offre vous a &eacute;t&eacute; factur&eacute;e;<br>iv. le rendement, la disponibilit&eacute;, la fiabilit&eacute;, les d&eacute;lais, la qualit&eacute;, la couverture, l&rsquo;utilisation sans interruption, la s&eacute;curit&eacute;, le prix ou le fonctionnement de l&rsquo;Offre;<br>v. toute erreur, inclusion ou omission en ce qui a trait aux annuaires ou aux r&eacute;pertoires t&eacute;l&eacute;phoniques;<br>vi. le refus, la restriction, le blocage, l&rsquo;interruption ou l&rsquo;inaccessibilit&eacute; des Services, y compris le 9-1-1, les alertes publiques ou les services sp&eacute;ciaux, l&rsquo;&Eacute;quipement ou les identifiants (y compris les num&eacute;ros de t&eacute;l&eacute;phone);<br>vii. la perte, le vol, l&rsquo;endommagement ou l&rsquo;expiration de l&rsquo;&Eacute;quipement, des identifiants, des mots de passe, des codes, des avantages, des rabais, des remises ou des cr&eacute;dits;<br>viii. toute erreur ou omission ou tout d&eacute;lai en rapport avec le transfert des num&eacute;ros de t&eacute;l&eacute;phone &agrave; un autre fournisseur de services de t&eacute;l&eacute;communications ou en provenance d&rsquo;un tel autre fournisseur de services de t&eacute;l&eacute;communications, de m&ecirc;me que toute restriction attribuable au transfert ou au fournisseur de services de t&eacute;l&eacute;communications;<br>ix. tout acte ou toute omission d&rsquo;un fournisseur de services de t&eacute;l&eacute;communications dont les installations sont utilis&eacute;es pour &eacute;tablir une liaison avec des points &agrave; l&rsquo;ext&eacute;rieur de notre zone de desserte; ou<br>x. toute r&eacute;clamation ou tout dommage attribuable directement ou indirectement &agrave; des affirmations selon lesquelles l&rsquo;utilisation, l&rsquo;utilisation pr&eacute;vue ou une combinaison de l&rsquo;Offre ou tout document transmis par l&rsquo;entremise des Services contreviennent aux droits de propri&eacute;t&eacute; intellectuelle, industrielle ou contractuelle, ou au droit &agrave; la vie priv&eacute;e ou &agrave; quelque autre droit d&rsquo;une tierce partie.</p><p>Non applicable aux R&eacute;sidents du Qu&eacute;bec** : Ces limites s&rsquo;ajoutent &agrave; toutes les autres limites &agrave; la responsabilit&eacute; des Parties de Rogers qui sont indiqu&eacute;es dans une Entente et qui s&rsquo;appliquent &agrave; tout acte ou toute omission des Parties de Rogers, peu importe que ces actes ou ces omissions puissent donner lieu &agrave; un recours en vertu d&rsquo;un contrat, d&rsquo;un d&eacute;lit civil ou de quelque loi ou autre doctrine juridique.</p><p>d. D&rsquo;autres limites de responsabilit&eacute; s&rsquo;appliquent-elles aux services d&rsquo;urgence 9 1 1?</p><p><strong>Pour les Services sans fil :</strong></p><p>Nous ne sommes pas responsables de ce qui suit :<br>i. diffamation ou atteinte aux droits d&rsquo;auteur inh&eacute;rents au mat&eacute;riel ou aux messages transmis par l&rsquo;interm&eacute;diaire de notre r&eacute;seau &agrave; partir de votre propri&eacute;t&eacute; ou de vos locaux ou enregistr&eacute;s &agrave; partir de votre &eacute;quipement ou du n&ocirc;tre;<br>ii. dommages caus&eacute;s par vos actes, par d&eacute;faut, par n&eacute;gligence ou par omission de votre part dans l&rsquo;utilisation ou la manipulation de l&rsquo;&eacute;quipement que nous fournissons;<br>iii. dommages caus&eacute;s par toute transmission ill&eacute;gale, de quelque fa&ccedil;on que ce soit, de mat&eacute;riel ou de messages par l&rsquo;interm&eacute;diaire de notre r&eacute;seau en votre nom; ou<br>iv. tout acte, toute omission ou toute n&eacute;gligence de la part d&rsquo;autres entreprises ou syst&egrave;mes de t&eacute;l&eacute;communications lorsque leurs installations sont utilis&eacute;es aux fins d&rsquo;&eacute;tablir une connexion &agrave; partir ou en direction de vos installations et de votre &eacute;quipement. &Agrave; l&rsquo;exception des cas de n&eacute;gligence de notre part entra&icirc;nant des blessures, la mort ou des dommages &agrave; votre propri&eacute;t&eacute; ou &agrave; vos locaux, notre responsabilit&eacute; pour cause de n&eacute;gligence relative &agrave; la prestation obligatoire de services d&rsquo;urgence 9-1-1 se limite &agrave; un montant de <strong>20 $</strong> ou &agrave; <strong>3</strong> fois le montant, s&rsquo;il y a lieu, auquel vous auriez autrement droit &agrave; titre de remboursement pour la prestation de Services d&eacute;fectueux en vertu d&rsquo;une Entente, selon le montant le plus &eacute;lev&eacute;. Toutefois, notre responsabilit&eacute; n&rsquo;est pas limit&eacute;e par le pr&eacute;sent article en cas de faute d&eacute;lib&eacute;r&eacute;e, de n&eacute;gligence grave ou de conduite anticoncurrentielle de notre part ou en cas de bris de contrat r&eacute;sultant d&rsquo;une n&eacute;gligence grossi&egrave;re de notre part.</p><p><strong>Pour les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle :</strong></p><p>Pour que les services d&rsquo;urgence 9 1 1 puissent fonctionner convenablement avec les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle, vous devez utiliser l&rsquo;adaptateur qui fait partie de l&rsquo;&Eacute;quipement que nous vous avons fourni (<strong>l&rsquo;&laquo; Adaptateur &raquo;</strong>) et les autres &eacute;l&eacute;ments d&rsquo;&Eacute;quipement &agrave; votre adresse de service. Nous ne pourrons &ecirc;tre tenus responsables envers vous ou une tierce partie pour tout manquement &agrave; cette exigence. Les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle pourraient ne pas fonctionner normalement, ou ne pas fonctionner du tout, dans les cas suivants :<br>i. si votre Adaptateur ou les autres &eacute;l&eacute;ments de l&rsquo;&Eacute;quipement font d&eacute;faut ou ne sont pas configur&eacute;s correctement;<br>ii. en cas de panne du r&eacute;seau de c&acirc;ble ou d&rsquo;une panne d&rsquo;&eacute;lectricit&eacute; prolong&eacute;e;<br>iii.si vous modifiez ou d&eacute;placez votre Adaptateur ou un autre &eacute;l&eacute;ment de l&rsquo;&Eacute;quipement &agrave; un endroit autre que votre adresse de service; ou<br>iv. apr&egrave;s la suspension ou la r&eacute;siliation de vos Services ou de votre compte.<br>Nous ne pourrons &ecirc;tre tenus responsables envers vous ou une tierce partie en cas d&rsquo;incapacit&eacute; &agrave; utiliser les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle ou d&rsquo;obtenir l&rsquo;acc&egrave;s aux services d&rsquo;urgence 9 1 1 en raison des limites d&eacute;crites au pr&eacute;sent article.</p><p>e. Existe-t-il des circonstances dans lesquelles je devrai indemniser Rogers?</p><p>Vous indemniserez et tiendrez &agrave; couvert les Parties de Rogers de quelque r&eacute;clamation, perte, dommages, co&ucirc;ts et d&eacute;penses que ce soit (y compris, sans limitation, les frais juridiques raisonnables et autres frais de r&egrave;glement de litiges), encourus par les Parties de Rogers li&eacute;s &agrave; la violation, &agrave; la violation pr&eacute;sum&eacute;e ou au d&eacute;tournement par vous du droit de propri&eacute;t&eacute; intellectuelle, industrielle ou contractuelle, ou toute atteinte au droit &agrave; la vie priv&eacute;e ou &agrave; quelque autre droit d&rsquo;une tierce partie, ou &agrave; tout pr&eacute;sum&eacute; libelle ou &agrave; toute pr&eacute;sum&eacute;e diffamation qui serait intent&eacute; ou all&eacute;gu&eacute; contre vous par une tierce partie.</p></div>");
$templateCache.put("views/localization/warranties-limitation-liability.html","<div class=\"bold paragraph\">WARRANTIES AND LIMITATION OF LIABILITY</div><div class=\"paragraph\"><p>Please note that the term <strong>&ldquo;Rogers Parties&rdquo;</strong> includes Rogers and its affiliates, partners, licensors, dealers, representatives, suppliers and agents (and their respective employees, officers, directors, shareholders and representatives).</p><p>a. Are there any warranties on the Equipment?</p><p>The Equipment may be covered by a manufacturer&rsquo;s or other warranty. Please see the materials accompanying your Equipment for warranty information and details, including coverage, duration and how you may make a claim under the warranty. There may also be optional Equipment protection programs made available to you from time to time.</p><p>b. Are there any warranties on the Services?</p><p>The Services that Rogers provides may be impacted by factors beyond Rogers&rsquo; reasonable control. For this reason, you acknowledge and understand that the Services or access to the Services, including 9-1-1, public alerts or special needs services, may not function correctly or at all in the following circumstances:</p><p>i. if your Equipment fails, is not configured correctly or does not meet Rogers&rsquo; requirements;<br>ii. if you install certain third party applications on your Equipment;<br>iii. in the event of a network outage or extended power failure;<br>iv. if you tamper with or, in some cases, move the Equipment; or<br>v. following suspension or cancellation of your Services or account.</p><p>To the maximum extent permitted by applicable law:<br>i. the Rogers Parties do not guarantee or warrant the performance, availability, coverage, uninterrupted use, security, pricing or operation of the Services, the Equipment <strong>(except towards residents of Qu&eacute;bec** in accordance with statutory warranties)</strong> or any products, content, applications, software, services, facilities, connections or networks used or provided by us or third parties (collectively, the <strong>&ldquo;Offering&rdquo;</strong>);<br>ii. Rogers may limit the amount of an Offering that you may purchase;<br>iii.you bear the entire risk as to the use, access, transmission, availability, reliability, timeliness, quality, security and performance of the Offering;<br>iv. the Rogers Parties do not make any express or implied representations, warranties or conditions, including warranties of title or non-infringement, or implied warranties of merchantable quality or fitness for a particular purpose, with regard to the Offering.</p><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong><br>v. all representations, warranties and conditions of any kind, express or implied, are excluded;<br>vi. no advice or information, whether oral or written, that you obtain from the Rogers Parties creates any term, condition, representation or warranty not expressly stated in an Agreement.</p><p>c. How does Rogers limit its liability?</p><p>Unless otherwise specifically set out in an Agreement, to the maximum extent permitted by applicable law, and <strong>except towards Residents of Qu&eacute;bec** for damages resulting from a Rogers Party&rsquo;s own act</strong>, the Rogers Parties will not be liable to you or to any third party for:</p><p>i. <strong>Not applicable to Residents of Qu&eacute;bec**:</strong> any direct, indirect, special, consequential, incidental, economic or punitive damages (including loss of profit or revenue; financial loss; loss of business opportunities; loss, destruction or alteration of data, files or software; breach of privacy or security; property damage; personal injury; death; or any other foreseeable or unforeseeable loss, however caused) resulting or relating directly or indirectly from or relating to the Offering or any advertisements, promotions or statements relating to any of the foregoing, even if we were negligent or were advised of the possibility of such damages;<br>ii. <strong>Applicable only to Residents of Qu&eacute;bec**:</strong> any damages (including loss of profit or revenue; financial loss; loss of business opportunities; loss, destruction or alteration of data, files or software; breach of privacy or security; or property damage) resulting or relating directly or indirectly from or relating to the Offering;<br>iii. any Offering provided to you or accessible by you through the Services, any charges incurred in connection with such Offering or anything that is or can be done with such Offering even if you are billed for such Offering;<br>iv. the performance, availability, reliability, timeliness, quality, coverage, uninterrupted use, security, pricing or operation of the Offering;<br>v. any error, inclusion or omission relating to any telephone listings or directories;<br>vi. the denial, restriction, blocking, disruption or inaccessibility of any Services, including 9-1-1, public alerts or special needs services, Equipment or identifiers (including phone numbers);<br>vii. any lost, stolen, damaged or expired Equipment, identifiers, passwords, codes, benefits, discounts, rebates or credits;<br>viii. any error, omission or delay in connection with the transfer of phone numbers to or from another telecommunications service provider, or any limitation connected to that transfer or that telecommunications service provider;<br>ix. any acts or omissions of a telecommunications carrier whose facilities are used to establish connections to points that we do not serve; or<br>x. any claims or damages resulting directly or indirectly from any claim that the use, intended use or combination of the Offering or any material transmitted through the Services infringes the intellectual property, industrial, contractual, privacy or other rights of a third party.</p><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong> These limits are in addition to any other limits on the Rogers Parties&rsquo; liability set out elsewhere in an Agreement and apply to any act or omission of the Rogers Parties, whether or not the act or omission would otherwise be a cause of action in contract, tort or pursuant to any statute or other doctrine of law.<br></p><p>d. Are there any additional limitations of liability that apply to 9-1-1 emergency services?</p><p><strong>For wireless Services:</strong></p><p>We are not liable for:<br>i. libel, slander, defamation or the infringement of copyright arising from material or messages transmitted over our network from your property or premises or recorded by your equipment or our equipment;<br>ii. damages arising out of your act, default, neglect or omission in the use or operation of equipment that we provide;<br>iii. damages arising out of the transmission of material or messages over our network on your behalf, which is in any way unlawful; or<br>iv. any act, omission or negligence of other companies or telecommunications systems when their facilities are used in establishing connections to or from your facilities and equipment. Except in cases where negligence on our part results in physical injury, death or damage to your property or premises, our liability for negligence related to the provision of 9-1-1 emergency services on a mandatory basis is limited to the greater of <strong>$20</strong> and <strong>3</strong> times the amount, if any, you would otherwise be entitled to receive as a refund for the provision of defective Service under an Agreement. However, our liability is not limited by this Section in cases of deliberate fault, gross negligence or anticompetitive conduct on our part or in cases of breach of contract where the breach results from our gross negligence.</p><p><strong>For home phone Services:</strong><br>In order for 9-1-1 emergency services to function properly with home phone Services, you must use the adapter which forms part of the Equipment we have provided you (<strong>&ldquo;Adaptor&rdquo;</strong>) and other Equipment at your service address. We will not be liable to you or to any third party for your failure to comply with this requirement. The home phone Services may not function correctly, or at all, in the following circumstances:<br>i. if your Adaptor or other Equipment fails or is not configured correctly;<br>ii. in the event of a cable network outage or extended power failure;<br>iii.if you tamper with or move your Adaptor or other Equipment to a location other than your service address; or<br>iv. following suspension or cancellation of your Services or account.<br>We will not be liable to you or to any third party for any inability to use the home phone Services or to obtain access to 9-1-1 emergency services as a result of the limitations described in this Section.</p><p>e. Are there any circumstances under which I would have to compensate Rogers?</p><p>You will indemnify and hold harmless the Rogers Parties from and against any claims, losses, damages, costs and expenses (including, without limitation, reasonable legal fees and other litigation expenses) incurred by the Rogers Parties relating to your violation, alleged violation or misappropriation of any intellectual property, industrial, contractual, privacy or other rights of a third party or any alleged libel or slander by a third party against you.</p></div>");
$templateCache.put("views/localization/your-privacy-fr.html","<div class=\"bold paragraph\">Protection de votre vie priv&eacute;e</div><div class=\"paragraph\"><p>a. Que peut faire Rogers avec les renseignements sur mon compte et mes renseignements personnels?</p><p>En concluant une Entente, vous :</p><p>i. autorisez express&eacute;ment Rogers &agrave; recueillir et &agrave; utiliser vos donn&eacute;es de localisation personnelles courantes et historiques associ&eacute;es &agrave; tout appareil que vous utilisez aux termes de votre ou vos Ententes de service pour vous fournir des services de g&eacute;olocalisation, &eacute;tant entendu que vous pouvez vous d&eacute;sabonner de ces services en tout temps.<br>ii. convenez express&eacute;ment que les renseignements relatifs &agrave; votre compte peuvent &ecirc;tre divulgu&eacute;s &agrave; d&rsquo;autres membres de l&rsquo;organisation de Rogers Communications Inc. et &agrave; ses agents, concessionnaires autoris&eacute;s et distributeurs, afin de g&eacute;rer votre compte, de r&eacute;pondre &agrave; vos questions, de faire le t&eacute;l&eacute;marketing (y compris au moyen de composeurs messagers automatiques) et de vous proposer d&rsquo;autres produits et services offerts par les membres de l&rsquo;organisation de Rogers Communications Inc. Si vous ne souhaitez pas recevoir de telles offres ou information, veuillez communiquer avec nous de l&rsquo;une ou l&rsquo;autre des fa&ccedil;ons indiqu&eacute;es au paragraphe 10e) ci-apr&egrave;s.</p><p>b. O&ugrave; seront stock&eacute;s mes renseignements personnels?</p><p>Les renseignements personnels recueillis dans le cadre de la prestation des Services peuvent &ecirc;tre enregistr&eacute;s et trait&eacute;s au Canada ou &agrave; l&rsquo;&eacute;tranger et &ecirc;tre soumis aux lois en vigueur dans d&rsquo;autres territoires.</p><p>c. Rogers divulguera-t-elle mes renseignements personnels &agrave; des tierces parties?</p><p>&Agrave; moins que vous ne fournissiez votre consentement explicite, ou que cette divulgation soit requise aux termes d&rsquo;une obligation l&eacute;gale, toute l&rsquo;information vous concernant que nous d&eacute;tenons, sauf votre nom, votre adresse et votre num&eacute;ro de t&eacute;l&eacute;phone inscrit dans l&rsquo;annuaire, est confidentielle et ne pourra &ecirc;tre divulgu&eacute;e par nous &agrave; quiconque autre que :</p><p>i. vous;<br>ii. une personne qui, selon notre jugement raisonnable, agit comme votre mandataire pour obtenir de l&rsquo;information;<br>iii.une autre compagnie de t&eacute;l&eacute;phone, dans la mesure o&ugrave; les renseignements sont requis pour offrir un service de t&eacute;l&eacute;phonie r&eacute;sidentielle efficace et rentable, que la divulgation se fait sur une base confidentielle et que l&rsquo;information est utilis&eacute;e uniquement &agrave; cette fin;<br>iv. un fournisseur vous assurant des services reli&eacute;s aux fonctions de t&eacute;l&eacute;phonie ou d&rsquo;annuaire t&eacute;l&eacute;phonique, dans la mesure o&ugrave; une telle divulgation se fait sur une base confidentielle et que l&rsquo;information est divulgu&eacute;e et utilis&eacute;e uniquement &agrave; cette fin;<br>v. un agent mandat&eacute; par nous pour le recouvrement de vos cr&eacute;ances ou pour toute autre fonction administrative, dans la mesure o&ugrave; l&rsquo;information est divulgu&eacute;e et utilis&eacute;e uniquement &agrave; ces fins;<br>vi. un agent mandat&eacute; par nous pour &eacute;valuer votre solvabilit&eacute;, dans la mesure o&ugrave; l&rsquo;information est divulgu&eacute;e et utilis&eacute;e uniquement &agrave; cette fin;<br>vii. un corps policier lorsque nous avons des motifs raisonnables de croire que vous nous avez sciemment fourni des renseignements faux ou trompeurs ou que vous &ecirc;tes engag&eacute; de quelque autre fa&ccedil;on dans des activit&eacute;s ill&eacute;gales;<br>viii. une autorit&eacute; publique ou le mandataire d&rsquo;une autorit&eacute; publique si, selon notre jugement raisonnable, nous croyons que la divulgation de vos renseignements pourrait &eacute;viter ou att&eacute;nuer un danger de mort ou de dommage mat&eacute;riel imminent;<br>ix. une autorit&eacute; publique ou le mandataire d&rsquo;une autorit&eacute; publique, aux fins des alertes publiques d&rsquo;urgence, si l&rsquo;autorit&eacute; publique a conclu &ecirc;tre en pr&eacute;sence d&rsquo;un danger imminent ou sur le point de se produire mettant en danger la vie, la sant&eacute; ou la s&eacute;curit&eacute; de tout individu et que le danger pourrait &ecirc;tre &eacute;vit&eacute; ou minimis&eacute; par la divulgation de l&rsquo;information.</p><p>d. De quelle fa&ccedil;on Rogers obtient-elle mon consentement &agrave; la divulgation de mes renseignements personnels?</p><p>Le consentement explicite &agrave; la divulgation peut &ecirc;tre obtenu comme suit :</p><p>i. un consentement &eacute;crit;<br>ii. une confirmation orale v&eacute;rifi&eacute;e par une tierce partie ind&eacute;pendante;<br>iii.une confirmation &eacute;lectronique par l&rsquo;utilisation d&rsquo;un num&eacute;ro sans frais;<br>iv. une confirmation &eacute;lectronique par Internet;<br>v. un consentement oral pour lequel nous avons conserv&eacute; un enregistrement audio; ou<br>vi. un consentement donn&eacute; par une autre m&eacute;thode, dans la mesure o&ugrave; il existe un enregistrement document&eacute; objectif de votre consentement cr&eacute;&eacute; par vous ou par un tiers ind&eacute;pendant.</p><p>e. Puis-je demander d&rsquo;avoir un num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel non inscrit dans l&rsquo;annuaire?</p><p>Vous pouvez choisir de payer pour avoir un num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel non inscrit dans l&rsquo;annuaire; cependant, veuillez noter que les fournisseurs d&rsquo;annuaires et de services de t&eacute;l&eacute;phoniste peuvent obtenir votre num&eacute;ro de t&eacute;l&eacute;phone et votre adresse d&rsquo;une source autre que nous. Par ailleurs, votre nom, votre adresse et votre num&eacute;ro de t&eacute;l&eacute;phone seront accessibles par les fournisseurs de service 9-1-1, m&ecirc;me si vous payez pour avoir un num&eacute;ro de t&eacute;l&eacute;phone non inscrit.</p><p>f. Comment puis-je obtenir de l&rsquo;information sur la protection de mes renseignements personnels chez Rogers?</p><p>Nos Politiques de protection de la vie priv&eacute;e d&rsquo;entreprise et en ligne se trouvent &agrave; <a href=\"http://rogers.com/privee\">rogers.com/privee</a>. Pour communiquer avec notre Agent de protection de la vie priv&eacute;e afin d&rsquo;acc&eacute;der &agrave; vos renseignements personnels conserv&eacute;s par Rogers, d&rsquo;obtenir plus d&rsquo;information &agrave; ce sujet, de formuler une plainte au sujet de la protection de la vie priv&eacute;e, ou d&rsquo;obtenir un exemplaire de nos Politiques de protection de la vie priv&eacute;e, envoyez un courriel &agrave; l&rsquo;adresse <a href=\"mailto:privacy@rci.rogers.com\">privacy@rci.rogers.com</a> ou &eacute;crivez &agrave; notre Agent de protection de la vie priv&eacute;e, Groupe de soci&eacute;t&eacute;s Rogers, 333, rue Bloor Est, Toronto (ON) M4W 1G9.</p></div>");
$templateCache.put("views/localization/your-privacy.html","<div class=\"bold paragraph\">YOUR PRIVACY</div><div class=\"paragraph\"><p>a. What can Rogers do with my account information and personal information?</p><p>By entering into an Agreement, you expressly:</p><p>i. authorize Rogers to collect and use your current and historical personal location information associated with any device you use under your Agreement(s) in order to provide geo-location services to you, with the ability to opt-out of these services at any time.<br>ii. agree that your account information may be disclosed to other members of the Rogers Communications Inc. organization, and to our agents, authorized dealers and distributors to service your account, respond to your questions, telemarket (including by way of automatic dialing and announcing devices), and promote additional products and services offered by members of the Rogers Communications Inc. organization. If you do not wish to receive these offers or information, please contact us in any of the ways set out in Section 10(e) below.<br></p><p>b. Where will my personal information be stored?</p><p>Personal information collected in connection with the provision of the Services may be stored and processed in or outside Canada and may be subject to the laws of other jurisdictions.</p><p>c. Will Rogers disclose my personal information to any outside parties?</p><p>Unless you provide express consent or disclosure is required pursuant to a legal power, all information regarding you kept by us, other than your name, address and listed phone number, is confidential and may not be disclosed by us to anyone other than:</p><p>i. you;<br>ii. a person who, in our reasonable judgment, is seeking the information as your agent;<br>iii.another telephone company, provided the information is required for the efficient and cost-effective provision of home phone service and disclosure is made on a confidential basis, with the information to be used only for that purpose;<br>iv. a company involved in supplying phone or phone directory-related services, provided the information is required for that purpose and disclosure is made on a confidential basis, with the information to be used only for that purpose;<br>v. an agent retained by us in the collection of your account or to perform other administrative functions for us, provided the information is required for and used only for that purpose;<br>vi. an agent retained by us to evaluate your creditworthiness, provided the information is required for and is to be used only for that purpose;<br>vii. a law enforcement agency whenever we have reasonable grounds to believe that you have knowingly supplied us with false or misleading information or are otherwise involved in unlawful activities;<br>viii. a public authority or agent of a public authority if, in our reasonable judgment, it appears that there is imminent danger to life or property which could be avoided or minimized by disclosure of the information; or<br>ix. a public authority or agent of a public authority, for emergency public alerting purposes, if a public authority has determined that there is an imminent or unfolding danger that threatens the life, health or security of an individual and that the danger could be avoided or minimized by disclosure of the information.</p><p>d. How does Rogers obtain consent from me to disclose my personal information?</p><p>Express consent to disclosure may be obtained by:</p><p>i. written consent;<br>ii. oral confirmation verified by an independent third party;<br>iii.electronic confirmation through the use of a toll-free number;<br>iv. electronic confirmation via the internet;<br>v. oral consent, where an audio recording of the consent is retained by us; or<br>vi. consent through other methods, as long as an objective documented record of your consent is created by you or by an independent third party.</p><p>e. Can I have an unlisted home phone number?</p><p>You may opt to pay for an unlisted home phone number; however, please note that directories or providers of operator services may obtain your phone numbers and address from a source other than us. In addition, your name, address and phone numbers will be accessible by 9-1-1 service providers even if you pay for an unlisted phone number.</p><p>f. How can I get more information about the protection of my personal information at Rogers?</p><p>Our corporate and online Privacy Policies are available at <a href=\"http://www.rogers.com/privacy\">rogers.com/privacy</a>. To contact our Privacy Officer in order to access, obtain more information about your personal information held by Rogers, make a privacy-related complaint, or obtain a copy of our Privacy Policies: e-mail us at <a href=\"mailto:privacy@rci.rogers.com\">privacy@rci.rogers.com</a>; or write to Chief Privacy Officer, Rogers Group of Companies, 333 Bloor Street East, Toronto, ON M4W 1G9.</p></div>");
$templateCache.put("views/localization/your-use-of-services-fr.html","<div class=\"bold paragraph\">Votre utilisation des Services</div><div class=\"paragraph\"><p>a. Suis-je propri&eacute;taire de mon num&eacute;ro de t&eacute;l&eacute;phone?</p><p>Vous n&rsquo;&ecirc;tes pas propri&eacute;taire de tout num&eacute;ro de t&eacute;l&eacute;phone, adresse courriel ou autre identifiant qui vous est attribu&eacute;. Nous pouvons changer ou supprimer un identifiant &agrave; tout moment.</p><p>b. Rogers surveille-t-elle le contenu que je transmets lorsque j&rsquo;utilise les Services?</p><p>Nous avons le droit, mais non l&rsquo;obligation, de surveiller tout &eacute;l&eacute;ment de contenu transmis au moyen des Services (autres que les Services de transmission de la voix) ou de l&rsquo;&Eacute;quipement, et de faire enqu&ecirc;te sur ceux-ci. Nous pouvons &eacute;galement consulter ou conserver du contenu ou de l&rsquo;information afin de nous conformer au processus judiciaire en vigueur au Canada et dans des territoires &eacute;trangers, d&rsquo;exploiter les Services, de veiller au respect d&rsquo;une Entente, ou encore de nous prot&eacute;ger nous-m&ecirc;mes et de prot&eacute;ger nos clients et le public.</p><p>c. Quelles sont mes responsabilit&eacute;s &agrave; l&rsquo;&eacute;gard des logiciels ou du contenu de Rogers ou de tierces parties?</p><p>Toutes les marques de commerce et tous les droits d&rsquo;auteur, concepts de marque, noms, logos et dessins que nous utilisons sont des actifs de propri&eacute;t&eacute; intellectuelle, d&eacute;pos&eacute;s ou autre, de Rogers Communications Inc. ou d&rsquo;une soci&eacute;t&eacute; membre de son groupe, ou encore sont utilis&eacute;s en vertu d&rsquo;une licence de Rogers Communications Inc. ou d&rsquo;une soci&eacute;t&eacute; membre de son groupe. Tous ces &eacute;l&eacute;ments sont reconnus comme des actifs de valeur de leurs propri&eacute;taires respectifs, et vous ne pouvez pas les afficher, les copier ni les utiliser de quelque fa&ccedil;on que ce soit &agrave; des fins commerciales ni pour quelque autre fin que ce soit.</p><p>Tout logiciel ou contenu que vous recevez ou achetez par l&rsquo;interm&eacute;diaire de Rogers ou d&rsquo;une de nos boutiques tierces ne peut servir qu&rsquo;&agrave; une utilisation personnelle non commerciale. Un tel logiciel ou contenu demeure notre propri&eacute;t&eacute; ou celle de nos conc&eacute;dants de licence ou de nos fournisseurs de contenu, le cas &eacute;ch&eacute;ant. Vous ne pouvez pas :</p><p>i. copier, distribuer, transf&eacute;rer ou vendre un tel logiciel ou contenu;<br>ii. modifier, changer ou falsifier un tel logiciel ou contenu;<br>iii. d&eacute;sosser, d&eacute;compiler ou d&eacute;sassembler une partie du logiciel;<br>iv. tenter de d&eacute;jouer, &eacute;viter, contourner, retirer ou d&eacute;sactiver les m&eacute;canismes de protection d&rsquo;un tel logiciel.</p><p>Vous devez &eacute;galement prendre toutes les mesures raisonnables pour prot&eacute;ger les logiciels ou le contenu contre le vol, la perte et les dommages. Veuillez noter que de tels logiciels ou contenus peuvent, de temps &agrave; autre et sans que vous en soyez avis&eacute;, faire en sorte que votre &Eacute;quipement acc&egrave;de &agrave; Internet de fa&ccedil;on automatique, entra&icirc;nant des frais de transmission de donn&eacute;es et (ou) des frais d&rsquo;utilisation exc&eacute;dentaire.</p><p>d. Que dois-je savoir &agrave; propos des Services Yahoo! qui me sont offerts?</p><p>Yahoo! Inc. et les soci&eacute;t&eacute;s membres de son groupe peuvent offrir aux clients du Service d&rsquo;acc&egrave;s Internet de Rogers l&rsquo;acc&egrave;s &agrave; une gamme de ressources, incluant divers outils de communication et du contenu vari&eacute; (les <strong>&laquo; Services Yahoo! &raquo;</strong>). Lorsque vous utilisez les Services Yahoo!, les modalit&eacute;s de service, les lignes directrices et les r&egrave;glements de Yahoo! (les <strong>&laquo; Modalit&eacute;s Yahoo! &raquo;</strong>) qui s&rsquo;appliquent &agrave; ces services et qui sont affich&eacute;s sur les pages o&ugrave; vous acc&eacute;dez &agrave; ces services r&eacute;gissent votre utilisation des Services Yahoo! En utilisant les Services Yahoo!, vous acceptez d&rsquo;&ecirc;tre li&eacute; par les Modalit&eacute;s Yahoo! int&eacute;gr&eacute;es par renvoi &agrave; une Entente. En ce qui concerne le Service d&rsquo;acc&egrave;s Internet de Rogers et les Services Yahoo!, les obligations respectives de Rogers et de Yahoo! sont distinctes et non conjointes. Pour communiquer avec Yahoo! Inc. au sujet des Services Yahoo! seulement, veuillez &eacute;crire au Service &agrave; la client&egrave;le, 701, First Avenue, Sunnyvale, CA, 94089, &Eacute;tats-Unis. Pour obtenir de plus amples renseignements au sujet du traitement de vos renseignements personnels lorsque vous utilisez le Service d&rsquo;acc&egrave;s Internet de Rogers et les Services Yahoo!, consultez <a href=\"http://www.rogers.yahoo.com/privacy\">rogers.yahoo.com/privacy</a>.</p></div>");
$templateCache.put("views/localization/your-use-of-services.html","<div class=\"bold paragraph\">YOUR USE OF THE SERVICES</div><div class=\"paragraph\"><p>a. Do I own my phone number?</p><p>You do not own any phone number, e-mail address or other identifier assigned to you. We may change or remove an identifier at any time.</p><p>b. Does Rogers monitor the content that I transmit when I use the Services?</p><p>We have the right, but not the obligation, to monitor or investigate any content that is transmitted using the Services (other than voice Services) or the Equipment. We may also access or preserve content or information to comply with legal process in Canada or foreign jurisdictions, operate the Services, ensure compliance with an Agreement, or protect ourselves, our customers or the public.</p><p>c. What are my responsibilities relating to Rogers or third party software or content?</p><p>All trademarks, copyright, brand concepts, names, logos and designs that we use are intellectual property assets, registered or otherwise, of or used under license by Rogers Communications Inc. or of one of its affiliates. All are recognized as valuable assets of their respective owners, and you may not display, copy or use them in any manner for commercial or any other purpose.</p><p>Any software or content that you receive or purchase through Rogers or our third party storefronts is for your own personal, non-commercial use. This software or content remains our property or that of our licensors or content providers, as applicable. You may not:</p><p>i. copy, distribute, transfer or sell any of this software or content;<br>ii. modify, alter or tamper with any of this software or content;<br>iii.reverse engineer, decompile or disassemble any of this software;<br>iv. attempt to defeat, avoid, by-pass, remove, deactivate or otherwise circumvent any software protection mechanisms.</p><p>You must also take reasonable steps to protect this software or content from theft, loss or damage. Please be aware that software or content may from time to time automatically and, without notice to you, cause your Equipment to access the internet incurring data usage and/or overage charges.</p><p>d. What do I need to know about the Yahoo! Services available to me?</p><p>Yahoo! Inc. and its affiliates may provide Rogers internet Service customers with access to a collection of resources, including various communications tools and content (the <strong>&ldquo;Yahoo! Services&rdquo;</strong>). When you use the Yahoo! Services, the Yahoo! terms of service, guidelines and rules <strong>(&ldquo;Yahoo! Terms&rdquo;)</strong> applicable to such services that are posted on the pages where you access these services govern your use of the Yahoo! Services. By using the Yahoo! Services you agree to be bound by the Yahoo! Terms which are incorporated by reference into an Agreement. With respect to Rogers internet Services and the Yahoo! Services, the obligations of Rogers and Yahoo! are several and not joint. To contact Yahoo! Inc. regarding the Yahoo! Services only: write to Customer Care, 701 First Avenue, Sunnyvale, CA, 94089, USA. Information about how your personal information is treated when using the Rogers internet Services and Yahoo! Services is available at <a href=\"http://www.rogers.yahoo.com/privacy\">rogers.yahoo.com/privacy</a>.</p></div>");
$templateCache.put("views/modals/account-removal-confirmation.html","<div class=\"verify-address totes-project\"><img class=\"close-icon\" ng-show=\"showRemovalConfirmation\" ng-click=\"close(true)\" src=\"images/close-icon.png\"> <img class=\"close-icon\" ng-show=\"!showRemovalConfirmation\" ng-click=\"close()\" src=\"images/close-icon.png\"><h3 class=\"address-heading\" res=\"_account_removal_confirmation_heading\">Account Removal Confirmation</h3><p class=\"subheading\" ng-show=\"!showRemovalConfirmation\" res=\"_account_removal_confirmation_message\">You are about to remove the account shown below. You can add or re-link accounts to your profile at any time</p><div ng-show=\"!showRemovalConfirmation\" class=\"gray-border\"></div><div ng-show=\"showRemovalConfirmation\"><span res=\"_account_removal_success_msg\"></span></div><div ng-show=\"!showRemovalConfirmation\" class=\"account-name customer-info-container\"><span res=\"_account_removal_confirmation_accountname\">Account Name:</span><div>{{accountName}}</div></div><div ng-show=\"!showRemovalConfirmation\" class=\"account-number customer-info-container\"><span res=\"_account_removal_confirmation_accountnumber\">Account Number:</span><div>{{accountNumber}}</div><img ng-show=\"loading\" class=\"widget-loader remove-account-loader\" src=\"images/widget-loader.gif\"></div><div ng-show=\"!showRemovalConfirmation\" class=\"button-container account-removal-button-container\"><button class=\"cancel-button cta-round tertiary large\" res=\"_cancel\" ng-click=\"close()\">cancel</button> <button class=\"submit-address cta-round primary large\" res=\"_remove_account\" ng-click=\"removeAccount()\">remove account</button></div></div>");
$templateCache.put("views/modals/accountOverviewLinkModal.html","<div class=\"totes-project\"><div class=\"module-account-overview-dialog\" id=\"myModal4\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1></h1><h3 res=\"acc_overview_which_account\"></h3></div></div><div class=\"row\"><ul class=\"list-of-accounts pln\"><li ng-repeat=\"value in al.als.accountTypes\" ng-click=\"selectAccountModal(value); closeThisDialog(\'Cancel\')\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"manageBAN\"><div class=\"account-ctn\" ng-class=\"{warning: value.accountStatusSimple == \'Warning\', error: value.accountStatusSimple === \'Error\'}\"><div class=\"account-name-ctn\" data-ng-show=\"!value.nickName\"><span class=\"account-name-txt\">{{value.accountName.firstName| capitalize}}</span></div><div class=\"account-name-ctn\" data-ng-show=\"value.nickName\"><span class=\"account-name-txt\">{{value.nickName}}</span></div><div class=\"account-number-ctn\"><span class=\"account-number-txt\"><span class=\"rui-icon-error-icon error-red\" ng-show=\"value.accountStatusSimple === \'Error\'\"></span> <span class=\"rui-icon-warning warning-color\" ng-show=\"value.accountStatusSimple === \'Warning\'\"></span> <span>{{value.accountNumber}}</span></span></div><div class=\"account-txt-warning\" ng-show=\"value.accountStatusSimple === \'Warning\'\"><span res=\"{{value.accountStatusModalMessage}}\"></span></div><div class=\"account-txt-error\" ng-show=\"value.accountStatusSimple === \'Error\'\"><span res=\"{{value.accountStatusModalMessage}}\"></span></div></div></li></ul></div></div></div>");
$templateCache.put("views/modals/briteBillPromo.html","<div class=\"totes-project\"><section class=\"module-brite-bill-promo-modal\"><img class=\"close-icon\" ng-click=\"cancel()\" src=\"images/close-icon.png\"><div id=\"video-ctn\" class=\"video-ctn\"><iframe class=\"youtube-video\" ng-src=\"{{videoLink}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></section></div>");
$templateCache.put("views/modals/disassociateModalFail.html","<div class=\"verify-address totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"images/close-icon.png\"><h3 class=\"address-heading\">Account Add/Removal Error</h3><p class=\"_account_removal_error_msg\">Sorry! It seems something went wrong on our end. A client care rep is available to help on</p><div ng-if=\"language === \'en\'\"><img src=\"images/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=24\" class=\"live-chat-label\" res=\"_live_chat\">Live Chat</a><img src=\"images/black-right-arrow.png\"></div><div ng-if=\"language === \'fr\'\"><img src=\"images/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_fr_landing.php?s=74\" class=\"live-chat-label\" res=\"_live_chat\">Live Chat</a><img src=\"images/black-right-arrow.png\"></div></div>");
$templateCache.put("views/modals/dmFailureMessage.html","<div class=\"modal-container\"><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\" res=\"dmAlertMsg\" style=\"font-size: 18px;\"></div><div class=\"col-xs-12\" style=\"margin-top:15px;\"><button type=\"button\" class=\"button-default col-xs-6 col-sm-3 pull-right\" ng-click=\"closeDmAlertMsg()\"><span res=\"wireless_ok\"></span></button></div></div></div></div>");
$templateCache.put("views/modals/error-message.html","{{ message }} <button ng-click=\"cancel()\">OK</button>");
$templateCache.put("views/modals/generalErrorDialog.html","<div class=\"verify-address general-error totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"images/close-icon.png\"><div class=\"error-explanation\"><img class=\"error-img\" src=\"images/error-exclamation.png\"><p ng-show=\"verifyAddressFailed\" class=\"subheading error-description\" res=\"verify_address_general_error\"></p><p ng-hide=\"verifyAddressFailed\" class=\"subheading error-description\" res=\"general_error\"></p></div><div class=\"live-chat-icon\"><div ng-if=\"language === \'en\'\"><img src=\"images/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=105\" class=\"live-chat-label\" res=\"_live_chat\">Live Chat</a><img src=\"images/black-right-arrow.png\"></div><div ng-if=\"language === \'fr\'\"><img src=\"images/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=105\" class=\"live-chat-label\" res=\"_live_chat\">Live Chat</a><img src=\"images/black-right-arrow.png\"></div></div></div>");
$templateCache.put("views/modals/linkAccountModalCtrl.html","<div class=\"totes-project\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"link-account-title\"><span res=\"link_account_title\"></span></h4><div class=\"pbm\"><span res=\"link_account_intro\"></span></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-left\"><a type=\"button\" class=\"title-h5 bold pointer uppercase\" ng-click=\"cancel()\"><span res=\"_cancel\"></span></a></div><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\"><span res=\"_continue\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"guestOverviewToLinkAccount\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/marketingPermissionsInfo.html","<div class=\"verify-address marketing-permissions-info general-error totes-project\"><img class=\"close-icon\" ng-click=\"closeModal()\" src=\"images/close-icon.png\"><div><p res=\"marketing_permissions_info\"></p></div></div>");
$templateCache.put("views/modals/modalEmpty.html","<div class=\"totes-project\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\">in development</div></div>");
$templateCache.put("views/modals/paper-billing-modal.html","<div class=\"modal-body modal-password-requirements\"><img class=\"close-icon\" ng-click=\"closeModal()\" src=\"images/close-icon.png\"><h3>Paper Billing</h3><p>You will receive your bills in the mail at the beginning of the next billing cycle. Please check your Billing Address to make sure we have the correct information.</p><p>You may also select Online Billing, which would directly send your Bills to your email imbox.</p></div>");
$templateCache.put("views/modals/passwordRequirement.html","<div class=\"verify-address general-error totes-project\"><img class=\"close-icon\" ng-click=\"closeModal()\" src=\"images/close-icon.png\"><div><h3 res=\"_password_requirements_label\">Password Requirements</h3><p res=\"_password_requirements_text\">Your password must be between 8 and 16 characters. It should contain at least one letter, at least one number and no special characters</p></div></div>");
$templateCache.put("views/modals/paynowCancel.html","<div class=\"totes-project\"><div class=\"page-pay-now\" style=\"padding:15px\"><div class=\"row\"><div class=\"ngdialog-close pull-right\"></div></div><div class=\"row\"><div class=\"dialog link-account\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span res=\"paynow_cancel_desc\"></span></div></div><div class=\"row ngdialog-buttons\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><button name=\"paynow_continue\" type=\"button\" tabindex=\"10\" class=\"cta-round primary medium mtm modal-ok-btn\" ng-click=\"cancelOk()\" res=\"paynow_continue\"></button> <button name=\"cancel\" class=\"cta-round secondary medium btn-redeem dark-gray-btn mtm mrm modal-cancel-btn\" tabindex=\"9\" ng-click=\"cancelCancel()\"><span res=\"paynow_cancel\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/paynowFailure.html","<div class=\"totes-project page-pay-now\"><div style=\"padding:15px\"><div class=\"row\"><div class=\"ngdialog-close pull-right\"></div></div><div><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1\"><span class=\"message-banner-icon icon-alert\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 pln prn\" style=\"float:left\"><div><span ng-bind-html=\"sorryMessage\"></span></div></div></div><div class=\"ngdialog-buttons\"><div class=\"row mtl\"><div class=\"col-lg-6 col-md-6\">&nbsp;</div><div class=\"col-xs-6 col-lg-6 col-md-6 col-sm-6\"><button name=\"cancel\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"showBegin()\" res=\"paynow_select_another\"></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/paynowSuccess.html","<div class=\"totes-project page-pay-now\"><div style=\"padding:15px\"><div class=\"row ptm\"><div class=\"col-xs-12 col-sm-12\" ng-class=\"{\'col-md-5 col-lg-5\':isPreAuthorized, \'col-md-12 col-lg-12\':!isPreAuthorized}\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\" style=\"max-width: 45px;\"><span class=\"message-banner-icon icon-success prs\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div><span ng-bind-html=\"thankYouMessage\"></span></div><div class=\"ptm pbm\" ng-class=\"{\'\':isPreAuthorized, \'pull-right\':!isPreAuthorized}\"><button name=\"cancel\" class=\"cta-round secondary medium mts\" ng-click=\"goToOverview()\"><span res=\"paynow_go_to_overview\"></span></button></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7 mbm mts\" data-ng-hide=\"!isPreAuthorized\"><div class=\"payNowThanks no-border\"><div class=\"myServiceArrow\"></div><div class=\"row ptl\"><div class=\"never-miss-ctn col-xs-10 col-md-10 col-lg-10 col-sm-10 col-md-font-size\"><span class=\"never-miss-1\" res=\"paynow_never_miss_1\"></span> <span class=\"never-miss-2\" res=\"paynow_never_miss_2\"></span></div></div></div></div></div></div></div>");
$templateCache.put("views/modals/pdEligibility.html","<div class=\"totes-project\"><div class=\"pd-eligibility-modal\"><div class=\"modal-close\" ng-click=\"vm.cancel()\"><span>&times;</span></div><div class=\"modal-header\"><h2 res=\"_pd_error_title\"></h2></div><div class=\"modal-body\"><div ng-show=\"vm.language === \'en\'\" ng-repeat=\"genDescEn in vm.isErrorDescEn\">{{genDescEn}}</div><div ng-show=\"vm.language === \'fr\'\" ng-repeat=\"genDescFr in vm.isErrorDescFr\">{{genDescFr}}</div></div><div class=\"modal-footer\"><button class=\"cta-round primary medium\" ng-click=\"vm.cancel()\" res=\"_continue\"></button></div></div></div>");
$templateCache.put("views/modals/ppc-full-details-en.html","<section class=\"module-ppc-modal single-line-ppc\"><div style=\"font-size: 16px;\"><img class=\"close-icon\" src=\"images/close-icon.png\" ng-click=\"cancel()\"><p style=\"font-size: 16px;\"><span style=\"font-weight: 600;\">Offers available for a limited time and subject to change without notice.</span><br></p><p style=\"font-size: 16px;\">* Third-party services are not provided by Rogers and are subject to third-party terms and conditions provided at time of registration. Services are available with eligible plans only and are free of monthly subscription fees for a 2-year period starting on the day your plan is first activated. Services may only be changed up to 30 days after plan activation date, after which time services can no longer be changed. Access to third-party services will end after such 2-year period, unless you elect to purchase a paid subscription to such service. Changing to an ineligible plan or cancellation of your plan or account will end your access to these services. Spotify Premium: Limit 3 Spotify Premium subscriptions for personal use within the same family across all Rogers brands; users will not be eligible for a similar offer under another Rogers brand after having activated their subscription under this offer. Next Issue: If you are an existing subscriber, you authorize us to associate your existing Next Issue account with your wireless telephone number as part of this offer. Data consumption: approx. 1 MB/min. for use of audio streaming, approx. 1.4 GB /h for use of video streaming (at the default “Best” setting, to a smartphone or tablet) and approx. 250 MB/magazine (varies based on length of audio/video, stream quality, device and other factors). Data usage exceeding your plan allotment (overage) is charged in increments rounded up to the next MB or GB (as applicable based on your plan). Standard roaming charges apply when not on the Rogers Wireless or an Extended Coverage area within Canada.</p><p style=\"font-size: 16px;\">&plusmn; Where applicable, additional airtime, data, long distance, roaming, options and taxes are extra and billed monthly. The following monthly government 9-1-1 fees apply where applicable: 62&cent; in Saskatchewan, 40&cent; in Quebec, 43&cent; in Nova Scotia, 53&cent; in New Brunswick, 70&cent; in Prince Edward Island, 44&cent; in Alberta, and 75&cent; in Newfoundland and Labrador. However, there is no airtime charge for calls made to 9-1-1 from your Rogers wireless device.</p><p style=\"font-size: 16px;\">Device Savings Recovery Fee (applicable to Term Services only). A Device Savings Recovery Fee (DSRF) applies if you were given an economic inducement when you agreed to your new term, and if, for any reason, your wireless service or your new term is terminated prior to the end of the term of your Service Agreement (Service Agreement Term). The DSRF is equal to the economic inducement multiplied by the number of months remaining in your Service Agreement Term divided by the total number of months of your Service Agreement Term (plus applicable taxes). In other words,&#160;<b>DSRF = Economic Inducement x # months left in your Service Agreement Term &divide; Total # months in your Service Agreement Term + applicable taxes.</b></p><p style=\"font-size: 16px;\">Price Plan Downgrade Fee. If, for any reason, you downgrade to a lower tier plan category during your term, then you will be charged a one-time price plan downgrade fee as set out in your service agreement.</p><ol style=\"margin-right: 6%;\"><li>Data usage exceeding the data allotment provided is charged in increments (refer to the applicable overage rate for your plan) rounded up to the next MB or GB (as applicable based on your plan).</li><li>On the Rogers network or an Extended Coverage area (excluding calls made through Call Forwarding, Video calling or similar services). Coverage not available in all areas. International long distance, text to landline and roaming charges extra. Only 10-digit Canadian based numbers eligible (excludes customers own wireless number, voicemail retrieval number and special numbers like 1-800/1-900).</li><li>Compatible device required. Includes unlimited extreme texts/picture/video messages sent from Canada to a Canadian wireless number and received texts from anywhere. Sent/ received premium texts (alerts, messages related to content and promotions), sent international texts and sent/received picture/video(as applicable) while roaming not included and charged at applicable rates.</li><li>Call Display is a service that allows you to see the number of incoming callers even if they are not in your address book. Compatible device required, not all numbers can be identified.</li><li>Records up to 3 messages; each message up to 3 minutes in length. Recorded messages saved for 3 days only.</li><li>Additional Call Forwarding minutes $0.10/minute (rounded to the next full minute).</li><li>Includes subscription for the 2015-16 season. Standard data overage/roaming charges apply. Free 2015-16 Season\'s Pass subscription with a Rogers Ignite&trade; internet plan (comparable legacy Hybrid Fibre 50 or above also eligible) or Share Everything&trade; wireless plan. MyRogers&trade; account registration required. Some blackouts and other restrictions apply based on your location at time of viewing. Other conditions apply. Visit rogers.com/terms for full terms and conditions. Data consumption is approx. 1GB/game when streamed to a smartphone and approx. 2-5GB/game when streamed to a tablet, computer, gaming console or TV (varies based on length of game, stream quality, device and other factors). Data usage exceeding your plan allotment (overage) is charged in increments rounded up to the next MB or GB (as applicable based on your plan). Standard roaming charges apply when not on the Rogers wireless network.</li><li>Taxes extra. The fee is a Pay-Per-Use rate and subject to change without notice. Fee is charged per line (in addition to your Share Everything plan monthly fee) and applies for 24 hours from first use while in an eligible country. Roaming charges apply when outside the eligible country. Data: Usage exceeding your plan allotment charged in increments rounded up to the next MB or GB (as applicable based on your plan). Texts: Includes texts sent to a local wireless number while in an eligible country or to a Canadian wireless number. Sent/received premium texts, sent international texts to countries other than the eligible countries charged at applicable rates. Calls: While in an eligible country, includes unlimited calls to local numbers or Canadian numbers. International long distance rates apply to calls made to other countries while in an eligible country. See rogers.com/terms for full terms and conditions and list of eligible countries.</li><li>By subscribing, user accepts that messages will be processed outside of Canada. This feature is available for all devices including BlackBerry, Android and iPhone through the text messaging inbox. Not compatible with the iPhone, BlackBerry or Android Visual Voicemail app. Customers who prefer Visual Voicemail must activate an iPhone Value Pack.</li><li>Applies to calls originating in Canada on the Rogers wireless network or an Extended Coverage area and terminating outside of Canada in the applicable countries. Rates differ for landline versus mobile terminated calls. Calls originating in Canada and terminating outside the applicable countries associated with the particular add-on charged at standard rates. Mobile Terminating calls are billed by the second (30-second minimum). Airtime charges apply to both landline and mobile terminating calls. Long distance charges are rounded up to the next full minute.</li><li>Applies to calls originating in Canada on the Rogers wireless network and terminating outside of Canada in the applicable countries. Rates differ for landline versus mobile terminated calls. Calls originating in Canada and terminating outside the applicable countries associated with the particular add-on charged at standard rates. Mobile Terminating calls are billed by the second (30-second minimum). Airtime charges apply to both landline and mobile terminating calls. Long distance charges are rounded up to the next full minute.</li><li>Includes text messages sent from Canada to the U.S. or Internationally. Sent text/picture/video messages while roaming are not included and are charged at applicable roaming rates.</li><li>Local calls only, excluding calls made through Call Forwarding, Video calling or similar services. Evenings are from 6 pm to 7 am, Monday to Friday, and weekends are from 6 pm Friday to 7 am Monday. Calls initiated outside these times are chargeable at standard rates or deplete from minutes allotted in your plan (as applicable).</li><li>Unlimited Canada-wide calls after 6 pm on the Rogers network (excluding calls made through Call Forwarding, Video calling or similar services). International long distance and roaming charges extra.</li><li>Records up to 35 messages; each message up to 5 minutes in length. Recorded messages saved for 10 days only.</li><li>Unlimited local calls (or unlimited province-wide calls in the province of Quebec) on the Rogers network or in an Extended Coverage area, excluding calls made through Call Forwarding, Video calling or similar services. Coverage not available in all areas. Long distance charges extra.</li></ol><p></p></div></section>");
$templateCache.put("views/modals/ppc-full-details-fr.html","<section class=\"module-ppc-modal single-line-ppc\"><div style=\"font-size: 16px;\"><img class=\"close-icon\" src=\"images/close-icon.png\" ng-click=\"cancel()\"><p style=\"font-size: 16px;\"><span style=\"font-weight: 600;\">Les offres sont d&rsquo;une dur&eacute;e limit&eacute;e et peuvent &ecirc;tre modifi&eacute;es sans pr&eacute;avis.</span><br></p><p style=\"font-size: 16px;\">* Les services de tierces parties ne sont pas fournis par Rogers et sont assujettis aux modalit&eacute;s des tierces parties fournies au moment de l&rsquo;abonnement. Les services sont offerts seulement avec les forfaits admissibles sans frais d&rsquo;abonnement mensuels pendant deux ans &agrave; partir de la date de mise en service du forfait. Les services ne peuvent &ecirc;tre modifi&eacute;s que dans les 30 jours suivant la date de mise en service; aucune modification ne pourra &ecirc;tre apport&eacute;e pass&eacute; ce d&eacute;lai. Apr&egrave;s la p&eacute;riode de deux ans, l&rsquo;acc&egrave;s aux services de tierces parties se terminera, sauf si vous d&eacute;cidez de payer l&rsquo;abonnement &agrave; ces services. Le fait d&rsquo;annuler votre forfait ou votre compte, ou encore de passer &agrave; un forfait inadmissible, entra&icirc;ne la fin de votre acc&egrave;s &agrave; ces services. Spotify Premium : Limite de trois abonnements &agrave; Spotify Premium pour usage personnel au sein d&rsquo;une m&ecirc;me famille pour toutes les marques de Rogers. Les utilisateurs ne seront pas admissibles &agrave; une offre similaire faite par une autre marque de Rogers apr&egrave;s avoir activ&eacute; leur abonnement dans le cadre de cette offre. Next Issue : Si vous &ecirc;tes un abonn&eacute; actuel, vous nous autorisez &agrave; associer votre compte Next Issue actuel &agrave; votre num&eacute;ro de sans-fil dans le cadre de cette offre. Consommation de donn&eacute;es : Environ 1 Mo par minute pour la lecture en continu de contenu audio, environ 1,4 Go par heure pour le visionnement en continu de vid&eacute;os (selon le r&eacute;glage par d&eacute;faut &laquo; Best &raquo; [Meilleur], sur un t&eacute;l&eacute;phone intelligent ou une tablette) et environ 250 Mo par magazine (varie selon la dur&eacute;e du contenu, la qualit&eacute; de lecture en continu, l&rsquo;appareil et d&rsquo;autres facteurs). L&rsquo;utilisation de donn&eacute;es sup&eacute;rieure au volume de donn&eacute;es compris dans votre forfait (utilisation exc&eacute;dentaire) est factur&eacute;e par tranches et arrondie au prochain Mo ou Go (selon les modalit&eacute;s de votre forfait). Les frais d&rsquo;itin&eacute;rance standard s&rsquo;appliquent &agrave; l&rsquo;ext&eacute;rieur du r&eacute;seau sans-fil de Rogers ou d&rsquo;une zone de Couverture &eacute;tendue au Canada.</p><p style=\"font-size: 16px;\">&plusmn;&#160;Les frais de temps d&rsquo;antenne additionnel, de transmission de donn&eacute;es, d&rsquo;interurbain, d&rsquo;itin&eacute;rance, les frais li&eacute;s aux options et les taxes sont en sus et factur&eacute;s mensuellement, le cas &eacute;ch&eacute;ant. Les frais gouvernementaux mensuels suivants pour le service d&rsquo;urgence 9 1 1 seront exig&eacute;s : 62 &cent; en Saskatchewan, 40 &cent; au Qu&eacute;bec, 43 &cent; en Nouvelle-&Eacute;cosse, 53 &cent; au Nouveau-Brunswick, 70 &cent; &agrave; l&rsquo;&Icirc;le-du-Prince-&Eacute;douard, 44 &cent; en Alberta et 75 &cent; &agrave; Terre-Neuve-et-Labrador. Cependant, le temps d&rsquo;antenne n&rsquo;est pas factur&eacute; pour les appels au 9 1 1 que vous faites &agrave; l&rsquo;aide de votre appareil sans fil de Rogers.</p><p style=\"font-size: 16px;\">Frais de r&eacute;cup&eacute;ration des &eacute;conomies r&eacute;alis&eacute;es sur l&rsquo;appareil (applicables uniquement aux services avec abonnement &agrave; dur&eacute;e d&eacute;termin&eacute;e). Des frais de r&eacute;cup&eacute;ration des &eacute;conomies r&eacute;alis&eacute;es sur l&rsquo;appareil (FR&Eacute;A) sont factur&eacute;s si vous avez obtenu un B&eacute;n&eacute;fice &eacute;conomique &agrave; la signature de votre nouvel abonnement et que, pour quelque raison que ce soit, votre service sans-fil ou votre nouvel abonnement est annul&eacute; avant la fin de votre Entente de service (P&eacute;riode d&rsquo;abonnement). Les FR&Eacute;A correspondent au B&eacute;n&eacute;fice &eacute;conomique multipli&eacute; par le nombre de mois restant &agrave; votre Entente de service divis&eacute; par le nombre total de mois compris dans votre Entente de service (taxes en sus). <b>En d&rsquo;autres mots : FR&Eacute;A = B&eacute;n&eacute;fice &eacute;conomique &times; nombre de mois restant &agrave; votre P&eacute;riode d&rsquo;abonnement &divide; nombre total de mois de votre P&eacute;riode d&rsquo;abonnement + taxes exigibles.</b></p><p style=\"font-size: 16px;\">Frais de d&eacute;classement de forfait. Si, pour quelque raison que ce soit, vous changez de forfait pour un forfait de niveau inf&eacute;rieur pendant votre p&eacute;riode d&rsquo;abonnement, vous devrez acquitter des frais uniques de d&eacute;classement de forfait, tel qu&rsquo;il est pr&eacute;vu dans votre entente de service.</p><ol style=\"margin-right: 6%;\"><li>Toute utilisation sup&eacute;rieure au volume de donn&eacute;es fourni est factur&eacute;e par tranches (voir les modalit&eacute;s d&rsquo;utilisation exc&eacute;dentaire associ&eacute;es &agrave; votre forfait), arrondie au prochain Mo ou Go (selon les modalit&eacute;s de votre forfait).</li><li>Appels effectu&eacute;s sur le r&eacute;seau de Rogers ou dans la zone de Couverture &eacute;tendue (exclut les appels achemin&eacute;s par Renvoi d&rsquo;appel, Appel vid&eacute;o ou tout autre service semblable). La couverture n&rsquo;est pas offerte dans toutes les r&eacute;gions. Les frais d&rsquo;interurbains internationaux, de message texte &agrave; ligne filaire et d&rsquo;itin&eacute;rance sont en sus. Seuls les num&eacute;ros canadiens &agrave; 10 chiffres sont admissibles (le num&eacute;ro de sans-fil du client, le num&eacute;ro d&rsquo;acc&egrave;s &agrave; la messagerie vocale et les num&eacute;ros sp&eacute;ciaux tels que 1 800 et 1 900 ne sont pas admissibles).</li><li>N&eacute;cessite un appareil compatible. Comprend un nombre illimit&eacute; de messages texte Extr&ecirc;me et de messages photo et vid&eacute;o envoy&eacute;s &agrave; partir du Canada vers un num&eacute;ro de sans-fil canadien ainsi qu&rsquo;un nombre illimit&eacute; de messages texte entrants, peu importe la provenance. Les messages texte entrants et sortants &agrave; tarification additionnelle (alertes, messages li&eacute;s au contenu et aux promotions), les messages texte internationaux sortants et les messages photo et vid&eacute;o entrants et sortants en itin&eacute;rance (s&rsquo;il y a lieu) ne sont pas compris et sont factur&eacute;s aux tarifs en vigueur.</li><li>L&rsquo;Affichage des appels vous permet de voir le num&eacute;ro de la personne qui vous appelle, m&ecirc;me si elle n&rsquo;est pas inscrite dans votre r&eacute;pertoire t&eacute;l&eacute;phonique. Appareil compatible requis, certains num&eacute;ros ne peuvent pas &ecirc;tre identifi&eacute;s.</li><li>Enregistre jusqu&rsquo;&agrave; trois messages d&rsquo;au plus trois minutes chacun. Les messages enregistr&eacute;s sont conserv&eacute;s pour un maximum de trois jours.</li><li>Toute minute de Renvoi d&rsquo;appel additionnelle est factur&eacute;e 0,10 $ la minute (arrondi &agrave; la minute compl&egrave;te suivante).</li><li>Comprend l&rsquo;abonnement pour la saison 2015-2016. Les frais courants d&rsquo;utilisation de donn&eacute;es suppl&eacute;mentaires et en itin&eacute;rance s&rsquo;appliquent. Obtenez un abonnement gratuit au laissez-passer de la saison 2015-2016 avec un forfait &Eacute;lanMC de Rogers (ou un ancien forfait comparable Fibre hybride 50 ou sup&eacute;rieur) ou un forfait sans-fil Partagez toutMC. Inscription &agrave; Mon RogersMC requise. Des interdictions de diffusion et d&rsquo;autres restrictions s&rsquo;appliquent en fonction de votre emplacement au moment du visionnement. D&rsquo;autres conditions s&rsquo;appliquent. Consultez rogers.com/modalites pour conna&icirc;tre toutes les modalit&eacute;s. L&rsquo;utilisation de donn&eacute;es est d&rsquo;environ 1 Go par match pour la lecture en continu sur un t&eacute;l&eacute;phone intelligent et d&rsquo;environ 2 &agrave; 5 Go par match pour le visionnement sur une tablette, un ordinateur, une console de jeu ou un t&eacute;l&eacute;viseur (varie selon la dur&eacute;e du match, la qualit&eacute; de la lecture en continu, l&rsquo;appareil et d&rsquo;autres facteurs). L&rsquo;utilisation de donn&eacute;es sup&eacute;rieure au volume de donn&eacute;es compris dans votre forfait (utilisation exc&eacute;dentaire) est factur&eacute;e par tranches et arrondie au Mo ou au Go suivant (selon les modalit&eacute;s de votre forfait). Les frais d&rsquo;itin&eacute;rance courants s&rsquo;appliquent lorsque vous &ecirc;tes &agrave; l&rsquo;ext&eacute;rieur du r&eacute;seau sans-fil de Rogers.</li><li>Taxes en sus. Les frais sont imput&eacute;s &agrave; l&rsquo;utilisation et peuvent &ecirc;tre modifi&eacute;s en tout temps sans pr&eacute;avis. Ce service est factur&eacute; par ligne (les frais s&rsquo;ajoutent aux frais de service mensuels de votre forfait Partagez tout) et s&rsquo;applique pendant 24 heures d&egrave;s votre premi&egrave;re utilisation de celui-ci dans un pays admissible. Des frais d&rsquo;itin&eacute;rance s&rsquo;appliquent lorsque vous &ecirc;tes &agrave; l&rsquo;ext&eacute;rieur des pays admissibles. Donn&eacute;es : L&rsquo;utilisation de donn&eacute;es sup&eacute;rieure au volume de donn&eacute;es compris dans votre forfait est factur&eacute;e par tranches et arrondie au Mo ou au Go suivant (selon les modalit&eacute;s de votre forfait). Messages texte : Comprend les messages texte envoy&eacute;s &agrave; un num&eacute;ro de sans-fil local dans un pays admissible ou &agrave; un num&eacute;ro de sans-fil au Canada. Les messages texte entrants et sortants &agrave; tarification additionnelle et les messages envoy&eacute;s &agrave; l&rsquo;&eacute;tranger, except&eacute; dans les pays admissibles, sont factur&eacute;s aux tarifs en vigueur. Appels : Comprend un nombre illimit&eacute; d&rsquo;appels &agrave; des num&eacute;ros locaux ou &agrave; des num&eacute;ros au Canada lorsque vous &ecirc;tes dans un pays admissible. Des tarifs interurbains internationaux s&rsquo;appliquent aux appels effectu&eacute;s vers d&rsquo;autres pays pendant que vous &ecirc;tes dans un pays admissible. Consultez rogers.com/modalites pour conna&icirc;tre les modalit&eacute;s et la liste des pays admissibles.</li><li>En s&rsquo;abonnant, le client accepte que les messages soient trait&eacute;s &agrave; l&rsquo;ext&eacute;rieur du Canada. Cette fonction est offerte pour tous les sans-fil, notamment les t&eacute;l&eacute;phones intelligents BlackBerry, Android et iPhone, par l&rsquo;entremise de la bo&icirc;te de r&eacute;ception de la messagerie texte. Non compatible avec l&rsquo;application Messagerie vocale visuelle pour iPhone, BlackBerry ou Android. Les clients qui pr&eacute;f&egrave;rent utiliser la Messagerie vocale visuelle doivent mettre en service une trousse pour iPhone.</li><li>S&rsquo;applique aux appels effectu&eacute;s &agrave; partir du Canada sur le r&eacute;seau sans-fil de Rogers ou dans une zone de Couverture &eacute;tendue vers les pays admissibles. Les tarifs varient selon que les appels sont achemin&eacute;s vers un num&eacute;ro filaire ou sans-fil. Les appels faits du Canada et achemin&eacute;s &agrave; l&rsquo;ext&eacute;rieur des pays admissibles associ&eacute;s &agrave; cette option sont factur&eacute;s aux tarifs en vigueur. Les appels effectu&eacute;s vers un num&eacute;ro de sans-fil sont factur&eacute;s &agrave; la seconde (minimum de 30 secondes). Les frais courants de temps d&rsquo;antenne s&rsquo;appliquent aux appels achemin&eacute;s vers un num&eacute;ro filaire ou sans-fil. Les frais d&rsquo;interurbain sont arrondis &agrave; la minute compl&egrave;te suivante.</li><li>S&rsquo;applique aux appels effectu&eacute;s &agrave; partir du Canada par l&rsquo;interm&eacute;diaire du r&eacute;seau sans-fil de Rogers vers les pays admissibles. Les tarifs varient selon que les appels sont achemin&eacute;s vers un num&eacute;ro filaire ou sans-fil. Les appels faits du Canada et achemin&eacute;s &agrave; l&rsquo;ext&eacute;rieur des pays admissibles associ&eacute;s &agrave; cette option sont factur&eacute;s aux tarifs en vigueur. Les appels effectu&eacute;s vers un num&eacute;ro de sans-fil sont factur&eacute;s &agrave; la seconde (minimum de 30 secondes). Les frais courants de temps d&rsquo;antenne s&rsquo;appliquent aux appels achemin&eacute;s vers un num&eacute;ro filaire ou sans-fil. Les frais d&rsquo;interurbain sont arrondis &agrave; la minute compl&egrave;te suivante.</li><li>Comprend les messages texte envoy&eacute;s &agrave; partir du Canada, &agrave; destination des &Eacute;tats-Unis et d&rsquo;autres pays. Les messages texte, photo et vid&eacute;o envoy&eacute;s en itin&eacute;rance ne sont pas compris et sont factur&eacute;s aux tarifs d&rsquo;itin&eacute;rance applicables.</li><li>Appels locaux seulement, à l’exception des appels faits par Renvoi d’appel, Appel vidéo ou services similaires. Soirs : de 18 h à 7 h, du lundi au vendredi; week-ends : du vendredi 18 h au lundi 7 h. Les appels effectués en dehors de ces heures sont facturés aux tarifs en vigueur ou déduits des minutes comprises dans le forfait (selon le cas).</li><li>Appels illimit&eacute;s partout au Canada apr&egrave;s 18 h sur le r&eacute;seau de Rogers (&agrave; l&rsquo;exception des appels effectu&eacute;s par Renvoi d&rsquo;appel, Appel vid&eacute;o ou services semblables). Les frais d&rsquo;interurbains internationaux et d&rsquo;itin&eacute;rance sont en sus.</li><li>Enregistre jusqu&apos;&agrave; 35 messages d&apos;au plus cinq minutes chacun. Les messages enregistr&eacute;s sont conserv&eacute;s pour un maximum de dix jours.</li><li>Les appels locaux illimit&eacute;s (ou les appels illimit&eacute;s &agrave; l&rsquo;&eacute;chelle de la province du Qu&eacute;bec) sur le r&eacute;seau de Rogers ou dans une zone de Couverture &eacute;tendue, excluant le Renvoi d&apos;appel, l&apos;Appel vid&eacute;o ou des services semblables. La couverture n&rsquo;est pas offerte dans toutes les r&eacute;gions. Les frais d&rsquo;interurbain sont en sus.</li></ol><p></p></div></section>");
$templateCache.put("views/modals/ppc-modal-template.html","<section class=\"module-ppc-modal\"><img class=\"close-icon\" src=\"images/close-icon.png\" ng-click=\"cancel()\"><h2>{{title}}</h2><p data-ng-bind-html=\"message\"></p><div class=\"contact row\" ng-show=\"showLiveChat\"><div class=\"col-xs-12 col-sm-6\"><bold-chat-static-button ng-if=\"lang === \'en\'\" data-cbid=\"{{boldChat.wlssPpc.en.cbid}}\" data-dynamic-div=\"{{boldChat.wlssPpc.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.wlssPpc.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"lang === \'fr\'\" data-cbid=\"{{boldChat.wlssPpc.fr.cbid}}\" data-dynamic-div=\"{{boldChat.wlssPpc.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.wlssPpc.fr.chatButtonClass}}\"></bold-chat-static-button></div><div class=\"col-xs-12 col-sm-6\"><img class=\"phone-icon\" src=\"images/phone-red-icon.png\"><span class=\"ng-scope\" ng-if=\"!isSuspendedAccount\" res=\"800_number\">1 866 727-2141</span></div></div><div class=\"ppc-button-ctn\"><a data-ng-show=\"showCancelBtn\" class=\"cancel-button blue\" ng-click=\"cancel()\" res=\"CANCEL\"></a> <a data-ng-show=\"showOKBtn\" class=\"modal-button\" ng-click=\"ok()\">OK</a> <a data-ng-show=\"showConfirmBtn\" class=\"modal-button\" ng-click=\"confirm()\" res=\"CONFIRM\"></a> <a data-ng-show=\"showConfirmPlanChangeBtn\" class=\"modal-button\" ng-click=\"confirm()\" res=\"CONFIRM_PLAN_CHANGE\"></a> <a data-ng-show=\"showContinueBtn\" class=\"modal-button\" ng-click=\"continue()\" res=\"_continue\"></a> <a data-ng-show=\"showRemoveAddOnBtn\" class=\"modal-button\" ng-click=\"removeAddOn()\" res=\"ppc_remove_addon\"></a> <a data-ng-show=\"showGoBackBtn\" class=\"modal-button\" ng-click=\"goBack()\" res=\"GO_BACK\"></a></div></section>");
$templateCache.put("views/modals/ppc-not-eligible.html","<div class=\"totes-project\"><div class=\"modal-body mlm mrm\"><div class=\"dialog\"><div class=\"row mbm\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"onContinue()\"><span aria-hidden=\"true\">&times;</span></button><h4><span res=\"ppc_not_eligible_title\">ppc_not_eligible_title</span></h4><div class=\"pbm\" ng-bind-html=\"model.desc\"></div><div class=\"contact\"><p><a data-ng-href=\"{{chatHref}}\" target=\"_blank\"><img class=\"live-chat-icon\" src=\"images/live-chat-red-icon.png\"> <span res=\"_live_chat\"></span></a></p><p><img class=\"phone-icon\" src=\"images/phone-red-icon.png\"> <span res=\"800_number\"></span></p></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"text-center\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"onContinue()\"><span res=\"_continue\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/prepaidModal.html","<div class=\"totes-project prepaid-modal\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\" ng-hide=\"actionOtherThanTopUp\"><span res=\"top_up_now\"></span></h4><h4 class=\"link-account-title\" ng-show=\"actionOtherThanTopUp\"><span res=\"make_account_changes\"></span></h4><div class=\"prepaid-body-section\"><div ng-hide=\"actionOtherThanTopUp\"><span res=\"top_up_now_body\"></span></div><div ng-show=\"actionOtherThanTopUp\"><span res=\"make_account_changes_body\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"close()\"><span res=\"close\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/profileModalCtrl.html","<div class=\"totes-project directive-profile-modal\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span res=\"submenu_profile\"></span></h4><div class=\"\"><span res=\"profile_popup_body_title\"></span></div><div class=\"body-section\"><div class=\"small-heading\"><span res=\"if_the_customer_has_a_wireless_product\"></span></div><div><span res=\"you_will_need_to_go_to_v21_or_ssp\"></span></div><div class=\"small-heading\"><span res=\"if_the_customer_has_only_residential_products\"></span></div><div><span res=\"you_will_need_to_go_to_sgi\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"close()\"><span res=\"close\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/proratedchangesexplanation.html","<section class=\"module-ppc-modal\"><div class=\"prorated\"><img class=\"close-icon\" src=\"images/close-icon.png\" ng-click=\"cancel()\"><h2 res=\"ppc_proration_details\">res</h2><time-line percent-passed=\"{{percentPassed}}\"></time-line><div class=\"timeline-arrow-bar\"><div class=\"arrow arrow-1\"></div><div class=\"arrow arrow-2\" ng-style=\"{\'left\': percentPassed * 2.17 + \'px\' }\"></div><div class=\"arrow arrow-3\"></div></div><div class=\"timeline-bar\"><span class=\"bill-date bill-date-1\">{{lastBillDate | date: \'MMM dd\'}}</span> <span class=\"bill-date bill-date-2\" ng-style=\"{\'left\': (percentPassed * 2 + 16) + \'px\' }\">{{currentDate | date: \'MMM dd\'}}</span> <span class=\"bill-date bill-date-3\">{{nextBillDate | date: \'MMM dd\'}}</span></div><div class=\"explanation-section\"><span class=\"circle circle-gray\">1</span><h2 res=\"ppc_proration_col1_header\">res</h2><p><span class=\"prorated-explanation\" res=\"ppc_proration_col1_text\">res</span></p></div><div class=\"explanation-section\"><span class=\"circle circle-blue\">2</span><h2><span res=\"ppc_proration_col2_header\">res</span></h2><p><span class=\"prorated-explanation\" res=\"ppc_proration_col2_text\" res-param-changedate=\"{{changePlanDate}}\" res-param-nextbilldate=\"{{ nextBillFormattedDate }}\" res-param-days=\"{{ diffBillDate }}\">res</span></p></div><div class=\"explanation-section\"><span class=\"circle circle-red\">3</span><h2 res=\"ppc_proration_col3_header\">res</h2><p><span class=\"prorated-explanation\" res=\"ppc_proration_col3_text\">res</span></p></div></div></section>");
$templateCache.put("views/modals/reserveDevice.html","<div class=\"totes-project\"><section class=\"module-wireless-device-reserve-modal\"><img class=\"close-icon\" ng-click=\"cancel()\" src=\"images/close-icon.png\"> <span class=\"rui-icon-warning warning-color\"></span><br><br><span class=\"warning-txt\" res=\"wireless_device_reservation_warning\"></span><br><a class=\"cta-round primary medium btn-not-activate\" ng-click=\"cancel()\" res=\"_cancel\"></a> <a class=\"cta-round primary medium btn-activate\" ng-click=\"ok()\" res=\"wireless_ok\"></a></section></div>");
$templateCache.put("views/modals/roamEnrollModal.html","<div class=\"totes-project roam-enroll-modal\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span res=\"roam_like_home_pop_up_title\"></span></h4><div class=\"prepaid-body-section\"><div><span res=\"roam_like_home_pop_up_message\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"close()\"><span res=\"close\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/sohoEmailConfirmationPopup.html","<div class=\"confirmation-popup\" ng-if=\"autoRegSuccess\"><button type=\"button\" class=\"close-popup\" data-ng-click=\"closeConfirmationPopup()\">&times;</button><div class=\"confirmation-popup-header\" res=\"confirmation_modal_title\" data-ng-if=\"autoRegSuccess\"></div><div class=\"confirmation-popup-body\" data-ng-if=\"autoRegSuccess\"><span res=\"confirmation_modal_msg_1\"></span> <strong data-ng-bind=\"selectedEmailForAutoReg\"></strong> <span res=\"confirmation_modal_msg_2\"></span><div ng-if=\"apiCount === 4\" res=\"retrigger_msg_attempt_4\"></div><div ng-if=\"apiCount === 5\" res=\"retrigger_msg_attempt_5\"></div></div><div class=\"confirmation-popup-button\"><span><a class=\"confirm-btn\" data-ng-click=\"closeConfirmationPopup()\" res=\"confirm_btn\"></a></span></div></div><div class=\"totes-project\"><div class=\"autoReg_error_popup\" ng-if=\"!autoRegSuccess\"><img class=\"close-icon\" data-ng-click=\"closeConfirmationPopup()\" src=\"images/close-icon.png\"><div class=\"soho-error-heading\"><img class=\"err-img\" src=\"images/error-exclamation.png\"> <span class=\"error-title h2\" res=\"error_heading\"></span></div><div class=\"soho-error-body\"><div class=\"soho-error-description\" res=\"general_error\"></div></div></div></div>");
$templateCache.put("views/modals/sohoMigrationPopup.html","<div class=\"soho-migration-popup\"><button type=\"button\" class=\"close-popup\" ng-click=\"closeSohoMigrationPopup()\">&times;</button><div ng-if=\"migrationEligibleKey == \'S\'\" class=\"soho-migration-popup-header\" res=\"soho_migration_popup_heading1\"></div><div ng-if=\"migrationEligibleKey == \'M\'\" class=\"soho-migration-popup-header\" res=\"soho_migration_popup_heading2\"></div><div ng-if=\"migrationEligibleKey == \'C\'\" class=\"soho-migration-popup-header\" res=\"soho_migration_popup_heading3\"></div><div ng-if=\"migrationEligibleKey == \'B\'\" class=\"soho-migration-popup-header\" res=\"soho_migration_popup_heading4\"></div><div class=\"soho-migration-popup-body\"><div ng-if=\"migrationEligibleKey == \'S\'\" res=\"migration_eligibile_content1\"></div><div ng-if=\"migrationEligibleKey == \'M\'\" res=\"migration_eligibile_content2\"></div><div ng-if=\"migrationEligibleKey == \'C\'\" res=\"migration_eligibile_content3\"></div><div ng-if=\"migrationEligibleKey == \'B\'\" res=\"migration_eligibile_content4\"></div></div><div class=\"soho-migration-popup-button\"><span><a class=\"faq-button\" href=\"{{faqURL}}\" res=\"_FAQ\" target=\"_blank\"></a></span> <span><label class=\"doNotShow-check\"><input type=\"checkbox\" ng-model=\"soho.isChecked\"> <span class=\"checkmark\"></span></label> <span res=\"do_not_show_message\" ng-class=\"soho.isChecked ? \'donot-show-msg\' : \'donot-show-msg-before\'\"></span></span></div></div>");
$templateCache.put("views/modals/switchBTFailure.html","<div class=\"modal-container\"><div class=\"modal-header\"><h3><b res=\"switch_failure\"></b></h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\" style=\"margin-top:15px;\"><div class=\"col-xs-12 col-sm-offset-2 col-sm-6\"><bold-chat-static-button ng-if=\"lang === \'en\'\" data-cbid=\"{{boldChat.olbLiveChat.en.cbid}}\" data-dynamic-div=\"{{boldChat.olbLiveChat.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.olbLiveChat.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"lang === \'fr\'\" data-cbid=\"{{boldChat.olbLiveChat.fr.cbid}}\" data-dynamic-div=\"{{boldChat.olbLiveChat.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.olbLiveChat.fr.chatButtonClass}}\"></bold-chat-static-button></div><div class=\"col-xs-12 col-sm-3 cancel\" ng-click=\"cancel()\"><span res=\"switch_cancel\"></span></div></div></div></div></div>");
$templateCache.put("views/modals/switchBTSuccess.html","<div class=\"modal-container\"><div class=\"modal-header\"><h3><b res=\"switch_success\"></b></h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\" style=\"margin-top:15px;\"><button type=\"button\" class=\"button-default col-xs-6 col-sm-3\" ng-click=\"ok()\"><span res=\"switch_success_btn\"></span></button></div></div></div></div>");
$templateCache.put("views/modals/switchBillType.html","<div class=\"modal-container\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\"><span aria-hidden=\"true\">X</span></button><h3><b res=\"switch_bill_type_title\"></b></h3></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"modal-body-message\"><p><span res=\"switch_bill_type_content\"></span> <a ng-click=\"updateUserEmail()\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"updateUsername\"><span res=\"click_here\"></span></a>.</p><p style=\"font-weight: bold;\"><span ng-if=\"ban.length == 12 || ban.length == 10\">{{cableEmail}}</span> <span ng-if=\"ban.length != 12 && ban.length != 10\">{{profileData}}</span></p></div></div></div><div class=\"row\"><div class=\"col-xs-12\" style=\"margin-top:15px;\"><button type=\"button\" class=\"button-default cta-round primary large col-xs-6 col-sm-6\" ng-click=\"switchBillType()\"><span res=\"switch_button\"></span></button><div class=\"col-xs-6 col-sm-3 cancel\" ng-click=\"cancel()\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"switchBillCancel\"><span res=\"switch_cancel\"></span></div><div class=\"widget-loader\" ng-show=\"switchBillLoader\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div></div></div>");
$templateCache.put("views/modals/thankYouModalCtrl.html","<div class=\"totes-project\"><div class=\"container-fluid modal-body\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\"><span aria-hidden=\"true\">&times;</span></button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 res=\"modal_thank_you_registration_headline\"></h1></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><hr></div></div><div class=\"row visible-xs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><center><img src=\"images/rogers_tiny_logo.gif\" alt=\"Rogers logo\"></center></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><center><h4 res=\"modal_thank_you_registration_join\"></h4></center></div></div><div class=\"row hidden-xs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"setCenter\"><img src=\"images/rogers_tiny_logo.gif\" alt=\"Rogers logo\"><h4 res=\"modal_thank_you_registration_join\"></h4></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><p res=\"modal_thank_you_registration_info\"></p></div></div><div class=\"row hidden-xs\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"pull-right\"><a type=\"button\" class=\"title-h5 bold pointer uppercase\" ng-click=\"cancel()\" res=\"modal_thank_you_registration_later\"></a></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"pull-left\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\" res=\"modal_thank_you_registration_community\"></button></div></div></div><div class=\"row visible-xs\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><center><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\" res=\"modal_thank_you_registration_community\"></button></center></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><center><a type=\"button\" class=\"title-h5 bold pointer uppercase\" ng-click=\"cancel()\" res=\"modal_thank_you_registration_later\"></a></center></div></div></div></div>");
$templateCache.put("views/modals/underConstruction.html","<div class=\"totes-project\"><section class=\"wireless-plan\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"ok()\"><span aria-hidden=\"true\">&times;</span></button><h2 class=\"widget-loader-mod pushDn\" res=\"_under_construction\"></h2></div><div class=\"row mbs\"></div><div class=\"row\"><button type=\"button\" class=\"cta-round primary medium pull-right mtm mbm\" ng-click=\"ok()\"><span res=\"internet_usage_close\"></span></button></div></div></div></section></div>");
$templateCache.put("views/modals/update-billing-type.html","<div class=\"verify-address totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"images/close-icon.png\"><div ng-show=\"data.billingType == \'INVOICE\'\"><h3 class=\"address-heading\" res=\"paper_bill_title\"></h3><p class=\"subheading\" res=\"paper_bill_success_1\"></p><p class=\"subheading\" res=\"paper_bill_success_2\"></p></div><div ng-show=\"data.billingType == \'E_BILL\'\"><h3 class=\"address-heading\" res=\"online_bill_title\"></h3><p class=\"subheading\" res=\"online_bill_success_1\"></p><p class=\"subheading\" res=\"online_bill_success_2\"></p></div></div>");
$templateCache.put("views/modals/verify-billing-address.html","<div class=\"verify-address totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"images/close-icon.png\"><h3 class=\"address-heading\" res=\"mailing_address\">Mailing Address</h3><p class=\"subheading billing-address\">&nbsp;</p><div class=\"canada-post-address\"><h3 res=\"_as_per_canada_post\">As per Canada Post</h3><p>{{data.canadaPostAddress}}</p><button class=\"submit-address cta-round primary large\" ng-click=\"submitCanadaPostAddress()\" res=\"_submit_canada_post_address\">submit canada post address</button></div><div class=\"gray-border-selfserve\"></div><div class=\"as-entered-address\"><h3 res=\"_as_entered\">As entered</h3><p>{{data.address}}</p><div class=\"button-container\"><button class=\"cancel-button cta-round tertiary large\" ng-click=\"close()\" res=\"_cancel\">cancel</button> <button class=\"submit-address cta-round primary large\" ng-click=\"submit()\" res=\"_submit_address_as_entered\">submit address as entered</button></div><div class=\"clear-fix\"></div></div></div>");
$templateCache.put("views/modals/wirelessRemovePlan.html","<div class=\"totes-project\"><section class=\"wireless-plan\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"ok()\"><span aria-hidden=\"true\">&times;</span></button><h2 class=\"widget-loader-mod pushDn\" res=\"wireless_popup_title\"></h2></div><div class=\"row mbs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div res=\"wireless_popup_title_2\"></div></div></div><div class=\"row mtm\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><img src=\"images/chatBlack.png\" class=\"mtm plm\"></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><bold-chat-static-button ng-if=\"lng === \'en\'\" data-cbid=\"{{boldChat.wlssPpc.en.cbid}}\" data-dynamic-div=\"{{boldChat.wlssPpc.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.wlssPpc.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"lng === \'fr\'\" data-cbid=\"{{boldChat.wlssPpc.fr.cbid}}\" data-dynamic-div=\"{{boldChat.wlssPpc.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.wlssPpc.fr.chatButtonClass}}\"></bold-chat-static-button><div res=\"wireless_popup_line1\"></div><div res=\"wireless_popup_line2\"></div></div></div><div class=\"row mts\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><img src=\"images/phoneBlack.png\" class=\"mtm plm\"></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div res=\"wireless_popup_phone\" class=\"mtl pts\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div res=\"wireless_popup_not_sure\" class=\"mtm\"></div><a class=\"title-h5\" ng-href=\"{{viewAllPlanslink}}\" target=\"_blank\"><span res=\"wireless_popup_all_plans\" class=\"bold\"></span></a></div></div><div class=\"row\"><button type=\"button\" class=\"cta-round primary medium pull-right mtm mbm\" ng-click=\"ok()\"><span res=\"internet_usage_close\"></span></button></div></div></div></section></div>");
$templateCache.put("views/modals/wirelessTravelPackage.html","<div class=\"totes-project\"><section class=\"module-wireless-travel-package-modal\"><img class=\"close-icon\" ng-click=\"cancel()\" src=\"images/close-icon.png\"><h1 class=\"modal-title\" res=\"activating_roam_like_home\"></h1><div ng-hide=\"errorMessage\"><span class=\"roaming-price-txt\" res=\"go_ahead_roam_on\"></span><p><span class=\"roaming-price-txt\" res=\"while_you_are_travelling\"></span></p><span class=\"roaming-price-txt\" res=\"remember_you_will_need_to_enroll\"></span> <span class=\"are-you-sure-txt\" res=\"are_you_sure_activate_roam\"></span> <a class=\"cta-round primary medium btn-not-activate\" ng-click=\"cancel()\" res=\"no_dont_activate\"></a> <a class=\"cta-round primary medium btn-activate\" ng-click=\"getPlan()\" res=\"yes_activate\"></a></div><div ng-show=\"errorMessage\"><span class=\"roaming-price-txt\" res=\"travel_package_fail_msg\"></span></div></section></div>");
$templateCache.put("views/modals/wirelessTravelPackageLegal.html","<div class=\"totes-project\"><section class=\"module-wireless-travel-package-modal\"><img class=\"close-icon\" ng-click=\"cancel()\" src=\"images/close-icon.png\"><div class=\"legal-content\" ng-bind-html=\"wirelessTravelPackageLegalContent\"></div></section></div>");
$templateCache.put("views/selfServe/selfServe.html","<div class=\"self-serve\"><break-point></break-point><div class=\"row hidden-xs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"profile\">profile</span></h1></div></div></div></div><div class=\"row header-row hidden-sm hidden-md hidden-lg\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"profile\">profile</span></h1></div></div></div></div><div class=\"container\"><editable-content editabletemplateurl=\"scripts/directives/editableContent/userAccount/usernameandpassword.html\" formtemplate=\"scripts/directives/editableContent/userAccount/usernameandpasswordform.html\" formdata=\"userInfo\" formheading=\"CredentialsHeading\" whiteout=\"true\" skin=\"rogers-content-margin\" load-login-security-questions=\"true\" on-submit=\"updateAccountInfo(updates, defer, form)\"></editable-content></div><div class=\"row hidden-xs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"account\">account</span></h1></div></div></div></div><div class=\"row header-row hidden-sm hidden-md hidden-lg\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"account\">account</span></h1></div></div></div></div><div class=\"container\"><div class=\"editable-content row rogers-content-margin\" ng-show=\"accountsFailed\"><div class=\"row info-banner error mts mbm\" data-ng-show=\"accountsFailed\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><span res=\"general_error\"></span></div></div></div><div ng-show=\"accountsFailed === false\"><div class=\"clear-fix\"></div><div ng-if=\"assosciatedAccountsExist\"><div class=\"row info-banner error mts mbm\" style=\"margin-left: 0px;\" data-ng-show=\"generalError\"><div ng-if=\"generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 general-error\" style=\"float:left\"><span res=\"general_error\"></span></div></div><div class=\"row account-select\"><div class=\"account-container\" style=\"margin-bottom: 15px !important;\"><div><span ng-show=\"loading\"><img class=\"widget-loader\" src=\"images/widget-loader.gif\"></span><div ng-show=\"!loading\" class=\"name\"><span ng-show=\"selectedAccount.nickname\">{{selectedAccount.nickname}}</span> <span ng-show=\"!selectedAccount.nickname\" res=\"_account_#\"></span></div><div class=\"select-drop-down\" ng-if=\"accounts.length === 1\">{{accounts[0].accountNumber}}</div><div rui-dropdown=\"\" class=\"rui-dropdown profile-select-dropdown\" list=\"accounts\" selected=\"selectedAccount\" property=\"accountNumber\" select-action=\"selectedAccountChanged(item)\" ng-if=\"accounts.length > 1\" ng-disabled=\"iscollapsed || isEditOpen()\"></div><div class=\"small-view-wrapper\" ng-click=\"!isEditOpen() && (iscollapsed = !iscollapsed);addRemoveAccTag()\" ng-class=\"{\'small-view-wrapper-enabled\': !isEditOpen()}\"><span class=\"add-remove-account-label\" ng-class=\"{\'add-remove-account-label-bottom\': !iscollapsed}\" res=\"_add_remove_accounts\">ADD/REMOVE ACCOUNTS</span> <img ng-show=\"iscollapsed\" src=\"images/arrow-up.png\" class=\"arrow\" ng-class=\"{\'arrow-enabled\': !isEditOpen()}\"> <img ng-hide=\"iscollapsed\" src=\"images/arrow.png\" class=\"arrow\" ng-class=\"{\'arrow-enabled\': !isEditOpen()}\"></div></div><div class=\"subaccount-container\" ng-show=\"iscollapsed\" style=\"padding-top: 20px !important;\"><ul class=\"subaccount-list\"><li class=\"subaccount-list-item\" ng-repeat=\"account in accounts\" ng-class=\"{last: $last}\"><span ng-show=\"account.nickname\" class=\"sub-account-name\">{{account.nickname}}</span><div class=\"small-view-wrapper-account-number\"><span class=\"account-number-label\" res=\"_account_#\">Account #</span><span class=\"sub-account-number\">{{account.accountNumber}}</span></div><div class=\"remove-button-container\"><img src=\"images/blue-trash-can.png\"><span class=\"remove-account-button\" res=\"_remove_account\" ng-click=\"disassociateAccount(account)\">Remove Account</span></div></li></ul><div class=\"add-account-section\"><p class=\"hidden-xs hidden-sm\" res=\"_want_add_account\">Want to add an account? Click Add account to link another</p><div class=\"add-account-container\"><img src=\"images/add-user.png\"> <span res=\"add_account\" ng-click=\"addAccount()\" atm=\"’MyRogers_Profile_Account_Addaccount’\">Add Account</span></div></div></div></div></div><div data-ng-hide=\"BillingAddress.noBillingAddress || prepaidAccount\"><editable-content editabletemplateurl=\"scripts/directives/editableContent/billingInformation/billinginformation.html\" formtemplate=\"scripts/directives/editableContent/billingInformation/billinginformationform.html\" formdata=\"BillingAddress\" formheading=\"BillingAddressHeading\" whiteout=\"true\" skin=\"billing-margin\" billingupdate=\"true\" on-billingtypeupdate=\"updateBillingType(updates, defer)\" on-submit=\"updateBillingAddress(updates, defer, form)\"></editable-content><div class=\"gray-border-selfserve no-margin-top\"></div></div><div ng-hide=\"prepaidAccount\"><editable-content editabletemplateurl=\"scripts/directives/editableContent/contactInformation/contactinformation.html\" formtemplate=\"scripts/directives/editableContent/contactInformation/contactinformationform.html\" formdata=\"ContactInformation\" formheading=\"ContactInformationHeading\" controller=\"contactInformationCtrl(scope)\" whiteout=\"true\" skin=\"rogers-content-margin\" emailupdate=\"true\" on-emailupdate=\"updateEmailAddress(updates, defer, form)\" on-submit=\"updateContactInformation(updates, defer, form)\"></editable-content><div ng-if=\"MarketingPermissions\" class=\"gray-border-selfserve no-margin-top\"></div></div><editable-content ng-hide=\"hideMarketingPermissionsSection || true\" marketingpermissions=\"true\" editabletemplateurl=\"scripts/directives/editableContent/marketingPermission/marketinginformation.html\" formtemplate=\"scripts/directives/editableContent/marketingPermission/marketinginformationform.html\" formdata=\"MarketingPermissions\" formheading=\"marketingPermissionsHeading\" on-submit=\"updateMarketingInformation(updates, defer)\" whiteout=\"true\" closeonresize=\"true\" skin=\"marketing-information-skin hidden-xs hidden-sm\"></editable-content><editable-content ng-hide=\"hideMarketingPermissionsSection || true\" marketingpermissions=\"true\" editabletemplateurl=\"scripts/directives/editableContent/marketingPermission/marketingPermissionsSmall.html\" formtemplate=\"scripts/directives/editableContent/marketingPermission/marketingPermissionsSmallForm.html\" formdata=\"MarketingPermissions\" formheading=\"marketingPermissionsHeading\" on-submit=\"updateMarketingInformation(updates, defer)\" whiteout=\"true\" skin=\"marketing-information-skin hide-heading-container\"></editable-content></div><div class=\"no-linked-accounts\" ng-if=\"!assosciatedAccountsExist\"><p res=\"_want_add_account\">Want to add an account?</p><div class=\"add-account-container\"><img src=\"images/blue-user-icon.png\"> <span res=\"add_account\">Add Account</span></div></div></div></div></div>");
$templateCache.put("views/uteInternetUsage/_dailyUsageTable.html","<table ng-table=\"tableParams\" class=\"table ute-table table-centred internet-usage-table\"><tr ng-repeat=\"usage in $data track by $index\"><td data-title=\"\'ute_label_Date\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_Date\"></ins></span> {{usage.date | date:\'MMM d, yyyy\'}}</td><td data-title=\"\'ute_label_DownloadUsage\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_DownloadUsage\"></ins></span> {{usage.download}}</td><td data-title=\"\'ute_label_UploadUsage\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_UploadUsage\"></ins></span> {{usage.upload}}</td><td data-title=\"\'ute_label_DailyTotal\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_DailyTotal\"></ins></span> {{usage.total}}</td></tr><tfoot class=\"ute-table-foot\"><tr><th><ins res=\"ute_label_TotalUsage\"></ins>(<ins res=\"ute_unit_MB\"></ins>)</th><th>{{footerData.download | number : 0}}</th><th>{{footerData.upload | number : 0}}</th><th>{{footerData.download + footerData.upload | number : 0}}</th></tr><tr><th><ins res=\"ute_label_TotalUsage\"></ins>(<ins res=\"ute_unit_GB\"></ins>)</th><th>{{footerData.download / 1024 | number: 0}}</th><th>{{footerData.upload / 1024 | number: 0}}</th><th>{{ (footerData.download + footerData.upload) / 1024 | number: 0}}</th></tr></tfoot></table>");
$templateCache.put("views/uteInternetUsage/_monthlyUsageTable.html","<table ng-table=\"tableParams\" class=\"table ute-table table-centred internet-usage-table\"><tr ng-repeat=\"usage in $data track by $index\"><td data-title=\"\'ute_label_BillingPeriod\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_BillingPeriod\"></ins></span>{{usage.billingPeriod}}</td><td data-title=\"\'ute_label_TotalUsed\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_TotalUsed\"></ins></span>{{usage.total}}</td><td data-title=\"\'ute_label_UsageIncluded\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_UsageIncluded\"></ins></span>{{(usage.included==9999999)?\'Unlimited\':usage.included}}</td><td data-title=\"\'ute_label_AdditionalDataUsed\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_AdditionalDataUsed\"></ins></span>{{usage.overusage}}</td><td data-title=\"\'ute_label_OverageCharges\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_UsageIncluded\"></ins></span>{{usage.overageCharge | currency}}</td></tr><tfoot class=\"ute-table-foot\"><tr><th><span class=\"mobile-table-title\"><ins res=\"ute_label_BillingPeriod\"></ins></span><span><ins res=\"ute_label_AverageMonthlyUsage\"></ins></span> ({{footerData.unit}})</th><th><span class=\"mobile-table-title\"><ins res=\"ute_label_TotalUsed\"></ins></span>{{footerData.total | number:2}}</th><th><span class=\"mobile-table-title\"><ins res=\"ute_label_UsageIncluded\"></ins></span>{{(footerData.included==9999999)?\'Unlimited\':(footerData.included | number:2)}}</th><th><span class=\"mobile-table-title\"><ins res=\"ute_label_AdditionalDataUsed\"></ins></span>{{footerData.additional | number:2}}</th><th><span class=\"mobile-table-title\"><ins res=\"ute_label_OverageCharges\"></ins></span>{{footerData.overageCharge | number:2 | currency}}</th></tr></tfoot></table>");
$templateCache.put("views/uteInternetUsage/_usageNotificationTable.html","<table ng-table=\"tableParams\" class=\"table ute-table table-centred internet-usage-table\"><tr ng-repeat=\"usage in $data track by $index\" class=\"internet-usage-{{usage.limit}}\"><td header-class=\"font-medium\" data-title=\"\'ute_label_DateNotified\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_DateNotified\"></ins></span> <span>{{usage.date}}</span></td><td header-class=\"font-medium\" data-title=\"\'ute_label_NotificationType\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_NotificationType\"></ins></span><ins res=\"ute_label_UsageAt\"></ins>{{usage.limit}}<ins res=\"ute_label_OfDataLimit\"></ins></td><td header-class=\"font-medium\" data-title=\"\'ute_label_ActionTaken\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_ActionTaken\"></ins></span><ins res=\"ute_eventCode_{{usage.actionTaken}}\"></ins><span ng-if=\"usage.actionTaken !== \'112\'\">{{usage.actionTaken}}<ins res=\"ute_label_OfLimitNotification\"></ins></span></td><td header-class=\"font-medium\" data-title=\"\'ute_label_DateActionTaken\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_DateActionTaken\"></ins></span> {{usage.dateActionTaken | amDateFormat:\' MMMM D, YYYY h:mm A z\'}}</td></tr></table>");
$templateCache.put("views/uteInternetUsage/uteInternetUsage.html","<div class=\"ute-internet-usage-nav col-xs-12\" ng-controller=\"uteInternetUsageNavCtrl\"><tabset class=\"tab-container ute-tabs-primary fido-tabs\" justified=\"true\"><tab class=\"tab\" ng-repeat=\"tab in tabConfig\" active=\"tab.active\" ng-click=\"navigate(tab.route)\"><tab-heading><b><span class=\"text-uppercase heading\" res=\"{{tab.heading}}\"></span></b><br><span class=\"text-uppercase sub-heading hidden-xs\" res=\"{{tab.subHeading}}\"></span></tab-heading></tab></tabset></div><div class=\"col-xs-12\"><ui-view></ui-view></div>");
$templateCache.put("views/uteInternetUsage/uteInternetUsageDaily.html","<div class=\"ute-internet-usage ute-internet-usage-daily\" ng-controller=\"uteInternetUsageDailyCtrl\"><div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"ute-select-container\"><select class=\"ute-input-select\" ng-model=\"slctMonth\" ng-change=\"billingCycleChanged()\"><option ng-repeat=\"billingCycle in usageSummary.billingCycle\" value=\"{{billingCycle.monthlyInd}}\">{{billingCycle.startDate | date:\'MMM dd, yyyy\'}} - {{billingCycle.endDate | date:\'MMM dd, yyyy\'}}</option></select></div><div class=\"spacer-10\"></div><p class=\"copy-4\"><span res=\"ute_label_last_update\"></span>:&nbsp;{{usageSummary.lastUpdated | amDateFormat:\'MMM Do, YYYY\'}}</p></div><div class=\"col-sm-1\"><div class=\"spacer-10\"></div><a ng-click=\"ruiMethods.printDiv(\'printable\');\"><i class=\"ute-icon-print ute-xl link\"></i></a></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"usage-meter\" ng-if=\"usageSummary\" ng-class=\"{\'unlimited\':usageSummary.included > 99999}\"><div percentage=\"{{::usageSummary.usageMeter}}\" class=\"c100 big center\"><span><ul><li><span>{{::usageSummary.included}}<ins res=\"ute_unit_GB\"></ins></span>/<ins res=\"ute_unit_Month\"></ins></li><li><span>{{::usageSummary.remaining}}<ins res=\"ute_unit_GB\"></ins></span><ins res=\"ute_label_Remaining\"></ins></li><li><ins res=\"ute_label_Download\"></ins><span>{{::usageSummary.downloaded}}<ins res=\"ute_unit_GB\"></ins></span></li><li><ins res=\"ute_label_Upload\"></ins><span>{{::usageSummary.uploaded}}<ins res=\"ute_unit_GB\"></ins></span></li></ul></span><div class=\"slice\"><div class=\"bar\"></div><div class=\"bar-layer2\"></div><div class=\"fill\"></div></div></div><div class=\"unlimited-data\"><div class=\"total-limit\"><ins res=\"ute_label_Unlimited\"></ins></div><div class=\"total-used\"><span><ins res=\"ute_label_Used\"></ins><span>{{usageSummary.used}}<ins res=\"ute_unit_GB\"></ins></span></span></div></div></div><p class=\"text-center\"><ins res=\"ute_label_ResetLimited\"></ins>{{usageSummary.limited}}<ins res=\"ute_unit_Days\"></ins></p></div><div class=\"col-sm-5 hidden-xs\" ng-if=\"usageData[slctMonth].lineDailyData\"><h4 class=\"ute-col-tertiary\"><ins class=\"text-uppercase\" res=\"ute_label_DailyUsage\"></ins></h4><div class=\"spacer-20\"></div><ute-chartist ng-repeat=\"billingCycle in usageSummary.billingCycle\" ng-if=\"billingCycle.monthlyInd==slctMonth\" chart-data=\"usageData[slctMonth].lineDailyData\" chart-options=\"lineDailyOptions\" chart-type=\"line\" chart-break-line=\"usageData[slctMonth].dailyChartLineBreak\"></ute-chartist></div><div class=\"col-sm-4 hidden-xs\" ng-if=\"!usageData[slctMonth].lineCumulativeData\"><div><div><div class=\"loading\"></div></div></div></div><div class=\"col-sm-4 hidden-xs\" ng-if=\"usageData[slctMonth].lineCumulativeData\"><h4 class=\"ute-col-tertiary\"><ins class=\"text-uppercase\" res=\"ute_label_Cumulative\"></ins></h4><div class=\"spacer-20\"></div><ute-chartist ng-repeat=\"billingCycle in usageSummary.billingCycle\" ng-if=\"billingCycle.monthlyInd==slctMonth\" chart-data=\"usageData[slctMonth].lineCumulativeData\" chart-options=\"lineCumulativeOptions\" chart-type=\"line\" chart-show-limit-line=\"usageData[slctMonth].cumulativeLimitOptions\" chart-break-line=\"usageData[slctMonth].cumulativeChartLineBreak\"></ute-chartist></div><div class=\"col-xs-12\"><h3><ins res=\"ute_label_DailyBreakdown\"></ins></h3><ute-table ng-repeat=\"billingCycle in usageSummary.billingCycle\" ng-if=\"billingCycle.monthlyInd==slctMonth\" table-data=\"usageData[slctMonth].dailyUsage\" footer-data=\"usageData[slctMonth].sum\" table-template-folder=\"views/uteInternetUsage/\" table-body-template=\"_dailyUsageTable\" initial-sort=\"date\"></ute-table></div></div></div></div>");
$templateCache.put("views/uteInternetUsage/uteInternetUsageMonthly.html","<div class=\"ute-internet-usage ute-internet-usage-monthly\" ng-controller=\"uteInternetUsageMonthlyCtrl\"><div class=\"container col-xs-12\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"spacer-15\"></div><div class=\"copy-4\"><ins res=\"ute_label_LastUpdate\"></ins>{{usageSummary.lastUpdated | amDateFormat:\'MMM Do, YYYY\'}}&nbsp; &nbsp; &nbsp;&nbsp; &nbsp;<a ng-click=\"ruiMethods.printDiv(\'printable\');\" class=\"adjust-print-icon\"><i class=\"ute-icon-print ute-xl link\"></i></a></div></div></div><div class=\"spacer-20\"></div><div class=\"row usage-charts\"><div class=\"col-md-4 col-xs-12 usage-meter\" ng-if=\"usageSummary\" ng-class=\"{\'unlimited\':usageSummary.included > 99999}\"><div percentage=\"{{::usageSummary.usageMeter}}\" class=\"c100 big center\"><span><ul><li><span>{{::usageSummary.included}}<ins res=\"ute_unit_GB\"></ins></span>/<ins res=\"ute_label_Month\"></ins></li><li><span>{{::usageSummary.remaining}}<ins res=\"ute_unit_GB\"></ins></span><ins res=\"ute_label_Remaining\"></ins></li><li><ins res=\"ute_label_Downloaded\"></ins><span>{{::usageSummary.downloaded}}<ins res=\"ute_unit_GB\"></ins></span></li><li><ins res=\"ute_label_Uploaded\"></ins><span>{{::usageSummary.uploaded}}<ins res=\"ute_unit_GB\"></ins></span></li></ul></span><div class=\"slice\"><div class=\"bar\"></div><div class=\"bar-layer2\"></div><div class=\"fill\"></div></div></div><div class=\"unlimited-data\"><div class=\"total-limit\"><ins res=\"ute_label_Unlimited\"></ins></div><div class=\"total-used\"><span><ins res=\"ute_label_Used\"></ins><span>{{usageSummary.used}}<ins res=\"ute_unit_GB\"></ins></span></span></div></div><p class=\"text-center\" style=\"margin-top:10px\"><span res=\"ute_label_ResetLimited\"></span> {{usageSummary.limited}} <span res=\"ute_unit_Days\"></span></p></div><div class=\"col-md-8 hidden-xs\" ng-if=\"!lineData\"><div><div><div class=\"loading\"></div></div></div></div><div class=\"col-md-8 hidden-xs\" ng-if=\"lineData\"><h4 class=\"ute-col-tertiary\"><ins class=\"text-uppercase\" res=\"ute_label_MonthlyUsage\"></ins></h4><div class=\"spacer-20\"></div><ute-chartist chart-data=\"lineData\" chart-type=\"line\" chart-options=\"lineOptions\" chart-break-line=\"{enabled:true, limit:(maxUsage), smartAlign:true}\" chart-limit-cumulative=\"true\"></ute-chartist></div></div><div class=\"row\"><div><h3><ins res=\"ute_label_MonthlyBreakdown\"></ins></h3><ute-table table-data=\"monthlyUsage\" footer-data=\"averageUseData\" table-body-template=\"_monthlyUsageTable\" table-template-folder=\"views/uteInternetUsage/\" initial-sort=\"date\"></ute-table></div></div></div></div>");
$templateCache.put("views/uteInternetUsage/uteInternetUsageNotification.html","<div class=\"ute-internet-usage ute-internet-usage-notification\" ng-controller=\"uteInternetUsageNotificationCtrl\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"spacer-15\"></div><div class=\"copy-4\"><ins res=\"ute_label_LastUpdate\"></ins>{{usageSummary.lastUpdated | amDateFormat:\'MMM Do, YYYY\'}} &nbsp;&nbsp;&nbsp;&nbsp; <a class=\"ute-link\" ng-click=\"ruiMethods.printDiv(\'printable\');\"><i class=\"ute-icon-print ute-xxl\"></i></a></div><div class=\"spacer-30\"></div></div></div><ute-table table-data=\"usageHistoryData\" table-body-template=\"_usageNotificationTable\" table-template-folder=\"views/uteInternetUsage/\" ng-class=\"{\'not-empty\': usageHistoryData.length>0}\"></ute-table><div ng-show=\"usageHistoryData.length==0\" class=\"alert alert-info\" role=\"alert\"><div><i class=\"ute-icon-alert-i\"></i></div><div><div><h4>No notifications.</h4></div></div></div></div>");
$templateCache.put("scripts/directives/accountBalance/accountBalanceHorizon.html","<div ng-controller=\"accountBalanceCtrl\" class=\"directive-account-balance medium-font-size\" ng-cloak=\"\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 pbm prm\"><div><div class=\"account-balance-sub-ctn\"><span class=\"title-light-h4 mbs\"><span class=\"semi-bold\" res=\"paynow_acc_balance_today\"></span> <span class=\"nowrap\">{{acctOverviewService.accountBalance.balanceAmount | currencies:lng}}</span></span></div><div ng-if=\"(isConsumer && !isPrepaid) || (isViewBillDisplay)\" class=\"cta-links-sub-ctn\"><a ng-hide=\"state === \'britebill\'\" class=\"pts button-view-bill pointer\" ng-click=\"postToRogers()\" data-ng-class=\"btnSettings.viewBill === btnStatus.disabled ? \'not-active\' : \'\'\" data-ng-hide=\"btnSettings.viewBill === btnStatus.hidden\"><span ng-show=\"!showOlderBills\" res=\"acc_balance_view_bill\" class=\"bold\"></span> <span ng-hide=\"state ===\'britebill\'\" class=\"rui-icon-button-arrow-right font-s\"></span></a></div></div><div class=\"pbm\"><div ng-if=\"isPrepaid\"><div><button name=\"postToRogersTop\" class=\"plm prm cta-round primary large\" ng-click=\"postToRogersTop()\"><span class=\"white\" res=\"acc_overview_top_up_now\"></span></button></div></div></div></div><div id=\"form-view-bill\" ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"ProfileAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"selectedAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"accountNum\"><br>briteBillInvoiceDates: <input type=\"text\" ng-show=\"briteBillInvoiceDates\" data-ng-model=\"briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"></form><form name=\"formToRogersTop\" id=\"formToRogersTop\" method=\"post\" novalidate=\"\">BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"selectedAccount.accountNumber\" name=\"ProfileAccountNumber\"><br>BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"selectedAccount.accountNumber\" name=\"ban\"><br>CTN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"selectedAccount.ctnNumber\" name=\"ctn\"><br>PIN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"selectedAccount.pinNumber\" name=\"passCode\"><br>Flow: <input type=\"text\" value=\"TOP\" name=\"flowId\"><br>briteBillInvoiceDates: <input type=\"text\" ng-show=\"briteBillInvoiceDates\" data-ng-model=\"briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"><br></form></div></div></div>");
$templateCache.put("scripts/directives/accountSelector/accountSelector.html","<div class=\"row\"><ul class=\"account-list pln\"><div class=\"col-lg-4 col-md-12 col-sm-12\" ng-repeat=\"value in accountTypes\" data-ng-hide=\"value.accountTypeNumber === 9\"><li class=\"radius mtm mbm mrm\"><div class=\"radius pam mrm bda-grey account-item\"><div class=\"row\" ng-hide=\"value.accountStatusSimple === \'Error\' || value.accountStatusSimple == \'Warning\'\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 pln prn\"><span class=\"rui-icon-error-icon error-red mrs\" ng-show=\"value.accountStatusSimple === \'Error\'\"></span> <span class=\"rui-icon-warning warning-color mrs\" ng-show=\"value.accountStatusSimple === \'Warning\'\"></span></div><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-11 pln prn\"><div><span class=\"account-owner-name label_blue\">{{value.accountName.firstName| capitalize}}</span></div><div><span class=\"account-owner-number\">{{value.accountNumber}}</span></div><div class=\"\"><a class=\"btn-view-bill\" ng-click=\"postToRogers()\"><span res=\"acc_balance_view_bill\" class=\"bold pointer\"></span></a></div></div></div><div class=\"row\" ng-show=\"value.accountStatusSimple === \'Error\' || value.accountStatusSimple == \'Warning\'\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 pln prn\"><span ng-class=\"value.accountStatusSimple === \'Error\' ? \'rui-icon-error-icon error-red 2x mrs\' : \'rui-icon-warning warning-color mrs\'\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span res=\"acc_overview_account_suspended_2\" ng-show=\"value.accountStatusSimple === \'Error\'\"></span> <span res=\"acc_overview_account_cancelled\" ng-show=\"value.accountStatusSimple === \'Warning\'\"></span><div><span class=\"label_blue mts\">{{value.accountName.firstName| capitalize}}</span></div><div><span class=\"\">{{value.accountNumber}}</span></div><div class=\"\"><a class=\"btn-view-bill\" ng-click=\"postToRogers()\"><span res=\"acc_balance_view_bill\" class=\"bold pointer\"></span></a></div></div></div></div></li></div></ul><div ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" name=\"accountNumber\"><br></form></div></div>");
$templateCache.put("scripts/directives/attemptsErrorBox/attemptsErrorBox.html","<div class=\"error-box-container\"><div class=\"row info-banner-warning\" ng-if=\"(errorAttempts > 0 && errorAttempts <= 3) && !(submitted && (form.USER.$error.required || form.password.$error.required)) || frontLineError\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-12 pln prn\"><div class=\"col-xs-2 col-sm-1 col-lg-1 pln prn\"><img ng-src=\"images/warning_yellow.png\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10 pln prn\"><span><span class=\"sign-error-line-1\" res=\"sign_warning_msg_line_1\"></span><bold-chat-static-button data-cbid=\"boldChatButtonId\" bold-chat-div=\"\'S_BSS_Login_Attempts_Error_2_div\'\" data-chat-button=\"boldChatButton\"></bold-chat-static-button><p class=\"sign-error-line-2\" res=\"sign_warning_msg_line_2\"></p><div data-ng-show=\"(errorAttempts > 0)\"><span class=\"sign-error-line-3\" res=\"sign_warning_msg_line_3\"></span><bold-chat-static-button ng-if=\"(errorAttempts > 0 && errorAttempts <= 3) && !(submitted && (form.USER.$error.required || form.password.$error.required)) && lang === \'en\'\" data-cbid=\"{{boldChat.attempts1.en.cbid}}\" data-dynamic-div=\"{{boldChat.attempts1.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.attempts1.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"(errorAttempts > 0 && errorAttempts <= 3) && !(submitted && (form.USER.$error.required || form.password.$error.required)) && lang === \'fr\'\" data-cbid=\"{{boldChat.attempts1.fr.cbid}}\" data-dynamic-div=\"{{boldChat.attempts1.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.attempts1.fr.chatButtonClass}}\"></bold-chat-static-button></div></span></div></div></div></div><div class=\"row info-banner-warning attempt\" ng-if=\"(errorAttempts === 4) && !(submitted && (form.USER.$error.required || form.password.$error.required))\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-12 pln prn\"><div class=\"col-xs-2 col-sm-1 col-lg-1 pln prn\"><img ng-src=\"images/warning.png\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10 pln prn\"><span><span class=\"sign-error-line-1\" res=\"sign_third_attempts_msg_line_1\"></span><p class=\"sign-error-line-2\" res=\"sign_third_attempts_msg_line_2\"></p><div><span class=\"sign-error-line-3\" res=\"sign_third_attempts_msg_line_3\"></span><bold-chat-static-button ng-if=\"(errorAttempts > 1 && errorAttempts <= 4) && !(submitted && (form.USER.$error.required || form.password.$error.required)) && lang === \'en\'\" data-cbid=\"{{boldChat.attempts2.en.cbid}}\" data-dynamic-div=\"{{boldChat.attempts2.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.attempts2.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"(errorAttempts > 1 && errorAttempts <= 4) && !(submitted && (form.USER.$error.required || form.password.$error.required)) && lang === \'fr\'\" data-cbid=\"{{boldChat.attempts2.fr.cbid}}\" data-dynamic-div=\"{{boldChat.attempts2.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.attempts2.fr.chatButtonClass}}\"></bold-chat-static-button></div></span></div></div></div></div><div class=\"row info-banner-warning attempt\" ng-if=\"(lockFlag) && !(submitted && (form.USER.$error.required || form.password.$error.required))\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-12 pln prn\"><div class=\"col-xs-2 col-sm-1 col-lg-1 pln prn\"><img ng-src=\"images/warning.png\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10 pln prn\"><span><span class=\"sign-error-line-1\" res=\"sign_maximum_attempts_line_1\"></span><p class=\"sign-error-line-2\" res=\"sign_maximum_attempts_line_2\"></p><div><span class=\"sign-error-line-3\" res=\"sign_maximum_attempts_line_3\"></span><bold-chat-static-button ng-if=\"(isLocked || errorAttempts >= 4) && !(submitted && (form.USER.$error.required || form.password.$error.required)) && lang === \'en\'\" data-cbid=\"{{boldChat.attempts3.en.cbid}}\" data-dynamic-div=\"{{boldChat.attempts3.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.attempts3.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"(isLocked || errorAttempts >= 4) && !(submitted && (form.USER.$error.required || form.password.$error.required)) && lang === \'fr\'\" data-cbid=\"{{boldChat.attempts3.fr.cbid}}\" data-dynamic-div=\"{{boldChat.attempts3.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.attempts3.fr.chatButtonClass}}\"></bold-chat-static-button></div></span></div></div></div></div><div class=\"row info-banner-warning\" ng-if=\"somethingWentWrong\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-12 pln prn\"><div class=\"col-xs-2 col-sm-1 col-lg-1 pln prn\"><img ng-src=\"images/warning_yellow.png\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10 pln prn\"><span><span class=\"sign-error-line-1\" res=\"_something_went_wrong\"></span><div data-ng-show=\"somethingWentWrong\"><span class=\"sign-error-line-3\" res=\"sign_warning_msg_line_3\"></span><bold-chat-static-button ng-if=\"somethingWentWrong && lang === \'en\'\" data-cbid=\"{{boldChat.attempts1.en.cbid}}\" data-dynamic-div=\"{{boldChat.attempts1.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.attempts1.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"somethingWentWrong && lang === \'fr\'\" data-cbid=\"{{boldChat.attempts1.fr.cbid}}\" data-dynamic-div=\"{{boldChat.attempts1.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.attempts1.fr.chatButtonClass}}\"></bold-chat-static-button></div></span></div></div></div></div></div>");
$templateCache.put("scripts/directives/bannerArea/bannerArea.html","<div class=\"banner-area-box\"><ins ute-content-injector-no-cache=\"\" language=\"{{lang}}\" content-id=\"/web/smb/cms/selfserve/banner/maintenance-banner\"></ins></div>");
$templateCache.put("scripts/directives/boldChat/boldChatStaticButton.html","<div id=\"{{boldChatDiv}}\"></div>");
$templateCache.put("scripts/directives/confirmDialog/confirmDialog.html","<div class=\"page-layer z4\" ng-show=\"dialog.show\"><div class=\"plxl prxl radius txtL z5 response-dialog\"><div class=\"close-dialog close black desc-font-size-12\">X</div><div><h3 class=\"ptm inline-block\"><span class=\"message-banner-icon icon-{{dialog.icon}} prs\" data-ng-show=\"dialog.icon\"></span>{{dialog.title}}</h3></div><div class=\"ptm desc-font-size-14\" data-ng-show=\"dialog.message\"><span class=\"message-banner-icon icon-{{dialog.iconBody}} prs\" data-ng-show=\"dialog.iconBody\"></span> <span ng-bind-html=\"dialog.message\"></span></div><div class=\"ptm txtR cta\"><button class=\"close-dialog cta-round {{option.type}} medium mll\" data-ng-repeat=\"option in dialog.buttons\" data-ng-click=\"option.action()\"><span class=\"inline-block plm prm\" res=\"{{option.label}}\"></span></button></div></div></div>");
$templateCache.put("scripts/directives/demoWidget/demoWidget.html","<div ng-controller=\"demoWidgetCtrl\"><div ng-show=\"p.lvl1\"><hr><h3>Demo Widget</h3><input data-tl-private=\"\" type=\"text\" name=\"answer\" ng-show=\"p.lvl2\" placeholder=\"Question Lv2\"><br><input data-tl-private=\"\" type=\"text\" name=\"answer\" ng-show=\"p.lvl3\" placeholder=\"Question Lv3\"><br><input data-tl-private=\"\" type=\"text\" name=\"answer\" ng-show=\"p.lvl5\" placeholder=\"Question Lv5\"><br><input data-tl-private=\"\" type=\"text\" name=\"answer\" ng-show=\"p.lvl4\" placeholder=\"Question Lv4\"><br><div class=\"row\"><div class=\"small medium-12 column\"><div class=\"pull-left\"><a href=\"#/signin\" res=\"_cancel\" ng-show=\"p.lvl2\">Cancel</a></div><div class=\"pull-right\"><button class=\"cta-round primary medium full\" ng-show=\"p.lvl5\"><span res=\"_continue\">Continue</span></button></div></div></div><hr></div></div>");
$templateCache.put("scripts/directives/formChequing/formChequing.html","<div class=\"wrapper\" ng-if=\"showDebitForm\"><div class=\"row mtm mbm\"><div class=\"paynow-body-size\"><h3 class=\"mts mrs inline-block black\" res=\"change_method_secure_debit\"></h3><img class=\"mbs\" src=\"images/lock.png\"><br><span class=\"title-light-h4\" res=\"change_method_info_secure_debit\"></span>.</div></div><div class=\"row ptm\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"form.transitNo.$error\" style=\"height:30px;\" ng-show=\"form.transitNo.$invalid && (form.transitNo.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"change_method_invalid_transit_code\"></span></span> <span ng-message=\"pattern\"><span res=\"change_method_invalid_transit_code\" class=\"prm\"></span></span></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"form.bankCode.$error\" ng-show=\"form.bankCode.$invalid && (form.bankCode.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"change_method_invalid_bank_code\"></span></span> <span ng-message=\"pattern\"><span res=\"change_method_invalid_bank_code\" class=\"prm\"></span></span></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"form.accountNo.$error\" ng-show=\"form.accountNo.$invalid && (form.accountNo.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"change_method_invalid_account\"></span></span> <span ng-message=\"pattern\"><span res=\"change_method_invalid_account\" class=\"prm\"></span></span></div></div></div><div class=\"row ptm\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm\"><input data-tl-private=\"\" type=\"text\" name=\"transitNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{5}$/\" id=\"transitNo\" maxlength=\"5\" res-attr=\"{ placeholder: \'change_method_info_transit_code\' }\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"transitFocused=false;\" ng-focus=\"transitFocused=true;\" data-ng-model=\"chequingObj.transitNo\" cobrowse=\"false\" required=\"\"> <span ng-show=\"form.transitNo.$dirty && form.transitNo.$valid\" class=\"inline-checker icon-checked\"></span> <span class=\"inline-checker icon-error\" data-ng-show=\"( form.transitNo.$invalid && (form.transitNo.$dirty || form.$submitted))\"></span></label></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm\"><input data-tl-private=\"\" type=\"text\" name=\"bankCode\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{3}$/\" id=\"bankCode\" maxlength=\"3\" res-attr=\"{ placeholder: \'change_method_info_bank_code\' }\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"bankFocused=false;\" ng-focus=\"bankFocused=true;\" data-ng-model=\"chequingObj.bankCode\" cobrowse=\"false\" required=\"\"> <span ng-show=\"form.bankCode.$dirty && form.bankCode.$valid\" class=\"inline-checker icon-checked\"></span> <span class=\"inline-checker icon-error\" data-ng-show=\"( form.bankCode.$invalid && (form.bankCode.$dirty || form.$submitted))\"></span></label></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm\"><input data-tl-private=\"\" type=\"text\" name=\"accountNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{7,12}$/\" id=\"accountNo\" maxlength=\"12\" res-attr=\"{ placeholder: \'change_method_account_number\' }\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"accountFocused=false;\" ng-focus=\"accountFocused=true;\" data-ng-model=\"chequingObj.accountNo\" cobrowse=\"false\" required=\"\"> <span ng-show=\"form.accountNo.$dirty && form.accountNo.$valid\" class=\"inline-checker icon-checked\"></span> <span class=\"inline-checker icon-error\" data-ng-show=\"( form.accountNo.$invalid && (form.accountNo.$dirty || form.$submitted))\"></span></label></div></div></div><div class=\"row\"><div class=\"hidden-xs\"><div class=\"mtl img-cheque\"><img id=\"overlay\" src=\"images/overlay_cheque_account.png\" data-ng-show=\"accountFocused\"> <img id=\"overlay\" src=\"images/overlay_cheque_bank.png\" data-ng-show=\"bankFocused\"> <img id=\"overlay\" src=\"images/overlay_cheque_transit.png\" data-ng-show=\"transitFocused\"></div></div><div class=\"hidden-sm hidden-md hidden-lg\"><div class=\"mtl img-cheque-mobile\"><img class=\"default-image\" id=\"overlay\" src=\"images/overlay_cheque_account_s.jpg\" data-ng-show=\"!accountFocused && !bankFocused && !transitFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_account_s.jpg\" data-ng-show=\"accountFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_bank_s.jpg\" data-ng-show=\"bankFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_transit_s.jpg\" data-ng-show=\"transitFocused\"></div></div></div><div class=\"row\"><h3 class=\"ptm pbm black\" res=\"change_method_terms_debit\"></h3><div><div res=\"change_method_terms\" class=\"desc-font-size-12 radius textarea_legal pam\" style=\"overflow-y: auto; height:200px\"></div><div class=\"inline_error accept-error\" ng-messages=\"form.isAccepted.$error\" ng-show=\"form.isAccepted.$invalid && form.$submitted\"><span class=\"fa fa-exclamation-circle\"></span> <span ng-message=\"required\"><span res=\"change_method_not_accepted\" class=\"mbs\"></span></span></div><div class=\"check-box-label ptm pbm\"><span ng-class=\"form.isAccepted.$invalid && form.$submitted ? \'checkbox_error\' : \'\'\" class=\"mrs\"><input class=\"check-terms\" type=\"checkbox\" name=\"isAccepted\" ng-model=\"isAccepted\" required=\"\"></span> <span class=\"bold desc-font-size-18\" res=\"change_method_accept\"></span></div></div></div></div>");
$templateCache.put("scripts/directives/goPaperless/goPaperless.html","<ins ute-content-injector-no-cache=\"\" compile=\"true\" language=\"{{language}}\" province=\"{{province}}\" content-id=\"/web/smb/cms/selfserve/onlinebilling/content/account-overview-banner/account-overview-banner\"></ins>");
$templateCache.put("scripts/directives/internetMyModem/internetMyModem.html","<section class=\"internet-my-modem\"><div class=\"container wireless-package\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-7\"><div class=\"row ptm\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"mtn widget-loader-mod\" res=\"internet_my_modem\"></h2><div class=\"widget-loader\" data-ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div></div></div><div class=\"container\" data-ng-show=\"errorMessage\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div call=\"row mbl\" data-ng-show=\"displayContent\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\"><div class=\"row mbl mtm\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 ptm\"><div class=\"visible-xs visible-sm mbm\"><div class=\"semi-bold\" res=\"internet_my_modem\">:</div><div data-ng-ht=\"\">{{internetObj.myModem.name}}</div></div><div class=\"mlm internetMyModem_mod1\"><img data-ng-src=\"{{internetObj.myModem.image}}\" class=\"visible-xs visible-sm internetMyModem_mod2\"> <img data-ng-src=\"{{internetObj.myModem.image}}\" class=\"visible-md visible-lg internetMyModem_mod3\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\"><div class=\"visible-md visible-lg\"><div class=\"semi-bold internetMyModem_mod4\" res=\"internet_my_modem\">:</div><div data-ng-bind-html=\"internetObj.myModem.name\"></div></div><a data-ng-href=\"{{chatHref}}\" target=\"_blank\" ng-hide=\"isDealer || isCare\"></a></div></div></div></div></div></section>");
$templateCache.put("scripts/directives/internetMyPackage/internetMyPackage.html","<section class=\"internet-my-package\"><div class=\"container wireless-package\" style=\"padding-top: 40px;\"><div class=\"row redHeadline mbm\"><div class=\"col-xs-12 col-sm-12 col-lg-7\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"widget-loader-mod\" res=\"internet_my_internet_package\"></h2><div class=\"widget-loader\" data-ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div></div></div><div class=\"container\" data-ng-show=\"errorMessage\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div class=\"row internet-package-ctn\" data-ng-show=\"displayContent\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3 semi-bold\"><div class=\"headline6 semi-bold\" ng-bind-html=\"internetObj.myPlan.package\"></div><div class=\"title-large\" data-ng-hide=\"internetUsageEmpty\"><span class=\"semi-bold\">{{internetObj.myPlan.totalGB| replace : \'\\.00\' : \'\'}}</span></div><div class=\"medium-font-size semi-bold\" data-ng-show=\"false\"><span res=\"internet_speed\"></span> <strong>{{internetObj.myPlan.downloadSpeed}}Mbps</strong></div><div class=\"medium-font-size semi-bold\" data-ng-show=\"false\"><span res=\"internet_speed_up\"></span> <strong>{{internetObj.myPlan.uploadSpeed}}Mbps</strong></div></div><div class=\"col-xs-12 col-sm-8 col-md-6 col-lg-6\" data-ng-hide=\"isDealer || isCare || (internetObj.myExtras.length === 0)\"><div class=\"title-h5 semi-bold mbs\" res=\"internet_my_extras\"></div><div class=\"mts\" res=\"internet_est_monthly_total\"></div><div class=\"my-line-plan-ctn\"><div class=\"container-fluid\"><div class=\"row headline6 myextras-line pbs pts\" data-ng-repeat=\"addon in internetObj.myExtras\"><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5 mls\"><span>{{addon.name}}</span></div><div class=\"col-xs-5 col-sm-4 col-md-4 col-lg-4\"><span class=\"semi-bold my-extras\"><span>{{dollarSignB}}</span> <span>{{addon.price}}</span> <span>{{dollarSignA}}</span> <span res=\"wireless_manage-plan_month\"></span></span></div><div class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2 mls mrs\"><a class=\"headline6\" href=\"\" data-ng-click=\"changeRemove(addon)\"><span res=\"internet_change\" class=\"semi-bold\" data-ng-show=\"addon.label === \'c\'\"></span> <span res=\"internet_remove\" class=\"semi-bold\" data-ng-show=\"addon.label === \'r\'\"></span></a></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-4 internet-package\" data-ng-show=\"isDealer || isCare\"><message-info-box info-message=\"myPackageMessage\"></message-info-box></div></div></div><div class=\"container wireless-package\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-7\"><div class=\"row ptm\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"mtn widget-loader-mod\" res=\"internet_my_modem\"></h2><div class=\"widget-loader\" data-ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div></div></div><div class=\"container\" data-ng-show=\"errorMessage\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div call=\"row mbl\" data-ng-show=\"displayContent\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\"><div class=\"row mbl mtm\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 ptm\"><div class=\"visible-xs visible-sm mbm\"><div class=\"semi-bold\" res=\"internet_my_modem\">:</div><div data-ng-ht=\"\">{{internetObj.myModem.name}}</div></div><div class=\"mlm internetMyModem_mod1\"><img data-ng-src=\"{{internetObj.myModem.image}}\" class=\"visible-xs visible-sm internetMyModem_mod2\"> <img data-ng-src=\"{{internetObj.myModem.image}}\" class=\"visible-md visible-lg internetMyModem_mod3\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\"><div class=\"visible-md visible-lg\"><div class=\"semi-bold internetMyModem_mod4\" res=\"internet_my_modem\">:</div><div data-ng-bind-html=\"internetObj.myModem.name\"></div></div><a data-ng-href=\"{{chatHref}}\" target=\"_blank\" ng-hide=\"isDealer || isCare\"></a></div></div></div></div></div></section>");
$templateCache.put("scripts/directives/internetMyUsage/internetMyUsage.html",".<section class=\"internet-my-usage\"><div class=\"container\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><h2 class=\"widget-loader-mod\" data-res=\"internet_my_usage\"></h2><div class=\"widget-loader internet\" data-ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\" data-ng-hide=\"loadingDataIndicator\"><h5 class=\"legend\" res=\"internet_new_usage\" res-param-days=\"{{internetObj.days}}\" data-ng-show=\"internetObj.days > 0\"></h5></div></div><div class=\"row\" data-ng-show=\"displayContent && !internetUsageEmpty\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"internet-usage\" data-res=\"internet_my_usage_48\"></div></div></div><div class=\"row\" data-ng-show=\"errorMessage\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div><div class=\"row\" data-ng-show=\"displayContent && !internetUsageEmpty\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"usageColours\" data-ng-hide=\"unlimitedShow\"><h6><span class=\"dot green\">&nbsp;</span><span class=\"text-uppercase\" data-res=\"wireless_ok\"></span></h6><h6><span class=\"dot yelow\">&nbsp;</span><span class=\"text-uppercase\" data-res=\"wireless_extra-usage\"></span></h6></div></div></div><div class=\"row usage-ctn\" data-ng-show=\"displayContent && !internetUsageEmpty\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-3\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 title-h4-capital mbm\"><span data-res=\"internet_total_usage\"></span></div><div class=\"title-h4-semibold mbl mtl txtC\" data-ng-show=\"unlimitedShow\"><br><br>{{planName}}</div></div><div class=\"row\" data-ng-hide=\"unlimitedShow\"><div class=\"serviceWrap\"><div class=\"inner-content text-center {{internetObj.globalColor}} {{internetObj.unlimitedClass}}\"><div class=\"center c100 internet-dash-circle\" data-ng-class=\"\'p\' + internetObj.globalPercentage\"><span class=\"inner-circle data\" data-ng-hide=\"isOverage\"><div class=\"h3\"></div><span class=\"ammount semi-bold mtm\">{{lbGB}} <strong data-res=\"internet_GB\" style=\"font-weight:500\"></strong></span> <span class=\"remaining mbm\">{{lbRemaining}}</span> <span class=\"round-small mbs\">{{lbDown}}</span> <span class=\"round-small\">{{lbUpload}}</span></span> <span class=\"inner-circle data\" data-ng-show=\"isOverage\"><span class=\"round-small mbs mtm ptl bold\">{{lblOvrUsedMonth}}</span> <span class=\"round-small bold\" style=\"color:#FFBE3E\">{{lblOvrUsed}}</span> <span class=\"ammount semi-bold mtm\">{{internetObj.extraUsage}} <strong data-res=\"internet_GB\" style=\"font-weight:500\"></strong></span> <span class=\"title-h4 mbs pts\" data-res=\"internet_overage\"></span></span><div class=\"slice\"><div class=\"bar\"></div><div class=\"fill\"></div></div></div><div class=\"unlimited center\" data-ng-show=\"unlimitedShow\"><div class=\"h3\"><span class=\"txt\" data-res=\"wireless_talk\"></span></div></div></div></div></div><div class=\"row mbl\"><div data-ng-show=\"unlimitedShow\" class=\"mbl\"><div class=\"closingTongue\" style=\"border-top-color:#00aec7\"><div class=\"semicircle\" style=\"background-color:#00aec7;\"></div><div class=\"text\"><span data-res=\"internet_used\"></span> {{internetObj.usedGb}} <span data-res=\"internet_GB\"></span></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-5\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 title-h4-capital xs-top-margin mbm\"><span data-res=\"internet_daily_usage\"></span></div></div><div class=\"row\"><div><canvas class=\"chart-position visible-lg visible-md visible-sm\" width=\"380\" height=\"260\"></canvas><canvas class=\"chart-position visible-xs visible-xs\" width=\"280\" height=\"260\"></canvas></div></div></div><div class=\"manage-device col-xs-12 col-sm-12 col-md-6 col-lg-4\"><div class=\"manageDevice semi-bold mtm\"><ul class=\"CTAmenu semi-bold pointer\"><li class=\"pointer\"><a ng-click=\"showUsage(\'daily\')\" ng-hide=\"isDealer || isCare\"><span data-res=\"internet_daily_usage\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a><div ng-show=\"isDealer || isCare\" class=\"internet-usage-link\"><span data-res=\"internet_daily_usage\"></span></div></li><li class=\"pointer\"><a ng-click=\"showUsage(\'monthly\')\" ng-hide=\"isDealer || isCare\"><span data-res=\"internet_monthly_usage\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a><div ng-show=\"isDealer || isCare\" class=\"internet-usage-link\"><span data-res=\"internet_monthly_usage\"></span></div></li><li class=\"pointer\" ng-class=\"{\'last\': !$root.displayEligibility}\"><a ng-click=\"showUsage(\'notification\')\" ng-hide=\"isDealer || isCare\"><span data-res=\"internet_usage_alerts\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a><div ng-show=\"isDealer || isCare\" class=\"internet-usage-link\"><span data-res=\"internet_usage_alerts\"></span></div></li><li class=\"pointer\" ng-if=\"$root.displayEligibility && $root.ColonyPortalSwitch\"><a ng-click=\"redirectToColonyPortal()\"><span data-res=\"internet_colony_network\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div></div><div class=\"row\" data-ng-show=\"internetUsageEmpty\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><center><h3 res=\"internet_missing_usage\"></h3></center></div><div class=\"manage-device col-xs-12 col-sm-12 col-md-offset-6 col-md-6 col-lg-offset-8 col-lg-4\" ng-if=\"$root.displayEligibility && $root.ColonyPortalSwitch\"><div class=\"manageDevice semi-bold mtm\"><ul class=\"CTAmenu semi-bold pointer\"><li class=\"pointer\"><a ng-click=\"redirectToColonyPortal()\"><span data-res=\"internet_colony_network\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div></div></div></section>");
$templateCache.put("scripts/directives/liveChat/liveChat.html","<div class=\"row mbm\" style=\"margin-top:40px\"><div style=\"background-color: #dddddd; height:1px; width:100%;position: absolute;left: 0;\"></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" style=\"margin-top:25px\"><h3 class=\"primary-color\" res=\"link_account_need_help\">Need Help?xxx</h3><img ng-src=\"images/live-chat.png\"> <a class=\"live-chat-link\" href=\"http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=105\" target=\"_blank\"><span res=\"mu_chat\">Live Chat</span></a></div></div>");
$templateCache.put("scripts/directives/mbhLinks/mbhLinks.html","<li ng-controller=\"mbhLinksCtrl\" ng-show=\"launcherEnabled()\"><a onkeydown=\"trackNavigation(event,\'signInDropdown\',\'\',\'{{mbhUrl}}\')\" target=\"_blank\" tabindex=\"0\" class=\"d-flex links mb-16\" href=\"{{mbhUrl}}\"><div class=\"d-flex linkContainer\"><i style=\"background: url(/web/smb/cms/images/OCP_Dashboard_Icon.svg) center bottom no-repeat;width: 15px;height: 15px;background-size: cover;margin: 6px 15px 0px 0px;display: flex;\"></i> <span class=\"linksCaption mr-8\" ng-bind-html=\"ocpHeader1\" style=\"color: #1f1f1f; font-size: 20px; font-weight: 600; letter-spacing: 0px; line-height: 26px;\"></span><div class=\"fa fa-chevron-right\" style=\"color: #da291c; margin-top: 7px;\"></div></div></a><ul class=\"pl-0 mt-0 mb-16\" style=\"border-top: 1px solid #eeeeee; padding-top: 30px;\"><li class=\"d-flex flex-column\" ng-repeat=\"link in links\"><a onkeydown=\"trackNavigation(event,\'signInDropdown\',\'\',\'{{link.url}}\')\" target=\"_blank\" tabindex=\"0\" class=\"d-flex links mb-16\" href=\"{{link.url}}\"><div class=\"d-flex linkContainer\"><span class=\"linksCaption mr-8\" ng-bind-html=\"link.text\"></span><ds-icon name=\"arrow-right\" class=\"d-flex links-icon -size-24\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-arrow-right\"></span></ds-icon></div></a><div></div></li></ul></li>");
$templateCache.put("scripts/directives/mbhLinks/mobileMbhLinks.html","<li class=\"ds-border-bottom ds-brcolor-fog pt-16 px-24\" ng-controller=\"mbhLinksCtrl\" ng-show=\"launcherEnabled()\"><a onkeydown=\"trackNavigation(event,\'signInDropdown\',\'\',\'{{mbhUrl}}\')\" tabindex=\"0\" class=\"d-flex links mb-16\" href=\"{{mbhUrl}}\"><div class=\"d-flex linkContainer\"><i style=\"background: url(/web/smb/cms/images/OCP_Dashboard_Icon.svg) center bottom no-repeat;width: 15px;height: 15px;background-size: cover;margin: 6px 15px 0px 0px;display: flex;\"></i> <span class=\"linksCaption mr-8 ng-binding\" ng-bind-html=\"ocpHeader1\" style=\"color: #1f1f1f; font-size: 20px; font-weight: 600; letter-spacing: 0px; line-height: 26px;\"></span><div class=\"fa fa-chevron-right\" style=\"color: #da291c; margin-top: 7px;\"></div></div></a><ul class=\"pl-0 mt-16 list-none mb-16\"><li ng-repeat=\"link in links\"><a tabindex=\"0\" class=\"d-flex links mb-16\" href=\"{{link.url}}\"><div class=\"d-flex linkContainer\"><span class=\"linksCaption ds-pointer mr-8\">{{link.text}}</span><ds-icon name=\"right\" class=\"d-flex links-icon -size-24\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-right\"></span></ds-icon></div></a><div></div></li></ul><div class=\"greySpaceContainer mb-16\"></div></li>");
$templateCache.put("scripts/directives/messageInfoBox/messageInfoBox.html","<div class=\"info-box\" ng-bind-html=\"infoMessage\"></div>");
$templateCache.put("scripts/directives/myOffers/myOffers.html","<div class=\"directive-my-offers\" id=\"myOffers\"><ute-content-injector language=\"{{lang}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/banners/banner_top/banner_top\"></ute-content-injector><ute-content-injector language=\"{{lang}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/banners/banner_bottom/banner_bottom\"></ute-content-injector></div>");
$templateCache.put("scripts/directives/myservices/myservices.html","<div class=\"row\" id=\"myServices\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\" ng-repeat=\"msl in myServicesList\"><div class=\"myServiceWrap\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? runService(\'{{msl.serviceName}}\', \'{{msl.serviceDetail}}\') : \'\'\" ng-class=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? \'pointer\' : \'\'\"><div class=\"myServiceName\"><div class=\"textVertical\"><img src=\"images/Smart_business_legacy_icon.png\" ng-show=\"msl.serviceType == \'myaccoverview_business_monotoring\'\"> <span ng-show=\"msl.serviceType != \'myaccoverview_business_monotoring\'\" class=\"{{msl.icon}} icon\"></span></div><div class=\"textVertical title-h5\"><span class=\"inline\" res=\"{{msl.serviceType}}\"></span><br><span ng-show=\"msl.showPhone\"><strong>{{msl.serviceDetail | phone2}}</strong></span></div></div><div class=\"myServiceArrow\"></div><div class=\"myServiceCTA\"><div class=\"textVertical arrow-ctn\" ng-hide=\"((isDealer || isCare) && msl.serviceName===\'businessphone\')\"><a name=\"{{msl.serviceName}}\"><span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"linkMsg\" ng-show=\"(isDealer || isCare) && msl.serviceName===\'businessphone\'\"><span ng-bind-html=\"loginMessage\"></span></div></div></div></div></div>");
$templateCache.put("scripts/directives/needHelp/needHelp.html","<div class=\"need-help-box\"><p class=\"need-help-help-text\" res=\"link_account_need_help\">Need Help?xxx</p><div class=\"overrite-margin\"><div id=\"{{boldChatDiv}}\"></div></div></div>");
$templateCache.put("scripts/directives/optionsDialog/optionsDialog.html","<div class=\"page-layer layer-hide z4\"><div class=\"center-all radius z5 option-dialog\"><div class=\"ptm pbm\">{{title}}</div><div class=\"pbm\" ng-bind-html=\"message\"></div><div class=\"txtC cta\"><button class=\"close inline-block cta-round primary medium mll\" data-ng-repeat=\"option in options\" data-ng-click=\"option.action()\"><span class=\"inline-block plm prm\" res=\"_continue\"></span></button></div></div></div>");
$templateCache.put("scripts/directives/otherservices/otherservices.html","<div class=\"row directive-other-services\" id=\"myOtherServicesListFinal\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\" ng-repeat=\"msl in myOtherServicesListFinal\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><a data-ng-class=\"btnSettings.otherAvailableServices === btnStatus.disabled ? \'not-active\' : \'\'\" href=\"\"><h5 class=\"get-services-link\"><span class=\"greater-than\"><span class=\"get-services-txt\" res=\"{{msl.title}}\"></span></span></h5><span class=\"rui-icon-button-arrow-right\"></span></a></div></div></div></div>");
$templateCache.put("scripts/directives/pageHeadline/pageHeadline.html","<div class=\"page-headline\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 ng-bind-html=\"pageHeadline.text\"></h1></div></div></div></div>");
$templateCache.put("scripts/directives/paymentHelper/paymentHelper.html","<div class=\"module-payment-helper\"><div class=\"container\"><div class=\"row\"><h2 class=\"bottom-logo-ctn\" res=\"need_help_with_your_bill\"></h2><div class=\"bottom-btn-ctn\"><div class=\"btn-register\"><a class=\"cta-round secondary medium full\" href=\"https://www.rogers.com/web/content/support?N=42+134\" target=\"_blank\"><span class=\"register-now\" res=\"visit_billing_support\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a></div></div><div class=\"payment-review-ctn\"><a href=\"{{reviewLink}}\" target=\"_blank\"><span class=\"talk-to-us-txt\" res=\"paynow_faq\">Talk to us now</span> <span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"talk-to-us-ctn\"><a class=\"english\" href=\"http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=17&lctc=17%7C01%7Cws%7Cpayment_page_en\" target=\"_blank\"><span class=\"talk-to-us-txt\" res=\"talk_to_us_now\">Talk to us now</span> <span class=\"rui-icon-button-arrow-right\"></span></a> <a class=\"french\" href=\"http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=67&lctc=67%7C01%7Cws%7Cpayment_page_fr\" target=\"_blank\"><span class=\"talk-to-us-txt\" res=\"talk_to_us_now\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a></div></div></div></div>");
$templateCache.put("scripts/directives/registrationArea/registrationArea.html","<div class=\"registration-area-box\"><h2 class=\"registration-area-text-lg\" res=\"mu_registration_lg\" role=\"heading\"></h2><a class=\"registration-area-text-sm\" res=\"mu_registration_sm\" data-ng-click=\"register()\" ng-keypress=\"$event.which === 13 ? register() : 0\" tabindex=\"0\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"registerLink\"></a> <img class=\"registration-area-arrow\" ng-src=\"images/arrow_re.png\" alt=\"\" role=\"presentation\"></div>");
$templateCache.put("scripts/directives/revolution/revolution.html","<div class=\"row mbl\" id=\"dirRevolution\"><div class=\"widget-loader\" ng-show=\"loadingDataIndicatorRev\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><div class=\"row\" ng-show=\"errorMessageR && !(isPageWireless && !hideWirelessTravelPackage)\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessageR\"></validation-error-box></div></div></div><div class=\"row\" ng-show=\"!loadingDataIndicatorRev\"><div class=\"col-lg-{{6+shiftBigCols}} col-md-{{6+shiftBigCols}} col-sm-{{shiftSmColsOut}} col-xs-12 prs\" ng-show=\"(activeOffers.length>0 || (isPageWireless && !hideWirelessTravelPackage))\"><div class=\"row\"><div class=\"no-left-border col-lg-12 col-md-12 col-sm-12 col xs-12\"><div class=\"rui-heading secondary\"><h3><span res=\"revo_included\"></span></h3></div></div></div><div class=\"row\"><div class=\"col-lg-{{numberInnerCols}} col-md-{{numberInnerCols}} widgit-outer-en col-sm-{{shiftSmColsInL}} col-xs-12 pls prs\" ng-show=\"isRgclVisible()\"><div><img ng-src=\"images/value-added-offers/gcl-logo.png\" class=\"visible-lg visible-md visible-sm pts pbs img-size rgcl-image\"> <img ng-src=\"images/value-added-offers/mb-gcl-logo.png\" class=\"visible-xs img-size-mb\" width=\"260px\"></div><div class=\"mbs mrs visible-lg visible-md visible-sm ng-binding title-h5\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\"><ute-content-injector language=\"{{lang}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/account-overview/rgcl/rgcl_message1/rgcl_message1\"></ute-content-injector></div><div class=\"mbs mrs visible-lg visible-md visible-sm ng-binding title-h5\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\"><ute-content-injector language=\"{{lang}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/account-overview/rgcl/rgcl_message2/rgcl_message2\"></ute-content-injector></div><a ng-href=\"https://secure.gamecentrelive.rogers.com/signin?lang={{lang}}\" class=\"widgit-inner cta-round primary medium full red-button white-button\" role=\"button\" res=\"rgcl_watch\" target=\"_blank\"></a><div class=\"visible-lg visible-sm visible-md grey-line\">&nbsp;</div><div class=\"visible-xs grey-line\">&nbsp;</div></div><div ng-hide=\"!isPageWireless || hideWirelessTravelPackage\" class=\"col-lg-{{numberInnerCols}} col-md-{{numberInnerCols}} col-sm-{{shiftSmColsInL}} col-xs-12 pls prs widgit-outer-en-roamlikehome\"><div class=\"headline6 free-empty-div pts\"><span><span>&nbsp;</span></span></div><div class=\"headline6-bold free-empty-div\"><span><span res=\"rome_like_home\"></span></span></div><div class=\"roam-ctn\" ng-show=\"lang === \'en\'\"><img class=\"visible-lg visible-md visible-sm pbs img-size\" src=\"images/RoamON-EN-HD-desktop.png\"> <img class=\"visible-xs pbs img-size\" src=\"images/RoamON-EN-HD-mobile.png\"></div><div class=\"roam-ctn\" ng-show=\"lang === \'fr\'\"><img class=\"visible-lg visible-md visible-sm pbs img-size\" src=\"images/RoamON-FR-HD-desktop.png\"> <img class=\"visible-xs pbs img-size\" src=\"images/RoamON-FR-HD-mobile.png\"></div><div class=\"roaming mbs mrs visible-lg visible-md visible-sm hidden-xs\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\"><span res=\"use_your_phone_like_you_do_at_home\"></span> <span ng-show=\"lang === \'en\'\">${{travelPackageData.us.en.price}}{{travelPackageData.us.en.per.value| escapeHtml}}</span> <span ng-show=\"lang === \'fr\'\">{{travelPackageData.us.fr.price}} $ {{travelPackageData.us.fr.per.value| escapeHtml}}</span> <span res=\"in_the_us\"></span> <span ng-show=\"lang === \'en\'\">${{travelPackageData.common.en.price}}{{travelPackageData.common.en.per.value}}</span> <span ng-show=\"lang === \'fr\'\">{{travelPackageData.common.fr.price}} $ {{travelPackageData.common.fr.per.value}}</span> <span res=\"in_other_countries\"></span> <sup class=\"roaming-legal\" ng-show=\"lang === \'en\'\" ng-repeat=\"legal in travelPackageData.common.en.per.legal\"><span ng-click=\"openWirelessTravelPackageLegalContentModal($event)\">{{legal.label}}</span> <span class=\"roaming-legal-content\" ng-bind-html=\"renderHTML(legal.content)\"></span></sup> <sup class=\"roaming-legal\" ng-show=\"lang === \'fr\'\" ng-repeat=\"legal in travelPackageData.common.fr.per.legal\"><span ng-click=\"openWirelessTravelPackageLegalContentModal($event)\">{{legal.label}}</span> <span class=\"roaming-legal-content\" ng-bind-html=\"renderHTML(legal.content)\"></span></sup></div><div ng-hide=\"travelPackageDataHasPlan\"><a class=\"widgit-inner cta-round primary medium full red-button\" res=\"enroll\" ng-click=\"openWirelesePackageModal()\"></a></div><div class=\"visible-lg visible-sm visible-md grey-line\">&nbsp;</div><a class=\"learn headline6-bold details col-xs-12\" target=\"_blank\" href=\"/consumer/wireless/travel\" ng-hide=\"(isDealer || isCare)\"><span res=\"learn_more\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a><div class=\"visible-xs grey-line col-xs-12\">&nbsp;</div></div><div ng-class=\"!isPageWireless || hideWirelessTravelPackage ? \'widgit-outer-en\' : \'widgit-outer-en-roamlikehome\'\" class=\"col-lg-{{numberInnerCols}} col-md-{{numberInnerCols}} col-sm-{{shiftSmColsInL}} col-xs-12 pls prs widgit-outer-en\" ng-repeat=\"valueAddedOffer in activeOffers | orderBy : \'-isFree\'\"><div ng-if=\"isPageWireless && !hideWirelessTravelPackage\" class=\"visibilityHidden\"><div class=\"headline6 free-empty-div hidden-xs\"><span><span>&nbsp;</span></span></div><div class=\"roam-ctn\"><span class=\"you-have-this-ctn\" ng-show=\"travelPackageDataHasPlan\">&nbsp;</span></div></div><div><img ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrl}}\" class=\"visible-lg visible-md visible-sm pts pbs img-size\"> <img ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrlmb}}\" class=\"visible-xs img-size-mb\"></div><div class=\"mbs mrs visible-lg visible-md visible-sm\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\">{{valueAddedOffer.offerDetails[0].offerDesc}}</div><button class=\"widgit-inner cta-round primary medium full red-button\" ng-class=\"valueAddedOffer.id !== \'spotify\' ? \'white-button\' : \'\'\" ng-click=\"startOffer(valueAddedOffer.id, valueAddedOffer.revSpUrl)\"><span>{{valueAddedOffer.offerDetails[0].messageMap.buttonLabel}}</span></button><div class=\"visible-lg visible-sm visible-md grey-line\">&nbsp;</div><div ng-show=\"valueAddedOffer.swappable\" class=\"headline6-bold details\" ng-click=\"changeSelection(valueAddedOffer.id)\"><span res=\"revo_change_selection\"></span> <span class=\"rui-icon-button-arrow-right mls\"></span></div><div ng-show=\"valueAddedOffer.swappableDate\" class=\"headline6 change-sel\">{{valueAddedOffer.swappableDate}}</div><span ng-show=\"valueAddedOffer.id == \'nextissue\' && !valueAddedOffer.swappable\"><button class=\"nextissue-manage cta-round primary medium full red-button\" ng-click=\"changeSelection(valueAddedOffer.id)\"><span res=\"revo_manage\"></span></button></span><div class=\"visible-xs grey-line\">&nbsp;</div></div></div></div><div class=\"col-lg-{{6-shiftBigCols}} col-md-{{6-shiftBigCols}} col-sm-{{12-shiftSmColsOut}} col-xs-12\" ng-class=\"showMargin?\'value-added-margin\':\'pls no-left-border\'\" ng-show=\"inactiveOffers.length>0\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"rui-heading secondary\"><h3><span res=\"revo_value_add\"></span></h3></div></div></div><div class=\"row\" ng-show=\"showRightLabel\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div ng-show=\"showRightLabel\" class=\"headline6\"><span res=\"revo_free_with_your_plan\"></span></div></div></div><div class=\"row\"><div ng-class=\"!isPageWireless || hideWirelessTravelPackage ? \'widgit-outer-right\' : \'widgit-outer-right-roamlikehome\'\" class=\"col-lg-{{numberRightCols}} col-md-{{numberRightCols}} col-sm-{{shiftSmColsInR}} col-xs-12 prs widgit-outer-right\" ng-repeat=\"valueAddedOffer in inactiveOffers\"><div ng-if=\"isPageWireless && !hideWirelessTravelPackage\" class=\"visibilityHidden\"><div class=\"roam-ctn\"><span class=\"you-have-this-ctn\" ng-show=\"travelPackageDataHasPlan\">&nbsp;</span></div></div><div class=\"rev-inactive-offers-top-image\"><img ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrl}}\" class=\"visible-lg visible-md visible-sm pts pbs img-size\"> <img ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrlmb}}\" class=\"visible-xs img-size-mb\"></div><div class=\"mbs mrs visible-lg visible-md visible-sm\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\">{{valueAddedOffer.offerDetails[0].offerDesc}}</div><button class=\"widgit-inner cta-round primary medium full red-button\" ng-click=\"getOffer(valueAddedOffer.id)\"><span>{{valueAddedOffer.offerDetails[0].messageMap.buttonLabel}}</span></button><div class=\"visible-lg visible-sm visible-md grey-line\">&nbsp;</div><div class=\"headline6-bold details\" ng-click=\"goToDetails(valueAddedOffer.id)\">&nbsp;</div><div class=\"visible-xs grey-line\">&nbsp;</div></div></div></div></div></div>");
$templateCache.put("scripts/directives/revolution/revyouhave.html","<div class=\"col-lg-{{6+shiftBigCols}} col-md-{{6+shiftBigCols}} col-sm-12 col-xs-12 prs\" ng-show=\"activeOffers.length>0\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col xs-12\"><div class=\"rui-heading secondary\"><h3><span res=\"revo_included\"></span></h3></div></div></div><div class=\"row\"><div class=\"col-lg-{{numberInnerCols}} col-md-{{numberInnerCols}} widgit-outer-en col-sm-6 col-xs-6 pls prs\" ng-repeat=\"valueAddedOffer in activeOffers | orderBy : \'-isFree\'\"><div class=\"headline6 free-empty-div\"><span ng-show=\"valueAddedOffer.isFree\"><span class=\"primary\" res=\"revo_free\"></span> <span>{{valueAddedOffer.isFreeLabel}}</span></span></div><div><img width=\"100%\" ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrl}}\" class=\"pts pbs\"></div><div class=\"mbs mrs\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\">{{valueAddedOffer.offerDetails[0].offerDesc}}</div><button class=\"widgit-inner cta-round primary medium full white-button\" ng-class=\"lang === \'fr\' ? \'fr-buttons\' : \'\'\" ng-click=\"getOffer(valueAddedOffer.id)\"><span>{{valueAddedOffer.offerDetails[0].messageMap.buttonLabel}}</span></button><div class=\"grey-line\">&nbsp;</div><div ng-show=\"valueAddedOffer.swappable\" class=\"headline6-bold details\" ng-click=\"changeSelection(valueAddedOffer.id)\"><span res=\"revo_change_selection\"></span> <span class=\"rui-icon-button-arrow-right mls\"></span></div><div ng-show=\"valueAddedOffer.swappableDate\" class=\"headline6 change-sel\">{{valueAddedOffer.swappableDate}}</div></div></div></div>");
$templateCache.put("scripts/directives/rewards/rewardsBanner.html","<div ng-controller=\"rewardsBannerCtrl\" class=\"row directive-rewards\" ng-show=\"objRedeem.isMember && objRedeem.gift\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div ng-class=\"mode==\'overview\'? \'myServiceWrap\' : \'myRewardsWrapWhite\'\" class=\"no-border no-margin\"><div class=\"row no-padding\"><div class=\"col-xs-2 col-sm-1 col-md-2 col-lg-3\"><div class=\"myServiceArrow\"></div></div><div class=\"col-xs-10 col-sm-8 col-md-10 col-lg-9\"><div class=\"rewards-earned-ctn\"><div class=\"pbs\"><span class=\"rewards-earned-txt\" ng-bind-html=\"objRedeem.gift\"></span></div><a class=\"rewards-earned-link\" ng-href=\"{{objRedeem.redeemLink}}\" target=\"_blank\" data-ng-class=\"btnSettings.getTheReward === btnStatus.disabled ? \'not-active\' : \'\'\" data-ng-hide=\"btnSettings.getTheReward === btnStatus.hidden\"><span res=\"rewards_get_reward_link\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a></div></div></div></div></div></div>");
$templateCache.put("scripts/directives/subMenu/subMenu.html","<div class=\"redTop navigation directive-sub-menu\" ng-if=\"!selfDestructFlag\"><div class=\"center-wrapper briteBill\" ng-if=\"!isLegacy()\"><div class=\"container sub-menu-ctn\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><nav id=\"navbar-example\" class=\"navbar navbar-default navbar-static\"><div class=\"container-fluid\"><div class=\"navbar-header col-lg-5 col-md-6 col-sm-12 col-xs-7\"><div class=\"subMenuHeader col-lg-7 col-md-7 col-sm-5 hidden-xs\" res=\"_my_rogers_nospace\"></div><div class=\"subMenuHeader col-xs-5 visible-xs\" res=\"bss_abbr\"></div><span class=\"subMenuDivider\"></span><div class=\"col-lg-5 col-md-5 col-sm-4 col-xs-7 accountDropdown\"><myr-account-list loading-brite-bill=\"ao.bb.loadingBriteBill\"></myr-account-list></div><div class=\"navbar-control\" data-toggle=\"collapse\" data-target=\".bs-example-js-navbar-collapse\" id=\"navToggleHeader\"><span class=\"navbar-close\" ng-class=\"showNavPlus ? \'active\' : \'\'\" res=\"more\"></span> <span class=\"navbar-close\" ng-class=\"!showNavPlus ? \'active\' : \'\'\" res=\"close\"></span> <span class=\"navbar-icon plus active\" ng-class=\"showNavPlus ? \'active\' : \'\'\" ng-show=\"showNavPlus\"><span class=\"navbar-plus\">+</span></span> <span class=\"navbar-icon minus\" ng-class=\"!showNavPlus ? \'active\' : \'\'\" ng-show=\"!showNavPlus\"><span class=\"navbar-minus\">-</span></span></div><div class=\"collapse navbar-collapse bs-example-js-navbar-collapse\" ng-class=\"toggleMainPlusMinus ? \'in\' : \'\'\"><ol class=\"nav navbar-nav\"><li ng-class=\"selSubMenuItem === subMenuItems.overview ? \'mobile-selected\' : \'\'\"><a class=\"pointer\" ng-if=\"isConsumer\" ui-sref=\"accountOverview\" target=\"_self\" role=\"button\" data-ng-class=\"isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\'\" data-ng-click=\"accountOverview($event)\"><span class=\"subMenu-item\" res=\"acc_overview_my_account_overview\" ng-class=\"selSubMenuItem === subMenuItems.overview ? \'selected\' : \'\'\"></span></a> <a class=\"pointer\" ng-if=\"(isDealer || isCare) && !isConsumer\" ui-sref=\"oneViewDashboard\" target=\"_self\" role=\"button\" data-ng-class=\"isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\'\" data-ng-click=\"accountOverview($event)\"><span class=\"subMenu-item\" res=\"acc_overview_my_account_overview\" ng-class=\"selSubMenuItem === subMenuItems.overview ? \'selected\' : \'\'\"></span></a> <span class=\"left-bar\"></span></li><li class=\"dropdown\" tabindex=\"0\" ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'selected\' : \'\'\" ng-if=\"hasWirelessAccount() || hasCableOnlyAccount() || hasIptvOnlyAccount() || isBtvPhaseTwoAccount()\"><a class=\"pointer caret-menu\" id=\"billingDrop\" data-ng-class=\"isSubMenuEnabled(\'billingAndPayment\') ? \'\' : \'not - active\'\" data-toggle=\"dropdown\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"billingAndPaymentTab\"><span class=\"caret caret-right\"></span> <span class=\"subMenu-item caret-left\" ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'selected\' : \'\'\" res=\"submenu_billing_and_payment\"></span> <span class=\"navbar-icon myr-toggle-plus\"></span></a> <span class=\"left-bar\"></span><ol class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"billingDrop\" data-ng-show=\"isDropDownEnabled()\"><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\" ui-sref=\"viewInvoice\" target=\"_self\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"invoiceBillingAndPayment\"><span class=\"service-account-type\" res=\"submenu_invoice\"></span></a></li><li role=\"presentation\" data-ng-hide=\"!hasWirelessAccount()\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\" ui-sref=\"viewGroups\" target=\"_self\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"groupsBillingAndPayment\"><span class=\"service-account-type\" res=\"submenu_groups\"></span></a></li><li role=\"presentation\" data-ng-hide=\"!hasWirelessAccount()\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\" ui-sref=\"viewReporting\" target=\"_self\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"reportsBillingAndPayment\"><span class=\"service-account-type\" res=\"submenu_reporting\"></span></a></li></ol></li><li ng-if=\"!hasCableOnlyAccount() && !hasWirelessAccount() && !hasIptvOnlyAccount() && !isBtvPhaseTwoAccount()\" tabindex=\"0\"><a class=\"pointer\" data-ng-class=\"not - active\" role=\"button\"><span class=\"subMenu-item\" res=\"submenu_billing_and_payment\"></span></a> <span class=\"left-bar\"></span></li><li ng-if=\"!isCableAccount() && !isWirelessAccount() && !isMaestroAccount()\" tabindex=\"0\"><a class=\"pointer\" data-ng-class=\"not - active\" role=\"button\"><span class=\"subMenu-item\" res=\"submenu_services\"></span></a> <span class=\"left-bar\"></span></li><li class=\"dropdown\" tabindex=\"0\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\" ng-if=\"isCableAccount() || isWirelessAccount() || isMaestroAccount()\"><a class=\"pointer caret-menu\" id=\"drop1\" data-ng-class=\"isSubMenuEnabled(\'services\') ? \'\' : \'not - active\'\" data-toggle=\"dropdown\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"serviceTab\"><span class=\"caret caret-right\"></span> <span class=\"subMenu-item caret-left\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\" res=\"submenu_services\"></span> <span class=\"navbar-icon myr-toggle-plus\"></span></a> <span class=\"left-bar\"></span><ol class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"drop1\" data-ng-show=\"isDropDownEnabled()\"><li data-ng-repeat=\"msl in subMenuMyServicesList\" tabindex=\"0\" data-ng-hide=\"msl.hide || btnSettings.allSubscriptions === btnStatus.hidden && activeAccountType != \'9\' || msl.isCompanion\"><a ng-hide=\"msl.hide\" class=\"pointer\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? runService(\'{{msl.serviceName}}\', \'{{msl.serviceDetail}}\',\'{{msl.subscriberName}}\') : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.servicetabMapping}}\"><span class=\"service-account-type\" ng-if=\"msl.serviceType != \'service_wireless\'\" res=\"{{msl.serviceType}}\" ng-hide=\"(isDealer || isCare)\"></span> <span class=\"service-account-type\" ng-if=\"msl.serviceType == \'service_wireless\'\" ng-hide=\"(isDealer || isCare)\">{{msl.subscriberName}}</span> <span class=\"service-account-number\" ng-hide=\"(isDealer || isCare) && msl.serviceName === \'businessphonedashboard\'\">{{ msl.serviceName === \'wireless\' || msl.serviceName === \'businessphonedashboard\' || msl.serviceName === \'wirelessPrepaid\' || msl.serviceName === \'suspended\' ? \' \' + (msl.serviceDetail | phone2) : \'\'}}</span></a></li><li data-ng-repeat=\"msl in subMenuMyServicesList\" tabindex=\"0\" data-ng-hide=\"msl.hide || btnSettings.allSubscriptions === btnStatus.hidden && activeAccountType != \'9\' || !msl.isCompanion || !brtEsimSwitch\"><a ng-hide=\"msl.hide\" class=\"pointer\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? runService(\'{{msl.serviceName}}\', \'{{msl.serviceDetail}}\',\'{{msl.subscriberName}}\') : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.servicetabMapping}}\"><span class=\"service-account-type\" ng-if=\"msl.serviceType != \'service_wireless\'\" res=\"{{msl.serviceType}}\" ng-hide=\"(isDealer || isCare)\"></span> <span class=\"service-account-type\" ng-if=\"msl.serviceType == \'service_wireless\'\" ng-hide=\"(isDealer || isCare)\">{{msl.subscriberName}}</span> <span class=\"service-account-number\" ng-hide=\"(isDealer || isCare) && msl.serviceName === \'businessphonedashboard\'\">{{ msl.serviceName === \'wireless\' || msl.serviceName === \'businessphonedashboard\' || msl.serviceName === \'wirelessPrepaid\' || msl.serviceName === \'suspended\' ? \' \' + (msl.serviceDetail | phone2) : \'\'}}</span></a></li><li ng-show=\"isWireless && subscriberName != \'undefined\'\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\"><span>{{subscriberName}}</span></a></li><li ng-show=\"isBusinessPhone\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\"><span res=\"service_phone\"></span></a></li><li tabindex=\"0\" ng-if=\"hasBrtPermission && hasAccountStatus() && (hasIptvOnlyAccount() == false)\" data-ng-show=\"isWirelessAccount() && hasSelectedWirelessAccount()\"><a class=\"pointer\" ng-click=\"addNewWirelessLine()\"><span class=\"service-account-type\" res=\"submenu_new_wireless_line\"></span></a></li></ol></li><li ng-class=\"selSubMenuItem === subMenuItems.profile ? \'mobile-selected\' : \'\'\" tabindex=\"0\"><a ng-click=\"isDisplayPopup() && isSubMenuEnabled(\'profile\') && runRogersProfile($event);\" role=\"button\" class=\"pointer\" data-ng-class=\"isSubMenuEnabled(\'profile\') ? \'\' : \'not - active\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"profileTab\"><span class=\"subMenu-item\" ng-class=\"selSubMenuItem === subMenuItems.profile ? \'selected\' : \'\'\" res=\"submenu_profile\"></span></a><span class=\"left-bar\"></span></li><li ng-show=\"showCareLink\" tabindex=\"0\"><a ng-click=\"runCustomerCare();\" role=\"button\" class=\"pointer\"><span res=\"_customer_care\"></span></a></li></ol></div></div></div></nav></div></div></div></div><div class=\"center-wrapper briteBill\" ng-if=\"isLegacy()\"><div class=\"container sub-menu-ctn\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><nav id=\"navbar-example\" class=\"navbar navbar-default navbar-static\"><div class=\"container-fluid\"><div class=\"navbar-header col-lg-5 col-md-6 col-sm-12 col-xs-7\"><div class=\"subMenuHeader col-lg-7 col-md-7 col-sm-5 hidden-xs\" res=\"_my_rogers_nospace\"></div><div class=\"subMenuHeader col-xs-5 visible-xs\" res=\"bss_abbr\"></div><span class=\"subMenuDivider\"></span><div class=\"col-lg-5 col-md-5 col-sm-4 col-xs-7 accountDropdown\"><myr-account-list loading-brite-bill=\"ao.bb.loadingBriteBill\"></myr-account-list></div><div class=\"navbar-control\" ng-click=\"navMainMenuClick($event)\" data-toggle=\"collapse\" data-target=\".bs-example-js-navbar-collapse\"><span class=\"navbar-close\" ng-class=\"!toggleMainPlusMinus ? \'active\' : \'\'\" res=\"more\"></span> <span class=\"navbar-close\" ng-class=\"toggleMainPlusMinus ? \'active\' : \'\'\" res=\"close\"></span> <span class=\"navbar-icon plus active\" ng-if=\"!toggleMainPlusMinus\" ng-class=\"!toggleMainPlusMinus ? \'active\' : \'\'\" ng-show=\"!toggleMainPlusMinus\"><span class=\"navbar-plus\">+</span></span> <span class=\"navbar-icon minus\" ng-if=\"toggleMainPlusMinus\" ng-class=\"toggleMainPlusMinus ? \'active\' : \'\'\" ng-show=\"toggleMainPlusMinus\"><span class=\"navbar-minus\">-</span></span></div></div><div class=\"collapse navbar-collapse bs-example-js-navbar-collapse col-lg-7 col-md-7\" ng-class=\"toggleMainPlusMinus ? \'in\' : \'\'\"><ol class=\"nav navbar-nav\"><li ng-class=\"selSubMenuItem === subMenuItems.overview ? \'mobile-selected\' : \'\'\"><a class=\"pointer\" ng-if=\"isConsumer\" ui-sref=\"accountOverview\" target=\"_self\" role=\"button\" data-ng-class=\"isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\'\" data-ng-click=\"accountOverview($event)\"><span class=\"subMenu-item\" res=\"acc_overview_my_account_overview\" ng-class=\"selSubMenuItem === subMenuItems.overview ? \'selected\' : \'\'\"></span></a> <a class=\"pointer\" ng-if=\"(isDealer || isCare) && !isConsumer\" ui-sref=\"oneViewDashboard\" target=\"_self\" role=\"button\" data-ng-class=\"isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\'\" data-ng-click=\"accountOverview($event)\"><span class=\"subMenu-item\" res=\"acc_overview_my_account_overview\" ng-class=\"selSubMenuItem === subMenuItems.overview ? \'selected\' : \'\'\"></span></a> <span class=\"left-bar\"></span></li><li ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'selected\' : \'\'\" tabindex=\"0\" ng-if=\"hasCableOnlyAccount()\" ng-click=\"isSubMenuEnabled(\'billingAndPayment\') && isBriteBillON() && rogersORpaybill() && runRogersProfile()\"><a class=\"pointer\" data-ng-class=\"isSubMenuEnabled(\'billingAndPayment\') ? \'\' : \'not - active\'\" role=\"button\"><span class=\"subMenu-item\" ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'selected\' : \'\'\" res=\"submenu_billing_and_payment\"></span></a> <span class=\"left-bar\"></span></li><li class=\"dropdown\" ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'selected\' : \'\'\" tabindex=\"0\" ng-if=\"hasWirelessAccount()\"><a class=\"pointer caret-menu\" id=\"billingDrop\" data-ng-class=\"isSubMenuEnabled(\'billingAndPayment\') ? \'\' : \'not - active\'\" data-toggle=\"dropdown\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"billingAndPaymentTab\"><span class=\"caret caret-right\"></span> <span class=\"subMenu-item caret-left\" ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'selected\' : \'\'\" res=\"submenu_billing_and_payment\"></span> <span class=\"navbar-icon myr-toggle-plus\"></span></a> <span class=\"left-bar\"></span><ol class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"billingDrop\" data-ng-show=\"isDropDownEnabled()\"><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\" ng-click=\"legacyRedirect(\'invoice\')\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"invoiceBillingAndPayment\"><span class=\"service-account-type\" res=\"submenu_invoice\"></span></a></li><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\" ng-click=\"legacyRedirect(\'reporting\')\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"reportsBillingAndPayment\"><span class=\"service-account-type\" res=\"submenu_reporting\"></span></a></li><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\" ng-click=\"legacyRedirect(\'groups\')\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"groupsBillingAndPayment\"><span class=\"service-account-type\" res=\"submenu_groups\"></span></a></li></ol></li><li ng-if=\"!hasCableOnlyAccount() && !hasWirelessAccount()\" tabindex=\"0\"><a class=\"pointer\" data-ng-class=\"not - active\" role=\"button\"><span class=\"subMenu-item\" res=\"submenu_billing_and_payment\"></span></a> <span class=\"left-bar\"></span></li><li ng-if=\"!isCableAccount() && !isWirelessAccount() && !isMaestroAccount()\" tabindex=\"0\"><a class=\"pointer\" data-ng-class=\"not - active\" role=\"button\"><span class=\"subMenu-item\" res=\"submenu_services\"></span></a> <span class=\"left-bar\"></span></li><li class=\"dropdown\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\" ng-if=\"isCableAccount() || isWirelessAccount() || isMaestroAccount()\" tabindex=\"0\"><a class=\"pointer caret-menu\" id=\"drop1\" data-ng-class=\"isSubMenuEnabled(\'services\') ? \'\' : \'not - active\'\" data-toggle=\"dropdown\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"serviceTab\"><span class=\"caret caret-right\"></span> <span class=\"subMenu-item caret-left\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\" res=\"submenu_services\"></span> <span class=\"navbar-icon myr-toggle-plus\"></span></a> <span class=\"left-bar\"></span><ol class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"drop1\" data-ng-show=\"isDropDownEnabled()\"><li data-ng-repeat=\"msl in subMenuMyServicesList\" ng-if=\"msl.serviceType != \'service_tv\' && hasIptvOnlyAccount()\" tabindex=\"0\" data-ng-hide=\"msl.hide || btnSettings.allSubscriptions === btnStatus.hidden && activeAccountType != \'9\'\"><a ng-hide=\"msl.hide\" class=\"pointer\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? runService(\'{{msl.serviceName}}\', \'{{msl.serviceDetail}}\',\'{{msl.subscriberName}}\') : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.servicetabMapping}}\"><span class=\"service-account-type\" ng-if=\"msl.serviceType != \'service_wireless\'\" res=\"{{msl.serviceType}}\" ng-hide=\"(isDealer || isCare)\"></span> <span class=\"service-account-type\" ng-if=\"msl.serviceType == \'service_wireless\'\" ng-hide=\"(isDealer || isCare)\">{{msl.subscriberName}}</span> <span class=\"service-account-number\" ng-hide=\"(isDealer || isCare) && msl.serviceName === \'businessphonedashboard\'\">{{ msl.serviceName === \'wireless\' || msl.serviceName === \'businessphonedashboard\' || msl.serviceName === \'wirelessPrepaid\' || msl.serviceName === \'suspended\' ? \' \' + (msl.serviceDetail | phone2) : \'\'}}</span></a></li><li ng-show=\"isWireless && subscriberName != \'undefined\'\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\"><span>{{subscriberName}}</span></a></li><li ng-show=\"isBusinessPhone\" tabindex=\"0\"><a role=\"menuitem\" tabindex=\"-1\"><span res=\"service_phone\"></span></a></li></ol></li><li ng-class=\"selSubMenuItem === subMenuItems.profile ? \'mobile-selected\' : \'\'\" tabindex=\"0\"><a ng-click=\"isDisplayPopup() && isSubMenuEnabled(\'profile\') && runRogersProfile($event);\" role=\"button\" class=\"pointer\" data-ng-class=\"isSubMenuEnabled(\'profile\') ? \'\' : \'not - active\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"profileTab\"><span class=\"subMenu-item\" ng-class=\"selSubMenuItem === subMenuItems.profile ? \'selected\' : \'\'\" res=\"submenu_profile\"></span></a><span class=\"left-bar\"></span></li><li ng-show=\"showCareLink\" tabindex=\"0\"><a ng-click=\"runCustomerCare();\" role=\"button\" class=\"pointer\"><span res=\"_customer_care\"></span></a></li></ol></div></div></nav></div></div></div></div></div>");
$templateCache.put("scripts/directives/termsConditions/termsConditions.html","<div><div res=\"change_method_terms\" class=\"desc-font-size-12 radius textarea_legal pam\" style=\"overflow-y: auto; height:200px\"></div><div class=\"inline_error accept-error\" ng-messages=\"form.isAccepted.$error\" ng-show=\"form.isAccepted.$invalid && form.$submitted\"><span class=\"fa fa-exclamation-circle\"></span> <span ng-message=\"required\"><span res=\"change_method_not_accepted\" class=\"mbs\"></span></span></div><div class=\"check-box-label ptm pbm\"><span ng-class=\"form.isAccepted.$invalid && form.$submitted ? \'checkbox_error\' : \'\'\" class=\"mrs\"><input class=\"check-terms\" type=\"checkbox\" name=\"isAccepted\" ng-model=\"isAccepted\" style=\"margin-left:5px;margin-top:2px;\" required=\"\"></span> <span class=\"bold desc-font-size-18\" res=\"change_method_accept\"></span></div></div>");
$templateCache.put("scripts/directives/validationErrorBox/validationErrorBox.html","<div class=\"row info-banner error module-global-error-message pam\" data-ng-show=\"errorMessage\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11\"><span ng-bind-html=\"errorMessage\"></span></div></div>");
$templateCache.put("scripts/directives/wirelessMyDevice/wirelessMyDevice.html","<section class=\"manage-device\"><div class=\"container\"></div></section>");
$templateCache.put("scripts/directives/wirelessNeedHelp/wirelessNeedHelp.html","<section class=\"need-help\"><div class=\"container\" ng-controller=\"wirelessNeedHelpCtrl\"><div class=\"row\"><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><h2 class=\"widget-loader-mod\"><strong>Need Help</strong> With your Wireless account?</h2><div class=\"widget-loader\" ng-show=\"loadingHelp\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><div class=\"doctorWrap\"><div class=\"doctorIcon\">-icon-</div><div class=\"doctorText\">The Doctor is in!<br>Use our Wireless<br>diagnostic tool</div></div></div></div><ul class=\"carousel-control-header row\"><li class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 active\"><h5>Troubleshoot Your<br>Device</h5></li><li class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><h5>Personalize Your<br>Device</h5></li><li class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><h5>User Guides &amp;<br>Software Download</h5></li><li class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><h5>Check If You Have<br>The Best Plan</h5></li></ul><div class=\"owl-carousel\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 carousel-item\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><img class=\"cell-phone-img\" src=\"images/cell-phone.png\"></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5\"><h2>Lorem Ipsum</h2><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum nunc risus, non efficitur elit vehicula dictum. Vestibulum quis ligula in tortor pharetra fermentum in vel eros.</span></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5\"><h2>Lorem Ipsum</h2><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum nunc risus, non efficitur elit vehicula dictum. Vestibulum quis ligula in tortor pharetra fermentum in vel eros.</span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 carousel-item\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><img class=\"cell-phone-img\" src=\"images/cell-phone.png\"></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5\"><h2>Lorem Ipsum</h2><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum nunc risus, non efficitur elit vehicula dictum. Vestibulum quis ligula in tortor pharetra fermentum in vel eros.</span></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5\"><h2>Lorem Ipsum</h2><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum nunc risus, non efficitur elit vehicula dictum. Vestibulum quis ligula in tortor pharetra fermentum in vel eros.</span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 carousel-item\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><img class=\"cell-phone-img\" src=\"images/cell-phone.png\"></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5\"><h2>Lorem Ipsum</h2><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum nunc risus, non efficitur elit vehicula dictum. Vestibulum quis ligula in tortor pharetra fermentum in vel eros.</span></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5\"><h2>Lorem Ipsum</h2><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum nunc risus, non efficitur elit vehicula dictum. Vestibulum quis ligula in tortor pharetra fermentum in vel eros.</span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 carousel-item\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><img class=\"cell-phone-img\" src=\"images/cell-phone.png\"></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5\"><h2>Lorem Ipsum</h2><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum nunc risus, non efficitur elit vehicula dictum. Vestibulum quis ligula in tortor pharetra fermentum in vel eros.</span></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5\"><h2>Lorem Ipsum</h2><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elementum nunc risus, non efficitur elit vehicula dictum. Vestibulum quis ligula in tortor pharetra fermentum in vel eros.</span></div></div></div><div class=\"owl-nav col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"prev\"><span class=\"rui-icon-arrow-left\"></span></div><div class=\"next\"><span class=\"rui-icon-arrow-right\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 visible-xs\"><my-offers></my-offers></div></div></div></section>");
$templateCache.put("scripts/directives/wirelessPackage/wirelessPackage.html","<section ng-controller=\"ute.common.voicemail.resetPassword.directive.controller as resetVoicemailPasswordCtrl\"><div><section class=\"wireless-package\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 redHeadline\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"widget-loader-mod pushDn\" res=\"wireless_manage-plan_wireless-package\"></h2><div class=\"widget-loader\" ng-show=\"wpkg_loadingDataIndicatorPackage\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"wpkg_displayContentPackage\"><div class=\"plan-amt-desc\"><span class=\"plan-title\" ng-show=\"lng === \'en\'\">{{wpkg_wd.postPaidPhoneDetails.planDescription}}</span> <span class=\"plan-title\" ng-show=\"lng === \'fr\'\">{{wpkg_wd.postPaidPhoneDetails.planDescriptionFr}}</span><div ng-if=\"lng === \'en\'\"><span class=\"contributed\" ng-if=\"contributedData.value>0\">{{contributedData.value| number: 0}}{{contributedData.unit}} <span res=\"_shared_data\"></span></span></div><div ng-if=\"lng === \'fr\'\"><span class=\"contributed\" ng-if=\"contributedData.value>0 && contributedData.unit.toLowerCase() === \'gb\'\">{{contributedData.value| number: 0}}<span res=\"wireless_usage_gb\"></span> <span res=\"_shared_data\"></span></span> <span class=\"contributed\" ng-if=\"contributedData.value>0 && contributedData.unit.toLowerCase() === \'mb\'\">{{contributedData.value| number: 0}} <span res=\"wireless_usage_mb\"></span> <span res=\"_shared_data\"></span></span></div></div><div class=\"minutes-txt\" ng-repeat=\"addon in wpkg_client.minutes\"><span>{{addon}}</span></div><div class=\"mtm mbs\" ng-show=\"false\"><a class=\"btn-credit-limit-status mbm mtm pointer\"><span res=\"wireless_package_included_with_plan\" ng-click=\"wpkg_isShowPanel = !wpkg_isShowPanel\" class=\"bold mtl\"></span> <span ng-class=\"wpkg_isShowPanel == true ? \'fa fa-arrow-circle-o-up\' : \'fa fa - arrow - circle - o - down\'\" ng-click=\"wpkg_isShowPanel = !wpkg_isShowPanel\"></span></a></div><div class=\"row my-line-ctn\" ng-if=\"!wpkg_errorMessageWirelessPackage\"><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10\" ng-if=\"!companion\"><ul class=\"addon-ctn\"><li class=\"addon-column\" ng-repeat=\"addon in wpkg_client.features\"><span class=\"addon-title\">{{addon}}</span></li></ul></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 manage-device\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"!companion\"><div class=\"redHeadline\"><h2 class=\"widget-loader-mod\" res=\"wireless_manage-device\"></h2><div class=\"widget-loader\" ng-show=\"wpkg_loadingDataIndicatorDevice\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div></div><div class=\"container\" ng-if=\"wpkg_errorMessageWirelessPackage\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam mtm\"><validation-error-box error-message=\"wpkg_errorMessageWirelessPackage\"></validation-error-box></div></div></div></div><div class=\"manageDevice\" ng-if=\"wpkg_displayContentDevice && !companion\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-6 col-sm-4 col-md-4 col-lg-4\"><div class=\"deviceDetail\"><div class=\"ddImage\"><img ng-src=\"{{wpkg_client.phoneImageProcessed}}\"></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-8 col-lg-8\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"deviceDetail\" ng-if=\"wpkg_client.deviceName != \'\'\"><h3 ng-bind-html=\"wpkg_client.deviceName\" ng-show=\"lng !== \'fr\'\"></h3><h3 ng-bind-html=\"wpkg_client.deviceNameFr\" ng-show=\"lng === \'fr\'\"></h3></div><div class=\"deviceDetail\" ng-if=\"wpkg_client.deviceName == \'\'\"><h3>&nbsp;</h3></div></div></div></div><div class=\"container-fluid\" data-ng-hide=\"isDealer || isCare\"><div class=\"row mts\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"mtm\"><div class=\"plan-cta\" ng-click=\"checkBalance()\" atm=\"wireless_checkdevicebalance_checkdevicebalance\" ng-hide=\"maintenanceTime\"><span class=\"plan-cta-text\" res=\"wireless_manage-device_check_balance\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div><p class=\"unlock-chat-label\" res=\"unlock_chat_label\"></p><div class=\"chat-en\"><a href=\"#\" onclick=\"event.preventDefault(); window.postMessage({ message: \'UCX-OPEN\', messageData: { context: \'Unlock-Device\'} }, \'/\'); return false;\"><p class=\"\" res=\"chat_unlock_device_label\"></p></a></div></div></div></div><div class=\"container-fluid visible-xs\" data-ng-hide=\"isDealer || isCare\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"deviceDetail\"><h3>&nbsp;</h3></div></div></div></div><div class=\"container-fluid\"><div class=\"row mts\"><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10 upgrade-message\" data-ng-show=\"isDealer\"><div><message-info-box info-message=\"upgradeMessage\"></message-info-box></div><div ng-bind-html=\"reserveDeviceMsg\" class=\"reserve-msg\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10 two-column-box\" data-ng-show=\"isCare\"><div><message-info-box info-message=\"careUpgradeMessage\"></message-info-box></div></div><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10 two-column-box\" data-ng-show=\"isCare\"><div><message-info-box info-message=\"careCheckMessage\"></message-info-box></div><div class=\"reserve-msg\" ng-bind-html=\"reserveDeviceMsg\"></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\" ng-show=\"wpkg_displayContentPackage\"><div class=\"my-line-ctn my-line-number-change\" ng-if=\"!wpkg_errorMessageWirelessPackage\"><div><span ng-show=\"brtph2\" class=\"my-line-number\">{{wpkg_client.subscriberName}}</span> <span class=\"my-line-number\">{{wpkg_client.ctn| phone2}}</span> <span class=\"my-line-simtype\" ng-show=\"pType_toggle === true\">{{simtype_label}} : {{physical_label}}</span> <span class=\"my-line-simtype\" ng-show=\"eType_toggle === true\">{{simtype_label}} : {{esim_label}}</span> <span class=\"my-line-simtype\" ng-show=\"uType_toggle === true\">{{simtype_label}} : {{unknown_label}}</span> <a atm=\"wireless_changesubscribername_changesubscribername\" class=\"my-line-change-sim link_blue\" ng-click=\"changeSubscriberName()\" ng-hide=\"isDealer || isCare || !brtph2 || brtph2 == undefined\"><span class=\"lnk-txt\" res=\"wireless_change_subscriber_name\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a> <a atm=\"wireless_changenumber_changenumber\" class=\"my-line-change-number\" ng-click=\"changeTelephoneNumber();\" ng-hide=\"isDealer || isCare || companion\"><span class=\"lnk-txt\" res=\"wireless_manage-plan_change-number\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a> <a atm=\"wireless_changesim_changesim\" class=\"my-line-change-sim link_blue\" ng-click=\"postToeSimpage()\" ng-hide=\"isDealer || isCare || companion || maintenanceTime\"><span class=\"lnk-txt\" res=\"wireless_manage-plan_change-sim\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a><div ng-hide=\"wpkg_client.planSuspended\"><a atm=\"wireless_suspendservice_suspendservice\" class=\"my-line-change-sim link_blue\" ng-click=\"suspendPhone()\" ng-hide=\"isDealer || isCare || companion || maintenanceTime\"><span class=\"lnk-txt\" res=\"wireless_manage-device_suspend-service\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a></div><div ng-show=\"wpkg_client.planSuspended\"><a atm=\"wireless_restoreservice_restoreservice\" class=\"my-line-change-sim link_blue\" ng-click=\"!isReactivateCtnCallInProgress() && reactivatePhone($event)\" ng-hide=\"isDealer || isCare || companion || maintenanceTime\"><span class=\"lnk-txt\" res=\"wireless_manage-device_restore-service\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a></div><a atm=\"wireless_resetyourvm_resetyourvm\" class=\"my-line-change-sim link_blue\" ng-click=\"resetVoicemailPasswordCtrl.openModalPopup()\" ng-hide=\"isDealer || isCare || companion || maintenanceTime\"><span class=\"lnk-txt\" res=\"wireless_manage-device_voicemail-password\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a><a atm=\"wireless_resetvmbox_resetvmbox\" class=\"my-line-change-sim link_blue\" ng-click=\"resetVoiceMailbox()\" ng-hide=\"isDealer || isCare || companion || !brtph2 || brtph2 == undefined || !wpkg_client.hasVoiceMail || wpkg_client.planSuspended || wpkg_client.hasRVoiceMail\"><span class=\"lnk-txt\" res=\"wireless_reset_voice_mailbox\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a> <a atm=\"wireless_resetvmbox_resetvmbox\" class=\"my-line-change-sim link_blue\" ng-click=\"getPdEligibility()\" ng-hide=\"isDealer || isCare || companion || !brtEsimSwitch\"><span class=\"lnk-txt\" res=\"_apple_watch\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a></div></div><div class=\"row my-line-ctn\" ng-if=\"!wpkg_errorMessageWirelessPackage\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"!companion\"><div class=\"my-line-plan-ctn\"><div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h5 class=\"my-line-left-align mtm\" res=\"wireless_manage-plan_estimated-values\"></h5></div></div></div><div class=\"container-fluid visible-lg visible-md\"><div class=\"row plan-ctn\" ng-repeat=\"addon in wpkg_client.postPaidAddons | filter:SOCIsNotSuppressed\"><div class=\"col-xs-8 col-sm-8 col-md-7 col-lg-7 plan-info plan-info-name\"><span class=\"plan-title pull-left\">{{addon.socDesc}}<div ng-if=\"lng === \'en\'\"><span class=\"contributed\" ng-if=\"contributedData.value>0\">{{contributedData.value| number: 0}}{{contributedData.unit}} <span res=\"_shared_data\"></span></span></div><div ng-if=\"lng === \'fr\'\"><span class=\"contributed\" ng-if=\"contributedData.value>0 && contributedData.unit.toLowerCase() === \'gb\'\">{{contributedData.value| number: 0}}<span res=\"wireless_usage_gb\"></span> <span res=\"_shared_data\"></span></span> <span class=\"contributed\" ng-if=\"contributedData.value>0 && contributedData.unit.toLowerCase() === \'mb\'\">{{contributedData.value| number: 0}}<span res=\"wireless_usage_mb\"></span> <span res=\"_shared_data\"></span></span></div></span> <sup style=\"font-size: 0.8em !important; color: #2f6fa7;\"><i class=\"rui-icon-info\" ng-click=\"showTooltip = !showTooltip\" ng-show=\"(addon.soc==\'OPTSRA3TE\' || addon.soc==\'STMSOC\')\" style=\"position: relative;\"></i></sup><div style=\"height:150px;width:300px; background-color:#eee; border:1px solid #aaa; position:absolute; top:25px; left:0%;border-radius:7px;\" ng-show=\"showTooltip\"><div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10\" style=\"margin-left: 10px;margin-top: 10px;\"><span res=\"stm_tooltip_text\"></span></div><span ng-click=\"showTooltip = !showTooltip\" style=\"position: relative; top: 2%; left: 8%; cursor: default;\">X</span></div></div><div class=\"col-xs-6 col-sm-6 col-md-3 col-lg-3 plan-info\"><span class=\"plan-cost\"><span class=\"plan-ammount\" ng-hide=\"lng == \'fr\'\">${{addon.addonMSF| number: 2}}</span> <span class=\"plan-ammount\" ng-show=\"lng == \'fr\'\">{{addon.addonMSF| number: 2 | replace : \'\\.\' : \',\'}} $</span> <span res=\"wireless_manage-plan_month\"></span></span></div><div class=\"col-xs-4 col-sm-4 col-md-2 col-lg-2 plan-info pull-right\" ng-hide=\"isDealer || isCare || maintenanceTime\"><button data-ng-disabled=\"wpkg_client.planSuspended\" class=\"pay-now-btn cta-round primary large\" ng-click=\"openPPC()\" data-test-id=\"myr-wirelessPackage-changePlanButton\" ng-show=\"addon.soc === \'MyPlan\' && isFetchOrderCompleted()\"><span res=\"internet_change\"></span></button><div class=\"widget-loader\" ng-show=\"changeBtnLoading() && addon.soc === \'MyPlan\'\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><span ng-class=\"!wpkg_client.planSuspended ? \'plan-action\' : \'plan - action - disabled\'\" ng-show=\"addon.soc !== \'MyPlan\' && (wpkg_unisonSOCs.indexOf(addon.soc) === -1 && addon.soc.toUpperCase().indexOf(\'UNI\') !== 0)\" ng-click=\"wpkg_client.planSuspended ? \'\' : postToRogersAddOn(addon)\"><span res=\"internet_remove\"></span> <span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"col-xs-12 info-box\" ng-show=\"addon.soc === \'MyPlan\' && hasPPCOrder()\"><div class=\"col-xs-1 text-center info-box-icon\"><span class=\"rui-icon-info\"></span></div><div class=\"col-xs-11 info-box-msg\"><div class=\"col-xs-9\" res=\"ppc_have_saved_order\">ppc_have_saved_order</div><div class=\"col-xs-3 pull-right clickable\" ng-click=\"isCare ? \'\' : openPPC(true)\" ng-class=\"{\'no-pointer\':isCare}\" ng-show=\"isFetchOrderCompleted()\" ng-hide=\"maintenanceTime\"><strong res=\"_continue\">_continue</strong> &gt;</div></div></div></div></div><div class=\"container-fluid visible-xs visible-sm\"><div class=\"row plan-ctn plm\" ng-repeat=\"addon in wpkg_client.postPaidAddons\"><div class=\"col-xs-8 col-sm-8 plan-info plan-info-name\"><div class=\"plan-title\">{{addon.socDesc}}</div><div ng-if=\"lng === \'en\'\"><span class=\"contributed\" ng-if=\"contributedData.value>0\">{{contributedData.value| number: 0}}{{contributedData.unit}} <span res=\"_shared_data\"></span></span></div><div ng-if=\"lng === \'fr\'\"><span class=\"contributed\" ng-if=\"contributedData.value>0 && contributedData.unit.toLowerCase() === \'gb\'\">{{contributedData.value| number: 0}}<span res=\"wireless_usage_gb\"></span> <span res=\"_shared_data\"></span></span> <span class=\"contributed\" ng-if=\"contributedData.value>0 && contributedData.unit.toLowerCase() === \'mb\'\">{{contributedData.value| number: 0}}<span res=\"wireless_usage_mb\"></span> <span res=\"_shared_data\"></span></span></div><div><span class=\"plan-ammount\" ng-hide=\"lng == \'fr\'\">${{addon.addonMSF| number: 2}}</span> <span class=\"plan-ammount\" ng-show=\"lng == \'fr\'\">{{addon.addonMSF| number: 2 | replace : \'\\.\' : \',\'}} $</span> <span res=\"wireless_manage-plan_month\"></span></div></div><div class=\"col-xs-4 col-sm-4 col-md-2 col-lg-2 plan-info pull-right\"><button data-ng-disabled=\"wpkg_client.planSuspended\" class=\"pay-now-btn cta-round primary large\" ng-click=\"openPPC()\" data-test-id=\"myr-wirelessPackage-changePlanButton\" ng-show=\"addon.soc === \'MyPlan\' && isFetchOrderCompleted()\"><span res=\"internet_change\"></span></button><div class=\"widget-loader\" ng-show=\"changeBtnLoading() && addon.soc === \'MyPlan\'\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><span ng-class=\"!wpkg_client.planSuspended ? \'plan-action\' : \'plan - action - disabled\'\" ng-show=\"addon.soc !== \'MyPlan\' && (wpkg_unisonSOCs.indexOf(addon.soc) === -1 && addon.soc.toUpperCase().indexOf(\'UNI\') !== 0)\" ng-click=\"wpkg_client.planSuspended ? \'\' : postToRogersAddOn(addon)\"><span res=\"internet_remove\"></span> <span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"col-xs-12 info-box xsView\" ng-show=\"addon.soc === \'MyPlan\' && hasPPCOrder()\"><div class=\"col-xs-1 text-center info-box-icon\"><span class=\"rui-icon-info\"></span></div><div class=\"col-xs-11 info-box-msg\"><div class=\"col-xs-9\" res=\"ppc_have_saved_order\">ppc_have_saved_order</div><div class=\"col-xs-3 pull-right clickable\" ng-click=\"isCare ? \'\' : openPPC(true)\" ng-class=\"{\'no-pointer\':isCare}\" ng-show=\"isFetchOrderCompleted()\"><strong res=\"_continue\">_continue</strong> &gt;</div></div></div></div></div></div></div></div><div class=\"plan-cta-ctn\" ng-if=\"!wpkg_errorMessageWirelessPackage && (!isDealer && !isCare && !companion)\"><div class=\"plan-cta\" ng-click=\"postToRogersBusinessAddOn()\" ng-show=\"!wpkg_client.planSuspended\" ng-hide=\"maintenanceTime\" atm=\"wireless_managemyaddons_managemyaddons\"><span class=\"plan-cta-text-sm\" res=\"wireless_uadd_new_addons\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"plan-cta\" ng-click=\"postToRogersBusinessAddOn()\" ng-show=\"!wpkg_client.planSuspended\" ng-hide=\"maintenanceTime\" atm=\"wireless_addatravelpack_addatravelpack\"><span class=\"plan-cta-text-sm\" res=\"wireless_uadd_travel_pack\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"plan-cta ng-hide\"><span class=\"plan-cta-text-sm\" res=\"wireless_uadd_a_line\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"plan-cta\" style=\"opacity: 0.6;cursor:auto\" ng-show=\"wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm\" res=\"wireless_uadd_new_addons\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"plan-cta\" style=\"opacity: 0.6;cursor:auto\" ng-show=\"wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm\" res=\"wireless_uadd_travel_pack\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"plan-cta ng-hide\"><span class=\"plan-cta-text-sm\" res=\"wireless_uadd_a_line\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 wireless-package-message\" ng-show=\"isDealer || isCare\"><message-info-box info-message=\"wireLessPackageMessage\"></message-info-box></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7 two-column-box\" ng-show=\"isCare\"><message-info-box info-message=\"wireLessPackagePricePlanMessage\"></message-info-box></div></div></div><div class=\"row\" ng-if=\"wpkg_errorMessageWirelessPackage\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"wpkg_errorMessageWirelessPackage\"></validation-error-box></div></div></div></div><div class=\"container no-left-border\"><div class=\"row ptm\"><revolution></revolution></div></div><div class=\"container\"><div ng-show=\"false\"><form name=\"formToRogersAddLine\" id=\"formToRogersAddLine\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ban\" name=\"ban\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br></form><form name=\"formToRogersAddOn\" id=\"formToRogersAddOn\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ban\" name=\"ban\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br></form><form name=\"formToRogersCTN\" id=\"formToRogersCTN\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ban\" name=\"ban\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br></form><form name=\"formToRogersSim\" id=\"formToRogersSim\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ban\" name=\"ban\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br></form>suspend<form name=\"formToRogersSuspend\" id=\"formToRogersSuspend\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br></form><form name=\"formToRogersBusinessSuspend\" id=\"formToRogersBusinessSuspend\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ban\" name=\"ban\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br><input type=\"text\" value=\"suspend\" name=\"context\"><br></form><form name=\"formToRogersBusinessReactivate\" id=\"formToRogersBusinessReactivate\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ban\" name=\"ban\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br><input type=\"text\" value=\"reactivate\" name=\"context\"><br></form><form name=\"formToRogersAcc\" id=\"formToRogersAcc\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br></form><form name=\"formToRogersUpgrade\" id=\"formToRogersUpgrade\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ban\" name=\"ban\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br><input type=\"text\" data-ng-value=\"wpkg_hupRefId\" name=\"hupRefId\"><br></form><form name=\"formToRogersVoicemail\" id=\"formToRogersVoicemail\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_client.ban\" name=\"ban\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"ctn\"><br>vmsoc<input type=\"text\" data-ng-value=\"wpkg_client.vmsoc\" name=\"VMSOC\"><br></form><form name=\"formToRogersMy5\" id=\"formToRogersMy5\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkg_my5.soc\" name=\"SOC\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ban\" name=\"BAN\"><br><input type=\"text\" data-ng-value=\"wpkg_client.ctn\" name=\"CTN\"><br><input type=\"text\" data-ng-value=\"wpkg_my5.socDesc\" name=\"socDesc\"><br><input type=\"text\" data-ng-value=\"wpkg_my5.MAX\" name=\"MAX\"><br><input type=\"text\" data-ng-value=\"wpkg_my5.TYPE\" name=\"TYPE\"><br><input type=\"text\" value=\"false\" name=\"isPrepaidCustomer\"><br><input type=\"text\" value=\"1\" name=\"passCode\"><br></form><form name=\"formToRogersReserveDevice\" id=\"formToRogersReserveDevice\" method=\"post\" novalidate=\"\"><input type=\"text\" value=\"NRS_MS\" name=\"sourceNRS\"><br></form></div></div></section><section class=\"module-wireless-travel-package ng-hide\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"travel-package-title\" res=\"travel_options\"></h2><div class=\"widget-loader\" ng-show=\"loadingDataIndicatorTravelPackage\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div></div><div class=\"container\" ng-show=\"!loadingDataIndicatorTravelPackage\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"location-title\" res=\"rome_like_home\"></h2></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-5\"><div class=\"roam-ctn\"><span class=\"you-have-this-ctn\" ng-show=\"travelPackageDataHasPlan\" res=\"you_have_this\"></span> <img class=\"roam-badge\" ng-show=\"lng === \'en\'\" src=\"images/RoamON-EN-HD.png\"> <img class=\"roam-badge\" ng-show=\"lng === \'fr\'\" src=\"images/RoamON-FR-HD.png\"></div><a class=\"learn-more-ctn\" target=\"_blank\" href=\"/consumer/wireless/travel\"><span class=\"learn-more-txt\" res=\"learn_more\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"roaming\"><span class=\"roaming-desc-txt\" res=\"use_your_phone_like_you_do_at_home\"></span> <span class=\"roaming-cost-txt\" ng-show=\"lng === \'en\'\">${{travelPackageData.us.en.price}}{{travelPackageData.us.en.per.value| escapeHtml}}</span> <span class=\"roaming-cost-txt\" ng-show=\"lng === \'fr\'\">{{travelPackageData.us.fr.price}}${{travelPackageData.us.fr.per.value| escapeHtml}}</span> <span class=\"roaming-desc-txt\" res=\"in_the_us\"></span> <span class=\"roaming-cost-txt\" ng-show=\"lng === \'en\'\">${{travelPackageData.common.en.price}}{{travelPackageData.common.en.per.value}}</span> <span class=\"roaming-cost-txt\" ng-show=\"lng === \'fr\'\">{{travelPackageData.common.fr.price}}${{travelPackageData.common.fr.per.value}}</span> <span class=\"roaming-desc-txt\" res=\"in_other_countries\"></span> <sup class=\"roaming-legal\" ng-show=\"lng === \'en\'\" ng-repeat=\"legal in travelPackageData.common.en.per.legal\"><span ng-click=\"openWirelessTravelPackageLegalContentModal($event)\">{{ legal.label}}</span> <span class=\"roaming-legal-content\" ng-bind-html=\"renderHTML(legal.content)\"></span></sup> <sup class=\"roaming-legal\" ng-show=\"lng === \'fr\'\" ng-repeat=\"legal in travelPackageData.common.fr.per.legal\"><span ng-click=\"openWirelessTravelPackageLegalContentModal($event)\">{{legal.label}}</span> <span class=\"roaming-legal-content\" ng-bind-html=\"renderHTML(legal.content)\"></span></sup></div><a ng-show=\"!travelPackageDataHasPlan\" class=\"btn-enroll cta-round primary medium\" res=\"enroll\" ng-click=\"openWirelesePackageModal()\"></a></div></div><div class=\"my-line-ctn wireless-travel-package-addons-ctn col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"my-line-plan-ctn\"><div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h5 class=\"my-line-left-align mtm\" res=\"wireless_manage-plan_estimated-values\"></h5></div></div></div><div class=\"container-fluid visible-lg visible-md\"><div class=\"row plan-ctn\" ng-repeat=\"addon in travelPackageAddOnSummaryData.planAddOnDetails\"><div class=\"col-xs-8 col-sm-8 col-md-7 col-lg-7 plan-info plan-info-name\"><span class=\"plan-title pull-left\">{{addon.socDesc}}</span></div><div class=\"col-xs-6 col-sm-6 col-md-3 col-lg-3 plan-info\"><span class=\"plan-cost\"><span class=\"plan-ammount\" ng-hide=\"lng == \'fr\'\">${{addon.addonMSF| number: 2}}</span> <span class=\"plan-ammount\" ng-show=\"lng == \'fr\'\">{{addon.addonMSF| number: 2 | replace : \'\\.\' : \',\'}} $</span> <span res=\"wireless_manage-plan_month\"></span></span></div><div class=\"col-xs-4 col-sm-4 col-md-2 col-lg-2 plan-info pull-right\" ng-hide=\"isDealer || isCare\"><span ng-class=\"!wpkg_client.planSuspended ? \'plan-action\' : \'plan - action - disabled\'\" ng-show=\"addon.soc === \'MyPlan\'\" ng-click=\"wpkg_client.planSuspended ? \'\' : openModal()\"><span res=\"internet_change\"></span> <span class=\"rui-icon-button-arrow-right\"></span></span> <span ng-class=\"!wpkg_client.planSuspended ? \'plan-action\' : \'plan - action - disabled\'\" ng-show=\"addon.soc !== \'MyPlan\' && (wpkg_unisonSOCs.indexOf(addon.soc) === -1 && addon.soc.toUpperCase().indexOf(\'UNI\') !== 0)\" ng-click=\"wpkg_client.planSuspended ? \'\' : postToRogersAddOn(addon)\"><span res=\"internet_remove\"></span> <span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div><div class=\"container-fluid visible-xs visible-sm\"><div class=\"row plan-ctn plm\" ng-repeat=\"addon in travelPackageAddOnSummaryData.planAddOnDetails\"><div class=\"col-xs-8 col-sm-8 plan-info plan-info-name\"><div class=\"plan-title\">{{addon.socDesc}}</div><div><span class=\"plan-ammount\">${{addon.addonMSF| number:2}}</span> <span res=\"wireless_manage-plan_month\"></span></div></div><div class=\"col-xs-4 col-sm-4 col-md-2 col-lg-2 plan-info pull-right\" ng-hide=\"isDealer || isCare\"><button data-ng-disabled=\"wpkg_client.planSuspended\" class=\"pay-now-btn cta-round primary large\" ng-click=\"openPPC()\" data-test-id=\"myr-wirelessPackage-changePlanButton\" ng-show=\"addon.soc === \'MyPlan\' && isFetchOrderCompleted()\"><span res=\"internet_change\"></span></button><div class=\"widget-loader\" ng-show=\"changeBtnLoading() && addon.soc === \'MyPlan\'\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><span ng-class=\"!wpkg_client.planSuspended ? \'plan-action\' : \'plan - action - disabled\'\" ng-show=\"addon.soc !== \'MyPlan\'\" ng-click=\"wpkg_client.planSuspended ? \'\' : postToRogersAddOn(addon)\"><span res=\"internet_remove\"></span> <span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"col-xs-12 info-box xsView\" ng-show=\"addon.soc === \'MyPlan\' && hasPPCOrder()\"><div class=\"col-xs-1 text-center info-box-icon\"><span class=\"rui-icon-info\"></span></div><div class=\"col-xs-11 info-box-msg\"><div class=\"col-xs-9\" res=\"ppc_have_saved_order\">ppc_have_saved_order</div><div class=\"col-xs-3 pull-right clickable\" ng-click=\"isCare ? \'\' : openPPC(true)\" ng-class=\"{\'no-pointer\':isCare}\" ng-show=\"isFetchOrderCompleted()\"><strong res=\"_continue\">_continue</strong> &gt;</div></div></div></div></div></div></div></div></div></section><section class=\"manage-device\"><div class=\"container\"><div class=\"row\" ng-if=\"wpkg_displayContentDevice && !companion\"><div class=\"col-lg-offset-6 col-md-offset-6 col-xs-12 col-sm-12 col-md-6 col-lg-6 my-device-options-list\"><div class=\"manageDevice manage-my-device-ctas\"><ul class=\"CTAmenu\"><li><a ng-click=\"linkToHandsetProtectionGuarantee()\" class=\"pointer\" ng-if=\"!(isDealer || isCare || companion)\"><strong res=\"wireless_manage-device_handset-protection-guarantee\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li><a ng-click=\"linkToWirelessPlans()\" class=\"pointer\" ng-if=\"!(isDealer || isCare || companion)\"><strong res=\"wireless_manage-device_choose-right-plan\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li><a ng-click=\"linkToWirelessNetworkCoverage()\" class=\"pointer\" ng-if=\"!(isDealer || isCare || companion)\"><strong res=\"wireless_manage-device_wireless-coverage-map\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li><a ng-click=\"linkToWirelessAddonTravel()\" class=\"pointer\" ng-hide=\"isDealer || isCare\"><strong res=\"wireless_manage-device_roam-like-home\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li ng-show=\"wpkg_client.hasMyFive && !wpkg_client.planSuspended\"><a ng-click=\"updateMy5()\" class=\"pointer\" ng-hide=\"isDealer || isCare\"><strong res=\"wireless_manage-device_my5-my10\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a><div ng-show=\"isDealer || isCare\" class=\"link-text-container\"><strong res=\"wireless_manage-device_my5-my10\"></strong> : <span class=\"\" ng-bind-html=\"loginMsg\"></span></div></li><li ng-show=\"wpkg_client.hasMyFive && wpkg_client.planSuspended\" style=\"color:#3d4040\"><strong res=\"wireless_manage-device_my5-my10\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\" ng-hide=\"isDealer || isCare\"></span> <span class=\"\" ng-bind-html=\"loginMsg\" ng-show=\"isDealer || isCare\"></span></li><li ng-show=\"wpkg_client.planSuspended\" class=\"opacity-disabled last\"><a style=\"text-decoration: none\"><strong res=\"wireless_manage-device_shop-accessories\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div></div><div class=\"row\" ng-if=\"companion\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"manageDevice\" ng-hide=\"companion\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-6 col-sm-4 col-md-4 col-lg-4\"><div class=\"deviceDetail\"><div class=\"ddImage\"><img ng-src=\"{{wpkg_client.phoneImageProcessed}}\"></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-8 col-lg-8\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"deviceDetail\" ng-if=\"wpkg_client.deviceName != \'\'\"><h3 ng-bind-html=\"wpkg_client.deviceName\" ng-show=\"lng !== \'fr\'\"></h3><h3 ng-bind-html=\"wpkg_client.deviceNameFr\" ng-show=\"lng === \'fr\'\"></h3></div><div class=\"deviceDetail\" ng-if=\"wpkg_client.deviceName == \'\'\"><h3>&nbsp;</h3></div></div></div></div><div class=\"container-fluid\" data-ng-hide=\"isDealer || isCare\"><div class=\"row mts\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"mtm\"><div class=\"plan-cta\" ng-click=\"checkBalance()\" atm=\"wireless_checkdevicebalance_checkdevicebalance\" ng-hide=\"maintenanceTime\"><span class=\"plan-cta-text\" res=\"wireless_manage-device_check_balance\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div><div class=\"mtm\" ng-if=\"reserveDeviceAvbl\"><div class=\"plan-cta\" ng-click=\"linkToReserveDevice()\" atm=\"wireless_reserveadevice_reserveadevice\"><span class=\"plan-cta-text\" res=\"wireless_manage-device_reserve-device\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div><div class=\"chat-en\"><bold-chat-static-button ng-if=\"lang === \'en\'\" data-cbid=\"{{boldChat.unlockDevice.en.cbid}}\" data-dynamic-div=\"{{boldChat.unlockDevice.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.unlockDevice.en.chatButtonClass}}\"></bold-chat-static-button></div><div class=\"chat-fr\"><bold-chat-static-button ng-if=\"lang === \'fr\'\" data-cbid=\"{{boldChat.unlockDevice.fr.cbid}}\" data-dynamic-div=\"{{boldChat.unlockDevice.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.unlockDevice.fr.chatButtonClass}}\"></bold-chat-static-button></div></div></div></div><div class=\"container-fluid visible-xs\" data-ng-hide=\"isDealer || isCare\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"deviceDetail\"><h3>&nbsp;</h3></div></div></div></div><div class=\"container-fluid\"><div class=\"row mts\"><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10 upgrade-message\" data-ng-show=\"isDealer\"><div><message-info-box info-message=\"upgradeMessage\"></message-info-box></div><div ng-bind-html=\"reserveDeviceMsg\" class=\"reserve-msg\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10 two-column-box\" data-ng-show=\"isCare\"><div><message-info-box info-message=\"careUpgradeMessage\"></message-info-box></div></div><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10 two-column-box\" data-ng-show=\"isCare\"><div><message-info-box info-message=\"careCheckMessage\"></message-info-box></div><div class=\"reserve-msg\" ng-bind-html=\"reserveDeviceMsg\"></div></div></div></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 my-device-options-list\"><div class=\"manageDevice manage-my-device-ctas\"><ul class=\"CTAmenu\"><li ng-if=\"!(isDealer || isCare || companion)\"><a ng-click=\"linkToHandsetProtectionGuarantee()\" class=\"pointer\"><strong res=\"wireless_manage-device_handset-protection-guarantee\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li ng-if=\"!(isDealer || isCare || companion)\"><a ng-click=\"linkToWirelessPlans()\" class=\"pointer\"><strong res=\"wireless_manage-device_choose-right-plan\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li ng-if=\"!(isDealer || isCare || companion)\"><a ng-click=\"linkToWirelessNetworkCoverage()\" class=\"pointer\"><strong res=\"wireless_manage-device_wireless-coverage-map\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li><a ng-click=\"linkToWirelessAddonTravel()\" class=\"pointer\" ng-hide=\"isDealer || isCare\"><strong res=\"wireless_manage-device_roam-like-home\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"hasMyFive\" ng-show=\"wpkg_client.hasMyFive && !wpkg_client.planSuspended\"><div ng-hide=\"isDealer || isCare\"><strong res=\"wireless_manage-device_my5-my10\"></strong>:<bold-chat-static-button ng-if=\"lng === \'en\'\" data-cbid=\"{{boldChat.manageMy5.en.cbid}}\" data-dynamic-div=\"{{boldChat.manageMy5.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.manageMy5.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"lng === \'fr\'\" data-cbid=\"{{boldChat.manageMy5.fr.cbid}}\" data-dynamic-div=\"{{boldChat.manageMy5.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.manageMy5.fr.chatButtonClass}}\"></bold-chat-static-button></div><div ng-show=\"isDealer || isCare\" class=\"link-text-container\"><strong res=\"wireless_manage-device_my5-my10\"></strong> : <span class=\"\" ng-bind-html=\"loginMsg\"></span></div></li><li ng-show=\"wpkg_client.hasMyFive && wpkg_client.planSuspended\" style=\"color:#3d4040\"><strong res=\"wireless_manage-device_my5-my10\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\" ng-hide=\"isDealer || isCare\"></span> <span class=\"\" ng-bind-html=\"loginMsg\" ng-show=\"isDealer || isCare\"></span></li><li ng-show=\"wpkg_client.planSuspended\" class=\"opacity-disabled last\"><a style=\"text-decoration: none\"><strong res=\"wireless_manage-device_shop-accessories\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div></div></div></section></div></section>");
$templateCache.put("scripts/directives/wirelessPlan/wirelessPlan.html","<section class=\"wireless-plan\"><div class=\"container\" ng-controller=\"wirelessPlanCtrl\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"widget-loader-mod pushDn\" res=\"wirelessPrepaid\"></h2><div class=\"widget-loader mtl\" ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"container\" ng-show=\"errorMessage\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div class=\"row mbm\" ng-show=\"displayContent\"><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3\"><div class=\"plan-info-wrap\"><div class=\"mbm\" ng-bind-html=\"vpd.phoneSelected.planDescHTML\"></div><h4 ng-show=\"true\"><small><span res=\"wireless_prepaid_plan-expires\" ng-show=\"dtEn\"></span></small> <small><span ng-show=\"lang === \'en\'\">{{dtEn}}</span></small> <small><span ng-show=\"lang === \'fr\'\">{{dtFr | capitalize}}</span></small></h4></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 ptl top-now-padding-left\"><button name=\"postToRogersTop\" class=\"plm prm cta-round primary large mtl\" ng-click=\"postToRogers(2)\"><span class=\"white\" res=\"acc_overview_top_up_now\"></span></button><div class=\"wireless-page my-line-plan-ctn mts pts pbs\"><div ng-click=\"postToRogers(0)\" class=\"pbs\" style=\"width:60%\"><span class=\"plan-title mts mrs pointer\" res=\"wireless_prepaid_change-plan\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 ptm\"><div class=\"\"><div class=\"plan-cta-ctn mtm\"><div class=\"container-fluid\"><div class=\"row plan-ctn pts pbs\" ng-repeat=\"addon in vpd.phoneSelected.addOns\" style=\"border-top: 1px solid #dde4e6;\"><div class=\"plan-info plan-info-name\"><span class=\"plan-title pull-left\">{{addon.addonTitle}}</span></div></div></div></div><div class=\"plan-cta\" ng-click=\"postToRogers(1)\"><span class=\"plan-cta-text\" res=\"wireless_prepaid_manage-add-ons\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div></div><div class=\"row my-line-ctn my-line-bpd\" ng-show=\"displayContent\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div><span class=\"plan-title\" res=\"wireless_prepaid_wireless-number\"></span></div></div></div><div class=\"row my-line-ctn my-line-bpd0\" ng-show=\"displayContent\"><div class=\"col-xs-12 col-sm-6 col-md-3 col-lg-3\"><span class=\"my-line-number\">{{vpd.ctns[0]| phone2}}</span><div ng-click=\"postToRogers(3)\" class=\"pbs pts\"><span class=\"plan-title mts mrs pointer\" res=\"wireless_prepaid_change-number\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-4 top-now-padding-left\"><span class=\"my-line-number\"><span res=\"wireless_prepaid_pin-code\"></span> <span ng-if=\"isConsumer\">{{vpd.phoneSelected.pin}}</span><span ng-if=\"isDealer || isCare\">XXXX</span></span><div ng-click=\"postToRogers(4)\" class=\"pbs pts\"><span class=\"plan-title mts mrs pointer\" res=\"wireless_prepaid_change-pin\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div><div ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">flowId: <input type=\"text\" data-ng-model=\"selectedFlow\" name=\"flowId\"><br>BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"vpd.phoneSelected.accountNumber\" name=\"ban\"><br>CTN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"vpd.phoneSelected.ctn\" name=\"ctn\"><br>PIN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"vpd.phoneSelected.pin\" name=\"passCode\"><br><button ng-click=\"postToRogers(0)\">Plan Change</button> <button ng-click=\"postToRogers(1)\">Add-ons</button> <button ng-click=\"postToRogers(2)\">Top-up</button> <button ng-click=\"postToRogers(3)\">Change Number</button> <button ng-click=\"postToRogers(4)\">Change PIN</button></form></div></div></section>");
$templateCache.put("scripts/modules/accountBalance/accountBalance.html","<div class=\"directive-account-balance medium-font-size\"><h2 class=\"account-balance-title\" res=\"acc_balance\"></h2><span class=\"widget-loader-inline position-abs\" ng-show=\"ab.loadingBalance\"><img src=\"images/widget-loader.gif\" alt=\"\"></span><div id=\"wrapper\" data-ng-hide=\"ab.loadingBalance\"><div class=\"account-balance-ctn\"><div class=\"title-h3-light mts lh41\"><span ng-show=\"ab.abs.accountBalance && !ab.abs.loadingData\">{{ab.abs.accountBalance.balanceAmount | currencies:ab.lng}}</span> <span ng-show=\"!ab.abs.accountBalance && !ab.abs.loadingData\" res=\"acc_balance_not_available\"></span></div><div ng-show=\"((ab.abs.accountBalance.balanceAmount*1) >= 0) && ab.mss.selectedAccountDetail.isPrepaid\"><span class=\"\" res=\"acc_overview_expires_on\"></span><span class=\"\" ng-switch=\"\" on=\"ab.mss.selectedAccountDetail.paymentMethod\"><span ng-switch-when=\"D\" res=\"acc_overview_due_debit\"></span> <span ng-switch-when=\"C\" res=\"acc_overview_due_credit\"></span> <span ng-switch-when=\"R\" res=\"acc_overview_due_invoice\"></span> <span ng-switch-default=\"\"></span>:</span> <span class=\"account-balance-amt\">{{ab.mss.selectedAccountDetail.due | date2:ab.mss.selectedAccountDetail.dateDelimiter:(((!ab.mss.selectedAccountDetail.isPrepaid) && (ab.lng == \'en\')) ? \'-\' : \' \'):ab.mss.selectedAccountDetail.dateYearPrefix:ab.mss.selectedAccountDetail.dateOrder}}</span></div></div><div ng-show=\"(ab.abs.accountBalance.balanceAmount*1 <= 0) && ab.mss.selectedAccountDetail.isPrepaid\"><span res=\"acc_overview_expires_on_default\"></span></div></div><div><div class=\"row bill-ctn\"><div ng-if=\"!ab.mss.selectedAccountDetail.isPrepaid\"><div class=\"col-xs-6 col-sm-4 col-md-6 col-lg-7 pay-now-btn-ctn\" ng-class=\"{\'extraTopMargin\':ab.loadingBalance}\" ng-hide=\"(currentTime>=ab.rs.maintenanceStart)&&(currentTime<ab.rs.maintenanceEnd)\"><button tabindex=\"0\" data-ng-disabled=\"ab.disableBalance || !ab.abs.accountBalance\" data-ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled\" name=\"payBill\" class=\"pay-now-btn cta-round primary large\" ng-click=\"ab.payBill()\" atm=\"overview_paynow_Paynow\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"makePaymentAccOverview\"><span class=\"white\" res=\"acc_balance_pay_now\"></span></button></div><div ng-show=\"(ab.rs.isConsumer && !ab.mss.selectedAccountDetail.isPrepaid) || ab.mss.selectedAccountDetail.isViewBillDisplay\" class=\"col-xs-6 col-sm-4 col-md-6 col-lg-5 pay-bill-ctn\" ng-class=\"{\'extraTopMarginViewBill\':ab.loadingBalance}\"><a class=\"btn-view-bill\" atm=\"overview_viewbill_viewbill\" ng-click=\"ab.postToRogers()\" tabindex=\"0\" data-ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || (ab.bb.loadingBriteBill && bbpermission)) ? \'not-active\' : \'\'\" data-ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"viewBillAccOverview\"><span res=\"acc_balance_view_bill\" class=\"bold pointer\"></span></a></div></div><div ng-if=\"ab.mss.selectedAccountDetail.isPrepaid\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><button atm=\"overview_viewbill_viewbill\" data-ng-disabled=\"ab.disableBalance\" name=\"postToRogersTop\" class=\"plm prm mbm cta-round primary large\" ng-click=\"ab.postToRogersTop()\"><span class=\"white\" res=\"acc_overview_top_up_now\"></span></button></div></div></div></div></div>");
$templateCache.put("scripts/modules/accountBalance/accountBalanceHorizon.html","<div class=\"directive-account-balance medium-font-size\" ng-cloak=\"\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 pbm prm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 account-balance-sub-ctn\"><span class=\"title-light-h4 mbs\"><span class=\"semi-bold\" res=\"paynow_acc_balance_today\"></span> <span class=\"nowrap\">{{ab.abs.accountBalance.balanceAmount | currencies:ab.lng}}</span></span></div><div data-ng-if=\"(ab.rs.isConsumer && !ab.mss.selectedAccountDetail.isPrepaid) || ab.mss.selectedAccountDetail.isViewBillDisplay\" class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 cta-links-sub-ctn\"><a data-ng-hide=\"ab.rs.currentStateName === \'britebill\' || ab.rs.currentStateName === \'paynow\'\" class=\"pts view-bill-link pointer\" data-ng-click=\"ab.postToRogers()\" data-ng-class=\"ab.btnSettings.viewBill === ab.btnStatus.disabled ? \'not-active\' : \'\'\"><span ng-show=\"!ab.showOlderBills\" res=\"acc_balance_view_bill\" class=\"bold\"></span> <span ng-hide=\"ab.rs.currentStateName ===\'britebill\'\" class=\"rui-icon-button-arrow-right font-s\"></span></a> <button data-ng-hide=\"ab.rs.currentStateName === \'britebill\' || ab.rs.currentStateName === \'changeMethod\' || ab.rs.currentStateName === \'paymentHistory\'\" name=\"payBill\" class=\"cta-round primary large view-bill-btn-cm2\" data-ng-click=\"ab.postToRogers()\"><span class=\"white\" res=\"acc_balance_view_bill\"></span></button></div></div><div class=\"pbm\"><div ng-if=\"ab.abs.selectedAccountDetail.isPrepaid\"><div><button name=\"postToRogersTop\" class=\"plm prm cta-round primary large\" data-ng-click=\"ab.postToRogersTop()\"><span class=\"white\" res=\"acc_overview_top_up_now\"></span></button></div></div></div></div><div id=\"form-view-bill\" ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"selectedAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNum\"><br>briteBillInvoiceDates: <input type=\"text\" ng-show=\"ab.rs.briteBillInvoiceDates\" data-ng-model=\"briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"></form><form name=\"formToRogersTop\" id=\"formToRogersTop\" method=\"post\" novalidate=\"\">BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ban\"><br>CTN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.rs.ao.accountDetails.ctnNumber\" name=\"ctn\"><br>PIN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.rs.ao.accountDetails.pinNumber\" name=\"passCode\"><br>Flow: <input type=\"text\" value=\"TOP\" name=\"flowId\"><br>briteBillInvoiceDates: <input type=\"text\" ng-show=\"ab.rs.briteBillInvoiceDates\" data-ng-model=\"briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"><br></form></div></div></div>");
$templateCache.put("scripts/modules/accountList/accountList.html","<form name=\"form\"><div res=\"account\" class=\"myr-account-select-text hidden-xs\"></div><div class=\"styled-select account-select\"><div class=\"accountList\"><div data-toggle=\"dropdown\" id=\"accMenu\" class=\"accMenu\" tabindex=\"0\">{{al.als.selectedAccount.accountNumber}} <i class=\"fa fa-caret-down\" aria-hidden=\"true\"></i></div><ol class=\"headerMenu dropdown-menu\" role=\"menu\" aria-labelledby=\"accMenu\"><li ng-repeat=\"value in al.als.accountTypes\" ng-click=\"al.changeAccNumber(value.accountNumber)\" tabindex=\"0\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"manageBAN\"><span ng-class=\"{ \'text-muted\' : value.accountStatus === \'Cancelled\'}\">{{value.accountNumber}}</span><span ng-class=\"al.als.selectedAccount.accountNumber == value.accountNumber ? \'accNumselected\': \'\'\"></span> <span ng-if=\"value.accountStatus === \'Cancelled\'\" class=\"accountCancelled\" res=\"_cancelled\"></span></li><li class=\"linkAccount\"><a ng-click=\"linkAccount()\" role=\"menuitem\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"accountOverviewTolinkAccount\"><span class=\"service-account-type\" res=\"submenu_link_account\" tabindex=\"0\"></span></a></li></ol></div><span class=\"menuTriangle\"></span></div><span class=\"widget-loader-inline\" ng-show=\"al.loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></form>");
$templateCache.put("scripts/modules/accountOverview/accountOverview.html","<section class=\"page-account-overview\"><div><div class=\"container\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ins ute-content-injector-no-cache=\"\" compile=\"true\" language=\"{{language}}\" content-id=\"/web/smb/cms/selfserve/onlinebilling/content/acctoverviewnotification\"></ins></div><div><myr-notification-banner data-banner-id=\"linkedMessage\" type=\"success\"></myr-notification-banner></div><div><myr-notification-banner data-banner-id=\"successMessage\" type=\"success\"></myr-notification-banner></div></div><div ng-class=\"(isSafariBrowser() && menuOpenSafari) ? \'top-bar-ctn-safari\' : \'top-bar-ctn\'\"><div class=\"container\" ng-if=\"ao.als.selectedAccount.accountStatusError && !ao.loadingDataIndicator\"><div class=\"row pts top-bar\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><h4 class=\"account-owner-name\"></h4><div class=\"row info-banner\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'error\' : \'warning-border\'\" data-ng-show=\"ao.als.selectedAccount.accountStatusError && !ao.loadingDataIndicator\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><span class=\"message-banner-icon error-sign-big\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'icon-error\' : \'icon-alert\'\"></span></div><div ng-show=\"!ao.als.selectedAccount.accountCancelled\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span class=\"v-base-line\" ng-bind-html=\"ao.als.selectedAccount.accountStatusError\" style=\"font-weight:normal\"></span><bold-chat-static-button ng-if=\"language === \'en\'\" data-cbid=\"{{boldChat.suspendAcct.en.cbid}}\" data-dynamic-div=\"{{boldChat.suspendAcct.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.suspendAcct.en.chatButtonClass}}\"></bold-chat-static-button></div><div ng-show=\"ao.als.selectedAccount.accountCancelled\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span class=\"v-base-line mbs\" res=\"acc_overview_account_limited\" style=\"font-weight:normal\"></span><br><span class=\"mtl\"><a class=\"pointer\" ng-click=\"ao.postToRogersCancelled()\">- <span res=\"acc_overview_view_bill\"></span></a><br><a ng-click=\"ao.viewHistory()\" class=\"pointer\">- <span res=\"acc_overview_view_bill_history\"></span></a><br><a ng-click=\"ao.runRogersProfile()\" class=\"pointer\">- <span res=\"acc_overview_manage_profile\"></span></a></span></div><div class=\"pull-right ptm pbm mrm pay-now-btn-ctn\" data-ng-show=\"ao.abs.accountBalance.isCLM && ao.als.selectedAccount\"><button name=\"payBill\" class=\"plm prm cta-round primary large\" ng-click=\"ao.payBill()\"><span class=\"white\" res=\"acc_overview_pay_now\"></span></button></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"acc_overview_my_acc_overview\" class=\"ng-hide\"></span> <span class=\"widget-loader-inline\" ng-show=\"ao.loadingDataIndicator || (ao.bb.loadingBriteBill && bbpermission)\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\"><div class=\"row\"><validation-error-box error-message=\"ao.errorMessage\"></validation-error-box></div><div ng-if=\"!ao.mss.selectedAccountDetail.isPrepaid\"><div class=\"row ptm\"><div data-ng-hide=\"ao.btnSettings.accountBalance === ao.btnStatus.hidden\" class=\"col-xs-12 col-sm-12 col-md-5 col-lg-4\"><myr-account-balance view-html=\"accountBalance.html\" loading-brite-bill=\"ao.bb.loadingBriteBill\"></myr-account-balance></div></div><div class=\"row my-services-list-ctn\"><div data-ng-hide=\"ao.btnSettings.allSubscriptions === ao.btnStatus.hidden\"><myr-my-services></myr-my-services></div></div></div><div ng-if=\"ao.mss.selectedAccountDetail.isPrepaid\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><div ng-show=\"!ao.loadingDataIndicator && !ao.mss.isDetailsNotFound\"><myr-account-balance permission=\"VIEW_ACCOUNT_BALANCE\" view-html=\"accountBalance.html\" loading-brite-bill=\"ao.bb.loadingBriteBill\"></myr-account-balance></div></div><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-1\"></div><div data-ng-hide=\"ao.loadingDataIndicator || ao.mss.isDetailsNotFound\" class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><h1 class=\"primary-color mbl\"></h1><div><myr-my-services mode=\"\'mobile\'\"></myr-my-services></div></div></div></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"mbhBadges col-xs-12 col-sm-12 col-md-12 col-lg-12\" id=\"wcoc-banner-id\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\" ng-if=\"ao.als.selectedAccount.accountStatus === \'Active\' && ao.als.hasActiveWirelessAccount && ao.hasCommunitiesAccess\"><div class=\"wcoc-banner\"><div class=\"banner\"><div class=\"wcoc-banner-head\" res=\"_tor_badge_title\"></div><div class=\"wcoc-banner-subheads\" res=\"_tor_badge_description\"></div><a class=\"wcoc-banner-link\" ng-click=\"ao.redirectToFitUrl(1, ao.mbhUrls.transferOfResponsibility)\"><span res=\"_tor_badge_link\"></span> <img src=\"images/arrow.png\" alt=\"\"></a></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\" ng-if=\"ao.als.selectedAccount.accountStatus === \'Active\' && ao.als.hasActiveWirelessAccount && ao.hasCommunitiesAccess\"><div class=\"wcoc-banner wcoc-banner-manage\"><div class=\"banner banner-manage\"><div class=\"wcoc-banner-head\" res=\"_bill_inquiry_badge_title\"></div><div class=\"wcoc-banner-subheads\" res=\"_bill_inquiry_badge_description\"></div><a class=\"wcoc-banner-link\" ng-click=\"ao.redirectToFitUrl(2, ao.mbhUrls.billInquiry)\"><span res=\"_bill_inquiry_badge_link\"></span> <img src=\"images/arrow.png\" alt=\"\"></a></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\" ng-if=\"ao.als.selectedAccount.accountStatus === \'Active\' && ao.als.hasActiveWirelessAccount && ao.hasCommunitiesAccess\"><div class=\"wcoc-banner\"><div class=\"banner\"><div class=\"wcoc-banner-head\" res=\"_portal_inquiry_badge_title\"></div><div class=\"wcoc-banner-subheads\" res=\"_portal_inquiry_badge_description\"></div><a class=\"wcoc-banner-link\" ng-click=\"ao.redirectToFitUrl(3, ao.mbhUrls.portalInquiry)\"><span res=\"_portal_inquiry_badge_link\"></span> <img src=\"images/arrow.png\" alt=\"\"></a></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\" ng-if=\"ao.als.selectedAccount.accountStatus === \'Active\' && ao.als.hasActiveWirelessAccount\"><div class=\"wcoc-banner wcoc-banner-manage\"><div class=\"banner banner-manage\"><div class=\"wcoc-banner-head\" res=\"_order_inquiry_badge_title\"></div><div class=\"wcoc-banner-subheads\" res=\"_order_inquiry_badge_description\"></div><a class=\"wcoc-banner-link\" ng-click=\"ao.redirectToMidMarket()\"><span res=\"_order_inquiry_badge_link\"></span> <img src=\"images/arrow.png\" alt=\"\"></a></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\" ng-if=\"ao.als.selectedAccount.accountStatus === \'Active\' && ao.als.hasActiveWirelessAccount && ao.hasCommunitiesAccess\"><div class=\"wcoc-banner\"><div class=\"banner\"><div class=\"wcoc-banner-head\" res=\"_port_in_badge_title\"></div><div class=\"wcoc-banner-subheads\" res=\"_port_in_badge_description\"></div><a class=\"wcoc-banner-link\" ng-click=\"ao.redirectToFitUrl(6, ao.mbhUrls.portIn)\"><span res=\"_port_in_badge_link\"></span> <img src=\"images/arrow.png\" alt=\"\"></a></div></div></div></div><div ng-if=\"ao.hasWcocBrt\" class=\"wcocBadges col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><div class=\"wcoc-banner wcoc-banner-manage\"><div class=\"banner banner-manage\"><div class=\"wcoc-banner-head\" res=\"_manage_authorize_extra\"></div><div class=\"wcoc-banner-subhead\" res=\"_data_access_temporary\"></div><a class=\"wcoc-banner-link\" ng-click=\"getJwtToken(\'addManage\')\"><span res=\"_add_manage_authorized\"></span> <img src=\"images/arrow.png\" alt=\"\"></a></div></div></div></div><div res=\"_other_services_available\" class=\"otherservices-title\"></div><div class=\"banner-zone\"><a ng-click=\"ao.addInternet()\" class=\"add-internet\"><span res=\"_add_business_internet\"></span></a><ins ute-content-injector-no-cache=\"\" language=\"{{ao.appState.language}}\" content-id=\"/web/smb/cms/selfserve/otherservices/banners\" compile=\"true\"></ins></div></div></div><div class=\"container\"><div class=\"row ptm\"><div ng-show=\"brtUccP1\" class=\"ucc-banner\" ng-click=\"getAccountUCCDetails()\" compile=\"true\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"RogersUnisonBanner\"><span><ins ute-content-injector-no-cache=\"\" language=\"{{ao.appState.language}}\" content-id=\"/web/smb/cms/ucc/ucc-banner/ucc-banner\"></ins></span></div></div></div><div class=\"container\"><div class=\"row ptm\"><div ng-show=\"cambrt\"><span><ins ute-content-injector-no-cache=\"\" language=\"{{ao.appState.language}}\" content-id=\"/web/smb/cms/cam/cam-banner/cam-banner\" compile=\"true\"></ins></span></div></div></div></section>");
$templateCache.put("scripts/modules/bssDelinkAccount/deLinkAccount.html","<section class=\"page-link-account wrapper\" ng-init=\'model={ account:\"\", postal:\"\", firstName:\"\", lastName:\"\", lastInvoice:\"\", lastPay: \"\", billType:\"online\"}; continue=false; asynWaiting=false\'><div class=\"container\"><div class=\"link-account col-xs-12\"><div class=\"link-account-breadcrumbs\"><a ui-sref=\"accountOverview\" res=\"linked_acc_breadcrumbs_1\"></a> <span>></span><span res=\"delink_acc_breadcrumbs_1\"></span></div><h5 class=\"font-title-lg hidden-xs\" res=\"delinked_acc_title\"></h5><h5 class=\"font-title visible-xs\" res=\"delinked_acc_title\"></h5><form name=\"linkAccForm\" ng-controller=\"BssDelinkAccountController\" novalidate=\"\"><h5 class=\"font-title-sm hidden-xs\" res=\"delinked_acc_title_sub\"></h5><div class=\"spacer-20 hidden-xs\"></div><div class=\"form-group col-xs-12 col-sm-4\"><div class=\"col-sm-12 col-xs-10\"><input type=\"text\" class=\"form-control\" ng-model=\"model.account\" name=\"account\" res-attr=\"{ placeholder: \'_account_number\'}\" ng-disabled=\"continue\" ng-required=\"true\" rgs-valid-acc=\"\"><div class=\"validation-form-info\" ng-show=\"linkAccForm.account.$error.rgsValidAcc\"><span res=\"linked_acc_validate_account\"></span></div></div></div><div class=\"spacer-20 hidden-xs\"></div><div class=\"link-acc-btn form-horizontal form-group col-xs-12 col-sm-12 col-md-8 col-lg-8\"><div class=\"button-container\"><button type=\"submit\" class=\"btn btn-default btn-sm pull-right link-button\" name=\"continue\" res=\"delinked_acc_btn_1\"></button><div class=\"stuff-20 pull-right hidden-xs\"></div><div class=\"spacer-15 visible-xs\"></div><a class=\"btn btn-default btn-sm pull-right link-button\" name=\"skip\" res=\"delinked_acc_btn_2\"></a></div></div></form></div></div></section>");
$templateCache.put("scripts/modules/bssLinkAccount/linkAccount.html","<h1 class=\"sr-only\" res=\"linked_acc_title\"></h1><section class=\"page-link-account wrapper\" ng-init=\'model={ account:\"\", postal:\"\", firstName:\"\", lastName:\"\", lastInvoice:\"\", lastPay: \"\", billType:\"online\"}; continue=false; asynWaiting=false\'><div class=\"container\"><div class=\"link-account col-xs-12\"><div class=\"link-account-breadcrumbs\"><a ui-sref=\"accountOverview\" target=\"_self\" res=\"linked_acc_breadcrumbs_1\"></a> <span>></span><span res=\"linked_acc_breadcrumbs_2\"></span></div><h2 class=\"font-title-lg hidden-xs\" res=\"linked_acc_title\"></h2><h2 class=\"font-title visible-xs\" res=\"linked_acc_title\"></h2><form name=\"linkAccForm\" ng-controller=\"BssLinkAccountController\" novalidate=\"\" ng-submit=\"!continue? (linkAccForm.account.$valid&&linkAccForm.postal.$valid? submit($event):null):(linkAccForm.$valid? submit($event):null);servererror=false;dataerror=false\"><h3 class=\"font-title-sm hidden-xs col-sm-12 col-md-12 col-lg-12\" res=\"linked_acc_title_sub\"></h3><div class=\"spacer-20 hidden-xs\"></div><div ng-if=\"(linkAccForm.$submitted && (servererror || dataerror))\"><div class=\"form-error-bar col-xs-12 col-sm-6\"><div class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2\"><img class=\"\" ng-src=\"images/warningIcon.png\" alt=\"\" role=\"presentation\"></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10\" ng-if=\"servererror\"><div res=\"linked_acc_err_server1\"></div></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10\" ng-if=\"dataerror && !continue\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:validatelinkAccountStep1FormError\" form-field-name=\"\"><div ng-if=\'lang == \"en\"\' bind-html-compile=\"errorMsgEn\"></div><div ng-if=\'lang == \"fr\"\' bind-html-compile=\"errorMsgFr\"></div></span></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10\" ng-if=\"dataerror && continue\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:validatelinkAccountStep2FormError\" form-field-name=\"\"><div ng-if=\'lang == \"en\"\' bind-html-compile=\"errorMsgEn\"></div><div ng-if=\'lang == \"fr\"\' bind-html-compile=\"errorMsgFr\"></div></span></div></div><div class=\"row col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"previous-button\" ng-click=\"previous()\" res=\"linked_acc_btn_skip2\" tabindex=\"0\"></div></div></div><div class=\"spacer-20 hidden-xs\"></div><div ng-if=\"!(servererror || dataerror)\"><div class=\"row\"><h3 class=\"font-title-sm col-xs-12 col-sm-12 col-md-12 col-lg-12\"><b res=\"linked_acc_sub_title_1\"></b></h3><div class=\"spacer-20 hidden-xs\"></div></div><div class=\"row\"><div class=\"form-group col-xs-12 col-sm-4 col-md-4 col-lg-4\"><div class=\"col-sm-12 col-xs-10\"><label for=\"accountNumber\" class=\"sr-only\" res=\"_enter_account_number\"></label> <input type=\"text\" id=\"accountNumber\" class=\"form-control\" ng-model=\"model.account\" name=\"account\" res-attr=\"{ placeholder: \'_account_number\'}\" ng-disabled=\"continue\" ng-required=\"true\" rgs-valid-acc=\"\" tabindex=\"0\"><div class=\"validation-form-info\" ng-show=\"linkAccForm.account.$error.rgsValidAcc\"><span res=\"linked_acc_validate_account\"></span></div><div ng-show=\"linkAccForm.$submitted\"><div class=\"validation-form-info\" ng-show=\"linkAccForm.account.$error.required\"><span res=\"linked_acc_err_req\"></span></div></div></div><div ng-show=\"!continue\"><rgs-inset popup=\"account\"><div class=\"new-info-icon account-number-icon visible-xs\" ng-show=\"!continue\">i</div></rgs-inset></div><div ng-show=\"continue\"><a href=\"\" class=\"account-number-icon glyphicon glyphicon-edit visible-xs\" ng-click=\"continue=false; linkAccForm.$setPristine()\"></a></div><div class=\"spacer-20\"></div><label for=\"postalCode\" class=\"sr-only\" res=\"_enter_postal_code\"></label> <input type=\"text\" id=\"postalCode\" class=\"form-control\" ng-model=\"model.postal\" name=\"postal\" res-attr=\"{ placeholder: \'_postal_code\'}\" ng-disabled=\"continue\" ng-required=\"true\" valid-postal=\"\" tabindex=\"0\"><div class=\"validation-form-info\" ng-show=\"linkAccForm.postal.$error.validPostal\"><span res=\"linked_acc_validate_postal\"></span></div><div ng-show=\"linkAccForm.$submitted\"><div class=\"validation-form-info\" ng-show=\"linkAccForm.postal.$error.required\"><span res=\"linked_acc_err_postal\"></span></div></div></div><div class=\"encloser col-sm-8 col-md-8 col-lg-8\" ng-show=\"!continue\"><div class=\"stuff-10 hidden-xs\"></div><rgs-inset popup=\"account\"><div href=\"\" class=\"new-info-icon account-number-icon hidden-xs\">i</div></rgs-inset><div class=\"recommend-info hidden-sm hidden-xs\" res=\"linked_acc_Where_Account_Number\"></div></div><div ng-show=\"continue\"><a href=\"\" class=\"account-number-icon hidden-xs\" ng-click=\"continue=false; linkAccForm.$setPristine();model.firstName=null; model.lastName=null;model.lastInvoice=null;model.lastPay=null;\" style=\"padding:4px 10px;font-size:18px;\" res=\"linked_acc_Modify\"></a></div></div><div class=\"spacer-30 hidden-xs\"></div><section ng-show=\"continue\"><h3 class=\"font-title-sm col-xs-12\"><b res=\"linked_acc_sub_title_2\"></b></h3><div class=\"spacer-15 hidden-xs\"></div><div class=\"col-sm-4 hidden-xs security-recommend\"><div class=\"cell-block\"><i class=\"glyphicon glyphicon-lock icon\">&nbsp;</i></div><div class=\"cell-block\" res=\"linked_acc_SecurityRecommend\"></div></div><div class=\"spacer-15 hidden-xs\"></div><div class=\"form-group col-xs-12 col-sm-4\"><label for=\"firstName\" class=\"sr-only\" res=\"_enter_first_name\"></label> <input type=\"text\" id=\"firstName\" class=\"form-control\" ng-model=\"model.firstName\" name=\"firstName\" res-attr=\"{ placeholder: \'_enter_first_name\'}\" ng-required=\"true\" tabindex=\"0\"><div ng-show=\"linkAccForm.$submitted\"><div class=\"validation-form-info\" ng-show=\"linkAccForm.firstName.$error.required\"><span res=\"linked_acc_err_req_first\"></span></div></div><div class=\"spacer-20\"></div><label for=\"lastName\" class=\"sr-only\" res=\"_enter_last_name\"></label> <input type=\"text\" id=\"lastName\" class=\"form-control\" ng-model=\"model.lastName\" name=\"lastName\" res-attr=\"{ placeholder: \'_enter_last_name\'}\" ng-required=\"true\" tabindex=\"0\"><div ng-show=\"linkAccForm.$submitted\"><div class=\"validation-form-info\" ng-show=\"linkAccForm.lastName.$error.required\"><span res=\"linked_acc_err_req_last\"></span></div></div><div class=\"spacer-20\"></div><div ng-if=\"showInvoiceAndPayment\"><date-picking class=\"col-sm-12 col-xs-10\" model=\"model.lastInvoice\" name=\"lastInvoice\" placeholder=\"Last Invoice Date\" ng-required=\"true\"></date-picking><div ng-show=\"linkAccForm.$submitted\"><div class=\"validation-form-info\" ng-show=\"linkAccForm.lastInvoice.$error.required\"><span res=\"linked_acc_err_req\"></span></div></div><rgs-inset popup=\"date\"><a class=\"new-info-icon account-number-icon visible-xs\">i</a></rgs-inset><div class=\"spacer-20\"></div><label for=\"lastPayment\" class=\"sr-only\" res=\"_enter_last_payment_amount\"></label> <input type=\"text\" id=\"lastPayment\" class=\"form-control\" ng-model=\"model.lastPay\" name=\"lastPay\" res-attr=\"{ placeholder: \'linked_acc_Last_Payment_Ammount\'}\" ng-required=\"true\" valid-money=\"\" tabindex=\"0\"><div ng-show=\"linkAccForm.$submitted\"><div class=\"validation-form-info\" ng-show=\"linkAccForm.lastPay.$error.required\"><span res=\"linked_acc_err_req\"></span></div></div></div></div><div class=\"inset-2 col-sm-8 col-md-8 col-lg-8 hidden-xs\" ng-if=\"showInvoiceAndPayment\"><div class=\"spacer-100\"></div><div class=\"spacer-15\"></div><div class=\"stuff-10\"></div><rgs-inset popup=\"date\"><div class=\"new-info-icon account-number-icon\">i</div></rgs-inset><div class=\"recommend-info hidden-sm hidden-xs\" res=\"linked_acc_Where_Information\"></div></div><div class=\"spacer-30 hidden-xs\"></div><div ng-hide=\"isCable && (showCableBillType == false)\"><h3 class=\"font-title-sm col-xs-12\"><b res=\"linked_acc_sub_title_3\"></b></h3><fieldset class=\"radiogroup col-xs-12\"><legend class=\"sr-only\" res=\"link_acc_sub_title_3\"></legend><ul style=\"list-style: none; padding-left: 0px !important;\"><li class=\"spacer-20 hidden-xs\"></li><li class=\"radio-zone col-xs-12 col-sm-4\" tabindex=\"0\" ng-keypress=\"$event.which === 13 ? model.billType = \'online\' : 0\" ng-click=\"model.billType = \'online\'\" ng-class=\'{\"selected\":model.billType==\"online\"}\'><input type=\"radio\" id=\"c1\" ng-model=\"model.billType\" name=\"billType\" value=\"online\"> <label for=\"c1\" class=\"sr-only\" res=\"linked_acc_bill_options_1\" style=\"color: #fff;\"></label> <span aria-hidden=\"true\" res=\"linked_acc_bill_options_1\"></span></li><li class=\"spacer-15 visible-xs\"></li><li ng-if=\"!isCable\" class=\"radio-zone col-xs-12 col-sm-4 col-sm-offset-1\" tabindex=\"0\" ng-keypress=\"$event.which === 13 ? model.billType = \'onlineAndPaper\' : 0\" ng-click=\"model.billType = \'onlineAndPaper\'\" ng-class=\'{\"selected\":model.billType==\"onlineAndPaper\"}\'><input type=\"radio\" id=\"c2\" ng-model=\"model.billType\" name=\"billType\" value=\"onlineAndPaper\"> <label for=\"c2\" class=\"sr-only\" res=\"linked_acc_bill_options_2\" style=\"color: #fff;\"></label> <span aria-hidden=\"true\" res=\"linked_acc_bill_options_2\"></span></li><li ng-if=\"!isCable\" class=\"spacer-30 hidden-xs\"></li><li ng-if=\"isCable\" ng-click=\"model.billType = \'paper\'\" tabindex=\"0\" ng-keypress=\"$event.which === 13 ? model.billType = \'paper\' : 0\" class=\"radio-zone col-xs-12 col-sm-4 col-sm-offset-1\" ng-class=\'{\"selected\":model.billType==\"paper\"}\'><input type=\"radio\" id=\"c3\" ng-model=\"model.billType\" name=\"billType\" value=\"paper\"> <label for=\"c3\" class=\"sr-only\" res=\"linked_acc_bill_options_3\" style=\"color: #fff;\"></label> <span aria-hidden=\"true\" res=\"linked_acc_bill_options_3\"></span></li><li ng-if=\"isCable\" class=\"spacer-30 hidden-xs\"></li></ul></fieldset></div></section><div class=\"spacer-20 hidden-xs\"></div><div class=\"link-acc-btn form-horizontal form-group col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"spacer-20 visible-xs\"></div><div class=\"button-container\"><button ng-if=\"!continue\" type=\"submit\" class=\"link-button\" name=\"continue\" res=\"linked_acc_btn_continue\"></button> <button ng-if=\"continue\" type=\"submit\" class=\"link-button\" name=\"continue\" res=\"linked_acc_btn_link_account\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"linkAccountStep2Validation\"></button><div class=\"spacer-15 visible-xs\"></div><a class=\"cancel-button\" name=\"skip\" res=\"linked_acc_btn_skip2\" ng-click=\"skip($event)\" tabindex=\"0\" ng-keypress=\"$event.which === 13 ? skip($event) : 0\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"linkAccountCancel\"></a> <span ng-show=\"asynWaiting\" style=\"text-align: center\"><img style=\"width: 40px;\" src=\"images/widget-loader.gif\" alt=\"Page loading...\"></span></div></div></div></form></div></div></section>");
$templateCache.put("scripts/modules/bssLinkAccount/rgsInset.html","<ng-transclude></ng-transclude><div class=\"inset-accordion\" ng-show=\"_insetOpen==true\" ng-init=\"_insetOpen=false;_account=false;_date=false\"><div ng-if=\"_account == true\" class=\"inset-box\"><img ng-src=\"images/sample-invoice.png\"></div><div style=\"top: -138%;left: 0.5%;\" ng-if=\"_date == true\" class=\"inset-box\"><img ng-src=\"images/sample-invoice-date.png\"></div></div>");
$templateCache.put("scripts/modules/businessPhoneDashboard/businessPhoneDashboard.html","<script type=\"text/javascript\">\n  $(function () {\n    $(\'.pointer\').popover();\n  });\n</script><section class=\"page-businessphonedashboard\"><div ng-cloak=\"\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"phone_business_business\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"styled-select wireless-account-select\" data-ng-show=\"wirelessDashData.length > 1\"><select name=\"accountType\" required=\"\" data-ng-model=\"wirelessDashActive\" ng-change=\"changeAccount()\" ng-options=\"value.ctn | phone2 for (key, value) in wirelessDashData\"></select></div><div class=\"wireless-account-spacer\" data-ng-show=\"wirelessDashData.length == 1\"></div></div></div></div><div class=\"container\"><span><ins ute-content-injector-no-cache=\"\" language=\"{{lng}}\" content-id=\"/web/smb/cms/selfserve/business-phone-dashboard/message-centre/business-message-centre\"></ins></span> <span><ins ute-content-injector-no-cache=\"\" language=\"{{lng}}\" content-id=\"/web/smb/cms/selfserve/business-phone-dashboard/online-manager/business-online-manager\"></ins></span></div><div class=\"container page-wireless tv-package-ctn\"><div class=\"container\"><div class=\"container page-businessphonedashboard businessphone-package-spacing\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-6\"><h2 class=\"widget-loader-mod\" res=\"phone_my_package\"></h2><div class=\"widget-loader tv\" ng-show=\"loadingDataIndicatorBusinessPhoneDashboard && !finalDataReceived\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div ng-show=\"displayContentPhoneDashboard\" class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-3 semi-bold mbl\"><div class=\"widget-loader tv\" ng-show=\"loadingDataIndicatorBusinessPhoneDashboard && !finalDataReceived\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><div class=\"title-h5 semi-bold mbs\" ng-bind-html=\"businessPhoneObj.myBusinessPhonePackageName\"></div></div><div class=\"col-xs-12 semi-bold\" ng-show=\"businessPhoneObj.myBusinessPhonePackageFeatures.length > 0\"><div class=\"title-h5 semi-bold mbs\">{{businessPhoneObj.myBusinessPhonePackageFeatures.length}} <span ng-show=\"businessPhoneObj.myBusinessPhonePackageFeatures.length > 1\" res=\"phone_features_included\"></span> <span ng-show=\"businessPhoneObj.myBusinessPhonePackageFeatures.length == 1\" res=\"phone_feature_included\"></span></div></div><div class=\"col-xs-12 semi-bold mbl\"><div class=\"title-h5 semi-bold mbs\" ng-repeat=\"businessPhoneFeature in businessPhoneObj.myBusinessPhonePackageFeatures track by $index\"><span ng-bind-html=\"businessPhoneFeature\"></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-5 col-lg-3 tv-package\" data-ng-show=\"isDealer || isCare\"><message-info-box info-message=\"changeTVPackageMessage\"></message-info-box></div></div></div><div class=\"container my-digital-box\" ng-show=\"businessPhoneObj.myBusinessPhoneAddons.length > 0\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 redHeadline\"><h2 class=\"widget-loader-mod\" res=\"phone_add_ons\"></h2><div class=\"widget-loader tv\" ng-show=\"loadingDataIndicatorBusinessPhoneDashboard && !finalDataReceived\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"container\" ng-show=\"errorMessage\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div ng-show=\"displayContentPhoneDashboard\" class=\"row mbl\"><div class=\"title-h5 semi-bold mbs\" ng-repeat=\"businessAddon in businessPhoneObj.myBusinessPhoneAddons\"><span ng-bind-html=\"businessAddon\"></span></div></div></div></div></div><div class=\"row ptm\"></div><div ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"selectedAccount.accountNumber\" name=\"selectedAccountNumber\"><br><input type=\"text\" data-ng-model=\"selectedFlow\" name=\"flowType\"><br><button ng-click=\"postToRogers(0)\">Add/Change themes</button> <button ng-click=\"postToRogers(1)\">change package</button></form><form name=\"formToRogersBottom\" id=\"formToRogersBottom\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"selectedAccount.accountNumber\" name=\"acctNum\"><br></form></div></div></section>");
$templateCache.put("scripts/modules/changePayMethod/changePayMethod.html","<change-payment-method data-method-of-payment=\"mop\" data-is-cable=\"isCable\" data-method-of-payment-code=\"mopCode\" data-contact-id=\"selectedAccContactId\" data-account-no=\"selectedAccNum\" data-nick-name=\"name\" data-lang=\"lang\" data-lob=\"selectedAccLOB\"></change-payment-method>");
$templateCache.put("scripts/modules/changePayMethod/changePaymentMethod.html","<section class=\"container changePaymentMethod\" ng-controller=\"changePaymentMethodController\"><div class=\"hidden-xs hidden-sm loadingIndEn\" ng-show=\"loadingIndicator\"><img src=\"images/widget-loader-lg.gif\"></div><div class=\"hidden-md hidden-lg loadingIndEn\" ng-show=\"loadingIndicator\"><img src=\"images/widget-loader-lg_plain.gif\"></div><div><div ng-show=\"!showChangePaymentMethodSection && !loadingIndicator\"><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h1 class=\"changePayment\" res=\"bss_paymentMethodChange_changeMonthlyPaymentOption\"></h1></section><div class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 accountDetails\"><section class=\"col-lg-5 col-md-5 col-xs-10 col-sm-10\"><p class=\"label\" res=\"bss_paymentMethodChange_Account\"></p><section class=\"storeInfo\"><span class=\"storeName\" ng-show=\"nickName\">{{nickName}}</span><span class=\"number\">{{accountNo}}</span></section></section><section class=\"col-lg-7 col-md-7 col-xs-10 col-sm-10\"><p class=\"label\" res=\"bss_paymentMethodChange_currentPaymentMethod\"></p><section class=\"currentMethod\">{{methodOfPayment}}</section></section></div><section class=\"selectPaymentMethod\"><section ng-show=\"!isCable\" class=\"col-lg-12 col-md-12 selectPaymentTitle\" style=\"padding-bottom:10px;\" res=\"bss_paymentMethodChange_selectPaymentMethod\"></section><ul ng-show=\"!isCable\" class=\"nav nav-tabs col-lg-9 col-md-9 hidden-xs hidden-sm\" style=\"padding-right:0px;\"><li class=\"tab col-lg-{{paymentMethods[0].size}} col-md-{{paymentMethods[0].size}} active\"><a style=\"margin-right:10px\" href=\"\" ng-click=\"showBankingSection(paymentMethods[0].name);\" ng-class=\"{borderRedFirst:paymentMethods[0].isActive, borderRedSecond:!paymentMethods[0].isActive}\" res=\"bss_paymentMethodChange_chequingAccount\" atm=\"BillingandPayment_changemethodofpayment_checking\"></a></li><li class=\"tab col-lg-{{paymentMethods[1].size}} col-md-{{paymentMethods[1].size}} active\"><a style=\"margin-right:10px\" href=\"\" ng-click=\"showBankingSection(paymentMethods[1].name);\" ng-class=\"{borderRedFirst:paymentMethods[1].isActive, borderRedSecond:!paymentMethods[1].isActive}\" res=\"bss_paymentMethodChange_preAuthorizedCredit\" atm=\"BillingandPayment_changemethodofpayment_creditcard\"></a></li><li class=\"tab col-lg-{{paymentMethods[2].size}} col-md-{{paymentMethods[2].size}} active\"><a href=\"\" ng-click=\"showBankingSection(paymentMethods[2].name);\" ng-class=\"{borderRedFirst:paymentMethods[2].isActive, borderRedSecond:!paymentMethods[2].isActive}\" res=\"bss_paymentMethodChange_invoice\" atm=\"BillingandPayment_changemethodofpayment_invoice\"></a></li></ul><ul class=\"row hidden-lg hidden-md paymentMethodRadioButtonsList\" ng-show=\"!isCable\"><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" ng-show=\"!thirdRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(paymentMethods[0].name);\" ng-enter=\"showBankingSection(paymentMethods[0].name);\" tabindex=\"0\"><img ng-show=\"thirdRadio\" src=\"images/activeRadio.png\" ng-class=\"{customizedRadioButtonColor:thirdRadio}\" tabindex=\"0\"><span res=\"bss_paymentMethodChange_chequingAccount\"></span></li><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" ng-show=\"!fourthRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(paymentMethods[1].name);\" tabindex=\"0\" ng-enter=\"showBankingSection(paymentMethods[1].name);\"><img ng-show=\"fourthRadio\" src=\"images/activeRadio.png\" ng-class=\"{customizedRadioButtonColor:fourthRadio}\" tabindex=\"0\"><span res=\"bss_paymentMethodChange_preAuthorizedCredit\"></span></li><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" ng-show=\"!fifthRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(paymentMethods[2].name);\" tabindex=\"0\" ng-enter=\"showBankingSection(paymentMethods[2].name);\"><img ng-show=\"fifthRadio\" src=\"images/activeRadio.png\" ng-class=\"{customizedRadioButtonColor:fifthRadio}\" tabindex=\"0\"><span res=\"bss_paymentMethodChange_invoice\"></span></li></ul><section class=\"chequing col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"paymentMethods[0].isActive && !isCable\" ng-form=\"chequingForm\"><div class=\"row labelMargin2\"><p class=\"hidden-sm hidden-xs col-md-12 col-lg-12 headLine\" res=\"bss_paymentMethodChange_preAuthorizedDebit\"></p><p class=\"hidden-xs hidden-sm inline col-lg-9\" res=\"bss_paymentMethodChange_preAuthorizedDebitInformation\"></p></div><div class=\"row labelMargin codesSection\"><div class=\"col-xs-6 col-sm-6 col-md-2 col-lg-2 transitCodeField\"><span res=\"bss_paymentMethodChange_transitCode\"></span> <input type=\"text\" ng-model=\"transitCode\" name=\"transitCode\" class=\"form-control\" required=\"\" ng-class=\"{redBorder:isValidTransitCode}\" ng-keyup=\"validateTransitCode()\" maxlength=\"5\"><div class=\"col-xs-12 col-sm-12 col-lg-12 col-md-12\" ng-show=\"isValidTransitCode\"><span class=\"styled-select-type beside-checker-changePayment icon-error\" ng-show=\"isValidTransitCode\"></span><div class=\"inline_error\" res=\"bss_invalid_transit_code\"></div></div></div><div class=\"col-xs-8 col-sm-8 col-md-2 col-lg-2 bankCodeField\"><span res=\"bss_paymentMethodChange_bankCode\"></span><input type=\"text\" ng-model=\"bankCode\" name=\"bankCode\" class=\"form-control\" ng-class=\"{redBorder:isValidBankCode}\" required=\"\" ng-keyup=\"validateBankCode()\" maxlength=\"3\"><div class=\"col-xs-12 col-sm-12 col-lg-12 col-md-12\" ng-show=\"isValidBankCode\"><span class=\"styled-select-type beside-checker-changePayment icon-error\" ng-show=\"isValidBankCode\"></span><div class=\"inline_error\" res=\"bss_invalid_bank_code\"></div></div></div><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-5 accountNumberField\"><span res=\"bss_paymentMethodChange_accountNumber\"></span><input type=\"text\" ng-model=\"accountNumber\" name=\"accountNumber\" class=\"form-control\" ng-class=\"{redBorder:isValidAccountNumber}\" required=\"\" ng-keyup=\"validateAccountNumber()\" maxlength=\"12\" numbers-only=\"\"><div class=\"col-xs-12 col-sm-12 col-lg-12 col-md-12\" ng-show=\"isValidAccountNumber\"><span class=\"styled-select-type beside-checker-changePayment icon-error\" ng-show=\"isValidAccountNumber\"></span><div class=\"inline_error\" res=\"bss_invalid_acc_number\"></div></div></div></div><div class=\"row voidCheque labelMargin\"><img src=\"images/VoidCheque.png\" class=\"hidden-xs hidden-sm col-md-9 col-lg-9 voidChequeImage\"> <img src=\"images/voidChequeSmallImage.png\" class=\"col-xs-11 col-sm-11 hidden-lg hidden-md voidChequeImage\"></div><div class=\"row voidCheque\"><section class=\"col-lg-11 col-md-11 col-xs-12 col-sm-12\"><section class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 bankCodeSection\"><span class=\"col-md-offset-2 col-md-10 col-xs-12 col-sm-12\" ng-class=\"{\'col-lg-10 col-lg-offset-2\':lang == \'en\', \'col-lg-11 col-lg-offset-0\':lang == \'fr\'}\" res=\"bss_paymentMethodChange_bankCode\"></span></section><section class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2 transitCodeSection\"><span class=\"col-md-9 col-xs-12 col-sm-10 col-sm-offset-3 col-md-offset-0 col-lg-offset-0 col-xs-offset-2\" ng-class=\"{\'col-lg-9\':lang == \'en\', \'col-lg-10\':lang == \'fr\'}\" res=\"bss_paymentMethodChange_transitCode\"></span></section><section class=\"col-xs-4 col-sm-4 col-md-5 col-lg-5 col-lg-offset-3 col-md-offset-3 col-xs-offset-2 accountNumberSection\"><span class=\"col-lg-5 col-md-5 col-xs-12 col-sm-10 col-sm-offset-4 col-md-offset-0 col-lg-offset-0 col-xs-offset-2\" res=\"bss_paymentMethodChange_accountNumber\"></span></section></section></div><div class=\"row\"><section class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" style=\"max-height:150px;margin:30px 0 10px 0;\" res=\"bss_paymentMethodChange_termsAndConditions\"></section></div><div class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12\" id=\"termsAndConditions\"><section class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" scrollbar=\"\"><p class=\"termsAndConditionsLabel\" res=\"bss_paymentMethodChange_termsAndConditions\"></p><div class=\"ptm pbm black\" res=\"change_method_terms\"></div></section></div><div class=\"row\"><section class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><input type=\"checkbox\" class=\"termsCheckbox\" ng-model=\"termsAndConditions\" name=\"termsAndConditions\" ng-change=\"termsAndConditions?isValid=false:isValid=true;validateTermsAndCondtions();\"> &nbsp;<span res=\"bss_paymentMethodChange_acceptTermsAndConditions\"></span></section></div><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 inline_error\" ng-show=\"isValid\" res=\"bss_invalid_terms_and_conditions\"></section><div class=\"row\"><section class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><p res=\"bss_paymentMethodChange_pleaseNote\"></p></section></div></section><section class=\"preAuthorized\" ng-show=\"paymentMethods[1].isActive\" ng-form=\"creditCardForm\"><section class=\"col-lg-12 col-md-12 hidden-xs hidden-sm labelMargin2\"><p class=\"headLine\" res=\"bss_paymentMethodChange_creditCardInformation1\"></p><p class=\"inline col-lg-9 col-md-9\" res=\"bss_paymentMethodChange_creditCardInformation2\"></p></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" style=\"padding-right:0px\"><section class=\"col-lg-6 col-md-5 col-sm-12 col-xs-12\" style=\"padding-right:0px\"><form-credit-card></form-credit-card></section></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 inline_error\" ng-show=\"isValidCreditCardNumber\" id=\"cardNumberErrorSection\" res=\"bss_invalid_cc_number\"></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 inline_error\" ng-show=\"isValidCreditCardScheme\" id=\"cardSchemeErrorSection\" res=\"bss_invalid_cc_type\"></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 labelMargin\"><span res=\"bss_paymentMethodChange_expirationDate\"></span><span class=\"mandatory hidden-xs hidden-sm\">*</span></section><div class=\"col-lg-6 col-md-6 col-xs-12 col-sm-12\"><div class=\"focusBorder styled-month-select select-month col-lg-4 col-md-4 col-sm-4 col-xs-4\" ng-class=\"{redBorder:isValidMonth}\"><select name=\"monthName\" class=\"\" ng-required=\"false\" ng-model=\"selectedMonth\" ng-init=\"selectedMonth = $scope.months[0]\" ng-change=\"changeMonth(selectedMonth)\"><option value=\"\" class=\"\" disabled=\"true\" ng-selected=\"true\" res=\"bss_month\"></option><option ng-repeat=\"month in months\">{{month.value}}</option></select></div><div class=\"focusBorder styled-year-select select-year col-lg-5 col-md-5 col-sm-5 col-xs-5\" ng-class=\"{redBorder:isValidYear}\"><select name=\"yearValue\" class=\"\" required=\"\" ng-model=\"selectedYear\" ng-init=\"selectedYear = $scope.years[0]\" ng-change=\"changeYear(selectedYear)\"><option value=\"\" class=\"\" disabled=\"true\" ng-selected=\"true\" res=\"bss_year\"></option><option ng-repeat=\"year in years\">{{year}}</option></select></div></div><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><section class=\"inline_error col-lg-7 col-md-7 col-sm-12 col-xs-12\" ng-show=\"isValidMonth || isValidYear\" res=\"bss_invalid_cc_ex_date\"></section></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 labelMargin\"><span res=\"bss_paymentMethodChange_securityCode\"></span><span class=\"mandatory hidden-xs hidden-sm\">*</span></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 securityCode\" style=\"padding-right: 7px;\"><section class=\"col-lg-2 col-md-2 col-sm-4 col-xs-5\" style=\"margin-right:15px;\"><input type=\"text\" maxlength=\"4\" class=\"form-control\" numbers-only=\"\" ng-keydown=\"validateSecurityCode()\" ng-model=\"securityCode\" placeholder=\"XXXX\" name=\"securityCode\" required=\"\" ng-class=\"{redBorder:isValidSecurityCode}\"></section><section class=\"col-lg-9 col-md-9 hidden-xs hidden-sm styleForDesktop\"><span class=\"popoverContent contentDesktopView\"><span><img id=\"cvvHelp\" src=\"images/informationIcon.png\"></span></span></section><div class=\"popoverContentDesktop\" style=\"display: none;\"><div class=\"col-lg-12\" style=\"padding-right:0px; margin-bottom:10px;cursor:pointer;\"><img class=\"popoverClose\" style=\"float:right;margin:0\" src=\"images/closeSecurityCode.png\"></div><div class=\"col-lg-12\" style=\"padding-right:0;\"><div class=\"col-lg-5\"><img src=\"images/securityCode.png\" style=\"max-width:100%\"></div><div class=\"col-lg-7\" style=\"padding-right:35px;text-align:justify;padding-left:5px;\" res=\"bss_makePayment_securityCodeDetail\"></div></div></div><div class=\"popoverContentMobile\" style=\"display: none;\"><div class=\"col-xs-12 col-sm-12\" style=\"padding-right:0px; margin-bottom:20px;cursor:pointer;\"><img class=\"popoverClose\" style=\"float:right;margin:0\" src=\"images/closeSecurityCode.png\"></div><div class=\"col-xs-12 col-sm-12\" style=\"padding-right:26px;padding-bottom:35px;text-align:justify;padding-left:5px;\" res=\"bss_makePayment_securityCodeDetail\"></div><div class=\"col-xs-12 col-sm-12\"><img src=\"images/securityCode.png\" style=\"max-width:100%\"></div></div><section class=\"hidden-lg hidden-md col-sm-3 col-xs-3 popOverStyle\" style=\"padding-right:0\"><span class=\"popoverContent contentSmallDevices\"><span><img id=\"cvvHelpSmallDevices\" src=\"images/informationIcon.png\"></span></span></section></section><section class=\"row\" ng-show=\"isValidSecurityCode\"><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 inline_error\" res=\"bss_invalid_ccv_value\"></section></section><div class=\"row\"><span style=\"font-size:14px;\"><ins ute-content-injector-no-cache=\"\" language=\"{{lang}}\" content-id=\"/web/smb/cms/selfserve/creditcard-correspondence/creditcard-correspondence\"></ins></span></div></section><section class=\"invoice col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"paymentMethods[2].isActive && !isCable\"><div class=\"row labelMargin2\"><p class=\"hidden-xs hidden-sm col-md-12 col-lg-12 headLine\" res=\"bss_paymentMethodChange_monthByMonthInformation1\"></p><p class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 inline\"><span res=\"invoice_intro_content_part_1\"></span><span res=\"invoice_intro_content_part_2\"></span><span res=\"invoice_intro_content_part_3\"></span> <span res=\"invoice_intro_content_part_4\"></span><span res=\"invoice_intro_content_part_5\"></span></p></div><div class=\"row\"><p class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 howToPay labelMargin2\" res=\"bss_paymentMethodChange_monthByMonthInformation3\"></p><ul class=\"waysToPayList col-xs-12 col-sm-12 col-md-9 col-lg-9 labelMargin2\"><li class=\"row\"><span class=\"col-md-1 col-lg-1 col-xs-1 col-sm-1 bulletSpan\"><img class=\"hidden-xs hidden-sm\" src=\"images/1.png\" height=\"22\" width=\"22\"></span><span class=\"col-md-11 col-lg-11 hidden-xs hidden-sm\" res=\"invoice_bill_options_list_online_part_desktop\"></span><span class=\"hidden-lg hidden-md col-xs-11 col-sm-11\" res=\"invoice_bill_options_list_online_part_mobile\"></span></li><li class=\"row\"><span class=\"col-md-1 col-lg-1 col-xs-1 col-sm-1 bulletSpan\"><img class=\"hidden-xs hidden-sm\" src=\"images/2.png\" height=\"22\" width=\"22\"></span><span class=\"col-md-11 col-lg-11 hidden-xs hidden-sm\" res=\"invoice_bill_options_list_store_part_desktop\"></span><span class=\"hidden-lg hidden-md col-xs-11 col-sm-11\" res=\"invoice_bill_options_list_store_part_mobile\"></span></li><li class=\"row\"><span class=\"col-md-1 col-lg-1 col-xs-1 col-sm-1 bulletSpan\"><img class=\"hidden-xs hidden-sm\" src=\"images/3.png\" height=\"22\" width=\"22\"></span><span class=\"col-md-11 col-lg-11 col-xs-11 col-sm-11\" res=\"invoice_bill_options_list_internet_telephone_banking\"></span></li><li class=\"row\"><span class=\"col-md-1 col-lg-1 col-xs-1 col-sm-1 bulletSpan\"><img class=\"hidden-xs hidden-sm\" src=\"images/4.png\" height=\"22\" width=\"22\"></span> <span class=\"col-md-11 col-lg-11 hidden-xs hidden-sm\" res=\"invoice_bill_options_list_mail_desktop\"></span><p res=\"invoice_address_companyName\"></p><p res=\"invoice_address_post_office_box_no\"></p><p res=\"invoice_address_street\"></p><p res=\"invoice_address_pincode\"></p><span class=\"col-xs-11 col-sm-11 hidden-lg hidden-md\" res=\"invoice_bill_options_list_mail_mobile\"></span></li></ul></div></section><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\"><section ng-class=\"{\'col-lg-3 col-md-3\':lang == \'en\', \'col-lg-4 col-md-4\':lang == \'fr\'}\" ng-show=\"paymentMethods[0].isActive || paymentMethods[1].isActive || (paymentMethods[2].isActive && methodOfPaymentCode!=\'R\')\"><button type=\"button\" class=\"continueReview\" ng-click=\"validateAndSubmitForm()\" res=\"bss_paymentMethodChange_updatePaymentMethod\">&nbsp;<img src=\"images/lock.png\" height=\"10\" width=\"8\"></button></section><section class=\"col-lg-2 col-md-2 cancel\" style=\"cursor: pointer;\"><a ng-click=\"redirectToLegacyPayment()\" res=\"bss_paymentMethodChange_cancel\"></a></section></div></section></div><div class=\"reviewAndConfirmation\" ng-show=\"showUpdatedPayment\"><section class=\"row\"><h1 class=\"changePayment\" res=\"bss_paymentMethodChange_changeMonthlyPaymentOption\"></h1></section><section class=\"row\"><section class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 thankYou\" style=\"margin-bottom:3rem;\"><section class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1\" style=\"padding-right:0px;\"><img src=\"images/Check.png\" class=\"checkImage\"></section><section class=\"col-lg-11 col-md-11 col-sm-10 col-xs-10\" style=\"margin-top:10px;\"><p class=\"inline\" res=\"bss_paymentMethodChange_sucess1\"></p><p class=\"inline\" res=\"bss_paymentMethodChange_sucess2\"></p></section></section></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_paymentMethodChange_Account\"></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\">{{nickName}}&nbsp;<span style=\"font-weight:400\">{{ACCOUNT.ACCOUNTNO}}</span></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_paymentMethodChange_newPaymentMethod\"></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\"><p>{{updatedPaymentMethod}}</p><p><img src=\"{{cardUrl}}\" ng-show=\"showCardImage\">{{cardNumber}}</p></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_paymentMethodChange_date\"></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\">{{requiredMonth}}&nbsp;{{requiredDate}}</section><section class=\"row\"><section class=\"col-lg-7 col-md-7 col-sm-8 col-xs-8 content\"><p res=\"bss_paymentMethodChange_instructionalCopy\"></p></section></section><section class=\"row col-xs-12 col-sm-12 col-md-12 col-lg-12\" style=\"margin-bottom:2rem;\"><section class=\"col-lg-3 col-md-3 col-xs-12 col-sm-12\"><a href=\"#/accountOverview\" style=\"cursor: pointer;font-size: 18px;\" class=\"cancel\" res=\"bss_paymentMethodChange_accountsOverviewLink\"><img class=\"arrow\" src=\"images/forwardArrow.png\"></a></section><section class=\"col-lg-6 col-md-6 col-xs-12 col-sm-10\"><a ng-click=\"redirectToLegacyPayment()\" style=\"cursor: pointer;font-size: 18px;\" class=\"cancel\" res=\"bss_paymentMethodChange_billingAndReportingLink\"><img src=\"images/forwardArrow.png\" class=\"arrow\"></a></section></section></div></div><div class=\"changePaymentMethodError\" ng-show=\"showChangePaymentMethodErrorSection\"><div class=\"\"><section class=\"row\"><section class=\"col-lg-12 col-md-12 col-sm-8 col-xs-11\"><h1 class=\"paymentError\">Change Payment Method Option</h1></section></section><section class=\"row\"><section class=\"col-lg-8 col-md-8 col-sm-8 col-xs-11 error\"><section style=\"margin-top:13px;padding-left:15px;\" class=\"col-lg-8 col-md-8\"><p class=\"inline\">Currently system unavailable. Please try again.</p></section></section></section><section class=\"row\"><section style=\"cursor: pointer;\" class=\"col-lg-2 col-md-2 cancel\"><a href=\"#/accountOverview\">Cancel</a></section></section></div></div></section>");
$templateCache.put("scripts/modules/changePaymentMethod/changePaymentMethod.html","<div class=\"page-change-method\" data-ng-controller=\"MyrChangePaymentMethodController\" ng-cloak=\"\"><div class=\"page-account-overview\" data-ng-include=\"\'scripts/modules/paymentTopBar/paymentTopBar.html\'\"></div><div class=\"container plm\"><div class=\"row rel\" data-ng-hide=\"!isPreAuthorized\"><div class=\"visible-xs visible-sm col-xs-12 col-sm-12 col-md-0 col-lg-0\"><div class=\"radius\"><div class=\"did-you-know-ctn\" style=\"width:360px;\"><span class=\"did-you-know-title\" res=\"shm_promo_title\"></span> <span class=\"did-you-know-promo-txt\" res=\"change_method_intro\"></span></div></div></div><div class=\"visible-md visible-lg col-xs-12 col-sm-12 col-md-12 col-lg-12 rel\"><div class=\"pin-tr radius mtl\"><div class=\"did-you-know-ctn\" style=\"width:360px;margin-top:50px;\"><span class=\"did-you-know-title\" res=\"shm_promo_title\"></span> <span class=\"did-you-know-promo-txt\" res=\"change_method_intro\"></span></div></div></div></div><div class=\"row\"><div class=\"ptm primary-color pbs title-light-h2\" res=\"change_method\"></div><div class=\"styled-select change-method-select\"><select name=\"paymentMethod\" required=\"\" data-ng-model=\"selectedMethodObj\" data-ng-change=\"changeMethod(selectedMethodObj)\" ng-options=\"value.resKey for (key, value) in paymentMethods\"></select></div></div><form id=\"form\" name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-9 col-md-9 cc-btn-ctn\"><div data-ng-show=\"selectedMethod ===0\"><div data-ng-hide=\"changeInvoiceMethod\"><h3 class=\"black\" res=\"change_method_ways\"></h3><ul class=\"ptl pbl headline6 invoice-intro\"><li><span res=\"online\"></span></li><li><span res=\"change_method_stores\"></span></li><li><span res=\"change_method_app\"></span></li><li><span res=\"change_method_banks\"></span></li><li><span res=\"change_method_mail\"></span></li></ul></div><div data-ng-show=\"changeInvoiceMethod\"><div><h3 class=\"black\" res=\"change_method_invoice\"></h3><div class=\"ptm pbm\"><span res=\"change_method_invoice_info\"></span></div></div><div class=\"ptm pbm\"><span class=\"rui-icon-icontalk primary-color title-light-h3\"></span> <a name=\"chatLink\" target=\"_blank\" ng-href=\"{{chatLink}}\"><span class=\"inline-block plm\" res=\"mu_chat\"></span></a></div></div></div><div><form-chequing></form-chequing></div><div id=\"formCreditCard\"><form-credit-card></form-credit-card></div></div></div><div class=\"ptm\" data-ng-hide=\"changeInvoiceMethod\"><span class=\"inline-block pbl title-note\" res=\"change_method_note\"></span></div><div class=\"row pbl\" data-ng-hide=\"selectedMethod === 0\"><div class=\"col-xs-12 col-sm-12 col-lg-7 col-md-7 cc-btn-ctn\"><div class=\"pts pull-left cc-cancel-btn-ctn pointer\"><a name=\"cancel\" data-ng-click=\"cancel()\" res=\"_cancel\"></a></div><div class=\"pull-right\"><button name=\"submit\" class=\"cta-round primary medium change-method-update\" tabindex=\"9\" data-ng-click=\"submit()\" ng-class=\"{disabled: isChanging, \'\': !isChanging}\"><span res=\"change_method_update\"></span></button> <span class=\"widget-loader-inline\" ng-show=\"isChanging\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></div></div></div></form></div></div><payment-helper></payment-helper>");
$templateCache.put("scripts/modules/completeProfile/completeProfile.html","<div class=\"page-complete-profile\"><div class=\"container\"><form name=\"form\" class=\"profile-form\" novalidate=\"\" label=\"Complete Profile - Security Question\" id=\"completeProfileForm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 profile-title\"><span res=\"_security_questions\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 mtm\"><div class=\"row info-banner error mts mbm\" data-ng-show=\"isError\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><span class=\"plm\" ng-bind-html=\"errorDescription\"></span></div></div><div class=\"row info-banner-complete-profile error mts mbm\" data-ng-show=\"(form.$valid == false && form.$submitted)\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><p class=\"plm\" res=\"_check_form_errors\"></p></div></div></div></div><div class=\"row mbm\"><div class=\"col-md-6\"><div class=\"inline_error\" ng-messages=\"form.question.$error\" ng-show=\"form.question.$invalid && (form.question.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"_require_security_question\"></span></span></div><div class=\"profile-select-wide\"><select name=\"question\" data-ng-model=\"questionId\" required=\"\" ng-options=\"key as value for (key, value) in questions\"><option res=\"_security_questions\"></option></select></div><span class=\"beside-checker icon-error drop-down\" data-ng-show=\"form.question.$invalid && (form.question.$dirty || form.$submitted)\"></span> <span ng-show=\"form.question.$dirty && form.question.$valid\" class=\"beside-checker icon-checked\"></span></div></div><div class=\"row mbm\"><div class=\"col-md-6\"><div class=\"inline_error\" ng-messages=\"form.answer.$error\" ng-show=\"form.answer.$invalid && (form.answer.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"_require_security_answer\"></span></span></div><label class=\"rel\"><input type=\"text\" name=\"answer\" tag-form-name=\"form\" tag-page-name=\"Registration\" res-attr=\"{placeholder: \'_answer\'}\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-maxlength=\"105\" data-ng-model=\"answer\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.answer.$invalid && (form.answer.$dirty || form.$submitted)\"></span> <span ng-show=\"form.answer.$dirty && form.answer.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"pull-right\" ng-show=\"loadingDataIndicator\"><span class=\"widget-loader-inline\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></div><div class=\"pull-right\"><button name=\"button_continue\" ng-disabled=\"loadingDataIndicator\" data-ng-click=\"submit()\" class=\"cta-round primary medium full\"><span res=\"_continue\"></span></button></div></div></div></form></div></div>");
$templateCache.put("scripts/modules/eSIMCard_PhysicalSim/eSIMChange.html","<div class=\"container ng-scope\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text ng-binding\">{{ctnNumber | phone2}}</div></div></div><div class=\"esimcontainer ng-scope\" style=\"margin-top: -40px;\"><div class=\"row\"><div class=\"hidden-xs hidden-sm col-md-6 col-lg-6\"><div class=\"eSimCard-headingGroup\"><div class=\"eSimCard-heading ng-scope\" res=\"change_eSim_title\"></div></div><div class=\"eSimCard-typeBodyGroup\"><div class=\"eSimCard-typeBody ng-scope\" res=\"change_eSim_details\"></div></div><form name=\"simCardForm\"><div class=\"eSimCard-inputGroup\"><div><div><span class=\"eSimCard-TextLabel ng-scope\" res=\"eSim_textlabel\"></span></div><span class=\"eSim-textdetails\" res=\"eSim_textlabel_details\"></span></div><div class=\"eSimCard-inputbutton\"><button class=\"eSimCard-continueButton\" ng-click=\"changeEsimpage()\"><span class=\"eSimcard-buttonlabel\" res=\"eSim_buttonlabel\"></span><ds-icon class=\"-size-24\" name=\"chevron-down\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-chevron-right\"></span></ds-icon></button></div></div></form></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12\"><div class=\"eSimCard-headingGroup\"><div class=\"eSimCard-heading ng-scope\" res=\"change_eSim_title\"></div></div><div class=\"eSimCard-typeBodyGroup\"><div class=\"eSimCard-typeBody ng-scope\" res=\"change_eSim_details\"></div></div><form name=\"simCardForm\"><div class=\"eSimCard-inputGroup\"><div><div><span class=\"eSimCard-TextLabel ng-scope\" res=\"eSim_textlabel\"></span></div><span class=\"eSim-textdetails\" res=\"eSim_textlabel_details\"></span></div><div class=\"eSimCard-inputbutton\"><button class=\"eSimCard-continueButton\" ng-click=\"changeEsimpage()\"><span class=\"eSimcard-buttonlabel\" res=\"eSim_buttonlabel\"></span><ds-icon class=\"-size-24\" name=\"chevron-down\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-chevron-right\"></span></ds-icon></button></div></div></form></div><div class=\"physicalSim-heading hidden-xs hidden-sm col-md-6 col-lg-6 ng-scope\"><div class=\"physicalSim-typeBodyGroup ng-scope\"><div class=\"physicalSim-inputCollection\"><div style=\"margin-left: 16px;\"><div class=\"physicalSim-inputTextLabel\"><span class=\"physicalSim-TextLabel ng-scope\" res=\"physicalSim_textlabel\"></span></div><span class=\"physicalSim-textdetails\" res=\"physicalSim_textdetails\"></span></div><div class=\"physicalSim-inputbutton\"><button class=\"physicalSim-continueButton\" ng-click=\"postToRogersSim()\"><span class=\"physicalSim-buttonlabel\" res=\"physicalSim_buttonlabel\"></span><ds-icon class=\"-size-24\" name=\"chevron-down\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-chevron-right\"></span></ds-icon></button></div></div></div></div><div class=\"physicalSim-heading hidden-lg hidden-md col-sm-12 col-xs-12 pull-left ng-scope\"><div class=\"physicalSim-typeBodyGroup ng-scope\"><div class=\"physicalSim-inputCollection\"><div style=\"margin-left: 16px;\"><div class=\"physicalSim-inputTextLabel\"><span class=\"physicalSim-TextLabel ng-scope\" res=\"physicalSim_textlabel\"></span></div><span class=\"physicalSim-textdetails\" res=\"physicalSim_textdetails\"></span></div><div class=\"physicalSim-inputbutton\"><button class=\"physicalSim-continueButton\" ng-click=\"postToRogersSim()\"><span class=\"physicalSim-buttonlabel\" res=\"physicalSim_buttonlabel\"></span><ds-icon class=\"-size-24\" name=\"chevron-down\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-chevron-right\"></span></ds-icon></button></div><div class=\"physicalSim-end\"></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/eSimCardChange/eSimCard.html","<div class=\"container ng-scope\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text ng-binding\">{{ctnNumber | phone2}}</div></div></div><div class=\"esimcard-container ng-scope\"><div class=\"esim-warningbody\"><div class=\"esim-warningborder\"><span><img class=\"esim-warningimg\" ng-src=\"images/warningIcon.png\"> <span class=\"esim-warningheader\" res=\"warning_header\"></span></span><div class=\"esim-warningdetails\" res=\"warning_details\"></div></div></div><div class=\"row\"><div class=\"hidden-xs hidden-sm col-md-6 col-lg-6\"><div class=\"simChange-headingGroup\"><div class=\"simChange-heading\" res=\"eSimcard_title\"></div></div><div class=\"\"><div class=\"simChange-headingdetails\" res=\"eSimcard_titleone_details\"></div><div class=\"simChange-seconddetails\" res=\"eSimcard_titletwo_details\"></div></div><div class=\"simChange-inputCollection\"><div class=\"simChange-inputGroup\"><div class=\"simChange-checkbox-details\"><span class=\"ute-icon-error-icon ng-hide\" data-ng-show=\"simCardForm.currentSim.$invalid &amp;amp;simCardForm.$submitted\"></span> <input type=\"checkbox\" class=\"termsCheckbox\" ng-model=\"successfullcheckbox\" name=\"successfullcheckbox\" ng-change=\"validatesuccessfullcheckbox();\">&nbsp; <span class=\"simChange-checkboxtwo ng-scope\" res=\"eSimcard_checkboxtwo_details\"></span></div><div ng-show=\"showcheckboxError === false\" class=\"ute-icon-error-icon checkboxerror\" res=\"eSimcard_checkboxerror\"></div></div></div><div class=\"esimchange-buttons\"><div class=\"row\"><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3\"><button class=\"simChange-backdetails\" ng-click=\"getbackWireless()\" type=\"button\"><span class=\"simChange-backbutton\" res=\"eSimcard_backbutton_details\"></span></button></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3\"><button class=\"simchange-confirmdetails\" ng-click=\"changeSwapsimpage()\" type=\"button\"><span class=\"simChange-confirmbutton ng-scope\" res=\"eSimcard_confirmbutton_details\"></span></button></div></div></div></div><div class=\"hidden-xs hidden-sm col-md-6 col-lg-6 pull-right ng-scope\"><div class=\"simChange-qrtypeBodyGroup ng-scope\"><div class=\"row\"><div class=\"simChange-qrcode col-xs-12 col-sm-6 col-md-4 col-lg-3\"><div id=\"qrcode\"></div></div></div></div><div ng-show=\"transferLinkhide == true\"><div class=\"eSimtransfer-details\"><div class=\"eSimtransfer-labels\" ng-click=\"transferEsim()\"><span class=\"eSimtransfer-button\" res=\"eSimtransfer_details\"></span> <img class=\"eSimtransfer_buttonimg\" ng-src=\"images/share_icon.png\"></div></div></div><div ng-show=\"brt_transfer_link == \'true\'\"><div class=\"eSimtransfer-details\"><div class=\"eSimtransfer-labels\" ng-click=\"transferEsim()\"><span class=\"eSimtransfer-button\" res=\"eSimtransfer_details\"></span> <img class=\"eSimtransfer_buttonimg\" ng-src=\"images/share_icon.png\"></div></div></div><div><div ng-class=\"lang === \'en\' ? \'qrCode-details\' : \'qrCode-detailsfr\'\"><div ng-class=\"brt_transfer_link === \'true\' ? \'qrcode-labels\' : \'qr-labelsbrt\'\" ng-click=\"shareEsimvalue()\"><span class=\"qrCode-button\" res=\"shareqrcode_details\"></span> <img class=\"qrcode_buttonimg\" ng-src=\"images/share_icon.png\"></div></div></div></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12\"><div class=\"simChange-headingGroup\"><div class=\"simChange-heading\" res=\"eSimcard_title\"></div></div><div class=\"\"><div class=\"simChange-headingdetails\" res=\"eSimcard_titleone_details\"></div><div class=\"simChange-seconddetails\" res=\"eSimcard_titletwo_details\"></div></div><div class=\"simChange-inputCollection\"><div class=\"simChange-inputGroup\"><div class=\"simChange-checkbox-details\"><span class=\"ute-icon-error-icon ng-hide\" data-ng-show=\"simCardForm.currentSim.$invalid &amp;amp;simCardForm.$submitted\"></span> <input type=\"checkbox\" class=\"termsCheckbox\" ng-model=\"successfullcheckbox\" name=\"successfullcheckbox\" ng-change=\"validatesuccessfullcheckbox();\">&nbsp; <span class=\"simChange-checkboxtwo ng-scope\" res=\"eSimcard_checkboxtwo_details\"></span></div><div ng-show=\"showcheckboxError === false\" class=\"ute-icon-error-icon checkboxerror\" res=\"eSimcard_checkboxerror\"></div></div></div><div class=\"esimchange-buttons\"><div class=\"row\"><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12\"><button class=\"simChange-backdetails\" type=\"button\" ng-click=\"getbackWireless()\"><span class=\"simChange-backbutton\" res=\"eSimcard_backbutton_details\"></span></button></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12 esim-activatebutton\"><button class=\"simchange-confirmdetails\" ng-click=\"changeSwapsimpage()\"><span class=\"simChange-confirmbutton ng-scope\" res=\"eSimcard_confirmbutton_details\"></span></button></div></div></div></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12 ng-scope\"><div class=\"simChange-qrtypeBodyGroup ng-scope\"><div class=\"row\"><div class=\"simChange-qrcode col-xs-12 col-sm-6 col-md-4 col-lg-3\"><div style=\"margin-left: -72px;margin-top: 5px;\" id=\"qrcodemobile\"></div></div></div></div><div ng-show=\"transferLinkhide == true\"><div class=\"eSimtransfer-details\"><div class=\"eSimtransfer-labels\" ng-click=\"transferEsim()\"><span class=\"eSimtransfer-button\" res=\"eSimtransfer_details\"></span> <img class=\"eSimtransfer_buttonimg\" ng-src=\"images/share_icon.png\"></div></div></div><div ng-show=\"brt_transfer_link == \'true\'\"><div class=\"eSimtransfer-details\"><div class=\"eSimtransfer-labels\" ng-click=\"transferEsim()\"><span class=\"eSimtransfer-button\" res=\"eSimtransfer_details\"></span> <img class=\"eSimtransfer_buttonimg\" ng-src=\"images/share_icon.png\"></div></div></div><div><div class=\"qrCode-details\"><div ng-class=\"brt_transfer_link === \'true\' ? \'qrcode-labels\' : \'qr-labelsbrt\'\" ng-click=\"shareEsimvalue()\"><span class=\"qrCode-button\" res=\"shareqrcode_details\"></span> <img class=\"qrcode_buttonimg\" ng-src=\"images/share_icon.png\"></div></div></div></div></div></div><div class=\"qr-container ng-scope\"><div class=\"row\"><div class=\"qrCode-detail\"><div class=\"Scanqr-header\" res=\"qr_code_header\"></div></div><div class=\"Qrcode_options\"><div class=\"eSim-qrcode-optionTypes\" res=\"eSim_qrcode_optionsheader\"></div></div><div class=\"Qrcode_optionsone\"><div class=\"eSim-devicetype-iphone\" res=\"eSim_qrcode_optionsone\"></div><div class=\"eSim-devicetype-steps\" res=\"eSim_qrcode_optionsteps\"></div><div class=\"eSim-devicetype-istepone\" res=\"eSim_iphone_optionone\"></div><div class=\"eSim-devicetype-isteptwo\" res=\"eSim_iphone_optionstwo\"></div><div class=\"eSim-devicetype-istepthree\" res=\"eSim_iphone_optionthree\"></div><div class=\"eSim-devicetype-istepfour\" res=\"eSim_iphone_optionfour\"></div><div class=\"eSim-devicetype-istepfive\" res=\"eSim_iphone_optionfive\"></div><div class=\"eSim-devicetype-istepsix\" res=\"eSim_iphone_optionsix\"></div></div><div class=\"Qrcode_optionstwo\"><div class=\"eSim-devicetype-samsung\" res=\"eSim_qrcode_optionstwo\"></div><div class=\"eSim-devicetype-steps\" res=\"eSim_qrcode_optionsteps\"></div><div class=\"eSim-devicetype-samsungsteps\" res=\"eSim_samsung_optionone\"></div><div class=\"eSim-devicetype-samsungsteps\" res=\"eSim_samsung_optiontwo\"></div><div class=\"eSim-devicetype-samsungsteps\" res=\"eSim_samsung_optionthree\"></div><div class=\"eSim-devicetype-samsungsteps\" res=\"eSim_samsung_optionfour\"></div><div class=\"eSim-devicetype-samsungsteps\" res=\"eSim_samsung_optionfive\"></div><div class=\"eSim-devicetype-samsungsteps\" res=\"eSim_samsung_optionsix\"></div><div class=\"eSim-devicetype-samsungsteps\" res=\"eSim_samsung_optionseven\"></div><div class=\"eSim-devicetype-samsungsteps\" res=\"eSim_samsung_optioneight\"></div><div class=\"eSim-devicetype-samsungsteps\" res=\"eSim_samsung_optionnine\"></div></div><div class=\"Qrcode_optionsthree\"><div class=\"eSim-devicetype-google\" res=\"eSim_qrcode_optionsthree\"></div><div class=\"eSim-devicetype-steps\" res=\"eSim_qrcode_optionsteps\"></div><div class=\"eSim-devicetype-googlesteps\" res=\"eSim_google_optionone\"></div><div class=\"eSim-devicetype-googlesteps\" res=\"eSim_google_optiontwo\"></div><div class=\"eSim-devicetype-googlesteps\" res=\"eSim_google_optionthree\"></div><div class=\"eSim-devicetype-googlesteps\" res=\"eSim_google_optionfour\"></div><div class=\"eSim-devicetype-googlesteps\" res=\"eSim_google_optionfive\"></div><div class=\"eSim-devicetype-googlesteps\" res=\"eSim_google_optionsix\"></div></div></div></div>");
$templateCache.put("scripts/modules/eSimEmailModal/eSimemail.html","<div class=\"container ng-scope\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text ng-binding\">{{ctnNumber | phone2}}</div></div></div><div class=\"esim-email-container ng-scope\"><div class=\"row\"><div class=\"hidden-xs hidden-sm col-md-9 col-lg-9\"><div class=\"esim-email-headingGroup\"><div class=\"esim-email-heading ng-scope\" res=\"share_esimheading\"></div></div><div class=\"esim-email-typeBodyGrouplabel\"><div class=\"esim-email-typeBodylabel ng-scope\" res=\"share_esimlabel\"></div></div><div class=\"esim-email-typeBodyGroup\"><div class=\"esim-email-typeBody ng-scope\" res=\"share_esimdetails\"></div></div><form><div class=\"esim-email-inputCollection\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><input class=\"no-inline-checker\" tabindex=\"0\" type=\"text\" id=\"USER\" name=\"USER\" placeholder=\"{{email_placeholder}}\" data-ng-model=\"email\" required=\"\" autocorrect=\"off\" autocapitalize=\"off\"></div></div><div class=\"esim-email-buttonGroup\"><button class=\"esim-email-shareButton\" ng-click=\"geteSimotpdetails()\"><span ng-class=\"lang === \'en\' ? \'esim-email-sharelabel\' : \'esim-email-sharelabelfr\'\" res=\"share_esimbutton\"></span></button> <button class=\"esim-email-cancelButton\" ng-click=\"getbackwirelesspage()\"><span class=\"esim-email-cancellabel ng-scope\" res=\"share_esimcancelbutton\"></span></button></div></form></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12\"><div class=\"esim-email-headingGroup\"><div class=\"esim-email-heading ng-scope\" res=\"share_esimheading\"></div></div><div class=\"esim-email-typeBodyGrouplabel\"><div class=\"esim-email-typeBodylabel ng-scope\" res=\"share_esimlabel\"></div></div><div class=\"esim-email-typeBodyGroup\"><div class=\"esim-email-typeBody ng-scope\" res=\"share_esimdetails\"></div></div><form><div class=\"esim-email-inputCollection\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><input class=\"no-inline-checker\" tabindex=\"0\" type=\"text\" id=\"USER\" name=\"USER\" placeholder=\"{{email_placeholder}}\" data-ng-model=\"email\" required=\"\" autocorrect=\"off\" autocapitalize=\"off\"></div></div><div class=\"esim-email-buttonGroup\"><button class=\"esim-email-shareButton\" ng-click=\"geteSimotpdetails()\"><span ng-class=\"lang === \'en\' ? \'esim-email-sharelabel\' : \'esim-email-sharelabelfr\'\" res=\"share_esimbutton\"></span></button> <button class=\"esim-email-cancelButton\" ng-click=\"getbackwirelesspage()\"><span class=\"esim-email-cancellabel ng-scope\" res=\"share_esimcancelbutton\"></span></button></div></form></div></div></div>");
$templateCache.put("scripts/modules/eSimOtpmodal/eSimOtp.html","<div class=\"container ng-scope\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text ng-binding\">{{ctnNumber | phone2}}</div></div></div><div class=\"esimotp-container ng-scope\"><div class=\"row esimotp-details\"><div class=\"hidden-xs hidden-sm col-md-9 col-lg-9\"><div class=\"esimotp-headingGroup\"><div class=\"esimotp-heading ng-scope\"><span><img style=\"width: 20px;\" class=\"esimotp-warningimg\" ng-src=\"images/green-checkbox.png\"> <span res=\"esim_otpheader\"></span></span></div></div><div class=\"esimotp-typeBodyGroup\"><span class=\"esimotp-typeBody ng-scope\" res=\"esim_emaildetails\"></span> <span class=\"esimotp-typeBody ng-scope\"><b>{{eSimemail}}</b></span></div><div class=\"esimotpdetails-typeBodyGroup\"><div class=\"esimotpdetails-typeBody ng-scope\" res=\"esim_otpdetails\"></div></div><div class=\"esim-randomotp-typeBodyGroup\"><div class=\"esim-randomotp-typeBody ng-scope\">{{randomOtp}}</div></div><form name=\"simCardForm\"><div class=\"esimotp-buttonGroup\"><button class=\"esimotp-okayButton\" ng-click=\"getbackwirelessdashboard()\"><span class=\"esimotp-okayButtonlabel ng-scope\" res=\"esim_otpbutton\"></span></button></div></form></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12\"><div class=\"esimotp-headingGroup\"><div class=\"esimotp-heading ng-scope\"><span><img style=\"width: 20px;\" class=\"esimotp-warningimg\" ng-src=\"images/green-checkbox.png\"> <span res=\"esim_otpheader\"></span></span></div></div><div class=\"esimotp-typeBodyGroup\"><span class=\"esimotp-typeBody ng-scope\" res=\"esim_emaildetails\"></span> <span class=\"esimotp-typeBody ng-scope\"><b>{{eSimemail}}</b></span></div><div class=\"esimotpdetails-typeBodyGroup\"><div class=\"esimotpdetails-typeBody ng-scope\" res=\"esim_otpdetails\"></div></div><div class=\"esim-randomotp-typeBodyGroup\"><div class=\"esim-randomotp-typeBody ng-scope\">{{randomOtp}}</div></div><form name=\"simCardForm\"><div class=\"esimotp-buttonGroup\"><button class=\"esimotp-okayButton\" ng-click=\"getbackwirelessdashboard()\"><span class=\"esimotp-okayButtonlabel ng-scope\" res=\"esim_otpbutton\"></span></button></div></form></div></div></div>");
$templateCache.put("scripts/modules/eSimSuccessmodal/eSimSuccess.html","<div class=\"container ng-scope\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text ng-binding\">{{ctnNumber | phone2}}</div></div></div><div class=\"eSimSuccess-container ng-scope\"><div class=\"row eSimSuccess-details\"><div class=\"hidden-xs hidden-sm col-md-9 col-lg-9\"><div class=\"eSimSuccess-headingGroup\"><div class=\"eSimSuccess-heading ng-scope\"><span><img style=\"width: 20px;\" class=\"eSimSuccess-warningimg\" ng-src=\"images/green-checkbox.png\"> <span res=\"esim_successdetails\"></span><div class=\"eSim-successbody\" res=\"esim_successbodydetails\"></div></span></div></div><form name=\"simCardForm\"><div class=\"eSimSuccess-buttonGroup\"><button class=\"eSimSuccess-okayButton\" ng-click=\"getbackwirelessdashboard()\"><span class=\"eSimSuccess-okayButtonlabel ng-scope\" res=\"esim_successbutton\"></span></button></div></form></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12\"><div class=\"eSimSuccess-headingGroup\"><div class=\"eSimSuccess-heading ng-scope\"><span><img style=\"width: 20px;\" class=\"eSimSuccess-warningimg\" ng-src=\"images/green-checkbox.png\"> <span res=\"esim_successdetails\"></span><div class=\"eSim-successbody\" res=\"esim_successbodydetails\"></div></span></div></div><form name=\"simCardForm\"><div class=\"eSimSuccess-buttonGroup\"><button class=\"eSimSuccess-okayButton\" ng-click=\"getbackwirelessdashboard()\"><span class=\"eSimSuccess-okayButtonlabel ng-scope\" res=\"esim_successbutton\"></span></button></div></form></div></div></div>");
$templateCache.put("scripts/modules/eSimtransfererror/eSimtransfererror.html","<div class=\"container ng-scope\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text ng-binding\">{{ctnNumber | phone2}}</div></div></div><div class=\"eSimtransfererror-container ng-scope\"><div class=\"row eSimtransfererror-details\"><div class=\"hidden-xs hidden-sm col-md-9 col-lg-9\"><div class=\"eSimtransfererror-headingGroup\"><div class=\"eSimtransfererror-heading ng-scope\"><span><img class=\"eSimtransfererror-warningimg\" ng-src=\"images/warningIcon.png\"> <span>{{transferesimerror_details}}</span><div class=\"eSim-successbody\">{{transferesimerrorbody_details}}</div></span></div></div><form name=\"simCardForm\"><div class=\"eSimtransfererror-buttonGroup\"><button class=\"eSimtransfererror-okayButton\" ng-click=\"getbackwirelessdashboard()\"><span class=\"eSimtransfererror-okayButtonlabel ng-scope\" res=\"transferesim_errorbutton\"></span></button></div></form></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12\"><div class=\"eSimtransfererror-headingGroup\"><div class=\"eSimtransfererror-heading ng-scope\"><span><img class=\"eSimtransfererror-warningimg\" ng-src=\"images/warningIcon.png\"> <span>{{transferesimerror_details}}</span><div class=\"eSim-successbody\">{{transferesimerrorbody_details}}</div></span></div></div><form name=\"simCardForm\"><div class=\"eSimtransfererror-buttonGroup\"><button class=\"eSimtransfererror-okayButton\" ng-click=\"getbackwirelessdashboard()\"><span class=\"eSimtransfererror-okayButtonlabel ng-scope\" res=\"transferesim_errorbutton\"></span></button></div></form></div></div></div>");
$templateCache.put("scripts/modules/eSimtransfermodal/eSimtransfer.html","<div class=\"container ng-scope\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text ng-binding\">{{ctnNumber | phone2}}</div></div></div><div class=\"esimtransfer-container ng-scope\"><div class=\"row\"><div class=\"hidden-xs hidden-sm col-md-9 col-lg-9\"><div class=\"esimtransfer-headingGroup\"><div class=\"esimtransfer-heading ng-scope\" res=\"transfer_esimheading\"></div></div><div class=\"esimtransfer-typeBodyGrouplabel\"><div class=\"esimtransfer-typeBodylabel ng-scope\" res=\"transfer_esimdetails\"></div></div><div class=\"esimtransfer-typeBodyGroup\"><div class=\"esimtransfer-typeBody ng-scope\" res=\"transfer_esimlabel\"></div></div><form><div class=\"esimtransfer-inputCollection\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><select class=\"esimtransfer-selectbox\" ng-model=\"devicevalueid\" ng-change=\"deviceValuechange(devicevalueid);\"><option value=\"\">{{transfer_placeholder}}</option><option ng-repeat=\"option in transferdata\" value=\"{{option}}\">{{lang === \'en\' ? option.modelDescriptionEn : option.modelDescriptionFr}}</option></select><ds-icon class=\"esimtransfer-selectboxicon -size-24\" name=\"chevron-down\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-chevron-down\"></span></ds-icon></div></div><div class=\"esimtransfer-buttonGroup\" ng-show=\"devicefieldvalue == true\"><button class=\"esimtransfer-continueButton\" ng-click=\"transfereSimpage()\"><span class=\"esimtransfer-buttonlabel\" res=\"transfereSim_buttonlabel\"></span><ds-icon class=\"-size-24\" name=\"chevron-down\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-chevron-right\"></span></ds-icon></button></div></form></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12\"><div class=\"esimtransfer-headingGroup\"><div class=\"esimtransfer-heading ng-scope\" res=\"share_esimheading\"></div></div><div class=\"esimtransfer-typeBodyGrouplabel\"><div class=\"esimtransfer-typeBodylabel ng-scope\" res=\"share_esimlabel\"></div></div><div class=\"esimtransfer-typeBodyGroup\"><div class=\"esimtransfer-typeBody ng-scope\" res=\"share_esimdetails\"></div></div><form><div class=\"esimtransfer-inputCollection\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><select class=\"esimtransfer-selectbox\" ng-model=\"devicevalueid\" ng-change=\"deviceValuechange(devicevalueid);\"><option value=\"\">{{transfer_placeholder}}</option><option ng-repeat=\"option in transferdata\" value=\"{{option}}\">{{lang === \'en\' ? option.modelDescriptionEn : option.modelDescriptionFr}}</option></select><ds-icon class=\"esimtransfer-selectboxicon -size-24\" name=\"chevron-down\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-chevron-down\"></span></ds-icon></div></div><div class=\"esimtransfer-buttonGroup\" ng-show=\"devicefieldvalue == true\"><button class=\"esimtransfer-continueButton\" ng-click=\"transfereSimpage()\"><span class=\"esimtransfer-buttonlabel\" res=\"transfereSim_buttonlabel\"></span><ds-icon class=\"-size-24\" name=\"chevron-down\"><span aria-hidden=\"true\" class=\"ds-icon rds-icon-chevron-right\"></span></ds-icon></button></div></form></div></div></div>");
$templateCache.put("scripts/modules/eSimtransfersuccess/eSimtransfersucces.html","<div class=\"container ng-scope\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text ng-binding\">{{ctnNumber | phone2}}</div></div></div><div class=\"eSimtransfersuccess-container ng-scope\"><div class=\"row eSimtransfersuccess-details\"><div class=\"hidden-xs hidden-sm col-md-9 col-lg-9\"><div class=\"eSimtransfersuccess-headingGroup\"><div class=\"eSimtransfersuccess-heading ng-scope\"><span><img class=\"eSimtransfersuccess-warningimg\" ng-src=\"images/green-success-checkbox.png\"> <span res=\"transferesim_successdetails\"></span><div class=\"eSim-successbody\" res=\"transferesim_successbodydetails\"></div></span></div></div><form name=\"simCardForm\"><div class=\"eSimtransfersuccess-buttonGroup\"><button class=\"eSimtransfersuccess-okayButton\" ng-click=\"getbackwirelessdashboard()\"><span class=\"eSimtransfersuccess-okayButtonlabel ng-scope\" res=\"transferesim_successbutton\"></span></button></div></form></div><div class=\"hidden-lg hidden-md col-sm-12 col-xs-12\"><div class=\"eSimtransfersuccess-headingGroup\"><div class=\"eSimtransfersuccess-heading ng-scope\"><span><img class=\"eSimtransfersuccess-warningimg\" ng-src=\"images/green-checkbox.png\"> <span res=\"transferesim_successdetails\"></span><div class=\"eSim-successbody\" res=\"transferesim_successbodydetails\"></div></span></div></div><form name=\"simCardForm\"><div class=\"eSimtransfersuccess-buttonGroup\"><button class=\"eSimtransfersuccess-okayButton\" ng-click=\"getbackwirelessdashboard()\"><span class=\"eSimtransfersuccess-okayButtonlabel ng-scope\" res=\"transferesim_successbutton\"></span></button></div></form></div></div></div>");
$templateCache.put("scripts/modules/eas/easError.html","<div class=\"eas-error\"><div class=\"container\"><div><a href=\"/web/smb/bss/#/signin\" class=\"r4b-logo\"><span><img src=\"/cms/common/dca/images/rogers-for-business-desktop-en.png\"></span></a> <a href=\"javascript: void(0)\" class=\"lang-toggle\" ng-click=\"toggleLang();$event.preventDefault()\" id=\"{{langLinkId}}\" res=\"_eas_lang_toggle\"></a></div><div class=\"eas-title\"><ds-icon><span class=\"rui-icon-error\"></span></ds-icon><div res=\"{{errorTitle}}\"></div></div><div class=\"eas-message\" res=\"{{errorMessage}}\"></div><div class=\"eas-btn\"><button type=\"submit\" value=\"submit\" ng-click=\"closeMessage()\" res=\"{{closeBtn}}\"></button></div></div></div>");
$templateCache.put("scripts/modules/eas/easSuccess.html","<div class=\"eas-success\"><div class=\"container\"><div><a href=\"/web/smb/bss/#/signin\" class=\"r4b-logo\"><span><img src=\"/cms/common/dca/images/rogers-for-business-desktop-en.png\"></span></a> <a href=\"javascript: void(0)\" class=\"lang-toggle\" ng-click=\"toggleLang();$event.preventDefault()\" id=\"{{langLinkId}}\" res=\"_eas_lang_toggle\"></a></div><div class=\"eas-title\"><ds-icon><span class=\"rui-icon-circle-solid-check\"></span></ds-icon><div res=\"_eas_password_update_title\"></div></div><div class=\"eas-message\" res=\"_eas_password_update_message\"></div><div class=\"eas-btn\"><button type=\"submit\" value=\"submit\" res=\"_eas_password_update_btn\" ng-click=\"closeMessage()\"></button></div></div></div>");
$templateCache.put("scripts/modules/forgotPassword/forgotPassword.html","<section class=\"page-forgot-password\"><div class=\"container\" ng-show=\"partNo === \'1\'\"><div class=\"row message-margin\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"#/signin\" res=\"_my_rogers_nospace\"></a></li><li class=\"child-1\"><span res=\"forgot_password\"></span></li></ul></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"mbm info-banner error mts\" data-ng-show=\"isError\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1\" style=\"max-width: 40px;\"><img ng-src=\"images/warning.png\" src=\"images/warning.png\"></div><div class=\"col-xs-10 col-sm-10 col-md-11 plm\" style=\"float:left\"><span ng-bind-html=\"errorDescription\"></span></div></div></div><p class=\"forgot-password-desc\" res=\"login_reset_pwd_desc\"></p></div></div><form name=\"form1\" novalidate=\"\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-12\"><div class=\"row\"><div class=\"inline_error\" ng-messages=\"form1.email.$error\" ng-show=\"(form1.email.$dirty || form1.$submitted) && form1.email.$invalid\"><span ng-message=\"required\"><span class=\"message-margin\" res=\"login_forget_pwd_email_invalid\"></span></span> <span ng-message=\"pattern\"><span res=\"_email_address_not_valid\" class=\"prm\"></span></span></div><label class=\"rel\"><input class=\"overrite-margin-bottom\" type=\"text\" name=\"email\" tag-form-name=\"form\" tag-page-name=\"Forget password\" data-ng-model=\"email\" required=\"\" ng-pattern=\"/[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,4}$/i\" ng-model-options=\"{ updateOn: \'blur\' }\" res-attr=\"{ placeholder : \'_email\'}\" autocapitalize=\"off\"> <i ng-show=\"form1.email.$invalid && (form1.email.$dirty || form1.$submitted)\" class=\"inline-checker icon-error\"></i> <span ng-show=\"form1.email.$dirty && form1.email.$valid\" class=\"inline-checker icon-checked\"></span></label></div><div class=\"row form-action-ctn\"><div class=\"cancel-ctn\"><a href=\"#/signin\" class=\"link-cancel link_blue_color\"><span res=\"_cancel\"></span></a></div><span class=\"widget-loader-inline\" data-ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></span><div class=\"btn-continue-ctn\"><button name=\"button_continue\" data-ng-disabled=\"loadingDataIndicator\" class=\"cta-round primary medium full btn-continue\" data-ng-click=\"submit()\"><span class=\"overrite-span\" res=\"_continue\"></span></button></div></div></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-12\"><div id=\"forgotPasswordBoldChat_div\"><need-help data-cbid=\"boldChatButtonId\" dynamic-div=\"boldChatButtonDiv\" data-chat-button=\"boldChatButton\"></need-help></div></div></div></form></div><div class=\"container\" data-ng-show=\"partNo === \'2\'\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" res=\"_my_rogers_nospace\"></a></li><li class=\"child-1\"><span res=\"reset_password\"></span></li></ul></div><div id=\"div_form\" data-ng-hide=\"success\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-log-12\"><div class=\"mbm info-banner error\" data-ng-show=\"isError\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1\" style=\"max-width: 40px;\"><img ng-src=\"images/warning.png\" src=\"images/warning.png\"></div><div class=\"col-xs-10 col-sm-10 col-md-11 plm\" style=\"float:left\"><span ng-bind-html=\"errorDescription\"></span></div></div></div><h2 res=\"login_reset_pwd_email_desc\"></h2></div></div><form name=\"form2\" novalidate=\"\"><div class=\"row\"><br><div class=\"col-xs-12 col-sm-12 col-md-5\"><div class=\"mbm\"><div class=\"mbs\"><strong>{{question()}}</strong></div><div class=\"inline_error\" ng-messages=\"form2.selectedAnswer.$error\" data-ng-show=\"form2.selectedAnswer.$invalid && (form2.selectedAnswer.$dirty || form2.$submitted)\"><span ng-message=\"required\"><span res=\"_require_security_answer\"></span></span></div><label class=\"rel\"><input data-tl-private=\"\" type=\"text\" name=\"selectedAnswer\" tag-form-name=\"form\" tag-page-name=\"Forget password\" data-ng-model=\"selectedAnswer\" ng-model-options=\"{ updateOn: \'blur\' }\" required=\"\"> <i ng-show=\"form2.selectedAnswer.$invalid && (form2.selectedAnswer.$dirty || form2.$submitted)\" class=\"inline-checker icon-error\"></i> <span ng-show=\"form2.selectedAnswer.$dirty && form2.selectedAnswer.$valid\" class=\"inline-checker icon-checked\"></span></label></div><div class=\"cancel-ctn\"><a href=\"#/signin\" class=\"link-cancel link_blue_color\"><span res=\"_cancel\"></span></a></div><span class=\"widget-loader-inline\" data-ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></span><div class=\"btn-continue-ctn\"><button name=\"button_continue\" data-ng-disabled=\"loadingDataIndicator\" class=\"cta-round primary medium full btn-continue\" data-ng-click=\"submitFinal()\"><span class=\"overrite-span\" res=\"_continue\"></span></button></div></div></div></form></div><div id=\"div_confirm\" data-ng-hide=\"success == false\"><div class=\"row mbm rest-pwd-success-message\"><div class=\"col-lg-12\"><h1 class=\"primary-color\" res=\"login_reset_pwd_success_message\"></h1></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-11\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-12\"><h4 res-param-email=\"{{email}}\" res=\"login_reset_pwd_success\"></h4></div></div></div></div></div><br><br><br></div></section>");
$templateCache.put("scripts/modules/forgotUserName/forgotUserName.html","<section class=\"page-forgot-username\"><div class=\"container\"><div class=\"row message-margin\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"#/signin\" res=\"_my_rogers_nospace\"></a></li><li class=\"child-1\"><span res=\"forgot_username\"></span></li></ul></div><div ng-hide=\"success == true\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"info-banner error mts\" data-ng-show=\"isError\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1 error-icon-ctn\"><img ng-src=\"images/warning.png\" src=\"images/warning.png\"></div><div class=\"col-xs-10 col-sm-10 col-md-11 error-message-ctn\"><span ng-bind-html=\"errorDescription\"></span></div></div></div><p class=\"forgot-username-desc\" res=\"login_forget_username_desc\"></p></div></div><form name=\"form1\" novalidate=\"\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-12\"><div class=\"row\"><div class=\"inline_error\" ng-messages=\"form1.email.$error\" ng-show=\"form1.email.$invalid && (form1.email.$dirty || form1.$submitted)\"><span ng-message=\"required\"><span class=\"message-margin\" res=\"login_forget_pwd_email_invalid\"></span></span> <span ng-message=\"pattern\"><span res=\"_email_address_not_valid\" class=\"prm\"></span></span></div><label class=\"rel\"><input class=\"no-inline-checker overrite-margin-bottom\" type=\"text\" name=\"email\" tag-form-name=\"form\" tag-page-name=\"Forget User Name\" data-ng-model=\"email\" ng-model-options=\"{ updateOn: \'blur\' }\" required=\"\" ng-pattern=\"/[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,4}$/i\" res-attr=\"{ placeholder : \'_email\'}\" autocorrect=\"off\" autocapitalize=\"off\"> <i ng-show=\"form1.email.$invalid && (form1.email.$dirty || form1.$submitted)\" class=\"inline-checker icon-error\"></i> <span ng-show=\"form1.email.$dirty && form1.email.$valid\" class=\"inline-checker icon-checked\"></span></label></div><div class=\"row form-action-ctn\"><div class=\"cancel-ctn\"><a ui-sref=\"signin\" class=\"link-cancel link_blue_color\"><span res=\"_cancel\"></span></a></div><span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></span><div class=\"btn-continue-ctn\"><button name=\"button_continue\" ng-disabled=\"loadingDataIndicator\" class=\"cta-round primary medium full btn-continue\" data-ng-click=\"submit()\"><span class=\"overrite-span\" res=\"_continue\"></span></button></div></div></div><div class=\"col-lg-5 col-md-5 col-sm-5 col-xs-12\"><div id=\"forgotUsernameBoldChat_div\"><need-help data-cbid=\"boldChatButtonId\" dynamic-div=\"boldChatButtonDiv\" data-chat-button=\"boldChatButton\"></need-help></div></div></div></form></div><div ng-hide=\"success == false\"><div class=\"row mbm reset-pwd-success-message\"><div class=\"col-md-8\"><h1 class=\"primary-color\" res=\"login_reset_pwd_success_message\"></h1></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-12 msg-padding\"><span class=\"forgot-username-success\" res-param-email=\"{{email}}\" res=\"login_forget_username_success\"></span></div></div></div></div></section>");
$templateCache.put("scripts/modules/guestOverview/guestOverview.html","<section ng-class=\"(isSafariBrowser() && menuOpenSafari) ? \'top-bar-ctn-safari\' : \'page-guest-overview page-account-overview\'\"><div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 mbl\"><div class=\"link-intro\"><div><span res=\"_hi\"></span>,</div><div class=\"mtm\"><span res=\"link_account_intro_no_link\"></span></div></div><a ng-hide=\"brtLinkAccount\" class=\"cta-round primary medium link-account-btn\" ng-click=\"linkAccount()\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"guestOverviewToLinkAccount\"><span res=\"linked_acc_btn_submit\"></span></a> <a ng-show=\"brtLinkAccount\" class=\"cta-round primary medium link-account-btn\" href=\"../../../business/ute/smb/transactions/uteAccountAssociation\"><span res=\"linked_acc_btn_submit\"></span></a></div></div></div><div class=\"container\"><div class=\"row ptm\"><div ng-show=\"cambrt\" class=\"ucc-banner\"><span><ins ute-content-injector-no-cache=\"\" language=\"{{lang}}\" content-id=\"/web/smb/cms/cam/cam-banner/cam-banner-guest\"></ins></span></div></div></div><div class=\"container\"><div class=\"row ptm\"></div></div></div></section>");
$templateCache.put("scripts/modules/igniteInternet/igniteInternet.html","<script type=\"text/javascript\">\n  $(function () {\n    $(\'.pointer\').popover();\n  });\n</script><section class=\"page-tvdashboard\"><div ng-cloak=\"\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"_internet\"></span> <span class=\"widget-loader-inline\" ng-show=\"!showPrdDetails\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container page-wireless tv-package-ctn\"><div class=\"container\"><div class=\"container page-tvdashboard tv-package-spacing\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-6\"><h2 class=\"widget-loader-mod\" res=\"internet_my_internet_package\"></h2><div class=\"widget-loader tv\" ng-show=\"loadingProdDetails && !showPrdDetails\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-3 semi-bold\"><div class=\"widget-loader tv\" ng-show=\"loadingProdDetails && !showPrdDetails\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><div class=\"title-h5 semi-bold mbs\" ng-if=\"showPrdDetails\" res=\"ignite_internet_{{offerCaption}}\"></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-12\"><div class=\"row wireless-package\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"mtn widget-loader-mod\" res=\"internet_my_modem\"></h2><div class=\"widget-loader\" data-ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\"><div class=\"row mbl mtm\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 ptm\"></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-12\"><div class=\"\" ng-repeat=\"modem in modemList track by $index\"><div class=\"semi-bold internetMyModem_mod4\" res=\"internet_my_modem\">:</div><div ng-if=\"showPrdDetails\" res=\"{{modem.componentCode}}\"></div></div></div></div></div></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/igniteTv/igniteTv.html","<script type=\"text/javascript\">\n  $(function () {\n    $(\'.pointer\').popover();\n  });\n</script><section class=\"page-tvdashboard\"><div ng-cloak=\"\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"_tv\"></span> <span class=\"widget-loader-inline\" ng-show=\"!showPrdDetails\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container page-wireless tv-package-ctn\"><div class=\"container\"><div class=\"container page-tvdashboard\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-6\"><h2 class=\"widget-loader-mod\" res=\"tv_my_package\"></h2><div class=\"widget-loader tv\" ng-show=\"loadingProdDetails && !showPrdDetails\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-3 semi-bold\"><div class=\"widget-loader tv\" ng-show=\"loadingProdDetails && !showPrdDetails\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><div class=\"title-h5 semi-bold mbs\" ng-if=\"showPrdDetails\" res=\"ignite_tv_{{offerCaption}}\"></div></div></div><div class=\"container my-digital-box\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-12\"><div class=\"row ptm\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"mtn widget-loader-mod\" res=\"tv_my_box\"></h2><div class=\"widget-loader\" data-ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4 mtl prs\"><div class=\"tvDevicesDiv\"><div class=\"top-head\"><div class=\"tvicon\"><img src=\"images/tv_icon_small.png\"></div><div class=\"tvheading\" res=\"ignite_box\"><div></div></div><div class=\"line1\"><div class=\"line\"></div></div><div class=\"sub-heading\"><span class=\"count\">{{tvBoxList.length}}&nbsp;</span><div class=\"box-text\" ng-class=\"{\'marClass\':boxcount<10}\" res=\"tv_box_line_2\"></div></div></div></div></div></div></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/internetDashboard/internetColonyPortal.html","<form method=\"post\" name=\"SAMLResponseForm\" id=\"SAMLResponseForm\"><input type=\"hidden\" id=\"RelayState\" name=\"RelayState\"> <input type=\"hidden\" id=\"SAMLResponse\" name=\"SAMLResponse\"></form>");
$templateCache.put("scripts/modules/internetDashboard/internetDashboard.html","<section class=\"page-internet-dashboard page-wireless\"><div data-ng-cloak=\"\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"_internet\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div data-internet-my-usage=\"\"></div><div data-internet-my-package=\"\"></div><div data-ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"selectedAccountNumber\" name=\"selectedAccountNumber\"><br><button data-ng-click=\"postToRogers(0)\">Usage History</button> <button data-ng-click=\"postToRogers(1)\" atm=\"internet_viewusagealerts_viewusagealerts\">Usage Alerts</button> <button data-ng-click=\"postToRogers(2)\" atm=\"internet_viewdailyusage_viewdailyusage\">Daily Usage</button> <button data-ng-click=\"postToRogers(3)\" atm=\"internet_viewmonthlyusage_viewmonthlyusage\">Monthly Usage</button> <button data-ng-click=\"postToRogers(4)\">Add extras</button></form></div><button data-ng-click=\"drawChartSync()\" data-ng-show=\"false\">Chart</button></div></section>");
$templateCache.put("scripts/modules/makePayment/formCreditCard.html","<input data-tl-private=\"\" type=\"hidden\" name=\"token\" id=\"token\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cardScheme\" id=\"cardScheme\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"maskedCardNumber\" id=\"maskedCardNumber\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneTokeniseErrorCode\" id=\"semafoneTokeniseErrorCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneTokeniseReasonCode\" id=\"semafoneTokeniseReasonCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"isPanResetOnInitialFocus\" id=\"isPanResetOnInitialFocus\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneTokeniseResponseCode\" id=\"semafoneTokeniseResponseCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneTokeniseErrorDesc\" id=\"semafoneTokeniseErrorDesc\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneValidationState\" id=\"semafoneValidationState\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneState\" id=\"semafoneState\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cybersourceTokeniseResponseCode\" id=\"cybersourceTokeniseResponseCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cybersourceTokeniseReasonCode\" id=\"cybersourceTokeniseReasonCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cybersourceTokeniseMessage\" id=\"cybersourceTokeniseMessage\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cybersourceTokeniseErrorCause\" id=\"cybersourceTokeniseErrorCause\" value=\"\"><div class=\"col-lg-12 col-md-12 col-xs-7 col-sm-4 labelMargin\" style=\"padding-right: 0px;\"><span res=\"bss_paymentMethodChange_creditCardNumber\"></span> <span class=\"mandatory hidden-xs hidden-sm\">*</span></div><div class=\"col-sm-6 col-xs-5 hidden-md hidden-lg labelMargin\" style=\"padding-right: 0px; padding-left:4px;\"><img ng-src=\"images/visa.png\" class=\"imgVisa card_not_selected\" alt=\"{{visa}}\"> <img ng-src=\"images/masterCard.png\" class=\"imgMc card_not_selected\" style=\"width: 33px; height: 22px\" alt=\"{{mastercard}}\"> <img ng-src=\"images/americanExpress.png\" class=\"imgAmex card_not_selected\" alt=\"{{amex}}\"></div><div class=\"row pts\"><div class=\"col-lg-7 col-md-4 col-sm-12 col-xs-12 lgStyle\"><div class=\"rel\"><label for=\"semafoneCapturePage\" class=\"sr-only\" res=\"_enter_cc_number\"></label><div align=\"left\" id=\"semafoneCapturePage\"></div></div></div><div class=\"col-lg-5 col-md-6 col-sm-12 col-xs-12 hidden-xs hidden-sm pls cc-image-ctns\"><img ng-src=\"images/visa.png\" class=\"imgVisa card_not_selected\" alt=\"{{visa}}\"> <img ng-src=\"images/masterCard.png\" class=\"imgMc card_not_selected\" style=\"width: 33px; height: 22px\" alt=\"{{mastercard}}\"> <img ng-src=\"images/americanExpress.png\" class=\"imgAmex card_not_selected\" alt=\"{{amex}}\"></div></div>");
$templateCache.put("scripts/modules/makePayment/makePayment.html","{{selectedAccNum}} {{selectedAccContactId}}<div class=\"container makePaymentContainer\" ng-controller=\"makePaymentController\"><div class=\"hidden-xs hidden-sm loadingIndEn\" ng-show=\"loadingIndicator\"><img src=\"images/widget-loader-lg.gif\"></div><div class=\"hidden-md hidden-lg loadingIndEn\" ng-show=\"loadingIndicator\"><img src=\"images/widget-loader-lg_plain.gif\"></div><div ng-show=\"!showMakePaymentSection && !loadingIndicator\"><h2 class=\"sr-only\" res=\"bss_makePayment_makeAPayment\"></h2><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 makePaymentNow\" res=\"bss_makePayment_makeAPayment\" ng-class=\"{\'makePaymentNowMargin\' : (makePaymentBreadCrumb[1].isActive || makePaymentBreadCrumb[2].isActive)}\"></div><div class=\"row\" ng-show=\"makePaymentBreadCrumb[2].isActive\"><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12 thankYou\"><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1\" style=\"padding-right:0px;\"><img src=\"images/Check.png\" class=\"checkImage\" alt=\"\" role=\"presentation\"></div><div class=\"col-lg-11 col-md-11 col-sm-10 col-xs-10\"><h2 class=\"thankYou1 marginTop0\" res=\"bss_makePayment_successMessage1\"></h2><p class=\"thankYou2\" res=\"bss_makePayment_successMessage2\"></p></div></div></div><div class=\"col-lg-12 col-md-12 hidden-xs hidden-sm selectChosenMethod\" ng-show=\"makePaymentBreadCrumb[0].isActive\" res=\"bss_makePayment_intro\"></div><ol class=\"nav nav-pills nav-wizard col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-hide=\"makePaymentBreadCrumb[2].isActive\"><li class=\"{{makePaymentBreadCrumb[0].selection}} col-lg-3 col-md-3 col-xs-6 col-sm-4 enter-info-tab\"><a class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" href=\"#\" ng-click=\"editInfo()\" tabindex=\"0\"><div class=\"col-lg-2 col-md-2 col-xs-2 col-sm-2 circle\">1</div><div class=\"stepName\" res=\"bss_makePayment_enterInformation\"></div><div class=\"nav-arrow\"></div></a></li><li class=\"{{makePaymentBreadCrumb[1].selection}} col-lg-3 col-md-3 col-xs-3 col-sm-4 review-tab\"><a class=\"col-lg-12 col-xs-12\" tabindex=\"0\"><div class=\"nav-wedge\"></div><div class=\"col-lg-2 col-md-2 col-xs-2 col-sm-2 circle\">2</div><div class=\"stepName\" res=\"bss_makePayment_review\"></div><div class=\"nav-arrow\"></div></a></li><li class=\"{{makePaymentBreadCrumb[2].selection}} col-lg-3 col-md-3 col-xs-3 col-sm-4 confirm-tab\"><div class=\"nav-wedge\"></div><a class=\"col-lg-12 col-xs-12\" tabindex=\"0\"><div class=\"nav-wedge\"></div><div class=\"col-lg-2 col-md-2 col-xs-2 col-sm-2 circle\">3</div><div class=\"stepName\" res=\"bss_makePayment_confirm\"></div><div class=\"nav-arrow\"></div></a></li></ol><div ng-show=\"makePaymentBreadCrumb[0].isActive\" class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12\"><p class=\"allFieldsRequired\" res=\"bss_makePayment_allFieldsRequired\"></p></div><div class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 accountDetails\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-xs-12 col-sm-12\"><h2 class=\"label marginTop0\" ng-show=\"makePaymentBreadCrumb[0].isActive\" res=\"bss_makePayment_paymentForAccount\"></h2><h2 class=\"accountNumberLabel marginTop0\" ng-show=\"makePaymentBreadCrumb[1].isActive || makePaymentBreadCrumb[2].isActive\" res=\"bss_makePayment_accountNumber\"></h2></div><div class=\"col-lg-8 col-md-8 col-xs-12 col-sm-12\"><div class=\"col-lg-7 col-md-7 col-xs-12 col-sm-12\" ng-if=\"bankPaymentId\"><h2 class=\"bankpaymentlabel\" ng-show=\"brtSwitchvalue == true || brtWhitelistvalue == true\" res=\"bss_makePayment_bankPaymentId\"></h2></div><div ng-show=\"brtSwitchvalue == true || brtWhitelistvalue == true\" class=\"col-lg-1 col-md-1 hidden-xs hidden-sm\" ng-class=\"lng === \'en\' ? \'styleForDesktopbrt\' : \'styleForDesktopbrtfr\'\"><span class=\"popoverContent contentDesktopViewbrt\" data-toggle=\"popover\"><span ng-if=\"bankPaymentId\"><img id=\"cvvHelp\" ng-show=\"lng === \'en\'\" style=\"width: 60%;margin-left: -151px;position:absolute;\" tabindex=\"0\" src=\"images/informationIcon.png\" alt=\"{{infoIcon}}\" role=\"presentation\"> <img id=\"cvvHelp\" ng-show=\"lng === \'fr\'\" style=\"width: 60%;margin-left: -38px;position:absolute;z-index:1\" tabindex=\"0\" src=\"images/informationIcon.png\" alt=\"{{infoIcon}}\" role=\"presentation\"></span></span><div class=\"popoverContentDesktopbrt\" style=\"display: none;\"><div class=\"col-lg-12\" style=\"padding-right:0px; margin-bottom:10px;\"><img class=\"popoverClose\" style=\"float:right;margin:0;cursor: pointer;width:8%;margin-right: -10px;position: relative;z-index:2;\" src=\"images/closeSecurityCode.png\" alt=\"\" role=\"presentation\"></div><div class=\"col-lg-12\" style=\"padding-right:0;\"><div class=\"col-lg-7\" ng-show=\"lng === \'en\'\" style=\"margin-bottom:6px; width:280px;margin-top: -28px;\" res=\"bss_makePayment_bankPaymentId_infoDetails\"></div><div class=\"col-lg-7\" ng-show=\"lng === \'fr\'\" style=\"margin-bottom:2px; width:260px;margin-top: -38px;\" res=\"bss_makePayment_bankPaymentId_infoDetails\"></div></div></div></div></div><div class=\"col-lg-5 col-md-5 col-xs-12 col-sm-12\" ng-if=\"bankPaymentId == undefined\"><h2 class=\"bankpaymentlabel\" ng-show=\"brtSwitchvalue == false && brtWhitelistvalue == false\"></h2></div></div><div class=\"row\"><div ng-if=\"bankPaymentId == undefined || brtWhitelistvalue == false\" class=\"col-lg-4 col-md-4 col-xs-12 col-sm-12 storeInfo\"><span class=\"storeName\">{{name}}</span><span class=\"number\">{{accountNo}}</span></div><div ng-if=\"(bankPaymentId && brtWhitelistvalue == true) || (bankPaymentId && brtSwitchvalue == true)\" class=\"col-lg-4 col-md-4 col-xs-12 col-sm-12 bankstoreInfo\"><span class=\"storeName\">{{name}}</span><span class=\"number\">{{accountNo}}</span></div><div class=\"col-lg-4 col-md-4 col-xs-12 col-sm-12 bankInfo\" ng-if=\"(bankPaymentId && brtWhitelistvalue == true) || (bankPaymentId && brtSwitchvalue == true)\" ng-show=\"brtSwitchvalue == true || brtWhitelistvalue == true\"><span class=\"number\">{{bankPaymentId}}</span></div><div class=\"col-lg-4 col-md-4 col-xs-12 col-sm-12 bankInfo\" ng-if=\"bankPaymentId == undefined || brtWhitelistvalue == false\"><span class=\"number\"></span></div><div class=\"col-lg-4 col-md-4 col-xs-12 col-sm-12 balance\" ng-show=\"makePaymentBreadCrumb[0].isActive\"><span class=\"hidden-xs hidden-sm\"><span class=\"balance_label\" res=\"bss_makePayment_acountBalance_label\"></span> <span style=\"padding-top: 16px !important;display: inline-block;\">{{currentDate|date:\'MM/dd/yyyy\'}}</span>:</span> <span ng-show=\"lng===\'en\'\"><sup>$</sup></span> <span class=\"amount\">{{dollar}}</span><span ng-show=\"lng===\'en\'\">.</span><span ng-show=\"lng===\'fr\'\">,</span><sup>{{cents}}</sup> <span ng-show=\"lng===\'fr\'\"><sup>$</sup></span><span class=\"hidden-md hidden-lg\">{{i18n.bss_makePayment_due}} <span>{{currentDate|date:\'MM/dd/yyyy\'}}</span></span></div></div></div><div class=\"enterInformation row\" ng-show=\"makePaymentBreadCrumb[0].isActive\" ng-form=\"enterInformationForm\"><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 selectPaymentMethod\"><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" style=\"padding-bottom:10px;\"><span class=\"hidden-xs hidden-sm\" res=\"bss_makePayment_selectPaymentMethod\"></span><span class=\"hidden-lg hidden-md\">Paying With</span></div><ol class=\"nav nav-tabs col-lg-9 col-md-9 hidden-xs hidden-sm\"><li class=\"active col-lg-6 col-md-6\"><a href=\"\" tabindex=\"0\" ng-click=\"showBankingSection(\'creditCard\')\" style=\"margin-right:10px;\" ng-class=\"{borderRedFirst:showCreditCardBanking, borderRedSecond:!showCreditCardBanking}\" res=\"bss_makePayment_creditCard\" ute-data-layer-event=\"\" event-name=\"click\" event-data=\"{&quot;page&quot;:{&quot;name&quot;:&quot;makeACreditCardPayment&quot;,&quot;hierarchy&quot;:[&quot;selfserve&quot;,&quot;billing&payment&quot;,&quot;makeAPayment&quot;]}}\"></a></li><li class=\"active col-lg-6 col-md-6\"><a href=\"\" tabindex=\"0\" ng-click=\"showBankingSection(\'online\')\" ng-class=\"{borderRedSecond:!showOnlineBanking, borderRedFirst:showOnlineBanking}\" res=\"bss_makePayment_onlineBanking\" ute-data-layer-event=\"\" event-name=\"click\" event-data=\"{&quot;page&quot;:{&quot;name&quot;:&quot;makeAnOnlineBankingPayment&quot;,&quot;hierarchy&quot;:[&quot;selfserve&quot;,&quot;billing&payment&quot;,&quot;makeAPayment&quot;]}}\"></a></li></ol><ol class=\"row hidden-lg hidden-md customizedRadioButtonsList\"><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" alt=\"\" role=\"presentation\" ng-show=\"!firstRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(\'creditCard\'); firstRadio=true;secondRadio=false;\" tabindex=\"0\" ng-enter=\"showBankingSection(\'creditCard\'); firstRadio=true;secondRadio=false;\" ute-data-layer-event=\"\" event-name=\"click\" event-data=\"{&quot;page&quot;:{&quot;name&quot;:&quot;makeACreditCardPayment&quot;,&quot;hierarchy&quot;:[&quot;selfserve&quot;,&quot;billing&payment&quot;,&quot;makeAPayment&quot;]}}\"> <img ng-show=\"firstRadio\" src=\"images/activeRadio.png\" alt=\"\" role=\"presentation\" ng-class=\"{customizedRadioButtonColor:firstRadio}\" tabindex=\"0\"> <span res=\"bss_makePayment_creditCard\"></span></li><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" alt=\"\" role=\"presentation\" ng-show=\"!secondRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(\'online\'); firstRadio=false;secondRadio=true;\" tabindex=\"0\" ng-enter=\"showBankingSection(\'online\');firstRadio=false;secondRadio=true;\" ute-data-layer-event=\"\" event-name=\"click\" event-data=\"{&quot;page&quot;:{&quot;name&quot;:&quot;makeAnOnlineBankingPayment&quot;,&quot;hierarchy&quot;:[&quot;selfserve&quot;,&quot;billing&payment&quot;,&quot;makeAPayment&quot;]}}\"> <img ng-show=\"secondRadio\" src=\"images/activeRadio.png\" alt=\"\" role=\"presentation\" ng-class=\"{customizedRadioButtonColor:secondRadio}\" tabindex=\"0\"> <span res=\"bss_makePayment_onlineBanking\"></span></li></ol><div class=\"creditCardBanking\" ng-show=\"showCreditCardBanking\"><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 paymentAmount\"><div class=\"paymentAmountInner\"><span res=\"bss_makePayment_amountDue\"></span> <span class=\"mandatory hidden-xs hidden-sm\">*</span></div><div class=\"row\"><div class=\"dollar\" ng-show=\"lng===\'en\'\">$</div><div class=\"col-lg-5 col-md-5 col-sm-11 col-xs-10\"><label for=\"amountDue\" class=\"sr-only\" res=\"_enter_amount_due\"></label> <input type=\"text\" id=\"amountDue\" name=\"paymentAmount\" ng-model=\"paymentAmount\" ng-pattern=\"/^\\s*(?=.*[1-9])\\d*(?:\\.\\d{1,2})?\\s*$/\" class=\"form-control\" required=\"\" tabindex=\"0\"></div><div class=\"dollar col-lg-1 col-md-1 col-xs-1 col-sm-1\" ng-show=\"lng===\'fr\'\">$</div><span class=\"styled-select-type beside-checker-payment icon-error\" ng-show=\"isValidPaymentAmount\"></span></div><div class=\"row\"><div><div ng-if=\"isValidPaymentAmount\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 inline_error\" message=\"\" image=\"images\\errorIcon.png\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"amountDue\"><span res=\"bss_invalid_payment_amount\"></span></span></div><div ng-if=\"isValidPaymentAmt\" ng-hide=\"!enterInformationForm.paymentAmount.$error.pattern\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 inline_error\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"amountDue\"><span res=\"bss_non_zero_amount\"></span></span></div></div></div></div><form-credit-card class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\" style=\"padding-right:0px\"></form-credit-card><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" id=\"cardNumberErrorSection\"><div class=\"inline_error\" ng-if=\"isValidCreditCardNumber\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"creditCardNumber\"><span res=\"bss_invalid_cc_number\"></span></span></div><div class=\"inline_error\" ng-if=\"isValidCreditCardScheme\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"creditCardType\"><span res=\"bss_invalid_cc_type\"></span></span></div></div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 labelMargin\"><span res=\"bss_makePayment_expirationDate\"></span><span class=\"mandatory\">*</span></div><div class=\"col-lg-6 col-md-6 col-xs-12 col-sm-12\"><div class=\"focusBorder styled-month-select select-month col-lg-4 col-md-4 col-sm-4 col-xs-4\" ng-class=\"{redBorder:isValidMonth}\"><label for=\"month\" class=\"sr-only\" res=\"_enter_expiration_month\"></label><select name=\"monthName\" id=\"month\" class=\"\" required=\"\" ng-model=\"selectedMonth\" ng-init=\"selectedMonth = $scope.months[0]\" ng-change=\"changeMonth(selectedMonth)\" tabindex=\"0\"><option value=\"\" class=\"\" disabled=\"true\" ng-selected=\"true\" res=\"bss_month\"></option><option ng-repeat=\"month in months\">{{month.value}}</option></select></div><div class=\"focusBorder styled-year-select select-year col-lg-5 col-md-5 col-sm-5 col-xs-5\" ng-class=\"{redBorder:isValidYear}\"><label for=\"year\" class=\"sr-only\" res=\"_enter_expiration_year\"></label><select name=\"yearValue\" id=\"year\" class=\"\" required=\"\" ng-model=\"selectedYear\" ng-init=\"selectedYear = $scope.years[0]\" ng-change=\"changeYear(selectedYear)\" tabindex=\"0\"><option value=\"\" class=\"\" disabled=\"true\" ng-selected=\"true\" res=\"bss_year\"></option><option ng-repeat=\"year in years\">{{year}}</option></select></div><span class=\"styled-select-type beside-checker-payment icon-error\" ng-show=\"isValidMonth || isValidYear\"></span></div><div class=\"errorClass col-lg-7 col-md-7 col-sm-12 col-xs-12 inline_error\" ng-if=\"isValidMonth || isValidYear\" image=\"images\\errorIcon.png\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"ccExpiryDate\"><span res=\"bss_invalid_cc_ex_date\"></span></span></div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 labelMargin\"><span res=\"bss_makePayment_securityCode\"></span><span class=\"mandatory\">*</span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 securityCode\" style=\"padding-right: 7px;\"><div class=\"col-lg-2 col-md-2 col-sm-5 col-xs-5\" style=\"margin-right:15px\"><label for=\"securityCode\" class=\"sr-only\" res=\"_enter_security_code\"></label> <input type=\"text\" id=\"securityCode\" maxlength=\"4\" class=\"form-control\" numbers-only=\"\" ng-keyup=\"validateSecurityCode()\" ng-model=\"securityCode\" placeholder=\"XXXX\" name=\"securityCode\" required=\"\" ng-class=\"{redBorder:isValidSecurityCode}\" tabindex=\"0\"></div><div class=\"col-lg-9 col-md-9 hidden-xs hidden-sm styleForDesktop\"><span class=\"popoverContent contentDesktopView\" data-toggle=\"popover\"><span><img id=\"cvvHelp\" tabindex=\"0\" src=\"images/informationIcon.png\" alt=\"{{infoIcon}}\" role=\"presentation\"></span></span><div><span custom-popover=\"\" popover-placement=\"right\" popover-label=\"Label\"></span></div></div><div class=\"popoverContentDesktop\" style=\"display: none;\"><div class=\"col-lg-12\" style=\"padding-right:0px; margin-bottom:10px;\"><img class=\"popoverClose\" style=\"float:right;margin:0;cursor: pointer;\" src=\"images/closeSecurityCode.png\" alt=\"\" role=\"presentation\"></div><div class=\"col-lg-12\" style=\"padding-right:0;\"><div class=\"col-lg-5\"><img src=\"images/securityCode.png\" style=\"max-width:100%\" alt=\"\" role=\"presentation\"></div><div class=\"col-lg-7\" style=\"padding-right:35px; padding-left:5px;\" res=\"bss_makePayment_securityCodeDetail\"></div></div></div><div class=\"hidden-lg hidden-md col-sm-3 col-xs-3 popOverStyle\" style=\"padding-right:0\"><span class=\"popoverContent contentSmallDevices\"><span><img id=\"cvvHelpSmallDevices\" tabindex=\"0\" src=\"images/informationIcon.png\" alt=\"{{infoIcon}}\" role=\"presentation\"></span></span><div><span custom-popover-smalldevice=\"\" popover-placement=\"bottom\" popover-label=\"Label\"></span></div></div><div class=\"popoverContentMobile\" style=\"display: none;\"><div class=\"col-xs-12 col-sm-12\" style=\"padding-right:0px; margin-bottom:20px;\"><img class=\"popoverClose\" style=\"float:right;margin:0;\" src=\"images/closeSecurityCode.png\" alt=\"\" role=\"presentation\"></div><div class=\"col-xs-12 col-sm-12\" style=\"padding-right:26px; padding-bottom:35px; padding-left:5px;\" res=\"bss_makePayment_securityCodeDetail\"></div><div class=\"col-xs-12 col-sm-12\"><img src=\"images/securityCode.png\" style=\"max-width:100%\" alt=\"\" role=\"presentation\"></div></div></div><div ng-if=\"isValidSecurityCode\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 inline_error\" image=\"images\\errorIcon.png\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"ccvValue\"><span res=\"bss_invalid_ccv_value\"></span></span></div><div class=\"row\"><span><ins ute-content-injector-no-cache=\"\" language=\"{{lng}}\" content-id=\"/web/smb/cms/selfserve/creditcard-correspondence/creditcard-correspondence\"></ins></span></div></div><div class=\"onlineBanking col-lg-9 col-md-9 col-xs-12 col-sm-12\" ng-show=\"showOnlineBanking\"><p res=\"bss_makePayment_onlineBankingInfo1\"></p><h3 res=\"bss_makePayment_onlineBankingInfo2\"></h3><ol style=\"list-style-type:decimal\"><li res=\"bss_makePayment_onlineBankingInfo3\"></li><li ng-if=\"bankPaymentId == undefined || brtWhitelistvalue == false\" res=\"bss_makePayment_onlineBankingInfo4\"></li><li ng-if=\"(bankPaymentId && brtWhitelistvalue == true) || (bankPaymentId && brtSwitchvalue == true)\" ng-show=\"brtSwitchvalue == true || brtWhitelistvalue == true\" res=\"bss_makePayment_onlineBankingInfo4_brt\"></li><li res=\"bss_makePayment_onlineBankingInfo5\"></li></ol><p res=\"bss_makePayment_onlineBankingInfo6\"></p><div class=\"row bankLinks\"><span class=\"col-lg-4 col-md-4 col-xs-6 col-sm-6\" ng-repeat=\"bankDetail in bankDetails\"><a class=\"\" href=\"{{bankDetail.href}}\" target=\"_blank\"><span class=\"{{bankDetail.name}} col-lg-12 col-md-12 col-xs-12 col-sm-12\"></span> <span class=\"sr-only\">{{bankDetail.name}}</span></a></span></div></div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" ng-hide=\"showOnlineBanking\"><section class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><button type=\"button\" class=\"continueReview\" ng-click=\"validateEnterInformationForm()\"><span class=\"row\"><span class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" res=\"bss_makePayment_continue\">&nbsp; <img src=\"images/lock.png\" alt=\"\" role=\"presentation\"></span></span></button></section><section class=\"col-lg-2 col-md-2 col-xs-12 col-sm-12 cancel\"><a style=\"cursor: pointer;\" href=\"#accountOverview\" res=\"bss_makePayment_cancel\" target=\"_self\"></a></section></div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" ng-show=\"showOnlineBanking\"><section class=\"col-lg-2 col-md-2 col-xs-5 col-sm-5\" style=\"padding-top:0px;font-size: 16px;\"><a style=\"cursor: pointer;\" href=\"#accountOverview\" res=\"bss_makePayment_cancel\" target=\"_self\"></a></section></div></div></div><div class=\"reviewAndConfirmation\" ng-show=\"makePaymentBreadCrumb[1].isActive || makePaymentBreadCrumb[2].isActive\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_makePayment_paymentAmount\"></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\"><span ng-show=\"lng===\'en\'\">$</span> <span ng-bind=\"paymentAmount\"></span> <span ng-show=\"lng===\'fr\'\">$</span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_makePayment_paymentMethod\"></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\"><img src=\"{{cardUrl}}\" alt=\"{{cardImg}}\" width=\"30\" and=\"\" height=\"20\">&nbsp;<span ng-bind=\"creditCardNumber\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_makePayment_date\"></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\">{{requiredMonth}}&nbsp;{{requiredDate}}</div><div class=\"col-lg-7 col-md-7 col-sm-8 col-xs-8 content\" ng-show=\"makePaymentBreadCrumb[2].isActive\"></div><div ng-show=\"makePaymentBreadCrumb[1].isActive\" class=\"reviewLabel\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 editPaymentInfo\"><a href=\"#\" ng-click=\"editInfo()\"><span res=\"bss_makePayment_editPaymentInformation\"></span></a></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"margin-top:10px;margin-bottom:3rem;\"><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12 payNowSection\"><button type=\"button\" class=\"payNow\" ng-click=\"submitPayment()\" res=\"bss_makePayment_payNow\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"makePaymentInitiate\">&nbsp;<img src=\"images/lock.png\" alt=\"\" role=\"presentation\" width=\"11\" height=\"14\" style=\"padding-bottom:3px;\"></button></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 cancel\" style=\"padding-top:10px;\"><a style=\"cursor: pointer;\" href=\"#/accountOverview\" res=\"bss_makePayment_cancel\" target=\"_self\"></a></div></div></div><div ng-show=\"makePaymentBreadCrumb[2].isActive\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"margin-top:30px;\"><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><a style=\"cursor: pointer;\" href=\"#/accountOverview\" class=\"cancel\" target=\"_self\" tabindex=\"0\"><span res=\"bss_makePayment_accountsOverviewLink\"></span></a></div><div class=\"col-lg-5 col-md-5 col-sm-10 col-xs-12\"><a style=\"cursor: pointer;\" ng-click=\"redirectToLegacyPayment()\" class=\"cancel\" target=\"_self\" tabindex=\"0\"><span res=\"bss_makePayment_billingAndReportingLink\"></span></a></div></div></div></div><div class=\"makePaymentError\" ng-show=\"showMakePaymentErrorSection\"><div class=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-8 col-xs-11\"><h1 class=\"paymentError\">Make a Payment Now</h1></div></div><div class=\"row\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-11 error\"><div style=\"margin-top:13px;padding-left:15px;\" class=\"col-lg-8 col-md-8\"><p class=\"inline\" ng-show=\"content == \'bss_makePayment_invalid_cc\'\" res=\"bss_makePayment_invalid_cc\"></p><p class=\"inline\" ng-show=\"content == \'bss_makePayment_generic_error\'\" res=\"bss_makePayment_generic_error\"></p></div></div></div><div class=\"row\"><div class=\"col-lg-2 col-md-2 cancel\"><a style=\"cursor: pointer;\" href=\"#/accountOverview\">Cancel</a></div></div></div></div></div>");
$templateCache.put("scripts/modules/makePayment/makePaymentError.html","<div class=\"makePaymentError\"><div class=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-8 col-xs-11\"><h1 class=\"paymentError\">Make a Payment Now</h1></div></div><div class=\"row\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-11 error\"><div style=\"margin-top:13px;padding-left:15px;\" class=\"col-lg-8 col-md-8\"><p class=\"inline\" ng-show=\"content == \'bss_makePayment_invalid_cc\'\" res=\"bss_makePayment_invalid_cc\"></p><p class=\"inline\" ng-show=\"content == \'bss_makePayment_generic_error\'\" res=\"bss_makePayment_generic_error\"></p></div></div></div><div class=\"row\"><div class=\"col-lg-2 col-md-2 cancel\"><a href=\"#\">Cancel</a></div></div></div></div>");
$templateCache.put("scripts/modules/makePayment/payNow.html","<div><make-payment lng=\"lang\" data-account-no=\"selectedAccNum\" data-contact-id=\"selectedAccContactId\" data-lob=\"selectedAccLOB\" duedate=\"\" data-dollar=\"dollar\" data-cents=\"cents\" data-name=\"name\" data-isconsolidated=\"isConsolidated\"></make-payment></div>");
$templateCache.put("scripts/modules/midmarket/midMarketPortal.html","<form method=\"post\" name=\"MidMarketSAMLResponseForm\" id=\"MidMarketSAMLResponseForm\"><input type=\"hidden\" id=\"MidMarketSAMLResponse\" name=\"SAMLResponse\"></form>");
$templateCache.put("scripts/modules/migrateUser/migrateUser.html","<section class=\"page-signin\" ng-controller=\"MyrMigrateUserController\"><div class=\"container\" ng-init=\"onClickUserNameMigrationPageLoadUsage()\"><div class=\"body-grey-dark\"><form id=\"signinForm\" name=\"form\" class=\"body-grey-light\" novalidate=\"\"><div class=\"mtl\"><h1 class=\"sign-in-title\"><span class=\"primary-color\" res=\"mu_your_username_willbe\"></span></h1></div><div class=\"row mbm\"><div class=\"pln sign-intro mbl\"><h4 res=\"mu_username_updation\"></h4></div></div><div class=\"row\" data-ng-show=\"errorCode === \'general\'\"><div class=\"col-xs-12 col-sm-12 col-lg-8 pln prn\"><div class=\"mbm info-banner error mts\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-12 col-md-11\"><span ng-bind-html=\"errorDescription\" class=\"error-description-migrate-user\"></span></div></div></div></div></div><div class=\"row\" data-ng-show=\"errorCode === \'10802\'\"><div class=\"col-xs-12 col-sm-12 col-lg-8 pln prn\"><div class=\"mbm info-banner error reverse-margin\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-9 col-sm-10 col-md-11 col-lg-11 no-padding\"><div class=\"message-error-normal mbs\" res=\"mu_sorry_email_registered_1\"></div><h3 class=\"mts mbs\"><span class=\"rui-icon-live-chat-employee\"></span> <a class=\"title-h5\" ng-href=\"{{chatHref}}\" target=\"_blank\"><span res=\"mu_chat\" class=\"bold\"></span></a></h3></div></div></div></div></div><div class=\"row mbm\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-4 pln prn\"><div class=\"inline_error\" ng-messages=\"form.email.$error\" ng-show=\"form.email.$invalid && (form.email.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"mu_email_required\"></span></span> <span ng-message=\"pattern\"><span res=\"mu_email_not_valid\"></span></span> <span ng-message=\"mismatchEmail\"><span res=\"_email_not_matched\"></span></span></div><label class=\"rel\"><input type=\"text\" ng-pattern=\"/^\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" name=\"email\" res-attr=\"{ placeholder: \'_email\' }\" maxlength=\"105\" ng-model-options=\"{ updateOn: \'blur\' }\" onpaste=\"return false;\" data-ng-model=\"regObj.email\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.email.$invalid && (form.email.$dirty || form.$submitted)\"></span> <span ng-show=\"form.email.$dirty && form.email.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-4 pln prn\"><div class=\"inline_error\" ng-messages=\"form.confirmEmail.$error\" ng-show=\"form.confirmEmail.$invalid && (form.confirmEmail.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"mu_please_confirm_email\"></span></span> <span ng-message=\"match\"><span res=\"mu_email_not_match\"></span></span> <span ng-message=\"pattern\"><span res=\"mu_email_not_valid\"></span></span> <span ng-message=\"mismatchEmail\"><span res=\"_email_not_matched\"></span></span></div><label class=\"rel\"><input type=\"text\" name=\"confirmEmail\" res-attr=\"{placeholder: \'_confirm_email\'}\" ng-pattern=\"/^\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" ng-model-options=\"{ updateOn: \'blur\' }\" data-ng-model=\"confirmEmail\" onpaste=\"return false;\" match-email-mu=\"\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.confirmEmail.$invalid && (form.confirmEmail.$dirty || form.$submitted)\"></span> <i ng-show=\"form.confirmEmail.$dirty && form.confirmEmail.$valid\" class=\"inline-checker icon-checked\"></i></label></div></div><div class=\"row mbm\" ng-show=\"true\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-4 txtC pln prn\"><div class=\"pull-right\"><span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></div><div class=\"pull-right\"><button class=\"cta-round primary medium full\" ng-disabled=\"loadingDataIndicator\" data-ng-click=\"submit()\"><span res=\"_update\"></span></button></div></div></div></form></div></div></section>");
$templateCache.put("scripts/modules/myServices/myServices.html","<div style=\"position:relative;\"><div class=\"row\" id=\"myServices\"><div class=\"dmContainer\" ng-if=\"dmRedirect\"><div ng-repeat=\"msl in ms.mss.myServicesList | filter:{dmServiceGrp: 1}\" ng-class=\"{\'sharePlans\' : dmEligibility}\"><div class=\"col-xs-12\" ng-if=\"$first\"><div class=\"servicesTitle\"><span res=\"shareEverything_wireless\"></span></div><div class=\"col-xs-12 dmBadgeContent\" ng-if=\"dmEligibility\"><form id=\"dmFormData\" action=\"{{dmUrl}}\" method=\"get\"><input type=\"hidden\" name=\"icid\" value=\"{{icid}}\"> <input type=\"hidden\" name=\"token\" value=\"{{token}}\"></form><div class=\"col-xs-12 col-md-6\"><div class=\"dmBadgeTitle\" res=\"_share_everything_plan\"></div><span class=\"dmBadgeSmallText\"><span>{{dmSharedSubLength}}</span> <span res=\"wireless_line\"></span></span></div><div class=\"col-xs-12 col-md-6\" ng-hide=\"ms.maintenanceTime\"><div res=\"dm_new\" class=\"dmHighlightedText\"></div><button name=\"dm_redirect_btn\" type=\"button\" res=\"dm_real_time_usage\" class=\"dmBadgeButton\" aria-label=\"Click on Manage Data Usage & Alerts\" ng-click=\"ms.redirectToDMDashboard()\"></button></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\"><div ng-if=\"msl.isCompanion && brtEsimSwitch\"><div ng-show=\"_longname && (msl.serviceType == \'service_wireless\') && ms.isNameLong(msl.subscriberName)\" class=\"longNameContent\"><div class=\"long-name\">{{msl.subscriberName}}</div><div class=\"caretbox\"></div></div><div class=\"myServiceWrap\" tabindex=\"0\" ng-mouseleave=\"_longname = false\" ng-mouseover=\"_longname = true\" ng-init=\"_longname=false\" ng-click=\'(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? ms.runService(\"{{msl.serviceName}}\", \"{{msl.serviceDetail}}\" , \"{{msl.subscriberName}}\") : \"\"\' atm=\"{{msl.atmType}}\" ng-class=\"(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? \'pointer\' : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.serviceBadgeMappingKey}}\"><div class=\"myServiceName\"><div class=\"textVertical\"><img src=\"images/Smart_business_legacy_icon.png\" style=\"max-width: 75px;max-height: 55px;padding-right:15px;\" ng-show=\"msl.serviceType == \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"> <img src=\"/web/smb/cms/images/icon_fitbit.svg\" class=\"icon-fitbit\" style=\"max-width: 75px;max-height: 55px;margin: 0 10px;\" ng-show=\"msl.serviceType != \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"></div><div class=\"textVertical title-h5 companion\"><div class=\"subscriber-name\" res=\"_apple_watch\"></div><div class=\"phone\"><strong>{{msl.serviceDetail | phone2}}</strong></div><div class=\"link\" ng-if=\"msl.isPrimaryDeviceNumber\"><span res=\"_linked\"></span> <span>{{msl.primaryDeviceNumber | phone2}}</span></div><div class=\"link\" ng-if=\"!msl.isPrimaryDeviceNumber\"><span res=\"_unlinked\"></span></div></div></div><div class=\"myServiceArrow\"></div><div class=\"myServiceCTA\"><div class=\"textVertical arrow-ctn\" ng-hide=\"((ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\')\"><a name=\"{{msl.serviceName}}\"><span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"linkMsg\" ng-show=\"(ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\'\"><span ng-bind-html=\"ms.loginMessage\"></span></div></div></div></div><div ng-if=\"!msl.isCompanion\"><div ng-show=\"_longname && (msl.serviceType == \'service_wireless\') && ms.isNameLong(msl.subscriberName)\" class=\"longNameContent\"><div class=\"long-name\">{{msl.subscriberName}}</div><div class=\"caretbox\"></div></div><div class=\"myServiceWrap\" tabindex=\"0\" ng-mouseleave=\"_longname = false\" ng-mouseover=\"_longname = true\" ng-init=\"_longname=false\" ng-click=\'(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? ms.runService(\"{{msl.serviceName}}\", \"{{msl.serviceDetail}}\" , \"{{msl.subscriberName}}\") : \"\"\' atm=\"{{msl.atmType}}\" ng-class=\"(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? \'pointer\' : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.serviceBadgeMappingKey}}\"><div class=\"myServiceName\"><div class=\"textVertical\"><img src=\"images/Smart_business_legacy_icon.png\" style=\"max-width: 75px;max-height: 55px;padding-right:15px;\" ng-show=\"msl.serviceType == \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"> <span ng-show=\"msl.serviceType != \'myaccoverview_business_monotoring\'\" class=\"{{msl.icon}} icon\"></span></div><div class=\"textVertical title-h5\"><div class=\"subscriber-name\" ng-if=\"msl.serviceType == \'service_wireless\'\">{{msl.subscriberName}}</div><div ng-if=\"msl.serviceType != \'service_wireless\'\" res=\"{{msl.serviceType}}\"></div><div ng-show=\"msl.showPhone\"><strong>{{msl.serviceDetail | phone2}}</strong></div></div></div><div class=\"myServiceArrow\"></div><div class=\"myServiceCTA\"><div class=\"textVertical arrow-ctn\" ng-hide=\"((ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\')\"><a name=\"{{msl.serviceName}}\"><span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"linkMsg\" ng-show=\"(ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\'\"><span ng-bind-html=\"ms.loginMessage\"></span></div></div></div></div></div></div><div ng-repeat=\"msl in ms.mss.myServicesList | filter:{dmServiceGrp: 2}\"><div class=\"col-xs-12\" ng-if=\"$first\"><div class=\"servicesTitle\"><span res=\"nonShareEverything_wireless\"></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\"><div ng-if=\"msl.isCompanion && brtEsimSwitch\"><div ng-show=\"_longname && (msl.serviceType == \'service_wireless\') && ms.isNameLong(msl.subscriberName)\" class=\"longNameContent\"><div class=\"long-name\">{{msl.subscriberName}}</div><div class=\"caretbox\"></div></div><div class=\"myServiceWrap\" tabindex=\"0\" ng-mouseleave=\"_longname = false\" ng-mouseover=\"_longname = true\" ng-init=\"_longname=false\" ng-click=\'(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? ms.runService(\"{{msl.serviceName}}\", \"{{msl.serviceDetail}}\" , \"{{msl.subscriberName}}\") : \"\"\' atm=\"{{msl.atmType}}\" ng-class=\"(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? \'pointer\' : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.serviceBadgeMappingKey}}\"><div class=\"myServiceName\"><div class=\"textVertical\"><img src=\"images/Smart_business_legacy_icon.png\" style=\"max-width: 75px;max-height: 55px;padding-right:15px;\" ng-show=\"msl.serviceType == \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"> <img src=\"/web/smb/cms/images/icon_fitbit.svg\" class=\"icon-fitbit\" style=\"max-width: 75px;max-height: 55px;margin: 0 10px;\" ng-show=\"msl.serviceType != \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"></div><div class=\"textVertical title-h5 companion\"><div class=\"subscriber-name\" res=\"_apple_watch\"></div><div class=\"phone\"><strong>{{msl.serviceDetail | phone2}}</strong></div><div class=\"link\" ng-if=\"msl.isPrimaryDeviceNumber\"><span res=\"_linked\"></span> <span>{{msl.primaryDeviceNumber | phone2}}</span></div><div class=\"link\" ng-if=\"!msl.isPrimaryDeviceNumber\"><span res=\"_unlinked\"></span></div></div></div><div class=\"myServiceArrow\"></div><div class=\"myServiceCTA\"><div class=\"textVertical arrow-ctn\" ng-hide=\"((ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\')\"><a name=\"{{msl.serviceName}}\"><span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"linkMsg\" ng-show=\"(ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\'\"><span ng-bind-html=\"ms.loginMessage\"></span></div></div></div></div><div ng-if=\"!msl.isCompanion\"><div ng-show=\"_longname && (msl.serviceType == \'service_wireless\') && ms.isNameLong(msl.subscriberName)\" class=\"longNameContent\"><div class=\"long-name\">{{msl.subscriberName}}</div><div class=\"caretbox\"></div></div><div class=\"myServiceWrap\" tabindex=\"0\" ng-mouseleave=\"_longname = false\" ng-mouseover=\"_longname = true\" ng-init=\"_longname=false\" ng-click=\'(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? ms.runService(\"{{msl.serviceName}}\", \"{{msl.serviceDetail}}\" , \"{{msl.subscriberName}}\") : \"\"\' atm=\"{{msl.atmType}}\" ng-class=\"(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? \'pointer\' : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.serviceBadgeMappingKey}}\"><div class=\"myServiceName\"><div class=\"textVertical\"><img src=\"images/Smart_business_legacy_icon.png\" style=\"max-width: 75px;max-height: 55px;padding-right:15px;\" ng-show=\"msl.serviceType == \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"> <span ng-show=\"msl.serviceType != \'myaccoverview_business_monotoring\'\" class=\"{{msl.icon}} icon\"></span></div><div class=\"textVertical title-h5\"><div class=\"subscriber-name\" ng-if=\"msl.serviceType == \'service_wireless\'\">{{msl.subscriberName}}</div><div ng-if=\"msl.serviceType != \'service_wireless\'\" res=\"{{msl.serviceType}}\"></div><div ng-show=\"msl.showPhone\"><strong>{{msl.serviceDetail | phone2}}</strong></div></div></div><div class=\"myServiceArrow\"></div><div class=\"myServiceCTA\"><div class=\"textVertical arrow-ctn\" ng-hide=\"((ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\')\"><a name=\"{{msl.serviceName}}\"><span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"linkMsg\" ng-show=\"(ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\'\"><span ng-bind-html=\"ms.loginMessage\"></span></div></div></div></div></div></div><div ng-repeat=\"msl in ms.mss.myServicesList | filter:{dmServiceGrp: 3}\"><div class=\"col-xs-12\" ng-if=\"$first\"><div ng-hide=\"accpdtFlag\" class=\"servicesTitle\"><span res=\"other_services\"></span></div></div><div ng-hide=\"((msl.serviceType == \'service_tv\') && accpdtFlag) || accountStatus === \'Cancelled\'\" class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\"><div class=\"myServiceWrap\" tabindex=\"0\" ng-mouseleave=\"_longname = false\" ng-mouseover=\"_longname = true\" ng-init=\"_longname=false\" ng-click=\'(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled || accountStatus !== ms.suspended) ? ms.runService(\"{{msl.serviceName}}\", \"{{msl.serviceDetail}}\" , \"{{msl.subscriberName}}\") : \"\"\' atm=\"{{msl.atmType}}\" ng-class=\"(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) || accountStatus !== ms.suspended ? \'pointer\' : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.serviceBadgeMappingKey}}\"><div class=\"myServiceName\"><div class=\"textVertical\"><img src=\"images/Smart_business_legacy_icon.png\" style=\"max-width: 75px;max-height: 55px;padding-right:15px;\" ng-show=\"msl.serviceType == \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"> <span ng-show=\"msl.serviceType != \'myaccoverview_business_monotoring\'\" class=\"{{msl.icon}} icon\"></span></div><div class=\"textVertical title-h5\"><div class=\"subscriber-name\" ng-if=\"msl.serviceType == \'service_wireless\'\">{{msl.subscriberName}}</div><div ng-if=\"msl.serviceType != \'service_wireless\'\" res=\"{{msl.serviceType}}\" style=\"font-size: 14px !important;\"></div><div ng-show=\"msl.showPhone\"><strong>{{msl.serviceDetail | phone2}}</strong></div></div></div><div class=\"myServiceArrow\"></div><div class=\"myServiceCTA\"><div class=\"textVertical arrow-ctn\" ng-hide=\"((ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\')\"><a name=\"{{msl.serviceName}}\"><span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"linkMsg\" ng-show=\"(ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\'\"><span ng-bind-html=\"ms.loginMessage\"></span></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\" ng-repeat=\"msl in ms.mss.myServicesList\" ng-show=\"!dmRedirect\"><div ng-if=\"msl.isCompanion && brtEsimSwitch\"><div ng-show=\"_longname && (msl.serviceType == \'service_wireless\') && ms.isNameLong(msl.subscriberName)\" style=\"position: absolute;z-index: 1100; top: -40px; left:2%;\"><div class=\"long-name\" style=\"background-color: #BBE4EC; padding: 5px 20px; border-radius: 10px;\">{{msl.subscriberName}}</div><div class=\"caretbox\" style=\"width: 0; height: 0; border-top: 15px solid #BBE4EC; border-left: 15px solid transparent; border-right: 15px solid transparent; position:relative; top:-2px; left:50%\"></div></div><div class=\"myServiceWrap\" tabindex=\"0\" ng-mouseleave=\"_longname = false\" ng-mouseover=\"_longname = true\" ng-init=\"_longname=false\" ng-click=\'(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? ms.runService(\"{{msl.serviceName}}\", \"{{msl.serviceDetail}}\" , \"{{msl.subscriberName}}\") : \"\"\' atm=\"{{msl.atmType}}\" ng-class=\"(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? \'pointer\' : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.serviceBadgeMappingKey}}\"><div class=\"myServiceName\"><div class=\"textVertical\"><img src=\"images/Smart_business_legacy_icon.png\" style=\"max-width: 75px;max-height: 55px;padding-right:15px;\" ng-show=\"msl.serviceType == \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"> <img src=\"/web/smb/cms/images/icon_fitbit.svg\" class=\"icon-fitbit\" style=\"max-width: 75px;max-height: 55px;margin: 0 10px;\" ng-show=\"msl.serviceType != \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"></div><div class=\"textVertical title-h5 companion\"><div class=\"subscriber-name\" res=\"_apple_watch\"></div><div class=\"phone\"><strong>{{msl.serviceDetail | phone2}}</strong></div><div class=\"link\" ng-if=\"msl.isPrimaryDeviceNumber\"><span res=\"_linked\"></span> <span>{{msl.primaryDeviceNumber | phone2}}</span></div><div class=\"link\" ng-if=\"!msl.isPrimaryDeviceNumber\"><span res=\"_unlinked\"></span></div></div></div><div class=\"myServiceArrow\"></div><div class=\"myServiceCTA\"><div class=\"textVertical arrow-ctn\" ng-hide=\"((ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\')\"><a name=\"{{msl.serviceName}}\"><span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"linkMsg\" ng-show=\"(ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\'\"><span ng-bind-html=\"ms.loginMessage\"></span></div></div></div></div><div ng-if=\"!msl.isCompanion\"><div ng-show=\"_longname && (msl.serviceType == \'service_wireless\') && ms.isNameLong(msl.subscriberName)\" style=\"position: absolute;z-index: 1100; top: -40px; left:2%;\"><div class=\"long-name\" style=\"background-color: #BBE4EC; padding: 5px 20px; border-radius: 10px;\">{{msl.subscriberName}}</div><div class=\"caretbox\" style=\"width: 0; height: 0; border-top: 15px solid #BBE4EC; border-left: 15px solid transparent; border-right: 15px solid transparent; position:relative; top:-2px; left:50%\"></div></div><div class=\"myServiceWrap\" tabindex=\"0\" ng-mouseleave=\"_longname = false\" ng-mouseover=\"_longname = true\" ng-init=\"_longname=false\" ng-click=\'(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? ms.runService(\"{{msl.serviceName}}\", \"{{msl.serviceDetail}}\" , \"{{msl.subscriberName}}\") : \"\"\' atm=\"{{msl.atmType}}\" ng-class=\"(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled) ? \'pointer\' : \'\'\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"{{msl.serviceBadgeMappingKey}}\"><div class=\"myServiceName\"><div class=\"textVertical\"><img src=\"images/Smart_business_legacy_icon.png\" style=\"max-width: 75px;max-height: 55px;padding-right:15px;\" ng-show=\"msl.serviceType == \'myaccoverview_business_monotoring\'\" alt=\"\" role=\"presentation\"> <span ng-show=\"msl.serviceType != \'myaccoverview_business_monotoring\'\" class=\"{{msl.icon}} icon\"></span></div><div class=\"textVertical title-h5\"><div class=\"subscriber-name\" ng-if=\"msl.serviceType == \'service_wireless\'\">{{msl.subscriberName}}</div><div ng-if=\"msl.serviceType != \'service_wireless\'\" res=\"{{msl.serviceType}}\"></div><div ng-show=\"msl.showPhone\"><strong>{{msl.serviceDetail | phone2}}</strong></div></div></div><div class=\"myServiceArrow\"></div><div class=\"myServiceCTA\"><div class=\"textVertical arrow-ctn\" ng-hide=\"((ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\')\"><a name=\"{{msl.serviceName}}\"><span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"linkMsg\" ng-show=\"(ms.isDealer || ms.isCare) && msl.serviceName===\'homephone\'\"><span ng-bind-html=\"ms.loginMessage\"></span></div></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/myrBriteBill/briteBillView.html","<iframe id=\"bb_iframe\" class=\"bb_iframe\" scrolling=\"no\" data-ng-src=\"{{bb.trustSrc(bb.bbService.src)}}\"></iframe>");
$templateCache.put("scripts/modules/myrPaymentTopBar/paymentTopBarView.html","<div class=\"top-bar-ctn paynow-body-size ptm payment-top-bar\"><div class=\"mtm radius-three-sides light-gray-bg container plm mtl\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 ptm pbs prs\"><span class=\"title-light-h4 mbs\" style=\"position:relative; top:-5px;\"><span class=\"semi-bold\" res=\"paynow_acc_balance_today\" data-test-id=\"myr-paymentTopBar-totalAccountBalance\"></span><div class=\"rui-package-pricing title-h3\"><div class=\"price semi-bold\"><span class=\"price-sign\" ng-hide=\"ptb.lang === \'fr\'\">$</span> <span class=\"price-dollars\" data-test-id=\"myr-paymentTopBar-totalAccountBalanceDollars\">{{ptb.abs.accountBalance.balanceAmount.substr(0,ptb.abs.accountBalance.balanceAmount.indexOf(\'.\'))}}</span> <span class=\"price-details\"><span class=\"price-cents\" data-test-id=\"myr-paymentTopBar-totalAccountBalanceCents\">{{ptb.abs.accountBalance.balanceAmount | decimals : ptb.lang}} <span ng-hide=\"ptb.lang ===\'en\'\">$</span></span> <span class=\"price-period\">&nbsp;</span></span></div></div><div ng-if=\"(ptb.abdf.billingDetails.pastDueBalance > 0) && (ptb.abdf.billingDetails.balanceAmount > 0)\" class=\"red overdue-balance\" data-test-id=\"myr-paymentTopBar-includingOverdueText\"><span res=\"paynow_overdue\"></span></div></span></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 rm ptm pbs\"><div class=\"pay-now-ctn row\"><div class=\"title-light-h4 mbs\"><span class=\"semi-bold\" data-test-id=\"myr-paymentTopBar-paymentMethodLabel\" res=\"paynow_payment_method2\"></span>: <span class=\"mrm light\" data-test-id=\"myr-paymentTopBar-paymentMethod\" ng-switch=\"\" on=\"ptb.ptbs.paymentMethod\"><span ng-switch-when=\"D\" res=\"paynow_method_check\"></span> <span ng-switch-when=\"C\" res=\"paynow_payment_method_cc\"></span> <span ng-switch-when=\"R\" res=\"paynow_invoice\"></span> <span ng-switch-when=\"U\" res=\"change_method_unavailable\"></span></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"\" ng-switch=\"\" data-test-id=\"myr-paymentTopBar-paymentMethodDetails\" on=\"ptb.ptbs.paymentMethod\"><span ng-switch-when=\"D\"><span class=\"title-light-h4 semi-bold\" data-test-id=\"myr-paymentTopBar-bankAccountNumber\" res=\"paynow_bank_account_number\"></span>: {{ ptb.getBankAccountNumber()}}</span> <span ng-switch-when=\"C\" class=\"payment-method-details\"><img class=\"payment-method-image\" data-test-id=\"myr-paymentTopBar-ccImage\" ng-src=\"{{ ptb.getCreditCardImage() }}\"> <span data-test-id=\"myr-paymentTopBar-ccType\"><strong>{{ ptb.getCreditCardText() }}</strong></span><br><span data-test-id=\"myr-paymentTopBar-ccNumber\">XXXX XXXX XXXX {{ ptb.abdf.billingDetails.methodOfPayment.creditCardDetails.ccNumber }}</span></span> <span ng-switch-when=\"R\"></span> <span ng-switch-default=\"\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\" ng-hide=\"ptb.state === \'changemethod\'\"><a class=\"mrm button-view-bill\" href=\"#/changePayMethod\" data-ng-class=\"ptb.btnSettings.changePaymentMethod === ptb.btnStatus.disabled ? \'not-active\' : \'\'\" data-ng-hide=\"ptb.btnSettings.changePaymentMethod === ptb.btnStatus.hidden\"><span res=\"paynow_change_bill_type\" data-test-id=\"myr-paymentTopBar-changePaymentMethod\" class=\"bold mts\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\" ng-hide=\"ptb.state === \'paymenthistory\'\"><a class=\"button-view-bill\" href=\"#/payHistory\"><span res=\"history\" data-test-id=\"myr-paymentTopBar-paymentHistory\" class=\"bold\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 ptm pbs prs\"><div style=\"display:none;\">{{ptb.state}} BB Version 0.16.3</div><myr-account-balance view-html=\"accountBalanceHorizon.html\" permission=\"VIEW_ACCOUNT_BALANCE\"></myr-account-balance><div ng-show=\"ptb.state != \'paynow\'\"><div class=\"brite-bill-pay-now\"><button name=\"payBill\" class=\"cta-round primary large pay-now-btn-cm2\" ng-click=\"ptb.payBill()\" data-test-id=\"myr-paymentTopbar-payBill\"><span class=\"white\" res=\"acc_balance_pay_now\"></span></button></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 pbs txtC\" ng-show=\"ptb.state !=\'paynow\'\"><div ng-show=\"ptb.state != \'paynow\'\"><div ng-show=\"isPaynowPage\" class=\"mbm\">&nbsp;</div><div class=\"primary ptm\" ng-show=\"false\"><span class=\"\" ng-if=\"isPrepaid && !isPreAuth\" res=\"acc_overview_expires_on\"></span> <span class=\"\" ng-if=\"isPrepaid && isPreAuth\" res=\"acc_overview_withdrawal_by\"></span><div class=\"prm\" ng-show=\"hasBallance\"><div class=\"\" ng-switch=\"\" on=\"ptb.ptbs.paymentMethod\"><span ng-switch-when=\"D\" res=\"acc_overview_due_debit\"></span> <span ng-switch-when=\"C\" res=\"acc_overview_due_credit\"></span> <span ng-switch-when=\"R\" res=\"acc_overview_due_invoice\"></span> <span ng-switch-default=\"\"></span> :</div><div><span class=\"semi-bold\">{{(lng === \'en\') ? dtEn : dtFr}}</span></div></div></div></div></div></div></div><div class=\"mtm radius-three-sides container plm mtl\" ng-hide=\"vb.isNoBillsAvailable() || vb.isBriteBillErrorOccurred()|| vb.isInvoiceProcessing()\"><div ng-show=\"ptb.showInvoiceDates\" class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 prm ptm pbs\"><span class=\"view-bill-for float-left\" res=\"view_bill_for\" data-test-id=\"myr-paymentTopBar-viewBillTitle\"></span><div class=\"view-bill-title\"><br><span class=\"title-light-h4 semi-bold inline-block prs ptm float-left\" res=\"view_billing_date\" data-test-id=\"myr-paymentTopBar-billingDateText\"></span></div><div class=\"styled-select select-pay-now inline-block\" ng-hide=\"briteBillFailed\"><select class=\"inline txtM invoice-date\" data-test-id=\"myr-paymentTopBar-viewBillingDateCombobox\" name=\"invoiceDate\" id=\"invoiceDate\" required=\"\" data-ng-model=\"ptb.bb.invoiceDateSelected\" data-ng-change=\"ptb.invoiceDateChange()\" ng-options=\"date.id as date.name for date in ptb.bb.invoiceDateArray\"></select></div><div class=\"widget-loader-inline\" ng-show=\"ptb.bbloadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><span class=\"widget-loader-inline\" ng-show=\"ptb.bb.loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></div></div><div class=\"widget-loader-inline invoiceLoader\" ng-show=\"vb.isInvoiceProcessing() || vb.isLegacyRedirection()\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div><div class=\"row light-gray-bg margin-top15\" ng-if=\"isWirelessAccount()\"><div class=\"container error-message\" data-ng-if=\"vb.isNoBillsAvailable() || vb.isBriteBillErrorOccurred()\"><div class=\"col-xs-12\"><div ng-if=\"vb.isNoBillsAvailable() && !vb.isBriteBillErrorOccurred()\"><div class=\"brite-bill-nobill-image\"><img ng-src=\"images/info_notice_lg.png\"></div><div class=\"error-message-title\" res=\"bb_error_message_header_no_bill\"></div><div class=\"error-message\"><span res=\"bb_error_message_no_bill\"></span> <span>{{ptb.billingCycleEndDate() | date:\'MM/dd\'}}.</span></div></div><div ng-if=\"vb.isBriteBillErrorOccurred()\"><img class=\"brite-bill-error-image\" ng-src=\"images/warning_yellow_lg.png\"><div class=\"information\"></div><div class=\"error-message-title\" res=\"bb_error_message_header_system_issue\"></div><div class=\"error-message\" res=\"bb_error_message_system_issue\"></div><div class=\"row brite-bill-live-chat\"><div class=\"col-sm-6 col-xs-12 brite-bill-live-chat-right hidden-xs\"><img class=\"phone-image\" ng-src=\"images\\phone.png\"><span res=\"800_number\"></span></div><div class=\"col-xs-12 col-sm-6 brite-bill-live-chat-left\"><bold-chat-static-button ng-if=\"lang === \'en\'\" data-cbid=\"{{boldChat.viewBillError.en.cbid}}\" data-dynamic-div=\"{{boldChat.viewBillError.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.viewBillError.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"lang === \'fr\'\" data-cbid=\"{{boldChat.viewBillError.fr.cbid}}\" data-dynamic-div=\"{{boldChat.viewBillError.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.viewBillError.fr.chatButtonClass}}\"></bold-chat-static-button></div></div></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 cta-round bb-account-overview\" ui-sref=\"accountOverview\" res=\"return_to_account_overview\"></div></div></div>");
$templateCache.put("scripts/modules/myrViewBill/viewBill.html","<section class=\"page-brite-bill\"><myr-payment-top-bar controller-name=\"MyrPaymentTopBarController\" ng-if=\"vb.isCable\"></myr-payment-top-bar><myr-payment-top-bar controller-name=\"utePaymentTopBarController\" ng-if=\"!vb.isCable\"></myr-payment-top-bar><div class=\"container error-message\" data-ng-show=\"vb.briteBillFailed\"><span res=\"bb_error_message\"></span></div><div data-test-id=\"myr-viewBill-briteBillIFrame\" id=\"bb_iframe_container\" class=\"iframe-ctn bb-iframe-container\" data-myr-brite-bill=\"\"></div></section>");
$templateCache.put("scripts/modules/notificationBanner/notificationBanner.html","<div class=\"ng-cloak row message-banner notification success mtm mbm\" data-ng-cloak=\"\" data-ng-show=\"nb.isVisible()\"><div class=\"pln prn\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 mls\" style=\"max-width: 45px;\"><i class=\"fa fa-check-circle fa-2x success-color\"></i></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10\" style=\"padding: 0 10px 0 5px;\"><div class=\"mbs mts word-wrap\" data-ng-bind-html=\"nb.getMessage()\"></div></div></div></div>");
$templateCache.put("scripts/modules/payHistory/payHistory.html","<payment-history data-account-no=\"selectedAccNum\" data-lob=\"selectedAccLOB\" data-contact-id=\"selectedAccContactId\" data-account-nick-name=\"selectedAccName\"></payment-history>");
$templateCache.put("scripts/modules/payHistory/paymentHistory.html","<div class=\"container\"><div id=\"paymentHistory\" ng-controller=\"paymentHistoryController\"><div class=\"row\"><div class=\"breadCrumbs col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"previousContainer\"><a ng-click=\"redirectBack()\" style=\"cursor: pointer;\" class=\"textPreviousContainer\"><span res=\"bss_paymentHistory_backToPreviousPage\"></span></a> <a ng-click=\"redirectBack()\" style=\"cursor: pointer;\" class=\"textPreviousContainerMobile\"><span res=\"bss_paymentHistory_backToPreviousPage\"></span></a></div><div class=\"sectionTitle col-xs-12 col-sm-12 col-md-8 col-lg-8\" res=\"bss_paymentHistory_paymentHistory\"></div></div></div><div class=\"loading-container\" ng-show=\"loadingIndicator\"><div class=\"hidden-xs hidden-sm loadingIndEn\"><img src=\"images/widget-loader-lg.gif\"></div><div class=\"hidden-md hidden-lg loadingIndEn\"><img src=\"images/widget-loader-lg_plain.gif\"></div></div><div class=\"content\" ng-show=\"!showPaymentHistoryErrorSection && !loadingIndicator\"><div class=\"accountDetails col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"accountHeading hidden-xs hidden-sm col-md-8 col-lg-8\" res=\"bss_paymentHistory_accountHeading\"></div><div class=\"accountNumber col-xs-12 col-sm-12 col-md-8 col-lg-8\"><span class=\"accountNickName\">{{accountNickName}}</span><span>{{accountNo}}</span></div></div><div class=\"row paginationContainer\" ng-show=\"showPaymentHistoryRecordsSection\"><div class=\"hidden-xs hidden-sm col-md-8 col-lg-8\"><div class=\"pageNumbers\"><div><a class=\"next\" href=\"\" ng-hide=\"hideNext\" ng-click=\"pagenumberScrollHolderatePage(\'next\')\"></a></div><div class=\"pagenumberScrollHolder\"><div ng-style=\"{\'left\':leftProperty}\" class=\"pagenumberScroll\"><a class=\"pageNumberDigit\" href=\"\" ng-repeat=\"id in ctrlArr\" ng-class=\"{activePage:activePageIndex==\'{{$index}}\'}\" ng-click=\"pagenumberScrollHolderatePage($index)\">{{id}}</a></div></div><div><span>{{i18n.bss_paymentHistory_paginationInfo1}} {{currentPage}} - {{(currentPage+9)>listLength?listLength:currentPage+9}}<span res=\"bss_paymentHistory_paginationInfo2\"></span>{{listLength}}</span> <a class=\"prev\" href=\"\" ng-hide=\"hidePrev\" ng-click=\"pagenumberScrollHolderatePage(\'prev\')\"></a></div></div></div></div><div class=\"row rowheading\"><div class=\"header-container col-xs-12 col-sm-12 col-md-8 col-lg-8 padding-reset\"><div class=\"col-xs-5 col-sm-5 col-md-3 col-lg-3 date\" ng-click=\"orderPayHistoryLabel(\'transDate\')\"><span ng-class=\"{activeSort:sortLable === \'transDate\'}\" res=\"bss_paymentHistory_date\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'transDate\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'transDate\')&& orderToggle\">&#x25BC;</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3 transactionType\" ng-click=\"orderPayHistoryLabel(\'tranType\')\"><span ng-class=\"{activeSort:sortLable === \'tranType\'}\" res=\"bss_paymentHistory_transaction\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'tranType\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'tranType\')&& orderToggle\">&#x25BC;</span></div><div class=\"col-xs-4 col-sm-4 col-md-3 col-lg-3 amount\" ng-click=\"orderPayHistoryLabel(\'amount\')\"><span ng-class=\"{activeSort:sortLable === \'amount\'}\" res=\"bss_paymentHistory_amount\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'amount\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'amount\')&& orderToggle\">&#x25BC;</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3 refNo\" ng-click=\"orderPayHistoryLabel(\'refNo\')\"><span ng-class=\"{activeSort:sortLable === \'refNo\'}\" res=\"bss_paymentHistory_reference\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'refNo\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'refNo\')&& orderToggle\">&#x25BC;</span></div><div class=\"col-xs-3 col-sm-3 hidden-md hidden-lg payDetailAccordion\"></div></div></div><div ng-show=\"showPaymentHistoryRecordsSection\" class=\"row\" id=\"history{{$index}}\" ng-class=\"{lastDetail:$index==pageList.length-1}\" ng-repeat=\"list in pageList| orderBy:sortLable:reverse | startFrom: currentPage-1 |limitTo:limiter\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8 rowlist\"><div class=\"row listcontent\"><div class=\"col-xs-5 col-sm-5 col-md-3 col-lg-3 date\"><span>{{list.transDate | date:\'MMM dd,yyyy\'}}</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3 transactionType\"><span>{{list.tranType}}</span></div><div class=\"col-xs-4 col-sm-4 col-md-3 col-lg-3 amount\"><span>{{list.amount | currencies:userlang}}</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3\"><span>{{list.refNo}}</span></div><div class=\"col-xs-3 col-sm-3 hidden-md hidden-lg payDetailAccordion\"><span ng-click=\"detailsShowHide($index)\">{{i18n.bss_paymentHistory_detail}} <span ng-hide=\"showDetails[$index]\">[+]</span> <span ng-show=\"showDetails[$index]\">[&#8212]</span></span></div></div></div><div class=\"row paymentDetails\" ng-if=\"showDetails[$index]\"><div class=\"paymentDetailsBackground\"><div class=\"details-container\"><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_paymentDate\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.transDate | date:\'MMM dd,yyyy\'}}</div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_transaction\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.tranType}}</div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_amount\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.amount}}</div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_reference\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.refNo}}</div></div></div></div></div></div><div ng-show=\"!showPaymentHistoryRecordsSection\" class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\"><div class=\"noRecordsFound\" res=\"bss_paymentHistory_noRecordsFound\"></div></div></div><div class=\"row paginationContainer\" ng-show=\"showPaymentHistoryRecordsSection\"><div class=\"hidden-xs hidden-sm col-md-8 col-lg-8\"><div class=\"pageNumbers\"><div style=\"\"><a class=\"next\" href=\"\" ng-hide=\"hideNext\" ng-click=\"pagenumberScrollHolderatePage(\'next\')\"></a></div><div class=\"pagenumberScrollHolder\"><div ng-style=\"{\'left\':leftProperty}\" class=\"pagenumberScroll\"><a class=\"pageNumberDigit\" href=\"\" ng-repeat=\"id in ctrlArr\" ng-class=\"{activePage:activePageIndex==\'{{$index}}\'}\" ng-click=\"pagenumberScrollHolderatePage($index)\">{{id}}</a></div></div><div style=\"\"><span><span res=\"bss_paymentHistory_paginationInfo1\"></span> {{currentPage}} - {{(currentPage+9)>listLength?listLength:currentPage+9}} <span res=\"bss_paymentHistory_paginationInfo2\"></span>{{listLength}}</span> <a class=\"prev\" href=\"\" ng-hide=\"hidePrev\" ng-click=\"pagenumberScrollHolderatePage(\'prev\')\"></a></div></div></div></div><div class=\"row mobilePaginationContainer\" ng-show=\"showPaymentHistoryRecordsSection\"><div class=\"col-xs-12 col-sm-12 hidden-md hidden-lg\"><div class=\"pageNumbers\"><span><span res=\"bss_paymentHistory_paginationInfo1\"></span> 1 - {{limiter}} <span res=\"bss_paymentHistory_paginationInfo2\"></span> {{listLength}}</span></div><div class=\"row paginationButton\"><button type=\"button\" class=\"pageNumberButton col-xs-12 col-sm-12\" ng-show=\"showNextButton\" ng-click=\"clicker()\">Show Next {{leftover}}</button></div></div></div></div><div class=\"paymentHistoryError\" ng-show=\"showPaymentHistoryErrorSection\"><div class=\"row\"><div class=\"col-xs-10 col-sm-10 col-md-8 col-lg-8 error\"><div res=\"bss_paymentHistory_systemError1\"></div><div res=\"bss_paymentHistory_systemError2\"></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/payNow/payNow.html","<script type=\"text/javascript\">\n  $(\'.moneyOnly\').keypress(function (e) {\n    if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57) && e.which !== 44 && e.which !== 46) {\n      return false;\n    }\n  });\n  $(\".numbersOnly\").keypress(function (e) {\n    if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {\n      return false;\n    }\n  });\n</script><div class=\"container\" ng-show=\"isError\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8 mtm\"><div class=\"row info-banner error mts mbm\" style=\"margin-left: 0px;\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11\" style=\"float:left;padding-left:10px;\"><span ng-bind-html=\"errorMessage\"></span></div></div></div></div></div><section class=\"page-pay-now\" id=\"topPayment\" ng-hide=\"isError\"><div ng-cloak=\"\"><div data-ng-include=\"\'scripts/modules/paymentTopBar/paymentTopBar.html\'\"></div><form name=\"form\" novalidate=\"\"><div class=\"container\"><div class=\"row\"><div class=\"ptm primary-color pbs title-light-h2 uppercase\" res=\"paynow_title\"></div></div></div><div class=\"container\"><div class=\"no-padding\" ng-show=\"!isConfirmPanel\"><div class=\"row\"><div class=\"mtm\"><div class=\"row info-banner error mts mbm\" style=\"margin-left: 0px;\" data-ng-show=\"(form.$valid == false && form.$submitted && form.$pristine == false) || !isAmountValid || !isValidCard || isCardNoEmpty\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding\" style=\"max-width: 45px;\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><span res=\"paynow_general_error\"></span></div></div></div></div><div class=\"row rel\" data-ng-hide=\"!isPreAuthorized\"><div class=\"visible-xs visible-sm col-xs-12 col-sm-12 col-md-0 col-lg-0\"><div class=\"radius\"><div class=\"did-you-know-ctn\"><span class=\"did-you-know-title\" res=\"shm_promo_title\"></span> <span class=\"did-you-know-promo-txt\" res=\"change_method_intro\"></span></div></div></div><div class=\"visible-md visible-lg col-xs-12 col-sm-12 col-md-12 col-lg-12 rel\"><div class=\"pin-tr radius mtl\"><div class=\"did-you-know-ctn\" style=\"width:360px;margin-top:50px;\"><span class=\"did-you-know-title\" res=\"shm_promo_title\"></span> <span class=\"did-you-know-promo-txt\" res=\"change_method_intro\"></span></div></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-xs-12 col-sm-12 mtm\"><h3 class=\"pay-now-sub-title pay-now-payment-amount\" res=\"paynow_payment_amount\"></h3><div class=\"row\"><div class=\"col-lg-9 col-sm-11 col-xs-11 pbs\"><div class=\"inline_error\" ng-messages=\"form.paymentAmount.$error\" ng-show=\"form.paymentAmount.$invalid && (form.paymentAmount.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"paynow_payment_required\"></span></span> <span ng-message=\"pattern\"><span res=\"paynow_payment_required\" class=\"prm\"></span></span></div><div ng-hide=\"form.paymentAmount.$invalid && (form.paymentAmount.$dirty || form.$submitted)\"><span class=\"inline_error\" res=\"paynow_payment_required\" ng-show=\"!isOverPaid && !isAmountValid\"></span> <span class=\"inline_error\" res=\"paynow_larger\" ng-show=\"isOverPaid && isAmountValid\"></span> <span class=\"inline_error\" res=\"paynow_tooLarge\" ng-show=\"isOverPaid && !isAmountValid\"></span></div></div></div><div class=\"row\"><div class=\"col-lg-1 col-md-1 col-sm-2 col-xs-2\" ng-show=\"lang === \'en\'\" style=\"max-width:20px;\"><span ng-show=\"lang === \'en\'\" class=\"pay-now-sub-title dollar-ctn pts inline-block\">$</span></div><div class=\"col-lg-9 col-sm-10 col-xs-10\" style=\"max-width:250px;\"><label class=\"rel\"><input data-tl-private=\"\" type=\"text\" tabindex=\"1\" class=\"title-light-h5 moneyOnly\" name=\"paymentAmount\" id=\"paymentAmount\" maxlength=\"10\" style=\"width:250px;\" data-ng-blur=\"validateAmount()\" data-ng-model=\"paymentAmount\" required=\"\"> <span ng-show=\"isAmountValid && form.paymentAmount.$dirty && form.paymentAmount.$valid\" class=\"inline-checker icon-checked\"></span> <span class=\"inline-checker icon-error\" data-ng-show=\"!isAmountValid || (form.paymentAmount.$invalid && (form.paymentAmount.$dirty || form.$submitted))\"></span></label></div><div class=\"col-lg-1 col-md-1 col-sm-2 col-xs-2\" ng-show=\"lang === \'fr\'\"><span class=\"pay-now-sub-title dollar-ctn pls pts inline-block\">$</span></div></div></div></div><div class=\"row ptl mts\"><div class=\"\"><h3 class=\"pay-now-sub-title\" res=\"paynow_method\"></h3></div></div><div class=\"row pbl\"><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-12 ptm\"><div class=\"select-payment-method\" ng-class=\"creditPaymentObj.isCreditCard === true ? \'border-payment-selected\' : \'border - payment\'\" ng-click=\"makeCCPayment();\"><div class=\"row\"><div class=\"txtC\"><img class=\"inline\" ng-src=\"{{paymentMethods.creditcard.image}}\"><div class=\"ptm\"><span class=\"title-h5 semi-bold inline-block txtC\" ng-bind-html=\"paymentMethods.creditcard.name\"></span></div></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-12 ptm interac-ctn\" ng-click=\"makeInteracPayment();\"><div class=\"select-payment-method\" ng-class=\"creditPaymentObj.isCreditCard === false ? \'border-payment-selected\' : \'border - payment\'\"><div class=\"row\"><div class=\"txtC\"><img ng-src=\"{{paymentMethods.interac.image}}\"><div class=\"ptm\"><span class=\"title-h5 capitalize semi-bold\" ng-bind-html=\"paymentMethods.interac.name\"></span></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span res=\"paynow_interac_2\"></span></div></div></div></div></div><div id=\"formCreditCard\" class=\"ptm wrapper\" ng-show=\"selectedCreditCard && !isConfirmPanel\"><form-credit-card></form-credit-card><div class=\"row ptm pbl mbl\"><div class=\"col-lg-6 col-md-6 col-sm-12 com-xs-12 cc-btn-ctn\"><a name=\"cancel\" ng-click=\"cancelPayNow()\" class=\"link-cancel pull-left pointer\"><span res=\"_cancel\"></span></a> <button name=\"buttonSubmit\" id=\"buttonSubmit\" class=\"cta-round primary medium full pull-right\" data-ng-click=\"submit()\"><span res=\"_continue\"></span></button></div></div></div><div class=\"row ptm pbm interac-ctn-sm\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 grx mbs cursor\" ng-click=\"makeInteracPayment();\"><div class=\"select-payment-method\" ng-class=\"creditPaymentObj.isCreditCard === false ? \'border-payment-selected\' : \'border - payment\'\"><div class=\"row\"><div class=\"txtC\"><img ng-src=\"{{paymentMethods.interac.image}}\"><div class=\"ptm\"><span class=\"title-h5 capitalize semi-bold\" ng-bind-html=\"paymentMethods.interac.name\"></span></div></div></div><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span res=\"paynow_interac_2\"></span></div></div></div></div></div></div></div><div class=\"container\"><div class=\"row mrm\" ng-show=\"isConfirmPanel===true\"><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12\"><div class=\"row mtm mbm\"><div class=\"col-lg-8 col-md-8 col-sm-10 col-xs-10\"><h3 class=\"bold mts\" res=\"paynow_review_details\"></h3></div><div class=\"col-lg-4 col-md-4 col-sm-2 col-xs-2 mtm align-right\"><a name=\"showEdit\" class=\"title-h5 pointer\" ng-click=\"showEdit()\"><span res=\"paynow_edit\" class=\"bold\"></span></a></div></div><div class=\"row mtm mbm\"><div class=\"col-lg-6 col-md-6 col-sm-8 col-xs-8\"><h3 res=\"paynow_review_amount\"></h3></div><div class=\"col-lg-6 col-md-6 col-sm-4 col-xs-4 align-right\"><h3 class=\"bold\" ng-show=\"lang === \'en\'\">{{paymentAmount| currency }}</h3><h3 class=\"bold\" ng-show=\"lang === \'fr\'\">{{paymentAmount| replace: \"\\.\":\",\"}} $</h3></div></div><div class=\"row mts mbm\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12\"><h3 res=\"paynow_review_method\"></h3></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 align-right cc-masked-digits-ctn\"><img ng-src=\"{{creditPaymentObj.creditCardType.image}}\" class=\"mrs mbs\"> <span class=\"cc-masked-digits bold\">{{maskedCC}}</span></div></div><div class=\"row mtm mbm\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><h3 res=\"paynow_review_date\"></h3></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 align-right\"><h3 class=\"bold\">{{dtPaid}}</h3></div></div><div class=\"row mtl mbm\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><div class=\"pull-left\"><a name=\"showCancel\" class=\"title-h5 bold pointer\" data-ng-click=\"showCancel()\"><span res=\"_cancel\"></span></a></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 align-right\"><button name=\"button_continue\" type=\"button\" ng-class=\"{disabled: loadingDataIndicatorPayment, \'\':!loadingDataIndicatorPayment}\" class=\"cta-round primary medium\" data-ng-click=\"submit()\"><span res=\"_continue\"></span></button> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicatorPayment\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></div></div></div></div></div></form></div></section><payment-helper></payment-helper><div ng-show=\"false\"><form name=\"formToRogers123\" id=\"formToRogers123\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_MERCHNUM\" data-ng-model=\"merchantNumber\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_TERMID\" data-ng-model=\"IDEBIT_TERMID\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_AMOUNT\" data-ng-model=\"IDEBIT_AMOUNT\"><br><input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_CURRENCY\" value=\"CAD\"><br><input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_INVOICE\" data-ng-model=\"IDEBIT_INVOICE\"><br><input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_MERCHDATA\" data-ng-model=\"IDEBIT_MERCHDATA\"><br><input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_FUNDEDURL\" data-ng-model=\"urlInteracSuccess\"><br><input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_NOTFUNDEDURL\" data-ng-model=\"urlInteracFailure\"><br><input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_MERCHLANG\" data-ng-model=\"lang\"><br><input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_VERSION\" value=\"1\"></form></div>");
$templateCache.put("scripts/modules/payNow/payNowContinueModal.html","<div class=\"totes-project\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span res=\"billing_title\"></span></h4><div ng-if=\"!showCreditCardForm && !showDebitForm\"><span res=\"to_pay_a_bill\"></span></div><div ng-if=\"showCreditCardForm || showDebitForm\"><span res=\"to_update_customer_payment_method\"></span></div><div class=\"body-section\"><div class=\"small-heading\"><span res=\"if_the_customer_has_a_wireless_product\"></span></div><div ng-if=\"isPaynow\"><div class=\"\"><span res=\"if_you_are_at_call_center_go_to_v21\"></span></div><div ng-if=\"!isLanguageFr\"><span res=\"if_you_are_at_retail_location_use_a_pos\"></span></div></div><div ng-if=\"!isPaynow\"><div ng-if=\"!isLanguageFr\"><div><span res=\"if_you_are_at_call_center_go_to_v21\"></span></div><div><span res=\"if_you_are_at_retail_location_go_to_ssp\"></span></div></div><div ng-if=\"isLanguageFr\"><span res=\"if_you_are_at_call_center_go_to_v21_fr\"></span></div></div><div class=\"small-heading\"><span res=\"if_the_customer_has_only_residential_products\"></span></div><div ng-if=\"isPaynow\"><div><span res=\"if_you_are_at_call_center_go_to_sgi\"></span></div><div ng-if=\"!isLanguageFr\"><span res=\"if_you_are_at_retail_location_use_a_pos\"></span></div></div><div ng-if=\"!isPaynow\"><div ng-if=\"!isLanguageFr\"><div><span res=\"if_you_are_at_call_center_go_to_sgi\"></span></div></div><div ng-if=\"isLanguageFr\"><span res=\"if_you_are_at_call_center_go_to_sgi_fr\"></span></div></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"close()\"><span res=\"close\"></span></button></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/pdWhiteList/pdWhiteList.html","<section class=\"pd-white-list\"><div class=\"col-xs-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"wireless\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-9\"><div class=\"white-list-section\"><div class=\"white-list-success\" ng-if=\"vm.isPdEligible\"><img src=\"/web/smb/cms/images/icon_success.svg\" alt=\"\" role=\"presentation\"><div class=\"content\"><h2 res=\"_success_title\"></h2><p res=\"_success_content\"></p></div></div><div class=\"white-list-failure\" ng-if=\"vm.updateEligiblityFailed\"><img src=\"/web/smb/cms/images/warning_yellow.png\" alt=\"\" class=\"icon\" role=\"presentation\"><div class=\"content\"><h2 res=\"_failure_title\"></h2><p res=\"_failure_content\"></p></div></div><div ng-if=\"!vm.isPdEligible && !vm.whiteListStatus\"><h5 class=\"white-list-header\" res=\"_white_list_header\"></h5><p class=\"white-list-content\" res=\"_white_list_content_title\"></p><p class=\"white-list-content\" res=\"_white_list_content\"></p></div><div ng-if=\"vm.whiteListStatus && !vm.isPdEligible\"><h5 class=\"white-list-header\" res=\"_unwhite_list_header\"></h5></div><div class=\"enable\" ng-if=\"!vm.isPdEligible\"><span ng-if=\"!vm.whiteListStatus\" res=\"_link\"></span> <span ng-if=\"vm.whiteListStatus\" res=\"_unlink\"></span> <label class=\"cta-toggle\"><input type=\"checkbox\" name=\"ctaToggle\" ng-model=\"vm.whiteListed\" ng-click=\"vm.checkWhiteListStatus()\" ng-disabled=\"vm.confirmationPage\"><div class=\"slider\"></div></label></div><div class=\"terms-section\" ng-if=\"vm.showTermsAndConditions && !vm.whiteListStatus\"><div class=\"terms-and-condition\"><div class=\"content\"><ute-content-injector language=\"{{lang}}\" ignore-province=\"true\" compile=\"true\" content-id=\"/web/smb/cms/content/rogersBSS/terms_and_conditions/terms_and_conditions\"></ute-content-injector></div></div><div class=\"agreement\"><label class=\"pd-checkbox\"><input type=\"checkbox\" name=\"serviceAgreement\" ng-model=\"vm.acceptAgreement\"><div class=\"tandc-checkbox\"></div></label><div class=\"tandc\" res=\"_white_list_acceptance\"></div></div></div><div class=\"submit\"><a ng-hide=\"vm.isPdEligible\" class=\"cta-round label medium hidden-xs\" res=\"_cancel\" ui-sref=\"wireless\"></a> <button class=\"cta-round primary medium\" res=\"_submit\" ng-if=\"vm.showTermsAndConditions && !vm.isPdEligible\" ng-click=\"vm.updatePdEligibility()\" ng-disabled=\"!vm.acceptAgreement && !vm.whiteListStatus\"></button> <span class=\"widget-loader-inline whitelistWidget\" ng-show=\"vm.waitingWhiteList\"><img src=\"images/widget-loader.gif\" alt=\"\"></span> <a class=\"cta-round primary medium\" ui-sref=\"wireless\" res=\"_continue\" ng-if=\"vm.isPdEligible\"></a> <a class=\"cta-round primary medium\" ui-sref=\"wireless\" res=\"_continue\" ng-if=\"vm.updateEligiblityFailed\"></a><div class=\"cancel visible-xs\"><a class=\"cta-round label medium\" res=\"_cancel\" ui-sref=\"wireless\"></a></div></div></div></div><div class=\"col-xs-12 col-sm-3\"></div></div></div></section>");
$templateCache.put("scripts/modules/registration/registration.html","<div class=\"page-registration\"><div class=\"container\"><form name=\"form\" novalidate=\"\" label=\"Registration\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"#/signin\" res=\"_my_rogers_nospace\"></a></li><li class=\"child-1\"><span res=\"_registration\"></span></li></ul></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 mtm\"><div class=\"row info-banner error mts mbm\" data-ng-show=\"isError\" style=\"margin-left: 0px;\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\" style=\"float:left\"><span ng-bind-html=\"errorDescription\"></span><bold-chat-static-button ng-if=\"isError && lang === \'en\'\" data-cbid=\"\'S_BSS_Login\'\" data-bold-chat-div=\"\'S_BSS_Registration_Page_div\'\" data-chat-button=\"\'chatButtonRegistrationEn\'\" data-error-message=\"errorMessageBoldChat\"></bold-chat-static-button><bold-chat-static-button ng-if=\"isError && lang === \'fr\'\" data-cbid=\"\'S_BSS_Login_Fr\'\" data-bold-chat-div=\"\'S_BSS_Registration_Page_Fr_div\'\" data-chat-button=\"\'chatButtonRegistrationFr\'\" data-error-message=\"errorMessageBoldChat\"></bold-chat-static-button></div></div><div class=\"row info-banner error mts mbm\" style=\"margin-left: 0px;\" data-ng-show=\"(form.$valid == false && form.$submitted)\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><span res=\"_check_form_errors\"></span></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h4>1. <span res=\"_contact_info\"></span></h4></div></div><div class=\"row mbm\"><div class=\"col-lg-6 col-md-6\"><div class=\"inline_error\" ng-messages=\"form.email.$error\" ng-show=\"(form.email.$dirty || form.$submitted) && (form.email.$invalid || form.email !== form.confirmEmail && form.confirmEmail !== \'\')\"><span ng-message=\"required\"><span res=\"_require_email\"></span></span> <span ng-message=\"pattern\"><span res=\"_email_address_not_valid\"></span></span> <span ng-message=\"mismatchEmail\"><span res=\"_email_not_matched\"></span></span></div><label class=\"rel\"><input type=\"text\" validation-tag=\"\" tag-form-name=\"form\" tag-page-name=\"Registration\" name=\"email\" id=\"email\" ng-pattern=\"/^\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" res-attr=\"{ placeholder: \'_email\' }\" maxlength=\"105\" ng-model-options=\"{ updateOn: \'blur\' }\" onpaste=\"return false;\" data-ng-model=\"regObj.email\" match-email=\"\" required=\"\" autocorrect=\"off\" autocapitalize=\"off\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.email.$invalid && (form.email.$dirty || form.$submitted)\"></span> <span ng-show=\"form.email.$dirty && form.email.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-lg-6 col-md-6\"><div class=\"inline_error\" ng-messages=\"form.confirmEmail.$error\" ng-show=\"(form.confirmEmail.$dirty || form.$submitted) && (form.confirmEmail.$invalid || form.confirmEmail !== form.email && form.email !== \'\')\"><span ng-message=\"required\"><span res=\"_require_confirm_email\"></span></span> <span ng-message=\"pattern\"><span res=\"_email_address_not_valid\"></span></span> <span ng-message=\"mismatchEmail\"><span res=\"_email_not_matched\"></span></span></div><label class=\"rel\"><input type=\"text\" name=\"confirmEmail\" tag-form-name=\"form\" tag-page-name=\"Registration\" res-attr=\"{placeholder: \'_confirm_email\'}\" ng-model-options=\"{ updateOn: \'blur\' }\" data-ng-model=\"confirmEmail\" onpaste=\"return false;\" match-email=\"\" required=\"\" autocorrect=\"off\" autocapitalize=\"off\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.confirmEmail.$invalid && (form.confirmEmail.$dirty || form.$submitted)\"></span> <span ng-show=\"form.confirmEmail.$dirty && form.confirmEmail.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 lang-btn-ctn\"><div class=\"\"><span res=\"registration_language\"></span></div><label class=\"btn btn-default left mtm\" ng-class=\"regObj.lang == lang ? \'box_selected\' : \'radio_unselected\'\" ng-repeat=\"(lang, title) in languages\"><input type=\"radio\" ng-model=\"regObj.lang\" ng-value=\"lang\" value=\"{{title}}\"> <span class=\"prm\">{{title}}</span></label></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h4>2. <span res=\"_password_reminder\"></span></h4></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"inline_error\" ng-messages=\"form.password.$error\" ng-show=\"(form.password.$dirty || form.$submitted) && form.password.$invalid && form.confirmPassword !== \'\'\"><span ng-message=\"required\"><span res=\"login_invalid_password\"></span></span><span ng-message=\"minlength\"><span res=\"registration_too_short\"></span></span> <span ng-message=\"maxlength\"><span res=\"registration_too_long\"></span></span> <span ng-message=\"pattern\"><span res=\"registration_wrong_password\"></span></span></div></div></div><div class=\"row mbm\"><div class=\"col-xs-11 col-sm-11 col-md-11\"><label class=\"rel\"><input data-tl-private=\"\" type=\"password\" name=\"password\" tag-form-name=\"form\" tag-page-name=\"Registration\" res-attr=\"{placeholder: \'_password\'}\" ng-minlength=\"7\" ng-maxlength=\"16\" ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#\\$%\\^\\&*\\)\\(+=._-]{7,16}$/\" ng-change=\"checkPassword()\" ng-model-options=\"{ updateOn: \'blur\' }\" onpaste=\"return false;\" data-ng-model=\"regObj.password\" required=\"\" autocorrect=\"off\" autocapitalize=\"off\" cobrowse=\"false\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.password.$invalid && (form.password.$dirty || form.$submitted)\"></span> <i ng-show=\"form.password.$dirty && form.password.$valid\" class=\"inline-checker icon-checked\"></i></label></div><div class=\"col-lg-1 col-md-1 col-xs-1 col-sm-1 mtss tooltip-ctn-reg\"><a alt=\"{{tooltip}}\" class=\"tooltipText\"><span class=\"new-info-icon\">i</span></a></div></div></div></div><div class=\"row mbm\"><div class=\"col-md-6\"><div class=\"inline_error\" ng-messages=\"form.confirmPassword.$error\" ng-show=\"form.confirmPassword.$invalid && (form.confirmPassword.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"login_re_enter\"></span></span> <span ng-message=\"mismatchPassword\"><span res=\"_password_not_matched\"></span></span></div><label class=\"rel\"><input data-tl-private=\"\" type=\"password\" name=\"confirmPassword\" tag-form-name=\"form\" tag-page-name=\"Registration\" res-attr=\"{placeholder: \'_confirm_password\'}\" match-password=\"\" ng-model-options=\"{ updateOn: \'blur\' }\" password=\"regObj.password\" confirmpassword=\"regObj.confirmPassword\" onpaste=\"return false;\" data-ng-model=\"regObj.confirmPassword\" required=\"\" autocorrect=\"off\" autocapitalize=\"off\" cobrowse=\"false\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.confirmPassword.$invalid && (form.confirmPassword.$dirty || form.$submitted)\"></span> <i ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$valid\" class=\"inline-checker icon-checked\"></i></label></div></div><div class=\"row mbm\"><div class=\"col-md-6\"><div class=\"inline_error\" ng-messages=\"form.question.$error\" ng-show=\"form.question.$invalid && (form.question.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"_require_security_question\"></span></span></div><div class=\"styled-select security-question-select\"><select name=\"question\" data-ng-model=\"regObj.question\" required=\"\" ng-options=\"key as value for (key, value) in questions\" cobrowse=\"false\"><option res=\"_security_questions\"></option></select></div><span class=\"beside-checker icon-error drop-down\" data-ng-show=\"form.question.$invalid && (form.question.$dirty || form.$submitted)\"></span> <span ng-show=\"form.question.$dirty && form.question.$valid\" class=\"beside-checker icon-checked\"></span></div></div><div class=\"row mbm\"><div class=\"col-md-6\"><div class=\"inline_error\" ng-messages=\"form.answer.$error\" ng-show=\"form.answer.$invalid && (form.answer.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"_require_security_answer\"></span></span></div><label class=\"rel\"><input data-tl-private=\"\" type=\"text\" name=\"answer\" tag-form-name=\"form\" tag-page-name=\"Registration\" res-attr=\"{placeholder: \'_answer\'}\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-maxlength=\"105\" data-ng-model=\"regObj.answer\" cobrowse=\"false\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.answer.$invalid && (form.answer.$dirty || form.$submitted)\"></span> <span ng-show=\"form.answer.$dirty && form.answer.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"pull-left\"><a href=\"#/signin\" class=\"link-cancel\" res=\"_cancel\"></a></div><div class=\"pull-right\" ng-show=\"loadingDataIndicator\"><span class=\"widget-loader-inline\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></div><div class=\"pull-right\"><button name=\"button_continue\" ng-disabled=\"loadingDataIndicator\" data-ng-click=\"submit()\" class=\"cta-round primary medium full\"><span res=\"_continue\"></span></button></div></div></div></form></div></div>");
$templateCache.put("scripts/modules/registration/securityQuestionAnswer.html","<div class=\"page-complete-profile\"><div class=\"container\"><form name=\"form\" class=\"profile-form\" novalidate=\"\" label=\"Complete Profile - Security Question\" id=\"completeProfileForm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 profile-title\"><span res=\"_security_questions\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 mtm\"><div class=\"row info-banner error mts mbm\" data-ng-show=\"isError\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><span class=\"plm\" ng-bind-html=\"errorDescription\"></span></div></div><div class=\"row info-banner-complete-profile error mts mbm\" data-ng-show=\"(form.$valid == false && form.$submitted)\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><p class=\"plm\" res=\"_check_form_errors\"></p></div></div></div></div><div class=\"row mbm\"><div class=\"col-md-6\"><div class=\"inline_error\" ng-messages=\"form.question.$error\" ng-show=\"form.question.$invalid && (form.question.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"_require_security_question\"></span></span></div><div class=\"profile-select-wide\"><select name=\"question\" data-ng-model=\"questionId\" required=\"\" ng-options=\"key as value for (key, value) in questions\"><option res=\"_security_questions\"></option></select></div><span class=\"beside-checker icon-error drop-down\" data-ng-show=\"form.question.$invalid && (form.question.$dirty || form.$submitted)\"></span> <span ng-show=\"form.question.$dirty && form.question.$valid\" class=\"beside-checker icon-checked\"></span></div></div><div class=\"row mbm\"><div class=\"col-md-6\"><div class=\"inline_error\" ng-messages=\"form.answer.$error\" ng-show=\"form.answer.$invalid && (form.answer.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"_require_security_answer\"></span></span></div><label class=\"rel\"><input type=\"text\" name=\"answer\" tag-form-name=\"form\" tag-page-name=\"Registration\" res-attr=\"{placeholder: \'_answer\'}\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-maxlength=\"105\" data-ng-model=\"answer\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.answer.$invalid && (form.answer.$dirty || form.$submitted)\"></span> <span ng-show=\"form.answer.$dirty && form.answer.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"pull-right\" ng-show=\"loadingDataIndicator\"><span class=\"widget-loader-inline\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></div><div class=\"pull-right\"><button name=\"button_continue\" ng-disabled=\"loadingDataIndicator\" data-ng-click=\"submit()\" class=\"cta-round primary medium full\"><span res=\"_continue\"></span></button></div></div></div></form></div></div>");
$templateCache.put("scripts/modules/reserveDevice/nrsform.html","<div ng-show=\"false\"><form name=\"formToSalesForce\" id=\"formToSalesForce\" method=\"post\" target=\"sf_iframe\"><input type=\"hidden\" name=\"UserCustomerBANInfo\" id=\"UserCustomerBANInfo\" data-ng-value=\"rd.encryptedString\"> <input type=\"hidden\" name=\"UserCustomerBANInfoSignature\" id=\"UserCustomerBANInfoSignature\" data-ng-value=\"rd.encryptedSignature\"></form><form name=\"formToRogersReserveDevice\" id=\"formToRogersReserveDevice\" method=\"post\" novalidate=\"\"><input type=\"text\" value=\"NRS_MS\" name=\"sourceNRS\"><br></form></div>");
$templateCache.put("scripts/modules/reserveDevice/reservedevice.html","<section class=\"page-reserve-device\"><myr-reserve-device></myr-reserve-device><div class=\"container error-message\" data-ng-show=\"salesForceFailed\"><span res=\"maintenance_info\"></span></div><div class=\"iframe-rd bb-iframe-container\"><iframe name=\"sf_iframe\" frameborder=\"0\" scrolling=\"no\" style=\"width: 100%; height: 1200px;\"></iframe></div></section>");
$templateCache.put("scripts/modules/rewards/rewards.html","<div class=\"container-fluid\"><div ng-show=\"!re.objRedeem.isFraudClosed\"><div class=\"row info-banner error module-global-error-message\" data-ng-show=\"re.errorMessage\" style=\"padding:10px;\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 icon-ctn\"><span class=\"message-banner-icon icon-error pts mls\" style=\"font-size:24px;\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span ng-bind-html=\"re.errorMessage\" style=\"font-size:14px;\"></span></div></div><div class=\"row directive-rewards\" ng-show=\"!re.errorMessage\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"row rewards-ctn no-padding\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 rewards-title-ctn\"><span class=\"title-h4-light\" res=\"rewards_title\"></span><span class=\"widget-loader-inline\" ng-show=\"re.loadingRewards\"><img src=\"images/widget-loader.gif\" alt=\"\"></span><div ng-if=\"!re.objRedeem.isMember || re.loadingRewards\"><div class=\"medium-font-size mbm mts\"><span res=\"acc_overview_benefits\"></span></div><a class=\"cta-round primary medium btn-redeem\" ng-href=\"{{re.rfrLinks.enrollLink}}\" target=\"_blank\" ng-hide=\"re.loadingRewards\" ng-disabled=\"re.isDealer || re.isCare\"><span res=\"acc_overview_enroll\"></span></a></div><div ng-if=\"re.objRedeem.isMember && !re.loadingRewards\"><div class=\"title-h3-light mts\"><span class=\"rewards-txt\" res=\"rewards_total_points\"></span> <span class=\"title-h4-semibold\">{{re.objRedeem.totalPointsDisplay}} <span res=\"rewards_points\"></span></span></div><div ng-show=\"re.objRedeem.monthPoints>0\"><span res=\"acc_overview_you_earned\" res-param-points=\"{{re.objRedeem.monthPoints}}\"></span></div></div></div><div class=\"row\" ng-if=\"re.objRedeem.isMember && !re.loadingRewards\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 pbm btn-redeem-ctn\"><div ng-show=\"re.objRedeem.totalPoints >= 0\"><a class=\"cta-round secondary medium btn-redeem\" target=\"_blank\" ng-href=\"{{re.rfrLinks.redeemLink}}\" data-ng-class=\"re.btnSettings.redeemEarnPoints === re.btnStatus.disabled ? \'not-active\' : \'\'\" data-ng-hide=\"(re.btnSettings.redeemEarnPoints === re.btnStatus.hidden) || re.loadingRewards\" ng-disabled=\"re.isDealer || re.isCare\"><span res=\"rewards_redeem\"></span></a></div></div></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/rgcl/rgcl.html","<div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12 prs\" ng-show=\"rgcl.isVisibleWithinAccountOverview()\"><div class=\"row\"><div class=\"no-left-border col-lg-12 col-md-12 col-sm-12 col xs-12\"><div class=\"rui-heading secondary\"><h3><span res=\"revo_included\"></span></h3></div></div></div><div class=\"col-lg-4 col-md-4 widgit-outer-en col-sm-4 col-xs-12 pls prs\"><div class=\"headline6 free-empty-div pts\"><span><span></span></span></div><div><img ng-src=\"images/value-added-offers/gcl-logo.png\" class=\"visible-lg visible-md visible-sm pts pbs img-size\"> <img ng-src=\"images/value-added-offers/mb-gcl-logo.png\" class=\"visible-xs img-size-mb\" width=\"260px\"></div><div class=\"mbs mrs visible-lg visible-md visible-sm ng-binding title-h5\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\"><ute-content-injector language=\"{{lang}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/account-overview/rgcl/rgcl_message1/rgcl_message1\"></ute-content-injector></div><div class=\"mbs mrs visible-lg visible-md visible-sm ng-binding title-h5\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\"><ute-content-injector language=\"{{lang}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/account-overview/rgcl/rgcl_message2/rgcl_message2\"></ute-content-injector></div><a ng-href=\"https://secure.gamecentrelive.rogers.com/signin?lang={{lang}}\" class=\"widgit-inner cta-round primary medium full red-button white-button\" role=\"button\" res=\"rgcl_watch\" target=\"_blank\"></a><div class=\"visible-lg visible-sm visible-md grey-line\">&nbsp;</div><div class=\"visible-xs grey-line\">&nbsp;</div></div></div>");
$templateCache.put("scripts/modules/setNewPassword/setNewPassword.html","<section class=\"page-set-new-password\"><div class=\"container\"><div class=\"row message-margin\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"#/signin\" res=\"_my_rogers_nospace\"></a></li><li class=\"child-1\"><span res=\"set_new_password\"></span></li></ul></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"mbm info-banner error mts\" data-ng-show=\"isError\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1\" style=\"max-width: 40px;\"><img ng-src=\"images/warning.png\" src=\"images/warning.png\"></div><div class=\"col-xs-10 col-sm-10 col-md-11 plm\" style=\"float:left\"><span ng-bind-html=\"errorDescription\"></span></div></div></div><p class=\"forgot-password-desc\" res=\"login_set_new_pwd_desc\"></p></div></div><form name=\"form1\" novalidate=\"\"><div class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-lg-7 col-md-7 col-sm-7 col-xs-12\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"user-info-cntr\"><div class=\"row\"><div class=\"header\" res=\"set_new_password_header\"></div></div><div class=\"row\"><div class=\"email\" ng-bind-html=\"snpc.username\"></div></div></div></div></div><div class=\"row\"><div class=\"inline_error\" ng-messages=\"form1.email.$error\" ng-show=\"(form1.email.$dirty || form1.$submitted) && form1.email.$invalid\"><span ng-message=\"required\"><span class=\"message-margin\" res=\"login_forget_pwd_email_invalid\"></span></span> <span ng-message=\"pattern\"><span res=\"_email_address_not_valid\" class=\"prm\"></span></span></div><label class=\"rel\"><input class=\"overrite-margin-bottom\" type=\"password\" name=\"password\" tag-form-name=\"form\" tag-page-name=\"Set New password\" data-ng-model=\"password\" ng-minlength=\"7\" ng-maxlength=\"16\" ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#\\$%\\^\\&*\\)\\(+=._-]{7,16}$/\" required=\"\" ng-model-options=\"{ updateOn: \'blur\' }\" res-attr=\"{ placeholder : \'_set_new_Pass1\'}\" autocapitalize=\"off\"> <i ng-show=\"form1.password.$invalid && (form1.password.$dirty || form1.$submitted)\" class=\"inline-checker icon-error\"></i> <span ng-show=\"form1.password.$dirty && form1.password.$valid\" class=\"inline-checker icon-checked\"></span></label></div><div class=\"row\"><div class=\"inline_error\" ng-messages=\"form1.email.$error\" ng-show=\"(form1.email.$dirty || form1.$submitted) && form1.email.$invalid\"><span ng-message=\"required\"><span class=\"message-margin\" res=\"login_forget_pwd_email_invalid\"></span></span> <span ng-message=\"pattern\"><span res=\"_email_address_not_valid\" class=\"prm\"></span></span></div><label class=\"rel\"><input class=\"overrite-margin-bottom\" type=\"password\" name=\"confirmPass\" tag-form-name=\"form\" tag-page-name=\"Set New password\" data-ng-model=\"confirmPass\" ng-minlength=\"7\" ng-maxlength=\"16\" ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#\\$%\\^\\&*\\)\\(+=._-]{7,16}$/\" required=\"\" ng-model-options=\"{ updateOn: \'blur\' }\" res-attr=\"{ placeholder : \'_set_new_Pass2\'}\" autocapitalize=\"off\"> <i ng-show=\"(form1.confirmPass.$invalid || !snpc.confirm()) && (form1.confirmPass.$dirty || form1.$submitted)\" class=\"inline-checker icon-error\"></i> <span ng-show=\"form1.confirmPass.$dirty && form1.confirmPass.$valid && snpc.confirm()\" class=\"inline-checker icon-checked\"></span></label></div><div class=\"row form-action-ctn\"><span class=\"widget-loader-inline\" data-ng-show=\"snpc.loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></span><div class=\"btn-continue-ctn\"><div class=\"btn-continue-ctn\"><button name=\"button_continue\" data-ng-disabled=\"snpc.loadingDataIndicator\" class=\"cta-round primary medium full btn-continue\" data-ng-click=\"snpc.submit()\"><span class=\"overrite-span\" res=\"_continue\"></span></button></div></div></div></div></div></form></div></section>");
$templateCache.put("scripts/modules/signin/frontlineSignin.html","<h1 class=\"sr-only\" res=\"frontline_heading\"></h1><section class=\"page-signin\" style=\"margin-bottom:70px;\"><div class=\"container\"><div class=\"body-grey-dark\"><form id=\"signinForm\" name=\"form\" class=\"body-grey-light\" novalidate=\"\" data-ng-show=\"myRogersPermission\"><div class=\"row message-margin\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"#/frontline\" res=\"frontline_heading\"></a></li><li class=\"child-1\"><span res=\"_frontline_signin\"></span></li><li class=\"widget-loader sign-in\" ng-show=\"loginWaiting\"><img src=\"images/widget-loader.gif\" alt=\"\"></li></ul></div><div class=\"row sign-intro\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><p class=\"overrite-margin\" res=\"frontline_intro\"></p></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7 pln prn\"><div class=\"message-banner error\" data-ng-show=\"submitted && (form.USER.$error.required || form.password.$error.required)\"><div class=\"row\"><div class=\"sigin-error-icon-ctn col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding\"><span class=\"fa fa-exclamation-circle fa-2x txtM\"></span></div><div class=\"col-xs-9 col-sm-10 col-md-11 col-lg-11 no-padding\"><span class=\"v-base-line\" res=\"_require_username_password\"></span></div></div></div></div></div><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7\"><div class=\"row sign-error-box\"><attempts-error-box></attempts-error-box></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7\"><fieldset class=\"bdn pan\"><legend class=\"sr-only\" res=\"signin\"></legend><div class=\"row overrite-margin\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label for=\"USER\" class=\"sr-only\" res=\"label_username\"></label> <input class=\"no-inline-checker\" tabindex=\"0\" type=\"text\" id=\"USER\" name=\"USER\" res-attr=\"{ placeholder : \'_username_email\'}\" data-ng-model=\"email\" required=\"\" autocorrect=\"off\" autocapitalize=\"off\"> <span class=\"inline-checker icon-error sign-in\" data-ng-show=\"submitted && form.USER.$error.required\"></span></div></div><div class=\"row overrite-margin\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label for=\"password\" class=\"sr-only\" res=\"label_password\"></label> <input data-tl-private=\"\" class=\"no-inline-checker\" tabindex=\"0\" type=\"password\" id=\"password\" name=\"password\" res-attr=\"{ placeholder : \'_password\'}\" data-ng-model=\"password\" required=\"\" autocorrect=\"off\" autocapitalize=\"off\"> <span class=\"inline-checker icon-error sign-in\" data-ng-show=\"submitted && form.password.$error.required\"></span></div></div></fieldset><div class=\"row overrite-margin\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-6 col-md-5 col-lg-5\" style=\"float:right;\"><div class=\"btn-parent btn-std btn-signin\" style=\"float:right;\"><button class=\"cta-round primary medium full overrite\" data-ng-click=\"submit()\" ng-keypress=\"$event.which === 13 ? submit() : 0\" ng-class=\"isWaitingClass\" ng-disabled=\"loginWaiting\" tabindex=\"0\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"signingIn\"><span class=\"overrite-span\" res=\"_signin\"></span></button></div><input type=\"hidden\" name=\"TARGET\" id=\"target\" value=\"\"> <input type=\"hidden\" name=\"SMAUTHREASON\" value=\"0\"></div><div class=\"col-xs-12 col-sm-6 col-md-7 col-lg-7\"></div></div></div></div><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5\"><ins ute-content-injector-no-cache=\"\" language=\"{{lang}}\" content-id=\"/web/smb/cms/selfserve/onlinebilling/content/onlinebilling\"></ins></div></div></form></div></div></section>");
$templateCache.put("scripts/modules/signin/signin.html","<div ng-show=\"showLoader\" class=\"largeload\"><img src=\"images/widget-loader.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div><div ng-show=\"!showLoader\"><h1 class=\"sr-only\" res=\"_my_rogers_nospace\"></h1><section class=\"page-signin\" style=\"margin-bottom: 70px;\"><div class=\"container\"><div class=\"body-grey-dark\"><form id=\"signinForm\" name=\"form\" class=\"body-grey-light\" novalidate=\"\" data-ng-show=\"myRogersPermission\"><div class=\"row message-margin\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"#/signin\" res=\"_my_rogers_nospace\"></a></li></ul></div><div class=\"row sign-intro\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\" style=\"width:65%\"><p class=\"overrite-margin\" res=\"sign_intro\"></p></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" style=\"height:200px\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7\"><div><h2 class=\"registration-area-text-lg\" res=\"sign_intro1\" style=\"display:flex;margin-left:5px\"></h2><div class=\"popup\"><span class=\"popuptext\" id=\"myPopup\" style=\"font-size: 16px;\"><div><img src=\"/web/smb/cms/selfserve/closeicon.png\" alt=\"close\" class=\"close-icon-style\" ng-click=\"showpopup()\"></div><div style=\"text-align: left;\" res=\"pop_up_modal_text\"></div></span></div></div><div class=\"row overrite-margin\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-6 col-md-5 col-lg-5\" style=\"float: center;\"><div class=\"btn-parent btn-std btn-signin\" style=\"float: right;\"><button class=\"cta-round primary medium full overrite\" data-ng-click=\"submit()\" ng-keypress=\"$event.which === 13 ? submit() : 0\" ng-class=\"isWaitingClass\" ng-disabled=\"loginWaiting\" tabindex=\"0\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"signingIn\"><span class=\"overrite-span\" res=\"_continue\"></span></button></div><input type=\"hidden\" name=\"TARGET\" id=\"target\" value=\"\"> <input type=\"hidden\" name=\"SMAUTHREASON\" value=\"0\"></div><div class=\"col-xs-12 col-sm-6 col-md-7 col-lg-7\"></div></div></div></div><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5\"><ins ute-content-injector-no-cache=\"\" language=\"{{lang}}\" content-id=\"/web/smb/cms/selfserve/onlinebilling/content/onlinebilling\"></ins><registration-area></registration-area></div></div></form></div></div></section></div>");
$templateCache.put("scripts/modules/simCardChangeIntegration/simCardChangeNumberForm.partial.html","<form name=\"simCardForm\" novalidate=\"\"><div data-ng-if=\"(simCardForm.currentSim.$invalid || simCardForm.newSim.$invalid) && simCardForm.$submitted\"><myr-error-message><div data-ng-messages=\"simCardForm.currentSim.$error\" data-ng-if=\"simCardForm.currentSim.$invalid\"><p data-ng-message=\"minlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f9\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p data-ng-message=\"maxlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f9\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p data-ng-message=\"required\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_currentSim_notFound\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f9\",\"mappingKey\":\"error.changeSIM\"}\'></span></p></div><div data-ng-messages=\"simCardForm.newSim.$error\" data-ng-if=\"simCardForm.currentSim.$valid && simCardForm.newSim.$invalid\"><p data-ng-message=\"minlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f10\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p data-ng-message=\"maxlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f10\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p data-ng-message=\"required\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_newSim_notFound\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f10\",\"mappingKey\":\"error.changeSIM\"}\'></span></p></div></myr-error-message></div><div class=\"ute-simCard-inputCollection\"><div class=\"ute-simCard-inputGroup\"><div data-ng-class=\"(simCardForm.currentSim.$invalid && simCardForm.$submitted) ? \'ute-simCard-inputTextLabelError\' : \'ute-simCard-inputTextLabel\'\"><span class=\"ute-icon-error-icon\" data-ng-show=\"simCardForm.currentSim.$invalid && simCardForm.$submitted\"></span> <span translate=\"ute.rogers.myrSimCard.simCardChange.currentSim\"></span></div><input data-ng-class=\"(simCardForm.currentSim.$invalid && simCardForm.$submitted) ? \'ute-simCard-inputTextError\' : \'ute-simCard-inputText\'\" type=\"text\" name=\"currentSim\" id=\"currentSim\" maxlength=\"20\" data-minlength=\"20\" data-ng-model=\"simCardChange.model.currentSimCardNumber\" ute-numbers-only-input=\"\" ng-model-options=\"{ allowInvalid: true }\" data-ute-enter-as-tab=\"\" data-next-element=\"newSim\" required=\"\"></div><div class=\"ute-simCard-inputGroup\"><div data-ng-class=\"(simCardForm.newSim.$invalid && simCardForm.$submitted) ? \'ute-simCard-inputTextLabelError\' : \'ute-simCard-inputTextLabel\'\"><span class=\"ute-icon-error-icon\" data-ng-show=\"simCardForm.newSim.$invalid && simCardForm.$submitted\"></span> <span translate=\"ute.rogers.myrSimCard.simCardChange.newSim\"></span></div><input data-ng-class=\"(simCardForm.newSim.$invalid && simCardForm.$submitted) ? \'ute-simCard-inputTextError\' : \'ute-simCard-inputText\'\" type=\"text\" name=\"newSim\" id=\"newSim\" maxlength=\"20\" data-minlength=\"20\" data-ng-model=\"simCardChange.model.newSimCardNumber\" ute-numbers-only-input=\"\" ng-model-options=\"{ allowInvalid: true }\" required=\"\"></div></div><div class=\"ute-simCard-buttonGroup\"><button class=\"ute-simCard-cancelButton\" type=\"button\" data-ng-click=\"simCardChange.cancel($event)\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardChange.cancel\"></span></button> <button class=\"ute-simCard-continueButton\" data-ng-click=\"simCardChange.submit(simCardForm, $event)\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardChange.continue\"></span></button></div></form>");
$templateCache.put("scripts/modules/simCardChangeIntegration/simCardHowToFindNumber.partial.html","<div class=\"ute-simCard-typeBodyGroup\"><div class=\"row\"><div class=\"ute-simCard-findSimNumber col-xs-12 col-sm-6 col-md-4 col-lg-3\"></div><div class=\"col-xs-12 col-sm-6 col-md-7 col-lg-7\"><span class=\"ute-simCard-typeBody\" translate=\"ute.rogers.myrSimCard.serialNumberLocation\"></span></div></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\"><div translate=\"ute.rogers.myrSimCard.firstWay\"></div><div translate=\"ute.rogers.myrSimCard.ios.osName\"></div><ol><li translate=\"ute.rogers.myrSimCard.ios.firstBullet\"></li><li translate=\"ute.rogers.myrSimCard.ios.secondBullet\"></li><li translate=\"ute.rogers.myrSimCard.ios.thirdBullet\"></li><li translate=\"ute.rogers.myrSimCard.ios.forthBullet\"></li></ol><div translate=\"ute.rogers.myrSimCard.android.osName\"></div><ol><li translate=\"ute.rogers.myrSimCard.android.firstBullet\"></li><li translate=\"ute.rogers.myrSimCard.android.secondBullet\"></li><li translate=\"ute.rogers.myrSimCard.android.thirdBullet\"></li><li translate=\"ute.rogers.myrSimCard.android.forthBullet\"></li></ol><div translate=\"ute.rogers.myrSimCard.findSerialParagraph\"></div></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\"><div translate=\"ute.rogers.myrSimCard.secondWay\"></div><div translate=\"ute.rogers.myrSimCard.onSimCard\"></div></div></div>");
$templateCache.put("scripts/modules/simCardChangeIntegration/simCardMain.view.html","<section><div data-ng-include=\"sc.simCardHeaderPartialPath\"></div><ui-view></ui-view></section><div style=\"display: none;\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"ProfileAccountNumber\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"selectedAccountNumber\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"accountNum\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"accountNumber\"><br><input type=\"text\" data-ng-model=\"briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"></form></div>");
$templateCache.put("scripts/modules/smartHomeMonitoring/shmDashboard.html","<section class=\"page-wireless page-home-monitoring\"><div ng-cloak=\"\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"shm_title\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div class=\"container rshm\"><div class=\"row mbl\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><div class=\"mtl mlm\"><img src=\"images/shm.png\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 did-you-know-ctn-desktop\"><div class=\"rsmh_did-you-know-ctn\"><span class=\"did-you-know-title\" res=\"shm_promo_title\"></span> <span class=\"did-you-know-promo-txt\" res=\"shm_promo\"></span> <a ng-if=\"!isDealer && !isCare\" class=\"learn-more-link\" target=\"_blank\" href=\"{{learnMoreUrl}}\"><span res=\"learn_more\"></span><span class=\"rui-icon-button-arrow-right\"></span></a><div ng-show=\"isDealer || isCare\" class=\"learn-link-text-container\"><span res=\"learn_more\"></span></div></div></div><div class=\"rshm_manage-device col-xs-12 col-sm-12 col-md-4 col-lg-4\"><div class=\"manageDevice semi-bold\"><ul class=\"CTAmenu\"><li><a ng-href=\"{{shmLink}}\" ng-if=\"!isDealer && !isCare\" atm=\"smartbusinessmonitoring_webcontrolcentre_accesswebcontrolcentre\"><span res=\"shm_access_web\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a><div ng-show=\"isDealer || isCare\" class=\"link-text-container\"><span res=\"shm_access_web\"></span></div></li><li><a href=\"/cmsbusiness/download/rsmb/RSMB_Quick_Start_Guide_en.pdf\" target=\"_blank\"><span res=\"shm_quick_start_guide\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li><a href=\"/web/content/municipal-permits?{{municipalPermitsInformationLink}}\" target=\"_blank\"><span res=\"shm_municipal_permits\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"last\"><a href=\"/cmsbusiness/download/rsmb/RSMB_User_Guide_en.pdf\" target=\"_blank\"><span res=\"shm_service_agreement\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 did-you-know-ctn-mobile\"><div class=\"rsmh_did-you-know-ctn\"><span class=\"did-you-know-title\" res=\"shm_promo_title\"></span> <span class=\"did-you-know-promo-txt\" res=\"shm_promo\"></span> <a ng-if=\"!isDealer && !isCare\" class=\"learn-more-link\" target=\"_blank\" href=\"/web/content/smart-home-monitoring-solutions-new?setLanguage={{lng}}#control\"><span res=\"learn_more\"></span><span class=\"rui-icon-button-arrow-right\"></span></a><div ng-show=\"isDealer || isCare\" style=\"font-size: 18px;font-weight: 600;padding-left: 13px;\"><span res=\"learn_more\"></span></div></div></div></div><div class=\"container-fluid mtl\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><hr class=\"divider\"></div></div></div><div class=\"row ptm\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-5 my-offers-ctn-sm\" data-ng-hide=\"appState.isMobile\"><my-offers></my-offers></div></div></div></div></section>");
$templateCache.put("scripts/modules/sohoMigration/sohoMigration.html","<div class=\"reset-password\"><div class=\"container\"><div class=\"row\"><div class=\"reset-password-heading\" res=\"reset_password_heading\"></div><div class=\"reset-password-body\" res=\"reset_password_body\"></div><div class=\"accounts\" data-ng-if=\"userMigratedEmailResponse.bizMigratedEmailResponsesList.length > 1\"><div class=\"account-list\"><div class=\"email-desc\" res=\"sent_email_desc\"></div><div class=\"account-info row\" ng-repeat=\"accList in userMigratedEmailResponse.bizMigratedEmailResponsesList\"><span class=\"account-number col-xs-12 col-md-3\"><span res=\"account_number\"></span><span data-ng-bind=\"accList.acctNbr\"></span></span> <span class=\"col-xs-12 col-md-5 mt-2\"><span res=\"migrated_email_and_date_1\"></span> <strong data-ng-bind=\"accList.migratedEmail\"></strong><span res=\"migrated_email_and_date_2\"></span> <strong data-ng-bind=\"accList.autoreg_email_date\"></strong><span res=\"migrated_email_and_date_3\"></span></span> <span class=\"col-xs-12 col-md-4 resend\" data-ng-if=\"userMigratedEmailResponse.migEmailPresent\"><button class=\"btn btn-outline-danger btn-resent\" ng-disabled=\"disableResendBtn || autoRegfail || (apiCount == 5)\" res=\"resent_btn\" data-ng-click=\"autoRegEmail(accList)\"></button></span></div></div></div><div data-ng-if=\"userMigratedEmailResponse.bizMigratedEmailResponsesList.length > 1\" class=\"mt-10\" res=\"reset_password_content\"></div><div class=\"account\" data-ng-if=\"userMigratedEmailResponse.bizMigratedEmailResponsesList.length === 1\"><span res=\"migrated_email_desc_1\"></span><strong data-ng-bind=\"userMigratedEmailResponse.bizMigratedEmailResponsesList[0].migratedEmail\"></strong> <span res=\"migrated_email_and_date_2\"></span><strong data-ng-bind=\"userMigratedEmailResponse.bizMigratedEmailResponsesList[0].autoreg_email_date\"></strong> <span res=\"migrated_email_desc_2\"></span><div class=\"mt-10\" res=\"reset_password_content\"></div><div data-ng-if=\"userMigratedEmailResponse.migEmailPresent\"><button ng-disabled=\"disableResendBtn || autoRegfail || (apiCount == 5)\" class=\"btn btn-outline-danger btn-resent\" data-ng-click=\"autoRegEmail(userMigratedEmailResponse.bizMigratedEmailResponsesList[0])\" res=\"resent_btn\"></button></div></div><strong class=\"myRogers-link\" res=\"myRogers_link\"></strong></div></div></div>");
$templateCache.put("scripts/modules/suspendCtnIntegration/suspendCtnConfirm.view.html","<section><div class=\"container\"><div class=\"row ute-suspendCtnConfirm-header\"><div class=\"col-xs-12 col-md-3 col-md-push-9\"><ute-suspend-ctn-wireless-number></ute-suspend-ctn-wireless-number><ute-suspend-ctn-device></ute-suspend-ctn-device></div><div class=\"col-xs-12 col-md-9 col-md-pull-3\"><h1 data-translate=\"ute.common.suspend.ctn.confirm.sorryToHear\">Sorry to hear<br>you\'ve lost your phone</h1><p data-translate=\"ute.common.suspend.ctn.confirm.rightPlace\">You\'re in the right place to find a solution.</p></div></div><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"ute-suspendCtnConfirm-steps\" data-translate=\"ute.common.suspend.ctn.confirm.firstStep\"></h3><a data-ng-href=\"{{\'ute.common.suspend.ctn.confirm.findIphoneUrl\' | translate}}\" target=\"_blank\"><p class=\"ute-suspendCtnConfirm-blue ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.findIphone\"></p></a> <a data-ng-href=\"{{\'ute.common.suspend.ctn.confirm.findAndroidUrl\' | translate}}\" target=\"_blank\"><p class=\"ute-suspendCtnConfirm-blue ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.findAndroid\"></p></a></div><div class=\"col-md-12\"><h3 class=\"ute-suspendCtnConfirm-steps\" data-translate=\"ute.common.suspend.ctn.confirm.secondStep\"></h3><p data-translate=\"ute.common.suspend.ctn.confirm.ifFind\"></p><p data-translate=\"ute.common.suspend.ctn.confirm.turnOff\"></p><ul class=\"ute-suspendCtnConfirm-service-list\"><li class=\"ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.data\"></li><li class=\"ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.talk\"></li><li class=\"ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.text\"></li></ul></div><div class=\"col-lg-3 col-md-3 col-xs-12 col-sm-12 row\"><button name=\"button_continue\" data-ng-disabled=\"confirmSuspendDevice.isSuspendCtnCallInProgress()\" data-ng-click=\"confirmSuspendDevice.switchOffService($event)\" class=\"ute-suspendCtnConfirm-switch col-xs-9 col-sm-9\" data-ng-class=\"(confirmSuspendDevice.isSuspendCtnCallInProgress()) ? \'\' : \'full\'\" type=\"button\"><span data-translate=\"ute.common.suspend.ctn.confirm.switchOffService\"></span></button><div data-ng-if=\"confirmSuspendDevice.isSuspendCtnCallInProgress()\" class=\"ute-suspendCtn-confirmation-loader-container col-xs-3 col-sm-3\"><img class=\"ute-suspendCtn-loading-img\" src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Suspending Device...\">&nbsp;</div></div><div data-ng-show=\"confirmSuspendDevice.getAccountEmail()\" class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 ute-suspendCtnConfirm-padding\"><p class=\"ute-suspendCtnConfirm-switch-left-margin\" data-translate=\"ute.common.suspend.ctn.confirm.confirmEmail\" data-translate-values=\"{accountEmail:confirmSuspendDevice.getAccountEmail()}\"></p><a ng-href=\"../../../business/ute/smb/transactions/uteMyRogersProfile\"><p class=\"ute-suspendCtnConfirm-switch-left-margin ute-suspendCtnConfirm-blue\" data-translate=\"ute.common.suspend.ctn.confirm.updateEmail\"></p></a></div><div class=\"col-md-12 col-xs-12 col-lg-12 col-sm-12 ute-suspendConfirm-bottom-border\"><h3 class=\"ute-suspendCtnConfirm-steps\" data-translate=\"ute.common.suspend.ctn.confirm.thirdStep\"></h3><bold-chat-static-button class=\"col-md-4 col-lg-4 col-xs-12 col-sm-12 ute-suspendCtnConfirm-live-chat\" data-cbid=\"{{\'ute.common.suspend.ctn.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.suspend.ctn.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.common.suspend.ctn.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button><img src=\"ute-common-assets/assets/call.png\"><div class=\"ute-suspendCtn-support-phone\" data-translate=\"ute.common.suspend.ctn.fail.supportPhoneNumber\"></div></div></div></div></section>");
$templateCache.put("scripts/modules/tvDashboard/tvdashboard.html","<script type=\"text/javascript\">\n  $(function () {\n    $(\'.pointer\').popover();\n  });\n</script><section class=\"page-tvdashboard\"><div ng-cloak=\"\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"_tv\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container page-wireless tv-package-ctn\"><div class=\"container\"><div class=\"container page-tvdashboard tv-package-spacing\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-6\"><h2 class=\"widget-loader-mod\" res=\"tv_my_package\"></h2><div class=\"widget-loader tv\" ng-show=\"loadingDataIndicatorTvDashboard && !finalDataReceived\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div ng-show=\"displayContentTvDashboard\" class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-3 semi-bold mbl\"><div class=\"widget-loader tv\" ng-show=\"loadingDataIndicatorTvDashboard && !finalDataReceived\"><img src=\"images/widget-loader.gif\" alt=\"\"></div><div class=\"title-h5 semi-bold mbs\">{{tvObj.myPlan.packageDescription}}</div></div><div class=\"col-xs-12 col-sm-8 col-md-9 col-lg-5\" ng-show=\"hasExtras || hasThemes\"><div class=\"title-h5 semi-bold mbs\" res=\"internet_my_extras\"></div><div class=\"mts myextras-line pbs\" res=\"wireless_manage-plan_estimated-values\"></div><div class=\"my-line-plan-ctn\"><div class=\"container-fluid\"><div class=\"headline6 myextras-line pbs pts\" ng-repeat=\"addon in tvObj.myExtras\"><div class=\"row\"><div class=\"col-xs-7 col-sm-7 col-md-8 col-lg-8\"><span ng-bind-html=\"addon\"></span></div></div></div><div class=\"headline6 myextras-line pbs pts\" ng-show=\"hasExtras\"><div class=\"row\"><div class=\"col-xs-7 col-sm-7 col-md-8 col-lg-8\"><span res=\"tv_channels_extra\"></span></div></div><div class=\"row\"><div class=\"sample-show-hide\" ng-init=\"addOnLimit=5\"><div class=\"medium-font-size mls\" ng-repeat=\"addon in tvObj.extraChannelList | limitTo:addOnLimit track by $index\"><span ng-bind-html=\"addon\"></span></div><span class=\"show-more\" ng-click=\"addOnLimit=addOnLimit==5?1000:5\" res=\"more\" ng-show=\"tvObj.extraChannelList.length > 5 && addOnLimit < 500\"></span></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-5 col-lg-3 tv-package\" data-ng-show=\"isDealer || isCare\"><message-info-box info-message=\"changeTVPackageMessage\"></message-info-box></div></div></div><div class=\"container my-digital-box\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 redHeadline\"><h2 class=\"widget-loader-mod\" res=\"tv_my_box\"></h2><div class=\"widget-loader tv\" ng-show=\"loadingDataIndicatorTvDashboard && !finalDataReceived\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"container\" ng-show=\"errorMessage\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div ng-show=\"displayContentTvDashboard\" class=\"row mbl\"><div ng-repeat=\"(boxName, boxcount) in tvObj.hardwareList\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4 mtl prs\"><div class=\"tvDevicesDiv\"><div class=\"top-head\"><div class=\"tvicon\"><img src=\"images/tv_icon_small.png\"></div><div class=\"tvheading\">{{boxName}}<div class=\"tooltipheading\" ng-if=\"boxName.length>33\">{{boxName}}</div><div></div></div><div class=\"line1\"><div class=\"line\"></div></div><div class=\"sub-heading\"><span class=\"count\">{{boxcount}}&nbsp;</span><div class=\"box-text\" ng-class=\"{\'marClass\':boxcount<10}\" res=\"tv_box_line_2\"></div></div></div></div></div><div ng-show=\"tvObj.rtoIndicator == true\" class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><div class=\"did-you-know-ctn\" style=\"margin-left:0px;\"><span class=\"did-you-know-title\" res=\"rto_Title\"></span> <span class=\"did-you-know-promo-txt\" res=\"rto_Message\"></span></div></div></div></div></div><div class=\"row ptm\"></div><div ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"selectedAccount.accountNumber\" name=\"selectedAccountNumber\"><br><input type=\"text\" data-ng-model=\"selectedFlow\" name=\"flowType\"><br><button ng-click=\"postToRogers(0)\">Add/Change themes</button> <button ng-click=\"postToRogers(1)\">change package</button></form><form name=\"formToRogersBottom\" id=\"formToRogersBottom\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"selectedAccount.accountNumber\" name=\"acctNum\"><br></form></div></div></div></div></section>");
$templateCache.put("scripts/modules/underMaintenance/underMaintenance.html","<section class=\"page-maintenance\" data-ng-controller=\"MyrUnderMaintenanceController\"><div class=\"top-bar-ctn\"><div class=\"pbm container\"><div><div class=\"row mrm\" data-ng-show=\"maintenanceInfo\"><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 pbl\"><div class=\"primary-color title-large\" ng-show=\"altMaintenance.SITE_ON_MAINTENANCE\" res=\"_my_rogers_nospace_mark\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 ptm pbl info-banner\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1\"><span class=\"message-banner-icon icon-alert error-sign-big\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 plm\"><span class=\"v-base-line\" ng-bind-html=\"maintenanceInfo\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 pbl\"><account-selector></account-selector></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/userRegistrationIntegration/userRegistration.html","<div class=\"page-registration\"><div class=\"container\"><form name=\"registration.form\" novalidate=\"\" data-label=\"Registration\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.rogers.user.registration.registration\"></span></li></ul></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 mtm\"><div class=\"row info-banner error mts mbm\" data-ng-if=\"registration.errorCode.frontendMessageKey\" style=\"margin-left: 0;\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\" style=\"float:left\"><span data-translate=\"{{registration.errorCode.frontendMessageKey}}\"></span><div id=\"myr-registration\" style=\"display: inline-block;\"><bold-chat-static-button data-cbid=\"{{registration.errorCode.boldChat.cbid | translate}}\" data-dynamic-div=\"{{registration.errorCode.boldChat.dynamicDivId | translate}}\" data-chat-button=\"{{registration.errorCode.boldChat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div><span data-translate=\"ute.rogers.user.registration.system.error.message.p2\"></span></div></div><div class=\"row info-banner error mts mbm\" data-ng-if=\"( registration.form.$submitted && !registration.form.$valid )\" style=\"margin-left: 0;\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><span data-translate=\"ute.common.label.check.form.errors\"></span></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h4><span data-translate=\"ute.common.label.contact.info\"></span></h4></div></div><div class=\"row mbm\"><div class=\"col-lg-6 col-md-5\"><div class=\"inline_error\" data-ng-messages=\"registration.form.email.$error\" data-ng-if=\"( registration.form.$submitted || registration.form.email.$dirty ) && registration.form.email.$invalid\"><span data-ng-if=\"registration.form.email.$error.required\" data-ng-message=\"required\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"email\"><span data-translate=\"ute.rogers.user.registration.require.email\"></span></span></span> <span data-ng-if=\"registration.form.email.$error.pattern\" data-ng-message=\"pattern\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"emailPattern\"><span data-translate=\"ute.rogers.user.registration.email.address.not.valid\"></span></span></span></div><label class=\"rel\"><input type=\"text\" xvalidation-tag=\"\" data-tag-form-name=\"registration.form\" data-tag-page-name=\"Registration\" name=\"email\" id=\"email\" data-ng-pattern=\"/^\\w+([-.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" translate=\"\" data-translate-attr-placeholder=\"ute.common.label.email.address\" maxlength=\"105\" data-ng-model-options=\"registration.modelOptions\" data-onpaste=\"return false;\" data-ng-model=\"registration.model.email\" required=\"\" data-autocorrect=\"off\" data-autocapitalize=\"off\"> <span class=\"inline-checker icon-error\" data-ng-show=\"registration.form.email.$invalid && (registration.form.email.$dirty || registration.form.$submitted)\"></span> <span data-ng-show=\"registration.form.email.$dirty && registration.form.email.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-lg-6 col-md-5\"><div class=\"inline_error\" data-ng-messages=\"registration.form.confirmEmail.$error\" data-ng-if=\"( registration.form.$submitted || registration.form.confirmEmail.$dirty ) && registration.form.confirmEmail.$invalid\"><span data-ng-if=\"registration.form.confirmEmail.$error.required\" data-ng-message=\"required\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"confirmEmail\"><span data-translate=\"ute.rogers.user.registration.require.confirm.email\"></span></span></span> <span data-ng-if=\"registration.form.confirmEmail.$error.pattern\" data-ng-message=\"pattern\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"confirmEmailPattern\"><span data-translate=\"ute.rogers.user.registration.email.address.not.valid\"></span></span></span> <span data-ng-if=\"registration.form.confirmEmail.$error.matches\" data-ng-message=\"matches\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"confirmEmailMatch\"><span data-translate=\"ute.rogers.user.registration.email.not.matched\"></span></span></span></div><label class=\"rel\"><input type=\"text\" name=\"confirmEmail\" data-tag-form-name=\"registration.form\" data-tag-page-name=\"Registration\" translate=\"\" data-translate-attr-placeholder=\"ute.common.label.email.confirm\" data-ng-model-options=\"registration.modelOptions\" matches=\"registration.form.email\" data-ng-model=\"registration.model.confirmEmail\" data-ng-pattern=\"registration.model.email\" data-onpaste=\"return false;\" required=\"\" data-autocorrect=\"off\" data-autocapitalize=\"off\"> <span class=\"inline-checker icon-error\" data-ng-show=\"registration.form.confirmEmail.$invalid && (registration.form.confirmEmail.$dirty || registration.form.$submitted)\"></span> <span data-ng-show=\"registration.form.confirmEmail.$dirty && registration.form.confirmEmail.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 lang-btn-ctn mbm\"><div class=\"rui-content-block intro mtm\"><span class=\"content\"><p data-translate=\"ute.common.label.language.preference\"></p></span></div><label class=\"btn btn-default left\" data-ng-class=\"registration.model.lang == lang ? \'box_selected\' : \'radio_unselected\'\" data-ng-repeat=\"(lang, title) in registration.languages\"><input type=\"radio\" data-ng-model=\"registration.model.lang\" data-ng-value=\"lang\" value=\"{{::title}}\"> <span class=\"prm\" data-ng-bind=\"::title\"></span></label></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 mtm\"><div class=\"pull-left mtm\"><a data-ui-sref=\"{{::registration.getCancelStateName()}}\" class=\"link-cancel\" data-translate=\"ute.common.label.cancel\"></a></div><div class=\"pull-right\" data-ng-show=\"registration.isUserRegistrationCallInProgress()\"><span class=\"widget-loader-inline\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div class=\"pull-right\"><button name=\"button_continue\" data-ng-click=\"registration.submit()\" class=\"cta-round primary medium full\"><span data-translate=\"ute.common.label.continue\"></span></button></div></div></div></form></div></div>");
$templateCache.put("scripts/modules/uteBill/bulkInvoiceDownload.html","<div ng-if=\"showDownloadsTab && !user.isAuthenticated\"><div class=\"dtStatusMessage\" ng-show=\"displayDownloadStatus\"><div class=\"toastClose\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"close()\"><span aria-hidden=\"true\">X</span></button></div><div class=\"\"><div ng-show=\"downloadingSelectedBills\"><div class=\"downloadingBills\" res=\"downloading_selected_bills\"></div><img alt=\"loading\" class=\"widget-loader-inline invoiceLoader\" src=\"images/widget-loader.gif\"></div><div ng-show=\"downloadSuccess\" class=\"downloadStatus col-xs-12\"><i class=\"fa fa-check-circle downloadSuccess\"></i><div class=\"downloadStatusText\" res=\"DT_success_message\"></div><button type=\"button\" aria-label=\"Press Dismiss to exit out of this window. Your bill have been successfully downloaded.\" class=\"download-dismiss-button\" ng-click=\"dismiss()\"><span res=\"_dismiss\"></span></button></div><div ng-show=\"timeoutError && !(firstRetryAttempt || secondRetryAttempt || lastRetryAttempt)\" class=\"downloadStatus col-xs-12\"><i class=\"fa fa-exclamation-triangle downloadError\"></i><div class=\"downloadStatusText\" res=\"DT_timeout_error_message\"></div><button type=\"button\" aria-label=\"Press Retry to download selected bills.\" class=\"download-retry-button\" ng-click=\"retry(\'firstRetryAttempt\')\"><span res=\"_retry\"></span></button></div><div ng-show=\"firstRetryAttempt\" class=\"downloadStatus col-xs-12\"><i class=\"fa fa-exclamation-triangle downloadError\"></i><div class=\"downloadStatusText\" res=\"DT_first_timeout_error_message\"></div><button type=\"button\" aria-label=\"Press the Retry button to try downloading bills again.\" class=\"download-retry-button\" ng-click=\"retry(\'secondRetryAttempt\')\"><span res=\"_retry\"></span></button></div><div ng-show=\"secondRetryAttempt\" class=\"downloadStatus col-xs-12\"><i class=\"fa fa-exclamation-triangle downloadError\"></i><div class=\"downloadStatusText\" res=\"DT_second_timeout_error_message\"></div><button type=\"button\" aria-label=\"Press Retry button for one final attempt to download bills.\" class=\"download-retry-button\" ng-click=\"retry(\'lastRetryAttempt\')\"><span res=\"_retry\"></span></button></div><div ng-show=\"lastRetryAttempt\" class=\"downloadStatus col-xs-12\"><i class=\"fa fa-exclamation-triangle downloadError\"></i><div class=\"downloadStatusText\" res=\"DT_technical_error_message\"></div><button type=\"button\" aria-label=\"Your attempts have failed, please press Dismiss button to continue.\" class=\"download-dismiss-button\" ng-click=\"dismiss()\"><span res=\"_dismiss\"></span></button></div><div ng-show=\"technicalError\" class=\"downloadStatus col-xs-12\"><i class=\"fa fa-exclamation-triangle downloadError\"></i><div class=\"downloadStatusText\" res=\"DT_technical_error_message\"></div></div></div></div><div class=\"dtStatusTab\" ng-class=\"displayDownloadStatus=== true ? \'dtTabSelected\' : \'dtTab\'\"><button class=\"dtStatusBtn\" ng-click=\"bulkDownloadStatus()\"><span res=\"_downloads\"></span></button></div></div>");
$templateCache.put("scripts/modules/uteBill/downloadBill.html","<div class=\"modal-container\"><div class=\"modal-header\" res=\"Download_Bills\"></div><div class=\"info-text\"><div res=\"bills_Zip_file\"></div></div><div class=\"modal-body\"><div class=\"col-md-12 col-sm-12 col-xs-12\"><input type=\"checkbox\" name=\"selectAll\" class=\"selectBox\" ng-model=\"ub.checkAll\" ng-change=\"ub.selectAll()\"> <span res=\"all_months\"></span></div><div class=\"col-md-12 col-sm-12 col-xs-12\" ng-repeat=\"date in ub.bb.invoiceDateArray\" style=\"text-transform: capitalize;\"><input type=\"checkbox\" name=\"{{date.name}}\" class=\"selectBox\" ng-checked=\"ub.checkAll\" ng-change=\"ub.isDateSelected(date.selected)\" ng-disabled=\"ub.checkAll\" ng-model=\"date.selected\"> <span>{{date.name}}</span></div></div><div class=\"print-notification-message\"><div id=\"print-notification\" class=\"print-notification\"><span res=\"print_notification\"></span></div><div id=\"read-more\" class=\"read-more\"><a ng-click=\"ub.readMore()\" res=\"read_more_link\"></a> <i class=\"fa fa-angle-down\"></i></div></div><div class=\"modal-footer pull-right\"><button name=\"downloadSelected\" aria-label=\"Press to download selected bills.\" class=\"pull-right red-button\" ng-disabled=\"(!ub.checkAll && !ub.dateSelected)\" ng-click=\"ub.downloadSelectedBills()\" ng-class=\"\'disableBtn\': (!ub.checkAll && !ub.dateSelected)\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"downloadBillConfirmation\"><span res=\"Download_Selected\"></span></button> <a data-dismiss=\"modal\" aria-label=\"Press to Cancel selected bills to download.\" ng-click=\"ub.cancel()\" class=\"cancel-button\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"cancelDownload\"><span res=\"_cancel\"></span></a></div></div>");
$templateCache.put("scripts/modules/uteBill/uteBill.html","<section class=\"page-brite-bill\"><div class=\"top-bar-ctn paynow-body-size ptm payment-top-bar\"><div class=\"mtm radius-three-sides light-gray-bg container plm mtl\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 ptm pbs prs\"><span class=\"title-light-h4 mbs\" style=\"position:relative; top:-5px;\"><span class=\"semi-bold\" res=\"paynow_acc_balance_today\" data-test-id=\"myr-paymentTopBar-totalAccountBalance\"></span><div class=\"rui-package-pricing title-h3\"><div class=\"price semi-bold\"><span class=\"price-sign\" ng-hide=\"ub.lang === \'fr\'\">$</span> <span class=\"price-dollars\" data-test-id=\"myr-paymentTopBar-totalAccountBalanceDollars\">{{ub.abs.accountBalance.balanceAmount.substr(0,ub.abs.accountBalance.balanceAmount.indexOf(\'.\'))}}</span> <span class=\"price-details\"><span class=\"price-cents\" data-test-id=\"myr-paymentTopBar-totalAccountBalanceCents\">{{ub.abs.accountBalance.balanceAmount | decimals : ub.lang}} <span ng-hide=\"ub.lang ===\'en\'\">$</span></span> <span class=\"price-period\">&nbsp;</span></span></div></div><div ng-if=\"(ub.abdf.billingDetails.pastDueBalance > 0) && (ub.abdf.billingDetails.balanceAmount > 0)\" class=\"red overdue-balance\" data-test-id=\"myr-paymentTopBar-includingOverdueText\"><span res=\"paynow_overdue\"></span></div></span></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 rm ptm pbs\"><div class=\"pay-now-ctn row\"><div class=\"title-light-h4 mbs\"><span class=\"semi-bold\" data-test-id=\"myr-paymentTopBar-paymentMethodLabel\" res=\"paynow_payment_method2\"></span>: <span class=\"mrm light\" data-test-id=\"myr-paymentTopBar-paymentMethod\" ng-switch=\"\" on=\"ub.ptbs.paymentMethod\"><span ng-switch-when=\"D\" res=\"paynow_method_check\"></span> <span ng-switch-when=\"C\" res=\"paynow_payment_method_cc\"></span> <span ng-switch-when=\"R\" res=\"paynow_invoice\"></span> <span ng-switch-when=\"U\" res=\"change_method_unavailable\"></span></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"\" ng-switch=\"\" data-test-id=\"myr-paymentTopBar-paymentMethodDetails\" on=\"ub.ptbs.paymentMethod\"><span ng-switch-when=\"D\"><span class=\"title-light-h4 semi-bold\" data-test-id=\"myr-paymentTopBar-bankAccountNumber\" res=\"paynow_bank_account_number\"></span>: {{ ub.getBankAccountNumber()}}</span> <span ng-switch-when=\"C\" class=\"payment-method-details\"><img class=\"payment-method-image\" data-test-id=\"myr-paymentTopBar-ccImage\" ng-src=\"{{ ub.getCreditCardImage() }}\"> <span data-test-id=\"myr-paymentTopBar-ccType\"><strong>{{ ub.getCreditCardText() }}</strong></span><br><span data-test-id=\"myr-paymentTopBar-ccNumber\">XXXX XXXX XXXX {{ ub.abdf.billingDetails.methodOfPayment.creditCardDetails.ccNumber }}</span></span> <span ng-switch-when=\"R\"></span> <span ng-switch-default=\"\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\" ng-hide=\"ub.state === \'changemethod\'\"><a class=\"mrm button-view-bill\" href=\"#/changePayMethod\" data-ng-class=\"ub.btnSettings.changePaymentMethod === ub.btnStatus.disabled ? \'not-active\' : \'\'\" data-ng-hide=\"ub.btnSettings.changePaymentMethod === ub.btnStatus.hidden\"><span res=\"paynow_change_bill_type\" data-test-id=\"myr-paymentTopBar-changePaymentMethod\" class=\"bold mts\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\" ng-hide=\"ub.state === \'paymenthistory\'\"><a class=\"button-view-bill\" href=\"#/payHistory\"><span res=\"history\" data-test-id=\"myr-paymentTopBar-paymentHistory\" class=\"bold\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\" style=\"margin-top:5px;\" ng-if=\"ub.als.selectedAccount.accountStatus === \'Active\' && ub.als.hasActiveWirelessAccount && ub.hasCommunitiesAccess && ub.state != \'changemethod\' && ub.state != \'paymenthistory\'\"><a class=\"button-view-bill\" ng-click=\"ub.triggerTrackData(ub.mbhUrls.billInquiry)\"><span res=\"_bill_inquiry_badge_link\" class=\"bold\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 ptm pbs prs\"><div style=\"display:none;\">{{ub.state}} BB Version 0.16.3</div><myr-account-balance view-html=\"accountBalanceHorizon.html\" permission=\"VIEW_ACCOUNT_BALANCE\"></myr-account-balance><div ng-show=\"ub.state != \'paynow\'\"><div class=\"brite-bill-pay-now\"><button name=\"payBill\" class=\"cta-round primary large pay-now-btn-cm2\" ng-click=\"ub.payBill()\" data-test-id=\"myr-paymentTopbar-payBill\"><span class=\"white\" res=\"acc_balance_pay_now\"></span></button></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 pbs txtC\" ng-show=\"ub.state !=\'paynow\'\"><div ng-show=\"ub.state != \'paynow\'\"><div ng-show=\"isPaynowPage\" class=\"mbm\">&nbsp;</div><div class=\"primary ptm\" ng-show=\"false\"><span class=\"\" ng-if=\"isPrepaid && !isPreAuth\" res=\"acc_overview_expires_on\"></span> <span class=\"\" ng-if=\"isPrepaid && isPreAuth\" res=\"acc_overview_withdrawal_by\"></span><div class=\"prm\" ng-show=\"hasBallance\"><div class=\"\" ng-switch=\"\" on=\"ub.ptbs.paymentMethod\"><span ng-switch-when=\"D\" res=\"acc_overview_due_debit\"></span> <span ng-switch-when=\"C\" res=\"acc_overview_due_credit\"></span> <span ng-switch-when=\"R\" res=\"acc_overview_due_invoice\"></span> <span ng-switch-default=\"\"></span> :</div><div><span class=\"semi-bold\">{{(lng === \'en\') ? dtEn : dtFr}}</span></div></div></div></div></div></div></div><div class=\"mtm radius-three-sides container mtl\" ng-hide=\"ub.isNoBillsAvailable() || ub.isBillError()|| ub.isInvoiceProcessing()\"><div ng-show=\"ub.showInvoiceDates\" class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 ptm pbs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"view-bill-for plm col-xs-6 col-sm-6 col-md-6 col-lg-6\" res=\"view_bill_for\" data-test-id=\"myr-paymentTopBar-viewBillTitle\"></div><div ng-hide=\"uteBillFailed || ub.isInvoiceProcessing()\" class=\"pull-right\"><button name=\"downloadBill\" aria-label=\"Press Button to Download bills.\" class=\"col-xs-6 col-sm-3 col-md-3 col-lg-2 download-bills cta-round primary large pay-now-btn-cm2\" ng-click=\"ub.downloadBill()\" ng-disabled=\"disableDownloadSelectedButton\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"downloadBills\"><span class=\"white\" res=\"Download_Bills\"></span></button></div></div><div class=\"col-xs-12 date-list\" ng-hide=\"uteBillFailed\"><div class=\"date-badge col-md-4 col-sm-4 col-xs-12\" ng-repeat=\"date in ub.bb.invoiceDateArray | limitTo: billLimit\" ng-click=\"ub.openInvoice(date)\"><div class=\"col-md-2 col-sm-2 col-xs-2 date-badge-icon\"><img src=\"/web/smb/cms/images/form-paper-info.svg\" alt=\"\" role=\"presentation\"></div><div class=\"col-md-9 col-sm-9 col-xs-9 date-content\"><span>{{date.name}}</span></div></div></div><div class=\"col-xs-12\" style=\"text-align: center;\" ng-hide=\"billLimit >= ub.bb.invoiceDateArray.length || ub.isInvoiceProcessing()\"><button type=\"button\" res=\"load_more_bills\" ng-click=\"ub.showMoreDates()\" class=\"btn btn-primary load-bills\"></button></div></div></div><div class=\"widget-loader-inline invoiceLoader\" ng-show=\"ub.isInvoiceProcessing()\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div><div class=\"row light-gray-bg margin-top15\" ng-hide=\"ub.isInvoiceProcessing()\"><div class=\"container error-message\" data-ng-if=\"ub.isNoBillsAvailable() || ub.isBillError()\"><div class=\"col-xs-12\"><div ng-if=\"ub.isNoBillsAvailable() && !ub.isBillError()\"><div class=\"brite-bill-nobill-image\"><img ng-src=\"images/info_notice_lg.png\"></div><div class=\"error-message-title\" res=\"bb_error_message_header_no_bill\"></div><div class=\"error-message\"><span res=\"bb_error_message_no_bill\"></span> <span>{{ub.billingCycleEndDate() | date:\'MM/dd\'}}.</span></div></div><div ng-if=\"ub.isBillError()\"><img class=\"brite-bill-error-image\" ng-src=\"images/warning_yellow_lg.png\"><div class=\"information\"></div><div class=\"error-message-title\" res=\"bb_error_message_header_system_issue\"></div><div class=\"error-message\" res=\"bb_error_message_system_issue\"></div><div class=\"row brite-bill-live-chat\"><div class=\"col-sm-6 col-xs-12 brite-bill-live-chat-right hidden-xs\"><img class=\"phone-image\" ng-src=\"images\\phone.png\"><span res=\"800_number\"></span></div><div class=\"col-xs-12 col-sm-6 brite-bill-live-chat-left\"><bold-chat-static-button ng-if=\"ub.lang === \'en\'\" data-cbid=\"{{boldChat.uteBillError.en.cbid}}\" data-dynamic-div=\"{{boldChat.uteBillError.en.dynamicDivId}}\" data-chat-button=\"{{boldChat.uteBillError.en.chatButtonClass}}\"></bold-chat-static-button><bold-chat-static-button ng-if=\"ub.lang === \'fr\'\" data-cbid=\"{{boldChat.uteBillError.fr.cbid}}\" data-dynamic-div=\"{{boldChat.uteBillError.fr.dynamicDivId}}\" data-chat-button=\"{{boldChat.uteBillError.fr.chatButtonClass}}\"></bold-chat-static-button></div></div></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 cta-round bb-account-overview\" ui-sref=\"accountOverview\" res=\"return_to_account_overview\"></div></div></div></section>");
$templateCache.put("scripts/modules/uteBill/viewAllBills.html","<div class=\"modal-container\"><div class=\"modal-header\"><div class=\"date-array\" ng-class=\"{paginationtrue: vab.bb.invoiceDateArray.length > 1}\"><button ng-hide=\"vab.index == 0\" title=\"{{vab.prevBillDate()}}\" ng-click=\"vab.prevBill()\" class=\"pagination\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span class=\"date-title\">{{dateChangeTitle}}</span> <button ng-hide=\"vab.index >= (vab.bb.invoiceDateArray.length - 1)\" title=\"{{vab.nextBillDate()}}\" ng-click=\"vab.nextBill()\" class=\"pagination\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button></div><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vab.cancel()\"><span aria-hidden=\"true\">X</span></button></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"britebillInvoice && !pdfNotLoading\" ute-data-layer-event=\"\" event-name=\"interaction\" mapping-key=\"{{analyticsMappingKey}}\"><div id=\"bb_iframe_container\" class=\"iframe-ctn bb-iframe-container\" data-myr-brite-bill=\"\"></div></div><div class=\"col-xs-12\" ng-if=\"winInvoice && !pdfNotLoading\" ute-data-layer-event=\"\" event-name=\"interaction\" mapping-key=\"{{analyticsMappingKey}}\"><iframe class=\"\" id=\"winInvoiceFrame\" data-ng-src=\"{{winIframeUrl}}\" style=\"background-image: url(\'images/widget-loader.gif\');background-position: top;background-repeat: no-repeat;\"></iframe><script>document.getElementById(\'winInvoiceFrame\').onload = function(){$(\'iframe\').css(\'background-image\',\'none\');};</script></div><div class=\"col-xs-12 epostInvoices\" ng-if=\"epostInvoice && !pdfNotLoading\" ute-data-layer-event=\"\" event-name=\"interaction\" mapping-key=\"{{analyticsMappingKey}}\"><iframe class=\"\" id=\"epostFrame\" data-ng-src=\"{{epostURL}}\" style=\"background-image: url(\'images/widget-loader.gif\');background-position: top;background-repeat: no-repeat;\"></iframe><script>document.getElementById(\'epostFrame\').onload = function(){$(\'iframe\').css(\'background-image\',\'none\');};</script></div><div class=\"col-xs-12 alignCenter\" ng-if=\"pdfNotLoading\"><div class=\"errorMessageTitle\" res=\"bb_error_message_header_system_issue\"></div><span class=\"errorMessageContent\" res=\"bb_error_message_system_issue\"></span></div><div class=\"widget-loader\" ng-show=\"switchBillLoader\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div></div></div>");
$templateCache.put("scripts/modules/uteInternetUsage/uteInternetUsage.html","<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"_internet\"></span> <span class=\"widget-loader-inline ng-hide\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container returnInternetDash\"><a href=\"#/internetdash\" res=\"ute_label_go_back\"></a></div><div class=\"container\" ng-controller=\"InternetUsageController\" style=\"clear: both;\"><div class=\"ute-internet-usage\" ng-include=\'\"views/uteInternetUsage/uteInternetUsage.html\"\'></div></div>");
$templateCache.put("scripts/modules/viewGroupsAndReporting/viewGroups.html","<div class=\"container\"><div class=\"row nac-margin\"><div class=\"nac-heading-block\"><h2><span res=\"invoice_groups\"></span></h2><div class=\"clearfix\"></div></div></div><div id=\"iframe_wrapper\"><div id=\"iframe_container\"><iframe ng-src=\"{{iFrameSrcGroups}}\" width=\"100%\" height=\"680px\" frameborder=\"0\"></iframe></div></div></div>");
$templateCache.put("scripts/modules/viewGroupsAndReporting/viewReporting.html","<div class=\"container\"><div class=\"row nac-margin\"><div class=\"nac-heading-block\"><h2><span res=\"invoice_reporting\"></span></h2><div class=\"clearfix\"></div></div></div><div id=\"iframe_wrapper\"><div id=\"iframe_container\"><iframe ng-src=\"{{iFrameSrcReporting}}\" width=\"100%\" height=\"680px\" frameborder=\"0\"></iframe></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/talkAndTextPopup.html","<div class=\"modal-container\"><div class=\"modal-header\"><h3 res=\"wireless_talk-and-text\"></h3><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"close()\"><span aria-hidden=\"true\">x</span></button></div><div class=\"modal-body\"><div class=\"row\" ng-show=\"wdEmpty || wdMidCycle || errorMessage\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"technicalErrorMsg\" res=\"error_wireless_usage\"></div></div></div><div class=\"row\" ng-hide=\"wdEmpty || wdMidCycle || errorMessage\" cloaker=\"\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"!talkEmpty\"><h4 class=\"modal-title modal-title-background\" res=\"wireless_talk\"></h4><div class=\"colDataWrap paddbot60 {{wd.talk.unlimitedClass}}\"><section class=\"usage\"><div class=\"container-fluid\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"wd.talkArr.usageType === \'extras_summary\'\"><div class=\"col-xs-offset-6 col-xs-6 usage-info-title extraSumWhite\"><span class=\"usuage-title\">{{wd.talkArr.usageSets.periodGroup}}</span></div><hr style=\"width: 100%;\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"wd.talkArr.usageType === \'extras_summary\'\"><div class=\"row\" ng-if=\"wd.talkArr.usageType != \'pay-per-use\'\"><div class=\"col-xs-offset-6 col-xs-3 usage-info-title\"><span class=\"usuage-title\" res=\"wireless_usage_included\"></span></div><div class=\"col-xs-3 usage-info-title\"><span class=\"usuage-title\" res=\"wireless_usage_my-usage\" ng-if=\"wddsum.usageType != \'unlimited\'\"></span> <span class=\"usuage-title\" res=\"wireless_usage_total-usage\" ng-if=\"wddsum.usageType == \'unlimited\'\"></span></div><hr style=\"width: 100%;\"></div><div class=\"row\" ng-if=\"wd.talkArr.usageType == \'limited\' && wd.talkArr.isFamilySharing == true\"><div class=\"col-xs-offset-6 col-xs-3 usage-info-title\"><span class=\"usuage-title\" res=\"wireless_usage_others-usage\"></span></div><div class=\"col-xs-3 usage-info-title\"><span class=\"usuage-title\" res=\"wireless_usage_total-usage\"></span></div><hr style=\"width: 100%;\"></div><div class=\"row\" ng-if=\"wd.talkArr.usageType == \'limited\' && wd.talkArr.remaining > 0\"><div class=\"col-xs-offset-6 col-xs-3 usage-info-title\"><span class=\"usuage-title\" res=\"wireless_usage_remaining\"></span></div><hr style=\"width: 100%;\"></div><div class=\"row extraSum\" ng-if=\"wd.talkArr.usageType != \'unlimited\' && wd.talkArr.remaining <= 0\"><div class=\"col-xs-offset-6 col-xs-3 usage-info-title extraSumWhite\"><span class=\"usuage-title\" res=\"wireless_extra-usage\"></span></div><hr style=\"width: 100%;\"></div></div><div class=\"row\" ng-repeat=\"wdtsum in wd.talkArr\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"wdtsum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row extraSum\" ng-repeat=\"wdtsumSet in wdtsum.usageSets\"><div class=\"col-xs-6 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_my-usage\" ng-if=\"wddsum.usageType != \'unlimited\'\"></span> <span class=\"usuage-title\" res=\"wireless_usage_total-usage\" ng-if=\"wddsum.usageType == \'unlimited\'\"></span></div><div class=\"col-xs-offset-3 col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{(wdtsumSet.used - wdtsumSet.total) | number}} <span res=\"wireless_usage_minutes\"></span></span></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"wdtsum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"wdtsum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6\"><span class=\"type-title\" ng-show=\"wdtsum.usageType === \'extras_summary\'\">Extras</span> <span class=\"type-title\" ng-hide=\"wdtsum.usageType === \'extras_summary\'\">{{wdtsum.periodGroup}}</span></div><div class=\"col-xs-3 usage-info\"><span ng-if=\"wdtsum.usageType == \'unlimited\'\"><span class=\"usuage-ammount\" res=\"wireless_unlimited\"></span></span> <span ng-if=\"wdtsum.usageType == \'pay-per-use\'\"><span class=\"usuage-ammount\" res=\"wireless_extra-usage\"></span></span> <span ng-if=\"wdtsum.usageType == \'limited\'\"><span class=\"usuage-ammount\">{{wdtsum.total| number}} <span res=\"wireless_usage_minutes\"></span></span></span></div><div class=\"col-xs-3 usage-info\" ng-if=\"wdtsum.isFamilySharing == true\"><span class=\"usuage-ammount\">{{wdtsum.subscriberUsage| number}} <span res=\"wireless_usage_minutes\"></span></span></div><div class=\"col-xs-3 usage-info\" ng-if=\"wdtsum.isFamilySharing == false\"><span class=\"usuage-ammount\">{{wdtsum.used| number}} <span res=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row\" ng-if=\"wdtsum.usageType == \'limited\' && wdtsum.isFamilySharing == true\"><div class=\"col-xs-6\"><span class=\"type-title\" ng-show=\"wdtsum.usageType === \'extras_summary\'\">Extras</span> <span class=\"type-title\" ng-hide=\"wdtsum.usageType === \'extras_summary\'\">{{wdtsum.periodGroup}}</span></div><div class=\"col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{wdtsum.othersUsage| number}} <span res=\"wireless_usage_minutes\"></span></span></div><div class=\"col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{wdtsum.used| number}} <span res=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row\" ng-if=\"wdtsum.usageType == \'limited\' && wdtsum.remaining > 0\"><div class=\"col-xs-6\"><span class=\"type-title\" ng-show=\"wdtsum.usageType === \'extras_summary\'\">Extras</span> <span class=\"type-title\" ng-hide=\"wdtsum.usageType === \'extras_summary\'\">{{wdtsum.periodGroup}}</span></div><div class=\"col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{wdtsum.remaining| number}} <span res=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row extraSum\" ng-if=\"wdtsum.usageType != \'unlimited\' && wdtsum.remaining <= 0\"><div class=\"col-xs-6\"><span class=\"type-title\" ng-show=\"wdtsum.usageType === \'extras_summary\'\">Extras</span> <span class=\"type-title\" ng-hide=\"wdtsum.usageType === \'extras_summary\'\">{{wdtsum.periodGroup}}</span></div><div class=\"col-xs-offset-3 col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{(wdtsum.used - wdtsum.total) | number}} <span res=\"wireless_usage_minutes\"></span></span></div></div></div></div></div></div></section></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"!textEmpty\"><h4 class=\"modal-title modal-title-background\" res=\"wireless_text\"></h4><div class=\"colDataWrap paddbot60 {{wd.sms.unlimitedClass}}\"><section class=\"usage\"><div class=\"container-fluid\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"wd.smsArr.usageType === \'extras_summary\'\"><div class=\"col-xs-offset-6 col-xs-6 usage-info-title extraSumWhite\"><span class=\"usuage-title\">{{wd.smsArr.usageSets.periodGroup}}</span></div><hr style=\"width: 100%;\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"wd.smsArr.usageType === \'extras_summary\'\"><div class=\"row\" ng-if=\"wd.smsArr.usageType != \'pay-per-use\'\"><div class=\"col-xs-offset-6 col-xs-3 usage-info-title\"><span class=\"usuage-title\" res=\"wireless_usage_included\"></span></div><div ng-repeat=\"wdssum in wd.smsArr | limitTo: 1\"><div class=\"col-xs-3 usage-info-title\" ng-if=\"wdssum.usageType == \'unlimited\'\"><span class=\"usuage-title\" ng-if=\"wdssum.action == 0\" res=\"wireless_usage_total-usage\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 1\" res=\"wireless_usage-text_total-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 2\" res=\"wireless_usage-text_total-usage_out\"></span></div><div class=\"col-xs-3 usage-info-title\" ng-if=\"wdssum.usageType != \'unlimited\'\"><span class=\"usuage-title\" ng-if=\"wdssum.action == 0\" res=\"wireless_usage-text_my-usage\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 1\" res=\"wireless_usage-text_my-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 2\" res=\"wireless_usage-text_my-usage_out\"></span></div></div><hr style=\"width: 100%;\"></div><div class=\"row\" ng-if=\"wd.smsArr.usageType == \'limited\' && wd.smsArr.isFamilySharing == true\"><div ng-repeat=\"wdssum in wd.smsArr | limitTo: 1\"><div class=\"col-xs-offset-6 col-xs-3 usage-info-title\"><span class=\"usuage-title\" ng-if=\"wdssum.action == 0\" res=\"wireless_usage-text_others-usage\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 1\" res=\"wireless_usage-text_others-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 2\" res=\"wireless_usage-text_others-usage_out\"></span></div><div class=\"col-xs-3 usage-info-title\"><span class=\"usuage-title\" ng-if=\"wdssum.action == 0\" res=\"wireless_usage-text_total-usage\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 1\" res=\"wireless_usage-text_total-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 2\" res=\"wireless_usage-text_total-usage_out\"></span></div></div><hr style=\"width: 100%;\"></div><div class=\"row\" ng-if=\"wd.smsArr.usageType == \'limited\' && wd.smsArr.remaining > 0\"><div class=\"col-xs-offset-6 col-xs-3 usage-info-title\"><span class=\"usuage-title\" res=\"wireless_usage-text_remaining\"></span></div><hr style=\"width: 100%;\"></div><div class=\"row extraSum\" ng-if=\"wd.smsArr.usageType != \'unlimited\' && wd.smsArr.remaining <= 0\"><div class=\"col-xs-offset-6 col-xs-3 usage-info-title extraSumWhite\"><span class=\"usuage-title\" res=\"wireless_extra-usage\"></span></div><hr style=\"width: 100%;\"></div></div><div class=\"row\" ng-repeat=\"wdssum in wd.smsArr\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"wdssum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row extraSum\" ng-repeat=\"wdssumSet in wdssum.usageSets\"><div class=\"col-xs-6\"><span class=\"type-title\" ng-show=\"wdssum.usageType === \'extras_summary\'\">Extras</span> <span class=\"type-title\" ng-hide=\"wdssum.usageType === \'extras_summary\'\">{{wdssum.periodGroup}}</span></div><div class=\"col-xs-offset-3 col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{(wdssumSet.used - wdssumSet.total) | number}} {{textsLbl}}</span></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"wdssum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"wdssum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6\"><span class=\"type-title\" ng-show=\"wdssum.usageType === \'extras_summary\'\">Extras</span> <span class=\"type-title\" ng-hide=\"wdssum.usageType === \'extras_summary\'\">{{wdssum.periodGroup}}</span></div><div class=\"col-xs-3 usage-info\"><span ng-if=\"wdssum.usageType == \'unlimited\'\"><span class=\"usuage-ammount\" res=\"wireless_unlimited\"></span></span> <span ng-if=\"wdssum.usageType == \'pay-per-use\'\"><span class=\"usuage-ammount\" res=\"wireless_extra-usage\"></span></span> <span ng-if=\"wdssum.usageType == \'limited\'\"><span class=\"usuage-ammount\">{{wdssum.total| number}} {{textsLbl}}</span></span></div><div class=\"col-xs-3 usage-info\" ng-if=\"wdssum.isFamilySharing == true\"><span class=\"usuage-ammount\">{{wdssum.subscriberUsage| number}} {{textsLbl}}</span></div><div class=\"col-xs-3 usage-info\" ng-if=\"wdssum.isFamilySharing == false\"><span class=\"usuage-ammount\">{{wdssum.used| number}} {{textsLbl}}</span></div></div><div class=\"row\" ng-if=\"wdssum.usageType == \'limited\' && wdssum.isFamilySharing == true\"><div class=\"col-xs-6\"><span class=\"type-title\" ng-show=\"wdssum.usageType === \'extras_summary\'\">Extras</span> <span class=\"type-title\" ng-hide=\"wdssum.usageType === \'extras_summary\'\">{{wdssum.periodGroup}}</span></div><div class=\"col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{wdssum.othersUsage| number}} {{textsLbl}}</span></div><div class=\"col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{wdssum.used| number}} {{textsLbl}}</span></div></div><div class=\"row\" ng-if=\"wdssum.usageType == \'limited\' && wdssum.remaining > 0\"><div class=\"col-xs-6\"><span class=\"type-title\" ng-show=\"wdssum.usageType === \'extras_summary\'\">Extras</span> <span class=\"type-title\" ng-hide=\"wdssum.usageType === \'extras_summary\'\">{{wdssum.periodGroup}}</span></div><div class=\"col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{wdssum.remaining| number}} {{textsLbl}}</span></div></div><div class=\"row extraSum\" ng-if=\"wdssum.usageType != \'unlimited\' && wdssum.remaining <= 0\"><div class=\"col-xs-6\"><span class=\"type-title\" ng-show=\"wdssum.usageType === \'extras_summary\'\">Extras</span> <span class=\"type-title\" ng-hide=\"wdssum.usageType === \'extras_summary\'\">{{wdssum.periodGroup}}</span></div><div class=\"col-xs-offset-3 col-xs-3 usage-info\"><span class=\"usuage-ammount\">{{(wdssum.used - wdssum.total) | number}} {{textsLbl}}</span></div></div></div></div></div></div></section></div></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/wirelessDashboard.html","<section class=\"page-wireless\"><div><div class=\"container\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ins ute-content-injector-no-cache=\"\" compile=\"true\" language=\"{{lng}}\" content-id=\"/web/smb/cms/selfserve/onlinebilling/content/wireless-banner\"></ins></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"wireless\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-4\"><div class=\"styled-select wireless-account-select\" data-ng-show=\"wirelessDashData.length > 1\"><select name=\"accountType\" required=\"\" data-ng-model=\"wirelessDashActive\" ng-change=\"changeAccount()\" ng-options=\"value.ctn | phone2 for (key, value) in wirelessDashData\"></select></div><div class=\"wireless-account-spacer\" data-ng-show=\"wirelessDashData.length == 1\"></div></div></div></div><div ng-if=\"showReactivateCtn()\"><ute-reactivate-ctn-message-box data-input-model=\"dataModelForReactivateCtn\"></ute-reactivate-ctn-message-box></div><div class=\"container\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-6\"><h2 class=\"widget-loader-mod\" res=\"wireless_my-wireless-usage\"></h2><div class=\"widget-loader\" ng-show=\"loadingDataIndicator\"><img src=\"images/widget-loader.gif\" alt=\"\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-6\" data-ng-show=\"displayContent\"><h5 class=\"wireless-new-usage-cycle ptm\" res=\"wireless_new-usage-cycle\" res-param-nextbilldaysuntil=\"{{ab.accountBalance.nextBillDate | date3}}\"></h5></div></div><div class=\"row\" data-ng-show=\"displayContent && !wdEmpty && !wdMidCycle && !wdMCPPCrerating && !(dmRedirect && dmEligibility && getDmServiceGrp() == 1)\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 updateLine\"><h5 class=\"refreshUpdate\" res=\"wireless_updated_12_hours\"></h5></div></div><div class=\"row ng-cloak\" ng-cloak=\"\" data-ng-show=\"displayContent && !wdEmpty && !wdMidCycle && !wdMCPPCrerating && !(dmRedirect && dmEligibility && getDmServiceGrp() == 1)\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"usageColours\"><h6><span class=\"dot green\">&nbsp;</span><span class=\"text-uppercase\" res=\"wireless_ok\"></span></h6><h6><span class=\"dot yelow\">&nbsp;</span><span class=\"text-uppercase\" res=\"wireless_extra-usage\"></span></h6></div></div></div><div class=\"container\" ng-hide=\"dmRedirect && dmEligibility && getDmServiceGrp() == 1\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div class=\"row\" ng-if=\"dmRedirect && dmEligibility && getDmServiceGrp() == 1\"><div class=\"col-xs-12 dmWirelessUsage\"><div class=\"col-xs-12 col-md-6 usageBlock\" ng-class=\"(textEmpty && talkEmpty) ? \'dataWithoutTalkTextUsage\' : \'dataUsage\'\" ng-if=\"!dataEmpty\" ng-hide=\"maintenanceTime\"><div class=\"dmUsageTitle\"><span class=\"wireless_data\" res=\"wireless_data\"></span>: <span ng-show=\"lng === \'en\'\">{{wpkg_wd.postPaidPhoneDetails.planDescription}}</span> <span ng-show=\"lng === \'fr\'\">{{wpkg_wd.postPaidPhoneDetails.planDescriptionFr}}</span><div ng-if=\"lng === \'en\'\"><span class=\"contributed\" ng-if=\"contributedData.value>0\">{{contributedData.value| number: 0}}{{contributedData.unit}} <span res=\"_shared_data\"></span></span></div><div ng-if=\"lng === \'fr\'\"><span class=\"contributed\" ng-if=\"contributedData.value>0 && contributedData.unit.toLowerCase() === \'gb\'\">{{contributedData.value| number: 0}}<span res=\"wireless_usage_gb\"></span> <span res=\"_shared_data\"></span></span> <span class=\"contributed\" ng-if=\"contributedData.value>0 && contributedData.unit.toLowerCase() === \'mb\'\">{{contributedData.value| number: 0}}<span res=\"wireless_usage_mb\"></span> <span res=\"_shared_data\"></span></span></div></div><div class=\"dmUsageDesc\" res=\"dm_usage_desc\"></div><div res=\"dm_new\" class=\"highlightedText\"></div><button name=\"dm_redirect_btn\" type=\"button\" res=\"dm_real_time_usage\" class=\"dmButton\" ng-click=\"redirectToDMDashboard()\" aria-label=\"Click on Manage Data Usage & Alerts\"></button><form id=\"dmFormData\" action=\"{{dmUrl}}\" method=\"get\"><input type=\"hidden\" name=\"icid\" value=\"{{icid}}\"> <input type=\"hidden\" name=\"token\" value=\"{{token}}\"></form></div><div class=\"col-xs-12 col-md-6\" ng-style=\"maintenanceTime && {\'border-left\' : \'1px solid #ccc\'}\" ng-if=\"!textEmpty || !talkEmpty\"><div class=\"usageBlock\" ng-class=\"dataEmpty ? \'talkTextWithoutDataUsage\' : \'talkTextUsage\'\"><div class=\"dmUsageTitle\" ng-if=\"!textEmpty && !talkEmpty\"><span class=\"txt\" res=\"wireless_talk\"></span>: <span ng-hide=\"wd.talk.unlimitedShow\"><span class=\"ammount\">{{wd.talk.globalDisplayRemain}}<ng-pluralize count=\"wd.talk.globalDisplayRemain\" when=\"{\'0\': \'min\', \'1\': \'min\', \'other\': \'mins\'}\"></ng-pluralize></span> <span class=\"remaining\" res=\"wireless_remaining\"></span></span> <span ng-show=\"wd.talk.unlimitedShow\"><span class=\"subtxt\" res=\"wireless_unlimited\"></span></span> <span>/</span> <span class=\"txt\" res=\"wireless_text\"></span>: <span class=\"txt\" ng-show=\"lng === \'fr\'\" res=\"wireless_text_2\"></span> <span ng-hide=\"wd.sms.unlimitedShow\"><span class=\"ammount\">{{wd.sms.globalDisplayRemain}} texts</span> <span class=\"remaining\" res=\"wireless_remaining\"></span></span> <span ng-show=\"wd.sms.unlimitedShow\"><span class=\"subtxt\" res=\"wireless_unlimited\"></span></span></div><div class=\"dmUsageTitle\" ng-if=\"textEmpty\"><span class=\"txt\" res=\"wireless_talk\"></span>: <span ng-hide=\"wd.talk.unlimitedShow\"><span class=\"ammount\">{{wd.talk.globalDisplayRemain}}<ng-pluralize count=\"wd.talk.globalDisplayRemain\" when=\"{\'0\': \'min\', \'1\': \'min\', \'other\': \'mins\'}\"></ng-pluralize></span> <span class=\"remaining\" res=\"wireless_remaining\"></span></span> <span ng-show=\"wd.talk.unlimitedShow\"><span class=\"subtxt\" res=\"wireless_unlimited\"></span></span></div><div class=\"dmUsageTitle\" ng-if=\"talkEmpty\"><span class=\"txt\" res=\"wireless_text\"></span>: <span class=\"txt\" ng-show=\"lng === \'fr\'\" res=\"wireless_text_2\"></span> <span ng-hide=\"wd.sms.unlimitedShow\"><span class=\"ammount\">{{wd.sms.globalDisplayRemain}} texts</span> <span class=\"remaining\" res=\"wireless_remaining\"></span></span> <span ng-show=\"wd.sms.unlimitedShow\"><span class=\"subtxt\" res=\"wireless_unlimited\"></span></span></div><div class=\"dmUsageDesc hidden-xs hidden-sm\"></div><button name=\"talk_text_popup_btn\" type=\"button\" res=\"dm_talk_text_btn\" class=\"dmButton\" ng-click=\"openTalkTextPopup()\" aria-label=\"Click on view your talk and text usage\"></button></div></div></div></div><div class=\"row\" cloaker=\"\" ng-hide=\"wdEmpty || wdMidCycle || (dmRedirect && dmEligibility && getDmServiceGrp() == 1)\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\" ng-show=\"showData\"><div class=\"serviceWrap\" ng-click=\"dataIsCollapsed = !dataIsCollapsed;onClickViewMyWirelessDataUsage();\"><div class=\"inner-content text-center {{wd.data.globalColor}} {{wd.data.unlimitedClass}}\"><div class=\"center c100\" ng-class=\"\'p\' + wd.data.globalPercentage\" ng-hide=\"wd.data.unlimitedShow\"><span class=\"inner-circle data\"><div class=\"h3\"><span class=\"ico rui-icon-mobile-internet\"></span> <span class=\"txt\" res=\"wireless_data\"></span></div><span class=\"ammount\" ng-if=\"(wd.data.globalDisplayRemain / 1024) >= 1024\">{{(wd.data.globalDisplayRemain / 1048576) | bilingualnumber:2}} <strong style=\"font-weight:normal;\" res=\"wireless_usage_gb\"></strong></span> <span class=\"ammount\" ng-if=\"(wd.data.globalDisplayRemain / 1024) < 1024\">{{(wd.data.globalDisplayRemain / 1024) | number:0}} <strong style=\"font-weight:normal;\" res=\"wireless_usage_mb\"></strong></span> <span class=\"remaining\" ng-hide=\"!globalDataDisplayRemainPlural\" res=\"wireless_remaining_plural\"></span> <span class=\"remaining\" ng-hide=\"globalDataDisplayRemainPlural\" res=\"wireless_remaining\"></span> <span class=\"extras\" ng-show=\"wd.data.globalHaveExtras\"><strong>+</strong><br>extras</span><span class=\"cta\" ng-show=\"dataIsCollapsed\" res=\"wireless_view\" atm=\"wireless_viewdata_viewdata\"></span> <span class=\"cta\" ng-hide=\"dataIsCollapsed\" res=\"wireless_close\"></span></span><div class=\"slice\"><div class=\"bar\"></div><div class=\"fill\"></div></div></div><div class=\"unlimited center\" ng-show=\"wd.data.unlimitedShow\"><div class=\"h3\"><span class=\"ico rui-icon-mobile-internet\"></span> <span class=\"txt\" res=\"wireless_data\"></span><br><span class=\"subtxt\" res=\"wireless_unlimited\" ng-hide=\"wd.data.globalOnlyExtras\"></span> <span class=\"subtxt\" ng-show=\"wd.data.globalOnlyExtras\">&nbsp;</span> <span class=\"extras\" ng-show=\"wd.data.globalHaveExtras && dataIsCollapsed\"><strong>+</strong><br>extras</span></div></div></div></div><div collapse=\"dataIsCollapsed\" class=\"colDataWrap paddbot60 {{wd.data.unlimitedClass}}\"><section class=\"usage\"><div class=\"container-fluid\"><div class=\"row\" ng-repeat=\"wddsum in wd.dataArr\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h4 class=\"type-title\" ng-show=\"wddsum.usageType === \'extras_summary\'\">Extras</h4><h4 class=\"type-title\" ng-hide=\"wddsum.usageType === \'extras_summary\'\">&nbsp;</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"wddsum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row extraSum\" ng-repeat=\"wddsumSet in wddsum.usageSets\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\">{{wddsumSet.periodGroup}}</span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\" ng-if=\"((wddsumSet.used - wddsumSet.total) / 1024) >= 1024\">{{((wddsumSet.used - wddsumSet.total) / 1048576) | number:2}} <span res=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"((wddsumSet.used - wddsumSet.total) / 1024) < 1024\">{{((wddsumSet.used - wddsumSet.total) / 1024) | number:0}} <span res=\"wireless_usage_mb\"></span></span></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"wddsum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"wddsum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_included\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span ng-if=\"wddsum.usageType == \'unlimited\'\"><strong><span class=\"usuage-ammount\" res=\"wireless_unlimited\"></span></strong></span><span ng-if=\"wddsum.usageType == \'limited\'\"><span class=\"usuage-ammount\" ng-if=\"(wddsum.total / 1024) >= 1024\">{{(wddsum.total / 1048576) | number:2}} <span res=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"(wddsum.total / 1024) < 1024\">{{(wddsum.total / 1024) | number:0}} <span res=\"wireless_usage_mb\"></span></span></span></div></div><div class=\"row\" ng-if=\"wddsum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_my-usage\" ng-if=\"wddsum.usageType != \'unlimited\'\"></span> <span class=\"usuage-title\" res=\"wireless_usage_total-usage\" ng-if=\"wddsum.usageType == \'unlimited\'\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\" ng-if=\"wddsum.isFamilySharing == true\"><span class=\"usuage-ammount\" ng-if=\"(wddsum.subscriberUsage / 1024) >= 1024\">{{(wddsum.subscriberUsage / 1048576) | number:2}} <span res=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"(wddsum.subscriberUsage / 1024) < 1024\">{{(wddsum.subscriberUsage / 1024) | number:0}} <span res=\"wireless_usage_mb\"></span></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\" ng-if=\"wddsum.isFamilySharing == false\"><span class=\"usuage-ammount\" ng-if=\"(wddsum.used / 1024) >= 1024\">{{(wddsum.used / 1048576) | number:2}} <span res=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"(wddsum.used / 1024) < 1024\">{{(wddsum.used / 1024) | number:0}} <span res=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"wddsum.usageType == \'limited\' && wddsum.isFamilySharing == true\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_others-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\" ng-if=\"(wddsum.othersUsage / 1024) >= 1024\">{{(wddsum.othersUsage / 1048576) | number:2}} <span res=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"(wddsum.othersUsage / 1024) < 1024\">{{(wddsum.othersUsage / 1024) | number:0}} <span res=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"wddsum.usageType == \'limited\' && wddsum.isFamilySharing == true\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_total-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\" ng-if=\"(wddsum.used / 1024) >= 1024\">{{(wddsum.used / 1048576) | number:2}} <span res=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"(wddsum.used / 1024) < 1024\">{{(wddsum.used / 1024) | number:0}} <span res=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"wddsum.usageType == \'limited\' && wddsum.remaining > 0\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_remaining\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\" ng-if=\"(wddsum.remaining / 1024) >= 1024\">{{(wddsum.remaining / 1048576) | number:2}} <span res=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"(wddsum.remaining / 1024) < 1024\">{{(wddsum.remaining / 1024) | number:0}} <span res=\"wireless_usage_mb\"></span></span></div></div><div class=\"row extraSum\" ng-if=\"wddsum.usageType != \'unlimited\' && wddsum.remaining <= 0\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\" res=\"wireless_extra-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\" ng-if=\"((wddsum.used - wddsum.total) / 1024) >= 1024\">{{((wddsum.used - wddsum.total) / 1048576) | number:2}} <span res=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"((wddsum.used - wddsum.total) / 1024) < 1024\">{{((wddsum.used - wddsum.total) / 1024) | number:0}} <span res=\"wireless_usage_mb\"></span></span></div></div></div></div></div></div></section><div class=\"closingTongue {{wd.data.globalColor}}\" ng-hide=\"wd.data.unlimitedShow\" ng-click=\"dataIsCollapsed = !dataIsCollapsed\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-show=\"dataIsCollapsed\" res=\"wireless_view\"></span> <span ng-hide=\"dataIsCollapsed\" res=\"wireless_close\"></span></div></div></div><div class=\"closingTongue {{wd.data.globalColor}}\" ng-show=\"wd.data.unlimitedShow\" ng-click=\"dataIsCollapsed = !dataIsCollapsed\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-show=\"dataIsCollapsed\" res=\"wireless_view\"></span> <span ng-hide=\"dataIsCollapsed\" res=\"wireless_close\"></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\" ng-show=\"showTalk\"><div class=\"serviceWrap\" ng-click=\"talkIsCollapsed = !talkIsCollapsed\"><div class=\"inner-content text-center {{wd.talk.globalColor}} {{wd.talk.unlimitedClass}}\"><div class=\"center c100\" ng-class=\"\'p\' + wd.talk.globalPercentage\" ng-hide=\"wd.talk.unlimitedShow\"><span class=\"inner-circle data\"><div class=\"h3\"><span class=\"ico rui-icon-call\"></span> <span class=\"txt\" res=\"wireless_talk\"></span></div><span class=\"ammount\">{{wd.talk.globalDisplayRemain}}<ng-pluralize count=\"wd.talk.globalDisplayRemain\" when=\"{\'0\': \'min\', \'1\': \'min\', \'other\': \'mins\'}\"></ng-pluralize></span><span class=\"remaining\" ng-hide=\"!globalTalkDisplayRemainPlural\" res=\"wireless_remaining_plural\"></span> <span class=\"remaining\" ng-hide=\"globalTalkDisplayRemainPlural\" res=\"wireless_remaining\"></span> <span class=\"extras\" ng-show=\"wd.talk.globalHaveExtras\"><strong>+</strong><br>extras</span> <span class=\"cta\" ng-show=\"talkIsCollapsed\" atm=\"wireless_viewtalk_viewtalk\" res=\"wireless_view\"></span> <span class=\"cta\" ng-hide=\"talkIsCollapsed\" res=\"wireless_close\"></span></span><div class=\"slice\"><div class=\"bar\"></div><div class=\"fill\"></div></div></div><div class=\"unlimited center\" ng-show=\"wd.talk.unlimitedShow\"><div class=\"h3\"><span class=\"ico rui-icon-call\"></span> <span class=\"txt\" res=\"wireless_talk\"></span><br><span class=\"subtxt\" res=\"wireless_unlimited\" ng-hide=\"wd.talk.globalOnlyExtras\"></span> <span class=\"subtxt\" ng-show=\"wd.talk.globalOnlyExtras\">&nbsp;</span> <span class=\"extras\" ng-show=\"wd.talk.globalHaveExtras && talkIsCollapsed\"><strong>+</strong><br>extras</span></div></div></div></div><div collapse=\"talkIsCollapsed\" class=\"colDataWrap paddbot60 {{wd.talk.unlimitedClass}}\"><section class=\"usage\"><div class=\"container-fluid\"><div class=\"row\" ng-repeat=\"wdtsum in wd.talkArr\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h4 class=\"type-title\" ng-show=\"wdtsum.usageType === \'extras_summary\'\">Extras</h4><h4 class=\"type-title\" ng-hide=\"wdtsum.usageType === \'extras_summary\'\">{{wdtsum.periodGroup}}</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"wdtsum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row extraSum\" ng-repeat=\"wdtsumSet in wdtsum.usageSets\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\">{{wdtsumSet.periodGroup}}</span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{(wdtsumSet.used - wdtsumSet.total) | number}} <span res=\"wireless_usage_minutes\"></span></span></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"wdtsum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"wdtsum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_included\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span ng-if=\"wdtsum.usageType == \'unlimited\'\"><strong><span class=\"usuage-ammount\" res=\"wireless_unlimited\"></span></strong></span> <span ng-if=\"wdtsum.usageType == \'pay-per-use\'\"><strong><span class=\"usuage-ammount\" res=\"wireless_extra-usage\"></span></strong></span> <span ng-if=\"wdtsum.usageType == \'limited\'\"><span class=\"usuage-ammount\">{{wdtsum.total| number}} <span res=\"wireless_usage_minutes\"></span></span></span></div></div><div class=\"row\" ng-if=\"wdtsum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_my-usage\" ng-if=\"wddsum.usageType != \'unlimited\'\"></span> <span class=\"usuage-title\" res=\"wireless_usage_total-usage\" ng-if=\"wddsum.usageType == \'unlimited\'\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\" ng-if=\"wdtsum.isFamilySharing == true\"><span class=\"usuage-ammount\">{{wdtsum.subscriberUsage| number}} <span res=\"wireless_usage_minutes\"></span></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\" ng-if=\"wdtsum.isFamilySharing == false\"><span class=\"usuage-ammount\">{{wdtsum.used| number}} <span res=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row\" ng-if=\"wdtsum.usageType == \'limited\' && wdtsum.isFamilySharing == true\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_others-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{wdtsum.othersUsage| number}} <span res=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row\" ng-if=\"wdtsum.usageType == \'limited\' && wdtsum.isFamilySharing == true\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_total-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{wdtsum.used| number}} <span res=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row\" ng-if=\"wdtsum.usageType == \'limited\' && wdtsum.remaining > 0\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_remaining\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{wdtsum.remaining| number}} <span res=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row extraSum\" ng-if=\"wdtsum.usageType != \'unlimited\' && wdtsum.remaining <= 0\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\" res=\"wireless_extra-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{(wdtsum.used - wdtsum.total) | number}} <span res=\"wireless_usage_minutes\"></span></span></div></div></div></div></div></div></section><div class=\"closingTongue {{wd.talk.globalColor}}\" ng-hide=\"wd.talk.unlimitedShow\" ng-click=\"talkIsCollapsed = !talkIsCollapsed\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-show=\"talkIsCollapsed\" res=\"wireless_view\"></span> <span ng-hide=\"talkIsCollapsed\" res=\"wireless_close\"></span></div></div></div><div class=\"closingTongue {{wd.talk.globalColor}}\" ng-show=\"wd.talk.unlimitedShow\" ng-click=\"talkIsCollapsed = !talkIsCollapsed;onClickViewMyWirelessTalkUsage();\" atm=\"wireless_viewtalk_viewtalk\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-show=\"talkIsCollapsed\" res=\"wireless_view\"></span> <span ng-hide=\"talkIsCollapsed\" res=\"wireless_close\"></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\" ng-show=\"showSms\"><div class=\"serviceWrap\" ng-click=\"smsIsCollapsed = !smsIsCollapsed\"><div class=\"inner-content text-center {{wd.sms.globalColor}} {{wd.sms.unlimitedClass}}\"><div class=\"center c100\" ng-class=\"\'p\' + wd.sms.globalPercentage\" ng-hide=\"wd.sms.unlimitedShow\"><span class=\"inner-circle data\"><div class=\"h3\"><span class=\"ico rui-icon-sms\"></span> <span class=\"txt\" ng-show=\"lng === \'en\'\" res=\"wireless_text\"></span> <span class=\"txt\" ng-show=\"lng === \'fr\'\" style=\"font-size:14pt;font-weight: 500\" res=\"wireless_text\"></span></div><span class=\"txt\" ng-show=\"lng === \'fr\'\" style=\"font-size:14pt;font-weight: 500;text-transform:uppercase\" res=\"wireless_text_2\"></span> <span class=\"ammount\" ng-show=\"lng === \'en\'\">{{wd.sms.globalDisplayRemain}} texts</span> <span class=\"ammount\" style=\"margin-top:10px\" ng-show=\"lng === \'fr\'\">{{wd.sms.globalDisplayRemain}} texts</span> <span class=\"remaining\" res=\"wireless_remaining\"></span> <span class=\"extras\" ng-show=\"wd.sms.globalHaveExtras\"><strong>+</strong><br>extras</span> <span class=\"cta\" ng-show=\"smsIsCollapsed\" res=\"wireless_view\"></span> <span class=\"cta\" ng-hide=\"smsIsCollapsed\" res=\"wireless_close\"></span></span><div class=\"slice\"><div class=\"bar\"></div><div class=\"fill\"></div></div></div><div class=\"unlimited center\" ng-show=\"wd.sms.unlimitedShow\"><div class=\"h3\"><span class=\"ico rui-icon-sms\"></span> <span class=\"txt\" res=\"wireless_text\"></span><br><span class=\"subtxt\" res=\"wireless_unlimited\" ng-hide=\"wd.sms.globalOnlyExtras\"></span> <span class=\"subtxt\" ng-show=\"wd.sms.globalOnlyExtras\">&nbsp;</span> <span class=\"extras\" ng-show=\"wd.sms.globalHaveExtras && smsIsCollapsed\"><strong>+</strong><br>extras</span></div></div></div></div><div collapse=\"smsIsCollapsed\" class=\"colDataWrap paddbot60 {{wd.sms.unlimitedClass}}\"><section class=\"usage\"><div class=\"container-fluid\"><div class=\"row\" ng-repeat=\"wdssum in wd.smsArr\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h4 class=\"type-title\" ng-show=\"wdssum.usageType === \'extras_summary\'\">Extras</h4><h4 class=\"type-title\" ng-hide=\"wdssum.usageType === \'extras_summary\'\">{{wdssum.periodGroup}}</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"wdssum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row extraSum\" ng-repeat=\"wdssumSet in wdssum.usageSets\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\">{{wdssumSet.periodGroup}}</span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{(wdssumSet.used - wdssumSet.total) | number}} {{textsLbl}}</span></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"wdssum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"wdssum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_included\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span ng-if=\"wdssum.usageType == \'unlimited\'\"><strong><span class=\"usuage-ammount\" res=\"wireless_unlimited\"></span></strong></span> <span ng-if=\"wdssum.usageType == \'pay-per-use\'\"><strong><span class=\"usuage-ammount\" res=\"wireless_extra-usage\"></span></strong></span> <span ng-if=\"wdssum.usageType == \'limited\'\"><span class=\"usuage-ammount\">{{wdssum.total| number}} {{textsLbl}}</span></span></div></div><div class=\"row\" ng-if=\"wdssum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\" ng-if=\"wdssum.usageType == \'unlimited\'\"><span class=\"usuage-title\" ng-if=\"wdssum.action == 0\" res=\"wireless_usage_total-usage\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 1\" res=\"wireless_usage-text_total-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 2\" res=\"wireless_usage-text_total-usage_out\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\" ng-if=\"wdssum.usageType != \'unlimited\'\"><span class=\"usuage-title\" ng-if=\"wdssum.action == 0\" res=\"wireless_usage-text_my-usage\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 1\" res=\"wireless_usage-text_my-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 2\" res=\"wireless_usage-text_my-usage_out\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\" ng-if=\"wdssum.isFamilySharing == true\"><span class=\"usuage-ammount\">{{wdssum.subscriberUsage| number}} {{textsLbl}}</span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\" ng-if=\"wdssum.isFamilySharing == false\"><span class=\"usuage-ammount\">{{wdssum.used| number}} {{textsLbl}}</span></div></div><div class=\"row\" ng-if=\"wdssum.usageType == \'limited\' && wdssum.isFamilySharing == true\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" ng-if=\"wdssum.action == 0\" res=\"wireless_usage-text_others-usage\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 1\" res=\"wireless_usage-text_others-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 2\" res=\"wireless_usage-text_others-usage_out\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{wdssum.othersUsage| number}} {{textsLbl}}</span></div></div><div class=\"row\" ng-if=\"wdssum.usageType == \'limited\' && wdssum.isFamilySharing == true\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" ng-if=\"wdssum.action == 0\" res=\"wireless_usage-text_total-usage\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 1\" res=\"wireless_usage-text_total-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"wdssum.action == 2\" res=\"wireless_usage-text_total-usage_out\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{wdssum.used| number}} {{textsLbl}}</span></div></div><div class=\"row\" ng-if=\"wdssum.usageType == \'limited\' && wdssum.remaining > 0\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage-text_remaining\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{wdssum.remaining| number}} {{textsLbl}}</span></div></div><div class=\"row extraSum\" ng-if=\"wdssum.usageType != \'unlimited\' && wdssum.remaining <= 0\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\" res=\"wireless_extra-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{(wdssum.used - wdssum.total) | number}} {{textsLbl}}</span></div></div></div></div></div></div></section><div class=\"closingTongue {{wd.sms.globalColor}}\" ng-hide=\"wd.sms.unlimitedShow\" ng-click=\"smsIsCollapsed = !smsIsCollapsed\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-show=\"smsIsCollapsed\" res=\"wireless_view\"></span> <span ng-hide=\"smsIsCollapsed\" res=\"wireless_close\"></span></div></div></div><div class=\"closingTongue {{wd.sms.globalColor}}\" ng-show=\"wd.sms.unlimitedShow\" ng-click=\"smsIsCollapsed = !smsIsCollapsed;onClickViewMyWirelessTextUsage();\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-show=\"smsIsCollapsed\" res=\"wireless_view\"></span> <span ng-hide=\"smsIsCollapsed\" res=\"wireless_close\"></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3\" ng-show=\"showRoamingComingSoon\"><div class=\"serviceWrapComingSoon\"><span class=\"data\"><div class=\"h3\"><span class=\"txt\" res=\"wireless_roaming\"></span></div><div class=\"h4\"><span class=\"txt\" res=\"wireless_roaming_details_coming_soon\"></span></div><div class=\"h5\"><span class=\"remaining\" res=\"_have_questions\"></span></div><div class=\"h6\"><a class=\"chat-with-us\" target=\"_blank\" ng-href=\"{{showRoamingComingSoonUrl}}\"><span class=\"cta\" res=\"_chat_with_us\"></span></a></div></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3\" ng-show=\"showRoaming\"><div class=\"serviceWrap\" ng-click=\"roamingIsCollapsed = !roamingIsCollapsed\"><div class=\"inner-content text-center {{wd.roaming.globalColor}} {{wd.roaming.unlimitedClass}}\"><div class=\"center c100\" ng-class=\"\'p\' + wd.roaming.globalPercentage\" ng-hide=\"wd.roaming.unlimitedShow\"><span class=\"inner-circle data\"><div class=\"h3\"><span class=\"ico rui-icon-talk-text-internet\"></span> <span class=\"txt\" res=\"wireless_roaming\"></span></div><span class=\"ammount\">{{wd.roaming.globalDisplayRemain}}</span> <span class=\"remaining\" res=\"wireless_remaining\"></span><span class=\"cta\" ng-show=\"roamingIsCollapsed\" res=\"wireless_view\"></span> <span class=\"cta\" ng-hide=\"roamingIsCollapsed\" res=\"wireless_close\"></span></span><div class=\"slice\"><div class=\"bar\"></div><div class=\"fill\"></div></div></div><div class=\"unlimited center\" ng-show=\"wd.roaming.unlimitedShow\"><div class=\"h3\"><span class=\"ico rui-icon-talk-text-internet\"></span> <span class=\"txt\" res=\"wireless_roaming\"></span><br><span class=\"subtxt\">&nbsp;</span></div></div></div></div><div collapse=\"roamingIsCollapsed\" class=\"colDataWrap paddbot60 {{wd.roaming.unlimitedClass}}\"><section class=\"usage\"><div class=\"container-fluid\"><div class=\"row\" ng-repeat=\"wdrsum in wd.roamingArr\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h4 class=\"type-title\" ng-show=\"wdrsum.usageType === \'extras_summary\'\" ng-hide=\"true\">Extras</h4><h4 class=\"type-title\" ng-hide=\"wdrsum.usageType === \'extras_summary\'\">{{wdrsum.periodGroup}}</h4></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"wdrsum.usageType === \'extras_summary\'\" ng-hide=\"true\"><div class=\"container-fluid\"><div class=\"row extraSum\" ng-repeat=\"wdrsumSet in wdrsum.usageSets\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\">{{wdrsumSet.periodGroup}}</span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{(wdrsumSet.used - wdrsumSet.total) | number}} <span ng-if=\"wdrsumSet.usageSummaryType == \'VR\'\" res=\"wireless_usage_minutes\"></span> <span ng-if=\"wdrsumSet.usageSummaryType == \'SR\'\">{{textsLbl}}</span> <span ng-if=\"wdrsumSet.usageSummaryType == \'DR\'\" res=\"wireless_usage_mb\"></span></span></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"wdrsum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"wdrsum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_included\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span ng-if=\"wdrsum.usageType == \'unlimited\'\"><strong><span class=\"usuage-ammount\" res=\"wireless_unlimited\"></span></strong></span> <span ng-if=\"wdrsum.usageType == \'pay-per-use\'\"><strong><span class=\"usuage-ammount\" res=\"wireless_extra-usage\"></span></strong></span> <span ng-if=\"wdrsum.usageType == \'limited\'\"><span class=\"usuage-ammount\">{{wdrsum.total| number}} <span ng-if=\"wdrsum.usageSummaryType == \'VR\'\" res=\"wireless_usage_minutes\"></span> <span ng-if=\"wdrsum.usageSummaryType == \'SR\'\">{{textsLbl}}</span> <span ng-if=\"wdrsum.usageSummaryType == \'DR\'\" res=\"wireless_usage_mb\"></span></span></span></div></div><div class=\"row\" ng-if=\"wdrsum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_my-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\" ng-if=\"wdrsum.isFamilySharing == true\"><span class=\"usuage-ammount\">{{wdrsum.subscriberUsage| number}} <span ng-if=\"wdrsum.usageSummaryType == \'VR\'\" res=\"wireless_usage_minutes\"></span> <span ng-if=\"wdrsum.usageSummaryType == \'SR\'\">{{textsLbl}}</span> <span ng-if=\"wdrsum.usageSummaryType == \'DR\'\" res=\"wireless_usage_mb\"></span></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\" ng-if=\"wdrsum.isFamilySharing == false\"><span class=\"usuage-ammount\">{{wdrsum.used| number}} <span ng-if=\"wdrsum.usageSummaryType == \'VR\'\" res=\"wireless_usage_minutes\"></span> <span ng-if=\"wdrsum.usageSummaryType == \'SR\'\">{{textsLbl}}</span> <span ng-if=\"wdrsum.usageSummaryType == \'DR\'\" res=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"wdrsum.usageType == \'limited\' && wdrsum.isFamilySharing == true\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_others-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{wdrsum.othersUsage| number}} <span ng-if=\"wdrsum.usageSummaryType == \'VR\'\" res=\"wireless_usage_minutes\"></span> <span ng-if=\"wdrsum.usageSummaryType == \'SR\'\">{{textsLbl}}</span> <span ng-if=\"wdrsum.usageSummaryType == \'DR\'\" res=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"wdrsum.usageType == \'limited\' && wdrsum.isFamilySharing == true\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_total-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{wdrsum.used| number}} <span ng-if=\"wdrsum.usageSummaryType == \'VR\'\" res=\"wireless_usage_minutes\"></span> <span ng-if=\"wdrsum.usageSummaryType == \'SR\'\">{{textsLbl}}</span> <span ng-if=\"wdrsum.usageSummaryType == \'DR\'\" res=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"wdrsum.usageType == \'limited\' && wdrsum.remaining > 0\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info\"><span class=\"usuage-title\" res=\"wireless_usage_remaining\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{wdrsum.remaining| number}} <span ng-if=\"wdrsum.usageSummaryType == \'VR\'\" res=\"wireless_usage_minutes\"></span> <span ng-if=\"wdrsum.usageSummaryType == \'SR\'\">{{textsLbl}}</span> <span ng-if=\"wdrsum.usageSummaryType == \'DR\'\" res=\"wireless_usage_mb\"></span></span></div></div><div class=\"row extraSum\" ng-if=\"wdrsum.usageType != \'unlimited\' && wdrsum.remaining <= 0\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\" res=\"wireless_extra-usage\"></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{(wdrsum.used - wdrsum.total) | number}} <span ng-if=\"wdrsum.usageSummaryType == \'VR\'\" res=\"wireless_usage_minutes\"></span> <span ng-if=\"wdrsum.usageSummaryType == \'SR\'\">{{textsLbl}}</span> <span ng-if=\"wdrsum.usageSummaryType == \'DR\'\" res=\"wireless_usage_mb\"></span></span></div></div></div></div></div></div></section><div class=\"closingTongue {{wd.roaming.globalColor}}\" ng-hide=\"wd.roaming.unlimitedShow\" ng-click=\"roamingIsCollapsed = !roamingIsCollapsed\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-show=\"roamingIsCollapsed\" res=\"wireless_view\"></span> <span ng-hide=\"roamingIsCollapsed\" res=\"wireless_close\"></span></div></div></div><div class=\"closingTongue {{wd.roaming.globalColor}}\" ng-show=\"wd.roaming.unlimitedShow\" ng-click=\"roamingIsCollapsed = !roamingIsCollapsed\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-show=\"roamingIsCollapsed\" res=\"wireless_view\"></span> <span ng-hide=\"roamingIsCollapsed\" res=\"wireless_close\"></span></div></div></div></div><div class=\"row\" ng-show=\"!(dmRedirect && dmEligibility && getDmServiceGrp() == 1) && (wdEmpty || wdMidCycle || wdMCPPCrerating)\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><center ng-show=\"wdEmpty\"><h3><span res=\"wireless_missing_usage\"></span>&nbsp;<a ng-href=\"{{redirectToWirelessPlans}}\" class=\"pointer\" target=\"_blank\" res=\"wireless_missing_usage_link\"></a></h3></center><center class=\"wireless-midcycle-message\" ng-show=\"wdMidCycle\"><h3 res=\"wireless_midcycle_message\"></h3></center><center class=\"wireless-midcycle-message\" ng-show=\"wdMCPPCrerating\"><h3 res=\"wireless_rerating_message\"></h3></center></div></div><div class=\"row\" ng-show=\"(dmRedirect && dmEligibility && getDmServiceGrp() == 1) && (talkEmpty && dataEmpty && textEmpty)\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><center class=\"wireless-midcycle-message\"><h3 res=\"error_wireless_usage\"></h3></center></div></div></div><wireless-package></wireless-package></div></section>");
$templateCache.put("scripts/modules/wirelessPrepaid/wirelessPrepaid.html","<section class=\"page-wireless\"><div><div class=\"wrap-overview\" data-ng-show=\"true\"><div class=\"\"><myr-notification-banner data-banner-id=\"linkedMessage\" type=\"success\"></myr-notification-banner></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"wirelessPrepaidHeader\"></span></h1></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div><div class=\"row info-banner\" ng-class=\"accountStatusSimple === \'Error\' ? \'error\' : \'warning - border\'\" data-ng-show=\"selAccountStatusError\"><div class=\"col-xs-2 col-sm-2 col-md-2 pln prn\"><span class=\"message-banner-icon error-sign-big\" ng-class=\"accountStatusSimple === \'Error\' ? \'icon-error\' : \'icon - alert\'\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 pln prn\" style=\"float:left\"><span class=\"v-base-line\" ng-bind-html=\"selAccountStatusError\" style=\"font-weight:normal\"></span></div></div></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><select data-ng-show=\"wirelessDashData.length > 1\" class=\"account-type\" name=\"accountType\" required=\"\" data-ng-model=\"wirelessDashActive\" ng-change=\"changeAccount()\" ng-options=\"value.ctn for (key, value) in wirelessDashData\"></select></div></div></div><wireless-plan mode=\"1\"></wireless-plan></div></section>");
$templateCache.put("views/uteInternetUsage/html/_dailyUsageTable.html","<table ng-table=\"tableParams\" class=\"table ute-table table-centred internet-usage-table\"><tr ng-repeat=\"usage in $data track by $index\"><td data-title=\"\'ute_label_Date\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_Date\"></ins></span> {{usage.date | date:\'MMM d, yyyy\'}}</td><td data-title=\"\'ute_label_DownloadUsage\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_DownloadUsage\"></ins></span> {{usage.download}}</td><td data-title=\"\'ute_label_UploadUsage\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_UploadUsage\"></ins></span> {{usage.upload}}</td><td data-title=\"\'ute_label_DailyTotal\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_DailyTotal\"></ins></span> {{usage.total}}</td></tr><tfoot class=\"ute-table-foot\"><tr><th><ins res=\"ute_label_TotalUsage\"></ins>(<ins res=\"ute_unit_MB\"></ins>)</th><th>{{footerData.download | number : 0}}</th><th>{{footerData.upload | number : 0}}</th><th>{{footerData.download + footerData.upload | number : 0}}</th></tr><tr><th><ins res=\"ute_label_TotalUsage\"></ins>(<ins res=\"ute_unit_GB\"></ins>)</th><th>{{footerData.download / 1024 | number: 0}}</th><th>{{footerData.upload / 1024 | number: 0}}</th><th>{{ (footerData.download + footerData.upload) / 1024 | number: 0}}</th></tr></tfoot></table>");
$templateCache.put("views/uteInternetUsage/html/_monthlyUsageTable.html","<table ng-table=\"tableParams\" class=\"table ute-table table-centred internet-usage-table\"><tr ng-repeat=\"usage in $data track by $index\"><td data-title=\"\'ute_label_BillingPeriod\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_BillingPeriod\"></ins></span>{{usage.billingPeriod}}</td><td data-title=\"\'ute_label_TotalUsed\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_TotalUsed\"></ins></span>{{usage.total}}</td><td data-title=\"\'ute_label_UsageIncluded\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_UsageIncluded\"></ins></span>{{(usage.included==9999999)?\'Unlimited\':usage.included}}</td><td data-title=\"\'ute_label_AdditionalDataUsed\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_AdditionalDataUsed\"></ins></span>{{usage.additional}}</td><td data-title=\"\'ute_label_OverageCharges\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_UsageIncluded\"></ins></span>{{usage.overageCharge | currency}}</td></tr><tfoot class=\"ute-table-foot\"><tr><th><span class=\"mobile-table-title\"></span><span><ins res=\"ute_label_AverageMonthlyUsage\"></ins></span> ({{footerData.unit}})</th><th><span class=\"mobile-table-title\"><ins res=\"ute_label_TotalUsed\"></ins></span>{{footerData.total | number:2}}</th><th><span class=\"mobile-table-title\"><ins res=\"ute_label_UsageIncluded\"></ins></span>{{(footerData.included==9999999)?\'Unlimited\':(footerData.included | number:2)}}</th><th><span class=\"mobile-table-title\"><ins res=\"ute_label_AdditionalDataUsed\"></ins></span>{{footerData.additional | number:2}}</th><th><span class=\"mobile-table-title\"><ins res=\"ute_label_OverageCharges\"></ins></span>{{footerData.overageCharge | number:2 | currency}}</th></tr></tfoot></table>");
$templateCache.put("views/uteInternetUsage/html/_usageNotificationTable.html","<table ng-table=\"tableParams\" class=\"table ute-table table-centred internet-usage-table\"><tr ng-repeat=\"usage in $data track by $index\" class=\"internet-usage-{{usage.limit}}\"><td header-class=\"font-medium\" data-title=\"\'ute_label_DateNotified\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_DateNotified\"></ins></span> <span>{{usage.date | amDateFormat:\' MMMM D, YYYY\'}}</span></td><td header-class=\"font-medium\" data-title=\"\'ute_label_NotificationType\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_NotificationType\"></ins></span><ins res=\"ute_label_UsageAt\"></ins>{{usage.limit}}<ins res=\"ute_label_OfDataLimit\"></ins></td><td header-class=\"font-medium\" data-title=\"\'ute_label_ActionTaken\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_ActionTaken\"></ins></span><ins res=\"ute_eventCode_{{usage.actionTaken}}\"></ins><span ng-if=\"usage.actionTaken !== \'112\'\">{{usage.limit}}<ins res=\"ute_label_OfLimitNotification\"></ins></span></td><td header-class=\"font-medium\" data-title=\"\'ute_label_DateActionTaken\' | res\"><span class=\"mobile-table-title\"><ins res=\"ute_label_DateActionTaken\"></ins></span> {{usage.dateActionTaken | amDateFormat:\' MMMM D, YYYY h:mm A z\'}}</td></tr></table>");
$templateCache.put("views/uteInternetUsage/html/uteInternetUsage.html","<div class=\"ute-internet-usage-nav col-xs-12\" ng-controller=\"uteInternetUsageNavCtrl\"><tabset class=\"tab-container ute-tabs-primary fido-tabs\" justified=\"true\"><tab class=\"tab\" ng-repeat=\"tab in tabConfig\" active=\"tab.active\" ng-click=\"navigate(tab.route)\"><tab-heading><b><span class=\"text-uppercase heading\" res=\"{{tab.heading}}\"></span></b><br><span class=\"text-uppercase sub-heading hidden-xs\" res=\"{{tab.subHeading}}\"></span></tab-heading></tab></tabset></div><div class=\"col-xs-12\"><ui-view></ui-view></div>");
$templateCache.put("views/uteInternetUsage/html/uteInternetUsageDaily.html","<div class=\"ute-internet-usage ute-internet-usage-daily\" ng-controller=\"uteInternetUsageDailyCtrl\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"ute-select-container\"><select class=\"ute-input-select\" ng-model=\"slctMonth\" ng-change=\"billingCycleChanged()\"><option ng-repeat=\"billingCycle in usageSummary.billingCycle\" value=\"{{billingCycle.monthlyInd}}\">{{billingCycle.startDate | date:\'MMM dd, yyyy\'}} - {{billingCycle.endDate | date:\'MMM dd, yyyy\'}}</option></select></div><div class=\"spacer-10\"></div><p class=\"copy-4\"><span res=\"ute_label_last_update\"></span>:&nbsp;{{usageSummary.lastUpdated | amDateFormat:\'MMM Do, YYYY\'}}</p></div><div class=\"col-sm-1\"><div class=\"spacer-10\"></div><a ng-click=\"ruiMethods.printDiv(\'printable\');\"><i class=\"ute-icon-print ute-xl link\"></i></a></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"usage-meter\" ng-if=\"usageSummary\" ng-class=\"{\'unlimited\':usageSummary.included > 99999}\"><div percentage=\"{{::usageSummary.usageMeter}}\" class=\"c100 big center\"><span><ul><li><span>{{::usageSummary.included}}<ins res=\"ute_unit_GB\"></ins></span>/<ins res=\"ute_unit_Month\"></ins></li><li><span>{{::usageSummary.remaining}}<ins res=\"ute_unit_GB\"></ins></span><ins res=\"ute_label_Remaining\"></ins></li><li><ins res=\"ute_label_Download\"></ins><span>{{::usageSummary.downloaded}}<ins res=\"ute_unit_GB\"></ins></span></li><li><ins res=\"ute_label_Upload\"></ins><span>{{::usageSummary.uploaded}}<ins res=\"ute_unit_GB\"></ins></span></li></ul></span><div class=\"slice\"><div class=\"bar\"></div><div class=\"bar-layer2\"></div><div class=\"fill\"></div></div></div><div class=\"unlimited-data\"><div class=\"total-limit\"><ins res=\"ute_label_Unlimited\"></ins></div><div class=\"total-used\"><span><ins res=\"ute_label_Used\"></ins><span>{{usageSummary.used}}<ins res=\"ute_unit_GB\"></ins></span></span></div></div></div><p class=\"text-center\"><ins res=\"ute_label_ResetLimited\"></ins>{{usageSummary.limited}}<ins res=\"ute_unit_Days\"></ins></p></div><div class=\"col-sm-5 hidden-xs\" ng-if=\"usageData[slctMonth].lineDailyData\"><h4 class=\"ute-col-tertiary\"><ins class=\"text-uppercase\" res=\"ute_label_DailyUsage\"></ins></h4><div class=\"spacer-20\"></div><ute-chartist ng-repeat=\"billingCycle in usageSummary.billingCycle\" ng-if=\"billingCycle.monthlyInd==slctMonth\" chart-data=\"usageData[slctMonth].lineDailyData\" chart-options=\"lineDailyOptions\" chart-type=\"line\" chart-break-line=\"usageData[slctMonth].dailyChartLineBreak\"></ute-chartist></div><div class=\"col-sm-4 hidden-xs padding-lr0\" ng-if=\"!usageData[slctMonth].lineCumulativeData\"><div><div><div class=\"loading\"></div></div></div></div><div class=\"col-sm-4 hidden-xs\" ng-if=\"usageData[slctMonth].lineCumulativeData\"><h4 class=\"ute-col-tertiary\"><ins class=\"text-uppercase\" res=\"ute_label_Cumulative\"></ins></h4><div class=\"spacer-20\"></div><ute-chartist ng-repeat=\"billingCycle in usageSummary.billingCycle\" ng-if=\"billingCycle.monthlyInd==slctMonth\" chart-data=\"usageData[slctMonth].lineCumulativeData\" chart-options=\"lineCumulativeOptions\" chart-type=\"line\" chart-show-limit-line=\"usageData[slctMonth].cumulativeLimitOptions\" chart-break-line=\"usageData[slctMonth].cumulativeChartLineBreak\"></ute-chartist></div><div class=\"col-xs-12\"><h3><ins res=\"ute_label_DailyBreakdown\"></ins></h3><ute-table ng-repeat=\"billingCycle in usageSummary.billingCycle\" ng-if=\"billingCycle.monthlyInd==slctMonth\" table-data=\"usageData[slctMonth].dailyUsage\" footer-data=\"usageData[slctMonth].sum\" table-template-folder=\"views/uteInternetUsage/html/\" table-body-template=\"_dailyUsageTable\" initial-sort=\"date\"></ute-table></div></div></div>");
$templateCache.put("views/uteInternetUsage/html/uteInternetUsageMonthly.html","<div class=\"ute-internet-usage ute-internet-usage-monthly\" ng-controller=\"uteInternetUsageMonthlyCtrl\"><div class=\"container col-xs-12\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"spacer-15\"></div><div class=\"copy-4\"><ins res=\"ute_label_LastUpdate\"></ins>{{usageSummary.lastUpdated | amDateFormat:\'MMM Do, YYYY\'}}&nbsp; &nbsp; &nbsp;&nbsp; &nbsp;<a ng-click=\"ruiMethods.printDiv(\'printable\');\" class=\"adjust-print-icon\"><i class=\"ute-icon-print ute-xl link\"></i></a></div></div></div><div class=\"spacer-20\"></div><div class=\"row usage-charts\"><div class=\"col-xs-4 usage-meter\" ng-if=\"usageSummary\" ng-class=\"{\'unlimited\':usageSummary.included > 99999}\"><div percentage=\"{{::usageSummary.usageMeter}}\" class=\"c100 big center\"><span><ul><li><span>{{::usageSummary.included}}<ins res=\"ute_unit_GB\"></ins></span>/<ins res=\"ute_label_Month\"></ins></li><li><span>{{::usageSummary.remaining}}<ins res=\"ute_unit_GB\"></ins></span><ins res=\"ute_label_Remaining\"></ins></li><li><ins res=\"ute_label_Downloaded\"></ins><span>{{::usageSummary.downloaded}}<ins res=\"ute_unit_GB\"></ins></span></li><li><ins res=\"ute_label_Uploaded\"></ins><span>{{::usageSummary.uploaded}}<ins res=\"ute_unit_GB\"></ins></span></li></ul></span><div class=\"slice\"><div class=\"bar\"></div><div class=\"bar-layer2\"></div><div class=\"fill\"></div></div></div><div class=\"unlimited-data\"><div class=\"total-limit\"><ins res=\"ute_label_Unlimited\"></ins></div><div class=\"total-used\"><span><ins res=\"ute_label_Used\"></ins><span>{{usageSummary.used}}<ins res=\"ute_unit_GB\"></ins></span></span></div></div><p class=\"text-center\"><span res=\"ute_label_ResetLimited\"></span> {{usageSummary.limited}} <span res=\"ute_unit_Days\"></span></p></div><div class=\"col-xs-8 hidden-xs\" ng-if=\"!lineData\"><div><div><div class=\"loading\"></div></div></div></div><div class=\"col-xs-8 hidden-xs\" ng-if=\"lineData\"><h4 class=\"ute-col-tertiary\"><ins class=\"text-uppercase\" res=\"ute_label_MonthlyUsage\"></ins></h4><div class=\"spacer-20\"></div><ute-chartist chart-data=\"lineData\" chart-type=\"line\" chart-options=\"lineOptions\" chart-break-line=\"{enabled:true, limit:(maxUsage), smartAlign:true}\" chart-limit-cumulative=\"true\"></ute-chartist></div></div><div class=\"row\"><div><h3><ins res=\"ute_label_MonthlyBreakdown\"></ins></h3><ute-table table-data=\"monthlyUsage\" footer-data=\"averageUseData\" table-body-template=\"_monthlyUsageTable\" table-template-folder=\"views/uteInternetUsage/html/\" initial-sort=\"date\"></ute-table></div></div></div></div>");
$templateCache.put("views/uteInternetUsage/html/uteInternetUsageNotification.html","<div class=\"ute-internet-usage ute-internet-usage-notification\" ng-controller=\"uteInternetUsageNotificationCtrl\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"spacer-15\"></div><div class=\"copy-4\"><ins res=\"ute_label_LastUpdate\"></ins>{{usageSummary.lastUpdated | amDateFormat:\'MMM Do, YYYY\'}} &nbsp;&nbsp;&nbsp;&nbsp; <a class=\"ute-link\" ng-click=\"ruiMethods.printDiv(\'printable\');\"><i class=\"ute-icon-print ute-xxl\"></i></a></div><div class=\"spacer-30\"></div></div></div><ute-table table-data=\"usageHistoryData\" table-body-template=\"_usageNotificationTable\" table-template-folder=\"views/uteInternetUsage/html/\" ng-class=\"{\'not-empty\': usageHistoryData.length>0}\"></ute-table><div ng-show=\"usageHistoryData.length==0\" class=\"alert alert-info\" role=\"alert\"><div><i class=\"ute-icon-alert-i\"></i></div><div><div><h4>No notifications.</h4></div></div></div></div>");
$templateCache.put("rfr/js/directives/accept/accept.html","<div class=\"accept-container\"><label><input type=\"checkbox\" ng-model=\"checkboxState\" class=\"rui-checkbox\" id=\"acceptCheckbox\"> <label class=\"checkbox-label\" for=\"acceptCheckbox\"></label> <span class=\"accept-terms-text\" res=\"{{::checkBoxLabelText}}\"></span> <img ng-show=\"viewLoader && !$parent.apiError\" class=\"pull-right\" width=\"29\" src=\"images/widget-loader.gif\" alt=\"\"></label><div class=\"accept-buttons-container\"><button class=\"cta-round primary medium btn-cta\" ng-class=\"(isDisabled || !checkboxState) ? \'disabled\' : \'\'\" ng-disabled=\"isDisabled || !checkboxState || viewLoader\" ng-click=\"acceptAction();viewLoader = true\"><span res=\"{{::acceptText}}\"></span></button> <button class=\"cta-round mvl secondary medium btn-cta\" ng-click=\"cancelAction()\"><span res=\"{{::cancelText}}\"></span></button></div></div>");
$templateCache.put("rfr/js/directives/addressFormModal/addressFormModal.html","<div class=\"address-form-modal\"><div class=\"address-form-modal-close\" ng-click=\"cancel()\"><i class=\"rui-icon rui-icon-plus\"></i></div><div class=\"address-form-header\" res=\"rfr_please_confirm_your_address\"></div><div class=\"address-form-copy\" res=\"rfr_please_confirm_copy\"></div><div class=\"suggestion-container\"><div class=\"form-entry col-xs-12 col-sm-6\"><div class=\"address-form-suggestion-title\" res=\"rfr_address_form_you_entered\"></div><span ng-bind=\"entry.addressLine1\"></span> <span ng-bind=\"entry.addressLine2\"></span> <span ng-bind=\"entry.city\"></span> <span ng-bind=\"entry.postalCode\"></span></div><div class=\"form-suggestion col-xs-12 col-sm-6\"><div class=\"address-form-suggestion-title\" res=\"rfr_address_form_suggest\"></div><span ng-bind=\"suggestion.addressLine1\"></span> <span ng-bind=\"suggestion.addressLine2\"></span> <span ng-bind=\"suggestion.city\"></span> <span ng-bind=\"suggestion.postalCode\"></span></div></div><div class=\"address-form-warning\" res=\"rfr_no_ship_to_po\"></div><div class=\"address-form-cta-container\"><div class=\"col-xs-12 col-sm-4\"><button class=\"cta-round primary full cta-use-suggestion\" res=\"rfr_address_form_use_suggestion\" ng-click=\"useSuggestion()\"></button></div><div class=\"col-xs-12 col-sm-4\"><button class=\"cta-round primary full cta-use-mine\" res=\"rfr_address_form_use_mine\" ng-click=\"useMine()\"></button></div><div class=\"col-xs-12 col-sm-4\"><button class=\"cta-round primary full medium cta-modify\" res=\"rfr_address_form_modify_address\" ng-click=\"modify()\"></button></div></div></div>");
$templateCache.put("rfr/js/directives/membershipInfo/membershipInfo.html","<div ng-show=\"isEnrolled\"><a id=\"rewards/membership\"></a><div section-header=\"\" header-copy=\"rewards_membership_info\" loader-enabled=\"true\" loader-hide=\"!loadingTransactions\"></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"membershipList.length === 1\"><h3 class=\"hidden-xs\" res=\"membership_select_account\"></h3><div class=\"rewards-select-wrapper col-xs-12 col-sm-4 col-md-4 col-lg-4\"><div rui-dropdown=\"\" class=\"rui-dropdown\" list=\"membershipList\" selected=\"account\" property=\"membershipId\" additional=\"showNotEnrolled\" prefix=\"#\"></div></div></div></div><div ng-show=\"errorCode.errInMembershipLoading\" class=\"mvm info-banner error reverse-margin\"><div class=\"row\"><div class=\"sigin-error-icon-ctn col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding\"><span class=\"fa fa-exclamation-circle fa-2x txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\"><span class=\"v-base-line\">Sorry, server returned an error.</span></div></div></div><div class=\"row rewards-account-info-container\"><div class=\"rfr-account-info rfr-info-section col-xs-12 col-sm-4 col-md-4 col-lg-4 prm\"><h3 res=\"membership_account_info\"></h3><div class=\"info-container\"><div class=\"info-container-row row\"><div class=\"col-xs-6 col-sm-7 membership-number-container\"><span class=\"info-container-label\" res=\"membership_number\"></span><div popover-placement=\"top\" ng-class=\"lang === \'en\' ? \'tooltip2\' : \'tooltip2fr\'\" rfr-popover=\"{{popupContentLeft}}\"><i class=\"rfr-icon rfr-icon-info\"></i></div></div><span class=\"info-container-value col-xs-6 col-sm-5\" ng-bind=\"accountDetails.membershipId\"></span></div><div class=\"info-container-row row\"><span class=\"info-container-label col-xs-6 col-sm-7\" res=\"membership_enrolled_on\"></span> <span class=\"info-container-value col-xs-6 col-sm-5\" ng-bind=\"accountDetails.enrolledOn\"></span></div></div></div><div class=\"rfr-points-info rfr-info-section col-xs-12 col-sm-4 col-md-4 col-lg-4\"><div class=\"border-separator\"><h3 res=\"membership_my_points\"></h3><div class=\"info-container\"><div class=\"info-container-row row\"><span class=\"info-container-label col-xs-6 col-sm-8\" res=\"membership_points\"></span> <span class=\"info-container-value col-xs-6 col-sm-4\"><span ng-bind=\"accountDetails.points | number:0\"></span>&nbsp;pts</span></div><div class=\"info-container-row row\"><div class=\"col-xs-6 col-sm-8\"><span class=\"info-container-label\" res=\"membership_pending_points\"></span><div popover-placement=\"top\" ng-class=\"lang === \'en\' ? \'tooltip2\' : \'tooltip2fr\'\" rfr-popover=\"{{popupContentRight}}\"><i class=\"rfr-icon rfr-icon-info\"></i></div></div><div class=\"col-xs-6 col-sm-4\"><span class=\"info-container-value\"><span ng-bind=\"accountDetails.pendingPoints\"></span>&nbsp;pts</span></div></div></div></div></div><div class=\"rfr-tier-info rfr-info-section col-xs-12 col-sm-4 col-md-4 col-lg-4\"><h3 res=\"membership_account_tier\"></h3><div class=\"rfr-sprite\" ng-bind-html=\"membershipTeirBadge\"></div><div class=\"info-container\"><div class=\"info-container-label\" res=\"rfr_home_banner_main\"></div><div class=\"info-container-value\" ng-bind=\"setTierLabel(accountDetails.tier)\"></div></div></div></div><div class=\"row\"><button class=\"btn btn-default linked-accounts-button\" ng-init=\"isCollapsed = true\" ng-click=\"isCollapsed = !isCollapsed\"><span res=\"membership_linked_rogers_accounts\"></span> <i class=\"linked-accounts-icon fa\" ng-class=\"isCollapsed ? \'fa-chevron-down\' : \'fa-chevron-up\'\"></i></button><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" collapse=\"isCollapsed\"><div class=\"rfr-linked-accounts-container\"><div class=\"linked-accounts-arrow\"></div><div class=\"rfr-linked-accounts\"><div class=\"row rfr-linked-account-content\" ng-repeat=\"(key, account) in accountsList track by key\" ng-class=\"{\'rfr-linked-account-content-last\':$last}\" ng-hide=\"account.hidden\"><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 linked-account-info\"><span ng-bind=\"::account.name\"></span><br><span res=\"membership_account_number\"></span>&nbsp;<span ng-bind=\"::account.listValue\"></span></div><div class=\"col-xs-12 col-sm-9 col-md-9 col-lg-9\"><div class=\"linked-account-subscriptions col-xs-12 col-sm-4 col-md-4 col-lg-4\" ng-repeat=\"(key, subscription) in account.subscriptions track by key\" ng-class=\"{\'fix\' : needsFix(subscription.typeCode)}\" ng-show=\"subscription.visible\"><span class=\"account-type-name-icon\" ng-class=\"::getAccountTypeIcon(subscription.typeCode)\"></span> <span class=\"account-type-name\" ng-bind=\"::subscription.typeName\"></span><br><div class=\"account-type-subscriber\" ng-show=\"(account.sourceSystem != \'B\' && account.sourceSystem !=\'T\' && !account.maskLinkedAccount && subscription.subscriberNumber)\">Subscriber No.: <span>{{ subscription.subscriberNumber | phone2 }}</span><br></div><div class=\"account-type-subscriber\" ng-show=\"((account.sourceSystem == \'T\' || account.sourceSystem ==\'S\') && !account.maskLinkedaccount && account.streetAddress)\">Address: <span ng-bind=\"::account.streetAddress\"></span></div></div></div></div></div><div class=\"rfr-linked-account-container-close\" ng-click=\"isCollapsed = true\"><div class=\"rfr-linked-account-container-close-text visible-xs\" res=\"membership_close_details\"></div><i class=\"rui-icon rui-icon-plus\"></i></div></div></div></div></div>");
$templateCache.put("rfr/js/directives/multiDatepicker/multiDatepicker.html","<form name=\"datepickerform\" novalidate=\"\"><div class=\"datepicker-container col-xs-12\"><div class=\"datepicker-wrapper col-xs-12 col-sm-4\"><span class=\"datepicker-label\" res=\"_from\"></span> <span class=\"datepicker-btn\"><div class=\"\" ng-click=\"open($event,\'fromDate\')\"><i class=\"rfr-icon rfr-icon-datepick\"></i></div></span> <input ng-if=\"!mobileDisplay\" ng-click=\"open($event,\'fromDate\')\" class=\"datepicker-input\" type=\"text\" min-date=\"formData.minFromDate\" max-date=\"formData.maxFromDate\" format-day-header=\"EE\" datepicker-popup=\"{{format}}\" name=\"fromDate\" ng-model=\"formData.fromDate\" is-open=\"datepickers.fromDate\" placeholder=\"{{dateFormatPlaceholder}}\" autocomplete=\"off\" show-button-bar=\"false\" show-weeks=\"false\" close-text=\"Close\"> <input ng-if=\"mobileDisplay\" class=\"datepicker-input\" type=\"date\" name=\"fromDate\" ng-model=\"formData.fromDate\" placeholder=\"{{dateFormatPlaceholder}}\" autocomplete=\"off\"></div><div class=\"datepicker-wrapper col-xs-12 col-sm-4\"><span class=\"datepicker-label\" res=\"_to\"></span> <span class=\"datepicker-btn\"><div class=\"\" ng-click=\"open($event,\'toDate\')\"><i class=\"rfr-icon rfr-icon-datepick\"></i></div></span> <input ng-if=\"!mobileDisplay\" ng-click=\"open($event,\'toDate\')\" class=\"datepicker-input\" type=\"text\" min-date=\"formData.minToDate\" max-date=\"formData.maxToDate\" format-day-header=\"EE\" datepicker-popup=\"{{format}}\" name=\"toDate\" ng-model=\"formData.toDate\" is-open=\"datepickers.toDate\" placeholder=\"{{dateFormatPlaceholder}}\" autocomplete=\"off\" show-button-bar=\"false\" show-weeks=\"false\" close-text=\"Close\"> <input ng-if=\"mobileDisplay\" class=\"datepicker-input\" type=\"date\" name=\"toDate\" ng-model=\"formData.toDate\" placeholder=\"{{dateFormatPlaceholder}}\" autocomplete=\"off\"></div><div class=\"col-xs-12 col-sm-4\"><a class=\"clear-dates hidden-sm hidden-md hidden-lg text-right\" ng-click=\"clear()\">Clear Dates</a> <button class=\"cta-round primary full request-date-range\" ng-click=\"requestDateRange()\" <span=\"\" res=\"membership_view_daterange\"></button> <a class=\"clear-dates hidden-xs text-center\" ng-click=\"clear()\">Clear Dates</a></div></div></form>");
$templateCache.put("rfr/js/directives/myPoints/myPoints.html","<div ng-if=\"currentRewardsBalance != undefined\" class=\"my-points\" ng-show=\"showMyPoints()\"><i ng-click=\"goToWishlist()\" class=\"fa fa-heart-o pointer\"></i> <span ng-click=\"goToWishlist()\" class=\"num pointer\" ng-show=\"wishlistCounter\">{{wishlistCounter}}</span> <span class=\"pointer\" ng-click=\"goToMembership()\" res=\"rfr_home_banner_my_points\"></span> <span class=\"pointer points\" ng-click=\"goToMembership()\"></span> <i class=\"fa fa-caret-right\"></i></div>");
$templateCache.put("rfr/js/directives/pointDial/pointDial.html","<div class=\"radial-progress\" data-progress=\"{{::getProgressPercentage()}}\"><div class=\"point-circle\"><div class=\"mask full\"><div class=\"fill\" ng-class=\"::getDialClass()\"></div></div><div class=\"mask half\"><div class=\"fill\" ng-class=\"::getDialClass()\"></div><div class=\"fill fix\" ng-class=\"::getDialClass()\"></div></div><div class=\"shadow\"></div></div><div class=\"inset\"></div></div>");
$templateCache.put("rfr/js/directives/rewardCard/rewardCard.html","<div class=\"reward-card-expiry-message\"><div ng-show=\"daysLeft\" class=\"reward-card-badge-text\" ng-class=\"{\'teal-background\': badgeText}\" ng-bind-html=\"badgeText\"></div></div><div class=\"reward-card-content reward-card-image\" ui-sref=\"{{getRedeemUrl()}}\" ng-style=\"imgPath\" ng-class=\"{\'small-image\': smallImage}\"><div class=\"reward-card-wishlist-badge\" ng-show=\"loggedInOnly && $parent.isEnrolled && $parent.pageLoaded\" ng-class=\"{\'show-background\' : !(reward.inWhishList || inWishListView), \'white-bg\' : viewLoader}\"><i ng-show=\"!viewLoader\" class=\"rfr-icon\" ng-click=\"toggleInWishList();$event.stopPropagation();\" ng-class=\"reward.inWhishList || inWishListView ? \'rfr-icon-heart\' : \'rfr-icon-heart-o\'\"></i> <img ng-show=\"viewLoader\" class=\"loading\" width=\"29\" src=\"images/widget-loader.gif\" alt=\"\"></div><div class=\"reward-card-out-of-stock-message\" ng-show=\"displayOutOfStockMessage()\"><div class=\"reward-out-of-stock-text\" res=\"rfr_item_out_of_stock\"></div></div><div reward-card-info-box=\"\"></div></div><div class=\"reward-redeem-card-expiry-message\" ng-show=\"showRedeemDetailsExpiryMessage()\"><div ng-show=\"daysLeft\" class=\"reward-card-badge-text\" ng-class=\"{\'teal-background\': badgeText}\" ng-bind-html=\"badgeText\"></div></div>");
$templateCache.put("rfr/js/directives/rewardCardInfoBox/rewardCardInfoBox.html","<div class=\"reward-card-info-box-content\"><span ng-show=\"(reward.points && loggedInOnly && enrolled && !displayOutOfStockMessage())\" class=\"reward-card-point-dial\" ng-class=\"{\'large\': largeDial}\" point-dial=\"\"></span><div ng-show=\"reward.points\" class=\"reward-info-points\"><div class=\"reward-info-points-display\"><span ng-bind=\"reward.points | number:0\"></span>&nbsp;<span>pts</span></div><span class=\"reward-info-points-message\" ng-show=\"(loggedInOnly && enrolled && !displayOutOfStockMessage())\" ng-bind=\"pointPercentMessage\"></span></div><div class=\"reward-title\" ng-bind=\"reward.rewardName | limitTo: 35 : 0\" ng-class=\"{ \'reward-title-long\': (reward.rewardName.length > 35) }\"></div><div class=\"reward-card-details-link\" ng-class=\"showGetItNow ? \'red-background\' : \'grey-background\'\"><div class=\"reward-card-details-link-text\"><span res=\"_details_no_semi\" ng-hide=\"showGetItNow\"></span> <span res=\"rfr_get_it_now\" ng-show=\"showGetItNow\"></span></div></div></div>");
$templateCache.put("rfr/js/directives/rewardFullfilment/deviceScenario.html","<div class=\"rewards-redeem-scenario-container\"><h4 class=\"details-header\" res=\"apply_reward_to\"></h4><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><div res=\"apply_reward_to_device\"></div><form class=\"rewards-redeem-device-select-form\" name=\"deviceSelectForm\"><label ng-repeat=\"(name, value) in deviceNumberList track by name\"><input type=\"radio\" name=\"device-select\" ng-model=\"$parent.selectedDeviceNumber\" ng-value=\"value.number\"> <span class=\"device-select-label\">{{::value.name}} ({{::value.number}})</span></label></form></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><div res=\"select_activation_date\"></div><div single-datepicker=\"\"></div></div></div>");
$templateCache.put("rfr/js/directives/rewardFullfilment/shipAddressScenario.html","<div class=\"rewards-redeem-scenario-container\"><h4 class=\"details-header\" res=\"ship_reward_to\" ng-show=\"stepId === \'confirm\'\"></h4><h4 class=\"details-header\" res=\"reward_shipped_to\" ng-show=\"stepId === \'success\'\"></h4><div class=\"rewards-redeem-address-list\"><div class=\"rewards-redeem-address-list-item col-xs-12 col-sm-3\" ng-repeat=\"(accountNumber, address) in ::addressList track by accountNumber\" ng-show=\"showSelectAddress(accountNumber)\" ng-class=\"{ \'readonly-item\': (stepId === \'success\') }\"><label><input type=\"radio\" ng-model=\"$root.selectedAccountNumber\" ng-value=\"accountNumber\" ng-change=\"hideAddressForm()\" name=\"address-select\" id=\"{{accountNumber}}\" class=\"rui-radio\"> <label class=\"radio-label\" for=\"{{accountNumber}}\" ng-hide=\"stepId === \'success\'\"></label><div class=\"address\"><p class=\"address-detail name\">{{::address.firstName}}</p><p class=\"address-detail\">(Acc.# {{::accountNumber}})</p><p class=\"address-detail\">{{::address.streetName}}.</p><p class=\"address-detail\">{{::address.city}}, {{::address.province}}</p><p class=\"address-detail\">{{::address.postalCode}}</p></div></label></div><div class=\"rewards-redeem-address-list-item col-xs-12 col-sm-3\" ng-show=\"showDifferentAddress()\" ng-class=\"{ \'readonly-item\': (stepId === \'success\') }\"><label><input type=\"radio\" name=\"address-select\" ng-model=\"$root.selectedAccountNumber\" ng-change=\"toggleShipAddressForm()\" value=\"differentAddress\" id=\"differentAddress\" class=\"rui-radio\"> <label class=\"radio-label\" for=\"differentAddress\" ng-hide=\"stepId === \'success\'\"></label><div class=\"address\"><p class=\"ship-to-different-address\" res=\"ship_to_different_address\" ng-hide=\"stepId === \'success\'\"></p></div><div ng-show=\"showDifferentAddress()\"><span class=\"address-detail\" ng-show=\"shipAddress\">{{shipAddress.firstName}}&nbsp;{{shipAddress.lastName}}</span> <span class=\"address-detail\" ng-show=\"shipAddress\">{{shipAddress.addressLine1}}</span> <span class=\"address-detail\" ng-show=\"shipAddress\">{{shipAddress.addressLine2}}</span> <span class=\"address-detail\" ng-show=\"shipAddress\">{{shipAddress.city}}, {{::shipAddress.province}}</span> <span class=\"address-detail\" ng-show=\"shipAddress\">{{shipAddress.postalCode}}</span> <span class=\"address-detail\" ng-show=\"stepId === \'success\' && redemptionDetails.shipmentAddress\">{{redemptionDetails.shipmentAddress.firstName}}&nbsp; {{redemptionDetails.shipmentAddress.lastName}}</span> <span class=\"address-detail\" ng-show=\"stepId === \'success\' && redemptionDetails.shipmentAddress\">{{redemptionDetails.shipmentAddress.houseNumber}}&nbsp; {{redemptionDetails.shipmentAddress.streetName}}</span> <span class=\"address-detail\" ng-show=\"stepId === \'success\' && redemptionDetails.shipmentAddress\">{{redemptionDetails.shipmentAddress.city}}&nbsp; {{redemptionDetails.shipmentAddress.province}}&nbsp; {{redemptionDetails.shipmentAddress.postalCode}}</span></div></label></div></div><div class=\"row rewards-redeem-address-form\" ng-show=\"showAddressForm && stepId === \'confirm\'\" ng-controller=\"addressFormCtrl\"><div class=\"redeem-address-form-arrow\"></div><form sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\" sf-options=\"options\" name=\"addressForm\" ng-submit=\"onSubmit(addressForm)\"></form><div class=\"rewards-redeem-address-container-close\" ng-click=\"toggleShipAddressForm()\"><i class=\"rui-icon rui-icon-plus\"></i></div></div></div>");
$templateCache.put("rfr/js/directives/rewardFullfilment/tvAccountScenario.html","<div class=\"rewards-redeem-scenario-container\"><h4 class=\"details-header\" res=\"apply_reward_to\" ng-show=\"stepId === \'confirm\'\"></h4><div class=\"redeem-details-user-input col-xs-12 col-sm-6 clearBoth\"><h4 class=\"details-header\" res=\"reward_applied_to\" ng-show=\"stepId === \'success\'\"></h4><div class=\"details-sub-header pull-left\" ng-show=\"stepId === \'confirm\'\" res=\"select_device_apply_reward_to\"></div><div class=\"redeem-details-user-selections\"><div class=\"rewards-redeem-address-list col-xs-12 col-sm-10 pull-left\"><div class=\"rewards-redeem-address-list-item col-xs-12 col-sm-6\" ng-repeat=\"subscriptionNumber in ::redemptionAccountChoices track by $index\" ng-show=\"showSubscriptionSelection(subscriptionNumber)\" ng-class=\"{ \'readonly-item\': (stepId === \'success\') }\"><label><input type=\"radio\" ng-model=\"$root.selectedSubscriptionNumber\" ng-value=\"subscriptionNumber\" name=\"address-select\" id=\"{{subscriptionNumber}}\" class=\"rui-radio\"> <label class=\"radio-label\" for=\"{{subscriptionNumber}}\" ng-hide=\"stepId === \'success\'\"></label> <span class=\"address-detail\">{{activationTypeMsg}} {{subscriptionNumber}}</span></label></div></div></div></div><div class=\"col-xs-12 col-sm-6\" ng-show=\"stepId === \'confirm\' && reward.futureActivationAllowed\"><div class=\"details-sub-header\" res=\"select_activation_date\"></div><div class=\"redeem-date-picker\" single-datepicker=\"\"></div></div><div class=\"col-xs-12 col-sm-6\" ng-show=\"stepId === \'success\' && reward.futureActivationAllowed\"><h4 class=\"details-header\" res=\"activation_date\"></h4><div>{{redemptionDetails.activationDate}}</div></div></div>");
$templateCache.put("rfr/js/directives/rewardsFooter/rewardsFooter.html","<div class=\"container\"><div class=\"row\" ng-show=\"(splitView === \'true\')\"><div class=\"rui-content-block col-xs-12 col-sm-5\"><h1 class=\"rfr-main-heading col-xs-12\"><span class=\"red\" res=\"rfr_earnmore_header\"></span></h1><div class=\"col-xs-12 mtm\" ng-bind-html=\"earnBanner\"></div><div class=\"col-xs-12\"><ins ute-content-injector=\"\" content-id=\"cms/content/rfr/views/home-earnmore-txt/home-earnmore-txt\"></ins><a ng-show=\"lang === \'en\'\" href=\"https://staging.rogersbank.com/rfr_qualifier/index.html\" class=\"footer-btn cta-round primary medium col-md-6\"><span res=\"rfr_learn_more\"></span></a> <a ng-show=\"lang === \'fr\'\" href=\"https://staging.rogersbank.com/rfr_qualifier/index_fr.html\" class=\"footer-btn cta-round primary medium col-md-6\"><span res=\"rfr_learn_more\"></span></a></div></div><div class=\"rui-content-block col-xs-12 col-sm-5 col-sm-offset-2\"><h1 class=\"rfr-main-heading col-xs-12\"><span class=\"red\" res=\"rfr_questions_header\"></span></h1><div class=\"col-xs-12 mtm\"><img class=\"img-responsive\" src=\"rfr/images/questions.png\"></div><div class=\"col-xs-12\"><p class=\"rfr_questions_copy\" res=\"rfr_questions_info\"></p><div class=\"mvm curved-btn-table curved-btn-arrow col-md-6 live-chat-cta\" ng-click=\"openChatPopup();\"><div class=\"curved-btn-table-cell text-center text-uppercase\"><span res=\"rfr_live_chat\"></span></div></div></div></div></div><div class=\"rui-content-block\" ng-show=\"(splitView === \'false\')\"><h1 class=\"col-xs-12 hidden-sm hidden-md hidden-lg\"><span class=\"red\" res=\"rfr_questions_header\"></span></h1><div class=\"col-xs-12 col-sm-5 mtm\"><img class=\"img-responsive\" src=\"rfr/images/questions.png\"></div><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5 col-sm-offset-1\"><h1 class=\"hidden-xs col-sm-12 col-md-12 col-lg-12\"><span class=\"questions-header-blue\" res=\"rfr_questions_header\"></span></h1><p class=\"rfr_questions_copy\" res=\"rfr_questions_info\"></p><div class=\"mvm curved-btn-table curved-btn-arrow col-md-6 live-chat-cta\" ng-click=\"openChatPopup();\"><div class=\"curved-btn-table-cell text-center text-uppercase\"><span res=\"rfr_live_chat\"></span></div></div></div></div></div>");
$templateCache.put("rfr/js/directives/rewardsSubMenu/rewardsSubMenu.html","<div class=\"redTop navigation directive-rewards-sub-menu\" ng-class=\"{\'hidden-lg hidden-md hidden-sm\': hideBreadCrumbsMenu}\"><div class=\"center-wrapper\"><div class=\"container sub-menu-ctn\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><nav id=\"navbar-example\" class=\"navbar navbar-default navbar-static\"><div class=\"container-fluid\" ng-class=\"{\'visible-sm visible-md visible-lg\': !hideBreadCrumbsMenu, \'hidden\': hideBreadCrumbsMenu}\"><div class=\"navbar-header\"><div><div class=\"subMenuHeader pointer\" ui-sref=\"rewards\" res=\"_my_rewards_nospace\"></div><div class=\"navbar-control\" ng-click=\"navMainMenuClick($event)\" data-toggle=\"collapse\" data-target=\".bs-example-js-navbar-collapse\"><span class=\"navbar-close active\" res=\"more\"></span> <span class=\"navbar-close\" res=\"close\"></span> <span class=\"navbar-icon plus active\" ng-class=\"!toggleMainPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-plus\">+</span></span> <span class=\"navbar-icon minus\" ng-class=\"toggleMainPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-minus\">-</span></span></div></div></div><div class=\"collapse navbar-collapse bs-example-js-navbar-collapse\"><ul class=\"nav navbar-nav\"><li ng-show=\"currentMenu.primary\"><a href=\"{{ currentMenu.primaryUrl }}\" class=\"pointer\" role=\"button\"><span class=\"subMenu-item\"><img src=\"images/Red-Dot.png\">{{currentMenu.primary}}</span></a></li><li class=\"secondary\" ng-if=\"currentMenu.secondary\"><a ng-if=\"!currentMenu.secondaryUrl\" class=\"pointer\" role=\"button\"><span class=\"subMenu-item\"><img src=\"images/Red-Dot.png\">{{currentMenu.secondary}}</span></a> <a ng-if=\"currentMenu.secondaryUrl\" href=\"{{ currentMenu.secondaryUrl }}\" class=\"pointer\" role=\"button\"><span class=\"subMenu-item\"><img src=\"images/Red-Dot.png\">{{currentMenu.secondary}}</span></a></li></ul></div></div><div class=\"container-fluid visible-xs\"><div class=\"container navbar-header\"><div><div class=\"subMenuHeader pointer\" ui-sref=\"rewards\" res=\"_my_rewards_nospace\"></div><div class=\"subMenuRedDot\"><img src=\"images/Red-Dot.png\"></div><div class=\"navbar-control\" ng-click=\"navMainMenuClick($event)\" data-toggle=\"collapse\" data-target=\".bs-example-js-navbar-collapse\"><span class=\"navbar-close active\" res=\"more\"></span> <span class=\"navbar-close\" res=\"close\"></span> <span class=\"navbar-icon plus active\" ng-class=\"!toggleMainPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-plus\">+</span></span> <span class=\"navbar-icon minus\" ng-class=\"toggleMainPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-minus\">-</span></span></div></div></div><div class=\"collapse navbar-collapse bs-example-js-navbar-collapse\" ng-class=\"toggleMainPlusMinus ? \'in\' : \'\'\"><ul class=\"nav navbar-nav\"><li ng-class=\"state.current === \'rewards.browse\' ? \'mobile-selected\' : \'\'\"><a ng-click=\"navHandle(\'rewards.browse\')\" class=\"pointer\" role=\"button\" data-ng-class=\"state.current === \'rewards.browse\' ? \'not-active\' : \'\'\"><span class=\"subMenu-item\" res=\"browse\" ng-class=\"state.current === \'rewards.browse\' ? \'selected\' : \'\'\"></span></a> <span class=\"left-bar\"></span></li><li ng-class=\"state.current === \'rewards.wishlist\' ? \'mobile-selected\' : \'\'\"><a ng-click=\"navHandle(\'rewards.wishlist\')\" role=\"button\" class=\"pointer\"><span class=\"subMenu-item\" ng-class=\"state.current === \'rewards.wishlist\' ? \'selected\' : \'\'\" res=\"wishlist\"></span></a><span class=\"left-bar\"></span></li><li ng-class=\"state.current === \'rewards.membership\' ? \'mobile-selected\' : \'\'\"><a ng-click=\"navHandle(\'rewards.membership\')\" role=\"button\" class=\"pointer\"><span class=\"subMenu-item\" ng-class=\"state.current === \'rewards.membership\' ? \'selected\' : \'\'\" res=\"submenu_membership\"></span></a><span class=\"left-bar\"></span></li></ul></div></div></nav></div></div></div></div></div>");
$templateCache.put("rfr/js/directives/rfrModal/rfrModal.html","<div class=\"rfr-modal-wrapper\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancelModal()\"><span aria-hidden=\"true\">&times;</span></button><p class=\"message-content\" ng-bind-html=\"rfrModalContentGn\"></p></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-left\"></div><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"okModal()\"><span res=\"go_back\"></span></button></div></div></div></div></div></div>");
$templateCache.put("rfr/js/directives/rfrPopover/rfrPopover.html","<div ng-transclude=\"\"></div><div class=\"rfr-popover\" ng-show=\"popoverVisible\"><div class=\"rfr-popover-close\" ng-click=\"!popoverVisible\">x</div><p>{{content}}</p></div>");
$templateCache.put("rfr/js/directives/ruiDropdown/ruiDropdown.html","<div class=\"dropdown-container\" ng-class=\"{ show: listVisible }\"><div class=\"dropdown-display\" ng-click=\"toggle();\" ng-class=\"{ clicked: listVisible }\"><span ng-if=\"!isPlaceholder\">{{ filter ? (useFilter(filter,display)) : display }}</span> <span class=\"placeholder font-14\" ng-if=\"isPlaceholder\">{{placeholder}}</span> <i class=\"fa fa-angle-down\"></i></div><div class=\"dropdown-list\"><div><div ng-repeat=\"item in list track by $index\" ng-click=\"select(item)\" ng-class=\"{ selected: isSelected(item) }\"><span ng-if=\"prefix\">{{prefix}}</span> <span ng-show=\"useres\" res=\"{{item.name}}\"></span> <span ng-hide=\"useres\">{{filter ? (useFilter(filter,getValue(item,property))):getValue(item,property)}}</span> <span ng-if=\"additional\">{{item[additional]}}</span></div></div></div></div>");
$templateCache.put("rfr/js/directives/sectionHeader/sectionHeader.html","<div class=\"row header-ctn\"><div class=\"col-xs-12 big-header-ctn\" ng-style=\"getHeaderStyle()\"><h1 class=\"big-header\" res=\"{{headerCopy}}\"></h1><span class=\"widget-loader-inline\" ng-show=\"{{loaderEnabled}}\"><img src=\"images/widget-loader.gif\" alt=\"\" ng-hide=\"{{loaderHide}}\"></span><hr class=\"big-header-underline\"></div></div>");
$templateCache.put("rfr/js/directives/signInOrRegister/signInOrRegister.html","<div class=\"sign-in-or-register\"><p res=\"rfr_sign_in_or_register\"></p><div class=\"sign-in-link-container\"><a href=\"#/signin\" class=\"sign-in-link cta-round primary large col-xs-12 col-sm-6\" res=\"rfr_sign_in\"></a></div><p class=\"rfr-sign-in-copy\" res=\"rfr_sign_in_copy\"></p><a class=\"rfr-details-link\" href=\"#/registration\" res=\"rfr_register_now\"></a></div>");
$templateCache.put("rfr/js/directives/singleDatepicker/singleDatepicker.html","<div class=\"device-activation-datepicker-wrapper\"><input ng-if=\"!mobileDisplay\" type=\"text\" class=\"datepicker-input\" min-date=\"minDate\" datepicker-popup=\"{{format}}\" ng-readonly=\"!mobileDisplay\" format-day-header=\"EE\" placeholder=\"MM/DD/YYYY\" name=\"deviceActivationDate\" ng-model=\"date.deviceActivationDate\" is-open=\"isOpen.open\" ng-required=\"true\" show-button-bar=\"false\" show-weeks=\"false\" close-text=\"Close\"> <input ng-if=\"mobileDisplay\" type=\"date\" class=\"datepicker-input\" placeholder=\"MM/DD/YYYY\" name=\"deviceActivationDate\" ng-model=\"date.deviceActivationDate\" ng-required=\"true\" autocomplete=\"off\"> <span class=\"datepicker-btn\" ng-click=\"open($event)\"><i class=\"rfr-icon rfr-icon-datepick\"></i></span></div>");
$templateCache.put("rfr/js/directives/transactionsGrid/transactionsGrid.html","<div ng-show=\"isEnrolled\"><a id=\"transactions\"></a><div section-header=\"\" header-copy=\"membership_my_transactions\" loader-enabled=\"true\" loader-hide=\"!loadingTransactions\"></div><a class=\"pull-right\" ng-click=\"sendToPrinter(\'\')\"><i class=\"font-xxl rfr-icon rfr-icon-print\"></i></a><div class=\"row\"><p class=\"membership_transactions_brief\" res=\"membership_transactions_brief\"></p><div class=\"rewards-select-wrapper col-xs-12 col-sm-3\"><div rui-dropdown=\"\" class=\"rui-dropdown\" useres=\"true\" list=\"filterOptions\" selected=\"filterOption\" select-action=\"changeTransactionType(item)\" property=\"name\" placeholder=\"{{getResourceString(\'rfr_select_transaction_type\')}}\"></div></div><div class=\"rewards-membership-transaction-datepicker col-xs-12 col-sm-9\" multi-datepicker=\"\"></div></div><br><div ng-show=\"errorCode.errInTransactionLoading\" class=\"mvm info-banner error reverse-margin\"><div class=\"row\"><div class=\"sigin-error-icon-ctn col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding\"><span class=\"fa fa-exclamation-circle fa-2x txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\"><span class=\"v-base-line\">Sorry, server returned an error.</span></div></div></div><div id=\"main\"><div class=\"row rfr-transaction-item\" ng-repeat=\"transaction in filtered = (transactions | transactionsDateFilter:formData.requestFromDate:formData.requestToDate | transactionsTypeFilter:filterOptionObj | orderBy:datePredicate:true | limitTo: transactionsGridLimit) track by transaction.transactionNo\" ui-sref=\"rewards.transactions({transactionId: {{::transaction.transactionNo}}})\"><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><div class=\"transaction-icon\"><i class=\"rfr-icon rfr-icon-transaction\"></i></div><div class=\"transaction-item-details\"><div ng-bind=\"::transactionDate(transaction)\"></div><div><span res=\"rfr_transaction_id\"></span> <span ng-bind=\"::transaction.transactionNo\"></span></div></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\" ng-bind=\"::getTransactionTitle(transaction)\"></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4\"><div ng-class=\"getPointsClass(transaction)\"><span ng-if=\"getPointsClass(transaction) == \'positive\'\">+</span>{{::transaction.points | number:0}} pts</div></div><hr></div><p class=\"membership_transactions_brief\" ng-show=\"!filtered.length && !loadingTransactions\">No transaction available.</p><div class=\"row\" ng-show=\"filtered.length && allTransactionsCount > 10\"><button class=\"btn btn-secondary transaction-load-more-cta col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-click=\"loadMoreTransactions()\"><i class=\"fa fa-chevron-down\" ng-class=\"transactionsGridLimit === transactions.length ? \'fa-chevron-up\' : \'fa-chevron-down\'\"></i></button></div></div></div>");
$templateCache.put("scripts/directives/editableContent/billingInformation/billinginformation.html","<div class=\"non-editable-row\"><span class=\"row-label\" res=\"BillingType\">Billing Type:</span> <span show-when=\"fr\"></span><b>:</b> <span class=\"value\" type=\"text\"><span ng-hide=\"nonEditableData.paper || nonEditableData.ebill\"><img class=\"widget-loader\" src=\"images/widget-loader.gif\"></span> <span ng-show=\"nonEditableData.paper && ! nonEditableData.ebill\" res=\"_paper\"></span> <span ng-show=\"nonEditableData.ebill && ! nonEditableData.paper\" res=\"_online\"></span></span></div><div class=\"non-editable-row\"><span class=\"row-label\" res=\"billing_address\">Billing Address:</span><span show-when=\"fr\"></span><b>:</b><span class=\"value\">{{nonEditableData.billing_streetAddress}}</span></div><div class=\"non-editable-row\" style=\"padding-top:10px;\" ng-if=\"nonEditableData.country!==\'CA\' && nonEditableData.country!==\'CAN\'\"><div class=\"col-md-6\"><alert><span res=\"billing_us_address_warning\">This is an US address. You can only change the billing method.</span></alert></div></div>");
$templateCache.put("scripts/directives/editableContent/billingInformation/billinginformationform.html","<form name=\"updateBillingTypeForm\" form-locator=\"\" novalidate=\"\"><div class=\"row info-banner error mts mbm\" style=\"margin-left: 0px;\" data-ng-show=\"(updateBillingTypeForm.$valid == false && updateBillingTypeForm.$submitted)\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div ng-if=\"updateBillingTypeForm.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 general-error\" style=\"float:left\"><span res=\"general_error\"></span></div><div ng-if=\"updateBillingTypeForm.errorMsg && !updateBillingTypeForm.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><p res=\"_check_form_errors\"></p><p res=\"_check_form_errors\">{{updateBillingTypeForm.errorMsg}}</p></div><div ng-if=\"!updateBillingTypeForm.errorMsg && !updateBillingTypeForm.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><span res=\"_check_form_errors\"></span></div></div><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-6\"><div class=\"col-md-12\"><div class=\"inline_error hidden-md hidden-xs hidden-sm\" ng-show=\"updateBillingTypeForm.billingType.$touched && updateBillingTypeForm.billingType.$error.invalidEmail\"><span res=\"no_email_error\"></span></div><span res=\"BillingType\">res</span><div class=\"inline_error hidden-lg\" ng-show=\"updateBillingTypeForm.billingType.$touched && updateBillingTypeForm.billingType.$error.invalidEmail\"><span res=\"no_email_error\"></span></div><div class=\"checkbox-line paper\"><label><input type=\"radio\" name=\"billingType\" class=\"rogers-checkbox billing\" ng-model=\"editableData.billingType\" ng-true-value=\"\'INVOICE\'\" value=\"INVOICE\"> <span class=\"selfserve-checkbox-label\" res=\"_paper\"></span></label></div><div class=\"checkbox-line online\"><label><input type=\"radio\" name=\"billingType\" class=\"rogers-checkbox billing paper\" ng-model=\"editableData.billingType\" ng-true-value=\"\'E_BILL\'\" value=\"E_BILL\" truth-test=\"{{editableData.validEmail}}\"> <span class=\"selfserve-checkbox-label\" res=\"_online\"></span></label></div></div><div class=\"col-md-12 billing-btn-ctn\"><button ng-disabled=\"!updateBillingTypeForm.$dirty || !updateBillingTypeForm.$valid\" class=\"save-changes cta-round primary large\"><span class=\"inline-loader-button-label\" ng-click=\"saveBillingChanges(updateBillingTypeForm)\" res=\"_save_changes\"></span></button> <button class=\"cancel cta-round tertiary large\" ng-click=\"cancel()\" res=\"_cancel\"></button></div></div></div></form><div class=\"gray-border-selfserve no-margin-top small-margin-bottom col-md-6\"></div><div class=\"non-editable-row pull-left\" ng-if=\"nonEditableData.country!==\'CA\' && nonEditableData.country!==\'CAN\'\"><div class=\"col-md-8\"><alert><span res=\"billing_us_address_warning\"></span></alert></div></div><form name=\"form\" novalidate=\"\" form-locator=\"\"><div class=\"col-lg-6 col-md-6 editable-row row large-view-margin-only\" style=\"clear:both\"><div class=\"col-lg-12 col-md-12\"><div class=\"col-md-3 col-lg-3 row small-view-margin\" style=\"margin-right:20px\"><span res=\"StreetNumber\"></span><div class=\"inline_error\" ng-show=\"form.StreetNumber.$touched && form.StreetNumber.$error.required\" style=\"clear:both\"><span res=\"street_number_error\"></span></div><div class=\"inline_error\" ng-show=\"form.StreetNumber.$touched && form.StreetNumber.$error.pattern\" style=\"clear:both\"><span res=\"street_number_error_char\"></span></div><input name=\"StreetNumber\" type=\"text\" ng-model=\"editableData.Street_number\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-pattern=\"/^[0-9]{1,6}$/\" required=\"\"></div><div class=\"col-md-4 col-lg-4 row small-view-margin\" style=\"margin-right:20px\"><span class=\"label-name\" res=\"StreetName\">Street Name:</span><div class=\"inline_error\" ng-show=\"form.StreetName.$touched && (form.StreetName.$error.pattern || form.StreetName.$error.required)\" style=\"clear:both\"><span res=\"street_name_error\"></span></div><input class=\"french-extra-margin\" name=\"StreetName\" type=\"text\" maxlength=\"30\" ng-model=\"editableData.Street_name\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-pattern=\"/^[-A-Za-z0-9. ]{1,30}$/\" required=\"\"></div><div class=\"col-md-3 col-lg-3 row\"><span class=\"label-name\" res=\"StreetType\">Street Type:</span><select class=\"streettype french-extra-margin\" ng-model=\"editableData.Street_type\"><option value=\"ABBEY\" res=\"ABBEY\"></option><option value=\"ACRE\" res=\"ACRE\"></option><option value=\"ALLEY\" res=\"ALLEY\"></option><option value=\"ANNEX\" res=\"ANNEX\"></option><option value=\"AVE\" res=\"AVE\"></option><option value=\"BAY\" res=\"BAY\"></option><option value=\"BEACH\" res=\"BEACH\"></option><option value=\"BEND\" res=\"BEND\"></option><option value=\"BLDNG\" res=\"BLDNG\"></option><option value=\"BLOCK\" res=\"BLOCK\"></option><option value=\"BLVD\" res=\"BLVD\"></option><option value=\"BRDG\" res=\"BRDG\"></option><option value=\"BURN\" res=\"BURN\"></option><option value=\"BYPASS\" res=\"BYPASS\"></option><option value=\"BYRON\" res=\"BYRON\"></option><option value=\"BYWAY\" res=\"BYWAY\"></option><option value=\"CAMPU\" res=\"CAMPU\"></option><option value=\"CAPE\" res=\"CAPE\"></option><option value=\"CHASE\" res=\"CHASE\"></option><option value=\"CIR\" res=\"CIR\"></option><option value=\"CIRCT\" res=\"CIRCT\"></option><option value=\"CLIFF\" res=\"CLIFF\"></option><option value=\"CLOSE\" res=\"CLOSE\"></option><option value=\"COMMO\" res=\"COMMO\"></option><option value=\"CONN\" res=\"CONN\"></option><option value=\"COURT\" res=\"COURT\"></option><option value=\"COVE\" res=\"COVE\"></option><option value=\"CRES\" res=\"CRES\"></option><option value=\"CRNRS\" res=\"CRNRS\"></option><option value=\"CROSS\" res=\"CROSS\"></option><option value=\"CTR\" res=\"CTR\"></option><option value=\"CURVE\" res=\"CURVE\"></option><option value=\"DALE\" res=\"DALE\"></option><option value=\"DELL\" res=\"DELL\"></option><option value=\"DIVER\" res=\"DIVER\"></option><option value=\"DOWN\" res=\"DOWN\"></option><option value=\"DR\" res=\"DR\"></option><option value=\"END\" res=\"END\"></option><option value=\"ESPL\" res=\"ESPL\"></option><option value=\"ESTAT\" res=\"ESTAT\"></option><option value=\"EXPY\" res=\"EXPY\"></option><option value=\"EXTEN\" res=\"EXTEN\"></option><option value=\"FARM\" res=\"FARM\"></option><option value=\"FIELD\" res=\"FIELD\"></option><option value=\"FORES\" res=\"FORES\"></option><option value=\"FRONT\" res=\"FRONT\"></option><option value=\"FWY\" res=\"FWY\"></option><option value=\"GARD\" res=\"GARD\"></option><option value=\"GATE\" res=\"GATE\"></option><option value=\"GDNS\" res=\"GDNS\"></option><option value=\"GLADE\" res=\"GLADE\"></option><option value=\"GLEN\" res=\"GLEN\"></option><option value=\"GREEN\" res=\"GREEN\"></option><option value=\"GRNDS\" res=\"GRNDS\"></option><option value=\"GROVE\" res=\"GROVE\"></option><option value=\"GTWAY\" res=\"GTWAY\"></option><option value=\"HALL\" res=\"HALL\"></option><option value=\"HARBR\" res=\"HARBR\"></option><option value=\"HEATH\" res=\"HEATH\"></option><option value=\"HEIGH\" res=\"HEIGH\"></option><option value=\"HGHLD\" res=\"HGHLD\"></option><option value=\"HILL\" res=\"HILL\"></option><option value=\"HOLLO\" res=\"HOLLO\"></option><option value=\"HTS\" res=\"HTS\"></option><option value=\"HWY\" res=\"HWY\"></option><option value=\"IMP\" res=\"IMP\"></option><option value=\"ISLAN\" res=\"ISLAN\"></option><option value=\"JARD\" res=\"JARD\"></option><option value=\"KEEP\" res=\"KEEP\"></option><option value=\"KEY\" res=\"KEY\"></option><option value=\"KNOLL\" res=\"KNOLL\"></option><option value=\"LAKE\" res=\"LAKE\"></option><option value=\"LANDN\" res=\"LANDN\"></option><option value=\"LANE\" res=\"LANE\"></option><option value=\"LAWN\" res=\"LAWN\"></option><option value=\"LINE\" res=\"LINE\"></option><option value=\"LINK\" res=\"LINK\"></option><option value=\"LKOUT\" res=\"LKOUT\"></option><option value=\"LMTS\" res=\"LMTS\"></option><option value=\"LOOP\" res=\"LOOP\"></option><option value=\"MAIN\" res=\"MAIN\"></option><option value=\"MALL\" res=\"MALL\"></option><option value=\"MANOR\" res=\"MANOR\"></option><option value=\"MARKE\" res=\"MARKE\"></option><option value=\"MAZE\" res=\"MAZE\"></option><option value=\"MEADO\" res=\"MEADO\"></option><option value=\"MEWS\" res=\"MEWS\"></option><option value=\"MIN12\" res=\"MIN12\"></option><option value=\"MOOR\" res=\"MOOR\"></option><option value=\"MOUNT\" res=\"MOUNT\"></option><option value=\"MTN\" res=\"MTN\"></option><option value=\"ORCH\" res=\"ORCH\"></option><option value=\"PARAD\" res=\"PARAD\"></option><option value=\"PARC\" res=\"PARC\"></option><option value=\"PARK\" res=\"PARK\"></option><option value=\"PASS\" res=\"PASS\"></option><option value=\"PATH\" res=\"PATH\"></option><option value=\"PINES\" res=\"PINES\"></option><option value=\"PKY\" res=\"PKY\"></option><option value=\"PL\" res=\"PLACE\"></option><option value=\"PLAT\" res=\"PLAT\"></option><option value=\"PLAZA\" res=\"PLAZA\"></option><option value=\"PLWAY\" res=\"PLWAY\"></option><option value=\"POINT\" res=\"POINT\"></option><option value=\"PRKRD\" res=\"PRKRD\"></option><option value=\"PROM\" res=\"PROM\"></option><option value=\"PTWAY\" res=\"PTWAY\"></option><option value=\"PVT\" res=\"PVT\"></option><option value=\"QUAY\" res=\"QUAY\"></option><option value=\"RANG\" res=\"RANG\"></option><option value=\"RANGE\" res=\"RANGE\"></option><option value=\"RDPT\" res=\"RDPT\"></option><option value=\"RIDGE\" res=\"RIDGE\"></option><option value=\"RISE\" res=\"RISE\"></option><option value=\"RD\" res=\"ROAD\"></option><option value=\"ROUTE\" res=\"ROUTE\"></option><option value=\"ROW\" res=\"ROW\"></option><option value=\"RUE\" res=\"RUE\"></option><option value=\"RUN\" res=\"RUN\"></option><option value=\"SEAWK\" res=\"SEAWK\"></option><option value=\"SQ\" res=\"SQ\"></option><option value=\"ST\" res=\"ST\"></option><option value=\"SUBDI\" res=\"SUBDI\"></option><option value=\"TERR\" res=\"TERR\"></option><option value=\"THICK\" res=\"THICK\"></option><option value=\"TLINE\" res=\"TLINE\"></option><option value=\"TOWER\" res=\"TOWER\"></option><option value=\"TRAIL\" res=\"TRAIL\"></option><option value=\"TRLWA\" res=\"TRLWA\"></option><option value=\"TRNAB\" res=\"TRNAB\"></option><option value=\"VALE\" res=\"VALE\"></option><option value=\"VALLE\" res=\"VALLE\"></option><option value=\"VIEW\" res=\"VIEW\"></option><option value=\"VILLA\" res=\"VILLA\"></option><option value=\"VILLG\" res=\"VILLG\"></option><option value=\"VISTA\" res=\"VISTA\"></option><option value=\"WALK\" res=\"WALK\"></option><option value=\"WAY\" res=\"WAY\"></option><option value=\"WHARF\" res=\"WHARF\"></option><option value=\"WKWAY\" res=\"WKWAY\"></option><option value=\"WOOD\" res=\"WOOD\"></option><option value=\"WYND\" res=\"WYND\"></option></select></div></div></div><div class=\"col-lg-6 col-md-6 editable-row large-view-margin-only\" style=\"clear:both\"><div class=\"col-lg-12 col-md-12\"><div class=\"col-md-3 col-lg-3 row\" style=\"margin-right:20px; margin-bottom:30px\"><span res=\"AptNumber\">Apt Number:</span> <input name=\"AptNumber\" type=\"text\" ng-model=\"editableData.AptNo\" ng-pattern=\"/^[0-9]{1,6}$/\"></div><div class=\"col-md-4 col-lg-4 row\" style=\"margin-bottom:30px\"><span class=\"label-name\" res=\"_Type\">Type:</span><select class=\"streettype french-extra-margin\" ng-model=\"editableData.AptType\"><option value=\"APT\" res=\"Apartment\"></option><option value=\"BUREAU\" res=\"Bureau\"></option><option value=\"FLR\" res=\"Floor\"></option><option value=\"PH\" res=\"Penthouse\"></option><option value=\"SUITE\" res=\"Suite\"></option><option value=\"UNIT\" res=\"Unit\"></option></select></div></div></div><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-6\"><span res=\"_city\">City</span><div class=\"inline_error\" ng-show=\"form.BillingCity.$touched && (form.BillingCity.$error.pattern || form.BillingCity.$error.required)\" style=\"clear:both\"><span res=\"valid_city_name\"></span></div><input name=\"BillingCity\" type=\"text\" maxlength=\"30\" ng-model=\"editableData.city\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-pattern=\"/^[A-Za-z0-9 ]{1,30}$/\" required=\"\"></div></div><div class=\"editable-row row\"><div class=\"col-md-3 col-lg-3 row\" style=\"margin-right:20px; margin-bottom:30px\"><span res=\"_province\"></span><select name=\"province\" ng-model=\"editableData.province\"><option value=\"AB\" res=\"alberta\"></option><option value=\"BC\" res=\"british_columbia\"></option><option value=\"MB\" res=\"manitoba\"></option><option value=\"NB\" res=\"new_brunswick\"></option><option value=\"NF\" res=\"newfoundland\"></option><option value=\"NW\" res=\"northwest\"></option><option value=\"NS\" res=\"nova_scotia\"></option><option value=\"NU\" res=\"nunavut\"></option><option value=\"ON\" res=\"ontario\"></option><option value=\"PE\" res=\"prince_edward_island\"></option><option value=\"QC\" res=\"quebec\"></option><option value=\"SK\" res=\"saskatchewan\"></option><option value=\"YK\" res=\"yukon\"></option></select></div><div class=\"col-md-4 col-lg-4 row\" style=\"margin-bottom:30px\"><span res=\"_postal_code\" class=\"postal-code-title\">Postal Code</span><div class=\"inline_error\" ng-show=\"form.PostalCode.$touched && (form.PostalCode.$error.pattern || form.PostalCode.$error.required)\" style=\"clear:both\"><span res=\"valid_postal_code\"></span></div><div class=\"col-md-4\"><input type=\"text\" name=\"PostalCode\" maxlength=\"7\" ng-model=\"editableData.postalCode\" ng-pattern=\"/^[a-z]{1}\\d{1}[a-z]{1} ?\\d{1}[a-z]{1}\\d{1}$/i\" ng-model-options=\"{ updateOn: \'blur\' }\" required=\"\"></div></div></div><div class=\"col-md-6 billing-btn-ctn\"><button class=\"save-changes cta-round primary large\" ng-class=\"{ inactive :form.$pristine }\" ng-click=\"saveChanges(form)\" res=\"_save_changes\"></button> <button class=\"cancel cta-round tertiary large\" ng-click=\"cancel()\" res=\"_cancel\"></button></div></form>");
$templateCache.put("scripts/directives/editableContent/contactInformation/contactinformation.html","<div class=\"non-editable-row\" ng-show=\"nonEditableData.email\"><span class=\"row-label\" res=\"_email_label\" ng-show=\"nonEditableData.email\">Email:</span><span show-when=\"fr\"></span><b>:</b><span class=\"value\" ng-show=\"nonEditableData.email\">{{nonEditableData.email}}</span></div><div class=\"non-editable-row\" ng-show=\"nonEditableData.contactNumber1\"><span class=\"row-label\" res=\"_contact_number_1\" ng-show=\"nonEditableData.contactNumber1\">Contact Number 1:</span><span show-when=\"fr\"></span><b>:</b><span class=\"value\" ng-show=\"nonEditableData.contactNumber1\" type=\"text\">{{nonEditableData.contactNumber1 | phone2}}</span></div><div class=\"non-editable-row\" ng-show=\"nonEditableData.contactNumber2\"><span class=\"row-label\" res=\"_contact_number_2\" ng-show=\"nonEditableData.contactNumber2\">Contact Number 2:</span><span show-when=\"fr\"></span><b>:</b><span class=\"value\" type=\"text\" ng-show=\"nonEditableData.contactNumber2\">{{nonEditableData.contactNumber2 | phone2}}</span></div><div class=\"non-editable-row\" ng-show=\"nonEditableData.extension\"><span class=\"row-label\" res=\"_ext\" ng-show=\"nonEditableData.extension\">Ext:</span><span show-when=\"fr\"></span><b>:</b><span class=\"value\" type=\"text\" ng-show=\"nonEditableData.extension\">{{nonEditableData.extension}}</span></div><div class=\"non-editable-row\" ng-show=\"nonEditableData.language\"><span class=\"row-label\" res=\"_lang\" ng-show=\"nonEditableData.language\">Language</span><span show-when=\"fr\"></span><b>:</b><span class=\"value\" type=\"text\" ng-show=\"nonEditableData.language\">{{nonEditableData.language}}</span></div>");
$templateCache.put("scripts/directives/editableContent/contactInformation/contactinformationform.html","<form name=\"updateEmailForm\" form-locator=\"\" novalidate=\"\"><div class=\"row info-banner error mts mbm\" style=\"margin-left: 0px;\" data-ng-show=\"(updateEmailForm.$valid == false && updateEmailForm.$submitted)\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div ng-if=\"updateEmailForm.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 general-error\" style=\"float:left\"><span res=\"general_error\"></span></div><div ng-if=\"updateEmailForm.errorMsg && !updateEmailForm.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><p res=\"_check_form_errors\"></p><p res=\"_check_form_errors\">{{updateEmailForm.errorMsg}}</p></div><div ng-if=\"!updateEmailForm.errorMsg && !updateEmailForm.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><span res=\"_check_form_errors\"></span></div></div><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-6\"><span res=\"_email_ppc\">Email:</span><div class=\"inline_error\" ng-show=\"updateEmailForm.Email.$error.pattern\"><span res=\"email_validation\"></span></div><input type=\"text\" name=\"Email\" required=\"\" ng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-model=\"editableData.email\"></div></div><div class=\"editable-row row\" ng-if=\"updateEmailForm.Email.$dirty\"><div class=\"col-md-6\"><span res=\"_email_confirm\">Confirm Email:</span><div class=\"inline_error\" ng-messages=\"updateEmailForm.confirmEmail.$error\" ng-show=\"updateEmailForm.confirmEmail.$invalid && updateEmailForm.confirmEmail.$dirty\"><span res=\"_email_not_matched\"></span></div><input type=\"text\" name=\"confirmEmail\" ng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/\" ng-model=\"editableData.emailconfirmation\" ng-model-options=\"{ updateOn: \'blur\' }\" compare-to=\"editableData.email\" ng-required=\"updateEmailForm.Email.$touched\"></div></div><div class=\"editable-row row\"><div class=\"col-md-6 col-lg-6\"><div class=\"button-container-email-update\"><button ng-disabled=\"!(updateEmailForm.$dirty && updateEmailForm.$valid)\" class=\"save-changes cta-round primary large\" ng-class=\"{ inactive :updateEmailForm.$pristine }\"><img class=\"inline-loader\" src=\"images/widget-loader.gif\" ng-show=\"updatingBillingType\"><span class=\"inline-loader-button-label\" ng-click=\"updateEmail(updateEmailForm)\" res=\"_save_changes\"></span></button> <button class=\"cancel cta-round tertiary large\" ng-click=\"cancel()\" res=\"_cancel\"></button></div></div></div></form><form name=\"form\" novalidate=\"\" form-locator=\"\"><div class=\"gray-border-selfserve small-margin-bottom no-margin-top col-md-6\"></div><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-3\"><span res=\"_contact_number_1\"></span><div class=\"inline_error\" ng-show=\"form.ContactNumber1.$error.pattern || form.ContactNumber1.$error.required\" res=\"contact_number_1_validation\"></div><input type=\"text\" name=\"ContactNumber1\" maxlength=\"10\" ng-model=\"editableData.contactNumber1\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-pattern=\"/^[0-9]{10}$/\" required=\"\"></div></div><div class=\"editable-row row\"><div class=\"col-md-6\"><div class=\"col-xs-12 col-md-6\"><span res=\"_contact_number_2\"></span><div class=\"inline_error hidden-xs hidden-sm hidden-md\" ng-show=\"form.ContactNumber2.$error.required || form.ContactNumber2.$error.pattern || form.Extension.$error.pattern\" res=\"contact_number_2_validation\"></div><div class=\"col-md-12\"><div class=\"inline_error hidden-lg\" ng-show=\"form.ContactNumber2.$error.required || form.ContactNumber2.$error.pattern || form.Extension.$error.pattern\" res=\"contact_number_2_validation\"></div><input type=\"text\" name=\"ContactNumber2\" maxlength=\"10\" ng-pattern=\"/^[0-9]{10}$/\" ng-model=\"editableData.contactNumber2\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-required=\"editableData.extension\"></div></div><div class=\"col-xs-12 col-md-2 extension\"><span res=\"_extension\"></span><div class=\"col-md-12\"><div class=\"inline_error hidden-lg\" ng-show=\"form.Extension.$error.pattern\" res=\"contact_number_2_validation\"></div><input type=\"text\" name=\"Extension\" maxlength=\"4\" ng-model=\"editableData.extension\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-pattern=\"/^[0-9]{1,5}$/\"></div></div></div></div><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-6\"><span res=\"_lang\">Language:</span><div class=\"checkbox-line english\"><label><input type=\"radio\" value=\"EN\" name=\"language\" class=\"rogers-checkbox billing\" ng-model=\"editableData.language\" ng-true-value=\"\'EN\'\" ng-change=\"checkForMultipleChecks()\"> <span class=\"selfserve-checkbox-label\" res=\"_english\">English</span></label></div><div class=\"checkbox-line french\"><label><input type=\"radio\" value=\"FR\" name=\"language\" class=\"rogers-checkbox billing paper\" ng-model=\"editableData.language\" ng-true-value=\"\'FR\'\" ng-change=\"checkForMultipleChecks()\"> <span class=\"selfserve-checkbox-label\" res=\"_french\">French</span></label></div></div></div><div class=\"col-md-6 billing-btn-ctn\"><button ng-disabled=\"!(form.$dirty && form.$valid)\" class=\"save-changes cta-round primary large\" ng-class=\"{ inactive :form.$pristine }\" ng-click=\"saveChanges(form)\" res=\"_save_changes\"></button> <button class=\"cancel cta-round tertiary large\" ng-click=\"cancel()\" res=\"_cancel\"></button></div></form>");
$templateCache.put("scripts/directives/editableContent/marketingPermission/marketingPermissionsSmall.html","<div class=\"marketing-permissions-small\"><div class=\"col-sm-10\"><p class=\"inline\" res=\"let_us_know_how_you\"></p><img src=\"images/blueicon-with-text.png\" alt=\"info\" class=\"info-icon\" ng-click=\"openModal()\"></div><ul class=\"col-sm-12 marketing-ctn\"><li class=\"marketing-heading\" ng-click=\"!isEditOpen() && (wirelessExpanded = !wirelessExpanded)\"><span res=\"wireless\"></span><div class=\"details-button\" ng-class=\"{clickable: !isEditOpen()}\"><div ng-hide=\"wirelessExpanded\" class=\"plus-sign\">+</div><div ng-show=\"wirelessExpanded\" class=\"minus-sign\"></div></div></li><ul ng-show=\"wirelessExpanded\" class=\"marketing-options\" id=\"expandWireless\"><td class=\"checkbox-ctn\"></td><li ng-repeat=\"marketingChannel in marketingChannels\"><span class=\"bold yes-no\">{{getYesNo(nonEditableData[\'WIRELESS\'][marketingChannel.id])}}</span> <span class=\"channel-name\">{{getResource(marketingChannel.resource)}}</span></li></ul></ul><ul class=\"col-sm-12 marketing-ctn\"><li class=\"marketing-heading\" ng-click=\"!isEditOpen() && (tvExpanded = !tvExpanded)\"><span res=\"tv\"></span><div class=\"details-button\" ng-class=\"{clickable: !isEditOpen()}\"><div ng-hide=\"tvExpanded\" class=\"plus-sign\">+</div><div ng-show=\"tvExpanded\" class=\"minus-sign\"></div></div></li><ul ng-show=\"tvExpanded\" class=\"marketing-options\" id=\"expandTv\"><li ng-repeat=\"marketingChannel in marketingChannels\"><span class=\"bold yes-no\">{{getYesNo(nonEditableData[\'CABLE\'][marketingChannel.id])}}</span> <span class=\"channel-name\">{{getResource(marketingChannel.resource)}}</span></li></ul></ul><ul class=\"col-sm-12 marketing-ctn\"><li class=\"marketing-heading\" ng-click=\"!isEditOpen() && (internetExpanded = !internetExpanded)\"><span res=\"_internet\"></span><div class=\"details-button\" ng-class=\"{clickable: !isEditOpen()}\"><div ng-hide=\"internetExpanded\" class=\"plus-sign\">+</div><div ng-show=\"internetExpanded\" class=\"minus-sign\"></div></div></li><ul ng-show=\"internetExpanded\" class=\"marketing-options\" id=\"expandInternet\"><li ng-repeat=\"marketingChannel in marketingChannels\"><span class=\"bold yes-no\">{{getYesNo(nonEditableData[\'INTERNET\'][marketingChannel.id])}}</span> <span class=\"channel-name\">{{getResource(marketingChannel.resource)}}</span></li></ul></ul><ul class=\"col-sm-12 marketing-ctn\"><li class=\"marketing-heading\" ng-click=\"!isEditOpen() && (homePhoneExpanded = !homePhoneExpanded)\"><span res=\"rogers_home_phone\"></span><div class=\"details-button\" ng-class=\"{clickable: !isEditOpen()}\"><div ng-hide=\"homePhoneExpanded\" class=\"plus-sign\">+</div><div ng-show=\"homePhoneExpanded\" class=\"minus-sign\"></div></div></li><ul ng-show=\"homePhoneExpanded\" class=\"marketing-options\" id=\"expandHomePhone\"><li ng-repeat=\"marketingChannel in marketingChannels\"><span class=\"bold yes-no\">{{getYesNo(nonEditableData[\'HOME PHONE\'][marketingChannel.id])}}</span> <span class=\"channel-name\">{{getResource(marketingChannel.resource)}}</span></li></ul></ul></div>");
$templateCache.put("scripts/directives/editableContent/marketingPermission/marketingPermissionsSmallForm.html","<div class=\"marketing-permissions-small\"><p>Let us know how you\'d like to be contacted</p><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandWireless\" aria-expanded=\"false\" aria-controls=\"expandWireless\"><span>Wireless</span><details-button expanded=\"detailsExpanded\"></details-button></li><ul class=\"collapse marketing-options\" id=\"expandWireless\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.wireless\" ng-click=\"alert(\'HI\')\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.wireless\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.wireless\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.wireless\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedWireless\" ng-change=\"clearSelections(\'wireless\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"wirelessCopySelection\" ng-change=\"copySelections()\"><span>Apply these settings to all services</span></li></ul></ul><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandTv\" aria-expanded=\"false\" aria-controls=\"expandTv\"><span>TV</span><details-button></details-button></li><ul class=\"collapse marketing-options\" id=\"expandTv\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.cable\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.cable\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.cable\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.cable\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedCable\" ng-change=\"clearSelections(\'cable\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"cableCopySelection\" ng-change=\"copySelections()\"><span>Apply these settings to all services</span></li></ul></ul><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandInternet\" aria-expanded=\"false\" aria-controls=\"expandInternet\"><span>Internet</span><details-button></details-button></li><ul class=\"collapse marketing-options\" id=\"expandInternet\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.internet\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.internet\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.internet\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.internet\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedInternet\" ng-change=\"clearSelections(\'internet\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\"><span>Apply these settings to all services</span></li></ul></ul><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandHomePhone\" aria-expanded=\"false\" aria-controls=\"expandHomePhone\"><span>Rogers Home Phone</span><details-button></details-button></li><ul class=\"collapse marketing-options\" id=\"expandHomePhone\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.homephone\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.homephone\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.homephone\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.homephone\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedHomePhone\" ng-change=\"clearSelections(\'homephone\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\"><span>Apply these settings to all services</span></li></ul></ul><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandHomeMonitoring\" aria-expanded=\"false\" aria-controls=\"expandHomeMonitoring\"><span>Smart Home Monitoring</span><details-button></details-button></li><ul class=\"collapse marketing-options\" id=\"expandHomeMonitoring\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.homemonitoring\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.homemonitoring\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.homemonitoring\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.homemonitoring\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedHomeMonitoring\" ng-change=\"clearSelections(\'homemonitoring\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\"><span>Apply these settings to all services</span></li></ul></ul></div>");
$templateCache.put("scripts/directives/editableContent/marketingPermission/marketinginformation.html","<div class=\"marketing-permissions\"><div class=\"col-md-12 col-lg-12\"><p class=\"let-us-know\" res=\"let_us_know_how_you\"></p><img src=\"images/blueicon-with-text.png\" alt=\"info\" class=\"info-icon\" style=\"display: inline;\" ng-click=\"openModal()\"></div><div class=\"col-md-12 col-lg-12\"><table><tr class=\"columns\"><td class=\"left-border\"></td><td ng-repeat=\"marketingChannel in marketingChannels\">{{getResource(marketingChannel.resource)}}</td></tr><tr class=\"filler-height\"></tr><tr ng-repeat=\"productCategory in productCategories\" class=\"bottom-border\"><td class=\"category first-category\">{{getResource(productCategory.resource)}}</td><td class=\"checkbox-ctn\" ng-repeat=\"marketingChannel in marketingChannels\">{{getYesNo(nonEditableData[productCategory.id][marketingChannel.id])}}</td></tr></table></div></div>");
$templateCache.put("scripts/directives/editableContent/marketingPermission/marketinginformationform.html","<div class=\"marketing-permissions\" disable-whiteout=\"\"><p res=\"editableDataSubheading\">Let us know how you\'d like to be contacted</p><table><tr class=\"columns\"><td class=\"left-border\"></td><td class=\"email-column-heading\">Email</td><td>Direct Mail</td><td>Telemarketing</td><td>Text messages</td><td class=\"right-border\">None</td></tr><tr class=\"filler-height\"></tr><tr><td class=\"category first-category\">Wireless</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.wireless\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_MAIL.Permissions.wireless\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.wireless\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.wireless\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedWireless\" ng-change=\"clearSelections(\'wireless\')\"></td></tr><tr class=\"bottom-border\"><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td class=\"category\">TV</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.cable\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_MAIL.cable\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.cable\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.cable\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedCable\" ng-change=\"clearSelections(\'cable\')\"></td></tr><tr class=\"bottom-border\"><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td class=\"category\">Internet</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.Permissions.internet\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.internet\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.internet\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.internet\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedInternet\" ng-change=\"clearSelections(\'internet\')\"></td></tr><tr class=\"bottom-border\"><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td class=\"category\">Rogers Home Phone</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.Permissions.homephone\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.homephone\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.homephone\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.homephone\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedHomePhone\" ng-change=\"clearSelections(\'homephone\')\"></td></tr><tr class=\"bottom-border\"><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td class=\"category\">Smart Home Monitoring</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.Permissions.homemonitoring\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.homemonitoring\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.homemonitoring\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.homemonitoring\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedHomeMonitoring\" ng-change=\"clearSelections(\'homemonitoring\')\"></td></tr></table></div>");
$templateCache.put("scripts/directives/editableContent/serviceAddress/serviceaddress.html","<div class=\"non-editable-row\"><span class=\"value\">{{nonEditableData.address}}</span></div>");
$templateCache.put("scripts/directives/editableContent/serviceAddress/serviceaddressform.html","<form novalidate=\"\"><div class=\"editable-row row\"><div class=\"col-md-6\"><span res=\"_address\">Address</span> <label class=\"rel\"><input type=\"text\" ng-model=\"editableData.address\" required=\"\"></label></div></div></form>");
$templateCache.put("scripts/directives/editableContent/userAccount/usernameandpassword.html","<div class=\"non-editable-row\"><span class=\"row-label\" res=\"_username\">Username:</span><span show-when=\"fr\"></span><b>:</b><span class=\"value\">{{nonEditableData.userName}}</span></div><div class=\"non-editable-row\"><span class=\"row-label\" res=\"_password\">Password:</span><span show-when=\"fr\"></span><b>:</b><input class=\"value\" type=\"password\" ng-value=\"123456\" readonly=\"\"></div><div class=\"non-editable-row\"><span class=\"row-label\" res=\"ReminderQuestion\">Reminder Question</span><span show-when=\"fr\"></span><b>:</b> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 1\" res=\"login_security_questions_1\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 2\" res=\"login_security_questions_2\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 3\" res=\"login_security_questions_3\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 4\" res=\"login_security_questions_4\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 5\" res=\"login_security_questions_5\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 6\" res=\"login_security_questions_6\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 7\" res=\"login_security_questions_7\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 8\" res=\"login_security_questions_8\"></span></div><div class=\"non-editable-row\"><span class=\"row-label\" res=\"ReminderAnswer\">Reminder Answer</span><span show-when=\"fr\"></span><b>:</b> <input type=\"password\" maxlength=\"250\" class=\"value reminder-answer\" ng-model=\"nonEditableData.answer\" readonly=\"\"></div>");
$templateCache.put("scripts/directives/editableContent/userAccount/usernameandpasswordform.html","<form name=\"form\" form-locator=\"\" novalidate=\"\" ng-submit=\"form.$valid && form.submit()\"><div class=\"row info-banner error mts\" style=\"margin-left: 0px;\" data-ng-show=\"(!form.$valid && form.$submitted)\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div ng-if=\"form.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 general-error\" style=\"float:left\"><span res=\"general_error\"></span></div><div ng-if=\"form.errorMsg && !form.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><span res=\"_check_form_errors\">{{form.errorMsg}}</span></div><div ng-if=\"!form.errorMsg && !form.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><span res=\"_check_form_errors\"></span></div></div><div class=\"editable-row row mbm\"><div class=\"col-md-6\"><span res=\"_username\">Username</span><span class=\"user-name\">{{editableData.userName}}</span></div></div><div class=\"editable-row row mbm\"><div class=\"col-md-6\"><span res=\"OldPassword\">Old Password</span><div class=\"inline_error\" ng-show=\"form.$submitted && form.oldpasswordwrong && !form.oldPassword.$touched\"><span res=\"registration_password_incorrect\"></span></div><div class=\"inline_error\" ng-show=\"form.oldPassword.$touched &&form.oldPassword.$error.required\"><span res=\"login_re_enter\"></span></div><input type=\"password\" ng-change=\"form.$setValidity(\'oldPassword\', true, form)\" name=\"oldPassword\" ng-model=\"editableData.oldPassword\" ng-required=\"form.newPassword.$touched\" ng-model-options=\"{ updateOn: \'blur\' }\"></div></div><div class=\"editable-row row mbm\"><div class=\"col-md-6\"><span res=\"temp_password_dew_pass_field\">New Password</span><more-information templateurl=\"views/modals/passwordRequirement.html\"></more-information><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"inline_error\" ng-messages=\"form.password.$error\" ng-show=\"form.password.$invalid && form.password.$dirty && form.confirmPassword !== \'\'\"><span ng-message=\"required\"><span res=\"login_invalid_password\"></span></span><span ng-message=\"minlength\"><span res=\"registration_too_short\"></span></span> <span ng-message=\"maxlength\"><span res=\"registration_too_long\"></span></span> <span ng-message=\"pattern\"><span res=\"registration_wrong_password\"></span></span> <span ng-message=\"match\"><span res=\"registration_password_must_differ\"></span></span></div></div></div></div></div><label class=\"rel\"><input type=\"password\" ng-model=\"editableData.newPassword\" name=\"password\" maxlength=\"16\" minlength=\"7\" ng-required=\"form.oldPassword.$touched\" ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#\\$%\\^\\&*\\)\\(+=._-]{7,16}$/\" autocorrect=\"off\" ng-model-options=\"{ updateOn: \'blur\' }\" autocapitalize=\"off\" match=\"form.oldPassword\" un-match=\"true\"> <span class=\"inline-checker icon-error rui-icon-error-icon\" data-ng-show=\"form.password.$dirty && form.password.$invalid\"></span> <i ng-show=\"form.password.$dirty && form.password.$valid\" class=\"inline-checker icon-checked\"></i></label></div></div><div class=\"editable-row row mbm\"><div class=\"col-md-6\"><span res=\"_confirm_new_password\">Confirm New Password</span><div class=\"inline_error\" ng-show=\"form.$submitted || form.confirmPassword.$touched\"><div ng-show=\"form.confirmPassword.$error.required\"><span res=\"login_re_enter\"></span></div><div ng-show=\"form.confirmPassword.$error.match\"><span res=\"_password_not_matched\"></span></div></div><label class=\"rel\"><input maxlength=\"16\" minlength=\"7\" ng-required=\"form.newPassword.$touched\" ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#\\$%\\^\\&*\\)\\(+=._-]{7,16}$/\" type=\"password\" ng-model=\"editableData.confirmPassword\" ng-model-options=\"{ updateOn: \'blur\' }\" name=\"confirmPassword\" match=\"form.password\"> <span class=\"inline-checker icon-error rui-icon-error-icon\" data-ng-show=\"form.confirmPassword.$invalid && (form.confirmPassword.$dirty || form.$submitted)\"></span> <i ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$valid\" class=\"inline-checker icon-checked\"></i></label></div></div><div class=\"gray-border-selfserve small-margin-bottom small-margin-top col-md-6\" style=\"clear:both\"></div><div class=\"editable-row row mbm\" style=\"clear:both\" ng-hide=\"\"><div class=\"col-md-6\"><span res=\"SecretQuestion\"></span><div class=\"inline_error\" ng-messages=\"form.ReminderQuestion.$error\"><div ng-message=\"required\"><span res=\"secret_question_select\"></span></div></div><div rui-dropdown=\"\" class=\"rui-dropdown\" list=\"loginSecurityQuestions\" selected=\"selectedSecurityQuestion\" property=\"label\" select-action=\"selectSecurityQuestion(item)\" listen-for-language-change=\"true\"></div></div></div><div class=\"editable-row row mbm\"><div class=\"col-md-6\"><span res=\"_answer\">Answer:</span><div class=\"inline_error\" ng-show=\"(form.SecretAnswer.$error.pattern || form.SecretAnswer.$error.required) && form.SecretAnswer.$touched\"><div><span res=\"secret_answer_validation\">Please answer your password reminder question. Your answer can contain letters, numbers, and special characters.</span></div></div><input type=\"text\" name=\"SecretAnswer\" ng-model=\"editableData.answer\" maxlength=\"200\" ng-required=\"form.SecretAnswer.$touched\" ng-model-options=\"{ updateOn: \'blur\' }\"></div></div><div class=\"col-md-6 billing-btn-ctn\"><button ng-disabled=\"!(form.$valid && form.$dirty)\" class=\"save-changes cta-round primary large\" ng-class=\"{ inactive :form.$pristine }\" ng-click=\"saveChanges(form)\" res=\"_save_changes\"></button> <button class=\"cancel cta-round tertiary large\" ng-click=\"cancel()\" res=\"_cancel\"></button></div></form>");
$templateCache.put("scripts/directives/oneview/repFeedback/repFeedback.html","<div ng-show=\"userTypeDealer || userTypeCare\"><div id=\"rep-feedback-tab\" class=\"rep-feedback-tab\" ng-class=\"{\'rep-feedback-tab-fr\':(lang === \'fr\')}\"><a ng-click=\"openSurveyLink()\"><span res=\"report_issue\"></span></a></div></div>");
$templateCache.put("scripts/directives/oneview/sspDashboard/sspDashboard.html","<div ng-controller=\"sspDashboardCtrl\" ng-show=\"userTypeDealer\"><div id=\"ssp-dashboard-tab\" class=\"ssp-dashboard-tab\"><a ng-click=\"backToSSPdashBoard()\"><span res=\"ssp_dashboard\"></span></a></div><div ng-show=\"false\"><form name=\"formToSSP\" id=\"formToSSP\" method=\"post\" novalidate=\"\"><input type=\"hidden\" name=\"data\" id=\"sharedKey\"><br><input type=\"hidden\" name=\"sig\" id=\"signature\"><br><input type=\"hidden\" name=\"content\" id=\"content\"><br></form></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/add-on/add-on-details.html","<div class=\"available-plan-details add-on-details add-on-details-collapsed\" ng-class=\"{ \'add-on-details-expanded\' : expanded }\"><div class=\"wedgie\" ng-class=\"{ \'wedgie-0\' : slideIndex === \'0\', \'wedgie-1\' : slideIndex === \'1\', \'wedgie-2\' : slideIndex === \'2\'}\"></div><div id=\"top-bar\" class=\"col-lg-12 col-md-12\"></div><div id=\"body\" class=\"ppc-addon-details-body\"><div class=\"column left-column padding-top col-lg-5 col-md-5 ppc-addon-details-padding\"><div class=\"title\"><span show-when=\"en\" ng-bind-html=\"details.cmsData_En.expandedDetails.title | trustHtml\"></span> <span show-when=\"fr\" ng-bind-html=\"details.cmsData_Fr.detailsSectionFr.title | trustHtml\"></span></div><div class=\"body\"><span show-when=\"en\" ng-bind-html=\"details.cmsData_En.expandedDetails.body | trustHtml\"></span> <span show-when=\"fr\" ng-bind-html=\"details.cmsData_Fr.expandedDetails.body | trustHtml\"></span></div><div class=\"footer\"><span show-when=\"en\" ng-bind-html=\"details.cmsData_En.expandedDetails.footer | trustHtml\"></span> <span show-when=\"fr\" ng-bind-html=\"details.cmsData_Fr.expandedDetails.footer | trustHtml\"></span></div></div><div class=\"column padding-top col-lg-7 col-md-7\"><div class=\"details-left-column col-lg-4 col-md-4\"><div class=\"details-list-title\"><span show-when=\"en\" data-ng-bind-html=\"details.cmsData_En.expandedDetails.features[0].title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"details.cmsData_Fr.features[0].title\"></span></div><div class=\"details-body\"><span show-when=\"en\" data-ng-bind-html=\"details.cmsData_En.expandedDetails.features[0].body\"></span> <span show-when=\"fr\" data-ng-bind-html=\"details.cmsData_Fr.expandedDetails.features[0].body\"></span></div></div><div class=\"details-right-column col-lg-4 col-md-4\"><div class=\"details-list-title\"><span show-when=\"en\" data-ng-bind-html=\"details.cmsData_En.expandedDetails.features[1].title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"details.cmsData_Fr.expandedDetails.features[1].title\"></span></div><div class=\"details-body\"><span show-when=\"en\" data-ng-bind-html=\"details.cmsData_En.expandedDetails.features[1].body\"></span> <span show-when=\"fr\" data-ng-bind-html=\"details.cmsData_Fr.expandedDetails.features[1].body\"></span></div></div><div class=\"details-right-column col-lg-4 col-md-4\"><div class=\"details-list-title\"><span show-when=\"en\" data-ng-bind-html=\"details.cmsData_En.expandedDetails.features[2].title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"details.cmsData_Fr.expandedDetails.features[2].title\"></span></div><div class=\"details-body\"><span show-when=\"en\" data-ng-bind-html=\"details.cmsData_En.expandedDetails.features[2].body\"></span> <span show-when=\"fr\" data-ng-bind-html=\"details.cmsData_Fr.expandedDetails.features[2].body\"></span></div></div></div></div><div id=\"bottom-bar\" class=\"col-lg-12 col-md-12\"></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/add-on/add-on.html","<div class=\"addon col-lg-4 col-md-4\" ng-show=\"((addOn.addonInfo.addOnPrice * 1) > 0)\"><h2 class=\"title\"><div><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.title\"></span></div></h2><div class=\"description\" data-ng-show=\"showDescription\"><ul show-when=\"en\"><li ng-repeat=\"feature in addOn.cmsData_En.features\" data-ng-bind-html=\"feature\"></li></ul><ul show-when=\"fr\"><li ng-repeat=\"feature in addOn.cmsData_Fr.features\" data-ng-bind-html=\"feature\"></li></ul></div><div class=\"price-and-button-container\"><div class=\"price-description\"><div class=\"price\"><span show-when=\"en\">$</span> <span class=\"price\">{{ addOn.addonInfo.addOnPrice | dollarsOnly }}</span><div class=\"price-detail\"><sup decimal-comma-value=\"\">{{ addOn.addonInfo.addOnPrice | centsWithDecimal | decimalCommaValueFltr }}</sup> <sub res=\"_month\">res</sub></div><span show-when=\"fr\">$</span></div></div><div class=\"button-container\"><button class=\"addon-action uppercase\" atm=\"wrls:chgplan:addons:rem:{{ addOn.addonInfo.addOnCode }}\" data-ng-class=\"(showDescription) ? \'buy\' : \'buy64\'\" ng-if=\"!addOn.selected\" ng-click=\"select()\" res=\"_select\">res</button> <button class=\"addon-action\" atm=\"wrls:chgplan:addons:includ:{{ addOn.addonInfo.addOnCode }}\" data-ng-class=\"(showDescription) ? \'remove\' : \'remove64\'\" ng-if=\"addOn.selected\" res=\"internet_remove\" ng-click=\"select()\">res</button><div class=\"details-button-container\" data-ng-show=\"showDescription\"><button class=\"addon-action details uppercase\" res=\"wireless_details\">res</button><div class=\"expand-action\" ng-hide=\"addOn.hideDetailsButton\"><subscribing-details-button show-details=\"showDetails\" hide-details=\"hideDetails\" button-id=\"{{ addOn.addonInfo.addOnCode }}\" event-name=\"{{ group + \'-add-on-details-expanded\' }}\" slide-index=\"slideIndex\"></subscribing-details-button></div></div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/add-on/available-add-on-adaptive.html","<div ng-hide-x=\"invisible === true\" class=\"available-add-on-adaptive\"><h2 class=\"title\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.title\"></span></h2><p show-when=\"en\" class=\"description\" ng-repeat=\"feature in addOn.cmsData_En.features\" ng-bind-html=\"feature\"></p><p show-when=\"fr\" class=\"description\" ng-repeat=\"feature in addOn.cmsData_Fr.features\" ng-bind-html=\"feature\"></p><div class=\"price-and-button-container\"><div class=\"price-description\"><div class=\"price\"><span class=\"dollar-sign\">$</span> <span class=\"price\">{{ addOn.addonInfo.addOnPrice | dollarsOnly }}</span><div class=\"price-detail\"><sup decimal-comma-value=\"\">{{ addOn.addonInfo.addOnPrice | centsWithDecimal | decimalCommaValueFltr }}</sup> <sub res=\"_month\">res</sub></div></div></div><div class=\"button-container\"><button class=\"addon-action buy uppercase\" ng-if=\"!addOn.selected\" ng-click=\"select()\" res=\"_select\">res</button> <button class=\"addon-action remove\" ng-if=\"addOn.selected\" ng-click=\"select()\" res=\"internet_remove\">res</button><div class=\"details-button-container\"><button class=\"addon-action details uppercase\" res=\"wireless_details\">res</button><div class=\"expand-action\"><details-button-mobile button-id=\"position\"></details-button-mobile></div></div></div></div><div class=\"mtl available-plan-details available-plan-details-mobile add-on-details add-on-details-collapsed\" ng-class=\"{ \'add-on-details-expanded\' : detailsExpanded }\"><div class=\"wedgie\"></div><div id=\"top-bar\" class=\"col-lg-12 col-md-12\"></div><div class=\"row\"><div class=\"column col-xs-12 pbn\"><div class=\"details-list-title\"><span show-when=\"en\" ng-bind-html=\"addOn.cmsData_En.expandedDetails.title | trustHtml\"></span> <span show-when=\"fr\" ng-bind-html=\"addOn.cmsData_Fr.detailsSectionFr.title | trustHtml\"></span></div><div class=\"body\"><span show-when=\"en\" ng-bind-html=\"addOn.cmsData_En.expandedDetails.body | trustHtml\"></span> <span show-when=\"fr\" ng-bind-html=\"addOn.cmsData_Fr.expandedDetails.body | trustHtml\"></span></div><div class=\"footer\" ng-show=\"addOn.cmsData_En.expandedDetails.footer || addOn.cmsData_Fr.expandedDetails.footer\"><span show-when=\"en\" ng-bind-html=\"addOn.cmsData_En.expandedDetails.footer | trustHtml\"></span> <span show-when=\"fr\" ng-bind-html=\"addOn.cmsData_Fr.expandedDetails.footer | trustHtml\"></span></div></div></div><div class=\"row\"><div class=\"column col-xs-12 pbn\"><div class=\"details-list-title\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.expandedDetails.features[0].title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.features[0].title\"></span></div><div class=\"body\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.expandedDetails.features[0].body\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.expandedDetails.features[0].body\"></span></div></div></div><div class=\"row\"><div class=\"column col-xs-12 pbn\"><div class=\"details-list-title\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.expandedDetails.features[1].title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.expandedDetails.features[1].title\"></span></div><div class=\"body details-space\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.expandedDetails.features[1].body\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.expandedDetails.features[1].body\"></span></div></div></div><div class=\"row\"><div class=\"column col-xs-12 prn\" style=\"padding-right:20px; !important\"><div class=\"details-list-title\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.expandedDetails.features[2].title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.expandedDetails.features[2].title\"></span></div><div class=\"body details-space\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.expandedDetails.features[2].body\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.expandedDetails.features[2].body\"></span></div></div></div><div id=\"bottom-bar\" class=\"col-xs-12\"></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/add-on/available-add-on-details.html","<div id=\"details-box\" class=\"details-box-collapsed details-box-expanded\"><div id=\"wedge-box\"><div id=\"wedgie\"></div></div><div id=\"tongue-tip\"></div><div id=\"tongue-body\"><div class=\"service-heading-expanded rogers-red-font text-uppercase\" res=\"wireless_data\">res</div><div class=\"service-heading-expanded plan-details-font text-uppercase\">4GB</div><div class=\"service-heading-expanded plan-details-font text-uppercase\">Overage Rate: $5/100MB</div><div class=\"service-heading-expanded tongue-break rogers-red-font text-uppercase\" res=\"wireless_talk\">res</div><div class=\"service-heading-expanded plan-details-font tongue-details-row text-uppercase\">Unlimited incoming & outgoing Canada Wide Calling</div><div class=\"service-heading-expanded tongue-break rogers-red-font text-uppercase\" res=\"wireless_text\">res</div><div class=\"service-heading-expanded plan-details-font tongue-details-row text-uppercase\">Unlimited incoming & outgoing Text, Video and Picture Messaging</div><div class=\"service-heading-expanded tongue-break rogers-red-font text-uppercase\" res=\"wireless_features\">res</div><div class=\"service-heading-expanded plan-details-font tongue-details-row text-uppercase\"><span><i class=\"fa fa-circle bullet-small\"></i></span><span>Call Display</span></div><div class=\"service-heading-expanded plan-details-font text-uppercase\"><span><i class=\"fa fa-circle bullet-small\"></i></span><span>Voicemail</span></div><div class=\"service-heading-expanded plan-details-font text-uppercase\"><span><i class=\"fa fa-circle bullet-small\"></i></span><span>Call Waiting</span></div><div class=\"service-heading-expanded plan-details-font text-uppercase\"><span><i class=\"fa fa-circle bullet-small\"></i></span><span>Group Calling</span></div><div class=\"service-heading-expanded plan-details-font text-uppercase\"><span><i class=\"fa fa-circle bullet-small\"></i></span><span>2500 Call Forwarding Minutes</span></div><div class=\"service-heading-expanded tongue-break rogers-red-font text-uppercase\" res=\"wireless_extras\">res</div><div class=\"service-heading-expanded plan-details-font tongue-details-row text-uppercase\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eleifend augue erat, a lacinia purus interdum nec. Mauris nisl neque, maximus et lobortis non, sollicitudin ac felis. Curabitur id rhoncus est. Morbi a dictum magna. Ut in purus feugiat, laoreet ipsum eu, varius lorem.</div><div class=\"service-heading-expanded plan-details-font tongue-details-row text-uppercase\">Vestibulum et felis erat. Proin augue nibh, mattis non est eget, rutrum molestie leo. Mauris hendrerit elit dui, at faucibus metus tincidunt vitae.</div></div><div id=\"tongue-footer\"><div id=\"tongue-close-button\" class=\"pull-right\" ng-click=\"showExpanded = false\"><div id=\"tongue-close-x\">x</div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/add-on/available-add-ons-list-adaptive.html","<div class=\"your-add-ons-adaptive existing-plan-adaptive available-plan-carousel-adaptive\"><div class=\"heading-font add-ons-column plan-details-row mll\"><span res=\"ppc_shop_choose_add_ons\">res</span></div><div class=\"col-sm-1 col-xs-1\"><span id=\"carousel-left-image-container\" class=\"clickable\" data-target=\"#available-{{type}}-add-on-carousel\" data-slide=\"prev\"><img class=\"carousel-arrow-image _left\" src=\"images/left-mobile.png\"></span></div><div class=\"col-sm-10 col-xs-10\"><div id=\"available-{{type}}-add-on-carousel\" class=\"carousel slide\" data-ride=\"carousel\" data-interval=\"false\"><div class=\"carousel-inner\" role=\"listbox\"><div ng-if=\"$first\" class=\"item active mbl\" ng-repeat=\"addOn in filterAddons(addOns, type)\"><available-add-on-adaptive add-on=\"addOn\" add-ons-updated=\"addOnsUpdated\" details-expanded=\"detailsExpanded\" show-details=\"showDetails\" hide-details=\"hideDetails\" position=\"{{$parent.$index}}\"></available-add-on-adaptive></div><div ng-if=\"!$first\" class=\"item mbl\" ng-repeat=\"addOn in filterAddons(addOns, type)\"><available-add-on-adaptive add-on=\"addOn\" add-ons-updated=\"addOnsUpdated\" details-expanded=\"detailsExpanded\" show-details=\"showDetails\" hide-details=\"hideDetails\" position=\"{{$parent.$index}}\"></available-add-on-adaptive></div></div></div></div><div class=\"col-sm-1 col-xs-1 txtR\"><span id=\"carousel-right-image-container\" class=\"clickable\" data-target=\"#available-{{type}}-add-on-carousel\" data-slide=\"next\"><img class=\"carousel-arrow-image _right\" src=\"images/right-mobile.png\"></span></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/add-on/duplicate-add-ons.html","<div ng-show=\"duplicates.length > 0 || dropped.length > 0\" class=\"addon un-needed-addon col-lg-4 col-md-4\"><div class=\"arrow\"></div><h2 class=\"title\" atm=\"wrls:chgplan:addons:includ\"><span res=\"ppc_you_wont_need_addons\">res</span></h2><ul><li ng-repeat=\"dupe in duplicates\"><span show-when=\"en\">{{ dupe.cmsData_En.title }}</span> <span show-when=\"fr\">{{ dupe.cmsData_Fr.title }}</span></li><li ng-repeat=\"drop in dropped\"><span show-when=\"en\">{{ drop.addonInfo.addOnName_En }}</span> <span show-when=\"fr\">{{ drop.addonInfo.addOnName_Fr }}</span></li></ul></div>");
$templateCache.put("scripts/directives/pricePlanChanges/add-on/your-add-ons-adaptive.html","<div id=\"viewable-add-ons\" class=\"add-ons-column\" ng-class=\"{ \'pbn\': !yourAddOnsExpanded}\"><div><div class=\"plan-details-font add-ons-row bold-line\"><span><i class=\"fa fa-circle bullet-small\"></i></span> <span>{{ addOn.cmsData_En.title }}</span></div><div ng-show=\"yourAddOnsExpanded\" class=\"plan-details-font add-ons-row plm\"><span>(<span res=\"ppc_add_ons_lower_single\">res</span> <span show-when=\"en\">$</span><span decimal-comma-value=\"\">{{ addOn.addonInfo.addOnPrice | number: 2 | decimalCommaValueFltr }}</span><span show-when=\"fr\">$</span> /<span res=\"ppc_shop_change_plan_month_abbreviation\">res</span>)</span> <span class=\"rogers-red-font pull-right uppercase\" res=\"internet_remove\" ng-show=\"addOn.selected\" ng-click=\"addOn.selected = false; addOnsUpdated();\">res</span> <span class=\"pull-right uppercase\" res=\"_select\" ng-hide=\"addOn.selected\" ng-click=\"addOn.selected = true; addOnsUpdated();\">res</span></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/add-on/your-add-ons-duplicates-adaptive.html","<div class=\"your-add-ons-collapsed add-ons-column-x\" ng-class=\"{\'your-add-ons-expanded\': yourAddOnsExpanded }\" ng-init=\"yourAddOnsExpanded = true\"><div class=\"hr\" ng-show=\"false\"></div><div class=\"plan-details-font add-ons-row bold-line\"><span res=\"ppc_your_un-needed_add_ons\">res</span>:</div><div id=\"un-needed-add-ons\"><ul class=\"plan-content-column plm\"><li ng-repeat=\"dupe in duplicates\"><span show-when=\"en\">{{ dupe.cmsData_En.title }}</span> <span show-when=\"fr\">{{ dupe.cmsData_Fr.title }}</span></li><li ng-repeat=\"drop in dropped\"><span show-when=\"en\">{{ drop.addonInfo.addOnName_En }}</span> <span show-when=\"fr\">{{ drop.addonInfo.addOnName_Fr }}</span></li></ul></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/available-plan/available-plan-adaptive.html","<div class=\"available-plan-adaptive existing-plan-adaptive\"><div class=\"info-box info-box-default\" ng-class=\"{ \'info-box-recommended\' : plan.targetPlanInd == 1, \'info-box-exclusive\' : plan.targetPlanInd == 2 }\"><span ng-show=\"plan.targetPlanInd == 1\" res=\"_recommended\"></span> <span ng-show=\"plan.targetPlanInd == 2\" res=\"_exclusive\"></span><div class=\"plan-tab-adaptive\"><span show-when=\"en\" data-ng-bind-html=\"plan.cmsData_En.categoryName2_En\"></span> <span show-when=\"fr\" data-ng-bind-html=\"plan.cmsData_Fr.categoryName2_Fr\"></span></div></div><div id=\"header-box\" class=\"round-3 plan-details-font\"><div id=\"header-box-plan-name\" class=\"col-sm-7 col-xs-7\"><span show-when=\"en\" data-ng-bind-html=\"plan.cmsData_En.categoryName_En\"></span> <span show-when=\"fr\" data-ng-bind-html=\"plan.cmsData_Fr.categoryName_Fr\"></span></div><div id=\"header-box-cost-box\" class=\"col-sm-5 col-xs-5 rogers-red-font\"><div class=\"float-right\"><span class=\"header-dolla\" show-when=\"en\">$</span> <span id=\"header-cost\">{{ plan.planInfo.planPrice }}</span> <span class=\"header-dolla\" show-when=\"fr\">$</span> <span id=\"header-month\">/<span res=\"ppc_shop_change_plan_month_abbreviation\">res</span>&#177;</span></div></div></div><div id=\"body-box\"><div id=\"body-box-columns\" class=\"plan-column-height _dt\"><div class=\"_dtr\"><div id=\"data-column\" class=\"plan-column-height light-grey-background _dtc\"><div class=\"service-column service-heading\"><span class=\"text-uppercase\" res=\"wireless_data\">res</span> <sup>1</sup></div><div class=\"rogers-red-font service-column heading-font pbn\"><span class=\"plan-details-font plan-details-row\">{{ plan.planInfo.includedDataMax | mbOrGbValue }}</span> <span class=\"plan-details-font plan-details-row\" show-when=\"en\">{{ plan.planInfo.includedDataMax | mbOrGbValueStr }}</span> <span class=\"plan-details-font plan-details-row\" show-when=\"fr\">{{ plan.planInfo.includedDataMax | mbOrGbValueStr }}</span></div><div class=\"service-column plan-details-font overage_rate\" ng-show=\"plan.planInfo.includedDataMax !== \'Not Applicable\'\"><span res=\"ppc_overage_rate\">res</span> <span class=\"plan-content-column mln\" show-when=\"en\">{{ plan.planInfo.overageRate }}</span> <span class=\"plan-content-column mln\" show-when=\"fr\">{{ overageFr(plan.planInfo.overageRate) }}</span><span show-when=\"fr\"></span></div></div><div id=\"talk-column\" class=\"plan-column-height light-grey-background _dtc\"><div class=\"service-heading service-column text-uppercase\" res=\"wireless_talk\">res</div><div class=\"service-column plan-details-font\"><div show-when=\"en\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_En.includedMinutes\" data-ng-bind-html=\"string\"></div><div show-when=\"fr\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_Fr.includedMinutes\" data-ng-bind-html=\"string\"></div></div></div><div id=\"text-column\" class=\"plan-column-height light-grey-background _dtc\"><div class=\"service-heading service-column text-uppercase\" res=\"wireless_text\">res</div><div class=\"service-column plan-details-font\"><div show-when=\"en\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_En.includedMessages\" data-ng-bind-html=\"string\"></div><div show-when=\"fr\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_Fr.includedMessages\" data-ng-bind-html=\"string\"></div></div></div></div></div><div id=\"included-box\" class=\"light-grey-background pbm\" ng-show=\"isShareable\"><div class=\"service-heading service-column service-heading text-uppercase pbs\" res=\"ppc_extras\">res</div><div class=\"_fw included-images\"><div class=\"mbm\"><img show-when=\"en\" class=\"mrm mtm\" src=\"images/RGCL-logo-EN_lg.png\" width=\"145\"> <img show-when=\"en\" class=\"mtm\" src=\"images/RoamON-EN-HD.png\" ng-src=\"images/RoamON-EN-HD.png\" width=\"95\"> <img show-when=\"fr\" class=\"mrm mtm\" src=\"images/RGCL-logo-FR_lg.png\" width=\"95\"> <img show-when=\"fr\" class=\"mtm\" src=\"images/RoamON-FR-HD.png\" ng-src=\"images/RoamON-FR-HD.png\" width=\"145\"></div></div></div><div id=\"extra-box\" class=\"light-grey-background pbm\" ng-show=\"isShareable && isSharePlus\"><div class=\"service-heading service-column service-heading text-uppercase pbs\" res=\"ppc_one_following\">res</div><div class=\"_fw included-images\"><div class=\"mbm\"><img src=\"images/value-added-offers/mb-spotify-logo.png\" width=\"85\"> <img src=\"images/value-added-offers/mb-shomi-logo-trans.png\" width=\"80\"> <img src=\"images/value-added-offers/mb-nextissue-logo-trans.png\" width=\"100\"></div></div></div><div id=\"plan-footer\" ng-init=\"showExpanded = false\"><div id=\"details\"><div class=\"pull-left button-padding text-uppercase\"><span res=\"wireless_details\">res</span></div><div class=\"pull-right button-padding\"><div class=\"abs-pos\"><div class=\"grey-box clickable\" ng-click=\"showExpanded = !showExpanded\"><div ng-hide=\"showExpanded\">+</div><div id=\"expand-sign-minus\" ng-show=\"showExpanded\"></div></div></div></div></div><div id=\"select\" class=\"select-remove-button\" atm=\"wrls:chgplan:plan:sel:{{plan.planInfo.planCode}}\" ng-click=\"selectPlan(plan.planInfo.planCode); plan.isSelected = !plan.isSelected; closeDetails(); doSelect();\" ng-hide=\"plan.isSelected\"><div class=\"button-padding text-uppercase\"><span res=\"_select\">res</span></div></div><div id=\"remove\" class=\"select-remove-button\" ng-click=\"confirmUndo()\" ng-show=\"plan.isSelected\"><div class=\"button-padding text-uppercase\"><span res=\"internet_remove\">res</span></div></div></div></div><div id=\"details-box\" class=\"details-box-collapsed\" ng-class=\"{ \'details-box-expanded\': showExpanded }\"><div id=\"wedge-box\"><div id=\"wedgie\"></div></div><div id=\"tongue-tip\"></div><div id=\"tongue-body\"><div class=\"service-heading-expanded rogers-red-font text-uppercase\" res=\"wireless_data\">res</div><div class=\"service-heading-expanded plan-details-font text-uppercase\"><span class=\"rogers-red-fontX plan-details-font plan-details-row\">{{ plan.planInfo.includedDataMax | mbOrGbValue }}</span> <span class=\"rogers-red-fontX plan-details-font plan-details-row\" show-when=\"en\">{{ plan.planInfo.includedDataMax | mbOrGbValueStr }}</span> <span class=\"rogers-red-fontX plan-details-font plan-details-row\" show-when=\"fr\">{{ plan.planInfo.includedDataMax | mbOrGbValueStr }}</span><div class=\"overage_rate\" ng-show=\"plan.planInfo.includedDataMax !== \'Not Applicable\'\"><span res=\"ppc_overage_rate\">res</span> <span class=\"plan-content-column mln\" show-when=\"en\">{{ plan.planInfo.overageRate }}</span> <span class=\"plan-content-column mln\" show-when=\"fr\">{{ overageFr(plan.planInfo.overageRate) }}</span></div></div><div class=\"service-heading-expanded tongue-break rogers-red-font text-uppercase\" res=\"wireless_talk\">res</div><div class=\"service-heading-expanded plan-details-font tongue-details-row text-uppercase rogers-red-font-remove\"><div show-when=\"en\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_En.includedMinutes\" data-ng-bind-html=\"string\"></div><div show-when=\"fr\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_Fr.includedMinutes\" data-ng-bind-html=\"string\"></div></div><div class=\"service-heading-expanded tongue-break rogers-red-font text-uppercase\" res=\"wireless_text\">res</div><div class=\"service-heading-expanded plan-details-font tongue-details-row text-uppercase rogers-red-font-remove\"><div show-when=\"en\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_En.includedMessages\" data-ng-bind-html=\"string\"></div><div show-when=\"fr\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_Fr.includedMessages\" data-ng-bind-html=\"string\"></div></div><div class=\"service-heading-expanded tongue-break rogers-red-font text-uppercase\" res=\"wireless_features\">res</div><div class=\"mtm\"><ul show-when=\"en\" class=\"plan-content-column plm\"><li ng-repeat=\"featureItem in plan.cmsData_En.planFeatures\" data-ng-bind-html=\"featureItem\"></li></ul><ul show-when=\"fr\" class=\"plan-content-column plm\"><li ng-repeat=\"featureItem in plan.cmsData_Fr.planFeatures\" data-ng-bind-html=\"featureItem\"></li></ul></div><div ng-show=\"isShareable\"><div class=\"service-heading-expanded tongue-break rogers-red-font text-uppercase\" res=\"ppc_extras\">res</div><div class=\"float-left mbm\"><img show-when=\"en\" class=\"mrm mtm\" src=\"images/RGCL-logo-EN_lg.png\" width=\"145\"> <img show-when=\"fr\" class=\"mrm mtm\" src=\"images/RGCL-logo-FR_lg.png\" width=\"95\"><img show-when=\"en\" class=\"mtm\" src=\"images/RoamON-EN-HD.png\" ng-src=\"images/RoamON-EN-HD.png\" width=\"95\"> <img show-when=\"fr\" class=\"mtm\" src=\"images/RoamON-FR-HD.png\" ng-src=\"images/RoamON-FR-HD.png\" width=\"145\"></div><div class=\"clearfix\"></div></div></div><div id=\"tongue-footer\"><div id=\"tongue-close-button\" class=\"pull-right\" ng-click=\"showExpanded = false\"><div id=\"tongue-close-x\">x</div></div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/available-plan/available-plan-details.html","<div class=\"available-plan-details available-plan-details-collapsed\" ng-class=\"{ \'available-plan-details-expanded\' : expanded }\"><div class=\"wedgie\" ng-class=\"{ \'wedgie-0\' : slideIndex === \'0\', \'wedgie-1\' : slideIndex === \'1\', \'wedgie-2\' : slideIndex === \'2\'}\"></div><div id=\"top-bar\"></div><div id=\"plan-body\"><div class=\"col-md-6 col-md-6\" style1=\"background-color: blue;\"><div class=\"title\"><span res=\"ppc_shop_all_plans_include\">res</span><span>:</span></div><div id=\"icons\"><div class=\"col-md-3 col-md-3\"><div class=\"icon-row\"><div class=\"icon-box\" ng-init=\"showPhonePopUp = false;\"><img ng-mouseenter=\"showPhonePopUp = true;\" src=\"images/phone.png\"></div></div><div><span data-ng-bind-html=\"unlimitedWideCanadaText\"></span></div></div><div class=\"col-md-3 col-md-3\"><div class=\"icon-row\"><div class=\"icon-box\" ng-init=\"showMessagePopUp = false;\"><img ng-mouseenter=\"showMessagePopUp = true;\" src=\"images/messages.png\"></div></div><div><span res=\"ppc_shop_all_unlimited_messaging\">res</span><span><sup>3</sup></span></div></div><div class=\"col-md-3 col-md-3\"><div class=\"icon-row\"><div class=\"icon-box\" ng-init=\"showCallDisplayPopUp = false;\"><img ng-mouseenter=\"showCallDisplayPopUp = true;\" src=\"images/call-display.png\"></div></div><div><span res=\"ppc_shop_all_call_display\">res</span><span><sup>4</sup></span></div></div><div class=\"col-md-3 col-md-3\"><div class=\"icon-row\"><div class=\"icon-box\" ng-init=\"showVoicemailPopUp = false;\"><img ng-mouseenter=\"showVoicemailPopUp = true;\" id=\"voicemail\" src=\"images/voicemail.png\"></div></div><div><span res=\"ppc_shop_all_voicemail\">res</span><span><sup>5</sup></span></div></div></div><div><div id=\"plus-body\" style=\"position: relative;\"><div id=\"plus-bubble\"><div res=\"_plus\">res</div></div><ul><li><span res=\"ppc_shop_call_waiting\" ng-mouseenter=\"showCallWaiting = true;\">res</span> <span res=\"ppc_shop_group_calling\" ng-mouseenter=\"showGroupCalling = true;\">res</span> <sup>6</sup><div class=\"available-plan-details-pop-up-bubble\" ng-mouseleave=\"showCallWaiting = false;\" ng-show=\"showCallWaiting\"><span res=\"ppc_popup_call_waiting\">res</span></div><div class=\"available-plan-details-pop-up-bubble\" ng-mouseleave=\"showGroupCalling = false;\" ng-show=\"showGroupCalling\"><span res=\"ppc_popup_group_calling\">res</span></div></li><li><span ng-mouseenter=\"showCallForwardMins = true;\" ng-mouseleave=\"showCallForwardMins = false;\" res=\"ppc_shop_2500_call_forward_mins\">res</span><sup>7</sup><div class=\"available-plan-details-pop-up-bubble\" ng-mouseleave=\"showCallForwardMins = false;\" ng-show=\"showCallForwardMins\"><span res=\"ppc_popup_callForwardMins\">res</span></div></li></ul></div></div></div><div class=\"col-md-6 col-md-6\" style1=\"background-color: green;\" data-ng-show=\"isShareable\"><div class=\"title\"><span res=\"ppc_shop_all_extras_included\">res</span><span>:</span></div><div class=\"col-md-6 col-md-6\"><div class=\"extra-image\" ng-mouseenter=\"showRGCLBubble = true;\"><img show-when=\"en\" src=\"images/RGCL-logo-EN_lg.png\" width=\"110\"> <img show-when=\"fr\" src=\"images/RGCL-logo-FR_lg.png\" width=\"70\"></div><div class=\"available-plan-extra-details-pop-up-bubble\" ng-mouseleave=\"showRGCLBubble = false;\" ng-show=\"showRGCLBubble\"><span res=\"ppc_popup_gamecenter\">res</span></div></div><div class=\"col-md-6 col-md-6\"><div class=\"extra-image\" ng-mouseenter=\"showRoamBubble = true;\"><img show-when=\"en\" src=\"images/RoamON-EN-HD.png\" width=\"75\"> <img show-when=\"fr\" src=\"images/RoamON-FR-HD.png\" width=\"120\"></div><div class=\"available-plan-extra-details-pop-up-bubble\" ng-mouseleave=\"showRoamBubble = false;\" ng-show=\"showRoamBubble\"><span res=\"ppc_popup_roam\">res</span></div></div><div class=\"col-md-12 share-plus-details\" data-ng-show=\"isSharePlus\" style=\"margin-top:10px;\"><div class=\"title\" res=\"ppc_share_plus_text\" style=\"margin-top:20px !important; margin-bottom:15px !important;\"></div><img src=\"images/value-added-offers/mb-spotify-logo.png\" width=\"100\"> <img src=\"images/value-added-offers/mb-shomi-logo.png\" width=\"90\"> <img src=\"images/value-added-offers/next_issue_2line.png\" width=\"110\"></div></div></div><div id=\"bottom-bar\"><div id=\"tongue-close-button\" class=\"pull-right clickable\" ng-click=\"closeDetails(expandedPlan)\"><div id=\"tongue-close-x\">x</div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/available-plan/available-plan.html","<div class=\"available-plan\"><div class=\"plan-header\" ng-class=\"{ \'default-plan-header\': true, \'recommended-plan-header\' : plan.targetPlanInd == 1, \'exclusive-plan-header\' : plan.targetPlanInd == 2 }\" data-plan-align-row=\"6\"><div class=\"plan-type-bubble pull-right\" ng-show=\"plan.targetPlanInd == 1 || plan.targetPlanInd == 2\" ng-class=\"{\'recommended-bubble-color\' : plan.targetPlanInd == 1, \'exclusive-bubble-color \' : plan.targetPlanInd == 2 }\"><span ng-show=\"plan.targetPlanInd == 1\" res=\"_recommended\"></span> <span ng-show=\"plan.targetPlanInd == 2\" res=\"_exclusive\"></span></div><div class=\"title text-center\"><span show-when=\"en\" data-ng-bind-html=\"plan.cmsData_En.categoryName_En\"></span> <span show-when=\"fr\" data-ng-bind-html=\"plan.cmsData_Fr.categoryName_Fr\"></span> <i class=\"fa fa-exclamation-circle fa-sm text-exclusive-adaptive clickable\" ng-click=\"toggleHeaderInfo(plan)\" ng-show=\"plan.targetPlanInd == 1 || plan.targetPlanInd == 2\"></i></div></div><div class=\"plan-body\" style=\"\"><div class=\"label-overlay col-sm-12 exclusive-plan-heading\" ng-show=\"plan.displayHeaderInfo\"><div class=\"row\"><span class=\"info-close clickable pull-right\" ng-click=\"toggleHeaderInfo(plan)\">X</span></div><div class=\"row label-overlay-detail\" ng-show=\"plan.targetPlanInd == 1\"><span res=\"ppc_recommended_header_info\">ppc_recommended_header_info</span></div><div class=\"row label-overlay-detail\" ng-show=\"plan.targetPlanInd == 2\"><span res=\"ppc_exclusive_header_info\">ppc_exclusive_header_info</span></div></div><div class=\"plan-tab\"><span show-when=\"en\" data-ng-bind-html=\"plan.cmsData_En.categoryName2_En\"></span> <span show-when=\"fr\" data-ng-bind-html=\"plan.cmsData_Fr.categoryName2_Fr\"></span></div><div class=\"price-panel\"><div class=\"price-line text-center\"><span show-when=\"en\" class=\"plan-price-dollar-sign\">$</span> <span class=\"plan-price\" decimal-comma-value=\"\">{{ plan.planInfo.planPrice | decimalCommaValueFltr }}</span> <span show-when=\"fr\" class=\"plan-price-dollar-sign\">$</span> <span class=\"plan-price-unit\">/</span> <span class=\"plan-price-unit\" res=\"ppc_shop_change_plan_month_abbreviation\">res</span> <span class=\"plan-price-unit\">&#177;</span></div><div class=\"trailing-line plan-content-column\"></div></div><div class=\"data-plan-align-row-1\" data-plan-align-row=\"1\"><div class=\"_dib mtm mv22\"><span res=\"wireless_data\" class=\"heading-font plan-content-column mhn\">res</span><sup>1</sup><br><span class=\"plan-content-column data-capacity-font mln rogers-red-font\"><span class=\"plan-details-font plan-details-row\">{{ plan.planInfo.includedDataMax | mbOrGbValueStr }}</span></span><div class=\"overage_rate\" ng-show=\"plan.planInfo.includedDataMax !== \'Not Applicable\'\"><span res=\"ppc_overage_rate\">res</span> <span class=\"plan-content-column mln\" show-when=\"en\">{{ plan.planInfo.overageRate }}</span> <span class=\"plan-content-column mln\" show-when=\"fr\">{{ overageFr(plan.planInfo.overageRate) }}</span></div></div></div><div class=\"trailing-line plan-content-column margin-top-large\"></div><div class=\"data-plan-align-row-2\" data-plan-align-row=\"2\"><div res=\"wireless_talk\" class=\"heading-font plan-content-column text-uppercaseX\">res</div><div show-when=\"en\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_En.includedMinutes\" data-ng-bind-html=\"string\"></div><div show-when=\"fr\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_Fr.includedMinutes\" data-ng-bind-html=\"string\"></div></div><div class=\"trailing-line plan-content-column margin-top-large\"></div><div class=\"data-plan-align-row-3\" data-plan-align-row=\"3\"><div res=\"wireless_text\" class=\"heading-font plan-content-column text-uppercaseX\">res</div><div show-when=\"en\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_En.includedMessages\" data-ng-bind-html=\"string\"></div><div show-when=\"fr\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_Fr.includedMessages\" data-ng-bind-html=\"string\"></div></div><div class=\"trailing-line plan-content-column margin-top-large\"></div><div class=\"data-plan-align-row-4\" data-plan-align-row=\"4\"><div res=\"wireless_features\" class=\"heading-font plan-content-column text-uppercaseX\">res</div><ul show-when=\"en\" class=\"plan-content-column\"><li ng-repeat=\"featureItem in plan.cmsData_En.planFeatures\" data-ng-bind-html=\"featureItem\"></li></ul><ul show-when=\"fr\" class=\"plan-content-column\"><li ng-repeat=\"featureItem in plan.cmsData_Fr.planFeatures\" data-ng-bind-html=\"featureItem\"></li></ul></div><div class=\"trailing-line plan-content-column mtl\"></div><div class=\"data-plan-align-row-5\" data-plan-align-row=\"5\" style=\"height: 310px; margin-top: 25px;\"><div id=\"included-title-container\" class=\"plan-content-column\" style=\"margin-top: 0;\" ng-show=\"isShareable\"><div res=\"ppc_extras\" class=\"heading-font\" style=\"margin-top: 0;\">res</div><div ng-show=\"isShareable\"><div><img show-when=\"en\" src=\"images/RGCL-logo-EN_lg.png\" width=\"110\"> <img show-when=\"fr\" src=\"images/RGCL-logo-FR_lg.png\" width=\"70\"></div><div><img show-when=\"en\" ng-src=\"images/RoamON-EN-HD.png\" ng-class=\"{\'mtm\': true}\" width=\"75\"> <img show-when=\"fr\" ng-src=\"images/RoamON-FR-HD.png\" ng-class=\"{\'mtm\': true}\" width=\"120\"></div></div><div ng-show=\"isSharePlus\" class=\"sharePlus\"><div res=\"ppc_one_following\" class=\"heading-font\" style=\"margin-bottom: 12px;\"></div><div><img src=\"images/value-added-offers/mb-spotify-logo.png\" width=\"85\"></div><div><img src=\"images/value-added-offers/mb-shomi-logo.png\" width=\"80\"></div><div><img src=\"images/value-added-offers/mb-nextissue-logo.png\" width=\"100\"></div></div></div></div></div><div class=\"plan-footer\"><div style=\"position: relative;\"><div ng-show=\"plan.isSelected\" res=\"internet_remove\" class=\"pull-right plan-select-button text-uppercase clickable\" ng-click=\"removePlan();doSelect(false)\">res</div><div ng-hide=\"plan.isSelected\" res=\"_select\" atm=\"wrls:chgplan:plan:sel:{{plan.planInfo.planCode}}\" class=\"pull-right plan-selected-indicator text-uppercase clickable\" ng-click=\"selectPlan(plan.planInfo.planCode); doSelect(true, plan.planInfo.planCode);\">res</div><div class=\"pull-left plan-remove-button text-uppercase pop-bottom\"><div class=\"pull-right\"><subscribing-details-button show-details=\"showDetails\" hide-details=\"hideDetails\" button-id=\"{{ plan.planInfo.planCode }}\" event-name=\"available-plan-details-expanded\" slide-index=\"slideIndex\"></subscribing-details-button></div><div class=\"pull-right details-caption\" res=\"wireless_details\">res</div></div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/available-plan/available-plan.orig.html","<div class=\"available-plan\"><div class=\"plan-header\" ng-class=\"{ \'default-plan-header\' : true, \'recommended-plan-header\' : plan.recommendedPlanInd === \'YES\' }\"><div class=\"plan-type-bubble pull-right\" ng-class=\"{ \'recommended-bubble-color\' : plan.recommendedPlanInd === \'YES\' }\" ng-show=\"plan.recommendedPlanInd === \'YES\'\"><span res=\"_recommended\"></span><div ng-mouseenter=\"popUpBubbles.showPlanPopUp(slideIndex)\" class=\"i-box pull-right\">i</div></div><div class=\"title text-center\"><span show-when=\"en\">{{ plan.cmsData_En.planTitle }}</span> <span show-when=\"fr\">{{ plan.cmsData_Fr.planTitle }}</span></div></div><div class=\"plan-body\" style=\"\"><div class=\"price-panel\"><div class=\"price-line text-center\"><span show-when=\"en\" class=\"plan-price-dollar-sign\">$</span> <span class=\"plan-price\" decimal-comma-value=\"\">{{ plan.planInfo.planPrice }}</span> <span show-when=\"fr\" class=\"plan-price-dollar-sign\">$</span> <span class=\"plan-price-unit\">/</span> <span class=\"plan-price-unit\" res=\"ppc_shop_change_plan_month_abbreviation\">res</span></div><div class=\"trailing-line plan-content-column\"></div></div><div data-plan-align-row=\"1\"><div res=\"wireless_data\" class=\"heading-font plan-content-column text-uppercase\">res</div><div class=\"plan-content-column rogers-red-font\"><span class=\"\">{{ plan.planInfo.includedDataMax | mbOrGbValue }}</span> <span show-when=\"en\">{{ plan.planInfo.includedDataMax | mbOrGbUnit:\'en\' }}</span> <span show-when=\"fr\">{{ plan.planInfo.includedDataMax | mbOrGbUnit:\'fr\' }}</span></div><div class=\"plan-content-column data-capacity-font rogers-red-font\">{{ plan.planInfo.overageRate }}</div><div class=\"trailing-line plan-content-column margin-top-large\"></div></div><div data-plan-align-row=\"2\"><div res=\"wireless_talk\" class=\"heading-font plan-content-column text-uppercase\">res</div><div show-when=\"en\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_En.includedMinutes\">{{ string }}</div><div show-when=\"fr\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_Fr.includedMinutes\">{{ string }}</div></div><div class=\"trailing-line plan-content-column margin-top-large\"></div><div data-plan-align-row=\"3\"><div res=\"wireless_text\" class=\"heading-font plan-content-column text-uppercase\">res</div><div show-when=\"en\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_En.includedMessages\">{{ string }}</div><div show-when=\"fr\" class=\"plan-content-column\" ng-repeat=\"string in plan.cmsData_Fr.includedMessages\">{{ string }}</div></div><div class=\"trailing-line plan-content-column margin-top-large\"></div><div data-plan-align-row=\"4\"><div res=\"wireless_features\" class=\"heading-font plan-content-column text-uppercase\">res</div><ul show-when=\"en\" class=\"plan-content-column\"><li ng-repeat=\"featureItem in plan.cmsData_En.planFeatures\">{{ featureItem }}</li></ul><ul show-when=\"fr\" class=\"plan-content-column\"><li ng-repeat=\"featureItem in plan.cmsData_Fr.planFeatures\">{{ featureItem }}</li></ul></div><div class=\"trailing-line plan-content-column\"></div><div data-plan-align-row=\"5\"><div id=\"included-title-container\" class=\"plan-content-column\"><div res=\"wireless_extras\" class=\"heading-font text-uppercase\">res</div><div><div show-when=\"en\" ng-repeat=\"includedItem in plan.cmsData_En.includedExtras\"><img ng-src=\"{{ includedItem.imageUrl }}\" width=\"180\"></div><div show-when=\"fr\" ng-repeat=\"includedItem in plan.cmsData_Fr.includedExtras\"><img ng-src=\"{{ includedItem.imageUrl }}\" width=\"180\"></div></div></div></div></div><div class=\"plan-footer\"><div style=\"position: relative;\"><div ng-show=\"isSelected\" res=\"internet_remove\" class=\"pull-left plan-select-button text-uppercase clickable\" ng-click=\"removePlan(); doSelect(false);\">res</div><div ng-hide=\"isSelected\" res=\"_select\" class=\"pull-left plan-selected-indicator text-uppercase clickable\" ng-click=\"selectPlan(plan.planInfo.planCode); doSelect(true, plan.planInfo.planCode);\">res</div><div class=\"pull-right plan-remove-button text-uppercase pop-bottom\"><div class=\"pull-right\"><subscribing-details-button show-details=\"showDetails\" hide-details=\"hideDetails\" button-id=\"{{ plan.planInfo.planCode }}\" event-name=\"available-plan-details-expanded\" slide-index=\"slideIndex\"></subscribing-details-button></div><div class=\"pull-right details-caption\" res=\"wireless_details\">res</div></div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/carousel/price-plans-carousel-adaptive.html","<div id=\"carousel-container-adaptive\" class=\"row available-plan-carousel-adaptive\"><div class=\"col-xs-1\"><span id=\"carousel-left-image-container\" class=\"clickable\" data-target=\"#myCarousel-adaptive\" ng-show=\"showArrow()\" data-slide=\"prev\"><img class=\"carousel-arrow-image\" src=\"images/left-mobile.png\" width=\"45\"></span></div><div class=\"col-xs-10\"><div id=\"myCarousel-adaptive\" class=\"carousel carousel-adaptive slide\" data-ride=\"carousel\" data-interval=\"false\"><div class=\"carousel-inner\" role=\"listbox\"><div ng-if=\"$first\" class=\"item active\" ng-repeat=\"plan in plans\"><available-plan-adaptive plan=\"plan\" select-plan=\"selectPlan\" remove-plan=\"removePlan\"></available-plan-adaptive></div><div ng-if=\"!$first\" class=\"item\" ng-repeat=\"plan in plans\"><available-plan-adaptive plan=\"plan\" select-plan=\"selectPlan\" remove-plan=\"removePlan\"></available-plan-adaptive></div></div></div></div><div class=\"col-xs-1 text-right\"><span id=\"carousel-right-image-container\" class=\"clickable\" data-target=\"#myCarousel-adaptive\" ng-show=\"showArrow()\" data-slide=\"next\"><img class=\"carousel-arrow-image\" src=\"images/right-mobile.png\" width=\"45\"></span></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/carousel/price-plans-carousel-dots.html","<div class=\"_fw carousel-dots-group\"><div class=\"_dib carousel-dots-container\"><i class=\"fa fa-circle carousel-dots-dot mlm\" data-dot=\"@@\"></i></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/carousel/price-plans-carousel-page-indicator.html","<div class=\"price-plans-carousel-page-indicator\"><div ng-repeat=\"plan in plans\" class=\"price-plan-carousel-circle\" ng-click=\"setPage($index)\" ng-class=\"{ \'price-plan-carousel-circle-active\': isCurrentPage($index)}\"></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/carousel/price-plans-carousel.html","<div id=\"carousel-container\" class=\"available-plan-carousel\"><span class=\"carousel-left-image-container clickable\" data-target=\"#myCarousel\" data-slide=\"prev\"><img class=\"carousel-arrow-image\" src=\"images/carousel-left-button.png\" ng-show=\"showArrow()\" ng-click=\"closeDetails()\"></span><span class=\"carousel-right-image-container pull-right clickable\" data-target=\"#myCarousel\" data-slide=\"next\"><img class=\"carousel-arrow-image\" src=\"images/carousel-right-button.png\" ng-show=\"showArrow()\" ng-click=\"closeDetails()\"></span><div id=\"myCarousel\" class=\"carousel slide\" data-ride=\"carousel\" data-interval=\"false\" data-ng-hide=\"$parent.plansLoading\"><div class=\"carousel-inner\" role=\"listbox\"><div class=\"item\" ng-class=\"{\'active\': $first === true}\" ng-repeat=\"page in plans\"><div class=\"slide-column\" ng-repeat=\"plan in page\"><available-plan plan=\"plan\" plans-length=\"plansLength\" show-details=\"showDetails\" hide-details=\"hideDetails\" select-plan=\"selectPlan\" remove-plan=\"removePlan\" slide-index=\"{{ $index }}\"></available-plan></div></div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/cart-summary/add-ons-list-adaptive.html","<div class=\"add-ons-list-adaptive confirm-order\" ng-show=\"addOns.length\"><div class=\"sub-title rogers-red-font\" res=\"_add_ons\">res</div><div class=\"sub-section mbl\" ng-repeat=\"addOn in addOns\"><div class=\"_fw\"><div class=\"left-col pull-left\" ng-class=\"{\'mts\': !$first}\"><span show-when=\"en\" ng-bind-html=\"addOn.cmsData_En.title\"></span> <span show-when=\"fr\" ng-bind-html=\"addOn.cmsData_Fr.title\"></span></div><div class=\"right-col pull-right\" ng-class=\"{\'mts\': !$first}\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ addOn.addonInfo.addOnPrice | number:2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div><div class=\"clearfix\"></div></div><div class=\"_fw\"><div class=\"bonus-body\" ng-show=\"addOn.addonInfo.addOnCode == \'VPKSRA0M3\' || addOn.addonInfo.addOnCode == \'VPKSRA0M\'\"><div class=\"bonus-bubble\"><div class=\"bonus-bubble-text\" res=\"bonus\">res</div></div><ul><li res=\"bonus_text\">res</li></ul></div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/cart-summary/add-ons-list.html","<div class=\"row margin-bottom-md\" ng-repeat=\"addOn in addOns\"><div class=\"col-lg-8 col-md-8\"><div class=\"col-lg-7 col-md-7\"><div class=\"pull-left your-order-column heading-font\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.title\"></span></div><div class=\"clickable pull-left add-on-edit\" ng-show=\"editBtn\" ng-click=\"onEditClick()\"><div class=\"float-left view-add-on-details\" res=\"paynow_edit\">res</div><div class=\"details-triangle float-left details-triangle-edit-plan-fix\"></div></div><div class=\"clear legal-fine-print mbl\" res=\"checkout_confirm_month_month_service\">res</div></div><div class=\"col-lg-5 col-md-5\"><div class=\"bonus-body\" ng-show=\"addOn.addonInfo.addOnCode == \'VPKSRA0M3\' || addOn.addonInfo.addOnCode == \'VPKSRA0M\'\"><div class=\"bonus-bubble\"><div class=\"bonus-bubble-text\" res=\"bonus\">Plus</div></div><ul><li res=\"bonus_text\"></li></ul></div></div></div><div class=\"col-lg-2 col-md-2\"></div><div class=\"col-lg-2 col-md-2\"><div class=\"your-order-column sub-heading-font\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ addOn.addonInfo.addOnPrice | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div></div><row-hr></row-hr></div>");
$templateCache.put("scripts/directives/pricePlanChanges/cart-summary/cart-summary-adaptive.html","<div class=\"cart-summary-adaptive cart-summary\" ng-init=\"cartSummaryExpanded = false\"><div id=\"closed-view\" ng-hide=\"cartSummaryExpanded\"><div class=\"margins\"><div id=\"total-summary-box\" class=\"pull-left\" ng-click=\"cartSummaryExpanded = !cartSummaryExpanded\"><div id=\"black-strip\"></div><div id=\"red-body\"><div id=\"total-summary\" class=\"centered-text\"><span res=\"ppc_shop_cart_summary_total\">res</span></div><div id=\"open-icon\" class=\"centered-text\"><img class=\"red-box-arrow rotate-180 mtl\" src=\"images/summary-up-arrow.png\" width=\"18\"></div></div><div id=\"wedge\"></div></div><div id=\"cost-box\" class=\"pull-right round-3\"><div class=\"centered-text1\"><span show-when=\"en\" id=\"dollar-sign\">$</span> <span id=\"dollar-amount\">{{ ((totalCost % 1 == 0) ? totalCost : totalCost - 1) | number: 0 }}</span><span id=\"decimal-amount\"><sup show-when=\"en\">{{ totalCost | centsWithDecimal }}</sup><sup show-when=\"fr\">{{ (totalCost | centsWithDecimal).replace(\'.\',\',\') }}</sup></span> <span show-when=\"fr\" id=\"dollar-sign-fr\">$</span></div></div></div></div><div id=\"expanded-view\" ng-show=\"cartSummaryExpanded\"><div id=\"header\" ng-click=\"cartSummaryExpanded = !cartSummaryExpanded\"><div id=\"red-box\"><span class=\"\" res=\"ppc_shop_cart_summary_monthly_summary\">res</span> <img class=\"pull-right red-box-arrow\" src=\"images/summary-up-arrow.png\"></div></div><div id=\"body\"><div id=\"ctn\" class=\"white-font margins\">{{ ctn | phone2 }}</div><div id=\"tab-box\" class=\"margins\"><div id=\"tab-header\"><div id=\"tab-left\" class=\"pull-left\"><div id=\"cost-container\"><div class=\"price-caption\"><span res=\"ppc_shop_cart_summary_new_monthly_cost\">res</span></div><div class=\"price\"><span show-when=\"en\" class=\"dollar-sign\">$</span> <span class=\"price-value\">{{ ((totalCost % 1 == 0) ? totalCost : totalCost - 1) | number: 0 }}</span> <span class=\"price-detail\"><sup><span show-when=\"en\">{{ totalCost | centsWithDecimal }}</span><span show-when=\"fr\">{{(totalCost | centsWithDecimal).replace(\'.\',\',\'); }}</span><span show-when=\"fr\" class=\"asterisk\" ng-show=\"isProrated\">*</span></sup> <sub><span res=\"description_Frmonth\">res</span><span show-when=\"en\" class=\"asterisk\" ng-show=\"isProrated\">*</span></sub></span> <span show-when=\"fr\" class=\"dollar-sign dollar-sign-right\">$</span></div></div></div><div id=\"tab-right\" class=\"pull-right\"><div atm=\"wrls:chgplan:checkout\" id=\"checkout-caption\" class=\"centered-text white-font uppercase\" res=\"checkout_review_checkout\" ng-click=\"checkout()\">res</div></div></div><div id=\"tab-body\"><div style=\"width: 100%;\"><div id=\"partial-line\" ng-show=\"localStorage.getItem(\'nextBillDate\') !== null && localStorage.getItem(\'nextBillDate\') != \'\'\"><div class=\"pull-left\"><span class=\"asterisk rogers-red-font\">*</span> <span class=\"proration\" atm=\"wrls:chgplan:partialchrg\" res=\"ppc_shop_cart_summary_partial_charges_next_bill\" ng-click=\"showProration()\">res</span></div><div id=\"dt\" class=\"details-triangle pull-left\"></div></div></div></div></div><div class=\"yellow-orange-font margins\"><h1><span res=\"ppc_shop_cart_your_plan_details\">res</span>:</h1></div><div id=\"wireless-heading\" class=\"white-font margins\"><h1 res=\"wireless_plan\">res</h1></div><div class=\"details-box details-box-nh row light-charcoal-background\"><div class=\"margins\"><div class=\"pull-left plan-title\"><div class=\"_dib\"><span class=\"yellow-orange-font\"><span class=\"white-font text-uppercase\" res=\"_new\">res</span> <span class=\"\" res=\"_share_everything_plan\">res</span></span></div></div><div class=\"pull-right\"><span show-when=\"en\">$</span><span>{{ plan.planInfo.planPrice % 1 == 0 ? plan.planInfo.planPrice : plan.planInfo.planPrice - 1 }}</span><span show-when=\"en\">{{ plan.planInfo.planPrice | centsWithDecimal }}</span><span show-when=\"fr\">{{ (plan.planInfo.planPrice | centsWithDecimal).replace(\'.\',\',\') }}</span> <span show-when=\"fr\">$</span>/<span res=\"ppc_shop_change_plan_month_abbreviation\">res</span></div><div class=\"clearfix\"></div></div></div><div class=\"break-line margins\"></div><div id=\"wireless-heading\" class=\"white-font margins\"><h1 res=\"_add_ons\">res</h1></div><div class=\"details-box add-on-detail-font\" ng-repeat=\"addOn in existingAddOns | filter: { selected: true }\" ng-class-odd=\"light-charcoal-background\"><div class=\"margins\"><div class=\"pull-left yellow-orange-font\"><span show-when=\"en\">{{ addOn.cmsData_En.title }}</span> <span show-when=\"fr\">{{ addOn.cmsData_Fr.title }}</span></div><div class=\"pull-right\"><span show-when=\"en\">$</span><span decimal-comma-value=\"\">{{ addOn.addonInfo.addOnPrice | number:2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span>/<span res=\"ppc_shop_change_plan_month_abbreviation\">res</span></div></div></div><div class=\"details-box add-on-detail-font\" ng-repeat=\"addOn in availableAddOns | filter: { selected: true }\" ng-class-odd=\"light-charcoal-background\"><div class=\"margins\"><div class=\"pull-left yellow-orange-font font-sz-16\"><span show-when=\"en\">{{ addOn.cmsData_En.title }}</span> <span show-when=\"fr\">{{ addOn.cmsData_Fr.title }}</span></div><div class=\"pull-right\"><span show-when=\"en\">$</span><span decimal-comma-value=\"\">{{ addOn.addonInfo.addOnPrice | number:2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span> /<span res=\"ppc_shop_change_plan_month_abbreviation\">res</span></div></div></div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/cart-summary/cart-summary.html","<div class=\"cart-summary\"><div id=\"red-header\"><div class=\"container\"><div class=\"row\"><div class=\"title col-lg-4 col-md-4\" res=\"ppc_cart_summary_total_monthly_summary\">res</div><div class=\"ctn middle-column col-lg-4 col-md-4\">{{ ctn | phone2 }}</div></div></div></div><div id=\"body-row-1\" class=\"charcoal-row\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-4 col-md-4\"><img class=\"icon\" src=\"images/wireless.png\"> <span id=\"wireless\" class=\"heading\" res=\"wireless_plan\">res</span> <span class=\"plus pull-right\">+</span></div><div class=\"middle-column col-lg-4 col-md-4\"><span class=\"heading\" res=\"_add_ons\">res</span></div></div></div></div><div id=\"body-row-2\" class=\"charcoal-row\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-4 col-md-4\"><div id=\"plan-title\" class=\"yellow-orange-font\"><span show-when=\"en\" data-ng-bind-html=\"plan.cmsData_En.planTitle\"></span> <span show-when=\"fr\" data-ng-bind-html=\"plan.cmsData_Fr.planTitle\"></span></div><div class=\"detail-cost\" ng-show=\"plan != null\"><span show-when=\"en\">$</span> <span show-when=\"en\">{{ plan.planInfo.planPrice | number : 2 }}</span><span show-when=\"fr\">{{ (plan.planInfo.planPrice | number : 2).replace(\'.\', \',\') }}</span> <span show-when=\"fr\">$</span>/<span res=\"ppc_shop_change_plan_month_abbreviation\">res</span></div></div><div class=\"middle-column col-lg-4 col-md-4\"><div class=\"detail-row\" ng-repeat=\"addOn in existingAddOns | filter: { selected: true }\"><div class=\"yellow-orange-font\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.title\"></span></div><div class=\"detail-cost\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ addOn.addonInfo.addOnPrice | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span>/<span res=\"ppc_shop_change_plan_month_abbreviation\">res</span></div></div><div class=\"detail-row\" ng-repeat=\"addOn in availableAddOns | filter: { selected: true }\"><div class=\"yellow-orange-font\"><span show-when=\"en\" data-ng-bind-html=\"addOn.cmsData_En.title\"></span> <span show-when=\"fr\" data-ng-bind-html=\"addOn.cmsData_Fr.title\"></span></div><div class=\"detail-cost\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ addOn.addonInfo.addOnPrice | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span>/<span res=\"ppc_shop_change_plan_month_abbreviation\">res</span></div></div></div><div class=\"col-lg-4 col-md-4\"></div></div></div></div><div id=\"body-row-3\" class=\"\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-4 col-md-4\"></div><div class=\"middle-column col-lg-4 col-md-4\"></div><div class=\"col-lg-4 col-md-4\"><div id=\"total-tab\"><div id=\"tab-header\"><div id=\"cost\" class=\"pull-left\"><div id=\"cost-caption\" class=\"\" res=\"ppc_shop_cart_summary_new_monthly_cost\">res</div><div id=\"cost-box\"><div class=\"price\" ng-show=\"plan != null\"><span show-when=\"en\" class=\"dollar-sign\">$</span> <span class=\"price-value\">{{ ((totalCost % 1 == 0) ? totalCost : totalCost - 1) | number: 0 }}</span> <span class=\"price-detail\"><sup><span show-when=\"en\">{{ (totalCost | centsWithDecimal) }}</span><span show-when=\"fr\">{{ (totalCost | centsWithDecimal).replace(\'.\', \',\') }}</span> <span show-when=\"fr\" class=\"asterisk\" ng-show=\"isProrated\">*</span></sup> <sub><span show-when=\"en\" class=\"asterisk\" ng-show=\"isProrated\">*</span></sub></span> <span show-when=\"fr\" class=\"dollar-sign dollar-sign-right\">$</span></div><div class=\"price\" ng-hide=\"plan != null\"><span show-when=\"en\" class=\"dollar-sign\">$</span> <span class=\"price-value\">--</span> <span class=\"price-detail\"><sup><span>.--</span> <span show-when=\"fr\" class=\"asterisk\" ng-show=\"isProrated\">*</span></sup> <sub><span res=\"_month\">res</span> <span show-when=\"en\" class=\"asterisk\" ng-show=\"isProrated\">*</span></sub></span> <span show-when=\"fr\" class=\"dollar-sign dollar-sign-right\">$</span></div></div></div><div id=\"checkout\" class=\"pull-right clickable\"><div atm=\"wrls:chgplan:checkout\" ng-click=\"checkout()\" id=\"checkout-caption\" class=\"text-center uppercase\"><span show-when=\"en\" res=\"checkout_review_checkout\">res</span> <span show-when=\"fr\" res=\"checkout_review_checkout\">res</span></div></div></div><div id=\"tab-body\"><div id=\"partial-line\" class=\"text-center partial-line\" ng-show=\"localStorage.getItem(\'nextBillDate\') !== null && localStorage.getItem(\'nextBillDate\') != \'\'\"><div class=\"pull-left proration-link\"><span class=\"asterisk\">*</span> <a stylex=\"cursor:pointer;\" atm=\"wrls:chgplan:partialchrg\" class=\"asterisk-link\" data-ng-click=\"showProration()\"><span res=\"ppc_shop_cart_summary_partial_charges_next_bill\">res</span></a></div><div id=\"dt\" class=\"details-triangle pull-left\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/cart-summary/confirm-review-order-shared.html","<div class=\"page-container\"><div class=\"row\" ng-show=\"path == paths.CONFIRM\"><div id=\"top-image-xs-container\" class=\"col-xs-12\"><div id=\"top-image-xs\" class=\"top-image\"><div class=\"thank-you-container\"><div show-when=\"en\" id=\"thank-you-line-1\" class=\"\" res=\"checkout_confirm_thank_you\">res</div><div show-when=\"en\" id=\"thank-you-line-2\" class=\"\"><span class=\"huge-thank-you\" res=\"checkout_confirm_for_your_order\">res</span>!</div><div show-when=\"fr\" id=\"thank-you-line-1\" class=\"font-sz-28\" res=\"checkout_confirm_thank_you\">res</div><div show-when=\"fr\" id=\"thank-you-line-2\" class=\"font-sz-28\"><span class=\"huge-thank-you\" res=\"checkout_confirm_for_your_order\">res</span>!</div><div id=\"processing\"></div><span class=\"visible-md\"></span></div></div><div class=\"thank-you-gray\"><div class=\"\"><strong><span res=\"checkout_confirm_congrats\">res</span></strong> <span res=\"checkout_confirm_on_your_new_plan\">res</span>!</div><div res=\"checkout_confirm_email_confirm\">res</div></div></div></div><div class=\"section\"><div ng-show=\"path == paths.CONFIRM\"><div class=\"title\" res=\"checkout_confirm_order_order_summary\">res</div><div class=\"red-line\"></div><div class=\"sub-title ptm\"><strong res=\"checkout_confirm_order_contact_details\">res</strong></div></div><div ng-show=\"path == paths.REVIEW\"><div class=\"sub-title\"><strong res=\"checkout_confirm_order_contact_details\">res</strong></div></div><div>{{ cart.contactPhoneNumber | phone2 }}</div><div>{{ cart.email }}</div><div class=\"mtl sub-title\"><strong res=\"ppc_date_of_agreement\">res</strong></div><div>{{ agreementDate | date:\'yyyy-MM-dd\'}}</div><div ng-show=\"path == paths.CONFIRM\"><div class=\"mtl\">{{ cart.billingStreetAddress }}</div><div class=\"\">{{ cart.billingCity +\', \' + cart.billingProvince }}</div><div class=\"\">{{ cart.billingPostalCode }}</div></div></div><div class=\"section mbn\"><div class=\"title\"><span res=\"checkout_confirm_order_your_order\">res</span></div><div id=\"print-button-container\" class=\"clickable pull-right\"><a href=\"{{ email() }}\"><img src=\"images/email-icon.png\" width=\"22px\" class=\"mrs\"></a> <a href=\"javascript:window.print()\"><img src=\"images/print-icon.png\" width=\"25\" height=\"23\"></a></div><div class=\"red-line\"></div><div class=\"left-column pull-left sub-title rogers-red-font\"><span res=\"ppc_shop_cart_plan_details\">res</span><span show-when=\"fr\"></span></div><div class=\"right-column pull-right sub-title rogers-red-font prm txtR\"><span res=\"checkout_confirm_order_monthly_fees\">res</span></div><div class=\"clear-float\"></div><div class=\"left-column pull-left sub-title\"><div class=\"pull-left\"><div class=\"col-xs-12\"><div class=\"review-order-plan-name\"><span show-when=\"en\">{{ cart.newPlan.cmsData_En.planTitle }}</span> <span show-when=\"fr\">{{ cart.newPlan.cmsData_Fr.planTitle }}</span></div><div class=\"review-order-edit-plan cursor-pointer\" ng-click=\"edit()\"><span res=\"paynow_edit\">res</span> <i class=\"fa fa-caret-right\"></i></div></div><div class=\"review-order-term-service\"><div class=\"mbm\" res=\"checkout_confirm_term_service\">res</div></div><ul class=\"pull-left-none\"><li>{{ cart.newPlan.planInfo.includedDataMax | mbOrGbValue }} {{ cart.newPlan.planInfo.includedDataMax | mbOrGbValueStr }} <span ng-show=\"cart.newPlan.planInfo.includedDataMax !== \'Not Applicable\'\"><span res=\"ppc_overage_rate\">res</span> <span show-when=\"en\">{{ cart.newPlan.planInfo.overageRate }}</span> <span show-when=\"fr\">{{ overageFr(cart.newPlan.planInfo.overageRate) }}</span></span></li><li><span show-when=\"en\" data-ng-bind-html=\"cart.newPlan.cmsData_En.includedMessages[0]\"></span> <span show-when=\"fr\" data-ng-bind-html=\"cart.newPlan.cmsData_Fr.includedMessages[0]\"></span></li><li><span show-when=\"en\" data-ng-bind-html=\"cart.newPlan.cmsData_En.includedMinutes[0]\"></span> <span show-when=\"fr\" data-ng-bind-html=\"cart.newPlan.cmsData_Fr.includedMinutes[0]\"></span></li><li show-when=\"en\" ng-repeat=\"featureItem in cart.newPlan.cmsData_En.planFeatures\" data-ng-bind-html=\"featureItem\"></li><li show-when=\"fr\" ng-repeat=\"featureItem in cart.newPlan.cmsData_Fr.planFeatures\" data-ng-bind-html=\"featureItem\"></li></ul></div></div><div class=\"right-column pull-right sub-title prm txtR\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ cart.newPlan.planInfo.planPrice | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div><div class=\"clear-float\"></div><div id=\"add-ons-list-container\"><add-ons-list-adaptive add-ons=\"cart.addOns\"></add-ons-list-adaptive></div></div><div id=\"extras-heading\" class=\"row\" ng-show=\"isShareable\"><div class=\"pull-left\"><h1 class=\"sub-title rogers-red-font mtn\" res=\"ppc_extras\">res</h1></div></div><div class=\"row\" ng-show=\"isShareable\"><div><img show-when=\"en\" class=\"mrm mtm\" src=\"images/RGCL-logo-EN_lg.png\" width=\"145\"> <img show-when=\"en\" class=\"mtm\" src=\"images/RoamON-EN-HD.png\" ng-src=\"images/RoamON-EN-HD.png\" width=\"95\"> <img show-when=\"fr\" class=\"mrm mtm\" src=\"images/RGCL-logo-FR_lg.png\" width=\"95\"> <img show-when=\"fr\" class=\"mtm\" src=\"images/RoamON-FR-HD.png\" ng-src=\"images/RoamON-FR-HD.png\" width=\"145\"></div><div ng-show=\"isSharePlus\" style=\"margin-top:30px;\" class=\"share-plus-logos\"><div res=\"ppc_one_following\" style=\"margin-bottom: 12px;\"></div><img src=\"images/value-added-offers/mb-spotify-logo.png\" width=\"90\"> <img src=\"images/value-added-offers/mb-shomi-logo.png\" width=\"80\"> <img src=\"images/value-added-offers/next_issue_2line.png\" width=\"100\"></div></div><div class=\"section clear-float\"><div class=\"title\" res=\"ppc_new_monthly_fees\">res</div><div class=\"red-line\"></div><div class=\"left-column pull-left bold-line bold-line-mod\"><span res=\"checkout_confirm_order_monthly_fees\">res</span></div><div class=\"right-column pull-right bold-line bold-line-mod prm txtR\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ cart.totalCost | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div><div class=\"left-column pull-left bold-line bold-line-mod\"><span res=\"_taxes\">res</span></div><div class=\"right-column pull-right bold-line bold-line-mod prm txtR\" ng-repeat=\"(key, value) in cart.taxes.taxes\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{value | number: 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div><div class=\"clear-float\"></div><div id=\"charges-next-bill\"><div class=\"pull-left\" res=\"checkout_confirm_new_monthly_total_fees\">res</div><div class=\"pull-right rogers-red-font\"><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ cart.grandTotal | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span></div><div class=\"clear\"></div><br><div class=\"pull-left legal-fine-print font-normal\" res=\"ppc_taxes_disclaimer\">res</div></div><div class=\"full-width mtl\" ng-show=\"path == paths.REVIEW\"><div class=\"legal-fine-print\" res=\"checkout_confirm_partial_prepaid\">res</div><div class=\"legal-fine-print\" res=\"checkout_confirm_fine_print\">res</div></div></div></div><div class=\"page-break-line\" ng-show=\"path == paths.REVIEW\"></div><div class=\"page-container\" ng-show=\"path == paths.REVIEW\"><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"showAgreementError\"><div res=\"ppc_agrrement_error_message\">res</div></div><div class=\"section\"><div class=\"title black-font-override margin-bottom-large\" res=\"checkout_review_additional_agreement_details\">res</div><div class=\"round-copy-box margin-bottom-large\" style=\"display: none;\"><div class=\"scroll-copy-box\"><div show-when=\"en\" ng-include=\"\'views/localization/account-maintenance-agreement.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/account-maintenance-agreement-fr.html\'\"></div><div show-when=\"en\" ng-include=\"\'views/localization/rogers-terms-of-service.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/rogers-terms-of-service-fr.html\'\"></div><div show-when=\"en\" ng-include=\"\'views/localization/acceptable-use-policy.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/acceptable-use-policy-fr.html\'\"></div><div show-when=\"en\" ng-include=\"\'views/localization/privacy-policy.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/privacy-policy-fr.html\'\"></div></div></div><div class=\"round-copy-box margin-bottom-large\"><div class=\"scroll-copy-box\"><div class=\"paragraph-link\" ng-click=\"scrollTo(\'account-maintenance-agreement\')\"><span res=\"checkout_review_account_maint_agree\"></span></div><div class=\"paragraph-link\" ng-click=\"scrollTo(\'rogers-terms-of-service\')\"><span res=\"checkout_review_rogers_tos\"></span></div><div class=\"paragraph-link\" ng-click=\"scrollTo(\'acceptable-use-policy\')\"><span res=\"checkout_acceptable_use_policy\"></span></div><div class=\"paragraph-link\" ng-click=\"scrollTo(\'privacy-policy\')\"><span res=\"checkout_privacy_policy\"></span></div><div class=\"paragraph\" id=\"account-maintenance-agreement\"><div show-when=\"en\" ng-include=\"\'views/localization/account-maintenance-agreement.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/account-maintenance-agreement-fr.html\'\"></div></div><div class=\"paragraph\" id=\"rogers-terms-of-service\"><div show-when=\"en\" ng-include=\"\'views/localization/rogers-terms-of-service.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/rogers-terms-of-service-fr.html\'\"></div></div><div class=\"paragraph\" id=\"acceptable-use-policy\"><div show-when=\"en\" ng-include=\"\'views/localization/acceptable-use-policy.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/acceptable-use-policy-fr.html\'\"></div></div><div class=\"paragraph\" id=\"privacy-policy\"><div show-when=\"en\" ng-include=\"\'views/localization/privacy-policy.html\'\"></div><div show-when=\"fr\" ng-include=\"\'views/localization/privacy-policy-fr.html\'\"></div></div></div></div></div><div id=\"agree-section\" class=\"section\"><div class=\"pull-left\"><input type=\"checkbox\" data-ng-model=\"tac_checkbox\" ng-click=\"checkTacValue()\"></div><div class=\"section-terms\"><span res=\"checkout_review_checkbox_copy\" class=\"ng-style: showAgreementError && {color:\'red\'};\">res</span></div><div class=\"clear-float\"></div></div><div class=\"section\"><div class=\"pull-left\"><a href=\"\"><span class=\"section-cancel\" res=\"_cancel\" ng-click=\"edit()\">res</span></a></div><div class=\"pull-right\"><div><span class=\"widget-loader mls\" ng-show=\"$root.reviewLoader === true\"><img src=\"images/widget-loader.gif\" alt=\"\" width=\"30\"></span></div><button ng-click=\"checkout()\" class=\"cta-round large\"><span class=\"white text-uppercase\" res=\"checkout_review_checkout\">res</span></button></div><div class=\"clear-float\"></div></div></div><div id=\"cancel-checkout\" class=\"row\" ng-show=\"path == paths.CONFIRM\"><div class=\"col-xs-12 prl\"><div class=\"your-order-column pull-right mrm mbl\"><button class=\"cta-round large\" ng-click=\"$state.go(\'accountOverview\');\"><span class=\"white text-uppercase\" res=\"acc_overview_my_acc_overview\">Account Overview</span></button></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/ctn-select/ctn-select.html","<div class=\"dropdown\"><div class=\"dropdown-toggle ctn-dropdown-toggle clickable\" atm=\"wrls:chgplan:drpdwn\" id=\"ctnDropdownMenu\" data-toggle=\"dropdown\" aria-expanded=\"true\"><div class=\"ctn-dropdown-body\"><div class=\"ctn-dropdown-text\">{{userSelections.ctn | phone2 }}</div></div><div class=\"ctn-dropdown-button\"><div class=\"ctn-dropdown-triangle\"></div></div></div><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"ctnDropdownMenu\"><li ng-repeat=\"ctn in ctnList\" role=\"presentation\"><a role=\"menuitem\" tabindex=\"-1\" class=\"ctn-number\" ng-click=\"clickCTN(ctn, $event)\">{{ctn | phone2}}</a></li></ul></div>");
$templateCache.put("scripts/directives/pricePlanChanges/existing-plan/existing-plan-adaptive.html","<div class=\"existing-plan-adaptive\"><div id=\"your-plan\" class=\"charcoal-bar yellow-orange-font\"><div class=\"your-plan-spanner\"><div class=\"float-left your-plan-caption-container\"><span class=\"your-plan-caption heading-font\" res=\"_your_plan\">res</span></div><div class=\"float-right your-plan-dollar-container\"><div class=\"_pr\"><span id=\"your-plan-dolla\" class=\"_dib\" show-when=\"en\">$</span> <span id=\"your-plan-price\" class=\"_dib heading-font\" decimal-comma-value=\"\">{{ plan.costs.planMSF + plan.costs.addOnsTotal | number: 2 | decimalCommaValueFltr }}</span> <span id=\"your-plan-month\" class=\"_dib\">/<span class=\"copy-font\" res=\"ppc_shop_change_plan_month_abbreviation\">res</span></span> <span id=\"your-plan-dolla-fr\" class=\"_dib\" show-when=\"fr\">$</span></div></div><div class=\"_cf\"></div></div></div><div class=\"plan-info pbm\"><div id=\"plan-columns-container\"><div ng-show=\"plan.data\"><div class=\"heading-font plan-column col-sm-4 col-xs-4\"><div res=\"wireless_data\" class=\"text-uppercase\">res</div><div class=\"plan-details-font plan-details-row\">{{ plan.data | mbOrGbValue }} <span class=\"plan-content-data-over mbm\" show-when=\"en\">{{ plan.data | mbOrGbUnit:\'en\' }}</span> <span class=\"plan-content-data-over mbm\" show-when=\"fr\">{{ plan.data | mbOrGbUnit:\'fr\' }}</span></div></div><div class=\"heading-font plan-column col-sm-5 col-xs-5\"><div res=\"wireless_talk\" class=\"text-uppercase\">res</div><ul class=\"plm\"><li show-when=\"en\" class=\"plan-details-font plan-details-row\" ng-repeat=\"talkItem in plan.talk\"><span ng-bind-html=\"talkItem.desc\"></span></li><li show-when=\"fr\" class=\"plan-details-font plan-details-row\" ng-repeat=\"talkItem in plan.talk\"><span ng-bind-html=\"talkItem.descFr\"></span></li></ul></div><div class=\"heading-font plan-column col-sm-3 col-xs-3\"><div res=\"wireless_text\" class=\"text-uppercase\">res</div><ul class=\"plm\"><li ng-if=\"plan.text.usageType == \'limited\'\" class=\"plan-details-font plan-details-row\"><span class=\"text-uc-first\" res=\"wireless_texts\">res</span></li><li ng-if=\"plan.text.usageType != \'limited\'\" class=\"plan-details-font plan-details-row\"><span class=\"text-uc-first\" res=\"wireless_unlimited\">res</span></li></ul></div></div><div class=\"plan-info-details-list\" ng-class=\"{ \'plan-info-expanded\': showDetails }\" ng-init=\"showDetails = plan.data ? false : true\"><div class=\"row\"><div class=\"col-xs-12\" style=\"margin-top:20px\"><span res=\"wireless_features_and_add_ons\" class=\"text-uppercase\" style=\"font-weight: 500; font-size: 14px;\"></span></div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\"><ul class=\"plm\"><li class=\"plan-details-font plan-details-row\" show-when=\"en\" ng-repeat=\"featureItem in combineFeatures(plan.talk, plan.features)\" ng-if=\"$even\" ng-bind-html=\"featureItem.desc\"></li><li class=\"plan-details-font plan-details-row\" show-when=\"fr\" ng-repeat=\"featureItem in combineFeatures(plan.talk, plan.features)\" ng-if=\"$even\" ng-bind-html=\"featureItem.descFr\"></li></ul></div><div class=\"col-xs-5 col-xs-offset-2 col-sm-5 col-sm-offset-2\"><ul class=\"plm\"><li class=\"plan-details-font plan-details-row\" show-when=\"en\" ng-repeat=\"featureItem in combineFeatures(plan.talk, plan.features)\" ng-if=\"$odd\" ng-bind-html=\"featureItem.desc\"></li><li class=\"plan-details-font plan-details-row\" show-when=\"fr\" ng-repeat=\"featureItem in combineFeatures(plan.talk, plan.features)\" ng-if=\"$odd\" ng-bind-html=\"featureItem.descFr\"></li><li class=\"plan-details-font plan-details-row\" show-when=\"en\" ng-repeat=\"addon in existingAddons\" data-ng-bind-html=\"addon.cmsData_En.title\"></li><li class=\"plan-details-font plan-details-row\" show-when=\"fr\" ng-repeat=\"addon in existingAddons\" data-ng-bind-html=\"addon.cmsData_Fr.title\"></li></ul></div></div></div></div><div id=\"plan-summary\" class=\"charcoal-bar yellow-orange-font heading-font\"><div class=\"heading-font\"><span res=\"_plan\">res</span> <span show-when=\"en\">$</span>{{ ::plan.costs.planMSF | number : 0 }}<span show-when=\"fr\">$</span><span ng-if=\"plan.costs.addOnsTotal > 0\"><span res=\"_includes\" class=\"text-lc\">res</span><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ plan.costs.addOnsTotal | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span> <span show-when=\"en\" res=\"ppc_add_ons_lower\" class=\"bold\">res</span></span> <span ng-if=\"false\">, <span res=\"_includes\">res</span> $??/<span res=\"_month\"></span> <span res=\"_discount\" class=\"lowercase\">res</span></span></div></div></div><div ng-click=\"showDetails = !showDetails\" ng-show=\"plan.data\" class=\"plan-info-details-box\"><span id=\"details-label\" res=\"wireless_details\" class=\"heading-font text-uppercase\">res</span><div class=\"details-sign\" ng-hide=\"showDetails\">+</div><div class=\"details-sign details-minus-sign\" ng-show=\"showDetails\">-</div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/existing-plan/existing-plan.html","<div id=\"plan-container\" class=\"existing-plan available-plan\"><div class=\"plan-header\" data-plan-align-row=\"6\"><div id=\"existing-plan-title\" class=\"text-center text-white h3-font-size\"><span res=\"_your_plan\">res</span>&nbsp;(<span show-when=\"en\">$</span><span decimal-comma-value=\"\">{{ plan.costs.planMSF | number: 2 | decimalCommaValueFltr }}&nbsp;</span><span show-when=\"fr\">$</span> <span show-when=\"en\" res=\"_plan\">res</span><span>)</span></div></div><div id=\"plan-price-container\"><div class=\"price-line text-center\" style=\"margin-top:20px; !important\"><span show-when=\"en\" class=\"plan-price-dollar-sign\">$</span> <span class=\"plan-price\">{{ (plan.costs.planMSF + plan.costs.addOnsTotal) | floor }}<sup class=\"font-sz-32\" decimal-comma-value=\"\">{{ plan.costs.planMSF + plan.costs.addOnsTotal | centsWithDecimal | decimalCommaValueFltr }}</sup></span> <span show-when=\"fr\" class=\"plan-price-dollar-sign\">$</span> <span class=\"plan-price-unit\">/</span> <span class=\"plan-price-unit\" res=\"ppc_shop_change_plan_month_abbreviation\">res</span><div class=\"plan-content-column text-left regular\"><div ng-show=\"plan.costs.addOnsTotal > 0\"><span res=\"_includes\" class=\"text-lc\">res</span><span show-when=\"en\">$</span> <span decimal-comma-value=\"\">{{ plan.costs.addOnsTotal | number : 2 | decimalCommaValueFltr }}</span> <span show-when=\"fr\">$</span> <span show-when=\"en\" res=\"ppc_add_ons_lower\" class=\"bold\">res</span></div></div></div></div><div id=\"existing-plan-grey-body\" data-ng-show=\"plan.data\"><div id=\"data-features-container\"><div data-plan-align-row=\"1\" class=\"mbl\"><div class=\"_dib plan-content-column\"><span class=\"_dib heading-font mbn plan-content-data-head\" res=\"wireless_data\">res</span><br><span class=\"\" res=\"_no_data_included\" ng-hide=\"plan.data\">res</span> <span class=\"rogers-red-font\"><span class=\"plan-content-data-mb data-capacity-font\">{{ plan.data | mbOrGbValue }}</span> <span class=\"data-capacity-font mbm\" show-when=\"en\">{{ plan.data | mbOrGbUnit:\'en\' }}</span> <span class=\"data-capacity-font mbm\" show-when=\"fr\">{{ plan.data | mbOrGbUnit:\'fr\' }}</span></span><br></div></div><div class=\"trailing-line plan-content-column\"></div></div><div data-plan-align-row=\"2\"><div res=\"wireless_talk\" class=\"heading-font plan-content-column plan-content-talk-head mbs\">res</div><ul class=\"plan-content-column mbl\"><li show-when=\"en\" ng-repeat=\"talkItem in plan.talk\" data-ng-bind-html=\"talkItem.desc\"></li><li show-when=\"fr\" ng-repeat=\"talkItem in plan.talk\" data-ng-bind-html=\"talkItem.descFr\"></li></ul><div class=\"plan-content-column\" ng-show=\"false && (!plan.talk || plan.talk.length === 0)\">----</div></div><div class=\"trailing-line plan-content-column margin-top-large\"></div><div data-plan-align-row=\"3\" style=\"margin-bottom: 23px; /*temp*/\"><div res=\"wireless_text\" class=\"heading-font plan-content-column plan-content-text-head mbs\">res</div><div class=\"plan-content-column mbl\" ng-show=\"false\"><span ng-if=\"plan.text.usageType == \'limited\'\"><span>{{ plan.text.total}}</span>&nbsp;<span res=\"wireless_texts\">res</span></span> <span ng-if=\"plan.text.usageType != \'limited\'\"><span class=\"text-uppercase\" res=\"wireless_unlimited\">res</span></span></div><ul class=\"plan-content-column mbl\"><li ng-if=\"plan.text.usageType == \'limited\'\"><span>{{ plan.text.total}}</span>&nbsp;<span res=\"wireless_texts\">res</span></li><li ng-if=\"plan.text.usageType != \'limited\'\"><span class=\"text-uppercase rogers-red-font bold\" res=\"wireless_unlimited\">res</span></li></ul><div class=\"plan-content-column\" ng-show=\"false && (!plan.text || plan.text.length === 0)\">----</div></div><div class=\"trailing-line plan-content-column margin-top-large\"></div><div data-plan-align-row=\"4\"><div res=\"wireless_features_and_add_ons\" class=\"heading-font plan-content-column plan-content-features-head mbs\">res</div><ul class=\"plan-content-column mbl\"><li show-when=\"en\" ng-repeat=\"featureItem in plan.features\" data-ng-bind-html=\"featureItem.desc\"></li><li show-when=\"fr\" ng-repeat=\"featureItem in plan.features\" data-ng-bind-html=\"featureItem.descFr\"></li></ul><div class=\"plan-content-column\" ng-show=\"false && (!plan.features || plan.features.length === 0)\">----</div></div><div ng-if=\"false\" class=\"trailing-line plan-content-column margin-top-large\"></div><div data-plan-align-row=\"5\">&nbsp;</div></div><div id=\"existing-plan-grey-body\" data-ng-show=\"!plan.data\" style=\"padding-top:20px;\"><div data-plan-align-row=\"99\"><ul class=\"plan-content-column mbl\"><li show-when=\"en\" ng-repeat=\"talkItem in plan.talk\" data-ng-bind-html=\"talkItem.desc\"></li><li show-when=\"fr\" ng-repeat=\"talkItem in plan.talk\" data-ng-bind-html=\"talkItem.descFr\"></li><li show-when=\"en\" ng-repeat=\"featureItem in plan.features\" data-ng-bind-html=\"featureItem.desc\">{{ featureItem.desc }}</li><li show-when=\"fr\" ng-repeat=\"featureItem in plan.features\" data-ng-bind-html=\"featureItem.descFr\"></li><li show-when=\"en\" ng-repeat=\"addon in existingAddons\" data-ng-bind-html=\"addon.cmsData_En.title\"></li><li show-when=\"fr\" ng-repeat=\"addon in existingAddons\" data-ng-bind-html=\"addon.cmsData_Fr.title\"></li></ul><div class=\"plan-content-column\" ng-show=\"false && (!plan.features || plan.features.length === 0)\">----</div></div><div ng-if=\"false\" class=\"trailing-line plan-content-column margin-top-large\"></div><div data-plan-align-row=\"5\">&nbsp;</div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/existing-plan/existing-plan.orig.html","<div id=\"plan-container\" class=\"existing-plan available-plan\"><div class=\"plan-header\"><div id=\"existing-plan-title\" class=\"text-center text-white h3-font-size\" style=\"/*margin-top: 52px; temp*/\"><span res=\"_your_plan\">res</span><span>&nbsp;($</span><span>{{ plan.costs.planMSF }}&nbsp;</span><span res=\"_plan\">res</span><span>)</span></div></div><div id=\"plan-price-container\"><div class=\"price-line text-center\"><span show-when=\"en\" class=\"plan-price-dollar-sign\">$</span> <span class=\"plan-price\">{{ plan.costs.planMSF + plan.costs.addOnsTotal }}</span> <span show-when=\"fr\" class=\"plan-price-dollar-sign\">$</span> <span class=\"plan-price-unit\">/</span> <span class=\"plan-price-unit\" res=\"ppc_shop_change_plan_month_abbreviation\">res</span><div class=\"plan-content-column text-left regular\"><div>+<span show-when=\"en\">$</span> {{ plan.costs.addOnsTotal }} <span show-when=\"fr\">$</span> <span res=\"ppc_add_ons_lower\" class=\"bold\">res</span></div></div></div></div><div id=\"existing-plan-grey-body\"><div id=\"data-features-container\"><div data-plan-align-row=\"1\"><div class=\"heading-font plan-content-column plan-content-data-head\" res=\"wireless_data\">res</div><div class=\"plan-content-column rogers-red-font\"><div class=\"plan-content-data-mb data-capacity-font\">{{ plan.data | mbOrGbValue }}</div><div class=\"plan-content-data-over mbm\" show-when=\"en\">{{ plan.data | mbOrGbUnit:\'en\' }}</div><div class=\"plan-content-data-over mbm\" show-when=\"fr\">{{ plan.data | mbOrGbUnit:\'fr\' }}</div></div></div><div class=\"trailing-line plan-content-column\"></div></div><div data-plan-align-row=\"2\"><div res=\"wireless_talk\" class=\"heading-font plan-content-column plan-content-talk-head mbs\">res</div><ul class=\"plan-content-column mbm\"><li show-when=\"en\" ng-repeat=\"talkItem in plan.talk\">{{ talkItem.desc }}</li><li show-when=\"fr\" ng-repeat=\"talkItem in plan.talk\">{{ talkItem.descFr }}</li></ul><div class=\"plan-content-column\" ng-show=\"false && (!plan.talk || plan.talk.length === 0)\">----</div></div><div class=\"trailing-line plan-content-column margin-top-large\"></div><div data-plan-align-row=\"3\" style=\"margin-bottom: 23px; /*temp*/\"><div res=\"wireless_text\" class=\"heading-font plan-content-column plan-content-text-head mbs\">res</div><div class=\"plan-content-column mbl\" ng-show=\"false\"><span ng-if=\"plan.text.usageType == \'limited\'\"><span>{{ plan.text.total}}</span>&nbsp;<span res=\"wireless_texts\">res</span></span> <span ng-if=\"plan.text.usageType != \'limited\'\"><span class=\"text-uppercase\" res=\"wireless_unlimited\">res</span></span></div><ul class=\"plan-content-column mbl\"><li ng-if=\"plan.text.usageType == \'limited\'\"><span>{{ plan.text.total}}</span>&nbsp;<span res=\"wireless_texts\">res</span></li><li ng-if=\"plan.text.usageType != \'limited\'\"><span class=\"text-uppercase rogers-red-font bold\" res=\"wireless_unlimited\">res</span></li></ul><div class=\"plan-content-column\" ng-show=\"false && (!plan.text || plan.text.length === 0)\">----</div></div><div class=\"trailing-line plan-content-column margin-top-large\"></div><div data-plan-align-row=\"4\"><div res=\"wireless_features_and_add_ons\" class=\"heading-font plan-content-column plan-content-features-head mbs\">res</div><ul class=\"plan-content-column mbl\"><li show-when=\"en\" ng-repeat=\"featureItem in plan.features\">{{ featureItem.desc }}</li><li show-when=\"fr\" ng-repeat=\"featureItem in plan.features\">{{ featureItem.descFr }}</li></ul><div class=\"plan-content-column\" ng-show=\"false && (!plan.features || plan.features.length === 0)\">----</div></div><div ng-if=\"false\" class=\"trailing-line plan-content-column margin-top-large\"></div><div data-plan-align-row=\"5\">&nbsp;</div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/timeline/timeline.html","<div class=\"timeline-container\"><div class=\"timeline-section\"><div class=\"change-plan-anchor\" ng-style=\"{ \'width\' : percentPassed + \'%\' }\"></div><span class=\"change-plan-anchor-description\" ng-style=\"{\'left\': percentPassed + \'%\' }\" res=\"changed_your_plan\">res</span><div class=\"change-plan-box\" ng-style=\"{ \'width\': (100 - percentPassed) + \'%\' }\"><span class=\"box-number\">2</span></div><div class=\"gray-box box\"><span class=\"box-number\">1</span></div></div><div class=\"timeline-section red-box-position\"><div class=\"red-box box\"><span class=\"box-number\">3</span></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/widgets/full-details.html","<div class=\"container\"><div class=\"row\" ng-init=\"closed = true\"><div class=\"col-xs-12 text-uppercase font-bold mtl mbs\"><a ng-click=\"showFullDetails();\" ng-rem=\"closed = !closed;\" class=\"clickable\">(<span ng-show=\"closed\">+</span><span ng-show=\"!closed\">-</span>) <span res=\"ppc_full_details\">res</span></a></div></div></div>");
$templateCache.put("scripts/modules/forgotPassword/tempPassword/tempPassword.html","<div class=\"page-temp-password\"><div class=\"container\"><form name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" res=\"_my_rogers_nospace\"></a></li><li class=\"child-1\"><span res=\"_signin\"></span></li><li class=\"widget-loader sign-in\" ng-show=\"loginWaiting\"><img src=\"images/widget-loader.gif\" alt=\"\"></li></ul></div><div class=\"col-lg-12\"><h1 class=\"temp-password-title primary-color\" res=\"temp_password_enter_new_password\"></h1><h5 class=\"password-help-txt black\" res=\"temp_password_enter_new_password_description\"></h5></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 mtm\"><div class=\"row info-banner error mts mbm\" style=\"margin-left: 0px;\" data-ng-show=\"errorSummary\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 error-icon-ctn prm\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 plm\" style=\"float:left\"><span ng-bind-html=\"errorMessage\"></span></div></div></div></div><div class=\"row input-ctn\"><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=\"row\"><div class=\"col-md-12 col-lg-12\"><div class=\"inline_error\" ng-messages=\"form.tempPassword.$error\" ng-show=\"form.tempPassword.$invalid && (form.tempPassword.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"temp_password_invalid_temp_password\"></span></span> <span ng-message=\"minlength\"><span res=\"registration_too_short\"></span></span> <span ng-message=\"maxlength\"><span res=\"registration_too_long\"></span></span> <span ng-message=\"pattern\"><span res=\"registration_wrong_password\"></span></span> <span ng-message=\"invalidPassword\"><span res=\"temp_password_invalid_temp_password\"></span></span></div></div></div><div class=\"row\"><div class=\"col-xs-11 col-sm-11 col-md-9 col-lg-9\"><label class=\"rel\"><input data-tl-private=\"\" type=\"password\" name=\"tempPassword\" tag-form-name=\"form\" tag-page-name=\"Temp password\" res-attr=\"{placeholder: \'temp_password_temp_pass_field\'}\" ng-minlength=\"7\" ng-maxlength=\"16\" ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#\\$%\\^\\&*\\)\\(+=._-]{7,16}$/\" ng-model-options=\"{updateOn: \'blur\'}\" onpaste=\"return true;\" data-ng-model=\"regObj.tempPassword\" required=\"\" custom-trim=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.tempPassword.$invalid && (form.tempPassword.$dirty || form.$submitted)\"></span> <i ng-show=\"form.tempPassword.$dirty && form.tempPassword.$valid\" class=\"inline-checker icon-checked\"></i></label></div><div class=\"col-xs-1 col-sm-1 colmd-1 col-lg-1 mtss\"><div class=\"tool-tip-ctn\"><a alt=\"{{tooltipTempPassword}}\" class=\"tooltipText\"><span class=\"new-info-icon\">i</span></a></div></div></div></div></div><div class=\"row input-ctn\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"row\"><div class=\"col-md-12 col-lg-12\"><div class=\"inline_error\" ng-messages=\"form.password.$error\" ng-show=\"form.password.$invalid && (form.password.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"login_invalid_password\"></span></span> <span ng-message=\"minlength\"><span res=\"registration_too_short\"></span></span> <span ng-message=\"maxlength\"><span res=\"registration_too_long\"></span></span> <span ng-message=\"pattern\"><span res=\"registration_wrong_password\"></span></span> <span ng-message=\"mismatchPassword\"><span res=\"_password_not_matched\"></span></span></div></div></div><div class=\"row\"><div class=\"col-xs-11 col-sm-11 col-md-9 col-lg-9\"><label class=\"rel\"><input data-tl-private=\"\" type=\"password\" name=\"password\" tag-form-name=\"form\" tag-page-name=\"Temp password\" res-attr=\"{placeholder: \'temp_password_dew_pass_field\'}\" ng-minlength=\"7\" ng-maxlength=\"16\" ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#\\$%\\^\\&*\\)\\(+=._-]{7,16}$/\" ng-change=\"checkPassword()\" ng-model-options=\"{ updateOn: \'blur\' }\" onpaste=\"return false;\" match-password=\"\" data-ng-model=\"regObj.password\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.password.$invalid && (form.password.$dirty || form.$submitted)\"></span> <i ng-show=\"form.password.$dirty && form.password.$valid\" class=\"inline-checker icon-checked\"></i></label></div><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 mtss\"><div class=\"tool-tip-ctn\"><a alt=\"{{tooltipPassword}}\" class=\"tooltipText\"><span class=\"new-info-icon\">i</span></a></div></div></div></div></div><div class=\"row input-ctn\"><div class=\"col-md-6 col-lg-6\"><div class=\"inline_error\" ng-messages=\"form.confirmPassword.$error\" ng-show=\"form.confirmPassword.$invalid && (form.confirmPassword.$dirty || form.$submitted)\"><span ng-message=\"required\"><span res=\"login_re_enter\"></span></span> <span ng-message=\"mismatchPassword\"><span res=\"_password_not_matched\"></span></span></div><div class=\"col-xs-11 col-sm-11 col-md-9 col-lg-9\"><label class=\"rel\"><input data-tl-private=\"\" type=\"password\" name=\"confirmPassword\" tag-form-name=\"form\" tag-page-name=\"Temp password\" res-attr=\"{placeholder: \'temp_password_confirm_dew_pass_field\'}\" ng-model-options=\"{ debounce: 500 }\" onpaste=\"return false;\" match-password=\"\" password=\"regObj.password\" confirmpassword=\"regObj.confirmPassword\" data-ng-model=\"regObj.confirmPassword\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.confirmPassword.$invalid && (form.confirmPassword.$dirty || form.$submitted)\"></span> <i ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$valid\" class=\"inline-checker icon-checked\"></i></label></div></div></div><div class=\"row input-ctn\"><div class=\"col-xs-11 col-sm-12 col-md-5 col-lg-5\"><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-12 cancel-continue-ctn\"><div class=\"pull-left\"><a class=\"link-cancel\" data-ng-click=\"cancel()\" href=\"#/signin\" res=\"_cancel\"></a></div><div class=\"pull-right\"><button name=\"button_continue\" data-ng-click=\"submit()\" data-ng-disabled=\"!form.$valid\" class=\"cta-round primary medium full btn-continue\"><span res=\"_continue\"></span></button></div></div></div></div></form></div></div>");
$templateCache.put("scripts/modules/payHistory/html/paymentHistory.html","<div class=\"container\"><div id=\"paymentHistory\" ng-controller=\"paymentHistoryController\"><div class=\"row\"><div class=\"breadCrumbs col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"previousContainer\"><a ng-click=\"redirectBack()\" style=\"cursor: pointer;\" class=\"textPreviousContainer\"><span res=\"bss_paymentHistory_backToPreviousPage\"></span></a> <a ng-click=\"redirectBack()\" style=\"cursor: pointer;\" class=\"textPreviousContainerMobile\"><span res=\"bss_paymentHistory_backToPreviousPage\"></span></a></div><div class=\"sectionTitle col-xs-12 col-sm-12 col-md-8 col-lg-8\" res=\"bss_paymentHistory_paymentHistory\"></div></div></div><div class=\"loading-container\" ng-show=\"loadingIndicator\"><div class=\"hidden-xs hidden-sm loadingIndEn\"><img src=\"images/widget-loader-lg.gif\"></div><div class=\"hidden-md hidden-lg loadingIndEn\"><img src=\"images/widget-loader-lg_plain.gif\"></div></div><div class=\"content\" ng-show=\"!showPaymentHistoryErrorSection && !loadingIndicator\"><div class=\"accountDetails col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"accountHeading hidden-xs hidden-sm col-md-8 col-lg-8\" res=\"bss_paymentHistory_accountHeading\"></div><div class=\"accountNumber col-xs-12 col-sm-12 col-md-8 col-lg-8\"><span class=\"accountNickName\">{{accountNickName}}</span><span>{{accountNo}}</span></div></div><div class=\"row paginationContainer\" ng-show=\"showPaymentHistoryRecordsSection\"><div class=\"hidden-xs hidden-sm col-md-8 col-lg-8\"><div class=\"pageNumbers\"><div><a class=\"next\" href=\"\" ng-hide=\"hideNext\" ng-click=\"pagenumberScrollHolderatePage(\'next\')\"></a></div><div class=\"pagenumberScrollHolder\"><div ng-style=\"{\'left\':leftProperty}\" class=\"pagenumberScroll\"><a class=\"pageNumberDigit\" href=\"\" ng-repeat=\"id in ctrlArr\" ng-class=\"{activePage:activePageIndex==\'{{$index}}\'}\" ng-click=\"pagenumberScrollHolderatePage($index)\">{{id}}</a></div></div><div><span>{{i18n.bss_paymentHistory_paginationInfo1}} {{currentPage}} - {{(currentPage+9)>listLength?listLength:currentPage+9}}<span res=\"bss_paymentHistory_paginationInfo2\"></span>{{listLength}}</span> <a class=\"prev\" href=\"\" ng-hide=\"hidePrev\" ng-click=\"pagenumberScrollHolderatePage(\'prev\')\"></a></div></div></div></div><div class=\"row rowheading\"><div class=\"header-container col-xs-12 col-sm-12 col-md-8 col-lg-8 padding-reset\"><div class=\"col-xs-5 col-sm-5 col-md-3 col-lg-3 date\" ng-click=\"orderPayHistoryLabel(\'transDate\')\"><span ng-class=\"{activeSort:sortLable === \'transDate\'}\" res=\"bss_paymentHistory_date\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'transDate\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'transDate\')&& orderToggle\">&#x25BC;</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3 transactionType\" ng-click=\"orderPayHistoryLabel(\'tranType\')\"><span ng-class=\"{activeSort:sortLable === \'tranType\'}\" res=\"bss_paymentHistory_transaction\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'tranType\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'tranType\')&& orderToggle\">&#x25BC;</span></div><div class=\"col-xs-4 col-sm-4 col-md-3 col-lg-3 amount\" ng-click=\"orderPayHistoryLabel(\'amount\')\"><span ng-class=\"{activeSort:sortLable === \'amount\'}\" res=\"bss_paymentHistory_amount\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'amount\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'amount\')&& orderToggle\">&#x25BC;</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3 refNo\" ng-click=\"orderPayHistoryLabel(\'refNo\')\"><span ng-class=\"{activeSort:sortLable === \'refNo\'}\" res=\"bss_paymentHistory_reference\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'refNo\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'refNo\')&& orderToggle\">&#x25BC;</span></div><div class=\"col-xs-3 col-sm-3 hidden-md hidden-lg payDetailAccordion\"></div></div></div><div ng-show=\"showPaymentHistoryRecordsSection\" class=\"row\" id=\"history{{$index}}\" ng-class=\"{lastDetail:$index==pageList.length-1}\" ng-repeat=\"list in pageList| orderBy:sortLable:reverse | startFrom: currentPage-1 |limitTo:limiter\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8 rowlist\"><div class=\"row listcontent\"><div class=\"col-xs-5 col-sm-5 col-md-3 col-lg-3 date\"><span>{{list.transDate | date:\'MMM dd,yyyy\'}}</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3 transactionType\"><span>{{list.tranType}}</span></div><div class=\"col-xs-4 col-sm-4 col-md-3 col-lg-3 amount\"><span>{{list.amount|currency}}</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3\"><span>{{list.refNo}}</span></div><div class=\"col-xs-3 col-sm-3 hidden-md hidden-lg payDetailAccordion\"><span ng-click=\"detailsShowHide($index)\">{{i18n.bss_paymentHistory_detail}} <span ng-hide=\"showDetails[$index]\">[+]</span> <span ng-show=\"showDetails[$index]\">[&#8212]</span></span></div></div></div><div class=\"row paymentDetails\" ng-if=\"showDetails[$index]\"><div class=\"paymentDetailsBackground\"><div class=\"details-container\"><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_paymentDate\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.transDate | date:\'MMM dd,yyyy\'}}</div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_transaction\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.tranType}}</div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_amount\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.amount}}</div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_reference\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.refNo}}</div></div></div></div></div></div><div ng-show=\"!showPaymentHistoryRecordsSection\" class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\"><div class=\"noRecordsFound\" res=\"bss_paymentHistory_noRecordsFound\"></div></div></div><div class=\"row paginationContainer\" ng-show=\"showPaymentHistoryRecordsSection\"><div class=\"hidden-xs hidden-sm col-md-8 col-lg-8\"><div class=\"pageNumbers\"><div style=\"\"><a class=\"next\" href=\"\" ng-hide=\"hideNext\" ng-click=\"pagenumberScrollHolderatePage(\'next\')\"></a></div><div class=\"pagenumberScrollHolder\"><div ng-style=\"{\'left\':leftProperty}\" class=\"pagenumberScroll\"><a class=\"pageNumberDigit\" href=\"\" ng-repeat=\"id in ctrlArr\" ng-class=\"{activePage:activePageIndex==\'{{$index}}\'}\" ng-click=\"pagenumberScrollHolderatePage($index)\">{{id}}</a></div></div><div style=\"\"><span><span res=\"bss_paymentHistory_paginationInfo1\"></span> {{currentPage}} - {{(currentPage+9)>listLength?listLength:currentPage+9}} <span res=\"bss_paymentHistory_paginationInfo2\"></span>{{listLength}}</span> <a class=\"prev\" href=\"\" ng-hide=\"hidePrev\" ng-click=\"pagenumberScrollHolderatePage(\'prev\')\"></a></div></div></div></div><div class=\"row mobilePaginationContainer\" ng-show=\"showPaymentHistoryRecordsSection\"><div class=\"col-xs-12 col-sm-12 hidden-md hidden-lg\"><div class=\"pageNumbers\"><span><span res=\"bss_paymentHistory_paginationInfo1\"></span> 1 - {{limiter}} <span res=\"bss_paymentHistory_paginationInfo2\"></span> {{listLength}}</span></div><div class=\"row paginationButton\"><button type=\"button\" class=\"pageNumberButton col-xs-12 col-sm-12\" ng-show=\"showNextButton\" ng-click=\"clicker()\">Show Next {{leftover}}</button></div></div></div></div><div class=\"paymentHistoryError\" ng-show=\"showPaymentHistoryErrorSection\"><div class=\"row\"><div class=\"col-xs-10 col-sm-10 col-md-8 col-lg-8 error\"><div res=\"bss_paymentHistory_systemError1\"></div><div res=\"bss_paymentHistory_systemError2\"></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/setNewPassword/setNewPasswordSuccess/setNewPasswordSuccess.html","<div class=\"totes-project\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"link-account-title\"><span res=\"set_new_password_title\"></span></h4><div class=\"pbm\"><span res=\"set_new_password_success_sub\"></span></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\"><span res=\"_continue\"></span></button></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/setNewPassword/validateModal/validateModalView.html","<div class=\"totes-project\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\"><span aria-hidden=\"true\">&times;</span></button><h4 class=\"link-account-title\"><span res=\"validate_code_title\"></span></h4><div class=\"pbm\"><span res=\"set_new_password_success_sub\"></span></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\"><span res=\"_continue\"></span></button></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcAddAditionalDataModal.html","<div class=\"totes-project mppc-modal entry-3\"><div class=\"modal-header\"><img class=\"close-icon\" src=\"images/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"modal-body share-everything-modal\"><h3 class=\"modal-title\"><span res=\"mppc_entry_3_title\"></span></h3><div class=\"row\"><div class=\"col-xs-12\"><a class=\"ppc-red-button\" href=\"\" ng-click=\"yes()\"><span res=\"mppc_entry_3_yes\"></span></a> <a class=\"ppc-white-button\" href=\"\" ng-click=\"no()\"><span res=\"mppc_entry_3_no\"></span></a></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcEntry1Modal.html","<div class=\"totes-project mppc-modal entry-1\"><div class=\"modal-header\"><img class=\"close-icon\" src=\"images/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"modal-body share-everything-modal\"><div class=\"row\"><div class=\"col-sm-5\" ng-click=\"changeCurrentPlan()\"><div class=\"well\"><div><img src=\"images/price-plan-changes/edit-current-ctn.png\"></div><span res=\"mppc_entry_1_change_current_plan\"></span></div></div><div class=\"col-sm-2 text-center or-div\">OR</div><div class=\"col-sm-5\" ng-click=\"createSharedGroup()\"><div class=\"well\"><div><img src=\"images/price-plan-changes/create-shared-group.png\"></div><span res=\"mppc_entry_1_create_shared_plan\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><a class=\"back-button\" href=\"\" ng-click=\"cancel()\"><span res=\"mppc_entry_1_cancel\"></span></a></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcEntry3Modal.html","<div class=\"totes-project mppc-modal entry-3\"><div class=\"modal-header\"><img class=\"close-icon\" src=\"images/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"modal-body share-everything-modal\"><h3 class=\"modal-title\"><span res=\"mppc_entry_3_change_wireless_plan\"></span></h3><div class=\"well\"><div class=\"row\"><div class=\"col-sm-8\"><span res=\"mppc_entry_3_change_current_plan\"></span></div><div class=\"col-sm-4\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"changeCurrentPlan()\"><span res=\"_continue\"></span></button></div></div></div><div class=\"text-center or-div\">OR</div><div class=\"well\"><div class=\"row\"><div class=\"col-sm-8\"><span res=\"mppc_entry_3_add_to_share_plan\"></span></div><div class=\"col-sm-4\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"addToSharedGroup()\"><span res=\"_continue\"></span></button></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><a class=\"back-button\" href=\"\" ng-click=\"cancel()\"><span res=\"mppc_entry_3_cancel\"></span></a></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupIndividualModal.html","<div class=\"totes-project mppc-modal\"><div class=\"modal-header\"><img class=\"close-icon\" src=\"images/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"modal-body share-everything-modal\" bfa-stop-event=\"touchend\"><h3 class=\"modal-title\"><span res=\"mppc_shared_group_indiv_title\"></span></h3><div class=\"benefit-link\" ng-click=\"toggleBenefits()\"><span res=\"mppc_shared_group_indiv_benefits\"></span> <i class=\"fa\" ng-class=\"{\'fa-chevron-down\':!model.showBenefits, \'fa-chevron-up\':model.showBenefits}\"></i></div><div ng-show=\"model.showBenefits\" class=\"benefits\"><span res=\"mppc_shared_group_indiv_switch_reason_intro\"></span><ul><li><span res=\"mppc_shared_group_indiv_switch_reason_1\"></span></li><li><span res=\"mppc_shared_group_indiv_switch_reason_2\"></span></li><li><span res=\"mppc_shared_group_indiv_switch_reason_3\"></span></li><li><span res=\"mppc_shared_group_indiv_switch_reason_4\"></span></li></ul></div><div class=\"inline-error\" ng-show=\"model.isCTNSelected\"><span res=\"mppc_ctn_selection_checkbox_error\"></span></div><div class=\"panel panel-default panel-individual\"><div class=\"panel-body\"><div class=\"individual-line row\" ng-repeat=\"individualLine in model.subscribers | filter: filterSubscribers\" ng-class=\"{\'last\': $last}\"><input type=\"checkbox\" ng-model=\"model.selectedSubscribersCheckBox[individualLine.subscriberNumber]\" data-icheck=\"\"> {{::individualLine.subscriberNumber}}</div></div></div><div class=\"row\"><div class=\"col-xs-6\"><a class=\"back-button\" href=\"\" ng-click=\"skipStep()\"><span res=\"mppc_shared_group_indiv_skip\"></span></a></div><div class=\"col-xs-6\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"continue()\"><span res=\"_add\"></span></button></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupPrimaryModal.html","<div class=\"totes-project mppc-modal\"><div class=\"modal-header\"><img class=\"close-icon\" src=\"images/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"modal-body share-everything-modal\" bfa-stop-event=\"touchend\"><h3 class=\"modal-title\"><span res=\"mppc_shared_group_primary_title\"></span></h3><div class=\"panel panel-default panel-individual\"><div class=\"panel-body\"><div class=\"individual-line row\"><input type=\"radio\" ng-model=\"model.selectedPrimaryCtn\" data-icheck=\"\" value=\"{{model.currentCtn}}\"> {{model.currentCtn}}</div><div class=\"individual-line row\" ng-repeat=\"ctn in model.selectedAdditionalSubscribers\" ng-class=\"{\'last\': $last}\"><input type=\"radio\" ng-model=\"model.selectedPrimaryCtn\" data-icheck=\"\" value=\"{{ctn}}\"> {{ctn}}</div></div></div><div class=\"row\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"continue()\"><span res=\"_continue\"></span></button></div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/widgets/big-half-header/big-half-header.html","<div class=\"big-half-header\"><div class=\"heading big-half hidden-xs\"><div><div></div></div><div class=\"rogers-red-font\" res=\"{{resKey}}\">res</div><div></div></div><div class=\"heading-small hidden-sm hidden-md hidden-lg\"><div class=\"red-boundary\"></div><div class=\"content\" res=\"{{resKey}}\">res</div></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/widgets/details-button/details-button-mobile.html","<div class=\"details-button clickable\" ng-class=\"{\'expanded\': detailsExpanded}\" ng-click=\"detailsExpanded = !detailsExpanded\"><div ng-hide=\"detailsExpanded\" class=\"plus-sign\">+</div><div ng-show=\"detailsExpanded\" class=\"minus-sign\"></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/widgets/details-button/details-button.html","<div class=\"details-button clickable\" ng-class=\"{\'expanded\': expanded}\" ng-click=\"handleClick(); expanded = !expanded\" atm=\"ppc_choose_a_plan_details_{{buttonId}}\"><div ng-hide=\"expanded\" class=\"plus-sign\">+</div><div ng-show=\"expanded\" class=\"minus-sign\"></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/widgets/more-information/more-information.html","<img src=\"images/blueicon-with-text.png\" alt=\"info\" class=\"info-icon\" style=\"display: inline;\" ng-click=\"openModal()\">");
$templateCache.put("scripts/directives/pricePlanChanges/widgets/rewards/rewards-box.html","<div class=\"rewards-box\"><div id=\"container-box\" class=\"round-3\"><div class=\"digit round-3 margin-left-1 margin-right-1\">{{firstDigit}}</div><div class=\"digit round-3 margin-right-1\">{{secondDigit}}</div><div class=\"digit round-3 margin-right-1\">{{thirdDigit}}</div><div class=\"digit round-3 margin-right-1\">{{fourthDigit}}</div></div><div id=\"rewards-points\" class=\"sub-script\" res=\"rewards_points\">res</div><div id=\"rewards-points-unit\" class=\"sub-script\"><span>/</span><span res=\"_month\">res</span> <span class=\"asterisk\" ng-show=\"isProrated\">*</span></div></div>");
$templateCache.put("scripts/directives/pricePlanChanges/widgets/row-hr/row-hr.html","<div class=\"row\"><hr></div>");
$templateCache.put("module/changeSubscriberName/changeSubscriberName.html","<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"wireless\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\"><div class=\"change-subscriber-name\"><div class=\"Header\"><span translate=\"csn.header\"></span> <span ng-bind-html=\"csn.phoneNumber | tel\"></span></div><div class=\"main\" ng-hide=\"csn.submitted\"><div class=\"subHeader\" translate=\"csn.subHeader\"></div><div class=\"name-ctnr\"><span translate=\"csn.name\"></span> <span class=\"username\" ng-bind-html=\"csn.subscriberName\"></span></div><div class=\"update\" translate=\"csn.update\"></div><form name=\"csnForm\" ng-submit=\"csn.submit()\"><div class=\"first-name-ctnr\"><span translate=\"csn.firstName\"></span> <input type=\"text\" class=\"form-control\" ng-model=\"model.firstName\" name=\"firstName\" ng-focus=\"csn.privateFirstName = false;csn.nullFirstName=false;csn.bannedFirstName=false;\" input-validator=\"15\"><div ng-show=\"csn.privateFirstName\" class=\"error-msg\" translate=\"csn.firstNameError\"></div><div ng-show=\"csn.bannedFirstName\" class=\"error-msg\" translate=\"csn.bannedFirstNameError\"></div><div ng-show=\"csn.nullFirstName\" class=\"error-msg\" translate=\"csn.nullFirstName\"></div></div><div class=\"last-name-ctnr\"><span translate=\"csn.lastName\"></span> <input type=\"text\" class=\"form-control\" ng-model=\"model.lastName\" name=\"lastName\" ng-focus=\"csn.privateLastName = false;csn.nullLastName=false;csn.bannedLastName=false;\" input-validator=\"30\"><div ng-show=\"csn.privateLastName\" class=\"error-msg\" translate=\"csn.lastNameError\"></div><div ng-show=\"csn.bannedLastName\" class=\"error-msg\" translate=\"csn.bannedLastNameError\"></div><div ng-show=\"csn.nullLastName\" class=\"error-msg\" translate=\"csn.nullLastName\"></div></div><div class=\"btn-ctnr\"><div class=\"cancel-btn hidden-xs hidden-sm\" ng-click=\"csn.back()\" translate=\"csn.cancel\"></div><button type=\"submit\" class=\"submit-btn col-xs-12 col-sm-12 hidden-md hidden-lg\" translate=\"csn.saveChanges\"></button> <button type=\"submit\" class=\"submit-btn hidden-xs hidden-sm\" translate=\"csn.saveChanges\"></button> <span ng-show=\"csn.loading\"><img ng-src=\"ute-change-subscriber-name/assets/loader-rg.gif\"></span><div class=\"cancel-btn col-xs-12 col-sm-12 hidden-md hidden-lg\" ng-click=\"csn.back()\" translate=\"csn.cancel\"></div></div></form></div><div ng-show=\"csn.submitted\"><div class=\"success\" ng-if=\"csn.success\"><div class=\"success-banner row col-xs-12 col-sm-6 col-md-5 col-lg-5\"><div class=\"check-ctnr col-xs-2 col-sm-1 col-md-1 col-lg-1\"><img ng-src=\"ute-change-subscriber-name/assets/checkIcon.png\"></div><div class=\"success-msg col-xs-10 col-sm-11 col-md-11 col-lg-11\"><div class=\"success-header\" translate=\"csn.success\"></div><div translate=\"csn.successSub\"></div></div></div><div class=\"updated-details col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div translate=\"csn.updatedDetails\"></div><div class=\"details-ctnr col-xs-12 col-sm-5 col-md-5 col-lg-5\"><div class=\"update-number\"><div translate=\"csn.wireless\"></div><div style=\"white-space: nowrap;\" ng-bind-html=\"csn.phoneNumber | tel\"></div></div><div class=\"update-name\"><div translate=\"csn.name2\"></div><div ng-bind-html=\"csn.subscriberName\"></div></div></div></div></div><div class=\"failure row col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"!csn.success\"><div class=\"failure-banner row col-xs-12 col-sm-6 col-md-5 col-lg-5\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><div class=\"error-icon\"><img ng-src=\"ute-change-subscriber-name/assets/errorIcon.png\"></div></div><div class=\"failure-msg col-xs-11 col-sm-11 col-md-11 col-lg-11\"><div class=\"success-header\" translate=\"csn.failure\"></div><div translate=\"csn.failureSub\"></div></div></div></div><div class=\"row col-xs-12 col-sm-12 col-md-12 col-lg-12 go-back\" ng-click=\"csn.back()\" translate=\"csn.back\"></div></div></div></div>");
$templateCache.put("module/boldChat/boldChatStaticButton.html","<div id=\"{{boldChatDiv}}\"></div>");
$templateCache.put("module/language.switcher/languageSwitch.html","<ul class=\"nav navbar-nav pull-right\"><li><a href=\"\" data-ng-click=\"languageSwitch.changeLanguage()\" translate=\"ute.blocks.language.switcher.label\"></a></li></ul>");
$templateCache.put("module/changePaymentMethod/changePaymentMethod.html","<section class=\"container changePaymentMethod\" ng-controller=\"changePaymentMethodController\"><div class=\"hidden-xs hidden-sm loadingIndEn\" ng-show=\"loadingIndicator\"><img src=\"images/widget-loader-lg.gif\"></div><div class=\"hidden-md hidden-lg loadingIndEn\" ng-show=\"loadingIndicator\"><img src=\"images/widget-loader-lg_plain.gif\"></div><div ng-show=\"!showChangePaymentMethodSection\"><div ng-show=\"!showChangePaymentMethodSection\"><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><h1 class=\"changePayment\" res=\"bss_paymentMethodChange_changeMonthlyPaymentOption\"></h1></section><div class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 accountDetails\"><section class=\"col-lg-5 col-md-5 col-xs-10 col-sm-10\"><p class=\"label\" res=\"bss_paymentMethodChange_Account\"></p><section class=\"storeInfo\"><span class=\"storeName\">{{nickName}}</span><span class=\"number\">{{accountNo}}</span></section></section><section class=\"col-lg-7 col-md-7 col-xs-10 col-sm-10\"><p class=\"label\" res=\"bss_paymentMethodChange_currentPaymentMethod\"></p><section class=\"currentMethod\">{{methodOfPayment}}</section></section></div><section class=\"selectPaymentMethod\"><section class=\"col-lg-12 col-md-12 selectPaymentTitle\" style=\"padding-bottom:10px;\" res=\"bss_paymentMethodChange_selectPaymentMethod\"></section><ul class=\"nav nav-tabs col-lg-9 col-md-9 hidden-xs hidden-sm\" style=\"padding-right:0px;\"><li class=\"tab col-lg-{{paymentMethods[0].size}} col-md-{{paymentMethods[0].size}} active\"><a style=\"margin-right:10px\" href=\"\" ng-click=\"showBankingSection(paymentMethods[0].name);\" ng-class=\"{borderRedFirst:paymentMethods[0].isActive, borderRedSecond:!paymentMethods[0].isActive}\" res=\"bss_paymentMethodChange_chequingAccount\"></a></li><li class=\"tab col-lg-{{paymentMethods[1].size}} col-md-{{paymentMethods[1].size}} active\"><a style=\"margin-right:10px\" href=\"\" ng-click=\"showBankingSection(paymentMethods[1].name);\" ng-class=\"{borderRedFirst:paymentMethods[1].isActive, borderRedSecond:!paymentMethods[1].isActive}\" res=\"bss_paymentMethodChange_preAuthorizedCredit\"></a></li><li class=\"tab col-lg-{{paymentMethods[2].size}} col-md-{{paymentMethods[2].size}} active\"><a href=\"\" ng-click=\"showBankingSection(paymentMethods[2].name);\" ng-class=\"{borderRedFirst:paymentMethods[2].isActive, borderRedSecond:!paymentMethods[2].isActive}\" res=\"bss_paymentMethodChange_invoice\"></a></li></ul><ul class=\"row hidden-lg hidden-md paymentMethodRadioButtonsList\"><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" ng-show=\"!thirdRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(paymentMethods[0].name);\" ng-enter=\"showBankingSection(paymentMethods[0].name);\" tabindex=\"0\"><img ng-show=\"thirdRadio\" src=\"images/activeRadio.png\" ng-class=\"{customizedRadioButtonColor:thirdRadio}\" tabindex=\"0\"><span res=\"bss_paymentMethodChange_chequingAccount\"></span></li><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" ng-show=\"!fourthRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(paymentMethods[1].name);\" tabindex=\"0\" ng-enter=\"showBankingSection(paymentMethods[1].name);\"><img ng-show=\"fourthRadio\" src=\"images/activeRadio.png\" ng-class=\"{customizedRadioButtonColor:fourthRadio}\" tabindex=\"0\"><span res=\"bss_paymentMethodChange_preAuthorizedCredit\"></span></li><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" ng-show=\"!fifthRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(paymentMethods[2].name);\" tabindex=\"0\" ng-enter=\"showBankingSection(paymentMethods[2].name);\"><img ng-show=\"fifthRadio\" src=\"images/activeRadio.png\" ng-class=\"{customizedRadioButtonColor:fifthRadio}\" tabindex=\"0\"><span res=\"bss_paymentMethodChange_invoice\"></span></li></ul><section class=\"chequing col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"paymentMethods[0].isActive\" ng-form=\"chequingForm\"><div class=\"row labelMargin2\"><p class=\"hidden-sm hidden-xs col-md-12 col-lg-12 headLine\" res=\"bss_paymentMethodChange_preAuthorizedDebit\"></p><p class=\"hidden-xs hidden-sm inline col-lg-9\" res=\"bss_paymentMethodChange_preAuthorizedDebitInformation\"></p></div><div class=\"row labelMargin codesSection\"><div class=\"col-xs-6 col-sm-6 col-md-2 col-lg-2 transitCodeField\"><span res=\"bss_paymentMethodChange_transitCode\"></span><input type=\"text\" ng-model=\"transitCode\" name=\"transitCode\" class=\"form-control\" required=\"\" ng-class=\"{redBorder:isValidTransitCode}\" ng-keyup=\"validateTransitCode()\"><div class=\"col-xs-12 col-sm-12 col-lg-12 col-md-12\" ng-show=\"isValidTransitCode\"><span class=\"styled-select-type beside-checker-changePayment icon-error\" ng-show=\"isValidTransitCode\"></span><div class=\"inline_error\" res=\"bss_invalid_transit_code\"></div></div></div><div class=\"col-xs-8 col-sm-8 col-md-2 col-lg-2 bankCodeField\"><span res=\"bss_paymentMethodChange_bankCode\"></span><input type=\"text\" ng-model=\"bankCode\" name=\"bankCode\" class=\"form-control\" ng-class=\"{redBorder:isValidBankCode}\" required=\"\" ng-keyup=\"validateBankCode()\"><div class=\"col-xs-12 col-sm-12 col-lg-12 col-md-12\" ng-show=\"isValidBankCode\"><span class=\"styled-select-type beside-checker-changePayment icon-error\" ng-show=\"isValidBankCode\"></span><div class=\"inline_error\" res=\"bss_invalid_bank_code\"></div></div></div><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-5 accountNumberField\"><span res=\"bss_paymentMethodChange_accountNumber\"></span><input type=\"text\" ng-model=\"accountNumber\" name=\"accountNumber\" class=\"form-control\" ng-class=\"{redBorder:isValidAccountNumber}\" required=\"\" ng-keyup=\"validateAccountNumber()\" numbers-only=\"\"><div class=\"col-xs-12 col-sm-12 col-lg-12 col-md-12\" ng-show=\"isValidAccountNumber\"><span class=\"styled-select-type beside-checker-changePayment icon-error\" ng-show=\"isValidAccountNumber\"></span><div class=\"inline_error\" res=\"bss_invalid_acc_number\"></div></div></div></div><div class=\"row voidCheque labelMargin\"><img src=\"images/voidCheque.png\" class=\"hidden-xs hidden-sm col-md-9 col-lg-9 voidChequeImage\"> <img src=\"images/voidChequeSmallImage.png\" class=\"col-xs-11 col-sm-11 hidden-lg hidden-md voidChequeImage\"></div><div class=\"row voidCheque\"><section class=\"col-lg-11 col-md-11 col-xs-12 col-sm-12\"><section class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 transitCodeSection\"><span class=\"col-md-offset-2 col-md-10 col-xs-12 col-sm-12\" ng-class=\"{\'col-lg-10 col-lg-offset-2\':lang == \'en\', \'col-lg-11 col-lg-offset-0\':lang == \'fr\'}\" res=\"bss_paymentMethodChange_transitCode\"></span></section><section class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2 bankCodeSection\"><span class=\"col-md-9 col-xs-12 col-sm-10 col-sm-offset-3 col-md-offset-0 col-lg-offset-0 col-xs-offset-2\" ng-class=\"{\'col-lg-9\':lang == \'en\', \'col-lg-10\':lang == \'fr\'}\" res=\"bss_paymentMethodChange_bankCode\"></span></section><section class=\"col-xs-4 col-sm-4 col-md-5 col-lg-5 col-lg-offset-3 col-md-offset-3 col-xs-offset-2 accountNumberSection\"><span class=\"col-lg-5 col-md-5 col-xs-12 col-sm-10 col-sm-offset-4 col-md-offset-0 col-lg-offset-0 col-xs-offset-2\" res=\"bss_paymentMethodChange_accountNumber\"></span></section></section></div><div class=\"row\"><section class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" style=\"max-height:150px;margin:30px 0 10px 0;\" res=\"bss_paymentMethodChange_termsAndConditions\"></section></div><div class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12\" id=\"termsAndConditions\"><section class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" scrollbar=\"\"><p class=\"termsAndConditionsLabel\" res=\"bss_paymentMethodChange_termsAndConditions\"></p><div class=\"ptm pbm black\" res=\"change_method_terms\"></div></section></div><div class=\"row\"><section class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><input type=\"checkbox\" class=\"termsCheckbox\" ng-model=\"termsAndConditions\" name=\"termsAndConditions\" ng-change=\"termsAndConditions?isValid=false:isValid=true;validateTermsAndCondtions();\"> &nbsp;<span res=\"bss_paymentMethodChange_acceptTermsAndConditions\"></span></section></div><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 inline_error\" ng-show=\"isValid\" res=\"bss_invalid_terms_and_conditions\"></section><div class=\"row\"><section class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><p res=\"bss_paymentMethodChange_pleaseNote\"></p></section></div></section><section class=\"preAuthorized\" ng-show=\"paymentMethods[1].isActive\" ng-form=\"creditCardForm\"><section class=\"col-lg-12 col-md-12 hidden-xs hidden-sm labelMargin2\"><p class=\"headLine\" res=\"bss_paymentMethodChange_creditCardInformation1\"></p><p class=\"inline col-lg-9 col-md-9\" res=\"bss_paymentMethodChange_creditCardInformation2\"></p></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" style=\"padding-right:0px\"><section class=\"col-lg-6 col-md-5 col-sm-12 col-xs-12\" style=\"padding-right:0px\"><form-credit-card></form-credit-card></section></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 inline_error\" ng-show=\"isValidCreditCardNumber\" id=\"cardNumberErrorSection\" res=\"bss_invalid_cc_number\"></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 inline_error\" ng-show=\"isValidCreditCardScheme\" id=\"cardSchemeErrorSection\" res=\"bss_invalid_cc_type\"></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 labelMargin\" res=\"bss_paymentMethodChange_expirationDate\"><span class=\"mandatory hidden-xs hidden-sm\">*</span></section><div class=\"col-lg-6 col-md-6 col-xs-12 col-sm-12\"><div class=\"focusBorder styled-month-select select-month col-lg-4 col-md-4 col-sm-4 col-xs-4\" ng-class=\"{redBorder:isValidMonth}\"><select name=\"monthName\" class=\"\" ng-required=\"false\" ng-model=\"selectedMonth\" ng-init=\"selectedMonth = $scope.months[0]\" ng-change=\"changeMonth(selectedMonth)\"><option value=\"\" class=\"\" disabled=\"true\" ng-selected=\"true\" res=\"bss_month\"></option><option ng-repeat=\"month in months\">{{month.value}}</option></select></div><div class=\"focusBorder styled-year-select select-year col-lg-5 col-md-5 col-sm-5 col-xs-5\" ng-class=\"{redBorder:isValidYear}\"><select name=\"yearValue\" class=\"\" required=\"\" ng-model=\"selectedYear\" ng-init=\"selectedYear = $scope.years[0]\" ng-change=\"changeYear(selectedYear)\"><option value=\"\" class=\"\" disabled=\"true\" ng-selected=\"true\" res=\"bss_year\"></option><option ng-repeat=\"year in years\">{{year}}</option></select></div></div><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><section class=\"inline_error col-lg-7 col-md-7 col-sm-12 col-xs-12\" ng-show=\"isValidMonth || isValidYear\" res=\"bss_invalid_cc_ex_date\"></section></section><section class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 labelMargin\" res=\"bss_paymentMethodChange_securityCode\"><span class=\"mandatory hidden-xs hidden-sm\">*</span></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 securityCode\" style=\"padding-right: 7px;\"><section class=\"col-lg-2 col-md-2 col-sm-4 col-xs-5\" style=\"margin-right:15px;\"><input type=\"text\" maxlength=\"3\" class=\"form-control\" numbers-only=\"\" ng-keyup=\"validateSecurityCode()\" ng-model=\"securityCode\" placeholder=\"XXX\" name=\"securityCode\" required=\"\" ng-class=\"{redBorder:isValidSecurityCode}\"></section><section class=\"col-lg-9 col-md-9 hidden-xs hidden-sm styleForDesktop\"><span class=\"popoverContent contentDesktopView\"><span><img id=\"cvvHelp\" src=\"images/informationIcon.png\"></span></span></section><div class=\"popoverContentDesktop\" style=\"display: none;\"><div class=\"col-lg-12\" style=\"padding-right:0px; margin-bottom:10px;\"><img class=\"popoverClose\" style=\"float:right;margin:0\" src=\"images/closeSecurityCode.png\"></div><div class=\"col-lg-12\" style=\"padding-right:0;\"><div class=\"col-lg-5\"><img src=\"images/securityCode.png\" style=\"max-width:100%\"></div><div class=\"col-lg-7\" style=\"padding-right:35px;text-align:justify;padding-left:5px;\" res=\"bss_makePayment_securityCodeDetail\"></div></div></div><div class=\"popoverContentMobile\" style=\"display: none;\"><div class=\"col-xs-12 col-sm-12\" style=\"padding-right:0px; margin-bottom:20px;\"><img class=\"popoverClose\" style=\"float:right;margin:0\" src=\"images/closeSecurityCode.png\"></div><div class=\"col-xs-12 col-sm-12\" style=\"padding-right:26px;padding-bottom:35px;text-align:justify;padding-left:5px;\" res=\"bss_makePayment_securityCodeDetail\"></div><div class=\"col-xs-12 col-sm-12\"><img src=\"images/securityCode.png\" style=\"max-width:100%\"></div></div><section class=\"hidden-lg hidden-md col-sm-3 col-xs-3 popOverStyle\" style=\"padding-right:0\"><span class=\"popoverContent contentSmallDevices\"><span><img id=\"cvvHelpSmallDevices\" src=\"images/informationIcon.png\"></span></span></section></section></section><section class=\"invoice col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-show=\"paymentMethods[2].isActive\"><div class=\"row labelMargin2\"><p class=\"hidden-xs hidden-sm col-md-12 col-lg-12 headLine\" res=\"bss_paymentMethodChange_monthByMonthInformation1\"></p><p class=\"col-xs-12 col-sm-12 col-md-9 col-lg-9 inline\"><span res=\"invoice_intro_content_part_1\"></span><span res=\"invoice_intro_content_part_2\"></span><span res=\"invoice_intro_content_part_3\"></span> <span res=\"invoice_intro_content_part_4\"></span><span res=\"invoice_intro_content_part_5\"></span></p></div><div class=\"row\"><p class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 howToPay labelMargin2\" res=\"bss_paymentMethodChange_monthByMonthInformation3\"></p><ul class=\"waysToPayList col-xs-12 col-sm-12 col-md-9 col-lg-9 labelMargin2\"><li class=\"row\"><span class=\"col-md-1 col-lg-1 col-xs-1 col-sm-1 bulletSpan\"><img class=\"hidden-xs hidden-sm\" src=\"images/1.png\" height=\"22\" width=\"22\"></span><span class=\"col-md-11 col-lg-11 hidden-xs hidden-sm\" res=\"invoice_bill_options_list_online_part_desktop\"></span><span class=\"hidden-lg hidden-md col-xs-11 col-sm-11\" res=\"invoice_bill_options_list_online_part_mobile\"></span></li><li class=\"row\"><span class=\"col-md-1 col-lg-1 col-xs-1 col-sm-1 bulletSpan\"><img class=\"hidden-xs hidden-sm\" src=\"images/2.png\" height=\"22\" width=\"22\"></span><span class=\"col-md-11 col-lg-11 hidden-xs hidden-sm\" res=\"invoice_bill_options_list_store_part_desktop\"></span><span class=\"hidden-lg hidden-md col-xs-11 col-sm-11\" res=\"invoice_bill_options_list_store_part_mobile\"></span></li><li class=\"row\"><span class=\"col-md-1 col-lg-1 col-xs-1 col-sm-1 bulletSpan\"><img class=\"hidden-xs hidden-sm\" src=\"images/3.png\" height=\"22\" width=\"22\"></span><span class=\"col-md-11 col-lg-11 col-xs-11 col-sm-11\" res=\"invoice_bill_options_list_internet_telephone_banking\"></span></li><li class=\"row\"><span class=\"col-md-1 col-lg-1 col-xs-1 col-sm-1 bulletSpan\"><img class=\"hidden-xs hidden-sm\" src=\"images/4.png\" height=\"22\" width=\"22\"></span> <span class=\"col-md-11 col-lg-11 hidden-xs hidden-sm\" res=\"invoice_bill_options_list_mail_desktop\"></span><p res=\"invoice_address_companyName\"></p><p res=\"invoice_address_post_office_box_no\"></p><p res=\"invoice_address_street\"></p><p res=\"invoice_address_pincode\"></p><span class=\"col-xs-11 col-sm-11 hidden-lg hidden-md\" res=\"invoice_bill_options_list_mail_mobile\"></span></li></ul></div></section><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\"><section ng-class=\"{\'col-lg-3 col-md-3\':lang == \'en\', \'col-lg-4 col-md-4\':lang == \'fr\'}\" ng-show=\"paymentMethods[0].isActive || paymentMethods[1].isActive || paymentMethods[2].isActive\"><button type=\"button\" class=\"continueReview\" ng-disabled=\"!enableButton\" ng-class=\"{enabledButton: enableButton, disabledButton: !enableButton}\" ng-click=\"validateAndSubmitForm()\" res=\"bss_paymentMethodChange_updatePaymentMethod\">&nbsp;<img src=\"images/lock.png\" height=\"10\" width=\"8\"></button></section><section class=\"col-lg-2 col-md-2 cancel\"><a href=\"#\" res=\"bss_paymentMethodChange_cancel\"></a></section></div></section></div><div class=\"reviewAndConfirmation\" ng-show=\"showUpdatedPayment\"><section class=\"row\"><h1 class=\"changePayment\" res=\"bss_paymentMethodChange_changeMonthlyPaymentOption\"></h1></section><section class=\"row\"><section class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 thankYou\" style=\"margin-bottom:3rem;\"><section class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1\" style=\"padding-right:0px;\"><img src=\"images/Check.png\" class=\"checkImage\"></section><section class=\"col-lg-11 col-md-11 col-sm-10 col-xs-10\" style=\"margin-top:10px;\" res=\"bss_paymentMethodChange_sucess1\"><p class=\"inline\" res=\"bss_paymentMethodChange_sucess2\"></p></section></section></section><div><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_paymentMethodChange_confirmation\"></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\">784851192</section></div><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_paymentMethodChange_Account\"></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\">Store1&nbsp;<span style=\"font-weight:400\">{{ACCOUNT.ACCOUNTNO}}</span></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_paymentMethodChange_newPaymentMethod\"></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\"><p>{{updatedPaymentMethod}}</p><p><img src=\"{{cardUrl}}\" ng-show=\"showCardImage\">{{cardNumber}}</p></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_paymentMethodChange_date\"></section><section class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\">{{i18n[requiredMonth]}}&nbsp;{{requiredDate}}</section><section class=\"row\"><section class=\"col-lg-7 col-md-7 col-sm-8 col-xs-8 content\"><p res=\"bss_paymentMethodChange_instructionalCopy\"></p></section></section><section class=\"row col-xs-12 col-sm-12 col-md-12 col-lg-12\" style=\"margin-bottom:2rem;\"><section class=\"col-lg-3 col-md-3 col-xs-12 col-sm-12\"><a href=\"#\" class=\"cancel\" res=\"bss_paymentMethodChange_accountsOverviewLink\"><img class=\"arrow\" src=\"images/forwardArrow.png\"></a></section><section class=\"col-lg-6 col-md-6 col-xs-12 col-sm-10\"><a href=\"#\" class=\"cancel\" res=\"bss_paymentMethodChange_billingAndReportingLink\"><img src=\"images/forwardArrow.png\" class=\"arrow\"></a></section></section></div></div><div class=\"changePaymentMethodError\" ng-show=\"showChangePaymentMethodErrorSection\"><div class=\"\"><section class=\"row\"><section class=\"col-lg-12 col-md-12 col-sm-8 col-xs-11\"><h1 class=\"paymentError\">Change Payment Method Option</h1></section></section><section class=\"row\"><section class=\"col-lg-8 col-md-8 col-sm-8 col-xs-11 error\"><section style=\"margin-top:13px;padding-left:15px;\" class=\"col-lg-8 col-md-8\"><p class=\"inline\">Currently system unavailable. Please try again.</p></section></section></section><section class=\"row\"><section class=\"col-lg-2 col-md-2 cancel\"><a href=\"#\">Cancel</a></section></section></div></div></section>");
$templateCache.put("module/makePayment/makePayment.html","<div class=\"container makePaymentContainer\" ng-controller=\"makePaymentController\"><div class=\"hidden-xs hidden-sm loadingIndEn\" ng-show=\"loadingIndicator\"><img src=\"images/widget-loader-lg.gif\"></div><div class=\"hidden-md hidden-lg loadingIndEn\" ng-show=\"loadingIndicator\"><img src=\"images/widget-loader-lg_plain.gif\"></div><div ng-show=\"!showMakePaymentSection && !loadingIndicator\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 makePaymentNow\" res=\"bss_makePayment_makeAPayment\"></div><div class=\"row\" ng-show=\"makePaymentBreadCrumb[2].isActive\"><div class=\"col-lg-8 col-md-8 col-sm-12 col-xs-12 thankYou\"><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-1\" style=\"padding-right:0px;\"><img src=\"images/Check.png\" class=\"checkImage\"></div><div style=\"margin-top:10px;\" class=\"col-lg-11 col-md-11 col-sm-10 col-xs-10\">{{i18n.bss_makePayment_successMessage1}}<p class=\"inline\" res=\"bss_makePayment_successMessage2\"></p></div></div></div><div class=\"col-lg-12 col-md-12 hidden-xs hidden-sm selectChosenMethod\" ng-show=\"makePaymentBreadCrumb[0].isActive\" res=\"bss_makePayment_intro\"></div><ul class=\"nav nav-pills nav-wizard col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-hide=\"makePaymentBreadCrumb[2].isActive\"><li class=\"{{makePaymentBreadCrumb[0].selection}} col-lg-3 col-md-3 col-xs-6 col-sm-4 enter-info-tab\"><a class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"col-lg-2 col-md-2 col-xs-2 col-sm-2 circle\">1</div><div class=\"stepName\" res=\"bss_makePayment_enterInformation\"></div><div class=\"nav-arrow\"></div></a></li><li class=\"{{makePaymentBreadCrumb[1].selection}} col-lg-3 col-md-3 col-xs-3 col-sm-4 review-tab\"><a class=\"col-lg-12 col-xs-12\"><div class=\"nav-wedge\"></div><div class=\"col-lg-2 col-md-2 col-xs-2 col-sm-2 circle\">2</div><div class=\"stepName\" res=\"bss_makePayment_review\"></div><div class=\"nav-arrow\"></div></a></li><li class=\"{{makePaymentBreadCrumb[2].selection}} col-lg-3 col-md-3 col-xs-3 col-sm-4 confirm-tab\"><div class=\"nav-wedge\"></div><a class=\"col-lg-12 col-xs-12\"><div class=\"nav-wedge\"></div><div class=\"col-lg-2 col-md-2 col-xs-2 col-sm-2 circle\">3</div><div class=\"stepName\" res=\"bss_makePayment_confirm\"></div><div class=\"nav-arrow\"></div></a></li></ul><div class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 accountDetails\"><p class=\"label\" ng-show=\"makePaymentBreadCrumb[0].isActive\" res=\"bss_makePayment_paymentForAccount\"></p><p class=\"label\" ng-show=\"makePaymentBreadCrumb[1].isActive || makePaymentBreadCrumb[2].isActive\" res=\"bss_makePayment_accountNumber\"></p><div class=\"row\"><div class=\"col-lg-5 col-md-5 col-xs-12 col-sm-12 storeInfo\"><span class=\"storeName\">{{name}}</span><span class=\"number\">{{accountNo}}</span></div><div class=\"col-lg-7 col-md-7 col-xs-12 col-sm-12 balance\" ng-show=\"makePaymentBreadCrumb[0].isActive\"><span class=\"hidden-xs hidden-sm\"><span res=\"bss_makePayment_acountBalance_label\"></span> <span>{{currentDate|date:\'MM/dd/yyyy\'}}</span>:</span> <span ng-show=\"lng===\'en\'\"><sup>$</sup></span> <span class=\"amount\">{{dollar}}</span><span ng-show=\"lng===\'en\'\">.</span><span ng-show=\"lng===\'fr\'\">,</span><sup>{{cents}}</sup> <span ng-show=\"lng===\'fr\'\"><sup>$</sup></span><span class=\"hidden-md hidden-lg\">{{i18n.bss_makePayment_due}} <span>{{currentDate|date:\'MM/dd/yyyy\'}}</span></span></div></div></div><div class=\"enterInformation row\" ng-show=\"makePaymentBreadCrumb[0].isActive\" ng-form=\"enterInformationForm\"><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 paymentAmount\"><div class=\"paymentAmountInner\"><span res=\"bss_makePayment_amountDue\"></span> <span class=\"mandatory hidden-xs hidden-sm\">*</span></div><div class=\"row\"><div class=\"dollar\" ng-show=\"lng===\'en\'\">$</div><div class=\"col-lg-5 col-md-5 col-sm-11 col-xs-11\"><input type=\"text\" name=\"paymentAmount\" ng-model=\"paymentAmount\" ng-keyup=\"validatePaymentAmount()\" ng-class=\"{\'redBorder\' : isValidPaymentAmount == true}\" class=\"form-control\" required=\"\"></div><div class=\"dollar col-lg-1 col-md-1 col-xs-1 col-sm-1\" ng-show=\"lng===\'fr\'\">$</div><span class=\"styled-select-type beside-checker-payment icon-error\" ng-show=\"isValidPaymentAmount\"></span></div><div class=\"row\"><div><div ng-show=\"isValidPaymentAmount\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 inline_error\" res=\"bss_invalid_payment_amount\" message=\"\" image=\"images\\errorIcon.png\"></div></div></div></div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 selectPaymentMethod\"><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" style=\"padding-bottom:10px;\"><span class=\"hidden-xs hidden-sm\" res=\"bss_makePayment_selectPaymentMethod\"></span><span class=\"hidden-lg hidden-md\">Paying With</span></div><ul class=\"nav nav-tabs col-lg-9 col-md-9 hidden-xs hidden-sm\"><li class=\"active col-lg-6 col-md-6\"><a href=\"\" ng-click=\"showBankingSection(\'creditCard\')\" style=\"margin-right:10px;\" ng-class=\"{borderRedFirst:showCreditCardBanking, borderRedSecond:showOnlineBanking}\" res=\"bss_makePayment_creditCard\"></a></li><li class=\"active col-lg-6 col-md-6\"><a href=\"\" ng-click=\"showBankingSection(\'online\')\" ng-class=\"{borderRedSecond:showCreditCardBanking, borderRedFirst:showOnlineBanking}\" res=\"bss_makePayment_onlineBanking\"></a></li></ul><ul class=\"row hidden-lg hidden-md customizedRadioButtonsList\"><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" ng-show=\"!firstRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(\'creditCard\'); firstRadio=true;secondRadio=false;\" tabindex=\"0\" ng-enter=\"showBankingSection(\'creditCard\'); firstRadio=true;secondRadio=false;\"><img ng-show=\"firstRadio\" src=\"images/activeRadio.png\" ng-class=\"{customizedRadioButtonColor:firstRadio}\" tabindex=\"0\"> <span res=\"bss_makePayment_creditCard\"></span></li><li class=\"col-xs-12 col-sm-12\"><img src=\"images/inactiveRadio.png\" ng-show=\"!secondRadio\" class=\"customizedRadioButton\" ng-click=\"showBankingSection(\'online\'); firstRadio=false;secondRadio=true;\" tabindex=\"0\" ng-enter=\"showBankingSection(\'online\');firstRadio=false;secondRadio=true;\"><img ng-show=\"secondRadio\" src=\"images/activeRadio.png\" ng-class=\"{customizedRadioButtonColor:secondRadio}\" tabindex=\"0\"> <span res=\"bss_makePayment_onlineBanking\"></span></li></ul><div class=\"creditCardBanking\" ng-show=\"showCreditCardBanking\"><form-credit-card class=\"col-lg-6 col-md-12 col-sm-12 col-xs-12\" style=\"padding-right:0px\"></form-credit-card><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" id=\"cardNumberErrorSection\"><div class=\"inline_error\" ng-show=\"isValidCreditCardNumber\" res=\"bss_invalid_cc_number\"></div><div class=\"inline_error\" ng-show=\"isValidCreditCardScheme\" res=\"bss_invalid_cc_type\"></div></div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 labelMargin\" res=\"bss_makePayment_expirationDate\"></div><div class=\"col-lg-6 col-md-6 col-xs-12 col-sm-12\"><div class=\"focusBorder styled-month-select select-month col-lg-4 col-md-4 col-sm-4 col-xs-4\" ng-class=\"{redBorder:isValidMonth}\"><select name=\"monthName\" class=\"\" required=\"\" ng-model=\"selectedMonth\" ng-init=\"selectedMonth = $scope.months[0]\" ng-change=\"changeMonth(selectedMonth)\"><option value=\"\" class=\"\" disabled=\"true\" ng-selected=\"true\" res=\"bss_month\"></option><option ng-repeat=\"month in months\">{{month.value}}</option></select></div><div class=\"focusBorder styled-year-select select-year col-lg-5 col-md-5 col-sm-5 col-xs-5\" ng-class=\"{redBorder:isValidYear}\"><select name=\"yearValue\" class=\"\" required=\"\" ng-model=\"selectedYear\" ng-init=\"selectedYear = $scope.years[0]\" ng-change=\"changeYear(selectedYear)\"><option value=\"\" class=\"\" disabled=\"true\" ng-selected=\"true\" res=\"bss_year\"></option><option ng-repeat=\"year in years\">{{year}}</option></select></div><span class=\"styled-select-type beside-checker-payment icon-error\" ng-show=\"isValidMonth || isValidYear\"></span></div><div class=\"errorClass col-lg-7 col-md-7 col-sm-12 col-xs-12 inline_error\" ng-show=\"isValidMonth || isValidYear\" res=\"bss_invalid_cc_ex_date\" image=\"images\\errorIcon.png\"></div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12 labelMargin\" res=\"bss_makePayment_securityCode\"></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 securityCode\" style=\"padding-right: 7px;\"><div class=\"col-lg-2 col-md-2 col-sm-5 col-xs-5\" style=\"margin-right:15px\"><input type=\"text\" maxlength=\"3\" class=\"form-control\" numbers-only=\"\" ng-keyup=\"validateSecurityCode()\" ng-model=\"securityCode\" placeholder=\"XXX\" name=\"securityCode\" required=\"\" ng-class=\"{redBorder:isValidSecurityCode}\"></div><div class=\"col-lg-9 col-md-9 hidden-xs hidden-sm styleForDesktop\"><span class=\"popoverContent contentDesktopView\" data-toggle=\"popover\"><span><img id=\"cvvHelp\" src=\"images/informationIcon.png\"></span></span><div><span custom-popover=\"\" popover-placement=\"right\" popover-label=\"Label\"></span></div></div><div class=\"popoverContentDesktop\" style=\"display: none;\"><div class=\"col-lg-12\" style=\"padding-right:0px; margin-bottom:10px;\"><img class=\"popoverClose\" style=\"float:right;margin:0\" src=\"images/closeSecurityCode.png\"></div><div class=\"col-lg-12\" style=\"padding-right:0;\"><div class=\"col-lg-5\"><img src=\"images/securityCode.png\" style=\"max-width:100%\"></div><div class=\"col-lg-7\" style=\"padding-right:35px;text-align:justify;padding-left:5px;\" res=\"bss_makePayment_securityCodeDetail\"></div></div></div><div class=\"hidden-lg hidden-md col-sm-3 col-xs-3 popOverStyle\" style=\"padding-right:0\"><span class=\"popoverContent contentSmallDevices\"><span><img id=\"cvvHelpSmallDevices\" src=\"images/informationIcon.png\"></span></span><div><span custom-popover-smalldevice=\"\" popover-placement=\"bottom\" popover-label=\"Label\"></span></div></div><div class=\"popoverContentMobile\" style=\"display: none;\"><div class=\"col-xs-12 col-sm-12\" style=\"padding-right:0px; margin-bottom:20px;\"><img class=\"popoverClose\" style=\"float:right;margin:0\" src=\"images/closeSecurityCode.png\"></div><div class=\"col-xs-12 col-sm-12\" style=\"padding-right:26px;padding-bottom:35px;text-align:justify;padding-left:5px;\" res=\"bss_makePayment_securityCodeDetail\"></div><div class=\"col-xs-12 col-sm-12\"><img src=\"images/securityCode.png\" style=\"max-width:100%\"></div></div></div><div ng-show=\"isValidSecurityCode\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 inline_error\" res=\"bss_invalid_ccv_value\" image=\"images\\errorIcon.png\"></div></div><div class=\"onlineBanking col-lg-9 col-md-9 col-xs-12 col-sm-12\" ng-show=\"showOnlineBanking\"><p res=\"bss_makePayment_onlineBankingInfo1\"></p><p res=\"bss_makePayment_onlineBankingInfo2\"></p><ul style=\"list-style-type:decimal\"><li res=\"bss_makePayment_onlineBankingInfo3\"></li><li res=\"bss_makePayment_onlineBankingInfo4\"></li><li res=\"bss_makePayment_onlineBankingInfo5\"></li></ul><p res=\"bss_makePayment_onlineBankingInfo6\"></p><div class=\"row bankLinks\"><span class=\"col-lg-4 col-md-4 col-xs-6 col-sm-6\" ng-repeat=\"bankDetail in bankDetails\"><a class=\"\" href=\"{{bankDetail.href}}\" target=\"_blank\"><span class=\"{{bankDetail.name}} col-lg-12 col-md-12 col-xs-12 col-sm-12\"></span></a></span></div></div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" ng-hide=\"showOnlineBanking\"><section class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><button type=\"button\" class=\"continueReview\" ng-click=\"validateEnterInformationForm()\"><span class=\"row\"><span class=\"col-lg-12 col-sm-12 col-md-12 col-xs-12\" res=\"bss_makePayment_continue\">&nbsp; <img src=\"images/lock.png\"></span></span></button></section><section class=\"col-lg-2 col-md-2 col-xs-12 col-sm-12 cancel\" style=\"z-index:-1\"><a href=\"#\" res=\"bss_makePayment_cancel\"></a></section></div><div class=\"col-lg-12 col-md-12 col-xs-12 col-sm-12\" ng-show=\"showOnlineBanking\"><section class=\"col-lg-2 col-md-2 col-xs-5 col-sm-5 cancel\" style=\"padding-top:0px;\"><a href=\"#\">{{i18n.bss_makePayment_cancel}}</a></section></div></div></div><div class=\"reviewAndConfirmation\" ng-show=\"makePaymentBreadCrumb[1].isActive || makePaymentBreadCrumb[2].isActive\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_makePayment_paymentAmount\"></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\" ng-bind=\"paymentAmount\"></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_makePayment_paymentMethod\"></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\"><img src=\"{{cardUrl}}\" width=\"30\" and=\"\" height=\"20\">&nbsp;<span ng-bind=\"creditCardNumber\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewLabel\" res=\"bss_makePayment_date\"></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 reviewContent\">{{i18n[requiredMonth]}}&nbsp;{{requiredDate}}</div><div class=\"col-lg-7 col-md-7 col-sm-8 col-xs-8 content\" ng-show=\"makePaymentBreadCrumb[2].isActive\"></div><div ng-show=\"makePaymentBreadCrumb[1].isActive\" class=\"reviewLabel\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 editPaymentInfo\"><a href=\"#\" ng-click=\"editInfo()\"><img src=\"images/Arrow.png\" class=\"arrow\">&nbsp;<span res=\"bss_makePayment_editPaymentInformation\"></span></a></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"margin-top:10px;margin-bottom:3rem;\"><div class=\"col-lg-2 col-md-2 col-sm-12 col-xs-12 payNowSection\"><button type=\"button\" class=\"payNow\" ng-click=\"submitPayment()\" res=\"bss_makePayment_payNow\">&nbsp;<img src=\"images/lock.png\" width=\"11\" height=\"14\" style=\"padding-bottom:3px;\"></button></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2 cancel\" style=\"padding-top:7px;\"><a href=\"#\" res=\"bss_makePayment_cancel\"></a></div></div></div><div ng-show=\"makePaymentBreadCrumb[2].isActive\" class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\" style=\"margin-bottom:30px;\"><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><a href=\"#/accountOverview\" class=\"cancel\"><span res=\"bss_makePayment_accountsOverviewLink\"></span><img class=\"arrow\" src=\"images/Arrow.png\"></a></div><div class=\"col-lg-5 col-md-5 col-sm-10 col-xs-12\"><a ng-click=\"redirectToLegacyPayment()\" class=\"cancel\"><span res=\"bss_makePayment_billingAndReportingLink\"></span><img src=\"images/Arrow.png\" class=\"arrow\"></a></div></div></div></div><div class=\"makePaymentError\" ng-show=\"showMakePaymentErrorSection\"><div class=\"\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-8 col-xs-11\"><h1 class=\"paymentError\">Make a Payment Now</h1></div></div><div class=\"row\"><div class=\"col-lg-8 col-md-8 col-sm-8 col-xs-11 error\"><div style=\"margin-top:13px;padding-left:15px;\" class=\"col-lg-8 col-md-8\"><p class=\"inline\" ng-show=\"content == \'bss_makePayment_invalid_cc\" res=\"bss_makePayment_invalid_cc\"></p><p class=\"inline\" ng-show=\"content == \'bss_makePayment_generic_error\" res=\"bss_makePayment_generic_error\"></p></div></div></div><div class=\"row\"><div class=\"col-lg-2 col-md-2 cancel\"><a href=\"#/accountOverview\">Cancel</a></div></div></div></div></div>");
$templateCache.put("module/paymentHistory/paymentHistory.html","<div class=\"container\"><div id=\"paymentHistory\" ng-controller=\"paymentHistoryController\"><div class=\"row\"><div class=\"breadCrumbs col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"previousContainer\"><a ng-click=\"redirectToLegacyPayment ()\" style=\"cursor: pointer;\" class=\"textPreviousContainer\"><span res=\"bss_paymentHistory_backToPreviousPage\"></span></a> <a ng-click=\"redirectToLegacyPayment ()\" style=\"cursor: pointer;\" class=\"textPreviousContainerMobile\"><span res=\"bss_paymentHistory_backToPreviousPage\"></span></a></div><div class=\"sectionTitle col-xs-12 col-sm-12 col-md-8 col-lg-8\" res=\"bss_paymentHistory_paymentHistory\"></div></div></div><div class=\"loading-container\" ng-show=\"loadingIndicator\"><div class=\"hidden-xs hidden-sm loadingIndEn\"><img src=\"images/widget-loader-lg.gif\"></div><div class=\"hidden-md hidden-lg loadingIndEn\"><img src=\"images/widget-loader-lg_plain.gif\"></div></div><div class=\"content\" ng-show=\"!showPaymentHistoryErrorSection && !loadingIndicator\"><div class=\"accountDetails col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"accountHeading hidden-xs hidden-sm col-md-8 col-lg-8\" res=\"bss_paymentHistory_accountHeading\"></div><div class=\"accountNumber col-xs-12 col-sm-12 col-md-8 col-lg-8\"><span class=\"accountNickName\">{{accountNickName}}</span><span>{{accountNo}}</span></div></div><div class=\"row paginationContainer\" ng-show=\"showPaymentHistoryRecordsSection\"><div class=\"hidden-xs hidden-sm col-md-8 col-lg-8\"><div class=\"pageNumbers\"><div><a class=\"next\" href=\"\" ng-hide=\"hideNext\" ng-click=\"pagenumberScrollHolderatePage(\'next\')\"></a></div><div class=\"pagenumberScrollHolder\"><div ng-style=\"{\'left\':leftProperty}\" class=\"pagenumberScroll\"><a class=\"pageNumberDigit\" href=\"\" ng-repeat=\"id in ctrlArr\" ng-class=\"{activePage:activePageIndex==\'{{$index}}\'}\" ng-click=\"pagenumberScrollHolderatePage($index)\">{{id}}</a></div></div><div><span>{{i18n.bss_paymentHistory_paginationInfo1}} {{currentPage}} - {{(currentPage+9)>listLength?listLength:currentPage+9}}<span res=\"bss_paymentHistory_paginationInfo2\"></span>{{listLength}}</span> <a class=\"prev\" href=\"\" ng-hide=\"hidePrev\" ng-click=\"pagenumberScrollHolderatePage(\'prev\')\"></a></div></div></div></div><div class=\"row rowheading\"><div class=\"header-container col-xs-12 col-sm-12 col-md-8 col-lg-8 padding-reset\"><div class=\"col-xs-5 col-sm-5 col-md-3 col-lg-3 date\" ng-click=\"orderPayHistoryLabel(\'transDate\')\"><span ng-class=\"{activeSort:sortLable === \'transDate\'}\" res=\"bss_paymentHistory_date\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'transDate\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'transDate\')&& orderToggle\">&#x25BC;</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3 transactionType\" ng-click=\"orderPayHistoryLabel(\'tranType\')\"><span ng-class=\"{activeSort:sortLable === \'tranType\'}\" res=\"bss_paymentHistory_transaction\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'tranType\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'tranType\')&& orderToggle\">&#x25BC;</span></div><div class=\"col-xs-4 col-sm-4 col-md-3 col-lg-3 amount\" ng-click=\"orderPayHistoryLabel(\'amount\')\"><span ng-class=\"{activeSort:sortLable === \'amount\'}\" res=\"bss_paymentHistory_amount\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'amount\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'amount\')&& orderToggle\">&#x25BC;</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3 refNo\" ng-click=\"orderPayHistoryLabel(\'refNo\')\"><span ng-class=\"{activeSort:sortLable === \'refNo\'}\" res=\"bss_paymentHistory_reference\"></span> <span class=\"sortorder\" ng-show=\"isActive(\'refNo\') && orderToggle\">&#x25B2;</span> <span class=\"sortorder\" ng-hide=\"isActive(\'refNo\')&& orderToggle\">&#x25BC;</span></div><div class=\"col-xs-3 col-sm-3 hidden-md hidden-lg payDetailAccordion\"></div></div></div><div ng-show=\"showPaymentHistoryRecordsSection\" class=\"row\" id=\"history{{$index}}\" ng-class=\"{lastDetail:$index==pageList.length-1}\" ng-repeat=\"list in pageList| orderBy:sortLable:reverse | startFrom: currentPage-1 |limitTo:limiter\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8 rowlist\"><div class=\"row listcontent\"><div class=\"col-xs-5 col-sm-5 col-md-3 col-lg-3 date\"><span>{{list.transDate | date:\'MMM dd,yyyy\'}}</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3 transactionType\"><span>{{list.tranType}}</span></div><div class=\"col-xs-4 col-sm-4 col-md-3 col-lg-3 amount\"><span>{{list.amount|currency}}</span></div><div class=\"hidden-xs hidden-sm col-md-3 col-lg-3\"><span>{{list.refNo}}</span></div><div class=\"col-xs-3 col-sm-3 hidden-md hidden-lg payDetailAccordion\"><span ng-click=\"detailsShowHide($index)\">{{i18n.bss_paymentHistory_detail}} <span ng-hide=\"showDetails[$index]\">[+]</span> <span ng-show=\"showDetails[$index]\">[&#8212]</span></span></div></div></div><div class=\"row paymentDetails\" ng-if=\"showDetails[$index]\"><div class=\"paymentDetailsBackground\"><div class=\"details-container\"><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_paymentDate\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.transDate | date:\'MMM dd,yyyy\'}}</div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_transaction\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.tranType}}</div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_amount\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.amount}}</div></div><div class=\"row\"><div class=\"col-xs-5 col-sm-5\" res=\"bss_paymentHistory_reference\"></div><div class=\"col-xs-7 col-sm-7 paymentDetailsContent\">{{list.refNo}}</div></div></div></div></div></div><div ng-show=\"!showPaymentHistoryRecordsSection\" class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\"><div class=\"noRecordsFound\" res=\"bss_paymentHistory_noRecordsFound\"></div></div></div><div class=\"row paginationContainer\" ng-show=\"showPaymentHistoryRecordsSection\"><div class=\"hidden-xs hidden-sm col-md-8 col-lg-8\"><div class=\"pageNumbers\"><div style=\"\"><a class=\"next\" href=\"\" ng-hide=\"hideNext\" ng-click=\"pagenumberScrollHolderatePage(\'next\')\"></a></div><div class=\"pagenumberScrollHolder\"><div ng-style=\"{\'left\':leftProperty}\" class=\"pagenumberScroll\"><a class=\"pageNumberDigit\" href=\"\" ng-repeat=\"id in ctrlArr\" ng-class=\"{activePage:activePageIndex==\'{{$index}}\'}\" ng-click=\"pagenumberScrollHolderatePage($index)\">{{id}}</a></div></div><div style=\"\"><span><span res=\"bss_paymentHistory_paginationInfo1\"></span> {{currentPage}} - {{(currentPage+9)>listLength?listLength:currentPage+9}} <span res=\"bss_paymentHistory_paginationInfo2\"></span>{{listLength}}</span> <a class=\"prev\" href=\"\" ng-hide=\"hidePrev\" ng-click=\"pagenumberScrollHolderatePage(\'prev\')\"></a></div></div></div></div><div class=\"row mobilePaginationContainer\" ng-show=\"showPaymentHistoryRecordsSection\"><div class=\"col-xs-12 col-sm-12 hidden-md hidden-lg\"><div class=\"pageNumbers\"><span><span res=\"bss_paymentHistory_paginationInfo1\"></span> 1 - {{limiter}} <span res=\"bss_paymentHistory_paginationInfo2\"></span> {{listLength}}</span></div><div class=\"row paginationButton\"><button type=\"button\" class=\"pageNumberButton col-xs-12 col-sm-12\" ng-show=\"showNextButton\" ng-click=\"clicker()\">Show Next {{leftover}}</button></div></div></div></div><div class=\"paymentHistoryError\" ng-show=\"showPaymentHistoryErrorSection\"><div class=\"row\"><div class=\"col-xs-10 col-sm-10 col-md-8 col-lg-8 error\"><div res=\"bss_paymentHistory_systemError1\"></div><div res=\"bss_paymentHistory_systemError2\"></div></div></div></div></div></div>");
$templateCache.put("module/myrPaymentHelper/paymentHelper.view.html","<div class=\"ute-paymentHelper\"><div class=\"container\"><div class=\"ute-paymentHelper-heading-group\"><div class=\"ute-paymentHelper-heading\"><span translate=\"ute.rogers.myrPaymentHelper.need_help_with_your_bill\"></span></div></div><a class=\"ute-paymentHelper-button\" href=\"https://www.rogers.com/web/content/support?N=42+134\" target=\"_blank\"><span translate=\"ute.rogers.myrPaymentHelper.visit_billing_support\"></span> <span class=\"ute-paymentHelper-icon-arrow-right\"></span></a> <a class=\"ute-paymentHelper-link\" ng-href=\"{{\'ute.rogers.myrPaymentHelper.reviewLink\' | translate}}\" target=\"_blank\"><span translate=\"ute.rogers.myrPaymentHelper.paynow_faq\"></span> <span class=\"ute-paymentHelper-icon-arrow-right\"></span></a><div class=\"ute-paymentHelper-chat\"><bold-chat-static-button data-cbid=\"{{\'ute.rogers.myrPaymentHelper.boldChatButtonId\' | translate}}\" data-dynamic-div=\"{{\'ute.rogers.myrPaymentHelper.boldChatButtonDiv\' | translate}}\" data-chat-button=\"{{\'ute.rogers.myrPaymentHelper.boldChatButton\' | translate}}\"></bold-chat-static-button></div></div></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnMain.view.html","<ui-view></ui-view>");
$templateCache.put("module/resetVoiceMailbox/resetVoiceMailbox.html","<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span res=\"wireless\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\"><div class=\"reset-voice-mailbox\"><div class=\"header\"><span translate=\"rvm.header\"></span> <span ng-bind-html=\"rvm.phoneNumber | tel\"></span></div><div class=\"main col-xs-12 col-sm-6 col-md-6 col-lg-6\" ng-hide=\"rvm.submitted\"><div class=\"subHeader\" translate=\"rvm.subHeader\"></div><div class=\"update\" translate=\"rvm.msg2\"></div><div class=\"btn-ctnr\"><div class=\"cancel-btn hidden-xs hidden-sm\" ng-click=\"rvm.back()\" translate=\"rvm.cancel\"></div><div ng-click=\"rvm.reset()\" class=\"submit-btn col-xs-12 col-sm-12 hidden-md hidden-lg\" translate=\"rvm.reset\"></div><div ng-click=\"rvm.reset()\" class=\"submit-btn hidden-xs hidden-sm\" translate=\"rvm.reset\"></div><span ng-show=\"rvm.loading\"><img ng-src=\"ute-change-subscriber-name/assets/loader-rg.gif\"></span><div class=\"cancel-btn col-xs-12 col-sm-12 hidden-md hidden-lg\" ng-click=\"rvm.back()\" translate=\"rvm.cancel\"></div></div></div><div ng-show=\"rvm.submitted\"><div class=\"success\" ng-if=\"rvm.success\"><div class=\"success-banner row col-xs-12 col-sm-6 col-md-5 col-lg-5\"><div class=\"check-ctnr col-xs-1 col-sm-1 col-md-1 col-lg-1\"><img ng-src=\"ute-reset-voicemail-box/assets/checkIcon.png\"></div><div class=\"success-msg col-xs-11 col-sm-11 col-md-11 col-lg-11\"><div class=\"success-header\" translate=\"rvm.success\"></div><div translate=\"rvm.successSub\"></div></div></div></div><div class=\"failure row col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"!rvm.success\"><div class=\"failure-banner row col-xs-12 col-sm-6 col-md-5 col-lg-5\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><div class=\"error-icon\"><img src=\"ute-reset-voicemail-box/assets/errorIcon.png\"></div></div><div class=\"failure-msg col-xs-11 col-sm-11 col-md-11 col-lg-11\"><div class=\"success-header\" translate=\"rvm.failure\"></div><div translate=\"rvm.failureSub\"></div></div></div></div><div class=\"row col-xs-12 col-sm-12 col-md-12 col-lg-12 go-back\" ng-click=\"rvm.back()\" translate=\"rvm.back\"></div></div></div></div>");
$templateCache.put("module/resetVoicemailPasswordDirective/resetVoicemailPassword.directive.view.html","<a data-ng-click=\"voicemailResetPassword.openModalPopup(\'md\', \'\')\" class=\"ute-resetVoicemailPassword-link\"><strong translate=\"ute.voicemail.resetPassword.directive.updateVoicemailPassword.{{voicemailResetPassword.userType}}\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_voicemail-password\"></strong> <span class=\"ute-resetVoicemailPassword-icon-button-arrow-right\"></span></a>");
$templateCache.put("module/resetVoicemailPasswordDirective/resetVoicemailPassword.modal.view.html","<div class=\"ute-resetVoicemailPassword-modal\" data-ng-show=\"!resetPasswordModal.updateSuccessful\"><form name=\"resetVoicemailPasswordForm\" novalidate=\"\"><div class=\"ute-resetVoicemailPassword-headingGroup\"><div class=\"ute-resetVoicemailPassword-heading\"><span translate=\"ute.voicemail.resetPassword.modalPopup.title\"></span></div></div><div class=\"ute-resetVoicemailPassword-typeGroup\"><div class=\"ute-resetVoicemailPassword-typeBody\"><span translate=\"ute.voicemail.resetPassword.modalPopup.subTitle\"></span></div></div><div data-ng-if=\"resetPasswordModal.errorMessagePath().length > 0\" class=\"ute-resetVoicemailPassword-errorMessage\"><img class=\"ute-resetVoicemailPassword-messageIcon\" data-ng-src=\"ute-common-assets/assets/error_warning.png\"><div class=\"ute-resetVoicemailPassword-messageBody\"><span translate=\"{{resetPasswordModal.errorMessagePath()}}\"></span></div></div><div data-ng-if=\"resetPasswordModal.showChatOption()\" class=\"ute-resetVoicemailPassword-boldChatLink\"><span translate=\"ute.voicemail.resetPassword.responseMessage.contactUs01\"></span><bold-chat-static-button data-cbid=\"{{\'ute.voicemail.resetPassword.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.voicemail.resetPassword.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.voicemail.resetPassword.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button><span translate=\"ute.voicemail.resetPassword.responseMessage.contactUs02\"></span></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-sm-push-6 col-md-6 col-md-push-6 col-lg-6 col-lg-push-6\"><div class=\"ute-resetVoicemailPassword-footnote\"><br class=\"hidden-xs\"><span translate=\"ute.voicemail.resetPassword.modalPopup.passwordInstruction\"></span></div></div><div class=\"col-xs-12 col-sm-6 col-sm-pull-6 col-md-6 col-md-pull-6 col-lg-6 col-lg-pull-6\"><div class=\"ute-resetVoicemailPassword-inputGroup\"><div class=\"ute-resetVoicemailPassword-inputTextLabel\"><span translate=\"ute.voicemail.resetPassword.modalPopup.newPassword\"></span></div><input data-ng-class=\"(resetVoicemailPasswordForm.newVoicemailPassword.$invalid && resetVoicemailPasswordForm.$submitted) ? \'ute-resetVoicemailPassword-inputTextError\' : \'ute-resetVoicemailPassword-inputText\'\" type=\"text\" name=\"newVoicemailPassword\" id=\"newVoicemailPassword\" data-ng-model=\"resetPasswordModal.model.newVoicemailPassword\" maxlength=\"5\" data-minlength=\"4\" required=\"\" data-ng-minlength=\"4\" data-ng-maxlength=\"5\" data-ng-required=\"true\" data-ng-pattern=\"/^[0-9]{1,5}$/\" data-ng-click=\"resetPasswordModal.inputOnClick($event)\" ute-numbers-only-input=\"\"></div><div class=\"ute-resetVoicemailPassword-inputGroup\"><div class=\"ute-resetVoicemailPassword-inputTextLabel\"><span translate=\"ute.voicemail.resetPassword.modalPopup.confirmPassword\"></span></div><input data-ng-class=\"(resetVoicemailPasswordForm.confirmVoicemailPassword.$invalid && resetVoicemailPasswordForm.$submitted) ? \'ute-resetVoicemailPassword-inputTextError\' : \'ute-resetVoicemailPassword-inputText\'\" type=\"text\" name=\"confirmVoicemailPassword\" id=\"confirmVoicemailPassword\" data-ng-model=\"resetPasswordModal.model.confirmVoicemailPassword\" maxlength=\"5\" data-minlength=\"4\" required=\"\" data-ng-minlength=\"4\" data-ng-maxlength=\"5\" data-ng-required=\"true\" data-ng-pattern=\"/^[0-9]{1,5}$/\" data-ng-click=\"resetPasswordModal.inputOnClick($event)\" ute-numbers-only-input=\"\"></div><div class=\"ute-resetVoicemailPassword-buttonGroupFlush\"><button name=\"button_cancel\" class=\"ute-resetVoicemailPassword-cancel\" data-ng-click=\"resetPasswordModal.cancel()\"><span translate=\"ute.voicemail.resetPassword.modalPopup.cancel\"></span></button> <button name=\"button_continue\" class=\"ute-resetVoicemailPassword-submit\" data-ng-click=\"resetPasswordModal.submit(resetVoicemailPasswordForm)\" data-ng-disabled=\"resetPasswordModal.isCallInProgress()\"><span translate=\"ute.voicemail.resetPassword.modalPopup.submit\"></span></button> <span class=\"ute-resetVoicemailPassword-buttonLoader\" data-ng-show=\"resetPasswordModal.isCallInProgress()\"><img data-ng-src=\"ute-common-assets/assets/widget-loader.gif\"></span></div></div></div></form></div><div data-ng-show=\"resetPasswordModal.updateSuccessful\"><div class=\"ute-resetVoicemailPassword-modalHeadingGroup\"><img class=\"ute-resetVoicemailPassword-modalHeadingIcon\" data-ng-src=\"ute-common-assets/assets/green-checkbox.png\"><div class=\"ute-resetVoicemailPassword-modalHeading\" translate=\"ute.voicemail.resetPassword.responseMessage.successTitle\"></div></div><div class=\"ute-resetVoicemailPassword-modalTypeGroup\"><div class=\"ute-resetVoicemailPassword-modalTypeBody\"><span translate=\"ute.voicemail.resetPassword.responseMessage.successMessage\"></span></div></div></div><img class=\"ute-resetVoicemailPassword-modalClose\" data-ng-click=\"resetPasswordModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/resetVoicemailPasswordDirective/resetVoicemailPasswordWindow.modal.view.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-resetVoicemailPassword-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/registrationConfirmation/registrationConfirmation.html","<div class=\"myrRegistration-confirmation\"><div class=\"container\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.rogers.user.registration.email.verification\"></span></li></ul></div><div class=\"mbl\"></div><div class=\"row desc-font-size-18\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\"><div data-translate=\"ute.rogers.user.registration.email.verification.msg\"></div><p><span data-translate=\"ute.rogers.user.registration.email.verfication.your.email\"></span> <strong data-ng-bind=\"::registration.emailAddress\"></strong></p></div></div></div></div>");
$templateCache.put("module/registrationStart/userRegistration.html","<div class=\"page-registration\"><div class=\"container\"><form name=\"registration.form\" novalidate=\"\" data-label=\"Registration\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.rogers.user.registration.registration\"></span></li></ul></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 mtm\"><div class=\"row info-banner error mts mbm\" data-ng-if=\"registration.errorCode.frontendMessageKey\" style=\"margin-left: 0;\"><dtm-error-form-field data-service=\"registration.dtmService\" data-key=\"registration.dtmName\"></dtm-error-form-field><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\" style=\"float:left\"><span data-translate=\"{{registration.errorCode.frontendMessageKey}}\"></span><div id=\"myr-registration\"><bold-chat-static-button data-cbid=\"{{registration.errorCode.boldChat.cbid | translate}}\" data-dynamic-div=\"{{registration.errorCode.boldChat.dynamicDivId | translate}}\" data-chat-button=\"{{registration.errorCode.boldChat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div></div></div><div class=\"row info-banner error mts mbm\" data-ng-if=\"( registration.form.$submitted && !registration.form.$valid )\" style=\"margin-left: 0;\"><dtm-error-form-field data-service=\"registration.dtmService\" data-key=\"registration.dtmName\"></dtm-error-form-field><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><span data-translate=\"ute.common.label.check.form.errors\"></span></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h4><span data-translate=\"ute.common.label.contact.info\"></span></h4></div></div><div class=\"row mbm\"><div class=\"col-lg-6 col-md-5\"><div class=\"inline_error\" data-ng-messages=\"registration.form.email.$error\" data-ng-if=\"( registration.form.$submitted || registration.form.email.$dirty ) && registration.form.email.$invalid\"><dtm-error-form-field data-service=\"registration.dtmService\" data-key=\"registration.dtmName\"></dtm-error-form-field><span data-ng-message=\"required\"><span data-translate=\"ute.rogers.user.registration.require.email\"></span></span> <span data-ng-message=\"pattern\"><span data-translate=\"ute.rogers.user.registration.email.address.not.valid\"></span></span></div><label class=\"rel\"><input type=\"text\" xvalidation-tag=\"\" data-tag-form-name=\"registration.form\" data-tag-page-name=\"Registration\" name=\"email\" id=\"email\" data-ng-pattern=\"/^\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" translate=\"\" data-translate-attr-placeholder=\"ute.common.label.email.address\" maxlength=\"105\" data-ng-model-options=\"registration.modelOptions\" data-onpaste=\"return false;\" data-ng-model=\"registration.model.email\" required=\"\" data-autocorrect=\"off\" data-autocapitalize=\"off\"> <span class=\"inline-checker icon-error\" data-ng-show=\"registration.form.email.$invalid && (registration.form.email.$dirty || registration.form.$submitted)\"></span> <span data-ng-show=\"registration.form.email.$dirty && registration.form.email.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-lg-6 col-md-5\"><div class=\"inline_error\" data-ng-messages=\"registration.form.confirmEmail.$error\" data-ng-if=\"( registration.form.$submitted || registration.form.confirmEmail.$dirty ) && registration.form.confirmEmail.$invalid\"><dtm-error-form-field data-service=\"registration.dtmService\" data-key=\"registration.dtmName\"></dtm-error-form-field><span data-ng-message=\"required\"><span data-translate=\"ute.rogers.user.registration.require.confirm.email\"></span></span> <span data-ng-message=\"pattern\"><span data-translate=\"ute.rogers.user.registration.email.address.not.valid\"></span></span> <span data-ng-message=\"matches\"><span data-translate=\"ute.rogers.user.registration.email.not.matched\"></span></span></div><label class=\"rel\"><input type=\"text\" name=\"confirmEmail\" data-tag-form-name=\"registration.form\" data-tag-page-name=\"Registration\" translate=\"\" data-translate-attr-placeholder=\"ute.common.label.email.confirm\" data-ng-model-options=\"registration.modelOptions\" matches=\"registration.form.email\" data-ng-model=\"registration.model.confirmEmail\" data-onpaste=\"return false;\" required=\"\" data-autocorrect=\"off\" data-autocapitalize=\"off\"> <span class=\"inline-checker icon-error\" data-ng-show=\"registration.form.confirmEmail.$invalid && (registration.form.confirmEmail.$dirty || registration.form.$submitted)\"></span> <span data-ng-show=\"registration.form.confirmEmail.$dirty && registration.form.confirmEmail.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 lang-btn-ctn mbm\"><div class=\"rui-content-block intro mtm\"><span class=\"content\"><p data-translate=\"ute.common.label.language.preference\"></p></span></div><label class=\"btn btn-default left\" data-ng-class=\"registration.model.lang == lang ? \'box_selected\' : \'radio_unselected\'\" data-ng-repeat=\"(lang, title) in registration.languages\"><input type=\"radio\" data-ng-model=\"registration.model.lang\" data-ng-value=\"lang\" value=\"{{::title}}\"> <span class=\"prm\" data-ng-bind=\"::title\"></span></label></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 mtm\"><div class=\"pull-left mtm\"><a data-ui-sref=\"{{::registration.getCancelStateName()}}\" class=\"link-cancel\" data-translate=\"ute.common.label.cancel\"></a></div><div class=\"pull-right\" data-ng-show=\"registration.isUserRegistrationCallInProgress()\"><span class=\"widget-loader-inline\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div class=\"pull-right\"><button name=\"button_continue\" data-ng-click=\"registration.submit()\" class=\"cta-round primary medium full\"><span data-translate=\"ute.common.label.continue\"></span></button></div></div></div></form></div></div>");
$templateCache.put("module/simCard/simCardHeader.partial.html","<div class=\"container\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text\">{{sc.getCtn() | ute_common_filter_phone}}</div></div></div>");
$templateCache.put("module/simCard/simCardMain.view.html","<section><div data-ng-include=\"sc.simCardHeaderPartialPath\"></div><ui-view></ui-view></section><myr-payment-helper></myr-payment-helper><div style=\"display: none;\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"ProfileAccountNumber\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"selectedAccountNumber\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"accountNum\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"accountNumber\"><br><input type=\"text\" data-ng-model=\"briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"></form></div>");
$templateCache.put("module/forgotPassword/emailRetriggerConfirmationPopup.html","<div class=\"confirmation-popup\"><button type=\"button\" class=\"close-popup\" data-ng-click=\"forgotPasswordCtrl.closeConfirmationPopup()\">&times;</button><div class=\"confirmation-popup-header\" res=\"confirmation_modal_title\" data-ng-if=\"forgotPasswordCtrl.autoRegSuccess\"></div><div class=\"confirmation-popup-body\" data-ng-if=\"forgotPasswordCtrl.autoRegSuccess\"><span res=\"confirmation_modal_msg_1\"></span> <strong data-ng-bind=\"forgotPasswordCtrl.selectedEmailForAutoReg\"></strong> <span res=\"confirmation_modal_msg_2\"></span><div ng-if=\"forgotPasswordCtrl.apiCount === 4\" res=\"retrigger_msg_attempt_4\"></div><div ng-if=\"forgotPasswordCtrl.apiCount === 5\" res=\"retrigger_msg_attempt_5\"></div></div><div class=\"confirmation-popup-button\"><span><a class=\"confirm-btn\" data-ng-click=\"forgotPasswordCtrl.closeConfirmationPopup()\" res=\"confirm_btn\"></a></span></div></div>");
$templateCache.put("module/forgotPassword/forgotPassword.html","<div class=\"ute-rogers-forgot-password\" data-ng-if=\"!forgotPasswordCtrl.showMigrationContent\"><div class=\"container\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.common.label.password.forgot\"></span></li><li class=\"widget-loader sign-in\" data-ng-show=\"forgotPasswordCtrl.isRogersForgotPasswordCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></li></ul></div><div id=\"forgotPassword-success\" class=\"row\" data-ng-if=\"forgotPasswordCtrl.model.isServiceCallSuccess\"><div class=\"col-xs-12 check-email\"><span data-translate=\"ute.rogers.forgotPassword.check.your.email\"></span></div><div class=\"col-xs-12 check-email-message\"><span data-translate=\"ute.rogers.forgotPassword.check.email.message\" data-translate-values=\"{email: \'{{forgotPasswordCtrl.model.email}}\'}\" data-ng-if=\"forgotPasswordCtrl.isLegacyUser()\"></span> <span data-translate=\"ute.rogers.forgotPassword.check.email.legacymessage\" data-translate-values=\"{email: \'{{forgotPasswordCtrl.model.email}}\'}\" data-ng-if=\"!forgotPasswordCtrl.isLegacyUser()\"></span></div></div><form name=\"forgotPasswordCtrl.form\" novalidate=\"\" data-ng-if=\"!forgotPasswordCtrl.model.isServiceCallSuccess\"><div class=\"row\"><div class=\"col-lg-12\"><h5 class=\"password-help-txt black\" data-translate=\"ute.common.form.secured\"></h5></div><div class=\"col-lg-12\"><h5 class=\"password-help-txt black\" data-translate=\"ute.rogers.forgotPassword.descriptionMessage\"></h5></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 forgot-password-section\"><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\"><div class=\"col-xs-12 col-sm-12 col-md-11 col-lg-11\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label class=\"rel\"><input id=\"email\" name=\"email\" type=\"text\" required=\"\" translate=\"\" data-ng-model=\"forgotPasswordCtrl.model.email\" data-translate-attr-placeholder=\"ute.rogers.forgotPassword.userName\" maxlength=\"105\"> <span class=\"inline-checker icon-error\" data-ng-show=\"(forgotPasswordCtrl.form.email.$invalid && (forgotPasswordCtrl.form.email.$dirty || forgotPasswordCtrl.form.$submitted))\"></span> <i data-ng-show=\"forgotPasswordCtrl.form.email.$dirty && forgotPasswordCtrl.form.email.$valid && forgotPasswordCtrl.model.email == forgotPasswordCtrl.model.newPassword\" class=\"inline-checker icon-checked\"></i></label></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-11 col-lg-11\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 action-button\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 pull-right\"><button name=\"button_continue\" data-ng-click=\"forgotPasswordCtrl.submit()\" data-ng-disabled=\"!forgotPasswordCtrl.isSubmitButtonEnable()\" class=\"primary medium btn-continue\"><span data-translate=\"ute.common.label.continue\"></span></button></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><button name=\"button_cancel\" data-ng-click=\"forgotPasswordCtrl.cancel()\" class=\"btn btn-link link-cancel btn-cancel\"><span data-translate=\"ute.common.label.cancel\"></span></button></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 forgot-password-right\"><div class=\"col-xs-11 col-sm-11 col-md-12 col-lg-12\"><span class=\"need-help-text\" data-translate=\"ute.common.label.need.help\"></span><br><bold-chat-static-button class=\"col-md-3 col-lg-3 col-xs-12 col-sm-12\" data-cbid=\"{{\'ute.rogers.forgotPassword.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.rogers.forgotPassword.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.rogers.forgotPassword.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button></div></div></div><div class=\"row input-password\"><div class=\"col-md-6 col-lg-6\"></div></div></div></form></div></div><div class=\"reset-password\" data-ng-if=\"forgotPasswordCtrl.showMigrationContent\"><div class=\"container\"><div class=\"row\"><div class=\"reset-password-heading\" res=\"reset_password_heading\"></div><div class=\"reset-password-body\" res=\"reset_password_body\"></div><div class=\"accounts\" data-ng-if=\"forgotPasswordCtrl.userMigratedResponse.bizMigratedEmailResponsesList.length > 1\"><div class=\"account-list\"><div class=\"email-desc\" res=\"sent_email_desc\"></div><div class=\"account-info row\" ng-repeat=\"accList in forgotPasswordCtrl.userMigratedResponse.bizMigratedEmailResponsesList\"><span class=\"account-number col-xs-12 col-md-3\"><span res=\"account_number\"></span><span data-ng-bind=\"accList.acctNbr\"></span></span> <span class=\"col-xs-12 col-md-5 mt-2\"><span res=\"migrated_email_and_date_1\"></span> <strong data-ng-bind=\"accList.migratedEmail\"></strong><span res=\"migrated_email_and_date_2\"></span> <strong data-ng-bind=\"accList.autoreg_email_date\"></strong><span res=\"migrated_email_and_date_3\"></span></span> <span class=\"col-xs-12 col-md-4 resend\" data-ng-if=\"forgotPasswordCtrl.userMigratedResponse.isMigEmailPresent\"><button class=\"btn btn-outline-danger btn-resent\" res=\"resent_btn\" data-ng-disabled=\"forgotPasswordCtrl.disableResendBtn || forgotPasswordCtrl.autoRegFail || (forgotPasswordCtrl.apiCount === 5)\" data-ng-click=\"forgotPasswordCtrl.autoRegEmail(accList)\"></button></span></div></div></div><div data-ng-if=\"forgotPasswordCtrl.userMigratedResponse.bizMigratedEmailResponsesList.length > 1\" class=\"mt-10\" res=\"reset_password_content\"></div><div class=\"account\" data-ng-if=\"forgotPasswordCtrl.userMigratedResponse.bizMigratedEmailResponsesList.length === 1\"><span res=\"migrated_email_desc_1\"></span><strong data-ng-bind=\"forgotPasswordCtrl.userMigratedResponse.bizMigratedEmailResponsesList[0].migratedEmail\"></strong> <span res=\"migrated_email_and_date_2\"></span><strong data-ng-bind=\"forgotPasswordCtrl.userMigratedResponse.bizMigratedEmailResponsesList[0].autoreg_email_date\"></strong> <span res=\"migrated_email_desc_2\"></span><div class=\"mt-10\" res=\"reset_password_content\"></div><div data-ng-if=\"forgotPasswordCtrl.userMigratedResponse.isMigEmailPresent\"><button class=\"btn btn-outline-danger btn-resent\" data-ng-disabled=\"forgotPasswordCtrl.disableResendBtn || forgotPasswordCtrl.autoRegFail || (forgotPasswordCtrl.apiCount === 5)\" data-ng-click=\"forgotPasswordCtrl.autoRegEmail(forgotPasswordCtrl.userMigratedResponse.bizMigratedEmailResponsesList[0])\" res=\"resent_btn\"></button></div></div><strong class=\"myRogers-link\" res=\"myRogers_link\"></strong></div></div></div>");
$templateCache.put("module/setPassword/setPassword.html","<div class=\"ute-rogers-setpassword\"><div class=\"container\"><form name=\"setPasswordCtrl.form\" novalidate=\"\"><div class=\"row\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.rogers.setPassword.register\"></span></li><li class=\"widget-loader sign-in\" data-ng-show=\"setPasswordCtrl.isJanrainVerificationCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></li></ul></div><div class=\"col-lg-12\"><h1 class=\"temp-password-title primary-color\" data-translate=\"ute.rogers.setPassword.page_title\"></h1><h5 class=\"password-help-txt black\" data-translate=\"ute.rogers.setPassword.page_description\"></h5></div></div><div class=\"row input-password\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 new-password-section\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><div class=\"row\"><div class=\"col-md-11 col-lg-11\"><div class=\"inline_error\" data-ng-messages=\"setPasswordCtrl.form.newPassword.$error\" data-ng-if=\"( setPasswordCtrl.form.$submitted || setPasswordCtrl.form.newPassword.$dirty ) && setPasswordCtrl.form.newPassword.$invalid\"><span data-ng-if=\"setPasswordCtrl.form.newPassword.$error.required\" data-ng-message=\"required\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"password\"><span data-translate=\"ute.rogers.setPassword.login_invalid_password\"></span></span></span> <span data-ng-if=\"setPasswordCtrl.form.newPassword.$error.minlength\" data-ng-message=\"minlength\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"shortPassword\"><span data-translate=\"ute.rogers.setPassword.registration_too_short\"></span></span></span> <span data-ng-if=\"setPasswordCtrl.form.newPassword.$error.maxlength\" data-ng-message=\"maxlength\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"longPassword\"><span data-translate=\"ute.rogers.setPassword.registration_too_long\"></span></span></span> <span data-ng-if=\"setPasswordCtrl.form.newPassword.$error.required\" data-ng-message=\"pattern\"><span data-ng-if=\"setPasswordCtrl.isNumericOnly(setPasswordCtrl.form.newPassword.$viewValue)\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"invalidPassword\"><span data-translate=\"ute.rogers.setPassword.registration_number_only\"></span></span></span> <span data-ng-if=\"setPasswordCtrl.isAlphabetOnly(setPasswordCtrl.form.newPassword.$viewValue)\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"invalidPassword\"><span data-translate=\"ute.rogers.setPassword.registration_alphabet_only\"></span></span></span> <span data-ng-if=\"!setPasswordCtrl.isAlphanumeric(setPasswordCtrl.form.newPassword.$viewValue)\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"invalidPassword\"><span data-translate=\"ute.rogers.setPassword.registration_wrong_password\"></span></span></span></span></div></div></div><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-11 password-input-field\"><label class=\"rel\"><input data-tl-private=\"\" type=\"password\" name=\"newPassword\" translate=\"\" data-translate-attr-placeholder=\"ute.rogers.setPassword.new_password_placeholder\" data-ng-minlength=\"7\" data-ng-maxlength=\"16\" data-ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#\\$%\\^\\&*\\)\\(+=._-]{7,16}$/\" data-ng-model-options=\"{ debounce: 500, allowInvalid: true }\" data-onpaste=\"return false;\" data-ng-model=\"setPasswordCtrl.model.newPassword\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"setPasswordCtrl.form.newPassword.$invalid && (setPasswordCtrl.form.newPassword.$dirty || setPasswordCtrl.form.$submitted)\"></span> <i data-ng-show=\"setPasswordCtrl.form.newPassword.$dirty && setPasswordCtrl.form.newPassword.$valid\" class=\"inline-checker icon-checked\"></i></label></div><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-11\"><div class=\"inline_error\" data-ng-messages=\"setPasswordCtrl.form.confirmPassword.$error\" data-ng-if=\"( setPasswordCtrl.form.$submitted || setPasswordCtrl.form.confirmPassword.$dirty ) && setPasswordCtrl.form.confirmPassword.$invalid\"><span data-ng-if=\"setPasswordCtrl.form.confirmPassword.$error.required\" data-ng-message=\"required\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"confirmPassword\"><span data-translate=\"ute.common.label.password.reenter\"></span></span></span><span data-ng-if=\"setPasswordCtrl.form.confirmPassword.$error.matches\" data-ng-message=\"matches\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"confirmPasswordMatch\"><span data-translate=\"ute.common.label.password.notmatch\"></span></span></span></div><div class=\"inline_error\"><span data-ng-if=\"!setPasswordCtrl.isPasswordsMatched() && !setPasswordCtrl.form.confirmPassword.$invalid\"><span ute-data-layer-form-field-error=\"\" mapping-key=\"errors:formError\" form-field-name=\"confirmPasswordMatch\"><span data-translate=\"ute.common.label.password.notmatch\"></span></span></span></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label class=\"rel\"><input data-tl-private=\"\" type=\"password\" name=\"confirmPassword\" translate=\"\" data-translate-attr-placeholder=\"ute.rogers.setPassword.confirm_password_placeholder\" data-ng-model-options=\"{ debounce: 500, allowInvalid: true }\" data-onpaste=\"return false;\" data-ng-model=\"setPasswordCtrl.model.confirmPassword\" required=\"\" matches=\"setPasswordCtrl.form.newPassword\"> <span class=\"inline-checker icon-error\" data-ng-show=\"(setPasswordCtrl.form.confirmPassword.$invalid && (setPasswordCtrl.form.confirmPassword.$dirty || setPasswordCtrl.form.$submitted)) || (setPasswordCtrl.mismatchPasswordError && setPasswordCtrl.model.confirmPassword != setPasswordCtrl.model.newPassword)\"></span> <i data-ng-show=\"setPasswordCtrl.form.confirmPassword.$dirty && setPasswordCtrl.form.confirmPassword.$valid && setPasswordCtrl.model.confirmPassword == setPasswordCtrl.model.newPassword\" class=\"inline-checker icon-checked\"></i></label></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7 new-password-right\"><div class=\"col-xs-11 col-sm-11 col-md-12 col-lg-12 password-guidelines\"><span class=\"password-guidelines-title\" data-translate=\"ute.rogers.setPassword.temp_password_guildeline\"></span> <span data-translate=\"ute.rogers.setPassword.temp_password_list_of_guildeline\"></span></div></div></div><div class=\"row input-password\"><div class=\"col-md-6 col-lg-6\"></div></div><div class=\"row input-password\"><div class=\"col-xs-11 col-sm-12 col-md-5 col-lg-5\"><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-12 cancel-continue-ctn\"><button name=\"button_continue\" data-ng-click=\"setPasswordCtrl.submit()\" data-ng-disabled=\"!setPasswordCtrl.isSubmitButtonEnable()\" class=\"cta-round primary medium full btn-continue\"><span data-translate=\"ute.rogers.setPassword.setAndContinueBtn\"></span></button></div></div></div></div></form></div></div>");
$templateCache.put("module/setPassword/setPasswordErrorMessageWindow.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-simCard-modalContent modal-content\" data-ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/setPassword/setPasswordGenericErrorModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img src=\"\" class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{errorModal.errorHandler.modalIcon}}\"><div class=\"ute-simCard-modalHeading\" data-translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><div style=\"font-size:22px;\"><div style=\"display: inline;\" data-translate=\"{{errorModal.errorHandler.frontendMessageKey}}\"></div><bold-chat-static-button data-cbid=\"{{errorModal.errorHandler.boldChat.cbid | translate}}\" data-dynamic-div=\"{{errorModal.errorHandler.boldChat.dynamicDivId | translate}}\" data-chat-button=\"{{errorModal.errorHandler.boldChat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button><div style=\"display: inline;\" data-translate=\"{{errorModal.errorHandler.errorHandler.frontendMessageP2Key}}\"></div></div></div></div><bold-chat-static-button data-cbid=\"\'string\'\" dynamic-div=\"\'string\'\" data-chat-button=\"\'string\'\"></bold-chat-static-button><img class=\"ute-simCard-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/suspendCtn/suspendCtnMain.view.html","<section><ui-view></ui-view><ute-suspend-ctn-faq></ute-suspend-ctn-faq></section>");
$templateCache.put("module/makePayment/formCreditCard/formCreditCard.html","<input data-tl-private=\"\" type=\"hidden\" name=\"token\" id=\"token\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cardScheme\" id=\"cardScheme\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"maskedCardNumber\" id=\"maskedCardNumber\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneTokeniseErrorCode\" id=\"semafoneTokeniseErrorCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneTokeniseReasonCode\" id=\"semafoneTokeniseReasonCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"isPanResetOnInitialFocus\" id=\"isPanResetOnInitialFocus\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneTokeniseResponseCode\" id=\"semafoneTokeniseResponseCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneTokeniseErrorDesc\" id=\"semafoneTokeniseErrorDesc\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneValidationState\" id=\"semafoneValidationState\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"semafoneState\" id=\"semafoneState\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cybersourceTokeniseResponseCode\" id=\"cybersourceTokeniseResponseCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cybersourceTokeniseReasonCode\" id=\"cybersourceTokeniseReasonCode\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cybersourceTokeniseMessage\" id=\"cybersourceTokeniseMessage\" value=\"\"> <input data-tl-private=\"\" type=\"hidden\" name=\"cybersourceTokeniseErrorCause\" id=\"cybersourceTokeniseErrorCause\" value=\"\"><div class=\"col-lg-12 col-md-12 col-xs-7 col-sm-4 labelMargin\" style=\"padding-right: 0px;\" res=\"bss_paymentMethodChange_creditCardNumber\"><span class=\"mandatory hidden-xs hidden-sm\">*</span></div><div class=\"col-sm-6 col-xs-5 hidden-md hidden-lg labelMargin\" style=\"padding-right: 0px; padding-left:4px;\"><img ng-src=\"images/visa.png\" class=\"imgVisa card_not_selected\"> <img ng-src=\"images/masterCard.png\" class=\"imgMc card_not_selected\"> <img ng-src=\"images/americanExpress.png\" class=\"imgAmex card_not_selected\"></div><div class=\"row pts\"><div class=\"col-lg-7 col-md-4 col-sm-12 col-xs-12 lgStyle\"><label class=\"rel\"><div align=\"left\" id=\"semafoneCapturePage\"></div></label></div><div class=\"col-lg-5 col-md-6 col-sm-12 col-xs-12 hidden-xs hidden-sm pls cc-image-ctns\"><img ng-src=\"images/visa.png\" class=\"imgVisa card_not_selected\"> <img ng-src=\"images/masterCard.png\" class=\"imgMc card_not_selected\"> <img ng-src=\"images/americanExpress.png\" class=\"imgAmex card_not_selected\"></div></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnDirective/reactivateCtn.device.directive.view.html","<div data-ng-if=\"reactivateCtnDevice.hasDeviceName()\"><h5 data-translate=\"ute.common.reactivate.ctn.device\"></h5><div data-translate=\"ute.common.reactivate.ctn.deviceName\"></div></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnDirective/reactivateCtn.messageBox.directive.view.html","<div class=\"container ute-reactivateCtn-message-box\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"ute-reactivateCtn-message-box-title\" data-translate=\"ute.common.reactivate.ctn.messageBox.title\"></div><div data-translate=\"ute.common.reactivate.ctn.messageBox.messageLeft\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><button name=\"button_continue\" data-ng-disabled=\"reactivateCtnMessageBox.isReactivateCtnCallInProgress()\" data-ng-click=\"reactivateCtnMessageBox.reactivateDevice($event)\" class=\"ute-reactivateCtn-button col-xs-9 col-sm-9\" data-ng-class=\"(reactivateCtnMessageBox.isReactivateCtnCallInProgress()) ? \'\' : \'full\'\" type=\"button\"><span data-translate=\"ute.common.reactivate.ctn.messageBox.buttonText\"></span></button><div data-ng-if=\"reactivateCtnMessageBox.isReactivateCtnCallInProgress()\" class=\"ute-reactivateCtn-confirmation-loader-container col-xs-3 col-sm-3\"><img class=\"ute-reactivateCtn-loading-img\" src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Reactivating Device...\"></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div data-translate=\"ute.common.reactivate.ctn.messageBox.messageRight01\"></div><div data-translate=\"ute.common.reactivate.ctn.messageBox.messageRight02\"></div><div class=\"ute-reactivateCtn-message-box-support col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7\"><bold-chat-static-button class=\"col-md-3 col-lg-3 col-xs-12 col-sm-12\" data-cbid=\"{{\'ute.common.reactivate.ctn.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.reactivate.ctn.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.common.reactivate.ctn.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button></div><div class=\"ute-reactivateCtn-support-phone-box col-xs-12 col-sm-5 col-md-5 col-lg-5\"><img data-ng-src=\"{{\'ute.common.reactivate.ctn.images.call\' | translate}}\"> <span class=\"ute-reactivateCtn-support-phone\" data-translate=\"ute.common.reactivate.ctn.supportPhoneNumber\"></span></div></div></div></div></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnDirective/reactivateCtn.wirelessNumber.directive.view.html","<div><h5 data-translate=\"ute.common.reactivate.ctn.wirelessNumber\"></h5><div>{{::reactivateCtnWirelessNumber.getFirstName()}} {{::reactivateCtnWirelessNumber.getPhoneNumber() | ute_common_filter_phone3}}</div><a class=\"ute-suspendCtn-link\" data-ng-click=\"reactivateCtnWirelessNumber.backToDevicePage()\" data-translate=\"ute.common.reactivate.ctn.backToDevice\"></a></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnError/reactivateCtn.error.view.html","<div class=\"ute-reactivateCtn-modalHeadingGroup row\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><img data-ng-src=\"{{reactivateCtnErrorModal.modalIcon | translate}}\"></div><div class=\"col-xs-offset-1 col-xs-9 col-sm-offset-1 col-sm-9 col-md-offset-1 col-md-9 col-lg-offset-1col-lg-9 ute-reactivateCtn-vertical-align-middle\" data-translate=\"ute.common.reactivate.ctn.fail.title\"></div></div><div class=\"ute-reactivateCtn-modalBodyGroup row\"><div class=\"ute-reactivateCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div style=\"display: inline;\" data-translate=\"{{reactivateCtnErrorModal.errorMessage}}\"></div></div><div class=\"ute-reactivateCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\"><a class=\"ute-reactivateCtn-link\" data-ng-click=\"reactivateCtnErrorModal.backToDevicePage()\" data-translate=\"ute.common.reactivate.ctn.backToDevice\"></a></div><div class=\"ute-reactivateCtn-modalBody row col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7\"><bold-chat-static-button class=\"col-md-3 col-lg-3 col-xs-12 col-sm-12\" data-cbid=\"{{\'ute.common.reactivate.ctn.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.reactivate.ctn.boldChat.dynamicDivId\' | translate}}_Modal\" data-chat-button=\"{{\'ute.common.reactivate.ctn.boldChat.chatButtonClass\' | translate}}_Modal\"></bold-chat-static-button></div><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5 ute-reactivateCtn-support-phone-box-modal\"><img data-ng-src=\"{{\'ute.common.reactivate.ctn.images.call\' | translate}}\"><div class=\"ute-reactivateCtn-support-phone-modal\" data-translate=\"ute.common.reactivate.ctn.supportPhoneNumber\"></div></div></div></div><img class=\"ute-reactivateCtn-modalClose\" data-ng-click=\"reactivateCtnErrorModal.cancel()\" data-ng-src=\"{{\'ute.common.reactivate.ctn.images.close\' | translate}}\">");
$templateCache.put("module/reactivateCtn/reactivateCtnSuccess/reactivateCtnSuccess.view.html","<div><section><section class=\"ute-reactivateCtn-Success-header\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-md-push-8 col-lg-4 col-lg-push-8\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-reactivate-ctn-wireless-number></ute-reactivate-ctn-wireless-number></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-reactivate-ctn-device></ute-reactivate-ctn-device></div></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-md-pull-4 col-lg-8 col-md-pull-4\"><h1 class=\"ute-reactivateCtn-Success-header-title\" data-translate=\"ute.common.reactivate.ctn.success.header.title\"></h1><div class=\"ute-reactivateCtn-Success-header-message\" data-translate=\"ute.common.reactivate.ctn.success.header.message\"></div></div></div></div></section><section class=\"ute-reactivateCtn-Success-body\"><div class=\"container\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8\"><div class=\"row ute-reactivateCtn-Success-body-title\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><span data-translate=\"ute.common.reactivate.ctn.success.body.header\"></span></div></div><div class=\"row ute-reactivateCtn-Success-body-section\"><div class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2\"><div><img data-ng-src=\"{{\'ute.common.reactivate.ctn.success.body.message01Icon\' | translate}}\" alt=\"\"></div></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10 ute-reactivateCtn-Success-body-text\"><div data-translate=\"ute.common.reactivate.ctn.success.body.message01\"></div></div></div><div class=\"row ute-reactivateCtn-Success-body-section\"><div class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2\"><div><img data-ng-src=\"{{\'ute.common.reactivate.ctn.success.body.message02Icon\' | translate}}\" alt=\"\"></div></div><div class=\"col-xs-8 col-sm-10 col-md-10 col-lg-10 ute-reactivateCtn-Success-body-text\"><div data-translate=\"ute.common.reactivate.ctn.success.body.message02\"></div></div></div></div></div></section><section class=\"ute-reactivateCtn-Success-support\"><div class=\"container\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8\"><div class=\"row ute-reactivateCtn-Success-body-title\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><span class=\"ute-reactivateCtn-Success-support-question\" data-translate=\"ute.common.reactivate.ctn.success.body.question\"></span> <span class=\"ute-reactivateCtn-Success-support-question\" data-translate=\"ute.common.reactivate.ctn.success.body.answer\"></span></div></div><div class=\"row ute-reactivateCtn-Success-body-section\"><div class=\"ute-suspendCtn-modalBody row col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><bold-chat-static-button data-cbid=\"{{\'ute.common.reactivate.ctn.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.reactivate.ctn.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.common.reactivate.ctn.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><img data-ng-src=\"{{\'ute.common.reactivate.ctn.images.call\' | translate}}\"><div class=\"ute-suspendCtn-support-phone\" data-translate=\"ute.common.reactivate.ctn.fail.supportPhoneNumber\"></div></div></div></div></div></div></section></section></div>");
$templateCache.put("module/simCard/simCardChange/simCardChangeNumberForm.partial.html","<form name=\"simCardForm\" novalidate=\"\"><div data-ng-if=\"(simCardForm.currentSim.$invalid || simCardForm.newSim.$invalid) && simCardForm.$submitted\"><myr-error-message><div data-ng-messages=\"simCardForm.currentSim.$error\" data-ng-if=\"simCardForm.currentSim.$invalid\"><p data-ng-message=\"minlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\"></span></p><p data-ng-message=\"maxlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\"></span></p><p data-ng-message=\"required\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_currentSim_notFound\"></span></p></div><div data-ng-messages=\"simCardForm.newSim.$error\" data-ng-if=\"simCardForm.currentSim.$valid && simCardForm.newSim.$invalid\"><p data-ng-message=\"minlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\"></span></p><p data-ng-message=\"maxlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\"></span></p><p data-ng-message=\"required\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_newSim_notFound\"></span></p></div></myr-error-message></div><div class=\"ute-simCard-inputCollection\"><div class=\"ute-simCard-inputGroup\"><div data-ng-class=\"(simCardForm.currentSim.$invalid && simCardForm.$submitted) ? \'ute-simCard-inputTextLabelError\' : \'ute-simCard-inputTextLabel\'\"><span class=\"ute-icon-error-icon\" data-ng-show=\"simCardForm.currentSim.$invalid && simCardForm.$submitted\"></span> <span translate=\"ute.rogers.myrSimCard.simCardChange.currentSim\"></span></div><input data-ng-class=\"(simCardForm.currentSim.$invalid && simCardForm.$submitted) ? \'ute-simCard-inputTextError\' : \'ute-simCard-inputText\'\" type=\"text\" name=\"currentSim\" id=\"currentSim\" maxlength=\"20\" data-minlength=\"20\" data-ng-model=\"simCardChange.model.currentSimCardNumber\" ute-numbers-only-input=\"\" ng-model-options=\"{ allowInvalid: true }\" required=\"\"></div><div class=\"ute-simCard-inputGroup\"><div data-ng-class=\"(simCardForm.newSim.$invalid && simCardForm.$submitted) ? \'ute-simCard-inputTextLabelError\' : \'ute-simCard-inputTextLabel\'\"><span class=\"ute-icon-error-icon\" data-ng-show=\"simCardForm.newSim.$invalid && simCardForm.$submitted\"></span> <span translate=\"ute.rogers.myrSimCard.simCardChange.newSim\"></span></div><input data-ng-class=\"(simCardForm.newSim.$invalid && simCardForm.$submitted) ? \'ute-simCard-inputTextError\' : \'ute-simCard-inputText\'\" type=\"text\" name=\"newSim\" id=\"newSim\" maxlength=\"20\" data-minlength=\"20\" data-ng-model=\"simCardChange.model.newSimCardNumber\" ute-numbers-only-input=\"\" ng-model-options=\"{ allowInvalid: true }\" required=\"\"></div></div><div class=\"ute-simCard-buttonGroup\"><button class=\"ute-simCard-cancelButton\" data-ng-click=\"simCardChange.cancel($event)\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardChange.cancel\"></span></button> <button class=\"ute-simCard-continueButton\" data-ng-click=\"simCardChange.submit(simCardForm, $event)\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardChange.continue\"></span></button></div></form>");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmation.html","<div class=\"container\"><myr-sim-card-confirmation></myr-sim-card-confirmation></div>");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmation.view.html","<div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-heading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.changeMySim\"></div></div><div class=\"ute-simCard-typeBody\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.sub\"></div><div class=\"ute-simCard-typeBodyGroup ute-simCard-typeMedium\"><span data-ng-bind=\"simCardConfirmation.getNewSimCardNumber()\"></span> &nbsp;&nbsp;&nbsp;&nbsp; <a class=\"ute-link\" data-ng-click=\"simCardConfirmation.backToUpdateSimCard()\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.update\"></span></a></div><div class=\"ute-simCard-messageBox-container\"><div class=\"ute-simCard-messageBox-warning\"><div class=\"row\"><div class=\"col-xs-2 col-sm-1 col-lg-1\"><img class=\"ute-simCard-messageBox-icon\" data-ng-src=\"ute-common-assets/assets/warning_yellow.png\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10\"><span><span class=\"ute-simCard-messageBox-heading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.messageBox_heading\"></span><p class=\"ute-simCard-messageBox-body\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.messageBox_body\"></p></span></div></div></div></div><div data-ng-if=\"simCardConfirmation.isChangeSimCallInProgress()\" class=\"ute-simCard-confirmation-loader-container\"><img class=\"ute-simCard-loading-img\" src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Changing Sim...\">&nbsp;</div><div class=\"ute-simCard-buttonGroup\"><button class=\"ute-simCard-cancelButton\" data-ng-click=\"simCardConfirmation.cancelConfirmation()\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.cancel\"></span></button> <button class=\"ute-simCard-continueButton\" data-ng-disabled=\"simCardConfirmation.isChangeSimCallInProgress()\" data-ng-click=\"simCardConfirmation.submitConfirmation()\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.submit\"></span></button></div>");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmationErrorModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{simCardConfirmationModal.modalIcon}}\"><div class=\"ute-simCard-modalHeading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><span translate=\"{{simCardConfirmationModal.errorMessage}}\"></span></div></div><div class=\"ute-simCard-modalButtonGroup\"><button name=\"button_continue\" data-ng-click=\"simCardConfirmationModal.cancel()\" class=\"ute-simCard-modalContinueButton\" type=\"button\"><span translate=\"ute.rogers.myrSimCard.simCardConfirmation.ok\"></span></button></div><img class=\"ute-simCard-modalClose\" data-ng-click=\"simCardConfirmationModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmationGenericModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{simCardConfirmationModal.modalIcon}}\"><div class=\"ute-simCard-modalHeading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><div style=\"font-size:22px;\"><div style=\"display: inline;\" translate=\"{{simCardConfirmationModal.errorMessage}}\"></div><bold-chat-static-button data-cbid=\"{{simCardConfirmationModal.boldChat.cbid | translate}}\" data-dynamic-div=\"{{simCardConfirmationModal.boldChat.dynamicDivId | translate}}\" data-chat-button=\"{{simCardConfirmationModal.boldChat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button><div style=\"display: inline;\" translate=\"{{simCardConfirmationModal.errorMessage_p2}}\"></div></div></div></div><bold-chat-static-button data-cbid=\"\'string\'\" dynamic-div=\"\'string\'\" data-chat-button=\"\'string\'\"></bold-chat-static-button><img class=\"ute-simCard-modalClose\" data-ng-click=\"simCardConfirmationModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmationModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"ute-common-assets/assets/warning_yellow.png\"><div class=\"ute-simCard-modalHeading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.popup_heading\"></div></div><div class=\"ute-simCard-modalButtonGroup\"><button name=\"button_continue\" data-ng-click=\"simCardConfirmationModal.cancel()\" class=\"ute-simCard-modalCancelButton\" type=\"button\"><span translate=\"ute.rogers.myrSimCard.simCardConfirmation.resume\"></span></button> <button data-ng-click=\"simCardConfirmationModal.continue()\" type=\"button\" class=\"ute-simCard-modalContinueButton\" name=\"button_continue\"><span translate=\"ute.rogers.myrSimCard.simCardConfirmation.cancel_changes\"></span></button></div><img class=\"ute-simCard-modalClose\" data-ng-click=\"simCardConfirmationModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/simCard/simCardEnterSimCard/simCardEnterSimCard.view.html","<div class=\"container\"><div class=\"row\"><div class=\"hidden-xs hidden-sm col-md-5 col-lg-5\"><div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-heading\" translate=\"ute.rogers.myrSimCard.changeMySim\"></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\" translate=\"ute.rogers.myrSimCard.directions\"></div></div><myr-sim-card-change submit-function=\"sc.submitFunction()\" cancel-function=\"sc.cancelFunction()\"></myr-sim-card-change></div><div class=\"hidden-xs hidden-sm col-md-6 col-lg-6 pull-right\"><div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-headingSecondary\" translate=\"ute.rogers.myrSimCard.howToFindSerial\"></div></div></div><div class=\"hidden-xs hidden-sm col-md-6 col-lg-6 pull-right\" data-ng-include=\"sc.howToFindNumberPartialPath\"></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 hidden-md hidden-lg\"><div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-heading\" translate=\"ute.rogers.myrSimCard.changeMySim\"></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\" translate=\"ute.rogers.myrSimCard.directions\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 hidden-md hidden-lg ute-simcard-accordion\" data-accordion=\"\"><div data-accordion-group=\"\" data-is-open=\"mobileAccordionIsOpen\"><accordion-heading><span translate=\"ute.rogers.myrSimCard.howToFindSerial\"></span> <i class=\"ute-icon-chevron-down ute-simCard-accordionIcon\" data-ng-class=\"{\'\': !mobileAccordionIsOpen, \'ute-simCard-accordionIconUp\': mobileAccordionIsOpen}\"></i></accordion-heading><div class=\"container\" data-ng-include=\"sc.howToFindNumberPartialPath\"></div></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 hidden-md hidden-lg\"><myr-sim-card-change></myr-sim-card-change></div></div></div>");
$templateCache.put("module/simCard/simCardEnterSimCard/simCardHowToFindNumber.partial.html","<div class=\"ute-simCard-typeBodyGroup\"><div class=\"row\"><div class=\"ute-simCard-findSimNumber col-xs-12 col-sm-6 col-md-4 col-lg-3\"></div><div class=\"col-xs-12 col-sm-6 col-md-7 col-lg-7\"><span class=\"ute-simCard-typeBody\" translate=\"ute.rogers.myrSimCard.serialNumberLocation\"></span></div></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\"><span translate=\"ute.rogers.myrSimCard.howToFindIt\"></span><ul><li translate=\"ute.rogers.myrSimCard.firstBullet\"></li><li translate=\"ute.rogers.myrSimCard.secondBullet\"></li><li translate=\"ute.rogers.myrSimCard.thirdBullet\"></li></ul></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\"><span translate=\"ute.rogers.myrSimCard.findSerialParagraph\"></span></div></div>");
$templateCache.put("module/simCard/simCardErrorMessage/simCardErrorMessage.template.html","<div class=\"ute-simCard-messageBox-container\"><div class=\"row ute-simCard-messageBox-error\"><div class=\"col-xs-2 col-sm-2 col-lg-2\"><img class=\"ute-simCard-messageBox-icon\" data-ng-src=\"ute-common-assets/assets/error_warning.png\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10 pull-right\"><div class=\"ute-simCard-messageBox-body\" style=\"margin-top: 10px;\"><ng-transclude></ng-transclude></div></div></div></div>");
$templateCache.put("module/simCard/simCardErrorMessage/simCardErrorMessageWindow.view.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-simCard-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/simCard/simCardSuccess/simCardSuccess.html","<div class=\"container\"><myr-sim-card-success></myr-sim-card-success></div>");
$templateCache.put("module/simCard/simCardSuccess/simCardSuccess.view.html","<div class=\"container\"><div class=\"row\"><div class=\"col-lg-11\"><div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-heading\"><span translate=\"ute.rogers.myrSimCard.simCardSuccess.heading\"></span></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\"><span translate=\"ute.rogers.myrSimCard.simCardSuccess.body\"></span></div></div><div class=\"ute-simCard-buttonGroup\"><button class=\"ute-simCard-continueButton\" data-ng-click=\"simCardSuccess.finishedRoute()\"><span translate=\"ute.rogers.myrSimCard.simCardSuccess.backToAccount\"></span></button></div></div></div></div>");
$templateCache.put("module/janrainVerification/genericError/errorModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img src=\"\" class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{errorModal.getModalIcon()}}\"><div class=\"ute-simCard-modalHeading\" data-translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><div style=\"font-size:22px;\"><div style=\"display: inline;\" translate=\"{{errorModal.getFrontendMessageKey()}}\"></div><bold-chat-static-button data-cbid=\"{{errorModal.getBoldChat().cbid | translate}}\" data-dynamic-div=\"{{errorModal.getBoldChat().dynamicDivId | translate}}\" data-chat-button=\"{{errorModal.getBoldChat().chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button><div style=\"display: inline;\" data-translate=\"{{errorModal.getFrontendMessageP2Key()}}\"></div></div></div></div><bold-chat-static-button data-cbid=\"\'string\'\" data-dynamic-div=\"\'string\'\" data-chat-button=\"\'string\'\"></bold-chat-static-button><img class=\"ute-simCard-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/janrainVerification/genericError/errorWindow.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-simCard-modalContent modal-content\" data-ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/janrainVerification/invalidForgotPassword/invalidForgotPasswordModal.view.html","<div class=\"ute-janrain-resend-email-modal-content\" data-ng-show=\"!errorModal.updateSuccessful\"><form name=\"errorModal.form\" novalidate=\"\"><div class=\"ute-janrain-resend-email-modal-headingGroup\"><div class=\"ute-janrain-resend-email-modal-heading\"><span data-translate=\"{{errorModal.errorCode.errorTitleMessageKey}}\"></span></div></div><div class=\"ute-janrain-resend-email-modal-typeGroup\"><div class=\"ute-janrain-resend-email-modal-typeBody\"><span data-translate=\"{{errorModal.errorCode.errorSubTitleMessageKey}}\"></span></div></div><div data-ng-if=\"errorModal.errorMessageKey\" class=\"ute-janrain-resend-email-modal-errorMessage\"><img class=\"ute-janrain-resend-email-modal-messageIcon\" src=\"ute-common-assets/assets/error_warning.png\"><div class=\"ute-janrain-resend-email-modal-messageBody\"><span data-translate=\"{{errorModal.errorMessageKey}}\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-sm-push-6 col-md-6 col-md-push-6 col-lg-6 col-lg-push-6\"></div><div class=\"col-xs-12 col-sm-6 col-sm-pull-6 col-md-6 col-md-pull-6 col-lg-6 col-lg-pull-6\"><div class=\"ute-janrain-resend-email-modal-inputGroup\"></div><div class=\"ute-janrain-resend-email-modal-buttonGroupFlush\"><button name=\"button_cancel\" class=\"ute-janrain-resend-email-modal-cancel\" data-ng-click=\"errorModal.cancel()\"><span data-translate=\"ute.janrain.verification.modalPopup.cancel\"></span></button> <button name=\"button_continue\" class=\"ute-janrain-resend-email-modal-submit\" data-ng-click=\"errorModal.tryAgain()\" data-ng-disabled=\"errorModal.isCallInProgress()\"><span data-translate=\"ute.common.label.continue\"></span></button> <span class=\"ute-janrain-resend-email-modal-buttonLoader\" data-ng-show=\"errorModal.isCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span></div></div></div></form></div><div data-ng-show=\"errorModal.updateSuccessful\"><div class=\"ute-janrain-resend-email-modal-modalHeadingGroup\"><img class=\"ute-janrain-resend-email-modal-modalHeadingIcon\" src=\"ute-common-assets/assets/green-checkbox.png\"><div class=\"ute-janrain-resend-email-modal-modalHeading\" data-translate=\"ute.janrain.verification.responseMessage.successTitle\"></div></div><div class=\"ute-janrain-resend-email-modal-modalTypeGroup\"><div class=\"ute-janrain-resend-email-modal-modalTypeBody\"><span data-translate=\"ute.janrain.verification.responseMessage.successMessage\"></span></div></div></div><img class=\"ute-janrain-resend-email-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/janrainVerification/invalidForgotPassword/invalidForgotPasswordWindow.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-janrain-resend-email-modal-container modal-content\" data-ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/janrainVerification/verificationModal/janrainVerification.modal.success.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-register-modalContent modal-content\"><div id=\"register-modal\" class=\"row\"><div class=\"col-xs-12 register-modal-top\"><img src=\"ute-common-assets/assets/security-lock.png\" alt=\"loading...\"> <span class=\"register-modal-top-txt\" data-translate=\"ute.common.form.secured\"></span></div><div class=\"col-xs-12 register-modal-bottom\"><div class=\"register-modal-valid-icon\"><img src=\"ute-common-assets/assets/code_valid.png\" alt=\"loading...\"></div><div class=\"register-modal-waiting-txt\"><span data-translate=\"ute.janrain.verification.modalPopup.codeValid\"></span></div></div></div></div></div></div>");
$templateCache.put("module/janrainVerification/verificationModal/janrainVerification.modal.validating.view.html","<div id=\"register-modal\" class=\"row\"><div class=\"col-xs-12 register-modal-top\"><img src=\"ute-common-assets/assets/security-lock.png\" alt=\"loading...\"> <span class=\"register-modal-top-txt\" data-translate=\"ute.common.form.secured\"></span></div><div class=\"col-xs-12 register-modal-bottom\"><div class=\"register-modal-waiting-icon\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"loading...\"></div><div class=\"register-modal-waiting-txt\"><span data-translate=\"ute.janrain.verification.modalPopup.validatingCode\"></span></div></div></div>");
$templateCache.put("module/janrainVerification/verificationModal/janrainVerification.modal.window.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-register-modalContent modal-content\"><div data-ng-include=\"\'module/janrainVerification/verificationModal/janrainVerification.modal.validating.view.html\'\"></div></div></div></div>");
$templateCache.put("module/suspendCtn/suspendCtnConfirm/suspendCtnConfirm.view.html","<section><div class=\"container\"><div class=\"row ute-suspendCtnConfirm-header\"><div class=\"col-xs-12 col-md-3 col-md-push-9\"><ute-suspend-ctn-wireless-number></ute-suspend-ctn-wireless-number><ute-suspend-ctn-device></ute-suspend-ctn-device></div><div class=\"col-xs-12 col-md-9 col-md-pull-3\"><h1 data-translate=\"ute.common.suspend.ctn.confirm.sorryToHear\">Sorry to hear<br>you\'ve lost your phone</h1><p data-translate=\"ute.common.suspend.ctn.confirm.rightPlace\">You\'re in the right place to find a solution.</p></div></div><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"ute-suspendCtnConfirm-steps\" data-translate=\"ute.common.suspend.ctn.confirm.firstStep\"></h3><a data-ng-href=\"{{\'ute.common.suspend.ctn.confirm.findIphoneUrl\' | translate}}\" target=\"_blank\"><p class=\"ute-suspendCtnConfirm-blue ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.findIphone\"></p></a> <a data-ng-href=\"{{\'ute.common.suspend.ctn.confirm.findAndroidUrl\' | translate}}\" target=\"_blank\"><p class=\"ute-suspendCtnConfirm-blue ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.findAndroid\"></p></a></div><div class=\"col-md-12\"><h3 class=\"ute-suspendCtnConfirm-steps\" data-translate=\"ute.common.suspend.ctn.confirm.secondStep\"></h3><p data-translate=\"ute.common.suspend.ctn.confirm.ifFind\"></p><p data-translate=\"ute.common.suspend.ctn.confirm.turnOff\"></p><ul class=\"ute-suspendCtnConfirm-service-list\"><li class=\"ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.data\"></li><li class=\"ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.talk\"></li><li class=\"ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.text\"></li></ul></div><div class=\"col-lg-3 col-md-3 col-xs-12 col-sm-12 row\"><button name=\"button_continue\" data-ng-disabled=\"confirmSuspendDevice.isSuspendCtnCallInProgress()\" data-ng-click=\"confirmSuspendDevice.switchOffService($event)\" class=\"ute-suspendCtnConfirm-switch col-xs-9 col-sm-9\" data-ng-class=\"(confirmSuspendDevice.isSuspendCtnCallInProgress()) ? \'\' : \'full\'\" type=\"button\"><span data-translate=\"ute.common.suspend.ctn.confirm.switchOffService\"></span></button><div data-ng-if=\"confirmSuspendDevice.isSuspendCtnCallInProgress()\" class=\"ute-suspendCtn-confirmation-loader-container col-xs-3 col-sm-3\"><img class=\"ute-suspendCtn-loading-img\" src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Suspending Device...\">&nbsp;</div></div><div data-ng-show=\"confirmSuspendDevice.getAccountEmail()\" class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 ute-suspendCtnConfirm-padding\"><p class=\"ute-suspendCtnConfirm-switch-left-margin\" data-translate=\"ute.common.suspend.ctn.confirm.confirmEmail\" data-translate-values=\"{accountEmail:confirmSuspendDevice.getAccountEmail()}\"></p><a data-ui-sref=\"{{::confirmSuspendDevice.getUpdateProfileState()}}\"><p class=\"ute-suspendCtnConfirm-switch-left-margin ute-suspendCtnConfirm-blue\" data-translate=\"ute.common.suspend.ctn.confirm.updateEmail\"></p></a></div><div class=\"col-md-12 col-xs-12 col-lg-12 col-sm-12 ute-suspendConfirm-bottom-border\"><h3 class=\"ute-suspendCtnConfirm-steps\" data-translate=\"ute.common.suspend.ctn.confirm.thirdStep\"></h3><bold-chat-static-button class=\"col-md-4 col-lg-4 col-xs-12 col-sm-12 ute-suspendCtnConfirm-live-chat\" data-cbid=\"{{\'ute.common.suspend.ctn.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.suspend.ctn.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.common.suspend.ctn.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button><img src=\"ute-common-assets/assets/call.png\"><div class=\"ute-suspendCtn-support-phone\" data-translate=\"ute.common.suspend.ctn.fail.supportPhoneNumber\"></div></div></div></div></section>");
$templateCache.put("module/suspendCtn/suspendCtnDirective/suspendCtn.device.directive.html","<div data-ng-if=\"suspendCtnDevice.hasDeviceName()\"><h5 data-translate=\"ute.common.suspend.ctn.success.header.device\"></h5><div data-translate=\"ute.common.suspend.ctn.success.header.deviceName\"></div></div>");
$templateCache.put("module/suspendCtn/suspendCtnDirective/suspendCtn.faq.directive.html","<section class=\"ute-suspendCtnSuccess-faq\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 data-translate=\"ute.common.suspend.ctn.success.faq.title\"></h1></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"ute-suspendCtnSuccess-faq-question\" data-translate=\"ute.common.suspend.ctn.success.faq.question02\"></div><div class=\"ute-suspendCtnSuccess-faq-answer\" data-translate=\"ute.common.suspend.ctn.success.faq.answer02\"></div></div></div></div></section>");
$templateCache.put("module/suspendCtn/suspendCtnDirective/suspendCtn.wirelessNumber.directive.html","<div class=\"ute-suspendCtn-wirelessNumber\"><h5 data-translate=\"ute.common.suspend.ctn.success.header.wirelessNumber\"></h5><div>{{::suspendCtnWirelessNumber.getFirstName()}} {{::suspendCtnWirelessNumber.getPhoneNumber() | ute_common_filter_phone3}}</div><a class=\"ute-suspendCtn-link\" data-ng-click=\"suspendCtnWirelessNumber.backToDevicePage()\" data-translate=\"ute.common.suspend.ctn.success.header.backToDevice\"></a></div>");
$templateCache.put("module/suspendCtn/suspendCtnError/suspendCtnError.view.html","<div class=\"ute-suspendCtn-modalHeadingGroup row\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><img src=\"ute-common-assets/assets/error_warning.png\"></div><div class=\"col-xs-offset-1 col-xs-9 col-sm-offset-1 col-sm-9 col-md-offset-1 col-md-9 col-lg-offset-1col-lg-9 ute-suspendCtn-vertical-align-middle\" data-translate=\"ute.common.suspend.ctn.fail.title\"></div></div><div class=\"ute-suspendCtn-modalBodyGroup row\"><div class=\"ute-suspendCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div style=\"display: inline;\" data-translate=\"ute.common.suspend.ctn.fail.message\"></div></div><div class=\"ute-suspendCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\"><a class=\"ute-suspendCtn-link\" data-ng-click=\"simCardErrorModal.backToDevicePage()\" data-translate=\"ute.common.suspend.ctn.success.header.backToDevice\"></a></div><div class=\"ute-suspendCtn-modalBody row col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-7\"><bold-chat-static-button data-cbid=\"{{\'ute.common.suspend.ctn.boldChatError.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.suspend.ctn.boldChatError.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.common.suspend.ctn.boldChatError.chatButtonClass\' | translate}}\"></bold-chat-static-button></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-5\"><img src=\"ute-common-assets/assets/call.png\"><div class=\"ute-suspendCtn-support-phone\" data-translate=\"ute.common.suspend.ctn.fail.supportPhoneNumber\"></div></div></div></div><img class=\"ute-suspendCtn-modalClose\" data-ng-click=\"simCardErrorModal.cancel()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/suspendCtn/suspendCtnSuccess/suspendCtnSuccess.view.html","<div><section><section class=\"ute-suspendCtnSuccess-header\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-md-push-8 col-lg-4 col-lg-push-8\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-suspend-ctn-wireless-number></ute-suspend-ctn-wireless-number></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-suspend-ctn-device></ute-suspend-ctn-device></div></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-md-pull-4 col-lg-8 col-md-pull-4\"><h1 class=\"ute-suspendCtnSuccess-title\" data-translate=\"ute.common.suspend.ctn.success.header.title\"></h1><div class=\"ute-suspendCtnSuccess-header-message\" data-translate=\"ute.common.suspend.ctn.success.header.message\"></div></div></div></div></section><section class=\"ute-suspendCtnSuccess-body\"><div class=\"container\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8\"><div class=\"row ute-suspendCtnSuccess-body-title\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 class=\"ute-suspendCtnSuccess-title\" data-translate=\"ute.common.suspend.ctn.success.body.title\"></h1></div></div><div class=\"row ute-suspendCtnSuccess-body-section\"><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><img data-ng-src=\"ute-common-assets/assets/wireless/mobile_phone.png\" alt=\"\"></div><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10 ute-suspendCtnSuccess-body-text\"><div data-translate=\"ute.common.suspend.ctn.success.body.message01\"></div></div></div><div class=\"row ute-suspendCtnSuccess-body-section\"><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><img data-ng-src=\"ute-common-assets/assets/wireless/dollar.png\" alt=\"\"></div><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10 ute-suspendCtnSuccess-body-text\"><div data-translate=\"ute.common.suspend.ctn.success.body.message02\"></div></div></div><div class=\"row ute-suspendCtnSuccess-body-section\"><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><img data-ng-src=\"ute-common-assets/assets/wireless/mobile_phone_cancel.png\" alt=\"\"></div><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10 ute-suspendCtnSuccess-body-text\"><div data-translate=\"ute.common.suspend.ctn.success.body.message03\"></div></div></div></div></div><div><div></div></div></section></section></div>");
$templateCache.put("module/janrainVerification/resendEmail/askEmail/modal.view.html","<div class=\"ute-janrain-resend-email-modal-content\" data-ng-show=\"!errorModal.updateSuccessful\"><form name=\"errorModal.form\" novalidate=\"\"><div class=\"ute-janrain-resend-email-modal-headingGroup\"><div class=\"ute-janrain-resend-email-modal-heading\"><span data-translate=\"{{errorModal.errorCode.errorTitleMessageKey}}\"></span></div></div><div class=\"ute-janrain-resend-email-modal-typeGroup\"><div class=\"ute-janrain-resend-email-modal-typeBody\"><span data-translate=\"{{errorModal.errorCode.errorSubTitleMessageKey}}\"></span></div></div><div data-ng-if=\"errorModal.errorMessageKey\" class=\"ute-janrain-resend-email-modal-errorMessage\"><img class=\"ute-janrain-resend-email-modal-messageIcon\" src=\"ute-common-assets/assets/error_warning.png\"><div class=\"ute-janrain-resend-email-modal-messageBody\"><span data-translate=\"{{errorModal.errorMessageKey}}\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-sm-push-6 col-md-6 col-md-push-6 col-lg-6 col-lg-push-6\"></div><div class=\"col-xs-12 cold-md-12\" style=\"padding-left: 0px;\"><div class=\"ute-janrain-resend-email-modal-inputGroup col-md-6 col-xs-12\" data-ng-if=\"!errorModal.errorCode.isForgotPassword\"><input data-ng-class=\"(errorModal.form.email.$invalid && errorModal.form.$submitted) ? \'ute-janrain-resend-email-modal-inputTextError\' : \'ute-janrain-resend-email-modal-inputText\'\" type=\"text\" name=\"email\" id=\"email\" data-ng-model=\"errorModal.model.email\" required=\"\" data-ng-required=\"true\" data-ng-click=\"errorModal.inputOnClick($event)\" data-ng-pattern=\"/^[a-z0-9!#$%&\'*+\\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i\" translate=\"\" data-translate-attr-placeholder=\"ute.common.label.email.address\" maxlength=\"105\" data-onpaste=\"return false;\" data-autocorrect=\"off\" data-autocapitalize=\"off\"></div><div class=\"ute-janrain-resend-email-modal-buttonGroupFlush col-xs-12\"><button data-ng-show=\"!errorModal.errorCode.isForgotPassword\" name=\"button_cancel\" class=\"ute-janrain-resend-email-modal-cancel\" data-ng-click=\"errorModal.cancel()\"><span data-translate=\"ute.janrain.verification.modalPopup.cancel\"></span></button> <button data-ng-show=\"!errorModal.errorCode.isForgotPassword\" name=\"button_continue\" class=\"ute-janrain-resend-email-modal-submit\" data-ng-click=\"errorModal.submit()\" data-ng-disabled=\"errorModal.isCallInProgress()\"><span data-translate=\"ute.janrain.verification.modalPopup.submit\"></span></button> <button data-ng-show=\"errorModal.errorCode.isForgotPassword\" name=\"button_cancel\" class=\"ute-janrain-resend-email-modal-cancel\" data-ng-click=\"errorModal.cancel()\"><span data-translate=\"ute.janrain.verification.modalPopup.cancelActivation\"></span></button> <button data-ng-show=\"errorModal.errorCode.isForgotPassword\" name=\"button_continue\" class=\"ute-janrain-resend-email-modal-submit\" data-ng-class=\"errorModal.errorCode.isForgotPassword ? \'ute-janrain-profile-incomplete-submit\' : \'\'\" data-ng-click=\"errorModal.submit()\" data-ng-disabled=\"errorModal.isCallInProgress()\"><span data-translate=\"ute.janrain.verification.modalPopup.resendActivationEmail\"></span></button> <span class=\"ute-janrain-resend-email-modal-buttonLoader\" data-ng-show=\"errorModal.isCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span></div></div></div></form></div><div data-ng-show=\"errorModal.updateSuccessful\"><div class=\"ute-janrain-resend-email-modal-modalHeadingGroup\"><img class=\"ute-janrain-resend-email-modal-modalHeadingIcon\" src=\"ute-common-assets/assets/green-checkbox.png\"><div class=\"ute-janrain-resend-email-modal-modalHeading\" data-translate=\"ute.janrain.verification.responseMessage.successTitle\"></div></div><div class=\"ute-janrain-resend-email-modal-modalTypeGroup\"><div class=\"ute-janrain-resend-email-modal-modalTypeBody\"><span data-translate=\"ute.janrain.verification.responseMessage.successMessage\"></span></div></div></div><img class=\"ute-janrain-resend-email-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/janrainVerification/resendEmail/askEmail/modal.view.ignore.html","<div class=\"ute-simCard-modalHeadingGroup\"><img src=\"\" class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{errorModal.getModalIcon()}}\"><div class=\"ute-simCard-modalHeading\" data-translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><div style=\"font-size:22px;\"><div style=\"display: inline;\" data-translate=\"{{errorModal.getFrontendMessageKey()}}\"></div></div></div></div><bold-chat-static-button data-cbid=\"\'string\'\" dynamic-div=\"\'string\'\" data-chat-button=\"\'string\'\"></bold-chat-static-button><img class=\"ute-simCard-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/janrainVerification/resendEmail/askEmail/window.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-janrain-resend-email-modal-container modal-content\" data-ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/janrainVerification/resendEmail/confirmation/view.html","<div class=\"resendEmail-confirmation\"><div class=\"container\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.janrain.verification.email.verification\"></span></li></ul></div><div class=\"mbl\"></div><div class=\"row desc-font-size-18\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\"><div data-translate=\"ute.janrain.verification.email.verification.msg\"></div><p><span data-translate=\"ute.janrain.verification.email.verfication.your.email\"></span> <strong data-ng-bind=\"::resendEmail.getEmail()\"></strong></p></div></div></div></div>");}]);
angular.module("translations", []).config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("en", {"ute":{"rogers":{"user":{"registration":{"registration":"Registration","email.not.matched":"The email addresses do not match. Please try again.","email.address.not.valid":"Sorry, please enter a valid email address.","email.verification":"Email Verification","require.email":"Please enter an email address.","require.confirm.email":"Please confirm your email address by re-entering it.","account.already.associated":"This account is already associated to a Business Self-Serve profile. Please log in to that profile to manage the account, or for assistance connect with a Customer Care representative via &nbsp;","system.error.message":"It seems something went wrong on our end. Please contact us on &nbsp;","system.error.message.p2":" to get this sorted out.","email.verification.msg":"<p><strong>We’ve sent you a Business Self-Serve account activation email.</strong></p><br/><p>To complete your registration, check your inbox for that email and open it. Follow the link in that email to create your password.</p><br/>","email.verfication.your.email":"Your email address is","boldChat":{"cbid":"S_BSS_Login","dynamicDivId":"changeSimCard-en","chatButtonClass":"chatButtonChangeSimCard-en"}}},"myrPaymentHelper":{"need_help_with_your_bill":"Need help with your bill","visit_billing_support":"Visit Billing Support","paynow_faq":"Review Payment FAQs","boldChatButtonId":"S_MRog_Payment","boldChatButtonDiv":"payment-en","boldChatButton":"chatButtonPayNowEn","reviewLink":"https://www.rogers.com/web/support/supportbillingpayment?setLanguage=en"},"myrSimCard":{"changeMySim":"Change the SIM card number","directions":"Enter the new SIM card number for this device below. ","howToFindSerial":"How do I find the SIM card number?","serialNumberLocation":"There are two ways to check your SIM card number:","howToFindIt":"Here's how to find it:","firstBullet":"Switch off your handset.","secondBullet":"Remove the cover on the back of the handset.","thirdBullet":"Carefully remove the battery.","findSerialParagraph":"<strong>Keep in mind:</strong> Instructions may vary by model. For more details, please refer to your phone’s user guide.","simCardChange":{"inputError_not20Digits":"Please enter a 20-digit number.","inputError_currentSim_notFound":"Current SIM Card field is not entered  Please make sure to enter your current SIM card number into the field below.","inputError_newSim_notFound":"Please enter the new SIM card number into the field below.","currentSim":"Current SIM card number (20 digits)","newSim":"New SIM card number (20 digits)","continue":"Continue","cancel":"Cancel"},"simCardConfirmation":{"changeMySim":"Changing the SIM card number","submit":"Submit","resume":"Resume","update":"Update","cancel":"Cancel","cancel_changes":"Cancel Changes","ok":"OK","sub":"The SIM card number will be changed to:","messageBox_heading":"IMPORTANT: This change will be effective immediately and is irreversible.","messageBox_body":"The old SIM card cannot be reactivated or re-used with other phone numbers. Please remember to back up any information that may be stored on the current SIM card before activating the new one.","popup_heading":"Are you sure you want to cancel the SIM card changes?","sorry":"Sorry!","error_current_sim_invalid":"It seems your current SIM card number is not valid.","error_new_sim_invalid":"Sorry, but the new SIM card number is not valid.","error_new_sim_in_use":"Sorry, but this new SIM card number has already been used.","system_error_message":"Sorry, but it looks like we've encountered an error. Please contact us on &nbsp;","system_error_message_p2":" to resolve this issue.","new.sim.has.been.used.before":"It seems your new SIM card has been used before.","new.sim.has.invalid.sim.prefix":"It seems the new SIM card number you entered is not valid.","new_sim_has_been_used_before":"Sorry, but this new SIM card number has already been used.","new_sim_has_invalid_sim_prefix":"Sorry, but the new SIM card number is not valid. "},"boldChat":{"cbid":"S_BSS_Change_SIMCard","dynamicDivId":"changeSimCard-en","chatButtonClass":"chatButtonChangeSimCard-en"},"simCardSuccess":{"heading":"The SIM card number has been changed successfully.","emailBody":"A confirmation email has been sent to:","body":"To resume services, please insert the new SIM card into the phone, then restart it. ","backToAccount":"Back to Account Overview"},"fourthBullet":"Remove the SIM Card.","firstWay":"<strong><u>Through your phone’s settings</u></strong>","ios":{"osName":"<strong>iOS</strong>","firstBullet":"Go to your phone’s <strong>Settings</strong>.","secondBullet":"Tap <strong>General</strong>.","thirdBullet":"Tap <strong>About</strong>.","forthBullet":"View the ICCID (SIM ID)."},"android":{"osName":"<strong>Android</strong>","firstBullet":"Go to your phone’s <strong>Settings</strong>.","secondBullet":"Tap <strong>About Phone</strong>.","thirdBullet":"Tap <strong>Status</strong>.","forthBullet":"View the ICCID (SIM ID). If your SIM card number is not visible, see <strong>View your SIM card</strong> below."},"secondWay":"<strong><u>View your SIM card</u></strong>","onSimCard":"Remove your SIM card from your phone. The 20-digit number on the back is the SIM card number."},"forgotPassword":{"description":"Enter your email address and we’ll send you a link to reset your password.","descriptionMessage":"Enter your username to receive a link to reset your password","userName":"Username","check.your.email":"Check your inbox","check.email.legacymessage":"A message has been sent to an email address linked to the username <strong>{{email}}</strong>. This email contains a link to create a new password for your Business Self-Serve account.","check.email.message":"We sent an email to <strong>{{email}}</strong>. This email contains a link to create a new password your Business Self-Serve account.","boldChat":{"cbid":"S_BSS_PassRest","dynamicDivId":"forgotUserName-En","chatButtonClass":"chatButtonForgotUserNameEn"},"email.not.found":"Sorry we were unable to find the email address you’ve entered. Please make sure you’ve entered the correct one and try again.","profile.lockedBy.agent":"Sorry, your access has been denied based on some changes to your permission settings. Please contact your admin to continue or call 1-866-727-2141"},"setPassword":{"register":"Register","page_title":"Please enter a new password","page_description":"Please enter a new password for your Business Self-Serve account.","login_invalid_password":"Please enter a valid password","registration_too_short":"Please enter a valid password","registration_too_long":"Please enter a valid password","registration_number_only":"Please enter a valid password","registration_alphabet_only":"Please enter a valid password","registration_wrong_password":"You can use only numbers and letters in your password, not special characters. Please try again.","password_not_matched":"Your password confirmation entry does not match.","temp_password_guildeline":"Password guidelines","temp_password_list_of_guildeline":"<br>Your password must be 7–16 characters long and must contain both letters and numbers.","setAndContinueBtn":"Set and continue","new_password_placeholder":"New Password","confirm_password_placeholder":"Confirm new password"}},"commonFilters":{"dataConversion":{"kb":"KB","mb":"MB","gb":"GB","tb":"TB"}},"common":{"label":{"edit":"Edit","cancel":"Cancel","check.form.errors":"There are errors on this page.  Please review the message(s) above each line.","contact.info":"Contact Information","continue":"Continue","email.address":"Email Address","email.confirm":"Confirm Email Address","email.invalid":"Please enter a valid email address","email.verification":"Email Verification","myRogers":"Business Self-Serve","username":"Username","username.edit":"Edit username","username.change":"Change username","username.and.password":"Username and Password","username.guildeline":"Username guidelines","username.guildeline.list":"<br>Your username must be a valid email address. An email will be sent to the address<br>you enter containing a link to verify your address","password":"Password","password.old":"Old Password","password.incorrect":"Old password incorrect.","password.new":"New Password","password.change":"Change Password","password.confirm.new":"Confirm New Password","password.invalid":"Please enter a valid password","password.forgot":"Forgot Password","password.reset":"reset password","password.wrong":"You can use only numbers and letters in your password, not special characters. Please try again.","password.reenter":"Please confirm your password by re-entering it.","password.notmatch":"Your password confirmation entry does not match.","password.edit":"Edit password","password.guildeline":"Password guidelines","password.guildeline.list":"<br>Your password must be 7–16 characters long and must contain both letters and numbers.","language.preference":"Language Preference","system.error.message":"It seems something went wrong on our end. Please contact us on &nbsp;","system.error.message.p2":" to get this sorted out.","save.changes":"Save Changes","chat.live":"Live Chat","need.help":"Need Help?","contactUs":"Contact Us","findStore":"Find a store","learnHowTo":"Learn how to","moving":"Moving","andMore":", and more","needHelpWith":"Need help with","tv":"TV","wireless":"Wireless","internet":"Internet","bundles":"Bundles","homePhone":"Home Phone","smartHomePhone":"Smart Home Phone","homeMonitoring":"Home Monitoring","visitSupport":"Visit Support","troubleshoot":"Troubleshoot","signIn":"Sign In","newToRogers":"New to Rogers?","registerNow":"Register now","month":"month","close":"Close"},"form":{"secured":"Secured form"},"error":{"general":"Sorry, something went wrong. We’re working on fixing it as quickly as we can. Please check back in a few minutes.","maintenance":"Looks like you’re trying to access your services through MyRogers. We apologize, unfortunately the information you’re looking for is temporarily unavailable. Please check back later and thank you for your patience!"},"reactivate":{"ctn":{"renameMePlease":"rename_me_please","wirelessNumber":"Wireless Number","devicePage":"Back to device page","device":"Device","deviceName":"","backToDevice":"Back to Device Page","images":{"call":"ute-common-assets/assets/call.png","widgetLoader":"ute-common-assets/assets/widget-loader.gif","errorWarning":"ute-common-assets/assets/error_warning.png","close":"ute-common-assets/assets/close-icon.png","phoneCancel":"ute-common-assets/assets/wireless/mobile_phone_cancel.png","phoneDouble":"ute-common-assets/assets/wireless/mobile_phone_double.png"},"boldChat":{"cbid":"S_BSS_Unlock_Phone","dynamicDivId":"reactivate-ctn-en","chatButtonClass":"chatButton-Reactivate-ctn-en"},"boldChatError":{"cbid":"S_BSS_Unlock_Phone","dynamicDivId":"reactivate-ctn-err-en","chatButtonClass":"chatButton-Reactivate-ctn-err-en"},"supportPhoneNumber":"1-877-274-3375","messageBox":{"title":"This device has been suspended","messageLeft":"Has this device been located?","buttonText":"Reactivate Your Services","messageRight01":"Need a new phone and SIM card?","messageRight02":"Talk to us and we'll help you out."},"fail":{"title":"Sorry, we couldn't reactivate this device. ","message":"Please try again later, or speak to a Small Business Specialist. ","supportPhoneNumber":"1-877-274-3375"},"success":{"header":{"title":"Services resumed","message":"Talk, text and data services have been reactivated for this device, so you can start using it again."},"body":{"header":"Keep in Mind&hellip;","message01Icon":"ute-common-assets/assets/wireless/mobile_phone_cancel.png","message01":"This account was not cancelled. Services were temporarily suspended. ","message02Icon":"ute-common-assets/assets/wireless/mobile_phone_double.png","message02":"Please restart the device to resume use. ","question":"Questions?","answer":"Just ask us. We're happy to help."}}}},"suspend":{"ctn":{"boldChat":{"cbid":"S_BSS_Unlock_Phone","dynamicDivId":"suspend-ctn-en","chatButtonClass":"chatButton-suspend-ctn-en"},"boldChatError":{"cbid":"S_BSS_Unlock_Phone","dynamicDivId":"suspend-ctn-err-en","chatButtonClass":"chatButton-suspend-ctn-err-en"},"confirm":{"switchOffService":"Disable Services","backToDevice":"Back to device page","wirelessNumber":"Wireless Number","devicePage":"Back to device page","device":"Device","sorryToHear":"Sorry to hear <br> that this device has gone missing. ","rightPlace":"We can help. ","firstStep":"1 - Try locating your device through the links below.","secondStep":"2 - Disable your services so you don't use up talk, text or data.","thirdStep":"3 - Is this device still missing? Contact us so we can help you determine your options.","ifFind":"You can reactivate these services if you get this device back.","turnOff":"This will turn off the following services on your device:","confirmEmail":"A confirmation email will be sent to <span class=\"bold\">{{::accountEmail}}</span>","updateEmail":"update email address","data":"- Data","talk":"- Talk","text":"- Text","findIphone":"Find my iPhone","findAndroid":"Find my Android Phone","findIphoneUrl":"https://www.icloud.com","findAndroidUrl":"https://www.google.ca/android/devicemanager"},"fail":{"title":"Sorry, we couldn't suspend your services.","message":"Please try again later or speak to a Small Business Specialist. ","supportPhoneNumber":"1-877-274-3375"},"success":{"header":{"title":"Services suspended","message":"This device's services have now been switched off so talk, text, and data can't be used.","wirelessNumber":"Wireless Number","device":"Device","deviceName":"","backToDevice":"Back to Device Page"},"body":{"title":"Keep in Mind&hellip;","message01":"If you get this device back or get a new device and SIM card, you can reactivate your services.","message02":"Monthly fees and charges incurred before you suspended this device's services still apply. ","message03":"The wireless account hasn't been cancelled. We've just suspended services so this device can't be used."},"faq":{"title":"FAQs","question01":"Will I be able to reactivate the device after it's suspended? ","answer01":"Yes. If you get it back, you can reactivate these services through Business Self-Serve and resume using the device.","question02":"Will I be able to access to my account after suspending the device?","answer02":"Yes, Business Self-Serve will remain available while the device is suspended. ","learnHow":"Learn how >","learnHowUrl":"/web/support/wireless/lost-stolen/823?setLanguage=en"}}}}},"voicemail":{"resetPassword":{"directive":{"updateVoicemailPassword":{"care":"Reset Voicemail Password","consumer":"Update My Voicemail Password","dealer":"Reset Voicemail Password"}},"modalPopup":{"title":"Update Voicemail Password","subTitle":"Please enter the new password.","newPassword":"New password","confirmPassword":"Confirm password","passwordInstruction":"The password must be 4 or 5 digits long and contain numbers only.","cancel":"CANCEL","submit":"SUBMIT"},"responseMessage":{"successTitle":"Thank you!","successMessage":"The voicemail password has been reset successfully.","failure":"Sorry! It seems something went wrong on our end.","contactUs01":"Please contact us on","contactUs02":"to get this sorted out","passwordNotMatch":"The passwords entered didn't match. Please try again.","notEnterBothFields":"Please make sure you enter the new password in both fields.","notFourToFiveDigits":"The new password must be 4 or 5 digits long and contain numbers only. Please try again."},"boldChat":{"cbid":"S_BSS_Reset_VM_Password","dynamicDivId":"resetVoicemailPassword-en","chatButtonClass":"chatButtonResetVoicemailPassword-en"}}},"janrain":{"verification":{"modalPopup":{"expired":{"title":"Looks like your link has expired.","subTitle":"Please provide the email address you registered with and we'll send you a new link."},"invalid":{"title":"Looks like there’s an issue with this link.","subTitle":"Please provide the email address you registered with and we'll send you a new link."},"invalidProfile":{"title":"Haven't activated your account?","subTitle":"Complete your registration process now."},"middleware.failure":{"title":"Looks like there’s an issue with this link.","subTitle":"Please provide the email address you registered with and we'll send you a new link."},"email.address":"Email Address","lockeByAgent":"Sorry, your access has been denied based on some changes to your permission settings. Please contact your admin to continue or call 1-866-727-2141","cancel":"CANCEL","submit":"RESEND CODE","cancelActivation":"Cancel","resendActivationEmail":"Resend Activation Email","validatingCode":"Validating Link","codeValid":"Valid Link"},"email.not.matched":"The email addresses do not match. Please try again.","email.address.not.valid":"Sorry, please enter a valid email address.","email.verification":"Email Verification","require.email":"Please enter an email address.","require.confirm.email":"Please confirm your email address by re-entering it.","account.already.associated":"This account is already associated to a Business Self-Serve profile. Please log in to that profile to manage the account, or for assistance connect with a Customer Care representative via &nbsp;","system.error.message":"It seems something went wrong on our end. Please contact us on &nbsp;","system.error.message.p2":" to get this sorted out.","email.verification.msg":"<p><strong>We’ve sent you a Business Self-Serve account activation email.</strong></p><br/><p>To complete your registration, check your inbox for that email and open it. Follow the link in that email to create your password.</p><br/>","email.verfication.your.email":"Your email address is","email.not.found.error.message":"Sorry, email not found.","email.already.verified.error.message":"We've got your email already. Go ahead and sign in."}}},"ute.blocks":{"language.switcher":{"to":"fr","label":"Français"}}});

$translateProvider.translations("fr", {"ute":{"rogers":{"user":{"registration":{"registration":"Enregistrement","email.not.matched":"Les adresses électroniques ne sont pas identiques. Veuillez réessayer.","email.address.not.valid":"Désolé, l'adresse électronique que vous avez entrée n’est pas valide.","email.verification":"Vérification","require.email":"Veuillez entrer une adresse électronique.","require.confirm.email":"Veuillez confirmer votre adresse électronique en la saisissant de nouveau.","account.already.associated":"Cette adresse électronique est déjà utilisée comme nom d’utilisateur Libre-Service Affaires.  Veuillez choisir une autre adresse électronique ou ouvrir une session avec ce nom d’utilisateur &nbsp;","system.error.message":"Il semble qu’une erreur se soit produite de notre côté. Veuillez communiquer avec nous au moyen du ","system.error.message.p2":" pour démêler le tout.","email.verification.msg":"<p><strong>Nous vous avons envoyé un courriel d’activation de compte Libre-Service Affaires.</strong></p><br/><p>Pour terminer votre inscription, consultez votre boîte de réception et ouvrez ce courriel. Veuillez suivre le lien dans le courriel pour créer votre mot de passe.</p><br/>","email.verfication.your.email":"Votre adresse courriel est","boldChat":{"cbid":"S_BSS_Login_Fr","dynamicDivId":"changeSimCard-en","chatButtonClass":"chatButtonChangeSimCard-en"}}},"myrPaymentHelper":{"need_help_with_your_bill":"Vous avez besoin d’aide avec votre facture?","visit_billing_support":"Service de soutien","paynow_faq":"Voir la foire aux questions sur le paiement","boldChatButtonId":"S_MRog_Payment","boldChatButtonDiv":"payment-fr","boldChatButton":"chatButtonPayNowFr","reviewLink":"https://www.rogers.com/web/support/supportbillingpayment?setLanguage=fr"},"myrSimCard":{"changeMySim":"Changer le num&eacute;ro de carte SIM","directions":"Entrez le num&eacute;ro de la carte SIM actuelle et celui de la nouvelle carte ci dessous. ","howToFindSerial":"Comment puis-je trouver le num&eacute;ro de la carte SIM?","serialNumberLocation":"Il y a deux méthodes pour vérifier votre numéro de carte SIM :","howToFindIt":"Voici comment le trouver:","firstBullet":"&Eacute;teignez l&rsquo;appareil.","secondBullet":"Retirez le couvercle &agrave; l&rsquo;arri&egrave;re de l&rsquo;appareil.","thirdBullet":"Retirez prudemment la pile.","findSerialParagraph":"<strong>Rappel :</strong> La marche à suivre peut varier d’un modèle à un autre. Pour obtenir de plus amples renseignements, veuillez consulter le guide de l’utilisateur de votre appareil.","simCardChange":{"inputError_not20Digits":"Veuillez entrer un num&eacute;ro &agrave; 20 chiffres.","inputError_currentSim_notFound":"Veuillez vous assurer d’entrer le numéro de votre carte SIM actuelle dans le champ ci-dessous.","inputError_newSim_notFound":"Veuillez entrer le num&eacute;ro de la nouvelle carte SIM dans le champ ci dessous.","currentSim":"Numéro de la carte SIM actuelle (20 chiffres)","newSim":"Num&eacute;ro de la nouvelle carte SIM (20 chiffres)","continue":"Continuer","cancel":"Annuler"},"simCardConfirmation":{"changeMySim":"Changer le num&eacute;ro de carte SIM","submit":"Soumettre","cancel":"Annuler","update":"Mettre &agrave; jour","resume":"Apporter les changements","cancel_changes":"Annuler les changements","ok":"OK","sub":"Le num&eacute;ro de carte SIM sera remplac&eacute; par :","messageBox_heading":"IMPORTANT: Ce changement entrera en vigueur imm&eacute;diatement et est irr&eacute;versible.","messageBox_body":"L&rsquo;ancienne carte SIM ne peut pas &ecirc;tre r&eacute;activ&eacute;e ni r&eacute;utilis&eacute;e avec d&rsquo;autres num&eacute;ros de t&eacute;l&eacute;phone. N&rsquo;oubliez pas de faire une sauvegarde des donn&eacute;es que vous avez enregistr&eacute;es sur la carte SIM actuelle avant d&rsquo;activer la nouvelle.","popup_heading":"&Ecirc;tes-vous certain de ne pas vouloir changer le num&eacute;ro de carte SIM?","sorry":"D&eacute;sol&eacute;!","error_current_sim_invalid":"Il semble que le numéro de votre carte SIM ne soit pas valide.","error_new_sim_invalid":"Le nouveau num&eacute;ro de carte SIM n&rsquo;est pas valide.","error_new_sim_in_use":"Ce nouveau num&eacute;ro de carte SIM a d&eacute;j&agrave; &eacute;t&eacute; utilis&eacute;","system_error_message":"Une erreur semble s&rsquo;&ecirc;tre produite. Veuillez communiquer avec nous par ","system_error_message_p2":" pour r&eacute;soudre le probl&egrave;me. ","new.sim.has.been.used.before":"Il semble que le num&eacute;ro de la nouvelle carte SIM que vous avez entr&eacute; a d&eacute;j&agrave; &eacute;t&eacute; utilis&eacute;.","new.sim.has.invalid.sim.prefix":"Il semble que le num&eacute;ro de la nouvelle carte SIM que vous avez entr&eacute; ne soit pas valide.","new_sim_has_been_used_before":"Ce nouveau num&eacute;ro de carte SIM a d&eacute;j&agrave; &eacute;t&eacute; utilis&eacute;.","new_sim_has_invalid_sim_prefix":"Le nouveau num&eacute;ro de carte SIM n&rsquo;est pas valide."},"boldChat":{"cbid":"S_BSS_Change_SIMCard_FR","dynamicDivId":"changeSimCard-fr","chatButtonClass":"chatButtonChangeSimCard-fr"},"simCardSuccess":{"heading":"Le num&eacute;ro de carte SIM a &eacute;t&eacute; chang&eacute;.","emailBody":"Un courriel de confirmation a &eacute;t&eacute; envoy&eacute; &agrave; :","body":"Pour r&eacute;activer les services, veuillez ins&eacute;rer la nouvelle carte SIM dans votre t&eacute;l&eacute;phone. ","backToAccount":"Retour &agrave; Aper&ccedil;u du compte"},"fourthBullet":"Retirez la carte SIM.","firstWay":"<strong><u>Accédez aux paramètres de votre appareil</u></strong>","ios":{"osName":"<strong>iOS</strong>","firstBullet":"Ouvrez les <strong>réglages</strong> de votre appareil.","secondBullet":"Sélectionnez <strong>Général</strong>.","thirdBullet":"Sélectionnez <strong>Information</strong>.","forthBullet":"Le numéro d’identification de la carte SIM est la valeur ICCID."},"android":{"osName":"<strong>Android</strong>","firstBullet":"Ouvrez les <strong>paramètres</strong> de votre appareil.","secondBullet":"Sélectionnez  <strong>À propos du téléphone</strong>.","thirdBullet":"Sélectionnez  <strong>État</strong>.","forthBullet":"Le numéro d’identification de la carte SIM est la valeur ICCID. Si vous ne voyez pas le numéro de votre carte SIM, reportez-vous à la rubrique <strong>Regardez sur votre carte SIM</strong> ci-dessous."},"secondWay":"<strong><u>Regardez sur votre carte SIM</u></strong>","onSimCard":"Retirez la carte SIM de votre téléphone. Le numéro à 20 chiffres au dos de la carte est le numéro de carte SIM."},"forgotPassword":{"description":"Veuillez entrer votre courriel <b>principal</b> pour réinitialiser votre mot de passe.","descriptionMessage":"Entrez votre nom d’utilisateur afin de recevoir un lien pour réinitialiser votre mot de passe.","userName":"Nom d’utilisateur","check.your.email":"Consultez votre boîte de réception.","check.email.legacymessage":"Un message a &#233;t&#233; envoy&#233; &#224; une adresse courriel correspondant au nom d’utilisateur <strong>{{email}}</strong>. Il comprend un lien pour cr&#233;er un nouveau mot de passe pour votre compte Libre-Service Affaires.","check.email.message":"Nous avons envoyé un courriel à l’adresse <strong>{{email}}</strong>. Il comprend un lien pour cr&#233;er un nouveau mot de passe pour votre compte Libre-Service Affaires.","boldChat":{"cbid":"S_BSS_PassRest_Fr","dynamicDivId":"forgotUserName-Fr","chatButtonClass":"chatButtonForgotUserNameFr"},"email.not.found":"Désolé, nous ne trouvons pas l’adresse électronique que vous avez entrée. Assurez-vous d’entrer la bonne adresse et réessayez.","profile.lockedBy.agent":"Nous sommes désolés, mais votre accès a été refusé en raison de certains changements apportés à vos paramètres d’autorisation. Veuillez communiquer avec votre administrateur pour poursuivre or appeler 1-866-727-2141."},"setPassword":{"register":"Enregistrement","page_title":"Veuillez saisir un nouveau mot de passe","page_description":"Veuillez saisir un nouveau mot de passe pour votre compte Libre-Service Affaires.","login_invalid_password":"Veuillez entrer un mot de passe valide","registration_too_short":"Veuillez entrer un mot de passe valide","registration_too_long":"Veuillez entrer un mot de passe valide","registration_number_only":"Veuillez entrer un mot de passe valide","registration_alphabet_only":"Veuillez entrer un mot de passe valide","registration_wrong_password":"Votre mot de passe ne peut contenir que des chiffres et des lettres, et non des caractères spéciaux. Veuillez réessayer.","password_not_matched":"Votre mot de passe et celui de confirmation ne sont pas semblables.","temp_password_guildeline":"Instructions pour créer votre mot de passe","temp_password_list_of_guildeline":"<br>Votre mot de passe doit être composé de 7 à 16 caractères et contenir des lettres et des chiffres.","setAndContinueBtn":"D&eacute;finir et continuer","new_password_placeholder":"Nouveau mot de passe","confirm_password_placeholder":"Confirmer le nouveau mot de passe"}},"commonFilters":{"dataConversion":{"kb":" Ko","mb":" Mo","gb":" Go","tb":" To"}},"common":{"label":{"edit":"Modifier","cancel":"Annuler","check.form.errors":"Des erreurs de validation ont été détectées sur cette page. Veuillez consulter le message au-dessus de chaque ligne.","contact.info":"Coordonnées","continue":"Continuer","email.address":"Adresse électronique","email.confirm":"Confirmez l’adresse électronique","email.invalid":"Veuillez entrer une adresse &eacute;lectronique valide.","email.verification":"V&eacute;rification","myRogers":"Libre-Service Affaires","username":"Nom d'utilisateur :","username.edit":"Modifier le nom d&rsquo;utilisateur","username.change":"Changer le nom d&rsquo;utilisateur","username.and.password":"Nom d&rsquo;utilisateur et mot de passe","username.guildeline":"Instructions pour cr&eacute;er votre nom d&rsquo;utilisateur","username.guildeline.list":"<br>Votre nom d&rsquo;utilisateur doit &ecirc;tre une adresse &eacute;lectronique valide. Un courriel contenant un lien de v&eacute;rification sera envoy&eacute; &agrave; cette adresse.","password":"Mot de passe :","password.old":"Ancien mot de passe","password.incorrect":"Ancien mot de passe est incorrect.","password.new":"Nouveau mot de passe","password.change":"Changer le Mot de passe","password.confirm.new":"Confirmer le nouveau mot de passe","password.invalid":"Veuillez entrer un mot de passe valide","password.forgot":"Vous avez oubli&eacute; votre mot de passe","password.reset":"R&eacute;initialisez votre mot de passe","password.wrong":"Votre mot de passe ne peut contenir que des chiffres et des lettres, et non des caract&egrave;res sp&eacute;ciaux. Veuillez r&eacute;essayer.","password.reenter":"Veuillez confirmer votre mot de passe en le saisissant de nouveau.","password.notmatch":"Votre mot de passe et celui de confirmation ne sont pas semblables.","password.edit":"Modifier le Mot de passe","password.guildeline":"Instructions pour cr&eacute;er votre mot de passe","password.guildeline.list":"<br>Votre mot de passe doit &ecirc;tre compos&eacute; de 7 &agrave; 16 caract&egrave;res et contenir des lettres et des chiffres.","language.preference":"Langue de préférence","system.error.message":"Il semble qu’une erreur se soit produite de notre côté. Veuillez communiquer avec nous au moyen du &nbsp;","system.error.message.p2":" pour démêler le tout. ","save.changes":"Enregistrer les changements","chat.live":"Clavardage en direct","need.help":"Besoin d'aide?","contactUs":"Contactez-nous","findStore":"Trouver un magasin","learnHowTo":"Apprendre à","moving":"Vous déménagez","andMore":" et plus encore","needHelpWith":"Besoin d'aide avec","tv":"Télé","wireless":"Sans fil","internet":"Internet","bundles":"Liasses","homePhone":"Téléphonie résidentielle","smartHomePhone":"Téléphonie résidentielle","homeMonitoring":"Système domotique","visitSupport":"Consulter le service de soutien","troubleshoot":"Obtenir du dépannage","signIn":"Connexion","newToRogers":"Vous êtes nouveau client de Rogers?","registerNow":"Inscrivez-vous dès maintenant!","month":"par mois","close":"Fermer"},"form":{"secured":"Formulaire sécurisé"},"error":{"general":"D&eacute;sol&eacute;, une erreur s&rsquo;est produite. Nous tentons de r&eacute;gler le probl&egrave;me le plus rapidement possible. Les changements apport&eacute;s &agrave; vos forfaits n&rsquo;ont pas &eacute;t&eacute; enregistr&eacute;s. Veuillez rev&eacute;rifier dans quelques minutes.","maintenance":"Il semble que vous essayer d&rsquo;acc&eacute;der &agrave; ce service par l&rsquo;entremise de MonRogers. Nous sommes d&eacute;sol&eacute;s; l&rsquo;information que vous cherchez n&rsquo;est malheureusement pas disponible en ce moment. Veuillez r&eacute;essayer plus tard. Merci de votre patience!"},"reactivate":{"ctn":{"renameMePlease":"rename_me_please FR","wirelessNumber":"Num&eacute;ro de sans-fil","devicePage":"Retour to device page","device":"Appareil","deviceName":"","backToDevice":"Retour &agrave; la page des appareils","images":{"call":"ute-common-assets/assets/call.png","widgetLoader":"ute-common-assets/assets/widget-loader.gif","errorWarning":"ute-common-assets/assets/error_warning.png","close":"ute-common-assets/assets/close-icon.png","phoneCancel":"ute-common-assets/assets/wireless/mobile_phone_cancel.png","phoneDouble":"ute-common-assets/assets/wireless/mobile_phone_double.png"},"boldChat":{"cbid":"S_BSS_Unlock_Phone_FR","dynamicDivId":"reactivate-ctn-fr","chatButtonClass":"chatButton-Reactivate-ctn-fr"},"boldChatError":{"cbid":"S_BSS_Unlock_Phone_FR","dynamicDivId":"reactivate-ctn-err-fr","chatButtonClass":"chatButton-Reactivate-ctn-err-fr"},"supportPhoneNumber":"1 877 274 3375","messageBox":{"title":"Cet appareil a &eacute;t&eacute; suspendu","messageLeft":"Cet appareil a-t-il &eacute;t&eacute; localis&eacute;?","buttonText":"R&eacute;activez vos services","messageRight01":"Vous avez besoin d&rsquo;un nouveau t&eacute;l&eacute;phone et d&rsquo;une carte SIM?","messageRight02":"Communiquez avec nous pour obtenir de l&rsquo;aide. "},"fail":{"title":"D&eacute;sol&eacute;, nous n&rsquo;avons pu r&eacute;activer cet appareil.","message":"Veuillez r&eacute;essayer plus tard ou communiquez avec un Sp&eacute;cialiste petites entreprises.","supportPhoneNumber":"1-877-274-3375"},"success":{"header":{"title":"Services r&eacute;activ&eacute;s","message":"Les services d&rsquo;appels, de messagerie texte et de donn&eacute;es ont &eacute;t&eacute; r&eacute;activ&eacute;s pour cet appareil. Vous pouvez donc recommencer &agrave; les utiliser."},"body":{"header":"N&rsquo;oubliez pas&hellip;","message01Icon":"ute-common-assets/assets/wireless/mobile_phone_cancel.png","message01":"Ce compte n&rsquo;a pas &eacute;t&eacute; annul&eacute;. Les services ont &eacute;t&eacute; suspendus temporairement. ","message02Icon":"ute-common-assets/assets/wireless/mobile_phone_double.png","message02":"Veuillez red&eacute;marrer l&rsquo;appareil pour recommencer &agrave; l&rsquo;utiliser.","question":"Des questions?","answer":"Nous sommes l&agrave; pour vous. Nous serons heureux de vous aider."}}}},"suspend":{"ctn":{"boldChat":{"cbid":"S_BSS_Unlock_Phone_FR","dynamicDivId":"suspend-ctn-fr","chatButtonClass":"chatButton-suspend-ctn-fr"},"boldChatError":{"cbid":"S_BSS_Unlock_Phone_FR","dynamicDivId":"suspend-ctn-err-fr","chatButtonClass":"chatButton-suspend-ctn-err-fr"},"confirm":{"switchOffService":"D&eacute;sactiver les services","backToDevice":"Back to device page - fr","wirelessNumber":"Numéro de sans-fil","devicePage":"Retour to device page","device":"Appareil","sorryToHear":"Nous sommes d&eacute;sol&eacute;s <br> d&rsquo;apprendre que vous n&rsquo;avez plus votre appareil.","rightPlace":"Nous pouvons vous aider.","firstStep":"1 - Essayez de localiser votre appareil en utilisant un des liens ci-dessous.","secondStep":"2 - D&eacute;sactivez vos services pour que vos services d&rsquo;appels, de messagerie texte ou de donn&eacute;es ne soient pas utilis&eacute;s. ","thirdStep":"3 - Vous n&rsquo;avez toujours pas retrouv&eacute; l&rsquo;appareil? Communiquez avec nous pour que nous puissions vous aider &agrave; d&eacute;terminer les options qui s&rsquo;offrent &agrave; vous.","ifFind":"Vous pouvez r&eacute;activer ces services si vous r&eacute;cup&eacute;rez votre appareil.","turnOff":"Les services suivants de votre appareil seront suspendus : ","confirmEmail":"Un courriel de confirmation sera envoy&eacute; &agrave; <span class=\"bold\">{{::accountEmail}}</span>","updateEmail":"Mettre à jour l'adresse courriel","data":"- Les donn&eacute;es","talk":"- Les appels","text":"- La messagerie texte","findIphone":"Localiser mon iPhone","findAndroid":"Localiser mon t&eacute;l&eacute;phone Android","findIphoneUrl":"https://www.icloud.com","findAndroidUrl":"https://www.google.ca/android/devicemanager?hl=fr"},"fail":{"title":"D&eacute;sol&eacute;, nous n&rsquo;avons pu suspendre vos services.","message":"Veuillez r&eacute;essayer plus tard ou communiquer avec un Sp&eacute;cialiste petites entreprises.","supportPhoneNumber":"1-877-274-3375"},"success":{"header":{"title":"Services suspendus","message":"Les services de cet appareil ont &eacute;t&eacute; d&eacute;sactiv&eacute;s. Vous ne pouvez donc ni parler, ni envoyer des messages, ni utiliser des donn&eacute;es avec cet appareil.","wirelessNumber":"Num&eacute;ro de sans-fil","device":"Appareil","deviceName":"","backToDevice":"Retour &agrave; la page des appareils"},"body":{"title":"N&rsquo;oubliez pas&hellip;","message01":"Si vous retrouvez cet appareil ou si vous vous procurez un nouvel appareil et une nouvelle carte SIM, vous pourrez r&eacute;activer vos services.","message02":"Les frais mensuels et les frais li&eacute;s &agrave; l&rsquo;utilisation ant&eacute;rieure &agrave; la suspension des services s&rsquo;appliquent encore.","message03":"Le compte sans-fil n&rsquo;a pas &eacute;t&eacute; annul&eacute;. Nous avons simplement suspendu les services pour qu&rsquo;ils ne soient pas utilis&eacute;s."},"faq":{"title":"FAQs","question01":"Pourrai-je r&eacute;activer l&rsquo;appareil apr&egrave;s la suspension de mes services? ","answer01":"Oui. Si vous retrouvez votre appareil, vous pourrez r&eacute;activer les services au moyen du Libre-service Affaires et recommencer &agrave; utiliser l&rsquo;appareil. ","question02":"Serai-je en mesure d&rsquo;acc&eacute;der &agrave; mon compte apr&egrave;s la suspension des services de l&rsquo;appareil?","answer02":"Oui. Le Libre-service Affaires restera accessible alors que les services de votre appareil sont suspendus.","learnHow":"Voici comment >","learnHowUrl":"/web/support/wireless/lost-stolen/823?setLanguage=fr"}}}}},"voicemail":{"resetPassword":{"directive":{"updateVoicemailPassword":{"care":"R&eacute;initialiser le mot de passe pour la Messagerie vocale","consumer":"Changer mon mot de passe pour la messagerie vocale","dealer":"R&eacute;initialiser le mot de passe pour la Messagerie vocale"}},"modalPopup":{"title":"Mettre &agrave; jour le mot de passe pour la Messagerie vocale","subTitle":"Veuillez entrer le nouveau mot de passe.","newPassword":"Nouveau mot de passe","confirmPassword":"Confirmer le mot de passe","passwordInstruction":"Le mot de passe doit &ecirc;tre compos&eacute; de 4 ou 5 caract&egrave;res et ne peut contenir que des chiffres.","cancel":"ANNULER","submit":"SOUMETTRE"},"responseMessage":{"successTitle":"Merci.","successMessage":"Le mot de passe de la Messagerie vocale a &eacute;t&eacute; r&eacute;initialis&eacute;.","failure":"D&eacute;sol&eacute;! Il semble qu&rsquo;une erreur se soit produite de notre c&ocirc;t&eacute;.","contactUs01":"Veuillez communiquer avec nous au moyen du","contactUs02":"en direct pour d&eacute;m&ecirc;ler le tout.","passwordNotMatch":"Les mots de passe entr&eacute;s ne correspondent pas. Veuillez r&eacute;essayer.","notEnterBothFields":"Veuillez vous assurer d&rsquo;entrer le nouveau mot de passe dans les deux champs.","notFourToFiveDigits":"Le mot de passe doit &ecirc;tre compos&eacute; de 4 ou 5 caract&egrave;res et ne peut contenir que des chiffres. Veuillez r&eacute;essayer."},"boldChat":{"cbid":"S_BSS_Reset_VM_Password_FR","dynamicDivId":"resetVoicemailPassword-fr","chatButtonClass":"chatButtonResetVoicemailPassword-fr"}}},"janrain":{"verification":{"modalPopup":{"expired":{"title":"Il semble que votre lien est expir&eacute;.","subTitle":"Veuillez indiquer l’adresse électronique liée à votre inscription et nous vous en enverrons un autre."},"invalid":{"title":"Il semble y avoir un problème touchant ce lien.","subTitle":"Veuillez indiquer l’adresse électronique liée à votre inscription et nous vous en enverrons un autre."},"invalidProfile":{"title":"Vous n’avez pas activé votre compte?","subTitle":"Suivez le processus d’inscription maintenant."},"middleware.failure":{"title":"Il semble y avoir un problème touchant ce lien.","subTitle":"Veuillez indiquer l’adresse électronique liée à votre inscription et nous vous en enverrons un autre."},"email.address":"Email Address","lockeByAgent":"Nous sommes désolés, mais votre accès a été refusé en raison de certains changements apportés à vos paramètres d’autorisation. Veuillez communiquer avec votre administrateur pour poursuivre or appeler 1-866-727-2141.","cancel":"CANCEL","submit":"RESEND CODE","cancelActivation":"Annuler","resendActivationEmail":"Envoyer le courriel d’activation de nouveau","validatingCode":"Lien de confirmation","codeValid":"Lien valide"},"email.not.matched":"Les adresses électroniques ne sont pas identiques. Veuillez réessayer.","email.address.not.valid":"Désolé, l'adresse électronique que vous avez entrée n’est pas valide.","email.verification":"Vérification","require.email":"Veuillez entrer une adresse électronique.","require.confirm.email":"Veuillez confirmer votre adresse électronique en la saisissant de nouveau.","account.already.associated":"Cette adresse électronique est déjà utilisée comme nom d’utilisateur Libre-Service Affaires.  Veuillez choisir une autre adresse électronique ou ouvrir une session avec ce nom d’utilisateur &nbsp;","system.error.message":"Il semble qu’une erreur se soit produite de notre côté. Veuillez communiquer avec nous au moyen du ","system.error.message.p2":" pour démêler le tout.","email.verification.msg":"<p><strong>Nous vous avons envoyé un courriel d’activation de compte Libre-Service Affaires.</strong></p><br/><p>Pour terminer votre inscription, consultez votre boîte de réception et ouvrez ce courriel. Veuillez suivre le lien dans le courriel pour créer votre mot de passe.</p><br/>","email.verfication.your.email":"Votre adresse courriel est","email.not.found.error.message":"FR: Sorry, email not found.","email.already.verified.error.message":"Nous avons d&eacute;j&agrave; votre adresse courriel. Maintenant, connectez-vous."}}},"ute.blocks":{"language.switcher":{"to":"en","label":"English"}}});
}]);
